import gr, { useRef as yQ, useLayoutEffect as AQ, useEffect as LM, version as EQ, createContext as SQ, useContext as MM, useState as wQ, createElement as OM } from "react";
import { stripVTControlCharacters as FQ, inspect as jy, format as TQ } from "node:util";
import $s, { stdout as vQ, stderr as xQ } from "node:process";
import _3, { WriteStream as CQ } from "node:tty";
import kQ from "node:os";
import { Stream as _Q } from "node:stream";
import { createRequire as bc, register as NQ, builtinModules as vx } from "node:module";
import { renderToStaticMarkup as DQ } from "react-dom/server";
import { createHash as IQ } from "node:crypto";
import { pathToFileURL as ju, fileURLToPath as wn } from "node:url";
import { MessageChannel as RQ, MessagePort as PQ } from "node:worker_threads";
import Ke from "typescript";
import Vu from "node:assert";
import * as uT from "node:fs";
import BM, { realpathSync as LQ, statSync as $M, existsSync as Sg, readFileSync as MQ, promises as OQ } from "node:fs";
import * as Sd from "node:path";
import rr, { dirname as Yy, join as wg } from "node:path";
import BQ from "node:v8";
import As from "fs";
import qr from "path";
import $Q, { URL as Pr, URLSearchParams as xx } from "url";
import _f, { webcrypto as HQ } from "crypto";
import UQ, { Buffer as nr, Blob as GQ } from "buffer";
import { TextEncoder as WQ, TextDecoder as VQ } from "util";
import Ti from "stream";
import { ReadableStream as sh } from "stream/web";
import hS, { Script as HM } from "vm";
import KQ, { isIP as zQ } from "net";
import Cx from "http";
import UM from "https";
import Da from "zlib";
import jQ from "child_process";
import { PerformanceObserver as YQ, PerformanceEntry as qQ } from "node:perf_hooks";
import GM from "events";
import JQ from "tls";
import N3 from "react-dom";
import "module";
var Ll = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kh(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function vt(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      var i = !1;
      try {
        i = this instanceof r;
      } catch {
      }
      return i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var dS = {}, Xh = {};
function kx(t, e) {
  return e;
}
kx.withConfig = function() {
  return function(t, e) {
    return e;
  };
};
const _x = "core:signals", QQ = /* @__PURE__ */ Symbol.for("preact-signals");
function Nx() {
  if (Hd > 1) {
    Hd--;
    return;
  }
  let t, e = !1;
  for (; jm !== void 0; ) {
    let n = jm;
    for (jm = void 0, lT++; n !== void 0; ) {
      const r = n.o;
      if (n.o = void 0, n.f &= -3, !(8 & n.f) && KM(n)) try {
        n.c();
      } catch (i) {
        e || (t = i, e = !0);
      }
      n = r;
    }
  }
  if (lT = 0, Hd--, e) throw t;
}
let Bn, jm;
function WM(t) {
  const e = Bn;
  Bn = void 0;
  try {
    return t();
  } finally {
    Bn = e;
  }
}
let Hd = 0, lT = 0, qy = 0;
function VM(t) {
  if (Bn === void 0) return;
  let e = t.n;
  if (e === void 0 || e.t !== Bn)
    return e = { i: 0, S: t, p: Bn.s, n: void 0, t: Bn, e: void 0, x: void 0, r: e }, Bn.s !== void 0 && (Bn.s.n = e), Bn.s = e, t.n = e, 32 & Bn.f && t.S(e), e;
  if (e.i === -1)
    return e.i = 0, e.n !== void 0 && (e.n.p = e.p, e.p !== void 0 && (e.p.n = e.n), e.p = Bn.s, e.n = void 0, Bn.s.n = e, Bn.s = e), e;
}
function os(t, e) {
  this.v = t, this.i = 0, this.n = void 0, this.t = void 0, this.W = e?.watched, this.Z = e?.unwatched, this.name = e?.name;
}
os.prototype.brand = QQ;
os.prototype.h = function() {
  return !0;
};
os.prototype.S = function(t) {
  const e = this.t;
  e !== t && t.e === void 0 && (t.x = e, this.t = t, e !== void 0 ? e.e = t : WM(() => {
    var n;
    (n = this.W) == null || n.call(this);
  }));
};
os.prototype.U = function(t) {
  if (this.t !== void 0) {
    const e = t.e, n = t.x;
    e !== void 0 && (e.x = n, t.e = void 0), n !== void 0 && (n.e = e, t.x = void 0), t === this.t && (this.t = n, n === void 0 && WM(() => {
      var r;
      (r = this.Z) == null || r.call(this);
    }));
  }
};
os.prototype.subscribe = function(t) {
  return Ix(() => {
    const e = this.value, n = Bn;
    Bn = void 0;
    try {
      t(e);
    } finally {
      Bn = n;
    }
  }, { name: "sub" });
};
os.prototype.valueOf = function() {
  return this.value;
};
os.prototype.toString = function() {
  return this.value + "";
};
os.prototype.toJSON = function() {
  return this.value;
};
os.prototype.peek = function() {
  const t = Bn;
  Bn = void 0;
  try {
    return this.value;
  } finally {
    Bn = t;
  }
};
Object.defineProperty(os.prototype, "value", { get() {
  const t = VM(this);
  return t !== void 0 && (t.i = this.i), this.v;
}, set(t) {
  if (t !== this.v) {
    if (lT > 100) throw new Error("Cycle detected");
    this.v = t, this.i++, qy++, Hd++;
    try {
      for (let e = this.t; e !== void 0; e = e.x) e.t.N();
    } finally {
      Nx();
    }
  }
} });
function XQ(t, e) {
  return new os(t, e);
}
function KM(t) {
  for (let e = t.s; e !== void 0; e = e.n) if (e.S.i !== e.i || !e.S.h() || e.S.i !== e.i) return !0;
  return !1;
}
function zM(t) {
  for (let e = t.s; e !== void 0; e = e.n) {
    const n = e.S.n;
    if (n !== void 0 && (e.r = n), e.S.n = e, e.i = -1, e.n === void 0) {
      t.s = e;
      break;
    }
  }
}
function jM(t) {
  let e, n = t.s;
  for (; n !== void 0; ) {
    const r = n.p;
    n.i === -1 ? (n.S.U(n), r !== void 0 && (r.n = n.n), n.n !== void 0 && (n.n.p = r)) : e = n, n.S.n = n.r, n.r !== void 0 && (n.r = void 0), n = r;
  }
  t.s = e;
}
function _h(t, e) {
  os.call(this, void 0), this.x = t, this.s = void 0, this.g = qy - 1, this.f = 4, this.W = e?.watched, this.Z = e?.unwatched, this.name = e?.name;
}
_h.prototype = new os();
_h.prototype.h = function() {
  if (this.f &= -3, 1 & this.f) return !1;
  if ((36 & this.f) == 32 || (this.f &= -5, this.g === qy)) return !0;
  if (this.g = qy, this.f |= 1, this.i > 0 && !KM(this))
    return this.f &= -2, !0;
  const t = Bn;
  try {
    zM(this), Bn = this;
    const e = this.x();
    (16 & this.f || this.v !== e || this.i === 0) && (this.v = e, this.f &= -17, this.i++);
  } catch (e) {
    this.v = e, this.f |= 16, this.i++;
  }
  return Bn = t, jM(this), this.f &= -2, !0;
};
_h.prototype.S = function(t) {
  if (this.t === void 0) {
    this.f |= 36;
    for (let e = this.s; e !== void 0; e = e.n) e.S.S(e);
  }
  os.prototype.S.call(this, t);
};
_h.prototype.U = function(t) {
  if (this.t !== void 0 && (os.prototype.U.call(this, t), this.t === void 0)) {
    this.f &= -33;
    for (let e = this.s; e !== void 0; e = e.n) e.S.U(e);
  }
};
_h.prototype.N = function() {
  if (!(2 & this.f)) {
    this.f |= 6;
    for (let t = this.t; t !== void 0; t = t.x) t.t.N();
  }
};
Object.defineProperty(_h.prototype, "value", { get() {
  if (1 & this.f) throw new Error("Cycle detected");
  const t = VM(this);
  if (this.h(), t !== void 0 && (t.i = this.i), 16 & this.f) throw this.v;
  return this.v;
} });
function ZQ(t, e) {
  return new _h(t, e);
}
function YM(t) {
  const e = t.u;
  if (t.u = void 0, typeof e == "function") {
    Hd++;
    const n = Bn;
    Bn = void 0;
    try {
      e();
    } catch (r) {
      throw t.f &= -2, t.f |= 8, Dx(t), r;
    } finally {
      Bn = n, Nx();
    }
  }
}
function Dx(t) {
  for (let e = t.s; e !== void 0; e = e.n) e.S.U(e);
  t.x = void 0, t.s = void 0, YM(t);
}
function eX(t) {
  if (Bn !== this) throw new Error("Out-of-order effect");
  jM(this), Bn = t, this.f &= -2, 8 & this.f && Dx(this), Nx();
}
function Nf(t, e) {
  this.x = t, this.u = void 0, this.s = void 0, this.o = void 0, this.f = 32, this.name = e?.name;
}
Nf.prototype.c = function() {
  const t = this.S();
  try {
    if (8 & this.f || this.x === void 0) return;
    const e = this.x();
    typeof e == "function" && (this.u = e);
  } finally {
    t();
  }
};
Nf.prototype.S = function() {
  if (1 & this.f) throw new Error("Cycle detected");
  this.f |= 1, this.f &= -9, YM(this), zM(this), Hd++;
  const t = Bn;
  return Bn = this, eX.bind(this, t);
};
Nf.prototype.N = function() {
  2 & this.f || (this.f |= 2, this.o = jm, jm = this);
};
Nf.prototype.d = function() {
  this.f |= 8, 1 & this.f || Dx(this);
};
Nf.prototype.dispose = function() {
  this.d();
};
function Ix(t, e) {
  const n = new Nf(t, e);
  try {
    n.c();
  } catch (i) {
    throw n.d(), i;
  }
  const r = n.d.bind(n);
  return r[Symbol.dispose] = r, r;
}
const tX = kx(_x, () => {
  const t = /* @__PURE__ */ new Set();
  return {
    signal: (e) => {
      const n = XQ(e);
      return {
        get: () => n.value,
        set: (i) => n.value = i,
        peek: () => n.peek()
      };
    },
    computed: (e) => {
      const n = ZQ(e);
      return {
        get: () => n.value,
        peek: () => n.peek()
      };
    },
    effect: (e, n) => {
      const r = Ix(e, n);
      return t.add(r), r;
    },
    dispose: () => {
      t.forEach((e) => e()), t.clear();
    }
  };
}), nX = {
  "viewer-core/interactions": "@wix/viewer-service-interactions",
  "viewer-core/provide-css": "@wix/viewer-service-provide-css",
  "viewer-core/session": "@wix/session-service",
  "viewer-core/viewer-service-anchors": "@wix/viewer-service-anchors",
  "viewer-core/business-logger": "@wix/viewer-service-business-logger",
  "viewer-core/viewer-service-consent-policy": "@wix/viewer-service-consent-policy",
  "viewer-core/cyclic-tabbing": "@wix/viewer-service-cyclic-tabbing",
  "viewer-core/viewer-service-environment": "@wix/viewer-service-environment",
  "viewer-core/fedops-logger": "@wix/viewer-service-fedops-logger",
  "viewer-core/viewer-service-lightbox": "@wix/viewer-service-lightbox",
  "viewer-core/viewer-service-link-utils": "@wix/viewer-service-link-utils",
  "viewer-core/named-signals": "@wix/viewer-service-named-signals",
  "viewer-core/viewer-service-page-context": "@wix/viewer-service-page-context",
  "viewer-core/viewer-service-pages": "@wix/viewer-service-pages",
  "viewer-core/provide-custom-element": "@wix/viewer-service-provide-custom-element",
  "viewer-core/sdk-state": "@wix/viewer-service-sdk-state",
  "viewer-core/site-scroll-blocker": "@wix/viewer-service-site-scroll-blocker",
  "viewer-core/viewer-service-site-theme": "@wix/viewer-service-site-theme",
  "viewer-core/slider-container-scroll": "@wix/viewer-service-slider-container-scroll",
  "viewer-service-ssr-status-code": "@wix/viewer-service-ssr-status-code",
  "viewer-core/viewer-service-style-utils": "@wix/viewer-service-style-utils",
  "viewer-core/viewer-service-topology": "@wix/viewer-service-topology",
  "viewer-core/translations": "@wix/viewer-service-translations",
  "viewer-core/viewer-service-url": "@wix/viewer-service-url",
  "viewer-core/viewer-service-window-scroll": "@wix/viewer-service-window-scroll",
  "viewer-core/viewer-service-wix-client": "@wix/viewer-service-wix-client",
  "viewer-core/window-ns": "@wix/window-ns"
};
function Bc(t) {
  return nX[t] ?? t;
}
let cT = "", Jy = null;
const D3 = (t) => {
  if (!t || cT && t !== cT)
    throw new Error("Invalid host key");
}, rX = (t) => {
  if (!Jy)
    throw new Error("getService() was called before Services Manager has been instantiated");
  return Jy.getService(t);
}, iX = {
  setGlobalServicesManager(t, e) {
    D3(e), cT = e, Jy = t;
  },
  release(t) {
    D3(t), Jy = null;
  }
};
function Rx(t, e) {
  const n = Px().addService(_x, tX), r = new Map([
    ...t ? t.registeredServices : [],
    ...n.registeredServices
  ].map((o) => [Bc(o.definition.toString()), o])), i = /* @__PURE__ */ new Map(), s = [], a = {
    dispose() {
      for (let o = s.length - 1; o >= 0; o--) {
        const u = s[o];
        i.get(u)?.dispose?.();
      }
    },
    getService(o) {
      const u = Bc(o.toString());
      if (!i.has(u)) {
        const l = r.get(u);
        if (!l) {
          if (e)
            return e.getService(o);
          throw new Error(`Service ${o} is not provided`);
        }
        i.set(u, l.impl({
          config: l.config,
          getService: a.getService
        })), s.push(u);
      }
      return i.get(u);
    },
    hasService(o) {
      return r.has(Bc(o.toString()));
    },
    addService(o, u, l) {
      if (a.hasService(o))
        throw new Error(`Service ${o.toString()} is already provided`);
      {
        const h = Bc(o.toString());
        r.set(h, {
          definition: o,
          impl: u,
          config: l || {}
        }), i.has(h) || (i.set(h, u({
          config: l || {},
          getService: a.getService
        })), s.push(h));
      }
    },
    extend(o) {
      return Rx(o, a);
    },
    addServices(o) {
      o.registeredServices.forEach(({ definition: u }) => {
        if (a.hasService(u))
          throw new Error(`Service ${u.toString()} is already provided`);
      }), o.registeredServices.forEach(({ definition: u, impl: l, config: h }) => {
        r.set(Bc(u.toString()), {
          definition: u,
          impl: l,
          config: h || {}
        });
      }), o.registeredServices.forEach(({ definition: u, impl: l, config: h }) => {
        const f = Bc(u.toString());
        i.has(f) || (i.set(f, l({
          config: h || {},
          getService: a.getService
        })), s.push(f));
      });
    }
  };
  return r.forEach(({ definition: o, impl: u, config: l }) => {
    const h = Bc(o.toString());
    i.has(h) || (i.set(h, u({
      config: l || {},
      getService: a.getService
    })), s.push(h));
  }), a;
}
function Px(t = []) {
  return {
    registeredServices: t,
    addService(e, n, r) {
      return Px([
        ...t,
        { definition: e, impl: n, config: r }
      ]);
    }
  };
}
const sX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createServicesManager: Rx,
  createServicesMap: Px,
  getService: rX,
  globalServicesManagerController: iX
}, Symbol.toStringTag, { value: "Module" })), aX = /* @__PURE__ */ vt(sX);
var m0 = { exports: {} }, fS = {};
var I3;
function oX() {
  if (I3) return fS;
  I3 = 1;
  var t = gr;
  function e(f, m) {
    return f === m && (f !== 0 || 1 / f === 1 / m) || f !== f && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, i = t.useEffect, s = t.useLayoutEffect, a = t.useDebugValue;
  function o(f, m) {
    var g = m(), A = r({ inst: { value: g, getSnapshot: m } }), E = A[0].inst, w = A[1];
    return s(
      function() {
        E.value = g, E.getSnapshot = m, u(E) && w({ inst: E });
      },
      [f, g, m]
    ), i(
      function() {
        return u(E) && w({ inst: E }), f(function() {
          u(E) && w({ inst: E });
        });
      },
      [f]
    ), a(g), g;
  }
  function u(f) {
    var m = f.getSnapshot;
    f = f.value;
    try {
      var g = m();
      return !n(f, g);
    } catch {
      return !0;
    }
  }
  function l(f, m) {
    return m();
  }
  var h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : o;
  return fS.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : h, fS;
}
var mS = {};
var R3;
function uX() {
  return R3 || (R3 = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(g, A) {
      return g === A && (g !== 0 || 1 / g === 1 / A) || g !== g && A !== A;
    }
    function e(g, A) {
      h || i.startTransition === void 0 || (h = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var E = A();
      if (!f) {
        var w = A();
        s(E, w) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      w = a({
        inst: { value: E, getSnapshot: A }
      });
      var x = w[0].inst, N = w[1];
      return u(
        function() {
          x.value = E, x.getSnapshot = A, n(x) && N({ inst: x });
        },
        [g, E, A]
      ), o(
        function() {
          return n(x) && N({ inst: x }), g(function() {
            n(x) && N({ inst: x });
          });
        },
        [g]
      ), l(E), E;
    }
    function n(g) {
      var A = g.getSnapshot;
      g = g.value;
      try {
        var E = A();
        return !s(g, E);
      } catch {
        return !0;
      }
    }
    function r(g, A) {
      return A();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = gr, s = typeof Object.is == "function" ? Object.is : t, a = i.useState, o = i.useEffect, u = i.useLayoutEffect, l = i.useDebugValue, h = !1, f = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    mS.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), mS;
}
var P3;
function lX() {
  return P3 || (P3 = 1, process.env.NODE_ENV === "production" ? m0.exports = oX() : m0.exports = uX()), m0.exports;
}
var cX = lX();
const [hX] = EQ.split(".").map(Number), dX = /* @__PURE__ */ Symbol.for(hX >= 19 ? "react.transitional.element" : "react.element"), fX = typeof window < "u" && !!window.__PREACT_SIGNALS_DEVTOOLS__, qM = Symbol.dispose || /* @__PURE__ */ Symbol.for("Symbol.dispose");
let ah;
function gS(t, e) {
  const n = e.effect.S();
  return ah = e, mX.bind(e, t, n);
}
function mX(t, e) {
  e(), ah = t;
}
const L3 = () => {
}, gX = { o: 0, effect: { s: void 0, c() {
}, S: () => L3, d() {
} }, subscribe: () => L3, getSnapshot: () => 0, S() {
}, f() {
}, [qM]() {
} }, pX = Promise.prototype.then.bind(Promise.resolve());
let hT;
function bX() {
  hT || (hT = pX(JM));
}
function JM() {
  var t;
  hT = void 0, (t = ah) == null || t.f();
}
const yX = typeof window < "u" ? AQ : LM;
function QM(t = 0, e) {
  bX();
  const n = yQ();
  n.current == null && (typeof window > "u" ? n.current = gX : n.current = (function(i, s) {
    let a, o, u, l = 0, h = Ix(function() {
      a = this;
    }, { name: s || "Component" });
    return a.c = function() {
      if (l = l + 1 | 0, fX) {
        var f;
        (f = a.y) == null || f.call(a);
      }
      u && u();
    }, { o: i, effect: a, subscribe(f) {
      return u = f, function() {
        l = l + 1 | 0, u = void 0, h();
      };
    }, getSnapshot: () => l, S() {
      if (ah == null) {
        o = gS(void 0, this);
        return;
      }
      const f = ah.o, m = this.o;
      f == 0 && m == 0 || f == 0 && m == 1 ? (ah.f(), o = gS(void 0, this)) : f == 1 && m == 0 || f == 2 && m == 0 || (o = gS(ah, this));
    }, f() {
      const f = o;
      o = void 0, f?.();
    }, [qM]() {
      this.f();
    } };
  })(t, e));
  const r = n.current;
  return cX.useSyncExternalStore(r.subscribe, r.getSnapshot, r.getSnapshot), r.S(), t === 0 && yX(JM), r;
}
Object.defineProperties(os.prototype, { $$typeof: { configurable: !0, value: dX }, type: { configurable: !0, value: function({ data: t }) {
  const e = QM(1);
  try {
    return t.value;
  } finally {
    e.f();
  }
} }, props: { configurable: !0, get() {
  return { data: this };
} }, ref: { configurable: !0, value: null } });
function XM(t, e) {
  return QM(t, e);
}
globalThis.WixReactContext || (globalThis.WixReactContext = SQ(void 0));
var Lx = globalThis.WixReactContext;
const rA = "core:provide-component", AX = kx(rA, ({ config: t, getService: e }) => {
  const { signal: n } = e(_x), r = n(t.topComponents || []), i = n(t.bottomComponents || []);
  return {
    addTopComponent: (o) => {
      r.set([...r.get(), o]);
    },
    addBottomComponent: (o) => {
      i.set([...i.get(), o]);
    },
    getAllTopComponents: () => r.get(),
    getAllBottomComponents: () => i.get()
  };
}), EX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ProvideComponentServiceDefinition: rA,
  ProvideComponentServiceFactory: AX
}, Symbol.toStringTag, { value: "Module" }));
function ZM({ servicesManager: t, children: e }) {
  const n = t.hasService(rA);
  return (
    // Passing partial service manager for security reasons
    gr.createElement(
      Lx.Provider,
      { value: {
        getService: t.getService,
        extend: t.extend
      } },
      n && gr.createElement(M3, { position: "top" }),
      e,
      n && gr.createElement(M3, { position: "bottom" })
    )
  );
}
function Mx() {
  const t = MM(Lx);
  if (!t)
    throw new Error("No ServiceManagerProvider found in the component tree, make sure to wrap your app with ServicesManagerProvider");
  return t.getService;
}
function eO(t) {
  const e = Mx();
  return XM(), e(t);
}
function SX(t) {
  const e = Mx();
  if (!e)
    throw new Error("No ServiceManagerProvider found in the component tree, make sure to wrap your app with ServicesManagerProvider");
  return t.map((n) => e(n));
}
function wX(t) {
  const e = MM(Lx), [n] = wQ(() => e ? e.extend(t.servicesMap) : Rx(t.servicesMap));
  return LM(() => {
    if (t.disposeOnUnmount)
      return () => {
        n.dispose();
      };
  }, [t.disposeOnUnmount, n]), gr.createElement(ZM, { servicesManager: n }, t.children);
}
function M3({ position: t }) {
  const e = eO(rA), n = t === "top" ? e.getAllTopComponents() : e.getAllBottomComponents();
  return gr.createElement(gr.Fragment, null, n.map((r, i) => gr.createElement(r, { key: i })));
}
const FX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ServicesManagerProvider: ZM,
  WixServices: wX,
  useGetService: Mx,
  useService: eO,
  useServices: SX,
  useSignals: XM
}, Symbol.toStringTag, { value: "Module" })), TX = /* @__PURE__ */ vt(FX);
function vX(t) {
  return t;
}
function la(t, e) {
  return e;
}
la.withConfig = function() {
  return function(t, e) {
    return e;
  };
};
const du = vX, Ja = la, xX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defineStaticService: du,
  implementStaticService: Ja
}, Symbol.toStringTag, { value: "Module" })), No = du("@wix/viewer-service-environment"), CX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EnvironmentDefinition: No
}, Symbol.toStringTag, { value: "Module" })), kX = /* @__PURE__ */ vt(CX), tO = ({ requestUrl: t, experiments: e = {}, isQaMode: n, trackClicksAnalytics: r = !1, useSandboxInHTMLComp: i = !1, viewMode: s = "desktop", previewMode: a = !1, editorType: o = "RESPONSIVE", editorName: u = "Studio", deviceType: l, isWixSite: h = !1, isInSeo: f = !1, metaSiteId: m = "", mainPageId: g = "", userId: A = "", domain: E = "", language: w = "en", languageDirection: x = "ltr", hasUserDomainMedia: N = !1, externalBaseUrl: B = "" }) => {
  const P = globalThis.window, C = t || P?.location?.href || "", D = C ? new URL(C).searchParams : "", L = C.toLowerCase().includes("forcereducedmotion");
  return {
    experiments: e,
    isExperimentOpen: (k) => {
      const I = e[k];
      return I === !0 || I === "true" || I === "B";
    },
    reducedMotion: L || !!P?.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches,
    isQaMode: n || (D ? D.get("isqa") === "true" : !1),
    trackClicksAnalytics: r,
    useSandboxInHTMLComp: i,
    viewMode: s,
    getPreviewMode: () => a,
    editorType: o,
    editorName: u,
    deviceType: l || (s === "mobile" ? "Smartphone" : "Desktop"),
    isMobileView: s === "mobile" && o !== "RESPONSIVE",
    isWixSite: h,
    isInSeo: f,
    getMetaSiteId: () => m,
    mainPageId: g,
    userId: A,
    domain: E,
    language: w,
    getLanguageDirection: () => x,
    isSSR: () => !P,
    hasUserDomainMedia: N,
    externalBaseUrl: B
  };
}, qg = "core:signals", _X = (t, e) => {
  const n = tO(t), { signal: r } = e(qg), i = r(t.languageDirection || "ltr"), s = r(t.metaSiteId || ""), a = r(t.previewMode || !1), o = r(t.language || "en");
  return {
    ...n,
    get language() {
      return o.get();
    },
    getLanguageDirection: () => i.get(),
    setLanguageDirection: (u) => i.set(u),
    getMetaSiteId: () => s.get(),
    setMetaSiteId: (u) => s.set(u),
    getPreviewMode: () => a.get(),
    setPreviewMode: (u) => a.set(u),
    setLanguage: (u) => o.set(u)
  };
}, NX = Ja(No, ({ config: t }) => tO(t)), DX = la(No, ({ config: t, getService: e }) => _X(t, e)), IX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EnvironmentEditorService: DX,
  EnvironmentService: NX
}, Symbol.toStringTag, { value: "Module" })), RX = /* @__PURE__ */ vt(IX), nO = du("@wix/viewer-service-cyclic-tabbing"), PX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CyclicTabbingDefinition: nO
}, Symbol.toStringTag, { value: "Module" })), LX = /* @__PURE__ */ vt(PX);
var Sy = { exports: {} }, O3 = Sy.exports, B3;
function MX() {
  return B3 || (B3 = 1, (function(t) {
    (function(e) {
      var n = function() {
      }, r = e.requestAnimationFrame || e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || e.msRequestAnimationFrame || function(h) {
        return setTimeout(h, 16);
      };
      function i() {
        var h = this;
        h.reads = [], h.writes = [], h.raf = r.bind(e);
      }
      i.prototype = {
        constructor: i,
        /**
         * We run this inside a try catch
         * so that if any jobs error, we
         * are able to recover and continue
         * to flush the batch until it's empty.
         *
         * @param {Array} tasks
         */
        runTasks: function(h) {
          for (var f; f = h.shift(); ) f();
        },
        /**
         * Adds a job to the read batch and
         * schedules a new frame if need be.
         *
         * @param  {Function} fn
         * @param  {Object} ctx the context to be bound to `fn` (optional).
         * @public
         */
        measure: function(h, f) {
          var m = f ? h.bind(f) : h;
          return this.reads.push(m), s(this), m;
        },
        /**
         * Adds a job to the
         * write batch and schedules
         * a new frame if need be.
         *
         * @param  {Function} fn
         * @param  {Object} ctx the context to be bound to `fn` (optional).
         * @public
         */
        mutate: function(h, f) {
          var m = f ? h.bind(f) : h;
          return this.writes.push(m), s(this), m;
        },
        /**
         * Clears a scheduled 'read' or 'write' task.
         *
         * @param {Object} task
         * @return {Boolean} success
         * @public
         */
        clear: function(h) {
          return o(this.reads, h) || o(this.writes, h);
        },
        /**
         * Extend this FastDom with some
         * custom functionality.
         *
         * Because fastdom must *always* be a
         * singleton, we're actually extending
         * the fastdom instance. This means tasks
         * scheduled by an extension still enter
         * fastdom's global task queue.
         *
         * The 'super' instance can be accessed
         * from `this.fastdom`.
         *
         * @example
         *
         * var myFastdom = fastdom.extend({
         *   initialize: function() {
         *     // runs on creation
         *   },
         *
         *   // override a method
         *   measure: function(fn) {
         *     // do extra stuff ...
         *
         *     // then call the original
         *     return this.fastdom.measure(fn);
         *   },
         *
         *   ...
         * });
         *
         * @param  {Object} props  properties to mixin
         * @return {FastDom}
         */
        extend: function(h) {
          if (typeof h != "object") throw new Error("expected object");
          var f = Object.create(this);
          return u(f, h), f.fastdom = this, f.initialize && f.initialize(), f;
        },
        // override this with a function
        // to prevent Errors in console
        // when tasks throw
        catch: null
      };
      function s(h) {
        h.scheduled || (h.scheduled = !0, h.raf(a.bind(null, h)));
      }
      function a(h) {
        var f = h.writes, m = h.reads, g;
        try {
          n("flushing reads", m.length), h.runTasks(m), n("flushing writes", f.length), h.runTasks(f);
        } catch (A) {
          g = A;
        }
        if (h.scheduled = !1, (m.length || f.length) && s(h), g)
          if (n("task errored", g.message), h.catch) h.catch(g);
          else throw g;
      }
      function o(h, f) {
        var m = h.indexOf(f);
        return !!~m && !!h.splice(m, 1);
      }
      function u(h, f) {
        for (var m in f)
          f.hasOwnProperty(m) && (h[m] = f[m]);
      }
      var l = e.fastdom = e.fastdom || new i();
      t.exports = l;
    })(typeof window < "u" ? window : typeof O3 < "u" ? O3 : globalThis);
  })(Sy)), Sy.exports;
}
var OX = MX();
const Ni = /* @__PURE__ */ kh(OX), BX = {
  elements: ["iframe", "input", "select", "textarea", "button"],
  additional: ["a[href]", '[tabindex]:not([tabindex="-1"])'],
  get all() {
    return [...this.elements, ...this.additional].join(",");
  }
}, $c = {
  RESTORE_TAB_INDEX: "data-restore-tabindex",
  ARIA_HIDDEN: "aria-hidden"
}, $X = (t, e) => {
  let n = [];
  const r = globalThis.window, s = e(No).isSSR(), a = (g = []) => {
    s || (n.length > 0 && f(), n.push({
      cyclicTabbingParentCompIds: g
    }), h(g));
  }, o = (g) => {
    s || (f(), m(g));
  }, u = (g) => (Array.isArray(g) ? g : [g]).map((E) => `#${E}`).join(","), l = (g) => {
    const A = g.getAttribute($c.RESTORE_TAB_INDEX) || g.getAttribute("tabindex");
    Ni.mutate(() => {
      g.setAttribute("tabindex", "-1"), g.setAttribute($c.RESTORE_TAB_INDEX, `${A}`), t?.screenReaderFocus && g.setAttribute($c.ARIA_HIDDEN, "true");
    });
  };
  function h(g) {
    function A() {
      const E = r.document.querySelectorAll(BX.all), w = g ? Array.from(r.document.querySelectorAll(u(g))) : [];
      E.forEach((x) => {
        w.some((N) => N.contains(x)) || l(x);
      });
    }
    Ni.measure(() => {
      A();
    });
  }
  const f = () => {
    Ni.measure(() => {
      r.document.querySelectorAll(`[${$c.RESTORE_TAB_INDEX}]`).forEach((A) => {
        const E = A.getAttribute($c.RESTORE_TAB_INDEX);
        Ni.mutate(() => {
          E === "null" ? A.removeAttribute("tabindex") : E && A.setAttribute("tabindex", E), A.removeAttribute($c.RESTORE_TAB_INDEX), t?.screenReaderFocus && A.removeAttribute($c.ARIA_HIDDEN);
        });
      });
    });
  }, m = (g) => {
    const A = u(g);
    n = n.filter((w) => u(w.cyclicTabbingParentCompIds) !== A);
    const E = n.pop();
    E && a(E.cyclicTabbingParentCompIds);
  };
  return {
    enableCyclicTabbing: a,
    disableCyclicTabbing: o
  };
}, HX = Ja(nO, ({ config: t, getService: e }) => $X(t, e)), UX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CyclicTabbingService: HX
}, Symbol.toStringTag, { value: "Module" })), GX = /* @__PURE__ */ vt(UX), Ox = du("@wix/viewer-service-link-utils"), WX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LinkUtilsDefinition: Ox
}, Symbol.toStringTag, { value: "Module" })), VX = /* @__PURE__ */ vt(WX), rO = /mailto:([^?]+)(\?(.*))?/, iO = /^tel:(.*)/, sO = /^\/([^?#]*)?[#]?([^?#]*)[?]?(.*)/, KX = /^#([^?]*)[?]?(.*)/, zX = /^(http|https):\/\/(.*)/, aO = /^wix:document:\/\/v1\/(.+)\/(.+)/, oO = /^document:\/\/(.*)/, jX = (t) => iO.test(t), dT = (t) => rO.test(t), uO = (t) => aO.test(t) || oO.test(t), Bx = (t) => zX.test(t), YX = (t) => sO.test(t), qX = (t) => KX.test(t), $x = (t) => ["SCROLL_TO_TOP", "SCROLL_TO_BOTTOM"].includes(t), JX = /(?:\+|\()?\d(?:[-.() \t\u00a0\u1680\u180e\u2000\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]{0,5}\d){6,16}\)?(?![<@)\w])|\*\d{4}(?![<@)\w])/, QX = /(?:^|[\s:;,<>])(?:\+|\()?\d(?:[-.() \t\u00a0\u1680\u180e\u2000\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]{0,5}\d){6,16}\)?(?![<@)\w])|\*\d{4}(?![<@)\w])/, XX = /(^|[\s:;,<>])([A-Z0-9][A-Z0-9._%+-]+@[A-Z0-9][A-Z0-9.-]+\.[A-Z]{2,})(?=$|[\s:;,<>])/i, ZX = /(^|[\s:;,<>])((?:https?:\/\/|www\.)[a-z0-9](?:\.?[a-z0-9\-%_])*(?:(?:\\|\/)[a-z0-9\-._~:/\\?#[\]@!$&'()*+,;=%]*)?)(?=$|[^a-z0-9\-._~:/\\?#[\]@!$&'()*+,;=%])/i, eZ = new RegExp(QX, "g"), tZ = /([A-Z0-9][A-Z0-9._%+-]+@[A-Z0-9][A-Z0-9.-]+\.[A-Z]{2,})/gi, nZ = /((?:https?:\/\/|www\.)[a-z0-9](?:\.?[a-z0-9\-%_])*(?:(?:\\|\/)[a-z0-9\-._~:/\\?#[\]@!$&'()*+,;=%]*)?)/gi, uu = {
  PHONE: "PHONE",
  MAIL: "MAIL",
  URL: "URL"
}, rZ = (t) => {
  const e = t.match(JX);
  return e && {
    key: e[0],
    value: e[0].match(/[*\d]/g).join(""),
    index: e.index,
    pattern: uu.PHONE
  };
}, iZ = (t) => {
  const e = t.match(XX);
  if (e) {
    const n = e[1].length, r = e[2];
    return {
      key: r,
      value: r,
      index: e.index + n,
      pattern: uu.MAIL
    };
  } else
    return null;
}, lO = (t) => t.toLowerCase().indexOf("http") === 0 ? t : `http://${t}`, sZ = (t) => {
  const e = t.match(ZX);
  if (e) {
    const n = e[2], r = e[1].length, i = lO(n);
    return {
      key: n,
      value: i,
      index: e.index + r,
      pattern: uu.URL
    };
  } else
    return null;
}, aZ = (t, e) => t.replace(tZ, e), oZ = [" ", ":", ";", ",", "<", ">"], uZ = (t, e) => t.replace(eZ, (n) => {
  const r = oZ.find((i) => i === n[0]);
  return r ? r + e(n.substring(1, n.length)) : e(n);
}), lZ = (t, e) => t.replace(nZ, e), cZ = {
  [uu.PHONE]: rZ,
  [uu.MAIL]: iZ,
  [uu.URL]: sZ
};
function hZ(t, e = {}) {
  if (!t)
    return null;
  const n = Object.keys(e).filter((i) => e[i]).map((i) => cZ[i](t)).filter((i) => i !== null);
  return n[0] ? n.reduce((i, s) => s.index < i.index ? s : i, n[0]) : null;
}
const cO = (t, e, n = "filesusr.com/", r = "", i = !1, s = !1) => {
  const [, a, o] = aO.exec(t) || oO.exec(t);
  return {
    type: "DocumentLink",
    href: vZ({ docId: a, name: o || "", indexable: !1 }, e, n, r, i, s),
    target: "_blank",
    docInfo: {
      docId: a,
      name: o
    }
  };
}, dZ = [
  "pdf",
  "docx",
  "zip",
  "pptx",
  "xlsx",
  "doc",
  "txt",
  "rar",
  "xls",
  "ppt",
  "ppsx",
  "epub",
  "rtf",
  "pub",
  "vcf",
  "csv"
], fZ = {
  [uu.PHONE]: "tel:",
  [uu.MAIL]: "mailto:",
  [uu.URL]: ""
}, mZ = ({ pattern: t, value: e }) => ({ ...t === uu.URL ? { target: "_blank" } : {}, href: `${fZ[t]}${e}` }), gZ = (t) => Object.keys(t).map((e) => `${e}=${encodeURIComponent(t[e])}`).join("&"), pZ = (t, e) => {
  const n = hZ(t, { MAIL: !0, URL: !0, PHONE: e });
  return n && mZ(n);
}, Hx = (t) => (e) => {
  let n = "";
  const r = e.trim();
  switch (t) {
    case "email":
      n = `href="mailto:${r}"`;
      break;
    case "phone":
      n = `href="tel:${r}"`;
      break;
    case "url":
      n = `href="${lO(r)}" target="_blank"`;
      break;
  }
  return `<a data-auto-recognition="true" ${n}>${e}</a>`;
}, bZ = Hx("email"), yZ = Hx("url"), AZ = Hx("phone"), EZ = (t, e) => (n, r) => {
  if (!r || !e && r.startsWith("&lt;"))
    return n;
  let i = aZ(r, bZ);
  return i = lZ(i, yZ), t && (i = uZ(i, AZ)), n.split(r).join(i);
};
function SZ(t, e, { parseEscaped: n } = { parseEscaped: !1 }) {
  return t.replace(/>((?![<>]).+?)<|(?:<a.*>.*<\/a>)/g, EZ(e, n));
}
const hO = ({ recipient: t, subject: e, body: n, bcc: r = void 0, cc: i = void 0 }) => {
  const s = Object.entries({ subject: e, body: n, bcc: r, cc: i }).filter(([, o]) => o).map(([o, u]) => `${o}=${u}`).join("&"), a = s.length > 0 ? `?${s}` : "";
  return `mailto:${t}${a}`;
}, dO = ({ phoneNumber: t }) => `tel:${t}`, wZ = (t) => {
  const e = new URL(t).hostname;
  return e.endsWith(".wixsite.com") || e.endsWith(".editorx.io") || e.endsWith(".wixstudio.io") || e.endsWith(".wixstudio.com");
}, FZ = (t, e, n) => {
  const r = new URL(e).hostname.startsWith("editor.wix");
  return !t || r || wZ(e) ? !1 : dZ.some((i) => n.endsWith(i));
}, TZ = (t, e, n) => t.endsWith(".pdf") ? "" : `?${gZ({ dn: e })}`, fO = (t) => {
  const e = t.endsWith("/") ? t : `${t}/`;
  return new URL("_files", e);
}, vZ = ({ docId: t, name: e, indexable: n }, r, i, s, a, o = !1) => {
  if (!o)
    return "";
  const l = FZ(a, s, t) ? fO(s) : `https://${r}.${i}`, h = t.includes("/") ? t : `ugd/${t}`, f = h.startsWith("/") ? h : `/${h}`, m = TZ(t, e);
  return `${l}${f}${m}`;
}, fT = (t, e = "") => `wix:document://v1/${t}/${e}`, xZ = {
  SCROLL_TO_TOP: "top",
  SCROLL_TO_BOTTOM: "bottom"
}, CZ = (t) => ({
  subject: encodeURIComponent(t.get("subject") || ""),
  body: encodeURIComponent(t.get("body") || ""),
  bcc: encodeURIComponent(t.get("bcc") || ""),
  cc: encodeURIComponent(t.get("cc") || "")
}), kZ = (t) => {
  const [, e, n] = rO.exec(t), r = CZ(new URLSearchParams(n));
  return {
    type: "EmailLink",
    href: hO({ recipient: e, ...r }),
    target: "_self"
  };
}, _Z = (t) => {
  const [, e] = iO.exec(t);
  return {
    type: "PhoneLink",
    href: dO({ phoneNumber: e }),
    target: "_self"
  };
}, NZ = (t, e = "_blank", n = "noopener") => ({
  type: "ExternalLink",
  href: t,
  target: e,
  rel: n
});
class Ux extends Error {
  constructor() {
    super("Unsupported link type"), this.name = "UnsupportedLinkTypeError", Error.captureStackTrace && Error.captureStackTrace(this, Ux);
  }
}
const mO = (t) => {
  const { metaSiteId: e, isMobileView: n, userFileDomainUrl: r, externalBaseUrl: i, isPremiumDomain: s, isResolveDocumentLinkEnabled: a = !1 } = t, o = `https://${e}.filesusr.com/`, u = (l) => l.startsWith(o);
  return {
    getImpliedLink: (l) => pZ(l, n),
    getImpliedLinks: (l, h) => SZ(l, n, h),
    getLink: ({ href: l = "", anchorDataId: h = "", docInfo: f, type: m } = {}) => {
      if (dT(l))
        return l;
      if (u(l))
        return fT(f.docId, f.name);
      const g = typeof h == "string" ? h : h?.id;
      return $x(g) ? `#${xZ[g]}` : l;
    },
    getLinkProps: (l, h, f) => {
      if (dT(l))
        return kZ(l);
      if (jX(l))
        return _Z(l);
      if (Bx(l))
        return NZ(l, h, f);
      if (uO(l))
        return cO(l, e, r, i, s, a);
      throw new Ux();
    },
    isDocumentHref: u
  };
}, DZ = (t, e) => {
  const n = e(No), { isMobileView: r } = n, i = n.getMetaSiteId() ?? "unknown", s = mO({
    metaSiteId: i,
    isMobileView: r
  });
  return {
    isDynamicPage: () => !1,
    isAbsoluteUrl: Bx,
    getImpliedLink: s.getImpliedLink,
    getImpliedLinks: s.getImpliedLinks,
    getLink: s.getLink,
    getLinkProps: s.getLinkProps,
    getLinkUrlFromDataItem: () => {
      throw new Error("getLinkUrlFromDataItem is not implemented");
    }
  };
}, IZ = Ja(Ox, ({ config: t, getService: e }) => DZ(t, e)), RZ = {
  top: "SCROLL_TO_TOP",
  bottom: "SCROLL_TO_BOTTOM"
}, $3 = (t, e) => {
  if (t) {
    const [n] = e.replace("#", "/#").split(/[/]+/);
    return Object.values(t).filter((i) => i.prefix === n).length === 1;
  }
  return !1;
}, PZ = (t, e) => {
  const n = decodeURIComponent(e), r = `./${n}`;
  if (t[r])
    return [n, ""];
  {
    const [i, ...s] = e.split("/"), a = s.length > 0 ? `/${s.join("/")}` : "";
    return [i, a];
  }
}, H3 = (t, e) => {
  const n = Object.keys(t.routes).find((r) => {
    const i = t.routes[r];
    return i.type === "Dynamic" ? (i.pageIds || []).includes(e) : i.pageId === e;
  });
  if (n)
    return mT(n);
  throw new Error(`No url route for pageId: ${e}`);
}, mT = (t) => t.replace(/^\.\//, "/"), LZ = (t) => t.replace(/\/+$/, ""), U3 = (t, e) => {
  const n = t.replace(/\/+$/, ""), r = e.replace(/^\/+/, ""), i = `${n}/${r}`;
  return LZ(i);
}, MZ = (t, e) => {
  const { routingInfo: n, userFileDomainUrl: r, popupPages: i, getCompIdByWixCodeNickname: s, getRoleForCompId: a, routersConfig: o, multilingualInfo: u, isPremiumDomain: l } = t, h = e(No), f = h.getMetaSiteId() ?? "unknown", m = h.isExperimentOpen("specs.thunderbolt.resolveDocumentLink"), g = mO({
    metaSiteId: f,
    isMobileView: h.isMobileView,
    userFileDomainUrl: r,
    externalBaseUrl: n.externalBaseUrl,
    isPremiumDomain: l,
    isResolveDocumentLinkEnabled: m
  }), A = (L) => i ? i[L] : !1, E = (L) => g.isDocumentHref(L) || l && L.startsWith(fO(n.externalBaseUrl).href), w = (L) => L.replace(n.externalBaseUrl, ""), x = (L) => {
    const [, k = "", I = "", U = ""] = sO.exec(L), j = k.replace(/\/+$/, ""), J = new URLSearchParams(U);
    return !u?.isOriginalLanguage && u?.currentLanguage?.resolutionMethod === "QueryParam" && J.set("lang", u.currentLanguage.languageCode), { relativePageUrlPrefix: j, anchor: I, queryString: J.toString() };
  }, N = (L) => {
    const { relativePageUrlPrefix: k } = x(L);
    return $3(o, k);
  }, B = () => {
    const L = Object.keys(n.routes).find((k) => n.routes[k].pageId === n.mainPageId);
    return mT(L);
  }, P = (L, k = "_self", I) => {
    const { relativePageUrlPrefix: U = "", anchor: j = "", queryString: J } = x(L), G = RZ[j] || j;
    if (A(U))
      return {
        type: "PageLink",
        href: "",
        target: "_self",
        linkPopupId: U
      };
    const H = n.externalBaseUrl;
    let q, X, ie;
    if ($3(o, U))
      ie = `./${U}` === n.relativeUrl, q = "DynamicPageLink", X = `${H}/${U}`;
    else {
      const [Me, Le] = PZ(n.routes, U), fn = n.pagesUriSEOs[Me] || Me, Yt = `./${fn}`, Rn = Yt === "./" ? { pageId: n.mainPageId } : n.routes[Yt], Pn = Rn?.pageId === n.mainPageId;
      q = "PageLink", X = Pn && !Le ? H : `${H}/${fn}${Le}`, ie = Rn && Rn.pageId === n.pageId;
    }
    const te = G && s && s(G), Pe = ie && te, We = G && !Pe;
    return {
      href: `${X}${J ? `?${new URLSearchParams(J).toString()}` : ""}`,
      target: k,
      rel: I,
      type: q,
      // if we have an anchor on the current page, we set the anchor compId
      ...Pe && { anchorCompId: te },
      // if we have an anchor on another page, we set the anchor data item Id
      ...We && { anchorDataId: G }
    };
  }, C = (L) => {
    const [k, I] = L.split("?");
    if (I) {
      const U = encodeURIComponent(`?${I}`);
      return k ? `${k}${U}` : U;
    }
    return k;
  }, D = {
    AnchorLink: (L) => {
      const { anchorDataId: k, pageId: I } = L, j = $x(k) ? n.pageId : I.replace(/^#/, ""), J = k.startsWith("#") ? k : `#${k}`;
      return `${H3(n, j)}${J}`;
    },
    DocumentLink: (L) => {
      const { docId: k, name: I } = L;
      return fT(k, I);
    },
    ExternalLink: (L) => {
      const { url: k } = L;
      return k;
    },
    DynamicPageLink: (L) => {
      const { routerId: k, innerRoute: I, anchorDataId: U = "" } = L, j = U ?? "", J = `/${o[k].prefix}`, G = I && C(I), H = G ? `/${G}${j}` : j;
      return `${J}${H}`;
    },
    TpaPageLink: (L) => {
      const { pageId: k, path: I = "" } = L, U = k.replace(/^#/, ""), j = n.pageIdToPrefix[U], J = n.pages[U].pageUriSEO, G = j ? `/${j}/${J}` : `/${J}`, H = C(I);
      return H && n.isCustomizedUrl ? j ? U3(j, H) : H : I.startsWith(G) ? H : U3(G, H);
    },
    PageLink: (L) => {
      const { pageId: k } = L, I = ((typeof k == "string" ? k : k.id) || "").replace(/^#/, "");
      return A(I) ? `/${I}` : I === n.mainPageId ? "/" : H3(n, I);
    },
    PhoneLink: (L) => dO(L),
    EmailLink: (L) => hO(L)
  };
  return {
    isDynamicPage: N,
    isAbsoluteUrl: Bx,
    getImpliedLink: g.getImpliedLink,
    getImpliedLinks: g.getImpliedLinks,
    getLink: ({ href: L = "", linkPopupId: k, anchorCompId: I = "", anchorDataId: U = "", docInfo: j, type: J } = {}) => {
      if (k)
        return `/${k}`;
      if (E(L))
        return fT(j.docId, j.name);
      const G = { href: L, linkPopupId: k, anchorDataId: U, docInfo: j, type: J };
      if (OZ(f, G))
        return g.getLink(G);
      const [H] = L.split("?"), q = a?.(I, "wixCode") || U, X = q ? `#${q}` : "";
      return `${H === n.externalBaseUrl ? B() : w(H)}${X}`;
    },
    getLinkProps: (L, k, I) => {
      if (qX(L)) {
        const j = `${mT(n.relativeUrl)}${L}`;
        return P(j, k);
      }
      return YX(L) ? P(L, k, I) : uO(L) ? cO(L, f, r, n.externalBaseUrl, l, m) : g.getLinkProps(L, k, I);
    },
    getLinkUrlFromDataItem: (L) => {
      const k = D[L.type];
      if (k)
        return k(L);
      throw new Error("Provided link type is not supported");
    }
  };
}, OZ = (t, { href: e = "", anchorDataId: n = "", type: r }) => {
  const i = typeof n == "string" ? n : n?.id;
  return dT(e) || r === "ExternalLink" || e.startsWith(`https://${t}.filesusr.com/`) || $x(i);
}, BZ = Ja(Ox, ({ config: t, getService: e }) => MZ(t, e)), $Z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  InternalLinkUtilsService: BZ,
  LinkUtilsService: IZ
}, Symbol.toStringTag, { value: "Module" })), HZ = /* @__PURE__ */ vt($Z), Gx = "@wix/viewer-service-site-scroll-blocker", UZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SiteScrollBlockerDefinition: Gx
}, Symbol.toStringTag, { value: "Module" })), GZ = /* @__PURE__ */ vt(UZ), Wx = du("@wix/viewer-service-provide-css"), WZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ProvideCssDefinition: Wx
}, Symbol.toStringTag, { value: "Module" })), VZ = ({ onSiteScrollBlockChanged: t, shouldBlockScrollWithoutVar: e } = {}, n) => {
  const r = n(No), i = r.isExperimentOpen("specs.thunderbolt.shouldFixIosFlashBug"), s = r.isSSR(), a = globalThis.window;
  let o = 0;
  const u = /* @__PURE__ */ new Map(), l = e ? "siteScrollingBlocked" : "blockSiteScrolling";
  let h = l;
  const f = "MENU_AS_CONTAINER", m = n(qg);
  n(Wx).addGlobalStyle(`
    .blockSiteScrolling,
    .siteScrollingBlocked {
        position: fixed;
        width: 100%;
    }

    .siteScrollingBlockedIOSFix {
        overflow: hidden !important;
    }

    .blockSiteScrolling #SITE_CONTAINER {
        margin-top: calc(var(--blocked-site-scroll-margin-top) * -1);
    }`);
  const E = m.signal([]);
  let w = 0, x, N = !1, B = null, P = !1;
  const C = m.computed(() => E.get().length > 0), D = () => {
    a.scrollTo(0, w);
  }, L = () => ({
    bodyElement: document.body,
    siteContainerElement: document.getElementById("SITE_CONTAINER"),
    menuInlineContentParentElement: document.getElementById("inlineContentParent-MENU_AS_CONTAINER")
  }), k = (te, Pe = "") => {
    te.style && (te.style.marginTop = Pe);
  }, I = (te) => {
    te && (te.style.overscrollBehaviorY = "contain");
  }, U = (te) => {
    te && te.style.removeProperty("overscroll-behavior-y");
  }, j = () => {
    const te = document.getElementById("inlineContentParent-MENU_AS_CONTAINER");
    if (!te || B)
      return;
    const Pe = (We) => {
      const Me = We.target, Le = document.getElementById("POPUPS_ROOT"), fn = te.contains(Me), Yt = Le?.contains(Me);
      fn || Yt || We.preventDefault();
    };
    document.addEventListener("touchmove", Pe, { passive: !1 }), B = () => {
      document.removeEventListener("touchmove", Pe), B = null;
    };
  }, J = () => {
    B?.();
  }, G = (te) => {
    const { bodyElement: Pe, siteContainerElement: We, menuInlineContentParentElement: Me } = L();
    Ni.measure(() => {
      P || (P = !0, w = a.scrollY, Ni.mutate(() => {
        e ? E.get().includes(f) && i ? (N = !0, h = "siteScrollingBlockedIOSFix", I(Me), j()) : (h = l, x = We?.style?.marginTop, We && k(We, `calc(${w}px*-1)`)) : (h = l, Pe.style.setProperty("--blocked-site-scroll-margin-top", `${Math.max(0.5, w)}px`), J()), Pe.classList.add(h);
      }));
    }), u.forEach(({ handleBlockedBy: Le }) => Le && Le(te));
  }, H = (te) => {
    const { bodyElement: Pe, siteContainerElement: We, menuInlineContentParentElement: Me } = L();
    P = !1, Ni.mutate(() => {
      Pe.classList.remove(h), e ? N ? (N = !1, U(Me), J()) : We && k(We, x) : (Pe.style.removeProperty("--blocked-site-scroll-margin-top"), J()), D();
    }), u.forEach(({ handleUnblockedBy: Le }) => Le && Le(te));
  }, q = (te) => {
    E.set(E.get().includes(te) ? E.get() : [...E.get(), te]), t && t(C.get()), E.get().length === 1 && G(te);
  }, X = (te) => {
    const [Pe] = E.get();
    E.set(E.get().filter((Le) => Le !== te));
    const [We] = E.get();
    t && t(C.get()), Pe !== We && (We ? G(te) : H(te));
  };
  return {
    setSiteScrollingBlocked: (te, Pe) => {
      if (!s)
        return te ? q(Pe) : X(Pe);
    },
    registerScrollBlockedListener(te) {
      const Pe = ++o;
      return u.set(Pe, te), Pe;
    },
    unRegisterScrollBlockedListener(te) {
      u.delete(te);
    },
    isScrollingBlocked: () => C.get()
  };
}, KZ = la(Gx, ({ config: t, getService: e }) => VZ(t, e)), zZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SiteScrollBlockerService: KZ
}, Symbol.toStringTag, { value: "Module" })), jZ = /* @__PURE__ */ vt(zZ), gO = du("@wix/viewer-service-style-utils"), YZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  StyleUtilsDefinition: gO
}, Symbol.toStringTag, { value: "Module" })), qZ = /* @__PURE__ */ vt(YZ), pO = {
  visibility: "hidden !important",
  overflow: "hidden !important",
  height: "0 !important",
  width: "0 !important",
  "min-width": "0 !important",
  "min-height": "0 !important",
  "margin-bottom": "0 !important",
  "margin-left": "0 !important",
  "margin-right": "0 !important",
  padding: "0 !important"
}, JZ = {
  ...pO,
  position: "absolute !important",
  "margin-top": "0 !important"
}, bO = {
  visibility: null,
  overflow: null,
  height: null,
  width: null,
  "min-width": null,
  "min-height": null,
  "margin-bottom": null,
  "margin-left": null,
  "margin-right": null,
  padding: null
}, QZ = {
  ...bO,
  position: null,
  "margin-top": null
}, XZ = {
  visibility: "hidden !important"
}, ZZ = {
  visibility: null
}, eee = ({ isResponsive: t }) => ({
  getCollapsedStyles: () => t ? JZ : pO,
  getExpandedStyles: () => t ? QZ : bO,
  getHiddenStyles: () => XZ,
  getShownStyles: () => ZZ
}), tee = Ja(gO, ({ config: t }) => eee(t)), nee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  StyleUtilsService: tee
}, Symbol.toStringTag, { value: "Module" })), ree = /* @__PURE__ */ vt(nee);
var pS = {}, gT = function(t, e) {
  return gT = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, gT(t, e);
};
function yO(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  gT(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var Qy = function() {
  return Qy = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, Qy.apply(this, arguments);
};
function AO(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function EO(t, e, n, r) {
  var i = arguments.length, s = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(t, e, n, r);
  else for (var o = t.length - 1; o >= 0; o--) (a = t[o]) && (s = (i < 3 ? a(s) : i > 3 ? a(e, n, s) : a(e, n)) || s);
  return i > 3 && s && Object.defineProperty(e, n, s), s;
}
function SO(t, e) {
  return function(n, r) {
    e(n, r, t);
  };
}
function wO(t, e, n, r, i, s) {
  function a(x) {
    if (x !== void 0 && typeof x != "function") throw new TypeError("Function expected");
    return x;
  }
  for (var o = r.kind, u = o === "getter" ? "get" : o === "setter" ? "set" : "value", l = !e && t ? r.static ? t : t.prototype : null, h = e || (l ? Object.getOwnPropertyDescriptor(l, r.name) : {}), f, m = !1, g = n.length - 1; g >= 0; g--) {
    var A = {};
    for (var E in r) A[E] = E === "access" ? {} : r[E];
    for (var E in r.access) A.access[E] = r.access[E];
    A.addInitializer = function(x) {
      if (m) throw new TypeError("Cannot add initializers after decoration has completed");
      s.push(a(x || null));
    };
    var w = (0, n[g])(o === "accessor" ? { get: h.get, set: h.set } : h[u], A);
    if (o === "accessor") {
      if (w === void 0) continue;
      if (w === null || typeof w != "object") throw new TypeError("Object expected");
      (f = a(w.get)) && (h.get = f), (f = a(w.set)) && (h.set = f), (f = a(w.init)) && i.unshift(f);
    } else (f = a(w)) && (o === "field" ? i.unshift(f) : h[u] = f);
  }
  l && Object.defineProperty(l, r.name, h), m = !0;
}
function FO(t, e, n) {
  for (var r = arguments.length > 2, i = 0; i < e.length; i++)
    n = r ? e[i].call(t, n) : e[i].call(t);
  return r ? n : void 0;
}
function TO(t) {
  return typeof t == "symbol" ? t : "".concat(t);
}
function vO(t, e, n) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(t, "name", { configurable: !0, value: n ? "".concat(n, " ", e) : e });
}
function xO(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(t, e);
}
function CO(t, e, n, r) {
  function i(s) {
    return s instanceof n ? s : new n(function(a) {
      a(s);
    });
  }
  return new (n || (n = Promise))(function(s, a) {
    function o(h) {
      try {
        l(r.next(h));
      } catch (f) {
        a(f);
      }
    }
    function u(h) {
      try {
        l(r.throw(h));
      } catch (f) {
        a(f);
      }
    }
    function l(h) {
      h.done ? s(h.value) : i(h.value).then(o, u);
    }
    l((r = r.apply(t, e || [])).next());
  });
}
function kO(t, e) {
  var n = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, r, i, s, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = o(0), a.throw = o(1), a.return = o(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function o(l) {
    return function(h) {
      return u([l, h]);
    };
  }
  function u(l) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, l[0] && (n = 0)), n; ) try {
      if (r = 1, i && (s = l[0] & 2 ? i.return : l[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, l[1])).done) return s;
      switch (i = 0, s && (l = [l[0] & 2, s.value]), l[0]) {
        case 0:
        case 1:
          s = l;
          break;
        case 4:
          return n.label++, { value: l[1], done: !1 };
        case 5:
          n.label++, i = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (s = n.trys, !(s = s.length > 0 && s[s.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < s[1]) {
            n.label = s[1], s = l;
            break;
          }
          if (s && n.label < s[2]) {
            n.label = s[2], n.ops.push(l);
            break;
          }
          s[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = e.call(t, n);
    } catch (h) {
      l = [6, h], i = 0;
    } finally {
      r = s = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
var iA = Object.create ? (function(t, e, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(e, n);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, i);
}) : (function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
});
function _O(t, e) {
  for (var n in t) n !== "default" && !Object.prototype.hasOwnProperty.call(e, n) && iA(e, t, n);
}
function Xy(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Vx(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), i, s = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; ) s.push(i.value);
  } catch (o) {
    a = { error: o };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return s;
}
function NO() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(Vx(arguments[e]));
  return t;
}
function DO() {
  for (var t = 0, e = 0, n = arguments.length; e < n; e++) t += arguments[e].length;
  for (var r = Array(t), i = 0, e = 0; e < n; e++)
    for (var s = arguments[e], a = 0, o = s.length; a < o; a++, i++)
      r[i] = s[a];
  return r;
}
function IO(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, i = e.length, s; r < i; r++)
    (s || !(r in e)) && (s || (s = Array.prototype.slice.call(e, 0, r)), s[r] = e[r]);
  return t.concat(s || Array.prototype.slice.call(e));
}
function of(t) {
  return this instanceof of ? (this.v = t, this) : new of(t);
}
function RO(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), i, s = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), o("next"), o("throw"), o("return", a), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function a(g) {
    return function(A) {
      return Promise.resolve(A).then(g, f);
    };
  }
  function o(g, A) {
    r[g] && (i[g] = function(E) {
      return new Promise(function(w, x) {
        s.push([g, E, w, x]) > 1 || u(g, E);
      });
    }, A && (i[g] = A(i[g])));
  }
  function u(g, A) {
    try {
      l(r[g](A));
    } catch (E) {
      m(s[0][3], E);
    }
  }
  function l(g) {
    g.value instanceof of ? Promise.resolve(g.value.v).then(h, f) : m(s[0][2], g);
  }
  function h(g) {
    u("next", g);
  }
  function f(g) {
    u("throw", g);
  }
  function m(g, A) {
    g(A), s.shift(), s.length && u(s[0][0], s[0][1]);
  }
}
function PO(t) {
  var e, n;
  return e = {}, r("next"), r("throw", function(i) {
    throw i;
  }), r("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function r(i, s) {
    e[i] = t[i] ? function(a) {
      return (n = !n) ? { value: of(t[i](a)), done: !1 } : s ? s(a) : a;
    } : s;
  }
}
function LO(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof Xy == "function" ? Xy(t) : t[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(s) {
    n[s] = t[s] && function(a) {
      return new Promise(function(o, u) {
        a = t[s](a), i(o, u, a.done, a.value);
      });
    };
  }
  function i(s, a, o, u) {
    Promise.resolve(u).then(function(l) {
      s({ value: l, done: o });
    }, a);
  }
}
function MO(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
var iee = Object.create ? (function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
}) : function(t, e) {
  t.default = e;
}, pT = function(t) {
  return pT = Object.getOwnPropertyNames || function(e) {
    var n = [];
    for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (n[n.length] = r);
    return n;
  }, pT(t);
};
function OO(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var n = pT(t), r = 0; r < n.length; r++) n[r] !== "default" && iA(e, t, n[r]);
  return iee(e, t), e;
}
function BO(t) {
  return t && t.__esModule ? t : { default: t };
}
function $O(t, e, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !r : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(t) : r ? r.value : e.get(t);
}
function HO(t, e, n, r, i) {
  if (r === "m") throw new TypeError("Private method is not writable");
  if (r === "a" && !i) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(t, n) : i ? i.value = n : e.set(t, n), n;
}
function UO(t, e) {
  if (e === null || typeof e != "object" && typeof e != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof t == "function" ? e === t : t.has(e);
}
function GO(t, e, n) {
  if (e != null) {
    if (typeof e != "object" && typeof e != "function") throw new TypeError("Object expected.");
    var r, i;
    if (n) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      r = e[Symbol.asyncDispose];
    }
    if (r === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      r = e[Symbol.dispose], n && (i = r);
    }
    if (typeof r != "function") throw new TypeError("Object not disposable.");
    i && (r = function() {
      try {
        i.call(this);
      } catch (s) {
        return Promise.reject(s);
      }
    }), t.stack.push({ value: e, dispose: r, async: n });
  } else n && t.stack.push({ async: !0 });
  return e;
}
var see = typeof SuppressedError == "function" ? SuppressedError : function(t, e, n) {
  var r = new Error(n);
  return r.name = "SuppressedError", r.error = t, r.suppressed = e, r;
};
function WO(t) {
  function e(s) {
    t.error = t.hasError ? new see(s, t.error, "An error was suppressed during disposal.") : s, t.hasError = !0;
  }
  var n, r = 0;
  function i() {
    for (; n = t.stack.pop(); )
      try {
        if (!n.async && r === 1) return r = 0, t.stack.push(n), Promise.resolve().then(i);
        if (n.dispose) {
          var s = n.dispose.call(n.value);
          if (n.async) return r |= 2, Promise.resolve(s).then(i, function(a) {
            return e(a), i();
          });
        } else r |= 1;
      } catch (a) {
        e(a);
      }
    if (r === 1) return t.hasError ? Promise.reject(t.error) : Promise.resolve();
    if (t.hasError) throw t.error;
  }
  return i();
}
function VO(t, e) {
  return typeof t == "string" && /^\.\.?\//.test(t) ? t.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(n, r, i, s, a) {
    return r ? e ? ".jsx" : ".js" : i && (!s || !a) ? n : i + s + "." + a.toLowerCase() + "js";
  }) : t;
}
const aee = {
  __extends: yO,
  __assign: Qy,
  __rest: AO,
  __decorate: EO,
  __param: SO,
  __esDecorate: wO,
  __runInitializers: FO,
  __propKey: TO,
  __setFunctionName: vO,
  __metadata: xO,
  __awaiter: CO,
  __generator: kO,
  __createBinding: iA,
  __exportStar: _O,
  __values: Xy,
  __read: Vx,
  __spread: NO,
  __spreadArrays: DO,
  __spreadArray: IO,
  __await: of,
  __asyncGenerator: RO,
  __asyncDelegator: PO,
  __asyncValues: LO,
  __makeTemplateObject: MO,
  __importStar: OO,
  __importDefault: BO,
  __classPrivateFieldGet: $O,
  __classPrivateFieldSet: HO,
  __classPrivateFieldIn: UO,
  __addDisposableResource: GO,
  __disposeResources: WO,
  __rewriteRelativeImportExtension: VO
}, oee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: GO,
  get __assign() {
    return Qy;
  },
  __asyncDelegator: PO,
  __asyncGenerator: RO,
  __asyncValues: LO,
  __await: of,
  __awaiter: CO,
  __classPrivateFieldGet: $O,
  __classPrivateFieldIn: UO,
  __classPrivateFieldSet: HO,
  __createBinding: iA,
  __decorate: EO,
  __disposeResources: WO,
  __esDecorate: wO,
  __exportStar: _O,
  __extends: yO,
  __generator: kO,
  __importDefault: BO,
  __importStar: OO,
  __makeTemplateObject: MO,
  __metadata: xO,
  __param: SO,
  __propKey: TO,
  __read: Vx,
  __rest: AO,
  __rewriteRelativeImportExtension: VO,
  __runInitializers: FO,
  __setFunctionName: vO,
  __spread: NO,
  __spreadArray: IO,
  __spreadArrays: DO,
  __values: Xy,
  default: aee
}, Symbol.toStringTag, { value: "Module" })), uee = /* @__PURE__ */ vt(oee);
var bS = {};
const lee = /* @__PURE__ */ vt(xX);
var nm = {};
const cee = "v1", hee = 2, dee = 1920, fee = 1920, mee = 1e3, gee = 1e3, Oe = {
  SCALE_TO_FILL: "fill",
  SCALE_TO_FIT: "fit",
  STRETCH: "stretch",
  ORIGINAL_SIZE: "original_size",
  TILE: "tile",
  TILE_HORIZONTAL: "tile_horizontal",
  TILE_VERTICAL: "tile_vertical",
  FIT_AND_TILE: "fit_and_tile",
  LEGACY_STRIP_TILE: "legacy_strip_tile",
  LEGACY_STRIP_TILE_HORIZONTAL: "legacy_strip_tile_horizontal",
  LEGACY_STRIP_TILE_VERTICAL: "legacy_strip_tile_vertical",
  LEGACY_STRIP_SCALE_TO_FILL: "legacy_strip_fill",
  LEGACY_STRIP_SCALE_TO_FIT: "legacy_strip_fit",
  LEGACY_STRIP_FIT_AND_TILE: "legacy_strip_fit_and_tile",
  LEGACY_STRIP_ORIGINAL_SIZE: "legacy_strip_original_size",
  LEGACY_ORIGINAL_SIZE: "actual_size",
  LEGACY_FIT_WIDTH: "fitWidth",
  LEGACY_FIT_HEIGHT: "fitHeight",
  LEGACY_FULL: "full",
  LEGACY_BG_FIT_AND_TILE: "legacy_tile",
  LEGACY_BG_FIT_AND_TILE_HORIZONTAL: "legacy_tile_horizontal",
  LEGACY_BG_FIT_AND_TILE_VERTICAL: "legacy_tile_vertical",
  LEGACY_BG_NORMAL: "legacy_normal"
}, vr = {
  FIT: "fit",
  FILL: "fill",
  FILL_FOCAL: "fill_focal",
  CROP: "crop",
  LEGACY_CROP: "legacy_crop",
  LEGACY_FILL: "legacy_fill"
}, et = {
  CENTER: "center",
  TOP: "top",
  TOP_LEFT: "top_left",
  TOP_RIGHT: "top_right",
  BOTTOM: "bottom",
  BOTTOM_LEFT: "bottom_left",
  BOTTOM_RIGHT: "bottom_right",
  LEFT: "left",
  RIGHT: "right"
}, pee = {
  [et.CENTER]: { x: 0.5, y: 0.5 },
  [et.TOP_LEFT]: { x: 0, y: 0 },
  [et.TOP_RIGHT]: { x: 1, y: 0 },
  [et.TOP]: { x: 0.5, y: 0 },
  [et.BOTTOM_LEFT]: { x: 0, y: 1 },
  [et.BOTTOM_RIGHT]: { x: 1, y: 1 },
  [et.BOTTOM]: { x: 0.5, y: 1 },
  [et.RIGHT]: { x: 1, y: 0.5 },
  [et.LEFT]: { x: 0, y: 0.5 }
}, bT = {
  center: "c",
  top: "t",
  top_left: "tl",
  top_right: "tr",
  bottom: "b",
  bottom_left: "bl",
  bottom_right: "br",
  left: "l",
  right: "r"
}, uf = {
  BG: "bg",
  IMG: "img",
  SVG: "svg"
}, wy = {
  AUTO: "auto",
  CLASSIC: "classic",
  SUPER: "super"
}, Kx = {
  classic: 1,
  super: 2
}, bee = {
  radius: "0.66",
  amount: "1.00",
  threshold: "0.01"
}, KO = {
  uri: "",
  css: {
    img: {},
    container: {}
  },
  attr: {
    img: {},
    container: {}
  },
  transformed: !1
}, yee = 5e3, Aee = 5e3, G3 = yee * Aee, yS = [1.5, 2, 4], Ud = {
  HIGH: {
    size: 1400 * 1400,
    quality: 90,
    maxUpscale: 1
  },
  MEDIUM: {
    size: 600 * 600,
    quality: 85,
    maxUpscale: 1
  },
  LOW: {
    size: 400 * 400,
    quality: 80,
    maxUpscale: 1.2
  },
  TINY: {
    size: 0,
    quality: 80,
    maxUpscale: 1.4
  }
}, Hc = {
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
  TINY: "TINY"
}, ni = {
  CONTRAST: "contrast",
  BRIGHTNESS: "brightness",
  SATURATION: "saturation",
  HUE: "hue",
  BLUR: "blur"
}, Sn = {
  JPG: "jpg",
  JPEG: "jpeg",
  JPE: "jpe",
  PNG: "png",
  WEBP: "webp",
  WIX_ICO_MP: "wix_ico_mp",
  WIX_MP: "wix_mp",
  GIF: "gif",
  SVG: "svg",
  AVIF: "avif",
  UNRECOGNIZED: "unrecognized"
}, W3 = {
  AVIF: "AVIF",
  PAVIF: "PAVIF"
};
Sn.JPG, Sn.JPEG, Sn.JPE, Sn.PNG, Sn.GIF, Sn.WEBP;
function Wr(t, ...e) {
  return function(...n) {
    const r = n[n.length - 1] || {}, i = [t[0]];
    return e.forEach(function(s, a) {
      const o = Number.isInteger(s) ? n[s] : r[s];
      i.push(o, t[a + 1]);
    }), i.join("");
  };
}
function Zy(t) {
  return t[t.length - 1];
}
const zO = [
  Sn.PNG,
  Sn.JPEG,
  Sn.JPG,
  Sn.JPE,
  Sn.WIX_ICO_MP,
  Sn.WIX_MP,
  Sn.WEBP,
  Sn.AVIF
], Eee = [
  Sn.JPEG,
  Sn.JPG,
  Sn.JPE
];
function See(t) {
  return zO.includes(Xu(t));
}
function zx(t, e, n) {
  return n && e && !xee(e.id) && Object.values(Oe).includes(t);
}
function wee(t, e, n) {
  return !(Jg(t) || aA(t)) || !e ? !0 : n;
}
function Fee(t, e, n) {
  return jx(t) ? !!(e || n) : !1;
}
function sA(t, e, n, r) {
  if (vee(t) || !wee(t, e, n))
    return !1;
  const i = See(t), s = Fee(t, n, r);
  return i || s;
}
function Tee(t) {
  return Eee.includes(Xu(t));
}
function jO(t) {
  return Xu(t) === Sn.PNG;
}
function Jg(t) {
  return Xu(t) === Sn.WEBP;
}
function jx(t) {
  return Xu(t) === Sn.GIF;
}
function aA(t) {
  return Xu(t) === Sn.AVIF;
}
function vee(t) {
  return /(^https?)|(^data)|(^\/\/)/.test(t);
}
function xee(t) {
  return !t || !t.trim() || t.toLowerCase() === "none";
}
function Cee(t) {
  return t?.isSEOBot ?? !1;
}
const kee = ["/", "\\", "?", "<", ">", "|", "“", ":", '"'].map(encodeURIComponent), _ee = ["\\.", "\\*"], Nee = "_";
function Dee(t, e) {
  const n = /\/(.*?)$/, r = /\.([^.]*)$/, i = new RegExp(`(${kee.concat(_ee).join("|")})`, "g");
  if (e && e.length) {
    let o = e;
    const u = e.match(r);
    return u && zO.includes(u[1]) && (o = e.replace(r, "")), encodeURIComponent(o).replace(i, Nee);
  }
  const s = t.match(n);
  return (s ? s[1] : t).replace(r, "");
}
function Iee(t) {
  return Tee(t) ? Sn.JPG : jO(t) ? Sn.PNG : Jg(t) ? Sn.WEBP : jx(t) ? Sn.GIF : aA(t) ? Sn.AVIF : Sn.UNRECOGNIZED;
}
function Xu(t) {
  return (/[.]([^.]+)$/.exec(t) && /[.]([^.]+)$/.exec(t)[1] || "").toLowerCase();
}
function Ree(t, e, n, r) {
  return Math.min(n / t, r / e);
}
function Pee(t, e, n, r) {
  return Math.max(n / t, r / e);
}
function e1(t, e, n, r, i) {
  let s;
  return i === vr.FILL ? s = Pee(t, e, n, r) : i === vr.FIT ? s = Ree(t, e, n, r) : s = 1, s;
}
function Lee(t, e, n, r, i) {
  let s, a = n, o = r;
  if (s = e1(t, e, n, r, i), i === vr.FIT && (a = t * s, o = e * s), a && o && a * o > G3) {
    const u = Math.sqrt(G3 / (a * o));
    a *= u, o *= u, s = e1(t, e, a, o, i);
  }
  return {
    scaleFactor: s,
    width: a,
    height: o
  };
}
function YO(t, e, n, r, i, s) {
  t = t || r.width, e = e || r.height;
  const { scaleFactor: a, width: o, height: u } = Lee(t, e, r.width * i, r.height * i, n);
  return Kee(t, e, o, u, s, a, n);
}
function Mee(t = et.CENTER) {
  return pee[t];
}
function Oee(t, e, n, r) {
  const i = qO(n) || Mee(r), s = Math.max(0, Math.min(t.width - e.width, i.x * t.width - e.width / 2)), a = Math.max(0, Math.min(t.height - e.height, i.y * t.height - e.height / 2));
  return {
    x: s,
    y: a,
    width: Math.min(t.width, e.width),
    height: Math.min(t.height, e.height)
  };
}
function Bee(t, e) {
  const n = Math.max(0, Math.min(t.width, e.x + e.width) - Math.max(0, e.x)), r = Math.max(0, Math.min(t.height, e.y + e.height) - Math.max(0, e.y));
  return n && r && (t.width !== n || t.height !== r) ? {
    x: Math.max(0, e.x),
    y: Math.max(0, e.y),
    width: n,
    height: r
  } : null;
}
function $ee(t) {
  return Math.min(t.pixelAspectRatio || 1, hee);
}
function Yx(t) {
  return t.alignment && bT[t.alignment] || bT[et.CENTER];
}
function qO(t) {
  let e;
  return t && typeof t.x == "number" && !isNaN(t.x) && typeof t.y == "number" && !isNaN(t.y) && (e = {
    x: Ym(Math.max(0, Math.min(100, t.x)) / 100, 2),
    y: Ym(Math.max(0, Math.min(100, t.y)) / 100, 2)
  }), e;
}
function Hee(t, e) {
  return Ud[qx(t, e)].quality;
}
function Uee(t, e) {
  const n = qx(t, e);
  return {
    optimizedScaleFactor: Ud[n].maxUpscale,
    upscaleMethodValue: Kx.classic,
    forceUSM: !1
  };
}
function Gee(t, e) {
  const n = qx(t, e);
  return {
    optimizedScaleFactor: Ud[n].maxUpscale,
    upscaleMethodValue: Kx.classic,
    forceUSM: !1
  };
}
function Wee(t) {
  return {
    optimizedScaleFactor: Zy(yS),
    upscaleMethodValue: Kx.super,
    forceUSM: !(yS.includes(t) || t > Zy(yS))
  };
}
function Vee(t, e, n, r) {
  return r === "auto" ? Gee(t, e) : r === "super" ? Wee(n) : Uee(t, e);
}
function Kee(t, e, n, r, i, s, a) {
  const { optimizedScaleFactor: o, upscaleMethodValue: u, forceUSM: l } = Vee(t, e, s, i);
  let h = n, f = r;
  if (s <= o)
    return {
      width: h,
      height: f,
      scaleFactor: s,
      upscaleMethodValue: u,
      forceUSM: l,
      cssUpscaleNeeded: !1
    };
  switch (a) {
    case vr.FILL:
      h = n * (o / s), f = r * (o / s);
      break;
    case vr.FIT:
      h = t * o, f = e * o;
      break;
  }
  return {
    width: h,
    height: f,
    scaleFactor: o,
    upscaleMethodValue: u,
    forceUSM: l,
    cssUpscaleNeeded: !0
  };
}
function qx(t, e) {
  const n = t * e;
  return n > Ud[Hc.HIGH].size ? Hc.HIGH : n > Ud[Hc.MEDIUM].size ? Hc.MEDIUM : n > Ud[Hc.LOW].size ? Hc.LOW : Hc.TINY;
}
function zee(t, e, n, r, i) {
  const s = e1(t, e, n, r, i);
  return {
    width: Math.round(t * s),
    height: Math.round(e * s)
  };
}
function Ym(t, e) {
  const n = Math.pow(10, e);
  return (t * n / n).toFixed(e);
}
function jee(t) {
  return !t || !t.upscaleMethod ? wy.AUTO : wy[t.upscaleMethod.toUpperCase()] || wy.AUTO;
}
function Yee(t, e) {
  const n = Jg(t) || aA(t);
  return Xu(t) === Sn.GIF || n && e;
}
const JO = {
  /**
   * @type {object<boolean>}
   */
  isMobile: !1
}, qee = function(t) {
  return JO[t];
}, Jee = function(t, e) {
  JO[t] = e;
};
function Jx() {
  if (typeof window < "u" && typeof navigator < "u") {
    const t = window.matchMedia && window.matchMedia("(max-width: 767px)").matches, e = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    Jee("isMobile", t && e);
  }
}
function Qee(t, e) {
  const n = {
    css: {
      container: {}
    }
  }, { css: r } = n, { fittingType: i } = t;
  switch (i) {
    case Oe.ORIGINAL_SIZE:
    case Oe.LEGACY_ORIGINAL_SIZE:
    case Oe.LEGACY_STRIP_ORIGINAL_SIZE:
      r.container.backgroundSize = "auto", r.container.backgroundRepeat = "no-repeat";
      break;
    case Oe.SCALE_TO_FIT:
    case Oe.LEGACY_STRIP_SCALE_TO_FIT:
      r.container.backgroundSize = "contain", r.container.backgroundRepeat = "no-repeat";
      break;
    case Oe.STRETCH:
      r.container.backgroundSize = "100% 100%", r.container.backgroundRepeat = "no-repeat";
      break;
    case Oe.SCALE_TO_FILL:
    case Oe.LEGACY_STRIP_SCALE_TO_FILL:
      r.container.backgroundSize = "cover", r.container.backgroundRepeat = "no-repeat";
      break;
    case Oe.TILE_HORIZONTAL:
    case Oe.LEGACY_STRIP_TILE_HORIZONTAL:
      r.container.backgroundSize = "auto", r.container.backgroundRepeat = "repeat-x";
      break;
    case Oe.TILE_VERTICAL:
    case Oe.LEGACY_STRIP_TILE_VERTICAL:
      r.container.backgroundSize = "auto", r.container.backgroundRepeat = "repeat-y";
      break;
    case Oe.TILE:
    case Oe.LEGACY_STRIP_TILE:
      r.container.backgroundSize = "auto", r.container.backgroundRepeat = "repeat";
      break;
    case Oe.LEGACY_STRIP_FIT_AND_TILE:
      r.container.backgroundSize = "contain", r.container.backgroundRepeat = "repeat";
      break;
    case Oe.FIT_AND_TILE:
      r.container.backgroundSize = "auto", r.container.backgroundRepeat = "repeat";
      break;
    // Legacy old editor bg types.
    case Oe.LEGACY_BG_FIT_AND_TILE:
      r.container.backgroundSize = "auto", r.container.backgroundRepeat = "repeat";
      break;
    case Oe.LEGACY_BG_FIT_AND_TILE_HORIZONTAL:
      r.container.backgroundSize = "auto", r.container.backgroundRepeat = "repeat-x";
      break;
    case Oe.LEGACY_BG_FIT_AND_TILE_VERTICAL:
      r.container.backgroundSize = "auto", r.container.backgroundRepeat = "repeat-y";
      break;
    case Oe.LEGACY_BG_NORMAL:
      r.container.backgroundSize = "auto", r.container.backgroundRepeat = "no-repeat";
      break;
  }
  switch (e.alignment) {
    case et.CENTER:
      r.container.backgroundPosition = "center center";
      break;
    case et.LEFT:
      r.container.backgroundPosition = "left center";
      break;
    case et.RIGHT:
      r.container.backgroundPosition = "right center";
      break;
    case et.TOP:
      r.container.backgroundPosition = "center top";
      break;
    case et.BOTTOM:
      r.container.backgroundPosition = "center bottom";
      break;
    case et.TOP_RIGHT:
      r.container.backgroundPosition = "right top";
      break;
    case et.TOP_LEFT:
      r.container.backgroundPosition = "left top";
      break;
    case et.BOTTOM_RIGHT:
      r.container.backgroundPosition = "right bottom";
      break;
    case et.BOTTOM_LEFT:
      r.container.backgroundPosition = "left bottom";
      break;
  }
  return n;
}
function Xee(t, e, n) {
  return {
    [et.TOP_LEFT]: { top: 0, left: 0 },
    [et.TOP_RIGHT]: { top: 0, right: 0 },
    [et.TOP]: { top: 0, left: e },
    [et.BOTTOM_LEFT]: { bottom: 0, left: 0 },
    [et.BOTTOM_RIGHT]: { bottom: 0, right: 0 },
    [et.BOTTOM]: { bottom: 0, left: e },
    [et.RIGHT]: { top: t, right: 0 },
    [et.LEFT]: { top: t, left: 0 },
    [et.CENTER]: {
      width: n.width,
      height: n.height,
      objectFit: "none"
    }
  };
}
const V3 = {
  [et.CENTER]: "center",
  [et.TOP]: "top",
  [et.TOP_LEFT]: "top left",
  [et.TOP_RIGHT]: "top right",
  [et.BOTTOM]: "bottom",
  [et.BOTTOM_LEFT]: "bottom left",
  [et.BOTTOM_RIGHT]: "bottom right",
  [et.LEFT]: "left",
  [et.RIGHT]: "right"
}, Zee = {
  position: "absolute",
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ete(t, e) {
  const n = {
    css: {
      container: {},
      img: {}
    }
  }, { css: r } = n, { fittingType: i } = t, s = e.alignment;
  switch (r.container.position = "relative", i) {
    case Oe.ORIGINAL_SIZE:
    case Oe.LEGACY_ORIGINAL_SIZE:
      t.parts && t.parts.length ? (r.img.width = t.parts[0].width, r.img.height = t.parts[0].height) : (r.img.width = t.src.width, r.img.height = t.src.height);
      break;
    case Oe.SCALE_TO_FIT:
    case Oe.LEGACY_FIT_WIDTH:
    case Oe.LEGACY_FIT_HEIGHT:
    case Oe.LEGACY_FULL:
      r.img.width = e.width, r.img.height = e.height, r.img.objectFit = "contain", r.img.objectPosition = V3[s] || "unset";
      break;
    // BG_NORMAL is a sitebackground legacy for original size fitting type.
    // target width and height were modified in transform.js
    case Oe.LEGACY_BG_NORMAL:
      r.img.width = "100%", r.img.height = "100%", r.img.objectFit = "none", r.img.objectPosition = V3[s] || "unset";
      break;
    case Oe.STRETCH:
      r.img.width = e.width, r.img.height = e.height, r.img.objectFit = "fill";
      break;
    case Oe.SCALE_TO_FILL:
      r.img.width = e.width, r.img.height = e.height, r.img.objectFit = "cover";
      break;
  }
  if (typeof r.img.width == "number" && typeof r.img.height == "number" && (r.img.width !== e.width || r.img.height !== e.height)) {
    const a = Math.round((e.height - r.img.height) / 2), o = Math.round((e.width - r.img.width) / 2);
    Object.assign(r.img, Zee, Xee(a, o, e)[s]);
  }
  return n;
}
function tte(t, e) {
  const n = {
    css: {
      container: {}
    },
    attr: {
      container: {},
      img: {}
    }
  }, { css: r, attr: i } = n, { fittingType: s } = t, a = e.alignment, { width: o, height: u } = t.src;
  let l;
  switch (r.container.position = "relative", s) {
    case Oe.ORIGINAL_SIZE:
    case Oe.LEGACY_ORIGINAL_SIZE:
    case Oe.TILE:
      t.parts && t.parts.length ? (i.img.width = t.parts[0].width, i.img.height = t.parts[0].height) : (i.img.width = o, i.img.height = u), i.img.preserveAspectRatio = "xMidYMid slice";
      break;
    case Oe.SCALE_TO_FIT:
    case Oe.LEGACY_FIT_WIDTH:
    case Oe.LEGACY_FIT_HEIGHT:
    case Oe.LEGACY_FULL:
      i.img.width = "100%", i.img.height = "100%", i.img.transform = "", i.img.preserveAspectRatio = "";
      break;
    case Oe.STRETCH:
      i.img.width = e.width, i.img.height = e.height, i.img.x = 0, i.img.y = 0, i.img.transform = "", i.img.preserveAspectRatio = "none";
      break;
    case Oe.SCALE_TO_FILL:
      sA(t.src.id) ? (i.img.width = e.width, i.img.height = e.height) : (l = zee(o, u, e.width, e.height, vr.FILL), i.img.width = l.width, i.img.height = l.height), i.img.x = 0, i.img.y = 0, i.img.transform = "", i.img.preserveAspectRatio = "xMidYMid slice";
      break;
  }
  if (typeof i.img.width == "number" && typeof i.img.height == "number" && (i.img.width !== e.width || i.img.height !== e.height)) {
    let h = 0, f = 0, m, g;
    s === Oe.TILE ? (m = e.width % i.img.width, g = e.height % i.img.height) : (m = e.width - i.img.width, g = e.height - i.img.height);
    const A = Math.round(m / 2), E = Math.round(g / 2);
    switch (a) {
      case et.TOP_LEFT:
        h = 0, f = 0;
        break;
      case et.TOP:
        h = A, f = 0;
        break;
      case et.TOP_RIGHT:
        h = m, f = 0;
        break;
      case et.LEFT:
        h = 0, f = E;
        break;
      case et.CENTER:
        h = A, f = E;
        break;
      case et.RIGHT:
        h = m, f = E;
        break;
      case et.BOTTOM_LEFT:
        h = 0, f = g;
        break;
      case et.BOTTOM:
        h = A, f = g;
        break;
      case et.BOTTOM_RIGHT:
        h = m, f = g;
        break;
    }
    i.img.x = h, i.img.y = f;
  }
  return i.container.width = e.width, i.container.height = e.height, i.container.viewBox = [0, 0, e.width, e.height].join(" "), n;
}
function nte(t, e) {
  let n;
  return e.htmlTag === uf.BG ? n = Qee : e.htmlTag === uf.SVG ? n = tte : n = ete, n(t, e);
}
function rte() {
  return qee("isMobile");
}
function ite(t, e, n) {
  let r;
  switch (e.crop && (r = Bee(e, e.crop), r && (t.src.width = r.width, t.src.height = r.height, t.src.isCropped = !0, t.parts.push(K3(r)))), t.fittingType) {
    case Oe.SCALE_TO_FIT:
    case Oe.LEGACY_FIT_WIDTH:
    case Oe.LEGACY_FIT_HEIGHT:
    case Oe.LEGACY_FULL:
    case Oe.FIT_AND_TILE:
    case Oe.LEGACY_BG_FIT_AND_TILE:
    case Oe.LEGACY_BG_FIT_AND_TILE_HORIZONTAL:
    case Oe.LEGACY_BG_FIT_AND_TILE_VERTICAL:
    case Oe.LEGACY_BG_NORMAL:
      t.parts.push(QO(t, n));
      break;
    case Oe.SCALE_TO_FILL:
      t.parts.push(ste(t, n));
      break;
    case Oe.STRETCH:
      t.parts.push(ate(t, n));
      break;
    case Oe.TILE_HORIZONTAL:
    case Oe.TILE_VERTICAL:
    case Oe.TILE:
    case Oe.LEGACY_ORIGINAL_SIZE:
    case Oe.ORIGINAL_SIZE:
      r = Oee(t.src, n, t.focalPoint, n.alignment), t.src.isCropped ? (Object.assign(t.parts[0], r), t.src.width = r.width, t.src.height = r.height) : t.parts.push(K3(r));
      break;
    // ---------------------------------------------------------------------------------------
    // handles a legacy bug on bgImageStrip, background html tag
    // component Full Width Strip stored incorrect image source width and height
    // ---------------------------------------------------------------------------------------
    case Oe.LEGACY_STRIP_TILE_HORIZONTAL:
    case Oe.LEGACY_STRIP_TILE_VERTICAL:
    case Oe.LEGACY_STRIP_TILE:
    case Oe.LEGACY_STRIP_ORIGINAL_SIZE:
      t.parts.push(lte(n));
      break;
    case Oe.LEGACY_STRIP_SCALE_TO_FIT:
    case Oe.LEGACY_STRIP_FIT_AND_TILE:
      t.parts.push(ote(n));
      break;
    case Oe.LEGACY_STRIP_SCALE_TO_FILL:
      t.parts.push(ute(n));
      break;
  }
}
function QO(t, e) {
  const n = YO(t.src.width, t.src.height, vr.FIT, e, t.devicePixelRatio, t.upscaleMethod);
  return {
    transformType: !t.src.width || !t.src.height ? vr.FIT : vr.FILL,
    width: Math.round(n.width),
    height: Math.round(n.height),
    alignment: bT.center,
    upscale: n.scaleFactor > 1,
    forceUSM: n.forceUSM,
    scaleFactor: n.scaleFactor,
    cssUpscaleNeeded: n.cssUpscaleNeeded,
    upscaleMethodValue: n.upscaleMethodValue
  };
}
function ste(t, e) {
  const n = YO(t.src.width, t.src.height, vr.FILL, e, t.devicePixelRatio, t.upscaleMethod), r = qO(t.focalPoint);
  return {
    transformType: r ? vr.FILL_FOCAL : vr.FILL,
    width: Math.round(n.width),
    height: Math.round(n.height),
    alignment: Yx(e),
    focalPointX: r && r.x,
    focalPointY: r && r.y,
    upscale: n.scaleFactor > 1,
    forceUSM: n.forceUSM,
    scaleFactor: n.scaleFactor,
    cssUpscaleNeeded: n.cssUpscaleNeeded,
    upscaleMethodValue: n.upscaleMethodValue
  };
}
function ate(t, e) {
  const n = e1(t.src.width, t.src.height, e.width, e.height, vr.FILL), r = { ...e };
  return r.width = t.src.width * n, r.height = t.src.height * n, QO(t, r);
}
function K3(t) {
  return {
    transformType: vr.CROP,
    x: Math.round(t.x),
    y: Math.round(t.y),
    width: Math.round(t.width),
    height: Math.round(t.height),
    upscale: !1,
    forceUSM: !1,
    scaleFactor: 1,
    cssUpscaleNeeded: !1
  };
}
function ote(t) {
  return {
    transformType: vr.FIT,
    width: Math.round(t.width),
    height: Math.round(t.height),
    upscale: !1,
    forceUSM: !0,
    scaleFactor: 1,
    cssUpscaleNeeded: !1
  };
}
function ute(t) {
  return {
    transformType: vr.LEGACY_FILL,
    width: Math.round(t.width),
    height: Math.round(t.height),
    alignment: Yx(t),
    upscale: !1,
    forceUSM: !0,
    scaleFactor: 1,
    cssUpscaleNeeded: !1
  };
}
function lte(t) {
  return {
    transformType: vr.LEGACY_CROP,
    width: Math.round(t.width),
    height: Math.round(t.height),
    alignment: Yx(t),
    upscale: !1,
    forceUSM: !1,
    scaleFactor: 1,
    cssUpscaleNeeded: !1
  };
}
function cte(t, e) {
  e = e || {}, t.quality = fte(t, e), t.progressive = dte(e), t.watermark = hte(e), t.autoEncode = e.autoEncode ?? !0, t.encoding = e?.encoding, t.unsharpMask = gte(t, e), t.filters = mte(e);
}
function hte(t) {
  return t.watermark;
}
function dte(t) {
  return t.progressive !== !1;
}
function fte(t, e) {
  const n = t.fileType === Sn.PNG, r = t.fileType === Sn.JPG, i = t.fileType === Sn.WEBP, s = t.fileType === Sn.AVIF;
  if (r || n || i || s) {
    const o = Zy(t.parts), u = Hee(o.width, o.height);
    let l = e.quality && e.quality >= 5 && e.quality <= 90 ? e.quality : u;
    return l = n ? l + 5 : l, l;
  }
  return 0;
}
function mte(t) {
  const e = t.filters || {}, n = {};
  return rm(e[ni.CONTRAST], -100, 100) && (n[ni.CONTRAST] = e[ni.CONTRAST]), rm(e[ni.BRIGHTNESS], -100, 100) && (n[ni.BRIGHTNESS] = e[ni.BRIGHTNESS]), rm(e[ni.SATURATION], -100, 100) && (n[ni.SATURATION] = e[ni.SATURATION]), rm(e[ni.HUE], -180, 180) && (n[ni.HUE] = e[ni.HUE]), rm(e[ni.BLUR], 0, 100) && (n[ni.BLUR] = e[ni.BLUR]), n;
}
function rm(t, e, n) {
  return typeof t == "number" && !isNaN(t) && t !== 0 && t >= e && t <= n;
}
function gte(t, e) {
  if (bte(e.unsharpMask))
    return {
      radius: Ym(e.unsharpMask?.radius, 2),
      amount: Ym(e.unsharpMask?.amount, 2),
      threshold: Ym(e.unsharpMask?.threshold, 2)
    };
  if (!yte(e.unsharpMask) && pte(t))
    return bee;
}
function pte(t) {
  const e = Zy(t.parts);
  return !(e.scaleFactor >= 1) || e.forceUSM || e.transformType === vr.FIT;
}
function bte(t) {
  t = t || {};
  const e = typeof t.radius == "number" && !isNaN(t.radius) && t.radius >= 0.1 && t.radius <= 500, n = typeof t.amount == "number" && !isNaN(t.amount) && t.amount >= 0 && t.amount <= 10, r = typeof t.threshold == "number" && !isNaN(t.threshold) && t.threshold >= 0 && t.threshold <= 255;
  return e && n && r;
}
function yte(t) {
  return t = t || {}, typeof t.radius == "number" && !isNaN(t.radius) && t.radius === 0 && typeof t.amount == "number" && !isNaN(t.amount) && t.amount === 0 && typeof t.threshold == "number" && !isNaN(t.threshold) && t.threshold === 0;
}
function t1(t, e, n, r) {
  const i = Cee(r), s = Iee(e.id), a = Dee(e.id, e.name), o = i ? 1 : $ee(n), u = Xu(e.id), l = u, h = sA(e.id, r?.hasAnimation, r?.allowAnimatedTransform, r?.allowFullGIFTransformation), f = {
    fileName: a,
    fileExtension: u,
    fileType: s,
    fittingType: t,
    preferredExtension: l,
    src: {
      id: e.id,
      width: e.width,
      height: e.height,
      isCropped: !1,
      isAnimated: Yee(e.id, r?.hasAnimation)
    },
    focalPoint: {
      x: e.focalPoint && e.focalPoint.x,
      y: e.focalPoint && e.focalPoint.y
    },
    parts: [],
    // options - general
    devicePixelRatio: o,
    quality: 0,
    upscaleMethod: jee(r),
    progressive: !0,
    watermark: "",
    unsharpMask: {},
    filters: {},
    transformed: h,
    allowFullGIFTransformation: r?.allowFullGIFTransformation,
    isPlaceholderFlow: r?.isPlaceholderFlow
  };
  return h && (ite(f, e, n), cte(f, r)), f;
}
function XO(t, e, n) {
  const r = { ...n }, i = rte();
  switch (t) {
    case Oe.LEGACY_BG_FIT_AND_TILE:
    case Oe.LEGACY_BG_FIT_AND_TILE_HORIZONTAL:
    case Oe.LEGACY_BG_FIT_AND_TILE_VERTICAL:
    case Oe.LEGACY_BG_NORMAL:
      const s = i ? mee : dee, a = i ? gee : fee;
      r.width = Math.min(s, e.width), r.height = Math.min(a, Math.round(r.width / (e.width / e.height))), r.pixelAspectRatio = 1;
  }
  return r;
}
const Ate = Wr`fit/w_${"width"},h_${"height"}`, Ete = Wr`fill/w_${"width"},h_${"height"},al_${"alignment"}`, Ste = Wr`fill/w_${"width"},h_${"height"},fp_${"focalPointX"}_${"focalPointY"}`, wte = Wr`crop/x_${"x"},y_${"y"},w_${"width"},h_${"height"}`, Fte = Wr`crop/w_${"width"},h_${"height"},al_${"alignment"}`, Tte = Wr`fill/w_${"width"},h_${"height"},al_${"alignment"}`, g0 = Wr`,lg_${"upscaleMethodValue"}`, vte = Wr`,q_${"quality"}`, z3 = Wr`,quality_auto`, xte = Wr`,usm_${"radius"}_${"amount"}_${"threshold"}`, Cte = Wr`,bl`, kte = Wr`,wm_${"watermark"}`, _te = {
  [ni.CONTRAST]: Wr`,con_${"contrast"}`,
  [ni.BRIGHTNESS]: Wr`,br_${"brightness"}`,
  [ni.SATURATION]: Wr`,sat_${"saturation"}`,
  [ni.HUE]: Wr`,hue_${"hue"}`,
  [ni.BLUR]: Wr`,blur_${"blur"}`
}, Nte = Wr`,enc_auto`, Dte = Wr`,enc_avif`, Ite = Wr`,enc_pavif`, Rte = Wr`,pstr`, Pte = Wr`,anm_all`;
function Lte(t) {
  const e = [];
  t.parts.forEach((r) => {
    switch (r.transformType) {
      case vr.CROP:
        e.push(wte(r));
        break;
      case vr.LEGACY_CROP:
        e.push(Fte(r));
        break;
      case vr.LEGACY_FILL:
        let i = Tte(r);
        r.upscale && (i += g0(r)), e.push(i);
        break;
      case vr.FIT:
        let s = Ate(r);
        r.upscale && (s += g0(r)), e.push(s);
        break;
      case vr.FILL:
        let a = Ete(r);
        r.upscale && (a += g0(r)), e.push(a);
        break;
      case vr.FILL_FOCAL:
        let o = Ste(r);
        r.upscale && (o += g0(r)), e.push(o);
        break;
    }
  });
  let n = e.join("/");
  if (t.quality && (n += vte(t)), t.unsharpMask && (n += xte(t.unsharpMask)), t.progressive || (n += Cte(t)), t.watermark && (n += kte(t)), t.filters && (n += Object.keys(t.filters).map((r) => _te[r](t.filters)).join("")), t.fileType !== Sn.GIF && (t.encoding === W3.AVIF ? (n += Dte(t), n += z3(t)) : t.encoding === W3.PAVIF ? (n += Ite(t), n += z3(t)) : t.autoEncode && (n += Nte(t))), t.src?.isAnimated && t.transformed) {
    const r = jx(t.src.id), i = t.isPlaceholderFlow === !0, s = t.allowFullGIFTransformation === !0;
    i ? n += Rte(t) : r && s && (n += Pte(t));
  }
  return `${t.src.id}/${cee}/${n}/${t.fileName}.${t.preferredExtension}`;
}
function n1(t, e, n, r = {}, i) {
  if (sA(e.id, r?.hasAnimation, r?.allowAnimatedTransform, r?.allowFullGIFTransformation)) {
    if ((Jg(e.id) || aA(e.id)) && !r.allowWebpAvifTransforms) {
      const { alignment: s, ...a } = n;
      e.focalPoint = { x: void 0, y: void 0 }, delete e?.crop, i = t1(t, e, a, r);
    } else
      i = i || t1(t, e, n, r);
    return Lte(i);
  }
  return e.id;
}
function Mte(t, e, n, r, i) {
  const s = n.pixelAspectRatio || 1;
  return {
    dpr: [
      `${s === 1 ? i.uri : n1(t, e, {
        ...n,
        pixelAspectRatio: 1
      }, r)} 1x`,
      `${s === 2 ? i.uri : n1(t, e, {
        ...n,
        pixelAspectRatio: 2
      }, r)} 2x`
    ]
  };
}
const ZO = {
  [et.CENTER]: "50% 50%",
  [et.TOP_LEFT]: "0% 0%",
  [et.TOP_RIGHT]: "100% 0%",
  [et.TOP]: "50% 0%",
  [et.BOTTOM_LEFT]: "0% 100%",
  [et.BOTTOM_RIGHT]: "100% 100%",
  [et.BOTTOM]: "50% 100%",
  [et.RIGHT]: "100% 50%",
  [et.LEFT]: "0% 50%"
}, Ote = Object.entries(ZO).reduce((t, [e, n]) => (t[n] = e, t), {}), oA = [
  Oe.TILE,
  Oe.TILE_HORIZONTAL,
  Oe.TILE_VERTICAL,
  Oe.LEGACY_BG_FIT_AND_TILE,
  Oe.LEGACY_BG_FIT_AND_TILE_HORIZONTAL,
  Oe.LEGACY_BG_FIT_AND_TILE_VERTICAL
], Bte = [
  Oe.LEGACY_ORIGINAL_SIZE,
  Oe.ORIGINAL_SIZE,
  Oe.LEGACY_BG_NORMAL
];
function eB(t, e, { width: n, height: r }) {
  return t === Oe.TILE && e.width > n && e.height > r;
}
function $te(t, e, { width: n, height: r }, i = !1) {
  if (i)
    return { width: n, height: r };
  const s = !Bte.includes(t), a = eB(t, e, { width: n, height: r }), o = !a && oA.includes(t), u = o ? e.width : n, l = o ? e.height : r, h = s ? Gte(u, jO(e.id)) : 1;
  return {
    width: a ? 1920 : u * h,
    height: l * h
  };
}
function Hte(t, e) {
  const n = oA.includes(t) && !e;
  return t === Oe.SCALE_TO_FILL || n ? Oe.SCALE_TO_FIT : t;
}
function Ute(t, { width: e, height: n }) {
  if (!e || !n) {
    const r = e || Math.min(980, t.width), i = r / t.width;
    return {
      width: r,
      height: n || t.height * i
    };
  }
  return { width: e, height: n };
}
function Gte(t, e) {
  return t > 900 ? e ? 0.05 : 0.15 : t > 500 ? e ? 0.1 : 0.18 : t > 200 ? 0.25 : 1;
}
function Wte(t, e, n) {
  return n ? 0 : oA.includes(e) ? 1 : t > 200 ? 2 : 3;
}
function Vte(t, e, n, r = "center") {
  const i = {
    img: {},
    container: {}
  };
  if (t === Oe.SCALE_TO_FILL) {
    const s = e.focalPoint && Kte(e.focalPoint), a = s || r;
    e.focalPoint && !s ? i.img = {
      objectPosition: zte(e, n, e.focalPoint)
    } : i.img = {
      objectPosition: ZO[a]
    };
  } else [Oe.LEGACY_ORIGINAL_SIZE, Oe.ORIGINAL_SIZE].includes(t) ? i.img = {
    objectFit: "none",
    top: "auto",
    left: "auto",
    right: "auto",
    bottom: "auto"
  } : oA.includes(t) && (i.container = {
    backgroundSize: `${e.width}px ${e.height}px`
  });
  return i;
}
function Kte(t) {
  const e = `${t.x}% ${t.y}%`;
  return Ote[e] || "";
}
function zte(t, e, n) {
  const { width: r, height: i } = t, { width: s, height: a } = e, { x: o, y: u } = n;
  if (!s || !a)
    return `${o}% ${u}%`;
  const l = Math.max(s / r, a / i), h = r * l, f = i * l, m = Math.max(0, Math.min(h - s, h * (o / 100) - s / 2)), g = Math.max(0, Math.min(f - a, f * (u / 100) - a / 2)), A = m && Math.floor(m / (h - s) * 100), E = g && Math.floor(g / (f - a) * 100);
  return `${A}% ${E}%`;
}
const jte = { width: "100%", height: "100%" };
function Yte(t, e, n, r = {}) {
  const { autoEncode: i = !0, isSEOBot: s, shouldLoadHQImage: a, hasAnimation: o, allowAnimatedTransform: u, encoding: l } = r;
  if (!zx(t, e, n))
    return KO;
  const h = !0, f = u ?? h, m = sA(e.id, o, f);
  if (!m || a)
    return qm(t, e, n, {
      ...r,
      autoEncode: i,
      useSrcset: m
    });
  const g = {
    ...n,
    ...Ute(e, n)
  }, { alignment: A, htmlTag: E } = g, w = eB(t, e, g), x = $te(t, e, g, s), N = Wte(g.width, t, s), B = Hte(t, w), P = Vte(t, e, n, A), { uri: C } = qm(B, e, {
    ...x,
    alignment: A,
    htmlTag: E
  }, {
    autoEncode: i,
    filters: N ? { blur: N } : {},
    hasAnimation: o,
    allowAnimatedTransform: f,
    encoding: l,
    isPlaceholderFlow: h
  }), { attr: D = {}, css: L } = qm(t, e, {
    ...g,
    alignment: A,
    htmlTag: E
  }, {});
  return L.img = L.img || {}, L.container = L.container || {}, Object.assign(L.img, P.img, jte), Object.assign(L.container, P.container), { uri: C, css: L, attr: D, transformed: !0 };
}
function qm(t, e, n, r) {
  let i = {};
  if (zx(t, e, n)) {
    const s = XO(t, e, n), a = t1(t, e, s, r);
    i.uri = n1(t, e, s, r, a), r?.useSrcset && (i.srcset = Mte(t, e, s, r, i)), Object.assign(i, nte(a, s), {
      transformed: a.transformed
    });
  } else
    i = KO;
  return i;
}
function Qx(t, e, n, r) {
  if (zx(t, e, n)) {
    const i = XO(t, e, n), s = t1(t, e, i, r);
    return {
      uri: n1(t, e, i, r || {}, s)
    };
  }
  return { uri: "" };
}
const tB = "https://static.wixstatic.com/", nB = "https://static.wixstatic.com/media/", qte = /^media\//i, Xx = typeof window < "u" ? window.devicePixelRatio : 1, Jte = (t) => qte.test(t) ? `${tB}${t}` : `${nB}${t}`, Zx = (t, e) => {
  const n = e && e.baseHostURL;
  return n ? `${n}${t}` : Jte(t);
};
function Qte(t, e, n, r, i, s) {
  const a = Qx(Oe.SCALE_TO_FIT, {
    id: t,
    width: e,
    height: n,
    name: s && s.name
  }, {
    width: r,
    height: i,
    htmlTag: uf.IMG,
    alignment: et.CENTER,
    pixelAspectRatio: s?.devicePixelRatio ?? Xx
  }, s);
  return Zx(a.uri, s);
}
function Xte(t, e, n, r, i, s) {
  const a = Qx(Oe.SCALE_TO_FILL, {
    id: t,
    width: e,
    height: n,
    name: s && s.name,
    focalPoint: {
      x: s && s.focalPoint && s.focalPoint.x,
      y: s && s.focalPoint && s.focalPoint.y
    }
  }, {
    width: r,
    height: i,
    htmlTag: uf.IMG,
    alignment: et.CENTER,
    pixelAspectRatio: s?.devicePixelRatio ?? Xx
  }, s);
  return Zx(a.uri, s);
}
function Zte(t, e, n, r, i, s, a, o, u, l) {
  const h = Qx(Oe.SCALE_TO_FILL, {
    id: t,
    width: e,
    height: n,
    name: l && l.name,
    crop: {
      x: r,
      y: i,
      width: s,
      height: a
    }
  }, {
    width: o,
    height: u,
    htmlTag: uf.IMG,
    alignment: et.CENTER,
    pixelAspectRatio: l?.devicePixelRatio ?? Xx
  }, l);
  return Zx(h.uri, l);
}
Jx();
const ene = {
  CENTER: "center"
}, tne = (t, e, n, r, i, s, a, o = ene.CENTER) => {
  if (t > e) {
    const u = r, l = Math.round(r / (s / i));
    let h = Math.round(n / 2 - l / 2);
    const f = 0;
    return o.includes("top") ? h = 0 : o.includes("bottom") && (h = n - l), { width: u, height: l, x: f, y: h };
  } else {
    const u = Math.round(n / (i / a)), l = n;
    let h = Math.round(r / 2 - u / 2);
    const f = 0;
    return o.includes("left") ? h = 0 : o.includes("right") && (h = r - u), { width: u, height: l, x: h, y: f };
  }
}, j3 = [1920, 1536, 1366, 1280, 980], nne = (t, e, n, r, i, s, a, o, u, l, h, f, m, g, A, E, w, x) => {
  const N = E === "original_size", B = e / n;
  return j3.map((P, C) => {
    const D = P === 980, L = (X) => D ? i : (X - 2 * (A || 0)) * (t / 100), k = L(j3[C + 1]), I = L(P), U = k / r, J = !(N || D) && tne(U, B, n, e, r, k, I, u), { srcset: G, fallbackSrc: H, css: q } = rB({
      displayMode: N ? "original_size" : D ? "fill" : "fit",
      uri: s,
      width: e,
      height: n,
      crop: m || J,
      name: o,
      focalPoint: f,
      alignType: u,
      quality: a,
      upscaleMethod: h,
      hasAnimation: l,
      encoding: g,
      allowFullGIFTransformation: w,
      baseHostURL: x
    }, I, r);
    return N && q && (q.img.objectFit = "cover"), {
      srcset: G || "",
      sizes: D ? `${t}vw` : `${I}px`,
      media: `(max-width: ${P}px)`,
      fallbackSrc: H,
      imgStyle: q?.img
    };
  });
}, rB = (t, e, n) => {
  const { displayMode: r, uri: i, width: s, height: a, name: o, crop: u, focalPoint: l, alignType: h, quality: f, upscaleMethod: m, hasAnimation: g, allowAnimatedTransform: A, encoding: E, siteMargin: w, widthProportion: x, allowFullGIFTransformation: N, baseHostURL: B } = t;
  if (x) {
    const P = nne(x, s, a, n, e, i, f, o, h, g, m, l, u, E, w, r, N, B).filter(Boolean).reverse();
    return {
      fallbackSrc: P[0].fallbackSrc,
      sources: P,
      css: P[0].imgStyle
    };
  } else {
    const { srcset: P, css: C, uri: D } = qm(r, { id: i, width: s, height: a, name: o, crop: u, focalPoint: l }, {
      width: e,
      height: n,
      alignment: h
    }, {
      focalPoint: l,
      name: o,
      quality: f?.quality,
      upscaleMethod: m,
      hasAnimation: g,
      allowAnimatedTransform: A,
      useSrcset: !0,
      encoding: E,
      allowFullGIFTransformation: N
    }), L = B || iB, k = P?.dpr?.map((j) => /^[a-z]+:/.test(j) ? j : `${L}${j}`), I = `${L}${D}`, U = k?.join(", ") || "";
    return {
      fallbackSrc: I,
      srcset: U,
      css: C
    };
  }
};
Jx();
const rne = {
  getScaleToFitImageURL: Qte,
  getScaleToFillImageURL: Xte,
  getCropImageURL: Zte
}, iB = nB, ine = tB, sne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MEDIA_ROOT_URL: ine,
  STATIC_MEDIA_URL: iB,
  alignTypes: et,
  fileType: Sn,
  fittingTypes: Oe,
  getData: qm,
  getFileExtension: Xu,
  getPlaceholder: Yte,
  getResponsiveImageProps: rB,
  htmlTag: uf,
  isWEBP: Jg,
  populateGlobalFeatureSupport: Jx,
  sdk: rne,
  upscaleMethods: wy
}, Symbol.toStringTag, { value: "Module" })), sB = /* @__PURE__ */ vt(sne);
var Y3;
function aB() {
  if (Y3) return nm;
  Y3 = 1, Object.defineProperty(nm, "__esModule", { value: !0 }), nm.createPlaceholderGetter = void 0;
  const t = sB, e = (n, { baseMediaUrl: r = t.STATIC_MEDIA_URL, isSEOBot: i = !1, userDomainMediaBaseUrl: s, userDomainMediaPrefixes: a = [] }) => {
    const o = /^[a-z]+:/;
    return {
      getPlaceholder: ({ fittingType: u, src: l, target: h, options: f }) => {
        const m = n(u, l, h, {
          ...f || {},
          isSEOBot: i,
          autoEncode: !0
        }), g = l.uri ?? l.id, E = (g && s && a.some((w) => g.startsWith(`${w}_`)) ? s : r).replace(/\/$/, "");
        return m && m.uri && !o.test(m.uri) && (m.uri = `${E}/${m.uri}`), m?.srcset?.dpr && (m.srcset.dpr = m.srcset.dpr.map((w) => o.test(w) ? w : `${E}/${w}`)), m;
      }
    };
  };
  return nm.createPlaceholderGetter = e, nm;
}
var q3;
function ane() {
  return q3 || (q3 = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ImagePlaceholderService = t.ImagePlaceholderDefintion = void 0;
    const e = lee, n = /* @__PURE__ */ aB(), r = sB;
    t.ImagePlaceholderDefintion = (0, e.defineStaticService)("viewer-core/image-placeholder"), t.ImagePlaceholderService = (0, e.implementStaticService)(t.ImagePlaceholderDefintion, ({ config: i }) => (0, n.createPlaceholderGetter)(r.getPlaceholder, i));
  })(bS)), bS;
}
var AS = {}, J3;
function one() {
  return J3 || (J3 = 1, Object.defineProperty(AS, "__esModule", { value: !0 })), AS;
}
var Q3;
function une() {
  return Q3 || (Q3 = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = uee;
    e.__exportStar(/* @__PURE__ */ ane(), t), e.__exportStar(/* @__PURE__ */ aB(), t), e.__exportStar(/* @__PURE__ */ one(), t);
  })(pS)), pS;
}
const oB = du("@wix/viewer-service-business-logger"), lne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BusinessLoggerDefinition: oB
}, Symbol.toStringTag, { value: "Module" })), cne = /* @__PURE__ */ vt(lne), hne = () => {
  const t = (e, n) => new Promise(() => {
    console.warn("The logger is not implemented");
  });
  return {
    logger: {
      log: t
    },
    reportBi: t
  };
}, dne = Ja(oB, () => hne()), fne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BusinessLoggerService: dne
}, Symbol.toStringTag, { value: "Module" })), mne = /* @__PURE__ */ vt(fne), uB = "@wix/viewer-service-url", gne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UrlDefinition: uB
}, Symbol.toStringTag, { value: "Module" })), pne = /* @__PURE__ */ vt(gne), bne = (t, e) => lB(t, e).relativeEncodedUrl, lB = (t, e) => {
  const n = yne(t, e), r = Ane(n), i = X3(r), s = X3(Ene(n));
  return {
    relativePathnameParts: r,
    relativeUrl: i,
    relativeEncodedUrl: s
  };
}, yne = (t, e) => {
  const n = new URL(t, `${e}/`), r = new URL(e);
  return n.pathname.replace(r.pathname, "");
}, Ane = (t) => {
  const e = cB(t);
  return wne(e).split("/");
}, X3 = (t) => `./${t.join("/")}`, Ene = (t) => cB(t).split("/"), cB = (t) => /^\/?(.*?)\/?$/.exec(t)[1], Sne = (t, e) => lB(t, e).relativeUrl, wne = (t) => {
  try {
    return decodeURIComponent(t);
  } catch {
    return t;
  }
}, Fne = (t, e, n) => {
  const r = e.startsWith("//") ? `${t.protocol}${e}` : e, i = new URL(r);
  return t.host === i.host && t.searchParams.forEach((a, o) => {
    n?.has(o) && !i.searchParams.has(o) && i.searchParams.set(o, a);
  }), i;
}, Tne = (t) => t && t.navigator && t.navigator.userAgent ? t.navigator.userAgent.toLowerCase() : "", vne = (t) => {
  const e = Tne(t);
  return e.indexOf("safari") > -1 && e.indexOf("version") > -1;
}, xne = (t, e) => {
  const { logger: n, currentRouteInfo: r, requestUrl: i, externalBaseUrl: s, queryParamsWhitelist: a } = t, o = globalThis.window, l = e(No).isExperimentOpen("specs.thunderbolt.update_href_in_safari_incognito"), h = () => o?.location.href || i;
  let f = [];
  const m = {}, A = {
    getHistoryState: () => !o || !o.history ? null : o.history.state,
    updateHistoryState: (E) => {
      if (!(!o || !o.history) && E) {
        const w = new URL(o.location.href);
        w.searchParams.sort(), o.history.replaceState(E, "", w.toString());
      }
    },
    getParsedUrl: () => new URL(A.getCurrentUrl()),
    getRelativeUrl: () => Sne(A.getCurrentUrl(), s),
    getRelativeEncodedUrl: () => bne(A.getCurrentUrl(), s),
    updateState: (E) => {
      m.previousPageId = E;
    },
    addOnUrlChangeListener: (E) => {
      f.push(E);
    },
    removeOnUrlChangeListener: (E) => {
      f = f.filter((w) => w !== E);
    },
    getFullUrlWithoutQueryParams: () => {
      const E = A.getRelativeUrl(), x = E === "./" ? s : `${s}/`;
      return E.replace("./", x);
    },
    pushUrl: (E, { disableScrollToTop: w, skipHistory: x } = {}) => {
      if (!o || !o.history)
        return;
      const N = new URL(h()), B = Fne(N, E.href, a), P = B.toString();
      B.searchParams.sort(), N.searchParams.sort();
      const C = { scrollY: o.scrollY };
      if (x && o.history.replaceState(C, "", P), N.toString() === B.toString())
        return;
      if (!x) {
        o.history.replaceState(C, "", N.toString());
        try {
          const L = w ? { scrollY: C?.scrollY } : null;
          o.history.pushState(L, "", P), l && vne(window) && P !== window.location.href && (window.location.href = P);
        } catch (L) {
          n?.captureError(L, { tags: { feature: "feature-router", pushStateError: !0 } });
        }
      }
      const D = r?.getCurrentRouteInfo()?.pageId;
      m.previousPageId === D && f.forEach((L) => L.onUrlChange(new URL(P)));
    },
    getCurrentUrl: h,
    getExternalBaseUrl: () => s
  };
  return A;
}, Cne = la(uB, ({ config: t, getService: e }) => {
  const n = e(qg), r = xne(t, e), i = n.signal(r.getFullUrlWithoutQueryParams()), s = n.signal(r.getCurrentUrl()), a = n.signal(r.getRelativeUrl());
  return {
    ...r,
    pushUrlState: (u, l = {}) => {
      r.pushUrl(u, l), i.set(r.getFullUrlWithoutQueryParams()), s.set(r.getCurrentUrl()), a.set(r.getRelativeUrl());
    },
    // state refs
    getCurrentUrl: () => i.get(),
    getCurrentUrlWithQueryParams: () => s.get(),
    getRelativeUrl: () => a.get()
  };
}), kne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UrlService: Cne
}, Symbol.toStringTag, { value: "Module" })), _ne = /* @__PURE__ */ vt(kne), hB = "@wix/window-ns", Nne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WindowNsDefinition: hB
}, Symbol.toStringTag, { value: "Module" })), Dne = /* @__PURE__ */ vt(Nne), eC = "@wix/viewer-service-window-scroll", Ine = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WindowScrollDefinition: eC
}, Symbol.toStringTag, { value: "Module" }));
var xm = { exports: {} };
var Rne = xm.exports, Z3;
function Pne() {
  return Z3 || (Z3 = 1, (function(t, e) {
    (function() {
      var n, r = "4.17.23", i = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", o = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", l = 500, h = "__lodash_placeholder__", f = 1, m = 2, g = 4, A = 1, E = 2, w = 1, x = 2, N = 4, B = 8, P = 16, C = 32, D = 64, L = 128, k = 256, I = 512, U = 30, j = "...", J = 800, G = 16, H = 1, q = 2, X = 3, ie = 1 / 0, te = 9007199254740991, Pe = 17976931348623157e292, We = NaN, Me = 4294967295, Le = Me - 1, fn = Me >>> 1, Yt = [
        ["ary", L],
        ["bind", w],
        ["bindKey", x],
        ["curry", B],
        ["curryRight", P],
        ["flip", I],
        ["partial", C],
        ["partialRight", D],
        ["rearg", k]
      ], Rn = "[object Arguments]", Pn = "[object Array]", ls = "[object AsyncFunction]", Tn = "[object Boolean]", qt = "[object Date]", yr = "[object DOMException]", $n = "[object Error]", Cr = "[object Function]", ii = "[object GeneratorFunction]", Hn = "[object Map]", cs = "[object Number]", hs = "[object Null]", oe = "[object Object]", Te = "[object Promise]", Je = "[object Proxy]", rt = "[object RegExp]", Ue = "[object Set]", rn = "[object String]", Vs = "[object Symbol]", el = "[object Undefined]", Xa = "[object WeakMap]", Tp = "[object WeakSet]", tl = "[object ArrayBuffer]", mu = "[object DataView]", gu = "[object Float32Array]", pu = "[object Float64Array]", Br = "[object Int8Array]", bn = "[object Int16Array]", gi = "[object Int32Array]", Lo = "[object Uint8Array]", bu = "[object Uint8ClampedArray]", Mh = "[object Uint16Array]", Mo = "[object Uint32Array]", kc = /\b__p \+= '';/g, vp = /\b(__p \+=) '' \+/g, $f = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Hf = /&(?:amp|lt|gt|quot|#39);/g, Oh = /[&<>"']/g, XA = RegExp(Hf.source), WW = RegExp(Oh.source), VW = /<%-([\s\S]+?)%>/g, KW = /<%([\s\S]+?)%>/g, nk = /<%=([\s\S]+?)%>/g, zW = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, jW = /^\w*$/, YW = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ZA = /[\\^$.*+?()[\]{}|]/g, qW = RegExp(ZA.source), eE = /^\s+/, JW = /\s/, QW = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, XW = /\{\n\/\* \[wrapped with (.+)\] \*/, ZW = /,? & /, eV = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, tV = /[()=,{}\[\]\/\s]/, nV = /\\(\\)?/g, rV = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, rk = /\w*$/, iV = /^[-+]0x[0-9a-f]+$/i, sV = /^0b[01]+$/i, aV = /^\[object .+?Constructor\]$/, oV = /^0o[0-7]+$/i, uV = /^(?:0|[1-9]\d*)$/, lV = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, xp = /($^)/, cV = /['\n\r\u2028\u2029\\]/g, Cp = "\\ud800-\\udfff", hV = "\\u0300-\\u036f", dV = "\\ufe20-\\ufe2f", fV = "\\u20d0-\\u20ff", ik = hV + dV + fV, sk = "\\u2700-\\u27bf", ak = "a-z\\xdf-\\xf6\\xf8-\\xff", mV = "\\xac\\xb1\\xd7\\xf7", gV = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", pV = "\\u2000-\\u206f", bV = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ok = "A-Z\\xc0-\\xd6\\xd8-\\xde", uk = "\\ufe0e\\ufe0f", lk = mV + gV + pV + bV, tE = "['’]", yV = "[" + Cp + "]", ck = "[" + lk + "]", kp = "[" + ik + "]", hk = "\\d+", AV = "[" + sk + "]", dk = "[" + ak + "]", fk = "[^" + Cp + lk + hk + sk + ak + ok + "]", nE = "\\ud83c[\\udffb-\\udfff]", EV = "(?:" + kp + "|" + nE + ")", mk = "[^" + Cp + "]", rE = "(?:\\ud83c[\\udde6-\\uddff]){2}", iE = "[\\ud800-\\udbff][\\udc00-\\udfff]", Bh = "[" + ok + "]", gk = "\\u200d", pk = "(?:" + dk + "|" + fk + ")", SV = "(?:" + Bh + "|" + fk + ")", bk = "(?:" + tE + "(?:d|ll|m|re|s|t|ve))?", yk = "(?:" + tE + "(?:D|LL|M|RE|S|T|VE))?", Ak = EV + "?", Ek = "[" + uk + "]?", wV = "(?:" + gk + "(?:" + [mk, rE, iE].join("|") + ")" + Ek + Ak + ")*", FV = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", TV = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Sk = Ek + Ak + wV, vV = "(?:" + [AV, rE, iE].join("|") + ")" + Sk, xV = "(?:" + [mk + kp + "?", kp, rE, iE, yV].join("|") + ")", CV = RegExp(tE, "g"), kV = RegExp(kp, "g"), sE = RegExp(nE + "(?=" + nE + ")|" + xV + Sk, "g"), _V = RegExp([
        Bh + "?" + dk + "+" + bk + "(?=" + [ck, Bh, "$"].join("|") + ")",
        SV + "+" + yk + "(?=" + [ck, Bh + pk, "$"].join("|") + ")",
        Bh + "?" + pk + "+" + bk,
        Bh + "+" + yk,
        TV,
        FV,
        hk,
        vV
      ].join("|"), "g"), NV = RegExp("[" + gk + Cp + ik + uk + "]"), DV = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, IV = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], RV = -1, hr = {};
      hr[gu] = hr[pu] = hr[Br] = hr[bn] = hr[gi] = hr[Lo] = hr[bu] = hr[Mh] = hr[Mo] = !0, hr[Rn] = hr[Pn] = hr[tl] = hr[Tn] = hr[mu] = hr[qt] = hr[$n] = hr[Cr] = hr[Hn] = hr[cs] = hr[oe] = hr[rt] = hr[Ue] = hr[rn] = hr[Xa] = !1;
      var ir = {};
      ir[Rn] = ir[Pn] = ir[tl] = ir[mu] = ir[Tn] = ir[qt] = ir[gu] = ir[pu] = ir[Br] = ir[bn] = ir[gi] = ir[Hn] = ir[cs] = ir[oe] = ir[rt] = ir[Ue] = ir[rn] = ir[Vs] = ir[Lo] = ir[bu] = ir[Mh] = ir[Mo] = !0, ir[$n] = ir[Cr] = ir[Xa] = !1;
      var PV = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, LV = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, MV = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, OV = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, BV = parseFloat, $V = parseInt, wk = typeof Ll == "object" && Ll && Ll.Object === Object && Ll, HV = typeof self == "object" && self && self.Object === Object && self, Pi = wk || HV || Function("return this")(), aE = e && !e.nodeType && e, _c = aE && !0 && t && !t.nodeType && t, Fk = _c && _c.exports === aE, oE = Fk && wk.process, da = (function() {
        try {
          var Z = _c && _c.require && _c.require("util").types;
          return Z || oE && oE.binding && oE.binding("util");
        } catch {
        }
      })(), Tk = da && da.isArrayBuffer, vk = da && da.isDate, xk = da && da.isMap, Ck = da && da.isRegExp, kk = da && da.isSet, _k = da && da.isTypedArray;
      function Ks(Z, ye, ue) {
        switch (ue.length) {
          case 0:
            return Z.call(ye);
          case 1:
            return Z.call(ye, ue[0]);
          case 2:
            return Z.call(ye, ue[0], ue[1]);
          case 3:
            return Z.call(ye, ue[0], ue[1], ue[2]);
        }
        return Z.apply(ye, ue);
      }
      function UV(Z, ye, ue, qe) {
        for (var kt = -1, _n = Z == null ? 0 : Z.length; ++kt < _n; ) {
          var si = Z[kt];
          ye(qe, si, ue(si), Z);
        }
        return qe;
      }
      function fa(Z, ye) {
        for (var ue = -1, qe = Z == null ? 0 : Z.length; ++ue < qe && ye(Z[ue], ue, Z) !== !1; )
          ;
        return Z;
      }
      function GV(Z, ye) {
        for (var ue = Z == null ? 0 : Z.length; ue-- && ye(Z[ue], ue, Z) !== !1; )
          ;
        return Z;
      }
      function Nk(Z, ye) {
        for (var ue = -1, qe = Z == null ? 0 : Z.length; ++ue < qe; )
          if (!ye(Z[ue], ue, Z))
            return !1;
        return !0;
      }
      function nl(Z, ye) {
        for (var ue = -1, qe = Z == null ? 0 : Z.length, kt = 0, _n = []; ++ue < qe; ) {
          var si = Z[ue];
          ye(si, ue, Z) && (_n[kt++] = si);
        }
        return _n;
      }
      function _p(Z, ye) {
        var ue = Z == null ? 0 : Z.length;
        return !!ue && $h(Z, ye, 0) > -1;
      }
      function uE(Z, ye, ue) {
        for (var qe = -1, kt = Z == null ? 0 : Z.length; ++qe < kt; )
          if (ue(ye, Z[qe]))
            return !0;
        return !1;
      }
      function Ar(Z, ye) {
        for (var ue = -1, qe = Z == null ? 0 : Z.length, kt = Array(qe); ++ue < qe; )
          kt[ue] = ye(Z[ue], ue, Z);
        return kt;
      }
      function rl(Z, ye) {
        for (var ue = -1, qe = ye.length, kt = Z.length; ++ue < qe; )
          Z[kt + ue] = ye[ue];
        return Z;
      }
      function lE(Z, ye, ue, qe) {
        var kt = -1, _n = Z == null ? 0 : Z.length;
        for (qe && _n && (ue = Z[++kt]); ++kt < _n; )
          ue = ye(ue, Z[kt], kt, Z);
        return ue;
      }
      function WV(Z, ye, ue, qe) {
        var kt = Z == null ? 0 : Z.length;
        for (qe && kt && (ue = Z[--kt]); kt--; )
          ue = ye(ue, Z[kt], kt, Z);
        return ue;
      }
      function cE(Z, ye) {
        for (var ue = -1, qe = Z == null ? 0 : Z.length; ++ue < qe; )
          if (ye(Z[ue], ue, Z))
            return !0;
        return !1;
      }
      var VV = hE("length");
      function KV(Z) {
        return Z.split("");
      }
      function zV(Z) {
        return Z.match(eV) || [];
      }
      function Dk(Z, ye, ue) {
        var qe;
        return ue(Z, function(kt, _n, si) {
          if (ye(kt, _n, si))
            return qe = _n, !1;
        }), qe;
      }
      function Np(Z, ye, ue, qe) {
        for (var kt = Z.length, _n = ue + (qe ? 1 : -1); qe ? _n-- : ++_n < kt; )
          if (ye(Z[_n], _n, Z))
            return _n;
        return -1;
      }
      function $h(Z, ye, ue) {
        return ye === ye ? iK(Z, ye, ue) : Np(Z, Ik, ue);
      }
      function jV(Z, ye, ue, qe) {
        for (var kt = ue - 1, _n = Z.length; ++kt < _n; )
          if (qe(Z[kt], ye))
            return kt;
        return -1;
      }
      function Ik(Z) {
        return Z !== Z;
      }
      function Rk(Z, ye) {
        var ue = Z == null ? 0 : Z.length;
        return ue ? fE(Z, ye) / ue : We;
      }
      function hE(Z) {
        return function(ye) {
          return ye == null ? n : ye[Z];
        };
      }
      function dE(Z) {
        return function(ye) {
          return Z == null ? n : Z[ye];
        };
      }
      function Pk(Z, ye, ue, qe, kt) {
        return kt(Z, function(_n, si, Xn) {
          ue = qe ? (qe = !1, _n) : ye(ue, _n, si, Xn);
        }), ue;
      }
      function YV(Z, ye) {
        var ue = Z.length;
        for (Z.sort(ye); ue--; )
          Z[ue] = Z[ue].value;
        return Z;
      }
      function fE(Z, ye) {
        for (var ue, qe = -1, kt = Z.length; ++qe < kt; ) {
          var _n = ye(Z[qe]);
          _n !== n && (ue = ue === n ? _n : ue + _n);
        }
        return ue;
      }
      function mE(Z, ye) {
        for (var ue = -1, qe = Array(Z); ++ue < Z; )
          qe[ue] = ye(ue);
        return qe;
      }
      function qV(Z, ye) {
        return Ar(ye, function(ue) {
          return [ue, Z[ue]];
        });
      }
      function Lk(Z) {
        return Z && Z.slice(0, $k(Z) + 1).replace(eE, "");
      }
      function zs(Z) {
        return function(ye) {
          return Z(ye);
        };
      }
      function gE(Z, ye) {
        return Ar(ye, function(ue) {
          return Z[ue];
        });
      }
      function Uf(Z, ye) {
        return Z.has(ye);
      }
      function Mk(Z, ye) {
        for (var ue = -1, qe = Z.length; ++ue < qe && $h(ye, Z[ue], 0) > -1; )
          ;
        return ue;
      }
      function Ok(Z, ye) {
        for (var ue = Z.length; ue-- && $h(ye, Z[ue], 0) > -1; )
          ;
        return ue;
      }
      function JV(Z, ye) {
        for (var ue = Z.length, qe = 0; ue--; )
          Z[ue] === ye && ++qe;
        return qe;
      }
      var QV = dE(PV), XV = dE(LV);
      function ZV(Z) {
        return "\\" + OV[Z];
      }
      function eK(Z, ye) {
        return Z == null ? n : Z[ye];
      }
      function Hh(Z) {
        return NV.test(Z);
      }
      function tK(Z) {
        return DV.test(Z);
      }
      function nK(Z) {
        for (var ye, ue = []; !(ye = Z.next()).done; )
          ue.push(ye.value);
        return ue;
      }
      function pE(Z) {
        var ye = -1, ue = Array(Z.size);
        return Z.forEach(function(qe, kt) {
          ue[++ye] = [kt, qe];
        }), ue;
      }
      function Bk(Z, ye) {
        return function(ue) {
          return Z(ye(ue));
        };
      }
      function il(Z, ye) {
        for (var ue = -1, qe = Z.length, kt = 0, _n = []; ++ue < qe; ) {
          var si = Z[ue];
          (si === ye || si === h) && (Z[ue] = h, _n[kt++] = ue);
        }
        return _n;
      }
      function Dp(Z) {
        var ye = -1, ue = Array(Z.size);
        return Z.forEach(function(qe) {
          ue[++ye] = qe;
        }), ue;
      }
      function rK(Z) {
        var ye = -1, ue = Array(Z.size);
        return Z.forEach(function(qe) {
          ue[++ye] = [qe, qe];
        }), ue;
      }
      function iK(Z, ye, ue) {
        for (var qe = ue - 1, kt = Z.length; ++qe < kt; )
          if (Z[qe] === ye)
            return qe;
        return -1;
      }
      function sK(Z, ye, ue) {
        for (var qe = ue + 1; qe--; )
          if (Z[qe] === ye)
            return qe;
        return qe;
      }
      function Uh(Z) {
        return Hh(Z) ? oK(Z) : VV(Z);
      }
      function Za(Z) {
        return Hh(Z) ? uK(Z) : KV(Z);
      }
      function $k(Z) {
        for (var ye = Z.length; ye-- && JW.test(Z.charAt(ye)); )
          ;
        return ye;
      }
      var aK = dE(MV);
      function oK(Z) {
        for (var ye = sE.lastIndex = 0; sE.test(Z); )
          ++ye;
        return ye;
      }
      function uK(Z) {
        return Z.match(sE) || [];
      }
      function lK(Z) {
        return Z.match(_V) || [];
      }
      var cK = (function Z(ye) {
        ye = ye == null ? Pi : Gh.defaults(Pi.Object(), ye, Gh.pick(Pi, IV));
        var ue = ye.Array, qe = ye.Date, kt = ye.Error, _n = ye.Function, si = ye.Math, Xn = ye.Object, bE = ye.RegExp, hK = ye.String, ma = ye.TypeError, Ip = ue.prototype, dK = _n.prototype, Wh = Xn.prototype, Rp = ye["__core-js_shared__"], Pp = dK.toString, Ln = Wh.hasOwnProperty, fK = 0, Hk = (function() {
          var c = /[^.]+$/.exec(Rp && Rp.keys && Rp.keys.IE_PROTO || "");
          return c ? "Symbol(src)_1." + c : "";
        })(), Lp = Wh.toString, mK = Pp.call(Xn), gK = Pi._, pK = bE(
          "^" + Pp.call(Ln).replace(ZA, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Mp = Fk ? ye.Buffer : n, sl = ye.Symbol, Op = ye.Uint8Array, Uk = Mp ? Mp.allocUnsafe : n, Bp = Bk(Xn.getPrototypeOf, Xn), Gk = Xn.create, Wk = Wh.propertyIsEnumerable, $p = Ip.splice, Vk = sl ? sl.isConcatSpreadable : n, Gf = sl ? sl.iterator : n, Nc = sl ? sl.toStringTag : n, Hp = (function() {
          try {
            var c = Lc(Xn, "defineProperty");
            return c({}, "", {}), c;
          } catch {
          }
        })(), bK = ye.clearTimeout !== Pi.clearTimeout && ye.clearTimeout, yK = qe && qe.now !== Pi.Date.now && qe.now, AK = ye.setTimeout !== Pi.setTimeout && ye.setTimeout, Up = si.ceil, Gp = si.floor, yE = Xn.getOwnPropertySymbols, EK = Mp ? Mp.isBuffer : n, Kk = ye.isFinite, SK = Ip.join, wK = Bk(Xn.keys, Xn), ai = si.max, ji = si.min, FK = qe.now, TK = ye.parseInt, zk = si.random, vK = Ip.reverse, AE = Lc(ye, "DataView"), Wf = Lc(ye, "Map"), EE = Lc(ye, "Promise"), Vh = Lc(ye, "Set"), Vf = Lc(ye, "WeakMap"), Kf = Lc(Xn, "create"), Wp = Vf && new Vf(), Kh = {}, xK = Mc(AE), CK = Mc(Wf), kK = Mc(EE), _K = Mc(Vh), NK = Mc(Vf), Vp = sl ? sl.prototype : n, zf = Vp ? Vp.valueOf : n, jk = Vp ? Vp.toString : n;
        function _(c) {
          if ($r(c) && !_t(c) && !(c instanceof sn)) {
            if (c instanceof ga)
              return c;
            if (Ln.call(c, "__wrapped__"))
              return Y_(c);
          }
          return new ga(c);
        }
        var zh = /* @__PURE__ */ (function() {
          function c() {
          }
          return function(d) {
            if (!kr(d))
              return {};
            if (Gk)
              return Gk(d);
            c.prototype = d;
            var p = new c();
            return c.prototype = n, p;
          };
        })();
        function Kp() {
        }
        function ga(c, d) {
          this.__wrapped__ = c, this.__actions__ = [], this.__chain__ = !!d, this.__index__ = 0, this.__values__ = n;
        }
        _.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: VW,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: KW,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: nk,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _
          }
        }, _.prototype = Kp.prototype, _.prototype.constructor = _, ga.prototype = zh(Kp.prototype), ga.prototype.constructor = ga;
        function sn(c) {
          this.__wrapped__ = c, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Me, this.__views__ = [];
        }
        function DK() {
          var c = new sn(this.__wrapped__);
          return c.__actions__ = Ss(this.__actions__), c.__dir__ = this.__dir__, c.__filtered__ = this.__filtered__, c.__iteratees__ = Ss(this.__iteratees__), c.__takeCount__ = this.__takeCount__, c.__views__ = Ss(this.__views__), c;
        }
        function IK() {
          if (this.__filtered__) {
            var c = new sn(this);
            c.__dir__ = -1, c.__filtered__ = !0;
          } else
            c = this.clone(), c.__dir__ *= -1;
          return c;
        }
        function RK() {
          var c = this.__wrapped__.value(), d = this.__dir__, p = _t(c), S = d < 0, v = p ? c.length : 0, R = Kz(0, v, this.__views__), V = R.start, Y = R.end, ee = Y - V, Ee = S ? Y : V - 1, Se = this.__iteratees__, Ce = Se.length, Ve = 0, Ze = ji(ee, this.__takeCount__);
          if (!p || !S && v == ee && Ze == ee)
            return b_(c, this.__actions__);
          var mt = [];
          e:
            for (; ee-- && Ve < Ze; ) {
              Ee += d;
              for (var Ut = -1, gt = c[Ee]; ++Ut < Ce; ) {
                var Jt = Se[Ut], mn = Jt.iteratee, qs = Jt.type, ms = mn(gt);
                if (qs == q)
                  gt = ms;
                else if (!ms) {
                  if (qs == H)
                    continue e;
                  break e;
                }
              }
              mt[Ve++] = gt;
            }
          return mt;
        }
        sn.prototype = zh(Kp.prototype), sn.prototype.constructor = sn;
        function Dc(c) {
          var d = -1, p = c == null ? 0 : c.length;
          for (this.clear(); ++d < p; ) {
            var S = c[d];
            this.set(S[0], S[1]);
          }
        }
        function PK() {
          this.__data__ = Kf ? Kf(null) : {}, this.size = 0;
        }
        function LK(c) {
          var d = this.has(c) && delete this.__data__[c];
          return this.size -= d ? 1 : 0, d;
        }
        function MK(c) {
          var d = this.__data__;
          if (Kf) {
            var p = d[c];
            return p === u ? n : p;
          }
          return Ln.call(d, c) ? d[c] : n;
        }
        function OK(c) {
          var d = this.__data__;
          return Kf ? d[c] !== n : Ln.call(d, c);
        }
        function BK(c, d) {
          var p = this.__data__;
          return this.size += this.has(c) ? 0 : 1, p[c] = Kf && d === n ? u : d, this;
        }
        Dc.prototype.clear = PK, Dc.prototype.delete = LK, Dc.prototype.get = MK, Dc.prototype.has = OK, Dc.prototype.set = BK;
        function yu(c) {
          var d = -1, p = c == null ? 0 : c.length;
          for (this.clear(); ++d < p; ) {
            var S = c[d];
            this.set(S[0], S[1]);
          }
        }
        function $K() {
          this.__data__ = [], this.size = 0;
        }
        function HK(c) {
          var d = this.__data__, p = zp(d, c);
          if (p < 0)
            return !1;
          var S = d.length - 1;
          return p == S ? d.pop() : $p.call(d, p, 1), --this.size, !0;
        }
        function UK(c) {
          var d = this.__data__, p = zp(d, c);
          return p < 0 ? n : d[p][1];
        }
        function GK(c) {
          return zp(this.__data__, c) > -1;
        }
        function WK(c, d) {
          var p = this.__data__, S = zp(p, c);
          return S < 0 ? (++this.size, p.push([c, d])) : p[S][1] = d, this;
        }
        yu.prototype.clear = $K, yu.prototype.delete = HK, yu.prototype.get = UK, yu.prototype.has = GK, yu.prototype.set = WK;
        function Au(c) {
          var d = -1, p = c == null ? 0 : c.length;
          for (this.clear(); ++d < p; ) {
            var S = c[d];
            this.set(S[0], S[1]);
          }
        }
        function VK() {
          this.size = 0, this.__data__ = {
            hash: new Dc(),
            map: new (Wf || yu)(),
            string: new Dc()
          };
        }
        function KK(c) {
          var d = i0(this, c).delete(c);
          return this.size -= d ? 1 : 0, d;
        }
        function zK(c) {
          return i0(this, c).get(c);
        }
        function jK(c) {
          return i0(this, c).has(c);
        }
        function YK(c, d) {
          var p = i0(this, c), S = p.size;
          return p.set(c, d), this.size += p.size == S ? 0 : 1, this;
        }
        Au.prototype.clear = VK, Au.prototype.delete = KK, Au.prototype.get = zK, Au.prototype.has = jK, Au.prototype.set = YK;
        function Ic(c) {
          var d = -1, p = c == null ? 0 : c.length;
          for (this.__data__ = new Au(); ++d < p; )
            this.add(c[d]);
        }
        function qK(c) {
          return this.__data__.set(c, u), this;
        }
        function JK(c) {
          return this.__data__.has(c);
        }
        Ic.prototype.add = Ic.prototype.push = qK, Ic.prototype.has = JK;
        function eo(c) {
          var d = this.__data__ = new yu(c);
          this.size = d.size;
        }
        function QK() {
          this.__data__ = new yu(), this.size = 0;
        }
        function XK(c) {
          var d = this.__data__, p = d.delete(c);
          return this.size = d.size, p;
        }
        function ZK(c) {
          return this.__data__.get(c);
        }
        function ez(c) {
          return this.__data__.has(c);
        }
        function tz(c, d) {
          var p = this.__data__;
          if (p instanceof yu) {
            var S = p.__data__;
            if (!Wf || S.length < i - 1)
              return S.push([c, d]), this.size = ++p.size, this;
            p = this.__data__ = new Au(S);
          }
          return p.set(c, d), this.size = p.size, this;
        }
        eo.prototype.clear = QK, eo.prototype.delete = XK, eo.prototype.get = ZK, eo.prototype.has = ez, eo.prototype.set = tz;
        function Yk(c, d) {
          var p = _t(c), S = !p && Oc(c), v = !p && !S && cl(c), R = !p && !S && !v && Jh(c), V = p || S || v || R, Y = V ? mE(c.length, hK) : [], ee = Y.length;
          for (var Ee in c)
            (d || Ln.call(c, Ee)) && !(V && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Ee == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            v && (Ee == "offset" || Ee == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            R && (Ee == "buffer" || Ee == "byteLength" || Ee == "byteOffset") || // Skip index properties.
            Fu(Ee, ee))) && Y.push(Ee);
          return Y;
        }
        function qk(c) {
          var d = c.length;
          return d ? c[DE(0, d - 1)] : n;
        }
        function nz(c, d) {
          return s0(Ss(c), Rc(d, 0, c.length));
        }
        function rz(c) {
          return s0(Ss(c));
        }
        function SE(c, d, p) {
          (p !== n && !to(c[d], p) || p === n && !(d in c)) && Eu(c, d, p);
        }
        function jf(c, d, p) {
          var S = c[d];
          (!(Ln.call(c, d) && to(S, p)) || p === n && !(d in c)) && Eu(c, d, p);
        }
        function zp(c, d) {
          for (var p = c.length; p--; )
            if (to(c[p][0], d))
              return p;
          return -1;
        }
        function iz(c, d, p, S) {
          return al(c, function(v, R, V) {
            d(S, v, p(v), V);
          }), S;
        }
        function Jk(c, d) {
          return c && Bo(d, pi(d), c);
        }
        function sz(c, d) {
          return c && Bo(d, Fs(d), c);
        }
        function Eu(c, d, p) {
          d == "__proto__" && Hp ? Hp(c, d, {
            configurable: !0,
            enumerable: !0,
            value: p,
            writable: !0
          }) : c[d] = p;
        }
        function wE(c, d) {
          for (var p = -1, S = d.length, v = ue(S), R = c == null; ++p < S; )
            v[p] = R ? n : nS(c, d[p]);
          return v;
        }
        function Rc(c, d, p) {
          return c === c && (p !== n && (c = c <= p ? c : p), d !== n && (c = c >= d ? c : d)), c;
        }
        function pa(c, d, p, S, v, R) {
          var V, Y = d & f, ee = d & m, Ee = d & g;
          if (p && (V = v ? p(c, S, v, R) : p(c)), V !== n)
            return V;
          if (!kr(c))
            return c;
          var Se = _t(c);
          if (Se) {
            if (V = jz(c), !Y)
              return Ss(c, V);
          } else {
            var Ce = Yi(c), Ve = Ce == Cr || Ce == ii;
            if (cl(c))
              return E_(c, Y);
            if (Ce == oe || Ce == Rn || Ve && !v) {
              if (V = ee || Ve ? {} : $_(c), !Y)
                return ee ? Mz(c, sz(V, c)) : Lz(c, Jk(V, c));
            } else {
              if (!ir[Ce])
                return v ? c : {};
              V = Yz(c, Ce, Y);
            }
          }
          R || (R = new eo());
          var Ze = R.get(c);
          if (Ze)
            return Ze;
          R.set(c, V), m3(c) ? c.forEach(function(gt) {
            V.add(pa(gt, d, p, gt, c, R));
          }) : d3(c) && c.forEach(function(gt, Jt) {
            V.set(Jt, pa(gt, d, p, Jt, c, R));
          });
          var mt = Ee ? ee ? GE : UE : ee ? Fs : pi, Ut = Se ? n : mt(c);
          return fa(Ut || c, function(gt, Jt) {
            Ut && (Jt = gt, gt = c[Jt]), jf(V, Jt, pa(gt, d, p, Jt, c, R));
          }), V;
        }
        function az(c) {
          var d = pi(c);
          return function(p) {
            return Qk(p, c, d);
          };
        }
        function Qk(c, d, p) {
          var S = p.length;
          if (c == null)
            return !S;
          for (c = Xn(c); S--; ) {
            var v = p[S], R = d[v], V = c[v];
            if (V === n && !(v in c) || !R(V))
              return !1;
          }
          return !0;
        }
        function Xk(c, d, p) {
          if (typeof c != "function")
            throw new ma(a);
          return em(function() {
            c.apply(n, p);
          }, d);
        }
        function Yf(c, d, p, S) {
          var v = -1, R = _p, V = !0, Y = c.length, ee = [], Ee = d.length;
          if (!Y)
            return ee;
          p && (d = Ar(d, zs(p))), S ? (R = uE, V = !1) : d.length >= i && (R = Uf, V = !1, d = new Ic(d));
          e:
            for (; ++v < Y; ) {
              var Se = c[v], Ce = p == null ? Se : p(Se);
              if (Se = S || Se !== 0 ? Se : 0, V && Ce === Ce) {
                for (var Ve = Ee; Ve--; )
                  if (d[Ve] === Ce)
                    continue e;
                ee.push(Se);
              } else R(d, Ce, S) || ee.push(Se);
            }
          return ee;
        }
        var al = v_(Oo), Zk = v_(TE, !0);
        function oz(c, d) {
          var p = !0;
          return al(c, function(S, v, R) {
            return p = !!d(S, v, R), p;
          }), p;
        }
        function jp(c, d, p) {
          for (var S = -1, v = c.length; ++S < v; ) {
            var R = c[S], V = d(R);
            if (V != null && (Y === n ? V === V && !Ys(V) : p(V, Y)))
              var Y = V, ee = R;
          }
          return ee;
        }
        function uz(c, d, p, S) {
          var v = c.length;
          for (p = $t(p), p < 0 && (p = -p > v ? 0 : v + p), S = S === n || S > v ? v : $t(S), S < 0 && (S += v), S = p > S ? 0 : p3(S); p < S; )
            c[p++] = d;
          return c;
        }
        function e_(c, d) {
          var p = [];
          return al(c, function(S, v, R) {
            d(S, v, R) && p.push(S);
          }), p;
        }
        function Li(c, d, p, S, v) {
          var R = -1, V = c.length;
          for (p || (p = Jz), v || (v = []); ++R < V; ) {
            var Y = c[R];
            d > 0 && p(Y) ? d > 1 ? Li(Y, d - 1, p, S, v) : rl(v, Y) : S || (v[v.length] = Y);
          }
          return v;
        }
        var FE = x_(), t_ = x_(!0);
        function Oo(c, d) {
          return c && FE(c, d, pi);
        }
        function TE(c, d) {
          return c && t_(c, d, pi);
        }
        function Yp(c, d) {
          return nl(d, function(p) {
            return Tu(c[p]);
          });
        }
        function Pc(c, d) {
          d = ul(d, c);
          for (var p = 0, S = d.length; c != null && p < S; )
            c = c[$o(d[p++])];
          return p && p == S ? c : n;
        }
        function n_(c, d, p) {
          var S = d(c);
          return _t(c) ? S : rl(S, p(c));
        }
        function ds(c) {
          return c == null ? c === n ? el : hs : Nc && Nc in Xn(c) ? Vz(c) : rj(c);
        }
        function vE(c, d) {
          return c > d;
        }
        function lz(c, d) {
          return c != null && Ln.call(c, d);
        }
        function cz(c, d) {
          return c != null && d in Xn(c);
        }
        function hz(c, d, p) {
          return c >= ji(d, p) && c < ai(d, p);
        }
        function xE(c, d, p) {
          for (var S = p ? uE : _p, v = c[0].length, R = c.length, V = R, Y = ue(R), ee = 1 / 0, Ee = []; V--; ) {
            var Se = c[V];
            V && d && (Se = Ar(Se, zs(d))), ee = ji(Se.length, ee), Y[V] = !p && (d || v >= 120 && Se.length >= 120) ? new Ic(V && Se) : n;
          }
          Se = c[0];
          var Ce = -1, Ve = Y[0];
          e:
            for (; ++Ce < v && Ee.length < ee; ) {
              var Ze = Se[Ce], mt = d ? d(Ze) : Ze;
              if (Ze = p || Ze !== 0 ? Ze : 0, !(Ve ? Uf(Ve, mt) : S(Ee, mt, p))) {
                for (V = R; --V; ) {
                  var Ut = Y[V];
                  if (!(Ut ? Uf(Ut, mt) : S(c[V], mt, p)))
                    continue e;
                }
                Ve && Ve.push(mt), Ee.push(Ze);
              }
            }
          return Ee;
        }
        function dz(c, d, p, S) {
          return Oo(c, function(v, R, V) {
            d(S, p(v), R, V);
          }), S;
        }
        function qf(c, d, p) {
          d = ul(d, c), c = W_(c, d);
          var S = c == null ? c : c[$o(ya(d))];
          return S == null ? n : Ks(S, c, p);
        }
        function r_(c) {
          return $r(c) && ds(c) == Rn;
        }
        function fz(c) {
          return $r(c) && ds(c) == tl;
        }
        function mz(c) {
          return $r(c) && ds(c) == qt;
        }
        function Jf(c, d, p, S, v) {
          return c === d ? !0 : c == null || d == null || !$r(c) && !$r(d) ? c !== c && d !== d : gz(c, d, p, S, Jf, v);
        }
        function gz(c, d, p, S, v, R) {
          var V = _t(c), Y = _t(d), ee = V ? Pn : Yi(c), Ee = Y ? Pn : Yi(d);
          ee = ee == Rn ? oe : ee, Ee = Ee == Rn ? oe : Ee;
          var Se = ee == oe, Ce = Ee == oe, Ve = ee == Ee;
          if (Ve && cl(c)) {
            if (!cl(d))
              return !1;
            V = !0, Se = !1;
          }
          if (Ve && !Se)
            return R || (R = new eo()), V || Jh(c) ? M_(c, d, p, S, v, R) : Gz(c, d, ee, p, S, v, R);
          if (!(p & A)) {
            var Ze = Se && Ln.call(c, "__wrapped__"), mt = Ce && Ln.call(d, "__wrapped__");
            if (Ze || mt) {
              var Ut = Ze ? c.value() : c, gt = mt ? d.value() : d;
              return R || (R = new eo()), v(Ut, gt, p, S, R);
            }
          }
          return Ve ? (R || (R = new eo()), Wz(c, d, p, S, v, R)) : !1;
        }
        function pz(c) {
          return $r(c) && Yi(c) == Hn;
        }
        function CE(c, d, p, S) {
          var v = p.length, R = v, V = !S;
          if (c == null)
            return !R;
          for (c = Xn(c); v--; ) {
            var Y = p[v];
            if (V && Y[2] ? Y[1] !== c[Y[0]] : !(Y[0] in c))
              return !1;
          }
          for (; ++v < R; ) {
            Y = p[v];
            var ee = Y[0], Ee = c[ee], Se = Y[1];
            if (V && Y[2]) {
              if (Ee === n && !(ee in c))
                return !1;
            } else {
              var Ce = new eo();
              if (S)
                var Ve = S(Ee, Se, ee, c, d, Ce);
              if (!(Ve === n ? Jf(Se, Ee, A | E, S, Ce) : Ve))
                return !1;
            }
          }
          return !0;
        }
        function i_(c) {
          if (!kr(c) || Xz(c))
            return !1;
          var d = Tu(c) ? pK : aV;
          return d.test(Mc(c));
        }
        function bz(c) {
          return $r(c) && ds(c) == rt;
        }
        function yz(c) {
          return $r(c) && Yi(c) == Ue;
        }
        function Az(c) {
          return $r(c) && h0(c.length) && !!hr[ds(c)];
        }
        function s_(c) {
          return typeof c == "function" ? c : c == null ? Ts : typeof c == "object" ? _t(c) ? u_(c[0], c[1]) : o_(c) : C3(c);
        }
        function kE(c) {
          if (!Zf(c))
            return wK(c);
          var d = [];
          for (var p in Xn(c))
            Ln.call(c, p) && p != "constructor" && d.push(p);
          return d;
        }
        function Ez(c) {
          if (!kr(c))
            return nj(c);
          var d = Zf(c), p = [];
          for (var S in c)
            S == "constructor" && (d || !Ln.call(c, S)) || p.push(S);
          return p;
        }
        function _E(c, d) {
          return c < d;
        }
        function a_(c, d) {
          var p = -1, S = ws(c) ? ue(c.length) : [];
          return al(c, function(v, R, V) {
            S[++p] = d(v, R, V);
          }), S;
        }
        function o_(c) {
          var d = VE(c);
          return d.length == 1 && d[0][2] ? U_(d[0][0], d[0][1]) : function(p) {
            return p === c || CE(p, c, d);
          };
        }
        function u_(c, d) {
          return zE(c) && H_(d) ? U_($o(c), d) : function(p) {
            var S = nS(p, c);
            return S === n && S === d ? rS(p, c) : Jf(d, S, A | E);
          };
        }
        function qp(c, d, p, S, v) {
          c !== d && FE(d, function(R, V) {
            if (v || (v = new eo()), kr(R))
              Sz(c, d, V, p, qp, S, v);
            else {
              var Y = S ? S(YE(c, V), R, V + "", c, d, v) : n;
              Y === n && (Y = R), SE(c, V, Y);
            }
          }, Fs);
        }
        function Sz(c, d, p, S, v, R, V) {
          var Y = YE(c, p), ee = YE(d, p), Ee = V.get(ee);
          if (Ee) {
            SE(c, p, Ee);
            return;
          }
          var Se = R ? R(Y, ee, p + "", c, d, V) : n, Ce = Se === n;
          if (Ce) {
            var Ve = _t(ee), Ze = !Ve && cl(ee), mt = !Ve && !Ze && Jh(ee);
            Se = ee, Ve || Ze || mt ? _t(Y) ? Se = Y : Vr(Y) ? Se = Ss(Y) : Ze ? (Ce = !1, Se = E_(ee, !0)) : mt ? (Ce = !1, Se = S_(ee, !0)) : Se = [] : tm(ee) || Oc(ee) ? (Se = Y, Oc(Y) ? Se = b3(Y) : (!kr(Y) || Tu(Y)) && (Se = $_(ee))) : Ce = !1;
          }
          Ce && (V.set(ee, Se), v(Se, ee, S, R, V), V.delete(ee)), SE(c, p, Se);
        }
        function l_(c, d) {
          var p = c.length;
          if (p)
            return d += d < 0 ? p : 0, Fu(d, p) ? c[d] : n;
        }
        function c_(c, d, p) {
          d.length ? d = Ar(d, function(R) {
            return _t(R) ? function(V) {
              return Pc(V, R.length === 1 ? R[0] : R);
            } : R;
          }) : d = [Ts];
          var S = -1;
          d = Ar(d, zs(ct()));
          var v = a_(c, function(R, V, Y) {
            var ee = Ar(d, function(Ee) {
              return Ee(R);
            });
            return { criteria: ee, index: ++S, value: R };
          });
          return YV(v, function(R, V) {
            return Pz(R, V, p);
          });
        }
        function wz(c, d) {
          return h_(c, d, function(p, S) {
            return rS(c, S);
          });
        }
        function h_(c, d, p) {
          for (var S = -1, v = d.length, R = {}; ++S < v; ) {
            var V = d[S], Y = Pc(c, V);
            p(Y, V) && Qf(R, ul(V, c), Y);
          }
          return R;
        }
        function Fz(c) {
          return function(d) {
            return Pc(d, c);
          };
        }
        function NE(c, d, p, S) {
          var v = S ? jV : $h, R = -1, V = d.length, Y = c;
          for (c === d && (d = Ss(d)), p && (Y = Ar(c, zs(p))); ++R < V; )
            for (var ee = 0, Ee = d[R], Se = p ? p(Ee) : Ee; (ee = v(Y, Se, ee, S)) > -1; )
              Y !== c && $p.call(Y, ee, 1), $p.call(c, ee, 1);
          return c;
        }
        function d_(c, d) {
          for (var p = c ? d.length : 0, S = p - 1; p--; ) {
            var v = d[p];
            if (p == S || v !== R) {
              var R = v;
              Fu(v) ? $p.call(c, v, 1) : PE(c, v);
            }
          }
          return c;
        }
        function DE(c, d) {
          return c + Gp(zk() * (d - c + 1));
        }
        function Tz(c, d, p, S) {
          for (var v = -1, R = ai(Up((d - c) / (p || 1)), 0), V = ue(R); R--; )
            V[S ? R : ++v] = c, c += p;
          return V;
        }
        function IE(c, d) {
          var p = "";
          if (!c || d < 1 || d > te)
            return p;
          do
            d % 2 && (p += c), d = Gp(d / 2), d && (c += c);
          while (d);
          return p;
        }
        function Wt(c, d) {
          return qE(G_(c, d, Ts), c + "");
        }
        function vz(c) {
          return qk(Qh(c));
        }
        function xz(c, d) {
          var p = Qh(c);
          return s0(p, Rc(d, 0, p.length));
        }
        function Qf(c, d, p, S) {
          if (!kr(c))
            return c;
          d = ul(d, c);
          for (var v = -1, R = d.length, V = R - 1, Y = c; Y != null && ++v < R; ) {
            var ee = $o(d[v]), Ee = p;
            if (ee === "__proto__" || ee === "constructor" || ee === "prototype")
              return c;
            if (v != V) {
              var Se = Y[ee];
              Ee = S ? S(Se, ee, Y) : n, Ee === n && (Ee = kr(Se) ? Se : Fu(d[v + 1]) ? [] : {});
            }
            jf(Y, ee, Ee), Y = Y[ee];
          }
          return c;
        }
        var f_ = Wp ? function(c, d) {
          return Wp.set(c, d), c;
        } : Ts, Cz = Hp ? function(c, d) {
          return Hp(c, "toString", {
            configurable: !0,
            enumerable: !1,
            value: sS(d),
            writable: !0
          });
        } : Ts;
        function kz(c) {
          return s0(Qh(c));
        }
        function ba(c, d, p) {
          var S = -1, v = c.length;
          d < 0 && (d = -d > v ? 0 : v + d), p = p > v ? v : p, p < 0 && (p += v), v = d > p ? 0 : p - d >>> 0, d >>>= 0;
          for (var R = ue(v); ++S < v; )
            R[S] = c[S + d];
          return R;
        }
        function _z(c, d) {
          var p;
          return al(c, function(S, v, R) {
            return p = d(S, v, R), !p;
          }), !!p;
        }
        function Jp(c, d, p) {
          var S = 0, v = c == null ? S : c.length;
          if (typeof d == "number" && d === d && v <= fn) {
            for (; S < v; ) {
              var R = S + v >>> 1, V = c[R];
              V !== null && !Ys(V) && (p ? V <= d : V < d) ? S = R + 1 : v = R;
            }
            return v;
          }
          return RE(c, d, Ts, p);
        }
        function RE(c, d, p, S) {
          var v = 0, R = c == null ? 0 : c.length;
          if (R === 0)
            return 0;
          d = p(d);
          for (var V = d !== d, Y = d === null, ee = Ys(d), Ee = d === n; v < R; ) {
            var Se = Gp((v + R) / 2), Ce = p(c[Se]), Ve = Ce !== n, Ze = Ce === null, mt = Ce === Ce, Ut = Ys(Ce);
            if (V)
              var gt = S || mt;
            else Ee ? gt = mt && (S || Ve) : Y ? gt = mt && Ve && (S || !Ze) : ee ? gt = mt && Ve && !Ze && (S || !Ut) : Ze || Ut ? gt = !1 : gt = S ? Ce <= d : Ce < d;
            gt ? v = Se + 1 : R = Se;
          }
          return ji(R, Le);
        }
        function m_(c, d) {
          for (var p = -1, S = c.length, v = 0, R = []; ++p < S; ) {
            var V = c[p], Y = d ? d(V) : V;
            if (!p || !to(Y, ee)) {
              var ee = Y;
              R[v++] = V === 0 ? 0 : V;
            }
          }
          return R;
        }
        function g_(c) {
          return typeof c == "number" ? c : Ys(c) ? We : +c;
        }
        function js(c) {
          if (typeof c == "string")
            return c;
          if (_t(c))
            return Ar(c, js) + "";
          if (Ys(c))
            return jk ? jk.call(c) : "";
          var d = c + "";
          return d == "0" && 1 / c == -ie ? "-0" : d;
        }
        function ol(c, d, p) {
          var S = -1, v = _p, R = c.length, V = !0, Y = [], ee = Y;
          if (p)
            V = !1, v = uE;
          else if (R >= i) {
            var Ee = d ? null : Hz(c);
            if (Ee)
              return Dp(Ee);
            V = !1, v = Uf, ee = new Ic();
          } else
            ee = d ? [] : Y;
          e:
            for (; ++S < R; ) {
              var Se = c[S], Ce = d ? d(Se) : Se;
              if (Se = p || Se !== 0 ? Se : 0, V && Ce === Ce) {
                for (var Ve = ee.length; Ve--; )
                  if (ee[Ve] === Ce)
                    continue e;
                d && ee.push(Ce), Y.push(Se);
              } else v(ee, Ce, p) || (ee !== Y && ee.push(Ce), Y.push(Se));
            }
          return Y;
        }
        function PE(c, d) {
          d = ul(d, c);
          var p = -1, S = d.length;
          if (!S)
            return !0;
          for (var v = c == null || typeof c != "object" && typeof c != "function"; ++p < S; ) {
            var R = d[p];
            if (typeof R == "string") {
              if (R === "__proto__" && !Ln.call(c, "__proto__"))
                return !1;
              if (R === "constructor" && p + 1 < S && typeof d[p + 1] == "string" && d[p + 1] === "prototype") {
                if (v && p === 0)
                  continue;
                return !1;
              }
            }
          }
          var V = W_(c, d);
          return V == null || delete V[$o(ya(d))];
        }
        function p_(c, d, p, S) {
          return Qf(c, d, p(Pc(c, d)), S);
        }
        function Qp(c, d, p, S) {
          for (var v = c.length, R = S ? v : -1; (S ? R-- : ++R < v) && d(c[R], R, c); )
            ;
          return p ? ba(c, S ? 0 : R, S ? R + 1 : v) : ba(c, S ? R + 1 : 0, S ? v : R);
        }
        function b_(c, d) {
          var p = c;
          return p instanceof sn && (p = p.value()), lE(d, function(S, v) {
            return v.func.apply(v.thisArg, rl([S], v.args));
          }, p);
        }
        function LE(c, d, p) {
          var S = c.length;
          if (S < 2)
            return S ? ol(c[0]) : [];
          for (var v = -1, R = ue(S); ++v < S; )
            for (var V = c[v], Y = -1; ++Y < S; )
              Y != v && (R[v] = Yf(R[v] || V, c[Y], d, p));
          return ol(Li(R, 1), d, p);
        }
        function y_(c, d, p) {
          for (var S = -1, v = c.length, R = d.length, V = {}; ++S < v; ) {
            var Y = S < R ? d[S] : n;
            p(V, c[S], Y);
          }
          return V;
        }
        function ME(c) {
          return Vr(c) ? c : [];
        }
        function OE(c) {
          return typeof c == "function" ? c : Ts;
        }
        function ul(c, d) {
          return _t(c) ? c : zE(c, d) ? [c] : j_(Mn(c));
        }
        var Nz = Wt;
        function ll(c, d, p) {
          var S = c.length;
          return p = p === n ? S : p, !d && p >= S ? c : ba(c, d, p);
        }
        var A_ = bK || function(c) {
          return Pi.clearTimeout(c);
        };
        function E_(c, d) {
          if (d)
            return c.slice();
          var p = c.length, S = Uk ? Uk(p) : new c.constructor(p);
          return c.copy(S), S;
        }
        function BE(c) {
          var d = new c.constructor(c.byteLength);
          return new Op(d).set(new Op(c)), d;
        }
        function Dz(c, d) {
          var p = d ? BE(c.buffer) : c.buffer;
          return new c.constructor(p, c.byteOffset, c.byteLength);
        }
        function Iz(c) {
          var d = new c.constructor(c.source, rk.exec(c));
          return d.lastIndex = c.lastIndex, d;
        }
        function Rz(c) {
          return zf ? Xn(zf.call(c)) : {};
        }
        function S_(c, d) {
          var p = d ? BE(c.buffer) : c.buffer;
          return new c.constructor(p, c.byteOffset, c.length);
        }
        function w_(c, d) {
          if (c !== d) {
            var p = c !== n, S = c === null, v = c === c, R = Ys(c), V = d !== n, Y = d === null, ee = d === d, Ee = Ys(d);
            if (!Y && !Ee && !R && c > d || R && V && ee && !Y && !Ee || S && V && ee || !p && ee || !v)
              return 1;
            if (!S && !R && !Ee && c < d || Ee && p && v && !S && !R || Y && p && v || !V && v || !ee)
              return -1;
          }
          return 0;
        }
        function Pz(c, d, p) {
          for (var S = -1, v = c.criteria, R = d.criteria, V = v.length, Y = p.length; ++S < V; ) {
            var ee = w_(v[S], R[S]);
            if (ee) {
              if (S >= Y)
                return ee;
              var Ee = p[S];
              return ee * (Ee == "desc" ? -1 : 1);
            }
          }
          return c.index - d.index;
        }
        function F_(c, d, p, S) {
          for (var v = -1, R = c.length, V = p.length, Y = -1, ee = d.length, Ee = ai(R - V, 0), Se = ue(ee + Ee), Ce = !S; ++Y < ee; )
            Se[Y] = d[Y];
          for (; ++v < V; )
            (Ce || v < R) && (Se[p[v]] = c[v]);
          for (; Ee--; )
            Se[Y++] = c[v++];
          return Se;
        }
        function T_(c, d, p, S) {
          for (var v = -1, R = c.length, V = -1, Y = p.length, ee = -1, Ee = d.length, Se = ai(R - Y, 0), Ce = ue(Se + Ee), Ve = !S; ++v < Se; )
            Ce[v] = c[v];
          for (var Ze = v; ++ee < Ee; )
            Ce[Ze + ee] = d[ee];
          for (; ++V < Y; )
            (Ve || v < R) && (Ce[Ze + p[V]] = c[v++]);
          return Ce;
        }
        function Ss(c, d) {
          var p = -1, S = c.length;
          for (d || (d = ue(S)); ++p < S; )
            d[p] = c[p];
          return d;
        }
        function Bo(c, d, p, S) {
          var v = !p;
          p || (p = {});
          for (var R = -1, V = d.length; ++R < V; ) {
            var Y = d[R], ee = S ? S(p[Y], c[Y], Y, p, c) : n;
            ee === n && (ee = c[Y]), v ? Eu(p, Y, ee) : jf(p, Y, ee);
          }
          return p;
        }
        function Lz(c, d) {
          return Bo(c, KE(c), d);
        }
        function Mz(c, d) {
          return Bo(c, O_(c), d);
        }
        function Xp(c, d) {
          return function(p, S) {
            var v = _t(p) ? UV : iz, R = d ? d() : {};
            return v(p, c, ct(S, 2), R);
          };
        }
        function jh(c) {
          return Wt(function(d, p) {
            var S = -1, v = p.length, R = v > 1 ? p[v - 1] : n, V = v > 2 ? p[2] : n;
            for (R = c.length > 3 && typeof R == "function" ? (v--, R) : n, V && fs(p[0], p[1], V) && (R = v < 3 ? n : R, v = 1), d = Xn(d); ++S < v; ) {
              var Y = p[S];
              Y && c(d, Y, S, R);
            }
            return d;
          });
        }
        function v_(c, d) {
          return function(p, S) {
            if (p == null)
              return p;
            if (!ws(p))
              return c(p, S);
            for (var v = p.length, R = d ? v : -1, V = Xn(p); (d ? R-- : ++R < v) && S(V[R], R, V) !== !1; )
              ;
            return p;
          };
        }
        function x_(c) {
          return function(d, p, S) {
            for (var v = -1, R = Xn(d), V = S(d), Y = V.length; Y--; ) {
              var ee = V[c ? Y : ++v];
              if (p(R[ee], ee, R) === !1)
                break;
            }
            return d;
          };
        }
        function Oz(c, d, p) {
          var S = d & w, v = Xf(c);
          function R() {
            var V = this && this !== Pi && this instanceof R ? v : c;
            return V.apply(S ? p : this, arguments);
          }
          return R;
        }
        function C_(c) {
          return function(d) {
            d = Mn(d);
            var p = Hh(d) ? Za(d) : n, S = p ? p[0] : d.charAt(0), v = p ? ll(p, 1).join("") : d.slice(1);
            return S[c]() + v;
          };
        }
        function Yh(c) {
          return function(d) {
            return lE(v3(T3(d).replace(CV, "")), c, "");
          };
        }
        function Xf(c) {
          return function() {
            var d = arguments;
            switch (d.length) {
              case 0:
                return new c();
              case 1:
                return new c(d[0]);
              case 2:
                return new c(d[0], d[1]);
              case 3:
                return new c(d[0], d[1], d[2]);
              case 4:
                return new c(d[0], d[1], d[2], d[3]);
              case 5:
                return new c(d[0], d[1], d[2], d[3], d[4]);
              case 6:
                return new c(d[0], d[1], d[2], d[3], d[4], d[5]);
              case 7:
                return new c(d[0], d[1], d[2], d[3], d[4], d[5], d[6]);
            }
            var p = zh(c.prototype), S = c.apply(p, d);
            return kr(S) ? S : p;
          };
        }
        function Bz(c, d, p) {
          var S = Xf(c);
          function v() {
            for (var R = arguments.length, V = ue(R), Y = R, ee = qh(v); Y--; )
              V[Y] = arguments[Y];
            var Ee = R < 3 && V[0] !== ee && V[R - 1] !== ee ? [] : il(V, ee);
            if (R -= Ee.length, R < p)
              return I_(
                c,
                d,
                Zp,
                v.placeholder,
                n,
                V,
                Ee,
                n,
                n,
                p - R
              );
            var Se = this && this !== Pi && this instanceof v ? S : c;
            return Ks(Se, this, V);
          }
          return v;
        }
        function k_(c) {
          return function(d, p, S) {
            var v = Xn(d);
            if (!ws(d)) {
              var R = ct(p, 3);
              d = pi(d), p = function(Y) {
                return R(v[Y], Y, v);
              };
            }
            var V = c(d, p, S);
            return V > -1 ? v[R ? d[V] : V] : n;
          };
        }
        function __(c) {
          return wu(function(d) {
            var p = d.length, S = p, v = ga.prototype.thru;
            for (c && d.reverse(); S--; ) {
              var R = d[S];
              if (typeof R != "function")
                throw new ma(a);
              if (v && !V && r0(R) == "wrapper")
                var V = new ga([], !0);
            }
            for (S = V ? S : p; ++S < p; ) {
              R = d[S];
              var Y = r0(R), ee = Y == "wrapper" ? WE(R) : n;
              ee && jE(ee[0]) && ee[1] == (L | B | C | k) && !ee[4].length && ee[9] == 1 ? V = V[r0(ee[0])].apply(V, ee[3]) : V = R.length == 1 && jE(R) ? V[Y]() : V.thru(R);
            }
            return function() {
              var Ee = arguments, Se = Ee[0];
              if (V && Ee.length == 1 && _t(Se))
                return V.plant(Se).value();
              for (var Ce = 0, Ve = p ? d[Ce].apply(this, Ee) : Se; ++Ce < p; )
                Ve = d[Ce].call(this, Ve);
              return Ve;
            };
          });
        }
        function Zp(c, d, p, S, v, R, V, Y, ee, Ee) {
          var Se = d & L, Ce = d & w, Ve = d & x, Ze = d & (B | P), mt = d & I, Ut = Ve ? n : Xf(c);
          function gt() {
            for (var Jt = arguments.length, mn = ue(Jt), qs = Jt; qs--; )
              mn[qs] = arguments[qs];
            if (Ze)
              var ms = qh(gt), Js = JV(mn, ms);
            if (S && (mn = F_(mn, S, v, Ze)), R && (mn = T_(mn, R, V, Ze)), Jt -= Js, Ze && Jt < Ee) {
              var Kr = il(mn, ms);
              return I_(
                c,
                d,
                Zp,
                gt.placeholder,
                p,
                mn,
                Kr,
                Y,
                ee,
                Ee - Jt
              );
            }
            var no = Ce ? p : this, xu = Ve ? no[c] : c;
            return Jt = mn.length, Y ? mn = ij(mn, Y) : mt && Jt > 1 && mn.reverse(), Se && ee < Jt && (mn.length = ee), this && this !== Pi && this instanceof gt && (xu = Ut || Xf(xu)), xu.apply(no, mn);
          }
          return gt;
        }
        function N_(c, d) {
          return function(p, S) {
            return dz(p, c, d(S), {});
          };
        }
        function e0(c, d) {
          return function(p, S) {
            var v;
            if (p === n && S === n)
              return d;
            if (p !== n && (v = p), S !== n) {
              if (v === n)
                return S;
              typeof p == "string" || typeof S == "string" ? (p = js(p), S = js(S)) : (p = g_(p), S = g_(S)), v = c(p, S);
            }
            return v;
          };
        }
        function $E(c) {
          return wu(function(d) {
            return d = Ar(d, zs(ct())), Wt(function(p) {
              var S = this;
              return c(d, function(v) {
                return Ks(v, S, p);
              });
            });
          });
        }
        function t0(c, d) {
          d = d === n ? " " : js(d);
          var p = d.length;
          if (p < 2)
            return p ? IE(d, c) : d;
          var S = IE(d, Up(c / Uh(d)));
          return Hh(d) ? ll(Za(S), 0, c).join("") : S.slice(0, c);
        }
        function $z(c, d, p, S) {
          var v = d & w, R = Xf(c);
          function V() {
            for (var Y = -1, ee = arguments.length, Ee = -1, Se = S.length, Ce = ue(Se + ee), Ve = this && this !== Pi && this instanceof V ? R : c; ++Ee < Se; )
              Ce[Ee] = S[Ee];
            for (; ee--; )
              Ce[Ee++] = arguments[++Y];
            return Ks(Ve, v ? p : this, Ce);
          }
          return V;
        }
        function D_(c) {
          return function(d, p, S) {
            return S && typeof S != "number" && fs(d, p, S) && (p = S = n), d = vu(d), p === n ? (p = d, d = 0) : p = vu(p), S = S === n ? d < p ? 1 : -1 : vu(S), Tz(d, p, S, c);
          };
        }
        function n0(c) {
          return function(d, p) {
            return typeof d == "string" && typeof p == "string" || (d = Aa(d), p = Aa(p)), c(d, p);
          };
        }
        function I_(c, d, p, S, v, R, V, Y, ee, Ee) {
          var Se = d & B, Ce = Se ? V : n, Ve = Se ? n : V, Ze = Se ? R : n, mt = Se ? n : R;
          d |= Se ? C : D, d &= ~(Se ? D : C), d & N || (d &= -4);
          var Ut = [
            c,
            d,
            v,
            Ze,
            Ce,
            mt,
            Ve,
            Y,
            ee,
            Ee
          ], gt = p.apply(n, Ut);
          return jE(c) && V_(gt, Ut), gt.placeholder = S, K_(gt, c, d);
        }
        function HE(c) {
          var d = si[c];
          return function(p, S) {
            if (p = Aa(p), S = S == null ? 0 : ji($t(S), 292), S && Kk(p)) {
              var v = (Mn(p) + "e").split("e"), R = d(v[0] + "e" + (+v[1] + S));
              return v = (Mn(R) + "e").split("e"), +(v[0] + "e" + (+v[1] - S));
            }
            return d(p);
          };
        }
        var Hz = Vh && 1 / Dp(new Vh([, -0]))[1] == ie ? function(c) {
          return new Vh(c);
        } : uS;
        function R_(c) {
          return function(d) {
            var p = Yi(d);
            return p == Hn ? pE(d) : p == Ue ? rK(d) : qV(d, c(d));
          };
        }
        function Su(c, d, p, S, v, R, V, Y) {
          var ee = d & x;
          if (!ee && typeof c != "function")
            throw new ma(a);
          var Ee = S ? S.length : 0;
          if (Ee || (d &= -97, S = v = n), V = V === n ? V : ai($t(V), 0), Y = Y === n ? Y : $t(Y), Ee -= v ? v.length : 0, d & D) {
            var Se = S, Ce = v;
            S = v = n;
          }
          var Ve = ee ? n : WE(c), Ze = [
            c,
            d,
            p,
            S,
            v,
            Se,
            Ce,
            R,
            V,
            Y
          ];
          if (Ve && tj(Ze, Ve), c = Ze[0], d = Ze[1], p = Ze[2], S = Ze[3], v = Ze[4], Y = Ze[9] = Ze[9] === n ? ee ? 0 : c.length : ai(Ze[9] - Ee, 0), !Y && d & (B | P) && (d &= -25), !d || d == w)
            var mt = Oz(c, d, p);
          else d == B || d == P ? mt = Bz(c, d, Y) : (d == C || d == (w | C)) && !v.length ? mt = $z(c, d, p, S) : mt = Zp.apply(n, Ze);
          var Ut = Ve ? f_ : V_;
          return K_(Ut(mt, Ze), c, d);
        }
        function P_(c, d, p, S) {
          return c === n || to(c, Wh[p]) && !Ln.call(S, p) ? d : c;
        }
        function L_(c, d, p, S, v, R) {
          return kr(c) && kr(d) && (R.set(d, c), qp(c, d, n, L_, R), R.delete(d)), c;
        }
        function Uz(c) {
          return tm(c) ? n : c;
        }
        function M_(c, d, p, S, v, R) {
          var V = p & A, Y = c.length, ee = d.length;
          if (Y != ee && !(V && ee > Y))
            return !1;
          var Ee = R.get(c), Se = R.get(d);
          if (Ee && Se)
            return Ee == d && Se == c;
          var Ce = -1, Ve = !0, Ze = p & E ? new Ic() : n;
          for (R.set(c, d), R.set(d, c); ++Ce < Y; ) {
            var mt = c[Ce], Ut = d[Ce];
            if (S)
              var gt = V ? S(Ut, mt, Ce, d, c, R) : S(mt, Ut, Ce, c, d, R);
            if (gt !== n) {
              if (gt)
                continue;
              Ve = !1;
              break;
            }
            if (Ze) {
              if (!cE(d, function(Jt, mn) {
                if (!Uf(Ze, mn) && (mt === Jt || v(mt, Jt, p, S, R)))
                  return Ze.push(mn);
              })) {
                Ve = !1;
                break;
              }
            } else if (!(mt === Ut || v(mt, Ut, p, S, R))) {
              Ve = !1;
              break;
            }
          }
          return R.delete(c), R.delete(d), Ve;
        }
        function Gz(c, d, p, S, v, R, V) {
          switch (p) {
            case mu:
              if (c.byteLength != d.byteLength || c.byteOffset != d.byteOffset)
                return !1;
              c = c.buffer, d = d.buffer;
            case tl:
              return !(c.byteLength != d.byteLength || !R(new Op(c), new Op(d)));
            case Tn:
            case qt:
            case cs:
              return to(+c, +d);
            case $n:
              return c.name == d.name && c.message == d.message;
            case rt:
            case rn:
              return c == d + "";
            case Hn:
              var Y = pE;
            case Ue:
              var ee = S & A;
              if (Y || (Y = Dp), c.size != d.size && !ee)
                return !1;
              var Ee = V.get(c);
              if (Ee)
                return Ee == d;
              S |= E, V.set(c, d);
              var Se = M_(Y(c), Y(d), S, v, R, V);
              return V.delete(c), Se;
            case Vs:
              if (zf)
                return zf.call(c) == zf.call(d);
          }
          return !1;
        }
        function Wz(c, d, p, S, v, R) {
          var V = p & A, Y = UE(c), ee = Y.length, Ee = UE(d), Se = Ee.length;
          if (ee != Se && !V)
            return !1;
          for (var Ce = ee; Ce--; ) {
            var Ve = Y[Ce];
            if (!(V ? Ve in d : Ln.call(d, Ve)))
              return !1;
          }
          var Ze = R.get(c), mt = R.get(d);
          if (Ze && mt)
            return Ze == d && mt == c;
          var Ut = !0;
          R.set(c, d), R.set(d, c);
          for (var gt = V; ++Ce < ee; ) {
            Ve = Y[Ce];
            var Jt = c[Ve], mn = d[Ve];
            if (S)
              var qs = V ? S(mn, Jt, Ve, d, c, R) : S(Jt, mn, Ve, c, d, R);
            if (!(qs === n ? Jt === mn || v(Jt, mn, p, S, R) : qs)) {
              Ut = !1;
              break;
            }
            gt || (gt = Ve == "constructor");
          }
          if (Ut && !gt) {
            var ms = c.constructor, Js = d.constructor;
            ms != Js && "constructor" in c && "constructor" in d && !(typeof ms == "function" && ms instanceof ms && typeof Js == "function" && Js instanceof Js) && (Ut = !1);
          }
          return R.delete(c), R.delete(d), Ut;
        }
        function wu(c) {
          return qE(G_(c, n, Q_), c + "");
        }
        function UE(c) {
          return n_(c, pi, KE);
        }
        function GE(c) {
          return n_(c, Fs, O_);
        }
        var WE = Wp ? function(c) {
          return Wp.get(c);
        } : uS;
        function r0(c) {
          for (var d = c.name + "", p = Kh[d], S = Ln.call(Kh, d) ? p.length : 0; S--; ) {
            var v = p[S], R = v.func;
            if (R == null || R == c)
              return v.name;
          }
          return d;
        }
        function qh(c) {
          var d = Ln.call(_, "placeholder") ? _ : c;
          return d.placeholder;
        }
        function ct() {
          var c = _.iteratee || aS;
          return c = c === aS ? s_ : c, arguments.length ? c(arguments[0], arguments[1]) : c;
        }
        function i0(c, d) {
          var p = c.__data__;
          return Qz(d) ? p[typeof d == "string" ? "string" : "hash"] : p.map;
        }
        function VE(c) {
          for (var d = pi(c), p = d.length; p--; ) {
            var S = d[p], v = c[S];
            d[p] = [S, v, H_(v)];
          }
          return d;
        }
        function Lc(c, d) {
          var p = eK(c, d);
          return i_(p) ? p : n;
        }
        function Vz(c) {
          var d = Ln.call(c, Nc), p = c[Nc];
          try {
            c[Nc] = n;
            var S = !0;
          } catch {
          }
          var v = Lp.call(c);
          return S && (d ? c[Nc] = p : delete c[Nc]), v;
        }
        var KE = yE ? function(c) {
          return c == null ? [] : (c = Xn(c), nl(yE(c), function(d) {
            return Wk.call(c, d);
          }));
        } : lS, O_ = yE ? function(c) {
          for (var d = []; c; )
            rl(d, KE(c)), c = Bp(c);
          return d;
        } : lS, Yi = ds;
        (AE && Yi(new AE(new ArrayBuffer(1))) != mu || Wf && Yi(new Wf()) != Hn || EE && Yi(EE.resolve()) != Te || Vh && Yi(new Vh()) != Ue || Vf && Yi(new Vf()) != Xa) && (Yi = function(c) {
          var d = ds(c), p = d == oe ? c.constructor : n, S = p ? Mc(p) : "";
          if (S)
            switch (S) {
              case xK:
                return mu;
              case CK:
                return Hn;
              case kK:
                return Te;
              case _K:
                return Ue;
              case NK:
                return Xa;
            }
          return d;
        });
        function Kz(c, d, p) {
          for (var S = -1, v = p.length; ++S < v; ) {
            var R = p[S], V = R.size;
            switch (R.type) {
              case "drop":
                c += V;
                break;
              case "dropRight":
                d -= V;
                break;
              case "take":
                d = ji(d, c + V);
                break;
              case "takeRight":
                c = ai(c, d - V);
                break;
            }
          }
          return { start: c, end: d };
        }
        function zz(c) {
          var d = c.match(XW);
          return d ? d[1].split(ZW) : [];
        }
        function B_(c, d, p) {
          d = ul(d, c);
          for (var S = -1, v = d.length, R = !1; ++S < v; ) {
            var V = $o(d[S]);
            if (!(R = c != null && p(c, V)))
              break;
            c = c[V];
          }
          return R || ++S != v ? R : (v = c == null ? 0 : c.length, !!v && h0(v) && Fu(V, v) && (_t(c) || Oc(c)));
        }
        function jz(c) {
          var d = c.length, p = new c.constructor(d);
          return d && typeof c[0] == "string" && Ln.call(c, "index") && (p.index = c.index, p.input = c.input), p;
        }
        function $_(c) {
          return typeof c.constructor == "function" && !Zf(c) ? zh(Bp(c)) : {};
        }
        function Yz(c, d, p) {
          var S = c.constructor;
          switch (d) {
            case tl:
              return BE(c);
            case Tn:
            case qt:
              return new S(+c);
            case mu:
              return Dz(c, p);
            case gu:
            case pu:
            case Br:
            case bn:
            case gi:
            case Lo:
            case bu:
            case Mh:
            case Mo:
              return S_(c, p);
            case Hn:
              return new S();
            case cs:
            case rn:
              return new S(c);
            case rt:
              return Iz(c);
            case Ue:
              return new S();
            case Vs:
              return Rz(c);
          }
        }
        function qz(c, d) {
          var p = d.length;
          if (!p)
            return c;
          var S = p - 1;
          return d[S] = (p > 1 ? "& " : "") + d[S], d = d.join(p > 2 ? ", " : " "), c.replace(QW, `{
/* [wrapped with ` + d + `] */
`);
        }
        function Jz(c) {
          return _t(c) || Oc(c) || !!(Vk && c && c[Vk]);
        }
        function Fu(c, d) {
          var p = typeof c;
          return d = d ?? te, !!d && (p == "number" || p != "symbol" && uV.test(c)) && c > -1 && c % 1 == 0 && c < d;
        }
        function fs(c, d, p) {
          if (!kr(p))
            return !1;
          var S = typeof d;
          return (S == "number" ? ws(p) && Fu(d, p.length) : S == "string" && d in p) ? to(p[d], c) : !1;
        }
        function zE(c, d) {
          if (_t(c))
            return !1;
          var p = typeof c;
          return p == "number" || p == "symbol" || p == "boolean" || c == null || Ys(c) ? !0 : jW.test(c) || !zW.test(c) || d != null && c in Xn(d);
        }
        function Qz(c) {
          var d = typeof c;
          return d == "string" || d == "number" || d == "symbol" || d == "boolean" ? c !== "__proto__" : c === null;
        }
        function jE(c) {
          var d = r0(c), p = _[d];
          if (typeof p != "function" || !(d in sn.prototype))
            return !1;
          if (c === p)
            return !0;
          var S = WE(p);
          return !!S && c === S[0];
        }
        function Xz(c) {
          return !!Hk && Hk in c;
        }
        var Zz = Rp ? Tu : cS;
        function Zf(c) {
          var d = c && c.constructor, p = typeof d == "function" && d.prototype || Wh;
          return c === p;
        }
        function H_(c) {
          return c === c && !kr(c);
        }
        function U_(c, d) {
          return function(p) {
            return p == null ? !1 : p[c] === d && (d !== n || c in Xn(p));
          };
        }
        function ej(c) {
          var d = l0(c, function(S) {
            return p.size === l && p.clear(), S;
          }), p = d.cache;
          return d;
        }
        function tj(c, d) {
          var p = c[1], S = d[1], v = p | S, R = v < (w | x | L), V = S == L && p == B || S == L && p == k && c[7].length <= d[8] || S == (L | k) && d[7].length <= d[8] && p == B;
          if (!(R || V))
            return c;
          S & w && (c[2] = d[2], v |= p & w ? 0 : N);
          var Y = d[3];
          if (Y) {
            var ee = c[3];
            c[3] = ee ? F_(ee, Y, d[4]) : Y, c[4] = ee ? il(c[3], h) : d[4];
          }
          return Y = d[5], Y && (ee = c[5], c[5] = ee ? T_(ee, Y, d[6]) : Y, c[6] = ee ? il(c[5], h) : d[6]), Y = d[7], Y && (c[7] = Y), S & L && (c[8] = c[8] == null ? d[8] : ji(c[8], d[8])), c[9] == null && (c[9] = d[9]), c[0] = d[0], c[1] = v, c;
        }
        function nj(c) {
          var d = [];
          if (c != null)
            for (var p in Xn(c))
              d.push(p);
          return d;
        }
        function rj(c) {
          return Lp.call(c);
        }
        function G_(c, d, p) {
          return d = ai(d === n ? c.length - 1 : d, 0), function() {
            for (var S = arguments, v = -1, R = ai(S.length - d, 0), V = ue(R); ++v < R; )
              V[v] = S[d + v];
            v = -1;
            for (var Y = ue(d + 1); ++v < d; )
              Y[v] = S[v];
            return Y[d] = p(V), Ks(c, this, Y);
          };
        }
        function W_(c, d) {
          return d.length < 2 ? c : Pc(c, ba(d, 0, -1));
        }
        function ij(c, d) {
          for (var p = c.length, S = ji(d.length, p), v = Ss(c); S--; ) {
            var R = d[S];
            c[S] = Fu(R, p) ? v[R] : n;
          }
          return c;
        }
        function YE(c, d) {
          if (!(d === "constructor" && typeof c[d] == "function") && d != "__proto__")
            return c[d];
        }
        var V_ = z_(f_), em = AK || function(c, d) {
          return Pi.setTimeout(c, d);
        }, qE = z_(Cz);
        function K_(c, d, p) {
          var S = d + "";
          return qE(c, qz(S, sj(zz(S), p)));
        }
        function z_(c) {
          var d = 0, p = 0;
          return function() {
            var S = FK(), v = G - (S - p);
            if (p = S, v > 0) {
              if (++d >= J)
                return arguments[0];
            } else
              d = 0;
            return c.apply(n, arguments);
          };
        }
        function s0(c, d) {
          var p = -1, S = c.length, v = S - 1;
          for (d = d === n ? S : d; ++p < d; ) {
            var R = DE(p, v), V = c[R];
            c[R] = c[p], c[p] = V;
          }
          return c.length = d, c;
        }
        var j_ = ej(function(c) {
          var d = [];
          return c.charCodeAt(0) === 46 && d.push(""), c.replace(YW, function(p, S, v, R) {
            d.push(v ? R.replace(nV, "$1") : S || p);
          }), d;
        });
        function $o(c) {
          if (typeof c == "string" || Ys(c))
            return c;
          var d = c + "";
          return d == "0" && 1 / c == -ie ? "-0" : d;
        }
        function Mc(c) {
          if (c != null) {
            try {
              return Pp.call(c);
            } catch {
            }
            try {
              return c + "";
            } catch {
            }
          }
          return "";
        }
        function sj(c, d) {
          return fa(Yt, function(p) {
            var S = "_." + p[0];
            d & p[1] && !_p(c, S) && c.push(S);
          }), c.sort();
        }
        function Y_(c) {
          if (c instanceof sn)
            return c.clone();
          var d = new ga(c.__wrapped__, c.__chain__);
          return d.__actions__ = Ss(c.__actions__), d.__index__ = c.__index__, d.__values__ = c.__values__, d;
        }
        function aj(c, d, p) {
          (p ? fs(c, d, p) : d === n) ? d = 1 : d = ai($t(d), 0);
          var S = c == null ? 0 : c.length;
          if (!S || d < 1)
            return [];
          for (var v = 0, R = 0, V = ue(Up(S / d)); v < S; )
            V[R++] = ba(c, v, v += d);
          return V;
        }
        function oj(c) {
          for (var d = -1, p = c == null ? 0 : c.length, S = 0, v = []; ++d < p; ) {
            var R = c[d];
            R && (v[S++] = R);
          }
          return v;
        }
        function uj() {
          var c = arguments.length;
          if (!c)
            return [];
          for (var d = ue(c - 1), p = arguments[0], S = c; S--; )
            d[S - 1] = arguments[S];
          return rl(_t(p) ? Ss(p) : [p], Li(d, 1));
        }
        var lj = Wt(function(c, d) {
          return Vr(c) ? Yf(c, Li(d, 1, Vr, !0)) : [];
        }), cj = Wt(function(c, d) {
          var p = ya(d);
          return Vr(p) && (p = n), Vr(c) ? Yf(c, Li(d, 1, Vr, !0), ct(p, 2)) : [];
        }), hj = Wt(function(c, d) {
          var p = ya(d);
          return Vr(p) && (p = n), Vr(c) ? Yf(c, Li(d, 1, Vr, !0), n, p) : [];
        });
        function dj(c, d, p) {
          var S = c == null ? 0 : c.length;
          return S ? (d = p || d === n ? 1 : $t(d), ba(c, d < 0 ? 0 : d, S)) : [];
        }
        function fj(c, d, p) {
          var S = c == null ? 0 : c.length;
          return S ? (d = p || d === n ? 1 : $t(d), d = S - d, ba(c, 0, d < 0 ? 0 : d)) : [];
        }
        function mj(c, d) {
          return c && c.length ? Qp(c, ct(d, 3), !0, !0) : [];
        }
        function gj(c, d) {
          return c && c.length ? Qp(c, ct(d, 3), !0) : [];
        }
        function pj(c, d, p, S) {
          var v = c == null ? 0 : c.length;
          return v ? (p && typeof p != "number" && fs(c, d, p) && (p = 0, S = v), uz(c, d, p, S)) : [];
        }
        function q_(c, d, p) {
          var S = c == null ? 0 : c.length;
          if (!S)
            return -1;
          var v = p == null ? 0 : $t(p);
          return v < 0 && (v = ai(S + v, 0)), Np(c, ct(d, 3), v);
        }
        function J_(c, d, p) {
          var S = c == null ? 0 : c.length;
          if (!S)
            return -1;
          var v = S - 1;
          return p !== n && (v = $t(p), v = p < 0 ? ai(S + v, 0) : ji(v, S - 1)), Np(c, ct(d, 3), v, !0);
        }
        function Q_(c) {
          var d = c == null ? 0 : c.length;
          return d ? Li(c, 1) : [];
        }
        function bj(c) {
          var d = c == null ? 0 : c.length;
          return d ? Li(c, ie) : [];
        }
        function yj(c, d) {
          var p = c == null ? 0 : c.length;
          return p ? (d = d === n ? 1 : $t(d), Li(c, d)) : [];
        }
        function Aj(c) {
          for (var d = -1, p = c == null ? 0 : c.length, S = {}; ++d < p; ) {
            var v = c[d];
            S[v[0]] = v[1];
          }
          return S;
        }
        function X_(c) {
          return c && c.length ? c[0] : n;
        }
        function Ej(c, d, p) {
          var S = c == null ? 0 : c.length;
          if (!S)
            return -1;
          var v = p == null ? 0 : $t(p);
          return v < 0 && (v = ai(S + v, 0)), $h(c, d, v);
        }
        function Sj(c) {
          var d = c == null ? 0 : c.length;
          return d ? ba(c, 0, -1) : [];
        }
        var wj = Wt(function(c) {
          var d = Ar(c, ME);
          return d.length && d[0] === c[0] ? xE(d) : [];
        }), Fj = Wt(function(c) {
          var d = ya(c), p = Ar(c, ME);
          return d === ya(p) ? d = n : p.pop(), p.length && p[0] === c[0] ? xE(p, ct(d, 2)) : [];
        }), Tj = Wt(function(c) {
          var d = ya(c), p = Ar(c, ME);
          return d = typeof d == "function" ? d : n, d && p.pop(), p.length && p[0] === c[0] ? xE(p, n, d) : [];
        });
        function vj(c, d) {
          return c == null ? "" : SK.call(c, d);
        }
        function ya(c) {
          var d = c == null ? 0 : c.length;
          return d ? c[d - 1] : n;
        }
        function xj(c, d, p) {
          var S = c == null ? 0 : c.length;
          if (!S)
            return -1;
          var v = S;
          return p !== n && (v = $t(p), v = v < 0 ? ai(S + v, 0) : ji(v, S - 1)), d === d ? sK(c, d, v) : Np(c, Ik, v, !0);
        }
        function Cj(c, d) {
          return c && c.length ? l_(c, $t(d)) : n;
        }
        var kj = Wt(Z_);
        function Z_(c, d) {
          return c && c.length && d && d.length ? NE(c, d) : c;
        }
        function _j(c, d, p) {
          return c && c.length && d && d.length ? NE(c, d, ct(p, 2)) : c;
        }
        function Nj(c, d, p) {
          return c && c.length && d && d.length ? NE(c, d, n, p) : c;
        }
        var Dj = wu(function(c, d) {
          var p = c == null ? 0 : c.length, S = wE(c, d);
          return d_(c, Ar(d, function(v) {
            return Fu(v, p) ? +v : v;
          }).sort(w_)), S;
        });
        function Ij(c, d) {
          var p = [];
          if (!(c && c.length))
            return p;
          var S = -1, v = [], R = c.length;
          for (d = ct(d, 3); ++S < R; ) {
            var V = c[S];
            d(V, S, c) && (p.push(V), v.push(S));
          }
          return d_(c, v), p;
        }
        function JE(c) {
          return c == null ? c : vK.call(c);
        }
        function Rj(c, d, p) {
          var S = c == null ? 0 : c.length;
          return S ? (p && typeof p != "number" && fs(c, d, p) ? (d = 0, p = S) : (d = d == null ? 0 : $t(d), p = p === n ? S : $t(p)), ba(c, d, p)) : [];
        }
        function Pj(c, d) {
          return Jp(c, d);
        }
        function Lj(c, d, p) {
          return RE(c, d, ct(p, 2));
        }
        function Mj(c, d) {
          var p = c == null ? 0 : c.length;
          if (p) {
            var S = Jp(c, d);
            if (S < p && to(c[S], d))
              return S;
          }
          return -1;
        }
        function Oj(c, d) {
          return Jp(c, d, !0);
        }
        function Bj(c, d, p) {
          return RE(c, d, ct(p, 2), !0);
        }
        function $j(c, d) {
          var p = c == null ? 0 : c.length;
          if (p) {
            var S = Jp(c, d, !0) - 1;
            if (to(c[S], d))
              return S;
          }
          return -1;
        }
        function Hj(c) {
          return c && c.length ? m_(c) : [];
        }
        function Uj(c, d) {
          return c && c.length ? m_(c, ct(d, 2)) : [];
        }
        function Gj(c) {
          var d = c == null ? 0 : c.length;
          return d ? ba(c, 1, d) : [];
        }
        function Wj(c, d, p) {
          return c && c.length ? (d = p || d === n ? 1 : $t(d), ba(c, 0, d < 0 ? 0 : d)) : [];
        }
        function Vj(c, d, p) {
          var S = c == null ? 0 : c.length;
          return S ? (d = p || d === n ? 1 : $t(d), d = S - d, ba(c, d < 0 ? 0 : d, S)) : [];
        }
        function Kj(c, d) {
          return c && c.length ? Qp(c, ct(d, 3), !1, !0) : [];
        }
        function zj(c, d) {
          return c && c.length ? Qp(c, ct(d, 3)) : [];
        }
        var jj = Wt(function(c) {
          return ol(Li(c, 1, Vr, !0));
        }), Yj = Wt(function(c) {
          var d = ya(c);
          return Vr(d) && (d = n), ol(Li(c, 1, Vr, !0), ct(d, 2));
        }), qj = Wt(function(c) {
          var d = ya(c);
          return d = typeof d == "function" ? d : n, ol(Li(c, 1, Vr, !0), n, d);
        });
        function Jj(c) {
          return c && c.length ? ol(c) : [];
        }
        function Qj(c, d) {
          return c && c.length ? ol(c, ct(d, 2)) : [];
        }
        function Xj(c, d) {
          return d = typeof d == "function" ? d : n, c && c.length ? ol(c, n, d) : [];
        }
        function QE(c) {
          if (!(c && c.length))
            return [];
          var d = 0;
          return c = nl(c, function(p) {
            if (Vr(p))
              return d = ai(p.length, d), !0;
          }), mE(d, function(p) {
            return Ar(c, hE(p));
          });
        }
        function e3(c, d) {
          if (!(c && c.length))
            return [];
          var p = QE(c);
          return d == null ? p : Ar(p, function(S) {
            return Ks(d, n, S);
          });
        }
        var Zj = Wt(function(c, d) {
          return Vr(c) ? Yf(c, d) : [];
        }), eY = Wt(function(c) {
          return LE(nl(c, Vr));
        }), tY = Wt(function(c) {
          var d = ya(c);
          return Vr(d) && (d = n), LE(nl(c, Vr), ct(d, 2));
        }), nY = Wt(function(c) {
          var d = ya(c);
          return d = typeof d == "function" ? d : n, LE(nl(c, Vr), n, d);
        }), rY = Wt(QE);
        function iY(c, d) {
          return y_(c || [], d || [], jf);
        }
        function sY(c, d) {
          return y_(c || [], d || [], Qf);
        }
        var aY = Wt(function(c) {
          var d = c.length, p = d > 1 ? c[d - 1] : n;
          return p = typeof p == "function" ? (c.pop(), p) : n, e3(c, p);
        });
        function t3(c) {
          var d = _(c);
          return d.__chain__ = !0, d;
        }
        function oY(c, d) {
          return d(c), c;
        }
        function a0(c, d) {
          return d(c);
        }
        var uY = wu(function(c) {
          var d = c.length, p = d ? c[0] : 0, S = this.__wrapped__, v = function(R) {
            return wE(R, c);
          };
          return d > 1 || this.__actions__.length || !(S instanceof sn) || !Fu(p) ? this.thru(v) : (S = S.slice(p, +p + (d ? 1 : 0)), S.__actions__.push({
            func: a0,
            args: [v],
            thisArg: n
          }), new ga(S, this.__chain__).thru(function(R) {
            return d && !R.length && R.push(n), R;
          }));
        });
        function lY() {
          return t3(this);
        }
        function cY() {
          return new ga(this.value(), this.__chain__);
        }
        function hY() {
          this.__values__ === n && (this.__values__ = g3(this.value()));
          var c = this.__index__ >= this.__values__.length, d = c ? n : this.__values__[this.__index__++];
          return { done: c, value: d };
        }
        function dY() {
          return this;
        }
        function fY(c) {
          for (var d, p = this; p instanceof Kp; ) {
            var S = Y_(p);
            S.__index__ = 0, S.__values__ = n, d ? v.__wrapped__ = S : d = S;
            var v = S;
            p = p.__wrapped__;
          }
          return v.__wrapped__ = c, d;
        }
        function mY() {
          var c = this.__wrapped__;
          if (c instanceof sn) {
            var d = c;
            return this.__actions__.length && (d = new sn(this)), d = d.reverse(), d.__actions__.push({
              func: a0,
              args: [JE],
              thisArg: n
            }), new ga(d, this.__chain__);
          }
          return this.thru(JE);
        }
        function gY() {
          return b_(this.__wrapped__, this.__actions__);
        }
        var pY = Xp(function(c, d, p) {
          Ln.call(c, p) ? ++c[p] : Eu(c, p, 1);
        });
        function bY(c, d, p) {
          var S = _t(c) ? Nk : oz;
          return p && fs(c, d, p) && (d = n), S(c, ct(d, 3));
        }
        function yY(c, d) {
          var p = _t(c) ? nl : e_;
          return p(c, ct(d, 3));
        }
        var AY = k_(q_), EY = k_(J_);
        function SY(c, d) {
          return Li(o0(c, d), 1);
        }
        function wY(c, d) {
          return Li(o0(c, d), ie);
        }
        function FY(c, d, p) {
          return p = p === n ? 1 : $t(p), Li(o0(c, d), p);
        }
        function n3(c, d) {
          var p = _t(c) ? fa : al;
          return p(c, ct(d, 3));
        }
        function r3(c, d) {
          var p = _t(c) ? GV : Zk;
          return p(c, ct(d, 3));
        }
        var TY = Xp(function(c, d, p) {
          Ln.call(c, p) ? c[p].push(d) : Eu(c, p, [d]);
        });
        function vY(c, d, p, S) {
          c = ws(c) ? c : Qh(c), p = p && !S ? $t(p) : 0;
          var v = c.length;
          return p < 0 && (p = ai(v + p, 0)), d0(c) ? p <= v && c.indexOf(d, p) > -1 : !!v && $h(c, d, p) > -1;
        }
        var xY = Wt(function(c, d, p) {
          var S = -1, v = typeof d == "function", R = ws(c) ? ue(c.length) : [];
          return al(c, function(V) {
            R[++S] = v ? Ks(d, V, p) : qf(V, d, p);
          }), R;
        }), CY = Xp(function(c, d, p) {
          Eu(c, p, d);
        });
        function o0(c, d) {
          var p = _t(c) ? Ar : a_;
          return p(c, ct(d, 3));
        }
        function kY(c, d, p, S) {
          return c == null ? [] : (_t(d) || (d = d == null ? [] : [d]), p = S ? n : p, _t(p) || (p = p == null ? [] : [p]), c_(c, d, p));
        }
        var _Y = Xp(function(c, d, p) {
          c[p ? 0 : 1].push(d);
        }, function() {
          return [[], []];
        });
        function NY(c, d, p) {
          var S = _t(c) ? lE : Pk, v = arguments.length < 3;
          return S(c, ct(d, 4), p, v, al);
        }
        function DY(c, d, p) {
          var S = _t(c) ? WV : Pk, v = arguments.length < 3;
          return S(c, ct(d, 4), p, v, Zk);
        }
        function IY(c, d) {
          var p = _t(c) ? nl : e_;
          return p(c, c0(ct(d, 3)));
        }
        function RY(c) {
          var d = _t(c) ? qk : vz;
          return d(c);
        }
        function PY(c, d, p) {
          (p ? fs(c, d, p) : d === n) ? d = 1 : d = $t(d);
          var S = _t(c) ? nz : xz;
          return S(c, d);
        }
        function LY(c) {
          var d = _t(c) ? rz : kz;
          return d(c);
        }
        function MY(c) {
          if (c == null)
            return 0;
          if (ws(c))
            return d0(c) ? Uh(c) : c.length;
          var d = Yi(c);
          return d == Hn || d == Ue ? c.size : kE(c).length;
        }
        function OY(c, d, p) {
          var S = _t(c) ? cE : _z;
          return p && fs(c, d, p) && (d = n), S(c, ct(d, 3));
        }
        var BY = Wt(function(c, d) {
          if (c == null)
            return [];
          var p = d.length;
          return p > 1 && fs(c, d[0], d[1]) ? d = [] : p > 2 && fs(d[0], d[1], d[2]) && (d = [d[0]]), c_(c, Li(d, 1), []);
        }), u0 = yK || function() {
          return Pi.Date.now();
        };
        function $Y(c, d) {
          if (typeof d != "function")
            throw new ma(a);
          return c = $t(c), function() {
            if (--c < 1)
              return d.apply(this, arguments);
          };
        }
        function i3(c, d, p) {
          return d = p ? n : d, d = c && d == null ? c.length : d, Su(c, L, n, n, n, n, d);
        }
        function s3(c, d) {
          var p;
          if (typeof d != "function")
            throw new ma(a);
          return c = $t(c), function() {
            return --c > 0 && (p = d.apply(this, arguments)), c <= 1 && (d = n), p;
          };
        }
        var XE = Wt(function(c, d, p) {
          var S = w;
          if (p.length) {
            var v = il(p, qh(XE));
            S |= C;
          }
          return Su(c, S, d, p, v);
        }), a3 = Wt(function(c, d, p) {
          var S = w | x;
          if (p.length) {
            var v = il(p, qh(a3));
            S |= C;
          }
          return Su(d, S, c, p, v);
        });
        function o3(c, d, p) {
          d = p ? n : d;
          var S = Su(c, B, n, n, n, n, n, d);
          return S.placeholder = o3.placeholder, S;
        }
        function u3(c, d, p) {
          d = p ? n : d;
          var S = Su(c, P, n, n, n, n, n, d);
          return S.placeholder = u3.placeholder, S;
        }
        function l3(c, d, p) {
          var S, v, R, V, Y, ee, Ee = 0, Se = !1, Ce = !1, Ve = !0;
          if (typeof c != "function")
            throw new ma(a);
          d = Aa(d) || 0, kr(p) && (Se = !!p.leading, Ce = "maxWait" in p, R = Ce ? ai(Aa(p.maxWait) || 0, d) : R, Ve = "trailing" in p ? !!p.trailing : Ve);
          function Ze(Kr) {
            var no = S, xu = v;
            return S = v = n, Ee = Kr, V = c.apply(xu, no), V;
          }
          function mt(Kr) {
            return Ee = Kr, Y = em(Jt, d), Se ? Ze(Kr) : V;
          }
          function Ut(Kr) {
            var no = Kr - ee, xu = Kr - Ee, k3 = d - no;
            return Ce ? ji(k3, R - xu) : k3;
          }
          function gt(Kr) {
            var no = Kr - ee, xu = Kr - Ee;
            return ee === n || no >= d || no < 0 || Ce && xu >= R;
          }
          function Jt() {
            var Kr = u0();
            if (gt(Kr))
              return mn(Kr);
            Y = em(Jt, Ut(Kr));
          }
          function mn(Kr) {
            return Y = n, Ve && S ? Ze(Kr) : (S = v = n, V);
          }
          function qs() {
            Y !== n && A_(Y), Ee = 0, S = ee = v = Y = n;
          }
          function ms() {
            return Y === n ? V : mn(u0());
          }
          function Js() {
            var Kr = u0(), no = gt(Kr);
            if (S = arguments, v = this, ee = Kr, no) {
              if (Y === n)
                return mt(ee);
              if (Ce)
                return A_(Y), Y = em(Jt, d), Ze(ee);
            }
            return Y === n && (Y = em(Jt, d)), V;
          }
          return Js.cancel = qs, Js.flush = ms, Js;
        }
        var HY = Wt(function(c, d) {
          return Xk(c, 1, d);
        }), UY = Wt(function(c, d, p) {
          return Xk(c, Aa(d) || 0, p);
        });
        function GY(c) {
          return Su(c, I);
        }
        function l0(c, d) {
          if (typeof c != "function" || d != null && typeof d != "function")
            throw new ma(a);
          var p = function() {
            var S = arguments, v = d ? d.apply(this, S) : S[0], R = p.cache;
            if (R.has(v))
              return R.get(v);
            var V = c.apply(this, S);
            return p.cache = R.set(v, V) || R, V;
          };
          return p.cache = new (l0.Cache || Au)(), p;
        }
        l0.Cache = Au;
        function c0(c) {
          if (typeof c != "function")
            throw new ma(a);
          return function() {
            var d = arguments;
            switch (d.length) {
              case 0:
                return !c.call(this);
              case 1:
                return !c.call(this, d[0]);
              case 2:
                return !c.call(this, d[0], d[1]);
              case 3:
                return !c.call(this, d[0], d[1], d[2]);
            }
            return !c.apply(this, d);
          };
        }
        function WY(c) {
          return s3(2, c);
        }
        var VY = Nz(function(c, d) {
          d = d.length == 1 && _t(d[0]) ? Ar(d[0], zs(ct())) : Ar(Li(d, 1), zs(ct()));
          var p = d.length;
          return Wt(function(S) {
            for (var v = -1, R = ji(S.length, p); ++v < R; )
              S[v] = d[v].call(this, S[v]);
            return Ks(c, this, S);
          });
        }), ZE = Wt(function(c, d) {
          var p = il(d, qh(ZE));
          return Su(c, C, n, d, p);
        }), c3 = Wt(function(c, d) {
          var p = il(d, qh(c3));
          return Su(c, D, n, d, p);
        }), KY = wu(function(c, d) {
          return Su(c, k, n, n, n, d);
        });
        function zY(c, d) {
          if (typeof c != "function")
            throw new ma(a);
          return d = d === n ? d : $t(d), Wt(c, d);
        }
        function jY(c, d) {
          if (typeof c != "function")
            throw new ma(a);
          return d = d == null ? 0 : ai($t(d), 0), Wt(function(p) {
            var S = p[d], v = ll(p, 0, d);
            return S && rl(v, S), Ks(c, this, v);
          });
        }
        function YY(c, d, p) {
          var S = !0, v = !0;
          if (typeof c != "function")
            throw new ma(a);
          return kr(p) && (S = "leading" in p ? !!p.leading : S, v = "trailing" in p ? !!p.trailing : v), l3(c, d, {
            leading: S,
            maxWait: d,
            trailing: v
          });
        }
        function qY(c) {
          return i3(c, 1);
        }
        function JY(c, d) {
          return ZE(OE(d), c);
        }
        function QY() {
          if (!arguments.length)
            return [];
          var c = arguments[0];
          return _t(c) ? c : [c];
        }
        function XY(c) {
          return pa(c, g);
        }
        function ZY(c, d) {
          return d = typeof d == "function" ? d : n, pa(c, g, d);
        }
        function eq(c) {
          return pa(c, f | g);
        }
        function tq(c, d) {
          return d = typeof d == "function" ? d : n, pa(c, f | g, d);
        }
        function nq(c, d) {
          return d == null || Qk(c, d, pi(d));
        }
        function to(c, d) {
          return c === d || c !== c && d !== d;
        }
        var rq = n0(vE), iq = n0(function(c, d) {
          return c >= d;
        }), Oc = r_(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? r_ : function(c) {
          return $r(c) && Ln.call(c, "callee") && !Wk.call(c, "callee");
        }, _t = ue.isArray, sq = Tk ? zs(Tk) : fz;
        function ws(c) {
          return c != null && h0(c.length) && !Tu(c);
        }
        function Vr(c) {
          return $r(c) && ws(c);
        }
        function aq(c) {
          return c === !0 || c === !1 || $r(c) && ds(c) == Tn;
        }
        var cl = EK || cS, oq = vk ? zs(vk) : mz;
        function uq(c) {
          return $r(c) && c.nodeType === 1 && !tm(c);
        }
        function lq(c) {
          if (c == null)
            return !0;
          if (ws(c) && (_t(c) || typeof c == "string" || typeof c.splice == "function" || cl(c) || Jh(c) || Oc(c)))
            return !c.length;
          var d = Yi(c);
          if (d == Hn || d == Ue)
            return !c.size;
          if (Zf(c))
            return !kE(c).length;
          for (var p in c)
            if (Ln.call(c, p))
              return !1;
          return !0;
        }
        function cq(c, d) {
          return Jf(c, d);
        }
        function hq(c, d, p) {
          p = typeof p == "function" ? p : n;
          var S = p ? p(c, d) : n;
          return S === n ? Jf(c, d, n, p) : !!S;
        }
        function eS(c) {
          if (!$r(c))
            return !1;
          var d = ds(c);
          return d == $n || d == yr || typeof c.message == "string" && typeof c.name == "string" && !tm(c);
        }
        function dq(c) {
          return typeof c == "number" && Kk(c);
        }
        function Tu(c) {
          if (!kr(c))
            return !1;
          var d = ds(c);
          return d == Cr || d == ii || d == ls || d == Je;
        }
        function h3(c) {
          return typeof c == "number" && c == $t(c);
        }
        function h0(c) {
          return typeof c == "number" && c > -1 && c % 1 == 0 && c <= te;
        }
        function kr(c) {
          var d = typeof c;
          return c != null && (d == "object" || d == "function");
        }
        function $r(c) {
          return c != null && typeof c == "object";
        }
        var d3 = xk ? zs(xk) : pz;
        function fq(c, d) {
          return c === d || CE(c, d, VE(d));
        }
        function mq(c, d, p) {
          return p = typeof p == "function" ? p : n, CE(c, d, VE(d), p);
        }
        function gq(c) {
          return f3(c) && c != +c;
        }
        function pq(c) {
          if (Zz(c))
            throw new kt(s);
          return i_(c);
        }
        function bq(c) {
          return c === null;
        }
        function yq(c) {
          return c == null;
        }
        function f3(c) {
          return typeof c == "number" || $r(c) && ds(c) == cs;
        }
        function tm(c) {
          if (!$r(c) || ds(c) != oe)
            return !1;
          var d = Bp(c);
          if (d === null)
            return !0;
          var p = Ln.call(d, "constructor") && d.constructor;
          return typeof p == "function" && p instanceof p && Pp.call(p) == mK;
        }
        var tS = Ck ? zs(Ck) : bz;
        function Aq(c) {
          return h3(c) && c >= -te && c <= te;
        }
        var m3 = kk ? zs(kk) : yz;
        function d0(c) {
          return typeof c == "string" || !_t(c) && $r(c) && ds(c) == rn;
        }
        function Ys(c) {
          return typeof c == "symbol" || $r(c) && ds(c) == Vs;
        }
        var Jh = _k ? zs(_k) : Az;
        function Eq(c) {
          return c === n;
        }
        function Sq(c) {
          return $r(c) && Yi(c) == Xa;
        }
        function wq(c) {
          return $r(c) && ds(c) == Tp;
        }
        var Fq = n0(_E), Tq = n0(function(c, d) {
          return c <= d;
        });
        function g3(c) {
          if (!c)
            return [];
          if (ws(c))
            return d0(c) ? Za(c) : Ss(c);
          if (Gf && c[Gf])
            return nK(c[Gf]());
          var d = Yi(c), p = d == Hn ? pE : d == Ue ? Dp : Qh;
          return p(c);
        }
        function vu(c) {
          if (!c)
            return c === 0 ? c : 0;
          if (c = Aa(c), c === ie || c === -ie) {
            var d = c < 0 ? -1 : 1;
            return d * Pe;
          }
          return c === c ? c : 0;
        }
        function $t(c) {
          var d = vu(c), p = d % 1;
          return d === d ? p ? d - p : d : 0;
        }
        function p3(c) {
          return c ? Rc($t(c), 0, Me) : 0;
        }
        function Aa(c) {
          if (typeof c == "number")
            return c;
          if (Ys(c))
            return We;
          if (kr(c)) {
            var d = typeof c.valueOf == "function" ? c.valueOf() : c;
            c = kr(d) ? d + "" : d;
          }
          if (typeof c != "string")
            return c === 0 ? c : +c;
          c = Lk(c);
          var p = sV.test(c);
          return p || oV.test(c) ? $V(c.slice(2), p ? 2 : 8) : iV.test(c) ? We : +c;
        }
        function b3(c) {
          return Bo(c, Fs(c));
        }
        function vq(c) {
          return c ? Rc($t(c), -te, te) : c === 0 ? c : 0;
        }
        function Mn(c) {
          return c == null ? "" : js(c);
        }
        var xq = jh(function(c, d) {
          if (Zf(d) || ws(d)) {
            Bo(d, pi(d), c);
            return;
          }
          for (var p in d)
            Ln.call(d, p) && jf(c, p, d[p]);
        }), y3 = jh(function(c, d) {
          Bo(d, Fs(d), c);
        }), f0 = jh(function(c, d, p, S) {
          Bo(d, Fs(d), c, S);
        }), Cq = jh(function(c, d, p, S) {
          Bo(d, pi(d), c, S);
        }), kq = wu(wE);
        function _q(c, d) {
          var p = zh(c);
          return d == null ? p : Jk(p, d);
        }
        var Nq = Wt(function(c, d) {
          c = Xn(c);
          var p = -1, S = d.length, v = S > 2 ? d[2] : n;
          for (v && fs(d[0], d[1], v) && (S = 1); ++p < S; )
            for (var R = d[p], V = Fs(R), Y = -1, ee = V.length; ++Y < ee; ) {
              var Ee = V[Y], Se = c[Ee];
              (Se === n || to(Se, Wh[Ee]) && !Ln.call(c, Ee)) && (c[Ee] = R[Ee]);
            }
          return c;
        }), Dq = Wt(function(c) {
          return c.push(n, L_), Ks(A3, n, c);
        });
        function Iq(c, d) {
          return Dk(c, ct(d, 3), Oo);
        }
        function Rq(c, d) {
          return Dk(c, ct(d, 3), TE);
        }
        function Pq(c, d) {
          return c == null ? c : FE(c, ct(d, 3), Fs);
        }
        function Lq(c, d) {
          return c == null ? c : t_(c, ct(d, 3), Fs);
        }
        function Mq(c, d) {
          return c && Oo(c, ct(d, 3));
        }
        function Oq(c, d) {
          return c && TE(c, ct(d, 3));
        }
        function Bq(c) {
          return c == null ? [] : Yp(c, pi(c));
        }
        function $q(c) {
          return c == null ? [] : Yp(c, Fs(c));
        }
        function nS(c, d, p) {
          var S = c == null ? n : Pc(c, d);
          return S === n ? p : S;
        }
        function Hq(c, d) {
          return c != null && B_(c, d, lz);
        }
        function rS(c, d) {
          return c != null && B_(c, d, cz);
        }
        var Uq = N_(function(c, d, p) {
          d != null && typeof d.toString != "function" && (d = Lp.call(d)), c[d] = p;
        }, sS(Ts)), Gq = N_(function(c, d, p) {
          d != null && typeof d.toString != "function" && (d = Lp.call(d)), Ln.call(c, d) ? c[d].push(p) : c[d] = [p];
        }, ct), Wq = Wt(qf);
        function pi(c) {
          return ws(c) ? Yk(c) : kE(c);
        }
        function Fs(c) {
          return ws(c) ? Yk(c, !0) : Ez(c);
        }
        function Vq(c, d) {
          var p = {};
          return d = ct(d, 3), Oo(c, function(S, v, R) {
            Eu(p, d(S, v, R), S);
          }), p;
        }
        function Kq(c, d) {
          var p = {};
          return d = ct(d, 3), Oo(c, function(S, v, R) {
            Eu(p, v, d(S, v, R));
          }), p;
        }
        var zq = jh(function(c, d, p) {
          qp(c, d, p);
        }), A3 = jh(function(c, d, p, S) {
          qp(c, d, p, S);
        }), jq = wu(function(c, d) {
          var p = {};
          if (c == null)
            return p;
          var S = !1;
          d = Ar(d, function(R) {
            return R = ul(R, c), S || (S = R.length > 1), R;
          }), Bo(c, GE(c), p), S && (p = pa(p, f | m | g, Uz));
          for (var v = d.length; v--; )
            PE(p, d[v]);
          return p;
        });
        function Yq(c, d) {
          return E3(c, c0(ct(d)));
        }
        var qq = wu(function(c, d) {
          return c == null ? {} : wz(c, d);
        });
        function E3(c, d) {
          if (c == null)
            return {};
          var p = Ar(GE(c), function(S) {
            return [S];
          });
          return d = ct(d), h_(c, p, function(S, v) {
            return d(S, v[0]);
          });
        }
        function Jq(c, d, p) {
          d = ul(d, c);
          var S = -1, v = d.length;
          for (v || (v = 1, c = n); ++S < v; ) {
            var R = c == null ? n : c[$o(d[S])];
            R === n && (S = v, R = p), c = Tu(R) ? R.call(c) : R;
          }
          return c;
        }
        function Qq(c, d, p) {
          return c == null ? c : Qf(c, d, p);
        }
        function Xq(c, d, p, S) {
          return S = typeof S == "function" ? S : n, c == null ? c : Qf(c, d, p, S);
        }
        var S3 = R_(pi), w3 = R_(Fs);
        function Zq(c, d, p) {
          var S = _t(c), v = S || cl(c) || Jh(c);
          if (d = ct(d, 4), p == null) {
            var R = c && c.constructor;
            v ? p = S ? new R() : [] : kr(c) ? p = Tu(R) ? zh(Bp(c)) : {} : p = {};
          }
          return (v ? fa : Oo)(c, function(V, Y, ee) {
            return d(p, V, Y, ee);
          }), p;
        }
        function eJ(c, d) {
          return c == null ? !0 : PE(c, d);
        }
        function tJ(c, d, p) {
          return c == null ? c : p_(c, d, OE(p));
        }
        function nJ(c, d, p, S) {
          return S = typeof S == "function" ? S : n, c == null ? c : p_(c, d, OE(p), S);
        }
        function Qh(c) {
          return c == null ? [] : gE(c, pi(c));
        }
        function rJ(c) {
          return c == null ? [] : gE(c, Fs(c));
        }
        function iJ(c, d, p) {
          return p === n && (p = d, d = n), p !== n && (p = Aa(p), p = p === p ? p : 0), d !== n && (d = Aa(d), d = d === d ? d : 0), Rc(Aa(c), d, p);
        }
        function sJ(c, d, p) {
          return d = vu(d), p === n ? (p = d, d = 0) : p = vu(p), c = Aa(c), hz(c, d, p);
        }
        function aJ(c, d, p) {
          if (p && typeof p != "boolean" && fs(c, d, p) && (d = p = n), p === n && (typeof d == "boolean" ? (p = d, d = n) : typeof c == "boolean" && (p = c, c = n)), c === n && d === n ? (c = 0, d = 1) : (c = vu(c), d === n ? (d = c, c = 0) : d = vu(d)), c > d) {
            var S = c;
            c = d, d = S;
          }
          if (p || c % 1 || d % 1) {
            var v = zk();
            return ji(c + v * (d - c + BV("1e-" + ((v + "").length - 1))), d);
          }
          return DE(c, d);
        }
        var oJ = Yh(function(c, d, p) {
          return d = d.toLowerCase(), c + (p ? F3(d) : d);
        });
        function F3(c) {
          return iS(Mn(c).toLowerCase());
        }
        function T3(c) {
          return c = Mn(c), c && c.replace(lV, QV).replace(kV, "");
        }
        function uJ(c, d, p) {
          c = Mn(c), d = js(d);
          var S = c.length;
          p = p === n ? S : Rc($t(p), 0, S);
          var v = p;
          return p -= d.length, p >= 0 && c.slice(p, v) == d;
        }
        function lJ(c) {
          return c = Mn(c), c && WW.test(c) ? c.replace(Oh, XV) : c;
        }
        function cJ(c) {
          return c = Mn(c), c && qW.test(c) ? c.replace(ZA, "\\$&") : c;
        }
        var hJ = Yh(function(c, d, p) {
          return c + (p ? "-" : "") + d.toLowerCase();
        }), dJ = Yh(function(c, d, p) {
          return c + (p ? " " : "") + d.toLowerCase();
        }), fJ = C_("toLowerCase");
        function mJ(c, d, p) {
          c = Mn(c), d = $t(d);
          var S = d ? Uh(c) : 0;
          if (!d || S >= d)
            return c;
          var v = (d - S) / 2;
          return t0(Gp(v), p) + c + t0(Up(v), p);
        }
        function gJ(c, d, p) {
          c = Mn(c), d = $t(d);
          var S = d ? Uh(c) : 0;
          return d && S < d ? c + t0(d - S, p) : c;
        }
        function pJ(c, d, p) {
          c = Mn(c), d = $t(d);
          var S = d ? Uh(c) : 0;
          return d && S < d ? t0(d - S, p) + c : c;
        }
        function bJ(c, d, p) {
          return p || d == null ? d = 0 : d && (d = +d), TK(Mn(c).replace(eE, ""), d || 0);
        }
        function yJ(c, d, p) {
          return (p ? fs(c, d, p) : d === n) ? d = 1 : d = $t(d), IE(Mn(c), d);
        }
        function AJ() {
          var c = arguments, d = Mn(c[0]);
          return c.length < 3 ? d : d.replace(c[1], c[2]);
        }
        var EJ = Yh(function(c, d, p) {
          return c + (p ? "_" : "") + d.toLowerCase();
        });
        function SJ(c, d, p) {
          return p && typeof p != "number" && fs(c, d, p) && (d = p = n), p = p === n ? Me : p >>> 0, p ? (c = Mn(c), c && (typeof d == "string" || d != null && !tS(d)) && (d = js(d), !d && Hh(c)) ? ll(Za(c), 0, p) : c.split(d, p)) : [];
        }
        var wJ = Yh(function(c, d, p) {
          return c + (p ? " " : "") + iS(d);
        });
        function FJ(c, d, p) {
          return c = Mn(c), p = p == null ? 0 : Rc($t(p), 0, c.length), d = js(d), c.slice(p, p + d.length) == d;
        }
        function TJ(c, d, p) {
          var S = _.templateSettings;
          p && fs(c, d, p) && (d = n), c = Mn(c), d = f0({}, d, S, P_);
          var v = f0({}, d.imports, S.imports, P_), R = pi(v), V = gE(v, R), Y, ee, Ee = 0, Se = d.interpolate || xp, Ce = "__p += '", Ve = bE(
            (d.escape || xp).source + "|" + Se.source + "|" + (Se === nk ? rV : xp).source + "|" + (d.evaluate || xp).source + "|$",
            "g"
          ), Ze = "//# sourceURL=" + (Ln.call(d, "sourceURL") ? (d.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++RV + "]") + `
`;
          c.replace(Ve, function(gt, Jt, mn, qs, ms, Js) {
            return mn || (mn = qs), Ce += c.slice(Ee, Js).replace(cV, ZV), Jt && (Y = !0, Ce += `' +
__e(` + Jt + `) +
'`), ms && (ee = !0, Ce += `';
` + ms + `;
__p += '`), mn && (Ce += `' +
((__t = (` + mn + `)) == null ? '' : __t) +
'`), Ee = Js + gt.length, gt;
          }), Ce += `';
`;
          var mt = Ln.call(d, "variable") && d.variable;
          if (!mt)
            Ce = `with (obj) {
` + Ce + `
}
`;
          else if (tV.test(mt))
            throw new kt(o);
          Ce = (ee ? Ce.replace(kc, "") : Ce).replace(vp, "$1").replace($f, "$1;"), Ce = "function(" + (mt || "obj") + `) {
` + (mt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Y ? ", __e = _.escape" : "") + (ee ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ce + `return __p
}`;
          var Ut = x3(function() {
            return _n(R, Ze + "return " + Ce).apply(n, V);
          });
          if (Ut.source = Ce, eS(Ut))
            throw Ut;
          return Ut;
        }
        function vJ(c) {
          return Mn(c).toLowerCase();
        }
        function xJ(c) {
          return Mn(c).toUpperCase();
        }
        function CJ(c, d, p) {
          if (c = Mn(c), c && (p || d === n))
            return Lk(c);
          if (!c || !(d = js(d)))
            return c;
          var S = Za(c), v = Za(d), R = Mk(S, v), V = Ok(S, v) + 1;
          return ll(S, R, V).join("");
        }
        function kJ(c, d, p) {
          if (c = Mn(c), c && (p || d === n))
            return c.slice(0, $k(c) + 1);
          if (!c || !(d = js(d)))
            return c;
          var S = Za(c), v = Ok(S, Za(d)) + 1;
          return ll(S, 0, v).join("");
        }
        function _J(c, d, p) {
          if (c = Mn(c), c && (p || d === n))
            return c.replace(eE, "");
          if (!c || !(d = js(d)))
            return c;
          var S = Za(c), v = Mk(S, Za(d));
          return ll(S, v).join("");
        }
        function NJ(c, d) {
          var p = U, S = j;
          if (kr(d)) {
            var v = "separator" in d ? d.separator : v;
            p = "length" in d ? $t(d.length) : p, S = "omission" in d ? js(d.omission) : S;
          }
          c = Mn(c);
          var R = c.length;
          if (Hh(c)) {
            var V = Za(c);
            R = V.length;
          }
          if (p >= R)
            return c;
          var Y = p - Uh(S);
          if (Y < 1)
            return S;
          var ee = V ? ll(V, 0, Y).join("") : c.slice(0, Y);
          if (v === n)
            return ee + S;
          if (V && (Y += ee.length - Y), tS(v)) {
            if (c.slice(Y).search(v)) {
              var Ee, Se = ee;
              for (v.global || (v = bE(v.source, Mn(rk.exec(v)) + "g")), v.lastIndex = 0; Ee = v.exec(Se); )
                var Ce = Ee.index;
              ee = ee.slice(0, Ce === n ? Y : Ce);
            }
          } else if (c.indexOf(js(v), Y) != Y) {
            var Ve = ee.lastIndexOf(v);
            Ve > -1 && (ee = ee.slice(0, Ve));
          }
          return ee + S;
        }
        function DJ(c) {
          return c = Mn(c), c && XA.test(c) ? c.replace(Hf, aK) : c;
        }
        var IJ = Yh(function(c, d, p) {
          return c + (p ? " " : "") + d.toUpperCase();
        }), iS = C_("toUpperCase");
        function v3(c, d, p) {
          return c = Mn(c), d = p ? n : d, d === n ? tK(c) ? lK(c) : zV(c) : c.match(d) || [];
        }
        var x3 = Wt(function(c, d) {
          try {
            return Ks(c, n, d);
          } catch (p) {
            return eS(p) ? p : new kt(p);
          }
        }), RJ = wu(function(c, d) {
          return fa(d, function(p) {
            p = $o(p), Eu(c, p, XE(c[p], c));
          }), c;
        });
        function PJ(c) {
          var d = c == null ? 0 : c.length, p = ct();
          return c = d ? Ar(c, function(S) {
            if (typeof S[1] != "function")
              throw new ma(a);
            return [p(S[0]), S[1]];
          }) : [], Wt(function(S) {
            for (var v = -1; ++v < d; ) {
              var R = c[v];
              if (Ks(R[0], this, S))
                return Ks(R[1], this, S);
            }
          });
        }
        function LJ(c) {
          return az(pa(c, f));
        }
        function sS(c) {
          return function() {
            return c;
          };
        }
        function MJ(c, d) {
          return c == null || c !== c ? d : c;
        }
        var OJ = __(), BJ = __(!0);
        function Ts(c) {
          return c;
        }
        function aS(c) {
          return s_(typeof c == "function" ? c : pa(c, f));
        }
        function $J(c) {
          return o_(pa(c, f));
        }
        function HJ(c, d) {
          return u_(c, pa(d, f));
        }
        var UJ = Wt(function(c, d) {
          return function(p) {
            return qf(p, c, d);
          };
        }), GJ = Wt(function(c, d) {
          return function(p) {
            return qf(c, p, d);
          };
        });
        function oS(c, d, p) {
          var S = pi(d), v = Yp(d, S);
          p == null && !(kr(d) && (v.length || !S.length)) && (p = d, d = c, c = this, v = Yp(d, pi(d)));
          var R = !(kr(p) && "chain" in p) || !!p.chain, V = Tu(c);
          return fa(v, function(Y) {
            var ee = d[Y];
            c[Y] = ee, V && (c.prototype[Y] = function() {
              var Ee = this.__chain__;
              if (R || Ee) {
                var Se = c(this.__wrapped__), Ce = Se.__actions__ = Ss(this.__actions__);
                return Ce.push({ func: ee, args: arguments, thisArg: c }), Se.__chain__ = Ee, Se;
              }
              return ee.apply(c, rl([this.value()], arguments));
            });
          }), c;
        }
        function WJ() {
          return Pi._ === this && (Pi._ = gK), this;
        }
        function uS() {
        }
        function VJ(c) {
          return c = $t(c), Wt(function(d) {
            return l_(d, c);
          });
        }
        var KJ = $E(Ar), zJ = $E(Nk), jJ = $E(cE);
        function C3(c) {
          return zE(c) ? hE($o(c)) : Fz(c);
        }
        function YJ(c) {
          return function(d) {
            return c == null ? n : Pc(c, d);
          };
        }
        var qJ = D_(), JJ = D_(!0);
        function lS() {
          return [];
        }
        function cS() {
          return !1;
        }
        function QJ() {
          return {};
        }
        function XJ() {
          return "";
        }
        function ZJ() {
          return !0;
        }
        function eQ(c, d) {
          if (c = $t(c), c < 1 || c > te)
            return [];
          var p = Me, S = ji(c, Me);
          d = ct(d), c -= Me;
          for (var v = mE(S, d); ++p < c; )
            d(p);
          return v;
        }
        function tQ(c) {
          return _t(c) ? Ar(c, $o) : Ys(c) ? [c] : Ss(j_(Mn(c)));
        }
        function nQ(c) {
          var d = ++fK;
          return Mn(c) + d;
        }
        var rQ = e0(function(c, d) {
          return c + d;
        }, 0), iQ = HE("ceil"), sQ = e0(function(c, d) {
          return c / d;
        }, 1), aQ = HE("floor");
        function oQ(c) {
          return c && c.length ? jp(c, Ts, vE) : n;
        }
        function uQ(c, d) {
          return c && c.length ? jp(c, ct(d, 2), vE) : n;
        }
        function lQ(c) {
          return Rk(c, Ts);
        }
        function cQ(c, d) {
          return Rk(c, ct(d, 2));
        }
        function hQ(c) {
          return c && c.length ? jp(c, Ts, _E) : n;
        }
        function dQ(c, d) {
          return c && c.length ? jp(c, ct(d, 2), _E) : n;
        }
        var fQ = e0(function(c, d) {
          return c * d;
        }, 1), mQ = HE("round"), gQ = e0(function(c, d) {
          return c - d;
        }, 0);
        function pQ(c) {
          return c && c.length ? fE(c, Ts) : 0;
        }
        function bQ(c, d) {
          return c && c.length ? fE(c, ct(d, 2)) : 0;
        }
        return _.after = $Y, _.ary = i3, _.assign = xq, _.assignIn = y3, _.assignInWith = f0, _.assignWith = Cq, _.at = kq, _.before = s3, _.bind = XE, _.bindAll = RJ, _.bindKey = a3, _.castArray = QY, _.chain = t3, _.chunk = aj, _.compact = oj, _.concat = uj, _.cond = PJ, _.conforms = LJ, _.constant = sS, _.countBy = pY, _.create = _q, _.curry = o3, _.curryRight = u3, _.debounce = l3, _.defaults = Nq, _.defaultsDeep = Dq, _.defer = HY, _.delay = UY, _.difference = lj, _.differenceBy = cj, _.differenceWith = hj, _.drop = dj, _.dropRight = fj, _.dropRightWhile = mj, _.dropWhile = gj, _.fill = pj, _.filter = yY, _.flatMap = SY, _.flatMapDeep = wY, _.flatMapDepth = FY, _.flatten = Q_, _.flattenDeep = bj, _.flattenDepth = yj, _.flip = GY, _.flow = OJ, _.flowRight = BJ, _.fromPairs = Aj, _.functions = Bq, _.functionsIn = $q, _.groupBy = TY, _.initial = Sj, _.intersection = wj, _.intersectionBy = Fj, _.intersectionWith = Tj, _.invert = Uq, _.invertBy = Gq, _.invokeMap = xY, _.iteratee = aS, _.keyBy = CY, _.keys = pi, _.keysIn = Fs, _.map = o0, _.mapKeys = Vq, _.mapValues = Kq, _.matches = $J, _.matchesProperty = HJ, _.memoize = l0, _.merge = zq, _.mergeWith = A3, _.method = UJ, _.methodOf = GJ, _.mixin = oS, _.negate = c0, _.nthArg = VJ, _.omit = jq, _.omitBy = Yq, _.once = WY, _.orderBy = kY, _.over = KJ, _.overArgs = VY, _.overEvery = zJ, _.overSome = jJ, _.partial = ZE, _.partialRight = c3, _.partition = _Y, _.pick = qq, _.pickBy = E3, _.property = C3, _.propertyOf = YJ, _.pull = kj, _.pullAll = Z_, _.pullAllBy = _j, _.pullAllWith = Nj, _.pullAt = Dj, _.range = qJ, _.rangeRight = JJ, _.rearg = KY, _.reject = IY, _.remove = Ij, _.rest = zY, _.reverse = JE, _.sampleSize = PY, _.set = Qq, _.setWith = Xq, _.shuffle = LY, _.slice = Rj, _.sortBy = BY, _.sortedUniq = Hj, _.sortedUniqBy = Uj, _.split = SJ, _.spread = jY, _.tail = Gj, _.take = Wj, _.takeRight = Vj, _.takeRightWhile = Kj, _.takeWhile = zj, _.tap = oY, _.throttle = YY, _.thru = a0, _.toArray = g3, _.toPairs = S3, _.toPairsIn = w3, _.toPath = tQ, _.toPlainObject = b3, _.transform = Zq, _.unary = qY, _.union = jj, _.unionBy = Yj, _.unionWith = qj, _.uniq = Jj, _.uniqBy = Qj, _.uniqWith = Xj, _.unset = eJ, _.unzip = QE, _.unzipWith = e3, _.update = tJ, _.updateWith = nJ, _.values = Qh, _.valuesIn = rJ, _.without = Zj, _.words = v3, _.wrap = JY, _.xor = eY, _.xorBy = tY, _.xorWith = nY, _.zip = rY, _.zipObject = iY, _.zipObjectDeep = sY, _.zipWith = aY, _.entries = S3, _.entriesIn = w3, _.extend = y3, _.extendWith = f0, oS(_, _), _.add = rQ, _.attempt = x3, _.camelCase = oJ, _.capitalize = F3, _.ceil = iQ, _.clamp = iJ, _.clone = XY, _.cloneDeep = eq, _.cloneDeepWith = tq, _.cloneWith = ZY, _.conformsTo = nq, _.deburr = T3, _.defaultTo = MJ, _.divide = sQ, _.endsWith = uJ, _.eq = to, _.escape = lJ, _.escapeRegExp = cJ, _.every = bY, _.find = AY, _.findIndex = q_, _.findKey = Iq, _.findLast = EY, _.findLastIndex = J_, _.findLastKey = Rq, _.floor = aQ, _.forEach = n3, _.forEachRight = r3, _.forIn = Pq, _.forInRight = Lq, _.forOwn = Mq, _.forOwnRight = Oq, _.get = nS, _.gt = rq, _.gte = iq, _.has = Hq, _.hasIn = rS, _.head = X_, _.identity = Ts, _.includes = vY, _.indexOf = Ej, _.inRange = sJ, _.invoke = Wq, _.isArguments = Oc, _.isArray = _t, _.isArrayBuffer = sq, _.isArrayLike = ws, _.isArrayLikeObject = Vr, _.isBoolean = aq, _.isBuffer = cl, _.isDate = oq, _.isElement = uq, _.isEmpty = lq, _.isEqual = cq, _.isEqualWith = hq, _.isError = eS, _.isFinite = dq, _.isFunction = Tu, _.isInteger = h3, _.isLength = h0, _.isMap = d3, _.isMatch = fq, _.isMatchWith = mq, _.isNaN = gq, _.isNative = pq, _.isNil = yq, _.isNull = bq, _.isNumber = f3, _.isObject = kr, _.isObjectLike = $r, _.isPlainObject = tm, _.isRegExp = tS, _.isSafeInteger = Aq, _.isSet = m3, _.isString = d0, _.isSymbol = Ys, _.isTypedArray = Jh, _.isUndefined = Eq, _.isWeakMap = Sq, _.isWeakSet = wq, _.join = vj, _.kebabCase = hJ, _.last = ya, _.lastIndexOf = xj, _.lowerCase = dJ, _.lowerFirst = fJ, _.lt = Fq, _.lte = Tq, _.max = oQ, _.maxBy = uQ, _.mean = lQ, _.meanBy = cQ, _.min = hQ, _.minBy = dQ, _.stubArray = lS, _.stubFalse = cS, _.stubObject = QJ, _.stubString = XJ, _.stubTrue = ZJ, _.multiply = fQ, _.nth = Cj, _.noConflict = WJ, _.noop = uS, _.now = u0, _.pad = mJ, _.padEnd = gJ, _.padStart = pJ, _.parseInt = bJ, _.random = aJ, _.reduce = NY, _.reduceRight = DY, _.repeat = yJ, _.replace = AJ, _.result = Jq, _.round = mQ, _.runInContext = Z, _.sample = RY, _.size = MY, _.snakeCase = EJ, _.some = OY, _.sortedIndex = Pj, _.sortedIndexBy = Lj, _.sortedIndexOf = Mj, _.sortedLastIndex = Oj, _.sortedLastIndexBy = Bj, _.sortedLastIndexOf = $j, _.startCase = wJ, _.startsWith = FJ, _.subtract = gQ, _.sum = pQ, _.sumBy = bQ, _.template = TJ, _.times = eQ, _.toFinite = vu, _.toInteger = $t, _.toLength = p3, _.toLower = vJ, _.toNumber = Aa, _.toSafeInteger = vq, _.toString = Mn, _.toUpper = xJ, _.trim = CJ, _.trimEnd = kJ, _.trimStart = _J, _.truncate = NJ, _.unescape = DJ, _.uniqueId = nQ, _.upperCase = IJ, _.upperFirst = iS, _.each = n3, _.eachRight = r3, _.first = X_, oS(_, (function() {
          var c = {};
          return Oo(_, function(d, p) {
            Ln.call(_.prototype, p) || (c[p] = d);
          }), c;
        })(), { chain: !1 }), _.VERSION = r, fa(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(c) {
          _[c].placeholder = _;
        }), fa(["drop", "take"], function(c, d) {
          sn.prototype[c] = function(p) {
            p = p === n ? 1 : ai($t(p), 0);
            var S = this.__filtered__ && !d ? new sn(this) : this.clone();
            return S.__filtered__ ? S.__takeCount__ = ji(p, S.__takeCount__) : S.__views__.push({
              size: ji(p, Me),
              type: c + (S.__dir__ < 0 ? "Right" : "")
            }), S;
          }, sn.prototype[c + "Right"] = function(p) {
            return this.reverse()[c](p).reverse();
          };
        }), fa(["filter", "map", "takeWhile"], function(c, d) {
          var p = d + 1, S = p == H || p == X;
          sn.prototype[c] = function(v) {
            var R = this.clone();
            return R.__iteratees__.push({
              iteratee: ct(v, 3),
              type: p
            }), R.__filtered__ = R.__filtered__ || S, R;
          };
        }), fa(["head", "last"], function(c, d) {
          var p = "take" + (d ? "Right" : "");
          sn.prototype[c] = function() {
            return this[p](1).value()[0];
          };
        }), fa(["initial", "tail"], function(c, d) {
          var p = "drop" + (d ? "" : "Right");
          sn.prototype[c] = function() {
            return this.__filtered__ ? new sn(this) : this[p](1);
          };
        }), sn.prototype.compact = function() {
          return this.filter(Ts);
        }, sn.prototype.find = function(c) {
          return this.filter(c).head();
        }, sn.prototype.findLast = function(c) {
          return this.reverse().find(c);
        }, sn.prototype.invokeMap = Wt(function(c, d) {
          return typeof c == "function" ? new sn(this) : this.map(function(p) {
            return qf(p, c, d);
          });
        }), sn.prototype.reject = function(c) {
          return this.filter(c0(ct(c)));
        }, sn.prototype.slice = function(c, d) {
          c = $t(c);
          var p = this;
          return p.__filtered__ && (c > 0 || d < 0) ? new sn(p) : (c < 0 ? p = p.takeRight(-c) : c && (p = p.drop(c)), d !== n && (d = $t(d), p = d < 0 ? p.dropRight(-d) : p.take(d - c)), p);
        }, sn.prototype.takeRightWhile = function(c) {
          return this.reverse().takeWhile(c).reverse();
        }, sn.prototype.toArray = function() {
          return this.take(Me);
        }, Oo(sn.prototype, function(c, d) {
          var p = /^(?:filter|find|map|reject)|While$/.test(d), S = /^(?:head|last)$/.test(d), v = _[S ? "take" + (d == "last" ? "Right" : "") : d], R = S || /^find/.test(d);
          v && (_.prototype[d] = function() {
            var V = this.__wrapped__, Y = S ? [1] : arguments, ee = V instanceof sn, Ee = Y[0], Se = ee || _t(V), Ce = function(Jt) {
              var mn = v.apply(_, rl([Jt], Y));
              return S && Ve ? mn[0] : mn;
            };
            Se && p && typeof Ee == "function" && Ee.length != 1 && (ee = Se = !1);
            var Ve = this.__chain__, Ze = !!this.__actions__.length, mt = R && !Ve, Ut = ee && !Ze;
            if (!R && Se) {
              V = Ut ? V : new sn(this);
              var gt = c.apply(V, Y);
              return gt.__actions__.push({ func: a0, args: [Ce], thisArg: n }), new ga(gt, Ve);
            }
            return mt && Ut ? c.apply(this, Y) : (gt = this.thru(Ce), mt ? S ? gt.value()[0] : gt.value() : gt);
          });
        }), fa(["pop", "push", "shift", "sort", "splice", "unshift"], function(c) {
          var d = Ip[c], p = /^(?:push|sort|unshift)$/.test(c) ? "tap" : "thru", S = /^(?:pop|shift)$/.test(c);
          _.prototype[c] = function() {
            var v = arguments;
            if (S && !this.__chain__) {
              var R = this.value();
              return d.apply(_t(R) ? R : [], v);
            }
            return this[p](function(V) {
              return d.apply(_t(V) ? V : [], v);
            });
          };
        }), Oo(sn.prototype, function(c, d) {
          var p = _[d];
          if (p) {
            var S = p.name + "";
            Ln.call(Kh, S) || (Kh[S] = []), Kh[S].push({ name: d, func: p });
          }
        }), Kh[Zp(n, x).name] = [{
          name: "wrapper",
          func: n
        }], sn.prototype.clone = DK, sn.prototype.reverse = IK, sn.prototype.value = RK, _.prototype.at = uY, _.prototype.chain = lY, _.prototype.commit = cY, _.prototype.next = hY, _.prototype.plant = fY, _.prototype.reverse = mY, _.prototype.toJSON = _.prototype.valueOf = _.prototype.value = gY, _.prototype.first = _.prototype.head, Gf && (_.prototype[Gf] = dY), _;
      }), Gh = cK();
      _c ? ((_c.exports = Gh)._ = Gh, aE._ = Gh) : Pi._ = Gh;
    }).call(Rne);
  })(xm, xm.exports)), xm.exports;
}
var dB = Pne();
const p0 = /* @__PURE__ */ kh(dB);
function fB(t) {
  return !!t && typeof t.navigator < "u";
}
function Lne(t) {
  return fB(t) ? t.navigator.language : null;
}
function Mne(t) {
  return t?.document?.referrer;
}
const One = ({ isSSR: t, animatedScrollTo: e }) => {
  const n = globalThis.window, r = async (l) => {
    if (t)
      return Promise.resolve();
    if (!l)
      return Promise.reject({ error: "unable to copy null value" });
    (await import("./index-CQq7GOf9.js").then((f) => f.i)).default(l);
  };
  function i(l, h, f) {
    if (typeof l !== f)
      return {
        param: h,
        value: l,
        expectedType: f
      };
  }
  const s = (l) => {
    console.error(`Wix code SDK error: ${l}`);
  }, a = (l, h, f) => {
    p0.isNil(l) && (l = 0), p0.isNil(h) && (h = 0);
    let m = i(l, "x", "number") || i(h, "y", "number");
    if (!m && f && (m = i(f, "options", "object")), m) {
      const { param: g, value: A, expectedType: E } = m;
      return s(`The ${g} parameter that is passed cannot be set to the value ${A}. It must be of type ${E}.`), { error: m, x: l, y: h };
    }
    return { x: l, y: h };
  };
  return {
    copyToClipboard: r,
    rendering: {
      env: t ? "backend" : "browser",
      renderCycle: 1
    },
    scrollTo: (l, h, f) => t ? Promise.resolve() : new Promise((m, g) => {
      if (a(l, h, f).error) {
        g({});
        return;
      }
      const E = f?.scrollAnimation !== !1;
      if (!t)
        return E || n.scrollTo(l, h), e?.(h);
    }),
    scrollBy: (l, h) => t ? Promise.resolve() : new Promise((f, m) => {
      if (a(l, h).error) {
        m({});
        return;
      }
      if (!t)
        return n.scrollBy(l, h), new Promise((A) => {
          n.requestAnimationFrame(() => {
            A();
          });
        });
    }),
    getBoundingRect: () => t ? null : Promise.resolve({
      window: {
        height: n.innerHeight,
        width: n.innerWidth
      },
      document: {
        height: document.documentElement.scrollHeight,
        width: document.documentElement.clientWidth
      },
      scroll: {
        x: n.scrollX,
        y: n.scrollY
      }
    }),
    browserLocale: Lne(n),
    referrer: Mne(n),
    getCurrentGeolocation() {
      return t ? Promise.resolve() : fB(n) ? new Promise((l, h) => {
        navigator.geolocation.getCurrentPosition(({ timestamp: f, coords: m }) => {
          const g = p0.pick(p0.toPlainObject(m), [
            "latitude",
            "longitude",
            "altitude",
            "accuracy",
            "altitudeAccuracy",
            "heading",
            "speed"
          ]);
          l({
            timestamp: f,
            coords: g
          });
        }, ({ message: f, code: m }) => {
          h({ message: f, code: m });
        });
      }) : Promise.reject(new Error("Geolocation not available"));
    }
  };
}, Bne = la(hB, ({ config: t, getService: e }) => {
  const n = e(No), r = e(eC);
  return One({
    ...t,
    animatedScrollTo: r.animatedScrollTo,
    isSSR: n.isSSR()
  });
}), $ne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WindowNsService: Bne
}, Symbol.toStringTag, { value: "Module" })), Hne = /* @__PURE__ */ vt($ne);
var Gd;
(function(t) {
  t[t.Completed = 0] = "Completed", t[t.Aborted = 1] = "Aborted";
})(Gd || (Gd = {}));
function Une(t, e, n, r, i) {
  return (t - e) * ((i - r) / (n - e)) + r;
}
function eN(t) {
  const e = dB.unzip(t), n = e[0], r = e[1];
  return function(i) {
    let s = 0;
    for (; s < n.length - 2 && i > n[s + 1]; )
      s++;
    return Une(i, n[s], n[s + 1], r[s], r[s + 1]);
  };
}
let ES = null;
const Gne = "mobile", Wne = "desktop";
function Vne(t, e, n) {
  ES = ES || {
    desktop: eN([
      [0, 0.6],
      [360, 0.8],
      [720, 1],
      [1440, 1.2],
      [7200, 2.8],
      [9600, 3],
      [1e4, 3]
    ]),
    mobile: eN([
      [0, 0.5],
      [360, 0.7],
      [720, 0.9],
      [1440, 1.1],
      [7200, 2.7],
      [9600, 2.9],
      [1e4, 2.9]
    ])
  };
  const r = Math.abs(e - t);
  return ES[n ? Gne : Wne](r);
}
const Kne = (t) => globalThis.window.getComputedStyle(t).getPropertyValue("position").toLowerCase();
function zne(t) {
  return t instanceof HTMLElement ? t.scrollTop : t.scrollY;
}
const jne = () => {
  const t = window.document.getElementById("WIX_ADS");
  return t ? t.offsetHeight : 0;
}, Yne = (t) => Number(t.replace("px", "")), qne = (t, e, n, r = !1) => {
  const i = Jne(window, n);
  if (!i)
    return 0;
  const s = Kne(i), a = s === "fixed" || s === "sticky", o = i.getBoundingClientRect().height, l = Math.abs(t - o - e) < o;
  return a && (!r || l) ? o : 0;
}, Jne = (t, e) => {
  let n = t.document.getElementById(e || "SITE_HEADER");
  if (!n) {
    const r = t.document.getElementsByTagName("header");
    r && r.length === 1 && (n = r[0]);
  }
  return n;
}, Qne = (t) => -(Math.cos(Math.PI * t) - 1) / 2, tN = 10;
class Xne {
  window;
  viewMode;
  reducedMotion;
  getScrollableElement;
  getTopLocation;
  addScrollInteractionEventListeners;
  getCompClientYForScroll;
  removeScrollInteractionEventListeners;
  animationFrameId = null;
  isAborted = !1;
  currentTargetY;
  updateCount = 0;
  targetUpdateCount = 0;
  constructor(e, n, r, i, s, a, o, u) {
    this.window = e, this.viewMode = n, this.reducedMotion = r, this.getScrollableElement = i, this.getTopLocation = s, this.addScrollInteractionEventListeners = a, this.getCompClientYForScroll = o, this.removeScrollInteractionEventListeners = u, this.currentTargetY = 0;
  }
  /**
   * Scrolls to the specified Y position with a smooth animation.
   * @param targetY - The target Y position to scroll to
   * @param callbacks - Optional callbacks for animation events:
   *   - onComplete: Called when animation completes successfully
   *   - onAbort: Called when animation is aborted by user interaction
   * @param targetSetterCallback - Optional callback that provides a function to update
   *   the target Y position during animation. This allows for dynamic target updates
   *   while respecting the MAX_TARGET_UPDATES limit.
   * @returns A promise that resolves with the animation result:
   *   - ScrollAnimationResult.Completed: Animation completed successfully
   *   - ScrollAnimationResult.Aborted: Animation was interrupted by user
   */
  scrollTo(e, n = {}, r) {
    this.currentTargetY = e, this.isAborted = !1, this.updateCount = 0, this.targetUpdateCount = 0, this.animationFrameId = null;
    const i = this.getScrollableElement();
    return this.reducedMotion ? (i.scrollTo({ top: e }), n.onComplete?.(), Promise.resolve(Gd.Completed)) : (this.animationFrameId !== null && (cancelAnimationFrame(this.animationFrameId), this.animationFrameId = null), new Promise((s) => {
      const a = () => {
        this.isAborted = !0, this.removeScrollInteractionEventListeners(a), i.scrollTo({ top: this.getTopLocation(i) }), this.animationFrameId !== null && (cancelAnimationFrame(this.animationFrameId), this.animationFrameId = null), s(Gd.Aborted);
      };
      this.addScrollInteractionEventListeners(a);
      const o = this.getTopLocation(i), u = this.viewMode === "mobile", l = Vne(this.window.pageYOffset, this.currentTargetY, u) * 1e3, h = performance.now(), f = (m) => {
        if (this.isAborted)
          return;
        const g = m - h, A = Math.min(g / l, 1), E = this.currentTargetY - o, w = o + E * Qne(A);
        i.scrollTo(0, w), g < l ? this.animationFrameId = this.window.requestAnimationFrame(f) : (i.scrollTo(0, this.currentTargetY), this.animationFrameId = null, this.removeScrollInteractionEventListeners(a), n.onComplete?.(), s(Gd.Completed));
      };
      this.window.requestAnimationFrame(f), r && r(this.setTargetY.bind(this));
    }));
  }
  /**
   * Sets a new target Y position during the animation
   * @param newTargetY - The new target Y position
   */
  setTargetY(e) {
    this.targetUpdateCount >= tN || (this.currentTargetY = e, this.targetUpdateCount++);
  }
  /**
   * Observes the Y position of an element during scroll animation
   * @param element - The element to observe
   * @param openLightboxId - The ID of the open lightbox
   * @param initialY - The initial Y position
   * @param callback - Callback function to handle Y position changes
   * @returns A function to stop observing
   */
  observeElementYPosition(e, n, r, i) {
    let s = !0, a = null, o = r, u = 0;
    const l = () => {
      s = !1, a !== null && (cancelAnimationFrame(a), a = null);
    }, h = async () => {
      if (!s)
        return;
      const f = await this.getAnimationFrameClientYForScroll(e, n || "");
      f !== o && (u++, u <= tN ? (i(f, o), o = f) : l()), s && (a = requestAnimationFrame(() => h()));
    };
    return a = requestAnimationFrame(() => h()), l;
  }
  /**
   * Gets the client Y position for scrolling to an element using requestAnimationFrame
   * @param compNode The component node to get the position for
   * @param openLightboxId The ID of the open lightbox, if any
   * @returns A promise that resolves to the client Y position
   * @public
   */
  async getAnimationFrameClientYForScroll(e, n) {
    return new Promise((r) => {
      this.window.requestAnimationFrame(() => {
        r(this.getCompClientYForScroll(e, n));
      });
    });
  }
}
const Zne = ({ reducedMotion: t, viewMode: e, isSSR: n, isScrollingBlocked: r, isHeaderAnimated: i, headerContainerComponentId: s, scrollContext: a }) => {
  const o = globalThis.window;
  if (n)
    return {
      animatedScrollTo: () => Promise.resolve(Gd.Aborted),
      scrollToSelector: () => Promise.resolve()
    };
  function u(g) {
    o.removeEventListener("touchmove", g), o.removeEventListener("wheel", g);
  }
  function l(g) {
    o.addEventListener("touchmove", g, { passive: !0 }), o.addEventListener("wheel", g, { passive: !0 });
  }
  const h = (g, A) => {
    const E = A && o.document.getElementById(A);
    let w = E ? E.getBoundingClientRect().top : o.document.body.getBoundingClientRect().top;
    if (r()) {
      const D = o.document.getElementById("SITE_CONTAINER");
      w = D ? Yne(o.getComputedStyle(D).marginTop) : 0;
    }
    const N = jne(), P = g.getBoundingClientRect().top - w, C = qne(P, N, s, i);
    return P - N - (A ? 0 : C);
  }, f = new Xne(o, e, t, () => a, zne, l, h, u);
  return {
    animatedScrollTo: async (g, A = {}, E) => f.scrollTo(g, A, E)
    // scrollToSelector,
  };
}, ere = la(eC, ({ config: t, getService: e }) => {
  const n = e(Gx), r = e(No);
  return Zne({
    ...t,
    reducedMotion: r.reducedMotion,
    // we can remove this and call the function from the feature after it's resolved?
    readyForScrollPromise: Promise.resolve(),
    isSSR: r.isSSR(),
    isScrollingBlocked: n.isScrollingBlocked
  });
}), tre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WindowScrollService: ere
}, Symbol.toStringTag, { value: "Module" })), nre = /* @__PURE__ */ vt(tre), rre = /* @__PURE__ */ vt(Ine), mB = du("@wix/viewer-service-fedops-logger"), ire = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FedopsLoggerDefinition: mB
}, Symbol.toStringTag, { value: "Module" })), sre = /* @__PURE__ */ vt(ire), are = () => {
  const t = (...n) => {
  }, e = (...n) => ({ timeoutId: 0 });
  return {
    createFedopsLogger: (n) => ({
      interactionStarted: e,
      interactionEnded: t,
      appLoadingPhaseStart: t,
      appLoadingPhaseFinish: t,
      appLoadStarted: t,
      appLoaded: t
    })
  };
}, ore = Ja(mB, (t) => are()), ure = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FedopsLoggerService: ore
}, Symbol.toStringTag, { value: "Module" })), lre = /* @__PURE__ */ vt(ure), tC = "@wix/viewer-service-wix-client", cre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WixClientDefinition: tC
}, Symbol.toStringTag, { value: "Module" })), hre = /* @__PURE__ */ vt(cre);
var Et = {};
function nN(t, e = !1, n = (r) => r) {
  return () => ({
    __type: "event-definition",
    type: t,
    isDomainEvent: e,
    transformations: n
  });
}
var dre = "wix_spi_error";
const fre = (t) => {
  switch (t) {
    case "get":
    case "GET":
      return "GET";
    case "post":
    case "POST":
      return "POST";
    case "put":
    case "PUT":
      return "PUT";
    case "delete":
    case "DELETE":
      return "DELETE";
    case "patch":
    case "PATCH":
      return "PATCH";
    case "head":
    case "HEAD":
      return "HEAD";
    case "options":
    case "OPTIONS":
      return "OPTIONS";
    default:
      throw new Error(`Unknown method: ${t}`);
  }
}, mre = (t) => (e) => async (n) => {
  let r;
  const i = (s) => {
    if (r = t(n)(s), r.url === void 0)
      throw new Error("Url was not successfully created for this request, please reach out to support channels for assistance.");
    const { method: a, url: o, params: u } = r;
    return {
      ...r,
      method: fre(a),
      url: o,
      data: r.data,
      params: u
    };
  };
  try {
    const s = await e.request(i);
    if (r === void 0)
      throw new Error("Request options were not created for this request, please reach out to support channels for assistance.");
    const a = Array.isArray(r.transformResponse) ? r.transformResponse : [r.transformResponse];
    let o = s.data;
    return a.forEach((u) => {
      u && (o = u(s.data, s.headers));
    }), o;
  } catch (s) {
    throw typeof s == "object" && s !== null && "response" in s && typeof s.response == "object" && s.response !== null && "data" in s.response ? s.response.data : s;
  }
}, gre = (t) => t.__isAmbassador ? !0 : !!t().__isAmbassador, pre = "__metadata", Wd = "www.wixapis.com", bre = "edge.wixapis.com";
class yre extends Error {
  message;
  response;
  constructor(e, n) {
    super(e), this.message = e, this.response = n;
  }
  async details() {
    const e = await this.response.json();
    return Are(this.response.status, e?.message, e?.details, {
      requestId: this.response.headers.get("X-Wix-Request-Id"),
      details: e
    });
  }
}
const Are = (t, e, n, r) => ({
  details: {
    ...!n?.validationError && {
      applicationError: {
        description: e,
        code: t,
        data: r
      }
    },
    ...n
  },
  message: e,
  requestId: r?.requestId
}), Ere = (t) => t?.method && ["post", "put", "patch"].includes(t.method.toLocaleLowerCase()) && t.body ? { "Content-Type": "application/json" } : {}, Sre = (t) => t && typeof t == "object" && !Array.isArray(t), wre = (t) => t.__type === "host";
function Fre(t, e) {
  return t.create(e);
}
const Tre = "x-wix-bi-gateway";
function gB(t, e, n) {
  return {
    [Tre]: vre({
      environment: `js-sdk${n ? `-${n}` : ""}`,
      "package-name": t.packageName ?? e?.PACKAGE_NAME,
      "method-fqn": t.methodFqn,
      entity: t.entityFqdn
    })
  };
}
function vre(t) {
  return Object.entries(t).filter(([e, n]) => !!n).map(([e, n]) => `${e}=${n}`).join(",");
}
function pB(t) {
  const e = globalThis.__wix_context__, n = {
    client: Et.client,
    elevatedClient: Et.elevatedClient
  };
  let r;
  globalThis.__wix_context__ = void 0, Et.client = void 0, Et.elevatedClient = void 0, typeof $wixContext < "u" && (r = {
    client: $wixContext?.client,
    elevatedClient: $wixContext?.elevatedClient
  }, delete $wixContext.client, delete $wixContext.elevatedClient);
  try {
    return t();
  } finally {
    globalThis.__wix_context__ = e, Et.client = n.client, Et.elevatedClient = n.elevatedClient, typeof $wixContext < "u" && ($wixContext.client = r.client, $wixContext.elevatedClient = r.elevatedClient);
  }
}
const rN = {
  id: "_id",
  createdDate: "_createdDate",
  updatedDate: "_updatedDate"
};
function nC(t) {
  return _re(t).map((e) => e.toLocaleUpperCase()).join("_");
}
const xre = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), Cre = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), iN = "$1\0$2", kre = /[^\p{L}\d]+/giu;
function _re(t) {
  let e = t.trim();
  e = e.replace(xre, iN).replace(Cre, iN), e = e.replace(kre, "\0");
  let n = 0, r = e.length;
  for (; e.charAt(n) === "\0"; )
    n++;
  if (n === r)
    return [];
  for (; e.charAt(r - 1) === "\0"; )
    r--;
  return e.slice(n, r).split(/\0/g);
}
const Nre = (t) => "validationError" in (t.response?.data?.details ?? {}), Dre = (t) => "applicationError" in (t.response?.data?.details ?? {}), Ire = (t) => (t.response?.status ?? -1) >= 400 && (t.response?.status ?? -1) < 500;
function Rre(t, e = {
  explicitPathsToArguments: {},
  spreadPathsToArguments: {},
  singleArgumentUnchanged: !1
}, n = []) {
  if (typeof t != "object" || t === null)
    throw t;
  if (Nre(t))
    return Pre(t, e, n);
  if (Dre(t))
    return Lre(t);
  if (Ire(t)) {
    const r = t.response?.status, i = t.response?.statusText ?? "UNKNOWN", s = t.response?.data?.message ?? i, a = {
      applicationError: {
        description: i,
        code: nC(i),
        data: {}
      },
      requestId: t.requestId
    };
    return uA(t, {
      message: JSON.stringify({
        message: s,
        details: a
      }, null, 2),
      extraProperties: {
        details: a,
        status: r
      }
    });
  }
  return Mre(t);
}
const Pre = (t, e, n) => {
  const r = t.response?.data, i = t.requestId, { fieldViolations: s } = r.details.validationError, a = Ore(e, s, n)?.sort((l, h) => l.field < h.field ? -1 : 1), o = `INVALID_ARGUMENT: ${a?.map(({ field: l, description: h }) => `"${l}" ${h}`)?.join(", ")}`, u = {
    validationError: { fieldViolations: a },
    requestId: i
  };
  return uA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: t.response?.status,
      requestId: i
    }
  });
}, uA = (t, { message: e, extraProperties: n }) => Object.assign(t, {
  ...n,
  message: e
}), Lre = (t) => {
  const e = t.response?.status, n = t.response?.statusText ?? "UNKNOWN", r = t.response?.data?.message ?? n, i = t.response?.data?.details?.applicationError?.description ?? n, s = t.response?.data?.details?.applicationError?.code ?? nC(n), a = t.response?.data?.details?.applicationError?.data ?? {}, o = r === i ? r : `${r}: ${i}`, u = {
    applicationError: {
      description: i,
      code: s,
      data: a
    },
    requestId: t.requestId
  };
  return uA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: e,
      requestId: t.requestId
    }
  });
}, Mre = (t) => {
  const e = t.requestId ? `System error occurred, request-id: ${t.requestId}` : `System error occurred: ${JSON.stringify(t)}`;
  return uA(t, {
    message: e,
    extraProperties: {
      requestId: t.requestId,
      status: t.response?.status,
      code: nC(t.response?.statusText ?? "UNKNOWN"),
      ...!t.response && {
        runtimeError: t
      }
    }
  });
}, Ore = ({ spreadPathsToArguments: t, explicitPathsToArguments: e, singleArgumentUnchanged: n }, r, i) => {
  const s = {
    ...t,
    ...e
  }, a = Object.keys(s);
  return r?.filter((o) => !r.some((l) => l.field.length > o.field.length && l.field.startsWith(o.field) && a.includes(l.field))).map((o) => {
    const u = e[o.field];
    if (u)
      return {
        ...o,
        field: sN(u, i)
      };
    const l = a?.sort((h, f) => f.length - h.length)?.find((h) => o.field.startsWith(h));
    if (l) {
      const h = s[l];
      if (h)
        return {
          ...o,
          field: o.field.replace(l, sN(h, i))
        };
    }
    return n ? {
      ...o,
      field: `${i[0]}.${o.field}`
    } : o;
  });
}, sN = (t, e) => {
  const n = Bre(t);
  return n !== null && typeof n < "u" ? t.replace(`$[${n}]`, e[n]) : t;
}, Bre = (t) => {
  const e = t.match(/\$\[(?<argIndex>\d+)\]/);
  return e && e.groups && Number(e.groups.argIndex);
};
function $re(t, e, n, r, i, s, a, o, u, l) {
  return pB(() => t({
    request: async (h) => {
      const f = h({
        host: o?.HTTPHost || Wd
      });
      let m = f;
      m.method === "GET" && m.fallback?.length && (m.params?.toString().length ?? 0) > 4e3 && (m = f.fallback[0]);
      const g = o?.HTTPHost ?? Wd;
      let A = `https://${l ? bre : g}${m.url}`;
      m.params && m.params.toString() && (A += `?${m.params.toString()}`);
      try {
        const E = gB(f, e, u), w = {
          method: m.method,
          ...m.data && {
            body: JSON.stringify(m.data)
          },
          headers: {
            ...E
          }
        }, x = await n(A, w);
        if (x.status !== 200) {
          let P = null;
          try {
            P = await x.json();
          } catch {
          }
          const C = Ure(x.status, P?.message, P?.details, {
            requestId: x.headers.get("X-Wix-Request-Id"),
            details: P
          }), D = Rre(C);
          throw r?.handleError(D, {
            requestOptions: {
              url: m.url,
              method: m.method,
              entityFqdn: f.entityFqdn,
              methodFqn: f.methodFqn
            }
          }), C;
        }
        const N = await x.json();
        return {
          data: (
            // we only transform the response if the optInTransformResponse flag is set
            // this is for backwards compatibility as some users might rely on not transforming the response
            // in older modules. In that case the modules would not have the optInTransformResponse flag set
            m.migrationOptions?.optInTransformResponse && m.transformResponse ? Array.isArray(m.transformResponse) ? m.transformResponse[0](N) : m.transformResponse(N) : N
          ),
          headers: x.headers,
          status: x.status,
          statusText: x.statusText
        };
      } catch (E) {
        throw E.message?.includes("fetch is not defined") && console.error("Node.js v18+ is required"), E;
      }
    },
    fetchWithAuth: n,
    wixAPIFetch: i,
    getActiveToken: s,
    getAuthHeaders: a
  }));
}
class Hre extends Error {
  response;
  requestId;
  constructor(e) {
    super(), this.response = e.response, this.requestId = e.requestId;
  }
}
const Ure = (t, e, n, r) => new Hre({
  response: {
    data: {
      details: {
        ...!n?.validationError && {
          applicationError: {
            description: e,
            code: t,
            data: r
          }
        },
        ...n
      },
      message: e
    },
    status: t
  },
  requestId: r?.requestId
}), Gre = ".";
function Wre(t, e, n) {
  if (t == null)
    throw new Error("Cannot set value on null or undefined");
  const r = bB(e);
  let i = t;
  for (let s = 0; s < r.length; s++) {
    const a = r[s];
    if (s === r.length - 1) {
      i[a] = n;
      break;
    }
    const o = r[s + 1];
    !(a in i) || i[a] == null ? i[a] = typeof o == "number" ? [] : {} : (typeof i[a] != "object" || i[a] === null) && (i[a] = typeof o == "number" ? [] : {}), i = i[a];
  }
  return t;
}
function bB(t) {
  return Array.isArray(t) ? t : t.split(Gre).map((e) => Vre(e) ? Number(e) : e);
}
function Vre(t) {
  return /^\d+$/.test(t);
}
function Kre(t) {
  const e = {};
  for (const [n, r] of Object.entries(t)) {
    if (zre(n))
      continue;
    const i = bB(n);
    Wre(e, i, r);
  }
  return e;
}
function zre(t) {
  return t === "__proto__" || t === "constructor" || t === "prototype";
}
class jre {
  BRACKET_PATTERN = /\[(\d+)\]/g;
  NUMERIC_PATTERN = /^\d+$/;
  ESCAPED_DOT_PATTERN = /\\\./g;
  ESCAPED_LEFT_BRACKET_PATTERN = /\\\[/g;
  ESCAPED_RIGHT_BRACKET_PATTERN = /\\\]/g;
  SPLIT_PATTERN = /\.|\[(\d+)\]/g;
  DOT_BEFORE_BRACKET_PATTERN = /\.\[/g;
  ESCAPED_DOT_PLACEHOLDER = "__DOT__";
  ESCAPED_RIGHT_BRACKET_PLACEHOLDER = "__RB__";
  ESCAPED_LEFT_BRACKET_PLACEHOLDER = "__LB__";
  modifiedFields;
  cleanedModifiedFields;
  constructor(e) {
    this.modifiedFields = e;
  }
  replaceEscapedCharacters(e) {
    return e.replace(this.ESCAPED_DOT_PATTERN, this.ESCAPED_DOT_PLACEHOLDER).replace(this.ESCAPED_LEFT_BRACKET_PATTERN, this.ESCAPED_LEFT_BRACKET_PLACEHOLDER).replace(this.ESCAPED_RIGHT_BRACKET_PATTERN, this.ESCAPED_RIGHT_BRACKET_PLACEHOLDER);
  }
  restoreEscapedCharacters(e) {
    return e.replace(this.ESCAPED_DOT_PLACEHOLDER, "\\.").replace(this.ESCAPED_RIGHT_BRACKET_PLACEHOLDER, "\\]").replace(this.ESCAPED_LEFT_BRACKET_PLACEHOLDER, "\\[");
  }
  unflatten() {
    return this.cleanedModifiedFields = Object.fromEntries(Object.entries(this.modifiedFields).map(([e, n]) => [
      this.replaceEscapedCharacters(this.bracketToDotNotation(e)),
      n
    ])), Kre(this.cleanedModifiedFields);
  }
  flatten(e) {
    let n = {};
    for (const r of Object.keys(this.cleanedModifiedFields)) {
      const i = this.splitPath(r), s = this.navigatePath(e, i);
      n = { ...n, ...s };
    }
    return Object.fromEntries(Object.entries(n).map(([r, i]) => [
      this.restoreEscapedCharacters(r),
      i
    ]));
  }
  splitPath(e) {
    const n = [];
    let r = 0;
    const i = Array.from(e.matchAll(this.SPLIT_PATTERN));
    for (const s of i)
      s.index > r && n.push(e.substring(r, s.index)), s[1] && n.push(s[1]), r = s.index + s[0].length;
    return r < e.length && n.push(e.substring(r)), n;
  }
  navigatePath(e, n) {
    let r = e;
    const i = [], s = (u) => {
      if (!Array.isArray(r))
        throw new Error(`Expected array at path ${this.buildPathString(i)}, but got ${typeof r}`);
      i.push(`[${u}]`), r = r[parseInt(u, 10)];
    }, a = (u, l) => {
      const h = u in rN ? rN[u] : void 0;
      if (h && h in l) {
        i.push(h), r = l[h];
        return;
      }
      const f = Qre(u);
      if (f && f in l) {
        i.push(f), r = l[f];
        return;
      }
      throw new Error(`Cannot find key '${u}' or its transformations at path ${this.buildPathString(i)}`);
    }, o = (u, l) => {
      i.push(u), r = l[u];
    };
    for (const u of n) {
      if (this.NUMERIC_PATTERN.test(u)) {
        s(u);
        continue;
      }
      if (r === null || typeof r != "object")
        throw new Error(`Cannot access property '${u}' on ${typeof r} at path ${this.buildPathString(i)}`);
      const l = r;
      if (u in r) {
        o(u, l);
        continue;
      }
      a(u, l);
    }
    return { [this.buildPathString(i)]: r };
  }
  buildPathString(e) {
    return e.join(".").replace(this.DOT_BEFORE_BRACKET_PATTERN, "[");
  }
  bracketToDotNotation(e) {
    return e.replace(this.BRACKET_PATTERN, (n, r, i) => i > 0 && e[i - 1] === "\\" ? n : "." + r);
  }
}
function Yre(t, e) {
  const n = t?.modifiedFields;
  if (!n)
    return null;
  const r = qre(n);
  if (!r)
    return null;
  const { unflattenedModifiedFields: i, modifiedFieldsManipulator: s } = r;
  t = {
    ...t,
    modifiedFields: i
  };
  const a = e(t), o = a?.modifiedFields;
  if (!o)
    return null;
  const u = Jre(o, s);
  return u !== null ? (a.modifiedFields = u, a) : null;
}
function qre(t) {
  if (typeof t == "object" && t !== null && !Array.isArray(t))
    try {
      const e = new jre(t);
      return {
        unflattenedModifiedFields: e.unflatten(),
        modifiedFieldsManipulator: e
      };
    } catch {
      return null;
    }
  return null;
}
function Jre(t, e) {
  if (typeof t == "object" && t !== null && !Array.isArray(t))
    try {
      return e.flatten(t);
    } catch {
      return null;
    }
  return null;
}
function Qre(t) {
  return t.replace(/[-_\s]+(.)?/g, (e, n) => n ? n.toUpperCase() : "").replace(/^./, (e) => e.toLowerCase());
}
function yB() {
  return {
    emit(t, ...e) {
      for (let n = 0, r = this.events[t] || [], i = r.length; n < i; n++)
        r[n](...e);
    },
    events: {},
    on(t, e) {
      return (this.events[t] ||= []).push(e), () => {
        this.events[t] = this.events[t]?.filter((n) => e !== n);
      };
    }
  };
}
const Xre = (t) => t.__type === "event-definition";
function aN(t, e, n, r) {
  let i;
  if (t.isDomainEvent) {
    const u = n, { deletedEvent: l, actionEvent: h, createdEvent: f, updatedEvent: m, ...g } = u, A = {
      ...r,
      ...g
    };
    l ? l?.deletedEntity ? i = {
      entity: l?.deletedEntity,
      metadata: A
    } : i = { metadata: A } : h ? i = {
      data: h.body,
      metadata: A
    } : m ? i = {
      entity: m.currentEntity,
      metadata: A,
      ...m.modifiedFields ? { modifiedFields: m.modifiedFields } : {}
    } : i = {
      entity: f?.entity,
      metadata: A
    };
  } else
    i = {
      data: n,
      metadata: r
    };
  const s = t.transformations ?? ((u) => u);
  let a = i;
  const o = i;
  if (o.modifiedFields) {
    const u = o.modifiedFields;
    if (typeof u == "object" && u !== null && !Array.isArray(u)) {
      a = structuredClone(i);
      const l = Yre(o, s);
      if (l)
        return e(l);
    }
  }
  return e(s(a));
}
function Zre(t) {
  const e = /* @__PURE__ */ new Map(), n = yB(), r = {
    ...n,
    getRegisteredEvents: () => e,
    async process(i, s = {
      expectedEvents: []
    }) {
      const { eventType: a, identity: o, instanceId: u, payload: l, accountInfo: h } = await this.parseJWT(i), f = [
        ...s.expectedEvents,
        ...Array.from(e.keys()).map((g) => ({ type: g }))
      ];
      if (f.length > 0 && !f.some(({ type: g }) => g === a))
        throw new Error(`Unexpected event type: ${a}. Expected one of: ${f.map((g) => g.type).join(", ")}`);
      const m = e.get(a) ?? [];
      return await Promise.all(m.map(({ eventDefinition: g, handler: A }) => aN(g, A, l, {
        instanceId: u,
        identity: o,
        accountInfo: h
      }))), {
        instanceId: u,
        eventType: a,
        payload: l,
        identity: o,
        accountInfo: h
      };
    },
    async processRequest(i, s) {
      const a = await i.text();
      return this.process(a, s);
    },
    async parseJWT(i) {
      const s = t();
      if (!s.decodeJWT)
        throw new Error("decodeJWT is not supported by the authentication strategy");
      const { decoded: a, valid: o } = await s.decodeJWT(i);
      if (!o)
        throw new Error("JWT is not valid");
      if (typeof a.data != "string")
        throw new Error(`Unexpected type of JWT data: expected string, got ${typeof a.data}`);
      const u = JSON.parse(a.data), l = u.eventType, h = u.accountInfo, f = u.instanceId, m = u.identity ? JSON.parse(u.identity) : void 0, g = JSON.parse(u.data);
      return {
        instanceId: f,
        eventType: l,
        payload: g,
        identity: m,
        accountInfo: h
      };
    },
    async parseRequest(i) {
      const s = await i.text();
      return this.parseJWT(s);
    },
    async executeHandlers(i) {
      const s = Array.from(e.keys()).map((o) => ({ type: o }));
      if (s.length > 0 && !s.some(({ type: o }) => o === i.eventType))
        throw new Error(`Unexpected event type: ${i.eventType}. Expected one of: ${s.map((o) => o.type).join(", ")}`);
      const a = e.get(i.eventType) ?? [];
      await Promise.all(a.map(({ eventDefinition: o, handler: u }) => aN(o, u, i.payload, {
        instanceId: i.instanceId,
        identity: i.identity
      })));
    },
    apps: {
      AppInstalled: nN("AppInstalled")(),
      AppRemoved: nN("AppRemoved")()
    }
  };
  return {
    initModule(i) {
      return (s) => {
        const a = e.get(i.type) ?? [];
        a.push({ eventDefinition: i, handler: s }), e.set(i.type, a), n.emit("registered", i);
      };
    },
    client: r
  };
}
const eie = (t) => t.__type === "service-plugin-definition";
function tie(t) {
  const e = /* @__PURE__ */ new Map(), n = yB(), r = {
    ...n,
    getRegisteredServicePlugins: () => e,
    async parseJWT(i) {
      const s = t();
      if (!s.decodeJWT)
        throw new Error("decodeJWT is not supported by the authentication strategy");
      const { decoded: a, valid: o } = await s.decodeJWT(i, !0);
      if (!o)
        throw new Error("JWT is not valid");
      if (typeof a.data != "object" || a.data === null || !("metadata" in a.data) || typeof a.data.metadata != "object" || a.data.metadata === null || !("appExtensionType" in a.data.metadata) || typeof a.data.metadata.appExtensionType != "string")
        throw new Error("Unexpected JWT data: expected object with metadata.appExtensionType string");
      return a.data;
    },
    async process(i) {
      const s = await this.parseJWT(i.body);
      return this.executeHandler(s, i.url);
    },
    async parseRequest(i) {
      const s = await i.text();
      return this.parseJWT(s);
    },
    async processRequest(i) {
      const s = i.url, a = await i.text();
      try {
        const o = await this.process({ url: s, body: a });
        return Response.json(o);
      } catch (o) {
        if (o.errorType === "SPI" && o.applicationCode && o.httpCode)
          return Response.json({ applicationError: { code: o.applicationCode, data: o.data } }, { status: o.httpCode });
        throw o;
      }
    },
    async executeHandler(i, s) {
      const a = i.metadata.appExtensionType.toLowerCase(), o = e.get(a) ?? [];
      if (o.length === 0)
        throw new Error(`No service plugin implementations found for component type ${a}`);
      if (o.length > 1)
        throw new Error(`Multiple service plugin implementations found for component type ${a}. This is currently not supported`);
      const { implementation: u, servicePluginDefinition: l } = o[0], h = l.methods.find((m) => s.endsWith(m.primaryHttpMappingPath));
      if (!h)
        throw new Error("Unexpect request: request url did not match any method: " + s);
      const f = u[h.name];
      if (!f)
        throw new Error(`Got request for service plugin method ${h.name} but no implementation was provided. Available methods: ${Object.keys(u).join(", ")}`);
      return h.transformations.toREST(await f(h.transformations.fromREST(i)));
    }
  };
  return {
    initModule(i) {
      return (s) => {
        const a = e.get(i.componentType.toLowerCase()) ?? [];
        a.push({ servicePluginDefinition: i, implementation: s }), e.set(i.componentType.toLowerCase(), a), n.emit("registered", i);
      };
    },
    client: r
  };
}
const oo = "X-Wix-Consistent";
function AB(t) {
  const e = t.headers || { Authorization: "" }, n = {
    getAuthHeaders: (E) => Promise.resolve({ headers: {} })
  }, r = t.auth, i = typeof r == "function" ? r : () => r ?? n, s = () => i().getAuthHeaders(t.host), a = async (E, w) => {
    const x = await s(), N = {
      ...w?.headers ?? {},
      ...x.headers,
      ...t.host?.essentials?.passThroughHeaders,
      ...e[oo] ? { [oo]: e[oo] } : {}
    }, B = t.host?.getErrorHandler?.();
    try {
      if (typeof E == "string" || E instanceof URL) {
        const P = await fetch(E, {
          ...w,
          headers: N
        });
        B?.handleError(P, {
          requestOptions: {
            url: E.toString(),
            method: w?.method
          }
        });
        const C = SS(P);
        return C && (e[oo] = C), P;
      } else {
        for (const [D, L] of Object.entries(N))
          typeof L == "string" && E.headers.set(D, L);
        const P = await fetch(E, w);
        B?.handleError(P, {
          requestOptions: {
            url: E.url,
            method: w?.method
          }
        });
        const C = SS(P);
        return C && (e[oo] = C), P;
      }
    } catch (P) {
      throw B?.handleError(P, {
        requestOptions: {
          url: typeof E == "string" || E instanceof URL ? E.toString() : E.url,
          method: w?.method
        }
      }), P;
    }
  }, { client: o, initModule: u } = tie(i), { client: l, initModule: h } = Zre(i), f = async (E, w) => {
    const x = await s(), N = Ere(w), B = await fetch(E, {
      ...w,
      headers: {
        ...N,
        ...e,
        ...x?.headers,
        ...w?.headers,
        ...t.host?.essentials?.passThroughHeaders,
        // Ensure consistent header always takes precedence
        ...e[oo] ? { [oo]: e[oo] } : {}
      }
    }), P = SS(B);
    return P && (e[oo] = P), B;
  }, m = (E, w) => {
    if (Xre(E))
      return h(E);
    if (eie(E))
      return u(E);
    if (wre(E) && t.host)
      return Fre(E, t.host);
    if (typeof E == "function") {
      if ("__type" in E && E.__type === dre)
        return E;
      const x = t.host?.apiBaseUrl ?? Wd, N = t.useCDN === void 0 ? i().shouldUseCDN : t.useCDN;
      return $re(
        pB(() => gre(E)) ? mre(E) : E,
        w ?? {},
        f,
        t.host?.getErrorHandler?.(),
        (B, P) => {
          const C = new URL(B, `https://${x}`);
          return C.host = x, C.protocol = "https", f(C.toString(), P);
        },
        i().getActiveToken,
        // async wrapper normalizes the sync/async union from AuthenticationStrategy.getAuthHeaders
        async () => s(),
        { HTTPHost: x },
        t.host?.name,
        N
      );
    } else return Sre(E) ? Object.fromEntries(Object.entries(E).map(([x, N]) => [x, m(N, E[pre])])) : E;
  }, g = (E) => {
    for (const w in E)
      e[w] = E[w];
  };
  return {
    ...t.modules ? m(t.modules) : {},
    get auth() {
      const E = i(), w = E.getAuthHeaders;
      return E.getAuthHeaders = w.bind(void 0, t.host), E;
    },
    setHeaders: g,
    use: m,
    enableContext(E, w = { elevated: !1 }) {
      E === "global" ? globalThis.__wix_context__ != null ? w.elevated ? globalThis.__wix_context__.elevatedClient = this : globalThis.__wix_context__.client = this : w.elevated ? globalThis.__wix_context__ = { elevatedClient: this } : globalThis.__wix_context__ = { client: this } : w.elevated ? Et.elevatedClient = this : Et.client = this;
    },
    /**
     * @param relativeUrl The URL to fetch relative to the API base URL
     * @param options The fetch options
     * @returns The fetch Response object
     * @deprecated Use `fetchWithAuth` instead
     */
    fetch: (E, w) => {
      const x = t.host?.apiBaseUrl ?? Wd, N = new URL(E, `https://${x}`);
      return N.host = x, N.protocol = "https", f(N.toString(), w);
    },
    fetchWithAuth: a,
    async graphql(E, w, x = {
      apiVersion: "alpha"
    }) {
      const N = t?.host?.apiBaseUrl ?? Wd, B = await f(`https://${N}/graphql/${x.apiVersion}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ query: E, variables: w })
      });
      if (B.status !== 200)
        throw new yre(`GraphQL request failed with status ${B.status}`, B);
      const { data: P, errors: C } = await B.json();
      return { data: P ?? {}, errors: C };
    },
    webhooks: l,
    servicePlugins: o
  };
}
function SS(t) {
  return t.headers?.get(oo) ?? t.headers?.get(oo.toLowerCase());
}
const nie = {
  _id: "id",
  _createdDate: "createdDate",
  _updatedDate: "updatedDate"
}, rie = {
  id: "_id",
  createdDate: "_createdDate",
  updatedDate: "_updatedDate"
};
function EB(t, e, n) {
  const r = (s) => n.includes(s), i = (s, a) => {
    if (Array.isArray(s))
      s.forEach((o) => {
        i(o, a);
      });
    else if (typeof s == "object" && s !== null) {
      const o = s;
      Object.keys(o).forEach((u) => {
        const l = a === "" ? u : `${a}.${u}`;
        if (r(l))
          return;
        const h = iie(u, e);
        h !== u && !(h in o) && (o[h] = o[u], delete o[u]), i(o[h], l);
      });
    }
  };
  return i(t, ""), t;
}
function iie(t, e) {
  let n;
  return t.includes(".") ? n = t.split(".").map((s) => e[s] ?? s).join(".") : n = e[t] ?? t, n;
}
function sie(t, e = []) {
  return EB(t, nie, e);
}
function SB(t, e = []) {
  return EB(t, rie, e);
}
function aie(t) {
  return t ? new Date(t) : void 0;
}
function Cm(t, { path: e, isRepeated: n, isMap: r }, i) {
  const s = e.split(".");
  if (s.length === 1 && e in t)
    return t[e] = n ? t[e].map(i) : r ? Object.fromEntries(Object.entries(t[e]).map(([u, l]) => [u, i(l)])) : i(t[e]), t;
  const [a, ...o] = s;
  if (a.endsWith("{}")) {
    const u = a.slice(0, -2);
    t[u] = Object.fromEntries(Object.entries(t[u]).map(([l, h]) => [
      l,
      Cm(h, { path: o.join("."), isRepeated: n, isMap: r }, i)
    ]));
  } else Array.isArray(t[a]) ? t[a] = t[a].map((u) => Cm(u, { path: o.join("."), isRepeated: n, isMap: r }, i)) : a in t && typeof t[a] == "object" && t[a] !== null ? t[a] = Cm(t[a], { path: o.join("."), isRepeated: n, isMap: r }, i) : a === "*" && Object.keys(t).reduce((u, l) => (u[l] = Cm(t[l], { path: o.join("."), isRepeated: n, isMap: r }, i), u), t);
  return t;
}
function oie(t, e) {
  return e.reduce((n, { paths: r, transformFn: i }) => r.reduce((s, a) => Cm(s, a, i), n), t);
}
function uie(t, e = !1, n = (r) => r) {
  return () => ({
    __type: "event-definition",
    type: t,
    isDomainEvent: e,
    transformations: n
  });
}
function rC(t) {
  return die(t).map((e) => e.toLocaleUpperCase()).join("_");
}
const lie = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), cie = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), oN = "$1\0$2", hie = /[^\p{L}\d]+/giu;
function die(t) {
  let e = t.trim();
  e = e.replace(lie, oN).replace(cie, oN), e = e.replace(hie, "\0");
  let n = 0, r = e.length;
  for (; e.charAt(n) === "\0"; )
    n++;
  if (n === r)
    return [];
  for (; e.charAt(r - 1) === "\0"; )
    r--;
  return e.slice(n, r).split(/\0/g);
}
const fie = (t) => "validationError" in (t.response?.data?.details ?? {}), mie = (t) => "applicationError" in (t.response?.data?.details ?? {}), gie = (t) => (t.response?.status ?? -1) >= 400 && (t.response?.status ?? -1) < 500;
function pie(t, e = {
  explicitPathsToArguments: {},
  spreadPathsToArguments: {},
  singleArgumentUnchanged: !1
}, n = []) {
  if (typeof t != "object" || t === null)
    throw t;
  if (fie(t))
    return bie(t, e, n);
  if (mie(t))
    return yie(t);
  if (gie(t)) {
    const r = t.response?.status, i = t.response?.statusText ?? "UNKNOWN", s = t.response?.data?.message ?? i, a = {
      applicationError: {
        description: i,
        code: rC(i),
        data: {}
      },
      requestId: t.requestId
    };
    return lA(t, {
      message: JSON.stringify({
        message: s,
        details: a
      }, null, 2),
      extraProperties: {
        details: a,
        status: r
      }
    });
  }
  return Aie(t);
}
const bie = (t, e, n) => {
  const r = t.response?.data, i = t.requestId, { fieldViolations: s } = r.details.validationError, a = Eie(e, s, n)?.sort((l, h) => l.field < h.field ? -1 : 1), o = `INVALID_ARGUMENT: ${a?.map(({ field: l, description: h }) => `"${l}" ${h}`)?.join(", ")}`, u = {
    validationError: { fieldViolations: a },
    requestId: i
  };
  return lA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: t.response?.status,
      requestId: i
    }
  });
}, lA = (t, { message: e, extraProperties: n }) => Object.assign(t, {
  ...n,
  message: e
}), yie = (t) => {
  const e = t.response?.status, n = t.response?.statusText ?? "UNKNOWN", r = t.response?.data?.message ?? n, i = t.response?.data?.details?.applicationError?.description ?? n, s = t.response?.data?.details?.applicationError?.code ?? rC(n), a = t.response?.data?.details?.applicationError?.data ?? {}, o = r === i ? r : `${r}: ${i}`, u = {
    applicationError: {
      description: i,
      code: s,
      data: a
    },
    requestId: t.requestId
  };
  return lA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: e,
      requestId: t.requestId
    }
  });
}, Aie = (t) => {
  const e = t.requestId ? `System error occurred, request-id: ${t.requestId}` : `System error occurred: ${JSON.stringify(t)}`;
  return lA(t, {
    message: e,
    extraProperties: {
      requestId: t.requestId,
      status: t.response?.status,
      code: rC(t.response?.statusText ?? "UNKNOWN"),
      ...!t.response && {
        runtimeError: t
      }
    }
  });
}, Eie = ({ spreadPathsToArguments: t, explicitPathsToArguments: e, singleArgumentUnchanged: n }, r, i) => {
  const s = {
    ...t,
    ...e
  }, a = Object.keys(s);
  return r?.filter((o) => !r.some((l) => l.field.length > o.field.length && l.field.startsWith(o.field) && a.includes(l.field))).map((o) => {
    const u = e[o.field];
    if (u)
      return {
        ...o,
        field: uN(u, i)
      };
    const l = a?.sort((h, f) => f.length - h.length)?.find((h) => o.field.startsWith(h));
    if (l) {
      const h = s[l];
      if (h)
        return {
          ...o,
          field: o.field.replace(l, uN(h, i))
        };
    }
    return n ? {
      ...o,
      field: `${i[0]}.${o.field}`
    } : o;
  });
}, uN = (t, e) => {
  const n = Sie(t);
  return n !== null && typeof n < "u" ? t.replace(`$[${n}]`, e[n]) : t;
}, Sie = (t) => {
  const e = t.match(/\$\[(?<argIndex>\d+)\]/);
  return e && e.groups && Number(e.groups.argIndex);
};
function wB() {
  const t = typeof $wixContext < "u" && $wixContext.initWixModules ? $wixContext.initWixModules : typeof globalThis.__wix_context__ < "u" && globalThis.__wix_context__.initWixModules ? globalThis.__wix_context__.initWixModules : void 0;
  if (t)
    return {
      // @ts-expect-error
      initWixModules(r, i) {
        return wS(() => t(r, i));
      },
      fetchWithAuth() {
        throw new Error("fetchWithAuth is not available in this context");
      },
      graphql() {
        throw new Error("graphql is not available in this context");
      }
    };
  const e = typeof $wixContext < "u" ? $wixContext.client : typeof Et.client < "u" ? Et.client : typeof globalThis.__wix_context__ < "u" ? globalThis.__wix_context__.client : void 0, n = typeof $wixContext < "u" ? $wixContext.elevatedClient : typeof Et.elevatedClient < "u" ? Et.elevatedClient : typeof globalThis.__wix_context__ < "u" ? globalThis.__wix_context__.elevatedClient : void 0;
  if (!(!e && !n))
    return {
      initWixModules(r, i) {
        if (i) {
          if (!n)
            throw new Error("An elevated client is required to use elevated modules. Make sure to initialize the Wix context with an elevated client before using elevated SDK modules");
          return wS(() => n.use(r));
        }
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return wS(() => e.use(r));
      },
      fetchWithAuth: (r, i) => {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.fetchWithAuth(r, i);
      },
      getAuth() {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.auth;
      },
      async graphql(r, i, s) {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.graphql(r, i, s);
      }
    };
}
function wS(t) {
  const e = globalThis.__wix_context__, n = {
    client: Et.client,
    elevatedClient: Et.elevatedClient
  };
  let r;
  globalThis.__wix_context__ = void 0, Et.client = void 0, Et.elevatedClient = void 0, typeof $wixContext < "u" && (r = {
    client: $wixContext?.client,
    elevatedClient: $wixContext?.elevatedClient
  }, delete $wixContext.client, delete $wixContext.elevatedClient);
  try {
    return t();
  } finally {
    globalThis.__wix_context__ = e, Et.client = n.client, Et.elevatedClient = n.elevatedClient, typeof $wixContext < "u" && ($wixContext.client = r.client, $wixContext.elevatedClient = r.elevatedClient);
  }
}
function wie(t, e) {
  return ((...n) => {
    const r = wB();
    return r ? r.initWixModules(t, e).apply(void 0, n) : t.apply(void 0, n);
  });
}
function Fie(t) {
  const e = ((...n) => {
    const r = wB();
    return r ? r.initWixModules(t).apply(void 0, n) : () => ({
      slug: t.type
    });
  });
  return e.__type = t.__type, e.type = t.type, e.isDomainEvent = t.isDomainEvent, e.transformations = t.transformations, e;
}
function Tie(t, e = !1) {
  return wie(t, e);
}
function vie(t) {
  const e = Pie(t.host), n = Mie(e, t.domainToMappings), r = Hie(t.protoPath, t.data || {});
  return Wie(r, n);
}
const xie = ["wix.com", "editorx.com"], Cie = "_", kie = new RegExp(`\\.(${xie.join("|")})$`), _ie = ["42.wixprod.net", "uw2-edt-1.wixprod.net"], Nie = "dev.wix-code.com", Die = /{(.*)}/, Iie = new RegExp(`\\.(${_ie.join("|")})$`), Rie = new RegExp(`.*\\.${Nie}$`);
function Pie(t) {
  return Lie(t).replace(kie, "._base_domain_").replace(Iie, "._api_base_domain_").replace(Rie, "*.dev.wix-code.com");
}
function Lie(t) {
  return t.replace("create.editorx.com", "editor.editorx.com");
}
function Mie(t, e) {
  const n = e[t] || e[Cie];
  if (n)
    return n;
  const r = Oie(t, e);
  return !r && Bie(t) ? e[$ie] : r ?? [];
}
function Oie(t, e) {
  return Object.entries(e).find(([n]) => {
    const [, ...r] = t.split(".");
    return r.join(".") === n;
  })?.[1];
}
function Bie(t) {
  return !!t.match(/\._base_domain_$/);
}
const $ie = "www._base_domain_";
function Hie(t, e) {
  return t.split("/").map((n) => Uie(n, e)).join("/");
}
function Uie(t, e) {
  const n = t.match(Die) || [], r = n[1];
  if (r) {
    const i = t.replace(n[0], "");
    return Gie(e, r, t, i);
  }
  return t;
}
function Gie(t, e, n, r) {
  let i = t;
  for (const s of e.split(".")) {
    if (!i)
      return n;
    i = i[s];
  }
  return `${i}${r}`;
}
function Wie(t, e) {
  const n = e?.find((r) => t.startsWith(r.destPath));
  return n ? n.srcPath + t.slice(n.destPath.length) : t;
}
function Vie(t) {
  return Fie(t);
}
function Kie(t) {
  return vie(Object.assign(t, { domainToMappings: {
    "www._base_domain_": [
      {
        srcPath: "/_api/redirects-api",
        destPath: ""
      }
    ],
    "www.wixapis.com": [
      {
        srcPath: "/_api/redirects-api",
        destPath: ""
      },
      {
        srcPath: "/redirect-session",
        destPath: ""
      },
      {
        srcPath: "/headless/v1/redirect-session",
        destPath: "/v1/redirect-session"
      }
    ],
    "*.dev.wix-code.com": [
      {
        srcPath: "/headless/v1/redirect-session",
        destPath: "/v1/redirect-session"
      }
    ],
    _: [
      {
        srcPath: "/headless/v1/redirect-session",
        destPath: "/v1/redirect-session"
      }
    ]
  } }));
}
var zie = "@wix/auto_sdk_redirects_redirects";
function jie(t) {
  function e({ host: n }) {
    return {
      entityFqdn: "wix.headless.v1.redirect_session",
      method: "POST",
      methodFqn: "wix.headless.v1.RedirectSessionService.CreateRedirectSession",
      packageName: zie,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: Kie({
        protoPath: "/v1/redirect-session",
        data: t,
        host: n
      }),
      data: t
    };
  }
  return e;
}
var FB = /* @__PURE__ */ ((t) => (t.UNDEFINED = "UNDEFINED", t.OWNER_BUSINESS = "OWNER_BUSINESS", t.OWNER_CUSTOM = "OWNER_CUSTOM", t.CUSTOM = "CUSTOM", t))(FB || {}), iC = /* @__PURE__ */ ((t) => (t.login = "login", t.none = "none", t))(iC || {}), TB = /* @__PURE__ */ ((t) => (t.ACCOUNT_INFO = "ACCOUNT_INFO", t.BOOKINGS = "BOOKINGS", t.ORDERS = "ORDERS", t.SUBSCRIPTIONS = "SUBSCRIPTIONS", t.EVENTS = "EVENTS", t))(TB || {}), vB = /* @__PURE__ */ ((t) => (t.UNKNOWN = "UNKNOWN", t.SUCCESS = "SUCCESS", t.NO_ACTION = "NO_ACTION", t.ERROR = "ERROR", t))(vB || {}), xB = /* @__PURE__ */ ((t) => (t.UNKNOWN = "UNKNOWN", t.LOGOUT = "LOGOUT", t.CHECKOUT = "CHECKOUT", t.AUTHORIZE = "AUTHORIZE", t))(xB || {}), CB = /* @__PURE__ */ ((t) => (t.UNKNOWN = "UNKNOWN", t.SUCCESS = "SUCCESS", t.ERROR = "ERROR", t))(CB || {}), kB = /* @__PURE__ */ ((t) => (t.UNKNOWN = "UNKNOWN", t.ANONYMOUS_VISITOR = "ANONYMOUS_VISITOR", t.MEMBER = "MEMBER", t.WIX_USER = "WIX_USER", t.APP = "APP", t))(kB || {});
async function Yie(t) {
  const { httpClient: e, sideEffects: n } = arguments[1], r = sie({
    bookingsCheckout: t?.bookingsCheckout,
    ecomCheckout: t?.ecomCheckout,
    eventsCheckout: t?.eventsCheckout,
    paidPlansCheckout: t?.paidPlansCheckout,
    login: t?.login,
    logout: t?.logout,
    auth: t?.auth,
    storesProduct: t?.storesProduct,
    bookingsBook: t?.bookingsBook,
    callbacks: t?.callbacks,
    preferences: t?.preferences,
    origin: t?.origin
  }), i = jie(r);
  n?.onSiteCall?.();
  try {
    const s = await e.request(i);
    return n?.onSuccess?.(s), SB(s.data);
  } catch (s) {
    const a = pie(
      s,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          bookingsCheckout: "$[0].bookingsCheckout",
          ecomCheckout: "$[0].ecomCheckout",
          eventsCheckout: "$[0].eventsCheckout",
          paidPlansCheckout: "$[0].paidPlansCheckout",
          login: "$[0].login",
          logout: "$[0].logout",
          auth: "$[0].auth",
          storesProduct: "$[0].storesProduct",
          bookingsBook: "$[0].bookingsBook",
          callbacks: "$[0].callbacks",
          preferences: "$[0].preferences",
          origin: "$[0].origin"
        },
        singleArgumentUnchanged: !1
      },
      ["options"]
    );
    throw n?.onError?.(s), a;
  }
}
function qie(t) {
  return (e) => Yie(
    e,
    // @ts-ignore
    { httpClient: t }
  );
}
var Jie = uie(
  "wix.headless.v1.redirect_session_created",
  !0,
  (t) => SB(
    oie(t, [
      {
        transformFn: aie,
        paths: [{ path: "metadata.eventTime" }]
      }
    ])
  )
)(), _B = /* @__PURE__ */ Tie(qie), Qie = Vie(
  Jie
);
const Xie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AttachPagesResponseStatus: vB,
  CallbackType: xB,
  LocationType: FB,
  MembersAccountSection: TB,
  Prompt: iC,
  Status: CB,
  WebhookIdentityType: kB,
  createRedirectSession: _B,
  onRedirectSessionCreated: Qie
}, Symbol.toStringTag, { value: "Module" }));
function NB() {
  return Math.floor(Date.now() / 1e3);
}
function lN(t) {
  const e = NB();
  return t.expiresAt < e;
}
function b0(t, e) {
  const n = NB();
  return { value: t, expiresAt: Number(e) + n };
}
const Zie = {
  _id: "id",
  _createdDate: "createdDate",
  _updatedDate: "updatedDate"
}, ese = {
  id: "_id",
  createdDate: "_createdDate",
  updatedDate: "_updatedDate"
};
function DB(t) {
  return Object.fromEntries(Object.entries(t).filter(([, e]) => e !== void 0));
}
function sC(t) {
  return ise(t).map((e) => e.toLocaleUpperCase()).join("_");
}
const tse = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), nse = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), cN = "$1\0$2", rse = /[^\p{L}\d]+/giu;
function ise(t) {
  let e = t.trim();
  e = e.replace(tse, cN).replace(nse, cN), e = e.replace(rse, "\0");
  let n = 0, r = e.length;
  for (; e.charAt(n) === "\0"; )
    n++;
  if (n === r)
    return [];
  for (; e.charAt(r - 1) === "\0"; )
    r--;
  return e.slice(n, r).split(/\0/g);
}
const sse = (t) => "validationError" in (t.response?.data?.details ?? {}), ase = (t) => "applicationError" in (t.response?.data?.details ?? {}), ose = (t) => (t.response?.status ?? -1) >= 400 && (t.response?.status ?? -1) < 500;
function Qg(t, e = {
  explicitPathsToArguments: {},
  spreadPathsToArguments: {},
  singleArgumentUnchanged: !1
}, n = []) {
  if (typeof t != "object" || t === null)
    throw t;
  if (sse(t))
    return use(t, e, n);
  if (ase(t))
    return lse(t);
  if (ose(t)) {
    const r = t.response?.status, i = t.response?.statusText ?? "UNKNOWN", s = t.response?.data?.message ?? i, a = {
      applicationError: {
        description: i,
        code: sC(i),
        data: {}
      },
      requestId: t.requestId
    };
    return cA(t, {
      message: JSON.stringify({
        message: s,
        details: a
      }, null, 2),
      extraProperties: {
        details: a,
        status: r
      }
    });
  }
  return cse(t);
}
const use = (t, e, n) => {
  const r = t.response?.data, i = t.requestId, { fieldViolations: s } = r.details.validationError, a = hse(e, s, n)?.sort((l, h) => l.field < h.field ? -1 : 1), o = `INVALID_ARGUMENT: ${a?.map(({ field: l, description: h }) => `"${l}" ${h}`)?.join(", ")}`, u = {
    validationError: { fieldViolations: a },
    requestId: i
  };
  return cA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: t.response?.status,
      requestId: i
    }
  });
}, cA = (t, { message: e, extraProperties: n }) => Object.assign(t, {
  ...n,
  message: e
}), lse = (t) => {
  const e = t.response?.status, n = t.response?.statusText ?? "UNKNOWN", r = t.response?.data?.message ?? n, i = t.response?.data?.details?.applicationError?.description ?? n, s = t.response?.data?.details?.applicationError?.code ?? sC(n), a = t.response?.data?.details?.applicationError?.data ?? {}, o = r === i ? r : `${r}: ${i}`, u = {
    applicationError: {
      description: i,
      code: s,
      data: a
    },
    requestId: t.requestId
  };
  return cA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: e,
      requestId: t.requestId
    }
  });
}, cse = (t) => {
  const e = t.requestId ? `System error occurred, request-id: ${t.requestId}` : `System error occurred: ${JSON.stringify(t)}`;
  return cA(t, {
    message: e,
    extraProperties: {
      requestId: t.requestId,
      status: t.response?.status,
      code: sC(t.response?.statusText ?? "UNKNOWN"),
      ...!t.response && {
        runtimeError: t
      }
    }
  });
}, hse = ({ spreadPathsToArguments: t, explicitPathsToArguments: e, singleArgumentUnchanged: n }, r, i) => {
  const s = {
    ...t,
    ...e
  }, a = Object.keys(s);
  return r?.filter((o) => !r.some((l) => l.field.length > o.field.length && l.field.startsWith(o.field) && a.includes(l.field))).map((o) => {
    const u = e[o.field];
    if (u)
      return {
        ...o,
        field: hN(u, i)
      };
    const l = a?.sort((h, f) => f.length - h.length)?.find((h) => o.field.startsWith(h));
    if (l) {
      const h = s[l];
      if (h)
        return {
          ...o,
          field: o.field.replace(l, hN(h, i))
        };
    }
    return n ? {
      ...o,
      field: `${i[0]}.${o.field}`
    } : o;
  });
}, hN = (t, e) => {
  const n = dse(t);
  return n !== null && typeof n < "u" ? t.replace(`$[${n}]`, e[n]) : t;
}, dse = (t) => {
  const e = t.match(/\$\[(?<argIndex>\d+)\]/);
  return e && e.groups && Number(e.groups.argIndex);
};
function IB(t, e, n) {
  const r = (s) => n.includes(s), i = (s, a) => {
    if (Array.isArray(s))
      s.forEach((o) => {
        i(o, a);
      });
    else if (typeof s == "object" && s !== null) {
      const o = s;
      Object.keys(o).forEach((u) => {
        const l = a === "" ? u : `${a}.${u}`;
        if (r(l))
          return;
        const h = fse(u, e);
        h !== u && !(h in o) && (o[h] = o[u], delete o[u]), i(o[h], l);
      });
    }
  };
  return i(t, ""), t;
}
function fse(t, e) {
  let n;
  return t.includes(".") ? n = t.split(".").map((s) => e[s] ?? s).join(".") : n = e[t] ?? t, n;
}
function Xg(t, e = []) {
  return IB(t, Zie, e);
}
function hA(t, e = []) {
  return IB(t, ese, e);
}
function mse() {
  const t = typeof $wixContext < "u" && $wixContext.initWixModules ? $wixContext.initWixModules : typeof globalThis.__wix_context__ < "u" && globalThis.__wix_context__.initWixModules ? globalThis.__wix_context__.initWixModules : void 0;
  if (t)
    return {
      // @ts-expect-error
      initWixModules(r, i) {
        return FS(() => t(r, i));
      },
      fetchWithAuth() {
        throw new Error("fetchWithAuth is not available in this context");
      },
      graphql() {
        throw new Error("graphql is not available in this context");
      }
    };
  const e = typeof $wixContext < "u" ? $wixContext.client : typeof Et.client < "u" ? Et.client : typeof globalThis.__wix_context__ < "u" ? globalThis.__wix_context__.client : void 0, n = typeof $wixContext < "u" ? $wixContext.elevatedClient : typeof Et.elevatedClient < "u" ? Et.elevatedClient : typeof globalThis.__wix_context__ < "u" ? globalThis.__wix_context__.elevatedClient : void 0;
  if (!(!e && !n))
    return {
      initWixModules(r, i) {
        if (i) {
          if (!n)
            throw new Error("An elevated client is required to use elevated modules. Make sure to initialize the Wix context with an elevated client before using elevated SDK modules");
          return FS(() => n.use(r));
        }
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return FS(() => e.use(r));
      },
      fetchWithAuth: (r, i) => {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.fetchWithAuth(r, i);
      },
      getAuth() {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.auth;
      },
      async graphql(r, i, s) {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.graphql(r, i, s);
      }
    };
}
function FS(t) {
  const e = globalThis.__wix_context__, n = {
    client: Et.client,
    elevatedClient: Et.elevatedClient
  };
  let r;
  globalThis.__wix_context__ = void 0, Et.client = void 0, Et.elevatedClient = void 0, typeof $wixContext < "u" && (r = {
    client: $wixContext?.client,
    elevatedClient: $wixContext?.elevatedClient
  }, delete $wixContext.client, delete $wixContext.elevatedClient);
  try {
    return t();
  } finally {
    globalThis.__wix_context__ = e, Et.client = n.client, Et.elevatedClient = n.elevatedClient, typeof $wixContext < "u" && ($wixContext.client = r.client, $wixContext.elevatedClient = r.elevatedClient);
  }
}
function gse(t, e) {
  return ((...n) => {
    const r = mse();
    return r ? r.initWixModules(t, e).apply(void 0, n) : t.apply(void 0, n);
  });
}
function Zg(t, e = !1) {
  return gse(t, e);
}
function pse(t, e) {
  const n = RB(t);
  return Object.entries(n).some(([r, i]) => r.includes(".") || Array.isArray(i) && i.some((s) => typeof s == "object")), Object.entries(n).reduce((r, [i, s]) => ((Array.isArray(s) ? s : [s]).forEach((o) => {
    o == null || Array.isArray(s) && typeof o == "object" || r.append(i, o);
  }), r), new URLSearchParams());
}
function bse(t) {
  const e = Cse(t.host), n = _se(e, t.domainToMappings), r = Rse(t.protoPath, t.data || {});
  return Mse(r, n);
}
function RB(t, e = "") {
  const n = {};
  return Object.entries(t).forEach(([r, i]) => {
    const s = i !== null && typeof i == "object" && !Array.isArray(i), a = yse(e, r);
    if (s) {
      const o = RB(i, a);
      Object.assign(n, o);
    } else
      n[a] = i;
  }), n;
}
function yse(t, e) {
  return `${t}${t ? "." : ""}${e}`;
}
const Ase = ["wix.com", "editorx.com"], Ese = "_", Sse = new RegExp(`\\.(${Ase.join("|")})$`), wse = ["42.wixprod.net", "uw2-edt-1.wixprod.net"], Fse = "dev.wix-code.com", Tse = /{(.*)}/, vse = new RegExp(`\\.(${wse.join("|")})$`), xse = new RegExp(`.*\\.${Fse}$`);
function Cse(t) {
  return kse(t).replace(Sse, "._base_domain_").replace(vse, "._api_base_domain_").replace(xse, "*.dev.wix-code.com");
}
function kse(t) {
  return t.replace("create.editorx.com", "editor.editorx.com");
}
function _se(t, e) {
  const n = e[t] || e[Ese];
  if (n)
    return n;
  const r = Nse(t, e);
  return !r && Dse(t) ? e[Ise] : r ?? [];
}
function Nse(t, e) {
  return Object.entries(e).find(([n]) => {
    const [, ...r] = t.split(".");
    return r.join(".") === n;
  })?.[1];
}
function Dse(t) {
  return !!t.match(/\._base_domain_$/);
}
const Ise = "www._base_domain_";
function Rse(t, e) {
  return t.split("/").map((n) => Pse(n, e)).join("/");
}
function Pse(t, e) {
  const n = t.match(Tse) || [], r = n[1];
  if (r) {
    const i = t.replace(n[0], "");
    return Lse(e, r, t, i);
  }
  return t;
}
function Lse(t, e, n, r) {
  let i = t;
  for (const s of e.split(".")) {
    if (!i)
      return n;
    i = i[s];
  }
  return `${i}${r}`;
}
function Mse(t, e) {
  const n = e?.find((r) => t.startsWith(r.destPath));
  return n ? n.srcPath + t.slice(n.destPath.length) : t;
}
function PB(t) {
  return isFinite(t) ? t : t.toString();
}
function aC(t) {
  return t === "NaN" ? NaN : t === "Infinity" ? 1 / 0 : t === "-Infinity" ? -1 / 0 : t;
}
function Ose(t) {
  return Uint8Array.from(atob(t), (e) => e.charCodeAt(0));
}
function LB(t) {
  return t?.toISOString();
}
function oC(t) {
  return t ? new Date(t) : void 0;
}
function km(t, { path: e, isRepeated: n, isMap: r }, i) {
  const s = e.split(".");
  if (s.length === 1 && e in t)
    return t[e] = n ? t[e].map(i) : r ? Object.fromEntries(Object.entries(t[e]).map(([u, l]) => [u, i(l)])) : i(t[e]), t;
  const [a, ...o] = s;
  if (a.endsWith("{}")) {
    const u = a.slice(0, -2);
    t[u] = Object.fromEntries(Object.entries(t[u]).map(([l, h]) => [
      l,
      km(h, { path: o.join("."), isRepeated: n, isMap: r }, i)
    ]));
  } else Array.isArray(t[a]) ? t[a] = t[a].map((u) => km(u, { path: o.join("."), isRepeated: n, isMap: r }, i)) : a in t && typeof t[a] == "object" && t[a] !== null ? t[a] = km(t[a], { path: o.join("."), isRepeated: n, isMap: r }, i) : a === "*" && Object.keys(t).reduce((u, l) => (u[l] = km(t[l], { path: o.join("."), isRepeated: n, isMap: r }, i), u), t);
  return t;
}
function Co(t, e) {
  return e.reduce((n, { paths: r, transformFn: i }) => r.reduce((s, a) => km(s, a, i), n), t);
}
function MB(t) {
  return t && DB({
    city: t.city,
    hint: t.hint,
    subdivision: t.subdivision,
    country: t.country,
    postalCode: t.postalCode,
    formattedAddress: t.formatted,
    geocode: t.location,
    addressLine: t.addressLine1,
    addressLine2: t.addressLine2,
    streetAddress: t.streetAddress && {
      name: t.streetAddress.name,
      number: t.streetAddress.number,
      apt: t.streetAddress.apt,
      formattedAddressLine: t.streetAddress.formattedAddressLine
    }
  });
}
function uC(t) {
  return t && DB({
    formatted: t.formattedAddress,
    location: t.geocode,
    addressLine1: t.addressLine,
    addressLine2: t.addressLine2,
    streetAddress: t.streetAddress && {
      name: t.streetAddress.name,
      number: t.streetAddress.number,
      apt: t.streetAddress.apt,
      formattedAddressLine: t.streetAddress.formattedAddressLine
    },
    hint: t.hint,
    city: t.city,
    subdivision: t.subdivision,
    country: t.country,
    postalCode: t.postalCode,
    countryFullname: t.countryFullname,
    subdivisionFullname: t.subdivisionFullname
  });
}
function ep(t) {
  return bse(Object.assign(t, { domainToMappings: {
    _: [
      {
        srcPath: "/_api/iam/authentication",
        destPath: ""
      }
    ],
    "users._base_domain_": [
      {
        srcPath: "/iam/wix/google",
        destPath: "/v1/sso/callback/root/0e6a50f5-b523-4e29-990d-f37fa2ffdd69"
      },
      {
        srcPath: "/authentication",
        destPath: ""
      },
      {
        srcPath: "/_api/iam/authentication/v1/sso/callback",
        destPath: "/v1/sso/callback"
      },
      {
        srcPath: "/_api/iam/authentication",
        destPath: ""
      }
    ],
    "www.wixapis.com": [
      {
        srcPath: "/_api/iam/authentication",
        destPath: ""
      },
      {
        srcPath: "/iam/authentication",
        destPath: ""
      }
    ],
    "bo._base_domain_": [
      {
        srcPath: "/_api/iam/authentication",
        destPath: ""
      }
    ],
    "wixbo.ai": [
      {
        srcPath: "/_api/iam/authentication",
        destPath: ""
      }
    ],
    "wix-bo.com": [
      {
        srcPath: "/_api/iam/authentication",
        destPath: ""
      }
    ],
    "dev._base_domain_": [
      {
        srcPath: "/_api/iam/authentication",
        destPath: ""
      }
    ],
    "manage._base_domain_": [
      {
        srcPath: "/_api/authentication",
        destPath: ""
      }
    ],
    "www._base_domain_": [
      {
        srcPath: "/_api/iam/authentication",
        destPath: ""
      }
    ],
    "*.dev.wix-code.com": [
      {
        srcPath: "/iam/authentication/v2/sign-on",
        destPath: "/v2/sign-on"
      },
      {
        srcPath: "/iam/authentication/v1/logout",
        destPath: "/v1/logout"
      },
      {
        srcPath: "/iam/authentication/v2/change-password",
        destPath: "/v2/change-password"
      },
      {
        srcPath: "/iam/authentication/v2/verify",
        destPath: "/v2/verify"
      },
      {
        srcPath: "/iam/authentication/v2/login",
        destPath: "/v2/login"
      },
      {
        srcPath: "/iam/authentication/v2/register",
        destPath: "/v2/register"
      },
      {
        srcPath: "/iam/authentication/v2",
        destPath: "/v2"
      }
    ]
  } }));
}
var tp = "@wix/auto_sdk_identity_authentication";
function Bse(t) {
  function e({ host: n }) {
    const r = Co(t, [
      {
        transformFn: PB,
        paths: [{ path: "profile.customFields.value.numValue" }]
      },
      {
        transformFn: LB,
        paths: [{ path: "profile.customFields.value.dateValue" }]
      }
    ]);
    return {
      entityFqdn: "wix.iam.authentication.v1.authentication",
      method: "POST",
      methodFqn: "wix.iam.authentication.v1.AuthenticationService.RegisterV2",
      packageName: tp,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: ep({
        protoPath: "/v2/register",
        data: r,
        host: n
      }),
      data: r,
      transformResponse: (s) => Co(s, [
        {
          transformFn: oC,
          paths: [
            { path: "identity.createdDate" },
            { path: "identity.updatedDate" },
            { path: "identity.identityProfile.customFields.value.dateValue" },
            { path: "additionalData.*.dateValue" }
          ]
        },
        {
          transformFn: aC,
          paths: [
            { path: "identity.identityProfile.customFields.value.numValue" },
            { path: "additionalData.*.numValue" }
          ]
        }
      ])
    };
  }
  return e;
}
function $se(t) {
  function e({ host: n }) {
    return {
      entityFqdn: "wix.iam.authentication.v1.authentication",
      method: "POST",
      methodFqn: "wix.iam.authentication.v1.AuthenticationService.LoginV2",
      packageName: tp,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: ep({
        protoPath: "/v2/login",
        data: t,
        host: n
      }),
      data: t,
      transformResponse: (i) => Co(i, [
        {
          transformFn: oC,
          paths: [
            { path: "identity.createdDate" },
            { path: "identity.updatedDate" },
            { path: "identity.identityProfile.customFields.value.dateValue" },
            { path: "additionalData.*.dateValue" }
          ]
        },
        {
          transformFn: aC,
          paths: [
            { path: "identity.identityProfile.customFields.value.numValue" },
            { path: "additionalData.*.numValue" }
          ]
        }
      ])
    };
  }
  return e;
}
function Hse(t) {
  function e({ host: n }) {
    return {
      entityFqdn: "wix.iam.authentication.v1.authentication",
      method: "POST",
      methodFqn: "wix.iam.authentication.v1.AuthenticationService.ChangePassword",
      packageName: tp,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: ep({
        protoPath: "/v2/change-password",
        data: t,
        host: n
      }),
      data: t
    };
  }
  return e;
}
function Use(t) {
  function e({ host: n }) {
    const r = Co(t, [
      {
        transformFn: PB,
        paths: [{ path: "profile.customFields.value.numValue" }]
      },
      {
        transformFn: LB,
        paths: [{ path: "profile.customFields.value.dateValue" }]
      }
    ]);
    return {
      entityFqdn: "wix.iam.authentication.v1.authentication",
      method: "POST",
      methodFqn: "wix.iam.authentication.v1.AuthenticationService.SignOn",
      packageName: tp,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: ep({
        protoPath: "/v2/sign-on",
        data: r,
        host: n
      }),
      data: r,
      transformResponse: (s) => Co(s, [
        {
          transformFn: oC,
          paths: [
            { path: "identity.createdDate" },
            { path: "identity.updatedDate" },
            { path: "identity.identityProfile.customFields.value.dateValue" }
          ]
        },
        {
          transformFn: aC,
          paths: [
            { path: "identity.identityProfile.customFields.value.numValue" }
          ]
        }
      ])
    };
  }
  return e;
}
function Gse(t) {
  function e({ host: n }) {
    return {
      entityFqdn: "wix.iam.authentication.v1.authentication",
      method: "GET",
      methodFqn: "wix.iam.authentication.v1.AuthenticationService.Logout",
      packageName: tp,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: ep({
        protoPath: "/v1/logout",
        data: t,
        host: n
      }),
      params: pse(t),
      transformResponse: (i) => Co(i, [
        {
          transformFn: Ose,
          paths: [{ path: "body" }]
        }
      ])
    };
  }
  return e;
}
var OB = /* @__PURE__ */ ((t) => (t.UNDEFINED = "UNDEFINED", t.PUBLIC = "PUBLIC", t.PRIVATE = "PRIVATE", t))(OB || {}), BB = /* @__PURE__ */ ((t) => (t.UNTAGGED = "UNTAGGED", t.MAIN = "MAIN", t.HOME = "HOME", t.WORK = "WORK", t))(BB || {}), $B = /* @__PURE__ */ ((t) => (t.UNTAGGED = "UNTAGGED", t.MAIN = "MAIN", t.HOME = "HOME", t.MOBILE = "MOBILE", t.WORK = "WORK", t.FAX = "FAX", t))($B || {}), HB = /* @__PURE__ */ ((t) => (t.UNTAGGED = "UNTAGGED", t.HOME = "HOME", t.WORK = "WORK", t.BILLING = "BILLING", t.SHIPPING = "SHIPPING", t))(HB || {}), Jm = /* @__PURE__ */ ((t) => (t.UNKNOWN_STATE = "UNKNOWN_STATE", t.SUCCESS = "SUCCESS", t.REQUIRE_OWNER_APPROVAL = "REQUIRE_OWNER_APPROVAL", t.REQUIRE_EMAIL_VERIFICATION = "REQUIRE_EMAIL_VERIFICATION", t.STATUS_CHECK = "STATUS_CHECK", t))(Jm || {}), UB = /* @__PURE__ */ ((t) => (t.UNKNOWN_STATUS = "UNKNOWN_STATUS", t.PENDING = "PENDING", t.ACTIVE = "ACTIVE", t.DELETED = "DELETED", t.BLOCKED = "BLOCKED", t.OFFLINE = "OFFLINE", t))(UB || {}), GB = /* @__PURE__ */ ((t) => (t.UNKNOWN_REASON = "UNKNOWN_REASON", t.PENDING_ADMIN_APPROVAL_REQUIRED = "PENDING_ADMIN_APPROVAL_REQUIRED", t.PENDING_EMAIL_VERIFICATION_REQUIRED = "PENDING_EMAIL_VERIFICATION_REQUIRED", t))(GB || {}), WB = /* @__PURE__ */ ((t) => (t.UNKNOWN_FACTOR_TYPE = "UNKNOWN_FACTOR_TYPE", t.PASSWORD = "PASSWORD", t.SMS = "SMS", t.CALL = "CALL", t.EMAIL = "EMAIL", t.TOTP = "TOTP", t.PUSH = "PUSH", t.WEBAUTHN = "WEBAUTHN", t.RECOVERY_CODE = "RECOVERY_CODE", t))(WB || {}), VB = /* @__PURE__ */ ((t) => (t.INACTIVE = "INACTIVE", t.ACTIVE = "ACTIVE", t.REQUIRE_REENROLL = "REQUIRE_REENROLL", t))(VB || {}), KB = /* @__PURE__ */ ((t) => (t.UNKNOWN_FACTOR_STATUS = "UNKNOWN_FACTOR_STATUS", t.ENABLED = "ENABLED", t.REQUIRE_ACTIVATION = "REQUIRE_ACTIVATION", t.REQUIRE_REENROLL = "REQUIRE_REENROLL", t.ENABLED_BY_RULE = "ENABLED_BY_RULE", t.DISABLED_BY_RULE = "DISABLED_BY_RULE", t))(KB || {}), zB = /* @__PURE__ */ ((t) => (t.UNKNOWN_MFA_REASON = "UNKNOWN_MFA_REASON", t.USER_SETTINGS = "USER_SETTINGS", t.HIGH_RISK_LOGIN = "HIGH_RISK_LOGIN", t))(zB || {}), jB = /* @__PURE__ */ ((t) => (t.UNKNOWN_TENANT_TYPE = "UNKNOWN_TENANT_TYPE", t.ACCOUNT = "ACCOUNT", t.SITE = "SITE", t))(jB || {}), YB = /* @__PURE__ */ ((t) => (t.UNKNOWN_DELIVERY_METHOD = "UNKNOWN_DELIVERY_METHOD", t.SMS = "SMS", t.WHATSAPP = "WHATSAPP", t))(YB || {});
async function Wse(t, e) {
  const { httpClient: n, sideEffects: r } = arguments[2], i = Co(
    Xg({
      loginId: t,
      password: e?.password,
      profile: e?.profile,
      captchaTokens: e?.captchaTokens,
      clientMetaData: e?.clientMetaData
    }),
    [
      {
        transformFn: MB,
        paths: [{ path: "profile.addresses.address" }]
      }
    ]
  ), s = Bse(i);
  r?.onSiteCall?.();
  try {
    const a = await n.request(s);
    return r?.onSuccess?.(a), hA(
      Co(a.data, [
        {
          transformFn: uC,
          paths: [{ path: "identity.identityProfile.addresses.address" }]
        }
      ])
    );
  } catch (a) {
    const o = Qg(
      a,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          loginId: "$[0]",
          password: "$[1].password",
          profile: "$[1].profile",
          captchaTokens: "$[1].captchaTokens",
          clientMetaData: "$[1].clientMetaData"
        },
        singleArgumentUnchanged: !1
      },
      ["loginId", "options"]
    );
    throw r?.onError?.(a), o;
  }
}
async function Vse(t, e) {
  const { httpClient: n, sideEffects: r } = arguments[2], i = Xg({
    loginId: t,
    password: e?.password,
    captchaTokens: e?.captchaTokens,
    clientMetaData: e?.clientMetaData
  }), s = $se(i);
  r?.onSiteCall?.();
  try {
    const a = await n.request(s);
    return r?.onSuccess?.(a), hA(
      Co(a.data, [
        {
          transformFn: uC,
          paths: [{ path: "identity.identityProfile.addresses.address" }]
        }
      ])
    );
  } catch (a) {
    const o = Qg(
      a,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          loginId: "$[0]",
          password: "$[1].password",
          captchaTokens: "$[1].captchaTokens",
          clientMetaData: "$[1].clientMetaData"
        },
        singleArgumentUnchanged: !1
      },
      ["loginId", "options"]
    );
    throw r?.onError?.(a), o;
  }
}
async function Kse(t) {
  const { httpClient: e, sideEffects: n } = arguments[1], r = Xg({
    newPassword: t
  }), i = Hse(r);
  n?.onSiteCall?.();
  try {
    const s = await e.request(i);
    n?.onSuccess?.(s);
  } catch (s) {
    const a = Qg(
      s,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { newPassword: "$[0]" },
        singleArgumentUnchanged: !1
      },
      ["newPassword"]
    );
    throw n?.onError?.(s), a;
  }
}
async function zse(t, e) {
  const { httpClient: n, sideEffects: r } = arguments[2], i = Co(
    Xg({
      loginId: t,
      profile: e?.profile,
      verifyEmail: e?.verifyEmail,
      mergeExistingContact: e?.mergeExistingContact
    }),
    [
      {
        transformFn: MB,
        paths: [{ path: "profile.addresses.address" }]
      }
    ]
  ), s = Use(i);
  r?.onSiteCall?.();
  try {
    const a = await n.request(s);
    return r?.onSuccess?.(a), hA(
      Co(a.data, [
        {
          transformFn: uC,
          paths: [{ path: "identity.identityProfile.addresses.address" }]
        }
      ])
    );
  } catch (a) {
    const o = Qg(
      a,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          loginId: "$[0]",
          profile: "$[1].profile",
          verifyEmail: "$[1].verifyEmail",
          mergeExistingContact: "$[1].mergeExistingContact"
        },
        singleArgumentUnchanged: !1
      },
      ["loginId", "options"]
    );
    throw r?.onError?.(a), o;
  }
}
async function jse(t) {
  const { httpClient: e, sideEffects: n } = arguments[1], r = Xg({
    postLogoutRedirectUri: t?.postLogoutRedirectUri,
    clientId: t?.clientId
  }), i = Gse(r);
  n?.onSiteCall?.();
  try {
    const s = await e.request(i);
    return n?.onSuccess?.(s), hA(s.data);
  } catch (s) {
    const a = Qg(
      s,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          postLogoutRedirectUri: "$[0].postLogoutRedirectUri",
          clientId: "$[0].clientId"
        },
        singleArgumentUnchanged: !1
      },
      ["options"]
    );
    throw n?.onError?.(s), a;
  }
}
function Yse(t) {
  return (e, n) => Wse(
    e,
    n,
    // @ts-ignore
    { httpClient: t }
  );
}
function qse(t) {
  return (e, n) => Vse(
    e,
    n,
    // @ts-ignore
    { httpClient: t }
  );
}
function Jse(t) {
  return (e) => Kse(
    e,
    // @ts-ignore
    { httpClient: t }
  );
}
function Qse(t) {
  return (e, n) => zse(
    e,
    n,
    // @ts-ignore
    { httpClient: t }
  );
}
function Xse(t) {
  return (e) => jse(
    e,
    // @ts-ignore
    { httpClient: t }
  );
}
var Zse = /* @__PURE__ */ Zg(Yse), eae = /* @__PURE__ */ Zg(qse), tae = /* @__PURE__ */ Zg(Jse), nae = /* @__PURE__ */ Zg(Qse), rae = /* @__PURE__ */ Zg(Xse);
const iae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddressTag: HB,
  DeliveryMethod: YB,
  EmailTag: BB,
  FactorStatus: KB,
  FactorType: WB,
  MfaReason: zB,
  PhoneTag: $B,
  PrivacyStatus: OB,
  Reason: GB,
  StateType: Jm,
  Status: VB,
  StatusName: UB,
  TenantType: jB,
  changePassword: tae,
  loginV2: eae,
  logout: rae,
  registerV2: Zse,
  signOn: nae
}, Symbol.toStringTag, { value: "Module" })), sae = {
  _id: "id",
  _createdDate: "createdDate",
  _updatedDate: "updatedDate"
}, aae = {
  id: "_id",
  createdDate: "_createdDate",
  updatedDate: "_updatedDate"
};
function oae(t) {
  return Object.fromEntries(Object.entries(t).filter(([, e]) => e !== void 0));
}
function lC(t) {
  return hae(t).map((e) => e.toLocaleUpperCase()).join("_");
}
const uae = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), lae = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), dN = "$1\0$2", cae = /[^\p{L}\d]+/giu;
function hae(t) {
  let e = t.trim();
  e = e.replace(uae, dN).replace(lae, dN), e = e.replace(cae, "\0");
  let n = 0, r = e.length;
  for (; e.charAt(n) === "\0"; )
    n++;
  if (n === r)
    return [];
  for (; e.charAt(r - 1) === "\0"; )
    r--;
  return e.slice(n, r).split(/\0/g);
}
const dae = (t) => "validationError" in (t.response?.data?.details ?? {}), fae = (t) => "applicationError" in (t.response?.data?.details ?? {}), mae = (t) => (t.response?.status ?? -1) >= 400 && (t.response?.status ?? -1) < 500;
function cC(t, e = {
  explicitPathsToArguments: {},
  spreadPathsToArguments: {},
  singleArgumentUnchanged: !1
}, n = []) {
  if (typeof t != "object" || t === null)
    throw t;
  if (dae(t))
    return gae(t, e, n);
  if (fae(t))
    return pae(t);
  if (mae(t)) {
    const r = t.response?.status, i = t.response?.statusText ?? "UNKNOWN", s = t.response?.data?.message ?? i, a = {
      applicationError: {
        description: i,
        code: lC(i),
        data: {}
      },
      requestId: t.requestId
    };
    return dA(t, {
      message: JSON.stringify({
        message: s,
        details: a
      }, null, 2),
      extraProperties: {
        details: a,
        status: r
      }
    });
  }
  return bae(t);
}
const gae = (t, e, n) => {
  const r = t.response?.data, i = t.requestId, { fieldViolations: s } = r.details.validationError, a = yae(e, s, n)?.sort((l, h) => l.field < h.field ? -1 : 1), o = `INVALID_ARGUMENT: ${a?.map(({ field: l, description: h }) => `"${l}" ${h}`)?.join(", ")}`, u = {
    validationError: { fieldViolations: a },
    requestId: i
  };
  return dA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: t.response?.status,
      requestId: i
    }
  });
}, dA = (t, { message: e, extraProperties: n }) => Object.assign(t, {
  ...n,
  message: e
}), pae = (t) => {
  const e = t.response?.status, n = t.response?.statusText ?? "UNKNOWN", r = t.response?.data?.message ?? n, i = t.response?.data?.details?.applicationError?.description ?? n, s = t.response?.data?.details?.applicationError?.code ?? lC(n), a = t.response?.data?.details?.applicationError?.data ?? {}, o = r === i ? r : `${r}: ${i}`, u = {
    applicationError: {
      description: i,
      code: s,
      data: a
    },
    requestId: t.requestId
  };
  return dA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: e,
      requestId: t.requestId
    }
  });
}, bae = (t) => {
  const e = t.requestId ? `System error occurred, request-id: ${t.requestId}` : `System error occurred: ${JSON.stringify(t)}`;
  return dA(t, {
    message: e,
    extraProperties: {
      requestId: t.requestId,
      status: t.response?.status,
      code: lC(t.response?.statusText ?? "UNKNOWN"),
      ...!t.response && {
        runtimeError: t
      }
    }
  });
}, yae = ({ spreadPathsToArguments: t, explicitPathsToArguments: e, singleArgumentUnchanged: n }, r, i) => {
  const s = {
    ...t,
    ...e
  }, a = Object.keys(s);
  return r?.filter((o) => !r.some((l) => l.field.length > o.field.length && l.field.startsWith(o.field) && a.includes(l.field))).map((o) => {
    const u = e[o.field];
    if (u)
      return {
        ...o,
        field: fN(u, i)
      };
    const l = a?.sort((h, f) => f.length - h.length)?.find((h) => o.field.startsWith(h));
    if (l) {
      const h = s[l];
      if (h)
        return {
          ...o,
          field: o.field.replace(l, fN(h, i))
        };
    }
    return n ? {
      ...o,
      field: `${i[0]}.${o.field}`
    } : o;
  });
}, fN = (t, e) => {
  const n = Aae(t);
  return n !== null && typeof n < "u" ? t.replace(`$[${n}]`, e[n]) : t;
}, Aae = (t) => {
  const e = t.match(/\$\[(?<argIndex>\d+)\]/);
  return e && e.groups && Number(e.groups.argIndex);
};
function qB(t, e, n) {
  const r = (s) => n.includes(s), i = (s, a) => {
    if (Array.isArray(s))
      s.forEach((o) => {
        i(o, a);
      });
    else if (typeof s == "object" && s !== null) {
      const o = s;
      Object.keys(o).forEach((u) => {
        const l = a === "" ? u : `${a}.${u}`;
        if (r(l))
          return;
        const h = Eae(u, e);
        h !== u && !(h in o) && (o[h] = o[u], delete o[u]), i(o[h], l);
      });
    }
  };
  return i(t, ""), t;
}
function Eae(t, e) {
  let n;
  return t.includes(".") ? n = t.split(".").map((s) => e[s] ?? s).join(".") : n = e[t] ?? t, n;
}
function hC(t, e = []) {
  return qB(t, sae, e);
}
function Sae(t, e = []) {
  return qB(t, aae, e);
}
function wae(t) {
  return t === "NaN" ? NaN : t === "Infinity" ? 1 / 0 : t === "-Infinity" ? -1 / 0 : t;
}
function Fae(t) {
  return t ? new Date(t) : void 0;
}
function _m(t, { path: e, isRepeated: n, isMap: r }, i) {
  const s = e.split(".");
  if (s.length === 1 && e in t)
    return t[e] = n ? t[e].map(i) : r ? Object.fromEntries(Object.entries(t[e]).map(([u, l]) => [u, i(l)])) : i(t[e]), t;
  const [a, ...o] = s;
  if (a.endsWith("{}")) {
    const u = a.slice(0, -2);
    t[u] = Object.fromEntries(Object.entries(t[u]).map(([l, h]) => [
      l,
      _m(h, { path: o.join("."), isRepeated: n, isMap: r }, i)
    ]));
  } else Array.isArray(t[a]) ? t[a] = t[a].map((u) => _m(u, { path: o.join("."), isRepeated: n, isMap: r }, i)) : a in t && typeof t[a] == "object" && t[a] !== null ? t[a] = _m(t[a], { path: o.join("."), isRepeated: n, isMap: r }, i) : a === "*" && Object.keys(t).reduce((u, l) => (u[l] = _m(t[l], { path: o.join("."), isRepeated: n, isMap: r }, i), u), t);
  return t;
}
function JB(t, e) {
  return e.reduce((n, { paths: r, transformFn: i }) => r.reduce((s, a) => _m(s, a, i), n), t);
}
function Tae() {
  const t = typeof $wixContext < "u" && $wixContext.initWixModules ? $wixContext.initWixModules : typeof globalThis.__wix_context__ < "u" && globalThis.__wix_context__.initWixModules ? globalThis.__wix_context__.initWixModules : void 0;
  if (t)
    return {
      // @ts-expect-error
      initWixModules(r, i) {
        return TS(() => t(r, i));
      },
      fetchWithAuth() {
        throw new Error("fetchWithAuth is not available in this context");
      },
      graphql() {
        throw new Error("graphql is not available in this context");
      }
    };
  const e = typeof $wixContext < "u" ? $wixContext.client : typeof Et.client < "u" ? Et.client : typeof globalThis.__wix_context__ < "u" ? globalThis.__wix_context__.client : void 0, n = typeof $wixContext < "u" ? $wixContext.elevatedClient : typeof Et.elevatedClient < "u" ? Et.elevatedClient : typeof globalThis.__wix_context__ < "u" ? globalThis.__wix_context__.elevatedClient : void 0;
  if (!(!e && !n))
    return {
      initWixModules(r, i) {
        if (i) {
          if (!n)
            throw new Error("An elevated client is required to use elevated modules. Make sure to initialize the Wix context with an elevated client before using elevated SDK modules");
          return TS(() => n.use(r));
        }
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return TS(() => e.use(r));
      },
      fetchWithAuth: (r, i) => {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.fetchWithAuth(r, i);
      },
      getAuth() {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.auth;
      },
      async graphql(r, i, s) {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.graphql(r, i, s);
      }
    };
}
function TS(t) {
  const e = globalThis.__wix_context__, n = {
    client: Et.client,
    elevatedClient: Et.elevatedClient
  };
  let r;
  globalThis.__wix_context__ = void 0, Et.client = void 0, Et.elevatedClient = void 0, typeof $wixContext < "u" && (r = {
    client: $wixContext?.client,
    elevatedClient: $wixContext?.elevatedClient
  }, delete $wixContext.client, delete $wixContext.elevatedClient);
  try {
    return t();
  } finally {
    globalThis.__wix_context__ = e, Et.client = n.client, Et.elevatedClient = n.elevatedClient, typeof $wixContext < "u" && ($wixContext.client = r.client, $wixContext.elevatedClient = r.elevatedClient);
  }
}
function vae(t, e) {
  return ((...n) => {
    const r = Tae();
    return r ? r.initWixModules(t, e).apply(void 0, n) : t.apply(void 0, n);
  });
}
function dC(t, e = !1) {
  return vae(t, e);
}
function xae(t) {
  const e = Lae(t.host), n = Oae(e, t.domainToMappings), r = Uae(t.protoPath, t.data || {});
  return Vae(r, n);
}
const Cae = ["wix.com", "editorx.com"], kae = "_", _ae = new RegExp(`\\.(${Cae.join("|")})$`), Nae = ["42.wixprod.net", "uw2-edt-1.wixprod.net"], Dae = "dev.wix-code.com", Iae = /{(.*)}/, Rae = new RegExp(`\\.(${Nae.join("|")})$`), Pae = new RegExp(`.*\\.${Dae}$`);
function Lae(t) {
  return Mae(t).replace(_ae, "._base_domain_").replace(Rae, "._api_base_domain_").replace(Pae, "*.dev.wix-code.com");
}
function Mae(t) {
  return t.replace("create.editorx.com", "editor.editorx.com");
}
function Oae(t, e) {
  const n = e[t] || e[kae];
  if (n)
    return n;
  const r = Bae(t, e);
  return !r && $ae(t) ? e[Hae] : r ?? [];
}
function Bae(t, e) {
  return Object.entries(e).find(([n]) => {
    const [, ...r] = t.split(".");
    return r.join(".") === n;
  })?.[1];
}
function $ae(t) {
  return !!t.match(/\._base_domain_$/);
}
const Hae = "www._base_domain_";
function Uae(t, e) {
  return t.split("/").map((n) => Gae(n, e)).join("/");
}
function Gae(t, e) {
  const n = t.match(Iae) || [], r = n[1];
  if (r) {
    const i = t.replace(n[0], "");
    return Wae(e, r, t, i);
  }
  return t;
}
function Wae(t, e, n, r) {
  let i = t;
  for (const s of e.split(".")) {
    if (!i)
      return n;
    i = i[s];
  }
  return `${i}${r}`;
}
function Vae(t, e) {
  const n = e?.find((r) => t.startsWith(r.destPath));
  return n ? n.srcPath + t.slice(n.destPath.length) : t;
}
function Kae(t) {
  return t && oae({
    formatted: t.formattedAddress,
    location: t.geocode,
    addressLine1: t.addressLine,
    addressLine2: t.addressLine2,
    streetAddress: t.streetAddress && {
      name: t.streetAddress.name,
      number: t.streetAddress.number,
      apt: t.streetAddress.apt,
      formattedAddressLine: t.streetAddress.formattedAddressLine
    },
    hint: t.hint,
    city: t.city,
    subdivision: t.subdivision,
    country: t.country,
    postalCode: t.postalCode,
    countryFullname: t.countryFullname,
    subdivisionFullname: t.subdivisionFullname
  });
}
function fC(t) {
  return xae(Object.assign(t, { domainToMappings: {
    _: [
      {
        srcPath: "/_iam/recovery",
        destPath: ""
      },
      {
        srcPath: "/_api/iam/recovery",
        destPath: ""
      }
    ],
    "www.wixapis.com": [
      {
        srcPath: "/_api/iam/recovery",
        destPath: ""
      }
    ],
    "*.dev.wix-code.com": [
      {
        srcPath: "/iam/recovery/v1/recover",
        destPath: "/v1/recover"
      },
      {
        srcPath: "/iam/recovery/v1/send-email",
        destPath: "/v1/send-email"
      },
      {
        srcPath: "/iam/recovery/v1/activation-email",
        destPath: "/v1/activation-email"
      }
    ]
  } }));
}
var mC = "@wix/auto_sdk_identity_recovery";
function zae(t) {
  function e({ host: n }) {
    return {
      entityFqdn: "wix.iam.recovery.v1.recovery",
      method: "POST",
      methodFqn: "wix.iam.recovery.v1.RecoveryService.SendRecoveryEmail",
      packageName: mC,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: fC({
        protoPath: "/v1/send-email",
        data: t,
        host: n
      }),
      data: t
    };
  }
  return e;
}
function jae(t) {
  function e({ host: n }) {
    return {
      entityFqdn: "wix.iam.recovery.v1.recovery",
      method: "POST",
      methodFqn: "wix.iam.recovery.v1.RecoveryService.SendActivationEmail",
      packageName: mC,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: fC({
        protoPath: "/v1/activation-email",
        data: t,
        host: n
      }),
      data: t
    };
  }
  return e;
}
function Yae(t) {
  function e({ host: n }) {
    return {
      entityFqdn: "wix.iam.recovery.v1.recovery",
      method: "POST",
      methodFqn: "wix.iam.recovery.v1.RecoveryService.Recover",
      packageName: mC,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: fC({
        protoPath: "/v1/recover",
        data: t,
        host: n
      }),
      data: t,
      transformResponse: (i) => JB(i, [
        {
          transformFn: Fae,
          paths: [
            { path: "identity.createdDate" },
            { path: "identity.updatedDate" },
            { path: "identity.identityProfile.customFields.value.dateValue" },
            { path: "additionalData.*.dateValue" }
          ]
        },
        {
          transformFn: wae,
          paths: [
            { path: "identity.identityProfile.customFields.value.numValue" },
            { path: "additionalData.*.numValue" }
          ]
        }
      ])
    };
  }
  return e;
}
var QB = /* @__PURE__ */ ((t) => (t.UNKNOWN_TENANT_TYPE = "UNKNOWN_TENANT_TYPE", t.ACCOUNT = "ACCOUNT", t.SITE = "SITE", t))(QB || {}), XB = /* @__PURE__ */ ((t) => (t.UNKNOWN_STATE = "UNKNOWN_STATE", t.SUCCESS = "SUCCESS", t.REQUIRE_OWNER_APPROVAL = "REQUIRE_OWNER_APPROVAL", t.REQUIRE_EMAIL_VERIFICATION = "REQUIRE_EMAIL_VERIFICATION", t.STATUS_CHECK = "STATUS_CHECK", t))(XB || {}), ZB = /* @__PURE__ */ ((t) => (t.UNDEFINED = "UNDEFINED", t.PUBLIC = "PUBLIC", t.PRIVATE = "PRIVATE", t))(ZB || {}), e4 = /* @__PURE__ */ ((t) => (t.UNTAGGED = "UNTAGGED", t.MAIN = "MAIN", t.HOME = "HOME", t.WORK = "WORK", t))(e4 || {}), t4 = /* @__PURE__ */ ((t) => (t.UNTAGGED = "UNTAGGED", t.MAIN = "MAIN", t.HOME = "HOME", t.MOBILE = "MOBILE", t.WORK = "WORK", t.FAX = "FAX", t))(t4 || {}), n4 = /* @__PURE__ */ ((t) => (t.UNTAGGED = "UNTAGGED", t.HOME = "HOME", t.WORK = "WORK", t.BILLING = "BILLING", t.SHIPPING = "SHIPPING", t))(n4 || {}), r4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_STATUS = "UNKNOWN_STATUS", t.PENDING = "PENDING", t.ACTIVE = "ACTIVE", t.DELETED = "DELETED", t.BLOCKED = "BLOCKED", t.OFFLINE = "OFFLINE", t))(r4 || {}), i4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_REASON = "UNKNOWN_REASON", t.PENDING_ADMIN_APPROVAL_REQUIRED = "PENDING_ADMIN_APPROVAL_REQUIRED", t.PENDING_EMAIL_VERIFICATION_REQUIRED = "PENDING_EMAIL_VERIFICATION_REQUIRED", t))(i4 || {}), s4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_FACTOR_TYPE = "UNKNOWN_FACTOR_TYPE", t.PASSWORD = "PASSWORD", t.SMS = "SMS", t.CALL = "CALL", t.EMAIL = "EMAIL", t.TOTP = "TOTP", t.PUSH = "PUSH", t.WEBAUTHN = "WEBAUTHN", t.RECOVERY_CODE = "RECOVERY_CODE", t))(s4 || {}), a4 = /* @__PURE__ */ ((t) => (t.INACTIVE = "INACTIVE", t.ACTIVE = "ACTIVE", t.REQUIRE_REENROLL = "REQUIRE_REENROLL", t))(a4 || {}), o4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_FACTOR_STATUS = "UNKNOWN_FACTOR_STATUS", t.ENABLED = "ENABLED", t.REQUIRE_ACTIVATION = "REQUIRE_ACTIVATION", t.REQUIRE_REENROLL = "REQUIRE_REENROLL", t.ENABLED_BY_RULE = "ENABLED_BY_RULE", t.DISABLED_BY_RULE = "DISABLED_BY_RULE", t))(o4 || {}), u4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_MFA_REASON = "UNKNOWN_MFA_REASON", t.USER_SETTINGS = "USER_SETTINGS", t.HIGH_RISK_LOGIN = "HIGH_RISK_LOGIN", t))(u4 || {});
async function qae(t, e) {
  const { httpClient: n, sideEffects: r } = arguments[2], i = hC({
    email: t,
    language: e?.language,
    redirect: e?.redirect
  }), s = zae(i);
  r?.onSiteCall?.();
  try {
    const a = await n.request(s);
    r?.onSuccess?.(a);
  } catch (a) {
    const o = cC(
      a,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          email: "$[0]",
          language: "$[1].language",
          redirect: "$[1].redirect"
        },
        singleArgumentUnchanged: !1
      },
      ["email", "options"]
    );
    throw r?.onError?.(a), o;
  }
}
async function Jae(t, e) {
  const { httpClient: n, sideEffects: r } = arguments[2], i = hC({
    identityId: t,
    emailOptions: e?.emailOptions
  }), s = jae(i);
  r?.onSiteCall?.();
  try {
    const a = await n.request(s);
    r?.onSuccess?.(a);
  } catch (a) {
    const o = cC(
      a,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          identityId: "$[0]",
          emailOptions: "$[1].emailOptions"
        },
        singleArgumentUnchanged: !1
      },
      ["identityId", "options"]
    );
    throw r?.onError?.(a), o;
  }
}
async function Qae(t, e) {
  const { httpClient: n, sideEffects: r } = arguments[2], i = hC({
    recoveryToken: t,
    password: e?.password
  }), s = Yae(i);
  r?.onSiteCall?.();
  try {
    const a = await n.request(s);
    return r?.onSuccess?.(a), Sae(
      JB(a.data, [
        {
          transformFn: Kae,
          paths: [{ path: "identity.identityProfile.addresses.address" }]
        }
      ])
    );
  } catch (a) {
    const o = cC(
      a,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          recoveryToken: "$[0]",
          password: "$[1].password"
        },
        singleArgumentUnchanged: !1
      },
      ["recoveryToken", "options"]
    );
    throw r?.onError?.(a), o;
  }
}
function Xae(t) {
  return (e, n) => qae(
    e,
    n,
    // @ts-ignore
    { httpClient: t }
  );
}
function Zae(t) {
  return (e, n) => Jae(
    e,
    n,
    // @ts-ignore
    { httpClient: t }
  );
}
function eoe(t) {
  return (e, n) => Qae(
    e,
    n,
    // @ts-ignore
    { httpClient: t }
  );
}
var toe = /* @__PURE__ */ dC(Xae), noe = /* @__PURE__ */ dC(Zae), roe = /* @__PURE__ */ dC(eoe);
const ioe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddressTag: n4,
  EmailTag: e4,
  FactorStatus: o4,
  FactorType: s4,
  MfaReason: u4,
  PhoneTag: t4,
  PrivacyStatus: ZB,
  Reason: i4,
  StateType: XB,
  Status: a4,
  StatusName: r4,
  TenantType: QB,
  recover: roe,
  sendActivationEmail: noe,
  sendRecoveryEmail: toe
}, Symbol.toStringTag, { value: "Module" })), soe = {
  _id: "id",
  _createdDate: "createdDate",
  _updatedDate: "updatedDate"
}, aoe = {
  id: "_id",
  createdDate: "_createdDate",
  updatedDate: "_updatedDate"
};
function ooe(t) {
  return Object.fromEntries(Object.entries(t).filter(([, e]) => e !== void 0));
}
function gC(t) {
  return hoe(t).map((e) => e.toLocaleUpperCase()).join("_");
}
const uoe = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), loe = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), mN = "$1\0$2", coe = /[^\p{L}\d]+/giu;
function hoe(t) {
  let e = t.trim();
  e = e.replace(uoe, mN).replace(loe, mN), e = e.replace(coe, "\0");
  let n = 0, r = e.length;
  for (; e.charAt(n) === "\0"; )
    n++;
  if (n === r)
    return [];
  for (; e.charAt(r - 1) === "\0"; )
    r--;
  return e.slice(n, r).split(/\0/g);
}
const doe = (t) => "validationError" in (t.response?.data?.details ?? {}), foe = (t) => "applicationError" in (t.response?.data?.details ?? {}), moe = (t) => (t.response?.status ?? -1) >= 400 && (t.response?.status ?? -1) < 500;
function l4(t, e = {
  explicitPathsToArguments: {},
  spreadPathsToArguments: {},
  singleArgumentUnchanged: !1
}, n = []) {
  if (typeof t != "object" || t === null)
    throw t;
  if (doe(t))
    return goe(t, e, n);
  if (foe(t))
    return poe(t);
  if (moe(t)) {
    const r = t.response?.status, i = t.response?.statusText ?? "UNKNOWN", s = t.response?.data?.message ?? i, a = {
      applicationError: {
        description: i,
        code: gC(i),
        data: {}
      },
      requestId: t.requestId
    };
    return fA(t, {
      message: JSON.stringify({
        message: s,
        details: a
      }, null, 2),
      extraProperties: {
        details: a,
        status: r
      }
    });
  }
  return boe(t);
}
const goe = (t, e, n) => {
  const r = t.response?.data, i = t.requestId, { fieldViolations: s } = r.details.validationError, a = yoe(e, s, n)?.sort((l, h) => l.field < h.field ? -1 : 1), o = `INVALID_ARGUMENT: ${a?.map(({ field: l, description: h }) => `"${l}" ${h}`)?.join(", ")}`, u = {
    validationError: { fieldViolations: a },
    requestId: i
  };
  return fA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: t.response?.status,
      requestId: i
    }
  });
}, fA = (t, { message: e, extraProperties: n }) => Object.assign(t, {
  ...n,
  message: e
}), poe = (t) => {
  const e = t.response?.status, n = t.response?.statusText ?? "UNKNOWN", r = t.response?.data?.message ?? n, i = t.response?.data?.details?.applicationError?.description ?? n, s = t.response?.data?.details?.applicationError?.code ?? gC(n), a = t.response?.data?.details?.applicationError?.data ?? {}, o = r === i ? r : `${r}: ${i}`, u = {
    applicationError: {
      description: i,
      code: s,
      data: a
    },
    requestId: t.requestId
  };
  return fA(t, {
    message: JSON.stringify({ message: o, details: u }, null, 2),
    extraProperties: {
      details: u,
      status: e,
      requestId: t.requestId
    }
  });
}, boe = (t) => {
  const e = t.requestId ? `System error occurred, request-id: ${t.requestId}` : `System error occurred: ${JSON.stringify(t)}`;
  return fA(t, {
    message: e,
    extraProperties: {
      requestId: t.requestId,
      status: t.response?.status,
      code: gC(t.response?.statusText ?? "UNKNOWN"),
      ...!t.response && {
        runtimeError: t
      }
    }
  });
}, yoe = ({ spreadPathsToArguments: t, explicitPathsToArguments: e, singleArgumentUnchanged: n }, r, i) => {
  const s = {
    ...t,
    ...e
  }, a = Object.keys(s);
  return r?.filter((o) => !r.some((l) => l.field.length > o.field.length && l.field.startsWith(o.field) && a.includes(l.field))).map((o) => {
    const u = e[o.field];
    if (u)
      return {
        ...o,
        field: gN(u, i)
      };
    const l = a?.sort((h, f) => f.length - h.length)?.find((h) => o.field.startsWith(h));
    if (l) {
      const h = s[l];
      if (h)
        return {
          ...o,
          field: o.field.replace(l, gN(h, i))
        };
    }
    return n ? {
      ...o,
      field: `${i[0]}.${o.field}`
    } : o;
  });
}, gN = (t, e) => {
  const n = Aoe(t);
  return n !== null && typeof n < "u" ? t.replace(`$[${n}]`, e[n]) : t;
}, Aoe = (t) => {
  const e = t.match(/\$\[(?<argIndex>\d+)\]/);
  return e && e.groups && Number(e.groups.argIndex);
};
function c4(t, e, n) {
  const r = (s) => n.includes(s), i = (s, a) => {
    if (Array.isArray(s))
      s.forEach((o) => {
        i(o, a);
      });
    else if (typeof s == "object" && s !== null) {
      const o = s;
      Object.keys(o).forEach((u) => {
        const l = a === "" ? u : `${a}.${u}`;
        if (r(l))
          return;
        const h = Eoe(u, e);
        h !== u && !(h in o) && (o[h] = o[u], delete o[u]), i(o[h], l);
      });
    }
  };
  return i(t, ""), t;
}
function Eoe(t, e) {
  let n;
  return t.includes(".") ? n = t.split(".").map((s) => e[s] ?? s).join(".") : n = e[t] ?? t, n;
}
function h4(t, e = []) {
  return c4(t, soe, e);
}
function d4(t, e = []) {
  return c4(t, aoe, e);
}
function Soe(t) {
  return t === "NaN" ? NaN : t === "Infinity" ? 1 / 0 : t === "-Infinity" ? -1 / 0 : t;
}
function woe(t) {
  return t ? new Date(t) : void 0;
}
function Nm(t, { path: e, isRepeated: n, isMap: r }, i) {
  const s = e.split(".");
  if (s.length === 1 && e in t)
    return t[e] = n ? t[e].map(i) : r ? Object.fromEntries(Object.entries(t[e]).map(([u, l]) => [u, i(l)])) : i(t[e]), t;
  const [a, ...o] = s;
  if (a.endsWith("{}")) {
    const u = a.slice(0, -2);
    t[u] = Object.fromEntries(Object.entries(t[u]).map(([l, h]) => [
      l,
      Nm(h, { path: o.join("."), isRepeated: n, isMap: r }, i)
    ]));
  } else Array.isArray(t[a]) ? t[a] = t[a].map((u) => Nm(u, { path: o.join("."), isRepeated: n, isMap: r }, i)) : a in t && typeof t[a] == "object" && t[a] !== null ? t[a] = Nm(t[a], { path: o.join("."), isRepeated: n, isMap: r }, i) : a === "*" && Object.keys(t).reduce((u, l) => (u[l] = Nm(t[l], { path: o.join("."), isRepeated: n, isMap: r }, i), u), t);
  return t;
}
function f4(t, e) {
  return e.reduce((n, { paths: r, transformFn: i }) => r.reduce((s, a) => Nm(s, a, i), n), t);
}
function Foe() {
  const t = typeof $wixContext < "u" && $wixContext.initWixModules ? $wixContext.initWixModules : typeof globalThis.__wix_context__ < "u" && globalThis.__wix_context__.initWixModules ? globalThis.__wix_context__.initWixModules : void 0;
  if (t)
    return {
      // @ts-expect-error
      initWixModules(r, i) {
        return vS(() => t(r, i));
      },
      fetchWithAuth() {
        throw new Error("fetchWithAuth is not available in this context");
      },
      graphql() {
        throw new Error("graphql is not available in this context");
      }
    };
  const e = typeof $wixContext < "u" ? $wixContext.client : typeof Et.client < "u" ? Et.client : typeof globalThis.__wix_context__ < "u" ? globalThis.__wix_context__.client : void 0, n = typeof $wixContext < "u" ? $wixContext.elevatedClient : typeof Et.elevatedClient < "u" ? Et.elevatedClient : typeof globalThis.__wix_context__ < "u" ? globalThis.__wix_context__.elevatedClient : void 0;
  if (!(!e && !n))
    return {
      initWixModules(r, i) {
        if (i) {
          if (!n)
            throw new Error("An elevated client is required to use elevated modules. Make sure to initialize the Wix context with an elevated client before using elevated SDK modules");
          return vS(() => n.use(r));
        }
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return vS(() => e.use(r));
      },
      fetchWithAuth: (r, i) => {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.fetchWithAuth(r, i);
      },
      getAuth() {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.auth;
      },
      async graphql(r, i, s) {
        if (!e)
          throw new Error("Wix context is not available. Make sure to initialize the Wix context before using SDK modules");
        return e.graphql(r, i, s);
      }
    };
}
function vS(t) {
  const e = globalThis.__wix_context__, n = {
    client: Et.client,
    elevatedClient: Et.elevatedClient
  };
  let r;
  globalThis.__wix_context__ = void 0, Et.client = void 0, Et.elevatedClient = void 0, typeof $wixContext < "u" && (r = {
    client: $wixContext?.client,
    elevatedClient: $wixContext?.elevatedClient
  }, delete $wixContext.client, delete $wixContext.elevatedClient);
  try {
    return t();
  } finally {
    globalThis.__wix_context__ = e, Et.client = n.client, Et.elevatedClient = n.elevatedClient, typeof $wixContext < "u" && ($wixContext.client = r.client, $wixContext.elevatedClient = r.elevatedClient);
  }
}
function Toe(t, e) {
  return ((...n) => {
    const r = Foe();
    return r ? r.initWixModules(t, e).apply(void 0, n) : t.apply(void 0, n);
  });
}
function m4(t, e = !1) {
  return Toe(t, e);
}
function voe(t) {
  const e = Poe(t.host), n = Moe(e, t.domainToMappings), r = Hoe(t.protoPath, t.data || {});
  return Woe(r, n);
}
const xoe = ["wix.com", "editorx.com"], Coe = "_", koe = new RegExp(`\\.(${xoe.join("|")})$`), _oe = ["42.wixprod.net", "uw2-edt-1.wixprod.net"], Noe = "dev.wix-code.com", Doe = /{(.*)}/, Ioe = new RegExp(`\\.(${_oe.join("|")})$`), Roe = new RegExp(`.*\\.${Noe}$`);
function Poe(t) {
  return Loe(t).replace(koe, "._base_domain_").replace(Ioe, "._api_base_domain_").replace(Roe, "*.dev.wix-code.com");
}
function Loe(t) {
  return t.replace("create.editorx.com", "editor.editorx.com");
}
function Moe(t, e) {
  const n = e[t] || e[Coe];
  if (n)
    return n;
  const r = Ooe(t, e);
  return !r && Boe(t) ? e[$oe] : r ?? [];
}
function Ooe(t, e) {
  return Object.entries(e).find(([n]) => {
    const [, ...r] = t.split(".");
    return r.join(".") === n;
  })?.[1];
}
function Boe(t) {
  return !!t.match(/\._base_domain_$/);
}
const $oe = "www._base_domain_";
function Hoe(t, e) {
  return t.split("/").map((n) => Uoe(n, e)).join("/");
}
function Uoe(t, e) {
  const n = t.match(Doe) || [], r = n[1];
  if (r) {
    const i = t.replace(n[0], "");
    return Goe(e, r, t, i);
  }
  return t;
}
function Goe(t, e, n, r) {
  let i = t;
  for (const s of e.split(".")) {
    if (!i)
      return n;
    i = i[s];
  }
  return `${i}${r}`;
}
function Woe(t, e) {
  const n = e?.find((r) => t.startsWith(r.destPath));
  return n ? n.srcPath + t.slice(n.destPath.length) : t;
}
function Voe(t) {
  return t && ooe({
    formatted: t.formattedAddress,
    location: t.geocode,
    addressLine1: t.addressLine,
    addressLine2: t.addressLine2,
    streetAddress: t.streetAddress && {
      name: t.streetAddress.name,
      number: t.streetAddress.number,
      apt: t.streetAddress.apt,
      formattedAddressLine: t.streetAddress.formattedAddressLine
    },
    hint: t.hint,
    city: t.city,
    subdivision: t.subdivision,
    country: t.country,
    postalCode: t.postalCode,
    countryFullname: t.countryFullname,
    subdivisionFullname: t.subdivisionFullname
  });
}
function g4(t) {
  return voe(Object.assign(t, { domainToMappings: {
    "www.wixapis.com": [
      {
        srcPath: "/_api/iam/verification",
        destPath: ""
      }
    ],
    _: [
      {
        srcPath: "/_api/iam/verification",
        destPath: ""
      }
    ],
    "www._base_domain_": [
      {
        srcPath: "/_api/iam/verification",
        destPath: ""
      }
    ],
    "*.dev.wix-code.com": [
      {
        srcPath: "/iam/verification/v1/auth/resend",
        destPath: "/v1/auth/resend"
      },
      {
        srcPath: "/iam/verification/v1/Start",
        destPath: "/v1/Start"
      },
      {
        srcPath: "/iam/verification/v1/auth/verify",
        destPath: "/v1/auth/verify"
      }
    ]
  } }));
}
var p4 = "@wix/auto_sdk_identity_verification";
function Koe(t) {
  function e({ host: n }) {
    return {
      entityFqdn: "wix.iam.verification.v1.start_response",
      method: "POST",
      methodFqn: "wix.iam.verification.v1.VerificationService.Start",
      packageName: p4,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: g4({
        protoPath: "/v1/Start",
        data: t,
        host: n
      }),
      data: t
    };
  }
  return e;
}
function zoe(t) {
  function e({ host: n }) {
    return {
      entityFqdn: "wix.iam.verification.v1.start_response",
      method: "POST",
      methodFqn: "wix.iam.verification.v1.VerificationService.VerifyDuringAuthentication",
      packageName: p4,
      migrationOptions: {
        optInTransformResponse: !0
      },
      url: g4({
        protoPath: "/v1/auth/verify",
        data: t,
        host: n
      }),
      data: t,
      transformResponse: (i) => f4(i, [
        {
          transformFn: woe,
          paths: [
            { path: "identity.createdDate" },
            { path: "identity.updatedDate" },
            { path: "identity.identityProfile.customFields.value.dateValue" },
            { path: "additionalData.*.dateValue" }
          ]
        },
        {
          transformFn: Soe,
          paths: [
            { path: "identity.identityProfile.customFields.value.numValue" },
            { path: "additionalData.*.numValue" }
          ]
        }
      ])
    };
  }
  return e;
}
var b4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_TARGET = "UNKNOWN_TARGET", t.EMAIL = "EMAIL", t))(b4 || {}), y4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_STATE = "UNKNOWN_STATE", t.SUCCESS = "SUCCESS", t.REQUIRE_OWNER_APPROVAL = "REQUIRE_OWNER_APPROVAL", t.REQUIRE_EMAIL_VERIFICATION = "REQUIRE_EMAIL_VERIFICATION", t.STATUS_CHECK = "STATUS_CHECK", t))(y4 || {}), A4 = /* @__PURE__ */ ((t) => (t.UNDEFINED = "UNDEFINED", t.PUBLIC = "PUBLIC", t.PRIVATE = "PRIVATE", t))(A4 || {}), E4 = /* @__PURE__ */ ((t) => (t.UNTAGGED = "UNTAGGED", t.MAIN = "MAIN", t.HOME = "HOME", t.WORK = "WORK", t))(E4 || {}), S4 = /* @__PURE__ */ ((t) => (t.UNTAGGED = "UNTAGGED", t.MAIN = "MAIN", t.HOME = "HOME", t.MOBILE = "MOBILE", t.WORK = "WORK", t.FAX = "FAX", t))(S4 || {}), w4 = /* @__PURE__ */ ((t) => (t.UNTAGGED = "UNTAGGED", t.HOME = "HOME", t.WORK = "WORK", t.BILLING = "BILLING", t.SHIPPING = "SHIPPING", t))(w4 || {}), F4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_STATUS = "UNKNOWN_STATUS", t.PENDING = "PENDING", t.ACTIVE = "ACTIVE", t.DELETED = "DELETED", t.BLOCKED = "BLOCKED", t.OFFLINE = "OFFLINE", t))(F4 || {}), T4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_REASON = "UNKNOWN_REASON", t.PENDING_ADMIN_APPROVAL_REQUIRED = "PENDING_ADMIN_APPROVAL_REQUIRED", t.PENDING_EMAIL_VERIFICATION_REQUIRED = "PENDING_EMAIL_VERIFICATION_REQUIRED", t))(T4 || {}), v4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_FACTOR_TYPE = "UNKNOWN_FACTOR_TYPE", t.PASSWORD = "PASSWORD", t.SMS = "SMS", t.CALL = "CALL", t.EMAIL = "EMAIL", t.TOTP = "TOTP", t.PUSH = "PUSH", t.WEBAUTHN = "WEBAUTHN", t.RECOVERY_CODE = "RECOVERY_CODE", t))(v4 || {}), x4 = /* @__PURE__ */ ((t) => (t.INACTIVE = "INACTIVE", t.ACTIVE = "ACTIVE", t.REQUIRE_REENROLL = "REQUIRE_REENROLL", t))(x4 || {}), C4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_FACTOR_STATUS = "UNKNOWN_FACTOR_STATUS", t.ENABLED = "ENABLED", t.REQUIRE_ACTIVATION = "REQUIRE_ACTIVATION", t.REQUIRE_REENROLL = "REQUIRE_REENROLL", t.ENABLED_BY_RULE = "ENABLED_BY_RULE", t.DISABLED_BY_RULE = "DISABLED_BY_RULE", t))(C4 || {}), k4 = /* @__PURE__ */ ((t) => (t.UNKNOWN_MFA_REASON = "UNKNOWN_MFA_REASON", t.USER_SETTINGS = "USER_SETTINGS", t.HIGH_RISK_LOGIN = "HIGH_RISK_LOGIN", t))(k4 || {});
async function joe(t) {
  const { httpClient: e, sideEffects: n } = arguments[1], r = h4({
    identityId: t?.identityId,
    target: t?.target
  }), i = Koe(r);
  n?.onSiteCall?.();
  try {
    const s = await e.request(i);
    return n?.onSuccess?.(s), d4(s.data);
  } catch (s) {
    const a = l4(
      s,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          identityId: "$[0].identityId",
          target: "$[0].target"
        },
        singleArgumentUnchanged: !1
      },
      ["options"]
    );
    throw n?.onError?.(s), a;
  }
}
async function Yoe(t, e) {
  const { httpClient: n, sideEffects: r } = arguments[2], i = h4({
    code: t,
    stateToken: e?.stateToken
  }), s = zoe(
    i
  );
  r?.onSiteCall?.();
  try {
    const a = await n.request(s);
    return r?.onSuccess?.(a), d4(
      f4(a.data, [
        {
          transformFn: Voe,
          paths: [{ path: "identity.identityProfile.addresses.address" }]
        }
      ])
    );
  } catch (a) {
    const o = l4(
      a,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          code: "$[0]",
          stateToken: "$[1].stateToken"
        },
        singleArgumentUnchanged: !1
      },
      ["code", "options"]
    );
    throw r?.onError?.(a), o;
  }
}
function qoe(t) {
  return (e) => joe(
    e,
    // @ts-ignore
    { httpClient: t }
  );
}
function Joe(t) {
  return (e, n) => Yoe(
    e,
    n,
    // @ts-ignore
    { httpClient: t }
  );
}
var Qoe = /* @__PURE__ */ m4(qoe), Xoe = /* @__PURE__ */ m4(Joe);
const Zoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddressTag: w4,
  EmailTag: E4,
  FactorStatus: C4,
  FactorType: v4,
  MfaReason: k4,
  PhoneTag: S4,
  PrivacyStatus: A4,
  Reason: T4,
  StateType: y4,
  Status: x4,
  StatusName: F4,
  Target: b4,
  start: Qoe,
  verifyDuringAuthentication: Xoe
}, Symbol.toStringTag, { value: "Module" }));
var gs;
(function(t) {
  t.SUCCESS = "SUCCESS", t.INITIAL = "INITIAL", t.FAILURE = "FAILURE", t.EMAIL_VERIFICATION_REQUIRED = "EMAIL_VERIFICATION_REQUIRED", t.OWNER_APPROVAL_REQUIRED = "OWNER_APPROVAL_REQUIRED", t.USER_CAPTCHA_REQUIRED = "USER_CAPTCHA_REQUIRED", t.SILENT_CAPTCHA_REQUIRED = "SILENT_CAPTCHA_REQUIRED";
})(gs || (gs = {}));
var _l;
(function(t) {
  t.NONE = "none", t.VISITOR = "visitor", t.MEMBER = "member";
})(_l || (_l = {}));
function eue(t, e, n) {
  t.addEventListener ? t.addEventListener(e, n) : t.attachEvent("on" + e, n);
}
function tue(t, e, n) {
  t.removeEventListener ? t.removeEventListener(e, n) : t.detachEvent("on" + e, n);
}
function nue(t) {
  const e = document.createElement("iframe");
  return e.style.display = "none", e.src = t, document.body.appendChild(e);
}
function rue(t) {
  let e, n;
  return new Promise((i, s) => {
    e = (a) => {
      !a.data || a.data.state !== t || i(a.data);
    }, eue(window, "message", e), n = setTimeout(() => {
      s(new Error("OAuth flow timed out"));
    }, 12e4);
  }).finally(() => {
    clearTimeout(n), tue(window, "message", e);
  });
}
const pN = "-19971", bN = "-19970", iue = "-19995", sue = "-19976", aue = "-19973";
const Ho = [24, 16, 8, 0], oue = [-2147483648, 8388608, 32768, 128], y0 = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
class uue {
  blocks;
  h0;
  h1;
  h2;
  h3;
  h4;
  h5;
  h6;
  h7;
  block;
  start;
  bytes;
  hBytes;
  finalized;
  hashed;
  first;
  lastByteIndex;
  chromeBugWorkAround;
  constructor() {
    this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0;
  }
  update(e) {
    const n = this.blocks, r = e.length;
    let i, s = 0, a;
    for (; s < r; ) {
      for (this.hashed && (this.hashed = !1, n[0] = this.block, this.block = n[16] = n[1] = n[2] = n[3] = n[4] = n[5] = n[6] = n[7] = n[8] = n[9] = n[10] = n[11] = n[12] = n[13] = n[14] = n[15] = 0), a = this.start; s < r && a < 64; ++s)
        i = e.charCodeAt(s), i < 128 ? n[a >>> 2] |= i << Ho[a++ & 3] : i < 2048 ? (n[a >>> 2] |= (192 | i >>> 6) << Ho[a++ & 3], n[a >>> 2] |= (128 | i & 63) << Ho[a++ & 3]) : i < 55296 || i >= 57344 ? (n[a >>> 2] |= (224 | i >>> 12) << Ho[a++ & 3], n[a >>> 2] |= (128 | i >>> 6 & 63) << Ho[a++ & 3], n[a >>> 2] |= (128 | i & 63) << Ho[a++ & 3]) : (i = 65536 + ((i & 1023) << 10 | e.charCodeAt(++s) & 1023), n[a >>> 2] |= (240 | i >>> 18) << Ho[a++ & 3], n[a >>> 2] |= (128 | i >>> 12 & 63) << Ho[a++ & 3], n[a >>> 2] |= (128 | i >>> 6 & 63) << Ho[a++ & 3], n[a >>> 2] |= (128 | i & 63) << Ho[a++ & 3]);
      this.lastByteIndex = a, this.bytes += a - this.start, a >= 64 ? (this.block = n[16], this.start = a - 64, this.hash(), this.hashed = !0) : this.start = a;
    }
    return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
  }
  hash() {
    const e = this.blocks;
    let n = this.h0, r = this.h1, i = this.h2, s = this.h3, a = this.h4, o = this.h5, u = this.h6, l = this.h7, h, f, m, g, A, E, w, x, N, B, P;
    for (h = 16; h < 64; ++h)
      A = e[h - 15], f = (A >>> 7 | A << 25) ^ (A >>> 18 | A << 14) ^ A >>> 3, A = e[h - 2], m = (A >>> 17 | A << 15) ^ (A >>> 19 | A << 13) ^ A >>> 10, e[h] = e[h - 16] + f + e[h - 7] + m << 0;
    for (P = r & i, h = 0; h < 64; h += 4)
      this.first ? (x = 704751109, A = e[0] - 210244248, l = A - 1521486534 << 0, s = A + 143694565 << 0, this.first = !1) : (f = (n >>> 2 | n << 30) ^ (n >>> 13 | n << 19) ^ (n >>> 22 | n << 10), m = (a >>> 6 | a << 26) ^ (a >>> 11 | a << 21) ^ (a >>> 25 | a << 7), x = n & r, g = x ^ n & i ^ P, w = a & o ^ ~a & u, A = l + m + w + y0[h] + e[h], E = f + g, l = s + A << 0, s = A + E << 0), f = (s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10), m = (l >>> 6 | l << 26) ^ (l >>> 11 | l << 21) ^ (l >>> 25 | l << 7), N = s & n, g = N ^ s & r ^ x, w = l & a ^ ~l & o, A = u + m + w + y0[h + 1] + e[h + 1], E = f + g, u = i + A << 0, i = A + E << 0, f = (i >>> 2 | i << 30) ^ (i >>> 13 | i << 19) ^ (i >>> 22 | i << 10), m = (u >>> 6 | u << 26) ^ (u >>> 11 | u << 21) ^ (u >>> 25 | u << 7), B = i & s, g = B ^ i & n ^ N, w = u & l ^ ~u & a, A = o + m + w + y0[h + 2] + e[h + 2], E = f + g, o = r + A << 0, r = A + E << 0, f = (r >>> 2 | r << 30) ^ (r >>> 13 | r << 19) ^ (r >>> 22 | r << 10), m = (o >>> 6 | o << 26) ^ (o >>> 11 | o << 21) ^ (o >>> 25 | o << 7), P = r & i, g = P ^ r & s ^ B, w = o & u ^ ~o & l, A = a + m + w + y0[h + 3] + e[h + 3], E = f + g, a = n + A << 0, n = A + E << 0, this.chromeBugWorkAround = !0;
    this.h0 = this.h0 + n << 0, this.h1 = this.h1 + r << 0, this.h2 = this.h2 + i << 0, this.h3 = this.h3 + s << 0, this.h4 = this.h4 + a << 0, this.h5 = this.h5 + o << 0, this.h6 = this.h6 + u << 0, this.h7 = this.h7 + l << 0;
  }
  finalize() {
    if (this.finalized)
      return;
    this.finalized = !0;
    const e = this.blocks, n = this.lastByteIndex;
    e[16] = this.block, e[n >>> 2] |= oue[n & 3], this.block = e[16], n >= 56 && (this.hashed || this.hash(), e[0] = this.block, e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = this.hBytes << 3 | this.bytes >>> 29, e[15] = this.bytes << 3, this.hash();
  }
  arrayBuffer() {
    this.finalize();
    const e = new ArrayBuffer(32), n = new DataView(e);
    return n.setUint32(0, this.h0), n.setUint32(4, this.h1), n.setUint32(8, this.h2), n.setUint32(12, this.h3), n.setUint32(16, this.h4), n.setUint32(20, this.h5), n.setUint32(24, this.h6), n.setUint32(28, this.h7), e;
  }
}
function lue(t) {
  return new uue().update(t).arrayBuffer();
}
function xS(t) {
  if (t || (t = 43), t < 43 || t > 128)
    throw new Error(`Expected a length between 43 and 128. Received ${t}.`);
  const e = cue(t), n = hue(e);
  return {
    code_verifier: e,
    code_challenge: n
  };
}
function cue(t) {
  return due(t);
}
function hue(t) {
  return fue(lue(t));
}
function due(t) {
  const e = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~";
  let n = "";
  const r = crypto.getRandomValues(new Uint8Array(t));
  for (let i = 0; i < t; i++) {
    const s = r[i] % e.length;
    n += e[s];
  }
  return n;
}
function fue(t) {
  return (typeof Buffer > "u" ? btoa(mue(t)) : Buffer.from(t).toString("base64")).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function mue(t) {
  return String.fromCharCode.apply(null, Array.from(new Uint8Array(t)));
}
const yT = "wixRedirectSessionLastPreWarm";
function _4() {
  const t = localStorage.getItem(yT), e = Date.now();
  if (t) {
    const n = parseInt(t, 10), r = 10080 * 60 * 1e3;
    if (e - n < r)
      return !0;
  }
  return !1;
}
async function gue(t = {}) {
  if (!(!t.force && _4())) {
    localStorage.removeItem(yT);
    try {
      await pue(), localStorage.setItem(yT, Date.now().toString());
    } catch (e) {
      console.error("Error during redirect session pre-warm:", e);
    }
  }
}
async function pue() {
  const e = (await _B({
    login: {}
  })).redirectSession?.fullUrl;
  if (!e)
    throw new Error("No redirect URL found");
  const n = document.createElement("iframe");
  n.style.display = "none", n.src = e;
  const r = new Promise((i) => n.onload = i);
  return document.body.appendChild(n), r;
}
const bue = {
  accessToken: { value: "", expiresAt: 0 },
  refreshToken: { value: "", role: _l.NONE }
};
function yue(t) {
  let e = t;
  return {
    getTokens: () => e,
    setTokens: (n) => {
      e = n;
    }
  };
}
const Aue = { redirects: Xie, authentication: iae, recovery: ioe, verification: Zoe };
function Eue(t) {
  const e = t.tokenRequestOptions?.headers ?? {}, n = t.tokenStorage ?? yue(t.tokens ?? bue), r = () => n.getTokens(), i = (I) => n.setTokens(I);
  let s = {
    loginState: gs.INITIAL
  };
  const a = async () => {
    const I = r();
    if (!I.accessToken?.value || lN(I.accessToken)) {
      const U = await u({
        refreshToken: I.refreshToken
      });
      i(U);
    }
    return Promise.resolve({
      headers: { Authorization: r().accessToken.value }
    });
  }, o = AB({
    modules: Aue,
    auth: { getAuthHeaders: a }
  }), u = async (I) => {
    if (I?.accessToken?.value && I?.refreshToken?.value && !lN(I.accessToken))
      return I;
    if (I?.refreshToken?.value)
      try {
        return await l(I.refreshToken);
      } catch {
      }
    const U = await A0({
      clientId: t.clientId,
      grantType: "anonymous"
    }, e);
    return {
      accessToken: b0(U.access_token, U.expires_in),
      refreshToken: {
        value: U.refresh_token,
        role: _l.VISITOR
      }
    };
  }, l = async (I) => {
    const U = await A0({
      refreshToken: I.value,
      grantType: "refresh_token"
    }, e);
    return {
      accessToken: b0(U.access_token, U.expires_in),
      refreshToken: I
    };
  }, h = () => {
    const I = xS();
    return {
      codeChallenge: I.code_challenge,
      codeVerifier: I.code_verifier,
      state: xS().code_challenge
    };
  }, f = (I, U) => {
    const j = { redirectUri: I }, J = h();
    return {
      ...j,
      originalUri: U ?? "",
      codeChallenge: J.codeChallenge,
      codeVerifier: J.codeVerifier,
      state: xS().code_challenge
    };
  }, m = async (I, U, j, J) => {
    const { redirectSession: G } = await o.redirects.createRedirectSession({
      auth: {
        authRequest: {
          redirectUri: I.redirectUri,
          ...I.redirectUri && {
            redirectUri: I.redirectUri
          },
          clientId: t.clientId,
          codeChallenge: I.codeChallenge,
          codeChallengeMethod: "S256",
          responseMode: U,
          responseType: "code",
          scope: "offline_access",
          state: I.state,
          ...J && { sessionToken: J }
        },
        prompt: iC[j]
      }
    });
    return {
      authUrl: G.fullUrl,
      authorizationEndpoint: G.urlDetails.endpoint,
      sessionToken: G.sessionToken
    };
  }, g = async (I = f("unused://"), U = {
    prompt: "login"
  }) => m(I, U.responseMode ?? "fragment", U.prompt ?? "login", U.sessionToken), A = (I, U = "fragment") => {
    const j = new URL(I ?? window.location.href), J = U === "query" ? j.searchParams : new URLSearchParams(j.hash.substring(1)), G = J.get("code"), H = J.get("state"), q = J.get("error"), X = J.get("error_description");
    return { code: G, state: H, ...q && { error: q, errorDescription: X } };
  }, E = async (I, U, j) => {
    if (!I || !U)
      throw new Error("Missing code or _state");
    if (U !== j.state)
      throw new Error("Invalid _state");
    const J = await A0({
      clientId: t.clientId,
      grantType: "authorization_code",
      ...j.redirectUri && { redirectUri: j.redirectUri },
      code: I,
      codeVerifier: j.codeVerifier
    }, e);
    return {
      accessToken: b0(J.access_token, J.expires_in),
      refreshToken: {
        value: J.refresh_token,
        role: _l.MEMBER
      }
    };
  }, w = async (I) => {
    const { redirectSession: U } = await o.redirects.createRedirectSession({
      logout: { clientId: t.clientId },
      callbacks: {
        postFlowUrl: I
      }
    });
    return i({
      accessToken: { value: "", expiresAt: 0 },
      refreshToken: { value: "", role: _l.NONE }
    }), { logoutUrl: U.fullUrl };
  }, x = (I) => I.state === Jm.SUCCESS ? {
    loginState: gs.SUCCESS,
    data: { sessionToken: I.sessionToken }
  } : I.state === Jm.REQUIRE_OWNER_APPROVAL ? {
    loginState: gs.OWNER_APPROVAL_REQUIRED
  } : I.state === Jm.REQUIRE_EMAIL_VERIFICATION ? (s = {
    loginState: gs.EMAIL_VERIFICATION_REQUIRED,
    data: { stateToken: I.stateToken }
  }, s) : {
    loginState: gs.FAILURE,
    error: "Unknown _state"
  };
  return {
    generateVisitorTokens: u,
    renewToken: l,
    parseFromUrl: A,
    getAuthUrl: g,
    getMemberTokens: E,
    generateOAuthData: f,
    getAuthHeaders: a,
    setTokens: i,
    getTokens: r,
    loggedIn: () => r().refreshToken.role === _l.MEMBER,
    logout: w,
    register: async (I) => {
      try {
        const U = await o.authentication.registerV2({
          email: I.email
        }, {
          password: I.password,
          profile: I.profile,
          ...I.captchaTokens && {
            captchaTokens: [
              {
                Recaptcha: I.captchaTokens?.recaptchaToken,
                InvisibleRecaptcha: I.captchaTokens?.invisibleRecaptchaToken
              }
            ]
          }
        });
        return x(U);
      } catch (U) {
        const j = U.details.validationError?.fieldViolations?.find((J) => J.data.type === "EMAIL");
        return j ? {
          loginState: gs.FAILURE,
          error: j.description,
          errorCode: "invalidEmail"
        } : U.details.applicationError?.code === pN ? {
          loginState: gs.FAILURE,
          error: U.message,
          errorCode: "missingCaptchaToken"
        } : U.details.applicationError?.code === iue ? {
          loginState: gs.FAILURE,
          error: U.message,
          errorCode: "emailAlreadyExists"
        } : U.details.applicationError?.code === bN ? {
          loginState: gs.FAILURE,
          error: U.message,
          errorCode: "invalidCaptchaToken"
        } : {
          loginState: gs.FAILURE,
          error: U.message
        };
      }
    },
    processVerification: async (I, U) => {
      const j = U ?? s;
      if (j.loginState === gs.EMAIL_VERIFICATION_REQUIRED) {
        const J = I.verificationCode ?? I.code, G = await o.verification.verifyDuringAuthentication(J, { stateToken: j.data.stateToken });
        return x(G);
      }
      return {
        loginState: gs.FAILURE,
        error: "Unknown _state"
      };
    },
    login: async (I) => {
      try {
        const U = await o.authentication.loginV2({
          email: I.email
        }, {
          password: I.password,
          ...I.captchaTokens && {
            captchaTokens: [
              {
                Recaptcha: I.captchaTokens?.recaptchaToken,
                InvisibleRecaptcha: I.captchaTokens?.invisibleRecaptchaToken
              }
            ]
          }
        });
        return x(U);
      } catch (U) {
        return {
          loginState: gs.FAILURE,
          error: U.message,
          errorCode: U.details.applicationError?.code === pN ? "missingCaptchaToken" : U.details.applicationError?.code === bN ? "invalidCaptchaToken" : U.details.applicationError.code === sue ? "invalidPassword" : U.details.applicationError.code === aue ? "resetPassword" : "invalidEmail"
        };
      }
    },
    getMemberTokensForDirectLogin: async (I) => {
      const U = h(), { authUrl: j } = await m(U, "web_message", "none", I), J = rue(U.state), G = nue(j);
      return J.then((H) => E(H.code, H.state, U)).finally(() => {
        document.body.contains(G) && G.parentElement?.removeChild(G);
      });
    },
    getMemberTokensForExternalLogin: async (I, U) => {
      const j = await A0({
        grant_type: "authorized_client",
        scope: "offline_access",
        member_id: I
      }, {
        Authorization: r().accessToken.value + "," + U,
        ...e
      });
      return {
        accessToken: b0(j.access_token, j.expires_in),
        refreshToken: {
          value: j.refresh_token,
          role: _l.MEMBER
        }
      };
    },
    sendPasswordResetEmail: async (I, U) => {
      await o.recovery.sendRecoveryEmail(I, {
        redirect: { url: U, clientId: t.clientId }
      });
    },
    captchaInvisibleSiteKey: "6LdoPaUfAAAAAJphvHoUoOob7mx0KDlXyXlgrx5v",
    captchaVisibleSiteKey: "6Ld0J8IcAAAAANyrnxzrRlX1xrrdXsOmsepUYosy",
    sessions: {
      isSessionSynced: _4,
      syncToWixPages: gue
    },
    shouldUseCDN: !0
  };
}
const A0 = async (t, e = {}) => {
  const n = await fetch(`https://${Wd}/oauth2/token`, {
    method: "POST",
    body: JSON.stringify(t),
    headers: {
      ...gB({
        entityFqdn: "wix.identity.oauth.v1.refresh_token",
        methodFqn: "wix.identity.oauth2.v1.Oauth2Ng.Token",
        packageName: "@wix/sdk"
      }),
      "Content-Type": "application/json",
      ...e
    }
  });
  if (n.status !== 200) {
    let i;
    try {
      i = await n.json();
    } catch {
    }
    throw new Error(`Failed to fetch tokens from OAuth API: ${n.statusText}. request id: ${n.headers.get("x-request-id")}. ${i ? `Response: ${JSON.stringify(i)}` : ""}`);
  }
  return await n.json();
}, Sue = (t) => AB({
  auth: Eue({
    clientId: t
  })
}), wue = la(tC, ({ config: t }) => {
  const e = Sue(t.clientId);
  return {
    getWixClient: () => e
  };
}), Fue = la(tC, (t) => ({
  getWixClient: () => null
})), Tue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WixClientService: wue,
  WixClientServiceNoop: Fue
}, Symbol.toStringTag, { value: "Module" })), vue = /* @__PURE__ */ vt(Tue), pC = du("@wix/site-service-interactions"), xue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  InteractionsDefinition: pC
}, Symbol.toStringTag, { value: "Module" }));
var CS = { exports: {} }, kS = { exports: {} }, _S = { exports: {} }, yN;
function N4() {
  return yN || (yN = 1, (function(t) {
    function e(n) {
      "@babel/helpers - typeof";
      return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(_S)), _S.exports;
}
var NS = { exports: {} }, AN;
function Cue() {
  return AN || (AN = 1, (function(t) {
    var e = N4().default;
    function n(r, i) {
      if (e(r) != "object" || !r) return r;
      var s = r[Symbol.toPrimitive];
      if (s !== void 0) {
        var a = s.call(r, i || "default");
        if (e(a) != "object") return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (i === "string" ? String : Number)(r);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(NS)), NS.exports;
}
var EN;
function kue() {
  return EN || (EN = 1, (function(t) {
    var e = N4().default, n = Cue();
    function r(i) {
      var s = n(i, "string");
      return e(s) == "symbol" ? s : s + "";
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(kS)), kS.exports;
}
var SN;
function _ue() {
  return SN || (SN = 1, (function(t) {
    var e = kue();
    function n(r, i, s) {
      return (i = e(i)) in r ? Object.defineProperty(r, i, {
        value: s,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[i] = s, r;
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(CS)), CS.exports;
}
var Nue = _ue();
const pr = /* @__PURE__ */ kh(Nue);
function Due(t) {
  return [...t.matchAll(/\[([-\w]+)]/g)].map((e) => {
    let [n, r] = e;
    return r;
  });
}
function Fg(t, e) {
  const n = Due(e);
  let r = 0;
  return n.length ? t.replace(/\[]/g, () => `[${n[r++]}]` || "[]") : t;
}
class bC {
  constructor(e, n) {
    pr(this, "animations", void 0), pr(this, "options", void 0), pr(this, "ready", void 0), pr(this, "isCSS", void 0), this.animations = e, this.options = n, this.ready = n?.measured || Promise.resolve(), this.isCSS = e[0] instanceof CSSAnimation;
  }
  getProgress() {
    var e;
    return ((e = this.animations[0]) == null || (e = e.effect) == null ? void 0 : e.getComputedTiming().progress) || 0;
  }
  async play(e) {
    await this.ready;
    for (const n of this.animations)
      n.play();
    await Promise.all(this.animations.map((n) => n.ready)), e && e();
  }
  pause() {
    for (const e of this.animations)
      e.pause();
  }
  async reverse(e) {
    await this.ready;
    for (const n of this.animations)
      n.reverse();
    await Promise.all(this.animations.map((n) => n.ready)), e && e();
  }
  progress(e) {
    for (const n of this.animations) {
      const {
        activeDuration: r
      } = n.effect.getComputedTiming(), {
        delay: i
      } = n.effect.getTiming();
      n.currentTime = ((i || 0) + (r || 0)) * e;
    }
  }
  cancel() {
    for (const e of this.animations)
      e.cancel();
  }
  setPlaybackRate(e) {
    for (const n of this.animations)
      n.playbackRate = e;
  }
  async onFinish(e) {
    try {
      await Promise.all(this.animations.map((i) => i.finished));
      const r = this.animations[0];
      if (r && !this.isCSS) {
        var n;
        const i = (n = r.effect) == null ? void 0 : n.target;
        if (i) {
          const s = new Event("animationend");
          i.dispatchEvent(s);
        }
      }
      e();
    } catch (r) {
      console.warn("animation was interrupted - aborting onFinish callback - ", r);
    }
  }
  async onAbort(e) {
    try {
      await Promise.all(this.animations.map((r) => r.finished));
    } catch (r) {
      if (r.name === "AbortError") {
        const i = this.animations[0];
        if (i && !this.isCSS) {
          var n;
          const s = (n = i.effect) == null ? void 0 : n.target;
          if (s) {
            const a = new Event("animationcancel");
            s.dispatchEvent(a);
          }
        }
        e();
      }
    }
  }
  get finished() {
    return Promise.all(this.animations.map((e) => e.finished));
  }
  get playState() {
    var e;
    return (e = this.animations[0]) == null ? void 0 : e.playState;
  }
}
const Iue = (t) => t, Rue = (t) => 1 - Math.cos(t * Math.PI / 2), Pue = (t) => Math.sin(t * Math.PI / 2), Lue = (t) => -(Math.cos(Math.PI * t) - 1) / 2, Mue = (t) => t ** 2, Oue = (t) => 1 - (1 - t) ** 2, D4 = (t) => t < 0.5 ? 2 * t ** 2 : 1 - (-2 * t + 2) ** 2 / 2, Bue = (t) => t ** 3, $ue = (t) => 1 - (1 - t) ** 3, Hue = (t) => t < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2, Uue = (t) => t ** 4, Gue = (t) => 1 - (1 - t) ** 4, Wue = (t) => t < 0.5 ? 8 * t ** 4 : 1 - (-2 * t + 2) ** 4 / 2, Vue = (t) => t ** 5, Kue = (t) => 1 - (1 - t) ** 5, zue = (t) => t < 0.5 ? 16 * t ** 5 : 1 - (-2 * t + 2) ** 5 / 2, jue = (t) => t === 0 ? 0 : 2 ** (10 * t - 10), Yue = (t) => t === 1 ? 1 : 1 - 2 ** (-10 * t), que = (t) => t === 0 ? 0 : t === 1 ? 1 : t < 0.5 ? 2 ** (20 * t - 10) / 2 : (2 - 2 ** (-20 * t + 10)) / 2, Jue = (t) => 1 - Math.sqrt(1 - t ** 2), Que = (t) => Math.sqrt(1 - (t - 1) ** 2), AT = (t) => t < 0.5 ? (1 - Math.sqrt(1 - 4 * t ** 2)) / 2 : (Math.sqrt(-(2 * t - 3) * (2 * t - 1)) + 1) / 2, Xue = (t) => 2.70158 * t ** 3 - 1.70158 * t ** 2, Zue = (t) => 1 + 2.70158 * (t - 1) ** 3 + 1.70158 * (t - 1) ** 2, ele = function(t, e) {
  return e === void 0 && (e = 1.70158 * 1.525), t < 0.5 ? (2 * t) ** 2 * ((e + 1) * 2 * t - e) / 2 : ((2 * t - 2) ** 2 * ((e + 1) * (t * 2 - 2) + e) + 2) / 2;
}, tle = {
  linear: Iue,
  sineIn: Rue,
  sineOut: Pue,
  sineInOut: Lue,
  quadIn: Mue,
  quadOut: Oue,
  quadInOut: D4,
  cubicIn: Bue,
  cubicOut: $ue,
  cubicInOut: Hue,
  quartIn: Uue,
  quartOut: Gue,
  quartInOut: Wue,
  quintIn: Vue,
  quintOut: Kue,
  quintInOut: zue,
  expoIn: jue,
  expoOut: Yue,
  expoInOut: que,
  circIn: Jue,
  circOut: Que,
  circInOut: AT,
  backIn: Xue,
  backOut: Zue,
  backInOut: ele
}, lf = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  sineIn: "cubic-bezier(0.47, 0, 0.745, 0.715)",
  sineOut: "cubic-bezier(0.39, 0.575, 0.565, 1)",
  sineInOut: "cubic-bezier(0.445, 0.05, 0.55, 0.95)",
  quadIn: "cubic-bezier(0.55, 0.085, 0.68, 0.53)",
  quadOut: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  quadInOut: "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
  cubicIn: "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
  cubicOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  cubicInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  quartIn: "cubic-bezier(0.895, 0.03, 0.685, 0.22)",
  quartOut: "cubic-bezier(0.165, 0.84, 0.44, 1)",
  quartInOut: "cubic-bezier(0.77, 0, 0.175, 1)",
  quintIn: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  quintOut: "cubic-bezier(0.23, 1, 0.32, 1)",
  quintInOut: "cubic-bezier(0.86, 0, 0.07, 1)",
  expoIn: "cubic-bezier(0.95, 0.05, 0.795, 0.035)",
  expoOut: "cubic-bezier(0.19, 1, 0.22, 1)",
  expoInOut: "cubic-bezier(1, 0, 0, 1)",
  circIn: "cubic-bezier(0.6, 0.04, 0.98, 0.335)",
  circOut: "cubic-bezier(0.075, 0.82, 0.165, 1)",
  circInOut: "cubic-bezier(0.785, 0.135, 0.15, 0.86)",
  backIn: "cubic-bezier(0.6, -0.28, 0.735, 0.045)",
  backOut: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  backInOut: "cubic-bezier(0.68, -0.55, 0.265, 1.55)"
};
function Ct(t, e, n, r, i) {
  return (i - t) * (r - n) / (e - t) + n;
}
function nle(t, e) {
  let [n, r] = t, [i, s] = e;
  return Math.sqrt((i - n) ** 2 + (s - r) ** 2);
}
function rle(t, e, n) {
  t === void 0 && (t = [0, 0]), e === void 0 && (e = [0, 0]);
  const r = Math.atan2(e[1] - t[1], e[0] - t[0]) * 180 / Math.PI;
  return (360 + n + r) % 360;
}
const Mr = 1e-6, ile = {
  initial: (t) => {
    let {
      top: e,
      bottom: n,
      left: r,
      right: i
    } = t;
    return `${r}% ${e}%, ${i}% ${e}%, ${i}% ${n}%, ${r}% ${n}%`;
  },
  top: (t) => {
    let {
      top: e,
      left: n,
      right: r,
      minimum: i
    } = t;
    return `${n}% ${e}%, ${r}% ${e}%, ${r}% ${e + i}%, ${n}% ${e + i}%`;
  },
  right: (t) => {
    let {
      top: e,
      bottom: n,
      right: r,
      minimum: i
    } = t;
    return `${r - i}% ${e}%, ${r}% ${e}%, ${r}% ${n}%, ${r - i}% ${n}%`;
  },
  center: (t) => {
    let {
      centerX: e,
      centerY: n,
      minimum: r
    } = t;
    return `${e - r / 2}% ${n - r / 2}%, ${e + r / 2}% ${n - r / 2}%, ${e + r / 2}% ${n + r / 2}%, ${e - r / 2}% ${n + r / 2}%`;
  },
  bottom: (t) => {
    let {
      bottom: e,
      left: n,
      right: r,
      minimum: i
    } = t;
    return `${n}% ${e - i}%, ${r}% ${e - i}%, ${r}% ${e}%, ${n}% ${e}%`;
  },
  left: (t) => {
    let {
      top: e,
      bottom: n,
      left: r,
      minimum: i
    } = t;
    return `${r}% ${e}%, ${r + i}% ${e}%, ${r + i}% ${n}%, ${r}% ${n}%`;
  },
  vertical: (t) => {
    let {
      top: e,
      bottom: n,
      left: r,
      right: i,
      minimum: s
    } = t;
    return `${r}% ${e + s / 2}%, ${i}% ${e + s / 2}%, ${i}% ${n - s / 2}%, ${r}% ${n - s / 2}%`;
  },
  horizontal: (t) => {
    let {
      top: e,
      bottom: n,
      left: r,
      right: i,
      minimum: s
    } = t;
    return `${r + s / 2}% ${e}%, ${i - s / 2}% ${e}%, ${i - s / 2}% ${n}%, ${r + s / 2}% ${n}%`;
  }
};
function oa(t) {
  let {
    direction: e,
    scaleX: n = 1,
    scaleY: r = 1,
    minimum: i = 0
  } = t;
  const s = (1 - r) / 2 * 100, a = (1 - n) / 2 * 100, o = 100 + a - (1 - n) * 100, u = 100 + s - (1 - r) * 100, l = (o + a) / 2, h = (u + s) / 2;
  return `polygon(${ile[e]({
    top: s,
    bottom: u,
    left: a,
    right: o,
    centerX: l,
    centerY: h,
    minimum: i
  })})`;
}
const mA = "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", np = ["bottom", "left", "top", "right"];
function yC(t, e) {
  return e === "out" ? mA : oa({
    direction: gA(np, t)
  });
}
function AC(t, e) {
  return e === "in" ? mA : oa({
    direction: e === "out" ? gA(np, t) : t
  });
}
function I4(t, e, n) {
  t.measure((r) => {
    if (!r)
      return;
    const i = parseInt(getComputedStyle(r).getPropertyValue("--comp-rotate-z") || "0", 10);
    t.mutate(() => {
      const s = wc(np, e, i);
      r.style.setProperty("--motion-clip-from", yC(s, n)), r.style.setProperty("--motion-clip-to", AC(s, n));
    });
  });
}
function wc(t, e, n) {
  const r = t.indexOf(e), i = t.length, s = Math.round((n || 0) / 360 * i), a = (r + (i - 1) * s) % i;
  return t[a];
}
function gA(t, e) {
  const n = Math.max(0, t.indexOf(e)), r = t.length;
  return t[(n + (r >> 1)) % r];
}
function sle(t, e) {
  const n = t * Math.PI / 180, r = Math.cos(n) * e, i = Math.sin(n) * e;
  return [r, i];
}
function Us(t) {
  return t === "percentage" ? "%" : t || "px";
}
function lr(t) {
  return t ? lf[t] || t : lf.linear;
}
function ale(t) {
  return t ? tle[t] : void 0;
}
function rp(t) {
  if (!lf[t])
    return {
      in: t,
      inOut: t,
      out: t
    };
  const e = t.replace(/In|Out/g, "");
  return e === "linear" ? {
    in: "linear",
    inOut: "linear",
    out: "linear"
  } : {
    in: `${e}In`,
    inOut: `${e}InOut`,
    out: `${e}Out`
  };
}
const ole = {
  linear: "linear",
  easeOut: "ease-out",
  hardBackOut: "cubic-bezier(0.58, 2.5, 0, 0.95)",
  elastic: "linear( 0, 0.2178 2.1%, 1.1144 8.49%, 1.2959 10.7%, 1.3463 11.81%, 1.3705 12.94%, 1.3726, 1.3643 14.48%, 1.3151 16.2%, 1.0317 21.81%, 0.941 24.01%, 0.8912 25.91%, 0.8694 27.84%, 0.8698 29.21%, 0.8824 30.71%, 1.0122 38.33%, 1.0357, 1.046 42.71%, 1.0416 45.7%, 0.9961 53.26%, 0.9839 57.54%, 0.9853 60.71%, 1.0012 68.14%, 1.0056 72.24%, 0.9981 86.66%, 1 )",
  bounce: "linear( 0, 0.0039, 0.0157, 0.0352, 0.0625 9.09%, 0.1407, 0.25, 0.3908, 0.5625, 0.7654, 1, 0.8907, 0.8125 45.45%, 0.7852, 0.7657, 0.7539, 0.75, 0.7539, 0.7657, 0.7852, 0.8125 63.64%, 0.8905, 1 72.73%, 0.9727, 0.9532, 0.9414, 0.9375, 0.9414, 0.9531, 0.9726, 1, 0.9883, 0.9844, 0.9883, 1 )"
};
function ko(t) {
  return t && ole[t] || "linear";
}
function ule(t) {
  const e = t * Math.PI / 180, n = Math.round(Math.cos(e) * 10) / 10, r = Math.round(Math.sin(e) * 10) / 10, i = Math.sign(n), s = Math.sign(r), a = "var(--motion-left, 0px)", o = "var(--motion-top, 0px)", u = i ? i === -1 ? `(-1 * ${a} - 100%)` : `(100vw - ${a})` : 0, l = s ? s === -1 ? `(-1 * ${o} - 100%)` : `(100vh - ${o})` : 0;
  let h;
  const f = `calc(${u} / ${n})`, m = `calc(${l} / ${r})`;
  return n ? r ? h = `min(${m}, ${f})` : h = f : h = m, {
    // distance: Math.abs(hypotenuse),
    x: `calc(${h} * ${n})`,
    y: `calc(${h} * ${r})`
  };
}
function lle(t, e) {
  let n = t.offsetLeft, r = t.offsetTop, i = t.offsetParent;
  for (; i && !(e && i === e); )
    n += i.offsetLeft, r += i.offsetTop, i = i.offsetParent;
  return {
    left: n,
    top: r
  };
}
const cle = (t, e, n) => {
  const r = t === "top" || t === "left", i = r ? e : 0, s = r ? 0 : e, a = r ? -1 : 1, o = t === "top" || t === "bottom", u = [], l = [];
  for (let h = i; h !== s; h += a) {
    const f = 100 * ((h + a) / e), m = 100 * (h / e) | 0;
    let g;
    if (n) {
      const A = r ? 1 + (e - h) / e : 1 + h / e;
      g = r ? 100 - (100 - f) * A : f * A;
    } else
      g = f;
    g |= 0, o ? (u.push(`0% ${m}%, 100% ${m}%, 100% ${m}%, 0% ${m}%`), l.push(`0% ${m}%, 100% ${m}%, 100% ${g}%, 0% ${g}%`)) : (u.push(`${m}% 0%, ${m}% 100%, ${m}% 100%, ${m}% 0%`), l.push(`${m}% 0%, ${m}% 100%, ${g}% 100%, ${g}% 0%`));
  }
  return {
    start: u,
    end: l
  };
};
function ET(t, e, n, r) {
  const {
    start: i,
    end: s
  } = cle(t, e, n);
  return r && (i.reverse(), s.reverse()), {
    clipStart: `polygon(${i.join(", ")})`,
    clipEnd: `polygon(${s.join(", ")})`
  };
}
function Fo(t, e) {
  return e === void 0 && (e = 2), parseFloat(t.toFixed(e));
}
function W(t, e, n, r) {
  return n === void 0 && (n = !1), r === void 0 && (r = void 0), n ? t[e] : `var(${e}${r !== void 0 ? `, ${r}` : ""})`;
}
function br(t, e, n) {
  n === void 0 && (n = !1);
  const r = t || 1, s = Fo(r / (r + (e || 0)));
  return n ? s.toString().replace(/\./g, "") : s;
}
class hle {
  constructor(e, n, r, i) {
    pr(this, "_animation", void 0), pr(this, "customEffect", void 0), pr(this, "progress", void 0), pr(this, "_tickCbId", void 0), pr(this, "_finishHandler", void 0);
    const s = new KeyframeEffect(n, [], {
      ...r,
      composite: "add"
    }), {
      timeline: a
    } = i;
    this._animation = new Animation(s, a), this._tickCbId = null, this.progress = null, this.customEffect = (o) => e(s.target, o), this._finishHandler = (o) => {
      var u;
      (u = this.effect.target) != null && u.getAnimations().find((l) => l === this._animation) || this.cancel();
    }, this.addEventListener("finish", this._finishHandler), this.addEventListener("remove", this._finishHandler);
  }
  // private tick method for customEffect loop implementation
  _tick() {
    try {
      var e;
      const r = ((e = this.effect) == null ? void 0 : e.getComputedTiming().progress) ?? null;
      if (r !== this.progress) {
        var n;
        (n = this.customEffect) == null || n.call(this, r), this.progress = r;
      }
      this._tickCbId = requestAnimationFrame(() => {
        this._tick();
      });
    } catch (r) {
      this._tickCbId = null, console.error(`failed to run customEffect! effectId: ${this.id}, error: ${r instanceof Error ? r.message : r}`);
    }
  }
  // Animation timing properties
  get currentTime() {
    return this._animation.currentTime;
  }
  set currentTime(e) {
    this._animation.currentTime = e;
  }
  get startTime() {
    return this._animation.startTime;
  }
  set startTime(e) {
    this._animation.startTime = e;
  }
  get playbackRate() {
    return this._animation.playbackRate;
  }
  set playbackRate(e) {
    this._animation.playbackRate = e;
  }
  // Animation basic properties
  get id() {
    return this._animation.id;
  }
  set id(e) {
    this._animation.id = e;
  }
  get effect() {
    return this._animation.effect;
  }
  set effect(e) {
    this._animation.effect = e;
  }
  get timeline() {
    return this._animation.timeline;
  }
  set timeline(e) {
    this._animation.timeline = e;
  }
  // Animation readonly state properties
  get finished() {
    return this._animation.finished;
  }
  get pending() {
    return this._animation.pending;
  }
  get playState() {
    return this._animation.playState;
  }
  get ready() {
    return this._animation.ready;
  }
  get replaceState() {
    return this._animation.replaceState;
  }
  // Animation event handlers
  get oncancel() {
    return this._animation.oncancel;
  }
  set oncancel(e) {
    this._animation.oncancel = e;
  }
  get onfinish() {
    return this._animation.onfinish;
  }
  set onfinish(e) {
    this._animation.onfinish = e;
  }
  get onremove() {
    return this._animation.onremove;
  }
  set onremove(e) {
    this._animation.onremove = e;
  }
  // CustomAnimation overridden methods
  play() {
    this._animation.play(), cancelAnimationFrame(this._tickCbId), this._tickCbId = requestAnimationFrame(() => this._tick());
  }
  pause() {
    this._animation.pause(), cancelAnimationFrame(this._tickCbId), this._tickCbId = null;
  }
  cancel() {
    this.removeEventListener("finish", this._finishHandler), this.removeEventListener("remove", this._finishHandler), this._animation.cancel(), this.customEffect(null), cancelAnimationFrame(this._tickCbId), this._tickCbId = null;
  }
  commitStyles() {
    console.warn("CustomEffect animations do not support commitStyles method as they have no style to commit");
  }
  // Animation methods without override
  finish() {
    this._animation.finish();
  }
  persist() {
    this._animation.persist();
  }
  reverse() {
    this._animation.reverse();
  }
  updatePlaybackRate(e) {
    this._animation.updatePlaybackRate(e);
  }
  // Animation events API
  addEventListener(e, n, r) {
    this._animation.addEventListener(e, n, r);
  }
  removeEventListener(e, n, r) {
    this._animation.removeEventListener(e, n, r);
  }
  dispatchEvent(e) {
    return this._animation.dispatchEvent(e);
  }
}
const wN = 68;
function R4(t) {
  return ["motion-arcScroll"];
}
function dle(t, e) {
  return P4(t, !0);
}
function P4(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "horizontal",
    range: r = "in"
  } = t.namedEffect, i = r === "out" ? "forwards" : r === "in" ? "backwards" : t.fill, s = `rotate${n === "vertical" ? "X" : "Y"}`, a = r === "out" ? 0 : -wN, o = r === "in" ? 0 : wN, u = "linear", [l] = R4(), h = {
    "--motion-arc-from": `${s}(${a}deg)`,
    "--motion-arc-to": `${s}(${o}deg)`
  };
  return [{
    ...t,
    name: l,
    fill: i,
    easing: u,
    custom: h,
    keyframes: [{
      transform: `perspective(500px) translateZ(-300px) ${W(h, "--motion-arc-from", e)} translateZ(300px) rotate(${W({}, "--comp-rotate-z", !1, "0deg")})`
    }, {
      transform: `perspective(500px) translateZ(-300px) ${W(h, "--motion-arc-to", e)} translateZ(300px) rotate(${W({}, "--comp-rotate-z", !1, "0deg")})`
    }]
  }];
}
const fle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: R4,
  style: P4,
  web: dle
}, Symbol.toStringTag, { value: "Module" })), FN = {
  soft: 6,
  medium: 25,
  hard: 50
};
function L4(t) {
  return ["motion-blurScroll"];
}
function mle(t, e) {
  return M4(t, !0);
}
function M4(t, e) {
  e === void 0 && (e = !1);
  const {
    blur: n = 6,
    power: r,
    range: i = "in"
  } = t.namedEffect, s = r && FN[r] ? FN[r] : n, a = i === "out" ? 0 : s, o = i === "out" ? s : 0, u = "linear", l = i === "out" ? "forwards" : i === "in" ? "backwards" : t.fill, [h] = L4(), f = {
    "--motion-blur-from": `${a}px`,
    "--motion-blur-to": `${o}px`
  };
  return [{
    ...t,
    name: h,
    fill: l,
    easing: u,
    composite: "add",
    custom: f,
    keyframes: [{
      filter: `blur(${W(f, "--motion-blur-from", e)})`
    }, {
      filter: `blur(${W(f, "--motion-blur-to", e)})`
    }]
  }];
}
const gle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: L4,
  style: M4,
  web: mle
}, Symbol.toStringTag, { value: "Module" }));
function O4(t) {
  return ["motion-fadeScroll"];
}
function ple(t, e) {
  return B4(t, !0);
}
function B4(t, e) {
  e === void 0 && (e = !1);
  const {
    opacity: n = 0,
    range: r = "in"
  } = t.namedEffect, i = r === "out", s = i ? W({}, "--comp-opacity", !1, "1") : n, a = i ? n : W({}, "--comp-opacity", !1, "1"), o = "linear", u = r === "out" ? "forwards" : r === "in" ? "backwards" : t.fill, [l] = O4(), h = {
    "--motion-fade-from": s,
    "--motion-fade-to": a
  };
  return [{
    ...t,
    name: l,
    fill: u,
    easing: o,
    custom: h,
    keyframes: [{
      opacity: W(h, "--motion-fade-from", e)
    }, {
      opacity: W(h, "--motion-fade-to", e)
    }]
  }];
}
const ble = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: O4,
  style: B4,
  web: ple
}, Symbol.toStringTag, { value: "Module" })), TN = {
  soft: 60,
  medium: 120,
  hard: 420
};
function $4(t) {
  return ["motion-flipScroll"];
}
function yle(t, e) {
  return H4(t, !0);
}
function H4(t, e) {
  e === void 0 && (e = !1);
  const {
    rotate: n = 240,
    direction: r = "horizontal",
    power: i,
    range: s = "continuous"
  } = t.namedEffect, a = `rotate${r === "vertical" ? "X" : "Y"}`, o = i && TN[i] ? TN[i] : n, u = s === "out" ? 0 : -o, l = s === "in" ? 0 : o, h = "linear", f = s === "out" ? "forwards" : s === "in" ? "backwards" : t.fill, [m] = $4(), g = {
    "--motion-flip-from": `${a}(${u}deg)`,
    "--motion-flip-to": `${a}(${l}deg)`
  };
  return [{
    ...t,
    name: m,
    fill: f,
    easing: h,
    custom: g,
    keyframes: [{
      transform: `perspective(800px) ${W(g, "--motion-flip-from", e)} rotate(${W({}, "--comp-rotate-z", !1, "0deg")})`
    }, {
      transform: `perspective(800px) ${W(g, "--motion-flip-to", e)} rotate(${W({}, "--comp-rotate-z", !1, "0deg")})`
    }]
  }];
}
const Ale = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: $4,
  style: H4,
  web: yle
}, Symbol.toStringTag, { value: "Module" })), Ele = 40, Zh = {
  soft: {
    scaleFrom: 0.8,
    scaleTo: 1.2,
    travelY: 0
  },
  medium: {
    scaleFrom: 0.3,
    scaleTo: 1.7,
    travelY: 0.75
  },
  hard: {
    scaleFrom: 0,
    scaleTo: 4,
    travelY: 1
  }
}, Sle = {
  top: [0, -50],
  "top-right": [50, -50],
  right: [50, 0],
  "bottom-right": [50, 50],
  bottom: [0, 50],
  "bottom-left": [-50, 50],
  left: [-50, 0],
  "top-left": [-50, -50],
  center: [0, 0]
};
function U4(t) {
  return ["motion-growScroll"];
}
function wle(t, e) {
  return G4(t, !0);
}
function G4(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    range: r = "in",
    scale: i = r === "in" ? Zh.hard.scaleFrom : Zh.hard.scaleTo,
    direction: s = "center",
    speed: a = 0
  } = t.namedEffect, o = "linear", u = r === "out" ? "forwards" : r === "in" ? "backwards" : t.fill, {
    scaleFrom: l,
    scaleTo: h,
    travelY: f
  } = n && Zh[n] ? Zh[n] : {
    scaleFrom: i,
    scaleTo: i,
    travelY: a
  }, m = f * Ele, g = {
    scale: r === "out" ? 1 : l,
    travel: r === "out" ? 0 : -m
  }, A = {
    scale: r === "in" ? 1 : h,
    travel: r === "in" ? 0 : m
  }, E = Math.abs(n && Zh[n] ? Zh[n].travelY : m), w = r === "out" ? "0px" : `${-E}vh`, x = r === "in" ? "0px" : `${E}vh`, [N, B] = Sle[s] || [0, 0], [P] = U4(), C = {
    "--motion-travel-from": `${g.travel}vh`,
    "--motion-travel-to": `${A.travel}vh`,
    "--motion-grow-from": g.scale,
    "--motion-grow-to": A.scale,
    "--motion-trans-x": `${N}%`,
    "--motion-trans-y": `${B}%`
  };
  return [{
    ...t,
    name: P,
    fill: u,
    easing: o,
    startOffsetAdd: w,
    endOffsetAdd: x,
    custom: C,
    keyframes: [{
      transform: `translateY(${W(C, "--motion-travel-from", e)}) translate(${W(C, "--motion-trans-x", e)}, ${W(C, "--motion-trans-y", e)}) scale(${W(C, "--motion-grow-from", e)}) translate(calc(-1 * ${W(C, "--motion-trans-x", e)}), calc(-1 * ${W(C, "--motion-trans-y", e)})) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }, {
      transform: `translateY(${W(C, "--motion-travel-to", e)}) translate(${W(C, "--motion-trans-x", e)}, ${W(C, "--motion-trans-y", e)}) scale(${W(C, "--motion-grow-to", e)}) translate(calc(-1 * ${W(C, "--motion-trans-x", e)}), calc(-1 * ${W(C, "--motion-trans-y", e)})) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }]
  }];
}
const Fle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: U4,
  style: G4,
  web: wle
}, Symbol.toStringTag, { value: "Module" })), vN = {
  soft: {
    value: 150,
    type: "px"
  },
  medium: {
    value: 400,
    type: "px"
  },
  hard: {
    value: 800,
    type: "px"
  }
};
function W4(t) {
  return ["motion-moveScroll"];
}
function Tle(t, e, n) {
  return V4(t, n, !0);
}
function V4(t, e, n) {
  n === void 0 && (n = !1);
  const {
    power: r,
    angle: i = 210,
    range: s = "in"
  } = t.namedEffect, a = "linear", o = s === "out" ? "forwards" : s === "in" ? "backwards" : t.fill, {
    distance: u = {
      value: 400,
      type: "px"
    }
  } = t.namedEffect, l = {
    value: u.value || 0,
    type: u.type || "px"
  }, h = r && vN[r] ? vN[r] : l;
  let [f, m] = sle(i - 90, h.value);
  const g = Us(h.type);
  let A = "", E = "";
  e != null && e.ignoreScrollMoveOffsets || (m < 0 && s !== "out" && (A = `${m}${g}`, s !== "in" && (E = `${Math.abs(m)}${g}`)), m > 0 && s === "out" && (E = `${Math.abs(m)}${g}`)), [f, m] = [f, m].map(Math.round);
  const w = {
    x: s === "out" ? 0 : f,
    y: s === "out" ? 0 : m
  }, x = {
    x: s === "in" ? 0 : s === "out" ? f : -f,
    y: s === "in" ? 0 : s === "out" ? m : -m
  }, [N] = W4(), B = {
    "--motion-move-from-x": `${w.x}${g}`,
    "--motion-move-from-y": `${w.y}${g}`,
    "--motion-move-to-x": `${x.x}${g}`,
    "--motion-move-to-y": `${x.y}${g}`
  };
  return [{
    ...t,
    name: N,
    fill: o,
    easing: a,
    startOffsetAdd: A,
    endOffsetAdd: E,
    custom: B,
    keyframes: [{
      transform: `translate(${W(B, "--motion-move-from-x", n)}, ${W(B, "--motion-move-from-y", n)}) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }, {
      transform: `translate(${W(B, "--motion-move-to-x", n)}, ${W(B, "--motion-move-to-y", n)}) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }]
  }];
}
const vle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: W4,
  style: V4,
  web: Tle
}, Symbol.toStringTag, { value: "Module" }));
function K4(t) {
  return ["motion-panScroll"];
}
function z4(t, e) {
  if (t.namedEffect && t.namedEffect.startFromOffScreen && e) {
    let n = 0;
    e.measure((r) => {
      r && (n = r.getBoundingClientRect().left);
    }), e.mutate((r) => {
      r?.style.setProperty("--motion-left", `${n}px`);
    });
  }
}
function xle(t, e) {
  return z4(t, e), j4(t, !0);
}
function j4(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "left",
    startFromOffScreen: r = !0,
    range: i = "in"
  } = t.namedEffect;
  let {
    distance: s
  } = t.namedEffect;
  (!s || !s.value || !s.type) && (s = {
    value: 400,
    type: "px"
  });
  const a = s.value * (n === "left" ? 1 : -1);
  let o = `${-a}${Us(s.type)}`, u = `${a}${Us(s.type)}`;
  if (r) {
    const E = `calc(${W({}, "--motion-left", !1, "calc(100vw - 100%)")} * -1 - 100%)`, w = `calc(100vw - ${W({}, "--motion-left", !1, "0px")})`;
    [o, u] = n === "left" ? [E, w] : [w, E];
  }
  const l = i === "out" ? 0 : o, h = i === "in" ? 0 : i === "out" ? o : u, f = "linear", m = i === "out" ? "forwards" : i === "in" ? "backwards" : t.fill, [g] = K4(), A = {
    "--motion-pan-from": l,
    "--motion-pan-to": h
  };
  return [{
    ...t,
    name: g,
    fill: m,
    easing: f,
    custom: A,
    keyframes: [{
      transform: `translateX(${W(A, "--motion-pan-from", e)}) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }, {
      transform: `translateX(${W(A, "--motion-pan-to", e)}) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }]
  }];
}
const Cle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: K4,
  prepare: z4,
  style: j4,
  web: xle
}, Symbol.toStringTag, { value: "Module" })), kle = 0.5;
function Y4(t) {
  return ["motion-parallaxScroll"];
}
function _le(t, e) {
  return q4(t, !0);
}
function q4(t, e) {
  e === void 0 && (e = !1);
  const {
    speed: n = kle
  } = t.namedEffect, r = "linear", i = `${-50 * n}vh`, s = `${50 * n}vh`, [a] = Y4(), o = {
    "--motion-parallax-to": s
  };
  return [{
    ...t,
    name: a,
    fill: "both",
    easing: r,
    startOffsetAdd: i,
    endOffsetAdd: s,
    custom: o,
    keyframes: [{
      transform: `translateY(calc(-1 * ${W(o, "--motion-parallax-to", e)})) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }, {
      transform: `translateY(${W(o, "--motion-parallax-to", e)}) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }]
  }];
}
const Nle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: Y4,
  style: q4,
  web: _le
}, Symbol.toStringTag, { value: "Module" }));
function J4(t) {
  const {
    range: e = "in"
  } = t.namedEffect;
  return [`motion-revealScroll${e === "continuous" ? "-continuous" : ""}`];
}
function Q4(t, e) {
  if (e) {
    const {
      direction: n = "bottom",
      range: r = "in"
    } = t.namedEffect;
    I4(e, n, r);
  }
}
function Dle(t, e) {
  return Q4(t, e), X4(t);
}
function X4(t) {
  const {
    direction: e = "bottom",
    range: n = "in"
  } = t.namedEffect, r = "linear", i = n === "out" ? "forwards" : n === "in" ? "backwards" : t.fill, [s] = J4(t), a = {
    "--motion-clip-from": yC(e, n),
    "--motion-clip-to": AC(e, n)
  }, o = [{
    clipPath: W({}, "--motion-clip-from", !1, a["--motion-clip-from"])
  }, {
    clipPath: W({}, "--motion-clip-to", !1, a["--motion-clip-to"])
  }];
  return n === "continuous" && o.splice(1, 0, {
    clipPath: mA
  }), [{
    ...t,
    name: s,
    fill: i,
    easing: r,
    custom: a,
    keyframes: o
  }];
}
const Ile = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: J4,
  prepare: Q4,
  style: X4,
  web: Dle
}, Symbol.toStringTag, { value: "Module" })), E0 = {
  diamond: {
    start: {
      soft: "polygon(50% 20%, 80% 50%, 50% 80%, 20% 50%)",
      medium: "polygon(50% 40%, 60% 50%, 50% 60%, 40% 50%)",
      hard: "polygon(50% 50%, 50% 50%, 50% 50%, 50% 50%)"
    },
    end: "polygon(50% -50%, 150% 50%, 50% 150%, -50% 50%)"
  },
  window: {
    start: {
      soft: "inset(20% round 50% 50% 0% 0%)",
      medium: "inset(35% round 50% 50% 0% 0%)",
      hard: "inset(50% round 50% 50% 0% 0%)"
    },
    end: "inset(-20% round 50% 50% 0% 0%)"
  },
  rectangle: {
    start: {
      soft: "inset(20%)",
      medium: "inset(50%)",
      hard: "inset(80%)"
    },
    end: "inset(0%)"
  },
  circle: {
    start: {
      soft: "circle(40%)",
      medium: "circle(25%)",
      hard: "circle(0%)"
    },
    end: "circle(75%)"
  },
  ellipse: {
    start: {
      soft: "ellipse(50% 50%)",
      medium: "ellipse(30% 30%)",
      hard: "ellipse(0% 0%)"
    },
    end: "ellipse(75% 75%)"
  }
}, Rle = {
  diamond: (t) => {
    const e = t / 2, n = 100 - e;
    return [`polygon(50% ${e}%, ${n}% 50%, 50% ${n}%, ${e}% 50%)`, "polygon(50% -50%, 150% 50%, 50% 150%, -50% 50%)"];
  },
  window: (t) => [`inset(${t / 2}% round 50% 50% 0% 0%)`, "inset(-20% round 50% 50% 0% 0%)"],
  rectangle: (t) => [`inset(${t}%)`, "inset(0%)"],
  circle: (t) => [`circle(${100 - t}%)`, "circle(75%)"],
  ellipse: (t) => {
    const e = 50 - t / 2;
    return [`ellipse(${e}% ${e}%)`, "ellipse(75% 75%)"];
  }
};
function Z4(t) {
  const {
    range: e = "in"
  } = t.namedEffect;
  return [`motion-shapeScroll${e === "continuous" ? "-continuous" : ""}`];
}
function Ple(t, e) {
  return e6(t, !0);
}
function e6(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    intensity: r = 0.5,
    range: i = "in"
  } = t.namedEffect;
  let {
    shape: s = "circle"
  } = t.namedEffect;
  s in E0 || (s = "circle");
  const a = i === "out" ? "forwards" : i === "in" ? "backwards" : t.fill, [o, u] = n && E0[s].start[n] ? [E0[s].start[n], E0[s].end] : Rle[s](r * 100), [l] = Z4(t), h = {
    "--motion-clip-from": i === "out" ? u : o,
    "--motion-clip-to": i === "out" ? o : u
  }, f = lr("circInOut"), m = [{
    clipPath: W(h, "--motion-clip-from", e),
    easing: f
  }, {
    clipPath: W(h, "--motion-clip-to", e)
  }];
  return i === "continuous" && (m[1].easing = f, m.push({
    clipPath: W(h, "--motion-clip-from", e)
  })), [{
    ...t,
    name: l,
    fill: a,
    easing: "linear",
    custom: h,
    keyframes: m
  }];
}
const Lle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: Z4,
  style: e6,
  web: Ple
}, Symbol.toStringTag, { value: "Module" }));
function t6(t) {
  const {
    range: e = "in"
  } = t.namedEffect;
  return [`motion-shuttersScroll-${e === "continuous" ? "-continuous" : ""}`];
}
function Mle(t, e) {
  return n6(t, !0);
}
function n6(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "right",
    shutters: r = 12,
    staggered: i = !0,
    range: s = "in"
  } = t.namedEffect, a = s === "out" ? "forwards" : s === "in" ? "backwards" : t.fill, o = lr(s === "in" ? "sineIn" : "sineOut"), u = gA(np, n), {
    clipStart: l,
    clipEnd: h
  } = ET(s === "out" ? u : n, r, i), f = {
    "--motion-shutters-clip-start": s === "out" ? h : l,
    "--motion-shutters-clip-end": s === "out" ? l : h
  }, [m] = t6(t), g = [{
    clipPath: W(f, "--motion-shutters-clip-start", e),
    easing: o
  }, {
    clipPath: W(f, "--motion-shutters-clip-end", e)
  }];
  if (s === "continuous") {
    g[1].easing = o, g[1].offset = i ? 0.45 : 0.4;
    const {
      clipStart: A,
      clipEnd: E
    } = ET(u, r, i, !0);
    Object.assign(f, {
      "--motion-shutters-clip-opp-end": E,
      "--motion-shutters-clip-opp-start": A
    });
    const w = i ? 0.55 : 0.6;
    g.push({
      clipPath: W(f, "--motion-shutters-clip-end", e),
      offset: w,
      easing: o
    }, {
      clipPath: W(f, "--motion-shutters-clip-opp-end", e),
      offset: w,
      easing: o
    }, {
      clipPath: W(f, "--motion-shutters-clip-opp-start", e)
    });
  }
  return [{
    ...t,
    name: m,
    fill: a,
    easing: "linear",
    custom: f,
    keyframes: g
  }];
}
const Ole = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: t6,
  style: n6,
  web: Mle
}, Symbol.toStringTag, { value: "Module" })), Ble = 40, S0 = {
  soft: {
    scaleFrom: 1.2,
    scaleTo: 0.8,
    travelY: 0
  },
  medium: {
    scaleFrom: 1.7,
    scaleTo: 0.3,
    travelY: 0.5
  },
  hard: {
    scaleFrom: 3.5,
    scaleTo: 0,
    travelY: 1
  }
}, $le = {
  top: [0, -50],
  "top-right": [50, -50],
  right: [50, 0],
  "bottom-right": [50, 50],
  bottom: [0, 50],
  "bottom-left": [-50, 50],
  left: [-50, 0],
  "top-left": [-50, -50],
  center: [0, 0]
};
function r6(t) {
  return ["motion-shrinkScroll"];
}
function Hle(t, e) {
  return i6(t, !0);
}
function i6(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    range: r = "in",
    scale: i = r === "in" ? 1.2 : 0.8,
    direction: s = "center",
    speed: a = 0
  } = t.namedEffect, o = "linear", u = r === "out" ? "forwards" : r === "in" ? "backwards" : t.fill, {
    scaleFrom: l,
    scaleTo: h,
    travelY: f
  } = n && S0[n] ? S0[n] : {
    scaleFrom: i,
    scaleTo: i,
    travelY: a
  }, m = f * Ble, g = {
    scale: r === "out" ? 1 : l,
    travel: r === "out" ? 0 : -m
  }, A = {
    scale: r === "in" ? 1 : h,
    travel: r === "in" ? 0 : m
  }, E = Math.abs(n && S0[n] ? S0[n].travelY : m), w = r === "out" ? "0px" : `${-E}vh`, x = r === "in" ? "0px" : `${E}vh`, [N, B] = $le[s] || [0, 0], [P] = r6(), C = {
    "--motion-travel-from": `${g.travel}vh`,
    "--motion-travel-to": `${A.travel}vh`,
    "--motion-shrink-from": g.scale,
    "--motion-shrink-to": A.scale,
    "--motion-trans-x": `${N}%`,
    "--motion-trans-y": `${B}%`
  };
  return [{
    ...t,
    name: P,
    fill: u,
    easing: o,
    custom: C,
    startOffsetAdd: w,
    endOffsetAdd: x,
    keyframes: [{
      transform: `translateY(${W(C, "--motion-travel-from", e)}) translate(${W(C, "--motion-trans-x", e)}, ${W(C, "--motion-trans-y", e)}) scale(${W(C, "--motion-shrink-from", e)}) translate(calc(-1 * ${W(C, "--motion-trans-x", e)}), calc(-1 * ${W(C, "--motion-trans-y", e)})) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }, {
      transform: `translateY(${W(C, "--motion-travel-to", e)}) translate(${W(C, "--motion-trans-x", e)}, ${W(C, "--motion-trans-y", e)}) scale(${W(C, "--motion-shrink-to", e)}) translate(calc(-1 * ${W(C, "--motion-trans-x", e)}), calc(-1 * ${W(C, "--motion-trans-y", e)})) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }]
  }];
}
const Ule = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: r6,
  style: i6,
  web: Hle
}, Symbol.toStringTag, { value: "Module" })), xN = {
  soft: 10,
  medium: 17,
  hard: 24
};
function s6(t) {
  return ["motion-skewPanScroll"];
}
function a6(t, e) {
  if (e) {
    let n = 0;
    e.measure((r) => {
      r && (n = r.getBoundingClientRect().left);
    }), e.mutate((r) => {
      r?.style.setProperty("--motion-left", `${n}px`);
    });
  }
}
function Gle(t, e) {
  return a6(t, e), o6(t, !0);
}
function o6(t, e) {
  e === void 0 && (e = !1);
  const {
    skew: n = 10,
    direction: r = "right",
    power: i,
    range: s = "in"
  } = t.namedEffect, a = "linear", o = s === "out" ? "forwards" : s === "in" ? "backwards" : t.fill, u = (i && xN[i] ? xN[i] : n) * (r === "left" ? 1 : -1), l = `calc(${W({}, "--motion-left", !1, "calc(100vw - 100%)")} * -1 - 100%)`, h = `calc(100vw - ${W({}, "--motion-left", !1, "0px")})`, [f, m] = r === "left" ? [l, h] : [h, l], g = {
    skew: s === "out" ? 0 : u,
    translate: s === "out" ? 0 : f
  }, A = {
    skew: s === "in" ? 0 : -u,
    translate: s === "in" ? 0 : s === "out" ? f : m
  }, [E] = s6(), w = {
    "--motion-skewpan-start-x": g.translate,
    "--motion-skewpan-end-x": A.translate,
    "--motion-skewpan-from-skew": `${g.skew}deg`,
    "--motion-skewpan-to-skew": `${A.skew}deg`
  };
  return [{
    ...t,
    name: E,
    fill: o,
    easing: a,
    custom: w,
    keyframes: [{
      transform: `translateX(${W(w, "--motion-skewpan-start-x", e)}) skewX(${W(w, "--motion-skewpan-from-skew", e)}) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }, {
      transform: `translateX(${W(w, "--motion-skewpan-end-x", e)}) skewX(${W(w, "--motion-skewpan-to-skew", e)}) rotate(${W({}, "--comp-rotate-z", !1, "0")})`
    }]
  }];
}
const Wle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: s6,
  prepare: a6,
  style: o6,
  web: Gle
}, Symbol.toStringTag, { value: "Module" })), CN = {
  bottom: {
    x: "0",
    y: "100%"
  },
  left: {
    x: "-100%",
    y: "0"
  },
  top: {
    x: "0",
    y: "-100%"
  },
  right: {
    x: "100%",
    y: "0"
  }
};
function u6(t) {
  const {
    range: e = "in"
  } = t.namedEffect;
  return [`motion-slideScroll${e === "continuous" ? "-continuous" : ""}`];
}
function l6(t, e) {
  if (e) {
    const {
      direction: n = "bottom",
      range: r = "in"
    } = t.namedEffect;
    I4(e, n, r);
  }
}
function Vle(t, e) {
  return l6(t, e), c6(t, !0);
}
function c6(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "bottom",
    range: r = "in"
  } = t.namedEffect, i = "linear", s = r === "out" ? "forwards" : r === "in" ? "backwards" : t.fill, a = gA(np, n), o = r === "out" ? {
    x: "0",
    y: "0"
  } : CN[n], u = r === "in" ? {
    x: "0",
    y: "0"
  } : CN[r === "out" ? n : a], l = {
    "--motion-clip-from": yC(n, r),
    "--motion-clip-to": AC(n, r),
    "--motion-translate-from-x": o.x,
    "--motion-translate-from-y": o.y,
    "--motion-translate-to-x": u.x,
    "--motion-translate-to-y": u.y
  }, h = [{
    clipPath: W({}, "--motion-clip-from", !1, l["--motion-clip-from"]),
    transform: `rotate(${W({}, "--comp-rotate-z", !1, "0")}) translate(${W(l, "--motion-translate-from-x", e)}, ${W(l, "--motion-translate-from-y", e)})`
  }, {
    clipPath: W({}, "--motion-clip-to", !1, l["--motion-clip-to"]),
    transform: `rotate(${W({}, "--comp-rotate-z", !1, "0")}) translate(${W(l, "--motion-translate-to-x", e)}, ${W(l, "--motion-translate-to-y", e)})`
  }];
  r === "continuous" && h.splice(1, 0, {
    clipPath: mA,
    transform: `rotate(${W({}, "--comp-rotate-z", !1, "0")}) translate(0, 0)`
  });
  const [f] = u6(t);
  return [{
    ...t,
    name: f,
    fill: s,
    easing: i,
    keyframes: h
  }];
}
const Kle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: u6,
  prepare: l6,
  style: c6,
  web: Vle
}, Symbol.toStringTag, { value: "Module" })), zle = 40, kN = {
  soft: {
    rotationZ: 45,
    travelY: 0
  },
  medium: {
    rotationZ: 100,
    travelY: 0.5
  },
  hard: {
    rotationZ: 200,
    travelY: 1
  }
};
function h6(t) {
  return ["motion-spin3dScroll"];
}
function jle(t, e) {
  return d6(t, !0);
}
function d6(t, e) {
  e === void 0 && (e = !1);
  const {
    rotate: n = -100,
    speed: r = 0,
    power: i,
    range: s = "in"
  } = t.namedEffect, a = "linear", o = s === "out" ? "forwards" : s === "in" ? "backwards" : t.fill, {
    rotationZ: u,
    travelY: l
  } = i && kN[i] ? kN[i] : {
    rotationZ: n,
    travelY: r
  }, h = l * zle, f = {
    rotationX: s === "out" ? 0 : -2 * u,
    rotationY: s === "out" ? 0 : -u,
    rotationZ: s === "out" ? 0 : -u,
    travel: s === "out" ? 0 : -h
  }, m = {
    rotationX: u * (s === "in" ? 0 : s === "out" ? 3 : 1.8),
    rotationY: u * (s === "in" ? 0 : s === "out" ? 2 : 1),
    rotationZ: u * (s === "in" ? 0 : s === "out" ? 1 : 2),
    travel: s === "in" ? 0 : h
  }, g = Math.abs(h), A = s === "out" ? "0px" : `${-g}vh`, E = s === "in" ? "0px" : `${g}vh`, [w] = h6(), x = {
    "--motion-travel-from": `${f.travel}vh`,
    "--motion-travel-to": `${m.travel}vh`,
    "--motion-rot-x-from": `${f.rotationX}deg`,
    "--motion-rot-x-to": `${m.rotationX}deg`,
    "--motion-rot-y-from": `${f.rotationY}deg`,
    "--motion-rot-y-to": `${m.rotationY}deg`,
    "--motion-rot-z-from": `${f.rotationZ}deg`,
    "--motion-rot-z-to": `${m.rotationZ}deg`
  };
  return [{
    ...t,
    name: w,
    fill: o,
    easing: a,
    custom: x,
    startOffsetAdd: A,
    endOffsetAdd: E,
    keyframes: [{
      transform: `perspective(1000px) translateY(${W(x, "--motion-travel-from", e)}) rotateZ(calc(${W({}, "--comp-rotate-z", !1, "0deg")} + ${W(x, "--motion-rot-z-from", e)})) rotateY(${W(x, "--motion-rot-y-from", e)}) rotateX(${W(x, "--motion-rot-x-from", e)})`
    }, {
      transform: `perspective(1000px) translateY(${W(x, "--motion-travel-to", e)}) rotateZ(calc(${W({}, "--comp-rotate-z", !1, "0deg")} + ${W(x, "--motion-rot-z-to", e)})) rotateY(${W(x, "--motion-rot-y-to", e)}) rotateX(${W(x, "--motion-rot-x-to", e)})`
    }]
  }];
}
const Yle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: h6,
  style: d6,
  web: jle
}, Symbol.toStringTag, { value: "Module" })), _N = {
  soft: 1,
  medium: 0.7,
  hard: 0.4
};
function f6(t) {
  return ["motion-spinScroll"];
}
function qle(t, e) {
  return m6(t, !0);
}
function m6(t, e) {
  e === void 0 && (e = !1);
  const {
    spins: n = 0.15,
    scale: r = 1,
    direction: i = "clockwise",
    power: s,
    range: a = "in"
  } = t.namedEffect, o = "linear", u = a === "out" ? "forwards" : a === "in" ? "backwards" : t.fill, l = 360 * n, h = s && _N[s] ? _N[s] : r, f = a === "in", m = f ? -l : a === "out" ? 0 : -l / 2, g = f ? 0 : a === "out" ? l : l / 2, A = i === "clockwise" ? 1 : -1, [E] = f6(), w = {
    "--motion-spin-from": `${A * m}deg`,
    "--motion-spin-to": `${A * g}deg`,
    "--motion-spin-scale-from": f ? h : 1,
    "--motion-spin-scale-to": f ? 1 : h
  };
  return [{
    ...t,
    name: E,
    fill: u,
    easing: o,
    custom: w,
    keyframes: [{
      transform: `scale(${W(w, "--motion-spin-scale-from", e)}) rotate(calc(${W({}, "--comp-rotate-z", !1, "0deg")} + ${W(w, "--motion-spin-from", e)}))`
    }, {
      transform: `scale(${W(w, "--motion-spin-scale-to", e)}) rotate(calc(${W({}, "--comp-rotate-z", !1, "0deg")} + ${W(w, "--motion-spin-to", e)}))`
    }]
  }];
}
const Jle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: f6,
  style: m6,
  web: qle
}, Symbol.toStringTag, { value: "Module" })), NN = {
  soft: {
    scaleY: 1.2,
    scaleX: 0.8
  },
  medium: {
    scaleY: 1.5,
    scaleX: 0.6
  },
  hard: {
    scaleY: 2,
    scaleX: 0.4
  }
}, DN = {
  in: [{
    opacity: 0,
    offset: 0
  }, {
    opacity: 1,
    offset: 0.65
  }],
  out: [{
    opacity: 1,
    offset: 0.35
  }, {
    opacity: 0,
    offset: 1
  }],
  continuous: [{
    opacity: 0,
    offset: 0
  }, {
    opacity: 1,
    offset: 0.325
  }, {
    opacity: 1,
    offset: 0.7
  }, {
    opacity: 0,
    offset: 1
  }]
};
function g6(t) {
  const {
    range: e = "out"
  } = t.namedEffect;
  return [`motion-stretchScrollScale${e === "continuous" ? "-continuous" : ""}`, `motion-stretchScrollOpacity-${e}`];
}
function Qle(t, e) {
  return p6(t, !0);
}
function p6(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    stretch: r = 0.6,
    range: i = "out"
  } = t.namedEffect, s = i === "continuous" ? "linear" : "backInOut", a = i === "out" ? "forwards" : i === "in" ? "backwards" : t.fill, {
    scaleX: o,
    scaleY: u
  } = n && NN[n] ? NN[n] : {
    scaleX: 1 - r,
    scaleY: 1 + r
  }, [l, h] = g6(t), f = i === "out", m = Fo(o), g = Fo(u), A = {
    "--motion-stretch-scale-x-from": f ? 1 : m,
    "--motion-stretch-scale-y-from": f ? 1 : g,
    "--motion-stretch-scale-x-to": f ? m : 1,
    "--motion-stretch-scale-y-to": f ? g : 1,
    "--motion-stretch-trans-from": f ? 0 : `calc(-100% * (1 - ${g}))`,
    "--motion-stretch-trans-to": f ? `calc(100% * (1 - ${g}))` : 0
  }, E = [{
    scale: `${W(A, "--motion-stretch-scale-x-from", e)} ${W(A, "--motion-stretch-scale-y-from", e)}`,
    translate: `0 ${W(A, "--motion-stretch-trans-from", e)}`
  }, {
    scale: `${W(A, "--motion-stretch-scale-x-to", e)} ${W(A, "--motion-stretch-scale-y-to", e)}`,
    translate: `0 ${W(A, "--motion-stretch-trans-to", e)}`
  }];
  return i === "continuous" && (E.forEach((w) => {
    Object.assign(w, {
      easing: lf.backInOut
    });
  }), E.push({
    scale: `${W(A, "--motion-stretch-scale-x-from", e)} ${W(A, "--motion-stretch-scale-y-from", e)}`,
    translate: `0 calc(100% * (1 - ${W(A, "--motion-stretch-scale-y-from", e)}))`
  })), [{
    ...t,
    name: l,
    fill: a,
    easing: s,
    custom: A,
    keyframes: E
  }, {
    ...t,
    name: h,
    fill: "both",
    easing: s,
    keyframes: DN[i] || DN.out
  }];
}
const Xle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: g6,
  style: p6,
  web: Qle
}, Symbol.toStringTag, { value: "Module" })), Zle = 40, [IN, RN, PN] = [10, 25, 25], LN = {
  soft: 0,
  medium: 0.5,
  hard: 1
};
function b6(t) {
  return ["motion-tiltScrollTranslate", "motion-tiltScrollRotate"];
}
function ece(t, e) {
  return y6(t, !0);
}
function y6(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    distance: r = 0,
    range: i = "in",
    direction: s = "right"
  } = t.namedEffect, a = "linear", o = i === "out" ? "forwards" : i === "in" ? "backwards" : t.fill, u = Zle * (n && n in LN ? LN[n] : r), l = s === "left" ? -1 : 1, h = {
    x: IN * (i === "out" ? 0 : -1),
    y: RN * (i === "out" ? 0 : -1),
    z: PN * l * (i === "out" ? 0 : i === "in" ? 1 : -1),
    transY: i === "out" ? 0 : u
  }, f = {
    x: IN * (i === "in" ? 0 : i === "out" ? -1 : 1),
    y: RN * (i === "in" ? 0 : i === "out" ? -1 : 0.5),
    z: PN * l * (i === "in" ? 0 : i === "out" ? 1 : 1.25),
    transY: i === "in" ? 0 : -1 * u
  }, m = i === "out" ? "0px" : `${-1 * Math.abs(u)}vh`, g = i === "in" ? "0px" : `${Math.abs(u)}vh`, [A, E] = b6(), w = {
    "--motion-tilt-y-from": `${h.transY}vh`,
    "--motion-tilt-y-to": `${f.transY}vh`,
    "--motion-tilt-x-from": `${h.x}deg`,
    "--motion-tilt-x-to": `${f.x}deg`,
    "--motion-tilt-y-rot-from": `${h.y}deg`,
    "--motion-tilt-y-rot-to": `${f.y}deg`,
    "--motion-tilt-z-from": `${h.z}deg`,
    "--motion-tilt-z-to": `${f.z}deg`
  };
  return [{
    ...t,
    name: A,
    fill: o,
    easing: a,
    startOffsetAdd: m,
    endOffsetAdd: g,
    custom: w,
    keyframes: [{
      transform: `perspective(400px) translateY(${W(w, "--motion-tilt-y-from", e)}) rotateX(${W(w, "--motion-tilt-x-from", e)}) rotateY(${W(w, "--motion-tilt-y-rot-from", e)})`
    }, {
      transform: `perspective(400px) translateY(${W(w, "--motion-tilt-y-to", e)}) rotateX(${W(w, "--motion-tilt-x-to", e)}) rotateY(${W(w, "--motion-tilt-y-rot-to", e)})`
    }]
  }, {
    ...t,
    name: E,
    fill: o,
    easing: lf.sineInOut,
    startOffsetAdd: m,
    endOffsetAdd: g,
    composite: "add",
    // add this animation on top of the previous one
    custom: w,
    keyframes: [{
      transform: `rotate(calc(${W({}, "--comp-rotate-z", !1, "0deg")} + ${W(w, "--motion-tilt-z-from", e)}))`
    }, {
      transform: `rotate(calc(${W({}, "--comp-rotate-z", !1, "0deg")} + ${W(w, "--motion-tilt-z-to", e)}))`
    }]
  }];
}
const tce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: b6,
  style: y6,
  web: ece
}, Symbol.toStringTag, { value: "Module" })), MN = 45, ON = {
  soft: {
    scaleFrom: 1,
    scaleTo: 1
  },
  medium: {
    scaleFrom: 0.7,
    scaleTo: 1.3
  },
  hard: {
    scaleFrom: 0.4,
    scaleTo: 1.6
  }
};
function A6(t) {
  return ["motion-turnScroll"];
}
function E6(t, e) {
  if (e) {
    let n = 0;
    e.measure((r) => {
      r && (n = r.getBoundingClientRect().left);
    }), e.mutate((r) => {
      r?.style.setProperty("--motion-left", `${n}px`);
    });
  }
}
function nce(t, e) {
  return E6(t, e), S6(t, !0);
}
function S6(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    spin: r = "clockwise",
    direction: i = "right",
    scale: s = 1,
    range: a = "in"
  } = t.namedEffect, o = "linear", u = a === "out" ? "forwards" : a === "in" ? "backwards" : t.fill, l = `calc(-1 * ${W({}, "--motion-left", !1, "calc(100vw - 100%)")} - 100%)`, h = `calc(100vw - ${W({}, "--motion-left", !1, "0px")})`, [f, m] = i === "left" ? [l, h] : [h, l], g = r === "clockwise" ? MN : -1 * MN, {
    scaleFrom: A,
    scaleTo: E
  } = n && ON[n] ? ON[n] : {
    scaleFrom: s,
    scaleTo: s
  }, w = {
    rotation: a === "out" ? 0 : -g,
    scale: a === "out" ? 1 : A,
    translate: a === "out" ? "0px" : f
  }, x = {
    rotation: a === "in" ? 0 : g,
    scale: a === "in" ? 1 : a === "continuous" ? E : A,
    translate: a === "in" ? "0px" : m
  }, [N] = A6(), B = {
    "--motion-turn-translate-from": w.translate,
    "--motion-turn-translate-to": x.translate,
    "--motion-turn-scale-from": w.scale,
    "--motion-turn-scale-to": x.scale,
    "--motion-turn-rotation-from": `${w.rotation}deg`,
    "--motion-turn-rotation-to": `${x.rotation}deg`
  };
  return [{
    ...t,
    name: N,
    fill: u,
    easing: o,
    custom: B,
    keyframes: [{
      transform: `translateX(${W(B, "--motion-turn-translate-from", e)}) scale(${W(B, "--motion-turn-scale-from", e)}) rotate(calc(${W({}, "--comp-rotate-z", !1, "0deg")} + ${W(B, "--motion-turn-rotation-from", e)}))`
    }, {
      transform: `translateX(${W(B, "--motion-turn-translate-to", e)}) scale(${W(B, "--motion-turn-scale-to", e)}) rotate(calc(${W({}, "--comp-rotate-z", !1, "0deg")} + ${W(B, "--motion-turn-rotation-to", e)}))`
    }]
  }];
}
const rce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: A6,
  prepare: E6,
  style: S6,
  web: nce
}, Symbol.toStringTag, { value: "Module" })), BN = {
  ArcScroll: fle,
  BlurScroll: gle,
  FadeScroll: ble,
  FlipScroll: Ale,
  GrowScroll: Fle,
  MoveScroll: vle,
  PanScroll: Cle,
  ParallaxScroll: Nle,
  RevealScroll: Ile,
  ShapeScroll: Lle,
  ShuttersScroll: Ole,
  ShrinkScroll: Ule,
  SkewPanScroll: Wle,
  SlideScroll: Kle,
  Spin3dScroll: Yle,
  SpinScroll: Jle,
  StretchScroll: Xle,
  TiltScroll: tce,
  TurnScroll: rce
}, $N = 80, ice = {
  top: {
    x: 1,
    y: 0,
    sign: 1
  },
  right: {
    x: 0,
    y: 1,
    sign: 1
  },
  bottom: {
    x: 1,
    y: 0,
    sign: -1
  },
  left: {
    x: 0,
    y: 1,
    sign: -1
  }
}, sce = {
  soft: "cubicInOut",
  medium: "quintInOut",
  hard: "backOut"
};
function ace(t, e) {
  return T6(t, e), F6(t, !0);
}
function w6(t) {
  return ["motion-fadeIn", "motion-arcIn"];
}
function F6(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    direction: r = "right"
  } = t.namedEffect, [i, s] = w6(), a = n && sce[n] || t.easing || "quintInOut", {
    x: o,
    y: u,
    sign: l
  } = ice[r], h = "(-1 * (var(--motion-height, 100vh) * var(--motion-arc-x, 1) + var(--motion-width, 100vw) * var(--motion-arc-y, 0))) / 2", f = {
    "--motion-arc-x": `${o}`,
    "--motion-arc-y": `${u}`,
    "--motion-arc-sign": `${l}`
  };
  return [{
    ...t,
    name: i,
    duration: t.duration * 0.7,
    easing: "sineIn",
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    name: s,
    easing: a,
    custom: f,
    keyframes: [{
      offset: Mr,
      transform: `perspective(800px) translateZ(calc(${h})) rotateX(calc(${W(f, "--motion-arc-x", e)} * ${W(f, "--motion-arc-sign", e)} * ${$N}deg)) rotateY(calc(${W(f, "--motion-arc-y", e)} * ${W(f, "--motion-arc-sign", e)} * ${$N}deg)) translateZ(calc(-1 * ${h})) rotate(var(--comp-rotate-z, 0deg))`
    }, {
      transform: `perspective(800px) translateZ(calc(${h})) rotateX(0deg) rotateY(0deg) translateZ(calc(-1 * ${h})) rotate(var(--comp-rotate-z, 0deg))`
    }]
  }];
}
function T6(t, e) {
  if (e) {
    let n, r;
    e.measure((i) => {
      if (!i)
        return;
      const s = i.getBoundingClientRect();
      n = s.width, r = s.height;
    }), e.mutate((i) => {
      i?.style.setProperty("--motion-height", `${r}px`), i?.style.setProperty("--motion-width", `${n}px`);
    });
  }
}
const oce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: w6,
  prepare: T6,
  style: F6,
  web: ace
}, Symbol.toStringTag, { value: "Module" })), HN = {
  soft: 6,
  medium: 25,
  hard: 50
};
function v6(t) {
  return ["motion-fadeIn", "motion-blurIn"];
}
function uce(t) {
  return x6(t, !0);
}
function x6(t, e) {
  e === void 0 && (e = !1);
  const {
    blur: n = 6,
    power: r
  } = t.namedEffect, [i, s] = v6(), a = t.easing || "linear", u = {
    "--motion-blur": `${r && HN[r] ? HN[r] : n}px`
  };
  return [{
    ...t,
    name: i,
    duration: t.duration * 0.7,
    easing: "sineIn",
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    name: s,
    easing: a,
    composite: "add",
    // make sure we don't override existing filters on the component
    custom: u,
    keyframes: [{
      filter: `blur(${W(u, "--motion-blur", e)})`
    }, {
      filter: "blur(0px)"
    }]
  }];
}
const lce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: v6,
  style: x6,
  web: uce
}, Symbol.toStringTag, { value: "Module" }));
function C6(t) {
  return ["motion-shuttersIn"];
}
function cce(t) {
  return k6(t, !0);
}
function k6(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "right",
    shutters: r = 12,
    staggered: i = !0
  } = t.namedEffect, [s] = C6(), {
    clipStart: a,
    clipEnd: o
  } = ET(n, r, i), u = {
    "--motion-shutters-start": a,
    "--motion-shutters-end": o
  }, l = lr(t.easing || "sineIn");
  return [{
    ...t,
    easing: l,
    name: s,
    custom: u,
    keyframes: [{
      offset: 0,
      opacity: 0,
      easing: "step-end"
    }, {
      offset: Mr,
      opacity: "var(--comp-opacity, 1)",
      clipPath: W(u, "--motion-shutters-start", e)
    }, {
      clipPath: W(u, "--motion-shutters-end", e)
    }]
  }];
}
const hce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: C6,
  style: k6,
  web: cce
}, Symbol.toStringTag, { value: "Module" }));
function _6(t) {
  return ["motion-fadeIn", "motion-bounceIn"];
}
const {
  in: dce,
  out: fce
} = rp("sineIn"), UN = [{
  offset: Mr * 100,
  translate: 100
}, {
  offset: 30,
  translate: 0
}, {
  offset: 42,
  translate: 35
}, {
  offset: 54,
  translate: 0
}, {
  offset: 62,
  translate: 21
}, {
  offset: 74,
  translate: 0
}, {
  offset: 82,
  translate: 9
}, {
  offset: 90,
  translate: 0
}, {
  offset: 95,
  translate: 2
}, {
  offset: 100,
  translate: 0,
  isIn: !0
}], mce = {
  soft: 1,
  medium: 2,
  hard: 3
}, gce = {
  top: {
    y: -1,
    x: 0,
    z: 0
  },
  right: {
    y: 0,
    x: 1,
    z: 0
  },
  bottom: {
    y: 1,
    x: 0,
    z: 0
  },
  left: {
    y: 0,
    x: -1,
    z: 0
  },
  center: {
    x: 0,
    y: 0,
    z: -1
  }
};
function pce(t) {
  return N6(t, !0);
}
function N6(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    distanceFactor: r = 1,
    direction: i = "bottom"
  } = t.namedEffect, [s, a] = _6(), o = n && mce[n] || r, u = i === "center" ? "perspective(800px)" : " ", {
    x: l,
    y: h,
    z: f
  } = gce[i], m = {
    "--motion-direction-x": l,
    "--motion-direction-y": h,
    "--motion-direction-z": f,
    "--motion-distance-factor": o,
    "--motion-perspective": u,
    "--motion-ease-in": lr(fce),
    "--motion-ease-out": lr(dce)
  }, g = W(m, "--motion-ease-in", e), A = W(m, "--motion-ease-out", e), E = W(m, "--motion-distance-factor", e), w = W(m, "--motion-perspective", e, ""), x = W(m, "--motion-direction-x", e), N = W(m, "--motion-direction-y", e), B = W(m, "--motion-direction-z", e), P = UN.map((C, D) => {
    let {
      offset: L,
      translate: k
    } = C;
    return {
      offset: L / 100,
      animationTimingFunction: D % 2 ? g : A,
      transform: `${w.trim()} translate3d(calc(${x} * ${E} * ${k / 2}px), calc(${N} * ${E} * ${k / 2}px), calc(${B} * ${E} * ${k / 2}px)) rotateZ(var(--comp-rotate-z, 0deg))`
    };
  });
  return [{
    ...t,
    name: s,
    easing: "quadOut",
    duration: t.duration * UN[3].offset / 100,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    name: a,
    easing: "linear",
    custom: m,
    keyframes: [{
      offset: 0,
      transform: "perspective(800px) translate3d(0, 0, 0) rotateZ(var(--comp-rotate-z, 0deg))"
    }, ...P]
  }];
}
const bce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: _6,
  style: N6,
  web: pce
}, Symbol.toStringTag, { value: "Module" }));
function D6(t) {
  return ["motion-curveIn"];
}
const yce = {
  pseudoRight: {
    rotationX: "180",
    rotationY: "0"
  },
  right: {
    rotationX: "0",
    rotationY: "180"
  },
  pseudoLeft: {
    rotationX: "-180",
    rotationY: "0"
  },
  left: {
    rotationX: "0",
    rotationY: "-180"
  }
};
function Ace(t, e) {
  return R6(t, e), I6(t, !0);
}
function I6(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "right"
  } = t.namedEffect, [r] = D6(), {
    rotationX: i,
    rotationY: s
  } = yce[n], a = {
    "--motion-rotate-x": `${i}deg`,
    "--motion-rotate-y": `${s}deg`
  };
  return [{
    ...t,
    name: r,
    easing: "quadOut",
    custom: a,
    keyframes: [{
      offset: 0,
      opacity: 0,
      easing: "step-end"
    }, {
      offset: Mr,
      opacity: 0,
      transform: `perspective(200px) translateZ(calc(var(--motion-width, 300px) * -3)) rotateX(${W(a, "--motion-rotate-x", e)}) rotateY(${W(a, "--motion-rotate-y", e)}) translateZ(calc(var(--motion-width, 300px) * 3)) rotateZ(var(--comp-rotate-z, 0deg))`
    }, {
      opacity: "var(--comp-opacity, 1)",
      transform: "perspective(200px) translateZ(calc(var(--motion-width, 300px) * -3)) rotateX(0deg) rotateY(0deg) translateZ(calc(var(--motion-width, 300px) * 3)) rotateZ(var(--comp-rotate-z, 0deg))"
    }]
  }];
}
function R6(t, e) {
  if (e) {
    let n;
    e.measure((r) => {
      r && (n = r.getBoundingClientRect().width);
    }), e.mutate((r) => {
      r?.style.setProperty("--motion-width", `${n}px`);
    });
  }
}
const Ece = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: D6,
  prepare: R6,
  style: I6,
  web: Ace
}, Symbol.toStringTag, { value: "Module" }));
function P6(t) {
  return ["motion-circleXIn", "motion-circleYIn"];
}
const Sce = 45;
function wce(t, e) {
  return M6(t, e), L6(t, !0);
}
function L6(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "right"
  } = t.namedEffect, [r, i] = P6(), s = n === "right" ? "calc(100vw - var(--motion-left, 0px))" : "calc(var(--motion-left, 0px) * -1 - 100%)", a = "min(calc(100% * -1.5), max(-300px, calc(100% * -5.5)))", o = {
    "--motion-translate-x": s
  }, u = {
    "--motion-translate-y": a,
    "--motion-rotate-z": `${(n === "right" ? 1 : -1) * Sce}deg`
  };
  return [{
    ...t,
    name: r,
    easing: "circOut",
    custom: o,
    keyframes: [{
      offset: Mr,
      translate: W(o, "--motion-translate-x", e)
    }, {
      translate: "0"
    }]
  }, {
    ...t,
    name: i,
    easing: "linear",
    custom: u,
    keyframes: [{
      offset: 0,
      opacity: 0,
      easing: "step-end"
    }, {
      offset: Mr,
      opacity: 0,
      transform: `translateY(${W(u, "--motion-translate-y", e)}) rotate(calc(var(--comp-rotate-z, 0deg) + ${W(u, "--motion-rotate-z", e)}))`
    }, {
      opacity: "var(--comp-opacity, 1)",
      transform: "translateY(0) rotate(var(--comp-rotate-z, 0deg))"
    }]
  }];
}
function M6(t, e) {
  if (e) {
    let n = 0;
    e.measure((r) => {
      r && (n = r.getBoundingClientRect().left);
    }), e.mutate((r) => {
      r?.style.setProperty("--motion-left", `${n}px`);
    });
  }
}
const Fce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: P6,
  prepare: M6,
  style: L6,
  web: wce
}, Symbol.toStringTag, { value: "Module" }));
function O6(t) {
  return ["motion-fadeIn", "motion-dropIn"];
}
const DS = {
  soft: {
    scale: 1.2,
    ease: "cubicInOut"
  },
  medium: {
    scale: 1.6,
    ease: "quintInOut"
  },
  hard: {
    scale: 2,
    ease: "backOut"
  }
};
function Tce(t) {
  return B6(t, !0);
}
function B6(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    initialScale: r = DS.medium.scale
  } = t.namedEffect, [i, s] = O6(), a = n && DS[n].scale || r, o = n && DS[n].ease || t.easing || "quintInOut", u = {
    "--motion-scale": `${a}`
  };
  return [{
    ...t,
    name: i,
    easing: "quadOut",
    duration: t.duration * 0.8,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    name: s,
    easing: o,
    custom: u,
    keyframes: [{
      offset: Mr,
      scale: W(u, "--motion-scale", e)
    }, {
      scale: "1"
    }]
  }];
}
const vce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: O6,
  style: B6,
  web: Tce
}, Symbol.toStringTag, { value: "Module" }));
function $6(t) {
  return ["motion-fadeIn", "motion-expandIn"];
}
const GN = {
  soft: 0.8,
  medium: 0.6,
  hard: 0
}, xce = {
  top: {
    x: 0,
    y: -0.5
  },
  "top-right": {
    x: 0.5,
    y: -0.5
  },
  right: {
    x: 0.5,
    y: 0
  },
  "bottom-right": {
    x: 0.5,
    y: 0.5
  },
  bottom: {
    x: 0,
    y: 0.5
  },
  "bottom-left": {
    x: -0.5,
    y: 0.5
  },
  left: {
    x: -0.5,
    y: 0
  },
  "top-left": {
    x: -0.5,
    y: -0.5
  },
  center: {
    x: 0,
    y: 0
  }
};
function Cce(t, e) {
  return U6(t, e), H6(t, !0);
}
function H6(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    initialScale: r = 0,
    direction: i = "center"
  } = t.namedEffect, [s, a] = $6(), o = t.easing || "cubicInOut", u = n && n in GN ? GN[n] : r, {
    x: l,
    y: h
  } = xce[i], f = {
    "--motion-translate-x": l,
    "--motion-translate-y": h,
    "--motion-scale": u
  }, m = W(f, "--motion-translate-x", e), g = W(f, "--motion-translate-y", e), A = W(f, "--motion-scale", e);
  return [{
    ...t,
    name: s,
    easing: "linear",
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    name: a,
    easing: o,
    custom: f,
    keyframes: [{
      offset: Mr,
      transform: `translateX(calc(var(--motion-width, 100%) * ${m})) translateY(calc(var(--motion-height, 100%) * ${g})) scale(${A}) translateX(calc(var(--motion-width, 100%) * -1 * ${m})) translateY(calc(var(--motion-height, 100%) * -1 * ${g}))  rotate(var(--comp-rotate-z, 0deg))`
    }, {
      transform: `translateX(calc(var(--motion-width, 100%) * ${m})) translateY(calc(var(--motion-height, 100%) * ${g})) scale(1) translateX(calc(var(--motion-width, 100%) * -1 * ${m})) translateY(calc(var(--motion-height, 100%) * -1 * ${g})) rotate(var(--comp-rotate-z, 0deg))`
    }]
  }];
}
function U6(t, e) {
  if (e) {
    let n, r;
    e.measure((i) => {
      if (!i)
        return;
      const s = i.getBoundingClientRect();
      n = s.width, r = s.height;
    }), e.mutate((i) => {
      i?.style.setProperty("--motion-width", `${n}px`), i?.style.setProperty("--motion-height", `${r}px`);
    });
  }
}
const kce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: $6,
  prepare: U6,
  style: H6,
  web: Cce
}, Symbol.toStringTag, { value: "Module" }));
function G6(t) {
  return ["motion-fadeIn"];
}
function _ce(t) {
  return W6(t);
}
function W6(t) {
  const [e] = G6();
  return [{
    ...t,
    name: e,
    easing: "sineInOut",
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }];
}
const Nce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: G6,
  style: W6,
  web: _ce
}, Symbol.toStringTag, { value: "Module" }));
function V6(t) {
  return ["motion-fadeIn", "motion-flipIn"];
}
const Dce = ["top", "right", "bottom", "left"], K6 = {
  soft: 45,
  medium: 90,
  hard: 270
};
function z6(t, e) {
  return {
    x: WN[t].x * e,
    y: WN[t].y * e
  };
}
const WN = {
  top: {
    x: 1,
    y: 0
  },
  right: {
    x: 0,
    y: 1
  },
  bottom: {
    x: -1,
    y: 0
  },
  left: {
    x: 0,
    y: -1
  }
};
function Ice(t, e) {
  return Y6(t, e), j6(t);
}
function j6(t) {
  const {
    direction: e = "top",
    power: n,
    initialRotate: r = 90
  } = t.namedEffect, [i, s] = V6(), a = n && K6[n] || r, o = t.easing || "backOut", u = z6(e, a), l = {
    "--motion-rotate-x": `${u.x}deg`,
    "--motion-rotate-y": `${u.y}deg`
  };
  return [{
    ...t,
    easing: "quadOut",
    name: i,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    easing: o,
    name: s,
    custom: l,
    keyframes: [{
      offset: Mr,
      transform: `perspective(800px) rotate(var(--comp-rotate-z, 0deg)) rotateX(var(--motion-rotate-x , ${l["--motion-rotate-x"]})) rotateY(var(--motion-rotate-y , ${l["--motion-rotate-y"]}))`
    }, {
      transform: "perspective(800px) rotate(var(--comp-rotate-z, 0deg)) rotateX(0deg) rotateY(0deg)"
    }]
  }];
}
function Y6(t, e) {
  const {
    direction: n = "top",
    power: r,
    initialRotate: i = 90
  } = t.namedEffect, s = r && K6[r] || i;
  if (e) {
    let a = n;
    e.measure((o) => {
      if (!o)
        return;
      const u = getComputedStyle(o).getPropertyValue("--comp-rotate-z") || "0deg";
      a = wc(Dce, n, parseInt(u, 10));
    }), e.mutate((o) => {
      const u = z6(a, s);
      o?.style.setProperty("--motion-rotate-x", `${u.x}deg`), o?.style.setProperty("--motion-rotate-y", `${u.y}deg`);
    });
  }
}
const Rce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: V6,
  prepare: Y6,
  style: j6,
  web: Ice
}, Symbol.toStringTag, { value: "Module" }));
function q6(t) {
  return ["motion-floatIn"];
}
const Pce = {
  top: {
    dx: 0,
    dy: -1,
    distance: 60
  },
  right: {
    dx: 1,
    dy: 0,
    distance: 60
  },
  bottom: {
    dx: 0,
    dy: 1,
    distance: 60
  },
  left: {
    dx: -1,
    dy: 0,
    distance: 60
  }
};
function Lce(t) {
  return J6(t, !0);
}
function J6(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "left",
    distance: r
  } = t.namedEffect, [i] = q6(), s = Pce[n], a = s.dx * (r || s.distance), o = s.dy * (r || s.distance), u = {
    "--motion-translate-x": `${a}px`,
    "--motion-translate-y": `${o}px`
  };
  return [{
    ...t,
    name: i,
    easing: "sineInOut",
    custom: u,
    keyframes: [{
      offset: 0,
      opacity: 0,
      easing: "step-end"
    }, {
      offset: Mr,
      opacity: 0,
      transform: `translate(${W(u, "--motion-translate-x", e)}, ${W(u, "--motion-translate-y", e)}) rotate(var(--comp-rotate-z, 0deg))`
    }, {
      opacity: "var(--comp-opacity, 1)",
      transform: "translate(0, 0) rotate(var(--comp-rotate-z, 0deg))"
    }]
  }];
}
const Mce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: q6,
  style: J6,
  web: Lce
}, Symbol.toStringTag, { value: "Module" }));
function Q6(t) {
  return ["motion-fadeIn", "motion-foldIn"];
}
const X6 = {
  soft: 35,
  medium: 60,
  hard: 90
}, Oce = ["top", "right", "bottom", "left"], r1 = {
  top: {
    x: -1,
    y: 0,
    origin: {
      x: 0,
      y: -50
    }
  },
  right: {
    x: 0,
    y: -1,
    origin: {
      x: 50,
      y: 0
    }
  },
  bottom: {
    x: 1,
    y: 0,
    origin: {
      x: 0,
      y: 50
    }
  },
  left: {
    x: 0,
    y: 1,
    origin: {
      x: -50,
      y: 0
    }
  }
};
function Z6(t, e) {
  return {
    x: r1[t].x * e,
    y: r1[t].y * e
  };
}
function Bce(t, e) {
  return t9(t, e), e9(t);
}
function e9(t) {
  const {
    direction: e = "top",
    power: n,
    initialRotate: r = 90
  } = t.namedEffect, [i, s] = Q6(), a = t.easing || "backOut", o = n && X6[n] || r, {
    x: u,
    y: l
  } = r1[e].origin, h = Z6(e, o), f = {
    "--motion-origin-x": `${u}%`,
    "--motion-origin-y": `${l}%`,
    "--motion-rotate-x": `${h.x}deg`,
    "--motion-rotate-y": `${h.y}deg`
  };
  return [{
    ...t,
    easing: "quadOut",
    name: i,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    easing: a,
    name: s,
    custom: f,
    keyframes: [{
      offset: Mr,
      transform: `rotate(var(--comp-rotate-z, 0deg)) translate(var(--motion-origin-x ,${f["--motion-origin-x"]}), var(--motion-origin-y, ${f["--motion-origin-y"]})) perspective(800px) rotateX(var(--motion-rotate-x, ${f["--motion-rotate-x"]})) rotateY(var(--motion-rotate-y, ${f["--motion-rotate-y"]})) translate(calc(-1 * var(--motion-origin-x ,${f["--motion-origin-x"]})), calc(-1 * var(--motion-origin-y, ${f["--motion-origin-y"]})))`
    }, {
      transform: `rotate(var(--comp-rotate-z, 0deg)) translate(var(--motion-origin-x ,${f["--motion-origin-x"]}), var(--motion-origin-y, ${f["--motion-origin-y"]})) perspective(800px) rotateX(0deg) rotateY(0deg) translate(calc(-1 * var(--motion-origin-x ,${f["--motion-origin-x"]})), calc(-1 * var(--motion-origin-y, ${f["--motion-origin-y"]})))`
    }]
  }];
}
function t9(t, e) {
  const {
    direction: n = "top",
    power: r,
    initialRotate: i = 90
  } = t.namedEffect, s = r && X6[r] || i;
  if (e) {
    let a = n;
    e.measure((o) => {
      if (!o)
        return;
      const u = getComputedStyle(o).getPropertyValue("--comp-rotate-z") || "0deg";
      a = wc(Oce, n, parseInt(u, 10));
    }), e.mutate((o) => {
      const {
        origin: u
      } = r1[a], l = Z6(a, s);
      o?.style.setProperty("--motion-origin-x", `${u.x}%`), o?.style.setProperty("--motion-origin-y", `${u.y}%`), o?.style.setProperty("--motion-rotate-x", `${l.x}deg`), o?.style.setProperty("--motion-rotate-y", `${l.y}deg`);
    });
  }
}
const $ce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: Q6,
  prepare: t9,
  style: e9,
  web: Bce
}, Symbol.toStringTag, { value: "Module" }));
function EC(t) {
  return ["motion-glideIn"];
}
const Hce = {
  soft: "cubicInOut",
  medium: "quintInOut",
  hard: "backOut"
};
function n9(t, e) {
  return wC(t, e), SC(t, !0);
}
function SC(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = 0,
    distance: r = {
      value: 100,
      type: "percentage"
    },
    power: i,
    startFromOffScreen: s = !1
  } = t.namedEffect, [a] = EC(), o = n * Math.PI / 180, u = Us(r.type), l = i && Hce[i] || t.easing || "quintInOut", {
    x: h,
    y: f
  } = ule(n), m = s ? h : `${Math.sin(o) * r.value | 0}${u}`, g = s ? f : `${Math.cos(o) * r.value * -1 | 0}${u}`, A = {
    "--motion-translate-x": `${m}`,
    "--motion-translate-y": `${g}`
  };
  return [{
    ...t,
    name: a,
    easing: l,
    custom: A,
    keyframes: [{
      offset: 0,
      opacity: 0,
      easing: "step-end"
    }, {
      offset: Mr,
      // TODO: remove opacity when not necessary to override hard-coded opacity:0 in style
      opacity: "var(--comp-opacity, 1)",
      transform: `translate(${W(A, "--motion-translate-x", e)}, ${W(A, "--motion-translate-y", e)}) rotate(var(--comp-rotate-z, 0deg))`
    }, {
      opacity: "var(--comp-opacity, 1)",
      transform: "translate(0, 0) rotate(var(--comp-rotate-z, 0deg))"
    }]
  }];
}
function wC(t, e) {
  const {
    startFromOffScreen: n = !1
  } = t.namedEffect;
  if (e && n) {
    let r = 0, i = 0;
    e.measure((s) => {
      if (!s)
        return;
      const {
        left: a,
        top: o
      } = s.getBoundingClientRect();
      r = a, i = o;
    }), e.mutate((s) => {
      s?.style.setProperty("--motion-left", `${r}px`), s?.style.setProperty("--motion-top", `${i}px`);
    });
  }
}
const Uce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: EC,
  prepare: wC,
  style: SC,
  web: n9
}, Symbol.toStringTag, { value: "Module" }));
function r9(t) {
  const e = JSON.parse(JSON.stringify(t)), {
    direction: n
  } = e.namedEffect;
  return e.namedEffect.startFromOffScreen ? e.namedEffect.direction = (n ?? 270) - 90 : typeof n > "u" && (e.namedEffect.direction = 270), e;
}
function Gce(t, e) {
  return n9(r9(t), e);
}
function Wce(t) {
  return SC(r9(t));
}
const Vce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: EC,
  prepare: wC,
  style: Wce,
  web: Gce
}, Symbol.toStringTag, { value: "Module" }));
function i9(t) {
  return ["motion-fadeIn", "motion-growIn"];
}
const Kce = {
  soft: 0.8,
  medium: 0.6,
  hard: 0
};
function zce(t) {
  return s9(t, !0);
}
function s9(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    initialScale: r = 0,
    distance: i = {
      value: 120,
      type: "percentage"
    },
    direction: s = 0
  } = t.namedEffect, [a, o] = i9(), u = t.easing || "cubicInOut", l = typeof n < "u" ? Kce[n] : r, h = s * Math.PI / 180, f = Us(i.type), m = `${Math.sin(h) * i.value | 0}${f}`, g = `${Math.cos(h) * i.value * -1 | 0}${f}`, A = {
    "--motion-translate-x": `${m}`,
    "--motion-translate-y": `${g}`,
    "--motion-scale": `${l}`
  };
  return [{
    ...t,
    easing: u,
    duration: t.duration * l,
    name: a,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    easing: u,
    name: o,
    custom: A,
    keyframes: [{
      offset: Mr,
      transform: `translate(${W(A, "--motion-translate-x", e)}, ${W(A, "--motion-translate-y", e)}) rotate(var(--comp-rotate-z, 0deg)) scale(${W(A, "--motion-scale", e)})`
    }, {
      transform: "translate(0px, 0px) rotate(var(--comp-rotate-z, 0deg)) scale(1)"
    }]
  }];
}
const jce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: i9,
  style: s9,
  web: zce
}, Symbol.toStringTag, { value: "Module" }));
function a9(t) {
  return ["motion-fadeIn", "motion-punchIn"];
}
const Yce = {
  "top-left": {
    y: -1,
    x: -1
  },
  "top-right": {
    y: -1,
    x: 1
  },
  "bottom-right": {
    y: 1,
    x: 1
  },
  "bottom-left": {
    y: 1,
    x: -1
  },
  center: {
    y: 0,
    x: 0
  }
}, qce = {
  soft: "sineIn",
  medium: "quadIn",
  hard: "quintIn"
};
function Jce(t, e, n) {
  return {
    x: `calc(var(--motion-width, 100%) * 1.1 / 3 * ${t} * ${n})`,
    y: `calc(var(--motion-height, 100%) * 1.1 / 3 * ${e} * ${n})`
  };
}
function Qce(t, e) {
  return u9(t, e), o9(t, !0);
}
function o9(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "top-right",
    power: r = "medium"
  } = t.namedEffect, [i, s] = a9(), a = Yce[n], o = {
    x: `calc(var(--motion-width, 100%) * 1.1 / 2 * ${a.x})`,
    y: `calc(var(--motion-height, 100%) * 1.1 / 2 * ${a.y})`
  }, {
    in: u,
    out: l
  } = rp(qce[r]), f = [{
    offset: 30,
    scale: 0.3,
    factor: 1,
    ease: "linear"
  }, {
    offset: 45,
    scale: 1.4,
    factor: -0.4,
    ease: l
  }, {
    offset: 62.65,
    scale: 0.8,
    factor: 0.2,
    ease: u
  }, {
    offset: 77.27,
    scale: 1.1,
    factor: -0.1,
    ease: l
  }, {
    offset: 86.23,
    scale: 0.94,
    factor: 0.06,
    ease: u
  }, {
    offset: 91.73,
    scale: 1.03,
    factor: -0.03,
    ease: l
  }, {
    offset: 95.11,
    scale: 0.98,
    factor: 0.02,
    ease: u
  }, {
    offset: 97.18,
    scale: 1.01,
    factor: -0.01,
    ease: l
  }, {
    offset: 98.45,
    scale: 0.99,
    factor: 0.01,
    ease: u
  }, {
    offset: 100,
    scale: 1,
    factor: 0,
    ease: l
  }].map((g) => {
    let {
      offset: A,
      scale: E,
      ease: w,
      factor: x
    } = g;
    const {
      x: N,
      y: B
    } = Jce(a.x, a.y, x);
    return {
      offset: A / 100,
      easing: lr(w),
      scale: `${E}`,
      translate: `${N} ${B}`
    };
  }), m = {
    "--motion-translate": `${o.x} ${o.y}`
  };
  return [{
    ...t,
    easing: "cubicIn",
    duration: t.duration * 0.3,
    name: i,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    easing: "linear",
    name: s,
    custom: m,
    keyframes: [{
      offset: Mr,
      translate: W(m, "--motion-translate", e),
      scale: "0",
      easing: lf.expoIn
    }, ...f]
  }];
}
function u9(t, e) {
  if (e) {
    let n, r;
    e.measure((i) => {
      if (!i)
        return;
      const s = i.getBoundingClientRect();
      n = s.width, r = s.height;
    }), e.mutate((i) => {
      i?.style.setProperty("--motion-width", `${n}px`), i?.style.setProperty("--motion-height", `${r}px`);
    });
  }
}
const Xce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: a9,
  prepare: u9,
  style: o9,
  web: Qce
}, Symbol.toStringTag, { value: "Module" }));
function l9(t) {
  return ["motion-fadeIn", "motion-shapeIn"];
}
const Zce = {
  diamond: {
    start: "polygon(50% 50%, 50% 50%, 50% 50%, 50% 50%)",
    end: "polygon(50% -50%, 150% 50%, 50% 150%, -50% 50%)"
  },
  window: {
    start: "inset(50% round 50% 50% 0% 0%)",
    end: "inset(-20% round 50% 50% 0% 0%)"
  },
  rectangle: {
    start: "inset(50%)",
    end: "inset(0%)"
  },
  circle: {
    start: "circle(0%)",
    end: "circle(75%)"
  },
  ellipse: {
    start: "ellipse(0% 0%)",
    end: "ellipse(75% 75%)"
  }
};
function ehe(t) {
  return c9(t, !0);
}
function c9(t, e) {
  e === void 0 && (e = !1);
  const {
    shape: n = "rectangle"
  } = t.namedEffect, [r, i] = l9(), s = t.easing || "cubicInOut", {
    start: a,
    end: o
  } = Zce[n], u = {
    "--motion-shape-start": a,
    "--motion-shape-end": o
  };
  return [{
    ...t,
    name: r,
    easing: "quadOut",
    duration: t.duration * 0.8,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    name: i,
    easing: s,
    custom: u,
    keyframes: [{
      offset: Mr,
      clipPath: W(u, "--motion-shape-start", e)
    }, {
      clipPath: W(u, "--motion-shape-end", e)
    }]
  }];
}
const the = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: l9,
  style: c9,
  web: ehe
}, Symbol.toStringTag, { value: "Module" }));
function h9(t) {
  return ["motion-revealIn"];
}
const nhe = ["top", "right", "bottom", "left"];
function d9(t, e) {
  const n = wc(nhe, e, t);
  return oa({
    direction: n,
    minimum: 0
  });
}
function rhe(t, e) {
  return m9(t, e), f9(t);
}
function f9(t) {
  const {
    direction: e = "left"
  } = t.namedEffect, [n] = h9(), r = t.easing || "cubicInOut", i = d9(0, e), s = oa({
    direction: "initial"
  });
  return [{
    ...t,
    easing: r,
    name: n,
    custom: {
      "--motion-clip-start": i
    },
    keyframes: [{
      offset: 0,
      opacity: 0,
      easing: "step-end"
    }, {
      offset: Mr,
      opacity: "var(--comp-opacity, 1)",
      clipPath: `var(--motion-clip-start, ${i})`
    }, {
      clipPath: s
    }]
  }];
}
function m9(t, e) {
  const {
    direction: n = "left"
  } = t.namedEffect;
  if (e) {
    let r = "0deg";
    e.measure((i) => {
      i && (r = getComputedStyle(i).getPropertyValue("--comp-rotate-z") || "0deg");
    }), e.mutate((i) => {
      i?.style.setProperty("--motion-clip-start", d9(parseInt(r, 10), n));
    });
  }
}
const ihe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: h9,
  prepare: m9,
  style: f9,
  web: rhe
}, Symbol.toStringTag, { value: "Module" }));
function g9(t) {
  const {
    power: e
  } = t.namedEffect;
  return e !== "hard" ? ["motion-slideIn", "motion-fadeIn"] : ["motion-slideIn"];
}
const Qm = {
  top: {
    dx: 0,
    dy: -1,
    clip: "bottom"
  },
  right: {
    dx: 1,
    dy: 0,
    clip: "left"
  },
  bottom: {
    dx: 0,
    dy: 1,
    clip: "top"
  },
  left: {
    dx: -1,
    dy: 0,
    clip: "right"
  }
}, she = ["top", "right", "bottom", "left"], p9 = {
  soft: 0.2,
  medium: 0.8,
  hard: 1
};
function ahe(t, e) {
  const n = b9(t);
  return y9(t, e), n;
}
function b9(t) {
  const {
    direction: e = "left",
    power: n,
    initialTranslate: r = 1
  } = t.namedEffect, [i, s] = g9(t), a = t.easing || "cubicInOut", u = 100 - (n && p9[n] || r) * 100, l = oa({
    direction: e,
    minimum: u
  }), h = oa({
    direction: "initial"
  }), f = {
    "--motion-clip-start": l,
    "--motion-translate-x": `${Qm[e].dx * 100}%`,
    "--motion-translate-y": `${Qm[e].dy * 100}%`
  }, m = [{
    ...t,
    name: i,
    easing: a,
    custom: f,
    keyframes: [{
      offset: Mr,
      opacity: "var(--comp-opacity, 1)",
      transform: "rotate(var(--comp-rotate-z, 0deg)) translate(var(--motion-translate-x, -100%), var(--motion-translate-y, 0%))",
      clipPath: `var(--motion-clip-start, ${f["--motion-clip-start"]})`
    }, {
      transform: "rotate(var(--comp-rotate-z, 0deg)) translate(0px, 0px)",
      clipPath: h
    }]
  }];
  return n !== "hard" ? m.push({
    ...t,
    easing: "cubicInOut",
    name: s,
    // @ts-expect-error
    custom: {},
    keyframes: [
      // @ts-expect-error
      {
        offset: 0,
        opacity: 0
      },
      // @ts-expect-error
      {
        opacity: "var(--comp-opacity, 1)"
      }
    ]
  }) : m[0].keyframes.unshift({
    offset: 0,
    // @ts-expect-error
    opacity: 0,
    easing: "step-end"
  }), m;
}
function y9(t, e) {
  const {
    direction: n = "left",
    power: r,
    initialTranslate: i = 1
  } = t.namedEffect, a = 100 - (r && p9[r] || i) * 100;
  if (e) {
    let o = 0;
    e.measure((u) => {
      u && (o = parseInt(getComputedStyle(u).getPropertyValue("--comp-rotate-z") || "0deg", 10));
    }), e.mutate((u) => {
      const l = wc(she, n, o);
      u?.style.setProperty("--motion-clip-start", oa({
        direction: Qm[l].clip,
        minimum: a
      })), u?.style.setProperty("--motion-translate-x", `${Qm[l].dx * 100}%`), u?.style.setProperty("--motion-translate-y", `${Qm[l].dy * 100}%`);
    });
  }
}
const ohe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: g9,
  prepare: y9,
  style: b9,
  web: ahe
}, Symbol.toStringTag, { value: "Module" }));
function A9(t) {
  return ["motion-fadeIn", "motion-spinIn"];
}
const uhe = {
  soft: 1,
  medium: 0.6,
  hard: 0
}, lhe = {
  clockwise: -1,
  "counter-clockwise": 1
};
function che(t) {
  return E9(t, !0);
}
function E9(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "clockwise",
    spins: r = 0.5,
    initialScale: i = 0,
    power: s
  } = t.namedEffect, [a, o] = A9(), u = t.easing || "cubicInOut", l = typeof s < "u" ? uhe[s] : i, h = (lhe[n] > 0 ? 1 : -1) * 360 * r, f = {
    "--motion-scale": `${l}`,
    "--motion-rotate": `${h}deg`
  };
  return [{
    ...t,
    name: a,
    easing: "cubicIn",
    duration: t.duration * l,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    name: o,
    easing: u,
    custom: f,
    keyframes: [{
      offset: Mr,
      scale: W(f, "--motion-scale", e),
      rotate: W(f, "--motion-rotate", e)
    }, {
      scale: "1",
      rotate: "0deg"
    }]
  }];
}
const hhe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: A9,
  style: E9,
  web: che
}, Symbol.toStringTag, { value: "Module" }));
function S9(t) {
  return ["motion-fadeIn", "motion-tiltInRotate", "motion-tiltInClip"];
}
const dhe = {
  left: 30,
  right: -30
}, fhe = ["top", "right", "bottom", "left"];
function w9(t) {
  const e = wc(fhe, "top", t);
  return oa({
    direction: e,
    minimum: 0
  });
}
function mhe(t, e) {
  return T9(t, e), F9(t, !0);
}
function F9(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "left"
  } = t.namedEffect, [r, i, s] = S9(), a = t.easing || "cubicOut", o = w9(0), u = dhe[n], l = oa({
    direction: "initial"
  }), h = "(var(--motion-height, 200px) / 2)", f = {
    "--motion-rotate-z": `${u}deg`,
    "--motion-clip-start": o
  };
  return [{
    ...t,
    name: r,
    duration: t.duration * 0.2,
    easing: "cubicOut",
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    name: i,
    easing: a,
    custom: {},
    keyframes: [{
      offset: 0,
      easing: "step-end",
      transform: "perspective(800px)"
    }, {
      offset: Mr,
      transform: `perspective(800px) translateZ(calc(${h} * -1)) rotateX(-90deg) translateZ(calc${h}) rotate(var(--comp-rotate-z, 0deg))`
    }, {
      transform: `perspective(800px) translateZ(calc(${h} * -1)) rotateX(0deg) translateZ(calc${h}) rotate(var(--comp-rotate-z, 0deg))`
    }]
  }, {
    ...t,
    name: s,
    easing: a,
    composite: "add",
    duration: t.duration * 0.8,
    custom: f,
    keyframes: [{
      offset: Mr,
      clipPath: `var(--motion-clip-start, ${f["--motion-clip-start"]})`,
      transform: `rotateZ(${W(f, "--motion-rotate-z", e)})`
    }, {
      clipPath: l,
      transform: "rotateZ(0deg)"
    }]
  }];
}
function T9(t, e) {
  if (e) {
    let n = "0deg";
    e.measure((r) => {
      r && (n = getComputedStyle(r).getPropertyValue("--comp-rotate-z") || "0deg");
    }), e.mutate((r) => {
      r?.style.setProperty("--motion-clip-start", w9(parseInt(n, 10)));
    });
  }
}
const ghe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: S9,
  prepare: T9,
  style: F9,
  web: mhe
}, Symbol.toStringTag, { value: "Module" }));
function v9(t) {
  return ["motion-fadeIn", "motion-turnIn"];
}
const VN = {
  soft: "cubicInOut",
  medium: "quintInOut",
  hard: "backOut"
}, KN = {
  "top-left": {
    angle: -50,
    x: -50,
    y: -50
  },
  "top-right": {
    angle: 50,
    x: 50,
    y: -50
  },
  "bottom-right": {
    angle: 50,
    x: 50,
    y: 50
  },
  "bottom-left": {
    angle: -50,
    x: -50,
    y: 50
  }
};
function phe(t) {
  return x9(t, !0);
}
function x9(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "top-left",
    power: r
  } = t.namedEffect, [i, s] = v9(), a = r && VN[r] ? VN[r] : t.easing || "backOut", {
    x: o,
    y: u
  } = KN[n], l = KN[n].angle, h = {
    "--motion-origin": `${o}%, ${u}%`,
    "--motion-origin-invert": `${-o}%, ${-u}%`,
    "--motion-rotate-z": `${l}deg`
  }, f = W(h, "--motion-origin", e), m = W(h, "--motion-origin-invert", e);
  return [{
    ...t,
    name: i,
    duration: t.duration * 0.6,
    easing: "sineIn",
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    name: s,
    easing: a,
    custom: h,
    keyframes: [{
      offset: Mr,
      transform: `translate(${f}) rotate(${W(h, "--motion-rotate-z", e)}) translate(${m}) rotate(var(--comp-rotate-z, 0deg))`
    }, {
      transform: `translate(${f}) rotate(0deg) translate(${m}) rotate(var(--comp-rotate-z, 0deg))`
    }]
  }];
}
const bhe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: v9,
  style: x9,
  web: phe
}, Symbol.toStringTag, { value: "Module" }));
function C9(t) {
  return ["motion-fadeIn", "motion-winkInClip", "motion-winkInRotate"];
}
const ST = {
  vertical: {
    scaleY: 0,
    scaleX: 1
  },
  horizontal: {
    scaleY: 1,
    scaleX: 0
  }
}, k9 = ["vertical", "horizontal"];
function yhe(t, e) {
  return N9(t, e), _9(t);
}
function _9(t) {
  const {
    direction: e = "horizontal"
  } = t.namedEffect, [n, r, i] = C9(), s = wc(k9, e, 0), {
    scaleX: a,
    scaleY: o
  } = ST[s], u = t.easing || "quintInOut", l = oa({
    direction: e,
    minimum: 100
  }), h = oa({
    direction: "initial"
  }), f = {
    "--motion-scale-x": a,
    "--motion-scale-y": o,
    "--motion-clip-start": l
  };
  return [{
    ...t,
    easing: "quadOut",
    name: n,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: "var(--comp-opacity, 1)"
    }]
  }, {
    ...t,
    easing: u,
    name: r,
    custom: f,
    keyframes: [{
      offset: Mr,
      clipPath: `var(--motion-clip-start, ${f["--motion-clip-start"]})`
    }, {
      clipPath: h
    }]
  }, {
    ...t,
    duration: t.duration * 0.85,
    easing: u,
    name: i,
    custom: f,
    keyframes: [{
      offset: Mr,
      transform: `rotate(var(--comp-rotate-z, 0deg)) scale(var(--motion-scale-x, ${f["--motion-scale-x"]}), var(--motion-scale-y, ${f["--motion-scale-y"]}))`
    }, {
      transform: "rotate(var(--comp-rotate-z, 0deg)) scale(1, 1)"
    }]
  }];
}
function N9(t, e) {
  const {
    direction: n = "horizontal"
  } = t.namedEffect;
  if (e) {
    let r = ST.horizontal, i = oa({
      direction: "horizontal",
      minimum: 100
    });
    e.measure((s) => {
      if (!s)
        return;
      const a = getComputedStyle(s).getPropertyValue("--comp-rotate-z") || "0", o = wc(k9, n, parseInt(a, 10));
      r = ST[o], i = oa({
        direction: o,
        minimum: 100
      });
    }), e.mutate((s) => {
      s?.style.setProperty("--motion-clip-start", i), s?.style.setProperty("--motion-scale-x", `${r.scaleX}`), s?.style.setProperty("--motion-scale-y", `${r.scaleY}`);
    });
  }
}
const Ahe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: C9,
  prepare: N9,
  style: _9,
  web: yhe
}, Symbol.toStringTag, { value: "Module" })), zN = {
  ArcIn: oce,
  BlurIn: lce,
  ShuttersIn: hce,
  BounceIn: bce,
  CurveIn: Ece,
  CircleIn: Fce,
  DropIn: vce,
  ExpandIn: kce,
  FadeIn: Nce,
  FlipIn: Rce,
  FloatIn: Mce,
  FoldIn: $ce,
  GlideIn: Uce,
  GlitchIn: Vce,
  GrowIn: jce,
  PunchIn: Xce,
  ShapeIn: the,
  RevealIn: ihe,
  SlideIn: ohe,
  SpinIn: hhe,
  TiltIn: ghe,
  TurnIn: bhe,
  WinkIn: Ahe
}, IS = {
  soft: 1,
  medium: 2,
  hard: 3
}, Ehe = [{
  keyframe: 0,
  translateY: 0
}, {
  keyframe: 8.8,
  translateY: -55
}, {
  keyframe: 17.6,
  translateY: -87
}, {
  keyframe: 26.5,
  translateY: -98
}, {
  keyframe: 35.3,
  translateY: -87
}, {
  keyframe: 44.1,
  translateY: -55
}, {
  keyframe: 53.1,
  translateY: 0
}, {
  keyframe: 66.2,
  translateY: -23
}, {
  keyframe: 81,
  translateY: 0
}, {
  keyframe: 86.8,
  translateY: -5
}, {
  keyframe: 94.1,
  translateY: 0
}, {
  keyframe: 97.1,
  translateY: -2
}, {
  keyframe: 100,
  translateY: 0
}];
function She(t, e) {
  return D9(t, !0);
}
function D9(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n = "soft",
    intensity: r
  } = t.namedEffect, i = t.duration || 1, s = t.delay || 0, a = br(i, s), [o] = I9(t), u = r ? Ct(0, 1, IS.soft, IS.hard, r) : IS[n], l = lr("sineOut"), h = {
    "--motion-bounce-factor": u
  }, f = Ehe.map((m) => {
    let {
      keyframe: g,
      translateY: A
    } = m;
    return {
      offset: g / 100 * a,
      translate: `0px calc(${A / 2}px * ${W(h, "--motion-bounce-factor", e)})`,
      easing: l
    };
  });
  return [{
    ...t,
    name: o,
    delay: 0,
    easing: "linear",
    duration: i + s,
    custom: h,
    keyframes: f
  }];
}
function I9(t) {
  return [`motion-bounce-${br(t.duration, t.delay, !0)}`];
}
const whe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: I9,
  style: D9,
  web: She
}, Symbol.toStringTag, { value: "Module" })), Fhe = {
  vertical: {
    x: 0,
    y: 1,
    z: 0
  },
  horizontal: {
    x: 1,
    y: 0,
    z: 0
  },
  center: {
    x: 0,
    y: 0,
    z: 1
  }
}, The = [{
  translateFactor: 1,
  timeFactor: 0.25
}, {
  translateFactor: -1,
  timeFactor: 0.5
}, {
  translateFactor: 1,
  timeFactor: 0.5
}, {
  translateFactor: -0.7,
  timeFactor: 0.5
}, {
  translateFactor: 0.6,
  timeFactor: 0.3333
}];
function vhe(t, e) {
  return R9(t, !0);
}
function R9(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "vertical",
    distance: r = {
      value: 25,
      type: "px"
    }
  } = t.namedEffect, i = t.easing || "sineInOut", s = t.duration || 1, a = t.delay || 0, o = 3.2 * s + a, u = br(s, o - s), [l] = P9(t), {
    x: h,
    y: f,
    z: m
  } = Fhe[n], g = rp(i), E = {
    "--motion-breathe-perspective": n === "center" ? "perspective(800px)" : "",
    "--motion-breathe-distance": `${r.value}${Us(r.type || "px")}`,
    "--motion-breathe-x": h,
    "--motion-breathe-y": f,
    "--motion-breathe-z": m
  }, w = `${W(E, "--motion-breathe-x", e)}`, x = `${W(E, "--motion-breathe-y", e)}`, N = `${W(E, "--motion-breathe-z", e)}`, B = `${W(E, "--motion-breathe-perspective", e, "")}`, P = `${W(E, "--motion-breathe-distance", e)}`;
  let C = 0;
  const D = a ? The.map((L) => {
    let {
      translateFactor: k,
      timeFactor: I
    } = L;
    const U = C + I * u;
    C = U;
    const j = `${P} * ${k}`;
    return {
      offset: U,
      easing: lr(g.inOut),
      transform: `${B} translate3d(calc(${w} * ${j}), calc(${x} * ${j}), calc(${N} * ${j})) rotateZ(var(--comp-rotate-z, 0deg))`
    };
  }) : [{
    offset: 0.25,
    easing: lr(g.inOut),
    transform: `${B} translate3d(calc(${w} * ${P}), calc(${x} * ${P}), calc(${N} * ${P})) rotateZ(var(--comp-rotate-z, 0deg))`
  }, {
    offset: 0.75,
    easing: lr(g.in),
    transform: `${B} translate3d(calc(${w} * -1 * ${P}), calc(${x} * -1 * ${P}), calc(${N} * -1 * ${P})) rotateZ(var(--comp-rotate-z, 0deg))`
  }];
  return [{
    ...t,
    name: l,
    easing: "linear",
    delay: 0,
    duration: a ? o : s,
    custom: E,
    keyframes: [{
      offset: 0,
      easing: lr(g.out),
      transform: `${B} translate3d(0, 0, 0) rotateZ(var(--comp-rotate-z, 0deg))`
    }, ...D, {
      offset: 1,
      transform: `${B} translate3d(0, 0, 0) rotateZ(var(--comp-rotate-z, 0deg))`
    }]
  }];
}
function P9(t) {
  return [`motion-breathe-${br(t.duration, t.delay, !0)}`];
}
const xhe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: P9,
  style: R9,
  web: vhe
}, Symbol.toStringTag, { value: "Module" })), Che = {
  // 100cqw - left
  RIGHT: "calc(var(--motion-parent-width, 100vw) - var(--motion-left, 0px))",
  // left * -1 - width
  LEFT: "calc(var(--motion-left, 0px) * -1 - var(--motion-width, 100%))",
  // top * -1 - height
  TOP: "calc(var(--motion-top, 0px) * -1 - var(--motion-height, 100%))",
  // 100cqh - top
  BOTTOM: "calc(var(--motion-parent-height, 100vh) - var(--motion-top, 0px))"
}, {
  RIGHT: wd,
  LEFT: Fd,
  TOP: Td,
  BOTTOM: vd
} = Che, jN = {
  "top-left": {
    // min(100cqw - left, 100cqh - top)
    from: `min(${wd}, ${vd})`,
    // min(abs(left * -1 - width), abs(top * -1 - height))
    to: `min(calc(${Fd} * -1), calc(${Td} * -1))`
  },
  "top-right": {
    // min(abs(left * -1 - width), 100cqh - top)
    from: `min(calc(${Fd} * -1), ${vd})`,
    // min(100cqw - left, abs(top * -1 - height))
    to: `min(${wd}, calc(${Td} * -1))`
  },
  "bottom-left": {
    // min(100cqw - left, abs(top * -1 - height))
    from: `min(${wd}, calc(${Td} * -1))`,
    // min(abs(left * -1 - width), 100cqh - top)
    to: `min(calc(${Fd} * -1), ${vd})`
  },
  "bottom-right": {
    // min(abs(left * -1 - width), abs(top * -1 - height))
    from: `min(calc(${Fd} * -1), calc(${Td} * -1))`,
    // min(100cqw - left, 100cqh - top)
    to: `min(${wd}, ${vd})`
  }
}, RS = {
  left: {
    from: `${wd} 0`,
    to: `${Fd} 0`
  },
  right: {
    from: `${Fd} 0`,
    to: `${wd} 0`
  },
  top: {
    from: `0 ${vd}`,
    to: `0 ${Td}`
  },
  bottom: {
    from: `0 ${Td}`,
    to: `0 ${vd}`
  }
}, khe = {
  // (width + left) / (100cqw + width)
  left: (t) => {
    let {
      left: e,
      width: n,
      parentWidth: r
    } = t;
    return (n + e) / (r + n || 1);
  },
  // (100cqw - left) / (100cqw + width)
  right: (t) => {
    let {
      left: e,
      width: n,
      parentWidth: r
    } = t;
    return (r - e) / (r + n || 1);
  },
  // (100cqh - top) / (100cqh + height)
  bottom: (t) => {
    let {
      top: e,
      height: n,
      parentHeight: r
    } = t;
    return (r - e) / (r + n || 1);
  },
  // (height + top) / (100cqh + height)
  top: (t) => {
    let {
      top: e,
      height: n,
      parentHeight: r
    } = t;
    return (n + e) / (r + n || 1);
  },
  // min(<left>, <top>)
  "bottom-right": (t) => {
    let {
      left: e,
      top: n,
      width: r,
      height: i,
      parentWidth: s,
      parentHeight: a
    } = t;
    const o = r + e, u = a - n;
    return o < u ? o / (s + r || 1) : u / (a + i || 1);
  },
  // min(<right>, <top>)
  "bottom-left": (t) => {
    let {
      left: e,
      top: n,
      width: r,
      height: i,
      parentWidth: s,
      parentHeight: a
    } = t;
    const o = s - e, u = a - n;
    return o < u ? o / (s + r || 1) : u / (a + i || 1);
  },
  // min(<left>, <bottom>)
  "top-right": (t) => {
    let {
      left: e,
      top: n,
      width: r,
      height: i,
      parentWidth: s,
      parentHeight: a
    } = t;
    const o = s - e, u = i + n;
    return o < u ? o / (s + r || 1) : u / (a + i || 1);
  },
  // min(<right>, <bottom>)
  "top-left": (t) => {
    let {
      left: e,
      top: n,
      width: r,
      height: i,
      parentWidth: s,
      parentHeight: a
    } = t;
    const o = s - e, u = i + n;
    return o < u ? o / (s + r || 1) : u / (a + i || 1);
  }
};
function _he(t) {
  const e = jN[t].from, n = jN[t].to, r = t.startsWith("top") ? 1 : -1, i = -r, s = t.endsWith("left") ? 1 : -1, a = -s;
  return {
    from: `calc(${e} * ${s}) calc(${e} * ${r})`,
    to: `calc(${n} * ${a}) calc(${n} * ${i})`
  };
}
function Nhe(t, e) {
  const {
    direction: n = "right"
  } = t.namedEffect, r = t.duration || 1, i = t.delay || 0, s = br(r, i), [a] = L9(), o = {
    "--motion-left": "0px",
    "--motion-top": "0px",
    "--motion-width": "100%",
    "--motion-height": "100%",
    "--motion-parent-width": "100vw",
    "--motion-parent-height": "100vh"
  };
  let u = 0, l = 0, h = 0, f = 0, m = 0, g = 0;
  return e && (e.measure((A) => {
    if (!A)
      return;
    const {
      width: E,
      height: w
    } = A.getBoundingClientRect(), x = A.offsetParent, N = x?.getBoundingClientRect() || {}, B = lle(A, x);
    u = B.left, l = B.top, h = E, f = w, m = N.width, g = N.height;
  }), e.mutate((A) => {
    A?.style.setProperty("--motion-left", `${u}px`), A?.style.setProperty("--motion-top", `${l}px`), A?.style.setProperty("--motion-width", `${h}px`), A?.style.setProperty("--motion-height", `${f}px`), A?.style.setProperty("--motion-parent-width", `${m}px`), A?.style.setProperty("--motion-parent-height", `${g}px`);
  })), [{
    ...t,
    name: a,
    delay: 0,
    easing: "linear",
    duration: r + i,
    custom: o,
    get keyframes() {
      const A = khe[n]({
        left: u,
        top: l,
        width: h,
        height: f,
        parentWidth: m,
        parentHeight: g
      }) * s;
      let E, w;
      if (n in RS)
        E = RS[n].from, w = RS[n].to;
      else {
        const x = _he(n);
        E = x.from, w = x.to;
      }
      return [{
        offset: 0,
        translate: "0 0"
      }, {
        offset: A,
        translate: w,
        easing: "step-start"
      }, {
        offset: A,
        translate: E
      }, {
        offset: s,
        translate: "0 0"
      }, {
        offset: 1,
        translate: "0 0"
      }];
    }
  }];
}
function L9(t) {
  return ["motion-cross"];
}
const Dhe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: L9,
  web: Nhe
}, Symbol.toStringTag, { value: "Module" }));
function Ihe(t, e) {
  return M9(t);
}
function M9(t, e) {
  const n = t.duration || 1, r = t.delay || 0, i = lr(t.easing || "cubicInOut"), s = br(n, r), [a] = O9(t), o = [{
    offset: 0,
    opacity: 1,
    easing: i
  }, {
    offset: 0.5 * s,
    opacity: 0,
    easing: i
  }, {
    offset: s,
    opacity: 1
  }, {
    offset: 1,
    opacity: 1
  }];
  return [{
    ...t,
    name: a,
    easing: "linear",
    delay: 0,
    duration: n + r,
    keyframes: o
  }];
}
function O9(t) {
  return [`motion-flash-${br(t.duration, t.delay, !0)}`];
}
const Rhe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: O9,
  style: M9,
  web: Ihe
}, Symbol.toStringTag, { value: "Module" })), Phe = {
  soft: "linear",
  medium: "quintInOut",
  hard: "backOut"
}, Lhe = {
  vertical: {
    x: "1",
    y: "0"
  },
  horizontal: {
    x: "0",
    y: "1"
  }
};
function Mhe(t, e) {
  return B9(t, !0);
}
function B9(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "horizontal",
    power: r
  } = t.namedEffect, i = t.duration || 1, s = t.delay || 0, a = br(i, s), [o] = $9(t), u = Lhe[n], l = r && Phe[r] || t.easing || "linear", h = {
    "--motion-rotate-x": u.x,
    "--motion-rotate-y": u.y
  }, f = `rotate3d(${W(h, "--motion-rotate-x", e)}, ${W(h, "--motion-rotate-y", e)}, 0, 0deg)`, m = `rotate3d(${W(h, "--motion-rotate-x", e)}, ${W(h, "--motion-rotate-y", e)}, 0, 360deg)`;
  return [{
    ...t,
    name: o,
    delay: 0,
    easing: "linear",
    duration: i + s,
    custom: h,
    keyframes: [{
      offset: 0,
      transform: `perspective(800px) rotateZ(var(--comp-rotate-z, 0deg)) ${f}`,
      easing: lr(l)
    }, {
      offset: a,
      transform: `perspective(800px) rotateZ(var(--comp-rotate-z, 0deg)) ${m}`
    }, {
      offset: 1,
      transform: `perspective(800px) rotateZ(var(--comp-rotate-z, 0deg)) ${m}`
    }]
  }];
}
function $9(t) {
  return [`motion-flip-${br(t.duration, t.delay, !0)}`];
}
const Ohe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: $9,
  style: B9,
  web: Mhe
}, Symbol.toStringTag, { value: "Module" })), Bhe = {
  soft: 1,
  medium: 2,
  hard: 3
}, $he = {
  top: {
    rotation: {
      x: 1,
      y: 0
    },
    origin: {
      x: 0,
      y: -50
    }
  },
  right: {
    rotation: {
      x: 0,
      y: 1
    },
    origin: {
      x: 50,
      y: 0
    }
  },
  bottom: {
    rotation: {
      x: 1,
      y: 0
    },
    origin: {
      x: 0,
      y: 50
    }
  },
  left: {
    rotation: {
      x: 0,
      y: 1
    },
    origin: {
      x: -50,
      y: 0
    }
  }
}, YN = 15, Hhe = [{
  fold: 1,
  frameFactor: 0.25
}, {
  fold: -0.7,
  frameFactor: 0.5
}, {
  fold: 0.6,
  frameFactor: 0.5
}, {
  fold: -0.3,
  frameFactor: 0.45
}, {
  fold: 0.2,
  frameFactor: 0.4
}, {
  fold: -0.05,
  frameFactor: 0.5
}, {
  fold: 0,
  frameFactor: 0.35
}];
function Uhe(t, e) {
  return H9(t, !0);
}
function H9(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "top",
    power: r,
    angle: i = YN
  } = t.namedEffect, s = t.easing || "cubicInOut", a = t.duration || 1, o = +(t.delay || 0), [u] = U9(t), l = typeof r > "u", {
    rotation: h,
    origin: f
  } = $he[n], {
    x: m,
    y: g
  } = f, A = rp(l ? s : "cubicInOut"), E = l ? i : YN * Bhe[r], w = 3.2 * a + o, x = br(a, w - a);
  let N = 0;
  const B = {
    "--motion-origin-x": `${m}%`,
    "--motion-origin-y": `${g}%`,
    "--motion-rotate-angle": `${E}deg`,
    "--motion-rotate-x": `${h.x}`,
    "--motion-rotate-y": `${h.y}`
  }, P = `rotateZ(var(--comp-rotate-z, 0deg)) translateX(${W(B, "--motion-origin-x", e)}) translateY(${W(B, "--motion-origin-y", e)}) perspective(800px)`, C = `translateX(calc(-1 * ${W(B, "--motion-origin-x", e)})) translateY(calc(-1 * ${W(B, "--motion-origin-y", e)}))`, D = (I) => `${P} rotateX(calc(${W(B, "--motion-rotate-x", e)} * ${I} * ${E}deg)) rotateY(calc(${W(B, "--motion-rotate-y", e)} * ${I} * ${E}deg)) ${C}`, L = o ? Hhe.map((I) => {
    let {
      fold: U,
      frameFactor: j
    } = I;
    const J = N + j * x;
    return N = J, {
      offset: J,
      easing: lr("sineInOut"),
      transform: D(U)
    };
  }) : [{
    offset: 0.25,
    easing: lr(A.inOut),
    transform: D(1)
  }, {
    offset: 0.75,
    easing: lr(A.in),
    transform: D(-1)
  }], k = D(0);
  return [{
    ...t,
    name: u,
    easing: "linear",
    delay: 0,
    duration: o ? w : a,
    custom: B,
    keyframes: [{
      offset: 0,
      easing: lr(A.out),
      transform: k
    }, ...L, {
      offset: 1,
      transform: k
    }]
  }];
}
function U9(t) {
  const e = t.duration || 1, n = +(t.delay || 0);
  if (!n)
    return ["motion-fold"];
  const r = 3.2 * e + n;
  return [`motion-fold-${br(e, r - e, !0)}`];
}
const Ghe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: U9,
  style: H9,
  web: Uhe
}, Symbol.toStringTag, { value: "Module" })), PS = {
  soft: 1,
  medium: 2,
  hard: 4
}, Whe = [{
  keyframe: 24,
  skewY: 7
}, {
  keyframe: 38,
  skewY: -2
}, {
  keyframe: 58,
  skewY: 4
}, {
  keyframe: 80,
  skewY: -2
}, {
  keyframe: 100,
  skewY: 0
}];
function Vhe(t, e) {
  return G9(t, !0);
}
function G9(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    intensity: r = 0.25
  } = t.namedEffect, i = t.duration || 1, s = t.delay || 0, [a] = W9(t), o = br(i, s), u = Ct(0, 1, PS.soft, PS.hard, r), h = {
    "--motion-skew-y": n && PS[n] || u
  }, f = Whe.map((m) => {
    let {
      keyframe: g,
      skewY: A
    } = m;
    return {
      offset: g / 100 * o,
      transform: `rotateZ(var(--comp-rotate-z, 0deg)) skewY(calc(${W(h, "--motion-skew-y", e)} * ${A}deg))`
    };
  });
  return [{
    ...t,
    name: a,
    delay: 0,
    easing: "linear",
    duration: i + s,
    custom: h,
    keyframes: f
  }];
}
function W9(t) {
  return [`motion-jello-${br(t.duration, t.delay, !0)}`];
}
const Khe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: W9,
  style: G9,
  web: Vhe
}, Symbol.toStringTag, { value: "Module" })), zhe = [{
  keyframe: 17,
  translate: 7
}, {
  keyframe: 32,
  translate: 25
}, {
  keyframe: 48,
  translate: 8
}, {
  keyframe: 56,
  translate: 11
}, {
  keyframe: 66,
  translate: 25
}, {
  keyframe: 83,
  translate: 4
}, {
  keyframe: 100,
  translate: 0
}], LS = {
  soft: 1,
  medium: 2,
  hard: 4
}, jhe = {
  top: {
    x: 0,
    y: -1
  },
  bottom: {
    x: 0,
    y: 1
  },
  right: {
    x: 1,
    y: 0
  },
  left: {
    x: -1,
    y: 0
  }
};
function Yhe(t, e) {
  return V9(t, !0);
}
function V9(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    intensity: r = 0.5,
    direction: i = "right"
  } = t.namedEffect, s = t.duration || 1, a = +(t.delay || 0), {
    x: o,
    y: u
  } = jhe[i], l = br(s, a), [h] = K9(t), f = Ct(0, 1, LS.soft, LS.hard, r), m = n ? LS[n] : f, g = {
    "--motion-translate-x": o * m,
    "--motion-translate-y": u * m
  }, A = zhe.map((E) => {
    let {
      keyframe: w,
      translate: x
    } = E;
    const N = `calc(${W(g, "--motion-translate-x", e)} * ${x}px) calc(${W(g, "--motion-translate-y", e)} * ${x}px)`;
    return {
      offset: w / 100 * l,
      translate: N
    };
  });
  return [{
    ...t,
    name: h,
    easing: "linear",
    delay: 0,
    duration: s + a,
    custom: g,
    keyframes: A
  }];
}
function K9(t) {
  return [`motion-poke-${br(t.duration, t.delay, !0)}`];
}
const qhe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: K9,
  style: V9,
  web: Yhe
}, Symbol.toStringTag, { value: "Module" })), MS = {
  soft: 0,
  medium: 0.05,
  hard: 0.1
}, qN = [{
  keyframe: 45,
  scaleX: 1.03,
  scaleY: 0.93
}, {
  keyframe: 56,
  scaleX: 0.9,
  scaleY: 1.03
}, {
  keyframe: 66,
  scaleX: 1.02,
  scaleY: 0.96
}, {
  keyframe: 78,
  scaleX: 0.98,
  scaleY: 1.02
}, {
  keyframe: 89,
  scaleX: 1.005,
  scaleY: 0.9995
}, {
  keyframe: 100,
  scaleX: 1,
  scaleY: 1
}];
function Jhe(t, e) {
  return z9(t, !0);
}
function z9(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    intensity: r = 0.5
  } = t.namedEffect, i = t.duration || 1, s = t.delay || 0, a = br(i, s), [o] = j9(t), u = Ct(0, 1, MS.soft, MS.hard, r), l = typeof n < "u" ? MS[n] : u, h = {}, f = qN.map((m, g) => {
    let {
      keyframe: A,
      scaleX: E,
      scaleY: w
    } = m;
    const x = g === qN.length - 1, N = g % 2 === 0, B = l * (x ? 0 : N ? 1 : -0.5), P = Fo(E + B, 4), C = Fo(w - B, 4), D = `--motion-scale-x-${A}`, L = `--motion-scale-y-${A}`;
    return h[D] = P, h[L] = C, {
      offset: A / 100 * a,
      transform: `rotateZ(var(--comp-rotate-z, 0deg)) scale(${W(h, D, e)}, ${W(h, L, e)})`
    };
  });
  return [{
    ...t,
    name: o,
    easing: "linear",
    delay: 0,
    duration: i + s,
    custom: h,
    keyframes: f
  }];
}
function j9(t) {
  return [`motion-rubber-${br(t.duration, t.delay, !0)}`];
}
const Qhe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: j9,
  style: z9,
  web: Jhe
}, Symbol.toStringTag, { value: "Module" })), OS = {
  soft: 0,
  medium: 0.06,
  hard: 0.12
}, Xhe = [{
  keyframe: 27,
  scale: 0.96
}, {
  keyframe: 45,
  scale: 1
}, {
  keyframe: 72,
  scale: 0.93
}, {
  keyframe: 100,
  scale: 1
}];
function Zhe(t, e) {
  return Y9(t, !0);
}
function Y9(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    intensity: r = 0
  } = t.namedEffect, i = t.duration || 1, s = t.delay || 0, a = br(i, s), [o] = q9(t), u = Ct(0, 1, OS.soft, OS.hard, r), h = {
    "--motion-pulse-offset": typeof n < "u" ? OS[n] : u
  }, f = Xhe.map((m) => {
    let {
      keyframe: g,
      scale: A
    } = m;
    return {
      offset: g / 100 * a,
      transform: `scale(${A < 1 ? `calc(${A} - ${W(h, "--motion-pulse-offset", e)})` : "1"})`
    };
  });
  return a < 1 && f.push({
    offset: 1,
    transform: "scale(1)"
  }), [{
    ...t,
    name: o,
    easing: "linear",
    delay: 0,
    duration: i + s,
    custom: h,
    keyframes: f
  }];
}
function q9(t) {
  return [`motion-pulse-${br(t.duration, t.delay, !0)}`];
}
const ede = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: q9,
  style: Y9,
  web: Zhe
}, Symbol.toStringTag, { value: "Module" })), tde = {
  soft: "linear",
  medium: "quintInOut",
  hard: "backOut"
}, nde = {
  clockwise: -1,
  "counter-clockwise": 1
};
function rde(t, e) {
  return J9(t, !0);
}
function J9(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    direction: r = "clockwise"
  } = t.namedEffect, i = t.duration || 1, s = t.delay || 0, a = br(i, s), [o] = Q9(t), u = n && tde[n] || t.easing || "linear", h = {
    "--motion-rotate-start": `calc(var(--comp-rotate-z, 0deg) + ${(nde[r] > 0 ? 1 : -1) * 360}deg)`
  };
  return [{
    ...t,
    name: o,
    easing: "linear",
    delay: 0,
    duration: i + s,
    custom: h,
    keyframes: [{
      offset: 0,
      easing: lr(u),
      rotate: W(h, "--motion-rotate-start", e)
    }, {
      offset: a,
      rotate: "var(--comp-rotate-z, 0deg)"
    }]
  }];
}
function Q9(t) {
  return [`motion-spin-${br(t.duration, t.delay, !0)}`];
}
const ide = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: Q9,
  style: J9,
  web: rde
}, Symbol.toStringTag, { value: "Module" })), sde = {
  soft: 1,
  medium: 2,
  hard: 3
}, ade = {
  top: {
    x: 0,
    y: -1
  },
  right: {
    x: 1,
    y: 0
  },
  bottom: {
    x: 0,
    y: 1
  },
  left: {
    x: -1,
    y: 0
  }
}, JN = 50, ode = [{
  factor: 1,
  timeFactor: 0.25
}, {
  factor: -1,
  timeFactor: 0.5
}, {
  factor: 0.6,
  timeFactor: 0.5
}, {
  factor: -0.3,
  timeFactor: 0.5
}, {
  factor: 0.2,
  timeFactor: 0.5
}, {
  factor: -0.05,
  timeFactor: 0.5
}, {
  factor: 0,
  timeFactor: 0.4
}];
function ude(t, e) {
  return X9(t, !0);
}
function X9(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    swing: r = 20,
    direction: i = "top"
  } = t.namedEffect, s = t.duration || 1, a = t.delay || 0, o = t.easing || "sineInOut", u = rp(o), [l] = Z9(t), h = typeof n < "u" ? 20 * sde[n] : r, {
    x: f,
    y: m
  } = ade[i], g = 3.55 * s + a, A = br(s, g - s), E = {
    "--motion-swing-deg": `${h}deg`,
    "--motion-trans-x": `${f * JN}%`,
    "--motion-trans-y": `${m * JN}%`,
    "--motion-ease-in": lr(u.in),
    "--motion-ease-inout": lr(u.inOut),
    "--motion-ease-out": lr(u.out)
  }, w = `translate(${W(E, "--motion-trans-x", e)}, ${W(E, "--motion-trans-y", e)})`, x = `translate(calc(${W(E, "--motion-trans-x", e)} * -1), calc(${W(E, "--motion-trans-y", e)} * -1))`;
  let N = 0;
  const B = a ? ode.map((P) => {
    let {
      factor: C,
      timeFactor: D
    } = P;
    const L = N + D * A;
    return N = L, {
      offset: L,
      easing: W(E, "--motion-ease-inout", e),
      transform: `rotate(var(--comp-rotate-z, 0deg)) ${w} rotate(calc(${W(E, "--motion-swing-deg", e)} * ${C})) ${x}`
    };
  }) : [{
    offset: 0.25,
    easing: W(E, "--motion-ease-inout", e),
    transform: `rotate(var(--comp-rotate-z, 0deg)) ${w} rotate(${W(E, "--motion-swing-deg", e)}) ${x}`
  }, {
    offset: 0.75,
    easing: W(E, "--motion-ease-in", e),
    transform: `rotate(var(--comp-rotate-z, 0deg)) ${w} rotate(calc(${W(E, "--motion-swing-deg", e)} * -1)) ${x}`
  }];
  return [{
    ...t,
    name: l,
    easing: "linear",
    delay: 0,
    duration: a ? g : s,
    custom: E,
    keyframes: [{
      offset: 0,
      easing: W(E, "--motion-ease-out", e),
      transform: `rotateZ(var(--comp-rotate-z, 0deg)) ${w} rotate(0deg) ${x}`
    }, ...B, {
      offset: 1,
      transform: `rotateZ(var(--comp-rotate-z, 0deg)) ${w} rotate(0deg) ${x}`
    }]
  }];
}
function Z9(t) {
  return [`motion-swing-${br(t.duration, t.delay, !0)}`];
}
const lde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: Z9,
  style: X9,
  web: ude
}, Symbol.toStringTag, { value: "Module" })), BS = {
  soft: 1,
  medium: 2,
  hard: 4
}, cde = [{
  keyframe: 18,
  transY: -10,
  accRotate: 10
}, {
  keyframe: 35,
  transY: 0,
  accRotate: -18
}, {
  keyframe: 53,
  transY: 0,
  accRotate: 14
}, {
  keyframe: 73,
  transY: 0,
  accRotate: -10
}, {
  keyframe: 100,
  transY: 0,
  accRotate: 4
}];
function hde(t, e) {
  return e8(t, !0);
}
function e8(t, e) {
  e === void 0 && (e = !1);
  const {
    power: n,
    intensity: r = 0.5
  } = t.namedEffect, i = t.duration || 1, s = t.delay || 0, a = br(i, s), [o] = t8(t), u = Ct(0, 1, BS.soft, BS.hard, r), l = n && BS[n] || u;
  let h = 0;
  const f = {
    "--motion-wiggle-factor": l
  }, m = cde.map((g) => {
    let {
      keyframe: A,
      transY: E,
      accRotate: w
    } = g;
    const x = A / 100 * a, N = `calc(var(--comp-rotate-z, 0deg) + ${Fo(h + w * l)}deg)`, B = `${E * l}px`, P = `--motion-rotate-${A}`, C = `--motion-translate-y-${A}`;
    return f[P] = N, f[C] = B, h += w * l, {
      offset: x,
      transform: `rotate(${W(f, P, e)}) translateY(${W(f, C, e)})`
    };
  });
  return [{
    ...t,
    name: o,
    easing: "linear",
    delay: 0,
    duration: i + s,
    custom: f,
    keyframes: m
  }];
}
function t8(t) {
  return [`motion-wiggle-${br(t.duration, t.delay, !0)}`];
}
const dde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: t8,
  style: e8,
  web: hde
}, Symbol.toStringTag, { value: "Module" })), QN = {
  Bounce: whe,
  Breathe: xhe,
  // Blink,
  Cross: Dhe,
  // DVD,
  Flash: Rhe,
  Flip: Ohe,
  Fold: Ghe,
  Jello: Khe,
  Poke: qhe,
  Rubber: Qhe,
  Pulse: ede,
  Spin: ide,
  Swing: lde,
  Wiggle: dde
};
class Do {
  constructor(e, n) {
    pr(this, "target", void 0), pr(this, "options", void 0), pr(this, "currentProgress", void 0), this.target = e, this.options = n || {}, this.currentProgress = {
      x: 0.5,
      y: 0.5,
      v: {
        x: 0,
        y: 0
      },
      active: !0
    }, this.play();
  }
  progress(e) {
    let {
      x: n,
      y: r,
      v: i,
      active: s
    } = e;
    this.currentProgress = {
      x: n,
      y: r,
      v: i,
      active: s
    }, typeof this.options.customEffect == "function" && this.options.customEffect(this.target, this.currentProgress);
  }
  cancel() {
    this.currentProgress = {
      x: 0.5,
      y: 0.5,
      v: {
        x: 0,
        y: 0
      }
    };
  }
  getProgress() {
    return this.currentProgress;
  }
  play() {
    this.options.transition && this.target && (this.target.style.transition = this.options.transition);
  }
}
function fde(t) {
  return (e) => new Do(e, t);
}
const XN = {
  soft: {
    angle: 10,
    easing: "easeOut"
  },
  medium: {
    angle: 50,
    easing: "easeOut"
  },
  hard: {
    angle: 85,
    easing: "easeOut"
  }
};
class mde extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e, i = 0, s = 0;
    const {
      distance: a,
      invert: o,
      angle: u,
      axis: l
    } = this.options;
    l !== "vertical" && (i = Ct(0, 1, -a.value, a.value, n) * o), l !== "horizontal" && (s = Ct(0, 1, -a.value, a.value, r) * o);
    const h = Ct(0, 1, -u, u, n) * o, f = Us(a.type);
    this.target.style.transform = `translateX(${i}${f}) translateY(${s}${f}) rotate(calc(${h}deg + var(--comp-rotate-z, 0deg)))`;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.transition = "";
  }
}
function gde(t) {
  const {
    transitionDuration: e,
    transitionEasing: n
  } = t, {
    power: r,
    inverted: i = !1,
    distance: s = {
      value: 200,
      type: "px"
    },
    angle: a = 30,
    axis: o = "both"
  } = t.namedEffect, u = i ? -1 : 1, l = {
    transition: e ? `transform ${e}ms ${ko(r ? XN[r].easing : n)}` : "",
    invert: u,
    distance: s,
    angle: r ? XN[r].angle : a,
    axis: o
  };
  return (h) => new mde(h, l);
}
const ZN = {
  soft: {
    scale: 1.2,
    easing: "easeOut"
  },
  medium: {
    scale: 1.6,
    easing: "easeOut"
  },
  hard: {
    scale: 2.4,
    easing: "easeOut"
  }
};
class pde extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e;
    const {
      distance: i,
      scale: s,
      invert: a
    } = this.options, o = Ct(0, 1, -i.value, i.value, n) * a, u = Ct(0, 1, -i.value, i.value, r) * a, l = n < 0.5 ? Ct(0, 0.5, s, 1, n) : Ct(0.5, 1, 1, s, n), h = r < 0.5 ? Ct(0, 0.5, s, 1, r) : Ct(0.5, 1, 1, s, r), f = Us(i.type);
    this.target.style.transform = `translateX(${o}${f}) translateY(${u}${f}) scale(${l}, ${h}) rotate(var(--comp-rotate-z, 0deg))`;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.transition = "";
  }
}
function bde(t) {
  const {
    transitionDuration: e,
    transitionEasing: n
  } = t, {
    power: r,
    inverted: i = !1,
    distance: s = {
      value: 200,
      type: "px"
    },
    scale: a = 1.4
  } = t.namedEffect, o = i ? -1 : 1, u = {
    transition: e ? `transform ${e}ms ${ko(r ? ZN[r].easing : n)}` : "",
    invert: o,
    distance: s,
    scale: r ? ZN[r].scale : a
  };
  return (l) => new pde(l, u);
}
const w0 = {
  soft: {
    angle: 0,
    scale: 1,
    easing: "easeOut"
  },
  medium: {
    angle: 25,
    scale: 0.7,
    easing: "easeOut"
  },
  hard: {
    angle: 65,
    scale: 0.25,
    easing: "easeOut"
  }
};
class yde extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e;
    const {
      distance: i,
      angle: s,
      scale: a,
      invert: o,
      blur: u,
      perspective: l
    } = this.options, h = Ct(0, 1, -i.value, i.value, n) * o, f = Ct(0, 1, -i.value, i.value, r) * o, m = n < 0.5 ? Ct(0, 0.5, a, 1, n) : Ct(0.5, 1, 1, a, n), g = r < 0.5 ? Ct(0, 0.5, a, 1, r) : Ct(0.5, 1, 1, a, r), A = Math.min(m, g), E = Ct(0, 1, -s, s, r) * o, w = Ct(0, 1, s, -s, n) * o, x = Us(i.type), N = `perspective(${l}px) translateX(${h}${x}) translateY(${f}${x}) scale(${A}, ${A}) rotateX(${E}deg) rotateY(${w}deg) rotate(var(--comp-rotate-z, 0deg))`, B = nle([0.5, 0.5], [n, r]), C = `blur(${Math.round(Ct(0, 1, 0, u, D4(B)))}px)`;
    this.target.style.transform = N, this.target.style.filter = C;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.filter = "", this.target.style.transition = "";
  }
}
function Ade(t) {
  const {
    transitionDuration: e,
    transitionEasing: n
  } = t, {
    power: r,
    inverted: i = !1,
    distance: s = {
      value: 80,
      type: "px"
    },
    angle: a = 5,
    scale: o = 0.3,
    blur: u = 20,
    perspective: l = 600
  } = t.namedEffect, h = i ? -1 : 1, f = {
    transition: e ? `transform ${e}ms ${ko(r ? w0[r].easing : n)}, filter ${e}ms ${ko(r ? w0[r].easing : n)}` : "",
    distance: s,
    angle: r ? w0[r].angle : a,
    scale: r ? w0[r].scale : o,
    blur: u,
    perspective: l,
    invert: h
  };
  return (m) => new yde(m, f);
}
const Ede = {
  soft: "linear",
  medium: "easeOut",
  hard: "hardBackOut"
};
class Sde extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e;
    const {
      invert: i,
      distance: s,
      axis: a
    } = this.options;
    let o = 0, u = 0;
    (a === "both" || a === "horizontal") && (o = Ct(0, 1, -s.value, s.value, n) * i), (a === "both" || a === "vertical") && (u = Ct(0, 1, -s.value, s.value, r) * i);
    const l = Us(s.type);
    this.target.style.transform = `translateX(${o}${l}) translateY(${u}${l}) rotate(var(--comp-rotate-z, 0deg))`;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.transition = "";
  }
}
function n8(t) {
  const {
    transitionDuration: e,
    transitionEasing: n
  } = t, {
    power: r,
    inverted: i = !1,
    distance: s = {
      value: 200,
      type: "px"
    },
    axis: a = "both"
  } = t.namedEffect, o = i ? -1 : 1, u = {
    transition: e ? `transform ${e}ms ${ko(r ? Ede[r] : n)}` : "",
    invert: o,
    distance: s,
    axis: a
  };
  return (l) => new Sde(l, u);
}
function wde(t) {
  const {
    distance: e = {
      value: 80,
      type: "px"
    }
  } = t.namedEffect, {
    transitionEasing: n = "elastic"
  } = t;
  return n8({
    ...t,
    transitionEasing: n,
    namedEffect: {
      ...t.namedEffect,
      distance: e
    }
  });
}
const eD = {
  down: {
    soft: {
      scale: 0.85,
      easing: "easeOut"
    },
    medium: {
      scale: 0.5,
      easing: "easeOut"
    },
    hard: {
      scale: 0,
      easing: "easeOut"
    }
  },
  up: {
    soft: {
      scale: 1.2,
      easing: "easeOut"
    },
    medium: {
      scale: 1.6,
      easing: "easeOut"
    },
    hard: {
      scale: 2.4,
      easing: "easeOut"
    }
  }
};
class Fde extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e;
    const {
      distance: i,
      scale: s,
      invert: a,
      axis: o
    } = this.options;
    let u = 0, l = 0, h = 1, f = 1;
    (o === "both" || o === "horizontal") && (u = Ct(0, 1, -i.value, i.value, n) * a, h = n < 0.5 ? Ct(0, 0.5, s, 1, n) : Ct(0.5, 1, 1, s, n)), (o === "both" || o === "vertical") && (l = Ct(0, 1, -i.value, i.value, r) * a, f = r < 0.5 ? Ct(0, 0.5, s, 1, r) : Ct(0.5, 1, 1, s, r));
    const m = s < 1 ? Math.min(h, f) : Math.max(h, f), g = Us(i.type);
    this.target.style.transform = `translateX(${u}${g}) translateY(${l}${g}) scale(${m}) rotate(var(--comp-rotate-z, 0deg))`;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.transition = "";
  }
}
function Tde(t) {
  const {
    transitionDuration: e,
    transitionEasing: n
  } = t, {
    power: r,
    scaleDirection: i = "down",
    inverted: s = !1,
    distance: a = {
      value: 80,
      type: "px"
    },
    axis: o = "both",
    scale: u = 1.4
  } = t.namedEffect, l = s ? -1 : 1, h = {
    transition: e ? `transform ${e}ms ${ko(r ? eD[i][r].easing : n)}` : "",
    invert: l,
    distance: a,
    axis: o,
    scale: r ? eD[i][r].scale : u
  };
  return (f) => new Fde(f, h);
}
const tD = {
  soft: {
    angle: 10,
    easing: "easeOut"
  },
  medium: {
    angle: 20,
    easing: "easeOut"
  },
  hard: {
    angle: 45,
    easing: "easeOut"
  }
};
class vde extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e, i = 0, s = 0, a = 0, o = 0;
    const {
      distance: u,
      angle: l,
      axis: h,
      invert: f
    } = this.options;
    h !== "vertical" && (i = Ct(0, 1, -u.value, u.value, n) * f, a = Ct(0, 1, l, -l, n) * f), h !== "horizontal" && (s = Ct(0, 1, -u.value, u.value, r) * f, o = Ct(0, 1, l, -l, r) * f), h === "both" && (a *= Ct(0, 1, 1, -1, AT(r)), o *= Ct(0, 1, 1, -1, AT(n)));
    const m = Us(u.type), g = `translateX(${i}${m}) translateY(${s}${m}) skew(${a}deg, ${o}deg) rotate(var(--comp-rotate-z, 0deg))`;
    this.target.style.transform = g;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.transition = "";
  }
}
function xde(t) {
  const {
    transitionDuration: e,
    transitionEasing: n
  } = t, {
    power: r,
    inverted: i = !1,
    distance: s = {
      value: 200,
      type: "px"
    },
    angle: a = 25,
    axis: o = "both"
  } = t.namedEffect, u = i ? -1 : 1, l = {
    transition: e ? `transform ${e}ms ${ko(r ? tD[r].easing : n)}` : "",
    invert: u,
    distance: s,
    angle: r ? tD[r].angle : a,
    axis: o
  };
  return (h) => new vde(h, l);
}
class Cde extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e;
    const {
      invert: i,
      axis: s
    } = this.options, a = rle([0.5, 0.5], [s === "vertical" ? 0 : n, s === "horizontal" ? 0 : r], 90) * i;
    this.target.style.transform = `rotate(calc(${a}deg + var(--comp-rotate-z, 0deg)))`;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.transition = "";
  }
}
function kde(t) {
  const {
    transitionDuration: e,
    transitionEasing: n = "linear"
  } = t, {
    inverted: r = !1,
    axis: i = "both"
  } = t.namedEffect, s = r ? -1 : 1, a = {
    transition: e ? `transform ${e}ms ${ko(n)}` : "",
    invert: s,
    axis: i
  };
  return (o) => new Cde(o, a);
}
const $S = {
  soft: {
    angle: 25,
    perspective: 1e3,
    easing: "easeOut"
  },
  medium: {
    angle: 50,
    perspective: 700,
    easing: "easeOut"
  },
  hard: {
    angle: 85,
    perspective: 300,
    easing: "easeOut"
  }
}, _de = {
  top: [0, -50],
  bottom: [0, 50],
  right: [50, 0],
  left: [-50, 0],
  "center-horizontal": [0, 0],
  "center-vertical": [0, 0]
};
class Nde extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e, i = "rotateX", s = r, a = -1;
    const {
      pivotAxis: o,
      angle: u,
      invert: l,
      perspective: h
    } = this.options;
    (o === "center-horizontal" || o === "right" || o === "left") && (i = "rotateY", s = n, a = 1);
    const f = Ct(0, 1, -u, u, s) * a * l, [m, g] = _de[o], A = `perspective(${h}px) translateX(${m}%) translateY(${g}%) ${i}(${f}deg) translateX(${-m}%) translateY(${-g}%) rotate(var(--comp-rotate-z, 0deg))`;
    this.target.style.transform = A;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.transition = "";
  }
}
function Dde(t) {
  const {
    transitionDuration: e,
    transitionEasing: n
  } = t, {
    power: r,
    inverted: i = !1,
    angle: s = 5,
    perspective: a = 800,
    pivotAxis: o = "center-horizontal"
  } = t.namedEffect, u = i ? -1 : 1, l = {
    transition: e ? `transform ${e}ms ${ko(r ? $S[r].easing : n)}` : "",
    invert: u,
    angle: r ? $S[r].angle : s,
    perspective: r ? $S[r].perspective : a,
    pivotAxis: o
  };
  return (h) => new Nde(h, l);
}
const HS = {
  soft: {
    angle: 25,
    perspective: 1e3,
    easing: "easeOut"
  },
  medium: {
    angle: 50,
    perspective: 500,
    easing: "easeOut"
  },
  hard: {
    angle: 85,
    perspective: 200,
    easing: "easeOut"
  }
};
class Ide extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e;
    const {
      invert: i,
      angle: s,
      perspective: a
    } = this.options, o = Ct(0, 1, s, -s, r) * i, u = Ct(0, 1, -s, s, n) * i;
    this.target.style.transform = `perspective(${a}px) rotateX(${o}deg) rotateY(${u}deg) rotate(var(--comp-rotate-z, 0deg))`;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.transition = "";
  }
}
function Rde(t) {
  const {
    transitionDuration: e,
    transitionEasing: n
  } = t, {
    power: r,
    inverted: i = !1,
    angle: s = 5,
    perspective: a = 800
  } = t.namedEffect, o = i ? -1 : 1, u = {
    transition: e ? `transform ${e}ms ${ko(r ? HS[r].easing : n)}` : "",
    invert: o,
    angle: r ? HS[r].angle : s,
    perspective: r ? HS[r].perspective : a
  };
  return (l) => new Ide(l, u);
}
const US = {
  soft: {
    angle: 25,
    perspective: 1e3,
    easing: "easeOut"
  },
  medium: {
    angle: 50,
    perspective: 500,
    easing: "easeOut"
  },
  hard: {
    angle: 85,
    perspective: 333,
    easing: "easeOut"
  }
};
class Pde extends Do {
  progress(e) {
    let {
      x: n,
      y: r
    } = e;
    const {
      invert: i,
      distance: s,
      angle: a,
      axis: o,
      perspective: u
    } = this.options;
    let l = 0, h = 0, f = 0, m = 0;
    (o === "both" || o === "horizontal") && (l = Ct(0, 1, -s.value, s.value, n), m = Ct(0, 1, -a, a, n) * i), (o === "both" || o === "vertical") && (h = Ct(0, 1, -s.value, s.value, r), f = Ct(0, 1, a, -a, r) * i);
    const g = Us(s.type);
    this.target.style.transform = `perspective(${u}px) translateX(${l}${g}) translateY(${h}${g}) rotateX(${f}deg) rotateY(${m}deg) rotate(var(--comp-rotate-z, 0deg))`;
  }
  cancel() {
    this.target.style.transform = "", this.target.style.transition = "";
  }
}
function Lde(t) {
  const {
    transitionDuration: e,
    transitionEasing: n
  } = t, {
    power: r,
    inverted: i = !1,
    distance: s = {
      value: 200,
      type: "px"
    },
    angle: a = 5,
    axis: o = "both",
    perspective: u = 800
  } = t.namedEffect, l = i ? -1 : 1, h = {
    transition: e ? `transform ${e}ms ${ko(r ? US[r].easing : n)}` : "",
    invert: l,
    distance: s,
    axis: o,
    angle: r ? US[r].angle : a,
    perspective: r ? US[r].perspective : u
  };
  return (f) => new Pde(f, h);
}
const nD = {
  AiryMouse: gde,
  BlobMouse: bde,
  BlurMouse: Ade,
  BounceMouse: wde,
  CustomMouse: fde,
  ScaleMouse: Tde,
  SkewMouse: xde,
  SpinMouse: kde,
  SwivelMouse: Dde,
  Tilt3DMouse: Rde,
  Track3DMouse: Lde,
  TrackMouse: n8
};
function Io(t, e, n) {
  e.measure((r) => {
    r && (t["--motion-comp-height"] = `${r.offsetHeight}px`, t["--motion-comp-half-height"] && (t["--motion-comp-half-height"] = `${Math.round(0.5 * r.offsetHeight)}px`));
  }), e.mutate((r) => {
    r?.style.setProperty("--motion-comp-height", t["--motion-comp-height"]), t["--motion-comp-half-height"] && r?.style.setProperty("--motion-comp-half-height", t["--motion-comp-half-height"]);
  });
}
const Mde = () => window.document.getElementById("masterPage"), Ode = () => {
  const t = window.document.getElementById("WIX_ADS");
  return t ? t.offsetHeight : 0;
}, Bde = () => {
  const t = Mde();
  return t ? t.offsetHeight + Ode() : 0;
};
function $de(t, e, n) {
  e.measure(() => {
    t["--motion-site-height"] = `${Bde()}px`;
  }), e.mutate((r) => {
    r?.style.setProperty("--motion-site-height", t["--motion-site-height"]);
  });
}
function r8(t, e) {
  return t > e ? 0 : 1 / (1 - t / e);
}
function i8(t) {
  return ["motion-bgCloseUpOpacity", "motion-bgCloseUpZoom"];
}
function s8(t, e) {
  const n = {
    "--motion-comp-height": "0px",
    "--motion-comp-half-height": "0px"
  };
  return e && Io(n, e), n;
}
function Hde(t, e) {
  return t.measures = s8(t, e), a8(t, !0);
}
function a8(t, e) {
  e === void 0 && (e = !1);
  const n = "linear", {
    scale: r = 80
  } = t.namedEffect, i = {
    "--motion-trans-z": `${r}px`
  }, [s, a] = i8();
  return [{
    ...t,
    name: s,
    easing: n,
    part: "BG_LAYER",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get startOffsetAdd() {
      return `calc(50vh + ${W(t.measures || {}, "--motion-comp-half-height", e)})`;
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100vh + ${W(t.measures || {}, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      opacity: 1
    }, {
      opacity: 0
    }]
  }, {
    ...t,
    name: a,
    easing: n,
    part: "BG_MEDIA",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100vh + ${W(t.measures || {}, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      transform: "perspective(100px) translateZ(0px)"
    }, {
      transform: `perspective(100px) translateZ(${W(i, "--motion-trans-z", e)})`
    }]
  }];
}
const Ude = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: i8,
  prepare: s8,
  style: a8,
  web: Hde
}, Symbol.toStringTag, { value: "Module" }));
function o8(t) {
  return ["motion-bgFade"];
}
function u8(t, e) {
  const n = {
    "--motion-comp-height": "0px",
    "--motion-comp-half-height": "0px"
  };
  return e && Io(n, e), n;
}
function Gde(t, e) {
  return t.measures = u8(t, e), l8(t, !0);
}
function l8(t, e) {
  e === void 0 && (e = !1);
  const {
    range: n = "in"
  } = t.namedEffect, r = n === "out", i = r ? "sineOut" : "sineIn", s = {
    "--motion-bg-fade-from": r ? 1 : 0,
    "--motion-bg-fade-to": r ? 0 : 1
  }, [a] = o8();
  return [{
    ...t,
    name: a,
    part: "BG_LAYER",
    easing: i,
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    startOffsetAdd: r ? "100vh" : "0px",
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return r ? `calc(100vh + ${W(t.measures || {}, "--motion-comp-height", e)})` : `calc(50vh + ${W(t.measures || {}, "--motion-comp-half-height", e)})`;
    },
    keyframes: [{
      opacity: W(s, "--motion-bg-fade-from", e)
    }, {
      opacity: W(s, "--motion-bg-fade-to", e)
    }]
  }];
}
const Wde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: o8,
  prepare: u8,
  style: l8,
  web: Gde
}, Symbol.toStringTag, { value: "Module" }));
function c8(t) {
  return ["motion-bgFadeBackOpacity", "motion-bgFadeBackScale"];
}
function h8(t, e) {
  const n = {
    "--motion-comp-height": "0px",
    "--motion-comp-half-height": "0px"
  };
  return e && Io(n, e), n;
}
function Vde(t, e) {
  return t.measures = h8(t, e), d8(t, !0);
}
function d8(t, e) {
  e === void 0 && (e = !1);
  const n = "sineOut", {
    scale: r = 0.7
  } = t.namedEffect, i = {
    "--motion-scale": r
  }, [s, a] = c8();
  return [{
    ...t,
    name: s,
    easing: "linear",
    part: "BG_LAYER",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    startOffsetAdd: "100vh",
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100vh + ${W(t.measures || {}, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      opacity: 1
    }, {
      opacity: 0
    }]
  }, {
    ...t,
    name: a,
    easing: n,
    part: "BG_LAYER",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    startOffsetAdd: "100vh",
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100vh + ${W(t.measures || {}, "--motion-comp-half-height", e)})`;
    },
    keyframes: [{
      scale: 1
    }, {
      scale: W(i, "--motion-scale", e)
    }]
  }];
}
const Kde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: c8,
  prepare: h8,
  style: d8,
  web: Vde
}, Symbol.toStringTag, { value: "Module" })), GS = 100;
function f8(t) {
  return ["motion-bgFake3DParallax", "motion-bgFake3DStretch", "motion-bgFake3DZoom"];
}
function m8(t, e) {
  const n = {
    "--motion-comp-height": "0px"
  };
  return e && Io(n, e), n;
}
function zde(t, e) {
  return t.measures = m8(t, e), g8(t, !0);
}
function g8(t, e) {
  e === void 0 && (e = !1);
  const {
    stretch: n = 1.3,
    zoom: r = 100 / 6
  } = t.namedEffect, i = r8(r, GS), s = {
    "--motion-scale-y": n,
    "--motion-trans-z": `${Fo(r)}px`,
    "--motion-trans-y-factor": Fo(-0.1 * (2 - i))
  }, [a, o, u] = f8(), {
    measures: l = {
      "--motion-comp-height": "0px"
    }
  } = t;
  return [{
    ...t,
    name: a,
    part: "BG_IMG",
    easing: "sineOut",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100svh + ${W(l, "--motion-comp-height", e)})`;
    },
    get keyframes() {
      return [{
        transform: "translateY(10svh)"
      }, {
        transform: `translateY(calc(${W(s, "--motion-trans-y-factor", e)} * ${W(l, "--motion-comp-height", !1, l["--motion-comp-height"])}))`
      }];
    }
  }, {
    ...t,
    name: o,
    part: "BG_IMG",
    easing: "linear",
    composite: "add",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100svh + ${W(l, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      transform: `scaleY(${W(s, "--motion-scale-y", e)})`
    }, {
      transform: "scaleY(1)"
    }]
  }, {
    ...t,
    name: u,
    part: "BG_IMG",
    easing: "sineIn",
    composite: "add",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100svh + ${W(l, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      transform: `perspective(${GS}px) translateZ(0px)`
    }, {
      transform: `perspective(${GS}px) translateZ(${W(s, "--motion-trans-z", e)})`
    }]
  }];
}
const jde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: f8,
  prepare: m8,
  style: g8,
  web: zde
}, Symbol.toStringTag, { value: "Module" }));
function p8(t) {
  return ["motion-bgPan"];
}
function b8(t, e) {
  const n = {
    "--motion-comp-height": "0px"
  };
  return e && Io(n, e), n;
}
function Yde(t, e) {
  return t.measures = b8(t, e), y8(t, !0);
}
function y8(t, e) {
  e === void 0 && (e = !1);
  const {
    direction: n = "left",
    speed: r = 0.2
  } = t.namedEffect, i = 50 * r / (1 + r) | 0, s = {
    "--motion-trans-x": n === "left" ? `${i}%` : `${-i}%`
  }, [a] = p8();
  return [{
    ...t,
    name: a,
    part: "BG_MEDIA",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100vh + ${W(t.measures || {}, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      transform: `translateX(${W(s, "--motion-trans-x", e)})`
    }, {
      transform: `translateX(calc(-1 * ${W(s, "--motion-trans-x", e)}))`
    }]
  }];
}
const qde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: p8,
  prepare: b8,
  style: y8,
  web: Yde
}, Symbol.toStringTag, { value: "Module" }));
function A8(t) {
  return ["motion-bgParallax"];
}
function E8(t, e) {
  const n = {
    "--motion-comp-height": "0px"
  };
  return e && Io(n, e), n;
}
function Jde(t, e) {
  return t.measures = E8(t, e), S8(t, !0);
}
function S8(t, e) {
  e === void 0 && (e = !1);
  const {
    speed: n = 0.2
  } = t.namedEffect, r = {
    "--motion-parallax-speed": n
  }, [i] = A8();
  return [{
    ...t,
    name: i,
    part: "BG_MEDIA",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100svh + ${W(t.measures || {}, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      transform: `translateY(calc(${W(r, "--motion-parallax-speed", e)} * 100svh))`
    }, {
      transform: `translateY(calc((200lvh - 100%) * ${W(r, "--motion-parallax-speed", e)}))`
    }]
  }];
}
const Qde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: A8,
  prepare: E8,
  style: S8,
  web: Jde
}, Symbol.toStringTag, { value: "Module" }));
function w8(t) {
  return ["motion-bgPullBack"];
}
function F8(t, e) {
  const n = {
    "--motion-comp-height": "0px"
  };
  return e && Io(n, e), n;
}
function Xde(t, e) {
  return t.measures = F8(t, e), T8(t, !0);
}
function T8(t, e) {
  e === void 0 && (e = !1);
  const n = "linear", {
    scale: r = 50
  } = t.namedEffect, i = {
    "--motion-trans-z": `${r}px`,
    // TODO: (ameerf) - remove and use only scale once CSS round is widely available
    "--motion-trans-y": `-${r / 3 | 0}%`
  }, [s] = w8();
  return [{
    ...t,
    name: s,
    easing: n,
    part: "BG_MEDIA",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `${W(t.measures || {}, "--motion-comp-height", e)}`;
    },
    keyframes: [{
      transform: `perspective(100px) translate3d(0px, ${W(i, "--motion-trans-y", e)}, ${W(i, "--motion-trans-z", e)})`
    }, {
      transform: "perspective(100px) translate3d(0px, 0px, 0px)"
    }]
  }];
}
const Zde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: w8,
  prepare: F8,
  style: T8,
  web: Xde
}, Symbol.toStringTag, { value: "Module" }));
function efe(t) {
  return [];
}
function v8(t, e) {
  const n = {
    "--motion-comp-height": "0px"
  };
  return e && Io(n, e), n;
}
function tfe(t, e) {
  return v8(t, e), x8();
}
function x8(t) {
  return [];
}
const nfe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: efe,
  prepare: v8,
  style: x8,
  web: tfe
}, Symbol.toStringTag, { value: "Module" }));
function C8(t) {
  return ["motion-bgRotate"];
}
function rfe(t) {
  return k8(t, !0);
}
function k8(t, e) {
  e === void 0 && (e = !1);
  const n = "sineOut", {
    angle: r = 22,
    direction: i = "counter-clockwise"
  } = t.namedEffect, s = {
    "--motion-rot-from": `${i === "counter-clockwise" ? r : -r}deg`
  }, [a] = C8();
  return [{
    ...t,
    name: a,
    easing: n,
    part: "BG_MEDIA",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffsetAdd: "100vh",
    keyframes: [{
      transform: `rotate(${W(s, "--motion-rot-from", e)})`
    }, {
      transform: "rotate(0deg)"
    }]
  }];
}
const ife = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: C8,
  style: k8,
  web: rfe
}, Symbol.toStringTag, { value: "Module" }));
function _8(t) {
  return ["motion-bgSkew"];
}
function N8(t, e) {
  const n = {
    "--motion-comp-height": "0px"
  };
  return e && Io(n, e), n;
}
function sfe(t, e) {
  return t.measures = N8(t, e), D8(t, !0);
}
function D8(t, e) {
  e === void 0 && (e = !1);
  const {
    angle: n = 20,
    direction: r = "counter-clockwise"
  } = t.namedEffect, i = {
    "--motion-skew": `${r === "counter-clockwise" ? n : -n}deg`
  }, [s] = _8();
  return [{
    ...t,
    name: s,
    part: "BG_MEDIA",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100vh + ${W(t.measures || {}, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      transform: `skewY(${W(i, "--motion-skew", e)})`
    }, {
      transform: `skewY(calc(-1 * ${W(i, "--motion-skew", e)}))`
    }]
  }];
}
const afe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: _8,
  prepare: N8,
  style: D8,
  web: sfe
}, Symbol.toStringTag, { value: "Module" })), F0 = 100, ofe = 40, ufe = 0.375, lfe = {
  in: {
    easing: "sineIn",
    fromY: "20svh"
  },
  out: {
    easing: "sineInOut",
    fromY: "0px"
  }
};
function I8(t) {
  const {
    direction: e = "in"
  } = t.namedEffect, n = ["motion-bgZoomMedia", "motion-bgZoomImg"];
  return e === "in" && n.splice(1, 0, "motion-bgZoomParallax"), n;
}
function R8(t, e) {
  const n = {
    "--motion-comp-height": "0px"
  };
  return e && Io(n, e), n;
}
function cfe(t, e) {
  return t.measures = R8(t, e), P8(t, !0);
}
function P8(t, e) {
  e === void 0 && (e = !1);
  let {
    direction: n = "in",
    zoom: r = ofe
  } = t.namedEffect;
  const i = n === "in";
  i || (n = "out", r *= ufe);
  const {
    easing: s,
    fromY: a
  } = lfe[n], o = i ? 0 : r / 1.3, u = i ? r : -r, l = Fo(r8(u, F0)), h = {
    "--motion-zoom-over-pers": 0.5 * r / F0,
    "--motion-scale-to": l,
    "--motion-trans-y-from": a,
    "--motion-trans-z-from": `${Fo(o)}px`,
    "--motion-trans-z-to": `${Fo(u)}px`
  }, {
    measures: f = {
      "--motion-comp-height": "0px"
    }
  } = t, m = [{
    ...t,
    part: "BG_MEDIA",
    easing: "linear",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    keyframes: [{
      transform: "translate3d(0, 0, 0)"
    }, {
      transform: "translate3d(0, 0, 0)"
    }]
  }, {
    ...t,
    easing: s,
    part: "BG_IMG",
    composite: i ? "add" : "replace",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100svh + ${W(f, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      transform: `perspective(${F0}px) translateZ(${W(h, "--motion-trans-z-from", e)})`
    }, {
      transform: `perspective(${F0}px) translateZ(${W(h, "--motion-trans-z-to", e)})`
    }]
  }];
  i && m.splice(1, 0, {
    ...t,
    part: "BG_IMG",
    easing: "linear",
    startOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100svh + ${W(f, "--motion-comp-height", e)})`;
    },
    get keyframes() {
      return [{
        transform: `translateY(${W(h, "--motion-trans-y-from", e)})`
      }, {
        transform: `translateY(calc(${W(h, "--motion-scale-to", e)} * (-0.2 * ${W(f, "--motion-comp-height", !1, f["--motion-comp-height"])} + ${W(h, "--motion-zoom-over-pers", e)} * max(0px, 100lvh - ${W(f, "--motion-comp-height", !1, f["--motion-comp-height"])}))))`
      }];
    }
  });
  const g = I8(t);
  return m.forEach((A, E) => {
    A.name = g[E];
  }), m;
}
const hfe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: I8,
  prepare: R8,
  style: P8,
  web: cfe
}, Symbol.toStringTag, { value: "Module" }));
function L8(t) {
  return ["motion-imageParallax"];
}
function M8(t, e) {
  const n = {
    "--motion-comp-height": "0px",
    "--motion-site-height": "0"
  }, {
    isPage: r = !1
  } = t.namedEffect;
  return e && (r ? $de(n, e) : Io(n, e)), n;
}
function dfe(t, e) {
  return t.measures = M8(t, e), O8(t, !0);
}
function O8(t, e) {
  e === void 0 && (e = !1);
  const {
    speed: n = 1.5,
    reverse: r = !1,
    isPage: i = !1
  } = t.namedEffect;
  let s = -100 * (n - 1);
  i || (s = s / n);
  let a = 0;
  r && ([s, a] = [a, s]);
  const o = {
    "--motion-trans-y-from": `${s | 0}%`,
    "--motion-trans-y-to": `${a | 0}%`
  }, [u] = L8();
  return [{
    ...t,
    name: u,
    part: "BG_MEDIA",
    startOffset: {
      name: i ? "contain" : "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    endOffset: {
      name: "cover",
      offset: {
        type: "percentage",
        value: 0
      }
    },
    get endOffsetAdd() {
      return i ? `${W(t.measures || {}, "--motion-site-height", e)}` : `calc(100vh + ${W(t.measures || {}, "--motion-comp-height", e)})`;
    },
    keyframes: [{
      transform: `translateY(${W(o, "--motion-trans-y-from", e)})`
    }, {
      transform: `translateY(${W(o, "--motion-trans-y-to", e)})`
    }]
  }];
}
const ffe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNames: L8,
  prepare: M8,
  style: O8,
  web: dfe
}, Symbol.toStringTag, { value: "Module" })), rD = {
  BgCloseUp: Ude,
  BgFade: Wde,
  BgFadeBack: Kde,
  BgFake3D: jde,
  BgPan: qde,
  BgParallax: Qde,
  BgPullBack: Zde,
  BgReveal: nfe,
  BgRotate: ife,
  BgSkew: afe,
  BgZoom: hfe,
  ImageParallax: ffe
};
function cf(t, e) {
  return t ? document.getElementById(t) : null;
}
function mfe(t, e) {
  return t != null && t.matches(`[data-motion-part~="${e}"]`) ? t : t?.querySelector(`[data-motion-part~="${e}"]`);
}
function gfe(t) {
  const e = t.alternate ? "alternate" : "";
  return t.reversed ? `${e ? `${e}-` : ""}reverse` : e || "normal";
}
function WS(t) {
  return `${t.value}${Us(t.type)}`;
}
function iD(t, e, n) {
  return `${t.name || "cover"} ${n && t.offset.type !== "percentage" ? `calc(100% + ${WS(t.offset)}${e ? ` + ${e}` : ""})` : e ? `calc(${WS(t.offset)} + ${e})` : WS(t.offset)}`;
}
function pfe(t) {
  return {
    start: iD(t.startOffset, t.startOffsetAdd),
    end: iD(t.endOffset, t.endOffsetAdd, !0)
  };
}
function B8(t) {
  return (e) => Ni.measure(() => e(t));
}
function $8(t) {
  return (e) => Ni.mutate(() => e(t));
}
function i1(t) {
  if (t.namedEffect) {
    const e = t.namedEffect.type;
    if (e in BN)
      return BN[e];
    if (e in zN)
      return zN[e];
    if (e in QN)
      return QN[e];
    if (e in nD)
      return nD[e];
    if (e in rD)
      return rD[e];
  } else if (t.keyframeEffect) {
    const e = (r) => {
      const {
        name: i,
        keyframes: s
      } = r.keyframeEffect;
      return [{
        ...r,
        name: i,
        keyframes: s
      }];
    };
    return {
      web: e,
      style: e,
      getNames: (r) => {
        const {
          effectId: i
        } = r, {
          name: s
        } = r.keyframeEffect, a = s || i;
        return a ? [a] : [];
      }
    };
  } else if (t.customEffect)
    return (e) => [{
      ...e,
      keyframes: []
    }];
  return null;
}
function bfe(t, e, n) {
  return t.map((r, i) => {
    const s = {
      fill: r.fill,
      easing: lr(r.easing),
      iterations: r.iterations === 0 ? 1 / 0 : r.iterations || 1,
      composite: r.composite,
      direction: gfe(r)
    };
    return H8(e) ? (s.duration = r.duration, s.delay = r.delay || 0) : window.ViewTimeline ? s.duration = "auto" : (s.duration = 99.99, s.delay = 0.01), {
      effect: r,
      options: s,
      id: n && `${n}-${i + 1}`,
      part: r.part
    };
  });
}
function H8(t) {
  return !t || t.trigger !== "pointer-move" && t.trigger !== "view-progress";
}
function sD(t, e, n, r, i) {
  if (t) {
    if (H8(r) && (e.duration = e.duration || 1, i != null && i.reducedMotion))
      if (e.iterations === 1 || e.iterations == null)
        e = {
          ...e,
          duration: 1
        };
      else
        return [];
    let s;
    return n instanceof HTMLElement && (s = {
      measure: B8(n),
      mutate: $8(n)
    }), t.web ? t.web(e, s, i) : t(e, s, i);
  }
  return [];
}
function FC(t, e, n, r, i) {
  const s = t instanceof HTMLElement ? t : cf(t);
  if (n?.trigger === "pointer-move") {
    let m = e;
    e.customEffect && (m = {
      ...e,
      namedEffect: {
        id: "",
        type: "CustomMouse"
      }
    });
    const g = i1(m), A = sD(g, e, s, n, r);
    return typeof A == "function" ? A(s) : null;
  }
  const a = i1(e), o = sD(a, e, s, n, r);
  if (!o)
    return null;
  const u = bfe(o, n, e.effectId);
  let l;
  const h = n?.trigger === "view-progress";
  h && window.ViewTimeline && (l = new ViewTimeline({
    subject: n.element || cf(n.componentId)
  }));
  const f = u.map((m) => {
    let {
      effect: g,
      options: A,
      id: E,
      part: w
    } = m;
    const x = w ? mfe(s, w) : s, N = new KeyframeEffect(x || null, [], A);
    Ni.mutate(() => {
      "timing" in g && N.updateTiming(g.timing), N.setKeyframes(g.keyframes);
    });
    const B = h && l ? {
      timeline: l
    } : {}, P = typeof g.customEffect == "function" ? new hle(g.customEffect, x || null, A, B) : new Animation(N, B.timeline);
    if (h)
      if (l)
        Ni.mutate(() => {
          const {
            start: C,
            end: D
          } = pfe(g);
          P.rangeStart = C, P.rangeEnd = D, P.play();
        });
      else {
        const {
          startOffset: C,
          endOffset: D
        } = e;
        Ni.mutate(() => {
          var L, k;
          const I = g.startOffset || C, U = g.endOffset || D;
          Object.assign(P, {
            start: {
              name: I.name,
              offset: (L = I.offset) == null ? void 0 : L.value,
              add: g.startOffsetAdd
            },
            end: {
              name: U.name,
              offset: (k = U.offset) == null ? void 0 : k.value,
              add: g.endOffsetAdd
            }
          });
        });
      }
    return E && (P.id = E), P;
  });
  return new bC(f, {
    ...e,
    trigger: {
      ...n || {}
    },
    // make sure the group is ready after all animation targets are measured and mutated
    measured: new Promise((m) => Ni.mutate(m))
  });
}
function yfe(t, e, n) {
  const r = i1(e), i = t instanceof HTMLElement ? t : cf(t);
  if (r && r.prepare && i) {
    const s = {
      measure: B8(i),
      mutate: $8(i)
    };
    r.prepare(e, s);
  }
  n && Ni.mutate(n);
}
function Afe(t, e) {
  const n = i1(e);
  if (!n)
    return null;
  if (!n.style)
    return e.effectId && t ? Efe(t, e.effectId) : null;
  const r = n.getNames(e), i = typeof t == "string" ? cf(t) : t, s = i?.getAnimations(), a = s?.map((u) => u.animationName) || [], o = [];
  return r.forEach((u) => {
    a.includes(u) && o.push(s?.find((l) => l.animationName === u));
  }), o != null && o.length ? new bC(o) : null;
}
function Efe(t, e) {
  const n = typeof t == "string" ? cf(t) : t, r = n?.getAnimations().filter((i) => {
    const s = i.id || i.animationName;
    return s ? s.startsWith(e) : !0;
  });
  return r != null && r.length ? new bC(r) : null;
}
function U8(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    disabled: i,
    allowActiveEvent: s,
    ...a
  } = r, o = FC(t, e, n, a);
  if (!o)
    return null;
  let u = {};
  if (n.trigger === "view-progress" && !window.ViewTimeline) {
    const l = n.element || cf(n.componentId), {
      ready: h
    } = o;
    return o.animations.map((f) => ({
      /* we use getters for start and end in order to access the animation's start and end
         only when initializing the scrub scene rather than immediately */
      get start() {
        return f.start;
      },
      get end() {
        return f.end;
      },
      viewSource: l,
      ready: h,
      getProgress() {
        return o.getProgress();
      },
      effect(m, g) {
        const {
          activeDuration: A
        } = f.effect.getComputedTiming(), {
          delay: E
        } = f.effect.getTiming();
        f.currentTime = ((E || 0) + (A || 0)) * g;
      },
      disabled: i,
      destroy() {
        f.cancel();
      }
    }));
  } else if (n.trigger === "pointer-move") {
    const {
      centeredToTarget: l,
      transitionDuration: h,
      transitionEasing: f
    } = e;
    u = {
      target: o.target,
      centeredToTarget: l,
      allowActiveEvent: s
    }, e.customEffect && h && (u.transitionDuration = h, u.transitionEasing = ale(f));
  }
  return {
    ...u,
    getProgress() {
      return o.getProgress();
    },
    effect(l, h, f, m) {
      o.progress(f ? {
        // @ts-expect-error spread error on p
        ...h,
        v: f,
        active: m
      } : h);
    },
    disabled: i,
    destroy() {
      o.cancel();
    }
  };
}
function pA(t, e, n, r) {
  r === void 0 && (r = !1);
  const i = Afe(t, e);
  return i ? (i.ready = new Promise((s) => {
    yfe(t, e, s);
  }), i) : FC(t, e, n, {
    reducedMotion: r
  });
}
function VS(t, e) {
  return e.includes("&") ? e.replace(/&/g, t) : `${t}${e}`;
}
function Sfe() {
  return "wi-12343210".replace(
    /\d/g,
    (t) => String.fromCharCode((+t ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +t / 4) + 97)
    // 97 for "a"
  );
}
function wfe(t) {
  var e;
  let {
    key: n,
    effectId: r,
    transition: i,
    properties: s,
    childSelector: a = "> :first-child",
    selectorCondition: o
  } = t, u = [];
  if (i != null && i.styleProperties) {
    const {
      duration: x,
      easing: N,
      delay: B
    } = i;
    x && (i.styleProperties.some((C) => C.name.startsWith("--")) ? u = [`all ${x}ms ${lr(N || "ease")}${B ? ` ${B}ms` : ""}`, "visibility 0s"] : u = i.styleProperties.map((C) => `${C.name} ${x}ms ${lr(N || "ease")}${B ? ` ${B}ms` : ""}`)), s = i.styleProperties;
  } else {
    var l;
    u = ((l = s) == null ? void 0 : l.filter((x) => x.duration).map((x) => `${x.name} ${x.duration}ms ${lr(x.easing) || "ease"}${x.delay ? ` ${x.delay}ms` : ""}`)) || [];
  }
  const h = ((e = s) == null ? void 0 : e.map((x) => `${x.name}: ${x.value};`)) || [], f = n.replace(/"/g, "'"), m = `:is(:state(${r}), :--${r}) ${a}`, g = `[data-interact-effect~="${r}"] ${a}`, A = o ? VS(m, o) : m, E = o ? VS(g, o) : g, w = [`${A},
    ${E} {
      ${h.join(`
      `)}
    }`];
  if (u.length) {
    const x = `[data-interact-key="${f}"] ${a}`, N = o ? VS(x, o) : x;
    w.push(`@media (prefers-reduced-motion: no-preference) { ${N} {
      transition: ${u.join(", ")};
    } }`);
  }
  return w;
}
function bA(t, e) {
  const n = (t || []).filter((s) => {
    var a;
    return ((a = e[s]) == null ? void 0 : a.type) === "media" && e[s].predicate;
  }).map((s) => e[s].predicate).join(") and ("), r = n && `(${n})`, i = r && window.matchMedia(r);
  if (i)
    return i;
}
function G8(t, e) {
  for (const n of t || []) {
    const r = e[n];
    if (r?.type === "selector" && r.predicate)
      return r.predicate;
  }
}
function Df(t) {
  if (t.duration)
    return {
      id: "",
      ...t
    };
  const {
    rangeStart: e,
    rangeEnd: n,
    ...r
  } = t;
  return {
    id: "",
    startOffset: e,
    endOffset: n,
    ...r
  };
}
function Os(t, e, n) {
  let r = t.get(e);
  r || (r = /* @__PURE__ */ new Set(), t.set(e, r)), r.add(n);
}
function If(t, e) {
  const n = t.get(e);
  n?.forEach((r) => {
    const {
      source: i,
      target: s,
      cleanup: a
    } = r;
    a();
    const o = i === e ? s : i, u = t.get(o);
    u?.delete(r);
  }), t.delete(e);
}
const Ffe = {
  root: null,
  rootMargin: "0px 0px -10% 0px",
  threshold: [0]
}, KS = {}, s1 = /* @__PURE__ */ new WeakMap(), Fy = /* @__PURE__ */ new WeakSet(), Ty = /* @__PURE__ */ new WeakMap();
let W8 = {};
function Tfe(t) {
  W8 = t;
}
function V8(t, e) {
  e === void 0 && (e = !1);
  const n = JSON.stringify({
    ...t,
    isSafeMode: e
  });
  if (KS[n])
    return KS[n];
  const r = e ? Ffe : {
    root: null,
    rootMargin: t.inset ? `${t.inset} 0px ${t.inset}` : "0px",
    threshold: t.threshold
  }, i = new IntersectionObserver((s) => {
    s.forEach((a) => {
      const o = a.target;
      if (!Fy.has(o) && (Fy.add(o), t.useSafeViewEnter && !a.isIntersecting)) {
        Ni.measure(() => {
          var l;
          const h = a.boundingClientRect.height, f = (l = a.rootBounds) == null ? void 0 : l.height;
          if (!f)
            return;
          const m = Array.isArray(t.threshold) ? Math.min(...t.threshold) : t.threshold;
          m && h * m > f && Ni.mutate(() => {
            i.unobserve(o);
            const A = V8(t, !0);
            Ty.set(o, A), A.observe(o);
          });
        });
        return;
      }
      if (a.isIntersecting) {
        const l = s1.get(o);
        l?.forEach((h) => {
          let {
            source: f,
            handler: m
          } = h;
          f === a.target && m();
        }), t.type === "once" && (i.unobserve(a.target), Fy.delete(o));
      }
    });
  }, r);
  return KS[n] = i, i;
}
function vfe(t, e, n, r, i) {
  r === void 0 && (r = {});
  const s = pA(e, Df(n), void 0, i?.reducedMotion);
  if (!s)
    return;
  const a = V8({
    ...W8,
    ...r
  });
  s != null && s.isCSS && r.type === "once" && s.onFinish(() => {
    e.dataset.motionEnter = "done";
  });
  const {
    selectorCondition: o
  } = i || {}, h = {
    source: t,
    target: e,
    handler: () => {
      o && !e.matches(o) || s.play(() => {
        s.isCSS || (e.dataset.motionEnter = "done");
      });
    },
    cleanup: () => {
      (Ty.get(t) || a).unobserve(t), s.cancel(), Fy.delete(t), Ty.delete(t);
    }
  };
  Os(s1, t, h), Os(s1, e, h), Ty.set(t, a), a.observe(t);
}
function xfe(t) {
  If(s1, t);
}
const aD = {
  add: vfe,
  remove: xfe,
  setOptions: Tfe
};
function K8(t, e) {
  return Object.assign(Object.create(e), t);
}
function Cfe(t, e, n, r) {
  let i = t * (1 - n) + e * n;
  if (r) {
    const s = i - t;
    Math.abs(s) < r && (i = t + r * Math.sign(s));
    const a = e - i;
    if (Math.abs(a) < r)
      return e;
  }
  return i;
}
function kfe(t) {
  let e = !1;
  return function() {
    e || (e = !0, window.requestAnimationFrame(() => {
      e = !1, t();
    }));
  };
}
function oD(t, e) {
  let n = 0;
  return function() {
    n && window.clearTimeout(n), n = window.setTimeout(() => {
      n = 0, t();
    }, e);
  };
}
function _fe(t, e) {
  const n = t.match(/^calc\s*\(\s*(-?\d+((px)|([lsd]?vh)|([lsd]?vw)))\s*\+\s*(-?\d+((px)|([lsd]?vh)|([lsd]?vw)))\s*\)\s*$/);
  return a1(n[1], e) + a1(n[6], e);
}
function a1(t, e) {
  return t ? /^-?\d+px$/.test(t) ? parseInt(t) : /^-?\d+[lsd]?vh$/.test(t) ? parseInt(t) * e.viewportHeight / 100 : /^-?\d+[lsd]?vw$/.test(t) ? parseInt(t) * e.viewportWidth / 100 : /^calc\s*\(\s*-?\d+((px)|([lsd]?vh)|([lsd]?vw))\s*\+\s*-?\d+((px)|([lsd]?vh)|([lsd]?vw))\s*\)\s*$/.test(t) ? _fe(t, e) : parseInt(t) || 0 : 0;
}
function ed(t, e, n) {
  const { name: r, offset: i = 0 } = t, { start: s, end: a } = n, o = a - s, u = i / 100;
  let l, h;
  return r === "entry" ? (l = s - e, h = Math.min(e, o)) : r === "entry-crossing" ? (l = s - e, h = o) : r === "contain" ? (l = Math.min(a - e, s), h = Math.abs(e - o)) : r === "exit" ? (l = Math.max(s, a - e), h = Math.min(e, o)) : r === "exit-crossing" ? (l = s, h = o) : r === "cover" && (l = s - e, h = o + e), l + u * h | 0;
}
function zS(t, e, n, r, i) {
  let s = 0;
  const a = { start: e, end: n };
  return t.forEach((o, u) => {
    s += o.offset;
    const l = o.sticky;
    if (l) {
      if ("end" in l && t[u - 1]?.element) {
        const m = ((i ? o.element.offsetWidth : o.element.offsetHeight) || 0) + l.end - r, g = s + m - o.offset, A = g < a.start, E = !A && g <= n;
        let w = 0;
        (A || E) && (w = o.offset, a.end += w), A && (a.start += w);
      }
      if ("start" in l) {
        const h = s - l.start, f = h < a.start, m = !f && h <= a.end;
        let g = 0;
        const A = t[u - 1]?.element;
        if (A) {
          if (f || m) {
            const E = (i ? A.offsetWidth : A.offsetHeight) || 0, w = o.offset, x = (i ? o.element.offsetWidth : o.element.offsetHeight) || 0;
            g = E - (w + x), s += g, a.end += g;
          }
          f && (a.start += g);
        }
      }
    }
  }), a;
}
function Nfe(t, e, n, r, i, s) {
  const { start: a, end: o, duration: u } = t;
  let l = a, h = o, f = t.startRange, m = t.endRange, g;
  if (typeof u == "string") {
    f = { name: u, offset: 0 }, m = { name: u, offset: 100 }, l = ed(f, n, e), h = ed(m, n, e), g = h - l;
    const A = zS(s, l, h, n, r);
    l = A.start, h = A.end;
  } else {
    if (f || a?.name) {
      f = f || a;
      const A = a1(f.add, i), E = ed({ ...f, offset: 0 }, n, e), w = ed({ ...f, offset: 100 }, n, e), x = zS(s, E, w, n, r);
      l = x.start + f.offset / 100 * (x.end - x.start) + A;
    }
    if (m || o?.name) {
      m = m || o;
      const A = a1(m.add, i), E = ed({ ...m, offset: 0 }, n, e), w = ed({ ...m, offset: 100 }, n, e), x = zS(s, E, w, n, r);
      h = x.start + m.offset / 100 * (x.end - x.start) + A;
    } else typeof u == "number" && (h = l + u);
  }
  return !g && !u && (g = h - l), { ...t, start: l, end: h, startRange: f, endRange: m, duration: g || u };
}
function Dfe(t) {
  return t.position === "sticky";
}
function Ife(t, e, n) {
  return t.position === "fixed" && (!e || e === window.document.body || e === n);
}
function Rfe(t, e) {
  return parseInt(e ? t.left : t.top);
}
function Pfe(t, e) {
  return parseInt(e ? t.right : t.bottom);
}
function Lfe(t, e, n) {
  n && (t.style.position = "static");
  const r = (e ? t.offsetLeft : t.offsetTop) || 0;
  return n && (t.style.position = null), r;
}
function Mfe(t, e) {
  let n;
  const r = Rfe(t, e), i = Pfe(t, e), s = !isNaN(r), a = !isNaN(i);
  return (s || a) && (n = {}, s && (n.start = r), a && (n.end = i)), n;
}
function T0(t, e, n, r, i) {
  const s = t[0].viewSource, a = [];
  let o = (r ? s.offsetWidth : s.offsetHeight) || 0, u = 0, l = s;
  for (; l; ) {
    const f = window.getComputedStyle(l), m = Dfe(f), g = m ? Mfe(f, r) : void 0, A = Lfe(l, r, m);
    if ((!g || !("end" in g)) && (u += A), a.push({ element: l, offset: A, sticky: g }), l = l.offsetParent, Ife(f, l, e))
      break;
    if (l === e) {
      a.push({ element: l, offset: 0 });
      break;
    }
  }
  return a.reverse(), t.map((f) => ({
    ...Nfe(
      f,
      { start: u, end: u + o },
      n,
      r,
      i,
      a
    )
  }));
}
const uD = 100, Ofe = {
  horizontal: !1,
  observeViewportEntry: !0,
  viewportRootMargin: "7% 7%",
  observeViewportResize: !1,
  observeSourcesResize: !1,
  observeContentResize: !1
};
function Bfe(t, e, n, r) {
  let i = 0;
  return t >= e && t <= n ? i = r ? (t - e) / r : 1 : t > n && (i = 1), i;
}
function lD(t, e) {
  return t === window ? e ? window.document.documentElement.clientWidth : window.document.documentElement.clientHeight : e ? t.clientWidth : t.clientHeight;
}
function $fe() {
  return {
    viewportWidth: window.document.documentElement.clientWidth,
    viewportHeight: window.document.documentElement.clientHeight
  };
}
function Hfe(t) {
  const e = K8(t, Ofe), n = e.root, r = e.horizontal, i = /* @__PURE__ */ new WeakMap();
  let s = lD(n, r), a, o, u, l, h;
  const f = [], m = $fe();
  if (e.scenes = Object.values(
    // TODO(ameerf): find a polyfill and use groupBy instead of following reduce
    t.scenes.reduce(
      (E, w, x) => {
        const N = w.groupId ? `group-${w.groupId}` : String(x);
        return E[N] ? E[N].push(w) : E[N] = [w], E;
      },
      {}
    )
  ).flatMap((E) => (E.every((w) => w.viewSource && (typeof w.duration == "string" || w.start?.name)) ? (E = T0(E, n, s, r, m), (e.observeSourcesResize || e.observeContentResize) && f.push(E)) : E.forEach((w) => {
    w.end == null && (w.end = w.start + w.duration), w.duration == null && (w.duration = w.end - w.start);
  }), E)), e.scenes.forEach((E, w) => {
    E.index = w;
  }), f.length) {
    const E = /* @__PURE__ */ new Map();
    window.ResizeObserver && (u = new window.ResizeObserver(function(w) {
      w.forEach((x) => {
        const N = E.get(x.target), B = T0(N, n, s, r, m);
        B.forEach((P, C) => {
          e.scenes[P.index] = B[C];
        }), f.splice(f.indexOf(N), 1, B);
      });
    }), f.forEach((w) => {
      u.observe(w[0].viewSource, { box: "border-box" }), E.set(w[0].viewSource, w);
    }), e.observeContentResize && e.contentRoot && new window.ResizeObserver(oD(() => {
      const x = f.map((N) => {
        const B = T0(N, n, s, r, m);
        return B.forEach((P, C) => {
          e.scenes[P.index] = B[C];
        }), B;
      });
      f.length = 0, f.push(...x), f.forEach((N) => {
        E.set(N[0].viewSource, N);
      });
    }, uD)).observe(e.contentRoot, { box: "border-box" })), e.observeViewportResize && (l = oD(function() {
      s = lD(n, r);
      const w = f.map((x) => {
        const N = T0(x, n, s, r, m);
        return N.forEach((B, P) => {
          e.scenes[B.index] = N[P];
        }), N;
      });
      f.length = 0, f.push(...w), f.forEach((x) => {
        E.set(x[0].viewSource, x);
      });
    }, uD), n === window ? window.addEventListener("resize", l) : window.ResizeObserver && (h = new window.ResizeObserver(l), h.observe(n, { box: "border-box" })));
  }
  e.observeViewportEntry && window.IntersectionObserver && (o = new window.IntersectionObserver(function(E) {
    E.forEach((w) => {
      (i.get(w.target) || []).forEach((x) => {
        x.disabled = !w.isIntersecting;
      });
    });
  }, {
    root: n === window ? window.document : n,
    rootMargin: e.viewportRootMargin,
    threshold: 0
  }), e.scenes.forEach((E) => {
    if (E.viewSource) {
      let w = i.get(E.viewSource);
      w || (w = [], i.set(E.viewSource, w), o.observe(E.viewSource)), w.push(E);
    }
  }));
  function g({ p: E, vp: w }) {
    E = +E.toFixed(1);
    const x = +w.toFixed(4);
    if (E !== a) {
      for (let N of e.scenes)
        if (!N.disabled) {
          const { start: B, end: P, duration: C } = N, D = Bfe(E, B, P, C);
          N.effect(N, D, x);
        }
      a = E;
    }
  }
  function A() {
    e.scenes.forEach((E) => E.destroy?.()), o && (o.disconnect(), o = null), u && (u.disconnect(), u = null), l && (h ? (h.disconnect(), h = null) : window.removeEventListener("resize", l));
  }
  return {
    tick: g,
    destroy: A
  };
}
const Ufe = {
  transitionActive: !1,
  transitionFriction: 0.9,
  transitionEpsilon: 1,
  velocityActive: !1,
  velocityMax: 1
};
class Gfe {
  constructor(e = {}) {
    this.config = K8(e, Ufe), this.progress = {
      p: 0,
      prevP: 0,
      vp: 0
    }, this.currentProgress = {
      p: 0,
      prevP: 0,
      vp: 0
    }, this._lerpFrameId = 0, this.effect = null;
    const n = !this.config.root || this.config.root === window.document.body;
    this.config.root = n ? window : this.config.root, this.config.contentRoot = this.config.contentRoot || (n ? window.document.body : this.config.root.firstElementChild), this.config.resetProgress = this.config.resetProgress || this.resetProgress.bind(this), this._measure = this.config.measure || (() => {
      const r = this.config.root;
      this.progress.p = this.config.horizontal ? r.scrollX || r.scrollLeft || 0 : r.scrollY || r.scrollTop || 0;
    }), this._trigger = kfe(() => {
      this._measure?.(), this.tick(!0);
    });
  }
  /**
   * Setup event and effect, and reset progress and frame.
   */
  start() {
    this.setupEffect(), this.setupEvent(), this.resetProgress(), this.tick();
  }
  /**
   * Removes event listener.
   */
  pause() {
    this.removeEvent();
  }
  /**
   * Reset progress in the DOM and inner state to given x and y.
   *
   * @param {Object} [scrollPosition]
   * @param {number} [scrollPosition.x]
   * @param {number} [scrollPosition.y]
   */
  resetProgress(e = {}) {
    const n = this.config.root, r = e.x || e.x === 0 ? e.x : n.scrollX || n.scrollLeft || 0, i = e.y || e.y === 0 ? e.y : n.scrollY || n.scrollTop || 0, s = this.config.horizontal ? r : i;
    this.progress.p = s, this.progress.prevP = s, this.progress.vp = 0, this.config.transitionActive && (this.currentProgress.p = s, this.currentProgress.prevP = s, this.currentProgress.vp = 0), e && this.config.root.scrollTo(r, i);
  }
  /**
   * Handle animation frame work.
   *
   * @param {boolean} [clearLerpFrame] whether to cancel an existing lerp frame
   */
  tick(e) {
    const n = this.config.transitionActive;
    n && this.lerp();
    const r = n ? this.currentProgress : this.progress;
    if (this.config.velocityActive) {
      const i = r.p - r.prevP, s = i < 0 ? -1 : 1;
      r.vp = Math.min(this.config.velocityMax, Math.abs(i)) / this.config.velocityMax * s;
    }
    this.effect.tick(r), n && r.p !== this.progress.p && (e && this._lerpFrameId && window.cancelAnimationFrame(this._lerpFrameId), this._lerpFrameId = window.requestAnimationFrame(() => this.tick())), r.prevP = r.p;
  }
  /**
   * Calculate current progress.
   */
  lerp() {
    this.currentProgress.p = Cfe(this.currentProgress.p, this.progress.p, +(1 - this.config.transitionFriction).toFixed(3), this.config.transitionEpsilon);
  }
  /**
   * Stop the event and effect, and remove all DOM side-effects.
   */
  destroy() {
    this.pause(), this.removeEffect();
  }
  /**
   * Register to scroll for triggering update.
   */
  setupEvent() {
    this.removeEvent(), this.config.root.addEventListener("scroll", this._trigger);
  }
  /**
   * Remove scroll handler.
   */
  removeEvent() {
    this.config.root.removeEventListener("scroll", this._trigger);
  }
  /**
   * Reset registered effect.
   */
  setupEffect() {
    this.removeEffect(), this.effect = Hfe(this.config);
  }
  /**
   * Remove registered effect.
   */
  removeEffect() {
    this.effect && this.effect.destroy(), this.effect = null;
  }
}
const Dm = /* @__PURE__ */ new WeakMap();
let z8 = () => ({});
function Wfe(t) {
  z8 = t;
}
function Vfe(t, e, n, r, i) {
  if (i != null && i.reducedMotion)
    return;
  const s = {
    trigger: "view-progress",
    element: t
  }, a = Df(n);
  let o;
  if ("ViewTimeline" in window) {
    const l = FC(e, a, s);
    if (l) {
      l.play(), o = () => {
        l.ready.then(() => {
          l.cancel();
        });
      };
      const h = {
        source: t,
        target: e,
        cleanup: o
      };
      Os(Dm, t, h), Os(Dm, e, h);
    }
  } else {
    const l = U8(e, a, s);
    if (l) {
      const h = Array.isArray(l) ? l : [l], f = new Gfe({
        viewSource: t,
        scenes: h,
        observeViewportEntry: !1,
        observeViewportResize: !1,
        observeSourcesResize: !0,
        root: document.body,
        ...z8()
      });
      o = () => {
        f.destroy();
      }, Promise.all(h.map((m) => m.ready || Promise.resolve())).then(() => {
        f.start();
      });
    }
  }
  if (!o)
    return;
  const u = {
    source: t,
    target: e,
    cleanup: o
  };
  Os(Dm, t, u), Os(Dm, e, u);
}
function Kfe(t) {
  If(Dm, t);
}
const zfe = {
  add: Vfe,
  remove: Kfe,
  registerOptionsGetter: Wfe
}, wT = /* @__PURE__ */ new WeakMap();
function jfe(t, e, n, r) {
  const i = pA(t, Df(e), void 0, r?.reducedMotion);
  if (!i)
    return;
  const s = n.type || "alternate", {
    selectorCondition: a
  } = r || {};
  let o = !0;
  return (u) => {
    a && !t.matches(a) || (u.type === "mouseenter" || u.type === "focusin" ? s === "alternate" ? o ? (o = !1, i.play()) : i.reverse() : s === "state" ? i.playState !== "finished" && i.play() : (i.progress(0), i.isCSS && i.onFinish(() => {
      t.dataset.motionEnter = "done";
    }), i.play()) : (u.type === "mouseleave" || u.type === "focusout") && (s === "alternate" ? i.reverse() : s === "repeat" ? (i.cancel(), delete t.dataset.motionEnter) : s === "state" && i.playState === "running" && i.pause()));
  };
}
function Yfe(t, e, n, r) {
  let {
    effectId: i,
    listContainer: s,
    listItemSelector: a
  } = e;
  const o = n.method || "toggle", u = o === "toggle", l = !!s;
  return (h) => {
    if (r && !t.matches(r))
      return;
    const f = t.closest("interact-element");
    if (!f)
      return;
    let m;
    if (l && (m = t.closest(`${s} > ${a || ""}:has(:scope)`)), h.type === "mouseenter" || h.type === "focusin") {
      const g = u ? "add" : o;
      f.toggleEffect(i, g, m);
    } else (h.type === "mouseleave" || h.type === "focusout") && u && f.toggleEffect(i, "remove", m);
  };
}
function qfe(t, e, n, r, i) {
  r === void 0 && (r = {});
  let s, a = !1, o = !1;
  if (n.transition || n.transitionProperties ? (s = Yfe(e, n, r, i?.selectorCondition), a = !0) : (s = jfe(e, n, r, {
    reducedMotion: i?.reducedMotion,
    selectorCondition: i?.selectorCondition
  }), o = r.type === "once"), !s)
    return;
  const l = {
    source: t,
    target: e,
    cleanup: () => {
      t.removeEventListener("mouseenter", s), t.removeEventListener("mouseleave", s), i != null && i.allowA11yTriggers && (t.removeEventListener("focusin", s), t.removeEventListener("focusout", s));
    }
  };
  Os(wT, t, l), Os(wT, e, l), i != null && i.allowA11yTriggers && (t.tabIndex = 0, t.addEventListener("focusin", (f) => {
    t.contains(f.relatedTarget) || s(f);
  }, {
    once: o
  })), t.addEventListener("mouseenter", s, {
    passive: !0,
    once: o
  }), (a ? (r.method || "toggle") === "toggle" : r.type !== "once") && (t.addEventListener("mouseleave", s, {
    passive: !0
  }), i != null && i.allowA11yTriggers && t.addEventListener("focusout", (f) => {
    t.contains(f.relatedTarget) || s(f);
  }, {
    once: o
  }));
}
function Jfe(t) {
  If(wT, t);
}
const cD = {
  add: qfe,
  remove: Jfe
}, FT = /* @__PURE__ */ new WeakMap();
function Qfe(t, e, n, r) {
  const i = pA(t, Df(e), void 0, r?.reducedMotion);
  if (!i)
    return;
  let s = !0;
  const a = n.type || "alternate", {
    selectorCondition: o
  } = r || {};
  return (u) => {
    o && !t.matches(o) || (a === "alternate" ? s ? (s = !1, i.play()) : i.reverse() : a === "state" ? s ? (s = !1, i.play()) : i.playState === "running" ? i.pause() : i.playState !== "finished" && i.play() : (i.progress(0), i.isCSS && i.onFinish(() => {
      t.dataset.motionEnter = "done";
    }), i.play()));
  };
}
function Xfe(t, e, n, r) {
  let {
    effectId: i,
    listContainer: s,
    listItemSelector: a
  } = e;
  const o = !!s;
  return (u) => {
    if (r && !t.matches(r))
      return;
    const l = t.closest("interact-element");
    if (!l)
      return;
    let h;
    o && (h = t.closest(`${s} > ${a || ""}:has(:scope)`)), l.toggleEffect(i, n.method || "toggle", h);
  };
}
function Zfe(t, e, n, r, i) {
  r === void 0 && (r = {});
  let s, a = !1;
  if (n.transition || n.transitionProperties ? s = Xfe(e, n, r, i?.selectorCondition) : (s = Qfe(e, n, r, {
    reducedMotion: i?.reducedMotion,
    selectorCondition: i?.selectorCondition
  }), a = r.type === "once"), !s)
    return;
  const u = {
    source: t,
    target: e,
    cleanup: () => {
      t.removeEventListener("click", s), i != null && i.allowA11yTriggers && t.removeEventListener("keydown", s);
    }
  };
  Os(FT, t, u), Os(FT, e, u), t.addEventListener("click", (l) => {
    l.pointerType && s(l);
  }, {
    passive: !0,
    once: a
  }), i != null && i.allowA11yTriggers && (t.tabIndex = 0, t.addEventListener("keydown", (l) => {
    l.code === "Space" ? (l.preventDefault(), s(l)) : l.code === "Enter" && s(l);
  }, {
    once: a
  }));
}
function eme(t) {
  If(FT, t);
}
const hD = {
  add: Zfe,
  remove: eme
};
function dD(t, e, n) {
  return Math.min(Math.max(t, n), e);
}
function fD(t) {
  let e = !1;
  return function() {
    if (!e)
      return e = !0, window.requestAnimationFrame(() => {
        e = !1, t();
      });
  };
}
function tme(t) {
  let e = t, n = 0, r = 0;
  if (e.offsetParent)
    do
      n += e.offsetLeft, r += e.offsetTop, e = e.offsetParent;
    while (e);
  return {
    left: n,
    top: r,
    width: t.offsetWidth,
    height: t.offsetHeight
  };
}
function nme() {
  const t = window.devicePixelRatio;
  let e = !1;
  if (t === 1)
    return !1;
  document.body.addEventListener("pointerdown", (r) => {
    e = r.offsetX !== 10;
  }, { once: !0 });
  const n = new PointerEvent("pointerdown", {
    clientX: 10
  });
  return document.body.dispatchEvent(n), e;
}
function rme() {
  return new Promise((t) => {
    const e = window.scrollY;
    let n = !1, r;
    function i() {
      document.body.addEventListener("pointerdown", (o) => {
        r === void 0 ? r = o.offsetY : n = o.offsetY === r;
      }, { once: !0 });
      const a = new PointerEvent("pointerdown", {
        clientY: 500
      });
      document.body.dispatchEvent(a);
    }
    function s() {
      window.scrollY !== e && (window.removeEventListener("scroll", s), i(), t(n));
    }
    i(), window.addEventListener("scroll", s), window.scrollY > 0 && window.scrollBy(0, -1);
  });
}
function ime(t) {
  rme().then((e) => {
    t.fixRequired = e, e && (window.addEventListener("scroll", t.scrollHandler), t.scrollHandler());
  });
}
let v0 = 0;
const vy = /* @__PURE__ */ new Set();
function sme() {
  const t = (n) => {
    for (let r of n.changedTouches)
      vy.add(r.identifier);
  }, e = (n) => {
    for (let r of n.changedTouches)
      vy.delete(r.identifier);
  };
  return document.addEventListener("touchstart", t, { passive: !0 }), document.addEventListener("touchend", e, { passive: !0 }), function() {
    vy.clear(), document.removeEventListener("touchstart", t), document.removeEventListener("touchend", e);
  };
}
function ame(t, e) {
  if ("onscrollend" in window)
    return t.addEventListener("scrollend", e), function() {
      t.removeEventListener("scrollend", e);
    };
  let n = 0, r;
  v0 || (r = sme()), v0 += 1;
  function i(s) {
    clearTimeout(n), n = setTimeout(() => {
      vy.size ? setTimeout(i, 100) : (e(s), n = 0);
    }, 100);
  }
  return t.addEventListener("scroll", i), function() {
    t.removeEventListener("scroll", i), v0 -= 1, v0 || r();
  };
}
function ome(t, e, n) {
  return {
    x(r) {
      const i = t.left - n.x + t.width / 2, s = i >= e.width / 2, a = (s ? i : e.width - i) * 2, o = s ? 0 : i - a / 2;
      return (r - o) / a;
    },
    y(r) {
      const i = t.top - n.y + t.height / 2, s = i >= e.height / 2, a = (s ? i : e.height - i) * 2, o = s ? 0 : i - a / 2;
      return (r - o) / a;
    }
  };
}
function ume(t, e) {
  this.x = window.scrollX, this.y = window.scrollY, requestAnimationFrame(() => t && t(e));
}
function lme(t) {
  t.rect.width = window.document.documentElement.clientWidth, t.rect.height = window.document.documentElement.clientHeight;
}
function cme(t) {
  const e = new ResizeObserver((n) => {
    n.forEach((r) => {
      t.rect.width = r.borderBoxSize[0].inlineSize, t.rect.height = r.borderBoxSize[0].blockSize;
    });
  });
  return e.observe(t.root, { box: "border-box" }), e;
}
function hme(t) {
  let e = !1, n = { x: t.rect.width / 2, y: t.rect.height / 2, vx: 0, vy: 0 }, r, i, s, a, o;
  const u = { x: 0, y: 0 };
  t.scenes.forEach((h) => {
    h.target && h.centeredToTarget && (h.transform = ome(tme(h.target), t.rect, u), e = !0), t.root ? i = cme(t) : (s = lme.bind(null, t), window.addEventListener("resize", s));
  }), r = function(h) {
    for (let f of t.scenes)
      if (!f.disabled) {
        const m = f.transform?.x(h.x) || h.x / t.rect.width, g = f.transform?.y(h.y) || h.y / t.rect.height, A = +dD(0, 1, m).toPrecision(4), E = +dD(0, 1, g).toPrecision(4), w = { x: h.vx, y: h.vy };
        t.allowActiveEvent && (h.active = m <= 1 && g <= 1 && m >= 0 && g >= 0), f.effect(f, { x: A, y: E }, w, h.active);
      }
    Object.assign(n, h);
  }, e && (a = ume.bind(u, r, n), o = ame(document, a));
  function l() {
    t.scenes.forEach((h) => h.destroy?.()), o?.(), i ? (i.disconnect(), i = null) : (window.removeEventListener("resize", s), s = null), r = null, n = null;
  }
  return {
    tick: r,
    destroy: l
  };
}
const dme = 1e3 / 60 * 3;
let x0;
function fme() {
  xd.x = window.scrollX, xd.y = window.scrollY;
}
const xd = { x: 0, y: 0, scrollHandler: fme, fixRequired: void 0 };
class mme {
  constructor(e = {}) {
    this.config = { ...e }, this.effect = null, this._nextTick = null, this._nextTransitionTick = null, this._startTime = 0;
    let n;
    this.config.transitionDuration ? n = this.config.noThrottle ? () => this.transition() : fD(() => this.transition()) : n = this.config.noThrottle ? () => (this.tick(), null) : fD(() => {
      this.tick();
    }), this.config.rect = this.config.root ? {
      width: this.config.root.offsetWidth,
      height: this.config.root.offsetHeight
    } : {
      width: window.document.documentElement.clientWidth,
      height: window.document.documentElement.clientHeight
    }, this.progress = {
      x: this.config.rect.width / 2,
      y: this.config.rect.height / 2,
      vx: 0,
      vy: 0
    }, this.previousProgress = { ...this.progress }, this.currentProgress = null;
    const r = (i) => {
      const s = this.config.root ? i.offsetX : i.x, a = this.config.root ? i.offsetY : i.y;
      this.progress.vx = s - this.progress.x, this.progress.vy = a - this.progress.y, this.progress.x = s, this.progress.y = a, this._nextTick = n();
    };
    if (this._pointerLeave = () => {
      this.progress.active = !1, this.progress.vx = 0, this.progress.vy = 0, this._nextTick = n();
    }, this._pointerEnter = () => {
      this.progress.active = !0, this._nextTick = n();
    }, this.config.root) {
      x0 = typeof x0 == "boolean" ? x0 : nme();
      const i = x0 ? window.devicePixelRatio : 1;
      typeof xd.fixRequired > "u" && ime(xd), this._measure = (s) => {
        if (s.target !== this.config.root) {
          const a = new PointerEvent("pointermove", {
            bubbles: !0,
            cancelable: !0,
            clientX: s.x * i + xd.x,
            clientY: s.y * i + xd.y
          });
          s.stopPropagation(), this.config.root.dispatchEvent(a);
        } else
          r(s);
      };
    } else
      this._measure = r;
  }
  /**
   * Setup event and effect, and reset progress and frame.
   */
  start() {
    this.setupEffect(), this.setupEvent();
  }
  /**
   * Removes event listener.
   */
  pause() {
    this.removeEvent();
  }
  /**
   * Handle animation frame work.
   */
  tick() {
    this.effect.tick(this.progress);
  }
  /**
   * Starts a transition from the previous progress to the current progress.
   *
   * @returns {number} the requestAnimationFrame id for the transition tick.
   */
  transition() {
    const e = this.config.transitionDuration, n = this.config.transitionEasing || ((a) => a), r = performance.now();
    let i = !1;
    const s = (a) => {
      const o = (a - this._startTime) / e, u = n(Math.min(1, o));
      i && (this.progress.vx = 0, this.progress.vy = 0, i = !1), this.currentProgress = Object.entries(this.progress).reduce((l, [h, f]) => (h === "active" ? l[h] = f : l[h] = this.previousProgress[h] + (f - this.previousProgress[h]) * u, l), this.currentProgress || {}), o < 1 && (this._nextTransitionTick = requestAnimationFrame(s), i = a - this._startTime > dme), this.effect.tick(this.currentProgress);
    };
    return this._startTime ? (this._nextTransitionTick && cancelAnimationFrame(this._nextTransitionTick), Object.assign(this.previousProgress, this.currentProgress), this._startTime = r, s(r)) : this._startTime = r, this._nextTransitionTick;
  }
  /**
   * Stop the event and effect, and remove all DOM side effects.
   */
  destroy() {
    this.pause(), this.removeEffect(), this._nextTick && cancelAnimationFrame(this._nextTick), this._nextTransitionTick && cancelAnimationFrame(this._nextTransitionTick);
  }
  /**
   * Register to pointermove for triggering update.
   */
  setupEvent() {
    this.removeEvent();
    const e = this.config.root || window;
    e.addEventListener("pointermove", this._measure, { passive: !0 }), this.config.eventSource && this.config.eventSource.addEventListener("pointermove", this._measure, { passive: !0 }), this.config.allowActiveEvent && (e.addEventListener("pointerleave", this._pointerLeave, { passive: !0 }), e.addEventListener("pointerenter", this._pointerEnter, { passive: !0 }), this.config.eventSource && (this.config.eventSource.addEventListener("pointerleave", this._pointerLeave, { passive: !0 }), this.config.eventSource.addEventListener("pointerenter", this._pointerEnter, { passive: !0 })));
  }
  /**
   * Remove pointermove handler.
   */
  removeEvent() {
    const e = this.config.root || window;
    e.removeEventListener("pointermove", this._measure), this.config.eventSource && this.config.eventSource.removeEventListener("pointermove", this._measure), this.config.allowActiveEvent && (e.removeEventListener("pointerleave", this._pointerLeave), e.removeEventListener("pointerenter", this._pointerEnter), this.config.eventSource && (this.config.eventSource.removeEventListener("pointerleave", this._pointerLeave), this.config.eventSource.removeEventListener("pointerenter", this._pointerEnter)));
  }
  /**
   * Reset registered effect.
   */
  setupEffect() {
    this.removeEffect(), this.effect = hme(this.config);
  }
  /**
   * Remove registered effect.
   */
  removeEffect() {
    this.effect && this.effect.destroy(), this.effect = null;
  }
}
const TT = /* @__PURE__ */ new WeakMap();
let j8 = () => ({});
function gme(t) {
  j8 = t;
}
function pme(t, e, n, r, i) {
  if (r === void 0 && (r = {}), i != null && i.reducedMotion)
    return;
  const s = {
    trigger: "pointer-move",
    element: t
  }, a = U8(e, Df(n), s);
  if (a) {
    const o = new mme({
      root: r.hitArea === "self" ? t : void 0,
      scenes: Array.isArray(a) ? a : [a],
      ...j8()
    }), l = {
      source: t,
      target: e,
      cleanup: () => {
        o.destroy();
      }
    };
    Os(TT, t, l), Os(TT, e, l), o.start();
  }
}
function bme(t) {
  If(TT, t);
}
const yme = {
  add: pme,
  remove: bme,
  registerOptionsGetter: gme
}, vT = /* @__PURE__ */ new WeakMap();
function Ame(t, e, n, r, i) {
  const s = pA(e, Df(n), void 0, i?.reducedMotion);
  if (!s)
    return;
  const {
    selectorCondition: a
  } = i || {}, o = () => {
    a && !e.matches(a) || s.play();
  }, l = {
    source: t,
    target: e,
    cleanup: () => {
      s.cancel(), t.removeEventListener("animationend", o);
    }
  };
  Os(vT, t, l), Os(vT, e, l), t.addEventListener("animationend", o);
}
function Eme(t) {
  If(vT, t);
}
const Sme = {
  add: Ame,
  remove: Eme
};
function mD(t) {
  return {
    add: (e, n, r, i, s) => t.add(e, n, r, i, {
      ...s,
      allowA11yTriggers: !0
    }),
    remove: t.remove
  };
}
const Xc = {
  viewEnter: aD,
  hover: cD,
  click: hD,
  pageVisible: aD,
  animationEnd: Sme,
  viewProgress: zfe,
  pointerMove: yme,
  activate: mD(hD),
  interest: mD(cD)
};
function gD(t, e) {
  if (t.listContainer) {
    const n = e.querySelector(t.listContainer);
    return n ? t.selector ? Array.from(n.querySelectorAll(t.selector)) : Array.from(n.children) : (console.warn(`Interact: No container found for list container "${t.listContainer}"`), []);
  }
  if (t.selector) {
    const n = e.querySelector(t.selector);
    if (n)
      return n;
    console.warn(`Interact: No element found for selector "${t.selector}"`);
  }
  return e.firstElementChild;
}
function pD(t, e) {
  return e.map((n) => t.selector ? n.querySelector(t.selector) : n).filter(Boolean);
}
function Y8(t, e, n, r, i, s) {
  return [i ? pD(t, i) : gD(t, n), s ? pD(e, s) : gD(e, r)];
}
function q8(t, e, n, r, i, s) {
  const a = Array.isArray(r), o = Array.isArray(i);
  a ? r.forEach((u, l) => {
    const h = o ? i[l] : i;
    h && bD(t, u, e.trigger, h, n, e.params, s);
  }) : (o ? i : [i]).forEach((l) => {
    bD(t, r, e.trigger, l, n, e.params, s);
  });
}
function J8(t, e, n, r, i) {
  const s = {};
  r.effects.forEach((a) => {
    const o = a.effectId, u = {
      ...n.dataCache.effects[o] || {},
      ...a,
      effectId: o
    }, l = u.key, h = Fg(a.interactionId, t);
    if (s[h] || n.addedInteractions[h] && !i)
      return;
    const f = bA(u.conditions || [], n.dataCache.conditions);
    if (f && n.setupMediaQueryListener(h, f, t, () => {
      e.disconnect(), e.connect();
    }), !f || f.matches) {
      s[h] = !0;
      const m = l && Fg(l, t);
      let g;
      if (m) {
        if (g = vn.getElement(m), !g)
          return;
        u.listContainer && g.watchChildList(u.listContainer);
      } else
        g = e;
      const [A, E] = Y8(r, u, e, g, i);
      if (!A || !E)
        return;
      n.addedInteractions[h] = !0;
      const w = m || r.key, x = G8(u.conditions || [], n.dataCache.conditions);
      q8(w, r, u, A, E, x);
    }
  });
}
function Q8(t, e, n, r, i) {
  var s;
  const a = ((s = n.get(t)) == null ? void 0 : s.effects) || {}, o = Object.keys(a);
  return o.forEach((u) => {
    const l = Fg(u, t);
    if (n.addedInteractions[l] && !i)
      return;
    a[u].some((f) => {
      let {
        effect: m,
        ...g
      } = f;
      const A = m.effectId, E = {
        ...n.dataCache.effects[A] || {},
        ...m,
        effectId: A
      };
      if (r && E.listContainer !== r)
        return !1;
      const w = bA(E.conditions || [], n.dataCache.conditions);
      if (w && n.setupMediaQueryListener(l, w, t, () => {
        e.disconnect(), e.connect();
      }), !w || w.matches) {
        const x = g.key && Fg(g.key, t), N = vn.getElement(x);
        if (!N)
          return !0;
        E.listContainer && e.watchChildList(E.listContainer);
        const [B, P] = Y8(g, E, N, e, void 0, i);
        if (!B || !P)
          return !0;
        n.addedInteractions[l] = !0;
        const C = G8(E.conditions || [], n.dataCache.conditions);
        return q8(t, g, E, B, P, C), !0;
      }
    });
  }), o.length > 0;
}
function bD(t, e, n, r, i, s, a) {
  var o;
  if (i.transition || i.transitionProperties) {
    const u = {
      key: t,
      effectId: i.effectId,
      transition: i.transition,
      properties: i.transitionProperties,
      childSelector: xT(i, {
        asCombinator: !0,
        addItemFilter: !0
      }),
      selectorCondition: a
    }, l = r.closest("interact-element");
    if (!l)
      return;
    l.renderStyle(wfe(u));
  }
  (o = Xc[n]) == null || o.add(e, r, i, s, {
    reducedMotion: vn.forceReducedMotion,
    allowA11yTriggers: vn.allowA11yTriggers,
    selectorCondition: a
  });
}
function wme(t, e) {
  const n = vn.getInstance(e);
  if (!n)
    return console.warn(`No instance found for key: ${e}`), vn.setElement(e, t), !1;
  const {
    triggers: r = []
  } = n?.get(e) || {}, i = r.length > 0;
  n.setElement(e, t), r.forEach((a, o) => {
    const u = bA(a.conditions, n.dataCache.conditions);
    if (u) {
      const l = `${e}::trigger::${o}`;
      n.setupMediaQueryListener(l, u, e, () => {
        t.disconnect(), t.connect();
      });
    }
    (!u || u.matches) && (a.listContainer && t.watchChildList(a.listContainer), J8(e, t, n, a));
  });
  let s = !1;
  return n && (s = Q8(e, t, n)), i || s;
}
function Fme(t, e, n, r) {
  const i = vn.getInstance(e);
  if (i) {
    const {
      triggers: s = []
    } = i?.get(e) || {};
    s.forEach((a, o) => {
      if (a.listContainer !== n)
        return;
      const u = bA(a.conditions, i.dataCache.conditions);
      if (u) {
        const l = `${e}::listTrigger::${n}::${o}`;
        i.setupMediaQueryListener(l, u, e, () => {
          t.disconnect(), t.connect();
        });
      }
      (!u || u.matches) && J8(e, t, i, a, r);
    }), Q8(e, t, i, n, r);
  }
}
function Tme(t) {
  var e;
  const n = vn.getInstance(t);
  if (!n)
    return;
  const r = vn.getElement(t);
  if (!r)
    return;
  const i = [...((e = n.get(t)) == null ? void 0 : e.selectors.values()) || []].join(","), s = r.querySelectorAll(i);
  X8(Array.from(s)), n?.deleteElement(t);
}
function X8(t) {
  const e = Object.values(Xc);
  for (const n of t)
    for (const r of e)
      r.remove(n);
}
const jS = "interactEffect";
function vme() {
  let t = !1, e = !1;
  return class extends HTMLElement {
    constructor() {
      if (super(), pr(this, "_internals", void 0), pr(this, "connected", void 0), pr(this, "sheet", void 0), pr(this, "_observers", void 0), this.connected = !1, this.sheet = null, this._observers = /* @__PURE__ */ new WeakMap(), this.attachInternals) {
        if (this._internals = this.attachInternals(), !t) {
          t = !0;
          try {
            this._internals.states.add("test"), this._internals.states.delete("test");
          } catch {
            e = !0;
          }
        }
      } else
        t = !0, this._internals = null;
    }
    connectedCallback() {
      this.connect();
    }
    disconnectedCallback() {
      this.disconnect();
    }
    disconnect() {
      const r = this.dataset.interactKey;
      if (r && Tme(r), this.sheet) {
        const i = document.adoptedStyleSheets.indexOf(this.sheet);
        document.adoptedStyleSheets.splice(i, 1);
      }
      this._observers = /* @__PURE__ */ new WeakMap(), this.sheet = null, this.connected = !1;
    }
    connect(r) {
      if (!this.connected) {
        if (r = r || this.dataset.interactKey, !r) {
          console.warn("InteractElement: No key provided");
          return;
        }
        this.connected = wme(this, r);
      }
    }
    renderStyle(r) {
      if (!this.sheet)
        this.sheet = new CSSStyleSheet(), this.sheet.replace(r.join(`
`)), document.adoptedStyleSheets.push(this.sheet);
      else {
        let i = this.sheet.cssRules.length;
        for (const s of r)
          try {
            this.sheet.insertRule(s, i), i++;
          } catch (a) {
            console.error(a);
          }
      }
    }
    toggleEffect(r, i, s) {
      if (s !== null)
        if (e && (r = `--${r}`), this._internals && !s)
          i === "toggle" ? this._internals.states.has(r) ? this._internals.states.delete(r) : this._internals.states.add(r) : i === "add" ? this._internals.states.add(r) : i === "remove" ? this._internals.states.delete(r) : i === "clear" && this._internals.states.clear();
        else {
          var a;
          const o = new Set(((a = this.dataset[jS]) == null ? void 0 : a.split(" ")) || []);
          i === "toggle" ? o.has(r) ? o.delete(r) : o.add(r) : i === "add" ? o.add(r) : i === "remove" ? o.delete(r) : i === "clear" && o.clear(), (s || this).dataset[jS] = Array.from(o).join(" ");
        }
    }
    getActiveEffects() {
      if (this._internals) {
        const s = Array.from(this._internals.states);
        return e ? s.map((a) => a.replace(/^--/g, "")) : s;
      }
      const i = (this.dataset[jS] || "").trim();
      return i ? i.split(/\s+/) : [];
    }
    watchChildList(r) {
      const i = this.querySelector(r);
      if (i) {
        let s = this._observers.get(i);
        s || (s = new MutationObserver(this._childListChangeHandler.bind(this, r)), this._observers.set(i, s), s.observe(i, {
          childList: !0
        }));
      }
    }
    _childListChangeHandler(r, i) {
      const s = this.dataset.interactKey, a = [], o = [];
      i.forEach((u) => {
        u.removedNodes.forEach((l) => {
          l instanceof HTMLElement && a.push(l);
        }), u.addedNodes.forEach((l) => {
          l instanceof HTMLElement && o.push(l);
        });
      }), X8(a), s && Fme(this, s, r, o);
    }
  };
}
function xme() {
  if (!customElements.get("interact-element")) {
    const t = vme();
    return customElements.define("interact-element", t), !0;
  }
  return !1;
}
function Cme(t) {
  return t.replace(/\[([-\w]+)]/g, "[]");
}
class vn {
  constructor() {
    pr(this, "dataCache", void 0), pr(this, "addedInteractions", void 0), pr(this, "listInteractionsCache", void 0), pr(this, "elements", void 0), pr(this, "mediaQueryListeners", void 0), this.dataCache = {
      effects: {},
      conditions: {},
      interactions: {}
    }, this.addedInteractions = {}, this.listInteractionsCache = {}, this.elements = /* @__PURE__ */ new Set(), this.mediaQueryListeners = /* @__PURE__ */ new Map();
  }
  init(e) {
    if (typeof window > "u" || !window.customElements)
      return;
    this.dataCache = _me(e), xme() || vn.elementCache.forEach((r, i) => r.connect(i));
  }
  destroy() {
    for (const e of this.elements)
      e.disconnect();
    for (const [, e] of this.mediaQueryListeners.entries())
      e.mql.removeEventListener("change", e.handler);
    this.mediaQueryListeners.clear(), this.addedInteractions = {}, this.listInteractionsCache = {}, this.elements.clear(), this.dataCache = {
      effects: {},
      conditions: {},
      interactions: {}
    }, vn.instances.splice(vn.instances.indexOf(this), 1);
  }
  setElement(e, n) {
    this.elements.add(n), vn.setElement(e, n);
  }
  deleteElement(e) {
    const n = vn.elementCache.get(e);
    this.clearInteractionStateForKey(e), this.clearMediaQueryListenersForKey(e), n && (this.elements.delete(n), vn.elementCache.delete(e));
  }
  has(e) {
    return !!this.get(e);
  }
  get(e) {
    const n = Cme(e);
    return this.dataCache.interactions[n];
  }
  clearInteractionStateForKey(e) {
    var n;
    (((n = this.get(e)) == null ? void 0 : n.interactionIds) || []).forEach((i) => {
      const s = Fg(i, e);
      delete this.addedInteractions[s];
    });
  }
  clearMediaQueryListenersForKey(e) {
    for (const [n, r] of this.mediaQueryListeners.entries())
      r.key === e && (r.mql.removeEventListener("change", r.handler), this.mediaQueryListeners.delete(n));
  }
  setupMediaQueryListener(e, n, r, i) {
    this.mediaQueryListeners.has(e) || (n.addEventListener("change", i), this.mediaQueryListeners.set(e, {
      mql: n,
      handler: i,
      key: r
    }));
  }
  static create(e) {
    const n = new vn();
    return vn.instances.push(n), n.init(e), n;
  }
  static destroy() {
    vn.elementCache.forEach((e) => {
      e.disconnect();
    }), vn.instances.length = 0, vn.elementCache.clear();
  }
  static setup(e) {
    e.scrollOptionsGetter && (Xc.viewProgress.registerOptionsGetter == null || Xc.viewProgress.registerOptionsGetter(e.scrollOptionsGetter)), e.pointerOptionsGetter && (Xc.pointerMove.registerOptionsGetter == null || Xc.pointerMove.registerOptionsGetter(e.pointerOptionsGetter)), e.viewEnter && Xc.viewEnter.setOptions(e.viewEnter), e.allowA11yTriggers !== void 0 && (vn.allowA11yTriggers = e.allowA11yTriggers);
  }
  static getInstance(e) {
    return vn.instances.find((n) => n.has(e));
  }
  static getElement(e) {
    return e ? vn.elementCache.get(e) : void 0;
  }
  static setElement(e, n) {
    vn.elementCache.set(e, n);
  }
}
pr(vn, "forceReducedMotion", !1);
pr(vn, "allowA11yTriggers", !0);
pr(vn, "instances", []);
pr(vn, "elementCache", /* @__PURE__ */ new Map());
let kme = 0;
function xT(t, e) {
  let {
    asCombinator: n = !1,
    addItemFilter: r = !1
  } = e === void 0 ? {} : e;
  if (t.listContainer) {
    const i = `${r && t.listItemSelector ? ` > ${t.listItemSelector}` : ""}`;
    return t.selector ? `${t.listContainer}${i} ${t.selector}` : `${t.listContainer}${i || " > *"}`;
  } else if (t.selector)
    return t.selector;
  return n ? "> :first-child" : ":scope > :first-child";
}
function _me(t) {
  var e;
  const n = t.conditions || {}, r = {};
  return (e = t.interactions) == null || e.forEach((i) => {
    const s = i.key, a = ++kme, {
      effects: o,
      ...u
    } = i;
    if (!s) {
      console.error(`Interaction ${a} is missing a key for source element.`);
      return;
    }
    r[s] || (r[s] = {
      triggers: [],
      effects: {},
      interactionIds: /* @__PURE__ */ new Set(),
      selectors: /* @__PURE__ */ new Set()
    });
    const l = Array.from(o);
    l.reverse();
    const h = {
      ...u,
      effects: l
    };
    r[s].triggers.push(h), r[s].selectors.add(xT(h));
    const f = h.listContainer;
    l.forEach((m) => {
      let g = m.key;
      if (!g && m.effectId) {
        const w = t.effects[m.effectId];
        w && (g = w.key);
      }
      m.effectId || (m.effectId = Sfe()), g = g || s, m.key = g;
      const A = m.effectId;
      if (f && m.listContainer && (g !== s || m.listContainer !== f))
        return;
      const E = `${s}::${g}::${A}::${a}`;
      m.interactionId = E, r[s].interactionIds.add(E), g !== s && (r[g] ? r[g].effects[E] || (r[g].effects[E] = [], r[g].interactionIds.add(E)) : r[g] = {
        triggers: [],
        effects: {
          [E]: []
        },
        interactionIds: /* @__PURE__ */ new Set(),
        selectors: /* @__PURE__ */ new Set()
      }, r[g].effects[E].push({
        ...u,
        effect: m
      }), r[g].selectors.add(xT(m)));
    });
  }), {
    effects: t.effects || {},
    conditions: n,
    interactions: r
  };
}
const TC = "@wix/site-service-device-info", Nme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DeviceInfoDefinition: TC
}, Symbol.toStringTag, { value: "Module" })), vC = "@wix/site-service-experiments", Dme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ExperimentsDefinition: vC
}, Symbol.toStringTag, { value: "Module" })), xC = "@wix/site-service-rendering-context", Ime = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RenderingContextDefinition: xC
}, Symbol.toStringTag, { value: "Module" })), Rme = "@wix/site-service-pages", CC = "core:provide-component", Pme = (t, e) => `
    await import(\`https://static.parastorage.com/services/interact/dist/interact.umd.min.js\`);

    const configElement = document.getElementById(\`${t}\`);
    if (configElement) {
        const Interact = window.interact?.Interact;
        if (!Interact) {
            console.error(\`Interact library is not loaded\`);
        } else {
            const config = JSON.parse(decodeURIComponent(configElement.textContent));

            Interact.forceReducedMotion = ${e};
            Interact.setup({
                scrollOptionsGetter: function(){ return document.getElementById(\`site-root\`) },
                allowA11yTriggers: true,
            });

            Interact.create(config);
        }
    }
`, Lme = (t, e, n) => () => {
  const r = `interactions-config-${n}`, i = Pme(r, e);
  return gr.createElement(
    gr.Fragment,
    null,
    gr.createElement("script", { type: "application/json", id: r }, encodeURIComponent(JSON.stringify(t))),
    gr.createElement("script", { type: "module", id: `interactions-loader-${n}` }, i)
  );
}, yD = (t, e) => {
  vn.forceReducedMotion = e, vn.setup({
    scrollOptionsGetter: () => globalThis.document.getElementById("site-root"),
    allowA11yTriggers: !0
  }), vn.create(t);
}, Mme = (t, e, n) => {
  if (!(t.interactions?.length > 0))
    return !1;
  const { currentPage: i } = n(Rme), s = i?.id;
  if (!s)
    return !1;
  const { addTopComponent: a } = n(CC), o = Lme(t, e, s);
  return a(o), !0;
}, Ome = (t) => t.reduce((e, { key: n, effects: r }) => (e.add(n), r.forEach(({ key: i }) => e.add(i)), e), /* @__PURE__ */ new Set()), Z8 = (t, e) => {
  const { reducedMotion: n } = e(TC), { isOpen: r } = e(vC), { SSR: i } = e(xC);
  if (r("specs.thunderbolt.interactionsInSsr")) {
    let a = !1;
    try {
      a = Mme(t, n, e);
    } catch (o) {
      console.warn("failed initializing Interact in SSR, falling back to client init:", o);
    }
    !a && !i && yD(t, n);
  } else
    yD(t, n);
  return {
    interactiveComps: Ome(t.interactions)
  };
}, Bme = (t, e) => {
  const { interactiveComps: n } = Z8(t, e), r = (s) => s.replace(/\[[^\]]+]/g, "[]");
  return {
    hasInteractions: (s) => n.has(r(s))
  };
}, kC = du("@wix/site-service-provide-css"), $me = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ProvideCssDefinition: kC
}, Symbol.toStringTag, { value: "Module" })), Hme = `
    wix-interact-element {
        display: contents;
    }
    `, Ume = `
    .has-click-trigger {
        cursor: pointer;
    }
    `, Gme = (t, e) => {
  const n = e(kC), i = [Hme, Ume].join(`
`);
  n.addStyle(i);
  const { interactiveComps: s } = Z8(t, e);
  return {
    hasInteractions: (o) => s.has(o)
  };
}, Wme = Ja(pC, ({ config: t, getService: e }) => Bme(t, e)), Vme = Ja(pC, ({ config: t, getService: e }) => Gme(t, e)), Kme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  InteractionsService: Wme,
  InteractionsServiceExternal: Vme
}, Symbol.toStringTag, { value: "Module" })), zme = /* @__PURE__ */ vt(Kme), jme = /* @__PURE__ */ vt(xue), Yme = /* @__PURE__ */ vt(EX), qme = /* @__PURE__ */ vt($me), Jme = Ja(kC, ({ getService: t }) => {
  const e = t(CC);
  return {
    addStyle: (r) => {
      if (!r)
        return;
      const i = () => OM("style", null, r.trim());
      e.addBottomComponent(i);
    }
  };
}), Qme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ProvideCssService: Jme
}, Symbol.toStringTag, { value: "Module" })), Xme = /* @__PURE__ */ vt(Qme), Zme = /* @__PURE__ */ vt(WZ), ege = (t) => {
  const e = t(CC);
  return {
    addGlobalStyle: (r) => {
      if (!r)
        return;
      const i = () => OM("style", null, r.trim());
      e.addBottomComponent(i);
    }
  };
}, tge = Ja(Wx, ({ getService: t }) => ege(t)), nge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ProvideCssService: tge
}, Symbol.toStringTag, { value: "Module" })), rge = /* @__PURE__ */ vt(nge), ige = /* @__PURE__ */ vt(Nme), sge = "Desktop", age = !1, oge = la(TC, ({ config: t, getService: e }) => {
  const { signal: n } = e(qg), r = n(t.deviceType ?? sge), i = n(t.reducedMotion ?? age);
  return {
    get deviceType() {
      return r.get();
    },
    get reducedMotion() {
      return i.get();
    },
    _updateConfig({ deviceType: s, reducedMotion: a }) {
      typeof s < "u" && r.set(s), typeof a < "u" && i.set(a);
    }
  };
}), uge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DeviceInfoService: oge
}, Symbol.toStringTag, { value: "Module" })), lge = /* @__PURE__ */ vt(uge), cge = /* @__PURE__ */ vt(Dme), hge = la(vC, ({ config: t }) => {
  const e = t.experiments ?? {};
  return {
    get all() {
      return e;
    },
    isOpen(n) {
      const r = e[n];
      return r === !0 || r === "true" || r === "B";
    }
  };
}), dge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ExperimentsService: hge
}, Symbol.toStringTag, { value: "Module" })), fge = /* @__PURE__ */ vt(dge), mge = /* @__PURE__ */ vt(Ime), gge = la(xC, ({ config: t }) => {
  const e = globalThis.window === void 0, n = t.seo ?? !1;
  return {
    get SSR() {
      return e;
    },
    get SEO() {
      return n;
    }
  };
}), pge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RenderingContextService: gge
}, Symbol.toStringTag, { value: "Module" })), bge = /* @__PURE__ */ vt(pge), e5 = "@wix/viewer-service-anchors", yge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnchorsDefinition: e5
}, Symbol.toStringTag, { value: "Module" })), Age = /* @__PURE__ */ vt(yge), Ege = "PAGE_TOP_ANCHOR", Sge = "SCROLL_TO_TOP", t5 = { compId: Ege, dataId: Sge }, wge = "WIX_ADS", Fge = 100, Tge = 100;
var YS, AD;
function n5() {
  if (AD) return YS;
  AD = 1;
  function t(e) {
    var n = typeof e;
    return e != null && (n == "object" || n == "function");
  }
  return YS = t, YS;
}
var qS, ED;
function vge() {
  if (ED) return qS;
  ED = 1;
  var t = typeof Ll == "object" && Ll && Ll.Object === Object && Ll;
  return qS = t, qS;
}
var JS, SD;
function r5() {
  if (SD) return JS;
  SD = 1;
  var t = vge(), e = typeof self == "object" && self && self.Object === Object && self, n = t || e || Function("return this")();
  return JS = n, JS;
}
var QS, wD;
function xge() {
  if (wD) return QS;
  wD = 1;
  var t = r5(), e = function() {
    return t.Date.now();
  };
  return QS = e, QS;
}
var XS, FD;
function Cge() {
  if (FD) return XS;
  FD = 1;
  var t = /\s/;
  function e(n) {
    for (var r = n.length; r-- && t.test(n.charAt(r)); )
      ;
    return r;
  }
  return XS = e, XS;
}
var ZS, TD;
function kge() {
  if (TD) return ZS;
  TD = 1;
  var t = Cge(), e = /^\s+/;
  function n(r) {
    return r && r.slice(0, t(r) + 1).replace(e, "");
  }
  return ZS = n, ZS;
}
var ew, vD;
function i5() {
  if (vD) return ew;
  vD = 1;
  var t = r5(), e = t.Symbol;
  return ew = e, ew;
}
var tw, xD;
function _ge() {
  if (xD) return tw;
  xD = 1;
  var t = i5(), e = Object.prototype, n = e.hasOwnProperty, r = e.toString, i = t ? t.toStringTag : void 0;
  function s(a) {
    var o = n.call(a, i), u = a[i];
    try {
      a[i] = void 0;
      var l = !0;
    } catch {
    }
    var h = r.call(a);
    return l && (o ? a[i] = u : delete a[i]), h;
  }
  return tw = s, tw;
}
var nw, CD;
function Nge() {
  if (CD) return nw;
  CD = 1;
  var t = Object.prototype, e = t.toString;
  function n(r) {
    return e.call(r);
  }
  return nw = n, nw;
}
var rw, kD;
function Dge() {
  if (kD) return rw;
  kD = 1;
  var t = i5(), e = _ge(), n = Nge(), r = "[object Null]", i = "[object Undefined]", s = t ? t.toStringTag : void 0;
  function a(o) {
    return o == null ? o === void 0 ? i : r : s && s in Object(o) ? e(o) : n(o);
  }
  return rw = a, rw;
}
var iw, _D;
function Ige() {
  if (_D) return iw;
  _D = 1;
  function t(e) {
    return e != null && typeof e == "object";
  }
  return iw = t, iw;
}
var sw, ND;
function Rge() {
  if (ND) return sw;
  ND = 1;
  var t = Dge(), e = Ige(), n = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || e(i) && t(i) == n;
  }
  return sw = r, sw;
}
var aw, DD;
function Pge() {
  if (DD) return aw;
  DD = 1;
  var t = kge(), e = n5(), n = Rge(), r = NaN, i = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, a = /^0o[0-7]+$/i, o = parseInt;
  function u(l) {
    if (typeof l == "number")
      return l;
    if (n(l))
      return r;
    if (e(l)) {
      var h = typeof l.valueOf == "function" ? l.valueOf() : l;
      l = e(h) ? h + "" : h;
    }
    if (typeof l != "string")
      return l === 0 ? l : +l;
    l = t(l);
    var f = s.test(l);
    return f || a.test(l) ? o(l.slice(2), f ? 2 : 8) : i.test(l) ? r : +l;
  }
  return aw = u, aw;
}
var ow, ID;
function Lge() {
  if (ID) return ow;
  ID = 1;
  var t = n5(), e = xge(), n = Pge(), r = "Expected a function", i = Math.max, s = Math.min;
  function a(o, u, l) {
    var h, f, m, g, A, E, w = 0, x = !1, N = !1, B = !0;
    if (typeof o != "function")
      throw new TypeError(r);
    u = n(u) || 0, t(l) && (x = !!l.leading, N = "maxWait" in l, m = N ? i(n(l.maxWait) || 0, u) : m, B = "trailing" in l ? !!l.trailing : B);
    function P(G) {
      var H = h, q = f;
      return h = f = void 0, w = G, g = o.apply(q, H), g;
    }
    function C(G) {
      return w = G, A = setTimeout(k, u), x ? P(G) : g;
    }
    function D(G) {
      var H = G - E, q = G - w, X = u - H;
      return N ? s(X, m - q) : X;
    }
    function L(G) {
      var H = G - E, q = G - w;
      return E === void 0 || H >= u || H < 0 || N && q >= m;
    }
    function k() {
      var G = e();
      if (L(G))
        return I(G);
      A = setTimeout(k, D(G));
    }
    function I(G) {
      return A = void 0, B && h ? P(G) : (h = f = void 0, g);
    }
    function U() {
      A !== void 0 && clearTimeout(A), w = 0, h = E = f = A = void 0;
    }
    function j() {
      return A === void 0 ? g : I(e());
    }
    function J() {
      var G = e(), H = L(G);
      if (h = arguments, f = this, E = G, H) {
        if (A === void 0)
          return C(E);
        if (N)
          return clearTimeout(A), A = setTimeout(k, u), P(E);
      }
      return A === void 0 && (A = setTimeout(k, u)), g;
    }
    return J.cancel = U, J.flush = j, J;
  }
  return ow = a, ow;
}
var Mge = Lge();
const RD = /* @__PURE__ */ kh(Mge), uw = (t) => ({
  compId: t.compId,
  dataId: t.dataId,
  name: t.name
}), Oge = (t, e, n) => {
  if (n.innerHeight + n.scrollY >= n.document.body.scrollHeight)
    return uw(t[t.length - 1]);
  const i = t.findIndex((s) => Math.floor(s.top - e) > 0);
  return i === -1 && t[t.length - 1] ? uw(t[t.length - 1]) : i === 0 || !t[i - 1] ? t5 : uw(t[i - 1]);
}, Bge = (t, e) => e.document.getElementById(t || "SITE_HEADER"), $ge = (t, e) => {
  const n = globalThis.window, { anchors: r, siteOffset: i, headerCompId: s, reCheckAnchors: a } = t, u = Bge(s, n)?.getBoundingClientRect().height;
  let l, h = u ?? i;
  const f = () => {
    const B = n.document.getElementById(wge);
    B && (h += B.offsetHeight), l = r.reduce((P, C) => {
      const D = n.document.getElementById(C.compId);
      return D && P.push({
        ...C,
        element: D,
        top: D.getBoundingClientRect().top || 0
      }), P;
    }, []), A();
  }, m = () => (a && (!l || r.length > l.length) && f(), l.map((B) => ({
    ...B,
    top: B.element.getBoundingClientRect().top || 0
  }))), g = () => {
    const B = Oge(l, h, n);
    B && e.set(B);
  }, A = () => l.sort((B, P) => B.top - P.top), E = (B) => {
    l = m(), B && A();
  }, w = (B = !1) => {
    Ni.measure(() => {
      E(B), g();
    });
  }, x = RD(w.bind(null, a), Fge), N = RD(w.bind(null, !0), Tge);
  return () => (Ni.measure(() => {
    f(), g();
  }), n.addEventListener("scroll", x), n.addEventListener("resize", N), () => {
    x.cancel(), N.cancel(), n.removeEventListener("scroll", x), n.removeEventListener("resize", N);
  });
}, Hge = la(e5, ({ getService: t }) => {
  const n = t(qg).signal(t5), r = t(No);
  let i = !1;
  return {
    getActiveAnchor: () => n.get(),
    observeAnchors: (s) => {
      if (r.isSSR())
        return console.warn("observeAnchors is not supported in SSR"), () => () => {
        };
      const a = $ge(s, n);
      return () => {
        if (i)
          return console.warn("Already observing, please clean up the previous observer before calling observeAnchors again"), () => {
          };
        const o = a();
        return i = !0, () => {
          o(), i = !1;
        };
      };
    }
  };
}), Uge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnchorsService: Hge
}, Symbol.toStringTag, { value: "Module" })), Gge = /* @__PURE__ */ vt(Uge);
function s5(t, e) {
  return e;
}
s5.withConfig = function() {
  return function(t, e) {
    return e;
  };
};
const a5 = "@wix/viewer-service-translations", Wge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TranslationsDefinition: a5
}, Symbol.toStringTag, { value: "Module" })), Vge = /* @__PURE__ */ vt(Wge), Kge = "core:signals", zge = s5(a5, ({ config: t, getService: e }) => {
  const { signal: n } = e(Kge), r = n(t.translations);
  return {
    translate: (i) => (s) => r.get()[i]?.[s] ?? s,
    onConfigChange(i) {
      r.set({
        ...r.get(),
        ...i.translations
      });
    }
  };
}), jge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TranslationsService: zge
}, Symbol.toStringTag, { value: "Module" })), Yge = /* @__PURE__ */ vt(jge);
var PD;
function qge() {
  if (PD) return Xh;
  PD = 1;
  var t = Xh && Xh.__importDefault || function(qt) {
    return qt && qt.__esModule ? qt : { default: qt };
  };
  Object.defineProperty(Xh, "__esModule", { value: !0 }), Xh.WixServicesWrapper = Tn;
  const e = t(gr), n = aX, r = TX, i = kX, s = RX, a = LX, o = GX, u = VX, l = HZ, h = GZ, f = jZ, m = qZ, g = ree, A = /* @__PURE__ */ une(), E = cne, w = mne, x = pne, N = _ne, B = Dne, P = Hne, C = nre, D = rre, L = sre, k = lre, I = hre, U = vue, j = zme, J = jme, G = Yme, H = qme, q = Xme, X = Zme, ie = rge, te = ige, Pe = lge, We = cge, Me = fge, Le = mge, fn = bge, Yt = Age, Rn = Gge, Pn = Vge, ls = Yge;
  function Tn({ children: qt }) {
    const yr = [
      { definition: a.CyclicTabbingDefinition, impl: o.CyclicTabbingService, config: {} },
      { definition: u.LinkUtilsDefinition, impl: l.LinkUtilsService, config: {} },
      { definition: h.SiteScrollBlockerDefinition, impl: f.SiteScrollBlockerService, config: {} },
      { definition: m.StyleUtilsDefinition, impl: g.StyleUtilsService, config: {} },
      { definition: A.ImagePlaceholderDefintion, impl: A.ImagePlaceholderService, config: {} },
      { definition: E.BusinessLoggerDefinition, impl: w.BusinessLoggerService, config: {} },
      {
        definition: i.EnvironmentDefinition,
        impl: s.EnvironmentService,
        config: { experiments: { "specs.thunderbolt.isClassNameToRootEnabled": !0 } }
      },
      {
        definition: x.UrlDefinition,
        impl: N.UrlService,
        config: { externalBaseUrl: "https://wix.com", requestUrl: "https://wix.com" }
      },
      {
        definition: B.WindowNsDefinition,
        impl: P.WindowNsService,
        config: {}
      },
      {
        definition: D.WindowScrollDefinition,
        impl: C.WindowScrollService,
        config: {}
      },
      { definition: L.FedopsLoggerDefinition, impl: k.FedopsLoggerService, config: {} },
      {
        definition: G.ProvideComponentServiceDefinition,
        impl: G.ProvideComponentServiceFactory,
        config: {}
      },
      { definition: H.ProvideCssDefinition, impl: q.ProvideCssService, config: {} },
      { definition: X.ProvideCssDefinition, impl: ie.ProvideCssService, config: {} },
      { definition: te.DeviceInfoDefinition, impl: Pe.DeviceInfoService, config: {} },
      { definition: We.ExperimentsDefinition, impl: Me.ExperimentsService, config: {} },
      { definition: Le.RenderingContextDefinition, impl: fn.RenderingContextService, config: {} },
      {
        definition: J.InteractionsDefinition,
        impl: j.InteractionsServiceExternal,
        config: {
          effects: {},
          conditions: {},
          interactions: []
        }
      },
      {
        definition: I.WixClientDefinition,
        impl: U.WixClientService,
        config: { clientId: "c089c8d7-83ed-41a0-9cb2-5e0add5e20fa" }
      },
      { definition: Yt.AnchorsDefinition, impl: Rn.AnchorsService, config: {} },
      { definition: Pn.TranslationsDefinition, impl: ls.TranslationsService, config: { translations: {} } }
    ], $n = (0, n.createServicesManager)((0, n.createServicesMap)(yr));
    return e.default.createElement(r.ServicesManagerProvider, { servicesManager: $n }, qt);
  }
  return Xh;
}
var LD;
function Jge() {
  return LD || (LD = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.WixServicesWrapper = void 0;
    var e = qge();
    Object.defineProperty(t, "WixServicesWrapper", { enumerable: !0, get: function() {
      return e.WixServicesWrapper;
    } });
  })(dS)), dS;
}
var Qge = Jge();
const Xge = {
  withStackTrace: !1
}, o5 = (t, e, n = Xge) => {
  const r = e.isOk() ? { type: "Ok", value: e.value } : { type: "Err", value: e.error }, i = n.withStackTrace ? new Error().stack : void 0;
  return {
    data: r,
    message: t,
    stack: i
  };
};
function Uc(t, e, n, r) {
  function i(s) {
    return s instanceof n ? s : new n(function(a) {
      a(s);
    });
  }
  return new (n || (n = Promise))(function(s, a) {
    function o(h) {
      try {
        l(r.next(h));
      } catch (f) {
        a(f);
      }
    }
    function u(h) {
      try {
        l(r.throw(h));
      } catch (f) {
        a(f);
      }
    }
    function l(h) {
      h.done ? s(h.value) : i(h.value).then(o, u);
    }
    l((r = r.apply(t, [])).next());
  });
}
function MD(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Qo(t) {
  return this instanceof Qo ? (this.v = t, this) : new Qo(t);
}
function OD(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), i, s = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), o("next"), o("throw"), o("return", a), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function a(g) {
    return function(A) {
      return Promise.resolve(A).then(g, f);
    };
  }
  function o(g, A) {
    r[g] && (i[g] = function(E) {
      return new Promise(function(w, x) {
        s.push([g, E, w, x]) > 1 || u(g, E);
      });
    }, A && (i[g] = A(i[g])));
  }
  function u(g, A) {
    try {
      l(r[g](A));
    } catch (E) {
      m(s[0][3], E);
    }
  }
  function l(g) {
    g.value instanceof Qo ? Promise.resolve(g.value.v).then(h, f) : m(s[0][2], g);
  }
  function h(g) {
    u("next", g);
  }
  function f(g) {
    u("throw", g);
  }
  function m(g, A) {
    g(A), s.shift(), s.length && u(s[0][0], s[0][1]);
  }
}
function Zge(t) {
  var e, n;
  return e = {}, r("next"), r("throw", function(i) {
    throw i;
  }), r("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function r(i, s) {
    e[i] = t[i] ? function(a) {
      return (n = !n) ? { value: Qo(t[i](a)), done: !1 } : s ? s(a) : a;
    } : s;
  }
}
function epe(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof MD == "function" ? MD(t) : t[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(s) {
    n[s] = t[s] && function(a) {
      return new Promise(function(o, u) {
        a = t[s](a), i(o, u, a.done, a.value);
      });
    };
  }
  function i(s, a, o, u) {
    Promise.resolve(u).then(function(l) {
      s({ value: l, done: o });
    }, a);
  }
}
class ar {
  constructor(e) {
    this._promise = e;
  }
  static fromSafePromise(e) {
    const n = e.then((r) => new uo(r));
    return new ar(n);
  }
  static fromPromise(e, n) {
    const r = e.then((i) => new uo(i)).catch((i) => new lo(n(i)));
    return new ar(r);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static fromThrowable(e, n) {
    return (...r) => new ar(Uc(this, void 0, void 0, function* () {
      try {
        return new uo(yield e(...r));
      } catch (i) {
        return new lo(n ? n(i) : i);
      }
    }));
  }
  static combine(e) {
    return npe(e);
  }
  static combineWithAllErrors(e) {
    return rpe(e);
  }
  map(e) {
    return new ar(this._promise.then((n) => Uc(this, void 0, void 0, function* () {
      return n.isErr() ? new lo(n.error) : new uo(yield e(n.value));
    })));
  }
  andThrough(e) {
    return new ar(this._promise.then((n) => Uc(this, void 0, void 0, function* () {
      if (n.isErr())
        return new lo(n.error);
      const r = yield e(n.value);
      return r.isErr() ? new lo(r.error) : new uo(n.value);
    })));
  }
  andTee(e) {
    return new ar(this._promise.then((n) => Uc(this, void 0, void 0, function* () {
      if (n.isErr())
        return new lo(n.error);
      try {
        yield e(n.value);
      } catch {
      }
      return new uo(n.value);
    })));
  }
  orTee(e) {
    return new ar(this._promise.then((n) => Uc(this, void 0, void 0, function* () {
      if (n.isOk())
        return new uo(n.value);
      try {
        yield e(n.error);
      } catch {
      }
      return new lo(n.error);
    })));
  }
  mapErr(e) {
    return new ar(this._promise.then((n) => Uc(this, void 0, void 0, function* () {
      return n.isOk() ? new uo(n.value) : new lo(yield e(n.error));
    })));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThen(e) {
    return new ar(this._promise.then((n) => {
      if (n.isErr())
        return new lo(n.error);
      const r = e(n.value);
      return r instanceof ar ? r._promise : r;
    }));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  orElse(e) {
    return new ar(this._promise.then((n) => Uc(this, void 0, void 0, function* () {
      return n.isErr() ? e(n.error) : new uo(n.value);
    })));
  }
  match(e, n) {
    return this._promise.then((r) => r.match(e, n));
  }
  unwrapOr(e) {
    return this._promise.then((n) => n.unwrapOr(e));
  }
  /**
   * @deprecated will be removed in 9.0.0.
   *
   * You can use `safeTry` without this method.
   * @example
   * ```typescript
   * safeTry(async function* () {
   *   const okValue = yield* yourResult
   * })
   * ```
   * Emulates Rust's `?` operator in `safeTry`'s body. See also `safeTry`.
   */
  safeUnwrap() {
    return OD(this, arguments, function* () {
      return yield Qo(yield Qo(yield* Zge(epe(yield Qo(this._promise.then((n) => n.safeUnwrap()))))));
    });
  }
  // Makes ResultAsync implement PromiseLike<Result>
  then(e, n) {
    return this._promise.then(e, n);
  }
  [Symbol.asyncIterator]() {
    return OD(this, arguments, function* () {
      const n = yield Qo(this._promise);
      return n.isErr() && (yield yield Qo(gh(n.error))), yield Qo(n.value);
    });
  }
}
function tpe(t) {
  return new ar(Promise.resolve(new uo(t)));
}
function gh(t) {
  return new ar(Promise.resolve(new lo(t)));
}
ar.fromPromise;
ar.fromSafePromise;
ar.fromThrowable;
const u5 = (t) => {
  let e = Gr([]);
  for (const n of t)
    if (n.isErr()) {
      e = Ps(n.error);
      break;
    } else
      e.map((r) => r.push(n.value));
  return e;
}, npe = (t) => ar.fromSafePromise(Promise.all(t)).andThen(u5), l5 = (t) => {
  let e = Gr([]);
  for (const n of t)
    n.isErr() && e.isErr() ? e.error.push(n.error) : n.isErr() && e.isOk() ? e = Ps([n.error]) : n.isOk() && e.isOk() && e.value.push(n.value);
  return e;
}, rpe = (t) => ar.fromSafePromise(Promise.all(t)).andThen(l5);
var hf;
(function(t) {
  function e(i, s) {
    return (...a) => {
      try {
        const o = i(...a);
        return Gr(o);
      } catch (o) {
        return Ps(s ? s(o) : o);
      }
    };
  }
  t.fromThrowable = e;
  function n(i) {
    return u5(i);
  }
  t.combine = n;
  function r(i) {
    return l5(i);
  }
  t.combineWithAllErrors = r;
})(hf || (hf = {}));
function Gr(t) {
  return new uo(t);
}
function Ps(t) {
  return new lo(t);
}
class uo {
  constructor(e) {
    this.value = e;
  }
  isOk() {
    return !0;
  }
  isErr() {
    return !this.isOk();
  }
  map(e) {
    return Gr(e(this.value));
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mapErr(e) {
    return Gr(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThen(e) {
    return e(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThrough(e) {
    return e(this.value).map((n) => this.value);
  }
  andTee(e) {
    try {
      e(this.value);
    } catch {
    }
    return Gr(this.value);
  }
  orTee(e) {
    return Gr(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  orElse(e) {
    return Gr(this.value);
  }
  asyncAndThen(e) {
    return e(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  asyncAndThrough(e) {
    return e(this.value).map(() => this.value);
  }
  asyncMap(e) {
    return ar.fromSafePromise(e(this.value));
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  unwrapOr(e) {
    return this.value;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  match(e, n) {
    return e(this.value);
  }
  safeUnwrap() {
    const e = this.value;
    return (function* () {
      return e;
    })();
  }
  _unsafeUnwrap(e) {
    return this.value;
  }
  _unsafeUnwrapErr(e) {
    throw o5("Called `_unsafeUnwrapErr` on an Ok", this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-this-alias, require-yield
  *[Symbol.iterator]() {
    return this.value;
  }
}
class lo {
  constructor(e) {
    this.error = e;
  }
  isOk() {
    return !1;
  }
  isErr() {
    return !this.isOk();
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  map(e) {
    return Ps(this.error);
  }
  mapErr(e) {
    return Ps(e(this.error));
  }
  andThrough(e) {
    return Ps(this.error);
  }
  andTee(e) {
    return Ps(this.error);
  }
  orTee(e) {
    try {
      e(this.error);
    } catch {
    }
    return Ps(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThen(e) {
    return Ps(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  orElse(e) {
    return e(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  asyncAndThen(e) {
    return gh(this.error);
  }
  asyncAndThrough(e) {
    return gh(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  asyncMap(e) {
    return gh(this.error);
  }
  unwrapOr(e) {
    return e;
  }
  match(e, n) {
    return n(this.error);
  }
  safeUnwrap() {
    const e = this.error;
    return (function* () {
      throw yield Ps(e), new Error("Do not use this generator out of `safeTry`");
    })();
  }
  _unsafeUnwrap(e) {
    throw o5("Called `_unsafeUnwrap` on an Err", this, e);
  }
  _unsafeUnwrapErr(e) {
    return this.error;
  }
  *[Symbol.iterator]() {
    const e = this;
    return yield e, e;
  }
}
hf.fromThrowable;
var BD;
(function(t) {
  t.UNKNOWN_PanelContentType = "UNKNOWN_PanelContentType", t.url = "url", t.code = "code";
})(BD || (BD = {}));
var CT;
(function(t) {
  t.UNKNOWN_DataType = "UNKNOWN_DataType", t.text = "text", t.textEnum = "textEnum", t.number = "number", t.booleanValue = "booleanValue", t.a11y = "a11y", t.link = "link", t.image = "image", t.video = "video", t.vectorArt = "vectorArt", t.audio = "audio", t.schema = "schema", t.localDate = "localDate", t.localTime = "localTime", t.localDateTime = "localDateTime", t.webUrl = "webUrl", t.email = "email", t.phone = "phone", t.hostname = "hostname", t.regex = "regex", t.guid = "guid", t.richText = "richText", t.container = "container", t.arrayItems = "arrayItems", t.direction = "direction", t.menuItems = "menuItems", t.data = "data", t.function = "function", t.onClick = "onClick", t.onChange = "onChange", t.onKeyPress = "onKeyPress", t.onKeyUp = "onKeyUp", t.onSubmit = "onSubmit";
})(CT || (CT = {}));
var kT;
(function(t) {
  t.Unknown_AriaAttributes = "Unknown_AriaAttributes", t.tabIndex = "tabIndex", t.ariaLevel = "ariaLevel", t.ariaExpanded = "ariaExpanded", t.ariaDisabled = "ariaDisabled", t.ariaAtomic = "ariaAtomic", t.ariaHidden = "ariaHidden", t.ariaBusy = "ariaBusy", t.multiline = "multiline", t.ariaAutocomplete = "ariaAutocomplete", t.ariaPressed = "ariaPressed", t.ariaHaspopup = "ariaHaspopup", t.ariaRelevant = "ariaRelevant", t.role = "role", t.ariaLive = "ariaLive", t.ariaCurrent = "ariaCurrent", t.ariaLabel = "ariaLabel", t.ariaRoledescription = "ariaRoledescription", t.ariaDescribedby = "ariaDescribedby", t.ariaLabelledby = "ariaLabelledby", t.ariaErrormessage = "ariaErrormessage", t.ariaOwns = "ariaOwns", t.ariaControls = "ariaControls", t.tag = "tag", t.ariaMultiline = "ariaMultiline", t.ariaInvalid = "ariaInvalid";
})(kT || (kT = {}));
var _T;
(function(t) {
  t.UNKNOWN_LinkType = "UNKNOWN_LinkType", t.externalLink = "externalLink", t.anchorLink = "anchorLink", t.emailLink = "emailLink", t.phoneLink = "phoneLink", t.dynamicPageLink = "dynamicPageLink", t.pageLink = "pageLink", t.whatsAppLink = "whatsAppLink", t.documentLink = "documentLink", t.popupLink = "popupLink", t.addressLink = "addressLink", t.edgeAnchorLinks = "edgeAnchorLinks", t.loginToWixLink = "loginToWixLink";
})(_T || (_T = {}));
var NT;
(function(t) {
  t.UNKNOWN_CONTAINER_TYPE = "UNKNOWN_CONTAINER_TYPE", t.simple = "simple", t.slot = "slot", t.placeholder = "placeholder", t.template = "template";
})(NT || (NT = {}));
var $D;
(function(t) {
  t.UNKNOWN_ResizeDirection = "UNKNOWN_ResizeDirection", t.horizontal = "horizontal", t.vertical = "vertical", t.horizontalAndVertical = "horizontalAndVertical", t.aspectRatio = "aspectRatio", t.none = "none";
})($D || ($D = {}));
var DT;
(function(t) {
  t.UNKNOWN_ContentResizeDirection = "UNKNOWN_ContentResizeDirection", t.horizontal = "horizontal", t.vertical = "vertical", t.horizontalAndVertical = "horizontalAndVertical", t.none = "none";
})(DT || (DT = {}));
var IT;
(function(t) {
  t.UNKNOWN_CategoryName = "UNKNOWN_CategoryName", t.IMAGE = "IMAGE", t.IMAGE_BACKGROUND = "IMAGE_BACKGROUND";
})(IT || (IT = {}));
var HD;
(function(t) {
  t.UNKNOWN_VideoCategoryTypes = "UNKNOWN_VideoCategoryTypes", t.VIDEO = "VIDEO", t.VIDEO_TRANSPARENT = "VIDEO_TRANSPARENT", t.VIDEO_OPAQUE = "VIDEO_OPAQUE";
})(HD || (HD = {}));
var UD;
(function(t) {
  t.UNKNOWN_VectorArtCategoryTypes = "UNKNOWN_VectorArtCategoryTypes", t.SHAPE_ALL = "SHAPE_ALL", t.SHAPE_BASIC = "SHAPE_BASIC", t.SHAPE_ART = "SHAPE_ART", t.ICON_SOCIAL = "ICON_SOCIAL", t.SHAPE_DIVIDERS = "SHAPE_DIVIDERS", t.SHAPE_LOCATION = "SHAPE_LOCATION", t.SHAPE_DOCUMENTS = "SHAPE_DOCUMENTS", t.SHAPE_SOCIAL = "SHAPE_SOCIAL", t.SHAPE_ARROWS = "SHAPE_ARROWS";
})(UD || (UD = {}));
var RT;
(function(t) {
  t.UNKNOWN_ElementType = "UNKNOWN_ElementType", t.inlineElement = "inlineElement", t.refElement = "refElement";
})(RT || (RT = {}));
var GD;
(function(t) {
  t.UNKNOWN_FilterFunctions = "UNKNOWN_FilterFunctions", t.blur = "blur", t.brightness = "brightness", t.contrast = "contrast", t.drop_shadow = "drop_shadow", t.grayscale = "grayscale", t.hue_rotate = "hue_rotate", t.invert = "invert", t.opacity = "opacity", t.sepia = "sepia", t.saturate = "saturate", t.dropShadow = "dropShadow", t.hueRotate = "hueRotate";
})(GD || (GD = {}));
var PT;
(function(t) {
  t.UNKNOWN_DisplayValue = "UNKNOWN_DisplayValue", t.none = "none", t.block = "block", t.inline = "inline", t.flow = "flow", t.flowRoot = "flowRoot", t.table = "table", t.flex = "flex", t.grid = "grid", t.list_item = "list_item", t.contents = "contents", t.inline_block = "inline_block", t.inline_table = "inline_table", t.inline_flex = "inline_flex", t.inline_grid = "inline_grid", t.inlineBlock = "inlineBlock", t.inlineTable = "inlineTable", t.inlineFlex = "inlineFlex", t.inlineGrid = "inlineGrid", t.listItem = "listItem";
})(PT || (PT = {}));
var WD;
(function(t) {
  t.UNKNOWN_WritingModeValue = "UNKNOWN_WritingModeValue", t.horizontalTb = "horizontalTb", t.verticalRl = "verticalRl", t.verticalLr = "verticalLr", t.sidewaysRl = "sidewaysRl", t.sidewaysLr = "sidewaysLr";
})(WD || (WD = {}));
var VD;
(function(t) {
  t.UNKNOWN_BackgroundModeEnum = "UNKNOWN_BackgroundModeEnum", t.shapeDividerSvg = "shapeDividerSvg";
})(VD || (VD = {}));
var KD;
(function(t) {
  t.UNKNOWN_ActionType = "UNKNOWN_ActionType", t.data = "data", t.event = "event", t.panel = "panel", t.forward = "forward", t.style = "style", t.displayGroup = "displayGroup", t.cssProperty = "cssProperty", t.cssCustomProperty = "cssCustomProperty";
})(KD || (KD = {}));
var zD;
(function(t) {
  t.UNKNOWN_PanelType = "UNKNOWN_PanelType", t.panelId = "panelId", t.inline = "inline";
})(zD || (zD = {}));
var jD;
(function(t) {
  t.UNKNOWN_ActionName = "UNKNOWN_ActionName", t.settings = "settings", t.design = "design", t.media = "media", t.manageItems = "manageItems", t.dashboard = "dashboard", t.custom = "custom", t.manageMenu = "manageMenu", t.container = "container";
})(jD || (jD = {}));
var YD;
(function(t) {
  t.UNKNOWN_SizingType = "UNKNOWN_SizingType", t.content = "content", t.stretched = "stretched", t.pixels = "pixels";
})(YD || (YD = {}));
var qD;
(function(t) {
  t.UNKNOWN_Breakpoint = "UNKNOWN_Breakpoint", t.small = "small", t.large = "large";
})(qD || (qD = {}));
var JD;
(function(t) {
  t.UNKNOWN_Archetype = "UNKNOWN_Archetype", t.Button = "Button", t.LoginButton = "LoginButton", t.Image = "Image", t.Gallery = "Gallery", t.Video = "Video", t.Audio = "Audio", t.Text = "Text", t.TextInput = "TextInput", t.RichTextEditor = "RichTextEditor", t.SignatureInput = "SignatureInput", t.Checkbox = "Checkbox", t.RadioGroup = "RadioGroup", t.Switch = "Switch", t.Dropdown = "Dropdown", t.DatePicker = "DatePicker", t.TimePicker = "TimePicker", t.Ratings = "Ratings", t.RatingInput = "RatingInput", t.Menu = "Menu", t.Pagination = "Pagination", t.Slider = "Slider", t.Container = "Container", t.Carousel = "Carousel", t.Accordion = "Accordion", t.Tabs = "Tabs", t.ProgressBar = "ProgressBar", t.Upload = "Upload", t.Social = "Social", t.Breadcrumbs = "Breadcrumbs", t.SearchBox = "SearchBox", t.Map = "Map", t.Line = "Line", t.Logo = "Logo", t.Avatar = "Avatar", t.Captcha = "Captcha", t.VectorArt = "VectorArt", t.AnimatedGraphic = "AnimatedGraphic", t.Cart = "Cart", t.ContactForm = "ContactForm", t.Frame = "Frame", t.Divider = "Divider";
})(JD || (JD = {}));
var Cd;
(function(t) {
  t.UNKNOWN_NativeStateType = "UNKNOWN_NativeStateType", t.hover = "hover", t.focus = "focus", t.disabled = "disabled", t.invalid = "invalid";
})(Cd || (Cd = {}));
var QD;
(function(t) {
  t.UNKNOWN_GroupType = "UNKNOWN_GroupType", t.cssDataType = "cssDataType", t.dataType = "dataType", t.preset = "preset", t.data = "data", t.presets = "presets", t.cssCustomProperties = "cssCustomProperties", t.displayGroups = "displayGroups", t.background = "background", t.margin = "margin", t.padding = "padding", t.border = "border", t.borderTop = "borderTop", t.borderRight = "borderRight", t.borderBottom = "borderBottom", t.borderLeft = "borderLeft", t.borderRadius = "borderRadius", t.borderInlineStart = "borderInlineStart", t.borderInlineEnd = "borderInlineEnd", t.borderColor = "borderColor", t.borderWidth = "borderWidth", t.borderStyle = "borderStyle", t.font = "font", t.textDecoration = "textDecoration", t.gap = "gap", t.text = "text", t.arrayItems = "arrayItems", t.arrayItem = "arrayItem", t.listItem = "listItem";
})(QD || (QD = {}));
var XD;
(function(t) {
  t.UNKNOWN_ImageType = "UNKNOWN_ImageType", t.url = "url", t.image = "image", t.imageSet = "imageSet", t.crossFade = "crossFade", t.element = "element", t.gradient = "gradient";
})(XD || (XD = {}));
var Zs;
(function(t) {
  t.UNKNOWN_CssPropertyType = "UNKNOWN_CssPropertyType", t.number = "number", t.string = "string", t.angle = "angle", t.length = "length", t.percentage = "percentage", t.lengthPercentage = "lengthPercentage", t.blendMode = "blendMode", t.customEnum = "customEnum", t.time = "time", t.background = "background", t.backgroundSize = "backgroundSize", t.backgroundColor = "backgroundColor", t.backgroundImage = "backgroundImage", t.backgroundClip = "backgroundClip", t.backgroundOrigin = "backgroundOrigin", t.backgroundPosition = "backgroundPosition", t.backgroundRepeat = "backgroundRepeat", t.backgroundAttachment = "backgroundAttachment", t.margin = "margin", t.marginTop = "marginTop", t.marginRight = "marginRight", t.marginBottom = "marginBottom", t.marginLeft = "marginLeft", t.marginInlineStart = "marginInlineStart", t.marginInlineEnd = "marginInlineEnd", t.padding = "padding", t.paddingTop = "paddingTop", t.paddingRight = "paddingRight", t.paddingBottom = "paddingBottom", t.paddingLeft = "paddingLeft", t.paddingInlineStart = "paddingInlineStart", t.paddingInlineEnd = "paddingInlineEnd", t.border = "border", t.borderWidth = "borderWidth", t.borderStyle = "borderStyle", t.borderColor = "borderColor", t.borderTop = "borderTop", t.borderTopColor = "borderTopColor", t.borderTopWidth = "borderTopWidth", t.borderTopStyle = "borderTopStyle", t.borderRight = "borderRight", t.borderRightColor = "borderRightColor", t.borderRightWidth = "borderRightWidth", t.borderRightStyle = "borderRightStyle", t.borderBottom = "borderBottom", t.borderBottomColor = "borderBottomColor", t.borderBottomWidth = "borderBottomWidth", t.borderBottomStyle = "borderBottomStyle", t.borderLeft = "borderLeft", t.borderLeftColor = "borderLeftColor", t.borderLeftWidth = "borderLeftWidth", t.borderLeftStyle = "borderLeftStyle", t.borderInlineStart = "borderInlineStart", t.borderInlineStartColor = "borderInlineStartColor", t.borderInlineStartWidth = "borderInlineStartWidth", t.borderInlineStartStyle = "borderInlineStartStyle", t.borderInlineEnd = "borderInlineEnd", t.borderInlineEndColor = "borderInlineEndColor", t.borderInlineEndWidth = "borderInlineEndWidth", t.borderInlineEndStyle = "borderInlineEndStyle", t.borderRadius = "borderRadius", t.borderTopLeftRadius = "borderTopLeftRadius", t.borderTopRightRadius = "borderTopRightRadius", t.borderBottomRightRadius = "borderBottomRightRadius", t.borderBottomLeftRadius = "borderBottomLeftRadius", t.borderStartStartRadius = "borderStartStartRadius", t.borderStartEndRadius = "borderStartEndRadius", t.borderEndStartRadius = "borderEndStartRadius", t.borderEndEndRadius = "borderEndEndRadius", t.font = "font", t.fontFamily = "fontFamily", t.fontSize = "fontSize", t.fontStretch = "fontStretch", t.fontStyle = "fontStyle", t.fontVariant = "fontVariant", t.fontWeight = "fontWeight", t.lineHeight = "lineHeight", t.color = "color", t.letterSpacing = "letterSpacing", t.writingMode = "writingMode", t.textAlign = "textAlign", t.textTransform = "textTransform", t.textShadow = "textShadow", t.textOverflow = "textOverflow", t.textIndent = "textIndent", t.textDecoration = "textDecoration", t.textDecorationColor = "textDecorationColor", t.textDecorationLine = "textDecorationLine", t.textDecorationStyle = "textDecorationStyle", t.textDecorationThickness = "textDecorationThickness", t.boxShadow = "boxShadow", t.opacity = "opacity", t.overflow = "overflow", t.display = "display", t.alignSelf = "alignSelf", t.justifyContent = "justifyContent", t.alignItems = "alignItems", t.flexDirection = "flexDirection", t.height = "height", t.width = "width", t.gap = "gap", t.columnGap = "columnGap", t.rowGap = "rowGap", t.filter = "filter", t.backdropFilter = "backdropFilter", t.objectFit = "objectFit", t.objectPosition = "objectPosition", t.mixBlendMode = "mixBlendMode", t.isolation = "isolation", t.stroke = "stroke", t.strokeWidth = "strokeWidth", t.strokeOpacity = "strokeOpacity", t.fill = "fill", t.fillOpacity = "fillOpacity", t.fillRule = "fillRule", t.mask = "mask", t.maskImage = "maskImage", t.maskMode = "maskMode", t.maskRepeat = "maskRepeat", t.maskPosition = "maskPosition", t.maskClip = "maskClip", t.maskOrigin = "maskOrigin", t.maskSize = "maskSize", t.maskComposite = "maskComposite";
})(Zs || (Zs = {}));
var ZD;
(function(t) {
  t.UNKNOWN_TRIGGER = "UNKNOWN_TRIGGER", t.hover = "hover", t.click = "click", t.viewEnter = "viewEnter", t.pageVisible = "pageVisible", t.viewProgress = "viewProgress", t.pointerMove = "pointerMove", t.animationEnd = "animationEnd";
})(ZD || (ZD = {}));
var eI;
(function(t) {
  t.UNKNOWN_EFFECT_GROUP = "UNKNOWN_EFFECT_GROUP", t.background = "background";
})(eI || (eI = {}));
var tI;
(function(t) {
  t.UNKNOWN = "UNKNOWN", t.DEV = "DEV", t.DEV_PREVIEW = "DEV_PREVIEW", t.USER = "USER", t.INTERNAL_BUILD = "INTERNAL_BUILD", t.INTERNAL_RC = "INTERNAL_RC";
})(tI || (tI = {}));
var ps = {
  DATA_TYPE: CT,
  A11Y_ATTRIBUTES: kT,
  LINK_TYPE: _T
}, ipe = {
  number: Zs.number,
  string: Zs.string,
  angle: Zs.angle,
  color: Zs.color,
  length: Zs.length,
  percentage: Zs.percentage,
  lengthPercentage: Zs.lengthPercentage,
  blendMode: Zs.blendMode,
  customEnum: Zs.customEnum,
  time: Zs.time
}, Ns = {
  CSS_PROPERTY_TYPE: Zs,
  CSS_DATA_TYPE: ipe,
  DISPLAY_VALUE: PT
}, nI = {
  ELEMENT_TYPE: RT
}, spe = {
  CONTENT_RESIZE_DIRECTION: DT
}, ape = {
  IMAGE_CATEGORY: IT
};
const Uo = {
  POINTER: "POINTER",
  CHANGE: "CHANGE",
  FOCUS: "FOCUS",
  SUBMIT: "SUBMIT",
  KEYBOARD: "KEYBOARD"
}, _C = /^[a-zà-öø-ÿа-я]+|[A-ZÀ-ÖØ-ßА-Я][a-zà-öø-ÿа-я]+|[a-zà-öø-ÿа-я]+|[0-9]+|[A-ZÀ-ÖØ-ßА-Я]+(?![a-zà-öø-ÿа-я])/g, ope = /\S+/g;
function upe(t, e) {
  const n = { parts: [], prefixes: [] }, r = t.matchAll(e);
  let i = 0;
  for (const a of r) {
    if (typeof a.index != "number")
      continue;
    const o = a[0];
    n.parts.push(o);
    const u = t.slice(i, a.index).trim();
    n.prefixes.push(u), i = a.index + o.length;
  }
  const s = t.slice(i).trim();
  return s && (n.parts.push(""), n.prefixes.push(s)), n;
}
function NC(t, e) {
  const { keepSpecialCharacters: n = !1, keep: r, prefix: i = "" } = e || {}, s = t.trim().normalize("NFC"), a = s.includes(" "), u = upe(s, a ? ope : _C);
  return u.parts.map((l, h) => {
    let f = u.prefixes[h] || "", m = l;
    return n === !1 && (r && (m = m.normalize("NFD").replace(new RegExp(`[^a-zA-ZØßø0-9${r.join("")}]`, "g"), "")), r || (m = m.normalize("NFD").replace(/[^a-zA-ZØßø0-9]/g, ""), f = "")), r && f && (f = f.replace(new RegExp(`[^${r.join("")}]`, "g"), "")), h === 0 ? f + m : !f && !m ? "" : a && !f && i.match(/\s/) ? " " + m : (f || i) + m;
  }).filter(Boolean);
}
function c5(t) {
  const e = t.matchAll(_C).next().value, n = e ? e.index : 0;
  return t.slice(0, n + 1).toUpperCase() + t.slice(n + 1).toLowerCase();
}
function ip(t, e) {
  return NC(t, e).reduce((n, r, i) => i === 0 || !(r[0] || "").match(_C) ? n + r.toLowerCase() : n + c5(r), "");
}
function lpe(t, e) {
  return NC(t, { ...e, prefix: "-" }).join("").toLowerCase();
}
function cpe(t, e = { keepSpecialCharacters: !0 }) {
  return NC(t, { ...e, prefix: " " }).reduce((n, r) => n + c5(r), "");
}
const h5 = (t) => typeof t == "object" && t !== null, LT = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    writable: !0,
    enumerable: !1,
    configurable: !0
  });
}, d5 = (t) => {
  if (!(t instanceof Error))
    throw new TypeError(`First argument must be an error instance: ${t}`);
}, hpe = (t, e) => {
  d5(t), dpe(e) && !("cause" in t && e.cause === t.cause) && LT(t, "cause", e.cause);
}, dpe = (t) => h5(t) && "cause" in t, fpe = (t, e) => {
  d5(t), mpe(e);
  const n = e.prototype;
  Object.getPrototypeOf(t) !== n && Object.setPrototypeOf(t, n), typeof n.constructor == "function" && t.constructor !== n.constructor && delete t.constructor;
}, mpe = (t) => {
  if (t === void 0)
    throw new TypeError(
      "This must be called directly inside the class's constructor."
    );
  if (typeof t != "function" || !h5(t.prototype))
    throw new TypeError("The second argument must be `new.target`.");
}, f5 = (t, e) => {
  gpe(e), LT(t, "name", e), LT(t.prototype, "name", e);
}, gpe = (t) => {
  if (typeof t != "string")
    throw new TypeError(`Error name must be a string: ${t}`);
  if (ppe(t), !t.endsWith(lw) || t === lw)
    throw new Error(`Error name "${t}" must end with "${lw}"`);
  ype(t);
}, ppe = (t) => {
  if (bpe.has(t))
    throw new Error(`Error name "${t}" must not be a native class.`);
}, bpe = /* @__PURE__ */ new Set(
  [
    "Error",
    "ReferenceError",
    "TypeError",
    "SyntaxError",
    "RangeError",
    "URIError",
    "EvalError",
    "AggregateError",
    "SystemError",
    "AssertionError",
    "Warning",
    "UnhandledPromiseRejection",
    "DOMException"
  ]
), ype = (t) => {
  if (t[0] !== t.toUpperCase()[0])
    throw new Error(
      `Error name "${t}" must start with an uppercase letter.`
    );
  if (!Ape.test(t))
    throw new Error(`Error name "${t}" must only contain letters.`);
}, lw = "Error", Ape = /[A-Z][a-zA-Z]*Error$/u;
function Epe(t) {
  const e = class extends Error {
    constructor(n, r) {
      super(n, r), fpe(this, new.target), hpe(this, r);
    }
  };
  return f5(e, t), e;
}
const Sh = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, Spe = (t, e) => {
  if (e !== void 0) {
    if (!Array.isArray(e))
      throw new TypeError(`"errors" option must be an array: ${e}`);
    Sh(t, "errors", e);
  }
}, sp = (t) => wpe(t) || Fpe(t), wpe = (t) => {
  try {
    return t instanceof Error;
  } catch {
    return !1;
  }
}, Fpe = (t) => {
  try {
    return Tpe.has(Object.prototype.toString.call(t));
  } catch {
    return !1;
  }
}, Tpe = /* @__PURE__ */ new Set(
  [
    "[object Error]",
    "[object DOMException]",
    "[object DOMError]",
    "[object Exception]"
  ]
), vpe = (t) => {
  DC.forEach((e) => {
    xpe(t, e);
  });
}, DC = ["name", "message", "stack", "cause", "errors"], xpe = (t, e) => {
  const n = IC(t, e);
  if (n !== void 0) {
    if (Cpe(n)) {
      Yu(t, e, t[e]);
      return;
    }
    kpe(n) && m5(t, e, n);
  }
}, IC = (t, e) => {
  const n = Object.getOwnPropertyDescriptor(t, e);
  if (n !== void 0)
    return n;
  const r = Object.getPrototypeOf(t);
  return r === null ? void 0 : IC(r, e);
}, Cpe = ({ get: t, set: e }) => t !== void 0 && e === void 0, kpe = ({ enumerable: t, writable: e }) => t || !e, Yu = (t, e, n) => {
  m5(t, e, { value: n });
}, m5 = (t, e, n) => {
  Object.defineProperty(t, e, {
    ...n,
    ..."get" in n || "set" in n ? {} : { writable: !0 },
    enumerable: !1,
    configurable: !0
  });
}, _pe = (t, e) => {
  if (Array.isArray(t.errors)) {
    const n = t.errors.filter(Npe).map(e).filter(Boolean);
    Yu(t, "errors", n);
  } else Dpe(t) ? Yu(t, "errors", []) : t.errors !== void 0 && Ipe(t);
}, Npe = (t) => t !== void 0, Dpe = (t) => "AggregateError" in globalThis && (t.name === "AggregateError" || t instanceof AggregateError), Ipe = (t) => {
  delete t.errors, t.errors !== void 0 && Yu(t, "errors", []);
}, Rpe = (t, e) => {
  if (!("cause" in t))
    return;
  const n = t.cause === void 0 ? t.cause : e(t.cause);
  n === void 0 ? delete t.cause : Yu(t, "cause", n);
};
function Ii(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = Object.getPrototypeOf(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
const Ppe = (t) => !Object.isExtensible(t) || DC.some(
  (e) => Lpe(t, e) || Mpe(t, e)
), Lpe = (t, e) => {
  const n = Object.getOwnPropertyDescriptor(t, e);
  return n !== void 0 && !n.configurable;
}, Mpe = (t, e) => {
  try {
    return t[e], !1;
  } catch {
    return !0;
  }
}, RC = (t) => {
  const e = Ope(t.message, t.name);
  Yu(t, "stack", e);
}, Ope = (t = "", e = "Error") => {
  const n = Bpe(e), { stack: r } = new n(t);
  return typeof r == "string" && r !== "" ? r : `${e}: ${t}`;
}, Bpe = (t) => {
  const e = {
    value: t,
    enumerable: !1,
    writable: !0,
    configurable: !0
  }, n = Object.defineProperty(
    class extends Error {
    },
    "name",
    e
  );
  return Object.defineProperty(n.prototype, "name", e), n;
}, $pe = (t) => {
  const e = {};
  for (const n of Hpe(t))
    try {
      const r = t[n], {
        enumerable: i,
        configurable: s,
        writable: a = !0
      } = IC(t, n);
      Object.defineProperty(e, n, {
        value: r,
        enumerable: i,
        configurable: s,
        writable: a
      });
    } catch {
    }
  return e;
}, Hpe = (t) => {
  const e = Upe(t);
  for (const n of DC)
    Gpe(t, n) && e.push(n);
  return e;
}, Upe = (t) => {
  try {
    return Reflect.ownKeys(t);
  } catch {
    return [];
  }
}, Gpe = (t, e) => {
  try {
    return e in t && !Object.hasOwn(t, e);
  } catch {
    return !1;
  }
}, rI = (t) => {
  const { name: e, message: n, stack: r, cause: i, errors: s, ...a } = $pe(t), o = Wpe(n, a), u = jpe(e, o);
  return n === o && Ype(u, a), Object.entries({ name: e, stack: r, cause: i, errors: s }).forEach(
    ([l, h]) => {
      qpe(u, l, h);
    }
  ), r === void 0 && RC(u), u;
}, Wpe = (t, e) => typeof t == "string" && t !== "" ? t : zpe(Vpe(e)), Vpe = (t) => {
  try {
    return JSON.stringify(t);
  } catch {
    return Kpe(t);
  }
}, Kpe = (t) => {
  try {
    return String(t);
  } catch {
    return "Invalid error";
  }
}, zpe = (t) => t.length < iI ? t : `${t.slice(0, iI)}...`, iI = 1e3, jpe = (t, e) => t === "AggregateError" && "AggregateError" in globalThis ? new AggregateError([], e) : t in sI ? new sI[t](e) : new Error(e), sI = {
  Error,
  ReferenceError,
  TypeError,
  SyntaxError,
  RangeError,
  URIError,
  EvalError
}, Ype = (t, e) => {
  for (const n in e)
    n in t || (t[n] = e[n]);
}, qpe = (t, e, n) => {
  n !== void 0 && Yu(t, e, n);
}, Jpe = (t) => {
  try {
    const e = new Error(String(t));
    return RC(e), e;
  } catch (e) {
    return e;
  }
}, { toString: Qpe } = Object.prototype, Xpe = (t) => Zpe(t) ? rI(t) : sp(t) ? e0e(t) ? rI(t) : t : Jpe(t), Zpe = (t) => {
  try {
    return Ii(t);
  } catch {
    return !1;
  }
}, e0e = (t) => t0e(t) || Ppe(t) || n0e(t), t0e = (t) => {
  try {
    return Qpe.call(t) === "[object Object]";
  } catch {
    return !0;
  }
}, n0e = (t) => typeof t.constructor != "function" || typeof t.constructor.name != "string" || t.constructor.name === "" || t.constructor.prototype !== Object.getPrototypeOf(t), fu = (t, { shallow: e = !1 } = {}) => g5(t, [], e), g5 = (t, e, n) => {
  if (e.includes(t))
    return;
  const r = n ? r0e : (s) => g5(s, [...e, t], n), i = Xpe(t);
  return i0e(i, r), i;
}, r0e = (t) => t, i0e = (t, e) => {
  s0e(t), a0e(t), o0e(t), Rpe(t, e), _pe(t, e), vpe(t);
}, s0e = (t) => {
  if (o1(t.name))
    return;
  const e = Object.getPrototypeOf(t).name, n = o1(e) ? e : t.constructor.name;
  Yu(t, "name", n);
}, a0e = (t) => {
  o1(t.message) || Yu(t, "message", "");
}, o0e = (t) => {
  o1(t.stack) || RC(t);
}, o1 = (t) => typeof t == "string" && t !== "", u0e = (t, e, n = t.name) => {
  if (l0e(e), typeof n != "string")
    throw new TypeError(`currentName must be a string: ${n}`);
  return n;
}, l0e = (t) => {
  if (!c0e(t))
    throw new TypeError(`ErrorClass must be a class: ${t}`);
  if (!p5(t.prototype))
    throw new TypeError(`ErrorClass must inherit from Error: ${t}`);
  if (!h0e(t))
    throw new TypeError(
      `ErrorClass must be have a valid constructor: ${t}`
    );
}, c0e = (t) => typeof t == "function" && typeof t.prototype == "object" && t.prototype !== null, p5 = (t) => t !== null && (t.name === "Error" || p5(Object.getPrototypeOf(t))), h0e = (t) => typeof t.prototype.constructor == "function", b5 = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, d0e = (t, e) => {
  Object.getPrototypeOf(t) !== e.prototype && (f0e(t, e), E5(t, "constructor"), m0e(t, e));
}, f0e = (t, e) => {
  Object.setPrototypeOf(t, e.prototype);
}, m0e = (t, e) => {
  E5(t, "name");
  const n = y5(e.prototype);
  t.name !== n && b5(t, "name", n);
}, y5 = (t) => g0e(t) ?? p0e(t) ?? y5(Object.getPrototypeOf(t)), g0e = (t) => Object.hasOwn(t, "name") && A5(t.name) ? t.name : void 0, p0e = (t) => typeof t.constructor == "function" && A5(t.constructor.name) ? t.constructor.name : void 0, A5 = (t) => typeof t == "string" && t !== "", E5 = (t, e) => {
  Object.hasOwn(t, e) && delete t[e];
}, b0e = (t, e) => {
  if (!y0e(t, e))
    return;
  const n = E0e(t, e);
  b5(t, "stack", n);
}, y0e = (t, e) => e !== t.name && e !== "" && t.stack.includes(e) && A0e(), A0e = () => {
  class t extends Error {
  }
  const e = {
    value: aI,
    enumerable: !1,
    writable: !0,
    configurable: !0
  };
  Object.defineProperty(t, "name", e), Object.defineProperty(t.prototype, "name", e);
  const { stack: n } = new t("");
  return typeof n == "string" && n.includes(aI);
}, aI = "SetErrorClassError", E0e = ({ name: t, stack: e }, n) => {
  if (e.startsWith(`${n}: `))
    return e.replace(n, t);
  const r = S0e(n, t), [i, s] = r.find(([a]) => e.includes(a));
  return e.replace(i, s);
}, S0e = (t, e) => [
  [`
${t}: `, `
${e}: `],
  [`${t}: `, `${e}: `],
  [`${t} `, `${e} `],
  [t, e]
], w0e = (t, e, n) => {
  const r = fu(t), i = u0e(r, e, n);
  return d0e(r, e), b0e(r, i), r;
}, F0e = (t, e) => e.configurable === !1 ? T0e(t, e) : C0e(t, e), T0e = (t, e) => ({
  ...e,
  ...v0e(t, e),
  ...x0e(t, e)
}), v0e = (t, e) => e.writable === !0 && t.writable === !1 ? { writable: !1 } : {}, x0e = (t, e) => t.hasValue && "value" in e && e.writable === !0 ? { value: t.value } : {}, C0e = (t, e) => {
  const n = Xm(
    t.enumerable,
    e.enumerable,
    !0
  ), r = Xm(
    t.writable,
    e.writable,
    !0
  ), i = Xm(
    t.configurable,
    e.configurable,
    !0
  );
  return { ...k0e(t, e, r), enumerable: n, configurable: i };
}, k0e = (t, e, n) => t.hasValue ? { value: t.value, writable: n } : !oI(t) && !oI(e) ? { value: e.value, writable: n } : {
  get: Xm(t.get, e.get),
  set: Xm(t.set, e.set)
}, oI = ({ get: t, set: e }) => t !== void 0 || e !== void 0, Xm = (t, e, n) => t ?? e ?? n, _0e = (t, e, n) => {
  if (!N0e(t))
    throw new TypeError(`Argument must be an object: ${t}`);
  if (!D0e(e))
    throw new TypeError(
      `Property key must be a string, a symbol or an integer: ${e}`
    );
  return I0e(n);
}, N0e = (t) => typeof t == "object" && t !== null, D0e = (t) => {
  const e = typeof t;
  return e === "string" || e === "symbol" || e === "number";
}, I0e = (t) => {
  if (!Ii(t))
    throw new TypeError(`Descriptor must be a plain object: ${t}`);
  const {
    enumerable: e,
    writable: n,
    configurable: r,
    value: i,
    get: s,
    set: a,
    ...o
  } = t, u = "value" in t;
  return R0e({
    enumerable: e,
    writable: n,
    configurable: r,
    get: s,
    set: a,
    unknownProps: o,
    hasValue: u
  }), { enumerable: e, writable: n, configurable: r, value: i, get: s, set: a, hasValue: u };
}, R0e = ({
  enumerable: t,
  writable: e,
  configurable: n,
  get: r,
  set: i,
  unknownProps: s,
  hasValue: a
}) => {
  uI(a, r, "get"), uI(a, i, "set"), cw(t, "enumerable"), cw(e, "writable"), cw(n, "configurable"), L0e(s);
}, uI = (t, e, n) => {
  if (P0e(e, n), t && e !== void 0)
    throw new TypeError(
      `Descriptor property "value" and "${n}" must not both be defined: ${e}`
    );
}, P0e = (t, e) => {
  if (t !== void 0 && typeof t != "function")
    throw new TypeError(
      `Descriptor property "${e}" must be a function: ${t}`
    );
}, cw = (t, e) => {
  if (t !== void 0 && typeof t != "boolean")
    throw new TypeError(
      `Descriptor property "${e}" must be a boolean: ${t}`
    );
}, L0e = (t) => {
  const [e] = Object.keys(t);
  if (e !== void 0)
    throw new TypeError(
      `Unknown descriptor property "${e}": ${t[e]}`
    );
}, M0e = (t, e, n) => {
  const r = _0e(t, e, n), i = S5(t, e), s = F0e(r, i);
  return O0e(t, e, s), t;
}, S5 = (t, e) => {
  const n = Object.getOwnPropertyDescriptor(t, e);
  if (n !== void 0)
    return n;
  const r = Object.getPrototypeOf(t);
  return r === null ? {} : S5(r, e);
}, O0e = (t, e, n) => {
  try {
    Object.defineProperty(t, e, n);
  } catch {
  }
}, B0e = (t, e, n) => {
  if (n !== void 0)
    return lI(t, e, n);
  try {
    delete t[e];
  } catch {
  }
  if (t[e] !== void 0)
    return lI(t, e);
}, lI = (t, e, n) => {
  const r = $0e(e);
  M0e(t, e, { value: n, ...r });
}, $0e = (t) => typeof t == "string" && t.startsWith("_") ? { enumerable: !1 } : {}, H0e = (t, e, n = {}) => {
  if (cI(t, "First argument"), cI(e, "Second argument"), !Ii(n))
    throw new TypeError(`Options must be a plain object: ${n}`);
  const { soft: r = !1 } = n;
  if (typeof r != "boolean")
    throw new TypeError(`Option "soft" must be a boolean: ${r}`);
  return { soft: r };
}, cI = (t, e) => {
  if (t === void 0)
    throw new TypeError(`${e} is required.`);
  if (!U0e(t))
    throw new TypeError(
      `${e} must be a plain object or an error: ${t}`
    );
}, U0e = (t) => Ii(t) || sp(t), G0e = ({ error: t, props: e, propName: n, soft: r }) => W0e(n) || !z0e.call(e, n) || r && t[n] !== void 0, W0e = (t) => t in V0e || K0e.has(t), V0e = new Error("check"), K0e = /* @__PURE__ */ new Set(["prototype", "errors", "cause"]), { propertyIsEnumerable: z0e } = Object.prototype, w5 = (t, e, n) => {
  const { soft: r } = H0e(t, e, n);
  for (const i of Reflect.ownKeys(e))
    j0e({ error: t, props: e, propName: i, soft: r });
  return t;
}, j0e = ({ error: t, props: e, propName: n, soft: r }) => {
  G0e({ error: t, props: e, propName: n, soft: r }) || B0e(t, n, e[n]);
}, yA = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    writable: !0,
    enumerable: !1,
    configurable: !0
  });
}, Y0e = (t, e) => {
  if (t.errors === void 0)
    return;
  const n = t.errors.map((r) => e(r).error).filter(Boolean);
  yA(t, "errors", n);
}, q0e = ({ target: t, source: e, parent: n, child: r }) => {
  if (!hI(t)) {
    J0e(t, e);
    return;
  }
  hI(e) && yA(t, "errors", [...r.errors, ...n.errors]);
}, J0e = (t, e) => {
  e.errors !== void 0 && yA(t, "errors", e.errors);
}, hI = (t) => t.errors !== void 0 && t.errors.length !== 0, Q0e = (t, e, n = t.message) => {
  if (typeof e != "string")
    throw new TypeError(`newMessage must be a string: ${e}`);
  if (typeof n != "string")
    throw new TypeError(`currentMessage must be a string: ${n}`);
  return n;
}, X0e = ({ name: t, stack: e }, n, r) => r !== "" && e.includes(r) ? Z0e({ name: t, stack: e, newMessage: n, currentMessage: r }) : tbe(t, e, n), Z0e = ({ name: t, stack: e, newMessage: n, currentMessage: r }) => {
  const i = ebe(t, n, r), [s, a] = i.find(([o]) => e.includes(o));
  return e.replace(s, a);
}, ebe = (t, e, n) => [
  [`${t}: ${n}`, `${t}: ${e}`],
  [`: ${n}`, `: ${e}`],
  [`
${n}`, `
${e}`],
  [` ${n}`, ` ${e}`],
  [n, e]
], tbe = (t, e, n) => {
  const r = `${t}: `, i = n.trimEnd();
  return e === t || e.startsWith(`${t}
`) ? e.replace(t, `${r}${i}`) : e.startsWith(r) ? e.replace(r, `${r}${i}
`) : `${r}${i}
${e}`;
}, AA = (t, e, n) => {
  const r = fu(t), i = Q0e(r, e, n);
  return F5(r, "message", e), nbe(r, e, i), r;
}, nbe = (t, e, n) => {
  if (e === n || !rbe())
    return;
  const r = X0e(t, e, n);
  F5(t, "stack", r);
}, rbe = () => {
  const { stack: t } = new Error(dI);
  return typeof t == "string" && t.includes(dI);
}, dI = "set-error-message test message", F5 = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, ibe = (t, e, n) => {
  if (typeof e != "string")
    throw new TypeError(
      `Second argument must be a message string: ${e}`
    );
  const r = fu(t), i = sbe(e, r.message);
  return AA(r, i, n);
}, sbe = (t, e) => {
  const n = t.trim(), r = e.trim();
  return n === "" ? r : r === "" ? n : abe(n, r, t);
}, abe = (t, e, n) => t.endsWith(obe) ? n.endsWith(ube) ? `${t}
${e}` : `${t} ${e}` : `${e}
${t}`, obe = ":", ube = `
`, lbe = ({ parent: t, child: e, target: n, stackError: r }) => {
  const i = t.message, s = r.message;
  return n.message = e.message, ibe(n, i, s);
}, cbe = (t, e) => T5(t) === e, T5 = (t) => typeof t == "object" && t !== null ? t.stack : void 0, hbe = ({ wrap: t, target: e, source: n, childHasStack: r }) => t === r ? e : (yA(e, "stack", n.stack), n), dbe = (t) => {
  const { wrap: e, name: n } = t;
  return typeof e != "boolean" ? n === "Error" : (Object.hasOwn(t, "wrap") && delete t.wrap, e);
}, u1 = (t) => v5(t, []).error, v5 = (t, e) => {
  if (e.includes(t))
    return {};
  const n = (l) => v5(l, [...e, t]), r = T5(t), i = fu(t, { shallow: !0 }), s = cbe(i, r);
  Y0e(i, n);
  const { parent: a, childHasStack: o } = fbe(i, n);
  return { error: a, errorHasStack: s || o };
}, fbe = (t, e) => {
  const n = dbe(t);
  if (t.cause === void 0)
    return { parent: t, childHasStack: !1 };
  const { error: r, errorHasStack: i } = e(t.cause);
  return delete t.cause, { parent: mbe({ parent: t, child: r, childHasStack: i, wrap: n }), childHasStack: i };
}, mbe = ({ parent: t, child: e, childHasStack: n, wrap: r }) => {
  if (e === void 0)
    return t;
  const [i, s] = r ? [e, t] : [t, e], a = hbe({ wrap: r, target: i, source: s, childHasStack: n }), o = w0e(i, i.constructor, a.name), u = lbe({ parent: t, child: e, target: o, stackError: a });
  return q0e({ target: u, source: s, parent: t, child: e }), w5(u, s, { soft: !r });
}, Tg = (t, e) => e === t || gbe.call(e, t), { isPrototypeOf: gbe } = Object.prototype, pbe = (t, e) => {
  const { cause: n } = t;
  return bbe(n) && (ybe(n, e) || n.name !== n.constructor.name);
}, bbe = (t) => typeof t.name == "string" && t.name !== "" && typeof t.constructor == "function" && typeof t.constructor.name == "string", ybe = (t, e) => !(Tg(t.constructor, e) || Tg(e, t.constructor) || t.constructor.name in globalThis || t.name === e.name), Abe = (t) => {
  const e = typeof t.message == "string" ? t.message : "", n = e === "" ? t.name : `${t.name}: ${e}`;
  return AA(t, n), e;
}, Ebe = (t, e) => {
  AA(t, e);
}, Sbe = (t, e) => (t.cause = e, t.wrap = !0, u1(t)), wbe = (t, e) => !sp(t.cause) || (t.wrap = Tg(t.cause.constructor, e), !pbe(t, e)) ? u1(t) : Fbe(t), Fbe = (t) => {
  const { cause: e } = t, n = Abe(e), r = u1(t);
  return e !== r && Ebe(e, n), r;
}, x5 = (t) => Object.prototype.toString.call(t) === "[object Set]";
function xy(t, e) {
  const n = {};
  if (Array.isArray(e) || x5(e))
    for (const r of e) {
      const i = Object.getOwnPropertyDescriptor(t, r);
      i?.enumerable && Object.defineProperty(n, r, i);
    }
  else
    for (const r of Reflect.ownKeys(t)) {
      const i = Object.getOwnPropertyDescriptor(t, r);
      if (!i?.enumerable)
        continue;
      const s = t[r];
      e(r, s, t) && Object.defineProperty(n, r, i);
    }
  return n;
}
function EA(t, e) {
  if (Array.isArray(e)) {
    const n = new Set(e);
    return xy(t, (r) => !n.has(r));
  }
  return x5(e) ? xy(t, (n) => !e.has(n)) : xy(t, (n, r, i) => !e(n, r, i));
}
const qu = /* @__PURE__ */ new WeakMap(), vg = /* @__PURE__ */ new WeakMap(), ap = (t) => Array.isArray(t) ? t.map(ap) : Ii(t) ? Tbe(t) : t, Tbe = (t) => {
  const e = {};
  for (const n of Reflect.ownKeys(t)) {
    const r = Object.getOwnPropertyDescriptor(t, n), i = ap(r.value);
    Object.defineProperty(e, n, { ...r, value: i });
  }
  return e;
}, SA = (t, e, n) => Object.fromEntries(
  MT(n).map((r) => vbe(t, e, r)).filter(Boolean)
), vbe = (t, e, n) => {
  const r = xbe(t[n], e[n]);
  return r === void 0 ? void 0 : [n, r];
}, xbe = (t, e) => e === void 0 ? t : Ii(t) && Ii(e) ? { ...t, ...e } : e, MT = (t) => t.map(Cbe), Cbe = ({ name: t }) => t, kbe = (t, e, n = {}) => {
  _be(t, n);
  const { errors: r, ...i } = n, s = EA(i, MT(e)), a = xy(i, MT(e)), o = Nbe(e, a, s);
  return { nativeOpts: s, errors: r, pluginsOpts: o };
}, _be = (t, e) => {
  if (!Ii(e))
    throw new TypeError(
      `Error options must be a plain object or undefined: ${e}`
    );
  if (e.custom !== void 0)
    throw new TypeError(
      `Error option "custom" must be passed to "${t.name}.subclass()", not to error constructors.`
    );
}, Nbe = (t, e, { cause: n }) => {
  if (!vg.has(n))
    return e;
  const r = vg.get(n).pluginsOpts, i = SA(r, e, t);
  return ap(i);
}, Dbe = (t = {}) => {
  if (!Ii(t))
    throw new TypeError(`It must be a plain object: ${t}`);
  const { message: e, ...n } = t;
  return n;
}, Ibe = ({ options: t }) => t, Rbe = {
  name: "props",
  getOptions: Dbe,
  properties: Ibe
}, Pbe = [Rbe], Lbe = ({
  plugin: t,
  plugin: {
    fullName: e,
    getOptions: n = Mbe.bind(void 0, e)
  }
}) => ({ ...t, getOptions: n }), Mbe = (t, e) => {
  if (e !== void 0)
    throw new Error(
      `The plugin "${t}" does not have any options: ${e}`
    );
}, C5 = ({
  pluginsOpts: t,
  plugin: { name: e, getOptions: n },
  full: r
}) => {
  try {
    return n(t[e], r);
  } catch (i) {
    throw Sbe(new Error(`Invalid "${e}" options:`), i);
  }
}, Obe = ({
  plugin: t,
  plugin: { getOptions: e, isOptions: n = () => e !== void 0 }
}) => ({ ...t, isOptions: n }), k5 = (t, e) => {
  if (t.length === 0)
    return { args: t };
  const n = t.at(-1);
  return Bbe(e, n) ? { args: t.slice(0, -1), methodOpts: { [e.name]: n } } : { args: t };
}, Bbe = ({ isOptions: t, fullName: e }, n) => {
  const r = t(n);
  if (typeof r != "boolean")
    throw new TypeError(
      `The plugin "${e}"'s "isOptions()" method must return a boolean, not: ${typeof r}`
    );
  return r;
}, $be = (t, e, n) => e === void 0 ? t : SA(t, e, n), _5 = ({
  pluginsOpts: t,
  methodOpts: e,
  plugins: n,
  plugin: r
}) => {
  const i = $be(t, e, n), s = ap(i);
  return C5({
    pluginsOpts: s,
    plugin: r,
    full: !0
  });
}, Hbe = ({ ErrorClass: t, methodOpts: e, plugins: n, plugin: r }, i) => {
  const s = t.normalize(i);
  return { ...N5({ error: s, methodOpts: e, plugins: n, plugin: r }), error: s };
}, N5 = ({ error: t, methodOpts: e, plugins: n, plugin: r }) => {
  const i = t.constructor, s = D5(i), { classOpts: a } = qu.get(i), { pluginsOpts: o } = vg.get(t), u = SA(a, o, n), l = _5({
    pluginsOpts: u,
    methodOpts: e,
    plugins: n,
    plugin: r
  });
  return { ErrorClass: i, ErrorClasses: s, options: l };
}, D5 = (t) => {
  const { subclasses: e } = qu.get(t);
  return [t, ...e];
}, I5 = ({ error: t, methodOpts: e, plugins: n, plugin: r }) => {
  const { ErrorClass: i, options: s } = N5({
    error: t,
    methodOpts: e,
    plugins: n,
    plugin: r
  }), a = R5({
    options: s,
    ErrorClass: i,
    methodOpts: e,
    plugins: n,
    plugin: r
  });
  return Object.assign(a, { error: t }), a;
}, R5 = ({
  options: t,
  ErrorClass: e,
  methodOpts: n,
  plugins: r,
  plugin: i
}) => {
  const s = Hbe.bind(void 0, {
    ErrorClass: e,
    methodOpts: n,
    plugins: r,
    plugin: i
  }), a = D5(e), o = { options: t, ErrorClass: e, ErrorClasses: a, errorInfo: s };
  return Ube(o), o;
}, Ube = (t) => {
  Object.defineProperty(t, "instancesData", {
    value: vg,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, Gbe = (t, e) => {
  if (typeof e != "string")
    throw new TypeError(`Stack trace must be a string: ${e}`);
  const n = fu(t), { name: r, stack: i } = n;
  return e === i || (P5(n, "stack", e), Wbe({ error: n, newStack: e, currentStack: i, name: r })), n;
}, Wbe = ({ error: t, newStack: e, currentStack: n, name: r }) => {
  if (fI(n, r) === void 0)
    return;
  const i = fI(e, r);
  i !== void 0 && P5(t, "message", i);
}, fI = (t, e) => {
  const n = Vbe(t, e);
  if (n === -1)
    return;
  const r = t.slice(n), i = r.indexOf(`
    at `);
  if (i !== -1)
    return r.slice(0, i);
}, Vbe = (t, e) => {
  const n = `${e}: `;
  if (t.startsWith(n))
    return n.length;
  const r = t.indexOf(`
${n}`);
  return r === -1 ? r : r + n.length + 1;
}, P5 = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, Kbe = ({
  error: t,
  methodFunc: e,
  methodName: n,
  plugin: r,
  plugins: i,
  ErrorClass: s,
  args: a
}) => {
  if (!(t instanceof s))
    throw new TypeError(
      `Missing "this" context: "${n}()" must be called using "error.${n}()"`
    );
  return L5({ methodFunc: e, plugin: r, plugins: i, error: t, args: a });
}, L5 = ({ methodFunc: t, plugin: e, plugins: n, error: r, args: i }) => {
  const { args: s, methodOpts: a } = k5(i, e), o = I5({ error: r, methodOpts: a, plugins: n, plugin: e });
  return t(o, ...s);
}, zbe = ({ methodFunc: t, plugin: e, plugins: n, ErrorClass: r }, i, ...s) => {
  const a = r.normalize(i);
  return L5({ methodFunc: t, plugin: e, plugins: n, error: a, args: s });
}, jbe = (t, e) => {
  t.forEach((n) => {
    Ybe(n, t, e);
  });
}, Ybe = (t, e, n) => {
  Object.entries(t.instanceMethods).forEach(
    qbe.bind(void 0, { plugin: t, plugins: e, ErrorClass: n })
  );
}, qbe = ({ plugin: t, plugins: e, ErrorClass: n }, [r, i]) => {
  Sh(
    n.prototype,
    r,
    function(...a) {
      return Kbe({
        error: this,
        methodFunc: i,
        methodName: r,
        plugin: t,
        plugins: e,
        ErrorClass: n,
        args: a
      });
    }
  ), Sh(
    n,
    r,
    zbe.bind(void 0, {
      methodFunc: i,
      plugin: t,
      plugins: e,
      ErrorClass: n
    })
  );
}, Jbe = (t) => t.flatMap(Qbe), Qbe = ({ instanceMethods: t }) => Object.keys(t), Xbe = (t, { message: e, stack: n, ...r }, i) => {
  if (n !== void 0 && Gbe(t, n), e !== void 0 && AA(t, e), Reflect.ownKeys(r).length === 0)
    return;
  const s = EA(
    r,
    [
      ...Zbe,
      ...Jbe(i)
    ]
  );
  w5(t, s);
}, Zbe = ["wrap", "constructorArgs"], eye = (t, e) => e.forEach((n) => {
  tye({ error: t, plugin: n, plugins: e });
}), tye = ({
  error: t,
  plugin: e,
  plugin: { properties: n, fullName: r },
  plugins: i
}) => {
  if (n === void 0)
    return;
  const s = I5({ error: t, plugins: i, plugin: e }), a = n(s);
  if (!Ii(a))
    throw new TypeError(
      `Plugin "${r}"'s "properties()" must return a plain object: ${a}`
    );
  Xbe(t, a, i);
}, nye = (t, e) => {
  Object.entries(t).forEach(([n, r]) => {
    rye(n, r, e);
  });
}, rye = (t, e, n) => {
  if (!n.some(({ name: r }) => r === t))
    throw new TypeError(
      `Invalid option "${t}": the plugin "${M5}${t}" must be passed to ErrorClass.subclass("...", { plugins })`
    );
}, iye = (t) => {
  if (t.name === void 0)
    throw new TypeError(`The plugin is missing a "name": ${t}`);
  const { name: e } = t;
  if (typeof e != "string")
    throw new TypeError(`The plugin "name" must be a string: ${e}`);
  return sye(e), { ...t, fullName: `${M5}${e}` };
}, sye = (t) => {
  if (aye.has(t))
    throw new TypeError(
      `The plugin "name" must not be the following reserved word: ${t}`
    );
  if (!oye.test(t))
    throw new TypeError(
      `The plugin "name" must only contain lowercase letters and digits: ${t}`
    );
}, aye = /* @__PURE__ */ new Set(
  [
    "cause",
    "errors",
    "custom",
    "wrap",
    "constructorArgs"
  ]
), oye = /^[a-z][a-z\d]*$/u, M5 = "modern-errors-", uye = (t, e = {}) => {
  if (!Ii(e))
    throw new TypeError(
      `The second argument of "${t.name}.subclass()" must be a plain object, not: ${e}`
    );
  return e;
}, lye = (t, e, n) => {
  nye(e, n);
  const r = SA(t, e, n), i = ap(r);
  return n.forEach((s) => {
    C5({ pluginsOpts: i, plugin: s, full: !1 });
  }), i;
}, cye = ({
  instanceMethods: t,
  staticMethods: e,
  fullName: n
}) => {
  const r = O5(e, t);
  if (r !== void 0)
    throw new TypeError(
      `The plugin "${n}" must not define "${r}()" as both "instanceMethods" and "staticMethods".`
    );
}, hye = (t, e) => {
  t.forEach((n, r) => {
    dye({ pluginA: n, indexA: r, plugins: t, ParentError: e });
  });
}, dye = ({ pluginA: t, indexA: e, plugins: n, ParentError: r }) => {
  n.forEach((i, s) => {
    fye({ pluginA: t, pluginB: i, indexA: e, indexB: s, ParentError: r });
  });
}, fye = ({
  pluginA: t,
  pluginB: e,
  indexA: n,
  indexB: r,
  ParentError: i
}) => {
  if (n === r)
    return;
  if (t.name === e.name)
    throw new TypeError(
      `The "plugins" option of "${i.name}.subclass()" must not include "${t.fullName}": this plugin has already been included.`
    );
  const s = O5(
    { ...t.instanceMethods, ...t.staticMethods },
    { ...e.instanceMethods, ...e.staticMethods }
  );
  if (s !== void 0)
    throw new TypeError(
      `The plugins "${t.fullName}" and "${e.fullName}" must not both define the same "${s}()" method.`
    );
}, O5 = (t, e) => {
  const n = Object.keys(t);
  return Object.keys(e).find((r) => n.includes(r));
}, mye = (t) => {
  const e = hw({
    ...gye,
    plugin: t,
    propName: "instanceMethods"
  }), n = hw({
    ...mI,
    plugin: e,
    propName: "instanceMethods"
  });
  return hw({
    ...mI,
    plugin: n,
    propName: "staticMethods"
  });
}, gye = {
  coreObject: Error.prototype,
  coreObjectName: "error",
  forbiddenNames: /* @__PURE__ */ new Set([])
}, mI = {
  coreObject: Error,
  coreObjectName: "Error",
  forbiddenNames: /* @__PURE__ */ new Set(["normalize", "subclass"])
}, hw = ({
  plugin: t,
  propName: e,
  coreObject: n,
  coreObjectName: r,
  forbiddenNames: i
}) => {
  const s = t[e] ?? {};
  if (!Ii(s))
    throw new TypeError(
      `The plugin "${t.fullName}"'s "${e}" property must be either undefined or a plain object, not: ${s}`
    );
  return Object.entries(s).forEach(([a, o]) => {
    pye({
      methodValue: o,
      propName: e,
      methodName: a,
      plugin: t,
      coreObject: n,
      coreObjectName: r,
      forbiddenNames: i
    });
  }), { ...t, [e]: s };
}, pye = ({
  methodValue: t,
  propName: e,
  methodName: n,
  plugin: r,
  coreObject: i,
  coreObjectName: s,
  forbiddenNames: a
}) => {
  if (typeof t != "function")
    throw new TypeError(
      `The plugin "${r.fullName}"'s "${e}.${n}" property must be a function, not: ${t}`
    );
  if (a.has(n) || n in i)
    throw new TypeError(
      `The plugin "${r.fullName}"'s "${e}.${n}" property name is invalid: "${s}.${n}" already exists.`
    );
}, bye = (t, e, n) => {
  const i = yye(n, e).map(
    (a) => Aye(a, n)
  ), s = [...t, ...i];
  return hye(s, n), s;
}, yye = (t, e = []) => {
  if (!Array.isArray(e))
    throw new TypeError(
      `The "plugins" option of "${t.name}.subclass()" must be an array: ${e}`
    );
  return e;
}, Aye = (t, e) => {
  if (!Ii(t))
    throw new TypeError(
      `The "plugins" option of "${e.name}.subclass()" must be an array of plugin objects: ${t}`
    );
  const n = iye(t);
  Eye(n);
  const r = mye(n);
  cye(r);
  const i = Obe({ plugin: r });
  return Lbe({ plugin: i });
}, Eye = (t) => {
  Sye.forEach((e) => {
    wye(t, e);
  });
}, Sye = ["isOptions", "getOptions", "properties"], wye = (t, e) => {
  const n = t[e];
  if (n !== void 0 && typeof n != "function")
    throw new TypeError(
      `The plugin "${t.fullName}"'s "${e}()" property must be either undefined or a function, not: ${n}`
    );
}, Fye = ({ methodFunc: t, plugin: e, plugins: n, ErrorClass: r }, ...i) => {
  const { classOpts: s } = qu.get(r), { args: a, methodOpts: o } = k5(i, e), u = _5({
    pluginsOpts: s,
    methodOpts: o,
    plugins: n,
    plugin: e
  }), l = R5({
    options: u,
    ErrorClass: r,
    methodOpts: o,
    plugins: n,
    plugin: e
  });
  return t(l, ...a);
}, Tye = (t, e) => {
  t.forEach((n) => {
    vye(n, t, e);
  });
}, vye = (t, e, n) => {
  Object.entries(t.staticMethods).forEach(
    xye.bind(void 0, { plugin: t, plugins: e, ErrorClass: n })
  );
}, xye = ({ plugin: t, plugins: e, ErrorClass: n }, [r, i]) => {
  Sh(
    n,
    r,
    Fye.bind(void 0, {
      methodFunc: i,
      plugin: t,
      plugins: e,
      ErrorClass: n
    })
  );
}, Cye = (t, e) => {
  if (typeof t != "function")
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" must be a class: ${t}`
    );
  kye(t, e), _ye(t, e);
}, kye = (t, e) => {
  if (t === e)
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" must extend from ${e.name}, but not be ${e.name} itself.`
    );
  if (!Tg(t, e))
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" must extend from ${e.name}.`
    );
  if (Object.getPrototypeOf(t) !== e)
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" must extend directly from ${e.name}.`
    );
}, _ye = (t, e) => {
  if (typeof t.prototype != "object" || t.prototype === null)
    throw new TypeError(
      `The "custom" class's prototype of "${e.name}.subclass()" is invalid: ${t.prototype}`
    );
  if (t.prototype.constructor !== t)
    throw new TypeError(
      `The "custom" class of "${e.name}.subclass()" has an invalid "constructor" property.`
    );
}, Nye = (t, e) => {
  const n = Dye(t, e);
  return class extends n {
  };
}, Dye = (t, e) => e === void 0 ? t : (Cye(e, t), e), Iye = (t, e, n = t) => {
  if (!Tg(n, t))
    throw new TypeError(
      `${t.name}.normalize()'s second argument should be a subclass of ${t.name}, not: ${n}`
    );
  return B5({ error: e, ErrorClass: t, UnknownError: n, parents: [] });
}, B5 = ({ error: t, ErrorClass: e, UnknownError: n, parents: r }) => (Rye({ error: t, ErrorClass: e, UnknownError: n, parents: r }), Pye(t, e, n) ? fu(t, { shallow: !0 }) : new n("", { cause: t })), Rye = ({
  error: t,
  ErrorClass: e,
  UnknownError: n,
  parents: r
}) => {
  if (!Array.isArray(t?.errors))
    return;
  const i = [...r, t], s = t.errors.filter((a) => !i.includes(a)).map(
    (a) => B5({
      error: a,
      ErrorClass: e,
      UnknownError: n,
      parents: i
    })
  );
  Sh(t, "errors", s);
}, Pye = (t, e, n) => t?.constructor === n || t instanceof e, Lye = (t, e, n) => {
  const { classOpts: r, plugins: i } = qu.get(t), { custom: s, plugins: a, ...o } = uye(
    t,
    n
  ), u = Nye(t, s);
  return Mye(u, t), $5({
    ParentError: t,
    ErrorClass: u,
    parentOpts: r,
    classOpts: o,
    parentPlugins: i,
    plugins: a,
    className: e
  });
}, Mye = (t, e) => {
  const { subclasses: n, ...r } = qu.get(e);
  qu.set(e, {
    ...r,
    subclasses: [...n, t]
  });
}, $5 = ({
  ParentError: t,
  ErrorClass: e,
  parentOpts: n,
  classOpts: r,
  parentPlugins: i,
  plugins: s,
  className: a
}) => {
  const o = bye(i, s, t), u = lye(n, r, o);
  return qu.set(e, {
    classOpts: u,
    plugins: o,
    subclasses: []
  }), f5(e, a), Oye(e, o), e;
}, Oye = (t, e) => {
  Sh(t, "normalize", Iye.bind(void 0, t)), Sh(
    t,
    "subclass",
    Lye.bind(void 0, t)
  ), jbe(e, t), Tye(e, t);
}, Bye = (t) => {
  if (qu.has(t))
    return;
  const { name: e } = t, { name: n } = Object.getPrototypeOf(t);
  throw new Error(
    `"new ${e}()" must not be directly called.
This error class should be created like this instead:
  export const ${e} = ${n}.subclass('${e}')`
  );
}, $ye = Epe("BaseModernError");
class Hye extends $ye {
  constructor(e, n) {
    const r = new.target;
    Bye(r);
    const { plugins: i } = qu.get(r), { nativeOpts: s, errors: a, pluginsOpts: o } = kbe(
      r,
      i,
      n
    );
    super(e, s), Spe(this, a);
    const u = wbe(this, r);
    return vg.set(u, { pluginsOpts: o }), eye(u, i), u;
  }
}
const Uye = $5({
  ParentError: Error,
  ErrorClass: Hye,
  parentOpts: {},
  classOpts: {},
  parentPlugins: [],
  plugins: Pbe,
  className: "ModernError"
}), l1 = (t, e, n) => {
  Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, Gye = (t) => {
  const { cause: e, errors: n } = t;
  return delete t.cause, delete t.errors, { cause: e, errors: n };
}, Wye = (t, e, n) => {
  e !== void 0 && l1(t, "cause", e), t !== void 0 && l1(t, "errors", n);
}, Vye = (t, e) => t.split(`
`).map((n) => Kye(n, e)).join(`
`), Kye = (t, e) => e === 0 ? t : `${" ".repeat(e * zye)}${t}`, zye = 4, dw = 10, gI = (t = 0) => (e) => `\x1B[${e + t}m`, pI = (t = 0) => (e) => `\x1B[${38 + t};5;${e}m`, bI = (t = 0) => (e, n, r) => `\x1B[${38 + t};2;${e};${n};${r}m`, wr = {
  modifier: {
    reset: [0, 0],
    // 21 isn't widely supported and 22 does the same thing
    bold: [1, 22],
    dim: [2, 22],
    italic: [3, 23],
    underline: [4, 24],
    overline: [53, 55],
    inverse: [7, 27],
    hidden: [8, 28],
    strikethrough: [9, 29]
  },
  color: {
    black: [30, 39],
    red: [31, 39],
    green: [32, 39],
    yellow: [33, 39],
    blue: [34, 39],
    magenta: [35, 39],
    cyan: [36, 39],
    white: [37, 39],
    // Bright color
    blackBright: [90, 39],
    gray: [90, 39],
    // Alias of `blackBright`
    grey: [90, 39],
    // Alias of `blackBright`
    redBright: [91, 39],
    greenBright: [92, 39],
    yellowBright: [93, 39],
    blueBright: [94, 39],
    magentaBright: [95, 39],
    cyanBright: [96, 39],
    whiteBright: [97, 39]
  },
  bgColor: {
    bgBlack: [40, 49],
    bgRed: [41, 49],
    bgGreen: [42, 49],
    bgYellow: [43, 49],
    bgBlue: [44, 49],
    bgMagenta: [45, 49],
    bgCyan: [46, 49],
    bgWhite: [47, 49],
    // Bright color
    bgBlackBright: [100, 49],
    bgGray: [100, 49],
    // Alias of `bgBlackBright`
    bgGrey: [100, 49],
    // Alias of `bgBlackBright`
    bgRedBright: [101, 49],
    bgGreenBright: [102, 49],
    bgYellowBright: [103, 49],
    bgBlueBright: [104, 49],
    bgMagentaBright: [105, 49],
    bgCyanBright: [106, 49],
    bgWhiteBright: [107, 49]
  }
};
Object.keys(wr.modifier);
const jye = Object.keys(wr.color), Yye = Object.keys(wr.bgColor);
[...jye, ...Yye];
function qye() {
  const t = /* @__PURE__ */ new Map();
  for (const [e, n] of Object.entries(wr)) {
    for (const [r, i] of Object.entries(n))
      wr[r] = {
        open: `\x1B[${i[0]}m`,
        close: `\x1B[${i[1]}m`
      }, n[r] = wr[r], t.set(i[0], i[1]);
    Object.defineProperty(wr, e, {
      value: n,
      enumerable: !1
    });
  }
  return Object.defineProperty(wr, "codes", {
    value: t,
    enumerable: !1
  }), wr.color.close = "\x1B[39m", wr.bgColor.close = "\x1B[49m", wr.color.ansi = gI(), wr.color.ansi256 = pI(), wr.color.ansi16m = bI(), wr.bgColor.ansi = gI(dw), wr.bgColor.ansi256 = pI(dw), wr.bgColor.ansi16m = bI(dw), Object.defineProperties(wr, {
    rgbToAnsi256: {
      value(e, n, r) {
        return e === n && n === r ? e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
      },
      enumerable: !1
    },
    hexToRgb: {
      value(e) {
        const n = /[a-f\d]{6}|[a-f\d]{3}/i.exec(e.toString(16));
        if (!n)
          return [0, 0, 0];
        let [r] = n;
        r.length === 3 && (r = [...r].map((s) => s + s).join(""));
        const i = Number.parseInt(r, 16);
        return [
          /* eslint-disable no-bitwise */
          i >> 16 & 255,
          i >> 8 & 255,
          i & 255
          /* eslint-enable no-bitwise */
        ];
      },
      enumerable: !1
    },
    hexToAnsi256: {
      value: (e) => wr.rgbToAnsi256(...wr.hexToRgb(e)),
      enumerable: !1
    },
    ansi256ToAnsi: {
      value(e) {
        if (e < 8)
          return 30 + e;
        if (e < 16)
          return 90 + (e - 8);
        let n, r, i;
        if (e >= 232)
          n = ((e - 232) * 10 + 8) / 255, r = n, i = n;
        else {
          e -= 16;
          const o = e % 36;
          n = Math.floor(e / 36) / 5, r = Math.floor(o / 6) / 5, i = o % 6 / 5;
        }
        const s = Math.max(n, r, i) * 2;
        if (s === 0)
          return 30;
        let a = 30 + (Math.round(i) << 2 | Math.round(r) << 1 | Math.round(n));
        return s === 2 && (a += 60), a;
      },
      enumerable: !1
    },
    rgbToAnsi: {
      value: (e, n, r) => wr.ansi256ToAnsi(wr.rgbToAnsi256(e, n, r)),
      enumerable: !1
    },
    hexToAnsi: {
      value: (e) => wr.ansi256ToAnsi(wr.hexToAnsi256(e)),
      enumerable: !1
    }
  }), wr;
}
const Yo = qye();
function Ca(t, e = globalThis.Deno ? globalThis.Deno.args : $s.argv) {
  const n = t.startsWith("-") ? "" : t.length === 1 ? "-" : "--", r = e.indexOf(n + t), i = e.indexOf("--");
  return r !== -1 && (i === -1 || r < i);
}
const { env: Fr } = $s;
let c1;
Ca("no-color") || Ca("no-colors") || Ca("color=false") || Ca("color=never") ? c1 = 0 : (Ca("color") || Ca("colors") || Ca("color=true") || Ca("color=always")) && (c1 = 1);
function Jye() {
  if ("FORCE_COLOR" in Fr)
    return Fr.FORCE_COLOR === "true" ? 1 : Fr.FORCE_COLOR === "false" ? 0 : Fr.FORCE_COLOR.length === 0 ? 1 : Math.min(Number.parseInt(Fr.FORCE_COLOR, 10), 3);
}
function Qye(t) {
  return t === 0 ? !1 : {
    level: t,
    hasBasic: !0,
    has256: t >= 2,
    has16m: t >= 3
  };
}
function Xye(t, { streamIsTTY: e, sniffFlags: n = !0 } = {}) {
  const r = Jye();
  r !== void 0 && (c1 = r);
  const i = n ? c1 : r;
  if (i === 0)
    return 0;
  if (n) {
    if (Ca("color=16m") || Ca("color=full") || Ca("color=truecolor"))
      return 3;
    if (Ca("color=256"))
      return 2;
  }
  if ("TF_BUILD" in Fr && "AGENT_NAME" in Fr)
    return 1;
  if (t && !e && i === void 0)
    return 0;
  const s = i || 0;
  if (Fr.TERM === "dumb")
    return s;
  if ($s.platform === "win32") {
    const a = kQ.release().split(".");
    return Number(a[0]) >= 10 && Number(a[2]) >= 10586 ? Number(a[2]) >= 14931 ? 3 : 2 : 1;
  }
  if ("CI" in Fr)
    return ["GITHUB_ACTIONS", "GITEA_ACTIONS", "CIRCLECI"].some((a) => a in Fr) ? 3 : ["TRAVIS", "APPVEYOR", "GITLAB_CI", "BUILDKITE", "DRONE"].some((a) => a in Fr) || Fr.CI_NAME === "codeship" ? 1 : s;
  if ("TEAMCITY_VERSION" in Fr)
    return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(Fr.TEAMCITY_VERSION) ? 1 : 0;
  if (Fr.COLORTERM === "truecolor" || Fr.TERM === "xterm-kitty" || Fr.TERM === "xterm-ghostty" || Fr.TERM === "wezterm")
    return 3;
  if ("TERM_PROGRAM" in Fr) {
    const a = Number.parseInt((Fr.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
    switch (Fr.TERM_PROGRAM) {
      case "iTerm.app":
        return a >= 3 ? 3 : 2;
      case "Apple_Terminal":
        return 2;
    }
  }
  return /-256(color)?$/i.test(Fr.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(Fr.TERM) || "COLORTERM" in Fr ? 1 : s;
}
function yI(t, e = {}) {
  const n = Xye(t, {
    streamIsTTY: t && t.isTTY,
    ...e
  });
  return Qye(n);
}
const Zye = {
  stdout: yI({ isTTY: _3.isatty(1) }),
  stderr: yI({ isTTY: _3.isatty(2) })
};
function e1e(t, e, n) {
  let r = t.indexOf(e);
  if (r === -1)
    return t;
  const i = e.length;
  let s = 0, a = "";
  do
    a += t.slice(s, r) + e + n, s = r + i, r = t.indexOf(e, s);
  while (r !== -1);
  return a += t.slice(s), a;
}
function t1e(t, e, n, r) {
  let i = 0, s = "";
  do {
    const a = t[r - 1] === "\r";
    s += t.slice(i, a ? r - 1 : r) + e + (a ? `\r
` : `
`) + n, i = r + 1, r = t.indexOf(`
`, i);
  } while (r !== -1);
  return s += t.slice(i), s;
}
const { stdout: AI, stderr: EI } = Zye, OT = /* @__PURE__ */ Symbol("GENERATOR"), df = /* @__PURE__ */ Symbol("STYLER"), xg = /* @__PURE__ */ Symbol("IS_EMPTY"), SI = [
  "ansi",
  "ansi",
  "ansi256",
  "ansi16m"
], ff = /* @__PURE__ */ Object.create(null), n1e = (t, e = {}) => {
  if (e.level && !(Number.isInteger(e.level) && e.level >= 0 && e.level <= 3))
    throw new Error("The `level` option should be an integer from 0 to 3");
  const n = AI ? AI.level : 0;
  t.level = e.level === void 0 ? n : e.level;
};
class r1e {
  constructor(e) {
    return H5(e);
  }
}
const H5 = (t) => {
  const e = (...n) => n.join(" ");
  return n1e(e, t), Object.setPrototypeOf(e, op.prototype), e;
};
function op(t) {
  return H5(t);
}
Object.setPrototypeOf(op.prototype, Function.prototype);
for (const [t, e] of Object.entries(Yo))
  ff[t] = {
    get() {
      const n = h1(this, $T(e.open, e.close, this[df]), this[xg]);
      return Object.defineProperty(this, t, { value: n }), n;
    }
  };
ff.visible = {
  get() {
    const t = h1(this, this[df], !0);
    return Object.defineProperty(this, "visible", { value: t }), t;
  }
};
const BT = (t, e, n, ...r) => t === "rgb" ? e === "ansi16m" ? Yo[n].ansi16m(...r) : e === "ansi256" ? Yo[n].ansi256(Yo.rgbToAnsi256(...r)) : Yo[n].ansi(Yo.rgbToAnsi(...r)) : t === "hex" ? BT("rgb", e, n, ...Yo.hexToRgb(...r)) : Yo[n][t](...r), i1e = ["rgb", "hex", "ansi256"];
for (const t of i1e) {
  ff[t] = {
    get() {
      const { level: n } = this;
      return function(...r) {
        const i = $T(BT(t, SI[n], "color", ...r), Yo.color.close, this[df]);
        return h1(this, i, this[xg]);
      };
    }
  };
  const e = "bg" + t[0].toUpperCase() + t.slice(1);
  ff[e] = {
    get() {
      const { level: n } = this;
      return function(...r) {
        const i = $T(BT(t, SI[n], "bgColor", ...r), Yo.bgColor.close, this[df]);
        return h1(this, i, this[xg]);
      };
    }
  };
}
const s1e = Object.defineProperties(() => {
}, {
  ...ff,
  level: {
    enumerable: !0,
    get() {
      return this[OT].level;
    },
    set(t) {
      this[OT].level = t;
    }
  }
}), $T = (t, e, n) => {
  let r, i;
  return n === void 0 ? (r = t, i = e) : (r = n.openAll + t, i = e + n.closeAll), {
    open: t,
    close: e,
    openAll: r,
    closeAll: i,
    parent: n
  };
}, h1 = (t, e, n) => {
  const r = (...i) => a1e(r, i.length === 1 ? "" + i[0] : i.join(" "));
  return Object.setPrototypeOf(r, s1e), r[OT] = t, r[df] = e, r[xg] = n, r;
}, a1e = (t, e) => {
  if (t.level <= 0 || !e)
    return t[xg] ? "" : e;
  let n = t[df];
  if (n === void 0)
    return e;
  const { openAll: r, closeAll: i } = n;
  if (e.includes("\x1B"))
    for (; n !== void 0; )
      e = e1e(e, n.close, n.open), n = n.parent;
  const s = e.indexOf(`
`);
  return s !== -1 && (e = t1e(e, i, r, s)), r + e + i;
};
Object.defineProperties(op.prototype, ff);
op();
op({ level: EI ? EI.level : 0 });
const o1e = (t = {}) => {
  u1e(t);
  const { colors: e, stream: n = vQ, level: r, ...i } = t;
  return l1e(e), c1e(n), h1e(r), { colors: e, stream: n, level: r, chalkOpts: i };
}, u1e = (t) => {
  if (!Ii(t))
    throw new TypeError(`Options must be a plain object: ${t}`);
}, l1e = (t) => {
  if (t !== void 0 && typeof t != "boolean")
    throw new TypeError(`"colors" option must be a boolean: ${t}`);
}, c1e = (t) => {
  if (!(t instanceof _Q))
    throw new TypeError(`"stream" option must be a stream: ${t}`);
}, h1e = (t) => {
  if (t !== void 0) {
    if (t === 0)
      throw new TypeError(
        '"level" option must not be 0. Please use "colors: false" instead.'
      );
    if (!Number.isInteger(t) || t < 1 || t > 3)
      throw new TypeError(`"level" option must be 1, 2 or 3, not: ${t}`);
  }
}, d1e = (t) => {
  const {
    stream: e,
    colors: n = e.isTTY && e.getColorDepth() !== 1,
    level: r = f1e[CQ.prototype.getColorDepth()],
    chalkOpts: i
  } = o1e(t), s = n ? r : 0;
  return new r1e({ ...i, level: s });
}, f1e = { 1: 1, 4: 1, 8: 2, 24: 3 }, wI = (t, e) => {
  if (t.length !== 3)
    throw new TypeError(
      `There must be 3 arguments with "${e}", not ${t.length}`
    );
  const n = t.map(Number);
  return n.forEach((r, i) => {
    m1e(r, t[i], e);
  }), n;
}, m1e = (t, e, n) => {
  if (!Number.isInteger(t) || String(t) !== e)
    throw new TypeError(`Argument "${t}" must be an integer with "${n}"`);
  if (t > FI)
    throw new TypeError(
      `Argument "${t}" must be less than ${FI} with "${n}"`
    );
}, FI = 255, TI = (t, e) => {
  if (t.length !== 1)
    throw new TypeError(
      `There must be exactly one argument with "${e}", not ${t.length}`
    );
  return g1e(t[0], e), t;
}, g1e = (t, e) => {
  if (t.includes("#"))
    throw new TypeError(`Argument "${t}" must not include # with "${e}"`);
  if (!p1e.has(t.length))
    throw new TypeError(
      `Argument "${t}" must have 3 or 6 characters with "${e}"`
    );
  if (!b1e.test(t))
    throw new TypeError(
      `Argument "${t}" must be an hexadecimal string with "${e}"`
    );
}, p1e = /* @__PURE__ */ new Set([3, 6]), b1e = /^[a-f\d]{3,6}$/iu, U5 = {
  rgb: wI,
  bgRgb: wI,
  hex: TI,
  bgHex: TI
}, G5 = (t, e) => {
  if (typeof t != "string")
    throw new TypeError(`Styles must be a string, not: ${t}`);
  const n = d1e(e), r = t.trim().split(y1e).reduce(A1e, n);
  return F1e.bind(void 0, r);
}, y1e = /\s+/u, A1e = (t, e) => {
  const [n, ...r] = e.split(E1e);
  if (typeof t[n] != "function")
    throw new TypeError(`Style "${e}" is unknown.`);
  return n in U5 ? S1e(t, n, r) : w1e(t, n, r);
}, E1e = "-", S1e = (t, e, n) => {
  const r = U5[e](n, e);
  return t[e](...r);
}, w1e = (t, e, n) => {
  if (n.length !== 0)
    throw new TypeError(`No arguments "${n[0]}" allowed with "${e}"`);
  return t[e];
}, F1e = (t, e) => {
  if (typeof e != "string")
    throw new TypeError(`Argument must be a string, not: ${e}`);
  return t(e);
}, T1e = (t, e) => {
  const n = {
    bold: fw("bold", t),
    italic: fw("italic", t),
    header: e === "" ? void 0 : fw(e, t)
  }, r = n.bold("_") !== "_";
  return { theme: n, useColors: r };
}, fw = (t, e) => G5(t, { colors: e, stream: xQ }), v1e = (t, e, { bold: n, italic: r }) => e ? t.replaceAll(
  x1e,
  mw.bind(void 0, n)
).replaceAll(
  C1e,
  mw.bind(void 0, n)
).replaceAll(
  k1e,
  mw.bind(void 0, r)
) : t, x1e = /(")([^"]+)(")/gu, C1e = /(')([^']+)(')/gu, k1e = /(`)([^`]+)(`)/gu, mw = (t, e, n, r, i) => `${n}${t(r)}${i}`, _1e = ({
  error: t,
  errorString: e,
  custom: n,
  recursiveBeautiful: r
}) => {
  if (typeof t[n] != "function" || Cg.has(t))
    return e;
  const i = N1e({
    error: t,
    errorString: e,
    custom: n,
    recursiveBeautiful: r
  });
  return I1e(i, r);
}, N1e = ({
  error: t,
  errorString: e,
  custom: n,
  recursiveBeautiful: r
}) => {
  Cg.add(t);
  try {
    return t[n](e);
  } catch (i) {
    return D1e(i, r);
  } finally {
    Cg.delete(t);
  }
}, D1e = (t, e) => {
  if (!sp(t))
    return e(t);
  Cg.add(t);
  try {
    return e(t);
  } finally {
    Cg.delete(t);
  }
}, Cg = /* @__PURE__ */ new WeakSet(), I1e = (t, e) => {
  if (typeof t == "string")
    return t;
  const n = new TypeError(
    `'error.beautiful()' must return a string, not: ${W5(t)}`
  );
  return e(n);
}, W5 = (t) => {
  try {
    return String(t);
  } catch (e) {
    return W5(e);
  }
}, R1e = (t = {}) => ({
  ...V5,
  ...K5(t)
}), V5 = {
  stack: !0,
  cause: !0,
  props: !0,
  icon: "cross",
  header: "red bold",
  custom: "beautiful"
}, K5 = (t) => EA(t, P1e), P1e = (t, e) => e === void 0, L1e = ({ classes: t = {}, ...e }) => {
  PC(t, "The option 'classes'");
  const { default: n = {}, ...r } = t;
  return { opts: e, classes: { ...r, default: n } };
}, M1e = (t, e, n) => {
  const r = e[t] ?? {};
  return PC(r, `The option 'classes.${t}'`), { ...n, ...K5(r) };
}, PC = (t, e) => {
  if (!Ii(t))
    throw new Error(`${e} must be a plain object, not: ${t}`);
}, O1e = (t, e) => t[e.name] ?? t.default, B1e = (t, e) => {
  if (typeof t != "string")
    throw new TypeError(`"${e}" must be a string: ${t}`);
  if (t !== "")
    try {
      G5(t);
    } catch (n) {
      throw new Error(
        `"${e}" ${t} must be a valid style: ${n.message}`
      );
    }
}, $1e = ({ messageLines: t, useColors: e, theme: n, error: r }) => {
  if (n.header === void 0 || !e)
    return t;
  const [i, ...s] = t;
  return [H1e(i, n, r), ...s];
}, H1e = (t, e, n) => {
  const r = U1e(t, n);
  if (r === -1)
    return t;
  const i = t.slice(0, r), s = t.slice(r);
  return `${e.header(i)}${s}`;
}, U1e = (t, e) => {
  const n = t.indexOf(":");
  return n !== -1 ? n + 1 : t.endsWith(e.name) ? t.length : n;
};
function G1e() {
  const { env: t } = $s, { TERM: e, TERM_PROGRAM: n } = t;
  return $s.platform !== "win32" ? e !== "linux" : !!t.WT_SESSION || !!t.TERMINUS_SUBLIME || t.ConEmuTask === "{cmd::Cmder}" || n === "Terminus-Sublime" || n === "vscode" || e === "xterm-256color" || e === "alacritty" || e === "rxvt-unicode" || e === "rxvt-unicode-256color" || t.TERMINAL_EMULATOR === "JetBrains-JediTerm";
}
const z5 = {
  circleQuestionMark: "(?)",
  questionMarkPrefix: "(?)",
  square: "█",
  squareDarkShade: "▓",
  squareMediumShade: "▒",
  squareLightShade: "░",
  squareTop: "▀",
  squareBottom: "▄",
  squareLeft: "▌",
  squareRight: "▐",
  squareCenter: "■",
  bullet: "●",
  dot: "․",
  ellipsis: "…",
  pointerSmall: "›",
  triangleUp: "▲",
  triangleUpSmall: "▴",
  triangleDown: "▼",
  triangleDownSmall: "▾",
  triangleLeftSmall: "◂",
  triangleRightSmall: "▸",
  home: "⌂",
  heart: "♥",
  musicNote: "♪",
  musicNoteBeamed: "♫",
  arrowUp: "↑",
  arrowDown: "↓",
  arrowLeft: "←",
  arrowRight: "→",
  arrowLeftRight: "↔",
  arrowUpDown: "↕",
  almostEqual: "≈",
  notEqual: "≠",
  lessOrEqual: "≤",
  greaterOrEqual: "≥",
  identical: "≡",
  infinity: "∞",
  subscriptZero: "₀",
  subscriptOne: "₁",
  subscriptTwo: "₂",
  subscriptThree: "₃",
  subscriptFour: "₄",
  subscriptFive: "₅",
  subscriptSix: "₆",
  subscriptSeven: "₇",
  subscriptEight: "₈",
  subscriptNine: "₉",
  oneHalf: "½",
  oneThird: "⅓",
  oneQuarter: "¼",
  oneFifth: "⅕",
  oneSixth: "⅙",
  oneEighth: "⅛",
  twoThirds: "⅔",
  twoFifths: "⅖",
  threeQuarters: "¾",
  threeFifths: "⅗",
  threeEighths: "⅜",
  fourFifths: "⅘",
  fiveSixths: "⅚",
  fiveEighths: "⅝",
  sevenEighths: "⅞",
  line: "─",
  lineBold: "━",
  lineDouble: "═",
  lineDashed0: "┄",
  lineDashed1: "┅",
  lineDashed2: "┈",
  lineDashed3: "┉",
  lineDashed4: "╌",
  lineDashed5: "╍",
  lineDashed6: "╴",
  lineDashed7: "╶",
  lineDashed8: "╸",
  lineDashed9: "╺",
  lineDashed10: "╼",
  lineDashed11: "╾",
  lineDashed12: "−",
  lineDashed13: "–",
  lineDashed14: "‐",
  lineDashed15: "⁃",
  lineVertical: "│",
  lineVerticalBold: "┃",
  lineVerticalDouble: "║",
  lineVerticalDashed0: "┆",
  lineVerticalDashed1: "┇",
  lineVerticalDashed2: "┊",
  lineVerticalDashed3: "┋",
  lineVerticalDashed4: "╎",
  lineVerticalDashed5: "╏",
  lineVerticalDashed6: "╵",
  lineVerticalDashed7: "╷",
  lineVerticalDashed8: "╹",
  lineVerticalDashed9: "╻",
  lineVerticalDashed10: "╽",
  lineVerticalDashed11: "╿",
  lineDownLeft: "┐",
  lineDownLeftArc: "╮",
  lineDownBoldLeftBold: "┓",
  lineDownBoldLeft: "┒",
  lineDownLeftBold: "┑",
  lineDownDoubleLeftDouble: "╗",
  lineDownDoubleLeft: "╖",
  lineDownLeftDouble: "╕",
  lineDownRight: "┌",
  lineDownRightArc: "╭",
  lineDownBoldRightBold: "┏",
  lineDownBoldRight: "┎",
  lineDownRightBold: "┍",
  lineDownDoubleRightDouble: "╔",
  lineDownDoubleRight: "╓",
  lineDownRightDouble: "╒",
  lineUpLeft: "┘",
  lineUpLeftArc: "╯",
  lineUpBoldLeftBold: "┛",
  lineUpBoldLeft: "┚",
  lineUpLeftBold: "┙",
  lineUpDoubleLeftDouble: "╝",
  lineUpDoubleLeft: "╜",
  lineUpLeftDouble: "╛",
  lineUpRight: "└",
  lineUpRightArc: "╰",
  lineUpBoldRightBold: "┗",
  lineUpBoldRight: "┖",
  lineUpRightBold: "┕",
  lineUpDoubleRightDouble: "╚",
  lineUpDoubleRight: "╙",
  lineUpRightDouble: "╘",
  lineUpDownLeft: "┤",
  lineUpBoldDownBoldLeftBold: "┫",
  lineUpBoldDownBoldLeft: "┨",
  lineUpDownLeftBold: "┥",
  lineUpBoldDownLeftBold: "┩",
  lineUpDownBoldLeftBold: "┪",
  lineUpDownBoldLeft: "┧",
  lineUpBoldDownLeft: "┦",
  lineUpDoubleDownDoubleLeftDouble: "╣",
  lineUpDoubleDownDoubleLeft: "╢",
  lineUpDownLeftDouble: "╡",
  lineUpDownRight: "├",
  lineUpBoldDownBoldRightBold: "┣",
  lineUpBoldDownBoldRight: "┠",
  lineUpDownRightBold: "┝",
  lineUpBoldDownRightBold: "┡",
  lineUpDownBoldRightBold: "┢",
  lineUpDownBoldRight: "┟",
  lineUpBoldDownRight: "┞",
  lineUpDoubleDownDoubleRightDouble: "╠",
  lineUpDoubleDownDoubleRight: "╟",
  lineUpDownRightDouble: "╞",
  lineDownLeftRight: "┬",
  lineDownBoldLeftBoldRightBold: "┳",
  lineDownLeftBoldRightBold: "┯",
  lineDownBoldLeftRight: "┰",
  lineDownBoldLeftBoldRight: "┱",
  lineDownBoldLeftRightBold: "┲",
  lineDownLeftRightBold: "┮",
  lineDownLeftBoldRight: "┭",
  lineDownDoubleLeftDoubleRightDouble: "╦",
  lineDownDoubleLeftRight: "╥",
  lineDownLeftDoubleRightDouble: "╤",
  lineUpLeftRight: "┴",
  lineUpBoldLeftBoldRightBold: "┻",
  lineUpLeftBoldRightBold: "┷",
  lineUpBoldLeftRight: "┸",
  lineUpBoldLeftBoldRight: "┹",
  lineUpBoldLeftRightBold: "┺",
  lineUpLeftRightBold: "┶",
  lineUpLeftBoldRight: "┵",
  lineUpDoubleLeftDoubleRightDouble: "╩",
  lineUpDoubleLeftRight: "╨",
  lineUpLeftDoubleRightDouble: "╧",
  lineUpDownLeftRight: "┼",
  lineUpBoldDownBoldLeftBoldRightBold: "╋",
  lineUpDownBoldLeftBoldRightBold: "╈",
  lineUpBoldDownLeftBoldRightBold: "╇",
  lineUpBoldDownBoldLeftRightBold: "╊",
  lineUpBoldDownBoldLeftBoldRight: "╉",
  lineUpBoldDownLeftRight: "╀",
  lineUpDownBoldLeftRight: "╁",
  lineUpDownLeftBoldRight: "┽",
  lineUpDownLeftRightBold: "┾",
  lineUpBoldDownBoldLeftRight: "╂",
  lineUpDownLeftBoldRightBold: "┿",
  lineUpBoldDownLeftBoldRight: "╃",
  lineUpBoldDownLeftRightBold: "╄",
  lineUpDownBoldLeftBoldRight: "╅",
  lineUpDownBoldLeftRightBold: "╆",
  lineUpDoubleDownDoubleLeftDoubleRightDouble: "╬",
  lineUpDoubleDownDoubleLeftRight: "╫",
  lineUpDownLeftDoubleRightDouble: "╪",
  lineCross: "╳",
  lineBackslash: "╲",
  lineSlash: "╱"
}, W1e = {
  tick: "✔",
  info: "ℹ",
  warning: "⚠",
  cross: "✘",
  squareSmall: "◻",
  squareSmallFilled: "◼",
  circle: "◯",
  circleFilled: "◉",
  circleDotted: "◌",
  circleDouble: "◎",
  circleCircle: "ⓞ",
  circleCross: "ⓧ",
  circlePipe: "Ⓘ",
  radioOn: "◉",
  radioOff: "◯",
  checkboxOn: "☒",
  checkboxOff: "☐",
  checkboxCircleOn: "ⓧ",
  checkboxCircleOff: "Ⓘ",
  pointer: "❯",
  triangleUpOutline: "△",
  triangleLeft: "◀",
  triangleRight: "▶",
  lozenge: "◆",
  lozengeOutline: "◇",
  hamburger: "☰",
  smiley: "㋡",
  mustache: "෴",
  star: "★",
  play: "▶",
  nodejs: "⬢",
  oneSeventh: "⅐",
  oneNinth: "⅑",
  oneTenth: "⅒"
}, V1e = {
  tick: "√",
  info: "i",
  warning: "‼",
  cross: "×",
  squareSmall: "□",
  squareSmallFilled: "■",
  circle: "( )",
  circleFilled: "(*)",
  circleDotted: "( )",
  circleDouble: "( )",
  circleCircle: "(○)",
  circleCross: "(×)",
  circlePipe: "(│)",
  radioOn: "(*)",
  radioOff: "( )",
  checkboxOn: "[×]",
  checkboxOff: "[ ]",
  checkboxCircleOn: "(×)",
  checkboxCircleOff: "( )",
  pointer: ">",
  triangleUpOutline: "∆",
  triangleLeft: "◄",
  triangleRight: "►",
  lozenge: "♦",
  lozengeOutline: "◊",
  hamburger: "≡",
  smiley: "☺",
  mustache: "┌─┐",
  star: "✶",
  play: "►",
  nodejs: "♦",
  oneSeventh: "1/7",
  oneNinth: "1/9",
  oneTenth: "1/10"
}, K1e = { ...z5, ...W1e }, z1e = { ...z5, ...V1e }, j1e = G1e(), j5 = j1e ? K1e : z1e, Y1e = (t, e) => {
  if (t !== "" && j5[t] === void 0)
    throw new Error(
      `"${e}" must be an icon name like "cross", "info" or "warning": ${t}`
    );
}, q1e = (t, e) => {
  if (e === "")
    return t;
  const [n, ...r] = t;
  return [`${j5[e]} ${n}`, ...r];
}, J1e = (t) => {
  Y5(t);
}, Y5 = (t = {}) => {
  PC(t, "The options");
  const { classes: e, opts: n } = L1e(t);
  return Object.fromEntries(
    Object.keys(e).map(
      (r) => [
        r,
        Q1e(r, e, n)
      ]
    )
  );
}, Q1e = (t, e, n) => {
  const r = M1e(t, e, n);
  return Object.entries(r).forEach(X1e), R1e(r);
}, X1e = ([t, e]) => {
  if (e === void 0)
    return;
  const n = eAe[t];
  if (n === void 0)
    throw new Error(`'${t}' is an unknown option`);
  n(e, t);
}, C0 = (t, e) => {
  if (typeof t != "boolean")
    throw new TypeError(`The option '${e}' must be a boolean: ${t}`);
}, Z1e = (t, e) => {
  if (typeof t != "string" && typeof t != "symbol")
    throw new TypeError(
      `The option '${e}' must be a string or a symbol: ${t}`
    );
}, eAe = {
  stack: C0,
  cause: C0,
  props: C0,
  colors: C0,
  icon: Y1e,
  header: B1e,
  custom: Z1e
}, tAe = (t, e) => {
  try {
    return { error: t, classes: Y5(e) };
  } catch (n) {
    return n.message = `${nAe} invalid usage: ${n.message}`, { error: fu(n), classes: { default: rAe } };
  }
}, nAe = "beautiful-error", rAe = { ...V5 }, iAe = ({
  error: t,
  errorString: e,
  theme: n,
  useColors: r,
  icon: i
}) => {
  const s = e.split(`
`);
  return sAe({ error: t, lines: s, theme: n, useColors: r, icon: i }).join(`
`);
}, sAe = ({ error: t, lines: e, theme: n, useColors: r, icon: i }) => {
  const { previewLines: s, messageLines: a, stackLines: o } = aAe(e, t), u = q1e(a, i), h = $1e({
    messageLines: u,
    useColors: r,
    theme: n,
    error: t
  }).map(
    (f) => v1e(f, r, n)
  );
  return [...s, ...h, ...o];
}, aAe = (t, e) => {
  const n = t.findIndex((h) => oAe(h, e)), r = n === -1 ? 0 : n, i = t.slice(0, r), s = t.slice(r), a = s.findIndex(uAe), o = a === -1 ? s.length : a, u = s.slice(0, o), l = s.slice(o);
  return { previewLines: i, messageLines: u, stackLines: l };
}, oAe = (t, e) => t === e.name || t.startsWith(`${e.name}: `) || t.startsWith(`${e.constructor.name} [`), uAe = (t) => FQ(t).trimStart().startsWith("at "), lAe = (t, e) => {
  if (e)
    return t;
  const n = new Error("");
  return Object.setPrototypeOf(n, Object.getPrototypeOf(t)), cAe(n, t), n;
}, cAe = (t, e) => {
  hAe.forEach((n) => {
    dAe(t, e, n);
  });
}, hAe = ["name", "message", "stack"], dAe = (t, e, n) => {
  const r = Object.getOwnPropertyDescriptor(e, n);
  r !== void 0 && Object.defineProperty(t, n, r);
}, fAe = (t, e) => {
  e || q5(t, mAe);
}, mAe = (t) => {
  !sp(t) || typeof t.stack != "string" || t.stack === "" || (l1(t, Cy, t.stack), delete t.stack);
}, gAe = (t, e) => {
  e || q5(t, pAe);
}, pAe = (t) => {
  t[Cy] !== void 0 && (l1(t, "stack", t[Cy]), delete t[Cy]);
}, Cy = /* @__PURE__ */ Symbol("stack"), q5 = (t, e) => {
  J5(t, e, 0);
}, J5 = (t, e, n) => {
  typeof t != "object" || t === null || n >= Q5 + 2 || (e(t), Reflect.ownKeys(t).forEach((r) => {
    J5(t[r], e, n + 1);
  }));
}, Q5 = 2, bAe = (t, e) => t.startsWith("[") ? t.slice(1).replace(`${e}]`, e) : t, LC = (t, e) => {
  const n = fu(t), { error: r, classes: i } = tAe(n, e);
  return X5({ error: r, depth: 0, classes: i, opts: e });
}, X5 = ({ error: t, depth: e, classes: n, opts: r }) => {
  const i = O1e(n, t), { cause: s, errors: a } = Gye(t), o = yAe({
    cause: s,
    errors: a,
    classes: n,
    classOpts: i,
    opts: r,
    depth: e
  }), u = AAe(t, r, i), l = Vye(u, e);
  return Wye(t, s, a), [l, ...o].join(`
`);
}, yAe = ({
  cause: t,
  errors: e = [],
  classes: n,
  classOpts: r,
  opts: i,
  depth: s
}) => r.cause ? [t, ...e].filter(Boolean).map(
  (a) => X5({ error: a, depth: s + 1, classes: n, opts: i })
) : [], AAe = (t, e, { colors: n, header: r, stack: i, props: s, icon: a, custom: o }) => {
  const { theme: u, useColors: l } = T1e(n, r), h = EAe({ error: t, stack: i, props: s, useColors: l }), f = iAe({
    error: t,
    errorString: h,
    theme: u,
    useColors: l,
    icon: a
  });
  return _1e({
    error: t,
    errorString: f,
    custom: o,
    recursiveBeautiful: (m) => LC(m, e)
  });
}, EAe = ({ error: t, stack: e, props: n, useColors: r }) => {
  const i = lAe(t, n);
  fAe(i, e);
  const s = jy(i, {
    colors: r,
    depth: Q5
  });
  return gAe(i, e), bAe(s, i.message);
}, SAe = (t, e) => {
  if ((!Number.isInteger(t) || t <= 0) && !wAe(t))
    throw new Error(
      `"${e}" must be 0, a positive integer or Infinity: ${t}`
    );
}, wAe = (t) => t === e$ || t === Z5, FAe = (t, e) => {
  if (t === Z5) {
    e();
    return;
  }
  t !== e$ && setTimeout(e, t).unref();
}, Z5 = 0, e$ = Number.POSITIVE_INFINITY, TAe = 5e3, vAe = (t, e) => {
  if (!Number.isInteger(t) || t < vI || t > xI)
    throw new Error(
      `"${e}" must be between ${vI} and ${xI}: ${t}`
    );
}, xAe = (t, e) => {
  $s.exitCode = t, FAe(e, () => {
    $s.exit(t);
  });
}, vI = 0, xI = 255, CAe = 125, kAe = 1, _Ae = (t) => ({
  ...t$,
  ...n$(t)
}), t$ = {
  silent: !1,
  exitCode: kAe,
  timeout: TAe,
  log(t) {
    console.error(t);
  }
}, n$ = (t) => EA(t, NAe), NAe = (t, e) => e === void 0, DAe = (t, e = {}) => {
  if (!Ii(e))
    throw new Error(`options must be a plain object: ${e}`);
  const { classes: n = {}, ...r } = e;
  HT(n, "classes");
  const i = n[t] || n.default || {};
  HT(i, `classes.${t}`);
  const s = {
    ...UT(r).beautifulErrorOpts,
    classes: Object.fromEntries(
      Object.entries(n).map(IAe)
    )
  };
  return { opts: UT({
    ...r,
    ...n$(i)
  }).opts, beautifulErrorOpts: s };
}, HT = (t, e) => {
  if (!Ii(t))
    throw new Error(`"${e}" must be a plain object: ${t}`);
}, IAe = ([t, e]) => [
  t,
  UT(e).beautifulErrorOpts
], UT = ({
  silent: t,
  exitCode: e,
  timeout: n,
  log: r,
  ...i
}) => ({ opts: { silent: t, exitCode: e, timeout: n, log: r }, beautifulErrorOpts: i }), RAe = (t = {}) => {
  HT(t, "options");
  const { classes: e } = t;
  (Ii(e) && Object.keys(e).length !== 0 ? Object.keys(e) : ["default"]).forEach((r) => {
    r$(r, t);
  });
}, r$ = (t, e) => {
  const { opts: n, beautifulErrorOpts: r } = DAe(t, e);
  return Object.entries(n).forEach(PAe), J1e(r), { opts: n, beautifulErrorOpts: r };
}, PAe = ([t, e]) => {
  e !== void 0 && OAe[t](e, t);
}, LAe = (t, e) => {
  if (typeof t != "boolean")
    throw new TypeError(`"${e}" must be a boolean: ${t}`);
}, MAe = (t, e) => {
  if (typeof t != "function")
    throw new TypeError(`"${e}" must be a function: ${t}`);
}, OAe = {
  silent: LAe,
  exitCode: vAe,
  timeout: SAe,
  log: MAe
}, BAe = (t, e) => {
  try {
    return $Ae(t, e);
  } catch (n) {
    return n.message = `handle-cli-error invalid usage: ${n.message}`, { error: fu(n), opts: HAe, beautifulErrorOpts: {} };
  }
}, $Ae = (t, e = {}) => {
  const { opts: n, beautifulErrorOpts: r } = r$(t.name, e), i = _Ae(n);
  return { error: t, opts: i, beautifulErrorOpts: r };
}, HAe = {
  ...t$,
  exitCode: CAe
}, UAe = (t, e) => {
  const n = fu(t), {
    error: r,
    opts: { silent: i, exitCode: s, timeout: a, log: o },
    beautifulErrorOpts: u
  } = BAe(n, e);
  GAe({ error: r, silent: i, log: o, beautifulErrorOpts: u }), xAe(s, a);
}, GAe = ({ error: t, silent: e, log: n, beautifulErrorOpts: r }) => {
  if (e)
    return;
  const i = LC(t, r);
  n(i);
}, WAe = (t) => typeof t != "string", VAe = (t = {}) => {
  if (RAe(t), t.classes !== void 0)
    throw new TypeError('The "classes" option must not be defined.');
  if (t.custom !== void 0)
    throw new TypeError('The "custom" option must not be defined.');
  return { ...t, custom: "pretty" };
}, KAe = ({ error: t, options: e }) => {
  i$(t);
  try {
    UAe(t, e);
  } finally {
    s$(t);
  }
}, zAe = ({
  error: t,
  options: { exitCode: e, silent: n, timeout: r, log: i, ...s }
}) => {
  i$(t);
  try {
    return LC(t, s);
  } finally {
    s$(t);
  }
}, i$ = (t) => {
  Object.defineProperty(t, "pretty", {
    value: void 0,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}, s$ = (t) => {
  delete t.pretty;
}, jAe = {
  name: "cli",
  isOptions: WAe,
  getOptions: VAe,
  instanceMethods: { exit: KAe, pretty: zAe }
}, Ao = Uye.subclass("BaseError", {
  plugins: [jAe],
  props: {
    /** Pipeline stage where the error originated (composed at runtime). */
    phase: "unknown",
    /** True if this error represents a violated invariant, not a user error. */
    isDefect: !1,
    /** Process exit code used by BaseError.exit(). */
    exitCode: 1
  }
}), a$ = Ao.subclass("NotFoundError"), ru = Ao.subclass("ParseError"), SVe = Ao.subclass("ValidationError"), Vd = Ao.subclass("IoError"), YAe = Ao.subclass("DefectError", {
  props: {
    phase: "internal",
    isDefect: !0,
    exitCode: 70
  }
}), qAe = "https://github.com/wix-private/ZeroConfig/issues";
async function wVe(t) {
  try {
    await t();
  } catch (e) {
    const n = Ao.normalize(e);
    if (n instanceof Ao) {
      Ao.exit(n);
      return;
    }
    const r = new YAe(
      `[DEFECT] An unexpected internal error occurred — please report at ${qAe}`,
      { cause: n }
    );
    Ao.exit(r);
  }
}
const JAe = "mock_ref_element__", QAe = /^mock_ref_element__([A-Za-z0-9\-_.!~*'()%]+)$/, CI = "props.elementProps.";
function XAe(t) {
  return `${JAe}${encodeURIComponent(t)}`;
}
function kI(t) {
  if (typeof t != "string") return;
  const e = t.trim(), n = QAe.exec(e);
  if (n?.[1])
    return decodeURIComponent(n[1]);
}
function o$(t) {
  if (t.startsWith(CI))
    return t.slice(CI.length);
}
function ZAe(t) {
  const e = t.lastIndexOf(".");
  if (e !== -1)
    return t.slice(0, e);
}
function _I(t) {
  return t.split(".").filter((e) => e !== "elementProps");
}
function eEe(t, e) {
  const n = _I(t), r = e ? _I(e) : [], s = r.every((o, u) => n[u] === o) && r.length > 0 ? n.slice(r.length) : n, a = s.length > 0 ? s : n.slice(-1);
  return a.length <= 1 ? a[0] ?? "" : ip(a.join(" "));
}
class tEe {
  constructor() {
    this.data = /* @__PURE__ */ new Map();
  }
  set(e, n, r) {
    this.data.has(e) || this.data.set(e, /* @__PURE__ */ new Map()), this.data.get(e).set(n, r);
  }
  get(e, n) {
    return this.data.get(e)?.get(n);
  }
  getAll(e) {
    return this.data.get(e);
  }
  entries() {
    return this.data.entries();
  }
  clear() {
    this.data.clear();
  }
}
const MC = bc(import.meta.url), mf = MC("react/jsx-runtime"), OC = MC("react/jsx-dev-runtime"), nEe = MC("react"), rEe = nEe.createElement, gw = /* @__PURE__ */ Symbol.for("zero-config:jsx-interceptor");
function u$() {
  const t = globalThis;
  return t[gw] || (t[gw] = {
    currentCreateElement: null,
    currentJsx: mf.jsx,
    currentJsxDEV: OC.jsxDEV,
    currentJsxs: mf.jsxs,
    isInsideOriginal: !1
  }), t[gw];
}
function NI(t, e, n) {
  const r = u$();
  r.currentJsx = t ?? mf.jsx, r.currentJsxs = e ?? mf.jsxs, r.currentJsxDEV = n ?? OC.jsxDEV;
}
function iEe() {
  return {
    jsx: mf.jsx,
    jsxs: mf.jsxs,
    jsxDEV: OC.jsxDEV
  };
}
function DI(t) {
  u$().currentCreateElement = t;
}
function sEe() {
  return rEe;
}
const l$ = "zero-config:ref-element-component-type", BC = Symbol.for(l$);
function Zm(t) {
  if (!t || typeof t != "function" && typeof t != "object")
    return;
  const e = t[BC];
  return typeof e == "string" ? e : void 0;
}
function aEe(t, e) {
  if (!c$(t))
    return t;
  try {
    if (Zm(t) === e)
      return t;
    Object.defineProperty(t, BC, {
      value: e,
      configurable: !0
    });
  } catch {
    return t;
  }
  return t;
}
function oEe(t, e) {
  if (!(!c$(t) || Zm(t) !== void 0) && (aEe(t, e), Zm(t) === e))
    return () => {
      try {
        Zm(t) === e && delete t[BC];
      } catch {
        return;
      }
    };
}
function uEe() {
  return `
const REF_ELEMENT_COMPONENT_TYPE_SYMBOL_KEY = ${JSON.stringify(l$)};
const refElementComponentTypeSymbol = Symbol.for(REF_ELEMENT_COMPONENT_TYPE_SYMBOL_KEY);
function isComponentLike(value) {
  return typeof value === 'function' || (typeof value === 'object' && value !== null && '$$typeof' in value);
}
function readRefElementComponentType(componentType) {
  if (!componentType || (typeof componentType !== 'function' && typeof componentType !== 'object')) {
    return undefined;
  }

  const refComponentType = componentType[refElementComponentTypeSymbol];
  return typeof refComponentType === 'string' ? refComponentType : undefined;
}
function safelyTagRefElementComponent(componentValue, refComponentType) {
  if (!isComponentLike(componentValue)) {
    return componentValue;
  }

  try {
    if (readRefElementComponentType(componentValue) === refComponentType) {
      return componentValue;
    }

    Object.defineProperty(componentValue, refElementComponentTypeSymbol, {
      value: refComponentType,
      configurable: true,
    });
  } catch {
    return componentValue;
  }

  return componentValue;
}
`;
}
function c$(t) {
  return typeof t == "function" || typeof t == "object" && t !== null && "$$typeof" in t;
}
const h$ = "zero-config:jsx-interceptor", d$ = "zero-config:jsx-originals", f$ = "zero-config:react-originals", $C = Symbol.for(f$), II = /* @__PURE__ */ Symbol.for("zero-config:jsx-loader-registered"), RI = /* @__PURE__ */ Symbol.for("zero-config:ref-element-runtime-state"), lEe = 1e3, d1 = "zero-config-ref-entry";
function cEe(t, e) {
  if (e.length === 0)
    return t;
  const n = UC(e), r = b$(n), i = new URL(t);
  return i.searchParams.has(d1) || i.searchParams.set(d1, r), i.href;
}
async function hEe(t, e = []) {
  if (m$(), e.length === 0)
    return {
      cleanup: async () => {
      },
      importUrl: ju(t).href
    };
  const n = UC(e), r = b$(n);
  await mEe(r, n);
  const i = ju(t);
  return i.searchParams.set(d1, r), {
    cleanup: async () => {
    },
    importUrl: i.href
  };
}
function m$() {
  const t = globalThis;
  if (t[II])
    return;
  const e = wA(), { port1: n, port2: r } = new RQ();
  try {
    e.loaderPort = n, n.on("message", (f) => {
      const m = e.pendingLoaderRequests.get(f.requestId);
      if (m) {
        if (e.pendingLoaderRequests.delete(f.requestId), f.success) {
          m.resolve();
          return;
        }
        m.reject(new Error(f.error ?? "Failed to register ref-element modules in the loader"));
      }
    }), n.unref(), r.unref();
    const i = bc(import.meta.url), s = i("react/jsx-runtime"), a = i("react/jsx-dev-runtime"), o = i("react");
    globalThis[Symbol.for(d$)] = {
      Fragment: s.Fragment,
      jsx: s.jsx,
      jsxDEV: a.jsxDEV,
      jsxs: s.jsxs
    }, globalThis[$C] = o;
    const u = `data:text/javascript,${encodeURIComponent(FEe(o))}`, l = `data:text/javascript,${encodeURIComponent(TEe())}`, h = vEe({
      interceptorModuleUrl: l,
      reactModuleUrl: u,
      taggerSource: uEe()
    });
    NQ(`data:text/javascript,${encodeURIComponent(h)}`, {
      data: { port: r },
      transferList: [r]
    }), t[II] = !0;
  } catch (i) {
    throw e.loaderPort = null, n.close(), r.close(), i;
  }
}
function dEe() {
  return globalThis[$C];
}
function PI(t) {
  globalThis[$C] = t;
}
function fEe(t, e = []) {
  const n = wA(), r = bc(t), i = pEe(n, e);
  bEe(n), yEe(r, i);
  let s = !1;
  try {
    const a = r(t);
    return {
      cleanup: async () => {
        s || (s = !0, LI(n, i.id));
      },
      moduleExports: a
    };
  } catch (a) {
    throw LI(n, i.id), a;
  }
}
function wA() {
  const t = globalThis, e = t[RI];
  if (e)
    return e;
  const n = {
    activeCjsExtractions: /* @__PURE__ */ new Map(),
    loaderPort: null,
    nextCjsExtractionId: 0,
    nextLoaderRequestId: 0,
    pendingLoaderRequests: /* @__PURE__ */ new Map(),
    registeredEsmModulesByResolvedUrl: /* @__PURE__ */ new Map(),
    originalModuleLoad: null
  };
  return t[RI] = n, n;
}
async function mEe(t, e) {
  const n = wA(), r = {};
  for (const i of e) {
    const s = p$(n.registeredEsmModulesByResolvedUrl, i);
    r[s.resolvedModuleUrl] = s;
  }
  await gEe({
    modulesByResolvedUrl: r,
    signature: t
  });
}
function gEe(t) {
  const e = wA(), n = e.loaderPort;
  if (!(n instanceof PQ))
    return Promise.reject(new Error("Ref-element loader has not been initialized"));
  e.nextLoaderRequestId += 1;
  const r = e.nextLoaderRequestId;
  return new Promise((i, s) => {
    const a = setTimeout(() => {
      e.pendingLoaderRequests.delete(r), s(new Error("Timed out waiting for ref-element loader registration"));
    }, lEe);
    e.pendingLoaderRequests.set(r, {
      reject: (o) => {
        clearTimeout(a), s(o);
      },
      resolve: () => {
        clearTimeout(a), i();
      }
    }), n.postMessage({
      ...t,
      requestId: r
    });
  });
}
function pEe(t, e) {
  t.nextCjsExtractionId += 1;
  const n = {
    cleanupHandlers: [],
    id: t.nextCjsExtractionId,
    runtimeModulesByResolvedPath: /* @__PURE__ */ new Map()
  };
  for (const r of UC(e)) {
    if (!r.resolvedModuleUrl.startsWith("file:"))
      continue;
    const i = wn(r.resolvedModuleUrl), s = n.runtimeModulesByResolvedPath.get(i) ?? [];
    s.push(r), n.runtimeModulesByResolvedPath.set(i, s);
  }
  return t.activeCjsExtractions.set(n.id, n), n;
}
function bEe(t) {
  if (t.originalModuleLoad)
    return;
  const e = HC();
  t.originalModuleLoad = e._load, e._load = function(n, r, i) {
    const s = t.originalModuleLoad?.call(this, n, r, i), a = EEe(n, r, i);
    return a && AEe(t, a, s), s;
  };
}
function LI(t, e) {
  const n = t.activeCjsExtractions.get(e);
  if (!n)
    return;
  t.activeCjsExtractions.delete(e);
  for (const i of n.cleanupHandlers.reverse())
    i();
  if (t.activeCjsExtractions.size !== 0)
    return;
  const r = HC();
  t.originalModuleLoad && (r._load = t.originalModuleLoad, t.originalModuleLoad = null);
}
function yEe(t, e) {
  for (const [n, r] of e.runtimeModulesByResolvedPath) {
    const i = t.cache[n];
    if (i)
      for (const s of r)
        e.cleanupHandlers.push(...g$(i.exports, s));
  }
}
function AEe(t, e, n) {
  for (const r of t.activeCjsExtractions.values()) {
    const i = r.runtimeModulesByResolvedPath.get(e);
    if (i)
      for (const s of i)
        r.cleanupHandlers.push(...g$(n, s));
  }
}
function HC() {
  return bc(import.meta.url)("node:module");
}
function EEe(t, e, n) {
  try {
    return HC()._resolveFilename(t, e, n);
  } catch {
    return;
  }
}
function g$(t, e) {
  const n = [];
  for (const r of e.exportNames) {
    const i = SEe(t, r), s = oEe(i, e.refComponentType);
    s && n.push(s);
  }
  return n;
}
function UC(t) {
  const e = /* @__PURE__ */ new Map();
  for (const n of t)
    p$(e, {
      exportNames: [...n.exportNames],
      resolvedModuleUrl: n.resolvedModuleUrl,
      refComponentType: n.refComponentType
    });
  return [...e.values()];
}
function p$(t, e) {
  const n = t.get(e.resolvedModuleUrl);
  if (!n)
    return t.set(e.resolvedModuleUrl, e), e;
  if (n.refComponentType !== e.refComponentType)
    throw new Error(
      `Conflicting ref-element types for ${e.resolvedModuleUrl}: ${n.refComponentType} vs ${e.refComponentType}`
    );
  return n.exportNames = [.../* @__PURE__ */ new Set([...n.exportNames, ...e.exportNames])], n;
}
function b$(t) {
  const e = t.map((n) => ({
    exportNames: [...n.exportNames].sort(),
    refComponentType: n.refComponentType,
    resolvedModuleUrl: n.resolvedModuleUrl
  })).sort((n, r) => JSON.stringify(n).localeCompare(JSON.stringify(r)));
  return IQ("sha1").update(JSON.stringify(e)).digest("hex");
}
function SEe(t, e) {
  if (e === "default")
    return wEe(t) ? t : typeof t == "object" && t !== null ? t.default : void 0;
  if (!(typeof t != "object" || t === null))
    return t[e];
}
function wEe(t) {
  return typeof t == "function" ? !0 : typeof t == "object" && t !== null && "$$typeof" in t;
}
function FEe(t) {
  const e = Object.keys(t).map((n) => n === "createElement" ? `export function createElement() {
  var state = globalThis[STATE_KEY];
  if (state && state.currentCreateElement) return state.currentCreateElement.apply(null, arguments);
  return globalThis[REACT_KEY].createElement.apply(null, arguments);
}` : n.startsWith("use") && typeof t[n] == "function" ? `export function ${n}() {
  return globalThis[REACT_KEY].${n}.apply(null, arguments);
}` : `export var ${n} = reactModule.${n};`).join(`
`);
  return `
var REACT_KEY = Symbol.for(${JSON.stringify(f$)});
var STATE_KEY = Symbol.for(${JSON.stringify(h$)});
var reactModule = globalThis[REACT_KEY];
export default new Proxy({}, { get: function(_, prop) { return globalThis[REACT_KEY][prop]; } });
${e}
`;
}
function TEe() {
  return `
const ORIGINALS_KEY = Symbol.for(${JSON.stringify(d$)});
const STATE_KEY = Symbol.for(${JSON.stringify(h$)});
const originals = globalThis[ORIGINALS_KEY];
function getState() {
  if (!globalThis[STATE_KEY]) {
    globalThis[STATE_KEY] = {
      currentJsx: originals.jsx, currentJsxs: originals.jsxs,
      currentJsxDEV: originals.jsxDEV, isInsideOriginal: false,
    };
  }
  return globalThis[STATE_KEY];
}
export const Fragment = originals.Fragment;
export function jsx(type, props, key) {
  const state = getState();
  if (state.isInsideOriginal) return originals.jsx(type, props, key);
  state.isInsideOriginal = true;
  try { return state.currentJsx(type, props, key); }
  finally { state.isInsideOriginal = false; }
}
export function jsxs(type, props, key) {
  const state = getState();
  if (state.isInsideOriginal) return originals.jsxs(type, props, key);
  state.isInsideOriginal = true;
  try { return state.currentJsxs(type, props, key); }
  finally { state.isInsideOriginal = false; }
}
export function jsxDEV(type, props, key, isStaticChildren, source, self) {
  const state = getState();
  if (state.isInsideOriginal) return originals.jsxDEV(type, props, key, isStaticChildren, source, self);
  state.isInsideOriginal = true;
  try { return state.currentJsxDEV(type, props, key, isStaticChildren, source, self); }
  finally { state.isInsideOriginal = false; }
}
`;
}
function vEe(t) {
  return `
const INTERCEPTOR_URL = ${JSON.stringify(t.interceptorModuleUrl)};
const REACT_MODULE_URL = ${JSON.stringify(t.reactModuleUrl)};
const TAGGER_SOURCE = ${JSON.stringify(t.taggerSource)};
const REF_ELEMENT_ENTRY_SIGNATURE_QUERY_PARAM = ${JSON.stringify(d1)};
const refElementModulesBySignature = Object.create(null);
export function initialize(data) {
  data.port.on('message', (message) => {
    try {
      const registeredModulesByResolvedUrl = refElementModulesBySignature[message.signature] ?? Object.create(null);
      Object.assign(registeredModulesByResolvedUrl, message.modulesByResolvedUrl);
      refElementModulesBySignature[message.signature] = registeredModulesByResolvedUrl;

      data.port.postMessage({ requestId: message.requestId, success: true });
    } catch (error) {
      data.port.postMessage({
        error: error instanceof Error ? error.message : String(error),
        requestId: message.requestId,
        success: false,
      });
    }
  });
}
function createTaggedRefElementModuleUrl(realUrl, moduleState) {
  const realModuleImportUrl = new URL(realUrl);
  realModuleImportUrl.searchParams.set('zero-config-ref-real', moduleState.refComponentType);
  const namedExportLines = moduleState.exportNames
    .filter((exportName) => exportName !== 'default')
    .map((exportName) => \`export const \${exportName} = safelyTagRefElementComponent(realModule.\${exportName}, REF_COMPONENT_TYPE);\`)
    .join('\\n');
  const taggedModuleSource = \`
import * as realModule from \${JSON.stringify(realModuleImportUrl.href)};
const REF_COMPONENT_TYPE = \${JSON.stringify(moduleState.refComponentType)};
\${TAGGER_SOURCE}
export default safelyTagRefElementComponent(realModule.default ?? realModule, REF_COMPONENT_TYPE);
\${namedExportLines}
export * from \${JSON.stringify(realModuleImportUrl.href)};
\`;

  return \`data:text/javascript,\${encodeURIComponent(taggedModuleSource)}\`;
}
function readRefElementEntrySignature(urlString) {
  if (!urlString) {
    return undefined;
  }

  try {
    const url = new URL(urlString);
    return url.searchParams.get(REF_ELEMENT_ENTRY_SIGNATURE_QUERY_PARAM) ?? undefined;
  } catch {
    return undefined;
  }
}
function shouldPropagateRefElementEntrySignature(resolvedUrl) {
  return resolvedUrl.startsWith('file:') && !resolvedUrl.includes('/node_modules/');
}
function addRefElementEntrySignature(resolvedUrl, refElementEntrySignature) {
  const signedUrl = new URL(resolvedUrl);
  if (!signedUrl.searchParams.has(REF_ELEMENT_ENTRY_SIGNATURE_QUERY_PARAM)) {
    signedUrl.searchParams.set(REF_ELEMENT_ENTRY_SIGNATURE_QUERY_PARAM, refElementEntrySignature);
  }
  return signedUrl.href;
}
export async function resolve(specifier, context, nextResolve) {
  if (specifier === 'react/jsx-runtime' || specifier === 'react/jsx-dev-runtime') {
    return { shortCircuit: true, url: INTERCEPTOR_URL };
  }
  if (specifier === 'react') {
    return { shortCircuit: true, url: REACT_MODULE_URL };
  }

  const resolvedModule = await nextResolve(specifier, context);
  if (new URL(resolvedModule.url).searchParams.has('zero-config-ref-real')) {
    return resolvedModule;
  }

  const refElementEntrySignature = readRefElementEntrySignature(context.parentURL);
  if (!refElementEntrySignature) {
    return resolvedModule;
  }

  const refElementModulesByResolvedUrl = refElementModulesBySignature[refElementEntrySignature] ?? Object.create(null);
  const moduleState = refElementModulesByResolvedUrl[resolvedModule.url];
  if (moduleState) {
    return {
      ...resolvedModule,
      shortCircuit: true,
      url: createTaggedRefElementModuleUrl(resolvedModule.url, moduleState),
    };
  }

  if (shouldPropagateRefElementEntrySignature(resolvedModule.url)) {
    return {
      ...resolvedModule,
      shortCircuit: true,
      url: addRefElementEntrySignature(resolvedModule.url, refElementEntrySignature),
    };
  }

  return resolvedModule;
}
`;
}
const gf = "data-trace-id", xEe = (t) => typeof t == "string" && /^[a-z]/.test(t);
function k0(t, e, n, r) {
  return (i, s, ...a) => {
    const o = s ?? {}, u = xEe(i), l = u ? n() : void 0, h = a.length > 0 ? a : o.children ? [o.children] : [], f = {
      type: i,
      isDomElement: u,
      tag: u ? i : void 0,
      props: { ...o, children: h },
      traceId: l,
      children: h,
      store: r
    };
    if (e.forEach((g) => g.onCreateElement(f)), !u || !l)
      return t(i, s, ...a);
    const m = { ...o, [gf]: l };
    return t(i, m, ...a);
  };
}
const CEe = "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", kEe = "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE";
function MI(t) {
  if (typeof t != "object" || t === null)
    return;
  const e = t, n = e[CEe] ?? e[kEe];
  return typeof n == "object" && n !== null ? n : void 0;
}
function _Ee(t, e) {
  const n = MI(t), r = MI(e);
  if (!n || !r)
    return () => {
    };
  if (n.ReactCurrentDispatcher && r.ReactCurrentDispatcher) {
    const i = n.ReactCurrentDispatcher, s = r.ReactCurrentDispatcher;
    if (i === s)
      return () => {
      };
    const a = Object.getOwnPropertyDescriptor(i, "current");
    return Object.defineProperty(i, "current", {
      configurable: !0,
      get: () => s.current,
      set: (o) => {
        s.current = o;
      }
    }), () => {
      Object.defineProperty(
        i,
        "current",
        a ?? { configurable: !0, enumerable: !0, value: null, writable: !0 }
      );
    };
  }
  if ("H" in r) {
    const i = Object.getOwnPropertyDescriptor(n, "H");
    return Object.defineProperty(n, "H", {
      configurable: !0,
      get: () => r.H,
      set: (s) => {
        r.H = s;
      }
    }), () => {
      Object.defineProperty(
        n,
        "H",
        i ?? { configurable: !0, enumerable: !0, value: void 0, writable: !0 }
      );
    };
  }
  return () => {
  };
}
function NEe(t, e, n, r, i) {
  let s = 0;
  const a = () => `t${++s}`, o = sEe(), { jsx: u, jsxs: l, jsxDEV: h } = iEe(), f = bc(import.meta.url), m = f("react/jsx-runtime"), g = f("react/jsx-dev-runtime"), A = m.jsx, E = m.jsxs, w = g.jsxDEV;
  let x, N, B, P, C, D, L, k;
  if (i)
    try {
      const q = bc(i), X = q("react");
      if (X !== gr) {
        x = X, C = X.createElement;
        try {
          N = q("react-dom/server").renderToStaticMarkup;
        } catch {
          throw new Error(
            `Component bundle at "${i}" resolves a different React than the host; install "react-dom" alongside "react" so SSR can run against the user's React.`
          );
        }
      }
      const ie = q("react/jsx-runtime");
      ie !== m && (B = ie, D = ie.jsx, L = ie.jsxs);
      const te = q("react/jsx-dev-runtime");
      te !== g && (P = te, k = te.jsxDEV);
    } catch (q) {
      if (x) throw q;
    }
  const I = k0(
    o,
    n,
    a,
    r
  ), U = k0(u, n, a, r), j = k0(l, n, a, r), J = k0(h, n, a, r), G = dEe();
  let H = () => {
  };
  try {
    gr.createElement = I, DI(I), NI(
      U,
      j,
      J
    ), m.jsx = U, m.jsxs = j, g.jsxDEV = J, x && (x.createElement = I, PI(x), H = _Ee(gr, x)), B && (B.jsx = U, B.jsxs = j), P && (P.jsxDEV = J);
    const X = (x ?? gr).createElement(t, e);
    return (N ?? DQ)(X);
  } finally {
    H(), PI(G), gr.createElement = o, DI(null), NI(), m.jsx = A, m.jsxs = E, g.jsxDEV = w, x && C && (x.createElement = C), B && (B.jsx = D, B.jsxs = L), P && (P.jsxDEV = k);
  }
}
const DEe = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), Er = "�";
var O;
(function(t) {
  t[t.EOF = -1] = "EOF", t[t.NULL = 0] = "NULL", t[t.TABULATION = 9] = "TABULATION", t[t.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", t[t.LINE_FEED = 10] = "LINE_FEED", t[t.FORM_FEED = 12] = "FORM_FEED", t[t.SPACE = 32] = "SPACE", t[t.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", t[t.QUOTATION_MARK = 34] = "QUOTATION_MARK", t[t.AMPERSAND = 38] = "AMPERSAND", t[t.APOSTROPHE = 39] = "APOSTROPHE", t[t.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", t[t.SOLIDUS = 47] = "SOLIDUS", t[t.DIGIT_0 = 48] = "DIGIT_0", t[t.DIGIT_9 = 57] = "DIGIT_9", t[t.SEMICOLON = 59] = "SEMICOLON", t[t.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", t[t.EQUALS_SIGN = 61] = "EQUALS_SIGN", t[t.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", t[t.QUESTION_MARK = 63] = "QUESTION_MARK", t[t.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", t[t.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", t[t.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", t[t.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", t[t.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", t[t.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(O || (O = {}));
const vs = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function y$(t) {
  return t >= 55296 && t <= 57343;
}
function IEe(t) {
  return t >= 56320 && t <= 57343;
}
function REe(t, e) {
  return (t - 55296) * 1024 + 9216 + e;
}
function A$(t) {
  return t !== 32 && t !== 10 && t !== 13 && t !== 9 && t !== 12 && t >= 1 && t <= 31 || t >= 127 && t <= 159;
}
function E$(t) {
  return t >= 64976 && t <= 65007 || DEe.has(t);
}
var ce;
(function(t) {
  t.controlCharacterInInputStream = "control-character-in-input-stream", t.noncharacterInInputStream = "noncharacter-in-input-stream", t.surrogateInInputStream = "surrogate-in-input-stream", t.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", t.endTagWithAttributes = "end-tag-with-attributes", t.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", t.unexpectedSolidusInTag = "unexpected-solidus-in-tag", t.unexpectedNullCharacter = "unexpected-null-character", t.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", t.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", t.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", t.missingEndTagName = "missing-end-tag-name", t.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", t.unknownNamedCharacterReference = "unknown-named-character-reference", t.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", t.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", t.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", t.eofBeforeTagName = "eof-before-tag-name", t.eofInTag = "eof-in-tag", t.missingAttributeValue = "missing-attribute-value", t.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", t.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", t.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", t.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", t.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", t.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", t.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", t.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", t.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", t.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", t.cdataInHtmlContent = "cdata-in-html-content", t.incorrectlyOpenedComment = "incorrectly-opened-comment", t.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", t.eofInDoctype = "eof-in-doctype", t.nestedComment = "nested-comment", t.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", t.eofInComment = "eof-in-comment", t.incorrectlyClosedComment = "incorrectly-closed-comment", t.eofInCdata = "eof-in-cdata", t.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", t.nullCharacterReference = "null-character-reference", t.surrogateCharacterReference = "surrogate-character-reference", t.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", t.controlCharacterReference = "control-character-reference", t.noncharacterCharacterReference = "noncharacter-character-reference", t.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", t.missingDoctypeName = "missing-doctype-name", t.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", t.duplicateAttribute = "duplicate-attribute", t.nonConformingDoctype = "non-conforming-doctype", t.missingDoctype = "missing-doctype", t.misplacedDoctype = "misplaced-doctype", t.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", t.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", t.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", t.openElementsLeftAfterEof = "open-elements-left-after-eof", t.abandonedHeadElementChild = "abandoned-head-element-child", t.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", t.nestedNoscriptInHead = "nested-noscript-in-head", t.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(ce || (ce = {}));
const PEe = 65536;
class LEe {
  constructor(e) {
    this.handler = e, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = PEe, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(e, n) {
    const { line: r, col: i, offset: s } = this, a = i + n, o = s + n;
    return {
      code: e,
      startLine: r,
      endLine: r,
      startCol: a,
      endCol: a,
      startOffset: o,
      endOffset: o
    };
  }
  _err(e) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(e, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(e) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (IEe(n))
        return this.pos++, this._addGap(), REe(e, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, O.EOF;
    return this._err(ce.surrogateInInputStream), e;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(e, n) {
    this.html.length > 0 ? this.html += e : this.html = e, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(e) {
    this.html = this.html.substring(0, this.pos + 1) + e + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(e, n) {
    if (this.pos + e.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (n)
      return this.html.startsWith(e, this.pos);
    for (let r = 0; r < e.length; r++)
      if ((this.html.charCodeAt(this.pos + r) | 32) !== e.charCodeAt(r))
        return !1;
    return !0;
  }
  peek(e) {
    const n = this.pos + e;
    if (n >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, O.EOF;
    const r = this.html.charCodeAt(n);
    return r === O.CARRIAGE_RETURN ? O.LINE_FEED : r;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, O.EOF;
    let e = this.html.charCodeAt(this.pos);
    return e === O.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, O.LINE_FEED) : e === O.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, y$(e) && (e = this._processSurrogate(e)), this.handler.onParseError === null || e > 31 && e < 127 || e === O.LINE_FEED || e === O.CARRIAGE_RETURN || e > 159 && e < 64976 || this._checkForProblematicCharacters(e), e);
  }
  _checkForProblematicCharacters(e) {
    A$(e) ? this._err(ce.controlCharacterInInputStream) : E$(e) && this._err(ce.noncharacterInInputStream);
  }
  retreat(e) {
    for (this.pos -= e; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var Fn;
(function(t) {
  t[t.CHARACTER = 0] = "CHARACTER", t[t.NULL_CHARACTER = 1] = "NULL_CHARACTER", t[t.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", t[t.START_TAG = 3] = "START_TAG", t[t.END_TAG = 4] = "END_TAG", t[t.COMMENT = 5] = "COMMENT", t[t.DOCTYPE = 6] = "DOCTYPE", t[t.EOF = 7] = "EOF", t[t.HIBERNATION = 8] = "HIBERNATION";
})(Fn || (Fn = {}));
function S$(t, e) {
  for (let n = t.attrs.length - 1; n >= 0; n--)
    if (t.attrs[n].name === e)
      return t.attrs[n].value;
  return null;
}
const MEe = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((t) => t.charCodeAt(0))
), OEe = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function BEe(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = OEe.get(t)) !== null && e !== void 0 ? e : t;
}
var ki;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(ki || (ki = {}));
const $Ee = 32;
var Ml;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Ml || (Ml = {}));
function GT(t) {
  return t >= ki.ZERO && t <= ki.NINE;
}
function HEe(t) {
  return t >= ki.UPPER_A && t <= ki.UPPER_F || t >= ki.LOWER_A && t <= ki.LOWER_F;
}
function UEe(t) {
  return t >= ki.UPPER_A && t <= ki.UPPER_Z || t >= ki.LOWER_A && t <= ki.LOWER_Z || GT(t);
}
function GEe(t) {
  return t === ki.EQUALS || UEe(t);
}
var yi;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})(yi || (yi = {}));
var Bu;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(Bu || (Bu = {}));
let WEe = class {
  constructor(e, n, r) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = r, this.state = yi.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Bu.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = yi.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, n) {
    switch (this.state) {
      case yi.EntityStart:
        return e.charCodeAt(n) === ki.NUM ? (this.state = yi.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = yi.NamedEntity, this.stateNamedEntity(e, n));
      case yi.NumericStart:
        return this.stateNumericStart(e, n);
      case yi.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case yi.NumericHex:
        return this.stateNumericHex(e, n);
      case yi.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | $Ee) === ki.LOWER_X ? (this.state = yi.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = yi.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  addToNumericResult(e, n, r, i) {
    if (n !== r) {
      const s = r - n;
      this.result = this.result * Math.pow(i, s) + Number.parseInt(e.substr(n, s), i), this.consumed += s;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const i = e.charCodeAt(n);
      if (GT(i) || HEe(i))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 16), this.emitNumericEntity(i, 3);
    }
    return this.addToNumericResult(e, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const i = e.charCodeAt(n);
      if (GT(i))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 10), this.emitNumericEntity(i, 2);
    }
    return this.addToNumericResult(e, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === ki.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Bu.Strict)
      return 0;
    return this.emitCodePoint(BEe(this.result), this.consumed), this.errors && (e !== ki.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, n) {
    const { decodeTree: r } = this;
    let i = r[this.treeIndex], s = (i & Ml.VALUE_LENGTH) >> 14;
    for (; n < e.length; n++, this.excess++) {
      const a = e.charCodeAt(n);
      if (this.treeIndex = VEe(r, i, this.treeIndex + Math.max(1, s), a), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Bu.Attribute && // We shouldn't have consumed any characters after the entity,
        (s === 0 || // And there should be no invalid characters.
        GEe(a)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (i = r[this.treeIndex], s = (i & Ml.VALUE_LENGTH) >> 14, s !== 0) {
        if (a === ki.SEMI)
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        this.decodeMode !== Bu.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: n, decodeTree: r } = this, i = (r[n] & Ml.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, i, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, n, r) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(n === 1 ? i[e] & ~Ml.VALUE_LENGTH : i[e + 1], r), n === 3 && this.emitCodePoint(i[e + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case yi.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Bu.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case yi.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case yi.NumericHex:
        return this.emitNumericEntity(0, 3);
      case yi.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case yi.EntityStart:
        return 0;
    }
  }
};
function VEe(t, e, n, r) {
  const i = (e & Ml.BRANCH_LENGTH) >> 7, s = e & Ml.JUMP_TABLE;
  if (i === 0)
    return s !== 0 && r === s ? n : -1;
  if (s) {
    const u = r - s;
    return u < 0 || u >= i ? -1 : t[n + u] - 1;
  }
  let a = n, o = a + i - 1;
  for (; a <= o; ) {
    const u = a + o >>> 1, l = t[u];
    if (l < r)
      a = u + 1;
    else if (l > r)
      o = u - 1;
    else
      return t[u + i];
  }
  return -1;
}
var ke;
(function(t) {
  t.HTML = "http://www.w3.org/1999/xhtml", t.MATHML = "http://www.w3.org/1998/Math/MathML", t.SVG = "http://www.w3.org/2000/svg", t.XLINK = "http://www.w3.org/1999/xlink", t.XML = "http://www.w3.org/XML/1998/namespace", t.XMLNS = "http://www.w3.org/2000/xmlns/";
})(ke || (ke = {}));
var ph;
(function(t) {
  t.TYPE = "type", t.ACTION = "action", t.ENCODING = "encoding", t.PROMPT = "prompt", t.NAME = "name", t.COLOR = "color", t.FACE = "face", t.SIZE = "size";
})(ph || (ph = {}));
var Ia;
(function(t) {
  t.NO_QUIRKS = "no-quirks", t.QUIRKS = "quirks", t.LIMITED_QUIRKS = "limited-quirks";
})(Ia || (Ia = {}));
var re;
(function(t) {
  t.A = "a", t.ADDRESS = "address", t.ANNOTATION_XML = "annotation-xml", t.APPLET = "applet", t.AREA = "area", t.ARTICLE = "article", t.ASIDE = "aside", t.B = "b", t.BASE = "base", t.BASEFONT = "basefont", t.BGSOUND = "bgsound", t.BIG = "big", t.BLOCKQUOTE = "blockquote", t.BODY = "body", t.BR = "br", t.BUTTON = "button", t.CAPTION = "caption", t.CENTER = "center", t.CODE = "code", t.COL = "col", t.COLGROUP = "colgroup", t.DD = "dd", t.DESC = "desc", t.DETAILS = "details", t.DIALOG = "dialog", t.DIR = "dir", t.DIV = "div", t.DL = "dl", t.DT = "dt", t.EM = "em", t.EMBED = "embed", t.FIELDSET = "fieldset", t.FIGCAPTION = "figcaption", t.FIGURE = "figure", t.FONT = "font", t.FOOTER = "footer", t.FOREIGN_OBJECT = "foreignObject", t.FORM = "form", t.FRAME = "frame", t.FRAMESET = "frameset", t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t.H6 = "h6", t.HEAD = "head", t.HEADER = "header", t.HGROUP = "hgroup", t.HR = "hr", t.HTML = "html", t.I = "i", t.IMG = "img", t.IMAGE = "image", t.INPUT = "input", t.IFRAME = "iframe", t.KEYGEN = "keygen", t.LABEL = "label", t.LI = "li", t.LINK = "link", t.LISTING = "listing", t.MAIN = "main", t.MALIGNMARK = "malignmark", t.MARQUEE = "marquee", t.MATH = "math", t.MENU = "menu", t.META = "meta", t.MGLYPH = "mglyph", t.MI = "mi", t.MO = "mo", t.MN = "mn", t.MS = "ms", t.MTEXT = "mtext", t.NAV = "nav", t.NOBR = "nobr", t.NOFRAMES = "noframes", t.NOEMBED = "noembed", t.NOSCRIPT = "noscript", t.OBJECT = "object", t.OL = "ol", t.OPTGROUP = "optgroup", t.OPTION = "option", t.P = "p", t.PARAM = "param", t.PLAINTEXT = "plaintext", t.PRE = "pre", t.RB = "rb", t.RP = "rp", t.RT = "rt", t.RTC = "rtc", t.RUBY = "ruby", t.S = "s", t.SCRIPT = "script", t.SEARCH = "search", t.SECTION = "section", t.SELECT = "select", t.SOURCE = "source", t.SMALL = "small", t.SPAN = "span", t.STRIKE = "strike", t.STRONG = "strong", t.STYLE = "style", t.SUB = "sub", t.SUMMARY = "summary", t.SUP = "sup", t.TABLE = "table", t.TBODY = "tbody", t.TEMPLATE = "template", t.TEXTAREA = "textarea", t.TFOOT = "tfoot", t.TD = "td", t.TH = "th", t.THEAD = "thead", t.TITLE = "title", t.TR = "tr", t.TRACK = "track", t.TT = "tt", t.U = "u", t.UL = "ul", t.SVG = "svg", t.VAR = "var", t.WBR = "wbr", t.XMP = "xmp";
})(re || (re = {}));
var y;
(function(t) {
  t[t.UNKNOWN = 0] = "UNKNOWN", t[t.A = 1] = "A", t[t.ADDRESS = 2] = "ADDRESS", t[t.ANNOTATION_XML = 3] = "ANNOTATION_XML", t[t.APPLET = 4] = "APPLET", t[t.AREA = 5] = "AREA", t[t.ARTICLE = 6] = "ARTICLE", t[t.ASIDE = 7] = "ASIDE", t[t.B = 8] = "B", t[t.BASE = 9] = "BASE", t[t.BASEFONT = 10] = "BASEFONT", t[t.BGSOUND = 11] = "BGSOUND", t[t.BIG = 12] = "BIG", t[t.BLOCKQUOTE = 13] = "BLOCKQUOTE", t[t.BODY = 14] = "BODY", t[t.BR = 15] = "BR", t[t.BUTTON = 16] = "BUTTON", t[t.CAPTION = 17] = "CAPTION", t[t.CENTER = 18] = "CENTER", t[t.CODE = 19] = "CODE", t[t.COL = 20] = "COL", t[t.COLGROUP = 21] = "COLGROUP", t[t.DD = 22] = "DD", t[t.DESC = 23] = "DESC", t[t.DETAILS = 24] = "DETAILS", t[t.DIALOG = 25] = "DIALOG", t[t.DIR = 26] = "DIR", t[t.DIV = 27] = "DIV", t[t.DL = 28] = "DL", t[t.DT = 29] = "DT", t[t.EM = 30] = "EM", t[t.EMBED = 31] = "EMBED", t[t.FIELDSET = 32] = "FIELDSET", t[t.FIGCAPTION = 33] = "FIGCAPTION", t[t.FIGURE = 34] = "FIGURE", t[t.FONT = 35] = "FONT", t[t.FOOTER = 36] = "FOOTER", t[t.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", t[t.FORM = 38] = "FORM", t[t.FRAME = 39] = "FRAME", t[t.FRAMESET = 40] = "FRAMESET", t[t.H1 = 41] = "H1", t[t.H2 = 42] = "H2", t[t.H3 = 43] = "H3", t[t.H4 = 44] = "H4", t[t.H5 = 45] = "H5", t[t.H6 = 46] = "H6", t[t.HEAD = 47] = "HEAD", t[t.HEADER = 48] = "HEADER", t[t.HGROUP = 49] = "HGROUP", t[t.HR = 50] = "HR", t[t.HTML = 51] = "HTML", t[t.I = 52] = "I", t[t.IMG = 53] = "IMG", t[t.IMAGE = 54] = "IMAGE", t[t.INPUT = 55] = "INPUT", t[t.IFRAME = 56] = "IFRAME", t[t.KEYGEN = 57] = "KEYGEN", t[t.LABEL = 58] = "LABEL", t[t.LI = 59] = "LI", t[t.LINK = 60] = "LINK", t[t.LISTING = 61] = "LISTING", t[t.MAIN = 62] = "MAIN", t[t.MALIGNMARK = 63] = "MALIGNMARK", t[t.MARQUEE = 64] = "MARQUEE", t[t.MATH = 65] = "MATH", t[t.MENU = 66] = "MENU", t[t.META = 67] = "META", t[t.MGLYPH = 68] = "MGLYPH", t[t.MI = 69] = "MI", t[t.MO = 70] = "MO", t[t.MN = 71] = "MN", t[t.MS = 72] = "MS", t[t.MTEXT = 73] = "MTEXT", t[t.NAV = 74] = "NAV", t[t.NOBR = 75] = "NOBR", t[t.NOFRAMES = 76] = "NOFRAMES", t[t.NOEMBED = 77] = "NOEMBED", t[t.NOSCRIPT = 78] = "NOSCRIPT", t[t.OBJECT = 79] = "OBJECT", t[t.OL = 80] = "OL", t[t.OPTGROUP = 81] = "OPTGROUP", t[t.OPTION = 82] = "OPTION", t[t.P = 83] = "P", t[t.PARAM = 84] = "PARAM", t[t.PLAINTEXT = 85] = "PLAINTEXT", t[t.PRE = 86] = "PRE", t[t.RB = 87] = "RB", t[t.RP = 88] = "RP", t[t.RT = 89] = "RT", t[t.RTC = 90] = "RTC", t[t.RUBY = 91] = "RUBY", t[t.S = 92] = "S", t[t.SCRIPT = 93] = "SCRIPT", t[t.SEARCH = 94] = "SEARCH", t[t.SECTION = 95] = "SECTION", t[t.SELECT = 96] = "SELECT", t[t.SOURCE = 97] = "SOURCE", t[t.SMALL = 98] = "SMALL", t[t.SPAN = 99] = "SPAN", t[t.STRIKE = 100] = "STRIKE", t[t.STRONG = 101] = "STRONG", t[t.STYLE = 102] = "STYLE", t[t.SUB = 103] = "SUB", t[t.SUMMARY = 104] = "SUMMARY", t[t.SUP = 105] = "SUP", t[t.TABLE = 106] = "TABLE", t[t.TBODY = 107] = "TBODY", t[t.TEMPLATE = 108] = "TEMPLATE", t[t.TEXTAREA = 109] = "TEXTAREA", t[t.TFOOT = 110] = "TFOOT", t[t.TD = 111] = "TD", t[t.TH = 112] = "TH", t[t.THEAD = 113] = "THEAD", t[t.TITLE = 114] = "TITLE", t[t.TR = 115] = "TR", t[t.TRACK = 116] = "TRACK", t[t.TT = 117] = "TT", t[t.U = 118] = "U", t[t.UL = 119] = "UL", t[t.SVG = 120] = "SVG", t[t.VAR = 121] = "VAR", t[t.WBR = 122] = "WBR", t[t.XMP = 123] = "XMP";
})(y || (y = {}));
const KEe = /* @__PURE__ */ new Map([
  [re.A, y.A],
  [re.ADDRESS, y.ADDRESS],
  [re.ANNOTATION_XML, y.ANNOTATION_XML],
  [re.APPLET, y.APPLET],
  [re.AREA, y.AREA],
  [re.ARTICLE, y.ARTICLE],
  [re.ASIDE, y.ASIDE],
  [re.B, y.B],
  [re.BASE, y.BASE],
  [re.BASEFONT, y.BASEFONT],
  [re.BGSOUND, y.BGSOUND],
  [re.BIG, y.BIG],
  [re.BLOCKQUOTE, y.BLOCKQUOTE],
  [re.BODY, y.BODY],
  [re.BR, y.BR],
  [re.BUTTON, y.BUTTON],
  [re.CAPTION, y.CAPTION],
  [re.CENTER, y.CENTER],
  [re.CODE, y.CODE],
  [re.COL, y.COL],
  [re.COLGROUP, y.COLGROUP],
  [re.DD, y.DD],
  [re.DESC, y.DESC],
  [re.DETAILS, y.DETAILS],
  [re.DIALOG, y.DIALOG],
  [re.DIR, y.DIR],
  [re.DIV, y.DIV],
  [re.DL, y.DL],
  [re.DT, y.DT],
  [re.EM, y.EM],
  [re.EMBED, y.EMBED],
  [re.FIELDSET, y.FIELDSET],
  [re.FIGCAPTION, y.FIGCAPTION],
  [re.FIGURE, y.FIGURE],
  [re.FONT, y.FONT],
  [re.FOOTER, y.FOOTER],
  [re.FOREIGN_OBJECT, y.FOREIGN_OBJECT],
  [re.FORM, y.FORM],
  [re.FRAME, y.FRAME],
  [re.FRAMESET, y.FRAMESET],
  [re.H1, y.H1],
  [re.H2, y.H2],
  [re.H3, y.H3],
  [re.H4, y.H4],
  [re.H5, y.H5],
  [re.H6, y.H6],
  [re.HEAD, y.HEAD],
  [re.HEADER, y.HEADER],
  [re.HGROUP, y.HGROUP],
  [re.HR, y.HR],
  [re.HTML, y.HTML],
  [re.I, y.I],
  [re.IMG, y.IMG],
  [re.IMAGE, y.IMAGE],
  [re.INPUT, y.INPUT],
  [re.IFRAME, y.IFRAME],
  [re.KEYGEN, y.KEYGEN],
  [re.LABEL, y.LABEL],
  [re.LI, y.LI],
  [re.LINK, y.LINK],
  [re.LISTING, y.LISTING],
  [re.MAIN, y.MAIN],
  [re.MALIGNMARK, y.MALIGNMARK],
  [re.MARQUEE, y.MARQUEE],
  [re.MATH, y.MATH],
  [re.MENU, y.MENU],
  [re.META, y.META],
  [re.MGLYPH, y.MGLYPH],
  [re.MI, y.MI],
  [re.MO, y.MO],
  [re.MN, y.MN],
  [re.MS, y.MS],
  [re.MTEXT, y.MTEXT],
  [re.NAV, y.NAV],
  [re.NOBR, y.NOBR],
  [re.NOFRAMES, y.NOFRAMES],
  [re.NOEMBED, y.NOEMBED],
  [re.NOSCRIPT, y.NOSCRIPT],
  [re.OBJECT, y.OBJECT],
  [re.OL, y.OL],
  [re.OPTGROUP, y.OPTGROUP],
  [re.OPTION, y.OPTION],
  [re.P, y.P],
  [re.PARAM, y.PARAM],
  [re.PLAINTEXT, y.PLAINTEXT],
  [re.PRE, y.PRE],
  [re.RB, y.RB],
  [re.RP, y.RP],
  [re.RT, y.RT],
  [re.RTC, y.RTC],
  [re.RUBY, y.RUBY],
  [re.S, y.S],
  [re.SCRIPT, y.SCRIPT],
  [re.SEARCH, y.SEARCH],
  [re.SECTION, y.SECTION],
  [re.SELECT, y.SELECT],
  [re.SOURCE, y.SOURCE],
  [re.SMALL, y.SMALL],
  [re.SPAN, y.SPAN],
  [re.STRIKE, y.STRIKE],
  [re.STRONG, y.STRONG],
  [re.STYLE, y.STYLE],
  [re.SUB, y.SUB],
  [re.SUMMARY, y.SUMMARY],
  [re.SUP, y.SUP],
  [re.TABLE, y.TABLE],
  [re.TBODY, y.TBODY],
  [re.TEMPLATE, y.TEMPLATE],
  [re.TEXTAREA, y.TEXTAREA],
  [re.TFOOT, y.TFOOT],
  [re.TD, y.TD],
  [re.TH, y.TH],
  [re.THEAD, y.THEAD],
  [re.TITLE, y.TITLE],
  [re.TR, y.TR],
  [re.TRACK, y.TRACK],
  [re.TT, y.TT],
  [re.U, y.U],
  [re.UL, y.UL],
  [re.SVG, y.SVG],
  [re.VAR, y.VAR],
  [re.WBR, y.WBR],
  [re.XMP, y.XMP]
]);
function FA(t) {
  var e;
  return (e = KEe.get(t)) !== null && e !== void 0 ? e : y.UNKNOWN;
}
const Ie = y, zEe = {
  [ke.HTML]: /* @__PURE__ */ new Set([
    Ie.ADDRESS,
    Ie.APPLET,
    Ie.AREA,
    Ie.ARTICLE,
    Ie.ASIDE,
    Ie.BASE,
    Ie.BASEFONT,
    Ie.BGSOUND,
    Ie.BLOCKQUOTE,
    Ie.BODY,
    Ie.BR,
    Ie.BUTTON,
    Ie.CAPTION,
    Ie.CENTER,
    Ie.COL,
    Ie.COLGROUP,
    Ie.DD,
    Ie.DETAILS,
    Ie.DIR,
    Ie.DIV,
    Ie.DL,
    Ie.DT,
    Ie.EMBED,
    Ie.FIELDSET,
    Ie.FIGCAPTION,
    Ie.FIGURE,
    Ie.FOOTER,
    Ie.FORM,
    Ie.FRAME,
    Ie.FRAMESET,
    Ie.H1,
    Ie.H2,
    Ie.H3,
    Ie.H4,
    Ie.H5,
    Ie.H6,
    Ie.HEAD,
    Ie.HEADER,
    Ie.HGROUP,
    Ie.HR,
    Ie.HTML,
    Ie.IFRAME,
    Ie.IMG,
    Ie.INPUT,
    Ie.LI,
    Ie.LINK,
    Ie.LISTING,
    Ie.MAIN,
    Ie.MARQUEE,
    Ie.MENU,
    Ie.META,
    Ie.NAV,
    Ie.NOEMBED,
    Ie.NOFRAMES,
    Ie.NOSCRIPT,
    Ie.OBJECT,
    Ie.OL,
    Ie.P,
    Ie.PARAM,
    Ie.PLAINTEXT,
    Ie.PRE,
    Ie.SCRIPT,
    Ie.SECTION,
    Ie.SELECT,
    Ie.SOURCE,
    Ie.STYLE,
    Ie.SUMMARY,
    Ie.TABLE,
    Ie.TBODY,
    Ie.TD,
    Ie.TEMPLATE,
    Ie.TEXTAREA,
    Ie.TFOOT,
    Ie.TH,
    Ie.THEAD,
    Ie.TITLE,
    Ie.TR,
    Ie.TRACK,
    Ie.UL,
    Ie.WBR,
    Ie.XMP
  ]),
  [ke.MATHML]: /* @__PURE__ */ new Set([Ie.MI, Ie.MO, Ie.MN, Ie.MS, Ie.MTEXT, Ie.ANNOTATION_XML]),
  [ke.SVG]: /* @__PURE__ */ new Set([Ie.TITLE, Ie.FOREIGN_OBJECT, Ie.DESC]),
  [ke.XLINK]: /* @__PURE__ */ new Set(),
  [ke.XML]: /* @__PURE__ */ new Set(),
  [ke.XMLNS]: /* @__PURE__ */ new Set()
}, WT = /* @__PURE__ */ new Set([Ie.H1, Ie.H2, Ie.H3, Ie.H4, Ie.H5, Ie.H6]);
re.STYLE, re.SCRIPT, re.XMP, re.IFRAME, re.NOEMBED, re.NOFRAMES, re.PLAINTEXT;
var $;
(function(t) {
  t[t.DATA = 0] = "DATA", t[t.RCDATA = 1] = "RCDATA", t[t.RAWTEXT = 2] = "RAWTEXT", t[t.SCRIPT_DATA = 3] = "SCRIPT_DATA", t[t.PLAINTEXT = 4] = "PLAINTEXT", t[t.TAG_OPEN = 5] = "TAG_OPEN", t[t.END_TAG_OPEN = 6] = "END_TAG_OPEN", t[t.TAG_NAME = 7] = "TAG_NAME", t[t.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", t[t.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", t[t.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", t[t.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", t[t.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", t[t.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", t[t.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", t[t.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", t[t.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", t[t.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", t[t.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", t[t.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", t[t.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", t[t.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", t[t.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", t[t.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", t[t.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", t[t.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", t[t.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", t[t.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", t[t.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", t[t.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", t[t.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", t[t.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", t[t.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", t[t.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", t[t.COMMENT_START = 42] = "COMMENT_START", t[t.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", t[t.COMMENT = 44] = "COMMENT", t[t.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", t[t.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", t[t.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", t[t.COMMENT_END = 50] = "COMMENT_END", t[t.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", t[t.DOCTYPE = 52] = "DOCTYPE", t[t.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", t[t.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", t[t.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", t[t.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", t[t.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", t[t.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", t[t.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", t[t.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", t[t.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", t[t.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", t[t.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", t[t.CDATA_SECTION = 68] = "CDATA_SECTION", t[t.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", t[t.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", t[t.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", t[t.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})($ || ($ = {}));
const Ls = {
  DATA: $.DATA,
  RCDATA: $.RCDATA,
  RAWTEXT: $.RAWTEXT,
  SCRIPT_DATA: $.SCRIPT_DATA,
  PLAINTEXT: $.PLAINTEXT,
  CDATA_SECTION: $.CDATA_SECTION
};
function jEe(t) {
  return t >= O.DIGIT_0 && t <= O.DIGIT_9;
}
function Im(t) {
  return t >= O.LATIN_CAPITAL_A && t <= O.LATIN_CAPITAL_Z;
}
function YEe(t) {
  return t >= O.LATIN_SMALL_A && t <= O.LATIN_SMALL_Z;
}
function El(t) {
  return YEe(t) || Im(t);
}
function OI(t) {
  return El(t) || jEe(t);
}
function _0(t) {
  return t + 32;
}
function w$(t) {
  return t === O.SPACE || t === O.LINE_FEED || t === O.TABULATION || t === O.FORM_FEED;
}
function BI(t) {
  return w$(t) || t === O.SOLIDUS || t === O.GREATER_THAN_SIGN;
}
function qEe(t) {
  return t === O.NULL ? ce.nullCharacterReference : t > 1114111 ? ce.characterReferenceOutsideUnicodeRange : y$(t) ? ce.surrogateCharacterReference : E$(t) ? ce.noncharacterCharacterReference : A$(t) || t === O.CARRIAGE_RETURN ? ce.controlCharacterReference : null;
}
let JEe = class {
  constructor(e, n) {
    this.options = e, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = $.DATA, this.returnState = $.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new LEe(n), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new WEe(MEe, (r, i) => {
      this.preprocessor.pos = this.entityStartPos + i - 1, this._flushCodePointConsumedAsCharacterReference(r);
    }, n.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(ce.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (r) => {
        this._err(ce.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + r);
      },
      validateNumericCharacterReference: (r) => {
        const i = qEe(r);
        i && this._err(i, 1);
      }
    } : void 0);
  }
  //Errors
  _err(e, n = 0) {
    var r, i;
    (i = (r = this.handler).onParseError) === null || i === void 0 || i.call(r, this.preprocessor.getError(e, n));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(e) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - e,
      startOffset: this.preprocessor.offset - e,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const e = this._consume();
        this._ensureHibernation() || this._callState(e);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(e) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || e?.());
  }
  write(e, n, r) {
    this.active = !0, this.preprocessor.write(e, n), this._runParsingLoop(), this.paused || r?.();
  }
  insertHtmlAtCurrentPos(e) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(e), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(e) {
    this.consumedAfterSnapshot += e;
    for (let n = 0; n < e; n++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(e, n) {
    return this.preprocessor.startsWith(e, n) ? (this._advanceBy(e.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: Fn.START_TAG,
      tagName: "",
      tagID: y.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: Fn.END_TAG,
      tagName: "",
      tagID: y.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(e) {
    this.currentToken = {
      type: Fn.COMMENT,
      data: "",
      location: this.getCurrentLocation(e)
    };
  }
  _createDoctypeToken(e) {
    this.currentToken = {
      type: Fn.DOCTYPE,
      name: e,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(e, n) {
    this.currentCharacterToken = {
      type: e,
      chars: n,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(e) {
    this.currentAttr = {
      name: e,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var e, n;
    const r = this.currentToken;
    if (S$(r, this.currentAttr.name) === null) {
      if (r.attrs.push(this.currentAttr), r.location && this.currentLocation) {
        const i = (e = (n = r.location).attrs) !== null && e !== void 0 ? e : n.attrs = /* @__PURE__ */ Object.create(null);
        i[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(ce.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(e) {
    this._emitCurrentCharacterToken(e.location), this.currentToken = null, e.location && (e.location.endLine = this.preprocessor.line, e.location.endCol = this.preprocessor.col + 1, e.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const e = this.currentToken;
    this.prepareToken(e), e.tagID = FA(e.tagName), e.type === Fn.START_TAG ? (this.lastStartTagName = e.tagName, this.handler.onStartTag(e)) : (e.attrs.length > 0 && this._err(ce.endTagWithAttributes), e.selfClosing && this._err(ce.endTagWithTrailingSolidus), this.handler.onEndTag(e)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(e) {
    this.prepareToken(e), this.handler.onComment(e), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(e) {
    this.prepareToken(e), this.handler.onDoctype(e), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(e) {
    if (this.currentCharacterToken) {
      switch (e && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = e.startLine, this.currentCharacterToken.location.endCol = e.startCol, this.currentCharacterToken.location.endOffset = e.startOffset), this.currentCharacterToken.type) {
        case Fn.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case Fn.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case Fn.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const e = this.getCurrentLocation(0);
    e && (e.endLine = e.startLine, e.endCol = e.startCol, e.endOffset = e.startOffset), this._emitCurrentCharacterToken(e), this.handler.onEof({ type: Fn.EOF, location: e }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(e, n) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === e) {
        this.currentCharacterToken.chars += n;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(e, n);
  }
  _emitCodePoint(e) {
    const n = w$(e) ? Fn.WHITESPACE_CHARACTER : e === O.NULL ? Fn.NULL_CHARACTER : Fn.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(e));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(e) {
    this._appendCharToCurrentCharacterToken(Fn.CHARACTER, e);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = $.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? Bu.Attribute : Bu.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === $.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === $.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === $.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(e) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(e) : this._emitCodePoint(e);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(e) {
    switch (this.state) {
      case $.DATA: {
        this._stateData(e);
        break;
      }
      case $.RCDATA: {
        this._stateRcdata(e);
        break;
      }
      case $.RAWTEXT: {
        this._stateRawtext(e);
        break;
      }
      case $.SCRIPT_DATA: {
        this._stateScriptData(e);
        break;
      }
      case $.PLAINTEXT: {
        this._statePlaintext(e);
        break;
      }
      case $.TAG_OPEN: {
        this._stateTagOpen(e);
        break;
      }
      case $.END_TAG_OPEN: {
        this._stateEndTagOpen(e);
        break;
      }
      case $.TAG_NAME: {
        this._stateTagName(e);
        break;
      }
      case $.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(e);
        break;
      }
      case $.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(e);
        break;
      }
      case $.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(e);
        break;
      }
      case $.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(e);
        break;
      }
      case $.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(e);
        break;
      }
      case $.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(e);
        break;
      }
      case $.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(e);
        break;
      }
      case $.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(e);
        break;
      }
      case $.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(e);
        break;
      }
      case $.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(e);
        break;
      }
      case $.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(e);
        break;
      }
      case $.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(e);
        break;
      }
      case $.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(e);
        break;
      }
      case $.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(e);
        break;
      }
      case $.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(e);
        break;
      }
      case $.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(e);
        break;
      }
      case $.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(e);
        break;
      }
      case $.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(e);
        break;
      }
      case $.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(e);
        break;
      }
      case $.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(e);
        break;
      }
      case $.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(e);
        break;
      }
      case $.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(e);
        break;
      }
      case $.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(e);
        break;
      }
      case $.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(e);
        break;
      }
      case $.ATTRIBUTE_NAME: {
        this._stateAttributeName(e);
        break;
      }
      case $.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(e);
        break;
      }
      case $.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(e);
        break;
      }
      case $.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(e);
        break;
      }
      case $.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(e);
        break;
      }
      case $.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(e);
        break;
      }
      case $.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(e);
        break;
      }
      case $.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(e);
        break;
      }
      case $.BOGUS_COMMENT: {
        this._stateBogusComment(e);
        break;
      }
      case $.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(e);
        break;
      }
      case $.COMMENT_START: {
        this._stateCommentStart(e);
        break;
      }
      case $.COMMENT_START_DASH: {
        this._stateCommentStartDash(e);
        break;
      }
      case $.COMMENT: {
        this._stateComment(e);
        break;
      }
      case $.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(e);
        break;
      }
      case $.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(e);
        break;
      }
      case $.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(e);
        break;
      }
      case $.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(e);
        break;
      }
      case $.COMMENT_END_DASH: {
        this._stateCommentEndDash(e);
        break;
      }
      case $.COMMENT_END: {
        this._stateCommentEnd(e);
        break;
      }
      case $.COMMENT_END_BANG: {
        this._stateCommentEndBang(e);
        break;
      }
      case $.DOCTYPE: {
        this._stateDoctype(e);
        break;
      }
      case $.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(e);
        break;
      }
      case $.DOCTYPE_NAME: {
        this._stateDoctypeName(e);
        break;
      }
      case $.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(e);
        break;
      }
      case $.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(e);
        break;
      }
      case $.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(e);
        break;
      }
      case $.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(e);
        break;
      }
      case $.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(e);
        break;
      }
      case $.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(e);
        break;
      }
      case $.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(e);
        break;
      }
      case $.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(e);
        break;
      }
      case $.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(e);
        break;
      }
      case $.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(e);
        break;
      }
      case $.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(e);
        break;
      }
      case $.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(e);
        break;
      }
      case $.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(e);
        break;
      }
      case $.CDATA_SECTION: {
        this._stateCdataSection(e);
        break;
      }
      case $.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(e);
        break;
      }
      case $.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(e);
        break;
      }
      case $.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case $.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(e);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(e) {
    switch (e) {
      case O.LESS_THAN_SIGN: {
        this.state = $.TAG_OPEN;
        break;
      }
      case O.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this._emitCodePoint(e);
        break;
      }
      case O.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(e) {
    switch (e) {
      case O.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case O.LESS_THAN_SIGN: {
        this.state = $.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(e) {
    switch (e) {
      case O.LESS_THAN_SIGN: {
        this.state = $.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(e) {
    switch (e) {
      case O.LESS_THAN_SIGN: {
        this.state = $.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(e) {
    switch (e) {
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(e) {
    if (El(e))
      this._createStartTagToken(), this.state = $.TAG_NAME, this._stateTagName(e);
    else
      switch (e) {
        case O.EXCLAMATION_MARK: {
          this.state = $.MARKUP_DECLARATION_OPEN;
          break;
        }
        case O.SOLIDUS: {
          this.state = $.END_TAG_OPEN;
          break;
        }
        case O.QUESTION_MARK: {
          this._err(ce.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = $.BOGUS_COMMENT, this._stateBogusComment(e);
          break;
        }
        case O.EOF: {
          this._err(ce.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(ce.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = $.DATA, this._stateData(e);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(e) {
    if (El(e))
      this._createEndTagToken(), this.state = $.TAG_NAME, this._stateTagName(e);
    else
      switch (e) {
        case O.GREATER_THAN_SIGN: {
          this._err(ce.missingEndTagName), this.state = $.DATA;
          break;
        }
        case O.EOF: {
          this._err(ce.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(ce.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = $.BOGUS_COMMENT, this._stateBogusComment(e);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED: {
        this.state = $.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case O.SOLIDUS: {
        this.state = $.SELF_CLOSING_START_TAG;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this.state = $.DATA, this.emitCurrentTagToken();
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), n.tagName += Er;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        n.tagName += String.fromCodePoint(Im(e) ? _0(e) : e);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(e) {
    e === O.SOLIDUS ? this.state = $.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = $.RCDATA, this._stateRcdata(e));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(e) {
    El(e) ? (this.state = $.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(e)) : (this._emitChars("</"), this.state = $.RCDATA, this._stateRcdata(e));
  }
  handleSpecialEndTag(e) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const n = this.currentToken;
    switch (n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = $.BEFORE_ATTRIBUTE_NAME, !1;
      case O.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = $.SELF_CLOSING_START_TAG, !1;
      case O.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = $.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = $.RCDATA, this._stateRcdata(e));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(e) {
    e === O.SOLIDUS ? this.state = $.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = $.RAWTEXT, this._stateRawtext(e));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(e) {
    El(e) ? (this.state = $.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(e)) : (this._emitChars("</"), this.state = $.RAWTEXT, this._stateRawtext(e));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = $.RAWTEXT, this._stateRawtext(e));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(e) {
    switch (e) {
      case O.SOLIDUS: {
        this.state = $.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case O.EXCLAMATION_MARK: {
        this.state = $.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = $.SCRIPT_DATA, this._stateScriptData(e);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(e) {
    El(e) ? (this.state = $.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(e)) : (this._emitChars("</"), this.state = $.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = $.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(e) {
    e === O.HYPHEN_MINUS ? (this.state = $.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = $.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(e) {
    e === O.HYPHEN_MINUS ? (this.state = $.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = $.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(e) {
    switch (e) {
      case O.HYPHEN_MINUS: {
        this.state = $.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case O.LESS_THAN_SIGN: {
        this.state = $.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(e) {
    switch (e) {
      case O.HYPHEN_MINUS: {
        this.state = $.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case O.LESS_THAN_SIGN: {
        this.state = $.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this.state = $.SCRIPT_DATA_ESCAPED, this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = $.SCRIPT_DATA_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(e) {
    switch (e) {
      case O.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case O.LESS_THAN_SIGN: {
        this.state = $.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this.state = $.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this.state = $.SCRIPT_DATA_ESCAPED, this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = $.SCRIPT_DATA_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(e) {
    e === O.SOLIDUS ? this.state = $.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : El(e) ? (this._emitChars("<"), this.state = $.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(e)) : (this._emitChars("<"), this.state = $.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(e) {
    El(e) ? (this.state = $.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(e)) : (this._emitChars("</"), this.state = $.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = $.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(e) {
    if (this.preprocessor.startsWith(vs.SCRIPT, !1) && BI(this.preprocessor.peek(vs.SCRIPT.length))) {
      this._emitCodePoint(e);
      for (let n = 0; n < vs.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = $.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(e) {
    switch (e) {
      case O.HYPHEN_MINUS: {
        this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case O.LESS_THAN_SIGN: {
        this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(e) {
    switch (e) {
      case O.HYPHEN_MINUS: {
        this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case O.LESS_THAN_SIGN: {
        this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(e) {
    switch (e) {
      case O.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case O.LESS_THAN_SIGN: {
        this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this.state = $.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Er);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(e) {
    e === O.SOLIDUS ? (this.state = $.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(e));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(e) {
    if (this.preprocessor.startsWith(vs.SCRIPT, !1) && BI(this.preprocessor.peek(vs.SCRIPT.length))) {
      this._emitCodePoint(e);
      for (let n = 0; n < vs.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = $.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = $.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(e));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(e) {
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
        break;
      case O.SOLIDUS:
      case O.GREATER_THAN_SIGN:
      case O.EOF: {
        this.state = $.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(e);
        break;
      }
      case O.EQUALS_SIGN: {
        this._err(ce.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = $.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = $.ATTRIBUTE_NAME, this._stateAttributeName(e);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(e) {
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
      case O.SOLIDUS:
      case O.GREATER_THAN_SIGN:
      case O.EOF: {
        this._leaveAttrName(), this.state = $.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(e);
        break;
      }
      case O.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = $.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case O.QUOTATION_MARK:
      case O.APOSTROPHE:
      case O.LESS_THAN_SIGN: {
        this._err(ce.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(e);
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this.currentAttr.name += Er;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Im(e) ? _0(e) : e);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(e) {
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
        break;
      case O.SOLIDUS: {
        this.state = $.SELF_CLOSING_START_TAG;
        break;
      }
      case O.EQUALS_SIGN: {
        this.state = $.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this.state = $.DATA, this.emitCurrentTagToken();
        break;
      }
      case O.EOF: {
        this._err(ce.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = $.ATTRIBUTE_NAME, this._stateAttributeName(e);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(e) {
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
        break;
      case O.QUOTATION_MARK: {
        this.state = $.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case O.APOSTROPHE: {
        this.state = $.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.missingAttributeValue), this.state = $.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = $.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(e);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(e) {
    switch (e) {
      case O.QUOTATION_MARK: {
        this.state = $.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case O.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this.currentAttr.value += Er;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(e) {
    switch (e) {
      case O.APOSTROPHE: {
        this.state = $.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case O.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this.currentAttr.value += Er;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(e) {
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED: {
        this._leaveAttrValue(), this.state = $.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case O.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = $.DATA, this.emitCurrentTagToken();
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), this.currentAttr.value += Er;
        break;
      }
      case O.QUOTATION_MARK:
      case O.APOSTROPHE:
      case O.LESS_THAN_SIGN:
      case O.EQUALS_SIGN:
      case O.GRAVE_ACCENT: {
        this._err(ce.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(e);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(e) {
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED: {
        this._leaveAttrValue(), this.state = $.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case O.SOLIDUS: {
        this._leaveAttrValue(), this.state = $.SELF_CLOSING_START_TAG;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = $.DATA, this.emitCurrentTagToken();
        break;
      }
      case O.EOF: {
        this._err(ce.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.missingWhitespaceBetweenAttributes), this.state = $.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(e);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(e) {
    switch (e) {
      case O.GREATER_THAN_SIGN: {
        const n = this.currentToken;
        n.selfClosing = !0, this.state = $.DATA, this.emitCurrentTagToken();
        break;
      }
      case O.EOF: {
        this._err(ce.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.unexpectedSolidusInTag), this.state = $.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(e);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(e) {
    const n = this.currentToken;
    switch (e) {
      case O.GREATER_THAN_SIGN: {
        this.state = $.DATA, this.emitCurrentComment(n);
        break;
      }
      case O.EOF: {
        this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), n.data += Er;
        break;
      }
      default:
        n.data += String.fromCodePoint(e);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(e) {
    this._consumeSequenceIfMatch(vs.DASH_DASH, !0) ? (this._createCommentToken(vs.DASH_DASH.length + 1), this.state = $.COMMENT_START) : this._consumeSequenceIfMatch(vs.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(vs.DOCTYPE.length + 1), this.state = $.DOCTYPE) : this._consumeSequenceIfMatch(vs.CDATA_START, !0) ? this.inForeignNode ? this.state = $.CDATA_SECTION : (this._err(ce.cdataInHtmlContent), this._createCommentToken(vs.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = $.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(ce.incorrectlyOpenedComment), this._createCommentToken(2), this.state = $.BOGUS_COMMENT, this._stateBogusComment(e));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(e) {
    switch (e) {
      case O.HYPHEN_MINUS: {
        this.state = $.COMMENT_START_DASH;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.abruptClosingOfEmptyComment), this.state = $.DATA;
        const n = this.currentToken;
        this.emitCurrentComment(n);
        break;
      }
      default:
        this.state = $.COMMENT, this._stateComment(e);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(e) {
    const n = this.currentToken;
    switch (e) {
      case O.HYPHEN_MINUS: {
        this.state = $.COMMENT_END;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.abruptClosingOfEmptyComment), this.state = $.DATA, this.emitCurrentComment(n);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = $.COMMENT, this._stateComment(e);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(e) {
    const n = this.currentToken;
    switch (e) {
      case O.HYPHEN_MINUS: {
        this.state = $.COMMENT_END_DASH;
        break;
      }
      case O.LESS_THAN_SIGN: {
        n.data += "<", this.state = $.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), n.data += Er;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += String.fromCodePoint(e);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(e) {
    const n = this.currentToken;
    switch (e) {
      case O.EXCLAMATION_MARK: {
        n.data += "!", this.state = $.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case O.LESS_THAN_SIGN: {
        n.data += "<";
        break;
      }
      default:
        this.state = $.COMMENT, this._stateComment(e);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(e) {
    e === O.HYPHEN_MINUS ? this.state = $.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = $.COMMENT, this._stateComment(e));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(e) {
    e === O.HYPHEN_MINUS ? this.state = $.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = $.COMMENT_END_DASH, this._stateCommentEndDash(e));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(e) {
    e !== O.GREATER_THAN_SIGN && e !== O.EOF && this._err(ce.nestedComment), this.state = $.COMMENT_END, this._stateCommentEnd(e);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(e) {
    const n = this.currentToken;
    switch (e) {
      case O.HYPHEN_MINUS: {
        this.state = $.COMMENT_END;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = $.COMMENT, this._stateComment(e);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(e) {
    const n = this.currentToken;
    switch (e) {
      case O.GREATER_THAN_SIGN: {
        this.state = $.DATA, this.emitCurrentComment(n);
        break;
      }
      case O.EXCLAMATION_MARK: {
        this.state = $.COMMENT_END_BANG;
        break;
      }
      case O.HYPHEN_MINUS: {
        n.data += "-";
        break;
      }
      case O.EOF: {
        this._err(ce.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--", this.state = $.COMMENT, this._stateComment(e);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(e) {
    const n = this.currentToken;
    switch (e) {
      case O.HYPHEN_MINUS: {
        n.data += "--!", this.state = $.COMMENT_END_DASH;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.incorrectlyClosedComment), this.state = $.DATA, this.emitCurrentComment(n);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--!", this.state = $.COMMENT, this._stateComment(e);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(e) {
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED: {
        this.state = $.BEFORE_DOCTYPE_NAME;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this.state = $.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(e);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), this._createDoctypeToken(null);
        const n = this.currentToken;
        n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.missingWhitespaceBeforeDoctypeName), this.state = $.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(e);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(e) {
    if (Im(e))
      this._createDoctypeToken(String.fromCharCode(_0(e))), this.state = $.DOCTYPE_NAME;
    else
      switch (e) {
        case O.SPACE:
        case O.LINE_FEED:
        case O.TABULATION:
        case O.FORM_FEED:
          break;
        case O.NULL: {
          this._err(ce.unexpectedNullCharacter), this._createDoctypeToken(Er), this.state = $.DOCTYPE_NAME;
          break;
        }
        case O.GREATER_THAN_SIGN: {
          this._err(ce.missingDoctypeName), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = $.DATA;
          break;
        }
        case O.EOF: {
          this._err(ce.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(e)), this.state = $.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED: {
        this.state = $.AFTER_DOCTYPE_NAME;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this.state = $.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), n.name += Er;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.name += String.fromCodePoint(Im(e) ? _0(e) : e);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
        break;
      case O.GREATER_THAN_SIGN: {
        this.state = $.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(vs.PUBLIC, !1) ? this.state = $.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(vs.SYSTEM, !1) ? this.state = $.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(ce.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = $.BOGUS_DOCTYPE, this._stateBogusDoctype(e));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED: {
        this.state = $.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case O.QUOTATION_MARK: {
        this._err(ce.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = $.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case O.APOSTROPHE: {
        this._err(ce.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = $.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = $.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = $.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
        break;
      case O.QUOTATION_MARK: {
        n.publicId = "", this.state = $.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case O.APOSTROPHE: {
        n.publicId = "", this.state = $.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = $.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = $.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case O.QUOTATION_MARK: {
        this.state = $.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), n.publicId += Er;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = $.DATA;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(e);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case O.APOSTROPHE: {
        this.state = $.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), n.publicId += Er;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = $.DATA;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(e);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED: {
        this.state = $.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this.state = $.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case O.QUOTATION_MARK: {
        this._err(ce.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = $.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case O.APOSTROPHE: {
        this._err(ce.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = $.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = $.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
        break;
      case O.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = $.DATA;
        break;
      }
      case O.QUOTATION_MARK: {
        n.systemId = "", this.state = $.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case O.APOSTROPHE: {
        n.systemId = "", this.state = $.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = $.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED: {
        this.state = $.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case O.QUOTATION_MARK: {
        this._err(ce.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = $.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case O.APOSTROPHE: {
        this._err(ce.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = $.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = $.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = $.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
        break;
      case O.QUOTATION_MARK: {
        n.systemId = "", this.state = $.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case O.APOSTROPHE: {
        n.systemId = "", this.state = $.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = $.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = $.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case O.QUOTATION_MARK: {
        this.state = $.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), n.systemId += Er;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = $.DATA;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(e);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case O.APOSTROPHE: {
        this.state = $.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter), n.systemId += Er;
        break;
      }
      case O.GREATER_THAN_SIGN: {
        this._err(ce.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = $.DATA;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(e);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case O.SPACE:
      case O.LINE_FEED:
      case O.TABULATION:
      case O.FORM_FEED:
        break;
      case O.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = $.DATA;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(ce.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = $.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(e) {
    const n = this.currentToken;
    switch (e) {
      case O.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = $.DATA;
        break;
      }
      case O.NULL: {
        this._err(ce.unexpectedNullCharacter);
        break;
      }
      case O.EOF: {
        this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(e) {
    switch (e) {
      case O.RIGHT_SQUARE_BRACKET: {
        this.state = $.CDATA_SECTION_BRACKET;
        break;
      }
      case O.EOF: {
        this._err(ce.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(e) {
    e === O.RIGHT_SQUARE_BRACKET ? this.state = $.CDATA_SECTION_END : (this._emitChars("]"), this.state = $.CDATA_SECTION, this._stateCdataSection(e));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(e) {
    switch (e) {
      case O.GREATER_THAN_SIGN: {
        this.state = $.DATA;
        break;
      }
      case O.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = $.CDATA_SECTION, this._stateCdataSection(e);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let e = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (e < 0)
      if (this.preprocessor.lastChunkWritten)
        e = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    e === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(O.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && OI(this.preprocessor.peek(1)) ? $.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(e) {
    OI(e) ? this._flushCodePointConsumedAsCharacterReference(e) : (e === O.SEMICOLON && this._err(ce.unknownNamedCharacterReference), this.state = this.returnState, this._callState(e));
  }
};
const F$ = /* @__PURE__ */ new Set([y.DD, y.DT, y.LI, y.OPTGROUP, y.OPTION, y.P, y.RB, y.RP, y.RT, y.RTC]), $I = /* @__PURE__ */ new Set([
  ...F$,
  y.CAPTION,
  y.COLGROUP,
  y.TBODY,
  y.TD,
  y.TFOOT,
  y.TH,
  y.THEAD,
  y.TR
]), f1 = /* @__PURE__ */ new Set([
  y.APPLET,
  y.CAPTION,
  y.HTML,
  y.MARQUEE,
  y.OBJECT,
  y.TABLE,
  y.TD,
  y.TEMPLATE,
  y.TH
]), QEe = /* @__PURE__ */ new Set([...f1, y.OL, y.UL]), XEe = /* @__PURE__ */ new Set([...f1, y.BUTTON]), HI = /* @__PURE__ */ new Set([y.ANNOTATION_XML, y.MI, y.MN, y.MO, y.MS, y.MTEXT]), UI = /* @__PURE__ */ new Set([y.DESC, y.FOREIGN_OBJECT, y.TITLE]), ZEe = /* @__PURE__ */ new Set([y.TR, y.TEMPLATE, y.HTML]), eSe = /* @__PURE__ */ new Set([y.TBODY, y.TFOOT, y.THEAD, y.TEMPLATE, y.HTML]), tSe = /* @__PURE__ */ new Set([y.TABLE, y.TEMPLATE, y.HTML]), nSe = /* @__PURE__ */ new Set([y.TD, y.TH]);
class rSe {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(e, n, r) {
    this.treeAdapter = n, this.handler = r, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = y.UNKNOWN, this.current = e;
  }
  //Index of element
  _indexOf(e) {
    return this.items.lastIndexOf(e, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === y.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === ke.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(e, n) {
    this.stackTop++, this.items[this.stackTop] = e, this.current = e, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(e, n, !0);
  }
  pop() {
    const e = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(e, !0);
  }
  replace(e, n) {
    const r = this._indexOf(e);
    this.items[r] = n, r === this.stackTop && (this.current = n);
  }
  insertAfter(e, n, r) {
    const i = this._indexOf(e) + 1;
    this.items.splice(i, 0, n), this.tagIDs.splice(i, 0, r), this.stackTop++, i === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, i === this.stackTop);
  }
  popUntilTagNamePopped(e) {
    let n = this.stackTop + 1;
    do
      n = this.tagIDs.lastIndexOf(e, n - 1);
    while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== ke.HTML);
    this.shortenToLength(Math.max(n, 0));
  }
  shortenToLength(e) {
    for (; this.stackTop >= e; ) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < e);
    }
  }
  popUntilElementPopped(e) {
    const n = this._indexOf(e);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilPopped(e, n) {
    const r = this._indexOfTagNames(e, n);
    this.shortenToLength(Math.max(r, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(WT, ke.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(nSe, ke.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(e, n) {
    for (let r = this.stackTop; r >= 0; r--)
      if (e.has(this.tagIDs[r]) && this.treeAdapter.getNamespaceURI(this.items[r]) === n)
        return r;
    return -1;
  }
  clearBackTo(e, n) {
    const r = this._indexOfTagNames(e, n);
    this.shortenToLength(r + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(tSe, ke.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(eSe, ke.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(ZEe, ke.HTML);
  }
  remove(e) {
    const n = this._indexOf(e);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(e, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === y.BODY ? this.items[1] : null;
  }
  contains(e) {
    return this._indexOf(e) > -1;
  }
  getCommonAncestor(e) {
    const n = this._indexOf(e) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === y.HTML;
  }
  //Element in scope
  hasInDynamicScope(e, n) {
    for (let r = this.stackTop; r >= 0; r--) {
      const i = this.tagIDs[r];
      switch (this.treeAdapter.getNamespaceURI(this.items[r])) {
        case ke.HTML: {
          if (i === e)
            return !0;
          if (n.has(i))
            return !1;
          break;
        }
        case ke.SVG: {
          if (UI.has(i))
            return !1;
          break;
        }
        case ke.MATHML: {
          if (HI.has(i))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(e) {
    return this.hasInDynamicScope(e, f1);
  }
  hasInListItemScope(e) {
    return this.hasInDynamicScope(e, QEe);
  }
  hasInButtonScope(e) {
    return this.hasInDynamicScope(e, XEe);
  }
  hasNumberedHeaderInScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const n = this.tagIDs[e];
      switch (this.treeAdapter.getNamespaceURI(this.items[e])) {
        case ke.HTML: {
          if (WT.has(n))
            return !0;
          if (f1.has(n))
            return !1;
          break;
        }
        case ke.SVG: {
          if (UI.has(n))
            return !1;
          break;
        }
        case ke.MATHML: {
          if (HI.has(n))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(e) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === ke.HTML)
        switch (this.tagIDs[n]) {
          case e:
            return !0;
          case y.TABLE:
          case y.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let e = this.stackTop; e >= 0; e--)
      if (this.treeAdapter.getNamespaceURI(this.items[e]) === ke.HTML)
        switch (this.tagIDs[e]) {
          case y.TBODY:
          case y.THEAD:
          case y.TFOOT:
            return !0;
          case y.TABLE:
          case y.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(e) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === ke.HTML)
        switch (this.tagIDs[n]) {
          case e:
            return !0;
          case y.OPTION:
          case y.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && F$.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && $I.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(e) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== e && $I.has(this.currentTagId); )
      this.pop();
  }
}
const pw = 3;
var Xo;
(function(t) {
  t[t.Marker = 0] = "Marker", t[t.Element = 1] = "Element";
})(Xo || (Xo = {}));
const GI = { type: Xo.Marker };
class iSe {
  constructor(e) {
    this.treeAdapter = e, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(e, n) {
    const r = [], i = n.length, s = this.treeAdapter.getTagName(e), a = this.treeAdapter.getNamespaceURI(e);
    for (let o = 0; o < this.entries.length; o++) {
      const u = this.entries[o];
      if (u.type === Xo.Marker)
        break;
      const { element: l } = u;
      if (this.treeAdapter.getTagName(l) === s && this.treeAdapter.getNamespaceURI(l) === a) {
        const h = this.treeAdapter.getAttrList(l);
        h.length === i && r.push({ idx: o, attrs: h });
      }
    }
    return r;
  }
  _ensureNoahArkCondition(e) {
    if (this.entries.length < pw)
      return;
    const n = this.treeAdapter.getAttrList(e), r = this._getNoahArkConditionCandidates(e, n);
    if (r.length < pw)
      return;
    const i = new Map(n.map((a) => [a.name, a.value]));
    let s = 0;
    for (let a = 0; a < r.length; a++) {
      const o = r[a];
      o.attrs.every((u) => i.get(u.name) === u.value) && (s += 1, s >= pw && this.entries.splice(o.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(GI);
  }
  pushElement(e, n) {
    this._ensureNoahArkCondition(e), this.entries.unshift({
      type: Xo.Element,
      element: e,
      token: n
    });
  }
  insertElementAfterBookmark(e, n) {
    const r = this.entries.indexOf(this.bookmark);
    this.entries.splice(r, 0, {
      type: Xo.Element,
      element: e,
      token: n
    });
  }
  removeEntry(e) {
    const n = this.entries.indexOf(e);
    n !== -1 && this.entries.splice(n, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const e = this.entries.indexOf(GI);
    e === -1 ? this.entries.length = 0 : this.entries.splice(0, e + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(e) {
    const n = this.entries.find((r) => r.type === Xo.Marker || this.treeAdapter.getTagName(r.element) === e);
    return n && n.type === Xo.Element ? n : null;
  }
  getElementEntry(e) {
    return this.entries.find((n) => n.type === Xo.Element && n.element === e);
  }
}
const Sl = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: Ia.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(t, e, n) {
    return {
      nodeName: t,
      tagName: t,
      attrs: n,
      namespaceURI: e,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(t) {
    return {
      nodeName: "#comment",
      data: t,
      parentNode: null
    };
  },
  createTextNode(t) {
    return {
      nodeName: "#text",
      value: t,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(t, e) {
    t.childNodes.push(e), e.parentNode = t;
  },
  insertBefore(t, e, n) {
    const r = t.childNodes.indexOf(n);
    t.childNodes.splice(r, 0, e), e.parentNode = t;
  },
  setTemplateContent(t, e) {
    t.content = e;
  },
  getTemplateContent(t) {
    return t.content;
  },
  setDocumentType(t, e, n, r) {
    const i = t.childNodes.find((s) => s.nodeName === "#documentType");
    if (i)
      i.name = e, i.publicId = n, i.systemId = r;
    else {
      const s = {
        nodeName: "#documentType",
        name: e,
        publicId: n,
        systemId: r,
        parentNode: null
      };
      Sl.appendChild(t, s);
    }
  },
  setDocumentMode(t, e) {
    t.mode = e;
  },
  getDocumentMode(t) {
    return t.mode;
  },
  detachNode(t) {
    if (t.parentNode) {
      const e = t.parentNode.childNodes.indexOf(t);
      t.parentNode.childNodes.splice(e, 1), t.parentNode = null;
    }
  },
  insertText(t, e) {
    if (t.childNodes.length > 0) {
      const n = t.childNodes[t.childNodes.length - 1];
      if (Sl.isTextNode(n)) {
        n.value += e;
        return;
      }
    }
    Sl.appendChild(t, Sl.createTextNode(e));
  },
  insertTextBefore(t, e, n) {
    const r = t.childNodes[t.childNodes.indexOf(n) - 1];
    r && Sl.isTextNode(r) ? r.value += e : Sl.insertBefore(t, Sl.createTextNode(e), n);
  },
  adoptAttributes(t, e) {
    const n = new Set(t.attrs.map((r) => r.name));
    for (let r = 0; r < e.length; r++)
      n.has(e[r].name) || t.attrs.push(e[r]);
  },
  //Tree traversing
  getFirstChild(t) {
    return t.childNodes[0];
  },
  getChildNodes(t) {
    return t.childNodes;
  },
  getParentNode(t) {
    return t.parentNode;
  },
  getAttrList(t) {
    return t.attrs;
  },
  //Node data
  getTagName(t) {
    return t.tagName;
  },
  getNamespaceURI(t) {
    return t.namespaceURI;
  },
  getTextNodeContent(t) {
    return t.value;
  },
  getCommentNodeContent(t) {
    return t.data;
  },
  getDocumentTypeNodeName(t) {
    return t.name;
  },
  getDocumentTypeNodePublicId(t) {
    return t.publicId;
  },
  getDocumentTypeNodeSystemId(t) {
    return t.systemId;
  },
  //Node types
  isTextNode(t) {
    return t.nodeName === "#text";
  },
  isCommentNode(t) {
    return t.nodeName === "#comment";
  },
  isDocumentTypeNode(t) {
    return t.nodeName === "#documentType";
  },
  isElementNode(t) {
    return Object.prototype.hasOwnProperty.call(t, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(t, e) {
    t.sourceCodeLocation = e;
  },
  getNodeSourceCodeLocation(t) {
    return t.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(t, e) {
    t.sourceCodeLocation = { ...t.sourceCodeLocation, ...e };
  }
}, T$ = "html", sSe = "about:legacy-compat", aSe = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", v$ = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], oSe = [
  ...v$,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], uSe = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), x$ = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], lSe = [
  ...x$,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function WI(t, e) {
  return e.some((n) => t.startsWith(n));
}
function cSe(t) {
  return t.name === T$ && t.publicId === null && (t.systemId === null || t.systemId === sSe);
}
function hSe(t) {
  if (t.name !== T$)
    return Ia.QUIRKS;
  const { systemId: e } = t;
  if (e && e.toLowerCase() === aSe)
    return Ia.QUIRKS;
  let { publicId: n } = t;
  if (n !== null) {
    if (n = n.toLowerCase(), uSe.has(n))
      return Ia.QUIRKS;
    let r = e === null ? oSe : v$;
    if (WI(n, r))
      return Ia.QUIRKS;
    if (r = e === null ? x$ : lSe, WI(n, r))
      return Ia.LIMITED_QUIRKS;
  }
  return Ia.NO_QUIRKS;
}
const VI = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, dSe = "definitionurl", fSe = "definitionURL", mSe = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((t) => [t.toLowerCase(), t])), gSe = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: ke.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: ke.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: ke.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: ke.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: ke.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: ke.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: ke.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: ke.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: ke.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: ke.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: ke.XMLNS }]
]), pSe = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((t) => [t.toLowerCase(), t])), bSe = /* @__PURE__ */ new Set([
  y.B,
  y.BIG,
  y.BLOCKQUOTE,
  y.BODY,
  y.BR,
  y.CENTER,
  y.CODE,
  y.DD,
  y.DIV,
  y.DL,
  y.DT,
  y.EM,
  y.EMBED,
  y.H1,
  y.H2,
  y.H3,
  y.H4,
  y.H5,
  y.H6,
  y.HEAD,
  y.HR,
  y.I,
  y.IMG,
  y.LI,
  y.LISTING,
  y.MENU,
  y.META,
  y.NOBR,
  y.OL,
  y.P,
  y.PRE,
  y.RUBY,
  y.S,
  y.SMALL,
  y.SPAN,
  y.STRONG,
  y.STRIKE,
  y.SUB,
  y.SUP,
  y.TABLE,
  y.TT,
  y.U,
  y.UL,
  y.VAR
]);
function ySe(t) {
  const e = t.tagID;
  return e === y.FONT && t.attrs.some(({ name: r }) => r === ph.COLOR || r === ph.SIZE || r === ph.FACE) || bSe.has(e);
}
function C$(t) {
  for (let e = 0; e < t.attrs.length; e++)
    if (t.attrs[e].name === dSe) {
      t.attrs[e].name = fSe;
      break;
    }
}
function k$(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = mSe.get(t.attrs[e].name);
    n != null && (t.attrs[e].name = n);
  }
}
function GC(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = gSe.get(t.attrs[e].name);
    n && (t.attrs[e].prefix = n.prefix, t.attrs[e].name = n.name, t.attrs[e].namespace = n.namespace);
  }
}
function ASe(t) {
  const e = pSe.get(t.tagName);
  e != null && (t.tagName = e, t.tagID = FA(t.tagName));
}
function ESe(t, e) {
  return e === ke.MATHML && (t === y.MI || t === y.MO || t === y.MN || t === y.MS || t === y.MTEXT);
}
function SSe(t, e, n) {
  if (e === ke.MATHML && t === y.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === ph.ENCODING) {
        const i = n[r].value.toLowerCase();
        return i === VI.TEXT_HTML || i === VI.APPLICATION_XML;
      }
  }
  return e === ke.SVG && (t === y.FOREIGN_OBJECT || t === y.DESC || t === y.TITLE);
}
function wSe(t, e, n, r) {
  return (!r || r === ke.HTML) && SSe(t, e, n) || (!r || r === ke.MATHML) && ESe(t, e);
}
const FSe = "hidden", TSe = 8, vSe = 3;
var z;
(function(t) {
  t[t.INITIAL = 0] = "INITIAL", t[t.BEFORE_HTML = 1] = "BEFORE_HTML", t[t.BEFORE_HEAD = 2] = "BEFORE_HEAD", t[t.IN_HEAD = 3] = "IN_HEAD", t[t.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", t[t.AFTER_HEAD = 5] = "AFTER_HEAD", t[t.IN_BODY = 6] = "IN_BODY", t[t.TEXT = 7] = "TEXT", t[t.IN_TABLE = 8] = "IN_TABLE", t[t.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", t[t.IN_CAPTION = 10] = "IN_CAPTION", t[t.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", t[t.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", t[t.IN_ROW = 13] = "IN_ROW", t[t.IN_CELL = 14] = "IN_CELL", t[t.IN_SELECT = 15] = "IN_SELECT", t[t.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", t[t.IN_TEMPLATE = 17] = "IN_TEMPLATE", t[t.AFTER_BODY = 18] = "AFTER_BODY", t[t.IN_FRAMESET = 19] = "IN_FRAMESET", t[t.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", t[t.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", t[t.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(z || (z = {}));
const xSe = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, _$ = /* @__PURE__ */ new Set([y.TABLE, y.TBODY, y.TFOOT, y.THEAD, y.TR]), KI = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: Sl,
  onParseError: null
};
let CSe = class {
  constructor(e, n, r = null, i = null) {
    this.fragmentContext = r, this.scriptHandler = i, this.currentToken = null, this.stopped = !1, this.insertionMode = z.INITIAL, this.originalInsertionMode = z.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...KI,
      ...e
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new JEe(this.options, this), this.activeFormattingElements = new iSe(this.treeAdapter), this.fragmentContextID = r ? FA(this.treeAdapter.getTagName(r)) : y.UNKNOWN, this._setContextModes(r ?? this.document, this.fragmentContextID), this.openElements = new rSe(this.document, this.treeAdapter, this);
  }
  // API
  static parse(e, n) {
    const r = new this(n);
    return r.tokenizer.write(e, !0), r.document;
  }
  static getFragmentParser(e, n) {
    const r = {
      ...KI,
      ...n
    };
    e ?? (e = r.treeAdapter.createElement(re.TEMPLATE, ke.HTML, []));
    const i = r.treeAdapter.createElement("documentmock", ke.HTML, []), s = new this(r, i, e);
    return s.fragmentContextID === y.TEMPLATE && s.tmplInsertionModeStack.unshift(z.IN_TEMPLATE), s._initTokenizerForFragmentParsing(), s._insertFakeRootElement(), s._resetInsertionMode(), s._findFormInFragmentContext(), s;
  }
  getFragment() {
    const e = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(e, n), n;
  }
  //Errors
  /** @internal */
  _err(e, n, r) {
    var i;
    if (!this.onParseError)
      return;
    const s = (i = e.location) !== null && i !== void 0 ? i : xSe, a = {
      code: n,
      startLine: s.startLine,
      startCol: s.startCol,
      startOffset: s.startOffset,
      endLine: r ? s.startLine : s.endLine,
      endCol: r ? s.startCol : s.endCol,
      endOffset: r ? s.startOffset : s.endOffset
    };
    this.onParseError(a);
  }
  //Stack events
  /** @internal */
  onItemPush(e, n, r) {
    var i, s;
    (s = (i = this.treeAdapter).onItemPush) === null || s === void 0 || s.call(i, e), r && this.openElements.stackTop > 0 && this._setContextModes(e, n);
  }
  /** @internal */
  onItemPop(e, n) {
    var r, i;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(e, this.currentToken), (i = (r = this.treeAdapter).onItemPop) === null || i === void 0 || i.call(r, e, this.openElements.current), n) {
      let s, a;
      this.openElements.stackTop === 0 && this.fragmentContext ? (s = this.fragmentContext, a = this.fragmentContextID) : { current: s, currentTagId: a } = this.openElements, this._setContextModes(s, a);
    }
  }
  _setContextModes(e, n) {
    const r = e === this.document || e && this.treeAdapter.getNamespaceURI(e) === ke.HTML;
    this.currentNotInHTML = !r, this.tokenizer.inForeignNode = !r && e !== void 0 && n !== void 0 && !this._isIntegrationPoint(n, e);
  }
  /** @protected */
  _switchToTextParsing(e, n) {
    this._insertElement(e, ke.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = z.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = z.TEXT, this.originalInsertionMode = z.IN_BODY, this.tokenizer.state = Ls.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let e = this.fragmentContext;
    for (; e; ) {
      if (this.treeAdapter.getTagName(e) === re.FORM) {
        this.formElement = e;
        break;
      }
      e = this.treeAdapter.getParentNode(e);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== ke.HTML))
      switch (this.fragmentContextID) {
        case y.TITLE:
        case y.TEXTAREA: {
          this.tokenizer.state = Ls.RCDATA;
          break;
        }
        case y.STYLE:
        case y.XMP:
        case y.IFRAME:
        case y.NOEMBED:
        case y.NOFRAMES:
        case y.NOSCRIPT: {
          this.tokenizer.state = Ls.RAWTEXT;
          break;
        }
        case y.SCRIPT: {
          this.tokenizer.state = Ls.SCRIPT_DATA;
          break;
        }
        case y.PLAINTEXT: {
          this.tokenizer.state = Ls.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(e) {
    const n = e.name || "", r = e.publicId || "", i = e.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, r, i), e.location) {
      const a = this.treeAdapter.getChildNodes(this.document).find((o) => this.treeAdapter.isDocumentTypeNode(o));
      a && this.treeAdapter.setNodeSourceCodeLocation(a, e.location);
    }
  }
  /** @protected */
  _attachElementToTree(e, n) {
    if (this.options.sourceCodeLocationInfo) {
      const r = n && {
        ...n,
        startTag: n
      };
      this.treeAdapter.setNodeSourceCodeLocation(e, r);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(e);
    else {
      const r = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(r ?? this.document, e);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(e, n) {
    const r = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(r, e.location);
  }
  /** @protected */
  _insertElement(e, n) {
    const r = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(r, e.location), this.openElements.push(r, e.tagID);
  }
  /** @protected */
  _insertFakeElement(e, n) {
    const r = this.treeAdapter.createElement(e, ke.HTML, []);
    this._attachElementToTree(r, null), this.openElements.push(r, n);
  }
  /** @protected */
  _insertTemplate(e) {
    const n = this.treeAdapter.createElement(e.tagName, ke.HTML, e.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n, e.location), this.openElements.push(n, e.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const e = this.treeAdapter.createElement(re.HTML, ke.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(e, null), this.treeAdapter.appendChild(this.openElements.current, e), this.openElements.push(e, y.HTML);
  }
  /** @protected */
  _appendCommentNode(e, n) {
    const r = this.treeAdapter.createCommentNode(e.data);
    this.treeAdapter.appendChild(n, r), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, e.location);
  }
  /** @protected */
  _insertCharacters(e) {
    let n, r;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: n, beforeElement: r } = this._findFosterParentingLocation(), r ? this.treeAdapter.insertTextBefore(n, e.chars, r) : this.treeAdapter.insertText(n, e.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, e.chars)), !e.location)
      return;
    const i = this.treeAdapter.getChildNodes(n), s = r ? i.lastIndexOf(r) : i.length, a = i[s - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(a)) {
      const { endLine: u, endCol: l, endOffset: h } = e.location;
      this.treeAdapter.updateNodeSourceCodeLocation(a, { endLine: u, endCol: l, endOffset: h });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(a, e.location);
  }
  /** @protected */
  _adoptNodes(e, n) {
    for (let r = this.treeAdapter.getFirstChild(e); r; r = this.treeAdapter.getFirstChild(e))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  /** @protected */
  _setEndLocation(e, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(e) && n.location) {
      const r = n.location, i = this.treeAdapter.getTagName(e), s = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        n.type === Fn.END_TAG && i === n.tagName ? {
          endTag: { ...r },
          endLine: r.endLine,
          endCol: r.endCol,
          endOffset: r.endOffset
        } : {
          endLine: r.startLine,
          endCol: r.startCol,
          endOffset: r.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(e, s);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(e) {
    if (!this.currentNotInHTML)
      return !1;
    let n, r;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, r = this.fragmentContextID) : { current: n, currentTagId: r } = this.openElements, e.tagID === y.SVG && this.treeAdapter.getTagName(n) === re.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === ke.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (e.tagID === y.MGLYPH || e.tagID === y.MALIGNMARK) && r !== void 0 && !this._isIntegrationPoint(r, n, ke.HTML)
    );
  }
  /** @protected */
  _processToken(e) {
    switch (e.type) {
      case Fn.CHARACTER: {
        this.onCharacter(e);
        break;
      }
      case Fn.NULL_CHARACTER: {
        this.onNullCharacter(e);
        break;
      }
      case Fn.COMMENT: {
        this.onComment(e);
        break;
      }
      case Fn.DOCTYPE: {
        this.onDoctype(e);
        break;
      }
      case Fn.START_TAG: {
        this._processStartTag(e);
        break;
      }
      case Fn.END_TAG: {
        this.onEndTag(e);
        break;
      }
      case Fn.EOF: {
        this.onEof(e);
        break;
      }
      case Fn.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(e);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(e, n, r) {
    const i = this.treeAdapter.getNamespaceURI(n), s = this.treeAdapter.getAttrList(n);
    return wSe(e, i, s, r);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const e = this.activeFormattingElements.entries.length;
    if (e) {
      const n = this.activeFormattingElements.entries.findIndex((i) => i.type === Xo.Marker || this.openElements.contains(i.element)), r = n === -1 ? e - 1 : n - 1;
      for (let i = r; i >= 0; i--) {
        const s = this.activeFormattingElements.entries[i];
        this._insertElement(s.token, this.treeAdapter.getNamespaceURI(s.element)), s.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = z.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(y.P), this.openElements.popUntilTagNamePopped(y.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let e = this.openElements.stackTop; e >= 0; e--)
      switch (e === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[e]) {
        case y.TR: {
          this.insertionMode = z.IN_ROW;
          return;
        }
        case y.TBODY:
        case y.THEAD:
        case y.TFOOT: {
          this.insertionMode = z.IN_TABLE_BODY;
          return;
        }
        case y.CAPTION: {
          this.insertionMode = z.IN_CAPTION;
          return;
        }
        case y.COLGROUP: {
          this.insertionMode = z.IN_COLUMN_GROUP;
          return;
        }
        case y.TABLE: {
          this.insertionMode = z.IN_TABLE;
          return;
        }
        case y.BODY: {
          this.insertionMode = z.IN_BODY;
          return;
        }
        case y.FRAMESET: {
          this.insertionMode = z.IN_FRAMESET;
          return;
        }
        case y.SELECT: {
          this._resetInsertionModeForSelect(e);
          return;
        }
        case y.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case y.HTML: {
          this.insertionMode = this.headElement ? z.AFTER_HEAD : z.BEFORE_HEAD;
          return;
        }
        case y.TD:
        case y.TH: {
          if (e > 0) {
            this.insertionMode = z.IN_CELL;
            return;
          }
          break;
        }
        case y.HEAD: {
          if (e > 0) {
            this.insertionMode = z.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = z.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(e) {
    if (e > 0)
      for (let n = e - 1; n > 0; n--) {
        const r = this.openElements.tagIDs[n];
        if (r === y.TEMPLATE)
          break;
        if (r === y.TABLE) {
          this.insertionMode = z.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = z.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(e) {
    return _$.has(e);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let e = this.openElements.stackTop; e >= 0; e--) {
      const n = this.openElements.items[e];
      switch (this.openElements.tagIDs[e]) {
        case y.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(n) === ke.HTML)
            return { parent: this.treeAdapter.getTemplateContent(n), beforeElement: null };
          break;
        }
        case y.TABLE: {
          const r = this.treeAdapter.getParentNode(n);
          return r ? { parent: r, beforeElement: n } : { parent: this.openElements.items[e - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(e) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, e, n.beforeElement) : this.treeAdapter.appendChild(n.parent, e);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(e, n) {
    const r = this.treeAdapter.getNamespaceURI(e);
    return zEe[r].has(n);
  }
  /** @internal */
  onCharacter(e) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      rFe(this, e);
      return;
    }
    switch (this.insertionMode) {
      case z.INITIAL: {
        im(this, e);
        break;
      }
      case z.BEFORE_HTML: {
        eg(this, e);
        break;
      }
      case z.BEFORE_HEAD: {
        tg(this, e);
        break;
      }
      case z.IN_HEAD: {
        ng(this, e);
        break;
      }
      case z.IN_HEAD_NO_SCRIPT: {
        rg(this, e);
        break;
      }
      case z.AFTER_HEAD: {
        ig(this, e);
        break;
      }
      case z.IN_BODY:
      case z.IN_CAPTION:
      case z.IN_CELL:
      case z.IN_TEMPLATE: {
        D$(this, e);
        break;
      }
      case z.TEXT:
      case z.IN_SELECT:
      case z.IN_SELECT_IN_TABLE: {
        this._insertCharacters(e);
        break;
      }
      case z.IN_TABLE:
      case z.IN_TABLE_BODY:
      case z.IN_ROW: {
        bw(this, e);
        break;
      }
      case z.IN_TABLE_TEXT: {
        O$(this, e);
        break;
      }
      case z.IN_COLUMN_GROUP: {
        m1(this, e);
        break;
      }
      case z.AFTER_BODY: {
        g1(this, e);
        break;
      }
      case z.AFTER_AFTER_BODY: {
        ky(this, e);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(e) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      nFe(this, e);
      return;
    }
    switch (this.insertionMode) {
      case z.INITIAL: {
        im(this, e);
        break;
      }
      case z.BEFORE_HTML: {
        eg(this, e);
        break;
      }
      case z.BEFORE_HEAD: {
        tg(this, e);
        break;
      }
      case z.IN_HEAD: {
        ng(this, e);
        break;
      }
      case z.IN_HEAD_NO_SCRIPT: {
        rg(this, e);
        break;
      }
      case z.AFTER_HEAD: {
        ig(this, e);
        break;
      }
      case z.TEXT: {
        this._insertCharacters(e);
        break;
      }
      case z.IN_TABLE:
      case z.IN_TABLE_BODY:
      case z.IN_ROW: {
        bw(this, e);
        break;
      }
      case z.IN_COLUMN_GROUP: {
        m1(this, e);
        break;
      }
      case z.AFTER_BODY: {
        g1(this, e);
        break;
      }
      case z.AFTER_AFTER_BODY: {
        ky(this, e);
        break;
      }
    }
  }
  /** @internal */
  onComment(e) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      VT(this, e);
      return;
    }
    switch (this.insertionMode) {
      case z.INITIAL:
      case z.BEFORE_HTML:
      case z.BEFORE_HEAD:
      case z.IN_HEAD:
      case z.IN_HEAD_NO_SCRIPT:
      case z.AFTER_HEAD:
      case z.IN_BODY:
      case z.IN_TABLE:
      case z.IN_CAPTION:
      case z.IN_COLUMN_GROUP:
      case z.IN_TABLE_BODY:
      case z.IN_ROW:
      case z.IN_CELL:
      case z.IN_SELECT:
      case z.IN_SELECT_IN_TABLE:
      case z.IN_TEMPLATE:
      case z.IN_FRAMESET:
      case z.AFTER_FRAMESET: {
        VT(this, e);
        break;
      }
      case z.IN_TABLE_TEXT: {
        sm(this, e);
        break;
      }
      case z.AFTER_BODY: {
        PSe(this, e);
        break;
      }
      case z.AFTER_AFTER_BODY:
      case z.AFTER_AFTER_FRAMESET: {
        LSe(this, e);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(e) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case z.INITIAL: {
        MSe(this, e);
        break;
      }
      case z.BEFORE_HEAD:
      case z.IN_HEAD:
      case z.IN_HEAD_NO_SCRIPT:
      case z.AFTER_HEAD: {
        this._err(e, ce.misplacedDoctype);
        break;
      }
      case z.IN_TABLE_TEXT: {
        sm(this, e);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(e) {
    this.skipNextNewLine = !1, this.currentToken = e, this._processStartTag(e), e.selfClosing && !e.ackSelfClosing && this._err(e, ce.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(e) {
    this.shouldProcessStartTagTokenInForeignContent(e) ? iFe(this, e) : this._startTagOutsideForeignContent(e);
  }
  /** @protected */
  _startTagOutsideForeignContent(e) {
    switch (this.insertionMode) {
      case z.INITIAL: {
        im(this, e);
        break;
      }
      case z.BEFORE_HTML: {
        OSe(this, e);
        break;
      }
      case z.BEFORE_HEAD: {
        $Se(this, e);
        break;
      }
      case z.IN_HEAD: {
        Ro(this, e);
        break;
      }
      case z.IN_HEAD_NO_SCRIPT: {
        GSe(this, e);
        break;
      }
      case z.AFTER_HEAD: {
        VSe(this, e);
        break;
      }
      case z.IN_BODY: {
        us(this, e);
        break;
      }
      case z.IN_TABLE: {
        pf(this, e);
        break;
      }
      case z.IN_TABLE_TEXT: {
        sm(this, e);
        break;
      }
      case z.IN_CAPTION: {
        Hwe(this, e);
        break;
      }
      case z.IN_COLUMN_GROUP: {
        KC(this, e);
        break;
      }
      case z.IN_TABLE_BODY: {
        xA(this, e);
        break;
      }
      case z.IN_ROW: {
        CA(this, e);
        break;
      }
      case z.IN_CELL: {
        Wwe(this, e);
        break;
      }
      case z.IN_SELECT: {
        H$(this, e);
        break;
      }
      case z.IN_SELECT_IN_TABLE: {
        Kwe(this, e);
        break;
      }
      case z.IN_TEMPLATE: {
        jwe(this, e);
        break;
      }
      case z.AFTER_BODY: {
        qwe(this, e);
        break;
      }
      case z.IN_FRAMESET: {
        Jwe(this, e);
        break;
      }
      case z.AFTER_FRAMESET: {
        Xwe(this, e);
        break;
      }
      case z.AFTER_AFTER_BODY: {
        eFe(this, e);
        break;
      }
      case z.AFTER_AFTER_FRAMESET: {
        tFe(this, e);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(e) {
    this.skipNextNewLine = !1, this.currentToken = e, this.currentNotInHTML ? sFe(this, e) : this._endTagOutsideForeignContent(e);
  }
  /** @protected */
  _endTagOutsideForeignContent(e) {
    switch (this.insertionMode) {
      case z.INITIAL: {
        im(this, e);
        break;
      }
      case z.BEFORE_HTML: {
        BSe(this, e);
        break;
      }
      case z.BEFORE_HEAD: {
        HSe(this, e);
        break;
      }
      case z.IN_HEAD: {
        USe(this, e);
        break;
      }
      case z.IN_HEAD_NO_SCRIPT: {
        WSe(this, e);
        break;
      }
      case z.AFTER_HEAD: {
        KSe(this, e);
        break;
      }
      case z.IN_BODY: {
        vA(this, e);
        break;
      }
      case z.TEXT: {
        Nwe(this, e);
        break;
      }
      case z.IN_TABLE: {
        kg(this, e);
        break;
      }
      case z.IN_TABLE_TEXT: {
        sm(this, e);
        break;
      }
      case z.IN_CAPTION: {
        Uwe(this, e);
        break;
      }
      case z.IN_COLUMN_GROUP: {
        Gwe(this, e);
        break;
      }
      case z.IN_TABLE_BODY: {
        KT(this, e);
        break;
      }
      case z.IN_ROW: {
        $$(this, e);
        break;
      }
      case z.IN_CELL: {
        Vwe(this, e);
        break;
      }
      case z.IN_SELECT: {
        U$(this, e);
        break;
      }
      case z.IN_SELECT_IN_TABLE: {
        zwe(this, e);
        break;
      }
      case z.IN_TEMPLATE: {
        Ywe(this, e);
        break;
      }
      case z.AFTER_BODY: {
        W$(this, e);
        break;
      }
      case z.IN_FRAMESET: {
        Qwe(this, e);
        break;
      }
      case z.AFTER_FRAMESET: {
        Zwe(this, e);
        break;
      }
      case z.AFTER_AFTER_BODY: {
        ky(this, e);
        break;
      }
    }
  }
  /** @internal */
  onEof(e) {
    switch (this.insertionMode) {
      case z.INITIAL: {
        im(this, e);
        break;
      }
      case z.BEFORE_HTML: {
        eg(this, e);
        break;
      }
      case z.BEFORE_HEAD: {
        tg(this, e);
        break;
      }
      case z.IN_HEAD: {
        ng(this, e);
        break;
      }
      case z.IN_HEAD_NO_SCRIPT: {
        rg(this, e);
        break;
      }
      case z.AFTER_HEAD: {
        ig(this, e);
        break;
      }
      case z.IN_BODY:
      case z.IN_TABLE:
      case z.IN_CAPTION:
      case z.IN_COLUMN_GROUP:
      case z.IN_TABLE_BODY:
      case z.IN_ROW:
      case z.IN_CELL:
      case z.IN_SELECT:
      case z.IN_SELECT_IN_TABLE: {
        L$(this, e);
        break;
      }
      case z.TEXT: {
        Dwe(this, e);
        break;
      }
      case z.IN_TABLE_TEXT: {
        sm(this, e);
        break;
      }
      case z.IN_TEMPLATE: {
        G$(this, e);
        break;
      }
      case z.AFTER_BODY:
      case z.IN_FRAMESET:
      case z.AFTER_FRAMESET:
      case z.AFTER_AFTER_BODY:
      case z.AFTER_AFTER_FRAMESET: {
        VC(this, e);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(e) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, e.chars.charCodeAt(0) === O.LINE_FEED)) {
      if (e.chars.length === 1)
        return;
      e.chars = e.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(e);
      return;
    }
    switch (this.insertionMode) {
      case z.IN_HEAD:
      case z.IN_HEAD_NO_SCRIPT:
      case z.AFTER_HEAD:
      case z.TEXT:
      case z.IN_COLUMN_GROUP:
      case z.IN_SELECT:
      case z.IN_SELECT_IN_TABLE:
      case z.IN_FRAMESET:
      case z.AFTER_FRAMESET: {
        this._insertCharacters(e);
        break;
      }
      case z.IN_BODY:
      case z.IN_CAPTION:
      case z.IN_CELL:
      case z.IN_TEMPLATE:
      case z.AFTER_BODY:
      case z.AFTER_AFTER_BODY:
      case z.AFTER_AFTER_FRAMESET: {
        N$(this, e);
        break;
      }
      case z.IN_TABLE:
      case z.IN_TABLE_BODY:
      case z.IN_ROW: {
        bw(this, e);
        break;
      }
      case z.IN_TABLE_TEXT: {
        M$(this, e);
        break;
      }
    }
  }
};
function kSe(t, e) {
  let n = t.activeFormattingElements.getElementEntryInScopeWithTagName(e.tagName);
  return n ? t.openElements.contains(n.element) ? t.openElements.hasInScope(e.tagID) || (n = null) : (t.activeFormattingElements.removeEntry(n), n = null) : P$(t, e), n;
}
function _Se(t, e) {
  let n = null, r = t.openElements.stackTop;
  for (; r >= 0; r--) {
    const i = t.openElements.items[r];
    if (i === e.element)
      break;
    t._isSpecialElement(i, t.openElements.tagIDs[r]) && (n = i);
  }
  return n || (t.openElements.shortenToLength(Math.max(r, 0)), t.activeFormattingElements.removeEntry(e)), n;
}
function NSe(t, e, n) {
  let r = e, i = t.openElements.getCommonAncestor(e);
  for (let s = 0, a = i; a !== n; s++, a = i) {
    i = t.openElements.getCommonAncestor(a);
    const o = t.activeFormattingElements.getElementEntry(a), u = o && s >= vSe;
    !o || u ? (u && t.activeFormattingElements.removeEntry(o), t.openElements.remove(a)) : (a = DSe(t, o), r === e && (t.activeFormattingElements.bookmark = o), t.treeAdapter.detachNode(r), t.treeAdapter.appendChild(a, r), r = a);
  }
  return r;
}
function DSe(t, e) {
  const n = t.treeAdapter.getNamespaceURI(e.element), r = t.treeAdapter.createElement(e.token.tagName, n, e.token.attrs);
  return t.openElements.replace(e.element, r), e.element = r, r;
}
function ISe(t, e, n) {
  const r = t.treeAdapter.getTagName(e), i = FA(r);
  if (t._isElementCausesFosterParenting(i))
    t._fosterParentElement(n);
  else {
    const s = t.treeAdapter.getNamespaceURI(e);
    i === y.TEMPLATE && s === ke.HTML && (e = t.treeAdapter.getTemplateContent(e)), t.treeAdapter.appendChild(e, n);
  }
}
function RSe(t, e, n) {
  const r = t.treeAdapter.getNamespaceURI(n.element), { token: i } = n, s = t.treeAdapter.createElement(i.tagName, r, i.attrs);
  t._adoptNodes(e, s), t.treeAdapter.appendChild(e, s), t.activeFormattingElements.insertElementAfterBookmark(s, i), t.activeFormattingElements.removeEntry(n), t.openElements.remove(n.element), t.openElements.insertAfter(e, s, i.tagID);
}
function WC(t, e) {
  for (let n = 0; n < TSe; n++) {
    const r = kSe(t, e);
    if (!r)
      break;
    const i = _Se(t, r);
    if (!i)
      break;
    t.activeFormattingElements.bookmark = r;
    const s = NSe(t, i, r.element), a = t.openElements.getCommonAncestor(r.element);
    t.treeAdapter.detachNode(s), a && ISe(t, a, s), RSe(t, i, r);
  }
}
function VT(t, e) {
  t._appendCommentNode(e, t.openElements.currentTmplContentOrNode);
}
function PSe(t, e) {
  t._appendCommentNode(e, t.openElements.items[0]);
}
function LSe(t, e) {
  t._appendCommentNode(e, t.document);
}
function VC(t, e) {
  if (t.stopped = !0, e.location) {
    const n = t.fragmentContext ? 0 : 2;
    for (let r = t.openElements.stackTop; r >= n; r--)
      t._setEndLocation(t.openElements.items[r], e);
    if (!t.fragmentContext && t.openElements.stackTop >= 0) {
      const r = t.openElements.items[0], i = t.treeAdapter.getNodeSourceCodeLocation(r);
      if (i && !i.endTag && (t._setEndLocation(r, e), t.openElements.stackTop >= 1)) {
        const s = t.openElements.items[1], a = t.treeAdapter.getNodeSourceCodeLocation(s);
        a && !a.endTag && t._setEndLocation(s, e);
      }
    }
  }
}
function MSe(t, e) {
  t._setDocumentType(e);
  const n = e.forceQuirks ? Ia.QUIRKS : hSe(e);
  cSe(e) || t._err(e, ce.nonConformingDoctype), t.treeAdapter.setDocumentMode(t.document, n), t.insertionMode = z.BEFORE_HTML;
}
function im(t, e) {
  t._err(e, ce.missingDoctype, !0), t.treeAdapter.setDocumentMode(t.document, Ia.QUIRKS), t.insertionMode = z.BEFORE_HTML, t._processToken(e);
}
function OSe(t, e) {
  e.tagID === y.HTML ? (t._insertElement(e, ke.HTML), t.insertionMode = z.BEFORE_HEAD) : eg(t, e);
}
function BSe(t, e) {
  const n = e.tagID;
  (n === y.HTML || n === y.HEAD || n === y.BODY || n === y.BR) && eg(t, e);
}
function eg(t, e) {
  t._insertFakeRootElement(), t.insertionMode = z.BEFORE_HEAD, t._processToken(e);
}
function $Se(t, e) {
  switch (e.tagID) {
    case y.HTML: {
      us(t, e);
      break;
    }
    case y.HEAD: {
      t._insertElement(e, ke.HTML), t.headElement = t.openElements.current, t.insertionMode = z.IN_HEAD;
      break;
    }
    default:
      tg(t, e);
  }
}
function HSe(t, e) {
  const n = e.tagID;
  n === y.HEAD || n === y.BODY || n === y.HTML || n === y.BR ? tg(t, e) : t._err(e, ce.endTagWithoutMatchingOpenElement);
}
function tg(t, e) {
  t._insertFakeElement(re.HEAD, y.HEAD), t.headElement = t.openElements.current, t.insertionMode = z.IN_HEAD, t._processToken(e);
}
function Ro(t, e) {
  switch (e.tagID) {
    case y.HTML: {
      us(t, e);
      break;
    }
    case y.BASE:
    case y.BASEFONT:
    case y.BGSOUND:
    case y.LINK:
    case y.META: {
      t._appendElement(e, ke.HTML), e.ackSelfClosing = !0;
      break;
    }
    case y.TITLE: {
      t._switchToTextParsing(e, Ls.RCDATA);
      break;
    }
    case y.NOSCRIPT: {
      t.options.scriptingEnabled ? t._switchToTextParsing(e, Ls.RAWTEXT) : (t._insertElement(e, ke.HTML), t.insertionMode = z.IN_HEAD_NO_SCRIPT);
      break;
    }
    case y.NOFRAMES:
    case y.STYLE: {
      t._switchToTextParsing(e, Ls.RAWTEXT);
      break;
    }
    case y.SCRIPT: {
      t._switchToTextParsing(e, Ls.SCRIPT_DATA);
      break;
    }
    case y.TEMPLATE: {
      t._insertTemplate(e), t.activeFormattingElements.insertMarker(), t.framesetOk = !1, t.insertionMode = z.IN_TEMPLATE, t.tmplInsertionModeStack.unshift(z.IN_TEMPLATE);
      break;
    }
    case y.HEAD: {
      t._err(e, ce.misplacedStartTagForHeadElement);
      break;
    }
    default:
      ng(t, e);
  }
}
function USe(t, e) {
  switch (e.tagID) {
    case y.HEAD: {
      t.openElements.pop(), t.insertionMode = z.AFTER_HEAD;
      break;
    }
    case y.BODY:
    case y.BR:
    case y.HTML: {
      ng(t, e);
      break;
    }
    case y.TEMPLATE: {
      Nh(t, e);
      break;
    }
    default:
      t._err(e, ce.endTagWithoutMatchingOpenElement);
  }
}
function Nh(t, e) {
  t.openElements.tmplCount > 0 ? (t.openElements.generateImpliedEndTagsThoroughly(), t.openElements.currentTagId !== y.TEMPLATE && t._err(e, ce.closingOfElementWithOpenChildElements), t.openElements.popUntilTagNamePopped(y.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode()) : t._err(e, ce.endTagWithoutMatchingOpenElement);
}
function ng(t, e) {
  t.openElements.pop(), t.insertionMode = z.AFTER_HEAD, t._processToken(e);
}
function GSe(t, e) {
  switch (e.tagID) {
    case y.HTML: {
      us(t, e);
      break;
    }
    case y.BASEFONT:
    case y.BGSOUND:
    case y.HEAD:
    case y.LINK:
    case y.META:
    case y.NOFRAMES:
    case y.STYLE: {
      Ro(t, e);
      break;
    }
    case y.NOSCRIPT: {
      t._err(e, ce.nestedNoscriptInHead);
      break;
    }
    default:
      rg(t, e);
  }
}
function WSe(t, e) {
  switch (e.tagID) {
    case y.NOSCRIPT: {
      t.openElements.pop(), t.insertionMode = z.IN_HEAD;
      break;
    }
    case y.BR: {
      rg(t, e);
      break;
    }
    default:
      t._err(e, ce.endTagWithoutMatchingOpenElement);
  }
}
function rg(t, e) {
  const n = e.type === Fn.EOF ? ce.openElementsLeftAfterEof : ce.disallowedContentInNoscriptInHead;
  t._err(e, n), t.openElements.pop(), t.insertionMode = z.IN_HEAD, t._processToken(e);
}
function VSe(t, e) {
  switch (e.tagID) {
    case y.HTML: {
      us(t, e);
      break;
    }
    case y.BODY: {
      t._insertElement(e, ke.HTML), t.framesetOk = !1, t.insertionMode = z.IN_BODY;
      break;
    }
    case y.FRAMESET: {
      t._insertElement(e, ke.HTML), t.insertionMode = z.IN_FRAMESET;
      break;
    }
    case y.BASE:
    case y.BASEFONT:
    case y.BGSOUND:
    case y.LINK:
    case y.META:
    case y.NOFRAMES:
    case y.SCRIPT:
    case y.STYLE:
    case y.TEMPLATE:
    case y.TITLE: {
      t._err(e, ce.abandonedHeadElementChild), t.openElements.push(t.headElement, y.HEAD), Ro(t, e), t.openElements.remove(t.headElement);
      break;
    }
    case y.HEAD: {
      t._err(e, ce.misplacedStartTagForHeadElement);
      break;
    }
    default:
      ig(t, e);
  }
}
function KSe(t, e) {
  switch (e.tagID) {
    case y.BODY:
    case y.HTML:
    case y.BR: {
      ig(t, e);
      break;
    }
    case y.TEMPLATE: {
      Nh(t, e);
      break;
    }
    default:
      t._err(e, ce.endTagWithoutMatchingOpenElement);
  }
}
function ig(t, e) {
  t._insertFakeElement(re.BODY, y.BODY), t.insertionMode = z.IN_BODY, TA(t, e);
}
function TA(t, e) {
  switch (e.type) {
    case Fn.CHARACTER: {
      D$(t, e);
      break;
    }
    case Fn.WHITESPACE_CHARACTER: {
      N$(t, e);
      break;
    }
    case Fn.COMMENT: {
      VT(t, e);
      break;
    }
    case Fn.START_TAG: {
      us(t, e);
      break;
    }
    case Fn.END_TAG: {
      vA(t, e);
      break;
    }
    case Fn.EOF: {
      L$(t, e);
      break;
    }
  }
}
function N$(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e);
}
function D$(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e), t.framesetOk = !1;
}
function zSe(t, e) {
  t.openElements.tmplCount === 0 && t.treeAdapter.adoptAttributes(t.openElements.items[0], e.attrs);
}
function jSe(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  n && t.openElements.tmplCount === 0 && (t.framesetOk = !1, t.treeAdapter.adoptAttributes(n, e.attrs));
}
function YSe(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  t.framesetOk && n && (t.treeAdapter.detachNode(n), t.openElements.popAllUpToHtmlElement(), t._insertElement(e, ke.HTML), t.insertionMode = z.IN_FRAMESET);
}
function qSe(t, e) {
  t.openElements.hasInButtonScope(y.P) && t._closePElement(), t._insertElement(e, ke.HTML);
}
function JSe(t, e) {
  t.openElements.hasInButtonScope(y.P) && t._closePElement(), t.openElements.currentTagId !== void 0 && WT.has(t.openElements.currentTagId) && t.openElements.pop(), t._insertElement(e, ke.HTML);
}
function QSe(t, e) {
  t.openElements.hasInButtonScope(y.P) && t._closePElement(), t._insertElement(e, ke.HTML), t.skipNextNewLine = !0, t.framesetOk = !1;
}
function XSe(t, e) {
  const n = t.openElements.tmplCount > 0;
  (!t.formElement || n) && (t.openElements.hasInButtonScope(y.P) && t._closePElement(), t._insertElement(e, ke.HTML), n || (t.formElement = t.openElements.current));
}
function ZSe(t, e) {
  t.framesetOk = !1;
  const n = e.tagID;
  for (let r = t.openElements.stackTop; r >= 0; r--) {
    const i = t.openElements.tagIDs[r];
    if (n === y.LI && i === y.LI || (n === y.DD || n === y.DT) && (i === y.DD || i === y.DT)) {
      t.openElements.generateImpliedEndTagsWithExclusion(i), t.openElements.popUntilTagNamePopped(i);
      break;
    }
    if (i !== y.ADDRESS && i !== y.DIV && i !== y.P && t._isSpecialElement(t.openElements.items[r], i))
      break;
  }
  t.openElements.hasInButtonScope(y.P) && t._closePElement(), t._insertElement(e, ke.HTML);
}
function ewe(t, e) {
  t.openElements.hasInButtonScope(y.P) && t._closePElement(), t._insertElement(e, ke.HTML), t.tokenizer.state = Ls.PLAINTEXT;
}
function twe(t, e) {
  t.openElements.hasInScope(y.BUTTON) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(y.BUTTON)), t._reconstructActiveFormattingElements(), t._insertElement(e, ke.HTML), t.framesetOk = !1;
}
function nwe(t, e) {
  const n = t.activeFormattingElements.getElementEntryInScopeWithTagName(re.A);
  n && (WC(t, e), t.openElements.remove(n.element), t.activeFormattingElements.removeEntry(n)), t._reconstructActiveFormattingElements(), t._insertElement(e, ke.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function rwe(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, ke.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function iwe(t, e) {
  t._reconstructActiveFormattingElements(), t.openElements.hasInScope(y.NOBR) && (WC(t, e), t._reconstructActiveFormattingElements()), t._insertElement(e, ke.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function swe(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, ke.HTML), t.activeFormattingElements.insertMarker(), t.framesetOk = !1;
}
function awe(t, e) {
  t.treeAdapter.getDocumentMode(t.document) !== Ia.QUIRKS && t.openElements.hasInButtonScope(y.P) && t._closePElement(), t._insertElement(e, ke.HTML), t.framesetOk = !1, t.insertionMode = z.IN_TABLE;
}
function I$(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, ke.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function R$(t) {
  const e = S$(t, ph.TYPE);
  return e != null && e.toLowerCase() === FSe;
}
function owe(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, ke.HTML), R$(e) || (t.framesetOk = !1), e.ackSelfClosing = !0;
}
function uwe(t, e) {
  t._appendElement(e, ke.HTML), e.ackSelfClosing = !0;
}
function lwe(t, e) {
  t.openElements.hasInButtonScope(y.P) && t._closePElement(), t._appendElement(e, ke.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function cwe(t, e) {
  e.tagName = re.IMG, e.tagID = y.IMG, I$(t, e);
}
function hwe(t, e) {
  t._insertElement(e, ke.HTML), t.skipNextNewLine = !0, t.tokenizer.state = Ls.RCDATA, t.originalInsertionMode = t.insertionMode, t.framesetOk = !1, t.insertionMode = z.TEXT;
}
function dwe(t, e) {
  t.openElements.hasInButtonScope(y.P) && t._closePElement(), t._reconstructActiveFormattingElements(), t.framesetOk = !1, t._switchToTextParsing(e, Ls.RAWTEXT);
}
function fwe(t, e) {
  t.framesetOk = !1, t._switchToTextParsing(e, Ls.RAWTEXT);
}
function zI(t, e) {
  t._switchToTextParsing(e, Ls.RAWTEXT);
}
function mwe(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, ke.HTML), t.framesetOk = !1, t.insertionMode = t.insertionMode === z.IN_TABLE || t.insertionMode === z.IN_CAPTION || t.insertionMode === z.IN_TABLE_BODY || t.insertionMode === z.IN_ROW || t.insertionMode === z.IN_CELL ? z.IN_SELECT_IN_TABLE : z.IN_SELECT;
}
function gwe(t, e) {
  t.openElements.currentTagId === y.OPTION && t.openElements.pop(), t._reconstructActiveFormattingElements(), t._insertElement(e, ke.HTML);
}
function pwe(t, e) {
  t.openElements.hasInScope(y.RUBY) && t.openElements.generateImpliedEndTags(), t._insertElement(e, ke.HTML);
}
function bwe(t, e) {
  t.openElements.hasInScope(y.RUBY) && t.openElements.generateImpliedEndTagsWithExclusion(y.RTC), t._insertElement(e, ke.HTML);
}
function ywe(t, e) {
  t._reconstructActiveFormattingElements(), C$(e), GC(e), e.selfClosing ? t._appendElement(e, ke.MATHML) : t._insertElement(e, ke.MATHML), e.ackSelfClosing = !0;
}
function Awe(t, e) {
  t._reconstructActiveFormattingElements(), k$(e), GC(e), e.selfClosing ? t._appendElement(e, ke.SVG) : t._insertElement(e, ke.SVG), e.ackSelfClosing = !0;
}
function jI(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, ke.HTML);
}
function us(t, e) {
  switch (e.tagID) {
    case y.I:
    case y.S:
    case y.B:
    case y.U:
    case y.EM:
    case y.TT:
    case y.BIG:
    case y.CODE:
    case y.FONT:
    case y.SMALL:
    case y.STRIKE:
    case y.STRONG: {
      rwe(t, e);
      break;
    }
    case y.A: {
      nwe(t, e);
      break;
    }
    case y.H1:
    case y.H2:
    case y.H3:
    case y.H4:
    case y.H5:
    case y.H6: {
      JSe(t, e);
      break;
    }
    case y.P:
    case y.DL:
    case y.OL:
    case y.UL:
    case y.DIV:
    case y.DIR:
    case y.NAV:
    case y.MAIN:
    case y.MENU:
    case y.ASIDE:
    case y.CENTER:
    case y.FIGURE:
    case y.FOOTER:
    case y.HEADER:
    case y.HGROUP:
    case y.DIALOG:
    case y.DETAILS:
    case y.ADDRESS:
    case y.ARTICLE:
    case y.SEARCH:
    case y.SECTION:
    case y.SUMMARY:
    case y.FIELDSET:
    case y.BLOCKQUOTE:
    case y.FIGCAPTION: {
      qSe(t, e);
      break;
    }
    case y.LI:
    case y.DD:
    case y.DT: {
      ZSe(t, e);
      break;
    }
    case y.BR:
    case y.IMG:
    case y.WBR:
    case y.AREA:
    case y.EMBED:
    case y.KEYGEN: {
      I$(t, e);
      break;
    }
    case y.HR: {
      lwe(t, e);
      break;
    }
    case y.RB:
    case y.RTC: {
      pwe(t, e);
      break;
    }
    case y.RT:
    case y.RP: {
      bwe(t, e);
      break;
    }
    case y.PRE:
    case y.LISTING: {
      QSe(t, e);
      break;
    }
    case y.XMP: {
      dwe(t, e);
      break;
    }
    case y.SVG: {
      Awe(t, e);
      break;
    }
    case y.HTML: {
      zSe(t, e);
      break;
    }
    case y.BASE:
    case y.LINK:
    case y.META:
    case y.STYLE:
    case y.TITLE:
    case y.SCRIPT:
    case y.BGSOUND:
    case y.BASEFONT:
    case y.TEMPLATE: {
      Ro(t, e);
      break;
    }
    case y.BODY: {
      jSe(t, e);
      break;
    }
    case y.FORM: {
      XSe(t, e);
      break;
    }
    case y.NOBR: {
      iwe(t, e);
      break;
    }
    case y.MATH: {
      ywe(t, e);
      break;
    }
    case y.TABLE: {
      awe(t, e);
      break;
    }
    case y.INPUT: {
      owe(t, e);
      break;
    }
    case y.PARAM:
    case y.TRACK:
    case y.SOURCE: {
      uwe(t, e);
      break;
    }
    case y.IMAGE: {
      cwe(t, e);
      break;
    }
    case y.BUTTON: {
      twe(t, e);
      break;
    }
    case y.APPLET:
    case y.OBJECT:
    case y.MARQUEE: {
      swe(t, e);
      break;
    }
    case y.IFRAME: {
      fwe(t, e);
      break;
    }
    case y.SELECT: {
      mwe(t, e);
      break;
    }
    case y.OPTION:
    case y.OPTGROUP: {
      gwe(t, e);
      break;
    }
    case y.NOEMBED:
    case y.NOFRAMES: {
      zI(t, e);
      break;
    }
    case y.FRAMESET: {
      YSe(t, e);
      break;
    }
    case y.TEXTAREA: {
      hwe(t, e);
      break;
    }
    case y.NOSCRIPT: {
      t.options.scriptingEnabled ? zI(t, e) : jI(t, e);
      break;
    }
    case y.PLAINTEXT: {
      ewe(t, e);
      break;
    }
    case y.COL:
    case y.TH:
    case y.TD:
    case y.TR:
    case y.HEAD:
    case y.FRAME:
    case y.TBODY:
    case y.TFOOT:
    case y.THEAD:
    case y.CAPTION:
    case y.COLGROUP:
      break;
    default:
      jI(t, e);
  }
}
function Ewe(t, e) {
  if (t.openElements.hasInScope(y.BODY) && (t.insertionMode = z.AFTER_BODY, t.options.sourceCodeLocationInfo)) {
    const n = t.openElements.tryPeekProperlyNestedBodyElement();
    n && t._setEndLocation(n, e);
  }
}
function Swe(t, e) {
  t.openElements.hasInScope(y.BODY) && (t.insertionMode = z.AFTER_BODY, W$(t, e));
}
function wwe(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n));
}
function Fwe(t) {
  const e = t.openElements.tmplCount > 0, { formElement: n } = t;
  e || (t.formElement = null), (n || e) && t.openElements.hasInScope(y.FORM) && (t.openElements.generateImpliedEndTags(), e ? t.openElements.popUntilTagNamePopped(y.FORM) : n && t.openElements.remove(n));
}
function Twe(t) {
  t.openElements.hasInButtonScope(y.P) || t._insertFakeElement(re.P, y.P), t._closePElement();
}
function vwe(t) {
  t.openElements.hasInListItemScope(y.LI) && (t.openElements.generateImpliedEndTagsWithExclusion(y.LI), t.openElements.popUntilTagNamePopped(y.LI));
}
function xwe(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTagsWithExclusion(n), t.openElements.popUntilTagNamePopped(n));
}
function Cwe(t) {
  t.openElements.hasNumberedHeaderInScope() && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilNumberedHeaderPopped());
}
function kwe(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker());
}
function _we(t) {
  t._reconstructActiveFormattingElements(), t._insertFakeElement(re.BR, y.BR), t.openElements.pop(), t.framesetOk = !1;
}
function P$(t, e) {
  const n = e.tagName, r = e.tagID;
  for (let i = t.openElements.stackTop; i > 0; i--) {
    const s = t.openElements.items[i], a = t.openElements.tagIDs[i];
    if (r === a && (r !== y.UNKNOWN || t.treeAdapter.getTagName(s) === n)) {
      t.openElements.generateImpliedEndTagsWithExclusion(r), t.openElements.stackTop >= i && t.openElements.shortenToLength(i);
      break;
    }
    if (t._isSpecialElement(s, a))
      break;
  }
}
function vA(t, e) {
  switch (e.tagID) {
    case y.A:
    case y.B:
    case y.I:
    case y.S:
    case y.U:
    case y.EM:
    case y.TT:
    case y.BIG:
    case y.CODE:
    case y.FONT:
    case y.NOBR:
    case y.SMALL:
    case y.STRIKE:
    case y.STRONG: {
      WC(t, e);
      break;
    }
    case y.P: {
      Twe(t);
      break;
    }
    case y.DL:
    case y.UL:
    case y.OL:
    case y.DIR:
    case y.DIV:
    case y.NAV:
    case y.PRE:
    case y.MAIN:
    case y.MENU:
    case y.ASIDE:
    case y.BUTTON:
    case y.CENTER:
    case y.FIGURE:
    case y.FOOTER:
    case y.HEADER:
    case y.HGROUP:
    case y.DIALOG:
    case y.ADDRESS:
    case y.ARTICLE:
    case y.DETAILS:
    case y.SEARCH:
    case y.SECTION:
    case y.SUMMARY:
    case y.LISTING:
    case y.FIELDSET:
    case y.BLOCKQUOTE:
    case y.FIGCAPTION: {
      wwe(t, e);
      break;
    }
    case y.LI: {
      vwe(t);
      break;
    }
    case y.DD:
    case y.DT: {
      xwe(t, e);
      break;
    }
    case y.H1:
    case y.H2:
    case y.H3:
    case y.H4:
    case y.H5:
    case y.H6: {
      Cwe(t);
      break;
    }
    case y.BR: {
      _we(t);
      break;
    }
    case y.BODY: {
      Ewe(t, e);
      break;
    }
    case y.HTML: {
      Swe(t, e);
      break;
    }
    case y.FORM: {
      Fwe(t);
      break;
    }
    case y.APPLET:
    case y.OBJECT:
    case y.MARQUEE: {
      kwe(t, e);
      break;
    }
    case y.TEMPLATE: {
      Nh(t, e);
      break;
    }
    default:
      P$(t, e);
  }
}
function L$(t, e) {
  t.tmplInsertionModeStack.length > 0 ? G$(t, e) : VC(t, e);
}
function Nwe(t, e) {
  var n;
  e.tagID === y.SCRIPT && ((n = t.scriptHandler) === null || n === void 0 || n.call(t, t.openElements.current)), t.openElements.pop(), t.insertionMode = t.originalInsertionMode;
}
function Dwe(t, e) {
  t._err(e, ce.eofInElementThatCanContainOnlyText), t.openElements.pop(), t.insertionMode = t.originalInsertionMode, t.onEof(e);
}
function bw(t, e) {
  if (t.openElements.currentTagId !== void 0 && _$.has(t.openElements.currentTagId))
    switch (t.pendingCharacterTokens.length = 0, t.hasNonWhitespacePendingCharacterToken = !1, t.originalInsertionMode = t.insertionMode, t.insertionMode = z.IN_TABLE_TEXT, e.type) {
      case Fn.CHARACTER: {
        O$(t, e);
        break;
      }
      case Fn.WHITESPACE_CHARACTER: {
        M$(t, e);
        break;
      }
    }
  else
    up(t, e);
}
function Iwe(t, e) {
  t.openElements.clearBackToTableContext(), t.activeFormattingElements.insertMarker(), t._insertElement(e, ke.HTML), t.insertionMode = z.IN_CAPTION;
}
function Rwe(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, ke.HTML), t.insertionMode = z.IN_COLUMN_GROUP;
}
function Pwe(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(re.COLGROUP, y.COLGROUP), t.insertionMode = z.IN_COLUMN_GROUP, KC(t, e);
}
function Lwe(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, ke.HTML), t.insertionMode = z.IN_TABLE_BODY;
}
function Mwe(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(re.TBODY, y.TBODY), t.insertionMode = z.IN_TABLE_BODY, xA(t, e);
}
function Owe(t, e) {
  t.openElements.hasInTableScope(y.TABLE) && (t.openElements.popUntilTagNamePopped(y.TABLE), t._resetInsertionMode(), t._processStartTag(e));
}
function Bwe(t, e) {
  R$(e) ? t._appendElement(e, ke.HTML) : up(t, e), e.ackSelfClosing = !0;
}
function $we(t, e) {
  !t.formElement && t.openElements.tmplCount === 0 && (t._insertElement(e, ke.HTML), t.formElement = t.openElements.current, t.openElements.pop());
}
function pf(t, e) {
  switch (e.tagID) {
    case y.TD:
    case y.TH:
    case y.TR: {
      Mwe(t, e);
      break;
    }
    case y.STYLE:
    case y.SCRIPT:
    case y.TEMPLATE: {
      Ro(t, e);
      break;
    }
    case y.COL: {
      Pwe(t, e);
      break;
    }
    case y.FORM: {
      $we(t, e);
      break;
    }
    case y.TABLE: {
      Owe(t, e);
      break;
    }
    case y.TBODY:
    case y.TFOOT:
    case y.THEAD: {
      Lwe(t, e);
      break;
    }
    case y.INPUT: {
      Bwe(t, e);
      break;
    }
    case y.CAPTION: {
      Iwe(t, e);
      break;
    }
    case y.COLGROUP: {
      Rwe(t, e);
      break;
    }
    default:
      up(t, e);
  }
}
function kg(t, e) {
  switch (e.tagID) {
    case y.TABLE: {
      t.openElements.hasInTableScope(y.TABLE) && (t.openElements.popUntilTagNamePopped(y.TABLE), t._resetInsertionMode());
      break;
    }
    case y.TEMPLATE: {
      Nh(t, e);
      break;
    }
    case y.BODY:
    case y.CAPTION:
    case y.COL:
    case y.COLGROUP:
    case y.HTML:
    case y.TBODY:
    case y.TD:
    case y.TFOOT:
    case y.TH:
    case y.THEAD:
    case y.TR:
      break;
    default:
      up(t, e);
  }
}
function up(t, e) {
  const n = t.fosterParentingEnabled;
  t.fosterParentingEnabled = !0, TA(t, e), t.fosterParentingEnabled = n;
}
function M$(t, e) {
  t.pendingCharacterTokens.push(e);
}
function O$(t, e) {
  t.pendingCharacterTokens.push(e), t.hasNonWhitespacePendingCharacterToken = !0;
}
function sm(t, e) {
  let n = 0;
  if (t.hasNonWhitespacePendingCharacterToken)
    for (; n < t.pendingCharacterTokens.length; n++)
      up(t, t.pendingCharacterTokens[n]);
  else
    for (; n < t.pendingCharacterTokens.length; n++)
      t._insertCharacters(t.pendingCharacterTokens[n]);
  t.insertionMode = t.originalInsertionMode, t._processToken(e);
}
const B$ = /* @__PURE__ */ new Set([y.CAPTION, y.COL, y.COLGROUP, y.TBODY, y.TD, y.TFOOT, y.TH, y.THEAD, y.TR]);
function Hwe(t, e) {
  const n = e.tagID;
  B$.has(n) ? t.openElements.hasInTableScope(y.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(y.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = z.IN_TABLE, pf(t, e)) : us(t, e);
}
function Uwe(t, e) {
  const n = e.tagID;
  switch (n) {
    case y.CAPTION:
    case y.TABLE: {
      t.openElements.hasInTableScope(y.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(y.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = z.IN_TABLE, n === y.TABLE && kg(t, e));
      break;
    }
    case y.BODY:
    case y.COL:
    case y.COLGROUP:
    case y.HTML:
    case y.TBODY:
    case y.TD:
    case y.TFOOT:
    case y.TH:
    case y.THEAD:
    case y.TR:
      break;
    default:
      vA(t, e);
  }
}
function KC(t, e) {
  switch (e.tagID) {
    case y.HTML: {
      us(t, e);
      break;
    }
    case y.COL: {
      t._appendElement(e, ke.HTML), e.ackSelfClosing = !0;
      break;
    }
    case y.TEMPLATE: {
      Ro(t, e);
      break;
    }
    default:
      m1(t, e);
  }
}
function Gwe(t, e) {
  switch (e.tagID) {
    case y.COLGROUP: {
      t.openElements.currentTagId === y.COLGROUP && (t.openElements.pop(), t.insertionMode = z.IN_TABLE);
      break;
    }
    case y.TEMPLATE: {
      Nh(t, e);
      break;
    }
    case y.COL:
      break;
    default:
      m1(t, e);
  }
}
function m1(t, e) {
  t.openElements.currentTagId === y.COLGROUP && (t.openElements.pop(), t.insertionMode = z.IN_TABLE, t._processToken(e));
}
function xA(t, e) {
  switch (e.tagID) {
    case y.TR: {
      t.openElements.clearBackToTableBodyContext(), t._insertElement(e, ke.HTML), t.insertionMode = z.IN_ROW;
      break;
    }
    case y.TH:
    case y.TD: {
      t.openElements.clearBackToTableBodyContext(), t._insertFakeElement(re.TR, y.TR), t.insertionMode = z.IN_ROW, CA(t, e);
      break;
    }
    case y.CAPTION:
    case y.COL:
    case y.COLGROUP:
    case y.TBODY:
    case y.TFOOT:
    case y.THEAD: {
      t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = z.IN_TABLE, pf(t, e));
      break;
    }
    default:
      pf(t, e);
  }
}
function KT(t, e) {
  const n = e.tagID;
  switch (e.tagID) {
    case y.TBODY:
    case y.TFOOT:
    case y.THEAD: {
      t.openElements.hasInTableScope(n) && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = z.IN_TABLE);
      break;
    }
    case y.TABLE: {
      t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = z.IN_TABLE, kg(t, e));
      break;
    }
    case y.BODY:
    case y.CAPTION:
    case y.COL:
    case y.COLGROUP:
    case y.HTML:
    case y.TD:
    case y.TH:
    case y.TR:
      break;
    default:
      kg(t, e);
  }
}
function CA(t, e) {
  switch (e.tagID) {
    case y.TH:
    case y.TD: {
      t.openElements.clearBackToTableRowContext(), t._insertElement(e, ke.HTML), t.insertionMode = z.IN_CELL, t.activeFormattingElements.insertMarker();
      break;
    }
    case y.CAPTION:
    case y.COL:
    case y.COLGROUP:
    case y.TBODY:
    case y.TFOOT:
    case y.THEAD:
    case y.TR: {
      t.openElements.hasInTableScope(y.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = z.IN_TABLE_BODY, xA(t, e));
      break;
    }
    default:
      pf(t, e);
  }
}
function $$(t, e) {
  switch (e.tagID) {
    case y.TR: {
      t.openElements.hasInTableScope(y.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = z.IN_TABLE_BODY);
      break;
    }
    case y.TABLE: {
      t.openElements.hasInTableScope(y.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = z.IN_TABLE_BODY, KT(t, e));
      break;
    }
    case y.TBODY:
    case y.TFOOT:
    case y.THEAD: {
      (t.openElements.hasInTableScope(e.tagID) || t.openElements.hasInTableScope(y.TR)) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = z.IN_TABLE_BODY, KT(t, e));
      break;
    }
    case y.BODY:
    case y.CAPTION:
    case y.COL:
    case y.COLGROUP:
    case y.HTML:
    case y.TD:
    case y.TH:
      break;
    default:
      kg(t, e);
  }
}
function Wwe(t, e) {
  const n = e.tagID;
  B$.has(n) ? (t.openElements.hasInTableScope(y.TD) || t.openElements.hasInTableScope(y.TH)) && (t._closeTableCell(), CA(t, e)) : us(t, e);
}
function Vwe(t, e) {
  const n = e.tagID;
  switch (n) {
    case y.TD:
    case y.TH: {
      t.openElements.hasInTableScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = z.IN_ROW);
      break;
    }
    case y.TABLE:
    case y.TBODY:
    case y.TFOOT:
    case y.THEAD:
    case y.TR: {
      t.openElements.hasInTableScope(n) && (t._closeTableCell(), $$(t, e));
      break;
    }
    case y.BODY:
    case y.CAPTION:
    case y.COL:
    case y.COLGROUP:
    case y.HTML:
      break;
    default:
      vA(t, e);
  }
}
function H$(t, e) {
  switch (e.tagID) {
    case y.HTML: {
      us(t, e);
      break;
    }
    case y.OPTION: {
      t.openElements.currentTagId === y.OPTION && t.openElements.pop(), t._insertElement(e, ke.HTML);
      break;
    }
    case y.OPTGROUP: {
      t.openElements.currentTagId === y.OPTION && t.openElements.pop(), t.openElements.currentTagId === y.OPTGROUP && t.openElements.pop(), t._insertElement(e, ke.HTML);
      break;
    }
    case y.HR: {
      t.openElements.currentTagId === y.OPTION && t.openElements.pop(), t.openElements.currentTagId === y.OPTGROUP && t.openElements.pop(), t._appendElement(e, ke.HTML), e.ackSelfClosing = !0;
      break;
    }
    case y.INPUT:
    case y.KEYGEN:
    case y.TEXTAREA:
    case y.SELECT: {
      t.openElements.hasInSelectScope(y.SELECT) && (t.openElements.popUntilTagNamePopped(y.SELECT), t._resetInsertionMode(), e.tagID !== y.SELECT && t._processStartTag(e));
      break;
    }
    case y.SCRIPT:
    case y.TEMPLATE: {
      Ro(t, e);
      break;
    }
  }
}
function U$(t, e) {
  switch (e.tagID) {
    case y.OPTGROUP: {
      t.openElements.stackTop > 0 && t.openElements.currentTagId === y.OPTION && t.openElements.tagIDs[t.openElements.stackTop - 1] === y.OPTGROUP && t.openElements.pop(), t.openElements.currentTagId === y.OPTGROUP && t.openElements.pop();
      break;
    }
    case y.OPTION: {
      t.openElements.currentTagId === y.OPTION && t.openElements.pop();
      break;
    }
    case y.SELECT: {
      t.openElements.hasInSelectScope(y.SELECT) && (t.openElements.popUntilTagNamePopped(y.SELECT), t._resetInsertionMode());
      break;
    }
    case y.TEMPLATE: {
      Nh(t, e);
      break;
    }
  }
}
function Kwe(t, e) {
  const n = e.tagID;
  n === y.CAPTION || n === y.TABLE || n === y.TBODY || n === y.TFOOT || n === y.THEAD || n === y.TR || n === y.TD || n === y.TH ? (t.openElements.popUntilTagNamePopped(y.SELECT), t._resetInsertionMode(), t._processStartTag(e)) : H$(t, e);
}
function zwe(t, e) {
  const n = e.tagID;
  n === y.CAPTION || n === y.TABLE || n === y.TBODY || n === y.TFOOT || n === y.THEAD || n === y.TR || n === y.TD || n === y.TH ? t.openElements.hasInTableScope(n) && (t.openElements.popUntilTagNamePopped(y.SELECT), t._resetInsertionMode(), t.onEndTag(e)) : U$(t, e);
}
function jwe(t, e) {
  switch (e.tagID) {
    // First, handle tags that can start without a mode change
    case y.BASE:
    case y.BASEFONT:
    case y.BGSOUND:
    case y.LINK:
    case y.META:
    case y.NOFRAMES:
    case y.SCRIPT:
    case y.STYLE:
    case y.TEMPLATE:
    case y.TITLE: {
      Ro(t, e);
      break;
    }
    // Re-process the token in the appropriate mode
    case y.CAPTION:
    case y.COLGROUP:
    case y.TBODY:
    case y.TFOOT:
    case y.THEAD: {
      t.tmplInsertionModeStack[0] = z.IN_TABLE, t.insertionMode = z.IN_TABLE, pf(t, e);
      break;
    }
    case y.COL: {
      t.tmplInsertionModeStack[0] = z.IN_COLUMN_GROUP, t.insertionMode = z.IN_COLUMN_GROUP, KC(t, e);
      break;
    }
    case y.TR: {
      t.tmplInsertionModeStack[0] = z.IN_TABLE_BODY, t.insertionMode = z.IN_TABLE_BODY, xA(t, e);
      break;
    }
    case y.TD:
    case y.TH: {
      t.tmplInsertionModeStack[0] = z.IN_ROW, t.insertionMode = z.IN_ROW, CA(t, e);
      break;
    }
    default:
      t.tmplInsertionModeStack[0] = z.IN_BODY, t.insertionMode = z.IN_BODY, us(t, e);
  }
}
function Ywe(t, e) {
  e.tagID === y.TEMPLATE && Nh(t, e);
}
function G$(t, e) {
  t.openElements.tmplCount > 0 ? (t.openElements.popUntilTagNamePopped(y.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode(), t.onEof(e)) : VC(t, e);
}
function qwe(t, e) {
  e.tagID === y.HTML ? us(t, e) : g1(t, e);
}
function W$(t, e) {
  var n;
  if (e.tagID === y.HTML) {
    if (t.fragmentContext || (t.insertionMode = z.AFTER_AFTER_BODY), t.options.sourceCodeLocationInfo && t.openElements.tagIDs[0] === y.HTML) {
      t._setEndLocation(t.openElements.items[0], e);
      const r = t.openElements.items[1];
      r && !(!((n = t.treeAdapter.getNodeSourceCodeLocation(r)) === null || n === void 0) && n.endTag) && t._setEndLocation(r, e);
    }
  } else
    g1(t, e);
}
function g1(t, e) {
  t.insertionMode = z.IN_BODY, TA(t, e);
}
function Jwe(t, e) {
  switch (e.tagID) {
    case y.HTML: {
      us(t, e);
      break;
    }
    case y.FRAMESET: {
      t._insertElement(e, ke.HTML);
      break;
    }
    case y.FRAME: {
      t._appendElement(e, ke.HTML), e.ackSelfClosing = !0;
      break;
    }
    case y.NOFRAMES: {
      Ro(t, e);
      break;
    }
  }
}
function Qwe(t, e) {
  e.tagID === y.FRAMESET && !t.openElements.isRootHtmlElementCurrent() && (t.openElements.pop(), !t.fragmentContext && t.openElements.currentTagId !== y.FRAMESET && (t.insertionMode = z.AFTER_FRAMESET));
}
function Xwe(t, e) {
  switch (e.tagID) {
    case y.HTML: {
      us(t, e);
      break;
    }
    case y.NOFRAMES: {
      Ro(t, e);
      break;
    }
  }
}
function Zwe(t, e) {
  e.tagID === y.HTML && (t.insertionMode = z.AFTER_AFTER_FRAMESET);
}
function eFe(t, e) {
  e.tagID === y.HTML ? us(t, e) : ky(t, e);
}
function ky(t, e) {
  t.insertionMode = z.IN_BODY, TA(t, e);
}
function tFe(t, e) {
  switch (e.tagID) {
    case y.HTML: {
      us(t, e);
      break;
    }
    case y.NOFRAMES: {
      Ro(t, e);
      break;
    }
  }
}
function nFe(t, e) {
  e.chars = Er, t._insertCharacters(e);
}
function rFe(t, e) {
  t._insertCharacters(e), t.framesetOk = !1;
}
function V$(t) {
  for (; t.treeAdapter.getNamespaceURI(t.openElements.current) !== ke.HTML && t.openElements.currentTagId !== void 0 && !t._isIntegrationPoint(t.openElements.currentTagId, t.openElements.current); )
    t.openElements.pop();
}
function iFe(t, e) {
  if (ySe(e))
    V$(t), t._startTagOutsideForeignContent(e);
  else {
    const n = t._getAdjustedCurrentElement(), r = t.treeAdapter.getNamespaceURI(n);
    r === ke.MATHML ? C$(e) : r === ke.SVG && (ASe(e), k$(e)), GC(e), e.selfClosing ? t._appendElement(e, r) : t._insertElement(e, r), e.ackSelfClosing = !0;
  }
}
function sFe(t, e) {
  if (e.tagID === y.P || e.tagID === y.BR) {
    V$(t), t._endTagOutsideForeignContent(e);
    return;
  }
  for (let n = t.openElements.stackTop; n > 0; n--) {
    const r = t.openElements.items[n];
    if (t.treeAdapter.getNamespaceURI(r) === ke.HTML) {
      t._endTagOutsideForeignContent(e);
      break;
    }
    const i = t.treeAdapter.getTagName(r);
    if (i.toLowerCase() === e.tagName) {
      e.tagName = i, t.openElements.shortenToLength(n);
      break;
    }
  }
}
re.AREA, re.BASE, re.BASEFONT, re.BGSOUND, re.BR, re.COL, re.EMBED, re.FRAME, re.HR, re.IMG, re.INPUT, re.KEYGEN, re.LINK, re.META, re.PARAM, re.SOURCE, re.TRACK, re.WBR;
function aFe(t, e, n) {
  typeof t == "string" && (n = e, e = t, t = null);
  const r = CSe.getFragmentParser(t, n);
  return r.tokenizer.write(e, !0), r.getFragment();
}
const zC = "[a-z][a-z0-9-]*", oFe = `(__${zC})?`, K$ = `--${zC}`, uFe = new RegExp(`^${zC}${oFe}(${K$})*$`), lFe = new RegExp(K$);
function z$(t) {
  return uFe.test(t);
}
function Rf(t) {
  return typeof t == "string" ? t.split(/\s+/).map((e) => e.trim()).filter(Boolean) : Array.isArray(t) ? t.flatMap((e) => Rf(e)) : [];
}
function lp(t) {
  const e = t.filter(z$);
  return e.find((n) => !lFe.test(n)) ?? e[0];
}
function j$(t) {
  const e = t.lastIndexOf("--");
  return e >= 0 ? t.slice(e + 2) : t;
}
var cFe = [{ name: "Aegean Airlines", iataCode: "A3" }, { name: "Aeroflot", iataCode: "SU" }, { name: "Aerolineas Argentinas", iataCode: "AR" }, { name: "Aeromexico", iataCode: "AM" }, { name: "Air Algerie", iataCode: "AH" }, { name: "Air Arabia", iataCode: "G9" }, { name: "Air Canada", iataCode: "AC" }, { name: "Air China", iataCode: "CA" }, { name: "Air Europa", iataCode: "UX" }, { name: "Air France", iataCode: "AF" }, { name: "Air India", iataCode: "AI" }, { name: "Air Mauritius", iataCode: "MK" }, { name: "Air New Zealand", iataCode: "NZ" }, { name: "Air Niugini", iataCode: "PX" }, { name: "Air Tahiti", iataCode: "VT" }, { name: "Air Tahiti Nui", iataCode: "TN" }, { name: "Air Transat", iataCode: "TS" }, { name: "AirAsia X", iataCode: "D7" }, { name: "AirAsia", iataCode: "AK" }, { name: "Aircalin", iataCode: "SB" }, { name: "Alaska Airlines", iataCode: "AS" }, { name: "Alitalia", iataCode: "AZ" }, { name: "All Nippon Airways", iataCode: "NH" }, { name: "Allegiant Air", iataCode: "G4" }, { name: "American Airlines", iataCode: "AA" }, { name: "Asiana Airlines", iataCode: "OZ" }, { name: "Avianca", iataCode: "AV" }, { name: "Azul Linhas Aereas Brasileiras", iataCode: "AD" }, { name: "Azur Air", iataCode: "ZF" }, { name: "Beijing Capital Airlines", iataCode: "JD" }, { name: "Boliviana de Aviacion", iataCode: "OB" }, { name: "British Airways", iataCode: "BA" }, { name: "Cathay Pacific", iataCode: "CX" }, { name: "Cebu Pacific Air", iataCode: "5J" }, { name: "China Airlines", iataCode: "CI" }, { name: "China Eastern Airlines", iataCode: "MU" }, { name: "China Southern Airlines", iataCode: "CZ" }, { name: "Condor", iataCode: "DE" }, { name: "Copa Airlines", iataCode: "CM" }, { name: "Delta Air Lines", iataCode: "DL" }, { name: "Easyfly", iataCode: "VE" }, { name: "EasyJet", iataCode: "U2" }, { name: "EcoJet", iataCode: "8J" }, { name: "Egyptair", iataCode: "MS" }, { name: "El Al", iataCode: "LY" }, { name: "Emirates Airlines", iataCode: "EK" }, { name: "Ethiopian Airlines", iataCode: "ET" }, { name: "Etihad Airways", iataCode: "EY" }, { name: "EVA Air", iataCode: "BR" }, { name: "Fiji Airways", iataCode: "FJ" }, { name: "Finnair", iataCode: "AY" }, { name: "Flybondi", iataCode: "FO" }, { name: "Flydubai", iataCode: "FZ" }, { name: "FlySafair", iataCode: "FA" }, { name: "Frontier Airlines", iataCode: "F9" }, { name: "Garuda Indonesia", iataCode: "GA" }, { name: "Go First", iataCode: "G8" }, { name: "Gol Linhas Aereas Inteligentes", iataCode: "G3" }, { name: "Hainan Airlines", iataCode: "HU" }, { name: "Hawaiian Airlines", iataCode: "HA" }, { name: "IndiGo Airlines", iataCode: "6E" }, { name: "Japan Airlines", iataCode: "JL" }, { name: "Jeju Air", iataCode: "7C" }, { name: "Jet2", iataCode: "LS" }, { name: "JetBlue Airways", iataCode: "B6" }, { name: "JetSMART", iataCode: "JA" }, { name: "Juneyao Airlines", iataCode: "HO" }, { name: "Kenya Airways", iataCode: "KQ" }, { name: "KLM Royal Dutch Airlines", iataCode: "KL" }, { name: "Korean Air", iataCode: "KE" }, { name: "Kulula.com", iataCode: "MN" }, { name: "LATAM Airlines", iataCode: "LA" }, { name: "Lion Air", iataCode: "JT" }, { name: "LOT Polish Airlines", iataCode: "LO" }, { name: "Lufthansa", iataCode: "LH" }, { name: "Libyan Airlines", iataCode: "LN" }, { name: "Linea Aerea Amaszonas", iataCode: "Z8" }, { name: "Malaysia Airlines", iataCode: "MH" }, { name: "Nordwind Airlines", iataCode: "N4" }, { name: "Norwegian Air Shuttle", iataCode: "DY" }, { name: "Oman Air", iataCode: "WY" }, { name: "Pakistan International Airlines", iataCode: "PK" }, { name: "Pegasus Airlines", iataCode: "PC" }, { name: "Philippine Airlines", iataCode: "PR" }, { name: "Qantas Group", iataCode: "QF" }, { name: "Qatar Airways", iataCode: "QR" }, { name: "Republic Airways", iataCode: "YX" }, { name: "Royal Air Maroc", iataCode: "AT" }, { name: "Ryanair", iataCode: "FR" }, { name: "S7 Airlines", iataCode: "S7" }, { name: "SAS", iataCode: "SK" }, { name: "Satena", iataCode: "9R" }, { name: "Saudia", iataCode: "SV" }, { name: "Shandong Airlines", iataCode: "SC" }, { name: "Sichuan Airlines", iataCode: "3U" }, { name: "Singapore Airlines", iataCode: "SQ" }, { name: "Sky Airline", iataCode: "H2" }, { name: "SkyWest Airlines", iataCode: "OO" }, { name: "South African Airways", iataCode: "SA" }, { name: "Southwest Airlines", iataCode: "WN" }, { name: "SpiceJet", iataCode: "SG" }, { name: "Spirit Airlines", iataCode: "NK" }, { name: "Spring Airlines", iataCode: "9C" }, { name: "SriLankan Airlines", iataCode: "UL" }, { name: "Star Peru", iataCode: "2I" }, { name: "Sun Country Airlines", iataCode: "SY" }, { name: "SunExpress", iataCode: "XQ" }, { name: "TAP Air Portugal", iataCode: "TP" }, { name: "Thai AirAsia", iataCode: "FD" }, { name: "Thai Airways", iataCode: "TG" }, { name: "TUI Airways", iataCode: "BY" }, { name: "Tunisair", iataCode: "TU" }, { name: "Turkish Airlines", iataCode: "TK" }, { name: "Ukraine International", iataCode: "PS" }, { name: "United Airlines", iataCode: "UA" }, { name: "Ural Airlines", iataCode: "U6" }, { name: "VietJet Air", iataCode: "VJ" }, { name: "Vietnam Airlines", iataCode: "VN" }, { name: "Virgin Atlantic Airways", iataCode: "VS" }, { name: "Virgin Australia", iataCode: "VA" }, { name: "VivaAerobus", iataCode: "VB" }, { name: "VOEPASS Linhas Aereas", iataCode: "2Z" }, { name: "Volaris", iataCode: "Y4" }, { name: "WestJet", iataCode: "WS" }, { name: "Wingo", iataCode: "P5" }, { name: "Wizz Air", iataCode: "W6" }], hFe = [{ name: "Aerospatiale/BAC Concorde", iataTypeCode: "SSC" }, { name: "Airbus A300", iataTypeCode: "AB3" }, { name: "Airbus A310", iataTypeCode: "310" }, { name: "Airbus A310-200", iataTypeCode: "312" }, { name: "Airbus A310-300", iataTypeCode: "313" }, { name: "Airbus A318", iataTypeCode: "318" }, { name: "Airbus A319", iataTypeCode: "319" }, { name: "Airbus A319neo", iataTypeCode: "31N" }, { name: "Airbus A320", iataTypeCode: "320" }, { name: "Airbus A320neo", iataTypeCode: "32N" }, { name: "Airbus A321", iataTypeCode: "321" }, { name: "Airbus A321neo", iataTypeCode: "32Q" }, { name: "Airbus A330", iataTypeCode: "330" }, { name: "Airbus A330-200", iataTypeCode: "332" }, { name: "Airbus A330-300", iataTypeCode: "333" }, { name: "Airbus A330-800neo", iataTypeCode: "338" }, { name: "Airbus A330-900neo", iataTypeCode: "339" }, { name: "Airbus A340", iataTypeCode: "340" }, { name: "Airbus A340-200", iataTypeCode: "342" }, { name: "Airbus A340-300", iataTypeCode: "343" }, { name: "Airbus A340-500", iataTypeCode: "345" }, { name: "Airbus A340-600", iataTypeCode: "346" }, { name: "Airbus A350", iataTypeCode: "350" }, { name: "Airbus A350-900", iataTypeCode: "359" }, { name: "Airbus A350-1000", iataTypeCode: "351" }, { name: "Airbus A380", iataTypeCode: "380" }, { name: "Airbus A380-800", iataTypeCode: "388" }, { name: "Antonov An-12", iataTypeCode: "ANF" }, { name: "Antonov An-24", iataTypeCode: "AN4" }, { name: "Antonov An-26", iataTypeCode: "A26" }, { name: "Antonov An-28", iataTypeCode: "A28" }, { name: "Antonov An-30", iataTypeCode: "A30" }, { name: "Antonov An-32", iataTypeCode: "A32" }, { name: "Antonov An-72", iataTypeCode: "AN7" }, { name: "Antonov An-124 Ruslan", iataTypeCode: "A4F" }, { name: "Antonov An-140", iataTypeCode: "A40" }, { name: "Antonov An-148", iataTypeCode: "A81" }, { name: "Antonov An-158", iataTypeCode: "A58" }, { name: "Antonov An-225 Mriya", iataTypeCode: "A5F" }, { name: "Boeing 707", iataTypeCode: "703" }, { name: "Boeing 717", iataTypeCode: "717" }, { name: "Boeing 720B", iataTypeCode: "B72" }, { name: "Boeing 727", iataTypeCode: "727" }, { name: "Boeing 727-100", iataTypeCode: "721" }, { name: "Boeing 727-200", iataTypeCode: "722" }, { name: "Boeing 737 MAX 7", iataTypeCode: "7M7" }, { name: "Boeing 737 MAX 8", iataTypeCode: "7M8" }, { name: "Boeing 737 MAX 9", iataTypeCode: "7M9" }, { name: "Boeing 737 MAX 10", iataTypeCode: "7MJ" }, { name: "Boeing 737", iataTypeCode: "737" }, { name: "Boeing 737-100", iataTypeCode: "731" }, { name: "Boeing 737-200", iataTypeCode: "732" }, { name: "Boeing 737-300", iataTypeCode: "733" }, { name: "Boeing 737-400", iataTypeCode: "734" }, { name: "Boeing 737-500", iataTypeCode: "735" }, { name: "Boeing 737-600", iataTypeCode: "736" }, { name: "Boeing 737-700", iataTypeCode: "73G" }, { name: "Boeing 737-800", iataTypeCode: "738" }, { name: "Boeing 737-900", iataTypeCode: "739" }, { name: "Boeing 747", iataTypeCode: "747" }, { name: "Boeing 747-100", iataTypeCode: "741" }, { name: "Boeing 747-200", iataTypeCode: "742" }, { name: "Boeing 747-300", iataTypeCode: "743" }, { name: "Boeing 747-400", iataTypeCode: "744" }, { name: "Boeing 747-400D", iataTypeCode: "74J" }, { name: "Boeing 747-8", iataTypeCode: "748" }, { name: "Boeing 747SP", iataTypeCode: "74L" }, { name: "Boeing 747SR", iataTypeCode: "74R" }, { name: "Boeing 757", iataTypeCode: "757" }, { name: "Boeing 757-200", iataTypeCode: "752" }, { name: "Boeing 757-300", iataTypeCode: "753" }, { name: "Boeing 767", iataTypeCode: "767" }, { name: "Boeing 767-200", iataTypeCode: "762" }, { name: "Boeing 767-300", iataTypeCode: "763" }, { name: "Boeing 767-400", iataTypeCode: "764" }, { name: "Boeing 777", iataTypeCode: "777" }, { name: "Boeing 777-200", iataTypeCode: "772" }, { name: "Boeing 777-200LR", iataTypeCode: "77L" }, { name: "Boeing 777-300", iataTypeCode: "773" }, { name: "Boeing 777-300ER", iataTypeCode: "77W" }, { name: "Boeing 787", iataTypeCode: "787" }, { name: "Boeing 787-8", iataTypeCode: "788" }, { name: "Boeing 787-9", iataTypeCode: "789" }, { name: "Boeing 787-10", iataTypeCode: "781" }, { name: "Canadair Challenger", iataTypeCode: "CCJ" }, { name: "Canadair CL-44", iataTypeCode: "CL4" }, { name: "Canadair Regional Jet 100", iataTypeCode: "CR1" }, { name: "Canadair Regional Jet 200", iataTypeCode: "CR2" }, { name: "Canadair Regional Jet 700", iataTypeCode: "CR7" }, { name: "Canadair Regional Jet 705", iataTypeCode: "CRA" }, { name: "Canadair Regional Jet 900", iataTypeCode: "CR9" }, { name: "Canadair Regional Jet 1000", iataTypeCode: "CRK" }, { name: "De Havilland Canada DHC-2 Beaver", iataTypeCode: "DHP" }, { name: "De Havilland Canada DHC-2 Turbo-Beaver", iataTypeCode: "DHR" }, { name: "De Havilland Canada DHC-3 Otter", iataTypeCode: "DHL" }, { name: "De Havilland Canada DHC-4 Caribou", iataTypeCode: "DHC" }, { name: "De Havilland Canada DHC-6 Twin Otter", iataTypeCode: "DHT" }, { name: "De Havilland Canada DHC-7 Dash 7", iataTypeCode: "DH7" }, { name: "De Havilland Canada DHC-8-100 Dash 8 / 8Q", iataTypeCode: "DH1" }, { name: "De Havilland Canada DHC-8-200 Dash 8 / 8Q", iataTypeCode: "DH2" }, { name: "De Havilland Canada DHC-8-300 Dash 8 / 8Q", iataTypeCode: "DH3" }, { name: "De Havilland Canada DHC-8-400 Dash 8Q", iataTypeCode: "DH4" }, { name: "De Havilland DH.104 Dove", iataTypeCode: "DHD" }, { name: "De Havilland DH.114 Heron", iataTypeCode: "DHH" }, { name: "Douglas DC-3", iataTypeCode: "D3F" }, { name: "Douglas DC-6", iataTypeCode: "D6F" }, { name: "Douglas DC-8-50", iataTypeCode: "D8T" }, { name: "Douglas DC-8-62", iataTypeCode: "D8L" }, { name: "Douglas DC-8-72", iataTypeCode: "D8Q" }, { name: "Douglas DC-9-10", iataTypeCode: "D91" }, { name: "Douglas DC-9-20", iataTypeCode: "D92" }, { name: "Douglas DC-9-30", iataTypeCode: "D93" }, { name: "Douglas DC-9-40", iataTypeCode: "D94" }, { name: "Douglas DC-9-50", iataTypeCode: "D95" }, { name: "Douglas DC-10", iataTypeCode: "D10" }, { name: "Douglas DC-10-10", iataTypeCode: "D1X" }, { name: "Douglas DC-10-30", iataTypeCode: "D1Y" }, { name: "Embraer 170", iataTypeCode: "E70" }, { name: "Embraer 175", iataTypeCode: "E75" }, { name: "Embraer 190", iataTypeCode: "E90" }, { name: "Embraer 195", iataTypeCode: "E95" }, { name: "Embraer E190-E2", iataTypeCode: "290" }, { name: "Embraer E195-E2", iataTypeCode: "295" }, { name: "Embraer EMB.110 Bandeirante", iataTypeCode: "EMB" }, { name: "Embraer EMB.120 Brasilia", iataTypeCode: "EM2" }, { name: "Embraer Legacy 600", iataTypeCode: "ER3" }, { name: "Embraer Phenom 100", iataTypeCode: "EP1" }, { name: "Embraer Phenom 300", iataTypeCode: "EP3" }, { name: "Embraer RJ135", iataTypeCode: "ER3" }, { name: "Embraer RJ140", iataTypeCode: "ERD" }, { name: "Embraer RJ145 Amazon", iataTypeCode: "ER4" }, { name: "Ilyushin IL18", iataTypeCode: "IL8" }, { name: "Ilyushin IL62", iataTypeCode: "IL6" }, { name: "Ilyushin IL76", iataTypeCode: "IL7" }, { name: "Ilyushin IL86", iataTypeCode: "ILW" }, { name: "Ilyushin IL96-300", iataTypeCode: "I93" }, { name: "Ilyushin IL114", iataTypeCode: "I14" }, { name: "Lockheed L-182 / 282 / 382 (L-100) Hercules", iataTypeCode: "LOH" }, { name: "Lockheed L-188 Electra", iataTypeCode: "LOE" }, { name: "Lockheed L-1011 Tristar", iataTypeCode: "L10" }, { name: "Lockheed L-1049 Super Constellation", iataTypeCode: "L49" }, { name: "McDonnell Douglas MD11", iataTypeCode: "M11" }, { name: "McDonnell Douglas MD80", iataTypeCode: "M80" }, { name: "McDonnell Douglas MD81", iataTypeCode: "M81" }, { name: "McDonnell Douglas MD82", iataTypeCode: "M82" }, { name: "McDonnell Douglas MD83", iataTypeCode: "M83" }, { name: "McDonnell Douglas MD87", iataTypeCode: "M87" }, { name: "McDonnell Douglas MD88", iataTypeCode: "M88" }, { name: "McDonnell Douglas MD90", iataTypeCode: "M90" }, { name: "Sukhoi Superjet 100-95", iataTypeCode: "SU9" }, { name: "Tupolev Tu-134", iataTypeCode: "TU3" }, { name: "Tupolev Tu-154", iataTypeCode: "TU5" }, { name: "Tupolev Tu-204", iataTypeCode: "T20" }, { name: "Yakovlev Yak-40", iataTypeCode: "YK4" }, { name: "Yakovlev Yak-42", iataTypeCode: "YK2" }], dFe = [{ name: "Adelaide International Airport", iataCode: "ADL" }, { name: "Adolfo Suarez Madrid-Barajas Airport", iataCode: "MAD" }, { name: "Aeroparque Jorge Newbery Airport", iataCode: "AEP" }, { name: "Afonso Pena International Airport", iataCode: "CWB" }, { name: "Alfonso Bonilla Aragon International Airport", iataCode: "CLO" }, { name: "Amsterdam Airport Schiphol", iataCode: "AMS" }, { name: "Arturo Merino Benitez International Airport", iataCode: "SCL" }, { name: "Auckland International Airport", iataCode: "AKL" }, { name: "Beijing Capital International Airport", iataCode: "PEK" }, { name: "Belem Val de Cans International Airport", iataCode: "BEL" }, { name: "Belo Horizonte Tancredo Neves International Airport", iataCode: "CNF" }, { name: "Berlin-Tegel Airport", iataCode: "TXL" }, { name: "Bole International Airport", iataCode: "ADD" }, { name: "Brasilia-Presidente Juscelino Kubitschek International Airport", iataCode: "BSB" }, { name: "Brisbane International Airport", iataCode: "BNE" }, { name: "Brussels Airport", iataCode: "BRU" }, { name: "Cairns Airport", iataCode: "CNS" }, { name: "Cairo International Airport", iataCode: "CAI" }, { name: "Canberra Airport", iataCode: "CBR" }, { name: "Capetown International Airport", iataCode: "CPT" }, { name: "Charles de Gaulle International Airport", iataCode: "CDG" }, { name: "Charlotte Douglas International Airport", iataCode: "CLT" }, { name: "Chengdu Shuangliu International Airport", iataCode: "CTU" }, { name: "Chhatrapati Shivaji International Airport", iataCode: "BOM" }, { name: "Chicago O'Hare International Airport", iataCode: "ORD" }, { name: "Chongqing Jiangbei International Airport", iataCode: "CKG" }, { name: "Christchurch International Airport", iataCode: "CHC" }, { name: "Copenhagen Kastrup Airport", iataCode: "CPH" }, { name: "Dallas Fort Worth International Airport", iataCode: "DFW" }, { name: "Daniel K. Inouye International Airport", iataCode: "HNL" }, { name: "Denver International Airport", iataCode: "DEN" }, { name: "Don Mueang International Airport", iataCode: "DMK" }, { name: "Dubai International Airport", iataCode: "DXB" }, { name: "Dublin Airport", iataCode: "DUB" }, { name: "Dusseldorf Airport", iataCode: "DUS" }, { name: "El Dorado International Airport", iataCode: "BOG" }, { name: "Eleftherios Venizelos International Airport", iataCode: "ATH" }, { name: "Faa'a International Airport", iataCode: "PPT" }, { name: "Fort Lauderdale Hollywood International Airport", iataCode: "FLL" }, { name: "Fortaleza Pinto Martins International Airport", iataCode: "FOR" }, { name: "Frankfurt am Main Airport", iataCode: "FRA" }, { name: "George Bush Intercontinental Houston Airport", iataCode: "IAH" }, { name: "Gold Coast Airport", iataCode: "OOL" }, { name: "Guarulhos - Governador Andre Franco Montoro International Airport", iataCode: "GRU" }, { name: "Hartsfield-Jackson Atlanta International Airport", iataCode: "ATL" }, { name: "Helsinki Vantaa Airport", iataCode: "HEL" }, { name: "Hobart International Airport", iataCode: "HBA" }, { name: "Hong Kong International Airport", iataCode: "HKG" }, { name: "Houari Boumediene Airport", iataCode: "ALG" }, { name: "Hurgada International Airport", iataCode: "HRG" }, { name: "Incheon International Airport", iataCode: "ICN" }, { name: "Indira Gandhi International Airport", iataCode: "DEL" }, { name: "Istanbul Airport", iataCode: "IST" }, { name: "Jacksons International Airport", iataCode: "POM" }, { name: "Jeju International Airport", iataCode: "CJU" }, { name: "John F Kennedy International Airport", iataCode: "JFK" }, { name: "Jorge Chavez International Airport", iataCode: "LIM" }, { name: "Jose Maria Cordova International Airport", iataCode: "MDE" }, { name: "Josep Tarradellas Barcelona-El Prat Airport", iataCode: "BCN" }, { name: "Kahului Airport", iataCode: "OGG" }, { name: "King Abdulaziz International Airport", iataCode: "JED" }, { name: "Kuala Lumpur International Airport", iataCode: "KUL" }, { name: "Kunming Changshui International Airport", iataCode: "KMG" }, { name: "La Tontouta International Airport", iataCode: "NOU" }, { name: "Leonardo da Vinci-Fiumicino Airport", iataCode: "FCO" }, { name: "London Heathrow Airport", iataCode: "LHR" }, { name: "Los Angeles International Airport", iataCode: "LAX" }, { name: "McCarran International Airport", iataCode: "LAS" }, { name: "Melbourne International Airport", iataCode: "MEL" }, { name: "Mexico City International Airport", iataCode: "MEX" }, { name: "Miami International Airport", iataCode: "MIA" }, { name: "Ministro Pistarini International Airport", iataCode: "EZE" }, { name: "Minneapolis-St Paul International/Wold-Chamberlain Airport", iataCode: "MSP" }, { name: "Mohammed V International Airport", iataCode: "CMN" }, { name: "Moscow Domodedovo Airport", iataCode: "DME" }, { name: "Munich Airport", iataCode: "MUC" }, { name: "Murtala Muhammed International Airport", iataCode: "LOS" }, { name: "Nadi International Airport", iataCode: "NAN" }, { name: "Nairobi Jomo Kenyatta International Airport", iataCode: "NBO" }, { name: "Narita International Airport", iataCode: "NRT" }, { name: "Newark Liberty International Airport", iataCode: "EWR" }, { name: "Ninoy Aquino International Airport", iataCode: "MNL" }, { name: "Noumea Magenta Airport", iataCode: "GEA" }, { name: "O. R. Tambo International Airport", iataCode: "JNB" }, { name: "Orlando International Airport", iataCode: "MCO" }, { name: "Oslo Lufthavn", iataCode: "OSL" }, { name: "Perth Airport", iataCode: "PER" }, { name: "Phoenix Sky Harbor International Airport", iataCode: "PHX" }, { name: "Recife Guararapes-Gilberto Freyre International Airport", iataCode: "REC" }, { name: "Rio de Janeiro Galeao International Airport", iataCode: "GIG" }, { name: "Salgado Filho International Airport", iataCode: "POA" }, { name: "Salvador Deputado Luis Eduardo Magalhaes International Airport", iataCode: "SSA" }, { name: "San Francisco International Airport", iataCode: "SFO" }, { name: "Santos Dumont Airport", iataCode: "SDU" }, { name: "Sao Paulo-Congonhas Airport", iataCode: "CGH" }, { name: "Seattle Tacoma International Airport", iataCode: "SEA" }, { name: "Shanghai Hongqiao International Airport", iataCode: "SHA" }, { name: "Shanghai Pudong International Airport", iataCode: "PVG" }, { name: "Shenzhen Bao'an International Airport", iataCode: "SZX" }, { name: "Sheremetyevo International Airport", iataCode: "SVO" }, { name: "Singapore Changi Airport", iataCode: "SIN" }, { name: "Soekarno-Hatta International Airport", iataCode: "CGK" }, { name: 'Stockholm-Arlanda Airport"', iataCode: "ARN" }, { name: "Suvarnabhumi Airport", iataCode: "BKK" }, { name: "Sydney Kingsford Smith International Airport", iataCode: "SYD" }, { name: "Taiwan Taoyuan International Airport", iataCode: "TPE" }, { name: "Tan Son Nhat International Airport", iataCode: "SGN" }, { name: "Tokyo Haneda International Airport", iataCode: "HND" }, { name: "Toronto Pearson International Airport", iataCode: "YYZ" }, { name: "Tunis Carthage International Airport", iataCode: "TUN" }, { name: "Vancouver International Airport", iataCode: "YVR" }, { name: "Vienna International Airport", iataCode: "VIE" }, { name: "Viracopos International Airport", iataCode: "VCP" }, { name: "Vnukovo International Airport", iataCode: "VKO" }, { name: "Wellington International Airport", iataCode: "WLG" }, { name: "Xi'an Xianyang International Airport", iataCode: "XIY" }, { name: "Zhukovsky International Airport", iataCode: "ZIA" }, { name: "Zurich Airport", iataCode: "ZRH" }], fFe = { airline: cFe, airplane: hFe, airport: dFe }, mFe = fFe, gFe = ["American black bear", "Asian black bear", "Brown bear", "Giant panda", "Polar bear", "Sloth bear", "Spectacled bear", "Sun bear"], pFe = ["Abert's Towhee", "Acadian Flycatcher", "Acorn Woodpecker", "Alder Flycatcher", "Aleutian Tern", "Allen's Hummingbird", "Altamira Oriole", "American Avocet", "American Bittern", "American Black Duck", "American Coot", "American Crow", "American Dipper", "American Golden-Plover", "American Goldfinch", "American Kestrel", "American Oystercatcher", "American Pipit", "American Redstart", "American Robin", "American Tree Sparrow", "American White Pelican", "American Wigeon", "American Woodcock", "Ancient Murrelet", "Anhinga", "Anna's Hummingbird", "Antillean Nighthawk", "Antillean Palm Swift", "Aplomado Falcon", "Arctic Loon", "Arctic Tern", "Arctic Warbler", "Ash-throated Flycatcher", "Ashy Storm-Petrel", "Asian Brown Flycatcher", "Atlantic Puffin", "Audubon's Oriole", "Audubon's Shearwater", "Aztec Thrush", "Azure Gallinule", "Bachman's Sparrow", "Bachman's Warbler", "Bahama Mockingbird", "Bahama Swallow", "Bahama Woodstar", "Baikal Teal", "Baird's Sandpiper", "Baird's Sparrow", "Bald Eagle", "Baltimore Oriole", "Bananaquit", "Band-rumped Storm-Petrel", "Band-tailed Gull", "Band-tailed Pigeon", "Bank Swallow", "Bar-tailed Godwit", "Barn Owl", "Barn Swallow", "Barnacle Goose", "Barred Owl", "Barrow's Goldeneye", "Bay-breasted Warbler", "Bean Goose", "Bell's Vireo", "Belted Kingfisher", "Bendire's Thrasher", "Berylline Hummingbird", "Bewick's Wren", "Bicknell's Thrush", "Black Catbird", "Black Guillemot", "Black Noddy", "Black Oystercatcher", "Black Phoebe", "Black Rail", "Black Rosy-Finch", "Black Scoter", "Black Skimmer", "Black Storm-Petrel", "Black Swift", "Black Tern", "Black Turnstone", "Black Vulture", "Black-and-white Warbler", "Black-backed Wagtail", "Black-backed Woodpecker", "Black-bellied Plover", "Black-bellied Whistling-Duck", "Black-billed Cuckoo", "Black-billed Magpie", "Black-browed Albatross", "Black-capped Chickadee", "Black-capped Gnatcatcher", "Black-capped Petrel", "Black-capped Vireo", "Black-chinned Hummingbird", "Black-chinned Sparrow", "Black-crowned Night-Heron", "Black-faced Grassquit", "Black-footed Albatross", "Black-headed Grosbeak", "Black-headed Gull", "Black-legged Kittiwake", "Black-necked Stilt", "Black-tailed Gnatcatcher", "Black-tailed Godwit", "Black-tailed Gull", "Black-throated Blue Warbler", "Black-throated Gray Warbler", "Black-throated Green Warbler", "Black-throated Sparrow", "Black-vented Oriole", "Black-vented Shearwater", "Black-whiskered Vireo", "Black-winged Stilt", "Blackburnian Warbler", "Blackpoll Warbler", "Blue Bunting", "Blue Grosbeak", "Blue Grouse", "Blue Jay", "Blue Mockingbird", "Blue-footed Booby", "Blue-gray Gnatcatcher", "Blue-headed Vireo", "Blue-throated Hummingbird", "Blue-winged Teal", "Blue-winged Warbler", "Bluethroat", "Boat-tailed Grackle", "Bobolink", "Bohemian Waxwing", "Bonaparte's Gull", "Boreal Chickadee", "Boreal Owl", "Botteri's Sparrow", "Brambling", "Brandt's Cormorant", "Brant", "Brewer's Blackbird", "Brewer's Sparrow", "Bridled Tern", "Bridled Titmouse", "Bristle-thighed Curlew", "Broad-billed Hummingbird", "Broad-billed Sandpiper", "Broad-tailed Hummingbird", "Broad-winged Hawk", "Bronzed Cowbird", "Brown Booby", "Brown Creeper", "Brown Jay", "Brown Noddy", "Brown Pelican", "Brown Shrike", "Brown Thrasher", "Brown-capped Rosy-Finch", "Brown-chested Martin", "Brown-crested Flycatcher", "Brown-headed Cowbird", "Brown-headed Nuthatch", "Budgerigar", "Buff-bellied Hummingbird", "Buff-breasted Flycatcher", "Buff-breasted Sandpiper", "Buff-collared Nightjar", "Bufflehead", "Buller's Shearwater", "Bullock's Oriole", "Bumblebee Hummingbird", "Burrowing Owl", "Bushtit", "Cactus Wren", "California Condor", "California Gnatcatcher", "California Gull", "California Quail", "California Thrasher", "California Towhee", "Calliope Hummingbird", "Canada Goose", "Canada Warbler", "Canvasback", "Canyon Towhee", "Canyon Wren", "Cape May Warbler", "Caribbean Elaenia", "Carolina Chickadee", "Carolina Parakeet", "Carolina Wren", "Caspian Tern", "Cassin's Auklet", "Cassin's Finch", "Cassin's Kingbird", "Cassin's Sparrow", "Cassin's Vireo", "Cattle Egret", "Cave Swallow", "Cedar Waxwing", "Cerulean Warbler", "Chestnut-backed Chickadee", "Chestnut-collared Longspur", "Chestnut-sided Warbler", "Chihuahuan Raven", "Chimney Swift", "Chinese Egret", "Chipping Sparrow", "Chuck-will's-widow", "Chukar", "Cinnamon Hummingbird", "Cinnamon Teal", "Citrine Wagtail", "Clapper Rail", "Clark's Grebe", "Clark's Nutcracker", "Clay-colored Robin", "Clay-colored Sparrow", "Cliff Swallow", "Colima Warbler", "Collared Forest-Falcon", "Collared Plover", "Common Black-Hawk", "Common Chaffinch", "Common Crane", "Common Cuckoo", "Common Eider", "Common Goldeneye", "Common Grackle", "Common Greenshank", "Common Ground-Dove", "Common House-Martin", "Common Loon", "Common Merganser", "Common Moorhen", "Common Murre", "Common Nighthawk", "Common Pauraque", "Common Pochard", "Common Poorwill", "Common Raven", "Common Redpoll", "Common Ringed Plover", "Common Rosefinch", "Common Sandpiper", "Common Snipe", "Common Swift", "Common Tern", "Common Yellowthroat", "Connecticut Warbler", "Cook's Petrel", "Cooper's Hawk", "Cordilleran Flycatcher", "Corn Crake", "Cory's Shearwater", "Costa's Hummingbird", "Couch's Kingbird", "Crane Hawk", "Craveri's Murrelet", "Crescent-chested Warbler", "Crested Auklet", "Crested Caracara", "Crested Myna", "Crimson-collared Grosbeak", "Crissal Thrasher", "Cuban Martin", "Curlew Sandpiper", "Curve-billed Thrasher", "Dark-eyed Junco", "Dickcissel", "Double-crested Cormorant", "Double-striped Thick-knee", "Dovekie", "Downy Woodpecker", "Dunlin", "Dusky Flycatcher", "Dusky Thrush", "Dusky Warbler", "Dusky-capped Flycatcher", "Eared Grebe", "Eared Trogon", "Eastern Bluebird", "Eastern Kingbird", "Eastern Meadowlark", "Eastern Phoebe", "Eastern Screech-Owl", "Eastern Towhee", "Eastern Wood-Pewee", "Elegant Tern", "Elegant Trogon", "Elf Owl", "Emperor Goose", "Eskimo Curlew", "Eurasian Blackbird", "Eurasian Bullfinch", "Eurasian Collared-Dove", "Eurasian Coot", "Eurasian Curlew", "Eurasian Dotterel", "Eurasian Hobby", "Eurasian Jackdaw", "Eurasian Kestrel", "Eurasian Oystercatcher", "Eurasian Siskin", "Eurasian Tree Sparrow", "Eurasian Wigeon", "Eurasian Woodcock", "Eurasian Wryneck", "European Golden-Plover", "European Starling", "European Storm-Petrel", "European Turtle-Dove", "Evening Grosbeak", "Eyebrowed Thrush", "Falcated Duck", "Fan-tailed Warbler", "Far Eastern Curlew", "Ferruginous Hawk", "Ferruginous Pygmy-Owl", "Field Sparrow", "Fieldfare", "Fish Crow", "Five-striped Sparrow", "Flame-colored Tanager", "Flammulated Owl", "Flesh-footed Shearwater", "Florida Scrub-Jay", "Fork-tailed Flycatcher", "Fork-tailed Storm-Petrel", "Fork-tailed Swift", "Forster's Tern", "Fox Sparrow", "Franklin's Gull", "Fulvous Whistling-Duck", "Gadwall", "Gambel's Quail", "Garganey", "Gila Woodpecker", "Gilded Flicker", "Glaucous Gull", "Glaucous-winged Gull", "Glossy Ibis", "Golden Eagle", "Golden-cheeked Warbler", "Golden-crowned Kinglet", "Golden-crowned Sparrow", "Golden-crowned Warbler", "Golden-fronted Woodpecker", "Golden-winged Warbler", "Grace's Warbler", "Grasshopper Sparrow", "Gray Bunting", "Gray Catbird", "Gray Flycatcher", "Gray Hawk", "Gray Jay", "Gray Kingbird", "Gray Partridge", "Gray Silky-flycatcher", "Gray Vireo", "Gray Wagtail", "Gray-breasted Martin", "Gray-cheeked Thrush", "Gray-crowned Rosy-Finch", "Gray-crowned Yellowthroat", "Gray-headed Chickadee", "Gray-spotted Flycatcher", "Gray-tailed Tattler", "Great Auk", "Great Black-backed Gull", "Great Blue Heron", "Great Cormorant", "Great Crested Flycatcher", "Great Egret", "Great Frigatebird", "Great Gray Owl", "Great Horned Owl", "Great Kiskadee", "Great Knot", "Great Skua", "Great Spotted Woodpecker", "Great-tailed Grackle", "Greater Flamingo", "Greater Pewee", "Greater Prairie-chicken", "Greater Roadrunner", "Greater Scaup", "Greater Shearwater", "Greater White-fronted Goose", "Greater Yellowlegs", "Green Heron", "Green Jay", "Green Kingfisher", "Green Sandpiper", "Green Violet-ear", "Green-breasted Mango", "Green-tailed Towhee", "Green-winged Teal", "Greenish Elaenia", "Groove-billed Ani", "Gull-billed Tern", "Gyrfalcon", "Hairy Woodpecker", "Hammond's Flycatcher", "Harlequin Duck", "Harris's Hawk", "Harris's Sparrow", "Hawfinch", "Heermann's Gull", "Henslow's Sparrow", "Hepatic Tanager", "Herald Petrel", "Hermit Thrush", "Hermit Warbler", "Herring Gull", "Himalayan Snowcock", "Hoary Redpoll", "Hooded Merganser", "Hooded Oriole", "Hooded Warbler", "Hook-billed Kite", "Hoopoe", "Horned Grebe", "Horned Lark", "Horned Puffin", "House Finch", "House Sparrow", "House Wren", "Hudsonian Godwit", "Hutton's Vireo", "Iceland Gull", "Inca Dove", "Indigo Bunting", "Island Scrub-Jay", "Ivory Gull", "Ivory-billed Woodpecker", "Jabiru", "Jack Snipe", "Jungle Nightjar", "Juniper Titmouse", "Kentucky Warbler", "Key West Quail-Dove", "Killdeer", "King Eider", "King Rail", "Kirtland's Warbler", "Kittlitz's Murrelet", "La Sagra's Flycatcher", "Labrador Duck", "Ladder-backed Woodpecker", "Lanceolated Warbler", "Lapland Longspur", "Large-billed Tern", "Lark Bunting", "Lark Sparrow", "Laughing Gull", "Lawrence's Goldfinch", "Laysan Albatross", "Lazuli Bunting", "Le Conte's Sparrow", "Le Conte's Thrasher", "Leach's Storm-Petrel", "Least Auklet", "Least Bittern", "Least Flycatcher", "Least Grebe", "Least Sandpiper", "Least Storm-Petrel", "Least Tern", "Lesser Black-backed Gull", "Lesser Frigatebird", "Lesser Goldfinch", "Lesser Nighthawk", "Lesser Prairie-chicken", "Lesser Scaup", "Lesser White-fronted Goose", "Lesser Yellowlegs", "Lewis's Woodpecker", "Limpkin", "Lincoln's Sparrow", "Little Blue Heron", "Little Bunting", "Little Curlew", "Little Egret", "Little Gull", "Little Ringed Plover", "Little Shearwater", "Little Stint", "Loggerhead Kingbird", "Loggerhead Shrike", "Long-billed Curlew", "Long-billed Dowitcher", "Long-billed Murrelet", "Long-billed Thrasher", "Long-eared Owl", "Long-tailed Jaeger", "Long-toed Stint", "Louisiana Waterthrush", "Lucifer Hummingbird", "Lucy's Warbler", "MacGillivray's Warbler", "Magnificent Frigatebird", "Magnificent Hummingbird", "Magnolia Warbler", "Mallard", "Mangrove Cuckoo", "Manx Shearwater", "Marbled Godwit", "Marbled Murrelet", "Marsh Sandpiper", "Marsh Wren", "Masked Booby", "Masked Duck", "Masked Tityra", "McCown's Longspur", "McKay's Bunting", "Merlin", "Mew Gull", "Mexican Chickadee", "Mexican Jay", "Middendorff's Grasshopper-Warbler", "Mississippi Kite", "Mongolian Plover", "Monk Parakeet", "Montezuma Quail", "Mottled Duck", "Mottled Owl", "Mottled Petrel", "Mountain Bluebird", "Mountain Chickadee", "Mountain Plover", "Mountain Quail", "Mourning Dove", "Mourning Warbler", "Mugimaki Flycatcher", "Murphy's Petrel", "Muscovy Duck", "Mute Swan", "Narcissus Flycatcher", "Nashville Warbler", "Nelson's Sharp-tailed Sparrow", "Neotropic Cormorant", "Northern Beardless-Tyrannulet", "Northern Bobwhite", "Northern Cardinal", "Northern Flicker", "Northern Fulmar", "Northern Gannet", "Northern Goshawk", "Northern Harrier", "Northern Hawk Owl", "Northern Jacana", "Northern Lapwing", "Northern Mockingbird", "Northern Parula", "Northern Pintail", "Northern Pygmy-Owl", "Northern Rough-winged Swallow", "Northern Saw-whet Owl", "Northern Shoveler", "Northern Shrike", "Northern Waterthrush", "Northern Wheatear", "Northwestern Crow", "Nuttall's Woodpecker", "Nutting's Flycatcher", "Oak Titmouse", "Oldsquaw", "Olive Sparrow", "Olive Warbler", "Olive-backed Pipit", "Olive-sided Flycatcher", "Orange-crowned Warbler", "Orchard Oriole", "Oriental Cuckoo", "Oriental Greenfinch", "Oriental Pratincole", "Oriental Scops-Owl", "Oriental Turtle-Dove", "Osprey", "Ovenbird", "Pacific Golden-Plover", "Pacific Loon", "Pacific-slope Flycatcher", "Paint-billed Crake", "Painted Bunting", "Painted Redstart", "Pallas's Bunting", "Palm Warbler", "Parakeet Auklet", "Parasitic Jaeger", "Passenger Pigeon", "Pechora Pipit", "Pectoral Sandpiper", "Pelagic Cormorant", "Peregrine Falcon", "Phainopepla", "Philadelphia Vireo", "Pied-billed Grebe", "Pigeon Guillemot", "Pileated Woodpecker", "Pin-tailed Snipe", "Pine Bunting", "Pine Grosbeak", "Pine Siskin", "Pine Warbler", "Pink-footed Goose", "Pink-footed Shearwater", "Pinyon Jay", "Piping Plover", "Plain Chachalaca", "Plain-capped Starthroat", "Plumbeous Vireo", "Pomarine Jaeger", "Prairie Falcon", "Prairie Warbler", "Prothonotary Warbler", "Purple Finch", "Purple Gallinule", "Purple Martin", "Purple Sandpiper", "Pygmy Nuthatch", "Pyrrhuloxia", "Razorbill", "Red Crossbill", "Red Knot", "Red Phalarope", "Red-bellied Woodpecker", "Red-billed Pigeon", "Red-billed Tropicbird", "Red-breasted Flycatcher", "Red-breasted Merganser", "Red-breasted Nuthatch", "Red-breasted Sapsucker", "Red-cockaded Woodpecker", "Red-crowned Parrot", "Red-eyed Vireo", "Red-faced Cormorant", "Red-faced Warbler", "Red-flanked Bluetail", "Red-footed Booby", "Red-headed Woodpecker", "Red-legged Kittiwake", "Red-naped Sapsucker", "Red-necked Grebe", "Red-necked Phalarope", "Red-necked Stint", "Red-shouldered Hawk", "Red-tailed Hawk", "Red-tailed Tropicbird", "Red-throated Loon", "Red-throated Pipit", "Red-whiskered Bulbul", "Red-winged Blackbird", "Reddish Egret", "Redhead", "Redwing", "Reed Bunting", "Rhinoceros Auklet", "Ring-billed Gull", "Ring-necked Duck", "Ring-necked Pheasant", "Ringed Kingfisher", "Roadside Hawk", "Rock Dove", "Rock Ptarmigan", "Rock Sandpiper", "Rock Wren", "Rose-breasted Grosbeak", "Rose-throated Becard", "Roseate Spoonbill", "Roseate Tern", "Ross's Goose", "Ross's Gull", "Rough-legged Hawk", "Royal Tern", "Ruby-crowned Kinglet", "Ruby-throated Hummingbird", "Ruddy Duck", "Ruddy Ground-Dove", "Ruddy Quail-Dove", "Ruddy Turnstone", "Ruff", "Ruffed Grouse", "Rufous Hummingbird", "Rufous-backed Robin", "Rufous-capped Warbler", "Rufous-crowned Sparrow", "Rufous-winged Sparrow", "Rustic Bunting", "Rusty Blackbird", "Sabine's Gull", "Sage Grouse", "Sage Sparrow", "Sage Thrasher", "Saltmarsh Sharp-tailed Sparrow", "Sanderling", "Sandhill Crane", "Sandwich Tern", "Savannah Sparrow", "Say's Phoebe", "Scaled Quail", "Scaly-naped Pigeon", "Scarlet Ibis", "Scarlet Tanager", "Scissor-tailed Flycatcher", "Scott's Oriole", "Seaside Sparrow", "Sedge Wren", "Semipalmated Plover", "Semipalmated Sandpiper", "Sharp-shinned Hawk", "Sharp-tailed Grouse", "Sharp-tailed Sandpiper", "Shiny Cowbird", "Short-billed Dowitcher", "Short-eared Owl", "Short-tailed Albatross", "Short-tailed Hawk", "Short-tailed Shearwater", "Shy Albatross", "Siberian Accentor", "Siberian Blue Robin", "Siberian Flycatcher", "Siberian Rubythroat", "Sky Lark", "Slate-throated Redstart", "Slaty-backed Gull", "Slender-billed Curlew", "Smew", "Smith's Longspur", "Smooth-billed Ani", "Snail Kite", "Snow Bunting", "Snow Goose", "Snowy Egret", "Snowy Owl", "Snowy Plover", "Solitary Sandpiper", "Song Sparrow", "Sooty Shearwater", "Sooty Tern", "Sora", "South Polar Skua", "Southern Martin", "Spectacled Eider", "Spoonbill Sandpiper", "Spot-billed Duck", "Spot-breasted Oriole", "Spotted Dove", "Spotted Owl", "Spotted Rail", "Spotted Redshank", "Spotted Sandpiper", "Spotted Towhee", "Sprague's Pipit", "Spruce Grouse", "Stejneger's Petrel", "Steller's Eider", "Steller's Jay", "Steller's Sea-Eagle", "Stilt Sandpiper", "Stonechat", "Streak-backed Oriole", "Streaked Shearwater", "Strickland's Woodpecker", "Stripe-headed Tanager", "Sulphur-bellied Flycatcher", "Summer Tanager", "Surf Scoter", "Surfbird", "Swainson's Hawk", "Swainson's Thrush", "Swainson's Warbler", "Swallow-tailed Kite", "Swamp Sparrow", "Tamaulipas Crow", "Tawny-shouldered Blackbird", "Temminck's Stint", "Tennessee Warbler", "Terek Sandpiper", "Thayer's Gull", "Thick-billed Kingbird", "Thick-billed Murre", "Thick-billed Parrot", "Thick-billed Vireo", "Three-toed Woodpecker", "Townsend's Solitaire", "Townsend's Warbler", "Tree Pipit", "Tree Swallow", "Tricolored Blackbird", "Tricolored Heron", "Tropical Kingbird", "Tropical Parula", "Trumpeter Swan", "Tufted Duck", "Tufted Flycatcher", "Tufted Puffin", "Tufted Titmouse", "Tundra Swan", "Turkey Vulture", "Upland Sandpiper", "Varied Bunting", "Varied Thrush", "Variegated Flycatcher", "Vaux's Swift", "Veery", "Verdin", "Vermilion Flycatcher", "Vesper Sparrow", "Violet-crowned Hummingbird", "Violet-green Swallow", "Virginia Rail", "Virginia's Warbler", "Wandering Albatross", "Wandering Tattler", "Warbling Vireo", "Wedge-rumped Storm-Petrel", "Wedge-tailed Shearwater", "Western Bluebird", "Western Grebe", "Western Gull", "Western Kingbird", "Western Meadowlark", "Western Reef-Heron", "Western Sandpiper", "Western Screech-Owl", "Western Scrub-Jay", "Western Tanager", "Western Wood-Pewee", "Whimbrel", "Whip-poor-will", "Whiskered Auklet", "Whiskered Screech-Owl", "Whiskered Tern", "White Ibis", "White Wagtail", "White-breasted Nuthatch", "White-cheeked Pintail", "White-chinned Petrel", "White-collared Seedeater", "White-collared Swift", "White-crowned Pigeon", "White-crowned Sparrow", "White-eared Hummingbird", "White-eyed Vireo", "White-faced Ibis", "White-faced Storm-Petrel", "White-headed Woodpecker", "White-rumped Sandpiper", "White-tailed Eagle", "White-tailed Hawk", "White-tailed Kite", "White-tailed Ptarmigan", "White-tailed Tropicbird", "White-throated Needletail", "White-throated Robin", "White-throated Sparrow", "White-throated Swift", "White-tipped Dove", "White-winged Crossbill", "White-winged Dove", "White-winged Parakeet", "White-winged Scoter", "White-winged Tern", "Whooper Swan", "Whooping Crane", "Wild Turkey", "Willet", "Williamson's Sapsucker", "Willow Flycatcher", "Willow Ptarmigan", "Wilson's Phalarope", "Wilson's Plover", "Wilson's Storm-Petrel", "Wilson's Warbler", "Winter Wren", "Wood Duck", "Wood Sandpiper", "Wood Stork", "Wood Thrush", "Wood Warbler", "Worm-eating Warbler", "Worthen's Sparrow", "Wrentit", "Xantus's Hummingbird", "Xantus's Murrelet", "Yellow Bittern", "Yellow Grosbeak", "Yellow Rail", "Yellow Wagtail", "Yellow Warbler", "Yellow-bellied Flycatcher", "Yellow-bellied Sapsucker", "Yellow-billed Cuckoo", "Yellow-billed Loon", "Yellow-billed Magpie", "Yellow-breasted Bunting", "Yellow-breasted Chat", "Yellow-crowned Night-Heron", "Yellow-eyed Junco", "Yellow-faced Grassquit", "Yellow-footed Gull", "Yellow-green Vireo", "Yellow-headed Blackbird", "Yellow-legged Gull", "Yellow-nosed Albatross", "Yellow-rumped Warbler", "Yellow-throated Vireo", "Yellow-throated Warbler", "Yucatan Vireo", "Zenaida Dove", "Zone-tailed Hawk"], bFe = ["Abyssinian", "American Bobtail", "American Curl", "American Shorthair", "American Wirehair", "Balinese", "Bengal", "Birman", "Bombay", "British Shorthair", "Burmese", "Chartreux", "Chausie", "Cornish Rex", "Devon Rex", "Donskoy", "Egyptian Mau", "Exotic Shorthair", "Havana", "Highlander", "Himalayan", "Japanese Bobtail", "Korat", "Kurilian Bobtail", "LaPerm", "Maine Coon", "Manx", "Minskin", "Munchkin", "Nebelung", "Norwegian Forest Cat", "Ocicat", "Ojos Azules", "Oriental", "Persian", "Peterbald", "Pixiebob", "Ragdoll", "Russian Blue", "Savannah", "Scottish Fold", "Selkirk Rex", "Serengeti", "Siamese", "Siberian", "Singapura", "Snowshoe", "Sokoke", "Somali", "Sphynx", "Thai", "Tonkinese", "Toyger", "Turkish Angora", "Turkish Van"], yFe = ["Amazon River Dolphin", "Arnoux's Beaked Whale", "Atlantic Humpbacked Dolphin", "Atlantic Spotted Dolphin", "Atlantic White-Sided Dolphin", "Australian Snubfin Dolphin", "Australian humpback Dolphin", "Blue Whale", "Bottlenose Dolphin", "Bryde’s whale", "Burrunan Dolphin", "Chilean Dolphin", "Chinese River Dolphin", "Chinese White Dolphin", "Clymene Dolphin", "Commerson’s Dolphin", "Costero", "Dusky Dolphin", "False Killer Whale", "Fin Whale", "Fraser’s Dolphin", "Ganges River Dolphin", "Guiana Dolphin", "Heaviside’s Dolphin", "Hector’s Dolphin", "Hourglass Dolphin", "Humpback whale", "Indo-Pacific Bottlenose Dolphin", "Indo-Pacific Hump-backed Dolphin", "Irrawaddy Dolphin", "Killer Whale (Orca)", "La Plata Dolphin", "Long-Beaked Common Dolphin", "Long-finned Pilot Whale", "Longman's Beaked Whale", "Melon-headed Whale", "Northern Rightwhale Dolphin", "Omura’s whale", "Pacific White-Sided Dolphin", "Pantropical Spotted Dolphin", "Peale’s Dolphin", "Pygmy Killer Whale", "Risso’s Dolphin", "Rough-Toothed Dolphin", "Sei Whale", "Short-Beaked Common Dolphin", "Short-finned Pilot Whale", "Southern Bottlenose Whale", "Southern Rightwhale Dolphin", "Sperm Whale", "Spinner Dolphin", "Striped Dolphin", "Tucuxi", "White-Beaked Dolphin"], AFe = ["Aberdeen Angus", "Abergele", "Abigar", "Abondance", "Abyssinian Shorthorned Zebu", "Aceh", "Achham", "Adamawa", "Adaptaur", "Afar", "Africangus", "Afrikaner", "Agerolese", "Alambadi", "Alatau", "Albanian", "Albera", "Alderney", "Alentejana", "Aleutian wild cattle", "Aliad Dinka", "Alistana-Sanabresa", "Allmogekor", "Alur", "American", "American Angus", "American Beef Friesian", "American Brown Swiss", "American Milking Devon", "American White Park", "Amerifax", "Amrit Mahal", "Amsterdam Island cattle", "Anatolian Black", "Andalusian Black", "Andalusian Blond", "Andalusian Grey", "Angeln", "Angoni", "Ankina", "Ankole", "Ankole-Watusi", "Aracena", "Arado", "Argentine Criollo", "Argentine Friesian", "Armorican", "Arouquesa", "Arsi", "Asturian Mountain", "Asturian Valley", "Aubrac", "Aulie-Ata", "Aure et Saint-Girons", "Australian Braford", "Australian Brangus", "Australian Charbray", "Australian Friesian Sahiwal", "Australian Lowline", "Australian Milking Zebu", "Australian Shorthorn", "Austrian Simmental", "Austrian Yellow", "Avileña-Negra Ibérica", "Avétonou", "Aweil Dinka", "Ayrshire", "Azaouak", "Azebuado", "Azerbaijan Zebu", "Azores", "Bachaur cattle", "Baherie cattle", "Bakosi cattle", "Balancer", "Baoule", "Bargur cattle", "Barrosã", "Barzona", "Bazadaise", "Beef Freisian", "Beefalo", "Beefmaker", "Beefmaster", "Begayt", "Belgian Blue", "Belgian Red", "Belgian Red Pied", "Belgian White-and-Red", "Belmont Red", "Belted Galloway", "Bernese", "Berrenda cattle", "Betizu", "Bianca Modenese", "Blaarkop", "Black Angus", "Black Baldy", "Black Hereford", "Blanca Cacereña", "Blanco Orejinegro BON", "Blonde d'Aquitaine", "Blue Albion", "Blue Grey", "Bohuskulla", "Bonsmara", "Boran", "Boškarin", "Braford", "Brahman", "Brahmousin", "Brangus", "Braunvieh", "Brava", "Breed", "British Friesian", "British White", "Brown Carpathian", "Brown Caucasian", "Brown Swiss", "Bue Lingo", "Burlina", "Bushuyev", "Butana cattle", "Buša cattle", "Cachena", "Caldelana", "Camargue", "Campbell Island cattle", "Canadian Speckle Park", "Canadienne", "Canaria", "Canchim", "Caracu", "Carinthian Blondvieh", "Carora", "Charbray", "Charolais", "Chateaubriand", "Chiangus", "Chianina", "Chillingham cattle", "Chinese Black Pied", "Cholistani", "Coloursided White Back", "Commercial", "Corriente", "Corsican cattle", "Costeño con Cuernos", "Crioulo Lageano", "Cárdena Andaluza", "Dajal", "Dangi cattle", "Danish Black-Pied", "Danish Jersey", "Danish Red", "Deep Red cattle", "Deoni", "Devon", "Dexter cattle", "Dhanni", "Doayo cattle", "Doela", "Drakensberger", "Droughtmaster", "Dulong'", "Dutch Belted", "Dutch Friesian", "Dwarf Lulu", "Dølafe", "East Anatolian Red", "Eastern Finncattle", "Eastern Red Polled", "Enderby Island cattle", "English Longhorn", "Ennstaler Bergscheck", "Estonian Holstein", "Estonian Native", "Estonian Red cattle", "Finncattle", "Finnish Ayrshire", "Finnish Holstein-Friesian", "Fjäll", "Fleckvieh", "Florida Cracker cattle", "Fogera", "French Simmental", "Fribourgeoise", "Friesian Red and White", "Fulani Sudanese", "Fēng Cattle", "Galician Blond", "Galloway cattle", "Gangatiri", "Gaolao", "Garvonesa", "Gascon cattle", "Gelbvieh", "Georgian Mountain cattle", "German Angus", "German Black Pied Dairy", "German Black Pied cattle", "German Red Pied", "Gir", "Glan cattle", "Gloucester", "Gobra", "Greek Shorthorn", "Greek Steppe", "Greyman cattle", "Gudali", "Guernsey cattle", "Guzerá", "Hallikar4", "Hanwoo", "Hariana cattle", "Hartón del Valle", "Harzer Rotvieh", "Hays Converter", "Heck cattle", "Hereford", "Herens", "Highland cattle", "Hinterwald", "Holando-Argentino", "Holstein Friesian cattle", "Horro", "Hungarian Grey", "Huáng Cattle", "Hybridmaster", "Iberian cattle", "Icelandic", "Illawarra cattle", "Improved Red and White", "Indo-Brazilian", "Irish Moiled", "Israeli Holstein", "Israeli Red", "Istoben cattle", "Istrian cattle", "Jamaica Black", "Jamaica Hope", "Jamaica Red", "Japanese Brown", "Jarmelista", "Javari cattle", "Jersey cattle", "Jutland cattle", "Kabin Buri cattle", "Kalmyk cattle", "Kamphaeng Saen cattle", "Kangayam", "Kankrej", "Karan Swiss", "Kasaragod Dwarf cattle", "Kathiawadi", "Kazakh Whiteheaded", "Kenana cattle", "Kenkatha cattle", "Kerry cattle", "Kherigarh", "Khillari cattle", "Kholomogory", "Korat Wagyu", "Kostroma cattle", "Krishna Valley cattle", "Kurgan cattle", "Kuri", "La Reina cattle", "Lakenvelder cattle", "Lampurger", "Latvian Blue", "Latvian Brown", "Latvian Danish Red", "Lebedyn", "Levantina", "Limia cattle", "Limousin", "Limpurger", "Lincoln Red", "Lineback", "Lithuanian Black-and-White", "Lithuanian Light Grey", "Lithuanian Red", "Lithuanian White-Backed", "Lohani cattle", "Lourdais", "Lucerna cattle", "Luing", "Madagascar Zebu", "Madura", "Maine-Anjou", "Malnad Gidda", "Malvi", "Mandalong Special", "Mantequera Leonesa", "Maramureş Brown", "Marchigiana", "Maremmana", "Marinhoa", "Maronesa", "Masai", "Mashona", "Menorquina", "Mertolenga", "Meuse-Rhine-Issel", "Mewati", "Milking Shorthorn", "Minhota", "Mirandesa", "Mirkadim", "Mocăniţă", "Mollie", "Monchina", "Mongolian", "Montbéliarde", "Morucha", "Murboden", "Murnau-Werdenfels", "Murray Grey", "Muturu", "N'Dama", "Nagori", "Negra Andaluza", "Nelore", "Nguni", "Nimari", "Normande", "North Bengal Grey", "Northern Finncattle", "Northern Shorthorn", "Norwegian Red", "Ongole", "Original Simmental", "Pajuna", "Palmera", "Pantaneiro", "Parda Alpina", "Parthenaise", "Pasiega", "Pembroke", "Philippine Native", "Pie Rouge des Plaines", "Piedmontese cattle", "Pineywoods", "Pinzgauer", "Pirenaica", "Podolac", "Podolica", "Polish Black-and-White", "Polish Red", "Poll Shorthorn", "Polled Hereford", "Polled Shorthorn", "Ponwar", "Preta", "Pulikulam", "Punganur", "Pustertaler Sprinzen", "Qinchaun", "Queensland Miniature Boran", "RX3", "Ramo Grande", "Randall", "Raramuri Criollo", "Rathi", "Raya", "Red Angus", "Red Brangus", "Red Chittagong", "Red Fulani", "Red Gorbatov", "Red Holstein", "Red Kandhari", "Red Mingrelian", "Red Poll", "Red Polled Østland", "Red Sindhi", "Retinta", "Riggit Galloway", "Ringamåla", "Rohjan", "Romagnola", "Romanian Bălţata", "Romanian Steppe Gray", "Romosinuano", "Russian Black Pied", "Rätisches Grauvieh", "Sahiwal", "Salers", "Salorn", "Sanga", "Sanhe", "Santa Cruz", "Santa Gertrudis", "Sayaguesa", "Schwyz", "Selembu", "Senepol", "Serbian Pied", "Serbian Steppe", "Sheko", "Shetland", "Shorthorn", "Siboney de Cuba", "Simbrah", "Simford", "Simmental", "Siri", "South Devon", "Spanish Fighting Bull", "Speckle Park", "Square Meater", "Sussex", "Swedish Friesian", "Swedish Polled", "Swedish Red Pied", "Swedish Red Polled", "Swedish Red-and-White", "Tabapuã", "Tarentaise", "Tasmanian Grey", "Tauros", "Telemark", "Texas Longhorn", "Texon", "Thai Black", "Thai Fighting Bull", "Thai Friesian", "Thai Milking Zebu", "Tharparkar", "Tswana", "Tudanca", "Tuli", "Tulim", "Turkish Grey Steppe", "Tux-Zillertal", "Tyrol Grey", "Ukrainian Grey", "Umblachery", "Valdostana Castana", "Valdostana Pezzata Nera", "Valdostana Pezzata Rossa", "Vaynol", "Vechur8", "Vestland Fjord", "Vestland Red Polled", "Vianesa", "Volinian Beef", "Vorderwald", "Vosgienne", "Väneko", "Waguli", "Wagyu", "Wangus", "Welsh Black", "Western Finncattle", "White Cáceres", "White Fulani", "White Lamphun", "White Park", "Whitebred Shorthorn", "Xingjiang Brown", "Yakutian", "Yanbian", "Yanhuang", "Yurino", "Zebu", "Évolène cattle", "Żubroń"], EFe = ["African Slender-snouted Crocodile", "Alligator mississippiensis", "American Crocodile", "Australian Freshwater Crocodile", "Black Caiman", "Broad-snouted Caiman", "Chinese Alligator", "Cuban Crocodile", "Cuvier’s Dwarf Caiman", "Dwarf Crocodile", "Gharial", "Morelet’s Crocodile", "Mugger Crocodile", "New Guinea Freshwater Crocodile", "Nile Crocodile", "Orinoco Crocodile", "Philippine Crocodile", "Saltwater Crocodile", "Schneider’s Smooth-fronted Caiman", "Siamese Crocodile", "Spectacled Caiman", "Tomistoma", "West African Crocodile", "Yacare Caiman"], SFe = ["Affenpinscher", "Afghan Hound", "Aidi", "Airedale Terrier", "Akbash", "Akita", "Alano Español", "Alapaha Blue Blood Bulldog", "Alaskan Husky", "Alaskan Klee Kai", "Alaskan Malamute", "Alopekis", "Alpine Dachsbracke", "American Bulldog", "American Bully", "American Cocker Spaniel", "American English Coonhound", "American Foxhound", "American Hairless Terrier", "American Pit Bull Terrier", "American Staffordshire Terrier", "American Water Spaniel", "Andalusian Hound", "Anglo-Français de Petite Vénerie", "Appenzeller Sennenhund", "Ariegeois", "Armant", "Armenian Gampr dog", "Artois Hound", "Australian Cattle Dog", "Australian Kelpie", "Australian Shepherd", "Australian Stumpy Tail Cattle Dog", "Australian Terrier", "Austrian Black and Tan Hound", "Austrian Pinscher", "Azawakh", "Bakharwal dog", "Banjara Hound", "Barbado da Terceira", "Barbet", "Basenji", "Basque Shepherd Dog", "Basset Artésien Normand", "Basset Bleu de Gascogne", "Basset Fauve de Bretagne", "Basset Hound", "Bavarian Mountain Hound", "Beagle", "Beagle-Harrier", "Bearded Collie", "Beauceron", "Bedlington Terrier", "Belgian Shepherd", "Bergamasco Shepherd", "Berger Picard", "Bernese Mountain Dog", "Bhotia", "Bichon Frisé", "Billy", "Black Mouth Cur", "Black Norwegian Elkhound", "Black Russian Terrier", "Black and Tan Coonhound", "Bloodhound", "Blue Lacy", "Blue Picardy Spaniel", "Bluetick Coonhound", "Boerboel", "Bohemian Shepherd", "Bolognese", "Border Collie", "Border Terrier", "Borzoi", "Bosnian Coarse-haired Hound", "Boston Terrier", "Bouvier des Ardennes", "Bouvier des Flandres", "Boxer", "Boykin Spaniel", "Bracco Italiano", "Braque Francais", "Braque Saint-Germain", "Braque d'Auvergne", "Braque de l'Ariège", "Braque du Bourbonnais", "Briard", "Briquet Griffon Vendéen", "Brittany", "Broholmer", "Bruno Jura Hound", "Brussels Griffon", "Bucovina Shepherd Dog", "Bull Arab", "Bull Terrier", "Bulldog", "Bullmastiff", "Bully Kutta", "Burgos Pointer", "Cairn Terrier", "Campeiro Bulldog", "Can de Chira", "Canaan Dog", "Canadian Eskimo Dog", "Cane Corso", "Cane Paratore", "Cane di Oropa", "Cantabrian Water Dog", "Cardigan Welsh Corgi", "Carea Castellano Manchego", "Carolina Dog", "Carpathian Shepherd Dog", "Catahoula Leopard Dog", "Catalan Sheepdog", "Caucasian Shepherd Dog", "Cavalier King Charles Spaniel", "Central Asian Shepherd Dog", "Cesky Fousek", "Cesky Terrier", "Chesapeake Bay Retriever", "Chien Français Blanc et Noir", "Chien Français Blanc et Orange", "Chien Français Tricolore", "Chihuahua", "Chilean Terrier", "Chinese Chongqing Dog", "Chinese Crested Dog", "Chinook", "Chippiparai", "Chongqing dog", "Chortai", "Chow Chow", "Cimarrón Uruguayo", "Cirneco dell'Etna", "Clumber Spaniel", "Colombian fino hound", "Coton de Tulear", "Cretan Hound", "Croatian Sheepdog", "Curly-Coated Retriever", "Cursinu", "Czechoslovakian Wolfdog", "Cão Fila de São Miguel", "Cão da Serra de Aires", "Cão de Castro Laboreiro", "Cão de Gado Transmontano", "Dachshund", "Dalmatian", "Dandie Dinmont Terrier", "Danish-Swedish Farmdog", "Denmark Feist", "Dingo", "Doberman Pinscher", "Dogo Argentino", "Dogo Guatemalteco", "Dogo Sardesco", "Dogue Brasileiro", "Dogue de Bordeaux", "Drentse Patrijshond", "Drever", "Dunker", "Dutch Shepherd", "Dutch Smoushond", "East European Shepherd", "East Siberian Laika", "English Cocker Spaniel", "English Foxhound", "English Mastiff", "English Setter", "English Shepherd", "English Springer Spaniel", "English Toy Terrier", "Entlebucher Mountain Dog", "Estonian Hound", "Estrela Mountain Dog", "Eurasier", "Field Spaniel", "Fila Brasileiro", "Finnish Hound", "Finnish Lapphund", "Finnish Spitz", "Flat-Coated Retriever", "French Bulldog", "French Spaniel", "Galgo Español", "Galician Shepherd Dog", "Garafian Shepherd", "Gascon Saintongeois", "Georgian Shepherd", "German Hound", "German Longhaired Pointer", "German Pinscher", "German Roughhaired Pointer", "German Shepherd Dog", "German Shorthaired Pointer", "German Spaniel", "German Spitz", "German Wirehaired Pointer", "Giant Schnauzer", "Glen of Imaal Terrier", "Golden Retriever", "Gordon Setter", "Gończy Polski", "Grand Anglo-Français Blanc et Noir", "Grand Anglo-Français Blanc et Orange", "Grand Anglo-Français Tricolore", "Grand Basset Griffon Vendéen", "Grand Bleu de Gascogne", "Grand Griffon Vendéen", "Great Dane", "Greater Swiss Mountain Dog", "Greek Harehound", "Greek Shepherd", "Greenland Dog", "Greyhound", "Griffon Bleu de Gascogne", "Griffon Fauve de Bretagne", "Griffon Nivernais", "Gull Dong", "Gull Terrier", "Hamiltonstövare", "Hanover Hound", "Harrier", "Havanese", "Hierran Wolfdog", "Hokkaido", "Hovawart", "Huntaway", "Hygen Hound", "Hällefors Elkhound", "Ibizan Hound", "Icelandic Sheepdog", "Indian Spitz", "Indian pariah dog", "Irish Red and White Setter", "Irish Setter", "Irish Terrier", "Irish Water Spaniel", "Irish Wolfhound", "Istrian Coarse-haired Hound", "Istrian Shorthaired Hound", "Italian Greyhound", "Jack Russell Terrier", "Jagdterrier", "Japanese Chin", "Japanese Spitz", "Japanese Terrier", "Jindo", "Jonangi", "Kai Ken", "Kaikadi", "Kangal Shepherd Dog", "Kanni", "Karakachan dog", "Karelian Bear Dog", "Kars", "Karst Shepherd", "Keeshond", "Kerry Beagle", "Kerry Blue Terrier", "King Charles Spaniel", "King Shepherd", "Kintamani", "Kishu", "Kokoni", "Kombai", "Komondor", "Kooikerhondje", "Koolie", "Koyun dog", "Kromfohrländer", "Kuchi", "Kuvasz", "Labrador Retriever", "Lagotto Romagnolo", "Lakeland Terrier", "Lancashire Heeler", "Landseer", "Lapponian Herder", "Large Münsterländer", "Leonberger", "Levriero Sardo", "Lhasa Apso", "Lithuanian Hound", "Lupo Italiano", "Löwchen", "Mackenzie River Husky", "Magyar agár", "Mahratta Greyhound", "Maltese", "Manchester Terrier", "Maremmano-Abruzzese Sheepdog", "McNab dog", "Miniature American Shepherd", "Miniature Bull Terrier", "Miniature Fox Terrier", "Miniature Pinscher", "Miniature Schnauzer", "Molossus of Epirus", "Montenegrin Mountain Hound", "Mountain Cur", "Mountain Feist", "Mucuchies", "Mudhol Hound", "Mudi", "Neapolitan Mastiff", "New Guinea Singing Dog", "New Zealand Heading Dog", "Newfoundland", "Norfolk Terrier", "Norrbottenspets", "Northern Inuit Dog", "Norwegian Buhund", "Norwegian Elkhound", "Norwegian Lundehund", "Norwich Terrier", "Nova Scotia Duck Tolling Retriever", "Old Croatian Sighthound", "Old Danish Pointer", "Old English Sheepdog", "Old English Terrier", "Olde English Bulldogge", "Otterhound", "Pachon Navarro", "Paisley Terrier", "Pampas Deerhound", "Papillon", "Parson Russell Terrier", "Pastore della Lessinia e del Lagorai", "Patagonian Sheepdog", "Patterdale Terrier", "Pekingese", "Pembroke Welsh Corgi", "Perro Majorero", "Perro de Pastor Mallorquin", "Perro de Presa Canario", "Perro de Presa Mallorquin", "Peruvian Inca Orchid", "Petit Basset Griffon Vendéen", "Petit Bleu de Gascogne", "Phalène", "Pharaoh Hound", "Phu Quoc Ridgeback", "Picardy Spaniel", "Plott Hound", "Plummer Terrier", "Podenco Canario", "Podenco Valenciano", "Pointer", "Poitevin", "Polish Greyhound", "Polish Hound", "Polish Lowland Sheepdog", "Polish Tatra Sheepdog", "Pomeranian", "Pont-Audemer Spaniel", "Poodle", "Porcelaine", "Portuguese Podengo", "Portuguese Pointer", "Portuguese Water Dog", "Posavac Hound", "Pražský Krysařík", "Pshdar Dog", "Pudelpointer", "Pug", "Puli", "Pumi", "Pungsan Dog", "Pyrenean Mastiff", "Pyrenean Mountain Dog", "Pyrenean Sheepdog", "Rafeiro do Alentejo", "Rajapalayam", "Rampur Greyhound", "Rat Terrier", "Ratonero Bodeguero Andaluz", "Ratonero Mallorquin", "Ratonero Murciano de Huerta", "Ratonero Valenciano", "Redbone Coonhound", "Rhodesian Ridgeback", "Romanian Mioritic Shepherd Dog", "Romanian Raven Shepherd Dog", "Rottweiler", "Rough Collie", "Russian Spaniel", "Russian Toy", "Russo-European Laika", "Saarloos Wolfdog", "Sabueso Español", "Saint Bernard", "Saint Hubert Jura Hound", "Saint-Usuge Spaniel", "Saluki", "Samoyed", "Sapsali", "Sarabi dog", "Sardinian Shepherd Dog", "Schapendoes", "Schillerstövare", "Schipperke", "Schweizer Laufhund", "Schweizerischer Niederlaufhund", "Scottish Deerhound", "Scottish Terrier", "Sealyham Terrier", "Segugio Italiano", "Segugio Maremmano", "Segugio dell'Appennino", "Seppala Siberian Sleddog", "Serbian Hound", "Serbian Tricolour Hound", "Serrano Bulldog", "Shar Pei", "Shetland Sheepdog", "Shiba Inu", "Shih Tzu", "Shikoku", "Shiloh Shepherd", "Siberian Husky", "Silken Windhound", "Silky Terrier", "Sinhala Hound", "Skye Terrier", "Sloughi", "Slovakian Wirehaired Pointer", "Slovenský Cuvac", "Slovenský Kopov", "Smalandstövare", "Small Greek domestic dog", "Small Münsterländer", "Smooth Collie", "Smooth Fox Terrier", "Soft-Coated Wheaten Terrier", "South Russian Ovcharka", "Spanish Mastiff", "Spanish Water Dog", "Spinone Italiano", "Sporting Lucas Terrier", "Stabyhoun", "Staffordshire Bull Terrier", "Standard Schnauzer", "Stephens Stock", "Styrian Coarse-haired Hound", "Sussex Spaniel", "Swedish Elkhound", "Swedish Lapphund", "Swedish Vallhund", "Swedish White Elkhound", "Taigan", "Taiwan Dog", "Tamaskan Dog", "Teddy Roosevelt Terrier", "Telomian", "Tenterfield Terrier", "Terrier Brasileiro", "Thai Bangkaew Dog", "Thai Ridgeback", "Tibetan Mastiff", "Tibetan Spaniel", "Tibetan Terrier", "Tornjak", "Tosa", "Toy Fox Terrier", "Toy Manchester Terrier", "Transylvanian Hound", "Treeing Cur", "Treeing Feist", "Treeing Tennessee Brindle", "Treeing Walker Coonhound", "Trigg Hound", "Tyrolean Hound", "Vikhan", "Villano de Las Encartaciones", "Villanuco de Las Encartaciones", "Vizsla", "Volpino Italiano", "Weimaraner", "Welsh Sheepdog", "Welsh Springer Spaniel", "Welsh Terrier", "West Highland White Terrier", "West Siberian Laika", "Westphalian Dachsbracke", "Wetterhoun", "Whippet", "White Shepherd", "White Swiss Shepherd Dog", "Wire Fox Terrier", "Wirehaired Pointing Griffon", "Wirehaired Vizsla", "Xiasi Dog", "Xoloitzcuintli", "Yakutian Laika", "Yorkshire Terrier", "Šarplaninac"], wFe = ["Alaska pollock", "Albacore", "Amur catfish", "Araucanian herring", "Argentine hake", "Asari", "Asian swamp eel", "Atlantic cod", "Atlantic herring", "Atlantic horse mackerel", "Atlantic mackerel", "Atlantic menhaden", "Atlantic salmon", "Bigeye scad", "Bigeye tuna", "Bighead carp", "Black carp", "Blood cockle", "Blue swimming crab", "Blue whiting", "Bombay-duck", "Bonga shad", "California pilchard", "Cape horse mackerel", "Capelin", "Catla", "Channel catfish", "Chilean jack mackerel", "Chinese perch", "Chinese softshell turtle", "Chub mackerel", "Chum salmon", "Common carp", "Crucian carp", "Daggertooth pike conger", "European anchovy", "European pilchard", "European sprat", "Filipino Venus", "Gazami crab", "Goldstripe sardinella", "Grass carp", "Gulf menhaden", "Haddock", "Hilsa shad", "Indian mackerel", "Indian oil sardine", "Iridescent shark", "Japanese anchovy", "Japanese cockle", "Japanese common catfish", "Japanese flying squid", "Japanese jack mackerel", "Japanese littleneck", "Japanese pilchard", "Jumbo flying squid", "Kawakawa", "Korean bullhead", "Largehead hairtail", "Longtail tuna", "Madeiran sardinella", "Mandarin fish", "Milkfish", "Mrigal carp", "Narrow-barred Spanish mackerel", "Nile perch", "Nile tilapia", "North Pacific hake", "Northern snakehead", "Pacific anchoveta", "Pacific cod", "Pacific herring", "Pacific sand lance", "Pacific sandlance", "Pacific saury", "Pacific thread herring", "Peruvian anchoveta", "Pink salmon", "Pollock", "Pond loach", "Rainbow trout", "Rohu", "Round sardinella", "Short mackerel", "Silver carp", "Silver cyprinid", "Skipjack tuna", "Southern African anchovy", "Southern rough shrimp", "Whiteleg shrimp", "Wuchang bream", "Yellow croaker", "Yellowfin tuna", "Yellowhead catfish", "Yellowstripe scad"], FFe = ["Abaco Barb", "Abtenauer", "Abyssinian", "Aegidienberger", "Akhal-Teke", "Albanian Horse", "Altai Horse", "Altèr Real", "American Albino", "American Cream Draft", "American Indian Horse", "American Paint Horse", "American Quarter Horse", "American Saddlebred", "American Warmblood", "Andalusian Horse", "Andravida Horse", "Anglo-Arabian", "Anglo-Arabo-Sardo", "Anglo-Kabarda", "Appaloosa", "AraAppaloosa", "Arabian Horse", "Ardennes Horse", "Arenberg-Nordkirchen", "Argentine Criollo", "Asian wild Horse", "Assateague Horse", "Asturcón", "Augeron", "Australian Brumby", "Australian Draught Horse", "Australian Stock Horse", "Austrian Warmblood", "Auvergne Horse", "Auxois", "Azerbaijan Horse", "Azteca Horse", "Baise Horse", "Bale", "Balearic Horse", "Balikun Horse", "Baluchi Horse", "Banker Horse", "Barb Horse", "Bardigiano", "Bashkir Curly", "Basque Mountain Horse", "Bavarian Warmblood", "Belgian Half-blood", "Belgian Horse", "Belgian Warmblood", "Bhutia Horse", "Black Forest Horse", "Blazer Horse", "Boerperd", "Borana", "Boulonnais Horse", "Brabant", "Brandenburger", "Brazilian Sport Horse", "Breton Horse", "Brumby", "Budyonny Horse", "Burguete Horse", "Burmese Horse", "Byelorussian Harness Horse", "Calabrese Horse", "Camargue Horse", "Camarillo White Horse", "Campeiro", "Campolina", "Canadian Horse", "Canadian Pacer", "Carolina Marsh Tacky", "Carthusian Horse", "Caspian Horse", "Castilian Horse", "Castillonnais", "Catria Horse", "Cavallo Romano della Maremma Laziale", "Cerbat Mustang", "Chickasaw Horse", "Chilean Corralero", "Choctaw Horse", "Cleveland Bay", "Clydesdale Horse", "Cob", "Coldblood Trotter", "Colonial Spanish Horse", "Colorado Ranger", "Comtois Horse", "Corsican Horse", "Costa Rican Saddle Horse", "Cretan Horse", "Criollo Horse", "Croatian Coldblood", "Cuban Criollo", "Cumberland Island Horse", "Curly Horse", "Czech Warmblood", "Daliboz", "Danish Warmblood", "Danube Delta Horse", "Dole Gudbrandsdal", "Don", "Dongola Horse", "Draft Trotter", "Dutch Harness Horse", "Dutch Heavy Draft", "Dutch Warmblood", "Dzungarian Horse", "East Bulgarian", "East Friesian Horse", "Estonian Draft", "Estonian Horse", "Falabella", "Faroese", "Finnhorse", "Fjord Horse", "Fleuve", "Florida Cracker Horse", "Foutanké", "Frederiksborg Horse", "Freiberger", "French Trotter", "Friesian Cross", "Friesian Horse", "Friesian Sporthorse", "Furioso-North Star", "Galiceño", "Galician Pony", "Gelderland Horse", "Georgian Grande Horse", "German Warmblood", "Giara Horse", "Gidran", "Groningen Horse", "Gypsy Horse", "Hackney Horse", "Haflinger", "Hanoverian Horse", "Heck Horse", "Heihe Horse", "Henson Horse", "Hequ Horse", "Hirzai", "Hispano-Bretón", "Holsteiner Horse", "Horro", "Hungarian Warmblood", "Icelandic Horse", "Iomud", "Irish Draught", "Irish Sport Horse sometimes called Irish Hunter", "Italian Heavy Draft", "Italian Trotter", "Jaca Navarra", "Jeju Horse", "Jutland Horse", "Kabarda Horse", "Kafa", "Kaimanawa Horses", "Kalmyk Horse", "Karabair", "Karabakh Horse", "Karachai Horse", "Karossier", "Kathiawari", "Kazakh Horse", "Kentucky Mountain Saddle Horse", "Kiger Mustang", "Kinsky Horse", "Kisber Felver", "Kiso Horse", "Kladruber", "Knabstrupper", "Konik", "Kundudo", "Kustanair", "Kyrgyz Horse", "Latvian Horse", "Lipizzan", "Lithuanian Heavy Draught", "Lokai", "Losino Horse", "Lusitano", "Lyngshest", "M'Bayar", "M'Par", "Mallorquín", "Malopolski", "Mangalarga", "Mangalarga Marchador", "Maremmano", "Marismeño Horse", "Marsh Tacky", "Marwari Horse", "Mecklenburger", "Menorquín", "Messara Horse", "Metis Trotter", "Mezőhegyesi Sport Horse", "Međimurje Horse", "Miniature Horse", "Misaki Horse", "Missouri Fox Trotter", "Monchina", "Mongolian Horse", "Mongolian Wild Horse", "Monterufolino", "Morab", "Morgan Horse", "Mountain Pleasure Horse", "Moyle Horse", "Murakoz Horse", "Murgese", "Mustang Horse", "Mérens Horse", "Namib Desert Horse", "Nangchen Horse", "National Show Horse", "Nez Perce Horse", "Nivernais Horse", "Nokota Horse", "Noma", "Nonius Horse", "Nooitgedachter", "Nordlandshest", "Noriker Horse", "Norman Cob", "North American Single-Footer Horse", "North Swedish Horse", "Norwegian Coldblood Trotter", "Norwegian Fjord", "Novokirghiz", "Oberlander Horse", "Ogaden", "Oldenburg Horse", "Orlov trotter", "Ostfriesen", "Paint", "Pampa Horse", "Paso Fino", "Pentro Horse", "Percheron", "Persano Horse", "Peruvian Paso", "Pintabian", "Pleven Horse", "Poitevin Horse", "Posavac Horse", "Pottok", "Pryor Mountain Mustang", "Przewalski's Horse", "Pura Raza Española", "Purosangue Orientale", "Qatgani", "Quarab", "Quarter Horse", "Racking Horse", "Retuerta Horse", "Rhenish German Coldblood", "Rhinelander Horse", "Riwoche Horse", "Rocky Mountain Horse", "Romanian Sporthorse", "Rottaler", "Russian Don", "Russian Heavy Draft", "Russian Trotter", "Saddlebred", "Salerno Horse", "Samolaco Horse", "San Fratello Horse", "Sarcidano Horse", "Sardinian Anglo-Arab", "Schleswig Coldblood", "Schwarzwälder Kaltblut", "Selale", "Sella Italiano", "Selle Français", "Shagya Arabian", "Shan Horse", "Shire Horse", "Siciliano Indigeno", "Silesian Horse", "Sokolsky Horse", "Sorraia", "South German Coldblood", "Soviet Heavy Draft", "Spanish Anglo-Arab", "Spanish Barb", "Spanish Jennet Horse", "Spanish Mustang", "Spanish Tarpan", "Spanish-Norman Horse", "Spiti Horse", "Spotted Saddle Horse", "Standardbred Horse", "Suffolk Punch", "Swedish Ardennes", "Swedish Warmblood", "Swedish coldblood trotter", "Swiss Warmblood", "Taishū Horse", "Takhi", "Tawleed", "Tchernomor", "Tennessee Walking Horse", "Tersk Horse", "Thoroughbred", "Tiger Horse", "Tinker Horse", "Tolfetano", "Tori Horse", "Trait Du Nord", "Trakehner", "Tsushima", "Tuigpaard", "Ukrainian Riding Horse", "Unmol Horse", "Uzunyayla", "Ventasso Horse", "Virginia Highlander", "Vlaamperd", "Vladimir Heavy Draft", "Vyatka", "Waler", "Waler Horse", "Walkaloosa", "Warlander", "Warmblood", "Welsh Cob", "Westphalian Horse", "Wielkopolski", "Württemberger", "Xilingol Horse", "Yakutian Horse", "Yili Horse", "Yonaguni Horse", "Zaniskari", "Zhemaichu", "Zweibrücker", "Žemaitukas"], TFe = ["Acacia-ants", "Acorn-plum gall", "Aerial yellowjacket", "Africanized honey bee", "Allegheny mound ant", "Almond stone wasp", "Ant", "Arboreal ant", "Argentine ant", "Asian paper wasp", "Baldfaced hornet", "Bee", "Bigheaded ant", "Black and yellow mud dauber", "Black carpenter ant", "Black imported fire ant", "Blue horntail woodwasp", "Blue orchard bee", "Braconid wasp", "Bumble bee", "Carpenter ant", "Carpenter wasp", "Chalcid wasp", "Cicada killer", "Citrus blackfly parasitoid", "Common paper wasp", "Crazy ant", "Cuckoo wasp", "Cynipid gall wasp", "Eastern Carpenter bee", "Eastern yellowjacket", "Elm sawfly", "Encyrtid wasp", "Erythrina gall wasp", "Eulophid wasp", "European hornet", "European imported fire ant", "False honey ant", "Fire ant", "Forest bachac", "Forest yellowjacket", "German yellowjacket", "Ghost ant", "Giant ichneumon wasp", "Giant resin bee", "Giant wood wasp", "Golden northern bumble bee", "Golden paper wasp", "Gouty oak gall", "Grass Carrying Wasp", "Great black wasp", "Great golden digger wasp", "Hackberry nipple gall parasitoid", "Honey bee", "Horned oak gall", "Horse guard wasp", "Hunting wasp", "Ichneumonid wasp", "Keyhole wasp", "Knopper gall", "Large garden bumble bee", "Large oak-apple gall", "Leafcutting bee", "Little fire ant", "Little yellow ant", "Long-horned bees", "Long-legged ant", "Macao paper wasp", "Mallow bee", "Marble gall", "Mossyrose gall wasp", "Mud-daubers", "Multiflora rose seed chalcid", "Oak apple gall wasp", "Oak rough bulletgall wasp", "Oak saucer gall", "Oak shoot sawfly", "Odorous house ant", "Orange-tailed bumble bee", "Orangetailed potter wasp", "Oriental chestnut gall wasp", "Paper wasp", "Pavement ant", "Pigeon tremex", "Pip gall wasp", "Prairie yellowjacket", "Pteromalid wasp", "Pyramid ant", "Raspberry Horntail", "Red ant", "Red carpenter ant", "Red harvester ant", "Red imported fire ant", "Red wasp", "Red wood ant", "Red-tailed wasp", "Reddish carpenter ant", "Rough harvester ant", "Sawfly parasitic wasp", "Scale parasitoid", "Silky ant", "Sirex woodwasp", "Siricid woodwasp", "Smaller yellow ant", "Southeastern blueberry bee", "Southern fire ant", "Southern yellowjacket", "Sphecid wasp", "Stony gall", "Sweat bee", "Texas leafcutting ant", "Tiphiid wasp", "Torymid wasp", "Tramp ant", "Valentine ant", "Velvet ant", "Vespid wasp", "Weevil parasitoid", "Western harvester ant", "Western paper wasp", "Western thatching ant", "Western yellowjacket", "White-horned horntail", "Willow shoot sawfly", "Woodwasp", "Wool sower gall maker", "Yellow Crazy Ant", "Yellow and black potter wasp", "Yellow-horned horntail"], vFe = ["Asiatic Lion", "Barbary Lion", "Cape lion", "Masai Lion", "Northeast Congo Lion", "Transvaal lion", "West African Lion"], xFe = ["Ace", "Archie", "Bailey", "Bandit", "Bella", "Bentley", "Bruno", "Buddy", "Charlie", "Coco", "Cookie", "Cooper", "Daisy", "Dixie", "Finn", "Ginger", "Gracie", "Gus", "Hank", "Jack", "Jax", "Joey", "Kobe", "Leo", "Lola", "Louie", "Lucy", "Maggie", "Max", "Mia", "Milo", "Molly", "Murphey", "Nala", "Nova", "Ollie", "Oreo", "Rosie", "Scout", "Stella", "Teddy", "Tuffy"], CFe = ["American", "American Chinchilla", "American Fuzzy Lop", "American Sable", "Argente Brun", "Belgian Hare", "Beveren", "Blanc de Hotot", "Britannia Petite", "Californian", "Champagne D’Argent", "Checkered Giant", "Cinnamon", "Crème D’Argent", "Dutch", "Dwarf Hotot", "English Angora", "English Lop", "English Spot", "Flemish Giant", "Florida White", "French Angora", "French Lop", "Giant Angora", "Giant Chinchilla", "Harlequin", "Havana", "Himalayan", "Holland Lop", "Jersey Wooly", "Lilac", "Lionhead", "Mini Lop", "Mini Rex", "Mini Satin", "Netherland Dwarf", "New Zealand", "Palomino", "Polish", "Rex", "Rhinelander", "Satin", "Satin Angora", "Silver", "Silver Fox", "Silver Marten", "Standard Chinchilla", "Tan", "Thrianta"], kFe = ["Abrocoma", "Abrocoma schistacea", "Aconaemys", "Aconaemys porteri", "African brush-tailed porcupine", "Andean mountain cavy", "Argentine tuco-tuco", "Ashy chinchilla rat", "Asiatic brush-tailed porcupine", "Atherurus", "Azara's agouti", "Azara's tuco-tuco", "Bahia porcupine", "Bathyergus", "Bathyergus janetta", "Bathyergus suillus", "Bennett's chinchilla rat", "Bicolored-spined porcupine", "Black agouti", "Black dwarf porcupine", "Black-rumped agouti", "Black-tailed hairy dwarf porcupine", "Bolivian chinchilla rat", "Bolivian tuco-tuco", "Bonetto's tuco-tuco", "Brandt's yellow-toothed cavy", "Brazilian guinea pig", "Brazilian porcupine", "Brazilian tuco-tuco", "Bridge's degu", "Brown hairy dwarf porcupine", "Budin's chinchilla rat, A. budini", "Cape porcupine", "Catamarca tuco-tuco", "Cavia", "Central American agouti", "Chacoan tuco-tuco", "Chilean rock rat", "Chinchilla", "Coendou", "Coiban agouti", "Colburn's tuco-tuco", "Collared tuco-tuco", "Common degu", "Common yellow-toothed cavy", "Conover's tuco-tuco", "Coruro", "Crested agouti", "Crested porcupine", "Cryptomys", "Cryptomys bocagei", "Cryptomys damarensis", "Cryptomys foxi", "Cryptomys hottentotus", "Cryptomys mechowi", "Cryptomys ochraceocinereus", "Cryptomys zechi", "Ctenomys", "Cuniculus", "Cuscomys", "Cuscomys ashanika", "Dactylomys", "Dactylomys boliviensis", "Dactylomys dactylinus", "Dactylomys peruanus", "Dasyprocta", "Domestic guinea pig", "Emily's tuco-tuco", "Erethizon", "Famatina chinchilla rat", "Frosted hairy dwarf porcupine", "Fukomys", "Fukomys amatus", "Fukomys anselli", "Fukomys bocagei", "Fukomys damarensis", "Fukomys darlingi", "Fukomys foxi", "Fukomys ilariae", "Fukomys kafuensis", "Fukomys mechowii", "Fukomys micklemi", "Fukomys occlusus", "Fukomys ochraceocinereus", "Fukomys whytei", "Fukomys zechi", "Furtive tuco-tuco", "Galea", "Georychus", "Georychus capensis", "Golden viscacha-rat", "Goya tuco-tuco", "Greater guinea pig", "Green acouchi", "Haig's tuco-tuco", "Heliophobius", "Heliophobius argenteocinereus", "Heterocephalus", "Heterocephalus glaber", "Highland tuco-tuco", "Hystrix", "Indian porcupine", "Isla Mocha degu", "Kalinowski agouti", "Kannabateomys", "Kannabateomys amblyonyx", "Lagidium", "Lagostomus", "Lewis' tuco-tuco", "Long-tailed chinchilla", "Long-tailed porcupine", "Los Chalchaleros' viscacha-rat", "Lowland paca", "Magellanic tuco-tuco", "Malayan porcupine", "Maule tuco-tuco", "Mendoza tuco-tuco", "Mexican agouti", "Mexican hairy dwarf porcupine", "Microcavia", "Montane guinea pig", "Moon-toothed degu", "Mottled tuco-tuco", "Mountain degu", "Mountain paca", "Mountain viscacha-rat", "Myoprocta", "Natterer's tuco-tuco", "North American porcupine", "Northern viscacha", "Octodon", "Octodontomys", "Octomys", "Olallamys", "Olallamys albicauda", "Olallamys edax", "Orinoco agouti", "Paraguaian hairy dwarf porcupine", "Pearson's tuco-tuco", "Peruvian tuco-tuco", "Philippine porcupine", "Pipanacoctomys", "Plains viscacha", "Plains viscacha-rat", "Porteous' tuco-tuco", "Punta de Vacas chinchilla rat", "Red acouchi", "Red-rumped agouti", "Reddish tuco-tuco", "Rio Negro tuco-tuco", "Robust tuco-tuco", "Roosmalen's dwarf porcupine", "Rothschild's porcupine", "Ruatan Island agouti", "Sage's rock rat", "Salinoctomys", "Salta tuco-tuco", "San Luis tuco-tuco", "Santa Catarina's guinea pig", "Shiny guinea pig", "Shipton's mountain cavy", "Short-tailed chinchilla", "Silky tuco-tuco", "Social tuco-tuco", "Southern mountain cavy", "Southern tuco-tuco", "Southern viscacha", "Spalacopus", "Spix's yellow-toothed cavy", "Steinbach's tuco-tuco", "Streaked dwarf porcupine", "Strong tuco-tuco", "Stump-tailed porcupine", "Sumatran porcupine", "Sunda porcupine", "Talas tuco-tuco", "Tawny tuco-tuco", "Thick-spined porcupine", "Tiny tuco-tuco", "Trichys", "Tucuman tuco-tuco", "Tympanoctomys", "Uspallata chinchilla rat", "White-toothed tuco-tuco", "Wolffsohn's viscacha"], _Fe = ["Abaco Island boa", "Aesculapian snake", "African beaked snake", "African puff adder", "African rock python", "African twig snake", "African wolf snake", "Amazon tree boa", "Amazonian palm viper", "American Vine Snake", "American copperhead", "Amethystine python", "Anaconda", "Andaman cat snake", "Andaman cobra", "Angolan python", "Annulated sea snake", "Arabian cobra", "Arafura file snake", "Arizona black rattlesnake", "Arizona coral snake", "Aruba rattlesnake", "Asian Vine Snake, Whip Snake", "Asian cobra", "Asian keelback", "Asian pipe snake", "Asp", "Asp viper", "Assam keelback", "Australian copperhead", "Australian scrub python", "Baird's rat snake", "Baja California lyresnake", "Ball Python", "Ball python", "Bamboo pitviper", "Bamboo viper", "Banded Flying Snake", "Banded cat-eyed snake", "Banded krait", "Banded pitviper", "Banded water cobra", "Barbour's pit viper", "Barred wolf snake", "Beaked sea snake", "Beauty rat snake", "Beddome's cat snake", "Beddome's coral snake", "Bimini racer", "Bird snake", "Bismarck ringed python", "Black headed python", "Black krait", "Black mamba", "Black rat snake", "Black snake", "Black tree cobra", "Black-banded trinket snake", "Black-headed snake", "Black-necked cobra", "Black-necked spitting cobra", "Black-speckled palm-pitviper", "Black-striped keelback", "Black-tailed horned pit viper", "Blanding's tree snake", "Blind snake", "Blonde hognose snake", "Blood python", "Blue krait", "Blunt-headed tree snake", "Bluntnose viper", "Boa", "Boa constrictor", "Bocourt's water snake", "Boelen python", "Boiga", "Bolivian anaconda", "Boomslang", "Bornean pitviper", "Borneo short-tailed python", "Brahminy blind snake", "Brazilian coral snake", "Brazilian mud Viper", "Brazilian smooth snake", "Bredl's python", "Brongersma's pitviper", "Brown snake", "Brown spotted pitviper[4]", "Brown tree snake", "Brown water python", "Brown white-lipped python", "Buff striped keelback", "Bull snake", "Burmese keelback", "Burmese krait", "Burmese python", "Burrowing cobra", "Burrowing viper", "Bush viper", "Bushmaster", "Buttermilk racer", "Calabar python", "California kingsnake", "Canebrake", "Cantil", "Cantor's pitviper", "Cape cobra", "Cape coral snake", "Cape gopher snake", "Carpet viper", "Cascabel", "Caspian cobra", "Cat snake", "Cat-eyed night snake", "Cat-eyed snake", "Central American lyre snake", "Central ranges taipan", "Centralian carpet python", "Ceylon krait", "Chappell Island tiger snake", "Checkered garter snake", "Checkered keelback", "Chicken snake", "Chihuahuan ridge-nosed rattlesnake", "Children's python", "Chinese tree viper", "Coachwhip snake", "Coastal carpet python", "Coastal taipan", "Cobra", "Collett's snake", "Colorado desert sidewinder", "Common adder", "Common cobra", "Common garter snake", "Common ground snake", "Common keelback", "Common lancehead", "Common tiger snake", "Common worm snake", "Congo snake", "Congo water cobra", "Copperhead", "Coral snake", "Corn snake", "Coronado Island rattlesnake", "Cottonmouth", "Crossed viper", "Crowned snake", "Cuban boa", "Cuban wood snake", "Cyclades blunt-nosed viper", "Dauan Island water python", "De Schauensee's anaconda", "Death Adder", "Desert death adder", "Desert kingsnake", "Desert woma python", "Diamond python", "Dog-toothed cat snake", "Down's tiger snake", "Dubois's sea snake", "Dumeril's boa", "Durango rock rattlesnake", "Dusky pigmy rattlesnake", "Dusty hognose snake", "Dwarf beaked snake", "Dwarf boa", "Dwarf pipe snake", "Dwarf sand adder", "Eastern brown snake", "Eastern coral snake", "Eastern diamondback rattlesnake", "Eastern green mamba", "Eastern hognose snake", "Eastern lyre snake", "Eastern mud snake", "Eastern racer", "Eastern tiger snake", "Eastern water cobra", "Eastern yellowbelly sad racer", "Egg-eater", "Egyptian asp", "Egyptian cobra", "Elegant pitviper", "Emerald tree boa", "Equatorial spitting cobra", "European asp", "European smooth snake", "Eyelash palm-pitviper", "Eyelash pit viper", "Eyelash viper", "False cobra", "False horned viper", "False water cobra", "Fan-Si-Pan horned pitviper", "Fea's viper", "Fer-de-lance", "Fierce snake", "Fifty pacer", "Fishing snake", "Flat-nosed pitviper", "Flinders python", "Flying snake", "Forest cobra", "Forest flame snake", "Forsten's cat snake", "Fox snake, three species of Pantherophis", "Gaboon viper", "Garter snake", "Giant Malagasy hognose snake", "Godman's pit viper", "Gold tree cobra", "Gold-ringed cat snake", "Golden tree snake", "Grand Canyon rattlesnake", "Grass snake", "Gray cat snake", "Great Basin rattlesnake", "Great Lakes bush viper", "Great Plains rat snake", "Green anaconda", "Green cat-eyed snake", "Green mamba", "Green palm viper", "Green rat snake", "Green snake", "Green tree pit viper", "Green tree python", "Grey Lora", "Grey-banded kingsnake", "Ground snake", "Guatemalan palm viper", "Guatemalan tree viper", "Habu", "Habu pit viper", "Hagen's pitviper", "Hairy bush viper", "Halmahera python", "Hardwicke's sea snake", "Harlequin coral snake", "High Woods coral snake", "Hill keelback", "Himalayan keelback", "Hogg Island boa", "Hognose snake", "Hognosed viper", "Honduran palm viper", "Hook Nosed Sea Snake", "Hopi rattlesnake", "Horned adder", "Horned desert viper", "Horned viper", "Horseshoe pitviper", "Hundred pacer", "Hutton's tree viper", "Ikaheka snake", "Indian cobra", "Indian flying snake", "Indian krait", "Indian python", "Indian tree viper", "Indigo snake", "Indochinese spitting cobra", "Indonesian water python", "Inland carpet python", "Inland taipan", "Jamaican Tree Snake", "Jamaican boa", "Jan's hognose snake", "Japanese forest rat snake", "Japanese rat snake", "Japanese striped snake", "Javan spitting cobra", "Jerdon's pitviper", "Jumping viper", "Jungle carpet python", "Kanburian pit viper", "Kaulback's lance-headed pitviper", "Kayaudi dwarf reticulated python", "Kaznakov's viper", "Keelback", "Kham Plateau pitviper", "Khasi Hills keelback", "King Island tiger snake", "King brown", "King cobra", "King rat snake", "King snake", "Krait", "Krefft's tiger snake", "Lance-headed rattlesnake", "Lancehead", "Large shield snake", "Large-eyed pitviper", "Large-scaled tree viper", "Leaf viper", "Leaf-nosed viper", "Lesser black krait", "Levant viper", "Long-nosed adder", "Long-nosed tree snake", "Long-nosed viper", "Long-nosed whip snake", "Long-tailed rattlesnake", "Longnosed worm snake", "Lora", "Lyre snake", "Machete savane", "Macklot's python", "Madagascar ground boa", "Madagascar tree boa", "Malabar rock pitviper", "Malayan krait", "Malayan long-glanded coral snake", "Malayan pit viper", "Malcolm's tree viper", "Mamba", "Mamushi", "Manchurian Black Water Snake", "Mandalay cobra", "Mandarin rat snake", "Mangrove pit viper", "Mangrove snake", "Mangshan pitviper", "Many-banded krait", "Many-banded tree snake", "Many-horned adder", "Many-spotted cat snake", "Massasauga rattlesnake", "McMahon's viper", "Mexican black kingsnake", "Mexican green rattlesnake", "Mexican hognose snake", "Mexican palm-pitviper", "Mexican parrot snake", "Mexican racer", "Mexican vine snake", "Mexican west coast rattlesnake", "Midget faded rattlesnake", "Milk snake", "Moccasin snake", "Modest keelback", "Mojave desert sidewinder", "Mojave rattlesnake", "Mole viper", "Mollucan python", "Moluccan flying snake", "Montpellier snake", "Motuo bamboo pitviper", "Mountain adder", "Mozambique spitting cobra", "Mud adder", "Mud snake", "Mussurana", "Namaqua dwarf adder", "Namib dwarf sand adder", "Narrowhead Garter Snake", "New Guinea carpet python", "Nichell snake", "Nicobar Island keelback", "Nicobar bamboo pitviper", "Night snake", "Nightingale adder", "Nilgiri keelback", "Nitsche's bush viper", "Nitsche's tree viper", "North Philippine cobra", "North eastern king snake", "Northeastern hill krait", "Northern black-tailed rattlesnake", "Northern tree snake", "Northern water snake", "Northern white-lipped python", "Northwestern carpet python", "Nose-horned viper", "Nubian spitting cobra", "Oaxacan small-headed rattlesnake", "Oenpelli python", "Olive python", "Olive sea snake", "Orange-collared keelback", "Ornate flying snake", "Palestine viper", "Pallas' viper", "Palm viper", "Papuan python", "Paradise flying snake", "Parrot snake", "Patchnose snake", "Paupan taipan", "Pelagic sea snake", "Peninsula tiger snake", "Peringuey's adder", "Perrotet's shieldtail snake", "Persian rat snake", "Philippine cobra", "Philippine pitviper", "Pine snake", "Pipe snake", "Pit viper", "Pointed-scaled pit viper[5]", "Pope's tree viper", "Portuguese viper", "Prairie kingsnake", "Puerto Rican boa", "Puff adder", "Pygmy python", "Python", "Queen snake", "Racer", "Raddysnake", "Rainbow boa", "Rat snake", "Rattler", "Rattlesnake", "Red blood python", "Red diamond rattlesnake", "Red spitting cobra", "Red-backed rat snake", "Red-bellied black snake", "Red-headed krait", "Red-necked keelback", "Red-tailed bamboo pitviper", "Red-tailed boa", "Red-tailed pipe snake", "Reticulated python", "Rhinoceros viper", "Rhombic night adder", "Ribbon snake", "Rinkhals", "Rinkhals cobra", "River jack", "Rosy boa", "Rough green snake", "Rough-scaled bush viper", "Rough-scaled python", "Rough-scaled tree viper", "Royal python", "Rubber boa", "Rufous beaked snake", "Rungwe tree viper", "San Francisco garter snake", "Sand adder", "Sand boa", "Savu python", "Saw-scaled viper", "Scarlet kingsnake", "Schlegel's viper", "Schultze's pitviper", "Sea snake", "Sedge viper", "Selayer reticulated python", "Sharp-nosed viper", "Shield-nosed cobra", "Shield-tailed snake", "Siamese palm viper", "Side-striped palm-pitviper", "Sidewinder", "Sikkim keelback", "Sinai desert cobra", "Sind krait", "Small-eyed snake", "Smooth green snake", "Smooth snake", "Snorkel viper", "Snouted cobra", "Sonoran sidewinder", "South American hognose snake", "South eastern corn snake", "Southern Indonesian spitting cobra", "Southern Pacific rattlesnake", "Southern Philippine cobra", "Southern black racer", "Southern white-lipped python", "Southwestern black spitting cobra", "Southwestern blackhead snake", "Southwestern carpet python", "Southwestern speckled rattlesnake", "Speckle-bellied keelback", "Speckled kingsnake", "Spectacled cobra", "Spiny bush viper", "Spitting cobra", "Spotted python", "Sri Lankan pit viper", "Stejneger's bamboo pitviper", "Stiletto snake", "Stimson's python", "Stoke's sea snake", "Storm water cobra", "Striped snake", "Sumatran short-tailed python", "Sumatran tree viper", "Sunbeam snake", "Taipan", "Taiwan cobra", "Tan racer", "Tancitaran dusky rattlesnake", "Tanimbar python", "Tasmanian tiger snake", "Tawny cat snake", "Temple pit viper", "Temple viper", "Tentacled snake", "Texas Coral Snake", "Texas blind snake", "Texas garter snake", "Texas lyre snake", "Texas night snake", "Thai cobra", "Three-lined ground snake", "Tibetan bamboo pitviper", "Tic polonga", "Tiger pit viper", "Tiger rattlesnake", "Tiger snake", "Tigre snake", "Timber rattlesnake", "Timor python", "Titanboa", "Tree boa", "Tree snake", "Tree viper", "Trinket snake", "Tropical rattlesnake", "Twig snake", "Twin Headed King Snake", "Twin-Barred tree snake", "Twin-spotted rat snake", "Twin-spotted rattlesnake", "Undulated pit viper", "Uracoan rattlesnake", "Ursini's viper", "Urutu", "Vine snake", "Viper", "Viper Adder", "Vipera ammodytes", "Wagler's pit viper", "Wart snake", "Water adder", "Water moccasin", "Water snake", "West Indian racer", "Western blind snake", "Western carpet python", "Western coral snake", "Western diamondback rattlesnake", "Western green mamba", "Western ground snake", "Western hog-nosed viper", "Western mud snake", "Western tiger snake", "Western woma python", "Wetar Island python", "Whip snake", "White-lipped keelback", "White-lipped python", "White-lipped tree viper", "Wirot's pit viper", "Wolf snake", "Woma python", "Worm snake", "Wutu", "Wynaad keelback", "Yarara", "Yellow anaconda", "Yellow-banded sea snake", "Yellow-bellied sea snake", "Yellow-lined palm viper", "Yellow-lipped sea snake", "Yellow-striped rat snake", "Yunnan keelback", "Zebra snake", "Zebra spitting cobra"], NFe = ["bat", "bear", "bee", "bird", "butterfly", "cat", "cow", "crocodile", "deer", "dog", "dolphin", "eagle", "elephant", "fish", "flamingo", "fox", "frog", "gecko", "giraffe", "gorilla", "hamster", "hippopotamus", "horse", "kangaroo", "koala", "lion", "monkey", "ostrich", "panda", "parrot", "peacock", "penguin", "polar bear", "rabbit", "rhinoceros", "sea lion", "shark", "snake", "squirrel", "tiger", "turtle", "whale", "wolf", "zebra"], DFe = { bear: gFe, bird: pFe, cat: bFe, cetacean: yFe, cow: AFe, crocodilia: EFe, dog: SFe, fish: wFe, horse: FFe, insect: TFe, lion: vFe, pet_name: xFe, rabbit: CFe, rodent: kFe, snake: _Fe, type: NFe }, IFe = DFe, RFe = ["{{person.name}}", "{{company.name}}"], PFe = ["Redhold", "Treeflex", "Trippledex", "Kanlam", "Bigtax", "Daltfresh", "Toughjoyfax", "Mat Lam Tam", "Otcom", "Tres-Zap", "Y-Solowarm", "Tresom", "Voltsillam", "Biodex", "Greenlam", "Viva", "Matsoft", "Temp", "Zoolab", "Subin", "Rank", "Job", "Stringtough", "Tin", "It", "Home Ing", "Zamit", "Sonsing", "Konklab", "Alpha", "Latlux", "Voyatouch", "Alphazap", "Holdlamis", "Zaam-Dox", "Sub-Ex", "Quo Lux", "Bamity", "Ventosanzap", "Lotstring", "Hatity", "Tempsoft", "Overhold", "Fixflex", "Konklux", "Zontrax", "Tampflex", "Span", "Namfix", "Transcof", "Stim", "Fix San", "Sonair", "Stronghold", "Fintone", "Y-find", "Opela", "Lotlux", "Ronstring", "Zathin", "Duobam", "Keylex"], LFe = ["0.#.#", "0.##", "#.##", "#.#", "#.#.#"], MFe = { author: RFe, name: PFe, version: LFe }, OFe = MFe, BFe = ["A.A. Milne", "Agatha Christie", "Alan Moore and Dave Gibbons", "Albert Camus", "Aldous Huxley", "Alexander Pope", "Alexandre Dumas", "Alice Walker", "Andrew Lang", "Anne Frank", "Anthony Burgess", "Anthony Trollope", "Antoine de Saint-Exupéry", "Anton Chekhov", "Anton Pavlovich Chekhov", "Arthur Conan Doyle", "Arthur Schopenhauer", "Aylmer Maude", "Ayn Rand", "Beatrix Potter", "Benjamin Disraeli", "Benjamin Jowett", "Bernard Shaw", "Bertrand Russell", "Bhagavanlal Indrajit", "Boris Pasternak", "Bram Stoker", "Brian Evenson", "C.E. Brock", "C.S. Lewis", "Carson McCallers", "Charles Dickens", "Charles E. Derbyshire", "Charlotte Brontë", "Charlotte Perkins Gilman", "Chinua Achebe", "Clifford R. Adams", "Constance Garnett", "Cormac McCarthy", "D.H. Lawrence", "Dan Brown", "Daniel Defoe", "Dante Alighieri", "Dashiell Hammett", "David Widger", "David Wyllie", "Dean Koontz", "Don DeLillo", "E.M. Forster", "Edgar Allan Poe", "Edgar Rice Burroughs", "Elizabeth Cleghorn Gaskell", "Elizabeth Von Arnim", "Emily Brontë", "Erich Remarque", "Ernest Hemingway", "Evelyn Waugh", "F. Scott Fitzgerald", "Ford Madox Ford", "Frances Hodgson Burnett", "Frank Herbert", "Frank T. Merrill", "Franz Kafka", "Friedrich Wilhelm Nietzsche", "Fyodor Dostoyevsky", "G.K. Chesterton", "Gabriel Garcia Marquez", "Geoffrey Chaucer", "George Eliot", "George Grossmith", "George Orwell", "George R. R. Martin", "George Saunders", "Grady Ward", "Graham Greene", "Gustave Doré", "Gustave Flaubert", "Guy de Maupassant", "Günter Grass", "H.G. Wells", "H.P. Lovecraft", "Harper Lee", "Harriet Beecher Stowe", "Haruki Murakami", "Henrik Ibsen", "Henry David Thoreau", "Henry Fielding", "Henry James", "Henry Miller", "Henry Morley", "Herman Melville", "Hermann Broch", "Homer", "Honoré de Balzac", "Ian McEwan", "Isabel Florence Hapgood", "Italo Calvino", "J.D. Salinger", "J.K. Rowling", "J.M. Barrie", "J.R.R. Tolkien", "Jack Kerouac", "Jack London", "Jacob Grimm", "Jacqueline Crooks", "James Baldwin", "James Dickey", "James Ellroy", "James Joyce", "James Patterson", "Jane Austen", "Johann Wolfgang von Goethe", "John Bunyan", "John Camden Hotten", "John Dos Passos", "John Green", "John Grisham", "John Kennedy Toole", "John Milton", "John Ormsby", "John Steinbeck", "John Updike", "Jonathan Franzen", "Jonathan Swift", "Joseph Conrad", "Joseph Heller", "José Rizal", "Judy Blume", "Jules Verne", "Junot Diaz", "Karl Marx", "Kazuo Ishiguro", "Ken Follett", "Ken Kesey", "Kenneth Grahame", "Khaled Hosseini", "Kingsley Amis", "Kurt Vonnegut", "L. Frank Baum", "L.M. Montgomery", "Laurence Sterne", "Leo Tolstoy", "Lewis Carroll", "Louisa May Alcott", "Louise Maude", "Malcolm Lowry", "Marcel Proust", "Margaret Atwood", "Margaret Mitchell", "Marilynne Robinson", "Mark Twain", "Martin Amis", "Mary Shelley", "Michael Chabon", "Miguel de Cervantes", "Mikhail Bulgakov", "Muriel Spark", "Nancy Mitford", "Nathanael West", "Nathaniel Hawthorne", "Neil Gaiman", "Niccolo Machiavelli", "Norman Mailer", "Oscar Levy", "Oscar Wilde", "P.G. Wodehouse", "Paulo Coelho", "Peter Carey", "Philip Pullman", "Philip Roth", "Plato", "R.L. Stine", "Rachel Kushner", "Ralph Ellison", "Ray Bradbury", "Raymond Chandler", "Richard Wagner", "Richard Wright", "Richard Yates", "Roald Dahl", "Robert Graves", "Robert Louis Stevenson", "Robert Penn Warren", "Rudyard Kipling", "Salman Rushdie", "Samuel Beckett", "Samuel Butler", "Samuel Richardson", "Saul Bellow", "Shivaram Parashuram Bhide", "Sir Arthur Conan Doyle", "Sir Richard Francis Burton", "Stendhal", "Stephen Hawking", "Stephen King", "Sun Tzu", "Suzanne Collins", "T. Smollett", "T.S. Eliot", "Theodore Alois Buckley", "Theodore Dreiser", "Thomas Hardy", "Thomas Love Peacock", "Thomas Mann", "Toni Morrison", "Truman Capote", "V.S. Naipaul", "Vance Packard", "Vatsyayana", "Victor Hugo", "Virgil", "Virginia Woolf", "Vladimir Nabokov", "Voltaire", "W.G. Sebald", "W.K. Marriott", "Walker Percy", "Walt Whitman", "Walter Scott", "Wilhelm Grimm", "Wilkie Collins", "William Faulkner", "William Gibson", "William Golding", "William Makepeace Thackeray", "William Shakespeare", "Zadie Smith"], $Fe = ["Audiobook", "Ebook", "Hardcover", "Paperback"], HFe = ["Adventure", "Biography", "Business", "Children's Literature", "Classic", "Comedy", "Comic", "Detective", "Drama", "Fantasy", "Graphic Novel", "Historical Fiction", "Horror", "Memoir", "Mystery", "Mythology", "Philosophy", "Poetry", "Psychology", "Religion", "Romance", "Science Fiction", "Thriller", "Western", "Young Adult"], UFe = ["Academic Press", "Ace Books", "Addison-Wesley", "Adis International", "Airiti Press", "Allen Ltd", "Andrews McMeel Publishing", "Anova Books", "Anvil Press Poetry", "Applewood Books", "Apress", "Athabasca University Press", "Atheneum Books", "Atheneum Publishers", "Atlantic Books", "Atlas Press", "BBC Books", "Ballantine Books", "Banner of Truth Trust", "Bantam Books", "Bantam Spectra", "Barrie & Jenkins", "Basic Books", "Belknap Press", "Bella Books", "Bellevue Literary Press", "Berg Publishers", "Berkley Books", "Bison Books", "Black Dog Publishing", "Black Library", "Black Sparrow Books", "Blackie and Son Limited", "Blackstaff Press", "Blackwell Publishing", "Bloodaxe Books", "Bloomsbury Publishing Plc", "Blue Ribbon Books", "Book League of America", "Book Works", "Booktrope", "Borgo Press", "Bowes & Bowes", "Boydell & Brewer", "Breslov Research Institute", "Brill", "Brimstone Press", "Broadview Press", "Burns & Oates", "Butterworth-Heinemann", "Caister Academic Press", "Cambridge University Press", "Candlewick Press", "Canongate Books", "Carcanet Press", "Carlton Books", "Carlton Publishing Group", "Carnegie Mellon University Press", "Casemate Publishers", "Cengage Learning", "Central European University Press", "Chambers Harrap", "Charles Scribner's Sons", "Chatto and Windus", "Chick Publications", "Chronicle Books", "Churchill Livingstone", "Cisco Press", "City Lights Publishers", "Cloverdale Corporation", "D. Appleton & Company", "D. Reidel", "DAW Books", "Da Capo Press", "Daedalus Publishing", "Dalkey Archive Press", "Darakwon Press", "David & Charles", "Dedalus Books", "Del Rey Books", "E. P. Dutton", "ECW Press", "Earthscan", "Edupedia Publications", "Eel Pie Publishing", "Eerdmans Publishing", "Ellora's Cave", "Elsevier", "Emerald Group Publishing", "Etruscan Press", "FabJob", "Faber and Faber", "Fairview Press", "Farrar, Straus & Giroux", "Fearless Books", "Felony & Mayhem Press", "Firebrand Books", "Flame Tree Publishing", "Focal Press", "G-Unit Books", "G. P. Putnam's Sons", "Gaspereau Press", "Gay Men's Press", "Gefen Publishing House", "George H. Doran Company", "George Newnes", "George Routledge & Sons", "Godwit Press", "Golden Cockerel Press", "HMSO", "Hachette Book Group USA", "Hackett Publishing Company", "Hamish Hamilton", "Happy House", "Harcourt Assessment", "Harcourt Trade Publishers", "Harlequin Enterprises Ltd", "Harper & Brothers", "Harper & Row", "HarperCollins", "HarperPrism", "HarperTrophy", "Harry N. Abrams, Inc.", "Harvard University Press", "Harvest House", "Harvill Press at Random House", "Hawthorne Books", "Hay House", "Haynes Manuals", "Heyday Books", "Hodder & Stoughton", "Hodder Headline", "Hogarth Press", "Holland Park Press", "Holt McDougal", "Horizon Scientific Press", "Ian Allan Publishing", "Ignatius Press", "Imperial War Museum", "Indiana University Press", "J. M. Dent", "Jaico Publishing House", "Jarrolds Publishing", "John Blake Publishing", "Karadi Tales", "Kensington Books", "Kessinger Publishing", "Kodansha", "Kogan Page", "Koren Publishers Jerusalem", "Ladybird Books", "Leaf Books", "Leafwood Publishers", "Left Book Club", "Legend Books", "Lethe Press", "Libertas Academica", "Liberty Fund", "Library of America", "Lion Hudson", "Macmillan Publishers", "Mainstream Publishing", "Manchester University Press", "Mandrake Press", "Mandrake of Oxford", "Manning Publications", "Manor House Publishing", "Mapin Publishing", "Marion Boyars Publishers", "Mark Batty Publisher", "Marshall Cavendish", "Marshall Pickering", "Martinus Nijhoff Publishers", "Mascot Books", "Matthias Media", "McClelland and Stewart", "McFarland & Company", "McGraw Hill Financial", "McGraw-Hill Education", "Medknow Publications", "Naiad Press", "Nauka", "NavPress", "New Directions Publishing", "New English Library", "New Holland Publishers", "New Village Press", "Newnes", "No Starch Press", "Nonesuch Press", "O'Reilly Media", "Oberon Books", "Open Court Publishing Company", "Open University Press", "Orchard Books", "Orion Books", "Packt Publishing", "Palgrave Macmillan", "Pan Books", "Pantheon Books at Random House", "Papadakis Publisher", "Parachute Publishing", "Parragon", "Pathfinder Press", "Paulist Press", "Pavilion Books", "Peace Hill Press", "Pecan Grove Press", "Pen and Sword Books", "Penguin Books", "Random House", "Reed Elsevier", "Reed Publishing", "SAGE Publications", "Salt Publishing", "Sams Publishing", "Schocken Books", "Scholastic Press", "Seagull Books", "Secker & Warburg", "Shambhala Publications", "Shire Books", "Shoemaker & Hoard Publishers", "Shuter & Shooter Publishers", "Sidgwick & Jackson", "Signet Books", "Simon & Schuster", "St. Martin's Press", "T & T Clark", "Tachyon Publications", "Tammi", "Target Books", "Tarpaulin Sky Press", "Tartarus Press", "Tate Publishing & Enterprises", "Taunton Press", "Taylor & Francis", "Ten Speed Press", "UCL Press", "Unfinished Monument Press", "United States Government Publishing Office", "University of Akron Press", "University of Alaska Press", "University of California Press", "University of Chicago Press", "University of Michigan Press", "University of Minnesota Press", "University of Nebraska Press", "Velazquez Press", "Verso Books", "Victor Gollancz Ltd", "Viking Press", "Vintage Books", "Vintage Books at Random House", "Virago Press", "Virgin Publishing", "Voyager Books", "Zed Books", "Ziff Davis Media", "Zondervan"], GFe = ["A Song of Ice and Fire", "Anna Karenina", "Colonel Race", "Discworld", "Dune", "Harry Potter", "Hercule Poirot", "His Dark Materials", "Jane Austen Murder Mysteries", "Little Women", "Outlander", "Percy Jackson", "Sherlock Holmes", "The Arc of a Scythe", "The Bartimaeus Trilogy", "The Border Trilogy", "The Chronicles of Narnia", "The Dark Tower", "The Dresden Files", "The Eighth Life", "The Foundation Series", "The Hitchhiker's Guide to the Galaxy", "The Hunger Games", "The Infinity Cycle", "The Inheritance Cycle", "The Lord of the Rings", "The Maze Runner", "The Prison Healer", "The Red Rising Saga", "The Southern Reach", "The Wheel of Time", "Thursday Next Series", "Twilight", "War and Peace"], WFe = ["1984", "20,000 Leagues Under the Sea", "A Bend in the River", "A Brief History of Time", "A Clockwork Orange", "A Confederacy of Dunces", "A Doll's House", "A Handful of Dust", "A Modest Proposal", "A Passage to India", "A Portrait of the Artist as a Young Man", "A Room with a View", "A Study in Scarlet", "A Tale of Two Cities", "A Wrinkle in Time", "Absalom, Absalom!", "Adventures of Huckleberry Finn", "Alice's Adventures in Wonderland", "All Quiet on the Western Front", "All the King's Men", "American Pastoral", "An American Tragedy", "And Then There Were None", "Animal Farm", "Anna Karenina", "Anne of Green Gables", "Are You There God? It's Me, Margaret", "As I Lay Dying", "Atlas Shrugged", "Atonement", "Austerlitz", "Beloved", "Beyond Good and Evil", "Bible", "Bleak House", "Blood Meridian", "Brave New World", "Brideshead Revisited", "Candide", "Carmilla", "Catch-22", "Charlie and the Chocolate Factory", "Charlotte's Web", "Clarissa", "Cranford", "Crime and Punishment", "Dao De Jing: A Minimalist Translation", "David Copperfield", "Deliverance", "Don Quixote", "Dora", "Dr. Zhivago", "Dracula", "Dubliners", "Dune", "East of Eden", "Emma", "Fahrenheit 451", "Faust", "For Whom the Bell Tolls", "Frankenstein", "Freakonomics", "Go Tell It on the Mountain", "Gone with the Wind", "Great Expectations", "Grimms' Fairy Tales", "Gulliver's Travels", "Hamlet", "Harry Potter and the Sorcerer's Stone", "Heart of Darkness", "Herzog", "His Dark Materials", "Hitting the line", "Housekeeping", "I, Claudius", "If on a Winter's Night a Traveler", "In Cold Blood", "In Search of Lost Time", "Invisible Man", "It", "Jane Eyre", "Josefine Mutzenbacher", "Jude the Obscure", "L.A. Confidential", "Leaves of Grass", "Les Miserables", "Life of Pi", "Little Women", "Lolita", "Long Walk to Freedom", "Lord Jim", "Lord of the Flies", "Lucky Jim", "Madame Bovary", "Malone Dies", "Meditations", "Men Without Women", "Metamorphosis", "Middlemarch", "Midnight's Children", "Moby Dick", "Money", "Mrs. Dalloway", "My Bondage and My Freedom", "My Life", "Native Son", "Neuromancer", "Never Let Me Go", "Nightmare Abbey", "Nineteen Eighty Four", "Nostromo", "Notes from the Underground", "Of Mice and Men", "Oliver Twist", "On the Duty of Civil Disobedience", "On the Road", "One Flew Over the Cuckoo's Nest", "One Hundred Years of Solitude", "One Thousand and One Nights", "Oscar and Lucinda", "Pale Fire", "Paradise Lost", "Peter Pan", "Portnoy's Complaint", "Pride and Prejudice", "Rabbit, Run", "Republic", "Revolutionary Road", "Robinson Crusoe", "Romeo and Juliet", "Ruth Fielding in Alaska", "Scoop", "Second Treatise of Government", "Slaughterhouse Five", "Stories of Anton Chekhov", "Sybil", "Tess of the d'Urbervilles", "The Adventures of Augie March", "The Adventures of Huckleberry Finn", "The Adventures of Sherlock Holmes", "The Adventures of Tom Sawyer", "The Aeneid", "The Alchemist", "The Ambassadors", "The Art of War", "The Big Sleep", "The Black Sheep", "The Blue Castle", "The Brief Wondrous Life of Oscar Wao", "The Brothers Karamazov", "The Call of the Wild", "The Canterbury Tales", "The Catcher in the Rye", "The Color Purple", "The Complete Works of Edgar Allen Poe", "The Corrections", "The Count of Monte Cristo", "The Day of the Locust", "The Diary of a Nobody", "The Diary of a Young Girl", "The Divine Comedy", "The Enchanted April", "The Fountainhead", "The Golden Bowl", "The Golden Notebook", "The Good Soldier", "The Grapes of Wrath", "The Great Gatsby", "The Handmaid's Tale", "The Heart is a Lonely Hunter", "The Heart of the Matter", "The Hobbit", "The Hound of the Baskervilles", "The Idiot", "The Iliad", "The King in Yellow", "The Kite Runner", "The Lion, the Witch, and the Wardrobe", "The Little Prince", "The Lord of the Rings", "The Magic Mountain", "The Maltese Falcon", "The Master and Margarita", "The Moviegoer", "The Naked and the Dead", "The Odyssey", "The Old Man and the Sea", "The Pickwick Papers", "The Picture of Dorian Gray", "The Pilgrim's Progress", "The Pillars of the Earth", "The Plague", "The Portrait of a Lady", "The Prime of Miss Jean Brodie", "The Prince", "The Problems of Philosophy", "The Prophet", "The Pursuit of Love", "The Rainbow", "The Red and the Black", "The Remains of the Day", "The Republic", "The Scarlet Letter", "The Sleepwalkers", "The Sound and the Fury", "The Stand", "The Strange Case of Dr. Jekyll and Mr. Hyde", "The Stranger", "The Sun Also Rises", "The Thirty-Nine Steps", "The Three Musketeers", "The Time Machine", "The Tin Drum", "The Trial", "The War of the Worlds", "The Waste Land", "The Way We Live Now", "The Wind in the Willows", "The Woman in White", "The Wonderful Wizard of Oz", "The Works of Edgar Allan Poe", "The Yellow Wallpaper", "Things Fall Apart", "Tinker, Tailor, Soldier, Spy", "To Kill a Mockingbird", "To the Lighthouse", "Tom Jones", "Treasure Island", "Tristram Shandy", "Tropic of Cancer", "U.S.A. Trilogy", "Ulysses", "Uncle Tom's Cabin", "Under the Volcano", "Underworld", "Vanity Fair", "Walden", "War and Peace", "Watchmen", "Winnie-the-Pooh", "Wuthering Heights"], VFe = { author: BFe, format: $Fe, genre: HFe, publisher: UFe, series: GFe, title: WFe }, KFe = VFe, zFe = ["###-###-####", "(###) ###-####", "1-###-###-####", "###.###.####"], jFe = { formats: zFe }, YFe = jFe, qFe = ["azure", "black", "blue", "cyan", "fuchsia", "gold", "green", "grey", "indigo", "ivory", "lavender", "lime", "magenta", "maroon", "mint green", "olive", "orange", "orchid", "pink", "plum", "purple", "red", "salmon", "silver", "sky blue", "tan", "teal", "turquoise", "violet", "white", "yellow"], JFe = { human: qFe }, QFe = JFe, XFe = ["Automotive", "Baby", "Beauty", "Books", "Clothing", "Computers", "Electronics", "Games", "Garden", "Grocery", "Health", "Home", "Industrial", "Jewelry", "Kids", "Movies", "Music", "Outdoors", "Shoes", "Sports", "Tools", "Toys"], ZFe = ["Discover the {{animal.type}}-like agility of our {{commerce.product}}, perfect for {{word.adjective}} users", "Discover the {{word.adjective}} new {{commerce.product}} with an exciting mix of {{commerce.productMaterial}} ingredients", "Ergonomic {{commerce.product}} made with {{commerce.productMaterial}} for all-day {{word.adjective}} support", "Experience the {{color.human}} brilliance of our {{commerce.product}}, perfect for {{word.adjective}} environments", "Featuring {{science.chemical_element.name}}-enhanced technology, our {{commerce.product}} offers unparalleled {{word.adjective}} performance", "Innovative {{commerce.product}} featuring {{word.adjective}} technology and {{commerce.productMaterial}} construction", "Introducing the {{location.country}}-inspired {{commerce.product}}, blending {{word.adjective}} style with local craftsmanship", "New {{color.human}} {{commerce.product}} with ergonomic design for {{word.adjective}} comfort", 'New {{commerce.product}} model with {{number.int({"min": 1, "max": 100})}} GB RAM, {{number.int({"min": 1, "max": 1000})}} GB storage, and {{word.adjective}} features', "Our {{animal.type}}-friendly {{commerce.product}} ensures {{word.adjective}} comfort for your pets", "Our {{food.adjective}}-inspired {{commerce.product}} brings a taste of luxury to your {{word.adjective}} lifestyle", "Professional-grade {{commerce.product}} perfect for {{word.adjective}} training and recreational use", "Savor the {{food.adjective}} essence in our {{commerce.product}}, designed for {{word.adjective}} culinary adventures", "Stylish {{commerce.product}} designed to make you stand out with {{word.adjective}} looks", "The sleek and {{word.adjective}} {{commerce.product}} comes with {{color.human}} LED lighting for smart functionality", "The {{color.human}} {{commerce.product}} combines {{location.country}} aesthetics with {{science.chemical_element.name}}-based durability", "The {{company.catchPhrase}} {{commerce.product}} offers reliable performance and {{word.adjective}} design", "The {{person.firstName}} {{commerce.product}} is the latest in a series of {{word.adjective}} products from {{company.name}}", "{{commerce.productAdjective}} {{commerce.product}} designed with {{commerce.productMaterial}} for {{word.adjective}} performance", "{{company.name}}'s most advanced {{commerce.product}} technology increases {{word.adjective}} capabilities"], eTe = { adjective: ["Awesome", "Bespoke", "Electronic", "Elegant", "Ergonomic", "Fantastic", "Fresh", "Frozen", "Generic", "Gorgeous", "Handcrafted", "Handmade", "Incredible", "Intelligent", "Licensed", "Luxurious", "Modern", "Oriental", "Practical", "Recycled", "Refined", "Rustic", "Sleek", "Small", "Soft", "Tasty", "Unbranded"], material: ["Aluminum", "Bamboo", "Bronze", "Ceramic", "Concrete", "Cotton", "Gold", "Granite", "Marble", "Metal", "Plastic", "Rubber", "Silk", "Steel", "Wooden"], product: ["Bacon", "Ball", "Bike", "Car", "Chair", "Cheese", "Chicken", "Chips", "Computer", "Fish", "Gloves", "Hat", "Keyboard", "Mouse", "Pants", "Pizza", "Salad", "Sausages", "Shirt", "Shoes", "Soap", "Table", "Towels", "Tuna"], pattern: ["{{commerce.productAdjective}} {{commerce.productMaterial}} {{commerce.product}}"] }, tTe = { department: XFe, product_description: ZFe, product_name: eTe }, nTe = tTe, rTe = ["AI-driven", "Adaptive", "Advanced", "Automated", "Balanced", "Business-focused", "Centralized", "Compatible", "Configurable", "Cross-platform", "Customer-focused", "Customizable", "Decentralized", "Devolved", "Digitized", "Distributed", "Diverse", "Enhanced", "Ergonomic", "Exclusive", "Expanded", "Extended", "Face to face", "Focused", "Front-line", "Fully-configurable", "Fundamental", "Future-proofed", "Grass-roots", "Horizontal", "Immersive", "Implemented", "Innovative", "Integrated", "Intuitive", "Managed", "Monitored", "Multi-tiered", "Networked", "Open-architected", "Open-source", "Operative", "Optimized", "Optional", "Organic", "Organized", "Persevering", "Persistent", "Phased", "Polarised", "Proactive", "Profit-focused", "Profound", "Programmable", "Progressive", "Public-key", "Quality-focused", "Reactive", "Realigned", "Reduced", "Reverse-engineered", "Robust", "Seamless", "Secured", "Self-enabling", "Sharable", "Smart", "Stand-alone", "Streamlined", "Sustainable", "Synchronised", "Team-oriented", "Total", "Triple-buffered", "Universal", "Upgradable", "User-centric", "User-friendly", "Versatile", "Virtual", "Visionary"], iTe = ["24/7", "AI-driven", "B2B", "B2C", "back-end", "best-of-breed", "bleeding-edge", "collaborative", "compelling", "cross-media", "cross-platform", "customized", "cutting-edge", "decentralized", "distributed", "dynamic", "efficient", "end-to-end", "enterprise", "extensible", "frictionless", "front-end", "generative", "global", "granular", "holistic", "immersive", "impactful", "innovative", "integrated", "interactive", "intuitive", "killer", "leading-edge", "magnetic", "mission-critical", "next-generation", "one-to-one", "open-source", "out-of-the-box", "plug-and-play", "proactive", "quantum", "real-time", "revolutionary", "rich", "robust", "scalable", "seamless", "smart", "sticky", "strategic", "sustainable", "synergistic", "transparent", "turn-key", "ubiquitous", "user-centric", "value-added", "vertical", "viral", "virtual", "visionary", "world-class"], sTe = ["AI", "ROI", "applications", "architectures", "blockchains", "channels", "communities", "content", "convergence", "deliverables", "e-commerce", "experiences", "functionalities", "infrastructures", "initiatives", "interfaces", "large language models", "lifetime value", "markets", "methodologies", "metrics", "mindshare", "models", "networks", "niches", "paradigms", "partnerships", "platforms", "relationships", "schemas", "smart contracts", "solutions", "supply-chains", "synergies", "systems", "technologies", "users", "web services"], aTe = ["aggregate", "architect", "benchmark", "brand", "collaborate", "cultivate", "deliver", "deploy", "disintermediate", "drive", "embrace", "empower", "enable", "engage", "engineer", "enhance", "evolve", "expedite", "exploit", "extend", "facilitate", "gamify", "generate", "grow", "harness", "implement", "incentivize", "incubate", "innovate", "integrate", "iterate", "leverage", "maximize", "mesh", "monetize", "optimize", "orchestrate", "productize", "redefine", "reinvent", "repurpose", "revolutionize", "scale", "seize", "simplify", "strategize", "streamline", "syndicate", "synthesize", "target", "transform", "transition", "unleash", "utilize", "visualize", "whiteboard"], oTe = ["24 hour", "24/7", "AI-powered", "actuating", "analyzing", "asymmetric", "asynchronous", "attitude-oriented", "bifurcated", "bottom-line", "clear-thinking", "client-driven", "client-server", "cloud-native", "coherent", "cohesive", "composite", "content-based", "context-sensitive", "contextually-based", "data-driven", "dedicated", "demand-driven", "directional", "discrete", "disintermediate", "dynamic", "eco-centric", "empowering", "encompassing", "executive", "explicit", "exuding", "fault-tolerant", "fresh-thinking", "full-range", "global", "heuristic", "high-level", "holistic", "homogeneous", "human-resource", "hybrid", "immersive", "impactful", "incremental", "intangible", "interactive", "intermediate", "leading edge", "local", "logistical", "maximized", "methodical", "mission-critical", "mobile", "modular", "motivating", "national", "needs-based", "neutral", "next generation", "optimal", "optimizing", "radical", "real-time", "reciprocal", "regional", "resilient", "responsive", "scalable", "secondary", "stable", "static", "sustainable", "system-worthy", "systematic", "systemic", "tangible", "tertiary", "transitional", "uniform", "user-facing", "value-added", "well-modulated", "zero administration", "zero defect", "zero tolerance", "zero trust"], uTe = ["Group", "Inc", "LLC", "and Sons"], lTe = ["{{person.last_name.generic}} - {{person.last_name.generic}}", "{{person.last_name.generic}} {{company.legal_entity_type}}", "{{person.last_name.generic}}, {{person.last_name.generic}} and {{person.last_name.generic}}"], cTe = ["ability", "access", "adapter", "algorithm", "alliance", "analyzer", "application", "approach", "architecture", "archive", "array", "artificial intelligence", "attitude", "benchmark", "budgetary management", "capability", "capacity", "challenge", "circuit", "collaboration", "complexity", "concept", "conglomeration", "contingency", "core", "customer loyalty", "data-warehouse", "database", "definition", "emulation", "encoding", "encryption", "firmware", "flexibility", "focus group", "forecast", "frame", "framework", "function", "functionalities", "generative AI", "hardware", "help-desk", "hierarchy", "hub", "implementation", "infrastructure", "initiative", "installation", "instruction set", "interface", "internet solution", "intranet", "knowledge base", "knowledge user", "leverage", "local area network", "matrices", "matrix", "methodology", "microservice", "middleware", "migration", "model", "moderator", "monitoring", "moratorium", "neural-net", "open architecture", "orchestration", "paradigm", "parallelism", "policy", "portal", "pricing structure", "process improvement", "product", "productivity", "project", "projection", "protocol", "service-desk", "software", "solution", "standardization", "strategy", "structure", "success", "support", "synergy", "system engine", "task-force", "throughput", "time-frame", "toolset", "utilisation", "website", "workforce"], hTe = { adjective: rTe, buzz_adjective: iTe, buzz_noun: sTe, buzz_verb: aTe, descriptor: oTe, legal_entity_type: uTe, name_pattern: lTe, noun: cTe }, dTe = hTe, fTe = ["avatar", "category", "comment", "createdAt", "email", "group", "id", "name", "password", "phone", "status", "title", "token", "updatedAt"], mTe = { column: fTe }, gTe = mTe, pTe = { wide: ["April", "August", "December", "February", "January", "July", "June", "March", "May", "November", "October", "September"], abbr: ["Apr", "Aug", "Dec", "Feb", "Jan", "Jul", "Jun", "Mar", "May", "Nov", "Oct", "Sep"] }, bTe = { wide: ["Friday", "Monday", "Saturday", "Sunday", "Thursday", "Tuesday", "Wednesday"], abbr: ["Fri", "Mon", "Sat", "Sun", "Thu", "Tue", "Wed"] }, yTe = { month: pTe, weekday: bTe }, ATe = yTe, ETe = ["Auto Loan", "Checking", "Credit Card", "Home Loan", "Investment", "Money Market", "Personal Loan", "Savings"], STe = ["34##-######-####L", "37##-######-####L"], wTe = ["30[0-5]#-######-###L", "36##-######-###L"], FTe = ["6011-####-####-###L", "65##-####-####-###L"], TTe = ["3528-####-####-###L", "3529-####-####-###L", "35[3-8]#-####-####-###L"], vTe = ["2[221-720]-####-####-###L", "5[1-5]##-####-####-###L"], xTe = ["4###########L", "4###-####-####-###L"], CTe = { american_express: STe, diners_club: wTe, discover: FTe, jcb: TTe, mastercard: vTe, visa: xTe }, kTe = CTe, _Te = [{ name: "UAE Dirham", code: "AED", symbol: "", numericCode: "784" }, { name: "Afghani", code: "AFN", symbol: "؋", numericCode: "971" }, { name: "Lek", code: "ALL", symbol: "Lek", numericCode: "008" }, { name: "Armenian Dram", code: "AMD", symbol: "", numericCode: "051" }, { name: "Netherlands Antillian Guilder", code: "ANG", symbol: "ƒ", numericCode: "532" }, { name: "Kwanza", code: "AOA", symbol: "", numericCode: "973" }, { name: "Argentine Peso", code: "ARS", symbol: "$", numericCode: "032" }, { name: "Australian Dollar", code: "AUD", symbol: "$", numericCode: "036" }, { name: "Aruban Guilder", code: "AWG", symbol: "ƒ", numericCode: "533" }, { name: "Azerbaijanian Manat", code: "AZN", symbol: "ман", numericCode: "944" }, { name: "Convertible Marks", code: "BAM", symbol: "KM", numericCode: "977" }, { name: "Barbados Dollar", code: "BBD", symbol: "$", numericCode: "052" }, { name: "Taka", code: "BDT", symbol: "", numericCode: "050" }, { name: "Bulgarian Lev", code: "BGN", symbol: "лв", numericCode: "975" }, { name: "Bahraini Dinar", code: "BHD", symbol: "", numericCode: "048" }, { name: "Burundi Franc", code: "BIF", symbol: "", numericCode: "108" }, { name: "Bermudian Dollar (customarily known as Bermuda Dollar)", code: "BMD", symbol: "$", numericCode: "060" }, { name: "Brunei Dollar", code: "BND", symbol: "$", numericCode: "096" }, { name: "Boliviano boliviano", code: "BOB", symbol: "Bs", numericCode: "068" }, { name: "Brazilian Real", code: "BRL", symbol: "R$", numericCode: "986" }, { name: "Bahamian Dollar", code: "BSD", symbol: "$", numericCode: "044" }, { name: "Pula", code: "BWP", symbol: "P", numericCode: "072" }, { name: "Belarusian Ruble", code: "BYN", symbol: "Rbl", numericCode: "933" }, { name: "Belize Dollar", code: "BZD", symbol: "BZ$", numericCode: "084" }, { name: "Canadian Dollar", code: "CAD", symbol: "$", numericCode: "124" }, { name: "Congolese Franc", code: "CDF", symbol: "", numericCode: "976" }, { name: "Swiss Franc", code: "CHF", symbol: "CHF", numericCode: "756" }, { name: "Chilean Peso", code: "CLP", symbol: "$", numericCode: "152" }, { name: "Yuan Renminbi", code: "CNY", symbol: "¥", numericCode: "156" }, { name: "Colombian Peso", code: "COP", symbol: "$", numericCode: "170" }, { name: "Costa Rican Colon", code: "CRC", symbol: "₡", numericCode: "188" }, { name: "Cuban Peso", code: "CUP", symbol: "₱", numericCode: "192" }, { name: "Cape Verde Escudo", code: "CVE", symbol: "", numericCode: "132" }, { name: "Czech Koruna", code: "CZK", symbol: "Kč", numericCode: "203" }, { name: "Djibouti Franc", code: "DJF", symbol: "", numericCode: "262" }, { name: "Danish Krone", code: "DKK", symbol: "kr", numericCode: "208" }, { name: "Dominican Peso", code: "DOP", symbol: "RD$", numericCode: "214" }, { name: "Algerian Dinar", code: "DZD", symbol: "", numericCode: "012" }, { name: "Egyptian Pound", code: "EGP", symbol: "£", numericCode: "818" }, { name: "Nakfa", code: "ERN", symbol: "", numericCode: "232" }, { name: "Ethiopian Birr", code: "ETB", symbol: "", numericCode: "230" }, { name: "Euro", code: "EUR", symbol: "€", numericCode: "978" }, { name: "Fiji Dollar", code: "FJD", symbol: "$", numericCode: "242" }, { name: "Falkland Islands Pound", code: "FKP", symbol: "£", numericCode: "238" }, { name: "Pound Sterling", code: "GBP", symbol: "£", numericCode: "826" }, { name: "Lari", code: "GEL", symbol: "", numericCode: "981" }, { name: "Cedi", code: "GHS", symbol: "", numericCode: "936" }, { name: "Gibraltar Pound", code: "GIP", symbol: "£", numericCode: "292" }, { name: "Dalasi", code: "GMD", symbol: "", numericCode: "270" }, { name: "Guinea Franc", code: "GNF", symbol: "", numericCode: "324" }, { name: "Quetzal", code: "GTQ", symbol: "Q", numericCode: "320" }, { name: "Guyana Dollar", code: "GYD", symbol: "$", numericCode: "328" }, { name: "Hong Kong Dollar", code: "HKD", symbol: "$", numericCode: "344" }, { name: "Lempira", code: "HNL", symbol: "L", numericCode: "340" }, { name: "Gourde", code: "HTG", symbol: "", numericCode: "332" }, { name: "Forint", code: "HUF", symbol: "Ft", numericCode: "348" }, { name: "Rupiah", code: "IDR", symbol: "Rp", numericCode: "360" }, { name: "New Israeli Sheqel", code: "ILS", symbol: "₪", numericCode: "376" }, { name: "Bhutanese Ngultrum", code: "BTN", symbol: "Nu", numericCode: "064" }, { name: "Indian Rupee", code: "INR", symbol: "₹", numericCode: "356" }, { name: "Iraqi Dinar", code: "IQD", symbol: "", numericCode: "368" }, { name: "Iranian Rial", code: "IRR", symbol: "﷼", numericCode: "364" }, { name: "Iceland Krona", code: "ISK", symbol: "kr", numericCode: "352" }, { name: "Jamaican Dollar", code: "JMD", symbol: "J$", numericCode: "388" }, { name: "Jordanian Dinar", code: "JOD", symbol: "", numericCode: "400" }, { name: "Yen", code: "JPY", symbol: "¥", numericCode: "392" }, { name: "Kenyan Shilling", code: "KES", symbol: "", numericCode: "404" }, { name: "Som", code: "KGS", symbol: "лв", numericCode: "417" }, { name: "Riel", code: "KHR", symbol: "៛", numericCode: "116" }, { name: "Comoro Franc", code: "KMF", symbol: "", numericCode: "174" }, { name: "North Korean Won", code: "KPW", symbol: "₩", numericCode: "408" }, { name: "Won", code: "KRW", symbol: "₩", numericCode: "410" }, { name: "Kuwaiti Dinar", code: "KWD", symbol: "", numericCode: "414" }, { name: "Cayman Islands Dollar", code: "KYD", symbol: "$", numericCode: "136" }, { name: "Tenge", code: "KZT", symbol: "лв", numericCode: "398" }, { name: "Kip", code: "LAK", symbol: "₭", numericCode: "418" }, { name: "Lebanese Pound", code: "LBP", symbol: "£", numericCode: "422" }, { name: "Sri Lanka Rupee", code: "LKR", symbol: "₨", numericCode: "144" }, { name: "Liberian Dollar", code: "LRD", symbol: "$", numericCode: "430" }, { name: "Libyan Dinar", code: "LYD", symbol: "", numericCode: "434" }, { name: "Moroccan Dirham", code: "MAD", symbol: "", numericCode: "504" }, { name: "Moldovan Leu", code: "MDL", symbol: "", numericCode: "498" }, { name: "Malagasy Ariary", code: "MGA", symbol: "", numericCode: "969" }, { name: "Denar", code: "MKD", symbol: "ден", numericCode: "807" }, { name: "Kyat", code: "MMK", symbol: "", numericCode: "104" }, { name: "Tugrik", code: "MNT", symbol: "₮", numericCode: "496" }, { name: "Pataca", code: "MOP", symbol: "", numericCode: "446" }, { name: "Ouguiya", code: "MRU", symbol: "", numericCode: "929" }, { name: "Mauritius Rupee", code: "MUR", symbol: "₨", numericCode: "480" }, { name: "Rufiyaa", code: "MVR", symbol: "", numericCode: "462" }, { name: "Kwacha", code: "MWK", symbol: "", numericCode: "454" }, { name: "Mexican Peso", code: "MXN", symbol: "$", numericCode: "484" }, { name: "Malaysian Ringgit", code: "MYR", symbol: "RM", numericCode: "458" }, { name: "Metical", code: "MZN", symbol: "MT", numericCode: "943" }, { name: "Naira", code: "NGN", symbol: "₦", numericCode: "566" }, { name: "Cordoba Oro", code: "NIO", symbol: "C$", numericCode: "558" }, { name: "Norwegian Krone", code: "NOK", symbol: "kr", numericCode: "578" }, { name: "Nepalese Rupee", code: "NPR", symbol: "₨", numericCode: "524" }, { name: "New Zealand Dollar", code: "NZD", symbol: "$", numericCode: "554" }, { name: "Rial Omani", code: "OMR", symbol: "﷼", numericCode: "512" }, { name: "Balboa", code: "PAB", symbol: "B/.", numericCode: "590" }, { name: "Nuevo Sol", code: "PEN", symbol: "S/.", numericCode: "604" }, { name: "Kina", code: "PGK", symbol: "", numericCode: "598" }, { name: "Philippine Peso", code: "PHP", symbol: "Php", numericCode: "608" }, { name: "Pakistan Rupee", code: "PKR", symbol: "₨", numericCode: "586" }, { name: "Zloty", code: "PLN", symbol: "zł", numericCode: "985" }, { name: "Guarani", code: "PYG", symbol: "Gs", numericCode: "600" }, { name: "Qatari Rial", code: "QAR", symbol: "﷼", numericCode: "634" }, { name: "New Leu", code: "RON", symbol: "lei", numericCode: "946" }, { name: "Serbian Dinar", code: "RSD", symbol: "Дин.", numericCode: "941" }, { name: "Russian Ruble", code: "RUB", symbol: "руб", numericCode: "643" }, { name: "Rwanda Franc", code: "RWF", symbol: "", numericCode: "646" }, { name: "Saudi Riyal", code: "SAR", symbol: "﷼", numericCode: "682" }, { name: "Solomon Islands Dollar", code: "SBD", symbol: "$", numericCode: "090" }, { name: "Seychelles Rupee", code: "SCR", symbol: "₨", numericCode: "690" }, { name: "Sudanese Pound", code: "SDG", symbol: "", numericCode: "938" }, { name: "Swedish Krona", code: "SEK", symbol: "kr", numericCode: "752" }, { name: "Singapore Dollar", code: "SGD", symbol: "$", numericCode: "702" }, { name: "Saint Helena Pound", code: "SHP", symbol: "£", numericCode: "654" }, { name: "Leone", code: "SLE", symbol: "", numericCode: "925" }, { name: "Somali Shilling", code: "SOS", symbol: "S", numericCode: "706" }, { name: "Surinam Dollar", code: "SRD", symbol: "$", numericCode: "968" }, { name: "South Sudanese pound", code: "SSP", symbol: "", numericCode: "728" }, { name: "Dobra", code: "STN", symbol: "Db", numericCode: "930" }, { name: "Syrian Pound", code: "SYP", symbol: "£", numericCode: "760" }, { name: "Lilangeni", code: "SZL", symbol: "", numericCode: "748" }, { name: "Baht", code: "THB", symbol: "฿", numericCode: "764" }, { name: "Somoni", code: "TJS", symbol: "", numericCode: "972" }, { name: "Manat", code: "TMT", symbol: "", numericCode: "934" }, { name: "Tunisian Dinar", code: "TND", symbol: "", numericCode: "788" }, { name: "Pa'anga", code: "TOP", symbol: "", numericCode: "776" }, { name: "Turkish Lira", code: "TRY", symbol: "₺", numericCode: "949" }, { name: "Trinidad and Tobago Dollar", code: "TTD", symbol: "TT$", numericCode: "780" }, { name: "New Taiwan Dollar", code: "TWD", symbol: "NT$", numericCode: "901" }, { name: "Tanzanian Shilling", code: "TZS", symbol: "", numericCode: "834" }, { name: "Hryvnia", code: "UAH", symbol: "₴", numericCode: "980" }, { name: "Uganda Shilling", code: "UGX", symbol: "", numericCode: "800" }, { name: "US Dollar", code: "USD", symbol: "$", numericCode: "840" }, { name: "Peso Uruguayo", code: "UYU", symbol: "$U", numericCode: "858" }, { name: "Uzbekistan Sum", code: "UZS", symbol: "лв", numericCode: "860" }, { name: "Venezuelan bolívar", code: "VES", symbol: "Bs", numericCode: "928" }, { name: "Dong", code: "VND", symbol: "₫", numericCode: "704" }, { name: "Vatu", code: "VUV", symbol: "", numericCode: "548" }, { name: "Tala", code: "WST", symbol: "", numericCode: "882" }, { name: "CFA Franc BEAC", code: "XAF", symbol: "", numericCode: "950" }, { name: "East Caribbean Dollar", code: "XCD", symbol: "$", numericCode: "951" }, { name: "CFA Franc BCEAO", code: "XOF", symbol: "", numericCode: "952" }, { name: "CFP Franc", code: "XPF", symbol: "", numericCode: "953" }, { name: "Yemeni Rial", code: "YER", symbol: "﷼", numericCode: "886" }, { name: "Rand", code: "ZAR", symbol: "R", numericCode: "710" }, { name: "Lesotho Loti", code: "LSL", symbol: "", numericCode: "426" }, { name: "Namibia Dollar", code: "NAD", symbol: "N$", numericCode: "516" }, { name: "Zambian Kwacha", code: "ZMW", symbol: "K", numericCode: "967" }, { name: "Zimbabwe Dollar", code: "ZWL", symbol: "", numericCode: "932" }], NTe = ["A {{finance.transactionType}} for {{finance.currencyCode}} {{finance.amount}} was made at {{company.name}} via card ending ****{{string.numeric(4)}} on account ***{{string.numeric(4)}}.", "A {{finance.transactionType}} of {{finance.currencyCode}} {{finance.amount}} occurred at {{company.name}} using a card ending in ****{{string.numeric(4)}} for account ***{{string.numeric(4)}}.", "Payment of {{finance.currencyCode}} {{finance.amount}} for {{finance.transactionType}} at {{company.name}}, processed with card ending ****{{string.numeric(4)}} linked to account ***{{string.numeric(4)}}.", "Transaction alert: {{finance.transactionType}} at {{company.name}} using card ending ****{{string.numeric(4)}} for an amount of {{finance.currencyCode}} {{finance.amount}} on account ***{{string.numeric(4)}}.", "You made a {{finance.transactionType}} of {{finance.currencyCode}} {{finance.amount}} at {{company.name}} using card ending in ****{{string.numeric(4)}} from account ***{{string.numeric(4)}}.", "Your {{finance.transactionType}} of {{finance.currencyCode}} {{finance.amount}} at {{company.name}} was successful. Charged via card ****{{string.numeric(4)}} to account ***{{string.numeric(4)}}.", "{{finance.transactionType}} at {{company.name}} with a card ending in ****{{string.numeric(4)}} for {{finance.currencyCode}} {{finance.amount}} from account ***{{string.numeric(4)}}.", "{{finance.transactionType}} confirmed at {{company.name}} for {{finance.currencyCode}} {{finance.amount}}, card ending in ****{{string.numeric(4)}} associated with account ***{{string.numeric(4)}}.", "{{finance.transactionType}} of {{finance.currencyCode}} {{finance.amount}} at {{company.name}} charged to account ending in {{string.numeric(4)}} using card ending in ****{{string.numeric(4)}}.", "{{finance.transactionType}} processed at {{company.name}} for {{finance.currencyCode}} {{finance.amount}}, using card ending ****{{string.numeric(4)}}. Account: ***{{string.numeric(4)}}.", "{{finance.transactionType}} transaction at {{company.name}} using card ending with ****{{string.numeric(4)}} for {{finance.currencyCode}} {{finance.amount}} in account ***{{string.numeric(4)}}."], DTe = ["deposit", "invoice", "payment", "withdrawal"], ITe = { account_type: ETe, credit_card: kTe, currency: _Te, transaction_description_pattern: NTe, transaction_type: DTe }, RTe = ITe, PTe = ["bitter", "creamy", "crispy", "crunchy", "delicious", "fluffy", "fresh", "golden", "juicy", "moist", "rich", "salty", "savory", "smoky", "sour", "spicy", "sweet", "tangy", "tender", "zesty"], LTe = ["A classic pie filled with delicious {{food.meat}} and {{food.adjective}} {{food.ingredient}}, baked in a {{food.adjective}} pastry crust and topped with a golden-brown lattice.", "A delightful tart combining {{food.adjective}} {{food.vegetable}} and sweet {{food.fruit}}, set in a buttery pastry shell and finished with a hint of {{food.spice}}.", "A heartwarming {{food.ethnic_category}} soup, featuring fresh {{food.ingredient}} and an aromatic blend of traditional spices.", "A robust {{food.adjective}} stew featuring {{food.ethnic_category}} flavors, loaded with {{food.adjective}} meat, {{food.adjective}} vegetables, and a {{food.adjective}}, {{food.adjective}} broth.", "A simple {{food.fruit}} pie. No fancy stuff. Just pie.", "A slow-roasted {{animal.bird}} with a {{food.adjective}}, {{food.adjective}} exterior. Stuffed with {{food.fruit}} and covered in {{food.fruit}} sauce. Sides with {{food.vegetable}} puree and wild {{food.vegetable}}.", "A special {{color.human}} {{food.ingredient}} from {{location.country}}. To support the strong flavor it is sided with a tablespoon of {{food.spice}}.", "A succulent {{food.meat}} steak, encased in a {{food.adjective}} {{food.spice}} crust, served with a side of {{food.spice}} mashed {{food.vegetable}}.", "An exquisite {{food.meat}} roast, infused with the essence of {{food.fruit}}, slow-roasted to bring out its natural flavors and served with a side of creamy {{food.vegetable}}", "Baked {{food.ingredient}}-stuffed {{food.meat}}, seasoned with {{food.spice}} and {{food.adjective}} herbs, accompanied by roasted {{food.vegetable}} medley.", "Crispy fried {{food.meat}} bites, seasoned with {{food.spice}} and served with a tangy {{food.fruit}} dipping sauce.", "Fresh mixed greens tossed with {{food.spice}}-rubbed {{food.meat}}, {{food.vegetable}}, and a light dressing.", "Fresh {{food.ingredient}} with a pinch of {{food.spice}}, topped by a caramelized {{food.fruit}} with whipped cream", "Grilled {{food.meat}} kebabs, marinated in {{food.ethnic_category}} spices and served with a fresh {{food.vegetable}} and {{food.fruit}} salad.", "Hearty {{food.ingredient}} and {{food.meat}} stew, slow-cooked with {{food.spice}} and {{food.vegetable}} for a comforting, flavorful meal.", "Juicy {{food.meat}}, grilled to your liking and drizzled with a bold {{food.spice}} sauce, served alongside roasted {{food.vegetable}}.", "Our {{food.adjective}} {{food.meat}}, slow-cooked to perfection, accompanied by steamed {{food.vegetable}} and a rich, savory gravy.", "Tender {{food.meat}} skewers, glazed with a sweet and tangy {{food.fruit}} sauce, served over a bed of fragrant jasmine rice.", "Tenderly braised {{food.meat}} in a rich {{food.spice}} and {{food.vegetable}} sauce, served with a side of creamy {{food.vegetable}}.", "Three {{food.ingredient}} with {{food.vegetable}}, {{food.vegetable}}, {{food.vegetable}}, {{food.vegetable}} and {{food.ingredient}}. With a side of baked {{food.fruit}}, and your choice of {{food.ingredient}} or {{food.ingredient}}.", '{{number.int({"min":1, "max":99})}}-day aged {{food.meat}} steak, with choice of {{number.int({"min":2, "max":4})}} sides.'], MTe = ["California maki", "Peking duck", "Philadelphia maki", "arepas", "barbecue ribs", "bruschette with tomato", "bunny chow", "caesar salad", "caprese salad", "cauliflower penne", "cheeseburger", "chicken fajitas", "chicken milanese", "chicken parm", "chicken wings", "chilli con carne", "ebiten maki", "fettuccine alfredo", "fish and chips", "french fries with sausages", "french toast", "hummus", "katsu curry", "kebab", "lasagne", "linguine with clams", "massaman curry", "meatballs with sauce", "mushroom risotto", "pappardelle alla bolognese", "pasta and beans", "pasta carbonara", "pasta with tomato and basil", "pho", "pierogi", "pizza", "poke", "pork belly buns", "pork sausage roll", "poutine", "ricotta stuffed ravioli", "risotto with seafood", "salmon nigiri", "scotch eggs", "seafood paella", "som tam", "souvlaki", "stinky tofu", "sushi", "tacos", "teriyaki chicken donburi", "tiramisù", "tuna sashimi", "vegetable soup"], OTe = ["{{food.adjective}} {{food.ethnic_category}} stew", "{{food.adjective}} {{food.meat}} with {{food.vegetable}}", "{{food.ethnic_category}} {{food.ingredient}} soup", "{{food.fruit}} and {{food.fruit}} tart", "{{food.fruit}} pie", "{{food.fruit}}-glazed {{food.meat}} skewers", "{{food.fruit}}-infused {{food.meat}} roast", "{{food.ingredient}} and {{food.meat}} pie", "{{food.ingredient}}-infused {{food.meat}}", "{{food.meat}} steak", "{{food.meat}} with {{food.fruit}} sauce", "{{food.spice}}-crusted {{food.meat}}", "{{food.spice}}-rubbed {{food.meat}} salad", "{{food.vegetable}} salad", "{{person.first_name.generic}}'s special {{food.ingredient}}"], BTe = ["Ainu", "Albanian", "American", "Andhra", "Anglo-Indian", "Arab", "Argentine", "Armenian", "Assyrian", "Awadhi", "Azerbaijani", "Balochi", "Bangladeshi", "Bashkir", "Belarusian", "Bengali", "Berber", "Brazilian", "British", "Buddhist", "Bulgarian", "Cajun", "Cantonese", "Caribbean", "Chechen", "Chinese", "Chinese Islamic", "Circassian", "Crimean Tatar", "Cypriot", "Czech", "Danish", "Egyptian", "English", "Eritrean", "Estonian", "Ethiopian", "Filipino", "French", "Georgian", "German", "Goan", "Goan Catholic", "Greek", "Gujarati", "Hyderabad", "Indian", "Indian Chinese", "Indian Singaporean", "Indonesian", "Inuit", "Irish", "Italian", "Italian-American", "Jamaican", "Japanese", "Jewish - Israeli", "Karnataka", "Kazakh", "Keralite", "Korean", "Kurdish", "Laotian", "Latvian", "Lebanese", "Lithuanian", "Louisiana Creole", "Maharashtrian", "Malay", "Malaysian Chinese", "Malaysian Indian", "Mangalorean", "Mediterranean", "Mennonite", "Mexican", "Mordovian", "Mughal", "Native American", "Nepalese", "New Mexican", "Odia", "Pakistani", "Parsi", "Pashtun", "Pennsylvania Dutch", "Peranakan", "Persian", "Peruvian", "Polish", "Portuguese", "Punjabi", "Québécois", "Rajasthani", "Romani", "Romanian", "Russian", "Sami", "Serbian", "Sindhi", "Slovak", "Slovenian", "Somali", "South Indian", "Soviet", "Spanish", "Sri Lankan", "Taiwanese", "Tamil", "Tatar", "Texan", "Thai", "Turkish", "Udupi", "Ukrainian", "Vietnamese", "Yamal", "Zambian", "Zanzibari"], $Te = ["apple", "apricot", "aubergine", "avocado", "banana", "berry", "blackberry", "blood orange", "blueberry", "bush tomato", "butternut pumpkin", "cantaloupe", "cavalo", "cherry", "corella pear", "cranberry", "cumquat", "currant", "custard apple", "custard apples daikon", "date", "dragonfruit", "dried apricot", "elderberry", "feijoa", "fig", "fingerlime", "goji berry", "grape", "grapefruit", "guava", "honeydew melon", "incaberry", "jarrahdale pumpkin", "juniper berry", "kiwi fruit", "kiwiberry", "lemon", "lime", "longan", "loquat", "lychee", "mandarin", "mango", "mangosteen", "melon", "mulberry", "nashi pear", "nectarine", "olive", "orange", "papaw", "papaya", "passionfruit", "peach", "pear", "pineapple", "plum", "pomegranate", "prune", "raspberry", "rockmelon", "snowpea", "sprout", "starfruit", "strawberry", "sultana", "tangelo", "tomato", "watermelon"], HTe = ["achacha", "adzuki beans", "agar", "agave syrup", "ajowan seed", "albacore tuna", "alfalfa", "allspice", "almond oil", "almonds", "amaranth", "amchur", "anchovies", "aniseed", "annatto seed", "apple cider vinegar", "apple juice", "apple juice concentrate", "apples", "apricots", "arborio rice", "arrowroot", "artichoke", "arugula", "asafoetida", "asian greens", "asian noodles", "asparagus", "aubergine", "avocado", "avocado oil", "avocado spread", "bacon", "baking powder", "baking soda", "balsamic vinegar", "bamboo shoots", "banana", "barberry", "barley", "barramundi", "basil basmati rice", "bay leaves", "bean shoots", "bean sprouts", "beans", "beef", "beef stock", "beetroot", "berries", "besan", "black eyed beans", "blackberries", "blood oranges", "blue cheese", "blue eye trevalla", "blue swimmer crab", "blueberries", "bocconcini", "bok choy", "bonito flakes", "bonza", "borlotti beans", "bran", "brazil nut", "bread", "brie", "broccoli", "broccolini", "brown flour", "brown mushrooms", "brown rice", "brown rice vinegar", "brussels sprouts", "buckwheat", "buckwheat flour", "buckwheat noodles", "bulghur", "bush tomato", "butter", "butter beans", "buttermilk", "butternut lettuce", "butternut pumpkin", "cabbage", "cacao", "cake", "calamari", "camellia tea oil", "camembert", "camomile", "candle nut", "cannellini beans", "canola oil", "cantaloupe", "capers", "capsicum", "caraway seed", "cardamom", "carob carrot", "carrot", "cashews", "cassia bark", "cauliflower", "cavalo", "cayenne", "celery", "celery seed", "cheddar", "cherries", "chestnut", "chia seeds", "chicken", "chicken stock", "chickory", "chickpea", "chilli pepper", "chinese cabbage", "chinese five spice", "chives", "choy sum", "cinnamon", "clams", "cloves", "cocoa powder", "coconut", "coconut oil", "coconut water", "coffee", "common cultivated mushrooms", "corella pear", "coriander leaves", "coriander seed", "corn oil", "corn syrup", "corn tortilla", "cornichons", "cornmeal", "cos lettuce", "cottage cheese", "cous cous", "crabs", "cranberry", "cream", "cream cheese", "cucumber", "cumin", "cumquat", "currants", "curry leaves", "curry powder", "custard apples", "dandelion", "dark chocolate", "dashi", "dates", "dill", "dragonfruit", "dried apricots", "dried chinese broccoli", "duck", "edam", "edamame", "eggplant", "eggs", "elderberry", "endive", "english spinach", "enoki mushrooms", "extra virgin olive oil", "farmed prawns", "feijoa", "fennel", "fennel seeds", "fenugreek", "feta", "figs", "file powder", "fingerlime", "fish sauce", "fish stock", "flat mushrooms", "flathead", "flaxseed", "flaxseed oil", "flounder", "flour", "freekeh", "french eschallots", "fresh chillies", "fromage blanc", "fruit", "galangal", "garam masala", "garlic", "goat cheese", "goat milk", "goji berry", "grape seed oil", "grapefruit", "grapes", "green beans", "green pepper", "green tea", "green tea noodles", "greenwheat freekeh", "gruyere", "guava", "gula melaka", "haloumi", "ham", "haricot beans", "harissa", "hazelnut", "hijiki", "hiramasa kingfish", "hokkien noodles", "honey", "honeydew melon", "horseradish", "hot smoked salmon", "hummus", "iceberg lettuce", "incaberries", "jarrahdale pumpkin", "jasmine rice", "jelly", "jerusalem artichoke", "jewfish", "jicama", "juniper berries", "kale", "kangaroo", "kecap manis", "kenchur", "kidney beans", "kidneys", "kiwi berries", "kiwi fruit", "kohlrabi", "kokam", "kombu", "koshihikari rice", "kudzu", "kumera", "lamb", "lavender flowers", "leeks", "lemon", "lemongrass", "lentils", "lettuce", "licorice", "lime leaves", "limes", "liver", "lobster", "longan", "loquats", "lotus root", "lychees", "macadamia nut", "macadamia oil", "mace", "mackerel", "mahi mahi", "mahlab", "malt vinegar", "mandarins", "mango", "mangosteens", "maple syrup", "margarine", "marigold", "marjoram", "mastic", "melon", "milk", "milk chocolate", "mint", "miso", "molasses", "monkfish", "morwong", "mountain bread", "mozzarella", "muesli", "mulberries", "mullet", "mung beans", "mussels", "mustard", "mustard seed", "nashi pear", "nasturtium", "nectarines", "nori", "nutmeg", "nutritional yeast", "nuts", "oat flour", "oatmeal", "oats", "octopus", "okra", "olive oil", "olives", "omega spread", "onion", "oranges", "oregano", "oyster mushrooms", "oyster sauce", "oysters", "pandanus leaves", "papaw", "papaya", "paprik", "parmesan cheese", "parrotfish", "parsley", "parsnip", "passionfruit", "pasta", "peaches", "peanuts", "pear", "pear juice", "pears", "peas", "pecan nut", "pecorino", "pepitas", "peppercorns", "peppermint", "peppers", "persimmon", "pine nut", "pineapple", "pinto beans", "pistachio nut", "plums", "polenta", "pomegranate", "poppy seed", "porcini mushrooms", "pork", "potato flour", "potatoes", "provolone", "prunes", "pumpkin", "pumpkin seed", "purple carrot", "purple rice", "quark", "quince", "quinoa", "radicchio", "radish", "raisin", "raspberry", "red cabbage", "red lentils", "red pepper", "red wine", "red wine vinegar", "redfish", "rhubarb", "rice flour", "rice noodles", "rice paper", "rice syrup", "ricemilk", "ricotta", "rockmelon", "rose water", "rosemary", "rye", "rye bread", "safflower oil", "saffron", "sage", "sake", "salmon", "sardines", "sausages", "scallops", "sea salt", "semolina", "sesame oil", "sesame seeds", "shark", "shiitake mushrooms", "silverbeet", "slivered almonds", "smoked trout", "snapper", "snowpea sprouts", "snowpeas", "soba", "sour dough bread", "soy", "soy beans", "soy flour", "soy milk", "soy sauce", "soymilk", "spearmint", "spelt", "spelt bread", "spinach", "spring onions", "sprouts", "squash", "squid", "star anise", "star fruit", "starfruit", "stevia", "strawberries", "sugar", "sultanas", "sun-dried tomatoes", "sunflower oil", "sunflower seeds", "sweet chilli sauce", "sweet potato", "swiss chard", "swordfish", "szechuan pepperberry", "tabasco", "tahini", "taleggio cheese", "tamari", "tamarillo", "tangelo", "tapioca", "tapioca flour", "tarragon", "tea", "tea oil", "tempeh", "thyme", "tinned", "tofu", "tom yum", "tomatoes", "trout", "tuna", "turkey", "turmeric", "turnips", "unbleached flour", "vanilla beans", "vegetable oil", "vegetable spaghetti", "vegetable stock", "vermicelli noodles", "vinegar", "wakame", "walnut", "warehou", "wasabi", "water", "watercress", "watermelon", "wattleseed", "wheat", "wheatgrass juice", "white bread", "white flour", "white rice", "white wine", "white wine vinegar", "whiting wild rice", "wholegrain bread", "wholemeal", "wholewheat flour", "william pear", "yeast", "yellow papaw", "yellowtail kingfish", "yoghurt", "yogurt", "zucchini"], UTe = ["beef", "chicken", "crocodile", "duck", "emu", "goose", "kangaroo", "lamb", "ostrich", "pigeon", "pork", "quail", "rabbit", "salmon", "turkey", "venison"], GTe = ["achiote seed", "ajwain seed", "ajwan seed", "allspice", "amchoor", "anise", "anise star", "aniseed", "annatto seed", "arrowroot", "asafoetida", "baharat", "balti masala", "balti stir fry mix", "basil", "bay leaves", "bbq", "caraway seed", "cardamom", "cassia", "cayenne pepper", "celery", "chamomile", "chervil", "chilli", "chilli pepper", "chillies", "china star", "chives", "cinnamon", "cloves", "colombo", "coriander", "cumin", "curly leaf parsley", "curry", "dhansak", "dill", "fennel seed", "fenugreek", "fines herbes", "five spice", "french lavender", "galangal", "garam masala", "garlic", "german chamomile", "ginger", "green cardamom", "herbes de provence", "jalfrezi", "jerk", "kaffir leaves", "korma", "lavender", "lemon grass", "lemon pepper", "lime leaves", "liquorice root", "mace", "mango", "marjoram", "methi", "mint", "mustard", "nutmeg", "onion seed", "orange zest", "oregano", "paprika", "parsley", "pepper", "peppercorns", "pimento", "piri piri", "poppy seed", "pot marjoram", "poudre de colombo", "ras-el-hanout", "rice paper", "rogan josh", "rose baie", "rosemary", "saffron", "sage", "sesame seed", "spearmint", "sumac", "sweet basil", "sweet laurel", "tagine", "tandoori masala", "tarragon", "thyme", "tikka masala", "turmeric", "vanilla", "zahtar"], WTe = ["artichoke", "arugula", "asian greens", "asparagus", "bean shoots", "bean sprouts", "beans", "beetroot", "bok choy", "broccoli", "broccolini", "brussels sprouts", "butternut lettuce", "cabbage", "capers", "carob carrot", "carrot", "cauliflower", "celery", "chilli pepper", "chinese cabbage", "chives", "cornichons", "cos lettuce", "cucumber", "dried chinese broccoli", "eggplant", "endive", "english spinach", "french eschallots", "fresh chillies", "garlic", "green beans", "green pepper", "hijiki", "iceberg lettuce", "jerusalem artichoke", "jicama", "kale", "kohlrabi", "leeks", "lettuce", "okra", "onion", "parsnip", "peas", "peppers", "potatoes", "pumpkin", "purple carrot", "radicchio", "radish", "red cabbage", "red pepper", "rhubarb", "snowpea sprouts", "spinach", "squash", "sun dried tomatoes", "sweet potato", "swiss chard", "turnips", "zucchini"], VTe = { adjective: PTe, description_pattern: LTe, dish: MTe, dish_pattern: OTe, ethnic_category: BTe, fruit: $Te, ingredient: HTe, meat: UTe, spice: GTe, vegetable: WTe }, KTe = VTe, zTe = ["1080p", "auxiliary", "back-end", "bluetooth", "cross-platform", "digital", "haptic", "mobile", "multi-byte", "neural", "online", "open-source", "optical", "primary", "redundant", "solid state", "virtual", "wireless"], jTe = ["backing up", "bypassing", "calculating", "compressing", "connecting", "copying", "generating", "hacking", "indexing", "navigating", "overriding", "parsing", "programming", "quantifying", "synthesizing", "transmitting"], YTe = ["alarm", "application", "array", "bandwidth", "bus", "capacitor", "card", "circuit", "driver", "feed", "firewall", "hard drive", "interface", "matrix", "microchip", "monitor", "panel", "pixel", "port", "program", "protocol", "sensor", "system", "transmitter"], qTe = ["I'll {{verb}} the {{adjective}} {{abbreviation}} {{noun}}, that should {{noun}} the {{abbreviation}} {{noun}}!", "If we {{verb}} the {{noun}}, we can get to the {{abbreviation}} {{noun}} through the {{adjective}} {{abbreviation}} {{noun}}!", "The {{abbreviation}} {{noun}} is down, {{verb}} the {{adjective}} {{noun}} so we can {{verb}} the {{abbreviation}} {{noun}}!", "Try to {{verb}} the {{abbreviation}} {{noun}}, maybe it will {{verb}} the {{adjective}} {{noun}}!", "Use the {{adjective}} {{abbreviation}} {{noun}}, then you can {{verb}} the {{adjective}} {{noun}}!", "We need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!", "You can't {{verb}} the {{noun}} without {{ingverb}} the {{adjective}} {{abbreviation}} {{noun}}!", "{{ingverb}} the {{noun}} won't do anything, we need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!"], JTe = ["back up", "bypass", "calculate", "compress", "connect", "copy", "generate", "hack", "index", "input", "navigate", "override", "parse", "program", "quantify", "reboot", "synthesize", "transmit"], QTe = { adjective: zTe, ingverb: jTe, noun: YTe, phrase: qTe, verb: JTe }, XTe = QTe, ZTe = ["biz", "com", "info", "name", "net", "org"], eve = ["example.com", "example.net", "example.org"], tve = ["gmail.com", "hotmail.com", "yahoo.com"], nve = { domain_suffix: ZTe, example_email: eve, free_email: tve }, rve = nve, ive = ["#####", "####", "###"], sve = ["Abilene", "Akron", "Alafaya", "Alameda", "Albany", "Albuquerque", "Alexandria", "Alhambra", "Aliso Viejo", "Allen", "Allentown", "Aloha", "Alpharetta", "Altadena", "Altamonte Springs", "Altoona", "Amarillo", "Ames", "Anaheim", "Anchorage", "Anderson", "Ankeny", "Ann Arbor", "Annandale", "Antelope", "Antioch", "Apex", "Apopka", "Apple Valley", "Appleton", "Arcadia", "Arden-Arcade", "Arecibo", "Arlington", "Arlington Heights", "Arvada", "Ashburn", "Asheville", "Aspen Hill", "Atascocita", "Athens-Clarke County", "Atlanta", "Attleboro", "Auburn", "Augusta-Richmond County", "Aurora", "Austin", "Avondale", "Azusa", "Bakersfield", "Baldwin Park", "Baltimore", "Barnstable Town", "Bartlett", "Baton Rouge", "Battle Creek", "Bayamon", "Bayonne", "Baytown", "Beaumont", "Beavercreek", "Beaverton", "Bedford", "Bel Air South", "Bell Gardens", "Belleville", "Bellevue", "Bellflower", "Bellingham", "Bend", "Bentonville", "Berkeley", "Berwyn", "Bethesda", "Bethlehem", "Billings", "Biloxi", "Binghamton", "Birmingham", "Bismarck", "Blacksburg", "Blaine", "Bloomington", "Blue Springs", "Boca Raton", "Boise City", "Bolingbrook", "Bonita Springs", "Bossier City", "Boston", "Bothell", "Boulder", "Bountiful", "Bowie", "Bowling Green", "Boynton Beach", "Bozeman", "Bradenton", "Brandon", "Brentwood", "Bridgeport", "Bristol", "Brockton", "Broken Arrow", "Brookhaven", "Brookline", "Brooklyn Park", "Broomfield", "Brownsville", "Bryan", "Buckeye", "Buena Park", "Buffalo", "Buffalo Grove", "Burbank", "Burien", "Burke", "Burleson", "Burlington", "Burnsville", "Caguas", "Caldwell", "Camarillo", "Cambridge", "Camden", "Canton", "Cape Coral", "Carlsbad", "Carmel", "Carmichael", "Carolina", "Carrollton", "Carson", "Carson City", "Cary", "Casa Grande", "Casas Adobes", "Casper", "Castle Rock", "Castro Valley", "Catalina Foothills", "Cathedral City", "Catonsville", "Cedar Hill", "Cedar Park", "Cedar Rapids", "Centennial", "Centreville", "Ceres", "Cerritos", "Champaign", "Chandler", "Chapel Hill", "Charleston", "Charlotte", "Charlottesville", "Chattanooga", "Cheektowaga", "Chesapeake", "Chesterfield", "Cheyenne", "Chicago", "Chico", "Chicopee", "Chino", "Chino Hills", "Chula Vista", "Cicero", "Cincinnati", "Citrus Heights", "Clarksville", "Clearwater", "Cleveland", "Cleveland Heights", "Clifton", "Clovis", "Coachella", "Coconut Creek", "Coeur d'Alene", "College Station", "Collierville", "Colorado Springs", "Colton", "Columbia", "Columbus", "Commerce City", "Compton", "Concord", "Conroe", "Conway", "Coon Rapids", "Coral Gables", "Coral Springs", "Corona", "Corpus Christi", "Corvallis", "Costa Mesa", "Council Bluffs", "Country Club", "Covina", "Cranston", "Cupertino", "Cutler Bay", "Cuyahoga Falls", "Cypress", "Dale City", "Dallas", "Daly City", "Danbury", "Danville", "Davenport", "Davie", "Davis", "Dayton", "Daytona Beach", "DeKalb", "DeSoto", "Dearborn", "Dearborn Heights", "Decatur", "Deerfield Beach", "Delano", "Delray Beach", "Deltona", "Denton", "Denver", "Des Moines", "Des Plaines", "Detroit", "Diamond Bar", "Doral", "Dothan", "Downers Grove", "Downey", "Draper", "Dublin", "Dubuque", "Duluth", "Dundalk", "Dunwoody", "Durham", "Eagan", "East Hartford", "East Honolulu", "East Lansing", "East Los Angeles", "East Orange", "East Providence", "Eastvale", "Eau Claire", "Eden Prairie", "Edina", "Edinburg", "Edmond", "El Cajon", "El Centro", "El Dorado Hills", "El Monte", "El Paso", "Elgin", "Elizabeth", "Elk Grove", "Elkhart", "Ellicott City", "Elmhurst", "Elyria", "Encinitas", "Enid", "Enterprise", "Erie", "Escondido", "Euclid", "Eugene", "Euless", "Evanston", "Evansville", "Everett", "Fairfield", "Fall River", "Fargo", "Farmington", "Farmington Hills", "Fayetteville", "Federal Way", "Findlay", "Fishers", "Flagstaff", "Flint", "Florence-Graham", "Florin", "Florissant", "Flower Mound", "Folsom", "Fond du Lac", "Fontana", "Fort Collins", "Fort Lauderdale", "Fort Myers", "Fort Pierce", "Fort Smith", "Fort Wayne", "Fort Worth", "Fountain Valley", "Fountainebleau", "Framingham", "Franklin", "Frederick", "Freeport", "Fremont", "Fresno", "Frisco", "Fullerton", "Gainesville", "Gaithersburg", "Galveston", "Garden Grove", "Gardena", "Garland", "Gary", "Gastonia", "Georgetown", "Germantown", "Gilbert", "Gilroy", "Glen Burnie", "Glendale", "Glendora", "Glenview", "Goodyear", "Grand Forks", "Grand Island", "Grand Junction", "Grand Prairie", "Grand Rapids", "Grapevine", "Great Falls", "Greeley", "Green Bay", "Greensboro", "Greenville", "Greenwood", "Gresham", "Guaynabo", "Gulfport", "Hacienda Heights", "Hackensack", "Haltom City", "Hamilton", "Hammond", "Hampton", "Hanford", "Harlingen", "Harrisburg", "Harrisonburg", "Hartford", "Hattiesburg", "Haverhill", "Hawthorne", "Hayward", "Hemet", "Hempstead", "Henderson", "Hendersonville", "Hesperia", "Hialeah", "Hicksville", "High Point", "Highland", "Highlands Ranch", "Hillsboro", "Hilo", "Hoboken", "Hoffman Estates", "Hollywood", "Homestead", "Honolulu", "Hoover", "Houston", "Huntersville", "Huntington", "Huntington Beach", "Huntington Park", "Huntsville", "Hutchinson", "Idaho Falls", "Independence", "Indianapolis", "Indio", "Inglewood", "Iowa City", "Irondequoit", "Irvine", "Irving", "Jackson", "Jacksonville", "Janesville", "Jefferson City", "Jeffersonville", "Jersey City", "Johns Creek", "Johnson City", "Joliet", "Jonesboro", "Joplin", "Jupiter", "Jurupa Valley", "Kalamazoo", "Kannapolis", "Kansas City", "Kearny", "Keller", "Kendale Lakes", "Kendall", "Kenner", "Kennewick", "Kenosha", "Kent", "Kentwood", "Kettering", "Killeen", "Kingsport", "Kirkland", "Kissimmee", "Knoxville", "Kokomo", "La Crosse", "La Habra", "La Mesa", "La Mirada", "Lacey", "Lafayette", "Laguna Niguel", "Lake Charles", "Lake Elsinore", "Lake Forest", "Lake Havasu City", "Lake Ridge", "Lakeland", "Lakeville", "Lakewood", "Lancaster", "Lansing", "Laredo", "Largo", "Las Cruces", "Las Vegas", "Lauderhill", "Lawrence", "Lawton", "Layton", "League City", "Lee's Summit", "Leesburg", "Lehi", "Lehigh Acres", "Lenexa", "Levittown", "Lewisville", "Lexington-Fayette", "Lincoln", "Linden", "Little Rock", "Littleton", "Livermore", "Livonia", "Lodi", "Logan", "Lombard", "Lompoc", "Long Beach", "Longmont", "Longview", "Lorain", "Los Angeles", "Louisville/Jefferson County", "Loveland", "Lowell", "Lubbock", "Lynchburg", "Lynn", "Lynwood", "Macon-Bibb County", "Madera", "Madison", "Malden", "Manchester", "Manhattan", "Mansfield", "Manteca", "Maple Grove", "Margate", "Maricopa", "Marietta", "Marysville", "Mayaguez", "McAllen", "McKinney", "McLean", "Medford", "Melbourne", "Memphis", "Menifee", "Mentor", "Merced", "Meriden", "Meridian", "Mesa", "Mesquite", "Metairie", "Methuen Town", "Miami", "Miami Beach", "Miami Gardens", "Middletown", "Midland", "Midwest City", "Milford", "Millcreek", "Milpitas", "Milwaukee", "Minneapolis", "Minnetonka", "Minot", "Miramar", "Mishawaka", "Mission", "Mission Viejo", "Missoula", "Missouri City", "Mobile", "Modesto", "Moline", "Monroe", "Montebello", "Monterey Park", "Montgomery", "Moore", "Moreno Valley", "Morgan Hill", "Mount Pleasant", "Mount Prospect", "Mount Vernon", "Mountain View", "Muncie", "Murfreesboro", "Murray", "Murrieta", "Nampa", "Napa", "Naperville", "Nashua", "Nashville-Davidson", "National City", "New Bedford", "New Braunfels", "New Britain", "New Brunswick", "New Haven", "New Orleans", "New Rochelle", "New York", "Newark", "Newport Beach", "Newport News", "Newton", "Niagara Falls", "Noblesville", "Norfolk", "Normal", "Norman", "North Bethesda", "North Charleston", "North Highlands", "North Las Vegas", "North Lauderdale", "North Little Rock", "North Miami", "North Miami Beach", "North Port", "North Richland Hills", "Norwalk", "Novato", "Novi", "O'Fallon", "Oak Lawn", "Oak Park", "Oakland", "Oakland Park", "Ocala", "Oceanside", "Odessa", "Ogden", "Oklahoma City", "Olathe", "Olympia", "Omaha", "Ontario", "Orange", "Orem", "Orland Park", "Orlando", "Oro Valley", "Oshkosh", "Overland Park", "Owensboro", "Oxnard", "Palatine", "Palm Bay", "Palm Beach Gardens", "Palm Coast", "Palm Desert", "Palm Harbor", "Palm Springs", "Palmdale", "Palo Alto", "Paradise", "Paramount", "Parker", "Parma", "Pasadena", "Pasco", "Passaic", "Paterson", "Pawtucket", "Peabody", "Pearl City", "Pearland", "Pembroke Pines", "Pensacola", "Peoria", "Perris", "Perth Amboy", "Petaluma", "Pflugerville", "Pharr", "Philadelphia", "Phoenix", "Pico Rivera", "Pine Bluff", "Pine Hills", "Pinellas Park", "Pittsburg", "Pittsburgh", "Pittsfield", "Placentia", "Plainfield", "Plano", "Plantation", "Pleasanton", "Plymouth", "Pocatello", "Poinciana", "Pomona", "Pompano Beach", "Ponce", "Pontiac", "Port Arthur", "Port Charlotte", "Port Orange", "Port St. Lucie", "Portage", "Porterville", "Portland", "Portsmouth", "Potomac", "Poway", "Providence", "Provo", "Pueblo", "Quincy", "Racine", "Raleigh", "Rancho Cordova", "Rancho Cucamonga", "Rancho Palos Verdes", "Rancho Santa Margarita", "Rapid City", "Reading", "Redding", "Redlands", "Redmond", "Redondo Beach", "Redwood City", "Reno", "Renton", "Reston", "Revere", "Rialto", "Richardson", "Richland", "Richmond", "Rio Rancho", "Riverside", "Riverton", "Riverview", "Roanoke", "Rochester", "Rochester Hills", "Rock Hill", "Rockford", "Rocklin", "Rockville", "Rockwall", "Rocky Mount", "Rogers", "Rohnert Park", "Rosemead", "Roseville", "Roswell", "Round Rock", "Rowland Heights", "Rowlett", "Royal Oak", "Sacramento", "Saginaw", "Salem", "Salina", "Salinas", "Salt Lake City", "Sammamish", "San Angelo", "San Antonio", "San Bernardino", "San Bruno", "San Buenaventura (Ventura)", "San Clemente", "San Diego", "San Francisco", "San Jacinto", "San Jose", "San Juan", "San Leandro", "San Luis Obispo", "San Marcos", "San Mateo", "San Rafael", "San Ramon", "San Tan Valley", "Sandy", "Sandy Springs", "Sanford", "Santa Ana", "Santa Barbara", "Santa Clara", "Santa Clarita", "Santa Cruz", "Santa Fe", "Santa Maria", "Santa Monica", "Santa Rosa", "Santee", "Sarasota", "Savannah", "Sayreville", "Schaumburg", "Schenectady", "Scottsdale", "Scranton", "Seattle", "Severn", "Shawnee", "Sheboygan", "Shoreline", "Shreveport", "Sierra Vista", "Silver Spring", "Simi Valley", "Sioux City", "Sioux Falls", "Skokie", "Smyrna", "Somerville", "South Bend", "South Gate", "South Hill", "South Jordan", "South San Francisco", "South Valley", "South Whittier", "Southaven", "Southfield", "Sparks", "Spokane", "Spokane Valley", "Spring", "Spring Hill", "Spring Valley", "Springdale", "Springfield", "St. Charles", "St. Clair Shores", "St. Cloud", "St. George", "St. Joseph", "St. Louis", "St. Louis Park", "St. Paul", "St. Peters", "St. Petersburg", "Stamford", "State College", "Sterling Heights", "Stillwater", "Stockton", "Stratford", "Strongsville", "Suffolk", "Sugar Land", "Summerville", "Sunnyvale", "Sunrise", "Sunrise Manor", "Surprise", "Syracuse", "Tacoma", "Tallahassee", "Tamarac", "Tamiami", "Tampa", "Taunton", "Taylor", "Taylorsville", "Temecula", "Tempe", "Temple", "Terre Haute", "Texas City", "The Hammocks", "The Villages", "The Woodlands", "Thornton", "Thousand Oaks", "Tigard", "Tinley Park", "Titusville", "Toledo", "Toms River", "Tonawanda", "Topeka", "Torrance", "Town 'n' Country", "Towson", "Tracy", "Trenton", "Troy", "Trujillo Alto", "Tuckahoe", "Tucson", "Tulare", "Tulsa", "Turlock", "Tuscaloosa", "Tustin", "Twin Falls", "Tyler", "Union City", "University", "Upland", "Urbana", "Urbandale", "Utica", "Vacaville", "Valdosta", "Vallejo", "Vancouver", "Victoria", "Victorville", "Vineland", "Virginia Beach", "Visalia", "Vista", "Waco", "Waipahu", "Waldorf", "Walnut Creek", "Waltham", "Warner Robins", "Warren", "Warwick", "Washington", "Waterbury", "Waterloo", "Watsonville", "Waukegan", "Waukesha", "Wauwatosa", "Wellington", "Wesley Chapel", "West Allis", "West Babylon", "West Covina", "West Des Moines", "West Hartford", "West Haven", "West Jordan", "West Lafayette", "West New York", "West Palm Beach", "West Sacramento", "West Seneca", "West Valley City", "Westfield", "Westland", "Westminster", "Weston", "Weymouth Town", "Wheaton", "White Plains", "Whittier", "Wichita", "Wichita Falls", "Wilmington", "Wilson", "Winston-Salem", "Woodbury", "Woodland", "Worcester", "Wylie", "Wyoming", "Yakima", "Yonkers", "Yorba Linda", "York", "Youngstown", "Yuba City", "Yucaipa", "Yuma"], ave = ["{{location.city_prefix}} {{person.first_name.generic}}{{location.city_suffix}}", "{{location.city_prefix}} {{person.first_name.generic}}", "{{person.first_name.generic}}{{location.city_suffix}}", "{{person.last_name.generic}}{{location.city_suffix}}", "{{location.city_name}}"], ove = ["North", "East", "West", "South", "New", "Lake", "Port", "Fort"], uve = ["town", "ton", "land", "ville", "berg", "burgh", "boro", "borough", "bury", "view", "port", "mouth", "stad", "stead", "furt", "chester", "cester", "fort", "field", "haven", "side", "shire", "worth"], lve = ["Africa", "Antarctica", "Asia", "Australia", "Europe", "North America", "South America"], cve = ["Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (Chagos Archipelago)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Cook Islands", "Costa Rica", "Côte d'Ivoire", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Faroe Islands", "Falkland Islands (Malvinas)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Democratic People's Republic of Korea", "Republic of Korea", "Kuwait", "Kyrgyz Republic", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Macedonia", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn Islands", "Poland", "Portugal", "Puerto Rico", "Qatar", "Réunion", "Romania", "Russian Federation", "Rwanda", "Saint Barthélemy", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard & Jan Mayen Islands", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States of America", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"], hve = ["Adams County", "Calhoun County", "Carroll County", "Clark County", "Clay County", "Crawford County", "Douglas County", "Fayette County", "Franklin County", "Grant County", "Greene County", "Hamilton County", "Hancock County", "Henry County", "Jackson County", "Jefferson County", "Johnson County", "Lake County", "Lawrence County", "Lee County", "Lincoln County", "Logan County", "Madison County", "Marion County", "Marshall County", "Monroe County", "Montgomery County", "Morgan County", "Perry County", "Pike County", "Polk County", "Scott County", "Union County", "Warren County", "Washington County", "Wayne County", "Avon", "Bedfordshire", "Berkshire", "Borders", "Buckinghamshire", "Cambridgeshire", "Central", "Cheshire", "Cleveland", "Clwyd", "Cornwall", "County Antrim", "County Armagh", "County Down", "County Fermanagh", "County Londonderry", "County Tyrone", "Cumbria", "Derbyshire", "Devon", "Dorset", "Dumfries and Galloway", "Durham", "Dyfed", "East Sussex", "Essex", "Fife", "Gloucestershire", "Grampian", "Greater Manchester", "Gwent", "Gwynedd County", "Hampshire", "Herefordshire", "Hertfordshire", "Highlands and Islands", "Humberside", "Isle of Wight", "Kent", "Lancashire", "Leicestershire", "Lincolnshire", "Lothian", "Merseyside", "Mid Glamorgan", "Norfolk", "North Yorkshire", "Northamptonshire", "Northumberland", "Nottinghamshire", "Oxfordshire", "Powys", "Rutland", "Shropshire", "Somerset", "South Glamorgan", "South Yorkshire", "Staffordshire", "Strathclyde", "Suffolk", "Surrey", "Tayside", "Tyne and Wear", "Warwickshire", "West Glamorgan", "West Midlands", "West Sussex", "West Yorkshire", "Wiltshire", "Worcestershire"], dve = { cardinal: ["North", "East", "South", "West"], cardinal_abbr: ["N", "E", "S", "W"], ordinal: ["Northeast", "Northwest", "Southeast", "Southwest"], ordinal_abbr: ["NE", "NW", "SE", "SW"] }, fve = [{ name: "Afrikaans", alpha2: "af", alpha3: "afr" }, { name: "Azerbaijani", alpha2: "az", alpha3: "aze" }, { name: "Maldivian", alpha2: "dv", alpha3: "div" }, { name: "Farsi/Persian", alpha2: "fa", alpha3: "fas" }, { name: "Latvian", alpha2: "lv", alpha3: "lav" }, { name: "Indonesian", alpha2: "id", alpha3: "ind" }, { name: "Nepali", alpha2: "ne", alpha3: "nep" }, { name: "Thai", alpha2: "th", alpha3: "tha" }, { name: "Uzbek", alpha2: "uz", alpha3: "uzb" }, { name: "Yoruba", alpha2: "yo", alpha3: "yor" }, { name: "Pashto", alpha2: "ps", alpha3: "pus" }, { name: "English", alpha2: "en", alpha3: "eng" }, { name: "Urdu", alpha2: "ur", alpha3: "urd" }, { name: "German", alpha2: "de", alpha3: "deu" }, { name: "French", alpha2: "fr", alpha3: "fra" }, { name: "Spanish", alpha2: "es", alpha3: "spa" }, { name: "Italian", alpha2: "it", alpha3: "ita" }, { name: "Dutch", alpha2: "nl", alpha3: "nld" }, { name: "Russian", alpha2: "ru", alpha3: "rus" }, { name: "Portuguese", alpha2: "pt", alpha3: "por" }, { name: "Polish", alpha2: "pl", alpha3: "pol" }, { name: "Arabic", alpha2: "ar", alpha3: "ara" }, { name: "Japanese", alpha2: "ja", alpha3: "jpn" }, { name: "Chinese", alpha2: "zh", alpha3: "zho" }, { name: "Hindi", alpha2: "hi", alpha3: "hin" }, { name: "Bengali", alpha2: "bn", alpha3: "ben" }, { name: "Gujarati", alpha2: "gu", alpha3: "guj" }, { name: "Tamil", alpha2: "ta", alpha3: "tam" }, { name: "Telugu", alpha2: "te", alpha3: "tel" }, { name: "Punjabi", alpha2: "pa", alpha3: "pan" }, { name: "Vietnamese", alpha2: "vi", alpha3: "vie" }, { name: "Korean", alpha2: "ko", alpha3: "kor" }, { name: "Turkish", alpha2: "tr", alpha3: "tur" }, { name: "Swedish", alpha2: "sv", alpha3: "swe" }, { name: "Greek", alpha2: "el", alpha3: "ell" }, { name: "Czech", alpha2: "cs", alpha3: "ces" }, { name: "Hungarian", alpha2: "hu", alpha3: "hun" }, { name: "Romanian", alpha2: "ro", alpha3: "ron" }, { name: "Ukrainian", alpha2: "uk", alpha3: "ukr" }, { name: "Norwegian", alpha2: "no", alpha3: "nor" }, { name: "Serbian", alpha2: "sr", alpha3: "srp" }, { name: "Croatian", alpha2: "hr", alpha3: "hrv" }, { name: "Slovak", alpha2: "sk", alpha3: "slk" }, { name: "Slovenian", alpha2: "sl", alpha3: "slv" }, { name: "Icelandic", alpha2: "is", alpha3: "isl" }, { name: "Finnish", alpha2: "fi", alpha3: "fin" }, { name: "Danish", alpha2: "da", alpha3: "dan" }, { name: "Swahili", alpha2: "sw", alpha3: "swa" }, { name: "Bashkir", alpha2: "ba", alpha3: "bak" }, { name: "Basque", alpha2: "eu", alpha3: "eus" }, { name: "Catalan", alpha2: "ca", alpha3: "cat" }, { name: "Galician", alpha2: "gl", alpha3: "glg" }, { name: "Esperanto", alpha2: "eo", alpha3: "epo" }, { name: "Fijian", alpha2: "fj", alpha3: "fij" }, { name: "Malagasy", alpha2: "mg", alpha3: "mlg" }, { name: "Maltese", alpha2: "mt", alpha3: "mlt" }, { name: "Albanian", alpha2: "sq", alpha3: "sqi" }, { name: "Armenian", alpha2: "hy", alpha3: "hye" }, { name: "Georgian", alpha2: "ka", alpha3: "kat" }, { name: "Macedonian", alpha2: "mk", alpha3: "mkd" }, { name: "Kazakh", alpha2: "kk", alpha3: "kaz" }, { name: "Haitian Creole", alpha2: "ht", alpha3: "hat" }, { name: "Mongolian", alpha2: "mn", alpha3: "mon" }, { name: "Kyrgyz", alpha2: "ky", alpha3: "kir" }, { name: "Finnish", alpha2: "fi", alpha3: "fin" }, { name: "Tagalog", alpha2: "tl", alpha3: "tgl" }, { name: "Malay", alpha2: "ms", alpha3: "msa" }, { name: "Tajik", alpha2: "tg", alpha3: "tgk" }, { name: "Swati", alpha2: "ss", alpha3: "ssw" }, { name: "Tatar", alpha2: "tt", alpha3: "tat" }, { name: "Zulu", alpha2: "zu", alpha3: "zul" }], mve = ["#####", "#####-####"], gve = ["Apt. ###", "Suite ###"], pve = ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"], bve = ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"], yve = { normal: "{{location.buildingNumber}} {{location.street}}", full: "{{location.buildingNumber}} {{location.street}} {{location.secondaryAddress}}" }, Ave = ["10th Street", "11th Street", "12th Street", "13th Street", "14th Street", "15th Street", "16th Street", "1st Avenue", "1st Street", "2nd Avenue", "2nd Street", "3rd Avenue", "3rd Street", "4th Avenue", "4th Street", "5th Avenue", "5th Street", "6th Avenue", "6th Street", "7th Avenue", "7th Street", "8th Avenue", "8th Street", "9th Street", "A Street", "Abbey Road", "Adams Avenue", "Adams Street", "Airport Road", "Albany Road", "Albert Road", "Albion Street", "Alexandra Road", "Alfred Street", "Alma Street", "Ash Close", "Ash Grove", "Ash Road", "Ash Street", "Aspen Close", "Atlantic Avenue", "Avenue Road", "Back Lane", "Baker Street", "Balmoral Road", "Barn Close", "Barton Road", "Bath Road", "Bath Street", "Bay Street", "Beach Road", "Bedford Road", "Beech Close", "Beech Drive", "Beech Grove", "Beech Road", "Beechwood Avenue", "Bell Lane", "Belmont Road", "Birch Avenue", "Birch Close", "Birch Grove", "Birch Road", "Blind Lane", "Bluebell Close", "Boundary Road", "Bramble Close", "Bramley Close", "Bridge Road", "Bridge Street", "Broad Lane", "Broad Street", "Broadway", "Broadway Avenue", "Broadway Street", "Brook Lane", "Brook Road", "Brook Street", "Brookside", "Buckingham Road", "Cambridge Street", "Canal Street", "Castle Close", "Castle Lane", "Castle Road", "Castle Street", "Cavendish Road", "Cedar Avenue", "Cedar Close", "Cedar Grove", "Cedar Road", "Cedar Street", "Cemetery Road", "Center Avenue", "Center Road", "Center Street", "Central Avenue", "Central Street", "Chapel Close", "Chapel Hill", "Chapel Road", "Chapel Street", "Charles Street", "Cherry Close", "Cherry Street", "Cherry Tree Close", "Chester Road", "Chestnut Close", "Chestnut Drive", "Chestnut Grove", "Chestnut Street", "Church Avenue", "Church Close", "Church Hill", "Church Lane", "Church Path", "Church Road", "Church Street", "Church View", "Church Walk", "Claremont Road", "Clarence Road", "Clarence Street", "Clarendon Road", "Clark Street", "Clay Lane", "Cleveland Street", "Cliff Road", "Clifton Road", "Clinton Street", "College Avenue", "College Street", "Columbia Avenue", "Commerce Street", "Commercial Road", "Commercial Street", "Common Lane", "Coronation Avenue", "Coronation Road", "County Line Road", "County Road", "Court Street", "Cow Lane", "Crescent Road", "Cromwell Road", "Cross Lane", "Cross Street", "Crown Street", "Cumberland Street", "Dale Street", "Dark Lane", "Davis Street", "Depot Street", "Derby Road", "Derwent Close", "Devonshire Road", "Division Street", "Douglas Road", "Duke Street", "E 10th Street", "E 11th Street", "E 12th Street", "E 14th Street", "E 1st Street", "E 2nd Street", "E 3rd Street", "E 4th Avenue", "E 4th Street", "E 5th Street", "E 6th Avenue", "E 6th Street", "E 7th Street", "E 8th Street", "E 9th Street", "E Bridge Street", "E Broad Street", "E Broadway", "E Broadway Street", "E Cedar Street", "E Center Street", "E Central Avenue", "E Church Street", "E Elm Street", "E Franklin Street", "E Front Street", "E Grand Avenue", "E High Street", "E Jackson Street", "E Jefferson Street", "E Main", "E Main Street", "E Maple Street", "E Market Street", "E North Street", "E Oak Street", "E Park Avenue", "E Pine Street", "E River Road", "E South Street", "E State Street", "E Union Street", "E Walnut Street", "E Washington Avenue", "E Washington Street", "E Water Street", "East Avenue", "East Road", "East Street", "Edward Street", "Elm Close", "Elm Grove", "Elm Road", "Elm Street", "Euclid Avenue", "Fairfield Road", "Farm Close", "Ferry Road", "Field Close", "Field Lane", "First Avenue", "First Street", "Fore Street", "Forest Avenue", "Forest Road", "Fourth Avenue", "Franklin Avenue", "Franklin Road", "Franklin Street", "Front Street", "Frontage Road", "Garden Close", "Garden Street", "George Street", "Gladstone Road", "Glebe Close", "Gloucester Road", "Gordon Road", "Gordon Street", "Grand Avenue", "Grange Avenue", "Grange Close", "Grange Road", "Grant Street", "Green Close", "Green Lane", "Green Street", "Greenville Road", "Greenway", "Greenwood Road", "Grove Lane", "Grove Road", "Grove Street", "Hall Lane", "Hall Street", "Harrison Avenue", "Harrison Street", "Hawthorn Avenue", "Hawthorn Close", "Hazel Close", "Hazel Grove", "Heath Road", "Heather Close", "Henry Street", "Heron Close", "Hickory Street", "High Road", "High Street", "Highfield Avenue", "Highfield Close", "Highfield Road", "Highland Avenue", "Hill Road", "Hill Street", "Hillside", "Hillside Avenue", "Hillside Close", "Hillside Road", "Holly Close", "Honeysuckle Close", "Howard Road", "Howard Street", "Jackson Avenue", "Jackson Street", "James Street", "Jefferson Avenue", "Jefferson Street", "Johnson Street", "Jubilee Close", "Juniper Close", "Kent Road", "Kestrel Close", "King Street", "King's Road", "Kingfisher Close", "Kings Highway", "Kingsway", "Laburnum Grove", "Lafayette Street", "Lake Avenue", "Lake Drive", "Lake Road", "Lake Street", "Lancaster Road", "Lansdowne Road", "Larch Close", "Laurel Close", "Lawrence Street", "Lee Street", "Liberty Street", "Lime Grove", "Lincoln Avenue", "Lincoln Highway", "Lincoln Road", "Lincoln Street", "Locust Street", "Lodge Close", "Lodge Lane", "London Road", "Long Lane", "Low Road", "Madison Avenue", "Madison Street", "Main", "Main Avenue", "Main Road", "Main Street", "Main Street E", "Main Street N", "Main Street S", "Main Street W", "Manchester Road", "Manor Close", "Manor Drive", "Manor Gardens", "Manor Road", "Manor Way", "Maple Avenue", "Maple Close", "Maple Drive", "Maple Road", "Maple Street", "Market Place", "Market Square", "Market Street", "Marlborough Road", "Marsh Lane", "Martin Luther King Boulevard", "Martin Luther King Drive", "Martin Luther King Jr Boulevard", "Mary Street", "Mayfield Road", "Meadow Close", "Meadow Drive", "Meadow Lane", "Meadow View", "Meadow Way", "Memorial Drive", "Middle Street", "Mill Close", "Mill Lane", "Mill Road", "Mill Street", "Milton Road", "Milton Street", "Monroe Street", "Moor Lane", "Moss Lane", "Mount Pleasant", "Mount Street", "Mulberry Street", "N 1st Street", "N 2nd Street", "N 3rd Street", "N 4th Street", "N 5th Street", "N 6th Street", "N 7th Street", "N 8th Street", "N 9th Street", "N Bridge Street", "N Broad Street", "N Broadway", "N Broadway Street", "N Cedar Street", "N Center Street", "N Central Avenue", "N Chestnut Street", "N Church Street", "N College Street", "N Court Street", "N Division Street", "N East Street", "N Elm Street", "N Franklin Street", "N Front Street", "N Harrison Street", "N High Street", "N Jackson Street", "N Jefferson Street", "N Lincoln Street", "N Locust Street", "N Main", "N Main Avenue", "N Main Street", "N Maple Street", "N Market Street", "N Monroe Street", "N Oak Street", "N Park Street", "N Pearl Street", "N Pine Street", "N Poplar Street", "N Railroad Street", "N State Street", "N Union Street", "N Walnut Street", "N Washington Avenue", "N Washington Street", "N Water Street", "Nelson Road", "Nelson Street", "New Lane", "New Road", "New Street", "Newton Road", "Nightingale Close", "Norfolk Road", "North Avenue", "North Lane", "North Road", "North Street", "Northfield Road", "Oak Avenue", "Oak Drive", "Oak Lane", "Oak Road", "Oak Street", "Oakfield Road", "Oaklands", "Old Lane", "Old Military Road", "Old Road", "Old State Road", "Orchard Drive", "Orchard Lane", "Orchard Road", "Orchard Street", "Oxford Road", "Oxford Street", "Park Avenue", "Park Crescent", "Park Drive", "Park Lane", "Park Place", "Park Road", "Park Street", "Park View", "Parkside", "Pearl Street", "Pennsylvania Avenue", "Pine Close", "Pine Grove", "Pine Street", "Pinfold Lane", "Pleasant Street", "Poplar Avenue", "Poplar Close", "Poplar Road", "Poplar Street", "Post Road", "Pound Lane", "Princes Street", "Princess Street", "Priory Close", "Priory Road", "Prospect Avenue", "Prospect Place", "Prospect Road", "Prospect Street", "Quarry Lane", "Quarry Road", "Queen's Road", "Railroad Avenue", "Railroad Street", "Railway Street", "Rectory Close", "Rectory Lane", "Richmond Close", "Richmond Road", "Ridge Road", "River Road", "River Street", "Riverside", "Riverside Avenue", "Riverside Drive", "Roman Road", "Roman Way", "Rowan Close", "Russell Street", "S 10th Street", "S 14th Street", "S 1st Avenue", "S 1st Street", "S 2nd Street", "S 3rd Street", "S 4th Street", "S 5th Street", "S 6th Street", "S 7th Street", "S 8th Street", "S 9th Street", "S Bridge Street", "S Broad Street", "S Broadway", "S Broadway Street", "S Center Street", "S Central Avenue", "S Chestnut Street", "S Church Street", "S College Street", "S Division Street", "S East Street", "S Elm Street", "S Franklin Street", "S Front Street", "S Grand Avenue", "S High Street", "S Jackson Street", "S Jefferson Street", "S Lincoln Street", "S Main", "S Main Avenue", "S Main Street", "S Maple Street", "S Market Street", "S Mill Street", "S Monroe Street", "S Oak Street", "S Park Street", "S Pine Street", "S Railroad Street", "S State Street", "S Union Street", "S Walnut Street", "S Washington Avenue", "S Washington Street", "S Water Street", "S West Street", "Salisbury Road", "Sandringham Road", "Sandy Lane", "School Close", "School Lane", "School Road", "School Street", "Second Avenue", "Silver Street", "Skyline Drive", "Smith Street", "Somerset Road", "South Avenue", "South Drive", "South Road", "South Street", "South View", "Spring Gardens", "Spring Street", "Springfield Close", "Springfield Road", "Spruce Street", "St Andrew's Road", "St Andrews Close", "St George's Road", "St John's Road", "St Mary's Close", "St Mary's Road", "Stanley Road", "Stanley Street", "State Avenue", "State Line Road", "State Road", "State Street", "Station Road", "Station Street", "Stoney Lane", "Sycamore Avenue", "Sycamore Close", "Sycamore Drive", "Sycamore Street", "Talbot Road", "Tennyson Road", "The Avenue", "The Beeches", "The Causeway", "The Chase", "The Coppice", "The Copse", "The Crescent", "The Croft", "The Dell", "The Drive", "The Fairway", "The Glebe", "The Grange", "The Green", "The Grove", "The Hawthorns", "The Lane", "The Laurels", "The Limes", "The Maltings", "The Meadows", "The Mews", "The Mount", "The Oaks", "The Orchard", "The Oval", "The Paddock", "The Paddocks", "The Poplars", "The Ridgeway", "The Ridings", "The Rise", "The Sidings", "The Spinney", "The Square", "The Willows", "The Woodlands", "Third Avenue", "Third Street", "Tower Road", "Trinity Road", "Tudor Close", "Union Avenue", "Union Street", "University Avenue", "University Drive", "Valley Road", "Veterans Memorial Drive", "Veterans Memorial Highway", "Vicarage Close", "Vicarage Lane", "Vicarage Road", "Victoria Place", "Victoria Road", "Victoria Street", "Vine Street", "W 10th Street", "W 11th Street", "W 12th Street", "W 14th Street", "W 1st Street", "W 2nd Street", "W 3rd Street", "W 4th Avenue", "W 4th Street", "W 5th Street", "W 6th Avenue", "W 6th Street", "W 7th Street", "W 8th Street", "W 9th Street", "W Bridge Street", "W Broad Street", "W Broadway", "W Broadway Avenue", "W Broadway Street", "W Center Street", "W Central Avenue", "W Chestnut Street", "W Church Street", "W Division Street", "W Elm Street", "W Franklin Street", "W Front Street", "W Grand Avenue", "W High Street", "W Jackson Street", "W Jefferson Street", "W Lake Street", "W Main", "W Main Street", "W Maple Street", "W Market Street", "W Monroe Street", "W North Street", "W Oak Street", "W Park Street", "W Pine Street", "W River Road", "W South Street", "W State Street", "W Union Street", "W Walnut Street", "W Washington Avenue", "W Washington Street", "Walnut Close", "Walnut Street", "Warren Close", "Warren Road", "Washington Avenue", "Washington Boulevard", "Washington Road", "Washington Street", "Water Lane", "Water Street", "Waterloo Road", "Waterside", "Watery Lane", "Waverley Road", "Well Lane", "Wellington Road", "Wellington Street", "West Avenue", "West End", "West Lane", "West Road", "West Street", "West View", "Western Avenue", "Western Road", "Westfield Road", "Westgate", "William Street", "Willow Close", "Willow Drive", "Willow Grove", "Willow Road", "Willow Street", "Windermere Road", "Windmill Close", "Windmill Lane", "Windsor Avenue", "Windsor Close", "Windsor Drive", "Wood Lane", "Wood Street", "Woodland Close", "Woodland Road", "Woodlands", "Woodlands Avenue", "Woodlands Close", "Woodlands Road", "Woodside", "Woodside Road", "Wren Close", "Yew Tree Close", "York Road", "York Street"], Eve = ["{{person.first_name.generic}} {{location.street_suffix}}", "{{person.last_name.generic}} {{location.street_suffix}}", "{{location.street_name}}"], Sve = ["Alley", "Avenue", "Branch", "Bridge", "Brook", "Brooks", "Burg", "Burgs", "Bypass", "Camp", "Canyon", "Cape", "Causeway", "Center", "Centers", "Circle", "Circles", "Cliff", "Cliffs", "Club", "Common", "Corner", "Corners", "Course", "Court", "Courts", "Cove", "Coves", "Creek", "Crescent", "Crest", "Crossing", "Crossroad", "Curve", "Dale", "Dam", "Divide", "Drive", "Drives", "Estate", "Estates", "Expressway", "Extension", "Extensions", "Fall", "Falls", "Ferry", "Field", "Fields", "Flat", "Flats", "Ford", "Fords", "Forest", "Forge", "Forges", "Fork", "Forks", "Fort", "Freeway", "Garden", "Gardens", "Gateway", "Glen", "Glens", "Green", "Greens", "Grove", "Groves", "Harbor", "Harbors", "Haven", "Heights", "Highway", "Hill", "Hills", "Hollow", "Inlet", "Island", "Islands", "Isle", "Junction", "Junctions", "Key", "Keys", "Knoll", "Knolls", "Lake", "Lakes", "Land", "Landing", "Lane", "Light", "Lights", "Loaf", "Lock", "Locks", "Lodge", "Loop", "Mall", "Manor", "Manors", "Meadow", "Meadows", "Mews", "Mill", "Mills", "Mission", "Motorway", "Mount", "Mountain", "Mountains", "Neck", "Orchard", "Oval", "Overpass", "Park", "Parks", "Parkway", "Parkways", "Pass", "Passage", "Path", "Pike", "Pine", "Pines", "Place", "Plain", "Plains", "Plaza", "Point", "Points", "Port", "Ports", "Prairie", "Radial", "Ramp", "Ranch", "Rapid", "Rapids", "Rest", "Ridge", "Ridges", "River", "Road", "Roads", "Route", "Row", "Rue", "Run", "Shoal", "Shoals", "Shore", "Shores", "Skyway", "Spring", "Springs", "Spur", "Spurs", "Square", "Squares", "Station", "Stravenue", "Stream", "Street", "Streets", "Summit", "Terrace", "Throughway", "Trace", "Track", "Trafficway", "Trail", "Tunnel", "Turnpike", "Underpass", "Union", "Unions", "Valley", "Valleys", "Via", "Viaduct", "View", "Views", "Village", "Villages", "Ville", "Vista", "Walk", "Walks", "Wall", "Way", "Ways", "Well", "Wells"], wve = { building_number: ive, city_name: sve, city_pattern: ave, city_prefix: ove, city_suffix: uve, continent: lve, country: cve, county: hve, direction: dve, language: fve, postcode: mve, secondary_address: gve, state: pve, state_abbr: bve, street_address: yve, street_name: Ave, street_pattern: Eve, street_suffix: Sve }, Fve = wve, Tve = ["a", "ab", "abbas", "abduco", "abeo", "abscido", "absconditus", "absens", "absorbeo", "absque", "abstergo", "absum", "abundans", "abutor", "accedo", "accendo", "acceptus", "accommodo", "accusamus", "accusantium", "accusator", "acer", "acerbitas", "acervus", "acidus", "acies", "acquiro", "acsi", "ad", "adamo", "adaugeo", "addo", "adduco", "ademptio", "adeo", "adeptio", "adfectus", "adfero", "adficio", "adflicto", "adhaero", "adhuc", "adicio", "adimpleo", "adinventitias", "adipisci", "adipiscor", "adiuvo", "administratio", "admiratio", "admitto", "admoneo", "admoveo", "adnuo", "adopto", "adsidue", "adstringo", "adsuesco", "adsum", "adulatio", "adulescens", "aduro", "advenio", "adversus", "advoco", "aedificium", "aeger", "aegre", "aegrotatio", "aegrus", "aeneus", "aequitas", "aequus", "aer", "aestas", "aestivus", "aestus", "aetas", "aeternus", "ager", "aggero", "aggredior", "agnitio", "agnosco", "ago", "ait", "aiunt", "alias", "alienus", "alii", "alioqui", "aliqua", "aliquam", "aliquid", "alius", "allatus", "alo", "alter", "altus", "alveus", "amaritudo", "ambitus", "ambulo", "amet", "amicitia", "amiculum", "amissio", "amita", "amitto", "amo", "amor", "amoveo", "amplexus", "amplitudo", "amplus", "ancilla", "angelus", "angulus", "angustus", "animadverto", "animi", "animus", "annus", "anser", "ante", "antea", "antepono", "antiquus", "aperiam", "aperio", "aperte", "apostolus", "apparatus", "appello", "appono", "appositus", "approbo", "apto", "aptus", "apud", "aqua", "ara", "aranea", "arbitro", "arbor", "arbustum", "arca", "arceo", "arcesso", "architecto", "arcus", "argentum", "argumentum", "arguo", "arma", "armarium", "aro", "ars", "articulus", "artificiose", "arto", "arx", "ascisco", "ascit", "asper", "asperiores", "aspernatur", "aspicio", "asporto", "assentator", "assumenda", "astrum", "at", "atavus", "ater", "atque", "atqui", "atrocitas", "atrox", "attero", "attollo", "attonbitus", "auctor", "auctus", "audacia", "audax", "audentia", "audeo", "audio", "auditor", "aufero", "aureus", "aurum", "aut", "autem", "autus", "auxilium", "avaritia", "avarus", "aveho", "averto", "baiulus", "balbus", "barba", "bardus", "basium", "beatae", "beatus", "bellicus", "bellum", "bene", "beneficium", "benevolentia", "benigne", "bestia", "bibo", "bis", "blandior", "blanditiis", "bonus", "bos", "brevis", "cado", "caecus", "caelestis", "caelum", "calamitas", "calcar", "calco", "calculus", "callide", "campana", "candidus", "canis", "canonicus", "canto", "capillus", "capio", "capitulus", "capto", "caput", "carbo", "carcer", "careo", "caries", "cariosus", "caritas", "carmen", "carpo", "carus", "casso", "caste", "casus", "catena", "caterva", "cattus", "cauda", "causa", "caute", "caveo", "cavus", "cedo", "celebrer", "celer", "celo", "cena", "cenaculum", "ceno", "censura", "centum", "cerno", "cernuus", "certe", "certus", "cervus", "cetera", "charisma", "chirographum", "cibo", "cibus", "cicuta", "cilicium", "cimentarius", "ciminatio", "cinis", "circumvenio", "cito", "civis", "civitas", "clam", "clamo", "claro", "clarus", "claudeo", "claustrum", "clementia", "clibanus", "coadunatio", "coaegresco", "coepi", "coerceo", "cogito", "cognatus", "cognomen", "cogo", "cohaero", "cohibeo", "cohors", "colligo", "collum", "colo", "color", "coma", "combibo", "comburo", "comedo", "comes", "cometes", "comis", "comitatus", "commemoro", "comminor", "commodi", "commodo", "communis", "comparo", "compello", "complectus", "compono", "comprehendo", "comptus", "conatus", "concedo", "concido", "conculco", "condico", "conduco", "confero", "confido", "conforto", "confugo", "congregatio", "conicio", "coniecto", "conitor", "coniuratio", "conor", "conqueror", "conscendo", "consectetur", "consequatur", "consequuntur", "conservo", "considero", "conspergo", "constans", "consuasor", "contabesco", "contego", "contigo", "contra", "conturbo", "conventus", "convoco", "copia", "copiose", "cornu", "corona", "corporis", "corpus", "correptius", "corrigo", "corroboro", "corrumpo", "corrupti", "coruscus", "cotidie", "crapula", "cras", "crastinus", "creator", "creber", "crebro", "credo", "creo", "creptio", "crepusculum", "cresco", "creta", "cribro", "crinis", "cruciamentum", "crudelis", "cruentus", "crur", "crustulum", "crux", "cubicularis", "cubitum", "cubo", "cui", "cuius", "culpa", "culpo", "cultellus", "cultura", "cum", "cumque", "cunabula", "cunae", "cunctatio", "cupiditas", "cupiditate", "cupio", "cuppedia", "cupressus", "cur", "cura", "curatio", "curia", "curiositas", "curis", "curo", "curriculum", "currus", "cursim", "curso", "cursus", "curto", "curtus", "curvo", "custodia", "damnatio", "damno", "dapifer", "debeo", "debilito", "debitis", "decens", "decerno", "decet", "decimus", "decipio", "decor", "decretum", "decumbo", "dedecor", "dedico", "deduco", "defaeco", "defendo", "defero", "defessus", "defetiscor", "deficio", "defleo", "defluo", "defungo", "degenero", "degero", "degusto", "deinde", "delectatio", "delectus", "delego", "deleniti", "deleo", "delibero", "delicate", "delinquo", "deludo", "demens", "demergo", "demitto", "demo", "demonstro", "demoror", "demulceo", "demum", "denego", "denique", "dens", "denuncio", "denuo", "deorsum", "depereo", "depono", "depopulo", "deporto", "depraedor", "deprecator", "deprimo", "depromo", "depulso", "deputo", "derelinquo", "derideo", "deripio", "deserunt", "desidero", "desino", "desipio", "desolo", "desparatus", "despecto", "dicta", "dignissimos", "distinctio", "dolor", "dolore", "dolorem", "doloremque", "dolores", "doloribus", "dolorum", "ducimus", "ea", "eaque", "earum", "eius", "eligendi", "enim", "eos", "error", "esse", "est", "et", "eum", "eveniet", "ex", "excepturi", "exercitationem", "expedita", "explicabo", "facere", "facilis", "fuga", "fugiat", "fugit", "harum", "hic", "id", "illo", "illum", "impedit", "in", "incidunt", "infit", "inflammatio", "inventore", "ipsa", "ipsam", "ipsum", "iste", "itaque", "iure", "iusto", "labore", "laboriosam", "laborum", "laudantium", "libero", "magnam", "magni", "maiores", "maxime", "minima", "minus", "modi", "molestiae", "molestias", "mollitia", "nam", "natus", "necessitatibus", "nemo", "neque", "nesciunt", "nihil", "nisi", "nobis", "non", "nostrum", "nulla", "numquam", "occaecati", "ocer", "odio", "odit", "officia", "officiis", "omnis", "optio", "paens", "pariatur", "patior", "patria", "patrocinor", "patruus", "pauci", "paulatim", "pauper", "pax", "peccatus", "pecco", "pecto", "pectus", "pecus", "peior", "pel", "perferendis", "perspiciatis", "placeat", "porro", "possimus", "praesentium", "provident", "quae", "quaerat", "quam", "quas", "quasi", "qui", "quia", "quibusdam", "quidem", "quis", "quisquam", "quo", "quod", "quos", "ratione", "recusandae", "reiciendis", "rem", "repellat", "repellendus", "reprehenderit", "repudiandae", "rerum", "saepe", "sapiente", "sed", "sequi", "similique", "sint", "sit", "socius", "sodalitas", "sol", "soleo", "solio", "solitudo", "solium", "sollers", "sollicito", "solum", "solus", "soluta", "solutio", "solvo", "somniculosus", "somnus", "sonitus", "sono", "sophismata", "sopor", "sordeo", "sortitus", "spargo", "speciosus", "spectaculum", "speculum", "sperno", "spero", "spes", "spiculum", "spiritus", "spoliatio", "sponte", "stabilis", "statim", "statua", "stella", "stillicidium", "stipes", "stips", "sto", "strenuus", "strues", "studio", "stultus", "suadeo", "suasoria", "sub", "subito", "subiungo", "sublime", "subnecto", "subseco", "substantia", "subvenio", "succedo", "succurro", "sufficio", "suffoco", "suffragium", "suggero", "sui", "sulum", "sum", "summa", "summisse", "summopere", "sumo", "sumptus", "sunt", "supellex", "super", "suppellex", "supplanto", "suppono", "supra", "surculus", "surgo", "sursum", "suscipio", "suscipit", "suspendo", "sustineo", "suus", "synagoga", "tabella", "tabernus", "tabesco", "tabgo", "tabula", "taceo", "tactus", "taedium", "talio", "talis", "talus", "tam", "tamdiu", "tamen", "tametsi", "tamisium", "tamquam", "tandem", "tantillus", "tantum", "tardus", "tego", "temeritas", "temperantia", "templum", "tempora", "tempore", "temporibus", "temptatio", "tempus", "tenax", "tendo", "teneo", "tener", "tenetur", "tenuis", "tenus", "tepesco", "tepidus", "ter", "terebro", "teres", "terga", "tergeo", "tergiversatio", "tergo", "tergum", "termes", "terminatio", "tero", "terra", "terreo", "territo", "terror", "tersus", "tertius", "testimonium", "texo", "textilis", "textor", "textus", "thalassinus", "theatrum", "theca", "thema", "theologus", "thermae", "thesaurus", "thesis", "thorax", "thymbra", "thymum", "tibi", "timidus", "timor", "titulus", "tolero", "tollo", "tondeo", "tonsor", "torqueo", "torrens", "tot", "totam", "totidem", "toties", "totus", "tracto", "trado", "traho", "trans", "tredecim", "tremo", "trepide", "tres", "tribuo", "tricesimus", "triduana", "tripudio", "tristis", "triumphus", "trucido", "truculenter", "tubineus", "tui", "tum", "tumultus", "tunc", "turba", "turbo", "turpis", "tutamen", "tutis", "tyrannus", "uberrime", "ubi", "ulciscor", "ullam", "ullus", "ulterius", "ultio", "ultra", "umbra", "umerus", "umquam", "una", "unde", "undique", "universe", "unus", "urbanus", "urbs", "uredo", "usitas", "usque", "ustilo", "ustulo", "usus", "ut", "uter", "uterque", "utilis", "utique", "utor", "utpote", "utrimque", "utroque", "utrum", "uxor", "vaco", "vacuus", "vado", "vae", "valde", "valens", "valeo", "valetudo", "validus", "vallum", "vapulus", "varietas", "varius", "vehemens", "vel", "velit", "velociter", "velum", "velut", "venia", "veniam", "venio", "ventito", "ventosus", "ventus", "venustas", "ver", "verbera", "verbum", "vere", "verecundia", "vereor", "vergo", "veritas", "veritatis", "vero", "versus", "verto", "verumtamen", "verus", "vesco", "vesica", "vesper", "vespillo", "vester", "vestigium", "vestrum", "vetus", "via", "vicinus", "vicissitudo", "victoria", "victus", "videlicet", "video", "viduo", "vigilo", "vigor", "vilicus", "vilis", "vilitas", "villa", "vinco", "vinculum", "vindico", "vinitor", "vinum", "vir", "virga", "virgo", "viridis", "viriliter", "virtus", "vis", "viscus", "vita", "vitae", "vitiosus", "vitium", "vito", "vivo", "vix", "vobis", "vociferor", "voco", "volaticus", "volo", "volubilis", "voluntarius", "volup", "voluptas", "voluptate", "voluptatem", "voluptates", "voluptatibus", "voluptatum", "volutabrum", "volva", "vomer", "vomica", "vomito", "vorago", "vorax", "voro", "vos", "votum", "voveo", "vox", "vulariter", "vulgaris", "vulgivagus", "vulgo", "vulgus", "vulnero", "vulnus", "vulpes", "vulticulus", "xiphias"], vve = { word: Tve }, xve = vve, Cve = { title: "English", code: "en", language: "en", endonym: "English", dir: "ltr", script: "Latn" }, kve = Cve, _ve = ['"Awaken, My Love!"', "(What's The Story) Morning Glory?", "- Tragedy +", "13 Reasons Why (Season 3)", "21st Century Breakdown", "30 De Febrero", "432 Hz Deep Healing", "5-Star", "528 Hz Meditation Music", "54+1", "8 Mile", "808s & Heartbreak", "9 To 5 And Odd Jobs", "A Beautiful Lie", "A Day At The Races", "A Day Without Rain", "A Fever You Can't Sweat Out", "A Gangsta's Pain", "A Gift & A Curse", "A Hard Day's Night", "A Head Full Of Dreams", "A Kind Of Magic", "A Million Ways To Murder", "A Moment Apart", "A Song For Every Moon", "A Thousand Suns", "A Winter Romance", "ABBA", "AI YoungBoy", "AJ Tracey", "Act One", "After Hours", "Agent Provocateur", "All About You", "All I Know So Far: Setlist", "All Or Nothing", "All Out", "All Over The Place", "All Stand Together", "All The Lost Souls", "All The Things I Never Said", "All Things Must Pass", "Alleen", "Alright, Still", "Alta Suciedad", "America", "American Heartbreak", "American Teen", "And Justice For None", "Animal Songs", "Another Friday Night", "Anything Goes", "Ao Vivo Em São Paulo", "Ao Vivo No Ibirapuera", "Apricot Princess", "Aqui E Agora (Ao Vivo)", "Arcane League Of Legends", "Ardipithecus", "Aretha Now", "Around The Fur", "Arrival", "Artist 2.0", "As She Pleases", "Ascend", "Ashlyn", "Astro Lounge", "At Night, Alone.", "At. Long. Last. ASAP", "Atlas", "Audioslave", "Aura", "Austin", "Awake", "Away From The Sun", "Ayayay!", "Baby On Baby", "Back For Everything", "Back From The Edge", "Back In Black", "Back To Black", "Back To The Game", "Bad", "Bahía Ducati", "Baila", "Barbie The Album", "Battleground", "Bayou Country", "Bcos U Will Never B Free", "Be", "Be Here Now", "Beautiful Mind", "Beautiful Thugger Girls", "Beautiful Trauma", "Beauty And The Beast", "Beggars Banquet", "Being Funny In A Foreign Language", "Berlin Lebt", "Berry Is On Top", "Best White Noise For Baby Sleep - Loopable With No Fade", "Big Baby DRAM", "Bigger, Better, Faster, More!", "Billy Talent II", "Black Star Elephant", "Blackout", "Blank Face LP", "Bleach", "Blizzard Of Ozz", "Blonde", "Blood Sugar Sex Magik", "Bloom", "Blowin' Your Mind!", "Blu Celeste", "Blue", "Blue Banisters", "Blue Hawaii", "Blue Neighbourhood", "Bluebird Days", "Bobby Tarantino", "Bobby Tarantino II", "Bon Iver", "Born Pink", "Born To Run", "Brand New Eyes", "Break The Cycle", "Breakfast In America", "Breakthrough", "Brett Young", "Bridge Over Troubled Water", "Bright: The Album", "Brol", "Buds", "Buena Vista Social Club", "Built On Glass", "Bury Me At Makeout Creek", "Busyhead", "By The Way", "CB6", "CNCO", "California Sunrise", "Californication", "Call Me Irresponsible", "Calm", "Camino Palmero", "Camp", "Caracal", "Carbon Fiber Hits", "Carnival", "Carry On", "Cartel De Santa", "Certified Lover Boy", "Chaaama", "Chama Meu Nome", "Chapter 1: Snake Oil", "Chapter 2: Swamp Savant", "Chapter One", "Charlie's Angels", "Cherry Bomb", "Chief", "Chocolate Factory", "Chosen", "Chris Brown", "Christina Aguilera", "Chromatica", "Church", "City Of Evil", "Clandestino", "Clouds", "Coco", "Collision Course", "Colour Vision", "Combat Rock", "Come Around Sundown", "Come Away With Me", "Come Home The Kids Miss You", "Come What(ever) May", "Commando", "Common Sense", "Communion", "Conditions", "Confident", "Confrontation", "Control The Streets, Volume 2", "Corinne Bailey Rae", "Costello Music", "Cottonwood", "Covers, Vol. 2", "Cozy Tapes Vol. 2: Too Cozy", "Crash Talk", "Crazy Love", "Crazysexycool", "Crowded House", "Cruisin' With Junior H", "Culture", "Current Mood", "DS2", "Dale", "Danger Days: The True Lives Of The Fabulous Killjoys", "Dangerous Woman", "Dangerous: The Double Album", "Dark Horse", "Day69", "Daydream", "De Fiesta", "De Viaje", "DeAnn", "Death Race For Love", "Delirium", "Delta", "Demidevil", "Depression Cherry", "Descendants", "Desgenerados Mixtape", "Destin", "Destiny Fulfilled", "Desvelado", "Detroit 2", "Dex Meets Dexter", "Dharma", "Die A Legend", "Different World", "Dig Your Roots", "Digital Druglord", "Dirt", "Disclaimer I / II", "Discovery", "Disraeli Gears", "Disumano", "Dizzy Up The Girl", "Don't Play That Song", "Donda", "Donde Quiero Estar", "Doo-Wops & Hooligans", "Down The Way", "Dr. Feelgood", "Dream Your Life Away", "Dreaming Out Loud", "Drip Harder", "Drive", "Drones", "Dropped Outta College", "Drowning", "Dua Warna Cinta", "Dulce Beat", "Dusty In Memphis", "Dutty Rock", "Dying To Live", "ENR", "East Atlanta Love Letter", "Editorial", "Edna", "El Abayarde", "El Amor En Los Tiempos Del Perreo", "El Camino", "El Comienzo", "El Dorado", "El Karma", "El Mal Querer", "El Malo", "El Trabajo Es La Suerte", "El Viaje De Copperpot", "Electric Ladyland", "Emotion", "En Tus Planes", "Endless Summer Vacation", "Enter The Wu-Tang (36 Chambers)", "Equals (=)", "Estrella", "Euphoria", "Europop", "Evermore", "Every Kingdom", "Everyday Life", "Evolve", "Expectations", "Face Yourself", "Facelift", "Fallin'", "Fancy You", "Fantasía", "Favourite Worst Nightmare", "Fear Of The Dark", "Fearless", "Feel Something", "Feels Like Home", "Femme Fatale", "Ferxxocalipsis", "Fifty Shades Darker", "Fifty Shades Freed", "Fifty Shades Of Grey", "Final (Vol.1)", "Finding Beauty In Negative Spaces", "Fine Line", "First Impressions Of Earth", "First Steps", "Five Seconds Flat", "Folklore", "For Emma, Forever Ago", "Forajido EP 1", "Forever", "Forever Young", "Formula Of Love: O+T=<3", "Free 6lack", "Freudian", "Frozen II", "Full Moon Fever", "Funhouse", "Funk Wav Bounces Vol.1", "Future History", "FutureSex/LoveSounds", "Fuzzybrain", "Gallery", "Gangsta's Paradise", "Gemini", "Gemini Rights", "Generationwhy", "Get A Grip", "Get Up", "Gettin' Old", "Girl", "Gladiator", "Glisten", "Globalization", "Gloria", "Glory Days", "God's Project", "Gold Skies", "Golden", "Good Evening", "Good Thing", "Goodbye Yellow Brick Road", "Gossip Columns", "Got Your Six", "Graceland", "Graduation", "Grand Champ", "Grandson, Vol. 1", "Green River", "Guerra", "Ha*Ash Primera Fila - Hecho Realidad", "Haiz", "Hamilton", "Happy Endings", "Harry Styles", "Hasta La Raíz", "Hatful Of Hollow", "Head In The Clouds", "Heard It In A Past Life", "Heart Shaped World", "Heartbeat City", "Heartbreak On A Full Moon / Cuffing Season - 12 Days Of Christmas", "Heaven Or Hell", "Heaven knows", "Hellbilly Deluxe", "Hellboy", "Help!", "Her Loss", "Here Comes The Cowboy", "Hey World", "High School Musical", "High Tide In The Snake's Nest", "Historias De Un Capricornio", "Hndrxx", "Hombres G (Devuélveme A Mi Chica)", "Homerun", "Homework", "Hot Fuss", "Hot Pink", "Hot Sauce / Hello Future", "Hot Space", "Hotel Diablo", "Houses Of The Holy", "How Big, How Blue, How Beautiful", "How I'm Feeling", "How To Be Human", "How To Save A Life", "How To: Friend, Love, Freefall", "Hozier", "Human", "Huncho Jack, Jack Huncho", "Hunter Hayes", "Hysteria", "I Am...Sasha Fierce", "I Can't Handle Change", "I Met You When I Was 18. (The Playlist)", "I Never Liked You", "I Never Loved A Man The Way I Love You", "I See You", "I Think You Think Too Much Of Me", "I Used To Know Her", "I Used To Think I Could Fly", "I'm Comin' Over", "Ich & Keine Maske", "If You Can Believe Your Eyes & Ears", "Il Ballo Della Vita", "Ill Communication", "Imagination & The Misfit Kid", "Imagine", "Immortalized", "In A Perfect World...", "In Colour", "In My Own Words", "In Rainbows", "In Return", "In The Lonely Hour", "Infest", "Innuendo", "Inter Shibuya - La Mafia", "Interstellar", "Is This It", "It Was Written", "It's Not Me, It's You", "It's Only Me", "Ivory", "JackBoys", "Jamie", "Jazz", "Jibrail & Iblis", "Jordi", "Jordin Sparks", "Jose", "Just As I Am", "Just Cause Y'all Waited 2", "Just Like You", "Justified", "K-12 / After School", "K.I.D.S.", "K.O.", "K.O.B. Live", "KG0516", "KOD", "Kane Brown", "Kid A", "Kid Krow", "Kids See Ghosts", "Kids in Love", "Kinks (You Really Got Me)", "Know-It-All", "Konvicted", "Kring", "LANY", "LM5", "La Criatura", "La Flaca", "La Melodia De La Calle", "La Revolucion", "Lady Lady", "Lady Wood", "Langit Mong Bughaw", "Las Que No Iban A Salir", "Last Day Of Summer", "Last Year Was Complicated", "Layers", "Layover", "Lazarus", "Led Zeppelin", "Left Of The Middle", "Leftoverture", "Legends Never Die", "Let's Skip To The Wedding", "Let's Talk About Love", "Licensed To Ill", "Life In Cartoon Motion", "Life Thru A Lens", "Lifelines", "Like..?", "Lil Big Pac", "Lil Boat", "Lil Boat 2", "Lil Boat 3.5", "Lil Kiwi", "Lil Pump", "Limon Y Sal", "Listen Without Prejudice", "Little Voice", "Live On Red Barn Radio I & II", "Lo Que Andábamos Buscando", "Lofi Fruits Music 2021", "London Calling", "Los Campeones Del Pueblo", "Los Extraterrestres", "Los Favoritos 2", "Lost", "Lost In Love", "Loud", "Love Sick", "Love Story", "Love Stuff", "Love Yourself: Tear", "Lover", "Luca Brasi 2: Gangsta Grillz", "Lust For Life", "Luv Is Rage", "M!ssundaztood", "Ma Fleur", "Made In Lagos", "Mafia Bidness", "Magazines Or Novels", "Mainstream Sellout", "Majestic", "Make It Big", "Make Yourself", "Making Mirrors", "Mamma Mia! Here We Go Again", "Man Of The Woods", "Manic", "Me And My Gang", "Meduza", "Meet The Orphans", "Meet The Woo", "Melim", "Mellon Collie And The Infinite Sadness", "Melly vs. Melvin", "Memories...Do Not Open", "Menagerie", "Midnights", "Minecraft - Volume Alpha", "Minutes To Midnight", "Mix Pa Llorar En Tu Cuarto", "Modo Avión", "Monkey Business", "Mono.", "Montana", "Montevallo", "Moosetape", "Morning View", "Motivan2", "Moving Pictures", "Mr. Davis", "Mr. Misunderstood", "Mulan", "Mura Masa", "Music From The Edge Of Heaven", "Music Of The Sun", "My House", "My Kinda Party", "My Krazy Life", "My Liver Will Handle What My Heart Can't", "My Moment", "My Own Lane", "My Turn", "My Worlds", "Na Praia (Ao Vivo)", "Nakamura", "Nation Of Two", "Navegando", "Need You Now", "Neon Future III", "Neotheater", "Never Trust A Happy Song", "New English", "News Of The World", "Nicole", "Night & Day", "Nimmerland", "Nimrod", "Nine Track Mind", "No Angel", "No Me Pidas Perdón", "No More Drama", "No Protection", "No Strings Attached", "No Time To Die", "Nobody Is Listening", "Non Stop Erotic Cabaret", "Non-Fiction", "Northsbest", "Nostalgia", "Nostalgia, Ultra", "Notes On A Conditional Form", "Now Or Never", "O Embaixador (Ao Vivo)", "O My Heart", "OK Computer", "Ocean", "Ocean Avenue", "Ocean Eyes", "Odisea", "Oh My My", "Oh, What A Life", "On The 6", "One In A Million", "One More Light", "One Of These Nights", "Open Up And Say...Ahh!", "Ordinary Man", "Origins", "Out Of The Blue", "Over It", "OzuTochi", "PTSD", "Pa Las Baby's Y Belikeada", "Pa Que Hablen", "Pa' Luego Es Tarde", "Pa' Otro La 'O", "Pablo Honey", "Pain Is Love", "Pain Is Temporary", "Painting Pictures", "Palmen Aus Plastik 2", "Para Mi Ex", "Para Siempre", "Partners In Crime", "Pawn Shop", "Pegasus / Neon Shark VS Pegasus", "Pet Sounds", "Piece By Piece", "Pier Pressure", "Pineapple Sunrise", "Piseiro 2020 Ao Vivo", "Planet Pit", "Plans", "Play Deep", "Playa Saturno", "Por Primera Vez", "Por Vida", "Positions", "Post Human: Survival Horror", "Poster Girl", "Prazer, Eu Sou Ferrugem (Ao Vivo)", "Pretty Girls Like Trap Music", "Pretty. Odd.", "Prince Royce", "Prisma", "Prometo", "Providence", "Puberty 2", "Punisher", "Purgatory", "Purple Rain", "Que Bendición", "Queen Of The Clouds", "Quiero Volver", "R&G (Rhythm & Gangsta): The Masterpiece", "Raise!", "Ransom 2", "Rapunzel", "Rare", "Re Mida", "Ready To Die", "Realer", "Rebelde", "Reclassified", "Recovery", "Recuerden Mi Estilo", "Reggatta De Blanc", "Regulate… G Funk Era", "Reik", "Reise, Reise", "Relapse", "Relaxing Piano Lullabies And Natural Sleep Aid For Baby Sleep Music", "Religiously. The Album.", "Replay", "Results May Vary", "Revenge", "Revolve", "Revolver", "Ricky Martin", "Rien 100 Rien", "Ripcord", "Rise And Fall, Rage And Grace", "Rise Of An Empire", "Robin Hood: Prince Of Thieves", "Rock N Roll Jesus", "Romance", "Romances", "Ronan", "Royal Blood", "Rumours", "Sad Boyz 4 Life II", "San Lucas", "Santana World", "Saturation III", "Sauce Boyz", "Savage Mode", "Saxobeats", "Scarlet", "Schwarzes Herz", "Seal The Deal & Let's Boogie", "Section.80", "Segundo Romance", "Sehnsucht", "Shake The Snow Globe", "Shang-Chi And The Legend Of The Ten Rings: The Album", "Sheer Heart Attack", "Shiesty Season", "Shock Value", "Shoot For The Stars, Aim For The Moon", "Signed Sealed And Delivered", "Signos", "Silent Alarm", "Simplemente Gracias", "Sin Bandera", "Sing Me A Lullaby, My Sweet Temptation", "Sinner", "Sirio", "Sit Still, Look Pretty", "Skin", "Slowhand", "Smash", "Smithereens", "Snow Cougar", "Social Cues", "Some Girls", "Song Hits From Holiday Inn", "Songs For Dads", "Songs For The Deaf", "Songs For You, Truths For Me", "Songs In The Key Of Life", "Souled Out", "Sounds Of Silence", "Soy Como Quiero Ser", "Speak Now", "Speak Your Mind", "Speakerboxxx/The Love Below", "Spider-Man: Into The Spider-Verse", "Split Decision", "Square Up", "SremmLife", "Starboy", "Stay +", "Stay Dangerous", "Staying At Tamara's", "Steppenwolf", "Stick Season", "Still Bill", "Straight Outta Compton", "Strange Trails", "Stronger", "Suavemente", "Sublime", "Suck It and See", "Sucker", "Sueños", "Sugar", "Summer Forever", "Summer,", "Sunset Season", "Sunshine On Leith", "Surfer Rosa", "Sweet Talker", "SweetSexySavage", "System Of A Down", "TA13OO", "Talk That Talk", "Talking Heads: 77", "Tangled Up", "Tango In The Night", "Taxi Driver", "Taylor Swift", "Tell Me It's Real", "Ten", "Ten Summoner's Tales", "Terra Sem Cep (Ao Vivo)", "Terral", "Testing", "Tha Carter III", "Thank Me Later", "That's Christmas To Me", "The Academy", "The Adventures Of Bobby Ray", "The Album", "The Andy Williams Christmas Album", "The Aviary", "The Balcony", "The Battle Of Los Angeles", "The Beatles (White Album)", "The Beginning", "The Better Life", "The Big Day", "The Book", "The Breakfast Club", "The Cars", "The Colour And The Shape", "The Death Of Peace Of Mind", "The Diary Of Alicia Keys", "The Documentary", "The Emancipation Of Mimi", "The Eminem Show", "The End Of Everything", "The Final Countdown", "The Forever Story", "The Foundation", "The Goat", "The Golden Child", "The Good Parts", "The Greatest Showman: Reimagined", "The Green Trip", "The Hardest Love", "The Head And The Heart", "The Human Condition", "The Infamous", "The Lady Killer", "The Last Don II", "The Lion King", "The Lockdown Sessions", "The London Sessions", "The Lord Of The Rings: The Fellowship Of The Ring", "The Lost Boy", "The Magic Of Christmas / The Christmas Song", "The Marshall Mathers LP", "The Martin Garrix Collection", "The Melodic Blue", "The Mockingbird & The Crow", "The Pains Of Growing", "The Papercut Chronicles", "The Perfect Luv Tape", "The Pinkprint", "The Predator", "The Queen Is Dead", "The ReVe Festival: Finale", "The Rise And Fall Of Ziggy Stardust And The Spiders From Mars", "The Rising Tied", "The River", "The Stone Roses", "The Story Of Us", "The Stranger", "The Sufferer & The Witness", "The Sun's Tirade", "The Temptations Sing Smokey", "The Time Of Our Lives", "The Way It Is", "The Wonderful World Of Sam Cooke", "The Writing's On The Wall", "The Young And The Hopeless", "Therapy", "Therapy Session", "There Is More (Live)", "There Is Nothing Left To Lose", "These Things Happen", "Third Eye Blind", "This Is Me...Then", "This Unruly Mess I've Made", "Threat to Survival", "Thrill Of The Chase", "Time", "Timelezz", "To Let A Good Thing Die", "To Pimp A Butterfly", "Toast To Our Differences", "Todos Os Cantos, Vol. 1 (Ao Vivo)", "Too Hard", "Torches X", "Total Xanarchy", "Toto IV", "Toulouse Street", "Tourist History", "Toxicity", "Tragic Kingdom", "Tranquility Base Hotel & Casino", "Traumazine", "Traveler", "Tres Hombres", "Trip At Knight", "Tron: Legacy", "True Blue", "True Colors", "Trustfall", "Tu Veneno Mortal", "Tudo Em Paz", "Ubuntu", "Ugly Is Beautiful", "Ultra 2021", "Una Mattina", "Unbroken", "Uncovered", "Under Pressure", "Unsponsored Content", "Unstoppable", "Unwritten", "Urban Flora", "Urban Hymns", "Use Your Illusion I", "Veneer", "Versions Of Me", "Vibes", "Vice Versa", "Vices & Virtues", "Victory", "Vida", "Viejo Marihuano", "Visualízate", "Walk Away", "Walk Me Home...", "Watch The Throne", "Wave", "We Broke The Rules", "We Love You Tecca", "We Love You Tecca 2", "Weezer (Green Album)", "Welcome To The Madhouse", "Westlife", "What A Time To Be Alive", "What Do You Think About The Car?", "What Is Love?", "What Makes You Country", "What Separates Me From You", "What You See Is What You Get / What You See Ain't Always What You Get", "When It's Dark Out", "When We All Fall Asleep, Where Do We Go?", "Where The Light Is", "While The World Was Burning", "White Pony", "Whitney", "Who Really Cares", "Who You Are", "Who's Next", "Wide Open", "Wilder Mind", "Wildfire", "Willy And The Poor Boys", "Wings / You Never Walk Alone", "Wish", "Wish You Were Here", "Without Warning", "Wonder", "X&Y", "XOXO", "Y Que Quede Claro", "YBN: The Mixtape", "Yo Creo", "You Will Regret", "Youngblood", "Younger Now", "Youth"], Nve = ["$NOT", "$uicideboy$", "(G)I-DLE", "*NSYNC", "2 Chainz", "21 Savage", "6LACK", "? & The Mysterians", "A Boogie Wit da Hoodie", "A Taste of Honey", "A Tribe Called Quest", "A-Ha", "ABBA", "AC/DC", "AJ Tracey", "ATEEZ", "Ace of Base", "Adele", "Ado", "Aerosmith", "Agust D", "Aitana", "Al Dexter & his Troopers", "Al Green", "Al Jolson", "Al Martino", "Alan Jackson", "Alannah Myles", "Alec Benjamin", "Alejandro Sanz", "Alesso", "Alfredo Olivas", "Ali Gatie", "Alice In Chains", "Alina Baraz", "All Time Low", "All-4-One", "All-American Rejects", "Alok", "America", "American Quartet", "Amii Stewart", "Amitabh Bhattacharya", "Ana Castela", "Anderson .Paak", "Andy Grammer", "Angus & Julia Stone", "Anirudh Ravichander", "Anita Ward", "Anitta", "Anton Karas", "Anuel AA", "Arcade Fire", "Archie Bell & The Drells", "Archies", "Aretha Franklin", "Arizona Zervas", "Armin van Buuren", "Arthur Conley", "Artie Shaw", "Asake", "Asees Kaur", "Association", "Atif Aslam", "Audioslave", "Aventura", "Avril Lavigne", "Aya Nakamura", "B J Thomas", "B.o.B", "BLACKPINK", "BONES", "BROCKHAMPTON", "BTS", "Baby Keem", "Bachman-Turner Overdrive", "Backstreet Boys", "Bad Bunny", "Badshah", "Bailey Zimmerman", "Banda El Recodo", "Barbra Streisand", "Barry White", "Bazzi", "Bebe Rexha", "Becky G", "Becky Hill", "Bee Gees", "Ben Bernie", "Ben Howard", "Ben Selvin", "Berlin", "Bessie Smith", "Bethel Music", "Bette Midler", "Beyonce", "Bibi Blocksberg", "Bibi und Tina", "BigXthaPlug", "Bill Doggett", "Bill Haley & his Comets", "Bill Withers", "Billy Davis Jr", "Billy Joel", "Billy Paul", "Billy Preston", "Billy Swan", "Birdy", "Bizarrap", "Blake Shelton", "Blur", "Bob Marley & The Wailers", "Bob Seger", "Bobby Darin", "Bobby Lewis", "Bobby McFerrin", "Bobby Vinton", "Boney M.", "Bonez MC", "Bonnie Tyler", "Booba", "Boston", "BoyWithUke", "Boyce Avenue", "Bradley Cooper", "Bread", "Brent Faiyaz", "Brett Young", "Bring Me The Horizon", "Britney Spears", "Brooks & Dunn", "Bruce Channel", "Bruno & Marrone", "Bryan Adams", "Bryce Vine", "Buddy Holly", "Burna Boy", "C. Tangana", "CKay", "CRO", "Camilo", "Capital Bra", "Captain & Tennille", "Cardi B", "Carin Leon", "Carlos Vives", "Carly Simon", "Carpenters", "Cavetown", "Celine Dion", "Central Cee", "Chaka Khan", "Champs", "Charlie Rich", "Chayanne", "Cheat Codes", "Cher", "Chic", "Chicago", "Chris Brown", "Chris Isaak", "Chris Young", "Christina Aguilera", "Christina Perri", "Christopher Cross", "Chuck Berry", "Ciara", "Cigarettes After Sex", "Cliff Edwards (Ukelele Ike)", "Cody Johnson", "Colbie Caillat", "Colby O'Donis", "Cole Swindell", "Coleman Hawkins", "Contours", "Coolio", "Count Basie", "Cris Mj", "Culture Club", "Cyndi Lauper", "D-Block Europe", "DAY6", "DJ Khaled", "DJ Luian", "DJ Nelson", "DMX", "DNCE", "DaVido", "Dadju", "Daft Punk", "Dan + Shay", "Daniel Powter", "Danny Ocean", "Darius Rucker", "Dave", "David Bowie", "David Guetta", "Daya", "Dean Martin", "Deee-Lite", "Deep Purple", "Deftones", "Demi Lovato", "Dennis Lloyd", "Denzel Curry", "Dermot Kennedy", "Desiigner", "Devo", "Dewa 19", "Dexys Midnight Runners", "Diddy", "Dido", "Die drei !!!", "Diego & Victor Hugo", "Diljit Dosanjh", "Dimitri Vegas & Like Mike", "Dinah Shore", "Dionne Warwick", "Dire Straits", "Disclosure", "Dixie Cups", "Doja Cat", "Dolly Parton", "Don Diablo", "Don Henley", "Don McLean", "Don Omar", "Donna Summer", "Donovan", "Dr. Dre", "Drake", "Dreamville", "Dua Lipa", "EMF", "ENHYPEN", "Earth, Wind & Fire", "Ed Sheeran", "Eddie Cantor", "Eddie Cochran", "Eddy Howard", "Edgar Winter Group", "Edwin Hawkins Singers", "Edwin Starr", "El Alfa", "Eladio Carrion", "Electric Light Orchestra", "Elevation Worship", "Ella Henderson", "Ellie Goulding", "Elton John", "Elvis Presley", "Empire of the Sun", "En Vogue", "Enrique Iglesias", "Eslabon Armado", "Ethel Waters", "Etta James", "Evanescence", "Exile", "Extreme", "Faith Hill", "Fall Out Boy", "Fanny Brice", "Farruko", "Fats Domino", "Fats Waller", "Feid", "Felix Jaehn", "Fergie", "Fetty Wap", "Fiersa Besari", "Fifth Harmony", "Fine Young Cannibals", "Five Finger Death Punch", "Fleetwood Mac", "Flo-Rida", "Florence + The Machine", "Flume", "Foo Fighters", "Foreigner", "Foster The People", "Four Aces", "Frank Ocean", "Frank Sinatra", "Frankie Avalon", "Frankie Valli", "Fred Astaire", "Freda Payne", "Freddie Dredd", "Freddy Fender", "French Montana", "Fuerza Regida", "Fujii Kaze", "Future", "G-Eazy", "Garfunkel and Oates", "Gary Lewis & The Playboys", "Gary Numan", "Gene Autry", "Gene Chandler", "Gene Vincent", "George Michael", "George Strait", "Gera MX", "Ghost", "Ghostemane", "Gigi D'Agostino", "Gladys Knight & The Pips", "Glass Animals", "Glee Cast", "Gloria Gaynor", "Godsmack", "Gorillaz", "Gotye", "Grand Funk Railroad", "Green Day", "Grouplove", "Grupo Firme", "Grupo Marca Registrada", "Gryffin", "Gucci Mane", "Guess Who", "Gunna", "Gusttavo Lima", "Guy Mitchell", "Gwen Stefani", "Gzuz", "H.E.R.", "HARDY", "Hailee Steinfeld", "Halsey", "Hans Zimmer", "Harris Jayaraj", "Harry Chapin", "Harry James", "Harry Nilsson", "Harry Styles", "Hayley Williams", "Herb Alpert", "Herman's Hermits", "Hillsong UNITED", "Hillsong Worship", "Hollywood Undead", "Honey Cone", "Hoobastank", "Hues Corporation", "I Prevail", "ITZY", "IVE", "Ice Cube", "Ice Spice", "Iggy Azalea", "Imagine Dragons", "Incubus", "Internet Money", "Isaac Hayes", "J Geils Band", "J. Cole", "JAY-Z", "JJ Lin", "JP Saxe", "JVKE", "Jack Harlow", "Jack Johnson", "Jackie Wilson", "Jacquees", "James Arthur", "James Brown", "James TW", "James Taylor", "Jamie Foxx", "Janet Jackson", "Janis Joplin", "Jason Aldean", "Jason Mraz", "Jay Chou", "Jay Sean", "Jay Wheeler", "Jaymes Young", "Jean Knight", "Jeezy", "Jennifer Lopez", "Jennifer Warnes", "Jeremih", "Jeremy Zucker", "Jerry Lee Lewis", "Jerry Murad's Harmonicats", "Jess Glynne", "Jessie J", "Jewel", "Jimi Hendrix", "Jimin", "Jimmie Rodgers", "Jimmy Dean", "Jo Stafford", "Joan Jett & The Blackhearts", "Joao Gilberto", "Joel Corry", "John Fred & The Playboy Band", "John Legend", "John Mayer", "John Williams", "Johnnie Ray", "Johnnie Taylor", "Johnny Cash", "Johnny Horton", "Johnny Mathis", "Johnny Mercer", "Johnny Nash", "Joji", "Jon Bellion", "Jonas Blue", "Jonas Brothers", "Joni James", "Jorja Smith", "Juan Gabriel", "Juan Luis Guerra 4.40", "Juanes", "Juice Newton", "Julia Michaels", "Justin Bieber", "Justin Quiles", "KALEO", "KAROL G", "KAYTRANADA", "KK", "KSI", "KYLE", "Kacey Musgraves", "Kane Brown", "Kanye West", "Karan Aujla", "Kate Smith", "Katy Perry", "Kay Kyser", "Ke$ha", "Kehlani", "Kelly Clarkson", "Kenny Chesney", "Kenny Loggins", "Kenny Rogers", "Kenshi Yonezu", "Kenya Grace", "Kevin Gates", "Key Glock", "Khalid", "Kim Carnes", "Kim Petras", "Kimbra", "Kina", "King Gnu", "Kings of Leon", "Kingsmen", "Kitty Kallen", "Kodak Black", "Kodaline", "Kollegah", "Kool & The Gang", "Kungs", "Kygo", "Kylie Minogue", "LE SSERAFIM", "LISA", "LMFAO", "LUDMILLA", "La Adictiva Banda San José de Mesillas", "La Oreja de Van Gogh", "Labrinth", "Lady Antebellum", "Lady GaGa", "Lainey Wilson", "Lana Del Rey", "Latto", "Lauryn Hill", "Lauv", "League of Legends", "Lee Brice", "Leon Bridges", "Leona Lewis", "Lesley Gore", "Leslie Odom Jr.", "Liam Payne", "Lifehouse", "Lil Baby", "Lil Dicky", "Lil Durk", "Lil Mosey", "Lil Nas X", "Lil Pump", "Lil Skies", "Lil Tjay", "Lil Uzi Vert", "Lil Yachty", "Lil' Kim", "Lil' Wayne", "Lin-Manuel Miranda", "Linkin Park", "Lionel Richie", "Lipps Inc", "Lisa Loeb", "Little Peggy March", "Little Richard", "Lofi Fruits Music", "Lord Huron", "Los Del Rio", "Los Dos Carnales", "Los Lobos", "Los Temerarios", "Los Tigres Del Norte", "Los Tucanes De Tijuana", "Lou Reed", "Loud Luxury", "Louis Jordan", "Louis Tomlinson", "Love Unlimited", "Lovin' Spoonful", "Luan Santana", "Luciano", "Luis Miguel", "Luis R Conriquez", "Lulu", "Lunay", "Lupe Fiasco", "M", "MAX", "MC Hammer", "MC Ryan SP", "MKTO", "Mabel", "Machine Gun Kelly", "Madison Beer", "Madonna", "Mahalini", "Major Lazer", "Mambo Kingz", "Maneskin", "Marco Antonio Solís", "Margaret Whiting", "Maria Becerra", "Mario", "Mario Lanza", "Mark Ronson", "Maroon 5", "Marshmello", "Martin Garrix", "Mary Ford", "Mary J Blige", "Mary J. Blige", "Mary Wells", "Matoma", "Mau y Ricky", "Meek Mill", "Megadeth", "Melanie", "Melanie Martinez", "Melendi", "Men At Work", "Metro Boomin", "Michael Bublé", "Michael Jackson", "Michael McDonald", "Michael Sembello", "Miguel", "Mike Posner", "Miley Cyrus", "Milky Chance", "Minnie Riperton", "Miracle Tones", "Miranda Lambert", "Mohit Chauhan", "Mon Laferte", "Moneybagg Yo", "Monsta X", "Mora", "Morad", "Morat", "Mother Mother", "Motley Crue", "Ms. Lauryn Hill", "Mumford & Sons", "Muse", "Mya", "Myke Towers", "NCT 127", "NCT DREAM", "NEFFEX", "Nadin Amizah", "Nancy Sinatra", "Nat King Cole", "Nate Smith", "Natti Natasha", "Nayer", "Neil Diamond", "Neil Sedaka", "Nekfeu", "Nelly", "New Vaudeville Band", "Next", "Nickelback", "Nicki Minaj", "Nicki Nicole", "Nicky Jam", "Nina Simone", "Ninho", "Nipsey Hussle", "Nirvana", "Niska", "No Doubt", "Norah Jones", "Normani", "OMI", "ONE OK ROCK", "Oasis", "Official HIGE DANdism", "Offset", "Old Dominion", "Oliver Heldens", "Olivia Rodrigo", "Omah Lay", "One Direction", "Otis Redding", "OutKast", "Owl City", "P Diddy", "P!nk", "PLK", "PNL", "Pamungkas", "Passenger", "Pat Boone", "Patsy Cline", "Patti LaBelle", "Patti Page", "Paul & Paula", "Paul Revere & the Raiders", "Paul Robeson", "Paul Russell", "Paul Whiteman", "Paula Abdul", "Peaches & Herb", "Pearl Jam", "Pee Wee Hunt", "Pee Wee King", "Pentatonix", "Percy Faith", "Percy Sledge", "Peso Pluma", "Peter Cetera", "Peter Gabriel", "Peter, Paul & Mary", "Pharrell Williams", "Pierce The Veil", "Pineapple StormTv", "Pink Floyd", "Pink Sweat$", "Piso 21", "Pitbull", "Plan B", "Player", "Polo G", "Pop Smoke", "Portugal. The Man", "Pouya", "Prince", "Prince Royce", "Pusha T", "Quality Control", "Queen", "Quinn XCII", "R. Kelly", "RAF Camora", "RAYE", "REM", "REO Speedwagon", "Radiohead", "Rag'n'Bone Man", "Rage Against The Machine", "Rahat Fateh Ali Khan", "Rainbow Kitten Surprise", "Rammstein", "Rauw Alejandro", "Ray Charles", "Ray Parker Jr", "Ray Stevens", "Red Foley", "Red Hot Chili Peppers", "Red Velvet", "Regard", "Regina Belle", "Reik", "Rels B", "Rema", "Ricardo Arjona", "Rich The Kid", "Rick Astley", "Rick Dees & his Cast of Idiots", "Rick Ross", "Rick Springfield", "Ricky Martin", "Ricky Nelson", "Rihanna", "Rita Ora", "Ritchie Valens", "Rizky Febian", "Rob Thomas", "Roberta Flack", "Robin Schulz", "Robin Thicke", "Rod Stewart", "Rod Wave", "Roddy Ricch", "Roger Miller", "Romeo Santos", "Rosemary Clooney", "Roxette", "Roy Acuff", "Roy Orbison", "Rudimental", "Ruel", "Ruth B.", "Ryan Lewis", "SCH", "SEVENTEEN", "SWV", "Sabaton", "Sabrina Carpenter", "Sachet Tandon", "Sachin-Jigar", "Sade", "Sam Cooke", "Sam Feldt", "Sam Hunt", "Sam Smith", "Sam The Sham & The Pharaohs", "Sammy Davis Jr", "Sammy Kaye", "Santana", "Sasha Alex Sloan", "Savage Garden", "Saweetie", "Scorpions", "Sean Kingston", "Sean Paul", "Sebastian Yatra", "Sech", "Seeb", "Sezen Aksu", "Sfera Ebbasta", "Shaggy", "Shania Twain", "Shawn Mendes", "Sheena Easton", "Shinedown", "Shubh", "Sia", "Sid Sriram", "Sidhu Moose Wala", "Silk", "Silver Convention", "Simon & Garfunkel", "Sinead O'Connor", "Sir Mix-a-Lot", "Sister Sledge", "Ski Mask The Slump God", "Skillet", "Skrillex", "Sleeping At Last", "Smokey Robinson", "Snoop Dogg", "Snow Patrol", "Soda Stereo", "Sonu Nigam", "Sophie Ellis-Bextor", "Spencer Davis Group", "Spice Girls", "Stan Getz", "Starland Vocal Band", "Stephen Sanchez", "Steve Aoki", "Steve Lacy", "Steve Winwood", "Stevie B", "Sting", "Stormzy", "Strawberry Alarm Clock", "Stray Kids", "Stromae", "Sublime", "Sum 41", "Summer Walker", "Supertramp", "Survivor", "Swedish House Mafia", "System Of A Down", "T-Pain", "T.I.", "TAEYEON", "TKKG", "TLC", "TOMORROW X TOGETHER", "TOTO", "TWICE", "Tag Team", "Tainy", "Tammi Terrell", "Tanishk Bagchi", "Tate McRae", "Taylor Swift", "Tears For Fears", "Tems", "Tennessee Ernie Ford", "Terence Trent D'Arby", "Teresa Brewer", "Terry Jacks", "The Ames Brothers", "The Animals", "The B52s", "The Bangles", "The Beatles", "The Black Eyed Peas", "The Black Keys", "The Box Tops", "The Chainsmokers", "The Chiffons", "The Chordettes", "The Clash", "The Coasters", "The Commodores", "The Cowsills", "The Cranberries", "The Crew-Cuts", "The Cure", "The Detroit Spinners", "The Diamonds", "The Doobie Brothers", "The Doors", "The Drifters", "The Emotions", "The Eurythmics", "The Fireballs", "The Flamingos", "The Foundations", "The Four Seasons", "The Fray", "The Game", "The Go Gos", "The Goo Goo Dolls", "The Head And The Heart", "The Hollies", "The Ink Spots", "The Isley Brothers", "The Jackson 5", "The Kid LAROI", "The Killers", "The Kingston Trio", "The Kooks", "The Lemon Pipers", "The Living Tombstone", "The Lumineers", "The Mamas & The Papas", "The Marvelettes", "The McCoys", "The Mills Brothers", "The Miracles", "The Monkees", "The Moody Blues", "The National", "The Neighbourhood", "The Notorious B.I.G.", "The O'Jays", "The Offspring", "The Osmonds", "The Partridge Family", "The Penguins", "The Pet Shop Boys", "The Platters", "The Righteous Brothers", "The Rolling Stones", "The Ronettes", "The Score", "The Script", "The Seekers", "The Shangri-Las", "The Smashing Pumpkins", "The Staple Singers", "The Strokes", "The Supremes", "The Temptations", "The Turtles", "The Vamps", "The Verve", "The Village People", "The Weavers", "The White Stripes", "The Young Rascals", "The Zombies", "Thelma Houston", "Thomas Rhett", "Three Days Grace", "Three Dog Night", "Three Man Down", "Timbaland", "Timmy Trumpet", "Toby Keith", "Tom Jones", "Tom Petty and the Heartbreakers", "Tommy Dorsey", "Tommy Edwards", "Tommy James & the Shondells", "Tone Loc", "Toni Braxton", "Topic", "Tory Lanez", "Tove Lo", "Trevor Daniel", "Trey Songz", "Trippie Redd", "Trueno", "Tulsi Kumar", "Tulus", "Twenty One Pilots", "Two Feet", "Ty Dolla $ign", "Tyga", "Tyler Hubbard", "U2", "UB40", "UZI", "Ufo361", "Upchurch", "V", "Vampire Weekend", "Van McCoy", "Van Morrison", "Vance Joy", "Vanessa Carlton", "Vanessa Williams", "Vera Lynn", "Vernon Dalhart", "Vicente Fernandez", "Vishal-Shekhar", "Volbeat", "WILLOW", "Wale", "Wallows", "Weezer", "Wham!", "Whitney Houston", "Why Don't We", "Wilbert Harrison", "Wilson Phillips", "Wiz Khalifa", "Woody Guthrie", "Wyclef Jean", "XXXTENTACION", "Xavi", "YG", "YNW Melly", "YOASOBI", "Yandel", "Years & Years", "Yeat", "Yo Gotti", "Young Dolph", "Young Miko", "Young Thug", "YoungBoy Never Broke Again", "Yung Gravy", "Yuuri", "Yuvan Shankar Raja", "ZAYN", "ZZ Top", "Zac Brown Band", "Zach Bryan", "Zara Larsson", "aespa", "benny blanco", "blink-182", "d4vd", "deadmau5", "girl in red", "gnash", "iann dior", "will.i.am"], Dve = ["Acid House", "Acid Jazz", "Acid Rock", "Acoustic", "Acoustic Blues", "Afro-Pop", "Afrobeat", "Alt-Rock", "Alternative", "Ambient", "American Trad Rock", "Americana", "Anime", "Arena Rock", "Art-Rock", "Avant-Garde", "Avant-Punk", "Baladas y Boleros", "Barbershop", "Baroque", "Bebop", "Big Band", "Black Metal", "Blue Note", "Bluegrass", "Blues", "Boogaloo", "Bop", "Bossa Nova", "Bounce", "Brazilian Funk", "Breakbeat", "Britpop", "CCM", "Cajun", "Cantopop", "Celtic", "Celtic Folk", "Chamber Music", "Chant", "Chanukah", "Chicago Blues", "Chicago House", "Chicano", "Children’s Music", "Chill", "Choral", "Christian", "Christmas", "Classical", "Club", "College Rock", "Conjunto", "Cool Jazz", "Country", "Crunk", "Dance", "Dancehall", "Death Metal", "Deep House", "Delta Blues", "Detroit Techno", "Dirty South", "Disco", "Disney", "Dixieland", "Doo-wop", "Downtempo", "Dream Pop", "Drill", "Drinking Songs", "Drone", "Drum'n'bass", "Dub", "Dubstep", "EDM", "Early Music", "East Coast Rap", "Easter", "Easy Listening", "Eclectic", "Electric Blues", "Electro", "Electronic", "Electronica", "Emo", "Enka", "Environmental", "Ethio-jazz", "Experimental", "Experimental Rock", "Flamenco", "Folk", "Folk-Rock", "Forro", "French Pop", "Funk", "Fusion", "Gangsta Rap", "Garage", "German Folk", "German Pop", "Glam Rock", "Gospel", "Goth", "Grime", "Grindcore", "Groove", "Grunge", "Hair Metal", "Halloween", "Happy", "Hard Bop", "Hard Dance", "Hard Rock", "Hardcore", "Hardcore Punk", "Hardcore Rap", "Hardstyle", "Healing", "Heavy Metal", "High Classical", "Hip Hop", "Holiday", "Honky Tonk", "House", "IDM", "Impressionist", "Indie", "Industrial", "Instrumental", "J-Dance", "J-Idol", "J-Pop", "J-Punk", "J-Rock", "J-Ska", "J-Synth", "Jackin House", "Jam Bands", "Japanese Pop", "Jazz", "Jungle", "K-Pop", "Karaoke", "Kayokyoku", "Kids", "Kitsch", "Klezmer", "Krautrock", "Latin", "Latin Jazz", "Latin Rap", "Local", "Lounge", "Lullabies", "MPB", "Mainstream Jazz", "Malay", "Mandopop", "March", "Mariachi", "Mawwal", "Medieval", "Meditation", "Metal", "Metalcore", "Minimal Techno", "Minimalism", "Modern", "Motown", "Mugham", "Musicals", "Musique Concrète", "Nature", "Neo-Soul", "Nerdcore", "New Acoustic", "New Age", "New Mex", "New Wave", "No Wave", "Noise", "Nordic", "Novelty", "OPM", "Oi!", "Old School Rap", "Opera", "Orchestral", "Original Score", "Outlaw Country", "Pagode", "Party", "Piano", "Polka", "Pop", "Pop Film", "Pop Latino", "Post Dubstep", "Power Pop", "Praise & Worship", "Progressive House", "Progressive Rock", "Proto-punk", "Psych Rock", "Psychedelic", "Punk", "Punk Rock", "Qawwali", "Quiet Storm", "R&B", "Ragtime", "Rainy Day", "Rap", "Reggae", "Reggaeton", "Regional Mexicano", "Relaxation", "Renaissance", "Retro", "Rock", "Rockabilly", "Rocksteady", "Romance", "Romantic", "Roots Reggae", "Roots Rock", "SKA", "Sad", "Salsa", "Samba", "Second Line", "Sertanejo", "Shaabi", "Shoegaze", "Sleep", "Smooth Jazz", "Soft Rock", "Soul", "Soundtrack", "Southern Gospel", "Southern Rock", "Space Rock", "Stage And Screen", "Steampunk", "Summer", "Surf", "Swamp Pop", "Swing", "Synth Pop", "Tango", "Techno", "Teen Pop", "Tejano", "Tex-Mex", "Thanksgiving", "Traditional", "Trance", "Trip Hop", "Tropical", "Underground Rap", "Urban", "Urban Cowboy", "West Coast Rap", "Western Swing", "World", "Worldbeat", "Zydeco"], Ive = ["(Everything I Do) I Do it For You", "(Ghost) Riders in the Sky", "(I Can't Get No) Satisfaction", "(I've Got a Gal In) Kalamazoo", "(I've Had) the Time of My Life", "(It's No) Sin", "(Just Like) Starting Over", "(Let Me Be Your) Teddy Bear", "(Put Another Nickel In) Music! Music! Music!", "(Sexual) Healing", "(Sittin' On) the Dock of the Bay", "(They Long to Be) Close to You", "(You Keep Me) Hangin' On", "(You're My) Soul & Inspiration", "(Your Love Keeps Lifting Me) Higher & Higher", "12th Street Rag", "1999", "19th Nervous Breakdown", "50 Ways to Leave Your Lover", "9 to 5", "96 Tears", "A Boy Named Sue", "A Hard Day's Night", "A String of Pearls", "A Thousand Miles", "A Tree in the Meadow", "A Whiter Shade of Pale", "A Whole New World (Aladdin's Theme)", "A Woman in Love", "A-Tisket A-Tasket", "ABC", "Abracadabra", "Ac-cent-tchu-ate the Positive", "Addicted to Love", "After You've Gone", "Afternoon Delight", "Again", "Against All Odds (Take a Look At Me Now)", "Ain't Misbehavin'", "Ain't No Mountain High Enough", "Ain't No Sunshine", "Ain't That a Shame", "Airplanes", "All Along the Watchtower", "All I Have to Do is Dream", "All I Wanna Do", "All My Lovin' (You're Never Gonna Get It)", "All Night Long (All Night)", "All Out of Love", "All Shook Up", "All You Need is Love", "Alone", "Alone Again (Naturally)", "Always On My Mind", "American Pie", "American Woman", "Angie", "Another Brick in the Wall (part 2)", "Another Day in Paradise", "Another Night", "Another One Bites the Dust", "Apologize", "April Showers", "Aquarius/Let The Sunshine In", "Are You Lonesome Tonight?", "Arthur's Theme (Best That You Can Do)", "As Time Goes By", "At Last", "At the Hop", "Auf Wiederseh'n Sweetheart", "Baby Baby", "Baby Come Back", "Baby Got Back", "Baby Love", "Baby One More Time", "Bad Day", "Bad Girls", "Bad Moon Rising", "Bad Romance", "Bad, Bad Leroy Brown", "Baker Street", "Ball of Confusion (That's What the World is Today)", "Ballad of the Green Berets", "Ballerina", "Band On the Run", "Band of Gold", "Battle of New Orleans", "Be Bop a Lula", "Be My Baby", "Be My Love", "Beat It", "Beautiful Day", "Beauty & the Beast", "Because I Love You (The Postman Song)", "Because You Loved Me", "Because of You", "Before The Next Teardrop Falls", "Begin the Beguine", "Behind Closed Doors", "Being With You", "Believe", "Ben", "Bennie & the Jets", "Besame Mucho", "Best of My Love", "Bette Davis Eyes", "Big Bad John", "Big Girls Don't Cry", "Billie Jean", "Bitter Sweet Symphony", "Black Or White", "Black Velvet", "Blaze of Glory", "Bleeding Love", "Blue Suede Shoes", "Blue Tango", "Blueberry Hill", "Blurred Lines", "Body & Soul", "Bohemian Rhapsody", "Boogie Oogie Oogie", "Boogie Woogie Bugle Boy", "Boom Boom Pow", "Born in the USA", "Born to Be Wild", "Born to Run", "Boulevard of Broken Dreams", "Brand New Key", "Brandy (You're A Fine Girl)", "Breaking Up is Hard to Do", "Breathe", "Bridge Over Troubled Water", "Brother Louie", "Brother, Can You Spare a Dime?", "Brown Eyed Girl", "Brown Sugar", "Build Me Up Buttercup", "Burn", "Buttons & Bows", "Bye Bye Love", "Bye Bye, Blackbird", "Bye, Bye, Bye", "Caldonia Boogie (What Makes Your Big Head So Hard)", "California Dreamin'", "California Girls", "Call Me", "Call Me Maybe", "Can You Feel the Love Tonight", "Can't Buy Me Love", "Can't Get Enough of Your Love, Babe", "Can't Help Falling in Love", "Candle in the Wind '97", "Candy Man", "Car Wash", "Careless Whisper", "Cars", "Cat's in the Cradle", "Cathy's Clown", "Celebration", "Centerfold", "Chain of Fools", "Chances Are", "Change the World", "Chapel of Love", "Chattanooga Choo Choo", "Chattanoogie Shoe-Shine Boy", "Check On It", "Cheek to Cheek", "Cherish", "Cherry Pink & Apple Blossom White", "Cold, Cold Heart", "Colors of the Wind", "Come On Eileen", "Come On-a My House", "Come Together", "Coming Up", "Cracklin' Rosie", "Crazy", "Crazy For You", "Crazy Little Thing Called Love", "Crazy in Love", "Creep", "Crimson & Clover", "Crocodile Rock", "Cry", "Cry Like a Baby", "Crying", "Da Doo Ron Ron (When He Walked Me Home)", "Dance to the Music", "Dancing Queen", "Dancing in the Dark", "Dancing in the Street", "Dardanella", "Daydream Believer", "December 1963 (Oh What a Night)", "Delicado", "Dilemma", "Disco Duck", "Disco Lady", "Disturbia", "Dizzy", "Do That to Me One More Time", "Do Wah Diddy Diddy", "Do Ya Think I'm Sexy?", "Do You Love Me?", "Don't Be Cruel", "Don't Fence Me In", "Don't Go Breaking My Heart", "Don't Leave Me This Way", "Don't Let the Stars Get in Your Eyes", "Don't Let the Sun Go Down On Me", "Don't Speak", "Don't Stop 'Til You Get Enough", "Don't Worry Be Happy", "Don't You (Forget About Me)", "Don't You Want Me", "Doo Wop (That Thing)", "Down", "Down Hearted Blues", "Down Under", "Downtown", "Dreamlover", "Dreams", "Drop it Like It's Hot", "Drops of Jupiter (Tell Me)", "Duke of Earl", "E.T.", "Earth Angel", "Ebony & Ivory", "Eight Days a Week", "Empire State Of Mind", "End of the Road", "Endless Love", "Escape (The Pina Colada Song)", "Eve of Destruction", "Every Breath You Take", "Every Little Thing She Does is Magic", "Everybody Loves Somebody", "Everybody Wants to Rule the World", "Everyday People", "Eye of the Tiger", "Faith", "Fallin'", "Fame", "Family Affair", "Fantasy", "Fast Car", "Feel Good Inc", "Feel Like Making Love", "Fire & Rain", "Firework", "Flashdance. What a Feeling", "Fly Robin Fly", "Foolish Games", "Footloose", "For What It's Worth (Stop, Hey What's That Sound)", "Fortunate Son", "Frankenstein", "Freak Me", "Freebird", "Frenesi", "Funkytown", "Gangsta's Paradise", "Georgia On My Mind", "Georgy Girl", "Get Back", "Get Down Tonight", "Get Off of My Cloud", "Ghostbusters", "Gimme Some Lovin'", "Girls Just Wanna Have Fun", "Give Me Everything", "Gives You Hell", "Glamorous", "Glory of Love", "Go Your Own Way", "God Bless America", "God Bless the Child", "Gold Digger", "Gonna Make You Sweat (Everybody Dance Now)", "Good Lovin'", "Good Times", "Good Vibrations", "Goodbye Yellow Brick Road", "Goodnight, Irene", "Got to Give it Up", "Grease", "Great Balls of Fire", "Greatest Love of All", "Green Onions", "Green River", "Green Tambourine", "Grenade", "Groove is in the Heart", "Groovin'", "Gypsies, Tramps & Thieves", "Hair", "Hang On Sloopy", "Hanging by a Moment", "Hanky Panky", "Happy Days Are Here Again", "Happy Together", "Harbour Lights", "Hard to Say I'm Sorry", "Harper Valley PTA", "Have You Ever Really Loved a Woman?", "He'll Have to Go", "He's So Fine", "He's a Rebel", "Heart of Glass", "Heart of Gold", "Heartbreak Hotel", "Hello Dolly", "Hello, I Love You, Won't You Tell Me Your Name?", "Help Me, Rhonda", "Help!", "Here Without You", "Here in My Heart", "Hero", "Hey Baby", "Hey Jude", "Hey Paula", "Hey There", "Hey There Delilah", "Hey Ya!", "Higher Love", "Hips don't lie", "Hit the Road, Jack", "Hold On", "Hollaback Girl", "Honey", "Honky Tonk", "Honky Tonk Woman", "Horse With No Name", "Hot Child In The City", "Hot Stuff", "Hotel California", "Hound Dog", "House of the Rising Sun", "How Deep is Your Love?", "How Do I Live?", "How Do You Mend a Broken Heart", "How High the Moon", "How Much is That Doggy in the Window?", "How Will I Know", "How You Remind Me", "How to Save a Life", "Hungry Heart", "Hurt So Good", "I Believe I Can Fly", "I Can Dream, Can't I?", "I Can Help", "I Can See Clearly Now", "I Can't Get Next to You", "I Can't Get Started", "I Can't Go For That (No Can Do)", "I Can't Help Myself (Sugar Pie, Honey Bunch)", "I Can't Stop Loving You", "I Don't Want to Miss a Thing", "I Fall to Pieces", "I Feel Fine", "I Feel For You", "I Feel Love", "I Get Around", "I Got You (I Feel Good)", "I Got You Babe", "I Gotta Feeling", "I Heard it Through the Grapevine", "I Honestly Love You", "I Just Called to Say I Love You", "I Just Wanna Be Your Everything", "I Kissed A Girl", "I Love Rock 'n' Roll", "I Need You Now", "I Only Have Eyes For You", "I Shot the Sheriff", "I Still Haven't Found What I'm Looking For", "I Swear", "I Think I Love You", "I Walk the Line", "I Wanna Dance With Somebody (Who Loves Me)", "I Wanna Love You", "I Want You Back", "I Want to Hold Your Hand", "I Want to Know What Love Is", "I Went to Your Wedding", "I Will Always Love You", "I Will Follow Him", "I Will Survive", "I Write the Songs", "I'll Be Missing You", "I'll Be There", "I'll Make Love to You", "I'll Never Smile Again", "I'll Take You There", "I'll Walk Alone", "I'll be seeing you", "I'm Looking Over a Four Leaf Clover", "I'm So Lonesome I Could Cry", "I'm Sorry", "I'm Walking Behind You", "I'm Your Boogie Man", "I'm Yours", "I'm a Believer", "I've Heard That Song Before", "If (They Made Me a King)", "If I Didn't Care", "If You Don't Know Me By Now", "If You Leave Me Now", "Imagine", "In Da Club", "In the End", "In the Ghetto", "In the Mood", "In the Summertime", "In the Year 2525 (Exordium & Terminus)", "Incense & Peppermints", "Indian Reservation (The Lament Of The Cherokee Reservation Indian)", "Instant Karma", "Iris", "Ironic", "Irreplaceable", "It Had to Be You", "It's All in the Game", "It's My Party", "It's Now Or Never", "It's Still Rock 'n' Roll to Me", "It's Too Late", "Jack & Diane", "Jailhouse Rock", "Jessie's Girl", "Jive Talkin'", "Johnny B Goode", "Joy to the World", "Judy in Disguise (With Glasses)", "Jump", "Jumpin' Jack Flash", "Just Dance", "Just My Imagination (Running Away With Me)", "Just the Way You Are", "Kansas City", "Karma Chameleon", "Keep On Loving You", "Killing Me Softly With His Song", "King of the Road", "Kiss", "Kiss & Say Goodbye", "Kiss From a Rose", "Kiss Me", "Kiss On My List", "Kiss You All Over", "Knock On Wood", "Knock Three Times", "Kokomo", "Kryptonite", "Kung Fu Fighting", "La Bamba", "Lady", "Lady Marmalade (Voulez-Vous Coucher Aver Moi Ce Soir?)", "Last Train to Clarksville", "Layla", "Le Freak", "Leader of the Pack", "Lean On Me", "Leaving, on a Jet Plane", "Let Me Call You Sweetheart", "Let Me Love You", "Let it Be", "Let it Snow! Let it Snow! Let it Snow!", "Let's Dance", "Let's Get it On", "Let's Groove", "Let's Hear it For the Boy", "Let's Stay Together", "Light My Fire", "Lights", "Like a Prayer", "Like a Rolling Stone", "Like a Virgin", "Little Darlin'", "Little Things Mean a Lot", "Live & Let Die", "Livin' La Vida Loca", "Livin' On a Prayer", "Living For the City", "Locked Out Of Heaven", "Lola", "Lonely Boy", "Long Cool Woman in a Black Dress", "Long Tall Sally", "Look Away", "Lookin' Out My Back Door", "Lose Yourself", "Losing My Religion", "Louie Louie", "Love Child", "Love Hangover", "Love In This Club", "Love Is Blue (L'Amour Est Bleu)", "Love Letters in the Sand", "Love Me Do", "Love Me Tender", "Love Shack", "Love Theme From 'A Star is Born' (Evergreen)", "Love Train", "Love Will Keep Us Together", "Love is a Many Splendoured Thing", "Love to Love You Baby", "Love's Theme", "Loving You", "Low", "Macarena", "Mack the Knife", "Maggie May", "Magic", "Magic Carpet Ride", "Make Love to Me", "Make it With You", "Makin' Whoopee", "Mama Told Me Not to Come", "Man in the Mirror", "Manana (Is Soon Enough For Me)", "Maneater", "Maniac", "Maybellene", "Me & Bobby McGee", "Me & Mrs Jones", "Memories Are Made of This", "Mercy Mercy Me (The Ecology)", "Mickey", "Midnight Train to Georgia", "Minnie the Moocher", "Miss You", "Miss You Much", "Mister Sandman", "Mmmbop", "Mona Lisa", "Monday Monday", "Money For Nothing", "Mony Mony", "Mood Indigo", "Moonlight Cocktail", "Moonlight Serenade", "More Than Words", "More Than a Feeling", "Morning Train (Nine to Five)", "Mr Big Stuff", "Mr Brightside", "Mr Tambourine Man", "Mrs Brown You've Got a Lovely Daughter", "Mrs Robinson", "Mule Train", "Music", "My Blue Heaven", "My Boyfriend's Back", "My Eyes Adored You", "My Girl", "My Guy", "My Heart Will Go On", "My Life", "My Love", "My Man", "My Prayer", "My Sharona", "My Sweet Lord", "Na Na Hey Hey (Kiss Him Goodbye)", "Nature Boy", "Near You", "Need You Now", "Need You Tonight", "Never Gonna Give You Up", "Night & Day", "Night Fever", "Nights in White Satin", "No One", "No Scrubs", "Nobody Does it Better", "Nothin' on You", "Nothing Compares 2 U", "Nothing's Gonna Stop Us Now", "Ode To Billie Joe", "Oh Happy Day", "Oh My Papa (O Mein Papa)", "Oh, Pretty Woman", "Ol' Man River", "Ole Buttermilk Sky", "On Bended Knee", "On My Own", "On the Atchison, Topeka & the Santa Fe", "One", "One Bad Apple", "One More Try", "One O'Clock Jump", "One Sweet Day", "One of These Nights", "One of Us", "Only The Lonely (Know The Way I Feel)", "Only You (And You Alone)", "Open Arms", "Over There", "Over the Rainbow", "Paint it Black", "Papa Don't Preach", "Papa Was a Rolling Stone", "Papa's Got a Brand New Bag", "Paper Doll", "Paper Planes", "Paperback Writer", "Party Rock Anthem", "Peg o' My Heart", "Peggy Sue", "Pennies From Heaven", "Penny Lane", "People", "People Got to Be Free", "Personality", "Philadelphia Freedom", "Physical", "Piano Man", "Pick Up the Pieces", "Pistol Packin' Mama", "Play That Funky Music", "Please Mr Postman", "Poker Face", "Pon De Replay", "Pony Time", "Pop Muzik", "Prisoner of Love", "Private Eyes", "Promiscuous", "Proud Mary", "Purple Haze", "Purple Rain", "Puttin' on the Ritz", "Que sera sera (Whatever will be will be)", "Queen of Hearts", "Rag Doll", "Rag Mop", "Rags to Riches", "Raindrops Keep Falling On My Head", "Rapture", "Ray of Light", "Reach Out (I'll Be There)", "Red Red Wine", "Rehab", "Respect", "Return to Sender", "Reunited", "Revolution", "Rhapsody in Blue", "Rhinestone Cowboy", "Rich Girl", "Riders On the Storm", "Right Back Where We Started From", "Ring My Bell", "Ring of Fire", "Rock Around the Clock", "Rock With You", "Rock Your Baby", "Rock the Boat", "Rock the Casbah", "Roll Over Beethoven", "Roll With It", "Rolling In The Deep", "Rosanna", "Roses Are Red", "Royals", "Ruby Tuesday", "Rudolph, the Red-Nosed Reindeer", "Rum & Coca-Cola", "Runaround Sue", "Runaway", "Running Scared", "Rush Rush", "Sailing", "Save the Best For Last", "Save the Last Dance For Me", "Say It Right", "Say My Name", "Say Say Say", "Say You, Say Me", "School's Out", "Seasons in the Sun", "Secret Love", "Sentimental Journey", "Sexyback", "Sh-Boom (Life Could Be a Dream)", "Shadow Dancing", "Shake Down", "Shake You Down", "She Drives Me Crazy", "She Loves You", "She's a Lady", "Shining Star", "Shop Around", "Shout", "Silly Love Songs", "Since U Been Gone", "Sing, Sing, Sing (With A Swing)", "Singing The Blues", "Single Ladies (Put A Ring On It)", "Sir Duke", "Sixteen Tons", "Sledgehammer", "Sleep Walk", "Sleepy Lagoon", "Slow Poke", "Smells Like Teen Spirit", "Smoke Gets in Your Eyes", "Smoke On the Water", "Smoke! Smoke! Smoke! (That Cigarette)", "Smooth", "So Much in Love", "Soldier Boy", "Some Enchanted Evening", "Some of These Days", "Somebody That I Used to Know", "Somebody to Love", "Someday", "Somethin' Stupid", "Something", "Soul Man", "Spanish Harlem", "Spill the Wine", "Spinning Wheel", "Spirit in the Sky", "St George & the Dragonette", "St Louis Blues", "Stagger Lee", "Stairway to Heaven", "Stand By Me", "Stardust", "Stars & Stripes Forever", "Stay (I Missed You)", "Stayin' Alive", "Stop! in the Name of Love", "Stormy Weather (Keeps Rainin' All the Time)", "Straight Up", "Strange Fruit", "Stranger On the Shore", "Strangers in the Night", "Strawberry Fields Forever", "Streets of Philadelphia", "Stronger", "Stuck On You", "Sugar Shack", "Sugar Sugar", "Summer in the City", "Summertime Blues", "Sunday, Monday or Always", "Sunshine Superman", "Sunshine of Your Love", "Superstar", "Superstition", "Surfin' USA", "Suspicious Minds", "Swanee", "Sweet Caroline (Good Times Never Seemed So Good)", "Sweet Child O' Mine", "Sweet Dreams (Are Made of This)", "Sweet Georgia Brown", "Sweet Home Alabama", "Sweet Soul Music", "Swinging On a Star", "T For Texas (Blue Yodel No 1)", "TSOP (The Sound of Philadelphia)", "Take Me Home, Country Roads", "Take My Breath Away", "Take On Me", "Take The 'A' Train", "Take a Bow", "Tammy", "Tangerine", "Tears in Heaven", "Tears of a Clown", "Temperature", "Tennessee Waltz", "Tequila", "Tha Crossroads", "Thank You (Falettinme be Mice Elf Again)", "That Lucky Old Sun (Just Rolls Around Heaven All Day)", "That Old Black Magic", "That'll Be the Day", "That's Amore", "That's What Friends Are For", "That's the Way (I Like It)", "That's the Way Love Goes", "The Boy is Mine", "The Boys of Summer", "The Christmas Song (Chestnuts Roasting On An Open Fire)", "The End of the World", "The First Time Ever I Saw Your Face", "The Girl From Ipanema", "The Glow-Worm", "The Great Pretender", "The Gypsy", "The Hustle", "The Joker", "The Last Dance", "The Letter", "The Loco-Motion", "The Long & Winding Road", "The Love You Save", "The Morning After", "The Power of Love", "The Prisoner's Song", "The Reason", "The Rose", "The Sign", "The Song From Moulin Rouge (Where Is Your Heart)", "The Sounds of Silence", "The Streak", "The Sweet Escape", "The Thing", "The Tide is High", "The Tracks of My Tears", "The Twist", "The Wanderer", "The Way We Were", "The Way You Look Tonight", "The Way You Move", "Theme From 'A Summer Place'", "Theme From 'Greatest American Hero' (Believe It Or Not)", "Theme From 'Shaft'", "There goes my baby", "These Boots Are Made For Walking", "Third Man Theme", "This Diamond Ring", "This Guy's in Love With You", "This Land is Your Land", "This Love", "This Ole House", "This Used to Be My Playground", "Three Coins in the Fountain", "Three Times a Lady", "Thrift Shop", "Thriller", "Ticket to Ride", "Tie a Yellow Ribbon 'round the Old Oak Tree", "Tiger Rag", "Tighten Up", "Tik-Toc", "Till I Waltz Again With You", "Till The End of Time", "Time After Time", "Time of the Season", "To Sir, with Love", "Tom Dooley", "Tonight's the Night (Gonna Be Alright)", "Too Close", "Too Young", "Tossing & Turning", "Total Eclipse of the Heart", "Touch Me", "Toxic", "Travellin' Band", "Travellin' Man", "Truly Madly Deeply", "Turn! Turn! Turn! (To Everything There is a Season)", "Tutti Frutti", "Twist & Shout", "Two Hearts", "U Can't Touch This", "U Got it Bad", "Umbrella", "Un-Break My Heart", "Unbelievable", "Unchained Melody", "Uncle Albert (Admiral Halsey)", "Under the Boardwalk", "Under the Bridge", "Unforgettable", "Up Around the Bend", "Up Up & Away", "Up Where We Belong", "Upside Down", "Use Somebody", "Vaya Con Dios (may God Be With You)", "Venus", "Vision of Love", "Viva La Vida", "Vogue", "Volare", "Wabash Cannonball", "Waiting For a Girl Like You", "Wake Me Up Before You Go Go", "Wake Up Little Susie", "Walk Don't Run", "Walk Like a Man", "Walk Like an Egyptian", "Walk On By", "Walk On the Wild Side", "Walk This Way", "Wannabe", "Want Ads", "Wanted", "War", "Waterfalls", "Wayward Wind", "We Are Family", "We Are Young", "We Are the Champions", "We Are the World", "We Belong Together", "We Built This City", "We Can Work it Out", "We Didn't Start the Fire", "We Found Love", "We Got The Beat", "We Will Rock You", "We've Only Just Begun", "Weak", "Wedding Bell Blues", "West End Blues", "West End Girls", "What Goes Around Comes Around", "What a Fool Believes", "What'd I Say", "What's Going On?", "What's Love Got to Do With It?", "Whatcha Say", "Wheel of Fortune", "When Doves Cry", "When You Wish Upon a Star", "When a Man Loves a Woman", "Where Did Our Love Go", "Where is the Love?", "Whip It", "Whispering", "White Christmas", "White Rabbit", "Whole Lotta Love", "Whole Lotta Shakin' Goin' On", "Whoomp! (There it Is)", "Why Do Fools Fall in Love?", "Why Don't You Believe Me?", "Wichita Lineman", "Wicked Game", "Wild Thing", "Wild Wild West", "Will It Go Round In Circles", "Will You Love Me Tomorrow", "Winchester Cathedral", "Wind Beneath My Wings", "Wipe Out", "Wishing Well", "With Or Without You", "Without Me", "Without You", "Woman", "Won't Get Fooled Again", "Wooly Bully", "Working My Way Back to You", "YMCA", "Yakety Yak", "Yeah!", "Yellow Rose of Texas", "Yesterday", "You Ain't Seen Nothin' Yet", "You Always Hurt the One You Love", "You Are the Sunshine of My Life", "You Belong With Me", "You Belong to Me", "You Can't Hurry Love", "You Don't Bring Me Flowers", "You Don't Have to Be a Star (To Be in My Show)", "You Light Up My Life", "You Make Me Feel Brand New", "You Make Me Feel Like Dancing", "You Really Got Me", "You Send Me", "You Sexy Thing", "You Were Meant for Me", "You make Me Wanna", "You'll Never Know", "You're Beautiful", "You're So Vain", "You're Still the One", "You're the One That I Want", "You've Got a Friend", "You've Lost That Lovin' Feelin'", "Your Cheatin' Heart", "Your Song"], Rve = { album: _ve, artist: Nve, genre: Dve, song_name: Ive }, Pve = Rve, Lve = ["activist", "artist", "author", "blogger", "business owner", "coach", "creator", "designer", "developer", "dreamer", "educator", "engineer", "entrepreneur", "environmentalist", "film lover", "filmmaker", "foodie", "founder", "friend", "gamer", "geek", "grad", "inventor", "leader", "model", "musician", "nerd", "parent", "patriot", "person", "philosopher", "photographer", "public speaker", "scientist", "singer", "streamer", "student", "teacher", "traveler", "veteran", "writer"], Mve = ["{{person.bio_part}}", "{{person.bio_part}}, {{person.bio_part}}", "{{person.bio_part}}, {{person.bio_part}}, {{person.bio_part}}", "{{person.bio_part}}, {{person.bio_part}}, {{person.bio_part}} {{internet.emoji}}", "{{word.noun}} {{person.bio_supporter}}", "{{word.noun}} {{person.bio_supporter}}  {{internet.emoji}}", "{{word.noun}} {{person.bio_supporter}}, {{person.bio_part}}", "{{word.noun}} {{person.bio_supporter}}, {{person.bio_part}} {{internet.emoji}}"], Ove = ["advocate", "devotee", "enthusiast", "fan", "junkie", "lover", "supporter"], Bve = { generic: ["Aaliyah", "Aaron", "Abagail", "Abbey", "Abbie", "Abbigail", "Abby", "Abdiel", "Abdul", "Abdullah", "Abe", "Abel", "Abelardo", "Abigail", "Abigale", "Abigayle", "Abner", "Abraham", "Ada", "Adah", "Adalberto", "Adaline", "Adam", "Adan", "Addie", "Addison", "Adela", "Adelbert", "Adele", "Adelia", "Adeline", "Adell", "Adella", "Adelle", "Aditya", "Adolf", "Adolfo", "Adolph", "Adolphus", "Adonis", "Adrain", "Adrian", "Adriana", "Adrianna", "Adriel", "Adrien", "Adrienne", "Afton", "Aglae", "Agnes", "Agustin", "Agustina", "Ahmad", "Ahmed", "Aida", "Aidan", "Aiden", "Aileen", "Aimee", "Aisha", "Aiyana", "Akeem", "Al", "Alaina", "Alan", "Alana", "Alanis", "Alanna", "Alayna", "Alba", "Albert", "Alberta", "Albertha", "Alberto", "Albin", "Albina", "Alda", "Alden", "Alec", "Aleen", "Alejandra", "Alejandrin", "Alek", "Alena", "Alene", "Alessandra", "Alessandro", "Alessia", "Aletha", "Alex", "Alexa", "Alexander", "Alexandra", "Alexandre", "Alexandrea", "Alexandria", "Alexandrine", "Alexandro", "Alexane", "Alexanne", "Alexie", "Alexis", "Alexys", "Alexzander", "Alf", "Alfonso", "Alfonzo", "Alford", "Alfred", "Alfreda", "Alfredo", "Ali", "Alia", "Alice", "Alicia", "Alisa", "Alisha", "Alison", "Alivia", "Aliya", "Aliyah", "Aliza", "Alize", "Allan", "Allen", "Allene", "Allie", "Allison", "Ally", "Alphonso", "Alta", "Althea", "Alva", "Alvah", "Alvena", "Alvera", "Alverta", "Alvina", "Alvis", "Alyce", "Alycia", "Alysa", "Alysha", "Alyson", "Alysson", "Amalia", "Amanda", "Amani", "Amara", "Amari", "Amaya", "Amber", "Ambrose", "Amelia", "Amelie", "Amely", "America", "Americo", "Amie", "Amina", "Amir", "Amira", "Amiya", "Amos", "Amparo", "Amy", "Amya", "Ana", "Anabel", "Anabelle", "Anahi", "Anais", "Anastacio", "Anastasia", "Anderson", "Andre", "Andreane", "Andreanne", "Andres", "Andrew", "Andy", "Angel", "Angela", "Angelica", "Angelina", "Angeline", "Angelita", "Angelo", "Angie", "Angus", "Anibal", "Anika", "Anissa", "Anita", "Aniya", "Aniyah", "Anjali", "Anna", "Annabel", "Annabell", "Annabelle", "Annalise", "Annamae", "Annamarie", "Anne", "Annetta", "Annette", "Annie", "Ansel", "Ansley", "Anthony", "Antoinette", "Antone", "Antonetta", "Antonette", "Antonia", "Antonietta", "Antonina", "Antonio", "Antwan", "Antwon", "Anya", "April", "Ara", "Araceli", "Aracely", "Arch", "Archibald", "Ardella", "Arden", "Ardith", "Arely", "Ari", "Ariane", "Arianna", "Aric", "Ariel", "Arielle", "Arjun", "Arlene", "Arlie", "Arlo", "Armand", "Armando", "Armani", "Arnaldo", "Arne", "Arno", "Arnold", "Arnoldo", "Arnulfo", "Aron", "Art", "Arthur", "Arturo", "Arvel", "Arvid", "Arvilla", "Aryanna", "Asa", "Asha", "Ashlee", "Ashleigh", "Ashley", "Ashly", "Ashlynn", "Ashton", "Ashtyn", "Asia", "Assunta", "Astrid", "Athena", "Aubree", "Aubrey", "Audie", "Audra", "Audreanne", "Audrey", "August", "Augusta", "Augustine", "Augustus", "Aurelia", "Aurelie", "Aurelio", "Aurore", "Austen", "Austin", "Austyn", "Autumn", "Ava", "Avery", "Avis", "Axel", "Ayana", "Ayden", "Ayla", "Aylin", "Baby", "Bailee", "Bailey", "Barbara", "Barney", "Baron", "Barrett", "Barry", "Bart", "Bartholome", "Barton", "Baylee", "Beatrice", "Beau", "Beaulah", "Bell", "Bella", "Belle", "Ben", "Benedict", "Benjamin", "Bennett", "Bennie", "Benny", "Benton", "Berenice", "Bernadette", "Bernadine", "Bernard", "Bernardo", "Berneice", "Bernhard", "Bernice", "Bernie", "Berniece", "Bernita", "Berry", "Bert", "Berta", "Bertha", "Bertram", "Bertrand", "Beryl", "Bessie", "Beth", "Bethany", "Bethel", "Betsy", "Bette", "Bettie", "Betty", "Bettye", "Beulah", "Beverly", "Bianka", "Bill", "Billie", "Billy", "Birdie", "Blair", "Blaise", "Blake", "Blanca", "Blanche", "Blaze", "Bo", "Bobbie", "Bobby", "Bonita", "Bonnie", "Boris", "Boyd", "Brad", "Braden", "Bradford", "Bradley", "Bradly", "Brady", "Braeden", "Brain", "Brandi", "Brando", "Brandon", "Brandt", "Brandy", "Brandyn", "Brannon", "Branson", "Brant", "Braulio", "Braxton", "Brayan", "Breana", "Breanna", "Breanne", "Brenda", "Brendan", "Brenden", "Brendon", "Brenna", "Brennan", "Brennon", "Brent", "Bret", "Brett", "Bria", "Brian", "Briana", "Brianne", "Brice", "Bridget", "Bridgette", "Bridie", "Brielle", "Brigitte", "Brionna", "Brisa", "Britney", "Brittany", "Brock", "Broderick", "Brody", "Brook", "Brooke", "Brooklyn", "Brooks", "Brown", "Bruce", "Bryana", "Bryce", "Brycen", "Bryon", "Buck", "Bud", "Buddy", "Buford", "Bulah", "Burdette", "Burley", "Burnice", "Buster", "Cade", "Caden", "Caesar", "Caitlyn", "Cale", "Caleb", "Caleigh", "Cali", "Calista", "Callie", "Camden", "Cameron", "Camila", "Camilla", "Camille", "Camren", "Camron", "Camryn", "Camylle", "Candace", "Candelario", "Candice", "Candida", "Candido", "Cara", "Carey", "Carissa", "Carlee", "Carleton", "Carley", "Carli", "Carlie", "Carlo", "Carlos", "Carlotta", "Carmel", "Carmela", "Carmella", "Carmelo", "Carmen", "Carmine", "Carol", "Carolanne", "Carole", "Carolina", "Caroline", "Carolyn", "Carolyne", "Carrie", "Carroll", "Carson", "Carter", "Cary", "Casandra", "Casey", "Casimer", "Casimir", "Casper", "Cassandra", "Cassandre", "Cassidy", "Cassie", "Catalina", "Caterina", "Catharine", "Catherine", "Cathrine", "Cathryn", "Cathy", "Cayla", "Ceasar", "Cecelia", "Cecil", "Cecile", "Cecilia", "Cedrick", "Celestine", "Celestino", "Celia", "Celine", "Cesar", "Chad", "Chadd", "Chadrick", "Chaim", "Chance", "Chandler", "Chanel", "Chanelle", "Charity", "Charlene", "Charles", "Charley", "Charlie", "Charlotte", "Chase", "Chasity", "Chauncey", "Chaya", "Chaz", "Chelsea", "Chelsey", "Chelsie", "Chesley", "Chester", "Chet", "Cheyanne", "Cheyenne", "Chloe", "Chris", "Christ", "Christa", "Christelle", "Christian", "Christiana", "Christina", "Christine", "Christop", "Christophe", "Christopher", "Christy", "Chyna", "Ciara", "Cicero", "Cielo", "Cierra", "Cindy", "Citlalli", "Clair", "Claire", "Clara", "Clarabelle", "Clare", "Clarissa", "Clark", "Claud", "Claude", "Claudia", "Claudie", "Claudine", "Clay", "Clemens", "Clement", "Clementina", "Clementine", "Clemmie", "Cleo", "Cleora", "Cleta", "Cletus", "Cleve", "Cleveland", "Clifford", "Clifton", "Clint", "Clinton", "Clotilde", "Clovis", "Cloyd", "Clyde", "Coby", "Cody", "Colby", "Cole", "Coleman", "Colin", "Colleen", "Collin", "Colt", "Colten", "Colton", "Columbus", "Concepcion", "Conner", "Connie", "Connor", "Conor", "Conrad", "Constance", "Constantin", "Consuelo", "Cooper", "Cora", "Coralie", "Corbin", "Cordelia", "Cordell", "Cordia", "Cordie", "Corene", "Corine", "Cornelius", "Cornell", "Corrine", "Cortez", "Cortney", "Cory", "Coty", "Courtney", "Coy", "Craig", "Crawford", "Creola", "Cristal", "Cristian", "Cristina", "Cristobal", "Cristopher", "Cruz", "Crystal", "Crystel", "Cullen", "Curt", "Curtis", "Cydney", "Cynthia", "Cyril", "Cyrus", "D'angelo", "Dagmar", "Dahlia", "Daija", "Daisha", "Daisy", "Dakota", "Dale", "Dallas", "Dallin", "Dalton", "Damaris", "Dameon", "Damian", "Damien", "Damion", "Damon", "Dan", "Dana", "Dandre", "Dane", "Dangelo", "Danial", "Daniela", "Daniella", "Danielle", "Danika", "Dannie", "Danny", "Dante", "Danyka", "Daphne", "Daphnee", "Daphney", "Darby", "Daren", "Darian", "Dariana", "Darien", "Dario", "Darion", "Darius", "Darlene", "Daron", "Darrel", "Darrell", "Darren", "Darrick", "Darrin", "Darrion", "Darron", "Darryl", "Darwin", "Daryl", "Dashawn", "Dasia", "Dave", "David", "Davin", "Davion", "Davon", "Davonte", "Dawn", "Dawson", "Dax", "Dayana", "Dayna", "Dayne", "Dayton", "Dean", "Deangelo", "Deanna", "Deborah", "Declan", "Dedric", "Dedrick", "Dee", "Deion", "Deja", "Dejah", "Dejon", "Dejuan", "Delaney", "Delbert", "Delfina", "Delia", "Delilah", "Dell", "Della", "Delmer", "Delores", "Delpha", "Delphia", "Delphine", "Delta", "Demarco", "Demarcus", "Demario", "Demetris", "Demetrius", "Demond", "Dena", "Denis", "Dennis", "Deon", "Deondre", "Deontae", "Deonte", "Dereck", "Derek", "Derick", "Deron", "Derrick", "Deshaun", "Deshawn", "Desiree", "Desmond", "Dessie", "Destany", "Destin", "Destinee", "Destiney", "Destini", "Destiny", "Devan", "Devante", "Deven", "Devin", "Devon", "Devonte", "Devyn", "Dewayne", "Dewitt", "Dexter", "Diamond", "Diana", "Dianna", "Diego", "Dillan", "Dillon", "Dimitri", "Dina", "Dino", "Dion", "Dixie", "Dock", "Dolly", "Dolores", "Domenic", "Domenica", "Domenick", "Domenico", "Domingo", "Dominic", "Dominique", "Don", "Donald", "Donato", "Donavon", "Donna", "Donnell", "Donnie", "Donny", "Dora", "Dorcas", "Dorian", "Doris", "Dorothea", "Dorothy", "Dorris", "Dortha", "Dorthy", "Doug", "Douglas", "Dovie", "Doyle", "Drake", "Drew", "Duane", "Dudley", "Dulce", "Duncan", "Durward", "Dustin", "Dusty", "Dwight", "Dylan", "Earl", "Earlene", "Earline", "Earnest", "Earnestine", "Easter", "Easton", "Ebba", "Ebony", "Ed", "Eda", "Edd", "Eddie", "Eden", "Edgar", "Edgardo", "Edison", "Edmond", "Edmund", "Edna", "Eduardo", "Edward", "Edwardo", "Edwin", "Edwina", "Edyth", "Edythe", "Effie", "Efrain", "Efren", "Eileen", "Einar", "Eino", "Eladio", "Elaina", "Elbert", "Elda", "Eldon", "Eldora", "Eldred", "Eldridge", "Eleanora", "Eleanore", "Eleazar", "Electa", "Elena", "Elenor", "Elenora", "Eleonore", "Elfrieda", "Eli", "Elian", "Eliane", "Elias", "Eliezer", "Elijah", "Elinor", "Elinore", "Elisa", "Elisabeth", "Elise", "Eliseo", "Elisha", "Elissa", "Eliza", "Elizabeth", "Ella", "Ellen", "Ellie", "Elliot", "Elliott", "Ellis", "Ellsworth", "Elmer", "Elmira", "Elmo", "Elmore", "Elna", "Elnora", "Elody", "Eloisa", "Eloise", "Elouise", "Eloy", "Elroy", "Elsa", "Else", "Elsie", "Elta", "Elton", "Elva", "Elvera", "Elvie", "Elvis", "Elwin", "Elwyn", "Elyse", "Elyssa", "Elza", "Emanuel", "Emelia", "Emelie", "Emely", "Emerald", "Emerson", "Emery", "Emie", "Emil", "Emile", "Emilia", "Emiliano", "Emilie", "Emilio", "Emily", "Emma", "Emmalee", "Emmanuel", "Emmanuelle", "Emmet", "Emmett", "Emmie", "Emmitt", "Emmy", "Emory", "Ena", "Enid", "Enoch", "Enola", "Enos", "Enrico", "Enrique", "Ephraim", "Era", "Eriberto", "Eric", "Erica", "Erich", "Erick", "Ericka", "Erik", "Erika", "Erin", "Erling", "Erna", "Ernest", "Ernestina", "Ernestine", "Ernesto", "Ernie", "Ervin", "Erwin", "Eryn", "Esmeralda", "Esperanza", "Esta", "Esteban", "Estefania", "Estel", "Estell", "Estella", "Estelle", "Estevan", "Esther", "Estrella", "Etha", "Ethan", "Ethel", "Ethelyn", "Ethyl", "Ettie", "Eudora", "Eugene", "Eugenia", "Eula", "Eulah", "Eulalia", "Euna", "Eunice", "Eusebio", "Eva", "Evalyn", "Evan", "Evangeline", "Evans", "Eve", "Eveline", "Evelyn", "Everardo", "Everett", "Everette", "Evert", "Evie", "Ewald", "Ewell", "Ezekiel", "Ezequiel", "Ezra", "Fabian", "Fabiola", "Fae", "Fannie", "Fanny", "Fatima", "Faustino", "Fausto", "Favian", "Fay", "Faye", "Federico", "Felicia", "Felicita", "Felicity", "Felipa", "Felipe", "Felix", "Felton", "Fermin", "Fern", "Fernando", "Ferne", "Fidel", "Filiberto", "Filomena", "Finn", "Fiona", "Flavie", "Flavio", "Fleta", "Fletcher", "Flo", "Florence", "Florencio", "Florian", "Florida", "Florine", "Flossie", "Floy", "Floyd", "Ford", "Forest", "Forrest", "Foster", "Frances", "Francesca", "Francesco", "Francis", "Francisca", "Francisco", "Franco", "Frank", "Frankie", "Franz", "Fred", "Freda", "Freddie", "Freddy", "Frederic", "Frederick", "Frederik", "Frederique", "Fredrick", "Fredy", "Freeda", "Freeman", "Freida", "Frida", "Frieda", "Friedrich", "Fritz", "Furman", "Gabe", "Gabriel", "Gabriella", "Gabrielle", "Gaetano", "Gage", "Gail", "Gardner", "Garett", "Garfield", "Garland", "Garnet", "Garnett", "Garret", "Garrett", "Garrick", "Garrison", "Garry", "Garth", "Gaston", "Gavin", "Gayle", "Gene", "General", "Genesis", "Genevieve", "Gennaro", "Genoveva", "Geo", "Geoffrey", "George", "Georgette", "Georgiana", "Georgianna", "Geovanni", "Geovanny", "Geovany", "Gerald", "Geraldine", "Gerard", "Gerardo", "Gerda", "Gerhard", "Germaine", "German", "Gerry", "Gerson", "Gertrude", "Gia", "Gianni", "Gideon", "Gilbert", "Gilberto", "Gilda", "Giles", "Gillian", "Gina", "Gino", "Giovani", "Giovanna", "Giovanni", "Giovanny", "Gisselle", "Giuseppe", "Gladyce", "Gladys", "Glen", "Glenda", "Glenna", "Glennie", "Gloria", "Godfrey", "Golda", "Golden", "Gonzalo", "Gordon", "Grace", "Gracie", "Graciela", "Grady", "Graham", "Grant", "Granville", "Grayce", "Grayson", "Green", "Greg", "Gregg", "Gregoria", "Gregorio", "Gregory", "Greta", "Gretchen", "Greyson", "Griffin", "Grover", "Guadalupe", "Gudrun", "Guido", "Guillermo", "Guiseppe", "Gunnar", "Gunner", "Gus", "Gussie", "Gust", "Gustave", "Guy", "Gwen", "Gwendolyn", "Hadley", "Hailee", "Hailey", "Hailie", "Hal", "Haleigh", "Haley", "Halie", "Halle", "Hallie", "Hank", "Hanna", "Hannah", "Hans", "Hardy", "Harley", "Harmon", "Harmony", "Harold", "Harrison", "Harry", "Harvey", "Haskell", "Hassan", "Hassie", "Hattie", "Haven", "Hayden", "Haylee", "Hayley", "Haylie", "Hazel", "Hazle", "Heath", "Heather", "Heaven", "Heber", "Hector", "Heidi", "Helen", "Helena", "Helene", "Helga", "Hellen", "Helmer", "Heloise", "Henderson", "Henri", "Henriette", "Henry", "Herbert", "Herman", "Hermann", "Hermina", "Herminia", "Herminio", "Hershel", "Herta", "Hertha", "Hester", "Hettie", "Hilario", "Hilbert", "Hilda", "Hildegard", "Hillard", "Hillary", "Hilma", "Hilton", "Hipolito", "Hiram", "Hobart", "Holden", "Hollie", "Hollis", "Holly", "Hope", "Horace", "Horacio", "Hortense", "Hosea", "Houston", "Howard", "Howell", "Hoyt", "Hubert", "Hudson", "Hugh", "Hulda", "Humberto", "Hunter", "Hyman", "Ian", "Ibrahim", "Icie", "Ida", "Idell", "Idella", "Ignacio", "Ignatius", "Ike", "Ila", "Ilene", "Iliana", "Ima", "Imani", "Imelda", "Immanuel", "Imogene", "Ines", "Irma", "Irving", "Irwin", "Isaac", "Isabel", "Isabell", "Isabella", "Isabelle", "Isac", "Isadore", "Isai", "Isaiah", "Isaias", "Isidro", "Ismael", "Isobel", "Isom", "Israel", "Issac", "Itzel", "Iva", "Ivah", "Ivory", "Ivy", "Izabella", "Izaiah", "Jabari", "Jace", "Jacey", "Jacinthe", "Jacinto", "Jack", "Jackeline", "Jackie", "Jacklyn", "Jackson", "Jacky", "Jaclyn", "Jacquelyn", "Jacques", "Jacynthe", "Jada", "Jade", "Jaden", "Jadon", "Jadyn", "Jaeden", "Jaida", "Jaiden", "Jailyn", "Jaime", "Jairo", "Jakayla", "Jake", "Jakob", "Jaleel", "Jalen", "Jalon", "Jalyn", "Jamaal", "Jamal", "Jamar", "Jamarcus", "Jamel", "Jameson", "Jamey", "Jamie", "Jamil", "Jamir", "Jamison", "Jammie", "Jan", "Jana", "Janae", "Jane", "Janelle", "Janessa", "Janet", "Janice", "Janick", "Janie", "Janis", "Janiya", "Jannie", "Jany", "Jaquan", "Jaquelin", "Jaqueline", "Jared", "Jaren", "Jarod", "Jaron", "Jarred", "Jarrell", "Jarret", "Jarrett", "Jarrod", "Jarvis", "Jasen", "Jasmin", "Jason", "Jasper", "Jaunita", "Javier", "Javon", "Javonte", "Jay", "Jayce", "Jaycee", "Jayda", "Jayde", "Jayden", "Jaydon", "Jaylan", "Jaylen", "Jaylin", "Jaylon", "Jayme", "Jayne", "Jayson", "Jazlyn", "Jazmin", "Jazmyn", "Jazmyne", "Jean", "Jeanette", "Jeanie", "Jeanne", "Jed", "Jedediah", "Jedidiah", "Jeff", "Jefferey", "Jeffery", "Jeffrey", "Jeffry", "Jena", "Jenifer", "Jennie", "Jennifer", "Jennings", "Jennyfer", "Jensen", "Jerad", "Jerald", "Jeramie", "Jeramy", "Jerel", "Jeremie", "Jeremy", "Jermain", "Jermaine", "Jermey", "Jerod", "Jerome", "Jeromy", "Jerrell", "Jerrod", "Jerrold", "Jerry", "Jess", "Jesse", "Jessica", "Jessie", "Jessika", "Jessy", "Jessyca", "Jesus", "Jett", "Jettie", "Jevon", "Jewel", "Jewell", "Jillian", "Jimmie", "Jimmy", "Jo", "Joan", "Joana", "Joanie", "Joanne", "Joannie", "Joanny", "Joany", "Joaquin", "Jocelyn", "Jodie", "Jody", "Joe", "Joel", "Joelle", "Joesph", "Joey", "Johan", "Johann", "Johanna", "Johathan", "John", "Johnathan", "Johnathon", "Johnnie", "Johnny", "Johnpaul", "Johnson", "Jolie", "Jon", "Jonas", "Jonatan", "Jonathan", "Jonathon", "Jordan", "Jordane", "Jordi", "Jordon", "Jordy", "Jordyn", "Jorge", "Jose", "Josefa", "Josefina", "Joseph", "Josephine", "Josh", "Joshua", "Joshuah", "Josiah", "Josiane", "Josianne", "Josie", "Josue", "Jovan", "Jovani", "Jovanny", "Jovany", "Joy", "Joyce", "Juana", "Juanita", "Judah", "Judd", "Jude", "Judge", "Judson", "Judy", "Jules", "Julia", "Julian", "Juliana", "Julianne", "Julie", "Julien", "Juliet", "Julio", "Julius", "June", "Junior", "Junius", "Justen", "Justice", "Justina", "Justine", "Juston", "Justus", "Justyn", "Juvenal", "Juwan", "Kacey", "Kaci", "Kacie", "Kade", "Kaden", "Kadin", "Kaela", "Kaelyn", "Kaia", "Kailee", "Kailey", "Kailyn", "Kaitlin", "Kaitlyn", "Kale", "Kaleb", "Kaleigh", "Kaley", "Kali", "Kallie", "Kameron", "Kamille", "Kamren", "Kamron", "Kamryn", "Kane", "Kara", "Kareem", "Karelle", "Karen", "Kari", "Kariane", "Karianne", "Karina", "Karine", "Karl", "Karlee", "Karley", "Karli", "Karlie", "Karolann", "Karson", "Kasandra", "Kasey", "Kassandra", "Katarina", "Katelin", "Katelyn", "Katelynn", "Katharina", "Katherine", "Katheryn", "Kathleen", "Kathlyn", "Kathryn", "Kathryne", "Katlyn", "Katlynn", "Katrina", "Katrine", "Kattie", "Kavon", "Kay", "Kaya", "Kaycee", "Kayden", "Kayla", "Kaylah", "Kaylee", "Kayleigh", "Kayley", "Kayli", "Kaylie", "Kaylin", "Keagan", "Keanu", "Keara", "Keaton", "Keegan", "Keeley", "Keely", "Keenan", "Keira", "Keith", "Kellen", "Kelley", "Kelli", "Kellie", "Kelly", "Kelsi", "Kelsie", "Kelton", "Kelvin", "Ken", "Kendall", "Kendra", "Kendrick", "Kenna", "Kennedi", "Kennedy", "Kenneth", "Kennith", "Kenny", "Kenton", "Kenya", "Kenyatta", "Kenyon", "Keon", "Keshaun", "Keshawn", "Keven", "Kevin", "Kevon", "Keyon", "Keyshawn", "Khalid", "Khalil", "Kian", "Kiana", "Kianna", "Kiara", "Kiarra", "Kiel", "Kiera", "Kieran", "Kiley", "Kim", "Kimberly", "King", "Kip", "Kira", "Kirk", "Kirsten", "Kirstin", "Kitty", "Kobe", "Koby", "Kody", "Kolby", "Kole", "Korbin", "Korey", "Kory", "Kraig", "Kris", "Krista", "Kristian", "Kristin", "Kristina", "Kristofer", "Kristoffer", "Kristopher", "Kristy", "Krystal", "Krystel", "Krystina", "Kurt", "Kurtis", "Kyla", "Kyle", "Kylee", "Kyleigh", "Kyler", "Kylie", "Kyra", "Lacey", "Lacy", "Ladarius", "Lafayette", "Laila", "Laisha", "Lamar", "Lambert", "Lamont", "Lance", "Landen", "Lane", "Laney", "Larissa", "Laron", "Larry", "Larue", "Laura", "Laurel", "Lauren", "Laurence", "Lauretta", "Lauriane", "Laurianne", "Laurie", "Laurine", "Laury", "Lauryn", "Lavada", "Lavern", "Laverna", "Laverne", "Lavina", "Lavinia", "Lavon", "Lavonne", "Lawrence", "Lawson", "Layla", "Layne", "Lazaro", "Lea", "Leann", "Leanna", "Leanne", "Leatha", "Leda", "Lee", "Leif", "Leila", "Leilani", "Lela", "Lelah", "Leland", "Lelia", "Lempi", "Lemuel", "Lenna", "Lennie", "Lenny", "Lenora", "Lenore", "Leo", "Leola", "Leon", "Leonard", "Leonardo", "Leone", "Leonel", "Leonie", "Leonor", "Leonora", "Leopold", "Leopoldo", "Leora", "Lera", "Lesley", "Leslie", "Lesly", "Lessie", "Lester", "Leta", "Letha", "Letitia", "Levi", "Lew", "Lewis", "Lexi", "Lexie", "Lexus", "Lia", "Liam", "Liana", "Libbie", "Libby", "Lila", "Lilian", "Liliana", "Liliane", "Lilla", "Lillian", "Lilliana", "Lillie", "Lilly", "Lily", "Lilyan", "Lina", "Lincoln", "Linda", "Lindsay", "Lindsey", "Linnea", "Linnie", "Linwood", "Lionel", "Lisa", "Lisandro", "Lisette", "Litzy", "Liza", "Lizeth", "Lizzie", "Llewellyn", "Lloyd", "Logan", "Lois", "Lola", "Lolita", "Loma", "Lon", "London", "Lonie", "Lonnie", "Lonny", "Lonzo", "Lora", "Loraine", "Loren", "Lorena", "Lorenz", "Lorenza", "Lorenzo", "Lori", "Lorine", "Lorna", "Lottie", "Lou", "Louie", "Louisa", "Lourdes", "Louvenia", "Lowell", "Loy", "Loyal", "Loyce", "Lucas", "Luciano", "Lucie", "Lucienne", "Lucile", "Lucinda", "Lucio", "Lucious", "Lucius", "Lucy", "Ludie", "Ludwig", "Lue", "Luella", "Luigi", "Luis", "Luisa", "Lukas", "Lula", "Lulu", "Luna", "Lupe", "Lura", "Lurline", "Luther", "Luz", "Lyda", "Lydia", "Lyla", "Lynn", "Lyric", "Lysanne", "Mabel", "Mabelle", "Mable", "Mac", "Macey", "Maci", "Macie", "Mack", "Mackenzie", "Macy", "Madaline", "Madalyn", "Maddison", "Madeline", "Madelyn", "Madelynn", "Madge", "Madie", "Madilyn", "Madisen", "Madison", "Madisyn", "Madonna", "Madyson", "Mae", "Maegan", "Maeve", "Mafalda", "Magali", "Magdalen", "Magdalena", "Maggie", "Magnolia", "Magnus", "Maia", "Maida", "Maiya", "Major", "Makayla", "Makenna", "Makenzie", "Malachi", "Malcolm", "Malika", "Malinda", "Mallie", "Mallory", "Malvina", "Mandy", "Manley", "Manuel", "Manuela", "Mara", "Marc", "Marcel", "Marcelina", "Marcelino", "Marcella", "Marcelle", "Marcellus", "Marcelo", "Marcia", "Marco", "Marcos", "Marcus", "Margaret", "Margarete", "Margarett", "Margaretta", "Margarette", "Margarita", "Marge", "Margie", "Margot", "Margret", "Marguerite", "Maria", "Mariah", "Mariam", "Marian", "Mariana", "Mariane", "Marianna", "Marianne", "Mariano", "Maribel", "Marie", "Mariela", "Marielle", "Marietta", "Marilie", "Marilou", "Marilyne", "Marina", "Mario", "Marion", "Marisa", "Marisol", "Maritza", "Marjolaine", "Marjorie", "Marjory", "Mark", "Markus", "Marlee", "Marlen", "Marlene", "Marley", "Marlin", "Marlon", "Marques", "Marquis", "Marquise", "Marshall", "Marta", "Martin", "Martina", "Martine", "Marty", "Marvin", "Mary", "Maryam", "Maryjane", "Maryse", "Mason", "Mateo", "Mathew", "Mathias", "Mathilde", "Matilda", "Matilde", "Matt", "Matteo", "Mattie", "Maud", "Maude", "Maudie", "Maureen", "Maurice", "Mauricio", "Maurine", "Maverick", "Mavis", "Max", "Maxie", "Maxime", "Maximilian", "Maximillia", "Maximillian", "Maximo", "Maximus", "Maxine", "Maxwell", "May", "Maya", "Maybell", "Maybelle", "Maye", "Maymie", "Maynard", "Mayra", "Mazie", "Mckayla", "Mckenna", "Mckenzie", "Meagan", "Meaghan", "Meda", "Megane", "Meggie", "Meghan", "Mekhi", "Melany", "Melba", "Melisa", "Melissa", "Mellie", "Melody", "Melvin", "Melvina", "Melyna", "Melyssa", "Mercedes", "Meredith", "Merl", "Merle", "Merlin", "Merritt", "Mertie", "Mervin", "Meta", "Mia", "Micaela", "Micah", "Michael", "Michaela", "Michale", "Micheal", "Michel", "Michele", "Michelle", "Miguel", "Mikayla", "Mike", "Mikel", "Milan", "Miles", "Milford", "Miller", "Millie", "Milo", "Milton", "Mina", "Minerva", "Minnie", "Miracle", "Mireille", "Mireya", "Misael", "Missouri", "Misty", "Mitchel", "Mitchell", "Mittie", "Modesta", "Modesto", "Mohamed", "Mohammad", "Mohammed", "Moises", "Mollie", "Molly", "Mona", "Monica", "Monique", "Monroe", "Monserrat", "Monserrate", "Montana", "Monte", "Monty", "Morgan", "Moriah", "Morris", "Mortimer", "Morton", "Mose", "Moses", "Moshe", "Mossie", "Mozell", "Mozelle", "Muhammad", "Muriel", "Murl", "Murphy", "Murray", "Mustafa", "Mya", "Myah", "Mylene", "Myles", "Myra", "Myriam", "Myrl", "Myrna", "Myron", "Myrtice", "Myrtie", "Myrtis", "Myrtle", "Nadia", "Nakia", "Name", "Nannie", "Naomi", "Naomie", "Napoleon", "Narciso", "Nash", "Nasir", "Nat", "Natalia", "Natalie", "Natasha", "Nathan", "Nathanael", "Nathanial", "Nathaniel", "Nathen", "Nayeli", "Neal", "Ned", "Nedra", "Neha", "Neil", "Nelda", "Nella", "Nelle", "Nellie", "Nels", "Nelson", "Neoma", "Nestor", "Nettie", "Neva", "Newell", "Newton", "Nia", "Nicholas", "Nicholaus", "Nichole", "Nick", "Nicklaus", "Nickolas", "Nico", "Nicola", "Nicolas", "Nicole", "Nicolette", "Nigel", "Nikita", "Nikki", "Nikko", "Niko", "Nikolas", "Nils", "Nina", "Noah", "Noble", "Noe", "Noel", "Noelia", "Noemi", "Noemie", "Noemy", "Nola", "Nolan", "Nona", "Nora", "Norbert", "Norberto", "Norene", "Norma", "Norris", "Norval", "Norwood", "Nova", "Novella", "Nya", "Nyah", "Nyasia", "Obie", "Oceane", "Ocie", "Octavia", "Oda", "Odell", "Odessa", "Odie", "Ofelia", "Okey", "Ola", "Olaf", "Ole", "Olen", "Oleta", "Olga", "Olin", "Oliver", "Ollie", "Oma", "Omari", "Omer", "Ona", "Onie", "Opal", "Ophelia", "Ora", "Oral", "Oran", "Oren", "Orie", "Orin", "Orion", "Orland", "Orlando", "Orlo", "Orpha", "Orrin", "Orval", "Orville", "Osbaldo", "Osborne", "Oscar", "Osvaldo", "Oswald", "Oswaldo", "Otha", "Otho", "Otilia", "Otis", "Ottilie", "Ottis", "Otto", "Ova", "Owen", "Ozella", "Pablo", "Paige", "Palma", "Pamela", "Pansy", "Paolo", "Paris", "Parker", "Pascale", "Pasquale", "Pat", "Patience", "Patricia", "Patrick", "Patsy", "Pattie", "Paul", "Paula", "Pauline", "Paxton", "Payton", "Pearl", "Pearlie", "Pearline", "Pedro", "Peggie", "Penelope", "Percival", "Percy", "Perry", "Pete", "Peter", "Petra", "Peyton", "Philip", "Phoebe", "Phyllis", "Pierce", "Pierre", "Pietro", "Pink", "Pinkie", "Piper", "Polly", "Porter", "Precious", "Presley", "Preston", "Price", "Prince", "Princess", "Priscilla", "Providenci", "Prudence", "Queen", "Queenie", "Quentin", "Quincy", "Quinn", "Quinten", "Quinton", "Rachael", "Rachel", "Rachelle", "Rae", "Raegan", "Rafael", "Rafaela", "Raheem", "Rahsaan", "Rahul", "Raina", "Raleigh", "Ralph", "Ramiro", "Ramon", "Ramona", "Randal", "Randall", "Randi", "Randy", "Ransom", "Raoul", "Raphael", "Raphaelle", "Raquel", "Rashad", "Rashawn", "Rasheed", "Raul", "Raven", "Ray", "Raymond", "Raymundo", "Reagan", "Reanna", "Reba", "Rebeca", "Rebecca", "Rebeka", "Rebekah", "Reece", "Reed", "Reese", "Regan", "Reggie", "Reginald", "Reid", "Reilly", "Reina", "Reinhold", "Remington", "Rene", "Renee", "Ressie", "Reta", "Retha", "Retta", "Reuben", "Reva", "Rex", "Rey", "Reyes", "Reymundo", "Reyna", "Reynold", "Rhea", "Rhett", "Rhianna", "Rhiannon", "Rhoda", "Ricardo", "Richard", "Richie", "Richmond", "Rick", "Rickey", "Rickie", "Ricky", "Rico", "Rigoberto", "Riley", "Rita", "River", "Robb", "Robbie", "Robert", "Roberta", "Roberto", "Robin", "Robyn", "Rocio", "Rocky", "Rod", "Roderick", "Rodger", "Rodolfo", "Rodrick", "Rodrigo", "Roel", "Rogelio", "Roger", "Rogers", "Rolando", "Rollin", "Roma", "Romaine", "Roman", "Ron", "Ronaldo", "Ronny", "Roosevelt", "Rory", "Rosa", "Rosalee", "Rosalia", "Rosalind", "Rosalinda", "Rosalyn", "Rosamond", "Rosanna", "Rosario", "Roscoe", "Rose", "Rosella", "Roselyn", "Rosemarie", "Rosemary", "Rosendo", "Rosetta", "Rosie", "Rosina", "Roslyn", "Ross", "Rossie", "Rowan", "Rowena", "Rowland", "Roxane", "Roxanne", "Roy", "Royal", "Royce", "Rozella", "Ruben", "Rubie", "Ruby", "Rubye", "Rudolph", "Rudy", "Rupert", "Russ", "Russel", "Russell", "Rusty", "Ruth", "Ruthe", "Ruthie", "Ryan", "Ryann", "Ryder", "Rylan", "Rylee", "Ryleigh", "Ryley", "Sabina", "Sabrina", "Sabryna", "Sadie", "Sadye", "Sage", "Saige", "Sallie", "Sally", "Salma", "Salvador", "Salvatore", "Sam", "Samanta", "Samantha", "Samara", "Samir", "Sammie", "Sammy", "Samson", "Sandra", "Sandrine", "Sandy", "Sanford", "Santa", "Santiago", "Santina", "Santino", "Santos", "Sarah", "Sarai", "Sarina", "Sasha", "Saul", "Savanah", "Savanna", "Savannah", "Savion", "Scarlett", "Schuyler", "Scot", "Scottie", "Scotty", "Seamus", "Sean", "Sebastian", "Sedrick", "Selena", "Selina", "Selmer", "Serena", "Serenity", "Seth", "Shad", "Shaina", "Shakira", "Shana", "Shane", "Shanel", "Shanelle", "Shania", "Shanie", "Shaniya", "Shanna", "Shannon", "Shanny", "Shanon", "Shany", "Sharon", "Shaun", "Shawn", "Shawna", "Shaylee", "Shayna", "Shayne", "Shea", "Sheila", "Sheldon", "Shemar", "Sheridan", "Sherman", "Sherwood", "Shirley", "Shyann", "Shyanne", "Sibyl", "Sid", "Sidney", "Sienna", "Sierra", "Sigmund", "Sigrid", "Sigurd", "Silas", "Sim", "Simeon", "Simone", "Sincere", "Sister", "Skye", "Skyla", "Skylar", "Sofia", "Soledad", "Solon", "Sonia", "Sonny", "Sonya", "Sophia", "Sophie", "Spencer", "Stacey", "Stacy", "Stan", "Stanford", "Stanley", "Stanton", "Stefan", "Stefanie", "Stella", "Stephan", "Stephania", "Stephanie", "Stephany", "Stephen", "Stephon", "Sterling", "Steve", "Stevie", "Stewart", "Stone", "Stuart", "Summer", "Sunny", "Susan", "Susana", "Susanna", "Susie", "Suzanne", "Sven", "Syble", "Sydnee", "Sydney", "Sydni", "Sydnie", "Sylvan", "Sylvester", "Sylvia", "Tabitha", "Tad", "Talia", "Talon", "Tamara", "Tamia", "Tania", "Tanner", "Tanya", "Tara", "Taryn", "Tate", "Tatum", "Tatyana", "Taurean", "Tavares", "Taya", "Taylor", "Teagan", "Ted", "Telly", "Terence", "Teresa", "Terrance", "Terrell", "Terrence", "Terrill", "Terry", "Tess", "Tessie", "Tevin", "Thad", "Thaddeus", "Thalia", "Thea", "Thelma", "Theo", "Theodora", "Theodore", "Theresa", "Therese", "Theresia", "Theron", "Thomas", "Thora", "Thurman", "Tia", "Tiana", "Tianna", "Tiara", "Tierra", "Tiffany", "Tillman", "Timmothy", "Timmy", "Timothy", "Tina", "Tito", "Titus", "Tobin", "Toby", "Tod", "Tom", "Tomas", "Tomasa", "Tommie", "Toney", "Toni", "Tony", "Torey", "Torrance", "Torrey", "Toy", "Trace", "Tracey", "Tracy", "Travis", "Travon", "Tre", "Tremaine", "Tremayne", "Trent", "Trenton", "Tressa", "Tressie", "Treva", "Trever", "Trevion", "Trevor", "Trey", "Trinity", "Trisha", "Tristian", "Tristin", "Triston", "Troy", "Trudie", "Trycia", "Trystan", "Turner", "Twila", "Tyler", "Tyra", "Tyree", "Tyreek", "Tyrel", "Tyrell", "Tyrese", "Tyrique", "Tyshawn", "Tyson", "Ubaldo", "Ulices", "Ulises", "Una", "Unique", "Urban", "Uriah", "Uriel", "Ursula", "Vada", "Valentin", "Valentina", "Valentine", "Valerie", "Vallie", "Van", "Vance", "Vanessa", "Vaughn", "Veda", "Velda", "Vella", "Velma", "Velva", "Vena", "Verda", "Verdie", "Vergie", "Verla", "Verlie", "Vern", "Verna", "Verner", "Vernice", "Vernie", "Vernon", "Verona", "Veronica", "Vesta", "Vicenta", "Vicente", "Vickie", "Vicky", "Victor", "Victoria", "Vida", "Vidal", "Vilma", "Vince", "Vincent", "Vincenza", "Vincenzo", "Vinnie", "Viola", "Violet", "Violette", "Virgie", "Virgil", "Virginia", "Virginie", "Vita", "Vito", "Viva", "Vivian", "Viviane", "Vivianne", "Vivien", "Vivienne", "Vladimir", "Wade", "Waino", "Waldo", "Walker", "Wallace", "Walter", "Walton", "Wanda", "Ward", "Warren", "Watson", "Wava", "Waylon", "Wayne", "Webster", "Weldon", "Wellington", "Wendell", "Wendy", "Werner", "Westley", "Weston", "Whitney", "Wilber", "Wilbert", "Wilburn", "Wiley", "Wilford", "Wilfred", "Wilfredo", "Wilfrid", "Wilhelm", "Wilhelmine", "Will", "Willa", "Willard", "William", "Willie", "Willis", "Willow", "Willy", "Wilma", "Wilmer", "Wilson", "Wilton", "Winfield", "Winifred", "Winnifred", "Winona", "Winston", "Woodrow", "Wyatt", "Wyman", "Xander", "Xavier", "Xzavier", "Yadira", "Yasmeen", "Yasmin", "Yasmine", "Yazmin", "Yesenia", "Yessenia", "Yolanda", "Yoshiko", "Yvette", "Yvonne", "Zachariah", "Zachary", "Zachery", "Zack", "Zackary", "Zackery", "Zakary", "Zander", "Zane", "Zaria", "Zechariah", "Zelda", "Zella", "Zelma", "Zena", "Zetta", "Zion", "Zita", "Zoe", "Zoey", "Zoie", "Zoila", "Zola", "Zora", "Zula"], female: ["Ada", "Adrienne", "Agnes", "Alberta", "Alexandra", "Alexis", "Alice", "Alicia", "Alison", "Allison", "Alma", "Alyssa", "Amanda", "Amber", "Amelia", "Amy", "Ana", "Andrea", "Angel", "Angela", "Angelica", "Angelina", "Angie", "Anita", "Ann", "Anna", "Anne", "Annette", "Annie", "Antoinette", "Antonia", "April", "Arlene", "Ashley", "Audrey", "Barbara", "Beatrice", "Becky", "Belinda", "Bernadette", "Bernice", "Bertha", "Bessie", "Beth", "Bethany", "Betsy", "Betty", "Beulah", "Beverly", "Billie", "Blanca", "Blanche", "Bobbie", "Bonnie", "Brandi", "Brandy", "Brenda", "Bridget", "Brittany", "Brooke", "Camille", "Candace", "Candice", "Carla", "Carmen", "Carol", "Carole", "Caroline", "Carolyn", "Carrie", "Casey", "Cassandra", "Catherine", "Cathy", "Cecelia", "Cecilia", "Celia", "Charlene", "Charlotte", "Chelsea", "Cheryl", "Christie", "Christina", "Christine", "Christy", "Cindy", "Claire", "Clara", "Claudia", "Colleen", "Connie", "Constance", "Cora", "Courtney", "Cristina", "Crystal", "Cynthia", "Daisy", "Dana", "Danielle", "Darla", "Darlene", "Dawn", "Deanna", "Debbie", "Deborah", "Debra", "Delia", "Della", "Delores", "Denise", "Desiree", "Diana", "Diane", "Dianna", "Dianne", "Dixie", "Dolores", "Donna", "Dora", "Doreen", "Doris", "Dorothy", "Ebony", "Edith", "Edna", "Eileen", "Elaine", "Eleanor", "Elena", "Elisa", "Elizabeth", "Ella", "Ellen", "Eloise", "Elsa", "Elsie", "Elvira", "Emily", "Emma", "Erica", "Erika", "Erin", "Erma", "Ernestine", "Essie", "Estelle", "Esther", "Ethel", "Eula", "Eunice", "Eva", "Evelyn", "Faith", "Fannie", "Faye", "Felicia", "Flora", "Florence", "Frances", "Francis", "Freda", "Gail", "Gayle", "Geneva", "Genevieve", "Georgia", "Geraldine", "Gertrude", "Gina", "Ginger", "Gladys", "Glenda", "Gloria", "Grace", "Gretchen", "Guadalupe", "Gwen", "Gwendolyn", "Hannah", "Harriet", "Hattie", "Hazel", "Heather", "Heidi", "Helen", "Henrietta", "Hilda", "Holly", "Hope", "Ida", "Inez", "Irene", "Iris", "Irma", "Isabel", "Jackie", "Jacqueline", "Jacquelyn", "Jaime", "Jamie", "Jan", "Jana", "Jane", "Janet", "Janice", "Janie", "Janis", "Jasmine", "Jean", "Jeanette", "Jeanne", "Jeannette", "Jeannie", "Jenna", "Jennie", "Jennifer", "Jenny", "Jessica", "Jessie", "Jill", "Jo", "Joan", "Joann", "Joanna", "Joanne", "Jodi", "Jody", "Johanna", "Johnnie", "Josefina", "Josephine", "Joy", "Joyce", "Juana", "Juanita", "Judith", "Judy", "Julia", "Julie", "June", "Kara", "Karen", "Kari", "Karla", "Kate", "Katherine", "Kathleen", "Kathryn", "Kathy", "Katie", "Katrina", "Kay", "Kayla", "Kelley", "Kelli", "Kellie", "Kelly", "Kendra", "Kerry", "Kim", "Kimberly", "Krista", "Kristen", "Kristi", "Kristie", "Kristin", "Kristina", "Kristine", "Kristy", "Krystal", "Lana", "Latoya", "Laura", "Lauren", "Laurie", "Laverne", "Leah", "Lee", "Leigh", "Lela", "Lena", "Leona", "Leslie", "Leticia", "Lila", "Lillian", "Lillie", "Linda", "Lindsay", "Lindsey", "Lisa", "Lois", "Lola", "Lora", "Lorena", "Lorene", "Loretta", "Lori", "Lorraine", "Louise", "Lucia", "Lucille", "Lucy", "Lula", "Luz", "Lydia", "Lynda", "Lynette", "Lynn", "Lynne", "Mabel", "Mable", "Madeline", "Mae", "Maggie", "Mamie", "Mandy", "Marcella", "Marcia", "Margaret", "Margarita", "Margie", "Marguerite", "Maria", "Marian", "Marianne", "Marie", "Marilyn", "Marion", "Marjorie", "Marlene", "Marsha", "Marta", "Martha", "Mary", "Maryann", "Mattie", "Maureen", "Maxine", "May", "Megan", "Meghan", "Melanie", "Melba", "Melinda", "Melissa", "Melody", "Mercedes", "Meredith", "Michele", "Michelle", "Mildred", "Mindy", "Minnie", "Miranda", "Miriam", "Misty", "Molly", "Mona", "Monica", "Monique", "Muriel", "Myra", "Myrtle", "Nadine", "Nancy", "Naomi", "Natalie", "Natasha", "Nellie", "Nettie", "Nichole", "Nicole", "Nina", "Nora", "Norma", "Olga", "Olive", "Olivia", "Ollie", "Opal", "Ora", "Pam", "Pamela", "Pat", "Patricia", "Patsy", "Patti", "Patty", "Paula", "Paulette", "Pauline", "Pearl", "Peggy", "Penny", "Phyllis", "Priscilla", "Rachael", "Rachel", "Ramona", "Raquel", "Rebecca", "Regina", "Renee", "Rhonda", "Rita", "Roberta", "Robin", "Robyn", "Rochelle", "Rosa", "Rosalie", "Rose", "Rosemarie", "Rosemary", "Rosie", "Roxanne", "Ruby", "Ruth", "Sabrina", "Sadie", "Sally", "Samantha", "Sandra", "Sandy", "Sara", "Sarah", "Shannon", "Shari", "Sharon", "Shawna", "Sheila", "Shelia", "Shelley", "Shelly", "Sheri", "Sherri", "Sherry", "Sheryl", "Shirley", "Silvia", "Sonia", "Sonja", "Sonya", "Sophia", "Sophie", "Stacey", "Stacy", "Stella", "Stephanie", "Sue", "Susan", "Susie", "Suzanne", "Sylvia", "Tabitha", "Tamara", "Tami", "Tammy", "Tanya", "Tara", "Tasha", "Teresa", "Teri", "Terri", "Terry", "Thelma", "Theresa", "Tiffany", "Tina", "Toni", "Tonya", "Tracey", "Traci", "Tracy", "Tricia", "Valerie", "Vanessa", "Velma", "Vera", "Verna", "Veronica", "Vicki", "Vickie", "Vicky", "Victoria", "Viola", "Violet", "Virginia", "Vivian", "Wanda", "Wendy", "Whitney", "Willie", "Wilma", "Winifred", "Yolanda", "Yvette", "Yvonne"], male: ["Aaron", "Abel", "Abraham", "Adam", "Adrian", "Al", "Alan", "Albert", "Alberto", "Alejandro", "Alex", "Alexander", "Alfonso", "Alfred", "Alfredo", "Allan", "Allen", "Alonzo", "Alton", "Alvin", "Amos", "Andre", "Andres", "Andrew", "Andy", "Angel", "Angelo", "Anthony", "Antonio", "Archie", "Armando", "Arnold", "Arthur", "Arturo", "Aubrey", "Austin", "Barry", "Ben", "Benjamin", "Bennie", "Benny", "Bernard", "Bert", "Bill", "Billy", "Blake", "Bob", "Bobby", "Boyd", "Brad", "Bradford", "Bradley", "Brandon", "Brendan", "Brent", "Brett", "Brian", "Bruce", "Bryan", "Bryant", "Byron", "Caleb", "Calvin", "Cameron", "Carl", "Carlos", "Carlton", "Carroll", "Cary", "Casey", "Cecil", "Cedric", "Cesar", "Chad", "Charles", "Charlie", "Chester", "Chris", "Christian", "Christopher", "Clarence", "Clark", "Claude", "Clay", "Clayton", "Clifford", "Clifton", "Clint", "Clinton", "Clyde", "Cody", "Colin", "Conrad", "Corey", "Cornelius", "Cory", "Courtney", "Craig", "Curtis", "Dale", "Dallas", "Damon", "Dan", "Dana", "Daniel", "Danny", "Darin", "Darnell", "Darrel", "Darrell", "Darren", "Darrin", "Darryl", "Daryl", "Dave", "David", "Dean", "Delbert", "Dennis", "Derek", "Derrick", "Devin", "Dewey", "Dexter", "Domingo", "Dominic", "Dominick", "Don", "Donald", "Donnie", "Doug", "Douglas", "Doyle", "Drew", "Duane", "Dustin", "Dwayne", "Dwight", "Earl", "Earnest", "Ed", "Eddie", "Edgar", "Edmond", "Edmund", "Eduardo", "Edward", "Edwin", "Elbert", "Elias", "Elijah", "Ellis", "Elmer", "Emanuel", "Emilio", "Emmett", "Enrique", "Eric", "Erick", "Erik", "Ernest", "Ernesto", "Ervin", "Eugene", "Evan", "Everett", "Felipe", "Felix", "Fernando", "Floyd", "Forrest", "Francis", "Francisco", "Frank", "Frankie", "Franklin", "Fred", "Freddie", "Frederick", "Fredrick", "Gabriel", "Garrett", "Garry", "Gary", "Gene", "Geoffrey", "George", "Gerald", "Gerard", "Gerardo", "Gilbert", "Gilberto", "Glen", "Glenn", "Gordon", "Grady", "Grant", "Greg", "Gregg", "Gregory", "Guadalupe", "Guillermo", "Gustavo", "Guy", "Harold", "Harry", "Harvey", "Hector", "Henry", "Herbert", "Herman", "Homer", "Horace", "Howard", "Hubert", "Hugh", "Hugo", "Ian", "Ignacio", "Ira", "Irvin", "Irving", "Isaac", "Ismael", "Israel", "Ivan", "Jack", "Jackie", "Jacob", "Jaime", "Jake", "James", "Jamie", "Jan", "Jared", "Jason", "Javier", "Jay", "Jean", "Jeff", "Jeffery", "Jeffrey", "Jerald", "Jeremiah", "Jeremy", "Jermaine", "Jerome", "Jerry", "Jesse", "Jessie", "Jesus", "Jim", "Jimmie", "Jimmy", "Jody", "Joe", "Joel", "Joey", "John", "Johnathan", "Johnnie", "Johnny", "Jon", "Jonathan", "Jonathon", "Jordan", "Jorge", "Jose", "Joseph", "Josh", "Joshua", "Juan", "Julian", "Julio", "Julius", "Justin", "Karl", "Keith", "Kelly", "Kelvin", "Ken", "Kenneth", "Kenny", "Kent", "Kerry", "Kevin", "Kim", "Kirk", "Kristopher", "Kurt", "Kyle", "Lamar", "Lance", "Larry", "Laurence", "Lawrence", "Lee", "Leland", "Leo", "Leon", "Leonard", "Leroy", "Leslie", "Lester", "Levi", "Lewis", "Lionel", "Lloyd", "Lonnie", "Loren", "Lorenzo", "Louis", "Lowell", "Lucas", "Luis", "Luke", "Luther", "Lyle", "Lynn", "Mack", "Malcolm", "Manuel", "Marc", "Marco", "Marcos", "Marcus", "Mario", "Marion", "Mark", "Marlon", "Marshall", "Martin", "Marty", "Marvin", "Mathew", "Matt", "Matthew", "Maurice", "Max", "Melvin", "Merle", "Michael", "Micheal", "Miguel", "Mike", "Milton", "Mitchell", "Morris", "Moses", "Myron", "Nathan", "Nathaniel", "Neal", "Neil", "Nelson", "Nicholas", "Nick", "Nicolas", "Noah", "Noel", "Norman", "Oliver", "Omar", "Orlando", "Orville", "Oscar", "Otis", "Owen", "Pablo", "Pat", "Patrick", "Paul", "Pedro", "Percy", "Perry", "Pete", "Peter", "Phil", "Philip", "Phillip", "Preston", "Rafael", "Ralph", "Ramiro", "Ramon", "Randal", "Randall", "Randolph", "Randy", "Raul", "Ray", "Raymond", "Reginald", "Rene", "Rex", "Ricardo", "Richard", "Rick", "Rickey", "Ricky", "Robert", "Roberto", "Robin", "Roderick", "Rodney", "Rodolfo", "Rogelio", "Roger", "Roland", "Rolando", "Roman", "Ron", "Ronald", "Ronnie", "Roosevelt", "Ross", "Roy", "Ruben", "Rudolph", "Rudy", "Rufus", "Russell", "Ryan", "Salvador", "Salvatore", "Sam", "Sammy", "Samuel", "Santiago", "Santos", "Saul", "Scott", "Sean", "Sergio", "Seth", "Shane", "Shannon", "Shaun", "Shawn", "Sheldon", "Sherman", "Sidney", "Simon", "Spencer", "Stanley", "Stephen", "Steve", "Steven", "Stewart", "Stuart", "Sylvester", "Taylor", "Ted", "Terence", "Terrance", "Terrell", "Terrence", "Terry", "Theodore", "Thomas", "Tim", "Timmy", "Timothy", "Toby", "Todd", "Tom", "Tomas", "Tommie", "Tommy", "Tony", "Tracy", "Travis", "Trevor", "Troy", "Tyler", "Tyrone", "Van", "Vernon", "Victor", "Vincent", "Virgil", "Wade", "Wallace", "Walter", "Warren", "Wayne", "Wendell", "Wesley", "Wilbert", "Wilbur", "Wilfred", "Willard", "William", "Willie", "Willis", "Wilson", "Winston", "Wm", "Woodrow", "Zachary"] }, $ve = ["Agender", "Androgyne", "Androgynous", "Bigender", "Cis female", "Cis male", "Cis man", "Cis woman", "Cis", "Cisgender female", "Cisgender male", "Cisgender man", "Cisgender woman", "Cisgender", "Demi-boy", "Demi-girl", "Demi-man", "Demi-woman", "Demiflux", "Demigender", "F2M", "FTM", "Female to male trans man", "Female to male transgender man", "Female to male transsexual man", "Female to male", "Gender fluid", "Gender neutral", "Gender nonconforming", "Gender questioning", "Gender variant", "Genderflux", "Genderqueer", "Hermaphrodite", "Intersex man", "Intersex person", "Intersex woman", "Intersex", "M2F", "MTF", "Male to female trans woman", "Male to female transgender woman", "Male to female transsexual woman", "Male to female", "Man", "Multigender", "Neither", "Neutrois", "Non-binary", "Omnigender", "Other", "Pangender", "Polygender", "T* man", "T* woman", "Trans female", "Trans male", "Trans man", "Trans person", "Trans woman", "Trans", "Transsexual female", "Transsexual male", "Transsexual man", "Transsexual person", "Transsexual woman", "Transsexual", "Transgender female", "Transgender person", "Transmasculine", "Trigender", "Two* person", "Two-spirit person", "Two-spirit", "Woman", "Xenogender"], Hve = ["Solutions", "Program", "Brand", "Security", "Research", "Marketing", "Directives", "Implementation", "Integration", "Functionality", "Response", "Paradigm", "Tactics", "Identity", "Markets", "Group", "Division", "Applications", "Optimization", "Operations", "Infrastructure", "Intranet", "Communications", "Web", "Branding", "Quality", "Assurance", "Mobility", "Accounts", "Data", "Creative", "Configuration", "Accountability", "Interactions", "Factors", "Usability", "Metrics"], Uve = ["Lead", "Senior", "Direct", "Corporate", "Dynamic", "Future", "Product", "National", "Regional", "District", "Central", "Global", "Customer", "Investor", "International", "Legacy", "Forward", "Internal", "Human", "Chief", "Principal"], Gve = ["{{person.jobDescriptor}} {{person.jobArea}} {{person.jobType}}"], Wve = ["Supervisor", "Associate", "Executive", "Liaison", "Officer", "Manager", "Engineer", "Specialist", "Director", "Coordinator", "Administrator", "Architect", "Analyst", "Designer", "Planner", "Orchestrator", "Technician", "Developer", "Producer", "Consultant", "Assistant", "Facilitator", "Agent", "Representative", "Strategist"], Vve = { generic: ["Abbott", "Abernathy", "Abshire", "Adams", "Altenwerth", "Anderson", "Ankunding", "Armstrong", "Auer", "Aufderhar", "Bahringer", "Bailey", "Balistreri", "Barrows", "Bartell", "Bartoletti", "Barton", "Bashirian", "Batz", "Bauch", "Baumbach", "Bayer", "Beahan", "Beatty", "Bechtelar", "Becker", "Bednar", "Beer", "Beier", "Berge", "Bergnaum", "Bergstrom", "Bernhard", "Bernier", "Bins", "Blanda", "Blick", "Block", "Bode", "Boehm", "Bogan", "Bogisich", "Borer", "Bosco", "Botsford", "Boyer", "Boyle", "Bradtke", "Brakus", "Braun", "Breitenberg", "Brekke", "Brown", "Bruen", "Buckridge", "Carroll", "Carter", "Cartwright", "Casper", "Cassin", "Champlin", "Christiansen", "Cole", "Collier", "Collins", "Conn", "Connelly", "Conroy", "Considine", "Corkery", "Cormier", "Corwin", "Cremin", "Crist", "Crona", "Cronin", "Crooks", "Cruickshank", "Cummerata", "Cummings", "D'Amore", "Dach", "Daniel", "Dare", "Daugherty", "Davis", "Deckow", "Denesik", "Dibbert", "Dickens", "Dicki", "Dickinson", "Dietrich", "Donnelly", "Dooley", "Douglas", "Doyle", "DuBuque", "Durgan", "Ebert", "Effertz", "Emard", "Emmerich", "Erdman", "Ernser", "Fadel", "Fahey", "Farrell", "Fay", "Feeney", "Feest", "Feil", "Ferry", "Fisher", "Flatley", "Frami", "Franecki", "Franey", "Friesen", "Fritsch", "Funk", "Gerhold", "Gerlach", "Gibson", "Gislason", "Gleason", "Gleichner", "Glover", "Goldner", "Goodwin", "Gorczany", "Gottlieb", "Goyette", "Grady", "Graham", "Grant", "Green", "Greenfelder", "Greenholt", "Grimes", "Gulgowski", "Gusikowski", "Gutkowski", "Gutmann", "Haag", "Hackett", "Hagenes", "Hahn", "Haley", "Halvorson", "Hamill", "Hammes", "Hand", "Hane", "Hansen", "Harber", "Harris", "Hartmann", "Harvey", "Hauck", "Hayes", "Heaney", "Heathcote", "Hegmann", "Heidenreich", "Heller", "Herman", "Hermann", "Hermiston", "Herzog", "Hessel", "Hettinger", "Hickle", "Hilll", "Hills", "Hilpert", "Hintz", "Hirthe", "Hodkiewicz", "Hoeger", "Homenick", "Hoppe", "Howe", "Howell", "Hudson", "Huel", "Huels", "Hyatt", "Jacobi", "Jacobs", "Jacobson", "Jakubowski", "Jaskolski", "Jast", "Jenkins", "Jerde", "Johns", "Johnson", "Johnston", "Jones", "Kassulke", "Kautzer", "Keebler", "Keeling", "Kemmer", "Kerluke", "Kertzmann", "Kessler", "Kiehn", "Kihn", "Kilback", "King", "Kirlin", "Klein", "Kling", "Klocko", "Koch", "Koelpin", "Koepp", "Kohler", "Konopelski", "Koss", "Kovacek", "Kozey", "Krajcik", "Kreiger", "Kris", "Kshlerin", "Kub", "Kuhic", "Kuhlman", "Kuhn", "Kulas", "Kunde", "Kunze", "Kuphal", "Kutch", "Kuvalis", "Labadie", "Lakin", "Lang", "Langosh", "Langworth", "Larkin", "Larson", "Leannon", "Lebsack", "Ledner", "Leffler", "Legros", "Lehner", "Lemke", "Lesch", "Leuschke", "Lind", "Lindgren", "Littel", "Little", "Lockman", "Lowe", "Lubowitz", "Lueilwitz", "Luettgen", "Lynch", "MacGyver", "Macejkovic", "Maggio", "Mann", "Mante", "Marks", "Marquardt", "Marvin", "Mayer", "Mayert", "McClure", "McCullough", "McDermott", "McGlynn", "McKenzie", "McLaughlin", "Medhurst", "Mertz", "Metz", "Miller", "Mills", "Mitchell", "Moen", "Mohr", "Monahan", "Moore", "Morar", "Morissette", "Mosciski", "Mraz", "Mueller", "Muller", "Murazik", "Murphy", "Murray", "Nader", "Nicolas", "Nienow", "Nikolaus", "Nitzsche", "Nolan", "O'Connell", "O'Conner", "O'Hara", "O'Keefe", "O'Kon", "O'Reilly", "Oberbrunner", "Okuneva", "Olson", "Ondricka", "Orn", "Ortiz", "Osinski", "Pacocha", "Padberg", "Pagac", "Parisian", "Parker", "Paucek", "Pfannerstill", "Pfeffer", "Pollich", "Pouros", "Powlowski", "Predovic", "Price", "Prohaska", "Prosacco", "Purdy", "Quigley", "Quitzon", "Rath", "Ratke", "Rau", "Raynor", "Reichel", "Reichert", "Reilly", "Reinger", "Rempel", "Renner", "Reynolds", "Rice", "Rippin", "Ritchie", "Robel", "Roberts", "Rodriguez", "Rogahn", "Rohan", "Rolfson", "Romaguera", "Roob", "Rosenbaum", "Rowe", "Ruecker", "Runolfsdottir", "Runolfsson", "Runte", "Russel", "Rutherford", "Ryan", "Sanford", "Satterfield", "Sauer", "Sawayn", "Schaden", "Schaefer", "Schamberger", "Schiller", "Schimmel", "Schinner", "Schmeler", "Schmidt", "Schmitt", "Schneider", "Schoen", "Schowalter", "Schroeder", "Schulist", "Schultz", "Schumm", "Schuppe", "Schuster", "Senger", "Shanahan", "Shields", "Simonis", "Sipes", "Skiles", "Smith", "Smitham", "Spencer", "Spinka", "Sporer", "Stamm", "Stanton", "Stark", "Stehr", "Steuber", "Stiedemann", "Stokes", "Stoltenberg", "Stracke", "Streich", "Stroman", "Strosin", "Swaniawski", "Swift", "Terry", "Thiel", "Thompson", "Tillman", "Torp", "Torphy", "Towne", "Toy", "Trantow", "Tremblay", "Treutel", "Tromp", "Turcotte", "Turner", "Ullrich", "Upton", "Vandervort", "Veum", "Volkman", "Von", "VonRueden", "Waelchi", "Walker", "Walsh", "Walter", "Ward", "Waters", "Watsica", "Weber", "Wehner", "Weimann", "Weissnat", "Welch", "West", "White", "Wiegand", "Wilderman", "Wilkinson", "Will", "Williamson", "Willms", "Windler", "Wintheiser", "Wisoky", "Wisozk", "Witting", "Wiza", "Wolf", "Wolff", "Wuckert", "Wunsch", "Wyman", "Yost", "Yundt", "Zboncak", "Zemlak", "Ziemann", "Zieme", "Zulauf"] }, Kve = { generic: [{ value: "{{person.last_name.generic}}", weight: 95 }, { value: "{{person.last_name.generic}}-{{person.last_name.generic}}", weight: 5 }] }, zve = { generic: ["Addison", "Alex", "Anderson", "Angel", "Arden", "August", "Austin", "Avery", "Bailey", "Billie", "Blake", "Bowie", "Brooklyn", "Cameron", "Charlie", "Corey", "Dakota", "Drew", "Elliott", "Ellis", "Emerson", "Finley", "Gray", "Greer", "Harper", "Hayden", "Jaden", "James", "Jamie", "Jordan", "Jules", "Kai", "Kendall", "Kennedy", "Kyle", "Leslie", "Logan", "London", "Marlowe", "Micah", "Nico", "Noah", "North", "Parker", "Phoenix", "Quinn", "Reagan", "Reese", "Reign", "Riley", "River", "Robin", "Rory", "Rowan", "Ryan", "Sage", "Sasha", "Sawyer", "Shawn", "Shiloh", "Skyler", "Taylor"], female: ["Abigail", "Adele", "Alex", "Alice", "Alisha", "Amber", "Amelia", "Amora", "Anaïs", "Angelou", "Anika", "Anise", "Annabel", "Anne", "Aphrodite", "Aretha", "Arya", "Ashton", "Aster", "Audrey", "Avery", "Bailee", "Bay", "Belle", "Beth", "Billie", "Blair", "Blaise", "Blake", "Blanche", "Blue", "Bree", "Brielle", "Brienne", "Brooke", "Caleen", "Candice", "Caprice", "Carelyn", "Caylen", "Celine", "Cerise", "Cia", "Claire", "Claudia", "Clementine", "Coral", "Coraline", "Dahlia", "Dakota", "Dawn", "Della", "Demi", "Denise", "Denver", "Devine", "Devon", "Diana", "Dylan", "Ebony", "Eden", "Eleanor", "Elein", "Elizabeth", "Ellen", "Elodie", "Eloise", "Ember", "Emma", "Erin", "Eyre", "Faith", "Farrah", "Fawn", "Fayre", "Fern", "France", "Francis", "Frida", "Genisis", "Georgia", "Grace", "Gwen", "Harley", "Harper", "Hazel", "Helen", "Hippolyta", "Holly", "Hope", "Imani", "Iowa", "Ireland", "Irene", "Iris", "Isa", "Isla", "Ivy", "Jade", "Jane", "Jazz", "Jean", "Jess", "Jett", "Jo", "Joan", "Jolie", "Jordan", "Josie", "Journey", "Joy", "Jules", "Julien", "Juliet", "Juniper", "Justice", "Kali", "Karma", "Kat", "Kate", "Kennedy", "Keva", "Kylie", "Lake", "Lane", "Lark", "Layla", "Lee", "Leigh", "Leona", "Lexi", "London", "Lou", "Louise", "Love", "Luna", "Lux", "Lynn", "Lyric", "Maddie", "Mae", "Marie", "Matilda", "Maude", "Maybel", "Meadow", "Medusa", "Mercy", "Michelle", "Mirabel", "Monroe", "Morgan", "Nalia", "Naomi", "Nova", "Olive", "Paige", "Parker", "Pax", "Pearl", "Penelope", "Phoenix", "Quinn", "Rae", "Rain", "Raven", "Ray", "Raye", "Rebel", "Reese", "Reeve", "Regan", "Riley", "River", "Robin", "Rory", "Rose", "Royal", "Ruth", "Rylie", "Sage", "Sam", "Saturn", "Scout", "Serena", "Sky", "Skylar", "Sofia", "Sophia", "Storm", "Sue", "Suzanne", "Sydney", "Taylen", "Taylor", "Teagan", "Tempest", "Tenley", "Thea", "Trinity", "Valerie", "Venus", "Vera", "Violet", "Willow", "Winter", "Xena", "Zaylee", "Zion", "Zoe"], male: ["Ace", "Aiden", "Alexander", "Ander", "Anthony", "Asher", "August", "Aziel", "Bear", "Beckham", "Benjamin", "Buddy", "Calvin", "Carter", "Charles", "Christopher", "Clyde", "Cooper", "Daniel", "David", "Dior", "Dylan", "Elijah", "Ellis", "Emerson", "Ethan", "Ezra", "Fletcher", "Flynn", "Gabriel", "Grayson", "Gus", "Hank", "Harrison", "Hendrix", "Henry", "Houston", "Hudson", "Hugh", "Isaac", "Jack", "Jackson", "Jacob", "Jakobe", "James", "Jaxon", "Jaxtyn", "Jayden", "John", "Joseph", "Josiah", "Jude", "Julian", "Karsyn", "Kenji", "Kobe", "Kylo", "Lennon", "Leo", "Levi", "Liam", "Lincoln", "Logan", "Louis", "Lucas", "Lucky", "Luke", "Mason", "Mateo", "Matthew", "Maverick", "Michael", "Monroe", "Nixon", "Ocean", "Oliver", "Otis", "Otto", "Owen", "Ozzy", "Parker", "Rocky", "Samuel", "Sebastian", "Sonny", "Teddy", "Theo", "Theodore", "Thomas", "Truett", "Walter", "Warren", "Watson", "William", "Wison", "Wyatt", "Ziggy", "Zyair"] }, jve = [{ value: "{{person.firstName}} {{person.lastName}}", weight: 49 }, { value: "{{person.prefix}} {{person.firstName}} {{person.lastName}}", weight: 7 }, { value: "{{person.firstName}} {{person.lastName}} {{person.suffix}}", weight: 7 }, { value: "{{person.prefix}} {{person.firstName}} {{person.lastName}} {{person.suffix}}", weight: 1 }], Yve = { generic: ["Dr.", "Miss", "Mr.", "Mrs.", "Ms."], female: ["Dr.", "Miss", "Mrs.", "Ms."], male: ["Dr.", "Mr."] }, qve = ["female", "male"], Jve = ["Jr.", "Sr.", "I", "II", "III", "IV", "V", "MD", "DDS", "PhD", "DVM"], Qve = ["Aquarius", "Pisces", "Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius", "Capricorn"], Xve = { bio_part: Lve, bio_pattern: Mve, bio_supporter: Ove, first_name: Bve, gender: $ve, job_area: Hve, job_descriptor: Uve, job_title_pattern: Gve, job_type: Wve, last_name: Vve, last_name_pattern: Kve, middle_name: zve, name: jve, prefix: Yve, sex: qve, suffix: Jve, western_zodiac_sign: Qve }, Zve = Xve, exe = ["!##-!##-####", "(!##) !##-####", "1-!##-!##-####", "!##.!##.####", "!##-!##-#### x###", "(!##) !##-#### x###", "1-!##-!##-#### x###", "!##.!##.#### x###", "!##-!##-#### x####", "(!##) !##-#### x####", "1-!##-!##-#### x####", "!##.!##.#### x####", "!##-!##-#### x#####", "(!##) !##-#### x#####", "1-!##-!##-#### x#####", "!##.!##.#### x#####"], txe = ["+1!##!######"], nxe = ["(!##) !##-####"], rxe = { human: exe, international: txe, national: nxe }, ixe = rxe, sxe = { format: ixe }, axe = sxe, oxe = [{ symbol: "H", name: "Hydrogen", atomicNumber: 1 }, { symbol: "He", name: "Helium", atomicNumber: 2 }, { symbol: "Li", name: "Lithium", atomicNumber: 3 }, { symbol: "Be", name: "Beryllium", atomicNumber: 4 }, { symbol: "B", name: "Boron", atomicNumber: 5 }, { symbol: "C", name: "Carbon", atomicNumber: 6 }, { symbol: "N", name: "Nitrogen", atomicNumber: 7 }, { symbol: "O", name: "Oxygen", atomicNumber: 8 }, { symbol: "F", name: "Fluorine", atomicNumber: 9 }, { symbol: "Ne", name: "Neon", atomicNumber: 10 }, { symbol: "Na", name: "Sodium", atomicNumber: 11 }, { symbol: "Mg", name: "Magnesium", atomicNumber: 12 }, { symbol: "Al", name: "Aluminium", atomicNumber: 13 }, { symbol: "Si", name: "Silicon", atomicNumber: 14 }, { symbol: "P", name: "Phosphorus", atomicNumber: 15 }, { symbol: "S", name: "Sulfur", atomicNumber: 16 }, { symbol: "Cl", name: "Chlorine", atomicNumber: 17 }, { symbol: "Ar", name: "Argon", atomicNumber: 18 }, { symbol: "K", name: "Potassium", atomicNumber: 19 }, { symbol: "Ca", name: "Calcium", atomicNumber: 20 }, { symbol: "Sc", name: "Scandium", atomicNumber: 21 }, { symbol: "Ti", name: "Titanium", atomicNumber: 22 }, { symbol: "V", name: "Vanadium", atomicNumber: 23 }, { symbol: "Cr", name: "Chromium", atomicNumber: 24 }, { symbol: "Mn", name: "Manganese", atomicNumber: 25 }, { symbol: "Fe", name: "Iron", atomicNumber: 26 }, { symbol: "Co", name: "Cobalt", atomicNumber: 27 }, { symbol: "Ni", name: "Nickel", atomicNumber: 28 }, { symbol: "Cu", name: "Copper", atomicNumber: 29 }, { symbol: "Zn", name: "Zinc", atomicNumber: 30 }, { symbol: "Ga", name: "Gallium", atomicNumber: 31 }, { symbol: "Ge", name: "Germanium", atomicNumber: 32 }, { symbol: "As", name: "Arsenic", atomicNumber: 33 }, { symbol: "Se", name: "Selenium", atomicNumber: 34 }, { symbol: "Br", name: "Bromine", atomicNumber: 35 }, { symbol: "Kr", name: "Krypton", atomicNumber: 36 }, { symbol: "Rb", name: "Rubidium", atomicNumber: 37 }, { symbol: "Sr", name: "Strontium", atomicNumber: 38 }, { symbol: "Y", name: "Yttrium", atomicNumber: 39 }, { symbol: "Zr", name: "Zirconium", atomicNumber: 40 }, { symbol: "Nb", name: "Niobium", atomicNumber: 41 }, { symbol: "Mo", name: "Molybdenum", atomicNumber: 42 }, { symbol: "Tc", name: "Technetium", atomicNumber: 43 }, { symbol: "Ru", name: "Ruthenium", atomicNumber: 44 }, { symbol: "Rh", name: "Rhodium", atomicNumber: 45 }, { symbol: "Pd", name: "Palladium", atomicNumber: 46 }, { symbol: "Ag", name: "Silver", atomicNumber: 47 }, { symbol: "Cd", name: "Cadmium", atomicNumber: 48 }, { symbol: "In", name: "Indium", atomicNumber: 49 }, { symbol: "Sn", name: "Tin", atomicNumber: 50 }, { symbol: "Sb", name: "Antimony", atomicNumber: 51 }, { symbol: "Te", name: "Tellurium", atomicNumber: 52 }, { symbol: "I", name: "Iodine", atomicNumber: 53 }, { symbol: "Xe", name: "Xenon", atomicNumber: 54 }, { symbol: "Cs", name: "Caesium", atomicNumber: 55 }, { symbol: "Ba", name: "Barium", atomicNumber: 56 }, { symbol: "La", name: "Lanthanum", atomicNumber: 57 }, { symbol: "Ce", name: "Cerium", atomicNumber: 58 }, { symbol: "Pr", name: "Praseodymium", atomicNumber: 59 }, { symbol: "Nd", name: "Neodymium", atomicNumber: 60 }, { symbol: "Pm", name: "Promethium", atomicNumber: 61 }, { symbol: "Sm", name: "Samarium", atomicNumber: 62 }, { symbol: "Eu", name: "Europium", atomicNumber: 63 }, { symbol: "Gd", name: "Gadolinium", atomicNumber: 64 }, { symbol: "Tb", name: "Terbium", atomicNumber: 65 }, { symbol: "Dy", name: "Dysprosium", atomicNumber: 66 }, { symbol: "Ho", name: "Holmium", atomicNumber: 67 }, { symbol: "Er", name: "Erbium", atomicNumber: 68 }, { symbol: "Tm", name: "Thulium", atomicNumber: 69 }, { symbol: "Yb", name: "Ytterbium", atomicNumber: 70 }, { symbol: "Lu", name: "Lutetium", atomicNumber: 71 }, { symbol: "Hf", name: "Hafnium", atomicNumber: 72 }, { symbol: "Ta", name: "Tantalum", atomicNumber: 73 }, { symbol: "W", name: "Tungsten", atomicNumber: 74 }, { symbol: "Re", name: "Rhenium", atomicNumber: 75 }, { symbol: "Os", name: "Osmium", atomicNumber: 76 }, { symbol: "Ir", name: "Iridium", atomicNumber: 77 }, { symbol: "Pt", name: "Platinum", atomicNumber: 78 }, { symbol: "Au", name: "Gold", atomicNumber: 79 }, { symbol: "Hg", name: "Mercury", atomicNumber: 80 }, { symbol: "Tl", name: "Thallium", atomicNumber: 81 }, { symbol: "Pb", name: "Lead", atomicNumber: 82 }, { symbol: "Bi", name: "Bismuth", atomicNumber: 83 }, { symbol: "Po", name: "Polonium", atomicNumber: 84 }, { symbol: "At", name: "Astatine", atomicNumber: 85 }, { symbol: "Rn", name: "Radon", atomicNumber: 86 }, { symbol: "Fr", name: "Francium", atomicNumber: 87 }, { symbol: "Ra", name: "Radium", atomicNumber: 88 }, { symbol: "Ac", name: "Actinium", atomicNumber: 89 }, { symbol: "Th", name: "Thorium", atomicNumber: 90 }, { symbol: "Pa", name: "Protactinium", atomicNumber: 91 }, { symbol: "U", name: "Uranium", atomicNumber: 92 }, { symbol: "Np", name: "Neptunium", atomicNumber: 93 }, { symbol: "Pu", name: "Plutonium", atomicNumber: 94 }, { symbol: "Am", name: "Americium", atomicNumber: 95 }, { symbol: "Cm", name: "Curium", atomicNumber: 96 }, { symbol: "Bk", name: "Berkelium", atomicNumber: 97 }, { symbol: "Cf", name: "Californium", atomicNumber: 98 }, { symbol: "Es", name: "Einsteinium", atomicNumber: 99 }, { symbol: "Fm", name: "Fermium", atomicNumber: 100 }, { symbol: "Md", name: "Mendelevium", atomicNumber: 101 }, { symbol: "No", name: "Nobelium", atomicNumber: 102 }, { symbol: "Lr", name: "Lawrencium", atomicNumber: 103 }, { symbol: "Rf", name: "Rutherfordium", atomicNumber: 104 }, { symbol: "Db", name: "Dubnium", atomicNumber: 105 }, { symbol: "Sg", name: "Seaborgium", atomicNumber: 106 }, { symbol: "Bh", name: "Bohrium", atomicNumber: 107 }, { symbol: "Hs", name: "Hassium", atomicNumber: 108 }, { symbol: "Mt", name: "Meitnerium", atomicNumber: 109 }, { symbol: "Ds", name: "Darmstadtium", atomicNumber: 110 }, { symbol: "Rg", name: "Roentgenium", atomicNumber: 111 }, { symbol: "Cn", name: "Copernicium", atomicNumber: 112 }, { symbol: "Nh", name: "Nihonium", atomicNumber: 113 }, { symbol: "Fl", name: "Flerovium", atomicNumber: 114 }, { symbol: "Mc", name: "Moscovium", atomicNumber: 115 }, { symbol: "Lv", name: "Livermorium", atomicNumber: 116 }, { symbol: "Ts", name: "Tennessine", atomicNumber: 117 }, { symbol: "Og", name: "Oganesson", atomicNumber: 118 }], uxe = [{ name: "meter", symbol: "m" }, { name: "second", symbol: "s" }, { name: "mole", symbol: "mol" }, { name: "ampere", symbol: "A" }, { name: "kelvin", symbol: "K" }, { name: "candela", symbol: "cd" }, { name: "kilogram", symbol: "kg" }, { name: "radian", symbol: "rad" }, { name: "hertz", symbol: "Hz" }, { name: "newton", symbol: "N" }, { name: "pascal", symbol: "Pa" }, { name: "joule", symbol: "J" }, { name: "watt", symbol: "W" }, { name: "coulomb", symbol: "C" }, { name: "volt", symbol: "V" }, { name: "ohm", symbol: "Ω" }, { name: "tesla", symbol: "T" }, { name: "degree Celsius", symbol: "°C" }, { name: "lumen", symbol: "lm" }, { name: "becquerel", symbol: "Bq" }, { name: "gray", symbol: "Gy" }, { name: "sievert", symbol: "Sv" }, { name: "steradian", symbol: "sr" }, { name: "farad", symbol: "F" }, { name: "siemens", symbol: "S" }, { name: "weber", symbol: "Wb" }, { name: "henry", symbol: "H" }, { name: "lux", symbol: "lx" }, { name: "katal", symbol: "kat" }], lxe = { chemical_element: oxe, unit: uxe }, cxe = lxe, hxe = ["ants", "bats", "bears", "bees", "birds", "buffalo", "cats", "chickens", "cattle", "dogs", "dolphins", "ducks", "elephants", "fishes", "foxes", "frogs", "geese", "goats", "horses", "kangaroos", "lions", "monkeys", "owls", "oxen", "penguins", "people", "pigs", "rabbits", "sheep", "tigers", "whales", "wolves", "zebras", "banshees", "crows", "black cats", "chimeras", "ghosts", "conspirators", "dragons", "dwarves", "elves", "enchanters", "exorcists", "sons", "foes", "giants", "gnomes", "goblins", "gooses", "griffins", "lycanthropes", "nemesis", "ogres", "oracles", "prophets", "sorcerors", "spiders", "spirits", "vampires", "warlocks", "vixens", "werewolves", "witches", "worshipers", "zombies", "druids"], dxe = ["{{location.state}} {{team.creature}}"], fxe = { creature: hxe, name: dxe }, mxe = fxe, gxe = ["Adventure Road Bicycle", "BMX Bicycle", "City Bicycle", "Cruiser Bicycle", "Cyclocross Bicycle", "Dual-Sport Bicycle", "Fitness Bicycle", "Flat-Foot Comfort Bicycle", "Folding Bicycle", "Hybrid Bicycle", "Mountain Bicycle", "Recumbent Bicycle", "Road Bicycle", "Tandem Bicycle", "Touring Bicycle", "Track/Fixed-Gear Bicycle", "Triathlon/Time Trial Bicycle", "Tricycle"], pxe = ["Diesel", "Electric", "Gasoline", "Hybrid"], bxe = ["Aston Martin", "Audi", "BMW", "BYD", "Bentley", "Bugatti", "Cadillac", "Chevrolet", "Chrysler", "Citroën", "Dodge", "Ferrari", "Fiat", "Ford", "Honda", "Hyundai", "Jaguar", "Jeep", "Kia", "Lamborghini", "Land Rover", "MG", "Mahindra & Mahindra", "Maruti", "Maserati", "Mazda", "Mercedes Benz", "Mini", "Mitsubishi", "NIO", "Nissan", "Peugeot", "Polestar", "Porsche", "Renault", "Rivian", "Rolls Royce", "Skoda", "Smart", "Subaru", "Suzuki", "Tata", "Tesla", "Toyota", "Vauxhall", "Volkswagen", "Volvo"], yxe = ["1", "2", "911", "A4", "A8", "ATS", "Accord", "Alpine", "Altima", "Aventador", "Beetle", "CTS", "CX-9", "Camaro", "Camry", "Challenger", "Charger", "Civic", "Colorado", "Corvette", "Countach", "Cruze", "Durango", "El Camino", "Element", "Escalade", "Expedition", "Explorer", "F-150", "Fiesta", "Focus", "Fortwo", "Golf", "Grand Caravan", "Grand Cherokee", "Impala", "Jetta", "Land Cruiser", "LeBaron", "Malibu", "Model 3", "Model S", "Model T", "Model X", "Model Y", "Murcielago", "Mustang", "PT Cruiser", "Prius", "Ranchero", "Roadster", "Sentra", "Silverado", "Spyder", "Taurus", "V90", "Volt", "Wrangler", "XC90", "XTS"], Axe = ["Cargo Van", "Convertible", "Coupe", "Crew Cab Pickup", "Extended Cab Pickup", "Hatchback", "Minivan", "Passenger Van", "SUV", "Sedan", "Wagon"], Exe = { bicycle_type: gxe, fuel: pxe, manufacturer: bxe, model: yxe, type: Axe }, Sxe = Exe, wxe = ["abandoned", "able", "acceptable", "acclaimed", "accomplished", "accurate", "aching", "acidic", "actual", "admired", "adolescent", "advanced", "affectionate", "afraid", "aged", "aggravating", "aggressive", "agile", "agitated", "agreeable", "ajar", "alarmed", "alert", "alienated", "alive", "all", "altruistic", "amazing", "ambitious", "ample", "amused", "angelic", "anguished", "animated", "annual", "another", "antique", "any", "apprehensive", "appropriate", "apt", "arid", "artistic", "ashamed", "assured", "astonishing", "athletic", "austere", "authentic", "authorized", "avaricious", "average", "aware", "awesome", "awful", "babyish", "back", "bad", "baggy", "bare", "basic", "beloved", "beneficial", "best", "better", "big", "biodegradable", "bitter", "black", "black-and-white", "blank", "blaring", "bleak", "blind", "blond", "blue", "blushing", "bogus", "boiling", "bony", "boring", "bossy", "both", "bouncy", "bowed", "brave", "breakable", "bright", "brilliant", "brisk", "broken", "brown", "bruised", "bulky", "burdensome", "burly", "bustling", "busy", "buttery", "buzzing", "calculating", "candid", "carefree", "careless", "caring", "cautious", "cavernous", "celebrated", "charming", "cheap", "cheerful", "chilly", "chubby", "circular", "classic", "clean", "clear", "clear-cut", "close", "closed", "cloudy", "clueless", "clumsy", "cluttered", "coarse", "colorful", "colorless", "colossal", "comfortable", "common", "compassionate", "competent", "complete", "complicated", "concerned", "concrete", "confused", "considerate", "content", "cool", "cooperative", "coordinated", "corny", "corrupt", "courageous", "courteous", "crafty", "crazy", "creamy", "creative", "criminal", "critical", "crooked", "crowded", "cruel", "crushing", "cuddly", "cultivated", "cumbersome", "curly", "cute", "damaged", "damp", "dapper", "dark", "darling", "dazzling", "dead", "deadly", "deafening", "dearest", "decent", "decisive", "deep", "defenseless", "defensive", "deficient", "definite", "definitive", "delectable", "delicious", "delirious", "dense", "dental", "dependable", "dependent", "descriptive", "deserted", "determined", "devoted", "different", "difficult", "digital", "diligent", "dim", "direct", "dirty", "discrete", "disloyal", "dismal", "distant", "distinct", "distorted", "doting", "downright", "drab", "dramatic", "dreary", "dual", "dull", "dutiful", "each", "early", "earnest", "easy", "ecstatic", "edible", "educated", "elastic", "elderly", "electric", "elegant", "elementary", "elliptical", "eminent", "emotional", "empty", "enchanted", "enchanting", "energetic", "enlightened", "enraged", "entire", "equatorial", "essential", "esteemed", "ethical", "everlasting", "every", "evil", "exalted", "excellent", "excitable", "excited", "exhausted", "exotic", "expensive", "experienced", "expert", "extra-large", "extroverted", "failing", "faint", "fair", "fake", "familiar", "fantastic", "far", "far-flung", "far-off", "faraway", "fat", "fatal", "fatherly", "favorable", "favorite", "fearless", "feline", "filthy", "fine", "finished", "firm", "first", "firsthand", "fixed", "flashy", "flawed", "flawless", "flickering", "flimsy", "flowery", "fluffy", "flustered", "focused", "fond", "foolhardy", "foolish", "forceful", "formal", "forsaken", "fortunate", "fragrant", "frail", "frank", "free", "french", "frequent", "friendly", "frightened", "frilly", "frivolous", "frizzy", "front", "frozen", "frugal", "fruitful", "functional", "funny", "fussy", "fuzzy", "gaseous", "general", "gentle", "genuine", "gifted", "gigantic", "giving", "glaring", "glass", "gleaming", "glittering", "gloomy", "glorious", "glossy", "glum", "golden", "good", "good-natured", "gorgeous", "graceful", "gracious", "grandiose", "granular", "grave", "gray", "great", "greedy", "grim", "grimy", "gripping", "grizzled", "grouchy", "grounded", "growing", "grown", "grubby", "gruesome", "grumpy", "guilty", "gullible", "gummy", "hairy", "handsome", "handy", "happy", "happy-go-lucky", "hard-to-find", "harmful", "hasty", "hateful", "haunting", "heartfelt", "heavenly", "heavy", "hefty", "helpful", "helpless", "hidden", "hoarse", "hollow", "homely", "honorable", "honored", "hopeful", "hospitable", "hot", "huge", "humble", "humiliating", "hungry", "hurtful", "husky", "icy", "ideal", "idealistic", "idolized", "ignorant", "ill", "ill-fated", "illiterate", "illustrious", "imaginary", "imaginative", "immaculate", "immediate", "immense", "impartial", "impassioned", "impeccable", "impish", "impolite", "important", "impossible", "impractical", "impressionable", "impressive", "improbable", "impure", "inborn", "incomparable", "incomplete", "inconsequential", "indelible", "indolent", "inexperienced", "infamous", "infatuated", "inferior", "infinite", "informal", "innocent", "insecure", "insidious", "insignificant", "insistent", "instructive", "intelligent", "intent", "interesting", "internal", "international", "intrepid", "ironclad", "irresponsible", "jagged", "jam-packed", "jaunty", "jealous", "jittery", "joyful", "joyous", "jubilant", "judicious", "juicy", "jumbo", "junior", "juvenile", "kaleidoscopic", "key", "knotty", "knowledgeable", "known", "kooky", "kosher", "lanky", "last", "lasting", "late", "lavish", "lawful", "lazy", "leading", "lean", "left", "legal", "light", "lighthearted", "likable", "likely", "limited", "limp", "limping", "linear", "lined", "liquid", "little", "live", "lively", "livid", "lone", "lonely", "long", "long-term", "lost", "lovable", "lovely", "low", "lucky", "lumbering", "lumpy", "lustrous", "mad", "made-up", "magnificent", "majestic", "major", "male", "mammoth", "married", "marvelous", "massive", "mature", "meager", "mealy", "mean", "measly", "meaty", "mediocre", "medium", "memorable", "menacing", "merry", "messy", "metallic", "mild", "milky", "mindless", "minor", "minty", "miserable", "miserly", "misguided", "mixed", "moist", "monstrous", "monthly", "monumental", "moral", "motionless", "muddy", "muffled", "multicolored", "mundane", "murky", "mushy", "musty", "muted", "mysterious", "narrow", "natural", "naughty", "nautical", "near", "neat", "necessary", "needy", "negative", "neglected", "negligible", "neighboring", "nervous", "new", "next", "nice", "nifty", "nimble", "nippy", "nocturnal", "normal", "noted", "noteworthy", "noxious", "numb", "nutritious", "obedient", "oblong", "obvious", "odd", "oddball", "official", "oily", "old", "old-fashioned", "only", "optimal", "optimistic", "orange", "orderly", "ordinary", "ornate", "ornery", "other", "our", "outgoing", "outlandish", "outlying", "outrageous", "outstanding", "oval", "overcooked", "overdue", "palatable", "pale", "paltry", "parallel", "parched", "partial", "passionate", "pastel", "peaceful", "peppery", "perfumed", "perky", "personal", "pertinent", "pessimistic", "petty", "phony", "physical", "pink", "pitiful", "plain", "pleasant", "pleased", "pleasing", "plump", "pointed", "pointless", "polished", "polite", "political", "poor", "portly", "posh", "possible", "potable", "powerful", "powerless", "practical", "precious", "present", "prestigious", "pretty", "pricey", "prickly", "primary", "prime", "private", "probable", "productive", "profitable", "profuse", "proper", "proud", "prudent", "punctual", "puny", "pure", "purple", "pushy", "putrid", "puzzled", "qualified", "quarrelsome", "quarterly", "queasy", "querulous", "questionable", "quick", "quick-witted", "quiet", "quintessential", "quixotic", "radiant", "ragged", "rapid", "rare", "raw", "realistic", "reasonable", "recent", "reckless", "rectangular", "red", "reflecting", "regal", "regular", "remarkable", "remorseful", "repentant", "respectful", "responsible", "rewarding", "rich", "right", "rigid", "ripe", "roasted", "robust", "rosy", "rotating", "rotten", "rough", "round", "rowdy", "royal", "rubbery", "ruddy", "rundown", "runny", "rural", "rusty", "sad", "salty", "same", "sandy", "sarcastic", "sardonic", "scaly", "scared", "scary", "scented", "scientific", "scornful", "scratchy", "second", "second-hand", "secondary", "secret", "self-assured", "self-reliant", "selfish", "sentimental", "separate", "serene", "serpentine", "severe", "shabby", "shadowy", "shady", "shallow", "shameful", "shameless", "shimmering", "shiny", "shocked", "shoddy", "short", "short-term", "showy", "shrill", "shy", "sick", "silent", "silky", "silver", "similar", "simple", "simplistic", "sinful", "sizzling", "skeletal", "sleepy", "slight", "slimy", "slow", "slushy", "small", "smart", "smoggy", "smooth", "smug", "snappy", "snarling", "sneaky", "sniveling", "snoopy", "sociable", "soft", "soggy", "somber", "some", "sophisticated", "sore", "sorrowful", "soulful", "soupy", "sour", "spanish", "sparkling", "sparse", "specific", "speedy", "spherical", "spiffy", "spirited", "spiteful", "splendid", "spotless", "square", "squeaky", "squiggly", "stable", "staid", "stained", "stale", "standard", "stark", "steel", "steep", "sticky", "stiff", "stingy", "stormy", "straight", "strange", "strict", "strident", "striking", "strong", "stunning", "stupendous", "sturdy", "stylish", "subdued", "submissive", "substantial", "subtle", "suburban", "sudden", "sugary", "sunny", "super", "superb", "superficial", "superior", "supportive", "sure-footed", "surprised", "svelte", "sweet", "swift", "talkative", "tall", "tame", "tangible", "tasty", "tattered", "taut", "tedious", "teeming", "tempting", "tender", "tense", "tepid", "terrible", "that", "these", "thick", "thin", "thorny", "thorough", "those", "thrifty", "tidy", "tight", "timely", "tinted", "tiny", "tired", "torn", "total", "tough", "tragic", "trained", "triangular", "tricky", "trim", "trivial", "troubled", "true", "trusting", "trustworthy", "trusty", "turbulent", "twin", "ugly", "ultimate", "unaware", "uncomfortable", "uncommon", "unconscious", "understated", "uneven", "unfinished", "unfit", "unfortunate", "unhappy", "unhealthy", "uniform", "unimportant", "unique", "unkempt", "unknown", "unlawful", "unlined", "unlucky", "unpleasant", "unrealistic", "unripe", "unruly", "unselfish", "unsightly", "unsteady", "unsung", "untidy", "untimely", "untried", "untrue", "unused", "unusual", "unwelcome", "unwieldy", "unwilling", "unwritten", "upbeat", "upright", "upset", "urban", "usable", "useless", "utilized", "utter", "vague", "vain", "valuable", "variable", "vast", "velvety", "vengeful", "vibrant", "victorious", "violent", "vivacious", "vivid", "voluminous", "warlike", "warm", "warmhearted", "warped", "wasteful", "waterlogged", "watery", "wavy", "wealthy", "weary", "webbed", "wee", "weekly", "weighty", "weird", "well-documented", "well-groomed", "well-lit", "well-made", "well-off", "well-to-do", "well-worn", "which", "whimsical", "whirlwind", "whispered", "white", "whole", "whopping", "wicked", "wide", "wide-eyed", "wiggly", "willing", "wilted", "winding", "windy", "winged", "wise", "witty", "wobbly", "woeful", "wonderful", "wordy", "worldly", "worse", "worst", "worthless", "worthwhile", "worthy", "wrathful", "wretched", "writhing", "wrong", "wry", "yearly", "yellow", "yellowish", "young", "youthful", "yummy", "zany", "zealous", "zesty"], Fxe = ["abnormally", "absentmindedly", "accidentally", "acidly", "actually", "adventurously", "afterwards", "almost", "always", "angrily", "annually", "anxiously", "arrogantly", "awkwardly", "badly", "bashfully", "beautifully", "bitterly", "bleakly", "blindly", "blissfully", "boastfully", "boldly", "bravely", "briefly", "brightly", "briskly", "broadly", "busily", "calmly", "carefully", "carelessly", "cautiously", "certainly", "cheerfully", "clearly", "cleverly", "closely", "coaxingly", "colorfully", "commonly", "continually", "coolly", "correctly", "courageously", "crossly", "cruelly", "curiously", "daily", "daintily", "dearly", "deceivingly", "deeply", "defiantly", "deliberately", "delightfully", "diligently", "dimly", "doubtfully", "dreamily", "easily", "elegantly", "energetically", "enormously", "enthusiastically", "equally", "especially", "even", "evenly", "eventually", "exactly", "excitedly", "extremely", "fairly", "faithfully", "famously", "far", "fast", "fatally", "ferociously", "fervently", "fiercely", "fondly", "foolishly", "fortunately", "frankly", "frantically", "freely", "frenetically", "frightfully", "fully", "furiously", "generally", "generously", "gently", "gladly", "gleefully", "gracefully", "gratefully", "greatly", "greedily", "happily", "hastily", "healthily", "heavily", "helpfully", "helplessly", "highly", "honestly", "hopelessly", "hourly", "hungrily", "immediately", "innocently", "inquisitively", "instantly", "intensely", "intently", "interestingly", "inwardly", "irritably", "jaggedly", "jealously", "joshingly", "jovially", "joyfully", "joyously", "jubilantly", "judgementally", "justly", "keenly", "kiddingly", "kindheartedly", "kindly", "kissingly", "knavishly", "knottily", "knowingly", "knowledgeably", "kookily", "lazily", "less", "lightly", "likely", "limply", "lively", "loftily", "longingly", "loosely", "loudly", "lovingly", "loyally", "madly", "majestically", "meaningfully", "mechanically", "merrily", "miserably", "mockingly", "monthly", "more", "mortally", "mostly", "mysteriously", "naturally", "nearly", "neatly", "needily", "nervously", "never", "nicely", "noisily", "not", "obediently", "obnoxiously", "oddly", "offensively", "officially", "often", "only", "openly", "optimistically", "overconfidently", "owlishly", "painfully", "partially", "patiently", "perfectly", "physically", "playfully", "politely", "poorly", "positively", "potentially", "powerfully", "promptly", "properly", "punctually", "quaintly", "quarrelsomely", "queasily", "questionably", "questioningly", "quicker", "quickly", "quietly", "quirkily", "quizzically", "rapidly", "rarely", "readily", "really", "reassuringly", "recklessly", "regularly", "reluctantly", "repeatedly", "reproachfully", "restfully", "righteously", "rightfully", "rigidly", "roughly", "rudely", "sadly", "safely", "scarcely", "scarily", "searchingly", "sedately", "seemingly", "seldom", "selfishly", "separately", "seriously", "shakily", "sharply", "sheepishly", "shrilly", "shyly", "silently", "sleepily", "slowly", "smoothly", "softly", "solemnly", "solidly", "sometimes", "soon", "speedily", "stealthily", "sternly", "strictly", "successfully", "suddenly", "surprisingly", "suspiciously", "sweetly", "swiftly", "sympathetically", "tenderly", "tensely", "terribly", "thankfully", "thoroughly", "thoughtfully", "tightly", "tomorrow", "too", "tremendously", "triumphantly", "truly", "truthfully", "ultimately", "unabashedly", "unaccountably", "unbearably", "unethically", "unexpectedly", "unfortunately", "unimpressively", "unnaturally", "unnecessarily", "upbeat", "upliftingly", "upright", "upside-down", "upward", "upwardly", "urgently", "usefully", "uselessly", "usually", "utterly", "vacantly", "vaguely", "vainly", "valiantly", "vastly", "verbally", "very", "viciously", "victoriously", "violently", "vivaciously", "voluntarily", "warmly", "weakly", "wearily", "well", "wetly", "wholly", "wildly", "willfully", "wisely", "woefully", "wonderfully", "worriedly", "wrongly", "yawningly", "yearly", "yearningly", "yesterday", "yieldingly", "youthfully"], Txe = ["after", "although", "and", "as", "because", "before", "but", "consequently", "even", "finally", "for", "furthermore", "hence", "how", "however", "if", "inasmuch", "incidentally", "indeed", "instead", "lest", "likewise", "meanwhile", "nor", "now", "once", "or", "provided", "since", "so", "supposing", "than", "that", "though", "till", "unless", "until", "what", "when", "whenever", "where", "whereas", "wherever", "whether", "which", "while", "who", "whoever", "whose", "why", "yet"], vxe = ["yuck", "oh", "phooey", "blah", "boo", "whoa", "yowza", "huzzah", "boohoo", "fooey", "geez", "pfft", "ew", "ah", "yum", "brr", "hm", "yahoo", "aha", "woot", "drat", "gah", "meh", "psst", "aw", "ugh", "yippee", "eek", "gee", "bah", "gadzooks", "duh", "ha", "mmm", "ouch", "phew", "ack", "uh-huh", "gosh", "hmph", "pish", "zowie", "er", "ick", "oof", "um"], xxe = ["CD", "SUV", "abacus", "academics", "accelerator", "accompanist", "account", "accountability", "acquaintance", "ad", "adaptation", "address", "adrenalin", "adult", "advancement", "advertisement", "adviser", "affect", "affiliate", "aftermath", "agreement", "airbus", "aircraft", "airline", "airmail", "airman", "airport", "alb", "alert", "allegation", "alliance", "alligator", "allocation", "almighty", "amendment", "amnesty", "analogy", "angle", "annual", "antelope", "anticodon", "apparatus", "appliance", "approach", "apricot", "arcade", "archaeology", "armchair", "armoire", "asset", "assist", "atrium", "attraction", "availability", "avalanche", "awareness", "babushka", "backbone", "backburn", "bakeware", "bandwidth", "bar", "barge", "baritone", "barracks", "baseboard", "basket", "bathhouse", "bathrobe", "battle", "begonia", "behest", "bell", "bench", "bend", "beret", "best-seller", "bid", "bidet", "bin", "birdbath", "birdcage", "birth", "blight", "blossom", "blowgun", "bob", "bog", "bonfire", "bonnet", "bookcase", "bookend", "boulevard", "bourgeoisie", "bowler", "bowling", "boyfriend", "brace", "bracelet", "bran", "breastplate", "brief", "brochure", "brook", "brush", "bug", "bump", "bungalow", "cafe", "cake", "calculus", "cannon", "cantaloupe", "cap", "cappelletti", "captain", "caption", "carboxyl", "cardboard", "carnival", "case", "casement", "cash", "casket", "cassava", "castanet", "catalyst", "cauliflower", "cellar", "celsius", "cemetery", "ceramic", "ceramics", "certification", "chainstay", "chairperson", "challenge", "championship", "chap", "chapel", "character", "characterization", "charlatan", "charm", "chasuble", "cheese", "cheetah", "chiffonier", "chops", "chow", "cinder", "cinema", "circumference", "citizen", "clamp", "clavicle", "cleaner", "climb", "co-producer", "coal", "coast", "cod", "coil", "coin", "coliseum", "collaboration", "collectivization", "colon", "colonialism", "comestible", "commercial", "commodity", "community", "comparison", "completion", "complication", "compromise", "concentration", "configuration", "confusion", "conservation", "conservative", "consistency", "contractor", "contrail", "convection", "conversation", "cook", "coordination", "cop-out", "cope", "cork", "cornet", "corporation", "corral", "cosset", "costume", "couch", "council", "councilman", "countess", "courtroom", "cow", "creator", "creature", "crest", "cricket", "crocodile", "cross-contamination", "cruelty", "cuckoo", "curl", "custody", "custom", "cutlet", "cutover", "cycle", "daddy", "dandelion", "dash", "daughter", "dead", "decision", "deck", "declaration", "decongestant", "decryption", "deduction", "deed", "deer", "defendant", "density", "department", "dependency", "deployment", "depot", "derby", "descendant", "descent", "design", "designation", "desk", "detective", "devastation", "developing", "developmental", "devil", "diagram", "digestive", "digit", "dime", "director", "disadvantage", "disappointment", "disclosure", "disconnection", "discourse", "dish", "disk", "disposer", "distinction", "diver", "diversity", "dividend", "divine", "doing", "doorpost", "doubter", "draft", "draw", "dream", "dredger", "dress", "drive", "drug", "duffel", "dulcimer", "dusk", "duster", "dwell", "e-mail", "earth", "ecliptic", "ectoderm", "edge", "editor", "effector", "eggplant", "electronics", "elevation", "elevator", "elver", "embarrassment", "embossing", "emergent", "encouragement", "entry", "epic", "equal", "essence", "eternity", "ethyl", "euphonium", "event", "exasperation", "excess", "executor", "exhaust", "expansion", "expense", "experience", "exploration", "extension", "extent", "exterior", "eyebrow", "eyeliner", "farm", "farmer", "fat", "fax", "feather", "fedora", "fellow", "fen", "fencing", "ferret", "festival", "fibre", "filter", "final", "finding", "finer", "finger", "fireplace", "fisherman", "fishery", "fit", "flame", "flat", "fledgling", "flight", "flint", "flood", "flu", "fog", "fold", "folklore", "follower", "following", "foodstuffs", "footrest", "forage", "forager", "forgery", "fork", "formamide", "formation", "formula", "fort", "fowl", "fraudster", "freckle", "freezing", "freight", "fuel", "fun", "fund", "fundraising", "futon", "gallery", "galoshes", "gastropod", "gazebo", "gerbil", "ghost", "giant", "gift", "giggle", "glider", "gloom", "goat", "godfather", "godparent", "going", "goodwill", "governance", "government", "gown", "gradient", "graffiti", "grandpa", "grandson", "granny", "grass", "gray", "gripper", "grouper", "guacamole", "guard", "guidance", "guide", "gym", "gymnast", "habit", "haircut", "halt", "hamburger", "hammock", "handful", "handle", "handover", "harp", "haversack", "hawk", "heartache", "heartbeat", "heating", "hello", "help", "hepatitis", "heroine", "hexagon", "hierarchy", "hippodrome", "honesty", "hoof", "hope", "horde", "hornet", "horst", "hose", "hospitalization", "hovel", "hovercraft", "hubris", "humidity", "humor", "hundred", "hunger", "hunt", "husband", "hutch", "hydrant", "hydrocarbon", "hydrolyse", "hydrolyze", "hyena", "hygienic", "hyphenation", "ice-cream", "icebreaker", "igloo", "ignorance", "illusion", "impact", "import", "importance", "impostor", "in-joke", "incandescence", "independence", "individual", "information", "injunction", "innovation", "insolence", "inspection", "instance", "institute", "instruction", "instructor", "integer", "intellect", "intent", "interchange", "interior", "intervention", "interviewer", "invite", "iridescence", "issue", "jacket", "jazz", "jellyfish", "jet", "jogging", "joy", "juggernaut", "jump", "jungle", "junior", "jury", "kettledrum", "kick", "kielbasa", "kinase", "king", "kiss", "kit", "knickers", "knight", "knitting", "knuckle", "label", "labourer", "lace", "lady", "lamp", "language", "larva", "lashes", "laughter", "lava", "lawmaker", "lay", "leading", "league", "legend", "legging", "legislature", "lender", "license", "lid", "lieu", "lifestyle", "lift", "linseed", "litter", "loaf", "lobster", "longboat", "lotion", "lounge", "louse", "lox", "loyalty", "luck", "lyre", "maestro", "mainstream", "maintainer", "majority", "makeover", "making", "mallard", "management", "manner", "mantua", "marathon", "march", "marimba", "marketplace", "marksman", "markup", "marten", "massage", "masterpiece", "mathematics", "meadow", "meal", "meander", "meatloaf", "mechanic", "median", "membership", "mentor", "merit", "metabolite", "metal", "middle", "midwife", "milestone", "millet", "minion", "minister", "minor", "minority", "mixture", "mobility", "molasses", "mom", "moment", "monasticism", "monocle", "monster", "morbidity", "morning", "mortise", "mountain", "mouser", "mousse", "mozzarella", "muscat", "mythology", "napkin", "necklace", "nectarine", "negotiation", "nephew", "nerve", "netsuke", "newsletter", "newsprint", "newsstand", "nightlife", "noon", "nougat", "nucleotidase", "nudge", "numeracy", "numeric", "nun", "obedience", "obesity", "object", "obligation", "ocelot", "octave", "offset", "oil", "omelet", "onset", "opera", "operating", "optimal", "orchid", "order", "ostrich", "other", "outlaw", "outrun", "outset", "overcoat", "overheard", "overload", "ownership", "pacemaker", "packaging", "paintwork", "palate", "pants", "pantyhose", "papa", "parade", "parsnip", "partridge", "passport", "pasta", "patroller", "pear", "pearl", "pecan", "pendant", "peninsula", "pension", "peony", "pepper", "perfection", "permafrost", "perp", "petal", "petticoat", "pharmacopoeia", "phrase", "pick", "piglet", "pigpen", "pigsty", "pile", "pillbox", "pillow", "pilot", "pine", "pinstripe", "place", "plain", "planula", "plastic", "platter", "platypus", "pleasure", "pliers", "plugin", "plumber", "pneumonia", "pocket-watch", "poetry", "polarisation", "polyester", "pomelo", "pop", "poppy", "popularity", "populist", "porter", "possession", "postbox", "precedent", "premeditation", "premier", "premise", "premium", "pressure", "presume", "priesthood", "printer", "privilege", "procurement", "produce", "programme", "prohibition", "promise", "pronoun", "providence", "provider", "provision", "publication", "publicity", "pulse", "punctuation", "pupil", "puppet", "puritan", "quart", "quinoa", "quit", "railway", "range", "rationale", "ravioli", "rawhide", "reach", "reasoning", "reboot", "receptor", "recommendation", "reconsideration", "recovery", "redesign", "relative", "release", "remark", "reorganisation", "repeat", "replacement", "reporter", "representation", "republican", "request", "requirement", "reservation", "resolve", "resource", "responsibility", "restaurant", "retention", "retrospectivity", "reward", "ribbon", "rim", "riser", "roadway", "role", "rosemary", "roundabout", "rubric", "ruin", "rule", "runway", "rust", "safe", "sailor", "saloon", "sand", "sandbar", "sanity", "sarong", "sauerkraut", "saw", "scaffold", "scale", "scarification", "scenario", "schedule", "schnitzel", "scholarship", "scorn", "scorpion", "scout", "scrap", "scratch", "seafood", "seagull", "seal", "season", "secrecy", "secret", "section", "sediment", "self-confidence", "sermon", "sesame", "settler", "shadowbox", "shark", "shipper", "shore", "shoulder", "sideboard", "siege", "sightseeing", "signature", "silk", "simple", "singing", "skean", "skeleton", "skyline", "skyscraper", "slide", "slime", "slipper", "smog", "smoke", "sock", "soliloquy", "solution", "solvency", "someplace", "sonar", "sonata", "sonnet", "soup", "soybean", "space", "spear", "spirit", "spork", "sport", "spring", "sprinkles", "squid", "stall", "starboard", "statue", "status", "stay", "steak", "steeple", "step", "step-mother", "sticker", "stir-fry", "stitcher", "stock", "stool", "story", "strait", "stranger", "strategy", "straw", "stump", "subexpression", "submitter", "subsidy", "substitution", "suitcase", "summary", "summer", "sunbeam", "sundae", "supplier", "surface", "sushi", "suspension", "sustenance", "swanling", "swath", "sweatshop", "swim", "swine", "swing", "switch", "switchboard", "swordfish", "synergy", "t-shirt", "tabletop", "tackle", "tail", "tapioca", "taro", "tarragon", "taxicab", "teammate", "technician", "technologist", "tectonics", "tenant", "tenement", "tennis", "tentacle", "teriyaki", "term", "testimonial", "testing", "thigh", "thongs", "thorn", "thread", "thunderbolt", "thyme", "tinderbox", "toaster", "tomatillo", "tomb", "tomography", "tool", "tooth", "toothbrush", "toothpick", "topsail", "traditionalism", "traffic", "translation", "transom", "transparency", "trash", "travel", "tray", "trench", "tribe", "tributary", "trick", "trolley", "tuba", "tuber", "tune-up", "turret", "tusk", "tuxedo", "typeface", "typewriter", "unblinking", "underneath", "underpants", "understanding", "unibody", "unique", "unit", "utilization", "valentine", "validity", "valley", "valuable", "vanadyl", "vein", "velocity", "venom", "version", "verve", "vestment", "veto", "viability", "vibraphone", "vibration", "vicinity", "video", "violin", "vision", "vista", "vol", "volleyball", "wafer", "waist", "wallaby", "warming", "wasabi", "waterspout", "wear", "wedding", "whack", "whale", "wheel", "widow", "wilderness", "willow", "window", "wombat", "word", "worth", "wriggler", "yak", "yarmulke", "yeast", "yin", "yogurt", "zebra", "zen"], Cxe = ["a", "abaft", "aboard", "about", "above", "absent", "across", "afore", "after", "against", "along", "alongside", "amid", "amidst", "among", "amongst", "an", "anenst", "anti", "apropos", "apud", "around", "as", "aside", "astride", "at", "athwart", "atop", "barring", "before", "behind", "below", "beneath", "beside", "besides", "between", "beyond", "but", "by", "circa", "concerning", "considering", "despite", "down", "during", "except", "excepting", "excluding", "failing", "following", "for", "forenenst", "from", "given", "in", "including", "inside", "into", "lest", "like", "mid", "midst", "minus", "modulo", "near", "next", "notwithstanding", "of", "off", "on", "onto", "opposite", "out", "outside", "over", "pace", "past", "per", "plus", "pro", "qua", "regarding", "round", "sans", "save", "since", "than", "the", "through", "throughout", "till", "times", "to", "toward", "towards", "under", "underneath", "unlike", "until", "unto", "up", "upon", "versus", "via", "vice", "with", "within", "without", "worth"], kxe = ["abnegate", "abscond", "abseil", "absolve", "accentuate", "accept", "access", "accessorise", "accompany", "account", "accredit", "achieve", "acknowledge", "acquire", "adjourn", "adjudge", "admonish", "adumbrate", "advocate", "afford", "airbrush", "ameliorate", "amend", "amount", "anaesthetise", "analyse", "anesthetize", "anneal", "annex", "antagonize", "ape", "apologise", "apostrophize", "appertain", "appreciate", "appropriate", "approximate", "arbitrate", "archive", "arraign", "arrange", "ascertain", "ascribe", "assail", "atomize", "attend", "attest", "attribute", "augment", "avow", "axe", "baa", "banish", "bank", "baptise", "battle", "beard", "beep", "behold", "belabor", "bemuse", "besmirch", "bestride", "better", "bewail", "bicycle", "bide", "bind", "biodegrade", "blacken", "blaspheme", "bleach", "blend", "blink", "bliss", "bloom", "bludgeon", "bobble", "boggle", "bolster", "book", "boom", "bootleg", "border", "bore", "boss", "braid", "brand", "brandish", "break", "breed", "broadcast", "broadside", "brood", "browse", "buck", "burgeon", "bus", "butter", "buzzing", "camouflage", "cannibalise", "canter", "cap", "capitalise", "capitalize", "capsize", "card", "carouse", "carp", "carpool", "catalog", "catalyze", "catch", "categorise", "cease", "celebrate", "censor", "certify", "char", "charter", "chase", "chatter", "chime", "chip", "christen", "chromakey", "chunder", "chunter", "cinch", "circle", "circulate", "circumnavigate", "clamor", "clamour", "claw", "cleave", "clinch", "clinking", "clone", "clonk", "coagulate", "coexist", "coincide", "collaborate", "colligate", "colorize", "colour", "comb", "come", "commandeer", "commemorate", "communicate", "compete", "conceal", "conceptualize", "conclude", "concrete", "condense", "cone", "confide", "confirm", "confiscate", "confound", "confute", "congregate", "conjecture", "connect", "consign", "construe", "contradict", "contrast", "contravene", "controvert", "convalesce", "converse", "convince", "convoke", "coop", "cop", "corner", "covenant", "cow", "crackle", "cram", "crank", "creak", "creaking", "cripple", "croon", "cross", "crumble", "crystallize", "culminate", "culture", "curry", "curse", "customise", "cycle", "dally", "dampen", "darn", "debit", "debut", "decide", "decode", "decouple", "decriminalize", "deduce", "deduct", "deflate", "deflect", "deform", "defrag", "degenerate", "degrease", "delete", "delight", "deliquesce", "demob", "demobilise", "democratize", "demonstrate", "denitrify", "deny", "depart", "depend", "deplore", "deploy", "deprave", "depute", "dereference", "describe", "desecrate", "deselect", "destock", "detain", "develop", "devise", "dial", "dicker", "digitize", "dilate", "disapprove", "disarm", "disbar", "discontinue", "disgorge", "dishearten", "dishonor", "disinherit", "dislocate", "dispense", "display", "dispose", "disrespect", "dissemble", "ditch", "divert", "dock", "doodle", "downchange", "downshift", "dowse", "draft", "drag", "drain", "dramatize", "drowse", "drum", "dwell", "economise", "edge", "efface", "egg", "eke", "electrify", "embalm", "embed", "embody", "emboss", "emerge", "emphasise", "emphasize", "emulsify", "encode", "endow", "enfold", "engage", "engender", "enhance", "enlist", "enrage", "enrich", "enroll", "entice", "entomb", "entrench", "entwine", "equate", "essay", "etch", "eulogise", "even", "evince", "exacerbate", "exaggerate", "exalt", "exempt", "exonerate", "expatiate", "explode", "expostulate", "extract", "extricate", "eyeglasses", "fabricate", "facilitate", "factorise", "factorize", "fail", "fall", "familiarize", "fashion", "father", "fathom", "fax", "federate", "feminize", "fence", "fess", "fictionalize", "fiddle", "fidget", "fill", "flash", "fleck", "flight", "floodlight", "floss", "fluctuate", "fluff", "fly", "focalise", "foot", "forearm", "forecast", "foretell", "forgather", "forgo", "fork", "form", "forswear", "founder", "fraternise", "fray", "frizz", "fumigate", "function", "furlough", "fuss", "gad", "gallivant", "galvanize", "gape", "garage", "garrote", "gasp", "gestate", "give", "glimmer", "glisten", "gloat", "gloss", "glow", "gnash", "gnaw", "goose", "govern", "grade", "graduate", "graft", "grok", "guest", "guilt", "gulp", "gum", "gurn", "gust", "gut", "guzzle", "ham", "harangue", "harvest", "hassle", "haul", "haze", "headline", "hearten", "heighten", "highlight", "hoick", "hold", "hole", "hollow", "holster", "home", "homeschool", "hoot", "horn", "horse", "hotfoot", "house", "hover", "howl", "huddle", "huff", "hunger", "hunt", "husk", "hype", "hypothesise", "hypothesize", "idle", "ignite", "imagineer", "impact", "impanel", "implode", "incinerate", "incline", "inculcate", "industrialize", "ingratiate", "inhibit", "inject", "innovate", "inscribe", "insert", "insist", "inspect", "institute", "institutionalize", "intend", "intermarry", "intermesh", "intermix", "internalise", "internalize", "internationalize", "intrigue", "inure", "inveigle", "inventory", "investigate", "irk", "iterate", "jaywalk", "jell", "jeopardise", "jiggle", "jive", "joint", "jot", "jut", "keel", "knife", "knit", "know", "kowtow", "lack", "lampoon", "large", "leap", "lecture", "legitimize", "lend", "libel", "liberalize", "license", "ligate", "list", "lobotomise", "lock", "log", "loose", "low", "lowball", "machine", "magnetize", "major", "make", "malfunction", "manage", "manipulate", "maroon", "masculinize", "mash", "mask", "masquerade", "massage", "masticate", "materialise", "matter", "maul", "memorise", "merge", "mesh", "metabolise", "microblog", "microchip", "micromanage", "militate", "mill", "minister", "minor", "misappropriate", "miscalculate", "misfire", "misjudge", "miskey", "mismatch", "mispronounce", "misread", "misreport", "misspend", "mob", "mobilise", "mobilize", "moisten", "mooch", "moor", "moralise", "mortar", "mosh", "mothball", "motivate", "motor", "mould", "mount", "muddy", "mummify", "mutate", "mystify", "nab", "narrate", "narrowcast", "nasalise", "nauseate", "navigate", "neaten", "neck", "neglect", "norm", "notarize", "object", "obscure", "observe", "obsess", "obstruct", "obtrude", "offend", "offset", "option", "orchestrate", "orient", "orientate", "outbid", "outdo", "outfit", "outflank", "outfox", "outnumber", "outrank", "outrun", "outsource", "overburden", "overcharge", "overcook", "overdub", "overfeed", "overload", "overplay", "overproduce", "overreact", "override", "overspend", "overstay", "overtrain", "overvalue", "overwork", "own", "oxidise", "oxidize", "oxygenate", "pace", "pack", "pale", "pant", "paralyse", "parody", "part", "pause", "pave", "penalise", "persecute", "personalise", "perspire", "pertain", "peter", "pike", "pillory", "pinion", "pip", "pity", "pivot", "pixellate", "plagiarise", "plait", "plan", "please", "pluck", "ponder", "popularize", "portray", "prance", "preclude", "preheat", "prejudge", "preregister", "presell", "preside", "pretend", "print", "prioritize", "probate", "probe", "proceed", "procrastinate", "profane", "progress", "proliferate", "proofread", "propound", "proselytise", "provision", "pry", "publicize", "puff", "pull", "pulp", "pulverize", "purse", "put", "putrefy", "quadruple", "quaff", "quantify", "quarrel", "quash", "quaver", "question", "quiet", "quintuple", "quip", "quit", "rag", "rally", "ramp", "randomize", "rationalise", "rationalize", "ravage", "ravel", "react", "readies", "readjust", "readmit", "ready", "reapply", "rear", "reassemble", "rebel", "reboot", "reborn", "rebound", "rebuff", "rebuild", "rebuke", "recede", "reckon", "reclassify", "recompense", "reconstitute", "record", "recount", "redact", "redevelop", "redound", "redraw", "redress", "reel", "refer", "reference", "refine", "reflate", "refute", "regulate", "reiterate", "rejigger", "rejoin", "rekindle", "relaunch", "relieve", "remand", "remark", "reopen", "reorient", "replicate", "repossess", "represent", "reprimand", "reproach", "reprove", "repurpose", "requite", "reschedule", "resort", "respray", "restructure", "retool", "retract", "revere", "revitalise", "revoke", "reword", "rewrite", "ride", "ridge", "rim", "ring", "rise", "rival", "roger", "rosin", "rot", "rout", "row", "rue", "rule", "safeguard", "sashay", "sate", "satirise", "satirize", "satisfy", "saturate", "savour", "scale", "scamper", "scar", "scare", "scarper", "scent", "schematise", "scheme", "schlep", "scoff", "scoop", "scope", "scotch", "scowl", "scrabble", "scram", "scramble", "scrape", "screw", "scruple", "scrutinise", "scuffle", "scuttle", "search", "secularize", "see", "segregate", "sell", "sense", "sensitize", "sequester", "serenade", "serialize", "serve", "service", "settle", "sew", "shaft", "sham", "shampoo", "shanghai", "shear", "sheathe", "shell", "shinny", "shirk", "shoot", "shoulder", "shout", "shovel", "showboat", "shred", "shrill", "shudder", "shush", "sidetrack", "sign", "silt", "sin", "singe", "sit", "sizzle", "skateboard", "ski", "slake", "slap", "slather", "sleet", "slink", "slip", "slope", "slump", "smarten", "smuggle", "snack", "sneak", "sniff", "snoop", "snow", "snowplow", "snuggle", "soap", "solace", "solder", "solicit", "source", "spark", "spattering", "spectacles", "spectate", "spellcheck", "spew", "spice", "spirit", "splash", "splay", "split", "splosh", "splurge", "spook", "square", "squirm", "stabilise", "stable", "stack", "stage", "stake", "starch", "state", "statement", "stiffen", "stigmatize", "sting", "stint", "stoop", "store", "storyboard", "stratify", "structure", "stuff", "stunt", "substantiate", "subtract", "suckle", "suffice", "suffocate", "summarise", "sun", "sunbathe", "sunder", "sup", "surge", "surprise", "swat", "swathe", "sway", "swear", "swelter", "swerve", "swill", "swing", "symbolise", "synthesise", "syringe", "table", "tabulate", "tag", "tame", "tank", "tankful", "tarry", "task", "taxicab", "team", "telescope", "tenant", "terraform", "terrorise", "testify", "think", "throbbing", "thump", "tighten", "toady", "toe", "tough", "tousle", "traduce", "train", "transcend", "transplant", "trash", "treasure", "treble", "trek", "trial", "tromp", "trouser", "trust", "tune", "tut", "twine", "twist", "typify", "unbalance", "uncork", "uncover", "underachieve", "undergo", "underplay", "unearth", "unfreeze", "unfurl", "unlearn", "unscramble", "unzip", "uproot", "upsell", "usher", "vacation", "vamoose", "vanish", "vary", "veg", "venture", "verify", "vet", "veto", "volunteer", "vulgarise", "waft", "wallop", "waltz", "warp", "wash", "waver", "weary", "weatherize", "wedge", "weep", "weight", "welcome", "westernise", "westernize", "while", "whine", "whisper", "whistle", "whitewash", "whup", "wilt", "wing", "wire", "wisecrack", "wolf", "wound", "wring", "writ", "yak", "yawn", "yearn", "yuppify"], _xe = { adjective: wxe, adverb: Fxe, conjunction: Txe, interjection: vxe, noun: xxe, preposition: Cxe, verb: kxe }, Nxe = _xe, Dxe = { airline: mFe, animal: IFe, app: OFe, book: KFe, cell_phone: YFe, color: QFe, commerce: nTe, company: dTe, database: gTe, date: ATe, finance: RTe, food: KTe, hacker: XTe, internet: rve, location: Fve, lorem: xve, metadata: kve, music: Pve, person: Zve, phone_number: axe, science: cxe, team: mxe, vehicle: Sxe, word: Nxe }, Ixe = Dxe, ft = class extends Error {
};
function Rxe(t) {
  let e = Object.getPrototypeOf(t);
  do {
    for (let n of Object.getOwnPropertyNames(e)) typeof t[n] == "function" && n !== "constructor" && (t[n] = t[n].bind(t));
    e = Object.getPrototypeOf(e);
  } while (e !== Object.prototype);
}
var Dh = class {
  constructor(e) {
    this.faker = e, Rxe(this);
  }
}, Zr = class extends Dh {
  constructor(t) {
    super(t), this.faker = t;
  }
}, Y$ = ((t) => (t.Narrowbody = "narrowbody", t.Regional = "regional", t.Widebody = "widebody", t))(Y$ || {}), Pxe = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], Lxe = ["0", "O", "1", "I", "L"], Mxe = { regional: 20, narrowbody: 35, widebody: 60 }, Oxe = { regional: ["A", "B", "C", "D"], narrowbody: ["A", "B", "C", "D", "E", "F"], widebody: ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K"] }, Bxe = class extends Zr {
  airport() {
    return this.faker.helpers.arrayElement(this.faker.definitions.airline.airport);
  }
  airline() {
    return this.faker.helpers.arrayElement(this.faker.definitions.airline.airline);
  }
  airplane() {
    return this.faker.helpers.arrayElement(this.faker.definitions.airline.airplane);
  }
  recordLocator(e = {}) {
    let { allowNumerics: n = !1, allowVisuallySimilarCharacters: r = !1 } = e, i = [];
    return n || i.push(...Pxe), r || i.push(...Lxe), this.faker.string.alphanumeric({ length: 6, casing: "upper", exclude: i });
  }
  seat(e = {}) {
    let { aircraftType: n = "narrowbody" } = e, r = Mxe[n], i = Oxe[n], s = this.faker.number.int({ min: 1, max: r }), a = this.faker.helpers.arrayElement(i);
    return `${s}${a}`;
  }
  aircraftType() {
    return this.faker.helpers.enumValue(Y$);
  }
  flightNumber(e = {}) {
    let { length: n = { min: 1, max: 4 }, addLeadingZeros: r = !1 } = e, i = this.faker.string.numeric({ length: n, allowLeadingZeros: !1 });
    return r ? i.padStart(4, "0") : i;
  }
}, q$ = ((t) => (t.SRGB = "sRGB", t.DisplayP3 = "display-p3", t.REC2020 = "rec2020", t.A98RGB = "a98-rgb", t.ProphotoRGB = "prophoto-rgb", t))(q$ || {}), J$ = ((t) => (t.RGB = "rgb", t.RGBA = "rgba", t.HSL = "hsl", t.HSLA = "hsla", t.HWB = "hwb", t.CMYK = "cmyk", t.LAB = "lab", t.LCH = "lch", t.COLOR = "color", t))(J$ || {});
function $xe(t, e) {
  let { prefix: n, casing: r } = e;
  switch (r) {
    case "upper": {
      t = t.toUpperCase();
      break;
    }
    case "lower": {
      t = t.toLowerCase();
      break;
    }
  }
  return n && (t = n + t), t;
}
function Q$(t) {
  return t.map((e) => {
    if (e % 1 !== 0) {
      let n = new ArrayBuffer(4);
      new DataView(n).setFloat32(0, e);
      let r = new Uint8Array(n);
      return Q$([...r]).replaceAll(" ", "");
    }
    return (e >>> 0).toString(2).padStart(8, "0");
  }).join(" ");
}
function Qs(t) {
  return Math.round(t * 100);
}
function Hxe(t, e = "rgb", n = "sRGB") {
  switch (e) {
    case "rgba":
      return `rgba(${t[0]}, ${t[1]}, ${t[2]}, ${t[3]})`;
    case "color":
      return `color(${n} ${t[0]} ${t[1]} ${t[2]})`;
    case "cmyk":
      return `cmyk(${Qs(t[0])}%, ${Qs(t[1])}%, ${Qs(t[2])}%, ${Qs(t[3])}%)`;
    case "hsl":
      return `hsl(${t[0]}deg ${Qs(t[1])}% ${Qs(t[2])}%)`;
    case "hsla":
      return `hsl(${t[0]}deg ${Qs(t[1])}% ${Qs(t[2])}% / ${Qs(t[3])})`;
    case "hwb":
      return `hwb(${t[0]} ${Qs(t[1])}% ${Qs(t[2])}%)`;
    case "lab":
      return `lab(${Qs(t[0])}% ${t[1]} ${t[2]})`;
    case "lch":
      return `lch(${Qs(t[0])}% ${t[1]} ${t[2]})`;
    case "rgb":
      return `rgb(${t[0]}, ${t[1]}, ${t[2]})`;
  }
}
function Gc(t, e, n = "rgb", r = "sRGB") {
  switch (e) {
    case "css":
      return Hxe(t, n, r);
    case "binary":
      return Q$(t);
    case "decimal":
      return t;
  }
}
var Uxe = class extends Zr {
  human() {
    return this.faker.helpers.arrayElement(this.faker.definitions.color.human);
  }
  space() {
    return this.faker.helpers.arrayElement(this.faker.definitions.color.space);
  }
  cssSupportedFunction() {
    return this.faker.helpers.enumValue(J$);
  }
  cssSupportedSpace() {
    return this.faker.helpers.enumValue(q$);
  }
  rgb(t = {}) {
    let { format: e = "hex", includeAlpha: n = !1, prefix: r = "#", casing: i = "lower" } = t, s, a = "rgb";
    return e === "hex" ? (s = this.faker.string.hexadecimal({ length: n ? 8 : 6, prefix: "" }), s = $xe(s, { prefix: r, casing: i }), s) : (s = Array.from({ length: 3 }, () => this.faker.number.int(255)), n && (s.push(this.faker.number.float({ multipleOf: 0.01 })), a = "rgba"), Gc(s, e, a));
  }
  cmyk(t = {}) {
    let { format: e = "decimal" } = t, n = Array.from({ length: 4 }, () => this.faker.number.float({ multipleOf: 0.01 }));
    return Gc(n, e, "cmyk");
  }
  hsl(t = {}) {
    let { format: e = "decimal", includeAlpha: n = !1 } = t, r = [this.faker.number.int(360)];
    for (let i = 0; i < (t?.includeAlpha ? 3 : 2); i++) r.push(this.faker.number.float({ multipleOf: 0.01 }));
    return Gc(r, e, n ? "hsla" : "hsl");
  }
  hwb(t = {}) {
    let { format: e = "decimal" } = t, n = [this.faker.number.int(360)];
    for (let r = 0; r < 2; r++) n.push(this.faker.number.float({ multipleOf: 0.01 }));
    return Gc(n, e, "hwb");
  }
  lab(t = {}) {
    let { format: e = "decimal" } = t, n = [this.faker.number.float({ multipleOf: 1e-6 })];
    for (let r = 0; r < 2; r++) n.push(this.faker.number.float({ min: -100, max: 100, multipleOf: 1e-4 }));
    return Gc(n, e, "lab");
  }
  lch(t = {}) {
    let { format: e = "decimal" } = t, n = [this.faker.number.float({ multipleOf: 1e-6 })];
    for (let r = 0; r < 2; r++) n.push(this.faker.number.float({ max: 230, multipleOf: 0.1 }));
    return Gc(n, e, "lch");
  }
  colorByCSSColorSpace(t = {}) {
    let { format: e = "decimal", space: n = "sRGB" } = t, r = Array.from({ length: 3 }, () => this.faker.number.float({ multipleOf: 1e-4 }));
    return Gc(r, e, "color", n);
  }
}, X$ = ((t) => (t.Legacy = "legacy", t.Segwit = "segwit", t.Bech32 = "bech32", t.Taproot = "taproot", t))(X$ || {}), Gxe = ((t) => (t.Mainnet = "mainnet", t.Testnet = "testnet", t))(Gxe || {}), Wxe = { legacy: { prefix: { mainnet: "1", testnet: "m" }, length: { min: 26, max: 34 }, casing: "mixed", exclude: "0OIl" }, segwit: { prefix: { mainnet: "3", testnet: "2" }, length: { min: 26, max: 34 }, casing: "mixed", exclude: "0OIl" }, bech32: { prefix: { mainnet: "bc1", testnet: "tb1" }, length: { min: 42, max: 42 }, casing: "lower", exclude: "1bBiIoO" }, taproot: { prefix: { mainnet: "bc1p", testnet: "tb1p" }, length: { min: 62, max: 62 }, casing: "lower", exclude: "1bBiIoO" } }, Z$ = typeof Buffer > "u" || !eH("base64") ? (t) => {
  let e = new TextEncoder().encode(t), n = Array.from(e, (r) => String.fromCodePoint(r)).join("");
  return btoa(n);
} : (t) => Buffer.from(t).toString("base64"), YI = typeof Buffer > "u" || !eH("base64url") ? (t) => Z$(t).replaceAll("+", "-").replaceAll("/", "_").replaceAll(/=+$/g, "") : (t) => Buffer.from(t).toString("base64url");
function eH(t) {
  try {
    return typeof Buffer.from("test").toString(t) == "string";
  } catch {
    return !1;
  }
}
var Vxe = Object.fromEntries([["А", "A"], ["а", "a"], ["Б", "B"], ["б", "b"], ["В", "V"], ["в", "v"], ["Г", "G"], ["г", "g"], ["Д", "D"], ["д", "d"], ["ъе", "ye"], ["Ъе", "Ye"], ["ъЕ", "yE"], ["ЪЕ", "YE"], ["Е", "E"], ["е", "e"], ["Ё", "Yo"], ["ё", "yo"], ["Ж", "Zh"], ["ж", "zh"], ["З", "Z"], ["з", "z"], ["И", "I"], ["и", "i"], ["ый", "iy"], ["Ый", "Iy"], ["ЫЙ", "IY"], ["ыЙ", "iY"], ["Й", "Y"], ["й", "y"], ["К", "K"], ["к", "k"], ["Л", "L"], ["л", "l"], ["М", "M"], ["м", "m"], ["Н", "N"], ["н", "n"], ["О", "O"], ["о", "o"], ["П", "P"], ["п", "p"], ["Р", "R"], ["р", "r"], ["С", "S"], ["с", "s"], ["Т", "T"], ["т", "t"], ["У", "U"], ["у", "u"], ["Ф", "F"], ["ф", "f"], ["Х", "Kh"], ["х", "kh"], ["Ц", "Ts"], ["ц", "ts"], ["Ч", "Ch"], ["ч", "ch"], ["Ш", "Sh"], ["ш", "sh"], ["Щ", "Sch"], ["щ", "sch"], ["Ъ", ""], ["ъ", ""], ["Ы", "Y"], ["ы", "y"], ["Ь", ""], ["ь", ""], ["Э", "E"], ["э", "e"], ["Ю", "Yu"], ["ю", "yu"], ["Я", "Ya"], ["я", "ya"]]), Kxe = Object.fromEntries([["α", "a"], ["β", "v"], ["γ", "g"], ["δ", "d"], ["ε", "e"], ["ζ", "z"], ["η", "i"], ["θ", "th"], ["ι", "i"], ["κ", "k"], ["λ", "l"], ["μ", "m"], ["ν", "n"], ["ξ", "ks"], ["ο", "o"], ["π", "p"], ["ρ", "r"], ["σ", "s"], ["τ", "t"], ["υ", "y"], ["φ", "f"], ["χ", "x"], ["ψ", "ps"], ["ω", "o"], ["ά", "a"], ["έ", "e"], ["ί", "i"], ["ό", "o"], ["ύ", "y"], ["ή", "i"], ["ώ", "o"], ["ς", "s"], ["ϊ", "i"], ["ΰ", "y"], ["ϋ", "y"], ["ΐ", "i"], ["Α", "A"], ["Β", "B"], ["Γ", "G"], ["Δ", "D"], ["Ε", "E"], ["Ζ", "Z"], ["Η", "I"], ["Θ", "TH"], ["Ι", "I"], ["Κ", "K"], ["Λ", "L"], ["Μ", "M"], ["Ν", "N"], ["Ξ", "KS"], ["Ο", "O"], ["Π", "P"], ["Ρ", "R"], ["Σ", "S"], ["Τ", "T"], ["Υ", "Y"], ["Φ", "F"], ["Χ", "X"], ["Ψ", "PS"], ["Ω", "O"], ["Ά", "A"], ["Έ", "E"], ["Ί", "I"], ["Ό", "O"], ["Ύ", "Y"], ["Ή", "I"], ["Ώ", "O"], ["Ϊ", "I"], ["Ϋ", "Y"]]), zxe = Object.fromEntries([["ء", "e"], ["آ", "a"], ["أ", "a"], ["ؤ", "w"], ["إ", "i"], ["ئ", "y"], ["ا", "a"], ["ب", "b"], ["ة", "t"], ["ت", "t"], ["ث", "th"], ["ج", "j"], ["ح", "h"], ["خ", "kh"], ["د", "d"], ["ذ", "dh"], ["ر", "r"], ["ز", "z"], ["س", "s"], ["ش", "sh"], ["ص", "s"], ["ض", "d"], ["ط", "t"], ["ظ", "z"], ["ع", "e"], ["غ", "gh"], ["ـ", "_"], ["ف", "f"], ["ق", "q"], ["ك", "k"], ["ل", "l"], ["م", "m"], ["ن", "n"], ["ه", "h"], ["و", "w"], ["ى", "a"], ["ي", "y"], ["َ‎", "a"], ["ُ", "u"], ["ِ‎", "i"]]), jxe = Object.fromEntries([["ա", "a"], ["Ա", "A"], ["բ", "b"], ["Բ", "B"], ["գ", "g"], ["Գ", "G"], ["դ", "d"], ["Դ", "D"], ["ե", "ye"], ["Ե", "Ye"], ["զ", "z"], ["Զ", "Z"], ["է", "e"], ["Է", "E"], ["ը", "y"], ["Ը", "Y"], ["թ", "t"], ["Թ", "T"], ["ժ", "zh"], ["Ժ", "Zh"], ["ի", "i"], ["Ի", "I"], ["լ", "l"], ["Լ", "L"], ["խ", "kh"], ["Խ", "Kh"], ["ծ", "ts"], ["Ծ", "Ts"], ["կ", "k"], ["Կ", "K"], ["հ", "h"], ["Հ", "H"], ["ձ", "dz"], ["Ձ", "Dz"], ["ղ", "gh"], ["Ղ", "Gh"], ["ճ", "tch"], ["Ճ", "Tch"], ["մ", "m"], ["Մ", "M"], ["յ", "y"], ["Յ", "Y"], ["ն", "n"], ["Ն", "N"], ["շ", "sh"], ["Շ", "Sh"], ["ո", "vo"], ["Ո", "Vo"], ["չ", "ch"], ["Չ", "Ch"], ["պ", "p"], ["Պ", "P"], ["ջ", "j"], ["Ջ", "J"], ["ռ", "r"], ["Ռ", "R"], ["ս", "s"], ["Ս", "S"], ["վ", "v"], ["Վ", "V"], ["տ", "t"], ["Տ", "T"], ["ր", "r"], ["Ր", "R"], ["ց", "c"], ["Ց", "C"], ["ու", "u"], ["ՈՒ", "U"], ["Ու", "U"], ["փ", "p"], ["Փ", "P"], ["ք", "q"], ["Ք", "Q"], ["օ", "o"], ["Օ", "O"], ["ֆ", "f"], ["Ֆ", "F"], ["և", "yev"]]), Yxe = Object.fromEntries([["چ", "ch"], ["ک", "k"], ["گ", "g"], ["پ", "p"], ["ژ", "zh"], ["ی", "y"]]), qxe = Object.fromEntries([["א", "a"], ["ב", "b"], ["ג", "g"], ["ד", "d"], ["ה", "h"], ["ו", "v"], ["ז", "z"], ["ח", "ch"], ["ט", "t"], ["י", "y"], ["כ", "k"], ["ך", "kh"], ["ל", "l"], ["ם", "m"], ["מ", "m"], ["ן", "n"], ["נ", "n"], ["ס", "s"], ["ע", "a"], ["פ", "f"], ["ף", "ph"], ["צ", "ts"], ["ץ", "ts"], ["ק", "k"], ["ר", "r"], ["ש", "sh"], ["ת", "t"], ["ו", "v"]]), qI = { ...Vxe, ...Kxe, ...zxe, ...Yxe, ...jxe, ...qxe }, Jxe = ((t) => (t.Any = "any", t.Loopback = "loopback", t.PrivateA = "private-a", t.PrivateB = "private-b", t.PrivateC = "private-c", t.TestNet1 = "test-net-1", t.TestNet2 = "test-net-2", t.TestNet3 = "test-net-3", t.LinkLocal = "link-local", t.Multicast = "multicast", t))(Jxe || {}), Qxe = { any: "0.0.0.0/0", loopback: "127.0.0.0/8", "private-a": "10.0.0.0/8", "private-b": "172.16.0.0/12", "private-c": "192.168.0.0/16", "test-net-1": "192.0.2.0/24", "test-net-2": "198.51.100.0/24", "test-net-3": "203.0.113.0/24", "link-local": "169.254.0.0/16", multicast: "224.0.0.0/4" };
function JI(t) {
  return /^[a-z][a-z-]*[a-z]$/i.exec(t) !== null;
}
function QI(t, e) {
  let n = t.helpers.slugify(e);
  if (JI(n)) return n;
  let r = t.helpers.slugify(t.lorem.word());
  return JI(r) ? r : t.string.alpha({ casing: "lower", length: t.number.int({ min: 4, max: 8 }) });
}
var Xxe = class extends Zr {
  email(t = {}) {
    let { firstName: e, lastName: n, provider: r = this.faker.helpers.arrayElement(this.faker.definitions.internet.free_email), allowSpecialCharacters: i = !1 } = t, s = this.username({ firstName: e, lastName: n });
    if (s = s.replaceAll(/[^A-Za-z0-9._+-]+/g, ""), s = s.substring(0, 50), i) {
      let a = [..."._-"], o = [...".!#$%&'*+-/=?^_`{|}~"];
      s = s.replace(this.faker.helpers.arrayElement(a), this.faker.helpers.arrayElement(o));
    }
    return s = s.replaceAll(/\.{2,}/g, "."), s = s.replace(/^\./, ""), s = s.replace(/\.$/, ""), `${s}@${r}`;
  }
  exampleEmail(t = {}) {
    let { firstName: e, lastName: n, allowSpecialCharacters: r = !1 } = t, i = this.faker.helpers.arrayElement(this.faker.definitions.internet.example_email);
    return this.email({ firstName: e, lastName: n, provider: i, allowSpecialCharacters: r });
  }
  username(t = {}) {
    let { firstName: e = this.faker.person.firstName(), lastName: n = this.faker.person.lastName(), lastName: r } = t, i = this.faker.helpers.arrayElement([".", "_"]), s = this.faker.number.int(99), a = [() => `${e}${i}${n}${s}`, () => `${e}${i}${n}`];
    r || a.push(() => `${e}${s}`);
    let o = this.faker.helpers.arrayElement(a)();
    return o = o.normalize("NFKD").replaceAll(/[\u0300-\u036F]/g, ""), o = [...o].map((u) => {
      if (qI[u]) return qI[u];
      let l = u.codePointAt(0) ?? Number.NaN;
      return l < 128 ? u : l.toString(36);
    }).join(""), o = o.replaceAll("'", ""), o = o.replaceAll(" ", ""), o;
  }
  displayName(t = {}) {
    let { firstName: e = this.faker.person.firstName(), lastName: n = this.faker.person.lastName() } = t, r = this.faker.helpers.arrayElement([".", "_"]), i = this.faker.number.int(99), s = [() => `${e}${i}`, () => `${e}${r}${n}`, () => `${e}${r}${n}${i}`], a = this.faker.helpers.arrayElement(s)();
    return a = a.replaceAll("'", ""), a = a.replaceAll(" ", ""), a;
  }
  protocol() {
    let t = ["http", "https"];
    return this.faker.helpers.arrayElement(t);
  }
  httpMethod() {
    let t = ["GET", "POST", "PUT", "DELETE", "PATCH"];
    return this.faker.helpers.arrayElement(t);
  }
  httpStatusCode(t = {}) {
    let { types: e = Object.keys(this.faker.definitions.internet.http_status_code) } = t, n = this.faker.helpers.arrayElement(e);
    return this.faker.helpers.arrayElement(this.faker.definitions.internet.http_status_code[n]);
  }
  url(t = {}) {
    let { appendSlash: e = this.faker.datatype.boolean(), protocol: n = "https" } = t;
    return `${n}://${this.domainName()}${e ? "/" : ""}`;
  }
  domainName() {
    return `${this.domainWord()}.${this.domainSuffix()}`;
  }
  domainSuffix() {
    return this.faker.helpers.arrayElement(this.faker.definitions.internet.domain_suffix);
  }
  domainWord() {
    let t = QI(this.faker, this.faker.word.adjective()), e = QI(this.faker, this.faker.word.noun());
    return `${t}-${e}`.toLowerCase();
  }
  ip() {
    return this.faker.datatype.boolean() ? this.ipv4() : this.ipv6();
  }
  ipv4(t = {}) {
    let { network: e = "any", cidrBlock: n = Qxe[e] } = t;
    if (!/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\/\d{1,2}$/.test(n)) throw new ft(`Invalid CIDR block provided: ${n}. Must be in the format x.x.x.x/y.`);
    let [r, i] = n.split("/"), s = 4294967295 >>> Number.parseInt(i), [a, o, u, l] = r.split(".").map(Number), h = (a << 24 | o << 16 | u << 8 | l) & ~s, f = this.faker.number.int(s), m = h | f;
    return [m >>> 24 & 255, m >>> 16 & 255, m >>> 8 & 255, m & 255].join(".");
  }
  ipv6() {
    return Array.from({ length: 8 }, () => this.faker.string.hexadecimal({ length: 4, casing: "lower", prefix: "" })).join(":");
  }
  port() {
    return this.faker.number.int(65535);
  }
  userAgent() {
    return this.faker.helpers.fake(this.faker.definitions.internet.user_agent_pattern);
  }
  mac(t = {}) {
    typeof t == "string" && (t = { separator: t });
    let { separator: e = ":" } = t, n, r = "";
    for ([":", "-", ""].includes(e) || (e = ":"), n = 0; n < 12; n++) r += this.faker.number.hex(15), n % 2 === 1 && n !== 11 && (r += e);
    return r;
  }
  password(t = {}) {
    let e = /[aeiouAEIOU]$/, n = /[bcdfghjklmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ]$/, r = (u, l, h, f) => {
      if (f.length >= u) return f;
      l && (h = n.test(f) ? e : n);
      let m = this.faker.number.int(94) + 33, g = String.fromCodePoint(m);
      return l && (g = g.toLowerCase()), h.test(g) ? r(u, l, h, f + g) : r(u, l, h, f);
    }, { length: i = 15, memorable: s = !1, pattern: a = /\w/, prefix: o = "" } = t;
    return r(i, s, a, o);
  }
  emoji(t = {}) {
    let { types: e = Object.keys(this.faker.definitions.internet.emoji) } = t, n = this.faker.helpers.arrayElement(e);
    return this.faker.helpers.arrayElement(this.faker.definitions.internet.emoji[n]);
  }
  jwtAlgorithm() {
    return this.faker.helpers.arrayElement(this.faker.definitions.internet.jwt_algorithm);
  }
  jwt(t = {}) {
    let { refDate: e = this.faker.defaultRefDate() } = t, n = this.faker.date.recent({ refDate: e }), { header: r = { alg: this.jwtAlgorithm(), typ: "JWT" }, payload: i = { iat: Math.round(n.valueOf() / 1e3), exp: Math.round(this.faker.date.soon({ refDate: n }).valueOf() / 1e3), nbf: Math.round(this.faker.date.anytime({ refDate: e }).valueOf() / 1e3), iss: this.faker.company.name(), sub: this.faker.string.uuid(), aud: this.faker.string.uuid(), jti: this.faker.string.uuid() } } = t, s = YI(JSON.stringify(r)), a = YI(JSON.stringify(i)), o = this.faker.string.alphanumeric(64);
    return `${s}.${a}.${o}`;
  }
}, tH = ((t) => (t.Female = "female", t.Male = "male", t))(tH || {});
function am(t, e, n) {
  let { generic: r, female: i, male: s } = n;
  switch (e) {
    case "female":
      return i ?? r;
    case "male":
      return s ?? r;
    default:
      return r ?? t.helpers.arrayElement([i, s]) ?? [];
  }
}
var Zxe = class extends Zr {
  firstName(e) {
    return this.faker.helpers.arrayElement(am(this.faker, e, this.faker.definitions.person.first_name));
  }
  lastName(e) {
    if (this.faker.rawDefinitions.person?.last_name_pattern != null) {
      let n = this.faker.helpers.weightedArrayElement(am(this.faker, e, this.faker.rawDefinitions.person.last_name_pattern));
      return this.faker.helpers.fake(n);
    }
    return this.faker.helpers.arrayElement(am(this.faker, e, this.faker.definitions.person.last_name));
  }
  middleName(e) {
    return this.faker.helpers.arrayElement(am(this.faker, e, this.faker.definitions.person.middle_name));
  }
  fullName(e = {}) {
    let { sex: n = this.faker.helpers.arrayElement(["female", "male"]), firstName: r = this.firstName(n), lastName: i = this.lastName(n) } = e, s = this.faker.helpers.weightedArrayElement(this.faker.definitions.person.name);
    return this.faker.helpers.mustache(s, { "person.prefix": () => this.prefix(n), "person.firstName": () => r, "person.middleName": () => this.middleName(n), "person.lastName": () => i, "person.suffix": () => this.suffix() });
  }
  gender() {
    return this.faker.helpers.arrayElement(this.faker.definitions.person.gender);
  }
  sex() {
    return this.faker.helpers.arrayElement(this.faker.definitions.person.sex);
  }
  sexType() {
    return this.faker.helpers.enumValue(tH);
  }
  bio() {
    let { bio_pattern: e } = this.faker.definitions.person;
    return this.faker.helpers.fake(e);
  }
  prefix(e) {
    return this.faker.helpers.arrayElement(am(this.faker, e, this.faker.definitions.person.prefix));
  }
  suffix() {
    return this.faker.helpers.arrayElement(this.faker.definitions.person.suffix);
  }
  jobTitle() {
    return this.faker.helpers.fake(this.faker.definitions.person.job_title_pattern);
  }
  jobDescriptor() {
    return this.faker.helpers.arrayElement(this.faker.definitions.person.job_descriptor);
  }
  jobArea() {
    return this.faker.helpers.arrayElement(this.faker.definitions.person.job_area);
  }
  jobType() {
    return this.faker.helpers.arrayElement(this.faker.definitions.person.job_type);
  }
  zodiacSign() {
    return this.faker.helpers.arrayElement(this.faker.definitions.person.western_zodiac_sign);
  }
}, eCe = 23283064365386963e-26, tCe = 1 / 9007199254740992, { imul: zT, trunc: jT } = Math;
function XI(t) {
  return typeof t == "number" ? nH(t) : nCe(t);
}
function nH(t) {
  let e = Array.from({ length: 624 });
  e[0] = t;
  for (let n = 1; n !== 624; ++n) {
    let r = e[n - 1] ^ e[n - 1] >>> 30;
    e[n] = jT(zT(1812433253, r) + n);
  }
  return e;
}
function nCe(t) {
  let e = nH(19650218), n = 1, r = 0;
  for (let i = Math.max(624, t.length); i !== 0; --i) {
    let s = e[n - 1] ^ e[n - 1] >>> 30;
    e[n] = jT((e[n] ^ zT(s, 1664525)) + t[r] + r), n++, r++, n >= 624 && (e[0] = e[623], n = 1), r >= t.length && (r = 0);
  }
  for (let i = 623; i !== 0; i--) e[n] = jT((e[n] ^ zT(e[n - 1] ^ e[n - 1] >>> 30, 1566083941)) - n), n++, n >= 624 && (e[0] = e[623], n = 1);
  return e[0] = 2147483648, e;
}
function yw(t) {
  for (let n = 0; n !== 227; ++n) {
    let r = (t[n] & 2147483648) + (t[n + 1] & 2147483647);
    t[n] = t[n + 397] ^ r >>> 1 ^ -(r & 1) & 2567483615;
  }
  for (let n = 227; n !== 623; ++n) {
    let r = (t[n] & 2147483648) + (t[n + 1] & 2147483647);
    t[n] = t[n + 397 - 624] ^ r >>> 1 ^ -(r & 1) & 2567483615;
  }
  let e = (t[623] & 2147483648) + (t[0] & 2147483647);
  return t[623] = t[396] ^ e >>> 1 ^ -(e & 1) & 2567483615, t;
}
var rCe = class {
  constructor(e = Math.random() * Number.MAX_SAFE_INTEGER, n = yw(XI(e)), r = 0) {
    this.states = n, this.index = r;
  }
  nextU32() {
    let e = this.states[this.index];
    return e ^= this.states[this.index] >>> 11, e ^= e << 7 & 2636928640, e ^= e << 15 & 4022730752, e ^= e >>> 18, ++this.index >= 624 && (this.states = yw(this.states), this.index = 0), e >>> 0;
  }
  nextF32() {
    return this.nextU32() * eCe;
  }
  nextU53() {
    let e = this.nextU32() >>> 5, n = this.nextU32() >>> 6;
    return e * 67108864 + n;
  }
  nextF53() {
    return this.nextU53() * tCe;
  }
  seed(e) {
    this.states = yw(XI(e)), this.index = 0;
  }
};
function rH() {
  return Math.ceil(Math.random() * Number.MAX_SAFE_INTEGER);
}
function iCe(t = rH()) {
  let e = new rCe(t);
  return { next() {
    return e.nextF53();
  }, seed(n) {
    e.seed(n);
  } };
}
var sCe = class extends Dh {
  boolean(t = {}) {
    typeof t == "number" && (t = { probability: t });
    let { probability: e = 0.5 } = t;
    return e <= 0 ? !1 : e >= 1 ? !0 : this.faker.number.float() < e;
  }
};
function Ru(t, e = "refDate") {
  let n = new Date(t);
  if (Number.isNaN(n.valueOf())) throw new ft(`Invalid ${e} date: ${t.toString()}`);
  return n;
}
var p1 = () => {
  throw new ft("You cannot edit the locale data on the faker instance");
};
function aCe(t) {
  let e = {};
  return new Proxy(t, { has() {
    return !0;
  }, get(n, r) {
    return typeof r == "symbol" || r === "nodeType" ? n[r] : r in e ? e[r] : e[r] = oCe(r, n[r]);
  }, set: p1, deleteProperty: p1 });
}
function YT(t, ...e) {
  if (t === null) throw new ft(`The locale data for '${e.join(".")}' aren't applicable to this locale.
  If you think this is a bug, please report it at: https://github.com/faker-js/faker`);
  if (t === void 0) throw new ft(`The locale data for '${e.join(".")}' are missing in this locale.
  If this is a custom Faker instance, please make sure all required locales are used e.g. '[de_AT, de, en, base]'.
  Please contribute the missing data to the project or use a locale/Faker instance that has these data.
  For more information see https://fakerjs.dev/guide/localization.html`);
}
function oCe(t, e = {}) {
  return new Proxy(e, { has(n, r) {
    return n[r] != null;
  }, get(n, r) {
    let i = n[r];
    return typeof r == "symbol" || r === "nodeType" || YT(i, t, r.toString()), i;
  }, set: p1, deleteProperty: p1 });
}
var iH = class extends Dh {
  anytime(t = {}) {
    let { refDate: e = this.faker.defaultRefDate() } = t, n = Ru(e).getTime();
    return this.between({ from: n - 1e3 * 60 * 60 * 24 * 365, to: n + 1e3 * 60 * 60 * 24 * 365 });
  }
  past(t = {}) {
    let { years: e = 1, refDate: n = this.faker.defaultRefDate() } = t;
    if (e <= 0) throw new ft("Years must be greater than 0.");
    let r = Ru(n).getTime();
    return this.between({ from: r - e * 365 * 24 * 3600 * 1e3, to: r - 1e3 });
  }
  future(t = {}) {
    let { years: e = 1, refDate: n = this.faker.defaultRefDate() } = t;
    if (e <= 0) throw new ft("Years must be greater than 0.");
    let r = Ru(n).getTime();
    return this.between({ from: r + 1e3, to: r + e * 365 * 24 * 3600 * 1e3 });
  }
  between(t) {
    let { from: e, to: n } = t, r = Ru(e, "from").getTime(), i = Ru(n, "to").getTime();
    if (r > i) throw new ft("`from` date must be before `to` date.");
    return new Date(this.faker.number.int({ min: r, max: i }));
  }
  betweens(t) {
    let { from: e, to: n, count: r = 3 } = t;
    return this.faker.helpers.multiple(() => this.between({ from: e, to: n }), { count: r }).toSorted((i, s) => i.getTime() - s.getTime());
  }
  recent(t = {}) {
    let { days: e = 1, refDate: n = this.faker.defaultRefDate() } = t;
    if (e <= 0) throw new ft("Days must be greater than 0.");
    let r = Ru(n).getTime();
    return this.between({ from: r - e * 24 * 3600 * 1e3, to: r - 1e3 });
  }
  soon(t = {}) {
    let { days: e = 1, refDate: n = this.faker.defaultRefDate() } = t;
    if (e <= 0) throw new ft("Days must be greater than 0.");
    let r = Ru(n).getTime();
    return this.between({ from: r + 1e3, to: r + e * 24 * 3600 * 1e3 });
  }
  birthdate(t = {}) {
    let { mode: e = "age", min: n = 18, max: r = 80, refDate: i = this.faker.defaultRefDate() } = t, s = Ru(i), a = s.getUTCFullYear();
    switch (e) {
      case "age": {
        let o = new Date(s).setUTCFullYear(a - r - 1) + 864e5, u = new Date(s).setUTCFullYear(a - n);
        if (o > u) throw new ft(`Max age ${r} should be greater than or equal to min age ${n}.`);
        return this.between({ from: o, to: u });
      }
      case "year": {
        let o = new Date(Date.UTC(0, 0, 2)).setUTCFullYear(n), u = new Date(Date.UTC(0, 11, 30)).setUTCFullYear(r);
        if (o > u) throw new ft(`Max year ${r} should be greater than or equal to min year ${n}.`);
        return this.between({ from: o, to: u });
      }
    }
  }
}, uCe = class extends iH {
  constructor(t) {
    super(t), this.faker = t;
  }
  month(t = {}) {
    let { abbreviated: e = !1, context: n = !1 } = t, r = this.faker.definitions.date.month, i;
    e ? i = n && r.abbr_context != null ? "abbr_context" : "abbr" : i = n && r.wide_context != null ? "wide_context" : "wide";
    let s = r[i];
    return YT(s, "date.month", i), this.faker.helpers.arrayElement(s);
  }
  weekday(t = {}) {
    let { abbreviated: e = !1, context: n = !1 } = t, r = this.faker.definitions.date.weekday, i;
    e ? i = n && r.abbr_context != null ? "abbr_context" : "abbr" : i = n && r.wide_context != null ? "wide_context" : "wide";
    let s = r[i];
    return YT(s, "date.weekday", i), this.faker.helpers.arrayElement(s);
  }
  timeZone() {
    return this.faker.helpers.arrayElement(this.faker.definitions.date.time_zone);
  }
}, lCe = /\.|\(/;
function cCe(t, e, n = [e, e.rawDefinitions]) {
  if (t.length === 0) throw new ft("Eval expression cannot be empty.");
  if (n.length === 0) throw new ft("Eval entrypoints cannot be empty.");
  let r = n, i = t;
  do {
    let a;
    i.startsWith("(") ? [a, r] = hCe(i, r) : [a, r] = fCe(i, r), i = i.substring(a), r = r.filter((o) => o != null).map((o) => Array.isArray(o) ? e.helpers.arrayElement(o) : o);
  } while (i.length > 0 && r.length > 0);
  if (r.length === 0) throw new ft(`Cannot resolve expression '${t}'`);
  let s = r[0];
  return typeof s == "function" ? s() : s;
}
function hCe(t, e) {
  let [n, r] = dCe(t), i = t[n + 1];
  switch (i) {
    case ".":
    case "(":
    case void 0:
      break;
    default:
      throw new ft(`Expected dot ('.'), open parenthesis ('('), or nothing after function call but got '${i}'`);
  }
  return [n + (i === "." ? 2 : 1), e.map((s) => typeof s == "function" ? s(...r) : void 0)];
}
function dCe(t) {
  let e = t.indexOf(")", 1);
  if (e === -1) throw new ft(`Missing closing parenthesis in '${t}'`);
  for (; e !== -1; ) {
    let r = t.substring(1, e);
    try {
      return [e, JSON.parse(`[${r}]`)];
    } catch {
      if (!r.includes("'") && !r.includes('"')) try {
        return [e, JSON.parse(`["${r}"]`)];
      } catch {
      }
    }
    e = t.indexOf(")", e + 1);
  }
  e = t.lastIndexOf(")");
  let n = t.substring(1, e);
  return [e, [n]];
}
function fCe(t, e) {
  let n = lCe.exec(t), r = (n?.[0] ?? "") === ".", i = n?.index ?? t.length, s = t.substring(0, i);
  if (s.length === 0) throw new ft(`Expression parts cannot be empty in '${t}'`);
  let a = t[i + 1];
  if (r && (a == null || a === "." || a === "(")) throw new ft(`Found dot without property name in '${t}'`);
  return [i + (r ? 1 : 0), e.map((o) => mCe(o, s))];
}
function mCe(t, e) {
  switch (typeof t) {
    case "function": {
      try {
        t = t();
      } catch {
        return;
      }
      return t?.[e];
    }
    case "object":
      return t?.[e];
    default:
      return;
  }
}
function gCe(t) {
  let e = pCe(t.replace(/L?$/, "0"));
  return e === 0 ? 0 : 10 - e;
}
function pCe(t) {
  t = t.replaceAll(/[\s-]/g, "");
  let e = 0, n = !1;
  for (let r = t.length - 1; r >= 0; r--) {
    let i = Number.parseInt(t[r]);
    n && (i *= 2, i > 9 && (i = i % 10 + 1)), e += i, n = !n;
  }
  return e % 10;
}
function ZI(t, e, n, r) {
  let i = 1;
  if (e) switch (e) {
    case "?": {
      i = t.datatype.boolean() ? 0 : 1;
      break;
    }
    case "*": {
      let s = 1;
      for (; t.datatype.boolean(); ) s *= 2;
      i = t.number.int({ min: 0, max: s });
      break;
    }
    case "+": {
      let s = 1;
      for (; t.datatype.boolean(); ) s *= 2;
      i = t.number.int({ min: 1, max: s });
      break;
    }
    default:
      throw new ft("Unknown quantifier symbol provided.");
  }
  else n != null && r != null ? i = t.number.int({ min: Number.parseInt(n), max: Number.parseInt(r) }) : n != null && r == null && (i = Number.parseInt(n));
  return i;
}
function bCe(t, e = "") {
  let n = /(.)\{(\d+),(\d+)\}/, r = /(.)\{(\d+)\}/, i = /\[(\d+)-(\d+)\]/, s, a, o, u, l = n.exec(e);
  for (; l != null; ) s = Number.parseInt(l[2]), a = Number.parseInt(l[3]), s > a && (o = a, a = s, s = o), u = t.number.int({ min: s, max: a }), e = e.slice(0, l.index) + l[1].repeat(u) + e.slice(l.index + l[0].length), l = n.exec(e);
  for (l = r.exec(e); l != null; ) u = Number.parseInt(l[2]), e = e.slice(0, l.index) + l[1].repeat(u) + e.slice(l.index + l[0].length), l = r.exec(e);
  for (l = i.exec(e); l != null; ) s = Number.parseInt(l[1]), a = Number.parseInt(l[2]), s > a && (o = a, a = s, s = o), e = e.slice(0, l.index) + t.number.int({ min: s, max: a }).toString() + e.slice(l.index + l[0].length), l = i.exec(e);
  return e;
}
function sH(t, e = "", n = "#") {
  let r = "";
  for (let i = 0; i < e.length; i++) e.charAt(i) === n ? r += t.number.int(9) : e.charAt(i) === "!" ? r += t.number.int({ min: 2, max: 9 }) : r += e.charAt(i);
  return r;
}
var aH = class extends Dh {
  slugify(t = "") {
    return t.normalize("NFKD").replaceAll(/[\u0300-\u036F]/g, "").replaceAll(" ", "-").replaceAll(/[^\w.-]+/g, "");
  }
  replaceSymbols(t = "") {
    let e = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"], n = "";
    for (let r = 0; r < t.length; r++) t.charAt(r) === "#" ? n += this.faker.number.int(9) : t.charAt(r) === "?" ? n += this.arrayElement(e) : t.charAt(r) === "*" ? n += this.faker.datatype.boolean() ? this.arrayElement(e) : this.faker.number.int(9) : n += t.charAt(r);
    return n;
  }
  replaceCreditCardSymbols(t = "6453-####-####-####-###L", e = "#") {
    t = bCe(this.faker, t), t = sH(this.faker, t, e);
    let n = gCe(t);
    return t.replace("L", String(n));
  }
  fromRegExp(t) {
    let e = !1;
    t instanceof RegExp && (e = t.flags.includes("i"), t = t.toString(), t = /\/(.+?)\//.exec(t)?.[1] ?? "");
    let n, r, i, s = /([.A-Za-z0-9])(?:\{(\d+)(?:,(\d+)|)\}|(\?|\*|\+))(?![^[]*]|[^{]*})/, a = s.exec(t);
    for (; a != null; ) {
      let f = a[2], m = a[3], g = a[4];
      i = ZI(this.faker, g, f, m);
      let A;
      a[1] === "." ? A = this.faker.string.alphanumeric(i) : e ? A = this.faker.string.fromCharacters([a[1].toLowerCase(), a[1].toUpperCase()], i) : A = a[1].repeat(i), t = t.slice(0, a.index) + A + t.slice(a.index + a[0].length), a = s.exec(t);
    }
    let o = /(\d-\d|\w-\w|\d|\w|[-!@#$&()`.+,/"])/, u = /\[(\^|)(-|)(.+?)\](?:\{(\d+)(?:,(\d+)|)\}|(\?|\*|\+)|)/;
    for (a = u.exec(t); a != null; ) {
      let f = a[1] === "^", m = a[2] === "-", g = a[4], A = a[5], E = a[6], w = [], x = a[3], N = o.exec(x);
      for (m && w.push(45); N != null; ) {
        if (N[0].includes("-")) {
          let P = N[0].split("-").map((C) => C.codePointAt(0) ?? Number.NaN);
          if (n = P[0], r = P[1], n > r) throw new ft("Character range provided is out of order.");
          for (let C = n; C <= r; C++) if (e && Number.isNaN(Number(String.fromCodePoint(C)))) {
            let D = String.fromCodePoint(C);
            w.push(D.toUpperCase().codePointAt(0) ?? Number.NaN, D.toLowerCase().codePointAt(0) ?? Number.NaN);
          } else w.push(C);
        } else e && Number.isNaN(Number(N[0])) ? w.push(N[0].toUpperCase().codePointAt(0) ?? Number.NaN, N[0].toLowerCase().codePointAt(0) ?? Number.NaN) : w.push(N[0].codePointAt(0) ?? Number.NaN);
        x = x.substring(N[0].length), N = o.exec(x);
      }
      if (i = ZI(this.faker, E, g, A), f) {
        let P = -1;
        for (let C = 48; C <= 57; C++) {
          if (P = w.indexOf(C), P > -1) {
            w.splice(P, 1);
            continue;
          }
          w.push(C);
        }
        for (let C = 65; C <= 90; C++) {
          if (P = w.indexOf(C), P > -1) {
            w.splice(P, 1);
            continue;
          }
          w.push(C);
        }
        for (let C = 97; C <= 122; C++) {
          if (P = w.indexOf(C), P > -1) {
            w.splice(P, 1);
            continue;
          }
          w.push(C);
        }
      }
      let B = this.multiple(() => String.fromCodePoint(this.arrayElement(w)), { count: i }).join("");
      t = t.slice(0, a.index) + B + t.slice(a.index + a[0].length), a = u.exec(t);
    }
    let l = /(.)\{(\d+),(\d+)\}/;
    for (a = l.exec(t); a != null; ) {
      if (n = Number.parseInt(a[2]), r = Number.parseInt(a[3]), n > r) throw new ft("Numbers out of order in {} quantifier.");
      i = this.faker.number.int({ min: n, max: r }), t = t.slice(0, a.index) + a[1].repeat(i) + t.slice(a.index + a[0].length), a = l.exec(t);
    }
    let h = /(.)\{(\d+)\}/;
    for (a = h.exec(t); a != null; ) i = Number.parseInt(a[2]), t = t.slice(0, a.index) + a[1].repeat(i) + t.slice(a.index + a[0].length), a = h.exec(t);
    return t;
  }
  shuffle(t, e = {}) {
    let { inplace: n = !1 } = e;
    n || (t = [...t]);
    for (let r = t.length - 1; r > 0; --r) {
      let i = this.faker.number.int(r);
      [t[r], t[i]] = [t[i], t[r]];
    }
    return t;
  }
  uniqueArray(t, e) {
    if (Array.isArray(t)) {
      let r = [...new Set(t)];
      return this.shuffle(r).splice(0, e);
    }
    let n = /* @__PURE__ */ new Set();
    try {
      if (typeof t == "function") {
        let r = 1e3 * e, i = 0;
        for (; n.size < e && i < r; ) n.add(t()), i++;
      }
    } catch {
    }
    return [...n];
  }
  mustache(t, e) {
    if (t == null) return "";
    for (let n in e) {
      let r = new RegExp(`{{${n}}}`, "g"), i = e[n];
      typeof i == "string" && (i = i.replaceAll("$", "$$$$")), t = t.replace(r, i);
    }
    return t;
  }
  maybe(t, e = {}) {
    if (this.faker.datatype.boolean(e)) return t();
  }
  objectKey(t) {
    let e = Object.keys(t);
    return this.arrayElement(e);
  }
  objectValue(t) {
    let e = this.faker.helpers.objectKey(t);
    return t[e];
  }
  objectEntry(t) {
    let e = this.faker.helpers.objectKey(t);
    return [e, t[e]];
  }
  arrayElement(t) {
    if (t.length === 0) throw new ft("Cannot get value from empty dataset.");
    let e = t.length > 1 ? this.faker.number.int({ max: t.length - 1 }) : 0;
    return t[e];
  }
  weightedArrayElement(t) {
    if (t.length === 0) throw new ft("weightedArrayElement expects an array with at least one element");
    if (!t.every((i) => i.weight > 0)) throw new ft("weightedArrayElement expects an array of { weight, value } objects where weight is a positive number");
    let e = t.reduce((i, { weight: s }) => i + s, 0), n = this.faker.number.float({ min: 0, max: e }), r = 0;
    for (let { weight: i, value: s } of t) if (r += i, n < r) return s;
    return t.at(-1).value;
  }
  arrayElements(t, e) {
    if (t.length === 0) return [];
    let n = this.rangeToNumber(e ?? { min: 1, max: t.length });
    if (n >= t.length) return this.shuffle(t);
    if (n <= 0) return [];
    let r = [...t], i = t.length, s = i - n, a, o;
    for (; i-- > s; ) o = this.faker.number.int(i), a = r[o], r[o] = r[i], r[i] = a;
    return r.slice(s);
  }
  enumValue(t) {
    let e = Object.keys(t).filter((r) => Number.isNaN(Number(r))), n = this.arrayElement(e);
    return t[n];
  }
  rangeToNumber(t) {
    return typeof t == "number" ? t : this.faker.number.int(t);
  }
  multiple(t, e = {}) {
    let n = this.rangeToNumber(e.count ?? 3);
    return n <= 0 ? [] : Array.from({ length: n }, t);
  }
}, yCe = class extends aH {
  constructor(e) {
    super(e), this.faker = e;
  }
  fake(e) {
    e = typeof e == "string" ? e : this.arrayElement(e);
    let n = e.search(/{{[a-z]/), r = e.indexOf("}}", n);
    if (n === -1 || r === -1) return e;
    let i = e.substring(n + 2, r + 2).replace("}}", "").replace("{{", ""), s = cCe(i, this.faker), a = String(s), o = e.substring(0, n) + a + e.substring(r + 2);
    return this.fake(o);
  }
}, oH = class extends Dh {
  latitude(t = {}) {
    let { max: e = 90, min: n = -90, precision: r = 4 } = t;
    return this.faker.number.float({ min: n, max: e, fractionDigits: r });
  }
  longitude(t = {}) {
    let { max: e = 180, min: n = -180, precision: r = 4 } = t;
    return this.faker.number.float({ max: e, min: n, fractionDigits: r });
  }
  nearbyGPSCoordinate(t = {}) {
    let { origin: e, radius: n = 10, isMetric: r = !1 } = t;
    if (e == null) return [this.latitude(), this.longitude()];
    let i = this.faker.number.float({ max: 2 * Math.PI, fractionDigits: 5 }), s = r ? n : n * 1.60934, a = this.faker.number.float({ max: s, fractionDigits: 3 }) * 0.995, o = 4e4 / 360, u = a / o, l = [e[0] + Math.sin(i) * u, e[1] + Math.cos(i) * u];
    return l[0] = l[0] % 180, (l[0] < -90 || l[0] > 90) && (l[0] = Math.sign(l[0]) * 180 - l[0], l[1] += 180), l[1] = (l[1] % 360 + 540) % 360 - 180, [l[0], l[1]];
  }
}, ACe = class extends oH {
  constructor(t) {
    super(t), this.faker = t;
  }
  zipCode(t = {}) {
    typeof t == "string" && (t = { format: t });
    let { state: e } = t;
    if (e != null) {
      let r = this.faker.definitions.location.postcode_by_state[e];
      if (r == null) throw new ft(`No zip code definition found for state "${e}"`);
      return this.faker.helpers.fake(r);
    }
    let { format: n = this.faker.definitions.location.postcode } = t;
    return typeof n == "string" && (n = [n]), n = this.faker.helpers.arrayElement(n), this.faker.helpers.replaceSymbols(n);
  }
  city() {
    return this.faker.helpers.fake(this.faker.definitions.location.city_pattern);
  }
  buildingNumber() {
    return this.faker.helpers.arrayElement(this.faker.definitions.location.building_number).replaceAll(/#+/g, (t) => this.faker.string.numeric({ length: t.length, allowLeadingZeros: !1 }));
  }
  street() {
    return this.faker.helpers.fake(this.faker.definitions.location.street_pattern);
  }
  streetAddress(t = {}) {
    typeof t == "boolean" && (t = { useFullAddress: t });
    let { useFullAddress: e } = t, n = this.faker.definitions.location.street_address[e ? "full" : "normal"];
    return this.faker.helpers.fake(n);
  }
  secondaryAddress() {
    return this.faker.helpers.fake(this.faker.definitions.location.secondary_address).replaceAll(/#+/g, (t) => this.faker.string.numeric({ length: t.length, allowLeadingZeros: !1 }));
  }
  county() {
    return this.faker.helpers.arrayElement(this.faker.definitions.location.county);
  }
  country() {
    return this.faker.helpers.arrayElement(this.faker.definitions.location.country);
  }
  continent() {
    return this.faker.helpers.arrayElement(this.faker.definitions.location.continent);
  }
  countryCode(t = {}) {
    typeof t == "string" && (t = { variant: t });
    let { variant: e = "alpha-2" } = t, n = (() => {
      switch (e) {
        case "numeric":
          return "numeric";
        case "alpha-3":
          return "alpha3";
        case "alpha-2":
          return "alpha2";
      }
    })();
    return this.faker.helpers.arrayElement(this.faker.definitions.location.country_code)[n];
  }
  state(t = {}) {
    let { abbreviated: e = !1 } = t, n = e ? this.faker.definitions.location.state_abbr : this.faker.definitions.location.state;
    return this.faker.helpers.arrayElement(n);
  }
  direction(t = {}) {
    let { abbreviated: e = !1 } = t;
    return e ? this.faker.helpers.arrayElement([...this.faker.definitions.location.direction.cardinal_abbr, ...this.faker.definitions.location.direction.ordinal_abbr]) : this.faker.helpers.arrayElement([...this.faker.definitions.location.direction.cardinal, ...this.faker.definitions.location.direction.ordinal]);
  }
  cardinalDirection(t = {}) {
    let { abbreviated: e = !1 } = t;
    return e ? this.faker.helpers.arrayElement(this.faker.definitions.location.direction.cardinal_abbr) : this.faker.helpers.arrayElement(this.faker.definitions.location.direction.cardinal);
  }
  ordinalDirection(t = {}) {
    let { abbreviated: e = !1 } = t;
    return e ? this.faker.helpers.arrayElement(this.faker.definitions.location.direction.ordinal_abbr) : this.faker.helpers.arrayElement(this.faker.definitions.location.direction.ordinal);
  }
  timeZone() {
    return this.faker.helpers.arrayElement(this.faker.definitions.location.time_zone);
  }
  language() {
    return this.faker.helpers.arrayElement(this.faker.definitions.location.language);
  }
}, ECe = class extends Dh {
  int(t = {}) {
    typeof t == "number" && (t = { max: t });
    let { min: e = 0, max: n = Number.MAX_SAFE_INTEGER, multipleOf: r = 1 } = t;
    if (!Number.isInteger(r)) throw new ft("multipleOf should be an integer.");
    if (r <= 0) throw new ft("multipleOf should be greater than 0.");
    let i = Math.ceil(e / r), s = Math.floor(n / r);
    if (i === s) return i * r;
    if (s < i) throw n >= e ? new ft(`No suitable integer value between ${e} and ${n} found.`) : new ft(`Max ${n} should be greater than min ${e}.`);
    let a = this.faker._randomizer.next(), o = s - i + 1;
    return Math.floor(a * o + i) * r;
  }
  float(t = {}) {
    typeof t == "number" && (t = { max: t });
    let { min: e = 0, max: n = 1, fractionDigits: r, multipleOf: i, multipleOf: s = r == null ? void 0 : 10 ** -r } = t;
    if (n < e) throw new ft(`Max ${n} should be greater than min ${e}.`);
    if (r != null) {
      if (i != null) throw new ft("multipleOf and fractionDigits cannot be set at the same time.");
      if (!Number.isInteger(r)) throw new ft("fractionDigits should be an integer.");
      if (r < 0) throw new ft("fractionDigits should be greater than or equal to 0.");
    }
    if (s != null) {
      if (s <= 0) throw new ft("multipleOf should be greater than 0.");
      let a = Math.log10(s), o = s < 1 && Number.isInteger(a) ? 10 ** -a : 1 / s;
      return this.int({ min: e * o, max: n * o }) / o;
    }
    return this.faker._randomizer.next() * (n - e) + e;
  }
  binary(t = {}) {
    typeof t == "number" && (t = { max: t });
    let { min: e = 0, max: n = 1 } = t;
    return this.int({ max: n, min: e }).toString(2);
  }
  octal(t = {}) {
    typeof t == "number" && (t = { max: t });
    let { min: e = 0, max: n = 7 } = t;
    return this.int({ max: n, min: e }).toString(8);
  }
  hex(t = {}) {
    typeof t == "number" && (t = { max: t });
    let { min: e = 0, max: n = 15 } = t;
    return this.int({ max: n, min: e }).toString(16);
  }
  bigInt(t = {}) {
    (typeof t == "bigint" || typeof t == "number" || typeof t == "string" || typeof t == "boolean") && (t = { max: t });
    let e = BigInt(t.min ?? 0), n = BigInt(t.max ?? e + BigInt(999999999999999)), r = BigInt(t.multipleOf ?? 1);
    if (n < e) throw new ft(`Max ${n} should be larger than min ${e}.`);
    if (r <= BigInt(0)) throw new ft("multipleOf should be greater than 0.");
    let i = e / r + (e % r > 0n ? 1n : 0n), s = n / r - (n % r < 0n ? 1n : 0n);
    if (i === s) return i * r;
    if (s < i) throw new ft(`No suitable bigint value between ${e} and ${n} found.`);
    let a = s - i + 1n, o = BigInt(this.faker.string.numeric({ length: a.toString(10).length, allowLeadingZeros: !0 })) % a;
    return (i + o) * r;
  }
  romanNumeral(t = {}) {
    typeof t == "number" && (t = { max: t });
    let { min: e = 1, max: n = 3999 } = t;
    if (e < 1) throw new ft(`Min value ${e} should be 1 or greater.`);
    if (n > 3999) throw new ft(`Max value ${n} should be 3999 or less.`);
    let r = this.int({ min: e, max: n }), i = [["M", 1e3], ["CM", 900], ["D", 500], ["CD", 400], ["C", 100], ["XC", 90], ["L", 50], ["XL", 40], ["X", 10], ["IX", 9], ["V", 5], ["IV", 4], ["I", 1]], s = "";
    for (let [a, o] of i) s += a.repeat(Math.floor(r / o)), r %= o;
    return s;
  }
}, uH = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
function SCe(t) {
  let e = t.valueOf(), n = "";
  for (let r = 10; r > 0; r--) {
    let i = e % 32;
    n = uH[i] + n, e = (e - i) / 32;
  }
  return n;
}
var N0 = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"], D0 = [..."abcdefghijklmnopqrstuvwxyz"], eR = [..."0123456789"], wCe = class extends Dh {
  fromCharacters(t, e = 1) {
    if (e = this.faker.helpers.rangeToNumber(e), e <= 0) return "";
    if (typeof t == "string" && (t = [...t]), t.length === 0) throw new ft("Unable to generate string: No characters to select from.");
    return this.faker.helpers.multiple(() => this.faker.helpers.arrayElement(t), { count: e }).join("");
  }
  alpha(t = {}) {
    typeof t == "number" && (t = { length: t });
    let e = this.faker.helpers.rangeToNumber(t.length ?? 1);
    if (e <= 0) return "";
    let { casing: n = "mixed" } = t, { exclude: r = [] } = t;
    typeof r == "string" && (r = [...r]);
    let i;
    switch (n) {
      case "upper": {
        i = [...N0];
        break;
      }
      case "lower": {
        i = [...D0];
        break;
      }
      case "mixed": {
        i = [...D0, ...N0];
        break;
      }
    }
    return i = i.filter((s) => !r.includes(s)), this.fromCharacters(i, e);
  }
  alphanumeric(t = {}) {
    typeof t == "number" && (t = { length: t });
    let e = this.faker.helpers.rangeToNumber(t.length ?? 1);
    if (e <= 0) return "";
    let { casing: n = "mixed" } = t, { exclude: r = [] } = t;
    typeof r == "string" && (r = [...r]);
    let i = [...eR];
    switch (n) {
      case "upper": {
        i.push(...N0);
        break;
      }
      case "lower": {
        i.push(...D0);
        break;
      }
      case "mixed": {
        i.push(...D0, ...N0);
        break;
      }
    }
    return i = i.filter((s) => !r.includes(s)), this.fromCharacters(i, e);
  }
  binary(t = {}) {
    let { prefix: e = "0b" } = t, n = e;
    return n += this.fromCharacters(["0", "1"], t.length ?? 1), n;
  }
  octal(t = {}) {
    let { prefix: e = "0o" } = t, n = e;
    return n += this.fromCharacters(["0", "1", "2", "3", "4", "5", "6", "7"], t.length ?? 1), n;
  }
  hexadecimal(t = {}) {
    let { casing: e = "mixed", prefix: n = "0x" } = t, r = this.faker.helpers.rangeToNumber(t.length ?? 1);
    if (r <= 0) return n;
    let i = this.fromCharacters(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "A", "B", "C", "D", "E", "F"], r);
    return e === "upper" ? i = i.toUpperCase() : e === "lower" && (i = i.toLowerCase()), `${n}${i}`;
  }
  numeric(t = {}) {
    typeof t == "number" && (t = { length: t });
    let e = this.faker.helpers.rangeToNumber(t.length ?? 1);
    if (e <= 0) return "";
    let { allowLeadingZeros: n = !0 } = t, { exclude: r = [] } = t;
    typeof r == "string" && (r = [...r]);
    let i = eR.filter((a) => !r.includes(a));
    if (i.length === 0 || i.length === 1 && !n && i[0] === "0") throw new ft("Unable to generate numeric string, because all possible digits are excluded.");
    let s = "";
    return !n && !r.includes("0") && (s += this.faker.helpers.arrayElement(i.filter((a) => a !== "0"))), s += this.fromCharacters(i, e - s.length), s;
  }
  sample(t = 10) {
    t = this.faker.helpers.rangeToNumber(t);
    let e = { min: 33, max: 125 }, n = "";
    for (; n.length < t; ) n += String.fromCodePoint(this.faker.number.int(e));
    return n;
  }
  uuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replaceAll("x", () => this.faker.number.hex({ min: 0, max: 15 })).replaceAll("y", () => this.faker.number.hex({ min: 8, max: 11 }));
  }
  ulid(t = {}) {
    let { refDate: e = this.faker.defaultRefDate() } = t, n = Ru(e);
    return SCe(n) + this.fromCharacters(uH, 16);
  }
  nanoid(t = 21) {
    if (t = this.faker.helpers.rangeToNumber(t), t <= 0) return "";
    let e = [{ value: () => this.alphanumeric(1), weight: 62 }, { value: () => this.faker.helpers.arrayElement(["_", "-"]), weight: 2 }], n = "";
    for (; n.length < t; ) {
      let r = this.faker.helpers.weightedArrayElement(e);
      n += r();
    }
    return n;
  }
  symbol(t = 1) {
    return this.fromCharacters(["!", '"', "#", "$", "%", "&", "'", "(", ")", "*", "+", ",", "-", ".", "/", ":", ";", "<", "=", ">", "?", "@", "[", "\\", "]", "^", "_", "`", "{", "|", "}", "~"], t);
  }
}, lH = class {
  _defaultRefDate = () => /* @__PURE__ */ new Date();
  get defaultRefDate() {
    return this._defaultRefDate;
  }
  setDefaultRefDate(t = () => /* @__PURE__ */ new Date()) {
    typeof t == "function" ? this._defaultRefDate = t : this._defaultRefDate = () => new Date(t);
  }
  _randomizer;
  datatype = new sCe(this);
  date = new iH(this);
  helpers = new aH(this);
  location = new oH(this);
  number = new ECe(this);
  string = new wCe(this);
  constructor(t = {}) {
    let { randomizer: e, seed: n } = t;
    e != null && n != null && e.seed(n), this._randomizer = e ?? iCe(n);
  }
  seed(t = rH()) {
    return this._randomizer.seed(t), t;
  }
};
new lH();
function FCe(t) {
  let e = {};
  for (let n of t) for (let r in n) {
    let i = n[r];
    e[r] === void 0 ? e[r] = { ...i } : e[r] = { ...i, ...e[r] };
  }
  return e;
}
var TCe = class extends Zr {
  dog() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.dog);
  }
  cat() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.cat);
  }
  snake() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.snake);
  }
  bear() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.bear);
  }
  lion() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.lion);
  }
  cetacean() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.cetacean);
  }
  horse() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.horse);
  }
  bird() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.bird);
  }
  cow() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.cow);
  }
  fish() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.fish);
  }
  crocodilia() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.crocodilia);
  }
  insect() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.insect);
  }
  rabbit() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.rabbit);
  }
  rodent() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.rodent);
  }
  type() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.type);
  }
  petName() {
    return this.faker.helpers.arrayElement(this.faker.definitions.animal.pet_name);
  }
}, vCe = class extends Zr {
  author() {
    return this.faker.helpers.arrayElement(this.faker.definitions.book.author);
  }
  format() {
    return this.faker.helpers.arrayElement(this.faker.definitions.book.format);
  }
  genre() {
    return this.faker.helpers.arrayElement(this.faker.definitions.book.genre);
  }
  publisher() {
    return this.faker.helpers.arrayElement(this.faker.definitions.book.publisher);
  }
  series() {
    return this.faker.helpers.arrayElement(this.faker.definitions.book.series);
  }
  title() {
    return this.faker.helpers.arrayElement(this.faker.definitions.book.title);
  }
};
function xCe(t) {
  if (!/^\d{11}$/.test(t)) throw new ft("calculateUPCCheckDigit expects exactly 11 numeric digits");
  let e = 0, n = 0;
  for (let r of t) {
    let i = Number.parseInt(r, 10);
    e += i * (n % 2 === 0 ? 3 : 1), n++;
  }
  return (10 - e % 10) % 10;
}
var CCe = { 0: [[1999999, 2], [2279999, 3], [2289999, 4], [3689999, 3], [3699999, 4], [6389999, 3], [6397999, 4], [6399999, 7], [6449999, 3], [6459999, 7], [6479999, 3], [6489999, 7], [6549999, 3], [6559999, 4], [6999999, 3], [8499999, 4], [8999999, 5], [9499999, 6], [9999999, 7]], 1: [[99999, 3], [299999, 2], [349999, 3], [399999, 4], [499999, 3], [699999, 2], [999999, 4], [3979999, 3], [5499999, 4], [6499999, 5], [6799999, 4], [6859999, 5], [7139999, 4], [7169999, 3], [7319999, 4], [7399999, 7], [7749999, 5], [7753999, 7], [7763999, 5], [7764999, 7], [7769999, 5], [7782999, 7], [7899999, 5], [7999999, 4], [8004999, 5], [8049999, 5], [8379999, 5], [8384999, 7], [8671999, 5], [8675999, 4], [8697999, 5], [9159999, 6], [9165059, 7], [9168699, 6], [9169079, 7], [9195999, 6], [9196549, 7], [9729999, 6], [9877999, 4], [9911499, 6], [9911999, 7], [9989899, 6], [9999999, 7]] }, kCe = class extends Zr {
  department() {
    return this.faker.helpers.arrayElement(this.faker.definitions.commerce.department);
  }
  productName() {
    let t = this.faker.definitions.commerce.product_name.pattern;
    return this.faker.helpers.fake(t);
  }
  price(t = {}) {
    let { dec: e = 2, max: n = 1e3, min: r = 1, symbol: i = "" } = t;
    if (r < 0 || n < 0) return `${i}0`;
    if (r === n) return `${i}${r.toFixed(e)}`;
    let s = this.faker.number.float({ min: r, max: n, fractionDigits: e });
    if (e === 0) return `${i}${s.toFixed(e)}`;
    let a = s * 10 ** e % 10, o = this.faker.helpers.weightedArrayElement([{ weight: 5, value: 9 }, { weight: 3, value: 5 }, { weight: 1, value: 0 }, { weight: 1, value: this.faker.number.int({ min: 0, max: 9 }) }]), u = (1 / 10) ** e, l = a * u, h = o * u, f = s - l + h;
    return r <= f && f <= n ? `${i}${f.toFixed(e)}` : `${i}${s.toFixed(e)}`;
  }
  productAdjective() {
    return this.faker.helpers.arrayElement(this.faker.definitions.commerce.product_name.adjective);
  }
  productMaterial() {
    return this.faker.helpers.arrayElement(this.faker.definitions.commerce.product_name.material);
  }
  product() {
    return this.faker.helpers.arrayElement(this.faker.definitions.commerce.product_name.product);
  }
  productDescription() {
    return this.faker.helpers.fake(this.faker.definitions.commerce.product_description);
  }
  isbn(t = {}) {
    typeof t == "number" && (t = { variant: t });
    let { variant: e = 13, separator: n = "-" } = t, r = "978", [i, s] = this.faker.helpers.objectEntry(CCe), a = this.faker.string.numeric(8), o = Number.parseInt(a.slice(0, -1)), u = s.find(([A]) => o <= A)?.[1];
    if (!u) throw new ft(`Unable to find a registrant length for the group ${i}`);
    let l = a.slice(0, u), h = a.slice(u), f = [r, i, l, h];
    e === 10 && f.shift();
    let m = f.join(""), g = 0;
    for (let A = 0; A < e - 1; A++) {
      let E = e === 10 ? A + 1 : A % 2 ? 3 : 1;
      g += E * Number.parseInt(m[A]);
    }
    return g = e === 10 ? g % 11 : (10 - g % 10) % 10, f.push(g === 10 ? "X" : g.toString()), f.join(n);
  }
  upc(t = {}) {
    let { prefix: e = "" } = t;
    if (e && /\D/.test(e)) throw new ft("Prefix must contain only numeric digits");
    if (e.length > 11) throw new ft("Prefix must be at most 11 numeric digits");
    let n = 11 - e.length, r = this.faker.string.numeric({ length: n, allowLeadingZeros: !0 }), i = `${e}${r}`, s = xCe(i);
    return `${i}${s}`;
  }
}, _Ce = class extends Zr {
  name() {
    return this.faker.helpers.fake(this.faker.definitions.company.name_pattern);
  }
  catchPhrase() {
    return [this.catchPhraseAdjective(), this.catchPhraseDescriptor(), this.catchPhraseNoun()].join(" ");
  }
  buzzPhrase() {
    return [this.buzzVerb(), this.buzzAdjective(), this.buzzNoun()].join(" ");
  }
  catchPhraseAdjective() {
    return this.faker.helpers.arrayElement(this.faker.definitions.company.adjective);
  }
  catchPhraseDescriptor() {
    return this.faker.helpers.arrayElement(this.faker.definitions.company.descriptor);
  }
  catchPhraseNoun() {
    return this.faker.helpers.arrayElement(this.faker.definitions.company.noun);
  }
  buzzAdjective() {
    return this.faker.helpers.arrayElement(this.faker.definitions.company.buzz_adjective);
  }
  buzzVerb() {
    return this.faker.helpers.arrayElement(this.faker.definitions.company.buzz_verb);
  }
  buzzNoun() {
    return this.faker.helpers.arrayElement(this.faker.definitions.company.buzz_noun);
  }
}, NCe = class extends Zr {
  column() {
    return this.faker.helpers.arrayElement(this.faker.definitions.database.column);
  }
  type() {
    return this.faker.helpers.arrayElement(this.faker.definitions.database.type);
  }
  collation() {
    return this.faker.helpers.arrayElement(this.faker.definitions.database.collation);
  }
  engine() {
    return this.faker.helpers.arrayElement(this.faker.definitions.database.engine);
  }
  mongodbObjectId() {
    return this.faker.string.hexadecimal({ length: 24, casing: "lower", prefix: "" });
  }
}, DCe = { alpha: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"], formats: [{ country: "AL", total: 28, bban: [{ type: "n", count: 8 }, { type: "c", count: 16 }], format: "ALkk bbbs sssx cccc cccc cccc cccc" }, { country: "AD", total: 24, bban: [{ type: "n", count: 8 }, { type: "c", count: 12 }], format: "ADkk bbbb ssss cccc cccc cccc" }, { country: "AT", total: 20, bban: [{ type: "n", count: 5 }, { type: "n", count: 11 }], format: "ATkk bbbb bccc cccc cccc" }, { country: "AZ", total: 28, bban: [{ type: "a", count: 4 }, { type: "n", count: 20 }], format: "AZkk bbbb cccc cccc cccc cccc cccc" }, { country: "BH", total: 22, bban: [{ type: "a", count: 4 }, { type: "c", count: 14 }], format: "BHkk bbbb cccc cccc cccc cc" }, { country: "BE", total: 16, bban: [{ type: "n", count: 3 }, { type: "n", count: 9 }], format: "BEkk bbbc cccc ccxx" }, { country: "BA", total: 20, bban: [{ type: "n", count: 6 }, { type: "n", count: 10 }], format: "BAkk bbbs sscc cccc ccxx" }, { country: "BR", total: 29, bban: [{ type: "n", count: 13 }, { type: "n", count: 10 }, { type: "a", count: 1 }, { type: "c", count: 1 }], format: "BRkk bbbb bbbb ssss sccc cccc ccct n" }, { country: "BG", total: 22, bban: [{ type: "a", count: 4 }, { type: "n", count: 6 }, { type: "c", count: 8 }], format: "BGkk bbbb ssss ddcc cccc cc" }, { country: "CR", total: 22, bban: [{ type: "n", count: 1 }, { type: "n", count: 3 }, { type: "n", count: 14 }], format: "CRkk xbbb cccc cccc cccc cc" }, { country: "HR", total: 21, bban: [{ type: "n", count: 7 }, { type: "n", count: 10 }], format: "HRkk bbbb bbbc cccc cccc c" }, { country: "CY", total: 28, bban: [{ type: "n", count: 8 }, { type: "c", count: 16 }], format: "CYkk bbbs ssss cccc cccc cccc cccc" }, { country: "CZ", total: 24, bban: [{ type: "n", count: 10 }, { type: "n", count: 10 }], format: "CZkk bbbb ssss sscc cccc cccc" }, { country: "DK", total: 18, bban: [{ type: "n", count: 4 }, { type: "n", count: 10 }], format: "DKkk bbbb cccc cccc cc" }, { country: "DO", total: 28, bban: [{ type: "a", count: 4 }, { type: "n", count: 20 }], format: "DOkk bbbb cccc cccc cccc cccc cccc" }, { country: "TL", total: 23, bban: [{ type: "n", count: 3 }, { type: "n", count: 16 }], format: "TLkk bbbc cccc cccc cccc cxx" }, { country: "EE", total: 20, bban: [{ type: "n", count: 4 }, { type: "n", count: 12 }], format: "EEkk bbss cccc cccc cccx" }, { country: "FO", total: 18, bban: [{ type: "n", count: 4 }, { type: "n", count: 10 }], format: "FOkk bbbb cccc cccc cx" }, { country: "FI", total: 18, bban: [{ type: "n", count: 6 }, { type: "n", count: 8 }], format: "FIkk bbbb bbcc cccc cx" }, { country: "FR", total: 27, bban: [{ type: "n", count: 10 }, { type: "c", count: 11 }, { type: "n", count: 2 }], format: "FRkk bbbb bggg ggcc cccc cccc cxx" }, { country: "GE", total: 22, bban: [{ type: "a", count: 2 }, { type: "n", count: 16 }], format: "GEkk bbcc cccc cccc cccc cc" }, { country: "DE", total: 22, bban: [{ type: "n", count: 8 }, { type: "n", count: 10 }], format: "DEkk bbbb bbbb cccc cccc cc" }, { country: "GI", total: 23, bban: [{ type: "a", count: 4 }, { type: "c", count: 15 }], format: "GIkk bbbb cccc cccc cccc ccc" }, { country: "GR", total: 27, bban: [{ type: "n", count: 7 }, { type: "c", count: 16 }], format: "GRkk bbbs sssc cccc cccc cccc ccc" }, { country: "GL", total: 18, bban: [{ type: "n", count: 4 }, { type: "n", count: 10 }], format: "GLkk bbbb cccc cccc cc" }, { country: "GT", total: 28, bban: [{ type: "c", count: 4 }, { type: "c", count: 4 }, { type: "c", count: 16 }], format: "GTkk bbbb mmtt cccc cccc cccc cccc" }, { country: "HU", total: 28, bban: [{ type: "n", count: 8 }, { type: "n", count: 16 }], format: "HUkk bbbs sssk cccc cccc cccc cccx" }, { country: "IS", total: 26, bban: [{ type: "n", count: 6 }, { type: "n", count: 16 }], format: "ISkk bbbb sscc cccc iiii iiii ii" }, { country: "IE", total: 22, bban: [{ type: "a", count: 4 }, { type: "n", count: 6 }, { type: "n", count: 8 }], format: "IEkk aaaa bbbb bbcc cccc cc" }, { country: "IL", total: 23, bban: [{ type: "n", count: 6 }, { type: "n", count: 13 }], format: "ILkk bbbn nncc cccc cccc ccc" }, { country: "IR", total: 26, bban: [{ type: "n", count: 22 }], format: "IRkk bbbb cccc cccc cccc cccc cc" }, { country: "IT", total: 27, bban: [{ type: "a", count: 1 }, { type: "n", count: 10 }, { type: "c", count: 12 }], format: "ITkk xaaa aabb bbbc cccc cccc ccc" }, { country: "JO", total: 30, bban: [{ type: "a", count: 4 }, { type: "n", count: 4 }, { type: "n", count: 18 }], format: "JOkk bbbb nnnn cccc cccc cccc cccc cc" }, { country: "KZ", total: 20, bban: [{ type: "n", count: 3 }, { type: "c", count: 13 }], format: "KZkk bbbc cccc cccc cccc" }, { country: "XK", total: 20, bban: [{ type: "n", count: 4 }, { type: "n", count: 12 }], format: "XKkk bbbb cccc cccc cccc" }, { country: "KW", total: 30, bban: [{ type: "a", count: 4 }, { type: "c", count: 22 }], format: "KWkk bbbb cccc cccc cccc cccc cccc cc" }, { country: "LV", total: 21, bban: [{ type: "a", count: 4 }, { type: "c", count: 13 }], format: "LVkk bbbb cccc cccc cccc c" }, { country: "LB", total: 28, bban: [{ type: "n", count: 4 }, { type: "c", count: 20 }], format: "LBkk bbbb cccc cccc cccc cccc cccc" }, { country: "LI", total: 21, bban: [{ type: "n", count: 5 }, { type: "c", count: 12 }], format: "LIkk bbbb bccc cccc cccc c" }, { country: "LT", total: 20, bban: [{ type: "n", count: 5 }, { type: "n", count: 11 }], format: "LTkk bbbb bccc cccc cccc" }, { country: "LU", total: 20, bban: [{ type: "n", count: 3 }, { type: "c", count: 13 }], format: "LUkk bbbc cccc cccc cccc" }, { country: "MK", total: 19, bban: [{ type: "n", count: 3 }, { type: "c", count: 10 }, { type: "n", count: 2 }], format: "MKkk bbbc cccc cccc cxx" }, { country: "MT", total: 31, bban: [{ type: "a", count: 4 }, { type: "n", count: 5 }, { type: "c", count: 18 }], format: "MTkk bbbb ssss sccc cccc cccc cccc ccc" }, { country: "MR", total: 27, bban: [{ type: "n", count: 10 }, { type: "n", count: 13 }], format: "MRkk bbbb bsss sscc cccc cccc cxx" }, { country: "MU", total: 30, bban: [{ type: "a", count: 4 }, { type: "n", count: 4 }, { type: "n", count: 15 }, { type: "a", count: 3 }], format: "MUkk bbbb bbss cccc cccc cccc 000d dd" }, { country: "MC", total: 27, bban: [{ type: "n", count: 10 }, { type: "c", count: 11 }, { type: "n", count: 2 }], format: "MCkk bbbb bsss sscc cccc cccc cxx" }, { country: "MD", total: 24, bban: [{ type: "c", count: 2 }, { type: "c", count: 18 }], format: "MDkk bbcc cccc cccc cccc cccc" }, { country: "ME", total: 22, bban: [{ type: "n", count: 3 }, { type: "n", count: 15 }], format: "MEkk bbbc cccc cccc cccc xx" }, { country: "NL", total: 18, bban: [{ type: "a", count: 4 }, { type: "n", count: 10 }], format: "NLkk bbbb cccc cccc cc" }, { country: "NO", total: 15, bban: [{ type: "n", count: 4 }, { type: "n", count: 7 }], format: "NOkk bbbb cccc ccx" }, { country: "PK", total: 24, bban: [{ type: "a", count: 4 }, { type: "n", count: 16 }], format: "PKkk bbbb cccc cccc cccc cccc" }, { country: "PS", total: 29, bban: [{ type: "a", count: 4 }, { type: "n", count: 9 }, { type: "n", count: 12 }], format: "PSkk bbbb xxxx xxxx xccc cccc cccc c" }, { country: "PL", total: 28, bban: [{ type: "n", count: 8 }, { type: "n", count: 16 }], format: "PLkk bbbs sssx cccc cccc cccc cccc" }, { country: "PT", total: 25, bban: [{ type: "n", count: 8 }, { type: "n", count: 13 }], format: "PTkk bbbb ssss cccc cccc cccx x" }, { country: "QA", total: 29, bban: [{ type: "a", count: 4 }, { type: "c", count: 21 }], format: "QAkk bbbb cccc cccc cccc cccc cccc c" }, { country: "RO", total: 24, bban: [{ type: "a", count: 4 }, { type: "c", count: 16 }], format: "ROkk bbbb cccc cccc cccc cccc" }, { country: "SM", total: 27, bban: [{ type: "a", count: 1 }, { type: "n", count: 10 }, { type: "c", count: 12 }], format: "SMkk xaaa aabb bbbc cccc cccc ccc" }, { country: "SA", total: 24, bban: [{ type: "n", count: 2 }, { type: "c", count: 18 }], format: "SAkk bbcc cccc cccc cccc cccc" }, { country: "RS", total: 22, bban: [{ type: "n", count: 3 }, { type: "n", count: 15 }], format: "RSkk bbbc cccc cccc cccc xx" }, { country: "SK", total: 24, bban: [{ type: "n", count: 10 }, { type: "n", count: 10 }], format: "SKkk bbbb ssss sscc cccc cccc" }, { country: "SI", total: 19, bban: [{ type: "n", count: 5 }, { type: "n", count: 10 }], format: "SIkk bbss sccc cccc cxx" }, { country: "ES", total: 24, bban: [{ type: "n", count: 10 }, { type: "n", count: 10 }], format: "ESkk bbbb gggg xxcc cccc cccc" }, { country: "SE", total: 24, bban: [{ type: "n", count: 3 }, { type: "n", count: 17 }], format: "SEkk bbbc cccc cccc cccc cccc" }, { country: "CH", total: 21, bban: [{ type: "n", count: 5 }, { type: "c", count: 12 }], format: "CHkk bbbb bccc cccc cccc c" }, { country: "TN", total: 24, bban: [{ type: "n", count: 5 }, { type: "n", count: 15 }], format: "TNkk bbss sccc cccc cccc cccc" }, { country: "TR", total: 26, bban: [{ type: "n", count: 5 }, { type: "n", count: 1 }, { type: "n", count: 16 }], format: "TRkk bbbb bxcc cccc cccc cccc cc" }, { country: "AE", total: 23, bban: [{ type: "n", count: 3 }, { type: "n", count: 16 }], format: "AEkk bbbc cccc cccc cccc ccc" }, { country: "GB", total: 22, bban: [{ type: "a", count: 4 }, { type: "n", count: 6 }, { type: "n", count: 8 }], format: "GBkk bbbb ssss sscc cccc cc" }, { country: "VG", total: 24, bban: [{ type: "a", count: 4 }, { type: "n", count: 16 }], format: "VGkk bbbb cccc cccc cccc cccc" }], iso3166: ["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "XK", "YE", "YT", "ZA", "ZM", "ZW"], mod97: (t) => {
  let e = 0;
  for (let n of t) e = (e * 10 + +n) % 97;
  return e;
}, pattern10: ["01", "02", "03", "04", "05", "06", "07", "08", "09"], pattern100: ["001", "002", "003", "004", "005", "006", "007", "008", "009"], toDigitString: (t) => t.replaceAll(/[A-Z]/gi, (e) => String((e.toUpperCase().codePointAt(0) ?? Number.NaN) - 55)) }, Cu = DCe;
function ICe(t) {
  let e = "";
  for (let n = 0; n < t.length; n += 4) e += `${t.substring(n, n + 4)} `;
  return e.trimEnd();
}
var RCe = class extends Zr {
  accountNumber(t = {}) {
    typeof t == "number" && (t = { length: t });
    let { length: e = 8 } = t;
    return this.faker.string.numeric({ length: e, allowLeadingZeros: !0 });
  }
  accountName() {
    return [this.faker.helpers.arrayElement(this.faker.definitions.finance.account_type), "Account"].join(" ");
  }
  routingNumber() {
    let t = this.faker.string.numeric({ length: 8, allowLeadingZeros: !0 }), e = 0;
    for (let n = 0; n < t.length; n += 3) e += Number(t[n]) * 3, e += Number(t[n + 1]) * 7, e += Number(t[n + 2]) || 0;
    return `${t}${Math.ceil(e / 10) * 10 - e}`;
  }
  amount(t = {}) {
    let { autoFormat: e = !1, dec: n = 2, max: r = 1e3, min: i = 0, symbol: s = "" } = t, a = this.faker.number.float({ max: r, min: i, fractionDigits: n }), o = e ? a.toLocaleString(void 0, { minimumFractionDigits: n }) : a.toFixed(n);
    return s + o;
  }
  transactionType() {
    return this.faker.helpers.arrayElement(this.faker.definitions.finance.transaction_type);
  }
  currency() {
    return this.faker.helpers.arrayElement(this.faker.definitions.finance.currency);
  }
  currencyCode() {
    return this.currency().code;
  }
  currencyName() {
    return this.currency().name;
  }
  currencySymbol() {
    let t;
    do
      t = this.currency().symbol;
    while (t.length === 0);
    return t;
  }
  currencyNumericCode() {
    return this.currency().numericCode;
  }
  bitcoinAddress(t = {}) {
    let { type: e = this.faker.helpers.enumValue(X$), network: n = "mainnet" } = t, r = Wxe[e], i = r.prefix[n], s = this.faker.number.int(r.length), a = this.faker.string.alphanumeric({ length: s - i.length, casing: r.casing, exclude: r.exclude });
    return i + a;
  }
  litecoinAddress() {
    let t = this.faker.number.int({ min: 26, max: 33 });
    return this.faker.string.fromCharacters("LM3") + this.faker.string.fromCharacters("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ", t - 1);
  }
  creditCardNumber(t = {}) {
    typeof t == "string" && (t = { issuer: t });
    let { issuer: e = "" } = t, n, r = this.faker.definitions.finance.credit_card, i = e.toLowerCase();
    if (i in r) n = this.faker.helpers.arrayElement(r[i]);
    else if (e.includes("#")) n = e;
    else {
      let s = this.faker.helpers.objectValue(r);
      n = this.faker.helpers.arrayElement(s);
    }
    return n = n.replaceAll("/", ""), this.faker.helpers.replaceCreditCardSymbols(n);
  }
  creditCardCVV() {
    return this.faker.string.numeric({ length: 3, allowLeadingZeros: !0 });
  }
  creditCardIssuer() {
    return this.faker.helpers.objectKey(this.faker.definitions.finance.credit_card);
  }
  pin(t = {}) {
    typeof t == "number" && (t = { length: t });
    let { length: e = 4 } = t;
    if (e < 1) throw new ft("minimum length is 1");
    return this.faker.string.numeric({ length: e, allowLeadingZeros: !0 });
  }
  ethereumAddress() {
    return this.faker.string.hexadecimal({ length: 40, casing: "lower" });
  }
  iban(t = {}) {
    let { countryCode: e, formatted: n = !1 } = t, r = e ? Cu.formats.find((u) => u.country === e) : this.faker.helpers.arrayElement(Cu.formats);
    if (!r) throw new ft(`Country code ${e} not supported.`);
    let i = "", s = 0;
    for (let u of r.bban) {
      let l = u.count;
      for (s += u.count; l > 0; ) u.type === "a" ? i += this.faker.helpers.arrayElement(Cu.alpha) : u.type === "c" ? this.faker.datatype.boolean(0.8) ? i += this.faker.number.int(9) : i += this.faker.helpers.arrayElement(Cu.alpha) : l >= 3 && this.faker.datatype.boolean(0.3) ? this.faker.datatype.boolean() ? (i += this.faker.helpers.arrayElement(Cu.pattern100), l -= 2) : (i += this.faker.helpers.arrayElement(Cu.pattern10), l--) : i += this.faker.number.int(9), l--;
      i = i.substring(0, s);
    }
    let a = 98 - Cu.mod97(Cu.toDigitString(`${i}${r.country}00`));
    a < 10 && (a = `0${a}`);
    let o = `${r.country}${a}${i}`;
    return n ? ICe(o) : o;
  }
  bic(t = {}) {
    let { includeBranchCode: e = this.faker.datatype.boolean() } = t, n = this.faker.string.alpha({ length: 4, casing: "upper" }), r = this.faker.helpers.arrayElement(Cu.iso3166), i = this.faker.string.alphanumeric({ length: 2, casing: "upper" }), s = e ? this.faker.datatype.boolean() ? this.faker.string.alphanumeric({ length: 3, casing: "upper" }) : "XXX" : "";
    return `${n}${r}${i}${s}`;
  }
  transactionDescription() {
    return this.faker.helpers.fake(this.faker.definitions.finance.transaction_description_pattern);
  }
};
function tR(t) {
  return t.split(" ").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
var PCe = class extends Zr {
  adjective() {
    return this.faker.helpers.arrayElement(this.faker.definitions.food.adjective);
  }
  description() {
    return this.faker.helpers.fake(this.faker.definitions.food.description_pattern);
  }
  dish() {
    return this.faker.datatype.boolean() ? tR(this.faker.helpers.fake(this.faker.definitions.food.dish_pattern)) : tR(this.faker.helpers.arrayElement(this.faker.definitions.food.dish));
  }
  ethnicCategory() {
    return this.faker.helpers.arrayElement(this.faker.definitions.food.ethnic_category);
  }
  fruit() {
    return this.faker.helpers.arrayElement(this.faker.definitions.food.fruit);
  }
  ingredient() {
    return this.faker.helpers.arrayElement(this.faker.definitions.food.ingredient);
  }
  meat() {
    return this.faker.helpers.arrayElement(this.faker.definitions.food.meat);
  }
  spice() {
    return this.faker.helpers.arrayElement(this.faker.definitions.food.spice);
  }
  vegetable() {
    return this.faker.helpers.arrayElement(this.faker.definitions.food.vegetable);
  }
}, LCe = " ", MCe = class extends Zr {
  branch() {
    let t = this.faker.hacker.noun().replace(" ", "-"), e = this.faker.hacker.verb().replace(" ", "-");
    return `${t}-${e}`;
  }
  commitEntry(t = {}) {
    let { merge: e = this.faker.datatype.boolean({ probability: 0.2 }), eol: n = "CRLF", refDate: r } = t, i = [`commit ${this.faker.git.commitSha()}`];
    e && i.push(`Merge: ${this.commitSha({ length: 7 })} ${this.commitSha({ length: 7 })}`);
    let s = this.faker.person.firstName(), a = this.faker.person.lastName(), o = this.faker.person.fullName({ firstName: s, lastName: a }), u = this.faker.internet.username({ firstName: s, lastName: a }), l = this.faker.helpers.arrayElement([o, u]), h = this.faker.internet.email({ firstName: s, lastName: a });
    l = l.replaceAll(/^[.,:;"\\']|[<>\n]|[.,:;"\\']$/g, ""), i.push(`Author: ${l} <${h}>`, `Date: ${this.commitDate({ refDate: r })}`, "", `${LCe.repeat(4)}${this.commitMessage()}`, "");
    let f = n === "CRLF" ? `\r
` : `
`;
    return i.join(f);
  }
  commitMessage() {
    return `${this.faker.hacker.verb()} ${this.faker.hacker.adjective()} ${this.faker.hacker.noun()}`;
  }
  commitDate(t = {}) {
    let { refDate: e = this.faker.defaultRefDate() } = t, n = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], r = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], i = this.faker.date.recent({ days: 1, refDate: e }), s = n[i.getUTCDay()], a = r[i.getUTCMonth()], o = i.getUTCDate(), u = i.getUTCHours().toString().padStart(2, "0"), l = i.getUTCMinutes().toString().padStart(2, "0"), h = i.getUTCSeconds().toString().padStart(2, "0"), f = i.getUTCFullYear(), m = this.faker.number.int({ min: -11, max: 12 }), g = Math.abs(m).toString().padStart(2, "0"), A = "00", E = m >= 0 ? "+" : "-";
    return `${s} ${a} ${o} ${u}:${l}:${h} ${f} ${E}${g}${A}`;
  }
  commitSha(t = {}) {
    let { length: e = 40 } = t;
    return this.faker.string.hexadecimal({ length: e, casing: "lower", prefix: "" });
  }
}, OCe = class extends Zr {
  abbreviation() {
    return this.faker.helpers.arrayElement(this.faker.definitions.hacker.abbreviation);
  }
  adjective() {
    return this.faker.helpers.arrayElement(this.faker.definitions.hacker.adjective);
  }
  noun() {
    return this.faker.helpers.arrayElement(this.faker.definitions.hacker.noun);
  }
  verb() {
    return this.faker.helpers.arrayElement(this.faker.definitions.hacker.verb);
  }
  ingverb() {
    return this.faker.helpers.arrayElement(this.faker.definitions.hacker.ingverb);
  }
  phrase() {
    let t = { abbreviation: this.abbreviation, adjective: this.adjective, ingverb: this.ingverb, noun: this.noun, verb: this.verb }, e = this.faker.helpers.arrayElement(this.faker.definitions.hacker.phrase);
    return this.faker.helpers.mustache(e, t);
  }
};
function BCe(t) {
  let { deprecated: e, since: n, until: r, proposed: i } = t, s = `[@faker-js/faker]: ${e} is deprecated`;
  n && (s += ` since v${n}`), r && (s += ` and will be removed in v${r}`), i && (s += `. Please use ${i} instead`), console.warn(`${s}.`);
}
var $Ce = class extends Zr {
  avatar() {
    return this.faker.helpers.arrayElement([this.personPortrait, this.avatarGitHub])();
  }
  avatarGitHub() {
    return `https://avatars.githubusercontent.com/u/${this.faker.number.int(1e8)}`;
  }
  personPortrait(t = {}) {
    let { sex: e = this.faker.person.sexType(), size: n = 512 } = t;
    return `https://cdn.jsdelivr.net/gh/faker-js/assets-person-portrait/${e}/${n}/${this.faker.number.int({ min: 0, max: 99 })}.jpg`;
  }
  url(t = {}) {
    let { width: e = this.faker.number.int({ min: 1, max: 3999 }), height: n = this.faker.number.int({ min: 1, max: 3999 }) } = t;
    return this.faker.helpers.arrayElement([({ width: r, height: i }) => this.urlPicsumPhotos({ width: r, height: i, grayscale: !1, blur: 0 })])({ width: e, height: n });
  }
  urlLoremFlickr(t = {}) {
    BCe({ deprecated: "faker.image.urlLoremFlickr()", proposed: "faker.image.url()", since: "10.1.0", until: "11.0.0" });
    let { width: e = this.faker.number.int({ min: 1, max: 3999 }), height: n = this.faker.number.int({ min: 1, max: 3999 }), category: r } = t;
    return `https://loremflickr.com/${e}/${n}${r == null ? "" : `/${r}`}?lock=${this.faker.number.int()}`;
  }
  urlPicsumPhotos(t = {}) {
    let { width: e = this.faker.number.int({ min: 1, max: 3999 }), height: n = this.faker.number.int({ min: 1, max: 3999 }), grayscale: r = this.faker.datatype.boolean(), blur: i = this.faker.number.int({ max: 10 }) } = t, s = `https://picsum.photos/seed/${this.faker.string.alphanumeric({ length: { min: 5, max: 10 } })}/${e}/${n}`, a = typeof i == "number" && i >= 1 && i <= 10;
    return (r || a) && (s += "?", r && (s += "grayscale"), r && a && (s += "&"), a && (s += `blur=${i}`)), s;
  }
  dataUri(t = {}) {
    let { width: e = this.faker.number.int({ min: 1, max: 3999 }), height: n = this.faker.number.int({ min: 1, max: 3999 }), color: r = this.faker.color.rgb(), type: i = this.faker.helpers.arrayElement(["svg-uri", "svg-base64"]) } = t, s = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" baseProfile="full" width="${e}" height="${n}"><rect width="100%" height="100%" fill="${r}"/><text x="${e / 2}" y="${n / 2}" font-size="20" alignment-baseline="middle" text-anchor="middle" fill="white">${e}x${n}</text></svg>`;
    return i === "svg-uri" ? `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(s)}` : `data:image/svg+xml;base64,${Z$(s)}`;
  }
};
function HCe(t, e, n = (r) => r) {
  let r = {};
  for (let i of t) {
    let s = e(i);
    r[s] === void 0 && (r[s] = []), r[s].push(n(i));
  }
  return r;
}
var Aw = { fail: () => {
  throw new ft("No words found that match the given length.");
}, closest: (t, e) => {
  let n = HCe(t, (o) => o.length), r = Object.keys(n).map(Number), i = Math.min(...r), s = Math.max(...r), a = Math.min(e.min - i, s - e.max);
  return t.filter((o) => o.length === e.min - a || o.length === e.max + a);
}, shortest: (t) => {
  let e = Math.min(...t.map((n) => n.length));
  return t.filter((n) => n.length === e);
}, longest: (t) => {
  let e = Math.max(...t.map((n) => n.length));
  return t.filter((n) => n.length === e);
}, "any-length": (t) => [...t] };
function wl(t) {
  let { wordList: e, length: n, strategy: r = "fail" } = t;
  if (n != null) {
    let i = typeof n == "number" ? (a) => a.length === n : (a) => a.length >= n.min && a.length <= n.max, s = e.filter(i);
    return s.length > 0 ? s : typeof n == "number" ? Aw[r](e, { min: n, max: n }) : Aw[r](e, n);
  } else if (r === "shortest" || r === "longest") return Aw[r](e);
  return [...e];
}
var UCe = class extends Zr {
  word(t = {}) {
    return typeof t == "number" && (t = { length: t }), this.faker.helpers.arrayElement(wl({ ...t, wordList: this.faker.definitions.lorem.word }));
  }
  words(t = 3) {
    return this.faker.helpers.multiple(() => this.word(), { count: t }).join(" ");
  }
  sentence(t = { min: 3, max: 10 }) {
    let e = this.words(t);
    return `${e.charAt(0).toUpperCase() + e.substring(1)}.`;
  }
  slug(t = 3) {
    let e = this.words(t);
    return this.faker.helpers.slugify(e);
  }
  sentences(t = { min: 2, max: 6 }, e = " ") {
    return this.faker.helpers.multiple(() => this.sentence(), { count: t }).join(e);
  }
  paragraph(t = 3) {
    return this.sentences(t);
  }
  paragraphs(t = 3, e = `
`) {
    return this.faker.helpers.multiple(() => this.paragraph(), { count: t }).join(e);
  }
  text() {
    let t = ["sentence", "sentences", "paragraph", "paragraphs", "lines"], e = this.faker.helpers.arrayElement(t);
    return this[e]();
  }
  lines(t = { min: 1, max: 5 }) {
    return this.sentences(t, `
`);
  }
}, GCe = class extends Zr {
  album() {
    return this.faker.helpers.arrayElement(this.faker.definitions.music.album);
  }
  artist() {
    return this.faker.helpers.arrayElement(this.faker.definitions.music.artist);
  }
  genre() {
    return this.faker.helpers.arrayElement(this.faker.definitions.music.genre);
  }
  songName() {
    return this.faker.helpers.arrayElement(this.faker.definitions.music.song_name);
  }
}, WCe = class extends Zr {
  number(t = {}) {
    let { style: e = "human" } = t, n = this.faker.definitions.phone_number.format[e];
    if (!n) throw new Error(`No definitions for ${e} in this locale`);
    let r = this.faker.helpers.arrayElement(n);
    return sH(this.faker, r);
  }
  imei() {
    return this.faker.helpers.replaceCreditCardSymbols("##-######-######-L", "#");
  }
}, VCe = class extends Zr {
  chemicalElement() {
    return this.faker.helpers.arrayElement(this.faker.definitions.science.chemical_element);
  }
  unit() {
    return this.faker.helpers.arrayElement(this.faker.definitions.science.unit);
  }
}, KCe = ["video", "audio", "image", "text", "application"], zCe = ["application/pdf", "audio/mpeg", "audio/wav", "image/png", "image/jpeg", "image/gif", "video/mp4", "video/mpeg", "text/html"], jCe = ["en", "wl", "ww"], nR = { index: "o", slot: "s", mac: "x", pci: "p" }, YCe = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"], qCe = class extends Zr {
  fileName(t = {}) {
    let { extensionCount: e = 1 } = t, n = this.faker.word.words().toLowerCase().replaceAll(/\W/g, "_"), r = this.faker.helpers.multiple(() => this.fileExt(), { count: e }).join(".");
    return r.length === 0 ? n : `${n}.${r}`;
  }
  commonFileName(t) {
    return `${this.fileName({ extensionCount: 0 })}.${t || this.commonFileExt()}`;
  }
  mimeType() {
    let t = Object.keys(this.faker.definitions.system.mime_type);
    return this.faker.helpers.arrayElement(t);
  }
  commonFileType() {
    return this.faker.helpers.arrayElement(KCe);
  }
  commonFileExt() {
    return this.fileExt(this.faker.helpers.arrayElement(zCe));
  }
  fileType() {
    let t = this.faker.definitions.system.mime_type, e = new Set(Object.keys(t).map((n) => n.split("/")[0]));
    return this.faker.helpers.arrayElement([...e]);
  }
  fileExt(t) {
    let e = this.faker.definitions.system.mime_type;
    if (typeof t == "string") return this.faker.helpers.arrayElement(e[t].extensions);
    let n = new Set(Object.values(e).flatMap(({ extensions: r }) => r));
    return this.faker.helpers.arrayElement([...n]);
  }
  directoryPath() {
    let t = this.faker.definitions.system.directory_path;
    return this.faker.helpers.arrayElement(t);
  }
  filePath() {
    return `${this.directoryPath()}/${this.fileName()}`;
  }
  semver() {
    return [this.faker.number.int(9), this.faker.number.int(20), this.faker.number.int(20)].join(".");
  }
  networkInterface(t = {}) {
    let { interfaceType: e = this.faker.helpers.arrayElement(jCe), interfaceSchema: n = this.faker.helpers.objectKey(nR) } = t, r, i = "";
    switch (n) {
      case "index": {
        r = this.faker.string.numeric();
        break;
      }
      case "slot": {
        r = `${this.faker.string.numeric()}${this.faker.helpers.maybe(() => `f${this.faker.string.numeric()}`) ?? ""}${this.faker.helpers.maybe(() => `d${this.faker.string.numeric()}`) ?? ""}`;
        break;
      }
      case "mac": {
        r = this.faker.internet.mac("");
        break;
      }
      case "pci": {
        i = this.faker.helpers.maybe(() => `P${this.faker.string.numeric()}`) ?? "", r = `${this.faker.string.numeric()}s${this.faker.string.numeric()}${this.faker.helpers.maybe(() => `f${this.faker.string.numeric()}`) ?? ""}${this.faker.helpers.maybe(() => `d${this.faker.string.numeric()}`) ?? ""}`;
        break;
      }
    }
    return `${i}${e}${nR[n]}${r}`;
  }
  cron(t = {}) {
    let { includeYear: e = !1, includeNonStandard: n = !1 } = t, r = [this.faker.number.int(59), "*"], i = [this.faker.number.int(23), "*"], s = [this.faker.number.int({ min: 1, max: 31 }), "*", "?"], a = [this.faker.number.int({ min: 1, max: 12 }), "*"], o = [this.faker.number.int(6), this.faker.helpers.arrayElement(YCe), "*", "?"], u = [this.faker.number.int({ min: 1970, max: 2099 }), "*"], l = this.faker.helpers.arrayElement(r), h = this.faker.helpers.arrayElement(i), f = this.faker.helpers.arrayElement(s), m = this.faker.helpers.arrayElement(a), g = this.faker.helpers.arrayElement(o), A = this.faker.helpers.arrayElement(u), E = `${l} ${h} ${f} ${m} ${g}`;
    e && (E += ` ${A}`);
    let w = ["@annually", "@daily", "@hourly", "@monthly", "@reboot", "@weekly", "@yearly"];
    return !n || this.faker.datatype.boolean() ? E : this.faker.helpers.arrayElement(w);
  }
}, JCe = class extends Zr {
  vehicle() {
    return `${this.manufacturer()} ${this.model()}`;
  }
  manufacturer() {
    return this.faker.helpers.arrayElement(this.faker.definitions.vehicle.manufacturer);
  }
  model() {
    return this.faker.helpers.arrayElement(this.faker.definitions.vehicle.model);
  }
  type() {
    return this.faker.helpers.arrayElement(this.faker.definitions.vehicle.type);
  }
  fuel() {
    return this.faker.helpers.arrayElement(this.faker.definitions.vehicle.fuel);
  }
  vin() {
    let t = ["o", "i", "q", "O", "I", "Q"];
    return `${this.faker.string.alphanumeric({ length: 10, casing: "upper", exclude: t })}${this.faker.string.alpha({ length: 1, casing: "upper", exclude: t })}${this.faker.string.alphanumeric({ length: 1, casing: "upper", exclude: t })}${this.faker.string.numeric({ length: 5, allowLeadingZeros: !0 })}`;
  }
  color() {
    return this.faker.color.human();
  }
  vrm() {
    return `${this.faker.string.alpha({ length: 2, casing: "upper" })}${this.faker.string.numeric({ length: 2, allowLeadingZeros: !0 })}${this.faker.string.alpha({ length: 3, casing: "upper" })}`;
  }
  bicycle() {
    return this.faker.helpers.arrayElement(this.faker.definitions.vehicle.bicycle_type);
  }
}, QCe = class extends Zr {
  adjective(t = {}) {
    return typeof t == "number" && (t = { length: t }), this.faker.helpers.arrayElement(wl({ ...t, wordList: this.faker.definitions.word.adjective }));
  }
  adverb(t = {}) {
    return typeof t == "number" && (t = { length: t }), this.faker.helpers.arrayElement(wl({ ...t, wordList: this.faker.definitions.word.adverb }));
  }
  conjunction(t = {}) {
    return typeof t == "number" && (t = { length: t }), this.faker.helpers.arrayElement(wl({ ...t, wordList: this.faker.definitions.word.conjunction }));
  }
  interjection(t = {}) {
    return typeof t == "number" && (t = { length: t }), this.faker.helpers.arrayElement(wl({ ...t, wordList: this.faker.definitions.word.interjection }));
  }
  noun(t = {}) {
    return typeof t == "number" && (t = { length: t }), this.faker.helpers.arrayElement(wl({ ...t, wordList: this.faker.definitions.word.noun }));
  }
  preposition(t = {}) {
    return typeof t == "number" && (t = { length: t }), this.faker.helpers.arrayElement(wl({ ...t, wordList: this.faker.definitions.word.preposition }));
  }
  verb(t = {}) {
    return typeof t == "number" && (t = { length: t }), this.faker.helpers.arrayElement(wl({ ...t, wordList: this.faker.definitions.word.verb }));
  }
  sample(t = {}) {
    let e = this.faker.helpers.shuffle([this.adjective, this.adverb, this.conjunction, this.interjection, this.noun, this.preposition, this.verb]);
    for (let n of e) try {
      return n(t);
    } catch {
      continue;
    }
    throw new ft("No matching word data available for the current locale");
  }
  words(t = {}) {
    typeof t == "number" && (t = { count: t });
    let { count: e = { min: 1, max: 3 } } = t;
    return this.faker.helpers.multiple(() => this.sample(), { count: e }).join(" ");
  }
}, XCe = class extends lH {
  rawDefinitions;
  definitions;
  airline = new Bxe(this);
  animal = new TCe(this);
  book = new vCe(this);
  color = new Uxe(this);
  commerce = new kCe(this);
  company = new _Ce(this);
  database = new NCe(this);
  date = new uCe(this);
  finance = new RCe(this);
  food = new PCe(this);
  git = new MCe(this);
  hacker = new OCe(this);
  helpers = new yCe(this);
  image = new $Ce(this);
  internet = new Xxe(this);
  location = new ACe(this);
  lorem = new UCe(this);
  music = new GCe(this);
  person = new Zxe(this);
  phone = new WCe(this);
  science = new VCe(this);
  system = new qCe(this);
  vehicle = new JCe(this);
  word = new QCe(this);
  constructor(t) {
    super({ randomizer: t.randomizer, seed: t.seed });
    let { locale: e } = t;
    if (Array.isArray(e)) {
      if (e.length === 0) throw new ft("The locale option must contain at least one locale definition.");
      e = FCe(e);
    }
    this.rawDefinitions = e, this.definitions = aCe(this.rawDefinitions);
  }
  getMetadata() {
    return this.rawDefinitions.metadata ?? {};
  }
}, ZCe = ["Academy Color Encoding System (ACES)", "Adobe RGB", "Adobe Wide Gamut RGB", "British Standard Colour (BS)", "CIE 1931 XYZ", "CIELAB", "CIELUV", "CIEUVW", "CMY", "CMYK", "DCI-P3", "Display-P3", "Federal Standard 595C", "HKS", "HSL", "HSLA", "HSLuv", "HSV", "HWB", "LCh", "LMS", "Munsell Color System", "Natural Color System (NSC)", "Pantone Matching System (PMS)", "ProPhoto RGB Color Space", "RAL", "RG", "RGBA", "RGK", "Rec. 2020", "Rec. 2100", "Rec. 601", "Rec. 709", "Uniform Color Spaces (UCSs)", "YDbDr", "YIQ", "YPbPr", "sRGB", "sYCC", "scRGB", "xvYCC"], e2e = { space: ZCe }, t2e = e2e, n2e = ["ascii_bin", "ascii_general_ci", "cp1250_bin", "cp1250_general_ci", "utf8_bin", "utf8_general_ci", "utf8_unicode_ci"], r2e = ["ARCHIVE", "BLACKHOLE", "CSV", "InnoDB", "MEMORY", "MyISAM"], i2e = ["bigint", "binary", "bit", "blob", "boolean", "date", "datetime", "decimal", "double", "enum", "float", "geometry", "int", "mediumint", "point", "real", "serial", "set", "smallint", "text", "time", "timestamp", "tinyint", "varchar"], s2e = { collation: n2e, engine: r2e, type: i2e }, a2e = s2e, cH = ["Africa/Abidjan", "Africa/Accra", "Africa/Addis_Ababa", "Africa/Algiers", "Africa/Asmara", "Africa/Bamako", "Africa/Bangui", "Africa/Banjul", "Africa/Bissau", "Africa/Blantyre", "Africa/Brazzaville", "Africa/Bujumbura", "Africa/Cairo", "Africa/Casablanca", "Africa/Ceuta", "Africa/Conakry", "Africa/Dakar", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Douala", "Africa/El_Aaiun", "Africa/Freetown", "Africa/Gaborone", "Africa/Harare", "Africa/Johannesburg", "Africa/Juba", "Africa/Kampala", "Africa/Khartoum", "Africa/Kigali", "Africa/Kinshasa", "Africa/Lagos", "Africa/Libreville", "Africa/Lome", "Africa/Luanda", "Africa/Lubumbashi", "Africa/Lusaka", "Africa/Malabo", "Africa/Maputo", "Africa/Maseru", "Africa/Mbabane", "Africa/Mogadishu", "Africa/Monrovia", "Africa/Nairobi", "Africa/Ndjamena", "Africa/Niamey", "Africa/Nouakchott", "Africa/Ouagadougou", "Africa/Porto-Novo", "Africa/Sao_Tome", "Africa/Tripoli", "Africa/Tunis", "Africa/Windhoek", "America/Adak", "America/Anchorage", "America/Anguilla", "America/Antigua", "America/Araguaina", "America/Argentina/Buenos_Aires", "America/Argentina/Catamarca", "America/Argentina/Cordoba", "America/Argentina/Jujuy", "America/Argentina/La_Rioja", "America/Argentina/Mendoza", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Aruba", "America/Asuncion", "America/Atikokan", "America/Bahia", "America/Bahia_Banderas", "America/Barbados", "America/Belem", "America/Belize", "America/Blanc-Sablon", "America/Boa_Vista", "America/Bogota", "America/Boise", "America/Cambridge_Bay", "America/Campo_Grande", "America/Cancun", "America/Caracas", "America/Cayenne", "America/Cayman", "America/Chicago", "America/Chihuahua", "America/Ciudad_Juarez", "America/Costa_Rica", "America/Creston", "America/Cuiaba", "America/Curacao", "America/Danmarkshavn", "America/Dawson", "America/Dawson_Creek", "America/Denver", "America/Detroit", "America/Dominica", "America/Edmonton", "America/Eirunepe", "America/El_Salvador", "America/Fort_Nelson", "America/Fortaleza", "America/Glace_Bay", "America/Goose_Bay", "America/Grand_Turk", "America/Grenada", "America/Guadeloupe", "America/Guatemala", "America/Guayaquil", "America/Guyana", "America/Halifax", "America/Havana", "America/Hermosillo", "America/Indiana/Indianapolis", "America/Indiana/Knox", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Tell_City", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Inuvik", "America/Iqaluit", "America/Jamaica", "America/Juneau", "America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/Kralendijk", "America/La_Paz", "America/Lima", "America/Los_Angeles", "America/Lower_Princes", "America/Maceio", "America/Managua", "America/Manaus", "America/Marigot", "America/Martinique", "America/Matamoros", "America/Mazatlan", "America/Menominee", "America/Merida", "America/Metlakatla", "America/Mexico_City", "America/Miquelon", "America/Moncton", "America/Monterrey", "America/Montevideo", "America/Montserrat", "America/Nassau", "America/New_York", "America/Nome", "America/Noronha", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Nuuk", "America/Ojinaga", "America/Panama", "America/Paramaribo", "America/Phoenix", "America/Port-au-Prince", "America/Port_of_Spain", "America/Porto_Velho", "America/Puerto_Rico", "America/Punta_Arenas", "America/Rankin_Inlet", "America/Recife", "America/Regina", "America/Resolute", "America/Rio_Branco", "America/Santarem", "America/Santiago", "America/Santo_Domingo", "America/Sao_Paulo", "America/Scoresbysund", "America/Sitka", "America/St_Barthelemy", "America/St_Johns", "America/St_Kitts", "America/St_Lucia", "America/St_Thomas", "America/St_Vincent", "America/Swift_Current", "America/Tegucigalpa", "America/Thule", "America/Tijuana", "America/Toronto", "America/Tortola", "America/Vancouver", "America/Whitehorse", "America/Winnipeg", "America/Yakutat", "America/Yellowknife", "Antarctica/Casey", "Antarctica/Davis", "Antarctica/DumontDUrville", "Antarctica/Macquarie", "Antarctica/Mawson", "Antarctica/McMurdo", "Antarctica/Palmer", "Antarctica/Rothera", "Antarctica/Syowa", "Antarctica/Troll", "Antarctica/Vostok", "Arctic/Longyearbyen", "Asia/Aden", "Asia/Almaty", "Asia/Amman", "Asia/Anadyr", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Ashgabat", "Asia/Atyrau", "Asia/Baghdad", "Asia/Bahrain", "Asia/Baku", "Asia/Bangkok", "Asia/Barnaul", "Asia/Beirut", "Asia/Bishkek", "Asia/Brunei", "Asia/Chita", "Asia/Choibalsan", "Asia/Colombo", "Asia/Damascus", "Asia/Dhaka", "Asia/Dili", "Asia/Dubai", "Asia/Dushanbe", "Asia/Famagusta", "Asia/Gaza", "Asia/Hebron", "Asia/Ho_Chi_Minh", "Asia/Hong_Kong", "Asia/Hovd", "Asia/Irkutsk", "Asia/Jakarta", "Asia/Jayapura", "Asia/Jerusalem", "Asia/Kabul", "Asia/Kamchatka", "Asia/Karachi", "Asia/Kathmandu", "Asia/Khandyga", "Asia/Kolkata", "Asia/Krasnoyarsk", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Kuwait", "Asia/Macau", "Asia/Magadan", "Asia/Makassar", "Asia/Manila", "Asia/Muscat", "Asia/Nicosia", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk", "Asia/Oral", "Asia/Phnom_Penh", "Asia/Pontianak", "Asia/Pyongyang", "Asia/Qatar", "Asia/Qostanay", "Asia/Qyzylorda", "Asia/Riyadh", "Asia/Sakhalin", "Asia/Samarkand", "Asia/Seoul", "Asia/Shanghai", "Asia/Singapore", "Asia/Srednekolymsk", "Asia/Taipei", "Asia/Tashkent", "Asia/Tbilisi", "Asia/Tehran", "Asia/Thimphu", "Asia/Tokyo", "Asia/Tomsk", "Asia/Ulaanbaatar", "Asia/Urumqi", "Asia/Ust-Nera", "Asia/Vientiane", "Asia/Vladivostok", "Asia/Yakutsk", "Asia/Yangon", "Asia/Yekaterinburg", "Asia/Yerevan", "Atlantic/Azores", "Atlantic/Bermuda", "Atlantic/Canary", "Atlantic/Cape_Verde", "Atlantic/Faroe", "Atlantic/Madeira", "Atlantic/Reykjavik", "Atlantic/South_Georgia", "Atlantic/St_Helena", "Atlantic/Stanley", "Australia/Adelaide", "Australia/Brisbane", "Australia/Broken_Hill", "Australia/Darwin", "Australia/Eucla", "Australia/Hobart", "Australia/Lindeman", "Australia/Lord_Howe", "Australia/Melbourne", "Australia/Perth", "Australia/Sydney", "Europe/Amsterdam", "Europe/Andorra", "Europe/Astrakhan", "Europe/Athens", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels", "Europe/Bucharest", "Europe/Budapest", "Europe/Busingen", "Europe/Chisinau", "Europe/Copenhagen", "Europe/Dublin", "Europe/Gibraltar", "Europe/Guernsey", "Europe/Helsinki", "Europe/Isle_of_Man", "Europe/Istanbul", "Europe/Jersey", "Europe/Kaliningrad", "Europe/Kirov", "Europe/Kyiv", "Europe/Lisbon", "Europe/Ljubljana", "Europe/London", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Mariehamn", "Europe/Minsk", "Europe/Monaco", "Europe/Moscow", "Europe/Oslo", "Europe/Paris", "Europe/Podgorica", "Europe/Prague", "Europe/Riga", "Europe/Rome", "Europe/Samara", "Europe/San_Marino", "Europe/Sarajevo", "Europe/Saratov", "Europe/Simferopol", "Europe/Skopje", "Europe/Sofia", "Europe/Stockholm", "Europe/Tallinn", "Europe/Tirane", "Europe/Ulyanovsk", "Europe/Vaduz", "Europe/Vatican", "Europe/Vienna", "Europe/Vilnius", "Europe/Volgograd", "Europe/Warsaw", "Europe/Zagreb", "Europe/Zurich", "Indian/Antananarivo", "Indian/Chagos", "Indian/Christmas", "Indian/Cocos", "Indian/Comoro", "Indian/Kerguelen", "Indian/Mahe", "Indian/Maldives", "Indian/Mauritius", "Indian/Mayotte", "Indian/Reunion", "Pacific/Apia", "Pacific/Auckland", "Pacific/Bougainville", "Pacific/Chatham", "Pacific/Chuuk", "Pacific/Easter", "Pacific/Efate", "Pacific/Fakaofo", "Pacific/Fiji", "Pacific/Funafuti", "Pacific/Galapagos", "Pacific/Gambier", "Pacific/Guadalcanal", "Pacific/Guam", "Pacific/Honolulu", "Pacific/Kanton", "Pacific/Kiritimati", "Pacific/Kosrae", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Marquesas", "Pacific/Midway", "Pacific/Nauru", "Pacific/Niue", "Pacific/Norfolk", "Pacific/Noumea", "Pacific/Pago_Pago", "Pacific/Palau", "Pacific/Pitcairn", "Pacific/Pohnpei", "Pacific/Port_Moresby", "Pacific/Rarotonga", "Pacific/Saipan", "Pacific/Tahiti", "Pacific/Tarawa", "Pacific/Tongatapu", "Pacific/Wake", "Pacific/Wallis"], o2e = { time_zone: cH }, u2e = o2e, l2e = ["ADP", "AGP", "AI", "API", "ASCII", "CLI", "COM", "CSS", "DNS", "DRAM", "EXE", "FTP", "GB", "HDD", "HEX", "HTTP", "IB", "IP", "JBOD", "JSON", "OCR", "PCI", "PNG", "RAM", "RSS", "SAS", "SCSI", "SDD", "SMS", "SMTP", "SQL", "SSD", "SSL", "TCP", "THX", "TLS", "UDP", "USB", "UTF8", "VGA", "XML", "XSS"], c2e = { abbreviation: l2e }, h2e = c2e, d2e = { smiley: ["☠️", "☹️", "☺️", "❣️", "❤️", "❤️‍🔥", "❤️‍🩹", "👁️‍🗨️", "👹", "👺", "👻", "👽", "👾", "👿", "💀", "💋", "💌", "💓", "💔", "💕", "💖", "💗", "💘", "💙", "💚", "💛", "💜", "💝", "💞", "💟", "💢", "💣", "💤", "💥", "💦", "💨", "💩", "💫", "💬", "💭", "💯", "🕳️", "🖤", "🗨️", "🗯️", "😀", "😁", "😂", "😃", "😄", "😅", "😆", "😇", "😈", "😉", "😊", "😋", "😌", "😍", "😎", "😏", "😐", "😑", "😒", "😓", "😔", "😕", "😖", "😗", "😘", "😙", "😚", "😛", "😜", "😝", "😞", "😟", "😠", "😡", "😢", "😣", "😤", "😥", "😦", "😧", "😨", "😩", "😪", "😫", "😬", "😭", "😮", "😮‍💨", "😯", "😰", "😱", "😲", "😳", "😴", "😵", "😵‍💫", "😶", "😶‍🌫️", "😷", "😸", "😹", "😺", "😻", "😼", "😽", "😾", "😿", "🙀", "🙁", "🙂", "🙃", "🙄", "🙈", "🙉", "🙊", "🤍", "🤎", "🤐", "🤑", "🤒", "🤓", "🤔", "🤕", "🤖", "🤗", "🤠", "🤡", "🤢", "🤣", "🤤", "🤥", "🤧", "🤨", "🤩", "🤪", "🤫", "🤬", "🤭", "🤮", "🤯", "🥰", "🥱", "🥲", "🥳", "🥴", "🥵", "🥶", "🥸", "🥺", "🧐", "🧡"], body: ["☝🏻", "☝🏼", "☝🏽", "☝🏾", "☝🏿", "☝️", "✊", "✊🏻", "✊🏼", "✊🏽", "✊🏾", "✊🏿", "✋", "✋🏻", "✋🏼", "✋🏽", "✋🏾", "✋🏿", "✌🏻", "✌🏼", "✌🏽", "✌🏾", "✌🏿", "✌️", "✍🏻", "✍🏼", "✍🏽", "✍🏾", "✍🏿", "✍️", "👀", "👁️", "👂", "👂🏻", "👂🏼", "👂🏽", "👂🏾", "👂🏿", "👃", "👃🏻", "👃🏼", "👃🏽", "👃🏾", "👃🏿", "👄", "👅", "👆", "👆🏻", "👆🏼", "👆🏽", "👆🏾", "👆🏿", "👇", "👇🏻", "👇🏼", "👇🏽", "👇🏾", "👇🏿", "👈", "👈🏻", "👈🏼", "👈🏽", "👈🏾", "👈🏿", "👉", "👉🏻", "👉🏼", "👉🏽", "👉🏾", "👉🏿", "👊", "👊🏻", "👊🏼", "👊🏽", "👊🏾", "👊🏿", "👋", "👋🏻", "👋🏼", "👋🏽", "👋🏾", "👋🏿", "👌", "👌🏻", "👌🏼", "👌🏽", "👌🏾", "👌🏿", "👍", "👍🏻", "👍🏼", "👍🏽", "👍🏾", "👍🏿", "👎", "👎🏻", "👎🏼", "👎🏽", "👎🏾", "👎🏿", "👏", "👏🏻", "👏🏼", "👏🏽", "👏🏾", "👏🏿", "👐", "👐🏻", "👐🏼", "👐🏽", "👐🏾", "👐🏿", "💅", "💅🏻", "💅🏼", "💅🏽", "💅🏾", "💅🏿", "💪", "💪🏻", "💪🏼", "💪🏽", "💪🏾", "💪🏿", "🖐🏻", "🖐🏼", "🖐🏽", "🖐🏾", "🖐🏿", "🖐️", "🖕", "🖕🏻", "🖕🏼", "🖕🏽", "🖕🏾", "🖕🏿", "🖖", "🖖🏻", "🖖🏼", "🖖🏽", "🖖🏾", "🖖🏿", "🙌", "🙌🏻", "🙌🏼", "🙌🏽", "🙌🏾", "🙌🏿", "🙏", "🙏🏻", "🙏🏼", "🙏🏽", "🙏🏾", "🙏🏿", "🤌", "🤌🏻", "🤌🏼", "🤌🏽", "🤌🏾", "🤌🏿", "🤏", "🤏🏻", "🤏🏼", "🤏🏽", "🤏🏾", "🤏🏿", "🤘", "🤘🏻", "🤘🏼", "🤘🏽", "🤘🏾", "🤘🏿", "🤙", "🤙🏻", "🤙🏼", "🤙🏽", "🤙🏾", "🤙🏿", "🤚", "🤚🏻", "🤚🏼", "🤚🏽", "🤚🏾", "🤚🏿", "🤛", "🤛🏻", "🤛🏼", "🤛🏽", "🤛🏾", "🤛🏿", "🤜", "🤜🏻", "🤜🏼", "🤜🏽", "🤜🏾", "🤜🏿", "🤝", "🤞", "🤞🏻", "🤞🏼", "🤞🏽", "🤞🏾", "🤞🏿", "🤟", "🤟🏻", "🤟🏼", "🤟🏽", "🤟🏾", "🤟🏿", "🤲", "🤲🏻", "🤲🏼", "🤲🏽", "🤲🏾", "🤲🏿", "🤳", "🤳🏻", "🤳🏼", "🤳🏽", "🤳🏾", "🤳🏿", "🦴", "🦵", "🦵🏻", "🦵🏼", "🦵🏽", "🦵🏾", "🦵🏿", "🦶", "🦶🏻", "🦶🏼", "🦶🏽", "🦶🏾", "🦶🏿", "🦷", "🦻", "🦻🏻", "🦻🏼", "🦻🏽", "🦻🏾", "🦻🏿", "🦾", "🦿", "🧠", "🫀", "🫁"], person: ["🎅", "🎅🏻", "🎅🏼", "🎅🏽", "🎅🏾", "🎅🏿", "👦", "👦🏻", "👦🏼", "👦🏽", "👦🏾", "👦🏿", "👧", "👧🏻", "👧🏼", "👧🏽", "👧🏾", "👧🏿", "👨", "👨‍⚕️", "👨‍⚖️", "👨‍✈️", "👨‍🌾", "👨‍🍳", "👨‍🍼", "👨‍🎓", "👨‍🎤", "👨‍🎨", "👨‍🏫", "👨‍🏭", "👨‍💻", "👨‍💼", "👨‍🔧", "👨‍🔬", "👨‍🚀", "👨‍🚒", "👨‍🦰", "👨‍🦱", "👨‍🦲", "👨‍🦳", "👨🏻", "👨🏻‍⚕️", "👨🏻‍⚖️", "👨🏻‍✈️", "👨🏻‍🌾", "👨🏻‍🍳", "👨🏻‍🍼", "👨🏻‍🎓", "👨🏻‍🎤", "👨🏻‍🎨", "👨🏻‍🏫", "👨🏻‍🏭", "👨🏻‍💻", "👨🏻‍💼", "👨🏻‍🔧", "👨🏻‍🔬", "👨🏻‍🚀", "👨🏻‍🚒", "👨🏻‍🦰", "👨🏻‍🦱", "👨🏻‍🦲", "👨🏻‍🦳", "👨🏼", "👨🏼‍⚕️", "👨🏼‍⚖️", "👨🏼‍✈️", "👨🏼‍🌾", "👨🏼‍🍳", "👨🏼‍🍼", "👨🏼‍🎓", "👨🏼‍🎤", "👨🏼‍🎨", "👨🏼‍🏫", "👨🏼‍🏭", "👨🏼‍💻", "👨🏼‍💼", "👨🏼‍🔧", "👨🏼‍🔬", "👨🏼‍🚀", "👨🏼‍🚒", "👨🏼‍🦰", "👨🏼‍🦱", "👨🏼‍🦲", "👨🏼‍🦳", "👨🏽", "👨🏽‍⚕️", "👨🏽‍⚖️", "👨🏽‍✈️", "👨🏽‍🌾", "👨🏽‍🍳", "👨🏽‍🍼", "👨🏽‍🎓", "👨🏽‍🎤", "👨🏽‍🎨", "👨🏽‍🏫", "👨🏽‍🏭", "👨🏽‍💻", "👨🏽‍💼", "👨🏽‍🔧", "👨🏽‍🔬", "👨🏽‍🚀", "👨🏽‍🚒", "👨🏽‍🦰", "👨🏽‍🦱", "👨🏽‍🦲", "👨🏽‍🦳", "👨🏾", "👨🏾‍⚕️", "👨🏾‍⚖️", "👨🏾‍✈️", "👨🏾‍🌾", "👨🏾‍🍳", "👨🏾‍🍼", "👨🏾‍🎓", "👨🏾‍🎤", "👨🏾‍🎨", "👨🏾‍🏫", "👨🏾‍🏭", "👨🏾‍💻", "👨🏾‍💼", "👨🏾‍🔧", "👨🏾‍🔬", "👨🏾‍🚀", "👨🏾‍🚒", "👨🏾‍🦰", "👨🏾‍🦱", "👨🏾‍🦲", "👨🏾‍🦳", "👨🏿", "👨🏿‍⚕️", "👨🏿‍⚖️", "👨🏿‍✈️", "👨🏿‍🌾", "👨🏿‍🍳", "👨🏿‍🍼", "👨🏿‍🎓", "👨🏿‍🎤", "👨🏿‍🎨", "👨🏿‍🏫", "👨🏿‍🏭", "👨🏿‍💻", "👨🏿‍💼", "👨🏿‍🔧", "👨🏿‍🔬", "👨🏿‍🚀", "👨🏿‍🚒", "👨🏿‍🦰", "👨🏿‍🦱", "👨🏿‍🦲", "👨🏿‍🦳", "👩", "👩‍⚕️", "👩‍⚖️", "👩‍✈️", "👩‍🌾", "👩‍🍳", "👩‍🍼", "👩‍🎓", "👩‍🎤", "👩‍🎨", "👩‍🏫", "👩‍🏭", "👩‍💻", "👩‍💼", "👩‍🔧", "👩‍🔬", "👩‍🚀", "👩‍🚒", "👩‍🦰", "👩‍🦱", "👩‍🦲", "👩‍🦳", "👩🏻", "👩🏻‍⚕️", "👩🏻‍⚖️", "👩🏻‍✈️", "👩🏻‍🌾", "👩🏻‍🍳", "👩🏻‍🍼", "👩🏻‍🎓", "👩🏻‍🎤", "👩🏻‍🎨", "👩🏻‍🏫", "👩🏻‍🏭", "👩🏻‍💻", "👩🏻‍💼", "👩🏻‍🔧", "👩🏻‍🔬", "👩🏻‍🚀", "👩🏻‍🚒", "👩🏻‍🦰", "👩🏻‍🦱", "👩🏻‍🦲", "👩🏻‍🦳", "👩🏼", "👩🏼‍⚕️", "👩🏼‍⚖️", "👩🏼‍✈️", "👩🏼‍🌾", "👩🏼‍🍳", "👩🏼‍🍼", "👩🏼‍🎓", "👩🏼‍🎤", "👩🏼‍🎨", "👩🏼‍🏫", "👩🏼‍🏭", "👩🏼‍💻", "👩🏼‍💼", "👩🏼‍🔧", "👩🏼‍🔬", "👩🏼‍🚀", "👩🏼‍🚒", "👩🏼‍🦰", "👩🏼‍🦱", "👩🏼‍🦲", "👩🏼‍🦳", "👩🏽", "👩🏽‍⚕️", "👩🏽‍⚖️", "👩🏽‍✈️", "👩🏽‍🌾", "👩🏽‍🍳", "👩🏽‍🍼", "👩🏽‍🎓", "👩🏽‍🎤", "👩🏽‍🎨", "👩🏽‍🏫", "👩🏽‍🏭", "👩🏽‍💻", "👩🏽‍💼", "👩🏽‍🔧", "👩🏽‍🔬", "👩🏽‍🚀", "👩🏽‍🚒", "👩🏽‍🦰", "👩🏽‍🦱", "👩🏽‍🦲", "👩🏽‍🦳", "👩🏾", "👩🏾‍⚕️", "👩🏾‍⚖️", "👩🏾‍✈️", "👩🏾‍🌾", "👩🏾‍🍳", "👩🏾‍🍼", "👩🏾‍🎓", "👩🏾‍🎤", "👩🏾‍🎨", "👩🏾‍🏫", "👩🏾‍🏭", "👩🏾‍💻", "👩🏾‍💼", "👩🏾‍🔧", "👩🏾‍🔬", "👩🏾‍🚀", "👩🏾‍🚒", "👩🏾‍🦰", "👩🏾‍🦱", "👩🏾‍🦲", "👩🏾‍🦳", "👩🏿", "👩🏿‍⚕️", "👩🏿‍⚖️", "👩🏿‍✈️", "👩🏿‍🌾", "👩🏿‍🍳", "👩🏿‍🍼", "👩🏿‍🎓", "👩🏿‍🎤", "👩🏿‍🎨", "👩🏿‍🏫", "👩🏿‍🏭", "👩🏿‍💻", "👩🏿‍💼", "👩🏿‍🔧", "👩🏿‍🔬", "👩🏿‍🚀", "👩🏿‍🚒", "👩🏿‍🦰", "👩🏿‍🦱", "👩🏿‍🦲", "👩🏿‍🦳", "👮", "👮‍♀️", "👮‍♂️", "👮🏻", "👮🏻‍♀️", "👮🏻‍♂️", "👮🏼", "👮🏼‍♀️", "👮🏼‍♂️", "👮🏽", "👮🏽‍♀️", "👮🏽‍♂️", "👮🏾", "👮🏾‍♀️", "👮🏾‍♂️", "👮🏿", "👮🏿‍♀️", "👮🏿‍♂️", "👰", "👰‍♀️", "👰‍♂️", "👰🏻", "👰🏻‍♀️", "👰🏻‍♂️", "👰🏼", "👰🏼‍♀️", "👰🏼‍♂️", "👰🏽", "👰🏽‍♀️", "👰🏽‍♂️", "👰🏾", "👰🏾‍♀️", "👰🏾‍♂️", "👰🏿", "👰🏿‍♀️", "👰🏿‍♂️", "👱", "👱‍♀️", "👱‍♂️", "👱🏻", "👱🏻‍♀️", "👱🏻‍♂️", "👱🏼", "👱🏼‍♀️", "👱🏼‍♂️", "👱🏽", "👱🏽‍♀️", "👱🏽‍♂️", "👱🏾", "👱🏾‍♀️", "👱🏾‍♂️", "👱🏿", "👱🏿‍♀️", "👱🏿‍♂️", "👲", "👲🏻", "👲🏼", "👲🏽", "👲🏾", "👲🏿", "👳", "👳‍♀️", "👳‍♂️", "👳🏻", "👳🏻‍♀️", "👳🏻‍♂️", "👳🏼", "👳🏼‍♀️", "👳🏼‍♂️", "👳🏽", "👳🏽‍♀️", "👳🏽‍♂️", "👳🏾", "👳🏾‍♀️", "👳🏾‍♂️", "👳🏿", "👳🏿‍♀️", "👳🏿‍♂️", "👴", "👴🏻", "👴🏼", "👴🏽", "👴🏾", "👴🏿", "👵", "👵🏻", "👵🏼", "👵🏽", "👵🏾", "👵🏿", "👶", "👶🏻", "👶🏼", "👶🏽", "👶🏾", "👶🏿", "👷", "👷‍♀️", "👷‍♂️", "👷🏻", "👷🏻‍♀️", "👷🏻‍♂️", "👷🏼", "👷🏼‍♀️", "👷🏼‍♂️", "👷🏽", "👷🏽‍♀️", "👷🏽‍♂️", "👷🏾", "👷🏾‍♀️", "👷🏾‍♂️", "👷🏿", "👷🏿‍♀️", "👷🏿‍♂️", "👸", "👸🏻", "👸🏼", "👸🏽", "👸🏾", "👸🏿", "👼", "👼🏻", "👼🏼", "👼🏽", "👼🏾", "👼🏿", "💁", "💁‍♀️", "💁‍♂️", "💁🏻", "💁🏻‍♀️", "💁🏻‍♂️", "💁🏼", "💁🏼‍♀️", "💁🏼‍♂️", "💁🏽", "💁🏽‍♀️", "💁🏽‍♂️", "💁🏾", "💁🏾‍♀️", "💁🏾‍♂️", "💁🏿", "💁🏿‍♀️", "💁🏿‍♂️", "💂", "💂‍♀️", "💂‍♂️", "💂🏻", "💂🏻‍♀️", "💂🏻‍♂️", "💂🏼", "💂🏼‍♀️", "💂🏼‍♂️", "💂🏽", "💂🏽‍♀️", "💂🏽‍♂️", "💂🏾", "💂🏾‍♀️", "💂🏾‍♂️", "💂🏿", "💂🏿‍♀️", "💂🏿‍♂️", "💆", "💆‍♀️", "💆‍♂️", "💆🏻", "💆🏻‍♀️", "💆🏻‍♂️", "💆🏼", "💆🏼‍♀️", "💆🏼‍♂️", "💆🏽", "💆🏽‍♀️", "💆🏽‍♂️", "💆🏾", "💆🏾‍♀️", "💆🏾‍♂️", "💆🏿", "💆🏿‍♀️", "💆🏿‍♂️", "💇", "💇🏻", "💇🏼", "💇🏽", "🕵🏻", "🕵🏻‍♀️", "🕵🏻‍♂️", "🕵🏼", "🕵🏼‍♀️", "🕵🏼‍♂️", "🕵🏽", "🕵🏽‍♀️", "🕵🏽‍♂️", "🕵🏾", "🕵🏾‍♀️", "🕵🏾‍♂️", "🕵🏿", "🕵🏿‍♀️", "🕵🏿‍♂️", "🕵️", "🕵️‍♀️", "🕵️‍♂️", "🙅", "🙅‍♀️", "🙅‍♂️", "🙅🏻", "🙅🏻‍♀️", "🙅🏻‍♂️", "🙅🏼", "🙅🏼‍♀️", "🙅🏼‍♂️", "🙅🏽", "🙅🏽‍♀️", "🙅🏽‍♂️", "🙅🏾", "🙅🏾‍♀️", "🙅🏾‍♂️", "🙅🏿", "🙅🏿‍♀️", "🙅🏿‍♂️", "🙆", "🙆‍♀️", "🙆‍♂️", "🙆🏻", "🙆🏻‍♀️", "🙆🏻‍♂️", "🙆🏼", "🙆🏼‍♀️", "🙆🏼‍♂️", "🙆🏽", "🙆🏽‍♀️", "🙆🏽‍♂️", "🙆🏾", "🙆🏾‍♀️", "🙆🏾‍♂️", "🙆🏿", "🙆🏿‍♀️", "🙆🏿‍♂️", "🙇", "🙇‍♀️", "🙇‍♂️", "🙇🏻", "🙇🏻‍♀️", "🙇🏻‍♂️", "🙇🏼", "🙇🏼‍♀️", "🙇🏼‍♂️", "🙇🏽", "🙇🏽‍♀️", "🙇🏽‍♂️", "🙇🏾", "🙇🏾‍♀️", "🙇🏾‍♂️", "🙇🏿", "🙇🏿‍♀️", "🙇🏿‍♂️", "🙋", "🙋‍♀️", "🙋‍♂️", "🙋🏻", "🙋🏻‍♀️", "🙋🏻‍♂️", "🙋🏼", "🙋🏼‍♀️", "🙋🏼‍♂️", "🙋🏽", "🙋🏽‍♀️", "🙋🏽‍♂️", "🙋🏾", "🙋🏾‍♀️", "🙋🏾‍♂️", "🙋🏿", "🙋🏿‍♀️", "🙋🏿‍♂️", "🙍", "🙍‍♀️", "🙍‍♂️", "🙍🏻", "🙍🏻‍♀️", "🙍🏻‍♂️", "🙍🏼", "🙍🏼‍♀️", "🙍🏼‍♂️", "🙍🏽", "🙍🏽‍♀️", "🙍🏽‍♂️", "🙍🏾", "🙍🏾‍♀️", "🙍🏾‍♂️", "🙍🏿", "🙍🏿‍♀️", "🙍🏿‍♂️", "🙎", "🙎‍♀️", "🙎‍♂️", "🙎🏻", "🙎🏻‍♀️", "🙎🏻‍♂️", "🙎🏼", "🙎🏼‍♀️", "🙎🏼‍♂️", "🙎🏽", "🙎🏽‍♀️", "🙎🏽‍♂️", "🙎🏾", "🙎🏾‍♀️", "🙎🏾‍♂️", "🙎🏿", "🙎🏿‍♀️", "🙎🏿‍♂️", "🤦", "🤦‍♀️", "🤦‍♂️", "🤦🏻", "🤦🏻‍♀️", "🤦🏻‍♂️", "🤦🏼", "🤦🏼‍♀️", "🤦🏼‍♂️", "🤦🏽", "🤦🏽‍♀️", "🤦🏽‍♂️", "🤦🏾", "🤦🏾‍♀️", "🤦🏾‍♂️", "🤦🏿", "🤦🏿‍♀️", "🤦🏿‍♂️", "🤰", "🤰🏻", "🤰🏼", "🤰🏽", "🤰🏾", "🤰🏿", "🤱", "🤱🏻", "🤱🏼", "🤱🏽", "🤱🏾", "🤱🏿", "🤴", "🤴🏻", "🤴🏼", "🤴🏽", "🤴🏾", "🤴🏿", "🤵", "🤵‍♀️", "🤵‍♂️", "🤵🏻", "🤵🏻‍♀️", "🤵🏻‍♂️", "🤵🏼", "🤵🏼‍♀️", "🤵🏼‍♂️", "🤵🏽", "🤵🏽‍♀️", "🤵🏽‍♂️", "🤵🏾", "🤵🏾‍♀️", "🤵🏾‍♂️", "🤵🏿", "🤵🏿‍♀️", "🤵🏿‍♂️", "🤶", "🤶🏻", "🤶🏼", "🤶🏽", "🤶🏾", "🤶🏿", "🤷", "🤷‍♀️", "🤷‍♂️", "🤷🏻", "🤷🏻‍♀️", "🤷🏻‍♂️", "🤷🏼", "🤷🏼‍♀️", "🤷🏼‍♂️", "🤷🏽", "🤷🏽‍♀️", "🤷🏽‍♂️", "🤷🏾", "🤷🏾‍♀️", "🤷🏾‍♂️", "🤷🏿", "🤷🏿‍♀️", "🤷🏿‍♂️", "🥷", "🥷🏻", "🥷🏼", "🥷🏽", "🥷🏾", "🥷🏿", "🦸", "🦸‍♀️", "🦸‍♂️", "🦸🏻", "🦸🏻‍♀️", "🦸🏻‍♂️", "🦸🏼", "🦸🏼‍♀️", "🦸🏼‍♂️", "🦸🏽", "🦸🏽‍♀️", "🦸🏽‍♂️", "🦸🏾", "🦸🏾‍♀️", "🦸🏾‍♂️", "🦸🏿", "🦸🏿‍♀️", "🦸🏿‍♂️", "🦹", "🦹‍♀️", "🦹‍♂️", "🦹🏻", "🦹🏻‍♀️", "🦹🏻‍♂️", "🦹🏼", "🦹🏼‍♀️", "🦹🏼‍♂️", "🦹🏽", "🦹🏽‍♀️", "🦹🏽‍♂️", "🦹🏾", "🦹🏾‍♀️", "🦹🏾‍♂️", "🦹🏿", "🦹🏿‍♀️", "🦹🏿‍♂️", "🧏", "🧏‍♀️", "🧏‍♂️", "🧏🏻", "🧏🏻‍♀️", "🧏🏻‍♂️", "🧏🏼", "🧏🏼‍♀️", "🧏🏼‍♂️", "🧏🏽", "🧏🏽‍♀️", "🧏🏽‍♂️", "🧏🏾", "🧏🏾‍♀️", "🧏🏾‍♂️", "🧏🏿", "🧏🏿‍♀️", "🧏🏿‍♂️", "🧑", "🧑‍⚕️", "🧑‍⚖️", "🧑‍✈️", "🧑‍🌾", "🧑‍🍳", "🧑‍🍼", "🧑‍🎄", "🧑‍🎓", "🧑‍🎤", "🧑‍🎨", "🧑‍🏫", "🧑‍🏭", "🧑‍💻", "🧑‍💼", "🧑‍🔧", "🧑‍🔬", "🧑‍🚀", "🧑‍🚒", "🧑‍🦰", "🧑‍🦱", "🧑‍🦲", "🧑‍🦳", "🧑🏻", "🧑🏻‍⚕️", "🧑🏻‍⚖️", "🧑🏻‍✈️", "🧑🏻‍🌾", "🧑🏻‍🍳", "🧑🏻‍🍼", "🧑🏻‍🎄", "🧑🏻‍🎓", "🧑🏻‍🎤", "🧑🏻‍🎨", "🧑🏻‍🏫", "🧑🏻‍🏭", "🧑🏻‍💻", "🧑🏻‍💼", "🧑🏻‍🔧", "🧑🏻‍🔬", "🧑🏻‍🚀", "🧑🏻‍🚒", "🧑🏻‍🦰", "🧑🏻‍🦱", "🧑🏻‍🦲", "🧑🏻‍🦳", "🧑🏼", "🧑🏼‍⚕️", "🧑🏼‍⚖️", "🧑🏼‍✈️", "🧑🏼‍🌾", "🧑🏼‍🍳", "🧑🏼‍🍼", "🧑🏼‍🎄", "🧑🏼‍🎓", "🧑🏼‍🎤", "🧑🏼‍🎨", "🧑🏼‍🏫", "🧑🏼‍🏭", "🧑🏼‍💻", "🧑🏼‍💼", "🧑🏼‍🔧", "🧑🏼‍🔬", "🧑🏼‍🚀", "🧑🏼‍🚒", "🧑🏼‍🦰", "🧑🏼‍🦱", "🧑🏼‍🦲", "🧑🏼‍🦳", "🧑🏽", "🧑🏽‍⚕️", "🧑🏽‍⚖️", "🧑🏽‍✈️", "🧑🏽‍🌾", "🧑🏽‍🍳", "🧑🏽‍🍼", "🧑🏽‍🎄", "🧑🏽‍🎓", "🧑🏽‍🎤", "🧑🏽‍🎨", "🧑🏽‍🏫", "🧑🏽‍🏭", "🧑🏽‍💻", "🧑🏽‍💼", "🧑🏽‍🔧", "🧑🏽‍🔬", "🧑🏽‍🚀", "🧑🏽‍🚒", "🧑🏽‍🦰", "🧑🏽‍🦱", "🧑🏽‍🦲", "🧑🏽‍🦳", "🧑🏾", "🧑🏾‍⚕️", "🧑🏾‍⚖️", "🧑🏾‍✈️", "🧑🏾‍🌾", "🧑🏾‍🍳", "🧑🏾‍🍼", "🧑🏾‍🎄", "🧑🏾‍🎓", "🧑🏾‍🎤", "🧑🏾‍🎨", "🧑🏾‍🏫", "🧑🏾‍🏭", "🧑🏾‍💻", "🧑🏾‍💼", "🧑🏾‍🔧", "🧑🏾‍🔬", "🧑🏾‍🚀", "🧑🏾‍🚒", "🧑🏾‍🦰", "🧑🏾‍🦱", "🧑🏾‍🦲", "🧑🏾‍🦳", "🧑🏿", "🧑🏿‍⚕️", "🧑🏿‍⚖️", "🧑🏿‍✈️", "🧑🏿‍🌾", "🧑🏿‍🍳", "🧑🏿‍🍼", "🧑🏿‍🎄", "🧑🏿‍🎓", "🧑🏿‍🎤", "🧑🏿‍🎨", "🧑🏿‍🏫", "🧑🏿‍🏭", "🧑🏿‍💻", "🧑🏿‍💼", "🧑🏿‍🔧", "🧑🏿‍🔬", "🧑🏿‍🚀", "🧑🏿‍🚒", "🧑🏿‍🦰", "🧑🏿‍🦱", "🧑🏿‍🦲", "🧑🏿‍🦳", "🧒", "🧒🏻", "🧒🏼", "🧒🏽", "🧒🏾", "🧒🏿", "🧓", "🧓🏻", "🧓🏼", "🧓🏽", "🧓🏾", "🧓🏿", "🧔", "🧔‍♀️", "🧔‍♂️", "🧔🏻", "🧔🏻‍♀️", "🧔🏻‍♂️", "🧔🏼", "🧔🏼‍♀️", "🧔🏼‍♂️", "🧔🏽", "🧔🏽‍♀️", "🧔🏽‍♂️", "🧔🏾", "🧔🏾‍♀️", "🧔🏾‍♂️", "🧔🏿", "🧔🏿‍♀️", "🧔🏿‍♂️", "🧕", "🧕🏻", "🧕🏼", "🧕🏽", "🧕🏾", "🧕🏿", "🧙", "🧙‍♀️", "🧙‍♂️", "🧙🏻", "🧙🏻‍♀️", "🧙🏻‍♂️", "🧙🏼", "🧙🏼‍♀️", "🧙🏼‍♂️", "🧙🏽", "🧙🏽‍♀️", "🧙🏽‍♂️", "🧙🏾", "🧙🏾‍♀️", "🧙🏾‍♂️", "🧙🏿", "🧙🏿‍♀️", "🧙🏿‍♂️", "🧚", "🧚‍♀️", "🧚‍♂️", "🧚🏻", "🧚🏻‍♀️", "🧚🏻‍♂️", "🧚🏼", "🧚🏼‍♀️", "🧚🏼‍♂️", "🧚🏽", "🧚🏽‍♀️", "🧚🏽‍♂️", "🧚🏾", "🧚🏾‍♀️", "🧚🏾‍♂️", "🧚🏿", "🧚🏿‍♀️", "🧚🏿‍♂️", "🧛", "🧛‍♀️", "🧛‍♂️", "🧛🏻", "🧛🏻‍♀️", "🧛🏻‍♂️", "🧛🏼", "🧛🏼‍♀️", "🧛🏼‍♂️", "🧛🏽", "🧛🏽‍♀️", "🧛🏽‍♂️", "🧛🏾", "🧛🏾‍♀️", "🧛🏾‍♂️", "🧛🏿", "🧛🏿‍♀️", "🧛🏿‍♂️", "🧜", "🧜‍♀️", "🧜‍♂️", "🧜🏻", "🧜🏻‍♀️", "🧜🏻‍♂️", "🧜🏼", "🧜🏼‍♀️", "🧜🏼‍♂️", "🧜🏽", "🧜🏽‍♀️", "🧜🏽‍♂️", "🧜🏾", "🧜🏾‍♀️", "🧜🏾‍♂️", "🧜🏿", "🧜🏿‍♀️", "🧜🏿‍♂️", "🧝", "🧝‍♀️", "🧝‍♂️", "🧝🏻", "🧝🏻‍♀️", "🧝🏻‍♂️", "🧝🏼", "🧝🏼‍♀️", "🧝🏼‍♂️", "🧝🏽", "🧝🏽‍♀️", "🧝🏽‍♂️", "🧝🏾", "🧝🏾‍♀️", "🧝🏾‍♂️", "🧝🏿", "🧝🏿‍♀️", "🧝🏿‍♂️", "🧞", "🧞‍♀️", "🧞‍♂️", "🧟", "🧟‍♀️", "🧟‍♂️"], nature: ["☘️", "🌱", "🌲", "🌳", "🌴", "🌵", "🌷", "🌸", "🌹", "🌺", "🌻", "🌼", "🌾", "🌿", "🍀", "🍁", "🍂", "🍃", "🏵️", "🐀", "🐁", "🐂", "🐃", "🐄", "🐅", "🐆", "🐇", "🐈", "🐈‍⬛", "🐉", "🐊", "🐋", "🐌", "🐍", "🐎", "🐏", "🐐", "🐑", "🐒", "🐓", "🐔", "🐕", "🐕‍🦺", "🐖", "🐗", "🐘", "🐙", "🐚", "🐛", "🐜", "🐝", "🐞", "🐟", "🐠", "🐡", "🐢", "🐣", "🐤", "🐥", "🐦", "🐧", "🐨", "🐩", "🐪", "🐫", "🐬", "🐭", "🐮", "🐯", "🐰", "🐱", "🐲", "🐳", "🐴", "🐵", "🐶", "🐷", "🐸", "🐹", "🐺", "🐻", "🐻‍❄️", "🐼", "🐽", "🐾", "🐿️", "💐", "💮", "🕊️", "🕷️", "🕸️", "🥀", "🦁", "🦂", "🦃", "🦄", "🦅", "🦆", "🦇", "🦈", "🦉", "🦊", "🦋", "🦌", "🦍", "🦎", "🦏", "🦒", "🦓", "🦔", "🦕", "🦖", "🦗", "🦘", "🦙", "🦚", "🦛", "🦜", "🦝", "🦟", "🦠", "🦡", "🦢", "🦣", "🦤", "🦥", "🦦", "🦧", "🦨", "🦩", "🦫", "🦬", "🦭", "🦮", "🪰", "🪱", "🪲", "🪳", "🪴", "🪶"], food: ["☕", "🌭", "🌮", "🌯", "🌰", "🌶️", "🌽", "🍄", "🍅", "🍆", "🍇", "🍈", "🍉", "🍊", "🍋", "🍌", "🍍", "🍎", "🍏", "🍐", "🍑", "🍒", "🍓", "🍔", "🍕", "🍖", "🍗", "🍘", "🍙", "🍚", "🍛", "🍜", "🍝", "🍞", "🍟", "🍠", "🍡", "🍢", "🍣", "🍤", "🍥", "🍦", "🍧", "🍨", "🍩", "🍪", "🍫", "🍬", "🍭", "🍮", "🍯", "🍰", "🍱", "🍲", "🍳", "🍴", "🍵", "🍶", "🍷", "🍸", "🍹", "🍺", "🍻", "🍼", "🍽️", "🍾", "🍿", "🎂", "🏺", "🔪", "🥂", "🥃", "🥄", "🥐", "🥑", "🥒", "🥓", "🥔", "🥕", "🥖", "🥗", "🥘", "🥙", "🥚", "🥛", "🥜", "🥝", "🥞", "🥟", "🥠", "🥡", "🥢", "🥣", "🥤", "🥥", "🥦", "🥧", "🥨", "🥩", "🥪", "🥫", "🥬", "🥭", "🥮", "🥯", "🦀", "🦐", "🦑", "🦞", "🦪", "🧀", "🧁", "🧂", "🧃", "🧄", "🧅", "🧆", "🧇", "🧈", "🧉", "🧊", "🧋", "🫐", "🫑", "🫒", "🫓", "🫔", "🫕", "🫖"], travel: ["⌚", "⌛", "⏰", "⏱️", "⏲️", "⏳", "☀️", "☁️", "☂️", "☃️", "☄️", "☔", "♨️", "⚓", "⚡", "⛄", "⛅", "⛈️", "⛩️", "⛪", "⛰️", "⛱️", "⛲", "⛴️", "⛵", "⛺", "⛽", "✈️", "❄️", "⭐", "🌀", "🌁", "🌂", "🌃", "🌄", "🌅", "🌆", "🌇", "🌈", "🌉", "🌊", "🌋", "🌌", "🌍", "🌎", "🌏", "🌐", "🌑", "🌒", "🌓", "🌔", "🌕", "🌖", "🌗", "🌘", "🌙", "🌚", "🌛", "🌜", "🌝", "🌞", "🌟", "🌠", "🌡️", "🌤️", "🌥️", "🌦️", "🌧️", "🌨️", "🌩️", "🌪️", "🌫️", "🌬️", "🎠", "🎡", "🎢", "🎪", "🏍️", "🏎️", "🏔️", "🏕️", "🏖️", "🏗️", "🏘️", "🏙️", "🏚️", "🏛️", "🏜️", "🏝️", "🏞️", "🏟️", "🏠", "🏡", "🏢", "🏣", "🏤", "🏥", "🏦", "🏨", "🏩", "🏪", "🏫", "🏬", "🏭", "🏯", "🏰", "💈", "💒", "💧", "💺", "🔥", "🕋", "🕌", "🕍", "🕐", "🕑", "🕒", "🕓", "🕔", "🕕", "🕖", "🕗", "🕘", "🕙", "🕚", "🕛", "🕜", "🕝", "🕞", "🕟", "🕠", "🕡", "🕢", "🕣", "🕤", "🕥", "🕦", "🕧", "🕰️", "🗺️", "🗻", "🗼", "🗽", "🗾", "🚀", "🚁", "🚂", "🚃", "🚄", "🚅", "🚆", "🚇", "🚈", "🚉", "🚊", "🚋", "🚌", "🚍", "🚎", "🚏", "🚐", "🚑", "🚒", "🚓", "🚔", "🚕", "🚖", "🚗", "🚘", "🚙", "🚚", "🚛", "🚜", "🚝", "🚞", "🚟", "🚠", "🚡", "🚢", "🚤", "🚥", "🚦", "🚧", "🚨", "🚲", "🛎️", "🛑", "🛕", "🛖", "🛢️", "🛣️", "🛤️", "🛥️", "🛩️", "🛫", "🛬", "🛰️", "🛳️", "🛴", "🛵", "🛶", "🛸", "🛹", "🛺", "🛻", "🛼", "🦼", "🦽", "🧭", "🧱", "🧳", "🪂", "🪐", "🪨", "🪵"], activity: ["♟️", "♠️", "♣️", "♥️", "♦️", "⚽", "⚾", "⛳", "⛸️", "✨", "🀄", "🃏", "🎀", "🎁", "🎃", "🎄", "🎆", "🎇", "🎈", "🎉", "🎊", "🎋", "🎍", "🎎", "🎏", "🎐", "🎑", "🎖️", "🎗️", "🎟️", "🎣", "🎨", "🎫", "🎭", "🎮", "🎯", "🎰", "🎱", "🎲", "🎳", "🎴", "🎽", "🎾", "🎿", "🏀", "🏅", "🏆", "🏈", "🏉", "🏏", "🏐", "🏑", "🏒", "🏓", "🏸", "🔮", "🕹️", "🖼️", "🛷", "🤿", "🥅", "🥇", "🥈", "🥉", "🥊", "🥋", "🥌", "🥍", "🥎", "🥏", "🧧", "🧨", "🧩", "🧵", "🧶", "🧸", "🧿", "🪀", "🪁", "🪄", "🪅", "🪆", "🪡", "🪢"], object: ["⌨️", "☎️", "⚒️", "⚔️", "⚖️", "⚗️", "⚙️", "⚰️", "⚱️", "⛏️", "⛑️", "⛓️", "✂️", "✉️", "✏️", "✒️", "🎒", "🎓", "🎙️", "🎚️", "🎛️", "🎞️", "🎤", "🎥", "🎧", "🎩", "🎬", "🎵", "🎶", "🎷", "🎸", "🎹", "🎺", "🎻", "🎼", "🏮", "🏷️", "🏹", "👑", "👒", "👓", "👔", "👕", "👖", "👗", "👘", "👙", "👚", "👛", "👜", "👝", "👞", "👟", "👠", "👡", "👢", "💄", "💉", "💊", "💍", "💎", "💡", "💰", "💳", "💴", "💵", "💶", "💷", "💸", "💹", "💻", "💼", "💽", "💾", "💿", "📀", "📁", "📂", "📃", "📄", "📅", "📆", "📇", "📈", "📉", "📊", "📋", "📌", "📍", "📎", "📏", "📐", "📑", "📒", "📓", "📔", "📕", "📖", "📗", "📘", "📙", "📚", "📜", "📝", "📞", "📟", "📠", "📡", "📢", "📣", "📤", "📥", "📦", "📧", "📨", "📩", "📪", "📫", "📬", "📭", "📮", "📯", "📰", "📱", "📲", "📷", "📸", "📹", "📺", "📻", "📼", "📽️", "📿", "🔇", "🔈", "🔉", "🔊", "🔋", "🔌", "🔍", "🔎", "🔏", "🔐", "🔑", "🔒", "🔓", "🔔", "🔕", "🔖", "🔗", "🔦", "🔧", "🔨", "🔩", "🔫", "🔬", "🔭", "🕯️", "🕶️", "🖇️", "🖊️", "🖋️", "🖌️", "🖍️", "🖥️", "🖨️", "🖱️", "🖲️", "🗂️", "🗃️", "🗄️", "🗑️", "🗒️", "🗓️", "🗜️", "🗝️", "🗞️", "🗡️", "🗳️", "🗿", "🚪", "🚬", "🚽", "🚿", "🛁", "🛋️", "🛍️", "🛏️", "🛒", "🛗", "🛠️", "🛡️", "🥁", "🥻", "🥼", "🥽", "🥾", "🥿", "🦯", "🦺", "🧢", "🧣", "🧤", "🧥", "🧦", "🧪", "🧫", "🧬", "🧮", "🧯", "🧰", "🧲", "🧴", "🧷", "🧹", "🧺", "🧻", "🧼", "🧽", "🧾", "🩰", "🩱", "🩲", "🩳", "🩴", "🩸", "🩹", "🩺", "🪃", "🪑", "🪒", "🪓", "🪔", "🪕", "🪖", "🪗", "🪘", "🪙", "🪚", "🪛", "🪜", "🪝", "🪞", "🪟", "🪠", "🪣", "🪤", "🪥", "🪦", "🪧"], symbol: ["#️⃣", "*️⃣", "0️⃣", "1️⃣", "2️⃣", "3️⃣", "4️⃣", "5️⃣", "6️⃣", "7️⃣", "8️⃣", "9️⃣", "©️", "®️", "‼️", "⁉️", "™️", "ℹ️", "↔️", "↕️", "↖️", "↗️", "↘️", "↙️", "↩️", "↪️", "⏏️", "⏩", "⏪", "⏫", "⏬", "⏭️", "⏮️", "⏯️", "⏸️", "⏹️", "⏺️", "Ⓜ️", "▪️", "▫️", "▶️", "◀️", "◻️", "◼️", "◽", "◾", "☑️", "☢️", "☣️", "☦️", "☪️", "☮️", "☯️", "☸️", "♀️", "♂️", "♈", "♉", "♊", "♋", "♌", "♍", "♎", "♏", "♐", "♑", "♒", "♓", "♻️", "♾️", "♿", "⚕️", "⚛️", "⚜️", "⚠️", "⚧️", "⚪", "⚫", "⛎", "⛔", "✅", "✔️", "✖️", "✝️", "✡️", "✳️", "✴️", "❇️", "❌", "❎", "❓", "❔", "❕", "❗", "➕", "➖", "➗", "➡️", "➰", "➿", "⤴️", "⤵️", "⬅️", "⬆️", "⬇️", "⬛", "⬜", "⭕", "〰️", "〽️", "㊗️", "㊙️", "🅰️", "🅱️", "🅾️", "🅿️", "🆎", "🆑", "🆒", "🆓", "🆔", "🆕", "🆖", "🆗", "🆘", "🆙", "🆚", "🈁", "🈂️", "🈚", "🈯", "🈲", "🈳", "🈴", "🈵", "🈶", "🈷️", "🈸", "🈹", "🈺", "🉐", "🉑", "🎦", "🏧", "💠", "💱", "💲", "📛", "📳", "📴", "📵", "📶", "🔀", "🔁", "🔂", "🔃", "🔄", "🔅", "🔆", "🔘", "🔙", "🔚", "🔛", "🔜", "🔝", "🔞", "🔟", "🔠", "🔡", "🔢", "🔣", "🔤", "🔯", "🔰", "🔱", "🔲", "🔳", "🔴", "🔵", "🔶", "🔷", "🔸", "🔹", "🔺", "🔻", "🔼", "🔽", "🕉️", "🕎", "🚫", "🚭", "🚮", "🚯", "🚰", "🚱", "🚳", "🚷", "🚸", "🚹", "🚺", "🚻", "🚼", "🚾", "🛂", "🛃", "🛄", "🛅", "🛐", "🟠", "🟡", "🟢", "🟣", "🟤", "🟥", "🟦", "🟧", "🟨", "🟩", "🟪", "🟫"], flag: ["🇦🇨", "🇦🇩", "🇦🇪", "🇦🇫", "🇦🇬", "🇦🇮", "🇦🇱", "🇦🇲", "🇦🇴", "🇦🇶", "🇦🇷", "🇦🇸", "🇦🇹", "🇦🇺", "🇦🇼", "🇦🇽", "🇦🇿", "🇧🇦", "🇧🇧", "🇧🇩", "🇧🇪", "🇧🇫", "🇧🇬", "🇧🇭", "🇧🇮", "🇧🇯", "🇧🇱", "🇧🇲", "🇧🇳", "🇧🇴", "🇧🇶", "🇧🇷", "🇧🇸", "🇧🇹", "🇧🇻", "🇧🇼", "🇧🇾", "🇧🇿", "🇨🇦", "🇨🇨", "🇨🇩", "🇨🇫", "🇨🇬", "🇨🇭", "🇨🇮", "🇨🇰", "🇨🇱", "🇨🇲", "🇨🇳", "🇨🇴", "🇨🇵", "🇨🇷", "🇨🇺", "🇨🇻", "🇨🇼", "🇨🇽", "🇨🇾", "🇨🇿", "🇩🇪", "🇩🇬", "🇩🇯", "🇩🇰", "🇩🇲", "🇩🇴", "🇩🇿", "🇪🇦", "🇪🇨", "🇪🇪", "🇪🇬", "🇪🇭", "🇪🇷", "🇪🇸", "🇪🇹", "🇪🇺", "🇫🇮", "🇫🇯", "🇫🇰", "🇫🇲", "🇫🇴", "🇫🇷", "🇬🇦", "🇬🇧", "🇬🇩", "🇬🇪", "🇬🇫", "🇬🇬", "🇬🇭", "🇬🇮", "🇬🇱", "🇬🇲", "🇬🇳", "🇬🇵", "🇬🇶", "🇬🇷", "🇬🇸", "🇬🇹", "🇬🇺", "🇬🇼", "🇬🇾", "🇭🇰", "🇭🇲", "🇭🇳", "🇭🇷", "🇭🇹", "🇭🇺", "🇮🇨", "🇮🇩", "🇮🇪", "🇮🇱", "🇮🇲", "🇮🇳", "🇮🇴", "🇮🇶", "🇮🇷", "🇮🇸", "🇮🇹", "🇯🇪", "🇯🇲", "🇯🇴", "🇯🇵", "🇰🇪", "🇰🇬", "🇰🇭", "🇰🇮", "🇰🇲", "🇰🇳", "🇰🇵", "🇰🇷", "🇰🇼", "🇰🇾", "🇰🇿", "🇱🇦", "🇱🇧", "🇱🇨", "🇱🇮", "🇱🇰", "🇱🇷", "🇱🇸", "🇱🇹", "🇱🇺", "🇱🇻", "🇱🇾", "🇲🇦", "🇲🇨", "🇲🇩", "🇲🇪", "🇲🇫", "🇲🇬", "🇲🇭", "🇲🇰", "🇲🇱", "🇲🇲", "🇲🇳", "🇲🇴", "🇲🇵", "🇲🇶", "🇲🇷", "🇲🇸", "🇲🇹", "🇲🇺", "🇲🇻", "🇲🇼", "🇲🇽", "🇲🇾", "🇲🇿", "🇳🇦", "🇳🇨", "🇳🇪", "🇳🇫", "🇳🇬", "🇳🇮", "🇳🇱", "🇳🇴", "🇳🇵", "🇳🇷", "🇳🇺", "🇳🇿", "🇴🇲", "🇵🇦", "🇵🇪", "🇵🇫", "🇵🇬", "🇵🇭", "🇵🇰", "🇵🇱", "🇵🇲", "🇵🇳", "🇵🇷", "🇵🇸", "🇵🇹", "🇵🇼", "🇵🇾", "🇶🇦", "🇷🇪", "🇷🇴", "🇷🇸", "🇷🇺", "🇷🇼", "🇸🇦", "🇸🇧", "🇸🇨", "🇸🇩", "🇸🇪", "🇸🇬", "🇸🇭", "🇸🇮", "🇸🇯", "🇸🇰", "🇸🇱", "🇸🇲", "🇸🇳", "🇸🇴", "🇸🇷", "🇸🇸", "🇸🇹", "🇸🇻", "🇸🇽", "🇸🇾", "🇸🇿", "🇹🇦", "🇹🇨", "🇹🇩", "🇹🇫", "🇹🇬", "🇹🇭", "🇹🇯", "🇹🇰", "🇹🇱", "🇹🇲", "🇹🇳", "🇹🇴", "🇹🇷", "🇹🇹", "🇹🇻", "🇹🇼", "🇹🇿", "🇺🇦", "🇺🇬", "🇺🇲", "🇺🇳", "🇺🇸", "🇺🇾", "🇺🇿", "🇻🇦", "🇻🇨", "🇻🇪", "🇻🇬", "🇻🇮", "🇻🇳", "🇻🇺", "🇼🇫", "🇼🇸", "🇽🇰", "🇾🇪", "🇾🇹", "🇿🇦", "🇿🇲", "🇿🇼", "🎌", "🏁", "🏳️", "🏳️‍⚧️", "🏳️‍🌈", "🏴", "🏴‍☠️", "🚩"] }, f2e = { informational: [100, 101, 102, 103], success: [200, 201, 202, 203, 204, 205, 206, 207, 208, 226], redirection: [300, 301, 302, 303, 304, 305, 306, 307, 308], clientError: [400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 421, 422, 423, 424, 425, 426, 428, 429, 431, 451], serverError: [500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511] }, m2e = ["ES256", "ES384", "ES512", "HS256", "HS384", "HS512", "PS256", "PS384", "PS512", "RS256", "RS384", "RS512", "none"], g2e = ["FakerBot/{{system.semver}}", "Googlebot/2.1 (+http://www.google.com/bot.html)", 'Mozilla/5.0 (Linux; Android {{number.int({"min":5,"max":13})}}; {{helpers.arrayElement(["SM-G998U","SM-G998B","SM-G998N","SM-G998P","SM-T800"])}}) AppleWebKit/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}} (KHTML, like Gecko) Chrome/{{number.int({"min":55,"max":131})}}.{{system.semver}} Mobile Safari/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}}', 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:{{number.int({"min":75, "max":133})}}.0) Gecko/20100101 Firefox/{{number.int({"min":75, "max":133})}}.0', 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}}.{{number.int({"min":0,"max":99})}} (KHTML, like Gecko) Version/16.1 Safari/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}}.{{number.int({"min":0,"max":99})}}', 'Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10_15_7) AppleWebKit/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}}.{{number.int({"min":0,"max":99})}} (KHTML, like Gecko) Chrome/{{number.int({"min":55,"max":131})}}.{{system.semver}} Safari/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}}.{{number.int({"min":0,"max":99})}}', 'Mozilla/5.0 (Windows NT {{helpers.arrayElement(["5.1","5.2","6.0","6.1","6.2","6.3","10.0"])}}; Win64; x64) AppleWebKit/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}} (KHTML, like Gecko) Chrome/{{number.int({"min":55,"max":131})}}.{{system.semver}} Safari/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}} Edg/{{number.int({"min":110,"max":131})}}.{{system.semver}}', 'Mozilla/5.0 (X11; Linux x86_64; rv:{{number.int({"min":75,"max":133})}}.0) Gecko/20100101 Firefox/{{number.int({"min":75,"max":133})}}.0', 'Mozilla/5.0 (compatible; MSIE {{number.int({"min":6,"max":10})}}.0; Windows NT {{helpers.arrayElement(["5.1","5.2","6.0","6.1","6.2","6.3","10.0"])}}; Trident/{{number.int({"min":4,"max":7})}}.0)', 'Mozilla/5.0 (iPhone; CPU iPhone OS {{number.int({"min":10,"max":18})}}_{{number.int({"min":0,"max":4})}} like Mac OS X) AppleWebKit/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}}.{{number.int({"min":0,"max":99})}} (KHTML, like Gecko) Version/{{number.int({"min":10,"max":18})}}_{{number.int({"min":0,"max":4})}} Mobile/15E148 Safari/{{number.int({"min":536,"max":605})}}.{{number.int({"min":0,"max":99})}}'], p2e = { emoji: d2e, http_status_code: f2e, jwt_algorithm: m2e, user_agent_pattern: g2e }, b2e = p2e, y2e = [{ alpha2: "AD", alpha3: "AND", numeric: "020" }, { alpha2: "AE", alpha3: "ARE", numeric: "784" }, { alpha2: "AF", alpha3: "AFG", numeric: "004" }, { alpha2: "AG", alpha3: "ATG", numeric: "028" }, { alpha2: "AI", alpha3: "AIA", numeric: "660" }, { alpha2: "AL", alpha3: "ALB", numeric: "008" }, { alpha2: "AM", alpha3: "ARM", numeric: "051" }, { alpha2: "AO", alpha3: "AGO", numeric: "024" }, { alpha2: "AQ", alpha3: "ATA", numeric: "010" }, { alpha2: "AR", alpha3: "ARG", numeric: "032" }, { alpha2: "AS", alpha3: "ASM", numeric: "016" }, { alpha2: "AT", alpha3: "AUT", numeric: "040" }, { alpha2: "AU", alpha3: "AUS", numeric: "036" }, { alpha2: "AW", alpha3: "ABW", numeric: "533" }, { alpha2: "AX", alpha3: "ALA", numeric: "248" }, { alpha2: "AZ", alpha3: "AZE", numeric: "031" }, { alpha2: "BA", alpha3: "BIH", numeric: "070" }, { alpha2: "BB", alpha3: "BRB", numeric: "052" }, { alpha2: "BD", alpha3: "BGD", numeric: "050" }, { alpha2: "BE", alpha3: "BEL", numeric: "056" }, { alpha2: "BF", alpha3: "BFA", numeric: "854" }, { alpha2: "BG", alpha3: "BGR", numeric: "100" }, { alpha2: "BH", alpha3: "BHR", numeric: "048" }, { alpha2: "BI", alpha3: "BDI", numeric: "108" }, { alpha2: "BJ", alpha3: "BEN", numeric: "204" }, { alpha2: "BL", alpha3: "BLM", numeric: "652" }, { alpha2: "BM", alpha3: "BMU", numeric: "060" }, { alpha2: "BN", alpha3: "BRN", numeric: "096" }, { alpha2: "BO", alpha3: "BOL", numeric: "068" }, { alpha2: "BQ", alpha3: "BES", numeric: "535" }, { alpha2: "BR", alpha3: "BRA", numeric: "076" }, { alpha2: "BS", alpha3: "BHS", numeric: "044" }, { alpha2: "BT", alpha3: "BTN", numeric: "064" }, { alpha2: "BV", alpha3: "BVT", numeric: "074" }, { alpha2: "BW", alpha3: "BWA", numeric: "072" }, { alpha2: "BY", alpha3: "BLR", numeric: "112" }, { alpha2: "BZ", alpha3: "BLZ", numeric: "084" }, { alpha2: "CA", alpha3: "CAN", numeric: "124" }, { alpha2: "CC", alpha3: "CCK", numeric: "166" }, { alpha2: "CD", alpha3: "COD", numeric: "180" }, { alpha2: "CF", alpha3: "CAF", numeric: "140" }, { alpha2: "CG", alpha3: "COG", numeric: "178" }, { alpha2: "CH", alpha3: "CHE", numeric: "756" }, { alpha2: "CI", alpha3: "CIV", numeric: "384" }, { alpha2: "CK", alpha3: "COK", numeric: "184" }, { alpha2: "CL", alpha3: "CHL", numeric: "152" }, { alpha2: "CM", alpha3: "CMR", numeric: "120" }, { alpha2: "CN", alpha3: "CHN", numeric: "156" }, { alpha2: "CO", alpha3: "COL", numeric: "170" }, { alpha2: "CR", alpha3: "CRI", numeric: "188" }, { alpha2: "CU", alpha3: "CUB", numeric: "192" }, { alpha2: "CV", alpha3: "CPV", numeric: "132" }, { alpha2: "CW", alpha3: "CUW", numeric: "531" }, { alpha2: "CX", alpha3: "CXR", numeric: "162" }, { alpha2: "CY", alpha3: "CYP", numeric: "196" }, { alpha2: "CZ", alpha3: "CZE", numeric: "203" }, { alpha2: "DE", alpha3: "DEU", numeric: "276" }, { alpha2: "DJ", alpha3: "DJI", numeric: "262" }, { alpha2: "DK", alpha3: "DNK", numeric: "208" }, { alpha2: "DM", alpha3: "DMA", numeric: "212" }, { alpha2: "DO", alpha3: "DOM", numeric: "214" }, { alpha2: "DZ", alpha3: "DZA", numeric: "012" }, { alpha2: "EC", alpha3: "ECU", numeric: "218" }, { alpha2: "EE", alpha3: "EST", numeric: "233" }, { alpha2: "EG", alpha3: "EGY", numeric: "818" }, { alpha2: "EH", alpha3: "ESH", numeric: "732" }, { alpha2: "ER", alpha3: "ERI", numeric: "232" }, { alpha2: "ES", alpha3: "ESP", numeric: "724" }, { alpha2: "ET", alpha3: "ETH", numeric: "231" }, { alpha2: "FI", alpha3: "FIN", numeric: "246" }, { alpha2: "FJ", alpha3: "FJI", numeric: "242" }, { alpha2: "FK", alpha3: "FLK", numeric: "238" }, { alpha2: "FM", alpha3: "FSM", numeric: "583" }, { alpha2: "FO", alpha3: "FRO", numeric: "234" }, { alpha2: "FR", alpha3: "FRA", numeric: "250" }, { alpha2: "GA", alpha3: "GAB", numeric: "266" }, { alpha2: "GB", alpha3: "GBR", numeric: "826" }, { alpha2: "GD", alpha3: "GRD", numeric: "308" }, { alpha2: "GE", alpha3: "GEO", numeric: "268" }, { alpha2: "GF", alpha3: "GUF", numeric: "254" }, { alpha2: "GG", alpha3: "GGY", numeric: "831" }, { alpha2: "GH", alpha3: "GHA", numeric: "288" }, { alpha2: "GI", alpha3: "GIB", numeric: "292" }, { alpha2: "GL", alpha3: "GRL", numeric: "304" }, { alpha2: "GM", alpha3: "GMB", numeric: "270" }, { alpha2: "GN", alpha3: "GIN", numeric: "324" }, { alpha2: "GP", alpha3: "GLP", numeric: "312" }, { alpha2: "GQ", alpha3: "GNQ", numeric: "226" }, { alpha2: "GR", alpha3: "GRC", numeric: "300" }, { alpha2: "GS", alpha3: "SGS", numeric: "239" }, { alpha2: "GT", alpha3: "GTM", numeric: "320" }, { alpha2: "GU", alpha3: "GUM", numeric: "316" }, { alpha2: "GW", alpha3: "GNB", numeric: "624" }, { alpha2: "GY", alpha3: "GUY", numeric: "328" }, { alpha2: "HK", alpha3: "HKG", numeric: "344" }, { alpha2: "HM", alpha3: "HMD", numeric: "334" }, { alpha2: "HN", alpha3: "HND", numeric: "340" }, { alpha2: "HR", alpha3: "HRV", numeric: "191" }, { alpha2: "HT", alpha3: "HTI", numeric: "332" }, { alpha2: "HU", alpha3: "HUN", numeric: "348" }, { alpha2: "ID", alpha3: "IDN", numeric: "360" }, { alpha2: "IE", alpha3: "IRL", numeric: "372" }, { alpha2: "IL", alpha3: "ISR", numeric: "376" }, { alpha2: "IM", alpha3: "IMN", numeric: "833" }, { alpha2: "IN", alpha3: "IND", numeric: "356" }, { alpha2: "IO", alpha3: "IOT", numeric: "086" }, { alpha2: "IQ", alpha3: "IRQ", numeric: "368" }, { alpha2: "IR", alpha3: "IRN", numeric: "364" }, { alpha2: "IS", alpha3: "ISL", numeric: "352" }, { alpha2: "IT", alpha3: "ITA", numeric: "380" }, { alpha2: "JE", alpha3: "JEY", numeric: "832" }, { alpha2: "JM", alpha3: "JAM", numeric: "388" }, { alpha2: "JO", alpha3: "JOR", numeric: "400" }, { alpha2: "JP", alpha3: "JPN", numeric: "392" }, { alpha2: "KE", alpha3: "KEN", numeric: "404" }, { alpha2: "KG", alpha3: "KGZ", numeric: "417" }, { alpha2: "KH", alpha3: "KHM", numeric: "116" }, { alpha2: "KI", alpha3: "KIR", numeric: "296" }, { alpha2: "KM", alpha3: "COM", numeric: "174" }, { alpha2: "KN", alpha3: "KNA", numeric: "659" }, { alpha2: "KP", alpha3: "PRK", numeric: "408" }, { alpha2: "KR", alpha3: "KOR", numeric: "410" }, { alpha2: "KW", alpha3: "KWT", numeric: "414" }, { alpha2: "KY", alpha3: "CYM", numeric: "136" }, { alpha2: "KZ", alpha3: "KAZ", numeric: "398" }, { alpha2: "LA", alpha3: "LAO", numeric: "418" }, { alpha2: "LB", alpha3: "LBN", numeric: "422" }, { alpha2: "LC", alpha3: "LCA", numeric: "662" }, { alpha2: "LI", alpha3: "LIE", numeric: "438" }, { alpha2: "LK", alpha3: "LKA", numeric: "144" }, { alpha2: "LR", alpha3: "LBR", numeric: "430" }, { alpha2: "LS", alpha3: "LSO", numeric: "426" }, { alpha2: "LT", alpha3: "LTU", numeric: "440" }, { alpha2: "LU", alpha3: "LUX", numeric: "442" }, { alpha2: "LV", alpha3: "LVA", numeric: "428" }, { alpha2: "LY", alpha3: "LBY", numeric: "434" }, { alpha2: "MA", alpha3: "MAR", numeric: "504" }, { alpha2: "MC", alpha3: "MCO", numeric: "492" }, { alpha2: "MD", alpha3: "MDA", numeric: "498" }, { alpha2: "ME", alpha3: "MNE", numeric: "499" }, { alpha2: "MF", alpha3: "MAF", numeric: "663" }, { alpha2: "MG", alpha3: "MDG", numeric: "450" }, { alpha2: "MH", alpha3: "MHL", numeric: "584" }, { alpha2: "MK", alpha3: "MKD", numeric: "807" }, { alpha2: "ML", alpha3: "MLI", numeric: "466" }, { alpha2: "MM", alpha3: "MMR", numeric: "104" }, { alpha2: "MN", alpha3: "MNG", numeric: "496" }, { alpha2: "MO", alpha3: "MAC", numeric: "446" }, { alpha2: "MP", alpha3: "MNP", numeric: "580" }, { alpha2: "MQ", alpha3: "MTQ", numeric: "474" }, { alpha2: "MR", alpha3: "MRT", numeric: "478" }, { alpha2: "MS", alpha3: "MSR", numeric: "500" }, { alpha2: "MT", alpha3: "MLT", numeric: "470" }, { alpha2: "MU", alpha3: "MUS", numeric: "480" }, { alpha2: "MV", alpha3: "MDV", numeric: "462" }, { alpha2: "MW", alpha3: "MWI", numeric: "454" }, { alpha2: "MX", alpha3: "MEX", numeric: "484" }, { alpha2: "MY", alpha3: "MYS", numeric: "458" }, { alpha2: "MZ", alpha3: "MOZ", numeric: "508" }, { alpha2: "NA", alpha3: "NAM", numeric: "516" }, { alpha2: "NC", alpha3: "NCL", numeric: "540" }, { alpha2: "NE", alpha3: "NER", numeric: "562" }, { alpha2: "NF", alpha3: "NFK", numeric: "574" }, { alpha2: "NG", alpha3: "NGA", numeric: "566" }, { alpha2: "NI", alpha3: "NIC", numeric: "558" }, { alpha2: "NL", alpha3: "NLD", numeric: "528" }, { alpha2: "NO", alpha3: "NOR", numeric: "578" }, { alpha2: "NP", alpha3: "NPL", numeric: "524" }, { alpha2: "NR", alpha3: "NRU", numeric: "520" }, { alpha2: "NU", alpha3: "NIU", numeric: "570" }, { alpha2: "NZ", alpha3: "NZL", numeric: "554" }, { alpha2: "OM", alpha3: "OMN", numeric: "512" }, { alpha2: "PA", alpha3: "PAN", numeric: "591" }, { alpha2: "PE", alpha3: "PER", numeric: "604" }, { alpha2: "PF", alpha3: "PYF", numeric: "258" }, { alpha2: "PG", alpha3: "PNG", numeric: "598" }, { alpha2: "PH", alpha3: "PHL", numeric: "608" }, { alpha2: "PK", alpha3: "PAK", numeric: "586" }, { alpha2: "PL", alpha3: "POL", numeric: "616" }, { alpha2: "PM", alpha3: "SPM", numeric: "666" }, { alpha2: "PN", alpha3: "PCN", numeric: "612" }, { alpha2: "PR", alpha3: "PRI", numeric: "630" }, { alpha2: "PS", alpha3: "PSE", numeric: "275" }, { alpha2: "PT", alpha3: "PRT", numeric: "620" }, { alpha2: "PW", alpha3: "PLW", numeric: "585" }, { alpha2: "PY", alpha3: "PRY", numeric: "600" }, { alpha2: "QA", alpha3: "QAT", numeric: "634" }, { alpha2: "RE", alpha3: "REU", numeric: "638" }, { alpha2: "RO", alpha3: "ROU", numeric: "642" }, { alpha2: "RS", alpha3: "SRB", numeric: "688" }, { alpha2: "RU", alpha3: "RUS", numeric: "643" }, { alpha2: "RW", alpha3: "RWA", numeric: "646" }, { alpha2: "SA", alpha3: "SAU", numeric: "682" }, { alpha2: "SB", alpha3: "SLB", numeric: "090" }, { alpha2: "SC", alpha3: "SYC", numeric: "690" }, { alpha2: "SD", alpha3: "SDN", numeric: "729" }, { alpha2: "SE", alpha3: "SWE", numeric: "752" }, { alpha2: "SG", alpha3: "SGP", numeric: "702" }, { alpha2: "SH", alpha3: "SHN", numeric: "654" }, { alpha2: "SI", alpha3: "SVN", numeric: "705" }, { alpha2: "SJ", alpha3: "SJM", numeric: "744" }, { alpha2: "SK", alpha3: "SVK", numeric: "703" }, { alpha2: "SL", alpha3: "SLE", numeric: "694" }, { alpha2: "SM", alpha3: "SMR", numeric: "674" }, { alpha2: "SN", alpha3: "SEN", numeric: "686" }, { alpha2: "SO", alpha3: "SOM", numeric: "706" }, { alpha2: "SR", alpha3: "SUR", numeric: "740" }, { alpha2: "SS", alpha3: "SSD", numeric: "728" }, { alpha2: "ST", alpha3: "STP", numeric: "678" }, { alpha2: "SV", alpha3: "SLV", numeric: "222" }, { alpha2: "SX", alpha3: "SXM", numeric: "534" }, { alpha2: "SY", alpha3: "SYR", numeric: "760" }, { alpha2: "SZ", alpha3: "SWZ", numeric: "748" }, { alpha2: "TC", alpha3: "TCA", numeric: "796" }, { alpha2: "TD", alpha3: "TCD", numeric: "148" }, { alpha2: "TF", alpha3: "ATF", numeric: "260" }, { alpha2: "TG", alpha3: "TGO", numeric: "768" }, { alpha2: "TH", alpha3: "THA", numeric: "764" }, { alpha2: "TJ", alpha3: "TJK", numeric: "762" }, { alpha2: "TK", alpha3: "TKL", numeric: "772" }, { alpha2: "TL", alpha3: "TLS", numeric: "626" }, { alpha2: "TM", alpha3: "TKM", numeric: "795" }, { alpha2: "TN", alpha3: "TUN", numeric: "788" }, { alpha2: "TO", alpha3: "TON", numeric: "776" }, { alpha2: "TR", alpha3: "TUR", numeric: "792" }, { alpha2: "TT", alpha3: "TTO", numeric: "780" }, { alpha2: "TV", alpha3: "TUV", numeric: "798" }, { alpha2: "TW", alpha3: "TWN", numeric: "158" }, { alpha2: "TZ", alpha3: "TZA", numeric: "834" }, { alpha2: "UA", alpha3: "UKR", numeric: "804" }, { alpha2: "UG", alpha3: "UGA", numeric: "800" }, { alpha2: "UM", alpha3: "UMI", numeric: "581" }, { alpha2: "US", alpha3: "USA", numeric: "840" }, { alpha2: "UY", alpha3: "URY", numeric: "858" }, { alpha2: "UZ", alpha3: "UZB", numeric: "860" }, { alpha2: "VA", alpha3: "VAT", numeric: "336" }, { alpha2: "VC", alpha3: "VCT", numeric: "670" }, { alpha2: "VE", alpha3: "VEN", numeric: "862" }, { alpha2: "VG", alpha3: "VGB", numeric: "092" }, { alpha2: "VI", alpha3: "VIR", numeric: "850" }, { alpha2: "VN", alpha3: "VNM", numeric: "704" }, { alpha2: "VU", alpha3: "VUT", numeric: "548" }, { alpha2: "WF", alpha3: "WLF", numeric: "876" }, { alpha2: "WS", alpha3: "WSM", numeric: "882" }, { alpha2: "YE", alpha3: "YEM", numeric: "887" }, { alpha2: "YT", alpha3: "MYT", numeric: "175" }, { alpha2: "ZA", alpha3: "ZAF", numeric: "710" }, { alpha2: "ZM", alpha3: "ZMB", numeric: "894" }, { alpha2: "ZW", alpha3: "ZWE", numeric: "716" }], A2e = { country_code: y2e, time_zone: cH }, E2e = A2e, S2e = { title: "Base", code: "base" }, w2e = S2e, F2e = ["/Applications", "/bin", "/boot", "/boot/defaults", "/dev", "/etc", "/etc/defaults", "/etc/mail", "/etc/namedb", "/etc/periodic", "/etc/ppp", "/home", "/home/user", "/home/user/dir", "/lib", "/Library", "/lost+found", "/media", "/mnt", "/net", "/Network", "/opt", "/opt/bin", "/opt/include", "/opt/lib", "/opt/sbin", "/opt/share", "/private", "/private/tmp", "/private/var", "/proc", "/rescue", "/root", "/sbin", "/selinux", "/srv", "/sys", "/System", "/tmp", "/Users", "/usr", "/usr/X11R6", "/usr/bin", "/usr/include", "/usr/lib", "/usr/libdata", "/usr/libexec", "/usr/local/bin", "/usr/local/src", "/usr/obj", "/usr/ports", "/usr/sbin", "/usr/share", "/usr/src", "/var", "/var/log", "/var/mail", "/var/spool", "/var/tmp", "/var/yp"], T2e = { "application/epub+zip": { extensions: ["epub"] }, "application/gzip": { extensions: ["gz"] }, "application/java-archive": { extensions: ["jar", "war", "ear"] }, "application/json": { extensions: ["json", "map"] }, "application/ld+json": { extensions: ["jsonld"] }, "application/msword": { extensions: ["doc", "dot"] }, "application/octet-stream": { extensions: ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"] }, "application/ogg": { extensions: ["ogx"] }, "application/pdf": { extensions: ["pdf"] }, "application/rtf": { extensions: ["rtf"] }, "application/vnd.amazon.ebook": { extensions: ["azw"] }, "application/vnd.apple.installer+xml": { extensions: ["mpkg"] }, "application/vnd.mozilla.xul+xml": { extensions: ["xul"] }, "application/vnd.ms-excel": { extensions: ["xls", "xlm", "xla", "xlc", "xlt", "xlw"] }, "application/vnd.ms-fontobject": { extensions: ["eot"] }, "application/vnd.ms-powerpoint": { extensions: ["ppt", "pps", "pot"] }, "application/vnd.oasis.opendocument.presentation": { extensions: ["odp"] }, "application/vnd.oasis.opendocument.spreadsheet": { extensions: ["ods"] }, "application/vnd.oasis.opendocument.text": { extensions: ["odt"] }, "application/vnd.openxmlformats-officedocument.presentationml.presentation": { extensions: ["pptx"] }, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { extensions: ["xlsx"] }, "application/vnd.openxmlformats-officedocument.wordprocessingml.document": { extensions: ["docx"] }, "application/vnd.rar": { extensions: ["rar"] }, "application/vnd.visio": { extensions: ["vsd", "vst", "vss", "vsw"] }, "application/x-7z-compressed": { extensions: ["7z"] }, "application/x-abiword": { extensions: ["abw"] }, "application/x-bzip": { extensions: ["bz"] }, "application/x-bzip2": { extensions: ["bz2", "boz"] }, "application/x-csh": { extensions: ["csh"] }, "application/x-freearc": { extensions: ["arc"] }, "application/x-httpd-php": { extensions: ["php"] }, "application/x-sh": { extensions: ["sh"] }, "application/x-tar": { extensions: ["tar"] }, "application/xhtml+xml": { extensions: ["xhtml", "xht"] }, "application/xml": { extensions: ["xml", "xsl", "xsd", "rng"] }, "application/zip": { extensions: ["zip"] }, "audio/3gpp": { extensions: ["3gpp"] }, "audio/3gpp2": { extensions: ["3g2"] }, "audio/aac": { extensions: ["aac"] }, "audio/midi": { extensions: ["mid", "midi", "kar", "rmi"] }, "audio/mpeg": { extensions: ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"] }, "audio/ogg": { extensions: ["oga", "ogg", "spx", "opus"] }, "audio/opus": { extensions: ["opus"] }, "audio/wav": { extensions: ["wav"] }, "audio/webm": { extensions: ["weba"] }, "font/otf": { extensions: ["otf"] }, "font/ttf": { extensions: ["ttf"] }, "font/woff": { extensions: ["woff"] }, "font/woff2": { extensions: ["woff2"] }, "image/avif": { extensions: ["avif"] }, "image/bmp": { extensions: ["bmp"] }, "image/gif": { extensions: ["gif"] }, "image/jpeg": { extensions: ["jpeg", "jpg", "jpe"] }, "image/png": { extensions: ["png"] }, "image/svg+xml": { extensions: ["svg", "svgz"] }, "image/tiff": { extensions: ["tif", "tiff"] }, "image/vnd.microsoft.icon": { extensions: ["ico"] }, "image/webp": { extensions: ["webp"] }, "text/calendar": { extensions: ["ics", "ifb"] }, "text/css": { extensions: ["css"] }, "text/csv": { extensions: ["csv"] }, "text/html": { extensions: ["html", "htm", "shtml"] }, "text/javascript": { extensions: ["js", "mjs"] }, "text/plain": { extensions: ["txt", "text", "conf", "def", "list", "log", "in", "ini"] }, "video/3gpp": { extensions: ["3gp", "3gpp"] }, "video/3gpp2": { extensions: ["3g2"] }, "video/mp2t": { extensions: ["ts"] }, "video/mp4": { extensions: ["mp4", "mp4v", "mpg4"] }, "video/mpeg": { extensions: ["mpeg", "mpg", "mpe", "m1v", "m2v"] }, "video/ogg": { extensions: ["ogv"] }, "video/webm": { extensions: ["webm"] }, "video/x-msvideo": { extensions: ["avi"] } }, v2e = { directory_path: F2e, mime_type: T2e }, x2e = v2e, C2e = { color: t2e, database: a2e, date: u2e, hacker: h2e, internet: b2e, location: E2e, metadata: w2e, system: x2e }, k2e = C2e, gn = new XCe({ locale: [Ixe, k2e] });
const hH = "mock-presets-wrapper-probe", Ew = [11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97], _2e = 101;
let _y = 0;
function dH() {
  if (_y < Ew.length)
    return Ew[_y++];
  const e = _y++ - Ew.length;
  return _2e + e;
}
function N2e() {
  gn.seed(42), _y = 0;
}
function D2e(t, e, n) {
  const r = {};
  for (const [i, s] of Object.entries(t.props))
    r[i] = jC(s, i, `props.${i}`, e, n);
  return r.wix = {
    elementsRemovalState: {},
    presetsWrapperProps: { className: hH }
  }, r;
}
function jC(t, e, n, r, i) {
  return !r && t.defaultValue !== void 0 ? I2e(t.defaultValue) : bf(t.resolvedType, e, n, r, i);
}
function I2e(t) {
  return t.value;
}
function bf(t, e, n, r, i) {
  const s = t.kind;
  if (s === "semantic")
    return R2e(t.value, e, n, r);
  switch (s) {
    case "primitive":
      return P2e(t.value, e, n, r);
    case "literal":
      return t.value;
    case "union":
      return L2e(t, e, n, r, i);
    case "intersection":
      return M2e(t, e, n, r, i);
    case "array":
      return O2e(t, e, n, r, i);
    case "object":
      return B2e(t, e, n, r, i);
    case "enum":
      return $2e(t);
    case "function":
      return H2e(e, n, r);
    default:
      return `mock_${e}_${gn.string.alphanumeric(6)}`;
  }
}
function R2e(t, e, n, r) {
  switch (t) {
    // Wix semantic types
    case "Image":
    case "ImageUri":
      return fH();
    case "Video":
    case "VideoUri":
      return U2e();
    case "Link":
      return mH();
    case "A11y":
      return V2e(n, r);
    case "VectorArt":
      return K2e();
    case "Audio":
    case "AudioUri":
      return z2e();
    case "RichText":
      return `<p>${gn.lorem.paragraph()}</p>`;
    case "LocalDate":
      return gn.date.recent().toISOString().split("T")[0];
    case "LocalTime":
      return gn.date.recent().toISOString().split("T")[1].split(".")[0];
    case "LocalDateTime":
      return gn.date.recent().toISOString().replace("Z", "");
    case "WebUrl":
      return gn.internet.url();
    case "Direction":
      return gn.helpers.arrayElement(["ltr", "rtl"]);
    case "MenuItems":
      return j2e();
    case "Container":
      return null;
    // React children - typically null for testing
    // React types
    case "ReactNode":
    case "ReactElement":
      return null;
    // Return null for React nodes in mock testing
    case "CSSProperties":
      return {
        color: gn.color.rgb(),
        fontSize: gn.number.int({ min: 12, max: 24 })
      };
    default:
      return `mock_${e}_${gn.string.alphanumeric(6)}`;
  }
}
function P2e(t, e, n, r) {
  switch (t) {
    case "string": {
      const i = `mock_${e}_${gn.string.alphanumeric(6)}`;
      return r && r.registerString(n, e, i), i;
    }
    case "number": {
      const i = dH();
      return r && r.registerNumber(n, e, i), i;
    }
    case "boolean":
      return gn.datatype.boolean();
    case "null":
      return null;
    case "undefined":
      return;
    default:
      return `mock_${e}_${gn.string.alphanumeric(6)}`;
  }
}
function L2e(t, e, n, r, i) {
  const s = t.types ?? [], a = s.find(
    (l) => l.kind === "literal" && typeof l.value == "string"
  );
  if (a)
    return a.value;
  const o = (l) => l.kind === "primitive" && (l.value === "undefined" || l.value === "null"), u = s.find((l) => !o(l)) ?? s[0];
  return u ? bf(u, e, n, r, i) : `mock_${e}_${gn.string.alphanumeric(6)}`;
}
function M2e(t, e, n, r, i) {
  const s = t.types ?? [], a = {};
  for (const o of s)
    if (o.kind === "object" && o.properties)
      for (const [u, l] of Object.entries(o.properties))
        a[u] = jC(l, `${e}.${u}`, `${n}.${u}`, r, i);
  return Object.keys(a).length > 0 ? a : `mock_${e}_${gn.string.alphanumeric(6)}`;
}
function O2e(t, e, n, r, i) {
  const s = t.elementType;
  return s ? [
    bf(s, `${e}[0]`, `${n}[0]`, r, i),
    bf(s, `${e}[1]`, `${n}[1]`, r, i)
  ] : [`mock_${e}[0]_${gn.string.alphanumeric(6)}`];
}
function B2e(t, e, n, r, i) {
  const s = t.properties ?? {}, a = {};
  for (const [u, l] of Object.entries(s))
    a[u] = jC(l, u, `${n}.${u}`, r, i);
  const o = o$(n);
  return o && i?.eligibleRefElementPaths?.has(o) && (a.id = XAe(o)), a;
}
function $2e(t) {
  const n = (t.types ?? []).find((r) => r.kind === "literal");
  return n ? n.value : "default";
}
function H2e(t, e, n) {
  const r = function() {
  };
  return Object.defineProperty(r, "name", { value: `mock_${t}` }), n && n.registerFunction(e, t, r), r;
}
function fH() {
  return {
    uri: gn.system.fileName({ extensionCount: 1 }),
    url: gn.image.url(),
    width: gn.number.int({ min: 100, max: 1920 }),
    height: gn.number.int({ min: 100, max: 1080 }),
    name: gn.lorem.words(2),
    alt: gn.lorem.sentence()
  };
}
function U2e() {
  const t = `${gn.internet.url()}/video.mp4`;
  return {
    uri: t,
    sources: [
      {
        quality: "720p",
        width: 1280,
        height: 720,
        types: [{ format: "mp4", uri: t, url: t }]
      }
    ],
    adaptiveSources: [],
    hasAudio: !0,
    fps: 30,
    poster: fH()
  };
}
function mH() {
  return {
    href: gn.internet.url(),
    target: gn.helpers.arrayElement(["_blank", "_self"]),
    rel: "noopener noreferrer"
  };
}
const G2e = [
  "ariaExpanded",
  "ariaDisabled",
  "ariaAtomic",
  "ariaHidden",
  "ariaBusy",
  "ariaAutocomplete",
  "ariaPressed",
  "ariaHaspopup",
  "ariaRelevant",
  "role",
  "ariaLive",
  "ariaCurrent",
  "ariaLabel",
  "ariaRoledescription",
  "ariaDescribedby",
  "ariaLabelledby",
  "ariaErrormessage",
  "ariaOwns",
  "ariaControls",
  "tag",
  "ariaMultiline",
  "ariaInvalid"
], W2e = ["tabIndex", "ariaLevel"];
function V2e(t, e) {
  const n = {};
  for (const r of G2e) {
    const i = `mock_a11y_${r}_${gn.string.alphanumeric(6)}`;
    e && e.registerString(`${t}.${r}`, r, i), n[r] = i;
  }
  for (const r of W2e) {
    const i = dH();
    e && e.registerNumber(`${t}.${r}`, r, i), n[r] = i;
  }
  return n;
}
function K2e() {
  return {
    svgId: gn.string.uuid(),
    url: `${gn.internet.url()}/icon.svg`,
    svgContent: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/></svg>'
  };
}
function z2e() {
  return {
    url: `${gn.internet.url()}/audio.mp3`,
    duration: gn.number.int({ min: 30, max: 600 }),
    name: gn.music.songName()
  };
}
function j2e() {
  return Array.from({ length: gn.number.int({ min: 2, max: 5 }) }, () => ({
    id: gn.string.uuid(),
    label: gn.lorem.words(2),
    link: mH()
  }));
}
function gH() {
  const t = new Proxy((() => {
  }), {
    get(e, n) {
      if (n !== "then") {
        if (n === Symbol.toPrimitive) return (r) => "mock";
        if (n === Symbol.iterator) return function* () {
        };
        if (n === Symbol.asyncIterator) return async function* () {
        };
        if (typeof n != "symbol")
          return t;
      }
    },
    ownKeys() {
      return [];
    },
    getOwnPropertyDescriptor() {
    },
    apply() {
      return t;
    }
  });
  return t;
}
function Y2e(t) {
  return new Proxy(t, {
    get(e, n) {
      if (n !== "then")
        return typeof n == "symbol" ? Reflect.get(e, n) : Object.prototype.hasOwnProperty.call(e, n) ? e[n] : gH();
    }
  });
}
function pH(t) {
  const e = {};
  for (const [n, r] of Object.entries(t.items))
    e[n] = bf(bH(r), n, `context.${n}`);
  return Y2e(e);
}
function bH(t) {
  switch (t.dataType) {
    case "text":
      return { kind: "primitive", value: "string" };
    case "richText":
      return { kind: "semantic", value: "RichText" };
    case "image":
      return { kind: "semantic", value: "Image" };
    case "video":
      return { kind: "semantic", value: "Video" };
    case "vectorArt":
      return { kind: "semantic", value: "VectorArt" };
    case "link":
      return { kind: "semantic", value: "Link" };
    case "function":
      return { kind: "function" };
    case "number":
      return { kind: "primitive", value: "number" };
    case "boolean":
      return { kind: "primitive", value: "boolean" };
    case "arrayItems": {
      const e = t.arrayItems?.item;
      return e ? { kind: "literal", value: [bf(
        bH(e),
        "item",
        "context.arrayItem"
      )] } : { kind: "literal", value: [] };
    }
    case "data": {
      const e = t.data;
      return e?.items && Object.keys(e.items).length > 0 ? { kind: "literal", value: pH(e) } : { kind: "literal", value: gH() };
    }
    default:
      return { kind: "primitive", value: "string" };
  }
}
const Nl = 0, He = 1, Rt = 2, ri = 3, or = 4, Po = 5, kA = 6, Xi = 7, Ds = 8, hn = 9, wt = 10, Dr = 11, cn = 12, Lr = 13, cp = 14, Is = 15, is = 16, ss = 17, Gs = 18, ca = 19, Ya = 20, kn = 21, yt = 22, Ri = 23, ua = 24, Ki = 25, q2e = 0;
function Vi(t) {
  return t >= 48 && t <= 57;
}
function yc(t) {
  return Vi(t) || // 0 .. 9
  t >= 65 && t <= 70 || // A .. F
  t >= 97 && t <= 102;
}
function YC(t) {
  return t >= 65 && t <= 90;
}
function J2e(t) {
  return t >= 97 && t <= 122;
}
function Q2e(t) {
  return YC(t) || J2e(t);
}
function X2e(t) {
  return t >= 128;
}
function b1(t) {
  return Q2e(t) || X2e(t) || t === 95;
}
function yH(t) {
  return b1(t) || Vi(t) || t === 45;
}
function Z2e(t) {
  return t >= 0 && t <= 8 || t === 11 || t >= 14 && t <= 31 || t === 127;
}
function y1(t) {
  return t === 10 || t === 13 || t === 12;
}
function wh(t) {
  return y1(t) || t === 32 || t === 9;
}
function ou(t, e) {
  return !(t !== 92 || y1(e) || e === q2e);
}
function Ny(t, e, n) {
  return t === 45 ? b1(e) || e === 45 || ou(e, n) : b1(t) ? !0 : t === 92 ? ou(t, e) : !1;
}
function Sw(t, e, n) {
  return t === 43 || t === 45 ? Vi(e) ? 2 : e === 46 && Vi(n) ? 3 : 0 : t === 46 ? Vi(e) ? 2 : 0 : Vi(t) ? 1 : 0;
}
function AH(t) {
  return t === 65279 || t === 65534 ? 1 : 0;
}
const qT = new Array(128), eke = 128, Dy = 130, EH = 131, qC = 132, SH = 133;
for (let t = 0; t < qT.length; t++)
  qT[t] = wh(t) && Dy || Vi(t) && EH || b1(t) && qC || Z2e(t) && SH || t || eke;
function ww(t) {
  return t < 128 ? qT[t] : qC;
}
function Kd(t, e) {
  return e < t.length ? t.charCodeAt(e) : 0;
}
function JT(t, e, n) {
  return n === 13 && Kd(t, e + 1) === 10 ? 2 : 1;
}
function zd(t, e, n) {
  let r = t.charCodeAt(e);
  return YC(r) && (r = r | 32), r === n;
}
function _g(t, e, n, r) {
  if (n - e !== r.length || e < 0 || n > t.length)
    return !1;
  for (let i = e; i < n; i++) {
    const s = r.charCodeAt(i - e);
    let a = t.charCodeAt(i);
    if (YC(a) && (a = a | 32), a !== s)
      return !1;
  }
  return !0;
}
function tke(t, e) {
  for (; e >= 0 && wh(t.charCodeAt(e)); e--)
    ;
  return e + 1;
}
function I0(t, e) {
  for (; e < t.length && wh(t.charCodeAt(e)); e++)
    ;
  return e;
}
function Fw(t, e) {
  for (; e < t.length && Vi(t.charCodeAt(e)); e++)
    ;
  return e;
}
function yf(t, e) {
  if (e += 2, yc(Kd(t, e - 1))) {
    for (const r = Math.min(t.length, e + 5); e < r && yc(Kd(t, e)); e++)
      ;
    const n = Kd(t, e);
    wh(n) && (e += JT(t, e, n));
  }
  return e;
}
function R0(t, e) {
  for (; e < t.length; e++) {
    const n = t.charCodeAt(e);
    if (!yH(n)) {
      if (ou(n, Kd(t, e + 1))) {
        e = yf(t, e) - 1;
        continue;
      }
      break;
    }
  }
  return e;
}
function _A(t, e) {
  let n = t.charCodeAt(e);
  if ((n === 43 || n === 45) && (n = t.charCodeAt(e += 1)), Vi(n) && (e = Fw(t, e + 1), n = t.charCodeAt(e)), n === 46 && Vi(t.charCodeAt(e + 1)) && (e += 2, e = Fw(t, e)), zd(
    t,
    e,
    101
    /* e */
  )) {
    let r = 0;
    n = t.charCodeAt(e + 1), (n === 45 || n === 43) && (r = 1, n = t.charCodeAt(e + 2)), Vi(n) && (e = Fw(t, e + 1 + r + 1));
  }
  return e;
}
function Tw(t, e) {
  for (; e < t.length; e++) {
    const n = t.charCodeAt(e);
    if (n === 41) {
      e++;
      break;
    }
    ou(n, Kd(t, e + 1)) && (e = yf(t, e));
  }
  return e;
}
function wH(t) {
  if (t.length === 1 && !yc(t.charCodeAt(0)))
    return t[0];
  let e = parseInt(t, 16);
  return (e === 0 || // If this number is zero,
  e >= 55296 && e <= 57343 || // or is for a surrogate,
  e > 1114111) && (e = 65533), String.fromCodePoint(e);
}
const QT = [
  "EOF-token",
  "ident-token",
  "function-token",
  "at-keyword-token",
  "hash-token",
  "string-token",
  "bad-string-token",
  "url-token",
  "bad-url-token",
  "delim-token",
  "number-token",
  "percentage-token",
  "dimension-token",
  "whitespace-token",
  "CDO-token",
  "CDC-token",
  "colon-token",
  "semicolon-token",
  "comma-token",
  "[-token",
  "]-token",
  "(-token",
  ")-token",
  "{-token",
  "}-token",
  "comment-token"
], nke = 16 * 1024;
function A1(t = null, e) {
  return t === null || t.length < e ? new Uint32Array(Math.max(e + 1024, nke)) : t;
}
const rR = 10, rke = 12, iR = 13;
function sR(t) {
  const e = t.source, n = e.length, r = e.length > 0 ? AH(e.charCodeAt(0)) : 0, i = A1(t.lines, n), s = A1(t.columns, n);
  let a = t.startLine, o = t.startColumn;
  for (let u = r; u < n; u++) {
    const l = e.charCodeAt(u);
    i[u] = a, s[u] = o++, (l === rR || l === iR || l === rke) && (l === iR && u + 1 < n && e.charCodeAt(u + 1) === rR && (u++, i[u] = a, s[u] = o), a++, o = 1);
  }
  i[n] = a, s[n] = o, t.lines = i, t.columns = s, t.computed = !0;
}
class ike {
  constructor(e, n, r, i) {
    this.setSource(e, n, r, i), this.lines = null, this.columns = null;
  }
  setSource(e = "", n = 0, r = 1, i = 1) {
    this.source = e, this.startOffset = n, this.startLine = r, this.startColumn = i, this.computed = !1;
  }
  getLocation(e, n) {
    return this.computed || sR(this), {
      source: n,
      offset: this.startOffset + e,
      line: this.lines[e],
      column: this.columns[e]
    };
  }
  getLocationRange(e, n, r) {
    return this.computed || sR(this), {
      source: r,
      start: {
        offset: this.startOffset + e,
        line: this.lines[e],
        column: this.columns[e]
      },
      end: {
        offset: this.startOffset + n,
        line: this.lines[n],
        column: this.columns[n]
      }
    };
  }
}
const ro = 16777215, io = 24, hp = 1, NA = 2, Ol = new Uint8Array(32);
Ol[Rt] = yt;
Ol[kn] = yt;
Ol[ca] = Ya;
Ol[Ri] = ua;
const Eo = new Uint8Array(32);
Eo[Rt] = hp;
Eo[kn] = hp;
Eo[ca] = hp;
Eo[Ri] = hp;
Eo[yt] = NA;
Eo[Ya] = NA;
Eo[ua] = NA;
function aR(t, e, n) {
  return t < e ? e : t > n ? n : t;
}
class ske {
  constructor(e, n) {
    this.setSource(e, n);
  }
  reset() {
    this.eof = !1, this.tokenIndex = -1, this.tokenType = 0, this.tokenStart = this.firstCharOffset, this.tokenEnd = this.firstCharOffset;
  }
  setSource(e = "", n = () => {
  }) {
    e = String(e || "");
    const r = e.length, i = A1(this.offsetAndType, e.length + 1), s = A1(this.balance, e.length + 1);
    let a = 0, o = -1, u = 0, l = e.length;
    this.offsetAndType = null, this.balance = null, s.fill(0), n(e, (h, f, m) => {
      const g = a++;
      if (i[g] = h << io | m, o === -1 && (o = f), s[g] = l, h === u) {
        const A = s[l];
        s[l] = g, l = A, u = Ol[i[A] >> io];
      } else this.isBlockOpenerTokenType(h) && (l = g, u = Ol[h]);
    }), i[a] = Nl << io | r, s[a] = a;
    for (let h = 0; h < a; h++) {
      const f = s[h];
      if (f <= h) {
        const m = s[f];
        m !== h && (s[h] = m);
      } else f > a && (s[h] = a);
    }
    this.source = e, this.firstCharOffset = o === -1 ? 0 : o, this.tokenCount = a, this.offsetAndType = i, this.balance = s, this.reset(), this.next();
  }
  lookupType(e) {
    return e += this.tokenIndex, e < this.tokenCount ? this.offsetAndType[e] >> io : Nl;
  }
  lookupTypeNonSC(e) {
    for (let n = this.tokenIndex; n < this.tokenCount; n++) {
      const r = this.offsetAndType[n] >> io;
      if (r !== Lr && r !== Ki && e-- === 0)
        return r;
    }
    return Nl;
  }
  lookupOffset(e) {
    return e += this.tokenIndex, e < this.tokenCount ? this.offsetAndType[e - 1] & ro : this.source.length;
  }
  lookupOffsetNonSC(e) {
    for (let n = this.tokenIndex; n < this.tokenCount; n++) {
      const r = this.offsetAndType[n] >> io;
      if (r !== Lr && r !== Ki && e-- === 0)
        return n - this.tokenIndex;
    }
    return Nl;
  }
  lookupValue(e, n) {
    return e += this.tokenIndex, e < this.tokenCount ? _g(
      this.source,
      this.offsetAndType[e - 1] & ro,
      this.offsetAndType[e] & ro,
      n
    ) : !1;
  }
  getTokenStart(e) {
    return e === this.tokenIndex ? this.tokenStart : e > 0 ? e < this.tokenCount ? this.offsetAndType[e - 1] & ro : this.offsetAndType[this.tokenCount] & ro : this.firstCharOffset;
  }
  getTokenEnd(e) {
    return e === this.tokenIndex ? this.tokenEnd : this.offsetAndType[aR(e, 0, this.tokenCount)] & ro;
  }
  getTokenType(e) {
    return e === this.tokenIndex ? this.tokenType : this.offsetAndType[aR(e, 0, this.tokenCount)] >> io;
  }
  substrToCursor(e) {
    return this.source.substring(e, this.tokenStart);
  }
  isBlockOpenerTokenType(e) {
    return Eo[e] === hp;
  }
  isBlockCloserTokenType(e) {
    return Eo[e] === NA;
  }
  getBlockTokenPairIndex(e) {
    const n = this.getTokenType(e);
    if (Eo[n] === 1) {
      const r = this.balance[e], i = this.getTokenType(r);
      return Ol[n] === i ? r : -1;
    } else if (Eo[n] === 2) {
      const r = this.balance[e], i = this.getTokenType(r);
      return Ol[i] === n ? r : -1;
    }
    return -1;
  }
  isBalanceEdge(e) {
    return this.balance[this.tokenIndex] < e;
  }
  isDelim(e, n) {
    return n ? this.lookupType(n) === hn && this.source.charCodeAt(this.lookupOffset(n)) === e : this.tokenType === hn && this.source.charCodeAt(this.tokenStart) === e;
  }
  skip(e) {
    let n = this.tokenIndex + e;
    n < this.tokenCount ? (this.tokenIndex = n, this.tokenStart = this.offsetAndType[n - 1] & ro, n = this.offsetAndType[n], this.tokenType = n >> io, this.tokenEnd = n & ro) : (this.tokenIndex = this.tokenCount, this.next());
  }
  next() {
    let e = this.tokenIndex + 1;
    e < this.tokenCount ? (this.tokenIndex = e, this.tokenStart = this.tokenEnd, e = this.offsetAndType[e], this.tokenType = e >> io, this.tokenEnd = e & ro) : (this.eof = !0, this.tokenIndex = this.tokenCount, this.tokenType = Nl, this.tokenStart = this.tokenEnd = this.source.length);
  }
  skipSC() {
    for (; this.tokenType === Lr || this.tokenType === Ki; )
      this.next();
  }
  skipUntilBalanced(e, n) {
    let r = e, i = 0, s = 0;
    e:
      for (; r < this.tokenCount; r++) {
        if (i = this.balance[r], i < e)
          break e;
        switch (s = r > 0 ? this.offsetAndType[r - 1] & ro : this.firstCharOffset, n(this.source.charCodeAt(s))) {
          case 1:
            break e;
          case 2:
            r++;
            break e;
          default:
            this.isBlockOpenerTokenType(this.offsetAndType[r] >> io) && (r = i);
        }
      }
    this.skip(r - this.tokenIndex);
  }
  forEachToken(e) {
    for (let n = 0, r = this.firstCharOffset; n < this.tokenCount; n++) {
      const i = r, s = this.offsetAndType[n], a = s & ro, o = s >> io;
      r = a, e(o, i, a, n);
    }
  }
  dump() {
    const e = new Array(this.tokenCount);
    return this.forEachToken((n, r, i, s) => {
      e[s] = {
        idx: s,
        type: QT[n],
        chunk: this.source.substring(r, i),
        balance: this.balance[s]
      };
    }), e;
  }
}
function DA(t, e) {
  function n(f) {
    return f < o ? t.charCodeAt(f) : 0;
  }
  function r() {
    if (l = _A(t, l), Ny(n(l), n(l + 1), n(l + 2))) {
      h = cn, l = R0(t, l);
      return;
    }
    if (n(l) === 37) {
      h = Dr, l++;
      return;
    }
    h = wt;
  }
  function i() {
    const f = l;
    if (l = R0(t, l), _g(t, f, l, "url") && n(l) === 40) {
      if (l = I0(t, l + 1), n(l) === 34 || n(l) === 39) {
        h = Rt, l = f + 4;
        return;
      }
      a();
      return;
    }
    if (n(l) === 40) {
      h = Rt, l++;
      return;
    }
    h = He;
  }
  function s(f) {
    for (f || (f = n(l++)), h = Po; l < t.length; l++) {
      const m = t.charCodeAt(l);
      switch (ww(m)) {
        // ending code point
        case f:
          l++;
          return;
        // EOF
        // case EofCategory:
        // This is a parse error. Return the <string-token>.
        // return;
        // newline
        case Dy:
          if (y1(m)) {
            l += JT(t, l, m), h = kA;
            return;
          }
          break;
        // U+005C REVERSE SOLIDUS (\)
        case 92:
          if (l === t.length - 1)
            break;
          const g = n(l + 1);
          y1(g) ? l += JT(t, l + 1, g) : ou(m, g) && (l = yf(t, l) - 1);
          break;
      }
    }
  }
  function a() {
    for (h = Xi, l = I0(t, l); l < t.length; l++) {
      const f = t.charCodeAt(l);
      switch (ww(f)) {
        // U+0029 RIGHT PARENTHESIS ())
        case 41:
          l++;
          return;
        // EOF
        // case EofCategory:
        // This is a parse error. Return the <url-token>.
        // return;
        // whitespace
        case Dy:
          if (l = I0(t, l), n(l) === 41 || l >= t.length) {
            l < t.length && l++;
            return;
          }
          l = Tw(t, l), h = Ds;
          return;
        // U+0022 QUOTATION MARK (")
        // U+0027 APOSTROPHE (')
        // U+0028 LEFT PARENTHESIS (()
        // non-printable code point
        case 34:
        case 39:
        case 40:
        case SH:
          l = Tw(t, l), h = Ds;
          return;
        // U+005C REVERSE SOLIDUS (\)
        case 92:
          if (ou(f, n(l + 1))) {
            l = yf(t, l) - 1;
            break;
          }
          l = Tw(t, l), h = Ds;
          return;
      }
    }
  }
  t = String(t || "");
  const o = t.length;
  let u = AH(n(0)), l = u, h;
  for (; l < o; ) {
    const f = t.charCodeAt(l);
    switch (ww(f)) {
      // whitespace
      case Dy:
        h = Lr, l = I0(t, l + 1);
        break;
      // U+0022 QUOTATION MARK (")
      case 34:
        s();
        break;
      // U+0023 NUMBER SIGN (#)
      case 35:
        yH(n(l + 1)) || ou(n(l + 1), n(l + 2)) ? (h = or, l = R0(t, l + 1)) : (h = hn, l++);
        break;
      // U+0027 APOSTROPHE (')
      case 39:
        s();
        break;
      // U+0028 LEFT PARENTHESIS (()
      case 40:
        h = kn, l++;
        break;
      // U+0029 RIGHT PARENTHESIS ())
      case 41:
        h = yt, l++;
        break;
      // U+002B PLUS SIGN (+)
      case 43:
        Sw(f, n(l + 1), n(l + 2)) ? r() : (h = hn, l++);
        break;
      // U+002C COMMA (,)
      case 44:
        h = Gs, l++;
        break;
      // U+002D HYPHEN-MINUS (-)
      case 45:
        Sw(f, n(l + 1), n(l + 2)) ? r() : n(l + 1) === 45 && n(l + 2) === 62 ? (h = Is, l = l + 3) : Ny(f, n(l + 1), n(l + 2)) ? i() : (h = hn, l++);
        break;
      // U+002E FULL STOP (.)
      case 46:
        Sw(f, n(l + 1), n(l + 2)) ? r() : (h = hn, l++);
        break;
      // U+002F SOLIDUS (/)
      case 47:
        n(l + 1) === 42 ? (h = Ki, l = t.indexOf("*/", l + 2), l = l === -1 ? t.length : l + 2) : (h = hn, l++);
        break;
      // U+003A COLON (:)
      case 58:
        h = is, l++;
        break;
      // U+003B SEMICOLON (;)
      case 59:
        h = ss, l++;
        break;
      // U+003C LESS-THAN SIGN (<)
      case 60:
        n(l + 1) === 33 && n(l + 2) === 45 && n(l + 3) === 45 ? (h = cp, l = l + 4) : (h = hn, l++);
        break;
      // U+0040 COMMERCIAL AT (@)
      case 64:
        Ny(n(l + 1), n(l + 2), n(l + 3)) ? (h = ri, l = R0(t, l + 1)) : (h = hn, l++);
        break;
      // U+005B LEFT SQUARE BRACKET ([)
      case 91:
        h = ca, l++;
        break;
      // U+005C REVERSE SOLIDUS (\)
      case 92:
        ou(f, n(l + 1)) ? i() : (h = hn, l++);
        break;
      // U+005D RIGHT SQUARE BRACKET (])
      case 93:
        h = Ya, l++;
        break;
      // U+007B LEFT CURLY BRACKET ({)
      case 123:
        h = Ri, l++;
        break;
      // U+007D RIGHT CURLY BRACKET (})
      case 125:
        h = ua, l++;
        break;
      // digit
      case EH:
        r();
        break;
      // name-start code point
      case qC:
        i();
        break;
      // EOF
      // case EofCategory:
      // Return an <EOF-token>.
      // break;
      // anything else
      default:
        h = hn, l++;
    }
    e(h, u, u = l);
  }
}
let td = null;
class wi {
  static createItem(e) {
    return {
      prev: null,
      next: null,
      data: e
    };
  }
  constructor() {
    this.head = null, this.tail = null, this.cursor = null;
  }
  createItem(e) {
    return wi.createItem(e);
  }
  // cursor helpers
  allocateCursor(e, n) {
    let r;
    return td !== null ? (r = td, td = td.cursor, r.prev = e, r.next = n, r.cursor = this.cursor) : r = {
      prev: e,
      next: n,
      cursor: this.cursor
    }, this.cursor = r, r;
  }
  releaseCursor() {
    const { cursor: e } = this;
    this.cursor = e.cursor, e.prev = null, e.next = null, e.cursor = td, td = e;
  }
  updateCursors(e, n, r, i) {
    let { cursor: s } = this;
    for (; s !== null; )
      s.prev === e && (s.prev = n), s.next === r && (s.next = i), s = s.cursor;
  }
  *[Symbol.iterator]() {
    for (let e = this.head; e !== null; e = e.next)
      yield e.data;
  }
  // getters
  get size() {
    let e = 0;
    for (let n = this.head; n !== null; n = n.next)
      e++;
    return e;
  }
  get isEmpty() {
    return this.head === null;
  }
  get first() {
    return this.head && this.head.data;
  }
  get last() {
    return this.tail && this.tail.data;
  }
  // convertors
  fromArray(e) {
    let n = null;
    this.head = null;
    for (let r of e) {
      const i = wi.createItem(r);
      n !== null ? n.next = i : this.head = i, i.prev = n, n = i;
    }
    return this.tail = n, this;
  }
  toArray() {
    return [...this];
  }
  toJSON() {
    return [...this];
  }
  // array-like methods
  forEach(e, n = this) {
    const r = this.allocateCursor(null, this.head);
    for (; r.next !== null; ) {
      const i = r.next;
      r.next = i.next, e.call(n, i.data, i, this);
    }
    this.releaseCursor();
  }
  forEachRight(e, n = this) {
    const r = this.allocateCursor(this.tail, null);
    for (; r.prev !== null; ) {
      const i = r.prev;
      r.prev = i.prev, e.call(n, i.data, i, this);
    }
    this.releaseCursor();
  }
  reduce(e, n, r = this) {
    let i = this.allocateCursor(null, this.head), s = n, a;
    for (; i.next !== null; )
      a = i.next, i.next = a.next, s = e.call(r, s, a.data, a, this);
    return this.releaseCursor(), s;
  }
  reduceRight(e, n, r = this) {
    let i = this.allocateCursor(this.tail, null), s = n, a;
    for (; i.prev !== null; )
      a = i.prev, i.prev = a.prev, s = e.call(r, s, a.data, a, this);
    return this.releaseCursor(), s;
  }
  some(e, n = this) {
    for (let r = this.head; r !== null; r = r.next)
      if (e.call(n, r.data, r, this))
        return !0;
    return !1;
  }
  map(e, n = this) {
    const r = new wi();
    for (let i = this.head; i !== null; i = i.next)
      r.appendData(e.call(n, i.data, i, this));
    return r;
  }
  filter(e, n = this) {
    const r = new wi();
    for (let i = this.head; i !== null; i = i.next)
      e.call(n, i.data, i, this) && r.appendData(i.data);
    return r;
  }
  nextUntil(e, n, r = this) {
    if (e === null)
      return;
    const i = this.allocateCursor(null, e);
    for (; i.next !== null; ) {
      const s = i.next;
      if (i.next = s.next, n.call(r, s.data, s, this))
        break;
    }
    this.releaseCursor();
  }
  prevUntil(e, n, r = this) {
    if (e === null)
      return;
    const i = this.allocateCursor(e, null);
    for (; i.prev !== null; ) {
      const s = i.prev;
      if (i.prev = s.prev, n.call(r, s.data, s, this))
        break;
    }
    this.releaseCursor();
  }
  // mutation
  clear() {
    this.head = null, this.tail = null;
  }
  copy() {
    const e = new wi();
    for (let n of this)
      e.appendData(n);
    return e;
  }
  prepend(e) {
    return this.updateCursors(null, e, this.head, e), this.head !== null ? (this.head.prev = e, e.next = this.head) : this.tail = e, this.head = e, this;
  }
  prependData(e) {
    return this.prepend(wi.createItem(e));
  }
  append(e) {
    return this.insert(e);
  }
  appendData(e) {
    return this.insert(wi.createItem(e));
  }
  insert(e, n = null) {
    if (n !== null)
      if (this.updateCursors(n.prev, e, n, e), n.prev === null) {
        if (this.head !== n)
          throw new Error("before doesn't belong to list");
        this.head = e, n.prev = e, e.next = n, this.updateCursors(null, e);
      } else
        n.prev.next = e, e.prev = n.prev, n.prev = e, e.next = n;
    else
      this.updateCursors(this.tail, e, null, e), this.tail !== null ? (this.tail.next = e, e.prev = this.tail) : this.head = e, this.tail = e;
    return this;
  }
  insertData(e, n) {
    return this.insert(wi.createItem(e), n);
  }
  remove(e) {
    if (this.updateCursors(e, e.prev, e, e.next), e.prev !== null)
      e.prev.next = e.next;
    else {
      if (this.head !== e)
        throw new Error("item doesn't belong to list");
      this.head = e.next;
    }
    if (e.next !== null)
      e.next.prev = e.prev;
    else {
      if (this.tail !== e)
        throw new Error("item doesn't belong to list");
      this.tail = e.prev;
    }
    return e.prev = null, e.next = null, e;
  }
  push(e) {
    this.insert(wi.createItem(e));
  }
  pop() {
    return this.tail !== null ? this.remove(this.tail) : null;
  }
  unshift(e) {
    this.prepend(wi.createItem(e));
  }
  shift() {
    return this.head !== null ? this.remove(this.head) : null;
  }
  prependList(e) {
    return this.insertList(e, this.head);
  }
  appendList(e) {
    return this.insertList(e);
  }
  insertList(e, n) {
    return e.head === null ? this : (n != null ? (this.updateCursors(n.prev, e.tail, n, e.head), n.prev !== null ? (n.prev.next = e.head, e.head.prev = n.prev) : this.head = e.head, n.prev = e.tail, e.tail.next = n) : (this.updateCursors(this.tail, e.tail, null, e.head), this.tail !== null ? (this.tail.next = e.head, e.head.prev = this.tail) : this.head = e.head, this.tail = e.tail), e.head = null, e.tail = null, this);
  }
  replace(e, n) {
    "head" in n ? this.insertList(n, e) : this.insert(n, e), this.remove(e);
  }
}
function IA(t, e) {
  const n = Object.create(SyntaxError.prototype), r = new Error();
  return Object.assign(n, {
    name: t,
    message: e,
    get stack() {
      return (r.stack || "").replace(/^(.+\n){1,3}/, `${t}: ${e}
`);
    }
  });
}
const vw = 100, oR = 60, uR = "    ";
function lR({ source: t, line: e, column: n, baseLine: r, baseColumn: i }, s) {
  function a(A, E) {
    return l.slice(A, E).map(
      (w, x) => String(A + x + 1).padStart(m) + " |" + w
    ).join(`
`);
  }
  const o = `
`.repeat(Math.max(r - 1, 0)), u = " ".repeat(Math.max(i - 1, 0)), l = (o + u + t).split(/\r\n?|\n|\f/), h = Math.max(1, e - s) - 1, f = Math.min(e + s, l.length + 1), m = Math.max(4, String(f).length) + 1;
  let g = 0;
  n += (uR.length - 1) * (l[e - 1].substr(0, n - 1).match(/\t/g) || []).length, n > vw && (g = n - oR + 3, n = oR - 2);
  for (let A = h; A <= f; A++)
    A >= 0 && A < l.length && (l[A] = l[A].replace(/\t/g, uR), l[A] = (g > 0 && l[A].length > g ? "…" : "") + l[A].substr(g, vw - 2) + (l[A].length > g + vw - 1 ? "…" : ""));
  return [
    a(h, e),
    new Array(n + m + 2).join("-") + "^",
    a(e, f)
  ].filter(Boolean).join(`
`).replace(/^(\s+\d+\s+\|\n)+/, "").replace(/\n(\s+\d+\s+\|)+$/, "");
}
function cR(t, e, n, r, i, s = 1, a = 1) {
  return Object.assign(IA("SyntaxError", t), {
    source: e,
    offset: n,
    line: r,
    column: i,
    sourceFragment(u) {
      return lR({ source: e, line: r, column: i, baseLine: s, baseColumn: a }, isNaN(u) ? 0 : u);
    },
    get formattedMessage() {
      return `Parse error: ${t}
` + lR({ source: e, line: r, column: i, baseLine: s, baseColumn: a }, 2);
    }
  });
}
function ake(t) {
  const e = this.createList();
  let n = !1;
  const r = {
    recognizer: t
  };
  for (; !this.eof; ) {
    switch (this.tokenType) {
      case Ki:
        this.next();
        continue;
      case Lr:
        n = !0, this.next();
        continue;
    }
    let i = t.getNode.call(this, r);
    if (i === void 0)
      break;
    n && (t.onWhiteSpace && t.onWhiteSpace.call(this, i, e, r), n = !1), e.push(i);
  }
  return n && t.onWhiteSpace && t.onWhiteSpace.call(this, null, e, r), e;
}
const nd = () => {
}, oke = 33, uke = 35, xw = 59, hR = 123, dR = 0, lke = {
  createList() {
    return [];
  },
  createSingleNodeList(t) {
    return [t];
  },
  getFirstListNode(t) {
    return t && t[0] || null;
  },
  getLastListNode(t) {
    return t && t.length > 0 ? t[t.length - 1] : null;
  }
}, cke = {
  createList() {
    return new wi();
  },
  createSingleNodeList(t) {
    return new wi().appendData(t);
  },
  getFirstListNode(t) {
    return t && t.first;
  },
  getLastListNode(t) {
    return t && t.last;
  }
};
function hke(t) {
  return function() {
    return this[t]();
  };
}
function Cw(t) {
  const e = /* @__PURE__ */ Object.create(null);
  for (const n of Object.keys(t)) {
    const r = t[n], i = r.parse || r;
    i && (e[n] = i);
  }
  return e;
}
function dke(t) {
  const e = {
    context: /* @__PURE__ */ Object.create(null),
    features: Object.assign(/* @__PURE__ */ Object.create(null), t.features),
    scope: Object.assign(/* @__PURE__ */ Object.create(null), t.scope),
    atrule: Cw(t.atrule),
    pseudo: Cw(t.pseudo),
    node: Cw(t.node)
  };
  for (const [n, r] of Object.entries(t.parseContext))
    switch (typeof r) {
      case "function":
        e.context[n] = r;
        break;
      case "string":
        e.context[n] = hke(r);
        break;
    }
  return {
    config: e,
    ...e,
    ...e.node
  };
}
function fke(t) {
  let e = "", n = "<unknown>", r = !1, i = nd, s = !1;
  const a = new ike(), o = Object.assign(new ske(), dke(t || {}), {
    parseAtrulePrelude: !0,
    parseRulePrelude: !0,
    parseValue: !0,
    parseCustomProperty: !1,
    readSequence: ake,
    consumeUntilBalanceEnd: () => 0,
    consumeUntilLeftCurlyBracket(h) {
      return h === hR ? 1 : 0;
    },
    consumeUntilLeftCurlyBracketOrSemicolon(h) {
      return h === hR || h === xw ? 1 : 0;
    },
    consumeUntilExclamationMarkOrSemicolon(h) {
      return h === oke || h === xw ? 1 : 0;
    },
    consumeUntilSemicolonIncluded(h) {
      return h === xw ? 2 : 0;
    },
    createList: nd,
    createSingleNodeList: nd,
    getFirstListNode: nd,
    getLastListNode: nd,
    parseWithFallback(h, f) {
      const m = this.tokenIndex;
      try {
        return h.call(this);
      } catch (g) {
        if (s)
          throw g;
        this.skip(m - this.tokenIndex);
        const A = f.call(this);
        return s = !0, i(g, A), s = !1, A;
      }
    },
    lookupNonWSType(h) {
      let f;
      do
        if (f = this.lookupType(h++), f !== Lr && f !== Ki)
          return f;
      while (f !== dR);
      return dR;
    },
    charCodeAt(h) {
      return h >= 0 && h < e.length ? e.charCodeAt(h) : 0;
    },
    substring(h, f) {
      return e.substring(h, f);
    },
    substrToCursor(h) {
      return this.source.substring(h, this.tokenStart);
    },
    cmpChar(h, f) {
      return zd(e, h, f);
    },
    cmpStr(h, f, m) {
      return _g(e, h, f, m);
    },
    consume(h) {
      const f = this.tokenStart;
      return this.eat(h), this.substrToCursor(f);
    },
    consumeFunctionName() {
      const h = e.substring(this.tokenStart, this.tokenEnd - 1);
      return this.eat(Rt), h;
    },
    consumeNumber(h) {
      const f = e.substring(this.tokenStart, _A(e, this.tokenStart));
      return this.eat(h), f;
    },
    eat(h) {
      if (this.tokenType !== h) {
        const f = QT[h].slice(0, -6).replace(/-/g, " ").replace(/^./, (A) => A.toUpperCase());
        let m = `${/[[\](){}]/.test(f) ? `"${f}"` : f} is expected`, g = this.tokenStart;
        switch (h) {
          case He:
            this.tokenType === Rt || this.tokenType === Xi ? (g = this.tokenEnd - 1, m = "Identifier is expected but function found") : m = "Identifier is expected";
            break;
          case or:
            this.isDelim(uke) && (this.next(), g++, m = "Name is expected");
            break;
          case Dr:
            this.tokenType === wt && (g = this.tokenEnd, m = "Percent sign is expected");
            break;
        }
        this.error(m, g);
      }
      this.next();
    },
    eatIdent(h) {
      (this.tokenType !== He || this.lookupValue(0, h) === !1) && this.error(`Identifier "${h}" is expected`), this.next();
    },
    eatDelim(h) {
      this.isDelim(h) || this.error(`Delim "${String.fromCharCode(h)}" is expected`), this.next();
    },
    getLocation(h, f) {
      return r ? a.getLocationRange(
        h,
        f,
        n
      ) : null;
    },
    getLocationFromList(h) {
      if (r) {
        const f = this.getFirstListNode(h), m = this.getLastListNode(h);
        return a.getLocationRange(
          f !== null ? f.loc.start.offset - a.startOffset : this.tokenStart,
          m !== null ? m.loc.end.offset - a.startOffset : this.tokenStart,
          n
        );
      }
      return null;
    },
    error(h, f) {
      const m = typeof f < "u" && f < e.length ? a.getLocation(f) : this.eof ? a.getLocation(tke(e, e.length - 1)) : a.getLocation(this.tokenStart);
      throw new cR(
        h || "Unexpected input",
        e,
        m.offset,
        m.line,
        m.column,
        a.startLine,
        a.startColumn
      );
    }
  }), u = () => ({
    filename: n,
    source: e,
    tokenCount: o.tokenCount,
    getTokenType: (h) => o.getTokenType(h),
    getTokenTypeName: (h) => QT[o.getTokenType(h)],
    getTokenStart: (h) => o.getTokenStart(h),
    getTokenEnd: (h) => o.getTokenEnd(h),
    getTokenValue: (h) => o.source.substring(o.getTokenStart(h), o.getTokenEnd(h)),
    substring: (h, f) => o.source.substring(h, f),
    balance: o.balance.subarray(0, o.tokenCount + 1),
    isBlockOpenerTokenType: o.isBlockOpenerTokenType,
    isBlockCloserTokenType: o.isBlockCloserTokenType,
    getBlockTokenPairIndex: (h) => o.getBlockTokenPairIndex(h),
    getLocation: (h) => a.getLocation(h, n),
    getRangeLocation: (h, f) => a.getLocationRange(h, f, n)
  });
  return Object.assign(function(h, f) {
    e = h, f = f || {}, o.setSource(e, DA), a.setSource(
      e,
      f.offset,
      f.line,
      f.column
    ), n = f.filename || "<unknown>", r = !!f.positions, i = typeof f.onParseError == "function" ? f.onParseError : nd, s = !1, o.parseAtrulePrelude = "parseAtrulePrelude" in f ? !!f.parseAtrulePrelude : !0, o.parseRulePrelude = "parseRulePrelude" in f ? !!f.parseRulePrelude : !0, o.parseValue = "parseValue" in f ? !!f.parseValue : !0, o.parseCustomProperty = "parseCustomProperty" in f ? !!f.parseCustomProperty : !1;
    const { context: m = "default", list: g = !0, onComment: A, onToken: E } = f;
    if (!(m in o.context))
      throw new Error("Unknown context `" + m + "`");
    Object.assign(o, g ? cke : lke), Array.isArray(E) ? o.forEachToken((x, N, B) => {
      E.push({ type: x, start: N, end: B });
    }) : typeof E == "function" && o.forEachToken(E.bind(u())), typeof A == "function" && o.forEachToken((x, N, B) => {
      if (x === Ki) {
        const P = o.getLocation(N, B), C = _g(e, B - 2, B, "*/") ? e.slice(N + 2, B - 2) : e.slice(N + 2, B);
        A(C, P);
      }
    });
    const w = o.context[m].call(o, f);
    return o.eof || o.error(), w;
  }, {
    SyntaxError: cR,
    config: o.config
  });
}
var kw = {}, P0 = {}, L0 = {}, fR;
function mke() {
  if (fR) return L0;
  fR = 1;
  var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
  return L0.encode = function(e) {
    if (0 <= e && e < t.length)
      return t[e];
    throw new TypeError("Must be between 0 and 63: " + e);
  }, L0.decode = function(e) {
    var n = 65, r = 90, i = 97, s = 122, a = 48, o = 57, u = 43, l = 47, h = 26, f = 52;
    return n <= e && e <= r ? e - n : i <= e && e <= s ? e - i + h : a <= e && e <= o ? e - a + f : e == u ? 62 : e == l ? 63 : -1;
  }, L0;
}
var mR;
function gke() {
  if (mR) return P0;
  mR = 1;
  var t = mke(), e = 5, n = 1 << e, r = n - 1, i = n;
  function s(o) {
    return o < 0 ? (-o << 1) + 1 : (o << 1) + 0;
  }
  function a(o) {
    var u = (o & 1) === 1, l = o >> 1;
    return u ? -l : l;
  }
  return P0.encode = function(u) {
    var l = "", h, f = s(u);
    do
      h = f & r, f >>>= e, f > 0 && (h |= i), l += t.encode(h);
    while (f > 0);
    return l;
  }, P0.decode = function(u, l, h) {
    var f = u.length, m = 0, g = 0, A, E;
    do {
      if (l >= f)
        throw new Error("Expected more digits in base 64 VLQ value.");
      if (E = t.decode(u.charCodeAt(l++)), E === -1)
        throw new Error("Invalid base64 digit: " + u.charAt(l - 1));
      A = !!(E & i), E &= r, m = m + (E << g), g += e;
    } while (A);
    h.value = a(m), h.rest = l;
  }, P0;
}
var _w = {}, gR;
function JC() {
  return gR || (gR = 1, (function(t) {
    function e(k, I, U) {
      if (I in k)
        return k[I];
      if (arguments.length === 3)
        return U;
      throw new Error('"' + I + '" is a required argument.');
    }
    t.getArg = e;
    var n = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/, r = /^data:.+\,.+$/;
    function i(k) {
      var I = k.match(n);
      return I ? {
        scheme: I[1],
        auth: I[2],
        host: I[3],
        port: I[4],
        path: I[5]
      } : null;
    }
    t.urlParse = i;
    function s(k) {
      var I = "";
      return k.scheme && (I += k.scheme + ":"), I += "//", k.auth && (I += k.auth + "@"), k.host && (I += k.host), k.port && (I += ":" + k.port), k.path && (I += k.path), I;
    }
    t.urlGenerate = s;
    var a = 32;
    function o(k) {
      var I = [];
      return function(U) {
        for (var j = 0; j < I.length; j++)
          if (I[j].input === U) {
            var J = I[0];
            return I[0] = I[j], I[j] = J, I[0].result;
          }
        var G = k(U);
        return I.unshift({
          input: U,
          result: G
        }), I.length > a && I.pop(), G;
      };
    }
    var u = o(function(I) {
      var U = I, j = i(I);
      if (j) {
        if (!j.path)
          return I;
        U = j.path;
      }
      for (var J = t.isAbsolute(U), G = [], H = 0, q = 0; ; )
        if (H = q, q = U.indexOf("/", H), q === -1) {
          G.push(U.slice(H));
          break;
        } else
          for (G.push(U.slice(H, q)); q < U.length && U[q] === "/"; )
            q++;
      for (var X, ie = 0, q = G.length - 1; q >= 0; q--)
        X = G[q], X === "." ? G.splice(q, 1) : X === ".." ? ie++ : ie > 0 && (X === "" ? (G.splice(q + 1, ie), ie = 0) : (G.splice(q, 2), ie--));
      return U = G.join("/"), U === "" && (U = J ? "/" : "."), j ? (j.path = U, s(j)) : U;
    });
    t.normalize = u;
    function l(k, I) {
      k === "" && (k = "."), I === "" && (I = ".");
      var U = i(I), j = i(k);
      if (j && (k = j.path || "/"), U && !U.scheme)
        return j && (U.scheme = j.scheme), s(U);
      if (U || I.match(r))
        return I;
      if (j && !j.host && !j.path)
        return j.host = I, s(j);
      var J = I.charAt(0) === "/" ? I : u(k.replace(/\/+$/, "") + "/" + I);
      return j ? (j.path = J, s(j)) : J;
    }
    t.join = l, t.isAbsolute = function(k) {
      return k.charAt(0) === "/" || n.test(k);
    };
    function h(k, I) {
      k === "" && (k = "."), k = k.replace(/\/$/, "");
      for (var U = 0; I.indexOf(k + "/") !== 0; ) {
        var j = k.lastIndexOf("/");
        if (j < 0 || (k = k.slice(0, j), k.match(/^([^\/]+:\/)?\/*$/)))
          return I;
        ++U;
      }
      return Array(U + 1).join("../") + I.substr(k.length + 1);
    }
    t.relative = h;
    var f = (function() {
      var k = /* @__PURE__ */ Object.create(null);
      return !("__proto__" in k);
    })();
    function m(k) {
      return k;
    }
    function g(k) {
      return E(k) ? "$" + k : k;
    }
    t.toSetString = f ? m : g;
    function A(k) {
      return E(k) ? k.slice(1) : k;
    }
    t.fromSetString = f ? m : A;
    function E(k) {
      if (!k)
        return !1;
      var I = k.length;
      if (I < 9 || k.charCodeAt(I - 1) !== 95 || k.charCodeAt(I - 2) !== 95 || k.charCodeAt(I - 3) !== 111 || k.charCodeAt(I - 4) !== 116 || k.charCodeAt(I - 5) !== 111 || k.charCodeAt(I - 6) !== 114 || k.charCodeAt(I - 7) !== 112 || k.charCodeAt(I - 8) !== 95 || k.charCodeAt(I - 9) !== 95)
        return !1;
      for (var U = I - 10; U >= 0; U--)
        if (k.charCodeAt(U) !== 36)
          return !1;
      return !0;
    }
    function w(k, I, U) {
      var j = P(k.source, I.source);
      return j !== 0 || (j = k.originalLine - I.originalLine, j !== 0) || (j = k.originalColumn - I.originalColumn, j !== 0 || U) || (j = k.generatedColumn - I.generatedColumn, j !== 0) || (j = k.generatedLine - I.generatedLine, j !== 0) ? j : P(k.name, I.name);
    }
    t.compareByOriginalPositions = w;
    function x(k, I, U) {
      var j;
      return j = k.originalLine - I.originalLine, j !== 0 || (j = k.originalColumn - I.originalColumn, j !== 0 || U) || (j = k.generatedColumn - I.generatedColumn, j !== 0) || (j = k.generatedLine - I.generatedLine, j !== 0) ? j : P(k.name, I.name);
    }
    t.compareByOriginalPositionsNoSource = x;
    function N(k, I, U) {
      var j = k.generatedLine - I.generatedLine;
      return j !== 0 || (j = k.generatedColumn - I.generatedColumn, j !== 0 || U) || (j = P(k.source, I.source), j !== 0) || (j = k.originalLine - I.originalLine, j !== 0) || (j = k.originalColumn - I.originalColumn, j !== 0) ? j : P(k.name, I.name);
    }
    t.compareByGeneratedPositionsDeflated = N;
    function B(k, I, U) {
      var j = k.generatedColumn - I.generatedColumn;
      return j !== 0 || U || (j = P(k.source, I.source), j !== 0) || (j = k.originalLine - I.originalLine, j !== 0) || (j = k.originalColumn - I.originalColumn, j !== 0) ? j : P(k.name, I.name);
    }
    t.compareByGeneratedPositionsDeflatedNoLine = B;
    function P(k, I) {
      return k === I ? 0 : k === null ? 1 : I === null ? -1 : k > I ? 1 : -1;
    }
    function C(k, I) {
      var U = k.generatedLine - I.generatedLine;
      return U !== 0 || (U = k.generatedColumn - I.generatedColumn, U !== 0) || (U = P(k.source, I.source), U !== 0) || (U = k.originalLine - I.originalLine, U !== 0) || (U = k.originalColumn - I.originalColumn, U !== 0) ? U : P(k.name, I.name);
    }
    t.compareByGeneratedPositionsInflated = C;
    function D(k) {
      return JSON.parse(k.replace(/^\)]}'[^\n]*\n/, ""));
    }
    t.parseSourceMapInput = D;
    function L(k, I, U) {
      if (I = I || "", k && (k[k.length - 1] !== "/" && I[0] !== "/" && (k += "/"), I = k + I), U) {
        var j = i(U);
        if (!j)
          throw new Error("sourceMapURL could not be parsed");
        if (j.path) {
          var J = j.path.lastIndexOf("/");
          J >= 0 && (j.path = j.path.substring(0, J + 1));
        }
        I = l(s(j), I);
      }
      return u(I);
    }
    t.computeSourceURL = L;
  })(_w)), _w;
}
var Nw = {}, pR;
function pke() {
  if (pR) return Nw;
  pR = 1;
  var t = JC(), e = Object.prototype.hasOwnProperty, n = typeof Map < "u";
  function r() {
    this._array = [], this._set = n ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
  }
  return r.fromArray = function(s, a) {
    for (var o = new r(), u = 0, l = s.length; u < l; u++)
      o.add(s[u], a);
    return o;
  }, r.prototype.size = function() {
    return n ? this._set.size : Object.getOwnPropertyNames(this._set).length;
  }, r.prototype.add = function(s, a) {
    var o = n ? s : t.toSetString(s), u = n ? this.has(s) : e.call(this._set, o), l = this._array.length;
    (!u || a) && this._array.push(s), u || (n ? this._set.set(s, l) : this._set[o] = l);
  }, r.prototype.has = function(s) {
    if (n)
      return this._set.has(s);
    var a = t.toSetString(s);
    return e.call(this._set, a);
  }, r.prototype.indexOf = function(s) {
    if (n) {
      var a = this._set.get(s);
      if (a >= 0)
        return a;
    } else {
      var o = t.toSetString(s);
      if (e.call(this._set, o))
        return this._set[o];
    }
    throw new Error('"' + s + '" is not in the set.');
  }, r.prototype.at = function(s) {
    if (s >= 0 && s < this._array.length)
      return this._array[s];
    throw new Error("No element indexed by " + s);
  }, r.prototype.toArray = function() {
    return this._array.slice();
  }, Nw.ArraySet = r, Nw;
}
var Dw = {}, bR;
function bke() {
  if (bR) return Dw;
  bR = 1;
  var t = JC();
  function e(r, i) {
    var s = r.generatedLine, a = i.generatedLine, o = r.generatedColumn, u = i.generatedColumn;
    return a > s || a == s && u >= o || t.compareByGeneratedPositionsInflated(r, i) <= 0;
  }
  function n() {
    this._array = [], this._sorted = !0, this._last = { generatedLine: -1, generatedColumn: 0 };
  }
  return n.prototype.unsortedForEach = function(i, s) {
    this._array.forEach(i, s);
  }, n.prototype.add = function(i) {
    e(this._last, i) ? (this._last = i, this._array.push(i)) : (this._sorted = !1, this._array.push(i));
  }, n.prototype.toArray = function() {
    return this._sorted || (this._array.sort(t.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
  }, Dw.MappingList = n, Dw;
}
var yR;
function yke() {
  if (yR) return kw;
  yR = 1;
  var t = gke(), e = JC(), n = pke().ArraySet, r = bke().MappingList;
  function i(s) {
    s || (s = {}), this._file = e.getArg(s, "file", null), this._sourceRoot = e.getArg(s, "sourceRoot", null), this._skipValidation = e.getArg(s, "skipValidation", !1), this._ignoreInvalidMapping = e.getArg(s, "ignoreInvalidMapping", !1), this._sources = new n(), this._names = new n(), this._mappings = new r(), this._sourcesContents = null;
  }
  return i.prototype._version = 3, i.fromSourceMap = function(a, o) {
    var u = a.sourceRoot, l = new i(Object.assign(o || {}, {
      file: a.file,
      sourceRoot: u
    }));
    return a.eachMapping(function(h) {
      var f = {
        generated: {
          line: h.generatedLine,
          column: h.generatedColumn
        }
      };
      h.source != null && (f.source = h.source, u != null && (f.source = e.relative(u, f.source)), f.original = {
        line: h.originalLine,
        column: h.originalColumn
      }, h.name != null && (f.name = h.name)), l.addMapping(f);
    }), a.sources.forEach(function(h) {
      var f = h;
      u !== null && (f = e.relative(u, h)), l._sources.has(f) || l._sources.add(f);
      var m = a.sourceContentFor(h);
      m != null && l.setSourceContent(h, m);
    }), l;
  }, i.prototype.addMapping = function(a) {
    var o = e.getArg(a, "generated"), u = e.getArg(a, "original", null), l = e.getArg(a, "source", null), h = e.getArg(a, "name", null);
    !this._skipValidation && this._validateMapping(o, u, l, h) === !1 || (l != null && (l = String(l), this._sources.has(l) || this._sources.add(l)), h != null && (h = String(h), this._names.has(h) || this._names.add(h)), this._mappings.add({
      generatedLine: o.line,
      generatedColumn: o.column,
      originalLine: u != null && u.line,
      originalColumn: u != null && u.column,
      source: l,
      name: h
    }));
  }, i.prototype.setSourceContent = function(a, o) {
    var u = a;
    this._sourceRoot != null && (u = e.relative(this._sourceRoot, u)), o != null ? (this._sourcesContents || (this._sourcesContents = /* @__PURE__ */ Object.create(null)), this._sourcesContents[e.toSetString(u)] = o) : this._sourcesContents && (delete this._sourcesContents[e.toSetString(u)], Object.keys(this._sourcesContents).length === 0 && (this._sourcesContents = null));
  }, i.prototype.applySourceMap = function(a, o, u) {
    var l = o;
    if (o == null) {
      if (a.file == null)
        throw new Error(
          `SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`
        );
      l = a.file;
    }
    var h = this._sourceRoot;
    h != null && (l = e.relative(h, l));
    var f = new n(), m = new n();
    this._mappings.unsortedForEach(function(g) {
      if (g.source === l && g.originalLine != null) {
        var A = a.originalPositionFor({
          line: g.originalLine,
          column: g.originalColumn
        });
        A.source != null && (g.source = A.source, u != null && (g.source = e.join(u, g.source)), h != null && (g.source = e.relative(h, g.source)), g.originalLine = A.line, g.originalColumn = A.column, A.name != null && (g.name = A.name));
      }
      var E = g.source;
      E != null && !f.has(E) && f.add(E);
      var w = g.name;
      w != null && !m.has(w) && m.add(w);
    }, this), this._sources = f, this._names = m, a.sources.forEach(function(g) {
      var A = a.sourceContentFor(g);
      A != null && (u != null && (g = e.join(u, g)), h != null && (g = e.relative(h, g)), this.setSourceContent(g, A));
    }, this);
  }, i.prototype._validateMapping = function(a, o, u, l) {
    if (o && typeof o.line != "number" && typeof o.column != "number") {
      var h = "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.";
      if (this._ignoreInvalidMapping)
        return typeof console < "u" && console.warn && console.warn(h), !1;
      throw new Error(h);
    }
    if (!(a && "line" in a && "column" in a && a.line > 0 && a.column >= 0 && !o && !u && !l)) {
      if (a && "line" in a && "column" in a && o && "line" in o && "column" in o && a.line > 0 && a.column >= 0 && o.line > 0 && o.column >= 0 && u)
        return;
      var h = "Invalid mapping: " + JSON.stringify({
        generated: a,
        source: u,
        original: o,
        name: l
      });
      if (this._ignoreInvalidMapping)
        return typeof console < "u" && console.warn && console.warn(h), !1;
      throw new Error(h);
    }
  }, i.prototype._serializeMappings = function() {
    for (var a = 0, o = 1, u = 0, l = 0, h = 0, f = 0, m = "", g, A, E, w, x = this._mappings.toArray(), N = 0, B = x.length; N < B; N++) {
      if (A = x[N], g = "", A.generatedLine !== o)
        for (a = 0; A.generatedLine !== o; )
          g += ";", o++;
      else if (N > 0) {
        if (!e.compareByGeneratedPositionsInflated(A, x[N - 1]))
          continue;
        g += ",";
      }
      g += t.encode(A.generatedColumn - a), a = A.generatedColumn, A.source != null && (w = this._sources.indexOf(A.source), g += t.encode(w - f), f = w, g += t.encode(A.originalLine - 1 - l), l = A.originalLine - 1, g += t.encode(A.originalColumn - u), u = A.originalColumn, A.name != null && (E = this._names.indexOf(A.name), g += t.encode(E - h), h = E)), m += g;
    }
    return m;
  }, i.prototype._generateSourcesContent = function(a, o) {
    return a.map(function(u) {
      if (!this._sourcesContents)
        return null;
      o != null && (u = e.relative(o, u));
      var l = e.toSetString(u);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, l) ? this._sourcesContents[l] : null;
    }, this);
  }, i.prototype.toJSON = function() {
    var a = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    return this._file != null && (a.file = this._file), this._sourceRoot != null && (a.sourceRoot = this._sourceRoot), this._sourcesContents && (a.sourcesContent = this._generateSourcesContent(a.sources, a.sourceRoot)), a;
  }, i.prototype.toString = function() {
    return JSON.stringify(this.toJSON());
  }, kw.SourceMapGenerator = i, kw;
}
var Ake = yke();
const AR = /* @__PURE__ */ new Set(["Atrule", "Selector", "Declaration"]);
function Eke(t) {
  const e = new Ake.SourceMapGenerator(), n = {
    line: 1,
    column: 0
  }, r = {
    line: 0,
    // should be zero to add first mapping
    column: 0
  }, i = {
    line: 1,
    column: 0
  }, s = {
    generated: i
  };
  let a = 1, o = 0, u = !1;
  const l = t.node;
  t.node = function(m) {
    if (m.loc && m.loc.start && AR.has(m.type)) {
      const g = m.loc.start.line, A = m.loc.start.column - 1;
      (r.line !== g || r.column !== A) && (r.line = g, r.column = A, n.line = a, n.column = o, u && (u = !1, (n.line !== i.line || n.column !== i.column) && e.addMapping(s)), u = !0, e.addMapping({
        source: m.loc.source,
        original: r,
        generated: n
      }));
    }
    l.call(this, m), u && AR.has(m.type) && (i.line = a, i.column = o);
  };
  const h = t.emit;
  t.emit = function(m, g, A) {
    for (let E = 0; E < m.length; E++)
      m.charCodeAt(E) === 10 ? (a++, o = 0) : o++;
    h(m, g, A);
  };
  const f = t.result;
  return t.result = function() {
    return u && e.addMapping(s), {
      css: f(),
      map: e
    };
  }, t;
}
const Ske = 43, wke = 45, Iw = (t, e) => (t === hn && (t = e), typeof t == "string" && (t = Math.min(t.charCodeAt(0), 128) << 6), t << 1), FH = [
  [He, He],
  [He, Rt],
  [He, Xi],
  [He, Ds],
  [He, "-"],
  [He, wt],
  [He, Dr],
  [He, cn],
  [He, Is],
  [He, kn],
  [ri, He],
  [ri, Rt],
  [ri, Xi],
  [ri, Ds],
  [ri, "-"],
  [ri, wt],
  [ri, Dr],
  [ri, cn],
  [ri, Is],
  [or, He],
  [or, Rt],
  [or, Xi],
  [or, Ds],
  [or, "-"],
  [or, wt],
  [or, Dr],
  [or, cn],
  [or, Is],
  [cn, He],
  [cn, Rt],
  [cn, Xi],
  [cn, Ds],
  [cn, "-"],
  [cn, wt],
  [cn, Dr],
  [cn, cn],
  [cn, Is],
  ["#", He],
  ["#", Rt],
  ["#", Xi],
  ["#", Ds],
  ["#", "-"],
  ["#", wt],
  ["#", Dr],
  ["#", cn],
  ["#", Is],
  // https://github.com/w3c/csswg-drafts/pull/6874
  ["-", He],
  ["-", Rt],
  ["-", Xi],
  ["-", Ds],
  ["-", "-"],
  ["-", wt],
  ["-", Dr],
  ["-", cn],
  ["-", Is],
  // https://github.com/w3c/csswg-drafts/pull/6874
  [wt, He],
  [wt, Rt],
  [wt, Xi],
  [wt, Ds],
  [wt, wt],
  [wt, Dr],
  [wt, cn],
  [wt, "%"],
  [wt, Is],
  // https://github.com/w3c/csswg-drafts/pull/6874
  ["@", He],
  ["@", Rt],
  ["@", Xi],
  ["@", Ds],
  ["@", "-"],
  ["@", Is],
  // https://github.com/w3c/csswg-drafts/pull/6874
  [".", wt],
  [".", Dr],
  [".", cn],
  ["+", wt],
  ["+", Dr],
  ["+", cn],
  ["/", "*"]
], Fke = FH.concat([
  [He, or],
  [cn, or],
  [or, or],
  [ri, kn],
  [ri, Po],
  [ri, is],
  [Dr, Dr],
  [Dr, cn],
  [Dr, Rt],
  [Dr, "-"],
  [yt, He],
  [yt, Rt],
  [yt, Dr],
  [yt, cn],
  [yt, or],
  [yt, "-"]
]);
function TH(t) {
  const e = new Set(
    t.map(([n, r]) => Iw(n) << 16 | Iw(r))
  );
  return function(n, r, i) {
    const s = Iw(r, i), a = i.charCodeAt(0), o = a === wke && r !== He && r !== Rt && r !== Is || a === Ske ? e.has((n & 65534) << 16 | a << 7) : e.has((n & 65534) << 16 | s);
    return s | o;
  };
}
const Tke = TH(FH), vH = TH(Fke), ER = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  safe: vH,
  spec: Tke
}, Symbol.toStringTag, { value: "Module" })), vke = 92;
function xke(t, e) {
  if (typeof e == "function") {
    let n = null;
    t.children.forEach((r) => {
      n !== null && e.call(this, n), this.node(r), n = r;
    });
    return;
  }
  t.children.forEach(this.node, this);
}
function Cke(t) {
  const e = /* @__PURE__ */ new Map();
  for (let [n, r] of Object.entries(t.node))
    typeof (r.generate || r) == "function" && e.set(n, r.generate || r);
  return function(n, r) {
    let i = "", s = 0, a = {
      node(u) {
        if (e.has(u.type))
          e.get(u.type).call(o, u);
        else
          throw new Error("Unknown node type: " + u.type);
      },
      tokenBefore: vH,
      token(u, l, h) {
        s = this.tokenBefore(s, u, l), !h && s & 1 && this.emit(" ", Lr, !0), this.emit(l, u, !1), u === hn && l.charCodeAt(0) === vke && this.emit(`
`, Lr, !0);
      },
      emit(u) {
        i += u;
      },
      result() {
        return i;
      }
    };
    r && (typeof r.decorator == "function" && (a = r.decorator(a)), r.sourceMap && (a = Eke(a)), r.mode in ER && (a.tokenBefore = ER[r.mode]));
    const o = {
      node: (u) => a.node(u),
      children: xke,
      token: (u, l) => a.token(u, l),
      tokenize: (u) => DA(u, (l, h, f) => {
        a.token(
          l,
          u.slice(h, f),
          h !== 0
          // suppress auto whitespace for internal value tokens
        );
      })
    };
    return a.node(n), a.result();
  };
}
function kke(t) {
  return {
    fromPlainObject(e) {
      return t(e, {
        enter(n) {
          n.children && !(n.children instanceof wi) && (n.children = new wi().fromArray(n.children));
        }
      }), e;
    },
    toPlainObject(e) {
      return t(e, {
        leave(n) {
          n.children && n.children instanceof wi && (n.children = n.children.toArray());
        }
      }), e;
    }
  };
}
const { hasOwnProperty: QC } = Object.prototype, Rm = function() {
};
function SR(t) {
  return typeof t == "function" ? t : Rm;
}
function wR(t, e) {
  return function(n, r, i) {
    n.type === e && t.call(this, n, r, i);
  };
}
function _ke(t, e) {
  const n = e.structure, r = [];
  for (const i in n) {
    if (QC.call(n, i) === !1)
      continue;
    let s = n[i];
    const a = {
      name: i,
      type: !1,
      nullable: !1
    };
    Array.isArray(s) || (s = [s]);
    for (const o of s)
      o === null ? a.nullable = !0 : typeof o == "string" ? a.type = "node" : Array.isArray(o) && (a.type = "list");
    a.type && r.push(a);
  }
  return r.length ? {
    context: e.walkContext,
    fields: r
  } : null;
}
function Nke(t) {
  const e = {};
  for (const n in t.node)
    if (QC.call(t.node, n)) {
      const r = t.node[n];
      if (!r.structure)
        throw new Error("Missed `structure` field in `" + n + "` node type definition");
      e[n] = _ke(n, r);
    }
  return e;
}
function FR(t, e) {
  const n = t.fields.slice(), r = t.context, i = typeof r == "string";
  return e && n.reverse(), function(s, a, o, u) {
    let l;
    i && (l = a[r], a[r] = s);
    for (const h of n) {
      const f = s[h.name];
      if (!h.nullable || f) {
        if (h.type === "list") {
          if (e ? f.reduceRight(u, !1) : f.reduce(u, !1))
            return !0;
        } else if (o(f))
          return !0;
      }
    }
    i && (a[r] = l);
  };
}
function TR({
  StyleSheet: t,
  Atrule: e,
  Rule: n,
  Block: r,
  DeclarationList: i
}) {
  return {
    Atrule: {
      StyleSheet: t,
      Atrule: e,
      Rule: n,
      Block: r
    },
    Rule: {
      StyleSheet: t,
      Atrule: e,
      Rule: n,
      Block: r
    },
    Declaration: {
      StyleSheet: t,
      Atrule: e,
      Rule: n,
      Block: r,
      DeclarationList: i
    }
  };
}
function Dke(t) {
  const e = Nke(t), n = {}, r = {}, i = /* @__PURE__ */ Symbol("break-walk"), s = /* @__PURE__ */ Symbol("skip-node");
  for (const l in e)
    QC.call(e, l) && e[l] !== null && (n[l] = FR(e[l], !1), r[l] = FR(e[l], !0));
  const a = TR(n), o = TR(r), u = function(l, h) {
    function f(x, N, B) {
      const P = m.call(w, x, N, B);
      return P === i ? !0 : P === s ? !1 : !!(A.hasOwnProperty(x.type) && A[x.type](x, w, f, E) || g.call(w, x, N, B) === i);
    }
    let m = Rm, g = Rm, A = n, E = (x, N, B, P) => x || f(N, B, P);
    const w = {
      break: i,
      skip: s,
      root: l,
      stylesheet: null,
      atrule: null,
      atrulePrelude: null,
      rule: null,
      selector: null,
      block: null,
      declaration: null,
      function: null
    };
    if (typeof h == "function")
      m = h;
    else if (h && (m = SR(h.enter), g = SR(h.leave), h.reverse && (A = r), h.visit)) {
      if (a.hasOwnProperty(h.visit))
        A = h.reverse ? o[h.visit] : a[h.visit];
      else if (!e.hasOwnProperty(h.visit))
        throw new Error("Bad value `" + h.visit + "` for `visit` option (should be: " + Object.keys(e).sort().join(", ") + ")");
      m = wR(m, h.visit), g = wR(g, h.visit);
    }
    if (m === Rm && g === Rm)
      throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
    f(l);
  };
  return u.break = i, u.skip = s, u.find = function(l, h) {
    let f = null;
    return u(l, function(m, g, A) {
      if (h.call(this, m, g, A))
        return f = m, i;
    }), f;
  }, u.findLast = function(l, h) {
    let f = null;
    return u(l, {
      reverse: !0,
      enter(m, g, A) {
        if (h.call(this, m, g, A))
          return f = m, i;
      }
    }), f;
  }, u.findAll = function(l, h) {
    const f = [];
    return u(l, function(m, g, A) {
      h.call(this, m, g, A) && f.push(m);
    }), f;
  }, u;
}
function Ike(t) {
  return t;
}
function Rke(t) {
  const { min: e, max: n, comma: r } = t;
  return e === 0 && n === 0 ? r ? "#?" : "*" : e === 0 && n === 1 ? "?" : e === 1 && n === 0 ? r ? "#" : "+" : e === 1 && n === 1 ? "" : (r ? "#" : "") + (e === n ? "{" + e + "}" : "{" + e + "," + (n !== 0 ? n : "") + "}");
}
function Pke(t) {
  if (t.type === "Range")
    return " [" + (t.min === null ? "-∞" : t.min) + "," + (t.max === null ? "∞" : t.max) + "]";
  throw new Error("Unknown node type `" + t.type + "`");
}
function Lke(t, e, n, r) {
  const i = t.combinator === " " || r ? t.combinator : " " + t.combinator + " ", s = t.terms.map((a) => E1(a, e, n, r)).join(i);
  return t.explicit || n ? (r || s[0] === "," ? "[" : "[ ") + s + (r ? "]" : " ]") : s;
}
function E1(t, e, n, r) {
  let i;
  switch (t.type) {
    case "Group":
      i = Lke(t, e, n, r) + (t.disallowEmpty ? "!" : "");
      break;
    case "Multiplier":
      return E1(t.term, e, n, r) + e(Rke(t), t);
    case "Boolean":
      i = "<boolean-expr[" + E1(t.term, e, n, r) + "]>";
      break;
    case "Type":
      i = "<" + t.name + (t.opts ? e(Pke(t.opts), t.opts) : "") + ">";
      break;
    case "Property":
      i = "<'" + t.name + "'>";
      break;
    case "Keyword":
      i = t.name;
      break;
    case "AtKeyword":
      i = "@" + t.name;
      break;
    case "Function":
      i = t.name + "(";
      break;
    case "String":
    case "Token":
      i = t.value;
      break;
    case "Comma":
      i = ",";
      break;
    default:
      throw new Error("Unknown node type `" + t.type + "`");
  }
  return e(i, t);
}
function XC(t, e) {
  let n = Ike, r = !1, i = !1;
  return typeof e == "function" ? n = e : e && (r = !!e.forceBraces, i = !!e.compact, typeof e.decorate == "function" && (n = e.decorate)), E1(t, n, r, i);
}
const vR = { offset: 0, line: 1, column: 1 };
function Mke(t, e) {
  const n = t.tokens, r = t.longestMatch, i = r < n.length && n[r].node || null, s = i !== e ? i : null;
  let a = 0, o = 0, u = 0, l = "", h, f;
  for (let m = 0; m < n.length; m++) {
    const g = n[m].value;
    m === r && (o = g.length, a = l.length), s !== null && n[m].node === s && (m <= r ? u++ : u = 0), l += g;
  }
  return r === n.length || u > 1 ? (h = M0(s || e, "end") || Pm(vR, l), f = Pm(h)) : (h = M0(s, "start") || Pm(M0(e, "start") || vR, l.slice(0, a)), f = M0(s, "end") || Pm(h, l.substr(a, o))), {
    css: l,
    mismatchOffset: a,
    mismatchLength: o,
    start: h,
    end: f
  };
}
function M0(t, e) {
  const n = t && t.loc && t.loc[e];
  return n ? "line" in n ? Pm(n) : n : null;
}
function Pm({ offset: t, line: e, column: n }, r) {
  const i = {
    offset: t,
    line: e,
    column: n
  };
  if (r) {
    const s = r.split(/\n|\r\n?|\f/);
    i.offset += r.length, i.line += s.length - 1, i.column = s.length === 1 ? i.column + r.length : s.pop().length + 1;
  }
  return i;
}
const om = function(t, e) {
  const n = IA(
    "SyntaxReferenceError",
    t + (e ? " `" + e + "`" : "")
  );
  return n.reference = e, n;
}, Oke = function(t, e, n, r) {
  const i = IA("SyntaxMatchError", t), {
    css: s,
    mismatchOffset: a,
    mismatchLength: o,
    start: u,
    end: l
  } = Mke(r, n);
  return i.rawMessage = t, i.syntax = e ? XC(e) : "<generic>", i.css = s, i.mismatchOffset = a, i.mismatchLength = o, i.message = t + `
  syntax: ` + i.syntax + `
   value: ` + (s || "<empty string>") + `
  --------` + new Array(i.mismatchOffset + 1).join("-") + "^", Object.assign(i, u), i.loc = {
    source: n && n.loc && n.loc.source || "<unknown>",
    start: u,
    end: l
  }, i;
}, O0 = /* @__PURE__ */ new Map(), rd = /* @__PURE__ */ new Map(), S1 = 45, Rw = Bke, xR = $ke;
function ZC(t, e) {
  return e = e || 0, t.length - e >= 2 && t.charCodeAt(e) === S1 && t.charCodeAt(e + 1) === S1;
}
function xH(t, e) {
  if (e = e || 0, t.length - e >= 3 && t.charCodeAt(e) === S1 && t.charCodeAt(e + 1) !== S1) {
    const n = t.indexOf("-", e + 2);
    if (n !== -1)
      return t.substring(e, n + 1);
  }
  return "";
}
function Bke(t) {
  if (O0.has(t))
    return O0.get(t);
  const e = t.toLowerCase();
  let n = O0.get(e);
  if (n === void 0) {
    const r = ZC(e, 0), i = r ? "" : xH(e, 0);
    n = Object.freeze({
      basename: e.substr(i.length),
      name: e,
      prefix: i,
      vendor: i,
      custom: r
    });
  }
  return O0.set(t, n), n;
}
function $ke(t) {
  if (rd.has(t))
    return rd.get(t);
  let e = t, n = t[0];
  n === "/" ? n = t[1] === "/" ? "//" : "/" : n !== "_" && n !== "*" && n !== "$" && n !== "#" && n !== "+" && n !== "&" && (n = "");
  const r = ZC(e, n.length);
  if (!r && (e = e.toLowerCase(), rd.has(e))) {
    const o = rd.get(e);
    return rd.set(t, o), o;
  }
  const i = r ? "" : xH(e, n.length), s = e.substr(0, n.length + i.length), a = Object.freeze({
    basename: e.substr(s.length),
    name: e.substr(n.length),
    hack: n,
    vendor: i,
    prefix: s,
    custom: r
  });
  return rd.set(t, a), a;
}
const e2 = [
  "initial",
  "inherit",
  "unset",
  "revert",
  "revert-layer"
], Ng = 43, qo = 45, Pw = 110, id = !0, Hke = !1;
function XT(t, e) {
  return t !== null && t.type === hn && t.value.charCodeAt(0) === e;
}
function sg(t, e, n) {
  for (; t !== null && (t.type === Lr || t.type === Ki); )
    t = n(++e);
  return e;
}
function Fl(t, e, n, r) {
  if (!t)
    return 0;
  const i = t.value.charCodeAt(e);
  if (i === Ng || i === qo) {
    if (n)
      return 0;
    e++;
  }
  for (; e < t.value.length; e++)
    if (!Vi(t.value.charCodeAt(e)))
      return 0;
  return r + 1;
}
function Lw(t, e, n) {
  let r = !1, i = sg(t, e, n);
  if (t = n(i), t === null)
    return e;
  if (t.type !== wt)
    if (XT(t, Ng) || XT(t, qo)) {
      if (r = !0, i = sg(n(++i), i, n), t = n(i), t === null || t.type !== wt)
        return 0;
    } else
      return e;
  if (!r) {
    const s = t.value.charCodeAt(0);
    if (s !== Ng && s !== qo)
      return 0;
  }
  return Fl(t, r ? 0 : 1, r, i);
}
function Uke(t, e) {
  let n = 0;
  if (!t)
    return 0;
  if (t.type === wt)
    return Fl(t, 0, Hke, n);
  if (t.type === He && t.value.charCodeAt(0) === qo) {
    if (!zd(t.value, 1, Pw))
      return 0;
    switch (t.value.length) {
      // -n
      // -n <signed-integer>
      // -n ['+' | '-'] <signless-integer>
      case 2:
        return Lw(e(++n), n, e);
      // -n- <signless-integer>
      case 3:
        return t.value.charCodeAt(2) !== qo ? 0 : (n = sg(e(++n), n, e), t = e(n), Fl(t, 0, id, n));
      // <dashndashdigit-ident>
      default:
        return t.value.charCodeAt(2) !== qo ? 0 : Fl(t, 3, id, n);
    }
  } else if (t.type === He || XT(t, Ng) && e(n + 1).type === He) {
    if (t.type !== He && (t = e(++n)), t === null || !zd(t.value, 0, Pw))
      return 0;
    switch (t.value.length) {
      // '+'? n
      // '+'? n <signed-integer>
      // '+'? n ['+' | '-'] <signless-integer>
      case 1:
        return Lw(e(++n), n, e);
      // '+'? n- <signless-integer>
      case 2:
        return t.value.charCodeAt(1) !== qo ? 0 : (n = sg(e(++n), n, e), t = e(n), Fl(t, 0, id, n));
      // '+'? <ndashdigit-ident>
      default:
        return t.value.charCodeAt(1) !== qo ? 0 : Fl(t, 2, id, n);
    }
  } else if (t.type === cn) {
    let r = t.value.charCodeAt(0), i = r === Ng || r === qo ? 1 : 0, s = i;
    for (; s < t.value.length && Vi(t.value.charCodeAt(s)); s++)
      ;
    return s === i || !zd(t.value, s, Pw) ? 0 : s + 1 === t.value.length ? Lw(e(++n), n, e) : t.value.charCodeAt(s + 1) !== qo ? 0 : s + 2 === t.value.length ? (n = sg(e(++n), n, e), t = e(n), Fl(t, 0, id, n)) : Fl(t, s + 2, id, n);
  }
  return 0;
}
const Gke = 43, CH = 45, kH = 63, Wke = 117;
function ZT(t, e) {
  return t !== null && t.type === hn && t.value.charCodeAt(0) === e;
}
function Vke(t, e) {
  return t.value.charCodeAt(0) === e;
}
function Lm(t, e, n) {
  let r = 0;
  for (let i = e; i < t.value.length; i++) {
    const s = t.value.charCodeAt(i);
    if (s === CH && n && r !== 0)
      return Lm(t, e + r + 1, !1), 6;
    if (!yc(s) || ++r > 6)
      return 0;
  }
  return r;
}
function B0(t, e, n) {
  if (!t)
    return 0;
  for (; ZT(n(e), kH); ) {
    if (++t > 6)
      return 0;
    e++;
  }
  return e;
}
function Kke(t, e) {
  let n = 0;
  if (t === null || t.type !== He || !zd(t.value, 0, Wke) || (t = e(++n), t === null))
    return 0;
  if (ZT(t, Gke))
    return t = e(++n), t === null ? 0 : t.type === He ? B0(Lm(t, 0, !0), ++n, e) : ZT(t, kH) ? B0(1, ++n, e) : 0;
  if (t.type === wt) {
    const r = Lm(t, 1, !0);
    return r === 0 ? 0 : (t = e(++n), t === null ? n : t.type === cn || t.type === wt ? !Vke(t, CH) || !Lm(t, 1, !1) ? 0 : n + 1 : B0(r, n, e));
  }
  return t.type === cn ? B0(Lm(t, 1, !0), ++n, e) : 0;
}
const t2 = [
  "calc(",
  "-moz-calc(",
  "-webkit-calc("
], n2 = [
  "min(",
  "max(",
  "clamp("
], r2 = [
  "round(",
  "mod(",
  "rem("
], zke = [
  "sin(",
  "cos(",
  "tan("
], jke = [
  "asin(",
  "acos(",
  "atan(",
  "atan2("
], Yke = [
  "pow(",
  "sqrt(",
  "log(",
  "exp(",
  "sign("
], i2 = [
  "hypot("
], s2 = [
  "abs("
], CR = [
  ...t2,
  ...n2,
  ...r2,
  ...zke,
  ...Yke,
  ...i2,
  ...s2
], qke = [
  ...t2,
  ...n2,
  ...r2,
  ...i2,
  ...s2
], ku = [
  ...t2,
  ...n2,
  ...r2,
  ...jke,
  ...i2,
  ...s2
], a2 = /* @__PURE__ */ new Map([
  [Rt, yt],
  [kn, yt],
  [ca, Ya],
  [Ri, ua]
]);
function To(t, e) {
  return e < t.length ? t.charCodeAt(e) : 0;
}
function _H(t, e) {
  return _g(t, 0, t.length, e);
}
function NH(t, e) {
  for (let n = 0; n < e.length; n++)
    if (_H(t, e[n]))
      return !0;
  return !1;
}
function DH(t, e) {
  return e !== t.length - 2 ? !1 : To(t, e) === 92 && // U+005C REVERSE SOLIDUS (\)
  Vi(To(t, e + 1));
}
function RA(t, e, n) {
  if (t && t.type === "Range") {
    const r = Number(
      n !== void 0 && n !== e.length ? e.substr(0, n) : e
    );
    if (isNaN(r) || t.min !== null && r < t.min && typeof t.min != "string" || t.max !== null && r > t.max && typeof t.max != "string")
      return !0;
  }
  return !1;
}
function Jke(t, e) {
  let n = 0, r = [], i = 0;
  e:
    do {
      switch (t.type) {
        case ua:
        case yt:
        case Ya:
          if (t.type !== n)
            break e;
          if (n = r.pop(), r.length === 0) {
            i++;
            break e;
          }
          break;
        case Rt:
        case kn:
        case ca:
        case Ri:
          r.push(n), n = a2.get(t.type);
          break;
      }
      i++;
    } while (t = e(i));
  return i;
}
function xa(t, e) {
  return function(n, r, i) {
    return n === null ? 0 : n.type === Rt && NH(n.value, e) ? Jke(n, r) : t(n, r, i);
  };
}
function sr(t) {
  return function(e) {
    return e === null || e.type !== t ? 0 : 1;
  };
}
function Qke(t) {
  if (t === null || t.type !== He)
    return 0;
  const e = t.value.toLowerCase();
  return NH(e, e2) || _H(e, "default") ? 0 : 1;
}
function IH(t) {
  return t === null || t.type !== He || To(t.value, 0) !== 45 || To(t.value, 1) !== 45 ? 0 : 1;
}
function Xke(t) {
  return !IH(t) || t.value === "--" ? 0 : 1;
}
function Zke(t) {
  if (t === null || t.type !== or)
    return 0;
  const e = t.value.length;
  if (e !== 4 && e !== 5 && e !== 7 && e !== 9)
    return 0;
  for (let n = 1; n < e; n++)
    if (!yc(To(t.value, n)))
      return 0;
  return 1;
}
function e_e(t) {
  return t === null || t.type !== or || !Ny(To(t.value, 1), To(t.value, 2), To(t.value, 3)) ? 0 : 1;
}
function t_e(t, e) {
  if (!t)
    return 0;
  let n = 0, r = [], i = 0;
  e:
    do {
      switch (t.type) {
        // ... <bad-string-token>, <bad-url-token>,
        case kA:
        case Ds:
          break e;
        // ... unmatched <)-token>, <]-token>, or <}-token>,
        case ua:
        case yt:
        case Ya:
          if (t.type !== n)
            break e;
          n = r.pop();
          break;
        // ... or top-level <semicolon-token> tokens
        case ss:
          if (n === 0)
            break e;
          break;
        // ... or <delim-token> tokens with a value of "!"
        case hn:
          if (n === 0 && t.value === "!")
            break e;
          break;
        case Rt:
        case kn:
        case ca:
        case Ri:
          r.push(n), n = a2.get(t.type);
          break;
      }
      i++;
    } while (t = e(i));
  return i;
}
function n_e(t, e) {
  if (!t)
    return 0;
  let n = 0, r = [], i = 0;
  e:
    do {
      switch (t.type) {
        // ... does not contain <bad-string-token>, <bad-url-token>,
        case kA:
        case Ds:
          break e;
        // ... unmatched <)-token>, <]-token>, or <}-token>,
        case ua:
        case yt:
        case Ya:
          if (t.type !== n)
            break e;
          n = r.pop();
          break;
        case Rt:
        case kn:
        case ca:
        case Ri:
          r.push(n), n = a2.get(t.type);
          break;
      }
      i++;
    } while (t = e(i));
  return i;
}
function _u(t) {
  return t && (t = new Set(t)), function(e, n, r) {
    if (e === null || e.type !== cn)
      return 0;
    const i = _A(e.value, 0);
    if (t !== null) {
      const s = e.value.indexOf("\\", i), a = s === -1 || !DH(e.value, s) ? e.value.substr(i) : e.value.substring(i, s);
      if (t.has(a.toLowerCase()) === !1)
        return 0;
    }
    return RA(r, e.value, i) ? 0 : 1;
  };
}
function r_e(t, e, n) {
  return t === null || t.type !== Dr || RA(n, t.value, t.value.length - 1) ? 0 : 1;
}
function RH(t) {
  return typeof t != "function" && (t = function() {
    return 0;
  }), function(e, n, r) {
    return e !== null && e.type === wt && Number(e.value) === 0 ? 1 : t(e, n, r);
  };
}
function i_e(t, e, n) {
  if (t === null)
    return 0;
  const r = _A(t.value, 0);
  return !(r === t.value.length) && !DH(t.value, r) || RA(n, t.value, r) ? 0 : 1;
}
function s_e(t, e, n) {
  if (t === null || t.type !== wt)
    return 0;
  let r = To(t.value, 0) === 43 || // U+002B PLUS SIGN (+)
  To(t.value, 0) === 45 ? 1 : 0;
  for (; r < t.value.length; r++)
    if (!Vi(To(t.value, r)))
      return 0;
  return RA(n, t.value, r) ? 0 : 1;
}
const a_e = {
  "ident-token": sr(He),
  "function-token": sr(Rt),
  "at-keyword-token": sr(ri),
  "hash-token": sr(or),
  "string-token": sr(Po),
  "bad-string-token": sr(kA),
  "url-token": sr(Xi),
  "bad-url-token": sr(Ds),
  "delim-token": sr(hn),
  "number-token": sr(wt),
  "percentage-token": sr(Dr),
  "dimension-token": sr(cn),
  "whitespace-token": sr(Lr),
  "CDO-token": sr(cp),
  "CDC-token": sr(Is),
  "colon-token": sr(is),
  "semicolon-token": sr(ss),
  "comma-token": sr(Gs),
  "[-token": sr(ca),
  "]-token": sr(Ya),
  "(-token": sr(kn),
  ")-token": sr(yt),
  "{-token": sr(Ri),
  "}-token": sr(ua)
}, o_e = {
  // token type aliases
  string: sr(Po),
  ident: sr(He),
  // percentage
  percentage: xa(r_e, qke),
  // numeric
  zero: RH(),
  number: xa(i_e, CR),
  integer: xa(s_e, CR),
  // complex types
  "custom-ident": Qke,
  "dashed-ident": IH,
  "custom-property-name": Xke,
  "hex-color": Zke,
  "id-selector": e_e,
  // element( <id-selector> )
  "an-plus-b": Uke,
  urange: Kke,
  "declaration-value": t_e,
  "any-value": n_e
}, u_e = [
  "length",
  "angle",
  "time",
  "frequency",
  "resolution",
  "flex",
  "decibel",
  "semitones"
];
function l_e(t) {
  const {
    angle: e,
    decibel: n,
    frequency: r,
    flex: i,
    length: s,
    resolution: a,
    semitones: o,
    time: u
  } = t || {};
  return {
    dimension: xa(_u(null), ku),
    angle: xa(_u(e), ku),
    decibel: xa(_u(n), ku),
    frequency: xa(_u(r), ku),
    flex: xa(_u(i), ku),
    length: xa(RH(_u(s)), ku),
    resolution: xa(_u(a), ku),
    semitones: xa(_u(o), ku),
    time: xa(_u(u), ku)
  };
}
function c_e(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of u_e)
    if (Array.isArray(t[n]))
      for (const r of t[n])
        e.add(r.toLowerCase());
  return function(r) {
    return r === null ? 0 : r.type === hn && r.value === "%" || r.type === He && e.has(r.value.toLowerCase()) ? 1 : 0;
  };
}
function h_e(t) {
  return {
    ...a_e,
    ...o_e,
    ...l_e(t),
    "attr-unit": c_e(t)
  };
}
const d_e = [
  // absolute length units https://www.w3.org/TR/css-values-3/#lengths
  "cm",
  "mm",
  "q",
  "in",
  "pt",
  "pc",
  "px",
  // font-relative length units https://drafts.csswg.org/css-values-4/#font-relative-lengths
  "em",
  "rem",
  "ex",
  "rex",
  "cap",
  "rcap",
  "ch",
  "rch",
  "ic",
  "ric",
  "lh",
  "rlh",
  // viewport-percentage lengths https://drafts.csswg.org/css-values-4/#viewport-relative-lengths
  "vw",
  "svw",
  "lvw",
  "dvw",
  "vh",
  "svh",
  "lvh",
  "dvh",
  "vi",
  "svi",
  "lvi",
  "dvi",
  "vb",
  "svb",
  "lvb",
  "dvb",
  "vmin",
  "svmin",
  "lvmin",
  "dvmin",
  "vmax",
  "svmax",
  "lvmax",
  "dvmax",
  // container relative lengths https://drafts.csswg.org/css-contain-3/#container-lengths
  "cqw",
  "cqh",
  "cqi",
  "cqb",
  "cqmin",
  "cqmax"
], f_e = ["deg", "grad", "rad", "turn"], m_e = ["s", "ms"], g_e = ["hz", "khz"], p_e = ["dpi", "dpcm", "dppx", "x"], b_e = ["fr"], y_e = ["db"], A_e = ["st"], kR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  angle: f_e,
  decibel: y_e,
  flex: b_e,
  frequency: g_e,
  length: d_e,
  resolution: p_e,
  semitones: A_e,
  time: m_e
}, Symbol.toStringTag, { value: "Module" }));
function E_e(t, e, n) {
  return Object.assign(IA("SyntaxError", t), {
    input: e,
    offset: n,
    rawMessage: t,
    message: t + `
  ` + e + `
--` + new Array((n || e.length) + 1).join("-") + "^"
  });
}
const S_e = 9, w_e = 10, F_e = 12, T_e = 13, v_e = 32, _R = new Uint8Array(128).map(
  (t, e) => /[a-zA-Z0-9\-]/.test(String.fromCharCode(e)) ? 1 : 0
);
class x_e {
  constructor(e) {
    this.str = e, this.pos = 0;
  }
  charCodeAt(e) {
    return e < this.str.length ? this.str.charCodeAt(e) : 0;
  }
  charCode() {
    return this.charCodeAt(this.pos);
  }
  isNameCharCode(e = this.charCode()) {
    return e < 128 && _R[e] === 1;
  }
  nextCharCode() {
    return this.charCodeAt(this.pos + 1);
  }
  nextNonWsCode(e) {
    return this.charCodeAt(this.findWsEnd(e));
  }
  skipWs() {
    this.pos = this.findWsEnd(this.pos);
  }
  findWsEnd(e) {
    for (; e < this.str.length; e++) {
      const n = this.str.charCodeAt(e);
      if (n !== T_e && n !== w_e && n !== F_e && n !== v_e && n !== S_e)
        break;
    }
    return e;
  }
  substringToPos(e) {
    return this.str.substring(this.pos, this.pos = e);
  }
  eat(e) {
    this.charCode() !== e && this.error("Expect `" + String.fromCharCode(e) + "`"), this.pos++;
  }
  peek() {
    return this.pos < this.str.length ? this.str.charAt(this.pos++) : "";
  }
  error(e) {
    throw new E_e(e, this.str, this.pos);
  }
  scanSpaces() {
    return this.substringToPos(this.findWsEnd(this.pos));
  }
  scanWord() {
    let e = this.pos;
    for (; e < this.str.length; e++) {
      const n = this.str.charCodeAt(e);
      if (n >= 128 || _R[n] === 0)
        break;
    }
    return this.pos === e && this.error("Expect a keyword"), this.substringToPos(e);
  }
  scanNumber() {
    let e = this.pos;
    for (; e < this.str.length; e++) {
      const n = this.str.charCodeAt(e);
      if (n < 48 || n > 57)
        break;
    }
    return this.pos === e && this.error("Expect a number"), this.substringToPos(e);
  }
  scanString() {
    const e = this.str.indexOf("'", this.pos + 1);
    return e === -1 && (this.pos = this.str.length, this.error("Expect an apostrophe")), this.substringToPos(e + 1);
  }
}
const C_e = 9, k_e = 10, __e = 12, N_e = 13, D_e = 32, PH = 33, o2 = 35, NR = 38, w1 = 39, LH = 40, MH = 41, OH = 42, u2 = 43, l2 = 44, DR = 45, c2 = 60, ev = 62, F1 = 63, I_e = 64, Dg = 91, Af = 93, T1 = 123, IR = 124, tv = 125, RR = 8734, PR = {
  " ": 1,
  "&&": 2,
  "||": 3,
  "|": 4
};
function LR(t) {
  let e = null, n = null;
  return t.eat(T1), t.skipWs(), e = t.scanNumber(t), t.skipWs(), t.charCode() === l2 ? (t.pos++, t.skipWs(), t.charCode() !== tv && (n = t.scanNumber(t), t.skipWs())) : n = e, t.eat(tv), {
    min: Number(e),
    max: n ? Number(n) : 0
  };
}
function R_e(t) {
  let e = null, n = !1;
  switch (t.charCode()) {
    case OH:
      t.pos++, e = {
        min: 0,
        max: 0
      };
      break;
    case u2:
      t.pos++, e = {
        min: 1,
        max: 0
      };
      break;
    case F1:
      t.pos++, e = {
        min: 0,
        max: 1
      };
      break;
    case o2:
      t.pos++, n = !0, t.charCode() === T1 ? e = LR(t) : t.charCode() === F1 ? (t.pos++, e = {
        min: 0,
        max: 0
      }) : e = {
        min: 1,
        max: 0
      };
      break;
    case T1:
      e = LR(t);
      break;
    default:
      return null;
  }
  return {
    type: "Multiplier",
    comma: n,
    min: e.min,
    max: e.max,
    term: null
  };
}
function Ju(t, e) {
  const n = R_e(t);
  return n !== null ? (n.term = e, t.charCode() === o2 && t.charCodeAt(t.pos - 1) === u2 || t.charCode() === F1 && t.charCodeAt(t.pos - 1) === tv ? Ju(t, n) : n) : e;
}
function Mw(t) {
  const e = t.peek();
  return e === "" ? null : Ju(t, {
    type: "Token",
    value: e
  });
}
function P_e(t) {
  let e;
  return t.eat(c2), t.eat(w1), e = t.scanWord(), t.eat(w1), t.eat(ev), Ju(t, {
    type: "Property",
    name: e
  });
}
function L_e(t) {
  let e = null, n = null, r = 1;
  return t.eat(Dg), t.charCode() === DR && (t.peek(), r = -1), r == -1 && t.charCode() === RR ? t.peek() : (e = r * Number(t.scanNumber(t)), t.isNameCharCode() && (e += t.scanWord())), t.skipWs(), t.eat(l2), t.skipWs(), t.charCode() === RR ? t.peek() : (r = 1, t.charCode() === DR && (t.peek(), r = -1), n = r * Number(t.scanNumber(t)), t.isNameCharCode() && (n += t.scanWord())), t.eat(Af), {
    type: "Range",
    min: e,
    max: n
  };
}
function M_e(t) {
  let e, n = null;
  if (t.eat(c2), e = t.scanWord(), e === "boolean-expr") {
    t.eat(Dg);
    const r = PA(t, Af);
    return t.eat(Af), t.eat(ev), Ju(t, {
      type: "Boolean",
      term: r.terms.length === 1 ? r.terms[0] : r
    });
  }
  return t.charCode() === LH && t.nextCharCode() === MH && (t.pos += 2, e += "()"), t.charCodeAt(t.findWsEnd(t.pos)) === Dg && (t.skipWs(), n = L_e(t)), t.eat(ev), Ju(t, {
    type: "Type",
    name: e,
    opts: n
  });
}
function O_e(t) {
  const e = t.scanWord();
  return t.charCode() === LH ? (t.pos++, {
    type: "Function",
    name: e
  }) : Ju(t, {
    type: "Keyword",
    name: e
  });
}
function B_e(t, e) {
  function n(i, s) {
    return {
      type: "Group",
      terms: i,
      combinator: s,
      disallowEmpty: !1,
      explicit: !1
    };
  }
  let r;
  for (e = Object.keys(e).sort((i, s) => PR[i] - PR[s]); e.length > 0; ) {
    r = e.shift();
    let i = 0, s = 0;
    for (; i < t.length; i++) {
      const a = t[i];
      a.type === "Combinator" && (a.value === r ? (s === -1 && (s = i - 1), t.splice(i, 1), i--) : (s !== -1 && i - s > 1 && (t.splice(
        s,
        i - s,
        n(t.slice(s, i), r)
      ), i = s + 1), s = -1));
    }
    s !== -1 && e.length && t.splice(
      s,
      i - s,
      n(t.slice(s, i), r)
    );
  }
  return r;
}
function PA(t, e = -1) {
  const n = /* @__PURE__ */ Object.create(null), r = [];
  let i = null, s = t.pos, a = !1;
  for (; t.charCode() !== e; ) {
    let o = a ? PA(t, MH) : H_e(t);
    if (!o)
      break;
    if (o.type !== "Spaces") {
      if (a) {
        if (o.terms.length === 0) {
          a = !1;
          continue;
        }
        if (o.combinator === " ") {
          for (; o.terms.length > 1; )
            n[" "] = !0, r.push({
              type: "Combinator",
              value: " "
            }, o.terms.shift());
          o = o.terms[0];
        }
      }
      o.type === "Combinator" ? ((i === null || i.type === "Combinator") && (t.pos = s, t.error("Unexpected combinator")), n[o.value] = !0) : i !== null && i.type !== "Combinator" && (n[" "] = !0, r.push({
        type: "Combinator",
        value: " "
      })), r.push(o), i = o, s = t.pos, a = o.type === "Function";
    }
  }
  return i !== null && i.type === "Combinator" && (t.pos -= s, t.error("Unexpected combinator")), {
    type: "Group",
    terms: r,
    combinator: B_e(r, n) || " ",
    disallowEmpty: !1,
    explicit: !1
  };
}
function $_e(t) {
  let e;
  return t.eat(Dg), e = PA(t, Af), t.eat(Af), e.explicit = !0, t.charCode() === PH && (t.pos++, e.disallowEmpty = !0), e;
}
function H_e(t) {
  let e = t.charCode();
  switch (e) {
    case Af:
      break;
    case Dg:
      return Ju(t, $_e(t));
    case c2:
      return t.nextCharCode() === w1 ? P_e(t) : M_e(t);
    case IR:
      return {
        type: "Combinator",
        value: t.substringToPos(
          t.pos + (t.nextCharCode() === IR ? 2 : 1)
        )
      };
    case NR:
      return t.pos++, t.eat(NR), {
        type: "Combinator",
        value: "&&"
      };
    case l2:
      return t.pos++, {
        type: "Comma"
      };
    case w1:
      return Ju(t, {
        type: "String",
        value: t.scanString()
      });
    case D_e:
    case C_e:
    case k_e:
    case N_e:
    case __e:
      return {
        type: "Spaces",
        value: t.scanSpaces()
      };
    case I_e:
      return e = t.nextCharCode(), t.isNameCharCode(e) ? (t.pos++, {
        type: "AtKeyword",
        name: t.scanWord()
      }) : Mw(t);
    case OH:
    case u2:
    case F1:
    case o2:
    case PH:
      break;
    case T1:
      if (e = t.nextCharCode(), e < 48 || e > 57)
        return Mw(t);
      break;
    default:
      return t.isNameCharCode(e) ? O_e(t) : Mw(t);
  }
}
function BH(t) {
  const e = new x_e(t), n = PA(e);
  return e.pos !== t.length && e.error("Unexpected input"), n.terms.length === 1 && n.terms[0].type === "Group" ? n.terms[0] : n;
}
const Mm = function() {
};
function MR(t) {
  return typeof t == "function" ? t : Mm;
}
function U_e(t, e, n) {
  function r(a) {
    switch (i.call(n, a), a.type) {
      case "Group":
        a.terms.forEach(r);
        break;
      case "Multiplier":
      case "Boolean":
        r(a.term);
        break;
      case "Type":
      case "Property":
      case "Keyword":
      case "AtKeyword":
      case "Function":
      case "String":
      case "Token":
      case "Comma":
        break;
      default:
        throw new Error("Unknown type: " + a.type);
    }
    s.call(n, a);
  }
  let i = Mm, s = Mm;
  if (typeof e == "function" ? i = e : e && (i = MR(e.enter), s = MR(e.leave)), i === Mm && s === Mm)
    throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
  r(t);
}
const G_e = {
  decorator(t) {
    const e = [];
    let n = null;
    return {
      ...t,
      node(r) {
        const i = n;
        n = r, t.node.call(this, r), n = i;
      },
      emit(r, i, s) {
        e.push({
          type: i,
          value: r,
          node: s ? null : n
        });
      },
      result() {
        return e;
      }
    };
  }
};
function W_e(t) {
  const e = [];
  return DA(
    t,
    (n, r, i) => e.push({
      type: n,
      value: t.slice(r, i),
      node: null
    })
  ), e;
}
function V_e(t, e) {
  return typeof t == "string" ? W_e(t) : e.generate(t, G_e);
}
const Nn = { type: "Match" }, jn = { type: "Mismatch" }, h2 = { type: "DisallowEmpty" }, K_e = 40, z_e = 41;
function Ji(t, e, n) {
  return e === Nn && n === jn || t === Nn && e === Nn && n === Nn ? t : (t.type === "If" && t.else === jn && e === Nn && (e = t.then, t = t.match), {
    type: "If",
    match: t,
    then: e,
    else: n
  });
}
function $H(t) {
  return t.length > 2 && t.charCodeAt(t.length - 2) === K_e && t.charCodeAt(t.length - 1) === z_e;
}
function OR(t) {
  return t.type === "Keyword" || t.type === "AtKeyword" || t.type === "Function" || t.type === "Type" && $H(t.name);
}
function hl(t, e = " ", n = !1) {
  return {
    type: "Group",
    terms: t,
    combinator: e,
    disallowEmpty: !1,
    explicit: n
  };
}
function ag(t, e, n = /* @__PURE__ */ new Set()) {
  if (!n.has(t))
    switch (n.add(t), t.type) {
      case "If":
        t.match = ag(t.match, e, n), t.then = ag(t.then, e, n), t.else = ag(t.else, e, n);
        break;
      case "Type":
        return e[t.name] || t;
    }
  return t;
}
function nv(t, e, n) {
  switch (t) {
    case " ": {
      let r = Nn;
      for (let i = e.length - 1; i >= 0; i--) {
        const s = e[i];
        r = Ji(
          s,
          r,
          jn
        );
      }
      return r;
    }
    case "|": {
      let r = jn, i = null;
      for (let s = e.length - 1; s >= 0; s--) {
        let a = e[s];
        if (OR(a) && (i === null && s > 0 && OR(e[s - 1]) && (i = /* @__PURE__ */ Object.create(null), r = Ji(
          {
            type: "Enum",
            map: i
          },
          Nn,
          r
        )), i !== null)) {
          const o = ($H(a.name) ? a.name.slice(0, -1) : a.name).toLowerCase();
          if (!(o in i)) {
            i[o] = a;
            continue;
          }
        }
        i = null, r = Ji(
          a,
          Nn,
          r
        );
      }
      return r;
    }
    case "&&": {
      if (e.length > 5)
        return {
          type: "MatchOnce",
          terms: e,
          all: !0
        };
      let r = jn;
      for (let i = e.length - 1; i >= 0; i--) {
        const s = e[i];
        let a;
        e.length > 1 ? a = nv(
          t,
          e.filter(function(o) {
            return o !== s;
          }),
          !1
        ) : a = Nn, r = Ji(
          s,
          a,
          r
        );
      }
      return r;
    }
    case "||": {
      if (e.length > 5)
        return {
          type: "MatchOnce",
          terms: e,
          all: !1
        };
      let r = n ? Nn : jn;
      for (let i = e.length - 1; i >= 0; i--) {
        const s = e[i];
        let a;
        e.length > 1 ? a = nv(
          t,
          e.filter(function(o) {
            return o !== s;
          }),
          !0
        ) : a = Nn, r = Ji(
          s,
          a,
          r
        );
      }
      return r;
    }
  }
}
function j_e(t) {
  let e = Nn, n = kd(t.term);
  if (t.max === 0)
    n = Ji(
      n,
      h2,
      jn
    ), e = Ji(
      n,
      null,
      // will be a loop
      jn
    ), e.then = Ji(
      Nn,
      Nn,
      e
      // make a loop
    ), t.comma && (e.then.else = Ji(
      { type: "Comma", syntax: t },
      e,
      jn
    ));
  else
    for (let r = t.min || 1; r <= t.max; r++)
      t.comma && e !== Nn && (e = Ji(
        { type: "Comma", syntax: t },
        e,
        jn
      )), e = Ji(
        n,
        Ji(
          Nn,
          Nn,
          e
        ),
        jn
      );
  if (t.min === 0)
    e = Ji(
      Nn,
      Nn,
      e
    );
  else
    for (let r = 0; r < t.min - 1; r++)
      t.comma && e !== Nn && (e = Ji(
        { type: "Comma", syntax: t },
        e,
        jn
      )), e = Ji(
        n,
        e,
        jn
      );
  return e;
}
function kd(t) {
  if (typeof t == "function")
    return {
      type: "Generic",
      fn: t
    };
  switch (t.type) {
    case "Group": {
      let e = nv(
        t.combinator,
        t.terms.map(kd),
        !1
      );
      return t.disallowEmpty && (e = Ji(
        e,
        h2,
        jn
      )), e;
    }
    case "Multiplier":
      return j_e(t);
    // https://drafts.csswg.org/css-values-5/#boolean
    case "Boolean": {
      const e = kd(t.term), n = kd(hl([
        hl([
          { type: "Keyword", name: "not" },
          { type: "Type", name: "!boolean-group" }
        ]),
        hl([
          { type: "Type", name: "!boolean-group" },
          hl([
            { type: "Multiplier", comma: !1, min: 0, max: 0, term: hl([
              { type: "Keyword", name: "and" },
              { type: "Type", name: "!boolean-group" }
            ]) },
            { type: "Multiplier", comma: !1, min: 0, max: 0, term: hl([
              { type: "Keyword", name: "or" },
              { type: "Type", name: "!boolean-group" }
            ]) }
          ], "|")
        ])
      ], "|")), r = kd(
        hl([
          { type: "Type", name: "!term" },
          hl([
            { type: "Token", value: "(" },
            { type: "Type", name: "!self" },
            { type: "Token", value: ")" }
          ]),
          { type: "Type", name: "general-enclosed" }
        ], "|")
      );
      return ag(r, { "!term": e, "!self": n }), ag(n, { "!boolean-group": r }), n;
    }
    case "Type":
    case "Property":
      return {
        type: t.type,
        name: t.name,
        syntax: t
      };
    case "Keyword":
      return {
        type: t.type,
        name: t.name.toLowerCase(),
        syntax: t
      };
    case "AtKeyword":
      return {
        type: t.type,
        name: "@" + t.name.toLowerCase(),
        syntax: t
      };
    case "Function":
      return {
        type: t.type,
        name: t.name.toLowerCase() + "(",
        syntax: t
      };
    case "String":
      return t.value.length === 3 ? {
        type: "Token",
        value: t.value.charAt(1),
        syntax: t
      } : {
        type: t.type,
        value: t.value.substr(1, t.value.length - 2).replace(/\\'/g, "'"),
        syntax: t
      };
    case "Token":
      return {
        type: t.type,
        value: t.value,
        syntax: t
      };
    case "Comma":
      return {
        type: t.type,
        syntax: t
      };
    default:
      throw new Error("Unknown node type:", t.type);
  }
}
function $0(t, e) {
  return typeof t == "string" && (t = BH(t)), {
    type: "MatchGraph",
    match: kd(t),
    syntax: e || null,
    source: t
  };
}
const { hasOwnProperty: BR } = Object.prototype, Y_e = 0, q_e = 1, rv = 2, HH = 3, $R = "Match", J_e = "Mismatch", Q_e = "Maximum iteration number exceeded (please fill an issue on https://github.com/csstree/csstree/issues)", HR = 15e3;
function X_e(t) {
  let e = null, n = null, r = t;
  for (; r !== null; )
    n = r.prev, r.prev = e, e = r, r = n;
  return e;
}
function Ow(t, e) {
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n++) {
    const r = e.charCodeAt(n);
    let i = t.charCodeAt(n);
    if (i >= 65 && i <= 90 && (i = i | 32), i !== r)
      return !1;
  }
  return !0;
}
function Z_e(t) {
  return t.type !== hn ? !1 : t.value !== "?";
}
function UR(t) {
  return t === null ? !0 : t.type === Gs || t.type === Rt || t.type === kn || t.type === ca || t.type === Ri || Z_e(t);
}
function GR(t) {
  return t === null ? !0 : t.type === yt || t.type === Ya || t.type === ua || t.type === hn && t.value === "/";
}
function e3e(t, e, n) {
  function r() {
    do
      N++, x = N < t.length ? t[N] : null;
    while (x !== null && (x.type === Lr || x.type === Ki));
  }
  function i(C) {
    const D = N + C;
    return D < t.length ? t[D] : null;
  }
  function s(C, D) {
    return {
      nextState: C,
      matchStack: P,
      syntaxStack: f,
      thenStack: m,
      tokenIndex: N,
      prev: D
    };
  }
  function a(C) {
    m = {
      nextState: C,
      matchStack: P,
      syntaxStack: f,
      prev: m
    };
  }
  function o(C) {
    g = s(C, g);
  }
  function u() {
    P = {
      type: q_e,
      syntax: e.syntax,
      token: x,
      prev: P
    }, r(), A = null, N > B && (B = N);
  }
  function l() {
    f = {
      syntax: e.syntax,
      opts: e.syntax.opts || f !== null && f.opts || null,
      prev: f
    }, P = {
      type: rv,
      syntax: e.syntax,
      token: P.token,
      prev: P
    };
  }
  function h() {
    P.type === rv ? P = P.prev : P = {
      type: HH,
      syntax: f.syntax,
      token: P.token,
      prev: P
    }, f = f.prev;
  }
  let f = null, m = null, g = null, A = null, E = 0, w = null, x = null, N = -1, B = 0, P = {
    type: Y_e,
    syntax: null,
    token: null,
    prev: null
  };
  for (r(); w === null && ++E < HR; )
    switch (e.type) {
      case "Match":
        if (m === null) {
          if (x !== null && (N !== t.length - 1 || x.value !== "\\0" && x.value !== "\\9")) {
            e = jn;
            break;
          }
          w = $R;
          break;
        }
        if (e = m.nextState, e === h2)
          if (m.matchStack === P) {
            e = jn;
            break;
          } else
            e = Nn;
        for (; m.syntaxStack !== f; )
          h();
        m = m.prev;
        break;
      case "Mismatch":
        if (A !== null && A !== !1)
          (g === null || N > g.tokenIndex) && (g = A, A = !1);
        else if (g === null) {
          w = J_e;
          break;
        }
        e = g.nextState, m = g.thenStack, f = g.syntaxStack, P = g.matchStack, N = g.tokenIndex, x = N < t.length ? t[N] : null, g = g.prev;
        break;
      case "MatchGraph":
        e = e.match;
        break;
      case "If":
        e.else !== jn && o(e.else), e.then !== Nn && a(e.then), e = e.match;
        break;
      case "MatchOnce":
        e = {
          type: "MatchOnceBuffer",
          syntax: e,
          index: 0,
          mask: 0
        };
        break;
      case "MatchOnceBuffer": {
        const L = e.syntax.terms;
        if (e.index === L.length) {
          if (e.mask === 0 || e.syntax.all) {
            e = jn;
            break;
          }
          e = Nn;
          break;
        }
        if (e.mask === (1 << L.length) - 1) {
          e = Nn;
          break;
        }
        for (; e.index < L.length; e.index++) {
          const k = 1 << e.index;
          if ((e.mask & k) === 0) {
            o(e), a({
              type: "AddMatchOnce",
              syntax: e.syntax,
              mask: e.mask | k
            }), e = L[e.index++];
            break;
          }
        }
        break;
      }
      case "AddMatchOnce":
        e = {
          type: "MatchOnceBuffer",
          syntax: e.syntax,
          index: 0,
          mask: e.mask
        };
        break;
      case "Enum":
        if (x !== null) {
          let L = x.value.toLowerCase();
          if (L.indexOf("\\") !== -1 && (L = L.replace(/\\[09].*$/, "")), BR.call(e.map, L)) {
            e = e.map[L];
            break;
          }
        }
        e = jn;
        break;
      case "Generic": {
        const L = f !== null ? f.opts : null, k = N + Math.floor(e.fn(x, i, L));
        if (!isNaN(k) && k > N) {
          for (; N < k; )
            u();
          e = Nn;
        } else
          e = jn;
        break;
      }
      case "Type":
      case "Property": {
        const L = e.type === "Type" ? "types" : "properties", k = BR.call(n, L) ? n[L][e.name] : null;
        if (!k || !k.match)
          throw new Error(
            "Bad syntax reference: " + (e.type === "Type" ? "<" + e.name + ">" : "<'" + e.name + "'>")
          );
        if (A !== !1 && x !== null && e.type === "Type" && // https://drafts.csswg.org/css-values-4/#custom-idents
        // When parsing positionally-ambiguous keywords in a property value, a <custom-ident> production
        // can only claim the keyword if no other unfulfilled production can claim it.
        (e.name === "custom-ident" && x.type === He || // https://drafts.csswg.org/css-values-4/#lengths
        // ... if a `0` could be parsed as either a <number> or a <length> in a property (such as line-height),
        // it must parse as a <number>
        e.name === "length" && x.value === "0")) {
          A === null && (A = s(e, g)), e = jn;
          break;
        }
        l(), e = k.matchRef || k.match;
        break;
      }
      case "Keyword": {
        const L = e.name;
        if (x !== null) {
          let k = x.value;
          if (k.indexOf("\\") !== -1 && (k = k.replace(/\\[09].*$/, "")), Ow(k, L)) {
            u(), e = Nn;
            break;
          }
        }
        e = jn;
        break;
      }
      case "AtKeyword":
      case "Function":
        if (x !== null && Ow(x.value, e.name)) {
          u(), e = Nn;
          break;
        }
        e = jn;
        break;
      case "Token":
        if (x !== null && x.value === e.value) {
          u(), e = Nn;
          break;
        }
        e = jn;
        break;
      case "Comma":
        x !== null && x.type === Gs ? UR(P.token) ? e = jn : (u(), e = GR(x) ? jn : Nn) : e = UR(P.token) || GR(x) ? Nn : jn;
        break;
      case "String":
        let C = "", D = N;
        for (; D < t.length && C.length < e.value.length; D++)
          C += t[D].value;
        if (Ow(C, e.value)) {
          for (; N < D; )
            u();
          e = Nn;
        } else
          e = jn;
        break;
      default:
        throw new Error("Unknown node type: " + e.type);
    }
  switch (w) {
    case null:
      console.warn("[csstree-match] BREAK after " + HR + " iterations"), w = Q_e, P = null;
      break;
    case $R:
      for (; f !== null; )
        h();
      break;
    default:
      P = null;
  }
  return {
    tokens: t,
    reason: w,
    iterations: E,
    match: P,
    longestMatch: B
  };
}
function WR(t, e, n) {
  const r = e3e(t, e, n || {});
  if (r.match === null)
    return r;
  let i = r.match, s = r.match = {
    syntax: e.syntax || null,
    match: []
  };
  const a = [s];
  for (i = X_e(i).prev; i !== null; ) {
    switch (i.type) {
      case rv:
        s.match.push(s = {
          syntax: i.syntax,
          match: []
        }), a.push(s);
        break;
      case HH:
        a.pop(), s = a[a.length - 1];
        break;
      default:
        s.match.push({
          syntax: i.syntax || null,
          token: i.token.value,
          node: i.token.node
        });
    }
    i = i.prev;
  }
  return r;
}
function UH(t) {
  function e(i) {
    return i === null ? !1 : i.type === "Type" || i.type === "Property" || i.type === "Keyword";
  }
  function n(i) {
    if (Array.isArray(i.match)) {
      for (let s = 0; s < i.match.length; s++)
        if (n(i.match[s]))
          return e(i.syntax) && r.unshift(i.syntax), !0;
    } else if (i.node === t)
      return r = e(i.syntax) ? [i.syntax] : [], !0;
    return !1;
  }
  let r = null;
  return this.matched !== null && n(this.matched), r;
}
function t3e(t, e) {
  return d2(this, t, (n) => n.type === "Type" && n.name === e);
}
function n3e(t, e) {
  return d2(this, t, (n) => n.type === "Property" && n.name === e);
}
function r3e(t) {
  return d2(this, t, (e) => e.type === "Keyword");
}
function d2(t, e, n) {
  const r = UH.call(t, e);
  return r === null ? !1 : r.some(n);
}
const i3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getTrace: UH,
  isKeyword: r3e,
  isProperty: n3e,
  isType: t3e
}, Symbol.toStringTag, { value: "Module" }));
function GH(t) {
  return "node" in t ? t.node : GH(t.match[0]);
}
function WH(t) {
  return "node" in t ? t.node : WH(t.match[t.match.length - 1]);
}
function VR(t, e, n, r, i) {
  function s(o) {
    if (o.syntax !== null && o.syntax.type === r && o.syntax.name === i) {
      const u = GH(o), l = WH(o);
      t.syntax.walk(e, function(h, f, m) {
        if (h === u) {
          const g = new wi();
          do {
            if (g.appendData(f.data), f.data === l)
              break;
            f = f.next;
          } while (f !== null);
          a.push({
            parent: m,
            nodes: g
          });
        }
      });
    }
    Array.isArray(o.match) && o.match.forEach(s);
  }
  const a = [];
  return n.matched !== null && s(n.matched), a;
}
const { hasOwnProperty: og } = Object.prototype;
function Bw(t) {
  return typeof t == "number" && isFinite(t) && Math.floor(t) === t && t >= 0;
}
function KR(t) {
  return !!t && Bw(t.offset) && Bw(t.line) && Bw(t.column);
}
function s3e(t, e) {
  return function(r, i) {
    if (!r || r.constructor !== Object)
      return i(r, "Type of node should be an Object");
    for (let s in r) {
      let a = !0;
      if (og.call(r, s) !== !1) {
        if (s === "type")
          r.type !== t && i(r, "Wrong node type `" + r.type + "`, expected `" + t + "`");
        else if (s === "loc") {
          if (r.loc === null)
            continue;
          if (r.loc && r.loc.constructor === Object)
            if (typeof r.loc.source != "string")
              s += ".source";
            else if (!KR(r.loc.start))
              s += ".start";
            else if (!KR(r.loc.end))
              s += ".end";
            else
              continue;
          a = !1;
        } else if (e.hasOwnProperty(s)) {
          a = !1;
          for (let o = 0; !a && o < e[s].length; o++) {
            const u = e[s][o];
            switch (u) {
              case String:
                a = typeof r[s] == "string";
                break;
              case Boolean:
                a = typeof r[s] == "boolean";
                break;
              case null:
                a = r[s] === null;
                break;
              default:
                typeof u == "string" ? a = r[s] && r[s].type === u : Array.isArray(u) && (a = r[s] instanceof wi);
            }
          }
        } else
          i(r, "Unknown field `" + s + "` for " + t + " node type");
        a || i(r, "Bad value for `" + t + "." + s + "`");
      }
    }
    for (const s in e)
      og.call(e, s) && og.call(r, s) === !1 && i(r, "Field `" + t + "." + s + "` is missed");
  };
}
function VH(t, e) {
  const n = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    if (i === String || i === Boolean)
      n.push(i.name.toLowerCase());
    else if (i === null)
      n.push("null");
    else if (typeof i == "string")
      n.push(i);
    else if (Array.isArray(i))
      n.push("List<" + (VH(i, e) || "any") + ">");
    else
      throw new Error("Wrong value `" + i + "` in `" + e + "` structure definition");
  }
  return n.join(" | ");
}
function a3e(t, e) {
  const n = e.structure, r = {
    type: String,
    loc: !0
  }, i = {
    type: '"' + t + '"'
  };
  for (const s in n) {
    if (og.call(n, s) === !1)
      continue;
    const a = r[s] = Array.isArray(n[s]) ? n[s].slice() : [n[s]];
    i[s] = VH(a, t + "." + s);
  }
  return {
    docs: i,
    check: s3e(t, r)
  };
}
function o3e(t) {
  const e = {};
  if (t.node) {
    for (const n in t.node)
      if (og.call(t.node, n)) {
        const r = t.node[n];
        if (r.structure)
          e[n] = a3e(n, r);
        else
          throw new Error("Missed `structure` field in `" + n + "` node type definition");
      }
  }
  return e;
}
function iv(t, e, n) {
  const r = {};
  for (const i in t)
    t[i].syntax && (r[i] = n ? t[i].syntax : XC(t[i].syntax, { compact: e }));
  return r;
}
function u3e(t, e, n) {
  const r = {};
  for (const [i, s] of Object.entries(t))
    r[i] = {
      prelude: s.prelude && (n ? s.prelude.syntax : XC(s.prelude.syntax, { compact: e })),
      descriptors: s.descriptors && iv(s.descriptors, e, n)
    };
  return r;
}
function l3e(t) {
  for (let e = 0; e < t.length; e++)
    if (t[e].value.toLowerCase() === "var(")
      return !0;
  return !1;
}
function c3e(t) {
  const e = t.terms[0];
  return t.explicit === !1 && t.terms.length === 1 && e.type === "Multiplier" && e.comma === !0;
}
function co(t, e, n) {
  return {
    matched: t,
    iterations: n,
    error: e,
    ...i3e
  };
}
function sd(t, e, n, r) {
  const i = V_e(n, t.syntax);
  let s;
  return l3e(i) ? co(null, new Error("Matching for a tree with var() is not supported")) : (r && (s = WR(i, t.cssWideKeywordsSyntax, t)), (!r || !s.match) && (s = WR(i, e.match, t), !s.match) ? co(
    null,
    new Oke(s.reason, e.syntax, n, s),
    s.iterations
  ) : co(s.match, null, s.iterations));
}
class zR {
  constructor(e, n, r) {
    if (this.cssWideKeywords = e2, this.syntax = n, this.generic = !1, this.units = { ...kR }, this.atrules = /* @__PURE__ */ Object.create(null), this.properties = /* @__PURE__ */ Object.create(null), this.types = /* @__PURE__ */ Object.create(null), this.structure = r || o3e(e), e) {
      if (e.cssWideKeywords && (this.cssWideKeywords = e.cssWideKeywords), e.units)
        for (const i of Object.keys(kR))
          Array.isArray(e.units[i]) && (this.units[i] = e.units[i]);
      if (e.types)
        for (const [i, s] of Object.entries(e.types))
          this.addType_(i, s);
      if (e.generic) {
        this.generic = !0;
        for (const [i, s] of Object.entries(h_e(this.units)))
          this.addType_(i, s);
      }
      if (e.atrules)
        for (const [i, s] of Object.entries(e.atrules))
          this.addAtrule_(i, s);
      if (e.properties)
        for (const [i, s] of Object.entries(e.properties))
          this.addProperty_(i, s);
    }
    this.cssWideKeywordsSyntax = $0(this.cssWideKeywords.join(" |  "));
  }
  checkStructure(e) {
    function n(s, a) {
      i.push({ node: s, message: a });
    }
    const r = this.structure, i = [];
    return this.syntax.walk(e, function(s) {
      r.hasOwnProperty(s.type) ? r[s.type].check(s, n) : n(s, "Unknown node type `" + s.type + "`");
    }), i.length ? i : !1;
  }
  createDescriptor(e, n, r, i = null) {
    const s = {
      type: n,
      name: r
    }, a = {
      type: n,
      name: r,
      parent: i,
      serializable: typeof e == "string" || e && typeof e.type == "string",
      syntax: null,
      match: null,
      matchRef: null
      // used for properties when a syntax referenced as <'property'> in other syntax definitions
    };
    return typeof e == "function" ? a.match = $0(e, s) : (typeof e == "string" ? Object.defineProperty(a, "syntax", {
      get() {
        return Object.defineProperty(a, "syntax", {
          value: BH(e)
        }), a.syntax;
      }
    }) : a.syntax = e, Object.defineProperty(a, "match", {
      get() {
        return Object.defineProperty(a, "match", {
          value: $0(a.syntax, s)
        }), a.match;
      }
    }), n === "Property" && Object.defineProperty(a, "matchRef", {
      get() {
        const o = a.syntax, u = c3e(o) ? $0({
          ...o,
          terms: [o.terms[0].term]
        }, s) : null;
        return Object.defineProperty(a, "matchRef", {
          value: u
        }), u;
      }
    })), a;
  }
  addAtrule_(e, n) {
    n && (this.atrules[e] = {
      type: "Atrule",
      name: e,
      prelude: n.prelude ? this.createDescriptor(n.prelude, "AtrulePrelude", e) : null,
      descriptors: n.descriptors ? Object.keys(n.descriptors).reduce(
        (r, i) => (r[i] = this.createDescriptor(n.descriptors[i], "AtruleDescriptor", i, e), r),
        /* @__PURE__ */ Object.create(null)
      ) : null
    });
  }
  addProperty_(e, n) {
    n && (this.properties[e] = this.createDescriptor(n, "Property", e));
  }
  addType_(e, n) {
    n && (this.types[e] = this.createDescriptor(n, "Type", e));
  }
  checkAtruleName(e) {
    if (!this.getAtrule(e))
      return new om("Unknown at-rule", "@" + e);
  }
  checkAtrulePrelude(e, n) {
    const r = this.checkAtruleName(e);
    if (r)
      return r;
    const i = this.getAtrule(e);
    if (!i.prelude && n)
      return new SyntaxError("At-rule `@" + e + "` should not contain a prelude");
    if (i.prelude && !n && !sd(this, i.prelude, "", !1).matched)
      return new SyntaxError("At-rule `@" + e + "` should contain a prelude");
  }
  checkAtruleDescriptorName(e, n) {
    const r = this.checkAtruleName(e);
    if (r)
      return r;
    const i = this.getAtrule(e), s = Rw(n);
    if (!i.descriptors)
      return new SyntaxError("At-rule `@" + e + "` has no known descriptors");
    if (!i.descriptors[s.name] && !i.descriptors[s.basename])
      return new om("Unknown at-rule descriptor", n);
  }
  checkPropertyName(e) {
    if (!this.getProperty(e))
      return new om("Unknown property", e);
  }
  matchAtrulePrelude(e, n) {
    const r = this.checkAtrulePrelude(e, n);
    if (r)
      return co(null, r);
    const i = this.getAtrule(e);
    return i.prelude ? sd(this, i.prelude, n || "", !1) : co(null, null);
  }
  matchAtruleDescriptor(e, n, r) {
    const i = this.checkAtruleDescriptorName(e, n);
    if (i)
      return co(null, i);
    const s = this.getAtrule(e), a = Rw(n);
    return sd(this, s.descriptors[a.name] || s.descriptors[a.basename], r, !1);
  }
  matchDeclaration(e) {
    return e.type !== "Declaration" ? co(null, new Error("Not a Declaration node")) : this.matchProperty(e.property, e.value);
  }
  matchProperty(e, n) {
    if (xR(e).custom)
      return co(null, new Error("Lexer matching doesn't applicable for custom properties"));
    const r = this.checkPropertyName(e);
    return r ? co(null, r) : sd(this, this.getProperty(e), n, !0);
  }
  matchType(e, n) {
    const r = this.getType(e);
    return r ? sd(this, r, n, !1) : co(null, new om("Unknown type", e));
  }
  match(e, n) {
    return typeof e != "string" && (!e || !e.type) ? co(null, new om("Bad syntax")) : ((typeof e == "string" || !e.match) && (e = this.createDescriptor(e, "Type", "anonymous")), sd(this, e, n, !1));
  }
  findValueFragments(e, n, r, i) {
    return VR(this, n, this.matchProperty(e, n), r, i);
  }
  findDeclarationValueFragments(e, n, r) {
    return VR(this, e.value, this.matchDeclaration(e), n, r);
  }
  findAllFragments(e, n, r) {
    const i = [];
    return this.syntax.walk(e, {
      visit: "Declaration",
      enter: (s) => {
        i.push.apply(i, this.findDeclarationValueFragments(s, n, r));
      }
    }), i;
  }
  getAtrule(e, n = !0) {
    const r = Rw(e);
    return (r.vendor && n ? this.atrules[r.name] || this.atrules[r.basename] : this.atrules[r.name]) || null;
  }
  getAtrulePrelude(e, n = !0) {
    const r = this.getAtrule(e, n);
    return r && r.prelude || null;
  }
  getAtruleDescriptor(e, n) {
    return this.atrules.hasOwnProperty(e) && this.atrules.declarators && this.atrules[e].declarators[n] || null;
  }
  getProperty(e, n = !0) {
    const r = xR(e);
    return (r.vendor && n ? this.properties[r.name] || this.properties[r.basename] : this.properties[r.name]) || null;
  }
  getType(e) {
    return hasOwnProperty.call(this.types, e) ? this.types[e] : null;
  }
  validate() {
    function e(u, l) {
      return l ? `<${u}>` : `<'${u}'>`;
    }
    function n(u, l, h, f) {
      if (h.has(l))
        return h.get(l);
      h.set(l, !1), f.syntax !== null && U_e(f.syntax, function(m) {
        if (m.type !== "Type" && m.type !== "Property")
          return;
        const g = m.type === "Type" ? u.types : u.properties, A = m.type === "Type" ? i : s;
        hasOwnProperty.call(g, m.name) ? n(u, m.name, A, g[m.name]) && (r.push(`${e(l, h === i)} used broken syntax definition ${e(m.name, m.type === "Type")}`), h.set(l, !0)) : (r.push(`${e(l, h === i)} used missed syntax definition ${e(m.name, m.type === "Type")}`), h.set(l, !0));
      }, this);
    }
    const r = [];
    let i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
    for (const u in this.types)
      n(this, u, i, this.types[u]);
    for (const u in this.properties)
      n(this, u, s, this.properties[u]);
    const a = [...i.keys()].filter((u) => i.get(u)), o = [...s.keys()].filter((u) => s.get(u));
    return a.length || o.length ? {
      errors: r,
      types: a,
      properties: o
    } : null;
  }
  dump(e, n) {
    return {
      generic: this.generic,
      cssWideKeywords: this.cssWideKeywords,
      units: this.units,
      types: iv(this.types, !n, e),
      properties: iv(this.properties, !n, e),
      atrules: u3e(this.atrules, !n, e)
    };
  }
  toString() {
    return JSON.stringify(this.dump());
  }
}
function $w(t, e) {
  return typeof e == "string" && /^\s*\|/.test(e) ? typeof t == "string" ? t + e : e.replace(/^\s*\|\s*/, "") : e || null;
}
function h3e(t, e) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const r of Object.keys(t))
    e.includes(r) && (n[r] = t[r]);
  return n;
}
function Hw(t, e, n) {
  const r = { ...t };
  for (const [i, s] of Object.entries(e))
    r[i] = {
      ...r[i],
      ...n ? h3e(s, n) : s
    };
  return r;
}
function sv(t, e) {
  const n = { ...t };
  for (const [r, i] of Object.entries(e))
    switch (r) {
      case "generic":
        n[r] = !!i;
        break;
      case "cssWideKeywords":
        n[r] = t[r] ? [...t[r], ...i] : i || [];
        break;
      case "units":
        n[r] = { ...t[r] };
        for (const [s, a] of Object.entries(i))
          n[r][s] = Array.isArray(a) ? a : [];
        break;
      case "atrules":
        n[r] = { ...t[r] };
        for (const [s, a] of Object.entries(i)) {
          const o = n[r][s] || {}, u = n[r][s] = {
            prelude: o.prelude || null,
            descriptors: {
              ...o.descriptors
            }
          };
          if (a) {
            u.prelude = a.prelude ? $w(u.prelude, a.prelude) : u.prelude || null;
            for (const [l, h] of Object.entries(a.descriptors || {}))
              u.descriptors[l] = h ? $w(u.descriptors[l], h) : null;
            Object.keys(u.descriptors).length || (u.descriptors = null);
          }
        }
        break;
      case "types":
      case "properties":
        n[r] = { ...t[r] };
        for (const [s, a] of Object.entries(i))
          n[r][s] = $w(n[r][s], a);
        break;
      case "parseContext":
        n[r] = {
          ...t[r],
          ...i
        };
        break;
      case "scope":
      case "features":
        n[r] = Hw(t[r], i);
        break;
      case "atrule":
      case "pseudo":
        n[r] = Hw(t[r], i, ["parse"]);
        break;
      case "node":
        n[r] = Hw(t[r], i, ["name", "structure", "parse", "generate", "walkContext"]);
        break;
    }
  return n;
}
function KH(t) {
  const e = fke(t), n = Dke(t), r = Cke(t), { fromPlainObject: i, toPlainObject: s } = kke(n), a = {
    lexer: null,
    createLexer: (o) => new zR(o, a, a.lexer.structure),
    tokenize: DA,
    parse: e,
    generate: r,
    walk: n,
    find: n.find,
    findLast: n.findLast,
    findAll: n.findAll,
    fromPlainObject: i,
    toPlainObject: s,
    fork(o) {
      const u = sv({}, t);
      return KH(
        typeof o == "function" ? o(u) : sv(u, o)
      );
    }
  };
  return a.lexer = new zR({
    generic: t.generic,
    cssWideKeywords: t.cssWideKeywords,
    units: t.units,
    types: t.types,
    atrules: t.atrules,
    properties: t.properties,
    node: t.node
  }, a), a;
}
const d3e = (t) => KH(sv({}, t)), f3e = {
  generic: !0,
  cssWideKeywords: [
    "initial",
    "inherit",
    "unset",
    "revert",
    "revert-layer"
  ],
  units: {
    angle: [
      "deg",
      "grad",
      "rad",
      "turn"
    ],
    decibel: [
      "db"
    ],
    flex: [
      "fr"
    ],
    frequency: [
      "hz",
      "khz"
    ],
    length: [
      "cm",
      "mm",
      "q",
      "in",
      "pt",
      "pc",
      "px",
      "em",
      "rem",
      "ex",
      "rex",
      "cap",
      "rcap",
      "ch",
      "rch",
      "ic",
      "ric",
      "lh",
      "rlh",
      "vw",
      "svw",
      "lvw",
      "dvw",
      "vh",
      "svh",
      "lvh",
      "dvh",
      "vi",
      "svi",
      "lvi",
      "dvi",
      "vb",
      "svb",
      "lvb",
      "dvb",
      "vmin",
      "svmin",
      "lvmin",
      "dvmin",
      "vmax",
      "svmax",
      "lvmax",
      "dvmax",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ],
    resolution: [
      "dpi",
      "dpcm",
      "dppx",
      "x"
    ],
    semitones: [
      "st"
    ],
    time: [
      "s",
      "ms"
    ]
  },
  types: {
    "abs()": "abs( <calc-sum> )",
    "absolute-size": "xx-small|x-small|small|medium|large|x-large|xx-large|xxx-large",
    "acos()": "acos( <calc-sum> )",
    "alpha-value": "<number>|<percentage>",
    "an+b": "odd|even|<integer>|<n-dimension>|'+'? † n|-n|<ndashdigit-dimension>|'+'? † <ndashdigit-ident>|<dashndashdigit-ident>|<n-dimension> <signed-integer>|'+'? † n <signed-integer>|-n <signed-integer>|<ndash-dimension> <signless-integer>|'+'? † n- <signless-integer>|-n- <signless-integer>|<n-dimension> ['+'|'-'] <signless-integer>|'+'? † n ['+'|'-'] <signless-integer>|-n ['+'|'-'] <signless-integer>",
    "anchor()": "anchor( <anchor-name>?&&<anchor-side> , <length-percentage>? )",
    "anchor-name": "<dashed-ident>",
    "anchor-side": "inside|outside|top|left|right|bottom|start|end|self-start|self-end|<percentage>|center",
    "anchor-size": "width|height|block|inline|self-block|self-inline",
    "anchor-size()": "anchor-size( [<anchor-name>||<anchor-size>]? , <length-percentage>? )",
    "angle-percentage": "<angle>|<percentage>",
    "angular-color-hint": "<angle-percentage>|<zero>",
    "angular-color-stop": "<color> <color-stop-angle>?",
    "angular-color-stop-list": "<angular-color-stop> , [<angular-color-hint>? , <angular-color-stop>]#?",
    "animateable-feature": "scroll-position|contents|<custom-ident>",
    "animation-action": "none|play|play-once|play-forwards|play-backwards|pause|reset|replay",
    "asin()": "asin( <calc-sum> )",
    "atan()": "atan( <calc-sum> )",
    "atan2()": "atan2( <calc-sum> , <calc-sum> )",
    attachment: "scroll|fixed|local",
    "attr()": "attr( <attr-name> <attr-type>? , <declaration-value>? )",
    "attr-matcher": "['~'|'|'|'^'|'$'|'*']? '='",
    "attr-modifier": "i|s",
    "attr-type": "type( <syntax> )|raw-string|number|<attr-unit>",
    "attribute-selector": "'[' <wq-name> ']'|'[' <wq-name> <attr-matcher> [<string-token>|<ident-token>] <attr-modifier>? ']'",
    "auto-repeat": "repeat( [auto-fill|auto-fit] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "auto-track-list": "[<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>? <auto-repeat> [<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>?",
    axis: "block|inline|x|y",
    "baseline-position": "[first|last]? baseline",
    "basic-shape": "<inset()>|<xywh()>|<rect()>|<circle()>|<ellipse()>|<polygon()>|<path()>",
    "basic-shape-rect": "<inset()>|<rect()>|<xywh()>",
    "bg-clip": "<visual-box>|border-area|text",
    "bg-image": "<image>|none",
    "bg-layer": "<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<visual-box>||<visual-box>",
    "bg-position": "[[left|center|right|top|bottom|<length-percentage>]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]|[center|[left|right] <length-percentage>?]&&[center|[top|bottom] <length-percentage>?]]",
    "bg-size": "[<length-percentage [0,∞]>|auto]{1,2}|cover|contain",
    "blend-mode": "normal|multiply|screen|overlay|darken|lighten|color-dodge|color-burn|hard-light|soft-light|difference|exclusion|hue|saturation|color|luminosity",
    "blur()": "blur( <length>? )",
    "brightness()": "brightness( [<number>|<percentage>]? )",
    "calc()": "calc( <calc-sum> )",
    "calc-constant": "e|pi|infinity|-infinity|NaN",
    "calc-product": "<calc-value> ['*' <calc-value>|'/' <number>]*",
    "calc-size()": "calc-size( <calc-size-basis> , <calc-sum> )",
    "calc-size-basis": "<intrinsic-size-keyword>|<calc-size()>|any|<calc-sum>",
    "calc-sum": "<calc-product> [['+'|'-'] <calc-product>]*",
    "calc-value": "<number>|<dimension>|<percentage>|<calc-constant>|( <calc-sum> )",
    "cf-final-image": "<image>|<color>",
    "cf-mixing-image": "<percentage>?&&<image>",
    "circle()": "circle( <radial-size>? [at <position>]? )",
    "clamp()": "clamp( <calc-sum>#{3} )",
    "class-selector": "'.' <ident-token>",
    "clip-source": "<url>",
    color: "<color-base>|currentColor|<system-color>|<device-cmyk()>|<light-dark()>|<-non-standard-color>",
    "color()": "color( <colorspace-params> [/ [<alpha-value>|none]]? )",
    "color-base": "<hex-color>|<color-function>|<named-color>|<color-mix()>|transparent",
    "color-function": "<rgb()>|<rgba()>|<hsl()>|<hsla()>|<hwb()>|<lab()>|<lch()>|<oklab()>|<oklch()>|<color()>",
    "color-interpolation-method": "in [<rectangular-color-space>|<polar-color-space> <hue-interpolation-method>?|<custom-color-space>]",
    "color-mix()": "color-mix( <color-interpolation-method> , [<color>&&<percentage [0,100]>?]#{2} )",
    "color-stop": "<color-stop-length>|<color-stop-angle>",
    "color-stop-angle": "[<angle-percentage>|<zero>]{1,2}",
    "color-stop-length": "<length-percentage>{1,2}",
    "color-stop-list": "<linear-color-stop> , [<linear-color-hint>? , <linear-color-stop>]#?",
    "colorspace-params": "[<predefined-rgb-params>|<xyz-params>]",
    combinator: "'>'|'+'|'~'|['|' '|']",
    "common-lig-values": "[common-ligatures|no-common-ligatures]",
    "compat-auto": "searchfield|textarea|checkbox|radio|menulist|listbox|meter|progress-bar|button",
    "compat-special": "textfield|menulist-button",
    "complex-selector": "<complex-selector-unit> [<combinator>? <complex-selector-unit>]*",
    "complex-selector-list": "<complex-selector>#",
    "composite-style": "clear|copy|source-over|source-in|source-out|source-atop|destination-over|destination-in|destination-out|destination-atop|xor",
    "compositing-operator": "add|subtract|intersect|exclude",
    "compound-selector": "[<type-selector>? <subclass-selector>*]!",
    "compound-selector-list": "<compound-selector>#",
    "conic-gradient()": "conic-gradient( [<conic-gradient-syntax>] )",
    "conic-gradient-syntax": "[[[from [<angle>|<zero>]]? [at <position>]?]||<color-interpolation-method>]? , <angular-color-stop-list>",
    "container-condition": "not <query-in-parens>|<query-in-parens> [[and <query-in-parens>]*|[or <query-in-parens>]*]",
    "container-name": "<custom-ident>",
    "container-query": "not <query-in-parens>|<query-in-parens> [[and <query-in-parens>]*|[or <query-in-parens>]*]",
    "content-distribution": "space-between|space-around|space-evenly|stretch",
    "content-list": "[<string>|contents|<image>|<counter>|<quote>|<target>|<leader()>|<attr()>]+",
    "content-position": "center|start|end|flex-start|flex-end",
    "content-replacement": "<image>",
    "contextual-alt-values": "[contextual|no-contextual]",
    "contrast()": "contrast( [<number>|<percentage>]? )",
    "coord-box": "content-box|padding-box|border-box|fill-box|stroke-box|view-box",
    "corner-shape-value": "round|scoop|bevel|notch|square|squircle|<superellipse()>",
    "cos()": "cos( <calc-sum> )",
    counter: "<counter()>|<counters()>",
    "counter()": "counter( <counter-name> , <counter-style>? )",
    "counter-name": "<custom-ident>",
    "counter-style": "<counter-style-name>|symbols( )",
    "counter-style-name": "<custom-ident>",
    "counters()": "counters( <counter-name> , <string> , <counter-style>? )",
    "cross-fade()": "cross-fade( <cf-mixing-image> , <cf-final-image>? )",
    "cubic-bezier()": "cubic-bezier( [<number [0,1]> , <number>]#{2} )",
    "cubic-bezier-easing-function": "ease|ease-in|ease-out|ease-in-out|cubic-bezier( <number [0,1]> , <number> , <number [0,1]> , <number> )",
    "cursor-predefined": "auto|default|none|context-menu|help|pointer|progress|wait|cell|crosshair|text|vertical-text|alias|copy|move|no-drop|not-allowed|e-resize|n-resize|ne-resize|nw-resize|s-resize|se-resize|sw-resize|w-resize|ew-resize|ns-resize|nesw-resize|nwse-resize|col-resize|row-resize|all-scroll|zoom-in|zoom-out|grab|grabbing",
    "custom-color-space": "<dashed-ident>",
    "custom-params": "<dashed-ident> [<number>|<percentage>|none]+",
    dasharray: "[[<length-percentage>|<number>]+]#",
    "dashndashdigit-ident": "<ident-token>",
    "deprecated-system-color": "ActiveBorder|ActiveCaption|AppWorkspace|Background|ButtonHighlight|ButtonShadow|CaptionText|InactiveBorder|InactiveCaption|InactiveCaptionText|InfoBackground|InfoText|Menu|MenuText|Scrollbar|ThreeDDarkShadow|ThreeDFace|ThreeDHighlight|ThreeDLightShadow|ThreeDShadow|Window|WindowFrame|WindowText",
    "discretionary-lig-values": "[discretionary-ligatures|no-discretionary-ligatures]",
    "display-box": "contents|none",
    "display-inside": "flow|flow-root|table|flex|grid|ruby",
    "display-internal": "table-row-group|table-header-group|table-footer-group|table-row|table-cell|table-column-group|table-column|table-caption|ruby-base|ruby-text|ruby-base-container|ruby-text-container",
    "display-legacy": "inline-block|inline-list-item|inline-table|inline-flex|inline-grid",
    "display-listitem": "<display-outside>?&&[flow|flow-root]?&&list-item",
    "display-outside": "block|inline|run-in",
    "drop-shadow()": "drop-shadow( [<color>?&&<length>{2,3}] )",
    "dynamic-range-limit-mix()": "dynamic-range-limit-mix( [<'dynamic-range-limit'>&&<percentage [0,100]>]#{2,} )",
    "easing-function": "<linear-easing-function>|<cubic-bezier-easing-function>|<step-easing-function>",
    "east-asian-variant-values": "[jis78|jis83|jis90|jis04|simplified|traditional]",
    "east-asian-width-values": "[full-width|proportional-width]",
    "element()": "element( <custom-ident> , [first|start|last|first-except]? )|element( <id-selector> )",
    "ellipse()": "ellipse( <radial-size>? [at <position>]? )",
    "env()": "env( <custom-ident> , <declaration-value>? )",
    "exp()": "exp( <calc-sum> )",
    "explicit-track-list": "[<line-names>? <track-size>]+ <line-names>?",
    "family-name": "<string>|<custom-ident>+",
    "feature-tag-value": "<string> [<integer>|on|off]?",
    "feature-type": "@stylistic|@historical-forms|@styleset|@character-variant|@swash|@ornaments|@annotation",
    "feature-value-block": "<feature-type> '{' <feature-value-declaration-list> '}'",
    "feature-value-block-list": "<feature-value-block>+",
    "feature-value-declaration": "<custom-ident> : <integer>+ ;",
    "feature-value-declaration-list": "<feature-value-declaration>",
    "feature-value-name": "<custom-ident>",
    "filter-function": "<blur()>|<brightness()>|<contrast()>|<drop-shadow()>|<grayscale()>|<hue-rotate()>|<invert()>|<opacity()>|<saturate()>|<sepia()>",
    "filter-value-list": "[<filter-function>|<url>]+",
    "final-bg-layer": "<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<visual-box>||<visual-box>||<'background-color'>",
    "fit-content()": "fit-content( <length-percentage [0,∞]> )",
    "fixed-breadth": "<length-percentage>",
    "fixed-repeat": "repeat( [<integer [1,∞]>] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "fixed-size": "<fixed-breadth>|minmax( <fixed-breadth> , <track-breadth> )|minmax( <inflexible-breadth> , <fixed-breadth> )",
    "font-stretch-absolute": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded|<percentage>",
    "font-variant-css2": "normal|small-caps",
    "font-weight-absolute": "normal|bold|<number [1,1000]>",
    "font-width-css3": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded",
    "form-control-identifier": "select",
    "frequency-percentage": "<frequency>|<percentage>",
    "generic-complete": "serif|sans-serif|system-ui|cursive|fantasy|math|monospace",
    "general-enclosed": "[<function-token> <any-value>? )]|[( <any-value>? )]",
    "generic-family": "<generic-script-specific>|<generic-complete>|<generic-incomplete>|<-non-standard-generic-family>",
    "generic-incomplete": "ui-serif|ui-sans-serif|ui-monospace|ui-rounded",
    "geometry-box": "<shape-box>|fill-box|stroke-box|view-box",
    gradient: "<linear-gradient()>|<repeating-linear-gradient()>|<radial-gradient()>|<repeating-radial-gradient()>|<conic-gradient()>|<repeating-conic-gradient()>|<-legacy-gradient>",
    "grayscale()": "grayscale( [<number>|<percentage>]? )",
    "grid-line": "auto|<custom-ident>|[<integer>&&<custom-ident>?]|[span&&[<integer>||<custom-ident>]]",
    "historical-lig-values": "[historical-ligatures|no-historical-ligatures]",
    "hsl()": "hsl( <hue> , <percentage> , <percentage> , <alpha-value>? )|hsl( [<hue>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
    "hsla()": "hsla( <hue> , <percentage> , <percentage> , <alpha-value>? )|hsla( [<hue>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
    hue: "<number>|<angle>",
    "hue-interpolation-method": "[shorter|longer|increasing|decreasing] hue",
    "hue-rotate()": "hue-rotate( [<angle>|<zero>]? )",
    "hwb()": "hwb( [<hue>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
    "hypot()": "hypot( <calc-sum># )",
    image: "<url>|<image()>|<image-set()>|<element()>|<paint()>|<cross-fade()>|<gradient>",
    "image()": "image( <image-tags>? [<image-src>? , <color>?]! )",
    "image-set()": "image-set( <image-set-option># )",
    "image-set-option": "[<image>|<string>] [<resolution>||type( <string> )]",
    "image-src": "<url>|<string>",
    "image-tags": "ltr|rtl",
    "inflexible-breadth": "<length-percentage>|min-content|max-content|auto",
    "inset()": "inset( <length-percentage>{1,4} [round <'border-radius'>]? )",
    "invert()": "invert( [<number>|<percentage>]? )",
    "keyframe-block": "<keyframe-selector># { <declaration-list> }",
    "keyframe-selector": "from|to|<percentage [0,100]>|<timeline-range-name> <percentage>",
    "keyframes-name": "<custom-ident>|<string>",
    "lab()": "lab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
    "layer()": "layer( <layer-name> )",
    "layer-name": "<ident> ['.' <ident>]*",
    "lch()": "lch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
    "leader()": "leader( <leader-type> )",
    "leader-type": "dotted|solid|space|<string>",
    "length-percentage": "<length>|<percentage>",
    "light-dark()": "light-dark( <color> , <color> )",
    "line-name-list": "[<line-names>|<name-repeat>]+",
    "line-names": "'[' <custom-ident>* ']'",
    "line-style": "none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset",
    "line-width": "<length>|thin|medium|thick",
    "linear()": "linear( [<number>&&<percentage>{0,2}]# )",
    "linear-color-hint": "<length-percentage>",
    "linear-color-stop": "<color> <color-stop-length>?",
    "linear-easing-function": "linear|<linear()>",
    "linear-gradient()": "linear-gradient( [<linear-gradient-syntax>] )",
    "linear-gradient-syntax": "[[<angle>|<zero>|to <side-or-corner>]||<color-interpolation-method>]? , <color-stop-list>",
    "log()": "log( <calc-sum> , <calc-sum>? )",
    "mask-layer": "<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||<geometry-box>||[<geometry-box>|no-clip]||<compositing-operator>||<masking-mode>",
    "mask-position": "[<length-percentage>|left|center|right] [<length-percentage>|top|center|bottom]?",
    "mask-reference": "none|<image>|<mask-source>",
    "mask-source": "<url>",
    "masking-mode": "alpha|luminance|match-source",
    "matrix()": "matrix( <number>#{6} )",
    "matrix3d()": "matrix3d( <number>#{16} )",
    "max()": "max( <calc-sum># )",
    "media-and": "<media-in-parens> [and <media-in-parens>]+",
    "media-condition": "<media-not>|<media-and>|<media-or>|<media-in-parens>",
    "media-condition-without-or": "<media-not>|<media-and>|<media-in-parens>",
    "media-feature": "( [<mf-plain>|<mf-boolean>|<mf-range>] )",
    "media-in-parens": "( <media-condition> )|<media-feature>|<general-enclosed>",
    "media-not": "not <media-in-parens>",
    "media-or": "<media-in-parens> [or <media-in-parens>]+",
    "media-query": "<media-condition>|[not|only]? <media-type> [and <media-condition-without-or>]?",
    "media-query-list": "<media-query>#",
    "media-type": "<ident>",
    "mf-boolean": "<mf-name>",
    "mf-name": "<ident>",
    "mf-plain": "<mf-name> : <mf-value>",
    "mf-range": "<mf-name> ['<'|'>']? '='? <mf-value>|<mf-value> ['<'|'>']? '='? <mf-name>|<mf-value> '<' '='? <mf-name> '<' '='? <mf-value>|<mf-value> '>' '='? <mf-name> '>' '='? <mf-value>",
    "mf-value": "<number>|<dimension>|<ident>|<ratio>",
    "min()": "min( <calc-sum># )",
    "minmax()": "minmax( [<length-percentage>|min-content|max-content|auto] , [<length-percentage>|<flex>|min-content|max-content|auto] )",
    "mod()": "mod( <calc-sum> , <calc-sum> )",
    "n-dimension": "<dimension-token>",
    "name-repeat": "repeat( [<integer [1,∞]>|auto-fill] , <line-names>+ )",
    "named-color": "aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen",
    "namespace-prefix": "<ident>",
    "ndash-dimension": "<dimension-token>",
    "ndashdigit-dimension": "<dimension-token>",
    "ndashdigit-ident": "<ident-token>",
    "ns-prefix": "[<ident-token>|'*']? '|'",
    "number-percentage": "<number>|<percentage>",
    "numeric-figure-values": "[lining-nums|oldstyle-nums]",
    "numeric-fraction-values": "[diagonal-fractions|stacked-fractions]",
    "numeric-spacing-values": "[proportional-nums|tabular-nums]",
    "offset-path": "<ray()>|<url>|<basic-shape>",
    "oklab()": "oklab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
    "oklch()": "oklch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
    "opacity()": "opacity( [<number>|<percentage>]? )",
    "opacity-value": "<number>|<percentage>",
    "outline-line-style": "none|dotted|dashed|solid|double|groove|ridge|inset|outset",
    "outline-radius": "<length>|<percentage>",
    "overflow-position": "unsafe|safe",
    "page-body": "<declaration>? [; <page-body>]?|<page-margin-box> <page-body>",
    "page-margin-box": "<page-margin-box-type> '{' <declaration-list> '}'",
    "page-margin-box-type": "@top-left-corner|@top-left|@top-center|@top-right|@top-right-corner|@bottom-left-corner|@bottom-left|@bottom-center|@bottom-right|@bottom-right-corner|@left-top|@left-middle|@left-bottom|@right-top|@right-middle|@right-bottom",
    "page-selector": "<pseudo-page>+|<ident> <pseudo-page>*",
    "page-selector-list": "[<page-selector>#]?",
    "page-size": "A5|A4|A3|B5|B4|JIS-B5|JIS-B4|letter|legal|ledger",
    paint: "none|<color>|<url> [none|<color>]?|context-fill|context-stroke",
    "paint()": "paint( <ident> , <declaration-value>? )",
    "paint-box": "<visual-box>|fill-box|stroke-box",
    "palette-identifier": "<dashed-ident>",
    "palette-mix()": "palette-mix( <color-interpolation-method> , [[normal|light|dark|<palette-identifier>|<palette-mix()>]&&<percentage [0,100]>?]#{2} )",
    "path()": "path( <'fill-rule'>? , <string> )",
    "perspective()": "perspective( [<length [0,∞]>|none] )",
    "polar-color-space": "hsl|hwb|lch|oklch",
    "polygon()": "polygon( <'fill-rule'>? , [<length-percentage> <length-percentage>]# )",
    position: "[[left|center|right]||[top|center|bottom]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]?|[[left|right] <length-percentage>]&&[[top|bottom] <length-percentage>]]",
    "position-area": "[[left|center|right|span-left|span-right|x-start|x-end|span-x-start|span-x-end|x-self-start|x-self-end|span-x-self-start|span-x-self-end|span-all]||[top|center|bottom|span-top|span-bottom|y-start|y-end|span-y-start|span-y-end|y-self-start|y-self-end|span-y-self-start|span-y-self-end|span-all]|[block-start|center|block-end|span-block-start|span-block-end|span-all]||[inline-start|center|inline-end|span-inline-start|span-inline-end|span-all]|[self-block-start|center|self-block-end|span-self-block-start|span-self-block-end|span-all]||[self-inline-start|center|self-inline-end|span-self-inline-start|span-self-inline-end|span-all]|[start|center|end|span-start|span-end|span-all]{1,2}|[self-start|center|self-end|span-self-start|span-self-end|span-all]{1,2}]",
    "pow()": "pow( <calc-sum> , <calc-sum> )",
    "predefined-rgb": "srgb|srgb-linear|display-p3|display-p3-linear|a98-rgb|prophoto-rgb|rec2020",
    "predefined-rgb-params": "<predefined-rgb> [<number>|<percentage>|none]{3}",
    "pseudo-class-selector": "':' <ident-token>|':' <function-token> <any-value> ')'",
    "pseudo-element-selector": "':' <pseudo-class-selector>|<legacy-pseudo-element-selector>",
    "pseudo-page": ": [left|right|first|blank]",
    "query-in-parens": "( <container-condition> )|( <size-feature> )|style( <style-query> )|<general-enclosed>",
    quote: "open-quote|close-quote|no-open-quote|no-close-quote",
    "radial-extent": "closest-corner|closest-side|farthest-corner|farthest-side",
    "radial-gradient()": "radial-gradient( [<radial-gradient-syntax>] )",
    "radial-gradient-syntax": "[[[<radial-shape>||<radial-size>]? [at <position>]?]||<color-interpolation-method>]? , <color-stop-list>",
    "radial-shape": "circle|ellipse",
    "radial-size": "<radial-extent>|<length [0,∞]>|<length-percentage [0,∞]>{2}",
    ratio: "<number [0,∞]> [/ <number [0,∞]>]?",
    "ray()": "ray( <angle>&&<ray-size>?&&contain?&&[at <position>]? )",
    "ray-size": "closest-side|closest-corner|farthest-side|farthest-corner|sides",
    "rect()": "rect( [<length-percentage>|auto]{4} [round <'border-radius'>]? )",
    "rectangular-color-space": "srgb|srgb-linear|display-p3|display-p3-linear|a98-rgb|prophoto-rgb|rec2020|lab|oklab|xyz|xyz-d50|xyz-d65",
    "relative-selector": "<combinator>? <complex-selector>",
    "relative-selector-list": "<relative-selector>#",
    "relative-size": "larger|smaller",
    "rem()": "rem( <calc-sum> , <calc-sum> )",
    "repeat-style": "repeat-x|repeat-y|[repeat|space|round|no-repeat]{1,2}",
    "repeating-conic-gradient()": "repeating-conic-gradient( [<conic-gradient-syntax>] )",
    "repeating-linear-gradient()": "repeating-linear-gradient( [<linear-gradient-syntax>] )",
    "repeating-radial-gradient()": "repeating-radial-gradient( [<radial-gradient-syntax>] )",
    "reversed-counter-name": "reversed( <counter-name> )",
    "rgb()": "rgb( <percentage>#{3} , <alpha-value>? )|rgb( <number>#{3} , <alpha-value>? )|rgb( [<number>|<percentage>|none]{3} [/ [<alpha-value>|none]]? )",
    "rgba()": "rgba( <percentage>#{3} , <alpha-value>? )|rgba( <number>#{3} , <alpha-value>? )|rgba( [<number>|<percentage>|none]{3} [/ [<alpha-value>|none]]? )",
    "rotate()": "rotate( [<angle>|<zero>] )",
    "rotate3d()": "rotate3d( <number> , <number> , <number> , [<angle>|<zero>] )",
    "rotateX()": "rotateX( [<angle>|<zero>] )",
    "rotateY()": "rotateY( [<angle>|<zero>] )",
    "rotateZ()": "rotateZ( [<angle>|<zero>] )",
    "round()": "round( <rounding-strategy>? , <calc-sum> , <calc-sum> )",
    "rounding-strategy": "nearest|up|down|to-zero",
    "saturate()": "saturate( [<number>|<percentage>]? )",
    "scale()": "scale( [<number>|<percentage>]#{1,2} )",
    "scale3d()": "scale3d( [<number>|<percentage>]#{3} )",
    "scaleX()": "scaleX( [<number>|<percentage>] )",
    "scaleY()": "scaleY( [<number>|<percentage>] )",
    "scaleZ()": "scaleZ( [<number>|<percentage>] )",
    "scope-end": "<forgiving-selector-list>",
    "scope-start": "<forgiving-selector-list>",
    "scroll()": "scroll( [<scroller>||<axis>]? )",
    scroller: "root|nearest|self",
    "scroll-state-feature": "<media-query-list>",
    "scroll-state-in-parens": "( <scroll-state-query> )|( <scroll-state-feature> )|<general-enclosed>",
    "scroll-state-query": "not <scroll-state-in-parens>|<scroll-state-in-parens> [[and <scroll-state-in-parens>]*|[or <scroll-state-in-parens>]*]|<scroll-state-feature>",
    "selector-list": "<complex-selector-list>",
    "self-position": "center|start|end|self-start|self-end|flex-start|flex-end",
    "sepia()": "sepia( [<number>|<percentage>]? )",
    shadow: "inset?&&<length>{2,4}&&<color>?",
    "shadow-t": "[<length>{2,3}&&<color>?]",
    shape: "rect( <top> , <right> , <bottom> , <left> )|rect( <top> <right> <bottom> <left> )",
    "shape-box": "<visual-box>|margin-box",
    "side-or-corner": "[left|right]||[top|bottom]",
    "sign()": "sign( <calc-sum> )",
    "signed-integer": "<number-token>",
    "signless-integer": "<number-token>",
    "sin()": "sin( <calc-sum> )",
    "single-animation": "<'animation-duration'>||<easing-function>||<'animation-delay'>||<single-animation-iteration-count>||<single-animation-direction>||<single-animation-fill-mode>||<single-animation-play-state>||[none|<keyframes-name>]||<single-animation-timeline>",
    "single-animation-composition": "replace|add|accumulate",
    "single-animation-direction": "normal|reverse|alternate|alternate-reverse",
    "single-animation-fill-mode": "none|forwards|backwards|both",
    "single-animation-iteration-count": "infinite|<number>",
    "single-animation-play-state": "running|paused",
    "single-animation-timeline": "auto|none|<dashed-ident>|<scroll()>|<view()>",
    "single-transition": "[none|<single-transition-property>]||<time>||<easing-function>||<time>||<transition-behavior-value>",
    "single-transition-property": "all|<custom-ident>",
    size: "closest-side|farthest-side|closest-corner|farthest-corner|<length>|<length-percentage>{2}",
    "size-feature": "<mf-plain>|<mf-boolean>|<mf-range>",
    "skew()": "skew( [<angle>|<zero>] , [<angle>|<zero>]? )",
    "skewX()": "skewX( [<angle>|<zero>] )",
    "skewY()": "skewY( [<angle>|<zero>] )",
    "sqrt()": "sqrt( <calc-sum> )",
    "step-position": "jump-start|jump-end|jump-none|jump-both|start|end",
    "step-easing-function": "step-start|step-end|<steps()>",
    "steps()": "steps( <integer> , <step-position>? )",
    "style-feature": "<declaration>",
    "style-in-parens": "( <style-condition> )|( <style-feature> )|<general-enclosed>",
    "style-query": "<style-condition>|<style-feature>",
    "subclass-selector": "<id-selector>|<class-selector>|<attribute-selector>|<pseudo-class-selector>",
    "superellipse()": "superellipse( [<number>|infinity|-infinity] )",
    "supports-condition": "not <supports-in-parens>|<supports-in-parens> [and <supports-in-parens>]*|<supports-in-parens> [or <supports-in-parens>]*",
    "supports-decl": "( <declaration> )",
    "supports-feature": "<supports-decl>|<supports-selector-fn>",
    "supports-in-parens": "( <supports-condition> )|<supports-feature>|<general-enclosed>",
    "supports-selector-fn": "selector( <complex-selector> )",
    symbol: "<string>|<image>|<custom-ident>",
    "symbols()": "symbols( <symbols-type>? [<string>|<image>]+ )",
    "symbols-type": "cyclic|numeric|alphabetic|symbolic|fixed",
    "system-color": "AccentColor|AccentColorText|ActiveText|ButtonBorder|ButtonFace|ButtonText|Canvas|CanvasText|Field|FieldText|GrayText|Highlight|HighlightText|LinkText|Mark|MarkText|SelectedItem|SelectedItemText|VisitedText",
    "system-family-name": "caption|icon|menu|message-box|small-caption|status-bar",
    "tan()": "tan( <calc-sum> )",
    target: "<target-counter()>|<target-counters()>|<target-text()>",
    "target-counter()": "target-counter( [<string>|<url>] , <custom-ident> , <counter-style>? )",
    "target-counters()": "target-counters( [<string>|<url>] , <custom-ident> , <string> , <counter-style>? )",
    "target-text()": "target-text( [<string>|<url>] , [content|before|after|first-letter]? )",
    "text-edge": "[text|cap|ex|ideographic|ideographic-ink] [text|alphabetic|ideographic|ideographic-ink]?",
    "time-percentage": "<time>|<percentage>",
    "timeline-range-name": "cover|contain|entry|exit|entry-crossing|exit-crossing",
    "track-breadth": "<length-percentage>|<flex>|min-content|max-content|auto",
    "track-list": "[<line-names>? [<track-size>|<track-repeat>]]+ <line-names>?",
    "track-repeat": "repeat( [<integer [1,∞]>] , [<line-names>? <track-size>]+ <line-names>? )",
    "track-size": "<track-breadth>|minmax( <inflexible-breadth> , <track-breadth> )|fit-content( <length-percentage> )",
    "transform-function": "<matrix()>|<translate()>|<translateX()>|<translateY()>|<scale()>|<scaleX()>|<scaleY()>|<rotate()>|<skew()>|<skewX()>|<skewY()>|<matrix3d()>|<translate3d()>|<translateZ()>|<scale3d()>|<scaleZ()>|<rotate3d()>|<rotateX()>|<rotateY()>|<rotateZ()>|<perspective()>",
    "transform-list": "<transform-function>+",
    "transition-behavior-value": "normal|allow-discrete",
    "translate()": "translate( <length-percentage> , <length-percentage>? )",
    "translate3d()": "translate3d( <length-percentage> , <length-percentage> , <length> )",
    "translateX()": "translateX( <length-percentage> )",
    "translateY()": "translateY( <length-percentage> )",
    "translateZ()": "translateZ( <length> )",
    "try-size": "most-width|most-height|most-block-size|most-inline-size",
    "try-tactic": "flip-block||flip-inline||flip-start",
    "type-or-unit": "string|color|url|integer|number|length|angle|time|frequency|cap|ch|em|ex|ic|lh|rlh|rem|vb|vi|vw|vh|vmin|vmax|mm|Q|cm|in|pt|pc|px|deg|grad|rad|turn|ms|s|Hz|kHz|%",
    "type-selector": "<wq-name>|<ns-prefix>? '*'",
    "var()": "var( <custom-property-name> , <declaration-value>? )",
    "view()": "view( [<axis>||<'view-timeline-inset'>]? )",
    "viewport-length": "auto|<length-percentage>",
    "visual-box": "content-box|padding-box|border-box",
    "wq-name": "<ns-prefix>? <ident-token>",
    "xywh()": "xywh( <length-percentage>{2} <length-percentage [0,∞]>{2} [round <'border-radius'>]? )",
    xyz: "xyz|xyz-d50|xyz-d65",
    "xyz-params": "<xyz-space> [<number>|<percentage>|none]{3}",
    "-legacy-gradient": "<-webkit-gradient()>|<-legacy-linear-gradient>|<-legacy-repeating-linear-gradient>|<-legacy-radial-gradient>|<-legacy-repeating-radial-gradient>",
    "-legacy-linear-gradient": "-moz-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-repeating-linear-gradient": "-moz-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-linear-gradient-arguments": "[<angle>|<side-or-corner>]? , <color-stop-list>",
    "-legacy-radial-gradient": "-moz-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-repeating-radial-gradient": "-moz-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-radial-gradient-arguments": "[<position> ,]? [[[<-legacy-radial-gradient-shape>||<-legacy-radial-gradient-size>]|[<length>|<percentage>]{2}] ,]? <color-stop-list>",
    "-legacy-radial-gradient-size": "closest-side|closest-corner|farthest-side|farthest-corner|contain|cover",
    "-legacy-radial-gradient-shape": "circle|ellipse",
    "-non-standard-font": "-apple-system-body|-apple-system-headline|-apple-system-subheadline|-apple-system-caption1|-apple-system-caption2|-apple-system-footnote|-apple-system-short-body|-apple-system-short-headline|-apple-system-short-subheadline|-apple-system-short-caption1|-apple-system-short-footnote|-apple-system-tall-body",
    "-non-standard-color": "-moz-ButtonDefault|-moz-ButtonHoverFace|-moz-ButtonHoverText|-moz-CellHighlight|-moz-CellHighlightText|-moz-Combobox|-moz-ComboboxText|-moz-Dialog|-moz-DialogText|-moz-dragtargetzone|-moz-EvenTreeRow|-moz-Field|-moz-FieldText|-moz-html-CellHighlight|-moz-html-CellHighlightText|-moz-mac-accentdarkestshadow|-moz-mac-accentdarkshadow|-moz-mac-accentface|-moz-mac-accentlightesthighlight|-moz-mac-accentlightshadow|-moz-mac-accentregularhighlight|-moz-mac-accentregularshadow|-moz-mac-chrome-active|-moz-mac-chrome-inactive|-moz-mac-focusring|-moz-mac-menuselect|-moz-mac-menushadow|-moz-mac-menutextselect|-moz-MenuHover|-moz-MenuHoverText|-moz-MenuBarText|-moz-MenuBarHoverText|-moz-nativehyperlinktext|-moz-OddTreeRow|-moz-win-communicationstext|-moz-win-mediatext|-moz-activehyperlinktext|-moz-default-background-color|-moz-default-color|-moz-hyperlinktext|-moz-visitedhyperlinktext|-webkit-activelink|-webkit-focus-ring-color|-webkit-link|-webkit-text",
    "-non-standard-image-rendering": "optimize-contrast|-moz-crisp-edges|-o-crisp-edges|-webkit-optimize-contrast",
    "-non-standard-overflow": "overlay|-moz-scrollbars-none|-moz-scrollbars-horizontal|-moz-scrollbars-vertical|-moz-hidden-unscrollable",
    "-non-standard-size": "intrinsic|min-intrinsic|-webkit-fill-available|-webkit-fit-content|-webkit-min-content|-webkit-max-content|-moz-available|-moz-fit-content|-moz-min-content|-moz-max-content",
    "-webkit-gradient()": "-webkit-gradient( <-webkit-gradient-type> , <-webkit-gradient-point> [, <-webkit-gradient-point>|, <-webkit-gradient-radius> , <-webkit-gradient-point>] [, <-webkit-gradient-radius>]? [, <-webkit-gradient-color-stop>]* )",
    "-webkit-gradient-color-stop": "from( <color> )|color-stop( [<number-zero-one>|<percentage>] , <color> )|to( <color> )",
    "-webkit-gradient-point": "[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]",
    "-webkit-gradient-radius": "<length>|<percentage>",
    "-webkit-gradient-type": "linear|radial",
    "-webkit-mask-box-repeat": "repeat|stretch|round",
    "-ms-filter-function-list": "<-ms-filter-function>+",
    "-ms-filter-function": "<-ms-filter-function-progid>|<-ms-filter-function-legacy>",
    "-ms-filter-function-progid": "'progid:' [<ident-token> '.']* [<ident-token>|<function-token> <any-value>? )]",
    "-ms-filter-function-legacy": "<ident-token>|<function-token> <any-value>? )",
    age: "child|young|old",
    "attr-name": "<wq-name>",
    "attr-fallback": "<any-value>",
    autospace: "no-autospace|[ideograph-alpha||ideograph-numeric||punctuation]||[insert|replace]",
    bottom: "<length>|auto",
    "generic-voice": "[<age>? <gender> <integer>?]",
    gender: "male|female|neutral",
    "generic-script-specific": "generic( kai )|generic( fangsong )|generic( nastaliq )",
    "-non-standard-generic-family": "-apple-system|BlinkMacSystemFont",
    "intrinsic-size-keyword": "min-content|max-content|fit-content",
    left: "<length>|auto",
    "device-cmyk()": "<legacy-device-cmyk-syntax>|<modern-device-cmyk-syntax>",
    "legacy-device-cmyk-syntax": "device-cmyk( <number>#{4} )",
    "modern-device-cmyk-syntax": "device-cmyk( <cmyk-component>{4} [/ [<alpha-value>|none]]? )",
    "cmyk-component": "<number>|<percentage>|none",
    "color-space": "<rectangular-color-space>|<polar-color-space>|<custom-color-space>",
    right: "<length>|auto",
    "forgiving-selector-list": "<complex-real-selector-list>",
    "forgiving-relative-selector-list": "<relative-real-selector-list>",
    "complex-real-selector-list": "<complex-real-selector>#",
    "simple-selector-list": "<simple-selector>#",
    "relative-real-selector-list": "<relative-real-selector>#",
    "complex-selector-unit": "[<compound-selector>? <pseudo-compound-selector>*]!",
    "complex-real-selector": "<compound-selector> [<combinator>? <compound-selector>]*",
    "relative-real-selector": "<combinator>? <complex-real-selector>",
    "pseudo-compound-selector": "<pseudo-element-selector> <pseudo-class-selector>*",
    "simple-selector": "<type-selector>|<subclass-selector>",
    "legacy-pseudo-element-selector": "':' [before|after|first-line|first-letter]",
    "svg-length": "<percentage>|<length>|<number>",
    "svg-writing-mode": "lr-tb|rl-tb|tb-rl|lr|rl|tb",
    top: "<length>|auto",
    x: "<number>",
    y: "<number>",
    declaration: "<ident-token> : <declaration-value>? ['!' important]?",
    "declaration-list": "[<declaration>? ';']* <declaration>?",
    url: "url( <string> <url-modifier>* )|<url-token>",
    "url-modifier": "<ident>|<function-token> <any-value> )",
    "number-zero-one": "<number [0,1]>",
    "number-one-or-greater": "<number [1,∞]>",
    "xyz-space": "xyz|xyz-d50|xyz-d65",
    "style-condition": "not <style-in-parens>|<style-in-parens> [[and <style-in-parens>]*|[or <style-in-parens>]*]",
    "-non-standard-display": "-ms-inline-flexbox|-ms-grid|-ms-inline-grid|-webkit-flex|-webkit-inline-flex|-webkit-box|-webkit-inline-box|-moz-inline-stack|-moz-box|-moz-inline-box",
    "inset-area": "[[left|center|right|span-left|span-right|x-start|x-end|span-x-start|span-x-end|x-self-start|x-self-end|span-x-self-start|span-x-self-end|span-all]||[top|center|bottom|span-top|span-bottom|y-start|y-end|span-y-start|span-y-end|y-self-start|y-self-end|span-y-self-start|span-y-self-end|span-all]|[block-start|center|block-end|span-block-start|span-block-end|span-all]||[inline-start|center|inline-end|span-inline-start|span-inline-end|span-all]|[self-block-start|self-block-end|span-self-block-start|span-self-block-end|span-all]||[self-inline-start|self-inline-end|span-self-inline-start|span-self-inline-end|span-all]|[start|center|end|span-start|span-end|span-all]{1,2}|[self-start|center|self-end|span-self-start|span-self-end|span-all]{1,2}]",
    syntax: "'*'|<syntax-component> [<syntax-combinator> <syntax-component>]*|<syntax-string>",
    "syntax-component": "<syntax-single-component> <syntax-multiplier>?|'<' transform-list '>'",
    "syntax-single-component": "'<' <syntax-type-name> '>'|<ident>",
    "syntax-type-name": "angle|color|custom-ident|image|integer|length|length-percentage|number|percentage|resolution|string|time|url|transform-function",
    "syntax-combinator": "'|'",
    "syntax-multiplier": "'#'|'+'",
    "syntax-string": "<string>"
  },
  properties: {
    "--*": "<declaration-value>",
    "-ms-accelerator": "false|true",
    "-ms-block-progression": "tb|rl|bt|lr",
    "-ms-content-zoom-chaining": "none|chained",
    "-ms-content-zoom-limit": "<'-ms-content-zoom-limit-min'> <'-ms-content-zoom-limit-max'>",
    "-ms-content-zoom-limit-max": "<percentage>",
    "-ms-content-zoom-limit-min": "<percentage>",
    "-ms-content-zoom-snap": "<'-ms-content-zoom-snap-type'>||<'-ms-content-zoom-snap-points'>",
    "-ms-content-zoom-snap-points": "snapInterval( <percentage> , <percentage> )|snapList( <percentage># )",
    "-ms-content-zoom-snap-type": "none|proximity|mandatory",
    "-ms-content-zooming": "none|zoom",
    "-ms-filter": "<string>",
    "-ms-flow-from": "[none|<custom-ident>]#",
    "-ms-flow-into": "[none|<custom-ident>]#",
    "-ms-grid-columns": "none|<track-list>|<auto-track-list>",
    "-ms-grid-rows": "none|<track-list>|<auto-track-list>",
    "-ms-high-contrast-adjust": "auto|none",
    "-ms-hyphenate-limit-chars": "auto|<integer>{1,3}",
    "-ms-hyphenate-limit-lines": "no-limit|<integer>",
    "-ms-hyphenate-limit-zone": "<percentage>|<length>",
    "-ms-ime-align": "auto|after",
    "-ms-overflow-style": "auto|none|scrollbar|-ms-autohiding-scrollbar",
    "-ms-scroll-chaining": "chained|none",
    "-ms-scroll-limit": "<'-ms-scroll-limit-x-min'> <'-ms-scroll-limit-y-min'> <'-ms-scroll-limit-x-max'> <'-ms-scroll-limit-y-max'>",
    "-ms-scroll-limit-x-max": "auto|<length>",
    "-ms-scroll-limit-x-min": "<length>",
    "-ms-scroll-limit-y-max": "auto|<length>",
    "-ms-scroll-limit-y-min": "<length>",
    "-ms-scroll-rails": "none|railed",
    "-ms-scroll-snap-points-x": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-points-y": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-type": "none|proximity|mandatory",
    "-ms-scroll-snap-x": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-x'>",
    "-ms-scroll-snap-y": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-y'>",
    "-ms-scroll-translation": "none|vertical-to-horizontal",
    "-ms-scrollbar-3dlight-color": "<color>",
    "-ms-scrollbar-arrow-color": "<color>",
    "-ms-scrollbar-base-color": "<color>",
    "-ms-scrollbar-darkshadow-color": "<color>",
    "-ms-scrollbar-face-color": "<color>",
    "-ms-scrollbar-highlight-color": "<color>",
    "-ms-scrollbar-shadow-color": "<color>",
    "-ms-scrollbar-track-color": "<color>",
    "-ms-text-autospace": "none|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space",
    "-ms-touch-select": "grippers|none",
    "-ms-user-select": "none|element|text",
    "-ms-wrap-flow": "auto|both|start|end|maximum|clear",
    "-ms-wrap-margin": "<length>",
    "-ms-wrap-through": "wrap|none",
    "-moz-appearance": "none|button|button-arrow-down|button-arrow-next|button-arrow-previous|button-arrow-up|button-bevel|button-focus|caret|checkbox|checkbox-container|checkbox-label|checkmenuitem|dualbutton|groupbox|listbox|listitem|menuarrow|menubar|menucheckbox|menuimage|menuitem|menuitemtext|menulist|menulist-button|menulist-text|menulist-textfield|menupopup|menuradio|menuseparator|meterbar|meterchunk|progressbar|progressbar-vertical|progresschunk|progresschunk-vertical|radio|radio-container|radio-label|radiomenuitem|range|range-thumb|resizer|resizerpanel|scale-horizontal|scalethumbend|scalethumb-horizontal|scalethumbstart|scalethumbtick|scalethumb-vertical|scale-vertical|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|separator|sheet|spinner|spinner-downbutton|spinner-textfield|spinner-upbutton|splitter|statusbar|statusbarpanel|tab|tabpanel|tabpanels|tab-scroll-arrow-back|tab-scroll-arrow-forward|textfield|textfield-multiline|toolbar|toolbarbutton|toolbarbutton-dropdown|toolbargripper|toolbox|tooltip|treeheader|treeheadercell|treeheadersortarrow|treeitem|treeline|treetwisty|treetwistyopen|treeview|-moz-mac-unified-toolbar|-moz-win-borderless-glass|-moz-win-browsertabbar-toolbox|-moz-win-communicationstext|-moz-win-communications-toolbox|-moz-win-exclude-glass|-moz-win-glass|-moz-win-mediatext|-moz-win-media-toolbox|-moz-window-button-box|-moz-window-button-box-maximized|-moz-window-button-close|-moz-window-button-maximize|-moz-window-button-minimize|-moz-window-button-restore|-moz-window-frame-bottom|-moz-window-frame-left|-moz-window-frame-right|-moz-window-titlebar|-moz-window-titlebar-maximized",
    "-moz-binding": "<url>|none",
    "-moz-border-bottom-colors": "<color>+|none",
    "-moz-border-left-colors": "<color>+|none",
    "-moz-border-right-colors": "<color>+|none",
    "-moz-border-top-colors": "<color>+|none",
    "-moz-context-properties": "none|[fill|fill-opacity|stroke|stroke-opacity]#",
    "-moz-float-edge": "border-box|content-box|margin-box|padding-box",
    "-moz-force-broken-image-icon": "0|1",
    "-moz-orient": "inline|block|horizontal|vertical",
    "-moz-outline-radius": "<outline-radius>{1,4} [/ <outline-radius>{1,4}]?",
    "-moz-outline-radius-bottomleft": "<outline-radius>",
    "-moz-outline-radius-bottomright": "<outline-radius>",
    "-moz-outline-radius-topleft": "<outline-radius>",
    "-moz-outline-radius-topright": "<outline-radius>",
    "-moz-stack-sizing": "ignore|stretch-to-fit",
    "-moz-text-blink": "none|blink",
    "-moz-user-focus": "ignore|normal|select-after|select-before|select-menu|select-same|select-all|none",
    "-moz-user-input": "auto|none|enabled|disabled",
    "-moz-user-modify": "read-only|read-write|write-only",
    "-moz-window-dragging": "drag|no-drag",
    "-moz-window-shadow": "default|menu|tooltip|sheet|none",
    "-webkit-appearance": "none|button|button-bevel|caps-lock-indicator|caret|checkbox|default-button|inner-spin-button|listbox|listitem|media-controls-background|media-controls-fullscreen-background|media-current-time-display|media-enter-fullscreen-button|media-exit-fullscreen-button|media-fullscreen-button|media-mute-button|media-overlay-play-button|media-play-button|media-seek-back-button|media-seek-forward-button|media-slider|media-sliderthumb|media-time-remaining-display|media-toggle-closed-captions-button|media-volume-slider|media-volume-slider-container|media-volume-sliderthumb|menulist|menulist-button|menulist-text|menulist-textfield|meter|progress-bar|progress-bar-value|push-button|radio|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbargripper-horizontal|scrollbargripper-vertical|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|searchfield-cancel-button|searchfield-decoration|searchfield-results-button|searchfield-results-decoration|slider-horizontal|slider-vertical|sliderthumb-horizontal|sliderthumb-vertical|square-button|textarea|textfield|-apple-pay-button",
    "-webkit-border-before": "<'border-width'>||<'border-style'>||<color>",
    "-webkit-border-before-color": "<color>",
    "-webkit-border-before-style": "<'border-style'>",
    "-webkit-border-before-width": "<'border-width'>",
    "-webkit-box-reflect": "[above|below|right|left]? <length>? <image>?",
    "-webkit-line-clamp": "none|<integer>",
    "-webkit-mask": "[<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||[<visual-box>|border|padding|content|text]||[<visual-box>|border|padding|content]]#",
    "-webkit-mask-attachment": "<attachment>#",
    "-webkit-mask-clip": "[<coord-box>|no-clip|border|padding|content|text]#",
    "-webkit-mask-composite": "<composite-style>#",
    "-webkit-mask-image": "<mask-reference>#",
    "-webkit-mask-origin": "[<coord-box>|border|padding|content]#",
    "-webkit-mask-position": "<position>#",
    "-webkit-mask-position-x": "[<length-percentage>|left|center|right]#",
    "-webkit-mask-position-y": "[<length-percentage>|top|center|bottom]#",
    "-webkit-mask-repeat": "<repeat-style>#",
    "-webkit-mask-repeat-x": "repeat|no-repeat|space|round",
    "-webkit-mask-repeat-y": "repeat|no-repeat|space|round",
    "-webkit-mask-size": "<bg-size>#",
    "-webkit-overflow-scrolling": "auto|touch",
    "-webkit-tap-highlight-color": "<color>",
    "-webkit-text-fill-color": "<color>",
    "-webkit-text-stroke": "<length>||<color>",
    "-webkit-text-stroke-color": "<color>",
    "-webkit-text-stroke-width": "<length>",
    "-webkit-touch-callout": "default|none",
    "-webkit-user-modify": "read-only|read-write|read-write-plaintext-only",
    "-webkit-user-select": "auto|none|text|all",
    "accent-color": "auto|<color>",
    "align-content": "normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>",
    "align-items": "normal|stretch|<baseline-position>|[<overflow-position>? <self-position>]|anchor-center",
    "align-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? <self-position>|anchor-center",
    "align-tracks": "[normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>]#",
    "alignment-baseline": "auto|baseline|before-edge|text-before-edge|middle|central|after-edge|text-after-edge|ideographic|alphabetic|hanging|mathematical",
    all: "initial|inherit|unset|revert|revert-layer",
    "anchor-name": "none|<dashed-ident>#",
    "anchor-scope": "none|all|<dashed-ident>#",
    animation: "<single-animation>#",
    "animation-composition": "<single-animation-composition>#",
    "animation-delay": "<time>#",
    "animation-direction": "<single-animation-direction>#",
    "animation-duration": "[auto|<time [0s,∞]>]#",
    "animation-fill-mode": "<single-animation-fill-mode>#",
    "animation-iteration-count": "<single-animation-iteration-count>#",
    "animation-name": "[none|<keyframes-name>]#",
    "animation-play-state": "<single-animation-play-state>#",
    "animation-range": "[<'animation-range-start'> <'animation-range-end'>?]#",
    "animation-range-end": "[normal|<length-percentage>|<timeline-range-name> <length-percentage>?]#",
    "animation-range-start": "[normal|<length-percentage>|<timeline-range-name> <length-percentage>?]#",
    "animation-timeline": "<single-animation-timeline>#",
    "animation-timing-function": "<easing-function>#",
    "animation-trigger": "[none|[<dashed-ident> <animation-action>+]+]#",
    appearance: "none|auto|<compat-auto>|<compat-special>",
    "aspect-ratio": "auto||<ratio>",
    "backdrop-filter": "none|<filter-value-list>",
    "backface-visibility": "visible|hidden",
    background: "<bg-layer>#? , <final-bg-layer>",
    "background-attachment": "<attachment>#",
    "background-blend-mode": "<blend-mode>#",
    "background-clip": "<bg-clip>#",
    "background-color": "<color>",
    "background-image": "<bg-image>#",
    "background-origin": "<visual-box>#",
    "background-position": "<bg-position>#",
    "background-position-x": "[center|[[left|right|x-start|x-end]? <length-percentage>?]!]#",
    "background-position-y": "[center|[[top|bottom|y-start|y-end]? <length-percentage>?]!]#",
    "background-repeat": "<repeat-style>#",
    "background-size": "<bg-size>#",
    "baseline-shift": "baseline|sub|super|<svg-length>",
    "baseline-source": "auto|first|last",
    "block-size": "<'width'>",
    border: "<line-width>||<line-style>||<color>",
    "border-block": "<'border-block-start'>",
    "border-block-color": "<'border-top-color'>{1,2}",
    "border-block-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-end-color": "<'border-top-color'>",
    "border-block-end-style": "<'border-top-style'>",
    "border-block-end-width": "<'border-top-width'>",
    "border-block-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-start-color": "<'border-top-color'>",
    "border-block-start-style": "<'border-top-style'>",
    "border-block-start-width": "<'border-top-width'>",
    "border-block-style": "<'border-top-style'>{1,2}",
    "border-block-width": "<'border-top-width'>{1,2}",
    "border-bottom": "<line-width>||<line-style>||<color>",
    "border-bottom-color": "<'border-top-color'>",
    "border-bottom-left-radius": "<length-percentage [0,∞]>{1,2}",
    "border-bottom-right-radius": "<length-percentage [0,∞]>{1,2}",
    "border-bottom-style": "<line-style>",
    "border-bottom-width": "<line-width>",
    "border-collapse": "separate|collapse",
    "border-color": "<color>{1,4}",
    "border-end-end-radius": "<'border-top-left-radius'>",
    "border-end-start-radius": "<'border-top-left-radius'>",
    "border-image": "<'border-image-source'>||<'border-image-slice'> [/ <'border-image-width'>|/ <'border-image-width'>? / <'border-image-outset'>]?||<'border-image-repeat'>",
    "border-image-outset": "[<length [0,∞]>|<number [0,∞]>]{1,4}",
    "border-image-repeat": "[stretch|repeat|round|space]{1,2}",
    "border-image-slice": "[<number [0,∞]>|<percentage [0,∞]>]{1,4}&&fill?",
    "border-image-source": "none|<image>",
    "border-image-width": "[<length-percentage [0,∞]>|<number [0,∞]>|auto]{1,4}",
    "border-inline": "<'border-block-start'>",
    "border-inline-color": "<'border-top-color'>{1,2}",
    "border-inline-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-end-color": "<'border-top-color'>",
    "border-inline-end-style": "<'border-top-style'>",
    "border-inline-end-width": "<'border-top-width'>",
    "border-inline-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-start-color": "<'border-top-color'>",
    "border-inline-start-style": "<'border-top-style'>",
    "border-inline-start-width": "<'border-top-width'>",
    "border-inline-style": "<'border-top-style'>{1,2}",
    "border-inline-width": "<'border-top-width'>{1,2}",
    "border-left": "<line-width>||<line-style>||<color>",
    "border-left-color": "<color>",
    "border-left-style": "<line-style>",
    "border-left-width": "<line-width>",
    "border-radius": "<length-percentage [0,∞]>{1,4} [/ <length-percentage [0,∞]>{1,4}]?",
    "border-right": "<line-width>||<line-style>||<color>",
    "border-right-color": "<color>",
    "border-right-style": "<line-style>",
    "border-right-width": "<line-width>",
    "border-spacing": "<length>{1,2}",
    "border-start-end-radius": "<'border-top-left-radius'>",
    "border-start-start-radius": "<'border-top-left-radius'>",
    "border-style": "<line-style>{1,4}",
    "border-top": "<line-width>||<line-style>||<color>",
    "border-top-color": "<color>",
    "border-top-left-radius": "<length-percentage [0,∞]>{1,2}",
    "border-top-right-radius": "<length-percentage [0,∞]>{1,2}",
    "border-top-style": "<line-style>",
    "border-top-width": "<line-width>",
    "border-width": "<line-width>{1,4}",
    bottom: "auto|<length-percentage>|<anchor()>|<anchor-size()>",
    "box-align": "start|center|end|baseline|stretch",
    "box-decoration-break": "slice|clone",
    "box-direction": "normal|reverse|inherit",
    "box-flex": "<number>",
    "box-flex-group": "<integer>",
    "box-lines": "single|multiple",
    "box-ordinal-group": "<integer>",
    "box-orient": "horizontal|vertical|inline-axis|block-axis|inherit",
    "box-pack": "start|center|end|justify",
    "box-shadow": "none|<shadow>#",
    "box-sizing": "content-box|border-box",
    "break-after": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-before": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-inside": "auto|avoid|avoid-page|avoid-column|avoid-region",
    "caption-side": "top|bottom",
    caret: "<'caret-color'>||<'caret-animation'>||<'caret-shape'>",
    "caret-animation": "auto|manual",
    "caret-color": "auto|<color>",
    "caret-shape": "auto|bar|block|underscore",
    clear: "none|left|right|both|inline-start|inline-end",
    clip: "<shape>|auto",
    "clip-path": "<clip-source>|[<basic-shape>||<geometry-box>]|none",
    "clip-rule": "nonzero|evenodd",
    color: "<color>",
    "color-interpolation-filters": "auto|sRGB|linearRGB",
    "color-scheme": "normal|[light|dark|<custom-ident>]+&&only?",
    "column-count": "<integer>|auto",
    "column-fill": "auto|balance",
    "column-gap": "normal|<length-percentage>",
    "column-height": "auto|<length [0,∞]>",
    "column-rule": "<'column-rule-width'>||<'column-rule-style'>||<'column-rule-color'>",
    "column-rule-color": "<color>",
    "column-rule-style": "<'border-style'>",
    "column-rule-width": "<'border-width'>",
    "column-span": "none|all",
    "column-width": "auto|<length [0,∞]>",
    "column-wrap": "auto|nowrap|wrap",
    columns: "[<'column-width'>||<'column-count'>] [/ <'column-height'>]?",
    contain: "none|strict|content|[[size||inline-size]||layout||style||paint]",
    "contain-intrinsic-block-size": "auto? [none|<length>]",
    "contain-intrinsic-height": "auto? [none|<length>]",
    "contain-intrinsic-inline-size": "auto? [none|<length>]",
    "contain-intrinsic-size": "[auto? [none|<length>]]{1,2}",
    "contain-intrinsic-width": "auto? [none|<length>]",
    container: "<'container-name'> [/ <'container-type'>]?",
    "container-name": "none|<custom-ident>+",
    "container-type": "normal||[size|inline-size]",
    content: "normal|none|[<content-replacement>|<content-list>] [/ [<string>|<counter>|<attr()>]+]?",
    "content-visibility": "visible|auto|hidden",
    "corner-block-end-shape": "<corner-shape-value>{1,2}",
    "corner-block-start-shape": "<corner-shape-value>{1,2}",
    "corner-bottom-shape": "<corner-shape-value>{1,2}",
    "corner-bottom-left-shape": "<corner-shape-value>",
    "corner-bottom-right-shape": "<corner-shape-value>",
    "corner-end-end-shape": "<corner-shape-value>",
    "corner-end-start-shape": "<corner-shape-value>",
    "corner-inline-end-shape": "<corner-shape-value>{1,2}",
    "corner-inline-start-shape": "<corner-shape-value>{1,2}",
    "corner-left-shape": "<corner-shape-value>{1,2}",
    "corner-right-shape": "<corner-shape-value>{1,2}",
    "corner-shape": "<corner-shape-value>{1,4}",
    "corner-start-start-shape": "<corner-shape-value>",
    "corner-start-end-shape": "<corner-shape-value>",
    "corner-top-shape": "<corner-shape-value>{1,2}",
    "corner-top-left-shape": "<corner-shape-value>",
    "corner-top-right-shape": "<corner-shape-value>",
    "counter-increment": "[<counter-name> <integer>?]+|none",
    "counter-reset": "[<counter-name> <integer>?|<reversed-counter-name> <integer>?]+|none",
    "counter-set": "[<counter-name> <integer>?]+|none",
    cursor: "[[<url> [<x> <y>]? ,]* [auto|default|none|context-menu|help|pointer|progress|wait|cell|crosshair|text|vertical-text|alias|copy|move|no-drop|not-allowed|e-resize|n-resize|ne-resize|nw-resize|s-resize|se-resize|sw-resize|w-resize|ew-resize|ns-resize|nesw-resize|nwse-resize|col-resize|row-resize|all-scroll|zoom-in|zoom-out|grab|grabbing|hand|-webkit-grab|-webkit-grabbing|-webkit-zoom-in|-webkit-zoom-out|-moz-grab|-moz-grabbing|-moz-zoom-in|-moz-zoom-out]]",
    cx: "<length>|<percentage>",
    cy: "<length>|<percentage>",
    d: "none|path( <string> )",
    direction: "ltr|rtl",
    display: "[<display-outside>||<display-inside>]|<display-listitem>|<display-internal>|<display-box>|<display-legacy>|<-non-standard-display>",
    "dominant-baseline": "auto|use-script|no-change|reset-size|ideographic|alphabetic|hanging|mathematical|central|middle|text-after-edge|text-before-edge",
    "dynamic-range-limit": "standard|no-limit|constrained|<dynamic-range-limit-mix()>",
    "empty-cells": "show|hide",
    "field-sizing": "content|fixed",
    fill: "<paint>",
    "fill-opacity": "<number-zero-one>|<percentage>",
    "fill-rule": "nonzero|evenodd",
    filter: "none|<filter-value-list>|<-ms-filter-function-list>",
    flex: "none|[<'flex-grow'> <'flex-shrink'>?||<'flex-basis'>]",
    "flex-basis": "content|<'width'>",
    "flex-direction": "row|row-reverse|column|column-reverse",
    "flex-flow": "<'flex-direction'>||<'flex-wrap'>",
    "flex-grow": "<number>",
    "flex-shrink": "<number>",
    "flex-wrap": "nowrap|wrap|wrap-reverse",
    float: "left|right|none|inline-start|inline-end",
    "flood-color": "<color>",
    "flood-opacity": "<'opacity'>",
    font: "[[<'font-style'>||<font-variant-css2>||<'font-weight'>||<font-width-css3>]? <'font-size'> [/ <'line-height'>]? <'font-family'>#]|<system-family-name>|<-non-standard-font>",
    "font-family": "[<family-name>|<generic-family>]#",
    "font-feature-settings": "normal|<feature-tag-value>#",
    "font-kerning": "auto|normal|none",
    "font-language-override": "normal|<string>",
    "font-optical-sizing": "auto|none",
    "font-palette": "normal|light|dark|<palette-identifier>|<palette-mix()>",
    "font-size": "<absolute-size>|<relative-size>|<length-percentage [0,∞]>|math",
    "font-size-adjust": "none|[ex-height|cap-height|ch-width|ic-width|ic-height]? [from-font|<number>]",
    "font-smooth": "auto|never|always|<absolute-size>|<length>",
    "font-stretch": "<font-stretch-absolute>",
    "font-style": "normal|italic|oblique <angle>?",
    "font-synthesis": "none|[weight||style||small-caps||position]",
    "font-synthesis-position": "auto|none",
    "font-synthesis-small-caps": "auto|none",
    "font-synthesis-style": "auto|none",
    "font-synthesis-weight": "auto|none",
    "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-alternates": "normal|[stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )]",
    "font-variant-caps": "normal|small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
    "font-variant-east-asian": "normal|[<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-emoji": "normal|text|emoji|unicode",
    "font-variant-ligatures": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>]",
    "font-variant-numeric": "normal|[<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero]",
    "font-variant-position": "normal|sub|super",
    "font-variation-settings": "normal|[<string> <number>]#",
    "font-weight": "<font-weight-absolute>|bolder|lighter",
    "font-width": "normal|<percentage [0,∞]>|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded",
    "forced-color-adjust": "auto|none|preserve-parent-color",
    gap: "<'row-gap'> <'column-gap'>?",
    grid: "<'grid-template'>|<'grid-template-rows'> / [auto-flow&&dense?] <'grid-auto-columns'>?|[auto-flow&&dense?] <'grid-auto-rows'>? / <'grid-template-columns'>",
    "grid-area": "<grid-line> [/ <grid-line>]{0,3}",
    "grid-auto-columns": "<track-size>+",
    "grid-auto-flow": "[row|column]||dense",
    "grid-auto-rows": "<track-size>+",
    "grid-column": "<grid-line> [/ <grid-line>]?",
    "grid-column-end": "<grid-line>",
    "grid-column-gap": "<length-percentage>",
    "grid-column-start": "<grid-line>",
    "grid-gap": "<'grid-row-gap'> <'grid-column-gap'>?",
    "grid-row": "<grid-line> [/ <grid-line>]?",
    "grid-row-end": "<grid-line>",
    "grid-row-gap": "<length-percentage>",
    "grid-row-start": "<grid-line>",
    "grid-template": "none|[<'grid-template-rows'> / <'grid-template-columns'>]|[<line-names>? <string> <track-size>? <line-names>?]+ [/ <explicit-track-list>]?",
    "grid-template-areas": "none|<string>+",
    "grid-template-columns": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "grid-template-rows": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "hanging-punctuation": "none|[first||[force-end|allow-end]||last]",
    height: "auto|<length-percentage [0,∞]>|min-content|max-content|fit-content|fit-content( <length-percentage [0,∞]> )|<calc-size()>|<anchor-size()>|stretch|<-non-standard-size>",
    "hyphenate-character": "auto|<string>",
    "hyphenate-limit-chars": "[auto|<integer>]{1,3}",
    hyphens: "none|manual|auto",
    "image-orientation": "from-image|<angle>|[<angle>? flip]",
    "image-rendering": "auto|crisp-edges|pixelated|smooth|optimizeSpeed|optimizeQuality|<-non-standard-image-rendering>",
    "image-resolution": "[from-image||<resolution>]&&snap?",
    "ime-mode": "auto|normal|active|inactive|disabled",
    "initial-letter": "normal|[<number> <integer>?]",
    "initial-letter-align": "[auto|alphabetic|hanging|ideographic]",
    "inline-size": "<'width'>",
    inset: "<'top'>{1,4}",
    "inset-block": "<'top'>{1,2}",
    "inset-block-end": "<'top'>",
    "inset-block-start": "<'top'>",
    "inset-inline": "<'top'>{1,2}",
    "inset-inline-end": "<'top'>",
    "inset-inline-start": "<'top'>",
    "interpolate-size": "numeric-only|allow-keywords",
    isolation: "auto|isolate",
    interactivity: "auto|inert",
    "interest-delay": "<'interest-delay-start'>{1,2}",
    "interest-delay-end": "normal|<time>",
    "interest-delay-start": "normal|<time>",
    "justify-content": "normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]",
    "justify-items": "normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]|legacy|legacy&&[left|right|center]|anchor-center",
    "justify-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]|anchor-center",
    "justify-tracks": "[normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]]#",
    left: "auto|<length-percentage>|<anchor()>|<anchor-size()>",
    "letter-spacing": "normal|<length-percentage>",
    "lighting-color": "<color>",
    "line-break": "auto|loose|normal|strict|anywhere",
    "line-clamp": "none|<integer>",
    "line-height": "normal|<number>|<length>|<percentage>",
    "line-height-step": "<length>",
    "list-style": "<'list-style-type'>||<'list-style-position'>||<'list-style-image'>",
    "list-style-image": "<image>|none",
    "list-style-position": "inside|outside",
    "list-style-type": "<counter-style>|<string>|none",
    margin: "<'margin-top'>{1,4}",
    "margin-block": "<'margin-top'>{1,2}",
    "margin-block-end": "<'margin-top'>",
    "margin-block-start": "<'margin-top'>",
    "margin-bottom": "<length-percentage>|auto|<anchor-size()>",
    "margin-inline": "<'margin-top'>{1,2}",
    "margin-inline-end": "<'margin-top'>",
    "margin-inline-start": "<'margin-top'>",
    "margin-left": "<length-percentage>|auto|<anchor-size()>",
    "margin-right": "<length-percentage>|auto|<anchor-size()>",
    "margin-top": "<length-percentage>|auto|<anchor-size()>",
    "margin-trim": "none|in-flow|all",
    marker: "none|<url>",
    "marker-end": "none|<url>",
    "marker-mid": "none|<url>",
    "marker-start": "none|<url>",
    mask: "<mask-layer>#",
    "mask-border": "<'mask-border-source'>||<'mask-border-slice'> [/ <'mask-border-width'>? [/ <'mask-border-outset'>]?]?||<'mask-border-repeat'>||<'mask-border-mode'>",
    "mask-border-mode": "luminance|alpha",
    "mask-border-outset": "[<length>|<number>]{1,4}",
    "mask-border-repeat": "[stretch|repeat|round|space]{1,2}",
    "mask-border-slice": "<number-percentage>{1,4} fill?",
    "mask-border-source": "none|<image>",
    "mask-border-width": "[<length-percentage>|<number>|auto]{1,4}",
    "mask-clip": "[<coord-box>|no-clip]#",
    "mask-composite": "<compositing-operator>#",
    "mask-image": "<mask-reference>#",
    "mask-mode": "<masking-mode>#",
    "mask-origin": "<coord-box>#",
    "mask-position": "<position>#",
    "mask-repeat": "<repeat-style>#",
    "mask-size": "<bg-size>#",
    "mask-type": "luminance|alpha",
    "masonry-auto-flow": "[pack|next]||[definite-first|ordered]",
    "math-depth": "auto-add|add( <integer> )|<integer>",
    "math-shift": "normal|compact",
    "math-style": "normal|compact",
    "max-block-size": "<'max-width'>",
    "max-height": "none|<length-percentage [0,∞]>|min-content|max-content|fit-content|fit-content( <length-percentage [0,∞]> )|<calc-size()>|<anchor-size()>|stretch|<-non-standard-size>",
    "max-inline-size": "<'max-width'>",
    "max-lines": "none|<integer>",
    "max-width": "none|<length-percentage [0,∞]>|min-content|max-content|fit-content|fit-content( <length-percentage [0,∞]> )|<calc-size()>|<anchor-size()>|stretch|<-non-standard-size>",
    "min-block-size": "<'min-width'>",
    "min-height": "auto|<length-percentage [0,∞]>|min-content|max-content|fit-content|fit-content( <length-percentage [0,∞]> )|<calc-size()>|<anchor-size()>|stretch|<-non-standard-size>",
    "min-inline-size": "<'min-width'>",
    "min-width": "auto|<length-percentage [0,∞]>|min-content|max-content|fit-content|fit-content( <length-percentage [0,∞]> )|<calc-size()>|<anchor-size()>|stretch|<-non-standard-size>",
    "mix-blend-mode": "<blend-mode>|plus-darker|plus-lighter",
    "object-fit": "fill|contain|cover|none|scale-down",
    "object-position": "<position>",
    "object-view-box": "none|<basic-shape-rect>",
    offset: "[<'offset-position'>? [<'offset-path'> [<'offset-distance'>||<'offset-rotate'>]?]?]! [/ <'offset-anchor'>]?",
    "offset-anchor": "auto|<position>",
    "offset-distance": "<length-percentage>",
    "offset-path": "none|<offset-path>||<coord-box>",
    "offset-position": "normal|auto|<position>",
    "offset-rotate": "[auto|reverse]||<angle>",
    opacity: "<opacity-value>",
    order: "<integer>",
    orphans: "<integer>",
    outline: "<'outline-width'>||<'outline-style'>||<'outline-color'>",
    "outline-color": "auto|<color>",
    "outline-offset": "<length>",
    "outline-style": "auto|<outline-line-style>",
    "outline-width": "<line-width>",
    overflow: "[visible|hidden|clip|scroll|auto]{1,2}|<-non-standard-overflow>",
    "overflow-anchor": "auto|none",
    "overflow-block": "visible|hidden|clip|scroll|auto|<-non-standard-overflow>",
    "overflow-clip-box": "padding-box|content-box",
    "overflow-clip-margin": "<visual-box>||<length [0,∞]>",
    "overflow-inline": "visible|hidden|clip|scroll|auto|<-non-standard-overflow>",
    "overflow-wrap": "normal|break-word|anywhere",
    "overflow-x": "visible|hidden|clip|scroll|auto|<-non-standard-overflow>",
    "overflow-y": "visible|hidden|clip|scroll|auto|<-non-standard-overflow>",
    overlay: "none|auto",
    "overscroll-behavior": "[contain|none|auto]{1,2}",
    "overscroll-behavior-block": "contain|none|auto",
    "overscroll-behavior-inline": "contain|none|auto",
    "overscroll-behavior-x": "contain|none|auto",
    "overscroll-behavior-y": "contain|none|auto",
    padding: "<'padding-top'>{1,4}",
    "padding-block": "<'padding-top'>{1,2}",
    "padding-block-end": "<'padding-top'>",
    "padding-block-start": "<'padding-top'>",
    "padding-bottom": "<length-percentage [0,∞]>",
    "padding-inline": "<'padding-top'>{1,2}",
    "padding-inline-end": "<'padding-top'>",
    "padding-inline-start": "<'padding-top'>",
    "padding-left": "<length-percentage [0,∞]>",
    "padding-right": "<length-percentage [0,∞]>",
    "padding-top": "<length-percentage [0,∞]>",
    page: "auto|<custom-ident>",
    "page-break-after": "auto|always|avoid|left|right|recto|verso",
    "page-break-before": "auto|always|avoid|left|right|recto|verso",
    "page-break-inside": "auto|avoid",
    "paint-order": "normal|[fill||stroke||markers]",
    perspective: "none|<length>",
    "perspective-origin": "<position>",
    "place-content": "<'align-content'> <'justify-content'>?",
    "place-items": "<'align-items'> <'justify-items'>?",
    "place-self": "<'align-self'> <'justify-self'>?",
    "pointer-events": "auto|none|visiblePainted|visibleFill|visibleStroke|visible|painted|fill|stroke|all|inherit",
    position: "static|relative|absolute|sticky|fixed|-webkit-sticky",
    "position-anchor": "auto|none|<anchor-name>",
    "position-area": "none|<position-area>",
    "position-try": "<'position-try-order'>? <'position-try-fallbacks'>",
    "position-try-fallbacks": "none|[[<dashed-ident>||<try-tactic>]|<'position-area'>]#",
    "position-try-order": "normal|<try-size>",
    "position-visibility": "always|[anchors-valid||anchors-visible||no-overflow]",
    "print-color-adjust": "economy|exact",
    quotes: "none|auto|[<string> <string>]+",
    r: "<length>|<percentage>",
    "reading-flow": "normal|source-order|flex-visual|flex-flow|grid-rows|grid-columns|grid-order",
    "reading-order": "<integer>",
    resize: "none|both|horizontal|vertical|block|inline",
    right: "auto|<length-percentage>|<anchor()>|<anchor-size()>",
    rotate: "none|<angle>|[x|y|z|<number>{3}]&&<angle>",
    "row-gap": "normal|<length-percentage>",
    "ruby-align": "start|center|space-between|space-around",
    "ruby-merge": "separate|collapse|auto",
    "ruby-overhang": "auto|none",
    "ruby-position": "[alternate||[over|under]]|inter-character",
    rx: "<length>|<percentage>",
    ry: "<length>|<percentage>",
    scale: "none|[<number>|<percentage>]{1,3}",
    "scroll-behavior": "auto|smooth",
    "scroll-initial-target": "none|nearest",
    "scroll-margin": "<length>{1,4}",
    "scroll-margin-block": "<length>{1,2}",
    "scroll-margin-block-end": "<length>",
    "scroll-margin-block-start": "<length>",
    "scroll-margin-bottom": "<length>",
    "scroll-margin-inline": "<length>{1,2}",
    "scroll-margin-inline-end": "<length>",
    "scroll-margin-inline-start": "<length>",
    "scroll-margin-left": "<length>",
    "scroll-margin-right": "<length>",
    "scroll-margin-top": "<length>",
    "scroll-marker-group": "none|before|after",
    "scroll-padding": "[auto|<length-percentage>]{1,4}",
    "scroll-padding-block": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-block-end": "auto|<length-percentage>",
    "scroll-padding-block-start": "auto|<length-percentage>",
    "scroll-padding-bottom": "auto|<length-percentage>",
    "scroll-padding-inline": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-inline-end": "auto|<length-percentage>",
    "scroll-padding-inline-start": "auto|<length-percentage>",
    "scroll-padding-left": "auto|<length-percentage>",
    "scroll-padding-right": "auto|<length-percentage>",
    "scroll-padding-top": "auto|<length-percentage>",
    "scroll-snap-align": "[none|start|end|center]{1,2}",
    "scroll-snap-coordinate": "none|<position>#",
    "scroll-snap-destination": "<position>",
    "scroll-snap-points-x": "none|repeat( <length-percentage> )",
    "scroll-snap-points-y": "none|repeat( <length-percentage> )",
    "scroll-snap-stop": "normal|always",
    "scroll-snap-type": "none|[x|y|block|inline|both] [mandatory|proximity]?",
    "scroll-snap-type-x": "none|mandatory|proximity",
    "scroll-snap-type-y": "none|mandatory|proximity",
    "scroll-target-group": "none|auto",
    "scroll-timeline": "[<'scroll-timeline-name'> <'scroll-timeline-axis'>?]#",
    "scroll-timeline-axis": "[block|inline|x|y]#",
    "scroll-timeline-name": "[none|<dashed-ident>]#",
    "scrollbar-color": "auto|<color>{2}",
    "scrollbar-gutter": "auto|stable&&both-edges?",
    "scrollbar-width": "auto|thin|none",
    "shape-image-threshold": "<opacity-value>",
    "shape-margin": "<length-percentage>",
    "shape-outside": "none|[<shape-box>||<basic-shape>]|<image>",
    "shape-rendering": "auto|optimizeSpeed|crispEdges|geometricPrecision",
    "speak-as": "normal|spell-out||digits||[literal-punctuation|no-punctuation]",
    "stop-color": "<'color'>",
    "stop-opacity": "<'opacity'>",
    stroke: "<paint>",
    "stroke-color": "<color>",
    "stroke-dasharray": "none|[<svg-length>+]#",
    "stroke-dashoffset": "<svg-length>",
    "stroke-linecap": "butt|round|square",
    "stroke-linejoin": "miter|round|bevel",
    "stroke-miterlimit": "<number-one-or-greater>",
    "stroke-opacity": "<'opacity'>",
    "stroke-width": "<svg-length>",
    "tab-size": "<integer>|<length>",
    "table-layout": "auto|fixed",
    "text-align": "start|end|left|right|center|justify|match-parent",
    "text-align-last": "auto|start|end|left|right|center|justify",
    "text-anchor": "start|middle|end",
    "text-autospace": "normal|<autospace>|auto",
    "text-box": "normal|<'text-box-trim'>||<'text-box-edge'>",
    "text-box-edge": "auto|<text-edge>",
    "text-box-trim": "none|trim-start|trim-end|trim-both",
    "text-combine-upright": "none|all|[digits <integer>?]",
    "text-decoration": "<'text-decoration-line'>||<'text-decoration-style'>||<'text-decoration-color'>||<'text-decoration-thickness'>",
    "text-decoration-color": "<color>",
    "text-decoration-inset": "<length>{1,2}|auto",
    "text-decoration-line": "none|[underline||overline||line-through||blink]|spelling-error|grammar-error",
    "text-decoration-skip": "none|[objects||[spaces|[leading-spaces||trailing-spaces]]||edges||box-decoration]",
    "text-decoration-skip-ink": "auto|all|none",
    "text-decoration-style": "solid|double|dotted|dashed|wavy",
    "text-decoration-thickness": "auto|from-font|<length>|<percentage>",
    "text-emphasis": "<'text-emphasis-style'>||<'text-emphasis-color'>",
    "text-emphasis-color": "<color>",
    "text-emphasis-position": "auto|[over|under]&&[right|left]?",
    "text-emphasis-style": "none|[[filled|open]||[dot|circle|double-circle|triangle|sesame]]|<string>",
    "text-indent": "<length-percentage>&&hanging?&&each-line?",
    "text-justify": "auto|inter-character|inter-word|none",
    "text-orientation": "mixed|upright|sideways",
    "text-overflow": "[clip|ellipsis|<string>]{1,2}",
    "text-rendering": "auto|optimizeSpeed|optimizeLegibility|geometricPrecision",
    "text-shadow": "none|<shadow-t>#",
    "text-size-adjust": "none|auto|<percentage>",
    "text-spacing-trim": "space-all|normal|space-first|trim-start",
    "text-transform": "none|[capitalize|uppercase|lowercase]||full-width||full-size-kana|math-auto",
    "text-underline-offset": "auto|<length>|<percentage>",
    "text-underline-position": "auto|from-font|[under||[left|right]]",
    "text-wrap": "<'text-wrap-mode'>||<'text-wrap-style'>",
    "text-wrap-mode": "wrap|nowrap",
    "text-wrap-style": "auto|balance|stable|pretty",
    "timeline-scope": "none|<dashed-ident>#",
    "timeline-trigger": "none|[<'timeline-trigger-name'> <'timeline-trigger-source'> <'timeline-trigger-range'> ['/' <'timeline-trigger-exit-range'>]?]#",
    "timeline-trigger-name": "none|<dashed-ident>#",
    "timeline-trigger-exit-range": "[<'timeline-trigger-exit-range-start'> <'timeline-trigger-exit-range-end'>?]#",
    "timeline-trigger-exit-range-end": "[auto|normal|<length-percentage>|<timeline-range-name> <length-percentage>?]#",
    "timeline-trigger-exit-range-start": "[auto|normal|<length-percentage>|<timeline-range-name> <length-percentage>?]#",
    "timeline-trigger-range": "[<'timeline-trigger-range-start'> <'timeline-trigger-range-end'>?]#",
    "timeline-trigger-range-end": "[normal|<length-percentage>|<timeline-range-name> <length-percentage>?]#",
    "timeline-trigger-range-start": "[normal|<length-percentage>|<timeline-range-name> <length-percentage>?]#",
    "timeline-trigger-source": "<single-animation-timeline>#",
    top: "auto|<length-percentage>|<anchor()>|<anchor-size()>",
    "touch-action": "auto|none|[[pan-x|pan-left|pan-right]||[pan-y|pan-up|pan-down]||pinch-zoom]|manipulation",
    transform: "none|<transform-list>",
    "transform-box": "content-box|border-box|fill-box|stroke-box|view-box",
    "transform-origin": "[<length-percentage>|left|center|right|top|bottom]|[[<length-percentage>|left|center|right]&&[<length-percentage>|top|center|bottom]] <length>?",
    "transform-style": "flat|preserve-3d",
    transition: "<single-transition>#",
    "transition-behavior": "<transition-behavior-value>#",
    "transition-delay": "<time>#",
    "transition-duration": "<time>#",
    "transition-property": "none|<single-transition-property>#",
    "transition-timing-function": "<easing-function>#",
    translate: "none|<length-percentage> [<length-percentage> <length>?]?",
    "trigger-scope": "none|all|<dashed-ident>#",
    "unicode-bidi": "normal|embed|isolate|bidi-override|isolate-override|plaintext|-moz-isolate|-moz-isolate-override|-moz-plaintext|-webkit-isolate|-webkit-isolate-override|-webkit-plaintext",
    "user-select": "auto|text|none|all",
    "vector-effect": "none|non-scaling-stroke|non-scaling-size|non-rotation|fixed-position",
    "vertical-align": "baseline|sub|super|text-top|text-bottom|middle|top|bottom|<percentage>|<length>",
    "view-timeline": "[<'view-timeline-name'> [<'view-timeline-axis'>||<'view-timeline-inset'>]?]#",
    "view-timeline-axis": "[block|inline|x|y]#",
    "view-timeline-inset": "[[auto|<length-percentage>]{1,2}]#",
    "view-timeline-name": "[none|<dashed-ident>]#",
    "view-transition-class": "none|<custom-ident>+",
    "view-transition-name": "none|<custom-ident>|match-element",
    visibility: "visible|hidden|collapse",
    "white-space": "normal|pre|pre-wrap|pre-line|<'white-space-collapse'>||<'text-wrap-mode'>",
    "white-space-collapse": "collapse|preserve|preserve-breaks|preserve-spaces|break-spaces",
    widows: "<integer>",
    width: "auto|<length-percentage [0,∞]>|min-content|max-content|fit-content|fit-content( <length-percentage [0,∞]> )|<calc-size()>|<anchor-size()>|stretch|<-non-standard-size>",
    "will-change": "auto|<animateable-feature>#",
    "word-break": "normal|break-all|keep-all|break-word|auto-phrase",
    "word-spacing": "normal|<length>",
    "word-wrap": "normal|break-word",
    "writing-mode": "horizontal-tb|vertical-rl|vertical-lr|sideways-rl|sideways-lr|<svg-writing-mode>",
    x: "<length>|<percentage>",
    y: "<length>|<percentage>",
    "z-index": "auto|<integer>",
    zoom: "normal|reset|<number [0,∞]>||<percentage [0,∞]>",
    "-moz-background-clip": "padding|border",
    "-moz-border-radius-bottomleft": "<'border-bottom-left-radius'>",
    "-moz-border-radius-bottomright": "<'border-bottom-right-radius'>",
    "-moz-border-radius-topleft": "<'border-top-left-radius'>",
    "-moz-border-radius-topright": "<'border-bottom-right-radius'>",
    "-moz-control-character-visibility": "visible|hidden",
    "-moz-osx-font-smoothing": "auto|grayscale",
    "-moz-user-select": "none|text|all|-moz-none",
    "-ms-flex-align": "start|end|center|baseline|stretch",
    "-ms-flex-item-align": "auto|start|end|center|baseline|stretch",
    "-ms-flex-line-pack": "start|end|center|justify|distribute|stretch",
    "-ms-flex-negative": "<'flex-shrink'>",
    "-ms-flex-pack": "start|end|center|justify|distribute",
    "-ms-flex-order": "<integer>",
    "-ms-flex-positive": "<'flex-grow'>",
    "-ms-flex-preferred-size": "<'flex-basis'>",
    "-ms-interpolation-mode": "nearest-neighbor|bicubic",
    "-ms-grid-column-align": "start|end|center|stretch",
    "-ms-grid-row-align": "start|end|center|stretch",
    "-ms-hyphenate-limit-last": "none|always|column|page|spread",
    "-webkit-background-clip": "[<visual-box>|border|padding|content|text]#",
    "-webkit-column-break-after": "always|auto|avoid",
    "-webkit-column-break-before": "always|auto|avoid",
    "-webkit-column-break-inside": "always|auto|avoid",
    "-webkit-font-smoothing": "auto|none|antialiased|subpixel-antialiased",
    "-webkit-mask-box-image": "[<url>|<gradient>|none] [<length-percentage>{4} <-webkit-mask-box-repeat>{2}]?",
    "-webkit-print-color-adjust": "economy|exact",
    "-webkit-text-security": "none|circle|disc|square",
    "-webkit-user-drag": "none|element|auto",
    behavior: "<url>+",
    cue: "<'cue-before'> <'cue-after'>?",
    "cue-after": "<url> <decibel>?|none",
    "cue-before": "<url> <decibel>?|none",
    "glyph-orientation-horizontal": "<angle>",
    "glyph-orientation-vertical": "<angle>",
    kerning: "auto|<svg-length>",
    pause: "<'pause-before'> <'pause-after'>?",
    "pause-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "pause-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "position-try-options": "<'position-try-fallbacks'>",
    rest: "<'rest-before'> <'rest-after'>?",
    "rest-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "rest-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    speak: "auto|never|always",
    "voice-balance": "<number>|left|center|right|leftwards|rightwards",
    "voice-duration": "auto|<time>",
    "voice-family": "[[<family-name>|<generic-voice>] ,]* [<family-name>|<generic-voice>]|preserve",
    "voice-pitch": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-range": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-rate": "[normal|x-slow|slow|medium|fast|x-fast]||<percentage>",
    "voice-stress": "normal|strong|moderate|none|reduced",
    "voice-volume": "silent|[[x-soft|soft|medium|loud|x-loud]||<decibel>]",
    "white-space-trim": "none|discard-before||discard-after||discard-inner"
  },
  atrules: {
    charset: {
      prelude: "<string>",
      descriptors: null
    },
    "counter-style": {
      prelude: "<counter-style-name>",
      descriptors: {
        "additive-symbols": "[<integer [0,∞]>&&<symbol>]#",
        fallback: "<counter-style-name>",
        negative: "<symbol> <symbol>?",
        pad: "<integer [0,∞]>&&<symbol>",
        prefix: "<symbol>",
        range: "[[<integer>|infinite]{2}]#|auto",
        "speak-as": "auto|bullets|numbers|words|spell-out|<counter-style-name>",
        suffix: "<symbol>",
        symbols: "<symbol>+",
        system: "cyclic|numeric|alphabetic|symbolic|additive|[fixed <integer>?]|[extends <counter-style-name>]"
      }
    },
    container: {
      prelude: "[<container-name>]? <container-condition>",
      descriptors: null
    },
    document: {
      prelude: "[<url>|url-prefix( <string> )|domain( <string> )|media-document( <string> )|regexp( <string> )]#",
      descriptors: null
    },
    "font-face": {
      prelude: null,
      descriptors: {
        "ascent-override": "normal|<percentage>",
        "descent-override": "normal|<percentage>",
        "font-display": "auto|block|swap|fallback|optional",
        "font-family": "<family-name>",
        "font-feature-settings": "normal|<feature-tag-value>#",
        "font-stretch": "<font-stretch-absolute>{1,2}",
        "font-style": "normal|italic|oblique <angle>{0,2}",
        "font-variation-settings": "normal|[<string> <number>]#",
        "font-weight": "<font-weight-absolute>{1,2}",
        "line-gap-override": "normal|<percentage>",
        "size-adjust": "<percentage>",
        src: "[<url> [format( <string># )]?|local( <family-name> )]#",
        "unicode-range": "<urange>#"
      }
    },
    "font-feature-values": {
      prelude: "<family-name>#",
      descriptors: null
    },
    "font-palette-values": {
      prelude: "<dashed-ident>",
      descriptors: {
        "base-palette": "light|dark|<integer [0,∞]>",
        "font-family": "<family-name>#",
        "override-colors": "[<integer [0,∞]> <color>]#"
      }
    },
    import: {
      prelude: "[<string>|<url>] [layer|layer( <layer-name> )]? [supports( [<supports-condition>|<declaration>] )]? <media-query-list>?",
      descriptors: null
    },
    keyframes: {
      prelude: "<keyframes-name>",
      descriptors: null
    },
    layer: {
      prelude: "[<layer-name>#|<layer-name>?]",
      descriptors: null
    },
    media: {
      prelude: "<media-query-list>",
      descriptors: null
    },
    namespace: {
      prelude: "<namespace-prefix>? [<string>|<url>]",
      descriptors: null
    },
    page: {
      prelude: "<page-selector-list>",
      descriptors: {
        bleed: "auto|<length>",
        marks: "none|[crop||cross]",
        "page-orientation": "upright|rotate-left|rotate-right",
        size: "<length [0,∞]>{1,2}|auto|[<page-size>||[portrait|landscape]]"
      }
    },
    "position-try": {
      prelude: "<dashed-ident>",
      descriptors: {
        top: "<'top'>",
        left: "<'left'>",
        bottom: "<'bottom'>",
        right: "<'right'>",
        "inset-block-start": "<'inset-block-start'>",
        "inset-block-end": "<'inset-block-end'>",
        "inset-inline-start": "<'inset-inline-start'>",
        "inset-inline-end": "<'inset-inline-end'>",
        "inset-block": "<'inset-block'>",
        "inset-inline": "<'inset-inline'>",
        inset: "<'inset'>",
        "margin-top": "<'margin-top'>",
        "margin-left": "<'margin-left'>",
        "margin-bottom": "<'margin-bottom'>",
        "margin-right": "<'margin-right'>",
        "margin-block-start": "<'margin-block-start'>",
        "margin-block-end": "<'margin-block-end'>",
        "margin-inline-start": "<'margin-inline-start'>",
        "margin-inline-end": "<'margin-inline-end'>",
        margin: "<'margin'>",
        "margin-block": "<'margin-block'>",
        "margin-inline": "<'margin-inline'>",
        width: "<'width'>",
        height: "<'height'>",
        "min-width": "<'min-width'>",
        "min-height": "<'min-height'>",
        "max-width": "<'max-width'>",
        "max-height": "<'max-height'>",
        "block-size": "<'block-size'>",
        "inline-size": "<'inline-size'>",
        "min-block-size": "<'min-block-size'>",
        "min-inline-size": "<'min-inline-size'>",
        "max-block-size": "<'max-block-size'>",
        "max-inline-size": "<'max-inline-size'>",
        "align-self": "<'align-self'>|anchor-center",
        "justify-self": "<'justify-self'>|anchor-center"
      }
    },
    property: {
      prelude: "<custom-property-name>",
      descriptors: {
        inherits: "true|false",
        "initial-value": "<declaration-value>?",
        syntax: "<string>"
      }
    },
    scope: {
      prelude: "[( <scope-start> )]? [to ( <scope-end> )]?",
      descriptors: null
    },
    "starting-style": {
      prelude: null,
      descriptors: null
    },
    supports: {
      prelude: "<supports-condition>",
      descriptors: null
    },
    "view-transition": {
      prelude: null,
      descriptors: {
        navigation: "auto|none",
        types: "none|<custom-ident>+"
      }
    },
    "font-features-values": {
      prelude: "[<string>|<custom-ident>]+",
      descriptors: {
        "font-display": "auto|block|swap|fallback|optional"
      }
    }
  }
}, iu = 43, ta = 45, Iy = 110, qc = !0, m3e = !1;
function Ry(t, e) {
  let n = this.tokenStart + t;
  const r = this.charCodeAt(n);
  for ((r === iu || r === ta) && (e && this.error("Number sign is not allowed"), n++); n < this.tokenEnd; n++)
    Vi(this.charCodeAt(n)) || this.error("Integer is expected", n);
}
function _d(t) {
  return Ry.call(this, 0, t);
}
function dl(t, e) {
  if (!this.cmpChar(this.tokenStart + t, e)) {
    let n = "";
    switch (e) {
      case Iy:
        n = "N is expected";
        break;
      case ta:
        n = "HyphenMinus is expected";
        break;
    }
    this.error(n, this.tokenStart + t);
  }
}
function Uw() {
  let t = 0, e = 0, n = this.tokenType;
  for (; n === Lr || n === Ki; )
    n = this.lookupType(++t);
  if (n !== wt)
    if (this.isDelim(iu, t) || this.isDelim(ta, t)) {
      e = this.isDelim(iu, t) ? iu : ta;
      do
        n = this.lookupType(++t);
      while (n === Lr || n === Ki);
      n !== wt && (this.skip(t), _d.call(this, qc));
    } else
      return null;
  return t > 0 && this.skip(t), e === 0 && (n = this.charCodeAt(this.tokenStart), n !== iu && n !== ta && this.error("Number sign is expected")), _d.call(this, e !== 0), e === ta ? "-" + this.consume(wt) : this.consume(wt);
}
const g3e = "AnPlusB", p3e = {
  a: [String, null],
  b: [String, null]
};
function zH() {
  const t = this.tokenStart;
  let e = null, n = null;
  if (this.tokenType === wt)
    _d.call(this, m3e), n = this.consume(wt);
  else if (this.tokenType === He && this.cmpChar(this.tokenStart, ta))
    switch (e = "-1", dl.call(this, 1, Iy), this.tokenEnd - this.tokenStart) {
      // -n
      // -n <signed-integer>
      // -n ['+' | '-'] <signless-integer>
      case 2:
        this.next(), n = Uw.call(this);
        break;
      // -n- <signless-integer>
      case 3:
        dl.call(this, 2, ta), this.next(), this.skipSC(), _d.call(this, qc), n = "-" + this.consume(wt);
        break;
      // <dashndashdigit-ident>
      default:
        dl.call(this, 2, ta), Ry.call(this, 3, qc), this.next(), n = this.substrToCursor(t + 2);
    }
  else if (this.tokenType === He || this.isDelim(iu) && this.lookupType(1) === He) {
    let r = 0;
    switch (e = "1", this.isDelim(iu) && (r = 1, this.next()), dl.call(this, 0, Iy), this.tokenEnd - this.tokenStart) {
      // '+'? n
      // '+'? n <signed-integer>
      // '+'? n ['+' | '-'] <signless-integer>
      case 1:
        this.next(), n = Uw.call(this);
        break;
      // '+'? n- <signless-integer>
      case 2:
        dl.call(this, 1, ta), this.next(), this.skipSC(), _d.call(this, qc), n = "-" + this.consume(wt);
        break;
      // '+'? <ndashdigit-ident>
      default:
        dl.call(this, 1, ta), Ry.call(this, 2, qc), this.next(), n = this.substrToCursor(t + r + 1);
    }
  } else if (this.tokenType === cn) {
    const r = this.charCodeAt(this.tokenStart), i = r === iu || r === ta;
    let s = this.tokenStart + i;
    for (; s < this.tokenEnd && Vi(this.charCodeAt(s)); s++)
      ;
    s === this.tokenStart + i && this.error("Integer is expected", this.tokenStart + i), dl.call(this, s - this.tokenStart, Iy), e = this.substring(t, s), s + 1 === this.tokenEnd ? (this.next(), n = Uw.call(this)) : (dl.call(this, s - this.tokenStart + 1, ta), s + 2 === this.tokenEnd ? (this.next(), this.skipSC(), _d.call(this, qc), n = "-" + this.consume(wt)) : (Ry.call(this, s - this.tokenStart + 2, qc), this.next(), n = this.substrToCursor(s + 1)));
  } else
    this.error();
  return e !== null && e.charCodeAt(0) === iu && (e = e.substr(1)), n !== null && n.charCodeAt(0) === iu && (n = n.substr(1)), {
    type: "AnPlusB",
    loc: this.getLocation(t, this.tokenStart),
    a: e,
    b: n
  };
}
function b3e(t) {
  if (t.a) {
    const e = t.a === "+1" && "n" || t.a === "1" && "n" || t.a === "-1" && "-n" || t.a + "n";
    if (t.b) {
      const n = t.b[0] === "-" || t.b[0] === "+" ? t.b : "+" + t.b;
      this.tokenize(e + n);
    } else
      this.tokenize(e);
  } else
    this.tokenize(t.b);
}
const y3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: b3e,
  name: g3e,
  parse: zH,
  structure: p3e
}, Symbol.toStringTag, { value: "Module" }));
function jR() {
  return this.Raw(this.consumeUntilLeftCurlyBracketOrSemicolon, !0);
}
function A3e() {
  for (let t = 1, e; e = this.lookupType(t); t++) {
    if (e === ua)
      return !0;
    if (e === Ri || e === ri)
      return !1;
  }
  return !1;
}
const E3e = "Atrule", S3e = "atrule", w3e = {
  name: String,
  prelude: ["AtrulePrelude", "Raw", null],
  block: ["Block", null]
};
function jH(t = !1) {
  const e = this.tokenStart;
  let n, r, i = null, s = null;
  switch (this.eat(ri), n = this.substrToCursor(e + 1), r = n.toLowerCase(), this.skipSC(), this.eof === !1 && this.tokenType !== Ri && this.tokenType !== ss && (this.parseAtrulePrelude ? i = this.parseWithFallback(this.AtrulePrelude.bind(this, n, t), jR) : i = jR.call(this, this.tokenIndex), this.skipSC()), this.tokenType) {
    case ss:
      this.next();
      break;
    case Ri:
      hasOwnProperty.call(this.atrule, r) && typeof this.atrule[r].block == "function" ? s = this.atrule[r].block.call(this, t) : s = this.Block(A3e.call(this));
      break;
  }
  return {
    type: "Atrule",
    loc: this.getLocation(e, this.tokenStart),
    name: n,
    prelude: i,
    block: s
  };
}
function F3e(t) {
  this.token(ri, "@" + t.name), t.prelude !== null && this.node(t.prelude), t.block ? this.node(t.block) : this.token(ss, ";");
}
const T3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: F3e,
  name: E3e,
  parse: jH,
  structure: w3e,
  walkContext: S3e
}, Symbol.toStringTag, { value: "Module" })), v3e = "AtrulePrelude", x3e = "atrulePrelude", C3e = {
  children: [[]]
};
function YH(t) {
  let e = null;
  return t !== null && (t = t.toLowerCase()), this.skipSC(), hasOwnProperty.call(this.atrule, t) && typeof this.atrule[t].prelude == "function" ? e = this.atrule[t].prelude.call(this) : e = this.readSequence(this.scope.AtrulePrelude), this.skipSC(), this.eof !== !0 && this.tokenType !== Ri && this.tokenType !== ss && this.error("Semicolon or block is expected"), {
    type: "AtrulePrelude",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function k3e(t) {
  this.children(t);
}
const _3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: k3e,
  name: v3e,
  parse: YH,
  structure: C3e,
  walkContext: x3e
}, Symbol.toStringTag, { value: "Module" })), N3e = 36, qH = 42, Py = 61, D3e = 94, av = 124, I3e = 126;
function R3e() {
  this.eof && this.error("Unexpected end of input");
  const t = this.tokenStart;
  let e = !1;
  return this.isDelim(qH) ? (e = !0, this.next()) : this.isDelim(av) || this.eat(He), this.isDelim(av) ? this.charCodeAt(this.tokenStart + 1) !== Py ? (this.next(), this.eat(He)) : e && this.error("Identifier is expected", this.tokenEnd) : e && this.error("Vertical line is expected"), {
    type: "Identifier",
    loc: this.getLocation(t, this.tokenStart),
    name: this.substrToCursor(t)
  };
}
function P3e() {
  const t = this.tokenStart, e = this.charCodeAt(t);
  return e !== Py && // =
  e !== I3e && // ~=
  e !== D3e && // ^=
  e !== N3e && // $=
  e !== qH && // *=
  e !== av && this.error("Attribute selector (=, ~=, ^=, $=, *=, |=) is expected"), this.next(), e !== Py && (this.isDelim(Py) || this.error("Equal sign is expected"), this.next()), this.substrToCursor(t);
}
const L3e = "AttributeSelector", M3e = {
  name: "Identifier",
  matcher: [String, null],
  value: ["String", "Identifier", null],
  flags: [String, null]
};
function JH() {
  const t = this.tokenStart;
  let e, n = null, r = null, i = null;
  return this.eat(ca), this.skipSC(), e = R3e.call(this), this.skipSC(), this.tokenType !== Ya && (this.tokenType !== He && (n = P3e.call(this), this.skipSC(), r = this.tokenType === Po ? this.String() : this.Identifier(), this.skipSC()), this.tokenType === He && (i = this.consume(He), this.skipSC())), this.eat(Ya), {
    type: "AttributeSelector",
    loc: this.getLocation(t, this.tokenStart),
    name: e,
    matcher: n,
    value: r,
    flags: i
  };
}
function O3e(t) {
  this.token(hn, "["), this.node(t.name), t.matcher !== null && (this.tokenize(t.matcher), this.node(t.value)), t.flags !== null && this.token(He, t.flags), this.token(hn, "]");
}
const B3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: O3e,
  name: L3e,
  parse: JH,
  structure: M3e
}, Symbol.toStringTag, { value: "Module" })), $3e = 38;
function QH() {
  return this.Raw(null, !0);
}
function YR() {
  return this.parseWithFallback(this.Rule, QH);
}
function qR() {
  return this.Raw(this.consumeUntilSemicolonIncluded, !0);
}
function H3e() {
  if (this.tokenType === ss)
    return qR.call(this, this.tokenIndex);
  const t = this.parseWithFallback(this.Declaration, qR);
  return this.tokenType === ss && this.next(), t;
}
const U3e = "Block", G3e = "block", W3e = {
  children: [[
    "Atrule",
    "Rule",
    "Declaration"
  ]]
};
function XH(t) {
  const e = t ? H3e : YR, n = this.tokenStart;
  let r = this.createList();
  this.eat(Ri);
  e:
    for (; !this.eof; )
      switch (this.tokenType) {
        case ua:
          break e;
        case Lr:
        case Ki:
          this.next();
          break;
        case ri:
          r.push(this.parseWithFallback(this.Atrule.bind(this, t), QH));
          break;
        default:
          t && this.isDelim($3e) ? r.push(YR.call(this)) : r.push(e.call(this));
      }
  return this.eof || this.eat(ua), {
    type: "Block",
    loc: this.getLocation(n, this.tokenStart),
    children: r
  };
}
function V3e(t) {
  this.token(Ri, "{"), this.children(t, (e) => {
    e.type === "Declaration" && this.token(ss, ";");
  }), this.token(ua, "}");
}
const K3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: V3e,
  name: U3e,
  parse: XH,
  structure: W3e,
  walkContext: G3e
}, Symbol.toStringTag, { value: "Module" })), z3e = "Brackets", j3e = {
  children: [[]]
};
function ZH(t, e) {
  const n = this.tokenStart;
  let r = null;
  return this.eat(ca), r = t.call(this, e), this.eof || this.eat(Ya), {
    type: "Brackets",
    loc: this.getLocation(n, this.tokenStart),
    children: r
  };
}
function Y3e(t) {
  this.token(hn, "["), this.children(t), this.token(hn, "]");
}
const q3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: Y3e,
  name: z3e,
  parse: ZH,
  structure: j3e
}, Symbol.toStringTag, { value: "Module" })), J3e = "CDC", Q3e = [];
function eU() {
  const t = this.tokenStart;
  return this.eat(Is), {
    type: "CDC",
    loc: this.getLocation(t, this.tokenStart)
  };
}
function X3e() {
  this.token(Is, "-->");
}
const Z3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: X3e,
  name: J3e,
  parse: eU,
  structure: Q3e
}, Symbol.toStringTag, { value: "Module" })), eNe = "CDO", tNe = [];
function tU() {
  const t = this.tokenStart;
  return this.eat(cp), {
    type: "CDO",
    loc: this.getLocation(t, this.tokenStart)
  };
}
function nNe() {
  this.token(cp, "<!--");
}
const rNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: nNe,
  name: eNe,
  parse: tU,
  structure: tNe
}, Symbol.toStringTag, { value: "Module" })), iNe = 46, sNe = "ClassSelector", aNe = {
  name: String
};
function nU() {
  return this.eatDelim(iNe), {
    type: "ClassSelector",
    loc: this.getLocation(this.tokenStart - 1, this.tokenEnd),
    name: this.consume(He)
  };
}
function oNe(t) {
  this.token(hn, "."), this.token(He, t.name);
}
const uNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: oNe,
  name: sNe,
  parse: nU,
  structure: aNe
}, Symbol.toStringTag, { value: "Module" })), lNe = 43, JR = 47, cNe = 62, hNe = 126, dNe = "Combinator", fNe = {
  name: String
};
function rU() {
  const t = this.tokenStart;
  let e;
  switch (this.tokenType) {
    case Lr:
      e = " ";
      break;
    case hn:
      switch (this.charCodeAt(this.tokenStart)) {
        case cNe:
        case lNe:
        case hNe:
          this.next();
          break;
        case JR:
          this.next(), this.eatIdent("deep"), this.eatDelim(JR);
          break;
        default:
          this.error("Combinator is expected");
      }
      e = this.substrToCursor(t);
      break;
  }
  return {
    type: "Combinator",
    loc: this.getLocation(t, this.tokenStart),
    name: e
  };
}
function mNe(t) {
  this.tokenize(t.name);
}
const gNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: mNe,
  name: dNe,
  parse: rU,
  structure: fNe
}, Symbol.toStringTag, { value: "Module" })), pNe = 42, bNe = 47, yNe = "Comment", ANe = {
  value: String
};
function iU() {
  const t = this.tokenStart;
  let e = this.tokenEnd;
  return this.eat(Ki), e - t + 2 >= 2 && this.charCodeAt(e - 2) === pNe && this.charCodeAt(e - 1) === bNe && (e -= 2), {
    type: "Comment",
    loc: this.getLocation(t, this.tokenStart),
    value: this.substring(t + 2, e)
  };
}
function ENe(t) {
  this.token(Ki, "/*" + t.value + "*/");
}
const SNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: ENe,
  name: yNe,
  parse: iU,
  structure: ANe
}, Symbol.toStringTag, { value: "Module" })), wNe = /* @__PURE__ */ new Set([is, yt, Nl]), FNe = "Condition", TNe = {
  kind: String,
  children: [[
    "Identifier",
    "Feature",
    "FeatureFunction",
    "FeatureRange",
    "SupportsDeclaration"
  ]]
};
function QR(t) {
  return this.lookupTypeNonSC(1) === He && wNe.has(this.lookupTypeNonSC(2)) ? this.Feature(t) : this.FeatureRange(t);
}
const vNe = {
  media: QR,
  container: QR,
  supports() {
    return this.SupportsDeclaration();
  }
};
function sU(t = "media") {
  const e = this.createList();
  e: for (; !this.eof; )
    switch (this.tokenType) {
      case Ki:
      case Lr:
        this.next();
        continue;
      case He:
        e.push(this.Identifier());
        break;
      case kn: {
        let n = this.parseWithFallback(
          () => vNe[t].call(this, t),
          () => null
        );
        n || (n = this.parseWithFallback(
          () => {
            this.eat(kn);
            const r = this.Condition(t);
            return this.eat(yt), r;
          },
          () => this.GeneralEnclosed(t)
        )), e.push(n);
        break;
      }
      case Rt: {
        let n = this.parseWithFallback(
          () => this.FeatureFunction(t),
          () => null
        );
        n || (n = this.GeneralEnclosed(t)), e.push(n);
        break;
      }
      default:
        break e;
    }
  return e.isEmpty && this.error("Condition is expected"), {
    type: "Condition",
    loc: this.getLocationFromList(e),
    kind: t,
    children: e
  };
}
function xNe(t) {
  t.children.forEach((e) => {
    e.type === "Condition" ? (this.token(kn, "("), this.node(e), this.token(yt, ")")) : this.node(e);
  });
}
const CNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: xNe,
  name: FNe,
  parse: sU,
  structure: TNe
}, Symbol.toStringTag, { value: "Module" })), aU = 33, kNe = 35, _Ne = 36, NNe = 38, DNe = 42, INe = 43, XR = 47;
function RNe() {
  return this.Raw(this.consumeUntilExclamationMarkOrSemicolon, !0);
}
function PNe() {
  return this.Raw(this.consumeUntilExclamationMarkOrSemicolon, !1);
}
function LNe() {
  const t = this.tokenIndex, e = this.Value();
  return e.type !== "Raw" && this.eof === !1 && this.tokenType !== ss && this.isDelim(aU) === !1 && this.isBalanceEdge(t) === !1 && this.error(), e;
}
const MNe = "Declaration", ONe = "declaration", BNe = {
  important: [Boolean, String],
  property: String,
  value: ["Value", "Raw"]
};
function oU() {
  const t = this.tokenStart, e = this.tokenIndex, n = HNe.call(this), r = ZC(n), i = r ? this.parseCustomProperty : this.parseValue, s = r ? PNe : RNe;
  let a = !1, o;
  this.skipSC(), this.eat(is);
  const u = this.tokenIndex;
  if (r || this.skipSC(), i ? o = this.parseWithFallback(LNe, s) : o = s.call(this, this.tokenIndex), r && o.type === "Value" && o.children.isEmpty) {
    for (let l = u - this.tokenIndex; l <= 0; l++)
      if (this.lookupType(l) === Lr) {
        o.children.appendData({
          type: "WhiteSpace",
          loc: null,
          value: " "
        });
        break;
      }
  }
  return this.isDelim(aU) && (a = UNe.call(this), this.skipSC()), this.eof === !1 && this.tokenType !== ss && this.isBalanceEdge(e) === !1 && this.error(), {
    type: "Declaration",
    loc: this.getLocation(t, this.tokenStart),
    important: a,
    property: n,
    value: o
  };
}
function $Ne(t) {
  this.token(He, t.property), this.token(is, ":"), this.node(t.value), t.important && (this.token(hn, "!"), this.token(He, t.important === !0 ? "important" : t.important));
}
function HNe() {
  const t = this.tokenStart;
  if (this.tokenType === hn)
    switch (this.charCodeAt(this.tokenStart)) {
      case DNe:
      case _Ne:
      case INe:
      case kNe:
      case NNe:
        this.next();
        break;
      // TODO: not sure we should support this hack
      case XR:
        this.next(), this.isDelim(XR) && this.next();
        break;
    }
  return this.tokenType === or ? this.eat(or) : this.eat(He), this.substrToCursor(t);
}
function UNe() {
  this.eat(hn), this.skipSC();
  const t = this.consume(He);
  return t === "important" ? !0 : t;
}
const GNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: $Ne,
  name: MNe,
  parse: oU,
  structure: BNe,
  walkContext: ONe
}, Symbol.toStringTag, { value: "Module" })), WNe = 38;
function Gw() {
  return this.Raw(this.consumeUntilSemicolonIncluded, !0);
}
const VNe = "DeclarationList", KNe = {
  children: [[
    "Declaration",
    "Atrule",
    "Rule"
  ]]
};
function uU() {
  const t = this.createList();
  for (; !this.eof; )
    switch (this.tokenType) {
      case Lr:
      case Ki:
      case ss:
        this.next();
        break;
      case ri:
        t.push(this.parseWithFallback(this.Atrule.bind(this, !0), Gw));
        break;
      default:
        this.isDelim(WNe) ? t.push(this.parseWithFallback(this.Rule, Gw)) : t.push(this.parseWithFallback(this.Declaration, Gw));
    }
  return {
    type: "DeclarationList",
    loc: this.getLocationFromList(t),
    children: t
  };
}
function zNe(t) {
  this.children(t, (e) => {
    e.type === "Declaration" && this.token(ss, ";");
  });
}
const jNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: zNe,
  name: VNe,
  parse: uU,
  structure: KNe
}, Symbol.toStringTag, { value: "Module" })), YNe = "Dimension", qNe = {
  value: String,
  unit: String
};
function lU() {
  const t = this.tokenStart, e = this.consumeNumber(cn);
  return {
    type: "Dimension",
    loc: this.getLocation(t, this.tokenStart),
    value: e,
    unit: this.substring(t + e.length, this.tokenStart)
  };
}
function JNe(t) {
  this.token(cn, t.value + t.unit);
}
const QNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: JNe,
  name: YNe,
  parse: lU,
  structure: qNe
}, Symbol.toStringTag, { value: "Module" })), XNe = 47, ZNe = "Feature", eDe = {
  kind: String,
  name: String,
  value: ["Identifier", "Number", "Dimension", "Ratio", "Function", null]
};
function cU(t) {
  const e = this.tokenStart;
  let n, r = null;
  if (this.eat(kn), this.skipSC(), n = this.consume(He), this.skipSC(), this.tokenType !== yt) {
    switch (this.eat(is), this.skipSC(), this.tokenType) {
      case wt:
        this.lookupNonWSType(1) === hn ? r = this.Ratio() : r = this.Number();
        break;
      case cn:
        r = this.Dimension();
        break;
      case He:
        r = this.Identifier();
        break;
      case Rt:
        r = this.parseWithFallback(
          () => {
            const i = this.Function(this.readSequence, this.scope.Value);
            return this.skipSC(), this.isDelim(XNe) && this.error(), i;
          },
          () => this.Ratio()
        );
        break;
      default:
        this.error("Number, dimension, ratio or identifier is expected");
    }
    this.skipSC();
  }
  return this.eof || this.eat(yt), {
    type: "Feature",
    loc: this.getLocation(e, this.tokenStart),
    kind: t,
    name: n,
    value: r
  };
}
function tDe(t) {
  this.token(kn, "("), this.token(He, t.name), t.value !== null && (this.token(is, ":"), this.node(t.value)), this.token(yt, ")");
}
const nDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: tDe,
  name: ZNe,
  parse: cU,
  structure: eDe
}, Symbol.toStringTag, { value: "Module" })), rDe = "FeatureFunction", iDe = {
  kind: String,
  feature: String,
  value: ["Declaration", "Selector"]
};
function sDe(t, e) {
  const r = (this.features[t] || {})[e];
  return typeof r != "function" && this.error(`Unknown feature ${e}()`), r;
}
function hU(t = "unknown") {
  const e = this.tokenStart, n = this.consumeFunctionName(), r = sDe.call(this, t, n.toLowerCase());
  this.skipSC();
  const i = this.parseWithFallback(
    () => {
      const s = this.tokenIndex, a = r.call(this);
      return this.eof === !1 && this.isBalanceEdge(s) === !1 && this.error(), a;
    },
    () => this.Raw(null, !1)
  );
  return this.eof || this.eat(yt), {
    type: "FeatureFunction",
    loc: this.getLocation(e, this.tokenStart),
    kind: t,
    feature: n,
    value: i
  };
}
function aDe(t) {
  this.token(Rt, t.feature + "("), this.node(t.value), this.token(yt, ")");
}
const oDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: aDe,
  name: rDe,
  parse: hU,
  structure: iDe
}, Symbol.toStringTag, { value: "Module" })), ZR = 47, uDe = 60, eP = 61, lDe = 62, cDe = "FeatureRange", hDe = {
  kind: String,
  left: ["Identifier", "Number", "Dimension", "Ratio", "Function"],
  leftComparison: String,
  middle: ["Identifier", "Number", "Dimension", "Ratio", "Function"],
  rightComparison: [String, null],
  right: ["Identifier", "Number", "Dimension", "Ratio", "Function", null]
};
function Ww() {
  switch (this.skipSC(), this.tokenType) {
    case wt:
      return this.isDelim(ZR, this.lookupOffsetNonSC(1)) ? this.Ratio() : this.Number();
    case cn:
      return this.Dimension();
    case He:
      return this.Identifier();
    case Rt:
      return this.parseWithFallback(
        () => {
          const t = this.Function(this.readSequence, this.scope.Value);
          return this.skipSC(), this.isDelim(ZR) && this.error(), t;
        },
        () => this.Ratio()
      );
    default:
      this.error("Number, dimension, ratio or identifier is expected");
  }
}
function tP(t) {
  if (this.skipSC(), this.isDelim(uDe) || this.isDelim(lDe)) {
    const e = this.source[this.tokenStart];
    return this.next(), this.isDelim(eP) ? (this.next(), e + "=") : e;
  }
  if (this.isDelim(eP))
    return "=";
  this.error(`Expected ${t ? '":", ' : ""}"<", ">", "=" or ")"`);
}
function dU(t = "unknown") {
  const e = this.tokenStart;
  this.skipSC(), this.eat(kn);
  const n = Ww.call(this), r = tP.call(this, n.type === "Identifier"), i = Ww.call(this);
  let s = null, a = null;
  return this.lookupNonWSType(0) !== yt && (s = tP.call(this), a = Ww.call(this)), this.skipSC(), this.eat(yt), {
    type: "FeatureRange",
    loc: this.getLocation(e, this.tokenStart),
    kind: t,
    left: n,
    leftComparison: r,
    middle: i,
    rightComparison: s,
    right: a
  };
}
function dDe(t) {
  this.token(kn, "("), this.node(t.left), this.tokenize(t.leftComparison), this.node(t.middle), t.right && (this.tokenize(t.rightComparison), this.node(t.right)), this.token(yt, ")");
}
const fDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: dDe,
  name: cDe,
  parse: dU,
  structure: hDe
}, Symbol.toStringTag, { value: "Module" })), mDe = "Function", gDe = "function", pDe = {
  name: String,
  children: [[]]
};
function fU(t, e) {
  const n = this.tokenStart, r = this.consumeFunctionName(), i = r.toLowerCase();
  let s;
  return s = e.hasOwnProperty(i) ? e[i].call(this, e) : t.call(this, e), this.eof || this.eat(yt), {
    type: "Function",
    loc: this.getLocation(n, this.tokenStart),
    name: r,
    children: s
  };
}
function bDe(t) {
  this.token(Rt, t.name + "("), this.children(t), this.token(yt, ")");
}
const yDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: bDe,
  name: mDe,
  parse: fU,
  structure: pDe,
  walkContext: gDe
}, Symbol.toStringTag, { value: "Module" })), ADe = "GeneralEnclosed", EDe = {
  kind: String,
  function: [String, null],
  children: [[]]
};
function mU(t) {
  const e = this.tokenStart;
  let n = null;
  this.tokenType === Rt ? n = this.consumeFunctionName() : this.eat(kn);
  const r = this.parseWithFallback(
    () => {
      const i = this.tokenIndex, s = this.readSequence(this.scope.Value);
      return this.eof === !1 && this.isBalanceEdge(i) === !1 && this.error(), s;
    },
    () => this.createSingleNodeList(
      this.Raw(null, !1)
    )
  );
  return this.eof || this.eat(yt), {
    type: "GeneralEnclosed",
    loc: this.getLocation(e, this.tokenStart),
    kind: t,
    function: n,
    children: r
  };
}
function SDe(t) {
  t.function ? this.token(Rt, t.function + "(") : this.token(kn, "("), this.children(t), this.token(yt, ")");
}
const wDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: SDe,
  name: ADe,
  parse: mU,
  structure: EDe
}, Symbol.toStringTag, { value: "Module" })), FDe = "XXX", TDe = "Hash", vDe = {
  value: String
};
function gU() {
  const t = this.tokenStart;
  return this.eat(or), {
    type: "Hash",
    loc: this.getLocation(t, this.tokenStart),
    value: this.substrToCursor(t + 1)
  };
}
function xDe(t) {
  this.token(or, "#" + t.value);
}
const CDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: xDe,
  name: TDe,
  parse: gU,
  structure: vDe,
  xxx: FDe
}, Symbol.toStringTag, { value: "Module" })), kDe = "Identifier", _De = {
  name: String
};
function pU() {
  return {
    type: "Identifier",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    name: this.consume(He)
  };
}
function NDe(t) {
  this.token(He, t.name);
}
const DDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: NDe,
  name: kDe,
  parse: pU,
  structure: _De
}, Symbol.toStringTag, { value: "Module" })), IDe = "IdSelector", RDe = {
  name: String
};
function bU() {
  const t = this.tokenStart;
  return this.eat(or), {
    type: "IdSelector",
    loc: this.getLocation(t, this.tokenStart),
    name: this.substrToCursor(t + 1)
  };
}
function PDe(t) {
  this.token(hn, "#" + t.name);
}
const LDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: PDe,
  name: IDe,
  parse: bU,
  structure: RDe
}, Symbol.toStringTag, { value: "Module" })), MDe = 46, ODe = "Layer", BDe = {
  name: String
};
function yU() {
  let t = this.tokenStart, e = this.consume(He);
  for (; this.isDelim(MDe); )
    this.eat(hn), e += "." + this.consume(He);
  return {
    type: "Layer",
    loc: this.getLocation(t, this.tokenStart),
    name: e
  };
}
function $De(t) {
  this.tokenize(t.name);
}
const HDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: $De,
  name: ODe,
  parse: yU,
  structure: BDe
}, Symbol.toStringTag, { value: "Module" })), UDe = "LayerList", GDe = {
  children: [[
    "Layer"
  ]]
};
function AU() {
  const t = this.createList();
  for (this.skipSC(); !this.eof && (t.push(this.Layer()), this.lookupTypeNonSC(0) === Gs); )
    this.skipSC(), this.next(), this.skipSC();
  return {
    type: "LayerList",
    loc: this.getLocationFromList(t),
    children: t
  };
}
function WDe(t) {
  this.children(t, () => this.token(Gs, ","));
}
const VDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: WDe,
  name: UDe,
  parse: AU,
  structure: GDe
}, Symbol.toStringTag, { value: "Module" })), KDe = "MediaQuery", zDe = {
  modifier: [String, null],
  mediaType: [String, null],
  condition: ["Condition", null]
};
function EU() {
  const t = this.tokenStart;
  let e = null, n = null, r = null;
  if (this.skipSC(), this.tokenType === He && this.lookupTypeNonSC(1) !== kn) {
    const i = this.consume(He), s = i.toLowerCase();
    switch (s === "not" || s === "only" ? (this.skipSC(), e = s, n = this.consume(He)) : n = i, this.lookupTypeNonSC(0)) {
      case He: {
        this.skipSC(), this.eatIdent("and"), r = this.Condition("media");
        break;
      }
      case Ri:
      case ss:
      case Gs:
      case Nl:
        break;
      default:
        this.error("Identifier or parenthesis is expected");
    }
  } else
    switch (this.tokenType) {
      case He:
      case kn:
      case Rt: {
        r = this.Condition("media");
        break;
      }
      case Ri:
      case ss:
      case Nl:
        break;
      default:
        this.error("Identifier or parenthesis is expected");
    }
  return {
    type: "MediaQuery",
    loc: this.getLocation(t, this.tokenStart),
    modifier: e,
    mediaType: n,
    condition: r
  };
}
function jDe(t) {
  t.mediaType ? (t.modifier && this.token(He, t.modifier), this.token(He, t.mediaType), t.condition && (this.token(He, "and"), this.node(t.condition))) : t.condition && this.node(t.condition);
}
const YDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: jDe,
  name: KDe,
  parse: EU,
  structure: zDe
}, Symbol.toStringTag, { value: "Module" })), qDe = "MediaQueryList", JDe = {
  children: [[
    "MediaQuery"
  ]]
};
function SU() {
  const t = this.createList();
  for (this.skipSC(); !this.eof && (t.push(this.MediaQuery()), this.tokenType === Gs); )
    this.next();
  return {
    type: "MediaQueryList",
    loc: this.getLocationFromList(t),
    children: t
  };
}
function QDe(t) {
  this.children(t, () => this.token(Gs, ","));
}
const XDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: QDe,
  name: qDe,
  parse: SU,
  structure: JDe
}, Symbol.toStringTag, { value: "Module" })), ZDe = 38, eIe = "NestingSelector", tIe = {};
function wU() {
  const t = this.tokenStart;
  return this.eatDelim(ZDe), {
    type: "NestingSelector",
    loc: this.getLocation(t, this.tokenStart)
  };
}
function nIe() {
  this.token(hn, "&");
}
const rIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: nIe,
  name: eIe,
  parse: wU,
  structure: tIe
}, Symbol.toStringTag, { value: "Module" })), iIe = "Nth", sIe = {
  nth: ["AnPlusB", "Identifier"],
  selector: ["SelectorList", null]
};
function FU() {
  this.skipSC();
  const t = this.tokenStart;
  let e = t, n = null, r;
  return this.lookupValue(0, "odd") || this.lookupValue(0, "even") ? r = this.Identifier() : r = this.AnPlusB(), e = this.tokenStart, this.skipSC(), this.lookupValue(0, "of") && (this.next(), n = this.SelectorList(), e = this.tokenStart), {
    type: "Nth",
    loc: this.getLocation(t, e),
    nth: r,
    selector: n
  };
}
function aIe(t) {
  this.node(t.nth), t.selector !== null && (this.token(He, "of"), this.node(t.selector));
}
const oIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: aIe,
  name: iIe,
  parse: FU,
  structure: sIe
}, Symbol.toStringTag, { value: "Module" })), uIe = "Number", lIe = {
  value: String
};
function TU() {
  return {
    type: "Number",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consume(wt)
  };
}
function cIe(t) {
  this.token(wt, t.value);
}
const hIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: cIe,
  name: uIe,
  parse: TU,
  structure: lIe
}, Symbol.toStringTag, { value: "Module" })), dIe = "Operator", fIe = {
  value: String
};
function vU() {
  const t = this.tokenStart;
  return this.next(), {
    type: "Operator",
    loc: this.getLocation(t, this.tokenStart),
    value: this.substrToCursor(t)
  };
}
function mIe(t) {
  this.tokenize(t.value);
}
const gIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: mIe,
  name: dIe,
  parse: vU,
  structure: fIe
}, Symbol.toStringTag, { value: "Module" })), pIe = "Parentheses", bIe = {
  children: [[]]
};
function xU(t, e) {
  const n = this.tokenStart;
  let r = null;
  return this.eat(kn), r = t.call(this, e), this.eof || this.eat(yt), {
    type: "Parentheses",
    loc: this.getLocation(n, this.tokenStart),
    children: r
  };
}
function yIe(t) {
  this.token(kn, "("), this.children(t), this.token(yt, ")");
}
const AIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: yIe,
  name: pIe,
  parse: xU,
  structure: bIe
}, Symbol.toStringTag, { value: "Module" })), EIe = "Percentage", SIe = {
  value: String
};
function CU() {
  return {
    type: "Percentage",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consumeNumber(Dr)
  };
}
function wIe(t) {
  this.token(Dr, t.value + "%");
}
const FIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: wIe,
  name: EIe,
  parse: CU,
  structure: SIe
}, Symbol.toStringTag, { value: "Module" })), TIe = "PseudoClassSelector", vIe = "function", xIe = {
  name: String,
  children: [["Raw"], null]
};
function kU() {
  const t = this.tokenStart;
  let e = null, n, r;
  return this.eat(is), this.tokenType === Rt ? (n = this.consumeFunctionName(), r = n.toLowerCase(), this.lookupNonWSType(0) == yt ? e = this.createList() : hasOwnProperty.call(this.pseudo, r) ? (this.skipSC(), e = this.pseudo[r].call(this), this.skipSC()) : (e = this.createList(), e.push(
    this.Raw(null, !1)
  )), this.eat(yt)) : n = this.consume(He), {
    type: "PseudoClassSelector",
    loc: this.getLocation(t, this.tokenStart),
    name: n,
    children: e
  };
}
function CIe(t) {
  this.token(is, ":"), t.children === null ? this.token(He, t.name) : (this.token(Rt, t.name + "("), this.children(t), this.token(yt, ")"));
}
const kIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: CIe,
  name: TIe,
  parse: kU,
  structure: xIe,
  walkContext: vIe
}, Symbol.toStringTag, { value: "Module" })), _Ie = "PseudoElementSelector", NIe = "function", DIe = {
  name: String,
  children: [["Raw"], null]
};
function _U() {
  const t = this.tokenStart;
  let e = null, n, r;
  return this.eat(is), this.eat(is), this.tokenType === Rt ? (n = this.consumeFunctionName(), r = n.toLowerCase(), this.lookupNonWSType(0) == yt ? e = this.createList() : hasOwnProperty.call(this.pseudo, r) ? (this.skipSC(), e = this.pseudo[r].call(this), this.skipSC()) : (e = this.createList(), e.push(
    this.Raw(null, !1)
  )), this.eat(yt)) : n = this.consume(He), {
    type: "PseudoElementSelector",
    loc: this.getLocation(t, this.tokenStart),
    name: n,
    children: e
  };
}
function IIe(t) {
  this.token(is, ":"), this.token(is, ":"), t.children === null ? this.token(He, t.name) : (this.token(Rt, t.name + "("), this.children(t), this.token(yt, ")"));
}
const RIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: IIe,
  name: _Ie,
  parse: _U,
  structure: DIe,
  walkContext: NIe
}, Symbol.toStringTag, { value: "Module" })), nP = 47;
function rP() {
  switch (this.skipSC(), this.tokenType) {
    case wt:
      return this.Number();
    case Rt:
      return this.Function(this.readSequence, this.scope.Value);
    default:
      this.error("Number of function is expected");
  }
}
const PIe = "Ratio", LIe = {
  left: ["Number", "Function"],
  right: ["Number", "Function", null]
};
function NU() {
  const t = this.tokenStart, e = rP.call(this);
  let n = null;
  return this.skipSC(), this.isDelim(nP) && (this.eatDelim(nP), n = rP.call(this)), {
    type: "Ratio",
    loc: this.getLocation(t, this.tokenStart),
    left: e,
    right: n
  };
}
function MIe(t) {
  this.node(t.left), this.token(hn, "/"), t.right ? this.node(t.right) : this.node(wt, 1);
}
const OIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: MIe,
  name: PIe,
  parse: NU,
  structure: LIe
}, Symbol.toStringTag, { value: "Module" }));
function BIe() {
  return this.tokenIndex > 0 && this.lookupType(-1) === Lr ? this.tokenIndex > 1 ? this.getTokenStart(this.tokenIndex - 1) : this.firstCharOffset : this.tokenStart;
}
const $Ie = "Raw", HIe = {
  value: String
};
function DU(t, e) {
  const n = this.getTokenStart(this.tokenIndex);
  let r;
  return this.skipUntilBalanced(this.tokenIndex, t || this.consumeUntilBalanceEnd), e && this.tokenStart > n ? r = BIe.call(this) : r = this.tokenStart, {
    type: "Raw",
    loc: this.getLocation(n, r),
    value: this.substring(n, r)
  };
}
function UIe(t) {
  this.tokenize(t.value);
}
const GIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: UIe,
  name: $Ie,
  parse: DU,
  structure: HIe
}, Symbol.toStringTag, { value: "Module" }));
function iP() {
  return this.Raw(this.consumeUntilLeftCurlyBracket, !0);
}
function WIe() {
  const t = this.SelectorList();
  return t.type !== "Raw" && this.eof === !1 && this.tokenType !== Ri && this.error(), t;
}
const VIe = "Rule", KIe = "rule", zIe = {
  prelude: ["SelectorList", "Raw"],
  block: ["Block"]
};
function IU() {
  const t = this.tokenIndex, e = this.tokenStart;
  let n, r;
  return this.parseRulePrelude ? n = this.parseWithFallback(WIe, iP) : n = iP.call(this, t), r = this.Block(!0), {
    type: "Rule",
    loc: this.getLocation(e, this.tokenStart),
    prelude: n,
    block: r
  };
}
function jIe(t) {
  this.node(t.prelude), this.node(t.block);
}
const YIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: jIe,
  name: VIe,
  parse: IU,
  structure: zIe,
  walkContext: KIe
}, Symbol.toStringTag, { value: "Module" })), qIe = "Scope", JIe = {
  root: ["SelectorList", "Raw", null],
  limit: ["SelectorList", "Raw", null]
};
function RU() {
  let t = null, e = null;
  this.skipSC();
  const n = this.tokenStart;
  return this.tokenType === kn && (this.next(), this.skipSC(), t = this.parseWithFallback(
    this.SelectorList,
    () => this.Raw(!1, !0)
  ), this.skipSC(), this.eat(yt)), this.lookupNonWSType(0) === He && (this.skipSC(), this.eatIdent("to"), this.skipSC(), this.eat(kn), this.skipSC(), e = this.parseWithFallback(
    this.SelectorList,
    () => this.Raw(!1, !0)
  ), this.skipSC(), this.eat(yt)), {
    type: "Scope",
    loc: this.getLocation(n, this.tokenStart),
    root: t,
    limit: e
  };
}
function QIe(t) {
  t.root && (this.token(kn, "("), this.node(t.root), this.token(yt, ")")), t.limit && (this.token(He, "to"), this.token(kn, "("), this.node(t.limit), this.token(yt, ")"));
}
const XIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: QIe,
  name: qIe,
  parse: RU,
  structure: JIe
}, Symbol.toStringTag, { value: "Module" })), ZIe = "Selector", eRe = {
  children: [[
    "TypeSelector",
    "IdSelector",
    "ClassSelector",
    "AttributeSelector",
    "PseudoClassSelector",
    "PseudoElementSelector",
    "Combinator"
  ]]
};
function PU() {
  const t = this.readSequence(this.scope.Selector);
  return this.getFirstListNode(t) === null && this.error("Selector is expected"), {
    type: "Selector",
    loc: this.getLocationFromList(t),
    children: t
  };
}
function tRe(t) {
  this.children(t);
}
const nRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: tRe,
  name: ZIe,
  parse: PU,
  structure: eRe
}, Symbol.toStringTag, { value: "Module" })), rRe = "SelectorList", iRe = "selector", sRe = {
  children: [[
    "Selector",
    "Raw"
  ]]
};
function LU() {
  const t = this.createList();
  for (; !this.eof; ) {
    if (t.push(this.Selector()), this.tokenType === Gs) {
      this.next();
      continue;
    }
    break;
  }
  return {
    type: "SelectorList",
    loc: this.getLocationFromList(t),
    children: t
  };
}
function aRe(t) {
  this.children(t, () => this.token(Gs, ","));
}
const oRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: aRe,
  name: rRe,
  parse: LU,
  structure: sRe,
  walkContext: iRe
}, Symbol.toStringTag, { value: "Module" })), ov = 92, MU = 34, uRe = 39;
function OU(t) {
  const e = t.length, n = t.charCodeAt(0), r = n === MU || n === uRe ? 1 : 0, i = r === 1 && e > 1 && t.charCodeAt(e - 1) === n ? e - 2 : e - 1;
  let s = "";
  for (let a = r; a <= i; a++) {
    let o = t.charCodeAt(a);
    if (o === ov) {
      if (a === i) {
        a !== e - 1 && (s = t.substr(a + 1));
        break;
      }
      if (o = t.charCodeAt(++a), ou(ov, o)) {
        const u = a - 1, l = yf(t, u);
        a = l - 1, s += wH(t.substring(u + 1, l));
      } else
        o === 13 && t.charCodeAt(a + 1) === 10 && a++;
    } else
      s += t[a];
  }
  return s;
}
function lRe(t, e) {
  const r = MU;
  let i = "", s = !1;
  for (let a = 0; a < t.length; a++) {
    const o = t.charCodeAt(a);
    if (o === 0) {
      i += "�";
      continue;
    }
    if (o <= 31 || o === 127) {
      i += "\\" + o.toString(16), s = !0;
      continue;
    }
    o === r || o === ov ? (i += "\\" + t.charAt(a), s = !1) : (s && (yc(o) || wh(o)) && (i += " "), i += t.charAt(a), s = !1);
  }
  return '"' + i + '"';
}
const cRe = "String", hRe = {
  value: String
};
function BU() {
  return {
    type: "String",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: OU(this.consume(Po))
  };
}
function dRe(t) {
  this.token(Po, lRe(t.value));
}
const fRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: dRe,
  name: cRe,
  parse: BU,
  structure: hRe
}, Symbol.toStringTag, { value: "Module" })), mRe = 33;
function sP() {
  return this.Raw(null, !1);
}
const gRe = "StyleSheet", pRe = "stylesheet", bRe = {
  children: [[
    "Comment",
    "CDO",
    "CDC",
    "Atrule",
    "Rule",
    "Raw"
  ]]
};
function $U() {
  const t = this.tokenStart, e = this.createList();
  let n;
  for (; !this.eof; ) {
    switch (this.tokenType) {
      case Lr:
        this.next();
        continue;
      case Ki:
        if (this.charCodeAt(this.tokenStart + 2) !== mRe) {
          this.next();
          continue;
        }
        n = this.Comment();
        break;
      case cp:
        n = this.CDO();
        break;
      case Is:
        n = this.CDC();
        break;
      // CSS Syntax Module Level 3
      // §2.2 Error handling
      // At the "top level" of a stylesheet, an <at-keyword-token> starts an at-rule.
      case ri:
        n = this.parseWithFallback(this.Atrule, sP);
        break;
      // Anything else starts a qualified rule ...
      default:
        n = this.parseWithFallback(this.Rule, sP);
    }
    e.push(n);
  }
  return {
    type: "StyleSheet",
    loc: this.getLocation(t, this.tokenStart),
    children: e
  };
}
function yRe(t) {
  this.children(t);
}
const ARe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: yRe,
  name: gRe,
  parse: $U,
  structure: bRe,
  walkContext: pRe
}, Symbol.toStringTag, { value: "Module" })), ERe = "SupportsDeclaration", SRe = {
  declaration: "Declaration"
};
function HU() {
  const t = this.tokenStart;
  this.eat(kn), this.skipSC();
  const e = this.Declaration();
  return this.eof || this.eat(yt), {
    type: "SupportsDeclaration",
    loc: this.getLocation(t, this.tokenStart),
    declaration: e
  };
}
function wRe(t) {
  this.token(kn, "("), this.node(t.declaration), this.token(yt, ")");
}
const FRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: wRe,
  name: ERe,
  parse: HU,
  structure: SRe
}, Symbol.toStringTag, { value: "Module" })), TRe = 42, aP = 124;
function Vw() {
  this.tokenType !== He && this.isDelim(TRe) === !1 && this.error("Identifier or asterisk is expected"), this.next();
}
const vRe = "TypeSelector", xRe = {
  name: String
};
function UU() {
  const t = this.tokenStart;
  return this.isDelim(aP) ? (this.next(), Vw.call(this)) : (Vw.call(this), this.isDelim(aP) && (this.next(), Vw.call(this))), {
    type: "TypeSelector",
    loc: this.getLocation(t, this.tokenStart),
    name: this.substrToCursor(t)
  };
}
function CRe(t) {
  this.tokenize(t.name);
}
const kRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: CRe,
  name: vRe,
  parse: UU,
  structure: xRe
}, Symbol.toStringTag, { value: "Module" })), GU = 43, WU = 45, uv = 63;
function Om(t, e) {
  let n = 0;
  for (let r = this.tokenStart + t; r < this.tokenEnd; r++) {
    const i = this.charCodeAt(r);
    if (i === WU && e && n !== 0)
      return Om.call(this, t + n + 1, !1), -1;
    yc(i) || this.error(
      e && n !== 0 ? "Hyphen minus" + (n < 6 ? " or hex digit" : "") + " is expected" : n < 6 ? "Hex digit is expected" : "Unexpected input",
      r
    ), ++n > 6 && this.error("Too many hex digits", r);
  }
  return this.next(), n;
}
function H0(t) {
  let e = 0;
  for (; this.isDelim(uv); )
    ++e > t && this.error("Too many question marks"), this.next();
}
function _Re(t) {
  this.charCodeAt(this.tokenStart) !== t && this.error((t === GU ? "Plus sign" : "Hyphen minus") + " is expected");
}
function NRe() {
  let t = 0;
  switch (this.tokenType) {
    case wt:
      if (t = Om.call(this, 1, !0), this.isDelim(uv)) {
        H0.call(this, 6 - t);
        break;
      }
      if (this.tokenType === cn || this.tokenType === wt) {
        _Re.call(this, WU), Om.call(this, 1, !1);
        break;
      }
      break;
    case cn:
      t = Om.call(this, 1, !0), t > 0 && H0.call(this, 6 - t);
      break;
    default:
      if (this.eatDelim(GU), this.tokenType === He) {
        t = Om.call(this, 0, !0), t > 0 && H0.call(this, 6 - t);
        break;
      }
      if (this.isDelim(uv)) {
        this.next(), H0.call(this, 5);
        break;
      }
      this.error("Hex digit or question mark is expected");
  }
}
const DRe = "UnicodeRange", IRe = {
  value: String
};
function VU() {
  const t = this.tokenStart;
  return this.eatIdent("u"), NRe.call(this), {
    type: "UnicodeRange",
    loc: this.getLocation(t, this.tokenStart),
    value: this.substrToCursor(t)
  };
}
function RRe(t) {
  this.tokenize(t.value);
}
const PRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: RRe,
  name: DRe,
  parse: VU,
  structure: IRe
}, Symbol.toStringTag, { value: "Module" })), LRe = 32, lv = 92, MRe = 34, ORe = 39, BRe = 40, KU = 41;
function $Re(t) {
  const e = t.length;
  let n = 4, r = t.charCodeAt(e - 1) === KU ? e - 2 : e - 1, i = "";
  for (; n < r && wh(t.charCodeAt(n)); )
    n++;
  for (; n < r && wh(t.charCodeAt(r)); )
    r--;
  for (let s = n; s <= r; s++) {
    let a = t.charCodeAt(s);
    if (a === lv) {
      if (s === r) {
        s !== e - 1 && (i = t.substr(s + 1));
        break;
      }
      if (a = t.charCodeAt(++s), ou(lv, a)) {
        const o = s - 1, u = yf(t, o);
        s = u - 1, i += wH(t.substring(o + 1, u));
      } else
        a === 13 && t.charCodeAt(s + 1) === 10 && s++;
    } else
      i += t[s];
  }
  return i;
}
function HRe(t) {
  let e = "", n = !1;
  for (let r = 0; r < t.length; r++) {
    const i = t.charCodeAt(r);
    if (i === 0) {
      e += "�";
      continue;
    }
    if (i <= 31 || i === 127) {
      e += "\\" + i.toString(16), n = !0;
      continue;
    }
    i === LRe || i === lv || i === MRe || i === ORe || i === BRe || i === KU ? (e += "\\" + t.charAt(r), n = !1) : (n && yc(i) && (e += " "), e += t.charAt(r), n = !1);
  }
  return "url(" + e + ")";
}
const URe = "Url", GRe = {
  value: String
};
function zU() {
  const t = this.tokenStart;
  let e;
  switch (this.tokenType) {
    case Xi:
      e = $Re(this.consume(Xi));
      break;
    case Rt:
      this.cmpStr(this.tokenStart, this.tokenEnd, "url(") || this.error("Function name must be `url`"), this.eat(Rt), this.skipSC(), e = OU(this.consume(Po)), this.skipSC(), this.eof || this.eat(yt);
      break;
    default:
      this.error("Url or Function is expected");
  }
  return {
    type: "Url",
    loc: this.getLocation(t, this.tokenStart),
    value: e
  };
}
function WRe(t) {
  this.token(Xi, HRe(t.value));
}
const VRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: WRe,
  name: URe,
  parse: zU,
  structure: GRe
}, Symbol.toStringTag, { value: "Module" })), KRe = "Value", zRe = {
  children: [[]]
};
function jU() {
  const t = this.tokenStart, e = this.readSequence(this.scope.Value);
  return {
    type: "Value",
    loc: this.getLocation(t, this.tokenStart),
    children: e
  };
}
function jRe(t) {
  this.children(t);
}
const YRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: jRe,
  name: KRe,
  parse: jU,
  structure: zRe
}, Symbol.toStringTag, { value: "Module" })), qRe = Object.freeze({
  type: "WhiteSpace",
  loc: null,
  value: " "
}), JRe = "WhiteSpace", QRe = {
  value: String
};
function YU() {
  return this.eat(Lr), qRe;
}
function XRe(t) {
  this.token(Lr, t.value);
}
const ZRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generate: XRe,
  name: JRe,
  parse: YU,
  structure: QRe
}, Symbol.toStringTag, { value: "Module" })), qU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnPlusB: y3e,
  Atrule: T3e,
  AtrulePrelude: _3e,
  AttributeSelector: B3e,
  Block: K3e,
  Brackets: q3e,
  CDC: Z3e,
  CDO: rNe,
  ClassSelector: uNe,
  Combinator: gNe,
  Comment: SNe,
  Condition: CNe,
  Declaration: GNe,
  DeclarationList: jNe,
  Dimension: QNe,
  Feature: nDe,
  FeatureFunction: oDe,
  FeatureRange: fDe,
  Function: yDe,
  GeneralEnclosed: wDe,
  Hash: CDe,
  IdSelector: LDe,
  Identifier: DDe,
  Layer: HDe,
  LayerList: VDe,
  MediaQuery: YDe,
  MediaQueryList: XDe,
  NestingSelector: rIe,
  Nth: oIe,
  Number: hIe,
  Operator: gIe,
  Parentheses: AIe,
  Percentage: FIe,
  PseudoClassSelector: kIe,
  PseudoElementSelector: RIe,
  Ratio: OIe,
  Raw: GIe,
  Rule: YIe,
  Scope: XIe,
  Selector: nRe,
  SelectorList: oRe,
  String: fRe,
  StyleSheet: ARe,
  SupportsDeclaration: FRe,
  TypeSelector: kRe,
  UnicodeRange: PRe,
  Url: VRe,
  Value: YRe,
  WhiteSpace: ZRe
}, Symbol.toStringTag, { value: "Module" })), ePe = {
  generic: !0,
  cssWideKeywords: e2,
  ...f3e,
  node: qU
}, tPe = 35, nPe = 42, oP = 43, rPe = 45, iPe = 47, sPe = 117;
function JU(t) {
  switch (this.tokenType) {
    case or:
      return this.Hash();
    case Gs:
      return this.Operator();
    case kn:
      return this.Parentheses(this.readSequence, t.recognizer);
    case ca:
      return this.Brackets(this.readSequence, t.recognizer);
    case Po:
      return this.String();
    case cn:
      return this.Dimension();
    case Dr:
      return this.Percentage();
    case wt:
      return this.Number();
    case Rt:
      return this.cmpStr(this.tokenStart, this.tokenEnd, "url(") ? this.Url() : this.Function(this.readSequence, t.recognizer);
    case Xi:
      return this.Url();
    case He:
      return this.cmpChar(this.tokenStart, sPe) && this.cmpChar(this.tokenStart + 1, oP) ? this.UnicodeRange() : this.Identifier();
    case hn: {
      const e = this.charCodeAt(this.tokenStart);
      if (e === iPe || e === nPe || e === oP || e === rPe)
        return this.Operator();
      e === tPe && this.error("Hex or identifier is expected", this.tokenStart + 1);
      break;
    }
  }
}
const aPe = {
  getNode: JU
}, oPe = 35, uPe = 38, lPe = 42, cPe = 43, hPe = 47, uP = 46, dPe = 62, fPe = 124, mPe = 126;
function gPe(t, e) {
  e.last !== null && e.last.type !== "Combinator" && t !== null && t.type !== "Combinator" && e.push({
    // FIXME: this.Combinator() should be used instead
    type: "Combinator",
    loc: null,
    name: " "
  });
}
function pPe() {
  switch (this.tokenType) {
    case ca:
      return this.AttributeSelector();
    case or:
      return this.IdSelector();
    case is:
      return this.lookupType(1) === is ? this.PseudoElementSelector() : this.PseudoClassSelector();
    case He:
      return this.TypeSelector();
    case wt:
    case Dr:
      return this.Percentage();
    case cn:
      this.charCodeAt(this.tokenStart) === uP && this.error("Identifier is expected", this.tokenStart + 1);
      break;
    case hn: {
      switch (this.charCodeAt(this.tokenStart)) {
        case cPe:
        case dPe:
        case mPe:
        case hPe:
          return this.Combinator();
        case uP:
          return this.ClassSelector();
        case lPe:
        case fPe:
          return this.TypeSelector();
        case oPe:
          return this.IdSelector();
        case uPe:
          return this.NestingSelector();
      }
      break;
    }
  }
}
const bPe = {
  onWhiteSpace: gPe,
  getNode: pPe
};
function yPe() {
  return this.createSingleNodeList(
    this.Raw(null, !1)
  );
}
function APe() {
  const t = this.createList();
  if (this.skipSC(), t.push(this.Identifier()), this.skipSC(), this.tokenType === Gs) {
    t.push(this.Operator());
    const e = this.tokenIndex, n = this.parseCustomProperty ? this.Value(null) : this.Raw(this.consumeUntilExclamationMarkOrSemicolon, !1);
    if (n.type === "Value" && n.children.isEmpty) {
      for (let r = e - this.tokenIndex; r <= 0; r++)
        if (this.lookupType(r) === Lr) {
          n.children.appendData({
            type: "WhiteSpace",
            loc: null,
            value: " "
          });
          break;
        }
    }
    t.push(n);
  }
  return t;
}
function lP(t) {
  return t !== null && t.type === "Operator" && (t.value[t.value.length - 1] === "-" || t.value[t.value.length - 1] === "+");
}
const EPe = {
  getNode: JU,
  onWhiteSpace(t, e) {
    lP(t) && (t.value = " " + t.value), lP(e.last) && (e.last.value += " ");
  },
  expression: yPe,
  var: APe
}, SPe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AtrulePrelude: aPe,
  Selector: bPe,
  Value: EPe
}, Symbol.toStringTag, { value: "Module" })), wPe = /* @__PURE__ */ new Set(["none", "and", "not", "or"]), FPe = {
  parse: {
    prelude() {
      const t = this.createList();
      if (this.tokenType === He) {
        const e = this.substring(this.tokenStart, this.tokenEnd);
        wPe.has(e.toLowerCase()) || t.push(this.Identifier());
      }
      return t.push(this.Condition("container")), t;
    },
    block(t = !1) {
      return this.Block(t);
    }
  }
}, TPe = {
  parse: {
    prelude: null,
    block() {
      return this.Block(!0);
    }
  }
};
function Kw(t, e) {
  return this.parseWithFallback(
    () => {
      try {
        return t.call(this);
      } finally {
        this.skipSC(), this.lookupNonWSType(0) !== yt && this.error();
      }
    },
    e || (() => this.Raw(null, !0))
  );
}
const cP = {
  layer() {
    this.skipSC();
    const t = this.createList(), e = Kw.call(this, this.Layer);
    return (e.type !== "Raw" || e.value !== "") && t.push(e), t;
  },
  supports() {
    this.skipSC();
    const t = this.createList(), e = Kw.call(
      this,
      this.Declaration,
      () => Kw.call(this, () => this.Condition("supports"))
    );
    return (e.type !== "Raw" || e.value !== "") && t.push(e), t;
  }
}, vPe = {
  parse: {
    prelude() {
      const t = this.createList();
      switch (this.tokenType) {
        case Po:
          t.push(this.String());
          break;
        case Xi:
        case Rt:
          t.push(this.Url());
          break;
        default:
          this.error("String or url() is expected");
      }
      return this.skipSC(), this.tokenType === He && this.cmpStr(this.tokenStart, this.tokenEnd, "layer") ? t.push(this.Identifier()) : this.tokenType === Rt && this.cmpStr(this.tokenStart, this.tokenEnd, "layer(") && t.push(this.Function(null, cP)), this.skipSC(), this.tokenType === Rt && this.cmpStr(this.tokenStart, this.tokenEnd, "supports(") && t.push(this.Function(null, cP)), (this.lookupNonWSType(0) === He || this.lookupNonWSType(0) === kn) && t.push(this.MediaQueryList()), t;
    },
    block: null
  }
}, xPe = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.LayerList()
      );
    },
    block() {
      return this.Block(!1);
    }
  }
}, CPe = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.MediaQueryList()
      );
    },
    block(t = !1) {
      return this.Block(t);
    }
  }
}, kPe = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.SelectorList()
      );
    },
    block() {
      return this.Block(!0);
    }
  }
}, _Pe = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.SelectorList()
      );
    },
    block() {
      return this.Block(!0);
    }
  }
}, NPe = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.Scope()
      );
    },
    block(t = !1) {
      return this.Block(t);
    }
  }
}, DPe = {
  parse: {
    prelude: null,
    block(t = !1) {
      return this.Block(t);
    }
  }
}, IPe = {
  parse: {
    prelude() {
      return this.createSingleNodeList(
        this.Condition("supports")
      );
    },
    block(t = !1) {
      return this.Block(t);
    }
  }
}, RPe = {
  container: FPe,
  "font-face": TPe,
  import: vPe,
  layer: xPe,
  media: CPe,
  nest: kPe,
  page: _Pe,
  scope: NPe,
  "starting-style": DPe,
  supports: IPe
};
function PPe() {
  const t = this.createList();
  this.skipSC();
  e: for (; !this.eof; ) {
    switch (this.tokenType) {
      case He:
        t.push(this.Identifier());
        break;
      case Po:
        t.push(this.String());
        break;
      case Gs:
        t.push(this.Operator());
        break;
      case yt:
        break e;
      default:
        this.error("Identifier, string or comma is expected");
    }
    this.skipSC();
  }
  return t;
}
const Wc = {
  parse() {
    return this.createSingleNodeList(
      this.SelectorList()
    );
  }
}, zw = {
  parse() {
    return this.createSingleNodeList(
      this.Selector()
    );
  }
}, LPe = {
  parse() {
    return this.createSingleNodeList(
      this.Identifier()
    );
  }
}, MPe = {
  parse: PPe
}, U0 = {
  parse() {
    return this.createSingleNodeList(
      this.Nth()
    );
  }
}, OPe = {
  dir: LPe,
  has: Wc,
  lang: MPe,
  matches: Wc,
  is: Wc,
  "-moz-any": Wc,
  "-webkit-any": Wc,
  where: Wc,
  not: Wc,
  "nth-child": U0,
  "nth-last-child": U0,
  "nth-last-of-type": U0,
  "nth-of-type": U0,
  slotted: zw,
  host: zw,
  "host-context": zw
}, BPe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnPlusB: zH,
  Atrule: jH,
  AtrulePrelude: YH,
  AttributeSelector: JH,
  Block: XH,
  Brackets: ZH,
  CDC: eU,
  CDO: tU,
  ClassSelector: nU,
  Combinator: rU,
  Comment: iU,
  Condition: sU,
  Declaration: oU,
  DeclarationList: uU,
  Dimension: lU,
  Feature: cU,
  FeatureFunction: hU,
  FeatureRange: dU,
  Function: fU,
  GeneralEnclosed: mU,
  Hash: gU,
  IdSelector: bU,
  Identifier: pU,
  Layer: yU,
  LayerList: AU,
  MediaQuery: EU,
  MediaQueryList: SU,
  NestingSelector: wU,
  Nth: FU,
  Number: TU,
  Operator: vU,
  Parentheses: xU,
  Percentage: CU,
  PseudoClassSelector: kU,
  PseudoElementSelector: _U,
  Ratio: NU,
  Raw: DU,
  Rule: IU,
  Scope: RU,
  Selector: PU,
  SelectorList: LU,
  String: BU,
  StyleSheet: $U,
  SupportsDeclaration: HU,
  TypeSelector: UU,
  UnicodeRange: VU,
  Url: zU,
  Value: jU,
  WhiteSpace: YU
}, Symbol.toStringTag, { value: "Module" })), $Pe = {
  parseContext: {
    default: "StyleSheet",
    stylesheet: "StyleSheet",
    atrule: "Atrule",
    atrulePrelude(t) {
      return this.AtrulePrelude(t.atrule ? String(t.atrule) : null);
    },
    mediaQueryList: "MediaQueryList",
    mediaQuery: "MediaQuery",
    condition(t) {
      return this.Condition(t.kind);
    },
    rule: "Rule",
    selectorList: "SelectorList",
    selector: "Selector",
    block() {
      return this.Block(!0);
    },
    declarationList: "DeclarationList",
    declaration: "Declaration",
    value: "Value"
  },
  features: {
    supports: {
      selector() {
        return this.Selector();
      }
    },
    container: {
      style() {
        return this.Declaration();
      }
    }
  },
  scope: SPe,
  atrule: RPe,
  pseudo: OPe,
  node: BPe
}, HPe = {
  node: qU
}, UPe = d3e({
  ...ePe,
  ...$Pe,
  ...HPe
}), {
  tokenize: DVe,
  parse: Fc,
  generate: Es,
  lexer: GPe,
  createLexer: IVe,
  walk: Ac,
  find: RVe,
  findLast: PVe,
  findAll: LVe,
  toPlainObject: MVe,
  fromPlainObject: OVe,
  fork: BVe
} = UPe;
function WPe(t) {
  return t.atrule?.name === "keyframes";
}
function VPe(t) {
  const e = /* @__PURE__ */ new Map(), { propertiesMap: n, varUsagesByProperty: r } = KPe(t, e), i = oLe(t), s = tLe(t);
  return {
    getStateClasses() {
      return i;
    },
    getPropertiesForSelector(a) {
      return n.get(a) ?? [];
    },
    getAllProperties() {
      return n;
    },
    getVarUsages(a) {
      const o = a.startsWith("--") ? a : `--${a}`;
      return [...r.get(o) ?? []];
    },
    getUniqueProperties(a) {
      const o = /* @__PURE__ */ new Map();
      for (const u of a) {
        const l = this.getPropertiesForSelector(u), h = /* @__PURE__ */ new Map();
        for (const f of l)
          h.set(f.name, f.value);
        for (const [f, m] of h)
          o.has(f) || o.set(f, m);
      }
      return o;
    },
    getDomSelector(a) {
      const o = e.get(a);
      return o ? uLe(o) : null;
    },
    getSelectorSpecificity(a) {
      const o = e.get(a);
      return o ? lLe(o) : null;
    },
    getVarPropertyType(a, o) {
      const u = a.startsWith("--") ? a : `--${a}`, l = s.get(u);
      if (l) return l.cssPropertyType;
      const h = this.getVarUsages(a);
      if (h.length === 0) return;
      const f = [...new Set(h)];
      if (f.length === 1) {
        const m = ip(f[0]);
        if (Object.values(Ns.CSS_PROPERTY_TYPE).includes(m)) return m;
      }
      return cLe(o);
    },
    getRegisteredCustomProperties() {
      return new Map(s);
    }
  };
}
function KPe(t, e) {
  const n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = Fc(t, {
    parseCustomProperty: !0,
    parseAtrulePrelude: !1,
    onParseError: (a) => {
      throw a;
    }
  }), s = YPe(i);
  return Ac(i, {
    visit: "Rule",
    enter(a) {
      try {
        const o = [];
        for (const l of a.block.children) {
          if (l.type !== "Declaration") continue;
          const h = zPe(l, r, s);
          h && o.push(h);
        }
        if (o.length === 0) return;
        const u = [];
        if (WPe(this)) {
          const l = this.atrule?.prelude ? Es(this.atrule.prelude).trim() : "";
          if (!l) return;
          const h = Es(a.prelude).trim();
          u.push(`@keyframes ${l} ${h}`);
        } else {
          if (a.prelude.type !== "SelectorList") return;
          for (const l of a.prelude.children) {
            if (l.type !== "Selector") continue;
            const h = Es(l);
            e.set(h, l), u.push(h);
          }
        }
        for (const l of u) {
          const h = n.get(l) ?? [];
          n.set(l, [...h, ...o]);
        }
      } catch {
      }
    }
  }), { propertiesMap: n, varUsagesByProperty: r };
}
function zPe(t, e, n) {
  try {
    const r = t.property;
    if (!r) return null;
    const i = JPe(t.value, n), s = qPe(t.value, n);
    if (!s) return null;
    for (const a of i) {
      const o = e.get(a) ?? /* @__PURE__ */ new Set();
      o.add(r), e.set(a, o);
    }
    return i.length > 0 ? { name: r, value: s, valueAst: t.value, varRefs: i } : { name: r, value: s, valueAst: t.value };
  } catch {
    return null;
  }
}
function QU(t) {
  return { kind: "resolved", value: t };
}
function hP() {
  return { kind: "unresolved" };
}
function jw() {
  return { kind: "invalid" };
}
function Ly(t, e, n) {
  const r = [];
  for (const i of t) {
    const s = XU(i, e, n);
    if (s.kind !== "resolved") return s;
    s.value.length > 0 && r.push(s.value);
  }
  return QU(r.join(" "));
}
function jPe(t, e, n) {
  const r = [...t.children], i = r.findIndex(
    (h) => h.type === "Operator" && h.value === ","
  ), s = i === -1 ? r : r.slice(0, i), a = i === -1 ? [] : r.slice(i + 1), o = s.map((h) => Es(h)).join("").trim(), u = o.startsWith("--") ? o : `--${o}`;
  if (n.has(u))
    return jw();
  const l = e[u];
  if (l !== void 0)
    try {
      const h = Fc(l, { context: "value" }), f = new Set(n);
      f.add(u);
      const m = Ly(
        [...h.children],
        e,
        f
      );
      return m.kind === "resolved" ? m : m.kind === "invalid" ? a.length > 0 ? Ly(a, e, n) : jw() : hP();
    } catch {
      return jw();
    }
  return a.length > 0 ? Ly(a, e, n) : hP();
}
function XU(t, e, n) {
  return t.type === "Value" ? Ly([...t.children], e, n) : t.type === "Function" && t.name === "var" ? jPe(t, e, n) : QU(Es(t).trim());
}
function ZU(t, e) {
  if (!t.valueAst || !t.varRefs || t.varRefs.length === 0)
    return t.value;
  const n = XU(t.valueAst, e, /* @__PURE__ */ new Set());
  return n.kind === "resolved" ? n.value : void 0;
}
function YPe(t) {
  const e = /* @__PURE__ */ new Map();
  return Ac(t, {
    visit: "Atrule",
    enter(n) {
      if (n.name !== "value" || n.block !== null || !n.prelude) return;
      const i = Es(n.prelude).trim().match(/^([\w-]+)\s*:\s*(--[\w-]+)\s*$/);
      i && e.set(i[1], i[2]);
    }
  }), e;
}
function qPe(t, e) {
  return Ac(t, {
    visit: "Function",
    enter(n) {
      if (n.name !== "var") return;
      const r = n.children.first;
      r?.type === "Identifier" && !r.name.startsWith("--") && (r.name = e.get(r.name) ?? `--${r.name}`);
    }
  }), Es(t);
}
function JPe(t, e) {
  const n = [];
  return Ac(t, {
    visit: "Function",
    enter(r) {
      if (r.name !== "var") return;
      const i = r.children.first;
      if (i && i.type === "Identifier") {
        const s = i.name;
        n.push(s.startsWith("--") ? s : e.get(s) ?? `--${s}`);
      }
    }
  }), n;
}
const QPe = {
  "<color>": Ns.CSS_DATA_TYPE.color,
  "<number>": Ns.CSS_DATA_TYPE.number,
  "<integer>": Ns.CSS_DATA_TYPE.number,
  "<length>": Ns.CSS_DATA_TYPE.length,
  "<percentage>": Ns.CSS_DATA_TYPE.percentage,
  "<length-percentage>": Ns.CSS_DATA_TYPE.lengthPercentage,
  "<angle>": Ns.CSS_DATA_TYPE.angle,
  "<time>": Ns.CSS_DATA_TYPE.time
}, XPe = /^-?[A-Za-z_][\w-]*$/;
function ZPe(t) {
  const { CSS_DATA_TYPE: e } = Ns, n = t.trim().replace(/^["']|["']$/g, "").trim();
  if (n === "" || n === "*") return;
  const r = n.split("|").map((s) => s.trim()).filter((s) => s.length > 0);
  if (r.filter((s) => XPe.test(s)).length === r.length && r.length >= 2)
    return { cssPropertyType: e.customEnum, enumOptions: r };
  for (const s of r) {
    const a = s.replace(/[+#]$/, ""), o = QPe[a];
    if (o) return { cssPropertyType: o };
  }
}
function eLe(t) {
  const e = /* @__PURE__ */ new Map(), n = [];
  if (Ac(t, {
    visit: "Declaration",
    enter(r) {
      n.push(r);
    }
  }), n.length === 0) {
    const r = Es(t).replace(/^\s*\{/, "").replace(/\}\s*$/, "");
    try {
      const i = Fc(r, { context: "declarationList" });
      Ac(i, {
        visit: "Declaration",
        enter(s) {
          n.push(s);
        }
      });
    } catch {
    }
  }
  for (const r of n)
    e.set(r.property, Es(r.value).trim());
  return e;
}
function tLe(t) {
  const e = /* @__PURE__ */ new Map(), n = Fc(t, {
    parseAtrulePrelude: !1,
    onParseError: (r) => {
      throw r;
    }
  });
  return Ac(n, {
    visit: "Atrule",
    enter(r) {
      if (r.name !== "property" || !r.prelude || !r.block) return;
      const i = Es(r.prelude).trim();
      if (!i.startsWith("--")) return;
      const s = eLe(r.block), a = ZPe(s.get("syntax") ?? "*");
      if (!a) return;
      const { cssPropertyType: o, enumOptions: u } = a, l = s.get("initial-value");
      e.set(i, {
        cssPropertyType: o,
        ...u && { enumOptions: u },
        ...l !== void 0 && { defaultValue: l }
      });
    }
  }), e;
}
const nLe = {
  hover: "hover",
  focus: "focus",
  "focus-visible": "focus",
  "focus-within": "focus",
  disabled: "disabled",
  invalid: "invalid"
}, rLe = /^:global\(\s*\.([\w-]+)\s*\)$/;
function iLe(t, e, n) {
  return e ? !0 : n.some((r) => r !== t && t.startsWith(`${r}--`));
}
function sLe(t) {
  let e;
  const n = [];
  for (const u of t) {
    if (u.type === "PseudoElementSelector") return null;
    if (u.type === "PseudoClassSelector") {
      if (u.name === "global") {
        const l = Es(u).match(rLe);
        l && n.push({ kind: "global", className: l[1] });
        continue;
      }
      e ??= nLe[u.name];
      continue;
    }
    n.push({ kind: "local", selector: Es(u) });
  }
  const r = n.some((u) => u.kind === "local"), i = n.flatMap((u) => u.kind === "global" ? [u.className] : []), s = [], a = [];
  for (const u of n)
    u.kind === "local" ? s.push(u.selector) : iLe(u.className, r, i) ? a.push(u.className) : s.push(`.${u.className}`);
  const o = s.join("");
  return o ? { base: o, pseudoClass: e, modifiers: a } : null;
}
function aLe(t) {
  const e = [[]];
  for (const r of t.children)
    r.type === "Combinator" ? e.push([]) : e[e.length - 1].push(r);
  const n = [];
  for (const r of e) {
    const i = sLe(r);
    i && (i.modifiers.length > 0 || i.pseudoClass) && n.push(i);
  }
  return n;
}
function oLe(t) {
  const e = [], n = Fc(t, {
    parseAtrulePrelude: !1,
    onParseError: (r) => {
      throw r;
    }
  });
  return Ac(n, {
    visit: "Rule",
    enter(r) {
      if (r.prelude.type !== "SelectorList") return;
      const i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
      for (const a of r.prelude.children)
        if (a.type === "Selector") {
          for (const o of aLe(a))
            if (o.pseudoClass && !i.has(o.base) && i.set(o.base, o.pseudoClass), o.modifiers.length > 0) {
              const u = s.get(o.base) ?? /* @__PURE__ */ new Set();
              for (const l of o.modifiers) u.add(l);
              s.set(o.base, u);
            }
        }
      for (const [a, o] of s) {
        const u = i.get(a);
        for (const l of o) {
          const h = u && j$(l) === u ? u : void 0;
          e.push({ baseSelector: a, modifier: l, pseudoClass: h });
        }
      }
    }
  }), e;
}
function uLe(t) {
  const e = [];
  for (const r of t.children) {
    if (r.type === "PseudoElementSelector")
      return null;
    r.type !== "PseudoClassSelector" && e.push(Es(r));
  }
  return e.join("") || null;
}
function lLe(t) {
  let e = 0, n = 0, r = 0;
  for (const i of t.children) {
    if (i.type === "IdSelector") {
      e += 1;
      continue;
    }
    if (i.type === "ClassSelector" || i.type === "AttributeSelector") {
      n += 1;
      continue;
    }
    if (i.type === "TypeSelector") {
      i.name !== "*" && (r += 1);
      continue;
    }
    if (i.type === "PseudoElementSelector") {
      r += 1;
      continue;
    }
    if (i.type === "PseudoClassSelector") {
      if (i.name === "where")
        continue;
      n += 1;
    }
  }
  return [e, n, r];
}
function ad(t, e) {
  return !GPe.matchType(t, e).error;
}
function cLe(t) {
  const { CSS_DATA_TYPE: e } = Ns;
  try {
    const n = Fc(t, { context: "value" });
    if (ad("color", n)) return e.color;
    if (ad("length", n)) return e.length;
    if (ad("angle", n)) return e.angle;
    if (ad("time", n)) return e.time;
    if (ad("number", n)) return e.number;
    if (ad("percentage", n)) return e.percentage;
  } catch {
  }
  return e.string;
}
const hLe = /* @__PURE__ */ new Set([
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "span",
  "li",
  "a",
  "label",
  "strong",
  "em",
  "b",
  "i"
]), dLe = /* @__PURE__ */ new Set(["p", "h1", "h2", "h3", "h4", "h5", "h6"]), fLe = /* @__PURE__ */ new Set(["img", "video", "canvas", "picture"]), { CSS_PROPERTY_TYPE: An } = Ns, eG = [
  An.background,
  An.borderTop,
  An.borderBottom,
  An.borderInlineStart,
  An.borderInlineEnd,
  An.paddingTop,
  An.paddingBottom,
  An.paddingInlineStart,
  An.paddingInlineEnd,
  An.borderStartStartRadius,
  An.borderStartEndRadius,
  An.borderEndStartRadius,
  An.borderEndEndRadius,
  An.boxShadow
], tG = [
  An.font,
  An.lineHeight,
  An.letterSpacing,
  An.textDecorationLine,
  An.textTransform,
  An.textAlign,
  An.textShadow,
  An.color
], mLe = [
  An.borderTop,
  An.borderBottom,
  An.borderInlineStart,
  An.borderInlineEnd,
  An.borderStartStartRadius,
  An.borderStartEndRadius,
  An.borderEndStartRadius,
  An.borderEndEndRadius,
  An.boxShadow
];
function nG(t, e) {
  const n = t.toLowerCase();
  if (e) {
    const r = e.toLowerCase();
    if (r === "heading" || r === "paragraph")
      return !0;
  }
  return hLe.has(n);
}
function gLe(t, e) {
  const n = t.toLowerCase();
  if (e) {
    const r = e.toLowerCase();
    if (r === "img" || r === "figure")
      return !0;
  }
  return fLe.has(n);
}
function pLe(t, e) {
  const n = [], r = nG(t, e), i = gLe(t, e), s = uG(t, e) && !i;
  return r && n.push(...tG), i && n.push(...mLe), s && n.push(...eG), n.push(An.display), [...new Set(n)];
}
function bLe(t) {
  const e = [...t];
  for (const n of tG)
    e.includes(n) || e.push(n);
  return e;
}
function yLe(t) {
  const e = [...t];
  for (const n of eG)
    e.includes(n) || e.push(n);
  return e;
}
function ALe(t) {
  return t.includes(An.gap) ? t : [...t, An.gap];
}
const ELe = {
  a: "inline",
  address: "block",
  area: "none",
  article: "block",
  aside: "block",
  audio: "inline",
  b: "inline",
  base: "none",
  basefont: "none",
  blockquote: "block",
  body: "block",
  button: "inline-block",
  canvas: "inline",
  caption: "table-caption",
  center: "block",
  col: "table-column",
  colgroup: "table-column-group",
  datalist: "none",
  dd: "block",
  dir: "block",
  div: "block",
  dl: "block",
  dt: "block",
  em: "inline",
  embed: "inline",
  fieldset: "block",
  figcaption: "block",
  figure: "block",
  footer: "block",
  form: "block",
  h1: "block",
  h2: "block",
  h3: "block",
  h4: "block",
  h5: "block",
  h6: "block",
  head: "none",
  header: "block",
  hgroup: "block",
  hr: "block",
  html: "block",
  i: "inline",
  iframe: "inline",
  img: "inline",
  input: "inline-block",
  label: "inline",
  legend: "block",
  li: "list-item",
  link: "none",
  main: "block",
  map: "inline",
  marquee: "inline-block",
  menu: "block",
  meta: "none",
  nav: "block",
  noembed: "none",
  noframes: "none",
  object: "inline",
  ol: "block",
  p: "block",
  param: "none",
  q: "inline",
  rp: "none",
  script: "none",
  search: "block",
  section: "block",
  select: "inline-block",
  span: "inline",
  strong: "inline",
  style: "none",
  table: "table",
  tbody: "table-row-group",
  td: "table-cell",
  template: "none",
  textarea: "inline-block",
  tfoot: "table-footer-group",
  th: "table-cell",
  thead: "table-header-group",
  title: "none",
  tr: "table-row",
  ul: "block",
  video: "inline"
};
function rG(t) {
  return ELe[t.toLowerCase()] ?? "block";
}
function iG(t) {
  let e, n;
  for (const r of t.matches)
    for (const i of r.properties)
      i.name === "display" && (!n || SLe(r.specificity, n) >= 0) && (e = i, n = r.specificity);
  return e;
}
function SLe(t, e) {
  for (let n = 0; n < t.length; n += 1) {
    const r = t[n] - e[n];
    if (r !== 0)
      return r;
  }
  return 0;
}
function f2(t) {
  const e = iG(t);
  if (e)
    return ZU(e, t.customProperties);
}
const wLe = /* @__PURE__ */ new Set(["flex", "grid", "inline-flex", "inline-grid"]), FLe = /* @__PURE__ */ new Set(["inline", "contents", "none"]), TLe = /* @__PURE__ */ new Set([
  "block",
  "flex",
  "grid",
  "flow-root",
  "inline-block",
  "inline-flex",
  "inline-grid",
  "inline-table",
  "table",
  "list-item",
  "table-caption",
  "table-cell",
  "table-column",
  "table-column-group",
  "table-footer-group",
  "table-header-group",
  "table-row",
  "table-row-group"
]);
function sG(t) {
  return t.trim().toLowerCase().replace(/\s+/g, " ");
}
function aG(t) {
  const e = sG(t);
  return FLe.has(e) ? !1 : e.split(" ").some((r) => TLe.has(r));
}
function vLe(t) {
  return sG(t).split(" ").some((r) => wLe.has(r));
}
function oG(t) {
  const e = iG(t);
  return !e?.varRefs || e.varRefs.length === 0 ? !1 : ZU(e, t.customProperties) === void 0;
}
function xLe(t) {
  for (const e of t.matches)
    for (const n of e.properties)
      if (n.name === "display") return !0;
  return !1;
}
function CLe(t) {
  const e = f2(t);
  return e !== void 0 ? vLe(e) : oG(t);
}
function kLe(t) {
  const e = f2(t);
  return e !== void 0 ? aG(e) : oG(t);
}
function _Le(t) {
  return aG(rG(t));
}
function NLe(t, e) {
  const n = t.toLowerCase();
  if (dLe.has(n))
    return !0;
  const r = e?.toLowerCase();
  return r === "heading" || r === "paragraph";
}
function uG(t, e) {
  return NLe(t, e) ? !1 : _Le(t);
}
function DLe(t, e, n) {
  return n && xLe(n) ? kLe(n) : uG(t, e);
}
function lG(t) {
  return t.map((e) => {
    if (e.children.length > 1) {
      const n = e.extractorData.get("css-matcher");
      if (n && CLe(n)) {
        const r = e.extractorData.get("css-properties");
        r && e.extractorData.set("css-properties", {
          relevant: ALe(r.relevant)
        });
      }
    }
    return {
      ...e,
      children: lG(e.children)
    };
  });
}
function cG(t) {
  return t.map((e) => {
    const n = e.attributes.role;
    if (nG(e.tag, n)) {
      const r = e.extractorData.get("css-matcher"), i = e.extractorData.get("css-properties");
      i && DLe(e.tag, n, r) && e.extractorData.set("css-properties", {
        relevant: yLe(i.relevant)
      });
    }
    return {
      ...e,
      children: cG(e.children)
    };
  });
}
function ILe() {
  return {
    name: "css-properties",
    onCreateElement(t) {
      if (!t.isDomElement || !t.tag || !t.traceId) return;
      const { tag: e, props: n, traceId: r, store: i } = t, s = n.role, o = { relevant: pLe(e, s) };
      i.set(r, "css-properties", o);
    }
  };
}
const RLe = {
  a: "anchor",
  abbr: "abbreviation",
  article: "article",
  aside: "aside",
  button: "button",
  caption: "caption",
  col: "tableColumn",
  colgroup: "tableColumnGroup",
  dd: "descriptionDetails",
  details: "details",
  div: "div",
  dl: "descriptionList",
  dt: "descriptionTerm",
  fieldset: "fieldset",
  figcaption: "figureCaption",
  figure: "figure",
  footer: "footer",
  form: "form",
  h1: "heading1",
  h2: "heading2",
  h3: "heading3",
  h4: "heading4",
  h5: "heading5",
  h6: "heading6",
  header: "header",
  hr: "horizontalRule",
  img: "image",
  input: "input",
  label: "label",
  legend: "legend",
  li: "listItem",
  main: "main",
  nav: "navigation",
  ol: "orderedList",
  optgroup: "optionGroup",
  option: "option",
  p: "paragraph",
  pre: "preformatted",
  progress: "progress",
  section: "section",
  select: "select",
  span: "span",
  strong: "strong",
  summary: "summary",
  table: "table",
  tbody: "tableBody",
  td: "tableCell",
  textarea: "textArea",
  tfoot: "tableFooter",
  th: "tableHeader",
  thead: "tableHead",
  tr: "tableRow",
  ul: "unorderedList"
}, v1 = (t) => "tagName" in t, hG = (t) => "nodeName" in t && t.nodeName === "#text", Hu = (t, e) => t.attrs.find((n) => n.name === e)?.value, PLe = (t) => {
  const e = {};
  for (const n of t.attrs)
    e[n.name] = n.value;
  return e;
}, LLe = (t) => t.childNodes.some((e) => hG(e) && e.value.trim().length > 0);
function MLe(t) {
  return RLe[t.toLowerCase()] ?? ip(t);
}
function dG(t) {
  let e = "";
  for (const n of t.childNodes)
    hG(n) ? e += n.value : v1(n) && (e += dG(n));
  return e.trim();
}
function OLe(t, e) {
  let n;
  const r = Hu(t, "id");
  r && !r.includes("mock_") && (n = r);
  const i = Hu(t, "aria-label");
  i && !i.startsWith("mock_") && (n = i);
  const s = Hu(t, "aria-labelledby");
  if (s) {
    const o = e(s);
    if (o) {
      const u = dG(o);
      u && (n = u);
    }
  }
  const a = Hu(t, "class");
  if (a) {
    const o = lp(Rf(a));
    o && (n = o);
  }
  return n ? ip(n) : MLe(t.tagName);
}
function BLe(t, e) {
  const n = Hu(t, "class");
  return !!(n && lp(Rf(n)) || e.get("prop-tracker")?.boundProps.includes("className"));
}
function $Le(t) {
  return t.flatMap((e) => {
    if (!v1(e)) return [e];
    const n = Hu(e, "class");
    return Hu(e, gf) && n?.includes(hH) ? [...e.childNodes] : [e];
  });
}
function HLe(t, e) {
  const n = aFe(t), r = /* @__PURE__ */ new Map(), i = (h) => {
    if (v1(h)) {
      const f = Hu(h, "id");
      f && r.set(f, h), h.childNodes.forEach(i);
    }
  };
  n.childNodes.forEach(i);
  const s = (h) => r.get(h), a = (h, f) => {
    if (!v1(h)) return [];
    const m = h.childNodes.flatMap((A) => a(A, !1)), g = Hu(h, gf);
    if (g) {
      const A = e.getAll(g) ?? /* @__PURE__ */ new Map();
      if (!f && !BLe(h, A))
        return m;
      const E = f ? "root" : OLe(h, s), w = LLe(h);
      if (w) {
        const N = A.get("css-properties");
        if (N) {
          const B = {
            relevant: bLe(N.relevant)
          };
          A.set("css-properties", B);
        }
      }
      const x = PLe(h);
      return delete x[gf], [
        {
          traceId: g,
          name: E,
          tag: h.tagName,
          attributes: x,
          extractorData: A,
          children: m,
          ...w && { hasTextContent: !0 }
        }
      ];
    }
    return m;
  }, o = $Le([...n.childNodes]);
  let u = !0;
  const l = [];
  for (const h of o) {
    const f = a(h, u);
    f.length > 0 && (l.push(...f), u = !1);
  }
  return l;
}
function ULe(t, e, n, r, i) {
  const s = new tEe(), a = {
    componentInfo: t,
    component: e,
    props: {},
    store: s
  };
  for (const f of n)
    f.onBeforeRender?.(a);
  const o = [
    {
      onCreateElement(f) {
        for (const m of n)
          m.onCreateElement?.(f);
      }
    }
  ], u = r?.wrapper ? r.wrapper(a.component) : a.component, l = NEe(u, a.props, o, s, i);
  for (const f of n)
    f.onRenderComplete?.({ html: l, context: a });
  const h = HLe(l, s);
  return { html: l, store: s, elements: h };
}
function GLe(t) {
  const e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new WeakMap(), i = {
    propUsages: /* @__PURE__ */ new Map()
  }, s = new Set(t?.eligiblePaths ?? []), a = /* @__PURE__ */ new Map(), o = {
    registerString(m, g, A) {
      e.set(A, { path: m, propName: g, originalValue: A });
    },
    registerNumber(m, g, A) {
      n.set(A, { path: m, propName: g, originalValue: A });
    },
    registerFunction(m, g, A) {
      r.set(A, { path: m, propName: g, originalValue: A });
    }
  }, u = (m, g = /* @__PURE__ */ new WeakSet()) => {
    if (typeof m == "string") {
      const A = [];
      for (const [E, w] of e)
        m.includes(E) && A.push({ propName: w.propName, path: w.path, embedded: m !== E });
      return A;
    }
    if (typeof m == "number") {
      const A = n.get(m);
      return A ? [{ propName: A.propName, path: A.path, embedded: !1 }] : [];
    }
    if (typeof m == "function") {
      const A = r.get(m);
      return A ? [{ propName: A.propName, path: A.path, embedded: !1 }] : [];
    }
    return m && typeof m == "object" ? g.has(m) ? [] : (g.add(m), "$$typeof" in m ? [] : Object.values(m).flatMap((A) => u(A, g))) : [];
  };
  return {
    extractor: {
      name: "prop-tracker",
      onBeforeRender(m) {
        N2e(), m.props = D2e(m.componentInfo, o, {
          eligibleRefElementPaths: s
        });
      },
      onCreateElement(m) {
        if (!m.isDomElement) {
          h(m.props.id, Zm(m.type));
          return;
        }
        if (!m.tag || !m.traceId) return;
        const { tag: g, props: A, traceId: E, store: w } = m, x = A, N = /* @__PURE__ */ new Set(), B = /* @__PURE__ */ new Map(), P = [];
        Object.entries(A).forEach(([C, D]) => {
          if (C.startsWith("__") || C === gf) return;
          typeof D == "function" && C.length > 2 && C.startsWith("on") && C[2] === C[2].toUpperCase() && P.push(C);
          const L = u(D);
          L.forEach((k) => {
            N.add(k.propName);
            const I = k.path.replace(/\[\d+\]/g, "");
            i.propUsages.has(I) || i.propUsages.set(I, { elements: /* @__PURE__ */ new Map(), attributes: /* @__PURE__ */ new Map() });
            const U = i.propUsages.get(I);
            U.elements.set(E, { tag: g, elementId: E });
            const j = L.length > 1 || k.embedded;
            U.attributes.set(`${E}:${C}`, { attr: C, concatenated: j }), j && B.set(C, k.propName);
          });
        }), w.set(E, "prop-tracker", {
          tag: g,
          role: x.role,
          boundProps: [...N],
          concatenatedAttrs: B,
          eventHandlers: P
        }), f(E, A, w);
      }
    },
    state: { stores: i }
  };
  function h(m, g) {
    const A = kI(m);
    if (!A || !g || s.size > 0 && !s.has(A)) return;
    const E = a.get(A) ?? [];
    E.push({ elementPropsPath: A, refComponentType: g }), a.set(A, E);
  }
  function f(m, g, A) {
    const E = kI(g.id);
    if (!E) return;
    const w = WLe(g.className);
    if (!w) return;
    const x = a.get(E), N = x?.shift();
    if (!N) return;
    x?.length === 0 && a.delete(E);
    const B = {
      elementPropsPath: N.elementPropsPath,
      refComponentType: N.refComponentType,
      selector: w
    };
    A.set(m, "ref-element", B);
  }
}
function WLe(t) {
  const e = lp(Rf(t));
  return e ? `.${e}` : void 0;
}
const VLe = /* @__PURE__ */ new Set(["button", "a", "input", "select", "textarea", "summary"]), KLe = /* @__PURE__ */ new Set([
  "button",
  "link",
  "switch",
  "checkbox",
  "radio",
  "tab",
  "option",
  "menuitem",
  "menuitemcheckbox",
  "menuitemradio",
  "treeitem",
  "combobox",
  "slider",
  "spinbutton",
  "searchbox",
  "textbox",
  "listbox"
]), zLe = /* @__PURE__ */ new Set([
  "onClick",
  "onMouseDown",
  "onMouseUp",
  "onMouseEnter",
  "onMouseLeave",
  "onPointerDown",
  "onPointerUp",
  "onFocus",
  "onBlur",
  "onKeyDown",
  "onKeyUp",
  "onKeyPress",
  "onChange",
  "onInput",
  "onSubmit"
]), jLe = /* @__PURE__ */ new Set(["button", "input", "select", "textarea", "fieldset"]), YLe = /* @__PURE__ */ new Set(["button", "switch", "checkbox", "radio", "menuitem", "tab", "option", "link"]), qLe = /* @__PURE__ */ new Set(["input", "select", "textarea", "form"]), JLe = /* @__PURE__ */ new Set(["presentation", "none"]);
function QLe(t) {
  return t.extractorData.get("prop-tracker")?.role ?? t.attributes.role;
}
function XLe(t) {
  return t.extractorData.get("prop-tracker")?.eventHandlers ?? [];
}
function ZLe(t) {
  return t !== void 0 && JLe.has(t);
}
function eMe(t, e, n) {
  return VLe.has(t) || e !== void 0 && KLe.has(e) ? !0 : n.some((r) => zLe.has(r));
}
function tMe(t, e) {
  return !!(jLe.has(t) || e !== void 0 && YLe.has(e));
}
function nMe(t) {
  return qLe.has(t);
}
function rMe(t) {
  const e = t.tag.toLowerCase(), n = QLe(t);
  if (ZLe(n))
    return { hover: !1, focus: !1, disabled: !1, invalid: !1 };
  const r = XLe(t), i = eMe(e, n, r), s = t.attributes.tabindex === "-1";
  return {
    hover: i,
    focus: i && !s,
    disabled: tMe(e, n),
    invalid: nMe(e)
  };
}
function iMe(t) {
  const e = t.get("fontSize"), n = t.get("fontFamily");
  if (e === void 0 || n === void 0) return;
  const r = [];
  for (const s of ["fontStyle", "fontVariant", "fontWeight", "fontStretch"]) {
    const a = t.get(s);
    a !== void 0 && a.toLowerCase() !== "normal" && r.push(a);
  }
  const i = t.get("lineHeight");
  return i !== void 0 && i.toLowerCase() !== "normal" ? r.push(`${e}/${i}`) : r.push(e), r.push(n.replace(/"/g, "'")), r.join(" ");
}
function sMe(t) {
  const e = t.get("rowGap"), n = t.get("columnGap");
  if (!(e === void 0 || n === void 0))
    return e === n ? e : `${e} ${n}`;
}
const aMe = {
  font: [iMe],
  gap: [sMe]
};
function m2(t) {
  const e = [];
  try {
    Fc(t, { context: "value" }).children.forEach((r) => {
      r.type === "WhiteSpace" || r.type === "Operator" || e.push(Es(r));
    });
  } catch {
  }
  return e;
}
function oMe(t) {
  const e = m2(t);
  switch (e.length) {
    case 1:
      return { top: e[0], right: e[0], bottom: e[0], left: e[0] };
    case 2:
      return { top: e[0], right: e[1], bottom: e[0], left: e[1] };
    case 3:
      return { top: e[0], right: e[1], bottom: e[2], left: e[1] };
    case 4:
      return { top: e[0], right: e[1], bottom: e[2], left: e[3] };
    default:
      return;
  }
}
function uMe(t) {
  const e = m2(t);
  switch (e.length) {
    case 1:
      return { start: e[0], end: e[0] };
    case 2:
      return { start: e[0], end: e[1] };
    default:
      return;
  }
}
function lMe(t) {
  const e = [];
  try {
    const n = Fc(t, { context: "value" });
    for (const r of n.children)
      if (r.type !== "WhiteSpace") {
        if (r.type === "Operator" && r.value === "/") break;
        e.push(Es(r));
      }
  } catch {
    return;
  }
  switch (e.length) {
    case 1:
      return { tl: e[0], tr: e[0], br: e[0], bl: e[0] };
    case 2:
      return { tl: e[0], tr: e[1], br: e[0], bl: e[1] };
    case 3:
      return { tl: e[0], tr: e[1], br: e[2], bl: e[1] };
    case 4:
      return { tl: e[0], tr: e[1], br: e[2], bl: e[3] };
    default:
      return;
  }
}
function oi(t) {
  return (e) => e.get(t);
}
function G0(t, e) {
  return (n) => {
    const r = n.get(t);
    return r === void 0 ? void 0 : oMe(r)?.[e];
  };
}
function W0(t, e) {
  return (n) => {
    const r = n.get(t);
    return r === void 0 ? void 0 : uMe(r)?.[e];
  };
}
function V0(t, e) {
  return (n) => {
    const r = n.get(t);
    return r === void 0 ? void 0 : lMe(r)?.[e];
  };
}
const cMe = /* @__PURE__ */ new Set(["none", "underline", "overline", "line-through", "blink"]), hMe = (t) => {
  const e = t.get("textDecoration");
  if (e === void 0) return;
  const n = m2(e).filter(
    (r) => cMe.has(r.toLowerCase())
  );
  if (n.length !== 0)
    return n.join(" ");
}, dMe = {
  // Padding — block axis is physical (top/bottom), inline axis is logical (start/end).
  paddingTop: [oi("paddingBlockStart"), W0("paddingBlock", "start"), G0("padding", "top")],
  paddingBottom: [oi("paddingBlockEnd"), W0("paddingBlock", "end"), G0("padding", "bottom")],
  paddingInlineStart: [oi("paddingLeft"), W0("paddingInline", "start"), G0("padding", "left")],
  paddingInlineEnd: [oi("paddingRight"), W0("paddingInline", "end"), G0("padding", "right")],
  // Border radius — schema uses all-logical corner names; physical names map under LTR/horizontal-tb.
  borderStartStartRadius: [oi("borderTopLeftRadius"), V0("borderRadius", "tl")],
  borderStartEndRadius: [oi("borderTopRightRadius"), V0("borderRadius", "tr")],
  borderEndStartRadius: [oi("borderBottomLeftRadius"), V0("borderRadius", "bl")],
  borderEndEndRadius: [oi("borderBottomRightRadius"), V0("borderRadius", "br")],
  // Border sides — these are themselves shorthands (<width> || <style> || <color>).
  // The schema treats them as one opaque value, so `border: 1px solid red` flows
  // through verbatim to every side.
  borderTop: [oi("borderBlockStart"), oi("border")],
  borderBottom: [oi("borderBlockEnd"), oi("border")],
  borderInlineStart: [oi("borderLeft"), oi("borderInline"), oi("border")],
  borderInlineEnd: [oi("borderRight"), oi("borderInline"), oi("border")],
  // Background — populate the schema's `background` from `background-color` when
  // the developer only wrote the color.
  background: [oi("backgroundColor")],
  // Text-decoration — `text-decoration: underline wavy red` carries line, style,
  // and color in one declaration. Pick out just the line tokens for the schema.
  textDecorationLine: [hMe],
  // Shorthand targets (e.g. `font`) live in css-shorthand-composer.ts and are
  // merged in here — composer-driven, conceptually the inverse of the rows above.
  ...aMe
};
function fMe(t, e) {
  const n = e.get(t);
  if (n !== void 0) return n;
  const r = dMe[t];
  if (r)
    for (const i of r) {
      const s = i(e);
      if (s !== void 0) return s;
    }
}
const dP = {
  a11y: "Accessibility"
}, Yw = 50;
function Qu(t) {
  if (t in dP)
    return dP[t];
  const e = cpe(t, { keepSpecialCharacters: !1 });
  if (e.length <= Yw)
    return e;
  const n = e.split(" ");
  for (; n.length > 1 && n.join(" ").length > Yw; )
    n.shift();
  return n.join(" ").slice(0, Yw);
}
function fG({
  element: t,
  propTriggers: e,
  classTriggers: n
}) {
  const r = {}, i = /* @__PURE__ */ new Map();
  for (const s of n)
    gMe(t, s.baseSelector, s.isCssModule) && i.set(j$(s.modifier), s);
  for (const s of e) {
    if (!s.isStateTrigger || s.type !== "boolean") continue;
    const a = mMe(s.name), o = i.get(a);
    r[a] = {
      displayName: Qu(a),
      ...o && { className: o.modifier },
      props: { [s.name]: !0 }
    };
  }
  for (const [s, a] of i)
    r[s] === void 0 && (r[s] = {
      displayName: Qu(s),
      className: a.modifier
    });
  return Object.keys(r).length > 0 ? r : void 0;
}
function mMe(t) {
  return lpe(t);
}
function gMe(t, e, n) {
  const r = e.match(/^\.([\w-]+)$/);
  if (!r) return !1;
  const i = r[1];
  return (t.attributes.class?.split(/\s+/).filter(Boolean) ?? []).some((a) => a === i ? !0 : !n || (a.startsWith(`${i}__`) || a.startsWith(`_${i}__`)) && z$(a.replace(/^_/, "")) ? !1 : a.startsWith(`${i}_`) || a.startsWith(`_${i}_`));
}
const mG = {
  Link: "link",
  Image: "image",
  Video: "video",
  VectorArt: "vectorArt",
  A11y: "a11y",
  Audio: "audio",
  MenuItems: "menuItems",
  Schema: "schema",
  Text: "text",
  TextEnum: "textEnum",
  NumberType: "number",
  BooleanValue: "booleanValue",
  LocalDate: "localDate",
  LocalTime: "localTime",
  LocalDateTime: "localDateTime",
  WebUrl: "webUrl",
  Email: "email",
  Phone: "phone",
  Hostname: "hostname",
  Regex: "regex",
  Guid: "guid",
  RichText: "richText",
  Container: "container",
  ArrayItems: "arrayItems",
  Direction: "direction"
};
function pMe(t, e) {
  if (!t || !e) return [];
  const n = [];
  for (const r of Object.values(ps.A11Y_ATTRIBUTES))
    r !== ps.A11Y_ATTRIBUTES.Unknown_AriaAttributes && t.has(`${e}.${r}`) && n.push(r);
  return n;
}
const { DATA_TYPE: Yn } = ps, bMe = 240;
function yMe(t, e) {
  const n = t.get(e);
  if (!n) return [];
  const r = [];
  for (const [i, s] of n.attributes) {
    const a = i.split(":")[0], o = n.elements.get(a);
    o && r.push({
      element: o.tag,
      attribute: s.attr,
      concatenated: s.concatenated,
      elementId: o.elementId
    });
  }
  return r;
}
function gG(t, e, n, r) {
  const i = {
    displayName: Qu(t.name)
  };
  e !== void 0 && (i.defaultValue = e);
  const s = g2(i, t.resolvedType, t, n, r);
  return s.isErr() ? Ps(s.error) : Gr(i);
}
function g2(t, e, n, r, i) {
  const s = r && i ? yMe(r, i) : void 0;
  switch (e.kind) {
    case "primitive":
      return AMe(t, e, n, s), Gr(void 0);
    case "literal":
      return EMe(t), Gr(void 0);
    case "enum":
      return SMe(t), Gr(void 0);
    case "array":
      return wMe(t, e, r, i);
    case "object":
      return FMe(t, e, r, i);
    case "union":
      return TMe(t, e, n);
    case "function":
      return xMe(t, n, s), Gr(void 0);
    case "semantic":
      return vMe({ dataItem: t, resolvedType: e, propUsages: r, propPath: i }), Gr(void 0);
    default:
      return t.dataType = Yn.text, t.text = {}, Gr(void 0);
  }
}
function AMe(t, e, n, r) {
  const i = e.value?.toLowerCase() || n.type.toLowerCase();
  i.includes("string") ? r?.some((s) => s.attribute === "dir") ? t.dataType = Yn.direction : r?.some((s) => s.attribute === "href" && s.element === "a" && !s.concatenated) ? t.dataType = Yn.webUrl : r?.some((s) => s.attribute === "id") ? t.dataType = Yn.guid : r?.some((s) => s.attribute === "pattern") ? t.dataType = Yn.regex : (t.dataType = Yn.text, t.text = {}) : i.includes("number") ? (t.dataType = Yn.number, t.number = n.min != null || n.max != null ? { ...n.min != null && { min: n.min }, ...n.max != null && { max: n.max } } : {}) : i.includes("boolean") ? t.dataType = Yn.booleanValue : (t.dataType = Yn.text, t.text = {});
}
function EMe(t) {
  t.dataType = Yn.text, t.text = {};
}
function SMe(t) {
  t.dataType = Yn.textEnum, t.textEnum = {
    options: []
  };
}
function wMe(t, e, n, r) {
  if (e.kind !== "array" || e.elementType === void 0)
    return Ps(
      new ru('Invalid array type: resolved type has kind "array" but is missing elementType', {
        props: { phase: "conversion", isDefect: !0 }
      })
    );
  t.dataType = Yn.arrayItems;
  const i = {}, s = g2(
    i,
    e.elementType,
    {
      name: "element",
      type: e.elementType.kind,
      resolvedType: e.elementType
    },
    n,
    r
  );
  return s.isErr() ? s : (t.arrayItems = i.dataType === Yn.data && i.data ? { data: i.data } : { dataItem: i }, Gr(void 0));
}
function FMe(t, e, n, r) {
  if (t.dataType = Yn.data, e.properties) {
    const i = {};
    for (const [s, a] of Object.entries(e.properties)) {
      const o = r ? `${r}.${s}` : s, u = gG(a, void 0, n, o);
      if (u.isErr())
        return Ps(u.error);
      i[s] = u.value;
    }
    t.data = {
      items: i
    };
  } else
    t.data = {
      items: {}
    };
  return Gr(void 0);
}
function TMe(t, e, n) {
  if (!e.types || e.types.length === 0)
    return t.dataType = Yn.text, t.text = {}, Gr(void 0);
  const r = e.types.filter((o) => o.value !== "undefined" && o.value !== "null");
  if (r.length === 0)
    return t.dataType = Yn.text, t.text = {}, Gr(void 0);
  if (r.length <= 2 && r.every(
    (o) => o.kind === "literal" && (o.value === !0 || o.value === !1)
  ))
    return t.dataType = Yn.booleanValue, Gr(void 0);
  if (r.every(
    (o) => o.kind === "literal" && typeof o.value == "string"
  ))
    return t.dataType = Yn.textEnum, t.textEnum = {
      options: r.map((o) => ({
        value: String(o.value || ""),
        displayName: Qu(String(o.value || ""))
      })).filter((o) => o.value)
    }, Gr(void 0);
  const a = r[0];
  return a ? g2(t, a, n) : (t.dataType = Yn.text, t.text = {}, Gr(void 0));
}
function vMe({
  dataItem: t,
  resolvedType: e,
  propUsages: n,
  propPath: r
}) {
  const i = e.value, s = e.source;
  if (s === "@types/react" || s === "react") {
    i === "ReactNode" || i === "ReactElement" ? (t.dataType = Yn.container, t.container = pG()) : (t.dataType = Yn.text, t.text = {});
    return;
  }
  if (s === "@wix/editor-react-types") {
    const a = mG[i];
    a ? (t.dataType = Yn[a], CMe({ dataItem: t, builderType: a, propUsages: n, propPath: r })) : (t.dataType = Yn.text, t.text = {});
    return;
  }
  t.dataType = Yn.text, t.text = {};
}
const fP = {
  onclick: Uo.POINTER,
  ondblclick: Uo.POINTER,
  onchange: Uo.CHANGE,
  onkeypress: Uo.KEYBOARD,
  onkeyup: Uo.KEYBOARD,
  onsubmit: Uo.SUBMIT,
  onfocus: Uo.FOCUS,
  onblur: Uo.FOCUS,
  onmousein: Uo.POINTER,
  onmouseout: Uo.POINTER
};
function xMe(t, e, n) {
  let r;
  if (n)
    for (const i of n) {
      const s = fP[i.attribute.toLowerCase()];
      if (s) {
        r = s;
        break;
      }
    }
  r || (r = fP[e.name.toLowerCase()]), t.dataType = Yn.function, r ? t.function = { parameters: [{ domEvent: r }] } : t.function = {};
}
function CMe({
  dataItem: t,
  builderType: e,
  propUsages: n,
  propPath: r
}) {
  switch (e) {
    case "link":
      t.dataType = Yn.link, t.link = {
        linkTypes: [
          ps.LINK_TYPE.externalLink,
          ps.LINK_TYPE.anchorLink,
          ps.LINK_TYPE.emailLink,
          ps.LINK_TYPE.phoneLink,
          ps.LINK_TYPE.dynamicPageLink,
          ps.LINK_TYPE.pageLink,
          ps.LINK_TYPE.whatsAppLink,
          ps.LINK_TYPE.documentLink,
          ps.LINK_TYPE.popupLink,
          ps.LINK_TYPE.addressLink,
          ps.LINK_TYPE.edgeAnchorLinks,
          ps.LINK_TYPE.loginToWixLink
        ]
      };
      break;
    case "image":
      t.dataType = Yn.image, t.image = {
        category: ape.IMAGE_CATEGORY.IMAGE
      };
      break;
    case "a11y":
      t.dataType = Yn.a11y, t.a11y = {
        attributes: pMe(n, r)
      };
      break;
    case "container":
      t.container = pG();
      break;
  }
}
function pG() {
  return {
    containerType: NT.simple,
    simple: {
      behaviors: { selectable: !0 },
      layout: { containerResizeDirection: spe.CONTENT_RESIZE_DIRECTION.vertical, height: bMe }
    }
  };
}
const kMe = {
  hover: "Hover",
  focus: "Focus",
  disabled: "Disabled",
  invalid: "Invalid"
}, _Me = {
  hover: Cd.hover,
  focus: Cd.focus,
  disabled: Cd.disabled,
  invalid: Cd.invalid
};
function bG(t, e) {
  const n = rMe(t), r = {};
  for (const i of Object.keys(n))
    n[i] && (r[i] = {
      displayName: kMe[i],
      className: `${e}--${i}`,
      pseudoClass: _Me[i]
    });
  return Object.keys(r).length > 0 ? r : void 0;
}
function yG(t, e) {
  if (!t && !e) return;
  const n = { ...e, ...t };
  return Object.keys(n).length > 0 ? n : void 0;
}
function NMe(t) {
  return t.css.flatMap(
    (e) => e.api.getStateClasses().filter((n) => n.pseudoClass === void 0).map((n) => ({ ...n, isCssModule: e.isCssModule }))
  );
}
const DMe = /* @__PURE__ */ new Set(["id", "className", "elementProps", "wix"]);
function IMe(t) {
  const e = LMe(t);
  return {
    editorElement: RMe(t, e)
  };
}
function RMe(t, e) {
  const n = t.elements[0];
  if (!n)
    throw new Vd(
      `Component "${t.componentName}" render produced no root element — null or text-only render`,
      { props: { phase: "render" } }
    );
  const r = n.children, i = e.get(n.traceId) ?? {}, s = NMe(t), a = p2(n), o = a ? [a] : [], u = n ? yG(
    a ? bG(n, a) : void 0,
    fG({
      element: n,
      propTriggers: Object.values(t.props).filter((l) => l.isStateTrigger),
      classTriggers: s
    })
  ) : void 0;
  return {
    selector: AG(n),
    displayName: Qu(t.componentName),
    data: EG(t.props, t.propUsages),
    elements: SG(
      r,
      e,
      s,
      o,
      t.innerElementProps,
      t.propUsages
    ),
    cssProperties: vG(n),
    cssCustomProperties: i,
    ...u && { states: u }
  };
}
function p2(t) {
  if (t?.attributes.class)
    return lp(Rf(t.attributes.class));
}
function AG(t) {
  if (t?.attributes.class) {
    const e = lp(Rf(t.attributes.class));
    if (e) return `.${e}`;
  }
  return t?.tag ?? "";
}
function PMe(t, e) {
  const n = p2(t);
  if (n)
    for (const r of [...e].reverse())
      for (const i of ["-", "__"]) {
        const s = `${r}${i}`;
        if (n.startsWith(s))
          return Qu(n.slice(s.length));
      }
  return Qu(t.name);
}
function EG(t, e) {
  const n = {};
  for (const [r, i] of Object.entries(t)) {
    if (DMe.has(r) || i.resolvedType.kind === "literal") continue;
    const s = i.defaultValue?.kind !== "unresolved" ? i.defaultValue?.value : void 0, a = gG(i, s, e, i.propPath);
    if (a.isErr()) throw a.error;
    n[r] = a.value;
  }
  return n;
}
function SG(t, e, n, r, i, s, a) {
  const o = {};
  for (const u of t) {
    const l = i?.get(u.traceId), h = u.extractorData.get("ref-element");
    if (h) {
      o[eEe(h.elementPropsPath, a)] = {
        elementType: nI.ELEMENT_TYPE.refElement,
        refElement: {
          selector: h.selector,
          type: h.refComponentType
        }
      };
      continue;
    }
    const f = p2(u), m = l && s ? EG(l.props, s) : void 0, g = vG(u), A = e.get(u.traceId) ?? {}, E = yG(
      f ? bG(u, f) : void 0,
      fG({ element: u, propTriggers: [], classTriggers: n })
    );
    o[u.name] = {
      elementType: nI.ELEMENT_TYPE.inlineElement,
      inlineElement: {
        selector: AG(u),
        displayName: PMe(u, r),
        behaviors: { removable: !0, selectable: !1 },
        // Add data from inner element props if available
        ...m && Object.keys(m).length > 0 && { data: m },
        // CSS properties from heuristic + matched CSS files
        ...Object.keys(g).length > 0 && { cssProperties: g },
        // CSS custom properties placed on the Nearest Common Ancestor of all elements that use each variable
        ...Object.keys(A).length > 0 && { cssCustomProperties: A },
        ...E && { states: E },
        // Recursively build nested elements
        elements: u.children.length > 0 ? SG(
          u.children,
          e,
          n,
          f ? [...r, f] : r,
          i,
          s,
          l?.elementPropsPath ?? a
        ) : void 0
      }
    };
  }
  return o;
}
function LMe(t) {
  const e = FG(t.elements), n = t.elements[0]?.traceId, r = MMe(t), i = wG(t.elements);
  for (const o of t.css)
    for (const [u, l] of o.customProperties)
      i.has(u) || i.set(u, l);
  const s = /* @__PURE__ */ new Set([...i.keys(), ...r.keys()]), a = /* @__PURE__ */ new Map();
  for (const o of s) {
    if (o === "--display") continue;
    const u = r.get(o), l = i.get(o) ?? u?.defaultValue, h = t.varUsedByTraceId.get(o) ?? /* @__PURE__ */ new Set();
    let f;
    if (h.size > 0 ? f = HMe(h, e) : f = TG(t.elements, o) ?? (u ? n : void 0), !f) continue;
    const m = u ? u.cssPropertyType : BMe(o, l ?? "", t.css), g = OMe(u), A = o.startsWith("--") ? o.slice(2) : o, E = a.get(f) ?? {};
    E[A] = {
      displayName: Qu(A),
      ...l !== void 0 && { defaultValue: l },
      ...m !== void 0 && { cssPropertyType: m },
      ...g && { customEnum: g }
    }, a.set(f, E);
  }
  return a;
}
function MMe(t) {
  const e = /* @__PURE__ */ new Map();
  for (const n of t.css)
    for (const [r, i] of n.api.getRegisteredCustomProperties())
      e.has(r) || e.set(r, i);
  return e;
}
function OMe(t) {
  if (!(!t?.enumOptions || t.enumOptions.length === 0))
    return {
      cssPropertyType: Ns.CSS_DATA_TYPE.string,
      options: t.enumOptions.map((e) => ({
        value: e,
        displayName: Qu(e)
      }))
    };
}
function BMe(t, e, n) {
  for (const r of n) {
    const i = r.api.getVarPropertyType(t, e);
    if (i !== void 0) return i;
  }
}
function wG(t) {
  const e = /* @__PURE__ */ new Map();
  for (const n of t) {
    const r = n.extractorData.get("css-matcher");
    if (r)
      for (const [i, s] of Object.entries(r.customProperties))
        e.has(i) || e.set(i, s);
    for (const [i, s] of wG(n.children))
      e.has(i) || e.set(i, s);
  }
  return e;
}
function FG(t, e) {
  const n = /* @__PURE__ */ new Map();
  for (const r of t) {
    e !== void 0 && n.set(r.traceId, e);
    for (const [i, s] of FG(r.children, r.traceId))
      n.set(i, s);
  }
  return n;
}
function $Me(t, e) {
  const n = [t];
  let r = t;
  for (; e.has(r); )
    r = e.get(r), n.unshift(r);
  return n;
}
function HMe(t, e) {
  const n = [...t];
  if (n.length === 1) return n[0];
  const r = n.map((a) => $Me(a, e)), i = Math.min(...r.map((a) => a.length));
  let s = r[0][0];
  for (let a = 0; a < i; a++) {
    const o = r[0][a];
    if (r.every((u) => u[a] === o))
      s = o;
    else
      break;
  }
  return s;
}
function TG(t, e) {
  for (const n of t) {
    if (n.extractorData.get("css-matcher")?.customProperties[e] !== void 0) return n.traceId;
    const i = TG(n.children, e);
    if (i !== void 0) return i;
  }
}
function UMe(t) {
  const n = t.extractorData.get("css-matcher")?.matches;
  if (!n || n.length === 0) return /* @__PURE__ */ new Map();
  const r = /* @__PURE__ */ new Map();
  for (const i of n)
    for (const s of i.properties)
      r.set(ip(s.name), s.value);
  return r;
}
const GMe = {
  "inline-block": "inlineBlock",
  "inline-flex": "inlineFlex",
  "inline-grid": "inlineGrid",
  "inline-table": "inlineTable",
  "list-item": "listItem",
  "flow-root": "flowRoot"
};
function WMe(t) {
  return GMe[t] ?? t;
}
const { CSS_PROPERTY_TYPE: VMe, DISPLAY_VALUE: mP } = Ns;
function vG(t) {
  const e = {}, r = t?.extractorData.get("css-properties")?.relevant;
  if (!r || r.length === 0)
    return e;
  const i = t ? UMe(t) : /* @__PURE__ */ new Map();
  for (const s of r) {
    if (s === VMe.display && t) {
      e[s] = KMe(t);
      continue;
    }
    const a = fMe(s, i);
    e[s] = {
      ...a !== void 0 && { defaultValue: a }
    };
  }
  return e;
}
function KMe(t) {
  const e = t.extractorData.get("css-matcher"), n = e ? f2(e) : void 0;
  if ((e?.matches.some((a) => a.properties.some((o) => o.name === "display")) ?? !1) && n === void 0)
    return {
      display: {
        displayValues: [mP.none]
      }
    };
  const i = n ?? rG(t.tag), s = WMe(i);
  return {
    display: {
      displayValues: [mP.none, s]
    }
  };
}
function xG(t) {
  return !t.startsWith(".") && !t.startsWith("/") && !t.startsWith("file:");
}
function CG(t, e) {
  return t.getSourceFile(e) ?? t.getSourceFiles().find((n) => n.fileName === e);
}
function zMe(t, e, n) {
  const i = Ke.resolveModuleName(n, e, t.getCompilerOptions(), Ke.sys).resolvedModule?.resolvedFileName;
  if (!i)
    return;
  const s = CG(t, i);
  if (!(!s || s.isDeclarationFile))
    return s;
}
function jMe(t) {
  if (Ke.isImportDeclaration(t) && Ke.isStringLiteral(t.moduleSpecifier) || Ke.isExportDeclaration(t) && t.moduleSpecifier && Ke.isStringLiteral(t.moduleSpecifier))
    return t.moduleSpecifier.text;
}
function kG(t, e, n) {
  const r = CG(t, e);
  if (!r)
    return [];
  const i = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
  function a(o) {
    if (!s.has(o.fileName)) {
      s.add(o.fileName);
      for (const u of o.statements) {
        const l = jMe(u);
        if (!l)
          continue;
        xG(l) && (!n || n(u, l)) && i.add(l);
        const h = zMe(t, o.fileName, l);
        h && a(h);
      }
    }
  }
  return a(r), [...i];
}
const YMe = {}.hasOwnProperty, qMe = /^([A-Z][a-z\d]*)+$/, JMe = /* @__PURE__ */ new Set([
  "string",
  "function",
  "number",
  "object",
  // Accept 'Function' and 'Object' as alternative to the lower cased version.
  "Function",
  "Object",
  "boolean",
  "bigint",
  "symbol"
]), zi = {};
function qw(t, e = "and") {
  return t.length < 3 ? t.join(` ${e} `) : `${t.slice(0, -1).join(", ")}, ${e} ${t[t.length - 1]}`;
}
const _G = /* @__PURE__ */ new Map(), QMe = "__node_internal_";
let gP;
zi.ERR_INVALID_ARG_TYPE = Qa(
  "ERR_INVALID_ARG_TYPE",
  /**
   * @param {string} name
   * @param {Array<string> | string} expected
   * @param {unknown} actual
   */
  (t, e, n) => {
    Vu.ok(typeof t == "string", "'name' must be a string"), Array.isArray(e) || (e = [e]);
    let r = "The ";
    if (t.endsWith(" argument"))
      r += `${t} `;
    else {
      const o = t.includes(".") ? "property" : "argument";
      r += `"${t}" ${o} `;
    }
    r += "must be ";
    const i = [], s = [], a = [];
    for (const o of e)
      Vu.ok(
        typeof o == "string",
        "All expected entries have to be of type string"
      ), JMe.has(o) ? i.push(o.toLowerCase()) : qMe.exec(o) === null ? (Vu.ok(
        o !== "object",
        'The value "object" should be written as "Object"'
      ), a.push(o)) : s.push(o);
    if (s.length > 0) {
      const o = i.indexOf("object");
      o !== -1 && (i.slice(o, 1), s.push("Object"));
    }
    return i.length > 0 && (r += `${i.length > 1 ? "one of type" : "of type"} ${qw(
      i,
      "or"
    )}`, (s.length > 0 || a.length > 0) && (r += " or ")), s.length > 0 && (r += `an instance of ${qw(s, "or")}`, a.length > 0 && (r += " or ")), a.length > 0 && (a.length > 1 ? r += `one of ${qw(a, "or")}` : (a[0].toLowerCase() !== a[0] && (r += "an "), r += `${a[0]}`)), r += `. Received ${nOe(n)}`, r;
  },
  TypeError
);
zi.ERR_INVALID_MODULE_SPECIFIER = Qa(
  "ERR_INVALID_MODULE_SPECIFIER",
  /**
   * @param {string} request
   * @param {string} reason
   * @param {string} [base]
   */
  (t, e, n = void 0) => `Invalid module "${t}" ${e}${n ? ` imported from ${n}` : ""}`,
  TypeError
);
zi.ERR_INVALID_PACKAGE_CONFIG = Qa(
  "ERR_INVALID_PACKAGE_CONFIG",
  /**
   * @param {string} path
   * @param {string} [base]
   * @param {string} [message]
   */
  (t, e, n) => `Invalid package config ${t}${e ? ` while importing ${e}` : ""}${n ? `. ${n}` : ""}`,
  Error
);
zi.ERR_INVALID_PACKAGE_TARGET = Qa(
  "ERR_INVALID_PACKAGE_TARGET",
  /**
   * @param {string} packagePath
   * @param {string} key
   * @param {unknown} target
   * @param {boolean} [isImport=false]
   * @param {string} [base]
   */
  (t, e, n, r = !1, i = void 0) => {
    const s = typeof n == "string" && !r && n.length > 0 && !n.startsWith("./");
    return e === "." ? (Vu.ok(r === !1), `Invalid "exports" main target ${JSON.stringify(n)} defined in the package config ${t}package.json${i ? ` imported from ${i}` : ""}${s ? '; targets must start with "./"' : ""}`) : `Invalid "${r ? "imports" : "exports"}" target ${JSON.stringify(
      n
    )} defined for '${e}' in the package config ${t}package.json${i ? ` imported from ${i}` : ""}${s ? '; targets must start with "./"' : ""}`;
  },
  Error
);
zi.ERR_MODULE_NOT_FOUND = Qa(
  "ERR_MODULE_NOT_FOUND",
  /**
   * @param {string} path
   * @param {string} base
   * @param {boolean} [exactUrl]
   */
  (t, e, n = !1) => `Cannot find ${n ? "module" : "package"} '${t}' imported from ${e}`,
  Error
);
zi.ERR_NETWORK_IMPORT_DISALLOWED = Qa(
  "ERR_NETWORK_IMPORT_DISALLOWED",
  "import of '%s' by %s is not supported: %s",
  Error
);
zi.ERR_PACKAGE_IMPORT_NOT_DEFINED = Qa(
  "ERR_PACKAGE_IMPORT_NOT_DEFINED",
  /**
   * @param {string} specifier
   * @param {string} packagePath
   * @param {string} base
   */
  (t, e, n) => `Package import specifier "${t}" is not defined${e ? ` in package ${e}package.json` : ""} imported from ${n}`,
  TypeError
);
zi.ERR_PACKAGE_PATH_NOT_EXPORTED = Qa(
  "ERR_PACKAGE_PATH_NOT_EXPORTED",
  /**
   * @param {string} packagePath
   * @param {string} subpath
   * @param {string} [base]
   */
  (t, e, n = void 0) => e === "." ? `No "exports" main defined in ${t}package.json${n ? ` imported from ${n}` : ""}` : `Package subpath '${e}' is not defined by "exports" in ${t}package.json${n ? ` imported from ${n}` : ""}`,
  Error
);
zi.ERR_UNSUPPORTED_DIR_IMPORT = Qa(
  "ERR_UNSUPPORTED_DIR_IMPORT",
  "Directory import '%s' is not supported resolving ES modules imported from %s",
  Error
);
zi.ERR_UNSUPPORTED_RESOLVE_REQUEST = Qa(
  "ERR_UNSUPPORTED_RESOLVE_REQUEST",
  'Failed to resolve module specifier "%s" from "%s": Invalid relative URL or base scheme is not hierarchical.',
  TypeError
);
zi.ERR_UNKNOWN_FILE_EXTENSION = Qa(
  "ERR_UNKNOWN_FILE_EXTENSION",
  /**
   * @param {string} extension
   * @param {string} path
   */
  (t, e) => `Unknown file extension "${t}" for ${e}`,
  TypeError
);
zi.ERR_INVALID_ARG_VALUE = Qa(
  "ERR_INVALID_ARG_VALUE",
  /**
   * @param {string} name
   * @param {unknown} value
   * @param {string} [reason='is invalid']
   */
  (t, e, n = "is invalid") => {
    let r = jy(e);
    return r.length > 128 && (r = `${r.slice(0, 128)}...`), `The ${t.includes(".") ? "property" : "argument"} '${t}' ${n}. Received ${r}`;
  },
  TypeError
  // Note: extra classes have been shaken out.
  // , RangeError
);
function Qa(t, e, n) {
  return _G.set(t, e), XMe(n, t);
}
function XMe(t, e) {
  return n;
  function n(...r) {
    const i = Error.stackTraceLimit;
    cv() && (Error.stackTraceLimit = 0);
    const s = new t();
    cv() && (Error.stackTraceLimit = i);
    const a = tOe(e, r, s);
    return Object.defineProperties(s, {
      // Note: no need to implement `kIsNodeError` symbol, would be hard,
      // probably.
      message: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      },
      toString: {
        /** @this {Error} */
        value() {
          return `${this.name} [${e}]: ${this.message}`;
        },
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), eOe(s), s.code = e, s;
  }
}
function cv() {
  try {
    if (BQ.startupSnapshot.isBuildingSnapshot())
      return !1;
  } catch {
  }
  const t = Object.getOwnPropertyDescriptor(Error, "stackTraceLimit");
  return t === void 0 ? Object.isExtensible(Error) : YMe.call(t, "writable") && t.writable !== void 0 ? t.writable : t.set !== void 0;
}
function ZMe(t) {
  const e = QMe + t.name;
  return Object.defineProperty(t, "name", { value: e }), t;
}
const eOe = ZMe(
  /**
   * @param {Error} error
   * @returns {Error}
   */
  // @ts-expect-error: fine
  function(t) {
    const e = cv();
    return e && (gP = Error.stackTraceLimit, Error.stackTraceLimit = Number.POSITIVE_INFINITY), Error.captureStackTrace(t), e && (Error.stackTraceLimit = gP), t;
  }
);
function tOe(t, e, n) {
  const r = _G.get(t);
  if (Vu.ok(r !== void 0, "expected `message` to be found"), typeof r == "function")
    return Vu.ok(
      r.length <= e.length,
      // Default options do not count.
      `Code: ${t}; The provided arguments length (${e.length}) does not match the required ones (${r.length}).`
    ), Reflect.apply(r, n, e);
  const i = /%[dfijoOs]/g;
  let s = 0;
  for (; i.exec(r) !== null; ) s++;
  return Vu.ok(
    s === e.length,
    `Code: ${t}; The provided arguments length (${e.length}) does not match the required ones (${s}).`
  ), e.length === 0 ? r : (e.unshift(r), Reflect.apply(TQ, null, e));
}
function nOe(t) {
  if (t == null)
    return String(t);
  if (typeof t == "function" && t.name)
    return `function ${t.name}`;
  if (typeof t == "object")
    return t.constructor && t.constructor.name ? `an instance of ${t.constructor.name}` : `${jy(t, { depth: -1 })}`;
  let e = jy(t, { colors: !1 });
  return e.length > 28 && (e = `${e.slice(0, 25)}...`), `type ${typeof t} (${e})`;
}
const um = {}.hasOwnProperty, { ERR_INVALID_PACKAGE_CONFIG: rOe } = zi, pP = /* @__PURE__ */ new Map();
function NG(t, { base: e, specifier: n }) {
  const r = pP.get(t);
  if (r)
    return r;
  let i;
  try {
    i = BM.readFileSync(rr.toNamespacedPath(t), "utf8");
  } catch (a) {
    const o = (
      /** @type {ErrnoException} */
      a
    );
    if (o.code !== "ENOENT")
      throw o;
  }
  const s = {
    exists: !1,
    pjsonPath: t,
    main: void 0,
    name: void 0,
    type: "none",
    // Ignore unknown types for forwards compatibility
    exports: void 0,
    imports: void 0
  };
  if (i !== void 0) {
    let a;
    try {
      a = JSON.parse(i);
    } catch (o) {
      const u = (
        /** @type {ErrnoException} */
        o
      ), l = new rOe(
        t,
        (e ? `"${n}" from ` : "") + wn(e || n),
        u.message
      );
      throw l.cause = u, l;
    }
    s.exists = !0, um.call(a, "name") && typeof a.name == "string" && (s.name = a.name), um.call(a, "main") && typeof a.main == "string" && (s.main = a.main), um.call(a, "exports") && (s.exports = a.exports), um.call(a, "imports") && (s.imports = a.imports), um.call(a, "type") && (a.type === "commonjs" || a.type === "module") && (s.type = a.type);
  }
  return pP.set(t, s), s;
}
function b2(t) {
  let e = new URL("package.json", t);
  for (; !e.pathname.endsWith("node_modules/package.json"); ) {
    const i = NG(wn(e), {
      specifier: t
    });
    if (i.exists)
      return i;
    const s = e;
    if (e = new URL("../package.json", e), e.pathname === s.pathname)
      break;
  }
  return {
    pjsonPath: wn(e),
    exists: !1,
    type: "none"
  };
}
function bP(t) {
  return b2(t).type;
}
const { ERR_UNKNOWN_FILE_EXTENSION: iOe } = zi, sOe = {}.hasOwnProperty, aOe = {
  // @ts-expect-error: hush.
  __proto__: null,
  ".cjs": "commonjs",
  ".js": "module",
  ".json": "json",
  ".mjs": "module"
};
function oOe(t) {
  return t && /\s*(text|application)\/javascript\s*(;\s*charset=utf-?8\s*)?/i.test(t) ? "module" : t === "application/json" ? "json" : null;
}
const yP = {
  // @ts-expect-error: hush.
  __proto__: null,
  "data:": uOe,
  "file:": cOe,
  "http:": AP,
  "https:": AP,
  "node:"() {
    return "builtin";
  }
};
function uOe(t) {
  const { 1: e } = /^([^/]+\/[^;,]+)[^,]*?(;base64)?,/.exec(
    t.pathname
  ) || [null, null, null];
  return oOe(e);
}
function lOe(t) {
  const e = t.pathname;
  let n = e.length;
  for (; n--; ) {
    const r = e.codePointAt(n);
    if (r === 47)
      return "";
    if (r === 46)
      return e.codePointAt(n - 1) === 47 ? "" : e.slice(n);
  }
  return "";
}
function cOe(t, e, n) {
  const r = lOe(t);
  if (r === ".js") {
    const a = bP(t);
    return a !== "none" ? a : "commonjs";
  }
  if (r === "") {
    const a = bP(t);
    return a === "none" || a === "commonjs" ? "commonjs" : "module";
  }
  const i = aOe[r];
  if (i) return i;
  if (n)
    return;
  const s = wn(t);
  throw new iOe(r, s);
}
function AP() {
}
function DG(t, e) {
  const n = t.protocol;
  return sOe.call(yP, n) && yP[n](t, e, !0) || null;
}
const { ERR_INVALID_ARG_VALUE: hOe } = zi, IG = Object.freeze(["node", "import"]), dOe = new Set(IG);
function fOe() {
  return IG;
}
function mOe() {
  return dOe;
}
function RG(t) {
  if (t !== void 0 && t !== fOe()) {
    if (!Array.isArray(t))
      throw new hOe(
        "conditions",
        t,
        "expected an array"
      );
    return new Set(t);
  }
  return mOe();
}
const K0 = RegExp.prototype[Symbol.replace], {
  ERR_NETWORK_IMPORT_DISALLOWED: Jw,
  ERR_INVALID_MODULE_SPECIFIER: LA,
  ERR_INVALID_PACKAGE_CONFIG: PG,
  ERR_INVALID_PACKAGE_TARGET: gOe,
  ERR_MODULE_NOT_FOUND: y2,
  ERR_PACKAGE_IMPORT_NOT_DEFINED: pOe,
  ERR_PACKAGE_PATH_NOT_EXPORTED: bOe,
  ERR_UNSUPPORTED_DIR_IMPORT: yOe,
  ERR_UNSUPPORTED_RESOLVE_REQUEST: EP
} = zi, LG = {}.hasOwnProperty, SP = /(^|\\|\/)((\.|%2e)(\.|%2e)?|(n|%6e|%4e)(o|%6f|%4f)(d|%64|%44)(e|%65|%45)(_|%5f)(m|%6d|%4d)(o|%6f|%4f)(d|%64|%44)(u|%75|%55)(l|%6c|%4c)(e|%65|%45)(s|%73|%53))?(\\|\/|$)/i, wP = /(^|\\|\/)((\.|%2e)(\.|%2e)?|(n|%6e|%4e)(o|%6f|%4f)(d|%64|%44)(e|%65|%45)(_|%5f)(m|%6d|%4d)(o|%6f|%4f)(d|%64|%44)(u|%75|%55)(l|%6c|%4c)(e|%65|%45)(s|%73|%53))(\\|\/|$)/i, AOe = /^\.|%|\\/, z0 = /\*/g, EOe = /%2f|%5c/i, FP = /* @__PURE__ */ new Set(), SOe = /[/\\]{2}/;
function TP(t, e, n, r, i, s, a) {
  if ($s.noDeprecation)
    return;
  const o = wn(r), u = SOe.exec(a ? t : e) !== null;
  $s.emitWarning(
    `Use of deprecated ${u ? "double slash" : "leading or trailing slash matching"} resolving "${t}" for module request "${e}" ${e === n ? "" : `matched to "${n}" `}in the "${i ? "imports" : "exports"}" field module resolution of the package at ${o}${s ? ` imported from ${wn(s)}` : ""}.`,
    "DeprecationWarning",
    "DEP0166"
  );
}
function vP(t, e, n, r) {
  if ($s.noDeprecation || DG(t, { parentURL: n.href }) !== "module") return;
  const s = wn(t.href), a = wn(new URL(".", e)), o = wn(n);
  r ? rr.resolve(a, r) !== s && $s.emitWarning(
    `Package ${a} has a "main" field set to "${r}", excluding the full filename and extension to the resolved file at "${s.slice(
      a.length
    )}", imported from ${o}.
 Automatic extension resolution of the "main" field is deprecated for ES modules.`,
    "DeprecationWarning",
    "DEP0151"
  ) : $s.emitWarning(
    `No "main" or "exports" field defined in the package.json for ${a} resolving the main entry point "${s.slice(
      a.length
    )}", imported from ${o}.
Default "index" lookups for the main are deprecated for ES modules.`,
    "DeprecationWarning",
    "DEP0151"
  );
}
function MG(t) {
  try {
    return $M(t);
  } catch {
  }
}
function Qw(t) {
  const e = $M(t, { throwIfNoEntry: !1 }), n = e ? e.isFile() : void 0;
  return n ?? !1;
}
function wOe(t, e, n) {
  let r;
  if (e.main !== void 0) {
    if (r = new URL(e.main, t), Qw(r)) return r;
    const a = [
      `./${e.main}.js`,
      `./${e.main}.json`,
      `./${e.main}.node`,
      `./${e.main}/index.js`,
      `./${e.main}/index.json`,
      `./${e.main}/index.node`
    ];
    let o = -1;
    for (; ++o < a.length && (r = new URL(a[o], t), !Qw(r)); )
      r = void 0;
    if (r)
      return vP(
        r,
        t,
        n,
        e.main
      ), r;
  }
  const i = ["./index.js", "./index.json", "./index.node"];
  let s = -1;
  for (; ++s < i.length && (r = new URL(i[s], t), !Qw(r)); )
    r = void 0;
  if (r)
    return vP(r, t, n, e.main), r;
  throw new y2(
    wn(new URL(".", t)),
    wn(n)
  );
}
function FOe(t, e, n) {
  if (EOe.exec(t.pathname) !== null)
    throw new LA(
      t.pathname,
      'must not include encoded "/" or "\\" characters',
      wn(e)
    );
  let r;
  try {
    r = wn(t);
  } catch (s) {
    const a = (
      /** @type {ErrnoException} */
      s
    );
    throw Object.defineProperty(a, "input", { value: String(t) }), Object.defineProperty(a, "module", { value: String(e) }), a;
  }
  const i = MG(
    r.endsWith("/") ? r.slice(-1) : r
  );
  if (i && i.isDirectory()) {
    const s = new yOe(r, wn(e));
    throw s.url = String(t), s;
  }
  if (!i || !i.isFile()) {
    const s = new y2(
      r || t.pathname,
      e && wn(e),
      !0
    );
    throw s.url = String(t), s;
  }
  {
    const s = LQ(r), { search: a, hash: o } = t;
    t = ju(s + (r.endsWith(rr.sep) ? "/" : "")), t.search = a, t.hash = o;
  }
  return t;
}
function TOe(t, e, n) {
  return new pOe(
    t,
    e && wn(new URL(".", e)),
    wn(n)
  );
}
function Xw(t, e, n) {
  return new bOe(
    wn(new URL(".", e)),
    t,
    n && wn(n)
  );
}
function vOe(t, e, n, r, i) {
  const s = `request is not a valid match in pattern "${e}" for the "${r ? "imports" : "exports"}" resolution of ${wn(n)}`;
  throw new LA(
    t,
    s,
    i && wn(i)
  );
}
function Bm(t, e, n, r, i) {
  return e = typeof e == "object" && e !== null ? JSON.stringify(e, null, "") : `${e}`, new gOe(
    wn(new URL(".", n)),
    t,
    e,
    r,
    i && wn(i)
  );
}
function xOe(t, e, n, r, i, s, a, o, u) {
  if (e !== "" && !s && t[t.length - 1] !== "/")
    throw Bm(n, t, r, a, i);
  if (!t.startsWith("./")) {
    if (a && !t.startsWith("../") && !t.startsWith("/")) {
      let m = !1;
      try {
        new URL(t), m = !0;
      } catch {
      }
      if (!m) {
        const g = s ? K0.call(
          z0,
          t,
          () => e
        ) : t + e;
        return BG(g, r, u);
      }
    }
    throw Bm(n, t, r, a, i);
  }
  if (SP.exec(t.slice(2)) !== null)
    if (wP.exec(t.slice(2)) === null) {
      if (!o) {
        const m = s ? n.replace("*", () => e) : n + e, g = s ? K0.call(
          z0,
          t,
          () => e
        ) : t;
        TP(
          g,
          m,
          n,
          r,
          a,
          i,
          !0
        );
      }
    } else
      throw Bm(n, t, r, a, i);
  const l = new URL(t, r), h = l.pathname, f = new URL(".", r).pathname;
  if (!h.startsWith(f))
    throw Bm(n, t, r, a, i);
  if (e === "") return l;
  if (SP.exec(e) !== null) {
    const m = s ? n.replace("*", () => e) : n + e;
    if (wP.exec(e) === null) {
      if (!o) {
        const g = s ? K0.call(
          z0,
          t,
          () => e
        ) : t;
        TP(
          g,
          m,
          n,
          r,
          a,
          i,
          !1
        );
      }
    } else
      vOe(m, n, r, a, i);
  }
  return s ? new URL(
    K0.call(
      z0,
      l.href,
      () => e
    )
  ) : new URL(e, l);
}
function COe(t) {
  const e = Number(t);
  return `${e}` !== t ? !1 : e >= 0 && e < 4294967295;
}
function Ef(t, e, n, r, i, s, a, o, u) {
  if (typeof e == "string")
    return xOe(
      e,
      n,
      r,
      t,
      i,
      s,
      a,
      o,
      u
    );
  if (Array.isArray(e)) {
    const l = e;
    if (l.length === 0) return null;
    let h, f = -1;
    for (; ++f < l.length; ) {
      const m = l[f];
      let g;
      try {
        g = Ef(
          t,
          m,
          n,
          r,
          i,
          s,
          a,
          o,
          u
        );
      } catch (A) {
        const E = (
          /** @type {ErrnoException} */
          A
        );
        if (h = E, E.code === "ERR_INVALID_PACKAGE_TARGET") continue;
        throw A;
      }
      if (g !== void 0) {
        if (g === null) {
          h = null;
          continue;
        }
        return g;
      }
    }
    if (h == null)
      return null;
    throw h;
  }
  if (typeof e == "object" && e !== null) {
    const l = Object.getOwnPropertyNames(e);
    let h = -1;
    for (; ++h < l.length; ) {
      const f = l[h];
      if (COe(f))
        throw new PG(
          wn(t),
          i,
          '"exports" cannot contain numeric property keys.'
        );
    }
    for (h = -1; ++h < l.length; ) {
      const f = l[h];
      if (f === "default" || u && u.has(f)) {
        const m = (
          /** @type {unknown} */
          e[f]
        ), g = Ef(
          t,
          m,
          n,
          r,
          i,
          s,
          a,
          o,
          u
        );
        if (g === void 0) continue;
        return g;
      }
    }
    return null;
  }
  if (e === null)
    return null;
  throw Bm(
    r,
    e,
    t,
    a,
    i
  );
}
function kOe(t, e, n) {
  if (typeof t == "string" || Array.isArray(t)) return !0;
  if (typeof t != "object" || t === null) return !1;
  const r = Object.getOwnPropertyNames(t);
  let i = !1, s = 0, a = -1;
  for (; ++a < r.length; ) {
    const o = r[a], u = o === "" || o[0] !== ".";
    if (s++ === 0)
      i = u;
    else if (i !== u)
      throw new PG(
        wn(e),
        n,
        `"exports" cannot contain some keys starting with '.' and some not. The exports object must either be an object of package subpath keys or an object of main entry condition name keys only.`
      );
  }
  return i;
}
function _Oe(t, e, n) {
  if ($s.noDeprecation)
    return;
  const r = wn(e);
  FP.has(r + "|" + t) || (FP.add(r + "|" + t), $s.emitWarning(
    `Use of deprecated trailing slash pattern mapping "${t}" in the "exports" field module resolution of the package at ${r}${n ? ` imported from ${wn(n)}` : ""}. Mapping specifiers ending in "/" is no longer supported.`,
    "DeprecationWarning",
    "DEP0155"
  ));
}
function xP(t, e, n, r, i) {
  let s = n.exports;
  if (kOe(s, t, r) && (s = { ".": s }), LG.call(s, e) && !e.includes("*") && !e.endsWith("/")) {
    const h = s[e], f = Ef(
      t,
      h,
      "",
      e,
      r,
      !1,
      !1,
      !1,
      i
    );
    if (f == null)
      throw Xw(e, t, r);
    return f;
  }
  let a = "", o = "";
  const u = Object.getOwnPropertyNames(s);
  let l = -1;
  for (; ++l < u.length; ) {
    const h = u[l], f = h.indexOf("*");
    if (f !== -1 && e.startsWith(h.slice(0, f))) {
      e.endsWith("/") && _Oe(
        e,
        t,
        r
      );
      const m = h.slice(f + 1);
      e.length >= h.length && e.endsWith(m) && OG(a, h) === 1 && h.lastIndexOf("*") === f && (a = h, o = e.slice(
        f,
        e.length - m.length
      ));
    }
  }
  if (a) {
    const h = (
      /** @type {unknown} */
      s[a]
    ), f = Ef(
      t,
      h,
      o,
      a,
      r,
      !0,
      !1,
      e.endsWith("/"),
      i
    );
    if (f == null)
      throw Xw(e, t, r);
    return f;
  }
  throw Xw(e, t, r);
}
function OG(t, e) {
  const n = t.indexOf("*"), r = e.indexOf("*"), i = n === -1 ? t.length : n + 1, s = r === -1 ? e.length : r + 1;
  return i > s ? -1 : s > i || n === -1 ? 1 : r === -1 || t.length > e.length ? -1 : e.length > t.length ? 1 : 0;
}
function NOe(t, e, n) {
  if (t === "#" || t.startsWith("#/") || t.endsWith("/")) {
    const s = "is not a valid internal imports specifier name";
    throw new LA(t, s, wn(e));
  }
  let r;
  const i = b2(e);
  if (i.exists) {
    r = ju(i.pjsonPath);
    const s = i.imports;
    if (s)
      if (LG.call(s, t) && !t.includes("*")) {
        const a = Ef(
          r,
          s[t],
          "",
          t,
          e,
          !1,
          !0,
          !1,
          n
        );
        if (a != null)
          return a;
      } else {
        let a = "", o = "";
        const u = Object.getOwnPropertyNames(s);
        let l = -1;
        for (; ++l < u.length; ) {
          const h = u[l], f = h.indexOf("*");
          if (f !== -1 && t.startsWith(h.slice(0, -1))) {
            const m = h.slice(f + 1);
            t.length >= h.length && t.endsWith(m) && OG(a, h) === 1 && h.lastIndexOf("*") === f && (a = h, o = t.slice(
              f,
              t.length - m.length
            ));
          }
        }
        if (a) {
          const h = s[a], f = Ef(
            r,
            h,
            o,
            a,
            e,
            !0,
            !0,
            !1,
            n
          );
          if (f != null)
            return f;
        }
      }
  }
  throw TOe(t, r, e);
}
function DOe(t, e) {
  let n = t.indexOf("/"), r = !0, i = !1;
  t[0] === "@" && (i = !0, n === -1 || t.length === 0 ? r = !1 : n = t.indexOf("/", n + 1));
  const s = n === -1 ? t : t.slice(0, n);
  if (AOe.exec(s) !== null && (r = !1), !r)
    throw new LA(
      t,
      "is not a valid package name",
      wn(e)
    );
  const a = "." + (n === -1 ? "" : t.slice(n));
  return { packageName: s, packageSubpath: a, isScoped: i };
}
function BG(t, e, n) {
  if (vx.includes(t))
    return new URL("node:" + t);
  const { packageName: r, packageSubpath: i, isScoped: s } = DOe(
    t,
    e
  ), a = b2(e);
  if (a.exists) {
    const h = ju(a.pjsonPath);
    if (a.name === r && a.exports !== void 0 && a.exports !== null)
      return xP(
        h,
        i,
        a,
        e,
        n
      );
  }
  let o = new URL(
    "./node_modules/" + r + "/package.json",
    e
  ), u = wn(o), l;
  do {
    const h = MG(u.slice(0, -13));
    if (!h || !h.isDirectory()) {
      l = u, o = new URL(
        (s ? "../../../../node_modules/" : "../../../node_modules/") + r + "/package.json",
        o
      ), u = wn(o);
      continue;
    }
    const f = NG(u, { base: e, specifier: t });
    return f.exports !== void 0 && f.exports !== null ? xP(
      o,
      i,
      f,
      e,
      n
    ) : i === "." ? wOe(o, f, e) : new URL(i, o);
  } while (u.length !== l.length);
  throw new y2(r, wn(e), !1);
}
function IOe(t) {
  return t[0] === "." && (t.length === 1 || t[1] === "/" || t[1] === "." && (t.length === 2 || t[2] === "/"));
}
function A2(t) {
  return t === "" ? !1 : t[0] === "/" ? !0 : IOe(t);
}
function ROe(t, e, n, r) {
  n === void 0 && (n = RG());
  const i = e.protocol, a = i === "data:" || i === "http:" || i === "https:";
  let o;
  if (A2(t))
    try {
      o = new URL(t, e);
    } catch (u) {
      const l = new EP(t, e);
      throw l.cause = u, l;
    }
  else if (i === "file:" && t[0] === "#")
    o = NOe(t, e, n);
  else
    try {
      o = new URL(t);
    } catch (u) {
      if (a && !vx.includes(t)) {
        const l = new EP(t, e);
        throw l.cause = u, l;
      }
      o = BG(t, e, n);
    }
  return Vu.ok(o !== void 0, "expected to be defined"), o.protocol !== "file:" ? o : FOe(o, e);
}
function POe(t, e, n) {
  if (n) {
    const r = n.protocol;
    if (r === "http:" || r === "https:") {
      if (A2(t)) {
        const i = e?.protocol;
        if (i && i !== "https:" && i !== "http:")
          throw new Jw(
            t,
            n,
            "remote imports cannot import from a local location."
          );
        return { url: e?.href || "" };
      }
      throw vx.includes(t) ? new Jw(
        t,
        n,
        "remote imports cannot import from a local location."
      ) : new Jw(
        t,
        n,
        "only relative and absolute specifiers are supported."
      );
    }
  }
}
function LOe(t) {
  return !!(t && typeof t == "object" && "href" in t && typeof t.href == "string" && "protocol" in t && typeof t.protocol == "string" && t.href && t.protocol);
}
function MOe(t) {
  if (t !== void 0 && typeof t != "string" && !LOe(t))
    throw new zi.ERR_INVALID_ARG_TYPE(
      "parentURL",
      ["string", "URL"],
      t
    );
}
function OOe(t, e = {}) {
  const { parentURL: n } = e;
  Vu.ok(n !== void 0, "expected `parentURL` to be defined"), MOe(n);
  let r;
  if (n)
    try {
      r = new URL(n);
    } catch {
    }
  let i, s;
  try {
    if (i = A2(t) ? new URL(t, r) : new URL(t), s = i.protocol, s === "data:")
      return { url: i.href, format: null };
  } catch {
  }
  const a = POe(
    t,
    i,
    r
  );
  if (a) return a;
  if (s === void 0 && i && (s = i.protocol), s === "node:")
    return { url: t };
  if (i && i.protocol === "node:") return { url: t };
  const o = RG(e.conditions), u = ROe(t, new URL(n), o);
  return {
    // Do NOT cast `url` to a string: that will work even when there are real
    // problems, silencing them
    url: u.href,
    format: DG(u, { parentURL: n })
  };
}
function BOe(t, e) {
  if (!e)
    throw new Error(
      "Please pass `parent`: `import-meta-resolve` cannot ponyfill that"
    );
  try {
    return OOe(t, { parentURL: e }).url;
  } catch (n) {
    const r = (
      /** @type {ErrnoException} */
      n
    );
    if ((r.code === "ERR_UNSUPPORTED_DIR_IMPORT" || r.code === "ERR_MODULE_NOT_FOUND") && typeof r.url == "string")
      return r.url;
    throw n;
  }
}
function $Oe(t, e) {
  const n = ju(t).href;
  try {
    return wn(BOe(e, n));
  } catch {
    return;
  }
}
function E2(t, e) {
  const n = $Oe(t, e);
  if (n)
    return ju(n).href;
}
function $G(t) {
  if (t.startsWith("@")) {
    const [e = "", n = ""] = t.split("/");
    return `${e}/${n}`;
  }
  return t.split("/")[0] ?? t;
}
function HG(t) {
  const e = t.split("/").pop();
  if (e)
    return /^[A-Za-z_$][A-Za-z0-9_$]*$/.test(e) ? e : void 0;
}
function HOe(t) {
  const e = t.default, n = Array.isArray(e) ? e : e?.extensions ?? t.extensions;
  return Array.isArray(n) ? n : [];
}
async function UOe(t, e) {
  const n = E2(e, `${t}/extensions`);
  if (!n)
    return [];
  try {
    const r = await import(n);
    return HOe(r);
  } catch (r) {
    if (GOe(r))
      return [];
    throw r;
  }
}
function GOe(t) {
  return t instanceof Error && "code" in t && (t.code === "ERR_MODULE_NOT_FOUND" || t.code === "MODULE_NOT_FOUND");
}
async function UG(t, e, n) {
  const r = [...new Set(t.filter(xG).map($G))];
  return (await Promise.all(
    r.map(async (s) => (await UOe(s, e)).map(n).filter((o) => o !== void 0))
  )).flat();
}
async function WOe(t, e, n) {
  const r = kG(t, e);
  if (r.length === 0)
    return [];
  const i = await UG(
    r,
    n,
    VOe
  ), s = new Set(r), a = [];
  for (const o of i) {
    if (!s.has(o.moduleSpecifier))
      continue;
    const u = E2(n, o.moduleSpecifier);
    u && a.push({
      hookName: o.hookName,
      moduleSpecifier: o.moduleSpecifier,
      resolvedModuleUrl: u,
      contextSchema: o.contextSchema,
      contextDependencies: o.contextDependencies
    });
  }
  return a;
}
function VOe(t) {
  if (t === null || typeof t != "object")
    return;
  const e = t, r = e.options?.compData?.editorContextProvider ?? e, i = r.resources, s = i?.contextSpecifier;
  if (!s?.hook || !s?.moduleSpecifier)
    return;
  const a = i?.dependencies;
  return {
    hookName: s.hook,
    moduleSpecifier: s.moduleSpecifier,
    contextSchema: {
      items: r.context?.items ?? {}
    },
    contextDependencies: a?.contextDependencies ?? []
  };
}
const KOe = {
  useState: (t) => [
    typeof t == "function" ? t() : t,
    () => {
    }
  ],
  useReducer: (t, e, n) => [
    typeof n == "function" ? n(e) : e,
    () => {
    }
  ],
  useRef: (t) => ({ current: t }),
  useMemo: (t) => {
    try {
      return t();
    } catch {
      return;
    }
  },
  useCallback: (t) => t,
  useTransition: () => [!1, () => {
  }],
  useDeferredValue: (t) => t,
  useSyncExternalStore: (t, e) => e()
}, zOe = () => {
};
async function jOe(t, e, n = []) {
  m$();
  const r = [];
  for (const i of t) {
    const s = await qOe(i, n);
    if (!s) {
      console.warn(
        `Could not capture context for hook "${i.hookName}" from "${i.moduleSpecifier}" — skipping mock provider.`
      );
      continue;
    }
    const a = pH(i.contextSchema), o = JOe(s, a, e);
    r.push({
      moduleSpecifier: i.moduleSpecifier,
      contextDependencies: i.contextDependencies,
      Provider: o
    });
  }
  return r;
}
function YOe(t, e, n) {
  const r = QOe(t);
  return (i) => e((a) => {
    let o = n.createElement(i, a);
    for (const { Provider: u } of r)
      o = n.createElement(u, null, o);
    return o;
  });
}
async function qOe(t, e) {
  const i = (await import(cEe(t.resolvedModuleUrl, e)))[t.hookName];
  if (typeof i != "function")
    return null;
  let s = null;
  const a = (f) => (s || (s = f), {}), o = /* @__PURE__ */ Symbol.for("zero-config:react-originals"), u = globalThis[o];
  if (!u)
    throw new Error(
      `React shim is not registered under Symbol.for('${o.description}') — ensure ensureReactRuntimeLoader() was called before loadMockProviders()`
    );
  const l = u.useContext;
  u.useContext = a;
  const h = {};
  for (const f of Object.keys(u))
    f !== "useContext" && f.startsWith("use") && typeof u[f] == "function" && (h[f] = u[f], u[f] = KOe[f] ?? zOe);
  try {
    i();
  } catch {
  } finally {
    u.useContext = l;
    for (const [f, m] of Object.entries(h))
      u[f] = m;
  }
  return s;
}
function JOe(t, e, n) {
  return ({ children: r }) => n.createElement(t.Provider, { value: e }, r);
}
function QOe(t) {
  const e = new Map(t.map((s) => [s.moduleSpecifier, s])), n = /* @__PURE__ */ new Set(), r = [];
  function i(s) {
    if (n.has(s))
      return;
    n.add(s);
    const a = e.get(s);
    if (a) {
      for (const o of a.contextDependencies)
        e.has(o) && i(o);
      r.push(a);
    }
  }
  for (const s of t)
    i(s.moduleSpecifier);
  return r.reverse();
}
function XOe(t) {
  const e = t.props.elementProps;
  if (!e)
    return [];
  const n = /* @__PURE__ */ new Set();
  return My(e.resolvedType, void 0, !0, n), [...n];
}
function My(t, e, n, r) {
  if (t.kind === "union" || t.kind === "intersection") {
    for (const i of t.types ?? [])
      My(i, e, n, r);
    return;
  }
  if (t.kind === "object")
    for (const [i, s] of Object.entries(t.properties ?? {})) {
      if (i === "elementProps") {
        const o = e ? `${e}.elementProps` : void 0;
        My(s.resolvedType, o, !0, r);
        continue;
      }
      const a = e ? `${e}.${i}` : i;
      n && r.add(a), My(s.resolvedType, a, !1, r);
    }
}
async function ZOe(t, e, n, r) {
  const i = kG(
    t,
    e,
    nBe
  );
  return {
    eligiblePaths: XOe(n),
    runtimeModules: await eBe(i, r)
  };
}
async function eBe(t, e) {
  if (t.length === 0)
    return [];
  const n = new Set(t), r = await UG(
    t,
    e,
    tBe
  ), i = /* @__PURE__ */ new Map();
  for (const a of r) {
    if (!n.has(a.moduleSpecifier))
      continue;
    const o = i.get(a.moduleSpecifier) ?? /* @__PURE__ */ new Set();
    o.add(a.refComponentType), i.set(a.moduleSpecifier, o);
  }
  const s = [];
  for (const [a, o] of i.entries()) {
    if (o.size !== 1)
      continue;
    const u = [...o][0];
    if (!u)
      continue;
    const l = E2(e, a);
    l && s.push({
      exportNames: sBe(a),
      moduleSpecifier: a,
      resolvedModuleUrl: l,
      refComponentType: u
    });
  }
  return s;
}
function tBe(t) {
  const e = t, n = e.options ?? e, r = n.resources?.client?.moduleSpecifier, i = n.type;
  if (!(!r || !i))
    return {
      moduleSpecifier: r,
      refComponentType: i
    };
}
function nBe(t, e) {
  const n = HG(e);
  return n ? Ke.isImportDeclaration(t) ? rBe(t, n) : Ke.isExportDeclaration(t) ? iBe(t, n) : !1 : !1;
}
function rBe(t, e) {
  const n = t.importClause;
  return n ? n.name ? !0 : !n.namedBindings || !Ke.isNamedImports(n.namedBindings) ? !1 : n.namedBindings.elements.some((r) => (r.propertyName?.text ?? r.name.text) === e) : !1;
}
function iBe(t, e) {
  return !t.exportClause || !Ke.isNamedExports(t.exportClause) ? !1 : t.exportClause.elements.some((n) => {
    const r = n.propertyName?.text ?? n.name.text;
    return r === "default" || r === e;
  });
}
function sBe(t) {
  const e = /* @__PURE__ */ new Set(["default"]);
  if ($G(t) === t)
    return [...e];
  const n = HG(t);
  return n && e.add(n), [...e];
}
var Zw = {}, Vc = {}, lm = {}, CP;
function aBe() {
  if (CP) return lm;
  CP = 1, Object.defineProperty(lm, "__esModule", { value: !0 }), lm.buildFilter = void 0;
  function t(e) {
    return function(n, r) {
      var i = e.propFilter;
      if (n.name === "children" && n.description.length === 0 && e.skipChildrenPropWithoutDoc !== !1)
        return !1;
      if (typeof i == "function") {
        var s = i(n, r);
        if (!s)
          return !1;
      } else if (typeof i == "object") {
        var a = i, o = a.skipPropsWithName, u = a.skipPropsWithoutDoc;
        if (typeof o == "string" && o === n.name)
          return !1;
        if (Array.isArray(o) && o.indexOf(n.name) > -1 || u && n.description.length === 0)
          return !1;
      }
      return !0;
    };
  }
  return lm.buildFilter = t, lm;
}
var cm = {}, kP;
function oBe() {
  if (kP) return cm;
  kP = 1, Object.defineProperty(cm, "__esModule", { value: !0 }), cm.trimFileName = void 0;
  var t = qr, e = /[\\/]/g, n = /* @__PURE__ */ new Map();
  function r(i, s, a) {
    var o;
    if (s === void 0 && (s = process.cwd()), n.has(i))
      return n.get(i);
    var u = a ? t[a] : t, l = ((o = i.match(e)) === null || o === void 0 ? void 0 : o[0]) || u.sep, h = u.normalize(i), f = u.parse(s).root, m = s;
    do {
      if (h.startsWith(m)) {
        var g = u.relative(u.dirname(m), h).replace(e, l);
        return n.set(i, g), g;
      }
      m = u.dirname(m);
    } while (m !== f);
    return n.set(i, i), i;
  }
  return cm.trimFileName = r, cm;
}
var _P;
function uBe() {
  return _P || (_P = 1, (function(t) {
    var e = Vc && Vc.__assign || function() {
      return e = Object.assign || function(J) {
        for (var G, H = 1, q = arguments.length; H < q; H++) {
          G = arguments[H];
          for (var X in G) Object.prototype.hasOwnProperty.call(G, X) && (J[X] = G[X]);
        }
        return J;
      }, e.apply(this, arguments);
    }, n = Vc && Vc.__spreadArray || function(J, G) {
      for (var H = 0, q = G.length, X = J.length; H < q; H++, X++)
        J[X] = G[H];
      return J;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.getDefaultExportForFile = t.Parser = t.withCompilerOptions = t.withCustomConfig = t.withDefaultConfig = t.parse = t.defaultOptions = t.defaultParserOpts = void 0;
    var r = As, i = qr, s = Ke, a = aBe(), o = oBe();
    t.defaultParserOpts = {}, t.defaultOptions = {
      jsx: s.JsxEmit.React,
      module: s.ModuleKind.CommonJS,
      target: s.ScriptTarget.Latest,
      esModuleInterop: !0
    };
    function u(J, G) {
      return G === void 0 && (G = t.defaultParserOpts), f(t.defaultOptions, G).parse(J);
    }
    t.parse = u;
    function l(J) {
      return J === void 0 && (J = t.defaultParserOpts), f(t.defaultOptions, J);
    }
    t.withDefaultConfig = l;
    function h(J, G) {
      var H = i.dirname(J), q = s.readConfigFile(J, function(Le) {
        return r.readFileSync(Le, "utf8");
      }), X = q.config, ie = q.error;
      if (ie !== void 0) {
        var te = "Cannot load custom tsconfig.json from provided path: " + J + ", with error code: " + ie.code + ", message: " + ie.messageText;
        throw new Error(te);
      }
      var Pe = s.parseJsonConfigFileContent(X, s.sys, H, {}, J), We = Pe.options, Me = Pe.errors;
      if (Me && Me.length)
        throw Me[0] instanceof Error ? Me[0] : Me[0].messageText ? new Error("TS" + Me[0].code + ": " + Me[0].messageText) : new Error(JSON.stringify(Me[0]));
      return f(We, G);
    }
    t.withCustomConfig = h;
    function f(J, G) {
      return G === void 0 && (G = t.defaultParserOpts), {
        parse: function(H) {
          return j(H, J, G);
        },
        parseWithProgramProvider: function(H, q) {
          return j(H, J, G, q);
        }
      };
    }
    t.withCompilerOptions = f;
    var m = function(J) {
      return (J.getFlags() & s.SymbolFlags.Optional) !== 0;
    }, g = {
      description: "",
      fullComment: "",
      tags: {}
    }, A = (
      /** @class */
      (function() {
        function J(G, H) {
          this.propertiesOfPropsCache = /* @__PURE__ */ new Map(), this.componentsInfoCache = /* @__PURE__ */ new Map();
          var q = H.savePropValueAsString, X = H.shouldExtractLiteralValuesFromEnum, ie = H.shouldRemoveUndefinedFromOptional, te = H.shouldExtractValuesFromUnion, Pe = H.shouldSortUnions, We = H.shouldIncludePropTagMap, Me = H.shouldIncludeExpression;
          this.checker = G.getTypeChecker(), this.propFilter = a.buildFilter(H), this.shouldExtractLiteralValuesFromEnum = !!X, this.shouldRemoveUndefinedFromOptional = !!ie, this.shouldExtractValuesFromUnion = !!te, this.shouldSortUnions = !!Pe, this.savePropValueAsString = !!q, this.shouldIncludePropTagMap = !!We, this.shouldIncludeExpression = !!Me;
        }
        return J.prototype.getTypeSymbol = function(G) {
          var H = G.valueDeclaration || G.declarations[0], q = this.checker.getTypeOfSymbolAtLocation(G, H), X = q.symbol || q.aliasSymbol;
          return X;
        }, J.prototype.isPlainObjectType = function(G) {
          var H = G;
          G.flags & s.SymbolFlags.Alias && (H = this.checker.getAliasedSymbol(G));
          var q = H.valueDeclaration;
          if (!q || s.isClassDeclaration(q))
            return !1;
          var X = this.checker.getTypeOfSymbolAtLocation(H, q);
          if (!(X.flags & s.TypeFlags.Object))
            return !1;
          var ie = X, te = !!(ie.objectFlags & (s.ObjectFlags.Anonymous | s.ObjectFlags.ObjectLiteral));
          return te;
        }, J.prototype.getComponentExports = function(G) {
          var H = G;
          if (H.exports)
            return { symbol: H, exports: H.exports };
          if (G.flags & s.SymbolFlags.Alias && (H = this.checker.getAliasedSymbol(G)), H.exports)
            return { symbol: H, exports: H.exports };
        }, J.prototype.getComponentFromExpression = function(G) {
          var H = G.valueDeclaration || G.declarations[0];
          if (H && s.isPropertyAssignment(H) && s.isIdentifier(H.initializer)) {
            var q = this.checker.getSymbolAtLocation(H.initializer);
            q && (G = q, H = G.valueDeclaration || G.declarations[0]);
          }
          var X = this.checker.getTypeOfSymbolAtLocation(G, H), ie = X.symbol || X.aliasSymbol;
          if (!ie)
            return G;
          var te = ie.getName();
          if ((te === "MemoExoticComponent" || te === "ForwardRefExoticComponent") && G.valueDeclaration && s.isExportAssignment(G.valueDeclaration) && s.isCallExpression(G.valueDeclaration.expression)) {
            var Pe = this.checker.getSymbolAtLocation(G.valueDeclaration.expression.arguments[0]);
            Pe && (G = Pe);
          }
          return G;
        }, J.prototype.getComponentInfo = function(G, H, q, X) {
          if (q === void 0 && (q = function() {
          }), X === void 0 && (X = []), G.declarations && G.declarations.length === 0)
            return null;
          var ie = this.getComponentFromExpression(G), te = ie.valueDeclaration || ie.declarations[0], Pe = this.checker.getTypeOfSymbolAtLocation(ie, te), We = ie, Me = Pe.symbol || Pe.aliasSymbol, Le = ie.getName(), fn = H.fileName, Yt = fn + "_" + Le;
          if (this.componentsInfoCache.has(Yt))
            return this.componentsInfoCache.get(Yt);
          if (ie.valueDeclaration)
            Pe.symbol && (s.isPropertyAccessExpression(te) || s.isPropertyDeclaration(te)) && (We = Pe.symbol);
          else if (!Me && (ie.flags & s.SymbolFlags.Alias) !== 0)
            We = this.checker.getAliasedSymbol(We);
          else if (Me) {
            ie = Me;
            var Rn = ie.getName(), Pn = [
              "__function",
              "StatelessComponent",
              "Stateless",
              "StyledComponentClass",
              "StyledComponent",
              "IStyledComponent",
              "FunctionComponent",
              "ForwardRefExoticComponent",
              "MemoExoticComponent"
            ], ls = n(n([], Pn), X);
            ls.indexOf(Rn) !== -1 ? We = this.checker.getAliasedSymbol(We) : We = ie;
          } else
            return this.componentsInfoCache.set(Yt, null), null;
          if (Me && (Me.getEscapedName() === "Requireable" || Me.getEscapedName() === "Validator"))
            return this.componentsInfoCache.set(Yt, null), null;
          var Tn = this.extractPropsFromTypeIfStatelessComponent(Pe) || this.extractPropsFromTypeIfStatefulComponent(Pe), qt = Le === "default" ? ie : We, yr = q(qt, H), $n = this.findDocComment(We), Cr = $n.description, ii = $n.tags, Hn = yr || ii.visibleName || C(qt, H, X), cs = this.getMethodsInfo(Pe), hs = null;
          if (Tn) {
            if (!We.valueDeclaration)
              return this.componentsInfoCache.set(Yt, null), null;
            for (var oe = this.extractDefaultPropsFromComponent(We, We.valueDeclaration.getSourceFile()), Te = this.getPropsInfo(Tn, oe), Je = 0, rt = Object.keys(Te); Je < rt.length; Je++) {
              var Ue = rt[Je], rn = Te[Ue], Vs = { name: Hn };
              this.propFilter(rn, Vs) || delete Te[Ue];
            }
            hs = {
              tags: ii,
              filePath: fn,
              description: Cr,
              displayName: Hn,
              methods: cs,
              props: Te
            };
          } else Cr && Hn && (hs = {
            tags: ii,
            filePath: fn,
            description: Cr,
            displayName: Hn,
            methods: cs,
            props: {}
          });
          return hs !== null && this.shouldIncludeExpression && (hs.expression = ie, hs.rootExpression = G), this.componentsInfoCache.set(Yt, hs), hs;
        }, J.prototype.extractPropsFromTypeIfStatelessComponent = function(G) {
          var H = G.getCallSignatures();
          if (H.length)
            for (var q = 0, X = H; q < X.length; q++) {
              var ie = X[q], te = ie.getParameters();
              if (te.length !== 0) {
                var Pe = te[0];
                if (Pe.name === "props" || te.length === 1)
                  return Pe;
              }
            }
          return null;
        }, J.prototype.extractPropsFromTypeIfStatefulComponent = function(G) {
          var H = G.getConstructSignatures();
          if (H.length)
            for (var q = 0, X = H; q < X.length; q++) {
              var ie = X[q], te = ie.getReturnType(), Pe = te.getProperty("props");
              if (Pe)
                return Pe;
            }
          return null;
        }, J.prototype.extractMembersFromType = function(G) {
          var H = this, q = [];
          return G.getProperties().forEach(function(X) {
            H.getCallSignature(X) && q.push(X);
          }), G.symbol && G.symbol.members && G.symbol.members.forEach(function(X) {
            q.push(X);
          }), q;
        }, J.prototype.getMethodsInfo = function(G) {
          var H = this, q = this.extractMembersFromType(G), X = [];
          return q.forEach(function(ie) {
            if (H.isTaggedPublic(ie)) {
              var te = ie.getName(), Pe = H.getFullJsDocComment(ie).fullComment, We = H.getCallSignature(ie), Me = H.getParameterInfo(We), Le = s.displayPartsToString(ie.getDocumentationComment(H.checker)), fn = H.checker.typeToString(We.getReturnType()), Yt = s.displayPartsToString(H.getReturnDescription(ie)), Rn = H.getModifiers(ie);
              X.push({
                description: Le,
                docblock: Pe,
                modifiers: Rn,
                name: te,
                params: Me,
                returns: Yt ? {
                  description: Yt,
                  type: fn
                } : null
              });
            }
          }), X;
        }, J.prototype.getModifiers = function(G) {
          var H = [];
          if (!G.valueDeclaration)
            return H;
          var q = s.getCombinedModifierFlags(G.valueDeclaration), X = (q & s.ModifierFlags.Static) !== 0;
          return X && H.push("static"), H;
        }, J.prototype.getParameterInfo = function(G) {
          var H = this;
          return G.parameters.map(function(q) {
            var X = H.checker.getTypeOfSymbolAtLocation(q, q.valueDeclaration), ie = H.checker.symbolToParameterDeclaration(q, void 0, void 0), te = !!(ie && ie.questionToken);
            return {
              description: s.displayPartsToString(q.getDocumentationComment(H.checker)) || null,
              name: q.getName() + (te ? "?" : ""),
              type: { name: H.checker.typeToString(X) }
            };
          });
        }, J.prototype.getCallSignature = function(G) {
          var H = this.checker.getTypeOfSymbolAtLocation(G, G.valueDeclaration);
          return H.getCallSignatures()[0];
        }, J.prototype.isTaggedPublic = function(G) {
          var H = G.getJsDocTags();
          return !!H.find(function(q) {
            return q.name === "public";
          });
        }, J.prototype.getReturnDescription = function(G) {
          var H = G.getJsDocTags(), q = H.find(function(X) {
            return X.name === "returns";
          });
          if (!(!q || !Array.isArray(q.text)))
            return q.text;
        }, J.prototype.getValuesFromUnionType = function(G) {
          return G.isStringLiteral() ? '"' + G.value + '"' : G.isNumberLiteral() ? "" + G.value : this.checker.typeToString(G);
        }, J.prototype.getInfoFromUnionType = function(G) {
          var H = {};
          return G.getSymbol() && (H = e({}, this.getFullJsDocComment(G.getSymbol()))), e({ value: this.getValuesFromUnionType(G) }, H);
        }, J.prototype.getDocgenType = function(G, H) {
          var q = this;
          G.getConstraint() && (G = G.getConstraint());
          var X = this.checker.typeToString(G);
          if (this.shouldRemoveUndefinedFromOptional && !H && (X = X.replace(" | undefined", "")), G.isUnion() && (this.shouldExtractValuesFromUnion || this.shouldExtractLiteralValuesFromEnum && G.types.every(function(te) {
            return te.getFlags() & (s.TypeFlags.StringLiteral | s.TypeFlags.NumberLiteral | s.TypeFlags.EnumLiteral | s.TypeFlags.Undefined);
          }))) {
            var ie = G.types.map(function(te) {
              return q.getInfoFromUnionType(te);
            });
            return this.shouldRemoveUndefinedFromOptional && !H && (ie = ie.filter(function(te) {
              return te.value != "undefined";
            })), this.shouldSortUnions && ie.sort(function(te, Pe) {
              return te.value.toString().localeCompare(Pe.value.toString());
            }), {
              name: "enum",
              raw: X,
              value: ie
            };
          }
          return this.shouldRemoveUndefinedFromOptional && !H && (X = X.replace(" | undefined", "")), { name: X };
        }, J.prototype.getPropsInfo = function(G, H) {
          var q = this;
          if (H === void 0 && (H = {}), !G.valueDeclaration)
            return {};
          var X = this.checker.getTypeOfSymbolAtLocation(G, G.valueDeclaration), ie = X.getApparentProperties(), te = ie;
          if (X.isUnionOrIntersection() && (te = n(n([], te = this.checker.getAllPossiblePropertiesOfTypes(X.types)), ie), !te.length)) {
            var Pe = this.checker.getAllPossiblePropertiesOfTypes(X.types.reduce(
              // @ts-ignore
              function(Me, Le) {
                return n(n([], Me), Le.types || []);
              },
              []
            ));
            te = n(n([], Pe), ie);
          }
          var We = {};
          return te.forEach(function(Me) {
            var Le = Me.getName(), fn = I(Me), Yt = fn?.fileName + "_" + Le;
            if (q.propertiesOfPropsCache.has(Yt))
              We[Le] = q.propertiesOfPropsCache.get(Yt);
            else {
              var Rn = q.checker.getTypeOfSymbolAtLocation(Me, G.valueDeclaration), Pn = q.findDocComment(Me), ls = H[Le] !== void 0, Tn = null;
              ls ? Tn = { value: H[Le] } : Pn.tags.default && (Tn = { value: Pn.tags.default });
              var qt = k(Me), yr = Me.declarations || [], $n = ie.find(function(oe) {
                return oe.getName() === Le;
              }), Cr = !m(Me) && !ls && // If in a intersection or union check original declaration for "?"
              // @ts-ignore
              yr.every(function(oe) {
                return !oe.questionToken;
              }) && (!$n || !m($n)), ii = Pn.tags.type ? {
                name: Pn.tags.type
              } : q.getDocgenType(Rn, Cr), Hn = q.shouldIncludePropTagMap ? { tags: Pn.tags } : {}, cs = q.shouldIncludePropTagMap ? Pn.description.replace(/\r\n/g, `
`) : Pn.fullComment.replace(/\r\n/g, `
`), hs = e({
                defaultValue: Tn,
                description: cs,
                name: Le,
                parent: fn,
                declarations: qt,
                required: Cr,
                type: ii
              }, Hn);
              fn?.fileName.includes("node_modules") && q.propertiesOfPropsCache.set(fn.fileName + "_" + Le, hs), We[Le] = hs;
            }
          }), We;
        }, J.prototype.findDocComment = function(G) {
          var H = this, q = this.getFullJsDocComment(G);
          if (q.fullComment || q.tags.default)
            return q;
          var X = this.checker.getRootSymbols(G), ie = X.filter(function(te) {
            return te !== G;
          }).map(function(te) {
            return H.getFullJsDocComment(te);
          }).filter(function(te) {
            return !!te.fullComment || !!q.tags.default;
          });
          return ie.length ? ie[0] : g;
        }, J.prototype.getFullJsDocComment = function(G) {
          if (G.getDocumentationComment === void 0)
            return g;
          var H = s.displayPartsToString(G.getDocumentationComment(this.checker));
          H && (H = H.replace(/\r\n/g, `
`));
          var q = G.getJsDocTags() || [], X = [], ie = {};
          return q.forEach(function(te) {
            var Pe = s.displayPartsToString(te.text).trim(), We = ie[te.name];
            ie[te.name] = We ? We + `
` + Pe : Pe, ["default", "type"].indexOf(te.name) < 0 && X.push(N(te));
          }), {
            description: H,
            fullComment: (H + `
` + X.join(`
`)).trim(),
            tags: ie
          };
        }, J.prototype.getFunctionStatement = function(G) {
          if (s.isFunctionDeclaration(G))
            return G;
          if (s.isVariableStatement(G)) {
            var H = G.declarationList && G.declarationList.declarations[0].initializer;
            if (H && s.isCallExpression(H)) {
              var q = this.checker.getSymbolAtLocation(H.expression);
              if (!q || q.getName() !== "forwardRef")
                return;
              H = H.arguments[0];
            }
            if (H && (s.isArrowFunction(H) || s.isFunctionExpression(H)))
              return H;
          }
        }, J.prototype.extractDefaultPropsFromComponent = function(G, H) {
          var q = this, X = n(n([], H.statements.filter(function(ie) {
            return !!ie.name;
          }).filter(function(ie) {
            return q.checker.getSymbolAtLocation(ie.name) === G;
          })), H.statements.filter(function(ie) {
            return s.isExpressionStatement(ie) || s.isVariableStatement(ie);
          }));
          return X.reduce(function(ie, te) {
            if (E(te) && te.members.length) {
              var Pe = te.members.filter(function($n) {
                return $n.name && x($n.name) === "defaultProps";
              });
              if (!Pe.length)
                return ie;
              var We = Pe[0], Me = We.initializer;
              if (!Me)
                return ie;
              for (var Le = Me.properties; s.isIdentifier(Me); ) {
                var fn = q.checker.getSymbolAtLocation(Me);
                if (fn) {
                  var Yt = fn.getDeclarations();
                  if (Yt) {
                    if (s.isImportSpecifier(Yt[0])) {
                      var Rn = q.checker.getSymbolAtLocation(Yt[0].name);
                      if (!Rn)
                        continue;
                      var Pn = q.checker.getAliasedSymbol(Rn);
                      if (Pn && Pn.declarations && Pn.declarations.length)
                        Me = Pn.declarations[0].initializer;
                      else
                        continue;
                    } else
                      Me = Yt[0].initializer;
                    Le = Me.properties;
                  }
                }
              }
              var ls = {};
              return Le && (ls = q.getPropMap(Le)), e(e({}, ie), ls);
            } else if (w(te)) {
              var Tn = {};
              return te.getChildren().forEach(function($n) {
                var Cr = $n.right;
                if (Cr && s.isIdentifier(Cr)) {
                  var ii = H.locals.get(Cr.escapedText);
                  ii && ii.valueDeclaration && s.isVariableDeclaration(ii.valueDeclaration) && ii.valueDeclaration.initializer && (Cr = ii.valueDeclaration.initializer);
                }
                if (Cr) {
                  var Hn = Cr.properties;
                  Hn && (Tn = q.getPropMap(Hn));
                }
              }), e(e({}, ie), Tn);
            }
            var qt = q.getFunctionStatement(te);
            if (qt && qt.parameters && qt.parameters.length) {
              var yr = qt.parameters[0].name;
              if (s.isObjectBindingPattern(yr))
                return e(e({}, ie), q.getPropMap(yr.elements));
            }
            return ie;
          }, {});
        }, J.prototype.getLiteralValueFromImportSpecifier = function(G) {
          if (s.isImportSpecifier(G)) {
            var H = this.checker.getSymbolAtLocation(G.name);
            if (!H)
              return null;
            var q = this.checker.getAliasedSymbol(H);
            return q && q.declarations && q.declarations.length ? this.getLiteralValueFromPropertyAssignment(q.declarations[0]) : null;
          }
          return null;
        }, J.prototype.getLiteralValueFromPropertyAssignment = function(G) {
          var H = G.initializer;
          if (!H && s.isShorthandPropertyAssignment(G)) {
            var q = this.checker.getShorthandAssignmentValueSymbol(G), X = q && q.valueDeclaration;
            X && X.initializer && (H = X.initializer);
          }
          if (H)
            switch (H.kind) {
              case s.SyntaxKind.FalseKeyword:
                return this.savePropValueAsString ? "false" : !1;
              case s.SyntaxKind.TrueKeyword:
                return this.savePropValueAsString ? "true" : !0;
              case s.SyntaxKind.StringLiteral:
                return H.text.trim();
              case s.SyntaxKind.PrefixUnaryExpression:
                return this.savePropValueAsString ? H.getFullText().trim() : Number(H.getFullText());
              case s.SyntaxKind.NumericLiteral:
                return this.savePropValueAsString ? "" + H.text : Number(H.text);
              case s.SyntaxKind.NullKeyword:
                return this.savePropValueAsString ? "null" : null;
              case s.SyntaxKind.Identifier:
                if (H.text === "undefined")
                  return "undefined";
                var q = this.checker.getSymbolAtLocation(H);
                return q && q.declarations && q.declarations.length ? s.isImportSpecifier(q.declarations[0]) ? this.getLiteralValueFromImportSpecifier(q.declarations[0]) : this.getLiteralValueFromPropertyAssignment(q.declarations[0]) : null;
              case s.SyntaxKind.PropertyAccessExpression: {
                var ie = this.checker.getSymbolAtLocation(H);
                if (ie && ie.declarations && ie.declarations.length) {
                  var te = ie.declarations[0];
                  if (s.isBindingElement(te) || s.isPropertyAssignment(te))
                    return this.getLiteralValueFromPropertyAssignment(te);
                }
              }
              case s.SyntaxKind.ObjectLiteralExpression:
              default:
                try {
                  return H.getText();
                } catch {
                  return null;
                }
            }
        }, J.prototype.getPropMap = function(G) {
          var H = this;
          return G.reduce(function(q, X) {
            var ie = x(s.isBindingElement(X) && X.propertyName || X.name);
            if (s.isSpreadAssignment(X) || !ie)
              return q;
            var te = H.getLiteralValueFromPropertyAssignment(X);
            return (typeof te == "string" || typeof te == "number" || typeof te == "boolean" || te === null) && (q[ie] = te), q;
          }, {});
        }, J;
      })()
    );
    t.Parser = A;
    function E(J) {
      return !!J.members;
    }
    function w(J) {
      for (var G = J.getChildren(), H = 0, q = G; H < q.length; H++) {
        var X = q[H], ie = X.left;
        if (ie) {
          var te = ie.name;
          if (te && te.escapedText === "defaultProps")
            return !0;
        }
      }
      return !1;
    }
    function x(J) {
      switch (J.kind) {
        case s.SyntaxKind.NumericLiteral:
        case s.SyntaxKind.StringLiteral:
        case s.SyntaxKind.Identifier:
          return J.text;
        case s.SyntaxKind.ComputedPropertyName:
          return J.getText();
        default:
          return null;
      }
    }
    function N(J) {
      var G = "@" + J.name;
      return J.text && (G += " " + s.displayPartsToString(J.text)), G;
    }
    function B(J, G) {
      var H = J.members || [], q = (H && H.filter(function(X) {
        return s.isPropertyDeclaration(X);
      }).filter(function(X) {
        var ie = s.getNameOfDeclaration(X);
        return ie && ie.text === G;
      }).map(function(X) {
        var ie = X;
        return ie.initializer && ie.initializer.text;
      }))[0];
      return q || "";
    }
    function P(J, G, H) {
      var q = G.statements.filter(function(ie) {
        return s.isExpressionStatement(ie);
      }).filter(function(ie) {
        var te, Pe, We, Me, Le = ie.expression, fn = Array.from(G.locals), Yt = fn.filter(function(Pn) {
          return !!Pn[1].exports;
        }).length === 1;
        if (Yt)
          return Le.left && Le.left.name && Le.left.name.escapedText === H;
        var Rn = (Me = (We = (Pe = (te = ie) === null || te === void 0 ? void 0 : te.flowNode) === null || Pe === void 0 ? void 0 : Pe.node) === null || We === void 0 ? void 0 : We.name) === null || Me === void 0 ? void 0 : Me.escapedText;
        return Le.left && Le.left.name && Le.left.name.escapedText === H && Rn === J.escapedName;
      }).filter(function(ie) {
        return s.isStringLiteral(ie.expression.right);
      }).map(function(ie) {
        var te = ie.expression, Pe = te.left.expression.escapedText, We = te.right.text;
        return [Pe, We];
      });
      if (q.length > 0) {
        var X = q.find(function(ie) {
          return ie[0] === J.escapedName;
        });
        return X ? X[1] : q[0][1] || "";
      }
      return "";
    }
    function C(J, G, H) {
      H === void 0 && (H = []);
      var q = J.getName(), X = P(J, G, "displayName"), ie = J.valueDeclaration && s.isClassDeclaration(J.valueDeclaration) && B(J.valueDeclaration, "displayName");
      if (X || ie)
        return X || ie || "";
      var te = [
        "default",
        "__function",
        "Stateless",
        "StyledComponentClass",
        "StyledComponent",
        "IStyledComponent",
        "FunctionComponent",
        "StatelessComponent",
        "ForwardRefExoticComponent",
        "MemoExoticComponent"
      ], Pe = n(n([], te), H);
      return Pe.indexOf(q) !== -1 ? D(G) : q;
    }
    function D(J) {
      var G = i.basename(J.fileName).split(".")[0], H = G === "index" ? i.basename(i.dirname(J.fileName)) : G, q = H.replace(/^[^A-Z]*/gi, "").replace(/[^A-Z0-9]*/gi, "");
      return q.length ? q : "DefaultName";
    }
    t.getDefaultExportForFile = D;
    function L(J) {
      return J.kind === s.SyntaxKind.TypeLiteral;
    }
    function k(J) {
      var G = J.getDeclarations();
      if (!(G === void 0 || G.length === 0)) {
        for (var H = [], q = 0, X = G; q < X.length; q++) {
          var ie = X[q], te = ie.parent;
          if (!(!L(te) && !U(te))) {
            var Pe = "name" in te ? te.name.text : "TypeLiteral", We = te.getSourceFile().fileName;
            H.push({
              fileName: o.trimFileName(We),
              name: Pe
            });
          }
        }
        return H;
      }
    }
    function I(J) {
      var G = J.getDeclarations();
      if (!(G == null || G.length === 0)) {
        var H = G[0].parent;
        if (U(H)) {
          var q = H.name.text, X = H.getSourceFile().fileName;
          return {
            fileName: o.trimFileName(X),
            name: q
          };
        }
      }
    }
    function U(J) {
      return J.kind === s.SyntaxKind.InterfaceDeclaration || J.kind === s.SyntaxKind.TypeAliasDeclaration;
    }
    function j(J, G, H, q) {
      var X = Array.isArray(J) ? J : [J], ie = q ? q() : s.createProgram(X, G), te = new A(ie, H), Pe = ie.getTypeChecker();
      return X.map(function(We) {
        return ie.getSourceFile(We);
      }).filter(function(We) {
        return typeof We < "u";
      }).reduce(function(We, Me) {
        var Le = Pe.getSymbolAtLocation(Me);
        if (!Le)
          return We;
        var fn = Pe.getExportsOfModule(Le), Yt = [], Rn = [];
        fn.forEach(function(Tn) {
          if (Rn.push(Tn), !!te.isPlainObjectType(Tn)) {
            var qt = te.getTypeSymbol(Tn);
            qt?.members && qt.members.forEach(function(yr) {
              Rn.push(yr);
            });
          }
        }), Rn.forEach(function(Tn) {
          var qt = te.getComponentInfo(Tn, Me, H.componentNameResolver, H.customComponentTypes);
          qt && Yt.push(qt);
          var yr = te.getComponentExports(Tn);
          yr && yr.exports.forEach(function($n) {
            if (!($n.flags & s.SymbolFlags.Prototype)) {
              if ($n.flags & s.SymbolFlags.Method) {
                var Cr = te.getCallSignature($n), ii = Pe.typeToString(Cr.getReturnType());
                if (ii !== "Element")
                  return;
              }
              var Hn = te.getComponentInfo($n, Me, H.componentNameResolver, H.customComponentTypes);
              if (Hn) {
                var cs = yr.symbol.escapedName === "default" ? "" : yr.symbol.escapedName + ".";
                Yt.push(e(e({}, Hn), { displayName: "" + cs + $n.escapedName }));
              }
            }
          });
        });
        var Pn = Yt.reduce(function(Tn, qt) {
          var yr = Tn.find(function($n) {
            return $n.displayName === qt.displayName;
          });
          return yr ? Tn : n(n([], Tn), [qt]);
        }, []), ls = Pn.filter(function(Tn, qt, yr) {
          return yr.slice(qt + 1).every(function($n) {
            return $n.displayName !== Tn.displayName;
          });
        });
        return n(n([], We), ls);
      }, []);
    }
  })(Vc)), Vc;
}
var NP;
function lBe() {
  return NP || (NP = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Parser = t.withCustomConfig = t.withDefaultConfig = t.withCompilerOptions = t.getDefaultExportForFile = t.parse = void 0;
    var e = uBe();
    Object.defineProperty(t, "getDefaultExportForFile", { enumerable: !0, get: function() {
      return e.getDefaultExportForFile;
    } }), Object.defineProperty(t, "parse", { enumerable: !0, get: function() {
      return e.parse;
    } }), Object.defineProperty(t, "Parser", { enumerable: !0, get: function() {
      return e.Parser;
    } }), Object.defineProperty(t, "withCompilerOptions", { enumerable: !0, get: function() {
      return e.withCompilerOptions;
    } }), Object.defineProperty(t, "withCustomConfig", { enumerable: !0, get: function() {
      return e.withCustomConfig;
    } }), Object.defineProperty(t, "withDefaultConfig", { enumerable: !0, get: function() {
      return e.withDefaultConfig;
    } });
  })(Zw)), Zw;
}
var cBe = lBe();
const hBe = 30, eF = /* @__PURE__ */ new Map();
function S2(t, e) {
  let n = t;
  (t.flags & Ke.SymbolFlags.Alias) !== 0 && (n = e.getAliasedSymbol(t));
  const r = n.getDeclarations()?.[0];
  if (!r) return;
  const i = r.getSourceFile().fileName;
  if (eF.has(i))
    return eF.get(i);
  const s = wBe(i);
  return eF.set(i, s), s;
}
const GG = /* @__PURE__ */ new Set(["ReactNode", "ReactElement"]);
function WG(t) {
  return t in mG;
}
function dBe(t, e) {
  const n = t.aliasSymbol ?? t.getSymbol();
  if (!n) return;
  const r = n.getName(), i = S2(n, e);
  if (i === "@types/react" || i === "react")
    return GG.has(r) ? { kind: "semantic", value: r, source: i } : void 0;
  if (i === "@wix/editor-react-types")
    return WG(r) ? { kind: "semantic", value: r, source: i } : void 0;
}
function fBe(t, e) {
  if (!(t.flags & Ke.TypeFlags.Union)) return !1;
  const n = t;
  let r = !1, i = !1;
  for (const s of n.types) {
    const a = s.aliasSymbol ?? s.getSymbol();
    if (a) {
      const o = a.getName(), u = S2(a, e);
      (u === "@types/react" || u === "react") && o === "ReactElement" && (r = !0);
    }
    s.flags & Ke.TypeFlags.String && (i = !0);
  }
  return r && i ? t.aliasSymbol?.getName() === "ReactNode" || !t.aliasSymbol : !1;
}
function dp({
  type: t,
  checker: e,
  depth: n = 0,
  typeString: r,
  declaredSymbol: i,
  seenTypes: s = /* @__PURE__ */ new Set()
}) {
  if (s.has(t))
    return { kind: "primitive", value: "any" };
  if (n > hBe)
    throw new Error(`Max resolve depth reached for type: ${e.typeToString(t)}`);
  s.add(t);
  const a = mBe({ type: t, checker: e, depth: n, typeString: r, declaredSymbol: i, seenTypes: s });
  return s.delete(t), a;
}
function mBe({
  type: t,
  checker: e,
  depth: n,
  typeString: r,
  declaredSymbol: i,
  seenTypes: s
}) {
  const a = dBe(t, e);
  if (a)
    return {
      kind: "semantic",
      value: a.value,
      source: a.source
    };
  if (fBe(t, e))
    return {
      kind: "semantic",
      value: "ReactNode",
      source: "@types/react"
    };
  if (i && r) {
    const u = S2(i, e);
    if ((u === "@types/react" || u === "react") && GG.has(r))
      return {
        kind: "semantic",
        value: r,
        source: u
      };
    if (u === "@wix/editor-react-types" && WG(r))
      return {
        kind: "semantic",
        value: r,
        source: u
      };
  }
  const o = [
    () => gBe(t),
    () => pBe(t, e),
    () => bBe(t, e, n, s),
    () => yBe(t, e, n, s),
    () => ABe(t, e, n, s),
    () => EBe(t, e),
    () => SBe(t, e, n, s)
  ];
  for (const u of o) {
    const l = u();
    if (l)
      return l;
  }
  return {
    kind: "primitive",
    value: e.typeToString(t)
  };
}
function gBe(t) {
  if (t.flags & Ke.TypeFlags.String)
    return { kind: "primitive", value: "string" };
  if (t.flags & Ke.TypeFlags.Number)
    return { kind: "primitive", value: "number" };
  if (t.flags & Ke.TypeFlags.Boolean)
    return { kind: "primitive", value: "boolean" };
  if (t.flags & Ke.TypeFlags.Null)
    return { kind: "primitive", value: "null" };
  if (t.flags & Ke.TypeFlags.Undefined)
    return { kind: "primitive", value: "undefined" };
  if (t.flags & Ke.TypeFlags.Any)
    return { kind: "primitive", value: "any" };
}
function pBe(t, e) {
  if (t.flags & Ke.TypeFlags.StringLiteral)
    return {
      kind: "literal",
      value: t.value
    };
  if (t.flags & Ke.TypeFlags.NumberLiteral)
    return {
      kind: "literal",
      value: t.value
    };
  if (t.flags & Ke.TypeFlags.BooleanLiteral)
    return {
      kind: "literal",
      value: e.typeToString(t) === "true"
    };
}
function bBe(t, e, n, r) {
  if (t.flags & Ke.TypeFlags.Union)
    return {
      kind: "union",
      types: t.types.map(
        (s) => dp({ type: s, checker: e, depth: n + 1, seenTypes: r })
      )
    };
}
function yBe(t, e, n, r) {
  if (t.flags & Ke.TypeFlags.Intersection)
    return {
      kind: "intersection",
      types: t.types.map(
        (s) => dp({ type: s, checker: e, depth: n + 1, seenTypes: r })
      )
    };
}
function ABe(t, e, n, r) {
  if (e.isArrayType(t)) {
    const i = t, s = e.getTypeArguments(i);
    return s.length > 0 ? {
      kind: "array",
      elementType: dp({ type: s[0], checker: e, depth: n + 1, seenTypes: r })
    } : { kind: "array", elementType: { kind: "primitive", value: "any" } };
  }
}
function EBe(t, e) {
  const n = t.getCallSignatures();
  if (n.length > 0) {
    const r = n[0], i = r.getParameters().map((a) => {
      const o = e.getTypeOfSymbol(a);
      return {
        name: a.getName(),
        type: e.typeToString(o)
      };
    }), s = r.getReturnType();
    return {
      kind: "function",
      value: {
        parameters: i,
        returnType: e.typeToString(s)
      }
    };
  }
}
function SBe(t, e, n, r) {
  const i = t.getProperties();
  if (i.length === 0)
    return;
  const s = {}, a = i.filter((o) => {
    const u = o.getName();
    return !["toString", "valueOf", "hasOwnProperty", "constructor", "toLocaleString"].includes(u);
  });
  for (const o of a) {
    const u = o.getName(), l = e.getTypeOfSymbol(o), h = (o.flags & Ke.SymbolFlags.Optional) !== 0;
    s[u] = {
      name: u,
      type: e.typeToString(l),
      required: !h,
      resolvedType: dp({ type: l, checker: e, depth: n + 1, seenTypes: r })
    };
  }
  if (Object.keys(s).length > 0)
    return {
      kind: "object",
      properties: s
    };
}
function wBe(t) {
  let e = Sd.dirname(t);
  const n = Sd.parse(e).root;
  for (; e !== n; ) {
    const r = Sd.join(e, "package.json");
    if (uT.existsSync(r))
      try {
        const i = uT.readFileSync(r, "utf-8");
        return JSON.parse(i).name;
      } catch (i) {
        throw new Error(`Failed to read package.json at ${r}: ${i}`);
      }
    e = Sd.dirname(e);
  }
}
const FBe = (t) => t.declarations && t.declarations.length > 0 ? !t.declarations.every((e) => {
  const n = e.fileName;
  return n.includes("node_modules/@types/") || n.includes("node_modules/typescript/");
}) : !0, TBe = {
  shouldRemoveUndefinedFromOptional: !0,
  shouldIncludePropTagMap: !0,
  // historically `children` were skipped as in older versions of React they ALWAYS were present in props
  // as we using newer React versions, we don't need to skip them
  skipChildrenPropWithoutDoc: !1,
  propFilter: FBe,
  // react-docgen-typescript resolves `commentSource` for known wrapper types (MemoExoticComponent,
  // ForwardRefExoticComponent, etc.) but not for NamedExoticComponent — the base type that
  // TypeScript reports when a memo-wrapped component is accessed via a default export alias.
  // Adding it here makes the library correctly resolve the actual variable symbol.
  customComponentTypes: ["NamedExoticComponent"]
};
function DP(t, e) {
  const n = t.getTypeChecker(), r = t.getCompilerOptions(), i = (o, u) => {
    const l = n.getSymbolAtLocation(u);
    if (!l) return;
    const h = n.getExportsOfModule(l).find((g) => g.getName() === "default");
    if (!h || !(h.getFlags() & Ke.SymbolFlags.Alias)) return;
    const m = n.getAliasedSymbol(h).getName();
    return m !== "default" ? m : void 0;
  };
  return cBe.withCompilerOptions(r, { ...TBe, componentNameResolver: i }).parseWithProgramProvider([e], () => t).map((o) => _Be(o, t, n));
}
function vBe(t, e) {
  const n = xBe(t, e);
  if (!n) return;
  const r = DP(t, e).find((s) => s.componentName === n);
  if (r) return r;
  const i = kBe(t, e);
  if (i)
    return DP(t, i).find((s) => s.componentName === n);
}
function xBe(t, e) {
  const n = t.getTypeChecker(), r = t.getSourceFile(e);
  if (!r) return;
  const i = n.getSymbolAtLocation(r);
  if (!i) return;
  const s = n.getExportsOfModule(i).find((a) => a.getName() === "default");
  if (s) {
    if (s.getFlags() & Ke.SymbolFlags.Alias) {
      const a = n.getAliasedSymbol(s), o = a.getName(), u = (a.getDeclarations()?.length ?? 0) > 0;
      if (o !== "default" && u) return o;
    }
    return CBe(r);
  }
}
function CBe(t) {
  return VG(t)?.propertyName?.text;
}
function kBe(t, e) {
  const n = t.getSourceFile(e);
  if (!n) return;
  const r = VG(n)?.parent?.parent;
  if (!r || !Ke.isExportDeclaration(r) || !r.moduleSpecifier || !Ke.isStringLiteral(r.moduleSpecifier)) return;
  const s = Ke.resolveModuleName(
    r.moduleSpecifier.text,
    e,
    t.getCompilerOptions(),
    Ke.sys
  ).resolvedModule?.resolvedFileName;
  if (s && s !== e)
    return s;
}
function VG(t) {
  for (const e of t.statements)
    if (Ke.isExportDeclaration(e) && e.moduleSpecifier && !(!e.exportClause || !Ke.isNamedExports(e.exportClause))) {
      for (const n of e.exportClause.elements)
        if (n.name.text === "default")
          return n;
    }
}
function _Be(t, e, n) {
  const r = NBe(t.displayName, t.filePath, e, n), i = {};
  for (const [s, a] of Object.entries(t.props)) {
    const o = a.tags;
    if (o?.ignore !== void 0 || o?.private !== void 0)
      continue;
    const u = r?.getProperty(s), l = u ? n.getTypeOfSymbol(u) : void 0;
    let h, f;
    if (u) {
      const E = u.getDeclarations()?.[0];
      if (E) {
        const w = E.getSourceFile();
        h = MBe(u, w, n), f = PBe(u, w, n);
      }
    }
    const m = f?.innerTypeName ?? h?.name ?? a.type.name, g = l ? dp({
      type: l,
      checker: n,
      typeString: m,
      declaredSymbol: f ? void 0 : h?.symbol
    }) : { kind: "primitive", value: a.type.name };
    let A;
    a.defaultValue != null && (A = DBe(a.defaultValue)), !A && o?.default && (A = KG(o.default)), i[s] = {
      name: s,
      type: m,
      required: a.required,
      defaultValue: A,
      resolvedType: g,
      description: a.description || void 0,
      deprecated: o?.deprecated !== void 0 ? !0 : void 0,
      min: IP(o?.min, s, "min"),
      max: IP(o?.max, s, "max"),
      isStateTrigger: f ? !0 : void 0
    };
  }
  return { componentName: t.displayName, props: i };
}
function NBe(t, e, n, r) {
  const i = n.getSourceFile(e);
  if (!i) return;
  const s = r.getSymbolAtLocation(i);
  if (!s) return;
  const a = r.getExportsOfModule(s);
  let o = a.find((m) => m.getName() === t);
  if (!o) {
    const m = a.find((g) => g.getName() === "default");
    if (m && (m.getFlags() & Ke.SymbolFlags.Alias) !== 0) {
      const g = r.getAliasedSymbol(m);
      g.getName() === t && (o = g);
    }
  }
  if (!o) return;
  const u = r.getTypeOfSymbol(o), l = u.getCallSignatures();
  if (l.length > 0) {
    const m = l[0].getParameters();
    if (m.length > 0)
      return r.getTypeOfSymbol(m[0]);
  }
  const h = u.getConstructSignatures();
  if (h.length > 0) {
    const m = h[0].getParameters();
    if (m.length > 0)
      return r.getTypeOfSymbol(m[0]);
  }
  const f = u.getProperties();
  for (const m of f)
    if (m.getName() === "type" || m.getName() === "render") {
      const A = r.getTypeOfSymbol(m).getCallSignatures();
      if (A.length > 0) {
        const E = A[0].getParameters();
        if (E.length > 0)
          return r.getTypeOfSymbol(E[0]);
      }
    }
}
function IP(t, e, n) {
  if (t !== void 0 && Number.isNaN(Number(t))) {
    console.warn(`@${n} on prop "${e}" is not a valid number ("${t}") — ignoring`);
    return;
  }
  return t;
}
function DBe(t) {
  if (!t || t.value == null) return;
  const e = t.value;
  return typeof e == "boolean" ? { kind: "boolean", value: e } : typeof e == "number" ? { kind: "number", value: e } : typeof e != "string" ? { kind: "unresolved", value: String(e) } : KG(
    e,
    /* fallbackToString */
    !0
  );
}
function KG(t, e = !1) {
  const n = t.trim();
  if (n === "true")
    return { kind: "boolean", value: !0 };
  if (n === "false")
    return { kind: "boolean", value: !1 };
  if (n === "null")
    return { kind: "null", value: null };
  const r = Number(n);
  if (!Number.isNaN(r) && n !== "")
    return { kind: "number", value: r };
  if (n.startsWith("'") && n.endsWith("'") || n.startsWith('"') && n.endsWith('"'))
    return { kind: "string", value: n.slice(1, -1) };
  if (n.startsWith("{") || n.startsWith("[")) {
    const i = IBe(n);
    if (i !== void 0)
      return Array.isArray(i) ? { kind: "array", value: i } : { kind: "object", value: i };
  }
  return e ? { kind: "string", value: n } : { kind: "unresolved", value: n };
}
function IBe(t) {
  const n = Ke.createSourceFile("__default__.ts", `const __v__ = ${t}`, Ke.ScriptTarget.Latest, !0).statements[0];
  if (!n || !Ke.isVariableStatement(n)) return;
  const r = n.declarationList.declarations[0]?.initializer;
  if (r)
    return hv(r);
}
function hv(t) {
  if (Ke.isObjectLiteralExpression(t)) {
    const e = {};
    for (const n of t.properties) {
      if (!Ke.isPropertyAssignment(n)) return;
      const r = RBe(n.name);
      if (r === void 0) return;
      const i = hv(n.initializer);
      if (i === void 0) return;
      e[r] = i;
    }
    return e;
  }
  if (Ke.isArrayLiteralExpression(t)) {
    const e = [];
    for (const n of t.elements) {
      const r = hv(n);
      if (r === void 0) return;
      e.push(r);
    }
    return e;
  }
  if (Ke.isStringLiteral(t) || Ke.isNoSubstitutionTemplateLiteral(t)) return t.text;
  if (Ke.isNumericLiteral(t)) return Number(t.text);
  if (Ke.isPrefixUnaryExpression(t) && t.operator === Ke.SyntaxKind.MinusToken && Ke.isNumericLiteral(t.operand))
    return -Number(t.operand.text);
  if (t.kind === Ke.SyntaxKind.TrueKeyword) return !0;
  if (t.kind === Ke.SyntaxKind.FalseKeyword) return !1;
  if (t.kind === Ke.SyntaxKind.NullKeyword) return null;
}
function RBe(t) {
  if (Ke.isIdentifier(t) || Ke.isStringLiteral(t) || Ke.isNumericLiteral(t))
    return t.text;
}
function PBe(t, e, n) {
  const r = t.getDeclarations()?.[0];
  if (!r || !(Ke.isPropertySignature(r) || Ke.isPropertyDeclaration(r) || Ke.isParameter(r)) || !r.type || !Ke.isTypeReferenceNode(r.type) || !r.type.typeArguments || r.type.typeArguments.length !== 1)
    return;
  const i = r.type.typeName, s = Ke.isIdentifier(i) ? i : i.right;
  if (s.text === "ElementState" && LBe(s, n))
    return { innerTypeName: r.type.typeArguments[0].getText(e) };
}
function LBe(t, e) {
  let n = e.getSymbolAtLocation(t);
  if (!n) return !1;
  (n.getFlags() & Ke.SymbolFlags.Alias) !== 0 && (n = e.getAliasedSymbol(n));
  const r = n.getDeclarations()?.[0];
  return !r || !Ke.isTypeAliasDeclaration(r) || r.name.text !== "ElementState" ? !1 : r.getSourceFile().fileName.includes("react-component-utils");
}
function MBe(t, e, n) {
  const r = t.getDeclarations()?.[0];
  if (r && (Ke.isPropertySignature(r) || Ke.isPropertyDeclaration(r) || Ke.isParameter(r)) && r.type && Ke.isTypeReferenceNode(r.type)) {
    const i = r.type.typeName, s = Ke.isIdentifier(i) ? i : i.right;
    return {
      name: s.getText(e),
      symbol: n.getSymbolAtLocation(s)
    };
  }
}
const OBe = 100;
function BBe(t) {
  const e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
  function r(i, s) {
    s > OBe || n.has(i.fileName) || (n.add(i.fileName), Ke.forEachChild(i, (a) => {
      if (!Ke.isImportDeclaration(a) || !Ke.isStringLiteral(a.moduleSpecifier)) return;
      const o = a.moduleSpecifier.text;
      if (o.endsWith(".css") || o.endsWith(".scss") || o.endsWith(".sass")) {
        const f = Sd.resolve(Sd.dirname(i.fileName), o);
        e.add(f);
        return;
      }
      const l = Ke.resolveModuleName(o, i.fileName, t.getCompilerOptions(), Ke.sys).resolvedModule?.resolvedFileName;
      if (!l) return;
      const h = t.getSourceFile(l);
      !h || h.isDeclarationFile || r(h, s + 1);
    }));
  }
  for (const i of t.getSourceFiles())
    i.isDeclarationFile || i.fileName.includes("node_modules") || r(i, 0);
  return Array.from(e);
}
const $Be = {
  _useHtmlParser2: !1
};
function dv(t, e) {
  if (!t)
    return e ?? $Be;
  const n = {
    _useHtmlParser2: !!t.xmlMode,
    ...e,
    ...t
  };
  return t.xml ? (n._useHtmlParser2 = !0, n.xmlMode = !0, t.xml !== !0 && Object.assign(n, t.xml)) : t.xmlMode && (n._useHtmlParser2 = !0), n;
}
var In;
(function(t) {
  t.Root = "root", t.Text = "text", t.Directive = "directive", t.Comment = "comment", t.Script = "script", t.Style = "style", t.Tag = "tag", t.CDATA = "cdata", t.Doctype = "doctype";
})(In || (In = {}));
function HBe(t) {
  return t.type === In.Tag || t.type === In.Script || t.type === In.Style;
}
const w2 = In.Root, zG = In.Text, UBe = In.Directive, jG = In.Comment, GBe = In.Script, WBe = In.Style, fv = In.Tag, VBe = In.CDATA, KBe = In.Doctype;
let YG = class {
  constructor() {
    this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(e) {
    this.parent = e;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(e) {
    this.prev = e;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(e) {
    this.next = e;
  }
  /**
   * Clone this node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(e = !1) {
    return Rg(this, e);
  }
};
class F2 extends YG {
  /**
   * @param data The content of the data node
   */
  constructor(e) {
    super(), this.data = e;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(e) {
    this.data = e;
  }
}
class x1 extends F2 {
  constructor() {
    super(...arguments), this.type = In.Text;
  }
  get nodeType() {
    return 3;
  }
}
class qG extends F2 {
  constructor() {
    super(...arguments), this.type = In.Comment;
  }
  get nodeType() {
    return 8;
  }
}
let JG = class extends F2 {
  constructor(e, n) {
    super(n), this.name = e, this.type = In.Directive;
  }
  get nodeType() {
    return 1;
  }
};
class T2 extends YG {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(e) {
    super(), this.children = e;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    var e;
    return (e = this.children[0]) !== null && e !== void 0 ? e : null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(e) {
    this.children = e;
  }
}
class QG extends T2 {
  constructor() {
    super(...arguments), this.type = In.CDATA;
  }
  get nodeType() {
    return 4;
  }
}
class Ig extends T2 {
  constructor() {
    super(...arguments), this.type = In.Root;
  }
  get nodeType() {
    return 9;
  }
}
let XG = class extends T2 {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  constructor(e, n, r = [], i = e === "script" ? In.Script : e === "style" ? In.Style : In.Tag) {
    super(r), this.name = e, this.attribs = n, this.type = i;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(e) {
    this.name = e;
  }
  get attributes() {
    return Object.keys(this.attribs).map((e) => {
      var n, r;
      return {
        name: e,
        value: this.attribs[e],
        namespace: (n = this["x-attribsNamespace"]) === null || n === void 0 ? void 0 : n[e],
        prefix: (r = this["x-attribsPrefix"]) === null || r === void 0 ? void 0 : r[e]
      };
    });
  }
};
function St(t) {
  return HBe(t);
}
function MA(t) {
  return t.type === In.CDATA;
}
function Fh(t) {
  return t.type === In.Text;
}
function v2(t) {
  return t.type === In.Comment;
}
function zBe(t) {
  return t.type === In.Directive;
}
function Ih(t) {
  return t.type === In.Root;
}
function Qr(t) {
  return Object.prototype.hasOwnProperty.call(t, "children");
}
function Rg(t, e = !1) {
  let n;
  if (Fh(t))
    n = new x1(t.data);
  else if (v2(t))
    n = new qG(t.data);
  else if (St(t)) {
    const r = e ? tF(t.children) : [], i = new XG(t.name, { ...t.attribs }, r);
    r.forEach((s) => s.parent = i), t.namespace != null && (i.namespace = t.namespace), t["x-attribsNamespace"] && (i["x-attribsNamespace"] = { ...t["x-attribsNamespace"] }), t["x-attribsPrefix"] && (i["x-attribsPrefix"] = { ...t["x-attribsPrefix"] }), n = i;
  } else if (MA(t)) {
    const r = e ? tF(t.children) : [], i = new QG(r);
    r.forEach((s) => s.parent = i), n = i;
  } else if (Ih(t)) {
    const r = e ? tF(t.children) : [], i = new Ig(r);
    r.forEach((s) => s.parent = i), t["x-mode"] && (i["x-mode"] = t["x-mode"]), n = i;
  } else if (zBe(t)) {
    const r = new JG(t.name, t.data);
    t["x-name"] != null && (r["x-name"] = t["x-name"], r["x-publicId"] = t["x-publicId"], r["x-systemId"] = t["x-systemId"]), n = r;
  } else
    throw new Error(`Not implemented yet: ${t.type}`);
  return n.startIndex = t.startIndex, n.endIndex = t.endIndex, t.sourceCodeLocation != null && (n.sourceCodeLocation = t.sourceCodeLocation), n;
}
function tF(t) {
  const e = t.map((n) => Rg(n, !0));
  for (let n = 1; n < e.length; n++)
    e[n].prev = e[n - 1], e[n - 1].next = e[n];
  return e;
}
const RP = {
  withStartIndices: !1,
  withEndIndices: !1,
  xmlMode: !1
};
class jBe {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(e, n, r) {
    this.dom = [], this.root = new Ig(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof n == "function" && (r = n, n = RP), typeof e == "object" && (n = e, e = void 0), this.callback = e ?? null, this.options = n ?? RP, this.elementCB = r ?? null;
  }
  onparserinit(e) {
    this.parser = e;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [], this.root = new Ig(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
  }
  onerror(e) {
    this.handleCallback(e);
  }
  onclosetag() {
    this.lastNode = null;
    const e = this.tagStack.pop();
    this.options.withEndIndices && (e.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(e);
  }
  onopentag(e, n) {
    const r = this.options.xmlMode ? In.Tag : void 0, i = new XG(e, n, void 0, r);
    this.addNode(i), this.tagStack.push(i);
  }
  ontext(e) {
    const { lastNode: n } = this;
    if (n && n.type === In.Text)
      n.data += e, this.options.withEndIndices && (n.endIndex = this.parser.endIndex);
    else {
      const r = new x1(e);
      this.addNode(r), this.lastNode = r;
    }
  }
  oncomment(e) {
    if (this.lastNode && this.lastNode.type === In.Comment) {
      this.lastNode.data += e;
      return;
    }
    const n = new qG(e);
    this.addNode(n), this.lastNode = n;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const e = new x1(""), n = new QG([e]);
    this.addNode(n), e.parent = n, this.lastNode = e;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(e, n) {
    const r = new JG(e, n);
    this.addNode(r);
  }
  handleCallback(e) {
    if (typeof this.callback == "function")
      this.callback(e, this.dom);
    else if (e)
      throw e;
  }
  addNode(e) {
    const n = this.tagStack[this.tagStack.length - 1], r = n.children[n.children.length - 1];
    this.options.withStartIndices && (e.startIndex = this.parser.startIndex), this.options.withEndIndices && (e.endIndex = this.parser.endIndex), n.children.push(e), r && (e.prev = r, r.next = e), e.parent = n, this.lastNode = null;
  }
}
const YBe = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((t) => t.charCodeAt(0))
), qBe = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((t) => t.charCodeAt(0))
);
var nF;
const JBe = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), QBe = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (nF = String.fromCodePoint) !== null && nF !== void 0 ? nF : function(t) {
    let e = "";
    return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | t & 1023), e += String.fromCharCode(t), e;
  }
);
function XBe(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = JBe.get(t)) !== null && e !== void 0 ? e : t;
}
var _i;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(_i || (_i = {}));
const ZBe = 32;
var Bl;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Bl || (Bl = {}));
function mv(t) {
  return t >= _i.ZERO && t <= _i.NINE;
}
function e4e(t) {
  return t >= _i.UPPER_A && t <= _i.UPPER_F || t >= _i.LOWER_A && t <= _i.LOWER_F;
}
function t4e(t) {
  return t >= _i.UPPER_A && t <= _i.UPPER_Z || t >= _i.LOWER_A && t <= _i.LOWER_Z || mv(t);
}
function n4e(t) {
  return t === _i.EQUALS || t4e(t);
}
var Ai;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})(Ai || (Ai = {}));
var Dl;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(Dl || (Dl = {}));
let r4e = class {
  constructor(e, n, r) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = r, this.state = Ai.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Dl.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = Ai.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, n) {
    switch (this.state) {
      case Ai.EntityStart:
        return e.charCodeAt(n) === _i.NUM ? (this.state = Ai.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = Ai.NamedEntity, this.stateNamedEntity(e, n));
      case Ai.NumericStart:
        return this.stateNumericStart(e, n);
      case Ai.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case Ai.NumericHex:
        return this.stateNumericHex(e, n);
      case Ai.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | ZBe) === _i.LOWER_X ? (this.state = Ai.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = Ai.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  addToNumericResult(e, n, r, i) {
    if (n !== r) {
      const s = r - n;
      this.result = this.result * Math.pow(i, s) + parseInt(e.substr(n, s), i), this.consumed += s;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const i = e.charCodeAt(n);
      if (mv(i) || e4e(i))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 16), this.emitNumericEntity(i, 3);
    }
    return this.addToNumericResult(e, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const i = e.charCodeAt(n);
      if (mv(i))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 10), this.emitNumericEntity(i, 2);
    }
    return this.addToNumericResult(e, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === _i.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Dl.Strict)
      return 0;
    return this.emitCodePoint(XBe(this.result), this.consumed), this.errors && (e !== _i.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, n) {
    const { decodeTree: r } = this;
    let i = r[this.treeIndex], s = (i & Bl.VALUE_LENGTH) >> 14;
    for (; n < e.length; n++, this.excess++) {
      const a = e.charCodeAt(n);
      if (this.treeIndex = i4e(r, i, this.treeIndex + Math.max(1, s), a), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Dl.Attribute && // We shouldn't have consumed any characters after the entity,
        (s === 0 || // And there should be no invalid characters.
        n4e(a)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (i = r[this.treeIndex], s = (i & Bl.VALUE_LENGTH) >> 14, s !== 0) {
        if (a === _i.SEMI)
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        this.decodeMode !== Dl.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: n, decodeTree: r } = this, i = (r[n] & Bl.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, i, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, n, r) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(n === 1 ? i[e] & ~Bl.VALUE_LENGTH : i[e + 1], r), n === 3 && this.emitCodePoint(i[e + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case Ai.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Dl.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case Ai.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Ai.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Ai.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case Ai.EntityStart:
        return 0;
    }
  }
};
function ZG(t) {
  let e = "";
  const n = new r4e(t, (r) => e += QBe(r));
  return function(i, s) {
    let a = 0, o = 0;
    for (; (o = i.indexOf("&", o)) >= 0; ) {
      e += i.slice(a, o), n.startEntity(s);
      const l = n.write(
        i,
        // Skip the "&"
        o + 1
      );
      if (l < 0) {
        a = o + n.end();
        break;
      }
      a = o + l, o = l === 0 ? a + 1 : a;
    }
    const u = e + i.slice(a);
    return e = "", u;
  };
}
function i4e(t, e, n, r) {
  const i = (e & Bl.BRANCH_LENGTH) >> 7, s = e & Bl.JUMP_TABLE;
  if (i === 0)
    return s !== 0 && r === s ? n : -1;
  if (s) {
    const u = r - s;
    return u < 0 || u >= i ? -1 : t[n + u] - 1;
  }
  let a = n, o = a + i - 1;
  for (; a <= o; ) {
    const u = a + o >>> 1, l = t[u];
    if (l < r)
      a = u + 1;
    else if (l > r)
      o = u - 1;
    else
      return t[u + i];
  }
  return -1;
}
const s4e = ZG(YBe);
ZG(qBe);
function a4e(t, e = Dl.Legacy) {
  return s4e(t, e);
}
const PP = /["&'<>$\x80-\uFFFF]/g, o4e = /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [39, "&apos;"],
  [60, "&lt;"],
  [62, "&gt;"]
]), u4e = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (t, e) => t.codePointAt(e) : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    (t, e) => (t.charCodeAt(e) & 64512) === 55296 ? (t.charCodeAt(e) - 55296) * 1024 + t.charCodeAt(e + 1) - 56320 + 65536 : t.charCodeAt(e)
  )
);
function e7(t) {
  let e = "", n = 0, r;
  for (; (r = PP.exec(t)) !== null; ) {
    const i = r.index, s = t.charCodeAt(i), a = o4e.get(s);
    a !== void 0 ? (e += t.substring(n, i) + a, n = i + 1) : (e += `${t.substring(n, i)}&#x${u4e(t, i).toString(16)};`, n = PP.lastIndex += +((s & 64512) === 55296));
  }
  return e + t.substr(n);
}
function t7(t, e) {
  return function(r) {
    let i, s = 0, a = "";
    for (; i = t.exec(r); )
      s !== i.index && (a += r.substring(s, i.index)), a += e.get(i[0].charCodeAt(0)), s = i.index + 1;
    return a + r.substring(s);
  };
}
const l4e = t7(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
])), c4e = t7(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
])), h4e = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((t) => [t.toLowerCase(), t])), d4e = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((t) => [t.toLowerCase(), t])), f4e = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function m4e(t) {
  return t.replace(/"/g, "&quot;");
}
function g4e(t, e) {
  var n;
  if (!t)
    return;
  const r = ((n = e.encodeEntities) !== null && n !== void 0 ? n : e.decodeEntities) === !1 ? m4e : e.xmlMode || e.encodeEntities !== "utf8" ? e7 : l4e;
  return Object.keys(t).map((i) => {
    var s, a;
    const o = (s = t[i]) !== null && s !== void 0 ? s : "";
    return e.xmlMode === "foreign" && (i = (a = d4e.get(i)) !== null && a !== void 0 ? a : i), !e.emptyAttrs && !e.xmlMode && o === "" ? i : `${i}="${r(o)}"`;
  }).join(" ");
}
const LP = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function OA(t, e = {}) {
  const n = "length" in t ? t : [t];
  let r = "";
  for (let i = 0; i < n.length; i++)
    r += p4e(n[i], e);
  return r;
}
function p4e(t, e) {
  switch (t.type) {
    case w2:
      return OA(t.children, e);
    // @ts-expect-error We don't use `Doctype` yet
    case KBe:
    case UBe:
      return E4e(t);
    case jG:
      return F4e(t);
    case VBe:
      return w4e(t);
    case GBe:
    case WBe:
    case fv:
      return A4e(t, e);
    case zG:
      return S4e(t, e);
  }
}
const b4e = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), y4e = /* @__PURE__ */ new Set(["svg", "math"]);
function A4e(t, e) {
  var n;
  e.xmlMode === "foreign" && (t.name = (n = h4e.get(t.name)) !== null && n !== void 0 ? n : t.name, t.parent && b4e.has(t.parent.name) && (e = { ...e, xmlMode: !1 })), !e.xmlMode && y4e.has(t.name) && (e = { ...e, xmlMode: "foreign" });
  let r = `<${t.name}`;
  const i = g4e(t.attribs, e);
  return i && (r += ` ${i}`), t.children.length === 0 && (e.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    e.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    e.selfClosingTags && LP.has(t.name)
  )) ? (e.xmlMode || (r += " "), r += "/>") : (r += ">", t.children.length > 0 && (r += OA(t.children, e)), (e.xmlMode || !LP.has(t.name)) && (r += `</${t.name}>`)), r;
}
function E4e(t) {
  return `<${t.data}>`;
}
function S4e(t, e) {
  var n;
  let r = t.data || "";
  return ((n = e.encodeEntities) !== null && n !== void 0 ? n : e.decodeEntities) !== !1 && !(!e.xmlMode && t.parent && f4e.has(t.parent.name)) && (r = e.xmlMode || e.encodeEntities !== "utf8" ? e7(r) : c4e(r)), r;
}
function w4e(t) {
  return `<![CDATA[${t.children[0].data}]]>`;
}
function F4e(t) {
  return `<!--${t.data}-->`;
}
function n7(t, e) {
  return OA(t, e);
}
function T4e(t, e) {
  return Qr(t) ? t.children.map((n) => n7(n, e)).join("") : "";
}
function Oy(t) {
  return Array.isArray(t) ? t.map(Oy).join("") : St(t) ? t.name === "br" ? `
` : Oy(t.children) : MA(t) ? Oy(t.children) : Fh(t) ? t.data : "";
}
function Sf(t) {
  return Array.isArray(t) ? t.map(Sf).join("") : Qr(t) && !v2(t) ? Sf(t.children) : Fh(t) ? t.data : "";
}
function C1(t) {
  return Array.isArray(t) ? t.map(C1).join("") : Qr(t) && (t.type === In.Tag || MA(t)) ? C1(t.children) : Fh(t) ? t.data : "";
}
function BA(t) {
  return Qr(t) ? t.children : [];
}
function r7(t) {
  return t.parent || null;
}
function i7(t) {
  const e = r7(t);
  if (e != null)
    return BA(e);
  const n = [t];
  let { prev: r, next: i } = t;
  for (; r != null; )
    n.unshift(r), { prev: r } = r;
  for (; i != null; )
    n.push(i), { next: i } = i;
  return n;
}
function v4e(t, e) {
  var n;
  return (n = t.attribs) === null || n === void 0 ? void 0 : n[e];
}
function x4e(t, e) {
  return t.attribs != null && Object.prototype.hasOwnProperty.call(t.attribs, e) && t.attribs[e] != null;
}
function C4e(t) {
  return t.name;
}
function x2(t) {
  let { next: e } = t;
  for (; e !== null && !St(e); )
    ({ next: e } = e);
  return e;
}
function C2(t) {
  let { prev: e } = t;
  for (; e !== null && !St(e); )
    ({ prev: e } = e);
  return e;
}
function Rh(t) {
  if (t.prev && (t.prev.next = t.next), t.next && (t.next.prev = t.prev), t.parent) {
    const e = t.parent.children, n = e.lastIndexOf(t);
    n >= 0 && e.splice(n, 1);
  }
  t.next = null, t.prev = null, t.parent = null;
}
function k4e(t, e) {
  const n = e.prev = t.prev;
  n && (n.next = e);
  const r = e.next = t.next;
  r && (r.prev = e);
  const i = e.parent = t.parent;
  if (i) {
    const s = i.children;
    s[s.lastIndexOf(t)] = e, t.parent = null;
  }
}
function _4e(t, e) {
  if (Rh(e), e.next = null, e.parent = t, t.children.push(e) > 1) {
    const n = t.children[t.children.length - 2];
    n.next = e, e.prev = n;
  } else
    e.prev = null;
}
function N4e(t, e) {
  Rh(e);
  const { parent: n } = t, r = t.next;
  if (e.next = r, e.prev = t, t.next = e, e.parent = n, r) {
    if (r.prev = e, n) {
      const i = n.children;
      i.splice(i.lastIndexOf(r), 0, e);
    }
  } else n && n.children.push(e);
}
function D4e(t, e) {
  if (Rh(e), e.parent = t, e.prev = null, t.children.unshift(e) !== 1) {
    const n = t.children[1];
    n.prev = e, e.next = n;
  } else
    e.next = null;
}
function I4e(t, e) {
  Rh(e);
  const { parent: n } = t;
  if (n) {
    const r = n.children;
    r.splice(r.indexOf(t), 0, e);
  }
  t.prev && (t.prev.next = e), e.parent = n, e.prev = t.prev, e.next = t, t.prev = e;
}
function fp(t, e, n = !0, r = 1 / 0) {
  return k2(t, Array.isArray(e) ? e : [e], n, r);
}
function k2(t, e, n, r) {
  const i = [], s = [Array.isArray(e) ? e : [e]], a = [0];
  for (; ; ) {
    if (a[0] >= s[0].length) {
      if (a.length === 1)
        return i;
      s.shift(), a.shift();
      continue;
    }
    const o = s[0][a[0]++];
    if (t(o) && (i.push(o), --r <= 0))
      return i;
    n && Qr(o) && o.children.length > 0 && (a.unshift(0), s.unshift(o.children));
  }
}
function R4e(t, e) {
  return e.find(t);
}
function _2(t, e, n = !0) {
  const r = Array.isArray(e) ? e : [e];
  for (let i = 0; i < r.length; i++) {
    const s = r[i];
    if (St(s) && t(s))
      return s;
    if (n && Qr(s) && s.children.length > 0) {
      const a = _2(t, s.children, !0);
      if (a)
        return a;
    }
  }
  return null;
}
function s7(t, e) {
  return (Array.isArray(e) ? e : [e]).some((n) => St(n) && t(n) || Qr(n) && s7(t, n.children));
}
function P4e(t, e) {
  const n = [], r = [Array.isArray(e) ? e : [e]], i = [0];
  for (; ; ) {
    if (i[0] >= r[0].length) {
      if (r.length === 1)
        return n;
      r.shift(), i.shift();
      continue;
    }
    const s = r[0][i[0]++];
    St(s) && t(s) && n.push(s), Qr(s) && s.children.length > 0 && (i.unshift(0), r.unshift(s.children));
  }
}
const k1 = {
  tag_name(t) {
    return typeof t == "function" ? (e) => St(e) && t(e.name) : t === "*" ? St : (e) => St(e) && e.name === t;
  },
  tag_type(t) {
    return typeof t == "function" ? (e) => t(e.type) : (e) => e.type === t;
  },
  tag_contains(t) {
    return typeof t == "function" ? (e) => Fh(e) && t(e.data) : (e) => Fh(e) && e.data === t;
  }
};
function N2(t, e) {
  return typeof e == "function" ? (n) => St(n) && e(n.attribs[t]) : (n) => St(n) && n.attribs[t] === e;
}
function L4e(t, e) {
  return (n) => t(n) || e(n);
}
function a7(t) {
  const e = Object.keys(t).map((n) => {
    const r = t[n];
    return Object.prototype.hasOwnProperty.call(k1, n) ? k1[n](r) : N2(n, r);
  });
  return e.length === 0 ? null : e.reduce(L4e);
}
function M4e(t, e) {
  const n = a7(t);
  return n ? n(e) : !0;
}
function O4e(t, e, n, r = 1 / 0) {
  const i = a7(t);
  return i ? fp(i, e, n, r) : [];
}
function B4e(t, e, n = !0) {
  return Array.isArray(e) || (e = [e]), _2(N2("id", t), e, n);
}
function Pf(t, e, n = !0, r = 1 / 0) {
  return fp(k1.tag_name(t), e, n, r);
}
function $4e(t, e, n = !0, r = 1 / 0) {
  return fp(N2("class", t), e, n, r);
}
function H4e(t, e, n = !0, r = 1 / 0) {
  return fp(k1.tag_type(t), e, n, r);
}
function U4e(t) {
  let e = t.length;
  for (; --e >= 0; ) {
    const n = t[e];
    if (e > 0 && t.lastIndexOf(n, e - 1) >= 0) {
      t.splice(e, 1);
      continue;
    }
    for (let r = n.parent; r; r = r.parent)
      if (t.includes(r)) {
        t.splice(e, 1);
        break;
      }
  }
  return t;
}
var ka;
(function(t) {
  t[t.DISCONNECTED = 1] = "DISCONNECTED", t[t.PRECEDING = 2] = "PRECEDING", t[t.FOLLOWING = 4] = "FOLLOWING", t[t.CONTAINS = 8] = "CONTAINS", t[t.CONTAINED_BY = 16] = "CONTAINED_BY";
})(ka || (ka = {}));
function o7(t, e) {
  const n = [], r = [];
  if (t === e)
    return 0;
  let i = Qr(t) ? t : t.parent;
  for (; i; )
    n.unshift(i), i = i.parent;
  for (i = Qr(e) ? e : e.parent; i; )
    r.unshift(i), i = i.parent;
  const s = Math.min(n.length, r.length);
  let a = 0;
  for (; a < s && n[a] === r[a]; )
    a++;
  if (a === 0)
    return ka.DISCONNECTED;
  const o = n[a - 1], u = o.children, l = n[a], h = r[a];
  return u.indexOf(l) > u.indexOf(h) ? o === e ? ka.FOLLOWING | ka.CONTAINED_BY : ka.FOLLOWING : o === t ? ka.PRECEDING | ka.CONTAINS : ka.PRECEDING;
}
function Lf(t) {
  return t = t.filter((e, n, r) => !r.includes(e, n + 1)), t.sort((e, n) => {
    const r = o7(e, n);
    return r & ka.PRECEDING ? -1 : r & ka.FOLLOWING ? 1 : 0;
  }), t;
}
function G4e(t) {
  const e = _1(j4e, t);
  return e ? e.name === "feed" ? W4e(e) : V4e(e) : null;
}
function W4e(t) {
  var e;
  const n = t.children, r = {
    type: "atom",
    items: Pf("entry", n).map((a) => {
      var o;
      const { children: u } = a, l = { media: u7(u) };
      Rs(l, "id", "id", u), Rs(l, "title", "title", u);
      const h = (o = _1("link", u)) === null || o === void 0 ? void 0 : o.attribs.href;
      h && (l.link = h);
      const f = $l("summary", u) || $l("content", u);
      f && (l.description = f);
      const m = $l("updated", u);
      return m && (l.pubDate = new Date(m)), l;
    })
  };
  Rs(r, "id", "id", n), Rs(r, "title", "title", n);
  const i = (e = _1("link", n)) === null || e === void 0 ? void 0 : e.attribs.href;
  i && (r.link = i), Rs(r, "description", "subtitle", n);
  const s = $l("updated", n);
  return s && (r.updated = new Date(s)), Rs(r, "author", "email", n, !0), r;
}
function V4e(t) {
  var e, n;
  const r = (n = (e = _1("channel", t.children)) === null || e === void 0 ? void 0 : e.children) !== null && n !== void 0 ? n : [], i = {
    type: t.name.substr(0, 3),
    id: "",
    items: Pf("item", t.children).map((a) => {
      const { children: o } = a, u = { media: u7(o) };
      Rs(u, "id", "guid", o), Rs(u, "title", "title", o), Rs(u, "link", "link", o), Rs(u, "description", "description", o);
      const l = $l("pubDate", o) || $l("dc:date", o);
      return l && (u.pubDate = new Date(l)), u;
    })
  };
  Rs(i, "title", "title", r), Rs(i, "link", "link", r), Rs(i, "description", "description", r);
  const s = $l("lastBuildDate", r);
  return s && (i.updated = new Date(s)), Rs(i, "author", "managingEditor", r, !0), i;
}
const K4e = ["url", "type", "lang"], z4e = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function u7(t) {
  return Pf("media:content", t).map((e) => {
    const { attribs: n } = e, r = {
      medium: n.medium,
      isDefault: !!n.isDefault
    };
    for (const i of K4e)
      n[i] && (r[i] = n[i]);
    for (const i of z4e)
      n[i] && (r[i] = parseInt(n[i], 10));
    return n.expression && (r.expression = n.expression), r;
  });
}
function _1(t, e) {
  return Pf(t, e, !0, 1)[0];
}
function $l(t, e, n = !1) {
  return Sf(Pf(t, e, n, 1)).trim();
}
function Rs(t, e, n, r, i = !1) {
  const s = $l(n, r, i);
  s && (t[e] = s);
}
function j4e(t) {
  return t === "rss" || t === "feed" || t === "rdf:RDF";
}
const $A = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DocumentPosition() {
    return ka;
  },
  append: N4e,
  appendChild: _4e,
  compareDocumentPosition: o7,
  existsOne: s7,
  filter: fp,
  find: k2,
  findAll: P4e,
  findOne: _2,
  findOneChild: R4e,
  getAttributeValue: v4e,
  getChildren: BA,
  getElementById: B4e,
  getElements: O4e,
  getElementsByClassName: $4e,
  getElementsByTagName: Pf,
  getElementsByTagType: H4e,
  getFeed: G4e,
  getInnerHTML: T4e,
  getName: C4e,
  getOuterHTML: n7,
  getParent: r7,
  getSiblings: i7,
  getText: Oy,
  hasAttrib: x4e,
  hasChildren: Qr,
  innerText: C1,
  isCDATA: MA,
  isComment: v2,
  isDocument: Ih,
  isTag: St,
  isText: Fh,
  nextElementSibling: x2,
  prepend: I4e,
  prependChild: D4e,
  prevElementSibling: C2,
  removeElement: Rh,
  removeSubsets: U4e,
  replaceElement: k4e,
  testElement: M4e,
  textContent: Sf,
  uniqueSort: Lf
}, Symbol.toStringTag, { value: "Module" }));
function l7(t, e, n) {
  return t ? t(e ?? t._root.children, null, void 0, n).toString() : "";
}
function Y4e(t, e) {
  return typeof t == "object" && t != null && !("length" in t) && !("type" in t);
}
function q4e(t, e) {
  const n = Y4e(t) ? (e = t, void 0) : t, r = {
    ...this === null || this === void 0 ? void 0 : this._options,
    ...dv(e)
  };
  return l7(this, n, r);
}
function J4e(t) {
  const e = { ...this._options, xmlMode: !0 };
  return l7(this, t, e);
}
function Pg(t) {
  const e = t ?? (this ? this.root() : []);
  let n = "";
  for (let r = 0; r < e.length; r++)
    n += Sf(e[r]);
  return n;
}
function Q4e(t, e, n = typeof e == "boolean" ? e : !1) {
  if (!t || typeof t != "string")
    return null;
  typeof e == "boolean" && (n = e);
  const r = this.load(t, this._options, !1);
  return n || r("script").remove(), [...r.root()[0].children];
}
function X4e() {
  return this(this._root);
}
function c7(t, e) {
  if (e === t)
    return !1;
  let n = e;
  for (; n && n !== n.parent; )
    if (n = n.parent, n === t)
      return !0;
  return !1;
}
function Z4e(t) {
  return this.root().extract(t);
}
function e6e(t, e) {
  if (!MP(t) || !MP(e))
    return;
  let n = t.length;
  const r = +e.length;
  for (let i = 0; i < r; i++)
    t[n++] = e[i];
  return t.length = n, t;
}
function MP(t) {
  if (Array.isArray(t))
    return !0;
  if (typeof t != "object" || t === null || !("length" in t) || typeof t.length != "number" || t.length < 0)
    return !1;
  for (let e = 0; e < t.length; e++)
    if (!(e in t))
      return !1;
  return !0;
}
const t6e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  contains: c7,
  extract: Z4e,
  html: q4e,
  merge: e6e,
  parseHTML: Q4e,
  root: X4e,
  text: Pg,
  xml: J4e
}, Symbol.toStringTag, { value: "Module" }));
function Ku(t) {
  return t.cheerio != null;
}
function n6e(t) {
  return t.replace(/[._-](\w|$)/g, (e, n) => n.toUpperCase());
}
function r6e(t) {
  return t.replace(/[A-Z]/g, "-$&").toLowerCase();
}
function Or(t, e) {
  const n = t.length;
  for (let r = 0; r < n; r++)
    e(t[r], r);
  return t;
}
var Zc;
(function(t) {
  t[t.LowerA = 97] = "LowerA", t[t.LowerZ = 122] = "LowerZ", t[t.UpperA = 65] = "UpperA", t[t.UpperZ = 90] = "UpperZ", t[t.Exclamation = 33] = "Exclamation";
})(Zc || (Zc = {}));
function gv(t) {
  if (typeof t != "string")
    return !1;
  const e = t.indexOf("<");
  if (e === -1 || e > t.length - 3)
    return !1;
  const n = t.charCodeAt(e + 1);
  return (n >= Zc.LowerA && n <= Zc.LowerZ || n >= Zc.UpperA && n <= Zc.UpperZ || n === Zc.Exclamation) && t.includes(">", e + 2);
}
var rF;
const i6e = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), OP = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
  (rF = String.fromCodePoint) !== null && rF !== void 0 ? rF : ((t) => {
    let e = "";
    return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | t & 1023), e += String.fromCharCode(t), e;
  })
);
function s6e(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = i6e.get(t)) !== null && e !== void 0 ? e : t;
}
function h7(t) {
  const e = (
    // eslint-disable-next-line n/no-unsupported-features/node-builtins
    typeof atob == "function" ? (
      // Browser (and Node >=16)
      // eslint-disable-next-line n/no-unsupported-features/node-builtins
      atob(t)
    ) : (
      // Older Node versions (<16)
      // eslint-disable-next-line n/no-unsupported-features/node-builtins
      typeof Buffer.from == "function" ? (
        // eslint-disable-next-line n/no-unsupported-features/node-builtins
        Buffer.from(t, "base64").toString("binary")
      ) : (
        // eslint-disable-next-line unicorn/no-new-buffer, n/no-deprecated-api
        new Buffer(t, "base64").toString("binary")
      )
    )
  ), n = e.length & -2, r = new Uint16Array(n / 2);
  for (let i = 0, s = 0; i < n; i += 2) {
    const a = e.charCodeAt(i), o = e.charCodeAt(i + 1);
    r[s++] = a | o << 8;
  }
  return r;
}
const a6e = /* @__PURE__ */ h7("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"), o6e = /* @__PURE__ */ h7("AAJhZ2xxBwARABMAFQBtAg0AAAAAAA8AcAAmYG8AcwAnYHQAPmB0ADxg9SFvdCJg");
var bs;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.FLAG13 = 8192] = "FLAG13", t[t.BRANCH_LENGTH = 8064] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(bs || (bs = {}));
var Nr;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(Nr || (Nr = {}));
const BP = 32;
function pv(t) {
  return t >= Nr.ZERO && t <= Nr.NINE;
}
function u6e(t) {
  return t >= Nr.UPPER_A && t <= Nr.UPPER_F || t >= Nr.LOWER_A && t <= Nr.LOWER_F;
}
function l6e(t) {
  return t >= Nr.UPPER_A && t <= Nr.UPPER_Z || t >= Nr.LOWER_A && t <= Nr.LOWER_Z || pv(t);
}
function c6e(t) {
  return t === Nr.EQUALS || l6e(t);
}
var Ei;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})(Ei || (Ei = {}));
var su;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(su || (su = {}));
class h6e {
  constructor(e, n, r) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = r, this.state = Ei.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = su.Strict, this.runConsumed = 0;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = Ei.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1, this.runConsumed = 0;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, n) {
    switch (this.state) {
      case Ei.EntityStart:
        return e.charCodeAt(n) === Nr.NUM ? (this.state = Ei.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = Ei.NamedEntity, this.stateNamedEntity(e, n));
      case Ei.NumericStart:
        return this.stateNumericStart(e, n);
      case Ei.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case Ei.NumericHex:
        return this.stateNumericHex(e, n);
      case Ei.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | BP) === Nr.LOWER_X ? (this.state = Ei.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = Ei.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, n) {
    for (; n < e.length; ) {
      const r = e.charCodeAt(n);
      if (pv(r) || u6e(r)) {
        const i = r <= Nr.NINE ? r - Nr.ZERO : (r | BP) - Nr.LOWER_A + 10;
        this.result = this.result * 16 + i, this.consumed++, n++;
      } else
        return this.emitNumericEntity(r, 3);
    }
    return -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, n) {
    for (; n < e.length; ) {
      const r = e.charCodeAt(n);
      if (pv(r))
        this.result = this.result * 10 + (r - Nr.ZERO), this.consumed++, n++;
      else
        return this.emitNumericEntity(r, 2);
    }
    return -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === Nr.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === su.Strict)
      return 0;
    return this.emitCodePoint(s6e(this.result), this.consumed), this.errors && (e !== Nr.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, n) {
    const { decodeTree: r } = this;
    let i = r[this.treeIndex], s = (i & bs.VALUE_LENGTH) >> 14;
    for (; n < e.length; ) {
      if (s === 0 && (i & bs.FLAG13) !== 0) {
        const o = (i & bs.BRANCH_LENGTH) >> 7;
        if (this.runConsumed === 0) {
          const u = i & bs.JUMP_TABLE;
          if (e.charCodeAt(n) !== u)
            return this.result === 0 ? 0 : this.emitNotTerminatedNamedEntity();
          n++, this.excess++, this.runConsumed++;
        }
        for (; this.runConsumed < o; ) {
          if (n >= e.length)
            return -1;
          const u = this.runConsumed - 1, l = r[this.treeIndex + 1 + (u >> 1)], h = u % 2 === 0 ? l & 255 : l >> 8 & 255;
          if (e.charCodeAt(n) !== h)
            return this.runConsumed = 0, this.result === 0 ? 0 : this.emitNotTerminatedNamedEntity();
          n++, this.excess++, this.runConsumed++;
        }
        this.runConsumed = 0, this.treeIndex += 1 + (o >> 1), i = r[this.treeIndex], s = (i & bs.VALUE_LENGTH) >> 14;
      }
      if (n >= e.length)
        break;
      const a = e.charCodeAt(n);
      if (a === Nr.SEMI && s !== 0 && (i & bs.FLAG13) !== 0)
        return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
      if (this.treeIndex = d6e(r, i, this.treeIndex + Math.max(1, s), a), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === su.Attribute && // We shouldn't have consumed any characters after the entity,
        (s === 0 || // And there should be no invalid characters.
        c6e(a)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (i = r[this.treeIndex], s = (i & bs.VALUE_LENGTH) >> 14, s !== 0) {
        if (a === Nr.SEMI)
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        this.decodeMode !== su.Strict && (i & bs.FLAG13) === 0 && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
      n++, this.excess++;
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: n, decodeTree: r } = this, i = (r[n] & bs.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, i, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, n, r) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(n === 1 ? i[e] & ~(bs.VALUE_LENGTH | bs.FLAG13) : i[e + 1], r), n === 3 && this.emitCodePoint(i[e + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case Ei.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== su.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case Ei.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Ei.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Ei.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case Ei.EntityStart:
        return 0;
    }
  }
}
function d6e(t, e, n, r) {
  const i = (e & bs.BRANCH_LENGTH) >> 7, s = e & bs.JUMP_TABLE;
  if (i === 0)
    return s !== 0 && r === s ? n : -1;
  if (s) {
    const l = r - s;
    return l < 0 || l >= i ? -1 : t[n + l] - 1;
  }
  const a = i + 1 >> 1;
  let o = 0, u = i - 1;
  for (; o <= u; ) {
    const l = o + u >>> 1, h = l >> 1, m = t[n + h] >> (l & 1) * 8 & 255;
    if (m < r)
      o = l + 1;
    else if (m > r)
      u = l - 1;
    else
      return t[n + a + l];
  }
  return -1;
}
var ut;
(function(t) {
  t[t.Tab = 9] = "Tab", t[t.NewLine = 10] = "NewLine", t[t.FormFeed = 12] = "FormFeed", t[t.CarriageReturn = 13] = "CarriageReturn", t[t.Space = 32] = "Space", t[t.ExclamationMark = 33] = "ExclamationMark", t[t.Number = 35] = "Number", t[t.Amp = 38] = "Amp", t[t.SingleQuote = 39] = "SingleQuote", t[t.DoubleQuote = 34] = "DoubleQuote", t[t.Dash = 45] = "Dash", t[t.Slash = 47] = "Slash", t[t.Zero = 48] = "Zero", t[t.Nine = 57] = "Nine", t[t.Semi = 59] = "Semi", t[t.Lt = 60] = "Lt", t[t.Eq = 61] = "Eq", t[t.Gt = 62] = "Gt", t[t.Questionmark = 63] = "Questionmark", t[t.UpperA = 65] = "UpperA", t[t.LowerA = 97] = "LowerA", t[t.UpperF = 70] = "UpperF", t[t.LowerF = 102] = "LowerF", t[t.UpperZ = 90] = "UpperZ", t[t.LowerZ = 122] = "LowerZ", t[t.LowerX = 120] = "LowerX", t[t.OpeningSquareBracket = 91] = "OpeningSquareBracket";
})(ut || (ut = {}));
var Ne;
(function(t) {
  t[t.Text = 1] = "Text", t[t.BeforeTagName = 2] = "BeforeTagName", t[t.InTagName = 3] = "InTagName", t[t.InSelfClosingTag = 4] = "InSelfClosingTag", t[t.BeforeClosingTagName = 5] = "BeforeClosingTagName", t[t.InClosingTagName = 6] = "InClosingTagName", t[t.AfterClosingTagName = 7] = "AfterClosingTagName", t[t.BeforeAttributeName = 8] = "BeforeAttributeName", t[t.InAttributeName = 9] = "InAttributeName", t[t.AfterAttributeName = 10] = "AfterAttributeName", t[t.BeforeAttributeValue = 11] = "BeforeAttributeValue", t[t.InAttributeValueDq = 12] = "InAttributeValueDq", t[t.InAttributeValueSq = 13] = "InAttributeValueSq", t[t.InAttributeValueNq = 14] = "InAttributeValueNq", t[t.BeforeDeclaration = 15] = "BeforeDeclaration", t[t.InDeclaration = 16] = "InDeclaration", t[t.InProcessingInstruction = 17] = "InProcessingInstruction", t[t.BeforeComment = 18] = "BeforeComment", t[t.CDATASequence = 19] = "CDATASequence", t[t.InSpecialComment = 20] = "InSpecialComment", t[t.InCommentLike = 21] = "InCommentLike", t[t.BeforeSpecialS = 22] = "BeforeSpecialS", t[t.BeforeSpecialT = 23] = "BeforeSpecialT", t[t.SpecialStartSequence = 24] = "SpecialStartSequence", t[t.InSpecialTag = 25] = "InSpecialTag", t[t.InEntity = 26] = "InEntity";
})(Ne || (Ne = {}));
function Pu(t) {
  return t === ut.Space || t === ut.NewLine || t === ut.Tab || t === ut.FormFeed || t === ut.CarriageReturn;
}
function j0(t) {
  return t === ut.Slash || t === ut.Gt || Pu(t);
}
function f6e(t) {
  return t >= ut.LowerA && t <= ut.LowerZ || t >= ut.UpperA && t <= ut.UpperZ;
}
var au;
(function(t) {
  t[t.NoValue = 0] = "NoValue", t[t.Unquoted = 1] = "Unquoted", t[t.Single = 2] = "Single", t[t.Double = 3] = "Double";
})(au || (au = {}));
const ei = {
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  // CDATA[
  CdataEnd: new Uint8Array([93, 93, 62]),
  // ]]>
  CommentEnd: new Uint8Array([45, 45, 62]),
  // `-->`
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  // `<\/script`
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  // `</style`
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
  // `</title`
  TextareaEnd: new Uint8Array([
    60,
    47,
    116,
    101,
    120,
    116,
    97,
    114,
    101,
    97
  ]),
  // `</textarea`
  XmpEnd: new Uint8Array([60, 47, 120, 109, 112])
  // `</xmp`
};
class m6e {
  constructor({ xmlMode: e = !1, decodeEntities: n = !0 }, r) {
    this.cbs = r, this.state = Ne.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.entityStart = 0, this.baseState = Ne.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.xmlMode = e, this.decodeEntities = n, this.entityDecoder = new h6e(e ? o6e : a6e, (i, s) => this.emitCodePoint(i, s));
  }
  reset() {
    this.state = Ne.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = Ne.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
  }
  write(e) {
    this.offset += this.buffer.length, this.buffer = e, this.parse();
  }
  end() {
    this.running && this.finish();
  }
  pause() {
    this.running = !1;
  }
  resume() {
    this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
  }
  stateText(e) {
    e === ut.Lt || !this.decodeEntities && this.fastForwardTo(ut.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = Ne.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && e === ut.Amp && this.startEntity();
  }
  stateSpecialStartSequence(e) {
    const n = this.sequenceIndex === this.currentSequence.length;
    if (!(n ? (
      // If we are at the end of the sequence, make sure the tag name has ended
      j0(e)
    ) : (
      // Otherwise, do a case-insensitive comparison
      (e | 32) === this.currentSequence[this.sequenceIndex]
    )))
      this.isSpecial = !1;
    else if (!n) {
      this.sequenceIndex++;
      return;
    }
    this.sequenceIndex = 0, this.state = Ne.InTagName, this.stateInTagName(e);
  }
  /** Look for an end tag. For <title> tags, also decode entities. */
  stateInSpecialTag(e) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (e === ut.Gt || Pu(e)) {
        const n = this.index - this.currentSequence.length;
        if (this.sectionStart < n) {
          const r = this.index;
          this.index = n, this.cbs.ontext(this.sectionStart, n), this.index = r;
        }
        this.isSpecial = !1, this.sectionStart = n + 2, this.stateInClosingTagName(e);
        return;
      }
      this.sequenceIndex = 0;
    }
    (e | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === ei.TitleEnd ? this.decodeEntities && e === ut.Amp && this.startEntity() : this.fastForwardTo(ut.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(e === ut.Lt);
  }
  stateCDATASequence(e) {
    e === ei.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === ei.Cdata.length && (this.state = Ne.InCommentLike, this.currentSequence = ei.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = Ne.InDeclaration, this.stateInDeclaration(e));
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */
  fastForwardTo(e) {
    for (; ++this.index < this.buffer.length + this.offset; )
      if (this.buffer.charCodeAt(this.index - this.offset) === e)
        return !0;
    return this.index = this.buffer.length + this.offset - 1, !1;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */
  stateInCommentLike(e) {
    e === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === ei.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = Ne.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : e !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   */
  isTagStartChar(e) {
    return this.xmlMode ? !j0(e) : f6e(e);
  }
  startSpecial(e, n) {
    this.isSpecial = !0, this.currentSequence = e, this.sequenceIndex = n, this.state = Ne.SpecialStartSequence;
  }
  stateBeforeTagName(e) {
    if (e === ut.ExclamationMark)
      this.state = Ne.BeforeDeclaration, this.sectionStart = this.index + 1;
    else if (e === ut.Questionmark)
      this.state = Ne.InProcessingInstruction, this.sectionStart = this.index + 1;
    else if (this.isTagStartChar(e)) {
      const n = e | 32;
      this.sectionStart = this.index, this.xmlMode ? this.state = Ne.InTagName : n === ei.ScriptEnd[2] ? this.state = Ne.BeforeSpecialS : n === ei.TitleEnd[2] || n === ei.XmpEnd[2] ? this.state = Ne.BeforeSpecialT : this.state = Ne.InTagName;
    } else e === ut.Slash ? this.state = Ne.BeforeClosingTagName : (this.state = Ne.Text, this.stateText(e));
  }
  stateInTagName(e) {
    j0(e) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = Ne.BeforeAttributeName, this.stateBeforeAttributeName(e));
  }
  stateBeforeClosingTagName(e) {
    Pu(e) || (e === ut.Gt ? this.state = Ne.Text : (this.state = this.isTagStartChar(e) ? Ne.InClosingTagName : Ne.InSpecialComment, this.sectionStart = this.index));
  }
  stateInClosingTagName(e) {
    (e === ut.Gt || Pu(e)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = Ne.AfterClosingTagName, this.stateAfterClosingTagName(e));
  }
  stateAfterClosingTagName(e) {
    (e === ut.Gt || this.fastForwardTo(ut.Gt)) && (this.state = Ne.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeAttributeName(e) {
    e === ut.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = Ne.InSpecialTag, this.sequenceIndex = 0) : this.state = Ne.Text, this.sectionStart = this.index + 1) : e === ut.Slash ? this.state = Ne.InSelfClosingTag : Pu(e) || (this.state = Ne.InAttributeName, this.sectionStart = this.index);
  }
  stateInSelfClosingTag(e) {
    e === ut.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = Ne.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : Pu(e) || (this.state = Ne.BeforeAttributeName, this.stateBeforeAttributeName(e));
  }
  stateInAttributeName(e) {
    (e === ut.Eq || j0(e)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = Ne.AfterAttributeName, this.stateAfterAttributeName(e));
  }
  stateAfterAttributeName(e) {
    e === ut.Eq ? this.state = Ne.BeforeAttributeValue : e === ut.Slash || e === ut.Gt ? (this.cbs.onattribend(au.NoValue, this.sectionStart), this.sectionStart = -1, this.state = Ne.BeforeAttributeName, this.stateBeforeAttributeName(e)) : Pu(e) || (this.cbs.onattribend(au.NoValue, this.sectionStart), this.state = Ne.InAttributeName, this.sectionStart = this.index);
  }
  stateBeforeAttributeValue(e) {
    e === ut.DoubleQuote ? (this.state = Ne.InAttributeValueDq, this.sectionStart = this.index + 1) : e === ut.SingleQuote ? (this.state = Ne.InAttributeValueSq, this.sectionStart = this.index + 1) : Pu(e) || (this.sectionStart = this.index, this.state = Ne.InAttributeValueNq, this.stateInAttributeValueNoQuotes(e));
  }
  handleInAttributeValue(e, n) {
    e === n || !this.decodeEntities && this.fastForwardTo(n) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(n === ut.DoubleQuote ? au.Double : au.Single, this.index + 1), this.state = Ne.BeforeAttributeName) : this.decodeEntities && e === ut.Amp && this.startEntity();
  }
  stateInAttributeValueDoubleQuotes(e) {
    this.handleInAttributeValue(e, ut.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(e) {
    this.handleInAttributeValue(e, ut.SingleQuote);
  }
  stateInAttributeValueNoQuotes(e) {
    Pu(e) || e === ut.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(au.Unquoted, this.index), this.state = Ne.BeforeAttributeName, this.stateBeforeAttributeName(e)) : this.decodeEntities && e === ut.Amp && this.startEntity();
  }
  stateBeforeDeclaration(e) {
    e === ut.OpeningSquareBracket ? (this.state = Ne.CDATASequence, this.sequenceIndex = 0) : this.state = e === ut.Dash ? Ne.BeforeComment : Ne.InDeclaration;
  }
  stateInDeclaration(e) {
    (e === ut.Gt || this.fastForwardTo(ut.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = Ne.Text, this.sectionStart = this.index + 1);
  }
  stateInProcessingInstruction(e) {
    (e === ut.Gt || this.fastForwardTo(ut.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = Ne.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeComment(e) {
    e === ut.Dash ? (this.state = Ne.InCommentLike, this.currentSequence = ei.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = Ne.InDeclaration;
  }
  stateInSpecialComment(e) {
    (e === ut.Gt || this.fastForwardTo(ut.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = Ne.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeSpecialS(e) {
    const n = e | 32;
    n === ei.ScriptEnd[3] ? this.startSpecial(ei.ScriptEnd, 4) : n === ei.StyleEnd[3] ? this.startSpecial(ei.StyleEnd, 4) : (this.state = Ne.InTagName, this.stateInTagName(e));
  }
  stateBeforeSpecialT(e) {
    switch (e | 32) {
      case ei.TitleEnd[3]: {
        this.startSpecial(ei.TitleEnd, 4);
        break;
      }
      case ei.TextareaEnd[3]: {
        this.startSpecial(ei.TextareaEnd, 4);
        break;
      }
      case ei.XmpEnd[3]: {
        this.startSpecial(ei.XmpEnd, 4);
        break;
      }
      default:
        this.state = Ne.InTagName, this.stateInTagName(e);
    }
  }
  startEntity() {
    this.baseState = this.state, this.state = Ne.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? su.Strict : this.baseState === Ne.Text || this.baseState === Ne.InSpecialTag ? su.Legacy : su.Attribute);
  }
  stateInEntity() {
    const e = this.index - this.offset, n = this.entityDecoder.write(this.buffer, e);
    if (n >= 0)
      this.state = this.baseState, n === 0 && (this.index -= 1);
    else {
      if (e < this.buffer.length && this.buffer.charCodeAt(e) === ut.Amp) {
        this.state = this.baseState, this.index -= 1;
        return;
      }
      this.index = this.offset + this.buffer.length - 1;
    }
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    this.running && this.sectionStart !== this.index && (this.state === Ne.Text || this.state === Ne.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === Ne.InAttributeValueDq || this.state === Ne.InAttributeValueSq || this.state === Ne.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    for (; this.shouldContinue(); ) {
      const e = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case Ne.Text: {
          this.stateText(e);
          break;
        }
        case Ne.SpecialStartSequence: {
          this.stateSpecialStartSequence(e);
          break;
        }
        case Ne.InSpecialTag: {
          this.stateInSpecialTag(e);
          break;
        }
        case Ne.CDATASequence: {
          this.stateCDATASequence(e);
          break;
        }
        case Ne.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(e);
          break;
        }
        case Ne.InAttributeName: {
          this.stateInAttributeName(e);
          break;
        }
        case Ne.InCommentLike: {
          this.stateInCommentLike(e);
          break;
        }
        case Ne.InSpecialComment: {
          this.stateInSpecialComment(e);
          break;
        }
        case Ne.BeforeAttributeName: {
          this.stateBeforeAttributeName(e);
          break;
        }
        case Ne.InTagName: {
          this.stateInTagName(e);
          break;
        }
        case Ne.InClosingTagName: {
          this.stateInClosingTagName(e);
          break;
        }
        case Ne.BeforeTagName: {
          this.stateBeforeTagName(e);
          break;
        }
        case Ne.AfterAttributeName: {
          this.stateAfterAttributeName(e);
          break;
        }
        case Ne.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(e);
          break;
        }
        case Ne.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(e);
          break;
        }
        case Ne.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(e);
          break;
        }
        case Ne.AfterClosingTagName: {
          this.stateAfterClosingTagName(e);
          break;
        }
        case Ne.BeforeSpecialS: {
          this.stateBeforeSpecialS(e);
          break;
        }
        case Ne.BeforeSpecialT: {
          this.stateBeforeSpecialT(e);
          break;
        }
        case Ne.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(e);
          break;
        }
        case Ne.InSelfClosingTag: {
          this.stateInSelfClosingTag(e);
          break;
        }
        case Ne.InDeclaration: {
          this.stateInDeclaration(e);
          break;
        }
        case Ne.BeforeDeclaration: {
          this.stateBeforeDeclaration(e);
          break;
        }
        case Ne.BeforeComment: {
          this.stateBeforeComment(e);
          break;
        }
        case Ne.InProcessingInstruction: {
          this.stateInProcessingInstruction(e);
          break;
        }
        case Ne.InEntity: {
          this.stateInEntity();
          break;
        }
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    this.state === Ne.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const e = this.buffer.length + this.offset;
    this.sectionStart >= e || (this.state === Ne.InCommentLike ? this.currentSequence === ei.CdataEnd ? this.cbs.oncdata(this.sectionStart, e, 0) : this.cbs.oncomment(this.sectionStart, e, 0) : this.state === Ne.InTagName || this.state === Ne.BeforeAttributeName || this.state === Ne.BeforeAttributeValue || this.state === Ne.AfterAttributeName || this.state === Ne.InAttributeName || this.state === Ne.InAttributeValueSq || this.state === Ne.InAttributeValueDq || this.state === Ne.InAttributeValueNq || this.state === Ne.InClosingTagName || this.cbs.ontext(this.sectionStart, e));
  }
  emitCodePoint(e, n) {
    this.baseState !== Ne.Text && this.baseState !== Ne.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + n, this.index = this.sectionStart - 1, this.cbs.onattribentity(e)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + n, this.index = this.sectionStart - 1, this.cbs.ontextentity(e, this.sectionStart));
  }
}
const od = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), Vn = /* @__PURE__ */ new Set(["p"]), $P = /* @__PURE__ */ new Set(["thead", "tbody"]), HP = /* @__PURE__ */ new Set(["dd", "dt"]), UP = /* @__PURE__ */ new Set(["rt", "rp"]), g6e = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", Vn],
  ["h1", Vn],
  ["h2", Vn],
  ["h3", Vn],
  ["h4", Vn],
  ["h5", Vn],
  ["h6", Vn],
  ["select", od],
  ["input", od],
  ["output", od],
  ["button", od],
  ["datalist", od],
  ["textarea", od],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", HP],
  ["dt", HP],
  ["address", Vn],
  ["article", Vn],
  ["aside", Vn],
  ["blockquote", Vn],
  ["details", Vn],
  ["div", Vn],
  ["dl", Vn],
  ["fieldset", Vn],
  ["figcaption", Vn],
  ["figure", Vn],
  ["footer", Vn],
  ["form", Vn],
  ["header", Vn],
  ["hr", Vn],
  ["main", Vn],
  ["nav", Vn],
  ["ol", Vn],
  ["pre", Vn],
  ["section", Vn],
  ["table", Vn],
  ["ul", Vn],
  ["rt", UP],
  ["rp", UP],
  ["tbody", $P],
  ["tfoot", $P]
]), p6e = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), GP = /* @__PURE__ */ new Set(["math", "svg"]), WP = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), b6e = /\s|\//;
class y6e {
  constructor(e, n = {}) {
    var r, i, s, a, o, u;
    this.options = n, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = e ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = (r = n.lowerCaseTags) !== null && r !== void 0 ? r : this.htmlMode, this.lowerCaseAttributeNames = (i = n.lowerCaseAttributeNames) !== null && i !== void 0 ? i : this.htmlMode, this.recognizeSelfClosing = (s = n.recognizeSelfClosing) !== null && s !== void 0 ? s : !this.htmlMode, this.tokenizer = new ((a = n.Tokenizer) !== null && a !== void 0 ? a : m6e)(this.options, this), this.foreignContext = [!this.htmlMode], (u = (o = this.cbs).onparserinit) === null || u === void 0 || u.call(o, this);
  }
  // Tokenizer event handlers
  /** @internal */
  ontext(e, n) {
    var r, i;
    const s = this.getSlice(e, n);
    this.endIndex = n - 1, (i = (r = this.cbs).ontext) === null || i === void 0 || i.call(r, s), this.startIndex = n;
  }
  /** @internal */
  ontextentity(e, n) {
    var r, i;
    this.endIndex = n - 1, (i = (r = this.cbs).ontext) === null || i === void 0 || i.call(r, OP(e)), this.startIndex = n;
  }
  /**
   * Checks if the current tag is a void element. Override this if you want
   * to specify your own additional void elements.
   */
  isVoidElement(e) {
    return this.htmlMode && p6e.has(e);
  }
  /** @internal */
  onopentagname(e, n) {
    this.endIndex = n;
    let r = this.getSlice(e, n);
    this.lowerCaseTagNames && (r = r.toLowerCase()), this.emitOpenTag(r);
  }
  emitOpenTag(e) {
    var n, r, i, s;
    this.openTagStart = this.startIndex, this.tagname = e;
    const a = this.htmlMode && g6e.get(e);
    if (a)
      for (; this.stack.length > 0 && a.has(this.stack[0]); ) {
        const o = this.stack.shift();
        (r = (n = this.cbs).onclosetag) === null || r === void 0 || r.call(n, o, !0);
      }
    this.isVoidElement(e) || (this.stack.unshift(e), this.htmlMode && (GP.has(e) ? this.foreignContext.unshift(!0) : WP.has(e) && this.foreignContext.unshift(!1))), (s = (i = this.cbs).onopentagname) === null || s === void 0 || s.call(i, e), this.cbs.onopentag && (this.attribs = {});
  }
  endOpenTag(e) {
    var n, r;
    this.startIndex = this.openTagStart, this.attribs && ((r = (n = this.cbs).onopentag) === null || r === void 0 || r.call(n, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
  }
  /** @internal */
  onopentagend(e) {
    this.endIndex = e, this.endOpenTag(!1), this.startIndex = e + 1;
  }
  /** @internal */
  onclosetag(e, n) {
    var r, i, s, a, o, u, l, h;
    this.endIndex = n;
    let f = this.getSlice(e, n);
    if (this.lowerCaseTagNames && (f = f.toLowerCase()), this.htmlMode && (GP.has(f) || WP.has(f)) && this.foreignContext.shift(), this.isVoidElement(f))
      this.htmlMode && f === "br" && ((a = (s = this.cbs).onopentagname) === null || a === void 0 || a.call(s, "br"), (u = (o = this.cbs).onopentag) === null || u === void 0 || u.call(o, "br", {}, !0), (h = (l = this.cbs).onclosetag) === null || h === void 0 || h.call(l, "br", !1));
    else {
      const m = this.stack.indexOf(f);
      if (m !== -1)
        for (let g = 0; g <= m; g++) {
          const A = this.stack.shift();
          (i = (r = this.cbs).onclosetag) === null || i === void 0 || i.call(r, A, g !== m);
        }
      else this.htmlMode && f === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
    }
    this.startIndex = n + 1;
  }
  /** @internal */
  onselfclosingtag(e) {
    this.endIndex = e, this.recognizeSelfClosing || this.foreignContext[0] ? (this.closeCurrentTag(!1), this.startIndex = e + 1) : this.onopentagend(e);
  }
  closeCurrentTag(e) {
    var n, r;
    const i = this.tagname;
    this.endOpenTag(e), this.stack[0] === i && ((r = (n = this.cbs).onclosetag) === null || r === void 0 || r.call(n, i, !e), this.stack.shift());
  }
  /** @internal */
  onattribname(e, n) {
    this.startIndex = e;
    const r = this.getSlice(e, n);
    this.attribname = this.lowerCaseAttributeNames ? r.toLowerCase() : r;
  }
  /** @internal */
  onattribdata(e, n) {
    this.attribvalue += this.getSlice(e, n);
  }
  /** @internal */
  onattribentity(e) {
    this.attribvalue += OP(e);
  }
  /** @internal */
  onattribend(e, n) {
    var r, i;
    this.endIndex = n, (i = (r = this.cbs).onattribute) === null || i === void 0 || i.call(r, this.attribname, this.attribvalue, e === au.Double ? '"' : e === au.Single ? "'" : e === au.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
  }
  getInstructionName(e) {
    const n = e.search(b6e);
    let r = n < 0 ? e : e.substr(0, n);
    return this.lowerCaseTagNames && (r = r.toLowerCase()), r;
  }
  /** @internal */
  ondeclaration(e, n) {
    this.endIndex = n;
    const r = this.getSlice(e, n);
    if (this.cbs.onprocessinginstruction) {
      const i = this.getInstructionName(r);
      this.cbs.onprocessinginstruction(`!${i}`, `!${r}`);
    }
    this.startIndex = n + 1;
  }
  /** @internal */
  onprocessinginstruction(e, n) {
    this.endIndex = n;
    const r = this.getSlice(e, n);
    if (this.cbs.onprocessinginstruction) {
      const i = this.getInstructionName(r);
      this.cbs.onprocessinginstruction(`?${i}`, `?${r}`);
    }
    this.startIndex = n + 1;
  }
  /** @internal */
  oncomment(e, n, r) {
    var i, s, a, o;
    this.endIndex = n, (s = (i = this.cbs).oncomment) === null || s === void 0 || s.call(i, this.getSlice(e, n - r)), (o = (a = this.cbs).oncommentend) === null || o === void 0 || o.call(a), this.startIndex = n + 1;
  }
  /** @internal */
  oncdata(e, n, r) {
    var i, s, a, o, u, l, h, f, m, g;
    this.endIndex = n;
    const A = this.getSlice(e, n - r);
    !this.htmlMode || this.options.recognizeCDATA ? ((s = (i = this.cbs).oncdatastart) === null || s === void 0 || s.call(i), (o = (a = this.cbs).ontext) === null || o === void 0 || o.call(a, A), (l = (u = this.cbs).oncdataend) === null || l === void 0 || l.call(u)) : ((f = (h = this.cbs).oncomment) === null || f === void 0 || f.call(h, `[CDATA[${A}]]`), (g = (m = this.cbs).oncommentend) === null || g === void 0 || g.call(m)), this.startIndex = n + 1;
  }
  /** @internal */
  onend() {
    var e, n;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let r = 0; r < this.stack.length; r++)
        this.cbs.onclosetag(this.stack[r], !0);
    }
    (n = (e = this.cbs).onend) === null || n === void 0 || n.call(e);
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    var e, n, r, i;
    (n = (e = this.cbs).onreset) === null || n === void 0 || n.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (i = (r = this.cbs).onparserinit) === null || i === void 0 || i.call(r, this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(!this.htmlMode), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   *
   * @param data Document to parse.
   */
  parseComplete(e) {
    this.reset(), this.end(e);
  }
  getSlice(e, n) {
    for (; e - this.bufferOffset >= this.buffers[0].length; )
      this.shiftBuffer();
    let r = this.buffers[0].slice(e - this.bufferOffset, n - this.bufferOffset);
    for (; n - this.bufferOffset > this.buffers[0].length; )
      this.shiftBuffer(), r += this.buffers[0].slice(0, n - this.bufferOffset);
    return r;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   *
   * @param chunk Chunk to parse.
   */
  write(e) {
    var n, r;
    if (this.ended) {
      (r = (n = this.cbs).onerror) === null || r === void 0 || r.call(n, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(e), this.tokenizer.running && (this.tokenizer.write(e), this.writeIndex++);
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   *
   * @param chunk Optional final chunk to parse.
   */
  end(e) {
    var n, r;
    if (this.ended) {
      (r = (n = this.cbs).onerror) === null || r === void 0 || r.call(n, new Error(".end() after done!"));
      return;
    }
    e && this.write(e), this.ended = !0, this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    this.ended && this.tokenizer.end();
  }
  /**
   * Alias of `write`, for backwards compatibility.
   *
   * @param chunk Chunk to parse.
   * @deprecated
   */
  parseChunk(e) {
    this.write(e);
  }
  /**
   * Alias of `end`, for backwards compatibility.
   *
   * @param chunk Optional final chunk to parse.
   * @deprecated
   */
  done(e) {
    this.end(e);
  }
}
function A6e(t, e) {
  const n = new jBe(void 0, e);
  return new y6e(n, e).end(t), n.root;
}
var iF;
const Lg = (
  // @ts-expect-error `hasOwn` is a standard object method
  (iF = Object.hasOwn) !== null && iF !== void 0 ? iF : ((t, e) => Object.prototype.hasOwnProperty.call(t, e))
), Mg = /\s+/, bv = "data-", D2 = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i, E6e = /^{[^]*}$|^\[[^]*]$/;
function N1(t, e, n) {
  var r;
  if (!(!t || !St(t))) {
    if ((r = t.attribs) !== null && r !== void 0 || (t.attribs = {}), !e)
      return t.attribs;
    if (Lg(t.attribs, e))
      return !n && D2.test(e) ? e : t.attribs[e];
    if (t.name === "option" && e === "value")
      return Pg(t.children);
    if (t.name === "input" && (t.attribs.type === "radio" || t.attribs.type === "checkbox") && e === "value")
      return "on";
  }
}
function jd(t, e, n) {
  n === null ? f7(t, e) : t.attribs[e] = `${n}`;
}
function S6e(t, e) {
  if (typeof t == "object" || e !== void 0) {
    if (typeof e == "function") {
      if (typeof t != "string")
        throw new Error("Bad combination of arguments.");
      return Or(this, (n, r) => {
        St(n) && jd(n, t, e.call(n, r, n.attribs[t]));
      });
    }
    return Or(this, (n) => {
      if (St(n))
        if (typeof t == "object")
          for (const r of Object.keys(t)) {
            const i = t[r];
            jd(n, r, i);
          }
        else
          jd(n, t, e);
    });
  }
  return arguments.length > 1 ? this : N1(this[0], t, this.options.xmlMode);
}
function VP(t, e, n) {
  return e in t ? (
    // @ts-expect-error TS doesn't like us accessing the value directly here.
    t[e]
  ) : !n && D2.test(e) ? N1(t, e, !1) !== void 0 : N1(t, e, n);
}
function sF(t, e, n, r) {
  e in t ? t[e] = n : jd(t, e, !r && D2.test(e) ? n ? "" : null : `${n}`);
}
function w6e(t, e) {
  var n;
  if (typeof t == "string" && e === void 0) {
    const r = this[0];
    if (!r)
      return;
    switch (t) {
      case "style": {
        const i = this.css(), s = Object.keys(i);
        for (let a = 0; a < s.length; a++)
          i[a] = s[a];
        return i.length = s.length, i;
      }
      case "tagName":
      case "nodeName":
        return St(r) ? r.name.toUpperCase() : void 0;
      case "href":
      case "src": {
        if (!St(r))
          return;
        const i = (n = r.attribs) === null || n === void 0 ? void 0 : n[t];
        return typeof URL < "u" && (t === "href" && (r.tagName === "a" || r.tagName === "link") || t === "src" && (r.tagName === "img" || r.tagName === "iframe" || r.tagName === "audio" || r.tagName === "video" || r.tagName === "source")) && i !== void 0 && this.options.baseURI ? new URL(i, this.options.baseURI).href : i;
      }
      case "innerText":
        return C1(r);
      case "textContent":
        return Sf(r);
      case "outerHTML":
        return r.type === w2 ? this.html() : this.clone().wrap("<container />").parent().html();
      case "innerHTML":
        return this.html();
      default:
        return St(r) ? VP(r, t, this.options.xmlMode) : void 0;
    }
  }
  if (typeof t == "object" || e !== void 0) {
    if (typeof e == "function") {
      if (typeof t == "object")
        throw new TypeError("Bad combination of arguments.");
      return Or(this, (r, i) => {
        St(r) && sF(r, t, e.call(r, i, VP(r, t, this.options.xmlMode)), this.options.xmlMode);
      });
    }
    return Or(this, (r) => {
      if (St(r))
        if (typeof t == "object")
          for (const i of Object.keys(t)) {
            const s = t[i];
            sF(r, i, s, this.options.xmlMode);
          }
        else
          sF(r, t, e, this.options.xmlMode);
    });
  }
}
function KP(t, e, n) {
  var r;
  (r = t.data) !== null && r !== void 0 || (t.data = {}), typeof e == "object" ? Object.assign(t.data, e) : typeof e == "string" && n !== void 0 && (t.data[e] = n);
}
function F6e(t) {
  for (const e of Object.keys(t.attribs)) {
    if (!e.startsWith(bv))
      continue;
    const n = n6e(e.slice(bv.length));
    Lg(t.data, n) || (t.data[n] = d7(t.attribs[e]));
  }
  return t.data;
}
function T6e(t, e) {
  const n = bv + r6e(e), r = t.data;
  if (Lg(r, e))
    return r[e];
  if (Lg(t.attribs, n))
    return r[e] = d7(t.attribs[n]);
}
function d7(t) {
  if (t === "null")
    return null;
  if (t === "true")
    return !0;
  if (t === "false")
    return !1;
  const e = Number(t);
  if (t === String(e))
    return e;
  if (E6e.test(t))
    try {
      return JSON.parse(t);
    } catch {
    }
  return t;
}
function v6e(t, e) {
  var n;
  const r = this[0];
  if (!r || !St(r))
    return;
  const i = r;
  return (n = i.data) !== null && n !== void 0 || (i.data = {}), t == null ? F6e(i) : typeof t == "object" || e !== void 0 ? (Or(this, (s) => {
    St(s) && (typeof t == "object" ? KP(s, t) : KP(s, t, e));
  }), this) : T6e(i, t);
}
function x6e(t) {
  const e = arguments.length === 0, n = this[0];
  if (!n || !St(n))
    return e ? void 0 : this;
  switch (n.name) {
    case "textarea":
      return this.text(t);
    case "select": {
      const r = this.find("option:selected");
      if (!e) {
        if (this.attr("multiple") == null && typeof t == "object")
          return this;
        this.find("option").removeAttr("selected");
        const i = typeof t == "object" ? t : [t];
        for (const s of i)
          this.find(`option[value="${s}"]`).attr("selected", "");
        return this;
      }
      return this.attr("multiple") ? r.toArray().map((i) => Pg(i.children)) : r.attr("value");
    }
    case "button":
    case "input":
    case "option":
      return e ? this.attr("value") : this.attr("value", t);
  }
}
function f7(t, e) {
  !t.attribs || !Lg(t.attribs, e) || delete t.attribs[e];
}
function D1(t) {
  return t ? t.trim().split(Mg) : [];
}
function C6e(t) {
  const e = D1(t);
  for (const n of e)
    Or(this, (r) => {
      St(r) && f7(r, n);
    });
  return this;
}
function k6e(t) {
  return this.toArray().some((e) => {
    const n = St(e) && e.attribs.class;
    let r = -1;
    if (n && t.length > 0)
      for (; (r = n.indexOf(t, r + 1)) > -1; ) {
        const i = r + t.length;
        if ((r === 0 || Mg.test(n[r - 1])) && (i === n.length || Mg.test(n[i])))
          return !0;
      }
    return !1;
  });
}
function m7(t) {
  if (typeof t == "function")
    return Or(this, (r, i) => {
      if (St(r)) {
        const s = r.attribs.class || "";
        m7.call([r], t.call(r, i, s));
      }
    });
  if (!t || typeof t != "string")
    return this;
  const e = t.split(Mg), n = this.length;
  for (let r = 0; r < n; r++) {
    const i = this[r];
    if (!St(i))
      continue;
    const s = N1(i, "class", !1);
    if (s) {
      let a = ` ${s} `;
      for (const o of e) {
        const u = `${o} `;
        a.includes(` ${u}`) || (a += u);
      }
      jd(i, "class", a.trim());
    } else
      jd(i, "class", e.join(" ").trim());
  }
  return this;
}
function g7(t) {
  if (typeof t == "function")
    return Or(this, (i, s) => {
      St(i) && g7.call([i], t.call(i, s, i.attribs.class || ""));
    });
  const e = D1(t), n = e.length, r = arguments.length === 0;
  return Or(this, (i) => {
    if (St(i))
      if (r)
        i.attribs.class = "";
      else {
        const s = D1(i.attribs.class);
        let a = !1;
        for (let o = 0; o < n; o++) {
          const u = s.indexOf(e[o]);
          u !== -1 && (s.splice(u, 1), a = !0, o--);
        }
        a && (i.attribs.class = s.join(" "));
      }
  });
}
function p7(t, e) {
  if (typeof t == "function")
    return Or(this, (a, o) => {
      St(a) && p7.call([a], t.call(a, o, a.attribs.class || "", e), e);
    });
  if (!t || typeof t != "string")
    return this;
  const n = t.split(Mg), r = n.length, i = typeof e == "boolean" ? e ? 1 : -1 : 0, s = this.length;
  for (let a = 0; a < s; a++) {
    const o = this[a];
    if (!St(o))
      continue;
    const u = D1(o.attribs.class);
    for (let l = 0; l < r; l++) {
      const h = u.indexOf(n[l]);
      i >= 0 && h === -1 ? u.push(n[l]) : i <= 0 && h !== -1 && u.splice(h, 1);
    }
    o.attribs.class = u.join(" ");
  }
  return this;
}
const _6e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addClass: m7,
  attr: S6e,
  data: v6e,
  hasClass: k6e,
  prop: w6e,
  removeAttr: C6e,
  removeClass: g7,
  toggleClass: p7,
  val: x6e
}, Symbol.toStringTag, { value: "Module" }));
var lt;
(function(t) {
  t.Attribute = "attribute", t.Pseudo = "pseudo", t.PseudoElement = "pseudo-element", t.Tag = "tag", t.Universal = "universal", t.Adjacent = "adjacent", t.Child = "child", t.Descendant = "descendant", t.Parent = "parent", t.Sibling = "sibling", t.ColumnCombinator = "column-combinator";
})(lt || (lt = {}));
var di;
(function(t) {
  t.Any = "any", t.Element = "element", t.End = "end", t.Equals = "equals", t.Exists = "exists", t.Hyphen = "hyphen", t.Not = "not", t.Start = "start";
})(di || (di = {}));
const zP = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/, N6e = /\\([\da-f]{1,6}\s?|(\s)|.)/gi, D6e = /* @__PURE__ */ new Map([
  [126, di.Element],
  [94, di.Start],
  [36, di.End],
  [42, di.Any],
  [33, di.Not],
  [124, di.Hyphen]
]), I6e = /* @__PURE__ */ new Set([
  "has",
  "not",
  "matches",
  "is",
  "where",
  "host",
  "host-context"
]);
function ug(t) {
  switch (t.type) {
    case lt.Adjacent:
    case lt.Child:
    case lt.Descendant:
    case lt.Parent:
    case lt.Sibling:
    case lt.ColumnCombinator:
      return !0;
    default:
      return !1;
  }
}
const R6e = /* @__PURE__ */ new Set(["contains", "icontains"]);
function P6e(t, e, n) {
  const r = parseInt(e, 16) - 65536;
  return r !== r || n ? e : r < 0 ? (
    // BMP codepoint
    String.fromCharCode(r + 65536)
  ) : (
    // Supplemental Plane codepoint (surrogate pair)
    String.fromCharCode(r >> 10 | 55296, r & 1023 | 56320)
  );
}
function hm(t) {
  return t.replace(N6e, P6e);
}
function aF(t) {
  return t === 39 || t === 34;
}
function jP(t) {
  return t === 32 || t === 9 || t === 10 || t === 12 || t === 13;
}
function HA(t) {
  const e = [], n = b7(e, `${t}`, 0);
  if (n < t.length)
    throw new Error(`Unmatched selector: ${t.slice(n)}`);
  return e;
}
function b7(t, e, n) {
  let r = [];
  function i(m) {
    const g = e.slice(n + m).match(zP);
    if (!g)
      throw new Error(`Expected name, found ${e.slice(n)}`);
    const [A] = g;
    return n += m + A.length, hm(A);
  }
  function s(m) {
    for (n += m; n < e.length && jP(e.charCodeAt(n)); )
      n++;
  }
  function a() {
    n += 1;
    const m = n;
    let g = 1;
    for (; g > 0 && n < e.length; n++)
      e.charCodeAt(n) === 40 && !o(n) ? g++ : e.charCodeAt(n) === 41 && !o(n) && g--;
    if (g)
      throw new Error("Parenthesis not matched");
    return hm(e.slice(m, n - 1));
  }
  function o(m) {
    let g = 0;
    for (; e.charCodeAt(--m) === 92; )
      g++;
    return (g & 1) === 1;
  }
  function u() {
    if (r.length > 0 && ug(r[r.length - 1]))
      throw new Error("Did not expect successive traversals.");
  }
  function l(m) {
    if (r.length > 0 && r[r.length - 1].type === lt.Descendant) {
      r[r.length - 1].type = m;
      return;
    }
    u(), r.push({ type: m });
  }
  function h(m, g) {
    r.push({
      type: lt.Attribute,
      name: m,
      action: g,
      value: i(1),
      namespace: null,
      ignoreCase: "quirks"
    });
  }
  function f() {
    if (r.length && r[r.length - 1].type === lt.Descendant && r.pop(), r.length === 0)
      throw new Error("Empty sub-selector");
    t.push(r);
  }
  if (s(0), e.length === n)
    return n;
  e: for (; n < e.length; ) {
    const m = e.charCodeAt(n);
    switch (m) {
      // Whitespace
      case 32:
      case 9:
      case 10:
      case 12:
      case 13: {
        (r.length === 0 || r[0].type !== lt.Descendant) && (u(), r.push({ type: lt.Descendant })), s(1);
        break;
      }
      // Traversals
      case 62: {
        l(lt.Child), s(1);
        break;
      }
      case 60: {
        l(lt.Parent), s(1);
        break;
      }
      case 126: {
        l(lt.Sibling), s(1);
        break;
      }
      case 43: {
        l(lt.Adjacent), s(1);
        break;
      }
      // Special attribute selectors: .class, #id
      case 46: {
        h("class", di.Element);
        break;
      }
      case 35: {
        h("id", di.Equals);
        break;
      }
      case 91: {
        s(1);
        let g, A = null;
        e.charCodeAt(n) === 124 ? g = i(1) : e.startsWith("*|", n) ? (A = "*", g = i(2)) : (g = i(0), e.charCodeAt(n) === 124 && e.charCodeAt(n + 1) !== 61 && (A = g, g = i(1))), s(0);
        let E = di.Exists;
        const w = D6e.get(e.charCodeAt(n));
        if (w) {
          if (E = w, e.charCodeAt(n + 1) !== 61)
            throw new Error("Expected `=`");
          s(2);
        } else e.charCodeAt(n) === 61 && (E = di.Equals, s(1));
        let x = "", N = null;
        if (E !== "exists") {
          if (aF(e.charCodeAt(n))) {
            const C = e.charCodeAt(n);
            let D = n + 1;
            for (; D < e.length && (e.charCodeAt(D) !== C || o(D)); )
              D += 1;
            if (e.charCodeAt(D) !== C)
              throw new Error("Attribute value didn't end");
            x = hm(e.slice(n + 1, D)), n = D + 1;
          } else {
            const C = n;
            for (; n < e.length && (!jP(e.charCodeAt(n)) && e.charCodeAt(n) !== 93 || o(n)); )
              n += 1;
            x = hm(e.slice(C, n));
          }
          s(0);
          const P = e.charCodeAt(n) | 32;
          P === 115 ? (N = !1, s(1)) : P === 105 && (N = !0, s(1));
        }
        if (e.charCodeAt(n) !== 93)
          throw new Error("Attribute selector didn't terminate");
        n += 1;
        const B = {
          type: lt.Attribute,
          name: g,
          action: E,
          value: x,
          namespace: A,
          ignoreCase: N
        };
        r.push(B);
        break;
      }
      case 58: {
        if (e.charCodeAt(n + 1) === 58) {
          r.push({
            type: lt.PseudoElement,
            name: i(2).toLowerCase(),
            data: e.charCodeAt(n) === 40 ? a() : null
          });
          continue;
        }
        const g = i(1).toLowerCase();
        let A = null;
        if (e.charCodeAt(n) === 40)
          if (I6e.has(g)) {
            if (aF(e.charCodeAt(n + 1)))
              throw new Error(`Pseudo-selector ${g} cannot be quoted`);
            if (A = [], n = b7(A, e, n + 1), e.charCodeAt(n) !== 41)
              throw new Error(`Missing closing parenthesis in :${g} (${e})`);
            n += 1;
          } else {
            if (A = a(), R6e.has(g)) {
              const E = A.charCodeAt(0);
              E === A.charCodeAt(A.length - 1) && aF(E) && (A = A.slice(1, -1));
            }
            A = hm(A);
          }
        r.push({ type: lt.Pseudo, name: g, data: A });
        break;
      }
      case 44: {
        f(), r = [], s(1);
        break;
      }
      default: {
        if (e.startsWith("/*", n)) {
          const E = e.indexOf("*/", n + 2);
          if (E < 0)
            throw new Error("Comment was not terminated");
          n = E + 2, r.length === 0 && s(0);
          break;
        }
        let g = null, A;
        if (m === 42)
          n += 1, A = "*";
        else if (m === 124) {
          if (A = "", e.charCodeAt(n + 1) === 124) {
            l(lt.ColumnCombinator), s(2);
            break;
          }
        } else if (zP.test(e.slice(n)))
          A = i(0);
        else
          break e;
        e.charCodeAt(n) === 124 && e.charCodeAt(n + 1) !== 124 && (g = A, e.charCodeAt(n + 1) === 42 ? (A = "*", n += 2) : A = i(1)), r.push(A === "*" ? { type: lt.Universal, namespace: g } : { type: lt.Tag, name: A, namespace: g });
      }
    }
  }
  return f(), n;
}
var oF, YP;
function L6e() {
  return YP || (YP = 1, oF = {
    trueFunc: function() {
      return !0;
    },
    falseFunc: function() {
      return !1;
    }
  }), oF;
}
var I1 = L6e();
const jt = /* @__PURE__ */ kh(I1), y7 = /* @__PURE__ */ new Map([
  [lt.Universal, 50],
  [lt.Tag, 30],
  [lt.Attribute, 1],
  [lt.Pseudo, 0]
]);
function I2(t) {
  return !y7.has(t.type);
}
const M6e = /* @__PURE__ */ new Map([
  [di.Exists, 10],
  [di.Equals, 8],
  [di.Not, 7],
  [di.Start, 6],
  [di.End, 6],
  [di.Any, 5]
]);
function O6e(t) {
  const e = t.map(A7);
  for (let n = 1; n < t.length; n++) {
    const r = e[n];
    if (!(r < 0))
      for (let i = n - 1; i >= 0 && r < e[i]; i--) {
        const s = t[i + 1];
        t[i + 1] = t[i], t[i] = s, e[i + 1] = e[i], e[i] = r;
      }
  }
}
function A7(t) {
  var e, n;
  let r = (e = y7.get(t.type)) !== null && e !== void 0 ? e : -1;
  return t.type === lt.Attribute ? (r = (n = M6e.get(t.action)) !== null && n !== void 0 ? n : 4, t.action === di.Equals && t.name === "id" && (r = 9), t.ignoreCase && (r >>= 1)) : t.type === lt.Pseudo && (t.data ? t.name === "has" || t.name === "contains" ? r = 0 : Array.isArray(t.data) ? (r = Math.min(...t.data.map((i) => Math.min(...i.map(A7)))), r < 0 && (r = 0)) : r = 2 : r = 3), r;
}
const B6e = /[-[\]{}()*+?.,\\^$|#\s]/g;
function qP(t) {
  return t.replace(B6e, "\\$&");
}
const $6e = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "align",
  "alink",
  "axis",
  "bgcolor",
  "charset",
  "checked",
  "clear",
  "codetype",
  "color",
  "compact",
  "declare",
  "defer",
  "dir",
  "direction",
  "disabled",
  "enctype",
  "face",
  "frame",
  "hreflang",
  "http-equiv",
  "lang",
  "language",
  "link",
  "media",
  "method",
  "multiple",
  "nohref",
  "noresize",
  "noshade",
  "nowrap",
  "readonly",
  "rel",
  "rev",
  "rules",
  "scope",
  "scrolling",
  "selected",
  "shape",
  "target",
  "text",
  "type",
  "valign",
  "valuetype",
  "vlink"
]);
function Kc(t, e) {
  return typeof t.ignoreCase == "boolean" ? t.ignoreCase : t.ignoreCase === "quirks" ? !!e.quirksMode : !e.xmlMode && $6e.has(t.name);
}
const H6e = {
  equals(t, e, n) {
    const { adapter: r } = n, { name: i } = e;
    let { value: s } = e;
    return Kc(e, n) ? (s = s.toLowerCase(), (a) => {
      const o = r.getAttributeValue(a, i);
      return o != null && o.length === s.length && o.toLowerCase() === s && t(a);
    }) : (a) => r.getAttributeValue(a, i) === s && t(a);
  },
  hyphen(t, e, n) {
    const { adapter: r } = n, { name: i } = e;
    let { value: s } = e;
    const a = s.length;
    return Kc(e, n) ? (s = s.toLowerCase(), function(u) {
      const l = r.getAttributeValue(u, i);
      return l != null && (l.length === a || l.charAt(a) === "-") && l.substr(0, a).toLowerCase() === s && t(u);
    }) : function(u) {
      const l = r.getAttributeValue(u, i);
      return l != null && (l.length === a || l.charAt(a) === "-") && l.substr(0, a) === s && t(u);
    };
  },
  element(t, e, n) {
    const { adapter: r } = n, { name: i, value: s } = e;
    if (/\s/.test(s))
      return jt.falseFunc;
    const a = new RegExp(`(?:^|\\s)${qP(s)}(?:$|\\s)`, Kc(e, n) ? "i" : "");
    return function(u) {
      const l = r.getAttributeValue(u, i);
      return l != null && l.length >= s.length && a.test(l) && t(u);
    };
  },
  exists(t, { name: e }, { adapter: n }) {
    return (r) => n.hasAttrib(r, e) && t(r);
  },
  start(t, e, n) {
    const { adapter: r } = n, { name: i } = e;
    let { value: s } = e;
    const a = s.length;
    return a === 0 ? jt.falseFunc : Kc(e, n) ? (s = s.toLowerCase(), (o) => {
      const u = r.getAttributeValue(o, i);
      return u != null && u.length >= a && u.substr(0, a).toLowerCase() === s && t(o);
    }) : (o) => {
      var u;
      return !!(!((u = r.getAttributeValue(o, i)) === null || u === void 0) && u.startsWith(s)) && t(o);
    };
  },
  end(t, e, n) {
    const { adapter: r } = n, { name: i } = e;
    let { value: s } = e;
    const a = -s.length;
    return a === 0 ? jt.falseFunc : Kc(e, n) ? (s = s.toLowerCase(), (o) => {
      var u;
      return ((u = r.getAttributeValue(o, i)) === null || u === void 0 ? void 0 : u.substr(a).toLowerCase()) === s && t(o);
    }) : (o) => {
      var u;
      return !!(!((u = r.getAttributeValue(o, i)) === null || u === void 0) && u.endsWith(s)) && t(o);
    };
  },
  any(t, e, n) {
    const { adapter: r } = n, { name: i, value: s } = e;
    if (s === "")
      return jt.falseFunc;
    if (Kc(e, n)) {
      const a = new RegExp(qP(s), "i");
      return function(u) {
        const l = r.getAttributeValue(u, i);
        return l != null && l.length >= s.length && a.test(l) && t(u);
      };
    }
    return (a) => {
      var o;
      return !!(!((o = r.getAttributeValue(a, i)) === null || o === void 0) && o.includes(s)) && t(a);
    };
  },
  not(t, e, n) {
    const { adapter: r } = n, { name: i } = e;
    let { value: s } = e;
    return s === "" ? (a) => !!r.getAttributeValue(a, i) && t(a) : Kc(e, n) ? (s = s.toLowerCase(), (a) => {
      const o = r.getAttributeValue(a, i);
      return (o == null || o.length !== s.length || o.toLowerCase() !== s) && t(a);
    }) : (a) => r.getAttributeValue(a, i) !== s && t(a);
  }
}, U6e = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]), JP = 48, G6e = 57;
function W6e(t) {
  if (t = t.trim().toLowerCase(), t === "even")
    return [2, 0];
  if (t === "odd")
    return [2, 1];
  let e = 0, n = 0, r = s(), i = a();
  if (e < t.length && t.charAt(e) === "n" && (e++, n = r * (i ?? 1), o(), e < t.length ? (r = s(), o(), i = a()) : r = i = 0), i === null || e < t.length)
    throw new Error(`n-th rule couldn't be parsed ('${t}')`);
  return [n, r * i];
  function s() {
    return t.charAt(e) === "-" ? (e++, -1) : (t.charAt(e) === "+" && e++, 1);
  }
  function a() {
    const u = e;
    let l = 0;
    for (; e < t.length && t.charCodeAt(e) >= JP && t.charCodeAt(e) <= G6e; )
      l = l * 10 + (t.charCodeAt(e) - JP), e++;
    return e === u ? null : l;
  }
  function o() {
    for (; e < t.length && U6e.has(t.charCodeAt(e)); )
      e++;
  }
}
function V6e(t) {
  const e = t[0], n = t[1] - 1;
  if (n < 0 && e <= 0)
    return jt.falseFunc;
  if (e === -1)
    return (s) => s <= n;
  if (e === 0)
    return (s) => s === n;
  if (e === 1)
    return n < 0 ? jt.trueFunc : (s) => s >= n;
  const r = Math.abs(e), i = (n % r + r) % r;
  return e > 1 ? (s) => s >= n && s % r === i : (s) => s <= n && s % r === i;
}
function Y0(t) {
  return V6e(W6e(t));
}
function q0(t, e) {
  return (n) => {
    const r = e.getParent(n);
    return r != null && e.isTag(r) && t(n);
  };
}
const yv = {
  contains(t, e, { adapter: n }) {
    return function(i) {
      return t(i) && n.getText(i).includes(e);
    };
  },
  icontains(t, e, { adapter: n }) {
    const r = e.toLowerCase();
    return function(s) {
      return t(s) && n.getText(s).toLowerCase().includes(r);
    };
  },
  // Location specific methods
  "nth-child"(t, e, { adapter: n, equals: r }) {
    const i = Y0(e);
    return i === jt.falseFunc ? jt.falseFunc : i === jt.trueFunc ? q0(t, n) : function(a) {
      const o = n.getSiblings(a);
      let u = 0;
      for (let l = 0; l < o.length && !r(a, o[l]); l++)
        n.isTag(o[l]) && u++;
      return i(u) && t(a);
    };
  },
  "nth-last-child"(t, e, { adapter: n, equals: r }) {
    const i = Y0(e);
    return i === jt.falseFunc ? jt.falseFunc : i === jt.trueFunc ? q0(t, n) : function(a) {
      const o = n.getSiblings(a);
      let u = 0;
      for (let l = o.length - 1; l >= 0 && !r(a, o[l]); l--)
        n.isTag(o[l]) && u++;
      return i(u) && t(a);
    };
  },
  "nth-of-type"(t, e, { adapter: n, equals: r }) {
    const i = Y0(e);
    return i === jt.falseFunc ? jt.falseFunc : i === jt.trueFunc ? q0(t, n) : function(a) {
      const o = n.getSiblings(a);
      let u = 0;
      for (let l = 0; l < o.length; l++) {
        const h = o[l];
        if (r(a, h))
          break;
        n.isTag(h) && n.getName(h) === n.getName(a) && u++;
      }
      return i(u) && t(a);
    };
  },
  "nth-last-of-type"(t, e, { adapter: n, equals: r }) {
    const i = Y0(e);
    return i === jt.falseFunc ? jt.falseFunc : i === jt.trueFunc ? q0(t, n) : function(a) {
      const o = n.getSiblings(a);
      let u = 0;
      for (let l = o.length - 1; l >= 0; l--) {
        const h = o[l];
        if (r(a, h))
          break;
        n.isTag(h) && n.getName(h) === n.getName(a) && u++;
      }
      return i(u) && t(a);
    };
  },
  // TODO determine the actual root element
  root(t, e, { adapter: n }) {
    return (r) => {
      const i = n.getParent(r);
      return (i == null || !n.isTag(i)) && t(r);
    };
  },
  scope(t, e, n, r) {
    const { equals: i } = n;
    return !r || r.length === 0 ? yv.root(t, e, n) : r.length === 1 ? (s) => i(r[0], s) && t(s) : (s) => r.includes(s) && t(s);
  },
  hover: uF("isHovered"),
  visited: uF("isVisited"),
  active: uF("isActive")
};
function uF(t) {
  return function(n, r, { adapter: i }) {
    const s = i[t];
    return typeof s != "function" ? jt.falseFunc : function(o) {
      return s(o) && n(o);
    };
  };
}
const QP = {
  empty(t, { adapter: e }) {
    return !e.getChildren(t).some((n) => (
      // FIXME: `getText` call is potentially expensive.
      e.isTag(n) || e.getText(n) !== ""
    ));
  },
  "first-child"(t, { adapter: e, equals: n }) {
    if (e.prevElementSibling)
      return e.prevElementSibling(t) == null;
    const r = e.getSiblings(t).find((i) => e.isTag(i));
    return r != null && n(t, r);
  },
  "last-child"(t, { adapter: e, equals: n }) {
    const r = e.getSiblings(t);
    for (let i = r.length - 1; i >= 0; i--) {
      if (n(t, r[i]))
        return !0;
      if (e.isTag(r[i]))
        break;
    }
    return !1;
  },
  "first-of-type"(t, { adapter: e, equals: n }) {
    const r = e.getSiblings(t), i = e.getName(t);
    for (let s = 0; s < r.length; s++) {
      const a = r[s];
      if (n(t, a))
        return !0;
      if (e.isTag(a) && e.getName(a) === i)
        break;
    }
    return !1;
  },
  "last-of-type"(t, { adapter: e, equals: n }) {
    const r = e.getSiblings(t), i = e.getName(t);
    for (let s = r.length - 1; s >= 0; s--) {
      const a = r[s];
      if (n(t, a))
        return !0;
      if (e.isTag(a) && e.getName(a) === i)
        break;
    }
    return !1;
  },
  "only-of-type"(t, { adapter: e, equals: n }) {
    const r = e.getName(t);
    return e.getSiblings(t).every((i) => n(t, i) || !e.isTag(i) || e.getName(i) !== r);
  },
  "only-child"(t, { adapter: e, equals: n }) {
    return e.getSiblings(t).every((r) => n(t, r) || !e.isTag(r));
  }
};
function XP(t, e, n, r) {
  if (n === null) {
    if (t.length > r)
      throw new Error(`Pseudo-class :${e} requires an argument`);
  } else if (t.length === r)
    throw new Error(`Pseudo-class :${e} doesn't have any arguments`);
}
const K6e = {
  // Links
  "any-link": ":is(a, area, link)[href]",
  link: ":any-link:not(:visited)",
  // Forms
  // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
  disabled: `:is(
        :is(button, input, select, textarea, optgroup, option)[disabled],
        optgroup[disabled] > option,
        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)
    )`,
  enabled: ":not(:disabled)",
  checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
  required: ":is(input, select, textarea)[required]",
  optional: ":is(input, select, textarea):not([required])",
  // JQuery extensions
  // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
  selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
  checkbox: "[type=checkbox]",
  file: "[type=file]",
  password: "[type=password]",
  radio: "[type=radio]",
  reset: "[type=reset]",
  image: "[type=image]",
  submit: "[type=submit]",
  parent: ":not(:empty)",
  header: ":is(h1, h2, h3, h4, h5, h6)",
  button: ":is(button, input[type=button])",
  input: ":is(input, textarea, select, button)",
  text: "input:is(:not([type!='']), [type=text])"
}, E7 = {};
function z6e(t, e) {
  return t === jt.falseFunc ? jt.falseFunc : (n) => e.isTag(n) && t(n);
}
function S7(t, e) {
  const n = e.getSiblings(t);
  if (n.length <= 1)
    return [];
  const r = n.indexOf(t);
  return r < 0 || r === n.length - 1 ? [] : n.slice(r + 1).filter(e.isTag);
}
function Av(t) {
  return {
    xmlMode: !!t.xmlMode,
    lowerCaseAttributeNames: !!t.lowerCaseAttributeNames,
    lowerCaseTags: !!t.lowerCaseTags,
    quirksMode: !!t.quirksMode,
    cacheResults: !!t.cacheResults,
    pseudos: t.pseudos,
    adapter: t.adapter,
    equals: t.equals
  };
}
const lF = (t, e, n, r, i) => {
  const s = i(e, Av(n), r);
  return s === jt.trueFunc ? t : s === jt.falseFunc ? jt.falseFunc : (a) => s(a) && t(a);
}, cF = {
  is: lF,
  /**
   * `:matches` and `:where` are aliases for `:is`.
   */
  matches: lF,
  where: lF,
  not(t, e, n, r, i) {
    const s = i(e, Av(n), r);
    return s === jt.falseFunc ? t : s === jt.trueFunc ? jt.falseFunc : (a) => !s(a) && t(a);
  },
  has(t, e, n, r, i) {
    const { adapter: s } = n, a = Av(n);
    a.relativeSelector = !0;
    const o = e.some((h) => h.some(I2)) ? (
      // Used as a placeholder. Will be replaced with the actual element.
      [E7]
    ) : void 0, u = i(e, a, o);
    if (u === jt.falseFunc)
      return jt.falseFunc;
    const l = z6e(u, s);
    if (o && u !== jt.trueFunc) {
      const { shouldTestNextSiblings: h = !1 } = u;
      return (f) => {
        if (!t(f))
          return !1;
        o[0] = f;
        const m = s.getChildren(f), g = h ? [...m, ...S7(f, s)] : m;
        return s.existsOne(l, g);
      };
    }
    return (h) => t(h) && s.existsOne(l, s.getChildren(h));
  }
};
function j6e(t, e, n, r, i) {
  var s;
  const { name: a, data: o } = e;
  if (Array.isArray(o)) {
    if (!(a in cF))
      throw new Error(`Unknown pseudo-class :${a}(${o})`);
    return cF[a](t, o, n, r, i);
  }
  const u = (s = n.pseudos) === null || s === void 0 ? void 0 : s[a], l = typeof u == "string" ? u : K6e[a];
  if (typeof l == "string") {
    if (o != null)
      throw new Error(`Pseudo ${a} doesn't have any arguments`);
    const h = HA(l);
    return cF.is(t, h, n, r, i);
  }
  if (typeof u == "function")
    return XP(u, a, o, 1), (h) => u(h, o) && t(h);
  if (a in yv)
    return yv[a](t, o, n, r);
  if (a in QP) {
    const h = QP[a];
    return XP(h, a, o, 2), (f) => h(f, n, o) && t(f);
  }
  throw new Error(`Unknown pseudo-class :${a}`);
}
function hF(t, e) {
  const n = e.getParent(t);
  return n && e.isTag(n) ? n : null;
}
function Y6e(t, e, n, r, i) {
  const { adapter: s, equals: a } = n;
  switch (e.type) {
    case lt.PseudoElement:
      throw new Error("Pseudo-elements are not supported by css-select");
    case lt.ColumnCombinator:
      throw new Error("Column combinators are not yet supported by css-select");
    case lt.Attribute: {
      if (e.namespace != null)
        throw new Error("Namespaced attributes are not yet supported by css-select");
      return (!n.xmlMode || n.lowerCaseAttributeNames) && (e.name = e.name.toLowerCase()), H6e[e.action](t, e, n);
    }
    case lt.Pseudo:
      return j6e(t, e, n, r, i);
    // Tags
    case lt.Tag: {
      if (e.namespace != null)
        throw new Error("Namespaced tag names are not yet supported by css-select");
      let { name: o } = e;
      return (!n.xmlMode || n.lowerCaseTags) && (o = o.toLowerCase()), function(l) {
        return s.getName(l) === o && t(l);
      };
    }
    // Traversal
    case lt.Descendant: {
      if (n.cacheResults === !1 || typeof WeakSet > "u")
        return function(l) {
          let h = l;
          for (; h = hF(h, s); )
            if (t(h))
              return !0;
          return !1;
        };
      const o = /* @__PURE__ */ new WeakSet();
      return function(l) {
        let h = l;
        for (; h = hF(h, s); )
          if (!o.has(h)) {
            if (s.isTag(h) && t(h))
              return !0;
            o.add(h);
          }
        return !1;
      };
    }
    case "_flexibleDescendant":
      return function(u) {
        let l = u;
        do
          if (t(l))
            return !0;
        while (l = hF(l, s));
        return !1;
      };
    case lt.Parent:
      return function(u) {
        return s.getChildren(u).some((l) => s.isTag(l) && t(l));
      };
    case lt.Child:
      return function(u) {
        const l = s.getParent(u);
        return l != null && s.isTag(l) && t(l);
      };
    case lt.Sibling:
      return function(u) {
        const l = s.getSiblings(u);
        for (let h = 0; h < l.length; h++) {
          const f = l[h];
          if (a(u, f))
            break;
          if (s.isTag(f) && t(f))
            return !0;
        }
        return !1;
      };
    case lt.Adjacent:
      return s.prevElementSibling ? function(u) {
        const l = s.prevElementSibling(u);
        return l != null && t(l);
      } : function(u) {
        const l = s.getSiblings(u);
        let h;
        for (let f = 0; f < l.length; f++) {
          const m = l[f];
          if (a(u, m))
            break;
          s.isTag(m) && (h = m);
        }
        return !!h && t(h);
      };
    case lt.Universal: {
      if (e.namespace != null && e.namespace !== "*")
        throw new Error("Namespaced universal selectors are not yet supported by css-select");
      return t;
    }
  }
}
function w7(t) {
  return t.type === lt.Pseudo && (t.name === "scope" || Array.isArray(t.data) && t.data.some((e) => e.some(w7)));
}
const q6e = { type: lt.Descendant }, J6e = {
  type: "_flexibleDescendant"
}, Q6e = {
  type: lt.Pseudo,
  name: "scope",
  data: null
};
function X6e(t, { adapter: e }, n) {
  const r = !!n?.every((i) => {
    const s = e.isTag(i) && e.getParent(i);
    return i === E7 || s && e.isTag(s);
  });
  for (const i of t) {
    if (!(i.length > 0 && I2(i[0]) && i[0].type !== lt.Descendant)) if (r && !i.some(w7))
      i.unshift(q6e);
    else
      continue;
    i.unshift(Q6e);
  }
}
function F7(t, e, n) {
  var r;
  t.forEach(O6e), n = (r = e.context) !== null && r !== void 0 ? r : n;
  const i = Array.isArray(n), s = n && (Array.isArray(n) ? n : [n]);
  if (e.relativeSelector !== !1)
    X6e(t, e, s);
  else if (t.some((u) => u.length > 0 && I2(u[0])))
    throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
  let a = !1;
  const o = t.map((u) => {
    if (u.length >= 2) {
      const [l, h] = u;
      l.type !== lt.Pseudo || l.name !== "scope" || (i && h.type === lt.Descendant ? u[1] = J6e : (h.type === lt.Adjacent || h.type === lt.Sibling) && (a = !0));
    }
    return Z6e(u, e, s);
  }).reduce(e9e, jt.falseFunc);
  return o.shouldTestNextSiblings = a, o;
}
function Z6e(t, e, n) {
  var r;
  return t.reduce((i, s) => i === jt.falseFunc ? jt.falseFunc : Y6e(i, s, e, n, F7), (r = e.rootFunc) !== null && r !== void 0 ? r : jt.trueFunc);
}
function e9e(t, e) {
  return e === jt.falseFunc || t === jt.trueFunc ? t : t === jt.falseFunc || e === jt.trueFunc ? e : function(r) {
    return t(r) || e(r);
  };
}
const T7 = (t, e) => t === e, t9e = {
  adapter: $A,
  equals: T7
};
function n9e(t) {
  var e, n, r, i;
  const s = t ?? t9e;
  return (e = s.adapter) !== null && e !== void 0 || (s.adapter = $A), (n = s.equals) !== null && n !== void 0 || (s.equals = (i = (r = s.adapter) === null || r === void 0 ? void 0 : r.equals) !== null && i !== void 0 ? i : T7), s;
}
function r9e(t) {
  return function(n, r, i) {
    const s = n9e(r);
    return t(n, s, i);
  };
}
const R2 = r9e(F7);
function v7(t, e, n = !1) {
  return n && (t = i9e(t, e)), Array.isArray(t) ? e.removeSubsets(t) : e.getChildren(t);
}
function i9e(t, e) {
  const n = Array.isArray(t) ? t.slice(0) : [t], r = n.length;
  for (let i = 0; i < r; i++) {
    const s = S7(n[i], e);
    n.push(...s);
  }
  return n;
}
const s9e = /* @__PURE__ */ new Set([
  "first",
  "last",
  "eq",
  "gt",
  "nth",
  "lt",
  "even",
  "odd"
]);
function R1(t) {
  return t.type !== "pseudo" ? !1 : s9e.has(t.name) ? !0 : t.name === "not" && Array.isArray(t.data) ? t.data.some((e) => e.some(R1)) : !1;
}
function a9e(t, e, n) {
  const r = e != null ? parseInt(e, 10) : NaN;
  switch (t) {
    case "first":
      return 1;
    case "nth":
    case "eq":
      return isFinite(r) ? r >= 0 ? r + 1 : 1 / 0 : 0;
    case "lt":
      return isFinite(r) ? r >= 0 ? Math.min(r, n) : 1 / 0 : 0;
    case "gt":
      return isFinite(r) ? 1 / 0 : 0;
    case "odd":
      return 2 * n;
    case "even":
      return 2 * n - 1;
    case "last":
    case "not":
      return 1 / 0;
  }
}
function o9e(t) {
  for (; t.parent; )
    t = t.parent;
  return t;
}
function P2(t) {
  const e = [], n = [];
  for (const r of t)
    r.some(R1) ? e.push(r) : n.push(r);
  return [n, e];
}
const u9e = {
  type: lt.Universal,
  namespace: null
}, l9e = {
  type: lt.Pseudo,
  name: "scope",
  data: null
};
function x7(t, e, n = {}) {
  return C7([t], e, n);
}
function C7(t, e, n = {}) {
  if (typeof e == "function")
    return t.some(e);
  const [r, i] = P2(HA(e));
  return r.length > 0 && t.some(R2(r, n)) || i.some((s) => N7(s, t, n).length > 0);
}
function c9e(t, e, n, r) {
  const i = typeof n == "string" ? parseInt(n, 10) : NaN;
  switch (t) {
    case "first":
    case "lt":
      return e;
    case "last":
      return e.length > 0 ? [e[e.length - 1]] : e;
    case "nth":
    case "eq":
      return isFinite(i) && Math.abs(i) < e.length ? [i < 0 ? e[e.length + i] : e[i]] : [];
    case "gt":
      return isFinite(i) ? e.slice(i + 1) : [];
    case "even":
      return e.filter((s, a) => a % 2 === 0);
    case "odd":
      return e.filter((s, a) => a % 2 === 1);
    case "not": {
      const s = new Set(_7(n, e, r));
      return e.filter((a) => !s.has(a));
    }
  }
}
function k7(t, e, n = {}) {
  return _7(HA(t), e, n);
}
function _7(t, e, n) {
  if (e.length === 0)
    return [];
  const [r, i] = P2(t);
  let s;
  if (r.length) {
    const a = Sv(e, r, n);
    if (i.length === 0)
      return a;
    a.length && (s = new Set(a));
  }
  for (let a = 0; a < i.length && s?.size !== e.length; a++) {
    const o = i[a];
    if ((s ? e.filter((h) => St(h) && !s.has(h)) : e).length === 0)
      break;
    const l = N7(o, e, n);
    if (l.length)
      if (s)
        l.forEach((h) => s.add(h));
      else {
        if (a === i.length - 1)
          return l;
        s = new Set(l);
      }
  }
  return typeof s < "u" ? s.size === e.length ? e : (
    // Filter elements to preserve order
    e.filter((a) => s.has(a))
  ) : [];
}
function N7(t, e, n) {
  var r;
  if (t.some(ug)) {
    const i = (r = n.root) !== null && r !== void 0 ? r : o9e(e[0]), s = { ...n, context: e, relativeSelector: !1 };
    return t.push(l9e), P1(i, t, s, !0, e.length);
  }
  return P1(e, t, n, !1, e.length);
}
function h9e(t, e, n = {}, r = 1 / 0) {
  if (typeof t == "function")
    return D7(e, t);
  const [i, s] = P2(HA(t)), a = s.map((o) => P1(e, o, n, !0, r));
  return i.length && a.push(Ev(e, i, n, r)), a.length === 0 ? [] : a.length === 1 ? a[0] : Lf(a.reduce((o, u) => [...o, ...u]));
}
function P1(t, e, n, r, i) {
  const s = e.findIndex(R1), a = e.slice(0, s), o = e[s], u = e.length - 1 === s ? i : 1 / 0, l = a9e(o.name, o.data, u);
  if (l === 0)
    return [];
  const f = (a.length === 0 && !Array.isArray(t) ? BA(t).filter(St) : a.length === 0 ? (Array.isArray(t) ? t : [t]).filter(St) : r || a.some(ug) ? Ev(t, [a], n, l) : Sv(t, [a], n)).slice(0, l);
  let m = c9e(o.name, f, o.data, n);
  if (m.length === 0 || e.length === s + 1)
    return m;
  const g = e.slice(s + 1), A = g.some(ug);
  if (A) {
    if (ug(g[0])) {
      const { type: E } = g[0];
      (E === lt.Sibling || E === lt.Adjacent) && (m = v7(m, $A, !0)), g.unshift(u9e);
    }
    n = {
      ...n,
      // Avoid absolutizing the selector
      relativeSelector: !1,
      /*
       * Add a custom root func, to make sure traversals don't match elements
       * that aren't a part of the considered tree.
       */
      rootFunc: (E) => m.includes(E)
    };
  } else n.rootFunc && n.rootFunc !== I1.trueFunc && (n = { ...n, rootFunc: I1.trueFunc });
  return g.some(R1) ? P1(m, g, n, !1, i) : A ? (
    // Query existing elements to resolve traversal.
    Ev(m, [g], n, i)
  ) : (
    // If we don't have any more traversals, simply filter elements.
    Sv(m, [g], n)
  );
}
function Ev(t, e, n, r) {
  const i = R2(e, n, t);
  return D7(t, i, r);
}
function D7(t, e, n = 1 / 0) {
  const r = v7(t, $A, e.shouldTestNextSiblings);
  return k2((i) => St(i) && e(i), r, !0, n);
}
function Sv(t, e, n) {
  const r = (Array.isArray(t) ? t : [t]).filter(St);
  if (r.length === 0)
    return r;
  const i = R2(e, n);
  return i === I1.trueFunc ? r : r.filter(i);
}
const d9e = /^\s*(?:[+~]|:scope\b)/;
function f9e(t) {
  if (!t)
    return this._make([]);
  if (typeof t != "string") {
    const e = Ku(t) ? t.toArray() : [t], n = this.toArray();
    return this._make(e.filter((r) => n.some((i) => c7(i, r))));
  }
  return this._findBySelector(t, Number.POSITIVE_INFINITY);
}
function m9e(t, e) {
  var n;
  const r = this.toArray(), i = d9e.test(t) ? r : this.children().toArray(), s = {
    context: r,
    root: (n = this._root) === null || n === void 0 ? void 0 : n[0],
    // Pass options that are recognized by `cheerio-select`
    xmlMode: this.options.xmlMode,
    lowerCaseTags: this.options.lowerCaseTags,
    lowerCaseAttributeNames: this.options.lowerCaseAttributeNames,
    pseudos: this.options.pseudos,
    quirksMode: this.options.quirksMode
  };
  return this._make(h9e(t, i, s, e));
}
function L2(t) {
  return function(e, ...n) {
    return function(r) {
      var i;
      let s = t(e, this);
      return r && (s = B2(s, r, this.options.xmlMode, (i = this._root) === null || i === void 0 ? void 0 : i[0])), this._make(
        // Post processing is only necessary if there is more than one element.
        this.length > 1 && s.length > 1 ? n.reduce((a, o) => o(a), s) : s
      );
    };
  };
}
const mp = L2((t, e) => {
  let n = [];
  for (let r = 0; r < e.length; r++) {
    const i = t(e[r]);
    i.length > 0 && (n = n.concat(i));
  }
  return n;
}), M2 = L2((t, e) => {
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const i = t(e[r]);
    i !== null && n.push(i);
  }
  return n;
});
function O2(t, ...e) {
  let n = null;
  const r = L2((i, s) => {
    const a = [];
    return Or(s, (o) => {
      for (let u; (u = i(o)) && !n?.(u, a.length); o = u)
        a.push(u);
    }), a;
  })(t, ...e);
  return function(i, s) {
    n = typeof i == "string" ? (o) => x7(o, i, this.options) : i ? gp(i) : null;
    const a = r.call(this, s);
    return n = null, a;
  };
}
function Mf(t) {
  return t.length > 1 ? Array.from(new Set(t)) : t;
}
const g9e = M2(({ parent: t }) => t && !Ih(t) ? t : null, Mf), p9e = mp(
  (t) => {
    const e = [];
    for (; t.parent && !Ih(t.parent); )
      e.push(t.parent), t = t.parent;
    return e;
  },
  Lf,
  // eslint-disable-next-line unicorn/no-array-reverse
  (t) => t.reverse()
), b9e = O2(
  ({ parent: t }) => t && !Ih(t) ? t : null,
  Lf,
  // eslint-disable-next-line unicorn/no-array-reverse
  (t) => t.reverse()
);
function y9e(t) {
  var e;
  const n = [];
  if (!t)
    return this._make(n);
  const r = {
    xmlMode: this.options.xmlMode,
    root: (e = this._root) === null || e === void 0 ? void 0 : e[0]
  }, i = typeof t == "string" ? (s) => x7(s, t, r) : gp(t);
  return Or(this, (s) => {
    for (s && !Ih(s) && !St(s) && (s = s.parent); s && St(s); ) {
      if (i(s, 0)) {
        n.includes(s) || n.push(s);
        break;
      }
      s = s.parent;
    }
  }), this._make(n);
}
const A9e = M2((t) => x2(t)), E9e = mp((t) => {
  const e = [];
  for (; t.next; )
    t = t.next, St(t) && e.push(t);
  return e;
}, Mf), S9e = O2((t) => x2(t), Mf), w9e = M2((t) => C2(t)), F9e = mp((t) => {
  const e = [];
  for (; t.prev; )
    t = t.prev, St(t) && e.push(t);
  return e;
}, Mf), T9e = O2((t) => C2(t), Mf), v9e = mp((t) => i7(t).filter((e) => St(e) && e !== t), Lf), x9e = mp((t) => BA(t).filter(St), Mf);
function C9e() {
  const t = this.toArray().reduce((e, n) => Qr(n) ? e.concat(n.children) : e, []);
  return this._make(t);
}
function k9e(t) {
  let e = 0;
  const n = this.length;
  for (; e < n && t.call(this[e], e, this[e]) !== !1; )
    ++e;
  return this;
}
function _9e(t) {
  let e = [];
  for (let n = 0; n < this.length; n++) {
    const r = this[n], i = t.call(r, n, r);
    i != null && (e = e.concat(i));
  }
  return this._make(e);
}
function gp(t) {
  return typeof t == "function" ? (e, n) => t.call(e, n, e) : Ku(t) ? (e) => Array.prototype.includes.call(t, e) : function(e) {
    return t === e;
  };
}
function N9e(t) {
  var e;
  return this._make(B2(this.toArray(), t, this.options.xmlMode, (e = this._root) === null || e === void 0 ? void 0 : e[0]));
}
function B2(t, e, n, r) {
  return typeof e == "string" ? k7(e, t, { xmlMode: n, root: r }) : t.filter(gp(e));
}
function D9e(t) {
  const e = this.toArray();
  return typeof t == "string" ? C7(e.filter(St), t, this.options) : t ? e.some(gp(t)) : !1;
}
function I9e(t) {
  let e = this.toArray();
  if (typeof t == "string") {
    const n = new Set(k7(t, e, this.options));
    e = e.filter((r) => !n.has(r));
  } else {
    const n = gp(t);
    e = e.filter((r, i) => !n(r, i));
  }
  return this._make(e);
}
function R9e(t) {
  return this.filter(typeof t == "string" ? (
    // Using the `:has` selector here short-circuits searches.
    `:has(${t})`
  ) : (e, n) => this._make(n).find(t).length > 0);
}
function P9e() {
  return this.length > 1 ? this._make(this[0]) : this;
}
function L9e() {
  return this.length > 0 ? this._make(this[this.length - 1]) : this;
}
function M9e(t) {
  var e;
  return t = +t, t === 0 && this.length <= 1 ? this : (t < 0 && (t = this.length + t), this._make((e = this[t]) !== null && e !== void 0 ? e : []));
}
function O9e(t) {
  return t == null ? this.toArray() : this[t < 0 ? this.length + t : t];
}
function B9e() {
  return Array.prototype.slice.call(this);
}
function $9e(t) {
  let e, n;
  return t == null ? (e = this.parent().children(), n = this[0]) : typeof t == "string" ? (e = this._make(t), n = this[0]) : (e = this, n = Ku(t) ? t[0] : t), Array.prototype.indexOf.call(e, n);
}
function H9e(t, e) {
  return this._make(Array.prototype.slice.call(this, t, e));
}
function U9e() {
  var t;
  return (t = this.prevObject) !== null && t !== void 0 ? t : this._make([]);
}
function G9e(t, e) {
  const n = this._make(t, e), r = Lf([...this.get(), ...n.get()]);
  return this._make(r);
}
function W9e(t) {
  return this.prevObject ? this.add(t ? this.prevObject.filter(t) : this.prevObject) : this;
}
const V9e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _findBySelector: m9e,
  add: G9e,
  addBack: W9e,
  children: x9e,
  closest: y9e,
  contents: C9e,
  each: k9e,
  end: U9e,
  eq: M9e,
  filter: N9e,
  filterArray: B2,
  find: f9e,
  first: P9e,
  get: O9e,
  has: R9e,
  index: $9e,
  is: D9e,
  last: L9e,
  map: _9e,
  next: A9e,
  nextAll: E9e,
  nextUntil: S9e,
  not: I9e,
  parent: g9e,
  parents: p9e,
  parentsUntil: b9e,
  prev: w9e,
  prevAll: F9e,
  prevUntil: T9e,
  siblings: v9e,
  slice: H9e,
  toArray: B9e
}, Symbol.toStringTag, { value: "Module" }));
function K9e(t) {
  return function(n, r, i, s) {
    if (typeof Buffer < "u" && Buffer.isBuffer(n) && (n = n.toString()), typeof n == "string")
      return t(n, r, i, s);
    const a = n;
    if (!Array.isArray(a) && Ih(a))
      return a;
    const o = new Ig([]);
    return Th(a, o), o;
  };
}
function Th(t, e) {
  const n = Array.isArray(t) ? t : [t];
  e ? e.children = n : e = null;
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    i.parent && i.parent.children !== n && Rh(i), e ? (i.prev = n[r - 1] || null, i.next = n[r + 1] || null) : i.prev = i.next = null, i.parent = e;
  }
  return e;
}
function z9e(t, e) {
  if (t == null)
    return [];
  if (typeof t == "string")
    return this._parse(t, this.options, !1, null).children.slice(0);
  if ("length" in t) {
    if (t.length === 1)
      return this._makeDomArray(t[0], e);
    const n = [];
    for (let r = 0; r < t.length; r++) {
      const i = t[r];
      if (typeof i == "object") {
        if (i == null)
          continue;
        if (!("length" in i)) {
          n.push(e ? Rg(i, !0) : i);
          continue;
        }
      }
      n.push(...this._makeDomArray(i, e));
    }
    return n;
  }
  return [e ? Rg(t, !0) : t];
}
function I7(t) {
  return function(...e) {
    const n = this.length - 1;
    return Or(this, (r, i) => {
      if (!Qr(r))
        return;
      const s = typeof e[0] == "function" ? e[0].call(r, i, this._render(r.children)) : e, a = this._makeDomArray(s, i < n);
      t(a, r.children, r);
    });
  };
}
function Tc(t, e, n, r, i) {
  var s, a;
  const o = [
    e,
    n,
    ...r
  ], u = e === 0 ? null : t[e - 1], l = e + n >= t.length ? null : t[e + n];
  for (let h = 0; h < r.length; ++h) {
    const f = r[h], m = f.parent;
    if (m) {
      const A = m.children.indexOf(f);
      A !== -1 && (m.children.splice(A, 1), i === m && e > A && o[0]--);
    }
    f.parent = i, f.prev && (f.prev.next = (s = f.next) !== null && s !== void 0 ? s : null), f.next && (f.next.prev = (a = f.prev) !== null && a !== void 0 ? a : null), f.prev = h === 0 ? u : r[h - 1], f.next = h === r.length - 1 ? l : r[h + 1];
  }
  return u && (u.next = r[0]), l && (l.prev = r[r.length - 1]), t.splice(...o);
}
function j9e(t) {
  return (Ku(t) ? t : this._make(t)).append(this), this;
}
function Y9e(t) {
  return (Ku(t) ? t : this._make(t)).prepend(this), this;
}
const q9e = I7((t, e, n) => {
  Tc(e, e.length, 0, t, n);
}), J9e = I7((t, e, n) => {
  Tc(e, 0, 0, t, n);
});
function R7(t) {
  return function(e) {
    const n = this.length - 1, r = this.parents().last();
    for (let i = 0; i < this.length; i++) {
      const s = this[i], a = typeof e == "function" ? e.call(s, i, s) : typeof e == "string" && !gv(e) ? r.find(e).clone() : e, [o] = this._makeDomArray(a, i < n);
      if (!o || !Qr(o))
        continue;
      let u = o, l = 0;
      for (; l < u.children.length; ) {
        const h = u.children[l];
        St(h) ? (u = h, l = 0) : l++;
      }
      t(s, u, [o]);
    }
    return this;
  };
}
const Q9e = R7((t, e, n) => {
  const { parent: r } = t;
  if (!r)
    return;
  const i = r.children, s = i.indexOf(t);
  Th([t], e), Tc(i, s, 0, n, r);
}), X9e = R7((t, e, n) => {
  Qr(t) && (Th(t.children, e), Th(n, t));
});
function Z9e(t) {
  return this.parent(t).not("body").each((e, n) => {
    this._make(n).replaceWith(n.children);
  }), this;
}
function e8e(t) {
  const e = this[0];
  if (e) {
    const n = this._make(typeof t == "function" ? t.call(e, 0, e) : t).insertBefore(e);
    let r;
    for (let s = 0; s < n.length; s++)
      n[s].type === fv && (r = n[s]);
    let i = 0;
    for (; r && i < r.children.length; ) {
      const s = r.children[i];
      s.type === fv ? (r = s, i = 0) : i++;
    }
    r && this._make(r).append(this);
  }
  return this;
}
function t8e(...t) {
  const e = this.length - 1;
  return Or(this, (n, r) => {
    if (!Qr(n) || !n.parent)
      return;
    const i = n.parent.children, s = i.indexOf(n);
    if (s === -1)
      return;
    const a = typeof t[0] == "function" ? t[0].call(n, r, this._render(n.children)) : t, o = this._makeDomArray(a, r < e);
    Tc(i, s + 1, 0, o, n.parent);
  });
}
function n8e(t) {
  typeof t == "string" && (t = this._make(t)), this.remove();
  const e = [];
  for (const n of this._makeDomArray(t)) {
    const r = this.clone().toArray(), { parent: i } = n;
    if (!i)
      continue;
    const s = i.children, a = s.indexOf(n);
    a !== -1 && (Tc(s, a + 1, 0, r, i), e.push(...r));
  }
  return this._make(e);
}
function r8e(...t) {
  const e = this.length - 1;
  return Or(this, (n, r) => {
    if (!Qr(n) || !n.parent)
      return;
    const i = n.parent.children, s = i.indexOf(n);
    if (s === -1)
      return;
    const a = typeof t[0] == "function" ? t[0].call(n, r, this._render(n.children)) : t, o = this._makeDomArray(a, r < e);
    Tc(i, s, 0, o, n.parent);
  });
}
function i8e(t) {
  const e = this._make(t);
  this.remove();
  const n = [];
  return Or(e, (r) => {
    const i = this.clone().toArray(), { parent: s } = r;
    if (!s)
      return;
    const a = s.children, o = a.indexOf(r);
    o !== -1 && (Tc(a, o, 0, i, s), n.push(...i));
  }), this._make(n);
}
function s8e(t) {
  const e = t ? this.filter(t) : this;
  return Or(e, (n) => {
    Rh(n), n.prev = n.next = n.parent = null;
  }), this;
}
function a8e(t) {
  return Or(this, (e, n) => {
    const { parent: r } = e;
    if (!r)
      return;
    const i = r.children, s = typeof t == "function" ? t.call(e, n, e) : t, a = this._makeDomArray(s);
    Th(a, null);
    const o = i.indexOf(e);
    Tc(i, o, 1, a, r), a.includes(e) || (e.parent = e.prev = e.next = null);
  });
}
function o8e() {
  return Or(this, (t) => {
    if (Qr(t)) {
      for (const e of t.children)
        e.next = e.prev = e.parent = null;
      t.children.length = 0;
    }
  });
}
function u8e(t) {
  if (t === void 0) {
    const e = this[0];
    return !e || !Qr(e) ? null : this._render(e.children);
  }
  return Or(this, (e) => {
    if (!Qr(e))
      return;
    for (const r of e.children)
      r.next = r.prev = r.parent = null;
    const n = Ku(t) ? t.toArray() : this._parse(`${t}`, this.options, !1, e).children;
    Th(n, e);
  });
}
function l8e() {
  return this._render(this);
}
function c8e(t) {
  return t === void 0 ? Pg(this) : typeof t == "function" ? Or(this, (e, n) => this._make(e).text(t.call(e, n, Pg([e])))) : Or(this, (e) => {
    if (!Qr(e))
      return;
    for (const r of e.children)
      r.next = r.prev = r.parent = null;
    const n = new x1(`${t}`);
    Th(n, e);
  });
}
function h8e() {
  const t = Array.prototype.map.call(this.get(), (n) => Rg(n, !0)), e = new Ig(t);
  for (const n of t)
    n.parent = e;
  return this._make(t);
}
const d8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _makeDomArray: z9e,
  after: t8e,
  append: q9e,
  appendTo: j9e,
  before: r8e,
  clone: h8e,
  empty: o8e,
  html: u8e,
  insertAfter: n8e,
  insertBefore: i8e,
  prepend: J9e,
  prependTo: Y9e,
  remove: s8e,
  replaceWith: a8e,
  text: c8e,
  toString: l8e,
  unwrap: Z9e,
  wrap: Q9e,
  wrapAll: e8e,
  wrapInner: X9e
}, Symbol.toStringTag, { value: "Module" }));
function f8e(t, e) {
  if (t != null && e != null || // When `prop` is a "plain" object
  typeof t == "object" && !Array.isArray(t))
    return Or(this, (n, r) => {
      St(n) && P7(n, t, e, r);
    });
  if (this.length !== 0)
    return L7(this[0], t);
}
function P7(t, e, n, r) {
  if (typeof e == "string") {
    const i = L7(t), s = typeof n == "function" ? n.call(t, r, i[e]) : n;
    s === "" ? delete i[e] : s != null && (i[e] = s), t.attribs.style = m8e(i);
  } else if (typeof e == "object") {
    const i = Object.keys(e);
    for (let s = 0; s < i.length; s++) {
      const a = i[s];
      P7(t, a, e[a], s);
    }
  }
}
function L7(t, e) {
  if (!t || !St(t))
    return;
  const n = g8e(t.attribs.style);
  if (typeof e == "string")
    return n[e];
  if (Array.isArray(e)) {
    const r = {};
    for (const i of e)
      n[i] != null && (r[i] = n[i]);
    return r;
  }
  return n;
}
function m8e(t) {
  return Object.keys(t).reduce((e, n) => `${e}${e ? " " : ""}${n}: ${t[n]};`, "");
}
function g8e(t) {
  if (t = (t || "").trim(), !t)
    return {};
  const e = {};
  let n;
  for (const r of t.split(";")) {
    const i = r.indexOf(":");
    if (i < 1 || i === r.length - 1) {
      const s = r.trimEnd();
      s.length > 0 && n !== void 0 && (e[n] += `;${s}`);
    } else
      n = r.slice(0, i).trim(), e[n] = r.slice(i + 1).trim();
  }
  return e;
}
const p8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  css: f8e
}, Symbol.toStringTag, { value: "Module" })), ZP = "input,select,textarea,keygen", b8e = /%20/g, eL = /\r?\n/g;
function y8e() {
  return this.serializeArray().map((n) => `${encodeURIComponent(n.name)}=${encodeURIComponent(n.value)}`).join("&").replace(b8e, "+");
}
function A8e() {
  return this.map((t, e) => {
    const n = this._make(e);
    return St(e) && e.name === "form" ? n.find(ZP).toArray() : n.filter(ZP).toArray();
  }).filter(
    // Verify elements have a name (`attr.name`) and are not disabled (`:enabled`)
    '[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))'
  ).map((t, e) => {
    var n;
    const r = this._make(e), i = r.attr("name"), s = (n = r.val()) !== null && n !== void 0 ? n : "";
    return Array.isArray(s) ? s.map((a) => (
      /*
       * We trim replace any line endings (e.g. `\r` or `\r\n` with `\r\n`) to guarantee consistency across platforms
       * These can occur inside of `<textarea>'s`
       */
      { name: i, value: a.replace(eL, `\r
`) }
    )) : { name: i, value: s.replace(eL, `\r
`) };
  }).toArray();
}
const E8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  serialize: y8e,
  serializeArray: A8e
}, Symbol.toStringTag, { value: "Module" }));
function S8e(t) {
  var e;
  return typeof t == "string" ? { selector: t, value: "textContent" } : {
    selector: t.selector,
    value: (e = t.value) !== null && e !== void 0 ? e : "textContent"
  };
}
function w8e(t) {
  const e = {};
  for (const n in t) {
    const r = t[n], i = Array.isArray(r), { selector: s, value: a } = S8e(i ? r[0] : r), o = typeof a == "function" ? a : typeof a == "string" ? (u) => this._make(u).prop(a) : (u) => this._make(u).extract(a);
    if (i)
      e[n] = this._findBySelector(s, Number.POSITIVE_INFINITY).map((u, l) => o(l, n, e)).get();
    else {
      const u = this._findBySelector(s, 1);
      e[n] = u.length > 0 ? o(u[0], n, e) : void 0;
    }
  }
  return e;
}
const F8e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  extract: w8e
}, Symbol.toStringTag, { value: "Module" }));
class pp {
  /**
   * Instance of cheerio. Methods are specified in the modules. Usage of this
   * constructor is not recommended. Please use `$.load` instead.
   *
   * @private
   * @param elements - The new selection.
   * @param root - Sets the root node.
   * @param options - Options for the instance.
   */
  constructor(e, n, r) {
    if (this.length = 0, this.options = r, this._root = n, e) {
      for (let i = 0; i < e.length; i++)
        this[i] = e[i];
      this.length = e.length;
    }
  }
}
pp.prototype.cheerio = "[cheerio object]";
pp.prototype.splice = Array.prototype.splice;
pp.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
Object.assign(pp.prototype, _6e, V9e, d8e, p8e, E8e, F8e);
function T8e(t, e) {
  return function n(r, i, s = !0) {
    if (r == null)
      throw new Error("cheerio.load() expects a string");
    const a = dv(i), o = t(r, a, s, null);
    class u extends pp {
      _make(f, m) {
        const g = l(f, m);
        return g.prevObject = this, g;
      }
      _parse(f, m, g, A) {
        return t(f, m, g, A);
      }
      _render(f) {
        return e(f, this.options);
      }
    }
    function l(h, f, m = o, g) {
      if (h && Ku(h))
        return h;
      const A = dv(g, a), E = typeof m == "string" ? [t(m, A, !1, null)] : "length" in m ? m : [m], w = Ku(E) ? E : new u(E, null, A);
      if (w._root = w, !h)
        return new u(void 0, w, A);
      const x = typeof h == "string" && gv(h) ? (
        // $(<html>)
        t(h, A, !1, null).children
      ) : v8e(h) ? (
        // $(dom)
        [h]
      ) : Array.isArray(h) ? (
        // $([dom])
        h
      ) : void 0, N = new u(x, w, A);
      if (x)
        return N;
      if (typeof h != "string")
        throw new TypeError("Unexpected type of selector");
      let B = h;
      const P = f ? (
        // If we don't have a context, maybe we have a root, from loading
        typeof f == "string" ? gv(f) ? (
          // $('li', '<ul>...</ul>')
          new u([t(f, A, !1, null)], w, A)
        ) : (
          // $('li', 'ul')
          (B = `${f} ${B}`, w)
        ) : Ku(f) ? (
          // $('li', $)
          f
        ) : (
          // $('li', node), $('li', [nodes])
          new u(Array.isArray(f) ? f : [f], w, A)
        )
      ) : w;
      return P ? P.find(B) : N;
    }
    return Object.assign(l, t6e, {
      load: n,
      // `_root` and `_options` are used in static methods.
      _root: o,
      _options: a,
      // Add `fn` for plugins
      fn: u.prototype,
      // Add the prototype here to maintain `instanceof` behavior.
      prototype: u.prototype
    }), l;
  };
}
function v8e(t) {
  return (
    // @ts-expect-error: TS doesn't know about the `name` property.
    !!t.name || // @ts-expect-error: TS doesn't know about the `type` property.
    t.type === w2 || // @ts-expect-error: TS doesn't know about the `type` property.
    t.type === zG || // @ts-expect-error: TS doesn't know about the `type` property.
    t.type === jG
  );
}
const x8e = T8e(K9e(A6e), OA), C8e = /^(\.[a-zA-Z][\w-]*)+$/;
function k8e(t, e, n) {
  if (n && C8e.test(e)) {
    const r = e.split(".").filter(Boolean);
    return t("[class]").filter((i, s) => {
      const a = t(s).attr("class");
      if (!a) return !1;
      const o = a.trim().split(/\s+/);
      return r.every(
        (u) => o.some(
          (l) => l === u || l.startsWith(`${u}_`) || l.startsWith(`_${u}_`)
        )
      );
    });
  }
  return t(e);
}
function _8e(t, e, n) {
  const r = x8e(t), i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const o of n) {
    const u = o.api.getAllProperties();
    for (const [l, h] of u) {
      if (l.startsWith("@")) continue;
      const f = o.api.getDomSelector(l);
      if (f)
        try {
          const m = o.api.getSelectorSpecificity(l) ?? [0, 0, 0];
          k8e(r, f, o.isCssModule).each((g, A) => {
            const E = r(A).attr(gf);
            if (!E) return;
            const { regular: w, custom: x } = h.reduce(
              (N, B) => (B.name.startsWith("--") ? N.custom[B.name] = B.value : N.regular.push(B), N),
              { regular: [], custom: {} }
            );
            if (w.length > 0) {
              const N = i.get(E) ?? [];
              N.push({ selector: l, properties: w, specificity: m }), i.set(E, N);
              for (const B of w)
                for (const P of B.varRefs ?? []) {
                  const C = a.get(P) ?? /* @__PURE__ */ new Set();
                  C.add(E), a.set(P, C);
                }
            }
            if (Object.keys(x).length > 0) {
              const N = s.get(E) ?? {};
              Object.assign(N, x), s.set(E, N);
            }
          });
        } catch {
        }
    }
  }
  return {
    elements: M7(e, i, s),
    varUsedByTraceId: a
  };
}
function M7(t, e, n) {
  return t.map((r) => {
    const i = {
      matches: e.get(r.traceId) ?? [],
      customProperties: n.get(r.traceId) ?? {}
    };
    return r.extractorData.set("css-matcher", i), {
      ...r,
      children: M7(r.children, e, n)
    };
  });
}
function N8e(t) {
  const e = [];
  let n = Yy(t);
  for (; ; ) {
    const r = wg(n, "node_modules");
    Sg(r) && e.push(r);
    const i = Yy(n);
    if (i === n) break;
    n = i;
  }
  return e;
}
function D8e(t, e) {
  const n = wg(t, "package.json");
  if (!Sg(n)) return null;
  let r;
  try {
    r = JSON.parse(MQ(n, "utf8"));
  } catch (a) {
    return console.error(`Failed to parse ${n}:`, a), null;
  }
  const i = r.exports?.[e];
  let s;
  if (typeof i == "string" ? s = i : typeof i == "object" && i !== null && (s = i.sass ?? i.default), typeof s == "string") {
    const a = wg(t, s);
    return Sg(a) ? a : null;
  }
  return null;
}
function I8e(t) {
  return {
    findFileUrl(e) {
      if (e.startsWith(".") || e.startsWith("/")) return null;
      const n = e.startsWith("@"), r = e.split("/"), i = n ? `${r[0]}/${r[1]}` : r[0], s = n ? r.slice(2) : r.slice(1), a = s.length > 0 ? `./${s.join("/")}` : ".";
      let o = t;
      for (; ; ) {
        const u = wg(o, "node_modules", i);
        if (Sg(u)) {
          const h = D8e(u, a);
          if (h) return ju(h);
          if (s.length > 0) {
            const f = wg(u, `${s.join("/")}.scss`);
            if (Sg(f)) return ju(f);
          }
        }
        const l = Yy(o);
        if (l === o) break;
        o = l;
      }
      return null;
    }
  };
}
const R8e = bc(import.meta.url);
function P8e(t) {
  let e;
  try {
    e = R8e("sass");
  } catch {
    return Ps(
      new Error(
        `Cannot process Sass file "${t}": the "sass" package is not installed. Install it with: npm install sass  (or yarn add sass)`
      )
    );
  }
  const n = N8e(t);
  return hf.fromThrowable(
    () => e.compile(t, {
      loadPaths: n,
      importers: [I8e(Yy(t))]
    }).css,
    (r) => r instanceof Error ? r : new Error(String(r))
  )();
}
function L8e(t, e, n, r, i, s) {
  const { componentName: a } = t;
  let o = null;
  try {
    if (o = e(a), !o)
      return {
        ok: !1,
        error: new a$(
          `Component "${a}" was not found as a named export in the compiled bundle. Ensure "${a}" is exported from the package entry point.`,
          { props: { phase: "loader" } }
        )
      };
  } catch (g) {
    return {
      ok: !1,
      error: new Vd(
        `Failed to access component "${a}" from compiled bundle: ${g instanceof Error ? g.message : String(g)}`,
        { cause: g instanceof Error ? g : void 0, props: { phase: "loader" } }
      )
    };
  }
  let u, l, h = [];
  try {
    const { extractor: g, state: A } = GLe({ eligiblePaths: s }), E = ILe(), w = ULe(t, o, [g, E], r, i);
    l = w.html, h = w.elements;
    const { props: x, innerElementProps: N } = M8e(t, A.stores);
    u = {
      componentName: a,
      props: x,
      elements: wv(h),
      innerElementProps: N.size > 0 ? N : void 0,
      propUsages: A.stores.propUsages
    };
  } catch (g) {
    return {
      ok: !1,
      error: new Vd(g instanceof Error ? g.message : String(g), {
        cause: g instanceof Error ? g : void 0,
        props: { phase: "render" }
      })
    };
  }
  let f;
  try {
    f = H8e(n, a);
  } catch (g) {
    return { ok: !1, error: g instanceof ru ? g : new ru(
      `Failed to parse CSS file for component "${a}": ${g instanceof Error ? g.message : String(g)}`,
      { cause: g instanceof Error ? g : void 0, props: { phase: "css" } }
    ) };
  }
  let m = /* @__PURE__ */ new Map();
  if (l && h.length > 0 && f.length > 0)
    try {
      const g = _8e(l, h, f), A = cG(g.elements), E = lG(A);
      u = {
        ...u,
        elements: wv(E)
      }, m = g.varUsedByTraceId;
    } catch (g) {
      return {
        ok: !1,
        error: new Vd(
          `CSS selector matching failed for "${a}": ${g instanceof Error ? g.message : String(g)}`,
          { cause: g instanceof Error ? g : void 0, props: { phase: "css" } }
        )
      };
    }
  return {
    ok: !0,
    component: {
      ...u,
      css: f,
      varUsedByTraceId: m
    }
  };
}
function M8e(t, e) {
  const n = {};
  for (const [i, s] of Object.entries(t.props)) {
    const a = e.propUsages.get(`props.${i}`);
    n[i] = {
      ...s,
      logicOnly: !a,
      propPath: `props.${i}`
    };
  }
  const r = O8e(t, e);
  return { props: n, innerElementProps: r };
}
function O8e(t, e) {
  const n = /* @__PURE__ */ new Map(), r = t.props.elementProps;
  if (!r) return n;
  for (const [i, s] of e.propUsages) {
    const a = o$(i);
    if (!a) continue;
    const o = B8e(r, a);
    if (!o) continue;
    const u = ZAe(a);
    if (!u) continue;
    const l = $8e(s);
    for (const h of l) {
      const { elementId: f } = h;
      let m = n.get(f);
      m || (m = { elementPropsPath: u, props: {} }, n.set(f, m));
      const g = o.name;
      m.props[g] || (m.props[g] = {
        ...o,
        logicOnly: !1,
        propPath: i
      });
    }
  }
  return n;
}
function B8e(t, e) {
  const n = e.split(".");
  let r = t.resolvedType;
  for (let i = 0; i < n.length; i++) {
    const s = n[i];
    if (!r.properties) return null;
    const a = r.properties[s];
    if (!a) return null;
    if (i === n.length - 1)
      return a;
    r = a.resolvedType;
  }
  return null;
}
function $8e(t) {
  const e = [];
  for (const [n, r] of t.attributes) {
    const i = n.split(":")[0], s = t.elements.get(i);
    s && e.push({
      element: s.tag,
      attribute: r.attr,
      concatenated: r.concatenated,
      elementId: s.elementId
    });
  }
  return e;
}
function wv(t) {
  return t.map((e) => {
    const n = e.extractorData.get("prop-tracker");
    return {
      traceId: e.traceId,
      name: e.name,
      tag: e.tag,
      attributes: e.attributes,
      extractorData: e.extractorData,
      children: wv(e.children),
      // Legacy fields
      boundProps: n?.boundProps ?? [],
      role: n?.role,
      hasTextContent: e.hasTextContent
    };
  });
}
function H8e(t, e) {
  const n = [];
  for (const r of t) {
    let i;
    if (r.endsWith(".scss") || r.endsWith(".sass")) {
      const l = P8e(r);
      if (l.isErr())
        throw new ru(`Failed to compile "${r}" for component "${e}"`, {
          cause: l.error,
          props: { phase: "css" }
        });
      i = l.value;
    } else
      i = BM.readFileSync(r, "utf-8");
    const s = VPe(i), a = s.getAllProperties(), o = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map();
    for (const [, l] of a)
      for (const h of l)
        h.name.startsWith("--") ? u.set(h.name, h.value) : o.set(h.name, h.value);
    n.push({
      filePath: r,
      api: s,
      properties: o,
      customProperties: u,
      isCssModule: /\.module\.(css|scss|sass)$/.test(r)
    });
  }
  return n;
}
const Hl = /* @__PURE__ */ Symbol("abort"), jr = /* @__PURE__ */ Symbol("activeElement"), xt = /* @__PURE__ */ Symbol("asyncTaskManager"), Ul = /* @__PURE__ */ Symbol("bodyBuffer"), En = /* @__PURE__ */ Symbol("buffer"), Zo = /* @__PURE__ */ Symbol("cachedResponse"), Mu = /* @__PURE__ */ Symbol("callbacks"), md = /* @__PURE__ */ Symbol("checked"), eh = /* @__PURE__ */ Symbol("childNodes"), ts = /* @__PURE__ */ Symbol("children"), dm = /* @__PURE__ */ Symbol("classList"), ho = /* @__PURE__ */ Symbol("connectedToNode"), bh = /* @__PURE__ */ Symbol("disconnectedFromNode"), Hs = /* @__PURE__ */ Symbol("connectedToDocument"), Bs = /* @__PURE__ */ Symbol("disconnectedFromDocument"), lg = /* @__PURE__ */ Symbol("contentLength"), xi = /* @__PURE__ */ Symbol("contentType"), za = /* @__PURE__ */ Symbol("cssText"), eu = /* @__PURE__ */ Symbol("currentScript"), tu = /* @__PURE__ */ Symbol("currentTarget"), Dn = /* @__PURE__ */ Symbol("data"), lu = /* @__PURE__ */ Symbol("defaultView"), tn = /* @__PURE__ */ Symbol("destroy"), Nd = /* @__PURE__ */ Symbol("dirtyness"), _e = /* @__PURE__ */ Symbol("end"), ui = /* @__PURE__ */ Symbol("entries"), wf = /* @__PURE__ */ Symbol("evaluateScript"), Ec = /* @__PURE__ */ Symbol("exceptionObserver"), Cn = /* @__PURE__ */ Symbol("formNode"), gd = /* @__PURE__ */ Symbol("internalId"), we = /* @__PURE__ */ Symbol("height"), Dd = /* @__PURE__ */ Symbol("immediatePropagationStopped"), zc = /* @__PURE__ */ Symbol("indeterminate"), pd = /* @__PURE__ */ Symbol("isFirstWrite"), bd = /* @__PURE__ */ Symbol("isFirstWriteAfterOpen"), L1 = /* @__PURE__ */ Symbol("isInPassiveEventListener"), po = /* @__PURE__ */ Symbol("isValue"), fl = /* @__PURE__ */ Symbol("listenerOptions"), ur = /* @__PURE__ */ Symbol("listeners"), _a = /* @__PURE__ */ Symbol("itemsByName"), Yd = /* @__PURE__ */ Symbol("nextActiveElement"), $m = /* @__PURE__ */ Symbol("observeMutations"), ea = /* @__PURE__ */ Symbol("mutationListeners"), he = /* @__PURE__ */ Symbol("ownerDocument"), zt = /* @__PURE__ */ Symbol("ownerElement"), qd = /* @__PURE__ */ Symbol("propagationStopped"), Uu = /* @__PURE__ */ Symbol("readyStateManager"), ra = /* @__PURE__ */ Symbol("referrer"), xl = /* @__PURE__ */ Symbol("registry"), La = /* @__PURE__ */ Symbol("relList"), By = /* @__PURE__ */ Symbol("resetSelection"), ci = /* @__PURE__ */ Symbol("rootNode"), zr = /* @__PURE__ */ Symbol("selectNode"), Qi = /* @__PURE__ */ Symbol("selectedness"), yd = /* @__PURE__ */ Symbol("selection"), tL = /* @__PURE__ */ Symbol("setupVMContext"), zn = /* @__PURE__ */ Symbol("shadowRoot"), fe = /* @__PURE__ */ Symbol("start"), er = /* @__PURE__ */ Symbol("style"), Ma = /* @__PURE__ */ Symbol("target"), Wi = /* @__PURE__ */ Symbol("textAreaNode"), $y = /* @__PURE__ */ Symbol("unobserveMutations"), oh = /* @__PURE__ */ Symbol("reportMutation"), Ad = /* @__PURE__ */ Symbol("updateSelectedness"), Ir = /* @__PURE__ */ Symbol("url"), ze = /* @__PURE__ */ Symbol("value"), Fe = /* @__PURE__ */ Symbol("width"), b = /* @__PURE__ */ Symbol("window"), dF = /* @__PURE__ */ Symbol("windowResizeListener"), Jd = /* @__PURE__ */ Symbol("mutationObservers"), zu = /* @__PURE__ */ Symbol("openerFrame"), Ff = /* @__PURE__ */ Symbol("openerWindow"), M1 = /* @__PURE__ */ Symbol("popup"), st = /* @__PURE__ */ Symbol("isConnected"), xe = /* @__PURE__ */ Symbol("parentNode"), ve = /* @__PURE__ */ Symbol("nodeType"), Xe = /* @__PURE__ */ Symbol("tagName"), pn = /* @__PURE__ */ Symbol("prefix"), nL = /* @__PURE__ */ Symbol("scrollHeight"), rL = /* @__PURE__ */ Symbol("scrollWidth"), fF = /* @__PURE__ */ Symbol("scrollTop"), mF = /* @__PURE__ */ Symbol("scrollLeft"), bt = /* @__PURE__ */ Symbol("attributes"), fm = /* @__PURE__ */ Symbol("attributesProxy"), je = /* @__PURE__ */ Symbol("namespaceURI"), mm = /* @__PURE__ */ Symbol("accessKey"), iL = /* @__PURE__ */ Symbol("offsetHeight"), sL = /* @__PURE__ */ Symbol("offsetWidth"), aL = /* @__PURE__ */ Symbol("offsetLeft"), oL = /* @__PURE__ */ Symbol("offsetTop"), uL = /* @__PURE__ */ Symbol("clientHeight"), lL = /* @__PURE__ */ Symbol("clientWidth"), cL = /* @__PURE__ */ Symbol("clientLeft"), hL = /* @__PURE__ */ Symbol("clientTop"), tt = /* @__PURE__ */ Symbol("name"), J0 = /* @__PURE__ */ Symbol("specified"), uh = /* @__PURE__ */ Symbol("adoptedStyleSheets"), gF = /* @__PURE__ */ Symbol("implementation"), Og = /* @__PURE__ */ Symbol("readyState"), Id = /* @__PURE__ */ Symbol("publicId"), Rd = /* @__PURE__ */ Symbol("systemId"), fi = /* @__PURE__ */ Symbol("validationMessage"), rs = /* @__PURE__ */ Symbol("validity"), pF = /* @__PURE__ */ Symbol("returnValue"), Gl = /* @__PURE__ */ Symbol("elements"), dL = /* @__PURE__ */ Symbol("complete"), fL = /* @__PURE__ */ Symbol("naturalHeight"), mL = /* @__PURE__ */ Symbol("naturalWidth"), U8e = /* @__PURE__ */ Symbol("loading"), me = /* @__PURE__ */ Symbol("x"), ge = /* @__PURE__ */ Symbol("y"), jo = /* @__PURE__ */ Symbol("files"), Yr = /* @__PURE__ */ Symbol("sheet"), bF = /* @__PURE__ */ Symbol("volume"), ud = /* @__PURE__ */ Symbol("paused"), yF = /* @__PURE__ */ Symbol("currentTime"), AF = /* @__PURE__ */ Symbol("playbackRate"), EF = /* @__PURE__ */ Symbol("defaultPlaybackRate"), gm = /* @__PURE__ */ Symbol("muted"), ld = /* @__PURE__ */ Symbol("defaultMuted"), SF = /* @__PURE__ */ Symbol("preservesPitch"), gL = /* @__PURE__ */ Symbol("buffered"), pL = /* @__PURE__ */ Symbol("duration"), Zi = /* @__PURE__ */ Symbol("error"), bL = /* @__PURE__ */ Symbol("ended"), yL = /* @__PURE__ */ Symbol("networkState"), wF = /* @__PURE__ */ Symbol("textTracks"), AL = /* @__PURE__ */ Symbol("seeking"), EL = /* @__PURE__ */ Symbol("seekable"), SL = /* @__PURE__ */ Symbol("played"), Wl = /* @__PURE__ */ Symbol("options"), xs = /* @__PURE__ */ Symbol("content"), Jr = /* @__PURE__ */ Symbol("mode"), Bg = /* @__PURE__ */ Symbol("host"), fo = /* @__PURE__ */ Symbol("setURL"), Tt = /* @__PURE__ */ Symbol("localName"), pm = /* @__PURE__ */ Symbol("classRegistry"), Q0 = /* @__PURE__ */ Symbol("nodeStream"), Gu = /* @__PURE__ */ Symbol("location"), Ci = /* @__PURE__ */ Symbol("history"), FF = /* @__PURE__ */ Symbol("navigator"), TF = /* @__PURE__ */ Symbol("screen"), vF = /* @__PURE__ */ Symbol("sessionStorage"), xF = /* @__PURE__ */ Symbol("localStorage"), X0 = /* @__PURE__ */ Symbol("sandbox"), Bt = /* @__PURE__ */ Symbol("cloneNode"), Ht = /* @__PURE__ */ Symbol("appendChild"), Ms = /* @__PURE__ */ Symbol("removeChild"), ja = /* @__PURE__ */ Symbol("insertBefore"), O1 = /* @__PURE__ */ Symbol("replaceChild"), Go = /* @__PURE__ */ Symbol("tracks"), bm = /* @__PURE__ */ Symbol("constraints"), $u = /* @__PURE__ */ Symbol("capabilities"), Pd = /* @__PURE__ */ Symbol("settings"), lh = /* @__PURE__ */ Symbol("removeNamedItem"), Ge = /* @__PURE__ */ Symbol("items"), jc = /* @__PURE__ */ Symbol("selectedOptions"), ys = /* @__PURE__ */ Symbol("styleNode"), cg = /* @__PURE__ */ Symbol("updateSheet"), Na = /* @__PURE__ */ Symbol("clearCache"), as = /* @__PURE__ */ Symbol("onSetAttribute"), qa = /* @__PURE__ */ Symbol("onRemoveAttribute"), Re = /* @__PURE__ */ Symbol("nodeArray"), Ft = /* @__PURE__ */ Symbol("elementArray"), Ae = /* @__PURE__ */ Symbol("cache"), li = /* @__PURE__ */ Symbol("affectsCache"), ym = /* @__PURE__ */ Symbol("forms"), fc = /* @__PURE__ */ Symbol("affectsComputedStyleCache"), cd = /* @__PURE__ */ Symbol("query"), hg = /* @__PURE__ */ Symbol("computedStyle"), Fa = /* @__PURE__ */ Symbol("getFormControlItems"), Fv = /* @__PURE__ */ Symbol("getFormControlNamedItem"), CF = /* @__PURE__ */ Symbol("dataset"), Vl = /* @__PURE__ */ Symbol("itemsByNamespaceURI"), yn = /* @__PURE__ */ Symbol("proxy"), mc = /* @__PURE__ */ Symbol("setNamedItem"), Mi = /* @__PURE__ */ Symbol("getTokenList"), ml = /* @__PURE__ */ Symbol("attributeName"), Ea = /* @__PURE__ */ Symbol("selectedIndex"), Qd = /* @__PURE__ */ Symbol("self"), bo = /* @__PURE__ */ Symbol("parent"), gc = /* @__PURE__ */ Symbol("top"), Z0 = /* @__PURE__ */ Symbol("areas"), So = /* @__PURE__ */ Symbol("defaultValue"), Il = /* @__PURE__ */ Symbol("elementIdMap"), Ld = /* @__PURE__ */ Symbol("clonable"), Hm = /* @__PURE__ */ Symbol("delegatesFocus"), ch = /* @__PURE__ */ Symbol("serializable"), Kl = /* @__PURE__ */ Symbol("slotAssignment"), Cl = /* @__PURE__ */ Symbol("assignedNodes"), nu = /* @__PURE__ */ Symbol("assignedToSlot"), eb = /* @__PURE__ */ Symbol("cells"), tb = /* @__PURE__ */ Symbol("rows"), kF = /* @__PURE__ */ Symbol("headers"), nb = /* @__PURE__ */ Symbol("tBodies"), B1 = /* @__PURE__ */ Symbol("track"), rb = /* @__PURE__ */ Symbol("controlsList"), _F = /* @__PURE__ */ Symbol("mediaKeys"), wL = /* @__PURE__ */ Symbol("remote"), NF = /* @__PURE__ */ Symbol("sinkId"), DF = /* @__PURE__ */ Symbol("srcObject"), hd = /* @__PURE__ */ Symbol("cues"), FL = /* @__PURE__ */ Symbol("activeCues"), Wu = /* @__PURE__ */ Symbol("kind"), $g = /* @__PURE__ */ Symbol("label"), $1 = /* @__PURE__ */ Symbol("language"), Tv = /* @__PURE__ */ Symbol("id"), T = /* @__PURE__ */ Symbol("illegalConstructor"), TL = /* @__PURE__ */ Symbol("state"), ib = /* @__PURE__ */ Symbol("canvas"), Xd = /* @__PURE__ */ Symbol("popoverTargetElement"), sb = /* @__PURE__ */ Symbol("composed"), Md = /* @__PURE__ */ Symbol("bubbles"), hh = /* @__PURE__ */ Symbol("cancelable"), vo = /* @__PURE__ */ Symbol("defaultPrevented"), ia = /* @__PURE__ */ Symbol("eventPhase"), vL = /* @__PURE__ */ Symbol("timeStamp"), qn = /* @__PURE__ */ Symbol("type"), ab = /* @__PURE__ */ Symbol("detail"), ob = /* @__PURE__ */ Symbol("destroyed"), xr = /* @__PURE__ */ Symbol("aborted"), ub = /* @__PURE__ */ Symbol("browserFrames"), IF = /* @__PURE__ */ Symbol("windowInternalId"), De = /* @__PURE__ */ Symbol("getItemList"), zl = /* @__PURE__ */ Symbol("requiredExtensions"), jl = /* @__PURE__ */ Symbol("systemLanguage"), lb = /* @__PURE__ */ Symbol("transform"), Jn = /* @__PURE__ */ Symbol("baseVal"), Qn = /* @__PURE__ */ Symbol("animVal"), cb = /* @__PURE__ */ Symbol("pathLength"), Yl = /* @__PURE__ */ Symbol("viewBox"), hb = /* @__PURE__ */ Symbol("markerUnits"), db = /* @__PURE__ */ Symbol("markerWidth"), fb = /* @__PURE__ */ Symbol("markerHeight"), Fi = /* @__PURE__ */ Symbol("values"), mb = /* @__PURE__ */ Symbol("orientType"), gb = /* @__PURE__ */ Symbol("orientAngle"), pb = /* @__PURE__ */ Symbol("refX"), bb = /* @__PURE__ */ Symbol("refY"), Be = /* @__PURE__ */ Symbol("readOnly"), ns = /* @__PURE__ */ Symbol("preserveAspectRatio"), ql = /* @__PURE__ */ Symbol("animatedPoints"), Jl = /* @__PURE__ */ Symbol("points"), Ql = /* @__PURE__ */ Symbol("rx"), Xl = /* @__PURE__ */ Symbol("ry"), Oa = /* @__PURE__ */ Symbol("cx"), Ba = /* @__PURE__ */ Symbol("cy"), Zl = /* @__PURE__ */ Symbol("r"), yb = /* @__PURE__ */ Symbol("clipPathUnits"), Ab = /* @__PURE__ */ Symbol("maskUnits"), Eb = /* @__PURE__ */ Symbol("maskContentUnits"), Sb = /* @__PURE__ */ Symbol("filterUnits"), wb = /* @__PURE__ */ Symbol("primitiveUnits"), dn = /* @__PURE__ */ Symbol("href"), ec = /* @__PURE__ */ Symbol("x1"), tc = /* @__PURE__ */ Symbol("y1"), nc = /* @__PURE__ */ Symbol("x2"), rc = /* @__PURE__ */ Symbol("y2"), Fb = /* @__PURE__ */ Symbol("gradientUnits"), Tb = /* @__PURE__ */ Symbol("gradientTransform"), vb = /* @__PURE__ */ Symbol("spreadMethod"), xb = /* @__PURE__ */ Symbol("patternUnits"), Cb = /* @__PURE__ */ Symbol("patternContentUnits"), kb = /* @__PURE__ */ Symbol("patternTransform"), _b = /* @__PURE__ */ Symbol("fx"), Nb = /* @__PURE__ */ Symbol("fy"), ic = /* @__PURE__ */ Symbol("offset"), Zd = /* @__PURE__ */ Symbol("disabled"), Db = /* @__PURE__ */ Symbol("textLength"), Ib = /* @__PURE__ */ Symbol("lengthAdjust"), se = /* @__PURE__ */ Symbol("getAttribute"), Q = /* @__PURE__ */ Symbol("setAttribute"), aa = /* @__PURE__ */ Symbol("z"), dg = /* @__PURE__ */ Symbol("w"), Rb = /* @__PURE__ */ Symbol("toArray"), fg = /* @__PURE__ */ Symbol("fromString"), Xs = /* @__PURE__ */ Symbol("fromArray"), Nt = /* @__PURE__ */ Symbol("m11"), Lt = /* @__PURE__ */ Symbol("m12"), an = /* @__PURE__ */ Symbol("m13"), on = /* @__PURE__ */ Symbol("m14"), Dt = /* @__PURE__ */ Symbol("m21"), Mt = /* @__PURE__ */ Symbol("m22"), un = /* @__PURE__ */ Symbol("m23"), ln = /* @__PURE__ */ Symbol("m24"), Vt = /* @__PURE__ */ Symbol("m31"), Qt = /* @__PURE__ */ Symbol("m32"), Xt = /* @__PURE__ */ Symbol("m33"), Kt = /* @__PURE__ */ Symbol("m34"), It = /* @__PURE__ */ Symbol("m41"), Ot = /* @__PURE__ */ Symbol("m42"), Zt = /* @__PURE__ */ Symbol("m43"), en = /* @__PURE__ */ Symbol("m44"), Hy = /* @__PURE__ */ Symbol("setMatrixValue"), Sa = /* @__PURE__ */ Symbol("translateSelf"), Jc = /* @__PURE__ */ Symbol("rotateSelf"), Qc = /* @__PURE__ */ Symbol("rotateAxisAngleSelf"), Tl = /* @__PURE__ */ Symbol("scaleSelf"), vv = /* @__PURE__ */ Symbol("scale3dSelf"), xv = /* @__PURE__ */ Symbol("scaleNonUniformSelf"), Um = /* @__PURE__ */ Symbol("skewXSelf"), Gm = /* @__PURE__ */ Symbol("skewYSelf"), wa = /* @__PURE__ */ Symbol("multiplySelf"), gl = /* @__PURE__ */ Symbol("matrix"), dr = /* @__PURE__ */ Symbol("getDOMMatrix"), bi = /* @__PURE__ */ Symbol("setDOMMatrix"), ae = /* @__PURE__ */ Symbol("attributeValue"), Pb = /* @__PURE__ */ Symbol("startOffset"), dh = /* @__PURE__ */ Symbol("method"), Lb = /* @__PURE__ */ Symbol("spacing"), nt = /* @__PURE__ */ Symbol("in1"), $a = /* @__PURE__ */ Symbol("in2"), Qe = /* @__PURE__ */ Symbol("result"), Mb = /* @__PURE__ */ Symbol("bias"), Ob = /* @__PURE__ */ Symbol("divisor"), sc = /* @__PURE__ */ Symbol("edgeMode"), Bb = /* @__PURE__ */ Symbol("kernelMatrix"), Ha = /* @__PURE__ */ Symbol("kernelUnitLengthX"), Ua = /* @__PURE__ */ Symbol("kernelUnitLengthY"), $b = /* @__PURE__ */ Symbol("orderX"), Hb = /* @__PURE__ */ Symbol("orderY"), Ub = /* @__PURE__ */ Symbol("preserveAlpha"), Gb = /* @__PURE__ */ Symbol("targetX"), Wb = /* @__PURE__ */ Symbol("targetY"), Vb = /* @__PURE__ */ Symbol("diffuseConstant"), ac = /* @__PURE__ */ Symbol("surfaceScale"), Kb = /* @__PURE__ */ Symbol("scale"), zb = /* @__PURE__ */ Symbol("xChannelSelector"), jb = /* @__PURE__ */ Symbol("yChannelSelector"), Yb = /* @__PURE__ */ Symbol("azimuth"), qb = /* @__PURE__ */ Symbol("elevation"), Ga = /* @__PURE__ */ Symbol("dx"), Wa = /* @__PURE__ */ Symbol("dy"), oc = /* @__PURE__ */ Symbol("stdDeviationX"), uc = /* @__PURE__ */ Symbol("stdDeviationY"), Jb = /* @__PURE__ */ Symbol("tableValues"), Qb = /* @__PURE__ */ Symbol("slope"), Xb = /* @__PURE__ */ Symbol("intercept"), Zb = /* @__PURE__ */ Symbol("amplitude"), ey = /* @__PURE__ */ Symbol("exponent"), G8e = /* @__PURE__ */ Symbol("crossOrigin"), ty = /* @__PURE__ */ Symbol("operator"), ny = /* @__PURE__ */ Symbol("radiusX"), ry = /* @__PURE__ */ Symbol("radiusY"), iy = /* @__PURE__ */ Symbol("specularConstant"), lc = /* @__PURE__ */ Symbol("specularExponent"), sy = /* @__PURE__ */ Symbol("pointsAtX"), ay = /* @__PURE__ */ Symbol("pointsAtY"), oy = /* @__PURE__ */ Symbol("pointsAtZ"), uy = /* @__PURE__ */ Symbol("limitingConeAngle"), ly = /* @__PURE__ */ Symbol("baseFrequencyX"), cy = /* @__PURE__ */ Symbol("baseFrequencyY"), hy = /* @__PURE__ */ Symbol("numOctaves"), dy = /* @__PURE__ */ Symbol("seed"), fy = /* @__PURE__ */ Symbol("stitchTiles"), Cv = /* @__PURE__ */ Symbol("rotateFromVectorSelf"), kv = /* @__PURE__ */ Symbol("flipXSelf"), _v = /* @__PURE__ */ Symbol("flipYSelf"), Nv = /* @__PURE__ */ Symbol("invertSelf"), xL = /* @__PURE__ */ Symbol("getLength"), RF = /* @__PURE__ */ Symbol("currentScale"), my = /* @__PURE__ */ Symbol("rotate"), CL = /* @__PURE__ */ Symbol("bindMethods"), Hg = /* @__PURE__ */ Symbol("xmlProcessingInstruction"), ao = /* @__PURE__ */ Symbol("filterNode"), ef = /* @__PURE__ */ Symbol("customElementReactionStack"), mg = /* @__PURE__ */ Symbol("dispatching"), cc = /* @__PURE__ */ Symbol("modules"), Va = /* @__PURE__ */ Symbol("preloads"), fh = /* @__PURE__ */ Symbol("body"), PF = /* @__PURE__ */ Symbol("redirect"), Uy = /* @__PURE__ */ Symbol("referrerPolicy"), LF = /* @__PURE__ */ Symbol("signal"), Wo = /* @__PURE__ */ Symbol("bodyUsed"), MF = /* @__PURE__ */ Symbol("credentials"), gy = /* @__PURE__ */ Symbol("blocking"), H1 = /* @__PURE__ */ Symbol("moduleImportMap"), tr = /* @__PURE__ */ Symbol("dispatchError"), OF = /* @__PURE__ */ Symbol("supports"), mo = /* @__PURE__ */ Symbol("reason"), F = /* @__PURE__ */ Symbol("propertyEventListeners"), Ui = /* @__PURE__ */ Symbol("cssRules"), tf = /* @__PURE__ */ Symbol("parentRule"), Ta = /* @__PURE__ */ Symbol("parentStyleSheet"), go = /* @__PURE__ */ Symbol("conditionText"), yh = /* @__PURE__ */ Symbol("keyText"), kL = /* @__PURE__ */ Symbol("media"), py = /* @__PURE__ */ Symbol("styleMap"), gg = /* @__PURE__ */ Symbol("selectorText"), U1 = /* @__PURE__ */ Symbol("cssParser"), pl = /* @__PURE__ */ Symbol("cssRule"), Ka = /* @__PURE__ */ Symbol("rulePrefix"), wo = /* @__PURE__ */ Symbol("virtualServerFile"), _L = /* @__PURE__ */ Symbol("frames"), Tf = /* @__PURE__ */ Symbol("disableEvaluation"), NL = /* @__PURE__ */ Symbol("validateJavaScriptExecutionEnvironment"), nf = /* @__PURE__ */ Symbol("openWebSockets"), Oi = /* @__PURE__ */ Symbol("webSocket"), Dv = /* @__PURE__ */ Symbol("moduleCache");
var Iv;
(function(t) {
  t.strict = "Strict", t.lax = "Lax", t.none = "None";
})(Iv || (Iv = {}));
const pg = Iv, O7 = {
  // Required
  key: null,
  originURL: null,
  // Optional
  value: null,
  domain: "",
  path: "",
  expires: null,
  httpOnly: !1,
  secure: !1,
  sameSite: pg.lax
};
class DL {
  /**
   * Returns "true" if cookie has expired.
   *
   * @param cookie Cookie.
   * @returns "true" if cookie has expired.
   */
  static hasExpired(e) {
    return e.expires && e.expires.getTime() < Date.now();
  }
}
class W8e {
  /**
   * Returns "true" if cookie matches URL.
   *
   * @param cookie Cookie.
   * @param url URL.
   * @returns "true" if cookie matches URL.
   */
  static cookieMatchesURL(e, n) {
    const r = n.hostname === "localhost" || n.hostname?.endsWith(".localhost");
    return (!e.secure || n.protocol === "https:" || r) && (!e.domain || n.hostname?.endsWith(e.domain)) && (!e.path || n.pathname?.startsWith(e.path)) && // @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie#samesitesamesite-value
    (e.sameSite === pg.none && e.secure || e.originURL?.hostname === n.hostname);
  }
}
class V8e {
  #e = [];
  /**
   * Adds cookies.
   *
   * @param cookies Cookies.
   */
  addCookies(e) {
    const n = /* @__PURE__ */ new Map(), r = (i) => `${i.key}-${i.originURL.hostname}-${i.path}-${typeof i.value}`;
    for (let i = 0, s = this.#e.length; i < s; i++)
      n.set(r(this.#e[i]), i);
    for (const i of e) {
      const s = Object.assign({}, O7, i);
      if (s && s.key && s.originURL) {
        const a = n.get(r(s));
        a !== void 0 && this.#e.splice(a, 1), DL.hasExpired(s) || (n.set(r(s), this.#e.length), this.#e.push(s));
      }
    }
  }
  /**
   * Returns cookies.
   *
   * @param [url] URL.
   * @param [httpOnly] "true" if only http cookies should be returned.
   * @returns Cookies.
   */
  getCookies(e = null, n = !1) {
    const r = [];
    for (const i of this.#e)
      !DL.hasExpired(i) && (!n || !i.httpOnly) && (!e || W8e.cookieMatchesURL(i, e || i.originURL)) && r.push(i);
    return r;
  }
  /**
   * Clears all cookies.
   */
  clearCookies() {
    this.#e = [];
  }
}
var Rv;
(function(t) {
  t.fresh = "fresh", t.stale = "stale";
})(Rv || (Rv = {}));
const bg = Rv;
var Pv;
(function(t) {
  t.invalidStateError = "InvalidStateError", t.indexSizeError = "IndexSizeError", t.syntaxError = "SyntaxError", t.hierarchyRequestError = "HierarchyRequestError", t.notSupportedError = "NotSupportedError", t.wrongDocumentError = "WrongDocumentError", t.invalidNodeTypeError = "InvalidNodeTypeError", t.invalidCharacterError = "InvalidCharacterError", t.notFoundError = "NotFoundError", t.securityError = "SecurityError", t.networkError = "NetworkError", t.domException = "DOMException", t.invalidAccessError = "InvalidAccessError", t.unknownError = "UnknownError", t.abortError = "AbortError", t.timeoutError = "TimeoutError", t.encodingError = "EncodingError", t.uriMismatchError = "URIMismatchError", t.inUseAttributeError = "InUseAttributeError", t.namespaceError = "NamespaceError";
})(Pv || (Pv = {}));
const ne = Pv;
let Tr = class extends Error {
  /**
   * Constructor.
   *
   * @param message Message.
   * @param name Name.
   */
  constructor(e, n = null) {
    super(e), this.name = n || ne.domException;
  }
}, G1 = class B7 {
  [ui] = {};
  /**
   * Constructor.
   *
   * @param init Headers init.
   */
  constructor(e) {
    if (e)
      if (e instanceof B7)
        this[ui] = JSON.parse(JSON.stringify(e[ui]));
      else if (Array.isArray(e))
        for (const n of e) {
          if (n.length !== 2)
            throw new Tr('Failed to construct "Headers": The provided init is not a valid array.', ne.invalidStateError);
          this.append(n[0], n[1]);
        }
      else
        for (const n of Object.keys(e))
          this.set(n, e[n]);
  }
  /**
   * Appends a new value onto an existing header inside a Headers object, or adds the header if it does not already exist.
   *
   * @param name Name.
   * @param value Value.
   */
  append(e, n) {
    const r = e.toLowerCase();
    this[ui][r] ? this[ui][r].value.push(n) : this[ui][r] = {
      name: e,
      value: [n]
    };
  }
  /**
   * Removes an header.
   *
   * @param name Name.
   */
  delete(e) {
    delete this[ui][e.toLowerCase()];
  }
  /**
   * Returns header value.
   *
   * @param name Name.
   * @returns Value.
   */
  get(e) {
    return this[ui][e.toLowerCase()]?.value.join(", ") ?? null;
  }
  /**
   * Sets a new value for an existing header inside a Headers object, or adds the header if it does not already exist.
   *
   * @param name Name.
   * @param value Value.
   */
  set(e, n) {
    this[ui][e.toLowerCase()] = {
      name: e,
      value: [n]
    };
  }
  /**
   * Returns an array containing the values of all Set-Cookie headers associated with a response.
   *
   * @returns An array of strings representing the values of all the different Set-Cookie headers.
   */
  getSetCookie() {
    const e = this[ui]["set-cookie"];
    return e ? e.value : [];
  }
  /**
   * Returns whether an Headers object contains a certain key.
   *
   * @param name Name.
   * @returns "true" if the Headers object contains the key.
   */
  has(e) {
    return !!this[ui][e.toLowerCase()];
  }
  /**
   * Executes a callback function once per each key/value pair in the Headers object.
   *
   * @param callback Callback.
   * @param thisArg thisArg.
   */
  forEach(e, n) {
    const r = n ?? this[b];
    for (const i of Object.values(this[ui]))
      e.call(r, i.value.join(", "), i.name, this);
  }
  /**
   * Returns an iterator, allowing you to go through all keys of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  *keys() {
    for (const e of Object.values(this[ui]))
      yield e.name;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  *values() {
    for (const e of Object.values(this[ui]))
      yield e.value.join(", ");
  }
  /**
   * Returns an iterator, allowing you to go through all key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  *entries() {
    for (const e of Object.values(this[ui]))
      yield [e.name, e.value.join(", ")];
  }
  /**
   * Iterator.
   *
   * @returns Iterator.
   */
  *[Symbol.iterator]() {
    for (const e of Object.values(this[ui]))
      yield [e.name, e.value.join(", ")];
  }
};
class K8e {
  #e = /* @__PURE__ */ new Set();
  #t = /* @__PURE__ */ new Set();
  #n;
  /**
   * Constructor.
   *
   * @param entries Map of URL to cached responses.
   */
  constructor(e) {
    this.#n = e;
  }
  /**
   * Loads cache from file system.
   *
   * @param directory Directory to load from.
   */
  async load(e) {
    if (!e)
      throw new Error("Failed to execute 'load' on 'ResponseCacheFileSystem': Directory is not specified.");
    const n = qr.resolve(e);
    let r = [];
    try {
      r = await As.promises.readdir(n);
    } catch {
      return;
    }
    const i = [], s = this.#n;
    for (const a of r)
      a.endsWith(".json") && i.push(As.promises.readFile(qr.join(n, a), "utf8").then((o) => {
        const u = JSON.parse(o);
        if (u.response && u.request && !u.virtual)
          return u.response.headers = new G1(u.response.headers), u.request.headers = new G1(u.request.headers), As.promises.readFile(qr.join(n, a.split(".")[0] + ".data")).then((l) => {
            u.response.body = l;
            let h = s.get(u.response.url);
            h || (h = [], s.set(u.response.url, h)), h.push(u);
          }).catch(() => {
            let l = s.get(u.response.url);
            l || (l = [], s.set(u.response.url, l)), l.push(u);
          });
      }).catch(() => {
      }));
    await Promise.all(i);
  }
  /**
   * Saves the cache to file system.
   *
   * @param directory Directory to store to.
   */
  async save(e) {
    if (!e)
      throw new Error("Failed to execute 'store' on 'ResponseCacheFileSystem': Directory is not specified.");
    if (!this.#n.size)
      return;
    const n = qr.resolve(e);
    if (!this.#e.has(n)) {
      this.#e.add(n);
      try {
        await As.promises.mkdir(n, {
          recursive: !0
        });
      } catch {
      }
    }
    const i = this.#n, s = [];
    for (const a of i.values())
      for (const o of a)
        if (!o.virtual) {
          const u = {}, l = {};
          for (const [g, A] of o.response.headers.entries())
            u[g] = A;
          for (const [g, A] of o.request.headers.entries())
            l[g] = A;
          const h = {
            ...o,
            response: {
              ...o.response,
              headers: u,
              body: null
            },
            request: {
              ...o.request,
              headers: l
            }
          }, f = JSON.stringify(h, null, 3), m = _f.createHash("md5").update(f).digest("hex");
          this.#t.has(m) || (this.#t.add(m), s.push(As.promises.writeFile(qr.join(n, `${m}.json`), f)), o.response.body && s.push(As.promises.writeFile(qr.join(n, `${m}.data`), o.response.body)));
        }
    await Promise.all(s);
  }
}
const z8e = ["Cache-Control", "Last-Modified", "Vary", "ETag"];
class j8e {
  fileSystem;
  #e = /* @__PURE__ */ new Map();
  /**
   * Constructor.
   */
  constructor() {
    this.fileSystem = new K8e(this.#e);
  }
  /**
   * Returns cached response.
   *
   * @param request Request.
   * @returns Cached response.
   */
  get(e) {
    if (e.headers.get("Cache-Control")?.includes("no-cache"))
      return null;
    const n = e.url, r = this.#e.get(n);
    if (r)
      for (let i = 0, s = r.length; i < s; i++) {
        const a = r[i];
        let o = a.request.method === e.method;
        if (o)
          for (const u of Object.keys(a.vary)) {
            const l = e.headers.get(u);
            if (l !== null && a.vary[u] !== l) {
              o = !1;
              break;
            }
          }
        if (o) {
          if (a.expires && a.expires < Date.now()) {
            if (a.lastModified)
              a.state = bg.stale;
            else if (!a.etag)
              return r.splice(i, 1), null;
          }
          return a;
        }
      }
    return null;
  }
  /**
   * Adds a cache entity.
   *
   * @param request Request.
   * @param response Response.
   * @returns Cached response.
   */
  add(e, n) {
    if (e.method !== "GET" && e.method !== "HEAD" || e.headers.get("Cache-Control")?.includes("no-cache"))
      return null;
    const r = e.url;
    let i = this.get(e);
    if (n.status === 304) {
      if (!i)
        throw new Error("ResponseCache: Cached response not found.");
      for (const s of z8e)
        n.headers.has(s) && i.response.headers.set(s, n.headers.get(s));
      i.cacheUpdateTime = Date.now(), i.state = bg.fresh;
    } else {
      if (i) {
        const a = this.#e.get(r);
        if (a) {
          const o = a.indexOf(i);
          o !== -1 && a.splice(o, 1);
        }
      }
      i = {
        response: {
          status: n.status,
          statusText: n.statusText,
          url: n.url,
          headers: new G1(n.headers),
          // We need to wait for the body to be consumed and then populated if set to true (e.g. by using Response.text()).
          waitingForBody: n.waitingForBody,
          body: n.body ?? null
        },
        request: {
          headers: e.headers,
          method: e.method
        },
        vary: {},
        expires: null,
        etag: null,
        cacheUpdateTime: Date.now(),
        lastModified: null,
        mustRevalidate: !1,
        staleWhileRevalidate: !1,
        state: bg.fresh,
        virtual: n.virtual ?? !1
      };
      let s = this.#e.get(r);
      s || (s = [], this.#e.set(r, s)), s.push(i);
    }
    if (n.headers.has("Cache-Control")) {
      const s = n.headers.get("Age");
      for (const a of n.headers.get("Cache-Control").split(",")) {
        const [o, u] = a.trim().split("=");
        switch (o) {
          case "max-age":
            i.expires = Date.now() + parseFloat(u) * 1e3 - (s ? parseFloat(s) * 1e3 : 0);
            break;
          case "no-cache":
          case "no-store":
            const l = this.#e.get(r);
            if (l) {
              const h = l.indexOf(i);
              h !== -1 && l.splice(h, 1);
            }
            return null;
          case "must-revalidate":
            i.mustRevalidate = !0;
            break;
          case "stale-while-revalidate":
            i.staleWhileRevalidate = !0;
            break;
        }
      }
    }
    if (n.headers.has("Last-Modified") && (i.lastModified = Date.parse(n.headers.get("Last-Modified"))), n.headers.has("Vary"))
      for (const s of n.headers.get("Vary").split(",")) {
        const a = s.trim(), o = e.headers.get(a);
        o && (i.vary[a] = o);
      }
    if (n.headers.has("ETag") && (i.etag = n.headers.get("ETag")), !i.expires) {
      const s = n.headers.get("Expires");
      s && (i.expires = Date.parse(s));
    }
    if (!i.etag && (!i.expires || i.expires < Date.now())) {
      const s = this.#e.get(r);
      if (s) {
        const a = s.indexOf(i);
        a !== -1 && s.splice(a, 1);
      }
      return null;
    }
    return i;
  }
  /**
   * Clears the cache.
   *
   * @param [options] Options.
   * @param [options.url] URL.
   * @param [options.toTime] Removes all entries that are older than this time. Time in MS.
   */
  clear(e) {
    if (e)
      if (e.toTime)
        for (const n of e.url ? [e.url] : this.#e.keys()) {
          const r = this.#e.get(n);
          if (r)
            for (let i = 0, s = r.length; i < s; i++)
              r[i].cacheUpdateTime < e.toTime && (r.splice(i, 1), i--, s--);
        }
      else e.url && this.#e.delete(e.url);
    else
      this.#e.clear();
  }
}
var Lv;
(function(t) {
  t[t.log = 0] = "log", t[t.info = 1] = "info", t[t.warn = 2] = "warn", t[t.error = 3] = "error";
})(Lv || (Lv = {}));
const $i = Lv;
var Mv;
(function(t) {
  t[t.elementNode = 1] = "elementNode", t[t.attributeNode = 2] = "attributeNode", t[t.textNode = 3] = "textNode", t[t.cdataSectionNode = 4] = "cdataSectionNode", t[t.commentNode = 8] = "commentNode", t[t.documentNode = 9] = "documentNode", t[t.documentTypeNode = 10] = "documentTypeNode", t[t.documentFragmentNode = 11] = "documentFragmentNode", t[t.processingInstructionNode = 7] = "processingInstructionNode";
})(Mv || (Mv = {}));
const le = Mv;
var Ov;
(function(t) {
  t[t.none = 0] = "none", t[t.capturing = 1] = "capturing", t[t.atTarget = 2] = "atTarget", t[t.bubbling = 3] = "bubbling";
})(Ov || (Ov = {}));
const mr = Ov;
let be = class Wm {
  static NONE = mr.none;
  static CAPTURING_PHASE = mr.capturing;
  static AT_TARGET = mr.atTarget;
  static BUBBLING_PHASE = mr.bubbling;
  NONE = Wm.NONE;
  CAPTURING_PHASE = Wm.CAPTURING_PHASE;
  AT_TARGET = Wm.AT_TARGET;
  BUBBLING_PHASE = Wm.BUBBLING_PHASE;
  [sb] = !1;
  [Md] = !1;
  [hh] = !1;
  [vo] = !1;
  [ia] = mr.none;
  [vL] = performance.now();
  [qn];
  [mg] = !1;
  [Dd] = !1;
  [qd] = !1;
  [Ma] = null;
  [tu] = null;
  [L1] = !1;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    this[qn] = e, this[Md] = n?.bubbles ?? !1, this[hh] = n?.cancelable ?? !1, this[sb] = n?.composed ?? !1;
  }
  /**
   * Returns composed.
   *
   * @returns Composed.
   */
  get composed() {
    return this[sb];
  }
  /**
   * Returns bubbles.
   *
   * @returns Bubbles.
   */
  get bubbles() {
    return this[Md];
  }
  /**
   * Returns cancelable.
   *
   * @returns Cancelable.
   */
  get cancelable() {
    return this[hh];
  }
  /**
   * Returns defaultPrevented.
   *
   * @returns Default prevented.
   */
  get defaultPrevented() {
    return this[vo];
  }
  /**
   * Returns eventPhase.
   *
   * @returns Event phase.
   */
  get eventPhase() {
    return this[ia];
  }
  /**
   * Returns timeStamp.
   *
   * @returns Time stamp.
   */
  get timeStamp() {
    return this[vL];
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this[qn];
  }
  /**
   * Returns target.
   *
   * @returns Target.
   */
  get target() {
    return this[Ma];
  }
  /**
   * Returns target.
   *
   * @returns Target.
   */
  get currentTarget() {
    return this[tu];
  }
  /**
   * Returns "true" if propagation has been stopped.
   *
   * @returns "true" if propagation has been stopped.
   */
  get cancelBubble() {
    return this[qd];
  }
  /**
   * Returns composed path.
   *
   * @returns Composed path.
   */
  composedPath() {
    if (!this[Ma])
      return [];
    const e = [];
    let n = this[Ma];
    for (; n; )
      if (e.push(n), n.parentNode)
        n = n.parentNode;
      else if (this[sb] && n[ve] === le.documentFragmentNode && n.host)
        n = n.host;
      else if (n[ve] === le.documentNode && // The "load" event is a special case. It should not bubble up to the window.
      this[qn] !== "load")
        n = n[b];
      else
        break;
    return e;
  }
  /**
   * Init event.
   *
   * @deprecated
   * @param type Type.
   * @param [bubbles=false] "true" if it bubbles.
   * @param [cancelable=false] "true" if it cancelable.
   */
  initEvent(e, n = !1, r = !1) {
    this[qn] = e, this[Md] = n, this[hh] = r;
  }
  /**
   * Prevents default.
   */
  preventDefault() {
    !this[L1] && this.cancelable && (this[vo] = !0);
  }
  /**
   * Stops immediate propagation.
   */
  stopImmediatePropagation() {
    this[Dd] = !0;
  }
  /**
   * Stops propagation.
   */
  stopPropagation() {
    this[qd] = !0;
  }
};
var Bv;
(function(t) {
  t.log = "log", t.table = "table", t.trace = "trace", t.dir = "dir", t.dirxml = "dirxml", t.group = "group", t.groupCollapsed = "groupCollapsed", t.debug = "debug", t.timeLog = "timeLog", t.info = "info", t.count = "count", t.timeEnd = "timeEnd", t.warn = "warn", t.countReset = "countReset", t.error = "error", t.assert = "assert";
})(Bv || (Bv = {}));
const Hr = Bv;
class Y8e {
  /**
   * Stringifies a log entry.
   *
   * @param logEntry Log entry.
   * @returns Stringified message.
   */
  static toString(e) {
    if (this.isLogEntryCollapsed(e))
      return "";
    const n = this.getLogEntryGroupTabbing(e);
    let r = n;
    for (const i of e.message)
      if (r += r !== "" && r !== n ? " " : "", typeof i == "object" && (i === null || i.constructor.name === "Object" || Array.isArray(i)))
        try {
          r += JSON.stringify(i);
        } catch {
          r += new Error("Failed to JSON stringify object in log entry.").stack.replace(/\n    at/gm, `
    ` + n + "at");
        }
      else typeof i == "object" && i.message && i.stack ? r += i.stack.replace(/\n    at/gm, `
    ` + n + "at") : r += this.getLogEntryIcon(e) + String(i);
    return r + `
`;
  }
  /**
   * Gets the log entry icon.
   *
   * @param logEntry Log entry.
   * @returns Icon.
   */
  static getLogEntryIcon(e) {
    switch (e.type) {
      case Hr.group:
        return "▼ ";
      case Hr.groupCollapsed:
        return "▶ ";
    }
    return "";
  }
  /**
   * Gets the log entry group tabbing.
   *
   * @param logEntry Log entry.
   * @returns Tabbing.
   */
  static getLogEntryGroupTabbing(e) {
    let n = "", r = e.type === Hr.group || e.type === Hr.groupCollapsed ? e.group?.parent : e.group;
    for (; r; )
      n += "  ", r = r.parent;
    return n;
  }
  /**
   * Checks if the log entry content is collapsed.
   *
   * @param logEntry Log entry.
   * @returns True if collapsed.
   */
  static isLogEntryCollapsed(e) {
    let n = e.type === Hr.group || e.type === Hr.groupCollapsed ? e.group?.parent : e.group;
    for (; n; ) {
      if (n.collapsed)
        return !0;
      n = n.parent;
    }
    return !1;
  }
}
class q8e {
  #e = [];
  #t = { print: [], clear: [] };
  #n = !1;
  /**
   * Returns closed state.
   *
   * @returns True if the printer is closed.
   */
  get closed() {
    return this.#n;
  }
  /**
   * Writes to the output.
   *
   * @param logEntry Log entry.
   */
  print(e) {
    this.#n || (this.#e.push(e), this.dispatchEvent(new be("print")));
  }
  /**
   * Clears the output.
   */
  clear() {
    this.#n || (this.#e = [], this.dispatchEvent(new be("clear")));
  }
  /**
   * Clears and closes the virtual console printer.
   */
  close() {
    this.#n || (this.#e = [], this.#t = { print: [], clear: [] }, this.#n = !0);
  }
  /**
   * Adds an event listener.
   *
   * @param eventType Event type ("print" or "clear").
   * @param listener Listener.
   */
  addEventListener(e, n) {
    if (!this.#n) {
      if (!this.#t[e])
        throw new Error(`Event type "${e}" is not supported.`);
      this.#t[e].push(n);
    }
  }
  /**
   * Removes an event listener.
   *
   * @param eventType Event type ("print" or "clear").
   * @param listener Listener.
   */
  removeEventListener(e, n) {
    if (this.#n)
      return;
    if (!this.#t[e])
      throw new Error(`Event type "${e}" is not supported.`);
    const r = this.#t[e].indexOf(n);
    r !== -1 && this.#t[e].splice(r, 1);
  }
  /**
   * Dispatches an event.
   *
   * @param event Event.
   */
  dispatchEvent(e) {
    if (!this.#n)
      switch (e.type) {
        case "print":
        case "clear":
          for (const n of this.#t[e.type])
            n(e);
          break;
        default:
          throw new Error(`Event type "${e.type}" is not supported.`);
      }
  }
  /**
   * Reads the buffer.
   *
   * @returns Console log entries.
   */
  read() {
    const e = this.#e;
    return this.#e = [], e;
  }
  /**
   * Returns the buffer as a string.
   *
   * @param [logLevel] Log level.
   * @returns Buffer as a string of concatenated log entries.
   */
  readAsString(e = $i.log) {
    const n = this.read();
    let r = "";
    for (const i of n)
      i.level >= e && (r += Y8e.toString(i));
    return r;
  }
}
class BF extends Error {
  /**
   * Constructor.
   *
   * @param message Message.
   */
  constructor(e) {
    super(e), this.name = "AsyncTaskManagerDebugError";
  }
}
const Cs = {
  setTimeout: globalThis.setTimeout.bind(globalThis),
  clearTimeout: globalThis.clearTimeout.bind(globalThis),
  clearImmediate: globalThis.clearImmediate.bind(globalThis)
};
class $2 {
  static taskID = 0;
  runningTasks = {};
  runningTaskCount = 0;
  runningTimers = [];
  runningImmediates = [];
  debugTrace = /* @__PURE__ */ new Map();
  waitUntilCompleteTimer = null;
  waitUntilCompleteResolvers = [];
  destroyed = !1;
  #e = null;
  #t;
  /**
   * Constructor.
   *
   * @param browserFrame Browser frame.
   */
  constructor(e) {
    this.#t = e;
  }
  /**
   * Returns a promise that is resolved when async tasks are complete.
   *
   * @returns Promise.
   */
  waitUntilComplete() {
    return new Promise((e, n) => {
      this.waitUntilCompleteResolvers.push({ resolve: e, reject: n }), this.resolveWhenComplete();
    });
  }
  /**
   * Aborts all tasks.
   */
  abort() {
    return this.destroyed ? new Promise((e, n) => {
      this.waitUntilCompleteResolvers.push({ resolve: e, reject: n }), this.resolveWhenComplete();
    }) : this.abortAll(!1);
  }
  /**
   * Destroys the manager.
   */
  destroy() {
    return this.destroyed ? new Promise((e, n) => {
      this.waitUntilCompleteResolvers.push({ resolve: e, reject: n }), this.resolveWhenComplete();
    }) : this.abortAll(!0);
  }
  /**
   * Starts a timer.
   *
   * @param timerID Timer ID.
   */
  startTimer(e) {
    if (this.destroyed) {
      Cs.clearTimeout(e);
      return;
    }
    this.waitUntilCompleteTimer && (Cs.clearTimeout(this.waitUntilCompleteTimer), this.waitUntilCompleteTimer = null), this.runningTimers.push(e), this.#t.page.context.browser.settings.debug.traceWaitUntilComplete > 0 && this.debugTrace.set(e, new BF().stack);
  }
  /**
   * Ends a timer.
   *
   * @param timerID Timer ID.
   */
  endTimer(e) {
    if (this.destroyed) {
      Cs.clearTimeout(e);
      return;
    }
    const n = this.runningTimers.indexOf(e);
    n !== -1 && (this.runningTimers.splice(n, 1), this.resolveWhenComplete()), this.#t.page.context.browser.settings.debug.traceWaitUntilComplete > 0 && this.debugTrace.delete(e);
  }
  /**
   * Starts an immediate.
   *
   * @param immediateID Immediate ID.
   */
  startImmediate(e) {
    if (this.destroyed) {
      Cs.clearImmediate(e);
      return;
    }
    this.waitUntilCompleteTimer && (Cs.clearTimeout(this.waitUntilCompleteTimer), this.waitUntilCompleteTimer = null), this.runningImmediates.push(e), this.#t.page?.context?.browser?.settings?.debug?.traceWaitUntilComplete > 0 && this.debugTrace.set(e, new BF().stack);
  }
  /**
   * Ends an immediate.
   *
   * @param immediateID Immediate ID.
   */
  endImmediate(e) {
    if (this.destroyed) {
      Cs.clearImmediate(e);
      return;
    }
    const n = this.runningImmediates.indexOf(e);
    n !== -1 && (this.runningImmediates.splice(n, 1), this.resolveWhenComplete()), this.#t.page.context.browser.settings.debug.traceWaitUntilComplete > 0 && this.debugTrace.delete(e);
  }
  /**
   * Starts an async task.
   *
   * @param abortHandler Abort handler.
   * @returns Task ID.
   */
  startTask(e) {
    if (this.destroyed)
      throw e && e(this.destroyed), new this.#t.window.Error("Failed to execute 'startTask()' on 'AsyncTaskManager': The asynchronous task manager has been destroyed. This error can be thrown if scripts continue to run while a browser frame is closed.");
    this.waitUntilCompleteTimer && (Cs.clearTimeout(this.waitUntilCompleteTimer), this.waitUntilCompleteTimer = null);
    const n = this.newTaskID();
    return this.runningTasks[n] = e || (() => {
    }), this.runningTaskCount++, this.#t.page.context.browser.settings.debug.traceWaitUntilComplete > 0 && this.debugTrace.set(n, new BF().stack), n;
  }
  /**
   * Ends an async task.
   *
   * @param taskID Task ID.
   */
  endTask(e) {
    this.destroyed || (this.runningTasks[e] && (delete this.runningTasks[e], this.runningTaskCount--, this.resolveWhenComplete()), this.#t.page.context.browser.settings.debug.traceWaitUntilComplete > 0 && this.debugTrace.delete(e));
  }
  /**
   * Returns the amount of running tasks.
   *
   * @returns Count.
   */
  getTaskCount() {
    return this.runningTaskCount;
  }
  /**
   * Returns a new task ID.
   *
   * @returns Task ID.
   */
  newTaskID() {
    return this.constructor.taskID++, this.constructor.taskID;
  }
  /**
   * Resolves when complete.
   */
  resolveWhenComplete() {
    this.applyDebugging(), !(this.runningTaskCount || this.runningTimers.length || this.runningImmediates.length) && (this.waitUntilCompleteTimer && (Cs.clearTimeout(this.waitUntilCompleteTimer), this.waitUntilCompleteTimer = null), this.waitUntilCompleteTimer = Cs.setTimeout(() => {
      if (this.waitUntilCompleteTimer = null, !this.runningTaskCount && !this.runningTimers.length && !this.runningImmediates.length) {
        this.#e && Cs.clearTimeout(this.#e);
        const e = this.waitUntilCompleteResolvers;
        this.waitUntilCompleteResolvers = [];
        for (const n of e)
          n.resolve();
        this.destroyed = !1;
      } else
        this.applyDebugging();
    }, 1));
  }
  /**
   * Applies debugging.
   */
  applyDebugging() {
    const e = this.#t.page.context.browser.settings.debug;
    !e?.traceWaitUntilComplete || e.traceWaitUntilComplete < 1 || this.#e || (this.#e = Cs.setTimeout(() => {
      this.#e = null;
      let n = `The maximum time was reached for "waitUntilComplete()".

${this.debugTrace.size} task${this.debugTrace.size === 1 ? "" : "s"} did not end in time.

The following traces were recorded:

`, r = 1;
      for (const [s, a] of this.debugTrace.entries())
        n += `${typeof s == "number" ? "Task" : "Timer"} #${r}
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾${a.replace(/AsyncTaskManagerDebugError:{0,1}/, "").replace(/\s+at /gm, `
> `)}

`, r++;
      const i = new Error(n);
      for (const s of this.waitUntilCompleteResolvers)
        s.reject(i);
      this.abortAll(!0);
    }, e.traceWaitUntilComplete));
  }
  /**
   * Aborts all tasks.
   *
   * @param destroy Destroy.
   */
  abortAll(e) {
    const n = this.runningTimers, r = this.runningImmediates, i = this.runningTasks;
    e && (this.destroyed = !0), this.runningTasks = {}, this.runningTaskCount = 0, this.runningImmediates = [], this.runningTimers = [], this.debugTrace = /* @__PURE__ */ new Map(), this.waitUntilCompleteTimer && (Cs.clearTimeout(this.waitUntilCompleteTimer), this.waitUntilCompleteTimer = null);
    for (const s of r)
      Cs.clearImmediate(s);
    for (const s of n)
      Cs.clearTimeout(s);
    for (const s of Object.keys(i))
      i[s](e);
    return new Promise((s, a) => {
      this.waitUntilCompleteResolvers.push({ resolve: s, reject: a }), this.resolveWhenComplete();
    });
  }
}
const IL = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
class RL {
  /**
   * Creates a Base64-encoded ASCII string from a binary string (i.e., a string in which each character in the string is treated as a byte of binary data).
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/btoa
   * @param data Binay data.
   * @returns Base64-encoded string.
   */
  static btoa(e) {
    const n = e.toString();
    if (/[^\u0000-\u00ff]/.test(n))
      throw new Tr("Failed to execute 'btoa' on 'Window': The string to be encoded contains characters outside of the Latin1 range.", ne.invalidCharacterError);
    let r = "", i = -6, s = 0, a = 0, o = 0, u;
    for (; a < n.length || i > -6; )
      i < 0 && (a < n.length ? (u = n.charCodeAt(a++), o += 8) : u = 0, s = (s & 255) << 8 | u & 255, i += 8), r += IL.charAt(o > 0 ? s >> i & 63 : 64), i -= 6, o -= 6;
    return r;
  }
  /**
   * Decodes a string of data which has been encoded using Base64 encoding.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/atob
   * @see https://infra.spec.whatwg.org/#forgiving-base64-encode.
   * @see Https://html.spec.whatwg.org/multipage/webappapis.html#btoa.
   * @param data Binay string.
   * @returns An ASCII string containing decoded data from encodedData.
   */
  static atob(e) {
    const n = e.toString();
    if (/[^\u0000-\u00ff]/.test(n))
      throw new Tr("Failed to execute 'atob' on 'Window': The string to be decoded contains characters outside of the Latin1 range.", ne.invalidCharacterError);
    if (/[^A-Za-z\d+/=]/.test(n) || n.length % 4 == 1)
      throw new Tr("Failed to execute 'atob' on 'Window': The string to be decoded is not correctly encoded.", ne.invalidCharacterError);
    let r = "", i = -8, s = 0, a, o;
    for (let u = 0; u < n.length; u++)
      (a = IL.indexOf(n.charAt(u))) < 0 || (s = s << 6 | a & 63, (i += 6) >= 0 && (o = s >> i & 255, a !== 64 && (r += String.fromCharCode(o)), s &= 63, i -= 8));
    return r;
  }
}
var $v;
(function(t) {
  t.tryAndCatch = "tryAndCatch", t.processLevel = "processLevel", t.disabled = "disabled";
})($v || ($v = {}));
const Rr = $v;
let Di = class Hv {
  type = "";
  [En];
  /**
   * Constructor.
   *
   * @param [bits] Bits.
   * @param [options] Options.
   * @param [options.type] MIME type.
   */
  constructor(e, n) {
    const r = [];
    if (e)
      for (const i of e) {
        let s;
        i instanceof ArrayBuffer ? s = nr.from(new Uint8Array(i)) : i instanceof Hv ? s = i[En] : i instanceof nr ? s = i : ArrayBuffer.isView(i) ? s = nr.from(new Uint8Array(i.buffer, i.byteOffset, i.byteLength)) : s = nr.from(typeof i == "string" ? i : String(i)), r.push(s);
      }
    this[En] = nr.concat(r), n && n.type && n.type.match(/^[\u0020-\u007E]*$/) && (this.type = String(n.type).toLowerCase());
  }
  /**
   * Returns size.
   *
   * @returns Size.
   */
  get size() {
    return this[En].length;
  }
  /**
   * Slices the blob.
   *
   * @param start Start.
   * @param end End.
   * @param contentType Content type.
   * @returns New Blob.
   */
  slice(e = 0, n = null, r = "") {
    const i = this.size;
    let s, a, o;
    e === void 0 ? s = 0 : e < 0 ? s = Math.max(i + e, 0) : s = Math.min(e, i), n === null ? a = i : n < 0 ? a = Math.max(i + n, 0) : a = Math.min(n, i), r === void 0 ? o = "" : o = r;
    const u = Math.max(a - s, 0), h = this[En].slice(s, s + u), f = new Hv([], { type: o });
    return f[En] = h, f;
  }
  /**
   * Returns a Promise that resolves to a ArrayBuffer.
   *
   * @returns ArrayBuffer.
   */
  // Reference:
  // https://github.com/web-std/io/blob/c88170bf24f064adfbb3586a21fb76650ca5a9ab/packages/blob/src/blob.js#L139-L148
  // https://stackoverflow.com/questions/8609289/convert-a-binary-nodejs-buffer-to-javascript-arraybuffer
  /**
   *
   */
  async arrayBuffer() {
    return new Uint8Array(this[En]).buffer;
  }
  /**
   * Returns a Promise that resolves to a text.
   *
   * @returns Text.
   */
  async text() {
    return this[En].toString();
  }
  /**
   * Returns returns a ReadableStream which upon reading returns the data contained within the Blob.
   *
   * @returns ReadableStream
   */
  stream() {
    const e = this[En];
    return new sh({
      start(n) {
        n.enqueue(e), n.close();
      }
    });
  }
  /**
   * Returns the object converted to string.
   *
   * @returns String.
   */
  toString() {
    return "[object Blob]";
  }
};
class $7 {
  #e;
  #t = [];
  /**
   * Constructor.
   *
   * @param window Owner window.
   */
  constructor(e) {
    if (!e)
      throw new TypeError("Illegal constructor");
    this.#e = e;
  }
  /**
   * Returns data.
   *
   * @returns Data.
   */
  async read() {
    if ((await this.#e.navigator.permissions.query({
      name: "clipboard-read"
    })).state === "denied")
      throw new this.#e.DOMException("Failed to execute 'read' on 'Clipboard': The request is not allowed");
    return this.#t;
  }
  /**
   * Returns text.
   *
   * @returns Text.
   */
  async readText() {
    if ((await this.#e.navigator.permissions.query({
      name: "clipboard-read"
    })).state === "denied")
      throw new this.#e.DOMException("Failed to execute 'readText' on 'Clipboard': The request is not allowed");
    let n = "";
    for (const r of this.#t)
      if (r.types.includes("text/plain")) {
        const i = await r.getType("text/plain");
        typeof i == "string" ? n += i : n += await i.text();
      }
    return n;
  }
  /**
   * Writes data.
   *
   * @param data Data.
   */
  async write(e) {
    if ((await this.#e.navigator.permissions.query({
      name: "clipboard-write"
    })).state === "denied")
      throw new this.#e.DOMException("Failed to execute 'write' on 'Clipboard': The request is not allowed");
    this.#t = e;
  }
  /**
   * Writes text.
   *
   * @param text Text.
   */
  async writeText(e) {
    if ((await this.#e.navigator.permissions.query({
      name: "clipboard-write"
    })).state === "denied")
      throw new this.#e.DOMException("Failed to execute 'writeText' on 'Clipboard': The request is not allowed");
    this.#t = [
      new this.#e.ClipboardItem({ "text/plain": new Di([e], { type: "text/plain" }) })
    ];
  }
}
class J8e {
  presentationStyle = "unspecified";
  #e;
  /**
   * Constructor.
   *
   * @param data Data.
   * @param [options] Options.
   * @param [options.presentationStyle] Presentation style.
   */
  constructor(e, n) {
    this.#e = e, n?.presentationStyle && (this.presentationStyle = n.presentationStyle);
  }
  /**
   * Returns types.
   *
   * @returns Types.
   */
  get types() {
    return Object.keys(this.#e);
  }
  /**
   * Returns data by type.
   *
   * @param type Type.
   * @returns Data.
   */
  async getType(e) {
    if (!this.#e[e])
      throw new Tr(`Failed to execute 'getType' on 'ClipboardItem': The type '${e}' was not found`);
    return this.#e[e] instanceof Di ? this.#e[e] : new Di([await this.#e[e]], { type: e });
  }
}
class Q8e {
  /**
   * Escapes CSS.
   *
   * Based on:
   * https://github.com/mathiasbynens/CSS.escape
   *
   * @param cssText CSS.
   * @returns Escaped CSS.
   */
  static escape(e) {
    if (arguments.length == 0)
      throw new TypeError("`CSS.escape` requires an argument.");
    const n = String(e), r = n.length;
    let i = -1, s, a = "";
    const o = n.charCodeAt(0);
    if (
      // If the character is the first character and is a `-` (U+002D), and
      // There is no second character, […]
      r == 1 && o == 45
    )
      return "\\" + n;
    for (; ++i < r; ) {
      if (s = n.charCodeAt(i), s == 0) {
        a += "�";
        continue;
      }
      if (
        // If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
        // U+007F, […]
        s >= 1 && s <= 31 || s == 127 || // If the character is the first character and is in the range [0-9]
        // (U+0030 to U+0039), […]
        i == 0 && s >= 48 && s <= 57 || // If the character is the second character and is in the range [0-9]
        // (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
        i == 1 && s >= 48 && s <= 57 && o == 45
      ) {
        a += "\\" + s.toString(16) + " ";
        continue;
      }
      if (s >= 128 || s == 45 || s == 95 || s >= 48 && s <= 57 || s >= 65 && s <= 90 || s >= 97 && s <= 122) {
        a += n.charAt(i);
        continue;
      }
      a += "\\" + n.charAt(i);
    }
    return a;
  }
}
const X8e = [
  "Hz",
  "Q",
  "ch",
  "cm",
  "deg",
  "dpcm",
  "dpi",
  "dppx",
  "em",
  "ex",
  "fr",
  "grad",
  "in",
  "kHz",
  "mm",
  "ms",
  "number",
  "pc",
  "percent",
  "pt",
  "px",
  "rad",
  "rem",
  "s",
  "turn",
  "vh",
  "vmax",
  "vmin",
  "vw"
];
class On {
  unit;
  value;
  /**
   * Constructor.
   *
   * @param value Value.
   * @param unit Unit.
   */
  constructor(e, n) {
    if (typeof e != "number")
      throw new TypeError("The provided double value is non-finite");
    if (!X8e.includes(n))
      throw new TypeError("Invalid unit: " + n);
    this.value = e, this.unit = n;
  }
}
class Z8e {
  Hz = (e) => new On(e, "Hz");
  Q = (e) => new On(e, "Q");
  ch = (e) => new On(e, "ch");
  cm = (e) => new On(e, "cm");
  deg = (e) => new On(e, "deg");
  dpcm = (e) => new On(e, "dpcm");
  dpi = (e) => new On(e, "dpi");
  dppx = (e) => new On(e, "dppx");
  em = (e) => new On(e, "em");
  ex = (e) => new On(e, "ex");
  fr = (e) => new On(e, "fr");
  grad = (e) => new On(e, "grad");
  in = (e) => new On(e, "in");
  kHz = (e) => new On(e, "kHz");
  mm = (e) => new On(e, "mm");
  ms = (e) => new On(e, "ms");
  number = (e) => new On(e, "number");
  pc = (e) => new On(e, "pc");
  percent = (e) => new On(e, "percent");
  pt = (e) => new On(e, "pt");
  px = (e) => new On(e, "px");
  rad = (e) => new On(e, "rad");
  rem = (e) => new On(e, "rem");
  s = (e) => new On(e, "s");
  turn = (e) => new On(e, "turn");
  vh = (e) => new On(e, "vh");
  vmax = (e) => new On(e, "vmax");
  vmin = (e) => new On(e, "vmin");
  vw = (e) => new On(e, "vw");
  /**
   * Returns a Boolean indicating if the pair property-value, or the condition, given in parameter is supported.
   *
   * TODO: Always returns "true" for now, but it should probably be improved in the future.
   *
   * @param _condition Property name or condition.
   * @param [_value] Value when using property name.
   * @returns "true" if supported.
   */
  supports(e, n) {
    return !0;
  }
  /**
   * Escapes a value.
   *
   * @param value Value to escape.
   * @returns Escaped string.
   */
  escape(e) {
    return Q8e.escape(e);
  }
}
var Uv;
(function(t) {
  t[t.containerRule = 0] = "containerRule", t[t.styleRule = 1] = "styleRule", t[t.importRule = 3] = "importRule", t[t.mediaRule = 4] = "mediaRule", t[t.fontFaceRule = 5] = "fontFaceRule", t[t.pageRule = 6] = "pageRule", t[t.keyframesRule = 7] = "keyframesRule", t[t.keyframeRule = 8] = "keyframeRule", t[t.namespaceRule = 10] = "namespaceRule", t[t.counterStyleRule = 11] = "counterStyleRule", t[t.supportsRule = 12] = "supportsRule", t[t.documentRule = 13] = "documentRule", t[t.fontFeatureValuesRule = 14] = "fontFeatureValuesRule", t[t.regionStyleRule = 16] = "regionStyleRule";
})(Uv || (Uv = {}));
const at = Uv;
class bp {
  // Static properties
  static CONTAINER_RULE = at.containerRule;
  static STYLE_RULE = at.styleRule;
  static IMPORT_RULE = at.importRule;
  static MEDIA_RULE = at.mediaRule;
  static FONT_FACE_RULE = at.fontFaceRule;
  static PAGE_RULE = at.pageRule;
  static KEYFRAMES_RULE = at.keyframesRule;
  static KEYFRAME_RULE = at.keyframeRule;
  static NAMESPACE_RULE = at.namespaceRule;
  static COUNTER_STYLE_RULE = at.counterStyleRule;
  static SUPPORTS_RULE = at.supportsRule;
  static DOCUMENT_RULE = at.documentRule;
  static FONT_FEATURE_VALUES_RULE = at.fontFeatureValuesRule;
  static REGION_STYLE_RULE = at.regionStyleRule;
  // Internal properties
  [b];
  [U1];
  // Public properties
  [tf] = null;
  [Ta] = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param cssParser CSS parser.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[U1] = r;
  }
  /**
   * Returns parent rule.
   *
   * @returns Parent rule.
   */
  get parentRule() {
    return this[tf];
  }
  /**
   * Returns parent style sheet.
   *
   * @returns Parent style sheet.
   */
  get parentStyleSheet() {
    return this[Ta];
  }
}
const e5e = /^#([0-9a-fA-F]{3,4}){1,2}$|^rgb\(([^)]*)\)$|^rgba\(([^)]*)\)$|^hsla?\(\s*(-?\d+|-?\d*.\d+)\s*,\s*(-?\d+|-?\d*.\d+)%\s*,\s*(-?\d+|-?\d*.\d+)%\s*(,\s*(-?\d+|-?\d*.\d+)\s*)?\)|(?:(rgba?|hsla?)\((var\(\s*(--[^)\s]+)\))\))/, t5e = /^(0|[-+]?[0-9]*\.?[0-9]+)(in|cm|em|mm|pt|pc|px|ex|rem|vh|vw|ch|vw|vh|vmin|vmax|Q)$/, n5e = /^[-+]?[0-9]*\.?[0-9]+%$/, r5e = /^[0-9]+deg$/, i5e = /^url\(\s*([^)]*)\s*\)$/, s5e = /^[0-9]+$/, a5e = /^[0-9.]+$/, o5e = /^calc\([^^)]+\)$/, u5e = /^var\(\s*(--[^)\s]+)\)$/, l5e = /^fit-content\([^^)]+\)$/, c5e = /^((repeating-linear|linear|radial|repeating-radial|conic|repeating-conic)-gradient)\(([^)]+)\)$/, PL = ["inherit", "initial", "unset", "revert"], h5e = [
  "none",
  "currentcolor",
  "transparent",
  "silver",
  "gray",
  "white",
  "maroon",
  "red",
  "purple",
  "fuchsia",
  "green",
  "lime",
  "olive",
  "yellow",
  "navy",
  "blue",
  "teal",
  "aliceblue",
  "aqua",
  "antiquewhite",
  "aquamarine",
  "azure",
  "beige",
  "bisque",
  "black",
  "blanchedalmond",
  "blueviolet",
  "brown",
  "burlywood",
  "cadetblue",
  "chartreuse",
  "chocolate",
  "coral",
  "cornflowerblue",
  "cornsilk",
  "crimson",
  "cyan",
  "darkblue",
  "darkcyan",
  "darkgoldenrod",
  "darkgray",
  "darkgreen",
  "darkgrey",
  "darkkhaki",
  "darkmagenta",
  "darkolivegreen",
  "darkorange",
  "darkorchid",
  "darkred",
  "darksalmon",
  "darkseagreen",
  "darkslateblue",
  "darkslategray",
  "darkslategrey",
  "darkturquoise",
  "darkviolet",
  "deeppink",
  "deepskyblue",
  "dimgray",
  "dimgrey",
  "dodgerblue",
  "firebrick",
  "floralwhite",
  "forestgreen",
  "gainsboro",
  "ghostwhite",
  "gold",
  "goldenrod",
  "greenyellow",
  "grey",
  "honeydew",
  "hotpink",
  "indianred",
  "indigo",
  "ivory",
  "khaki",
  "lavender",
  "lavenderblush",
  "lawngreen",
  "lemonchiffon",
  "lightblue",
  "lightcoral",
  "lightcyan",
  "lightgoldenrodyellow",
  "lightgray",
  "lightgreen",
  "lightgrey",
  "lightpink",
  "lightsalmon",
  "lightseagreen",
  "lightskyblue",
  "lightslategray",
  "lightslategrey",
  "lightsteelblue",
  "lightyellow",
  "limegreen",
  "linen",
  "magenta",
  "mediumaquamarine",
  "mediumblue",
  "mediumorchid",
  "mediumpurple",
  "mediumseagreen",
  "mediumslateblue",
  "mediumspringgreen",
  "mediumturquoise",
  "mediumvioletred",
  "midnightblue",
  "mintcream",
  "mistyrose",
  "moccasin",
  "navajowhite",
  "oldlace",
  "olivedrab",
  "orange",
  "orangered",
  "orchid",
  "palegoldenrod",
  "palegreen",
  "paleturquoise",
  "palevioletred",
  "papayawhip",
  "peachpuff",
  "peru",
  "pink",
  "plum",
  "powderblue",
  "rebeccapurple",
  "rosybrown",
  "royalblue",
  "saddlebrown",
  "salmon",
  "sandybrown",
  "seagreen",
  "seashell",
  "sienna",
  "skyblue",
  "slateblue",
  "slategray",
  "slategrey",
  "snow",
  "springgreen",
  "steelblue",
  "tan",
  "thistle",
  "tomato",
  "turquoise",
  "violet",
  "wheat",
  "whitesmoke",
  "yellowgreen"
];
class M {
  /**
   * Returns length.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getLength(e) {
    if (e === "0")
      return "0px";
    const n = e.match(t5e);
    if (n) {
      const r = parseFloat(n[1]);
      if (isNaN(r))
        return null;
      const i = n[2];
      return `${Math.round(r * 1e6) / 1e6}${i}`;
    }
    return null;
  }
  /**
   * Returns percentance.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getPercentage(e) {
    return e === "0" ? "0%" : n5e.test(e) ? e : null;
  }
  /**
   * Returns degree.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getDegree(e) {
    return e === "0" ? "0deg" : r5e.test(e) ? e : null;
  }
  /**
   * Returns calc.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getCalc(e) {
    return o5e.test(e) ? e : null;
  }
  /**
   * Returns fit content.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getFitContent(e) {
    const n = e.toLowerCase();
    return n === "auto" || n === "max-content" || n === "min-content" || n === "fit-content" || l5e.test(n) ? n : null;
  }
  /**
   * Returns measurement.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getMeasurement(e) {
    return this.getLength(e) || this.getPercentage(e) || this.getCalc(e);
  }
  /**
   * Returns measurement or auto, min-content, max-content or fit-content.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getContentMeasurement(e) {
    return this.getFitContent(e) || this.getMeasurement(e);
  }
  /**
   * Returns measurement or auto, min-content, max-content or fit-content.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getAutoMeasurement(e) {
    return e.toLocaleLowerCase() === "auto" ? "auto" : this.getMeasurement(e);
  }
  /**
   * Returns integer.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getInteger(e) {
    return s5e.test(e) ? e : null;
  }
  /**
   * Returns float.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getFloat(e) {
    if (a5e.test(e)) {
      const n = parseFloat(e);
      return isNaN(n) ? null : String(Math.round(n * 1e6) / 1e6);
    }
    return null;
  }
  /**
   * Returns gradient.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getGradient(e) {
    const n = e.match(c5e);
    return n ? `${n[1]}(${n[3].trim().split(/\s*,\s*/).join(", ")})` : null;
  }
  /**
   * Returns color.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getColor(e) {
    const n = e.toLowerCase();
    return h5e.includes(n) ? n : e5e.test(e) ? e.replace(/,([^ ])/g, ", $1") : null;
  }
  /**
   * Returns URL.
   *
   * Based on:
   * https://github.com/jsdom/cssstyle/blob/master/lib/parsers.js#L222
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getURL(e) {
    if (!e)
      return null;
    if (e.toLowerCase() === "none")
      return "none";
    const n = i5e.exec(e);
    if (!n)
      return null;
    let r = n[1].trim();
    if ((r[0] === '"' || r[0] === "'") && r[0] !== r[r.length - 1])
      return null;
    (r[0] === '"' || r[0] === "'") && (r = r.substring(1, r.length - 1));
    for (let i = 0; i < r.length; i++)
      switch (r[i]) {
        case "(":
        case ")":
        case " ":
        case "	":
        case `
`:
        case "'":
        case '"':
          return null;
        case "\\":
          i++;
          break;
      }
    return `url("${r}")`;
  }
  /**
   * Returns global initial value.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getInitial(e) {
    return e.toLowerCase() === "initial" ? "initial" : null;
  }
  /**
   * Returns CSS variable.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getVariable(e) {
    const n = e.match(u5e);
    return n ? `var(${n[1]})` : null;
  }
  /**
   * Returns global.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getGlobal(e) {
    const n = e.toLowerCase();
    return PL.includes(n) ? n : null;
  }
  /**
   * Returns global, unless it is not set to 'initial' as it is sometimes treated different.
   *
   * @param value Value.
   * @returns Parsed value.
   */
  static getGlobalExceptInitial(e) {
    const n = e.toLowerCase();
    return n !== "initial" && PL.includes(n) ? n : null;
  }
}
const d5e = /^rect\((.*)\)$/i, Am = /,(?=(?:(?:(?!\))[\s\S])*\()|[^\(\)]*$)/, _r = /\s+(?=(?:(?:(?!\))[\s\S])*\()|[^\(\)]*$)/, f5e = /\s+/gm, Em = [
  "none",
  "hidden",
  "dotted",
  "dashed",
  "solid",
  "double",
  "groove",
  "ridge",
  "inset",
  "outset"
], Sm = ["thin", "medium", "thick"], m5e = ["separate", "collapse"], g5e = ["repeat", "repeat-x", "repeat-y", "no-repeat"], p5e = ["border-box", "padding-box", "content-box"], b5e = ["border-box", "padding-box", "content-box"], y5e = ["scroll", "fixed"], A5e = ["auto", "fill", "content"], E5e = ["none", "left", "right", "both"], S5e = ["none", "left", "right", "inline-start", "inline-end"], w5e = ["caption", "icon", "menu", "message-box", "small-caption", "status-bar"], F5e = ["normal", "bold", "bolder", "lighter"], T5e = ["normal", "italic", "oblique"], v5e = [
  "xx-small",
  "x-small",
  "small",
  "medium",
  "large",
  "x-large",
  "xx-large",
  "xxx-large",
  "smaller",
  "larger"
], x5e = [
  "ultra-condensed",
  "extra-condensed",
  "condensed",
  "semi-condensed",
  "normal",
  "semi-expanded",
  "expanded",
  "extra-expanded",
  "ultra-expanded"
], C5e = [
  /* Legacy values */
  "block",
  "inline",
  "inline-block",
  "flex",
  "inline-flex",
  "grid",
  "inline-grid",
  "flow-root",
  /* Box generation */
  "none",
  "contents",
  /* Two-value syntax */
  "block flow",
  "inline flow",
  "inline flow-root",
  "block flex",
  "inline flex",
  "block grid",
  "inline grid",
  "block flow-root",
  /* Other values */
  "table",
  "table-row",
  "list-item"
], k5e = ["stretch", "repeat", "round", "space"], _5e = [
  "capitalize",
  "uppercase",
  "lowercase",
  "none",
  "full-width",
  "full-size-kana"
], N5e = ["visible", "hidden", "collapse"];
class $e {
  /**
   * Returns border collapse.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderCollapse(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-collapse": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || m5e.includes(i) ? { "border-collapse": { value: i, important: n } } : null;
  }
  /**
   * Returns display.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getDisplay(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { display: { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || C5e.includes(i) ? { display: { value: i, important: n } } : null;
  }
  /**
   * Returns direction.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getDirection(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { direction: { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || i === "ltr" || i === "rtl" ? { direction: { value: i, important: n } } : null;
  }
  /**
   * Returns letter spacing.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getLetterSpacing(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getContentMeasurement(e);
    return r ? { "letter-spacing": { value: r, important: n } } : null;
  }
  /**
   * Returns word spacing.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getWordSpacing(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getContentMeasurement(e);
    return r ? { "word-spacing": { value: r, important: n } } : null;
  }
  /**
   * Returns text indent.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getTextIndent(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getContentMeasurement(e);
    return r ? { "text-indent": { value: r, important: n } } : null;
  }
  /**
   * Returns width.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getWidth(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getContentMeasurement(e);
    return r ? { width: { value: r, important: n } } : null;
  }
  /**
   * Returns height.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getHeight(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getContentMeasurement(e);
    return r ? { height: { value: r, important: n } } : null;
  }
  /**
   * Returns top.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getTop(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getContentMeasurement(e);
    return r ? { top: { value: r, important: n } } : null;
  }
  /**
   * Returns top.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getRight(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getContentMeasurement(e);
    return r ? { right: { value: r, important: n } } : null;
  }
  /**
   * Returns top.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBottom(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getContentMeasurement(e);
    return r ? { bottom: { value: r, important: n } } : null;
  }
  /**
   * Returns top.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getLeft(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getContentMeasurement(e);
    return r ? { left: { value: r, important: n } } : null;
  }
  /**
   * Returns clear.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getClear(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { clear: { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || E5e.includes(i) ? { clear: { value: i, important: n } } : null;
  }
  /**
   * Returns clip
   *
   * Based on:
   * https://github.com/jsdom/cssstyle/blob/master/lib/properties/clip.js
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getClip(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { clip: { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i) || i === "auto")
      return { clip: { value: i, important: n } };
    const s = i.match(d5e);
    if (!s)
      return null;
    const a = s[1].split(/\s*,\s*/);
    if (a.length !== 4)
      return null;
    for (const o of a)
      if (!M.getMeasurement(o))
        return null;
    return { clip: { value: e, important: n } };
  }
  /**
   * Returns float.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFloat(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { float: { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || S5e.includes(i) ? { float: { value: i, important: n } } : null;
  }
  /**
   * Returns float.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getCSSFloat(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "css-float": { value: r, important: n } };
    const i = this.getFloat(e, n);
    return i ? { "css-float": i.float } : null;
  }
  /**
   * Returns outline.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getOutline(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { outline: { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getOutlineColor(i, n),
        ...this.getOutlineStyle(i, n),
        ...this.getOutlineWidth(i, n)
      };
    const s = {
      ...this.getOutlineColor("initial", n),
      ...this.getOutlineStyle("initial", n),
      ...this.getOutlineWidth("initial", n)
    }, a = e.split(_r);
    for (const o of a) {
      const u = this.getOutlineWidth(o, n), l = this.getOutlineStyle(o, n), h = this.getOutlineColor(o, n);
      if (u === null && l === null && h === null)
        return null;
      Object.assign(s, u, l, h);
    }
    return s;
  }
  /**
   * Returns outline color.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getOutlineColor(e, n) {
    const r = M.getVariable(e) || M.getGlobal(e) || M.getColor(e);
    return r ? {
      "outline-color": { value: r, important: n }
    } : null;
  }
  /**
   * Returns outline offset.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getOutlineOffset(e, n) {
    const r = M.getVariable(e) || M.getLength(e);
    return r ? { "outline-offset": { value: r, important: n } } : null;
  }
  /**
   * Returns outline style.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getOutlineStyle(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "outline-style": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || Em.includes(i) ? {
      "outline-style": { value: i, important: n }
    } : null;
  }
  /**
   * Returns outline width.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getOutlineWidth(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "outline-width": { value: r, important: n } };
    const i = e.toLowerCase(), s = Sm.includes(i) || M.getGlobal(i) ? i : M.getLength(e);
    return s ? {
      "outline-width": { value: s, important: n }
    } : null;
  }
  /**
   * Returns border.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorder(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { border: { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderWidth(i, n),
        ...this.getBorderStyle(i, n),
        ...this.getBorderColor(i, n),
        ...this.getBorderImage(i, n)
      };
    const s = {
      ...this.getBorderWidth("initial", n),
      ...this.getBorderStyle("initial", n),
      ...this.getBorderColor("initial", n),
      ...this.getBorderImage("initial", n)
    }, a = e.replace(/\s*,\s*/g, ",").split(_r);
    for (const o of a) {
      const u = this.getBorderWidth(o, n), l = this.getBorderStyle(o, n), h = this.getBorderColor(o, n);
      if (u === null && l === null && h === null)
        return null;
      Object.assign(s, u, l, h);
    }
    return s;
  }
  /**
   * Returns border width.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderWidth(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-width": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderTopWidth(i, n),
        ...this.getBorderRightWidth(i, n),
        ...this.getBorderBottomWidth(i, n),
        ...this.getBorderLeftWidth(i, n)
      };
    const s = e.split(_r), a = this.getBorderTopWidth(s[0], n), o = this.getBorderRightWidth(s[1] || s[0], n), u = this.getBorderBottomWidth(s[2] || s[0], n), l = this.getBorderLeftWidth(s[3] || s[1] || s[0], n);
    return !a || !o || !u || !l ? null : {
      ...a,
      ...o,
      ...u,
      ...l
    };
  }
  /**
   * Returns border style.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderStyle(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-style": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderTopStyle(i, n),
        ...this.getBorderRightStyle(i, n),
        ...this.getBorderBottomStyle(i, n),
        ...this.getBorderLeftStyle(i, n)
      };
    const s = e.split(_r), a = this.getBorderTopStyle(s[0], n), o = this.getBorderRightStyle(s[1] || s[0], n), u = this.getBorderBottomStyle(s[2] || s[0], n), l = this.getBorderLeftStyle(s[3] || s[1] || s[0], n);
    return !a || !o || !u || !l ? null : {
      ...a,
      ...o,
      ...u,
      ...l
    };
  }
  /**
   * Returns border color.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderColor(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-color": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderTopColor(i, n),
        ...this.getBorderRightColor(i, n),
        ...this.getBorderBottomColor(i, n),
        ...this.getBorderLeftColor(i, n)
      };
    const s = e.split(_r), a = this.getBorderTopColor(s[0], n), o = this.getBorderRightColor(s[1] || s[0], n), u = this.getBorderBottomColor(s[2] || s[0], n), l = this.getBorderLeftColor(s[3] || s[1] || s[0], n);
    return !a || !o || !u || !l ? null : {
      ...a,
      ...o,
      ...u,
      ...l
    };
  }
  /**
   * Returns border image.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderImage(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-image": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderImageSource(i, n),
        ...this.getBorderImageSlice(i, n),
        ...this.getBorderImageWidth(i, n),
        ...this.getBorderImageOutset(i, n),
        ...this.getBorderImageRepeat(i, n)
      };
    let s = e.replace(/\s\/\s/g, "/");
    const a = s.match(/\s*([a-zA-Z-]+\([^)]*\))\s*/);
    a && (s = s.replace(a[0], ""));
    const o = s.split(_r);
    a && o.push(a[1]);
    const u = {
      ...this.getBorderImageSource("none", n),
      ...this.getBorderImageSlice("100%", n),
      ...this.getBorderImageWidth("1", n),
      ...this.getBorderImageOutset("0", n),
      ...this.getBorderImageRepeat("stretch", n)
    };
    for (let l = 0, h = o.length; l < h; l++) {
      const f = o[l], m = l > 0 ? o[l - 1] : "";
      if (!f.startsWith("url") && f.includes("/")) {
        const [g, A, E] = f.split("/"), w = this.getBorderImageSlice(`${m} ${g}`, n) || this.getBorderImageSlice(g, n), x = this.getBorderImageWidth(A, n), N = E && this.getBorderImageOutset(E, n);
        if (!w || !x || N === null)
          return null;
        Object.assign(u, w, x, N);
      } else {
        const g = this.getBorderImageSlice(`${m} ${f}`, n) || this.getBorderImageSlice(f, n), A = this.getBorderImageSource(f, n), E = this.getBorderImageRepeat(f, n);
        if (!g && !A && !E)
          return null;
        Object.assign(u, g, A, E);
      }
    }
    return u;
  }
  /**
   * Returns border source.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderImageSource(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-image-source": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i) || i === "none")
      return {
        "border-image-source": {
          important: n,
          value: i
        }
      };
    const s = M.getURL(e) || M.getGradient(e);
    return s ? {
      "border-image-source": {
        important: n,
        value: s
      }
    } : null;
  }
  /**
   * Returns border slice.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderImageSlice(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-image-slice": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i))
      return {
        "border-image-slice": {
          important: n,
          value: i
        }
      };
    if (i !== i.trim())
      return null;
    const s = /(fill)|(calc\([^^)]+\))|([0-9]+%)|([0-9]+)/g, a = [];
    let o;
    for (; o = s.exec(i); ) {
      const u = i[o.index - 1], l = i[o.index + o[0].length];
      if (u && u !== " " || l && l !== " ")
        return null;
      const h = o[1] && "fill", f = o[2] && M.getCalc(o[2]), m = o[3] && M.getPercentage(o[3]), g = o[4] && M.getInteger(o[4]);
      if (!h && !f && !m && !g)
        return null;
      a.push(h || f || m || g);
    }
    return !a.length || a.length > 4 ? null : {
      "border-image-slice": {
        important: n,
        value: a.join(" ")
      }
    };
  }
  /**
   * Returns border width.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderImageWidth(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-image-width": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i))
      return {
        "border-image-width": {
          important: n,
          value: i
        }
      };
    const s = i.split(_r);
    if (s.length > 4)
      return null;
    for (const a of s)
      if (!M.getInteger(a) && !M.getAutoMeasurement(a))
        return null;
    return {
      "border-image-width": {
        important: n,
        value: e
      }
    };
  }
  /**
   * Returns border outset.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderImageOutset(e, n) {
    if (e === "0")
      return {
        "border-image-outset": {
          important: n,
          value: e
        }
      };
    const r = M.getVariable(e);
    if (r)
      return { "border-image-outset": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i))
      return {
        "border-image-outset": {
          important: n,
          value: i
        }
      };
    const s = e.split(_r);
    if (s.length > 4)
      return null;
    const a = [];
    for (const o of s) {
      const u = M.getLength(o) || M.getFloat(o);
      if (!u)
        return null;
      a.push(u === "0px" ? "0" : u);
    }
    return {
      "border-image-outset": {
        important: n,
        value: a.join(" ")
      }
    };
  }
  /**
   * Returns border repeat.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderImageRepeat(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-image-repeat": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i))
      return {
        "border-image-repeat": {
          important: n,
          value: i
        }
      };
    const s = i.split(_r);
    if (s.length > 2)
      return null;
    for (const a of s)
      if (!k5e.includes(a))
        return null;
    return {
      "border-image-repeat": {
        important: n,
        value: e
      }
    };
  }
  /**
   * Returns border width.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderTopWidth(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-top-width": { value: r, important: n } };
    const i = e.toLowerCase(), s = Sm.includes(i) || M.getGlobal(i) ? i : M.getLength(e);
    return s ? {
      "border-top-width": { value: s, important: n }
    } : null;
  }
  /**
   * Returns border width.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderRightWidth(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-right-width": { value: r, important: n } };
    const i = e.toLowerCase(), s = Sm.includes(i) || M.getGlobal(i) ? i : M.getLength(e);
    return s ? {
      "border-right-width": { value: s, important: n }
    } : null;
  }
  /**
   * Returns border width.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderBottomWidth(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-bottom-width": { value: r, important: n } };
    const i = e.toLowerCase(), s = Sm.includes(i) || M.getGlobal(i) ? i : M.getLength(e);
    return s ? {
      "border-bottom-width": { value: s, important: n }
    } : null;
  }
  /**
   * Returns border width.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderLeftWidth(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-left-width": { value: r, important: n } };
    const i = e.toLowerCase(), s = Sm.includes(i) || M.getGlobal(i) ? i : M.getLength(e);
    return s ? {
      "border-left-width": { value: s, important: n }
    } : null;
  }
  /**
   * Returns border style.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderTopStyle(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-top-style": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || Em.includes(i) ? {
      "border-top-style": { value: i, important: n }
    } : null;
  }
  /**
   * Returns border style.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderRightStyle(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-right-style": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || Em.includes(i) ? {
      "border-right-style": { value: i, important: n }
    } : null;
  }
  /**
   * Returns border style.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderBottomStyle(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-bottom-style": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || Em.includes(i) ? {
      "border-bottom-style": { value: i, important: n }
    } : null;
  }
  /**
   * Returns border style.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderLeftStyle(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-left-style": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || Em.includes(i) ? {
      "border-left-style": { value: i, important: n }
    } : null;
  }
  /**
   * Returns border color.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderTopColor(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-top-color": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getColor(e);
    return i ? {
      "border-top-color": { value: i, important: n }
    } : null;
  }
  /**
   * Returns border color.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderRightColor(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-right-color": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getColor(e);
    return i ? {
      "border-right-color": { value: i, important: n }
    } : null;
  }
  /**
   * Returns border color.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderBottomColor(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-bottom-color": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getColor(e);
    return i ? {
      "border-bottom-color": { value: i, important: n }
    } : null;
  }
  /**
   * Returns border color.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBorderLeftColor(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-left-color": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getColor(e);
    return i ? {
      "border-left-color": { value: i, important: n }
    } : null;
  }
  /**
   * Returns border radius.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorderRadius(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-radius": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderTopLeftRadius(i, n),
        ...this.getBorderTopRightRadius(i, n),
        ...this.getBorderBottomRightRadius(i, n),
        ...this.getBorderBottomLeftRadius(i, n)
      };
    const s = e.split(_r), a = this.getBorderTopLeftRadius(s[0], n), o = this.getBorderTopRightRadius(s[1] || s[0], n), u = this.getBorderBottomRightRadius(s[2] || s[0], n), l = this.getBorderBottomLeftRadius(s[3] || s[1] || s[0], n);
    return !a || !o || !u || !l ? null : {
      ...a,
      ...o,
      ...u,
      ...l
    };
  }
  /**
   * Returns border radius.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorderTopLeftRadius(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-top-left-radius": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getMeasurement(e);
    return i ? { "border-top-left-radius": { important: n, value: i } } : null;
  }
  /**
   * Returns border radius.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorderTopRightRadius(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-top-right-radius": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getMeasurement(e);
    return i ? { "border-top-right-radius": { important: n, value: i } } : null;
  }
  /**
   * Returns border radius.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorderBottomRightRadius(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-bottom-right-radius": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getMeasurement(e);
    return i ? { "border-bottom-right-radius": { important: n, value: i } } : null;
  }
  /**
   * Returns border radius.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorderBottomLeftRadius(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-bottom-left-radius": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getMeasurement(e);
    return i ? { "border-bottom-left-radius": { important: n, value: i } } : null;
  }
  /**
   * Returns border top, right, bottom or left.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorderTop(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-top": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderTopWidth(i, n),
        ...this.getBorderTopStyle(i, n),
        ...this.getBorderTopColor(i, n)
      };
    const s = {
      ...this.getBorderTopWidth("initial", n),
      ...this.getBorderTopStyle("initial", n),
      ...this.getBorderTopColor("initial", n)
    }, a = e.split(_r);
    for (const o of a) {
      const u = this.getBorderTopWidth(o, n), l = this.getBorderTopStyle(o, n), h = this.getBorderTopColor(o, n);
      if (u === null && l === null && h === null)
        return null;
      Object.assign(s, u, l, h);
    }
    return s;
  }
  /**
   * Returns border top, right, bottom or left.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorderRight(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-right": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderRightWidth(i, n),
        ...this.getBorderRightStyle(i, n),
        ...this.getBorderRightColor(i, n)
      };
    const s = {
      ...this.getBorderRightWidth("initial", n),
      ...this.getBorderRightStyle("initial", n),
      ...this.getBorderRightColor("initial", n)
    }, a = e.split(_r);
    for (const o of a) {
      const u = this.getBorderRightWidth(o, n), l = this.getBorderRightStyle(o, n), h = this.getBorderRightColor(o, n);
      if (u === null && l === null && h === null)
        return null;
      Object.assign(s, u, l, h);
    }
    return s;
  }
  /**
   * Returns border top, right, bottom or left.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorderBottom(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-bottom": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderBottomWidth(i, n),
        ...this.getBorderBottomStyle(i, n),
        ...this.getBorderBottomColor(i, n)
      };
    const s = {
      ...this.getBorderBottomWidth("initial", n),
      ...this.getBorderBottomStyle("initial", n),
      ...this.getBorderBottomColor("initial", n)
    }, a = e.split(_r);
    for (const o of a) {
      const u = this.getBorderBottomWidth(o, n), l = this.getBorderBottomStyle(o, n), h = this.getBorderBottomColor(o, n);
      if (u === null && l === null && h === null)
        return null;
      Object.assign(s, u, l, h);
    }
    return s;
  }
  /**
   * Returns border top, right, bottom or left.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBorderLeft(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "border-left": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBorderLeftWidth(i, n),
        ...this.getBorderLeftStyle(i, n),
        ...this.getBorderLeftColor(i, n)
      };
    const s = {
      ...this.getBorderLeftWidth("initial", n),
      ...this.getBorderLeftStyle("initial", n),
      ...this.getBorderLeftColor("initial", n)
    }, a = e.split(_r);
    for (const o of a) {
      const u = this.getBorderLeftWidth(o, n), l = this.getBorderLeftStyle(o, n), h = this.getBorderLeftColor(o, n);
      if (u === null && l === null && h === null)
        return null;
      Object.assign(s, u, l, h);
    }
    return s;
  }
  /**
   * Returns padding.
   *
   * @param value Value.
   * @param important Important.
   */
  static getPadding(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { padding: { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getPaddingTop(i, n),
        ...this.getPaddingRight(i, n),
        ...this.getPaddingBottom(i, n),
        ...this.getPaddingLeft(i, n)
      };
    const s = e.split(_r), a = this.getPaddingTop(s[0], n), o = this.getPaddingRight(s[1] || s[0], n), u = this.getPaddingBottom(s[2] || s[0], n), l = this.getPaddingLeft(s[3] || s[1] || s[0], n);
    return !a || !o || !u || !l ? null : {
      ...a,
      ...o,
      ...u,
      ...l
    };
  }
  /**
   * Returns padding top.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getPaddingTop(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "padding-top": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getMeasurement(e);
    return i ? { "padding-top": { value: i, important: n } } : null;
  }
  /**
   * Returns padding right.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getPaddingRight(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "padding-right": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getMeasurement(e);
    return i ? { "padding-right": { value: i, important: n } } : null;
  }
  /**
   * Returns padding bottom.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getPaddingBottom(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "padding-bottom": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getMeasurement(e);
    return i ? { "padding-bottom": { value: i, important: n } } : null;
  }
  /**
   * Returns padding left.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getPaddingLeft(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "padding-left": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getMeasurement(e);
    return i ? { "padding-left": { value: i, important: n } } : null;
  }
  /**
   * Returns margin.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getMargin(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { margin: { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getMarginTop(i, n),
        ...this.getMarginRight(i, n),
        ...this.getMarginBottom(i, n),
        ...this.getMarginLeft(i, n)
      };
    const s = e.split(_r), a = this.getMarginTop(s[0], n), o = this.getMarginRight(s[1] || s[0], n), u = this.getMarginBottom(s[2] || s[0], n), l = this.getMarginLeft(s[3] || s[1] || s[0], n);
    return !a || !o || !u || !l ? null : {
      ...a,
      ...o,
      ...u,
      ...l
    };
  }
  /**
   * Returns margin top.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getMarginTop(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "margin-top": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getAutoMeasurement(e);
    return i ? { "margin-top": { value: i, important: n } } : null;
  }
  /**
   * Returns margin right.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getMarginRight(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "margin-right": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getAutoMeasurement(e);
    return i ? { "margin-right": { value: i, important: n } } : null;
  }
  /**
   * Returns margin right.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getMarginBottom(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "margin-bottom": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getAutoMeasurement(e);
    return i ? { "margin-bottom": { value: i, important: n } } : null;
  }
  /**
   * Returns margin left.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getMarginLeft(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "margin-left": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getAutoMeasurement(e);
    return i ? { "margin-left": { value: i, important: n } } : null;
  }
  /**
   * Returns flex.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getFlex(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { flex: { value: r, important: n } };
    const i = e.trim().toLowerCase(), s = M.getGlobal(e);
    if (s)
      return {
        ...this.getFlexGrow(s, n),
        ...this.getFlexShrink(s, n),
        ...this.getFlexBasis(s, n)
      };
    switch (i) {
      case "none":
        return {
          ...this.getFlexGrow("0", n),
          ...this.getFlexShrink("0", n),
          ...this.getFlexBasis("auto", n)
        };
      case "auto":
        return {
          ...this.getFlexGrow("1", n),
          ...this.getFlexShrink("1", n),
          ...this.getFlexBasis("auto", n)
        };
    }
    const a = M.getContentMeasurement(i);
    if (a)
      return {
        ...this.getFlexGrow("1", n),
        ...this.getFlexShrink("1", n),
        ...this.getFlexBasis(a, n)
      };
    const o = e.split(_r), u = this.getFlexGrow(o[0], n), l = this.getFlexShrink(o[1] || "1", n), h = this.getFlexBasis(o[2] || "0%", n);
    return !u || !l || !h ? null : {
      ...u,
      ...l,
      ...h
    };
  }
  /**
   * Returns flex basis.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFlexBasis(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "flex-basis": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i) || A5e.includes(i))
      return { "flex-basis": { value: i, important: n } };
    const s = M.getContentMeasurement(i);
    return s ? { "flex-basis": { value: s, important: n } } : null;
  }
  /**
   * Returns flex shrink.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFlexShrink(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "flex-shrink": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getFloat(e);
    return i ? { "flex-shrink": { value: i, important: n } } : null;
  }
  /**
   * Returns flex grow.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFlexGrow(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "flex-grow": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getFloat(e);
    return i ? { "flex-grow": { value: i, important: n } } : null;
  }
  /**
   * Returns background.
   *
   * @param name Name.
   * @param value Value.
   * @param important Important.
   * @returns Property values.
   */
  static getBackground(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { background: { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBackgroundImage(i, n),
        ...this.getBackgroundPosition(i, n),
        ...this.getBackgroundSize(i, n),
        ...this.getBackgroundRepeat(i, n),
        ...this.getBackgroundAttachment(i, n),
        ...this.getBackgroundOrigin(i, n),
        ...this.getBackgroundClip(i, n),
        ...this.getBackgroundColor(i, n)
      };
    const s = {
      ...this.getBackgroundImage("initial", n),
      ...this.getBackgroundPosition("initial", n),
      ...this.getBackgroundSize("initial", n),
      ...this.getBackgroundRepeat("initial", n),
      ...this.getBackgroundAttachment("initial", n),
      ...this.getBackgroundOrigin("initial", n),
      ...this.getBackgroundClip("initial", n),
      ...this.getBackgroundColor("initial", n)
    }, a = e.replace(/\s,\s/g, ",").replace(/\s\/\s/g, "/").split(_r), o = [];
    for (const u of a)
      if (!u.startsWith("url") && u.includes("/")) {
        const [l, h] = u.split("/"), f = this.getBackgroundPositionX(l, n), m = this.getBackgroundPositionY(l, n), g = this.getBackgroundSize(h, n);
        if (!f && !m || !g)
          return null;
        m ? o.push(m["background-position-y"].value) : f && o.push(f["background-position-x"].value), Object.assign(s, g);
      } else {
        const l = this.getBackgroundImage(u, n), h = this.getBackgroundRepeat(u, n), f = this.getBackgroundAttachment(u, n), m = this.getBackgroundPositionX(u, n), g = this.getBackgroundPositionY(u, n), A = this.getBackgroundColor(u, n), E = this.getBackgroundOrigin(u, n), w = this.getBackgroundClip(u, n);
        if (!l && !h && !f && !m && !g && !A && !E && !w)
          return null;
        m ? o.push(m["background-position-x"].value) : g && o.push(g["background-position-y"].value), Object.assign(s, l, h, f, A, E, w);
      }
    return o.length && Object.assign(s, this.getBackgroundPosition(o.join(" "), n)), s;
  }
  /**
   * Returns background size.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBackgroundSize(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-size": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i))
      return { "background-size": { value: i, important: n } };
    const s = i.split(Am), a = [];
    for (const o of s) {
      const u = o.trim().split(" ");
      if (u.length !== 1 && u.length !== 2)
        return null;
      if (u.length === 1) {
        if (u[0] !== "cover" && u[0] !== "contain" && !M.getAutoMeasurement(u[0]))
          return null;
        a.push(u[0]);
      } else {
        if (!M.getAutoMeasurement(u[0]) || !M.getAutoMeasurement(u[1]))
          return null;
        a.push(`${u[0]} ${u[1]}`);
      }
    }
    return a.length === 1 ? { "background-size": { value: a.join(", "), important: n } } : null;
  }
  /**
   * Returns background origin.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBackgroundOrigin(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-origin": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || p5e.includes(i) ? { "background-origin": { value: i, important: n } } : null;
  }
  /**
   * Returns background clip.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBackgroundClip(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-clip": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || b5e.includes(i) ? { "background-clip": { value: i, important: n } } : null;
  }
  /**
   * Returns background repeat.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBackgroundRepeat(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-repeat": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || g5e.includes(i) ? { "background-repeat": { value: i, important: n } } : null;
  }
  /**
   * Returns background attachment.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBackgroundAttachment(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-attachment": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || y5e.includes(i) ? { "background-attachment": { value: i, important: n } } : null;
  }
  /**
   * Returns background position.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBackgroundPosition(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-position": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return {
        ...this.getBackgroundPositionX(i, n),
        ...this.getBackgroundPositionY(i, n)
      };
    const s = e.split(Am);
    let a = "", o = "";
    for (const h of s) {
      const f = h.trim().split(_r);
      switch (a && (a += ",", o += ","), f.length) {
        case 1:
          f[0] === "top" || f[0] === "bottom" ? (a += "center", o += f[0]) : f[0] === "left" || f[0] === "right" ? (a += f[0], o += "center") : f[0] === "center" && (a += "center", o += "center");
          break;
        case 2:
          a += f[0] === "top" || f[0] === "bottom" ? f[1] : f[0], o += f[0] === "top" || f[0] === "bottom" ? f[0] : f[1];
          break;
        case 3:
          f[0] === "top" || f[0] === "bottom" || f[1] === "left" || f[1] === "right" || f[2] === "left" || f[2] === "right" ? M.getMeasurement(f[1]) ? (a += f[2], o += `${f[0]} ${f[1]}`) : (a += `${f[1]} ${f[2]}`, o += f[0]) : M.getMeasurement(f[1]) ? (a += `${f[0]} ${f[1]}`, o += f[2]) : (a += f[0], o += `${f[1]} ${f[2]}`);
          break;
        case 4:
          a += f[0] === "top" || f[0] === "bottom" || f[1] === "top" || f[1] === "bottom" ? `${f[2]} ${f[3]}` : `${f[0]} ${f[1]}`, o += f[0] === "top" || f[0] === "bottom" || f[1] === "top" || f[1] === "bottom" ? `${f[0]} ${f[1]}` : `${f[2]} ${f[3]}`;
          break;
        default:
          return null;
      }
    }
    const u = this.getBackgroundPositionX(a, n), l = this.getBackgroundPositionY(o, n);
    return u && l ? {
      ...u,
      ...l
    } : null;
  }
  /**
   * Returns background position.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBackgroundPositionX(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-position-x": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i))
      return { "background-position-x": { value: i, important: n } };
    const s = i.split(Am);
    let a = "";
    for (const o of s) {
      const u = o.trim().split(_r);
      a && (a += ",");
      for (const l of u) {
        const h = M.getMeasurement(l);
        if (!h && l !== "left" && l !== "right" && l !== "center")
          return null;
        a && (a += " "), a += h || l;
      }
    }
    return { "background-position-x": { value: a, important: n } };
  }
  /**
   * Returns background position.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getBackgroundPositionY(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-position-y": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i))
      return { "background-position-y": { value: i, important: n } };
    const s = i.split(Am);
    let a = "";
    for (const o of s) {
      const u = o.trim().split(_r);
      a && (a += ",");
      for (const l of u) {
        const h = M.getMeasurement(l);
        if (!h && l !== "top" && l !== "bottom" && l !== "center")
          return null;
        a && (a += " "), a += h || l;
      }
    }
    return { "background-position-y": { value: a, important: n } };
  }
  /**
   * Returns background color.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property value.
   */
  static getBackgroundColor(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-color": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getColor(e);
    return i ? {
      "background-color": { important: n, value: i }
    } : null;
  }
  /**
   * Returns background image.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property value.
   */
  static getBackgroundImage(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "background-image": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i) || i === "none")
      return { "background-image": { value: i, important: n } };
    const s = e.split(Am), a = [];
    for (const o of s) {
      const u = M.getURL(o.trim()) || M.getGradient(o.trim());
      if (!u)
        return null;
      a.push(u);
    }
    return a.length ? { "background-image": { value: a.join(", "), important: n } } : null;
  }
  /**
   * Returns color.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property value.
   */
  static getColor(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { color: { value: r, important: n } };
    const i = M.getGlobal(e) || M.getColor(e);
    return i ? { color: { important: n, value: i } } : null;
  }
  /**
   * Returns color.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property value.
   */
  static getFloodColor(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "flood-color": { value: r, important: n } };
    const i = M.getGlobal(e) || M.getColor(e);
    return i ? { "flood-color": { important: n, value: i } } : null;
  }
  /**
   * Returns font.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFont(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { font: { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i))
      return {
        ...this.getFontStyle(i, n),
        ...this.getFontVariant(i, n),
        ...this.getFontWeight(i, n),
        ...this.getFontStretch(i, n),
        ...this.getFontSize(i, n),
        ...this.getLineHeight(i, n),
        ...this.getFontFamily(i, n)
      };
    if (w5e.includes(i))
      return { font: { value: i, important: n } };
    const s = {
      ...this.getFontStyle("normal", n),
      ...this.getFontVariant("normal", n),
      ...this.getFontWeight("normal", n),
      ...this.getFontStretch("normal", n),
      ...this.getLineHeight("normal", n)
    }, a = e.replace(/\s*\/\s*/g, "/").split(_r);
    for (let o = 0, u = a.length; o < u; o++) {
      const l = a[o];
      if (l.includes("/")) {
        const [h, f] = l.split("/"), m = this.getFontSize(h, n), g = this.getLineHeight(f, n);
        if (!m || !g)
          return null;
        Object.assign(s, m, g);
      } else {
        const h = this.getFontStyle(l, n), f = this.getFontVariant(l, n), m = this.getFontWeight(l, n), g = this.getFontSize(l, n), A = this.getFontStretch(l, n);
        if (h)
          Object.assign(s, h);
        else if (f)
          Object.assign(s, f);
        else if (m)
          Object.assign(s, m);
        else if (g)
          Object.assign(s, g);
        else if (A)
          Object.assign(s, A);
        else {
          const E = a.slice(o).join(" "), w = this.getFontFamily(E, n);
          if (!w)
            return null;
          Object.assign(s, w);
          break;
        }
      }
    }
    return s;
  }
  /**
   * Returns font style.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFontStyle(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "font-style": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i) || T5e.includes(i))
      return { "font-style": { value: i, important: n } };
    const s = e.split(_r);
    return s.length === 2 && s[0] === "oblique" && M.getDegree(s[1]) ? { "font-style": { value: i, important: n } } : null;
  }
  /**
   * Returns font variant.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFontVariant(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "font-variant": { value: r, important: n } };
    const i = e.toLowerCase();
    return M.getGlobal(i) || i === "normal" || i === "small-caps" ? { "font-variant": { value: i, important: n } } : null;
  }
  /**
   * Returns font strech.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFontStretch(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "font-stretch": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i) || x5e.includes(i))
      return { "font-stretch": { value: i, important: n } };
    const s = M.getPercentage(e);
    return s ? { "font-stretch": { value: s, important: n } } : null;
  }
  /**
   * Returns font weight.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFontWeight(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "font-weight": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i) || F5e.includes(i))
      return { "font-weight": { value: i, important: n } };
    const s = M.getInteger(e);
    return s ? { "font-weight": { value: s, important: n } } : null;
  }
  /**
   * Returns font size.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFontSize(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "font-size": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i) || v5e.includes(i))
      return { "font-size": { value: i, important: n } };
    const s = M.getMeasurement(e);
    return s ? { "font-size": { value: s, important: n } } : null;
  }
  /**
   * Returns line height.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getLineHeight(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "line-height": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i) || i === "normal")
      return { "line-height": { value: i, important: n } };
    const s = M.getFloat(e) || M.getMeasurement(e);
    return s ? { "line-height": { value: s, important: n } } : null;
  }
  /**
   * Returns font family.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getFontFamily(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "font-family": { value: r, important: n } };
    const i = M.getGlobal(e);
    if (i)
      return { "font-family": { value: i, important: n } };
    const s = e.split(",");
    let a = "", o = !1;
    for (let u = 0, l = s.length; u < l; u++) {
      let h = s[u].trim().replace(/'/g, '"');
      if (!h)
        return null;
      if (h.includes(" ")) {
        const f = (h.match(/"/g) || []).length;
        if ((h[0] !== '"' || u !== 0) && f !== 2 && f !== 0)
          return null;
        h[0] === '"' && h[h.length - 1] !== '"' ? o = !0 : h[0] !== '"' && h[h.length - 1] !== '"' && (h = `"${h}"`);
      } else
        h = h.replace(/"/g, "");
      u > 0 && (a += ", "), a += h;
    }
    return o && (a += '"'), a ? {
      "font-family": {
        important: n,
        value: a
      }
    } : null;
  }
  /**
   * Returns font family.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property values
   */
  static getTextTransform(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "text-transform": { value: r, important: n } };
    const i = e.toLowerCase(), s = M.getGlobal(i) || _5e.includes(i) && i;
    return s ? {
      "text-transform": { value: s, important: n }
    } : null;
  }
  /**
   * Returns visibility.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property
   */
  static getVisibility(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { visibility: { value: r, important: n } };
    const i = e.toLowerCase(), s = M.getGlobal(i) || N5e.includes(i) && i;
    return s ? {
      visibility: { value: s, important: n }
    } : null;
  }
  /**
   * Returns aspect ratio.
   *
   * @param value Value.
   * @param important Important.
   * @returns Property
   */
  static getAspectRatio(e, n) {
    const r = M.getVariable(e);
    if (r)
      return { "aspect-ratio": { value: r, important: n } };
    const i = e.toLowerCase();
    if (M.getGlobal(i))
      return { "aspect-ratio": { value: i, important: n } };
    let s = e;
    const a = s.includes("auto");
    if (a && (s = s.replace("auto", "")), s = s.replace(f5e, ""), !s)
      return { "aspect-ratio": { value: "auto", important: n } };
    const o = s.split("/");
    if (o.length > 3)
      return null;
    const u = Number(o[0]), l = o[1] ? Number(o[1]) : 1;
    return isNaN(u) || isNaN(l) ? null : a ? { "aspect-ratio": { value: `auto ${u} / ${l}`, important: n } } : { "aspect-ratio": { value: `${u} / ${l}`, important: n } };
  }
}
class Bi {
  /**
   * Returns margin.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getMargin(e) {
    return this.getPaddingLikeProperty(["margin-top", "margin-right", "margin-bottom", "margin-left"], e);
  }
  /**
   * Returns padding.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getPadding(e) {
    return this.getPaddingLikeProperty(["padding-top", "padding-right", "padding-bottom", "padding-left"], e);
  }
  /**
   * Returns outline.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getOutline(e) {
    if (!e["outline-color"]?.value || !e["outline-style"]?.value || !e["outline-width"]?.value)
      return null;
    const n = e["outline-color"].important && e["outline-style"].important && e["outline-width"].important;
    if (M.getGlobalExceptInitial(e["outline-width"].value) && e["outline-width"].value === e["outline-style"].value && e["outline-width"].value === e["outline-color"].value)
      return {
        important: n,
        value: e["outline-width"].value
      };
    const r = [];
    return M.getInitial(e["outline-color"]?.value) || r.push(e["outline-color"].value), M.getInitial(e["outline-style"]?.value) || r.push(e["outline-style"].value), M.getInitial(e["outline-width"].value) || r.push(e["outline-width"].value), {
      important: n,
      value: r.join(" ")
    };
  }
  /**
   * Returns border.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorder(e) {
    if (!e["border-top-width"]?.value || e["border-top-width"]?.value !== e["border-right-width"]?.value || e["border-top-width"]?.value !== e["border-bottom-width"]?.value || e["border-top-width"]?.value !== e["border-left-width"]?.value || !e["border-top-style"]?.value || e["border-top-style"]?.value !== e["border-right-style"]?.value || e["border-top-style"]?.value !== e["border-bottom-style"]?.value || e["border-top-style"]?.value !== e["border-left-style"]?.value || !e["border-top-color"]?.value || e["border-top-color"]?.value !== e["border-right-color"]?.value || e["border-top-color"]?.value !== e["border-bottom-color"]?.value || e["border-top-color"]?.value !== e["border-left-color"]?.value || !e["border-image-source"]?.value || !e["border-image-slice"]?.value || !e["border-image-width"]?.value || !e["border-image-outset"]?.value || !e["border-image-repeat"]?.value)
      return null;
    const n = e["border-top-width"].important && e["border-right-width"].important && e["border-bottom-width"].important && e["border-left-width"].important && e["border-top-style"].important && e["border-right-style"].important && e["border-bottom-style"].important && e["border-left-style"].important && e["border-top-color"].important && e["border-right-color"].important && e["border-bottom-color"].important && e["border-left-color"].important && e["border-image-source"].important && e["border-image-slice"].important && e["border-image-width"].important && e["border-image-outset"].important && e["border-image-repeat"].important;
    if (M.getGlobalExceptInitial(e["border-top-width"].value) || M.getGlobalExceptInitial(e["border-top-style"].value) || M.getGlobalExceptInitial(e["border-top-color"].value) || M.getGlobalExceptInitial(e["border-image-source"].value) || M.getGlobalExceptInitial(e["border-image-slice"].value) || M.getGlobalExceptInitial(e["border-image-width"].value) || M.getGlobalExceptInitial(e["border-image-outset"].value) || M.getGlobalExceptInitial(e["border-image-repeat"].value))
      return e["border-top-width"].value !== e["border-top-style"].value || e["border-top-width"].value !== e["border-top-color"].value || e["border-top-width"].value !== e["border-image-source"].value || e["border-top-width"].value !== e["border-image-slice"].value || e["border-top-width"].value !== e["border-image-width"].value || e["border-top-width"].value !== e["border-image-outset"].value || e["border-top-width"].value !== e["border-image-repeat"].value ? null : {
        important: n,
        value: e["border-top-width"].value
      };
    const r = [];
    return M.getInitial(e["border-top-width"].value) || r.push(e["border-top-width"].value), M.getInitial(e["border-top-style"].value) || r.push(e["border-top-style"].value), M.getInitial(e["border-top-color"].value) || r.push(e["border-top-color"].value), {
      important: n,
      value: r.join(" ")
    };
  }
  /**
   * Returns border.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorderTop(e) {
    return this.getBorderTopRightBottomLeft("top", e);
  }
  /**
   * Returns border.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorderRight(e) {
    return this.getBorderTopRightBottomLeft("right", e);
  }
  /**
   * Returns border.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorderBottom(e) {
    return this.getBorderTopRightBottomLeft("bottom", e);
  }
  /**
   * Returns border.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorderLeft(e) {
    return this.getBorderTopRightBottomLeft("left", e);
  }
  /**
   * Returns border.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorderColor(e) {
    return this.getPaddingLikeProperty(["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"], e);
  }
  /**
   * Returns border.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorderWidth(e) {
    return this.getPaddingLikeProperty(["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"], e);
  }
  /**
   * Returns border.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorderStyle(e) {
    return this.getPaddingLikeProperty(["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"], e);
  }
  /**
   * Returns border radius.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorderRadius(e) {
    return this.getPaddingLikeProperty([
      "border-top-left-radius",
      "border-top-right-radius",
      "border-bottom-right-radius",
      "border-bottom-left-radius"
    ], e);
  }
  /**
   * Returns border image.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBorderImage(e) {
    if (!e["border-image-source"]?.value || !e["border-image-slice"]?.value || !e["border-image-width"]?.value || !e["border-image-outset"]?.value || !e["border-image-repeat"]?.value)
      return null;
    const n = e["border-image-source"].important && e["border-image-slice"].important && e["border-image-width"].important && e["border-image-outset"].important && e["border-image-repeat"].important;
    return M.getGlobal(e["border-image-source"].value) || M.getGlobal(e["border-image-slice"].value) || M.getGlobal(e["border-image-width"].value) || M.getGlobal(e["border-image-outset"].value) || M.getGlobal(e["border-image-repeat"].value) ? e["border-image-source"].value !== e["border-image-slice"].value || e["border-image-source"].value !== e["border-image-width"].value || e["border-image-source"].value !== e["border-image-outset"].value || e["border-image-source"].value !== e["border-image-repeat"].value ? null : {
      important: n,
      value: e["border-image-source"].value
    } : {
      important: n,
      value: `${e["border-image-source"].value} ${e["border-image-slice"].value} / ${e["border-image-width"].value} / ${e["border-image-outset"].value} ${e["border-image-repeat"].value}`
    };
  }
  /**
   * Returns background.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBackground(e) {
    if (!e["background-image"]?.value || !e["background-repeat"]?.value || !e["background-attachment"]?.value || !e["background-position-x"]?.value || !e["background-position-y"]?.value || !e["background-color"]?.value || !e["background-size"]?.value || !e["background-origin"]?.value || !e["background-clip"]?.value)
      return null;
    const n = e["background-image"].important && e["background-repeat"].important && e["background-attachment"].important && e["background-position-x"].important && e["background-position-y"].important && e["background-color"].important && e["background-size"].important && e["background-origin"].important && e["background-clip"].important;
    if (M.getGlobalExceptInitial(e["background-image"].value) || M.getGlobalExceptInitial(e["background-repeat"].value) || M.getGlobalExceptInitial(e["background-attachment"].value) || M.getGlobalExceptInitial(e["background-position-x"].value) || M.getGlobalExceptInitial(e["background-position-y"].value) || M.getGlobalExceptInitial(e["background-color"].value) || M.getGlobalExceptInitial(e["background-size"].value) || M.getGlobalExceptInitial(e["background-origin"].value) || M.getGlobalExceptInitial(e["background-clip"].value))
      return e["background-image"].value !== e["background-repeat"].value || e["background-image"].value !== e["background-attachment"].value || e["background-image"].value !== e["background-position-x"].value || e["background-image"].value !== e["background-position-y"].value || e["background-image"].value !== e["background-color"].value || e["background-image"].value !== e["background-size"].value || e["background-image"].value !== e["background-origin"].value || e["background-image"].value !== e["background-clip"].value ? null : {
        important: n,
        value: e["background-image"].value
      };
    const r = [];
    return M.getInitial(e["background-image"].value) || r.push(e["background-image"].value), !M.getInitial(e["background-position-x"].value) && !M.getInitial(e["background-position-y"].value) && !M.getInitial(e["background-size"].value) ? r.push(`${e["background-position-x"].value} ${e["background-position-y"].value} / ${e["background-size"].value}`) : !M.getInitial(e["background-position-x"].value) && !M.getInitial(e["background-position-y"].value) && r.push(`${e["background-position-x"].value} ${e["background-position-y"].value}`), M.getInitial(e["background-repeat"].value) || r.push(e["background-repeat"].value), M.getInitial(e["background-attachment"].value) || r.push(e["background-attachment"].value), M.getInitial(e["background-origin"].value) || r.push(e["background-origin"].value), M.getInitial(e["background-clip"].value) || r.push(e["background-clip"].value), M.getInitial(e["background-color"].value) || r.push(e["background-color"].value), {
      important: n,
      value: r.join(" ")
    };
  }
  /**
   * Returns background position.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getBackgroundPosition(e) {
    if (!e["background-position-x"]?.value || !e["background-position-y"]?.value)
      return null;
    const n = e["background-position-x"].important && e["background-position-y"].important;
    if (M.getGlobal(e["background-position-x"].value) || M.getGlobal(e["background-position-y"].value))
      return e["background-position-x"].value !== e["background-position-y"].value ? null : {
        important: n,
        value: e["background-position-x"].value
      };
    const r = e["background-position-x"].value.replace(/ *, */g, ",").split(","), i = e["background-position-y"].value.replace(/ *, */g, ",").split(","), s = [];
    for (let a = 0; a < r.length; a++)
      s.push(`${r[a]} ${i[a]}`);
    return {
      important: n,
      value: s.join(", ")
    };
  }
  /**
   * Returns flex.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getFlex(e) {
    if (!e["flex-grow"]?.value || !e["flex-shrink"]?.value || !e["flex-basis"]?.value)
      return null;
    const n = e["flex-grow"].important && e["flex-shrink"].important && e["flex-basis"].important;
    return M.getGlobal(e["flex-grow"].value) || M.getGlobal(e["flex-shrink"].value) || M.getGlobal(e["flex-basis"].value) ? e["flex-grow"].value !== e["flex-shrink"].value || e["flex-grow"].value !== e["flex-basis"].value ? null : {
      important: n,
      value: e["flex-grow"].value
    } : {
      important: n,
      value: `${e["flex-grow"].value} ${e["flex-shrink"].value} ${e["flex-basis"].value}`
    };
  }
  /**
   * Returns flex.
   *
   * @param properties Properties.
   * @returns Property value
   */
  static getFont(e) {
    if (!e["font-size"]?.value || !e["font-family"]?.value || !e["font-weight"]?.value || !e["font-style"]?.value || !e["font-variant"]?.value || !e["font-stretch"]?.value || !e["line-height"]?.value)
      return null;
    const n = e["font-size"].important && e["font-family"].important && e["font-weight"].important && e["font-style"].important && e["font-variant"].important && e["font-stretch"].important && e["line-height"].important;
    if (M.getGlobal(e["font-size"].value) || M.getGlobal(e["font-family"].value) || M.getGlobal(e["font-weight"].value) || M.getGlobal(e["font-style"].value) || M.getGlobal(e["font-variant"].value) || M.getGlobal(e["font-stretch"].value) || M.getGlobal(e["line-height"].value))
      return e["font-size"].value !== e["font-family"].value || e["font-size"].value !== e["font-weight"].value || e["font-size"].value !== e["font-style"].value || e["font-size"].value !== e["font-variant"].value || e["font-size"].value !== e["font-stretch"].value || e["font-size"].value !== e["line-height"].value ? null : {
        important: n,
        value: e["font-size"].value
      };
    const r = [];
    return e["font-style"].value !== "normal" && r.push(e["font-style"].value), e["font-variant"].value !== "normal" && r.push(e["font-variant"].value), e["font-weight"].value !== "normal" && r.push(e["font-weight"].value), e["font-stretch"].value !== "normal" && r.push(e["font-stretch"].value), e["line-height"].value !== "normal" ? r.push(`${e["font-size"].value} / ${e["line-height"].value}`) : r.push(e["font-size"].value), r.push(e["font-family"].value), {
      important: n,
      value: r.join(" ")
    };
  }
  /**
   * Returns border.
   *
   * @param properties Properties.
   * @param position
   * @returns Property value
   */
  static getBorderTopRightBottomLeft(e, n) {
    if (!n[`border-${e}-width`]?.value || !n[`border-${e}-style`]?.value || !n[`border-${e}-color`]?.value)
      return null;
    const r = n[`border-${e}-width`].important && n[`border-${e}-style`].important && n[`border-${e}-color`].important;
    if (M.getGlobalExceptInitial(n[`border-${e}-width`].value) && n[`border-${e}-width`].value === n[`border-${e}-style`].value && n[`border-${e}-width`].value === n[`border-${e}-color`].value)
      return {
        important: r,
        value: n[`border-${e}-width`].value
      };
    const i = [];
    return M.getInitial(n[`border-${e}-width`].value) || i.push(n[`border-${e}-width`].value), M.getInitial(n[`border-${e}-style`]?.value) || i.push(n[`border-${e}-style`].value), M.getInitial(n[`border-${e}-color`]?.value) || i.push(n[`border-${e}-color`].value), {
      important: r,
      value: i.join(" ")
    };
  }
  /**
   * Returns a padding like property.
   *
   * @param properties Properties.
   * @param position
   * @param propertyNames
   * @returns Property value
   */
  static getPaddingLikeProperty(e, n) {
    if (!n[e[0]]?.value || !n[e[1]]?.value || !n[e[2]]?.value || !n[e[3]]?.value)
      return null;
    const r = n[e[0]].important && n[e[1]].important && n[e[2]].important && n[e[3]].important;
    if (M.getGlobal(n[e[0]].value) || M.getGlobal(n[e[1]].value) || M.getGlobal(n[e[2]].value) || M.getGlobal(n[e[3]].value))
      return n[e[0]].value !== n[e[1]].value || n[e[0]].value !== n[e[2]].value || n[e[0]].value !== n[e[3]].value ? null : {
        important: r,
        value: n[e[0]].value
      };
    const i = [n[e[0]].value];
    return (n[e[1]].value !== n[e[0]].value || n[e[2]].value !== n[e[0]].value || n[e[3]].value !== n[e[1]].value) && i.push(n[e[1]].value), (n[e[2]].value !== n[e[0]].value || n[e[3]].value !== n[e[1]].value) && i.push(n[e[2]].value), n[e[3]].value !== n[e[1]].value && i.push(n[e[3]].value), {
      important: r,
      value: i.join(" ")
    };
  }
}
const D5e = /\s*([^:;]+?)\s*:\s*((?:[^(;]*?(?:\([^)]*\))?)*?)\s*(!important)?\s*(?:$|;)/g;
class H7 {
  /**
   * Class construtor.
   *
   * @param cssText CSS string.
   * @param callback Callback.
   */
  static parse(e) {
    const n = {}, r = [], i = new RegExp(D5e);
    let s;
    for (; s = i.exec(e); ) {
      const a = (s[1] ?? "").trim(), o = (s[2] ?? "").trim(), u = !!s[3];
      a && o && (a.startsWith("--") && (n[a] = o), r.push({ name: a, value: o, important: u }));
    }
    return { rules: r, properties: n };
  }
}
const I5e = [
  ["margin"],
  ["padding"],
  ["border", ["border-width", "border-style", "border-color", "border-image"]],
  ["border-radius"],
  ["background", "background-position"],
  ["font"]
];
class Od {
  properties = {};
  definedPropertyNames = {};
  /**
   * Class construtor.
   *
   * @param [options] Options.
   * @param [options.cssText] CSS string.
   */
  constructor(e) {
    if (e?.cssText) {
      const { rules: n } = H7.parse(e.cssText);
      for (const r of n)
        (r.important || !this.get(r.name)?.important) && this.set(r.name, r.value, r.important);
    }
  }
  /**
   * Returns property value.
   *
   * @param name Property name.
   * @returns Property value.
   */
  get(e) {
    if (this.properties[e])
      return this.properties[e];
    switch (e) {
      case "margin":
        return Bi.getMargin(this.properties);
      case "padding":
        return Bi.getPadding(this.properties);
      case "border":
        return Bi.getBorder(this.properties);
      case "border-top":
        return Bi.getBorderTop(this.properties);
      case "border-right":
        return Bi.getBorderRight(this.properties);
      case "border-bottom":
        return Bi.getBorderBottom(this.properties);
      case "border-left":
        return Bi.getBorderLeft(this.properties);
      case "border-color":
        return Bi.getBorderColor(this.properties);
      case "border-style":
        return Bi.getBorderStyle(this.properties);
      case "border-width":
        return Bi.getBorderWidth(this.properties);
      case "border-radius":
        return Bi.getBorderRadius(this.properties);
      case "border-image":
        return Bi.getBorderImage(this.properties);
      case "outline":
        return Bi.getOutline(this.properties);
      case "background":
        return Bi.getBackground(this.properties);
      case "background-position":
        return Bi.getBackgroundPosition(this.properties);
      case "flex":
        return Bi.getFlex(this.properties);
      case "font":
        return Bi.getFont(this.properties);
    }
    return this.properties[e] || null;
  }
  /**
   * Removes a property.
   *
   * @param name Property name.
   */
  remove(e) {
    switch (delete this.properties[e], delete this.definedPropertyNames[e], e) {
      case "border":
        delete this.properties["border-top-width"], delete this.properties["border-right-width"], delete this.properties["border-bottom-width"], delete this.properties["border-left-width"], delete this.properties["border-top-style"], delete this.properties["border-right-style"], delete this.properties["border-bottom-style"], delete this.properties["border-left-style"], delete this.properties["border-top-color"], delete this.properties["border-right-color"], delete this.properties["border-bottom-color"], delete this.properties["border-left-color"], delete this.properties["border-image-source"], delete this.properties["border-image-slice"], delete this.properties["border-image-width"], delete this.properties["border-image-outset"], delete this.properties["border-image-repeat"];
        break;
      case "border-top":
        delete this.properties["border-top-width"], delete this.properties["border-top-style"], delete this.properties["border-top-color"], delete this.properties["border-image-source"], delete this.properties["border-image-slice"], delete this.properties["border-image-width"], delete this.properties["border-image-outset"], delete this.properties["border-image-repeat"];
        break;
      case "border-right":
        delete this.properties["border-right-width"], delete this.properties["border-right-style"], delete this.properties["border-right-color"], delete this.properties["border-image-source"], delete this.properties["border-image-slice"], delete this.properties["border-image-width"], delete this.properties["border-image-outset"], delete this.properties["border-image-repeat"];
        break;
      case "border-bottom":
        delete this.properties["border-bottom-width"], delete this.properties["border-bottom-style"], delete this.properties["border-bottom-color"], delete this.properties["border-image-source"], delete this.properties["border-image-slice"], delete this.properties["border-image-width"], delete this.properties["border-image-outset"], delete this.properties["border-image-repeat"];
        break;
      case "border-left":
        delete this.properties["border-left-width"], delete this.properties["border-left-style"], delete this.properties["border-left-color"], delete this.properties["border-image-source"], delete this.properties["border-image-slice"], delete this.properties["border-image-width"], delete this.properties["border-image-outset"], delete this.properties["border-image-repeat"];
        break;
      case "border-width":
        delete this.properties["border-top-width"], delete this.properties["border-right-width"], delete this.properties["border-bottom-width"], delete this.properties["border-left-width"];
        break;
      case "border-style":
        delete this.properties["border-top-style"], delete this.properties["border-right-style"], delete this.properties["border-bottom-style"], delete this.properties["border-left-style"];
        break;
      case "border-color":
        delete this.properties["border-top-color"], delete this.properties["border-right-color"], delete this.properties["border-bottom-color"], delete this.properties["border-left-color"];
        break;
      case "border-image":
        delete this.properties["border-image-source"], delete this.properties["border-image-slice"], delete this.properties["border-image-width"], delete this.properties["border-image-outset"], delete this.properties["border-image-repeat"];
        break;
      case "border-radius":
        delete this.properties["border-top-left-radius"], delete this.properties["border-top-right-radius"], delete this.properties["border-bottom-right-radius"], delete this.properties["border-bottom-left-radius"];
        break;
      case "outline":
        delete this.properties["outline-color"], delete this.properties["outline-style"], delete this.properties["outline-width"];
        break;
      case "background":
        delete this.properties["background-color"], delete this.properties["background-image"], delete this.properties["background-repeat"], delete this.properties["background-attachment"], delete this.properties["background-position-x"], delete this.properties["background-position-y"], delete this.properties["background-size"], delete this.properties["background-origin"], delete this.properties["background-clip"];
        break;
      case "background-position":
        delete this.properties["background-position-x"], delete this.properties["background-position-y"];
        break;
      case "flex":
        delete this.properties["flex-grow"], delete this.properties["flex-shrink"], delete this.properties["flex-basis"];
        break;
      case "font":
        delete this.properties["font-style"], delete this.properties["font-variant"], delete this.properties["font-weight"], delete this.properties["font-stretch"], delete this.properties["font-size"], delete this.properties["line-height"], delete this.properties["font-family"];
        break;
      case "padding":
        delete this.properties["padding-top"], delete this.properties["padding-right"], delete this.properties["padding-bottom"], delete this.properties["padding-left"];
        break;
      case "margin":
        delete this.properties["margin-top"], delete this.properties["margin-right"], delete this.properties["margin-bottom"], delete this.properties["margin-left"];
        break;
    }
  }
  /**
   * Sets a property
   *
   * @param name Name.
   * @param value Value.
   * @param important Important.
   */
  set(e, n, r) {
    if (n === null) {
      this.remove(e);
      return;
    }
    let i = null;
    switch (e) {
      case "border":
        i = $e.getBorder(n, r);
        break;
      case "border-top":
        i = $e.getBorderTop(n, r);
        break;
      case "border-right":
        i = $e.getBorderRight(n, r);
        break;
      case "border-bottom":
        i = $e.getBorderBottom(n, r);
        break;
      case "border-left":
        i = $e.getBorderLeft(n, r);
        break;
      case "border-width":
        i = $e.getBorderWidth(n, r);
        break;
      case "border-style":
        i = $e.getBorderStyle(n, r);
        break;
      case "border-color":
        i = $e.getBorderColor(n, r);
        break;
      case "border-image":
        i = $e.getBorderImage(n, r);
        break;
      case "border-image-source":
        i = $e.getBorderImageSource(n, r);
        break;
      case "border-image-slice":
        i = $e.getBorderImageSlice(n, r);
        break;
      case "border-image-width":
        i = $e.getBorderImageWidth(n, r);
        break;
      case "border-image-outset":
        i = $e.getBorderImageOutset(n, r);
        break;
      case "border-image-repeat":
        i = $e.getBorderImageRepeat(n, r);
        break;
      case "border-top-width":
        i = $e.getBorderTopWidth(n, r);
        break;
      case "border-right-width":
        i = $e.getBorderRightWidth(n, r);
        break;
      case "border-bottom-width":
        i = $e.getBorderBottomWidth(n, r);
        break;
      case "border-left-width":
        i = $e.getBorderLeftWidth(n, r);
        break;
      case "border-top-color":
        i = $e.getBorderTopColor(n, r);
        break;
      case "border-right-color":
        i = $e.getBorderRightColor(n, r);
        break;
      case "border-bottom-color":
        i = $e.getBorderBottomColor(n, r);
        break;
      case "border-left-color":
        i = $e.getBorderLeftColor(n, r);
        break;
      case "border-top-style":
        i = $e.getBorderTopStyle(n, r);
        break;
      case "border-right-style":
        i = $e.getBorderRightStyle(n, r);
        break;
      case "border-bottom-style":
        i = $e.getBorderBottomStyle(n, r);
        break;
      case "border-left-style":
        i = $e.getBorderLeftStyle(n, r);
        break;
      case "border-radius":
        i = $e.getBorderRadius(n, r);
        break;
      case "border-top-left-radius":
        i = $e.getBorderTopLeftRadius(n, r);
        break;
      case "border-top-right-radius":
        i = $e.getBorderTopRightRadius(n, r);
        break;
      case "border-bottom-right-radius":
        i = $e.getBorderBottomRightRadius(n, r);
        break;
      case "border-bottom-left-radius":
        i = $e.getBorderBottomLeftRadius(n, r);
        break;
      case "border-collapse":
        i = $e.getBorderCollapse(n, r);
        break;
      case "outline":
        i = $e.getOutline(n, r);
        break;
      case "outline-width":
        i = $e.getOutlineWidth(n, r);
        break;
      case "outline-style":
        i = $e.getOutlineStyle(n, r);
        break;
      case "outline-color":
        i = $e.getOutlineColor(n, r);
        break;
      case "letter-spacing":
        i = $e.getLetterSpacing(n, r);
        break;
      case "word-spacing":
        i = $e.getWordSpacing(n, r);
        break;
      case "clear":
        i = $e.getClear(n, r);
        break;
      case "clip":
        i = $e.getClip(n, r);
        break;
      case "css-float":
        i = $e.getCSSFloat(n, r);
        break;
      case "float":
        i = $e.getFloat(n, r);
        break;
      case "display":
        i = $e.getDisplay(n, r);
        break;
      case "direction":
        i = $e.getDirection(n, r);
        break;
      case "flex":
        i = $e.getFlex(n, r);
        break;
      case "flex-shrink":
        i = $e.getFlexShrink(n, r);
        break;
      case "flex-grow":
        i = $e.getFlexGrow(n, r);
        break;
      case "flex-basis":
        i = $e.getFlexBasis(n, r);
        break;
      case "padding":
        i = $e.getPadding(n, r);
        break;
      case "padding-top":
        i = $e.getPaddingTop(n, r);
        break;
      case "padding-right":
        i = $e.getPaddingRight(n, r);
        break;
      case "padding-bottom":
        i = $e.getPaddingBottom(n, r);
        break;
      case "padding-left":
        i = $e.getPaddingLeft(n, r);
        break;
      case "margin":
        i = $e.getMargin(n, r);
        break;
      case "margin-top":
        i = $e.getMarginTop(n, r);
        break;
      case "margin-right":
        i = $e.getMarginRight(n, r);
        break;
      case "margin-bottom":
        i = $e.getMarginBottom(n, r);
        break;
      case "margin-left":
        i = $e.getMarginLeft(n, r);
        break;
      case "background":
        i = $e.getBackground(n, r);
        break;
      case "background-image":
        i = $e.getBackgroundImage(n, r);
        break;
      case "background-color":
        i = $e.getBackgroundColor(n, r);
        break;
      case "background-repeat":
        i = $e.getBackgroundRepeat(n, r);
        break;
      case "background-attachment":
        i = $e.getBackgroundAttachment(n, r);
        break;
      case "background-position":
        i = $e.getBackgroundPosition(n, r);
        break;
      case "width":
        i = $e.getWidth(n, r);
        break;
      case "height":
        i = $e.getHeight(n, r);
        break;
      case "top":
        i = $e.getTop(n, r);
        break;
      case "right":
        i = $e.getRight(n, r);
        break;
      case "bottom":
        i = $e.getBottom(n, r);
        break;
      case "left":
        i = $e.getLeft(n, r);
        break;
      case "font":
        i = $e.getFont(n, r);
        break;
      case "font-style":
        i = $e.getFontStyle(n, r);
        break;
      case "font-variant":
        i = $e.getFontVariant(n, r);
        break;
      case "font-weight":
        i = $e.getFontWeight(n, r);
        break;
      case "font-stretch":
        i = $e.getFontStretch(n, r);
        break;
      case "font-size":
        i = $e.getFontSize(n, r);
        break;
      case "line-height":
        i = $e.getLineHeight(n, r);
        break;
      case "text-indent":
        i = $e.getTextIndent(n, r);
        break;
      case "font-family":
        i = $e.getFontFamily(n, r);
        break;
      case "color":
        i = $e.getColor(n, r);
        break;
      case "flood-color":
        i = $e.getFloodColor(n, r);
        break;
      case "text-transform":
        i = $e.getTextTransform(n, r);
        break;
      case "visibility":
        i = $e.getVisibility(n, r);
        break;
      case "aspect-ratio":
        i = $e.getAspectRatio(n, r);
        break;
      default:
        const s = n.trim();
        if (s) {
          const a = M.getGlobal(s);
          i = {
            [e]: { value: a || s, important: r }
          };
        }
        break;
    }
    i !== null && Object.keys(i).length > 0 && (this.definedPropertyNames[e] = !0, Object.assign(this.properties, i));
  }
  /**
   * Returns a clone.
   *
   * @returns Clone.
   */
  clone() {
    const e = this.constructor, n = new e();
    return n.properties = JSON.parse(JSON.stringify(this.properties)), n.definedPropertyNames = Object.assign({}, this.definedPropertyNames), n;
  }
  /**
   * Returns size.
   *
   * @returns Size.
   */
  size() {
    return Object.keys(this.properties).length;
  }
  /**
   * Returns property name.
   *
   * @param index Index.
   * @returns Property name.
   */
  item(e) {
    return Object.keys(this.properties)[e] || "";
  }
  /**
   * Converts properties to string.
   *
   * @returns String.
   */
  toString() {
    const e = [], n = this.clone(), r = {};
    for (const i of I5e)
      for (const s of i)
        if (Array.isArray(s)) {
          let a = !1;
          for (const o of s) {
            const u = n.get(o);
            u && (r[o] = u, n.remove(o), a = !0);
          }
          if (a)
            break;
        } else {
          const a = n.get(s);
          if (a) {
            r[s] = a, n.remove(s);
            break;
          }
        }
    for (const i of Object.keys(n.properties))
      r[i] = n.get(i);
    for (const i of Object.keys(this.definedPropertyNames)) {
      const s = r[i];
      s && (e.push(`${i}: ${s.value}${s.important ? " !important" : ""};`), delete r[i]);
    }
    for (const i of Object.keys(r)) {
      const s = r[i];
      s && e.push(`${i}: ${s.value}${s.important ? " !important" : ""};`);
    }
    return e.join(" ");
  }
}
const R5e = {
  default: "display: inline;",
  A: "",
  ABBR: "",
  ADDRESS: "display: block;",
  AREA: "",
  ARTICLE: "display: block;",
  ASIDE: "display: block;",
  AUDIO: "display: none;",
  B: "",
  BASE: "display: none;",
  BDI: "",
  BDO: "",
  BLOCKQUAOTE: "",
  BODY: "display: block;",
  TEMPLATE: "display: none;",
  FORM: "display: block;",
  INPUT: "display: inline-block;",
  TEXTAREA: "display: inline-block;",
  SCRIPT: "display: none;",
  IMG: "",
  LINK: "display: none;",
  STYLE: "display: none;",
  LABEL: "",
  SLOT: "display: contents;",
  SVG: "",
  CIRCLE: "",
  ELLIPSE: "",
  LINE: "",
  PATH: "",
  POLYGON: "",
  POLYLINE: "",
  RECT: "",
  STOP: "",
  USE: "",
  META: "display: none;",
  BLOCKQUOTE: "display: block;",
  BR: "",
  BUTTON: "display: inline-block;",
  CANVAS: "",
  CAPTION: "display: table-caption;",
  CITE: "",
  CODE: "",
  COL: "display: table-column;",
  COLGROUP: "display: table-column-group;",
  DATA: "",
  DATALIST: "display: none;",
  DD: "display: block;",
  DEL: "",
  DETAILS: "display: block;",
  DFN: "",
  DIALOG: {
    default: "display: none;",
    open: "display: block;"
  },
  DIV: "display: block;",
  DL: "display: block;",
  DT: "display: block;",
  EM: "",
  EMBED: "",
  FIELDSET: "display: block;",
  FIGCAPTION: "display: block;",
  FIGURE: "display: block;",
  FOOTER: "display: block;",
  H1: "display: block;",
  H2: "display: block;",
  H3: "display: block;",
  H4: "display: block;",
  H5: "display: block;",
  H6: "display: block;",
  HEAD: "display: none;",
  HEADER: "display: block;",
  HGROUP: "display: block;",
  HR: "display: block;",
  HTML: 'display: block;direction: ltr;font: 16px "Times New Roman";',
  I: "",
  IFRAME: "",
  INS: "",
  KBD: "",
  LEGEND: "display: block;",
  LI: "display: list-item;",
  MAIN: "display: block;",
  MAP: "",
  MARK: "",
  MATH: "",
  MENU: "display: block;",
  MENUITEM: "",
  METER: "display: inline-block;",
  NAV: "display: block;",
  NOSCRIPT: "",
  OBJECT: "",
  OL: "display: block;",
  OPTGROUP: "display: block;",
  OPTION: "display: block;",
  OUTPUT: "unicode-bidi: isolate;",
  P: "display: block;",
  PARAM: "display: none;",
  PICTURE: "",
  PRE: "display: block;",
  PROGRESS: "display: inline-block;",
  Q: "",
  RB: "",
  RP: "display: none;",
  RT: "",
  RTC: "",
  RUBY: "",
  S: "",
  SAMP: "",
  SECTION: "display: block;",
  SELECT: "display: inline-block;",
  SMALL: "",
  SOURCE: "",
  SPAN: "",
  STRONG: "",
  SUB: "",
  SUMMARY: "display: block;",
  SUP: "",
  TABLE: "display: table;",
  TBODY: "display: table-row-group;",
  TD: "display: table-cell;",
  TFOOT: "display: table-footer-group;",
  TH: "display: table-cell;",
  THEAD: "display: table-header-group;",
  TIME: "",
  TITLE: "display: none;",
  TR: "display: table-row;",
  TRACK: "",
  U: "",
  UL: "display: block;",
  VAR: "",
  VIDEO: "",
  WBR: ""
}, P5e = {
  "border-collapse": !0,
  "border-spacing": !0,
  "caption-side": !0,
  color: !0,
  cursor: !0,
  direction: !0,
  "empty-cells": !0,
  "font-family": !0,
  "font-size": !0,
  "font-style": !0,
  "font-variant": !0,
  "font-weight": !0,
  "font-size-adjust": !0,
  "font-stretch": !0,
  font: !0,
  "letter-spacing": !0,
  "line-height": !0,
  "list-style-image": !0,
  "list-style-position": !0,
  "list-style-type": !0,
  "list-style": !0,
  orphans: !0,
  quotes: !0,
  "tab-size": !0,
  "text-align": !0,
  "text-align-last": !0,
  "text-decoration-color": !0,
  "text-indent": !0,
  "text-justify": !0,
  "text-shadow": !0,
  "text-transform": !0,
  visibility: !0,
  "white-space": !0,
  widows: !0,
  "word-break": !0,
  "word-spacing": !0,
  "word-wrap": !0
}, L5e = [
  "background-position-x",
  "background-position-y",
  "background-size",
  "border-image-outset",
  "border-top-width",
  "border-right-width",
  "border-bottom-width",
  "border-left-width",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-bottom-right-radius",
  "border-bottom-left-radius",
  "border-image-width",
  "clip",
  "font-size",
  "padding-top",
  "padding-right",
  "padding-bottom",
  "padding-left",
  "margin-top",
  "margin-right",
  "margin-bottom",
  "margin-left",
  "width",
  "height",
  "min-width",
  "min-height",
  "max-width",
  "max-height",
  "top",
  "right",
  "bottom",
  "left",
  "outline-width",
  "outline-offset",
  "letter-spacing",
  "word-spacing",
  "text-indent",
  "line-height"
];
class Ws {
  target;
  classes;
  cache = /* @__PURE__ */ new Map();
  /**
   * Constructor.
   *
   * @param target Target.
   * @param classes Classes.
   */
  constructor(e, n) {
    this.target = e, this.classes = n;
  }
  /**
   * Binds method, getters and setters to a target.
   *
   * @param name Method name.
   */
  bind(e) {
    if (this.cache.has(e) || e === Symbol.iterator || e === "constructor")
      return;
    this.cache.set(e, !0);
    const n = this.target;
    if (e in n)
      for (const r of this.classes) {
        const i = Object.getOwnPropertyDescriptor(r.prototype, e);
        if (i) {
          if (typeof i.value == "function") {
            if (i.value.toString().startsWith("class "))
              return;
            Object.defineProperty(n, e, {
              ...i,
              value: i.value.bind(n)
            });
          } else i.get !== void 0 && Object.defineProperty(n, e, {
            ...i,
            get: i.get?.bind(n),
            set: i.set?.bind(n)
          });
          return;
        }
      }
  }
  /**
   * Prevents a method, getter or setter from being bound.
   *
   * @param name Method name.
   */
  preventBinding(e) {
    this.cache.set(e, !0);
  }
}
class xo {
  [Ge];
  [yn];
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param items Items.
   */
  constructor(e, n) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[Ge] = n;
    const r = new Ws(this, this.constructor !== xo ? [this.constructor, xo] : [xo]), i = new Proxy(this, {
      get: (s, a) => {
        if (a === "length")
          return n.length;
        if (a in s || typeof a == "symbol")
          return r.bind(a), s[a];
        if (a === "")
          return;
        const o = Number(a);
        if (!isNaN(o))
          return n[o];
      },
      set(s, a, o) {
        if (r.bind(a), typeof a == "symbol")
          return s[a] = o, !0;
        const u = Number(a);
        return isNaN(u) && (s[a] = o), !0;
      },
      deleteProperty(s, a) {
        if (typeof a == "symbol")
          return delete s[a], !0;
        const o = Number(a);
        return isNaN(o) && delete s[a], !0;
      },
      ownKeys() {
        return Object.keys(n);
      },
      has(s, a) {
        if (a in s)
          return !0;
        if (typeof a == "symbol")
          return !1;
        const o = Number(a);
        return !isNaN(o) && o >= 0 && o < n.length;
      },
      defineProperty(s, a, o) {
        return r.preventBinding(a), a in s ? (Object.defineProperty(s, a, o), !0) : !1;
      },
      getOwnPropertyDescriptor(s, a) {
        if (a in s || typeof a == "symbol")
          return;
        const o = Number(a);
        if (!isNaN(o) && n[o])
          return {
            value: n[o],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
    return this[yn] = i, i;
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[Ge].length;
  }
  /**
   * Returns `Symbol.toStringTag`.
   *
   * @returns `Symbol.toStringTag`.
   */
  get [Symbol.toStringTag]() {
    return "NodeList";
  }
  /**
   * Returns `[object NodeList]`.
   *
   * @returns `[object NodeList]`.
   */
  toLocaleString() {
    return "[object NodeList]";
  }
  /**
   * Returns `[object NodeList]`.
   *
   * @returns `[object NodeList]`.
   */
  toString() {
    return "[object NodeList]";
  }
  /**
   * Returns item by index.
   *
   * @param index Index.
   */
  item(e) {
    const n = this[Ge];
    return e >= 0 && n[e] ? n[e] : null;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  [Symbol.iterator]() {
    return this[Ge][Symbol.iterator]();
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  values() {
    return this[Ge].values();
  }
  /**
   * Returns an iterator, allowing you to go through all key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  entries() {
    return this[Ge].entries();
  }
  /**
   * Executes a provided callback function once for each DOMTokenList element.
   *
   * @param callback Function.
   * @param thisArg thisArg.
   */
  forEach(e, n) {
    const r = this[Ge], i = this[yn] ?? this;
    for (let s = 0, a = r.length; s < a; s++) {
      const o = r[s];
      e.call(n ?? o[b], o, s, i);
    }
  }
  /**
   * Returns an iterator, allowing you to go through all keys of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  keys() {
    return this[Ge].keys();
  }
}
var Gv;
(function(t) {
  t.descendant = "descendant", t.child = "child", t.adjacentSibling = "adjacentSibling", t.subsequentSibling = "subsequentSibling";
})(Gv || (Gv = {}));
const Ur = Gv;
class Vo {
  root;
  scope;
  tagName;
  id;
  classNames;
  attributes;
  pseudos;
  isPseudoElement;
  combinator;
  ignoreErrors;
  /**
   * Constructor.
   *
   * @param [options] Options.
   * @param [options.scope] Scope.
   * @param [options.combinator] Combinator.
   * @param [options.tagName] Tag name.
   * @param [options.id] ID.
   * @param [options.classNames] Class names.
   * @param [options.attributes] Attributes.
   * @param [options.pseudos] Pseudos.
   * @param [options.isPseudoElement] Is pseudo element.
   * @param [options.ignoreErrors] Ignore errors.
   */
  constructor(e) {
    this.root = e?.scope ? e.scope[he].documentElement : null, this.scope = e?.scope || null, this.tagName = e?.tagName || null, this.id = e?.id || null, this.classNames = e?.classNames || null, this.attributes = e?.attributes || null, this.pseudos = e?.pseudos || null, this.isPseudoElement = e?.isPseudoElement || !1, this.combinator = e?.combinator || Ur.descendant, this.ignoreErrors = e?.ignoreErrors || !1;
  }
  /**
   * Matches a selector against an element.
   *
   * @param element HTML element.
   * @returns Result.
   */
  match(e) {
    let n = 0;
    if (this.isPseudoElement)
      return null;
    if (this.tagName) {
      if (this.tagName !== "*" && this.tagName !== e[Xe].toUpperCase())
        return null;
      n += 1;
    }
    if (this.id) {
      if (this.id !== e.id)
        return null;
      n += 100;
    }
    if (this.classNames) {
      const r = this.matchClass(e);
      if (!r)
        return null;
      n += r.priorityWeight;
    }
    if (this.attributes) {
      const r = this.matchAttributes(e);
      if (!r)
        return null;
      n += r.priorityWeight;
    }
    if (this.pseudos) {
      const r = this.matchPseudo(e);
      if (!r)
        return null;
      n += r.priorityWeight;
    }
    return { priorityWeight: n };
  }
  /**
   * Matches a pseudo selector.
   *
   * @param element Element.
   * @returns Result.
   */
  matchPseudo(e) {
    const n = e[xe], r = e[xe] ? e[xe][Ft] : [];
    if (!this.pseudos)
      return { priorityWeight: 0 };
    let i = 0;
    for (const s of this.pseudos) {
      switch (s.name) {
        case "not":
        case "nth-child":
        case "nth-of-type":
        case "nth-last-child":
        case "nth-last-of-type":
        case "is":
        case "where":
          if (!s.arguments) {
            if (this.ignoreErrors)
              return null;
            throw new e[b].DOMException(`Failed to execute 'matches' on '${e.constructor.name}': '${this.getSelectorString()}' is not a valid selector.`);
          }
          break;
      }
      if (!n)
        switch (s.name) {
          case "first-child":
          case "last-child":
          case "only-child":
          case "first-of-type":
          case "last-of-type":
          case "only-of-type":
          case "nth-child":
          case "nth-of-type":
          case "nth-last-child":
          case "nth-last-of-type":
            return null;
        }
      const a = this.matchPseudoItem(e, r, s);
      if (!a)
        return null;
      i += a.priorityWeight;
    }
    return { priorityWeight: i };
  }
  /**
   * Matches a pseudo selector.
   *
   * @param element Element.
   * @param parentChildren Parent children.
   * @param pseudo Pseudo.
   */
  matchPseudoItem(e, n, r) {
    switch (r.name) {
      case "first-child":
        return n[0] === e ? { priorityWeight: 10 } : null;
      case "last-child":
        return n.length && n[n.length - 1] === e ? { priorityWeight: 10 } : null;
      case "only-child":
        return n.length === 1 && n[0] === e ? { priorityWeight: 10 } : null;
      case "first-of-type":
        for (const m of n)
          if (m[Xe] === e[Xe])
            return m === e ? { priorityWeight: 10 } : null;
        return null;
      case "last-of-type":
        for (let m = n.length - 1; m >= 0; m--) {
          const g = n[m];
          if (g[Xe] === e[Xe])
            return g === e ? { priorityWeight: 10 } : null;
        }
        return null;
      case "only-of-type":
        let i = !1;
        for (const m of n)
          if (m[Xe] === e[Xe]) {
            if (i || m !== e)
              return null;
            i = !0;
          }
        return i ? { priorityWeight: 10 } : null;
      case "checked":
        return e[Xe] === "INPUT" && e.checked ? { priorityWeight: 10 } : null;
      case "disabled":
        return "disabled" in e && e.hasAttribute("disabled") ? { priorityWeight: 10 } : null;
      case "empty":
        return e[Ft].length ? null : { priorityWeight: 10 };
      case "root":
        return this.root && e === this.root ? { priorityWeight: 10 } : null;
      case "not":
        for (const m of r.selectorItems)
          if (m.match(e))
            return null;
        return { priorityWeight: 10 };
      case "nth-child":
        let s = -1;
        if (r.selectorItems?.[0] && !r.selectorItems[0].match(e))
          return null;
        for (let m = 0, g = n.length; m < g; m++)
          if ((!r.selectorItems?.[0] || r.selectorItems[0].match(n[m])) && s++, n[m] === e)
            return s !== -1 && r.nthFunction(s + 1) ? { priorityWeight: 10 } : null;
        return null;
      case "nth-of-type":
        let a = -1;
        for (let m = 0, g = n.length; m < g; m++)
          if (n[m][Xe] === e[Xe] && a++, n[m] === e)
            return a !== -1 && r.nthFunction(a + 1) ? { priorityWeight: 10 } : null;
        return null;
      case "nth-last-child":
        let o = -1;
        if (r.selectorItems?.[0] && !r.selectorItems[0].match(e))
          return null;
        for (let m = n.length - 1; m >= 0; m--)
          if ((!r.selectorItems?.[0] || r.selectorItems[0].match(n[m])) && o++, n[m] === e)
            return o !== -1 && r.nthFunction(o + 1) ? { priorityWeight: 10 } : null;
        return null;
      case "nth-last-of-type":
        let u = -1;
        for (let m = n.length - 1; m >= 0; m--)
          if (n[m][Xe] === e[Xe] && u++, n[m] === e)
            return u !== -1 && r.nthFunction(u + 1) ? { priorityWeight: 10 } : null;
        return null;
      case "target":
        const l = e[he].location.hash;
        return l && e.isConnected && e.id === l.slice(1) ? { priorityWeight: 10 } : null;
      case "is":
        let h = 0;
        if (!r.selectorItems)
          return null;
        for (const m of r.selectorItems) {
          const g = m.match(e);
          g && h < g.priorityWeight && (h = g.priorityWeight);
        }
        return h ? { priorityWeight: h } : null;
      case "where":
        if (!r.selectorItems)
          return null;
        for (const m of r.selectorItems)
          if (m.match(e))
            return { priorityWeight: 0 };
        return null;
      case "has":
        let f = 0;
        if (r.arguments && r.selectorItems)
          if (r.arguments[0] === "+") {
            const m = e.nextElementSibling;
            if (!m)
              return null;
            for (const g of r.selectorItems) {
              const A = g.match(m);
              A && f < A.priorityWeight && (f = A.priorityWeight);
            }
          } else if (r.arguments[0] === ">")
            for (const m of r.selectorItems)
              for (const g of e[Ft]) {
                const A = m.match(g);
                if (A && f < A.priorityWeight) {
                  f = A.priorityWeight;
                  break;
                }
              }
          else
            for (const m of r.selectorItems) {
              const g = this.matchChildOfElement(m, e);
              g && f < g.priorityWeight && (f = g.priorityWeight);
            }
        return f ? { priorityWeight: f } : null;
      case "focus":
      case "focus-visible":
        return e[he].activeElement === e ? { priorityWeight: 10 } : null;
      case "scope":
        return this.scope && this.scope === e ? { priorityWeight: 10 } : null;
      default:
        return null;
    }
  }
  /**
   * Matches attribute.
   *
   * @param element Element.
   * @returns Result.
   */
  matchAttributes(e) {
    if (!this.attributes)
      return null;
    let n = 0;
    for (const r of this.attributes) {
      const i = e[bt].getNamedItem(r.name);
      if (!i || (n += 10, r.value !== null && (i[ze] === null || r.regExp && !r.regExp.test(i[ze]) || !r.regExp && r.value !== i[ze])))
        return null;
    }
    return { priorityWeight: n };
  }
  /**
   * Matches class.
   *
   * @param element Element.
   * @returns Result.
   */
  matchClass(e) {
    if (!this.classNames)
      return null;
    let n = 0;
    for (const r of this.classNames) {
      if (!e.classList.contains(r))
        return null;
      n += 10;
    }
    return { priorityWeight: n };
  }
  /**
   * Matches a selector item against children of an element.
   *
   * @param selectorItem Selector item.
   * @param element Element.
   * @returns Result.
   */
  matchChildOfElement(e, n) {
    for (const r of n[Ft]) {
      const i = e.match(r);
      if (i)
        return i;
      const s = this.matchChildOfElement(e, r);
      if (s)
        return s;
    }
    return null;
  }
  /**
   * Returns the selector string.
   *
   * @returns Selector string.
   */
  getSelectorString() {
    return `${this.tagName ? this.tagName.toLowerCase() : ""}${this.id ? `#${this.id}` : ""}${this.classNames ? `.${this.classNames.join(".")}` : ""}${this.attributes ? this.attributes.map((e) => `[${e.name}${e.value ? `${e.operator || ""}="${e.value}"` : ""}]`).join("") : ""}${this.pseudos ? this.pseudos.map((e) => `:${e.name}${e.arguments ? `(${e.arguments})` : ""}`).join("") : ""}`;
  }
}
const M5e = /(\*)|([a-zA-Z0-9-]+)|#((?:[a-zA-Z0-9-_«»]|\\.)+)|\.((?:[a-zA-Z0-9-_«»]|\\.)+)|\[([a-zA-Z0-9-_\\:]+)\]|\[([a-zA-Z0-9-_\\:]+)\s*([~|^$*]{0,1})\s*=\s*["']{1}([^"']*)["']{1}\s*(s|i){0,1}\]|\[([a-zA-Z0-9-_]+)\s*([~|^$*]{0,1})\s*=\s*([^\]]*)\]|:([a-zA-Z-]+)\s*\(((?:[^()]|\[[^\]]*\]|\([^()]*\))*)\){0,1}|:([a-zA-Z-]+)|::([a-zA-Z-]+)|([\s,+>~]*)/gm, by = /\\/g, O5e = /[.*+?^${}()|[\]\\]/g, LL = {
  odd: (t) => (t + 1) % 2 === 0,
  even: (t) => (t + 1) % 2 !== 0
}, B5e = / /g, $5e = /(^[a-zA-Z0-9-]+$)|(^\.[a-zA-Z0-9-_.]+$)|(^#[a-zA-Z0-9-_]+$)/;
class Gy {
  /**
   * Parses a selector string and returns an instance of SelectorItem.
   *
   * @param selector Selector.
   * @param options Options.
   * @param [options.scope] Scope.
   * @param [options.ignoreErrors] Ignores errors.
   * @returns Selector item.
   */
  static getSelectorItem(e, n) {
    return this.getSelectorGroups(e, n)[0][0];
  }
  /**
   * Parses a selector string and returns groups with SelectorItem instances.
   *
   * @param selector Selector.
   * @param options Options.
   * @param [options.scope] Scope.
   * @param [options.ignoreErrors] Ignores errors.
   * @returns Selector groups.
   */
  static getSelectorGroups(e, n) {
    e = e.trim();
    const r = n?.ignoreErrors, i = n?.scope;
    if (e === "*")
      return [[new Vo({ scope: i, tagName: "*", ignoreErrors: r })]];
    const s = e.match($5e);
    if (s) {
      if (s[1])
        return [[new Vo({ scope: i, tagName: e.toUpperCase(), ignoreErrors: r })]];
      if (s[2])
        return [
          [
            new Vo({
              scope: i,
              classNames: e.replace(".", "").split("."),
              ignoreErrors: r
            })
          ]
        ];
      if (s[3])
        return [[new Vo({ scope: i, id: e.replace("#", ""), ignoreErrors: r })]];
    }
    const a = new RegExp(M5e);
    let o = new Vo({
      scope: i,
      combinator: Ur.descendant,
      ignoreErrors: r
    }), u = [o];
    const l = [u];
    let h = !1, f;
    for (; (f = a.exec(e)) && f[0]; )
      if (h = !0, f[1])
        o.tagName = "*";
      else if (f[2])
        o.tagName = f[2].toUpperCase();
      else if (f[3])
        o.id = f[3].replace(by, "");
      else if (f[4])
        o.classNames = o.classNames || [], o.classNames.push(f[4].replace(by, ""));
      else if (f[5])
        o.attributes = o.attributes || [], o.attributes.push({
          name: f[5],
          operator: null,
          value: null,
          modifier: null,
          regExp: null
        });
      else if (f[6] && f[8] !== void 0)
        o.attributes = o.attributes || [], o.attributes.push({
          name: f[6],
          operator: f[7] || null,
          value: f[8].replace(by, ""),
          modifier: f[9] || null,
          regExp: this.getAttributeRegExp({
            operator: f[7],
            value: f[8],
            modifier: f[9]
          })
        });
      else if (f[10] && f[12] !== void 0)
        o.attributes = o.attributes || [], o.attributes.push({
          name: f[10],
          operator: f[11] || null,
          value: f[12].replace(by, ""),
          modifier: null,
          regExp: this.getAttributeRegExp({ operator: f[11], value: f[12] })
        });
      else if (f[13] && f[14])
        o.pseudos = o.pseudos || [], o.pseudos.push(this.getPseudo(f[13], f[14], n));
      else if (f[15])
        o.pseudos = o.pseudos || [], o.pseudos.push(this.getPseudo(f[15], null, n));
      else if (f[16])
        o.isPseudoElement = !0;
      else if (f[17])
        switch (f[17].trim()) {
          case ",":
            o = new Vo({
              scope: i,
              combinator: Ur.descendant,
              ignoreErrors: r
            }), u = [o], l.push(u);
            break;
          case ">":
            o = new Vo({
              scope: i,
              combinator: Ur.child,
              ignoreErrors: r
            }), u.push(o);
            break;
          case "+":
            o = new Vo({
              scope: i,
              combinator: Ur.adjacentSibling,
              ignoreErrors: r
            }), u.push(o);
            break;
          case "~":
            o = new Vo({
              scope: i,
              combinator: Ur.subsequentSibling,
              ignoreErrors: r
            }), u.push(o);
            break;
          case "":
            o = new Vo({
              scope: i,
              combinator: Ur.descendant,
              ignoreErrors: r
            }), u.push(o);
            break;
        }
    if (!h) {
      if (n?.ignoreErrors)
        return [];
      throw new Tr(`Invalid selector: "${e}"`);
    }
    return l;
  }
  /**
   * Returns attribute RegExp.
   *
   * @param attribute Attribute.
   * @param attribute.value Attribute value.
   * @param attribute.operator Attribute operator.
   * @param attribute.modifier Attribute modifier.
   * @returns Attribute RegExp.
   */
  static getAttributeRegExp(e) {
    const n = e.modifier === "i" ? "i" : "";
    if (!e.operator || !e.value)
      return null;
    const r = e.value.replace(O5e, "\\$&");
    switch (e.operator) {
      // [attribute~="value"] - Contains a specified word.
      case "~":
        return new RegExp(`[- ]${r}|${r}[- ]|^${r}$`, n);
      // [attribute|="value"] - Starts with the specified word.
      case "|":
        return new RegExp(`^${r}[- ]|^${r}$`, n);
      // [attribute^="value"] - Begins with a specified value.
      case "^":
        return new RegExp(`^${r}`, n);
      // [attribute$="value"] - Ends with a specified value.
      case "$":
        return new RegExp(`${r}$`, n);
      // [attribute*="value"] - Contains a specified value.
      case "*":
        return new RegExp(`${r}`, n);
      default:
        return null;
    }
  }
  /**
   * Returns pseudo.
   *
   * @param name Pseudo name.
   * @param args Pseudo arguments.
   * @param [options] Options.
   * @param [options.scope] Scope.
   * @param [options.ignoreErrors] Ignores errors.
   * @returns Pseudo.
   */
  static getPseudo(e, n, r) {
    const i = e.toLowerCase();
    if (n && (n = n.trim()), !n)
      return { name: i, arguments: null, selectorItems: null, nthFunction: null };
    switch (i) {
      case "nth-last-child":
      case "nth-child":
        const s = n.indexOf(" of "), a = s !== -1 ? n.substring(0, s) : n, o = s !== -1 ? this.getSelectorItem(n.substring(s + 4).trim(), r) : null;
        return {
          name: i,
          arguments: n,
          selectorItems: o ? [o] : null,
          nthFunction: this.getPseudoNthFunction(a)
        };
      case "nth-of-type":
      case "nth-last-of-type":
        return {
          name: i,
          arguments: n,
          selectorItems: null,
          nthFunction: this.getPseudoNthFunction(n)
        };
      case "not":
        const u = [];
        for (const f of this.getSelectorGroups(n, r))
          u.push(f[0]);
        return {
          name: i,
          arguments: n,
          selectorItems: u,
          nthFunction: null
        };
      case "is":
      case "where":
        const l = [];
        for (const f of this.getSelectorGroups(n, r))
          l.push(f[0]);
        return {
          name: i,
          arguments: n,
          selectorItems: l,
          nthFunction: null
        };
      case "has":
        const h = [];
        if (!n.includes(":has(")) {
          let f = n;
          n[0] === "+" ? f = n.replace("+", "") : n[0] === ">" && (f = n.replace(">", ""));
          for (const m of this.getSelectorGroups(f, r))
            h.push(m[0]);
        }
        return {
          name: i,
          arguments: n || "",
          selectorItems: h,
          nthFunction: null
        };
      default:
        return { name: i, arguments: n, selectorItems: null, nthFunction: null };
    }
  }
  /**
   * Returns pseudo nth function.
   *
   * Based on:
   * https://github.com/dperini/nwsapi/blob/master/src/nwsapi.js
   *
   * @param args Pseudo arguments.
   * @returns Pseudo nth function.
   */
  static getPseudoNthFunction(e) {
    if (!e)
      return null;
    if (e === "odd")
      return LL.odd;
    if (e === "even")
      return LL.even;
    const n = e.replace(B5e, "").split("n");
    let r = parseInt(n[0], 10) || 0;
    if (n[0] == "-" && (r = -1), n.length === 1)
      return (s) => s == r;
    let i = parseInt(n[1], 10) || 0;
    return n[0] == "+" && (i = 1), r >= 1 || r <= -1 ? r >= 1 ? Math.abs(r) === 1 ? (s) => s > i - 1 : (s) => s > i - 1 && (s + -1 * i) % r === 0 : Math.abs(r) === 1 ? (s) => s < i + 1 : (s) => s < i + 1 && (s + -1 * i) % r === 0 : n[0] ? (s) => s === i : (s) => s > i - 1;
  }
}
const $F = /^[.#\[]?\d|[.#]$/;
class it {
  /**
   * Finds elements based on a query selector.
   *
   * @param node Node to search in.
   * @param selector Selector.
   * @returns HTML elements.
   */
  static querySelectorAll(e, n) {
    const r = e[b];
    if (n === "")
      throw new r.DOMException(`Failed to execute 'querySelectorAll' on '${e.constructor.name}': The provided selector is empty.`);
    if (typeof n == "function")
      throw new r.DOMException(`Failed to execute 'querySelectorAll' on '${e.constructor.name}': '${n}' is not a valid selector.`);
    if (typeof n == "symbol")
      throw new r.TypeError(`Failed to execute 'querySelectorAll' on '${e.constructor.name}': Cannot convert a Symbol value to a string`);
    if (n = String(n), $F.test(n))
      throw new r.DOMException(`Failed to execute 'querySelectorAll' on '${e.constructor.name}': '${n}' is not a valid selector.`);
    const i = e[Ae].querySelectorAll, s = i.get(n);
    if (s) {
      if (s.result !== null) {
        const A = s.result.deref();
        if (A)
          return A;
      }
      i.delete(n);
    }
    const a = e[ve] === le.documentNode ? e.documentElement : e, o = Gy.getSelectorGroups(n, { scope: a }), u = [], l = new xo(T, u), h = /* @__PURE__ */ new Map(), f = [], m = {
      result: new WeakRef(l)
    };
    e[Ae].querySelectorAll.set(n, m), e[st] && (e[he] || e)[li].push(m);
    for (const A of o) {
      const E = e[ve] === le.elementNode ? this.findAll(e, [e], A, m) : this.findAll(null, e[Ft], A, m);
      for (const w of E)
        h.has(w.documentPosition) || (h.set(w.documentPosition, w.element), f.push(w.documentPosition));
    }
    const g = f.sort();
    for (let A = 0, E = g.length; A < E; A++)
      u.push(h.get(g[A]));
    return l;
  }
  /**
   * Finds an element based on a query selector.
   *
   * @param node Node to search in.
   * @param selector Selector.
   * @returns HTML element.
   */
  static querySelector(e, n) {
    const r = e[b];
    if (n === "")
      throw new r.DOMException(`Failed to execute 'querySelector' on '${e.constructor.name}': The provided selector is empty.`);
    if (typeof n == "function")
      throw new r.DOMException(`Failed to execute 'querySelector' on '${e.constructor.name}': '${n}' is not a valid selector.`);
    if (typeof n == "symbol")
      throw new r.TypeError(`Failed to execute 'querySelector' on '${e.constructor.name}': Cannot convert a Symbol value to a string`);
    if (n = String(n), $F.test(n))
      throw new r.DOMException(`Failed to execute 'querySelector' on '${e.constructor.name}': '${n}' is not a valid selector.`);
    const i = e[Ae].querySelector.get(n);
    if (i) {
      if (i.result !== null) {
        if (!i.result.element)
          return null;
        const h = i.result.element.deref();
        if (h)
          return h;
      }
      e[Ae].querySelector.delete(n);
    }
    const s = {
      result: { element: null }
    };
    e[Ae].querySelector.set(n, s), e[st] && (e[he] || e)[li].push(s);
    let a = null;
    const o = /* @__PURE__ */ new Map(), u = e[ve] === le.documentNode ? e.documentElement : e;
    for (const h of Gy.getSelectorGroups(n, { scope: u })) {
      const f = e[ve] === le.elementNode ? this.findFirst(e, [e], h, s) : this.findFirst(null, e[Ft], h, s);
      f && !o.has(f.documentPosition) && (o.set(f.documentPosition, !0), (!a || f.documentPosition < a.documentPosition) && (a = f));
    }
    const l = a?.element || null;
    return s.result = { element: l ? new WeakRef(l) : null }, l;
  }
  /**
   * Checks if an element matches a selector and returns priority weight.
   *
   * @param element Element to match.
   * @param selector Selector to match with.
   * @param [options] Options.
   * @param [options.scope] Scope.
   * @param [options.ignoreErrors] Ignores errors.
   * @returns Result.
   */
  static matches(e, n, r) {
    const i = r?.ignoreErrors, s = e[b];
    if (n === "*")
      return {
        priorityWeight: 1
      };
    if (n === "") {
      if (i)
        return null;
      throw new s.DOMException(`Failed to execute 'matches' on '${e.constructor.name}': The provided selector is empty.`);
    }
    if (typeof n == "function") {
      if (i)
        return null;
      throw new s.DOMException(`Failed to execute 'matches' on '${e.constructor.name}': '${n}' is not a valid selector.`);
    }
    if (typeof n == "symbol") {
      if (i)
        return null;
      throw new s.TypeError("Cannot convert a Symbol value to a string");
    }
    if (n = String(n), $F.test(n)) {
      if (i)
        return null;
      throw new s.DOMException(`Failed to execute 'matches' on '${e.constructor.name}': '${n}' is not a valid selector.`);
    }
    const a = e[Ae].matches.get(n);
    if (a) {
      if (a.result !== null)
        return a.result.match;
      e[Ae].matches.delete(n);
    }
    const o = {
      result: { match: null }
    };
    e[Ae].matches.set(n, o), e[st] && (e[he] || e)[li].push(o);
    const u = r?.scope || e, l = u[ve] === le.documentNode ? u.documentElement : u;
    for (const h of Gy.getSelectorGroups(n, {
      ...r,
      scope: l
    })) {
      const f = this.matchSelector(e, h.reverse(), o);
      if (f)
        return o.result.match = f, f;
    }
    return null;
  }
  /**
   * Checks if a node matches a selector.
   *
   * @param element Target element.
   * @param currentElement
   * @param selectorItems Selector items.
   * @param cachedItem Cached item.
   * @param [previousSelectorItem] Previous selector item.
   * @param [priorityWeight] Priority weight.
   * @returns Result.
   */
  static matchSelector(e, n, r, i = null, s = 0) {
    const a = n[0], o = a.match(e);
    if (o) {
      if (n.length === 1)
        return {
          priorityWeight: s + o.priorityWeight
        };
      switch (a.combinator) {
        case Ur.adjacentSibling:
          const u = e.previousElementSibling;
          if (u) {
            u[li].push(r);
            const f = this.matchSelector(u, n.slice(1), r, a, s + o.priorityWeight);
            if (f)
              return f;
          }
          break;
        case Ur.child:
        case Ur.descendant:
          const l = e.parentElement;
          if (l) {
            l[li].push(r);
            const f = this.matchSelector(l, n.slice(1), r, a, s + o.priorityWeight);
            if (f)
              return f;
          }
          break;
        case Ur.subsequentSibling:
          const h = e.parentElement;
          if (h) {
            const f = h[Ft], m = f.indexOf(e);
            h[li].push(r);
            for (let g = m - 1; g >= 0; g--) {
              const A = f[g];
              A[li].push(r);
              const E = this.matchSelector(A, n.slice(1), r, a, s + o.priorityWeight);
              if (E)
                return E;
            }
          }
          break;
      }
    }
    if (i?.combinator === Ur.descendant) {
      const u = e.parentElement;
      if (u)
        return this.matchSelector(u, n, r, i, s);
    }
    return null;
  }
  /**
   * Finds elements based on a query selector for a part of a list of selectors separated with comma.
   *
   * @param rootElement Root element.
   * @param children Child elements.
   * @param selectorItems Selector items.
   * @param cachedItem Cached item.
   * @param [documentPosition] Document position of the element.
   * @returns Document position and element map.
   */
  static findAll(e, n, r, i, s) {
    const a = r[0], o = r[1];
    let u = [];
    for (let l = 0, h = n.length; l < h; l++) {
      const f = n[l], m = f[Ft], g = (s ? s + ">" : "") + String.fromCharCode(l);
      if (f[li].push(i), a.match(f))
        if (!o)
          e !== f && u.push({
            documentPosition: g,
            element: f
          });
        else
          switch (o.combinator) {
            case Ur.adjacentSibling:
              const A = f.nextElementSibling;
              A && (u = u.concat(this.findAll(e, [A], r.slice(1), i, g)));
              break;
            case Ur.descendant:
            case Ur.child:
              u = u.concat(this.findAll(e, m, r.slice(1), i, g));
              break;
            case Ur.subsequentSibling:
              const E = n.indexOf(f);
              for (let w = E + 1; w < n.length; w++) {
                const x = n[w];
                u = u.concat(this.findAll(e, [x], r.slice(1), i, g));
              }
              break;
          }
      a.combinator === Ur.descendant && m.length && (u = u.concat(this.findAll(e, m, r, i, g)));
    }
    return u;
  }
  /**
   * Finds an element based on a query selector for a part of a list of selectors separated with comma.
   *
   * @param rootElement Root element.
   * @param children Child elements.
   * @param selectorItems Selector items.
   * @param cachedItem Cached item.
   * @param [documentPosition] Document position of the element.
   * @returns Document position and element map.
   */
  static findFirst(e, n, r, i, s) {
    const a = r[0], o = r[1];
    for (let u = 0, l = n.length; u < l; u++) {
      const h = n[u], f = h[Ft], m = (s ? s + ">" : "") + String.fromCharCode(u);
      if (h[li].push(i), a.match(h)) {
        if (o)
          switch (o.combinator) {
            case Ur.adjacentSibling:
              const g = h.nextElementSibling;
              if (g) {
                const w = this.findFirst(e, [g], r.slice(1), i, m);
                if (w)
                  return w;
              }
              break;
            case Ur.descendant:
            case Ur.child:
              const A = this.findFirst(e, f, r.slice(1), i, m);
              if (A)
                return A;
              break;
            case Ur.subsequentSibling:
              const E = n.indexOf(h);
              for (let w = E + 1; w < n.length; w++) {
                const x = n[w], N = this.findFirst(e, [x], r.slice(1), i, m);
                if (N)
                  return N;
              }
              break;
          }
        else if (e !== h)
          return { documentPosition: m, element: h };
      }
      if (a.combinator === Ur.descendant && f.length) {
        const g = this.findFirst(e, f, r, i, m);
        if (g)
          return g;
      }
    }
    return null;
  }
}
class Wv {
  /**
   * Returns measurement in pixels.
   *
   * @param options Options.
   * @param options.window Owner window.
   * @param options.value Measurement (e.g. "10px", "10rem" or "10em").
   * @param options.rootFontSize Root font size in pixels.
   * @param options.parentFontSize Parent font size in pixels.
   * @param [options.parentSize] Parent size in pixels.
   * @returns Measurement in pixels.
   */
  static toPixels(e) {
    const n = parseFloat(e.value), r = e.value.replace(n.toString(), "");
    if (isNaN(n))
      return null;
    switch (r) {
      case "px":
        return n;
      case "rem":
        return this.round(n * parseFloat(e.rootFontSize));
      case "em":
        return this.round(n * parseFloat(e.parentFontSize));
      case "vw":
        return this.round(n * e.window.innerWidth / 100);
      case "vh":
        return this.round(n * e.window.innerHeight / 100);
      case "%":
        return e.parentSize !== void 0 && e.parentSize !== null ? this.round(n * parseFloat(e.parentSize) / 100) : null;
      case "vmin":
        return this.round(n * Math.min(e.window.innerWidth, e.window.innerHeight) / 100);
      case "vmax":
        return n * Math.max(e.window.innerWidth, e.window.innerHeight) / 100;
      case "cm":
        return this.round(n * 37.7812);
      case "mm":
        return this.round(n * 3.7781);
      case "in":
        return this.round(n * 96);
      case "pt":
        return this.round(n * 1.3281);
      case "pc":
        return this.round(n * 16);
      case "Q":
        return this.round(n * 0.945);
      default:
        return null;
    }
  }
  /**
   * Rounds the number with 4 decimals.
   *
   * @param value Value.
   * @returns Rounded value.
   */
  static round(e) {
    return Math.round(e * 1e4) / 1e4;
  }
}
class pt {
  static [ub] = /* @__PURE__ */ new Map();
  static [IF] = 0;
  #e;
  /**
   * Browser window.
   *
   * @param window Window.
   */
  constructor(e) {
    this.#e = e;
  }
  /**
   * Returns the browser settings of the window.
   *
   * @returns Browser settings.
   */
  getSettings() {
    return this.getBrowserFrame()?.page.context.browser.settings || null;
  }
  /**
   * Returns the browser.
   *
   * @returns Browser.
   */
  getBrowser() {
    return this.getBrowserFrame()?.page.context.browser || null;
  }
  /**
   * Returns the browser page.
   *
   * @returns Browser page.
   */
  getBrowserPage() {
    return this.getBrowserFrame()?.page || null;
  }
  /**
   * Returns the browser context.
   *
   * @returns Browser context.
   */
  getBrowserContext() {
    return this.getBrowserFrame()?.page.context || null;
  }
  /**
   * Returns the browser frame of the window.
   *
   * @returns Browser frame.
   */
  getBrowserFrame() {
    return this.#e && this.constructor[ub].get(this.#e[gd]) || null;
  }
  /**
   * Returns the async task manager of the window.
   *
   * @returns Async task manager.
   */
  getAsyncTaskManager() {
    return this.getBrowserFrame()?.[xt] || null;
  }
  /**
   * Assigns the window to a browser frame.
   *
   * @param window Window.
   * @param browserFrame Browser frame.
   */
  static setWindowBrowserFrameRelation(e, n) {
    const r = this[ub];
    e[gd] === -1 && (e[gd] = this[IF], this[IF]++), r.set(e[gd], n);
  }
  /**
   * Assigns the window to a browser frame.
   *
   * @param window Window.
   * @param browserFrame Browser frame.
   */
  static removeWindowBrowserFrameRelation(e) {
    this[ub].delete(e[gd]);
  }
}
let Xr = class {
  [ur] = {
    capturing: /* @__PURE__ */ new Map(),
    bubbling: /* @__PURE__ */ new Map()
  };
  [fl] = {
    capturing: /* @__PURE__ */ new Map(),
    bubbling: /* @__PURE__ */ new Map()
  };
  /**
   * Return a default description for the EventTarget class.
   */
  get [Symbol.toStringTag]() {
    return "EventTarget";
  }
  /**
   * Adds an event listener.
   *
   * @param type Event type.
   * @param listener Listener.
   * @param options An object that specifies characteristics about the event listener.(currently only once)
   * @param options.once
   * @param options.signal An AbortSignal. The listener will be removed when the given AbortSignal object's abort() method is called.
   */
  addEventListener(e, n, r) {
    r = typeof r == "boolean" ? { capture: r } : r || {};
    const i = r.capture ? "capturing" : "bubbling";
    let s = this[ur][i].get(e), a;
    s ? a = this[fl][i].get(e) : (s = [], a = [], this[ur][i].set(e, s), this[fl][i].set(e, a)), !s.includes(n) && (s.push(n), a.push(r), r.signal && !r.signal.aborted && r.signal.addEventListener("abort", () => {
      this.removeEventListener(e, n);
    }));
  }
  /**
   * Adds an event listener.
   *
   * @param type Event type.
   * @param listener Listener.
   */
  removeEventListener(e, n) {
    const r = this[ur].bubbling.get(e);
    if (r) {
      const s = r.indexOf(n);
      if (s !== -1) {
        r.splice(s, 1), this[fl].bubbling.get(e).splice(s, 1);
        return;
      }
    }
    const i = this[ur].capturing.get(e);
    if (i) {
      const s = i.indexOf(n);
      s !== -1 && (i.splice(s, 1), this[fl].capturing.get(e).splice(s, 1));
    }
  }
  /**
   * Dispatches an event.
   *
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#event-flow
   * @see https://www.quirksmode.org/js/events_order.html#link4
   * @param event Event.
   * @returns The return value is false if event is cancelable and at least one of the event handlers which handled this event called Event.preventDefault().
   */
  dispatchEvent(e) {
    return !e[mg] && (e[qn] !== "load" || !e[Ma]) ? (e[mg] = !0, e[Ma] = this[yn] || this, this.#e(e), e[mg] = !1, !(e[hh] && e[vo])) : (this.#t(e), !(e[hh] && e[vo]));
  }
  /**
   * Adds an event listener.
   *
   * TODO:
   * Was used by with IE8- and Opera. React believed Happy DOM was a legacy browser and used them, but that is no longer the case, so we should remove this method after that this is verified.
   *
   * @deprecated
   * @param type Event type.
   * @param listener Listener.
   */
  attachEvent(e, n) {
    this.addEventListener(e.replace("on", ""), n);
  }
  /**
   * Removes an event listener.
   *
   * TODO:
   * Was used by IE8- and Opera. React believed Happy DOM was a legacy browser and used them, but that is no longer the case, so we should remove this method after that this is verified.
   *
   * @deprecated
   * @param type Event type.
   * @param listener Listener.
   */
  detachEvent(e, n) {
    this.removeEventListener(e.replace("on", ""), n);
  }
  /**
   * Destroys the node.
   */
  [tn]() {
    this[ur].capturing.clear(), this[ur].bubbling.clear(), this[fl].capturing.clear(), this[fl].bubbling.clear();
  }
  /**
   * Goes through dispatch event phases.
   *
   * @param event Event.
   */
  #e(e) {
    const n = e.composedPath();
    e[ia] = mr.capturing;
    for (let r = n.length - 1; r >= 0; r--)
      if (e[tu] = n[r], n[r].dispatchEvent(e), e[qd] || e[Dd]) {
        e[ia] = mr.none, e[tu] = null;
        return;
      }
    if (e[ia] = mr.atTarget, e[tu] = this[yn] || this, e[Ma].dispatchEvent(e), e[ia] = mr.bubbling, e[Md] && !e[qd] && !e[Dd]) {
      for (let r = 1, i = n.length; r < i; r++)
        if (e[tu] = n[r], n[r].dispatchEvent(e), e[qd] || e[Dd]) {
          e[ia] = mr.none, e[tu] = null;
          return;
        }
    }
    e[ia] = mr.none, e[tu] = null;
  }
  /**
   * Handles dispatch event listeners.
   *
   * @param event Event.
   */
  #t(e) {
    const n = this[b], r = n ? new pt(n).getSettings() : null, i = e.eventPhase === mr.capturing ? "capturing" : "bubbling", s = this[ur][i].get(e.type)?.slice();
    if (s && s.length) {
      const a = this[fl][i].get(e.type).slice();
      for (let o = 0, u = s.length; o < u; o++) {
        const l = s[o], h = a[o];
        if (h?.passive && (e[L1] = !0), n && (this !== n || e.type !== "error") && !r?.disableErrorCapturing && r?.errorCapture === Rr.tryAndCatch)
          if (l.handleEvent) {
            let f;
            try {
              f = l.handleEvent.call(l, e);
            } catch (m) {
              n[tr](m);
            }
            f instanceof Promise && f.catch((m) => n[tr](m));
          } else {
            let f;
            try {
              f = l.call(this, e);
            } catch (m) {
              n[tr](m);
            }
            f instanceof Promise && f.catch((m) => n[tr](m));
          }
        else
          l.handleEvent ? l.handleEvent.call(l, e) : l.call(this, e);
        if (e[L1] = !1, h?.once && (s.splice(o, 1), a.splice(o, 1), this.removeEventListener(e.type, l), o--, u--), e[Dd])
          return;
      }
    }
    if (e.eventPhase !== mr.capturing) {
      const a = "on" + e.type.toLowerCase(), o = this[F], u = !o && Object.hasOwn(this, a) && this.constructor.name !== "EventTarget";
      if (o || u) {
        const l = o?.get(a) ?? this[a];
        if (typeof l == "function")
          if (n && (this !== n || e.type !== "error") && !r?.disableErrorCapturing && r?.errorCapture === Rr.tryAndCatch) {
            let h;
            try {
              h = l(e);
            } catch (f) {
              n[tr](f);
            }
            h instanceof Promise && h.catch((f) => n[tr](f));
          } else
            l(e);
      }
    }
  }
};
class U7 extends be {
  matches;
  media;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.matches = n?.matches ?? !1, this.media = n?.media ?? "";
  }
}
var Vv;
(function(t) {
  t.all = "all", t.print = "print", t.screen = "screen";
})(Vv || (Vv = {}));
const G7 = Vv;
class HF {
  mediaTypes;
  not;
  rules;
  ranges;
  rootFontSize = null;
  window;
  /**
   * Constructor.
   *
   * @param options Options.
   * @param options.window Owner window.
   * @param [options.rootFontSize] Root font size.
   * @param [options.mediaTypes] Media types.
   * @param [options.not] Not.
   * @param [options.rules] Rules.
   * @param [options.ranges] Ranges.
   */
  constructor(e) {
    this.window = e.window, this.rootFontSize = e.rootFontSize || null, this.mediaTypes = e.mediaTypes || [], this.not = e.not || !1, this.rules = e.rules || [], this.ranges = e.ranges || [];
  }
  /**
   * Returns media string.
   */
  toString() {
    return `${this.not ? "not " : ""}${this.mediaTypes.join(", ")}${(this.not || this.mediaTypes.length > 0) && this.ranges.length ? " and " : ""}${this.ranges.map((e) => `(${e.before ? `${e.before.value} ${e.before.operator} ` : ""}${e.type}${e.after ? ` ${e.after.operator} ${e.after.value}` : ""})`).join(" and ")}${(this.not || this.mediaTypes.length > 0) && this.rules.length ? " and " : ""}${this.rules.map((e) => e.value ? `(${e.name}: ${e.value})` : `(${e.name})`).join(" and ")}`;
  }
  /**
   * Returns "true" if the item matches.
   */
  matches() {
    return this.not ? !this.matchesAll() : this.matchesAll();
  }
  /**
   * Returns "true" if all matches.
   *
   * @returns "true" if all matches.
   */
  matchesAll() {
    if (this.mediaTypes.length) {
      let e = !1;
      for (const n of this.mediaTypes)
        if (this.matchesMediaType(n)) {
          e = !0;
          break;
        }
      if (!e)
        return !1;
    }
    for (const e of this.rules)
      if (!this.matchesRule(e))
        return !1;
    for (const e of this.ranges)
      if (!this.matchesRange(e))
        return !1;
    return !0;
  }
  /**
   * Returns "true" if the mediaType matches.
   *
   * @param mediaType Media type.
   * @returns "true" if the mediaType matches.
   */
  matchesMediaType(e) {
    return e === G7.all ? !0 : e === new pt(this.window).getSettings()?.device.mediaType;
  }
  /**
   * Returns "true" if the range matches.
   *
   * @param range Range.
   * @returns "true" if the range matches.
   */
  matchesRange(e) {
    const n = e.type === "width" ? this.window.innerWidth : this.window.innerHeight;
    if (e.before) {
      const r = this.toPixels(e.before.value);
      if (r === null)
        return !1;
      switch (e.before.operator) {
        case "<":
          if (r >= n)
            return !1;
          break;
        case "<=":
          if (r > n)
            return !1;
          break;
        case ">":
          if (r <= n)
            return !1;
          break;
        case ">=":
          if (r < n)
            return !1;
          break;
      }
    }
    if (e.after) {
      const r = this.toPixels(e.after.value);
      if (r === null)
        return !1;
      switch (e.after.operator) {
        case "<":
          if (n >= r)
            return !1;
          break;
        case "<=":
          if (n > r)
            return !1;
          break;
        case ">":
          if (n <= r)
            return !1;
          break;
        case ">=":
          if (n < r)
            return !1;
          break;
      }
    }
    return !0;
  }
  /**
   * Returns "true" if the rule matches.
   *
   * @param rule Rule.
   * @returns "true" if the rule matches.
   */
  matchesRule(e) {
    const n = new pt(this.window).getSettings();
    if (!n)
      return !1;
    if (!e.value) {
      switch (e.name) {
        case "min-width":
        case "max-width":
        case "min-height":
        case "max-height":
        case "width":
        case "height":
        case "orientation":
        case "prefers-color-scheme":
        case "hover":
        case "any-hover":
        case "any-pointer":
        case "pointer":
        case "display-mode":
        case "min-aspect-ratio":
        case "max-aspect-ratio":
        case "aspect-ratio":
          return !0;
        case "prefers-reduced-motion":
          return n.device.prefersReducedMotion === "reduce";
        case "forced-colors":
          return n.device.forcedColors === "active";
      }
      return !1;
    }
    switch (e.name) {
      case "min-width":
        const r = this.toPixels(e.value);
        return r !== null && this.window.innerWidth >= r;
      case "max-width":
        const i = this.toPixels(e.value);
        return i !== null && this.window.innerWidth <= i;
      case "min-height":
        const s = this.toPixels(e.value);
        return s !== null && this.window.innerHeight >= s;
      case "max-height":
        const a = this.toPixels(e.value);
        return a !== null && this.window.innerHeight <= a;
      case "width":
        const o = this.toPixels(e.value);
        return o !== null && this.window.innerWidth === o;
      case "height":
        const u = this.toPixels(e.value);
        return u !== null && this.window.innerHeight === u;
      case "orientation":
        return e.value === "landscape" ? this.window.innerWidth > this.window.innerHeight : this.window.innerWidth < this.window.innerHeight;
      case "prefers-color-scheme":
        return e.value === n.device.prefersColorScheme;
      case "prefers-reduced-motion":
        return e.value === n.device.prefersReducedMotion;
      case "forced-colors":
        return (e.value === "none" || e.value === "active") && e.value === n.device.forcedColors;
      case "any-hover":
      case "hover":
        return e.value === "none" ? this.window.navigator.maxTouchPoints > 0 : e.value === "hover" ? this.window.navigator.maxTouchPoints === 0 : !1;
      case "any-pointer":
      case "pointer":
        return e.value === "none" ? !1 : e.value === "coarse" ? this.window.navigator.maxTouchPoints > 0 : e.value === "fine" ? this.window.navigator.maxTouchPoints === 0 : !1;
      case "display-mode":
        return e.value === "browser";
      case "min-aspect-ratio":
      case "max-aspect-ratio":
      case "aspect-ratio":
        const l = e.value.split("/"), h = parseInt(l[0], 10), f = parseInt(l[1], 10);
        if (isNaN(h) || isNaN(f))
          return !1;
        switch (e.name) {
          case "min-aspect-ratio":
            return h / f <= this.window.innerWidth / this.window.innerHeight;
          case "max-aspect-ratio":
            return h / f >= this.window.innerWidth / this.window.innerHeight;
          case "aspect-ratio":
            return h / f === this.window.innerWidth / this.window.innerHeight;
        }
    }
    return !1;
  }
  /**
   * Convert to pixels.
   *
   * @param value Value.
   * @returns Value in pixels.
   */
  toPixels(e) {
    return !new pt(this.window).getSettings()?.disableComputedStyleRendering && e.endsWith("em") ? (this.rootFontSize = this.rootFontSize || parseFloat(this.window.getComputedStyle(this.window.document.documentElement).fontSize), Wv.toPixels({
      window: this.window,
      value: e,
      rootFontSize: this.rootFontSize,
      parentFontSize: this.rootFontSize
    })) : Wv.toPixels({
      window: this.window,
      value: e,
      rootFontSize: 16,
      parentFontSize: 16
    });
  }
}
const H5e = /(not|only|all|screen|print)|\(([^\)]+)(\)){0,1}|(,)| +(or|and) +/g, U5e = /[<>]/, G5e = /(?:([0-9]+[a-z]+) *(<|<=|>|>=)){0,1} *(width|height) *(?:(<|<=|>|>=) *([0-9]+[a-z]+)){0,1}/;
class ML {
  /**
   * Parses a media query string.
   *
   * @param options Options.
   * @param options.window Owner window.
   * @param options.mediaQuery Media query string.
   * @param [options.rootFontSize] Root font size.
   * @returns Media query items.
   */
  static parse(e) {
    let n = new HF({
      window: e.window,
      rootFontSize: e.rootFontSize
    });
    const r = [n], i = new RegExp(H5e);
    let s = null;
    for (; s = i.exec(e.mediaQuery.toLowerCase()); )
      if (s[4] === "," || s[5] === "or")
        n = new HF({
          window: e.window,
          rootFontSize: e.rootFontSize
        }), r.push(n);
      else if (s[1] === "all" || s[1] === "screen" || s[1] === "print")
        n.mediaTypes.push(s[1]);
      else if (s[1] === "not")
        n.not = !0;
      else if (s[2]) {
        const a = U5e.test(s[2]) ? s[2].match(G5e) : null;
        if (a && (a[1] || a[5]))
          n.ranges.push({
            before: a[1] ? {
              value: a[1],
              operator: a[2]
            } : null,
            type: a[3],
            after: a[5] ? {
              value: a[5],
              operator: a[4]
            } : null
          });
        else {
          const [o, u] = s[2].split(":"), l = u ? u.trim() : null;
          if (!l && !s[3])
            return [
              new HF({
                window: e.window,
                rootFontSize: e.rootFontSize,
                not: !0,
                mediaTypes: [G7.all]
              })
            ];
          n.rules.push({
            name: o.trim(),
            value: l
          });
        }
      }
    return r;
  }
}
class W7 extends Xr {
  onchange = null;
  #e;
  #t = null;
  #n;
  #r = null;
  /**
   * Constructor.
   *
   * @param options Options.
   * @param options.window Owner window.
   * @param options.media Media.
   * @param [options.rootFontSize] Root font size.
   */
  constructor(e) {
    super(), this.#e = e.window, this.#n = e.media, this.#r = e.rootFontSize || null;
  }
  /**
   * Returns media.
   *
   * @returns Media.
   */
  get media() {
    return this.#t = this.#t || ML.parse({
      window: this.#e,
      mediaQuery: this.#n,
      rootFontSize: this.#r
    }), this.#t.map((e) => e.toString()).join(", ");
  }
  /**
   * Returns "true" if the document matches.
   *
   * @returns Matches.
   */
  get matches() {
    this.#t = this.#t || ML.parse({
      window: this.#e,
      mediaQuery: this.#n,
      rootFontSize: this.#r
    });
    for (const e of this.#t)
      if (!e.matches())
        return !1;
    return !0;
  }
  /**
   * Adds a listener.
   *
   * @deprecated
   * @param callback Callback.
   */
  addListener(e) {
    this.addEventListener("change", e);
  }
  /**
   * Removes listener.
   *
   * @deprecated
   * @param callback Callback.
   */
  removeListener(e) {
    this.removeEventListener("change", e);
  }
  /**
   * @override
   */
  addEventListener(e, n) {
    if (super.addEventListener(e, n), e === "change") {
      let r = !1;
      const i = () => {
        const s = this.matches;
        s !== r && (r = s, this.dispatchEvent(new U7("change", { matches: s, media: this.media })));
      };
      n[dF] = i, this.#e.addEventListener("resize", i);
    }
  }
  /**
   * @override
   */
  removeEventListener(e, n) {
    super.removeEventListener(e, n), e === "change" && n[dF] && this.#e.removeEventListener("resize", n[dF]);
  }
}
class UA extends bp {
  [Ui] = [];
  /**
   * Returns CSS rules.
   *
   * @returns CSS rules.
   */
  get cssRules() {
    return this[Ui];
  }
  /**
   * Inserts a new rule.
   *
   * @param rule Rule.
   * @param [index] Index.
   * @returns The index of the new rule.
   */
  insertRule(e, n) {
    if (arguments.length === 0)
      throw new this[b].TypeError(`Failed to execute 'insertRule' on '${this.constructor.name}': 1 argument required, but only 0 present.`);
    const r = this[U1].parseFromString(e);
    if (r.length === 0 || r.length > 1)
      throw new this[b].DOMException(`Failed to execute 'insertRule' on '${this.constructor.name}': Failed to parse the rule '${e}'.`, ne.syntaxError);
    if (n !== void 0) {
      if (n = Number(n), isNaN(n) || n > this.cssRules.length)
        throw new this[b].DOMException(`Failed to execute 'insertRule' on '${this.constructor.name}': The index provided (${n}) is larger than the maximum index (${this.cssRules.length}).`, ne.indexSizeError);
      return this.cssRules.splice(n, 0, r[0]), n;
    }
    const i = this.cssRules.length;
    return this.cssRules.unshift(r[0]), i;
  }
  /**
   * Removes a rule.
   *
   * @param index Index.
   */
  deleteRule(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError(`Failed to execute 'deleteRule' on '${this.constructor.name}': 1 argument required, but only 0 present.`);
    if (e = Number(e), isNaN(e) || e < 0 || e >= this.cssRules.length)
      throw new this[b].DOMException(`Failed to execute 'deleteRule' on '${this.constructor.name}': the index (${e}) is greater than the length of the rule list.`, ne.indexSizeError);
    this.cssRules.splice(e, 1);
  }
}
class H2 extends UA {
  [fe] = "";
  [_e] = "";
  [Ka] = "";
  /**
   * @override
   */
  get type() {
    return at.containerRule;
  }
  /**
   * @override
   */
  get cssText() {
    let e = "";
    for (const n of this[Ui])
      e += `
  ` + n.cssText;
    return e += `
`, `@${this[Ka]}scope${this[fe] ? ` (${this[fe]})` : ""}${this[_e] ? ` to (${this[_e]})` : ""} {${e}}`;
  }
  /**
   * Returns start.
   *
   * @returns Start.
   */
  get start() {
    return this[fe];
  }
  /**
   * Returns end.
   *
   * @returns End.
   */
  get end() {
    return this[_e];
  }
}
const W5e = /[0-9.]+(px|rem|em|vw|vh|%|vmin|vmax|cm|mm|in|pt|pc|Q)/g, OL = /:host\s*\(([^)]+)\)|:host-context\s*\(([^)]+)\)/, V5e = /var\( *(--[^), ]+)\)/, K5e = /var\( *(--[^), ]+), *([^), ]+)\)/;
class z5e {
  element;
  /**
   * Constructor.
   *
   * @param element Element.
   * @param [computed] Computed.
   */
  constructor(e) {
    this.element = e;
  }
  /**
   * Returns style sheets.
   *
   * @param element Element.
   * @returns Style sheets.
   */
  getComputedStyle() {
    const e = [], n = [];
    let r = {
      element: this.element,
      cssTexts: []
    }, i = [], s = [];
    if (!this.element[st])
      return new Od();
    const a = this.element[Ae].computedStyle;
    if (a?.result) {
      const g = a.result.deref();
      if (g)
        return g;
    }
    for (; r.element; )
      if (r.element[ve] === le.elementNode && (r.element.getRootNode()[ve] === le.documentNode ? e.unshift(r) : i.unshift(r), r.element.shadowRoot && s.push(r), n.unshift(r)), r.element === this.element[he]) {
        const g = this.getStyleSheets(this.element[he]);
        for (const A of g)
          this.parseCSSRules({
            elements: e,
            cssRules: A.cssRules
          });
        for (const A of s) {
          const E = this.getStyleSheets(A.element.shadowRoot);
          for (const w of E)
            this.parseCSSRules({
              elements: [],
              cssRules: w.cssRules,
              hostElement: A
            });
        }
        r = { element: null, cssTexts: [] };
      } else if (r.element[ve] === le.documentFragmentNode && r.element.host) {
        const g = r.element, A = this.getStyleSheets(g);
        r = {
          element: g.host,
          cssTexts: []
        };
        for (const E of A)
          this.parseCSSRules({
            elements: i,
            cssRules: E.cssRules,
            hostElement: r
          });
        for (const E of s) {
          const w = this.getStyleSheets(E.element.shadowRoot);
          for (const x of w)
            this.parseCSSRules({
              elements: [],
              cssRules: x.cssRules,
              hostElement: E
            });
        }
        s = [], i = [];
      } else
        r = {
          element: r.element[xe],
          cssTexts: []
        };
    const o = n[n.length - 1], u = new Od(), l = {};
    let h = 16, f = 16;
    for (const g of n) {
      g.cssTexts.sort((B, P) => B.priorityWeight - P.priorityWeight);
      const A = R5e[g.element[Xe]];
      let E = "";
      if (A)
        if (typeof A == "string")
          E += A;
        else
          for (const B of Object.keys(A))
            (B === "default" || g.element[B]) && (E += A[B]);
      for (const B of g.cssTexts)
        E += B.cssText;
      const w = g.element.getAttribute("style");
      w && (E += w);
      const x = H7.parse(E), N = x.rules;
      Object.assign(l, x.properties);
      for (const { name: B, value: P, important: C } of N)
        if (P5e[B] || g === o) {
          const D = this.parseCSSVariablesInValue(P.trim(), l);
          if (D && (!u.get(B)?.important || C) && (u.set(B, D, C), B === "font" || B === "font-size")) {
            const L = u.properties["font-size"];
            if (L !== null) {
              const k = this.parseMeasurementsInValue({
                value: L.value,
                rootFontSize: h,
                parentFontSize: f,
                parentSize: f
              });
              g.element[Xe] === "HTML" ? h = k : g !== o && (f = k);
            }
          }
        }
    }
    for (const g of L5e) {
      const A = u.properties[g];
      A && (A.value = this.parseMeasurementsInValue({
        value: A.value,
        rootFontSize: h,
        parentFontSize: f,
        // TODO: Only "font-size" is supported when using percentage values. Add support for other properties.
        parentSize: g === "font-size" ? f : null
      }));
    }
    const m = {
      result: new WeakRef(u)
    };
    return this.element[Ae].computedStyle = m, this.element[he][fc].push(m), u;
  }
  /**
   * Returns style sheets.
   *
   * @param root Root element.
   * @returns Style sheets.
   */
  getStyleSheets(e) {
    if (!e)
      return [];
    const n = e.querySelectorAll('style,link[rel="stylesheet"]');
    let r = [];
    for (const i of n) {
      const s = i.sheet;
      s && r.push(s);
    }
    return e.adoptedStyleSheets && (r = r.concat(e.adoptedStyleSheets)), r;
  }
  /**
   * Applies CSS text to elements.
   *
   * @param options Options.
   * @param options.elements Elements.
   * @param options.cssRules CSS rules.
   * @param [options.hostElement] Host element.
   * @param [options.scopeElement] Scope element.
   */
  parseCSSRules(e) {
    if (!e.hostElement && !e.elements.length)
      return;
    const n = this.element[b];
    for (const r of e.cssRules)
      if (r.type === at.styleRule) {
        const i = r.selectorText;
        if (i)
          if (i[0] === ":" && i.startsWith(":host")) {
            if (e.hostElement) {
              let s = !0;
              if (i !== ":host") {
                const a = i.match(OL);
                if (a)
                  if (it.matches(e.hostElement.element, a[1] || a[2], {
                    ignoreErrors: !0,
                    scope: e.scopeElement?.element
                  })) {
                    const u = i?.replace(OL, "").trim();
                    if (u && u[0] !== ":") {
                      s = !1;
                      for (const l of e.elements) {
                        const h = it.matches(l.element, u, {
                          ignoreErrors: !0,
                          scope: e.scopeElement?.element
                        });
                        h && l.cssTexts.push({
                          cssText: r[za],
                          priorityWeight: 10 + h.priorityWeight
                        });
                      }
                    }
                  } else
                    s = !1;
              }
              s && e.hostElement.cssTexts.push({
                cssText: r[za],
                priorityWeight: 10
              });
            }
          } else
            for (const s of e.elements) {
              const a = it.matches(s.element, i, {
                ignoreErrors: !0,
                scope: e.scopeElement?.element
              });
              a && s.cssTexts.push({
                cssText: r[za],
                priorityWeight: a.priorityWeight
              });
            }
      } else if (r.type === at.mediaRule && // TODO: We need to send in a predefined root font size as it will otherwise be calculated using Window.getComputedStyle(), which will cause a never ending loop. Is there another solution?
      new W7({
        window: n,
        media: r.conditionText,
        rootFontSize: this.element[Xe] === "HTML" ? 16 : null
      }).matches)
        this.parseCSSRules({
          elements: e.elements,
          cssRules: r.cssRules,
          hostElement: e.hostElement,
          scopeElement: e.scopeElement
        });
      else if (r.type === at.supportsRule)
        n.CSS.supports(r.conditionText) && this.parseCSSRules({
          elements: e.elements,
          cssRules: r.cssRules,
          hostElement: e.hostElement,
          scopeElement: e.scopeElement
        });
      else if (r.type === at.containerRule && r instanceof H2) {
        const i = [];
        let s = null;
        for (const a of e.elements)
          if (s) {
            if (r[_e] && it.matches(a.element, r[_e], {
              ignoreErrors: !0,
              scope: s.element
            }))
              break;
            i.push(a);
          } else
            it.matches(a.element, r[fe] || ":root", {
              ignoreErrors: !0
            }) && (s = a, i.push(a));
        i.length && this.parseCSSRules({
          elements: i,
          cssRules: r.cssRules,
          hostElement: e.hostElement,
          scopeElement: s
        });
      }
  }
  /**
   * Parses CSS variables in a value.
   *
   * @param value Value.
   * @param cssVariables CSS variables.
   * @returns CSS value.
   */
  parseCSSVariablesInValue(e, n) {
    let r = e, i;
    for (; (i = r.match(V5e)) != null; )
      r = r.replace(i[0], n[i[1]] || "");
    for (; (i = r.match(K5e)) !== null; )
      r = r.replace(i[0], n[i[1]] || i[2]);
    return r;
  }
  /**
   * Parses measurements in a value.
   *
   * @param options Options.
   * @param options.value Value.
   * @param options.rootFontSize Root font size.
   * @param options.parentFontSize Parent font size.
   * @param [options.parentSize] Parent width.
   * @returns CSS value.
   */
  parseMeasurementsInValue(e) {
    if (new pt(this.element[b]).getSettings()?.disableComputedStyleRendering)
      return e.value;
    const n = new RegExp(W5e);
    let r = e.value, i;
    for (; (i = n.exec(e.value)) !== null; )
      if (i[1] !== "px") {
        const s = Wv.toPixels({
          window: this.element[b],
          value: i[0],
          rootFontSize: e.rootFontSize,
          parentFontSize: e.parentFontSize,
          parentSize: e.parentSize
        });
        s !== null && (r = r.replace(i[0], s + "px"));
      }
    return r;
  }
}
class vh {
  // Public properties
  parentRule = null;
  // Internal properties
  [b];
  // Private properties
  #e;
  #t;
  #n = {
    attributeValue: null,
    propertyManager: null
  };
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param [options] Options.
   * @param [options.element] Element.
   * @param [options.computed] Computed.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this.#e = r?.element || null, this.#t = r?.element ? !!r?.computed : !1;
  }
  /**
   * Index properties
   */
  /* eslint-disable jsdoc/require-jsdoc */
  get 0() {
    return this.item(0) || void 0;
  }
  get 1() {
    return this.item(1) || void 0;
  }
  get 2() {
    return this.item(2) || void 0;
  }
  get 3() {
    return this.item(3) || void 0;
  }
  get 4() {
    return this.item(4) || void 0;
  }
  get 5() {
    return this.item(5) || void 0;
  }
  get 6() {
    return this.item(6) || void 0;
  }
  get 7() {
    return this.item(7) || void 0;
  }
  get 8() {
    return this.item(8) || void 0;
  }
  get 9() {
    return this.item(9) || void 0;
  }
  get 10() {
    return this.item(10) || void 0;
  }
  get 11() {
    return this.item(11) || void 0;
  }
  get 12() {
    return this.item(12) || void 0;
  }
  get 13() {
    return this.item(13) || void 0;
  }
  get 14() {
    return this.item(14) || void 0;
  }
  get 15() {
    return this.item(15) || void 0;
  }
  get 16() {
    return this.item(16) || void 0;
  }
  get 17() {
    return this.item(17) || void 0;
  }
  get 18() {
    return this.item(18) || void 0;
  }
  get 19() {
    return this.item(19) || void 0;
  }
  get 20() {
    return this.item(20) || void 0;
  }
  get 21() {
    return this.item(21) || void 0;
  }
  get 22() {
    return this.item(22) || void 0;
  }
  get 23() {
    return this.item(23) || void 0;
  }
  get 24() {
    return this.item(24) || void 0;
  }
  get 25() {
    return this.item(25) || void 0;
  }
  get 26() {
    return this.item(26) || void 0;
  }
  get 27() {
    return this.item(27) || void 0;
  }
  get 28() {
    return this.item(28) || void 0;
  }
  get 29() {
    return this.item(29) || void 0;
  }
  get 30() {
    return this.item(30) || void 0;
  }
  get 31() {
    return this.item(31) || void 0;
  }
  get 32() {
    return this.item(32) || void 0;
  }
  get 33() {
    return this.item(33) || void 0;
  }
  get 34() {
    return this.item(34) || void 0;
  }
  get 35() {
    return this.item(35) || void 0;
  }
  get 36() {
    return this.item(36) || void 0;
  }
  get 37() {
    return this.item(37) || void 0;
  }
  get 38() {
    return this.item(38) || void 0;
  }
  get 39() {
    return this.item(39) || void 0;
  }
  get 40() {
    return this.item(40) || void 0;
  }
  get 41() {
    return this.item(41) || void 0;
  }
  get 42() {
    return this.item(42) || void 0;
  }
  get 43() {
    return this.item(43) || void 0;
  }
  get 44() {
    return this.item(44) || void 0;
  }
  get 45() {
    return this.item(45) || void 0;
  }
  get 46() {
    return this.item(46) || void 0;
  }
  get 47() {
    return this.item(47) || void 0;
  }
  get 48() {
    return this.item(48) || void 0;
  }
  get 49() {
    return this.item(49) || void 0;
  }
  get 50() {
    return this.item(50) || void 0;
  }
  get 51() {
    return this.item(51) || void 0;
  }
  get 52() {
    return this.item(52) || void 0;
  }
  get 53() {
    return this.item(53) || void 0;
  }
  get 54() {
    return this.item(54) || void 0;
  }
  get 55() {
    return this.item(55) || void 0;
  }
  get 56() {
    return this.item(56) || void 0;
  }
  get 57() {
    return this.item(57) || void 0;
  }
  get 58() {
    return this.item(58) || void 0;
  }
  get 59() {
    return this.item(59) || void 0;
  }
  get 60() {
    return this.item(60) || void 0;
  }
  get 61() {
    return this.item(61) || void 0;
  }
  get 62() {
    return this.item(62) || void 0;
  }
  get 63() {
    return this.item(63) || void 0;
  }
  get 64() {
    return this.item(64) || void 0;
  }
  get 65() {
    return this.item(65) || void 0;
  }
  get 66() {
    return this.item(66) || void 0;
  }
  get 67() {
    return this.item(67) || void 0;
  }
  get 68() {
    return this.item(68) || void 0;
  }
  get 69() {
    return this.item(69) || void 0;
  }
  get 70() {
    return this.item(70) || void 0;
  }
  get 71() {
    return this.item(71) || void 0;
  }
  get 72() {
    return this.item(72) || void 0;
  }
  get 73() {
    return this.item(73) || void 0;
  }
  get 74() {
    return this.item(74) || void 0;
  }
  get 75() {
    return this.item(75) || void 0;
  }
  get 76() {
    return this.item(76) || void 0;
  }
  get 77() {
    return this.item(77) || void 0;
  }
  get 78() {
    return this.item(78) || void 0;
  }
  get 79() {
    return this.item(79) || void 0;
  }
  get 80() {
    return this.item(80) || void 0;
  }
  get 81() {
    return this.item(81) || void 0;
  }
  get 82() {
    return this.item(82) || void 0;
  }
  get 83() {
    return this.item(83) || void 0;
  }
  get 84() {
    return this.item(84) || void 0;
  }
  get 85() {
    return this.item(85) || void 0;
  }
  get 86() {
    return this.item(86) || void 0;
  }
  get 87() {
    return this.item(87) || void 0;
  }
  get 88() {
    return this.item(88) || void 0;
  }
  get 89() {
    return this.item(89) || void 0;
  }
  get 90() {
    return this.item(90) || void 0;
  }
  get 91() {
    return this.item(91) || void 0;
  }
  get 92() {
    return this.item(92) || void 0;
  }
  get 93() {
    return this.item(93) || void 0;
  }
  get 94() {
    return this.item(94) || void 0;
  }
  get 95() {
    return this.item(95) || void 0;
  }
  get 96() {
    return this.item(96) || void 0;
  }
  get 97() {
    return this.item(97) || void 0;
  }
  get 98() {
    return this.item(98) || void 0;
  }
  get 99() {
    return this.item(99) || void 0;
  }
  get 100() {
    return this.item(100) || void 0;
  }
  get 101() {
    return this.item(101) || void 0;
  }
  get 102() {
    return this.item(102) || void 0;
  }
  get 103() {
    return this.item(103) || void 0;
  }
  get 104() {
    return this.item(104) || void 0;
  }
  get 105() {
    return this.item(105) || void 0;
  }
  get 106() {
    return this.item(106) || void 0;
  }
  get 107() {
    return this.item(107) || void 0;
  }
  get 108() {
    return this.item(108) || void 0;
  }
  get 109() {
    return this.item(109) || void 0;
  }
  get 110() {
    return this.item(110) || void 0;
  }
  get 111() {
    return this.item(111) || void 0;
  }
  get 112() {
    return this.item(112) || void 0;
  }
  get 113() {
    return this.item(113) || void 0;
  }
  get 114() {
    return this.item(114) || void 0;
  }
  get 115() {
    return this.item(115) || void 0;
  }
  get 116() {
    return this.item(116) || void 0;
  }
  get 117() {
    return this.item(117) || void 0;
  }
  get 118() {
    return this.item(118) || void 0;
  }
  get 119() {
    return this.item(119) || void 0;
  }
  get 120() {
    return this.item(120) || void 0;
  }
  get 121() {
    return this.item(121) || void 0;
  }
  get 122() {
    return this.item(122) || void 0;
  }
  get 123() {
    return this.item(123) || void 0;
  }
  get 124() {
    return this.item(124) || void 0;
  }
  get 125() {
    return this.item(125) || void 0;
  }
  get 126() {
    return this.item(126) || void 0;
  }
  get 127() {
    return this.item(127) || void 0;
  }
  get 128() {
    return this.item(128) || void 0;
  }
  get 129() {
    return this.item(129) || void 0;
  }
  get 130() {
    return this.item(130) || void 0;
  }
  get 131() {
    return this.item(131) || void 0;
  }
  get 132() {
    return this.item(132) || void 0;
  }
  get 133() {
    return this.item(133) || void 0;
  }
  get 134() {
    return this.item(134) || void 0;
  }
  get 135() {
    return this.item(135) || void 0;
  }
  get 136() {
    return this.item(136) || void 0;
  }
  get 137() {
    return this.item(137) || void 0;
  }
  get 138() {
    return this.item(138) || void 0;
  }
  get 139() {
    return this.item(139) || void 0;
  }
  get 140() {
    return this.item(140) || void 0;
  }
  get 141() {
    return this.item(141) || void 0;
  }
  get 142() {
    return this.item(142) || void 0;
  }
  get 143() {
    return this.item(143) || void 0;
  }
  get 144() {
    return this.item(144) || void 0;
  }
  get 145() {
    return this.item(145) || void 0;
  }
  get 146() {
    return this.item(146) || void 0;
  }
  get 147() {
    return this.item(147) || void 0;
  }
  get 148() {
    return this.item(148) || void 0;
  }
  get 149() {
    return this.item(149) || void 0;
  }
  get 150() {
    return this.item(150) || void 0;
  }
  get 151() {
    return this.item(151) || void 0;
  }
  get 152() {
    return this.item(152) || void 0;
  }
  get 153() {
    return this.item(153) || void 0;
  }
  get 154() {
    return this.item(154) || void 0;
  }
  get 155() {
    return this.item(155) || void 0;
  }
  get 156() {
    return this.item(156) || void 0;
  }
  get 157() {
    return this.item(157) || void 0;
  }
  get 158() {
    return this.item(158) || void 0;
  }
  get 159() {
    return this.item(159) || void 0;
  }
  get 160() {
    return this.item(160) || void 0;
  }
  get 161() {
    return this.item(161) || void 0;
  }
  get 162() {
    return this.item(162) || void 0;
  }
  get 163() {
    return this.item(163) || void 0;
  }
  get 164() {
    return this.item(164) || void 0;
  }
  get 165() {
    return this.item(165) || void 0;
  }
  get 166() {
    return this.item(166) || void 0;
  }
  get 167() {
    return this.item(167) || void 0;
  }
  get 168() {
    return this.item(168) || void 0;
  }
  get 169() {
    return this.item(169) || void 0;
  }
  get 170() {
    return this.item(170) || void 0;
  }
  get 171() {
    return this.item(171) || void 0;
  }
  get 172() {
    return this.item(172) || void 0;
  }
  get 173() {
    return this.item(173) || void 0;
  }
  get 174() {
    return this.item(174) || void 0;
  }
  get 175() {
    return this.item(175) || void 0;
  }
  get 176() {
    return this.item(176) || void 0;
  }
  get 177() {
    return this.item(177) || void 0;
  }
  get 178() {
    return this.item(178) || void 0;
  }
  get 179() {
    return this.item(179) || void 0;
  }
  get 180() {
    return this.item(180) || void 0;
  }
  get 181() {
    return this.item(181) || void 0;
  }
  get 182() {
    return this.item(182) || void 0;
  }
  get 183() {
    return this.item(183) || void 0;
  }
  get 184() {
    return this.item(184) || void 0;
  }
  get 185() {
    return this.item(185) || void 0;
  }
  get 186() {
    return this.item(186) || void 0;
  }
  get 187() {
    return this.item(187) || void 0;
  }
  get 188() {
    return this.item(188) || void 0;
  }
  get 189() {
    return this.item(189) || void 0;
  }
  get 190() {
    return this.item(190) || void 0;
  }
  get 191() {
    return this.item(191) || void 0;
  }
  get 192() {
    return this.item(192) || void 0;
  }
  get 193() {
    return this.item(193) || void 0;
  }
  get 194() {
    return this.item(194) || void 0;
  }
  get 195() {
    return this.item(195) || void 0;
  }
  get 196() {
    return this.item(196) || void 0;
  }
  get 197() {
    return this.item(197) || void 0;
  }
  get 198() {
    return this.item(198) || void 0;
  }
  get 199() {
    return this.item(199) || void 0;
  }
  get 200() {
    return this.item(200) || void 0;
  }
  get 201() {
    return this.item(201) || void 0;
  }
  get 202() {
    return this.item(202) || void 0;
  }
  get 203() {
    return this.item(203) || void 0;
  }
  get 204() {
    return this.item(204) || void 0;
  }
  get 205() {
    return this.item(205) || void 0;
  }
  get 206() {
    return this.item(206) || void 0;
  }
  get 207() {
    return this.item(207) || void 0;
  }
  get 208() {
    return this.item(208) || void 0;
  }
  get 209() {
    return this.item(209) || void 0;
  }
  get 210() {
    return this.item(210) || void 0;
  }
  get 211() {
    return this.item(211) || void 0;
  }
  get 212() {
    return this.item(212) || void 0;
  }
  get 213() {
    return this.item(213) || void 0;
  }
  get 214() {
    return this.item(214) || void 0;
  }
  get 215() {
    return this.item(215) || void 0;
  }
  get 216() {
    return this.item(216) || void 0;
  }
  get 217() {
    return this.item(217) || void 0;
  }
  get 218() {
    return this.item(218) || void 0;
  }
  get 219() {
    return this.item(219) || void 0;
  }
  get 220() {
    return this.item(220) || void 0;
  }
  get 221() {
    return this.item(221) || void 0;
  }
  get 222() {
    return this.item(222) || void 0;
  }
  get 223() {
    return this.item(223) || void 0;
  }
  get 224() {
    return this.item(224) || void 0;
  }
  get 225() {
    return this.item(225) || void 0;
  }
  get 226() {
    return this.item(226) || void 0;
  }
  get 227() {
    return this.item(227) || void 0;
  }
  get 228() {
    return this.item(228) || void 0;
  }
  get 229() {
    return this.item(229) || void 0;
  }
  get 230() {
    return this.item(230) || void 0;
  }
  get 231() {
    return this.item(231) || void 0;
  }
  get 232() {
    return this.item(232) || void 0;
  }
  get 233() {
    return this.item(233) || void 0;
  }
  get 234() {
    return this.item(234) || void 0;
  }
  get 235() {
    return this.item(235) || void 0;
  }
  get 236() {
    return this.item(236) || void 0;
  }
  get 237() {
    return this.item(237) || void 0;
  }
  get 238() {
    return this.item(238) || void 0;
  }
  get 239() {
    return this.item(239) || void 0;
  }
  get 240() {
    return this.item(240) || void 0;
  }
  get 241() {
    return this.item(241) || void 0;
  }
  get 242() {
    return this.item(242) || void 0;
  }
  get 243() {
    return this.item(243) || void 0;
  }
  get 244() {
    return this.item(244) || void 0;
  }
  get 245() {
    return this.item(245) || void 0;
  }
  get 246() {
    return this.item(246) || void 0;
  }
  get 247() {
    return this.item(247) || void 0;
  }
  get 248() {
    return this.item(248) || void 0;
  }
  get 249() {
    return this.item(249) || void 0;
  }
  get 250() {
    return this.item(250) || void 0;
  }
  get 251() {
    return this.item(251) || void 0;
  }
  get 252() {
    return this.item(252) || void 0;
  }
  get 253() {
    return this.item(253) || void 0;
  }
  get 254() {
    return this.item(254) || void 0;
  }
  get 255() {
    return this.item(255) || void 0;
  }
  get 256() {
    return this.item(256) || void 0;
  }
  get 257() {
    return this.item(257) || void 0;
  }
  get 258() {
    return this.item(258) || void 0;
  }
  get 259() {
    return this.item(259) || void 0;
  }
  get 260() {
    return this.item(260) || void 0;
  }
  get 261() {
    return this.item(261) || void 0;
  }
  get 262() {
    return this.item(262) || void 0;
  }
  get 263() {
    return this.item(263) || void 0;
  }
  get 264() {
    return this.item(264) || void 0;
  }
  get 265() {
    return this.item(265) || void 0;
  }
  get 266() {
    return this.item(266) || void 0;
  }
  get 267() {
    return this.item(267) || void 0;
  }
  get 268() {
    return this.item(268) || void 0;
  }
  get 269() {
    return this.item(269) || void 0;
  }
  get 270() {
    return this.item(270) || void 0;
  }
  get 271() {
    return this.item(271) || void 0;
  }
  get 272() {
    return this.item(272) || void 0;
  }
  get 273() {
    return this.item(273) || void 0;
  }
  get 274() {
    return this.item(274) || void 0;
  }
  get 275() {
    return this.item(275) || void 0;
  }
  get 276() {
    return this.item(276) || void 0;
  }
  get 277() {
    return this.item(277) || void 0;
  }
  get 278() {
    return this.item(278) || void 0;
  }
  get 279() {
    return this.item(279) || void 0;
  }
  get 280() {
    return this.item(280) || void 0;
  }
  get 281() {
    return this.item(281) || void 0;
  }
  get 282() {
    return this.item(282) || void 0;
  }
  get 283() {
    return this.item(283) || void 0;
  }
  get 284() {
    return this.item(284) || void 0;
  }
  get 285() {
    return this.item(285) || void 0;
  }
  get 286() {
    return this.item(286) || void 0;
  }
  get 287() {
    return this.item(287) || void 0;
  }
  get 288() {
    return this.item(288) || void 0;
  }
  get 289() {
    return this.item(289) || void 0;
  }
  get 290() {
    return this.item(290) || void 0;
  }
  get 291() {
    return this.item(291) || void 0;
  }
  get 292() {
    return this.item(292) || void 0;
  }
  get 293() {
    return this.item(293) || void 0;
  }
  get 294() {
    return this.item(294) || void 0;
  }
  get 295() {
    return this.item(295) || void 0;
  }
  get 296() {
    return this.item(296) || void 0;
  }
  get 297() {
    return this.item(297) || void 0;
  }
  get 298() {
    return this.item(298) || void 0;
  }
  get 299() {
    return this.item(299) || void 0;
  }
  get 300() {
    return this.item(300) || void 0;
  }
  get 301() {
    return this.item(301) || void 0;
  }
  get 302() {
    return this.item(302) || void 0;
  }
  get 303() {
    return this.item(303) || void 0;
  }
  get 304() {
    return this.item(304) || void 0;
  }
  get 305() {
    return this.item(305) || void 0;
  }
  get 306() {
    return this.item(306) || void 0;
  }
  get 307() {
    return this.item(307) || void 0;
  }
  get 308() {
    return this.item(308) || void 0;
  }
  get 309() {
    return this.item(309) || void 0;
  }
  get 310() {
    return this.item(310) || void 0;
  }
  get 311() {
    return this.item(311) || void 0;
  }
  get 312() {
    return this.item(312) || void 0;
  }
  get 313() {
    return this.item(313) || void 0;
  }
  get 314() {
    return this.item(314) || void 0;
  }
  get 315() {
    return this.item(315) || void 0;
  }
  get 316() {
    return this.item(316) || void 0;
  }
  get 317() {
    return this.item(317) || void 0;
  }
  get 318() {
    return this.item(318) || void 0;
  }
  get 319() {
    return this.item(319) || void 0;
  }
  get 320() {
    return this.item(320) || void 0;
  }
  get 321() {
    return this.item(321) || void 0;
  }
  get 322() {
    return this.item(322) || void 0;
  }
  get 323() {
    return this.item(323) || void 0;
  }
  get 324() {
    return this.item(324) || void 0;
  }
  get 325() {
    return this.item(325) || void 0;
  }
  get 326() {
    return this.item(326) || void 0;
  }
  get 327() {
    return this.item(327) || void 0;
  }
  get 328() {
    return this.item(328) || void 0;
  }
  get 329() {
    return this.item(329) || void 0;
  }
  get 330() {
    return this.item(330) || void 0;
  }
  get 331() {
    return this.item(331) || void 0;
  }
  get 332() {
    return this.item(332) || void 0;
  }
  get 333() {
    return this.item(333) || void 0;
  }
  get 334() {
    return this.item(334) || void 0;
  }
  get 335() {
    return this.item(335) || void 0;
  }
  get 336() {
    return this.item(336) || void 0;
  }
  get 337() {
    return this.item(337) || void 0;
  }
  get 338() {
    return this.item(338) || void 0;
  }
  get 339() {
    return this.item(339) || void 0;
  }
  get 340() {
    return this.item(340) || void 0;
  }
  get 341() {
    return this.item(341) || void 0;
  }
  get 342() {
    return this.item(342) || void 0;
  }
  get 343() {
    return this.item(343) || void 0;
  }
  get 344() {
    return this.item(344) || void 0;
  }
  get 345() {
    return this.item(345) || void 0;
  }
  get 346() {
    return this.item(346) || void 0;
  }
  get 347() {
    return this.item(347) || void 0;
  }
  get 348() {
    return this.item(348) || void 0;
  }
  get 349() {
    return this.item(349) || void 0;
  }
  get 350() {
    return this.item(350) || void 0;
  }
  get 351() {
    return this.item(351) || void 0;
  }
  get 352() {
    return this.item(352) || void 0;
  }
  get 353() {
    return this.item(353) || void 0;
  }
  get 354() {
    return this.item(354) || void 0;
  }
  get 355() {
    return this.item(355) || void 0;
  }
  get 356() {
    return this.item(356) || void 0;
  }
  get 357() {
    return this.item(357) || void 0;
  }
  get 358() {
    return this.item(358) || void 0;
  }
  get 359() {
    return this.item(359) || void 0;
  }
  get 360() {
    return this.item(360) || void 0;
  }
  get 361() {
    return this.item(361) || void 0;
  }
  get 362() {
    return this.item(362) || void 0;
  }
  get 363() {
    return this.item(363) || void 0;
  }
  get 364() {
    return this.item(364) || void 0;
  }
  get 365() {
    return this.item(365) || void 0;
  }
  get 366() {
    return this.item(366) || void 0;
  }
  get 367() {
    return this.item(367) || void 0;
  }
  get 368() {
    return this.item(368) || void 0;
  }
  get 369() {
    return this.item(369) || void 0;
  }
  get 370() {
    return this.item(370) || void 0;
  }
  get 371() {
    return this.item(371) || void 0;
  }
  get 372() {
    return this.item(372) || void 0;
  }
  get 373() {
    return this.item(373) || void 0;
  }
  get 374() {
    return this.item(374) || void 0;
  }
  get 375() {
    return this.item(375) || void 0;
  }
  get 376() {
    return this.item(376) || void 0;
  }
  get 377() {
    return this.item(377) || void 0;
  }
  get 378() {
    return this.item(378) || void 0;
  }
  get 379() {
    return this.item(379) || void 0;
  }
  get 380() {
    return this.item(380) || void 0;
  }
  get 381() {
    return this.item(381) || void 0;
  }
  get 382() {
    return this.item(382) || void 0;
  }
  get 383() {
    return this.item(383) || void 0;
  }
  get 384() {
    return this.item(384) || void 0;
  }
  get 385() {
    return this.item(385) || void 0;
  }
  get 386() {
    return this.item(386) || void 0;
  }
  get 387() {
    return this.item(387) || void 0;
  }
  get 388() {
    return this.item(388) || void 0;
  }
  get 389() {
    return this.item(389) || void 0;
  }
  get 390() {
    return this.item(390) || void 0;
  }
  get 391() {
    return this.item(391) || void 0;
  }
  get 392() {
    return this.item(392) || void 0;
  }
  get 393() {
    return this.item(393) || void 0;
  }
  /**
   * CSS properties
   */
  get accentColor() {
    return this.getPropertyValue("accent-color");
  }
  set accentColor(e) {
    this.setProperty("accent-color", e);
  }
  get appRegion() {
    return this.getPropertyValue("app-region");
  }
  set appRegion(e) {
    this.setProperty("app-region", e);
  }
  get alignContent() {
    return this.getPropertyValue("align-content");
  }
  set alignContent(e) {
    this.setProperty("align-content", e);
  }
  get alignItems() {
    return this.getPropertyValue("align-items");
  }
  set alignItems(e) {
    this.setProperty("align-items", e);
  }
  get alignSelf() {
    return this.getPropertyValue("align-self");
  }
  set alignSelf(e) {
    this.setProperty("align-self", e);
  }
  get alignmentBaseline() {
    return this.getPropertyValue("alignment-baseline");
  }
  set alignmentBaseline(e) {
    this.setProperty("alignment-baseline", e);
  }
  get all() {
    return this.getPropertyValue("all");
  }
  set all(e) {
    this.setProperty("all", e);
  }
  get animation() {
    return this.getPropertyValue("animation");
  }
  set animation(e) {
    this.setProperty("animation", e);
  }
  get animationDelay() {
    return this.getPropertyValue("animation-delay");
  }
  set animationDelay(e) {
    this.setProperty("animation-delay", e);
  }
  get animationDirection() {
    return this.getPropertyValue("animation-direction");
  }
  set animationDirection(e) {
    this.setProperty("animation-direction", e);
  }
  get animationDuration() {
    return this.getPropertyValue("animation-duration");
  }
  set animationDuration(e) {
    this.setProperty("animation-duration", e);
  }
  get animationFillMode() {
    return this.getPropertyValue("animation-fill-mode");
  }
  set animationFillMode(e) {
    this.setProperty("animation-fill-mode", e);
  }
  get animationIterationCount() {
    return this.getPropertyValue("animation-iteration-count");
  }
  set animationIterationCount(e) {
    this.setProperty("animation-iteration-count", e);
  }
  get animationName() {
    return this.getPropertyValue("animation-name");
  }
  set animationName(e) {
    this.setProperty("animation-name", e);
  }
  get animationPlayState() {
    return this.getPropertyValue("animation-play-state");
  }
  set animationPlayState(e) {
    this.setProperty("animation-play-state", e);
  }
  get animationTimingFunction() {
    return this.getPropertyValue("animation-timing-function");
  }
  set animationTimingFunction(e) {
    this.setProperty("animation-timing-function", e);
  }
  get appearance() {
    return this.getPropertyValue("appearance");
  }
  set appearance(e) {
    this.setProperty("appearance", e);
  }
  get backdropFilter() {
    return this.getPropertyValue("backdrop-filter");
  }
  set backdropFilter(e) {
    this.setProperty("backdrop-filter", e);
  }
  get backfaceVisibility() {
    return this.getPropertyValue("backface-visibility");
  }
  set backfaceVisibility(e) {
    this.setProperty("backface-visibility", e);
  }
  get background() {
    return this.getPropertyValue("background");
  }
  set background(e) {
    this.setProperty("background", e);
  }
  get backgroundAttachment() {
    return this.getPropertyValue("background-attachment");
  }
  set backgroundAttachment(e) {
    this.setProperty("background-attachment", e);
  }
  get backgroundBlendMode() {
    return this.getPropertyValue("background-blend-mode");
  }
  set backgroundBlendMode(e) {
    this.setProperty("background-blend-mode", e);
  }
  get backgroundClip() {
    return this.getPropertyValue("background-clip");
  }
  set backgroundClip(e) {
    this.setProperty("background-clip", e);
  }
  get backgroundColor() {
    return this.getPropertyValue("background-color");
  }
  set backgroundColor(e) {
    this.setProperty("background-color", e);
  }
  get backgroundImage() {
    return this.getPropertyValue("background-image");
  }
  set backgroundImage(e) {
    this.setProperty("background-image", e);
  }
  get backgroundOrigin() {
    return this.getPropertyValue("background-origin");
  }
  set backgroundOrigin(e) {
    this.setProperty("background-origin", e);
  }
  get backgroundPosition() {
    return this.getPropertyValue("background-position");
  }
  set backgroundPosition(e) {
    this.setProperty("background-position", e);
  }
  get backgroundPositionX() {
    return this.getPropertyValue("background-position-x");
  }
  set backgroundPositionX(e) {
    this.setProperty("background-position-x", e);
  }
  get backgroundPositionY() {
    return this.getPropertyValue("background-position-y");
  }
  set backgroundPositionY(e) {
    this.setProperty("background-position-y", e);
  }
  get backgroundRepeat() {
    return this.getPropertyValue("background-repeat");
  }
  set backgroundRepeat(e) {
    this.setProperty("background-repeat", e);
  }
  get backgroundRepeatX() {
    return this.getPropertyValue("background-repeat-x");
  }
  set backgroundRepeatX(e) {
    this.setProperty("background-repeat-x", e);
  }
  get backgroundRepeatY() {
    return this.getPropertyValue("background-repeat-y");
  }
  set backgroundRepeatY(e) {
    this.setProperty("background-repeat-y", e);
  }
  get backgroundSize() {
    return this.getPropertyValue("background-size");
  }
  set backgroundSize(e) {
    this.setProperty("background-size", e);
  }
  get baselineShift() {
    return this.getPropertyValue("baseline-shift");
  }
  set baselineShift(e) {
    this.setProperty("baseline-shift", e);
  }
  get blockSize() {
    return this.getPropertyValue("block-size");
  }
  set blockSize(e) {
    this.setProperty("block-size", e);
  }
  get border() {
    return this.getPropertyValue("border");
  }
  set border(e) {
    this.setProperty("border", e);
  }
  get borderBlockEnd() {
    return this.getPropertyValue("border-block-end");
  }
  set borderBlockEnd(e) {
    this.setProperty("border-block-end", e);
  }
  get borderBlockEndColor() {
    return this.getPropertyValue("border-block-end-color");
  }
  set borderBlockEndColor(e) {
    this.setProperty("border-block-end-color", e);
  }
  get borderBlockEndStyle() {
    return this.getPropertyValue("border-block-end-style");
  }
  set borderBlockEndStyle(e) {
    this.setProperty("border-block-end-style", e);
  }
  get borderBlockEndWidth() {
    return this.getPropertyValue("border-block-end-width");
  }
  set borderBlockEndWidth(e) {
    this.setProperty("border-block-end-width", e);
  }
  get borderBlockStart() {
    return this.getPropertyValue("border-block-start");
  }
  set borderBlockStart(e) {
    this.setProperty("border-block-start", e);
  }
  get borderBlockStartColor() {
    return this.getPropertyValue("border-block-start-color");
  }
  set borderBlockStartColor(e) {
    this.setProperty("border-block-start-color", e);
  }
  get borderBlockStartStyle() {
    return this.getPropertyValue("border-block-start-style");
  }
  set borderBlockStartStyle(e) {
    this.setProperty("border-block-start-style", e);
  }
  get borderBlockStartWidth() {
    return this.getPropertyValue("border-block-start-width");
  }
  set borderBlockStartWidth(e) {
    this.setProperty("border-block-start-width", e);
  }
  get borderBottom() {
    return this.getPropertyValue("border-bottom");
  }
  set borderBottom(e) {
    this.setProperty("border-bottom", e);
  }
  get borderBottomColor() {
    return this.getPropertyValue("border-bottom-color");
  }
  set borderBottomColor(e) {
    this.setProperty("border-bottom-color", e);
  }
  get borderBottomLeftRadius() {
    return this.getPropertyValue("border-bottom-left-radius");
  }
  set borderBottomLeftRadius(e) {
    this.setProperty("border-bottom-left-radius", e);
  }
  get borderBottomRightRadius() {
    return this.getPropertyValue("border-bottom-right-radius");
  }
  set borderBottomRightRadius(e) {
    this.setProperty("border-bottom-right-radius", e);
  }
  get borderBottomStyle() {
    return this.getPropertyValue("border-bottom-style");
  }
  set borderBottomStyle(e) {
    this.setProperty("border-bottom-style", e);
  }
  get borderBottomWidth() {
    return this.getPropertyValue("border-bottom-width");
  }
  set borderBottomWidth(e) {
    this.setProperty("border-bottom-width", e);
  }
  get borderCollapse() {
    return this.getPropertyValue("border-collapse");
  }
  set borderCollapse(e) {
    this.setProperty("border-collapse", e);
  }
  get borderColor() {
    return this.getPropertyValue("border-color");
  }
  set borderColor(e) {
    this.setProperty("border-color", e);
  }
  get borderImage() {
    return this.getPropertyValue("border-image");
  }
  set borderImage(e) {
    this.setProperty("border-image", e);
  }
  get borderImageOutset() {
    return this.getPropertyValue("border-image-outset");
  }
  set borderImageOutset(e) {
    this.setProperty("border-image-outset", e);
  }
  get borderImageRepeat() {
    return this.getPropertyValue("border-image-repeat");
  }
  set borderImageRepeat(e) {
    this.setProperty("border-image-repeat", e);
  }
  get borderImageSlice() {
    return this.getPropertyValue("border-image-slice");
  }
  set borderImageSlice(e) {
    this.setProperty("border-image-slice", e);
  }
  get borderImageSource() {
    return this.getPropertyValue("border-image-source");
  }
  set borderImageSource(e) {
    this.setProperty("border-image-source", e);
  }
  get borderImageWidth() {
    return this.getPropertyValue("border-image-width");
  }
  set borderImageWidth(e) {
    this.setProperty("border-image-width", e);
  }
  get borderInlineEnd() {
    return this.getPropertyValue("border-inline-end");
  }
  set borderInlineEnd(e) {
    this.setProperty("border-inline-end", e);
  }
  get borderInlineEndColor() {
    return this.getPropertyValue("border-inline-end-color");
  }
  set borderInlineEndColor(e) {
    this.setProperty("border-inline-end-color", e);
  }
  get borderInlineEndStyle() {
    return this.getPropertyValue("border-inline-end-style");
  }
  set borderInlineEndStyle(e) {
    this.setProperty("border-inline-end-style", e);
  }
  get borderInlineEndWidth() {
    return this.getPropertyValue("border-inline-end-width");
  }
  set borderInlineEndWidth(e) {
    this.setProperty("border-inline-end-width", e);
  }
  get borderInlineStart() {
    return this.getPropertyValue("border-inline-start");
  }
  set borderInlineStart(e) {
    this.setProperty("border-inline-start", e);
  }
  get borderInlineStartColor() {
    return this.getPropertyValue("border-inline-start-color");
  }
  set borderInlineStartColor(e) {
    this.setProperty("border-inline-start-color", e);
  }
  get borderInlineStartStyle() {
    return this.getPropertyValue("border-inline-start-style");
  }
  set borderInlineStartStyle(e) {
    this.setProperty("border-inline-start-style", e);
  }
  get borderInlineStartWidth() {
    return this.getPropertyValue("border-inline-start-width");
  }
  set borderInlineStartWidth(e) {
    this.setProperty("border-inline-start-width", e);
  }
  get borderLeft() {
    return this.getPropertyValue("border-left");
  }
  set borderLeft(e) {
    this.setProperty("border-left", e);
  }
  get borderLeftColor() {
    return this.getPropertyValue("border-left-color");
  }
  set borderLeftColor(e) {
    this.setProperty("border-left-color", e);
  }
  get borderLeftStyle() {
    return this.getPropertyValue("border-left-style");
  }
  set borderLeftStyle(e) {
    this.setProperty("border-left-style", e);
  }
  get borderLeftWidth() {
    return this.getPropertyValue("border-left-width");
  }
  set borderLeftWidth(e) {
    this.setProperty("border-left-width", e);
  }
  get borderRadius() {
    return this.getPropertyValue("border-radius");
  }
  set borderRadius(e) {
    this.setProperty("border-radius", e);
  }
  get borderRight() {
    return this.getPropertyValue("border-right");
  }
  set borderRight(e) {
    this.setProperty("border-right", e);
  }
  get borderRightColor() {
    return this.getPropertyValue("border-right-color");
  }
  set borderRightColor(e) {
    this.setProperty("border-right-color", e);
  }
  get borderRightStyle() {
    return this.getPropertyValue("border-right-style");
  }
  set borderRightStyle(e) {
    this.setProperty("border-right-style", e);
  }
  get borderRightWidth() {
    return this.getPropertyValue("border-right-width");
  }
  set borderRightWidth(e) {
    this.setProperty("border-right-width", e);
  }
  get borderSpacing() {
    return this.getPropertyValue("border-spacing");
  }
  set borderSpacing(e) {
    this.setProperty("border-spacing", e);
  }
  get borderStyle() {
    return this.getPropertyValue("border-style");
  }
  set borderStyle(e) {
    this.setProperty("border-style", e);
  }
  get borderTop() {
    return this.getPropertyValue("border-top");
  }
  set borderTop(e) {
    this.setProperty("border-top", e);
  }
  get borderTopColor() {
    return this.getPropertyValue("border-top-color");
  }
  set borderTopColor(e) {
    this.setProperty("border-top-color", e);
  }
  get borderTopLeftRadius() {
    return this.getPropertyValue("border-top-left-radius");
  }
  set borderTopLeftRadius(e) {
    this.setProperty("border-top-left-radius", e);
  }
  get borderTopRightRadius() {
    return this.getPropertyValue("border-top-right-radius");
  }
  set borderTopRightRadius(e) {
    this.setProperty("border-top-right-radius", e);
  }
  get borderTopStyle() {
    return this.getPropertyValue("border-top-style");
  }
  set borderTopStyle(e) {
    this.setProperty("border-top-style", e);
  }
  get borderTopWidth() {
    return this.getPropertyValue("border-top-width");
  }
  set borderTopWidth(e) {
    this.setProperty("border-top-width", e);
  }
  get borderWidth() {
    return this.getPropertyValue("border-width");
  }
  set borderWidth(e) {
    this.setProperty("border-width", e);
  }
  get borderEndEndRadius() {
    return this.getPropertyValue("border-end-end-radius");
  }
  set borderEndEndRadius(e) {
    this.setProperty("border-end-end-radius", e);
  }
  get borderEndStartRadius() {
    return this.getPropertyValue("border-end-start-radius");
  }
  set borderEndStartRadius(e) {
    this.setProperty("border-end-start-radius", e);
  }
  get borderStartEndRadius() {
    return this.getPropertyValue("border-start-end-radius");
  }
  set borderStartEndRadius(e) {
    this.setProperty("border-start-end-radius", e);
  }
  get borderStartStartRadius() {
    return this.getPropertyValue("border-start-start-radius");
  }
  set borderStartStartRadius(e) {
    this.setProperty("border-start-start-radius", e);
  }
  get bottom() {
    return this.getPropertyValue("bottom");
  }
  set bottom(e) {
    this.setProperty("bottom", e);
  }
  get boxShadow() {
    return this.getPropertyValue("box-shadow");
  }
  set boxShadow(e) {
    this.setProperty("box-shadow", e);
  }
  get boxSizing() {
    return this.getPropertyValue("box-sizing");
  }
  set boxSizing(e) {
    this.setProperty("box-sizing", e);
  }
  get breakAfter() {
    return this.getPropertyValue("break-after");
  }
  set breakAfter(e) {
    this.setProperty("break-after", e);
  }
  get breakBefore() {
    return this.getPropertyValue("break-before");
  }
  set breakBefore(e) {
    this.setProperty("break-before", e);
  }
  get breakInside() {
    return this.getPropertyValue("break-inside");
  }
  set breakInside(e) {
    this.setProperty("break-inside", e);
  }
  get bufferedRendering() {
    return this.getPropertyValue("buffered-rendering");
  }
  set bufferedRendering(e) {
    this.setProperty("buffered-rendering", e);
  }
  get captionSide() {
    return this.getPropertyValue("caption-side");
  }
  set captionSide(e) {
    this.setProperty("caption-side", e);
  }
  get caretColor() {
    return this.getPropertyValue("caret-color");
  }
  set caretColor(e) {
    this.setProperty("caret-color", e);
  }
  get clear() {
    return this.getPropertyValue("clear");
  }
  set clear(e) {
    this.setProperty("clear", e);
  }
  get clip() {
    return this.getPropertyValue("clip");
  }
  set clip(e) {
    this.setProperty("clip", e);
  }
  get clipPath() {
    return this.getPropertyValue("clip-path");
  }
  set clipPath(e) {
    this.setProperty("clip-path", e);
  }
  get clipRule() {
    return this.getPropertyValue("clip-rule");
  }
  set clipRule(e) {
    this.setProperty("clip-rule", e);
  }
  get color() {
    return this.getPropertyValue("color");
  }
  set color(e) {
    this.setProperty("color", e);
  }
  get colorInterpolation() {
    return this.getPropertyValue("color-interpolation");
  }
  set colorInterpolation(e) {
    this.setProperty("color-interpolation", e);
  }
  get colorInterpolationFilters() {
    return this.getPropertyValue("color-interpolation-filters");
  }
  set colorInterpolationFilters(e) {
    this.setProperty("color-interpolation-filters", e);
  }
  get colorRendering() {
    return this.getPropertyValue("color-rendering");
  }
  set colorRendering(e) {
    this.setProperty("color-rendering", e);
  }
  get colorScheme() {
    return this.getPropertyValue("color-scheme");
  }
  set colorScheme(e) {
    this.setProperty("color-scheme", e);
  }
  get columnCount() {
    return this.getPropertyValue("column-count");
  }
  set columnCount(e) {
    this.setProperty("column-count", e);
  }
  get columnFill() {
    return this.getPropertyValue("column-fill");
  }
  set columnFill(e) {
    this.setProperty("column-fill", e);
  }
  get columnGap() {
    return this.getPropertyValue("column-gap");
  }
  set columnGap(e) {
    this.setProperty("column-gap", e);
  }
  get columnRule() {
    return this.getPropertyValue("column-rule");
  }
  set columnRule(e) {
    this.setProperty("column-rule", e);
  }
  get columnRuleColor() {
    return this.getPropertyValue("column-rule-color");
  }
  set columnRuleColor(e) {
    this.setProperty("column-rule-color", e);
  }
  get columnRuleStyle() {
    return this.getPropertyValue("column-rule-style");
  }
  set columnRuleStyle(e) {
    this.setProperty("column-rule-style", e);
  }
  get columnRuleWidth() {
    return this.getPropertyValue("column-rule-width");
  }
  set columnRuleWidth(e) {
    this.setProperty("column-rule-width", e);
  }
  get columnSpan() {
    return this.getPropertyValue("column-span");
  }
  set columnSpan(e) {
    this.setProperty("column-span", e);
  }
  get columnWidth() {
    return this.getPropertyValue("column-width");
  }
  set columnWidth(e) {
    this.setProperty("column-width", e);
  }
  get columns() {
    return this.getPropertyValue("columns");
  }
  set columns(e) {
    this.setProperty("columns", e);
  }
  get contain() {
    return this.getPropertyValue("contain");
  }
  set contain(e) {
    this.setProperty("contain", e);
  }
  get containIntrinsicSize() {
    return this.getPropertyValue("contain-intrinsic-size");
  }
  set containIntrinsicSize(e) {
    this.setProperty("contain-intrinsic-size", e);
  }
  get content() {
    return this.getPropertyValue("content");
  }
  set content(e) {
    this.setProperty("content", e);
  }
  get contentVisibility() {
    return this.getPropertyValue("content-visibility");
  }
  set contentVisibility(e) {
    this.setProperty("content-visibility", e);
  }
  get counterIncrement() {
    return this.getPropertyValue("counter-increment");
  }
  set counterIncrement(e) {
    this.setProperty("counter-increment", e);
  }
  get counterReset() {
    return this.getPropertyValue("counter-reset");
  }
  set counterReset(e) {
    this.setProperty("counter-reset", e);
  }
  get counterSet() {
    return this.getPropertyValue("counter-set");
  }
  set counterSet(e) {
    this.setProperty("counter-set", e);
  }
  get containIntrinsicBlockSize() {
    return this.getPropertyValue("contain-intrinsic-block-size");
  }
  set containIntrinsicBlockSize(e) {
    this.setProperty("contain-intrinsic-block-size", e);
  }
  get containIntrinsicHeight() {
    return this.getPropertyValue("contain-intrinsic-height");
  }
  set containIntrinsicHeight(e) {
    this.setProperty("contain-intrinsic-height", e);
  }
  get containIntrinsicInlineSize() {
    return this.getPropertyValue("contain-intrinsic-inline-size");
  }
  set containIntrinsicInlineSize(e) {
    this.setProperty("contain-intrinsic-inline-size", e);
  }
  get containIntrinsicWidth() {
    return this.getPropertyValue("contain-intrinsic-width");
  }
  set containIntrinsicWidth(e) {
    this.setProperty("contain-intrinsic-width", e);
  }
  get cssFloat() {
    return this.getPropertyValue("css-float");
  }
  set cssFloat(e) {
    this.setProperty("css-float", e);
  }
  get cursor() {
    return this.getPropertyValue("cursor");
  }
  set cursor(e) {
    this.setProperty("cursor", e);
  }
  get cx() {
    return this.getPropertyValue("cx");
  }
  set cx(e) {
    this.setProperty("cx", e);
  }
  get cy() {
    return this.getPropertyValue("cy");
  }
  set cy(e) {
    this.setProperty("cy", e);
  }
  get d() {
    return this.getPropertyValue("d");
  }
  set d(e) {
    this.setProperty("d", e);
  }
  get direction() {
    return this.getPropertyValue("direction");
  }
  set direction(e) {
    this.setProperty("direction", e);
  }
  get display() {
    return this.getPropertyValue("display");
  }
  set display(e) {
    this.setProperty("display", e);
  }
  get dominantBaseline() {
    return this.getPropertyValue("dominant-baseline");
  }
  set dominantBaseline(e) {
    this.setProperty("dominant-baseline", e);
  }
  get emptyCells() {
    return this.getPropertyValue("empty-cells");
  }
  set emptyCells(e) {
    this.setProperty("empty-cells", e);
  }
  get fill() {
    return this.getPropertyValue("fill");
  }
  set fill(e) {
    this.setProperty("fill", e);
  }
  get fillOpacity() {
    return this.getPropertyValue("fill-opacity");
  }
  set fillOpacity(e) {
    this.setProperty("fill-opacity", e);
  }
  get fillRule() {
    return this.getPropertyValue("fill-rule");
  }
  set fillRule(e) {
    this.setProperty("fill-rule", e);
  }
  get filter() {
    return this.getPropertyValue("filter");
  }
  set filter(e) {
    this.setProperty("filter", e);
  }
  get flex() {
    return this.getPropertyValue("flex");
  }
  set flex(e) {
    this.setProperty("flex", e);
  }
  get flexBasis() {
    return this.getPropertyValue("flex-basis");
  }
  set flexBasis(e) {
    this.setProperty("flex-basis", e);
  }
  get flexDirection() {
    return this.getPropertyValue("flex-direction");
  }
  set flexDirection(e) {
    this.setProperty("flex-direction", e);
  }
  get flexFlow() {
    return this.getPropertyValue("flex-flow");
  }
  set flexFlow(e) {
    this.setProperty("flex-flow", e);
  }
  get flexGrow() {
    return this.getPropertyValue("flex-grow");
  }
  set flexGrow(e) {
    this.setProperty("flex-grow", e);
  }
  get flexShrink() {
    return this.getPropertyValue("flex-shrink");
  }
  set flexShrink(e) {
    this.setProperty("flex-shrink", e);
  }
  get flexWrap() {
    return this.getPropertyValue("flex-wrap");
  }
  set flexWrap(e) {
    this.setProperty("flex-wrap", e);
  }
  get float() {
    return this.getPropertyValue("float");
  }
  set float(e) {
    this.setProperty("float", e);
  }
  get floodColor() {
    return this.getPropertyValue("flood-color");
  }
  set floodColor(e) {
    this.setProperty("flood-color", e);
  }
  get floodOpacity() {
    return this.getPropertyValue("flood-opacity");
  }
  set floodOpacity(e) {
    this.setProperty("flood-opacity", e);
  }
  get font() {
    return this.getPropertyValue("font");
  }
  set font(e) {
    this.setProperty("font", e);
  }
  get fontDisplay() {
    return this.getPropertyValue("font-display");
  }
  set fontDisplay(e) {
    this.setProperty("font-display", e);
  }
  get fontFamily() {
    return this.getPropertyValue("font-family");
  }
  set fontFamily(e) {
    this.setProperty("font-family", e);
  }
  get fontFeatureSettings() {
    return this.getPropertyValue("font-feature-settings");
  }
  set fontFeatureSettings(e) {
    this.setProperty("font-feature-settings", e);
  }
  get fontKerning() {
    return this.getPropertyValue("font-kerning");
  }
  set fontKerning(e) {
    this.setProperty("font-kerning", e);
  }
  get fontOpticalSizing() {
    return this.getPropertyValue("font-optical-sizing");
  }
  set fontOpticalSizing(e) {
    this.setProperty("font-optical-sizing", e);
  }
  get fontSize() {
    return this.getPropertyValue("font-size");
  }
  set fontSize(e) {
    this.setProperty("font-size", e);
  }
  get fontStretch() {
    return this.getPropertyValue("font-stretch");
  }
  set fontStretch(e) {
    this.setProperty("font-stretch", e);
  }
  get fontStyle() {
    return this.getPropertyValue("font-style");
  }
  set fontStyle(e) {
    this.setProperty("font-style", e);
  }
  get fontVariant() {
    return this.getPropertyValue("font-variant");
  }
  set fontVariant(e) {
    this.setProperty("font-variant", e);
  }
  get fontVariantCaps() {
    return this.getPropertyValue("font-variant-caps");
  }
  set fontVariantCaps(e) {
    this.setProperty("font-variant-caps", e);
  }
  get fontVariantEastAsian() {
    return this.getPropertyValue("font-variant-east-asian");
  }
  set fontVariantEastAsian(e) {
    this.setProperty("font-variant-east-asian", e);
  }
  get fontVariantLigatures() {
    return this.getPropertyValue("font-variant-ligatures");
  }
  set fontVariantLigatures(e) {
    this.setProperty("font-variant-ligatures", e);
  }
  get fontVariantNumeric() {
    return this.getPropertyValue("font-variant-numeric");
  }
  set fontVariantNumeric(e) {
    this.setProperty("font-variant-numeric", e);
  }
  get fontVariationSettings() {
    return this.getPropertyValue("font-variation-settings");
  }
  set fontVariationSettings(e) {
    this.setProperty("font-variation-settings", e);
  }
  get fontPalette() {
    return this.getPropertyValue("font-palette");
  }
  set fontPalette(e) {
    this.setProperty("font-palette", e);
  }
  get fontSynthesisSmallCaps() {
    return this.getPropertyValue("font-synthesis-small-caps");
  }
  set fontSynthesisSmallCaps(e) {
    this.setProperty("font-synthesis-small-caps", e);
  }
  get fontSynthesisStyle() {
    return this.getPropertyValue("font-synthesis-style");
  }
  set fontSynthesisStyle(e) {
    this.setProperty("font-synthesis-style", e);
  }
  get fontSynthesisWeight() {
    return this.getPropertyValue("font-synthesis-weight");
  }
  set fontSynthesisWeight(e) {
    this.setProperty("font-synthesis-weight", e);
  }
  get fontWeight() {
    return this.getPropertyValue("font-weight");
  }
  set fontWeight(e) {
    this.setProperty("font-weight", e);
  }
  get gap() {
    return this.getPropertyValue("gap");
  }
  set gap(e) {
    this.setProperty("gap", e);
  }
  get grid() {
    return this.getPropertyValue("grid");
  }
  set grid(e) {
    this.setProperty("grid", e);
  }
  get gridArea() {
    return this.getPropertyValue("grid-area");
  }
  set gridArea(e) {
    this.setProperty("grid-area", e);
  }
  get gridAutoColumns() {
    return this.getPropertyValue("grid-auto-columns");
  }
  set gridAutoColumns(e) {
    this.setProperty("grid-auto-columns", e);
  }
  get gridAutoFlow() {
    return this.getPropertyValue("grid-auto-flow");
  }
  set gridAutoFlow(e) {
    this.setProperty("grid-auto-flow", e);
  }
  get gridAutoRows() {
    return this.getPropertyValue("grid-auto-rows");
  }
  set gridAutoRows(e) {
    this.setProperty("grid-auto-rows", e);
  }
  get gridColumn() {
    return this.getPropertyValue("grid-column");
  }
  set gridColumn(e) {
    this.setProperty("grid-column", e);
  }
  get gridColumnEnd() {
    return this.getPropertyValue("grid-column-end");
  }
  set gridColumnEnd(e) {
    this.setProperty("grid-column-end", e);
  }
  get gridColumnGap() {
    return this.getPropertyValue("grid-column-gap");
  }
  set gridColumnGap(e) {
    this.setProperty("grid-column-gap", e);
  }
  get gridColumnStart() {
    return this.getPropertyValue("grid-column-start");
  }
  set gridColumnStart(e) {
    this.setProperty("grid-column-start", e);
  }
  get gridGap() {
    return this.getPropertyValue("grid-gap");
  }
  set gridGap(e) {
    this.setProperty("grid-gap", e);
  }
  get gridRow() {
    return this.getPropertyValue("grid-row");
  }
  set gridRow(e) {
    this.setProperty("grid-row", e);
  }
  get gridRowEnd() {
    return this.getPropertyValue("grid-row-end");
  }
  set gridRowEnd(e) {
    this.setProperty("grid-row-end", e);
  }
  get gridRowGap() {
    return this.getPropertyValue("grid-row-gap");
  }
  set gridRowGap(e) {
    this.setProperty("grid-row-gap", e);
  }
  get gridRowStart() {
    return this.getPropertyValue("grid-row-start");
  }
  set gridRowStart(e) {
    this.setProperty("grid-row-start", e);
  }
  get gridTemplate() {
    return this.getPropertyValue("grid-template");
  }
  set gridTemplate(e) {
    this.setProperty("grid-template", e);
  }
  get gridTemplateAreas() {
    return this.getPropertyValue("grid-template-areas");
  }
  set gridTemplateAreas(e) {
    this.setProperty("grid-template-areas", e);
  }
  get gridTemplateColumns() {
    return this.getPropertyValue("grid-template-columns");
  }
  set gridTemplateColumns(e) {
    this.setProperty("grid-template-columns", e);
  }
  get gridTemplateRows() {
    return this.getPropertyValue("grid-template-rows");
  }
  set gridTemplateRows(e) {
    this.setProperty("grid-template-rows", e);
  }
  get height() {
    return this.getPropertyValue("height");
  }
  set height(e) {
    this.setProperty("height", e);
  }
  get hyphens() {
    return this.getPropertyValue("hyphens");
  }
  set hyphens(e) {
    this.setProperty("hyphens", e);
  }
  get imageOrientation() {
    return this.getPropertyValue("image-orientation");
  }
  set imageOrientation(e) {
    this.setProperty("image-orientation", e);
  }
  get imageRendering() {
    return this.getPropertyValue("image-rendering");
  }
  set imageRendering(e) {
    this.setProperty("image-rendering", e);
  }
  get inherits() {
    return this.getPropertyValue("inherits");
  }
  set inherits(e) {
    this.setProperty("inherits", e);
  }
  get initialValue() {
    return this.getPropertyValue("initial-value");
  }
  set initialValue(e) {
    this.setProperty("initial-value", e);
  }
  get inlineSize() {
    return this.getPropertyValue("inline-size");
  }
  set inlineSize(e) {
    this.setProperty("inline-size", e);
  }
  get isolation() {
    return this.getPropertyValue("isolation");
  }
  set isolation(e) {
    this.setProperty("isolation", e);
  }
  get insetBlockEnd() {
    return this.getPropertyValue("inset-block-end");
  }
  set insetBlockEnd(e) {
    this.setProperty("inset-block-end", e);
  }
  get insetBlockStart() {
    return this.getPropertyValue("inset-block-start");
  }
  set insetBlockStart(e) {
    this.setProperty("inset-block-start", e);
  }
  get insetInlineEnd() {
    return this.getPropertyValue("inset-inline-end");
  }
  set insetInlineEnd(e) {
    this.setProperty("inset-inline-end", e);
  }
  get insetInlineStart() {
    return this.getPropertyValue("inset-inline-start");
  }
  set insetInlineStart(e) {
    this.setProperty("inset-inline-start", e);
  }
  get justifyContent() {
    return this.getPropertyValue("justify-content");
  }
  set justifyContent(e) {
    this.setProperty("justify-content", e);
  }
  get justifyItems() {
    return this.getPropertyValue("justify-items");
  }
  set justifyItems(e) {
    this.setProperty("justify-items", e);
  }
  get justifySelf() {
    return this.getPropertyValue("justify-self");
  }
  set justifySelf(e) {
    this.setProperty("justify-self", e);
  }
  get left() {
    return this.getPropertyValue("left");
  }
  set left(e) {
    this.setProperty("left", e);
  }
  get letterSpacing() {
    return this.getPropertyValue("letter-spacing");
  }
  set letterSpacing(e) {
    this.setProperty("letter-spacing", e);
  }
  get lightingColor() {
    return this.getPropertyValue("lighting-color");
  }
  set lightingColor(e) {
    this.setProperty("lighting-color", e);
  }
  get lineBreak() {
    return this.getPropertyValue("line-break");
  }
  set lineBreak(e) {
    this.setProperty("line-break", e);
  }
  get lineHeight() {
    return this.getPropertyValue("line-height");
  }
  set lineHeight(e) {
    this.setProperty("line-height", e);
  }
  get listStyle() {
    return this.getPropertyValue("list-style");
  }
  set listStyle(e) {
    this.setProperty("list-style", e);
  }
  get listStyleImage() {
    return this.getPropertyValue("list-style-image");
  }
  set listStyleImage(e) {
    this.setProperty("list-style-image", e);
  }
  get listStylePosition() {
    return this.getPropertyValue("list-style-position");
  }
  set listStylePosition(e) {
    this.setProperty("list-style-position", e);
  }
  get listStyleType() {
    return this.getPropertyValue("list-style-type");
  }
  set listStyleType(e) {
    this.setProperty("list-style-type", e);
  }
  get margin() {
    return this.getPropertyValue("margin");
  }
  set margin(e) {
    this.setProperty("margin", e);
  }
  get marginBlockEnd() {
    return this.getPropertyValue("margin-block-end");
  }
  set marginBlockEnd(e) {
    this.setProperty("margin-block-end", e);
  }
  get marginBlockStart() {
    return this.getPropertyValue("margin-block-start");
  }
  set marginBlockStart(e) {
    this.setProperty("margin-block-start", e);
  }
  get marginBottom() {
    return this.getPropertyValue("margin-bottom");
  }
  set marginBottom(e) {
    this.setProperty("margin-bottom", e);
  }
  get marginInlineEnd() {
    return this.getPropertyValue("margin-inline-end");
  }
  set marginInlineEnd(e) {
    this.setProperty("margin-inline-end", e);
  }
  get marginInlineStart() {
    return this.getPropertyValue("margin-inline-start");
  }
  set marginInlineStart(e) {
    this.setProperty("margin-inline-start", e);
  }
  get marginLeft() {
    return this.getPropertyValue("margin-left");
  }
  set marginLeft(e) {
    this.setProperty("margin-left", e);
  }
  get marginRight() {
    return this.getPropertyValue("margin-right");
  }
  set marginRight(e) {
    this.setProperty("margin-right", e);
  }
  get marginTop() {
    return this.getPropertyValue("margin-top");
  }
  set marginTop(e) {
    this.setProperty("margin-top", e);
  }
  get marker() {
    return this.getPropertyValue("marker");
  }
  set marker(e) {
    this.setProperty("marker", e);
  }
  get markerEnd() {
    return this.getPropertyValue("marker-end");
  }
  set markerEnd(e) {
    this.setProperty("marker-end", e);
  }
  get markerMid() {
    return this.getPropertyValue("marker-mid");
  }
  set markerMid(e) {
    this.setProperty("marker-mid", e);
  }
  get markerStart() {
    return this.getPropertyValue("marker-start");
  }
  set markerStart(e) {
    this.setProperty("marker-start", e);
  }
  get mask() {
    return this.getPropertyValue("mask");
  }
  set mask(e) {
    this.setProperty("mask", e);
  }
  get maskType() {
    return this.getPropertyValue("mask-type");
  }
  set maskType(e) {
    this.setProperty("mask-type", e);
  }
  get maxBlockSize() {
    return this.getPropertyValue("max-block-size");
  }
  set maxBlockSize(e) {
    this.setProperty("max-block-size", e);
  }
  get maxHeight() {
    return this.getPropertyValue("max-height");
  }
  set maxHeight(e) {
    this.setProperty("max-height", e);
  }
  get maxInlineSize() {
    return this.getPropertyValue("max-inline-size");
  }
  set maxInlineSize(e) {
    this.setProperty("max-inline-size", e);
  }
  get maxWidth() {
    return this.getPropertyValue("max-width");
  }
  set maxWidth(e) {
    this.setProperty("max-width", e);
  }
  get maxZoom() {
    return this.getPropertyValue("max-zoom");
  }
  set maxZoom(e) {
    this.setProperty("max-zoom", e);
  }
  get minBlockSize() {
    return this.getPropertyValue("min-block-size");
  }
  set minBlockSize(e) {
    this.setProperty("min-block-size", e);
  }
  get minHeight() {
    return this.getPropertyValue("min-height");
  }
  set minHeight(e) {
    this.setProperty("min-height", e);
  }
  get minInlineSize() {
    return this.getPropertyValue("min-inline-size");
  }
  set minInlineSize(e) {
    this.setProperty("min-inline-size", e);
  }
  get minWidth() {
    return this.getPropertyValue("min-width");
  }
  set minWidth(e) {
    this.setProperty("min-width", e);
  }
  get minZoom() {
    return this.getPropertyValue("min-zoom");
  }
  set minZoom(e) {
    this.setProperty("min-zoom", e);
  }
  get mixBlendMode() {
    return this.getPropertyValue("mix-blend-mode");
  }
  set mixBlendMode(e) {
    this.setProperty("mix-blend-mode", e);
  }
  get objectFit() {
    return this.getPropertyValue("object-fit");
  }
  set objectFit(e) {
    this.setProperty("object-fit", e);
  }
  get objectPosition() {
    return this.getPropertyValue("object-position");
  }
  set objectPosition(e) {
    this.setProperty("object-position", e);
  }
  get offset() {
    return this.getPropertyValue("offset");
  }
  set offset(e) {
    this.setProperty("offset", e);
  }
  get offsetDistance() {
    return this.getPropertyValue("offset-distance");
  }
  set offsetDistance(e) {
    this.setProperty("offset-distance", e);
  }
  get offsetPath() {
    return this.getPropertyValue("offset-path");
  }
  set offsetPath(e) {
    this.setProperty("offset-path", e);
  }
  get offsetRotate() {
    return this.getPropertyValue("offset-rotate");
  }
  set offsetRotate(e) {
    this.setProperty("offset-rotate", e);
  }
  get opacity() {
    return this.getPropertyValue("opacity");
  }
  set opacity(e) {
    this.setProperty("opacity", e);
  }
  get order() {
    return this.getPropertyValue("order");
  }
  set order(e) {
    this.setProperty("order", e);
  }
  get orientation() {
    return this.getPropertyValue("orientation");
  }
  set orientation(e) {
    this.setProperty("orientation", e);
  }
  get orphans() {
    return this.getPropertyValue("orphans");
  }
  set orphans(e) {
    this.setProperty("orphans", e);
  }
  get outline() {
    return this.getPropertyValue("outline");
  }
  set outline(e) {
    this.setProperty("outline", e);
  }
  get outlineColor() {
    return this.getPropertyValue("outline-color");
  }
  set outlineColor(e) {
    this.setProperty("outline-color", e);
  }
  get outlineOffset() {
    return this.getPropertyValue("outline-offset");
  }
  set outlineOffset(e) {
    this.setProperty("outline-offset", e);
  }
  get outlineStyle() {
    return this.getPropertyValue("outline-style");
  }
  set outlineStyle(e) {
    this.setProperty("outline-style", e);
  }
  get outlineWidth() {
    return this.getPropertyValue("outline-width");
  }
  set outlineWidth(e) {
    this.setProperty("outline-width", e);
  }
  get overflow() {
    return this.getPropertyValue("overflow");
  }
  set overflow(e) {
    this.setProperty("overflow", e);
  }
  get overflowAnchor() {
    return this.getPropertyValue("overflow-anchor");
  }
  set overflowAnchor(e) {
    this.setProperty("overflow-anchor", e);
  }
  get overflowWrap() {
    return this.getPropertyValue("overflow-wrap");
  }
  set overflowWrap(e) {
    this.setProperty("overflow-wrap", e);
  }
  get overflowX() {
    return this.getPropertyValue("overflow-x");
  }
  set overflowX(e) {
    this.setProperty("overflow-x", e);
  }
  get overflowY() {
    return this.getPropertyValue("overflow-y");
  }
  set overflowY(e) {
    this.setProperty("overflow-y", e);
  }
  get overscrollBehavior() {
    return this.getPropertyValue("overscroll-behavior");
  }
  set overscrollBehavior(e) {
    this.setProperty("overscroll-behavior", e);
  }
  get overscrollBehaviorBlock() {
    return this.getPropertyValue("overscroll-behavior-block");
  }
  set overscrollBehaviorBlock(e) {
    this.setProperty("overscroll-behavior-block", e);
  }
  get overscrollBehaviorInline() {
    return this.getPropertyValue("overscroll-behavior-inline");
  }
  set overscrollBehaviorInline(e) {
    this.setProperty("overscroll-behavior-inline", e);
  }
  get overscrollBehaviorX() {
    return this.getPropertyValue("overscroll-behavior-x");
  }
  set overscrollBehaviorX(e) {
    this.setProperty("overscroll-behavior-x", e);
  }
  get overscrollBehaviorY() {
    return this.getPropertyValue("overscroll-behavior-y");
  }
  set overscrollBehaviorY(e) {
    this.setProperty("overscroll-behavior-y", e);
  }
  get overflowClipMargin() {
    return this.getPropertyValue("overflow-clip-margin");
  }
  set overflowClipMargin(e) {
    this.setProperty("overflow-clip-margin", e);
  }
  get padding() {
    return this.getPropertyValue("padding");
  }
  set padding(e) {
    this.setProperty("padding", e);
  }
  get paddingBlockEnd() {
    return this.getPropertyValue("padding-block-end");
  }
  set paddingBlockEnd(e) {
    this.setProperty("padding-block-end", e);
  }
  get paddingBlockStart() {
    return this.getPropertyValue("padding-block-start");
  }
  set paddingBlockStart(e) {
    this.setProperty("padding-block-start", e);
  }
  get paddingBottom() {
    return this.getPropertyValue("padding-bottom");
  }
  set paddingBottom(e) {
    this.setProperty("padding-bottom", e);
  }
  get paddingInlineEnd() {
    return this.getPropertyValue("padding-inline-end");
  }
  set paddingInlineEnd(e) {
    this.setProperty("padding-inline-end", e);
  }
  get paddingInlineStart() {
    return this.getPropertyValue("padding-inline-start");
  }
  set paddingInlineStart(e) {
    this.setProperty("padding-inline-start", e);
  }
  get paddingLeft() {
    return this.getPropertyValue("padding-left");
  }
  set paddingLeft(e) {
    this.setProperty("padding-left", e);
  }
  get paddingRight() {
    return this.getPropertyValue("padding-right");
  }
  set paddingRight(e) {
    this.setProperty("padding-right", e);
  }
  get paddingTop() {
    return this.getPropertyValue("padding-top");
  }
  set paddingTop(e) {
    this.setProperty("padding-top", e);
  }
  get page() {
    return this.getPropertyValue("page");
  }
  set page(e) {
    this.setProperty("page", e);
  }
  get pageBreakAfter() {
    return this.getPropertyValue("page-break-after");
  }
  set pageBreakAfter(e) {
    this.setProperty("page-break-after", e);
  }
  get pageBreakBefore() {
    return this.getPropertyValue("page-break-before");
  }
  set pageBreakBefore(e) {
    this.setProperty("page-break-before", e);
  }
  get pageBreakInside() {
    return this.getPropertyValue("page-break-inside");
  }
  set pageBreakInside(e) {
    this.setProperty("page-break-inside", e);
  }
  get pageOrientation() {
    return this.getPropertyValue("page-orientation");
  }
  set pageOrientation(e) {
    this.setProperty("page-orientation", e);
  }
  get paintOrder() {
    return this.getPropertyValue("paint-order");
  }
  set paintOrder(e) {
    this.setProperty("paint-order", e);
  }
  get perspective() {
    return this.getPropertyValue("perspective");
  }
  set perspective(e) {
    this.setProperty("perspective", e);
  }
  get perspectiveOrigin() {
    return this.getPropertyValue("perspective-origin");
  }
  set perspectiveOrigin(e) {
    this.setProperty("perspective-origin", e);
  }
  get placeContent() {
    return this.getPropertyValue("place-content");
  }
  set placeContent(e) {
    this.setProperty("place-content", e);
  }
  get placeItems() {
    return this.getPropertyValue("place-items");
  }
  set placeItems(e) {
    this.setProperty("place-items", e);
  }
  get placeSelf() {
    return this.getPropertyValue("place-self");
  }
  set placeSelf(e) {
    this.setProperty("place-self", e);
  }
  get pointerEvents() {
    return this.getPropertyValue("pointer-events");
  }
  set pointerEvents(e) {
    this.setProperty("pointer-events", e);
  }
  get position() {
    return this.getPropertyValue("position");
  }
  set position(e) {
    this.setProperty("position", e);
  }
  get quotes() {
    return this.getPropertyValue("quotes");
  }
  set quotes(e) {
    this.setProperty("quotes", e);
  }
  get r() {
    return this.getPropertyValue("r");
  }
  set r(e) {
    this.setProperty("r", e);
  }
  get resize() {
    return this.getPropertyValue("resize");
  }
  set resize(e) {
    this.setProperty("resize", e);
  }
  get right() {
    return this.getPropertyValue("right");
  }
  set right(e) {
    this.setProperty("right", e);
  }
  get rowGap() {
    return this.getPropertyValue("row-gap");
  }
  set rowGap(e) {
    this.setProperty("row-gap", e);
  }
  get rubyPosition() {
    return this.getPropertyValue("ruby-position");
  }
  set rubyPosition(e) {
    this.setProperty("ruby-position", e);
  }
  get rx() {
    return this.getPropertyValue("rx");
  }
  set rx(e) {
    this.setProperty("rx", e);
  }
  get ry() {
    return this.getPropertyValue("ry");
  }
  set ry(e) {
    this.setProperty("ry", e);
  }
  get scrollBehavior() {
    return this.getPropertyValue("scroll-behavior");
  }
  set scrollBehavior(e) {
    this.setProperty("scroll-behavior", e);
  }
  get scrollMargin() {
    return this.getPropertyValue("scroll-margin");
  }
  set scrollMargin(e) {
    this.setProperty("scroll-margin", e);
  }
  get scrollMarginBlock() {
    return this.getPropertyValue("scroll-margin-block");
  }
  set scrollMarginBlock(e) {
    this.setProperty("scroll-margin-block", e);
  }
  get scrollMarginBlockEnd() {
    return this.getPropertyValue("scroll-margin-block-end");
  }
  set scrollMarginBlockEnd(e) {
    this.setProperty("scroll-margin-block-end", e);
  }
  get scrollMarginBlockStart() {
    return this.getPropertyValue("scroll-margin-block-start");
  }
  set scrollMarginBlockStart(e) {
    this.setProperty("scroll-margin-block-start", e);
  }
  get scrollMarginBottom() {
    return this.getPropertyValue("scroll-margin-bottom");
  }
  set scrollMarginBottom(e) {
    this.setProperty("scroll-margin-bottom", e);
  }
  get scrollMarginInline() {
    return this.getPropertyValue("scroll-margin-inline");
  }
  set scrollMarginInline(e) {
    this.setProperty("scroll-margin-inline", e);
  }
  get scrollMarginInlineEnd() {
    return this.getPropertyValue("scroll-margin-inline-end");
  }
  set scrollMarginInlineEnd(e) {
    this.setProperty("scroll-margin-inline-end", e);
  }
  get scrollMarginInlineStart() {
    return this.getPropertyValue("scroll-margin-inline-start");
  }
  set scrollMarginInlineStart(e) {
    this.setProperty("scroll-margin-inline-start", e);
  }
  get scrollMarginLeft() {
    return this.getPropertyValue("scroll-margin-left");
  }
  set scrollMarginLeft(e) {
    this.setProperty("scroll-margin-left", e);
  }
  get scrollMarginRight() {
    return this.getPropertyValue("scroll-margin-right");
  }
  set scrollMarginRight(e) {
    this.setProperty("scroll-margin-right", e);
  }
  get scrollMarginTop() {
    return this.getPropertyValue("scroll-margin-top");
  }
  set scrollMarginTop(e) {
    this.setProperty("scroll-margin-top", e);
  }
  get scrollPadding() {
    return this.getPropertyValue("scroll-padding");
  }
  set scrollPadding(e) {
    this.setProperty("scroll-padding", e);
  }
  get scrollPaddingBlock() {
    return this.getPropertyValue("scroll-padding-block");
  }
  set scrollPaddingBlock(e) {
    this.setProperty("scroll-padding-block", e);
  }
  get scrollPaddingBlockEnd() {
    return this.getPropertyValue("scroll-padding-block-end");
  }
  set scrollPaddingBlockEnd(e) {
    this.setProperty("scroll-padding-block-end", e);
  }
  get scrollPaddingBlockStart() {
    return this.getPropertyValue("scroll-padding-block-start");
  }
  set scrollPaddingBlockStart(e) {
    this.setProperty("scroll-padding-block-start", e);
  }
  get scrollPaddingBottom() {
    return this.getPropertyValue("scroll-padding-bottom");
  }
  set scrollPaddingBottom(e) {
    this.setProperty("scroll-padding-bottom", e);
  }
  get scrollPaddingInline() {
    return this.getPropertyValue("scroll-padding-inline");
  }
  set scrollPaddingInline(e) {
    this.setProperty("scroll-padding-inline", e);
  }
  get scrollPaddingInlineEnd() {
    return this.getPropertyValue("scroll-padding-inline-end");
  }
  set scrollPaddingInlineEnd(e) {
    this.setProperty("scroll-padding-inline-end", e);
  }
  get scrollPaddingInlineStart() {
    return this.getPropertyValue("scroll-padding-inline-start");
  }
  set scrollPaddingInlineStart(e) {
    this.setProperty("scroll-padding-inline-start", e);
  }
  get scrollPaddingLeft() {
    return this.getPropertyValue("scroll-padding-left");
  }
  set scrollPaddingLeft(e) {
    this.setProperty("scroll-padding-left", e);
  }
  get scrollPaddingRight() {
    return this.getPropertyValue("scroll-padding-right");
  }
  set scrollPaddingRight(e) {
    this.setProperty("scroll-padding-right", e);
  }
  get scrollPaddingTop() {
    return this.getPropertyValue("scroll-padding-top");
  }
  set scrollPaddingTop(e) {
    this.setProperty("scroll-padding-top", e);
  }
  get scrollSnapAlign() {
    return this.getPropertyValue("scroll-snap-align");
  }
  set scrollSnapAlign(e) {
    this.setProperty("scroll-snap-align", e);
  }
  get scrollSnapStop() {
    return this.getPropertyValue("scroll-snap-stop");
  }
  set scrollSnapStop(e) {
    this.setProperty("scroll-snap-stop", e);
  }
  get scrollSnapType() {
    return this.getPropertyValue("scroll-snap-type");
  }
  set scrollSnapType(e) {
    this.setProperty("scroll-snap-type", e);
  }
  get shapeImageThreshold() {
    return this.getPropertyValue("shape-image-threshold");
  }
  set shapeImageThreshold(e) {
    this.setProperty("shape-image-threshold", e);
  }
  get shapeMargin() {
    return this.getPropertyValue("shape-margin");
  }
  set shapeMargin(e) {
    this.setProperty("shape-margin", e);
  }
  get shapeOutside() {
    return this.getPropertyValue("shape-outside");
  }
  set shapeOutside(e) {
    this.setProperty("shape-outside", e);
  }
  get shapeRendering() {
    return this.getPropertyValue("shape-rendering");
  }
  set shapeRendering(e) {
    this.setProperty("shape-rendering", e);
  }
  get size() {
    return this.getPropertyValue("size");
  }
  set size(e) {
    this.setProperty("size", e);
  }
  get speak() {
    return this.getPropertyValue("speak");
  }
  set speak(e) {
    this.setProperty("speak", e);
  }
  get src() {
    return this.getPropertyValue("src");
  }
  set src(e) {
    this.setProperty("src", e);
  }
  get stopColor() {
    return this.getPropertyValue("stop-color");
  }
  set stopColor(e) {
    this.setProperty("stop-color", e);
  }
  get stopOpacity() {
    return this.getPropertyValue("stop-opacity");
  }
  set stopOpacity(e) {
    this.setProperty("stop-opacity", e);
  }
  get stroke() {
    return this.getPropertyValue("stroke");
  }
  set stroke(e) {
    this.setProperty("stroke", e);
  }
  get strokeDasharray() {
    return this.getPropertyValue("stroke-dasharray");
  }
  set strokeDasharray(e) {
    this.setProperty("stroke-dasharray", e);
  }
  get strokeDashoffset() {
    return this.getPropertyValue("stroke-dashoffset");
  }
  set strokeDashoffset(e) {
    this.setProperty("stroke-dashoffset", e);
  }
  get strokeLinecap() {
    return this.getPropertyValue("stroke-linecap");
  }
  set strokeLinecap(e) {
    this.setProperty("stroke-linecap", e);
  }
  get strokeLinejoin() {
    return this.getPropertyValue("stroke-linejoin");
  }
  set strokeLinejoin(e) {
    this.setProperty("stroke-linejoin", e);
  }
  get strokeMiterlimit() {
    return this.getPropertyValue("stroke-miterlimit");
  }
  set strokeMiterlimit(e) {
    this.setProperty("stroke-miterlimit", e);
  }
  get strokeOpacity() {
    return this.getPropertyValue("stroke-opacity");
  }
  set strokeOpacity(e) {
    this.setProperty("stroke-opacity", e);
  }
  get strokeWidth() {
    return this.getPropertyValue("stroke-width");
  }
  set strokeWidth(e) {
    this.setProperty("stroke-width", e);
  }
  get syntax() {
    return this.getPropertyValue("syntax");
  }
  set syntax(e) {
    this.setProperty("syntax", e);
  }
  get scrollbarGutter() {
    return this.getPropertyValue("scrollbar-gutter");
  }
  set scrollbarGutter(e) {
    this.setProperty("scrollbar-gutter", e);
  }
  get tabSize() {
    return this.getPropertyValue("tab-size");
  }
  set tabSize(e) {
    this.setProperty("tab-size", e);
  }
  get tableLayout() {
    return this.getPropertyValue("table-layout");
  }
  set tableLayout(e) {
    this.setProperty("table-layout", e);
  }
  get textAlign() {
    return this.getPropertyValue("text-align");
  }
  set textAlign(e) {
    this.setProperty("text-align", e);
  }
  get textAlignLast() {
    return this.getPropertyValue("text-align-last");
  }
  set textAlignLast(e) {
    this.setProperty("text-align-last", e);
  }
  get textAnchor() {
    return this.getPropertyValue("text-anchor");
  }
  set textAnchor(e) {
    this.setProperty("text-anchor", e);
  }
  get textCombineUpright() {
    return this.getPropertyValue("text-combine-upright");
  }
  set textCombineUpright(e) {
    this.setProperty("text-combine-upright", e);
  }
  get textDecoration() {
    return this.getPropertyValue("text-decoration");
  }
  set textDecoration(e) {
    this.setProperty("text-decoration", e);
  }
  get textDecorationColor() {
    return this.getPropertyValue("text-decoration-color");
  }
  set textDecorationColor(e) {
    this.setProperty("text-decoration-color", e);
  }
  get textDecorationLine() {
    return this.getPropertyValue("text-decoration-line");
  }
  set textDecorationLine(e) {
    this.setProperty("text-decoration-line", e);
  }
  get textDecorationSkipInk() {
    return this.getPropertyValue("text-decoration-skip-ink");
  }
  set textDecorationSkipInk(e) {
    this.setProperty("text-decoration-skip-ink", e);
  }
  get textDecorationStyle() {
    return this.getPropertyValue("text-decoration-style");
  }
  set textDecorationStyle(e) {
    this.setProperty("text-decoration-style", e);
  }
  get textIndent() {
    return this.getPropertyValue("text-indent");
  }
  set textIndent(e) {
    this.setProperty("text-indent", e);
  }
  get textOrientation() {
    return this.getPropertyValue("text-orientation");
  }
  set textOrientation(e) {
    this.setProperty("text-orientation", e);
  }
  get textOverflow() {
    return this.getPropertyValue("text-overflow");
  }
  set textOverflow(e) {
    this.setProperty("text-overflow", e);
  }
  get textRendering() {
    return this.getPropertyValue("text-rendering");
  }
  set textRendering(e) {
    this.setProperty("text-rendering", e);
  }
  get textShadow() {
    return this.getPropertyValue("text-shadow");
  }
  set textShadow(e) {
    this.setProperty("text-shadow", e);
  }
  get textSizeAdjust() {
    return this.getPropertyValue("text-size-adjust");
  }
  set textSizeAdjust(e) {
    this.setProperty("text-size-adjust", e);
  }
  get textTransform() {
    return this.getPropertyValue("text-transform");
  }
  set textTransform(e) {
    this.setProperty("text-transform", e);
  }
  get textUnderlinePosition() {
    return this.getPropertyValue("text-underline-position");
  }
  set textUnderlinePosition(e) {
    this.setProperty("text-underline-position", e);
  }
  get top() {
    return this.getPropertyValue("top");
  }
  set top(e) {
    this.setProperty("top", e);
  }
  get touchAction() {
    return this.getPropertyValue("touch-action");
  }
  set touchAction(e) {
    this.setProperty("touch-action", e);
  }
  get transform() {
    return this.getPropertyValue("transform");
  }
  set transform(e) {
    this.setProperty("transform", e);
  }
  get transformBox() {
    return this.getPropertyValue("transform-box");
  }
  set transformBox(e) {
    this.setProperty("transform-box", e);
  }
  get transformOrigin() {
    return this.getPropertyValue("transform-origin");
  }
  set transformOrigin(e) {
    this.setProperty("transform-origin", e);
  }
  get transformStyle() {
    return this.getPropertyValue("transform-style");
  }
  set transformStyle(e) {
    this.setProperty("transform-style", e);
  }
  get transition() {
    return this.getPropertyValue("transition");
  }
  set transition(e) {
    this.setProperty("transition", e);
  }
  get transitionDelay() {
    return this.getPropertyValue("transition-delay");
  }
  set transitionDelay(e) {
    this.setProperty("transition-delay", e);
  }
  get transitionDuration() {
    return this.getPropertyValue("transition-duration");
  }
  set transitionDuration(e) {
    this.setProperty("transition-duration", e);
  }
  get transitionProperty() {
    return this.getPropertyValue("transition-property");
  }
  set transitionProperty(e) {
    this.setProperty("transition-property", e);
  }
  get transitionTimingFunction() {
    return this.getPropertyValue("transition-timing-function");
  }
  set transitionTimingFunction(e) {
    this.setProperty("transition-timing-function", e);
  }
  get textEmphasisColor() {
    return this.getPropertyValue("text-emphasis-color");
  }
  set textEmphasisColor(e) {
    this.setProperty("text-emphasis-color", e);
  }
  get textEmphasisPosition() {
    return this.getPropertyValue("text-emphasis-position");
  }
  set textEmphasisPosition(e) {
    this.setProperty("text-emphasis-position", e);
  }
  get textEmphasisStyle() {
    return this.getPropertyValue("text-emphasis-style");
  }
  set textEmphasisStyle(e) {
    this.setProperty("text-emphasis-style", e);
  }
  get unicodeBidi() {
    return this.getPropertyValue("unicode-bidi");
  }
  set unicodeBidi(e) {
    this.setProperty("unicode-bidi", e);
  }
  get unicodeRange() {
    return this.getPropertyValue("unicode-range");
  }
  set unicodeRange(e) {
    this.setProperty("unicode-range", e);
  }
  get userSelect() {
    return this.getPropertyValue("user-select");
  }
  set userSelect(e) {
    this.setProperty("user-select", e);
  }
  get userZoom() {
    return this.getPropertyValue("user-zoom");
  }
  set userZoom(e) {
    this.setProperty("user-zoom", e);
  }
  get vectorEffect() {
    return this.getPropertyValue("vector-effect");
  }
  set vectorEffect(e) {
    this.setProperty("vector-effect", e);
  }
  get verticalAlign() {
    return this.getPropertyValue("vertical-align");
  }
  set verticalAlign(e) {
    this.setProperty("vertical-align", e);
  }
  get visibility() {
    return this.getPropertyValue("visibility");
  }
  set visibility(e) {
    this.setProperty("visibility", e);
  }
  get whiteSpace() {
    return this.getPropertyValue("white-space");
  }
  set whiteSpace(e) {
    this.setProperty("white-space", e);
  }
  get widows() {
    return this.getPropertyValue("widows");
  }
  set widows(e) {
    this.setProperty("widows", e);
  }
  get width() {
    return this.getPropertyValue("width");
  }
  set width(e) {
    this.setProperty("width", e);
  }
  get willChange() {
    return this.getPropertyValue("will-change");
  }
  set willChange(e) {
    this.setProperty("will-change", e);
  }
  get wordBreak() {
    return this.getPropertyValue("word-break");
  }
  set wordBreak(e) {
    this.setProperty("word-break", e);
  }
  get wordSpacing() {
    return this.getPropertyValue("word-spacing");
  }
  set wordSpacing(e) {
    this.setProperty("word-spacing", e);
  }
  get wordWrap() {
    return this.getPropertyValue("word-wrap");
  }
  set wordWrap(e) {
    this.setProperty("word-wrap", e);
  }
  get writingMode() {
    return this.getPropertyValue("writing-mode");
  }
  set writingMode(e) {
    this.setProperty("writing-mode", e);
  }
  get x() {
    return this.getPropertyValue("x");
  }
  set x(e) {
    this.setProperty("x", e);
  }
  get y() {
    return this.getPropertyValue("y");
  }
  set y(e) {
    this.setProperty("y", e);
  }
  get zIndex() {
    return this.getPropertyValue("z-index");
  }
  set zIndex(e) {
    this.setProperty("z-index", e);
  }
  get zoom() {
    return this.getPropertyValue("zoom");
  }
  set zoom(e) {
    this.setProperty("zoom", e);
  }
  get containerType() {
    return this.getPropertyValue("container-type");
  }
  set containerType(e) {
    this.setProperty("container-type", e);
  }
  get containerName() {
    return this.getPropertyValue("container-name");
  }
  set containerName(e) {
    this.setProperty("container-name", e);
  }
  get aspectRatio() {
    return this.getPropertyValue("aspect-ratio");
  }
  set aspectRatio(e) {
    this.setProperty("aspect-ratio", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this.#r().size();
  }
  /**
   * Returns the style decleration as a CSS text.
   *
   * @returns CSS text.
   */
  get cssText() {
    return this.#e && this.#t ? "" : this.#r().toString();
  }
  /**
   * Sets CSS text.
   *
   * @param cssText CSS text.
   */
  set cssText(e) {
    if (this.#t)
      throw new this[b].DOMException("Failed to execute 'cssText' on 'CSSStyleDeclaration': These styles are computed, and the properties are therefore read-only.", ne.domException);
    this.#e ? (this.#n.propertyManager = new Od({ cssText: e }), this.#n.attributeValue = e, this.#e.setAttribute("style", this.#n.propertyManager.toString())) : this.#n.propertyManager = new Od({ cssText: e });
  }
  /**
   * Returns item.
   *
   * @param index Index.
   * @returns Item.
   */
  item(e) {
    return this.#r().item(e);
  }
  /**
   * Set a property.
   *
   * @param name Property name.
   * @param value Value. Must not contain "!important" as that should be set using the priority parameter.
   * @param [priority] Can be "important", or an empty string.
   */
  setProperty(e, n, r) {
    if (this.#t)
      throw new this[b].DOMException(`Failed to execute 'setProperty' on 'CSSStyleDeclaration': These styles are computed, and therefore the '${e}' property is read-only.`, ne.domException);
    if (r !== "" && r !== void 0 && r !== "important")
      return;
    const i = String(n).trim(), s = this.#r();
    i ? s.set(e, i, !!r) : s.remove(e), this.#e && (this.#n.attributeValue = s.toString(), this.#n.attributeValue ? this.#e.setAttribute("style", this.#n.attributeValue) : this.#e.removeAttribute("style"));
  }
  /**
   * Removes a property.
   *
   * @param name Property name in kebab case.
   * @param value Value. Must not contain "!important" as that should be set using the priority parameter.
   * @param [priority] Can be "important", or an empty string.
   */
  removeProperty(e) {
    if (this.#t)
      throw new this[b].DOMException(`Failed to execute 'removeProperty' on 'CSSStyleDeclaration': These styles are computed, and therefore the '${e}' property is read-only.`, ne.domException);
    const n = this.#r();
    n.remove(e), this.#e && (this.#n.attributeValue = n.toString(), this.#n.attributeValue ? this.#e.setAttribute("style", this.#n.attributeValue) : this.#e.removeAttribute("style"));
  }
  /**
   * Returns a property.
   *
   * @param name Property name in kebab case.
   * @returns Property value.
   */
  getPropertyValue(e) {
    return this.#r().get(e)?.value || "";
  }
  /**
   * Returns a property.
   *
   * @param name Property name in kebab case.
   * @returns "important" if set to be important.
   */
  getPropertyPriority(e) {
    return this.#r().get(e)?.important ? "important" : "";
  }
  /**
   * Returns property manager.
   *
   * @returns Property manager.
   */
  #r() {
    const e = this.#e, n = this.#n;
    if (!e)
      return n.propertyManager || (n.propertyManager = new Od()), n.propertyManager;
    if (this.#t)
      return new z5e(e).getComputedStyle();
    const r = e.getAttribute("style") || "";
    return n.attributeValue !== r && (n.propertyManager = new Od({ cssText: r })), n.propertyManager;
  }
}
class GA extends UA {
  [go] = "";
  /**
   * Returns condition text.
   *
   * @returns Condition text.
   */
  get conditionText() {
    return this[go];
  }
}
class V7 extends GA {
  [qn] = at.containerRule;
  [Ka] = "";
  /**
   * @override
   */
  get type() {
    return at.containerRule;
  }
  /**
   * @override
   */
  get cssText() {
    let e = "";
    for (const n of this[Ui])
      e += `
  ` + n.cssText;
    return e += `
`, `@${this[Ka]}container ${this[go]} {${e}}`;
  }
}
class K7 extends bp {
  [za] = "";
  #e = null;
  /**
   * @override
   */
  get type() {
    return at.fontFaceRule;
  }
  /**
   * @override
   */
  get cssText() {
    return `@font-face { ${this.style.cssText} }`;
  }
  /**
   * Returns style.
   *
   * @returns Style.
   */
  get style() {
    return this.#e || (this.#e = new vh(T, this[b]), this.#e.parentRule = this, this.#e.cssText = this[za]), this.#e;
  }
}
class U2 extends bp {
  [yh] = "";
  [za] = "";
  #e = null;
  /**
   * @override
   */
  get type() {
    return at.keyframeRule;
  }
  /**
   * @override
   */
  get cssText() {
    return `${this[yh]} { ${this.style.cssText} }`;
  }
  /**
   * Returns style.
   *
   * @returns Style.
   */
  get style() {
    return this.#e || (this.#e = new vh(T, this[b]), this.#e.parentRule = this, this.#e.cssText = this[za]), this.#e;
  }
  /**
   * Returns key text.
   *
   * @returns Key text.
   */
  get keyText() {
    return this[yh];
  }
}
const j5e = /^(from|to|[0-9]{1,3}%)\s*{([^}]*)}$/;
class z7 extends bp {
  [Ui] = [];
  [tt] = "";
  [Ka] = "";
  /**
   * @override
   */
  get type() {
    return at.keyframesRule;
  }
  /**
   * @override
   */
  get cssText() {
    let e = "";
    for (const n of this[Ui])
      e += `
  ` + n.cssText;
    return e += `
`, `@${this[Ka]}keyframes ${this[tt]} { ${e}}`;
  }
  /**
   * Returns CSS rules.
   *
   * @returns CSS rules.
   */
  get cssRules() {
    return this[Ui];
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this[tt];
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[Ui].length;
  }
  /**
   * Appends a rule.
   *
   * @param rule Rule. E.g. "0% { transform: rotate(360deg); }".
   */
  appendRule(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'appendRule' on 'CSSKeyframesRule': 1 argument required, but only 0 present.");
    const n = String(e).trim().match(j5e);
    if (!n)
      throw new this[b].DOMException("Invalid or unexpected token", ne.syntaxError);
    const r = new U2(T, this[b], this[U1]);
    let i = n[1].trim();
    i === "from" ? i = "0%" : i === "to" && (i = "100%"), r[tf] = this, r[yh] = i, r[za] = n[2].trim(), this[Ui].push(r);
  }
  /**
   * Removes a rule.
   *
   * @param rule Rule. E.g. "0%".
   */
  deleteRule(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'deleteRule' on 'CSSKeyframesRule': 1 argument required, but only 0 present.");
    for (let n = 0, r = this[Ui].length; n < r; n++)
      if (this[Ui][n][yh] === e) {
        this[Ui].splice(n, 1);
        return;
      }
  }
  /**
   * Finds a rule.
   *
   * @param rule Rule. E.g. "0%".
   * @returns Rule.
   */
  findRule(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'findRule' on 'CSSKeyframesRule': 1 argument required, but only 0 present.");
    for (let n = 0, r = this[Ui].length; n < r; n++)
      if (this[Ui][n][yh] === e)
        return this[Ui][n];
    return null;
  }
}
const BL = /\s*,\s*/;
class WA {
  [pl];
  /**
   *
   * @param illegalConstructorSymbol
   * @param cssRule
   */
  constructor(e, n) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[pl] = n;
    const r = new Ws(this, [WA]);
    return new Proxy(this, {
      get: (i, s) => {
        if (s in i || typeof s == "symbol")
          return r.bind(s), i[s];
        const a = Number(s);
        if (!isNaN(a))
          return i[De]()[a];
      },
      set(i, s, a) {
        return r.bind(s), (s in i || typeof s == "symbol") && (i[s] = a), !0;
      },
      deleteProperty(i, s) {
        return (s in i || typeof s == "symbol") && delete i[s], !0;
      },
      ownKeys(i) {
        return Object.keys(i[De]());
      },
      has(i, s) {
        if (typeof s == "symbol")
          return !1;
        if (s in i)
          return !0;
        const a = Number(s);
        return !isNaN(a) && a >= 0 && a < i[De]().length;
      },
      defineProperty(i, s, a) {
        return r.preventBinding(s), s in i ? (Object.defineProperty(i, s, a), !0) : !1;
      },
      getOwnPropertyDescriptor(i, s) {
        if (s in i || typeof s == "symbol")
          return;
        const a = Number(s), o = i[De]();
        if (!isNaN(a) && o[a])
          return {
            value: o[a],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[De]().length;
  }
  /**
   * Returns media text.
   *
   * @returns Media text.
   */
  get mediaText() {
    return this[pl][go];
  }
  /**
   * Sets media text.
   *
   * @param mediaText Media text.
   */
  set mediaText(e) {
    this[pl][go] = e === null ? "" : String(e).split(BL).join(", ");
  }
  /**
   * Returns item.
   *
   * @param index Index.
   * @returns Item.
   */
  item(e) {
    return this[De]()[Number(e)] || null;
  }
  /**
   * Appends a medium.
   *
   * @param medium Medium.
   */
  appendMedium(e) {
    const n = this[De]();
    n.indexOf(e) === -1 && (n.push(e), this[pl][go] = n.join(", "));
  }
  /**
   * Deletes a medium.
   *
   * @param medium Medium.
   */
  deleteMedium(e) {
    const n = this[De](), r = n.indexOf(e);
    r !== -1 && (n.splice(r, 1), this[pl][go] = n.join(", "));
  }
  /**
   * Returns item list.
   *
   * @returns Item list.
   */
  [De]() {
    return this[pl][go].trim() ? this[pl][go].split(BL) : [];
  }
}
class j7 extends GA {
  [kL] = new WA(T, this);
  /**
   * @override
   */
  get type() {
    return at.mediaRule;
  }
  /**
   * @override
   */
  get cssText() {
    let e = "";
    for (const n of this[Ui])
      e += `
  ` + n.cssText;
    return e += e ? `
` : "  ", `@media ${this.conditionText} {${e}}`;
  }
  /**
   * Returns media.
   *
   * @returns Media.
   */
  get media() {
    return this[kL];
  }
  /**
   * Returns conditional text.
   *
   * @returns Conditional text.
   */
  get conditionText() {
    return this.media.mediaText;
  }
}
class Kv {
  #e;
  /**
   * Constructor.
   *
   * @param value Value..
   */
  constructor(e) {
    this.#e = e;
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    return this.#e;
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    this.#e = e;
  }
}
class zv {
  #e;
  #t;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol
   * @param style Style.
   * @param property Property.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this.#e = n, this.#t = r;
  }
  /**
   * Returns value as string.
   *
   * @returns Value.
   */
  toString() {
    return this.#e.getPropertyValue(this.#t);
  }
}
class Y7 {
  [er];
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param style Style.
   */
  constructor(e, n) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[er] = n;
  }
  /**
   * Returns size.
   *
   * @returns Size.
   */
  get size() {
    return this[er].length;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  [Symbol.iterator]() {
    return this.entries();
  }
  /**
   * Returns an iterator, allowing you to go through all key/value pairs contained in this object.
   *
   * @returns Entries.
   */
  entries() {
    const e = this[er].length, n = new Array(e);
    for (let r = 0; r < e; r++) {
      const i = this[er][r];
      n[r] = [
        i,
        [new Kv(this[er].getPropertyValue(i))]
      ];
    }
    return n.values();
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   *
   * @returns Values.
   */
  values() {
    const e = this[er].length, n = new Array(e);
    for (let r = 0; r < e; r++) {
      const i = this[er][r];
      n[r] = [new Kv(this[er].getPropertyValue(i))];
    }
    return n.values();
  }
  /**
   * Returns an iterator, allowing you to go through all keys of the key/value pairs contained in this object.
   *
   * @returns Keys.
   */
  keys() {
    const e = this[er].length, n = new Array(e);
    for (let r = 0; r < e; r++)
      n[r] = this[er][r];
    return n.values();
  }
  /**
   * Returns a property value.
   *
   * @param property Property.
   * @returns Value.
   */
  get(e) {
    return new zv(T, this[er], e);
  }
  /**
   * Returns array of property values.
   *
   * @param property Property.
   * @returns Values.
   */
  getAll(e) {
    return [
      new zv(T, this[er], e)
    ];
  }
  /**
   * Checks if a property is present.
   *
   * @param property Property.
   * @returns True if the property is present.
   */
  has(e) {
    return !!this[er].getPropertyValue(e);
  }
}
class q7 extends Y7 {
  /**
   * Appends a property.
   *
   * @param property Property.
   * @param value Value.
   */
  append(e, n) {
    this[er].setProperty(e, n);
  }
  /**
   * Clears all properties.
   */
  clear() {
    this[er].cssText = "";
  }
  /**
   * Deletes a property.
   *
   * @param property Property.
   */
  delete(e) {
    this[er].removeProperty(e);
  }
  /**
   * Sets a property.
   *
   * @param property Property.
   * @param value Value.
   */
  set(e, n) {
    this[er].setProperty(e, n);
  }
}
class Wy extends UA {
  [py] = null;
  [gg] = "";
  [za] = "";
  #e = null;
  /**
   * @override
   */
  get type() {
    return at.styleRule;
  }
  /**
   * @override
   */
  get cssText() {
    return `${this[gg]} { ${this.style.cssText} }`;
  }
  /**
   * Returns style map.
   *
   * @returns Style map.
   */
  get styleMap() {
    return this[py] || (this[py] = new q7(T, this.style)), this[py];
  }
  /**
   * Returns selector text.
   *
   * @returns Selector text.
   */
  get selectorText() {
    return this[gg];
  }
  /**
   * Returns style.
   *
   * @returns Style.
   */
  get style() {
    return this.#e || (this.#e = new vh(T, this[b]), this.#e.parentRule = this, this.#e.cssText = this[za]), this.#e;
  }
}
class J7 extends GA {
  [qn] = at.supportsRule;
  [Ka] = "";
  /**
   * @override
   */
  get type() {
    return at.supportsRule;
  }
  /**
   * @override
   */
  get cssText() {
    let e = "";
    for (const n of this[Ui])
      e += `
  ` + n.cssText;
    return e += `
`, `@${this[Ka]}supports ${this.conditionText} {${e}}`;
  }
}
const xn = {
  html: "http://www.w3.org/1999/xhtml",
  svg: "http://www.w3.org/2000/svg",
  mathML: "http://www.w3.org/1998/Math/MathML",
  xml: "http://www.w3.org/XML/1998/namespace",
  xlink: "http://www.w3.org/1999/xlink",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, $L = /* @__PURE__ */ new Map(), HL = /* @__PURE__ */ new Map(), Y5e = /[A-Z]/g, q5e = /[a-z]/g;
class yo {
  /**
   * ASCII lowercase.
   *
   * @see https://infra.spec.whatwg.org/#ascii-lowercase
   * @param text Text.
   * @returns Lowercase text.
   */
  static asciiLowerCase(e) {
    const n = $L.get(e);
    if (n)
      return n;
    const r = e.replace(Y5e, (i) => String.fromCharCode(i.charCodeAt(0) + 32));
    return $L.set(e, r), r;
  }
  /**
   * ASCII uppercase.
   *
   * @see https://infra.spec.whatwg.org/#ascii-uppercase
   * @param text Text.
   * @returns Uppercase text.
   */
  static asciiUpperCase(e) {
    const n = HL.get(e);
    if (n)
      return n;
    const r = e.replace(q5e, (i) => String.fromCharCode(i.charCodeAt(0) - 32));
    return HL.set(e, r), r;
  }
}
const UL = "[-_.]|[0-9]|[a-z]|·|[À-Ö]|[Ø-ö]|[ø-ͽ]|[Ϳ-῿]|[‌-‍]|[‿-⁀]|[⁰-↏]|[Ⰰ-⿯]|[、-퟿]|[豈-﷏]|[ﷰ-�]|[𐀀-󯿿]", J5e = new RegExp(`^[a-z](${UL})*-(${UL})*$`, "u"), Q5e = [
  "annotation-xml",
  "color-profile",
  "font-face",
  "font-face-src",
  "font-face-uri",
  "font-face-format",
  "font-face-name",
  "missing-glyph"
];
class GL {
  /**
   * Returns true if the tag name is a valid custom element name.
   *
   * @see https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
   * @param name Tag name.
   * @returns True if valid.
   */
  static isValidCustomElementName(e) {
    return J5e.test(e) && !Q5e.includes(e);
  }
}
class WL {
  [xl] = /* @__PURE__ */ new Map();
  [pm] = /* @__PURE__ */ new Map();
  [Mu] = /* @__PURE__ */ new Map();
  [ob] = !1;
  #e;
  /**
   * Constructor.
   *
   * @param window Window.
   */
  constructor(e) {
    if (!e)
      throw new TypeError("Illegal constructor");
    this.#e = e;
  }
  /**
   * Defines a custom element class.
   *
   * @param name Tag name of element.
   * @param elementClass Element class.
   * @param [options] Options.
   * @param [options.extends] Extends tag name.
   */
  define(e, n, r) {
    if (this[ob])
      return;
    if (!GL.isValidCustomElementName(e))
      throw new this.#e.DOMException(`Failed to execute 'define' on 'CustomElementRegistry': "${e}" is not a valid custom element name`);
    if (this[xl].has(e))
      throw new this.#e.DOMException(`Failed to execute 'define' on 'CustomElementRegistry': the name "${e}" has already been used with this registry`);
    if (this[pm].has(n))
      throw new this.#e.DOMException("Failed to execute 'define' on 'CustomElementRegistry': this constructor has already been used with this registry");
    const i = yo.asciiUpperCase(e);
    n.prototype[b] = this.#e, n.prototype[he] = this.#e.document, n.prototype[Xe] = i, n.prototype[Tt] = e, n.prototype[je] = xn.html;
    const s = /* @__PURE__ */ new Set(), a = n.observedAttributes;
    if (Array.isArray(a))
      for (const u of a)
        s.add(String(u).toLowerCase());
    this[xl].set(e, {
      elementClass: n,
      extends: r && r.extends ? r.extends.toLowerCase() : null,
      observedAttributes: s,
      lifecycleCallbacks: {
        connectedCallback: n.prototype.connectedCallback,
        disconnectedCallback: n.prototype.disconnectedCallback,
        attributeChangedCallback: n.prototype.attributeChangedCallback
      }
    }), this[pm].set(n, e);
    const o = this[Mu].get(e);
    if (o) {
      this[Mu].delete(e);
      for (const u of o)
        u();
    }
  }
  /**
   * Returns a defined element class.
   *
   * @param name Tag name of element.
   * @returns HTMLElement Class defined or undefined.
   */
  get(e) {
    return this[xl].get(e)?.elementClass;
  }
  /**
   * Upgrades a custom element directly, even before it is connected to its shadow root.
   *
   * Not implemented yet.
   *
   * @param _root Root node.
   */
  upgrade(e) {
  }
  /**
   * When defined.
   *
   * @param name Tag name of element.
   */
  whenDefined(e) {
    return this[ob] ? Promise.reject(new this.#e.DOMException("Failed to execute 'whenDefined' on 'CustomElementRegistry': The custom element registry has been destroyed.")) : GL.isValidCustomElementName(e) ? this.get(e) ? Promise.resolve() : new Promise((n) => {
      const r = this[Mu].get(e);
      r ? r.push(n) : this[Mu].set(e, [n]);
    }) : Promise.reject(new this.#e.DOMException(`Failed to execute 'whenDefined' on 'CustomElementRegistry': Invalid custom element name: "${e}"`));
  }
  /**
   * Reverse lookup searching for name by given element class.
   *
   * @param elementClass Class constructor.
   * @returns Found tag name or `null`.
   */
  getName(e) {
    return this[pm].get(e) || null;
  }
  /**
   * Destroys the registry.
   */
  [tn]() {
    this[ob] = !0;
    for (const e of this[xl].values())
      e.elementClass.prototype[b] = null, e.elementClass.prototype[he] = null, e.elementClass.prototype[Xe] = null, e.elementClass.prototype[Tt] = null, e.elementClass.prototype[je] = null;
    this[xl] = /* @__PURE__ */ new Map(), this[pm] = /* @__PURE__ */ new Map(), this[Mu] = /* @__PURE__ */ new Map();
  }
}
class W1 {
  kind;
  type;
  #e = null;
  /**
   * Constructor.
   *
   * @param item Item.
   * @param type Type.
   */
  constructor(e, n = "") {
    this.kind = typeof e == "string" ? "string" : "file", this.type = this.kind === "string" ? n : e.type, this.#e = e;
  }
  /**
   * Returns file.
   */
  getAsFile() {
    return this.kind === "string" ? null : this.#e;
  }
  /**
   * Returns string.
   *
   * @param callback Callback.
   */
  getAsString(e) {
    this.kind, e(this.#e);
  }
}
class mh extends Di {
  lastModified;
  name;
  /**
   * Constructor.
   *
   * @param bits File bits.
   * @param name File name.
   * @param [options] Options.
   * @param [options.type] MIME type.
   * @param [options.lastModifier] Last modified. Defaults to Date.now().
   * @param options.lastModified
   */
  constructor(e, n, r) {
    if (arguments.length < 2)
      throw new TypeError("Failed to construct 'File': 2 arguments required, but only " + arguments.length + " present.");
    super(e, r), this.name = n, this.lastModified = r && r.lastModified ? r.lastModified : Date.now();
  }
}
class Q7 extends Array {
  /**
   * Adds an item.
   *
   * @param item Item.
   * @param type Type.
   */
  add(e, n) {
    if (e instanceof mh) {
      this.push(new W1(e));
      return;
    }
    if (!n)
      throw new TypeError("Failed to execute 'add' on 'DataTransferItemList': parameter 1 is not of type 'File'.");
    this.push(new W1(e, n));
  }
  /**
   * Removes an item.
   *
   * @param index Index.
   */
  remove(e) {
    this.splice(e, 1);
  }
  /**
   * Clears list.
   */
  clear() {
    for (; this.length; )
      this.pop();
  }
}
class X5e {
  dropEffect = "none";
  effectAllowed = "none";
  items = new Q7();
  /**
   * Returns files.
   *
   * @returns Files.
   */
  get files() {
    const e = [];
    for (const n of this.items)
      if (n.kind === "file") {
        const r = n.getAsFile();
        r && e.push(r);
      }
    return e;
  }
  /**
   * Returns types.
   *
   * @returns Types.
   */
  get types() {
    return this.items.map((e) => e.type);
  }
  /**
   * Clears the data.
   */
  clearData() {
    this.items.clear();
  }
  /**
   * Sets the data.
   *
   * @param format Format.
   * @param data Data.
   */
  setData(e, n) {
    for (let r = 0, i = this.items.length; r < i; r++)
      if (this.items[r].type === e) {
        this.items[r] = new W1(n, e);
        return;
      }
    this.items.add(n, e);
  }
  /**
   * Gets the data.
   *
   * @param format Format.
   * @returns Data.
   */
  getData(e) {
    const n = this.#e(e);
    for (let r = 0, i = this.items.length; r < i; r++)
      if (this.#e(this.items[r].type) === n) {
        let a = "";
        return this.items[r].getAsString((o) => a = o), a;
      }
    return "";
  }
  /**
   * Normalizes the format according to the HTML spec.
   *
   * @param format Format to normalize.
   * @returns Normalized format.
   */
  #e(e) {
    const n = e.toLowerCase();
    return n === "text" ? "text/plain" : n === "url" ? "text/uri-list" : n;
  }
  /**
   * Sets drag image.
   *
   * TODO: Implement.
   */
  setDragImage() {
    throw new Error("Not implemented.");
  }
}
class Z5e {
  identifier;
  target;
  clientX;
  clientY;
  screenX;
  screenY;
  pageX;
  pageY;
  radiusX;
  radiusY;
  rotationAngle;
  force;
  /**
   * Constructor.
   *
   * @param [touchInit] Touch init.
   */
  constructor(e) {
    this.identifier = e.identifier, this.target = e.target, this.clientX = e.clientX ?? 0, this.clientY = e.clientY ?? 0, this.screenX = e.screenX ?? 0, this.screenY = e.screenY ?? 0, this.pageX = e.pageX ?? 0, this.pageY = e.pageY ?? 0, this.radiusX = e.radiusX ?? 0, this.radiusY = e.radiusY ?? 0, this.rotationAngle = e.rotationAngle ?? 0, this.force = e.force ?? 0;
  }
}
class vc extends be {
  static NONE = 0;
  static CAPTURING_PHASE = 1;
  static AT_TARGET = 2;
  static BUBBLING_PHASE = 3;
  detail;
  layerX = 0;
  layerY = 0;
  pageX = 0;
  pageY = 0;
  view;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.detail = n?.detail ?? 0, this.view = n?.view ?? null;
  }
}
class e$e extends be {
  animationName;
  elapsedTime;
  pseudoElement;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.animationName = n?.animationName ?? "", this.elapsedTime = n?.elapsedTime ?? 0, this.pseudoElement = n?.pseudoElement ?? "";
  }
}
class t$e extends be {
  clipboardData;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.clipboardData = n?.clipboardData ?? null;
  }
}
class n$e extends be {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ab];
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this[ab] = n?.detail ?? null;
  }
  /**
   * Returns detail.
   *
   * @returns Detail.
   */
  get detail() {
    return this[ab];
  }
  /**
   * Init event.
   *
   * @deprecated
   * @param type Type.
   * @param [bubbles=false] "true" if it bubbles.
   * @param [cancelable=false] "true" if it cancelable.
   * @param [detail=null] Custom event detail.
   */
  initCustomEvent(e, n = !1, r = !1, i = null) {
    this[qn] = e, this[Md] = n, this[hh] = r, this[ab] = i;
  }
}
class V1 extends vc {
  message;
  filename;
  lineno;
  colno;
  error;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.message = n?.message ?? "", this.filename = n?.filename ?? "", this.lineno = n?.lineno ?? 0, this.colno = n?.colno ?? 0, this.error = n?.error ?? null;
  }
}
class Vm extends vc {
  relatedTarget;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.relatedTarget = n?.relatedTarget ?? null;
  }
}
class X7 extends be {
  newURL;
  oldURL;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.newURL = n?.newURL ?? "", this.oldURL = n?.oldURL ?? "";
  }
}
class r$e extends vc {
  data;
  dataTransfer;
  inputType;
  isComposing;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.data = n?.data ?? "", this.dataTransfer = n?.dataTransfer ?? null, this.inputType = n?.inputType ?? "", this.isComposing = n?.isComposing ?? !1;
  }
}
class i$e extends vc {
  static DOM_KEY_LOCATION_STANDARD = 0;
  static DOM_KEY_LOCATION_LEFT = 1;
  static DOM_KEY_LOCATION_RIGHT = 2;
  static DOM_KEY_LOCATION_NUMPAD = 3;
  altKey;
  code;
  ctrlKey;
  isComposing;
  key;
  location;
  metaKey;
  repeat;
  shiftKey;
  /**
   * @deprecated
   */
  keyCode;
  /**
   * @deprecated
   */
  which;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.altKey = n?.altKey ?? !1, this.code = n?.code ?? "", this.ctrlKey = n?.ctrlKey ?? !1, this.isComposing = n?.isComposing ?? !1, this.key = n?.key ?? "", this.location = n?.location ?? 0, this.metaKey = n?.metaKey ?? !1, this.repeat = n?.repeat ?? !1, this.shiftKey = n?.shiftKey ?? !1, this.keyCode = n?.keyCode ?? 0, this.which = n?.which ?? n?.keyCode ?? 0;
  }
  /**
   * Returns the state of a modifier key.
   *
   * @param key A modifier key value.
   * @returns True if it's pressed, false otherwise.
   */
  getModifierState(e) {
    if (arguments.length < 1)
      throw new TypeError("Failed to execute 'getModifierState' on 'KeyboardEvent': 1 argument required, but only 0 present.");
    switch (String(e).toLowerCase()) {
      case "alt":
      case "altgraph":
        return this.altKey;
      case "control":
        return this.ctrlKey;
      case "meta":
        return this.metaKey;
      case "shift":
        return this.shiftKey;
      default:
        return !1;
    }
  }
}
class VL extends be {
  data;
  origin;
  lastEventId;
  source;
  ports;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.data = n?.data ?? null, this.origin = n?.origin ?? "", this.lastEventId = n?.lastEventId ?? "", this.source = n?.source ?? null, this.ports = n?.ports ?? [];
  }
}
class _o extends vc {
  altKey;
  button;
  buttons;
  clientX;
  clientY;
  ctrlKey;
  metaKey;
  movementX;
  movementY;
  offsetX;
  offsetY;
  region;
  relatedTarget;
  screenX;
  screenY;
  shiftKey;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.altKey = n?.altKey ?? !1, this.button = n?.button ?? 0, this.buttons = n?.buttons ?? 0, this.clientX = n?.clientX ?? 0, this.clientY = n?.clientY ?? 0, this.ctrlKey = n?.ctrlKey ?? !1, this.metaKey = n?.metaKey ?? !1, this.movementX = n?.movementX ?? 0, this.movementY = n?.movementY ?? 0, this.offsetX = n?.offsetX ?? 0, this.offsetY = n?.offsetY ?? 0, this.region = n?.region ?? "", this.relatedTarget = n?.relatedTarget ?? null, this.screenX = n?.screenX ?? 0, this.screenY = n?.screenY ?? 0, this.shiftKey = n?.shiftKey ?? !1;
  }
}
let Z7 = class extends _o {
  pointerId;
  width;
  height;
  pressure;
  tangentialPressure;
  tiltX;
  tiltY;
  twist;
  altitudeAngle;
  azimuthAngle;
  pointerType;
  isPrimary;
  coalescedEvents;
  predictedEvents;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.pointerId = n?.pointerId ?? 0, this.width = n?.width ?? 1, this.height = n?.height ?? 1, this.pressure = n?.pressure ?? 0, this.tangentialPressure = n?.tangentialPressure ?? 0, this.tiltX = n?.tiltX ?? 0, this.tiltY = n?.tiltY ?? 0, this.twist = n?.twist ?? 0, this.altitudeAngle = n?.altitudeAngle ?? 0, this.azimuthAngle = n?.azimuthAngle ?? 0, this.pointerType = n?.pointerType ?? "", this.isPrimary = n?.isPrimary ?? !1, this.coalescedEvents = n?.coalescedEvents ?? [], this.predictedEvents = n?.predictedEvents ?? [];
  }
  getCoalescedEvents = () => this.coalescedEvents;
  getPredictedEvents = () => this.predictedEvents;
};
class kl extends be {
  lengthComputable;
  loaded;
  total;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e), this.lengthComputable = n?.lengthComputable ?? !1, this.loaded = n?.loaded ?? 0, this.total = n?.total ?? 0;
  }
}
class s$e extends be {
  key;
  oldValue;
  newValue;
  url;
  storageArea;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e), this.key = n?.key ?? null, this.oldValue = n?.oldValue ?? null, this.newValue = n?.newValue ?? null, this.url = n?.url ?? "", this.storageArea = n?.storageArea ?? null;
  }
}
class eW extends be {
  submitter;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.submitter = n?.submitter ?? null;
  }
}
class a$e extends vc {
  altKey;
  changedTouches;
  ctrlKey;
  metaKey;
  shiftKey;
  targetTouches;
  touches;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.altKey = n?.altKey ?? !1, this.changedTouches = n?.changedTouches ?? [], this.ctrlKey = n?.ctrlKey ?? !1, this.metaKey = n?.metaKey ?? !1, this.shiftKey = n?.shiftKey ?? !1, this.targetTouches = n?.targetTouches ?? [], this.touches = n?.touches ?? [];
  }
}
class o$e extends vc {
  static DOM_DELTA_PIXEL = 0;
  static DOM_DELTA_LINE = 1;
  static DOM_DELTA_PAGE = 2;
  deltaX;
  deltaY;
  deltaZ;
  deltaMode;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.deltaX = n?.deltaX ?? 0, this.deltaY = n?.deltaY ?? 0, this.deltaZ = n?.deltaZ ?? 0, this.deltaMode = n?.deltaMode ?? 0;
  }
}
let vi = class extends Pr {
  /**
   * Constructor.
   *
   * @param url URL.
   * @param [base] Base URL.
   */
  constructor(e, n) {
    try {
      super(e, n);
    } catch (r) {
      throw super("about:blank"), this[b] ? new this[b].TypeError("Invalid URL") : r;
    }
  }
  /**
   * Creates a string containing a URL representing the object given in the parameter.
   *
   * @param object Object.
   * @returns URL.
   */
  static createObjectURL(e) {
    if (e instanceof Di) {
      const n = new GQ([e[En]], { type: e.type });
      return super.createObjectURL(n);
    }
    return super.createObjectURL(e);
  }
};
const u$e = /^(about|blob|data):$/, l$e = [
  "",
  "no-referrer",
  "no-referrer-when-downgrade",
  "same-origin",
  "origin",
  "strict-origin",
  "origin-when-cross-origin",
  "strict-origin-when-cross-origin",
  "unsafe-url"
];
class Ug {
  /**
   * Prepares the request before being sent.
   *
   * @param originURL Origin URL.
   * @param request Request.
   */
  static prepareRequest(e, n) {
    n.referrerPolicy || (n[Uy] = "strict-origin-when-cross-origin"), n.referrer && n.referrer !== "no-referrer" ? n[ra] = this.getSentReferrer(e, n) : n[ra] = "no-referrer";
  }
  /**
   * Returns initial referrer.
   *
   * @param window Window.
   * @param referrer Referrer.
   * @returns Initial referrer.
   */
  static getInitialReferrer(e, n) {
    if (n === "" || n === "no-referrer" || n === "client")
      return n;
    if (n) {
      const r = n instanceof vi ? n : new vi(n, e.location.href);
      return r.origin === e.location.origin ? r : "client";
    }
    return "client";
  }
  /**
   * Returns referrer policy from header.
   *
   * @see https://w3c.github.io/webappsec-referrer-policy/#parse-referrer-policy-from-header
   * @param headers Response headers
   * @returns Policy.
   */
  static getReferrerPolicyFromHeader(e) {
    const n = e.get("Referrer-Policy");
    if (!n)
      return "";
    const r = n.split(/[,\s]+/);
    let i = "";
    for (const s of r)
      s && l$e.includes(s) && (i = s);
    return i;
  }
  /**
   * Returns the request referrer to be used as the value for the "Referer" header.
   *
   * Based on:
   * https://github.com/node-fetch/node-fetch/blob/main/src/utils/referrer.js (MIT)
   *
   * @see https://w3c.github.io/webappsec-referrer-policy/#determine-requests-referrer
   * @param originURL Origin URL.
   * @param request Request.
   * @returns Request referrer.
   */
  static getSentReferrer(e, n) {
    if (n.referrer === "about:client" && e.origin === "null")
      return "no-referrer";
    const r = new vi(n.url), i = n.referrer === "about:client" ? new vi(e.href) : new vi(n.referrer);
    if (u$e.test(i.protocol))
      return "no-referrer";
    switch (i.username = "", i.password = "", i.hash = "", n.referrerPolicy) {
      case "no-referrer":
        return "no-referrer";
      case "origin":
        return new vi(i.origin);
      case "unsafe-url":
        return i;
      case "strict-origin":
        return this.isURLPotentiallyTrustWorthy(i) && !this.isURLPotentiallyTrustWorthy(r) ? "no-referrer" : new vi(i.origin);
      case "strict-origin-when-cross-origin":
        return i.origin === r.origin ? i : this.isURLPotentiallyTrustWorthy(i) && !this.isURLPotentiallyTrustWorthy(r) ? "no-referrer" : new vi(i.origin);
      case "same-origin":
        return i.origin === r.origin ? i : "no-referrer";
      case "origin-when-cross-origin":
        return i.origin === r.origin ? i : new vi(i.origin);
      case "no-referrer-when-downgrade":
        return this.isURLPotentiallyTrustWorthy(i) && !this.isURLPotentiallyTrustWorthy(r) ? "no-referrer" : i;
    }
    return "no-referrer";
  }
  /**
   * Returns "true" if the request's referrer is potentially trustworthy.
   *
   * @see https://w3c.github.io/webappsec-secure-contexts/#is-origin-trustworthy
   * @param url URL.
   * @returns "true" if the request's referrer is potentially trustworthy.
   */
  static isURLPotentiallyTrustWorthy(e) {
    return /^about:(blank|srcdoc)$/.test(e.href) || e.protocol === "data:" || /^(blob|filesystem):$/.test(e.protocol) ? !0 : this.isOriginPotentiallyTrustWorthy(e);
  }
  /**
   * Returns "true" if the request's referrer origin is potentially trustworthy.
   *
   * @see https://w3c.github.io/webappsec-secure-contexts/#is-origin-trustworthy
   * @param url URL.
   * @returns "true" if the request's referrer origin is potentially trustworthy.
   */
  static isOriginPotentiallyTrustWorthy(e) {
    if (/^(http|ws)s:$/.test(e.protocol))
      return !0;
    const n = e.host.replace(/(^\[)|(]$)/g, ""), r = zQ(n);
    return r === 4 && /^127\./.test(n) || r === 6 && /^(((0+:){7})|(::(0+:){0,6}))0*1$/.test(n) ? !0 : e.host === "localhost" || e.host.endsWith(".localhost") ? !1 : e.protocol === "file:";
  }
}
class tW {
  /**
   * Returns a Buffer instance from the given data URI `uri`.
   *
   * @param uri Data URI.
   * @returns Buffer.
   */
  static parse(e) {
    if (!/^data:/i.test(e))
      throw new TypeError('`uri` does not appear to be a Data URI (must begin with "data:")');
    e = e.replace(/\r?\n/g, "");
    const n = e.indexOf(",");
    if (n === -1 || n <= 4)
      throw new TypeError("malformed data: URI");
    const r = e.substring(5, n).split(";");
    let i = "", s = !1, a = r[0] || "text/plain";
    for (let h = 1; h < r.length; h++)
      r[h] === "base64" ? s = !0 : r[h] && (a += `;${r[h]}`, r[h].indexOf("charset=") === 0 && (i = r[h].substring(8)));
    !r[0] && !i.length && (a += ";charset=US-ASCII", i = "US-ASCII");
    const o = s ? "base64" : "ascii", u = unescape(e.substring(n + 1)), l = Buffer.from(u, o);
    return {
      type: a,
      charset: i,
      buffer: l
    };
  }
}
class vf {
  /**
   * Validates request headers.
   *
   * @param originURL Origin URL.
   * @param targetURL Target URL.
   */
  static isCORS(e, n) {
    return e = typeof e == "string" ? new Pr(e) : e, n = typeof n == "string" ? new Pr(n) : n, n.protocol === "about:" || n.protocol === "javascript:" ? !1 : e.hostname !== n.hostname && !e.hostname.endsWith(n.hostname) || e.protocol !== n.protocol;
  }
}
var va;
(function(t) {
  t[t.boundary = 0] = "boundary", t[t.headerStart = 2] = "headerStart", t[t.header = 3] = "header", t[t.data = 5] = "data";
})(va || (va = {}));
const yy = {
  lf: 10,
  cr: 13
};
class c$e {
  formData;
  boundary;
  boundaryIndex = 0;
  state = va.boundary;
  data = {
    contentDisposition: null,
    value: [],
    contentType: null,
    header: ""
  };
  /**
   * Constructor.
   *
   * @param window Window.
   * @param formData Form data.
   * @param boundary Boundary.
   */
  constructor(e, n) {
    const r = `--${n}`;
    this.boundary = new Uint8Array(r.length), this.formData = new e.FormData();
    for (let i = 0, s = r.length; i < s; i++)
      this.boundary[i] = r.charCodeAt(i);
  }
  /**
   * Appends data.
   *
   * @param data Data.
   */
  write(e) {
    let n, r;
    for (let i = 0, s = e.length; i < s; i++)
      switch (n = e[i], r = e[i + 1], this.state) {
        case va.boundary:
          n === this.boundary[this.boundaryIndex] ? this.boundaryIndex++ : this.boundaryIndex = 0, this.boundaryIndex === this.boundary.length && (this.state = va.headerStart, this.boundaryIndex = 0);
          break;
        case va.headerStart:
          r !== yy.cr && r !== yy.lf && (this.data.header = "", this.state = e[i - 2] === yy.lf ? va.data : va.header);
          break;
        case va.header:
          if (n === yy.cr) {
            if (this.data.header) {
              const a = this.data.header.split(":");
              if (a.length > 1) {
                const o = a[0].toLowerCase(), u = a[1].trim();
                switch (o) {
                  case "content-disposition":
                    this.data.contentDisposition = this.getContentDisposition(u);
                    break;
                  case "content-type":
                    this.data.contentType = u;
                    break;
                }
              }
            }
            this.state = va.headerStart;
          } else
            this.data.header += String.fromCharCode(n);
          break;
        case va.data:
          n === this.boundary[this.boundaryIndex] ? this.boundaryIndex++ : this.boundaryIndex = 0, this.boundaryIndex === this.boundary.length ? (this.state = va.headerStart, this.data.value.length && (this.appendFormData(this.data.contentDisposition.name, Buffer.from(this.data.value.slice(0, -(this.boundary.length + 1))), this.data.contentDisposition.filename, this.data.contentType), this.data.value = [], this.data.contentDisposition = null, this.data.contentType = null), this.boundaryIndex = 0) : this.data.value.push(n);
          break;
      }
  }
  /**
   * Ends the stream.
   *
   * @returns Form data.
   */
  end() {
    return this.data.contentDisposition && this.data.value.length && this.appendFormData(this.data.contentDisposition.name, Buffer.from(this.data.value.slice(0, -2)), this.data.contentDisposition.filename, this.data.contentType), this.formData;
  }
  /**
   * Appends data.
   *
   * @param key Key.
   * @param value value.
   * @param filename Filename.
   * @param type Type.
   */
  appendFormData(e, n, r, i) {
    n.length && (r ? this.formData.append(e, new mh([n], r, {
      type: i
    })) : this.formData.append(e, n.toString()));
  }
  /**
   * Returns content disposition.
   *
   * @param headerValue Header value.
   * @returns Content disposition.
   */
  getContentDisposition(e) {
    const n = /([a-z]+) *= *"([^"]+)"/g, r = {};
    let i;
    for (; i = n.exec(e); )
      r[i[1]] = i[2];
    return r;
  }
}
class G2 {
  /**
   * Returns form data.
   *
   * @param window Window.
   * @param response Response object containing a body stream.
   * @param response.body Body stream.
   * @param requestOrResponse
   * @param requestOrResponse.body
   * @param contentType Content type header value.
   * @returns Form data.
   */
  static async streamToFormData(e, n, r) {
    if (!/multipart/i.test(r))
      throw new e.DOMException(`Failed to build FormData object: The "content-type" header isn't of type "multipart/form-data".`, ne.invalidStateError);
    const i = n.body;
    if (!i)
      throw new e.DOMException("Failed to build FormData object: The response body is null.", ne.invalidStateError);
    const s = r.match(/boundary=(?:"([^"]+)"|([^;]+))/i);
    if (!s)
      throw new e.DOMException(`Failed to build FormData object: The "content-type" header doesn't contain any multipart boundary.`, ne.invalidStateError);
    const a = i.getReader(), o = new c$e(e, s[1] || s[2]), u = [];
    let l;
    const h = 0;
    let f = await a.read();
    for (; !f.done; ) {
      if (n[Zi])
        throw n[Zi];
      if (n[xr])
        throw new e.DOMException("Failed to read response body: The stream was aborted.", ne.abortError);
      o.write(f.value), f = await a.read();
    }
    try {
      l = typeof u[0] == "string" ? nr.from(u.join("")) : nr.concat(u, h);
    } catch (m) {
      throw new e.DOMException(`Could not create Buffer from response body. Error: ${m.message}.`, ne.invalidStateError);
    }
    return {
      formData: o.end(),
      buffer: l
    };
  }
  /**
   * Converts a FormData object to a ReadableStream.
   *
   * @param formData FormData.
   * @returns Stream and type.
   */
  static formDataToStream(e) {
    const n = "----HappyDOMFormDataBoundary" + Math.random().toString(36), r = [], i = `--${n}\r
Content-Disposition: form-data; name="`;
    for (const [a, o] of e)
      typeof o == "string" ? r.push(nr.from(`${i}${this.escapeName(a)}"\r
\r
${o.replace(new RegExp("\\r(?!\\n)|(?<!\\r)\\n", "g"), `\r
`)}\r
`)) : (r.push(nr.from(`${i}${this.escapeName(a)}"; filename="${this.escapeName(o.name, !0)}"\r
Content-Type: ${o.type || "application/octet-stream"}\r
\r
`)), r.push(o[En]), r.push(nr.from(`\r
`)));
    r.push(nr.from(`--${n}--\r
`));
    const s = nr.concat(r);
    return {
      contentType: `multipart/form-data; boundary=${n}`,
      contentLength: s.length,
      buffer: s,
      stream: new sh({
        start(a) {
          a.enqueue(s), a.close();
        }
      })
    };
  }
  /**
   * Escapes a form data entry name.
   *
   * @param name Name.
   * @param filename Whether it is a filename.
   * @returns Escaped name.
   */
  static escapeName(e, n = !1) {
    return (n ? e : e.replace(/\r?\n|\r/g, `\r
`)).replace(/\n/g, "%0A").replace(/\r/g, "%0D").replace(/"/g, "%22");
  }
}
let nW = class {
  #e = [];
  /**
   * Constructor.
   *
   * @param [form] Form.
   * @param [submitter] The element that triggered the submission if this came from a form submit.
   */
  constructor(e, n) {
    if (!e)
      return;
    if (n) {
      const i = e[yn] ? e[yn] : e;
      if (n.form !== i)
        throw new this[b].DOMException("The specified element is not owned by this form element", ne.notFoundError);
      if (!(n[Xe] === "INPUT" && (n.type === "submit" || n.type === "image") || n[Xe] === "BUTTON" && n.type === "submit"))
        throw new this[b].TypeError("The specified element is not a submit button");
    }
    const r = e[Fa]();
    for (const i of r) {
      const s = i.name;
      if (s)
        switch (i[Xe]) {
          case "INPUT":
            if (i.disabled)
              break;
            switch (i.type) {
              case "file":
                if (i[jo].length === 0)
                  this.append(s, new mh([], "", { type: "application/octet-stream" }));
                else
                  for (const a of i[jo])
                    this.append(s, a);
                break;
              case "checkbox":
              case "radio":
                i.checked && this.append(s, i.value);
                break;
              case "submit":
              case "reset":
              case "button":
                i === n && i.value && this.append(s, i.value);
                break;
              default:
                this.append(s, i.value);
                break;
            }
            break;
          case "BUTTON":
            i === n && i.value && this.append(s, i.value);
            break;
          case "TEXTAREA":
          case "SELECT":
            this.append(s, i.value);
            break;
        }
    }
  }
  /**
   * For each.
   *
   * @param callback Callback.
   * @param thisArg thisArg.
   */
  forEach(e, n) {
    for (const r of this.#e)
      e.call(n, r.value, r.name, this);
  }
  /**
   * Appends a new value onto an existing key.
   *
   * @param name Name.
   * @param value Value.
   * @param [filename] Filename.
   */
  append(e, n, r) {
    if (r && !(n instanceof Di))
      throw new this[b].TypeError('Failed to execute "append" on "FormData": parameter 2 is not of type "Blob".');
    this.#e.push({
      name: e,
      value: this.#t(n, r)
    });
  }
  /**
   * Removes a value.
   *
   * @param name Name.
   */
  delete(e) {
    const n = [];
    for (const r of this.#e)
      r.name !== e && n.push(r);
    this.#e = n;
  }
  /**
   * Returns value.
   *
   * @param name Name.
   * @returns Value.
   */
  get(e) {
    for (const n of this.#e)
      if (n.name === e)
        return n.value;
    return null;
  }
  /**
   * Returns all values associated with the given name.
   *
   * @param name Name.
   * @returns Values.
   */
  getAll(e) {
    const n = [];
    for (const r of this.#e)
      r.name === e && n.push(r.value);
    return n;
  }
  /**
   * Returns whether a FormData object contains a certain key.
   *
   * @param name Name.
   * @returns "true" if the FormData object contains the key.
   */
  has(e) {
    for (const n of this.#e)
      if (n.name === e)
        return !0;
    return !1;
  }
  /**
   * Sets a new value for an existing key inside a FormData object, or adds the key/value if it does not already exist.
   *
   * @param name Name.
   * @param value Value.
   * @param [filename] Filename.
   */
  set(e, n, r) {
    for (const i of this.#e)
      if (i.name === e) {
        i.value = this.#t(n, r);
        return;
      }
    this.append(e, n);
  }
  /**
   * Returns an iterator, allowing you to go through all keys of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  *keys() {
    for (const e of this.#e)
      yield e.name;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  *values() {
    for (const e of this.#e)
      yield e.value;
  }
  /**
   * Returns an iterator, allowing you to go through all key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  *entries() {
    for (const e of this.#e)
      yield [e.name, e.value];
  }
  /**
   * Iterator.
   *
   * @returns Iterator.
   */
  *[Symbol.iterator]() {
    for (const e of this.#e)
      yield [e.name, e.value];
  }
  /**
   * Parses a value.
   *
   * @param value Value.
   * @param [filename] Filename.
   * @returns Parsed value.
   */
  #t(e, n) {
    if (e instanceof mh) {
      if (n) {
        const r = new mh([], n, { type: e.type, lastModified: e.lastModified });
        return r[En] = e[En], r;
      }
      return e;
    }
    if (e instanceof Di) {
      const r = new mh([], "blob", { type: e.type });
      return r[En] = e[En], r;
    }
    return String(e);
  }
};
class es {
  /**
   * Parses body and returns stream and type.
   *
   * Based on:
   * https://github.com/node-fetch/node-fetch/blob/main/src/body.js (MIT)
   *
   * @param body Body.
   * @returns Stream and type.
   */
  static getBodyStream(e) {
    if (e == null)
      return { stream: null, buffer: null, contentType: null, contentLength: null };
    if (e instanceof xx) {
      const r = nr.from(e.toString());
      return {
        buffer: r,
        stream: this.toReadableStream(r),
        contentType: "application/x-www-form-urlencoded;charset=UTF-8",
        contentLength: r.length
      };
    } else if (e instanceof Di) {
      const r = e[En];
      return {
        buffer: r,
        stream: this.toReadableStream(r),
        contentType: e.type,
        contentLength: e.size
      };
    } else {
      if (nr.isBuffer(e))
        return {
          buffer: e,
          stream: this.toReadableStream(e),
          contentType: null,
          contentLength: e.length
        };
      if (e instanceof ArrayBuffer) {
        const r = nr.from(e);
        return {
          buffer: r,
          stream: this.toReadableStream(r),
          contentType: null,
          contentLength: e.byteLength
        };
      } else if (ArrayBuffer.isView(e)) {
        const r = nr.from(e.buffer, e.byteOffset, e.byteLength);
        return {
          buffer: r,
          stream: this.toReadableStream(r),
          contentType: null,
          contentLength: e.byteLength
        };
      } else {
        if (e instanceof sh)
          return {
            buffer: null,
            stream: e,
            contentType: null,
            contentLength: null
          };
        if (e instanceof nW)
          return G2.formDataToStream(e);
      }
    }
    const n = nr.from(String(e));
    return {
      buffer: n,
      stream: this.toReadableStream(n),
      contentType: "text/plain;charset=UTF-8",
      contentLength: n.length
    };
  }
  /**
   * Clones a request or body body stream.
   *
   * It is actually not cloning the stream.
   * It creates a pass through stream and pipes the original stream to it.
   *
   * @param window Window.
   * @param requestOrResponse Request or Response.
   * @param requestOrResponse.body Body.
   * @param requestOrResponse.bodyUsed Body used.
   * @returns New stream.
   */
  static cloneBodyStream(e, n) {
    if (n.bodyUsed)
      throw new e.DOMException("Failed to clone body stream of request: Request body is already used.", ne.invalidStateError);
    if (n.body === null || n.body === void 0)
      return null;
    if (n[En])
      return this.toReadableStream(n[En]);
    if (n.body[Q0]) {
      const s = new Ti.PassThrough(), a = new Ti.PassThrough();
      n.body[Q0].pipe(s), n.body[Q0].pipe(a);
      const o = this.nodeToWebStream(s);
      return fh in n ? n[fh] = o : n.body = o, this.nodeToWebStream(a);
    }
    const [r, i] = n.body.tee();
    return fh in n ? n[fh] = r : n.body = r, i;
  }
  /**
   * Consume and convert an entire Body to a Buffer.
   *
   * Based on:
   * https://github.com/node-fetch/node-fetch/blob/main/src/body.js (MIT)
   *
   * @see https://fetch.spec.whatwg.org/#concept-body-consume-body
   * @param window Window.
   * @param requestOrResponse
   * @param requestOrResponse.body
   * @param body Body stream.
   * @returns Promise.
   */
  static async consumeBodyStream(e, n) {
    const r = n.body;
    if (r === null || !(r instanceof sh))
      return nr.alloc(0);
    if (n[Zi])
      throw n[Zi];
    const i = r.getReader(), s = [];
    let a = 0;
    try {
      let o = await i.read();
      for (; !o.done; ) {
        if (n[Zi])
          throw n[Zi];
        if (n[xr])
          throw new e.DOMException("Failed to read response body: The stream was aborted.", ne.abortError);
        const u = o.value;
        a += u.length, s.push(u), o = await i.read();
      }
    } catch (o) {
      throw o instanceof Tr ? o : new e.DOMException(`Failed to read response body. Error: ${o.message}.`, ne.encodingError);
    }
    try {
      return typeof s[0] == "string" ? nr.from(s.join("")) : nr.concat(s, a);
    } catch (o) {
      throw new e.DOMException(`Could not create Buffer from response body. Error: ${o.message}.`, ne.invalidStateError);
    }
  }
  /**
   * Wraps a given value in a browser ReadableStream.
   *
   * This method creates a ReadableStream and immediately enqueues and closes it
   * with the provided value, useful for stream API compatibility.
   *
   * @param value The value to be wrapped in a ReadableStream.
   * @returns ReadableStream
   */
  static toReadableStream(e) {
    return new sh({
      start(n) {
        n.enqueue(e), n.close();
      }
    });
  }
  /**
   * Wraps a Node.js stream into a browser-compatible ReadableStream.
   *
   * Enables the use of Node.js streams where browser ReadableStreams are required.
   * Handles 'data', 'end', and 'error' events from the Node.js stream.
   *
   * @param nodeStream The Node.js stream to be converted.
   * @returns ReadableStream
   */
  static nodeToWebStream(e) {
    const n = new sh({
      start(r) {
        e.on("data", (i) => {
          r.enqueue(i);
        }), e.on("end", () => {
          r.close();
        }), e.on("error", (i) => {
          r.error(i);
        });
      }
    });
    return n[Q0] = e, n;
  }
}
const h$e = [
  "",
  "no-referrer",
  "no-referrer-when-downgrade",
  "same-origin",
  "origin",
  "strict-origin",
  "origin-when-cross-origin",
  "strict-origin-when-cross-origin",
  "unsafe-url"
], d$e = ["error", "manual", "follow"], f$e = ["data:", "http:", "https:"], m$e = ["TRACE", "TRACK", "CONNECT"], g$e = /^[A-Z]+$/;
class th {
  /**
   * Validates request method.
   *
   * @throws DOMException
   * @param request Request.
   */
  static validateMethod(e) {
    if (!e.method || m$e.includes(e.method))
      throw new Tr(`'${e.method || ""}' is not a valid HTTP method.`, ne.invalidStateError);
    if (!g$e.test(e.method))
      throw new Tr(`'${e.method}' HTTP method is unsupported.`, ne.invalidStateError);
  }
  /**
   * Validates request body.
   *
   * @throws DOMException
   * @param request Request.
   */
  static validateBody(e) {
    if (e.body && (e.method === "GET" || e.method === "HEAD"))
      throw new Tr("Request with GET/HEAD method cannot have body.", ne.invalidStateError);
  }
  /**
   * Validates request URL.
   *
   * @throws DOMException
   * @param url URL.
   */
  static validateURL(e) {
    if (e.username !== "" || e.password !== "")
      throw new Tr(`${e} is an url with embedded credentials.`, ne.notSupportedError);
  }
  /**
   * Validates request referrer policy.
   *
   * @throws DOMException
   * @param referrerPolicy Referrer policy.
   */
  static validateReferrerPolicy(e) {
    if (!h$e.includes(e))
      throw new Tr(`Invalid referrer policy "${e}".`, ne.syntaxError);
  }
  /**
   * Validates request redirect.
   *
   * @throws DOMException
   * @param redirect Redirect.
   */
  static validateRedirect(e) {
    if (!d$e.includes(e))
      throw new Tr(`Invalid redirect "${e}".`, ne.syntaxError);
  }
  /**
   * Validates request redirect.
   *
   * @throws DOMException
   * @param request
   * @param redirect Redirect.
   */
  static validateSchema(e) {
    if (!f$e.includes(e[Ir].protocol))
      throw new Tr(`Failed to fetch from "${e.url}": URL scheme "${e[Ir].protocol.replace(/:$/, "")}" is not supported.`, ne.notSupportedError);
  }
}
class xf {
  /**
   * Returns cookie.
   *
   * @param originURL Origin URL.
   * @param cookieString Cookie string.
   * @returns Cookie.
   */
  static stringToCookie(e, n) {
    const r = n.split(";"), i = r.shift();
    if (!i)
      return null;
    const s = i.indexOf("="), a = s !== -1 ? i.slice(0, s).trim() : i.trim(), o = s !== -1 ? i.slice(s + 1).trim() : null, u = Object.assign({}, O7, {
      // Required
      key: a,
      value: o,
      originURL: e
    });
    if (!u.key)
      return null;
    for (const h of r) {
      const f = h.indexOf("="), m = f !== -1 ? h.slice(0, f).trim().toLowerCase() : h.trim().toLowerCase(), g = f !== -1 ? h.slice(f + 1).trim() : "";
      switch (m) {
        case "expires":
          u.expires = new Date(g);
          break;
        case "max-age":
          u.expires = new Date(parseInt(g, 10) * 1e3 + Date.now());
          break;
        case "domain":
          u.domain = g;
          break;
        case "path":
          u.path = g[0] === "/" ? g : `/${g}`;
          break;
        case "httponly":
          u.httpOnly = !0;
          break;
        case "secure":
          u.secure = !0;
          break;
        case "samesite":
          switch (g.toLowerCase()) {
            case "strict":
              u.sameSite = pg.strict;
              break;
            case "lax":
              u.sameSite = pg.lax;
              break;
            case "none":
              u.sameSite = pg.none;
          }
          break;
      }
    }
    const l = u.key.toLowerCase();
    return l.startsWith("__secure-") && !u.secure || l.startsWith("__host-") && (!u.secure || u.path !== "/" || u.domain) ? null : u;
  }
  /**
   * Returns cookie string with key and value.
   *
   * @param cookies Cookies.
   * @returns Cookie string.
   */
  static cookiesToString(e) {
    const n = [];
    for (const r of e)
      r.value !== null ? n.push(`${r.key}=${r.value}`) : n.push(r.key);
    return n.join("; ");
  }
}
const KL = [
  "accept-charset",
  "accept-encoding",
  "access-control-request-headers",
  "access-control-request-method",
  "connection",
  "content-length",
  "content-transfer-encoding",
  "cookie",
  "cookie2",
  "date",
  "dnt",
  "expect",
  "host",
  "keep-alive",
  "origin",
  "referer",
  "te",
  "trailer",
  "transfer-encoding",
  "upgrade",
  "via"
];
class VA {
  /**
   * Validates request headers.
   *
   * @param headers Headers.
   */
  static removeForbiddenHeaders(e) {
    for (const n of Object.keys(e[ui]))
      (KL.includes(n) || n.startsWith("proxy-") || n.startsWith("sec-")) && delete e[ui][n];
  }
  /**
   * Returns "true" if the header is forbidden.
   *
   * @param name Header name.
   * @returns "true" if the header is forbidden.
   */
  static isHeaderForbidden(e) {
    return KL.includes(e.toLowerCase());
  }
  /**
   * Returns request headers.
   *
   * @param options Options.
   * @param options.browserFrame Browser frame.
   * @param options.window Window.
   * @param options.request Request.
   * @param [options.baseHeaders] Any base headers (may be overwritten by browser/window headers).
   * @returns Headers.
   */
  static getRequestHeaders(e) {
    const n = new e.window.Headers(e.baseHeaders);
    e.request.headers.forEach((a, o) => {
      n.set(o, a);
    });
    const r = new Pr(e.window.location.href), i = vf.isCORS(r, e.request[Ir]);
    if (n.set("Accept-Encoding", "gzip, deflate, br"), n.set("Connection", "close"), n.has("User-Agent") || n.set("User-Agent", e.window.navigator.userAgent), e.request[ra] instanceof Pr && n.set("Referer", e.request[ra].href), e.request.credentials === "include" || e.request.credentials === "same-origin" && !i) {
      const a = e.browserFrame.page.context.cookieContainer.getCookies(r, !1);
      a.length > 0 && n.set("Cookie", xf.cookiesToString(a));
    } else
      n.delete("Cookie"), n.delete("Cookie2");
    n.has("Accept") || n.set("Accept", "*/*"), !n.has("Content-Length") && e.request[lg] !== null && n.set("Content-Length", String(e.request[lg])), !n.has("Content-Type") && e.request[xi] && n.set("Content-Type", e.request[xi]), i && n.set("Origin", r.origin);
    const s = {};
    for (const a of Object.values(n[ui]))
      s[a.name] = a.value.join(", ");
    return s;
  }
}
let rW = class Km {
  // Public properties
  [dh];
  [fh];
  [Jr] = "cors";
  [kF];
  [PF];
  [Uy];
  [LF];
  [Wo] = !1;
  [MF];
  // Internal properties
  [xr] = !1;
  [Zi] = null;
  [lg] = null;
  [xi] = null;
  [ra] = "client";
  [Ir];
  [Ul];
  /**
   * Constructor.
   *
   * @param input Input.
   * @param [init] Init.
   */
  constructor(e, n) {
    const r = this[b];
    if (!r)
      throw new TypeError("Failed to construct 'Request': 'Request' was constructed outside a Window context.");
    if (typeof e != "string" && !e)
      throw new r.TypeError("Failed to contruct 'Request': 1 argument required, only 0 present.");
    if (this[dh] = (n?.method || e.method || "GET").toUpperCase(), n?.mode)
      switch (n.mode) {
        case "navigate":
        case "websocket":
          throw new r.DOMException(`Failed to construct 'Request': Cannot construct a Request with a RequestInit whose mode member is set as '${n.mode}'.`, ne.securityError);
        case "same-origin":
        case "no-cors":
        case "cors":
          this[Jr] = n.mode;
          break;
        default:
          throw new r.DOMException(`Failed to construct 'Request': The provided value '${n.mode}' is not a valid enum value of type RequestMode.`, ne.syntaxError);
      }
    else e instanceof Km && (this[Jr] = e.mode);
    const { stream: i, buffer: s, contentType: a, contentLength: o } = es.getBodyStream(e instanceof Km && (e[Ul] || e.body) ? e[Ul] || es.cloneBodyStream(r, e) : n?.body ?? null);
    if (this[Ul] = s, this[fh] = i, this[MF] = n?.credentials || e.credentials || "same-origin", this[kF] = new this[b].Headers(n?.headers || e.headers || {}), VA.removeForbiddenHeaders(this.headers), o ? this[lg] = o : !this.body && (this.method === "POST" || this.method === "PUT") && (this[lg] = 0), a ? (this.headers.has("Content-Type") || this.headers.set("Content-Type", a), this[xi] = a) : e instanceof Km && e[xi] && (this[xi] = e[xi]), this[PF] = n?.redirect || e.redirect || "follow", this[Uy] = (n?.referrerPolicy || e.referrerPolicy || "").toLowerCase(), this[LF] = n?.signal || e.signal || new r.AbortSignal(), this[ra] = Ug.getInitialReferrer(r, n?.referrer !== null && n?.referrer !== void 0 ? n?.referrer : e.referrer), e instanceof Pr)
      this[Ir] = e;
    else
      try {
        e instanceof Km && e.url ? this[Ir] = new Pr(e.url, r.location.href) : this[Ir] = new Pr(e, r.location.href);
      } catch {
        throw new r.DOMException(`Failed to construct 'Request': Invalid URL "${e}" on document location '${r.location}'.${r.location.origin === "null" ? " Relative URLs are not permitted on current document location." : ""}`, ne.notSupportedError);
      }
    th.validateMethod(this), th.validateBody(this), th.validateURL(this[Ir]), th.validateReferrerPolicy(this.referrerPolicy), th.validateRedirect(this.redirect);
  }
  /**
   * Returns method.
   *
   * @returns Method.
   */
  get method() {
    return this[dh];
  }
  /**
   * Returns body.
   *
   * @returns Body.
   */
  get body() {
    return this[fh];
  }
  /**
   * Returns mode.
   *
   * @returns Mode.
   */
  get mode() {
    return this[Jr];
  }
  /**
   * Returns headers.
   *
   * @returns Headers.
   */
  get headers() {
    return this[kF];
  }
  /**
   * Returns redirect.
   *
   * @returns Redirect.
   */
  get redirect() {
    return this[PF];
  }
  /**
   * Returns referrer policy.
   *
   * @returns Referrer policy.
   */
  get referrerPolicy() {
    return this[Uy];
  }
  /**
   * Returns signal.
   *
   * @returns Signal.
   */
  get signal() {
    return this[LF];
  }
  /**
   * Returns body used.
   *
   * @returns Body used.
   */
  get bodyUsed() {
    return this[Wo];
  }
  /**
   * Returns credentials.
   *
   * @returns Credentials.
   */
  get credentials() {
    return this[MF];
  }
  /**
   * Returns referrer.
   *
   * @returns Referrer.
   */
  get referrer() {
    return !this[ra] || this[ra] === "no-referrer" ? "" : this[ra] === "client" ? "about:client" : this[ra].toString();
  }
  /**
   * Returns URL.
   *
   * @returns URL.
   */
  get url() {
    return this[Ir].href;
  }
  /**
   * Returns string tag.
   *
   * @returns String tag.
   */
  get [Symbol.toStringTag]() {
    return "Request";
  }
  /**
   * Returns array buffer.
   *
   * @returns Array buffer.
   */
  async arrayBuffer() {
    const e = this[b];
    if (this[Wo])
      throw new e.DOMException(`Body has already been used for "${this.url}".`, ne.invalidStateError);
    const n = new pt(e).getAsyncTaskManager();
    this[Wo] = !0;
    const r = n.startTask(() => {
      this[xr] = !0, this.signal[Hl]();
    });
    let i;
    try {
      i = await es.consumeBodyStream(e, this);
    } catch (s) {
      throw n.endTask(r), s;
    }
    return n.endTask(r), i.buffer.slice(i.byteOffset, i.byteOffset + i.byteLength);
  }
  /**
   * Returns blob.
   *
   * @returns Blob.
   */
  async blob() {
    const e = this.headers.get("Content-Type") || "", n = await this.arrayBuffer();
    return new Di([n], { type: e });
  }
  /**
   * Returns buffer.
   *
   * @returns Buffer.
   */
  async buffer() {
    const e = this[b];
    if (this[Wo])
      throw new e.DOMException(`Body has already been used for "${this.url}".`, ne.invalidStateError);
    const n = new pt(e).getAsyncTaskManager();
    this[Wo] = !0;
    const r = n.startTask(() => {
      this[xr] = !0, this.signal[Hl]();
    });
    let i;
    try {
      i = await es.consumeBodyStream(e, this);
    } catch (s) {
      throw n.endTask(r), s;
    }
    return n.endTask(r), i;
  }
  /**
   * Returns text.
   *
   * @returns Text.
   */
  async text() {
    const e = this[b];
    if (this[Wo])
      throw new e.DOMException(`Body has already been used for "${this.url}".`, ne.invalidStateError);
    const n = new pt(e).getAsyncTaskManager();
    this[Wo] = !0;
    const r = n.startTask(() => {
      this[xr] = !0, this.signal[Hl]();
    });
    let i;
    try {
      i = await es.consumeBodyStream(e, this);
    } catch (s) {
      throw n.endTask(r), s;
    }
    return n.endTask(r), new TextDecoder().decode(i);
  }
  /**
   * Returns json.
   *
   * @returns JSON.
   */
  async json() {
    const e = await this.text();
    return JSON.parse(e);
  }
  /**
   * Returns FormData.
   *
   * @returns FormData.
   */
  async formData() {
    const e = this[b], n = new pt(e).getAsyncTaskManager(), r = this[xi];
    if (this.body && r && /multipart/i.test(r)) {
      if (this[Wo])
        throw new e.DOMException(`Body has already been used for "${this.url}".`, ne.invalidStateError);
      this[Wo] = !0;
      const i = n.startTask(() => {
        this[xr] = !0, this.signal[Hl]();
      });
      let s;
      try {
        s = (await G2.streamToFormData(e, this, r)).formData;
      } catch (a) {
        throw n.endTask(i), a;
      }
      return n.endTask(i), s;
    }
    if (r?.startsWith("application/x-www-form-urlencoded")) {
      const i = new URLSearchParams(await this.text()), s = new e.FormData();
      for (const [a, o] of i)
        s.append(a, o);
      return s;
    }
    throw new e.DOMException('Failed to construct FormData object: The "content-type" header is neither "application/x-www-form-urlencoded" nor "multipart/form-data".', ne.invalidStateError);
  }
  /**
   * Clones request.
   *
   * @returns Clone.
   */
  clone() {
    return new this[b].Request(this);
  }
};
const p$e = [301, 302, 303, 307, 308];
let Lu = class {
  // Public properties
  body = null;
  bodyUsed = !1;
  redirected = !1;
  type = "basic";
  url = "";
  status;
  statusText;
  ok;
  headers;
  [Zo] = null;
  [En] = null;
  [wo] = null;
  [xr] = !1;
  [Zi] = null;
  /**
   * Constructor.
   *
   * @param body Body.
   * @param [init] Init.
   */
  constructor(e, n) {
    if (!this[b])
      throw new TypeError(`Failed to construct '${this.constructor.name}': '${this.constructor.name}' was constructed outside a Window context.`);
    if (this.status = n?.status !== void 0 ? n.status : 200, this.statusText = n?.statusText || "", this.ok = this.status >= 200 && this.status < 300, this.headers = new this[b].Headers(n?.headers), this.headers.delete("Set-Cookie"), this.headers.delete("Set-Cookie2"), e) {
      const { stream: r, buffer: i, contentType: s } = es.getBodyStream(e);
      this.body = r, i && (this[En] = i), s && !this.headers.has("Content-Type") && this.headers.set("Content-Type", s);
    }
  }
  /**
   * Returns string tag.
   *
   * @returns String tag.
   */
  get [Symbol.toStringTag]() {
    return "Response";
  }
  /**
   * Returns array buffer.
   *
   * @returns Array buffer.
   */
  async arrayBuffer() {
    const e = this[b];
    if (this.bodyUsed)
      throw new e.DOMException(`Body has already been used for "${this.url}".`, ne.invalidStateError);
    const n = new pt(e).getBrowserFrame();
    if (!n)
      return new ArrayBuffer(0);
    const r = n[xt];
    this.bodyUsed = !0;
    let i = this[En];
    if (!i) {
      const s = r.startTask(() => {
        this[xr] = !0;
      });
      try {
        i = await es.consumeBodyStream(e, this);
      } catch (a) {
        throw r.endTask(s), a;
      }
      r.endTask(s);
    }
    return this.#e(i), i.buffer.slice(i.byteOffset, i.byteOffset + i.byteLength);
  }
  /**
   * Returns blob.
   *
   * @returns Blob.
   */
  async blob() {
    const e = this.headers.get("Content-Type") || "", n = await this.arrayBuffer();
    return new Di([n], { type: e });
  }
  /**
   * Returns buffer.
   *
   * @returns Buffer.
   */
  async buffer() {
    const e = this[b];
    if (this.bodyUsed)
      throw new e.DOMException(`Body has already been used for "${this.url}".`, ne.invalidStateError);
    const n = new pt(e).getBrowserFrame();
    if (!n)
      return nr.alloc(0);
    const r = n[xt];
    this.bodyUsed = !0;
    let i = this[En];
    if (!i) {
      const s = r.startTask(() => {
        this[xr] = !0;
      });
      try {
        i = await es.consumeBodyStream(e, this);
      } catch (a) {
        throw r.endTask(s), a;
      }
      r.endTask(s);
    }
    return this.#e(i), i;
  }
  /**
   * Returns text.
   *
   * @returns Text.
   */
  async text() {
    const e = this[b];
    if (this.bodyUsed)
      throw new e.DOMException(`Body has already been used for "${this.url}".`, ne.invalidStateError);
    const n = new pt(e).getBrowserFrame();
    if (!n)
      return "";
    const r = n[xt];
    this.bodyUsed = !0;
    let i = this[En];
    if (!i) {
      const s = r.startTask(() => {
        this[xr] = !0;
      });
      try {
        i = await es.consumeBodyStream(e, this);
      } catch (a) {
        throw r.endTask(s), a;
      }
      r.endTask(s);
    }
    return this.#e(i), new TextDecoder().decode(i);
  }
  /**
   * Returns json.
   *
   * @returns JSON.
   */
  async json() {
    const e = await this.text();
    return JSON.parse(e);
  }
  /**
   * Returns form data.
   *
   * @returns Form data.
   */
  async formData() {
    const e = this[b], n = new pt(e).getBrowserFrame();
    if (!n)
      return new e.FormData();
    const r = n[xt], i = this.headers.get("Content-Type");
    if (i && this.body && /multipart/i.test(i)) {
      if (this.bodyUsed)
        throw new e.DOMException(`Body has already been used for "${this.url}".`, ne.invalidStateError);
      this.bodyUsed = !0;
      const s = n[xt].startTask(() => {
        this[xr] = !0;
      });
      let a, o;
      try {
        const u = await G2.streamToFormData(e, this, i);
        a = u.formData, o = u.buffer;
      } catch (u) {
        throw r.endTask(s), u;
      }
      return this.#e(o), r.endTask(s), a;
    }
    if (i?.startsWith("application/x-www-form-urlencoded")) {
      const s = new xx(await this.text()), a = new e.FormData();
      for (const [o, u] of s)
        a.append(o, u);
      return a;
    }
    throw new e.DOMException('Failed to build FormData object: The "content-type" header is neither "application/x-www-form-urlencoded" nor "multipart/form-data".', ne.invalidStateError);
  }
  /**
   * Clones request.
   *
   * @returns Clone.
   */
  clone() {
    const e = this[b], n = es.cloneBodyStream(e, this), r = new e.Response(n, {
      status: this.status,
      statusText: this.statusText,
      headers: this.headers
    });
    return r[Zo] = this[Zo], r[En] = this[En], r.ok = this.ok, r.redirected = this.redirected, r.type = this.type, r.url = this.url, r;
  }
  /**
   * Stores body in cache.
   *
   * @param buffer Buffer.
   */
  #e(e) {
    this[En] = e, this[Zo]?.response?.waitingForBody && (this[Zo].response.body = e, this[Zo].response.waitingForBody = !1);
  }
  /**
   * Returns a redirect response.
   *
   * @param url URL.
   * @param status Status code.
   * @returns Response.
   */
  static redirect(e, n = 302) {
    const r = this[b];
    if (!p$e.includes(n))
      throw new r.DOMException("Failed to create redirect response: Invalid redirect status code.", ne.invalidStateError);
    return new r.Response(null, {
      headers: {
        location: new vi(e).toString()
      },
      status: n
    });
  }
  /**
   * Returns an error response.
   *
   * @param url URL.
   * @param status Status code.
   * @returns Response.
   */
  static error() {
    const e = new this[b].Response(null, { status: 0, statusText: "" });
    return e.type = "error", e;
  }
  /**
   * Returns an JSON response.
   *
   * @param injected Injected properties.
   * @param data Data.
   * @param [init] Init.
   * @returns Response.
   */
  static json(e, n) {
    const r = this[b], i = JSON.stringify(e);
    if (i === void 0)
      throw new r.TypeError("data is not JSON serializable");
    const s = new r.Headers(n && n.headers);
    return s.has("Content-Type") || s.set("Content-Type", "application/json"), new r.Response(i, {
      status: 200,
      ...n,
      headers: s
    });
  }
};
const b$e = [301, 302, 303, 307, 308], y$e = 20;
class K1 {
  /**
   * Returns "true" if redirect.
   *
   * @param statusCode Status code.
   * @returns "true" if redirect.
   */
  static isRedirect(e) {
    return b$e.includes(e);
  }
  /**
   * Returns "true" if max redirects is reached.
   *
   * @param redirectCount Redirect count.
   * @returns "true" if max redirects is reached.
   */
  static isMaxRedirectsReached(e) {
    return e >= y$e;
  }
}
class iW {
  /**
   * Appends headers to response.
   *
   * @param nodeResponse HTTP request.
   * @param options
   * @param options.browserFrame
   * @param options.requestURL
   * @param options.rawHeaders
   * @returns Headers.
   */
  static parseResponseHeaders(e) {
    const n = new e.browserFrame.window.Headers();
    let r = null;
    for (const i of e.rawHeaders)
      if (!r)
        r = i;
      else {
        const s = r.toLowerCase();
        if (s === "set-cookie" || s === "set-cookie2") {
          const a = xf.stringToCookie(e.requestURL, i);
          a && e.browserFrame.page.context.cookieContainer.addCookies([a]);
        } else
          n.append(r, i);
        r = null;
      }
    return n;
  }
}
const z1 = {
  cert: `-----BEGIN CERTIFICATE-----
MIIDYzCCAkugAwIBAgIUJRKB/H66hpet1VfUlm0CiXqePA4wDQYJKoZIhvcNAQEL
BQAwQTELMAkGA1UEBhMCU0UxDjAMBgNVBAgMBVNrYW5lMQ4wDAYDVQQHDAVNYWxt
bzESMBAGA1UECgwJSGFwcHkgRE9NMB4XDTIyMTAxMTIyMDM0OVoXDTMyMTAwODIy
MDM0OVowQTELMAkGA1UEBhMCU0UxDjAMBgNVBAgMBVNrYW5lMQ4wDAYDVQQHDAVN
YWxtbzESMBAGA1UECgwJSGFwcHkgRE9NMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8A
MIIBCgKCAQEAqerQSQEg/SxVxRiwlItithr5e5EMZo1nsqt/xOxagbmpW3IEmt0j
bpbH7iEF4DDEo7KAOwUCOwVWeFxRoag8lG2ax48wrgjlCna45XDn0Xeg1ARajL04
gs46HZ0VrzIloVGfln0zgt/Vum5BNqs9Oc5fQoBmoP3cAn3dn4ZVcP0AKthtcyPl
q2DuNRN0PV0D2RtMSiAy9l1Ko6N5x+sAeClDyOL+sTDLngZBVeZyOKt9Id15S8Zt
XtA6VMgHnnF3jChn7pag77rsd/y5iANAVNZYqRl+Eg7xaDcsvbgH46UBOrBcB39Q
tTh5Mtjoxep5e3ZDFG+kQ1HUE+iz5O5n0wIDAQABo1MwUTAdBgNVHQ4EFgQU69s9
YSobG/m2SN4L/7zTaF7iDbwwHwYDVR0jBBgwFoAU69s9YSobG/m2SN4L/7zTaF7i
DbwwDwYDVR0TAQH/BAUwAwEB/zANBgkqhkiG9w0BAQsFAAOCAQEAi/WUXx2oal8L
YnPlIuKfh49n/K18wXSYG//oFYwxfVxqpYH8hUiXVm/GUcXCxS++hUkaKLqXmH9q
MKJiCrZr3vS+2nsBKopkICu/TLdROl0sAI9lByfnEbfSAzjxe1IWJdK8NdY0y5m5
9pEr/URVIAp/CxrneyASb4q0Jg5To3FR7vYc+2X6wZn0MundKMg6Dp9/A37jiF3l
Tt/EJp299YZcsUzh+LnRuggRjnoOVu1aLcLFlaUiwZfy9m8mLG6B/mdW/qNzNMh9
Oqvg1zfGdpz/4D/2UUUBn6pq1vbsoAaF3OesoA3mfDcegDf/H9woJlpT0Wql+e68
Y3FblSokcA==
-----END CERTIFICATE-----`,
  key: `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCp6tBJASD9LFXF
GLCUi2K2Gvl7kQxmjWeyq3/E7FqBualbcgSa3SNulsfuIQXgMMSjsoA7BQI7BVZ4
XFGhqDyUbZrHjzCuCOUKdrjlcOfRd6DUBFqMvTiCzjodnRWvMiWhUZ+WfTOC39W6
bkE2qz05zl9CgGag/dwCfd2fhlVw/QAq2G1zI+WrYO41E3Q9XQPZG0xKIDL2XUqj
o3nH6wB4KUPI4v6xMMueBkFV5nI4q30h3XlLxm1e0DpUyAeecXeMKGfulqDvuux3
/LmIA0BU1lipGX4SDvFoNyy9uAfjpQE6sFwHf1C1OHky2OjF6nl7dkMUb6RDUdQT
6LPk7mfTAgMBAAECggEAKkwTkTjAt4UjzK56tl+EMQTB+ep/hb/JgoaChci4Nva6
m9LkJpDJ0yuhlTuPNOGu8XjrxsVWas7HWarRf0Zb3i7yip6wZYI9Ub+AA015x4DZ
/i0fRU2NFbK0cM67qSL4jxG8gj+kZP3HPGNZxHwX/53JxMolwgmvjMc8NgvAlSFd
NnV9h4xtbhUh1NGS5zmP3iU2rwnE8JrIEzwy6axLom7nekAgkdcbAr0UoBs8gcgH
aYNhU4Gz3tGcZZ0IXAfT/bJIH1Ko8AGv4pssWc3BXcmmNdm/+kzvHIxEIV7Qegmo
XG1ZyZCyD/0b4/3e8ySDBEDqwR+HeyTW2isWG2agAQKBgQDp44aTwr3dkIXY30xv
FPfUOipg/B49dWnffYJ9MWc1FT9ijNPAngWSk0EIiEQIazICcUBI4Yji6/KeyqLJ
GdLpDi1CkKqtyh73mjELinYp3EUQgEa77aQogGa2+nMOVfu+O5CtloUrv/A18jX3
+VEyaEASK0fWmnSI0OdlxQHIAQKBgQC5+xOls2F3MlKASvWRLlnW1wHqlDTtVoYg
5Nh8syZH4Ci2UH8tON3A5/7SWNM0t1cgV6Cw4zW8Z2spgIT/W0iYYrQ4hHL1xdCu
+CxL1km4Gy8Uwpsd+KdFahFqF/XTmLzW0HXLxWSK0fTwmdV0SFrKF3MXfTCU2AeZ
jJoMFb6P0wKBgQC3Odw6s0vkYAzLGhuZxfZkVvDOK5RRF0NKpttr0iEFL9EJFkPo
2KKK8jr3QTDy229BBJGUxsJi6u6VwS8HlehpVQbV59kd7oKV/EBBx0XMg1fDlopT
PNbmN7i/zbIG4AsoOyebJZjL7kBzMn1e9vzKHWtcEHXlw/hZGja8vjooAQKBgAeg
xK2HLfg1mCyq5meN/yFQsENu0LzrT5UJzddPgcJw7zqLEqxIKNBAs7Ls8by3yFsL
PQwERa/0jfCl1M6kb9XQNpQa2pw6ANUsWKTDpUJn2wZ+9N3F1RaDwzMWyH5lRVmK
M0qoTfdjpSg5Jwgd75taWt4bxGJWeflSSv8z5R0BAoGAWL8c527AbeBvx2tOYKkD
2TFranvANNcoMrbeviZSkkGvMNDP3p8b6juJwXOIeWNr8q4vFgCzLmq6d1/9gYm2
3XJwwyD0LKlqzkBrrKU47qrnmMosUrIRlrAzd3HbShOptxc6Iz2apSaUDKGKXkaw
gl5OpEjeliU7Mus0BVS858g=
-----END PRIVATE KEY-----`
}, zL = "<html><head><title>Happy DOM Virtual Server - 404 Not Found</title></head><body><h1>Happy DOM Virtual Server - 404 Not Found</h1></body></html>";
class rf {
  /**
   * Returns the filesystem path for a request URL if it matches a virtual server.
   *
   * @param window Window.
   * @param requestURL Request URL.
   */
  static getFilepath(e, n) {
    const r = new pt(e).getSettings();
    if (!r || !r.fetch.virtualServers && !r.module.resolveNodeModules)
      return null;
    if (r.fetch.virtualServers)
      for (const i of r.fetch.virtualServers) {
        let s = null;
        if (typeof i.url == "string") {
          const a = new URL(i.url[i.url.length - 1] === "/" ? i.url.slice(0, -1) : i.url, e.location.origin);
          n.startsWith(a.href) && (s = a);
        } else if (i.url instanceof RegExp) {
          const a = n.match(i.url);
          a && (s = new URL(a[0][a[0].length - 1] === "/" ? a[0].slice(0, -1) : a[0], e.location.origin));
        }
        if (s) {
          const a = n.slice(s.href.length).split("?")[0].split("#")[0];
          return qr.join(qr.resolve(i.directory), a.replaceAll("/", qr.sep));
        }
      }
    if (r.module.resolveNodeModules) {
      const i = r.module.resolveNodeModules.url, s = new URL(i[i.length - 1] === "/" ? i.slice(0, -1) : i, e.location.origin);
      if (n.startsWith(s.href)) {
        const a = n.slice(s.href.length).split("?")[0].split("#")[0];
        return qr.join(qr.resolve(r.module.resolveNodeModules.directory), a.replaceAll("/", qr.sep));
      }
    }
    return null;
  }
  /**
   * Returns a 404 response.
   *
   * @param window Window.
   * @returns 404 response.
   */
  static getNotFoundResponse(e) {
    return new e.Response(zL, {
      status: 404,
      statusText: "Not Found",
      headers: {
        "Content-Type": "text/html"
      }
    });
  }
  /**
   * Returns a 404 response.
   *
   * @param window Window.
   * @param requestURL Request URL.
   * @returns 404 response.
   */
  static getNotFoundSyncResponse(e, n) {
    return {
      status: 404,
      statusText: "Not Found",
      ok: !1,
      url: n,
      redirected: !1,
      headers: new e.Headers({
        "Content-Type": "text/html"
      }),
      body: Buffer.from(zL),
      [wo]: null
    };
  }
}
class j1 {
  /**
   * Returns a key for a preload entry.
   *
   * @param options Options.
   * @param options.url URL.
   * @param options.destination Destination.
   * @param options.mode Mode.
   * @param options.credentialsMode Credentials mode.
   * @returns Key.
   */
  static getKey(e) {
    return JSON.stringify({
      url: e.url,
      destination: e.destination,
      mode: e.mode,
      credentialsMode: e.credentialsMode
    });
  }
}
const UF = nr.from(`0\r
\r
`);
class cu {
  reject = null;
  resolve = null;
  listeners = {
    onSignalAbort: this.onSignalAbort.bind(this)
  };
  isChunkedTransfer = !1;
  isProperLastChunkReceived = !1;
  previousChunk = null;
  nodeRequest = null;
  nodeResponse = null;
  response = null;
  responseHeaders = null;
  interceptor;
  requestHeaders;
  request;
  redirectCount = 0;
  disableCache;
  disableSameOriginPolicy;
  disablePreload;
  #e;
  #t;
  #n = null;
  /**
   * Constructor.
   *
   * @param options Options.
   * @param options.browserFrame Browser frame.
   * @param options.window Window.
   * @param options.url URL.
   * @param [options.init] Init.
   * @param [options.redirectCount] Redirect count.
   * @param [options.contentType] Content Type.
   * @param [options.disableCache] Disables the use of cached responses. It will still store the response in the cache.
   * @param [options.disableSameOriginPolicy] Disables the Same-Origin policy.
   * @param [options.unfilteredHeaders] Unfiltered headers - necessary for preflight requests.
   * @param [options.disablePreload] Disables the use of preloaded responses.
   */
  constructor(e) {
    this.#e = e.browserFrame, this.#t = e.window, this.#n = e.unfilteredHeaders ?? null, this.request = typeof e.url == "string" || e.url instanceof Pr ? new e.window.Request(e.url, e.init) : e.url, e.contentType && (this.request[xi] = e.contentType), this.redirectCount = e.redirectCount ?? 0, this.disableCache = e.disableCache ?? !1, this.disableSameOriginPolicy = e.disableSameOriginPolicy ?? this.#e.page.context.browser.settings.fetch.disableSameOriginPolicy ?? !1, this.interceptor = this.#e.page.context.browser.settings.fetch.interceptor, this.requestHeaders = this.#e.page.context.browser.settings.fetch.requestHeaders, this.disablePreload = e.disablePreload ?? !1;
  }
  /**
   * Sends request.
   *
   * @returns Response.
   */
  async send() {
    if (!(this.request instanceof rW) || !(this.request[Ir] instanceof Pr))
      throw new this.#t.DOMException("Unknown request object. Request object must be an instance of Request.", ne.invalidStateError);
    if (Ug.prepareRequest(new Pr(this.#t.location.href), this.request), this.requestHeaders) {
      for (const n of this.requestHeaders)
        if (!n.url || (typeof n.url == "string" ? n.url.startsWith(this.request.url) : this.request.url.match(n.url)))
          for (const [r, i] of Object.entries(n.headers))
            this.request.headers.set(r, i);
    }
    if (this.interceptor?.beforeAsyncRequest) {
      const n = this.#e[xt].startTask(), r = await this.interceptor.beforeAsyncRequest({
        request: this.request,
        window: this.#t
      });
      if (this.#e[xt].endTask(n), r instanceof Lu)
        return r;
    }
    if (th.validateSchema(this.request), this.request.signal[xr])
      throw this.request.signal[mo] !== void 0 ? this.request.signal[mo] : new this.#t.DOMException("signal is aborted without reason", ne.abortError);
    if (this.request[Ir].protocol === "data:") {
      const n = tW.parse(this.request.url);
      this.response = new this.#t.Response(n.buffer, {
        headers: { "Content-Type": n.type }
      });
      const r = this.interceptor?.afterAsyncResponse ? await this.interceptor.afterAsyncResponse({
        window: this.#t,
        response: this.response,
        request: this.request
      }) : void 0;
      return r instanceof Lu ? r : this.response;
    }
    if (this.request[Ir].protocol === "http:" && this.#t.location.protocol === "https:")
      throw new this.#t.DOMException(`Mixed Content: The page at '${this.#t.location.href}' was loaded over HTTPS, but requested an insecure XMLHttpRequest endpoint '${this.request.url}'. This request has been blocked; the content must be served over HTTPS.`, ne.securityError);
    if (!this.disableCache) {
      const n = await this.getCachedResponse();
      if (n)
        return n;
    }
    if (!this.disablePreload) {
      const n = j1.getKey({
        url: this.request.url,
        destination: "fetch",
        mode: this.request.mode,
        credentialsMode: this.request.credentials
      }), r = this.#t.document[Va].get(n);
      if (r) {
        if (this.#t.document[Va].delete(n), r.response)
          return r.response;
        const i = this.#e[xt].startTask(), s = await r.onResponseAvailable();
        return this.#e[xt].endTask(i), s;
      }
    }
    const e = await this.getVirtualServerResponse();
    if (e)
      return e;
    if (!this.disableSameOriginPolicy && !await this.compliesWithCrossOriginPolicy())
      throw this.#e.page.console.warn(`Cross-Origin Request Blocked: The Same Origin Policy disallows reading the remote resource at "${this.request.url}".`), new this.#t.DOMException(`Cross-Origin Request Blocked: The Same Origin Policy disallows reading the remote resource at "${this.request.url}".`, ne.networkError);
    return await this.sendRequest();
  }
  /**
   * Returns cached response.
   *
   * @returns Response.
   */
  async getCachedResponse() {
    if (this.disableCache)
      return null;
    let e = this.#e.page.context.responseCache.get(this.request);
    if (!e || e.response.waitingForBody)
      return null;
    if (e.state === bg.stale) {
      const r = new this.#t.Headers(e.request.headers);
      if (e.etag)
        r.set("If-None-Match", e.etag);
      else {
        if (!e.lastModified)
          return null;
        r.set("If-Modified-Since", new Date(e.lastModified).toUTCString());
      }
      const i = new cu({
        browserFrame: this.#e,
        window: this.#t,
        url: this.request.url,
        init: { headers: r, method: e.request.method },
        disableCache: !0,
        disableSameOriginPolicy: !0
      });
      if (e.etag || !e.staleWhileRevalidate) {
        const s = await i.send(), a = s.status !== 304 ? await s.buffer() : null;
        if (e = this.#e.page.context.responseCache.add(this.request, {
          ...s,
          body: a,
          waitingForBody: !1
        }), s.status !== 304) {
          const o = new this.#t.Response(a, {
            status: s.status,
            statusText: s.statusText,
            headers: s.headers
          });
          return o.url = s.url, o[Zo] = e, o;
        }
      } else
        i.send().then((s) => {
          s.buffer().then((a) => {
            this.#e.page.context.responseCache.add(this.request, {
              ...s,
              body: a,
              waitingForBody: !1
            });
          });
        });
    }
    if (!e || e.response.waitingForBody)
      return null;
    const n = new this.#t.Response(e.response.body, {
      status: e.response.status,
      statusText: e.response.statusText,
      headers: e.response.headers
    });
    return n.url = e.response.url, n[Zo] = e, n;
  }
  /**
   * Returns virtual server response.
   *
   * @returns Response.
   */
  async getVirtualServerResponse() {
    let e = rf.getFilepath(this.#t, this.request.url);
    if (!e)
      return null;
    const n = this.#e[xt].startTask();
    if (this.request.method !== "GET") {
      this.#e.page.console.error(`${this.request.method} ${this.request.url} 404 (Not Found)`);
      const l = rf.getNotFoundResponse(this.#t), h = this.interceptor?.afterAsyncResponse ? await this.interceptor.afterAsyncResponse({
        window: this.#t,
        response: await l,
        request: this.request
      }) : void 0;
      return this.#e[xt].endTask(n), h instanceof Lu ? h : l;
    }
    let r;
    try {
      e = (await As.promises.stat(e)).isDirectory() ? qr.join(e, "index.html") : e, r = await As.promises.readFile(e);
    } catch {
      this.#e.page.console.error(`${this.request.method} ${this.request.url} 404 (Not Found)`);
      const h = rf.getNotFoundResponse(this.#t), f = this.interceptor?.afterAsyncResponse ? await this.interceptor.afterAsyncResponse({
        window: this.#t,
        response: await h,
        request: this.request
      }) : void 0;
      return this.#e[xt].endTask(n), f instanceof Lu ? f : h;
    }
    const i = new this.#t.ReadableStream({
      start: (l) => {
        this.#t.queueMicrotask(() => {
          l.enqueue(r), l.close();
        });
      }
    }), s = new this.#t.Response(i);
    s[En] = r, s[wo] = e, s.url = this.request.url;
    const a = this.interceptor?.afterAsyncResponse ? await this.interceptor.afterAsyncResponse({
      window: this.#t,
      response: await s,
      request: this.request
    }) : void 0;
    this.#e[xt].endTask(n);
    const o = a instanceof Lu ? a : s, u = {
      ...o,
      body: r,
      waitingForBody: !1,
      virtual: !0
    };
    return s[Zo] = this.#e.page.context.responseCache.add(this.request, u), o;
  }
  /**
   * Checks if the request complies with the Cross-Origin policy.
   *
   * @returns True if it complies with the policy.
   */
  async compliesWithCrossOriginPolicy() {
    if (this.disableSameOriginPolicy || !vf.isCORS(this.#t.location.href, this.request[Ir]))
      return !0;
    const e = this.#e.page.context.preflightResponseCache.get(this.request);
    if (e)
      return !(e.allowOrigin !== "*" && e.allowOrigin !== this.#t.location.origin || e.allowMethods.length !== 0 && !e.allowMethods.includes(this.request.method));
    const n = [];
    for (const [u] of this.request.headers)
      n.push(u.toLowerCase());
    const r = new this.#t.Headers({
      "Access-Control-Request-Method": this.request.method,
      Origin: this.#t.location.origin
    });
    n.length > 0 && r.set("Access-Control-Request-Headers", n.slice().sort().join(","));
    const s = await new cu({
      browserFrame: this.#e,
      window: this.#t,
      url: this.request.url,
      init: { method: "OPTIONS" },
      disableCache: !0,
      disableSameOriginPolicy: !0,
      unfilteredHeaders: r
    }).send();
    if (!s.ok)
      return !1;
    const a = s.headers.get("Access-Control-Allow-Origin");
    if (!a || a !== "*" && a !== this.#t.location.origin)
      return !1;
    const o = [];
    if (s.headers.has("Access-Control-Allow-Methods")) {
      const u = s.headers.get("Access-Control-Allow-Methods");
      if (u !== "*")
        for (const l of u.split(","))
          o.push(l.trim().toUpperCase());
    }
    return !(o.length !== 0 && !o.includes(this.request.method));
  }
  /**
   * Sends request.
   *
   * @returns Response.
   */
  sendRequest() {
    return new Promise((e, n) => {
      const r = this.#e[xt].startTask(() => this.onAsyncTaskManagerAbort());
      if (this.resolve)
        throw new this.#t.Error("Fetch already sent.");
      this.resolve = async (s) => {
        !this.disableCache && s instanceof Lu && this.#e.page && this.#e.page.context && (s[Zo] = this.#e.page.context.responseCache.add(this.request, {
          ...s,
          headers: this.responseHeaders,
          body: s[En],
          waitingForBody: !s[En] && !!s.body
        }));
        const a = this.interceptor?.afterAsyncResponse ? await this.interceptor.afterAsyncResponse({
          window: this.#t,
          response: await s,
          request: this.request
        }) : void 0;
        this.#e[xt].endTask(r);
        const o = a instanceof Lu ? a : s;
        o instanceof Lu && !o.ok && this.#e.page.console.error(`${this.request.method} ${this.request.url} ${o.status} (${o.statusText})`), e(o);
      }, this.reject = (s) => {
        this.#e[xt].endTask(r), n(s);
      }, this.request.signal.addEventListener("abort", this.listeners.onSignalAbort);
      const i = (this.request[Ir].protocol === "https:" ? UM : Cx).request;
      this.nodeRequest = i(this.request[Ir].href, {
        method: this.request.method,
        headers: VA.getRequestHeaders({
          browserFrame: this.#e,
          window: this.#t,
          request: this.request,
          baseHeaders: this.#n
        }),
        agent: !1,
        rejectUnauthorized: !this.#e.page.context.browser.settings.fetch.disableStrictSSL,
        key: this.request[Ir].protocol === "https:" ? z1.key : void 0,
        cert: this.request[Ir].protocol === "https:" ? z1.cert : void 0
      }), this.nodeRequest.on("error", this.onError.bind(this)), this.nodeRequest.on("socket", this.onSocket.bind(this)), this.nodeRequest.on("response", this.onResponse.bind(this)), this.request.body === null ? this.nodeRequest.end() : Ti.pipeline(this.request.body, this.nodeRequest, (s) => {
        s && this.onError(s);
      });
    });
  }
  /**
   * Event listener for "socket" event.
   *
   * @param socket Socket.
   */
  onSocket(e) {
    const n = () => {
      if (this.isChunkedTransfer && !this.isProperLastChunkReceived) {
        const i = new this.#t.DOMException("Premature close.", ne.networkError);
        this.request[Zi] = i, this.response && (this.response[Zi] = i, this.response.body && !this.response.body.locked && this.response.body.cancel(i));
      }
    }, r = (i) => {
      this.isProperLastChunkReceived = nr.compare(i.slice(-5), UF) === 0, !this.isProperLastChunkReceived && this.previousChunk && (this.isProperLastChunkReceived = nr.compare(this.previousChunk.slice(-3), UF.slice(0, 3)) === 0 && nr.compare(i.slice(-2), UF.slice(3)) === 0), this.previousChunk = i;
    };
    e.prependListener("close", n), e.on("data", r), this.nodeRequest.on("close", () => {
      e.removeListener("close", n), e.removeListener("data", r);
    });
  }
  /**
   * Event listener for signal "abort" event.
   *
   * @param event Event.
   */
  onSignalAbort(e) {
    this.finalizeRequest(), this.abort(e.target?.reason);
  }
  /**
   * Event listener for request "error" event.
   *
   * @param error Error.
   */
  onError(e) {
    this.finalizeRequest(), this.#e.page.console.error(e), this.reject(new this.#t.DOMException(`Failed to execute "fetch()" on "Window" with URL "${this.request.url}": ${e.message}`, ne.networkError));
  }
  /**
   * Triggered when the async task manager aborts.
   */
  onAsyncTaskManagerAbort() {
    const e = new this.#t.DOMException("The operation was aborted.", ne.abortError);
    this.request[xr] = !0, this.request[Zi] = e, this.response && (this.response[xr] = !0, this.response[Zi] = e), this.listeners.onSignalAbort && this.request.signal.removeEventListener("abort", this.listeners.onSignalAbort), this.nodeRequest && !this.nodeRequest.destroyed && this.nodeRequest.destroy(e), this.nodeResponse && !this.nodeResponse.destroyed && this.nodeResponse.destroy(e), this.response && this.response.body && (this.response.body.locked || this.response.body.cancel(e));
  }
  /**
   * Event listener for request "response" event.
   *
   * @param nodeResponse Node response.
   */
  onResponse(e) {
    if (this.isChunkedTransfer = e.headers["transfer-encoding"] === "chunked" && !e.headers["content-length"], this.nodeRequest.setTimeout(0), this.responseHeaders = iW.parseResponseHeaders({
      browserFrame: this.#e,
      requestURL: this.request[Ir],
      rawHeaders: e.rawHeaders
    }), this.handleRedirectResponse(e, this.responseHeaders))
      return;
    e.once("end", () => this.request.signal.removeEventListener("abort", this.listeners.onSignalAbort));
    let n = Ti.pipeline(e, new Ti.PassThrough(), (s) => {
    });
    const r = {
      status: e.statusCode,
      statusText: e.statusMessage,
      headers: this.responseHeaders
    }, i = this.responseHeaders.get("Content-Encoding");
    if (this.request.method === "HEAD" || i === null || e.statusCode === 204 || e.statusCode === 304) {
      this.response = new this.#t.Response(es.nodeToWebStream(n), r), this.response.redirected = this.redirectCount > 0, this.response.url = this.request.url, this.resolve(this.response);
      return;
    }
    if (i === "gzip" || i === "x-gzip") {
      const s = {
        flush: Da.constants.Z_SYNC_FLUSH,
        finishFlush: Da.constants.Z_SYNC_FLUSH
      };
      n = Ti.pipeline(n, Da.createGunzip(s), (a) => {
      }), this.response = new this.#t.Response(es.nodeToWebStream(n), r), this.response.redirected = this.redirectCount > 0, this.response.url = this.request.url, this.resolve(this.response);
      return;
    }
    if (i === "deflate" || i === "x-deflate") {
      const s = Ti.pipeline(e, new Ti.PassThrough(), (a) => {
      });
      s.on("data", (a) => {
        (a[0] & 15) === 8 ? n = Ti.pipeline(n, Da.createInflate(), (o) => {
        }) : n = Ti.pipeline(n, Da.createInflateRaw(), (o) => {
        }), this.response = new this.#t.Response(es.nodeToWebStream(n), r), this.response.redirected = this.redirectCount > 0, this.response.url = this.request.url, this.resolve(this.response);
      }), s.on("end", () => {
        this.response || (this.response = new this.#t.Response(es.nodeToWebStream(n), r), this.response.redirected = this.redirectCount > 0, this.response.url = this.request.url, this.resolve(this.response));
      });
      return;
    }
    if (i === "br") {
      n = Ti.pipeline(n, Da.createBrotliDecompress(), (s) => {
      }), this.response = new this.#t.Response(es.nodeToWebStream(n), r), this.response.redirected = this.redirectCount > 0, this.response.url = this.request.url, this.resolve(this.response);
      return;
    }
    this.response = new this.#t.Response(es.nodeToWebStream(n), r), this.response.redirected = this.redirectCount > 0, this.response.url = this.request.url, this.resolve(this.response);
  }
  /**
   * Handles redirect response.
   *
   * @param nodeResponse Node response.
   * @param responseHeaders Headers.
   * @returns True if redirect response was handled, false otherwise.
   */
  handleRedirectResponse(e, n) {
    if (!K1.isRedirect(e.statusCode))
      return !1;
    switch (this.request.redirect) {
      case "error":
        return this.finalizeRequest(), this.reject(new this.#t.DOMException(`URI requested responds with a redirect, redirect mode is set to "error": ${this.request.url}`, ne.abortError)), !0;
      case "manual":
        return !1;
      case "follow":
        const r = n.get("Location"), i = e.statusCode === 303 || (e.statusCode === 301 || e.statusCode === 302) && this.request.method === "POST";
        let s = null;
        if (r !== null)
          try {
            s = new Pr(r, this.request.url);
          } catch {
            return this.finalizeRequest(), this.reject(new this.#t.DOMException(`URI requested responds with an invalid redirect URL: ${r}`, ne.uriMismatchError)), !0;
          }
        if (s === null)
          return !1;
        if (K1.isMaxRedirectsReached(this.redirectCount))
          return this.finalizeRequest(), this.reject(new this.#t.DOMException(`Maximum redirects reached at: ${this.request.url}`, ne.networkError)), !0;
        const a = new this.#t.Headers(this.request.headers), o = {
          method: this.request.method,
          signal: this.request.signal,
          referrer: this.request.referrer,
          referrerPolicy: this.request.referrerPolicy,
          credentials: this.request.credentials,
          headers: a,
          body: this.request[Ul]
        };
        if ((this.request.credentials === "omit" || this.request.credentials === "same-origin" && vf.isCORS(this.#t.location.href, s)) && (a.delete("cookie"), a.delete("cookie2")), this.request.signal[xr])
          return this.abort(this.request.signal[mo]), !0;
        i && (o.method = "GET", o.body = void 0, a.delete("Content-Length"), a.delete("Content-Type"));
        const u = Ug.getReferrerPolicyFromHeader(a);
        u && (o.referrerPolicy = u);
        const l = new cu({
          browserFrame: this.#e,
          window: this.#t,
          url: s,
          init: o,
          redirectCount: this.redirectCount + 1,
          disableSameOriginPolicy: this.disableSameOriginPolicy,
          contentType: i ? null : this.request[xi]
        });
        return this.finalizeRequest(), l.send().then((h) => this.resolve(h)).catch((h) => this.reject(h)), !0;
      default:
        return this.finalizeRequest(), this.reject(new this.#t.DOMException(`Redirect option '${this.request.redirect}' is not a valid value of IRequestRedirect`)), !0;
    }
  }
  /**
   * Finalizes the request.
   */
  finalizeRequest() {
    this.request.signal.removeEventListener("abort", this.listeners.onSignalAbort), this.nodeRequest?.destroy();
  }
  /**
   * Aborts the request.
   *
   * @param reason Reason.
   */
  abort(e) {
    const n = new this.#t.DOMException("The operation was aborted." + (e ? " " + e.toString() : ""), ne.abortError);
    this.request[xr] = !0, this.request[Zi] = n, this.response && (this.response[xr] = !0, this.response[Zi] = n), this.nodeRequest && !this.nodeRequest.destroyed && this.nodeRequest.destroy(n), this.nodeResponse && !this.nodeResponse.destroyed && this.nodeResponse.destroy(n), this.response && this.response.body && (this.response.body.locked || this.response.body.cancel(n)), this.reject && this.reject(e !== void 0 ? e : n);
  }
}
var jv;
(function(t) {
  t.auto = "auto", t.manual = "manual";
})(jv || (jv = {}));
const pc = jv;
class Cf {
  /**
   * Returns relative URL.
   *
   * @param frame Frame.
   * @param url URL.
   * @returns Relative URL.
   */
  static getRelativeURL(e, n) {
    if (n = n ? String(n) : "about:blank", n.startsWith("about:") || n.startsWith("javascript:"))
      return new Pr(n);
    try {
      return new Pr(n, e.window[Gu].href);
    } catch {
      return new Pr("about:blank");
    }
  }
}
class jL {
  #e;
  #t;
  /**
   * Constructor.
   *
   * @param browserFrame Browser frame.
   * @param window Owner window.
   */
  constructor(e, n) {
    if (!e)
      throw new TypeError("Illegal constructor");
    this.#e = e, this.#t = n;
  }
  /**
   * Returns the history length.
   *
   * @returns History length.
   */
  get length() {
    return this.#e?.[Ci].items.length || 0;
  }
  /**
   * Returns an any value representing the state at the top of the history stack. This is a way to look at the state without having to wait for a popstate event.
   *
   * @returns State.
   */
  get state() {
    return this.#e?.[Ci].currentItem.state || null;
  }
  /**
   * Returns scroll restoration.
   *
   * @returns Sroll restoration.
   */
  get scrollRestoration() {
    return this.#e?.[Ci].currentItem.scrollRestoration || pc.auto;
  }
  /**
   * Sets scroll restoration.
   *
   * @param scrollRestoration Sroll restoration.
   */
  set scrollRestoration(e) {
    switch (e) {
      case pc.auto:
      case pc.manual:
        const n = this.#e?.[Ci].currentItem;
        n && (n.scrollRestoration = e);
        break;
    }
  }
  /**
   * Goes to the previous page in session history.
   */
  back() {
    this.#t.closed || this.#e?.goBack();
  }
  /**
   * Goes to the next page in session history.
   */
  forward() {
    this.#t.closed || this.#e?.goForward();
  }
  /**
   * Load a specific page from the session history.
   *
   * @param delta Delta.
   * @param _delta
   */
  go(e) {
    this.#t.closed || this.#e?.goSteps(e);
  }
  /**
   * Pushes the given data onto the session history stack.
   *
   * @param state State.
   * @param _unused Unused.
   * @param [url] URL.
   */
  pushState(e, n, r) {
    if (!this.#e || this.#t.closed)
      return;
    const i = this.#e?.[Ci];
    if (!i)
      return;
    if (arguments.length < 2)
      throw new this.#t.TypeError(`Failed to execute 'pushState' on 'History': 2 arguments required, but only ${arguments.length} present.`);
    const s = this.#t[Gu], a = r ? Cf.getRelativeURL(this.#e, r) : s;
    if (r && a.origin !== s.origin)
      throw new this.#t.DOMException(`Failed to execute 'pushState' on 'History': A history state object with URL '${r.toString()}' cannot be created in a document with origin '${s.origin}' and URL '${s.href}'.`, ne.securityError);
    i.currentItem.popState = !0, i.push({
      title: this.#t.document.title,
      href: a.href,
      state: e,
      popState: !0,
      scrollRestoration: i.currentItem.scrollRestoration,
      method: i.currentItem.method || "GET",
      formData: i.currentItem.formData || null
    }), s[fo](this.#e, i.currentItem.href);
  }
  /**
   * This method modifies the current history entry, replacing it with a new state.
   *
   * @param state State.
   * @param _unused Unused.
   * @param [url] URL.
   */
  replaceState(e, n, r) {
    if (!this.#e || this.#t.closed)
      return;
    const i = this.#e?.[Ci];
    if (!i)
      return;
    if (arguments.length < 2)
      throw new this.#t.TypeError(`Failed to execute 'pushState' on 'History': 2 arguments required, but only ${arguments.length} present.`);
    const s = this.#t[Gu], a = r ? Cf.getRelativeURL(this.#e, r) : s;
    if (r && a.origin !== s.origin)
      throw new this.#t.DOMException(`Failed to execute 'pushState' on 'History': A history state object with URL '${r.toString()}' cannot be created in a document with origin '${s.origin}' and URL '${s.href}'.`, ne.securityError);
    i.replace({
      title: this.#t.document.title,
      href: a.href,
      state: e,
      popState: i.currentItem.popState,
      scrollRestoration: i.currentItem.scrollRestoration,
      method: i.currentItem.method,
      formData: i.currentItem.formData
    }), r && s[fo](this.#e, i.currentItem.href);
  }
  /**
   * Destroys the history.
   *
   * This will make sure that the History API can't access page data from the next history item.
   */
  [tn]() {
    this.#e = null;
  }
}
let A$e = class {
  // @ts-ignore
  #e;
  // @ts-ignore
  #t;
  /**
   * Constructor.
   *
   * @param callback Callback.
   * @param options Options.
   */
  constructor(e, n) {
    this.#e = e, this.#t = n || {};
  }
  /**
   * Starts observing.
   *
   * @param _target Target.
   */
  observe(e) {
  }
  /**
   * Disconnects.
   */
  disconnect() {
  }
  /**
   * Unobserves an element.
   *
   * @param _target Target.
   */
  unobserve(e) {
  }
  /**
   * Returns an array of IntersectionObserverEntry objects for all observed targets.
   *
   * @returns Records.
   */
  takeRecords() {
    return [];
  }
};
class E$e {
  boundingClientRect = null;
  intersectionRatio = 0;
  intersectionRect = null;
  isIntersecting = !1;
  rootBounds = null;
  target = null;
  time = 0;
  /**
   * Constructor.
   *
   * @param init Options to initialize the intersection observer entry.
   */
  constructor(e) {
    Object.assign(this, e);
  }
}
class YL {
  // Public properties
  [Symbol.toStringTag] = "Location";
  // Private properties
  #e;
  #t;
  #n = null;
  #r = [];
  /**
   * Constructor.
   *
   * @param browserFrame Browser frame.
   * @param url URL.
   */
  constructor(e, n) {
    if (!e)
      throw new TypeError("Illegal constructor");
    this.#e = e, this.#t = new URL(n);
  }
  /**
   * Returns hash.
   *
   * @returns Hash.
   */
  get hash() {
    return this.#t.hash;
  }
  /**
   * Sets hash.
   *
   * @param hash Value.
   */
  set hash(e) {
    const n = this.#e?.[Ci];
    if (!n || !this.#e)
      return;
    const r = new URL(this.#t.href), i = this.#t.hash;
    r.hash = e, r.hash !== i && (n.currentItem.popState = !0, n.push({
      title: "",
      href: r.href,
      state: n.currentItem.state,
      popState: !0,
      scrollRestoration: pc.manual,
      method: n.currentItem.method,
      formData: n.currentItem.formData || null
    }), this[fo](this.#e, r.href));
  }
  /**
   * Returns host.
   *
   * @returns Host.
   */
  get host() {
    return this.#t.host;
  }
  /**
   * Sets host.
   *
   * @param host Value.
   */
  set host(e) {
    const n = new URL(this.#t.href);
    n.host = e, this.href = n.href;
  }
  /**
   * Returns hostname.
   *
   * @returns Hostname.
   */
  get hostname() {
    return this.#t.hostname;
  }
  /**
   * Sets hostname.
   *
   * @param hostname Value.
   */
  set hostname(e) {
    const n = new URL(this.#t.href);
    n.hostname = e, this.href = n.href;
  }
  /**
   * Override set href.
   */
  get href() {
    return this.#t.href;
  }
  /**
   * Override set href.
   */
  set href(e) {
    this.#e && this.#e.goto(e).catch((n) => {
      if (this.#e?.page?.console)
        this.#e.page.console.error(n);
      else
        throw n;
    });
  }
  /**
   * Returns origin.
   *
   * @returns Origin.
   */
  get origin() {
    return this.#t.origin;
  }
  /**
   * Returns pathname
   *
   * @returns Pathname.
   */
  get pathname() {
    return this.#t.pathname;
  }
  /**
   * Sets pathname.
   *
   * @param pathname Value.
   */
  set pathname(e) {
    const n = new URL(this.#t.href);
    n.pathname = e, this.href = n.href;
  }
  /**
   * Returns port.
   *
   * @returns Port.
   */
  get port() {
    return this.#t.port;
  }
  /**
   * Sets port.
   *
   * @param port Value.
   */
  set port(e) {
    const n = new URL(this.#t.href);
    n.port = e, this.href = n.href;
  }
  /**
   * Returns protocol.
   *
   * @returns Protocol.
   */
  get protocol() {
    return this.#t.protocol;
  }
  /**
   * Sets protocol.
   *
   * @param protocol Value.
   */
  set protocol(e) {
    const n = new URL(this.#t.href);
    n.protocol = e, this.href = n.href;
  }
  /**
   * Returns search.
   *
   * @returns Search.
   */
  get search() {
    return this.#t.search;
  }
  /**
   * Sets search.
   *
   * @param search Value.
   */
  set search(e) {
    const n = new URL(this.#t.href);
    n.search = e, this.href = n.href;
  }
  /**
   * Replaces the current resource with the one at the provided URL. The difference from the assign() method is that after using replace() the current page will not be saved in session History, meaning the user won't be able to use the back button to navigate to it.
   *
   * @param url URL.
   */
  replace(e) {
    this.href = String(e);
  }
  /**
   * Loads the resource at the URL provided in parameter.
   *
   * @param url URL.
   */
  assign(e) {
    this.href = String(e);
  }
  /**
   * Reloads the resource from the current URL.
   */
  reload() {
    this.#e && this.#e.goto(this.href).catch((e) => {
      if (this.#e?.page.console)
        this.#e.page.console.error(e);
      else
        throw e;
    });
  }
  /**
   * Replaces the current URL state with the provided one without navigating to the new URL.
   *
   * @param browserFrame Browser frame that must match the current one as validation.
   * @param url URL.
   */
  [fo](e, n) {
    if (!this.#e)
      return;
    if (this.#e !== e)
      throw new Error("Failed to set URL. Browser frame mismatch.");
    const r = this.#t.href, i = this.#t.hash;
    if (this.#t.href = n, this.#t.hash !== i) {
      const s = this.#t.href;
      this.#r.push(new X7("hashchange", { oldURL: r, newURL: s })), this.#e?.window?.document?.[Na](), this.#n && this.#e.window?.clearTimeout(this.#n), this.#n = this.#e.window?.setTimeout(() => {
        const a = this.#r;
        this.#r = [];
        for (const o of a)
          this.#e?.window?.dispatchEvent(o);
      });
    }
  }
  /**
   * Destroys the location.
   */
  [tn]() {
    this.#n && this.#e?.window?.clearTimeout(this.#n), this.#e = null;
  }
  /**
   * Returns the URL as a string.
   *
   * @returns URL as a string.
   */
  toString() {
    return this.#t.toString();
  }
}
class Ah {
  type;
  target;
  addedNodes;
  removedNodes;
  previousSibling;
  nextSibling;
  attributeName;
  attributeNamespace;
  oldValue;
  /**
   * Constructor.
   *
   * @param init Options to initialize the mutation record.
   * @param init.type Type.
   * @param init.target Target node.
   * @param init.addedNodes Nodes added.
   * @param init.removedNodes Nodes removed.
   * @param init.previousSibling Previous sibling node.
   * @param init.nextSibling Next sibling node.
   * @param init.attributeName Name of the attribute.
   * @param init.attributeNamespace Namespace of the attribute.
   * @param init.oldValue Previous value of the attribute.
   */
  constructor(e) {
    this.type = e.type, this.target = e.target, this.addedNodes = e.addedNodes || [], this.removedNodes = e.removedNodes || [], this.previousSibling = e.previousSibling || null, this.nextSibling = e.nextSibling || null, this.attributeName = e.attributeName || null, this.attributeNamespace = e.attributeNamespace || null, this.oldValue = e.oldValue || null;
  }
}
class S$e {
  description;
  enabledPlugin;
  suffixes;
  type;
  /**
   * Constructor.
   *
   * @param description
   * @param enabledPlugin
   * @param suffixes
   * @param type
   */
  constructor(e, n, r, i) {
    this.description = e, this.enabledPlugin = n, this.suffixes = r, this.type = i;
  }
  /**
   * Returns the object as a string.
   *
   * @returns String.
   */
  toString() {
    return "[object MimeType]";
  }
}
class sW {
  length;
  /**
   * Constructor.
   *
   * @param mimeTypes
   */
  constructor(e) {
    for (let n = 0, r = e.length; n < r; n++)
      this[n] = e[n], this[e[n].type] = e[n];
    this.length = e.length;
  }
  /**
   * @param index
   */
  item(e) {
    return this[e] || null;
  }
  /**
   * @param name
   */
  namedItem(e) {
    return this[e] || null;
  }
  /**
   * Returns the object as a string.
   *
   * @returns String.
   */
  toString() {
    return "[object MimeTypeArray]";
  }
}
class aW {
  length;
  /**
   * Constructor.
   *
   * @param plugins Plugins.
   */
  constructor(e) {
    for (let n = 0, r = e.length; n < r; n++)
      this[n] = e[n], this[e[n].name] = e[n];
    this.length = e.length;
  }
  /**
   * Returns an item.
   *
   * @param index Index.
   * @returns Plugin.
   */
  item(e) {
    return this[e] || null;
  }
  /**
   * Returns an item.
   *
   * @param name Name.
   * @returns Plugin.
   */
  namedItem(e) {
    return this[e] || null;
  }
  /**
   * Refreshes the list.
   */
  refresh() {
  }
  /**
   * Returns the object as a string.
   *
   * @returns String.
   */
  toString() {
    return "[object PluginArray]";
  }
}
var Yv;
(function(t) {
  t.geolocation = "geolocation", t.notifications = "notifications", t.push = "push", t.midi = "midi", t.camera = "camera", t.microphone = "microphone", t.backgroundFetch = "background-fetch", t.backgroundSync = "background-sync", t.persistentStorage = "persistent-storage", t.ambientLightSensor = "ambient-light-sensor", t.accelerometer = "accelerometer", t.gyroscope = "gyroscope", t.magnetometer = "magnetometer", t.screenWakeLock = "screen-wake-lock", t.nfc = "nfc", t.displayCapture = "display-capture", t.accessibilityEvents = "accessibility-events", t.clipboardRead = "clipboard-read", t.clipboardWrite = "clipboard-write", t.paymentHandler = "payment-handler", t.idleDetection = "idle-detection", t.periodicBackgroundSync = "periodic-background-sync", t.systemWakeLock = "system-wake-lock", t.storageAccess = "storage-access", t.windowManagement = "window-management", t.windowPlacement = "window-placement", t.localFonts = "local-fonts", t.topLevelStorageAccess = "top-level-storage-access";
})(Yv || (Yv = {}));
const w$e = Yv;
class oW {
  #e = {};
  #t;
  /**
   * Constructor.
   *
   * @param window Window.
   */
  constructor(e) {
    e?.document, this.#t = e;
  }
  /**
   * Returns scroll restoration.
   *
   * @param permissionDescriptor Permission descriptor.
   * @param permissionDescriptor.name Permission name.
   * @param [permissionDescriptor.userVisibleOnly] User visible only.
   * @param [permissionDescriptor.sysex] Sysex.
   * @returns Permission status.
   */
  async query(e) {
    const n = e?.name;
    if (n && this.#e[n])
      return this.#e[n];
    if (!Object.values(w$e).includes(n))
      throw new Error(`Failed to execute 'query' on 'Permissions': Failed to read the 'name' property from 'PermissionDescriptor': The provided value '${n}' is not a valid enum value of type PermissionName.`);
    return this.#e[n] = new this.#t.PermissionStatus("granted"), this.#e[n];
  }
}
class qL {
  #e;
  #t;
  #n;
  /**
   * Constructor.
   *
   * @param window Owner window.
   */
  constructor(e) {
    if (!e)
      throw new TypeError("Invalid constructor");
    this.#e = e, this.#t = new $7(e), this.#n = new oW(e);
  }
  /**
   * False if setting a cookie will be ignored and true otherwise.
   */
  get cookieEnabled() {
    return !0;
  }
  /**
   * TODO: Not implemented.
   */
  get credentials() {
    return null;
  }
  /**
   * TODO: Not implemented.
   */
  get geolocation() {
    return null;
  }
  /**
   * String representing the preferred language of the user, usually the language of the browser UI.
   */
  get language() {
    return "en-US";
  }
  /**
   * Array of string representing the user's preferred languages.
   */
  get languages() {
    return ["en-US", "en"];
  }
  /**
   * TODO: Not implemented.
   */
  get locks() {
    return null;
  }
  /**
   * Maximum number of simultaneous touch contact points are supported by the current device.
   */
  get maxTouchPoints() {
    return new pt(this.#e).getSettings()?.navigator.maxTouchPoints || 0;
  }
  /**
   * Number of logical processors available to run threads on the user's computer.
   */
  get hardwareConcurrency() {
    return 8;
  }
  /**
   * Browser app code name.
   */
  get appCodeName() {
    return "Mozilla";
  }
  /**
   * Browser app name.
   */
  get appName() {
    return "Netscape";
  }
  /**
   * Browser app version.
   */
  get appVersion() {
    const e = this.userAgent, n = e.indexOf("/");
    return n > -1 ? e.substring(n + 1) : "";
  }
  /**
   * Browser platform.
   */
  get platform() {
    const e = this.userAgent, n = e.indexOf("("), r = e.indexOf(")");
    return n > -1 && r > -1 ? e.substring(n + 1, r) : "";
  }
  /**
   * Browser product.
   */
  get product() {
    return "Gecko";
  }
  /**
   * Browser product sub.
   */
  get productSub() {
    return "20100101";
  }
  /**
   * Browser vendor.
   */
  get vendor() {
    return "";
  }
  /**
   * Browser vendor sub.
   */
  get vendorSub() {
    return "";
  }
  /**
   * Browser user agent.
   *
   * "appCodeName/appVersion number (Platform; Security; OS-or-CPU; Localization; rv: revision-version-number) product/productSub Application-Name Application-Name-version".
   */
  get userAgent() {
    return new pt(this.#e).getSettings()?.navigator.userAgent || "";
  }
  /**
   * Boolean value indicating whether the browser is working online.
   */
  get onLine() {
    return !0;
  }
  /**
   * Returns a Permissions object that can be used to query and update permission status of APIs covered by the Permissions API.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/permissions
   * @returns Permissions.
   */
  get permissions() {
    return this.#n;
  }
  /**
   * Returns a Clipboard object providing access to the contents of the system clipboard.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/clipboard
   * @returns Clipboard.
   */
  get clipboard() {
    return this.#t;
  }
  /**
   * Boolean Indicates whether the user agent is controlled by automation.
   */
  get webdriver() {
    return !0;
  }
  /**
   * The user's Do Not Track setting, which indicates whether the user is requesting web sites and advertisers to not track them.
   *
   * The value of the property reflects that of the DNT HTTP header, i.e. Values of "1", "0", or "unspecified".
   */
  get doNotTrack() {
    return "unspecified";
  }
  /**
   * Browser mime-types.
   */
  get mimeTypes() {
    return new sW([]);
  }
  /**
   * Browser plugins.
   */
  get plugins() {
    return new aW([]);
  }
  /**
   * Sends an HTTP POST request containing a small amount of data to a web server.
   *
   * @param url URL.
   * @param data Data.
   * @returns "true" if the user agent successfully queued the data for transfer. Otherwise, it returns "false".
   */
  sendBeacon(e, n) {
    return this.#e.fetch(e, {
      method: "POST",
      body: n
    }), !0;
  }
  /**
   * Returns the object as a string.
   *
   * @returns String.
   */
  toString() {
    return "[object Navigator]";
  }
}
class F$e {
  length = 0;
  description;
  filename;
  name;
  /**
   * Constructor.
   *
   * @param mimeTypes Mime types.
   * @param description Description.
   * @param filename Filename.
   * @param name Name.
   */
  constructor(e, n, r, i) {
    this.description = n, this.filename = r, this.name = i;
    for (let s = 0, a = e.length; s < a; s++)
      this[s] = e[s], this[e[s].type] = e[s];
    this.length = e.length;
  }
  /**
   * Item.
   *
   * @param index Number.
   * @returns IMimeType.
   */
  item(e) {
    return this[e] || null;
  }
  /**
   * NamedItem.
   *
   * @param name String.
   * @returns IMimeType.
   */
  namedItem(e) {
    return this[e] || null;
  }
  /**
   * Returns the object as a string.
   *
   * @returns String.
   */
  toString() {
    return "[object Plugin]";
  }
}
var qv;
(function(t) {
  t[t.disconnect = 1] = "disconnect", t[t.preceding = 2] = "preceding", t[t.following = 4] = "following", t[t.contains = 8] = "contains", t[t.containedBy = 16] = "containedBy", t[t.implementationSpecific = 32] = "implementationSpecific";
})(qv || (qv = {}));
const Ra = qv;
class dt {
  /**
   * Returns whether the passed node is a text node, and narrows its type.
   *
   * @param node The node to be tested.
   * @returns "true" if the node is a text node.
   */
  static isTextNode(e) {
    return e?.[ve] === le.textNode;
  }
  /**
   * Returns boolean indicating if "ancestorNode" is an inclusive ancestor of "referenceNode".
   *
   * Based on:
   * https://github.com/jsdom/jsdom/blob/master/lib/jsdom/living/helpers/node.js
   *
   * @see https://dom.spec.whatwg.org/#concept-tree-inclusive-ancestor
   * @param ancestorNode Ancestor node.
   * @param referenceNode Reference node.
   * @param [includeShadowRoots = false] Include shadow roots.
   * @returns "true" if inclusive ancestor.
   */
  static isInclusiveAncestor(e, n, r = !1) {
    if (e === null || n === null)
      return !1;
    if (e === n)
      return !0;
    if (!e[Re].length || r && n[st] !== e[st])
      return !1;
    if (r && e === n[he] && n[st])
      return !0;
    let i = n[xe];
    for (; i; ) {
      if (e === i)
        return !0;
      if (e[xe] === i[xe])
        return !1;
      i = i[xe] ? i[xe] : r && i.host ? i.host : null;
    }
    return !1;
  }
  /**
   * Returns boolean indicating if nodeB is following nodeA in the document tree.
   *
   * Based on:
   * https://github.com/jsdom/jsdom/blob/master/lib/jsdom/living/helpers/node.js
   *
   * @see https://dom.spec.whatwg.org/#concept-tree-following
   * @param nodeA Node A.
   * @param nodeB Node B.
   * @returns "true" if following.
   */
  static isFollowing(e, n) {
    if (e === n)
      return !1;
    let r = n;
    for (; r; )
      if (r = this.following(r), r === e)
        return !0;
    return !1;
  }
  /**
   * Node length.
   *
   * Based on:
   * https://github.com/jsdom/jsdom/blob/master/lib/jsdom/living/helpers/node.js
   *
   * @see https://dom.spec.whatwg.org/#concept-node-length
   * @param node Node.
   * @returns Node length.
   */
  static getNodeLength(e) {
    switch (e[ve]) {
      case le.documentTypeNode:
        return 0;
      case le.textNode:
      case le.processingInstructionNode:
      case le.commentNode:
        return e.data.length;
      default:
        return e[Re].length;
    }
  }
  /**
   * Returns boolean indicating if nodeB is following nodeA in the document tree.
   *
   * Based on:
   * https://github.com/jsdom/js-symbol-tree/blob/master/lib/SymbolTree.js#L220
   *
   * @param node Node.
   * @param [root] Root.
   * @returns Following node.
   */
  static following(e, n) {
    const r = e.firstChild;
    if (r)
      return r;
    let i = e;
    for (; i; ) {
      if (i === n)
        return null;
      const s = i.nextSibling;
      if (s)
        return s;
      i = i[xe];
    }
    return null;
  }
  /**
   * Returns the next sibling or parents sibling.
   *
   * @param node Node.
   * @returns Next descendant node.
   */
  static nextDescendantNode(e) {
    for (; e && !e.nextSibling; )
      e = e[xe];
    return e ? e.nextSibling : null;
  }
  /**
   * Needed by https://dom.spec.whatwg.org/#concept-node-equals
   *
   * @param elementA
   * @param elementB
   */
  static attributeListsEqual(e, n) {
    const r = Array.from(e[bt][Ge].values()), i = Array.from(n[bt][Ge].values());
    for (const s of r) {
      let a = !1;
      for (const o of i)
        if (s[je] === o[je] && s.localName === o.localName && s[ze] === o[ze]) {
          a = !0;
          break;
        }
      if (!a)
        return !1;
    }
    return !0;
  }
  /**
   * Check if node nodeA equals node nodeB.
   * Reference: https://dom.spec.whatwg.org/#concept-node-equals
   *
   * @param nodeA Node A.
   * @param nodeB Node B.
   */
  static isEqualNode(e, n) {
    if (e[ve] !== n[ve])
      return !1;
    switch (e[ve]) {
      case le.documentTypeNode:
        const r = e, i = n;
        if (r.name !== i.name || r.publicId !== i.publicId || r.systemId !== i.systemId)
          return !1;
        break;
      case le.elementNode:
        const s = e, a = n;
        if (s[je] !== a[je] || s[pn] !== a[pn] || s[Tt] !== a[Tt] || s[bt][Ge].size !== a[bt][Ge].size)
          return !1;
        break;
      case le.attributeNode:
        const o = e, u = n;
        if (o[je] !== u[je] || o.localName !== u.localName || o[ze] !== u[ze])
          return !1;
        break;
      case le.processingInstructionNode:
        const l = e, h = n;
        if (l.target !== h.target || l.data !== h.data)
          return !1;
        break;
      case le.textNode:
      case le.commentNode:
        const f = e, m = n;
        if (f.data !== m.data)
          return !1;
        break;
    }
    if (e[ve] === le.elementNode && !dt.attributeListsEqual(e, n) || e[Re].length !== n[Re].length)
      return !1;
    for (let r = 0; r < e[Re].length; r++) {
      const i = e[Re][r], s = n[Re][r];
      if (!dt.isEqualNode(i, s))
        return !1;
    }
    return !0;
  }
}
var Jv;
(function(t) {
  t.attributes = "attributes", t.characterData = "characterData", t.childList = "childList";
})(Jv || (Jv = {}));
const Ou = Jv;
class Gi {
  static ownerDocuments = [];
  /**
   * Creates a node instance with the given owner document.
   *
   * @param ownerDocument Owner document.
   * @param nodeClass Node class.
   * @param [args] Node arguments.
   * @returns Node instance.
   */
  static createNode(e, n, ...r) {
    return n.prototype[b] || this.ownerDocuments.push(e), new n(...r);
  }
  /**
   * Pulls an owner document from the queue.
   *
   * @returns Document.
   */
  static pullOwnerDocument() {
    return this.ownerDocuments.pop() || null;
  }
}
class ot extends Xr {
  // Public properties
  static ELEMENT_NODE = le.elementNode;
  static ATTRIBUTE_NODE = le.attributeNode;
  static TEXT_NODE = le.textNode;
  static CDATA_SECTION_NODE = le.cdataSectionNode;
  static COMMENT_NODE = le.commentNode;
  static DOCUMENT_NODE = le.documentNode;
  static DOCUMENT_TYPE_NODE = le.documentTypeNode;
  static DOCUMENT_FRAGMENT_NODE = le.documentFragmentNode;
  static PROCESSING_INSTRUCTION_NODE = le.processingInstructionNode;
  static DOCUMENT_POSITION_CONTAINED_BY = Ra.containedBy;
  static DOCUMENT_POSITION_CONTAINS = Ra.contains;
  static DOCUMENT_POSITION_DISCONNECTED = Ra.disconnect;
  static DOCUMENT_POSITION_FOLLOWING = Ra.following;
  static DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC = Ra.implementationSpecific;
  static DOCUMENT_POSITION_PRECEDING = Ra.preceding;
  // Internal properties
  [st] = !1;
  [xe] = null;
  [ci] = null;
  [ys] = null;
  [Wi] = null;
  [Cn] = null;
  [zr] = null;
  [ea] = [];
  [Re] = [];
  [Ft] = [];
  [eh] = null;
  [nu] = null;
  [Ae] = {
    querySelector: /* @__PURE__ */ new Map(),
    querySelectorAll: /* @__PURE__ */ new Map(),
    matches: /* @__PURE__ */ new Map(),
    elementsByTagName: /* @__PURE__ */ new Map(),
    elementsByTagNameNS: /* @__PURE__ */ new Map(),
    elementByTagName: /* @__PURE__ */ new Map(),
    elementById: /* @__PURE__ */ new Map(),
    computedStyle: null
  };
  [li] = [];
  /**
   * Constructor.
   */
  constructor() {
    if (super(), this[b])
      this[he] = this[b].document;
    else {
      const e = Gi.pullOwnerDocument();
      if (!e)
        throw new TypeError("Illegal constructor");
      this[he] = e, this[b] = e[b];
    }
  }
  /**
   * Returns `Symbol.toStringTag`.
   *
   * @returns `Symbol.toStringTag`.
   */
  get [Symbol.toStringTag]() {
    return this.constructor.name;
  }
  /**
   * Returns connected state.
   *
   * @returns Connected state.
   */
  get isConnected() {
    return this[st];
  }
  /**
   * Returns owner document.
   *
   * @returns Owner document.
   */
  get ownerDocument() {
    return this[he];
  }
  /**
   * Returns parent node.
   *
   * @returns Parent node.
   */
  get parentNode() {
    return this[xe];
  }
  /**
   * Returns node type.
   *
   * @returns Node type.
   */
  get nodeType() {
    return this[ve];
  }
  /**
   * Get child nodes.
   *
   * @returns Child nodes list.
   */
  get childNodes() {
    return this[eh] || (this[eh] = new xo(T, this[Re])), this[eh];
  }
  /**
   * Get text value of children.
   *
   * @returns Text content.
   */
  get textContent() {
    return "";
  }
  /**
   * Sets text content.
   *
   * @param _textContent Text content.
   */
  set textContent(e) {
  }
  /**
   * Node value.
   *
   * @returns Node value.
   */
  get nodeValue() {
    return null;
  }
  /**
   * Sets node value.
   */
  set nodeValue(e) {
  }
  /**
   * Node name.
   *
   * @returns Node name.
   */
  get nodeName() {
    return "";
  }
  /**
   * Previous sibling.
   *
   * @returns Node.
   */
  get previousSibling() {
    if (this[xe]) {
      const e = this[xe][Re], n = e.indexOf(this[yn] || this);
      if (n > 0)
        return e[n - 1];
    }
    return null;
  }
  /**
   * Next sibling.
   *
   * @returns Node.
   */
  get nextSibling() {
    if (this[xe]) {
      const e = this[xe][Re], n = e.indexOf(this[yn] || this);
      if (n > -1 && n + 1 < e.length)
        return e[n + 1];
    }
    return null;
  }
  /**
   * First child.
   *
   * @returns Node.
   */
  get firstChild() {
    const e = this[Re];
    return e.length > 0 ? e[0] : null;
  }
  /**
   * Last child.
   *
   * @returns Node.
   */
  get lastChild() {
    const e = this[Re];
    return e.length > 0 ? e[e.length - 1] : null;
  }
  /**
   * Returns parent element.
   *
   * @returns Element.
   */
  get parentElement() {
    let e = this[xe];
    for (; e && e[ve] !== le.elementNode; )
      e = e[xe];
    return e;
  }
  /**
   * Returns base URI.
   *
   * @returns Base URI.
   */
  get baseURI() {
    const e = this[he].querySelector("base");
    return e ? e.href : this[b].location.href;
  }
  /**
   * Returns "true" if the node has child nodes.
   *
   * @returns "true" if the node has child nodes.
   */
  hasChildNodes() {
    return this[Re].length > 0;
  }
  /**
   * Returns "true" if this node contains the other node.
   *
   * @param otherNode Node to test with.
   * @returns "true" if this node contains the other node.
   */
  contains(e) {
    if (e === void 0)
      return !1;
    const n = this[yn] || this;
    return dt.isInclusiveAncestor(n, e);
  }
  /**
   * Returns closest root node (Document or ShadowRoot).
   *
   * @param options Options.
   * @param options.composed A Boolean that indicates whether the shadow root should be returned (false, the default), or a root node beyond shadow root (true).
   * @returns Node.
   */
  getRootNode(e) {
    if (this[st])
      return this[ci] && !e?.composed ? this[ci] : this[he];
    let n = this;
    for (; n[xe]; )
      n = n[xe];
    return n;
  }
  /**
   * Clones a node.
   *
   * @param [deep=false] "true" to clone deep.
   * @returns Cloned node.
   */
  cloneNode(e = !1) {
    return this[Bt](e);
  }
  /**
   * Append a child node to childNodes.
   *
   * @param  node Node to append.
   * @returns Appended node.
   */
  appendChild(e) {
    if (arguments.length < 1)
      throw new this[b].TypeError("Failed to execute 'appendChild' on 'Node': 1 argument required, but only 0 present");
    return this[Ht](e);
  }
  /**
   * Remove Child element from childNodes array.
   *
   * @param node Node to remove.
   * @returns Removed node.
   */
  removeChild(e) {
    if (arguments.length < 1)
      throw new this[b].TypeError("Failed to execute 'removeChild' on 'Node': 1 argument required, but only 0 present");
    return this[Ms](e);
  }
  /**
   * Inserts a node before another.
   *
   * @param newNode Node to insert.
   * @param referenceNode Node to insert before.
   * @returns Inserted node.
   */
  insertBefore(e, n) {
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'insertBefore' on 'Node': 2 arguments required, but only ${arguments.length} present.`);
    return this[ja](e, n);
  }
  /**
   * Replaces a node with another.
   *
   * @param newChild New child.
   * @param oldChild Old child.
   * @returns Replaced node.
   */
  replaceChild(e, n) {
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'replaceChild' on 'Node': 2 arguments required, but only ${arguments.length} present.`);
    return this[O1](e, n);
  }
  /**
   * Clones a node.
   *
   * @param [deep=false] "true" to clone deep.
   * @returns Cloned node.
   */
  [Bt](e = !1) {
    const n = Gi.createNode(this[he], this.constructor);
    if (n[Re].length) {
      const r = n[Re];
      for (; r.length; )
        n.removeChild(r[0]);
    }
    if (e)
      for (const r of this[Re]) {
        const i = r.cloneNode(!0);
        i[xe] = n, n[Re].push(i), i[ve] === le.elementNode && n[Ft].push(i);
      }
    return n;
  }
  /**
   * Append a child node to childNodes.
   *
   * @param  node Node to append.
   * @param [disableValidations=false] "true" to disable validations.
   * @returns Appended node.
   */
  [Ht](e, n = !1) {
    e[yn] && (e = e[yn]);
    const r = this[yn] || this;
    if (!n) {
      if (e === r)
        throw new this[b].DOMException("Failed to execute 'appendChild' on 'Node': Not possible to append a node as a child of itself.");
      if (dt.isInclusiveAncestor(e, r, !0))
        throw new this[b].DOMException("Failed to execute 'appendChild' on 'Node': The new node is a parent of the node to insert to.", ne.domException);
    }
    if (e[ve] === le.documentFragmentNode) {
      const i = e[Re];
      for (; i.length; )
        this.appendChild(i[0]);
      return e;
    }
    e[xe] && e[xe][Ms](e), e[xe] = r, e[Na](), this[Re].push(e), e[ve] === le.elementNode && this[Ft].push(e), e[ho]();
    for (const i of this[ea])
      i.options?.subtree && i.callback.deref() && e[$m](i);
    return this[oh](new Ah({
      target: r,
      type: Ou.childList,
      addedNodes: [e]
    })), e;
  }
  /**
   * Remove Child element from childNodes array.
   *
   * @param node Node to remove.
   * @returns Removed node.
   */
  [Ms](e) {
    e[yn] && (e = e[yn]);
    const n = this[Re].indexOf(e);
    if (n === -1)
      throw new this[b].DOMException("Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.");
    const r = e.previousSibling, i = e.nextSibling;
    if (e[xe] = null, e[Na](), this[Re].splice(n, 1), e[ve] === le.elementNode) {
      const s = this[Ft].indexOf(e);
      s !== -1 && this[Ft].splice(s, 1);
    }
    if (e[nu]) {
      const s = e[nu][Cl].indexOf(e);
      s !== -1 && e[nu][Cl].splice(s, 1), e[nu] = null;
    }
    e[bh]();
    for (const s of this[ea])
      s.options?.subtree && s.callback.deref() && e[$y](s);
    return this[oh](new Ah({
      target: this[yn] || this,
      type: Ou.childList,
      removedNodes: [e],
      previousSibling: r,
      nextSibling: i
    })), e;
  }
  /**
   * Inserts a node before another.
   *
   * @param newNode Node to insert.
   * @param referenceNode Node to insert before.
   * @param [disableValidations=false] "true" to disable validations.
   * @returns Inserted node.
   */
  [ja](e, n, r = !1) {
    if (e[yn] && (e = e[yn]), n && n[yn] && (n = n[yn]), e === n)
      return e;
    const i = this[yn] || this;
    if (!r) {
      if (e === i)
        throw new this[b].DOMException("Failed to execute 'insertBefore' on 'Node': Not possible to insert a node as a child of itself.");
      if (dt.isInclusiveAncestor(e, i, !0))
        throw new this[b].DOMException("Failed to execute 'insertBefore' on 'Node': The new node is a parent of the node to insert to.", ne.domException);
    }
    if (e[ve] === le.documentFragmentNode) {
      const o = e[Re];
      for (; o.length > 0; )
        this[ja](o[0], n, !0);
      return e;
    }
    if (!n)
      return this[Ht](e, !0), e;
    const s = this[Re];
    if (!s.includes(n))
      throw new this[b].DOMException("Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.");
    e[xe] && e[xe][Ms](e), e[xe] = i, e[Na]();
    const a = s.indexOf(n);
    if (e[ve] === le.elementNode) {
      const o = this[Ft];
      if (n[ve] === le.elementNode)
        o.splice(o.indexOf(n), 0, e);
      else {
        let u = !1;
        for (let l = a, h = s.length; l < h; l++)
          if (s[l][ve] === le.elementNode) {
            o.splice(o.indexOf(s[l]), 0, e), u = !0;
            break;
          }
        u || o.push(e);
      }
    }
    s.splice(a, 0, e), e[ho]();
    for (const o of this[ea])
      o.options?.subtree && o.callback.deref() && e[$m](o);
    return this[oh](new Ah({
      target: i,
      type: Ou.childList,
      addedNodes: [e]
    })), e;
  }
  /**
   * Replaces a node with another.
   *
   * @param newChild New child.
   * @param oldChild Old child.
   * @returns Replaced node.
   */
  [O1](e, n) {
    return this.insertBefore(e, n), this.removeChild(n), n;
  }
  /**
   * Compares two nodes.
   * Two nodes are equal if they have the same type, defining the same attributes, and so on.
   *
   * @param node  Node to compare.
   * @returns boolean - `true` if two nodes are equal.
   */
  isEqualNode(e) {
    return dt.isEqualNode(this, e);
  }
  /**
   * Converts the node to a string.
   *
   * @param listener Listener.
   */
  toString() {
    return `[object ${this.constructor.name}]`;
  }
  /**
   * Observeres mutations on the node.
   *
   * Used by MutationObserver and internal logic.
   *
   * @param listener Listener.
   */
  [$m](e) {
    if (this[ea].push(e), e.options.subtree)
      for (const n of this[Re])
        n[$m](e);
  }
  /**
   * Stops observing mutations on the node.
   *
   * Used by MutationObserver and internal logic.
   *
   * @param listener Listener.
   */
  [$y](e) {
    const n = this[ea].indexOf(e);
    if (n !== -1 && this[ea].splice(n, 1), e.options.subtree)
      for (const r of this[Re])
        r[$y](e);
  }
  /**
   * Reports a mutation on the node.
   *
   * Used by MutationObserver and internal logic.
   *
   * @param record Mutation record.
   */
  [oh](e) {
    this[Na]();
    const n = this[ea];
    if (n.length)
      for (let r = 0, i = n.length; r < i; r++) {
        const s = n[r], a = s.callback.deref();
        if (a)
          switch (e.type) {
            case Ou.childList:
              s.options.childList && a(e);
              break;
            case Ou.attributes:
              s.options.attributes && (!s.options.attributeFilter || s.options.attributeFilter.includes(e.attributeName)) && a(e);
              break;
            case Ou.characterData:
              s.options?.characterData && a(e);
              break;
          }
        else
          n.splice(r, 1), r--, i--;
      }
  }
  /**
   * Clears query selector cache.
   */
  [Na]() {
    const e = this[Ae];
    if (e.querySelector.size) {
      for (const i of e.querySelector.values())
        i.result && (i.result = null);
      e.querySelector = /* @__PURE__ */ new Map();
    }
    if (e.querySelectorAll.size) {
      for (const i of e.querySelectorAll.values())
        i.result && (i.result = null);
      e.querySelectorAll = /* @__PURE__ */ new Map();
    }
    if (e.matches.size) {
      for (const i of e.matches.values())
        i.result && (i.result = null);
      e.matches = /* @__PURE__ */ new Map();
    }
    if (e.elementsByTagName.size) {
      for (const i of e.elementsByTagName.values())
        i.result && (i.result = null);
      e.elementsByTagName = /* @__PURE__ */ new Map();
    }
    if (e.elementsByTagNameNS.size) {
      for (const i of e.elementsByTagNameNS.values())
        i.result && (i.result = null);
      e.elementsByTagNameNS = /* @__PURE__ */ new Map();
    }
    if (e.elementByTagName.size) {
      for (const i of e.elementByTagName.values())
        i.result && (i.result = null);
      e.elementByTagName = /* @__PURE__ */ new Map();
    }
    if (e.elementById.size) {
      for (const i of e.elementById.values())
        i.result && (i.result = null);
      e.elementById = /* @__PURE__ */ new Map();
    }
    const n = this[li];
    if (n.length) {
      for (const i of n)
        i.result = null;
      this[li] = [];
    }
    const r = this[he];
    if (r && r[fc].length) {
      for (const i of r[fc])
        i.result = null;
      r[fc] = [];
    }
  }
  /**
   * Called when connected to a node.
   */
  [ho]() {
    const e = this[xe], n = e || this[Bg];
    let r = !1, i = !1;
    if (!this[st] && n[st] ? (this[st] = !0, r = !0) : this[st] && !n[st] && (this[st] = !1, i = !0), this[he] = n[he] || n, this[b] = n[b] || n[lu], e) {
      this[ve] !== le.documentFragmentNode && (this[ci] = e[ci]);
      const a = this[Xe];
      e[ys] && a !== "STYLE" && (this[ys] = e[ys]), e[Wi] && a !== "TEXTAREA" && (this[Wi] = e[Wi]), e[Cn] && a !== "FORM" && (this[Cn] = e[Cn]), e[zr] && a !== "SELECT" && (this[zr] = e[zr]);
    }
    const s = this[Re];
    for (let a = 0, o = s.length; a < o; a++)
      s[a][xe] = this, s[a][ho]();
    this[zn] && this[zn][ho](), r ? this[Hs]() : i && this[Bs]();
  }
  /**
   * Called when disconnected from a node.
   */
  [bh]() {
    this[ve] !== le.documentFragmentNode && (this[ci] = null);
    const e = this[Xe];
    e !== "STYLE" && (this[ys] = null), e !== "TEXTAREA" && (this[Wi] = null), e !== "FORM" && (this[Cn] = null), e !== "SELECT" && (this[zr] = null), this[st] && (this[st] = !1, this[Bs]());
    const n = this[Re];
    for (let r = 0, i = n.length; r < i; r++)
      n[r][ho]();
    this[zn] && this[zn][bh]();
  }
  /**
   * Called when connected to document.
   */
  [Hs]() {
    this[zn] && this[zn][Hs]();
  }
  /**
   * Called when disconnected from document.
   */
  [Bs]() {
    this[he][jr] === this && (this[he][Na](), this[he][jr] = null), this[zn] && this[zn][Bs]();
  }
  /**
   * @override
   */
  [tn]() {
    super[tn](), this[st] = !1;
    for (let e = 0, n = this[Re].length; e < n; e++)
      this[Re][e][tn]();
    this[ea] = [], this[xe] = null, this[ci] = null, this[ys] = null, this[Wi] = null, this[Cn] = null, this[zr] = null, this[ea] = [], this[Re] = [], this[Ft] = [], this[eh] = null, this[nu] = null, this[Na]();
  }
  /**
   * Reports the position of its argument node relative to the node on which it is called.
   *
   * @see https://dom.spec.whatwg.org/#dom-node-comparedocumentposition
   * @param otherNode Other node.
   */
  compareDocumentPosition(e) {
    if (this === e)
      return 0;
    let n = e, r = this[yn] || this, i = null, s = null;
    if (n[ve] === le.attributeNode && (i = n, n = i[zt]), r[ve] === le.attributeNode && (s = r, r = s[zt], i !== null && n !== null && r === n))
      for (const C of r[bt][Ge].values()) {
        if (dt.isEqualNode(C, i))
          return ot.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC | ot.DOCUMENT_POSITION_PRECEDING;
        if (dt.isEqualNode(C, s))
          return ot.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC | ot.DOCUMENT_POSITION_FOLLOWING;
      }
    const a = [];
    let o = r;
    for (; o; ) {
      if (o === n)
        return ot.DOCUMENT_POSITION_CONTAINS | ot.DOCUMENT_POSITION_PRECEDING;
      a.push(o), o = o[xe];
    }
    const u = [];
    let l = n;
    for (; l; ) {
      if (l === r)
        return ot.DOCUMENT_POSITION_CONTAINED_BY | ot.DOCUMENT_POSITION_FOLLOWING;
      u.push(l), l = l[xe];
    }
    const h = (C, D) => C[C.length - 1 - D], f = h(a, 0);
    if (!f || f !== h(u, 0))
      return ot.DOCUMENT_POSITION_DISCONNECTED | ot.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC | ot.DOCUMENT_POSITION_FOLLOWING;
    let m = 0;
    const g = Math.min(a.length, u.length);
    for (let C = 0; C < g; ++C) {
      const D = h(a, C), L = h(u, C);
      if (D !== L)
        break;
      m = C;
    }
    const A = h(a, m);
    let E = 0, w = -1, x = -1;
    const N = h(a, m + 1), B = h(u, m + 1), P = (C) => {
      for (const D of C) {
        if (P(D[Re]), D === N ? w = E : D === B && (x = E), w !== -1 && x !== -1)
          break;
        E++;
      }
    };
    return P(A[Re]), x < w ? ot.DOCUMENT_POSITION_PRECEDING : ot.DOCUMENT_POSITION_FOLLOWING;
  }
  /**
   * Normalizes the sub-tree of the node, i.e. joins adjacent text nodes, and
   * removes all empty text nodes.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Node/normalize
   */
  normalize() {
    let e = this.firstChild;
    for (; e; ) {
      if (dt.isTextNode(e)) {
        for (; dt.isTextNode(e.nextSibling); )
          e.data += e.nextSibling.data, e.nextSibling.remove();
        if (!e.data.length) {
          const n = e;
          e = e.nextSibling, n.remove();
          continue;
        }
      } else
        e.normalize();
      e = e.nextSibling;
    }
  }
  /**
   * Determines whether the given node is equal to the current node.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Node/isSameNode
   * @param node Node to check.
   * @returns True if the given node is equal to the current node, otherwise false.
   */
  isSameNode(e) {
    return this === e;
  }
}
ot.prototype.ELEMENT_NODE = le.elementNode;
ot.prototype.ATTRIBUTE_NODE = le.attributeNode;
ot.prototype.TEXT_NODE = le.textNode;
ot.prototype.CDATA_SECTION_NODE = le.cdataSectionNode;
ot.prototype.COMMENT_NODE = le.commentNode;
ot.prototype.DOCUMENT_NODE = le.documentNode;
ot.prototype.DOCUMENT_TYPE_NODE = le.documentTypeNode;
ot.prototype.DOCUMENT_FRAGMENT_NODE = le.documentFragmentNode;
ot.prototype.PROCESSING_INSTRUCTION_NODE = le.processingInstructionNode;
ot.prototype.DOCUMENT_POSITION_CONTAINED_BY = Ra.containedBy;
ot.prototype.DOCUMENT_POSITION_CONTAINS = Ra.contains;
ot.prototype.DOCUMENT_POSITION_DISCONNECTED = Ra.disconnect;
ot.prototype.DOCUMENT_POSITION_FOLLOWING = Ra.following;
ot.prototype.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC = Ra.implementationSpecific;
ot.prototype.DOCUMENT_POSITION_PRECEDING = Ra.preceding;
class T$e extends ot {
  [ve] = le.attributeNode;
  [je] = null;
  [tt] = null;
  [Tt] = null;
  [pn] = null;
  [ze] = null;
  [J0] = !0;
  [zt] = null;
  /**
   * Returns specified.
   *
   * @deprecated
   * @returns Specified.
   */
  get specified() {
    return this[J0];
  }
  /**
   * Returns owner element.
   *
   * @returns Owner element.
   */
  get ownerElement() {
    return this[zt];
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    return this[ze];
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    this[ze] = e;
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this[tt] || "";
  }
  /**
   * Returns local name.
   *
   * @returns Local name.
   */
  get localName() {
    return this[Tt] || "";
  }
  /**
   * Returns prefix.
   *
   * @returns Prefix.
   */
  get prefix() {
    return this[pn];
  }
  /**
   * @override
   */
  get textContent() {
    return this[ze] || "";
  }
  /**
   * Returns namespace URI.
   *
   * @returns Namespace URI.
   */
  get namespaceURI() {
    return this[je];
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    const n = super[Bt](e);
    return n[je] = this[je], n[tt] = this[tt], n[Tt] = this[Tt], n[pn] = this[pn], n[ze] = this[ze], n[J0] = this[J0], n;
  }
}
class wm {
  /**
   * Appends the given DOMString to the CharacterData.data string; when this method returns, data contains the concatenated DOMString.
   *
   * @param characterData Character data.
   * @param data Data.
   */
  static appendData(e, n) {
    e.data += n;
  }
  /**
   * Removes the specified amount of characters, starting at the specified offset, from the CharacterData.data string; when this method returns, data contains the shortened DOMString.
   *
   * @param characterData Character data.
   * @param offset Offset.
   * @param count Count.
   */
  static deleteData(e, n, r) {
    e.data = e.data.substring(0, n) + e.data.substring(n + r);
  }
  /**
   * Inserts the specified characters, at the specified offset, in the CharacterData.data string; when this method returns, data contains the modified DOMString.
   *
   * @param characterData Character data.
   * @param offset Offset.
   * @param data Data.
   */
  static insertData(e, n, r) {
    e.data = e.data.substring(0, n) + r + e.data.substring(n);
  }
  /**
   * Replaces the specified amount of characters, starting at the specified offset, with the specified DOMString; when this method returns, data contains the modified DOMString.
   *
   * @param characterData Character data.
   * @param offset Offset.
   * @param count Count.
   * @param data Data.
   */
  static replaceData(e, n, r, i) {
    e.data = e.data.substring(0, n) + i + e.data.substring(n + r);
  }
  /**
   * Returns a DOMString containing the part of CharacterData.data of the specified length and starting at the specified offset.
   *
   * @param characterData Character data.
   * @param offset Offset.
   * @param count Count.
   */
  static substringData(e, n, r) {
    return e.data.substring(n, n + r);
  }
}
class Y1 {
  /**
   * Previous element sibling.
   *
   * @param childNode Child node.
   * @returns Element.
   */
  static previousElementSibling(e) {
    let n = e.previousSibling;
    for (; n && n[ve] !== le.elementNode; )
      n = n.previousSibling;
    return n;
  }
  /**
   * Next element sibling.
   *
   * @param childNode Child node.
   * @returns Element.
   */
  static nextElementSibling(e) {
    let n = e.nextSibling;
    for (; n && n[ve] !== le.elementNode; )
      n = n.nextSibling;
    return n;
  }
}
class hc {
  /**
   * Removes the node from its parent.
   *
   * @param childNode Child node.
   */
  static remove(e) {
    e[xe] && e[xe].removeChild(e);
  }
  /**
   * The Node.replaceWith() method replaces this Node in the children list of its parent with a set of Node or DOMString objects.
   *
   * @param childNode Child node.
   * @param nodes List of Node or DOMString.
   */
  static replaceWith(e, ...n) {
    const r = e[xe];
    if (!r)
      throw new Tr("This element has no parent node.");
    for (const i of n)
      i instanceof ot ? r.insertBefore(i, e) : r.insertBefore(r[he].createTextNode(String(i)), e);
    r.removeChild(e);
  }
  /**
   * Inserts a set of Node or DOMString objects in the children list of this ChildNode's parent, just before this ChildNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param childNode Child node.
   * @param nodes List of Node or DOMString.
   */
  static before(e, ...n) {
    const r = e[xe];
    if (r)
      for (const i of n)
        i instanceof ot ? r.insertBefore(i, e) : r.insertBefore(r[he].createTextNode(String(i)), e);
  }
  /**
   * Inserts a set of Node or DOMString objects in the children list of this ChildNode's parent, just after this ChildNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param childNode Child node.
   * @param nodes List of Node or DOMString.
   */
  static after(e, ...n) {
    const r = e[xe];
    if (!r)
      return;
    const i = e.nextSibling;
    for (const s of n) {
      const a = s instanceof ot ? s : r[he].createTextNode(String(s));
      i ? r.insertBefore(a, i) : r.appendChild(a);
    }
  }
}
class KA extends ot {
  [Dn] = "";
  /**
   * Constructor.
   *
   * @param [data] Data.
   */
  constructor(e) {
    super(), this[Dn] = e !== void 0 ? String(e) : "";
  }
  /**
   * Returns text content.
   *
   * @returns Text content.
   */
  get length() {
    return this[Dn].length;
  }
  /**
   * Returns text content.
   *
   * @returns Text content.
   */
  get data() {
    return this[Dn];
  }
  /**
   * Sets text content.
   *
   * @param textContent Text content.
   */
  set data(e) {
    const n = this[Dn];
    this[Dn] = String(e), this[oh](new Ah({
      target: this,
      type: Ou.characterData,
      oldValue: n
    }));
  }
  /**
   * Returns text content.
   *
   * @returns Text content.
   */
  get textContent() {
    return this[Dn];
  }
  /**
   * Sets text content.
   *
   * @param textContent Text content.
   */
  set textContent(e) {
    this.data = e;
  }
  /**
   * Returns node value.
   *
   * @returns Node value.
   */
  get nodeValue() {
    return this[Dn];
  }
  /**
   * Sets node value.
   *
   * @param nodeValue Node value.
   */
  set nodeValue(e) {
    this.textContent = e;
  }
  /**
   * Previous element sibling.
   *
   * @returns Element.
   */
  get previousElementSibling() {
    return Y1.previousElementSibling(this);
  }
  /**
   * Next element sibling.
   *
   * @returns Element.
   */
  get nextElementSibling() {
    return Y1.nextElementSibling(this);
  }
  /**
   * Appends the given DOMString to the CharacterData.data string; when this method returns, data contains the concatenated DOMString.
   *
   * @param data Data.
   */
  appendData(e) {
    wm.appendData(this, e);
  }
  /**
   * Removes the specified amount of characters, starting at the specified offset, from the CharacterData.data string; when this method returns, data contains the shortened DOMString.
   *
   * @param offset Offset.
   * @param count Count.
   */
  deleteData(e, n) {
    wm.deleteData(this, e, n);
  }
  /**
   * Inserts the specified characters, at the specified offset, in the CharacterData.data string; when this method returns, data contains the modified DOMString.
   *
   * @param offset Offset.
   * @param data Data.
   */
  insertData(e, n) {
    wm.insertData(this, e, n);
  }
  /**
   * Replaces the specified amount of characters, starting at the specified offset, with the specified DOMString; when this method returns, data contains the modified DOMString.
   *
   * @param offset Offset.
   * @param count Count.
   * @param data Data.
   */
  replaceData(e, n, r) {
    wm.replaceData(this, e, n, r);
  }
  /**
   * Returns a DOMString containing the part of CharacterData.data of the specified length and starting at the specified offset.
   *
   * @param offset Offset.
   * @param count Count.
   */
  substringData(e, n) {
    return wm.substringData(this, e, n);
  }
  /**
   * Removes the object from its parent children list.
   */
  remove() {
    hc.remove(this);
  }
  /**
   * The Node.replaceWith() method replaces this Node in the children list of its parent with a set of Node or DOMString objects.
   *
   * @param nodes List of Node or DOMString.
   */
  replaceWith(...e) {
    hc.replaceWith(this, ...e);
  }
  /**
   * Inserts a set of Node or DOMString objects in the children list of this ChildNode's parent, just before this ChildNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  before(...e) {
    hc.before(this, ...e);
  }
  /**
   * Inserts a set of Node or DOMString objects in the children list of this ChildNode's parent, just after this ChildNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  after(...e) {
    hc.after(this, ...e);
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    const n = super[Bt](e);
    return n[Dn] = this[Dn], n;
  }
}
class W2 extends ot {
  [ve] = le.documentTypeNode;
  [tt] = "";
  [Id] = "";
  [Rd] = "";
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this[tt];
  }
  /**
   * Returns public ID.
   *
   * @returns Public ID.
   */
  get publicId() {
    return this[Id];
  }
  /**
   * Returns system ID.
   *
   * @returns System ID.
   */
  get systemId() {
    return this[Rd];
  }
  /**
   * Node name.
   *
   * @returns Node name.
   */
  get nodeName() {
    return this.name;
  }
  /**
   * Converts to string.
   *
   * @returns String.
   */
  toString() {
    return "[object DocumentType]";
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    const n = super[Bt](e);
    return n[tt] = this[tt], n[Id] = this[Id], n[Rd] = this[Rd], n;
  }
}
var Qv;
(function(t) {
  t.loading = "loading", t.interactive = "interactive", t.complete = "complete";
})(Qv || (Qv = {}));
const uW = Qv;
class v$e {
  #e;
  /**
   * Constructor.
   *
   * @param browserFrame Browser frame.
   */
  constructor(e) {
    this.#e = new $2(e);
  }
  /**
   * Returns a promise that is fulfilled when ready state is complete.
   *
   * @returns Promise.
   */
  waitUntilComplete() {
    return this.#e.waitUntilComplete();
  }
  /**
   * Starts a task.
   *
   * @returns Task ID.
   */
  startTask() {
    return this.#e.startTask();
  }
  /**
   * Ends a task.
   *
   * @param taskID Task ID.
   */
  endTask(e) {
    this.#e.endTask(e);
  }
  /**
   * Destroys the manager.
   */
  destroy() {
    return this.#e.destroy();
  }
}
class zA {
  [me] = 0;
  [ge] = 0;
  [Fe] = 0;
  [we] = 0;
  /**
   * Constructor.
   *
   * @param [x] X position.
   * @param [y] Y position.
   * @param [width] Width.
   * @param [height] Height.
   */
  constructor(e, n, r, i) {
    this[me] = e != null ? Number(e) : 0, this[ge] = n != null ? Number(n) : 0, this[Fe] = r != null ? Number(r) : 0, this[we] = i != null ? Number(i) : 0;
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we];
  }
  /**
   * Returns top.
   *
   * @returns Top.
   */
  get top() {
    return Math.min(this[ge], this[ge] + this[we]);
  }
  /**
   * Returns right.
   *
   * @returns Right.
   */
  get right() {
    return Math.max(this[me], this[me] + this[Fe]);
  }
  /**
   * Returns bottom.
   *
   * @returns Bottom.
   */
  get bottom() {
    return Math.max(this[ge], this[ge] + this[we]);
  }
  /**
   * Returns left.
   *
   * @returns Left.
   */
  get left() {
    return Math.min(this[me], this[me] + this[Fe]);
  }
  /**
   * Returns the JSON representation of the object.
   *
   * @returns JSON representation.
   */
  toJSON() {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
      top: this.top,
      right: this.right,
      bottom: this.bottom,
      left: this.left
    };
  }
  /**
   * Returns a new DOMRectReadOnly object.
   *
   * @param other
   * @returns Cloned object.
   */
  static fromRect(e) {
    return new zA(e.x, e.y, e.width, e.height);
  }
}
class Of extends zA {
  /**
   * Sets x.
   *
   * @param value X.
   */
  set x(e) {
    this[me] = e;
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me];
  }
  /**
   * Sets y.
   *
   * @param value Y.
   */
  set y(e) {
    this[ge] = e;
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge];
  }
  /**
   * Sets width.
   *
   * @param value Width.
   */
  set width(e) {
    this[Fe] = e;
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe];
  }
  /**
   * Sets height.
   *
   * @param value Height.
   */
  set height(e) {
    this[we] = e;
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we];
  }
  /**
   * Returns a new DOMRect object.
   *
   * @param other
   * @returns Cloned object.
   */
  static fromRect(e) {
    return new Of(e.x, e.y, e.width, e.height);
  }
}
const x$e = /[\t\f\n\r ]+/;
class Zu {
  [zt];
  [ml];
  [Ae] = {
    items: [],
    attributeValue: ""
  };
  [OF];
  [yn];
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param ownerElement Owner element.
   * @param attributeName Attribute name.
   * @param [supports] Supports.
   */
  constructor(e, n, r, i) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[zt] = n, this[ml] = r, this[OF] = i || [];
    const s = new Ws(this, [Zu]), a = new Proxy(this, {
      get: (o, u) => {
        if (u === "length")
          return o[Mi]().length;
        if (u in o || typeof u == "symbol")
          return s.bind(u), o[u];
        const l = Number(u);
        if (!isNaN(l))
          return o[Mi]()[l];
      },
      set(o, u, l) {
        if (s.bind(u), typeof u == "symbol")
          return o[u] = l, !0;
        const h = Number(u);
        return isNaN(h) && (o[u] = l), !0;
      },
      deleteProperty(o, u) {
        if (typeof u == "symbol")
          return delete o[u], !0;
        const l = Number(u);
        return isNaN(l) && delete o[u], !0;
      },
      ownKeys(o) {
        return Object.keys(o[Mi]());
      },
      has(o, u) {
        if (u in o)
          return !0;
        if (typeof u == "symbol")
          return !1;
        const l = Number(u);
        return !isNaN(l) && l >= 0 && l < o[Mi]().length;
      },
      defineProperty(o, u, l) {
        return s.preventBinding(u), u in o ? (Object.defineProperty(o, u, l), !0) : !1;
      },
      getOwnPropertyDescriptor(o, u) {
        if (u in o || typeof u == "symbol")
          return;
        const l = Number(u), h = o[Mi]();
        if (!isNaN(l) && h[l])
          return {
            value: h[l],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
    return this[yn] = a, a;
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[Mi]().length;
  }
  /**
   * Set value.
   *
   * @param value Value.
   */
  set value(e) {
    this[zt].setAttribute(this[ml], e);
  }
  /**
   * Get value.
   */
  get value() {
    return this[zt].getAttribute(this[ml]) || "";
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   */
  [Symbol.iterator]() {
    return this[Mi]().values();
  }
  /**
   * Get ClassName.
   *
   * @param index Index.
   * */
  item(e) {
    const n = this[Mi]();
    return typeof e == "number" || (e = Number(e), e = isNaN(e) ? 0 : e), n[e] ? n[e] : null;
  }
  /**
   * Replace Token.
   *
   * @param token Token.
   * @param newToken NewToken.
   */
  replace(e, n) {
    const r = this[Mi]().slice(), i = r.indexOf(e);
    return i === -1 ? !1 : (r[i] = n, this[zt].setAttribute(this[ml], r.join(" ")), !0);
  }
  /**
   * Supports.
   *
   * @param token Token.
   */
  supports(e) {
    return this[OF].includes(e);
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   */
  values() {
    return this[Mi]().values();
  }
  /**
   * Returns an iterator, allowing you to go through all key/value pairs contained in this object.
   */
  entries() {
    return this[Mi]().entries();
  }
  /**
   * Executes a provided callback function once for each DOMTokenList element.
   *
   * @param callback
   * @param thisArg
   */
  forEach(e, n) {
    const r = n ?? this[zt][b], i = this[Mi](), s = this[yn] ?? this;
    for (let a = 0, o = i.length; a < o; a++)
      e.call(r, i[a], a, s);
  }
  /**
   * Returns an iterator, allowing you to go through all keys of the key/value pairs contained in this object.
   *
   */
  keys() {
    return this[Mi]().keys();
  }
  /**
   * Adds tokens.
   *
   * @param tokens Tokens.
   */
  add(...e) {
    const n = this[Mi]().slice(), r = new Set(n);
    for (const i of e)
      r.has(i) || (r.add(i), n.push(i));
    this[zt].setAttribute(this[ml], n.join(" "));
  }
  /**
   * Removes tokens.
   *
   * @param tokens Tokens.
   */
  remove(...e) {
    const n = this[Mi](), r = new Set(e), i = n.filter((s) => !r.has(s));
    this[zt].setAttribute(this[ml], i.join(" "));
  }
  /**
   * Check if the list contains a class.
   *
   * @param className Class name.
   * @returns TRUE if it contains.
   */
  contains(e) {
    return this[Mi]().includes(e);
  }
  /**
   * Toggle a class name.
   *
   * @param token A string representing the class name you want to toggle.
   * @param [force] If included, turns the toggle into a one way-only operation. If set to `false`, then class name will only be removed, but not added. If set to `true`, then class name will only be added, but not removed.
   * @returns A boolean value, `true` or `false`, indicating whether class name is in the list after the call or not.
   */
  toggle(e, n) {
    let r;
    return n !== void 0 ? r = n : r = !this.contains(e), r ? (this.add(e), !0) : (this.remove(e), !1);
  }
  /**
   * Returns token list from attribute value.
   *
   * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
   */
  [Mi]() {
    const e = this[zt].getAttribute(this[ml]) ?? "", n = this[Ae];
    if (n.attributeValue === e)
      return n.items;
    const r = [], i = e.trim();
    if (i)
      for (const s of i.split(x$e))
        r.includes(s) || r.push(s);
    return n.attributeValue = e, n.items = r, r;
  }
  /**
   * Returns DOMTokenList value.
   */
  toString() {
    return this.value || "";
  }
}
const Gn = {
  FILTER_ACCEPT: 1,
  FILTER_REJECT: 2,
  FILTER_SKIP: 3,
  SHOW_ALL: -1,
  SHOW_ELEMENT: 1,
  SHOW_ATTRIBUTE: 2,
  SHOW_TEXT: 4,
  SHOW_CDATA_SECTION: 8,
  SHOW_ENTITY_REFERENCE: 16,
  SHOW_ENTITY: 32,
  SHOW_PROCESSING_INSTRUCTION: 64,
  SHOW_COMMENT: 128,
  SHOW_DOCUMENT: 256,
  SHOW_DOCUMENT_TYPE: 512,
  SHOW_DOCUMENT_FRAGMENT: 1024,
  SHOW_NOTATION: 2048
}, C$e = {
  /* ELEMENT_NODE */
  1: Gn.SHOW_ELEMENT,
  /* ATTRIBUTE_NODE */
  2: Gn.SHOW_ATTRIBUTE,
  /* TEXT_NODE */
  3: Gn.SHOW_TEXT,
  /* CDATA_SECTION_NODE */
  4: Gn.SHOW_CDATA_SECTION,
  /* ENTITY_REFERENCE_NODE */
  5: Gn.SHOW_ENTITY_REFERENCE,
  /* ENTITY_NODE */
  6: Gn.SHOW_PROCESSING_INSTRUCTION,
  /* PROCESSING_INSTRUCTION_NODE */
  7: Gn.SHOW_PROCESSING_INSTRUCTION,
  /* COMMENT_NODE */
  8: Gn.SHOW_COMMENT,
  /* DOCUMENT_NODE */
  9: Gn.SHOW_DOCUMENT,
  /* DOCUMENT_TYPE_NODE */
  10: Gn.SHOW_DOCUMENT_TYPE,
  /* DOCUMENT_FRAGMENT_NODE */
  11: Gn.SHOW_DOCUMENT_FRAGMENT,
  /* NOTATION_NODE */
  12: Gn.SHOW_NOTATION
};
var nh;
(function(t) {
  t.first = "first", t.last = "last";
})(nh || (nh = {}));
var rh;
(function(t) {
  t.next = "next", t.previous = "previous";
})(rh || (rh = {}));
class V2 {
  root;
  whatToShow = -1;
  filter = null;
  #e = null;
  /**
   * Constructor.
   *
   * @param root Root.
   * @param [whatToShow] What to show.
   * @param [filter] Filter.
   */
  constructor(e, n = -1, r = null) {
    if (!(e instanceof ot))
      throw new Tr("Parameter 1 was not of type Node.");
    this.root = e, this.whatToShow = n, this.filter = r, this.#e = e;
  }
  /**
   * Returns the current Node.
   *
   * @returns Current node.
   */
  get currentNode() {
    return this.#e;
  }
  /**
   * Sets the current Node.
   *
   * @param node Node.
   */
  set currentNode(e) {
    if (!(e instanceof ot))
      throw new this.root[b].TypeError("Failed to set the 'currentNode' property on 'TreeWalker': Failed to convert value to 'Node'.");
    this.#e = e;
  }
  /**
   * Moves the current Node to the first visible ancestor node in the document order, and returns the found node. It also moves the current node to this one. If no such node exists, or if it is before that the root node defined at the object construction, returns null and the current node is not changed.
   *
   * @returns Current node.
   */
  parentNode() {
    let e = this.#e;
    for (; e !== null && e !== this.root; )
      if (e = e.parentNode, e !== null && this[ao](e) === Gn.FILTER_ACCEPT)
        return this.#e = e, this.#e;
    return null;
  }
  /**
   * Moves the current Node to the first visible child of the current node, and returns the found child. It also moves the current node to this child. If no such child exists, returns null and the current node is not changed.
   *
   * @returns Current node.
   */
  firstChild() {
    return this.#t(nh.first);
  }
  /**
   * Moves the current Node to the last visible child of the current node, and returns the found child. It also moves the current node to this child. If no such child exists, null is returned and the current node is not changed.
   *
   * @returns Current node.
   */
  lastChild() {
    return this.#t(nh.last);
  }
  /**
   * Moves the current Node to its next sibling, if any, and returns the found sibling. If there is no such node, null is returned and the current node is not changed.
   *
   * @returns Current node.
   */
  nextSibling() {
    return this.#n(rh.next);
  }
  /**
   * Moves the current Node to its previous sibling, if any, and returns the found sibling. If there is no such node, return null and the current node is not changed.
   *
   * @returns Current node.
   */
  previousSibling() {
    return this.#n(rh.previous);
  }
  /**
   * Moves the current Node to the previous visible node in the document order, and returns the found node. It also moves the current node to this one. If no such node exists, or if it is before that the root node defined at the object construction, returns null and the current node is not changed.
   *
   * @returns Current node.
   */
  previousNode() {
    let e = this.#e;
    for (; e !== this.root; ) {
      let n = e?.previousSibling || null;
      for (; n !== null; ) {
        let r = n, i = this[ao](r);
        for (; i !== Gn.FILTER_REJECT && r[Re].length; )
          r = r.lastChild, i = this[ao](r);
        if (i === Gn.FILTER_ACCEPT)
          return this.#e = r, r;
        n = r.previousSibling;
      }
      if (e === this.root || e.parentNode === null)
        return null;
      if (e = e.parentNode, this[ao](e) === Gn.FILTER_ACCEPT)
        return this.#e = e, e;
    }
    return null;
  }
  /**
   * Moves the current Node to the next visible node in the document order.
   *
   * @returns Current node.
   */
  nextNode() {
    let e = this.#e, n = Gn.FILTER_ACCEPT;
    if (e === null)
      return null;
    for (; ; ) {
      for (; n !== Gn.FILTER_REJECT && e[Re].length; )
        if (e = e.firstChild, n = this[ao](e), n === Gn.FILTER_ACCEPT)
          return this.#e = e, e;
      for (; e !== null; ) {
        if (e === this.root)
          return null;
        const r = e.nextSibling;
        if (r !== null) {
          e = r;
          break;
        }
        e = e.parentNode;
      }
      if (e === null)
        return null;
      if (n = this[ao](e), n === Gn.FILTER_ACCEPT)
        return this.#e = e, e;
    }
  }
  /**
   * Filters a node.
   *
   * Based on solution:
   * https://gist.github.com/shawndumas/1132009.
   *
   * @param node Node.
   * @returns Child nodes.
   */
  [ao](e) {
    const n = C$e[e.nodeType];
    return n && (this.whatToShow & n) == 0 ? Gn.FILTER_SKIP : typeof this.filter == "function" ? this.filter(e) : this.filter ? this.filter.acceptNode(e) : Gn.FILTER_ACCEPT;
  }
  /**
   * Traverses children.
   *
   * @param type Type.
   * @returns Node.
   */
  #t(e) {
    let n = this.#e;
    if (!n)
      return null;
    for (n = e === nh.first ? n.firstChild : n.lastChild; n !== null; ) {
      const r = this[ao](n);
      if (r === Gn.FILTER_ACCEPT)
        return this.#e = n, n;
      if (r === Gn.FILTER_SKIP) {
        const i = e === nh.first ? n.firstChild : n.lastChild;
        if (i !== null) {
          n = i;
          continue;
        }
      }
      for (; n !== null; ) {
        const i = e === nh.first ? n.nextSibling : n.previousSibling;
        if (i !== null) {
          n = i;
          break;
        }
        const s = n.parentNode;
        if (s === null || s === this.root || s === this.#e)
          return null;
        n = s;
      }
    }
    return null;
  }
  /**
   * Traverses siblings.
   *
   * @param type Type.
   * @returns Node.
   */
  #n(e) {
    let n = this.#e;
    if (!n || n === this.root)
      return null;
    for (; ; ) {
      let r = e === rh.next ? n.nextSibling : n.previousSibling;
      for (; r !== null; ) {
        const i = r, s = this[ao](i);
        if (s === Gn.FILTER_ACCEPT)
          return this.#e = i, i;
        r = e === rh.next ? i.firstChild : i.lastChild, (s === Gn.FILTER_REJECT || r === null) && (r = e === rh.next ? i.nextSibling : i.previousSibling);
      }
      if (n = n.parentNode, n === null || n === this.root || this[ao](n) === Gn.FILTER_ACCEPT)
        return null;
    }
  }
}
class lW {
  #e;
  #t = -1;
  #n = null;
  #r;
  #i = !0;
  /**
   * Constructor.
   *
   * @param root Root.
   * @param [whatToShow] What to show.
   * @param [filter] Filter.
   */
  constructor(e, n = -1, r = null) {
    this.#e = e, this.#t = n, this.#n = r, this.#r = new V2(e, n, r);
  }
  /**
   * Returns root.
   *
   * @returns Root.
   */
  get root() {
    return this.#e;
  }
  /**
   * Returns what to show.
   *
   * @returns What to show.
   */
  get whatToShow() {
    return this.#t;
  }
  /**
   * Returns filter.
   *
   * @returns Filter.
   */
  get filter() {
    return this.#n;
  }
  /**
   * Moves the current Node to the next visible node in the document order.
   *
   * @returns Current node.
   */
  nextNode() {
    return this.#i ? (this.#i = !1, this.#r[ao](this.#e) !== Gn.FILTER_ACCEPT ? this.#r.nextNode() : this.#e) : this.#r.nextNode();
  }
  /**
   * Moves the current Node to the previous visible node in the document order, and returns the found node. It also moves the current node to this one. If no such node exists, or if it is before that the root node defined at the object construction, returns null and the current node is not changed.
   *
   * @returns Current node.
   */
  previousNode() {
    return this.#r.previousNode();
  }
}
class k$e {
  #e;
  /**
   * Constructor.
   *
   * @param document Document.
   */
  constructor(e) {
    this.#e = e;
  }
  /**
   * Creates and returns an XML Document.
   *
   * TODO: Not fully implemented.
   *
   * @param _namespaceURI Namespace URI.
   * @param _qualifiedName Qualified name.
   * @param [_docType] Document type.
   */
  createDocument(e, n, r) {
    return new this.#e[b].HTMLDocument();
  }
  /**
   * Creates and returns an HTML Document.
   */
  createHTMLDocument() {
    return new this.#e[b].HTMLDocument();
  }
  /**
   * Creates and returns an HTML Document.
   *
   * @param qualifiedName Qualified name.
   * @param publicId Public ID.
   * @param systemId System ID.
   */
  createDocumentType(e, n, r) {
    const i = Gi.createNode(this.#e, W2);
    return i[tt] = e, i[Id] = n, i[Rd] = r, i;
  }
}
class mi {
  [cd];
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param query Query function.
   */
  constructor(e, n) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[cd] = n;
    const r = new Ws(this, this.constructor !== mi ? [this.constructor, mi] : [mi]);
    return new Proxy(this, {
      get: (i, s) => {
        if (s === "length")
          return n().length;
        if (s in i || typeof s == "symbol")
          return r.bind(s), i[s];
        const a = Number(s);
        return isNaN(a) ? i.namedItem(s) || void 0 : n()[a];
      },
      set(i, s, a) {
        if (r.bind(s), typeof s == "symbol")
          return i[s] = a, !0;
        const o = Number(s);
        return isNaN(o) && (i[s] = a), !0;
      },
      deleteProperty(i, s) {
        if (typeof s == "symbol")
          return delete i[s], !0;
        const a = Number(s);
        return isNaN(a) && delete i[s], !0;
      },
      ownKeys() {
        const i = [], s = n();
        for (let a = 0; a < s.length; a++) {
          const o = s[a], u = o.getAttribute("id") || o.getAttribute("name");
          i.push(String(a)), u && i.push(u);
        }
        return i;
      },
      has(i, s) {
        if (s in i)
          return !0;
        const a = n(), o = Number(s);
        if (!isNaN(o) && o >= 0 && o < a.length)
          return !0;
        s = String(s);
        for (let u = 0; u < a.length; u++) {
          const l = a[u], h = l.getAttribute("id") || l.getAttribute("name");
          if (h && h === s)
            return !0;
        }
        return !1;
      },
      defineProperty(i, s, a) {
        return r.preventBinding(s), s in i ? (Object.defineProperty(i, s, a), !0) : !1;
      },
      getOwnPropertyDescriptor(i, s) {
        if (s in i || typeof s == "symbol")
          return;
        const a = n(), o = Number(s);
        if (!isNaN(o) && o >= 0 && o < a.length)
          return {
            value: a[o],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
        for (let u = 0; u < a.length; u++) {
          const l = a[u], h = l.getAttribute("id") || l.getAttribute("name");
          if (h && h === s)
            return {
              value: l,
              writable: !1,
              enumerable: !0,
              configurable: !0
            };
        }
      }
    });
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[cd]().length;
  }
  /**
   * Returns `Symbol.toStringTag`.
   *
   * @returns `Symbol.toStringTag`.
   */
  get [Symbol.toStringTag]() {
    return this.constructor.name;
  }
  /**
   * Returns `[object HTMLCollection]`.
   *
   * @returns `[object HTMLCollection]`.
   */
  toLocaleString() {
    return `[object ${this.constructor.name}]`;
  }
  /**
   * Returns `[object HTMLCollection]`.
   *
   * @returns `[object HTMLCollection]`.
   */
  toString() {
    return `[object ${this.constructor.name}]`;
  }
  /**
   * Returns item by index.
   *
   * @param index Index.
   */
  item(e) {
    const n = this[cd]();
    return e >= 0 && n[e] ? n[e] : null;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  [Symbol.iterator]() {
    return this[cd]()[Symbol.iterator]();
  }
  /**
   * Returns named item.
   *
   * @param name Name.
   * @returns Node.
   */
  namedItem(e) {
    const n = this[cd]();
    e = String(e);
    for (const r of n)
      if (r.getAttribute("id") === e || r.getAttribute("name") === e)
        return r;
    return null;
  }
}
class Un {
  /**
   * Compares boundary points.
   *
   * Based on logic from:
   * https://github.com/jsdom/jsdom/blob/master/lib/jsdom/living/range/boundary-point.js
   *
   * @see https://dom.spec.whatwg.org/#concept-range-bp-after
   * @param pointA Point A.
   * @param pointB Point B.
   * @returns A number, -1, 0, or 1, indicating whether the corresponding boundary-point of the Range is respectively before, equal to, or after the corresponding boundary-point of sourceRange.
   */
  static compareBoundaryPointsPosition(e, n) {
    if (e.node === n.node)
      return e.offset === n.offset ? 0 : e.offset < n.offset ? -1 : 1;
    if (dt.isFollowing(e.node, n.node))
      return this.compareBoundaryPointsPosition(n, e) === -1 ? 1 : -1;
    if (dt.isInclusiveAncestor(e.node, n.node)) {
      let r = n.node;
      for (; r[xe] !== e.node; )
        r = r[xe];
      if (r[xe][Re].indexOf(r) < e.offset)
        return 1;
    }
    return -1;
  }
  /**
   * Validates a boundary point.
   *
   * @throws DOMException
   * @param point Boundary point.
   */
  static validateBoundaryPoint(e) {
    if (e.node[ve] === le.documentTypeNode)
      throw new Tr("DocumentType Node can't be used as boundary point.", ne.invalidNodeTypeError);
    if (e.offset > dt.getNodeLength(e.node))
      throw new Tr("Offset out of bound.", ne.indexSizeError);
  }
  /**
   * Returns "true" if contained.
   *
   * @param node Node.
   * @param range Range.
   * @returns "true" if contained.
   */
  static isContained(e, n) {
    return this.compareBoundaryPointsPosition({ node: e, offset: 0 }, { node: n.startContainer, offset: n.startOffset }) === 1 && this.compareBoundaryPointsPosition({ node: e, offset: dt.getNodeLength(e) }, { node: n.endContainer, offset: n.endOffset }) === -1;
  }
  /**
   * Returns "true" if partially contained.
   *
   * @param node Node.
   * @param range Range.
   * @returns "true" if partially contained.
   */
  static isPartiallyContained(e, n) {
    return dt.isInclusiveAncestor(e, n.startContainer) && !dt.isInclusiveAncestor(e, n.endContainer) || !dt.isInclusiveAncestor(e, n.startContainer) && dt.isInclusiveAncestor(e, n.endContainer);
  }
}
var Xv;
(function(t) {
  t[t.forwards = 1] = "forwards", t[t.backwards = -1] = "backwards", t[t.directionless = 0] = "directionless";
})(Xv || (Xv = {}));
const so = Xv;
class cW {
  #e;
  #t = null;
  #n = so.directionless;
  /**
   * Constructor.
   *
   * @param ownerDocument Owner document.
   */
  constructor(e) {
    this.#e = e;
  }
  /**
   * Returns range count.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-rangecount
   * @returns Range count.
   */
  get rangeCount() {
    return this.#t ? 1 : 0;
  }
  /**
   * Returns collapsed state.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-iscollapsed
   * @returns "true" if collapsed.
   */
  get isCollapsed() {
    return this.#t === null || this.#t.collapsed;
  }
  /**
   * Returns type.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-type
   * @returns Type.
   */
  get type() {
    if (this.#t) {
      if (this.#t.collapsed)
        return "Caret";
    } else return "None";
    return "Range";
  }
  /**
   * Returns anchor node.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-anchornode
   * @returns Node.
   */
  get anchorNode() {
    return this.#t ? this.#n === so.forwards ? this.#t.startContainer : this.#t.endContainer : null;
  }
  /**
   * Returns anchor offset.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-anchoroffset
   * @returns Node.
   */
  get anchorOffset() {
    return this.#t ? this.#n === so.forwards ? this.#t.startOffset : this.#t.endOffset : 0;
  }
  /**
   * Returns anchor node.
   *
   * @deprecated
   * @alias anchorNode
   * @returns Node.
   */
  get baseNode() {
    return this.anchorNode;
  }
  /**
   * Returns anchor offset.
   *
   * @deprecated
   * @alias anchorOffset
   * @returns Node.
   */
  get baseOffset() {
    return this.anchorOffset;
  }
  /**
   * Returns focus node.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-focusnode
   * @returns Node.
   */
  get focusNode() {
    return this.#t ? this.#n === so.forwards ? this.#t.endContainer : this.#t.startContainer : null;
  }
  /**
   * Returns focus offset.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-focusoffset
   * @returns Node.
   */
  get focusOffset() {
    return this.#t ? this.#n === so.forwards ? this.#t.endOffset : this.#t.startOffset : 0;
  }
  /**
   * Returns focus node.
   *
   * @deprecated
   * @alias focusNode
   * @returns Node.
   */
  get extentNode() {
    return this.focusNode;
  }
  /**
   * Returns focus offset.
   *
   * @deprecated
   * @alias focusOffset
   * @returns Node.
   */
  get extentOffset() {
    return this.focusOffset;
  }
  /**
   * Adds a range.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-addrange
   * @param newRange Range.
   */
  addRange(e) {
    if (!e)
      throw new this.#e[b].TypeError("Failed to execute addRange on Selection. Parameter 1 is not of type Range.");
    !this.#t && e[he] === this.#e && this.#r(e);
  }
  /**
   * Returns Range.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-getrangeat
   * @param index Index.
   * @returns Range.
   */
  getRangeAt(e) {
    if (!this.#t || e !== 0)
      throw new this.#e[b].DOMException("Invalid range index.", ne.indexSizeError);
    return this.#t;
  }
  /**
   * Removes a range from a selection.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-removerange
   * @param range Range.
   */
  removeRange(e) {
    if (this.#t !== e)
      throw new this.#e[b].DOMException("Invalid range.", ne.notFoundError);
    this.#r(null);
  }
  /**
   * Removes all ranges.
   */
  removeAllRanges() {
    this.#r(null);
  }
  /**
   * Removes all ranges.
   *
   * @alias removeAllRanges()
   */
  empty() {
    this.removeAllRanges();
  }
  /**
   * Collapses the current selection to a single point.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-collapse
   * @param node Node.
   * @param offset Offset.
   */
  collapse(e, n) {
    if (e === null) {
      this.removeAllRanges();
      return;
    }
    if (e[ve] === le.documentTypeNode)
      throw new this.#e[b].DOMException("DocumentType Node can't be used as boundary point.", ne.invalidNodeTypeError);
    if (n > dt.getNodeLength(e))
      throw new this.#e[b].DOMException("Invalid range index.", ne.indexSizeError);
    if (e !== this.#e && e[he] !== this.#e)
      return;
    const r = new this.#e[b].Range();
    r[fe].node = e, r[fe].offset = n, r[_e].node = e, r[_e].offset = n, this.#r(r);
  }
  /**
   * Collapses the current selection to a single point.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-setposition
   * @alias collapse()
   * @param node Node.
   * @param offset Offset.
   */
  setPosition(e, n) {
    this.collapse(e, n);
  }
  /**
   * Collapses the selection to the end.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-collapsetoend
   */
  collapseToEnd() {
    if (this.#t === null)
      throw new this.#e[b].DOMException("There is no selection to collapse.", ne.invalidStateError);
    const { node: e, offset: n } = this.#t[_e], r = new this.#e[b].Range();
    r[fe].node = e, r[fe].offset = n, r[_e].node = e, r[_e].offset = n, this.#r(r);
  }
  /**
   * Collapses the selection to the start.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-collapsetostart
   */
  collapseToStart() {
    if (!this.#t)
      throw new this.#e[b].DOMException("There is no selection to collapse.", ne.invalidStateError);
    const { node: e, offset: n } = this.#t[fe], r = new this.#e[b].Range();
    r[fe].node = e, r[fe].offset = n, r[_e].node = e, r[_e].offset = n, this.#r(r);
  }
  /**
   * Indicates whether a specified node is part of the selection.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-containsnode
   * @param node Node.
   * @param [allowPartialContainment] Set to "true" to allow partial containment.
   * @returns Always returns "true" for now.
   */
  containsNode(e, n = !1) {
    if (!this.#t || e[he] !== this.#e)
      return !1;
    const r = Un.compareBoundaryPointsPosition(this.#t[fe], {
      node: e,
      offset: 0
    }) === -1, i = Un.compareBoundaryPointsPosition(this.#t[_e], {
      node: e,
      offset: dt.getNodeLength(e)
    }) === 1;
    return n ? r || i : r && i;
  }
  /**
   * Deletes the selected text from the document's DOM.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-deletefromdocument
   */
  deleteFromDocument() {
    this.#t && this.#t.deleteContents();
  }
  /**
   * Moves the focus of the selection to a specified point.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-extend
   * @param node Node.
   * @param offset Offset.
   */
  extend(e, n) {
    if (e !== this.#e && e[he] !== this.#e)
      return;
    if (!this.#t)
      throw new this.#e[b].DOMException("There is no selection to extend.", ne.invalidStateError);
    const r = this.anchorNode, i = this.anchorOffset, s = new this.#e[b].Range();
    s[fe].node = e, s[fe].offset = 0, s[_e].node = e, s[_e].offset = 0, e[he] !== this.#t[he] ? (s[fe].offset = n, s[_e].offset = n) : Un.compareBoundaryPointsPosition({ node: r, offset: i }, { node: e, offset: n }) <= 0 ? (s[fe].node = r, s[fe].offset = i, s[_e].node = e, s[_e].offset = n) : (s[fe].node = e, s[fe].offset = n, s[_e].node = r, s[_e].offset = i), this.#r(s), this.#n = Un.compareBoundaryPointsPosition({ node: e, offset: n }, { node: r, offset: i }) === -1 ? so.backwards : so.forwards;
  }
  /**
   * Selects all children.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-selectallchildren
   * @param node Node.
   */
  selectAllChildren(e) {
    if (e[ve] === le.documentTypeNode)
      throw new this.#e[b].DOMException("DocumentType Node can't be used as boundary point.", ne.invalidNodeTypeError);
    if (e !== this.#e && e[he] !== this.#e)
      return;
    const n = e[Re].length, r = new this.#e[b].Range();
    r[fe].node = e, r[fe].offset = 0, r[_e].node = e, r[_e].offset = n, this.#r(r);
  }
  /**
   * Sets the selection to be a range including all or parts of two specified DOM nodes, and any content located between them.
   *
   * @see https://w3c.github.io/selection-api/#dom-selection-setbaseandextent
   * @param anchorNode Anchor node.
   * @param anchorOffset Anchor offset.
   * @param focusNode Focus node.
   * @param focusOffset Focus offset.
   */
  setBaseAndExtent(e, n, r, i) {
    if (n > dt.getNodeLength(e) || i > dt.getNodeLength(r))
      throw new this.#e[b].DOMException("Invalid anchor or focus offset.", ne.indexSizeError);
    if (e !== this.#e && e[he] !== this.#e || r !== this.#e && r[he] !== this.#e)
      return;
    const s = { node: e, offset: n }, a = { node: r, offset: i }, o = new this.#e[b].Range();
    Un.compareBoundaryPointsPosition(s, a) === -1 ? (o[fe] = s, o[_e] = a) : (o[fe] = a, o[_e] = s), this.#r(o), this.#n = Un.compareBoundaryPointsPosition(a, s) === -1 ? so.backwards : so.forwards;
  }
  /**
   * Returns string currently being represented by the selection object.
   *
   * @returns Selection as string.
   */
  toString() {
    return this.#t ? this.#t.toString() : "";
  }
  /**
   * Sets the current range.
   *
   * @param range Range.
   */
  #r(e) {
    const n = this.#t;
    this.#t = e, this.#n = e === null ? so.directionless : so.forwards, n !== this.#t && this.#e.dispatchEvent(new be("selectionchange"));
  }
}
var Zv;
(function(t) {
  t.hidden = "hidden", t.visible = "visible", t.prerender = "prerender";
})(Zv || (Zv = {}));
const JL = Zv;
var ex;
(function(t) {
  t.rawText = "rawText", t.noSelfDescendants = "noSelfDescendants", t.noFirstLevelSelfDescendants = "noFirstLevelSelfDescendants", t.noForbiddenFirstLevelDescendants = "noForbiddenFirstLevelDescendants", t.noDescendants = "noDescendants", t.permittedDescendants = "permittedDescendants", t.textOrComments = "textOrComments", t.anyDescendants = "anyDescendants";
})(ex || (ex = {}));
const pe = ex, Si = {
  a: {
    className: "HTMLAnchorElement",
    contentModel: pe.noSelfDescendants
  },
  abbr: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  address: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  area: {
    className: "HTMLAreaElement",
    contentModel: pe.noDescendants
  },
  article: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  aside: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  audio: {
    className: "HTMLAudioElement",
    contentModel: pe.anyDescendants
  },
  b: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  base: {
    className: "HTMLBaseElement",
    contentModel: pe.noDescendants
  },
  bdi: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  bdo: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  body: {
    className: "HTMLBodyElement",
    contentModel: pe.anyDescendants
  },
  template: {
    className: "HTMLTemplateElement",
    contentModel: pe.anyDescendants
  },
  form: {
    className: "HTMLFormElement",
    contentModel: pe.anyDescendants
  },
  input: {
    className: "HTMLInputElement",
    contentModel: pe.noDescendants
  },
  textarea: {
    className: "HTMLTextAreaElement",
    contentModel: pe.anyDescendants
  },
  script: {
    className: "HTMLScriptElement",
    contentModel: pe.rawText
  },
  img: {
    className: "HTMLImageElement",
    contentModel: pe.noDescendants
  },
  link: {
    className: "HTMLLinkElement",
    contentModel: pe.noDescendants
  },
  style: {
    className: "HTMLStyleElement",
    contentModel: pe.rawText
  },
  label: {
    className: "HTMLLabelElement",
    contentModel: pe.anyDescendants
  },
  slot: {
    className: "HTMLSlotElement",
    contentModel: pe.anyDescendants
  },
  meta: {
    className: "HTMLMetaElement",
    contentModel: pe.noDescendants
  },
  blockquote: {
    className: "HTMLQuoteElement",
    contentModel: pe.anyDescendants
  },
  br: {
    className: "HTMLBRElement",
    contentModel: pe.noDescendants
  },
  button: {
    className: "HTMLButtonElement",
    contentModel: pe.anyDescendants
  },
  canvas: {
    className: "HTMLCanvasElement",
    contentModel: pe.anyDescendants
  },
  caption: {
    className: "HTMLTableCaptionElement",
    contentModel: pe.textOrComments
  },
  cite: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  code: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  col: {
    className: "HTMLTableColElement",
    contentModel: pe.noDescendants,
    permittedParents: ["colgroup"]
  },
  colgroup: {
    className: "HTMLTableColElement",
    contentModel: pe.permittedDescendants,
    permittedDescendants: ["col"]
  },
  data: {
    className: "HTMLDataElement",
    contentModel: pe.anyDescendants
  },
  datalist: {
    className: "HTMLDataListElement",
    contentModel: pe.anyDescendants
  },
  dd: {
    className: "HTMLElement",
    contentModel: pe.noForbiddenFirstLevelDescendants,
    forbiddenDescendants: ["dt", "dd"]
  },
  del: {
    className: "HTMLModElement",
    contentModel: pe.anyDescendants
  },
  details: {
    className: "HTMLDetailsElement",
    contentModel: pe.anyDescendants
  },
  dfn: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  dialog: {
    className: "HTMLDialogElement",
    contentModel: pe.anyDescendants
  },
  div: {
    className: "HTMLDivElement",
    contentModel: pe.anyDescendants
  },
  dl: {
    className: "HTMLDListElement",
    contentModel: pe.anyDescendants
  },
  dt: {
    className: "HTMLElement",
    contentModel: pe.noForbiddenFirstLevelDescendants,
    forbiddenDescendants: ["dt", "dd"]
  },
  em: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  embed: {
    className: "HTMLEmbedElement",
    contentModel: pe.noDescendants
  },
  fieldset: {
    className: "HTMLFieldSetElement",
    contentModel: pe.anyDescendants
  },
  figcaption: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  figure: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  footer: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  h1: {
    className: "HTMLHeadingElement",
    contentModel: pe.noFirstLevelSelfDescendants
  },
  h2: {
    className: "HTMLHeadingElement",
    contentModel: pe.noFirstLevelSelfDescendants
  },
  h3: {
    className: "HTMLHeadingElement",
    contentModel: pe.noFirstLevelSelfDescendants
  },
  h4: {
    className: "HTMLHeadingElement",
    contentModel: pe.noFirstLevelSelfDescendants
  },
  h5: {
    className: "HTMLHeadingElement",
    contentModel: pe.noFirstLevelSelfDescendants
  },
  h6: {
    className: "HTMLHeadingElement",
    contentModel: pe.noFirstLevelSelfDescendants
  },
  head: {
    className: "HTMLHeadElement",
    contentModel: pe.anyDescendants
  },
  header: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  hgroup: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  hr: {
    className: "HTMLHRElement",
    contentModel: pe.noDescendants
  },
  html: {
    className: "HTMLHtmlElement",
    contentModel: pe.anyDescendants
  },
  i: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  iframe: {
    className: "HTMLIFrameElement",
    contentModel: pe.anyDescendants
  },
  ins: {
    className: "HTMLModElement",
    contentModel: pe.anyDescendants
  },
  kbd: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  legend: {
    className: "HTMLLegendElement",
    contentModel: pe.anyDescendants
  },
  li: {
    className: "HTMLLIElement",
    contentModel: pe.noFirstLevelSelfDescendants
  },
  main: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  map: {
    className: "HTMLMapElement",
    contentModel: pe.anyDescendants
  },
  mark: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  menu: {
    className: "HTMLMenuElement",
    contentModel: pe.anyDescendants
  },
  meter: {
    className: "HTMLMeterElement",
    contentModel: pe.anyDescendants
  },
  nav: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  noscript: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  object: {
    className: "HTMLObjectElement",
    contentModel: pe.anyDescendants
  },
  ol: {
    className: "HTMLOListElement",
    contentModel: pe.anyDescendants
  },
  optgroup: {
    className: "HTMLOptGroupElement",
    contentModel: pe.noFirstLevelSelfDescendants
  },
  option: {
    className: "HTMLOptionElement",
    contentModel: pe.noForbiddenFirstLevelDescendants,
    forbiddenDescendants: ["option", "optgroup"]
  },
  output: {
    className: "HTMLOutputElement",
    contentModel: pe.anyDescendants
  },
  p: {
    className: "HTMLParagraphElement",
    contentModel: pe.noForbiddenFirstLevelDescendants,
    forbiddenDescendants: [
      "address",
      "article",
      "aside",
      "blockquote",
      "details",
      "dialog",
      "div",
      "dl",
      "fieldset",
      "figcaption",
      "figure",
      "footer",
      "form",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "header",
      "hgroup",
      "hr",
      "main",
      "menu",
      "nav",
      "ol",
      "p",
      "pre",
      "section",
      "table",
      "ul"
    ]
  },
  param: {
    className: "HTMLParamElement",
    contentModel: pe.noDescendants
  },
  picture: {
    className: "HTMLPictureElement",
    contentModel: pe.anyDescendants
  },
  pre: {
    className: "HTMLPreElement",
    contentModel: pe.anyDescendants
  },
  progress: {
    className: "HTMLProgressElement",
    contentModel: pe.anyDescendants
  },
  q: {
    className: "HTMLQuoteElement",
    contentModel: pe.anyDescendants
  },
  rb: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  rp: {
    className: "HTMLElement",
    contentModel: pe.noForbiddenFirstLevelDescendants,
    forbiddenDescendants: ["rp", "rt"]
  },
  rt: {
    className: "HTMLElement",
    contentModel: pe.noForbiddenFirstLevelDescendants,
    forbiddenDescendants: ["rp", "rt"]
  },
  rtc: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  ruby: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  s: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  samp: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  section: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  select: {
    className: "HTMLSelectElement",
    contentModel: pe.anyDescendants
  },
  small: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  source: {
    className: "HTMLSourceElement",
    contentModel: pe.noDescendants
  },
  span: {
    className: "HTMLSpanElement",
    contentModel: pe.anyDescendants
  },
  strong: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  sub: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  summary: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  sup: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  table: {
    className: "HTMLTableElement",
    contentModel: pe.permittedDescendants,
    permittedDescendants: ["caption", "colgroup", "thead", "tfoot", "tbody"],
    moveForbiddenDescendant: { exclude: [] }
  },
  tbody: {
    className: "HTMLTableSectionElement",
    contentModel: pe.permittedDescendants,
    permittedDescendants: ["tr"],
    permittedParents: ["table"],
    moveForbiddenDescendant: { exclude: ["caption", "colgroup", "thead", "tfoot", "tbody"] }
  },
  td: {
    className: "HTMLTableCellElement",
    contentModel: pe.noForbiddenFirstLevelDescendants,
    forbiddenDescendants: ["td", "th", "tr", "tbody", "tfoot", "thead"],
    permittedParents: ["tr"]
  },
  tfoot: {
    className: "HTMLTableSectionElement",
    contentModel: pe.permittedDescendants,
    permittedDescendants: ["tr"],
    permittedParents: ["table"],
    moveForbiddenDescendant: { exclude: ["caption", "colgroup", "thead", "tfoot", "tbody"] }
  },
  th: {
    className: "HTMLTableCellElement",
    contentModel: pe.noForbiddenFirstLevelDescendants,
    forbiddenDescendants: ["td", "th", "tr", "tbody", "tfoot", "thead"],
    permittedParents: ["tr"]
  },
  thead: {
    className: "HTMLTableSectionElement",
    contentModel: pe.permittedDescendants,
    permittedDescendants: ["tr"],
    permittedParents: ["table"],
    moveForbiddenDescendant: { exclude: ["caption", "colgroup", "thead", "tfoot", "tbody"] }
  },
  time: {
    className: "HTMLTimeElement",
    contentModel: pe.anyDescendants
  },
  title: {
    className: "HTMLTitleElement",
    contentModel: pe.anyDescendants
  },
  tr: {
    className: "HTMLTableRowElement",
    contentModel: pe.permittedDescendants,
    permittedDescendants: ["td", "th"],
    permittedParents: ["tbody", "tfoot", "thead"],
    addPermittedParent: "tbody",
    moveForbiddenDescendant: { exclude: ["caption", "colgroup", "thead", "tfoot", "tbody", "tr"] }
  },
  track: {
    className: "HTMLTrackElement",
    contentModel: pe.noDescendants
  },
  u: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  ul: {
    className: "HTMLUListElement",
    contentModel: pe.anyDescendants
  },
  var: {
    className: "HTMLElement",
    contentModel: pe.anyDescendants
  },
  video: {
    className: "HTMLVideoElement",
    contentModel: pe.anyDescendants
  },
  wbr: {
    className: "HTMLElement",
    contentModel: pe.noDescendants
  }
}, tx = {
  svg: { localName: "svg", className: "SVGSVGElement" },
  animate: { localName: "animate", className: "SVGAnimateElement" },
  animatemotion: { localName: "animateMotion", className: "SVGAnimateMotionElement" },
  animatetransform: { localName: "animateTransform", className: "SVGAnimateTransformElement" },
  circle: { localName: "circle", className: "SVGCircleElement" },
  clippath: { localName: "clipPath", className: "SVGClipPathElement" },
  defs: { localName: "defs", className: "SVGDefsElement" },
  desc: { localName: "desc", className: "SVGDescElement" },
  ellipse: { localName: "ellipse", className: "SVGEllipseElement" },
  feblend: { localName: "feBlend", className: "SVGFEBlendElement" },
  fecolormatrix: { localName: "feColorMatrix", className: "SVGFEColorMatrixElement" },
  fecomponenttransfer: {
    localName: "feComponentTransfer",
    className: "SVGFEComponentTransferElement"
  },
  fecomposite: { localName: "feComposite", className: "SVGFECompositeElement" },
  feconvolvematrix: { localName: "feConvolveMatrix", className: "SVGFEConvolveMatrixElement" },
  fediffuselighting: { localName: "feDiffuseLighting", className: "SVGFEDiffuseLightingElement" },
  fedisplacementmap: { localName: "feDisplacementMap", className: "SVGFEDisplacementMapElement" },
  fedistantlight: { localName: "feDistantLight", className: "SVGFEDistantLightElement" },
  fedropshadow: { localName: "feDropShadow", className: "SVGFEDropShadowElement" },
  feflood: { localName: "feFlood", className: "SVGFEFloodElement" },
  fefunca: { localName: "feFuncA", className: "SVGFEFuncAElement" },
  fefuncb: { localName: "feFuncB", className: "SVGFEFuncBElement" },
  fefuncg: { localName: "feFuncG", className: "SVGFEFuncGElement" },
  fefuncr: { localName: "feFuncR", className: "SVGFEFuncRElement" },
  fegaussianblur: { localName: "feGaussianBlur", className: "SVGFEGaussianBlurElement" },
  feimage: { localName: "feImage", className: "SVGFEImageElement" },
  femerge: { localName: "feMerge", className: "SVGFEMergeElement" },
  femergenode: { localName: "feMergeNode", className: "SVGFEMergeNodeElement" },
  femorphology: { localName: "feMorphology", className: "SVGFEMorphologyElement" },
  feoffset: { localName: "feOffset", className: "SVGFEOffsetElement" },
  fepointlight: { localName: "fePointLight", className: "SVGFEPointLightElement" },
  fespecularlighting: {
    localName: "feSpecularLighting",
    className: "SVGFESpecularLightingElement"
  },
  fespotlight: { localName: "feSpotLight", className: "SVGFESpotLightElement" },
  fetile: { localName: "feTile", className: "SVGFETileElement" },
  feturbulence: { localName: "feTurbulence", className: "SVGFETurbulenceElement" },
  filter: { localName: "filter", className: "SVGFilterElement" },
  foreignobject: { localName: "foreignObject", className: "SVGForeignObjectElement" },
  g: { localName: "g", className: "SVGGElement" },
  image: { localName: "image", className: "SVGImageElement" },
  line: { localName: "line", className: "SVGLineElement" },
  lineargradient: { localName: "linearGradient", className: "SVGLinearGradientElement" },
  marker: { localName: "marker", className: "SVGMarkerElement" },
  mask: { localName: "mask", className: "SVGMaskElement" },
  metadata: { localName: "metadata", className: "SVGMetadataElement" },
  mpath: { localName: "mpath", className: "SVGMPathElement" },
  path: { localName: "path", className: "SVGPathElement" },
  pattern: { localName: "pattern", className: "SVGPatternElement" },
  polygon: { localName: "polygon", className: "SVGPolygonElement" },
  polyline: { localName: "polyline", className: "SVGPolylineElement" },
  radialgradient: { localName: "radialGradient", className: "SVGRadialGradientElement" },
  rect: { localName: "rect", className: "SVGRectElement" },
  script: { localName: "script", className: "SVGScriptElement" },
  set: { localName: "set", className: "SVGSetElement" },
  stop: { localName: "stop", className: "SVGStopElement" },
  style: { localName: "style", className: "SVGStyleElement" },
  switch: { localName: "switch", className: "SVGSwitchElement" },
  symbol: { localName: "symbol", className: "SVGSymbolElement" },
  text: { localName: "text", className: "SVGTextElement" },
  textpath: { localName: "textPath", className: "SVGTextPathElement" },
  title: { localName: "title", className: "SVGTitleElement" },
  tspan: { localName: "tspan", className: "SVGTSpanElement" },
  use: { localName: "use", className: "SVGUseElement" },
  view: { localName: "view", className: "SVGViewElement" }
}, _$e = /[&"<>\t\n\r]/g, N$e = /[&"]/g, D$e = /[&\xA0<>]/g, I$e = /&(?:quot|lt|gt|amp|#x9|#xA|#xD);/g, R$e = /&(?:quot|amp);/g, P$e = /&(?:nbsp|lt|gt|amp);/g, L$e = /&(?:lt|gt|quot|apos|#(\d+)|#x([A-Fa-f\d]+)|amp);/g, M$e = {
  "&": "&amp;",
  '"': "&quot;",
  "<": "&lt;",
  ">": "&gt;",
  "	": "&#x9;",
  "\n": "&#xA;",
  "\r": "&#xD;"
}, O$e = {
  "&": "&amp;",
  '"': "&quot;"
}, B$e = {
  "&": "&amp;",
  " ": "&nbsp;",
  "<": "&lt;",
  ">": "&gt;"
}, $$e = {
  "&quot;": '"',
  "&lt;": "<",
  "&gt;": ">",
  "&#x9;": "	",
  "&#xA;": `
`,
  "&#xD;": "\r",
  "&amp;": "&"
}, H$e = {
  "&quot;": '"',
  "&amp;": "&"
}, U$e = {
  "&nbsp;": " ",
  "&lt;": "<",
  "&gt;": ">",
  "&amp;": "&"
}, G$e = {
  "&lt;": "<",
  "&gt;": ">",
  "&nbsp;": " ",
  "&quot;": '"',
  "&apos;": "'",
  "&amp;": "&"
};
class hi {
  /**
   * Encodes attribute value.
   *
   * @param value Value.
   * @returns Escaped value.
   */
  static encodeXMLAttributeValue(e) {
    return e === null ? "" : e.replace(_$e, (n) => M$e[n]);
  }
  /**
   * Decodes attribute value.
   *
   * @param value Value.
   * @returns Decoded value.
   */
  static decodeXMLAttributeValue(e) {
    return e === null ? "" : e.replace(I$e, (n) => $$e[n]);
  }
  /**
   * Encodes attribute value.
   *
   * @param value Value.
   * @returns Escaped value.
   */
  static encodeHTMLAttributeValue(e) {
    return e === null ? "" : e.replace(N$e, (n) => O$e[n]);
  }
  /**
   * Decodes attribute value.
   *
   * @param value Value.
   * @returns Decoded value.
   */
  static decodeHTMLAttributeValue(e) {
    return e === null ? "" : e.replace(R$e, (n) => H$e[n]);
  }
  /**
   * Encodes text content.
   *
   * @param text Value.
   * @returns Escaped value.
   */
  static encodeTextContent(e) {
    return e === null ? "" : e.replace(D$e, (n) => B$e[n]);
  }
  /**
   * Decodes text content.
   *
   * @param text Value.
   * @returns Decoded value.
   */
  static decodeTextContent(e) {
    return e === null ? "" : e.replace(P$e, (n) => U$e[n]);
  }
  /**
   * Decodes HTML entities.
   *
   * Uses the 'entities' library for comprehensive HTML5 named character reference support.
   *
   * @param value Value.
   * @returns Decoded value.
   */
  static decodeHTMLEntities(e) {
    return e === null ? "" : a4e(e);
  }
  /**
   * Decodes XML entities.
   *
   * @param value Value.
   * @returns Decoded value.
   */
  static decodeXMLEntities(e) {
    return e === null ? "" : e.replace(L$e, (n, r, i) => r !== void 0 ? String.fromCodePoint(parseInt(r, 10)) : i !== void 0 ? String.fromCodePoint(parseInt(i, 16)) : G$e[n]);
  }
}
const W$e = /<([^\s/!>?]+)|<\/([^\s/!>?]+)\s*>|(<!--)|(-->|--!>)|(<!)|(<\?)|(\/>)|(>)/gm, V$e = /\s*([a-zA-Z0-9-_:.$@?\\<\[\]]+)\s*=\s*([^"'=<>\\`\s]+)|\s*([a-zA-Z0-9-_:.$@?\\<\[\]]+)\s*=\s*"([^"]*)("{0,1})|\s*([a-zA-Z0-9-_:.$@?\\<\[\]]+)\s*=\s*'([^']*)('{0,1})|\s*([a-zA-Z0-9-_:.$@?\\<\[\]]+)/gm, K$e = /"([^"]+)"/gm, z$e = /\s+/, j$e = /^\s+/;
var Sr;
(function(t) {
  t.any = "any", t.startTag = "startTag", t.comment = "comment", t.documentType = "documentType", t.processingInstruction = "processingInstruction", t.rawTextElement = "rawTextElement";
})(Sr || (Sr = {}));
var Zn;
(function(t) {
  t[t.root = 0] = "root", t[t.doctype = 1] = "doctype", t[t.documentElement = 2] = "documentElement", t[t.head = 3] = "head", t[t.additionalHeadWithoutBody = 4] = "additionalHeadWithoutBody", t[t.body = 5] = "body", t[t.afterBody = 6] = "afterBody";
})(Zn || (Zn = {}));
class hu {
  window;
  evaluateScripts = !1;
  isTemplateDocumentFragment = !1;
  rootNode = null;
  rootDocument = null;
  nodeStack = [];
  tagNameStack = [];
  documentStructure = null;
  startTagIndex = 0;
  markupRegExp = null;
  nextElement = null;
  currentNode = null;
  readState = Sr.any;
  /**
   * Constructor.
   *
   * @param window Window.
   * @param [options] Options.
   * @param [options.evaluateScripts] Set to "true" to enable script execution
   * @param [options.isTemplateDocumentFragment] Set to "true" if parsing a template content fragment.
   */
  constructor(e, n) {
    this.window = e, n?.evaluateScripts && (this.evaluateScripts = !0), n?.isTemplateDocumentFragment && (this.isTemplateDocumentFragment = !0);
  }
  /**
   * Parses HTML a root element containing nodes found.
   *
   * @param html HTML string.
   * @param [rootNode] Root node.
   * @returns Root node.
   */
  parse(e, n) {
    if (this.rootNode = n || this.window.document.createDocumentFragment(), this.rootDocument = this.rootNode instanceof kf ? this.rootNode : this.window.document, this.nodeStack = [this.rootNode], this.tagNameStack = [null], this.currentNode = this.rootNode, this.readState = Sr.any, this.documentStructure = null, this.startTagIndex = 0, this.markupRegExp = new RegExp(W$e), this.rootNode instanceof kf) {
      const { doctype: s, documentElement: a, head: o, body: u } = this.rootNode;
      if (!a || !o || !u)
        throw new Error(`Failed to parse HTML: The root node must have "documentElement", "head" and "body".

We should not end up here and it is therefore a bug in Happy DOM. Please report this issue.`);
      this.documentStructure = {
        nodes: {
          doctype: s || null,
          documentElement: a,
          head: o,
          body: u
        },
        level: Zn.root
      };
    }
    if (this.rootNode instanceof this.window.HTMLHtmlElement) {
      const s = this.rootDocument.createElement("head"), a = this.rootDocument.createElement("body");
      for (; this.rootNode[Re].length > 0; )
        this.rootNode[Ms](this.rootNode[Re][this.rootNode[Re].length - 1]);
      this.rootNode[Ht](s), this.rootNode[Ht](a), this.documentStructure = {
        nodes: {
          doctype: null,
          documentElement: this.rootNode,
          head: s,
          body: a
        },
        level: Zn.documentElement
      };
    }
    let r, i = 0;
    for (e = String(e); r = this.markupRegExp.exec(e); ) {
      switch (this.readState) {
        case Sr.any:
          r.index !== i && (r[1] || r[2] || r[3] || r[4] || r[5] !== void 0 || r[6]) && this.parsePlainText(e.substring(i, r.index)), r[1] ? (this.nextElement = this.getStartTagElement(r[1]), this.startTagIndex = this.markupRegExp.lastIndex, this.readState = Sr.startTag) : r[2] ? this.parseEndTag(r[2]) : r[3] ? (this.startTagIndex = this.markupRegExp.lastIndex, this.readState = Sr.comment) : r[5] !== void 0 ? (this.startTagIndex = this.markupRegExp.lastIndex, this.readState = Sr.documentType) : r[6] ? (this.startTagIndex = this.markupRegExp.lastIndex, this.readState = Sr.processingInstruction) : this.parsePlainText(e.substring(i, this.markupRegExp.lastIndex));
          break;
        case Sr.startTag:
          if (r[7] || r[8] || r[2])
            if (this.nextElement) {
              const s = e.substring(this.startTagIndex, r[2] ? this.markupRegExp.lastIndex - 1 : r.index), a = !!r[7];
              this.parseEndOfStartTag(s, a);
            } else
              this.readState = Sr.any;
          break;
        case Sr.comment:
          r[4] && this.parseComment(e.substring(this.startTagIndex, r.index));
          break;
        case Sr.documentType:
          (r[7] || r[8]) && this.parseDocumentType(e.substring(this.startTagIndex, r.index));
          break;
        case Sr.processingInstruction:
          (r[7] || r[8]) && this.parseComment("?" + e.substring(this.startTagIndex, r.index));
          break;
        case Sr.rawTextElement:
          r[2] && this.parseRawTextElementContent(r[2], e.substring(this.startTagIndex, r.index));
          break;
      }
      i = this.markupRegExp.lastIndex;
    }
    return i !== e.length && this.currentNode && this.parsePlainText(e.substring(i)), this.rootNode;
  }
  /**
   * Parses plain text.
   *
   * @param text Text.
   */
  parsePlainText(e) {
    if (this.documentStructure) {
      const n = this.documentStructure.level, { documentElement: r, head: i, body: s } = this.documentStructure.nodes, a = (this.currentNode === this.rootNode || this.currentNode === r) && n < Zn.head && s[Ft].length === 0 ? e.replace(j$e, "") : e;
      if (a) {
        const o = this.rootDocument.createTextNode(hi.decodeHTMLEntities(a));
        this.currentNode === i && n === Zn.additionalHeadWithoutBody ? r[ja](o, s, !0) : this.currentNode === this.rootNode || this.currentNode === r || this.currentNode === i && n >= Zn.body ? n === Zn.head ? r[ja](o, s, !0) : s.lastChild?.[ve] === le.textNode ? s.lastChild[Dn] += e : s[Ht](o, !0) : this.currentNode[Ht](o, !0);
      }
    } else {
      const n = this.rootDocument.createTextNode(hi.decodeHTMLEntities(e));
      this.currentNode[Ht](n, !0);
    }
  }
  /**
   * Parses end of start tag.
   *
   * @param attributeString Attribute string.
   * @param isSelfClosed Is self closed.
   */
  parseEndOfStartTag(e, n) {
    if (e && (!this.documentStructure || this.nextElement !== this.documentStructure.nodes.head || this.documentStructure.level < Zn.body)) {
      const o = new RegExp(V$e);
      let u;
      for (; u = o.exec(e); )
        if (u[1] && u[2] || u[3] && u[5] === '"' || u[6] && u[8] === "'" || u[9]) {
          const l = u[1] || u[3] || u[6] || u[9] || "", h = u[2] || u[4] || u[7] || "", f = h ? hi.decodeHTMLAttributeValue(h) : "", m = this.nextElement[bt];
          if (this.nextElement[je] === xn.svg) {
            const g = l.split(":");
            let A = null;
            switch (g[0]) {
              case "xmlns":
                A = !g[1] || g[1] === "xlink" ? xn.xmlns : null;
                break;
              case "xlink":
                A = xn.xlink;
                break;
            }
            if (!m.getNamedItemNS(A, g[1] ?? l)) {
              const E = Gi.createNode(this.rootDocument, this.window.Attr);
              E[je] = A, E[tt] = l, E[Tt] = A && g[1] ? g[1] : l, E[pn] = A && g[1] ? g[0] : null, E[ze] = f, m[mc](E);
            }
          } else if (!m.getNamedItem(l)) {
            const g = this.rootDocument.createAttribute(l);
            g[ze] = f, m[mc](g);
          }
          this.startTagIndex += u[0].length;
        } else if (!u[1] && (u[3] && !u[5] || u[6] && !u[8]))
          return;
    }
    const r = this.nextElement[Xe], i = r.toLowerCase(), s = Si[i];
    let a = null;
    for (; a !== this.rootNode; ) {
      const o = this.currentNode[Xe]?.toLowerCase(), u = o ? Si[o] : null;
      if (a === this.currentNode)
        throw new Error("Failed to parse HTML: The parser is stuck in an infinite loop. Please report this issue.");
      if (a = this.currentNode, s?.contentModel === pe.noFirstLevelSelfDescendants && this.tagNameStack[this.tagNameStack.length - 1] === r || u?.contentModel === pe.textOrComments || u?.contentModel === pe.noForbiddenFirstLevelDescendants && u?.forbiddenDescendants?.includes(i) || u?.contentModel === pe.permittedDescendants && !u?.permittedDescendants?.includes(i) && (!s || !s.addPermittedParent || Si[s.addPermittedParent].permittedParents && !Si[s.addPermittedParent].permittedParents.includes(o) || Si[s.addPermittedParent].permittedDescendants && !Si[s.addPermittedParent].permittedDescendants.includes(i))) {
        if (u?.contentModel === pe.permittedDescendants && u.moveForbiddenDescendant && !u.moveForbiddenDescendant.exclude.includes(i)) {
          let l = this.currentNode;
          for (; l && !(!l.parentNode || !Si[l.parentNode[Tt]]?.permittedDescendants || Si[l.parentNode[Tt]]?.permittedDescendants?.includes(i)); )
            l = l.parentNode;
          l && l.parentNode ? l.parentNode.insertBefore(this.nextElement, l) : l.appendChild(this.nextElement), this.startTagIndex = this.markupRegExp.lastIndex, this.readState = Sr.any;
          return;
        }
        this.nodeStack.pop(), this.tagNameStack.pop(), this.currentNode = this.nodeStack[this.nodeStack.length - 1] || this.rootNode;
      } else if (s?.contentModel === pe.noSelfDescendants && this.tagNameStack.includes(r))
        for (; this.currentNode !== this.rootNode; ) {
          if (this.currentNode[Xe] === r) {
            this.nodeStack.pop(), this.tagNameStack.pop(), this.currentNode = this.nodeStack[this.nodeStack.length - 1] || this.rootNode;
            break;
          }
          this.nodeStack.pop(), this.tagNameStack.pop(), this.currentNode = this.nodeStack[this.nodeStack.length - 1] || this.rootNode;
        }
      else if (!this.isTemplateDocumentFragment && s?.permittedParents && !s.permittedParents.includes(o)) {
        if (!s.addPermittedParent || Si[s.addPermittedParent].permittedParents && !Si[s.addPermittedParent].permittedParents.includes(o) || Si[s.addPermittedParent].permittedDescendants && !Si[s.addPermittedParent].permittedDescendants.includes(i)) {
          this.readState = Sr.any, this.startTagIndex = this.markupRegExp.lastIndex;
          return;
        }
        const l = this.rootDocument.createElement(s.addPermittedParent);
        this.currentNode[Ht](l, !0), this.nodeStack.push(l), this.tagNameStack.push(l[Xe]), this.currentNode = l;
      } else
        break;
    }
    if (this.documentStructure) {
      const { documentElement: o, head: u, body: l } = this.documentStructure.nodes, h = this.documentStructure.level;
      (!s || s.contentModel !== pe.rawText) && this.nextElement !== o && this.nextElement !== u && this.nextElement !== l && (o && (this.currentNode === this.rootNode || this.currentNode === o || this.currentNode === u && h >= Zn.body) ? (h < Zn.body && (this.documentStructure.level = Zn.afterBody), l[Ht](this.nextElement, !0)) : this.currentNode[Ht](this.nextElement, !0));
    } else
      this.currentNode[Ht](this.nextElement, !0);
    !this.documentStructure || this.nextElement !== this.documentStructure.nodes.body || this.documentStructure.level <= Zn.body ? (this.currentNode = this.nextElement, this.nodeStack.push(this.currentNode), this.tagNameStack.push(r), this.documentStructure && this.nextElement === this.documentStructure.nodes.body && (this.documentStructure.level = Zn.afterBody), s?.contentModel === pe.noDescendants || n && this.currentNode[je] === xn.svg ? (this.nodeStack.pop(), this.tagNameStack.pop(), this.currentNode = this.nodeStack[this.nodeStack.length - 1] || this.rootNode, this.readState = Sr.any) : this.readState = s?.contentModel === pe.rawText ? Sr.rawTextElement : Sr.any) : this.readState = Sr.any, this.startTagIndex = this.markupRegExp.lastIndex;
  }
  /**
   * Parses end tag.
   *
   * @param tagName Tag name.
   */
  parseEndTag(e) {
    const n = this.currentNode[je] === xn.html ? yo.asciiUpperCase(e) : tx[yo.asciiLowerCase(e)]?.localName || e, r = this.tagNameStack.lastIndexOf(n);
    r !== -1 && (this.nodeStack.splice(r, this.nodeStack.length - r), this.tagNameStack.splice(r, this.tagNameStack.length - r), this.currentNode = this.nodeStack[this.nodeStack.length - 1] || this.rootNode);
  }
  /**
   * Parses comment.
   *
   * @param comment Comment.
   */
  parseComment(e) {
    const n = this.rootDocument.createComment(hi.decodeHTMLEntities(e));
    if (this.documentStructure) {
      const r = this.documentStructure.level, { documentElement: i, head: s, body: a } = this.documentStructure.nodes;
      let o = null;
      this.currentNode === this.rootNode && r === Zn.root ? o = i : this.currentNode === i && r === Zn.documentElement ? o = s : this.currentNode === i && r === Zn.head && (o = a), this.currentNode[ja](n, o, !0);
    } else
      this.currentNode[Ht](n, !0);
    this.readState = Sr.any;
  }
  /**
   * Parses document type.
   *
   * @param text Text.
   */
  parseDocumentType(e) {
    const n = hi.decodeHTMLEntities(e);
    if (this.documentStructure) {
      let { doctype: r } = this.documentStructure.nodes;
      const i = this.getDocumentType(n);
      i ? this.currentNode === this.rootNode && this.documentStructure.level === Zn.root && (r ? (r[tt] = i.name, r[Id] = i.publicId, r[Rd] = i.systemId) : (r = this.rootNode.implementation.createDocumentType(i.name, i.publicId, i.systemId), this.rootNode.insertBefore(r, this.rootNode.documentElement)), this.documentStructure.level = Zn.doctype) : this.parseComment(n);
    } else
      this.getDocumentType(n) || this.parseComment(n);
    this.readState = Sr.any;
  }
  /**
   * Parses raw text content for elements such as <script> and <style>.
   *
   * @param tagName End tag name.
   * @param text Text.
   */
  parseRawTextElementContent(e, n) {
    const r = yo.asciiUpperCase(e);
    if (r !== this.currentNode[Xe])
      return;
    r === "SCRIPT" ? this.currentNode[Tf] = !this.evaluateScripts : r === "LINK" && (this.currentNode[Tf] = !this.evaluateScripts), this.currentNode[Ht](this.rootDocument.createTextNode(n), !0);
    const i = this.currentNode;
    if (this.nodeStack.pop(), this.tagNameStack.pop(), this.currentNode = this.nodeStack[this.nodeStack.length - 1] || this.rootNode, this.readState = Sr.any, this.documentStructure) {
      const { documentElement: s, body: a } = this.documentStructure.nodes;
      s && (this.currentNode === this.rootNode || this.currentNode === s) ? a[Ht](i, !0) : this.currentNode[Ht](i, !0);
    } else
      this.currentNode[Ht](i, !0);
  }
  /**
   * Creates an element or returns a reference to it.
   *
   * @param tagName Tag name.
   */
  getStartTagElement(e) {
    const n = yo.asciiLowerCase(e), r = this.currentNode[je];
    if (n === "svg")
      return this.rootDocument.createElementNS(xn.svg, "svg");
    if (r === xn.svg)
      return this.rootDocument.createElementNS(xn.svg, tx[n]?.localName || e);
    switch (n) {
      case "html":
        return this.documentStructure ? (this.documentStructure.level < Zn.documentElement && (this.documentStructure.level = Zn.documentElement), this.documentStructure.nodes.documentElement ?? null) : null;
      case "head":
        return this.documentStructure ? (this.documentStructure.level < Zn.head ? this.documentStructure.level = Zn.head : this.documentStructure.level === Zn.head && (this.documentStructure.level = Zn.additionalHeadWithoutBody), this.documentStructure.nodes.head ?? null) : null;
      case "body":
        return this.documentStructure ? (this.documentStructure.level < Zn.body && (this.documentStructure.level = Zn.body), this.documentStructure.nodes.body ?? null) : null;
      default:
        return this.rootDocument.createElementNS(xn.html, n);
    }
  }
  /**
   * Returns document type.
   *
   * @param value Value.
   * @returns Document type.
   */
  getDocumentType(e) {
    if (!e.toUpperCase().startsWith("DOCTYPE"))
      return null;
    const n = e.split(z$e);
    if (n.length <= 1)
      return null;
    const r = n.slice(1).join(" "), i = [], s = new RegExp(K$e, "gm"), a = r.toUpperCase().includes("PUBLIC");
    let o;
    for (; o = s.exec(r); )
      i.push(o[1]);
    const u = a && i[0] || "", l = a ? i[1] || "" : i[0] || "";
    return {
      name: n[1].toLowerCase(),
      publicId: u,
      systemId: l
    };
  }
}
const Y$e = /^[a-z][a-z0-9-]+$/;
let kf = class extends ot {
  // Internal properties
  [ts] = null;
  [jr] = null;
  [Yd] = null;
  [eu] = null;
  [ci] = this;
  [pd] = !0;
  [bd] = !1;
  [ve] = le.documentNode;
  [st] = !0;
  [uh] = [];
  [gF] = new k$e(this);
  [Og] = uW.interactive;
  [ra] = "";
  [lu] = null;
  [ym] = null;
  [fc] = [];
  [he] = null;
  [Il] = /* @__PURE__ */ new Map();
  [xi] = "text/html";
  [Hg] = null;
  [Va] = /* @__PURE__ */ new Map();
  [F] = /* @__PURE__ */ new Map();
  [yd] = null;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onreadystatechange() {
    return this[F].get("onreadystatechange") ?? null;
  }
  set onreadystatechange(e) {
    this[F].set("onreadystatechange", e);
  }
  get onpointerlockchange() {
    return this[F].get("onpointerlockchange") ?? null;
  }
  set onpointerlockchange(e) {
    this[F].set("onpointerlockchange", e);
  }
  get onpointerlockerror() {
    return this[F].get("onpointerlockerror") ?? null;
  }
  set onpointerlockerror(e) {
    this[F].set("onpointerlockerror", e);
  }
  get onbeforecopy() {
    return this[F].get("onbeforecopy") ?? null;
  }
  set onbeforecopy(e) {
    this[F].set("onbeforecopy", e);
  }
  get onbeforecut() {
    return this[F].get("onbeforecut") ?? null;
  }
  set onbeforecut(e) {
    this[F].set("onbeforecut", e);
  }
  get onbeforepaste() {
    return this[F].get("onbeforepaste") ?? null;
  }
  set onbeforepaste(e) {
    this[F].set("onbeforepaste", e);
  }
  get onfreeze() {
    return this[F].get("onfreeze") ?? null;
  }
  set onfreeze(e) {
    this[F].set("onfreeze", e);
  }
  get onprerenderingchange() {
    return this[F].get("onprerenderingchange") ?? null;
  }
  set onprerenderingchange(e) {
    this[F].set("onprerenderingchange", e);
  }
  get onresume() {
    return this[F].get("onresume") ?? null;
  }
  set onresume(e) {
    this[F].set("onresume", e);
  }
  get onsearch() {
    return this[F].get("onsearch") ?? null;
  }
  set onsearch(e) {
    this[F].set("onsearch", e);
  }
  get onvisibilitychange() {
    return this[F].get("onvisibilitychange") ?? null;
  }
  set onvisibilitychange(e) {
    this[F].set("onvisibilitychange", e);
  }
  get onfullscreenchange() {
    return this[F].get("onfullscreenchange") ?? null;
  }
  set onfullscreenchange(e) {
    this[F].set("onfullscreenchange", e);
  }
  get onfullscreenerror() {
    return this[F].get("onfullscreenerror") ?? null;
  }
  set onfullscreenerror(e) {
    this[F].set("onfullscreenerror", e);
  }
  get onwebkitfullscreenchange() {
    return this[F].get("onwebkitfullscreenchange") ?? null;
  }
  set onwebkitfullscreenchange(e) {
    this[F].set("onwebkitfullscreenchange", e);
  }
  get onwebkitfullscreenerror() {
    return this[F].get("onwebkitfullscreenerror") ?? null;
  }
  set onwebkitfullscreenerror(e) {
    this[F].set("onwebkitfullscreenerror", e);
  }
  get onbeforexrselect() {
    return this[F].get("onbeforexrselect") ?? null;
  }
  set onbeforexrselect(e) {
    this[F].set("onbeforexrselect", e);
  }
  get onabort() {
    return this[F].get("onabort") ?? null;
  }
  set onabort(e) {
    this[F].set("onabort", e);
  }
  get onbeforeinput() {
    return this[F].get("onbeforeinput") ?? null;
  }
  set onbeforeinput(e) {
    this[F].set("onbeforeinput", e);
  }
  get onbeforematch() {
    return this[F].get("onbeforematch") ?? null;
  }
  set onbeforematch(e) {
    this[F].set("onbeforematch", e);
  }
  get onbeforetoggle() {
    return this[F].get("onbeforetoggle") ?? null;
  }
  set onbeforetoggle(e) {
    this[F].set("onbeforetoggle", e);
  }
  get onblur() {
    return this[F].get("onblur") ?? null;
  }
  set onblur(e) {
    this[F].set("onblur", e);
  }
  get oncancel() {
    return this[F].get("oncancel") ?? null;
  }
  set oncancel(e) {
    this[F].set("oncancel", e);
  }
  get oncanplay() {
    return this[F].get("oncanplay") ?? null;
  }
  set oncanplay(e) {
    this[F].set("oncanplay", e);
  }
  get oncanplaythrough() {
    return this[F].get("oncanplaythrough") ?? null;
  }
  set oncanplaythrough(e) {
    this[F].set("oncanplaythrough", e);
  }
  get onchange() {
    return this[F].get("onchange") ?? null;
  }
  set onchange(e) {
    this[F].set("onchange", e);
  }
  get onclick() {
    return this[F].get("onclick") ?? null;
  }
  set onclick(e) {
    this[F].set("onclick", e);
  }
  get onclose() {
    return this[F].get("onclose") ?? null;
  }
  set onclose(e) {
    this[F].set("onclose", e);
  }
  get oncontentvisibilityautostatechange() {
    return this[F].get("oncontentvisibilityautostatechange") ?? null;
  }
  set oncontentvisibilityautostatechange(e) {
    this[F].set("oncontentvisibilityautostatechange", e);
  }
  get oncontextlost() {
    return this[F].get("oncontextlost") ?? null;
  }
  set oncontextlost(e) {
    this[F].set("oncontextlost", e);
  }
  get oncontextmenu() {
    return this[F].get("oncontextmenu") ?? null;
  }
  set oncontextmenu(e) {
    this[F].set("oncontextmenu", e);
  }
  get oncontextrestored() {
    return this[F].get("oncontextrestored") ?? null;
  }
  set oncontextrestored(e) {
    this[F].set("oncontextrestored", e);
  }
  get oncuechange() {
    return this[F].get("oncuechange") ?? null;
  }
  set oncuechange(e) {
    this[F].set("oncuechange", e);
  }
  get ondblclick() {
    return this[F].get("ondblclick") ?? null;
  }
  set ondblclick(e) {
    this[F].set("ondblclick", e);
  }
  get ondrag() {
    return this[F].get("ondrag") ?? null;
  }
  set ondrag(e) {
    this[F].set("ondrag", e);
  }
  get ondragend() {
    return this[F].get("ondragend") ?? null;
  }
  set ondragend(e) {
    this[F].set("ondragend", e);
  }
  get ondragenter() {
    return this[F].get("ondragenter") ?? null;
  }
  set ondragenter(e) {
    this[F].set("ondragenter", e);
  }
  get ondragleave() {
    return this[F].get("ondragleave") ?? null;
  }
  set ondragleave(e) {
    this[F].set("ondragleave", e);
  }
  get ondragover() {
    return this[F].get("ondragover") ?? null;
  }
  set ondragover(e) {
    this[F].set("ondragover", e);
  }
  get ondragstart() {
    return this[F].get("ondragstart") ?? null;
  }
  set ondragstart(e) {
    this[F].set("ondragstart", e);
  }
  get ondrop() {
    return this[F].get("ondrop") ?? null;
  }
  set ondrop(e) {
    this[F].set("ondrop", e);
  }
  get ondurationchange() {
    return this[F].get("ondurationchange") ?? null;
  }
  set ondurationchange(e) {
    this[F].set("ondurationchange", e);
  }
  get onemptied() {
    return this[F].get("onemptied") ?? null;
  }
  set onemptied(e) {
    this[F].set("onemptied", e);
  }
  get onended() {
    return this[F].get("onended") ?? null;
  }
  set onended(e) {
    this[F].set("onended", e);
  }
  get onerror() {
    return this[F].get("onerror") ?? null;
  }
  set onerror(e) {
    this[F].set("onerror", e);
  }
  get onfocus() {
    return this[F].get("onfocus") ?? null;
  }
  set onfocus(e) {
    this[F].set("onfocus", e);
  }
  get onformdata() {
    return this[F].get("onformdata") ?? null;
  }
  set onformdata(e) {
    this[F].set("onformdata", e);
  }
  get oninput() {
    return this[F].get("oninput") ?? null;
  }
  set oninput(e) {
    this[F].set("oninput", e);
  }
  get oninvalid() {
    return this[F].get("oninvalid") ?? null;
  }
  set oninvalid(e) {
    this[F].set("oninvalid", e);
  }
  get onkeydown() {
    return this[F].get("onkeydown") ?? null;
  }
  set onkeydown(e) {
    this[F].set("onkeydown", e);
  }
  get onkeypress() {
    return this[F].get("onkeypress") ?? null;
  }
  set onkeypress(e) {
    this[F].set("onkeypress", e);
  }
  get onkeyup() {
    return this[F].get("onkeyup") ?? null;
  }
  set onkeyup(e) {
    this[F].set("onkeyup", e);
  }
  get onload() {
    return this[F].get("onload") ?? null;
  }
  set onload(e) {
    this[F].set("onload", e);
  }
  get onloadeddata() {
    return this[F].get("onloadeddata") ?? null;
  }
  set onloadeddata(e) {
    this[F].set("onloadeddata", e);
  }
  get onloadedmetadata() {
    return this[F].get("onloadedmetadata") ?? null;
  }
  set onloadedmetadata(e) {
    this[F].set("onloadedmetadata", e);
  }
  get onloadstart() {
    return this[F].get("onloadstart") ?? null;
  }
  set onloadstart(e) {
    this[F].set("onloadstart", e);
  }
  get onmousedown() {
    return this[F].get("onmousedown") ?? null;
  }
  set onmousedown(e) {
    this[F].set("onmousedown", e);
  }
  get onmouseenter() {
    return this[F].get("onmouseenter") ?? null;
  }
  set onmouseenter(e) {
    this[F].set("onmouseenter", e);
  }
  get onmouseleave() {
    return this[F].get("onmouseleave") ?? null;
  }
  set onmouseleave(e) {
    this[F].set("onmouseleave", e);
  }
  get onmousemove() {
    return this[F].get("onmousemove") ?? null;
  }
  set onmousemove(e) {
    this[F].set("onmousemove", e);
  }
  get onmouseout() {
    return this[F].get("onmouseout") ?? null;
  }
  set onmouseout(e) {
    this[F].set("onmouseout", e);
  }
  get onmouseover() {
    return this[F].get("onmouseover") ?? null;
  }
  set onmouseover(e) {
    this[F].set("onmouseover", e);
  }
  get onmouseup() {
    return this[F].get("onmouseup") ?? null;
  }
  set onmouseup(e) {
    this[F].set("onmouseup", e);
  }
  get onmousewheel() {
    return this[F].get("onmousewheel") ?? null;
  }
  set onmousewheel(e) {
    this[F].set("onmousewheel", e);
  }
  get onpause() {
    return this[F].get("onpause") ?? null;
  }
  set onpause(e) {
    this[F].set("onpause", e);
  }
  get onplay() {
    return this[F].get("onplay") ?? null;
  }
  set onplay(e) {
    this[F].set("onplay", e);
  }
  get onplaying() {
    return this[F].get("onplaying") ?? null;
  }
  set onplaying(e) {
    this[F].set("onplaying", e);
  }
  get onprogress() {
    return this[F].get("onprogress") ?? null;
  }
  set onprogress(e) {
    this[F].set("onprogress", e);
  }
  get onratechange() {
    return this[F].get("onratechange") ?? null;
  }
  set onratechange(e) {
    this[F].set("onratechange", e);
  }
  get onreset() {
    return this[F].get("onreset") ?? null;
  }
  set onreset(e) {
    this[F].set("onreset", e);
  }
  get onresize() {
    return this[F].get("onresize") ?? null;
  }
  set onresize(e) {
    this[F].set("onresize", e);
  }
  get onscroll() {
    return this[F].get("onscroll") ?? null;
  }
  set onscroll(e) {
    this[F].set("onscroll", e);
  }
  get onsecuritypolicyviolation() {
    return this[F].get("onsecuritypolicyviolation") ?? null;
  }
  set onsecuritypolicyviolation(e) {
    this[F].set("onsecuritypolicyviolation", e);
  }
  get onseeked() {
    return this[F].get("onseeked") ?? null;
  }
  set onseeked(e) {
    this[F].set("onseeked", e);
  }
  get onseeking() {
    return this[F].get("onseeking") ?? null;
  }
  set onseeking(e) {
    this[F].set("onseeking", e);
  }
  get onselect() {
    return this[F].get("onselect") ?? null;
  }
  set onselect(e) {
    this[F].set("onselect", e);
  }
  get onslotchange() {
    return this[F].get("onslotchange") ?? null;
  }
  set onslotchange(e) {
    this[F].set("onslotchange", e);
  }
  get onstalled() {
    return this[F].get("onstalled") ?? null;
  }
  set onstalled(e) {
    this[F].set("onstalled", e);
  }
  get onsubmit() {
    return this[F].get("onsubmit") ?? null;
  }
  set onsubmit(e) {
    this[F].set("onsubmit", e);
  }
  get onsuspend() {
    return this[F].get("onsuspend") ?? null;
  }
  set onsuspend(e) {
    this[F].set("onsuspend", e);
  }
  get ontimeupdate() {
    return this[F].get("ontimeupdate") ?? null;
  }
  set ontimeupdate(e) {
    this[F].set("ontimeupdate", e);
  }
  get ontoggle() {
    return this[F].get("ontoggle") ?? null;
  }
  set ontoggle(e) {
    this[F].set("ontoggle", e);
  }
  get onvolumechange() {
    return this[F].get("onvolumechange") ?? null;
  }
  set onvolumechange(e) {
    this[F].set("onvolumechange", e);
  }
  get onwaiting() {
    return this[F].get("onwaiting") ?? null;
  }
  set onwaiting(e) {
    this[F].set("onwaiting", e);
  }
  get onwebkitanimationend() {
    return this[F].get("onwebkitanimationend") ?? null;
  }
  set onwebkitanimationend(e) {
    this[F].set("onwebkitanimationend", e);
  }
  get onwebkitanimationiteration() {
    return this[F].get("onwebkitanimationiteration") ?? null;
  }
  set onwebkitanimationiteration(e) {
    this[F].set("onwebkitanimationiteration", e);
  }
  get onwebkitanimationstart() {
    return this[F].get("onwebkitanimationstart") ?? null;
  }
  set onwebkitanimationstart(e) {
    this[F].set("onwebkitanimationstart", e);
  }
  get onwebkittransitionend() {
    return this[F].get("onwebkittransitionend") ?? null;
  }
  set onwebkittransitionend(e) {
    this[F].set("onwebkittransitionend", e);
  }
  get onwheel() {
    return this[F].get("onwheel") ?? null;
  }
  set onwheel(e) {
    this[F].set("onwheel", e);
  }
  get onauxclick() {
    return this[F].get("onauxclick") ?? null;
  }
  set onauxclick(e) {
    this[F].set("onauxclick", e);
  }
  get ongotpointercapture() {
    return this[F].get("ongotpointercapture") ?? null;
  }
  set ongotpointercapture(e) {
    this[F].set("ongotpointercapture", e);
  }
  get onlostpointercapture() {
    return this[F].get("onlostpointercapture") ?? null;
  }
  set onlostpointercapture(e) {
    this[F].set("onlostpointercapture", e);
  }
  get onpointerdown() {
    return this[F].get("onpointerdown") ?? null;
  }
  set onpointerdown(e) {
    this[F].set("onpointerdown", e);
  }
  get onpointermove() {
    return this[F].get("onpointermove") ?? null;
  }
  set onpointermove(e) {
    this[F].set("onpointermove", e);
  }
  get onpointerrawupdate() {
    return this[F].get("onpointerrawupdate") ?? null;
  }
  set onpointerrawupdate(e) {
    this[F].set("onpointerrawupdate", e);
  }
  get onpointerup() {
    return this[F].get("onpointerup") ?? null;
  }
  set onpointerup(e) {
    this[F].set("onpointerup", e);
  }
  get onpointercancel() {
    return this[F].get("onpointercancel") ?? null;
  }
  set onpointercancel(e) {
    this[F].set("onpointercancel", e);
  }
  get onpointerover() {
    return this[F].get("onpointerover") ?? null;
  }
  set onpointerover(e) {
    this[F].set("onpointerover", e);
  }
  get onpointerout() {
    return this[F].get("onpointerout") ?? null;
  }
  set onpointerout(e) {
    this[F].set("onpointerout", e);
  }
  get onpointerenter() {
    return this[F].get("onpointerenter") ?? null;
  }
  set onpointerenter(e) {
    this[F].set("onpointerenter", e);
  }
  get onpointerleave() {
    return this[F].get("onpointerleave") ?? null;
  }
  set onpointerleave(e) {
    this[F].set("onpointerleave", e);
  }
  get onselectstart() {
    return this[F].get("onselectstart") ?? null;
  }
  set onselectstart(e) {
    this[F].set("onselectstart", e);
  }
  get onselectionchange() {
    return this[F].get("onselectionchange") ?? null;
  }
  set onselectionchange(e) {
    this[F].set("onselectionchange", e);
  }
  get onanimationend() {
    return this[F].get("onanimationend") ?? null;
  }
  set onanimationend(e) {
    this[F].set("onanimationend", e);
  }
  get onanimationiteration() {
    return this[F].get("onanimationiteration") ?? null;
  }
  set onanimationiteration(e) {
    this[F].set("onanimationiteration", e);
  }
  get onanimationstart() {
    return this[F].get("onanimationstart") ?? null;
  }
  set onanimationstart(e) {
    this[F].set("onanimationstart", e);
  }
  get ontransitionrun() {
    return this[F].get("ontransitionrun") ?? null;
  }
  set ontransitionrun(e) {
    this[F].set("ontransitionrun", e);
  }
  get ontransitionstart() {
    return this[F].get("ontransitionstart") ?? null;
  }
  set ontransitionstart(e) {
    this[F].set("ontransitionstart", e);
  }
  get ontransitionend() {
    return this[F].get("ontransitionend") ?? null;
  }
  set ontransitionend(e) {
    this[F].set("ontransitionend", e);
  }
  get ontransitioncancel() {
    return this[F].get("ontransitioncancel") ?? null;
  }
  set ontransitioncancel(e) {
    this[F].set("ontransitioncancel", e);
  }
  get oncopy() {
    return this[F].get("oncopy") ?? null;
  }
  set oncopy(e) {
    this[F].set("oncopy", e);
  }
  get oncut() {
    return this[F].get("oncut") ?? null;
  }
  set oncut(e) {
    this[F].set("oncut", e);
  }
  get onpaste() {
    return this[F].get("onpaste") ?? null;
  }
  set onpaste(e) {
    this[F].set("onpaste", e);
  }
  get onscrollend() {
    return this[F].get("onscrollend") ?? null;
  }
  set onscrollend(e) {
    this[F].set("onscrollend", e);
  }
  get onscrollsnapchange() {
    return this[F].get("onscrollsnapchange") ?? null;
  }
  set onscrollsnapchange(e) {
    this[F].set("onscrollsnapchange", e);
  }
  get onscrollsnapchanging() {
    return this[F].get("onscrollsnapchanging") ?? null;
  }
  set onscrollsnapchanging(e) {
    this[F].set("onscrollsnapchanging", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns adopted style sheets.
   *
   * @returns Adopted style sheets.
   */
  get adoptedStyleSheets() {
    return this[uh];
  }
  /**
   * Sets adopted style sheets.
   *
   * @param value Adopted style sheets.
   */
  set adoptedStyleSheets(e) {
    this[uh] = e;
  }
  /**
   * Returns DOM implementation.
   *
   * @returns DOM implementation.
   */
  get implementation() {
    return this[gF];
  }
  /**
   * Returns document ready state.
   *
   * @returns Document ready state.
   */
  get readyState() {
    return this[Og];
  }
  /**
   * Returns referrer.
   *
   * @returns Referrer.
   */
  get referrer() {
    return this[ra];
  }
  /**
   * Returns default view.
   *
   * @returns Default view.
   */
  get defaultView() {
    return this[lu];
  }
  /**
   * Returns document children.
   */
  get children() {
    if (!this[ts]) {
      const e = this[Ft];
      this[ts] = new mi(T, () => e);
    }
    return this[ts];
  }
  /**
   * Returns character set.
   *
   * @deprecated
   * @returns Character set.
   */
  get charset() {
    return this.characterSet;
  }
  /**
   * Returns character set.
   *
   * @returns Character set.
   */
  get characterSet() {
    const e = it.querySelector(this, "meta[charset]")?.getAttributeNS(null, "charset");
    return e || "UTF-8";
  }
  /**
   * Returns title.
   *
   * @returns Title.
   */
  get title() {
    const e = Wn.getElementByTagName(this, "title");
    return e ? e.text.trim() : "";
  }
  /**
   * Returns set title.
   *
   */
  set title(e) {
    const n = Wn.getElementByTagName(this, "title");
    if (n)
      n.textContent = e;
    else {
      const r = this.createElement("title");
      r.textContent = e, this.head.appendChild(r);
    }
  }
  /**
   * Returns a collection of all area elements and a elements in a document with a value for the href attribute.
   */
  get links() {
    return it.querySelectorAll(this, "a[href],area[href]");
  }
  /**
   * Returns a collection of all form elements in a document.
   */
  get forms() {
    return this[ym] || (this[ym] = Wn.getElementsByTagName(this, "form")), this[ym];
  }
  /**
   * Last element child.
   *
   * @returns Element.
   */
  get childElementCount() {
    return this[Ft].length;
  }
  /**
   * First element child.
   *
   * @returns Element.
   */
  get firstElementChild() {
    return this[Ft][0] ?? null;
  }
  /**
   * Last element child.
   *
   * @returns Element.
   */
  get lastElementChild() {
    const e = this[Ft];
    return e[e.length - 1] ?? null;
  }
  /**
   * Returns cookie string.
   *
   * @returns Cookie.
   */
  get cookie() {
    const e = new pt(this[b]).getBrowserFrame();
    return e ? xf.cookiesToString(e.page.context.cookieContainer.getCookies(this[b].location, !0)) : "";
  }
  /**
   * Sets a cookie string.
   *
   * @param cookie Cookie string.
   */
  set cookie(e) {
    const n = new pt(this[b]).getBrowserFrame();
    if (!n)
      return;
    const r = xf.stringToCookie(this[b].location, e);
    r && n.page.context.cookieContainer.addCookies([r]);
  }
  /**
   * Node name.
   *
   * @returns Node name.
   */
  get nodeName() {
    return "#document";
  }
  /**
   * Returns <html> element.
   *
   * @returns Element.
   */
  get documentElement() {
    return this[Ft][0] ?? null;
  }
  /**
   * Returns document type element.
   *
   * @returns Document type.
   */
  get doctype() {
    for (const e of this[Re])
      if (e instanceof W2)
        return e;
    return null;
  }
  /**
   * Returns <body> element.
   *
   * @returns Element.
   */
  get body() {
    const e = this.documentElement;
    return e ? Wn.getElementByTagName(e, "body") : null;
  }
  /**
   * Returns <head> element.
   *
   * @returns Element.
   */
  get head() {
    const e = this.documentElement;
    return e ? Wn.getElementByTagName(e, "head") : null;
  }
  /**
   * Returns CSS style sheets.
   *
   * @returns CSS style sheets.
   */
  get styleSheets() {
    const e = it.querySelectorAll(this, 'link[rel="stylesheet"][href],style'), n = [];
    for (const r of e) {
      const i = r.sheet;
      i && n.push(i);
    }
    return n;
  }
  /**
   * Returns active element.
   *
   * @returns Active element.
   */
  get activeElement() {
    if (this[jr] && !this[jr][st] && (this[jr] = null), this[jr] && this[jr] instanceof Sc) {
      let e = this[jr].getRootNode(), n = this[jr];
      for (; e !== this; )
        n = e.host, e = n ? n.getRootNode() : this;
      return n;
    }
    return this[jr] || this.body || this.documentElement || null;
  }
  /**
   * Returns scrolling element.
   *
   * @returns Scrolling element.
   */
  get scrollingElement() {
    return this.documentElement;
  }
  /**
   * Returns location.
   *
   * @returns Location.
   */
  get location() {
    return this[b].location;
  }
  /**
   * Returns scripts.
   *
   * @returns Scripts.
   */
  get scripts() {
    return this.getElementsByTagName("script");
  }
  /**
   * Returns base URI.
   *
   * @override
   * @returns Base URI.
   */
  get baseURI() {
    const e = Wn.getElementByTagName(this, "base");
    return e ? e.href : this[b].location.href;
  }
  /**
   * Returns URL.
   *
   * @returns URL of the current document.
   * */
  get URL() {
    return this[b].location.href;
  }
  /**
   * Returns document URI.
   *
   * @returns URL of the current document.
   * */
  get documentURI() {
    return this.URL;
  }
  /**
   * Returns domain.
   *
   * @returns Domain.
   * */
  get domain() {
    return this[b].location.hostname;
  }
  /**
   * Returns document visibility state.
   *
   * @returns the visibility state of the current document.
   * */
  get visibilityState() {
    return this.defaultView ? JL.visible : JL.hidden;
  }
  /**
   * Returns document hidden state.
   *
   * @returns the hidden state of the current document.
   * */
  get hidden() {
    return !this.defaultView;
  }
  /**
   * Gets the currently executing script element.
   *
   * @returns the currently executing script element.
   */
  get currentScript() {
    return this[eu];
  }
  /**
   * Returns content type.
   *
   * @returns Content type.
   */
  get contentType() {
    return this[xi];
  }
  /**
   * Inserts a set of Node objects or DOMString objects after the last child of the ParentNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  append(...e) {
    Wn.append(this, ...e);
  }
  /**
   * Inserts a set of Node objects or DOMString objects before the first child of the ParentNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  prepend(...e) {
    Wn.prepend(this, ...e);
  }
  /**
   * Replaces the existing children of a node with a specified new set of children.
   *
   * @param nodes List of Node or DOMString.
   */
  replaceChildren(...e) {
    Wn.replaceChildren(this, ...e);
  }
  /**
   * Query CSS selector to find matching elements.
   *
   * @param selector CSS selector.
   * @returns Matching elements.
   */
  querySelectorAll(e) {
    return it.querySelectorAll(this, e);
  }
  /**
   * Query CSS Selector to find matching node.
   *
   * @param selector CSS selector.
   * @returns Matching element.
   */
  querySelector(e) {
    return it.querySelector(this, e);
  }
  /**
   * Returns true if the command is supported.
   * @deprecated
   * @param _ Command.
   * @returns True if the command is supported, false otherwise.
   */
  queryCommandSupported(e) {
    if (!arguments.length)
      throw new this[b].TypeError("Failed to execute 'queryCommandSupported' on 'Document': 1 argument required, but only 0 present.");
    return !0;
  }
  /**
   * Returns an elements by class name.
   *
   * @param className Tag name.
   * @returns Matching element.
   */
  getElementsByClassName(e) {
    return Wn.getElementsByClassName(this, e);
  }
  /**
   * Returns an elements by tag name.
   *
   * @param tagName Tag name.
   * @returns Matching element.
   */
  getElementsByTagName(e) {
    return Wn.getElementsByTagName(this, e);
  }
  /**
   * Returns an elements by tag name and namespace.
   *
   * @param namespaceURI Namespace URI.
   * @param tagName Tag name.
   * @returns Matching element.
   */
  getElementsByTagNameNS(e, n) {
    return Wn.getElementsByTagNameNS(this, e, n);
  }
  /**
   * Returns an element by ID.
   *
   * @param id ID.
   * @returns Matching element.
   */
  getElementById(e) {
    return Wn.getElementById(this, e);
  }
  /**
   * Returns an element by Name.
   *
   * @returns Matching element.
   * @param name
   */
  getElementsByName(e) {
    return it.querySelectorAll(this, `[name="${e}"]`);
  }
  /**
   * Replaces the document HTML with new HTML.
   *
   * @param html HTML.
   */
  write(e) {
    if (this[pd] || this[bd]) {
      this[pd] && (this[bd] || this.open(), this[pd] = !1);
      const { documentElement: n, head: r, body: i } = this;
      (!n || !r || !i) && this.open(), this[pd] = !1, this[bd] = !1, new hu(this[b], {
        evaluateScripts: !0
      }).parse(e, this);
    } else
      new hu(this[b], {
        evaluateScripts: !0
      }).parse(e, this.body);
  }
  /**
   * Opens the document.
   *
   * @returns Document.
   */
  open() {
    this[bd] = !0;
    for (const a of this[ur].bubbling.keys()) {
      const o = this[ur].bubbling.get(a);
      if (o)
        for (const u of o)
          this.removeEventListener(a, u);
    }
    for (const a of this[ur].capturing.keys()) {
      const o = this[ur].capturing.get(a);
      if (o)
        for (const u of o)
          this.removeEventListener(a, u);
    }
    const e = this[Re];
    for (; e.length; )
      this.removeChild(e[0]);
    const n = this[gF].createDocumentType("html", "", ""), r = this.createElement("html"), i = this.createElement("body"), s = this.createElement("head");
    return this.appendChild(n), this.appendChild(r), r.appendChild(s), r.appendChild(i), this;
  }
  /**
   * Closes the document.
   */
  close() {
  }
  /**
   * Creates an element.
   *
   * @param qualifiedName Tag name.
   * @param [options] Options.
   * @param [options.is] Tag name of a custom element previously defined via customElements.define().
   * @returns Element.
   */
  createElement(e, n) {
    return this.createElementNS(xn.html, yo.asciiLowerCase(String(e)), n);
  }
  /**
   * Creates an element with the specified namespace URI and qualified name.
   *
   * @param namespaceURI Namespace URI.
   * @param qualifiedName Tag name.
   * @param [options] Options.
   * @param [options.is] Tag name of a custom element previously defined via customElements.define().
   * @returns Element.
   */
  createElementNS(e, n, r) {
    const i = this[b];
    if (n = String(n), !n)
      throw new i.DOMException("Failed to execute 'createElementNS' on 'Document': The qualified name provided is empty.");
    const s = n.split(":"), a = s[1] ?? s[0], o = s[1] ? s[0] : null;
    switch (e) {
      case xn.svg:
        const u = tx[n.toLowerCase()], l = u && u.localName === n ? i[u.className] : i.SVGElement, h = Gi.createNode(this, l);
        return h[Xe] = n, h[Tt] = a, h[pn] = o, h[je] = e, h[po] = r && r.is ? String(r.is) : null, h;
      case xn.html:
        const f = i.customElements[xl]?.get(r && r.is ? String(r.is) : n);
        if (f) {
          const w = new f.elementClass();
          return w[Xe] = yo.asciiUpperCase(n), w[Tt] = a, w[pn] = o, w[je] = e, w[po] = r && r.is ? String(r.is) : null, w;
        }
        const m = Si[n] ? i[Si[n].className] : null;
        if (m) {
          const w = Gi.createNode(this, m);
          return w[Xe] = yo.asciiUpperCase(n), w[Tt] = a, w[pn] = o, w[je] = e, w[po] = r && r.is ? String(r.is) : null, w;
        }
        const g = n.includes("-") ? i.HTMLElement : i.HTMLUnknownElement, A = Gi.createNode(this, g);
        return A[Xe] = yo.asciiUpperCase(n), A[Tt] = a, A[pn] = o, A[je] = e, A[po] = r && r.is ? String(r.is) : null, A;
      default:
        const E = Gi.createNode(this, Sc);
        return E[Xe] = n, E[Tt] = a, E[pn] = o, E[je] = e, E[po] = r && r.is ? String(r.is) : null, E;
    }
  }
  /* eslint-enable jsdoc/valid-types */
  /**
   * Creates a text node.
   *
   * @param [data] Text data.
   * @returns Text node.
   */
  createTextNode(e) {
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'createTextNode' on 'Document': 1 argument required, but only ${arguments.length} present.`);
    return Gi.createNode(this, this[b].Text, String(e));
  }
  /**
   * Creates a comment node.
   *
   * @param [data] Text data.
   * @returns Text node.
   */
  createComment(e) {
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'createComment' on 'Document': 1 argument required, but only ${arguments.length} present.`);
    return Gi.createNode(this, this[b].Comment, String(e));
  }
  /**
   * Creates a document fragment.
   *
   * @returns Document fragment.
   */
  createDocumentFragment() {
    return Gi.createNode(this, this[b].DocumentFragment);
  }
  /**
   * Creates a node iterator.
   *
   * @param root Root.
   * @param [whatToShow] What to show.
   * @param [filter] Filter.
   */
  createNodeIterator(e, n = -1, r = null) {
    return new lW(e, n, r);
  }
  /**
   * Creates a Tree Walker.
   *
   * @param root Root.
   * @param [whatToShow] What to show.
   * @param [filter] Filter.
   */
  createTreeWalker(e, n = -1, r = null) {
    return new V2(e, n, r);
  }
  /**
   * Creates an event.
   *
   * @deprecated
   * @param type Type.
   * @returns Event.
   */
  createEvent(e) {
    return typeof this[b][e] == "function" ? new this[b][e]("init") : new be("init");
  }
  /**
   * Creates an Attr node.
   *
   * @param qualifiedName Name.
   * @returns Attribute.
   */
  createAttribute(e) {
    const n = Gi.createNode(this, this[b].Attr), r = yo.asciiLowerCase(e), i = r.split(":");
    return n[tt] = r, n[Tt] = i[1] ?? r, n[pn] = i[1] ? i[0] : null, n;
  }
  /**
   * Creates a namespaced Attr node.
   *
   * @param namespaceURI Namespace URI.
   * @param qualifiedName Qualified name.
   * @returns Element.
   */
  createAttributeNS(e, n) {
    const r = Gi.createNode(this, this[b].Attr), i = n.split(":");
    if (r[je] = e, r[tt] = n, r[Tt] = i[1] ?? n, r[pn] = i[1] ? i[0] : null, !e && r[pn])
      throw new this[b].DOMException(`Failed to execute 'createAttributeNS' on 'Document': The namespace URI provided ('${e || ""}') is not valid for the qualified name provided ('${n}').`, ne.namespaceError);
    return r;
  }
  /**
   * Imports a node.
   *
   * @param node Node to import.
   * @param [deep=false] Set to "true" if the clone should be deep.
   */
  importNode(e, n = !1) {
    if (!(e instanceof ot))
      throw new this[b].DOMException("Parameter 1 was not of type Node.");
    const r = e.cloneNode(n);
    return this.#e(r), r;
  }
  /**
   * Creates a range.
   *
   * @returns Range.
   */
  createRange() {
    return new this[b].Range();
  }
  /**
   * Adopts a node.
   *
   * @param node Node to adopt.
   * @returns Adopted node.
   */
  adoptNode(e) {
    if (!(e instanceof ot))
      throw new this[b].DOMException("Parameter 1 was not of type Node.");
    const n = e[xe] ? e[xe].removeChild(e) : e;
    return Object.defineProperty(n, "ownerDocument", { value: this }), n;
  }
  /**
   * Returns selection.
   *
   * @returns Selection.
   */
  getSelection() {
    return this[yd] || (this[yd] = new cW(this)), this[yd];
  }
  /**
   * Returns a boolean value indicating whether the document or any element inside the document has focus.
   *
   * @returns "true" if the document has focus.
   */
  hasFocus() {
    return !!this.activeElement;
  }
  /**
   * Creates a Processing Instruction node.
   *
   * @param target Target.
   * @param data Data.
   * @returns ProcessingInstruction.
   */
  createProcessingInstruction(e, n) {
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'createProcessingInstruction' on 'Document': 2 arguments required, but only ${arguments.length} present.`);
    if (e = String(e), n = String(n), !e || !Y$e.test(e))
      throw new this[b].DOMException(`Failed to execute 'createProcessingInstruction' on 'Document': The target provided ('${e}') is not a valid name.`);
    if (n.includes("?>"))
      throw new this[b].DOMException("Failed to execute 'createProcessingInstruction' on 'Document': The data provided ('?>') contains '?>'");
    const r = Gi.createNode(this, this[b].ProcessingInstruction);
    return r[Dn] = n, r[Ma] = e, r;
  }
  /**
   * Get element at a given point.
   *
   * @param _x horizontal coordinate
   * @param _y vertical coordinate
   * @returns Always returns null since Happy DOM does not render elements.
   */
  elementFromPoint(e, n) {
    return null;
  }
  /**
   * @override
   */
  [tn]() {
    super[tn](), this[ts] = null, this[jr] = null, this[Yd] = null, this[eu] = null, this[lu] = null, this[uh] = [], this[ym] = null, this[fc] = [], this[Il].clear(), this[Hg] = null, this[Va].clear(), this[F].clear(), this[yd] = null;
  }
  /**
   * Imports a node.
   *
   * @param node Node.
   */
  #e(e) {
    e[he] = this;
    for (const n of e[Re])
      this.#e(n);
  }
};
class Wn {
  /**
   * Inserts a set of Node objects or DOMString objects after the last child of the ParentNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param parentNode Parent node.
   * @param nodes List of Node or DOMString.
   */
  static append(e, ...n) {
    for (const r of n)
      r instanceof ot ? e.appendChild(r) : e.appendChild(e[he].createTextNode(String(r)));
  }
  /**
   * Inserts a set of Node objects or DOMString objects before the first child of the ParentNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param parentNode Parent node.
   * @param nodes List of Node or DOMString.
   */
  static prepend(e, ...n) {
    const r = e.firstChild;
    for (const i of n)
      i instanceof ot ? e.insertBefore(i, r) : e.insertBefore(e[he].createTextNode(String(i)), r);
  }
  /**
   * Replaces the existing children of a ParentNode with a specified new set of children.
   *
   * @param parentNode Parent node.
   * @param nodes List of Node or DOMString.
   */
  static replaceChildren(e, ...n) {
    const r = e[Re];
    for (; r.length; )
      e.removeChild(r[0]);
    this.append(e, ...n);
  }
  /**
   * Returns an elements by class name.
   *
   * @param parentNode Parent node.
   * @param className Tag name.
   * @returns Matching element.
   */
  static getElementsByClassName(e, n) {
    return new mi(T, () => it.querySelectorAll(e, `.${n.replace(/\s+/gm, ".")}`)[Ge]);
  }
  /**
   * Returns an elements by tag name.
   *
   * @param parentNode Parent node.
   * @param tagName Tag name.
   * @returns Matching element.
   */
  static getElementsByTagName(e, n) {
    const r = n.toUpperCase(), i = n === "*", s = (o, u) => {
      const l = [];
      for (const h of o[Ft]) {
        (i || h[Xe].toUpperCase() === r) && l.push(h), h[li].push(u);
        for (const f of s(h, u))
          l.push(f);
      }
      return l;
    }, a = () => {
      const o = e[Ae].elementsByTagName, u = o.get(n);
      if (u?.result) {
        const f = u.result.deref();
        if (f)
          return f;
      }
      const l = { result: null }, h = s(e, l);
      return l.result = new WeakRef(h), o.set(n, l), h;
    };
    return new mi(T, a);
  }
  /**
   * Returns an elements by tag name and namespace.
   *
   * @param parentNode Parent node.
   * @param namespaceURI Namespace URI.
   * @param tagName Tag name.
   * @returns Matching element.
   */
  static getElementsByTagNameNS(e, n, r) {
    const i = n === xn.html && e[he][xi] === "text/html" ? r.toUpperCase() : r, s = r === "*", a = (u, l) => {
      const h = [];
      for (const f of u[Ft]) {
        (s || f[Xe] === i) && f[je] === n && h.push(f), f[li].push(l);
        for (const m of a(f, l))
          h.push(m);
      }
      return h;
    }, o = () => {
      const u = e[Ae].elementsByTagNameNS, l = u.get(r);
      if (l?.result) {
        const m = l.result.deref();
        if (m)
          return m;
      }
      const h = { result: null }, f = a(e, h);
      return h.result = new WeakRef(f), u.set(r, h), f;
    };
    return new mi(T, o);
  }
  /**
   * Returns the first element matching a tag name.
   * This is not part of the browser standard and is only used internally (used in Document).
   *
   * @param parentNode Parent node.
   * @param tagName Tag name.
   * @returns Matching element.
   */
  static getElementByTagName(e, n) {
    const r = n.toUpperCase(), i = (l, h) => {
      for (const f of l[Ft]) {
        if (f[li].push(h), f[Xe] === r)
          return f;
        const m = i(f, h);
        if (m)
          return m;
      }
      return null;
    }, s = e[Ae].elementByTagName, a = s.get(n);
    if (a?.result) {
      const l = a.result.deref();
      if (l)
        return l;
    }
    const o = { result: null }, u = i(e, o);
    return o.result = u ? new WeakRef(u) : { deref: () => null }, s.set(n, o), u;
  }
  /**
   * Returns an element by ID.
   *
   * @param parentNode Parent node.
   * @param id ID.
   * @returns Matching element.
   */
  static getElementById(e, n) {
    if (n = String(n), e instanceof kf) {
      const u = e[Il].get(n);
      return u && u.elements.length > 0 ? u.elements[0] : null;
    }
    const r = (u, l) => {
      for (const h of u[Ft]) {
        if (h[li].push(l), h.getAttribute("id") === n)
          return h;
        const f = r(h, l);
        if (f)
          return f;
      }
      return null;
    }, i = e[Ae].elementById, s = i.get(n);
    if (s?.result) {
      const u = s.result.deref();
      if (u)
        return u;
    }
    const a = { result: null }, o = r(e, a);
    return a.result = o ? new WeakRef(o) : { deref: () => null }, i.set(n, a), o;
  }
}
class hW extends Array {
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   */
  constructor(e) {
    if (super(), e !== 1 && e !== T)
      throw new TypeError("Illegal constructor");
  }
  /**
   * Returns item by index.
   *
   * @param index Index.
   */
  item(e) {
    return this[e] ?? null;
  }
}
class q1 {
  // Items by attribute namespaceURI
  [Vl] = /* @__PURE__ */ new Map();
  // Items by attribute name
  [_a] = /* @__PURE__ */ new Map();
  // All items
  [Ge] = /* @__PURE__ */ new Map();
  /**
   * Constructor.
   *
   * @param ownerElement Owner element.
   */
  constructor(e) {
    this[zt] = e;
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[Ge].size;
  }
  /**
   * Returns string.
   *
   * @returns string.
   */
  get [Symbol.toStringTag]() {
    return "NamedNodeMap";
  }
  /**
   * Returns string.
   *
   * @returns string.
   */
  toString() {
    return "[object NamedNodeMap]";
  }
  /**
   * Iterator.
   *
   * @returns Iterator.
   */
  [Symbol.iterator]() {
    return this[Ge].values();
  }
  /**
   * Returns item by index.
   *
   * @param index Index.
   */
  item(e) {
    const n = Array.from(this[Ge].values());
    return e >= 0 && n[e] ? n[e] : null;
  }
  /**
   * Returns named item.
   *
   * @param name Name.
   * @returns Item.
   */
  getNamedItem(e) {
    return e = String(e), this[zt][je] === xn.html && this[zt][he][xi] === "text/html" ? this[_a].get(yo.asciiLowerCase(e))?.[0] || null : this[_a].get(e)?.[0] || null;
  }
  /**
   * Returns item by name and namespace.
   *
   * @param namespace Namespace.
   * @param localName Local name of the attribute.
   * @returns Item.
   */
  getNamedItemNS(e, n) {
    const r = this[Vl].get(`${e || ""}:${n}`);
    return r && (!r[pn] || r[je]) ? r : null;
  }
  /**
   * Sets named item.
   *
   * @param item Item.
   * @returns Replaced item.
   */
  setNamedItem(e) {
    return this[mc](e);
  }
  /**
   * Adds a new namespaced item.
   *
   * @alias setNamedItem()
   * @param item Item.
   * @returns Replaced item.
   */
  setNamedItemNS(e) {
    return this[mc](e);
  }
  /**
   * Removes an item.
   *
   * @throws DOMException
   * @param name Name of item.
   * @returns Removed item.
   */
  removeNamedItem(e) {
    const n = this.getNamedItem(e);
    if (!n)
      throw new this[zt][b].DOMException(`Failed to execute 'removeNamedItem' on 'NamedNodeMap': No item with name '${e}' was found.`, ne.notFoundError);
    return this[lh](n), n;
  }
  /**
   * Removes a namespaced item.
   *
   * @param namespace Namespace.
   * @param localName Local name of the item.
   * @returns Removed item.
   */
  removeNamedItemNS(e, n) {
    const r = this.getNamedItemNS(e, n);
    if (!r)
      throw new this[zt][b].DOMException(`Failed to execute 'removeNamedItemNS' on 'NamedNodeMap': No item with name '${n}' in namespace '${e}' was found.`, ne.notFoundError);
    return this[lh](r), r;
  }
  /**
   * Sets named item.
   *
   * @param item Item.
   * @param [ignoreListeners] Ignore listeners.
   * @returns Replaced item.
   */
  [mc](e, n = !1) {
    if (e[zt] !== null && e[zt] !== this[zt])
      throw new this[zt][b].DOMException("The attribute is in use.", ne.inUseAttributeError);
    e[zt] = this[zt];
    const r = this.getNamedItemNS(e[je], e[Tt]) || null, i = this[_a].get(e[tt]);
    if (r === e)
      return e;
    if (this[Vl].set(`${e[je] || ""}:${e[Tt]}`, e), this[Ge].set(`${e[je] || ""}:${e[tt]}`, e), !i?.length)
      this[_a].set(e[tt], [e]);
    else {
      const s = i.indexOf(r);
      s !== -1 && i.splice(s, 1), i.push(e);
    }
    return n || this[zt][as](e, r), r;
  }
  /**
   * Removes named item.
   *
   * @param item Item.
   * @param ignoreListeners
   */
  [lh](e, n = !1) {
    e[zt] = null, this[Vl].delete(`${e[je] || ""}:${e[Tt]}`), this[Ge].delete(`${e[je] || ""}:${e[tt]}`);
    const r = this[_a].get(e[tt]);
    if (r?.length) {
      const i = r.indexOf(e);
      i !== -1 && r.splice(i, 1), r.length || this[_a].delete(e[tt]);
    }
    n || this[zt][qa](e);
  }
}
class q$e {
  /**
   * Constructor.
   *
   * @param namedNodeMap
   */
  static createProxy(e) {
    const n = new Ws(this, [q1]);
    return new Proxy(e, {
      get: (r, i) => {
        if (i === "length")
          return e[Ge].size;
        if (i in r || typeof i == "symbol")
          return n.bind(i), r[i];
        const s = Number(i);
        return isNaN(s) ? r.getNamedItem(i) || void 0 : r.item(s);
      },
      set(r, i, s) {
        if (n.bind(i), typeof i == "symbol")
          return r[i] = s, !0;
        const a = Number(i);
        return isNaN(a) && (r[i] = s), !0;
      },
      deleteProperty(r, i) {
        if (typeof i == "symbol")
          return delete r[i], !0;
        const s = Number(i);
        return isNaN(s) && delete r[i], !0;
      },
      ownKeys() {
        const r = Array.from(e[Ge].keys());
        for (let i = 0, s = e[Ge].size; i < s; i++)
          r.push(String(i));
        return r;
      },
      has(r, i) {
        if (typeof i == "symbol")
          return !1;
        if (i in r || e[Ge].has(i))
          return !0;
        const s = Number(i);
        return !isNaN(s) && s >= 0 && s < e[Ge].size;
      },
      defineProperty(r, i, s) {
        return n.preventBinding(i), i in r ? (Object.defineProperty(r, i, s), !0) : !1;
      },
      getOwnPropertyDescriptor(r, i) {
        if (i in r || typeof i == "symbol")
          return;
        const s = Number(i);
        if (!isNaN(s)) {
          if (s >= 0) {
            const o = r.item(s);
            if (o)
              return {
                value: o,
                writable: !1,
                enumerable: !0,
                configurable: !0
              };
          }
          return;
        }
        const a = e[Ge].get(i);
        if (a)
          return {
            value: a,
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
}
class sf {
  options = {
    serializableShadowRoots: !1,
    shadowRoots: null,
    allShadowRoots: !1,
    excludeShadowRootTags: null
  };
  /**
   * Constructor.
   *
   * @param [options] Options.
   * @param [options.serializableShadowRoots] If shadow roots should be serialized.
   * @param [options.shadowRoots] Shadow roots to serialize.
   * @param [options.allShadowRoots] If all shadow roots should be serialized.
   * @param [options.excludeShadowRootTags] Tags to exclude from serialization.
   */
  constructor(e) {
    e && (e.serializableShadowRoots && (this.options.serializableShadowRoots = e.serializableShadowRoots), e.shadowRoots && (this.options.shadowRoots = e.shadowRoots), e.allShadowRoots && (this.options.allShadowRoots = e.allShadowRoots), e.excludeShadowRootTags && (this.options.excludeShadowRootTags = e.excludeShadowRootTags));
  }
  /**
   * Renders an element as HTML.
   *
   * @param root Root element.
   * @returns Result.
   */
  serializeToString(e) {
    switch (e[ve]) {
      case le.elementNode:
        const n = e, r = n[pn], i = n[Tt], s = Si[n[Tt]], a = r ? `${r}:${i}` : i;
        if (s?.contentModel === pe.noDescendants)
          return `<${a}${this.getAttributes(n)}>`;
        let o = "";
        if (n.shadowRoot && (this.options.allShadowRoots || this.options.serializableShadowRoots && n.shadowRoot[ch] || this.options.shadowRoots?.includes(n.shadowRoot)) && (!this.options.excludeShadowRootTags || !this.options.excludeShadowRootTags.includes(a))) {
          o += `<template shadowrootmode="${n.shadowRoot[Jr]}"${n.shadowRoot[ch] ? ' shadowrootserializable=""' : ""}>`;
          for (const E of n.shadowRoot[Re])
            o += this.serializeToString(E);
          o += "</template>";
        }
        const u = a === "template" ? e.content[Re] : e[Re];
        for (const E of u)
          o += this.serializeToString(E);
        return `<${a}${this.getAttributes(n)}>${o}</${a}>`;
      case ot.DOCUMENT_FRAGMENT_NODE:
      case ot.DOCUMENT_NODE:
        let l = "";
        for (const E of e[Re])
          l += this.serializeToString(E);
        return l;
      case le.commentNode:
        return `<!--${e.textContent}-->`;
      case le.processingInstructionNode:
        return `<!--?${e.target} ${e.textContent}?-->`;
      case le.textNode:
        const h = e.parentElement;
        return h && Si[h[Tt]]?.contentModel === pe.rawText ? e.textContent : hi.encodeTextContent(e.textContent);
      case le.documentTypeNode:
        const f = e, m = f.publicId ? " PUBLIC" : f.systemId ? " SYSTEM" : "", g = f.publicId ? ` "${f.publicId}"` : "", A = f.systemId ? ` "${f.systemId}"` : "";
        return `<!DOCTYPE ${f.name}${m}${g}${A}>`;
    }
    return "";
  }
  /**
   * Returns attributes as a string.
   *
   * @param element Element.
   * @returns Attributes.
   */
  getAttributes(e) {
    let n = "";
    const r = e[bt][Ge];
    !r.has(":is") && e[po] && (n += ' is="' + hi.encodeHTMLAttributeValue(e[po]) + '"');
    for (const i of r.values()) {
      const s = hi.encodeHTMLAttributeValue(i[ze]);
      n += " " + i[tt] + '="' + s + '"';
    }
    return n;
  }
}
const J$e = /[\x00-\x1F\x7F\x80-\x9F "\'><=\/\uFDD0-\uFDEF\uFFFE\uFFFF\u1FFFE\u1FFFF\u2FFFE\u2FFFF\u3FFFE\u3FFFF\u4FFFE\u4FFFF\u5FFFE\u5FFFF\u6FFFE\u6FFFF\u7FFFE\u7FFFF\u8FFFE\u8FFFF\u9FFFE\u9FFFF\uAFFFE\uAFFFF\uBFFFE\uBFFFF\uCFFFE\uCFFFF\uDFFFE\uDFFFF\uEFFFE\uEFFFF\uFFFFE\uFFFFF\u10FFFE\u10FFFF]/;
class Q$e {
  /**
   *
   * @param name the attribute name
   * @param contentType the attribute has to be valid in
   * @param context the context in which the error occurred in
   * @param context.method
   * @param context.instance
   */
  static validateAttributeName(e, n, r) {
    const { method: i, instance: s } = r;
    if (n === "text/html") {
      const a = String(e).toLowerCase();
      if (J$e.test(a) || a.length === 0 || a[0] === "-")
        throw new Tr(`Uncaught InvalidCharacterError: Failed to execute '${i}' on '${s}': '${e}' is not a valid attribute name.`, ne.invalidCharacterError);
    }
  }
}
class K {
  /**
   * Evaluates code in attribute and returns event listener.
   *
   * @param element
   * @param property Property.
   * @returns Result.
   */
  static getEventListener(e, n) {
    const r = e[F].get(n);
    if (r)
      return r;
    const i = e[he][lu];
    if (!i)
      return null;
    const s = new pt(i).getSettings();
    if (!s || !s.enableJavaScriptEvaluation)
      return null;
    const a = e.getAttribute(n);
    if (!a)
      return null;
    let o = "(function anonymous($happy_dom, event) {";
    s && !s.disableErrorCapturing && s.errorCapture === Rr.tryAndCatch && (o += `try {
`), o += a, s && !s.disableErrorCapturing && s.errorCapture === Rr.tryAndCatch && (o += "} catch(e) { $happy_dom.dispatchError(e); }"), o += "})";
    let u = null;
    try {
      u = i[wf](o, {
        filename: i.location.href
      }).bind(e, {
        dispatchError: i[tr].bind(i)
      });
    } catch (l) {
      const h = new i.SyntaxError(`Failed to read the '${n}' property from '${e.constructor.name}': ${l.message}`);
      if (s.disableErrorCapturing || s.errorCapture !== Rr.tryAndCatch)
        throw h;
      return i[tr](h), null;
    }
    return u && e[F].set(n, u), u;
  }
}
class Sc extends ot {
  static [Xe] = null;
  static [Tt] = null;
  static [je] = null;
  // Internal properties
  [dm] = null;
  [po] = null;
  [ve] = le.elementNode;
  [pn] = null;
  [zn] = null;
  [nL] = 0;
  [rL] = 0;
  [fF] = 0;
  [mF] = 0;
  [bt] = new q1(this);
  [fm] = null;
  [ts] = null;
  [hg] = null;
  [F] = /* @__PURE__ */ new Map();
  /**
   * Constructor.
   */
  constructor() {
    super(), this[Xe] || (this[Xe] = null), this[Tt] || (this[Tt] = null), this[je] || (this[je] = null);
  }
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onfullscreenerror() {
    return K.getEventListener(this, "onfullscreenerror");
  }
  set onfullscreenerror(e) {
    this[F].set("onfullscreenerror", e);
  }
  get onfullscreenchange() {
    return K.getEventListener(this, "onfullscreenchange");
  }
  set onfullscreenchange(e) {
    this[F].set("onfullscreenchange", e);
  }
  get onbeforecopy() {
    return K.getEventListener(this, "onbeforecopy");
  }
  set onbeforecopy(e) {
    this[F].set("onbeforecopy", e);
  }
  get onbeforecut() {
    return K.getEventListener(this, "onbeforecut");
  }
  set onbeforecut(e) {
    this[F].set("onbeforecut", e);
  }
  get onbeforepaste() {
    return K.getEventListener(this, "onbeforepaste");
  }
  set onbeforepaste(e) {
    this[F].set("onbeforepaste", e);
  }
  get onsearch() {
    return K.getEventListener(this, "onsearch");
  }
  set onsearch(e) {
    this[F].set("onsearch", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns tag name.
   *
   * @returns Tag name.
   */
  get tagName() {
    return this[Xe];
  }
  /**
   * Returns prefix.
   *
   * @returns Prefix.
   */
  get prefix() {
    return this[pn];
  }
  /**
   * Returns shadow root.
   *
   * @returns Shadow root.
   */
  get shadowRoot() {
    const e = this[zn];
    return e && e[Jr] === "open" ? e : null;
  }
  /**
   * Returns scroll height.
   *
   * @returns Scroll height.
   */
  get scrollHeight() {
    return this[nL];
  }
  /**
   * Returns scroll width.
   *
   * @returns Scroll width.
   */
  get scrollWidth() {
    return this[rL];
  }
  /**
   * Returns scroll top.
   *
   * @returns Scroll top.
   */
  get scrollTop() {
    return this[fF];
  }
  /**
   * Sets scroll top.
   *
   * @param value Scroll top.
   */
  set scrollTop(e) {
    this[fF] = e;
  }
  /**
   * Returns scroll left.
   *
   * @returns Scroll left.
   */
  get scrollLeft() {
    return this[mF];
  }
  /**
   * Sets scroll left.
   *
   * @param value Scroll left.
   */
  set scrollLeft(e) {
    this[mF] = e;
  }
  /**
   * Returns attributes.
   *
   * @returns Attributes.
   */
  get attributes() {
    return this[fm] || (this[fm] = q$e.createProxy(this[bt])), this[fm];
  }
  /**
   * Returns namespace URI.
   *
   * @returns Namespace URI.
   */
  get namespaceURI() {
    return this[je];
  }
  /**
   * Returns element children.
   */
  get children() {
    if (!this[ts]) {
      const e = this[Ft];
      this[ts] = new mi(T, () => e);
    }
    return this[ts];
  }
  /**
   * Returns class list.
   *
   * @returns Class list.
   */
  get classList() {
    return this[dm] || (this[dm] = new Zu(T, this, "class")), this[dm];
  }
  /**
   * Sets class list.
   *
   * @param value Class list.
   */
  set classList(e) {
    this.setAttribute("class", e);
  }
  /**
   * Returns ID.
   *
   * @returns ID.
   */
  get id() {
    return this.getAttribute("id") || "";
  }
  /**
   * Sets ID.
   *
   * @param id ID.
   */
  set id(e) {
    this.setAttribute("id", e);
  }
  /**
   * Returns class name.
   *
   * @returns Class name.
   */
  get className() {
    return this.getAttribute("class") || "";
  }
  /**
   * Sets class name.
   *
   * @param className Class name.
   */
  set className(e) {
    this.setAttribute("class", e);
  }
  /**
   * Node name.
   *
   * @returns Node name.
   */
  get nodeName() {
    return this[Xe];
  }
  /**
   * Local name.
   *
   * @returns Local name.
   */
  get localName() {
    return this[Tt];
  }
  /**
   * Returns role.
   *
   * @returns Role.
   */
  get role() {
    return this.getAttribute("role") || "";
  }
  /**
   * Sets role.
   *
   * @param role Role.
   */
  set role(e) {
    this.setAttribute("role", e);
  }
  /**
   * Previous element sibling.
   *
   * @returns Element.
   */
  get previousElementSibling() {
    return Y1.previousElementSibling(this);
  }
  /**
   * Next element sibling.
   *
   * @returns Element.
   */
  get nextElementSibling() {
    return Y1.nextElementSibling(this);
  }
  /**
   * Get text value of children.
   *
   * @returns Text content.
   */
  get textContent() {
    let e = "";
    for (const n of this[Re])
      (n[ve] === le.elementNode || n[ve] === le.textNode) && (e += n.textContent);
    return e;
  }
  /**
   * Sets text content.
   *
   * @param textContent Text content.
   */
  set textContent(e) {
    const n = this[Re];
    for (; n.length; )
      this.removeChild(n[0]);
    e && this.appendChild(this[he].createTextNode(e));
  }
  /**
   * Returns inner HTML.
   *
   * @returns HTML.
   */
  get innerHTML() {
    return this.getHTML();
  }
  /**
   * Sets inner HTML.
   *
   * @param html HTML.
   */
  set innerHTML(e) {
    const n = this[Re];
    for (; n.length; )
      this.removeChild(n[0]);
    new hu(this[b]).parse(e, this);
  }
  /**
   * Returns outer HTML.
   *
   * @returns HTML.
   */
  get outerHTML() {
    return new sf().serializeToString(this);
  }
  /**
   * Returns outer HTML.
   *
   * @param html HTML.
   */
  set outerHTML(e) {
    const n = new hu(this[b]).parse(e)[Re];
    this.replaceWith(...n);
  }
  /**
   * Last element child.
   *
   * @returns Element.
   */
  get childElementCount() {
    return this[Ft].length;
  }
  /**
   * First element child.
   *
   * @returns Element.
   */
  get firstElementChild() {
    return this[Ft][0] ?? null;
  }
  /**
   * Last element child.
   *
   * @returns Element.
   */
  get lastElementChild() {
    const e = this[Ft];
    return e[e.length - 1] ?? null;
  }
  /**
   * Returns slot.
   *
   * @returns Slot.
   */
  get slot() {
    return this.getAttributeNS(null, "slot") || "";
  }
  /**
   * Returns slot.
   *
   * @param slot Slot.
   */
  set slot(e) {
    this.setAttribute("slot", e);
  }
  /**
   * Returns inner HTML and optionally the content of shadow roots.
   *
   * @deprecated
   * @param [options] Options.
   * @param [options.includeShadowRoots] Set to "true" to include shadow roots.
   * @returns HTML.
   */
  getInnerHTML(e) {
    const n = new sf({
      allShadowRoots: !!e?.includeShadowRoots
    });
    let r = "";
    for (const i of this[Re])
      r += n.serializeToString(i);
    return r;
  }
  /**
   * Returns inner HTML and optionally the content of shadow roots.
   *
   * @param [options] Options.
   * @param [options.serializableShadowRoots] A boolean value that specifies whether to include serializable shadow roots. The default value is false.
   * @param [options.shadowRoots] An array of ShadowRoot objects to serialize. These are included regardless of whether they are marked as serializable, or if they are open or closed. The default value is an empty array.
   * @returns HTML.
   */
  getHTML(e) {
    const n = new sf({
      serializableShadowRoots: !!e?.serializableShadowRoots,
      shadowRoots: e?.shadowRoots ?? null
    });
    let r = "";
    for (const i of this[Re])
      r += n.serializeToString(i);
    return r;
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    const n = super[Bt](e);
    n[Xe] = this[Xe], n[Tt] = this[Tt], n[je] = this[je], this[zn]?.[Ld] && (n[zn] = this[zn].cloneNode(e), n[zn][Bg] = n), n[bt] = new q1(n);
    for (const r of this[bt][Ge].values())
      n[bt].setNamedItem(r.cloneNode(e));
    return n;
  }
  /**
   * Removes the node from its parent.
   */
  remove() {
    hc.remove(this);
  }
  /**
   * The Node.replaceWith() method replaces this Node in the children list of its parent with a set of Node or DOMString objects.
   *
   * @param nodes List of Node or DOMString.
   */
  replaceWith(...e) {
    hc.replaceWith(this, ...e);
  }
  /**
   * Inserts a set of Node or DOMString objects in the children list of this ChildNode's parent, just before this ChildNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  before(...e) {
    hc.before(this, ...e);
  }
  /**
   * Inserts a set of Node or DOMString objects in the children list of this ChildNode's parent, just after this ChildNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  after(...e) {
    hc.after(this, ...e);
  }
  /**
   * Inserts a set of Node objects or DOMString objects after the last child of the ParentNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  append(...e) {
    Wn.append(this, ...e);
  }
  /**
   * Inserts a set of Node objects or DOMString objects before the first child of the ParentNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  prepend(...e) {
    Wn.prepend(this, ...e);
  }
  /**
   * Replaces the existing children of a node with a specified new set of children.
   *
   * @param nodes List of Node or DOMString.
   */
  replaceChildren(...e) {
    Wn.replaceChildren(this, ...e);
  }
  /**
   * Inserts a node to the given position.
   *
   * @param position Position to insert element.
   * @param element Node to insert.
   * @returns Inserted node or null if couldn't insert.
   */
  insertAdjacentElement(e, n) {
    if (e === "beforebegin") {
      if (!this.parentElement)
        return null;
      this.parentElement.insertBefore(n, this);
    } else if (e === "afterbegin")
      this.insertBefore(n, this.firstChild);
    else if (e === "beforeend")
      this.appendChild(n);
    else if (e === "afterend") {
      if (!this.parentElement)
        return null;
      this.parentElement.insertBefore(n, this.nextSibling);
    }
    return n;
  }
  /**
   * Inserts an HTML string to the given position.
   *
   * @param position Position to insert text.
   * @param text HTML string to insert.
   */
  insertAdjacentHTML(e, n) {
    const r = new hu(this[b]).parse(n)[Re];
    for (; r.length; )
      this.insertAdjacentElement(e, r[0]);
  }
  /**
   * Inserts text to the given position.
   *
   * @param position Position to insert text.
   * @param text String to insert.
   */
  insertAdjacentText(e, n) {
    if (!n)
      return;
    const r = this[he].createTextNode(n);
    this.insertAdjacentElement(e, r);
  }
  /**
   * Sets an attribute.
   *
   * @param name Name.
   * @param value Value.
   */
  setAttribute(e, n) {
    if (Q$e.validateAttributeName(e, this[he][xi], { method: "setAttribute", instance: "Element" }), e = String(e), this[je] === xn.html) {
      const i = this[he].createAttribute(e);
      i[ze] = String(n), this[bt][mc](i);
    } else {
      const i = e.split(":");
      let s = null;
      switch (i[0]) {
        case "xmlns":
          s = !i[1] || i[1] === "xlink" ? xn.xmlns : null;
          break;
        case "xlink":
          s = xn.xlink;
          break;
      }
      const a = Gi.createNode(this[he], this[b].Attr);
      a[je] = s, a[tt] = e, a[Tt] = s && i[1] ? i[1] : e, a[pn] = s && i[1] ? i[0] : null, a[ze] = String(n), this[bt][mc](a);
    }
  }
  /**
   * Sets a namespace attribute.
   *
   * @param namespaceURI Namespace URI.
   * @param name Name.
   * @param value Value.
   */
  setAttributeNS(e, n, r) {
    const i = this[he].createAttributeNS(e, n);
    if (!e && i[pn])
      throw new this[b].DOMException("Failed to execute 'setAttributeNS' on 'Element': '' is an invalid namespace for attributes.", ne.namespaceError);
    i[ze] = String(r), this[bt].setNamedItemNS(i);
  }
  /**
   * Returns attribute names.
   *
   * @returns Attribute names.
   */
  getAttributeNames() {
    const e = [];
    for (const n of this[bt][Ge].values())
      e.push(n[tt]);
    return e;
  }
  /**
   * Returns attribute value.
   *
   * @param name Name.
   */
  getAttribute(e) {
    const n = this[bt].getNamedItem(e);
    return n ? n[ze] : null;
  }
  /**
   * Toggle an attribute.
   * Returns `true` if attribute name is eventually present, and `false` otherwise.
   *
   * @param name A DOMString specifying the name of the attribute to be toggled.
   * @param force A boolean value to determine whether the attribute should be added or removed, no matter whether the attribute is present or not at the moment.
   */
  toggleAttribute(e, n) {
    e = e.toLowerCase();
    const r = this[bt].getNamedItem(e);
    return r ? n === !0 ? !0 : (this[bt][lh](r), !1) : n === !1 ? !1 : (this.setAttribute(e, ""), !0);
  }
  /**
   * Returns namespace attribute value.
   *
   * @param namespace Namespace URI.
   * @param localName Local name.
   */
  getAttributeNS(e, n) {
    const r = this.getAttributeNodeNS(e, n);
    return r ? r[ze] : null;
  }
  /**
   * Returns a boolean value indicating whether the specified element has the attribute or not.
   *
   * @param name Attribute name.
   * @returns True if attribute exists, false otherwise.
   */
  hasAttribute(e) {
    return !!this.getAttributeNode(e);
  }
  /**
   * Returns a boolean value indicating whether the specified element has the namespace attribute or not.
   *
   * @param namespace Namespace URI.
   * @param localName Local name.
   * @returns True if attribute exists, false otherwise.
   */
  hasAttributeNS(e, n) {
    return this[bt].getNamedItemNS(e, n) !== null;
  }
  /**
   * Returns "true" if the element has attributes.
   *
   * @returns "true" if the element has attributes.
   */
  hasAttributes() {
    return this[bt][Ge].size > 0;
  }
  /**
   * Removes an attribute.
   *
   * @param name Name.
   */
  removeAttribute(e) {
    const n = this[bt].getNamedItem(e);
    n && this[bt][lh](n);
  }
  /**
   * Removes a namespace attribute.
   *
   * @param namespace Namespace URI.
   * @param localName Local name.
   */
  removeAttributeNS(e, n) {
    const r = this[bt].getNamedItemNS(e, n);
    r && this[bt][lh](r);
  }
  /**
   * Attaches a shadow root.
   *
   * @param init Shadow root init.
   * @param init.mode Shadow root mode.
   * @param [init.clonable] Clonable.
   * @param [init.delegateFocus] Delegate focus.
   * @param [init.serializable] Serializable.
   * @param [init.slotAssignment] Slot assignment.
   * @returns Shadow root.
   */
  attachShadow(e) {
    const n = this[b];
    if (!e)
      throw new n.TypeError("Failed to execute 'attachShadow' on 'Element': 1 argument required, but only 0 present.");
    if (!e.mode)
      throw new n.TypeError("Failed to execute 'attachShadow' on 'Element': Failed to read the 'mode' property from 'ShadowRootInit': Required member is undefined.");
    if (e.mode !== "open" && e.mode !== "closed")
      throw new n.TypeError(`Failed to execute 'attachShadow' on 'Element': Failed to read the 'mode' property from 'ShadowRootInit': The provided value '${e.mode}' is not a valid enum value of type ShadowRootMode.`);
    if (this[zn])
      throw new n.DOMException("Failed to execute 'attachShadow' on 'Element': Shadow root cannot be created on a host which already hosts a shadow tree.");
    const r = Gi.createNode(this[he], this[b].ShadowRoot);
    return this[zn] = r, r[Bg] = this, r[Jr] = e.mode, r[Ld] = !!e.clonable, r[Hm] = !!e.delegateFocus, r[ch] = !!e.serializable, r[Kl] = e.slotAssignment === "manual" ? "manual" : "named", r[ho](), this[zn];
  }
  /**
   * Converts to string.
   *
   * @returns String.
   */
  toString() {
    return this.outerHTML;
  }
  /**
   * Returns the size of an element and its position relative to the viewport.
   *
   * @returns DOM rect.
   */
  getBoundingClientRect() {
    return new Of();
  }
  /**
   * Returns a collection of DOMRect objects that indicate the bounding rectangles for each CSS border box in a client.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/getClientRects
   * @returns DOM rect list.
   */
  getClientRects() {
    const e = new hW(T);
    return e.push(this.getBoundingClientRect()), e;
  }
  /**
   * The matches() method checks to see if the Element would be selected by the provided selectorString.
   *
   * @param selector Selector.
   * @returns "true" if matching.
   */
  matches(e) {
    return !!it.matches(this, e);
  }
  /**
   * Traverses the Element and its parents (heading toward the document root) until it finds a node that matches the provided selector string.
   *
   * @param selector Selector.
   * @returns Closest matching element.
   */
  closest(e) {
    let n = this;
    for (; n; ) {
      if (it.matches(n, e))
        return n;
      n = n.parentElement;
    }
    return null;
  }
  /**
   * Query CSS selector to find matching elements.
   *
   * @param selector CSS selector.
   * @returns Matching elements.
   */
  querySelectorAll(e) {
    return it.querySelectorAll(this, e);
  }
  /**
   * Query CSS Selector to find matching node.
   *
   * @param selector CSS selector.
   * @returns Matching element.
   */
  querySelector(e) {
    return it.querySelector(this, e);
  }
  /**
   * Returns an elements by class name.
   *
   * @param className Tag name.
   * @returns Matching element.
   */
  getElementsByClassName(e) {
    return Wn.getElementsByClassName(this, e);
  }
  /**
   * Returns an elements by tag name.
   *
   * @param tagName Tag name.
   * @returns Matching element.
   */
  getElementsByTagName(e) {
    return Wn.getElementsByTagName(this, e);
  }
  /**
   * Returns an elements by tag name and namespace.
   *
   * @param namespaceURI Namespace URI.
   * @param tagName Tag name.
   * @returns Matching element.
   */
  getElementsByTagNameNS(e, n) {
    return Wn.getElementsByTagNameNS(this, e, n);
  }
  /**
   * The setAttributeNode() method adds a new Attr node to the specified element.
   *
   * @param attribute Attribute.
   * @returns Replaced attribute.
   */
  setAttributeNode(e) {
    return this[bt].setNamedItem(e);
  }
  /**
   * The setAttributeNodeNS() method adds a new Attr node to the specified element.
   *
   * @param attribute Attribute.
   * @returns Replaced attribute.
   */
  setAttributeNodeNS(e) {
    return this[bt].setNamedItemNS(e);
  }
  /**
   * Returns an Attr node.
   *
   * @param name Name.
   * @returns Replaced attribute.
   */
  getAttributeNode(e) {
    return this[bt].getNamedItem(e);
  }
  /**
   * Returns a namespaced Attr node.
   *
   * @param namespace Namespace.
   * @param localName Name.
   * @returns Replaced attribute.
   */
  getAttributeNodeNS(e, n) {
    return this[bt].getNamedItemNS(e, n);
  }
  /**
   * Removes an Attr node.
   *
   * @param attribute Attribute.
   * @returns Removed attribute.
   */
  removeAttributeNode(e) {
    if (e[zt] !== this)
      throw new this[b].DOMException("Failed to execute 'removeAttributeNode' on 'Element': The node provided is owned by another element.");
    return this[bt][lh](e), e;
  }
  /**
   * Scrolls to a particular set of coordinates.
   *
   * @param x X position or options object.
   * @param y Y position.
   */
  scroll(e, n) {
    if (typeof e != "object" && arguments.length === 1)
      throw new this[b].TypeError("Failed to execute 'scroll' on 'Element': The provided value is not of type 'ScrollToOptions'.");
    const r = typeof e == "object" ? e : { left: e, top: n };
    if (r.behavior === "smooth")
      this[b].setTimeout(() => {
        if (r.top !== void 0) {
          const i = Number(r.top);
          this.scrollTop = isNaN(i) ? 0 : i;
        }
        if (r.left !== void 0) {
          const i = Number(r.left);
          this.scrollLeft = isNaN(i) ? 0 : i;
        }
      });
    else {
      if (r.top !== void 0) {
        const i = Number(r.top);
        this.scrollTop = isNaN(i) ? 0 : i;
      }
      if (r.left !== void 0) {
        const i = Number(r.left);
        this.scrollLeft = isNaN(i) ? 0 : i;
      }
    }
  }
  /**
   * Scrolls to a particular set of coordinates.
   *
   * @param x X position or options object.
   * @param y Y position.
   */
  scrollTo(e, n) {
    if (typeof e != "object" && arguments.length === 1)
      throw new this[b].TypeError("Failed to execute 'scrollTo' on 'Element': The provided value is not of type 'ScrollToOptions'.");
    this.scroll(e, n);
  }
  /**
   * Scrolls by a relative amount from the current position.
   *
   * @param x Pixels to scroll by from top or scroll options object.
   * @param y Pixels to scroll by from left.
   */
  scrollBy(e, n) {
    if (typeof e != "object" && arguments.length === 1)
      throw new this[b].TypeError("Failed to execute 'scrollBy' on 'Element': The provided value is not of type 'ScrollToOptions'.");
    const r = typeof e == "object" ? e : { left: e, top: n };
    this.scroll({
      left: this.scrollLeft + (r.left ?? 0),
      top: this.scrollTop + (r.top ?? 0),
      behavior: r.behavior
    });
  }
  /**
   * Scrolls the element's ancestor containers such that the element on which scrollIntoView() is called is visible to the user.
   *
   * @param [_options] Options.
   */
  scrollIntoView(e) {
  }
  /**
   * @override
   */
  [Ht](e, n = !1) {
    const r = super[Ht](e, n);
    return this.#n(e), r;
  }
  /**
   * @override
   */
  [Ms](e) {
    const n = super[Ms](e);
    return this.#n(e), n;
  }
  /**
   * @override
   */
  [ja](e, n, r = !1) {
    const i = super[ja](e, n, r);
    return this.#n(e), i;
  }
  /**
   * Triggered when an attribute is set.
   *
   * @param attribute Attribute.
   * @param replacedAttribute Replaced attribute.
   */
  [as](e, n) {
    if (!e[tt])
      return;
    const r = n ? n[ze] : null;
    if (e[tt] === "slot" && this[xe] && this[xe][zn]) {
      const i = this[xe][zn];
      if (i && e[ze] !== r) {
        if (r !== null && n) {
          const a = i.querySelector(`slot[name="${n[ze]}"]`);
          a && a.dispatchEvent(new be("slotchange", { bubbles: !0 }));
        } else {
          const a = i.querySelector("slot:not([name])");
          a && a.dispatchEvent(new be("slotchange", { bubbles: !0 }));
        }
        const s = i.querySelector(`slot[name="${e[ze]}"]`);
        s && s.dispatchEvent(new be("slotchange", { bubbles: !0 }));
      }
    }
    this[e[tt]] !== void 0 && e[tt][0] === "o" && e[tt][1] === "n" && this[F].delete(e[tt]), e[tt] === "id" && this[st] && (n?.[ze] && this.#t(n[ze]), this.#e(e[ze])), this[oh](new Ah({
      type: Ou.attributes,
      target: this,
      attributeName: e[tt],
      oldValue: r
    }));
  }
  /**
   * Triggered when an attribute is set.
   *
   * @param removedAttribute Attribute.
   */
  [qa](e) {
    if (e[tt] === "slot" && this[xe] && this[xe][zn]) {
      const n = this[xe][zn], r = n.querySelector(`slot[name="${e[ze]}"]`), i = n.querySelector("slot:not([name])");
      r && r.dispatchEvent(new be("slotchange", { bubbles: !0 })), i && i.dispatchEvent(new be("slotchange", { bubbles: !0 }));
    }
    e[tt] === "id" && this[st] && this.#t(e[ze]), this[oh](new Ah({
      type: Ou.attributes,
      target: this,
      attributeName: e[tt],
      oldValue: e[ze]
    }));
  }
  /**
   * @override
   */
  [Hs]() {
    const e = this.getAttribute("id");
    if (e && this.#e(e), super[Hs](), this[b][ef].enqueueReaction(this, "connectedCallback"), this[zn])
      for (const n of this[Re])
        this.#n(n);
  }
  /**
   * @override
   */
  [Bs]() {
    super[Bs]();
    const e = this.getAttribute("id");
    e && this.#t(e), this[b][ef].enqueueReaction(this, "disconnectedCallback");
  }
  /**
   * @override
   */
  [tn]() {
    const e = this.getAttribute("id");
    e && this.#t(e), this[b][ef].enqueueReaction(this, "disconnectedCallback"), super[tn](), this[zn] && this[zn][tn](), this[dm] = null, this[zn] = null, this[fm] = null, this[ts] = null, this[hg] = null, this[F].clear(), this[bt][Vl].clear(), this[bt][_a].clear(), this[bt][Ge].clear();
  }
  /**
   * Adds identifier to the window object.
   *
   * @param id Identifier.
   */
  #e(e) {
    if (!e)
      return;
    const n = this[he], r = this[b];
    if (this[ci] && this[ci] !== n)
      return;
    n[Il].has(e) || n[Il].set(e, { elements: [], htmlCollection: null });
    const i = n[Il].get(e);
    if (!i)
      return;
    const s = this[yn] || this;
    i.elements.push(s), i.elements.length > 1 ? (i.htmlCollection || (i.htmlCollection = new mi(T, () => i.elements)), (!(e in r) || r[e] === i.elements[0]) && (r[e] = i.htmlCollection)) : (!(e in r) || i.htmlCollection !== null && r[e] === i.htmlCollection) && (r[e] = s);
  }
  /**
   * Removes identifier from the window object.
   *
   * @param id Identifier.
   */
  #t(e) {
    if (!e)
      return;
    const n = this[he], r = this[b];
    if (this[ci] && this[ci] !== n)
      return;
    const i = n[Il].get(e);
    if (!i)
      return;
    const s = this[yn] || this, a = i.elements.indexOf(s);
    a !== -1 && i.elements.splice(a, 1), i.elements.length === 1 ? (r[e] === i.htmlCollection && (r[e] = i.elements[0]), i.htmlCollection = null) : i.elements.length || (n[Il].delete(e), (r[e] === s || r[e] === i.htmlCollection) && delete r[e]);
  }
  /**
   * Triggered when child nodes are changed.
   *
   * @param addedOrRemovedNode Changed node.
   */
  #n(e) {
    const n = this[zn];
    if (!n || !this[st])
      return;
    const r = e.getAttribute ? e.getAttribute("slot") : null;
    if (r) {
      const i = n.querySelector(`slot[name="${r}"]`);
      i && i.dispatchEvent(new be("slotchange", { bubbles: !0 }));
    } else if (e[ve] !== le.commentNode) {
      const i = n.querySelector("slot:not([name])");
      i && i.dispatchEvent(new be("slotchange", { bubbles: !0 }));
    }
  }
}
class J1 {
  /**
   * Triggers a blur event.
   *
   * @param element Element.
   */
  static blur(e) {
    const n = e[yn] || e, r = n[he];
    if (r[jr] !== n || !n[st] || n.disabled)
      return;
    const i = r[Yd] ?? null;
    r[jr] = null, r[Na](), n.dispatchEvent(new Vm("blur", {
      relatedTarget: i,
      bubbles: !1,
      composed: !0,
      cancelable: !0
    })), n.dispatchEvent(new Vm("focusout", {
      relatedTarget: i,
      bubbles: !0,
      composed: !0,
      cancelable: !0
    }));
  }
  /**
   * Triggers a focus event.
   *
   * @param element Element.
   */
  static focus(e) {
    const n = e[yn] || e, r = n[he];
    if (r[jr] === n || !n[st] || n.disabled)
      return;
    r[Yd] = n;
    const i = r[jr];
    r[jr] !== null && r[jr].blur(), r[Yd] = null, r[jr] = n, r[Na](), n.dispatchEvent(new Vm("focus", {
      relatedTarget: i,
      bubbles: !1,
      composed: !0
    })), n.dispatchEvent(new Vm("focusin", {
      relatedTarget: i,
      bubbles: !0,
      composed: !0
    }));
  }
}
class Yc {
  /**
   * Transforms a kebab cased string to camel case.
   *
   * @param text Text string.
   * @returns Camel cased string.
   */
  static kebabToCamelCase(e) {
    const n = e.split("-");
    for (let r = 0, i = n.length; r < i; r++)
      n[r] = r > 0 ? n[r].charAt(0).toUpperCase() + n[r].slice(1) : n[r];
    return n.join("");
  }
  /**
   * Transforms a camel cased string to kebab case.
   *
   * @param text Text string.
   * @returns Kebab cased string.
   */
  static camelCaseToKebab(e) {
    return e.toString().replace(/[A-Z]+(?![a-z])|[A-Z]/g, (n, r) => (r ? "-" : "") + n.toLowerCase());
  }
}
class dW {
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param element Element.
   */
  constructor(e, n) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    return new Proxy(this, {
      get(r, i) {
        const s = n.getAttribute("data-" + Yc.camelCaseToKebab(i));
        if (s !== null)
          return s;
      },
      set(r, i, s) {
        return n.setAttribute("data-" + Yc.camelCaseToKebab(i), s), !0;
      },
      deleteProperty(r, i) {
        return n.removeAttribute("data-" + Yc.camelCaseToKebab(i)), !0;
      },
      ownKeys(r) {
        const i = [];
        for (const s of n[bt][_a].values())
          s[0][tt].startsWith("data-") && i.push(Yc.kebabToCamelCase(s[0][tt].replace("data-", "")));
        return i;
      },
      has(r, i) {
        return n.hasAttribute("data-" + Yc.camelCaseToKebab(i));
      },
      defineProperty(r, i, s) {
        return s.value === void 0 ? !1 : (n.setAttribute("data-" + Yc.camelCaseToKebab(i), s.value), !0);
      },
      getOwnPropertyDescriptor(r, i) {
        const s = n.getAttribute("data-" + Yc.camelCaseToKebab(i));
        if (s)
          return {
            value: s,
            writable: !0,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
}
let Ye = class extends Sc {
  static observedAttributes;
  // Internal properties
  [mm] = "";
  [iL] = 0;
  [sL] = 0;
  [aL] = 0;
  [oL] = 0;
  [uL] = 0;
  [lL] = 0;
  [cL] = 0;
  [hL] = 0;
  [er] = null;
  [CF] = null;
  // Private properties
  #e = null;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get oncancel() {
    return K.getEventListener(this, "oncancel");
  }
  set oncancel(e) {
    this[F].set("oncancel", e);
  }
  get onerror() {
    return K.getEventListener(this, "onerror");
  }
  set onerror(e) {
    this[F].set("onerror", e);
  }
  get onscroll() {
    return K.getEventListener(this, "onscroll");
  }
  set onscroll(e) {
    this[F].set("onscroll", e);
  }
  get onselect() {
    return K.getEventListener(this, "onselect");
  }
  set onselect(e) {
    this[F].set("onselect", e);
  }
  get onwheel() {
    return K.getEventListener(this, "onwheel");
  }
  set onwheel(e) {
    this[F].set("onwheel", e);
  }
  get oncopy() {
    return K.getEventListener(this, "oncopy");
  }
  set oncopy(e) {
    this[F].set("oncopy", e);
  }
  get oncut() {
    return K.getEventListener(this, "oncut");
  }
  set oncut(e) {
    this[F].set("oncut", e);
  }
  get onpaste() {
    return K.getEventListener(this, "onpaste");
  }
  set onpaste(e) {
    this[F].set("onpaste", e);
  }
  get oncompositionend() {
    return K.getEventListener(this, "oncompositionend");
  }
  set oncompositionend(e) {
    this[F].set("oncompositionend", e);
  }
  get oncompositionstart() {
    return K.getEventListener(this, "oncompositionstart");
  }
  set oncompositionstart(e) {
    this[F].set("oncompositionstart", e);
  }
  get oncompositionupdate() {
    return K.getEventListener(this, "oncompositionupdate");
  }
  set oncompositionupdate(e) {
    this[F].set("oncompositionupdate", e);
  }
  get onblur() {
    return K.getEventListener(this, "onblur");
  }
  set onblur(e) {
    this[F].set("onblur", e);
  }
  get onfocus() {
    return K.getEventListener(this, "onfocus");
  }
  set onfocus(e) {
    this[F].set("onfocus", e);
  }
  get onfocusin() {
    return K.getEventListener(this, "onfocusin");
  }
  set onfocusin(e) {
    this[F].set("onfocusin", e);
  }
  get onfocusout() {
    return K.getEventListener(this, "onfocusout");
  }
  set onfocusout(e) {
    this[F].set("onfocusout", e);
  }
  get onkeydown() {
    return K.getEventListener(this, "onkeydown");
  }
  set onkeydown(e) {
    this[F].set("onkeydown", e);
  }
  get onkeyup() {
    return K.getEventListener(this, "onkeyup");
  }
  set onkeyup(e) {
    this[F].set("onkeyup", e);
  }
  get onauxclick() {
    return K.getEventListener(this, "onauxclick");
  }
  set onauxclick(e) {
    this[F].set("onauxclick", e);
  }
  get onclick() {
    return K.getEventListener(this, "onclick");
  }
  set onclick(e) {
    this[F].set("onclick", e);
  }
  get oncontextmenu() {
    return K.getEventListener(this, "oncontextmenu");
  }
  set oncontextmenu(e) {
    this[F].set("oncontextmenu", e);
  }
  get ondblclick() {
    return K.getEventListener(this, "ondblclick");
  }
  set ondblclick(e) {
    this[F].set("ondblclick", e);
  }
  get onmousedown() {
    return K.getEventListener(this, "onmousedown");
  }
  set onmousedown(e) {
    this[F].set("onmousedown", e);
  }
  get onmouseenter() {
    return K.getEventListener(this, "onmouseenter");
  }
  set onmouseenter(e) {
    this[F].set("onmouseenter", e);
  }
  get onmouseleave() {
    return K.getEventListener(this, "onmouseleave");
  }
  set onmouseleave(e) {
    this[F].set("onmouseleave", e);
  }
  get onmousemove() {
    return K.getEventListener(this, "onmousemove");
  }
  set onmousemove(e) {
    this[F].set("onmousemove", e);
  }
  get onmouseout() {
    return K.getEventListener(this, "onmouseout");
  }
  set onmouseout(e) {
    this[F].set("onmouseout", e);
  }
  get onmouseover() {
    return K.getEventListener(this, "onmouseover");
  }
  set onmouseover(e) {
    this[F].set("onmouseover", e);
  }
  get onmouseup() {
    return K.getEventListener(this, "onmouseup");
  }
  set onmouseup(e) {
    this[F].set("onmouseup", e);
  }
  get ontouchcancel() {
    return K.getEventListener(this, "ontouchcancel");
  }
  set ontouchcancel(e) {
    this[F].set("ontouchcancel", e);
  }
  get ontouchend() {
    return K.getEventListener(this, "ontouchend");
  }
  set ontouchend(e) {
    this[F].set("ontouchend", e);
  }
  get ontouchmove() {
    return K.getEventListener(this, "ontouchmove");
  }
  set ontouchmove(e) {
    this[F].set("ontouchmove", e);
  }
  get ontouchstart() {
    return K.getEventListener(this, "ontouchstart");
  }
  set ontouchstart(e) {
    this[F].set("ontouchstart", e);
  }
  get oninvalid() {
    return K.getEventListener(this, "oninvalid");
  }
  set oninvalid(e) {
    this[F].set("oninvalid", e);
  }
  get onanimationcancel() {
    return K.getEventListener(this, "onanimationcancel");
  }
  set onanimationcancel(e) {
    this[F].set("onanimationcancel", e);
  }
  get onanimationend() {
    return K.getEventListener(this, "onanimationend");
  }
  set onanimationend(e) {
    this[F].set("onanimationend", e);
  }
  get onanimationiteration() {
    return K.getEventListener(this, "onanimationiteration");
  }
  set onanimationiteration(e) {
    this[F].set("onanimationiteration", e);
  }
  get onanimationstart() {
    return K.getEventListener(this, "onanimationstart");
  }
  set onanimationstart(e) {
    this[F].set("onanimationstart", e);
  }
  get onbeforeinput() {
    return K.getEventListener(this, "onbeforeinput");
  }
  set onbeforeinput(e) {
    this[F].set("onbeforeinput", e);
  }
  get oninput() {
    return K.getEventListener(this, "oninput");
  }
  set oninput(e) {
    this[F].set("oninput", e);
  }
  get onchange() {
    return K.getEventListener(this, "onchange");
  }
  set onchange(e) {
    this[F].set("onchange", e);
  }
  get ongotpointercapture() {
    return K.getEventListener(this, "ongotpointercapture");
  }
  set ongotpointercapture(e) {
    this[F].set("ongotpointercapture", e);
  }
  get onlostpointercapture() {
    return K.getEventListener(this, "onlostpointercapture");
  }
  set onlostpointercapture(e) {
    this[F].set("onlostpointercapture", e);
  }
  get onpointercancel() {
    return K.getEventListener(this, "onpointercancel");
  }
  set onpointercancel(e) {
    this[F].set("onpointercancel", e);
  }
  get onpointerdown() {
    return K.getEventListener(this, "onpointerdown");
  }
  set onpointerdown(e) {
    this[F].set("onpointerdown", e);
  }
  get onpointerenter() {
    return K.getEventListener(this, "onpointerenter");
  }
  set onpointerenter(e) {
    this[F].set("onpointerenter", e);
  }
  get onpointerleave() {
    return K.getEventListener(this, "onpointerleave");
  }
  set onpointerleave(e) {
    this[F].set("onpointerleave", e);
  }
  get onpointermove() {
    return K.getEventListener(this, "onpointermove");
  }
  set onpointermove(e) {
    this[F].set("onpointermove", e);
  }
  get onpointerout() {
    return K.getEventListener(this, "onpointerout");
  }
  set onpointerout(e) {
    this[F].set("onpointerout", e);
  }
  get onpointerover() {
    return K.getEventListener(this, "onpointerover");
  }
  set onpointerover(e) {
    this[F].set("onpointerover", e);
  }
  get onpointerup() {
    return K.getEventListener(this, "onpointerup");
  }
  set onpointerup(e) {
    this[F].set("onpointerup", e);
  }
  get ontransitioncancel() {
    return K.getEventListener(this, "ontransitioncancel");
  }
  set ontransitioncancel(e) {
    this[F].set("ontransitioncancel", e);
  }
  get ontransitionend() {
    return K.getEventListener(this, "ontransitionend");
  }
  set ontransitionend(e) {
    this[F].set("ontransitionend", e);
  }
  get ontransitionrun() {
    return K.getEventListener(this, "ontransitionrun");
  }
  set ontransitionrun(e) {
    this[F].set("ontransitionrun", e);
  }
  get ontransitionstart() {
    return K.getEventListener(this, "ontransitionstart");
  }
  set ontransitionstart(e) {
    this[F].set("ontransitionstart", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns access key.
   *
   * @returns Access key.
   */
  get accessKey() {
    return this[mm];
  }
  /**
   * Sets access key.
   *
   * @param accessKey Access key.
   */
  set accessKey(e) {
    this[mm] = e;
  }
  /**
   * Returns content editable.
   *
   * @returns Content editable.
   */
  get contentEditable() {
    const e = String(this.getAttribute("contentEditable")).toLowerCase();
    switch (e) {
      case "false":
      case "true":
      case "plaintext-only":
        return e;
      default:
        return "inherit";
    }
  }
  /**
   * Sets content editable.
   *
   * @param contentEditable Content editable.
   */
  set contentEditable(e) {
    switch (e = String(e).toLowerCase(), e) {
      case "false":
      case "true":
      case "plaintext-only":
      case "inherit":
        this.setAttribute("contentEditable", e);
        break;
      default:
        throw new this[b].SyntaxError(`Failed to set the 'contentEditable' property on 'HTMLElement': The value provided ('${e}') is not one of 'true', 'false', 'plaintext-only', or 'inherit'.`);
    }
  }
  /**
   * Returns is content editable.
   *
   * @returns Is content editable.
   */
  get isContentEditable() {
    const e = this.contentEditable;
    return e === "true" || e === "plaintext-only" ? !0 : e === "inherit" ? this[xe]?.isContentEditable ?? !1 : !1;
  }
  /**
   * Returns offset height.
   *
   * @returns Offset height.
   */
  get offsetHeight() {
    return this[iL];
  }
  /**
   * Returns offset width.
   *
   * @returns Offset width.
   */
  get offsetWidth() {
    return this[sL];
  }
  /**
   * Returns offset left.
   *
   * @returns Offset left.
   */
  get offsetLeft() {
    return this[aL];
  }
  /**
   * Returns offset top.
   *
   * @returns Offset top.
   */
  get offsetTop() {
    return this[oL];
  }
  /**
   * Returns client height.
   *
   * @returns Client height.
   */
  get clientHeight() {
    return this[uL];
  }
  /**
   * Returns client width.
   *
   * @returns Client width.
   */
  get clientWidth() {
    return this[lL];
  }
  /**
   * Returns client left.
   *
   * @returns Client left.
   */
  get clientLeft() {
    return this[cL];
  }
  /**
   * Returns client top.
   *
   * @returns Client top.
   */
  get clientTop() {
    return this[hL];
  }
  /**
   * Returns tab index.
   *
   * @returns Tab index.
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? -1 : n;
    }
    return -1;
  }
  /**
   * Returns tab index.
   *
   * @param tabIndex Tab index.
   */
  set tabIndex(e) {
    const n = Number(e);
    isNaN(n) ? this.setAttribute("tabindex", "0") : this.setAttribute("tabindex", String(n));
  }
  /**
   * Returns inner text, which is the rendered appearance of text.
   *
   * @see https://html.spec.whatwg.org/multipage/dom.html#the-innertext-idl-attribute
   * @returns Inner text.
   */
  get innerText() {
    if (!this[st])
      return this.textContent;
    let e = "";
    for (const n of this[Re])
      if (n[ve] === le.elementNode) {
        const r = n, i = this[b].getComputedStyle(r);
        if (r[Xe] !== "SCRIPT" && r[Xe] !== "STYLE" && r[Xe] !== "svg") {
          const s = i.display;
          if (s !== "none") {
            const a = i.textTransform, o = r.innerText;
            (s === "block" || s === "flex") && e && o && (e += `
`);
            let u = o;
            switch (a) {
              case "uppercase":
                u = u.toUpperCase();
                break;
              case "lowercase":
                u = u.toLowerCase();
                break;
              case "capitalize":
                u = u.replace(/(^|\s)\S/g, (l) => l.toUpperCase());
                break;
            }
            e += u;
          }
        }
      } else n[ve] === le.textNode && (e += n.textContent.replace(/[\n\r]/, ""));
    return e;
  }
  /**
   * Sets the inner text, which is the rendered appearance of text.
   *
   * @see https://html.spec.whatwg.org/multipage/dom.html#the-innertext-idl-attribute
   * @param innerText Inner text.
   */
  set innerText(e) {
    const n = this[Re];
    for (; n.length; )
      this.removeChild(n[0]);
    const r = e.split(/[\n\r]/), i = this[he];
    for (let s = 0, a = r.length; s < a; s++)
      s !== 0 && this.appendChild(i.createElement("br")), this.appendChild(i.createTextNode(r[s]));
  }
  /**
   * Returns outer text.
   *
   * @see https://html.spec.whatwg.org/multipage/dom.html#the-innertext-idl-attribute
   * @returns HTML.
   */
  get outerText() {
    return this.innerText;
  }
  /**
   * Sets outer text.
   *
   * @see https://html.spec.whatwg.org/multipage/dom.html#the-innertext-idl-attribute
   * @param text Text.
   */
  set outerText(e) {
    if (!this[xe])
      throw new this[b].DOMException("Failed to set the 'outerHTML' property on 'Element': This element has no parent node.");
    const n = e.split(/[\n\r]/);
    for (let r = 0, i = n.length; r < i; r++)
      r !== 0 && this[xe].insertBefore(this[he].createElement("br"), this), this[xe].insertBefore(this[he].createTextNode(n[r]), this);
    this[xe].removeChild(this);
  }
  /**
   * Returns style.
   *
   * @returns Style.
   */
  get style() {
    return this[er] || (this[er] = new vh(T, this[b], { element: this })), this[er];
  }
  /**
   * Sets style.
   *
   * @param cssText Style as text.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style#setting_styles
   */
  set style(e) {
    this.style.cssText = typeof e == "string" ? e : "";
  }
  /**
   * Returns data set.
   *
   * @returns Data set.
   */
  get dataset() {
    return this[CF] ??= new dW(T, this);
  }
  /**
   * Returns direction.
   *
   * @returns Direction.
   */
  get dir() {
    return this.getAttribute("dir") || "";
  }
  /**
   * Returns direction.
   *
   * @param direction Direction.
   */
  set dir(e) {
    this.setAttribute("dir", e);
  }
  /**
   * Returns hidden.
   *
   * @returns Hidden.
   */
  get hidden() {
    return this.getAttribute("hidden") !== null;
  }
  /**
   * Returns hidden.
   *
   * @param hidden Hidden.
   */
  set hidden(e) {
    e ? this.setAttribute("hidden", "") : this.removeAttribute("hidden");
  }
  /**
   * Returns inert.
   *
   * @returns Inert.
   */
  get inert() {
    return this.getAttribute("inert") !== null;
  }
  /**
   * Returns inert.
   *
   * @param inert Inert.
   */
  set inert(e) {
    e ? this.setAttribute("inert", "") : this.removeAttribute("inert");
  }
  /**
   * Returns language.
   *
   * @returns Language.
   */
  get lang() {
    return this.getAttribute("lang") || "";
  }
  /**
   * Returns language.
   *
   * @param language Language.
   */
  set lang(e) {
    this.setAttribute("lang", e);
  }
  /**
   * Returns title.
   *
   * @returns Title.
   */
  get title() {
    return this.getAttribute("title") || "";
  }
  /**
   * Returns title.
   *
   * @param title Title.
   */
  set title(e) {
    this.setAttribute("title", e);
  }
  /**
   * Returns popover.
   *
   * @returns Popover.
   */
  get popover() {
    switch (this.getAttribute("popover")) {
      case null:
        return null;
      case "":
      case "auto":
        return "auto";
      case "manual":
        return "manual";
      default:
        return "manual";
    }
  }
  /**
   * Sets popover.
   *
   * @param value Value.
   */
  set popover(e) {
    if (e === null) {
      this.removeAttribute("popover");
      return;
    }
    this.setAttribute("popover", e);
  }
  /**
   * Triggers a click event.
   */
  click() {
    this.dispatchEvent(new Z7("click", {
      bubbles: !0,
      composed: !0,
      cancelable: !0
    }));
  }
  /**
   * Triggers a blur event.
   */
  blur() {
    J1.blur(this);
  }
  /**
   * Triggers a focus event.
   */
  focus() {
    J1.focus(this);
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    const n = super[Bt](e);
    return n[mm] = this[mm], n;
  }
  /**
   * @override
   * @see https://html.spec.whatwg.org/multipage/dom.html#htmlelement
   */
  [Hs]() {
    const e = this[b], n = this[Tt], r = e.customElements[Mu];
    if (this.constructor === e.HTMLElement && n.includes("-") && r && !this.#e) {
      const i = this.#t.bind(this), s = r.get(n);
      s ? s.unshift(i) : r.set(n, [i]), this.#e = i;
    }
    super[Hs]();
  }
  /**
   * @override
   */
  [Bs]() {
    const e = this[b], n = this[Tt], r = e.customElements[Mu];
    if (this.constructor === e.HTMLElement && n.includes("-") && r) {
      const i = r.get(n);
      if (i && this.#e) {
        const s = i.indexOf(this.#e);
        s !== -1 && i.splice(s, 1), i.length || r.delete(n), this.#e = null;
      }
    }
    super[Bs]();
  }
  /**
   * @override
   */
  [as](e, n) {
    super[as](e, n), this[b][ef].enqueueReaction(this, "attributeChangedCallback", [e.name, n?.value ?? null, e.value]);
  }
  /**
   * @override
   */
  [qa](e) {
    super[qa](e), this[b][ef].enqueueReaction(this, "attributeChangedCallback", [e.name, e.value, null]);
  }
  /**
   * @override
   */
  [tn]() {
    super[tn](), this[er] = null, this[CF] = null;
  }
  /**
   * Triggered when a custom element is connected to the DOM.
   */
  #t() {
    if (!this[xe])
      return;
    const e = this[b], n = this[Tt], r = this[he].createElement(n), i = r[Ae];
    r[Re] = this[Re], r[Ft] = this[Ft], r[eh] = null, r[ts] = null, r[st] = this[st], r[ci] = this[ci], r[Cn] = this[Cn], r[xe] = this[xe], r[zr] = this[zr], r[Wi] = this[Wi], r[ea] = this[ea], r[po] = this[po], r[Ae] = this[Ae], r[li] = this[li], r[bt][Vl] = this[bt][Vl], r[bt][_a] = this[bt][_a], r[bt][Ge] = this[bt][Ge];
    for (const l of r[bt][Ge].values())
      l[zt] = r;
    this[Na](), this[Re] = [], this[Ft] = [], this[eh] = null, this[ts] = null, this[xe] = null, this[ci] = null, this[Cn] = null, this[zr] = null, this[Wi] = null, this[ea] = [], this[po] = null, this[Ae] = i, this[li] = [], this[bt][Vl] = /* @__PURE__ */ new Map(), this[bt][_a] = /* @__PURE__ */ new Map(), this[bt][Ge] = /* @__PURE__ */ new Map();
    for (const l of r[Re])
      l[xe] = r;
    const s = r[xe][Re], a = r[xe][Ft];
    s[s.indexOf(this)] = r, a[a.indexOf(this)] = r;
    const o = e.customElements[Mu], u = o.get(n);
    if (u && this.#e) {
      const l = u.indexOf(this.#e);
      l !== -1 && u.splice(l, 1), u.length || o.delete(n), this.#e = null;
    }
    r[st] && (r[zn] && (r[zn][st] = !0), r[Hs]());
  }
};
class fW {
  element;
  /**
   * Constructor.
   *
   * @param element Element.
   */
  constructor(e) {
    this.element = e;
  }
  /**
   * Returns the hyperlink's URL's origin.
   *
   * @returns Origin.
   */
  getOrigin() {
    try {
      return new URL(this.getHref()).origin;
    } catch {
      return "";
    }
  }
  /**
   * Returns href.
   *
   * @returns Href.
   */
  getHref() {
    if (!this.element.hasAttribute("href"))
      return "";
    try {
      return new URL(this.element.getAttribute("href"), this.element[he].location.href).href;
    } catch {
      return this.element.getAttribute("href");
    }
  }
  /**
   * Sets href.
   *
   * @param href Href.
   */
  setHref(e) {
    this.element.setAttribute("href", e);
  }
  /**
   * Returns protocol.
   *
   * @returns Protocol.
   */
  getProtocol() {
    try {
      return new URL(this.getHref()).protocol;
    } catch {
      return "";
    }
  }
  /**
   * Sets protocol.
   *
   * @param protocol Protocol.
   */
  setProtocol(e) {
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return;
    }
    n.protocol = e, this.element.setAttribute("href", n.href);
  }
  /**
   * Returns username.
   *
   * @returns Username.
   */
  getUsername() {
    try {
      return new URL(this.getHref()).username;
    } catch {
      return "";
    }
  }
  /**
   * Sets username.
   *
   * @param username Username.
   */
  setUsername(e) {
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return;
    }
    n.username = e, this.element.setAttribute("href", n.href);
  }
  /**
   * Returns password.
   *
   * @returns Password.
   */
  getPassword() {
    try {
      return new URL(this.getHref()).password;
    } catch {
      return "";
    }
  }
  /**
   * Sets password.
   *
   * @param password Password.
   */
  setPassword(e) {
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return;
    }
    n.password = e, this.element.setAttribute("href", n.href);
  }
  /**
   * Returns host.
   *
   * @returns Host.
   */
  getHost() {
    try {
      return new URL(this.getHref()).host;
    } catch {
      return "";
    }
  }
  /**
   * Sets host.
   *
   * @param host Host.
   */
  setHost(e) {
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return;
    }
    n.host = e, this.element.setAttribute("href", n.href);
  }
  /**
   * Returns hostname.
   *
   * @returns Hostname.
   */
  getHostname() {
    try {
      return new URL(this.getHref()).hostname;
    } catch {
      return "";
    }
  }
  /**
   * Sets hostname.
   *
   * @param hostname Hostname.
   */
  setHostname(e) {
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return;
    }
    n.hostname = e, this.element.setAttribute("href", n.href);
  }
  /**
   * Returns port.
   *
   * @returns Port.
   */
  getPort() {
    try {
      return new URL(this.getHref()).port;
    } catch {
      return "";
    }
  }
  /**
   * Sets port.
   *
   * @param port Port.
   */
  setPort(e) {
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return;
    }
    n.port = e, this.element.setAttribute("href", n.href);
  }
  /**
   * Returns pathname.
   *
   * @returns Pathname.
   */
  getPathname() {
    try {
      return new URL(this.getHref()).pathname;
    } catch {
      return "";
    }
  }
  /**
   * Sets pathname.
   *
   * @param pathname Pathname.
   */
  setPathname(e) {
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return;
    }
    n.pathname = e, this.element.setAttribute("href", n.href);
  }
  /**
   * Returns search.
   *
   * @returns Search.
   */
  getSearch() {
    try {
      return new URL(this.getHref()).search;
    } catch {
      return "";
    }
  }
  /**
   * Sets search.
   *
   * @param search Search.
   */
  setSearch(e) {
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return;
    }
    n.search = e, this.element.setAttribute("href", n.href);
  }
  /**
   * Returns hash.
   *
   * @returns Hash.
   */
  getHash() {
    const e = this.element.getAttribute("href");
    if (e?.[0] === "#")
      return e;
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return "";
    }
    return n.hash;
  }
  /**
   * Sets hash.
   *
   * @param hash Hash.
   */
  setHash(e) {
    let n;
    try {
      n = new URL(this.getHref());
    } catch {
      return;
    }
    n.hash = e, this.element.setAttribute("href", n.href);
  }
}
class X$e extends Ye {
  [La] = null;
  #e = new fW(this);
  /**
   * Returns download.
   *
   * @returns download.
   */
  get download() {
    return this.getAttribute("download") || "";
  }
  /**
   * Sets download.
   *
   * @param download Download.
   */
  set download(e) {
    this.setAttribute("download", e);
  }
  /**
   * Returns hash.
   *
   * @returns Hash.
   */
  get hash() {
    return this.#e.getHash();
  }
  /**
   * Sets hash.
   *
   * @param hash Hash.
   */
  set hash(e) {
    this.#e.setHash(e);
  }
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this.#e.getHref();
  }
  /**
   * Sets href.
   *
   * @param href Href.
   */
  set href(e) {
    this.#e.setHref(e);
  }
  /**
   * Returns hreflang.
   *
   * @returns Hreflang.
   */
  get hreflang() {
    return this.getAttribute("hreflang") || "";
  }
  /**
   * Sets hreflang.
   *
   * @param hreflang Hreflang.
   */
  set hreflang(e) {
    this.setAttribute("hreflang", e);
  }
  /**
   * Returns the hyperlink's URL's origin.
   *
   * @returns Origin.
   */
  get origin() {
    return this.#e.getOrigin();
  }
  /**
   * Returns ping.
   *
   * @returns Ping.
   */
  get ping() {
    return this.getAttribute("ping") || "";
  }
  /**
   * Sets ping.
   *
   * @param ping Ping.
   */
  set ping(e) {
    this.setAttribute("ping", e);
  }
  /**
   * Returns protocol.
   *
   * @returns Protocol.
   */
  get protocol() {
    return this.#e.getProtocol();
  }
  /**
   * Sets protocol.
   *
   * @param protocol Protocol.
   */
  set protocol(e) {
    this.#e.setProtocol(e);
  }
  /**
   * Returns username.
   *
   * @returns Username.
   */
  get username() {
    return this.#e.getUsername();
  }
  /**
   * Sets username.
   *
   * @param username Username.
   */
  set username(e) {
    this.#e.setUsername(e);
  }
  /**
   * Returns password.
   *
   * @returns Password.
   */
  get password() {
    return this.#e.getPassword();
  }
  /**
   * Sets password.
   *
   * @param password Password.
   */
  set password(e) {
    this.#e.setPassword(e);
  }
  /**
   * Returns pathname.
   *
   * @returns Pathname.
   */
  get pathname() {
    return this.#e.getPathname();
  }
  /**
   * Sets pathname.
   *
   * @param pathname Pathname.
   */
  set pathname(e) {
    this.#e.setPathname(e);
  }
  /**
   * Returns port.
   *
   * @returns Port.
   */
  get port() {
    return this.#e.getPort();
  }
  /**
   * Sets port.
   *
   * @param port Port.
   */
  set port(e) {
    this.#e.setPort(e);
  }
  /**
   * Returns host.
   *
   * @returns Host.
   */
  get host() {
    return this.#e.getHost();
  }
  /**
   * Sets host.
   *
   * @param host Host.
   */
  set host(e) {
    this.#e.setHost(e);
  }
  /**
   * Returns hostname.
   *
   * @returns Hostname.
   */
  get hostname() {
    return this.#e.getHostname();
  }
  /**
   * Sets hostname.
   *
   * @param hostname Hostname.
   */
  set hostname(e) {
    this.#e.setHostname(e);
  }
  /**
   * Returns referrerPolicy.
   *
   * @returns Referrer Policy.
   */
  get referrerPolicy() {
    return this.getAttribute("referrerPolicy") || "";
  }
  /**
   * Sets referrerPolicy.
   *
   * @param referrerPolicy Referrer Policy.
   */
  set referrerPolicy(e) {
    this.setAttribute("referrerPolicy", e);
  }
  /**
   * Returns rel.
   *
   * @returns Rel.
   */
  get rel() {
    return this.getAttribute("rel") || "";
  }
  /**
   * Sets rel.
   *
   * @param rel Rel.
   */
  set rel(e) {
    this.setAttribute("rel", e);
  }
  /**
   * Returns rel list.
   *
   * @returns Rel list.
   */
  get relList() {
    return this[La] || (this[La] = new Zu(T, this, "rel")), this[La];
  }
  /**
   * Sets rel list.
   *
   * @param value Value.
   */
  set relList(e) {
    this.setAttribute("rel", e);
  }
  /**
   * Returns search.
   *
   * @returns Search.
   */
  get search() {
    return this.#e.getSearch();
  }
  /**
   * Sets search.
   *
   * @param search Search.
   */
  set search(e) {
    this.#e.setSearch(e);
  }
  /**
   * Returns target.
   *
   * @returns target.
   */
  get target() {
    return this.getAttribute("target") || "";
  }
  /**
   * Sets target.
   *
   * @param target Target.
   */
  set target(e) {
    this.setAttribute("target", e);
  }
  /**
   * Returns text.
   *
   * @returns text.
   */
  get text() {
    return this.textContent;
  }
  /**
   * Sets text.
   *
   * @param text Text.
   */
  set text(e) {
    this.textContent = e;
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "";
  }
  /**
   * Sets type.
   *
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
  /**
   * @override
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
  /**
   * @override
   */
  set tabIndex(e) {
    super.tabIndex = e;
  }
  /**
   * @override
   */
  toString() {
    return this.href;
  }
  /**
   * @override
   */
  dispatchEvent(e) {
    const n = super.dispatchEvent(e);
    if (!e[vo] && e.type === "click" && e instanceof _o && (e.eventPhase === mr.none || e.eventPhase === mr.bubbling)) {
      const r = this.href;
      if (r) {
        const i = [];
        this.relList.contains("noreferrer") && i.push("noreferrer"), this.relList.contains("noopener") && i.push("noopener"), this[b].open(r, this.target || "_self", i.join(",")), this[b].closed && e.stopImmediatePropagation();
      }
    }
    return n;
  }
}
class Z$e extends Ye {
  [La] = null;
  #e = new fW(this);
  /**
   * Returns alt.
   *
   * @returns Alt.
   */
  get alt() {
    return this.getAttribute("alt") || "";
  }
  /**
   * Sets alt.
   *
   * @param alt Alt.
   */
  set alt(e) {
    this.setAttribute("alt", e);
  }
  /**
   * Returns coords.
   *
   * @returns Coords.
   */
  get coords() {
    return this.getAttribute("coords") || "";
  }
  /**
   * Sets coords.
   *
   * @param coords Coords.
   */
  set coords(e) {
    this.setAttribute("coords", e);
  }
  /**
   * Returns shape.
   *
   * @returns Shape.
   */
  get shape() {
    return this.getAttribute("shape") || "";
  }
  /**
   * Sets shape.
   *
   * @param shape Shape.
   */
  set shape(e) {
    this.setAttribute("shape", e);
  }
  /**
   * Returns download.
   *
   * @returns download.
   */
  get download() {
    return this.getAttribute("download") || "";
  }
  /**
   * Sets download.
   *
   * @param download Download.
   */
  set download(e) {
    this.setAttribute("download", e);
  }
  /**
   * Returns referrerPolicy.
   *
   * @returns Referrer Policy.
   */
  get referrerPolicy() {
    return this.getAttribute("referrerPolicy") || "";
  }
  /**
   * Sets referrerPolicy.
   *
   * @param referrerPolicy Referrer Policy.
   */
  set referrerPolicy(e) {
    this.setAttribute("referrerPolicy", e);
  }
  /**
   * Returns ping.
   *
   * @returns Ping.
   */
  get ping() {
    return this.getAttribute("ping") || "";
  }
  /**
   * Sets ping.
   *
   * @param ping Ping.
   */
  set ping(e) {
    this.setAttribute("ping", e);
  }
  /**
   * Returns rel.
   *
   * @returns Rel.
   */
  get rel() {
    return this.getAttribute("rel") || "";
  }
  /**
   * Sets rel.
   *
   * @param rel Rel.
   */
  set rel(e) {
    this.setAttribute("rel", e);
  }
  /**
   * Returns rel list.
   *
   * @returns Rel list.
   */
  get relList() {
    return this[La] || (this[La] = new Zu(T, this, "rel")), this[La];
  }
  /**
   * Sets rel list.
   *
   * @param value Value.
   */
  set relList(e) {
    this.setAttribute("rel", e);
  }
  /**
   * Returns target.
   *
   * @returns target.
   */
  get target() {
    return this.getAttribute("target") || "";
  }
  /**
   * Sets target.
   *
   * @param target Target.
   */
  set target(e) {
    this.setAttribute("target", e);
  }
  /**
   * Returns the hyperlink's URL's origin.
   *
   * @returns Origin.
   */
  get origin() {
    return this.#e.getOrigin();
  }
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this.#e.getHref();
  }
  /**
   * Sets href.
   *
   * @param href Href.
   */
  set href(e) {
    this.#e.setHref(e);
  }
  /**
   * Returns protocol.
   *
   * @returns Protocol.
   */
  get protocol() {
    return this.#e.getProtocol();
  }
  /**
   * Sets protocol.
   *
   * @param protocol Protocol.
   */
  set protocol(e) {
    this.#e.setProtocol(e);
  }
  /**
   * Returns username.
   *
   * @returns Username.
   */
  get username() {
    return this.#e.getUsername();
  }
  /**
   * Sets username.
   *
   * @param username Username.
   */
  set username(e) {
    this.#e.setUsername(e);
  }
  /**
   * Returns password.
   *
   * @returns Password.
   */
  get password() {
    return this.#e.getPassword();
  }
  /**
   * Sets password.
   *
   * @param password Password.
   */
  set password(e) {
    this.#e.setPassword(e);
  }
  /**
   * Returns host.
   *
   * @returns Host.
   */
  get host() {
    return this.#e.getHost();
  }
  /**
   * Sets host.
   *
   * @param host Host.
   */
  set host(e) {
    this.#e.setHost(e);
  }
  /**
   * Returns hostname.
   *
   * @returns Hostname.
   */
  get hostname() {
    return this.#e.getHostname();
  }
  /**
   * Sets hostname.
   *
   * @param hostname Hostname.
   */
  set hostname(e) {
    this.#e.setHostname(e);
  }
  /**
   * Returns port.
   *
   * @returns Port.
   */
  get port() {
    return this.#e.getPort();
  }
  /**
   * Sets port.
   *
   * @param port Port.
   */
  set port(e) {
    this.#e.setPort(e);
  }
  /**
   * Returns pathname.
   *
   * @returns Pathname.
   */
  get pathname() {
    return this.#e.getPathname();
  }
  /**
   * Sets pathname.
   *
   * @param pathname Pathname.
   */
  set pathname(e) {
    this.#e.setPathname(e);
  }
  /**
   * Returns search.
   *
   * @returns Search.
   */
  get search() {
    return this.#e.getSearch();
  }
  /**
   * Sets search.
   *
   * @param search Search.
   */
  set search(e) {
    this.#e.setSearch(e);
  }
  /**
   * Returns hash.
   *
   * @returns Hash.
   */
  get hash() {
    return this.#e.getHash();
  }
  /**
   * Sets hash.
   *
   * @param hash Hash.
   */
  set hash(e) {
    this.#e.setHash(e);
  }
  /**
   * @override
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
  /**
   * @override
   */
  set tabIndex(e) {
    super.tabIndex = e;
  }
  /**
   * @override
   */
  toString() {
    return this.href;
  }
  /**
   * @override
   */
  dispatchEvent(e) {
    const n = super.dispatchEvent(e);
    if (!e[vo] && e[qn] === "click" && e[ia] === mr.none && e instanceof _o) {
      const r = this.href;
      r && (this[b].open(r, this.target || "_self"), this[b].closed && e.stopImmediatePropagation());
    }
    return n;
  }
}
class Vy {
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   */
  constructor(e) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
  }
  /**
   * Returns length.
   */
  get length() {
    return 0;
  }
  /**
   * Returns `Symbol.toStringTag`.
   *
   * @returns `Symbol.toStringTag`.
   */
  get [Symbol.toStringTag]() {
    return "TimeRanges";
  }
  /**
   * Returns `[object NodeList]`.
   *
   * @returns `[object NodeList]`.
   */
  toLocaleString() {
    return "[object TimeRanges]";
  }
  /**
   * Returns `[object NodeList]`.
   *
   * @returns `[object NodeList]`.
   */
  toString() {
    return "[object TimeRanges]";
  }
  /**
   * Returns start.
   *
   * @param _index Index.
   * @returns Start.
   */
  start(e) {
    return 0;
  }
  /**
   * Returns end.
   *
   * @param _index Index.
   * @returns End.
   */
  end(e) {
    return 0;
  }
}
class QL extends be {
  track;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.track = n?.track ?? null;
  }
}
let mW = class gW extends Xr {
  // Public properties
  active = !0;
  id = _f.randomUUID();
  // Events
  onaddtrack = null;
  onremovetrack = null;
  // Internal properties
  [Go] = [];
  /**
   * Constructor.
   *
   * @param [streamOrTracks] Stream or tracks.
   */
  constructor(e) {
    if (super(), !this[b])
      throw new TypeError(`Failed to construct '${this.constructor.name}': '${this.constructor.name}' was constructed outside a Window context.`);
    e !== void 0 && (this[Go] = e instanceof gW ? e[Go].slice() : e);
  }
  /**
   * Adds a track.
   *
   * @param track Track.
   */
  addTrack(e) {
    this[Go].includes(e) || (this[Go].push(e), this.dispatchEvent(new QL("addtrack", { track: e })));
  }
  /**
   * Returns a clone.
   *
   * @returns Clone.
   */
  clone() {
    return new this.constructor(this);
  }
  /**
   * Returns audio tracks.
   *
   * @returns Audio tracks.
   */
  getAudioTracks() {
    return this[Go].filter((e) => e.kind === "audio");
  }
  /**
   * Returns track by id.
   *
   * @param id Id.
   * @returns Track.
   */
  getTrackById(e) {
    for (const n of this[Go])
      if (n.id === e)
        return n;
    return null;
  }
  /**
   * Returns video tracks.
   *
   * @returns Video tracks.
   */
  getVideoTracks() {
    return this[Go].filter((e) => e.kind === "video");
  }
  /**
   * Removes a track.
   *
   * @param track Track.
   */
  removeTrack(e) {
    const n = this[Go].indexOf(e);
    n !== -1 && (this[Go].splice(n, 1), this.dispatchEvent(new QL("removetrack", { track: e })));
  }
};
var nx;
(function(t) {
  t.subtitles = "subtitles", t.captions = "captions", t.descriptions = "descriptions", t.chapters = "chapters", t.metadata = "metadata";
})(nx || (nx = {}));
const ih = nx;
class K2 extends Ye {
  // Internal Properties
  [bF] = 1;
  [ud] = !0;
  [yF] = 0;
  [AF] = 1;
  [EF] = 1;
  [gm] = !1;
  [ld] = !1;
  [SF] = !0;
  [gL] = new Vy(T);
  [pL] = NaN;
  [Zi] = null;
  [bL] = !1;
  [yL] = 0;
  [Og] = 0;
  [AL] = !1;
  [EL] = new Vy(T);
  [NF] = "";
  [SL] = new Vy(T);
  [wL] = new this[b].RemotePlayback();
  [rb] = null;
  [_F] = null;
  [DF] = null;
  [wF] = [];
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onabort() {
    return K.getEventListener(this, "onabort");
  }
  set onabort(e) {
    this[F].set("onabort", e);
  }
  get oncanplay() {
    return K.getEventListener(this, "oncanplay");
  }
  set oncanplay(e) {
    this[F].set("oncanplay", e);
  }
  get oncanplaythrough() {
    return K.getEventListener(this, "oncanplaythrough");
  }
  set oncanplaythrough(e) {
    this[F].set("oncanplaythrough", e);
  }
  get ondurationchange() {
    return K.getEventListener(this, "ondurationchange");
  }
  set ondurationchange(e) {
    this[F].set("ondurationchange", e);
  }
  get onemptied() {
    return K.getEventListener(this, "onemptied");
  }
  set onemptied(e) {
    this[F].set("onemptied", e);
  }
  get onended() {
    return K.getEventListener(this, "onended");
  }
  set onended(e) {
    this[F].set("onended", e);
  }
  get onloadeddata() {
    return K.getEventListener(this, "onloadeddata");
  }
  set onloadeddata(e) {
    this[F].set("onloadeddata", e);
  }
  get onloadedmetadata() {
    return K.getEventListener(this, "onloadedmetadata");
  }
  set onloadedmetadata(e) {
    this[F].set("onloadedmetadata", e);
  }
  get onloadstart() {
    return K.getEventListener(this, "onloadstart");
  }
  set onloadstart(e) {
    this[F].set("onloadstart", e);
  }
  get onpause() {
    return K.getEventListener(this, "onpause");
  }
  set onpause(e) {
    this[F].set("onpause", e);
  }
  get onplay() {
    return K.getEventListener(this, "onplay");
  }
  set onplay(e) {
    this[F].set("onplay", e);
  }
  get onplaying() {
    return K.getEventListener(this, "onplaying");
  }
  set onplaying(e) {
    this[F].set("onplaying", e);
  }
  get onprogress() {
    return K.getEventListener(this, "onprogress");
  }
  set onprogress(e) {
    this[F].set("onprogress", e);
  }
  get onratechange() {
    return K.getEventListener(this, "onratechange");
  }
  set onratechange(e) {
    this[F].set("onratechange", e);
  }
  get onresize() {
    return K.getEventListener(this, "onresize");
  }
  set onresize(e) {
    this[F].set("onresize", e);
  }
  get onseeked() {
    return K.getEventListener(this, "onseeked");
  }
  set onseeked(e) {
    this[F].set("onseeked", e);
  }
  get onseeking() {
    return K.getEventListener(this, "onseeking");
  }
  set onseeking(e) {
    this[F].set("onseeking", e);
  }
  get onstalled() {
    return K.getEventListener(this, "onstalled");
  }
  set onstalled(e) {
    this[F].set("onstalled", e);
  }
  get onsuspend() {
    return K.getEventListener(this, "onsuspend");
  }
  set onsuspend(e) {
    this[F].set("onsuspend", e);
  }
  get ontimeupdate() {
    return K.getEventListener(this, "ontimeupdate");
  }
  set ontimeupdate(e) {
    this[F].set("ontimeupdate", e);
  }
  get onvolumechange() {
    return K.getEventListener(this, "onvolumechange");
  }
  set onvolumechange(e) {
    this[F].set("onvolumechange", e);
  }
  get onwaiting() {
    return K.getEventListener(this, "onwaiting");
  }
  set onwaiting(e) {
    this[F].set("onwaiting", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns buffered.
   *
   * @returns Buffered.
   */
  get buffered() {
    return this[gL];
  }
  /**
   * Returns duration.
   *
   * @returns Duration.
   */
  get duration() {
    return this[pL];
  }
  /**
   * Returns error.
   *
   * @returns Error.
   */
  get error() {
    return this[Zi];
  }
  /**
   * Returns ended.
   *
   * @returns Ended.
   */
  get ended() {
    return this[bL];
  }
  /**
   * Returns networkState.
   *
   * @returns NetworkState.
   */
  get networkState() {
    return this[yL];
  }
  /**
   * Returns readyState.
   *
   * @returns ReadyState.
   */
  get readyState() {
    return this[Og];
  }
  /**
   * Return a RemotePlayback object instance associated with the media element.
   *
   * @returns RemotePlayback.
   */
  get remote() {
    return this[wL];
  }
  /**
   * Returns seeking.
   *
   * @returns Seeking.
   */
  get seeking() {
    return this[AL];
  }
  /**
   * Returns seekable.
   *
   * @returns Seekable.
   */
  get seekable() {
    return this[EL];
  }
  /**
   * Returns sinkId.
   *
   * @returns SinkId.
   */
  get sinkId() {
    return this[NF];
  }
  /**
   * Returns played.
   *
   * @returns Played.
   */
  get played() {
    return this[SL];
  }
  /**
   * Returns autoplay.
   *
   * @returns Autoplay.
   */
  get autoplay() {
    return this.getAttribute("autoplay") !== null;
  }
  /**
   * Sets autoplay.
   *
   * @param autoplay Autoplay.
   */
  set autoplay(e) {
    e ? this.setAttribute("autoplay", "") : this.removeAttribute("autoplay");
  }
  /**
   * Returns controls.
   *
   * @returns Controls.
   */
  get controls() {
    return this.getAttribute("controls") !== null;
  }
  /**
   * Sets controls.
   *
   * @param controls Controls.
   */
  set controls(e) {
    e ? this.setAttribute("controls", "") : this.removeAttribute("controls");
  }
  /**
   * Returns loop.
   *
   * @returns Loop.
   */
  get loop() {
    return this.getAttribute("loop") !== null;
  }
  /**
   * Sets loop.
   *
   * @param loop Loop.
   */
  set loop(e) {
    e ? this.setAttribute("loop", "") : this.removeAttribute("loop");
  }
  /**
   * Returns preload.
   *
   * @returns preload.
   */
  get preload() {
    return this.getAttribute("preload") || "auto";
  }
  /**
   * Sets preload.
   *
   * @param preload preload.
   */
  set preload(e) {
    this.setAttribute("preload", e);
  }
  /**
   * Returns src.
   *
   * @returns Src.
   */
  get src() {
    if (!this.hasAttribute("src"))
      return "";
    try {
      return new URL(this.getAttribute("src"), this[he].location.href).href;
    } catch {
      return this.getAttribute("src");
    }
  }
  /**
   * Sets src.
   *
   * @param src Src.
   */
  set src(e) {
    this.setAttribute("src", e), e && (this.dispatchEvent(new be("canplay", { bubbles: !1, cancelable: !1 })), this.dispatchEvent(new be("durationchange", { bubbles: !1, cancelable: !1 })));
  }
  /**
   * Returns controlsList.
   *
   * @returns ControlsList.
   */
  get controlsList() {
    return this[rb] === null && (this[rb] = new Zu(T, this, "controlslist")), this[rb];
  }
  /**
   * Sets controlsList.
   *
   * @param value Value.
   */
  set controlsList(e) {
    this.setAttribute("controlslist", e);
  }
  /**
   * Returns mediaKeys.
   *
   * @returns MediaKeys.
   */
  get mediaKeys() {
    return this[_F];
  }
  /**
   * Returns muted.
   *
   * @returns Muted.
   */
  get muted() {
    return this[gm] ? this[gm] : this[ld] ? !1 : this.getAttribute("muted") !== null;
  }
  /**
   * Sets muted.
   *
   * @param muted Muted.
   */
  set muted(e) {
    this[gm] = !!e, !e && !this[ld] ? this.removeAttribute("muted") : this.setAttribute("muted", "");
  }
  /**
   * Returns defaultMuted.
   *
   * @returns DefaultMuted.
   */
  get defaultMuted() {
    return this[ld];
  }
  /**
   * Sets defaultMuted.
   *
   * @param defaultMuted DefaultMuted.
   */
  set defaultMuted(e) {
    this[ld] = !!e, !this[ld] && !this[gm] ? this.removeAttribute("muted") : this.setAttribute("muted", "");
  }
  /**
   * Returns disableRemotePlayback.
   *
   * @returns DisableRemotePlayback.
   */
  get disableRemotePlayback() {
    return this.getAttribute("disableremoteplayback") !== null;
  }
  /**
   * Sets disableRemotePlayback.
   *
   * @param disableRemotePlayback DisableRemotePlayback.
   */
  set disableRemotePlayback(e) {
    e ? this.setAttribute("disableremoteplayback", "") : this.removeAttribute("disableremoteplayback");
  }
  /**
   * A MediaStream representing the media to play or that has played in the current HTMLMediaElement, or null if not assigned.
   *
   * @returns MediaStream.
   */
  get srcObject() {
    return this[DF];
  }
  /**
   * Sets src object.
   *
   * @param srcObject SrcObject.
   */
  set srcObject(e) {
    if (e !== null && !(e instanceof mW))
      throw new this[b].TypeError("Failed to set the 'srcObject' property on 'HTMLMediaElement': The provided value is not of type 'MediaStream'.");
    this[DF] = e;
  }
  /**
   * Returns text track list.
   *
   * @returns Text track list.
   */
  get textTracks() {
    const e = [];
    for (const n of this[wF])
      e.push(n);
    for (const n of this.querySelectorAll("track")[Ge])
      e.push(n.track);
    return new this[b].TextTrackList(T, e);
  }
  /**
   * Returns currentSrc.
   *
   * @returns CurrentrSrc.
   */
  get currentSrc() {
    const e = this.src;
    if (e)
      return e;
    const n = this.querySelector("source");
    return n ? n.src : "";
  }
  /**
   * Returns volume.
   *
   * @returns Volume.
   */
  get volume() {
    return this[bF];
  }
  /**
   * Sets volume.
   *
   * @param volume Volume.
   */
  set volume(e) {
    const n = Number(e);
    if (isNaN(n))
      throw new this[b].TypeError("Failed to set the 'volume' property on 'HTMLMediaElement': The provided double value is non-finite.");
    if (n < 0 || n > 1)
      throw new this[b].DOMException(`Failed to set the 'volume' property on 'HTMLMediaElement': The volume provided (${n}) is outside the range [0, 1].`, ne.indexSizeError);
    this[bF] = n;
  }
  /**
   * Returns crossOrigin.
   *
   * @returns CrossOrigin.
   */
  get crossOrigin() {
    const e = this.getAttribute("crossorigin");
    return e === "use-credentials" ? "use-credentials" : e !== null ? "anonymous" : null;
  }
  /**
   * Sets crossOrigin.
   *
   * @param crossOrigin CrossOrigin.
   */
  set crossOrigin(e) {
    this.setAttribute("crossorigin", e);
  }
  /**
   * Returns currentTime.
   *
   * @returns CurrentTime.
   */
  get currentTime() {
    return this[yF];
  }
  /**
   * Sets currentTime.
   *
   * @param currentTime CurrentTime.
   */
  set currentTime(e) {
    const n = Number(e);
    if (isNaN(n))
      throw new this[b].TypeError("Failed to set the 'currentTime' property on 'HTMLMediaElement': The provided double value is non-finite.");
    this[yF] = n;
  }
  /**
   * Returns playbackRate.
   *
   * @returns PlaybackRate.
   */
  get playbackRate() {
    return this[AF];
  }
  /**
   * Sets playbackRate.
   *
   * @param playbackRate PlaybackRate.
   */
  set playbackRate(e) {
    const n = Number(e);
    if (isNaN(n))
      throw new this[b].TypeError("Failed to set the 'playbackRate' property on 'HTMLMediaElement': The provided double value is non-finite.");
    this[AF] = n;
  }
  /**
   * Returns defaultPlaybackRate.
   *
   * @returns DefaultPlaybackRate.
   */
  get defaultPlaybackRate() {
    return this[EF];
  }
  /**
   * Sets defaultPlaybackRate.
   *
   * @param defaultPlaybackRate DefaultPlaybackRate.
   */
  set defaultPlaybackRate(e) {
    const n = Number(e);
    if (isNaN(n))
      throw new this[b].TypeError("Failed to set the 'defaultPlaybackRate' property on 'HTMLMediaElement': The provided double value is non-finite.");
    this[EF] = n;
  }
  /**
   * Returns preservesPitch.
   *
   * @returns PlaybackRate.
   */
  get preservesPitch() {
    return this[SF];
  }
  /**
   * Sets preservesPitch.
   *
   * @param preservesPitch PreservesPitch.
   */
  set preservesPitch(e) {
    this[SF] = !!e;
  }
  /**
   * Returns paused.
   *
   * @returns Paused.
   */
  get paused() {
    return this[ud];
  }
  /**
   * @override
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
  /**
   * @override
   */
  set tabIndex(e) {
    super.tabIndex = e;
  }
  /**
   * Adds a new text track to the media element.
   *
   * @param kind The kind of text track.
   * @param label The label of the text track.
   * @param language The language of the text track data.
   */
  addTextTrack(e, n, r) {
    const i = this[b];
    if (arguments.length === 0)
      throw new i.TypeError("Failed to execute 'addTextTrack' on 'HTMLMediaElement': 1 argument required, but only 0 present.");
    if (!ih[e])
      throw new i.TypeError(`Failed to execute 'addTextTrack' on 'HTMLMediaElement': The provided value '${e}' is not a valid enum value of type TextTrackKind.`);
    const s = new i.TextTrack(T);
    return s[Wu] = e, s[$g] = n || "", s[$1] = r || "", this[wF].push(s), s;
  }
  /**
   * Pause played media.
   */
  pause() {
    this[ud] || (this[ud] = !0, this.dispatchEvent(new be("pause", { bubbles: !1, cancelable: !1 })));
  }
  /**
   * Start playing media.
   */
  async play() {
    this[ud] && (this[ud] = !1, this.dispatchEvent(new be("play", { bubbles: !1, cancelable: !1 })), this.dispatchEvent(new be("playing", { bubbles: !1, cancelable: !1 })));
  }
  /**
   * Reports how likely it is that the current browser will be able to play media of a given MIME type.
   *
   * @param _type MIME type.
   * @returns Can play type.
   */
  canPlayType(e) {
    return "";
  }
  /**
   * Quickly seeks the media to the new time with precision tradeoff.
   *
   * @param _time Time.
   */
  fastSeek(e) {
  }
  /**
   * Load media.
   */
  load() {
    this.dispatchEvent(new be("emptied", { bubbles: !1, cancelable: !1 }));
  }
  /**
   * Sets media keys.
   *
   * @param mediaKeys MediaKeys.
   * @returns Promise.
   */
  async setMediaKeys(e) {
    this[_F] = e;
  }
  /**
   * Sets sink id.
   *
   * @param sinkId SinkId.
   * @returns Promise.
   */
  async setSinkId(e) {
    this[NF] = e;
  }
  /**
   * Returns MediaStream, captures a stream of the media content.
   *
   * @returns MediaStream.
   */
  captureStream() {
    return new this[b].MediaStream();
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
}
class pW extends K2 {
}
class eHe extends Ye {
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    if (!this.hasAttribute("href"))
      return this[he].location.href;
    try {
      return new URL(this.getAttribute("href"), this[he].location.href).href;
    } catch {
      return this.getAttribute("href");
    }
  }
  /**
   * Sets href.
   *
   * @param href Href.
   */
  set href(e) {
    this.setAttribute("href", e);
  }
  /**
   * Returns target.
   *
   * @returns Target.
   */
  get target() {
    return this.getAttribute("target") || "";
  }
  /**
   * Sets target.
   *
   * @param target Target.
   */
  set target(e) {
    this.setAttribute("target", e);
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
}
class tHe extends Ye {
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onafterprint() {
    return K.getEventListener(this, "onafterprint");
  }
  set onafterprint(e) {
    this[F].set("onafterprint", e);
  }
  get onbeforeprint() {
    return K.getEventListener(this, "onbeforeprint");
  }
  set onbeforeprint(e) {
    this[F].set("onbeforeprint", e);
  }
  get onbeforeunload() {
    return K.getEventListener(this, "onbeforeunload");
  }
  set onbeforeunload(e) {
    this[F].set("onbeforeunload", e);
  }
  get ongamepadconnected() {
    return K.getEventListener(this, "ongamepadconnected");
  }
  set ongamepadconnected(e) {
    this[F].set("ongamepadconnected", e);
  }
  get ongamepaddisconnected() {
    return K.getEventListener(this, "ongamepaddisconnected");
  }
  set ongamepaddisconnected(e) {
    this[F].set("ongamepaddisconnected", e);
  }
  get onhashchange() {
    return K.getEventListener(this, "onhashchange");
  }
  set onhashchange(e) {
    this[F].set("onhashchange", e);
  }
  get onlanguagechange() {
    return K.getEventListener(this, "onlanguagechange");
  }
  set onlanguagechange(e) {
    this[F].set("onlanguagechange", e);
  }
  get onmessage() {
    return K.getEventListener(this, "onmessage");
  }
  set onmessage(e) {
    this[F].set("onmessage", e);
  }
  get onmessageerror() {
    return K.getEventListener(this, "onmessageerror");
  }
  set onmessageerror(e) {
    this[F].set("onmessageerror", e);
  }
  get onoffline() {
    return K.getEventListener(this, "onoffline");
  }
  set onoffline(e) {
    this[F].set("onoffline", e);
  }
  get ononline() {
    return K.getEventListener(this, "ononline");
  }
  set ononline(e) {
    this[F].set("ononline", e);
  }
  get onpagehide() {
    return K.getEventListener(this, "onpagehide");
  }
  set onpagehide(e) {
    this[F].set("onpagehide", e);
  }
  get onpageshow() {
    return K.getEventListener(this, "onpageshow");
  }
  set onpageshow(e) {
    this[F].set("onpageshow", e);
  }
  get onpopstate() {
    return K.getEventListener(this, "onpopstate");
  }
  set onpopstate(e) {
    this[F].set("onpopstate", e);
  }
  get onrejectionhandled() {
    return K.getEventListener(this, "onrejectionhandled");
  }
  set onrejectionhandled(e) {
    this[F].set("onrejectionhandled", e);
  }
  get onstorage() {
    return K.getEventListener(this, "onstorage");
  }
  set onstorage(e) {
    this[F].set("onstorage", e);
  }
  get onunhandledrejection() {
    return K.getEventListener(this, "onunhandledrejection");
  }
  set onunhandledrejection(e) {
    this[F].set("onunhandledrejection", e);
  }
  get onunload() {
    return K.getEventListener(this, "onunload");
  }
  set onunload(e) {
    this[F].set("onunload", e);
  }
}
class nHe extends Ye {
}
const GF = /[\n\r]/gm, Ay = (t) => t.map((e) => parseInt(e, 10));
class rHe {
  /**
   * Sanitizes a value.
   *
   * @param input Input.
   * @param value Value.
   */
  static sanitize(e, n) {
    switch (e.type) {
      case "password":
      case "search":
      case "tel":
      case "text":
        return n.replace(GF, "");
      case "color":
        return /^#[a-fA-F\d]{6}$/.test(n) ? n.toLowerCase() : "#000000";
      case "email":
        return e.multiple ? n.split(",").map((r) => r.trim()).join(",") : n.trim().replace(GF, "");
      case "number":
        return isNaN(Number.parseFloat(n)) ? "" : n;
      case "range": {
        const r = Number.parseFloat(n), i = parseFloat(e.min) || 0, s = parseFloat(e.max) || 100;
        return isNaN(r) ? s < i ? String(i) : String((i + s) / 2) : r < i ? String(i) : r > s ? String(s) : n;
      }
      case "url":
        return n.trim().replace(GF, "");
      case "date":
        return this.sanitizeDate(n);
      case "datetime-local": {
        const r = n.match(/^(\d\d\d\d)-(\d\d)-(\d\d)[T ](\d\d):(\d\d)(?::(\d\d)(?:\.(\d{1,3}))?)?$/);
        if (!r)
          return "";
        const i = this.sanitizeDate(n.slice(0, 10));
        let s = this.sanitizeTime(n.slice(11));
        return i && s ? (r[6] !== void 0 && (s.indexOf(".") !== -1 && (s = s.replace(/(?:\.0*|(\.\d+?)0+)$/, "$1")), s = s.replace(/(\d\d:\d\d)(:00)$/, "$1")), i + "T" + s) : "";
      }
      case "month":
        return n.match(/^(\d\d\d\d)-(\d\d)$/) && this.parseMonthComponent(n) && this.checkBoundaries(n, e.min, e.max) ? n : "";
      case "time":
        return n = this.sanitizeTime(n), n && this.checkBoundaries(n, e.min, e.max) ? n : "";
      case "week": {
        const r = n.match(/^(\d\d\d\d)-W(\d\d)$/);
        if (!r)
          return "";
        const [i, s] = Ay(r.slice(1, 3));
        if (i <= 0 || s < 1 || s > 53)
          return "";
        const a = this.lastIsoWeekOfYear(i);
        return s < 1 || s > 52 + a || !this.checkBoundaries(n, e.min, e.max) ? "" : n;
      }
    }
    return n;
  }
  /**
   * Checks if a value is within the boundaries of min and max.
   *
   * @param value
   * @param min
   * @param max
   */
  static checkBoundaries(e, n, r) {
    return n && n > e ? !1 : !(r && r < e);
  }
  /**
   * Parses the month component of a date string.
   *
   * @param value
   */
  static parseMonthComponent(e) {
    const [n, r] = e.split("-"), [i, s] = Ay([n, r]);
    return isNaN(i) || isNaN(s) || i <= 0 || s < 1 || s > 12 ? "" : e;
  }
  /**
   * Returns the last ISO week of a year.
   *
   * @param year
   */
  static lastIsoWeekOfYear = (e) => {
    const n = new Date(+e, 11, 31), r = (n.getDay() + 6) % 7;
    n.setDate(n.getDate() - r + 3);
    const i = n.getTime();
    return n.setMonth(0, 1), n.getDay() !== 4 && n.setMonth(0, 1 + (4 - n.getDay() + 7) % 7), 1 + Math.ceil((i - n.getTime()) / 6048e5);
  };
  /**
   * Sanitizes a date string.
   *
   * @param value
   */
  static sanitizeDate(e) {
    const n = e.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!n || !this.parseMonthComponent(e.slice(0, 7)))
      return "";
    const [i, s, a] = Ay(n.slice(1, 4));
    if (a < 1 || a > 31)
      return "";
    const o = new Date(i, s, 0).getDate();
    return a > o ? "" : e;
  }
  /**
   * Sanitizes a time string.
   *
   * @param value
   */
  static sanitizeTime(e) {
    const n = e.match(/^(\d{2}):(\d{2})(?::(\d{2}(?:\.(\d{1,3}))?))?$/);
    if (!n)
      return "";
    const [r, i] = Ay(n.slice(1, 3)), s = parseFloat(n[3] || "0") * 1e3;
    return r > 23 || i > 59 || s > 59999 ? "" : s === 0 ? `${n[1]}:${n[2]}` : `${n[1]}:${n[2]}${s >= 1e4 ? `:${s / 1e3}` : `:0${s / 1e3}`}`;
  }
}
var rx;
(function(t) {
  t.preserve = "preserve", t.select = "select", t.start = "start", t.end = "end";
})(rx || (rx = {}));
const dc = rx;
var ix;
(function(t) {
  t.none = "none", t.forward = "forward", t.backward = "backward";
})(ix || (ix = {}));
const na = ix;
class XL {
  /**
   * Steps up or down.
   *
   * @param type Type.
   * @param value Value.
   * @param direction Direction.
   * @param [increment] Increment.
   * @returns New value.
   */
  static step(e, n, r, i) {
    switch (e) {
      case "number":
        return String(Number(n) + (i !== void 0 ? i * r : r));
      case "date":
      case "month":
      case "week":
      case "time":
      case "datetime-local":
      case "range":
        return null;
      default:
        throw new Tr("This form element is not steppable.");
    }
  }
}
class sx extends Array {
  /**
   * Constructor.
   */
  constructor() {
    super(0);
  }
  /**
   * Returns `Symbol.toStringTag`.
   *
   * @returns `Symbol.toStringTag`.
   */
  get [Symbol.toStringTag]() {
    return this.constructor.name;
  }
  /**
   * Returns item by index.
   *
   * @param index Index.
   * @returns Item.
   */
  item(e) {
    return this[e] || null;
  }
}
class WF {
  /**
   * Returns iso week number from given date
   *
   * @see https://stackoverflow.com/a/6117889
   * @param date Date or number.
   * @returns Iso-week string.
   */
  static dateIsoWeek(e) {
    e = typeof e == "number" ? new Date(e) : e, e = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate())), e.setUTCDate(e.getUTCDate() + 4 - (e.getUTCDay() || 7));
    const n = new Date(Date.UTC(e.getUTCFullYear(), 0, 1)), r = Math.ceil(((e - n) / 864e5 + 1) / 7);
    return `${e.getUTCFullYear()}-W${r < 10 ? "0" : ""}${r}`;
  }
  /**
   * Returns a date object for monday of given iso week string (\d\d\d\d-W\d\d)
   *
   * @param isoWeek Iso-week string.
   * @returns Date.
   */
  static isoWeekDate(e) {
    const [, n, r] = e.match(/^(\d{4})-W(\d{2})$/) || [];
    if (!n || !r || Number(r) > 53 || Number(r) < 1)
      return /* @__PURE__ */ new Date("x");
    const i = /* @__PURE__ */ new Date(`${n}-01-01T00:00Z`), a = ((/* @__PURE__ */ new Date(`${n}-01-04T00:00Z`)).getUTCDay() + 6) % 7, o = 1 + (Number(r) - 1) * 7 - a + 3;
    return i.setUTCDate(o), i.getUTCFullYear() > Number(n) ? /* @__PURE__ */ new Date("x") : i;
  }
}
class Ph {
  /**
   * Returns label elements for a form element.
   *
   * @param element Element to get labels for.
   * @returns Label elements.
   */
  static getAssociatedLabelElements(e) {
    const n = e.id;
    let r;
    n && e[st] ? r = (e[ci] || e[he]).querySelectorAll(`label[for="${n}"]`)[Ge] : r = [];
    let i = e[xe];
    for (; i; ) {
      if (i.tagName === "LABEL") {
        r.push(i);
        break;
      }
      i = i[xe];
    }
    return new xo(T, r);
  }
}
class zo extends Ye {
  [ze] = null;
  [we] = 0;
  [Fe] = 0;
  [md] = null;
  [fi] = "";
  [rs] = new Lh(this);
  [jo] = new sx();
  [zc] = !1;
  [Cn] = null;
  [Xd] = null;
  // Private properties
  #e = null;
  #t = null;
  #n = na.none;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get oninput() {
    return K.getEventListener(this, "oninput");
  }
  set oninput(e) {
    this[F].set("oninput", e);
  }
  get oninvalid() {
    return K.getEventListener(this, "oninvalid");
  }
  set oninvalid(e) {
    this[F].set("oninvalid", e);
  }
  get onselectionchange() {
    return K.getEventListener(this, "onselectionchange");
  }
  set onselectionchange(e) {
    this[F].set("onselectionchange", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns default checked.
   *
   * @returns Default checked.
   */
  get defaultChecked() {
    return this.hasAttribute("checked");
  }
  /**
   * Sets default checked.
   *
   * @param defaultChecked Default checked.
   */
  set defaultChecked(e) {
    e ? this.setAttribute("checked", "") : this.removeAttribute("checked");
  }
  /**
   * Returns files.
   *
   * @returns Files.
   */
  get files() {
    return this[jo];
  }
  /**
   * Sets files.
   *
   * @param files Files.
   */
  set files(e) {
    this[jo] = e;
  }
  /**
   * Returns form action.
   *
   * @returns Form action.
   */
  get formAction() {
    if (!this.hasAttribute("formaction"))
      return this[he].location.href;
    try {
      return new Pr(this.getAttribute("formaction"), this[he].location.href).href;
    } catch {
      return "";
    }
  }
  /**
   * Sets form action.
   *
   * @param formAction Form action.
   */
  set formAction(e) {
    this.setAttribute("formaction", e);
  }
  /**
   * Returns form enctype.
   *
   * @returns Form enctype.
   */
  get formEnctype() {
    return this.getAttribute("formenctype") || "";
  }
  /**
   * Sets form enctype.
   *
   * @param formEnctype Form enctype.
   */
  set formEnctype(e) {
    this.setAttribute("formenctype", e);
  }
  /**
   * Returns form method.
   *
   * @returns Form method.
   */
  get formMethod() {
    return this.getAttribute("formmethod") || "";
  }
  /**
   * Sets form method.
   *
   * @param formMethod Form method.
   */
  set formMethod(e) {
    this.setAttribute("formmethod", e);
  }
  /**
   * Returns no validate.
   *
   * @returns No validate.
   */
  get formNoValidate() {
    return this.getAttribute("formnovalidate") !== null;
  }
  /**
   * Sets no validate.
   *
   * @param formNoValidate No validate.
   */
  set formNoValidate(e) {
    e ? this.setAttribute("formnovalidate", "") : this.removeAttribute("formnovalidate");
  }
  /**
   * Returns form target.
   *
   * @returns Form target.
   */
  get formTarget() {
    return this.getAttribute("formtarget") || "";
  }
  /**
   * Sets form target.
   *
   * @param formTarget Form target.
   */
  set formTarget(e) {
    this.setAttribute("formtarget", e);
  }
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    if (this[Cn])
      return this[Cn];
    const e = this.getAttribute("form");
    return !e || !this[st] ? null : this[he].getElementById(e);
  }
  /**
   * Returns validation message.
   *
   * @returns Validation message.
   */
  get validationMessage() {
    return this[fi];
  }
  /**
   * Returns validity.
   *
   * @returns Validity.
   */
  get validity() {
    return this[rs];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we];
  }
  /**
   * Sets height.
   *
   * @param height Height.
   */
  set height(e) {
    this[we] = e, this.setAttribute("height", String(e));
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe];
  }
  /**
   * Sets width.
   *
   * @param width Width.
   */
  set width(e) {
    this[Fe] = e, this.setAttribute("width", String(e));
  }
  /**
   * Returns size.
   *
   * @returns Size.
   */
  get size() {
    const e = this.getAttribute("size");
    return e !== null ? parseInt(e) : 20;
  }
  /**
   * Sets size.
   *
   * @param size Size.
   */
  set size(e) {
    this.setAttribute("size", String(e));
  }
  /**
   * Returns minlength.
   *
   * @returns Min length.
   */
  get minLength() {
    const e = this.getAttribute("minlength");
    return e !== null ? parseInt(e) : -1;
  }
  /**
   * Sets minlength.
   *
   * @param minLength Min length.
   */
  set minLength(e) {
    this.setAttribute("minlength", String(e));
  }
  /**
   * Returns maxlength.
   *
   * @returns Max length.
   */
  get maxLength() {
    const e = this.getAttribute("maxlength");
    return e !== null ? parseInt(e) : -1;
  }
  /**
   * Sets maxlength.
   *
   * @param maxlength Max length.
   */
  set maxLength(e) {
    this.setAttribute("maxlength", String(e));
  }
  /**
   * Returns type.
   *
   * @returns Type. Defaults to "text".
   */
  get type() {
    return this.getAttribute("type") || "text";
  }
  /**
   * Sets type.
   *
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e.toLowerCase());
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns alt.
   *
   * @returns Alt.
   */
  get alt() {
    return this.getAttribute("alt") || "";
  }
  /**
   * Sets alt.
   *
   * @param alt Alt.
   */
  set alt(e) {
    this.setAttribute("alt", e);
  }
  /**
   * Returns min.
   *
   * @returns Min.
   */
  get min() {
    return this.getAttribute("min") || "";
  }
  /**
   * Sets min.
   *
   * @param min Min.
   */
  set min(e) {
    this.setAttribute("min", e);
  }
  /**
   * Returns max.
   *
   * @returns Max.
   */
  get max() {
    return this.getAttribute("max") || "";
  }
  /**
   * Sets max.
   *
   * @param max Max.
   */
  set max(e) {
    this.setAttribute("max", e);
  }
  /**
   * Returns pattern.
   *
   * @returns Pattern.
   */
  get pattern() {
    return this.getAttribute("pattern") || "";
  }
  /**
   * Sets pattern.
   *
   * @param pattern Pattern.
   */
  set pattern(e) {
    this.setAttribute("pattern", e);
  }
  /**
   * Returns placeholder.
   *
   * @returns Placeholder.
   */
  get placeholder() {
    return this.getAttribute("placeholder") || "";
  }
  /**
   * Sets placeholder.
   *
   * @param placeholder Placeholder.
   */
  set placeholder(e) {
    this.setAttribute("placeholder", e);
  }
  /**
   * Returns step.
   *
   * @returns Step.
   */
  get step() {
    return this.getAttribute("step") || "";
  }
  /**
   * Sets step.
   *
   * @param step Step.
   */
  set step(e) {
    this.setAttribute("step", e);
  }
  /**
   * Returns inputmode.
   *
   * @returns Inputmode.
   */
  get inputMode() {
    return this.getAttribute("inputmode") || "";
  }
  /**
   * Sets inputmode.
   *
   * @param inputmode Inputmode.
   */
  set inputMode(e) {
    this.setAttribute("inputmode", e);
  }
  /**
   * Returns accept.
   *
   * @returns Accept.
   */
  get accept() {
    return this.getAttribute("accept") || "";
  }
  /**
   * Sets accept.
   *
   * @param accept Accept.
   */
  set accept(e) {
    this.setAttribute("accept", e);
  }
  /**
   * Returns allowdirs.
   *
   * @returns Allowdirs.
   */
  get allowdirs() {
    return this.getAttribute("allowdirs") || "";
  }
  /**
   * Sets allowdirs.
   *
   * @param allowdirs Allowdirs.
   */
  set allowdirs(e) {
    this.setAttribute("allowdirs", e);
  }
  /**
   * Returns autocomplete.
   *
   * @returns Autocomplete.
   */
  get autocomplete() {
    return this.getAttribute("autocomplete") || "";
  }
  /**
   * Sets autocomplete.
   *
   * @param autocomplete Autocomplete.
   */
  set autocomplete(e) {
    this.setAttribute("autocomplete", e);
  }
  /**
   * Returns src.
   *
   * @returns Src.
   */
  get src() {
    return this.getAttribute("src") || "";
  }
  /**
   * Sets src.
   *
   * @param src Src.
   */
  set src(e) {
    this.setAttribute("src", e);
  }
  /**
   * Returns defaultValue.
   *
   * @returns Defaultvalue.
   */
  get defaultValue() {
    return this.getAttribute("value") || "";
  }
  /**
   * Sets defaultValue.
   *
   * @param defaultValue Defaultvalue.
   */
  set defaultValue(e) {
    this.setAttribute("value", e);
  }
  /**
   * Returns read only.
   *
   * @returns Read only.
   */
  get readOnly() {
    return this.getAttribute("readonly") !== null;
  }
  /**
   * Sets read only.
   *
   * @param readOnly Read only.
   */
  set readOnly(e) {
    e ? this.setAttribute("readonly", "") : this.removeAttribute("readonly");
  }
  /**
   * Returns disabled.
   *
   * @returns Disabled.
   */
  get disabled() {
    return this.getAttribute("disabled") !== null;
  }
  /**
   * Sets disabled.
   *
   * @param disabled Disabled.
   */
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  /**
   * Returns autofocus.
   *
   * @returns Autofocus.
   */
  get autofocus() {
    return this.getAttribute("autofocus") !== null;
  }
  /**
   * Sets autofocus.
   *
   * @param autofocus Autofocus.
   */
  set autofocus(e) {
    e ? this.setAttribute("autofocus", "") : this.removeAttribute("autofocus");
  }
  /**
   * Returns required.
   *
   * @returns Required.
   */
  get required() {
    return this.getAttribute("required") !== null;
  }
  /**
   * Sets required.
   *
   * @param required Required.
   */
  set required(e) {
    e ? this.setAttribute("required", "") : this.removeAttribute("required");
  }
  /**
   * Returns indeterminate.
   *
   * @returns Indeterminate.
   */
  get indeterminate() {
    return this[zc];
  }
  /**
   * Sets indeterminate.
   *
   * @param indeterminate Indeterminate.
   */
  set indeterminate(e) {
    this[zc] = !!e;
  }
  /**
   * Returns multiple.
   *
   * @returns Multiple.
   */
  get multiple() {
    return this.getAttribute("multiple") !== null;
  }
  /**
   * Sets multiple.
   *
   * @param multiple Multiple.
   */
  set multiple(e) {
    e ? this.setAttribute("multiple", "") : this.removeAttribute("multiple");
  }
  /**
   * Returns checked.
   *
   * @returns Checked.
   */
  get checked() {
    return this[md] !== null ? this[md] : this.getAttribute("checked") !== null;
  }
  /**
   * Sets checked.
   *
   * @param checked Checked.
   */
  set checked(e) {
    this.#i(e);
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    switch (this.type) {
      case "hidden":
      case "submit":
      case "image":
      case "reset":
      case "button":
        return this.getAttribute("value") || "";
      case "checkbox":
      case "radio":
        const e = this.getAttribute("value");
        return e !== null ? e : "on";
      case "file":
        return this[jo].length > 0 ? "/fake/path/" + this[jo][0].name : "";
    }
    return this[ze] === null ? this.getAttribute("value") || "" : this[ze];
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    switch (e = e === null ? "" : String(e), this.type) {
      case "hidden":
      case "submit":
      case "image":
      case "reset":
      case "button":
      case "checkbox":
      case "radio":
        this.setAttribute("value", e);
        break;
      case "file":
        if (e !== null && e !== "")
          throw new this[b].DOMException('Input elements of type "file" may only programmatically set the value to empty string.', ne.invalidStateError);
        this[jo] = new sx();
        break;
      default:
        const n = this.value;
        this[ze] = rHe.sanitize(this, e), n !== this[ze] && (this.#e = this[ze].length, this.#t = this[ze].length, this.#n = na.none);
        break;
    }
  }
  /**
   * Returns selection start.
   *
   * @returns Selection start.
   */
  get selectionStart() {
    return this.#r() ? this.#e === null ? this.value.length : this.#e : null;
  }
  /**
   * Sets selection start.
   *
   * @param start Start.
   */
  set selectionStart(e) {
    if (!this.#r())
      throw new this[b].DOMException(`The input element's type (${this.type}) does not support selection.`, ne.invalidStateError);
    this.setSelectionRange(e, Math.max(e, this.selectionEnd), this.#n);
  }
  /**
   * Returns selection end.
   *
   * @returns Selection end.
   */
  get selectionEnd() {
    return this.#r() ? this.#t === null ? this.value.length : this.#t : null;
  }
  /**
   * Sets selection end.
   *
   * @param end End.
   */
  set selectionEnd(e) {
    if (!this.#r())
      throw new this[b].DOMException(`The input element's type (${this.type}) does not support selection.`, ne.invalidStateError);
    this.setSelectionRange(this.selectionStart, e, this.#n);
  }
  /**
   * Returns selection direction.
   *
   * @returns Selection direction.
   */
  get selectionDirection() {
    return this.#r() ? this.#n : null;
  }
  /**
   * Sets selection direction.
   *
   * @param direction Direction.
   */
  set selectionDirection(e) {
    if (!this.#r())
      throw new this[b].DOMException(`The input element's type (${this.type}) does not support selection.`, ne.invalidStateError);
    this.setSelectionRange(this.#e, this.#t, e);
  }
  /**
   * Returns "true" if it will validate.
   *
   * @returns "true" if it will validate.
   */
  get willValidate() {
    return this.type !== "hidden" && this.type !== "reset" && this.type !== "button" && !this.disabled && !this.readOnly;
  }
  /**
   * Returns value as Date.
   *
   * @returns Date.
   */
  get valueAsDate() {
    switch (this.type) {
      case "date":
      case "month":
        return isNaN(new Date(String(this.value)).getTime()) ? null : new Date(this.value);
      case "week": {
        const e = WF.isoWeekDate(this.value);
        return isNaN(e.getTime()) ? null : e;
      }
      case "time": {
        const e = /* @__PURE__ */ new Date(`1970-01-01T${this.value}Z`);
        return isNaN(e.getTime()) ? null : e;
      }
      default:
        return null;
    }
  }
  /**
   * Sets value from a Date.
   *
   * @param value Date.
   */
  set valueAsDate(e) {
    if (!["date", "month", "time", "week"].includes(this.type))
      throw new this[b].DOMException("Failed to set the 'valueAsDate' property on 'HTMLInputElement': This input element does not support Date values.", ne.invalidStateError);
    if (typeof e != "object")
      throw new this[b].TypeError("Failed to set the 'valueAsDate' property on 'HTMLInputElement': Failed to convert value to 'object'.");
    if (e && !(e instanceof Date))
      throw new this[b].TypeError("Failed to set the 'valueAsDate' property on 'HTMLInputElement': The provided value is not a Date.");
    if (e === null || isNaN(e.getTime())) {
      this.value = "";
      return;
    }
    switch (this.type) {
      case "date":
        this.value = e.toISOString().split("T")[0];
        break;
      case "month":
        this.value = e.toISOString().split("T")[0].slice(0, -3);
        break;
      case "time":
        this.value = e.toISOString().split("T")[1].slice(0, 5);
        break;
      case "week":
        this.value = WF.dateIsoWeek(e);
        break;
    }
  }
  /**
   * Returns value as number.
   *
   * @returns Number.
   */
  get valueAsNumber() {
    const e = this.value;
    if (!this.type.match(/^(range|number|date|datetime-local|month|time|week)$/) || !e)
      return NaN;
    switch (this.type) {
      case "number":
        return parseFloat(e);
      case "range": {
        const n = parseFloat(e), r = parseFloat(this.min) || 0, i = parseFloat(this.max) || 100;
        return isNaN(n) ? i < r ? r : (r + i) / 2 : n < r ? r : n > i ? i : n;
      }
      case "date":
        return new Date(e).getTime();
      case "datetime-local":
        return new Date(e).getTime() - new Date(e).getTimezoneOffset() * 6e4;
      case "month":
        return (new Date(e).getUTCFullYear() - 1970) * 12 + new Date(e).getUTCMonth();
      case "time":
        return (/* @__PURE__ */ new Date("1970-01-01T" + e)).getTime() - (/* @__PURE__ */ new Date("1970-01-01T00:00:00")).getTime();
      case "week": {
        const n = e.match(/^(\d{4})-W(\d{2})$/);
        if (!n)
          return NaN;
        const r = new Date(Date.UTC(parseInt(n[1], 10), 0)), i = r.getUTCDay(), s = ((i === 0 ? -6 : 1) - i) * 864e5 + parseInt(n[2], 10) * 6048e5;
        return r.getTime() + s;
      }
      default:
        return NaN;
    }
  }
  /**
   * Sets value from a number.
   *
   * @param value number.
   */
  set valueAsNumber(e) {
    switch (this.type) {
      case "number":
      case "range":
        this.value = Number(e).toString();
        break;
      case "date":
      case "datetime-local": {
        const n = new Date(Number(e));
        if (isNaN(n.getTime())) {
          this.value = "";
          break;
        }
        this.type == "date" ? this.value = n.toISOString().slice(0, 10) : this.value = n.toISOString().slice(0, -1);
        break;
      }
      case "month":
        !Number.isInteger(e) || e < 0 ? this.value = "" : this.value = new Date(Date.UTC(1970, Number(e))).toISOString().slice(0, 7);
        break;
      case "time":
        !Number.isInteger(e) || e < 0 ? this.value = "" : this.value = new Date(Number(e)).toISOString().slice(11, -1);
        break;
      case "week": {
        const n = new Date(Number(e));
        this.value = isNaN(n.getTime()) ? "" : WF.dateIsoWeek(n);
        break;
      }
      default:
        throw new this[b].DOMException("Failed to set the 'valueAsNumber' property on 'HTMLInputElement': This input element does not support Number values.", ne.invalidStateError);
    }
  }
  /**
   * Returns the associated label elements.
   *
   * @returns Label elements.
   */
  get labels() {
    return Ph.getAssociatedLabelElements(this);
  }
  /**
   * Returns associated datalist element.
   *
   * @returns Data list element.
   */
  get list() {
    const e = this.getAttribute("list");
    return e ? (this[ci] || this[he]).querySelector(`datalist#${e}`) : null;
  }
  /**
   * Returns popover target element.
   *
   * @returns Popover target element.
   */
  get popoverTargetElement() {
    return this[Xd];
  }
  /**
   * Sets popover target element.
   *
   * @param popoverTargetElement Popover target element.
   */
  set popoverTargetElement(e) {
    if (e !== null && !(e instanceof Ye))
      throw new this[b].TypeError("Failed to set the 'popoverTargetElement' property on 'HTMLInputElement': Failed to convert value to 'Element'.");
    this[Xd] = e;
  }
  /**
   * Returns popover target action.
   *
   * @returns Popover target action.
   */
  get popoverTargetAction() {
    const e = this.getAttribute("popovertargetaction");
    return e === null || e !== "hide" && e !== "show" && e !== "toggle" ? "toggle" : e;
  }
  /**
   * Sets popover target action.
   *
   * @param value Popover target action.
   */
  set popoverTargetAction(e) {
    this.setAttribute("popovertargetaction", e);
  }
  /**
   * @override
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
  /**
   * @override
   */
  set tabIndex(e) {
    super.tabIndex = e;
  }
  /**
   * Sets validation message.
   *
   * @param message Message.
   */
  setCustomValidity(e) {
    this[fi] = String(e);
  }
  /**
   * Selects the text.
   */
  select() {
    this.#r() && (this.#e = 0, this.#t = this.value.length, this.#n = na.none, this.dispatchEvent(new be("select", { bubbles: !0, cancelable: !1 })));
  }
  /**
   * Set selection range.
   *
   * @param start Start.
   * @param end End.
   * @param [direction="none"] Direction.
   */
  setSelectionRange(e, n, r = "none") {
    if (!this.#r())
      throw new this[b].DOMException(`The input element's type (${this.type}) does not support selection.`, ne.invalidStateError);
    this.#t = Math.min(n, this.value.length), this.#e = Math.min(e, this.#t), this.#n = r === na.forward || r === na.backward ? r : na.none, this.dispatchEvent(new be("select", { bubbles: !0, cancelable: !1 }));
  }
  /**
   * Set range text.
   *
   * @param replacement Replacement.
   * @param [start] Start.
   * @param [end] End.
   * @param [direction] Direction.
   * @param selectionMode
   */
  setRangeText(e, n = null, r = null, i = dc.preserve) {
    if (!this.#r())
      throw new this[b].DOMException(`The input element's type (${this.type}) does not support selection.`, ne.invalidStateError);
    if (n === null && (n = this.#e), r === null && (r = this.#t), n > r)
      throw new this[b].DOMException("The index is not in the allowed range.", ne.invalidStateError);
    n = Math.min(n, this.value.length), r = Math.min(r, this.value.length);
    const s = this.value;
    let a = this.#e, o = this.#t;
    this.value = s.slice(0, n) + e + s.slice(r);
    const u = n + this.value.length;
    switch (i) {
      case dc.select:
        this.setSelectionRange(n, u);
        break;
      case dc.start:
        this.setSelectionRange(n, n);
        break;
      case dc.end:
        this.setSelectionRange(u, u);
        break;
      default:
        const l = e.length - (r - n);
        a > r ? a += l : a > n && (a = n), o > r ? o += l : o > n && (o = u), this.setSelectionRange(a, o);
        break;
    }
  }
  /**
   * Checks validity.
   *
   * @returns "true" if the field is valid.
   */
  checkValidity() {
    const e = this.disabled || this.readOnly || this.type === "hidden" || this.type === "reset" || this.type === "button" || this[rs].valid;
    return e || this.dispatchEvent(new be("invalid", { bubbles: !0, cancelable: !0 })), e;
  }
  /**
   * Reports validity.
   *
   * @returns "true" if the field is valid.
   */
  reportValidity() {
    return this.checkValidity();
  }
  /**
   * Steps up.
   *
   * @param [increment] Increment.
   */
  stepUp(e) {
    const n = XL.step(this.type, this.value, 1, e);
    n !== null && (this.value = n);
  }
  /**
   * Steps down.
   *
   * @param [increment] Increment.
   */
  stepDown(e) {
    const n = XL.step(this.type, this.value, -1, e);
    n !== null && (this.value = n);
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    const n = super[Bt](e);
    return n[ze] = this[ze], n[we] = this[we], n[Fe] = this[Fe], n[jo] = this[jo].slice(), n.#e = this.#e, n.#t = this.#t, n.#n = this.#n, n;
  }
  /**
   * @override
   */
  dispatchEvent(e) {
    if (e[qn] !== "click" || e[ia] !== mr.none || !(e instanceof _o))
      return super.dispatchEvent(e);
    if (this.disabled)
      return !1;
    let n = null, r = this[zc];
    const i = this.type;
    (i === "checkbox" || i === "radio") && (n = this.checked, this.#i(i === "checkbox" ? !n : !0), i === "checkbox" && (r = this[zc], this[zc] = !1));
    const s = super.dispatchEvent(e);
    if (e[qn] !== "click" || e[ia] !== mr.none || !(e instanceof _o))
      return s;
    if (e[vo])
      n !== null && (this.#i(n), this[zc] = r);
    else {
      const a = this.type;
      if (a === "checkbox" && this[st])
        this.dispatchEvent(new be("input", { bubbles: !0, cancelable: !0 })), this.dispatchEvent(new be("change", { bubbles: !0, cancelable: !0 }));
      else if (a === "radio" && !n && this[st])
        this.dispatchEvent(new be("input", { bubbles: !0, cancelable: !0 })), this.dispatchEvent(new be("change", { bubbles: !0, cancelable: !0 }));
      else if (a === "submit" || a === "reset") {
        const o = this.form;
        o && (a === "submit" && this[st] ? o.requestSubmit(this) : a === "reset" && o.reset());
      }
    }
    return s;
  }
  /**
   * Checks is selection is supported.
   *
   * @returns "true" if selection is supported.
   */
  #r() {
    const e = this.type;
    return e === "text" || e === "search" || e === "url" || e === "tel" || e === "password";
  }
  /**
   * Sets checked value.
   *
   * @param checked Checked.
   */
  #i(e) {
    if (this[md] = e, this[Na](), e && this.type === "radio" && this.name) {
      const r = (this[Cn] || this.getRootNode()).querySelectorAll(`input[type="radio"][name="${this.name}"]`);
      for (const i of r)
        i !== this && (i[md] = !1);
    }
  }
}
class ax extends Ye {
  type = "textarea";
  // Internal properties
  [fi] = "";
  [rs] = new Lh(this);
  [ze] = null;
  [Wi] = this;
  [Cn] = null;
  // Private properties
  #e = null;
  #t = null;
  #n = na.none;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get oninput() {
    return K.getEventListener(this, "oninput");
  }
  set oninput(e) {
    this[F].set("oninput", e);
  }
  get onselectionchange() {
    return K.getEventListener(this, "onselectionchange");
  }
  set onselectionchange(e) {
    this[F].set("onselectionchange", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns validation message.
   *
   * @returns Validation message.
   */
  get validationMessage() {
    return this[fi];
  }
  /**
   * Returns validity.
   *
   * @returns Validity.
   */
  get validity() {
    return this[rs];
  }
  /**
   * Returns the default value.
   *
   * @returns Default value.
   */
  get defaultValue() {
    return this.textContent;
  }
  /**
   * Sets the default value.
   *
   * @param defaultValue Default value.
   */
  set defaultValue(e) {
    this.textContent = e;
  }
  /**
   * Returns minlength.
   *
   * @returns Min length.
   */
  get minLength() {
    const e = this.getAttribute("minlength");
    return e !== null ? parseInt(e) : -1;
  }
  /**
   * Sets minlength.
   *
   * @param minLength Min length.
   */
  set minLength(e) {
    this.setAttribute("minlength", String(e));
  }
  /**
   * Returns maxlength.
   *
   * @returns Max length.
   */
  get maxLength() {
    const e = this.getAttribute("maxlength");
    return e !== null ? parseInt(e) : -1;
  }
  /**
   * Sets maxlength.
   *
   * @param maxlength Max length.
   */
  set maxLength(e) {
    this.setAttribute("maxlength", String(e));
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns placeholder.
   *
   * @returns Placeholder.
   */
  get placeholder() {
    return this.getAttribute("placeholder") || "";
  }
  /**
   * Sets placeholder.
   *
   * @param placeholder Placeholder.
   */
  set placeholder(e) {
    this.setAttribute("placeholder", e);
  }
  /**
   * Returns inputmode.
   *
   * @returns Inputmode.
   */
  get inputMode() {
    return this.getAttribute("inputmode") || "";
  }
  /**
   * Sets inputmode.
   *
   * @param inputmode Inputmode.
   */
  set inputMode(e) {
    this.setAttribute("inputmode", e);
  }
  /**
   * Returns cols.
   *
   * @returns Cols.
   */
  get cols() {
    return this.getAttribute("cols") || "";
  }
  /**
   * Sets cols.
   *
   * @param cols Cols.
   */
  set cols(e) {
    this.setAttribute("cols", e);
  }
  /**
   * Returns rows.
   *
   * @returns Rows.
   */
  get rows() {
    return this.getAttribute("rows") || "";
  }
  /**
   * Sets rows.
   *
   * @param rows Rows.
   */
  set rows(e) {
    this.setAttribute("rows", e);
  }
  /**
   * Returns autocomplete.
   *
   * @returns Autocomplete.
   */
  get autocomplete() {
    return this.getAttribute("autocomplete") || "";
  }
  /**
   * Sets autocomplete.
   *
   * @param autocomplete Autocomplete.
   */
  set autocomplete(e) {
    this.setAttribute("autocomplete", e);
  }
  /**
   * Returns readOnly.
   *
   * @returns ReadOnly.
   */
  get readOnly() {
    return this.getAttribute("readonly") !== null;
  }
  /**
   * Sets readOnly.
   *
   * @param readOnly ReadOnly.
   */
  set readOnly(e) {
    e ? this.setAttribute("readonly", "") : this.removeAttribute("readonly");
  }
  /**
   * Returns disabled.
   *
   * @returns Disabled.
   */
  get disabled() {
    return this.getAttribute("disabled") !== null;
  }
  /**
   * Sets disabled.
   *
   * @param disabled Disabled.
   */
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  /**
   * Returns autofocus.
   *
   * @returns Autofocus.
   */
  get autofocus() {
    return this.getAttribute("autofocus") !== null;
  }
  /**
   * Sets autofocus.
   *
   * @param autofocus Autofocus.
   */
  set autofocus(e) {
    e ? this.setAttribute("autofocus", "") : this.removeAttribute("autofocus");
  }
  /**
   * Returns required.
   *
   * @returns Required.
   */
  get required() {
    return this.getAttribute("required") !== null;
  }
  /**
   * Sets required.
   *
   * @param required Required.
   */
  set required(e) {
    e ? this.setAttribute("required", "") : this.removeAttribute("required");
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    return this[ze] === null ? this.textContent : this[ze];
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    const n = this[ze];
    this[ze] = e, n !== this[ze] && (this.#e = this[ze].length, this.#t = this[ze].length, this.#n = na.none);
  }
  /**
   * Returns selection start.
   *
   * @returns Selection start.
   */
  get selectionStart() {
    return this.#e === null ? this.value.length : this.#e;
  }
  /**
   * Sets selection start.
   *
   * @param start Start.
   */
  set selectionStart(e) {
    this.setSelectionRange(e, Math.max(e, this.selectionEnd), this.#n);
  }
  /**
   * Returns selection end.
   *
   * @returns Selection end.
   */
  get selectionEnd() {
    return this.#t === null ? this.value.length : this.#t;
  }
  /**
   * Sets selection end.
   *
   * @param end End.
   */
  set selectionEnd(e) {
    this.setSelectionRange(this.selectionStart, e, this.#n);
  }
  /**
   * Returns selection direction.
   *
   * @returns Selection direction.
   */
  get selectionDirection() {
    return this.#n;
  }
  /**
   * Sets selection direction.
   *
   * @param direction Direction.
   */
  set selectionDirection(e) {
    this.setSelectionRange(this.selectionStart, this.selectionEnd, e);
  }
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    if (this[Cn])
      return this[Cn];
    const e = this.getAttribute("form");
    return !e || !this[st] ? null : this[he].getElementById(e);
  }
  /**
   * Returns text length.
   *
   * @param Text Length.
   */
  get textLength() {
    return this.value.length;
  }
  /**
   * Returns the associated label elements.
   *
   * @returns Label elements.
   */
  get labels() {
    return Ph.getAssociatedLabelElements(this);
  }
  /**
   * @override
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
  /**
   * @override
   */
  set tabIndex(e) {
    super.tabIndex = e;
  }
  /**
   * Selects the text.
   */
  select() {
    this.#e = 0, this.#t = this.value.length, this.#n = na.none, this.dispatchEvent(new be("select", { bubbles: !0, cancelable: !1 }));
  }
  /**
   * Set selection range.
   *
   * @param start Start.
   * @param end End.
   * @param [direction="none"] Direction.
   */
  setSelectionRange(e, n, r = "none") {
    this.#t = Math.min(n, this.value.length), this.#e = Math.min(e, this.selectionEnd), this.#n = r === na.forward || r === na.backward ? r : na.none, this.dispatchEvent(new be("select", { bubbles: !0, cancelable: !1 }));
  }
  /**
   * Set range text.
   *
   * @param replacement Replacement.
   * @param [start] Start.
   * @param [end] End.
   * @param [direction] Direction.
   * @param selectionMode
   */
  setRangeText(e, n = null, r = null, i = dc.preserve) {
    if (n === null && (n = this.#e !== null ? this.#e : 0), r === null && (r = this.#t !== null ? this.#t : this.value.length), n > r)
      throw new this[b].DOMException("The index is not in the allowed range.", ne.invalidStateError);
    n = Math.min(n, this.value.length), r = Math.min(r, this.value.length);
    const s = this.value;
    let a = this.#e !== null ? this.#e : 0, o = this.#t !== null ? this.#t : this.value.length;
    this.value = s.slice(0, n) + e + s.slice(r);
    const u = n + this.value.length;
    switch (i) {
      case dc.select:
        this.setSelectionRange(n, u);
        break;
      case dc.start:
        this.setSelectionRange(n, n);
        break;
      case dc.end:
        this.setSelectionRange(u, u);
        break;
      default:
        const l = e.length - (r - n);
        a > r ? a += l : a > n && (a = n), o > r ? o += l : o > n && (o = u), this.setSelectionRange(a, o);
        break;
    }
  }
  /**
   * Sets validation message.
   *
   * @param message Message.
   */
  setCustomValidity(e) {
    this[fi] = String(e);
  }
  /**
   * Checks validity.
   *
   * @returns "true" if the field is valid.
   */
  checkValidity() {
    const e = this.disabled || this.readOnly || this[rs].valid;
    return e || this.dispatchEvent(new be("invalid", { bubbles: !0, cancelable: !0 })), e;
  }
  /**
   * Reports validity.
   *
   * @returns "true" if the field is valid.
   */
  reportValidity() {
    return this.checkValidity();
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    const n = super[Bt](e);
    return n[ze] = this[ze], n.#e = this.#e, n.#t = this.#t, n.#n = this.#n, n;
  }
  /**
   * Resets selection.
   */
  [By]() {
    this[ze] === null && (this.#e = null, this.#t = null, this.#n = na.none);
  }
}
class bW extends Ye {
  [Cn] = null;
  [fi] = "";
  [rs] = new Lh(this);
  /**
   * Returns the content document.
   *
   * @returns Document
   */
  get contentDocument() {
    return null;
  }
  /**
   * Returns the content window.
   *
   * @returns Window
   */
  get contentWindow() {
    return null;
  }
  /**
   * Returns source.
   *
   * @returns Source.
   */
  get data() {
    if (!this.hasAttribute("data"))
      return "";
    try {
      return new URL(this.getAttribute("data"), this[he].location.href).href;
    } catch {
      return this.getAttribute("data");
    }
  }
  /**
   * Sets source.
   *
   * @param data Source.
   */
  set data(e) {
    this.setAttribute("data", e);
  }
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    if (this[Cn])
      return this[Cn];
    const e = this.getAttribute("form");
    return !e || !this[st] ? null : this[he].getElementById(e);
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this.getAttribute("height") || "";
  }
  /**
   * Sets height.
   *
   * @param height Height.
   */
  set height(e) {
    this.setAttribute("height", e);
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this.getAttribute("width") || "";
  }
  /**
   * Sets width.
   *
   * @param width Width.
   */
  set width(e) {
    this.setAttribute("width", e);
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "";
  }
  /**
   * Sets type.
   *
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
  /**
   * Returns validation message.
   *
   * @returns Validation message.
   */
  get validationMessage() {
    return this[fi];
  }
  /**
   * Returns validity.
   *
   * @returns Validity.
   */
  get validity() {
    return this[rs];
  }
  /**
   * Returns "true" if it will validate.
   *
   * @returns "true" if it will validate.
   */
  get willValidate() {
    return !1;
  }
  /**
   * @override
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
  /**
   * @override
   */
  set tabIndex(e) {
    super.tabIndex = e;
  }
  /**
   * Checks validity.
   *
   * @returns "true" if the field is valid.
   */
  checkValidity() {
    return !0;
  }
  /**
   * Reports validity.
   *
   * @returns Validity.
   */
  reportValidity() {
    return this.checkValidity();
  }
  /**
   * Sets validation message.
   *
   * @param message Message.
   */
  setCustomValidity(e) {
    this[fi] = String(e);
  }
}
class yW extends Ye {
  [Cn] = null;
  [fi] = "";
  [rs] = new Lh(this);
  [So] = "";
  /**
   * Returns default value.
   *
   * @returns Default value.
   */
  get defaultValue() {
    return this[So];
  }
  /**
   * Sets default value.
   *
   * @param defaultValue Default value.
   */
  set defaultValue(e) {
    this[So] = e;
  }
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    if (this[Cn])
      return this[Cn];
    const e = this.getAttribute("form");
    return !e || !this[st] ? null : this[he].getElementById(e);
  }
  /**
   * Returns a string containing the ID of the labeled control. This reflects the "for" attribute.
   *
   * @returns ID of the labeled control.
   */
  get htmlFor() {
    return this.getAttribute("for") || "";
  }
  /**
   * Sets a string containing the ID of the labeled control. This reflects the "for" attribute.
   *
   * @param htmlFor ID of the labeled control.
   */
  set htmlFor(e) {
    this.setAttribute("for", e);
  }
  /**
   * Returns the associated label elements.
   *
   * @returns Label elements.
   */
  get labels() {
    return Ph.getAssociatedLabelElements(this);
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    return this.textContent || "";
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    this.textContent = e;
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return "output";
  }
  /**
   * Returns validation message.
   *
   * @returns Validation message.
   */
  get validationMessage() {
    return this[fi];
  }
  /**
   * Returns validity.
   *
   * @returns Validity.
   */
  get validity() {
    return this[rs];
  }
  /**
   * Returns "true" if it will validate.
   *
   * @returns "true" if it will validate.
   */
  get willValidate() {
    return !1;
  }
  /**
   * Checks validity.
   *
   * @returns "true" if the field is valid.
   */
  checkValidity() {
    return !0;
  }
  /**
   * Reports validity.
   *
   * @returns Validity.
   */
  reportValidity() {
    return this.checkValidity();
  }
  /**
   * Sets validation message.
   *
   * @param message Message.
   */
  setCustomValidity(e) {
    this[fi] = String(e);
  }
}
const iHe = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/, sHe = /^(?:(?:https?|HTTPS?|ftp|FTP):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*)(?::\d{2,5})?(?:[\/?#]\S*)?$/;
class Lh {
  element;
  /**
   * Constructor.
   *
   * @param element Input element.
   */
  constructor(e) {
    this.element = e;
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get badInput() {
    return this.element instanceof zo && (this.element.type === "number" || this.element.type === "range") && this.element.value.length > 0 && !/^[-+]?(?:\d+|\d*[.,]\d+)$/.test(this.element.value);
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get customError() {
    return this.element[fi].length > 0;
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get patternMismatch() {
    return this.element instanceof zo && this.element.hasAttribute("pattern") && this.element.value.length > 0 && this.element.value.replace(new RegExp(this.element.getAttribute("pattern")), "").length > 0;
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get rangeOverflow() {
    return this.element instanceof zo && this.element.hasAttribute("max") && (this.element.type === "number" || this.element.type === "range") && this.element.value.length > 0 && Number(this.element.value) > Number(this.element.getAttribute("max"));
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get rangeUnderflow() {
    return this.element instanceof zo && this.element.hasAttribute("min") && (this.element.type === "number" || this.element.type === "range") && this.element.value.length > 0 && Number(this.element.value) < Number(this.element.getAttribute("min"));
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get stepMismatch() {
    return this.element instanceof zo && (this.element.type === "number" || this.element.type === "range") && (this.element.hasAttribute("step") && this.element.getAttribute("step") !== "any" && Number(this.element.value) % Number(this.element.getAttribute("step")) !== 0 || !this.element.hasAttribute("step") && Number(this.element.value) % 1 !== 0);
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get tooLong() {
    return (this.element instanceof zo || this.element instanceof ax) && this.element.maxLength > 0 && this.element.value.length > this.element.maxLength;
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get tooShort() {
    return (this.element instanceof zo || this.element instanceof ax) && this.element.minLength > 0 && this.element.value.length > 0 && this.element.value.length < this.element.minLength;
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get typeMismatch() {
    return this.element instanceof zo && this.element.value.length > 0 && (this.element.type === "email" && !iHe.test(this.element.value) || this.element.type === "url" && !sHe.test(this.element.value));
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get valueMissing() {
    if (!this.element.required || this.element instanceof bW || this.element instanceof yW)
      return !1;
    if (this.element instanceof zo) {
      if (this.element.type === "checkbox")
        return !this.element.checked;
      if (this.element.type === "radio") {
        if (this.element.checked)
          return !1;
        if (!this.element.name)
          return !0;
        const e = this.element[Cn] || this.element.getRootNode();
        return !e || !e.querySelector(`input[name="${this.element.name}"]:checked`);
      }
    }
    return this.element.value.length === 0;
  }
  /**
   * Returns validity.
   *
   * @returns "true" if valid.
   */
  get valid() {
    return !this.badInput && !this.customError && !this.patternMismatch && !this.rangeOverflow && !this.rangeUnderflow && !this.stepMismatch && !this.tooLong && !this.tooShort && !this.typeMismatch && !this.valueMissing;
  }
}
const aHe = ["submit", "reset", "button", "menu"];
class oHe extends Ye {
  [fi] = "";
  [rs] = new Lh(this);
  [Cn] = null;
  [Xd] = null;
  /**
   * Returns validation message.
   *
   * @returns Validation message.
   */
  get validationMessage() {
    return this[fi];
  }
  /**
   * Returns validity.
   *
   * @returns Validity.
   */
  get validity() {
    return this[rs];
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    return this.getAttribute("value") || "";
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    this.setAttribute("value", e);
  }
  /**
   * Returns disabled.
   *
   * @returns Disabled.
   */
  get disabled() {
    return this.getAttribute("disabled") !== null;
  }
  /**
   * Sets disabled.
   *
   * @param disabled Disabled.
   */
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  /**
   * Returns type
   *
   * @returns Type
   */
  get type() {
    const e = this.getAttribute("type");
    return e === null || !aHe.includes(e) ? "submit" : e;
  }
  /**
   * Sets type
   *
   * @param value Type
   */
  set type(e) {
    this.setAttribute("type", e);
  }
  /**
   * Returns form action.
   *
   * @returns Form action.
   */
  get formAction() {
    if (!this.hasAttribute("formaction"))
      return this[he].location.href;
    try {
      return new Pr(this.getAttribute("formaction"), this[he].location.href).href;
    } catch {
      return "";
    }
  }
  /**
   * Sets form action.
   *
   * @param formAction Form action.
   */
  set formAction(e) {
    this.setAttribute("formaction", e);
  }
  /**
   * Returns form enctype.
   *
   * @returns Form enctype.
   */
  get formEnctype() {
    return this.getAttribute("formenctype") || "";
  }
  /**
   * Sets form enctype.
   *
   * @param formEnctype Form enctype.
   */
  set formEnctype(e) {
    this.setAttribute("formenctype", e);
  }
  /**
   * Returns form method.
   *
   * @returns Form method.
   */
  get formMethod() {
    return this.getAttribute("formmethod") || "";
  }
  /**
   * Sets form method.
   *
   * @param formMethod Form method.
   */
  set formMethod(e) {
    this.setAttribute("formmethod", e);
  }
  /**
   * Returns no validate.
   *
   * @returns No validate.
   */
  get formNoValidate() {
    return this.getAttribute("formnovalidate") !== null;
  }
  /**
   * Sets no validate.
   *
   * @param formNoValidate No validate.
   */
  set formNoValidate(e) {
    e ? this.setAttribute("formnovalidate", "") : this.removeAttribute("formnovalidate");
  }
  /**
   * Returns form target.
   *
   * @returns Form target.
   */
  get formTarget() {
    return this.getAttribute("formtarget") || "";
  }
  /**
   * Sets form target.
   *
   * @param formTarget Form target.
   */
  set formTarget(e) {
    this.setAttribute("formtarget", e);
  }
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    if (this[Cn])
      return this[Cn];
    const e = this.getAttribute("form");
    return !e || !this[st] ? null : this[he].getElementById(e);
  }
  /**
   * Returns the associated label elements.
   *
   * @returns Label elements.
   */
  get labels() {
    return Ph.getAssociatedLabelElements(this);
  }
  /**
   * Returns popover target element.
   *
   * @returns Popover target element.
   */
  get popoverTargetElement() {
    return this[Xd];
  }
  /**
   * Sets popover target element.
   *
   * @param popoverTargetElement Popover target element.
   */
  set popoverTargetElement(e) {
    if (e !== null && !(e instanceof Ye))
      throw new this[b].TypeError("Failed to set the 'popoverTargetElement' property on 'HTMLInputElement': Failed to convert value to 'Element'.");
    this[Xd] = e;
  }
  /**
   * Returns popover target action.
   *
   * @returns Popover target action.
   */
  get popoverTargetAction() {
    const e = this.getAttribute("popovertargetaction");
    return e === null || e !== "hide" && e !== "show" && e !== "toggle" ? "toggle" : e;
  }
  /**
   * Sets popover target action.
   *
   * @param value Popover target action.
   */
  set popoverTargetAction(e) {
    this.setAttribute("popovertargetaction", e);
  }
  /**
   * @override
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
  /**
   * @override
   */
  set tabIndex(e) {
    super.tabIndex = e;
  }
  /**
   * Checks validity.
   *
   * @returns "true" if the field is valid.
   */
  checkValidity() {
    const e = this.disabled || this.type === "reset" || this.type === "button" || this[rs].valid;
    return e || this.dispatchEvent(new be("invalid", { bubbles: !0, cancelable: !0 })), e;
  }
  /**
   * Reports validity.
   *
   * @returns Validity.
   */
  reportValidity() {
    return this.checkValidity();
  }
  /**
   * Sets validation message.
   *
   * @param message Message.
   */
  setCustomValidity(e) {
    this[fi] = String(e);
  }
  /**
   * @override
   */
  dispatchEvent(e) {
    if (e.type === "click" && e instanceof _o && e.eventPhase === mr.none && this.disabled)
      return !1;
    const n = super.dispatchEvent(e);
    if (!e[vo] && e.type === "click" && e.eventPhase === mr.none && e instanceof _o) {
      const r = this.type;
      if (r === "submit" || r === "reset") {
        const i = this.form;
        i && (r === "submit" && this[st] ? i.requestSubmit(this) : r === "reset" && i.reset());
      }
    }
    return n;
  }
}
class uHe {
  height;
  width;
  /**
   * Constructor.
   *
   * @param width Width.
   * @param height Height.
   */
  constructor(e, n) {
    this.width = e, this.height = n;
  }
  /**
   * Disposes of all graphical resources associated with an ImageBitmap.
   */
  close() {
  }
}
class lHe {
  width;
  height;
  /**
   * Constructor.
   *
   * @param width Width.
   * @param height Height.
   */
  constructor(e, n) {
    this.width = e, this.height = n;
  }
  /**
   * Returns context.
   *
   * @param _contextType Context type.
   * @param [_contextAttributes] Context attributes.
   * @returns Context.
   */
  getContext(e, n) {
    return null;
  }
  /**
   * Converts the canvas to a Blob.
   *
   * @param [_options] Options.
   * @param [_options.type] Type.
   * @param [_options.quality] Quality.
   * @returns Blob.
   */
  async convertToBlob(e) {
    return new Di([]);
  }
  /**
   * Creates an ImageBitmap object from the most recently rendered image of the OffscreenCanvas.
   *
   * @returns ImageBitmap.
   */
  transferToImageBitmap() {
    return new uHe(this.width, this.height);
  }
}
const ZL = "S3F/aBCdEfGHIjKlMnOpQRStUvWxYz1234567890+1AbC2DEf2GHi3jK34le+ab12C3+1aBCdEf==";
class cHe extends Ye {
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get oncontextlost() {
    return K.getEventListener(this, "oncontextlost");
  }
  set oncontextlost(e) {
    this[F].set("oncontextlost", e);
  }
  get oncontextrestored() {
    return K.getEventListener(this, "oncontextrestored");
  }
  set oncontextrestored(e) {
    this[F].set("oncontextrestored", e);
  }
  get onwebglcontextcreationerror() {
    return K.getEventListener(this, "onwebglcontextcreationerror");
  }
  set onwebglcontextcreationerror(e) {
    this[F].set("onwebglcontextcreationerror", e);
  }
  get onwebglcontextlost() {
    return K.getEventListener(this, "onwebglcontextlost");
  }
  set onwebglcontextlost(e) {
    this[F].set("onwebglcontextlost", e);
  }
  get onwebglcontextrestored() {
    return K.getEventListener(this, "onwebglcontextrestored");
  }
  set onwebglcontextrestored(e) {
    this[F].set("onwebglcontextrestored", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    const e = this.getAttribute("width");
    return e !== null ? Number(e) : 300;
  }
  /**
   * Sets width.
   *
   * @param width Width.
   */
  set width(e) {
    this.setAttribute("width", String(e));
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    const e = this.getAttribute("height");
    return e !== null ? Number(e) : 150;
  }
  /**
   * Sets height.
   *
   * @param height Height.
   */
  set height(e) {
    this.setAttribute("height", String(e));
  }
  /**
   * Returns capture stream.
   *
   * @param [frameRate] Frame rate.
   * @returns Capture stream.
   */
  captureStream(e) {
    const n = new this[b].MediaStream(), r = new this[b].CanvasCaptureMediaStreamTrack(T, this);
    return r[Wu] = "video", r[$u].deviceId = ZL, r[$u].aspectRatio.max = this.width, r[$u].height.max = this.height, r[$u].width.max = this.width, r[Pd].deviceId = ZL, e !== void 0 && (r[$u].frameRate.max = e, r[Pd].frameRate = e), n.addTrack(r), n;
  }
  /**
   * Returns context.
   *
   * @param _contextType Context type.
   * @param [_contextAttributes] Context attributes.
   * @returns Context.
   */
  getContext(e, n) {
    return null;
  }
  /**
   * Returns to data URL.
   *
   * @param [_type] Type.
   * @param [_encoderOptions] Quality.
   * @returns Data URL.
   */
  toDataURL(e, n) {
    return "";
  }
  /**
   * Returns to blob.
   *
   * @param callback Callback.
   * @param [_type] Type.
   * @param [_quality] Quality.
   */
  toBlob(e, n, r) {
    e(new Di([]));
  }
  /**
   * Transfers control to offscreen.
   *
   * @returns Offscreen canvas.
   */
  transferControlToOffscreen() {
    return new lHe(this.width, this.height);
  }
}
class hHe extends Ye {
}
class dHe extends Ye {
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    return this.getAttribute("value") || "";
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    this.setAttribute("value", e);
  }
}
class fHe extends Ye {
  [Wl] = null;
  /**
   * Returns options.
   *
   * @returns Options.
   */
  get options() {
    return this[Wl] || (this[Wl] = Wn.getElementsByTagName(this, "OPTION")), this[Wl];
  }
}
class mHe extends Ye {
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get ontoggle() {
    return K.getEventListener(this, "ontoggle");
  }
  set ontoggle(e) {
    this[F].set("ontoggle", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns the open attribute.
   */
  get open() {
    return this.getAttribute("open") !== null;
  }
  /**
   * Sets the open attribute.
   *
   * @param open New value.
   */
  set open(e) {
    e ? this.setAttribute("open", "") : this.removeAttribute("open");
  }
  /**
   * @override
   */
  [as](e, n) {
    super[as](e, n), e[tt] === "open" && e[ze] !== n?.[ze] && this.dispatchEvent(new be("toggle"));
  }
  /**
   * @override
   */
  [qa](e) {
    super[qa](e), e && e[tt] === "open" && this.dispatchEvent(new be("toggle"));
  }
  /**
   * @override
   */
  dispatchEvent(e) {
    const n = super.dispatchEvent(e);
    if (!e[vo] && e.type === "click" && e.eventPhase === mr.bubbling && e instanceof _o) {
      const r = e[Ma];
      if (r)
        if (r[Tt] === "summary" && r[xe] === this)
          this.open = !this.open;
        else {
          let i = r;
          for (const s of this[Ft])
            if (s[Tt] === "summary") {
              i = s;
              break;
            }
          i && i.contains(r) && (this.open = !this.open);
        }
    }
    return n;
  }
}
class gHe extends Ye {
  // Internal properties
  [pF] = "";
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get oncancel() {
    return K.getEventListener(this, "oncancel");
  }
  set oncancel(e) {
    this[F].set("oncancel", e);
  }
  get onclose() {
    return K.getEventListener(this, "onclose");
  }
  set onclose(e) {
    this[F].set("onclose", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns return value.
   *
   * @returns Return value.
   */
  get returnValue() {
    return this[pF];
  }
  /**
   * Sets return value.
   *
   * @param value Return value.
   */
  set returnValue(e) {
    this[pF] = String(e);
  }
  /**
   * Sets the "open" attribute.
   *
   * @param open Open.
   */
  set open(e) {
    e ? this.setAttribute("open", "") : this.removeAttribute("open");
  }
  /**
   * Returns open.
   *
   * @returns Open.
   */
  get open() {
    return this.getAttribute("open") !== null;
  }
  /**
   * Closes the dialog.
   *
   * @param [returnValue] ReturnValue.
   */
  close(e) {
    const n = this.open;
    this.removeAttribute("open"), this.returnValue = e !== void 0 ? String(e) : "", n && this.dispatchEvent(new be("close"));
  }
  /**
   * Shows the modal.
   */
  showModal() {
    this.setAttribute("open", "");
  }
  /**
   * Shows the dialog.
   */
  show() {
    this.setAttribute("open", "");
  }
}
class pHe extends Ye {
}
class bHe extends Ye {
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this.getAttribute("height") || "";
  }
  /**
   * Sets height.
   *
   * @param height Height.
   */
  set height(e) {
    this.setAttribute("height", e);
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this.getAttribute("width") || "";
  }
  /**
   * Sets width.
   *
   * @param width Width.
   */
  set width(e) {
    this.setAttribute("width", e);
  }
  /**
   * Returns source.
   *
   * @returns Source.
   */
  get src() {
    if (!this.hasAttribute("src"))
      return "";
    try {
      return new URL(this.getAttribute("src"), this[he].location.href).href;
    } catch {
      return this.getAttribute("src");
    }
  }
  /**
   * Sets source.
   *
   * @param src Source.
   */
  set src(e) {
    this.setAttribute("src", e);
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "";
  }
  /**
   * Sets type.
   *
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
}
class AW extends Ye {
  // Internal properties
  [Gl] = null;
  [Cn] = null;
  /**
   * Returns elements.
   *
   * @returns Elements.
   */
  get elements() {
    return this[Gl] || (this[Gl] = new mi(T, () => it.querySelectorAll(this, "input,button,textarea,select")[Ge])), this[Gl];
  }
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    if (this[Cn])
      return this[Cn];
    const e = this.getAttribute("form");
    return !e || !this[st] ? null : this[he].getElementById(e);
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns type "fieldset".
   *
   * @returns Type.
   */
  get type() {
    return "fieldset";
  }
  /**
   * Returns empty string as fieldset never candidates for constraint validation.
   */
  get validationMessage() {
    return "";
  }
  /**
   * Returns will validate state.
   *
   * Always returns false as fieldset never candidates for constraint validation.
   *
   * @returns Will validate state.
   */
  get willValidate() {
    return !1;
  }
  /**
   * Returns disabled.
   *
   * @returns Disabled.
   */
  get disabled() {
    return this.getAttribute("disabled") !== null;
  }
  /**
   * Sets disabled.
   *
   * @param disabled Disabled.
   */
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  /**
   * Checks validity.
   *
   * Always returns true as fieldset never candidates for constraint validation.
   *
   * @returns "true" if the field is valid.
   */
  checkValidity() {
    return !0;
  }
  /**
   * Reports validity.
   *
   * Always returns true as fieldset never candidates for constraint validation.
   *
   * @returns Validity.
   */
  reportValidity() {
    return !0;
  }
  /**
   * Sets validation message.
   *
   * Does nothing as fieldset never candidates for constraint validation.
   *
   * @param _message Message.
   */
  setCustomValidity(e) {
  }
}
class EW extends mi {
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param ownerElement Form element.
   */
  constructor(e, n) {
    super(e, () => n[Fa]()), this[zt] = n;
  }
  /**
   * @override
   */
  namedItem(e) {
    return this[zt][Fv](e);
  }
}
class yg {
  /**
   * Creates a new frame.
   *
   * @param parentFrame Parent frame.
   * @returns Frame.
   */
  static createChildFrame(e) {
    const n = new e.constructor(e.page);
    return n.parentFrame = e, e.childFrames.push(n), n;
  }
  /**
   * Aborts all ongoing operations and destroys the frame.
   *
   * @param frame Frame.
   */
  static destroyFrame(e) {
    const n = e.page.context.browser[Ec];
    return e.closed ? Promise.resolve() : (e.closed = !0, new Promise((r, i) => {
      if (!e.window) {
        r();
        return;
      }
      if (e.parentFrame) {
        const s = e.parentFrame.childFrames.indexOf(e);
        s !== -1 && e.parentFrame.childFrames.splice(s, 1);
      }
      if (!e.childFrames.length) {
        e[xt].destroy().then(() => {
          n && e.window && n.disconnect(e.window), e.window = { closed: !0 }, e[zu] = null, e[Ff] = null, e[ur] && (e[ur].navigation = []), r();
        }).catch((s) => i(s)), e.window && e.window[tn]();
        return;
      }
      Promise.all(e.childFrames.slice().map((s) => this.destroyFrame(s))).then(() => {
        e[xt].destroy().then(() => {
          n && e.window && n.disconnect(e.window), e.window = { closed: !0 }, e[zu] = null, e[Ff] = null, e[ur] && (e[ur].navigation = []), r();
        }).catch((s) => i(s)), e.window && e.window[tn]();
      }).catch((s) => i(s));
    }));
  }
}
var ox;
(function(t) {
  t.anyOrigin = "anyOrigin", t.sameOrigin = "sameOrigin", t.strictOrigin = "strictOrigin";
})(ox || (ox = {}));
const ux = ox;
class SW {
  url;
  #e;
  #t;
  #n = null;
  /**
   * Constructor.
   *
   * @param init Initialization options.
   */
  constructor(e) {
    this.#e = e.window, this.url = e.url, this.#t = e.source;
  }
  /**
   * Compiles and evaluates the module.
   *
   * @returns Module exports.
   */
  async evaluate() {
    if (this.#n)
      return this.#n;
    const e = new this.#e.CSSStyleSheet();
    return e.replaceSync(this.#t), this.#n = { default: e }, this.#n;
  }
  /**
   * Compiles and preloads the module and its imports.
   *
   * @returns Promise.
   */
  async preload() {
    await this.evaluate();
  }
}
const yHe = ["module", "main"], AHe = [".js", ".mjs"];
class Ky {
  static nodeModuleResolveCache = /* @__PURE__ */ new Map();
  static packageJsonCache = /* @__PURE__ */ new Map();
  /**
   * Returns module URL based on parent URL and the import map.
   *
   * @param window Window.
   * @param parentURL Parent URL.
   * @param url Module URL.
   */
  static getURL(e, n, r) {
    const i = typeof n == "string" ? n : n.href, s = e[H1], a = this.resolveURL(e, i, r);
    if (!s)
      return new Pr(a, i);
    if (s.scopes.length) {
      for (const o of s.scopes)
        if (i.includes(o.scope)) {
          for (const u of o.rules)
            if (a.startsWith(u.from))
              return new Pr(u.to + a.replace(u.from, ""), i);
        }
    }
    if (s.imports.length) {
      for (const o of s.imports)
        if (a.startsWith(o.from))
          return new Pr(o.to + a.replace(o.from, ""), i);
    }
    return new Pr(a, i);
  }
  /**
   * Clears the internal caches.
   */
  static clearCache() {
    this.nodeModuleResolveCache.clear(), this.packageJsonCache.clear();
  }
  /**
   * Resolves the module URL using the settings.
   *
   * @param window Window.
   * @param parentURL Parent URL.
   * @param url Module URL.
   */
  static resolveURL(e, n, r) {
    const i = new pt(e).getSettings();
    if (!i)
      return r;
    let s = r;
    return i.module.resolveNodeModules && (s = this.resolveNodeModuleURL(i.module.resolveNodeModules, r)), i.module.urlResolver && (s = i.module.urlResolver({ url: s, parentURL: n, window: e })), s;
  }
  /**
   * Resolves node module URL.
   *
   * @param resolveNodeModules Settings for resolving node modules.
   * @param url Module URL.
   */
  static resolveNodeModuleURL(e, n) {
    if (n[0] === "." || n[0] === "/" || n.startsWith("http://") || n.startsWith("https://"))
      return n;
    const r = e.url[e.url.length - 1] === "/" ? "" : "/", i = `${e.url}${r}`, s = qr.resolve(e.directory), a = n.split("/"), o = this.nodeModuleResolveCache.get(n);
    if (o)
      return o;
    const u = n[0] === "@" ? `${a[0]}/${a[1]}` : a[0];
    let l = this.packageJsonCache.get(u);
    if (!l)
      try {
        l = JSON.parse(As.readFileSync(qr.join(s, u, "package.json"), "utf-8")), this.packageJsonCache.set(u, l);
      } catch {
        return n;
      }
    if (n[0] === "@" && a.length === 2 || a.length === 1) {
      if (l.exports?.["."]?.import) {
        const m = `${i}${u}/${l.exports["."].import.replace("./", "")}`;
        return this.nodeModuleResolveCache.set(n, m), m;
      }
      const f = e.mainFields || yHe;
      for (const m of f)
        if (l[m] && As.existsSync(qr.join(s, u, l[m]))) {
          const g = `${i}${n}/${l[m]}`;
          return this.nodeModuleResolveCache.set(n, g), g;
        }
      return n;
    }
    const h = a.slice(n[0] === "@" ? 2 : 1).join("/");
    if (l.exports)
      for (const f of Object.keys(l.exports)) {
        const m = Array.isArray(l.exports[f].import) ? l.exports[f].import[0] : l.exports[f].import;
        if (m) {
          const g = new RegExp(`^${f.replace("./", "").replace(/\./g, "\\.").replace(/\*/g, "(.*)")}$`), A = h.match(g);
          if (A) {
            const E = m.replace("./", "").replace("*", A[1]), w = `${i}${u}/${E}`;
            return this.nodeModuleResolveCache.set(n, w), w;
          }
        }
      }
    if (!n.endsWith(".js") && !n.endsWith(".mjs")) {
      for (const f of AHe)
        if (As.existsSync(qr.join(s, `${n}${f}`))) {
          const m = `${i}${n}${f}`;
          return this.nodeModuleResolveCache.set(n, m), m;
        }
    } else if (As.existsSync(qr.join(s, n))) {
      const f = `${i}${n}`;
      return this.nodeModuleResolveCache.set(n, f), f;
    }
    return n;
  }
}
const EHe = /import\.meta\.([a-zA-Z]+)|import\s*["']([^"']+)["'];{0,1}|import\s*\(([^)]+)\)|(import[\s{])|[\s}]from\s*["']([^"']+)["'](\s+with\s*{\s*type\s*:\s*["']([^"']+)["']\s*}){0,1}([;\s]*)|export(\s+[a-zA-Z0-9-_$]+\s+|\s+\*\s+|\s+\*\s+as\s+["'a-zA-Z0-9-_$]+\s+|\s*{[^}]+}\s*)from\s*["']([^"']+)["']|export\s*(default\s+){0,1}(async\s+){0,1}(function\*{0,1}|class)\s*([^({\s]+)|(export\s*default\s*)|export\s*{([^}]+)}|export\s+(var|let|const)\s+([^=;]+)(=|;)/gm, SHe = /(\/)|(\(|\))|({|})|(\[|\])|(\${)|(`)|(')|(")|(\n)/gm, wHe = /{([^}]+)}|\*\s+as\s+([a-zA-Z0-9-_$]+)|([a-zA-Z0-9-_$]+)/gm, Nu = /['"`(){}\s;=><\[\]+-,:&]/, FHe = /['"`({};=><\[+-,:&]/, THe = /\/\*|\*\//gm, Ey = /export\s*/, vHe = /export\s*default\s*/, xHe = /;\s*$/;
class CHe {
  window;
  debug = !1;
  count = {
    comment: 0,
    singleLineComment: 0,
    parentheses: 0,
    curlyBraces: 0,
    squareBrackets: 0,
    regExp: 0,
    regExpSquareBrackets: 0,
    escapeTemplateString: 0,
    simpleString: 0,
    doubleString: 0
  };
  debugCount = {
    comment: [],
    singleLineComment: [],
    parentheses: [],
    curlyBraces: [],
    squareBrackets: [],
    regExp: [],
    regExpSquareBrackets: [],
    escapeTemplateString: [],
    simpleString: [],
    doubleString: []
  };
  templateString = [];
  /**
   * Constructor.
   *
   * @param window Window.
   * @param url Module URL.
   */
  constructor(e) {
    this.window = e;
  }
  /**
   * Compiles code and returns imports and compiled code.
   *
   * @param moduleURL Module URL.
   * @param code Code.
   * @param sourceURL Source URL.
   * @returns Result.
   */
  compile(e, n, r = null) {
    const i = new pt(this.window).getBrowserContext();
    if (!i)
      return { imports: [], execute: async () => {
      } };
    const s = i.browser.settings;
    if (!s.module.disableCache && r) {
      const P = i[Dv].get(e);
      if (P)
        return {
          imports: P.imports,
          execute: this.window[wf](P.code, {
            filename: r
          })
        };
    }
    this.reset();
    const a = new RegExp(EHe), o = [], u = [], l = this.count;
    let h = "", f = "", m = "", g = null, A, E, w = !0, x = 0, N = -1;
    for (; g = a.exec(n); ) {
      if (A = n[g.index - 1] || " ", E = n.substring(x, g.index), this.parseSyntax(E, x), N === -1 && (h += E), w = l.comment === 0 && l.singleLineComment === 0 && l.parentheses === 0 && l.curlyBraces === 0 && l.squareBrackets === 0 && l.regExp === 0 && l.simpleString === 0 && l.doubleString === 0 && this.templateString.length === 0, g[1] && l.simpleString === 0 && l.doubleString === 0 && l.comment === 0 && l.singleLineComment === 0 && l.regExp === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && Nu.test(this.getNonSpacePrecedingToken(n, g.index)))
        h += `$happy_dom.importMeta.${g[1]}`;
      else if (g[2] && w && Nu.test(A))
        o.push({
          url: Ky.getURL(this.window, e, g[2]).href,
          type: "esm"
        });
      else if (g[3] && l.simpleString === 0 && l.doubleString === 0 && l.comment === 0 && l.singleLineComment === 0 && l.regExp === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && Nu.test(A))
        h += `$happy_dom.dynamicImport(${g[3]})`;
      else if (g[4] && w && Nu.test(A)) {
        if (N !== -1)
          throw new this.window.TypeError(`Failed to parse module: Unexpected import statement in "${e}"`);
        N = g.index + g[0].length - 1;
      } else if (g[5] && w && N !== -1) {
        const P = Ky.getURL(this.window, e, g[5]).href, C = n.substring(N, g.index + 1), D = new RegExp(wHe);
        let L = null;
        for (; L = D.exec(C); )
          if (L[1]) {
            const k = this.removeMultilineComments(L[1]).split(/\s*,\s*/), I = [];
            for (const U of k) {
              const j = U.trim().split(/\s+as\s+/), J = (j[1] || j[0]).replace(/["']/g, ""), G = j[0].replace(/["']/g, "");
              J && G && (G === J ? I.push({ name: G }) : I.push({ name: G, alias: J }));
            }
            (!g[7] || g[7] === "esm") && u.push({ url: P, properties: I }), f += `let {${I.map((U) => U.alias ? `"${U.name}": ${U.alias}` : U.name).join(", ")}} = $happy_dom.imports.get('${P}')${g[8]}`;
          } else L[2] ? f += `const ${L[2]} = $happy_dom.imports.get('${P}')${g[8]}` : L[3] && ((!g[7] || g[7] === "esm") && u.push({
            url: P,
            properties: [{ name: "default", alias: L[3] }]
          }), f += `let ${L[3]} = $happy_dom.imports.get('${P}').default${g[8]}`);
        N = -1, o.push({ url: P, type: g[7] || "esm" });
      } else if (g[9] && g[10] && w && Nu.test(A)) {
        const P = Ky.getURL(this.window, e, g[10]).href, C = g[9].trim();
        if (C === "*")
          h += `Object.assign($happy_dom.exports, $happy_dom.imports.get('${P}'))`, o.push({ url: P, type: "esm" });
        else if (C[0] === "*") {
          const D = C.split(/\s+as\s+/);
          if (D.length === 2) {
            const L = D[1].replace(/["']/g, "");
            h += `$happy_dom.exports['${L}'] = $happy_dom.imports.get('${P}')`, o.push({ url: P, type: "esm" });
          }
        } else if (C[0] === "{") {
          const D = this.removeMultilineComments(C).slice(1, -1).split(/\s*,\s*/), L = [];
          for (const k of D) {
            const I = k.trim().split(/\s+as\s+/), U = (I[1] || I[0]).replace(/["']/g, ""), j = I[0].replace(/["']/g, "");
            U && j && L.push(`$happy_dom.exports['${U}'] = $happy_dom.imports.get('${P}')['${j}']`);
          }
          h += L.join(`;
`), o.push({ url: P, type: "esm" });
        }
      } else if (g[13] && g[14] && w && Nu.test(A)) {
        const P = g[14].replace("*", "");
        if (P)
          g[11] ? (h += g[0].replace(vHe, ""), m += `$happy_dom.exports.default = ${P};
`) : (h += g[0].replace(Ey, ""), m += `$happy_dom.exports['${P}'] = ${P};
`);
        else if (g[11])
          h += `$happy_dom.exports.default = ${g[12] || ""}${g[13]}${P ? " " : ""}${g[14]}`;
        else
          throw new this.window.SyntaxError(`Failed to parse module: Missing function or class name in export statement in "${e}"`);
      } else if (g[15] && w && Nu.test(A))
        h += "$happy_dom.exports.default = ";
      else if (g[16] && w && Nu.test(A)) {
        const P = this.removeMultilineComments(g[16]).split(/\s*,\s*/), C = [];
        for (const D of P) {
          const L = D.trim().split(/\s+as\s+/), k = (L[1] || L[0]).replace(/["']/g, ""), I = L[0].replace(/["']/g, "");
          k && I && C.push(`$happy_dom.exports['${k}'] = ${I}`);
        }
        h += C.join(`;
`);
      } else if (g[17] && w && Nu.test(A))
        if (g[19] === "=") {
          const P = this.removeMultilineComments(g[18]).trim();
          if (P[0] === "{" && P[P.length - 1] === "}" || P[0] === "[" && P[P.length - 1] === "]") {
            const C = P.slice(1, -1).split(/\s*,\s*/);
            for (const D of C) {
              const L = D.trim().split(/\s*:\s*/), k = (L[1] || L[0]).replace(/["']/g, "");
              k && (m += `$happy_dom.exports['${k}'] = ${k};
`);
            }
            h += g[0].replace(Ey, "");
          } else
            h += g[0].replace(Ey, ""), m += `$happy_dom.exports['${P}'] = ${P};
`;
        } else {
          h += g[0].replace(Ey, "");
          const P = this.removeMultilineComments(g[18]).split(",");
          for (const C of P) {
            const D = C.trim();
            m += `$happy_dom.exports['${D}'] = ${D};
`;
          }
        }
      else if (N !== -1) {
        const P = n.substring(N, g.index + 1);
        h += P, this.parseSyntax(P, N);
      } else
        h += g[0], this.parseSyntax(g[0], g.index);
      x = a.lastIndex;
    }
    if (this.debug)
      return {
        imports: o,
        execute: async () => {
        }
      };
    if (f && !xHe.test(f) && (f = `
${f};`), !s.disableErrorCapturing && s.errorCapture === Rr.tryAndCatch ? f = "(async function anonymous($happy_dom) { try {" + f : f = "(async function anonymous($happy_dom) {" + f, h = f + h, x === 0 ? h += n : h += n.substring(x), h += `
` + m, u.length > 0) {
      h += `$happy_dom.addCircularImportResolver(() => {
`;
      for (const P of u)
        for (const C of P.properties)
          C.alias ? h += `${C.alias} = $happy_dom.imports.get('${P.url}')['${C.name}'];
` : h += `${C.name} = $happy_dom.imports.get('${P.url}')['${C.name}'];
`;
      h += "});";
    }
    !s.disableErrorCapturing && s.errorCapture === Rr.tryAndCatch && (h += "} catch(e) { $happy_dom.dispatchError(e); }"), h += "})";
    let B;
    try {
      B = this.window[wf](h, {
        filename: r || e
      });
    } catch (P) {
      const C = this.getError(e, n, r), D = C ? new this.window.SyntaxError(`Failed to parse module in '${e}'. Execution error: ${P.message}. Compile error: ${C}`) : P;
      if (P.message = `Failed to parse module in '${r}': ${D.message}`, s.disableErrorCapturing || s.errorCapture !== Rr.tryAndCatch)
        throw D;
      return this.window[tr](D), {
        imports: o,
        execute: async () => {
        }
      };
    }
    return !s.module.disableCache && r && i[Dv].set(e, {
      imports: o,
      code: h
    }), { imports: o, execute: B };
  }
  /**
   * Parses syntax.
   *
   * @param code Code.
   * @param index Index.
   */
  parseSyntax(e, n) {
    const r = new RegExp(SHe), i = this.count, s = this.debug, a = this.debugCount;
    let o = null, u, l;
    for (n++; o = r.exec(e); )
      u = e[o.index - 1] || " ", l = u === "\\" && e[o.index - 2] !== "\\", o[1] ? i.simpleString === 0 && i.doubleString === 0 && i.singleLineComment === 0 && i.regExpSquareBrackets === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && (i.comment === 1 ? u === "*" && (i.comment = 0, s && (a.comment.length = 0)) : i.regExp === 0 ? e[o.index + 1] === "*" ? (i.comment = 1, s && (a.comment = [n + o.index])) : e[o.index + 1] === "/" ? (i.singleLineComment = 1, s && (a.singleLineComment = [n + o.index])) : FHe.test(this.getNonSpacePrecedingToken(e, o.index)) && (i.regExp = 1, s && (a.regExp = [n + o.index])) : l || (i.regExp = 0, s && (a.regExp.length = 0))) : o[2] ? i.simpleString === 0 && i.doubleString === 0 && i.regExp === 0 && i.comment === 0 && i.singleLineComment === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && (o[2] === "(" ? (i.parentheses++, s && a.parentheses.push(n + o.index)) : o[2] === ")" && i.parentheses > 0 && (i.parentheses--, s && a.parentheses.pop())) : o[3] ? i.simpleString === 0 && i.doubleString === 0 && i.regExp === 0 && i.comment === 0 && i.singleLineComment === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && (o[3] === "{" ? (this.templateString.length && this.templateString[0]++, i.curlyBraces++, s && a.curlyBraces.push(n + o.index)) : o[3] === "}" && (this.templateString.length && this.templateString[0] > 0 && this.templateString[0]--, i.curlyBraces > 0 && (i.curlyBraces--, s && a.curlyBraces.pop()))) : o[4] ? i.simpleString === 0 && i.doubleString === 0 && i.comment === 0 && i.singleLineComment === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && (i.regExp === 1 ? l || (o[4] === "[" && i.regExpSquareBrackets === 0 ? (i.regExpSquareBrackets = 1, s && (a.regExpSquareBrackets = [n + o.index])) : o[4] === "]" && i.regExpSquareBrackets === 1 && (i.regExpSquareBrackets = 0, s && (a.regExpSquareBrackets.length = 0))) : o[4] === "[" ? (i.squareBrackets++, s && a.squareBrackets.push(n + o.index)) : o[4] === "]" && i.squareBrackets > 0 && (i.squareBrackets--, s && a.squareBrackets.pop())) : o[5] ? i.simpleString === 0 && i.doubleString === 0 && i.comment === 0 && i.singleLineComment === 0 && i.regExp === 0 && !l && this.templateString[0] === 0 && (this.templateString[0] = 1, i.curlyBraces++, s && a.curlyBraces.push(n + o.index)) : o[6] ? i.simpleString === 0 && i.doubleString === 0 && i.comment === 0 && i.singleLineComment === 0 && i.regExp === 0 && !l && (this.templateString?.[0] === 0 ? this.templateString.shift() : this.templateString.unshift(0)) : o[7] ? i.doubleString === 0 && i.comment === 0 && i.singleLineComment === 0 && i.regExp === 0 && !l && (this.templateString.length === 0 || this.templateString[0] > 0) && (i.simpleString === 0 ? (i.simpleString = 1, s && (a.simpleString = [n + o.index])) : (i.simpleString = 0, s && (a.simpleString.length = 0))) : o[8] ? i.simpleString === 0 && i.comment === 0 && i.singleLineComment === 0 && i.regExp === 0 && !l && (this.templateString.length === 0 || this.templateString[0] > 0) && (i.doubleString === 0 ? (i.doubleString = 1, s && (a.doubleString = [n + o.index])) : (i.doubleString = 0, s && (a.doubleString.length = 0))) : o[9] && (i.singleLineComment = 0, s && (a.singleLineComment.length = 0));
  }
  /**
   * Returns error.
   *
   * @param moduleURL Module URL.
   * @param code Code.
   * @param sourceURL Source URL.
   * @returns Error.
   */
  getError(e, n, r) {
    if (this.count.comment === 0 && this.count.singleLineComment === 0 && this.count.parentheses === 0 && this.count.curlyBraces === 0 && this.count.squareBrackets === 0 && this.count.regExp === 0 && this.count.regExpSquareBrackets === 0 && this.count.simpleString === 0 && this.count.doubleString === 0)
      return null;
    this.debug || (this.debug = !0, this.compile(e, n, r));
    const i = this.debugCount;
    if (i.comment.length > 0) {
      const { line: s, column: a } = this.getLineAndColumn(n, i.comment[0]);
      return `Missing end of comment on line ${s} and column ${a}`;
    } else if (i.regExp.length > 0) {
      const { line: s, column: a } = this.getLineAndColumn(n, i.regExp[0]);
      return `Missing end of regular expression on line ${s} and column ${a}`;
    } else if (i.regExpSquareBrackets.length > 0) {
      const { line: s, column: a } = this.getLineAndColumn(n, i.regExpSquareBrackets[0]);
      return `Missing end of regular expression square brackets on line ${s} and column ${a}`;
    } else if (i.simpleString.length > 0) {
      const { line: s, column: a } = this.getLineAndColumn(n, i.simpleString[0]);
      return `Missing end of single quote string on line ${s} and column ${a}`;
    } else if (i.doubleString.length > 0) {
      const { line: s, column: a } = this.getLineAndColumn(n, i.doubleString[0]);
      return `Missing end of double quote string on line ${s} and column ${a}`;
    } else if (i.parentheses.length > 0) {
      const { line: s, column: a } = this.getLineAndColumn(n, i.parentheses[0]);
      return `Missing end of parentheses on line ${s} and column ${a}`;
    } else if (i.curlyBraces.length > 0) {
      const { line: s, column: a } = this.getLineAndColumn(n, i.curlyBraces[0]);
      return `Missing end of curly braces on line ${s} and column ${a}`;
    } else if (i.squareBrackets.length > 0) {
      const { line: s, column: a } = this.getLineAndColumn(n, i.squareBrackets[0]);
      return `Missing end of square brackets on line ${s} and column ${a}`;
    } else if (i.escapeTemplateString.length > 0) {
      const { line: s, column: a } = this.getLineAndColumn(n, i.escapeTemplateString[0]);
      return `Missing end of escaped template string on line ${s} and column ${a}`;
    }
    return null;
  }
  /**
   * Returns line and column for an error.
   *
   * @param code Code.
   * @param index Index.
   * @returns Line and column.
   */
  getLineAndColumn(e, n) {
    const r = e.substring(0, n).split(`
`), i = r.length, s = r[r.length - 1].length;
    return { line: i, column: s };
  }
  /**
   * Get the non-space preceding token.
   *
   * @param code Code.
   * @param index Index.
   * @returns Non-space preceding token.
   */
  getNonSpacePrecedingToken(e, n) {
    n--;
    let r = e[n];
    for (; r === " " || r === `
` || r === "	"; )
      n--, r = e[n];
    return r || ";";
  }
  /**
   * Remove multiline comments.
   *
   * @param code Code.
   * @returns Code without multiline comments.
   */
  removeMultilineComments(e) {
    const n = new RegExp(THe);
    let r, i = 0, s = 0, a = "";
    for (; r = n.exec(e); )
      i === 0 && (a += e.substring(s, r.index)), r[0] === "/*" ? i++ : r[0] === "*/" && i > 0 && i--, s = n.lastIndex;
    return a += e.substring(s), a;
  }
  /**
   * Resets the compiler state.
   */
  reset() {
    this.count = {
      comment: 0,
      singleLineComment: 0,
      parentheses: 0,
      curlyBraces: 0,
      squareBrackets: 0,
      regExp: 0,
      regExpSquareBrackets: 0,
      escapeTemplateString: 0,
      simpleString: 0,
      doubleString: 0
    }, this.debugCount = {
      comment: [],
      singleLineComment: [],
      parentheses: [],
      curlyBraces: [],
      squareBrackets: [],
      regExp: [],
      regExpSquareBrackets: [],
      escapeTemplateString: [],
      simpleString: [],
      doubleString: []
    }, this.templateString = [];
  }
}
class wW {
  url;
  #e;
  #t;
  #n = null;
  /**
   * Constructor.
   *
   * @param init Initialization options.
   */
  constructor(e) {
    this.#e = e.window, this.url = e.url, this.#t = e.source;
  }
  /**
   * Compiles and evaluates the module.
   *
   * @returns Module exports.
   */
  async evaluate() {
    if (this.#n)
      return this.#n;
    let e;
    try {
      e = JSON.parse(this.#t);
    } catch (n) {
      throw new this.#e.TypeError(`Failed to parse module "${this.url.href}": ${n.message}`);
    }
    return this.#n = { default: e }, this.#n;
  }
  /**
   * Compiles and preloads the module and its imports.
   *
   * @returns Promise.
   */
  async preload() {
    await this.evaluate();
  }
}
class eM {
  url;
  #e;
  #t = [];
  #n = null;
  /**
   * Constructor.
   *
   * @param init Initialization options.
   */
  constructor(e) {
    this.#e = e.window, this.url = e.url;
  }
  /**
   * Compiles and evaluates the module.
   *
   * @returns Module exports.
   */
  async evaluate() {
    throw new this.#e.TypeError("Unresolved module. We should never end up here.");
  }
  /**
   * Compiles and preloads the module and its imports.
   *
   * @returns Promise.
   */
  async preload() {
    throw new this.#e.TypeError("Unresolved module. We should never end up here.");
  }
  /**
   * Add a hook to be called when the module is resolved.
   *
   * @param resolve Resolve.
   * @param reject Reject.
   */
  addResolveListener(e, n) {
    if (this.#n) {
      n(this.#n);
      return;
    }
    this.#t.push({ resolve: e, reject: n });
  }
  /**
   * Resolves the module.
   *
   * @param [error] Error.
   */
  resolve(e) {
    e && (this.#n = e);
    for (const n of this.#t)
      e ? n.reject(e) : n.resolve(null);
  }
}
class kHe {
  /**
   * Sends a synchronous request.
   *
   * @param request Request.
   * @param request.url
   * @param request.method
   * @param request.headers
   * @param request.body
   * @param request.disableStrictSSL
   * @returns Script.
   */
  static getScript(e) {
    const n = {}, r = Object.keys(e.headers).sort();
    for (const i of r)
      n[i] = e.headers[i];
    return `
                const sendRequest = require('http${e.url.protocol === "https:" ? "s" : ""}').request;
                const options = ${JSON.stringify({
      method: e.method,
      headers: n,
      agent: !1,
      rejectUnauthorized: !e.disableStrictSSL,
      key: e.url.protocol === "https:" ? z1.key : void 0,
      cert: e.url.protocol === "https:" ? z1.cert : void 0
    }, null, 4)};
                const request = sendRequest(${JSON.stringify(e.url.href)}, options, (incomingMessage) => {
                    let data = Buffer.alloc(0);
                    incomingMessage.on('data', (chunk) => {
                        data = Buffer.concat([data, Buffer.from(chunk)]);
                    });
                    incomingMessage.on('end', () => {
                        console.log(JSON.stringify({
                            error: null,
                            incomingMessage: {
                                statusCode: incomingMessage.statusCode,
                                statusMessage: incomingMessage.statusMessage,
                                rawHeaders: incomingMessage.rawHeaders,
                                data: data.toString('base64')
                            }
                        }));
                    });
                    incomingMessage.on('error', (error) => {
                        console.log(JSON.stringify({ error: error.message, incomingMessage: null }));
                    });
                });
                request.write(Buffer.from('${e.body ? e.body.toString("base64") : ""}', 'base64'));
                request.end();
            `;
  }
}
class af {
  request;
  redirectCount = 0;
  disableCache;
  disableSameOriginPolicy;
  interceptor;
  requestHeaders;
  #e;
  #t;
  #n = null;
  /**
   * Constructor.
   *
   * @param options Options.
   * @param options.browserFrame Browser frame.
   * @param options.window Window.
   * @param options.url URL.
   * @param [options.init] Init.
   * @param [options.redirectCount] Redirect count.
   * @param [options.contentType] Content Type.
   * @param [options.disableCache] Disables the use of cached responses. It will still store the response in the cache.
   * @param [options.disableSameOriginPolicy] Disables the Same-Origin policy.
   * @param [options.unfilteredHeaders] Unfiltered headers - necessary for preflight requests.
   */
  constructor(e) {
    this.#e = e.browserFrame, this.#t = e.window, this.#n = e.unfilteredHeaders ?? null, this.request = typeof e.url == "string" || e.url instanceof vi ? new e.window.Request(e.url, e.init) : e.url, e.contentType && (this.request[xi] = e.contentType), this.redirectCount = e.redirectCount ?? 0, this.disableCache = e.disableCache ?? !1, this.disableSameOriginPolicy = e.disableSameOriginPolicy ?? this.#e.page.context.browser.settings.fetch.disableSameOriginPolicy ?? !1, this.interceptor = this.#e.page.context.browser.settings.fetch.interceptor, this.requestHeaders = this.#e.page.context.browser.settings.fetch.requestHeaders;
  }
  /**
   * Sends request.
   *
   * @returns Response.
   */
  send() {
    if (Ug.prepareRequest(new vi(this.#t.location.href), this.request), this.requestHeaders) {
      for (const r of this.requestHeaders)
        if (!r.url || (typeof r.url == "string" ? r.url.startsWith(this.request.url) : this.request.url.match(r.url)))
          for (const [i, s] of Object.entries(r.headers))
            this.request.headers.set(i, s);
    }
    if (this.interceptor?.beforeSyncRequest) {
      const r = this.interceptor.beforeSyncRequest({
        request: this.request,
        window: this.#t
      });
      if (typeof r == "object")
        return r;
    }
    if (th.validateSchema(this.request), this.request.signal[xr])
      throw this.request.signal[mo] !== void 0 ? this.request.signal[mo] : new this.#t.DOMException("signal is aborted without reason", ne.abortError);
    if (this.request[Ir].protocol === "data:") {
      const r = tW.parse(this.request.url), i = {
        status: 200,
        statusText: "OK",
        ok: !0,
        url: this.request.url,
        redirected: !1,
        headers: new this.#t.Headers({ "Content-Type": r.type }),
        body: r.buffer,
        [wo]: null
      }, s = this.interceptor?.afterSyncResponse ? this.interceptor.afterSyncResponse({
        window: this.#t,
        response: i,
        request: this.request
      }) : void 0;
      return typeof s == "object" ? s : i;
    }
    if (this.request[Ir].protocol === "http:" && this.#t.location.protocol === "https:")
      throw new this.#t.DOMException(`Mixed Content: The page at '${this.#t.location.href}' was loaded over HTTPS, but requested an insecure XMLHttpRequest endpoint '${this.request.url}'. This request has been blocked; the content must be served over HTTPS.`, ne.securityError);
    const e = this.getCachedResponse();
    if (e)
      return e;
    const n = this.getVirtualServerResponse();
    if (n)
      return n;
    if (!this.compliesWithCrossOriginPolicy())
      throw this.#t.console.warn(`Cross-Origin Request Blocked: The Same Origin Policy disallows reading the remote resource at "${this.request.url}".`), new this.#t.DOMException(`Cross-Origin Request Blocked: The Same Origin Policy disallows reading the remote resource at "${this.request.url}".`, ne.networkError);
    return this.sendRequest();
  }
  /**
   * Returns cached response.
   *
   * @returns Response.
   */
  getCachedResponse() {
    if (this.disableCache)
      return null;
    let e = this.#e.page.context.responseCache.get(this.request);
    if (!e || e.response.waitingForBody)
      return null;
    if (e.state === bg.stale) {
      const n = new this.#t.Headers(e.request.headers);
      if (e.etag)
        n.set("If-None-Match", e.etag);
      else {
        if (!e.lastModified)
          return null;
        n.set("If-Modified-Since", new Date(e.lastModified).toUTCString());
      }
      if (e.etag || !e.staleWhileRevalidate) {
        const i = new af({
          browserFrame: this.#e,
          window: this.#t,
          url: this.request.url,
          init: { headers: n, method: e.request.method },
          disableCache: !0,
          disableSameOriginPolicy: !0
        }).send(), s = i.status !== 304 ? i.body : null;
        if (e = this.#e.page.context.responseCache.add(this.request, {
          ...i,
          body: s,
          waitingForBody: !1
        }), i.status !== 304)
          return i;
      } else
        new cu({
          browserFrame: this.#e,
          window: this.#t,
          url: this.request.url,
          init: { headers: n, method: e.request.method },
          disableCache: !0,
          disableSameOriginPolicy: !0
        }).send().then((i) => {
          i.buffer().then((s) => {
            this.#e.page.context.responseCache.add(this.request, {
              ...i,
              body: s,
              waitingForBody: !1
            });
          });
        });
    }
    return !e || e.response.waitingForBody ? null : {
      status: e.response.status,
      statusText: e.response.statusText,
      ok: !0,
      url: e.response.url,
      // TODO: Do we need to add support for redirected responses to the cache?
      redirected: !1,
      headers: e.response.headers,
      body: e.response.body,
      [wo]: e.response[wo] || null
    };
  }
  /**
   * Returns virtual server response.
   *
   * @returns Response.
   */
  getVirtualServerResponse() {
    let e = rf.getFilepath(this.#t, this.request.url);
    if (!e)
      return null;
    if (this.request.method !== "GET") {
      this.#e.page.console.error(`${this.request.method} ${this.request.url} 404 (Not Found)`);
      const a = rf.getNotFoundSyncResponse(this.#t, this.request.url), o = this.interceptor?.afterSyncResponse ? this.interceptor.afterSyncResponse({
        window: this.#t,
        response: a,
        request: this.request
      }) : void 0;
      return typeof o == "object" ? o : a;
    }
    let n;
    try {
      e = As.statSync(e).isDirectory() ? qr.join(e, "index.html") : e, n = As.readFileSync(e);
    } catch {
      this.#e.page.console.error(`${this.request.method} ${this.request.url} 404 (Not Found)`);
      const a = rf.getNotFoundSyncResponse(this.#t, this.request.url), o = this.interceptor?.afterSyncResponse ? this.interceptor.afterSyncResponse({
        window: this.#t,
        response: a,
        request: this.request
      }) : void 0;
      return typeof o == "object" ? o : a;
    }
    const r = {
      status: 200,
      statusText: "",
      ok: !0,
      url: this.request.url,
      redirected: !1,
      headers: new this.#t.Headers(),
      body: n,
      [wo]: e
    }, i = this.interceptor?.afterSyncResponse ? this.interceptor.afterSyncResponse({
      window: this.#t,
      response: r,
      request: this.request
    }) : void 0, s = typeof i == "object" ? i : r;
    return this.#e.page.context.responseCache.add(this.request, {
      ...s,
      waitingForBody: !1,
      virtual: !0
    }), s;
  }
  /**
   * Checks if the request complies with the Cross-Origin policy.
   *
   * @returns True if it complies with the policy.
   */
  compliesWithCrossOriginPolicy() {
    if (this.disableSameOriginPolicy || !vf.isCORS(this.#t.location.href, this.request[Ir]))
      return !0;
    const e = this.#e.page.context.preflightResponseCache.get(this.request);
    if (e)
      return !(e.allowOrigin !== "*" && e.allowOrigin !== this.#t.location.origin || e.allowMethods.length !== 0 && !e.allowMethods.includes(this.request.method));
    const n = [];
    for (const [u] of this.request.headers)
      n.push(u.toLowerCase());
    const r = new this.#t.Headers({
      "Access-Control-Request-Method": this.request.method,
      Origin: this.#t.location.origin
    });
    n.length > 0 && r.set("Access-Control-Request-Headers", n.slice().sort().join(","));
    const s = new af({
      browserFrame: this.#e,
      window: this.#t,
      url: this.request.url,
      init: { method: "OPTIONS" },
      disableCache: !0,
      disableSameOriginPolicy: !0,
      unfilteredHeaders: r
    }).send();
    if (!s.ok)
      return !1;
    const a = s.headers.get("Access-Control-Allow-Origin");
    if (!a || a !== "*" && a !== this.#t.location.origin)
      return !1;
    const o = [];
    if (s.headers.has("Access-Control-Allow-Methods")) {
      const u = s.headers.get("Access-Control-Allow-Methods");
      if (u !== "*")
        for (const l of u.split(","))
          o.push(l.trim().toUpperCase());
    }
    return !(o.length !== 0 && !o.includes(this.request.method));
  }
  /**
   * Sends request.
   *
   * @returns Response.
   */
  sendRequest() {
    if (!this.request[Ul] && this.request.body)
      throw new this.#t.DOMException("Streams are not supported as request body for synchronous requests.", ne.notSupportedError);
    const e = kHe.getScript({
      url: this.request[Ir],
      method: this.request.method,
      headers: VA.getRequestHeaders({
        browserFrame: this.#e,
        window: this.#t,
        request: this.request,
        baseHeaders: this.#n
      }),
      disableStrictSSL: this.#e.page.context.browser.settings.fetch.disableStrictSSL,
      body: this.request[Ul]
    }), n = jQ.execFileSync(process.argv[0], ["-e", e], {
      encoding: "buffer",
      maxBuffer: 1024 * 1024 * 1024
      // TODO: Consistent buffer size: 1GB.
    });
    if (!n.length)
      throw new this.#t.DOMException(`Synchronous fetch to "${this.request.url}" failed.`, ne.networkError);
    const { error: r, incomingMessage: i } = JSON.parse(n.toString());
    if (r)
      throw new this.#t.DOMException(`Synchronous fetch to "${this.request.url}" failed. Error: ${r}`, ne.networkError);
    const s = iW.parseResponseHeaders({
      browserFrame: this.#e,
      requestURL: this.request[Ir],
      rawHeaders: i.rawHeaders
    }), a = {
      status: i.statusCode,
      statusText: i.statusMessage,
      ok: i.statusCode >= 200 && i.statusCode < 300,
      url: this.request.url,
      redirected: this.redirectCount > 0,
      headers: s,
      body: this.parseIResponseBody({
        headers: s,
        status: i.statusCode,
        body: Buffer.from(i.data, "base64")
      })
    }, o = this.handleRedirectResponse(a) || a;
    !this.disableCache && !o.redirected && this.#e.page.context.responseCache.add(this.request, {
      status: o.status,
      statusText: o.statusText,
      url: o.url,
      headers: o.headers,
      body: o.body,
      waitingForBody: !1
    });
    const u = this.interceptor?.afterSyncResponse ? this.interceptor.afterSyncResponse({
      window: this.#t,
      response: o,
      request: this.request
    }) : void 0, l = typeof u == "object" ? u : o;
    return l.ok || this.#e.page.console.error(`${this.request.method} ${this.request.url} ${l.status} (${l.statusText})`), l;
  }
  /**
   * Parses response body.
   *
   * @param options Options.
   * @param options.headers Headers.
   * @param options.status Status.
   * @param options.body Body.
   * @returns Parsed body.
   */
  parseIResponseBody(e) {
    const n = e.headers.get("Content-Encoding");
    if (this.request.method === "HEAD" || n === null || e.status === 204 || e.status === 304)
      return e.body;
    try {
      if (n === "gzip" || n === "x-gzip")
        return Da.gunzipSync(e.body, {
          flush: Da.constants.Z_SYNC_FLUSH,
          finishFlush: Da.constants.Z_SYNC_FLUSH
        });
      if (n === "deflate" || n === "x-deflate")
        return Da.inflateSync(e.body);
      if (n === "br")
        return Da.brotliDecompressSync(e.body);
    } catch (r) {
      throw new this.#t.DOMException(`Failed to read response body. Error: ${r.message}.`, ne.encodingError);
    }
    return e.body;
  }
  /**
   * Handles redirect response.
   *
   * @param response Response.
   * @returns Redirected response or null.
   */
  handleRedirectResponse(e) {
    if (!K1.isRedirect(e.status))
      return null;
    switch (this.request.redirect) {
      case "error":
        throw new this.#t.DOMException(`URI requested responds with a redirect, redirect mode is set to "error": ${this.request.url}`, ne.abortError);
      case "manual":
        return null;
      case "follow":
        const n = e.headers.get("Location"), r = e.status === 303 || (e.status === 301 || e.status === 302) && this.request.method === "POST";
        let i = null;
        if (n !== null)
          try {
            i = new vi(n, this.request.url);
          } catch {
            throw new this.#t.DOMException(`URI requested responds with an invalid redirect URL: ${n}`, ne.uriMismatchError);
          }
        if (i === null)
          return null;
        if (K1.isMaxRedirectsReached(this.redirectCount))
          throw new this.#t.DOMException(`Maximum redirects reached at: ${this.request.url}`, ne.networkError);
        const s = new this.#t.Headers(this.request.headers), a = {
          method: this.request.method,
          signal: this.request.signal,
          referrer: this.request.referrer,
          referrerPolicy: this.request.referrerPolicy,
          credentials: this.request.credentials,
          headers: s,
          body: this.request[Ul]
        };
        (this.request.credentials === "omit" || this.request.credentials === "same-origin" && vf.isCORS(this.#t.location.href, i)) && (s.delete("cookie"), s.delete("cookie2")), r && (a.method = "GET", a.body = void 0, s.delete("Content-Length"), s.delete("Content-Type"));
        const o = Ug.getReferrerPolicyFromHeader(s);
        return o && (a.referrerPolicy = o), new af({
          browserFrame: this.#e,
          window: this.#t,
          url: i,
          init: a,
          redirectCount: this.redirectCount + 1,
          contentType: r ? null : this.request[xi]
        }).send();
      default:
        throw new this.#t.DOMException(`Redirect option '${this.request.redirect}' is not a valid value of IRequestRedirect`);
    }
  }
}
class z2 {
  window;
  /**
   * Constructor.
   *
   * @param window Window.
   */
  constructor(e) {
    this.window = e;
  }
  /**
   * Returns resource data asynchronously.
   *
   * @param url URL.
   * @param destination Destination.
   * @param [options]
   * @param [options.credentials] Credentials.
   * @param options.referrerPolicy
   * @returns Response.
   */
  async fetch(e, n, r) {
    const i = new pt(this.window).getBrowserFrame();
    if (!i)
      return {
        content: "",
        virtualServerFile: null
      };
    if (n === "script" || n === "style") {
      const o = j1.getKey({
        url: String(e),
        destination: n,
        mode: "cors",
        credentialsMode: r?.credentials || "same-origin"
      }), u = this.window.document[Va].get(o);
      if (u) {
        this.window.document[Va].delete(o);
        const l = u.response || await u.onResponseAvailable();
        if (l && !l.ok)
          throw new this.window.DOMException(`Failed to perform request to "${new vi(e, this.window.location.href).href}". Status ${u.response?.status || "0"} ${u.response?.statusText || "Unknown"}.`);
        return {
          content: u.response?.[En]?.toString() || "",
          virtualServerFile: u.response?.[wo] || null
        };
      }
    }
    const a = await new cu({
      browserFrame: i,
      window: this.window,
      url: e,
      disableSameOriginPolicy: n === "script" || n === "style",
      disablePreload: !0,
      init: {
        credentials: r?.credentials,
        referrerPolicy: r?.referrerPolicy
      }
    }).send();
    if (!a.ok)
      throw new this.window.DOMException(`Failed to perform request to "${new vi(e, this.window.location.href).href}". Status ${a.status} ${a.statusText}.`);
    return {
      content: await a.text(),
      virtualServerFile: a[wo] || null
    };
  }
  /**
   * Returns resource data synchronously.
   *
   * @param url URL.
   * @param destination Destination.
   * @param [options] Options.
   * @param [options.credentials] Credentials.
   * @param [options.referrerPolicy] Referrer policy.
   * @returns Response.
   */
  fetchSync(e, n, r) {
    const i = new pt(this.window).getBrowserFrame();
    if (!i)
      return {
        content: "",
        virtualServerFile: null
      };
    if (n === "script" || n === "style") {
      const o = j1.getKey({
        url: String(e),
        destination: n,
        mode: "cors",
        credentialsMode: r?.credentials || "same-origin"
      }), u = this.window.document[Va].get(o);
      if (u && u.response) {
        if (this.window.document[Va].delete(o), !u.response.ok)
          throw new this.window.DOMException(`Failed to perform request to "${new vi(e, this.window.location.href).href}". Status ${u.response.status} ${u.response.statusText}.`);
        return {
          content: u.response?.[En]?.toString() || "",
          virtualServerFile: u.response?.[wo] || null
        };
      }
    }
    const a = new af({
      browserFrame: i,
      window: this.window,
      url: e,
      disableSameOriginPolicy: !0,
      init: {
        credentials: r?.credentials,
        referrerPolicy: r?.referrerPolicy
      }
    }).send();
    if (!a.ok)
      throw new this.window.DOMException(`Failed to perform request to "${new vi(e, this.window.location.href).href}". Status ${a.status} ${a.statusText}.`);
    return {
      content: a.body?.toString() || "",
      virtualServerFile: a[wo] || null
    };
  }
}
class Eh {
  window;
  parentURL;
  /**
   * Constructor.
   *
   * @param window Window.
   * @param parentURL Parent URL.
   */
  constructor(e, n) {
    this.window = e, this.parentURL = n;
  }
  /**
   * Fetches the source code of the module from the given URL and creates a new module instance.
   *
   * @param url Module URL.
   * @param [parent] Parent module.
   * @param [options] Options.
   * @param [options.with] Options.
   * @param [options.with.type] Module type.
   */
  async getModule(e, n) {
    const r = this.window, i = this.parentURL, s = Ky.getURL(r, i, e), a = s.href, o = n?.with?.type || "esm";
    if (o !== "esm" && o !== "css" && o !== "json")
      throw new r.TypeError(`Failed to import module "${s}" from "${i}": Unknown type "${o}"`);
    const u = r[cc][o].get(a);
    if (u)
      return u instanceof eM ? (await new Promise((w, x) => {
        u.addResolveListener(w, x);
      }), r[cc][o].get(a)) : u;
    if (!new pt(r).getBrowserFrame())
      throw new r.TypeError(`Failed to import module "${s}" from "${i}": Window is closed and is no longer attached to a frame`);
    const h = new eM({ window: r, url: s }), f = r[Uu], m = f.startTask();
    r[cc][o].set(a, h);
    const g = new z2(r);
    let A;
    try {
      A = await g.fetch(s, "module");
    } catch (w) {
      throw f.endTask(m), h.resolve(w), w;
    }
    f.endTask(m);
    let E;
    switch (o) {
      case "json":
        E = new wW({ window: r, url: s, source: A.content });
        break;
      case "css":
        E = new SW({ window: r, url: s, source: A.content });
        break;
      case "esm":
        E = new yp({
          window: r,
          url: s,
          source: A.content,
          sourceURL: A.virtualServerFile || a
        });
        break;
    }
    return r[cc][o].set(a, E), h.resolve(), E;
  }
  /**
   * Imports a module.
   *
   * @param window Window.
   * @param parentURL Parent URL.
   * @param url URL.
   * @param [options] Options.
   * @param [options.with] With.
   * @param [options.with.type] Type.
   */
  async importModule(e, n) {
    const r = new pt(this.window).getBrowserFrame();
    if (!r)
      return {};
    const i = r[xt], s = i?.startTask(), o = await (await this.getModule(e, n)).evaluate();
    return i.endTask(s), o;
  }
}
const _He = { imports: [], execute: async () => {
} };
class yp {
  url;
  [b];
  #e;
  #t;
  #n = !1;
  #r = null;
  #i = null;
  #s = null;
  /**
   * Constructor.
   *
   * @param init Initialization options.
   */
  constructor(e) {
    this[b] = e.window, this.url = e.url, this.#e = e.source, this.#t = e.sourceURL || null;
  }
  /**
   * Compiles and evaluates the module.
   *
   * @param [parentUrls] Parent modules URLs to detect circular imports.
   * @param [circularResolver] Resolver for circular imports.
   * @returns Module exports.
   */
  async evaluate(e = [], n = null) {
    if (this.#s)
      return e.includes(this.url.href) ? (n && this.#s.push(n), this.#i) : new Promise((A) => {
        this.#s.push(A);
      });
    if (this.#i)
      return this.#i;
    const r = this.#u(), i = [], s = this[b], a = new pt(s).getBrowserFrame(), o = new Eh(s, this.url);
    if (!a)
      return {};
    const u = {};
    this.#i = u, this.#s = [];
    for (const A of r.imports)
      i.push(o.getModule(A.url, {
        with: { type: A.type }
      }));
    const l = /* @__PURE__ */ new Map();
    let h = null;
    const f = () => {
      h && h();
    };
    if (i.length) {
      const A = await Promise.all(i), E = [...e, this.url.href];
      for (const w of A)
        if (w instanceof yp) {
          const x = await w.evaluate(E, f);
          l.set(w.url.href, x);
        } else {
          const x = await w.evaluate();
          l.set(w.url.href, x);
        }
    }
    const m = this.url.href;
    r.execute({
      dispatchError: s[tr].bind(s),
      dynamicImport: o.importModule.bind(o),
      importMeta: {
        url: m,
        resolve: (A) => new Pr(A, m).href
      },
      imports: l,
      exports: u,
      addCircularImportResolver: (A) => h = A
    });
    const g = this.#s;
    this.#s = null;
    for (const A of g)
      A(u);
    return u;
  }
  /**
   * Compiles and preloads the module and its imports.
   *
   * @returns Promise.
   */
  async preload() {
    if (this.#n)
      return;
    this.#n = !0;
    const e = this.#u(), n = [], r = this[b], i = new pt(r).getBrowserFrame(), s = new Eh(r, this.url);
    if (!i)
      return;
    for (const u of e.imports)
      n.push(s.getModule(u.url, {
        with: { type: u.type }
      }));
    const a = await Promise.all(n), o = [];
    for (const u of a)
      o.push(u.preload());
    await Promise.all(o);
  }
  /**
   * Compiles the module.
   */
  #u() {
    if (this.#r)
      return this.#r;
    this.#r = _He;
    const e = new CHe(this[b]);
    return this.#r = e.compile(this.url.href, this.#e, this.#t), this.#r;
  }
}
class tM {
  /**
   * Evaluates code or a VM Script in the frame's context.
   *
   * @param frame Frame.
   * @param script Script.
   * @returns Result.
   */
  static evaluate(e, n) {
    if (!e.window)
      throw new Error('The frame has been destroyed, the "window" property is not set.');
    return n = typeof n == "string" ? new HM(n) : n, n.runInContext(e.window);
  }
  /**
   * Evaluates a module in the frame's context.
   *
   * @param frame Frame.
   * @param options Options.
   * @param options.url URL.
   * @param options.type Module type.
   * @param options.code Code.
   * @returns Exports.
   */
  static async evaluateModule(e, n) {
    if (!e.window)
      throw new Error('The frame has been destroyed, the "window" property is not set.');
    const r = e.window;
    if (n?.code) {
      const i = n.url ? new URL(n.url, r.location.href) : r.location, s = n.code;
      switch (n?.type || "esm") {
        case "esm":
          return await new yp({ window: r, url: i, source: s }).evaluate();
        case "json":
          return await new wW({ window: r, url: i, source: s }).evaluate();
        case "css":
          return await new SW({ window: r, url: i, source: s }).evaluate();
      }
    }
    return n?.url ? await (await new Eh(r, r.location).getModule(n.url, {
      with: { type: n.type || "esm" }
    })).evaluate() : {};
  }
}
class NHe {
  currentItem = {
    title: "",
    href: "about:blank",
    state: null,
    popState: !1,
    scrollRestoration: pc.auto,
    method: "GET",
    formData: null
  };
  items = [this.currentItem];
  /**
   * History item list.
   *
   * @param historyItem History item.
   */
  push(e) {
    const n = this.items.indexOf(this.currentItem);
    n !== this.items.length - 1 && (this.items.length = n + 1), this.items.push(e), this.currentItem = e;
  }
  /**
   *
   * @param historyItem
   */
  replace(e) {
    const n = this.items.indexOf(this.currentItem);
    if (n !== this.items.length - 1 && (this.items.length = n + 1), n === -1)
      throw new Error("Current history item not found");
    this.currentItem = e, this.items[n] = e;
  }
  /**
   * Clears history and sets current item to "about:blank".
   */
  clear() {
    this.items.length = 0, this.currentItem = {
      title: "",
      href: "about:blank",
      state: null,
      popState: !1,
      scrollRestoration: pc.auto,
      method: "GET",
      formData: null
    }, this.items.push(this.currentItem);
  }
}
class FW {
  childFrames = [];
  parentFrame = null;
  page;
  closed = !1;
  [xt] = new $2(this);
  [ur] = { navigation: [] };
  [zu] = null;
  [Ff] = null;
  [M1] = !1;
  [Ci] = new NHe();
  /**
   * Constructor.
   *
   * @param page Page.
   * @param [window] Window.
   */
  constructor(e) {
    this.page = e, e.context.browser.contexts[0]?.pages[0]?.mainFrame && (this.window = new this.page.context.browser.windowClass(this), e.context.browser[Ec] && e.context.browser[Ec].observe(this.window));
  }
  /**
   * Returns the content.
   *
   * @returns Content.
   */
  get content() {
    if (!this.window)
      throw new Error('The frame has been destroyed, the "window" property is not set.');
    return this.window.document.documentElement.outerHTML;
  }
  /**
   * Sets the content.
   *
   * @param content Content.
   */
  set content(e) {
    if (!this.window)
      throw new Error('The frame has been destroyed, the "window" property is not set.');
    this.window.document[pd] = !0, this.window.document[bd] = !1, this.window.document.open(), this.window.document.write(e);
  }
  /**
   * Returns the URL.
   *
   * @returns URL.
   */
  get url() {
    if (!this.window)
      throw new Error('The frame has been destroyed, the "window" property is not set.');
    return this.window.location.href;
  }
  /**
   * Sets the content.
   *
   * @param url URL.
   */
  set url(e) {
    if (!this.window)
      throw new Error('The frame has been destroyed, the "window" property is not set.');
    this.window[Gu][fo](this, Cf.getRelativeURL(this, e).href);
  }
  /**
   * Returns document.
   *
   * @returns Document.
   */
  get document() {
    return this.window?.document ?? null;
  }
  /**
   * Returns a promise that is resolved when all resources has been loaded, fetch has completed, and all async tasks such as timers are complete.
   */
  async waitUntilComplete() {
    await Promise.all([
      this[xt].waitUntilComplete(),
      ...this.childFrames.map((e) => e.waitUntilComplete())
    ]);
  }
  /**
   * Returns a promise that is resolved when the frame has navigated and the response HTML has been written to the document.
   */
  waitForNavigation() {
    return new Promise((e) => this[ur].navigation.push(e));
  }
  /**
   * Aborts all ongoing operations.
   */
  abort() {
    return this.childFrames.length ? new Promise((e, n) => {
      Promise.all(this.childFrames.map((r) => r.abort()).concat([this[xt].abort()])).then(() => e()).catch(n);
    }) : this[xt].abort();
  }
  /**
   * Evaluates code or a VM Script in the page's context.
   *
   * @param script Script.
   * @returns Result.
   */
  evaluate(e) {
    return tM.evaluate(this, e);
  }
  /**
   * Evaluates a module in the page's context.
   *
   * @param options Options.
   * @param options.url URL.
   * @param options.type Module type.
   * @param options.code Code.
   * @returns Module exports.
   */
  evaluateModule(e) {
    return tM.evaluateModule(this, e);
  }
  /**
   * Go to a page.
   *
   * @param url URL.
   * @param [options] Options.
   * @returns Response.
   */
  goto(e, n) {
    return Pa.navigate({
      windowClass: this.page.context.browser.windowClass,
      frame: this,
      url: e,
      goToOptions: n
    });
  }
  /**
   * Navigates back in history.
   *
   * @param [options] Options.
   */
  goBack(e) {
    return Pa.navigateBack({
      windowClass: this.page.context.browser.windowClass,
      frame: this,
      goToOptions: e
    });
  }
  /**
   * Navigates forward in history.
   *
   * @param [options] Options.
   */
  goForward(e) {
    return Pa.navigateForward({
      windowClass: this.page.context.browser.windowClass,
      frame: this,
      goToOptions: e
    });
  }
  /**
   * Navigates a delta in history.
   *
   * @param steps Steps.
   * @param [options] Options.
   */
  goSteps(e, n) {
    return Pa.navigateSteps({
      windowClass: this.page.context.browser.windowClass,
      frame: this,
      steps: e,
      goToOptions: n
    });
  }
  /**
   * Reloads the current frame.
   *
   * @param [options] Options.
   * @returns Response.
   */
  reload(e) {
    return Pa.reload({
      windowClass: this.page.context.browser.windowClass,
      frame: this,
      goToOptions: e
    });
  }
}
class nM {
  /**
   * Returns true if the frame navigation complies with the cross origin policy.
   *
   * @param frame Frame.
   * @param toURL URL.
   * @returns True if the frame navigation complies with the cross origin policy.
   */
  static validateCrossOriginPolicy(e, n) {
    const r = e.page.context.browser.settings;
    let i = e.page.mainFrame.window.location;
    return e[zu] ? i = e[zu].window.location : e.parentFrame && (i = e.parentFrame.window.location), !(r.navigation.crossOriginPolicy === ux.sameOrigin && i.protocol !== "about:" && n.protocol !== "about:" && n.protocol !== "javascript:" && i.origin !== n.origin || r.navigation.crossOriginPolicy === ux.strictOrigin && i.protocol === "https:" && n.protocol === "http:");
  }
  /**
   * Returns true if navigation is allowed for the frame.
   *
   * @param frame Frame.
   * @returns True if navigation is allowed for the frame.
   */
  static validateFrameNavigation(e) {
    const n = e.page.context.browser.settings;
    return !(e instanceof FW && e.page.context === e.page.context.browser.defaultContext && e.page.context.pages[0] === e.page && e.page.mainFrame === e || n.navigation.disableMainFrameNavigation && e.page.mainFrame === e || n.navigation.disableChildFrameNavigation && e.page.mainFrame !== e || n.navigation.disableChildPageNavigation && e[zu]);
  }
}
class Pa {
  /**
   * Navigates to a page.
   *
   * @throws Error if the request can't be resolved (because of SSL error or similar). It will not throw if the response is not ok.
   * @param options Options.
   * @param options.windowClass Window class.
   * @param options.frame Frame.
   * @param options.url URL.
   * @param [options.goToOptions] Go to options.
   * @param [options.method] Method.
   * @param [options.formData] Form data.
   * @param [options.disableHistory] Disables adding the navigation to the history.
   * @returns Response.
   */
  static async navigate(e) {
    const { windowClass: n, frame: r, url: i, formData: s, method: a, goToOptions: o, disableHistory: u } = e, l = r.page.context.browser[Ec], h = o?.referrer || r.window.location.origin, f = Cf.getRelativeURL(r, i), m = new URL(f.href.split("#")[0]), g = new URL(r.url.split("#")[0]), A = () => {
      const te = r[ur].navigation;
      r[ur].navigation = [];
      for (const Pe of te)
        Pe();
    };
    if (!r.window)
      throw new Error('The frame has been destroyed, the "window" property is not set.');
    if (m.href === g.href && f.hash && f.hash !== r.window?.location.hash) {
      const te = r[Ci];
      return u || (te.currentItem.popState = !0, te.push({
        title: "",
        href: f.href,
        state: null,
        popState: !0,
        scrollRestoration: pc.manual,
        method: a || (s ? "POST" : "GET"),
        formData: s || null
      })), r.window.location[fo](r, f.href), null;
    }
    if (f.protocol === "javascript:") {
      if (r && r.page.context.browser.settings.enableJavaScriptEvaluation) {
        const te = r.window[Uu], Pe = r[xt], We = te.startTask(), Me = f.href.replace("javascript:", "");
        await new Promise((Le) => {
          r.window.requestAnimationFrame(() => {
            const fn = setImmediate(() => {
              Pe.endTask(Yt), Le(null);
            }), Yt = Pe.startTask(() => () => {
              clearImmediate(fn), Le(null);
            });
            r.window[wf](Me, { filename: r.url });
          });
        }), te.endTask(We), A();
      }
      return null;
    }
    if (!nM.validateCrossOriginPolicy(r, f))
      return null;
    if (!nM.validateFrameNavigation(r))
      return r.page.context.browser.settings.navigation.disableFallbackToSetURL || r.window.location[fo](r, f.href), null;
    u || r[Ci].push({
      title: "",
      href: f.href,
      state: null,
      popState: !1,
      scrollRestoration: pc.auto,
      method: a || (s ? "POST" : "GET"),
      formData: s || null
    });
    const E = r.window, w = r[xt], x = E.innerWidth, N = E.innerHeight, B = E.devicePixelRatio, P = r.parentFrame ? r.parentFrame.window : r.page.mainFrame.window, C = r.page.mainFrame.window;
    r[xt] = new $2(r), r.window = new n(r, { url: f.href, width: x, height: N }), r.window[bo] = P, r.window[gc] = C, r.window.devicePixelRatio = B, l && l.observe(r.window), h && (r.window.document[ra] = h);
    const D = r[xt].startTask(), L = () => {
      w.destroy().then(() => {
        l && l.disconnect(E), r[xt].endTask(D);
      }), E[tn]();
    };
    if (r.childFrames.length ? Promise.all(r.childFrames.map((te) => yg.destroyFrame(te))).then(L) : L(), f.protocol === "about:")
      return o?.beforeContentCallback && o.beforeContentCallback(r.window), r.page.context.browser.settings.navigation.beforeContentCallback && r.page.context.browser.settings.navigation.beforeContentCallback(r.window), await new Promise((te) => r.page.mainFrame.window.requestAnimationFrame(te)), A(), null;
    const k = r.window[Uu], I = r[xt], U = new r.window.AbortController(), j = setTimeout(() => {
      I.endTimer(j), U.abort(new r.window.DOMException("The operation was aborted. Request timed out.", ne.timeoutError));
    }, o?.timeout ?? 3e4);
    I.startTimer(j);
    const J = k.startTask(), G = () => {
      clearTimeout(j), I.endTimer(j), k.endTask(J), A();
    }, H = new r.window.Headers(o?.headers);
    let q, X;
    o?.hard && H.set("Cache-Control", "no-cache");
    const ie = new cu({
      browserFrame: r,
      window: r.window,
      url: f.href,
      disableSameOriginPolicy: !0,
      init: {
        referrer: h,
        referrerPolicy: o?.referrerPolicy || "origin",
        signal: U.signal,
        method: a || (s ? "POST" : "GET"),
        headers: H,
        body: s
      }
    });
    try {
      if (q = await ie.send(), r.parentFrame) {
        const te = r.parentFrame.window.location, Pe = q.headers?.get("X-Frame-Options")?.toLowerCase(), We = te.origin === f.origin || f.origin === "null";
        if (Pe === "deny" || Pe === "sameorigin" && !We)
          throw new Error(`Refused to display '${i}' in a frame because it set 'X-Frame-Options' to '${Pe}'.`);
      }
      X = await q.text();
    } catch (te) {
      throw G(), te;
    }
    return r.window ? (q.url && r.window[Gu][fo](r, q.url), q.ok || r.page.console.error(`GET ${f.href} ${q.status} (${q.statusText})`), o?.beforeContentCallback && o.beforeContentCallback(r.window), r.page.context.browser.settings.navigation.beforeContentCallback && r.page.context.browser.settings.navigation.beforeContentCallback(r.window), await new Promise((te) => {
      r.window.requestAnimationFrame(() => {
        let Pe;
        const We = I.startTask(() => () => {
          clearImmediate(Pe), te(null);
        });
        Pe = setImmediate(() => {
          I.endTask(We), te(null);
        }), r.content = X;
      });
    }), G(), q) : null;
  }
  /**
   * Navigates back in history.
   *
   * @param options Options.
   * @param options.windowClass Window class.
   * @param options.frame Frame.
   * @param [options.goToOptions] Go to options.
   */
  static navigateBack(e) {
    const { windowClass: n, frame: r, goToOptions: i } = e, s = r[Ci], a = s.items[s.items.indexOf(s.currentItem) - 1];
    if (!a)
      return new Promise((l) => {
        r.window.requestAnimationFrame(() => {
          const h = r[ur].navigation;
          r[ur].navigation = [];
          for (const f of h)
            f();
          l(null);
        });
      });
    const o = new URL(s.currentItem.href).origin, u = new URL(a.href).origin;
    return s.currentItem = a, !a.popState || o !== u ? Pa.navigate({
      windowClass: n,
      frame: r,
      goToOptions: {
        ...i,
        referrer: r.url
      },
      url: a.href,
      method: a.method,
      formData: a.formData,
      disableHistory: !0
    }) : (r.window.location[fo](r, a.href), r.window.dispatchEvent(new r.window.PopStateEvent("popstate", {
      state: a.state,
      hasUAVisualTransition: !1
    })), Promise.resolve(null));
  }
  /**
   * Navigates forward in history.
   *
   * @param options Options.
   * @param options.windowClass Window class.
   * @param options.frame Frame.
   * @param [options.goToOptions] Go to options.
   */
  static navigateForward(e) {
    const { windowClass: n, frame: r, goToOptions: i } = e, s = r[Ci], a = s.items[s.items.indexOf(s.currentItem) + 1];
    if (!a)
      return new Promise((l) => {
        r.window.requestAnimationFrame(() => {
          const h = r[ur].navigation;
          r[ur].navigation = [];
          for (const f of h)
            f();
          l(null);
        });
      });
    const o = new URL(s.currentItem.href).origin, u = new URL(a.href).origin;
    return s.currentItem = a, !a.popState || o !== u ? Pa.navigate({
      windowClass: n,
      frame: r,
      goToOptions: {
        ...i,
        referrer: r.url
      },
      url: a.href,
      method: a.method,
      formData: a.formData,
      disableHistory: !0
    }) : (r.window.location[fo](r, a.href), r.window.dispatchEvent(new r.window.PopStateEvent("popstate", {
      state: a.state,
      hasUAVisualTransition: !1
    })), Promise.resolve(null));
  }
  /**
   * Navigates steps in history.
   *
   * @param options Options.
   * @param options.windowClass Window class.
   * @param options.frame Frame.
   * @param options.goToOptions Go to options.
   * @param options.steps Steps.
   */
  static navigateSteps(e) {
    if (!e.steps)
      return this.reload(e);
    const { windowClass: n, frame: r, goToOptions: i, steps: s } = e, a = r[Ci], o = a.items.indexOf(a.currentItem), u = o + s, l = a.items[u];
    if (!l)
      return new Promise((m) => {
        r.window.requestAnimationFrame(() => {
          const g = r[ur].navigation;
          r[ur].navigation = [];
          for (const A of g)
            A();
          m(null);
        });
      });
    const h = new URL(a.currentItem.href).origin;
    let f = !0;
    if (s < 0) {
      for (let m = o; m > u; m--)
        if (!a.items[m].popState || h !== new URL(a.items[m].href).origin) {
          f = !1;
          break;
        }
    } else
      for (let m = o; m < u; m++)
        if (!a.items[m].popState || h !== new URL(a.items[m].href).origin) {
          f = !1;
          break;
        }
    return a.currentItem = l, f ? (r.window.location[fo](r, l.href), r.window.dispatchEvent(new r.window.PopStateEvent("popstate", {
      state: l.state,
      hasUAVisualTransition: !1
    })), Promise.resolve(null)) : Pa.navigate({
      windowClass: n,
      frame: r,
      goToOptions: {
        ...i,
        referrer: r.url
      },
      url: l.href,
      method: l.method,
      formData: l.formData,
      disableHistory: !0
    });
  }
  /**
   * Reloads the current history item.
   *
   * @param options Options.
   * @param options.windowClass Window class.
   * @param options.frame Frame.
   * @param options.goToOptions Go to options.
   */
  static reload(e) {
    const { windowClass: n, frame: r, goToOptions: i } = e, s = r[Ci];
    return Pa.navigate({
      windowClass: n,
      frame: r,
      goToOptions: {
        ...i,
        referrer: r.url
      },
      url: s.currentItem.href,
      method: s.currentItem.method,
      formData: s.currentItem.formData,
      disableHistory: !0
    });
  }
}
class TW extends xo {
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    for (const e of this[Ge])
      if (e.checked)
        return e.value;
    return null;
  }
}
class j2 extends Ye {
  // Internal properties.
  [Gl] = null;
  [yn];
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Constructor.
   */
  constructor() {
    super();
    const e = new Ws(this, [
      j2,
      Ye,
      Sc,
      ot,
      Xr
    ]), n = new Proxy(this, {
      get: (r, i) => {
        if (i === "length")
          return r[Fa]().length;
        if (i in r || typeof i == "symbol")
          return e.bind(i), r[i];
        const s = Number(i);
        return isNaN(s) ? r[Fv](i) || void 0 : r[Fa]()[s];
      },
      set(r, i, s) {
        if (e.bind(i), typeof i == "symbol")
          return r[i] = s, !0;
        const a = Number(i);
        return isNaN(a) && (r[i] = s), !0;
      },
      deleteProperty(r, i) {
        if (typeof i == "symbol")
          return delete r[i], !0;
        const s = Number(i);
        return isNaN(s) && delete r[i], !0;
      },
      ownKeys(r) {
        return Object.keys(r[Fa]());
      },
      has(r, i) {
        if (i in r)
          return !0;
        if (typeof i == "symbol")
          return !1;
        const s = r[Fa](), a = Number(i);
        if (!isNaN(a) && a >= 0 && a < s.length)
          return !0;
        i = String(i);
        for (let o = 0; o < s.length; o++) {
          const u = s[o], l = u.getAttribute("id") || u.getAttribute("name");
          if (l && l === i)
            return !0;
        }
        return !1;
      },
      defineProperty(r, i, s) {
        if (e.preventBinding(i), !s.value)
          return Object.defineProperty(r, i, s), !0;
        const a = Number(s.value);
        return isNaN(a) ? (Object.defineProperty(r, i, s), !0) : !1;
      },
      getOwnPropertyDescriptor(r, i) {
        if (i in r)
          return Object.getOwnPropertyDescriptor(r, i);
        const s = r[Fa](), a = Number(i);
        if (!isNaN(a) && a >= 0 && a < s.length)
          return {
            value: s[a],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
        for (let o = 0; o < s.length; o++) {
          const u = s[o], l = u.getAttribute("id") || u.getAttribute("name");
          if (l && l === i)
            return {
              value: u,
              writable: !1,
              enumerable: !0,
              configurable: !0
            };
        }
      }
    });
    return this[yn] = n, this[Cn] = n, n;
  }
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onformdata() {
    return K.getEventListener(this, "onformdata");
  }
  set onformdata(e) {
    this[F].set("onformdata", e);
  }
  get onreset() {
    return K.getEventListener(this, "onreset");
  }
  set onreset(e) {
    this[F].set("onreset", e);
  }
  get onsubmit() {
    return K.getEventListener(this, "onsubmit");
  }
  set onsubmit(e) {
    this[F].set("onsubmit", e);
  }
  /**
   * Returns elements.
   *
   * @returns Elements.
   */
  get elements() {
    return this[Gl] || (this[Gl] = new EW(T, this)), this[Gl];
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[Fa]().length;
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns method.
   *
   * @returns Method.
   */
  get method() {
    return this.getAttribute("method") || "get";
  }
  /**
   * Sets method.
   *
   * @param method Method.
   */
  set method(e) {
    this.setAttribute("method", e);
  }
  /**
   * Returns target.
   *
   * @returns Target.
   */
  get target() {
    return this.getAttribute("target") || "";
  }
  /**
   * Sets target.
   *
   * @param target Target.
   */
  set target(e) {
    this.setAttribute("target", e);
  }
  /**
   * Returns action.
   *
   * @returns Action.
   */
  get action() {
    if (!this.hasAttribute("action"))
      return this[he].location.href;
    try {
      return new URL(this.getAttribute("action"), this[he].location.href).href;
    } catch {
      return "";
    }
  }
  /**
   * Sets action.
   *
   * @param action Action.
   */
  set action(e) {
    this.setAttribute("action", e);
  }
  /**
   * Returns encoding.
   *
   * @returns Encoding.
   */
  get encoding() {
    return this.getAttribute("encoding") || "";
  }
  /**
   * Sets encoding.
   *
   * @param encoding Encoding.
   */
  set encoding(e) {
    this.setAttribute("encoding", e);
  }
  /**
   * Returns enctype.
   *
   * @returns Enctype.
   */
  get enctype() {
    return this.getAttribute("enctype") || "";
  }
  /**
   * Sets enctype.
   *
   * @param enctype Enctype.
   */
  set enctype(e) {
    this.setAttribute("enctype", e);
  }
  /**
   * Returns autocomplete.
   *
   * @returns Autocomplete.
   */
  get autocomplete() {
    return this.getAttribute("autocomplete") || "";
  }
  /**
   * Sets autocomplete.
   *
   * @param autocomplete Autocomplete.
   */
  set autocomplete(e) {
    this.setAttribute("autocomplete", e);
  }
  /**
   * Returns accept charset.
   *
   * @returns Accept charset.
   */
  get acceptCharset() {
    return this.getAttribute("acceptcharset") || "";
  }
  /**
   * Sets accept charset.
   *
   * @param acceptCharset Accept charset.
   */
  set acceptCharset(e) {
    this.setAttribute("acceptcharset", e);
  }
  /**
   * Returns no validate.
   *
   * @returns No validate.
   */
  get noValidate() {
    return this.getAttribute("novalidate") !== null;
  }
  /**
   * Sets no validate.
   *
   * @param noValidate No validate.
   */
  set noValidate(e) {
    e ? this.setAttribute("novalidate", "") : this.removeAttribute("novalidate");
  }
  /**
   * Submits form. No submit event is raised. In particular, the form's "submit" event handler is not run.
   */
  submit() {
    this.#e();
  }
  /**
   * Submits form, reports validity and raises submit event.
   *
   * @param [submitter] Submitter.
   */
  requestSubmit(e) {
    if (e?.formNoValidate || this.noValidate || this.checkValidity()) {
      const r = new eW("submit", {
        bubbles: !0,
        cancelable: !0,
        submitter: e || this[yn]
      });
      this.dispatchEvent(r), r.defaultPrevented || this.#e(e);
    }
  }
  /**
   * Resets form.
   */
  reset() {
    for (const e of this[Fa]())
      switch (e[Xe]) {
        case "TEXTAREA":
          e[ze] = null;
          break;
        case "INPUT":
          e[ze] = null, e[md] = null;
          break;
        case "OUTPUT":
          e.textContent = e[So];
          break;
        case "SELECT":
          let n = !1;
          for (const r of e.options)
            if (r.hasAttribute("selected")) {
              n = !0, r.selected = !0;
              break;
            }
          !n && e.options.length > 0 && (e.options[0].selected = !0);
          break;
      }
    this.dispatchEvent(new be("reset", { bubbles: !0, cancelable: !0 }));
  }
  /**
   * Checks validity.
   *
   * @returns "true" if validation does'nt fail.
   */
  checkValidity() {
    const e = {};
    let n = !0;
    for (const r of this[Fa]())
      r[Xe] === "INPUT" && r.type === "radio" && r.name ? e[r.name] || (e[r.name] = !0, r.checkValidity() || (n = !1)) : r.checkValidity() || (n = !1);
    return n;
  }
  /**
   * Reports validity.
   *
   * @returns "true" if validation does'nt fail.
   */
  reportValidity() {
    return this.checkValidity();
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
  /**
   * Returns form control items.
   *
   * @returns Form control items.
   */
  [Fa]() {
    const e = it.querySelectorAll(this, "input,select,textarea,button,fieldset,object,output")[Ge].slice();
    if (this[st]) {
      const n = this.getAttribute("id");
      if (n)
        for (const r of it.querySelectorAll(this[he], `input[form="${n}"],select[form="${n}"],textarea[form="${n}"],button[form="${n}"],fieldset[form="${n}"],object[form="${n}"],output[form="${n}"]`)[Ge])
          e.includes(r) || e.push(r);
    }
    return e;
  }
  /**
   * Returns form control named item.
   *
   * @param name
   * @returns Form control named item.
   */
  [Fv](e) {
    const n = this[Fa](), r = [];
    e = String(e);
    for (const i of n)
      (i.getAttribute("id") === e || i.getAttribute("name") === e) && r.push(i);
    return r.length ? r.length === 1 ? r[0] : new TW(T, r) : null;
  }
  /**
   * Submits form.
   *
   * @param browserFrame Browser frame. Injected by the constructor.
   * @param [submitter] Submitter.
   */
  #e(e) {
    const n = e?.formMethod || this.method;
    if (n === "dialog") {
      let o = null, u = this;
      for (; u; ) {
        if (u[Xe] === "DIALOG") {
          o = u;
          break;
        }
        u = u.parentElement;
      }
      if (o) {
        o.close(e?.value);
        return;
      }
    }
    const r = e?.hasAttribute("formaction") ? e?.formAction || this.action : this.action, i = new pt(this[b]).getBrowserFrame();
    if (!i)
      return;
    if (!r) {
      this[he].location.hash = "#blocked";
      return;
    }
    const s = new this[b].FormData(this, e);
    let a;
    switch (e?.formTarget || this.target) {
      default:
      case "_self":
        a = i;
        break;
      case "_top":
        a = i.page.mainFrame;
        break;
      case "_parent":
        a = i.parentFrame ?? i;
        break;
      case "_blank":
        a = i.page.context.newPage().mainFrame, a[zu] = i;
        break;
    }
    if (n === "get") {
      const o = new URL(r);
      o.search = "";
      for (const [u, l] of s)
        typeof l == "string" && o.searchParams.append(u, l);
      Pa.navigate({
        windowClass: this[he][lu]?.constructor,
        frame: a,
        url: o.href,
        goToOptions: {
          referrer: i.page.mainFrame.window.location.origin
        }
      });
      return;
    }
    Pa.navigate({
      windowClass: this[he][lu]?.constructor,
      frame: a,
      method: n,
      url: r,
      formData: s,
      goToOptions: {
        referrer: i.page.mainFrame.window.location.origin
      }
    });
  }
}
class DHe extends Ye {
}
class IHe extends Ye {
}
class RHe extends Ye {
}
class PHe extends Ye {
}
class Q1 extends Xr {
  window = this;
  location;
  // Internal properties
  [Qd] = this;
  // Private properties
  #e;
  /**
   * Constructor.
   *
   * @param target Target window.
   * @param [parent] Parent window.
   */
  constructor(e, n) {
    super(), this[bo] = n ?? this, this[gc] = n ?? this, this.location = new Proxy({}, {
      get: () => {
        throw new Tr(`Blocked a frame with origin "${this.parent.location.origin}" from accessing a cross-origin frame.`, ne.securityError);
      },
      set: () => {
        throw new Tr(`Blocked a frame with origin "${this.parent.location.origin}" from accessing a cross-origin frame.`, ne.securityError);
      }
    }), this.#e = e;
  }
  /**
   * Returns self.
   *
   * @returns Self.
   */
  get self() {
    return this[Qd];
  }
  /**
   * Returns self.
   *
   * @param self Self.
   */
  set self(e) {
    this[Qd] = e;
  }
  /**
   * Returns top.
   *
   * @returns Top.
   */
  get top() {
    return this[gc];
  }
  /**
   * Returns parent.
   *
   * @returns Parent.
   */
  get parent() {
    return this[bo];
  }
  /**
   * Returns parent.
   *
   * @param parent Parent.
   */
  set parent(e) {
    this[bo] = e;
  }
  /**
   * Returns the opener.
   *
   * @returns Opener.
   */
  get opener() {
    return this.#e.opener;
  }
  /**
   * Returns the closed state.
   *
   * @returns Closed state.
   */
  get closed() {
    return this.#e.closed;
  }
  /**
   * Shifts focus away from the window.
   */
  blur() {
    this.#e.blur();
  }
  /**
   * Gives focus to the window.
   */
  focus() {
    this.#e.focus();
  }
  /**
   * Closes the window.
   */
  close() {
    this.#e.close();
  }
  /**
   * Safely enables cross-origin communication between Window objects; e.g., between a page and a pop-up that it spawned, or between a page and an iframe embedded within it.
   *
   * @param message Message.
   * @param [targetOrigin=*] Target origin.
   * @param transfer Transfer. Not implemented.
   */
  postMessage(e, n = "*", r) {
    this.#e.postMessage(e, n, r);
  }
}
const LHe = [
  "allow-downloads",
  "allow-forms",
  "allow-modals",
  "allow-orientation-lock",
  "allow-pointer-lock",
  "allow-popups",
  "allow-popups-to-escape-sandbox",
  "allow-presentation",
  "allow-same-origin",
  "allow-scripts",
  "allow-top-navigation",
  "allow-top-navigation-by-user-activation",
  "allow-top-navigation-to-custom-protocols"
];
class MHe extends Ye {
  // Internal properties
  [X0] = null;
  // Private properties
  #e = {
    window: null
  };
  #t = null;
  #n = null;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onload() {
    return K.getEventListener(this, "onload");
  }
  set onload(e) {
    this[F].set("onload", e);
  }
  get onerror() {
    return K.getEventListener(this, "onerror");
  }
  set onerror(e) {
    this[F].set("onerror", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns source.
   *
   * @returns Source.
   */
  get src() {
    if (!this.hasAttribute("src"))
      return "";
    try {
      return new URL(this.getAttribute("src"), this[he].location.href).href;
    } catch {
      return this.getAttribute("src");
    }
  }
  /**
   * Sets source.
   *
   * @param src Source.
   */
  set src(e) {
    this.setAttribute("src", e);
  }
  /**
   * Returns allow.
   *
   * @returns Allow.
   */
  get allow() {
    return this.getAttribute("allow") || "";
  }
  /**
   * Sets allow.
   *
   * @param allow Allow.
   */
  set allow(e) {
    this.setAttribute("allow", e);
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this.getAttribute("height") || "";
  }
  /**
   * Sets height.
   *
   * @param height Height.
   */
  set height(e) {
    this.setAttribute("height", e);
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this.getAttribute("width") || "";
  }
  /**
   * Sets width.
   *
   * @param width Width.
   */
  set width(e) {
    this.setAttribute("width", e);
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns sandbox.
   *
   * @returns Sandbox.
   */
  get sandbox() {
    return this[X0] || (this[X0] = new Zu(T, this, "sandbox")), this[X0];
  }
  /**
   * Sets sandbox.
   */
  set sandbox(e) {
    this.setAttribute("sandbox", e);
  }
  /**
   * Returns srcdoc.
   *
   * @returns Srcdoc.
   */
  get srcdoc() {
    return this.getAttribute("srcdoc") || "";
  }
  /**
   * Sets srcdoc.
   *
   * @param srcdoc Srcdoc.
   */
  set srcdoc(e) {
    this.setAttribute("srcdoc", e);
  }
  /**
   * Returns referrer policy.
   */
  get referrerPolicy() {
    return this.getAttribute("referrerpolicy") || "";
  }
  /**
   * Sets referrer policy.
   *
   * @param referrerPolicy Referrer policy.
   */
  set referrerPolicy(e) {
    this.setAttribute("referrerpolicy", e);
  }
  /**
   * Returns content document.
   *
   * @returns Content document.
   */
  get contentDocument() {
    return this.#e.window?.document ?? null;
  }
  /**
   * Returns content window.
   *
   * @returns Content window.
   */
  get contentWindow() {
    return this.#e.window;
  }
  /**
   * @override
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
  /**
   * @override
   */
  set tabIndex(e) {
    super.tabIndex = e;
  }
  /**
   * @override
   */
  [Hs]() {
    super[Hs](), this.#i();
  }
  /**
   * Called when disconnected from document.
   * @param e
   */
  [Bs]() {
    super[Bs](), this.#s();
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
  /**
   * @override
   */
  [as](e, n) {
    super[as](e, n), e[tt] === "srcdoc" && this.#i(), e[tt] === "src" && e[ze] && !this.hasAttribute("srcdoc") && e[ze] !== n?.[ze] && this.#i(), e[tt] === "sandbox" && this.#r();
  }
  /**
   * @override
   */
  [qa](e) {
    super[qa](e), (e[tt] === "srcdoc" || e[tt] === "src") && this.#i();
  }
  /**
   *
   * @param tokens
   * @param vconsole
   */
  #r() {
    const e = this[b], n = [];
    for (const r of this.sandbox)
      LHe.includes(r) || n.push(r);
    n.length === 1 ? e.console.error(`Error while parsing the 'sandbox' attribute: '${n[0]}' is an invalid sandbox flag.`) : n.length > 1 && e.console.error(`Error while parsing the 'sandbox' attribute: '${n.join("', '")}' are invalid sandbox flags.`);
  }
  /**
   * Loads an iframe page.
   */
  #i() {
    if (!this[st]) {
      this.#s();
      return;
    }
    const e = this.getAttribute("srcdoc"), n = this[b], r = new pt(n).getBrowserFrame();
    if (!r)
      return;
    if (e !== null) {
      if (this.#n === e)
        return;
      this.#s(), this.#t = yg.createChildFrame(r), this.#t.url = "about:srcdoc", this.#e.window = this.#t.window, this.#t.window[gc] = r.window.top, this.#t.window[bo] = r.window, this.#t.window.document.open(), this.#t.window.document.write(e), this.#n = e, this[b].requestAnimationFrame(() => this.dispatchEvent(new be("load")));
      return;
    }
    this.#n !== null && this.#s();
    const i = r.window.location, s = Cf.getRelativeURL(r, this.src);
    if (this.#t && this.#t.window.location.href === s.href)
      return;
    if (r.page.context.browser.settings.disableIframePageLoading) {
      const u = new n.DOMException(`Failed to load iframe page "${s.href}". Iframe page loading is disabled.`, ne.notSupportedError);
      r.page.console.error(u), this.dispatchEvent(new be("error"));
      return;
    }
    const a = i.origin === s.origin || s.origin === "null", o = a ? n : new Q1(n);
    this.#t = this.#t ?? yg.createChildFrame(r), this.#t.window[gc] = o, this.#t.window[bo] = o, this.#t.goto(s.href, {
      referrer: i.origin,
      referrerPolicy: this.referrerPolicy
    }).then(() => this.dispatchEvent(new be("load"))).catch((u) => {
      r.page.console.error(u), this.dispatchEvent(new be("error"));
    }), this.#e.window = a ? this.#t.window : new Q1(this.#t.window, n);
  }
  /**
   * Unloads an iframe page.
   */
  #s() {
    this.#t && (yg.destroyFrame(this.#t), this.#t = null), this.#e.window = null, this.#n = null;
  }
}
class vW extends Ye {
  [Xe] = "IMG";
  [dL] = !1;
  [fL] = 0;
  [mL] = 0;
  [U8e] = "auto";
  [me] = 0;
  [ge] = 0;
  /**
   * Returns complete.
   *
   * @returns Complete.
   */
  get complete() {
    return this[dL];
  }
  /**
   * Returns natural height.
   *
   * @returns Natural height.
   */
  get naturalHeight() {
    return this[fL];
  }
  /**
   * Returns natural width.
   *
   * @returns Natural width.
   */
  get naturalWidth() {
    return this[mL];
  }
  /**
   * Returns loading.
   *
   * @returns Loading.
   */
  get loading() {
    const e = this.getAttribute("loading");
    return e === "eager" || e === "lazy" ? e : "auto";
  }
  /**
   * Sets loading.
   *
   * @param loading Loading.
   */
  set loading(e) {
    this.setAttribute("loading", e);
  }
  /**
   * Returns x.
   */
  get x() {
    return this[me];
  }
  /**
   * Returns y.
   */
  get y() {
    return this[ge];
  }
  /**
   * Returns decoding.
   *
   * @returns Decoding.
   */
  get decoding() {
    return this.getAttribute("decoding") || "auto";
  }
  /**
   * Sets decoding.
   *
   * @param decoding Decoding.
   */
  set decoding(e) {
    this.setAttribute("decoding", e);
  }
  /**
   * Returns cross origin.
   *
   * @returns Cross origin.
   */
  get crossOrigin() {
    return this.getAttribute("crossOrigin");
  }
  /**
   * Sets cross origin.
   *
   * @param crossOrigin Cross origin.
   */
  set crossOrigin(e) {
    (e === "anonymous" || e === "use-credentials") && this.setAttribute("crossOrigin", e);
  }
  /**
   * Returns alt.
   *
   * @returns Alt.
   */
  get alt() {
    return this.getAttribute("alt") || "";
  }
  /**
   * Sets alt.
   *
   * @param alt Alt.
   */
  set alt(e) {
    this.setAttribute("alt", e);
  }
  /**
   * Returns current src.
   *
   * @returns Current src.
   */
  get currentSrc() {
    return this.src;
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    const e = this.getAttribute("width");
    return e !== null ? Number(e) : 0;
  }
  /**
   * Sets width.
   *
   * @param width Width.
   */
  set width(e) {
    this.setAttribute("width", String(e));
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    const e = this.getAttribute("height");
    return e !== null ? Number(e) : 0;
  }
  /**
   * Sets height.
   *
   * @param height Height.
   */
  set height(e) {
    this.setAttribute("height", String(e));
  }
  /**
   * Returns is map.
   *
   * @returns Is map.
   */
  get isMap() {
    return this.getAttribute("ismap") !== null;
  }
  /**
   * Sets is map.
   *
   * @param ismap Is map.
   */
  set isMap(e) {
    e ? this.setAttribute("ismap", "") : this.removeAttribute("ismap");
  }
  /**
   * Returns referrer policy.
   *
   * @returns Referrer policy.
   */
  get referrerPolicy() {
    return this.getAttribute("referrerpolicy") || "";
  }
  /**
   * Sets referrer policy.
   *
   * @param referrerPolicy Referrer policy.
   */
  set referrerPolicy(e) {
    this.setAttribute("referrerpolicy", e);
  }
  /**
   * Returns sizes.
   *
   * @returns Sizes.
   */
  get sizes() {
    return this.getAttribute("sizes") || "";
  }
  /**
   * Sets sizes.
   *
   * @param sizes Sizes.
   */
  set sizes(e) {
    this.setAttribute("sizes", e);
  }
  /**
   * Returns source.
   *
   * @returns Source.
   */
  get src() {
    if (!this.hasAttribute("src"))
      return "";
    try {
      return new URL(this.getAttribute("src"), this[he].location.href).href;
    } catch {
      return this.getAttribute("src");
    }
  }
  /**
   * Sets source.
   *
   * @param src Source.
   */
  set src(e) {
    this.setAttribute("src", e);
  }
  /**
   * Returns srcset.
   *
   * @returns Source.
   */
  get srcset() {
    return this.getAttribute("srcset") || "";
  }
  /**
   * Sets src set.
   *
   * @param srcset Src set.
   */
  set srcset(e) {
    this.setAttribute("srcset", e);
  }
  /**
   * Returns use map.
   *
   * @returns Use map.
   */
  get useMap() {
    return this.getAttribute("usemap") || "";
  }
  /**
   * Sets is map.
   *
   * @param useMap Is map.
   */
  set useMap(e) {
    this.setAttribute("usemap", e);
  }
  /**
   * The decode() method of the HTMLImageElement interface returns a Promise that resolves when the image is decoded and it is safe to append the image to the DOM.
   *
   * @returns Promise.
   */
  decode() {
    return Promise.resolve();
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
}
class OHe extends Ye {
  /**
   * Returns a string containing the ID of the labeled control. This reflects the "for" attribute.
   *
   * @returns ID of the labeled control.
   */
  get htmlFor() {
    const e = this.getAttribute("for");
    return e !== null || e !== null ? e : "";
  }
  /**
   * Sets a string containing the ID of the labeled control. This reflects the "for" attribute.
   *
   * @param htmlFor ID of the labeled control.
   */
  set htmlFor(e) {
    this.setAttribute("for", e);
  }
  /**
   * Returns an HTML element representing the control with which the label is associated.
   *
   * @returns Control element.
   */
  get control() {
    const e = this.getAttribute("for");
    if (e !== null) {
      if (!e || !this[st])
        return null;
      const n = this[ci].getElementById(e);
      if (n)
        switch (n[Xe]) {
          case "INPUT":
            return n.type !== "hidden" ? n : null;
          case "BUTTON":
          case "METER":
          case "OUTPUT":
          case "PROGRESS":
          case "SELECT":
          case "TEXTAREA":
            return n;
          default:
            return null;
        }
    }
    return this.querySelector('button,input:not([type="hidden"]),meter,output,progress,select,textarea');
  }
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    return this.control?.form || null;
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
  /**
   * @override
   */
  dispatchEvent(e) {
    const n = super.dispatchEvent(e);
    if (!e[vo] && e.type === "click" && (e.eventPhase === mr.atTarget || e.eventPhase === mr.bubbling) && e instanceof _o) {
      const r = this.control;
      r && e.target !== r && r.dispatchEvent(new _o("click", { bubbles: !0, cancelable: !0 }));
    }
    return n;
  }
}
class BHe extends Ye {
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    let e = this;
    for (; e; ) {
      if (e instanceof AW)
        return e.form;
      e = e.parentNode;
    }
    return null;
  }
}
class $He extends Ye {
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    if (!this.hasAttribute("value"))
      return 0;
    const e = Number(this.getAttribute("value"));
    return isNaN(e) ? 0 : e;
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    const n = Number(e);
    this.setAttribute("value", isNaN(n) ? "0" : String(n));
  }
}
class HHe {
  integrityMetadata = null;
  response = null;
  error = null;
  #e = null;
  /**
   * On response available.
   *
   * @returns Response.
   */
  onResponseAvailable() {
    return new Promise((e, n) => {
      this.#e = { resolve: e, reject: n };
    });
  }
  /**
   * Response available.
   *
   * @param error
   * @param response
   */
  responseAvailable(e, n) {
    this.response = n, this.error = e, this.#e && (e ? this.#e.reject(e) : n ? this.#e.resolve(n) : this.#e.reject(new Error("Response is null")));
  }
}
class UHe extends Ye {
  // Internal properties
  [Yr] = null;
  [Tf] = !1;
  [La] = null;
  #e = null;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onerror() {
    return K.getEventListener(this, "onerror");
  }
  set onerror(e) {
    this[F].set("onerror", e);
  }
  get onload() {
    return K.getEventListener(this, "onload");
  }
  set onload(e) {
    this[F].set("onload", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns sheet.
   */
  get sheet() {
    return this[Yr];
  }
  /**
   * Returns rel list.
   *
   * @returns Rel list.
   */
  get relList() {
    return this[La] || (this[La] = new Zu(T, this, "rel", ["stylesheet", "modulepreload", "preload"])), this[La];
  }
  /**
   * Sets rel list.
   *
   * @param value Value.
   */
  set relList(e) {
    this.setAttribute("rel", e);
  }
  /**
   * Returns as.
   *
   * @returns As.
   */
  get as() {
    return this.getAttribute("as") || "";
  }
  /**
   * Sets as.
   *
   * @param as As.
   */
  set as(e) {
    this.setAttribute("as", e);
  }
  /**
   * Returns crossOrigin.
   *
   * @returns CrossOrigin.
   */
  get crossOrigin() {
    return this.getAttribute("crossorigin") || "";
  }
  /**
   * Sets crossOrigin.
   *
   * @param crossOrigin CrossOrigin.
   */
  set crossOrigin(e) {
    this.setAttribute("crossorigin", e);
  }
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    if (!this.hasAttribute("href"))
      return "";
    try {
      return new URL(this.getAttribute("href"), this[he].location.href).href;
    } catch {
      return this.getAttribute("href");
    }
  }
  /**
   * Sets href.
   *
   * @param href Href.
   */
  set href(e) {
    this.setAttribute("href", e);
  }
  /**
   * Returns hreflang.
   *
   * @returns Hreflang.
   */
  get hreflang() {
    return this.getAttribute("hreflang") || "";
  }
  /**
   * Sets hreflang.
   *
   * @param hreflang Hreflang.
   */
  set hreflang(e) {
    this.setAttribute("hreflang", e);
  }
  /**
   * Returns media.
   *
   * @returns Media.
   */
  get media() {
    return this.getAttribute("media") || "";
  }
  /**
   * Sets media.
   *
   * @param media Media.
   */
  set media(e) {
    this.setAttribute("media", e);
  }
  /**
   * Returns referrerPolicy.
   *
   * @returns ReferrerPolicy.
   */
  get referrerPolicy() {
    return this.getAttribute("referrerPolicy") || "";
  }
  /**
   * Sets referrerPolicy.
   *
   * @param referrerPolicy ReferrerPolicy.
   */
  set referrerPolicy(e) {
    this.setAttribute("referrerPolicy", e);
  }
  /**
   * Returns rel.
   *
   * @returns Rel.
   */
  get rel() {
    return this.getAttribute("rel") || "";
  }
  /**
   * Sets rel.
   *
   * @param rel Rel.
   */
  set rel(e) {
    this.setAttribute("rel", e);
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "";
  }
  /**
   * Sets type.
   *
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
  /**
   * @override
   */
  [Hs]() {
    super[Hs]();
    const e = this.getAttribute("rel"), n = this.getAttribute("href");
    if (e && n)
      switch (e) {
        case "stylesheet":
          this.#r(n);
          break;
        case "modulepreload":
          this.#t(n);
          break;
        case "preload":
          this.#n(n);
          break;
      }
  }
  /**
   * @override
   */
  [as](e, n) {
    if (super[as](e, n), e[tt] === "rel" || e[tt] === "href") {
      const r = this.getAttribute("rel"), i = this.getAttribute("href");
      if (r && i)
        switch (r) {
          case "stylesheet":
            this.#r(i);
            break;
          case "modulepreload":
            this.#t(i);
            break;
          case "preload":
            this.#n(i);
            break;
        }
    }
  }
  /**
   * Preloads a module.
   *
   * @param url URL.
   */
  async #t(e) {
    const n = this[b], r = new pt(n).getBrowserFrame(), i = new pt(n).getSettings();
    if (!r || !i || !this[st] || i.disableJavaScriptFileLoading || !i.enableJavaScriptEvaluation)
      return;
    const s = new Eh(n, n.location);
    if (i.disableErrorCapturing || i.errorCapture !== Rr.tryAndCatch)
      await (await s.getModule(e)).preload();
    else
      try {
        await (await s.getModule(e)).preload();
      } catch (a) {
        r.page.console.error(a), n[tr](a);
        return;
      }
  }
  /**
   * Preloads a resource.
   *
   * @param url URL.
   */
  async #n(e) {
    const n = this[b], r = new pt(n).getBrowserFrame(), i = this.as;
    if (!r || !this[st] || i !== "script" && i !== "style" && i !== "fetch")
      return;
    const s = r.page.context.browser.settings;
    if (i === "script" && (s.disableJavaScriptFileLoading || !s.enableJavaScriptEvaluation) || i === "style" && s.disableCSSFileLoading)
      return;
    const a = new URL(e, n.location.href).href, o = j1.getKey({
      url: a,
      destination: i,
      mode: "cors",
      credentialsMode: this.crossOrigin === "use-credentials" ? "include" : "same-origin"
    });
    if (n.document[Va].has(o))
      return;
    const u = new HHe();
    n.document[Va].set(o, u);
    const l = new cu({
      browserFrame: r,
      window: n,
      url: a,
      disableSameOriginPolicy: i === "script" || i === "style",
      disablePreload: !0,
      init: {
        credentials: this.crossOrigin === "use-credentials" ? "include" : "same-origin"
      }
    });
    try {
      const h = await l.send();
      h[En] || await h.buffer(), u.responseAvailable(null, h);
    } catch (h) {
      u.responseAvailable(h, null), n.document[Va].delete(o), r.page.console.error(`Failed to preload resource "${a}": ${h.message}`);
    }
  }
  /**
   * Returns a URL relative to the given Location object.
   *
   * @param url URL.
   * @param rel Rel.
   */
  async #r(e) {
    const n = this[b], r = new pt(n).getBrowserFrame();
    if (!r || e === null)
      return;
    const i = r.page.context.browser.settings;
    if (this[Tf] || !this[st])
      return;
    let s;
    try {
      s = new URL(e, n.location.href).href;
    } catch {
      return;
    }
    if (this.#e === s)
      return;
    if (i && i.disableCSSFileLoading) {
      if (i.handleDisabledFileLoadingAsSuccess)
        this.dispatchEvent(new be("load"));
      else {
        const f = new n.DOMException(`Failed to load external stylesheet "${s}". CSS file loading is disabled.`, ne.notSupportedError);
        r.page.console.error(f), this.dispatchEvent(new be("error"));
      }
      return;
    }
    const a = new z2(n), o = n[Uu];
    this.#e = s;
    const u = o.startTask();
    let l = null, h = null;
    try {
      l = await a.fetch(s, "style", {
        credentials: this.crossOrigin === "use-credentials" ? "include" : "same-origin"
      });
    } catch (f) {
      h = f;
    }
    if (o.endTask(u), h)
      r.page.console.error(h), this.dispatchEvent(new be("error"));
    else {
      const f = new this[he][b].CSSStyleSheet();
      f.replaceSync(l.content), this[Yr] = f;
      const m = this[he];
      if (m) {
        for (const g of m[fc])
          g.result = null;
        m[fc] = [];
      }
      this.dispatchEvent(new be("load"));
    }
  }
}
class GHe extends Ye {
  [Z0] = null;
  /**
   * Returns areas.
   *
   * @returns Areas.
   */
  get areas() {
    return this[Z0] || (this[Z0] = Wn.getElementsByTagName(this, "area")), this[Z0];
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
}
class lx extends Array {
  /**
   * Constructor.
   *
   * @param [illegalConstructorSymbol] Illegal constructor symbol.
   */
  constructor(e) {
    if (super(), e !== 1 && e !== T)
      throw new TypeError("Illegal constructor");
  }
  /**
   * Returns the first TextTrackCue object with the identifier passed to it.
   *
   * @param id Text track cue identifier.
   */
  getCueById(e) {
    for (const n of this)
      if (n.id === e)
        return n;
    return null;
  }
}
class WHe extends Ye {
}
class VHe extends Ye {
  /**
   * Returns content.
   *
   * @returns Content.
   */
  get content() {
    return this.getAttribute("content") || "";
  }
  /**
   * Sets content.
   *
   * @param content Content.
   */
  set content(e) {
    this.setAttribute("content", e);
  }
  /**
   * Returns httpEquiv.
   *
   * @returns HttpEquiv.
   */
  get httpEquiv() {
    return this.getAttribute("http-equiv") || "";
  }
  /**
   * Sets httpEquiv.
   *
   * @param httpEquiv HttpEquiv.
   */
  set httpEquiv(e) {
    this.setAttribute("http-equiv", e);
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns scheme.
   *
   * @returns Name.
   */
  get scheme() {
    return this.getAttribute("scheme") || "";
  }
  /**
   * Sets scheme.
   *
   * @param scheme Scheme.
   */
  set scheme(e) {
    this.setAttribute("scheme", e);
  }
}
class KHe extends Ye {
  /**
   * Returns high.
   *
   * @returns High.
   */
  get high() {
    if (!this.hasAttribute("high"))
      return 1;
    const e = parseFloat(this.getAttribute("high") || "");
    return isNaN(e) || e > 1 ? 1 : e < 0 ? 0 : e;
  }
  /**
   * Sets high.
   *
   * @param high High.
   */
  set high(e) {
    if (e = typeof e != "number" ? Number(e) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'high' property on 'HTMLMeterElement': The provided double value is non-finite.");
    this.setAttribute("high", String(e));
  }
  /**
   * Returns low.
   *
   * @returns Low.
   */
  get low() {
    if (!this.hasAttribute("low"))
      return 0;
    const e = parseFloat(this.getAttribute("low") || "");
    return isNaN(e) || e < 0 ? 0 : e > 1 ? 1 : e;
  }
  /**
   * Sets low.
   *
   * @param low Low.
   */
  set low(e) {
    if (e = typeof e != "number" ? Number(e) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'low' property on 'HTMLMeterElement': The provided double value is non-finite.");
    this.setAttribute("low", String(e));
  }
  /**
   * Returns max.
   *
   * @returns Max.
   */
  get max() {
    if (!this.hasAttribute("max"))
      return 1;
    const e = parseFloat(this.getAttribute("max") || "");
    return isNaN(e) || e > 1 ? 1 : e < 0 ? 0 : e;
  }
  /**
   * Sets max.
   *
   * @param max Max.
   */
  set max(e) {
    if (e = typeof e != "number" ? Number(e) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'max' property on 'HTMLMeterElement': The provided double value is non-finite.");
    this.setAttribute("max", String(e));
  }
  /**
   * Returns min.
   *
   * @returns Min.
   */
  get min() {
    if (!this.hasAttribute("min"))
      return 0;
    const e = parseFloat(this.getAttribute("min") || "");
    return isNaN(e) || e < 0 ? 0 : e > 1 ? 1 : e;
  }
  /**
   * Sets min.
   *
   * @param min Min.
   */
  set min(e) {
    if (e = typeof e != "number" ? Number(e) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'min' property on 'HTMLMeterElement': The provided double value is non-finite.");
    this.setAttribute("min", String(e));
  }
  /**
   * Returns optimum.
   *
   * @returns Optimum.
   */
  get optimum() {
    if (!this.hasAttribute("optimum"))
      return 0.5;
    const e = parseFloat(this.getAttribute("optimum") || "");
    return isNaN(e) ? 0.5 : e < 0 ? 0 : e > 1 ? 1 : e;
  }
  /**
   * Sets optimum.
   *
   * @param optimum Optimum.
   */
  set optimum(e) {
    if (e = typeof e != "number" ? Number(e) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'optimum' property on 'HTMLMeterElement': The provided double value is non-finite.");
    this.setAttribute("optimum", String(e));
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    if (!this.hasAttribute("value"))
      return 0;
    const e = parseFloat(this.getAttribute("value") || "");
    return isNaN(e) || e < 0 ? 0 : e > 1 ? 1 : e;
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    if (e = typeof e != "number" ? Number(e) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'value' property on 'HTMLMeterElement': The provided double value is non-finite.");
    this.setAttribute("value", String(e));
  }
  /**
   * Returns the associated label elements.
   *
   * @returns Label elements.
   */
  get labels() {
    return Ph.getAssociatedLabelElements(this);
  }
}
class zHe extends Ye {
  /**
   * Returns source.
   *
   * @returns Source.
   */
  get cite() {
    if (!this.hasAttribute("cite"))
      return "";
    try {
      return new URL(this.getAttribute("cite"), this[he].location.href).href;
    } catch {
      return this.getAttribute("cite");
    }
  }
  /**
   * Sets source.
   *
   * @param cite Source.
   */
  set cite(e) {
    this.setAttribute("cite", e);
  }
  /**
   * Returns date time.
   *
   * @returns Date time.
   */
  get dateTime() {
    return this.getAttribute("datetime") || "";
  }
  /**
   * Sets date time.
   *
   * @param dateTime Date time.
   */
  set dateTime(e) {
    this.setAttribute("datetime", e);
  }
}
class jHe extends Ye {
  /**
   * Returns reversed.
   *
   * @returns Reversed.
   */
  get reversed() {
    return this.getAttribute("reversed") !== null;
  }
  /**
   * Sets reversed.
   *
   * @param reversed Reversed.
   */
  set reversed(e) {
    e ? this.setAttribute("reversed", "") : this.removeAttribute("reversed");
  }
  /**
   * Returns start.
   *
   * @returns Start.
   */
  get start() {
    if (!this.hasAttribute("start"))
      return 1;
    const e = Number(this.getAttribute("start") || "");
    return isNaN(e) ? 1 : e;
  }
  /**
   * Sets start.
   *
   * @param start Start.
   */
  set start(e) {
    typeof e != "number" && (e = Number(e)), isNaN(e) && (e = 0), this.setAttribute("start", String(e));
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "";
  }
  /**
   * Sets type.
   *
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
}
class YHe extends Ye {
  /**
   * Returns label.
   *
   * @returns Label.
   */
  get label() {
    return this.getAttribute("label") || "";
  }
  /**
   * Sets label.
   *
   * @param label Label.
   */
  set label(e) {
    e ? this.setAttribute("label", e) : this.removeAttribute("label");
  }
  /**
   * Returns disabled.
   *
   * @returns Disabled.
   */
  get disabled() {
    return this.getAttribute("disabled") !== null;
  }
  /**
   * Sets disabled.
   *
   * @param disabled Disabled.
   */
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
}
class zy extends Ye {
  [Qi] = !1;
  [Nd] = !1;
  [zr] = null;
  /**
   * Returns inner text, which is the rendered appearance of text.
   *
   * @returns Inner text.
   */
  get text() {
    return this.innerText;
  }
  /**
   * Sets the inner text, which is the rendered appearance of text.
   *
   * @param innerText Inner text.
   */
  set text(e) {
    this.innerText = e;
  }
  /**
   * Returns index.
   *
   * @returns Index.
   */
  get index() {
    return this[zr] ? it.querySelectorAll(this[zr], "option")[Ge].indexOf(this) : 0;
  }
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    return this[zr]?.form || null;
  }
  /**
   * Returns selected.
   *
   * @returns Selected.
   */
  get selected() {
    return this[Qi];
  }
  /**
   * Sets selected.
   *
   * @param selected Selected.
   */
  set selected(e) {
    const n = this[zr];
    this[Nd] = !0, this[Qi] = !!e, n && n[Ad](this[Qi] ? this : null);
  }
  /**
   * Returns disabled.
   *
   * @returns Disabled.
   */
  get disabled() {
    return this.getAttribute("disabled") !== null;
  }
  /**
   * Sets disabled.
   *
   * @param disabled Disabled.
   */
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    return this.getAttribute("value") ?? this.textContent;
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    this.setAttribute("value", e);
  }
  /**
   * @override
   */
  [as](e, n) {
    if (super[as](e, n), !this[Nd] && e[tt] === "selected" && n?.[ze] !== e[ze]) {
      const r = this[zr];
      this[Qi] = !0, r && r[Ad](this);
    }
  }
  /**
   * @override
   */
  [qa](e) {
    if (super[qa](e), e && !this[Nd] && e[tt] === "selected") {
      const n = this[zr];
      this[Qi] = !1, n && n[Ad]();
    }
  }
  /**
   * @override
   */
  [ho]() {
    super[ho](), this[zr] && this[zr][Ad]();
  }
  /**
   * @override
   */
  [bh]() {
    this[zr] && this[zr][Ad](), super[bh]();
  }
}
class qHe extends Ye {
}
class JHe extends Ye {
}
class QHe extends Ye {
}
class XHe extends Ye {
}
class ZHe extends Ye {
  /**
   * Returns max.
   *
   * @returns Max.
   */
  get max() {
    if (!this.hasAttribute("max"))
      return 1;
    const e = parseFloat(this.getAttribute("max") || "");
    return isNaN(e) || e < 0 ? 1 : e;
  }
  /**
   * Sets max.
   *
   * @param max Max.
   */
  set max(e) {
    if (e = typeof e != "number" ? Number(e) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'max' property on 'HTMLProgressElement': The provided double value is non-finite.");
    this.setAttribute("max", e < 0 ? "1" : String(e));
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    if (!this.hasAttribute("value"))
      return 0;
    const e = parseFloat(this.getAttribute("value") || "");
    return isNaN(e) || e < 0 ? 0 : e;
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    if (e = typeof e != "number" ? Number(e) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'value' property on 'HTMLProgressElement': The provided double value is non-finite.");
    this.setAttribute("value", e < 0 ? "0" : String(e));
  }
  /**
   * Returns position.
   *
   * @returns Position.
   */
  get position() {
    return this.hasAttribute("value") ? this.value / this.max : -1;
  }
  /**
   * Returns the associated label elements.
   *
   * @returns Label elements.
   */
  get labels() {
    return Ph.getAssociatedLabelElements(this);
  }
}
class eUe extends Ye {
  /**
   * Returns source.
   *
   * @returns Source.
   */
  get cite() {
    if (!this.hasAttribute("cite"))
      return "";
    try {
      return new URL(this.getAttribute("cite"), this[he].location.href).href;
    } catch {
      return this.getAttribute("cite");
    }
  }
  /**
   * Sets source.
   *
   * @param cite Source.
   */
  set cite(e) {
    this.setAttribute("cite", e);
  }
}
const tUe = /import\s*\(([^)]+)\)/gm, nUe = /(\/)|(\(|\))|({|})|(\[|\])|(\${)|(`)|(')|(")|(\n)/gm, rUe = /['"`(){}\s;=><\[\]+-,:&]/, iUe = /['"`({};=><\[+-,:&]/;
class rM {
  window;
  count = {
    comment: 0,
    singleLineComment: 0,
    parentheses: 0,
    curlyBraces: 0,
    squareBrackets: 0,
    regExp: 0,
    regExpSquareBrackets: 0,
    escapeTemplateString: 0,
    simpleString: 0,
    doubleString: 0
  };
  templateString = [];
  /**
   * Constructor.
   *
   * @param window Window.
   * @param url Module URL.
   */
  constructor(e) {
    this.window = e;
  }
  /**
   * Compiles code.
   *
   * @param sourceURL Source URL.
   * @param code Code.
   * @returns Result.
   */
  compile(e, n) {
    const r = new pt(this.window).getSettings();
    if (!r)
      return { execute: () => {
      } };
    const i = new RegExp(tUe), s = this.count;
    let a = "(function anonymous($happy_dom) {", o = null, u, l, h = 0;
    for (!r.disableErrorCapturing && r.errorCapture === Rr.tryAndCatch && (a += "try {"); o = i.exec(n); )
      u = n[o.index - 1] || " ", l = n.substring(h, o.index), this.parseSyntax(l, h), a += l, o[1] && s.simpleString === 0 && s.doubleString === 0 && s.comment === 0 && s.singleLineComment === 0 && s.regExp === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && rUe.test(u) ? a += `$happy_dom.dynamicImport(${o[1]})` : (a += o[0], this.parseSyntax(o[0], o.index)), h = i.lastIndex;
    h === 0 ? a += n : a += n.substring(h), !r.disableErrorCapturing && r.errorCapture === Rr.tryAndCatch && (a += "} catch (error) { $happy_dom.dispatchError(error); }"), a += "})";
    try {
      return {
        execute: this.window[wf](a, {
          filename: e
        })
      };
    } catch (f) {
      if (f.message = `Failed to parse JavaScript in '${e}': ${f.message}`, r.disableErrorCapturing || r.errorCapture !== Rr.tryAndCatch)
        throw f;
      return this.window[tr](f), {
        execute: () => {
        }
      };
    }
  }
  /**
   * Parses syntax.
   *
   * @param code Code.
   * @param index Index.
   */
  parseSyntax(e, n) {
    const r = new RegExp(nUe), i = this.count;
    let s = null, a, o;
    for (; s = r.exec(e); )
      a = e[s.index - 1] || " ", o = a === "\\" && e[s.index - 2] !== "\\", s[1] ? i.simpleString === 0 && i.doubleString === 0 && i.singleLineComment === 0 && i.regExpSquareBrackets === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && (i.comment === 1 ? a === "*" && (i.comment = 0) : i.regExp === 0 ? e[s.index + 1] === "*" ? i.comment = 1 : e[s.index + 1] === "/" ? i.singleLineComment = 1 : iUe.test(this.getNonSpacePrecedingToken(e, s.index)) && (i.regExp = 1) : o || (i.regExp = 0)) : s[2] ? i.simpleString === 0 && i.doubleString === 0 && i.regExp === 0 && i.comment === 0 && i.singleLineComment === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && (s[2] === "(" ? i.parentheses++ : s[2] === ")" && i.parentheses > 0 && i.parentheses--) : s[3] ? i.simpleString === 0 && i.doubleString === 0 && i.regExp === 0 && i.comment === 0 && i.singleLineComment === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && (s[3] === "{" ? (this.templateString.length && this.templateString[0]++, i.curlyBraces++) : s[3] === "}" && (this.templateString.length && this.templateString[0] > 0 && this.templateString[0]--, i.curlyBraces > 0 && i.curlyBraces--)) : s[4] ? i.simpleString === 0 && i.doubleString === 0 && i.comment === 0 && i.singleLineComment === 0 && (this.templateString.length === 0 || this.templateString[0] > 0) && (i.regExp === 1 ? o || (s[4] === "[" && i.regExpSquareBrackets === 0 ? i.regExpSquareBrackets = 1 : s[4] === "]" && i.regExpSquareBrackets === 1 && (i.regExpSquareBrackets = 0)) : s[4] === "[" ? i.squareBrackets++ : s[4] === "]" && i.squareBrackets > 0 && i.squareBrackets--) : s[5] ? i.simpleString === 0 && i.doubleString === 0 && i.comment === 0 && i.singleLineComment === 0 && i.regExp === 0 && !o && this.templateString[0] === 0 && (this.templateString[0] = 1, i.curlyBraces++) : s[6] ? i.simpleString === 0 && i.doubleString === 0 && i.comment === 0 && i.singleLineComment === 0 && i.regExp === 0 && !o && (this.templateString?.[0] === 0 ? this.templateString.shift() : this.templateString.unshift(0)) : s[7] ? i.doubleString === 0 && i.comment === 0 && i.singleLineComment === 0 && i.regExp === 0 && !o && (this.templateString.length === 0 || this.templateString[0] > 0) && (i.simpleString === 0 ? i.simpleString = 1 : i.simpleString = 0) : s[8] ? i.simpleString === 0 && i.comment === 0 && i.singleLineComment === 0 && i.regExp === 0 && !o && (this.templateString.length === 0 || this.templateString[0] > 0) && (i.doubleString === 0 ? i.doubleString = 1 : i.doubleString = 0) : s[9] && (i.singleLineComment = 0);
  }
  /**
   * Get the non-space preceding token.
   *
   * @param code Code.
   * @param index Index.
   * @returns Non-space preceding token.
   */
  getNonSpacePrecedingToken(e, n) {
    n--;
    let r = e[n];
    for (; r === " " || r === `
` || r === "	"; )
      n--, r = e[n];
    return r || ";";
  }
}
class sUe extends Ye {
  // Internal properties
  [Tf] = !1;
  [gy] = null;
  // Private properties
  #e = null;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onerror() {
    return K.getEventListener(this, "onerror");
  }
  set onerror(e) {
    this[F].set("onerror", e);
  }
  get onload() {
    return K.getEventListener(this, "onload");
  }
  set onload(e) {
    this[F].set("onload", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "";
  }
  /**
   * Sets type.
   *
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
  /**
   * Returns blocking.
   */
  get blocking() {
    return this[gy] || (this[gy] = new Zu(T, this, "blocking")), this[gy];
  }
  /**
   * Sets blocking.
   *
   * @param value Value.
   */
  set blocking(e) {
    this.setAttribute("blocking", e);
  }
  /**
   * Returns crossOrigin.
   *
   * @returns CrossOrigin.
   */
  get crossOrigin() {
    return this.getAttribute("crossorigin") || "";
  }
  /**
   * Sets crossOrigin.
   *
   * @param crossOrigin CrossOrigin.
   */
  set crossOrigin(e) {
    this.setAttribute("crossorigin", e);
  }
  /**
   * Returns fetch priority.
   *
   * @returns Fetch priority.
   */
  get fetchPriority() {
    const e = this.getAttribute("fetchpriority");
    switch (e) {
      case "high":
      case "low":
      case "normal":
        return e;
      default:
        return "auto";
    }
  }
  /**
   * Sets fetch priority.
   *
   * @param fetchPriority Fetch priority.
   */
  set fetchPriority(e) {
    this.setAttribute("fetchpriority", e);
  }
  /**
   * Returns noModule.
   *
   * @returns NoModule.
   */
  get noModule() {
    return this.getAttribute("nomodule") !== null;
  }
  /**
   * Sets noModule.
   *
   * @param noModule NoModule.
   */
  set noModule(e) {
    e ? this.setAttribute("nomodule", "") : this.removeAttribute("nomodule");
  }
  /**
   * Returns integrity.
   *
   * @returns Integrity.
   */
  get integrity() {
    return this.getAttribute("integrity") || "";
  }
  /**
   * Sets integrity.
   *
   * @param integrity Integrity.
   */
  set integrity(e) {
    this.setAttribute("integrity", e);
  }
  /**
   * Returns referrerPolicy.
   *
   * @returns ReferrerPolicy.
   */
  get referrerPolicy() {
    const e = this.getAttribute("referrerpolicy");
    switch (e) {
      case "no-referrer":
      case "no-referrer-when-downgrade":
      case "same-origin":
      case "origin":
      case "strict-origin":
      case "origin-when-cross-origin":
      case "strict-origin-when-cross-origin":
      case "unsafe-url":
        return e;
      default:
        return "";
    }
  }
  /**
   * Sets referrerPolicy.
   *
   * @param referrerPolicy ReferrerPolicy.
   */
  set referrerPolicy(e) {
    this.setAttribute("referrerpolicy", e);
  }
  /**
   * Returns source.
   *
   * @returns Source.
   */
  get src() {
    if (!this.hasAttribute("src"))
      return "";
    try {
      return new URL(this.getAttribute("src"), this[he].location.href).href;
    } catch {
      return this.getAttribute("src");
    }
  }
  /**
   * Sets source.
   *
   * @param src Source.
   */
  set src(e) {
    this.setAttribute("src", e);
  }
  /**
   * Returns charset.
   *
   * @returns Charset.
   */
  get charset() {
    return this.getAttribute("charset") || "";
  }
  /**
   * Sets charset.
   *
   * @param charset Charset.
   */
  set charset(e) {
    this.setAttribute("charset", e);
  }
  /**
   * Returns lang.
   *
   * @returns Lang.
   */
  get lang() {
    return this.getAttribute("lang") || "";
  }
  /**
   * Sets lang.
   *
   * @param lang Lang.
   */
  set lang(e) {
    this.setAttribute("lang", e);
  }
  /**
   * Returns async.
   *
   * @returns Async.
   */
  get async() {
    return this.getAttribute("async") !== null;
  }
  /**
   * Sets async.
   *
   * @param async Async.
   */
  set async(e) {
    e ? this.setAttribute("async", "") : this.removeAttribute("async");
  }
  /**
   * Returns defer.
   *
   * @returns Defer.
   */
  get defer() {
    return this.getAttribute("defer") !== null;
  }
  /**
   * Sets defer.
   *
   * @param defer Defer.
   */
  set defer(e) {
    e ? this.setAttribute("defer", "") : this.removeAttribute("defer");
  }
  /**
   * Returns text.
   *
   * @returns Text.
   */
  get text() {
    return this.textContent;
  }
  /**
   * Sets text.
   *
   * @param text Text.
   */
  set text(e) {
    this.textContent = e;
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
  /**
   * @override
   */
  [Hs]() {
    const e = new pt(this[b]).getSettings();
    if (super[Hs](), this[Tf])
      return;
    const n = this.getAttribute("src");
    if (n !== null)
      this.getAttribute("type") === "module" ? this.#i(n) : this.#s(n);
    else if (e && e.enableJavaScriptEvaluation) {
      const r = this.textContent, i = this.getAttribute("type");
      r && (i === "module" ? this.#t(r) : i === "importmap" ? this.#n(r) : (i === null || i === "application/x-ecmascript" || i === "application/x-javascript" || i.startsWith("text/javascript")) && this.#r(r));
    }
  }
  /**
   * @override
   */
  [as](e, n) {
    super[as](e, n), e[tt] === "src" && e[ze] !== null && this[st] && (this.getAttribute("type") === "module" ? this.#i(e[ze]) : this.#s(e[ze]));
  }
  /**
   * Evaluates a module.
   *
   * @param source Source.
   */
  #t(e) {
    const n = this[he].location, r = this[b], i = new pt(r).getSettings();
    if (!new pt(r).getBrowserFrame() || !i || !i.enableJavaScriptEvaluation)
      return;
    this[he][eu] = this;
    const a = new yp({ window: r, url: n, source: e });
    i.disableErrorCapturing || i.errorCapture !== Rr.tryAndCatch ? a.evaluate() : a.evaluate().catch((o) => {
      r[tr](o);
    }), this[he][eu] = null, this.dispatchEvent(new be("load"));
  }
  /**
   * Evaluates an import map.
   *
   * @param source Source.
   */
  async #n(e) {
    const n = this[b], r = new pt(n).getSettings();
    if (!new pt(n).getBrowserFrame() || !r || n[H1] || !r.enableJavaScriptEvaluation)
      return;
    let s;
    if (r.disableErrorCapturing || r.errorCapture !== Rr.tryAndCatch)
      s = JSON.parse(e);
    else
      try {
        s = JSON.parse(e);
      } catch (a) {
        n[tr](a);
        return;
      }
    if (s.imports || s.scopes) {
      const a = {
        imports: [],
        scopes: []
      };
      if (s.imports)
        for (const o of Object.keys(s.imports))
          a.imports.push({
            from: o,
            to: s.imports[o]
          });
      if (s.scopes)
        for (const o of Object.keys(s.scopes)) {
          const u = {
            scope: o,
            rules: []
          };
          for (const l of Object.keys(s.scopes[o])) {
            const h = s.scopes[o][l];
            u.rules.push({
              from: l,
              to: h
            });
          }
          a.scopes.push(u);
        }
      n[H1] = a;
    }
  }
  /**
   * Evaluates a script.
   *
   * @param code Code.
   */
  #r(e) {
    const n = this[b];
    if (!new pt(n).getSettings())
      return;
    this[he][eu] = this;
    const s = new rM(n).compile(n.location.href, e), a = new Eh(n, n.location);
    s.execute({
      dynamicImport: a.importModule.bind(a),
      dispatchError: n[tr].bind(n)
    }), this[he][eu] = null;
  }
  /**
   * Loads a module.
   *
   * @param url URL.
   */
  async #i(e) {
    const n = this[b], r = new pt(n).getBrowserFrame(), i = new pt(n).getSettings();
    if (!r || !i || !e || !this[st] || this.getAttribute("type") !== "module")
      return;
    if (i && (i.disableJavaScriptFileLoading || !i.enableJavaScriptEvaluation)) {
      if (i.handleDisabledFileLoadingAsSuccess)
        this.dispatchEvent(new be("load"));
      else {
        const a = new n.DOMException(`Failed to load module "${e}". JavaScript file loading is disabled.`, ne.notSupportedError);
        r.page.console.error(a), this.dispatchEvent(new be("error"));
      }
      return;
    }
    const s = new Eh(n, n.location);
    if (i.disableErrorCapturing || i.errorCapture !== Rr.tryAndCatch)
      await (await s.getModule(e)).evaluate();
    else
      try {
        await (await s.getModule(e)).evaluate();
      } catch (a) {
        r.page.console.error(a), this.dispatchEvent(new be("error"));
        return;
      }
    this.dispatchEvent(new be("load"));
  }
  /**
   * Returns a URL relative to the given Location object.
   *
   * @param url URL.
   */
  async #s(e) {
    const n = this[b], r = new pt(n).getBrowserFrame();
    if (!r)
      return;
    const i = r.page.context.browser.settings, s = this.getAttribute("type");
    if (!e || !this[st] || s !== null && s !== "application/x-ecmascript" && s !== "application/x-javascript" && !s.startsWith("text/javascript"))
      return;
    let a;
    try {
      a = new URL(e, n.location.href);
    } catch {
      return;
    }
    const o = a.toString();
    if (this.#e === o)
      return;
    if (i && (i.disableJavaScriptFileLoading || !i.enableJavaScriptEvaluation)) {
      if (i.handleDisabledFileLoadingAsSuccess)
        this.dispatchEvent(new be("load"));
      else {
        const A = new n.DOMException(`Failed to load script "${a}". JavaScript file loading is disabled.`, ne.notSupportedError);
        r.page.console.error(A), this.dispatchEvent(new be("error"));
      }
      return;
    }
    this.#e = o;
    const u = new z2(n), l = this.getAttribute("async") !== null || this.getAttribute("defer") !== null;
    let h = null;
    if (l) {
      const A = n[Uu], E = A.startTask();
      try {
        h = await u.fetch(o, "script", {
          credentials: this.crossOrigin === "use-credentials" ? "include" : "same-origin",
          referrerPolicy: this.referrerPolicy
        });
      } catch (w) {
        r.page.console.error(w), this.dispatchEvent(new be("error")), A.endTask(E);
        return;
      }
      A.endTask(E);
    } else
      try {
        h = u.fetchSync(o, "script", {
          credentials: this.crossOrigin === "use-credentials" ? "include" : "same-origin",
          referrerPolicy: this.referrerPolicy
        });
      } catch (A) {
        r.page.console.error(A), this.dispatchEvent(new be("error"));
        return;
      }
    this[he][eu] = this;
    const m = new rM(n).compile(h.virtualServerFile || o, h.content), g = new Eh(n, n.location);
    m.execute({
      dynamicImport: g.importModule.bind(g),
      dispatchError: n[tr].bind(n)
    }), this[he][eu] = null, this.dispatchEvent(new be("load"));
  }
  /**
   * Returns true if the given type is supported.
   *
   * @param type Type.
   * @returns True if the given type is supported.
   */
  static supports(e) {
    switch (e) {
      case "classic":
      case "module":
      case "importmap":
        return !0;
      default:
        return !1;
    }
  }
}
class xW extends mi {
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param ownerElement Select element.
   */
  constructor(e, n) {
    super(e, () => it.querySelectorAll(n, "option")[Ge]), this[zt] = n;
  }
  /**
   * Returns selectedIndex.
   *
   * @returns SelectedIndex.
   */
  get selectedIndex() {
    return this[zt].selectedIndex;
  }
  /**
   * Sets selectedIndex.
   *
   * @param selectedIndex SelectedIndex.
   */
  set selectedIndex(e) {
    this[zt].selectedIndex = e;
  }
  /**
   *
   * @param element
   * @param before
   */
  add(e, n) {
    this[zt].add(e, n);
  }
  /**
   * Removes indexed element from collection.
   *
   * @param index Index.
   */
  remove(e) {
    this[zt].remove(e);
  }
}
class Y2 extends Ye {
  // Internal properties.
  [fi] = "";
  [rs] = new Lh(this);
  [Wl] = null;
  [jc] = null;
  [Ea] = -1;
  [yn];
  /**
   * Constructor.
   */
  constructor() {
    super();
    const e = new Ws(this, [
      Y2,
      Ye,
      Sc,
      ot,
      Xr
    ]), n = new Proxy(this, {
      get: (r, i) => {
        if (i in r || typeof i == "symbol")
          return e.bind(i), r[i];
        const s = Number(i);
        if (!isNaN(s))
          return it.querySelectorAll(r, "option")[Ge][s];
      },
      set(r, i, s) {
        if (e.bind(i), typeof i == "symbol")
          return r[i] = s, !0;
        const a = Number(i);
        if (isNaN(a))
          return r[i] = s, !0;
        if (!s || !(s instanceof zy))
          throw new r[b].Error(`TypeError: Failed to set an indexed property [${a}] on 'HTMLSelectElement': parameter 2 is not of type 'HTMLOptionElement'.`);
        const o = it.querySelectorAll(r, "option")[Ge], u = r[Re];
        for (; u.length; )
          r[Ms](u[0]);
        for (let l = 0; l <= a; l++)
          l === a ? r[Ht](s) : o[l] ? r[Ht](o[l]) : r[Ht](r[he].createElement("option"));
        return !0;
      },
      deleteProperty(r, i) {
        if (typeof i == "symbol")
          return delete r[i], !0;
        const s = Number(i);
        return isNaN(s) && delete r[i], !0;
      },
      ownKeys(r) {
        return Object.keys(it.querySelectorAll(r, "option")[Ge]);
      },
      has(r, i) {
        if (i in r)
          return !0;
        if (typeof i == "symbol")
          return !1;
        const s = Number(i);
        return isNaN(s) ? !1 : !!it.querySelectorAll(r, "option")[Ge][s];
      },
      defineProperty(r, i, s) {
        e.preventBinding(i);
        const a = Number(i);
        if (isNaN(a))
          return Object.defineProperty(r, i, s), !0;
        if (!s.value || !(s.value instanceof zy))
          throw new r[b].Error(`TypeError: Failed to set an indexed property [${a}] on 'HTMLSelectElement': parameter 2 is not of type 'HTMLOptionElement'.`);
        const o = it.querySelectorAll(r, "option")[Ge], u = r[Re];
        for (; u.length; )
          r[Ms](u[0]);
        for (let l = 0; l <= a; l++)
          l === a ? r[Ht](s.value) : o[l] ? r[Ht](o[l]) : r[Ht](r[he].createElement("option"));
        return !0;
      },
      getOwnPropertyDescriptor(r, i) {
        if (i in r)
          return Object.getOwnPropertyDescriptor(r, i);
        const s = Number(i);
        if (isNaN(s))
          return;
        const a = it.querySelectorAll(r, "option")[Ge];
        if (a[s])
          return {
            value: a[s],
            writable: !0,
            enumerable: !0,
            configurable: !0
          };
      }
    });
    return this[yn] = n, this[zr] = n, n;
  }
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onchange() {
    return K.getEventListener(this, "onchange");
  }
  set onchange(e) {
    this[F].set("onchange", e);
  }
  get oninput() {
    return K.getEventListener(this, "oninput");
  }
  set oninput(e) {
    this[F].set("oninput", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return it.querySelectorAll(this, "option")[Ge].length;
  }
  /**
   * Returns options.
   *
   * @returns Options.
   */
  get options() {
    return this[Wl] || (this[Wl] = new xW(T, this)), this[Wl];
  }
  /**
   * Returns validation message.
   *
   * @returns Validation message.
   */
  get validationMessage() {
    return this[fi];
  }
  /**
   * Returns validity.
   *
   * @returns Validity.
   */
  get validity() {
    return this[rs];
  }
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Returns disabled.
   *
   * @returns Disabled.
   */
  get disabled() {
    return this.getAttribute("disabled") !== null;
  }
  /**
   * Sets disabled.
   *
   * @param disabled Disabled.
   */
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  /**
   * Returns multiple.
   *
   * @returns Multiple.
   */
  get multiple() {
    return this.getAttribute("multiple") !== null;
  }
  /**
   * Sets multiple.
   *
   * @param multiple Multiple.
   */
  set multiple(e) {
    e ? this.setAttribute("multiple", "") : this.removeAttribute("multiple");
  }
  /**
   * Returns autofocus.
   *
   * @returns Autofocus.
   */
  get autofocus() {
    return this.getAttribute("autofocus") !== null;
  }
  /**
   * Sets autofocus.
   *
   * @param autofocus Autofocus.
   */
  set autofocus(e) {
    e ? this.setAttribute("autofocus", "") : this.removeAttribute("autofocus");
  }
  /**
   * Returns required.
   *
   * @returns Required.
   */
  get required() {
    return this.getAttribute("required") !== null;
  }
  /**
   * Sets required.
   *
   * @param required Required.
   */
  set required(e) {
    e ? this.setAttribute("required", "") : this.removeAttribute("required");
  }
  /**
   * Returns type.
   *
   * @returns type.
   */
  get type() {
    return this.hasAttributeNS(null, "multiple") ? "select-multiple" : "select-one";
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    const e = it.querySelectorAll(this, "option")[Ge];
    for (let n = 0, r = e.length; n < r; n++) {
      const i = e[n];
      if (i[Qi])
        return i.value;
    }
    return "";
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    const n = it.querySelectorAll(this, "option")[Ge];
    this[Ea] = -1;
    for (let r = 0, i = n.length; r < i; r++) {
      const s = n[r];
      s.value === e ? (s[Qi] = !0, s[Nd] = !0, this[Ea] = r) : s[Qi] = !1;
    }
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get selectedIndex() {
    return this[Ea];
  }
  /**
   * Sets value.
   *
   * @param selectedIndex Selected index.
   */
  set selectedIndex(e) {
    if (e = Number(e), isNaN(e))
      return;
    const n = it.querySelectorAll(this, "option")[Ge];
    if (this[Ea] = -1, typeof e == "number" && !isNaN(e)) {
      for (let i = 0, s = n.length; i < s; i++)
        n[i][Qi] = !1;
      const r = n[e];
      r && (r[Qi] = !0, r[Nd] = !0, this[Ea] = e);
    }
  }
  /**
   * Returns selected options.
   *
   * @returns HTMLCollection.
   */
  get selectedOptions() {
    return this[jc] || (this[jc] = new mi(T, () => {
      const e = it.querySelectorAll(this, "option")[Ge];
      if (e[jc])
        return e[jc];
      const n = [];
      for (let r = 0, i = e.length; r < i; r++) {
        const s = e[r];
        s[Qi] && n.push(s);
      }
      return e[jc] = n, n;
    })), this[jc];
  }
  /**
   * Returns the associated label elements.
   *
   * @returns Label elements.
   */
  get labels() {
    return Ph.getAssociatedLabelElements(this);
  }
  /**
   * Returns the parent form element.
   *
   * @returns Form.
   */
  get form() {
    if (this[Cn])
      return this[Cn];
    const e = this.getAttribute("form");
    return !e || !this[st] ? null : this[he].getElementById(e);
  }
  /**
   * Returns "true" if it will validate.
   *
   * @returns "true" if it will validate.
   */
  get willValidate() {
    return this.type !== "hidden" && this.type !== "reset" && this.type !== "button" && !this.disabled;
  }
  /**
   * @override
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    if (e !== null) {
      const n = Number(e);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }
  /**
   * @override
   */
  set tabIndex(e) {
    super.tabIndex = e;
  }
  /**
   * Returns item from options collection by index.
   *
   * @param index Index.
   */
  item(e) {
    return this.options.item(e);
  }
  /**
   * Adds new option to options collection.
   *
   * @param element HTMLOptionElement to add.
   * @param before HTMLOptionElement or index number.
   */
  add(e, n) {
    const r = it.querySelectorAll(this, "option")[Ge];
    if (!n && n !== 0) {
      const o = this[Re];
      for (; o.length; )
        this[Ms](o[0]);
      for (const u of r)
        this[Ht](u);
      this[Ht](e);
      return;
    }
    const i = this[b];
    if (typeof n != "number") {
      if (!(n instanceof zy))
        throw new i.DOMException("Failed to execute 'add' on 'HTMLFormElement': The node before which the new node is to be inserted before is not an 'HTMLOptionElement'.");
      n = r.indexOf(n);
    }
    if (!r[n])
      throw new i.DOMException("Failed to execute 'add' on 'HTMLFormElement': The node before which the new node is to be inserted before is not a child of this node.");
    const a = this[Re];
    for (; a.length; )
      this[Ms](a[0]);
    for (let o = 0, u = r.length; o < u; o++)
      o === n && this[Ht](e), this[Ht](r[o]);
  }
  /**
   * Removes indexed element from collection or the select element.
   *
   * @param [index] Index.
   */
  remove(e) {
    if (typeof e == "number") {
      const n = it.querySelectorAll(this, "option")[Ge];
      if (!n[e])
        return;
      const r = this[Re];
      for (; r.length; )
        this[Ms](r[0]);
      for (let i = 0, s = n.length; i < s; i++)
        i !== e && this[Ht](n[i]);
    } else
      super.remove();
  }
  /**
   * Sets validation message.
   *
   * @param message Message.
   */
  setCustomValidity(e) {
    this[fi] = String(e);
  }
  /**
   * Checks validity.
   *
   * @returns "true" if the field is valid.
   */
  checkValidity() {
    const e = this.disabled || this[rs].valid;
    return e || this.dispatchEvent(new be("invalid", { bubbles: !0, cancelable: !0 })), e;
  }
  /**
   * Reports validity.
   *
   * @returns "true" if the field is valid.
   */
  reportValidity() {
    return this.checkValidity();
  }
  /**
   * Updates option item.
   *
   * Based on:
   * https://github.com/jsdom/jsdom/blob/master/lib/jsdom/living/nodes/HTMLSelectElement-impl.js
   *
   * @see https://html.spec.whatwg.org/multipage/form-elements.html#selectedness-setting-algorithm
   * @param [selectedOption] Selected option.
   */
  [Ad](e) {
    const n = this.hasAttribute("multiple"), r = it.querySelectorAll(this, "option")[Ge], i = [];
    if (e && (this[Ea] = -1), !n)
      for (let a = 0, o = r.length; a < o; a++) {
        const u = r[a];
        e && (u[Qi] = u === e, u === e && (this[Ea] = a)), u[Qi] && i.push(u);
      }
    if (this.#e() === 1 && !i.length) {
      this[Ea] = -1;
      for (let a = 0, o = r.length; a < o; a++) {
        const u = r[a], l = u[xe];
        let h = u.hasAttributeNS(null, "disabled");
        if (l && l[ve] === le.elementNode && l[Xe] === "OPTGROUP" && l.hasAttributeNS(null, "disabled") && (h = !0), !h) {
          u[Qi] = !0, this[Ea] = a;
          break;
        }
      }
    } else if (i.length >= 2) {
      this[Ea] = -1;
      for (let a = 0, o = r.length; a < o; a++)
        r[a][Qi] = a === i.length - 1, a === i.length - 1 && (this[Ea] = a);
    }
  }
  /**
   * Returns display size.
   *
   * @returns Display size.
   */
  #e() {
    if (this.hasAttributeNS(null, "size")) {
      const e = parseInt(this.getAttribute("size"));
      if (!isNaN(e) && e >= 0)
        return e;
    }
    return this.hasAttributeNS(null, "multiple") ? 4 : 1;
  }
}
var cx;
class CW extends Ye {
  // Internal properties
  [Cl] = [];
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onslotchange() {
    return K.getEventListener(this, "onslotchange");
  }
  set onslotchange(e) {
    this[F].set("onslotchange", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns name.
   *
   * @returns Name.
   */
  get name() {
    return this.getAttribute("name") || "";
  }
  /**
   * Sets name.
   *
   * @param name Name.
   */
  set name(e) {
    this.setAttribute("name", e);
  }
  /**
   * Sets the slot's manually assigned nodes to an ordered set of slottables.
   *
   * @param nodes Nodes.
   */
  assign(...e) {
    const n = this.getRootNode();
    if (n?.[Kl] !== "manual")
      return;
    const r = n.host;
    if (r) {
      for (const i of e)
        if (i instanceof ot && r[Re].includes(i) && i[ve] !== le.commentNode) {
          if (i[nu]) {
            const s = i[nu][Cl].indexOf(i);
            s !== -1 && i[nu][Cl].splice(s, 1);
          }
          i[nu] = this, this[Cl].push(i);
        }
    }
  }
  /**
   * Returns assigned nodes.
   *
   * @param [options] Options.
   * @param [options.flatten] A boolean value indicating whether to return the assigned nodes of any available child <slot> elements (true) or not (false). Defaults to false.
   * @returns Nodes.
   */
  assignedNodes(e) {
    return this.#e(this.name, e);
  }
  /**
   * Returns assigned elements.
   *
   * @param [options] Options.
   * @param [options.flatten] A boolean value indicating whether to return the assigned elements of any available child <slot> elements (true) or not (false). Defaults to false.
   * @returns Nodes.
   */
  assignedElements(e) {
    return this.#t(this.name, e);
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
  /**
   * @override
   */
  [as](e, n) {
    if (super[as](e, n), e[tt] === "name" && e[ze] !== n?.[ze]) {
      const r = this.#e(n?.[ze]), i = this.#e(e.value);
      if (r.length !== i.length)
        this.dispatchEvent(new be("slotchange", { bubbles: !0 }));
      else
        for (let s = 0, a = i.length; s < a; s++)
          if (r[s] !== i[s]) {
            this.dispatchEvent(new be("slotchange", { bubbles: !0 }));
            break;
          }
    }
  }
  /**
   * @override
   */
  [qa](e) {
    super[qa](e), e[tt] === "name" && e[ze] && this.#e(e.value).length > 0 && this.dispatchEvent(new be("slotchange", { bubbles: !0 }));
  }
  /**
   * Returns assigned nodes.
   *
   * @param name Name.
   * @param [options] Options.
   * @param [options.flatten] A boolean value indicating whether to return the assigned nodes of any available child <slot> elements (true) or not (false). Defaults to false.
   * @returns Nodes.
   */
  #e(e, n) {
    const r = this.getRootNode();
    if (!r?.host)
      return [];
    if (r[Kl] === "manual")
      return this[Cl];
    const i = r.host, s = !!n?.flatten, a = [];
    for (const o of i[Re]) {
      const u = o.slot;
      if (e && u && u === e || !e && !u)
        if (s && o instanceof cx)
          for (const l of o.assignedNodes(n))
            a.push(l);
        else
          a.push(o);
    }
    return a;
  }
  /**
   * Returns assigned elements.
   *
   * @param name Name.
   * @param [options] Options.
   * @param [options.flatten] A boolean value indicating whether to return the assigned elements of any available child <slot> elements (true) or not (false). Defaults to false.
   * @returns Nodes.
   */
  #t(e, n) {
    const r = this.getRootNode();
    if (!r?.host)
      return [];
    if (r[Kl] === "manual") {
      const o = [];
      for (const u of this[Cl])
        u instanceof Sc && o.push(u);
      return o;
    }
    const i = r.host, s = !!n?.flatten, a = [];
    for (const o of i[Ft]) {
      const u = o.slot;
      if (e && u === e || !e && !u)
        if (s && o instanceof cx)
          for (const l of o.assignedElements(n))
            a.push(l);
        else
          a.push(o);
    }
    return a;
  }
}
cx = CW;
class aUe extends Ye {
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    const e = Number(this.getAttribute("height"));
    return isNaN(e) || e < 0 ? 0 : e;
  }
  /**
   * Sets height.
   *
   * @param value Height.
   */
  set height(e) {
    const n = Number(e);
    this.setAttribute("height", isNaN(n) || n < 0 ? "0" : String(n));
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    const e = Number(this.getAttribute("width"));
    return isNaN(e) || e < 0 ? 0 : e;
  }
  /**
   * Sets width.
   *
   * @param value Width.
   */
  set width(e) {
    const n = Number(e);
    this.setAttribute("width", isNaN(n) || n < 0 ? "0" : String(n));
  }
  /**
   * Returns media.
   *
   * @returns Media.
   */
  get media() {
    return this.getAttribute("media") || "";
  }
  /**
   * Sets media.
   *
   * @param value Media.
   */
  set media(e) {
    this.setAttribute("media", e);
  }
  /**
   * Returns sizes.
   *
   * @returns Sizes.
   */
  get sizes() {
    return this.getAttribute("sizes") || "";
  }
  /**
   * Sets sizes.
   *
   * @param value Sizes.
   */
  set sizes(e) {
    this.setAttribute("sizes", e);
  }
  /**
   * Returns source.
   *
   * @returns Source.
   */
  get src() {
    if (!this.hasAttribute("src"))
      return "";
    try {
      return new URL(this.getAttribute("src"), this[he].location.href).href;
    } catch {
      return this.getAttribute("src") || "";
    }
  }
  /**
   * Sets source.
   *
   * @param src Source.
   */
  set src(e) {
    this.setAttribute("src", e);
  }
  /**
   * Returns source set.
   *
   * @returns Source set.
   */
  get srcset() {
    return this.getAttribute("srcset") || "";
  }
  /**
   * Sets source set.
   *
   * @param value Source set.
   */
  set srcset(e) {
    this.setAttribute("srcset", e);
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "";
  }
  /**
   * Sets type.
   *
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
}
class oUe extends Ye {
}
class uUe extends Ye {
  [Yr] = null;
  [ys] = this;
  [Zd] = !1;
  /**
   * Returns media.
   *
   * @returns Media.
   */
  get media() {
    return this.getAttribute("media") || "";
  }
  /**
   * Sets media.
   *
   * @param media Media.
   */
  set media(e) {
    this.setAttribute("media", e);
  }
  /**
   * Returns type.
   *
   * @deprecated
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "";
  }
  /**
   * Sets type.
   *
   * @deprecated
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
  /**
   * Returns disabled.
   *
   * @returns Disabled.
   */
  get disabled() {
    return this[Zd];
  }
  /**
   * Sets disabled.
   *
   * @param disabled Disabled.
   */
  set disabled(e) {
    this[Zd] = !!e;
  }
  /**
   * Returns CSS style sheet.
   *
   * @returns CSS style sheet.
   */
  get sheet() {
    return this[st] ? (this[Yr] || (this[Yr] = new this[he][b].CSSStyleSheet(), this[Yr].replaceSync(this.textContent)), this[Yr]) : null;
  }
  /**
   * @override
   */
  [Bs]() {
    super[Bs](), this[Yr] = null;
  }
  /**
   * @override
   */
  [tn]() {
    super[tn](), this[Yr] = null;
  }
  /**
   * Updates the CSSStyleSheet with the text content.
   */
  [cg]() {
    this[Yr] && this[Yr].replaceSync(this.textContent);
  }
}
class kW extends Ye {
}
class lUe extends Ye {
  /**
   * Returns abbr.
   *
   * @returns Abbr.
   */
  get abbr() {
    return this.getAttribute("abbr") || "";
  }
  /**
   * Sets abbr.
   *
   * @param value Abbr.
   */
  set abbr(e) {
    this.setAttribute("abbr", e);
  }
  /**
   * A number representing the cell's position in the cells collection of the <tr> the cell is contained within. If the cell doesn't belong to a <tr>, it returns -1.
   *
   * @returns Cell index.
   */
  get cellIndex() {
    let e = this.parentNode;
    for (; e; ) {
      if (e[Xe] === "TR")
        return it.querySelectorAll(e, "td,th")[Ge].indexOf(this);
      e = e.parentNode;
    }
    return -1;
  }
  /**
   * Returns colspan.
   *
   * @returns Colspan.
   */
  get colSpan() {
    const e = Number(this.getAttribute("colspan"));
    return isNaN(e) || e < 1 ? 1 : e;
  }
  /**
   * Sets colspan.
   *
   * @param value Colspan.
   */
  set colSpan(e) {
    const n = Number(e);
    this.setAttribute("colspan", isNaN(n) || n < 1 ? "1" : String(n));
  }
  /**
   * Returns headers.
   *
   * @returns headers.
   */
  get headers() {
    return this.getAttribute("headers") || "";
  }
  /**
   * Sets headers.
   *
   * @param value headers.
   */
  set headers(e) {
    this.setAttribute("headers", String(e));
  }
  /**
   * Returns rowspan.
   *
   * @returns Rowspan.
   */
  get rowSpan() {
    const e = Number(this.getAttribute("rowspan"));
    return isNaN(e) || e < 1 ? 1 : e;
  }
  /**
   * Sets rowspan.
   *
   * @param value Rowspan.
   */
  set rowSpan(e) {
    const n = Number(e);
    this.setAttribute("rowspan", isNaN(n) || n < 1 ? "1" : String(n));
  }
  /**
   * Returns scope.
   *
   * @returns Scope.
   */
  get scope() {
    return this.getAttribute("scope") || "";
  }
  /**
   * Sets scope.
   *
   * @param value Scope.
   */
  set scope(e) {
    this.setAttribute("scope", e);
  }
}
class cUe extends Ye {
}
class X1 extends Ye {
  /**
   * Returns an HTMLTableRowElement representing a new row of the table. It inserts it in the rows collection immediately before the <tr> element at the given index position. If the index is -1, the new row is appended to the collection. If the index is smaller than -1 or greater than the number of rows in the collection, a DOMException with the value IndexSizeError is raised.
   *
   * @param [index] Index.
   * @returns Row.
   */
  insertRow(e = -1) {
    typeof e != "number" && (e = -1);
    const n = it.querySelectorAll(this, "tr")[Ge];
    if (e < -1)
      throw new this[b].DOMException(`Failed to execute 'insertRow' on 'HTMLTableSectionElement': The index provided (${e}) is less than -1.`, ne.indexSizeError);
    if (e > n.length)
      throw new this[b].DOMException(`Failed to execute 'insertRow' on 'HTMLTableSectionElement': The index provided (${e}) is greater than the number of rows (${n.length}).`, ne.indexSizeError);
    const r = this[he].createElement("tr");
    return e === -1 || e === n.length ? this.appendChild(r) : this.insertBefore(r, n[e]), r;
  }
  /**
   * Removes the row corresponding to the index given in parameter. If the index value is -1 the last row is removed; if it is smaller than -1 or greater than the amount of rows in the collection, a DOMException with the value IndexSizeError is raised.
   *
   * @param index Index.
   */
  deleteRow(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'deleteRow' on 'HTMLTableSectionElement': 1 argument required, but only 0 present.");
    if (typeof e != "number" && (e = -1), e < -1)
      throw new this[b].DOMException(`Failed to execute 'deleteRow' on 'HTMLTableSectionElement': The index provided (${e}) is less than -1.`, ne.indexSizeError);
    const n = it.querySelectorAll(this, "tr")[Ge];
    if (e >= n.length)
      throw new this[b].DOMException(`Failed to execute 'deleteRow' on 'HTMLTableSectionElement': The index provided (${e}) is greater than the number of rows in the table (${n.length}).`, ne.indexSizeError);
    e === -1 && (e = n.length - 1), n[e].remove();
  }
}
class hUe extends Ye {
  [tb] = null;
  [nb] = null;
  /**
   * Returns caption.
   *
   * @returns Caption.
   */
  get caption() {
    return it.querySelector(this, "caption");
  }
  /**
   * Sets caption.
   *
   * @param caption Caption.
   */
  set caption(e) {
    if (e) {
      if (!(e instanceof kW))
        throw new this[b].TypeError("Failed to set the 'caption' property on 'HTMLTableElement': Failed to convert value to 'HTMLTableCaptionElement'.");
      this.caption?.remove(), this.insertBefore(e, this.firstChild);
    } else
      this.caption?.remove();
  }
  /**
   * Returns table section element.
   *
   * @returns Table section element.
   */
  get tHead() {
    return it.querySelector(this, "thead");
  }
  /**
   * Sets table section element.
   *
   * @param tHead Table section element.
   */
  set tHead(e) {
    if (e) {
      if (!(e instanceof X1))
        throw new this[b].TypeError("Failed to set the 'tHead' property on 'HTMLTableElement': Failed to convert value to 'HTMLTableSectionElement'.");
      this.tHead?.remove();
      let n = !1;
      for (const r of this[Ft])
        if (r[Xe] !== "CAPTION" && r[Xe] !== "COLGROUP") {
          this.insertBefore(e, r), n = !0;
          break;
        }
      n || this.appendChild(e);
    } else
      this.tHead?.remove();
  }
  /**
   * Returns table section element.
   *
   * @returns Table section element.
   */
  get tFoot() {
    return it.querySelector(this, "tfoot");
  }
  /**
   * Sets table section element.
   *
   * @param tFoot Table section element.
   */
  set tFoot(e) {
    if (e) {
      if (!(e instanceof X1))
        throw new this[b].TypeError("Failed to set the 'tFoot' property on 'HTMLTableElement': Failed to convert value to 'HTMLTableSectionElement'.");
      this.tFoot?.remove();
      let n = !1;
      for (const r of this[Ft])
        if (r[Xe] !== "CAPTION" && r[Xe] !== "COLGROUP" && r[Xe] !== "THEAD") {
          this.insertBefore(e, r), n = !0;
          break;
        }
      n || this.appendChild(e);
    } else
      this.tFoot?.remove();
  }
  /**
   * Returns rows.
   *
   * @returns Rows.
   */
  get rows() {
    return this[tb] || (this[tb] = new mi(T, () => it.querySelectorAll(this, "tr")[Ge])), this[tb];
  }
  /**
   * Returns bodies.
   *
   * @returns Bodies.
   */
  get tBodies() {
    return this[nb] || (this[nb] = new mi(T, () => it.querySelectorAll(this, "tbody")[Ge])), this[nb];
  }
  /**
   * Returns an HTMLTableSectionElement representing the first <thead> that is a child of the element. If none is found, a new one is created and inserted in the tree immediately before the first element that is neither a <caption>, nor a <colgroup>, or as the last child if there is no such element.
   *
   * @returns Table section element.
   */
  createTHead() {
    const e = this.tHead;
    if (e)
      return e;
    const n = this[he].createElement("thead");
    return this.tHead = n, n;
  }
  /**
   * Removes the first <thead> that is a child of the element.
   */
  deleteTHead() {
    this.tHead = null;
  }
  /**
   * Returns an HTMLTableSectionElement representing the first <tfoot> that is a child of the element. If none is found, a new one is created and inserted in the tree as the last child.
   *
   * @returns Table section element.
   */
  createTFoot() {
    const e = this.tFoot;
    if (e)
      return e;
    const n = this[he].createElement("tfoot");
    return this.tFoot = n, n;
  }
  /**
   * Removes the first <tfoot> that is a child of the element.
   */
  deleteTFoot() {
    this.tFoot = null;
  }
  /**
   * Returns a HTMLTableSectionElement representing a new <tbody> that is a child of the element. It is inserted in the tree after the last element that is a <tbody>, or as the last child if there is no such element.
   *
   * @returns Table section element.
   */
  createTBody() {
    const e = it.querySelectorAll(this, "tbody")[Ge], n = this[he].createElement("tbody");
    if (e.length > 0) {
      const r = e[e.length - 1];
      return r.parentNode?.insertBefore(n, r.nextSibling), n;
    }
    return this.appendChild(n), n;
  }
  /**
   * Returns an HTMLTableCaptionElement representing the first <caption> that is a child of the element. If none is found, a new one is created and inserted in the tree as the first child of the <table> element.
   */
  createCaption() {
    const e = this.caption;
    if (e)
      return e;
    const n = this[he].createElement("caption");
    return this.caption = n, n;
  }
  /**
   * Removes the first <caption> that is a child of the element.
   */
  deleteCaption() {
    this.caption = null;
  }
  /**
   * Returns an HTMLTableRowElement representing a new row of the table. It inserts it in the rows collection immediately before the <tr> element at the given index position. If necessary a <tbody> is created. If the index is -1, the new row is appended to the collection. If the index is smaller than -1 or greater than the number of rows in the collection, a DOMException with the value IndexSizeError is raised.
   *
   * @param [index] Index.
   * @returns Row.
   */
  insertRow(e = -1) {
    typeof e != "number" && (e = -1);
    const n = it.querySelectorAll(this, "tr")[Ge];
    if (e < -1)
      throw new this[b].DOMException(`Failed to execute 'insertRow' on 'HTMLTableElement': The index provided (${e}) is less than -1.`, ne.indexSizeError);
    if (e > n.length)
      throw new this[b].DOMException(`Failed to execute 'insertRow' on 'HTMLTableElement': The index provided (${e}) is greater than the number of rows (${n.length}).`, ne.indexSizeError);
    const r = this[he].createElement("tr");
    if (e === -1 || e === n.length) {
      const i = it.querySelector(this, "tbody");
      if (i)
        i.appendChild(r);
      else {
        const s = this[he].createElement("tbody");
        s.appendChild(r), this.appendChild(s);
      }
      return r;
    }
    return n[e].parentNode?.insertBefore(r, n[e]), r;
  }
  /**
   * Removes the row corresponding to the index given in parameter. If the index value is -1 the last row is removed; if it is smaller than -1 or greater than the amount of rows in the collection, a DOMException with the value IndexSizeError is raised.
   *
   * @param index Index.
   */
  deleteRow(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'deleteRow' on 'HTMLTableElement': 1 argument required, but only 0 present.");
    if (typeof e != "number" && (e = -1), e < -1)
      throw new this[b].DOMException(`Failed to execute 'deleteRow' on 'HTMLTableElement': The index provided (${e}) is less than -1.`, ne.indexSizeError);
    const n = it.querySelectorAll(this, "tr")[Ge];
    if (e >= n.length)
      throw new this[b].DOMException(`Failed to execute 'deleteRow' on 'HTMLTableElement': The index provided (${e}) is greater than the number of rows in the table (${n.length}).`, ne.indexSizeError);
    e === -1 && (e = n.length - 1), n[e].remove();
  }
}
class dUe extends Ye {
  [eb] = null;
  /**
   * Returns cells.
   *
   * @returns Cells.
   */
  get cells() {
    return this[eb] || (this[eb] = new mi(T, () => it.querySelectorAll(this, "td,th")[Ge])), this[eb];
  }
  /**
   * Returns a number that gives the logical position of the row within the entire table. If the row is not part of a table, returns -1.
   *
   * @returns Row index.
   */
  get rowIndex() {
    let e = this.parentNode;
    for (; e; ) {
      if (e[Xe] === "TABLE")
        return it.querySelectorAll(e, "tr")[Ge].indexOf(this);
      e = e.parentNode;
    }
    return -1;
  }
  /**
   * Returns a number that gives the logical position of the row within the table section it belongs to. If the row is not part of a section, returns -1.
   */
  get sectionRowIndex() {
    let e = this.parentNode;
    for (; e; ) {
      if (e instanceof X1)
        return it.querySelectorAll(e, "tr")[Ge].indexOf(this);
      e = e.parentNode;
    }
    return -1;
  }
  /**
   * Returns an HTMLTableCellElement representing a new cell of the row. The cell is inserted in the collection of cells immediately before the given index position in the row. If index is -1, the new cell is appended to the collection. If index is less than -1 or greater than the number of cells in the collection, a DOMException with the value IndexSizeError is raised.
   *
   * @param [index] Index.
   * @returns Cell.
   */
  insertCell(e = -1) {
    typeof e != "number" && (e = -1);
    const n = it.querySelectorAll(this, "td,th")[Ge];
    if (e < -1)
      throw new this[b].DOMException(`Failed to execute 'insertCell' on 'HTMLTableRowElement': The index provided (${e}) is less than -1.`, ne.indexSizeError);
    if (e > n.length)
      throw new this[b].DOMException(`Failed to execute 'insertCell' on 'HTMLTableRowElement': The index provided (${e}) is greater than the number of cells (${n.length}).`, ne.indexSizeError);
    const r = this[he].createElement("td");
    return e === -1 || e === n.length ? (this.appendChild(r), r) : (n[e].parentNode?.insertBefore(r, n[e]), r);
  }
  /**
   * Removes the cell corresponding to index. If index is -1, the last cell of the row is removed. If index is less than -1 or greater than the amount of cells in the collection, a DOMException with the value IndexSizeError is raised.
   *
   * @param index Index.
   */
  deleteCell(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'deleteCell' on 'HTMLTableRowElement': 1 argument required, but only 0 present.");
    if (typeof e != "number" && (e = -1), e < -1)
      throw new this[b].DOMException(`Failed to execute 'deleteCell' on 'HTMLTableRowElement': The index provided (${e}) is less than -1.`, ne.indexSizeError);
    const n = it.querySelectorAll(this, "td,th")[Ge];
    if (e >= n.length)
      throw new this[b].DOMException(`Failed to execute 'deleteCell' on 'HTMLTableRowElement': The index provided (${e}) is greater than the number of cells in the row (${n.length}).`, ne.indexSizeError);
    e === -1 && (e = n.length - 1), n[e].remove();
  }
}
class fUe extends Ye {
  // Internal properties
  [xs] = this[he].createDocumentFragment();
  /**
   * Returns content.
   *
   * @returns Content.
   */
  get content() {
    return this[xs];
  }
  /**
   * @override
   */
  get innerHTML() {
    return this.getHTML();
  }
  /**
   * @override
   */
  set innerHTML(e) {
    const n = this[xs], r = n[Re];
    for (; r.length; )
      n.removeChild(r[0]);
    new hu(this[b], { isTemplateDocumentFragment: !0 }).parse(e, this[xs]);
  }
  /**
   * @override
   */
  get firstChild() {
    return this[xs].firstChild;
  }
  /**
   * @override
   */
  get lastChild() {
    return this[xs].lastChild;
  }
  /**
   * @deprecated
   * @override
   */
  getInnerHTML(e) {
    const n = new sf(), r = this[xs];
    let i = "";
    for (const s of r[Re])
      i += n.serializeToString(s);
    return i;
  }
  /**
   * @override
   */
  getHTML(e) {
    const n = new sf(), r = this[xs];
    let i = "";
    for (const s of r[Re])
      i += n.serializeToString(s);
    return i;
  }
  /**
   * @override
   */
  [Ht](e, n = !1) {
    return this[xs][Ht](e, n);
  }
  /**
   * @override
   */
  [Ms](e) {
    return this[xs][Ms](e);
  }
  /**
   * @override
   */
  [ja](e, n, r = !1) {
    return this[xs][ja](e, n, r);
  }
  /**
   * @override
   */
  [O1](e, n) {
    return this[xs][O1](e, n);
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    const n = super[Bt](e);
    return n[xs] = this[xs].cloneNode(e), n;
  }
}
class mUe extends Ye {
  /**
   * Returns dateTime.
   *
   * @returns dateTime.
   */
  get dateTime() {
    return this.getAttribute("dateTime") || "";
  }
  /**
   * Sets dateTime.
   *
   * @param dateTime dateTime.
   */
  set dateTime(e) {
    this.setAttribute("dateTime", e);
  }
}
class gUe extends Ye {
  /**
   * Returns text.
   *
   * @returns Text.
   */
  get text() {
    let e = "";
    for (const n of this[Re])
      n[ve] === le.textNode && (e += n.textContent);
    return e;
  }
  /**
   * Sets text.
   *
   * @param text Text.
   */
  set text(e) {
    this.textContent = e;
  }
  /**
   * @override
   */
  get innerHTML() {
    return this.getHTML();
  }
  /**
   * @override
   */
  set innerHTML(e) {
    this.textContent = e;
  }
}
class pUe extends Ye {
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get oncuechange() {
    return K.getEventListener(this, "oncuechange");
  }
  set oncuechange(e) {
    this[F].set("oncuechange", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns kind.
   *
   * @returns Kind.
   */
  get kind() {
    const e = this.getAttribute("kind");
    return e === null ? ih.subtitles : ih[e] ? e : ih.metadata;
  }
  /**
   * Sets kind.
   *
   * @param value Value.
   */
  set kind(e) {
    ih[e] || (e = ih.metadata), this.setAttribute("kind", e);
  }
  /**
   * Returns source.
   *
   * @returns Source.
   */
  get src() {
    if (!this.hasAttribute("src"))
      return "";
    try {
      return new URL(this.getAttribute("src"), this[he].location.href).href;
    } catch {
      return this.getAttribute("src") || "";
    }
  }
  /**
   * Sets source.
   *
   * @param src Source.
   */
  set src(e) {
    this.setAttribute("src", e);
  }
  /**
   * Returns source language.
   *
   * @returns Source language.
   */
  get srclang() {
    return this.getAttribute("srclang") || "";
  }
  /**
   * Sets source language.
   *
   * @param value Value.
   */
  set srclang(e) {
    this.setAttribute("srclang", e);
  }
  /**
   * Returns label.
   *
   * @returns Label.
   */
  get label() {
    return this.getAttribute("label") || "";
  }
  /**
   * Sets label.
   *
   * @param value Value.
   */
  set label(e) {
    this.setAttribute("label", e);
  }
  /**
   * Returns default.
   *
   * @returns Default.
   */
  get default() {
    return this.hasAttribute("default");
  }
  /**
   * Sets default.
   *
   * @param value Value.
   */
  set default(e) {
    e ? this.setAttribute("default", "") : this.removeAttribute("default");
  }
  /**
   * Returns ready state.
   *
   * @returns Ready state.
   */
  get readyState() {
    return 0;
  }
  /**
   * Returns the TextTrack object corresponding to the track element.
   *
   * @returns TextTrack
   */
  get track() {
    const e = new this[b].TextTrack(T);
    return e[Wu] = this.kind, e[$g] = this.label, e[$1] = this.srclang, e[Jr] = this.default ? "showing" : "disabled", e[Tv] = this.id, e;
  }
}
class bUe extends Ye {
}
class yUe extends Ye {
}
class AUe extends K2 {
}
class EUe extends KA {
  [ve] = le.processingInstructionNode;
  [Ma] = "";
  /**
   * Returns target.
   *
   * @returns Target.
   */
  get target() {
    return this[Ma];
  }
}
let _W = class extends ot {
  [ts] = null;
  [ci] = this;
  [ve] = le.documentFragmentNode;
  /**
   * Returns the document fragment children.
   */
  get children() {
    if (!this[ts]) {
      const e = this[Ft];
      this[ts] = new mi(T, () => e);
    }
    return this[ts];
  }
  /**
   * Last element child.
   *
   * @returns Element.
   */
  get childElementCount() {
    return this[Ft].length;
  }
  /**
   * First element child.
   *
   * @returns Element.
   */
  get firstElementChild() {
    return this[Ft][0] ?? null;
  }
  /**
   * Last element child.
   *
   * @returns Element.
   */
  get lastElementChild() {
    const e = this[Ft];
    return e[e.length - 1] ?? null;
  }
  /**
   * Get text value of children.
   *
   * @returns Text content.
   */
  get textContent() {
    let e = "";
    for (const n of this[Re])
      (n[ve] === le.elementNode || n[ve] === le.textNode) && (e += n.textContent);
    return e;
  }
  /**
   * Sets text content.
   *
   * @param textContent Text content.
   */
  set textContent(e) {
    const n = this[Re];
    for (; n.length; )
      this.removeChild(n[0]);
    e && this.appendChild(this[he].createTextNode(e));
  }
  /**
   * Inserts a set of Node objects or DOMString objects after the last child of the ParentNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  append(...e) {
    Wn.append(this, ...e);
  }
  /**
   * Inserts a set of Node objects or DOMString objects before the first child of the ParentNode. DOMString objects are inserted as equivalent Text nodes.
   *
   * @param nodes List of Node or DOMString.
   */
  prepend(...e) {
    Wn.prepend(this, ...e);
  }
  /**
   * Replaces the existing children of a node with a specified new set of children.
   *
   * @param nodes List of Node or DOMString.
   */
  replaceChildren(...e) {
    Wn.replaceChildren(this, ...e);
  }
  /**
   * Query CSS selector to find matching elments.
   *
   * @param selector CSS selector.
   * @returns Matching elements.
   */
  querySelectorAll(e) {
    return it.querySelectorAll(this, e);
  }
  /**
   * Query CSS Selector to find a matching element.
   *
   * @param selector CSS selector.
   * @returns Matching element.
   */
  querySelector(e) {
    return it.querySelector(this, e);
  }
  /**
   * Returns an element by ID.
   *
   * @param id ID.
   * @returns Matching element.
   */
  getElementById(e) {
    return Wn.getElementById(this, e);
  }
};
class SUe extends _W {
  // Internal properties
  [uh] = [];
  [Jr] = "open";
  [Bg] = null;
  [Ld] = !1;
  [Hm] = !1;
  [ch] = !1;
  [Kl] = "named";
  [F] = /* @__PURE__ */ new Map();
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onslotchange() {
    return this[F].get("onslotchange") ?? null;
  }
  set onslotchange(e) {
    this[F].set("onslotchange", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns mode.
   *
   * @returns Mode.
   */
  get mode() {
    return this[Jr];
  }
  /**
   * Returns host.
   *
   * @returns Host.
   */
  get host() {
    return this[Bg];
  }
  /**
   * Returns clonable.
   *
   * @returns Clonable.
   */
  get clonable() {
    return this[Ld];
  }
  /**
   * Returns delegates focus.
   *
   * @returns Delegates focus.
   */
  get delegatesFocus() {
    return this[Hm];
  }
  /**
   * Returns serializable.
   *
   * @returns Serializable.
   */
  get serializable() {
    return this[ch];
  }
  /**
   * Returns slot assignment.
   *
   * @returns Slot assignment.
   */
  get slotAssignment() {
    return this[Kl];
  }
  /**
   * The element that's currently in full screen mode for this shadow tree.
   *
   * @returns Fullscreen element.
   */
  get fullscreenElement() {
    return null;
  }
  /**
   * Returns the Element within the shadow tree that is currently being presented in picture-in-picture mode.
   *
   * @returns Picture-in-picture element.
   */
  get pictureInPictureElement() {
    return null;
  }
  /**
   * Returns the Element set as the target for mouse events while the pointer is locked. null if lock is pending, pointer is unlocked, or if the target is in another tree.
   *
   * @returns Pointer lock element.
   */
  get pointerLockElement() {
    return null;
  }
  /**
   * Returns inner HTML.
   *
   * @returns HTML.
   */
  get innerHTML() {
    const e = new sf();
    let n = "";
    for (const r of this[Re])
      n += e.serializeToString(r);
    return n;
  }
  /**
   * Sets inner HTML.
   *
   * @param html HTML.
   */
  set innerHTML(e) {
    const n = this[Re];
    for (; n.length; )
      this.removeChild(n[0]);
    new hu(this[b]).parse(e, this);
  }
  /**
   * Returns adopted style sheets.
   *
   * @returns Adopted style sheets.
   */
  get adoptedStyleSheets() {
    return this[uh];
  }
  /**
   * Sets adopted style sheets.
   *
   * @param value Adopted style sheets.
   */
  set adoptedStyleSheets(e) {
    this[uh] = e;
  }
  /**
   * Returns active element.
   *
   * @returns Active element.
   */
  get activeElement() {
    let e = this[he][jr], n = e?.getRootNode();
    if (!n || n === this[he])
      return null;
    if (n === this)
      return e;
    for (; n && n !== this; )
      e = n.host, n = e.getRootNode();
    return e;
  }
  /**
   * Returns an array of all Animation objects currently in effect, whose target elements are descendants of the shadow tree.
   *
   * @returns Array of animations.
   */
  getAnimations() {
    return [];
  }
  /**
   * Parses a string of HTML into a document fragment, without sanitization, which then replaces the shadowroot's original subtree. The HTML string may include declarative shadow roots, which would be parsed as template elements the HTML was set using ShadowRoot.innerHTML.
   *
   * @param html HTML.
   */
  setHTMLUnsafe(e) {
    const n = this[Re];
    for (; n.length; )
      this.removeChild(n[0]);
    new hu(this[b]).parse(e, this);
  }
  /**
   * Converts to string.
   *
   * @returns String.
   */
  toString() {
    return this.innerHTML;
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    const n = super[Bt](e);
    return n[Jr] = this[Jr], n[Ld] = this[Ld], n[Hm] = this[Hm], n[ch] = this[ch], n[Kl] = this[Kl], n;
  }
}
class nn extends Sc {
  // Internal properties
  [er] = null;
  // Private properties
  #e = null;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onabort() {
    return K.getEventListener(this, "onabort");
  }
  set onabort(e) {
    this[F].set("onabort", e);
  }
  get onanimationend() {
    return K.getEventListener(this, "onanimationend");
  }
  set onanimationend(e) {
    this[F].set("onanimationend", e);
  }
  get onanimationiteration() {
    return K.getEventListener(this, "onanimationiteration");
  }
  set onanimationiteration(e) {
    this[F].set("onanimationiteration", e);
  }
  get onanimationstart() {
    return K.getEventListener(this, "onanimationstart");
  }
  set onanimationstart(e) {
    this[F].set("onanimationstart", e);
  }
  get onauxclick() {
    return K.getEventListener(this, "onauxclick");
  }
  set onauxclick(e) {
    this[F].set("onauxclick", e);
  }
  get onblur() {
    return K.getEventListener(this, "onblur");
  }
  set onblur(e) {
    this[F].set("onblur", e);
  }
  get oncancel() {
    return K.getEventListener(this, "oncancel");
  }
  set oncancel(e) {
    this[F].set("oncancel", e);
  }
  get oncanplay() {
    return K.getEventListener(this, "oncanplay");
  }
  set oncanplay(e) {
    this[F].set("oncanplay", e);
  }
  get oncanplaythrough() {
    return K.getEventListener(this, "oncanplaythrough");
  }
  set oncanplaythrough(e) {
    this[F].set("oncanplaythrough", e);
  }
  get onchange() {
    return K.getEventListener(this, "onchange");
  }
  set onchange(e) {
    this[F].set("onchange", e);
  }
  get onclick() {
    return K.getEventListener(this, "onclick");
  }
  set onclick(e) {
    this[F].set("onclick", e);
  }
  get onclose() {
    return K.getEventListener(this, "onclose");
  }
  set onclose(e) {
    this[F].set("onclose", e);
  }
  get oncontextmenu() {
    return K.getEventListener(this, "oncontextmenu");
  }
  set oncontextmenu(e) {
    this[F].set("oncontextmenu", e);
  }
  get oncopy() {
    return K.getEventListener(this, "oncopy");
  }
  set oncopy(e) {
    this[F].set("oncopy", e);
  }
  get oncuechange() {
    return K.getEventListener(this, "oncuechange");
  }
  set oncuechange(e) {
    this[F].set("oncuechange", e);
  }
  get oncut() {
    return K.getEventListener(this, "oncut");
  }
  set oncut(e) {
    this[F].set("oncut", e);
  }
  get ondblclick() {
    return K.getEventListener(this, "ondblclick");
  }
  set ondblclick(e) {
    this[F].set("ondblclick", e);
  }
  get ondrag() {
    return K.getEventListener(this, "ondrag");
  }
  set ondrag(e) {
    this[F].set("ondrag", e);
  }
  get ondragend() {
    return K.getEventListener(this, "ondragend");
  }
  set ondragend(e) {
    this[F].set("ondragend", e);
  }
  get ondragenter() {
    return K.getEventListener(this, "ondragenter");
  }
  set ondragenter(e) {
    this[F].set("ondragenter", e);
  }
  get ondragleave() {
    return K.getEventListener(this, "ondragleave");
  }
  set ondragleave(e) {
    this[F].set("ondragleave", e);
  }
  get ondragover() {
    return K.getEventListener(this, "ondragover");
  }
  set ondragover(e) {
    this[F].set("ondragover", e);
  }
  get ondragstart() {
    return K.getEventListener(this, "ondragstart");
  }
  set ondragstart(e) {
    this[F].set("ondragstart", e);
  }
  get ondrop() {
    return K.getEventListener(this, "ondrop");
  }
  set ondrop(e) {
    this[F].set("ondrop", e);
  }
  get ondurationchange() {
    return K.getEventListener(this, "ondurationchange");
  }
  set ondurationchange(e) {
    this[F].set("ondurationchange", e);
  }
  get onemptied() {
    return K.getEventListener(this, "onemptied");
  }
  set onemptied(e) {
    this[F].set("onemptied", e);
  }
  get onended() {
    return K.getEventListener(this, "onended");
  }
  set onended(e) {
    this[F].set("onended", e);
  }
  get onerror() {
    return K.getEventListener(this, "onerror");
  }
  set onerror(e) {
    this[F].set("onerror", e);
  }
  get onfocus() {
    return K.getEventListener(this, "onfocus");
  }
  set onfocus(e) {
    this[F].set("onfocus", e);
  }
  get onformdata() {
    return K.getEventListener(this, "onformdata");
  }
  set onformdata(e) {
    this[F].set("onformdata", e);
  }
  get ongotpointercapture() {
    return K.getEventListener(this, "ongotpointercapture");
  }
  set ongotpointercapture(e) {
    this[F].set("ongotpointercapture", e);
  }
  get oninput() {
    return K.getEventListener(this, "oninput");
  }
  set oninput(e) {
    this[F].set("oninput", e);
  }
  get oninvalid() {
    return K.getEventListener(this, "oninvalid");
  }
  set oninvalid(e) {
    this[F].set("oninvalid", e);
  }
  get onkeydown() {
    return K.getEventListener(this, "onkeydown");
  }
  set onkeydown(e) {
    this[F].set("onkeydown", e);
  }
  get onkeypress() {
    return K.getEventListener(this, "onkeypress");
  }
  set onkeypress(e) {
    this[F].set("onkeypress", e);
  }
  get onkeyup() {
    return K.getEventListener(this, "onkeyup");
  }
  set onkeyup(e) {
    this[F].set("onkeyup", e);
  }
  get onload() {
    return K.getEventListener(this, "onload");
  }
  set onload(e) {
    this[F].set("onload", e);
  }
  get onloadeddata() {
    return K.getEventListener(this, "onloadeddata");
  }
  set onloadeddata(e) {
    this[F].set("onloadeddata", e);
  }
  get onloadedmetadata() {
    return K.getEventListener(this, "onloadedmetadata");
  }
  set onloadedmetadata(e) {
    this[F].set("onloadedmetadata", e);
  }
  get onloadstart() {
    return K.getEventListener(this, "onloadstart");
  }
  set onloadstart(e) {
    this[F].set("onloadstart", e);
  }
  get onlostpointercapture() {
    return K.getEventListener(this, "onlostpointercapture");
  }
  set onlostpointercapture(e) {
    this[F].set("onlostpointercapture", e);
  }
  get onmousedown() {
    return K.getEventListener(this, "onmousedown");
  }
  set onmousedown(e) {
    this[F].set("onmousedown", e);
  }
  get onmouseenter() {
    return K.getEventListener(this, "onmouseenter");
  }
  set onmouseenter(e) {
    this[F].set("onmouseenter", e);
  }
  get onmouseleave() {
    return K.getEventListener(this, "onmouseleave");
  }
  set onmouseleave(e) {
    this[F].set("onmouseleave", e);
  }
  get onmousemove() {
    return K.getEventListener(this, "onmousemove");
  }
  set onmousemove(e) {
    this[F].set("onmousemove", e);
  }
  get onmouseout() {
    return K.getEventListener(this, "onmouseout");
  }
  set onmouseout(e) {
    this[F].set("onmouseout", e);
  }
  get onmouseover() {
    return K.getEventListener(this, "onmouseover");
  }
  set onmouseover(e) {
    this[F].set("onmouseover", e);
  }
  get onmouseup() {
    return K.getEventListener(this, "onmouseup");
  }
  set onmouseup(e) {
    this[F].set("onmouseup", e);
  }
  get onmousewheel() {
    return K.getEventListener(this, "onmousewheel");
  }
  set onmousewheel(e) {
    this[F].set("onmousewheel", e);
  }
  get onpaste() {
    return K.getEventListener(this, "onpaste");
  }
  set onpaste(e) {
    this[F].set("onpaste", e);
  }
  get onpause() {
    return K.getEventListener(this, "onpause");
  }
  set onpause(e) {
    this[F].set("onpause", e);
  }
  get onplay() {
    return K.getEventListener(this, "onplay");
  }
  set onplay(e) {
    this[F].set("onplay", e);
  }
  get onplaying() {
    return K.getEventListener(this, "onplaying");
  }
  set onplaying(e) {
    this[F].set("onplaying", e);
  }
  get onpointercancel() {
    return K.getEventListener(this, "onpointercancel");
  }
  set onpointercancel(e) {
    this[F].set("onpointercancel", e);
  }
  get onpointerdown() {
    return K.getEventListener(this, "onpointerdown");
  }
  set onpointerdown(e) {
    this[F].set("onpointerdown", e);
  }
  get onpointerenter() {
    return K.getEventListener(this, "onpointerenter");
  }
  set onpointerenter(e) {
    this[F].set("onpointerenter", e);
  }
  get onpointerleave() {
    return K.getEventListener(this, "onpointerleave");
  }
  set onpointerleave(e) {
    this[F].set("onpointerleave", e);
  }
  get onpointermove() {
    return K.getEventListener(this, "onpointermove");
  }
  set onpointermove(e) {
    this[F].set("onpointermove", e);
  }
  get onpointerout() {
    return K.getEventListener(this, "onpointerout");
  }
  set onpointerout(e) {
    this[F].set("onpointerout", e);
  }
  get onpointerover() {
    return K.getEventListener(this, "onpointerover");
  }
  set onpointerover(e) {
    this[F].set("onpointerover", e);
  }
  get onpointerrawupdate() {
    return K.getEventListener(this, "onpointerrawupdate");
  }
  set onpointerrawupdate(e) {
    this[F].set("onpointerrawupdate", e);
  }
  get onpointerup() {
    return K.getEventListener(this, "onpointerup");
  }
  set onpointerup(e) {
    this[F].set("onpointerup", e);
  }
  get onprogress() {
    return K.getEventListener(this, "onprogress");
  }
  set onprogress(e) {
    this[F].set("onprogress", e);
  }
  get onratechange() {
    return K.getEventListener(this, "onratechange");
  }
  set onratechange(e) {
    this[F].set("onratechange", e);
  }
  get onreset() {
    return K.getEventListener(this, "onreset");
  }
  set onreset(e) {
    this[F].set("onreset", e);
  }
  get onresize() {
    return K.getEventListener(this, "onresize");
  }
  set onresize(e) {
    this[F].set("onresize", e);
  }
  get onscroll() {
    return K.getEventListener(this, "onscroll");
  }
  set onscroll(e) {
    this[F].set("onscroll", e);
  }
  get onscrollend() {
    return K.getEventListener(this, "onscrollend");
  }
  set onscrollend(e) {
    this[F].set("onscrollend", e);
  }
  get onscrollsnapchange() {
    return K.getEventListener(this, "onscrollsnapchange");
  }
  set onscrollsnapchange(e) {
    this[F].set("onscrollsnapchange", e);
  }
  get onscrollsnapchanging() {
    return K.getEventListener(this, "onscrollsnapchanging");
  }
  set onscrollsnapchanging(e) {
    this[F].set("onscrollsnapchanging", e);
  }
  get onsecuritypolicyviolation() {
    return K.getEventListener(this, "onsecuritypolicyviolation");
  }
  set onsecuritypolicyviolation(e) {
    this[F].set("onsecuritypolicyviolation", e);
  }
  get onseeked() {
    return K.getEventListener(this, "onseeked");
  }
  set onseeked(e) {
    this[F].set("onseeked", e);
  }
  get onseeking() {
    return K.getEventListener(this, "onseeking");
  }
  set onseeking(e) {
    this[F].set("onseeking", e);
  }
  get onselect() {
    return K.getEventListener(this, "onselect");
  }
  set onselect(e) {
    this[F].set("onselect", e);
  }
  get onselectionchange() {
    return K.getEventListener(this, "onselectionchange");
  }
  set onselectionchange(e) {
    this[F].set("onselectionchange", e);
  }
  get onselectstart() {
    return K.getEventListener(this, "onselectstart");
  }
  set onselectstart(e) {
    this[F].set("onselectstart", e);
  }
  get onslotchange() {
    return K.getEventListener(this, "onslotchange");
  }
  set onslotchange(e) {
    this[F].set("onslotchange", e);
  }
  get onstalled() {
    return K.getEventListener(this, "onstalled");
  }
  set onstalled(e) {
    this[F].set("onstalled", e);
  }
  get onsubmit() {
    return K.getEventListener(this, "onsubmit");
  }
  set onsubmit(e) {
    this[F].set("onsubmit", e);
  }
  get onsuspend() {
    return K.getEventListener(this, "onsuspend");
  }
  set onsuspend(e) {
    this[F].set("onsuspend", e);
  }
  get ontimeupdate() {
    return K.getEventListener(this, "ontimeupdate");
  }
  set ontimeupdate(e) {
    this[F].set("ontimeupdate", e);
  }
  get ontoggle() {
    return K.getEventListener(this, "ontoggle");
  }
  set ontoggle(e) {
    this[F].set("ontoggle", e);
  }
  get ontransitioncancel() {
    return K.getEventListener(this, "ontransitioncancel");
  }
  set ontransitioncancel(e) {
    this[F].set("ontransitioncancel", e);
  }
  get ontransitionend() {
    return K.getEventListener(this, "ontransitionend");
  }
  set ontransitionend(e) {
    this[F].set("ontransitionend", e);
  }
  get ontransitionrun() {
    return K.getEventListener(this, "ontransitionrun");
  }
  set ontransitionrun(e) {
    this[F].set("ontransitionrun", e);
  }
  get ontransitionstart() {
    return K.getEventListener(this, "ontransitionstart");
  }
  set ontransitionstart(e) {
    this[F].set("ontransitionstart", e);
  }
  get onvolumechange() {
    return K.getEventListener(this, "onvolumechange");
  }
  set onvolumechange(e) {
    this[F].set("onvolumechange", e);
  }
  get onwaiting() {
    return K.getEventListener(this, "onwaiting");
  }
  set onwaiting(e) {
    this[F].set("onwaiting", e);
  }
  get onwheel() {
    return K.getEventListener(this, "onwheel");
  }
  set onwheel(e) {
    this[F].set("onwheel", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns current translate.
   *
   * @returns Element.
   */
  get ownerSVGElement() {
    let e = this[xe];
    for (; e; ) {
      if (e[Tt] === "svg")
        return e;
      e = e[xe];
    }
    return null;
  }
  /**
   * Returns the SVGElement which established the current viewport. Often the nearest ancestor <svg> element. null if the given element is the outermost <svg> element.
   *
   * @returns SVG element.
   */
  get viewportElement() {
    return this.ownerSVGElement;
  }
  /**
   * Returns data set.
   *
   * @returns Data set.
   */
  get dataset() {
    return this.#e ??= new dW(T, this);
  }
  /**
   * Returns style.
   *
   * @returns Style.
   */
  get style() {
    return this[er] || (this[er] = new vh(T, this[b], { element: this })), this[er];
  }
  /**
   * Returns tab index.
   *
   * @returns Tab index.
   */
  get tabIndex() {
    const e = this.getAttribute("tabindex");
    return e !== null ? Number(e) : -1;
  }
  /**
   * Returns tab index.
   *
   * @param tabIndex Tab index.
   */
  set tabIndex(e) {
    e === -1 ? this.removeAttribute("tabindex") : this.setAttribute("tabindex", String(e));
  }
  /**
   * Triggers a blur event.
   */
  blur() {
    J1.blur(this);
  }
  /**
   * Triggers a focus event.
   */
  focus() {
    J1.focus(this);
  }
}
let wUe = class {
  /**
   * Starts observing.
   *
   * Not implemented.
   */
  observe() {
  }
  /**
   * Stops observing.
   *
   * Not implemented.
   */
  unobserve() {
  }
  /**
   * Disconnects.
   *
   * Not implemented.
   */
  disconnect() {
  }
};
class iM {
  width = 1024;
  height = 768;
  availWidth = 1024;
  availHeight = 768;
  colorDepth = 24;
  pixelDepth = 24;
}
class Ag {
  [Dn] = {};
  /**
   * Constructor.
   */
  constructor() {
    const e = this[Dn], n = new Ws(this, [Ag]);
    return new Proxy(this, {
      get: (r, i) => {
        if (i in r || typeof i == "symbol")
          return n.bind(i), r[i];
        if (i in e)
          return e[i];
      },
      set(r, i, s) {
        return n.bind(i), i in r || typeof i == "symbol" || (e[String(i)] = String(s)), !0;
      },
      deleteProperty(r, i) {
        return i in e ? (delete e[String(i)], !0) : !1;
      },
      ownKeys() {
        return Object.keys(e);
      },
      has(r, i) {
        return i in r || i in e;
      },
      defineProperty(r, i, s) {
        return n.preventBinding(i), i in r ? (Object.defineProperty(r, i, s), !0) : s.value !== void 0 ? (e[String(i)] = String(s.value), !0) : !1;
      },
      getOwnPropertyDescriptor(r, i) {
        if (i in r)
          return;
        const s = e[String(i)];
        if (s !== void 0)
          return {
            value: s,
            writable: !0,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return Object.keys(this[Dn]).length;
  }
  /**
   * Returns name of the nth key.
   *
   * @param index Index.
   * @returns Name.
   */
  key(e) {
    const n = Object.keys(this[Dn])[e];
    return n !== void 0 ? n : null;
  }
  /**
   * Sets item.
   *
   * @param name Name.
   * @param item Item.
   */
  setItem(e, n) {
    this[Dn][e] = String(n);
  }
  /**
   * Returns item.
   *
   * @param name Name.
   * @returns Item.
   */
  getItem(e) {
    return this[Dn][e] !== void 0 ? this[Dn][e] : null;
  }
  /**
   * Removes item.
   *
   * @param name Name.
   */
  removeItem(e) {
    delete this[Dn][e];
  }
  /**
   * Clears storage.
   */
  clear() {
    const e = this[Dn];
    for (const n of Object.keys(e))
      delete e[n];
  }
}
class FUe {
  /**
   * Serializes a node into XML.
   *
   * @param root Root node.
   * @returns Result.
   */
  serializeToString(e) {
    return this.#e(e);
  }
  /**
   * Serializes a node into XML.
   *
   * @param root Root node.
   * @param [inheritedDefaultNamespace] Default namespace.
   * @param [inheritedNamespacePrefixes] Inherited namespace prefixes.
   * @returns Result.
   */
  #e(e, n = null, r = null) {
    switch (e[ve]) {
      case le.elementNode:
        const i = e, s = i[Tt];
        let a = "";
        const o = this.#t(i, r), u = i[je] === xn.html ? i[pn] : this.#n(i, o), l = `${u ? u + ":" : ""}${s}`, h = u ? n : i[je] || n, f = this.#r(i, u, n, r), m = h === xn.html && s === "template" ? e.content[Re] : e[Re];
        for (const B of m)
          a += this.#e(B, h, o);
        return !a && h === xn.html && Si[s.toLowerCase()]?.contentModel === pe.noDescendants ? `<${l}${f} />` : !a && h !== xn.html ? `<${l}${f}/>` : `<${l}${f}>${a}</${l}>`;
      case ot.DOCUMENT_FRAGMENT_NODE:
      case ot.DOCUMENT_NODE:
        let g = "";
        e[Hg] && (g += this.#e(e[Hg], n, new Map(r)));
        for (const B of e[Re])
          g += this.#e(B, n, new Map(r));
        return g;
      case le.commentNode:
        return `<!--${e.textContent}-->`;
      case le.processingInstructionNode:
        return `<?${e.target} ${e.textContent}?>`;
      case le.textNode:
        const A = e.parentElement;
        return A && Si[A[Tt]]?.contentModel === pe.rawText ? e.textContent : hi.encodeTextContent(e.textContent);
      case le.documentTypeNode:
        const E = e, w = E.publicId ? " PUBLIC" : E.systemId ? " SYSTEM" : "", x = E.publicId ? ` "${E.publicId}"` : "", N = E.systemId ? ` "${E.systemId}"` : "";
        return `<!DOCTYPE ${E.name}${w}${x}${N}>`;
    }
    return "";
  }
  /**
   * Returns namespace prefixes.
   *
   * @param element Element.
   * @param inheritedNamespacePrefixes Inherited namespace prefixes.
   * @returns Namespace prefixes.
   */
  #t(e, n) {
    const r = new Map(n);
    for (const i of e[bt][Ge].values())
      i[je] === xn.xmlns && i[pn] && r.set(i[ze], i[Tt]);
    return r;
  }
  /**
   * Returns namespace prefixes.
   *
   * @param element Element.
   * @param namespacePrefixes Inherited namespace prefixes.
   * @returns Element prefix.
   */
  #n(e, n) {
    if (e[pn] && !e[je])
      throw new Error("Element has a prefix but no namespace.");
    if (!e[pn] || !n)
      return null;
    const r = n.get(e[je]);
    if (r)
      return r;
    const i = new Set(n.values());
    if (i.has(e[pn])) {
      let s = 1;
      for (; i.has("n" + s); )
        s++;
      return n.set(e[je], "n" + s), "n" + s;
    }
    return n.set(e[je], e[pn]), e[pn];
  }
  /**
   * Returns attributes as a string.
   *
   * @param element Element.
   * @param elementPrefix Element prefix.
   * @param inheritedDefaultNamespace Inherited default namespace.
   * @param inheritedNamespacePrefixes Inherited namespace prefixes.
   * @returns Attributes.
   */
  #r(e, n, r, i) {
    let s = "", a = "";
    const o = /* @__PURE__ */ new Set();
    for (const u of e[bt][Ge].values())
      u[je] === xn.xmlns ? n && u[Tt] === n && e[je] ? (a += ` xmlns:${n}="${hi.encodeXMLAttributeValue(e[je])}"`, o.add(e[je])) : !n && u[tt] === "xmlns" && e[je] ? (a += ` xmlns="${hi.encodeXMLAttributeValue(e[je])}"`, o.add(e[je])) : (a += ` ${u[tt]}="${hi.encodeXMLAttributeValue(u[ze])}"`, o.add(u[ze])) : s += ` ${u[tt]}="${hi.encodeXMLAttributeValue(u[ze])}"`;
    return e[je] && r !== e[je] && !o.has(e[je]) && (n && !i?.has(e[je]) ? a += ` xmlns:${n}="${hi.encodeXMLAttributeValue(e[je])}"` : !n && r !== e[je] && (a += ` xmlns="${hi.encodeXMLAttributeValue(e[je])}"`)), a + s;
  }
}
const TUe = new HM(`
this.ArrayBuffer = globalThis.ArrayBuffer;
this.Boolean = globalThis.Boolean;
this.DataView = globalThis.DataView;
this.Date = globalThis.Date;
this.Error = globalThis.Error;
this.EvalError = globalThis.EvalError;
this.Float32Array = globalThis.Float32Array;
this.Float64Array = globalThis.Float64Array;
this.GLOBAL = globalThis.GLOBAL;
this.Infinity = globalThis.Infinity;
this.Int16Array = globalThis.Int16Array;
this.Int32Array = globalThis.Int32Array;
this.Int8Array = globalThis.Int8Array;
this.Intl = globalThis.Intl;
this.JSON = globalThis.JSON;
this.Map = globalThis.Map;
this.Math = globalThis.Math;
this.NaN = globalThis.NaN;
this.Number = globalThis.Number;
this.Promise = globalThis.Promise;
this.RangeError = globalThis.RangeError;
this.ReferenceError = globalThis.ReferenceError;
this.RegExp = globalThis.RegExp;
this.Reflect = globalThis.Reflect;
this.Set = globalThis.Set;
this.Symbol = globalThis.Symbol;
this.SyntaxError = globalThis.SyntaxError;
this.String = globalThis.String;
this.TypeError = globalThis.TypeError;
this.URIError = globalThis.URIError;
this.Uint16Array = globalThis.Uint16Array;
this.Uint32Array = globalThis.Uint32Array;
this.Uint8Array = globalThis.Uint8Array;
this.Uint8ClampedArray = globalThis.Uint8ClampedArray;
this.WeakMap = globalThis.WeakMap;
this.WeakSet = globalThis.WeakSet;
this.decodeURI = globalThis.decodeURI;
this.decodeURIComponent = globalThis.decodeURIComponent;
this.encodeURI = globalThis.encodeURI;
this.encodeURIComponent = globalThis.encodeURIComponent;
this.eval = globalThis.eval;
this.escape = globalThis.escape;
this.global = globalThis.global;
this.isFinite = globalThis.isFinite;
this.isNaN = globalThis.isNaN;
this.parseFloat = globalThis.parseFloat;
this.parseInt = globalThis.parseInt;
this.root = globalThis.root;
this.undefined = globalThis.undefined;
this.unescape = globalThis.unescape;
this.AbortController = globalThis.AbortController;
this.AbortSignal = globalThis.AbortSignal;
this.Array = globalThis.Array;
this.Object = globalThis.Object;
this.Function = globalThis.Function;
`);
class vUe {
  /**
   * Opens a page.
   *
   * @param browserFrame Browser frame.
   * @param [options] Options.
   * @param [options.url] URL.
   * @param [options.target] Target.
   * @param [options.features] Window features.
   */
  static openPage(e, n) {
    const r = this.getWindowFeatures(n?.features || ""), i = n?.target !== void 0 ? String(n.target) : null, s = new Pr(e.window.location.href), a = Cf.getRelativeURL(e, n?.url), o = e.window;
    let u;
    if (e.window !== o)
      return null;
    switch (i) {
      case "_self":
        u = e;
        break;
      case "_top":
        u = e.page.mainFrame;
        break;
      case "_parent":
        u = e.parentFrame ?? e;
        break;
      default:
        u = e.page.context.newPage().mainFrame, u[zu] = e;
        break;
    }
    if (u.goto(a.href, {
      referrer: r.noreferrer ? void 0 : e.window.location.origin,
      referrerPolicy: r.noreferrer ? "no-referrer" : void 0
    }).catch((h) => {
      u.page.console.error(h);
    }), a.protocol === "javascript:")
      return u.window;
    if (u === e && e.window === o)
      return null;
    r.popup && i !== "_self" && i !== "_top" && i !== "_parent" && (u[M1] = !0, (r?.width || r?.height) && u.page.setViewport({
      width: r?.width,
      height: r?.height
    }), r?.left && (u.window.screenLeft = r.left, u.window.screenX = r.left), r?.top && (u.window.screenTop = r.top, u.window.screenY = r.top)), i && i !== "_self" && i !== "_top" && i !== "_parent" && i !== "_blank" && (u.window.name = i);
    const l = vf.isCORS(s, u.url);
    return !r.noopener && !r.noreferrer && e.window && u[zu] && u.window !== e.window && (u[Ff] = l ? new Q1(e.window) : e.window), r.noopener || r.noreferrer ? null : l ? new Q1(u.window, e.window) : u.window;
  }
  /**
   * Returns window features.
   *
   * @param features Window features string.
   * @returns Window features.
   */
  static getWindowFeatures(e) {
    const n = e.split(","), r = {
      popup: !1,
      width: 0,
      height: 0,
      left: 0,
      top: 0,
      noopener: !1,
      noreferrer: !1
    };
    for (const i of n) {
      const [s, a] = i.split("=");
      switch (s) {
        case "popup":
          r.popup = !a || a === "yes" || a === "1" || a === "true";
          break;
        case "width":
        case "innerWidth":
          r.width = parseInt(a, 10);
          break;
        case "height":
        case "innerHeight":
          r.height = parseInt(a, 10);
          break;
        case "left":
        case "screenX":
          r.left = parseInt(a, 10);
          break;
        case "top":
        case "screenY":
          r.top = parseInt(a, 10);
          break;
        case "noopener":
          r.noopener = !0;
          break;
        case "noreferrer":
          r.noreferrer = !0;
          break;
      }
    }
    return r;
  }
}
let xUe = class extends kf {
  /**
   * Constructor.
   */
  constructor() {
    super();
    const e = this.createElement("html"), n = this.createElement("body"), r = this.createElement("head");
    this.appendChild(e), e.appendChild(r), e.appendChild(n);
  }
  /**
   * @override
   */
  [Ht](e, n = !1) {
    if (e[ve] === le.textNode)
      throw new this[b].Error("Failed to execute 'appendChild' on 'Node': Nodes of type '#text' may not be inserted inside nodes of type '#document'.");
    if (e[ve] === le.documentFragmentNode)
      return e;
    if (e[ve] === le.elementNode && this[Ft].length !== 0)
      throw new this[b].Error("Failed to execute 'appendChild' on 'Node': Only one element on document allowed.");
    return super[Ht](e, n);
  }
  /**
   * @override
   */
  [ja](e, n, r = !1) {
    if (e[ve] === le.textNode)
      throw new this[b].Error("Failed to execute 'insertBefore' on 'Node': Nodes of type '#text' may not be inserted inside nodes of type '#document'.");
    if (e[ve] === le.documentFragmentNode)
      return e;
    if (e[ve] === le.elementNode && this[Ft].length !== 0)
      throw new this[b].Error("Failed to execute 'insertBefore' on 'Node': Only one element on document allowed.");
    return super[ja](e, n, r);
  }
}, CUe = class extends kf {
  // Internal properties
  [xi] = "application/xml";
}, kUe = class extends KA {
  [ve] = le.textNode;
  [Wi] = null;
  [ys] = null;
  /**
   * Node name.
   *
   * @returns Node name.
   */
  get nodeName() {
    return "#text";
  }
  /**
   * @override
   */
  get data() {
    return this[Dn];
  }
  /**
   * @override
   */
  set data(e) {
    super.data = e, this[Wi] && this[Wi][By](), this[ys] && this[ys][cg]();
  }
  /**
   * Breaks the Text node into two nodes at the specified offset, keeping both nodes in the tree as siblings.
   *
   * @see https://dom.spec.whatwg.org/#dom-text-splittext
   * @param offset Offset.
   * @returns New text node.
   */
  splitText(e) {
    const n = this[Dn].length;
    if (e < 0 || e > n)
      throw new this[b].DOMException("The index is not in the allowed range.", ne.indexSizeError);
    const r = n - e, i = this.substringData(e, r), s = this[he].createTextNode(i);
    return this[xe] !== null && this[xe].insertBefore(s, this.nextSibling), this.replaceData(e, r, ""), s;
  }
  /**
   * Converts to string.
   *
   * @returns String.
   */
  toString() {
    return "[object Text]";
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
  /**
   * @override
   */
  [ho]() {
    super[ho](), this[Wi] && this[Wi][By](), this[ys] && this[Dn] && this[ys][cg]();
  }
  /**
   * @override
   */
  [bh]() {
    this[Wi] && this[Wi][By](), this[ys] && this[Dn] && this[ys][cg](), super[bh]();
  }
}, _Ue = class extends KA {
  [ve] = le.commentNode;
  /**
   * Node name.
   *
   * @returns Node name.
   */
  get nodeName() {
    return "#comment";
  }
  /**
   * Converts to string.
   *
   * @returns String.
   */
  toString() {
    return "[object Comment]";
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
}, NUe = class extends vW {
  [Xe] = "IMG";
  [Tt] = "img";
  [je] = xn.html;
  /**
   * Constructor.
   *
   * @param [width] Width.
   * @param [height] Height.
   */
  constructor(e = null, n = null) {
    super(), e !== null && (this.width = e), n !== null && (this.height = n);
  }
}, DUe = class extends pW {
  [Xe] = "AUDIO";
  [Tt] = "audio";
  [je] = xn.html;
  /**
   * Constructor.
   *
   * @param [url] source URL.
   */
  constructor(e = null) {
    super(), e !== null && (this.src = e);
  }
};
class IUe {
  target;
  options;
  mutationListener;
  #e;
  #t;
  #n;
  #r = [];
  #i = !1;
  #s = !1;
  /**
   * Constructor.
   *
   * @param init Options.
   * @param init.window Window.
   * @param init.options Options.
   * @param init.target Target.
   * @param init.observer Observer.
   * @param init.callback Callback.
   */
  constructor(e) {
    this.options = e.options, this.target = e.target, this.mutationListener = {
      options: e.options,
      callback: new WeakRef((n) => this.report(n))
    }, this.#e = e.window, this.#t = e.observer, this.#n = e.callback;
  }
  /**
   * Reports mutations.
   *
   * @param record Record.
   */
  report(e) {
    this.#i || (this.#r.push(e), !this.#s && (this.#e.queueMicrotask(() => {
      if (this.#i)
        return;
      this.#s = !1;
      const n = this.#r;
      n?.length > 0 && (this.#r = [], this.#n(n, this.#t));
    }), this.#s = !0));
  }
  /**
   * Destroys the listener.
   */
  takeRecords() {
    if (this.#i)
      return [];
    const e = this.#r;
    return this.#r = [], e;
  }
  /**
   * Destroys the listener.
   */
  destroy() {
    this.#i || (this.#i = !0, this.options = null, this.target = null, this.mutationListener = null, this.#e = null, this.#t = null, this.#n = null, this.#r = null);
  }
}
let RUe = class {
  #e;
  #t = [];
  #n = !1;
  /**
   * Constructor.
   *
   * @param callback Callback.
   */
  constructor(e) {
    if (!this[b])
      throw new TypeError(`Failed to construct '${this.constructor.name}': '${this.constructor.name}' was constructed outside a Window context.`);
    this.#e = e;
  }
  /**
   * Starts observing.
   *
   * @param target Target.
   * @param options Options.
   */
  observe(e, n) {
    if (this.#n)
      return;
    if (!e)
      throw new this[b].TypeError(`Failed to execute 'observe' on 'MutationObserver': The first parameter "target" should be of type "Node".`);
    if (n && (n.attributeFilter || n.attributeOldValue)) {
      if (n.attributes === void 0 && (n = Object.assign({}, n, {
        attributes: !0,
        attributeFilter: n.attributeFilter,
        attributeOldValue: n.attributeOldValue
      })), !n.attributes && n.attributeOldValue)
        throw new this[b].TypeError("Failed to execute 'observe' on 'MutationObserver': The options object may only set 'attributeOldValue' to true when 'attributes' is true or not present.");
      if (!n.attributes && n.attributeFilter)
        throw new this[b].TypeError("Failed to execute 'observe' on 'MutationObserver': The options object may only set 'attributeFilter' when 'attributes' is true or not present.");
    }
    if (n && n.characterDataOldValue && (n.characterData === void 0 && (n = Object.assign({}, n, {
      characterData: !0,
      characterDataOldValue: n.characterDataOldValue
    })), !n.characterData && n.characterDataOldValue))
      throw new this[b].TypeError("Failed to execute 'observe' on 'MutationObserver': The options object may only set 'characterDataOldValue' to true when 'characterData' is true or not present.");
    if (!n || !n.childList && !n.attributes && !n.characterData)
      throw new this[b].TypeError("Failed to execute 'observe' on 'MutationObserver': The options object must set at least one of 'attributes', 'characterData', or 'childList' to true.");
    n = Object.assign({}, n, {
      attributeFilter: n.attributeFilter ? n.attributeFilter.map((i) => i.toLowerCase()) : null
    });
    for (const i of this.#t)
      if (i.target === e) {
        i.options = n;
        return;
      }
    const r = new IUe({
      window: this[b],
      options: n,
      callback: this.#e.bind(this),
      observer: this,
      target: e
    });
    this.#t.push(r), this[b][Jd].includes(this) || this[b][Jd].push(this), e[$m](r.mutationListener);
  }
  /**
   * Disconnects.
   */
  disconnect() {
    if (this.#t.length === 0)
      return;
    for (const r of this.#t)
      r.target[$y](r.mutationListener), r.destroy();
    this.#t = [];
    const e = this[b][Jd], n = e.indexOf(this);
    n !== -1 && e.splice(n, 1);
  }
  /**
   * Returns a list of all matching DOM changes that have been detected but not yet processed by the observer's callback function, leaving the mutation queue empty.
   *
   * @returns Records.
   */
  takeRecords() {
    let e = [];
    for (const n of this.#t)
      e = e.concat(n.takeRecords());
    return e;
  }
  /**
   *
   */
  [tn]() {
    this.#n = !0, this.disconnect();
  }
}, PUe = class extends Xr {
  /**
   * Sends a message from the port, and optionally, transfers ownership of objects to other browsing contexts.
   *
   * @param _message Message.
   * @param _transerList Transfer list.
   */
  postMessage(e, n) {
  }
  /**
   * Starts the sending of messages queued on the port.
   */
  start() {
  }
  /**
   * Disconnects the port, so it is no longer active. This stops the flow of messages to that port.
   */
  close() {
  }
};
const LUe = /\/\*[\s\S]*?\*\//gm;
class sM {
  #e;
  /**
   * Constructor.
   *
   * @param parentStyleSheet Parent style sheet.
   */
  constructor(e) {
    this.#e = e;
  }
  /**
   * Parses HTML and returns a root element.
   *
   * @param cssText CSS code.
   * @returns CSS rules.
   */
  parseFromString(e) {
    const n = this.#e, r = n[b], i = e.replace(LUe, ""), s = [], a = /{|}/gm, o = [];
    let u = null, l = 0, h;
    for (; h = a.exec(i); ) {
      if (h[0] === "{") {
        const f = i.substring(l, h.index).trim();
        if (f[0] === "@") {
          const m = f.split(" "), g = m[0], A = m.slice(1).join(" ").trim();
          switch (g) {
            case "@keyframes":
            case "@-webkit-keyframes":
              const E = new z7(T, r, this);
              E[Ka] = g === "@-webkit-keyframes" ? "-webkit-" : "", E[tt] = A, E[Ta] = n, u ? (u.type === at.mediaRule || u.type === at.containerRule || u.type === at.supportsRule) && u.cssRules.push(E) : s.push(E), u = E;
              break;
            case "@media":
              const w = A.split(","), x = new j7(T, r, this);
              for (const L of w)
                x.media.appendMedium(L.trim());
              x[Ta] = n, u ? (u.type === at.mediaRule || u.type === at.containerRule || u.type === at.supportsRule) && u.cssRules.push(x) : s.push(x), u = x;
              break;
            case "@container":
            case "@-webkit-container":
              const N = new V7(T, r, this);
              N[Ka] = g === "@-webkit-container" ? "-webkit-" : "", N[go] = A, N[Ta] = n, u ? (u.type === at.mediaRule || u.type === at.containerRule || u.type === at.supportsRule) && u.cssRules.push(N) : s.push(N), u = N;
              break;
            case "@supports":
            case "@-webkit-supports":
              const B = new J7(T, r, this);
              B[Ka] = g === "@-webkit-supports" ? "-webkit-" : "", B[go] = A, B[Ta] = n, u ? (u.type === at.mediaRule || u.type === at.containerRule || u.type === at.supportsRule) && u.cssRules.push(B) : s.push(B), u = B;
              break;
            case "@font-face":
              const P = new K7(T, r, this);
              P[za] = A, P[Ta] = n, u ? (u.type === at.mediaRule || u.type === at.containerRule || u.type === at.supportsRule) && u.cssRules.push(P) : s.push(P), u = P;
              break;
            case "@scope":
            case "@-webkit-scope":
              const C = new H2(T, r, this);
              if (C[Ka] = g === "@-webkit-scope" ? "-webkit-" : "", C[Ta] = n, A) {
                const L = A.split(/\s+to\s+/);
                L[0] && L[0][0] === "(" && L[0][L[0].length - 1] === ")" && (C[fe] = L[0].slice(1, -1)), L[1] && L[1][0] === "(" && L[1][L[1].length - 1] === ")" && (C[_e] = L[1].slice(1, -1));
              }
              u ? (u.type === at.mediaRule || u.type === at.containerRule || u.type === at.supportsRule) && u.cssRules.push(C) : s.push(C), u = C;
              break;
            default:
              const D = new Wy(T, r, this);
              D[Ta] = n, u = D;
              break;
          }
        } else if (u && u.type === at.keyframesRule) {
          const m = new U2(T, r, this);
          let g = f.trim();
          g === "from" ? g = "0%" : g === "to" && (g = "100%"), m[yh] = g, m[Ta] = n, m[tf] = u, u.cssRules.push(m), u = m;
        } else if (u && (u.type === at.mediaRule || u.type === at.containerRule || u.type === at.supportsRule)) {
          if (this.validateSelectorText(f)) {
            const m = new Wy(T, r, this);
            m[gg] = f, m[Ta] = n, m[tf] = u, u.cssRules.push(m), u = m;
          }
        } else if (this.validateSelectorText(f)) {
          const m = new Wy(T, r, this);
          m[gg] = f, m[Ta] = n, m[tf] = u, u || s.push(m), u = m;
        }
        u && o.push(u);
      } else {
        if (u) {
          const f = i.substring(l, h.index).trim().replace(/([^;])$/, "$1;");
          switch (u.type) {
            case at.fontFaceRule:
            case at.keyframeRule:
            case at.styleRule:
              u[za] = f;
              break;
          }
        }
        o.pop(), u = o[o.length - 1] || null;
      }
      l = h.index + 1;
    }
    return s;
  }
  /**
   * Validates a selector text.
   *
   * @see https://www.w3.org/TR/CSS21/syndata.html#rule-sets
   * @param selectorText Selector text.
   * @returns True if valid, false otherwise.
   */
  validateSelectorText(e) {
    try {
      Gy.getSelectorGroups(e);
    } catch {
      return !1;
    }
    return !0;
  }
}
let MUe = class {
  cssRules = [];
  // TODO: MediaList is not fully implemented.
  media;
  title;
  alternate;
  disabled;
  #e = null;
  /**
   * Constructor.
   *
   * @param [options] Options.
   * @param [options.media] Media.
   * @param [options.title] Title.
   * @param [options.alternate] Alternate.
   * @param [options.disabled] Disabled.
   */
  constructor(e) {
    this.media = e && e.media ? e.media : "", this.title = e && e.title ? e.title : "", this.alternate = e && e.alternate ? e.alternate : !1, this.disabled = e && e.disabled ? e.disabled : !1;
  }
  /**
   * Inserts a rule.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet/insertRule
   * @param rule Rule.
   * @param [index] Index.
   * @returns The newly inserterted rule's index.
   */
  insertRule(e, n) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'insertRule' on 'CSSStyleSheet': 1 argument required, but only 0 present.");
    const i = new sM(this).parseFromString(e);
    if (i.length === 0 || i.length > 1)
      throw new this[b].DOMException(`Failed to execute 'insertRule' on 'CSSStyleSheet': Failed to parse the rule '${e}'.`, ne.syntaxError);
    if (n !== void 0) {
      if (n > this.cssRules.length)
        throw new this[b].DOMException(`Failed to execute 'insertRule' on 'CSSStyleSheet': The index provided (${n}) is larger than the maximum index (${this.cssRules.length - 1}).`, ne.indexSizeError);
      return this.cssRules.splice(n, 0, i[0]), n;
    }
    const s = this.cssRules.length;
    return this.cssRules.push(i[0]), s;
  }
  /**
   * Removes a rule.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet/deleteRule
   * @param index Index.
   */
  deleteRule(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'deleteRule' on 'CSSStyleSheet': 1 argument required, but only 0 present.");
    this.cssRules.splice(e, 1);
  }
  /**
   * Replaces all CSS rules.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet/replace
   * @param text CSS text.
   * @returns Promise.
   */
  async replace(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'replace' on 'CSSStyleSheet': 1 argument required, but only 0 present.");
    this.replaceSync(e);
  }
  /**
   * Replaces all CSS rules.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet/replaceSync
   * @param text CSS text.
   */
  replaceSync(e) {
    if (arguments.length === 0)
      throw new this[b].TypeError("Failed to execute 'replaceSync' on 'CSSStyleSheet': 1 argument required, but only 0 present.");
    this.#e !== e && (this.#e = e, this.cssRules = new sM(this).parseFromString(e));
  }
}, q2 = class extends Xr {
  // Internal properties
  [F] = /* @__PURE__ */ new Map();
  /* eslint-disable jsdoc/require-jsdoc */
  get onloadstart() {
    return this[F].get("onloadstart") ?? null;
  }
  set onloadstart(e) {
    this[F].set("onloadstart", e);
  }
  get onprogress() {
    return this[F].get("onprogress") ?? null;
  }
  set onprogress(e) {
    this[F].set("onprogress", e);
  }
  get onabort() {
    return this[F].get("onabort") ?? null;
  }
  set onabort(e) {
    this[F].set("onabort", e);
  }
  get onerror() {
    return this[F].get("onerror") ?? null;
  }
  set onerror(e) {
    this[F].set("onerror", e);
  }
  get onload() {
    return this[F].get("onload") ?? null;
  }
  set onload(e) {
    this[F].set("onload", e);
  }
  get ontimeout() {
    return this[F].get("ontimeout") ?? null;
  }
  set ontimeout(e) {
    this[F].set("ontimeout", e);
  }
  get onloadend() {
    return this[F].get("onloadend") ?? null;
  }
  set onloadend(e) {
    this[F].set("onloadend", e);
  }
}, OUe = class extends q2 {
}, BUe = class {
  // Public properties
  signal = new this[b].AbortSignal();
  /**
   * Aborts the signal.
   *
   * @param [reason] Reason.
   */
  abort(e) {
    this.signal[Hl](e);
  }
}, $Ue = class extends Xr {
  // Internal properties
  [xr] = !1;
  [mo] = void 0;
  // Events
  onabort = null;
  /**
   * Constructor.
   */
  constructor() {
    if (super(), !this[b])
      throw new TypeError("Failed to construct 'AbortSignal': Illegal constructor");
  }
  /**
   * Return a default description for the AbortSignal class.
   */
  get [Symbol.toStringTag]() {
    return "AbortSignal";
  }
  /**
   * Returns true if the signal has been aborted.
   *
   * @returns True if the signal has been aborted.
   */
  get aborted() {
    return this[xr];
  }
  /**
   * Setter for aborted. Value will be ignored as the property is read-only.
   *
   * @param _value Aborted.
   */
  set aborted(e) {
  }
  /**
   * Returns the reason the signal was aborted.
   *
   * @returns Reason.
   */
  get reason() {
    return this[mo];
  }
  /**
   * Setter for reason. Value will be ignored as the property is read-only.
   *
   * @param _value Reason.
   */
  set reason(e) {
  }
  /**
   * Aborts the signal.
   *
   * @param [reason] Reason.
   */
  [Hl](e) {
    this.aborted || (this[mo] = e !== void 0 ? e : new this[b].DOMException("signal is aborted without reason", ne.abortError), this[xr] = !0, this.dispatchEvent(new be("abort")));
  }
  /**
   * Throws an "AbortError" if the signal has been aborted.
   */
  throwIfAborted() {
    if (this.aborted)
      throw this.reason;
  }
  /**
   * Returns an AbortSignal instance that has been set as aborted.
   *
   * @param [reason] Reason.
   * @returns AbortSignal instance.
   */
  static abort(e) {
    const n = new this();
    return n[mo] = e !== void 0 ? e : new this[b].DOMException("signal is aborted without reason", ne.abortError), n[xr] = !0, n;
  }
  /**
   * Returns an AbortSignal that will automatically abort after a specified
   * time.
   *
   * @param [time] Time in milliseconds.
   * @returns AbortSignal instance.
   */
  static timeout(e) {
    const n = this[b], r = new this();
    return n.setTimeout(() => {
      r[Hl](new n.DOMException("signal timed out", ne.timeoutError));
    }, e), r;
  }
  /**
   * Takes an iterable of abort signals and returns an AbortSignal that is
   * aborted when any of the input iterable abort signals are aborted.
   *
   * The abort reason will be set to the reason of the first signal that is
   * aborted. If any of the given abort signals are already aborted then so will
   * be the returned AbortSignal.
   *
   * @param [signals] Iterable of abort signals.
   * @returns AbortSignal instance.
   */
  static any(e) {
    for (const s of e)
      if (s[xr])
        return this.abort(s[mo]);
    const n = new this(), r = /* @__PURE__ */ new Map(), i = () => {
      for (const s of e)
        s.removeEventListener("abort", r.get(s));
    };
    for (const s of e) {
      const a = () => {
        i(), n[Hl](s[mo]);
      };
      r.set(s, a), s.addEventListener("abort", a);
    }
    return n;
  }
}, HUe = class extends Xr {
  state;
  onchange = null;
  /**
   * Constructor.
   *
   * @param [state] State.
   */
  constructor(e = "granted") {
    super(), this.state = e;
  }
};
var hx;
(function(t) {
  t[t.unsent = 0] = "unsent", t[t.opened = 1] = "opened", t[t.headersReceived = 2] = "headersReceived", t[t.loading = 3] = "loading", t[t.done = 4] = "done";
})(hx || (hx = {}));
const fr = hx;
var dx;
(function(t) {
  t.arraybuffer = "arraybuffer", t.blob = "blob", t.document = "document", t.json = "json", t.text = "text";
})(dx || (dx = {}));
const Rl = dx;
class aM {
  /**
   * Parses response.
   *
   * @param options Options.
   * @param options.window Window.
   * @param [options.responseType] Response type.
   * @param [options.data] Data.
   * @param [options.contentType] Content type.
   * @returns Parsed response.
   **/
  static parse(e) {
    if (!e.data)
      return "";
    switch (e.responseType) {
      case Rl.arraybuffer:
        const n = new ArrayBuffer(e.data.length), r = new Uint8Array(n);
        return r.set(e.data), r;
      case Rl.blob:
        try {
          return new e.window.Blob([new Uint8Array(e.data)], {
            type: e.contentType || ""
          });
        } catch {
        }
        return null;
      case Rl.document:
        const i = e.window, s = new i.DOMParser();
        try {
          return s.parseFromString(e.data.toString(), "application/xml");
        } catch {
        }
        return null;
      case Rl.json:
        try {
          return JSON.parse(e.data.toString());
        } catch {
        }
        return null;
      case Rl.text:
      default:
        return e.data.toString();
    }
  }
}
let UUe = class extends q2 {
  // Constants
  static UNSENT = fr.unsent;
  static OPENED = fr.opened;
  static HEADERS_RECEIVED = fr.headersReceived;
  static LOADING = fr.loading;
  static DONE = fr.done;
  // Public properties
  upload = new this[b].XMLHttpRequestUpload();
  withCredentials = !1;
  // Private properties
  #e = !0;
  #t = null;
  #n = !1;
  #r = null;
  #i = null;
  #s = "";
  #u = null;
  #l = Buffer.from([]);
  #o = fr.unsent;
  #c = null;
  /**
   * Constructor.
   */
  constructor() {
    if (super(), !this[b])
      throw new TypeError(`Failed to construct '${this.constructor.name}': '${this.constructor.name}' was constructed outside a Window context.`);
  }
  /**
   * Returns the status.
   *
   * @returns Status.
   */
  get status() {
    return this.#i?.status || 0;
  }
  /**
   * Returns the status text.
   *
   * @returns Status text.
   */
  get statusText() {
    return this.#i?.statusText || "";
  }
  /**
   * Returns the response.
   *
   * @returns Response.
   */
  get response() {
    return this.#i ? this.#u : "";
  }
  /**
   * Get the response text.
   *
   * @throws {DOMException} If the response type is not text or empty.
   * @returns The response text.
   */
  get responseText() {
    if (this.responseType !== Rl.text && this.responseType !== "")
      throw new this[b].DOMException(`Failed to read the 'responseText' property from 'XMLHttpRequest': The value is only accessible if the object's 'responseType' is '' or 'text' (was '${this.responseType}').`, ne.invalidStateError);
    return this.#u !== null ? this.#u : this.readyState === fr.headersReceived || this.readyState === fr.loading ? this.#l.toString() ?? "" : "";
  }
  /**
   * Get the responseXML.
   *
   * @throws {DOMException} If the response type is not text or empty.
   * @returns Response XML.
   */
  get responseXML() {
    if (this.responseType !== Rl.document && this.responseType !== "")
      throw new this[b].DOMException(`Failed to read the 'responseXML' property from 'XMLHttpRequest': The value is only accessible if the object's 'responseType' is '' or 'document' (was '${this.responseType}').`, ne.invalidStateError);
    return this.responseType === "" ? null : this.#u;
  }
  /**
   * Returns the response URL.
   *
   * @returns Response URL.
   */
  get responseURL() {
    return this.#i?.url || "";
  }
  /**
   * Returns the ready state.
   *
   * @returns Ready state.
   */
  get readyState() {
    return this.#o;
  }
  /**
   * Set response type.
   *
   * @param type Response type.
   * @throws {DOMException} If the state is not unsent or opened.
   * @throws {DOMException} If the request is synchronous.
   */
  set responseType(e) {
    if (this.readyState !== fr.opened && this.readyState !== fr.unsent)
      throw new this[b].DOMException("Failed to set the 'responseType' property on 'XMLHttpRequest': The object's state must be OPENED or UNSENT.", ne.invalidStateError);
    if (!this.#e)
      throw new this[b].DOMException("Failed to set the 'responseType' property on 'XMLHttpRequest': The response type cannot be changed for synchronous requests made from a document.", ne.invalidStateError);
    this.#s = e;
  }
  /**
   * Get response Type.
   *
   * @returns Response type.
   */
  get responseType() {
    return this.#s;
  }
  /**
   * Opens the connection.
   *
   * @param method Connection method (eg GET, POST).
   * @param url URL for the connection.
   * @param [async=true] Asynchronous connection.
   * @param [user] Username for basic authentication (optional).
   * @param [password] Password for basic authentication (optional).
   */
  open(e, n, r = !0, i, s) {
    const a = this[b];
    if (!r && this.responseType && this.responseType !== Rl.text)
      throw new a.DOMException("Failed to execute 'open' on 'XMLHttpRequest': Synchronous requests from a document must not set a response type.", ne.invalidAccessError);
    const o = new this[b].Headers();
    if (i) {
      const u = Buffer.from(`${i}:${s || ""}`);
      o.set("Authorization", "Basic " + u.toString("base64"));
    }
    this.#e = r, this.#n = !1, this.#i = null, this.#u = null, this.#l = Buffer.from([]), this.#t = new a.AbortController(), this.#r = new a.Request(n, {
      method: e,
      headers: o,
      signal: this.#t.signal,
      credentials: this.withCredentials ? "include" : "same-origin"
    }), this.#o = fr.opened;
  }
  /**
   * Sets a header for the request.
   *
   * @param name Header name.
   * @param value Header value.
   * @returns Header added.
   */
  setRequestHeader(e, n) {
    if (this.readyState !== fr.opened)
      throw new this[b].DOMException("Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.", ne.invalidStateError);
    return VA.isHeaderForbidden(e) ? !1 : (this.#r.headers.set(e, n), !0);
  }
  /**
   * Gets a header from the server response.
   *
   * @param header header Name of header to get.
   * @returns string Text of the header or null if it doesn't exist.
   */
  getResponseHeader(e) {
    return this.#i?.headers.get(e) ?? null;
  }
  /**
   * Gets all the response headers.
   *
   * @returns A string with all response headers separated by CR+LF.
   */
  getAllResponseHeaders() {
    if (!this.#i)
      return "";
    const e = [];
    for (const [n, r] of this.#i?.headers) {
      const i = n.toLowerCase();
      i !== "set-cookie" && i !== "set-cookie2" && e.push(`${n}: ${r}`);
    }
    return e.join(`\r
`);
  }
  /**
   * Sends the request to the server.
   *
   * @param body Optional data to send as request body.
   */
  send(e) {
    const n = this[b];
    if (this.readyState != fr.opened)
      throw new this[b].DOMException("Failed to execute 'send' on 'XMLHttpRequest': Connection must be opened before send() is called.", ne.invalidStateError);
    typeof e == "object" && e !== null && e[ve] === le.documentNode && (e = new n.XMLSerializer().serializeToString(e)), this.#e ? this.#h(e).catch((r) => {
      throw r;
    }) : this.#d(e);
  }
  /**
   * Aborts a request.
   */
  abort() {
    this.#n || (this.#n = !0, this.#t.abort());
  }
  /**
   * Overrides the MIME type returned by the server.
   * This method must be called before send().
   *
   * @param mimeType The MIME type to use instead of the one specified by the server.
   * @throws {DOMException} If the request state is LOADING or DONE.
   */
  overrideMimeType(e) {
    if (this.readyState === fr.loading || this.readyState === fr.done)
      throw new this[b].DOMException("Failed to execute 'overrideMimeType' on 'XMLHttpRequest': MIME type cannot be overridden when the request state is LOADING or DONE.", ne.invalidStateError);
    this.#c = e;
  }
  /**
   * Sends the request to the server asynchronously.
   *
   * @param body Optional data to send as request body.
   */
  async #h(e) {
    const n = this[b], r = new pt(n).getBrowserFrame();
    if (!r)
      return;
    const i = r[xt], s = i.startTask(() => this.abort());
    this.#o = fr.loading, this.#a(new be("readystatechange")), this.#a(new be("loadstart")), e && (this.#r = new n.Request(this.#r.url, {
      method: this.#r.method,
      headers: this.#r.headers,
      signal: this.#t.signal,
      credentials: this.#r.credentials,
      body: e
    })), this.#t.signal.addEventListener("abort", () => {
      this.#n = !0, this.#o = fr.unsent, this.#a(new be("abort")), this.#a(new be("loadend")), this.#a(new be("readystatechange")), i.endTask(s);
    });
    const a = (f) => {
      if (f instanceof Tr && f.name === ne.abortError) {
        if (this.#n)
          return;
        this.#o = fr.unsent, this.#a(new be("abort"));
      } else
        this.#o = fr.done, this.#a(new V1("error", { error: f, message: f.message }));
      this.#a(new be("loadend")), this.#a(new be("readystatechange")), i.endTask(s);
    }, o = new cu({
      browserFrame: r,
      window: n,
      url: this.#r.url,
      init: this.#r
    });
    try {
      this.#i = await o.send();
    } catch (f) {
      a(f);
      return;
    }
    this.#o = fr.headersReceived, this.#a(new be("readystatechange"));
    const u = this.#i.headers.get("Content-Length"), l = u !== null && !isNaN(Number(u)) ? Number(u) : null;
    let h = 0;
    if (this.#i.body) {
      let f;
      try {
        for await (const m of this.#i.body) {
          const g = typeof m == "string" ? Buffer.from(m) : m;
          this.#l = Buffer.concat([this.#l, g]), h += m.length;
          try {
            this.#a(new kl("progress", {
              lengthComputable: l !== null,
              loaded: h,
              total: l !== null ? l : 0
            }));
          } catch (A) {
            throw f = A, A;
          }
        }
      } catch (m) {
        if (m === f)
          throw m;
        a(m);
        return;
      }
    }
    this.#u = aM.parse({
      window: n,
      responseType: this.#s,
      data: this.#l,
      contentType: this.#c || this.#i.headers.get("Content-Type") || this.#r.headers.get("Content-Type")
    }), this.#o = fr.done, this.#l = Buffer.from([]), i.endTask(s), this.#a(new be("readystatechange")), this.#a(new be("load")), this.#a(new be("loadend"));
  }
  /**
   * Sends the request to the server synchronously.
   *
   * @param body Optional data to send as request body.
   */
  #d(e) {
    const n = this[b], r = new pt(n).getBrowserFrame();
    if (!r)
      return;
    e && (this.#r = new n.Request(this.#r.url, {
      method: this.#r.method,
      headers: this.#r.headers,
      signal: this.#t.signal,
      credentials: this.#r.credentials,
      body: e
    })), this.#o = fr.loading;
    const i = new af({
      browserFrame: r,
      window: n,
      url: this.#r.url,
      init: this.#r
    });
    try {
      this.#i = i.send();
    } catch (s) {
      this.#o = fr.done, this.#a(new V1("error", { error: s, message: s.message })), this.#a(new be("loadend")), this.#a(new be("readystatechange"));
      return;
    }
    this.#o = fr.headersReceived, this.#u = aM.parse({
      window: n,
      responseType: this.#s,
      data: this.#i.body,
      contentType: this.#c || this.#i.headers.get("Content-Type") || this.#r.headers.get("Content-Type")
    }), this.#o = fr.done, this.#a(new be("readystatechange")), this.#a(new be("load")), this.#a(new be("loadend"));
  }
  /**
   * Dispatches an event with try/catch.
   *
   * This is necessary to prevent errors from setting XMLHttpRequest in an invalid state.
   *
   * @param event Event.
   */
  #a(e) {
    const n = new pt(this[b]).getBrowserFrame();
    if (!n?.page?.context?.browser?.settings?.errorCapture)
      return;
    const r = n.page.context.browser.settings, i = r.errorCapture;
    r.errorCapture = Rr.tryAndCatch, this.dispatchEvent(e), r.errorCapture = i;
  }
};
const GUe = /<([^\s/!>?]+)|<\/([^\s/!>?]+)\s*>|(<!--)|(-->)|(<!)|(<\?)|(\/>)|(>)/gm, WUe = /\s*([a-zA-Z0-9-_:]+)\s*=\s*"([^"]*)("{0,1})|\s*([a-zA-Z0-9-_:]+)\s*=\s*'([^']*)('{0,1})/gm, oM = /^\s*([a-zA-Z0-9-_:]+)$/, VUe = /version="[^"]+"/, KUe = /"([^"]+)"/gm, Fm = /\s+/, zUe = /\n/g;
var Gt;
(function(t) {
  t.any = "any", t.startTag = "startTag", t.comment = "comment", t.documentType = "documentType", t.processingInstruction = "processingInstruction", t.error = "error";
})(Gt || (Gt = {}));
const jUe = Object.values(xn);
class YUe {
  window;
  rootNode = null;
  nodeStack = [];
  tagNameStack = [];
  defaultNamespaceStack = null;
  namespacePrefixStack = null;
  startTagIndex = 0;
  markupRegExp = null;
  lastIndex = 0;
  errorIndex = 0;
  nextElement = null;
  nextTagName = null;
  currentNode = null;
  readState = Gt.any;
  errorMessage = null;
  /**
   * Constructor.
   *
   * @param window Window.
   */
  constructor(e) {
    this.window = e;
  }
  /**
   * Parses XML and returns an XML document containing nodes found.
   *
   * @param xml XML string.
   * @returns XML document.
   */
  parse(e) {
    this.rootNode = new this.window.XMLDocument(), this.nodeStack = [this.rootNode], this.tagNameStack = [null], this.currentNode = this.rootNode, this.readState = Gt.any, this.defaultNamespaceStack = [null], this.namespacePrefixStack = [null], this.startTagIndex = 0, this.errorIndex = 0, this.errorMessage = null, this.markupRegExp = new RegExp(GUe, "gm"), this.lastIndex = 0;
    let n;
    for (this.rootNode[lu] = this.window, e = String(e); n = this.markupRegExp.exec(e); ) {
      switch (this.readState) {
        case Gt.any:
          n.index !== this.lastIndex && (n[1] || n[2] || n[3] || n[4] || n[5] !== void 0 || n[6]) && this.parsePlainText(e.substring(this.lastIndex, n.index)), n[1] ? this.parseStartTag(n[1]) : n[2] ? this.parseEndTag(n[2]) || (this.errorMessage = `Opening and ending tag mismatch: ${this.tagNameStack[this.tagNameStack.length - 1]} line ${e.substring(0, this.startTagIndex).split(`
`).length} and ${n[2]}
`, this.errorIndex = this.markupRegExp.lastIndex, this.readState = Gt.error, this.removeOverflowingTextNodes()) : n[3] ? (this.startTagIndex = this.markupRegExp.lastIndex, this.readState = Gt.comment) : n[5] !== void 0 ? (this.startTagIndex = this.markupRegExp.lastIndex, this.readState = Gt.documentType) : n[6] ? (this.startTagIndex = this.markupRegExp.lastIndex, this.readState = Gt.processingInstruction) : this.parsePlainText(e.substring(this.lastIndex, this.markupRegExp.lastIndex));
          break;
        case Gt.startTag:
          if (n[7] || n[8]) {
            const r = e.substring(this.startTagIndex, n[2] ? this.markupRegExp.lastIndex - 1 : n.index), i = !!n[7];
            this.parseEndOfStartTag(r, i);
          } else
            this.errorMessage = n[2] && this.lastIndex !== this.startTagIndex ? `Unescaped '&lt;' not allowed in attributes values
` : `error parsing attribute name
`, this.errorIndex = n.index, this.readState = Gt.error, this.removeOverflowingTextNodes();
          break;
        case Gt.comment:
          n[4] && this.parseComment(e.substring(this.startTagIndex, n.index));
          break;
        case Gt.documentType:
          (n[7] || n[8]) && this.parseDocumentType(e.substring(this.startTagIndex, n.index));
          break;
        case Gt.processingInstruction:
          (n[7] || n[8]) && this.parseProcessingInstruction(e.substring(this.startTagIndex, n.index));
          break;
        case Gt.error:
          return this.parseError(e.slice(0, this.errorIndex), this.errorMessage), this.rootNode;
      }
      this.lastIndex = this.markupRegExp.lastIndex;
    }
    return this.readState === Gt.error ? (this.parseError(e.slice(0, this.errorIndex), this.errorMessage), this.rootNode) : this.readState === Gt.comment ? (this.parseError(e, `Comment not terminated
`), this.removeOverflowingTextNodes(), this.rootNode) : this.rootNode[Ft].length === 0 ? (this.parseError("", "Start tag expected, '&lt;' not found"), this.rootNode) : (this.lastIndex !== e.length && this.currentNode && this.parsePlainText(e.substring(this.lastIndex)), this.nodeStack.length !== 1 ? (this.parseError(e, this.nextElement ? `attributes construct error
` : `Premature end of data in tag article line 1
`), this.rootNode) : this.rootNode);
  }
  /**
   * Parses plain text.
   *
   * @param text Text.
   */
  parsePlainText(e) {
    this.currentNode === this.rootNode ? e.replace(Fm, "") && (this.errorMessage = `Extra content at the end of the document
`, this.errorIndex = this.lastIndex, this.readState = Gt.error) : e.includes("&nbsp;") ? (this.errorMessage = `Entity 'nbsp' not defined
`, this.errorIndex = this.lastIndex + e.indexOf("&nbsp;") + 6, this.readState = Gt.error) : this.currentNode[Ht](this.rootNode.createTextNode(hi.decodeXMLEntities(e)), !0);
  }
  /**
   * Parses processing instruction.
   *
   * @param text Text.
   */
  parseProcessingInstruction(e) {
    const n = this.markupRegExp, r = e.split(Fm), i = e[e.length - 1] === "?";
    if (r[0] === "xml")
      if (this.currentNode !== this.rootNode || this.rootNode[Re].length !== 0 || r.length === 1)
        this.errorMessage = `XML declaration allowed only at the start of the document
`, this.errorIndex = n.lastIndex - e.length + 2, this.readState = Gt.error, this.removeOverflowingTextNodes();
      else if (!VUe.test(r[1]))
        this.errorMessage = `Malformed declaration expecting version
`, this.errorIndex = n.lastIndex - e.length + 3, this.readState = Gt.error;
      else if (!i)
        this.errorMessage = `Blank needed here
`, this.errorIndex = n.lastIndex - 1, this.readState = Gt.error;
      else {
        const s = r[0], a = r.slice(1).join(" ").slice(0, -1);
        this.rootNode[Hg] = this.rootNode.createProcessingInstruction(s, a), this.readState = Gt.any;
      }
    else if (r.length === 1 && !i)
      this.errorMessage = `ParsePI: PI processing-instruction space expected
`, this.errorIndex = n.lastIndex - 1, this.readState = Gt.error;
    else if (r.length > 1 && !i)
      this.errorMessage = `ParsePI: PI processing-instruction never end ...
`, this.errorIndex = n.lastIndex - 1, this.readState = Gt.error;
    else {
      const s = r[0], a = r.slice(1).join(" ").slice(0, -1);
      this.currentNode[Ht](this.rootNode.createProcessingInstruction(s, a), !0), this.readState = Gt.any;
    }
  }
  /**
   * Parses comment.
   *
   * @param comment Comment.
   */
  parseComment(e) {
    this.currentNode !== this.rootNode && this.currentNode[Ht](this.rootNode.createComment(hi.decodeXMLEntities(e)), !0), this.readState = Gt.any;
  }
  /**
   * Parses document type.
   *
   * @param text Text.
   */
  parseDocumentType(e) {
    const n = this.markupRegExp;
    if (this.currentNode === this.rootNode && this.rootNode[Re].length === 0) {
      const r = this.getDocumentType(hi.decodeXMLEntities(e));
      r?.name ? (this.rootNode[Ht](this.window.document.implementation.createDocumentType(r.name, r.publicId, r.systemId), !0), this.readState = Gt.any) : r ? (this.errorMessage = `xmlParseDocTypeDecl : no DOCTYPE name
`, this.errorIndex = n.lastIndex - e.length - 2, this.readState = Gt.error) : (this.errorMessage = `StartTag: invalid element name
`, this.errorIndex = n.lastIndex - e.length - 2, this.readState = Gt.error);
    } else this.currentNode === this.rootNode && this.rootNode[Ft].length === 1 ? (this.errorMessage = `Extra content at the end of the document
`, this.errorIndex = n.lastIndex - e.length - 2, this.readState = Gt.error) : (this.errorMessage = `StartTag: invalid element name
`, this.errorIndex = n.lastIndex - e.length - 2, this.readState = Gt.error);
  }
  /**
   * Parses start tag.
   *
   * @param tagName Tag name.
   */
  parseStartTag(e) {
    const n = e.split(":"), r = this.namespacePrefixStack, i = this.defaultNamespaceStack;
    n.length > 1 ? this.nextElement = this.rootNode.createElementNS(r[r.length - 1]?.get(n[0]) || null, e) : this.nextElement = this.rootNode.createElementNS(i[i.length - 1] || null, e), r.push(new Map(r[r.length - 1])), this.nextTagName = e, this.startTagIndex = this.markupRegExp.lastIndex, this.readState = Gt.startTag;
  }
  /**
   * Parses end of start tag.
   *
   * @param attributeString Attribute string.
   * @param isSelfClosed Is self closed.
   */
  parseEndOfStartTag(e, n) {
    const r = this.namespacePrefixStack[this.namespacePrefixStack.length - 1];
    if (e) {
      const i = new RegExp(WUe, "gm");
      let s, a = 0;
      for (; s = i.exec(e); ) {
        const u = e.substring(a, s.index).replace(Fm, "");
        if (u.length) {
          const l = u.match(oM);
          this.errorMessage = l ? `Specification mandates value for attribute ${l[1]}
` : `attributes construct error
`, this.errorIndex = this.startTagIndex, this.readState = Gt.error, this.removeOverflowingTextNodes();
          return;
        }
        if (s[1] && s[3] === '"' || s[4] && s[6] === "'") {
          const l = s[1] ?? s[4], h = s[2] ?? s[5], f = h ? hi.decodeXMLAttributeValue(h.replace(zUe, " ")) : "", m = this.nextElement[bt], g = l.split(":");
          if (g.length > 2 || g.length === 2 && (!g[0] || !g[1])) {
            this.errorMessage = `Failed to parse QName '${l}'
`, this.errorIndex = this.startTagIndex + s.index + s[0].split("=")[0].length, this.readState = Gt.error;
            return;
          }
          let A = null;
          switch (g[0]) {
            case "xmlns":
              A = xn.xmlns;
              break;
            case "xlink":
              A = xn.xlink;
              break;
          }
          if (m.getNamedItemNS(A, g[1] ?? l))
            this.errorMessage = `Attribute ${l} redefined
`, this.errorIndex = this.startTagIndex, this.readState = Gt.error;
          else {
            const E = Gi.createNode(this.rootNode, this.window.Attr);
            if (E[je] = A, E[tt] = l, E[Tt] = A && g[1] ? g[1] : l, E[pn] = A && g[1] ? g[0] : null, E[ze] = f, m[mc](E), E[pn] === "xmlns")
              r.set(E[Tt], f), this.nextElement[pn] === E[Tt] && (this.nextElement[je] = f);
            else if (l === "xmlns" && !this.nextElement[pn])
              if (jUe.includes(f)) {
                this.nextElement = this.rootNode.createElementNS(f, this.nextElement[Xe]), this.nextElement[bt] = m, m[zt] = this.nextElement;
                for (const w of m[Ge].values())
                  w[zt] = this.nextElement;
              } else
                this.nextElement[je] = f;
          }
          this.startTagIndex += s[0].length;
        } else if (s[1] && s[3] !== '"' || s[4] && s[6] !== "'")
          return;
        a = i.lastIndex;
      }
      const o = e.substring(a).replace(Fm, "");
      if (o.length) {
        const u = o.match(oM);
        u ? (this.errorMessage = `Specification mandates value for attribute ${u[1]}
`, this.errorIndex = this.markupRegExp.lastIndex - 2) : (this.errorMessage = `attributes construct error
`, this.errorIndex = this.startTagIndex), this.readState = Gt.error, this.removeOverflowingTextNodes();
        return;
      }
    }
    if (this.nextElement[pn] && !this.nextElement[je]) {
      this.errorMessage = `Namespace prefix ${this.nextElement[pn]} on name is not defined
`, this.errorIndex = this.lastIndex, this.readState = Gt.error;
      return;
    }
    if (this.currentNode === this.rootNode && this.rootNode[Ft].length !== 0) {
      this.errorMessage = `Extra content at the end of the document
`, this.errorIndex = this.lastIndex - this.nextElement[Xe].length - 1, this.readState = Gt.error;
      return;
    }
    this.currentNode[Ht](this.nextElement, !0), n || (this.currentNode = this.nextElement, this.nodeStack.push(this.currentNode), this.tagNameStack.push(this.nextTagName), this.currentNode[je] && !this.currentNode[pn] ? this.defaultNamespaceStack.push(this.currentNode[je]) : this.defaultNamespaceStack.push(this.defaultNamespaceStack[this.defaultNamespaceStack.length - 1])), this.nextElement = null, this.nextTagName = null, this.readState = Gt.any, this.startTagIndex = this.markupRegExp.lastIndex;
  }
  /**
   * Parses end tag.
   *
   * @param tagName Tag name.
   * @returns True if the end tag was parsed, false otherwise.
   */
  parseEndTag(e) {
    return this.tagNameStack[this.tagNameStack.length - 1] === e ? (this.nodeStack.pop(), this.tagNameStack.pop(), this.namespacePrefixStack.pop(), this.defaultNamespaceStack.pop(), this.currentNode = this.nodeStack[this.nodeStack.length - 1] || this.rootNode, !0) : !1;
  }
  /**
   * Parses XML document error.
   *
   * @param readXML XML that has been read.
   * @param errorMessage Error message.
   */
  parseError(e, n) {
    let r = this.rootNode.documentElement;
    if (!r) {
      const u = this.rootNode.createElementNS(xn.html, "html"), l = this.rootNode.createElementNS(xn.html, "body");
      u.appendChild(l), r = l, this.rootNode[Ht](u, !0);
    }
    const i = e.split(`
`), s = i[i.length - 1].length + 1, a = `error on line ${i.length} at column ${s}: ${n || "Unknown error"}`, o = this.rootNode.createElementNS(xn.html, "parsererror");
    o.setAttribute("style", "display: block; white-space: pre; border: 2px solid #c77; padding: 0 1em 0 1em; margin: 1em; background-color: #fdd; color: black"), o.innerHTML = `<h3>This page contains the following errors:</h3><div style="font-family:monospace;font-size:12px">${a}</div><h3>Below is a rendering of the page up to the first error.</h3>`, r.insertBefore(o, r.firstChild);
  }
  /**
   * Removes overflowing text nodes in the current node.
   *
   * This needs to be done for some errors.
   */
  removeOverflowingTextNodes() {
    if (this.currentNode && this.currentNode !== this.rootNode)
      for (; this.currentNode.lastChild?.[ve] === ot.TEXT_NODE; )
        this.currentNode.removeChild(this.currentNode.lastChild);
  }
  /**
   * Returns document type.
   *
   * @param value Value.
   * @returns Document type.
   */
  getDocumentType(e) {
    if (!e.toUpperCase().startsWith("DOCTYPE"))
      return null;
    const n = e.split(Fm);
    if (n.length <= 1)
      return null;
    const r = n.slice(1).join(" "), i = [], s = new RegExp(KUe, "gm"), a = r.toUpperCase().includes("PUBLIC");
    let o;
    for (; o = s.exec(r); )
      i.push(o[1]);
    const u = a && i[0] || "", l = a ? i[1] || "" : i[0] || "";
    return {
      name: n[1].toLowerCase(),
      publicId: u,
      systemId: l
    };
  }
}
let qUe = class {
  /**
   * Parses HTML and returns a root element.
   *
   * @param string HTML data.
   * @param mimeType Mime type.
   * @returns Root element.
   */
  parseFromString(e, n) {
    if (!n)
      throw new this[b].DOMException('Second parameter "mimeType" is mandatory.');
    const r = this[b];
    switch (n) {
      case "text/html":
        const i = new r.HTMLDocument();
        return i[lu] = r, new hu(this[b]).parse(e, i);
      case "image/svg+xml":
      case "text/xml":
      case "application/xml":
      case "application/xhtml+xml":
        return new YUe(this[b]).parse(e);
      default:
        throw new r.DOMException(`Unknown mime type "${n}".`);
    }
  }
};
var fx;
(function(t) {
  t[t.endToEnd = 2] = "endToEnd", t[t.endToStart = 3] = "endToStart", t[t.startToEnd = 1] = "startToEnd", t[t.startToStart = 0] = "startToStart";
})(fx || (fx = {}));
const ti = fx;
let JUe = class {
  static END_TO_END = ti.endToEnd;
  static END_TO_START = ti.endToStart;
  static START_TO_END = ti.startToEnd;
  static START_TO_START = ti.startToStart;
  END_TO_END = ti.endToEnd;
  END_TO_START = ti.endToStart;
  START_TO_END = ti.startToEnd;
  START_TO_START = ti.startToStart;
  [fe];
  [_e];
  [he];
  /**
   * Constructor.
   *
   * @param window Window.
   */
  constructor() {
    const e = this[b];
    if (!e)
      throw new TypeError(`Failed to construct '${this.constructor.name}': '${this.constructor.name}' was constructed outside a Window context.`);
    this[he] = e.document, this[fe] = { node: e.document, offset: 0 }, this[_e] = { node: e.document, offset: 0 };
  }
  /**
   * Returns start container.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-startcontainer
   * @returns Start container.
   */
  get startContainer() {
    return this[fe].node;
  }
  /**
   * Returns end container.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-endcontainer
   * @returns End container.
   */
  get endContainer() {
    return this[_e].node;
  }
  /**
   * Returns start offset.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-startoffset
   * @returns Start offset.
   */
  get startOffset() {
    if (this[fe].offset > 0) {
      const e = dt.getNodeLength(this[fe].node);
      this[fe].offset > e && (this[fe].offset = e);
    }
    return this[fe].offset;
  }
  /**
   * Returns end offset.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-endoffset
   * @returns End offset.
   */
  get endOffset() {
    if (this[_e].offset > 0) {
      const e = dt.getNodeLength(this[_e].node);
      this[_e].offset > e && (this[_e].offset = e);
    }
    return this[_e].offset;
  }
  /**
   * Returns a boolean value indicating whether the range's start and end points are at the same position.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-collapsed
   * @returns Collapsed.
   */
  get collapsed() {
    return this[fe].node === this[_e].node && this.startOffset === this.endOffset;
  }
  /**
   * Returns the deepest Node that contains the startContainer and endContainer nodes.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-commonancestorcontainer
   * @returns Node.
   */
  get commonAncestorContainer() {
    let e = this[fe].node;
    for (; e; ) {
      if (dt.isInclusiveAncestor(e, this[_e].node))
        return e;
      e = e[xe];
    }
    return null;
  }
  /**
   * Returns -1, 0, or 1 depending on whether the referenceNode is before, the same as, or after the Range.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-collapse
   * @param toStart A boolean value: true collapses the Range to its start, false to its end. If omitted, it defaults to false.
   */
  collapse(e = !1) {
    e ? this[_e] = Object.assign({}, this[fe]) : this[fe] = Object.assign({}, this[_e]);
  }
  /**
   * Compares the boundary points of the Range with those of another range.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-compareboundarypoints
   * @param how How.
   * @param sourceRange Range.
   * @returns A number, -1, 0, or 1, indicating whether the corresponding boundary-point of the Range is respectively before, equal to, or after the corresponding boundary-point of sourceRange.
   */
  compareBoundaryPoints(e, n) {
    if (e !== ti.startToStart && e !== ti.startToEnd && e !== ti.endToEnd && e !== ti.endToStart)
      throw new this[b].DOMException(`The comparison method provided must be one of '${ti.startToStart}', '${ti.startToEnd}', '${ti.endToEnd}' or '${ti.endToStart}'.`, ne.notSupportedError);
    if (this[he] !== n[he])
      throw new this[b].DOMException("The two Ranges are not in the same tree.", ne.wrongDocumentError);
    const r = {
      node: null,
      offset: 0
    }, i = {
      node: null,
      offset: 0
    };
    switch (e) {
      case ti.startToStart:
        r.node = this[fe].node, r.offset = this.startOffset, i.node = n[fe].node, i.offset = n.startOffset;
        break;
      case ti.startToEnd:
        r.node = this[_e].node, r.offset = this.endOffset, i.node = n[fe].node, i.offset = n.startOffset;
        break;
      case ti.endToEnd:
        r.node = this[_e].node, r.offset = this.endOffset, i.node = n[_e].node, i.offset = n.endOffset;
        break;
      case ti.endToStart:
        r.node = this[fe].node, r.offset = this.startOffset, i.node = n[_e].node, i.offset = n.endOffset;
        break;
    }
    return Un.compareBoundaryPointsPosition(r, i);
  }
  /**
   * Returns -1, 0, or 1 depending on whether the referenceNode is before, the same as, or after the Range.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-comparepoint
   * @param node Reference node.
   * @param offset Offset.
   * @returns -1,0, or 1.
   */
  comparePoint(e, n) {
    if (e[he] !== this[he])
      throw new this[b].DOMException("The two Ranges are not in the same tree.", ne.wrongDocumentError);
    Un.validateBoundaryPoint({ node: e, offset: n });
    const r = { node: e, offset: n };
    return Un.compareBoundaryPointsPosition(r, {
      node: this[fe].node,
      offset: this.startOffset
    }) === -1 ? -1 : Un.compareBoundaryPointsPosition(r, {
      node: this[_e].node,
      offset: this.endOffset
    }) === 1 ? 1 : 0;
  }
  /**
   * Returns a DocumentFragment copying the objects of type Node included in the Range.
   *
   * @see https://dom.spec.whatwg.org/#concept-range-clone
   * @returns Document fragment.
   */
  cloneContents() {
    const e = this[b], n = this[he].createDocumentFragment(), r = this.startOffset, i = this.endOffset;
    if (this.collapsed)
      return n;
    if (this[fe].node === this[_e].node && (this[fe].node[ve] === le.textNode || this[fe].node[ve] === le.processingInstructionNode || this[fe].node[ve] === le.commentNode)) {
      const l = this[fe].node.cloneNode(!1);
      return l[Dn] = l.substringData(r, i - r), n.appendChild(l), n;
    }
    let s = this[fe].node;
    for (; !dt.isInclusiveAncestor(s, this[_e].node); )
      s = s[xe];
    let a = null;
    if (!dt.isInclusiveAncestor(this[fe].node, this[_e].node)) {
      let l = s.firstChild;
      for (; !a; )
        Un.isPartiallyContained(l, this) && (a = l), l = l.nextSibling;
    }
    let o = null;
    if (!dt.isInclusiveAncestor(this[_e].node, this[fe].node)) {
      let l = s.lastChild;
      for (; !o; )
        Un.isPartiallyContained(l, this) && (o = l), l = l.previousSibling;
    }
    const u = [];
    for (const l of s[Re])
      if (Un.isContained(l, this)) {
        if (l[ve] === le.documentTypeNode)
          throw new e.DOMException("Invalid document type element.", ne.hierarchyRequestError);
        u.push(l);
      }
    if (a !== null && (a[ve] === le.textNode || a[ve] === le.processingInstructionNode || a[ve] === le.commentNode)) {
      const l = this[fe].node.cloneNode(!1);
      l[Dn] = l.substringData(r, dt.getNodeLength(this[fe].node) - r), n.appendChild(l);
    } else if (a !== null) {
      const l = a.cloneNode();
      n.appendChild(l);
      const h = new e.Range();
      h[fe].node = this[fe].node, h[fe].offset = r, h[_e].node = a, h[_e].offset = dt.getNodeLength(a);
      const f = h.cloneContents();
      l.appendChild(f);
    }
    for (const l of u) {
      const h = l.cloneNode(!0);
      n.appendChild(h);
    }
    if (o !== null && (o[ve] === le.textNode || o[ve] === le.processingInstructionNode || o[ve] === le.commentNode)) {
      const l = this[_e].node.cloneNode(!1);
      l[Dn] = l.substringData(0, i), n.appendChild(l);
    } else if (o !== null) {
      const l = o.cloneNode(!1);
      n.appendChild(l);
      const h = new e.Range();
      h[fe].node = o, h[fe].offset = 0, h[_e].node = this[_e].node, h[_e].offset = i;
      const f = h.cloneContents();
      l.appendChild(f);
    }
    return n;
  }
  /**
   * Returns a Range object with boundary points identical to the cloned Range.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-clonerange
   * @returns Range.
   */
  cloneRange() {
    const e = new this[b].Range();
    return e[fe].node = this[fe].node, e[fe].offset = this[fe].offset, e[_e].node = this[_e].node, e[_e].offset = this[_e].offset, e;
  }
  /**
   * Returns a DocumentFragment by invoking the HTML fragment parsing algorithm or the XML fragment parsing algorithm with the start of the range (the parent of the selected node) as the context node. The HTML fragment parsing algorithm is used if the range belongs to a Document whose HTMLness bit is set. In the HTML case, if the context node would be html, for historical reasons the fragment parsing algorithm is invoked with body as the context instead.
   *
   * @see https://w3c.github.io/DOM-Parsing/#dfn-fragment-parsing-algorithm
   * @param tagString Tag string.
   * @returns Document fragment.
   */
  createContextualFragment(e) {
    return new hu(this[b]).parse(e);
  }
  /**
   * Removes the contents of the Range from the Document.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-deletecontents
   */
  deleteContents() {
    const e = this.startOffset, n = this.endOffset;
    if (this.collapsed)
      return;
    if (this[fe].node === this[_e].node && (this[fe].node[ve] === le.textNode || this[fe].node[ve] === le.processingInstructionNode || this[fe].node[ve] === le.commentNode)) {
      this[fe].node.replaceData(e, n - e, "");
      return;
    }
    const r = [];
    let i = this[fe].node;
    const s = dt.nextDescendantNode(this[_e].node);
    for (; i && i !== s; )
      Un.isContained(i, this) && !Un.isContained(i[xe], this) && r.push(i), i = dt.following(i);
    let a, o;
    if (dt.isInclusiveAncestor(this[fe].node, this[_e].node))
      a = this[fe].node, o = e;
    else {
      let u = this[fe].node;
      for (; u && !dt.isInclusiveAncestor(u[xe], this[_e].node); )
        u = u[xe];
      a = u[xe], o = u[xe][Re].indexOf(u) + 1;
    }
    (this[fe].node[ve] === le.textNode || this[fe].node[ve] === le.processingInstructionNode || this[fe].node[ve] === le.commentNode) && this[fe].node.replaceData(this.startOffset, dt.getNodeLength(this[fe].node) - this.startOffset, "");
    for (const u of r)
      u[xe].removeChild(u);
    (this[_e].node[ve] === le.textNode || this[_e].node[ve] === le.processingInstructionNode || this[_e].node[ve] === le.commentNode) && this[_e].node.replaceData(0, n, ""), this[fe].node = a, this[fe].offset = o, this[_e].node = a, this[_e].offset = o;
  }
  /**
   * Does nothing. It used to disable the Range object and enable the browser to release associated resources. The method has been kept for compatibility.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-detach
   */
  detach() {
  }
  /**
   * Moves contents of the Range from the document tree into a DocumentFragment.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-extractcontents
   * @returns Document fragment.
   */
  extractContents() {
    const e = this[b], n = this[he].createDocumentFragment(), r = this.startOffset, i = this.endOffset;
    if (this.collapsed)
      return n;
    if (this[fe].node === this[_e].node && (this[fe].node[ve] === le.textNode || this[fe].node[ve] === le.processingInstructionNode || this[fe].node[ve] === le.commentNode)) {
      const f = this[fe].node.cloneNode(!1);
      return f[Dn] = f.substringData(r, i - r), n.appendChild(f), this[fe].node.replaceData(r, i - r, ""), n;
    }
    let s = this[fe].node;
    for (; !dt.isInclusiveAncestor(s, this[_e].node); )
      s = s[xe];
    let a = null;
    if (!dt.isInclusiveAncestor(this[fe].node, this[_e].node)) {
      let f = s.firstChild;
      for (; !a; )
        Un.isPartiallyContained(f, this) && (a = f), f = f.nextSibling;
    }
    let o = null;
    if (!dt.isInclusiveAncestor(this[_e].node, this[fe].node)) {
      let f = s.lastChild;
      for (; !o; )
        Un.isPartiallyContained(f, this) && (o = f), f = f.previousSibling;
    }
    const u = [];
    for (const f of s[Re])
      if (Un.isContained(f, this)) {
        if (f[ve] === le.documentTypeNode)
          throw new this[b].DOMException("Invalid document type element.", ne.hierarchyRequestError);
        u.push(f);
      }
    let l, h;
    if (dt.isInclusiveAncestor(this[fe].node, this[_e].node))
      l = this[fe].node, h = r;
    else {
      let f = this[fe].node;
      for (; f && !dt.isInclusiveAncestor(f[xe], this[_e].node); )
        f = f[xe];
      l = f[xe], h = f[xe][Re].indexOf(f) + 1;
    }
    if (a !== null && (a[ve] === le.textNode || a[ve] === le.processingInstructionNode || a[ve] === le.commentNode)) {
      const f = this[fe].node.cloneNode(!1);
      f[Dn] = f.substringData(r, dt.getNodeLength(this[fe].node) - r), n.appendChild(f), this[fe].node.replaceData(r, dt.getNodeLength(this[fe].node) - r, "");
    } else if (a !== null) {
      const f = a.cloneNode(!1);
      n.appendChild(f);
      const m = new e.Range();
      m[fe].node = this[fe].node, m[fe].offset = r, m[_e].node = a, m[_e].offset = dt.getNodeLength(a);
      const g = m.extractContents();
      f.appendChild(g);
    }
    for (const f of u)
      n.appendChild(f);
    if (o !== null && (o[ve] === le.textNode || o[ve] === le.processingInstructionNode || o[ve] === le.commentNode)) {
      const f = this[_e].node.cloneNode(!1);
      f[Dn] = f.substringData(0, i), n.appendChild(f), this[_e].node.replaceData(0, i, "");
    } else if (o !== null) {
      const f = o.cloneNode(!1);
      n.appendChild(f);
      const m = new e.Range();
      m[fe].node = o, m[fe].offset = 0, m[_e].node = this[_e].node, m[_e].offset = i;
      const g = m.extractContents();
      f.appendChild(g);
    }
    return this[fe].node = l, this[fe].offset = h, this[_e].node = l, this[_e].offset = h, n;
  }
  /**
   * Returns a DOMRect object that bounds the contents of the range; this is a rectangle enclosing the union of the bounding rectangles for all the elements in the range.
   *
   * @returns DOMRect object.
   */
  getBoundingClientRect() {
    return new Of();
  }
  /**
   * The Range.getClientRects() method returns a list of DOMRect objects representing the area of the screen occupied by the range. This is created by aggregating the results of calls to Element.getClientRects() for all the elements in the range.
   *
   * @returns DOMRect objects.
   */
  getClientRects() {
    return new hW(T);
  }
  /**
   * Returns a boolean indicating whether the given point is in the Range.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-ispointinrange
   * @param node Reference node.
   * @param offset Offset.
   * @returns "true" if in range.
   */
  isPointInRange(e, n = 0) {
    if (e[he] !== this[he])
      return !1;
    const r = { node: e, offset: n };
    return Un.validateBoundaryPoint(r), !(Un.compareBoundaryPointsPosition(r, {
      node: this[fe].node,
      offset: this.startOffset
    }) === -1 || Un.compareBoundaryPointsPosition(r, {
      node: this[_e].node,
      offset: this.endOffset
    }) === 1);
  }
  /**
   * Inserts a node at the start of the Range.
   *
   * @see https://dom.spec.whatwg.org/#concept-range-insert
   * @param newNode New node.
   */
  insertNode(e) {
    if (this[fe].node[ve] === le.processingInstructionNode || this[fe].node[ve] === le.commentNode || this[fe].node[ve] === le.textNode && !this[fe].node[xe] || e === this[fe].node)
      throw new this[b].DOMException("Invalid start node.", ne.hierarchyRequestError);
    let n = this[fe].node[ve] === le.textNode ? this[fe].node : this[fe].node[Re][this.startOffset] || null;
    const r = n ? n[xe] : this[fe].node;
    this[fe].node[ve] === le.textNode && (n = this[fe].node.splitText(this.startOffset)), e === n && (n = n.nextSibling);
    const i = e[xe];
    i && i.removeChild(e);
    let s = n ? n[xe][Re].indexOf(n) : dt.getNodeLength(r);
    s += e[ve] === le.documentFragmentNode ? dt.getNodeLength(e) : 1, r.insertBefore(e, n), this.collapsed && (this[_e].node = r, this[_e].offset = s);
  }
  /**
   * Returns a boolean indicating whether the given Node intersects the Range.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-intersectsnode
   * @param node Reference node.
   * @returns "true" if it intersects.
   */
  intersectsNode(e) {
    if (e[he] !== this[he])
      return !1;
    const n = e[xe];
    if (!n)
      return !0;
    const r = n[Re].indexOf(e);
    return Un.compareBoundaryPointsPosition({ node: n, offset: r }, { node: this[_e].node, offset: this.endOffset }) === -1 && Un.compareBoundaryPointsPosition({ node: n, offset: r + 1 }, { node: this[fe].node, offset: this.startOffset }) === 1;
  }
  /**
   * Sets the Range to contain the Node and its contents.
   *
   * @see https://dom.spec.whatwg.org/#concept-range-select
   * @param node Reference node.
   */
  selectNode(e) {
    if (!e[xe])
      throw new this[b].DOMException("The given Node has no parent.", ne.invalidNodeTypeError);
    const n = e[xe][Re].indexOf(e);
    this[fe].node = e[xe], this[fe].offset = n, this[_e].node = e[xe], this[_e].offset = n + 1;
  }
  /**
   * Sets the Range to contain the contents of a Node.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-selectnodecontents
   * @param node Reference node.
   */
  selectNodeContents(e) {
    if (e[ve] === le.documentTypeNode)
      throw new this[b].DOMException("DocumentType Node can't be used as boundary point.", ne.invalidNodeTypeError);
    this[fe].node = e, this[fe].offset = 0, this[_e].node = e, this[_e].offset = dt.getNodeLength(e);
  }
  /**
   * Sets the end position of a Range to be located at the given offset into the specified node x.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-setend
   * @param node End node.
   * @param offset End offset.
   */
  setEnd(e, n = 0) {
    Un.validateBoundaryPoint({ node: e, offset: n });
    const r = { node: e, offset: n };
    (e[he] !== this[he] || Un.compareBoundaryPointsPosition(r, {
      node: this[fe].node,
      offset: this.startOffset
    }) === -1) && (this[fe].node = e, this[fe].offset = n), this[_e].node = e, this[_e].offset = n;
  }
  /**
   * Sets the start position of a Range.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-setstart
   * @param node Start node.
   * @param offset Start offset.
   */
  setStart(e, n = 0) {
    Un.validateBoundaryPoint({ node: e, offset: n });
    const r = { node: e, offset: n };
    (e[he] !== this[he] || Un.compareBoundaryPointsPosition(r, {
      node: this[_e].node,
      offset: this.endOffset
    }) === 1) && (this[_e].node = e, this[_e].offset = n), this[fe].node = e, this[fe].offset = n;
  }
  /**
   * Sets the end position of a Range relative to another Node.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-setendafter
   * @param node Reference node.
   */
  setEndAfter(e) {
    if (!e[xe])
      throw new this[b].DOMException("The given Node has no parent.", ne.invalidNodeTypeError);
    this.setEnd(e[xe], e[xe][Re].indexOf(e) + 1);
  }
  /**
   * Sets the end position of a Range relative to another Node.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-setendbefore
   * @param node Reference node.
   */
  setEndBefore(e) {
    if (!e[xe])
      throw new this[b].DOMException("The given Node has no parent.", ne.invalidNodeTypeError);
    this.setEnd(e[xe], e[xe][Re].indexOf(e));
  }
  /**
   * Sets the start position of a Range relative to a Node.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-setstartafter
   * @param node Reference node.
   */
  setStartAfter(e) {
    if (!e[xe])
      throw new this[b].DOMException("The given Node has no parent.", ne.invalidNodeTypeError);
    this.setStart(e[xe], e[xe][Re].indexOf(e) + 1);
  }
  /**
   * Sets the start position of a Range relative to another Node.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-setstartbefore
   * @param node Reference node.
   */
  setStartBefore(e) {
    if (!e[xe])
      throw new this[b].DOMException("The given Node has no parent.", ne.invalidNodeTypeError);
    this.setStart(e[xe], e[xe][Re].indexOf(e));
  }
  /**
   * Moves content of the Range into a new node, placing the new node at the start of the specified range.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-surroundcontents
   * @param newParent New parent.
   */
  surroundContents(e) {
    let n = this.commonAncestorContainer;
    if (!n)
      return;
    const r = dt.nextDescendantNode(n);
    for (; n && n !== r; ) {
      if (n[ve] !== le.textNode && Un.isPartiallyContained(n, this))
        throw new this[b].DOMException("The Range has partially contains a non-Text node.", ne.invalidStateError);
      n = dt.following(n);
    }
    if (e[ve] === le.documentNode || e[ve] === le.documentTypeNode || e[ve] === le.documentFragmentNode)
      throw new this[b].DOMException("Invalid element type.", ne.invalidNodeTypeError);
    const i = this.extractContents();
    for (; e.firstChild; )
      e.removeChild(e.firstChild);
    this.insertNode(e), e.appendChild(i), this.selectNode(e);
  }
  /**
   * Returns the text of the Range.
   *
   * @see https://dom.spec.whatwg.org/#dom-range-stringifier
   */
  toString() {
    const e = this.startOffset, n = this.endOffset;
    let r = "";
    if (this[fe].node === this[_e].node && this[fe].node[ve] === le.textNode)
      return this[fe].node.data.slice(e, n);
    this[fe].node[ve] === le.textNode && (r += this[fe].node.data.slice(e));
    const i = dt.nextDescendantNode(this[_e].node);
    let s = this[fe].node;
    for (; s && s !== i; )
      s[ve] === le.textNode && Un.isContained(s, this) && (r += s.data), s = dt.following(s);
    return this[_e].node[ve] === le.textNode && (r += this[_e].node.data.slice(0, n)), r;
  }
}, NW = class extends Xr {
  // Public properties
  id = "";
  startTime = 0;
  endTime = 0;
  pauseOnExit = !1;
  // Internal properties
  [B1] = null;
  // Events
  onenter = null;
  onexit = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   */
  constructor(e) {
    if (super(), e !== T)
      throw new TypeError("Illegal constructor");
    if (!this[b])
      throw new TypeError(`Failed to construct '${this.constructor.name}': '${this.constructor.name}' was constructed outside a Window context.`);
  }
  /**
   * Returns the owner track.
   *
   * @returns TextTrack.
   */
  get track() {
    return this[B1];
  }
}, QUe = class extends NW {
  region = null;
  vertical = "";
  snapToLines = !0;
  line = 0;
  lineAlign = "";
  position = "auto";
  positionAlign = "auto";
  size = 100;
  align = "";
  text = "";
  /**
   * Constructor.
   *
   * @param startTime The start time for the cue.
   * @param endTime The end time for the cue.
   * @param text The text of the cue.
   */
  constructor(e, n, r) {
    super(T);
    const i = this[b];
    let s = 0;
    if (e !== void 0 && s++, n !== void 0 && s++, r !== void 0 && s++, s < 3)
      throw new i.TypeError(`Failed to construct 'VTTCue': 3 arguments required, but only ${s} present.`);
    if (e = Number(e), n = Number(n), isNaN(e) || isNaN(n))
      throw new i.TypeError("Failed to construct 'VTTCue': The provided double value is non-finite.");
    this.startTime = e, this.endTime = n, this.text = String(r);
  }
  /**
   * Returns the cue as HTML.
   *
   * @returns DocumentFragment
   */
  getCueAsHTML() {
    const e = this[b], n = e.document.createDocumentFragment();
    return n.appendChild(e.document.createTextNode(this.text)), n;
  }
}, XUe = class extends Xr {
  // Internal properties
  [Wu] = ih.subtitles;
  [$g] = "";
  [$1] = "";
  [Tv] = "";
  [Jr] = "disabled";
  [hd] = new lx(T);
  [FL] = new lx(T);
  // Events
  oncuechange = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   */
  constructor(e) {
    if (super(), e !== T)
      throw new TypeError("Illegal constructor");
    if (!this[b])
      throw new TypeError(`Failed to construct '${this.constructor.name}': '${this.constructor.name}' was constructed outside a Window context.`);
  }
  /**
   * Returns the kind of the text track.
   *
   * @returns Kind.
   */
  get kind() {
    return this[Wu];
  }
  /**
   * Returns the label of the text track.
   *
   * @returns Label.
   */
  get label() {
    return this[$g];
  }
  /**
   * Returns the language of the text track.
   *
   * @returns Language.
   */
  get language() {
    return this[$1];
  }
  /**
   * Returns the id of the text track.
   *
   * @returns Id.
   */
  get id() {
    return this[Tv];
  }
  /**
   * Returns the mode of the text track.
   *
   * @returns Mode.
   */
  get mode() {
    return this[Jr];
  }
  /**
   * Sets the mode of the text track.
   *
   * @param mode Mode.
   */
  set mode(e) {
    e !== "disabled" && e !== "showing" || (this[Jr] = e);
  }
  /**
   * Returns the list of cues in the track list.
   *
   * @returns List of cues.
   */
  get cues() {
    return this[Jr] === "disabled" ? null : this[hd];
  }
  /**
   * Returns the list of active cues in the track list.
   *
   * @returns List of active cues.
   */
  get activeCues() {
    return this[Jr] === "disabled" ? null : this[FL];
  }
  /**
   * Adds a cue to the track list.
   *
   * @param cue Text track cue.
   */
  addCue(e) {
    this[hd].includes(e) || (e[B1] = this, this[hd].push(e));
  }
  /**
   * Removes a cue from the track list.
   *
   * @param cue Text track cue.
   */
  removeCue(e) {
    const n = this[hd].indexOf(e);
    n !== -1 && (e[B1] = null, this[hd].splice(n, 1));
  }
}, ZUe = class DW extends Xr {
  // Internal properties
  [Ge] = [];
  // Events
  onaddtrack = null;
  onchange = null;
  onremovetrack = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param items Items.
   */
  constructor(e, n) {
    if (super(), e !== T)
      throw new TypeError("Illegal constructor");
    this[Ge] = n;
    const r = new Ws(this, [DW, Xr]);
    return new Proxy(this, {
      get: (i, s) => {
        if (s === "length")
          return n.length;
        if (s in i || typeof s == "symbol")
          return r.bind(s), i[s];
        const a = Number(s);
        if (!isNaN(a))
          return n[a];
      },
      set(i, s, a) {
        if (r.bind(s), typeof s == "symbol")
          return i[s] = a, !0;
        const o = Number(s);
        return isNaN(o) && (i[s] = a), !0;
      },
      deleteProperty(i, s) {
        if (typeof s == "symbol")
          return delete i[s], !0;
        const a = Number(s);
        return isNaN(a) && delete i[s], !0;
      },
      ownKeys() {
        return Object.keys(n);
      },
      has(i, s) {
        if (s in i)
          return !0;
        if (typeof s == "symbol")
          return !1;
        const a = Number(s);
        return !isNaN(a) && a >= 0 && a < n.length;
      },
      defineProperty(i, s, a) {
        return r.preventBinding(s), s in i ? (Object.defineProperty(i, s, a), !0) : !1;
      },
      getOwnPropertyDescriptor(i, s) {
        if (s in i || typeof s == "symbol")
          return;
        const a = Number(s);
        if (!isNaN(a) && n[a])
          return {
            value: n[a],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
  /**
   * Returns the number of TextTrack objects in the TextTrackList.
   *
   * @returns Number of TextTrack objects.
   */
  get length() {
    return this[Ge].length;
  }
  /**
   * Returns `Symbol.toStringTag`.
   *
   * @returns `Symbol.toStringTag`.
   */
  get [Symbol.toStringTag]() {
    return "TextTrackList";
  }
  /**
   * Returns `[object NodeList]`.
   *
   * @returns `[object NodeList]`.
   */
  toLocaleString() {
    return "[object TextTrackList]";
  }
  /**
   * Returns `[object NodeList]`.
   *
   * @returns `[object NodeList]`.
   */
  toString() {
    return "[object TextTrackList]";
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   *
   * @returns Iterator.
   */
  [Symbol.iterator]() {
    return this[Ge][Symbol.iterator]();
  }
  /**
   * Returns the TextTrack found within the TextTrackList whose id matches the specified string. If no match is found, null is returned.
   *
   * @param id Text track cue identifier.
   * @returns TextTrack.
   */
  getTrackById(e) {
    for (const n of this[Ge])
      if (n.id === e)
        return n;
    return null;
  }
}, eGe = class extends Xr {
  // Internal properties
  [TL] = "disconnected";
  // Events
  onconnecting = null;
  onconnect = null;
  ondisconnect = null;
  /**
   * Returns the state of the remote playback.
   */
  get state() {
    return this[TL];
  }
  /**
   * Watches the list of available remote playback devices and returns a Promise that resolves with a callbackId of an available remote playback device.
   *
   * @returns Promise.
   */
  async watchAvailability() {
  }
  /**
   * Cancels the request to monitor the availability of remote playback devices.
   */
  cancelWatchAvailability() {
  }
  /**
   * Prompts the user to select and give permission to connect to a remote playback device.
   */
  prompt() {
  }
};
var Du = {}, uM;
function jA() {
  return uM || (uM = 1, Du.removeLeadingAndTrailingHTTPWhitespace = (t) => t.replace(/^[ \t\n\r]+/u, "").replace(/[ \t\n\r]+$/u, ""), Du.removeTrailingHTTPWhitespace = (t) => t.replace(/[ \t\n\r]+$/u, ""), Du.isHTTPWhitespaceChar = (t) => t === " " || t === "	" || t === `
` || t === "\r", Du.solelyContainsHTTPTokenCodePoints = (t) => /^[-!#$%&'*+.^_`|~A-Za-z0-9]*$/u.test(t), Du.soleyContainsHTTPQuotedStringTokenCodePoints = (t) => /^[\t\u0020-\u007E\u0080-\u00FF]*$/u.test(t), Du.asciiLowercase = (t) => t.replace(/[A-Z]/ug, (e) => e.toLowerCase()), Du.collectAnHTTPQuotedString = (t, e) => {
    let n = "";
    for (e++; ; ) {
      for (; e < t.length && t[e] !== '"' && t[e] !== "\\"; )
        n += t[e], ++e;
      if (e >= t.length)
        break;
      const r = t[e];
      if (++e, r === "\\") {
        if (e >= t.length) {
          n += "\\";
          break;
        }
        n += t[e], ++e;
      } else
        break;
    }
    return [n, e];
  }), Du;
}
var VF, lM;
function tGe() {
  if (lM) return VF;
  lM = 1;
  const {
    asciiLowercase: t,
    solelyContainsHTTPTokenCodePoints: e,
    soleyContainsHTTPQuotedStringTokenCodePoints: n
  } = jA();
  return VF = class {
    constructor(i) {
      this._map = i;
    }
    get size() {
      return this._map.size;
    }
    get(i) {
      return i = t(String(i)), this._map.get(i);
    }
    has(i) {
      return i = t(String(i)), this._map.has(i);
    }
    set(i, s) {
      if (i = t(String(i)), s = String(s), !e(i))
        throw new Error(`Invalid MIME type parameter name "${i}": only HTTP token code points are valid.`);
      if (!n(s))
        throw new Error(`Invalid MIME type parameter value "${s}": only HTTP quoted-string token code points are valid.`);
      return this._map.set(i, s);
    }
    clear() {
      this._map.clear();
    }
    delete(i) {
      return i = t(String(i)), this._map.delete(i);
    }
    forEach(i, s) {
      this._map.forEach(i, s);
    }
    keys() {
      return this._map.keys();
    }
    values() {
      return this._map.values();
    }
    entries() {
      return this._map.entries();
    }
    [Symbol.iterator]() {
      return this._map[Symbol.iterator]();
    }
  }, VF;
}
var KF, cM;
function nGe() {
  if (cM) return KF;
  cM = 1;
  const {
    removeLeadingAndTrailingHTTPWhitespace: t,
    removeTrailingHTTPWhitespace: e,
    isHTTPWhitespaceChar: n,
    solelyContainsHTTPTokenCodePoints: r,
    soleyContainsHTTPQuotedStringTokenCodePoints: i,
    asciiLowercase: s,
    collectAnHTTPQuotedString: a
  } = jA();
  return KF = (o) => {
    o = t(o);
    let u = 0, l = "";
    for (; u < o.length && o[u] !== "/"; )
      l += o[u], ++u;
    if (l.length === 0 || !r(l) || u >= o.length)
      return null;
    ++u;
    let h = "";
    for (; u < o.length && o[u] !== ";"; )
      h += o[u], ++u;
    if (h = e(h), h.length === 0 || !r(h))
      return null;
    const f = {
      type: s(l),
      subtype: s(h),
      parameters: /* @__PURE__ */ new Map()
    };
    for (; u < o.length; ) {
      for (++u; n(o[u]); )
        ++u;
      let m = "";
      for (; u < o.length && o[u] !== ";" && o[u] !== "="; )
        m += o[u], ++u;
      if (m = s(m), u < o.length) {
        if (o[u] === ";")
          continue;
        ++u;
      }
      let g = null;
      if (o[u] === '"')
        for ([g, u] = a(o, u); u < o.length && o[u] !== ";"; )
          ++u;
      else {
        for (g = ""; u < o.length && o[u] !== ";"; )
          g += o[u], ++u;
        if (g = e(g), g === "")
          continue;
      }
      m.length > 0 && r(m) && i(g) && !f.parameters.has(m) && f.parameters.set(m, g);
    }
    return f;
  }, KF;
}
var zF, hM;
function rGe() {
  if (hM) return zF;
  hM = 1;
  const { solelyContainsHTTPTokenCodePoints: t } = jA();
  return zF = (e) => {
    let n = `${e.type}/${e.subtype}`;
    if (e.parameters.size === 0)
      return n;
    for (let [r, i] of e.parameters)
      n += ";", n += r, n += "=", (!t(i) || i.length === 0) && (i = i.replace(/(["\\])/ug, "\\$1"), i = `"${i}"`), n += i;
    return n;
  }, zF;
}
var jF, dM;
function iGe() {
  if (dM) return jF;
  dM = 1;
  const t = tGe(), e = nGe(), n = rGe(), {
    asciiLowercase: r,
    solelyContainsHTTPTokenCodePoints: i
  } = jA();
  return jF = class {
    constructor(a) {
      a = String(a);
      const o = e(a);
      if (o === null)
        throw new Error(`Could not parse MIME type string "${a}"`);
      this._type = o.type, this._subtype = o.subtype, this._parameters = new t(o.parameters);
    }
    static parse(a) {
      try {
        return new this(a);
      } catch {
        return null;
      }
    }
    get essence() {
      return `${this.type}/${this.subtype}`;
    }
    get type() {
      return this._type;
    }
    set type(a) {
      if (a = r(String(a)), a.length === 0)
        throw new Error("Invalid type: must be a non-empty string");
      if (!i(a))
        throw new Error(`Invalid type ${a}: must contain only HTTP token code points`);
      this._type = a;
    }
    get subtype() {
      return this._subtype;
    }
    set subtype(a) {
      if (a = r(String(a)), a.length === 0)
        throw new Error("Invalid subtype: must be a non-empty string");
      if (!i(a))
        throw new Error(`Invalid subtype ${a}: must contain only HTTP token code points`);
      this._subtype = a;
    }
    get parameters() {
      return this._parameters;
    }
    toString() {
      return n(this);
    }
    isJavaScript({ prohibitParameters: a = !1 } = {}) {
      switch (this._type) {
        case "text":
          switch (this._subtype) {
            case "ecmascript":
            case "javascript":
            case "javascript1.0":
            case "javascript1.1":
            case "javascript1.2":
            case "javascript1.3":
            case "javascript1.4":
            case "javascript1.5":
            case "jscript":
            case "livescript":
            case "x-ecmascript":
            case "x-javascript":
              return !a || this._parameters.size === 0;
            default:
              return !1;
          }
        case "application":
          switch (this._subtype) {
            case "ecmascript":
            case "javascript":
            case "x-ecmascript":
            case "x-javascript":
              return !a || this._parameters.size === 0;
            default:
              return !1;
          }
        default:
          return !1;
      }
    }
    isXML() {
      return this._subtype === "xml" && (this._type === "text" || this._type === "application") || this._subtype.endsWith("+xml");
    }
    isHTML() {
      return this._subtype === "html" && this._type === "text";
    }
  }, jF;
}
var sGe = iGe();
const aGe = /* @__PURE__ */ kh(sGe);
var mx;
(function(t) {
  t[t.empty = 0] = "empty", t[t.loading = 1] = "loading", t[t.done = 2] = "done";
})(mx || (mx = {}));
const bl = mx;
var gx;
(function(t) {
  t.buffer = "buffer", t.binaryString = "binaryString", t.dataURL = "dataURL", t.text = "text";
})(gx || (gx = {}));
const yl = gx;
var px;
(function(t) {
  t.abort = "abort", t.error = "error", t.load = "load", t.loadstart = "loadstart", t.loadend = "loadend", t.progress = "progress";
})(px || (px = {}));
const dd = px;
let oGe = class extends Xr {
  error = null;
  result = null;
  readyState = bl.empty;
  onabort = null;
  onerror = null;
  onload = null;
  onloadstart = null;
  onloadend = null;
  onprogress = null;
  #e = !1;
  #t = null;
  #n = null;
  /**
   * Constructor.
   */
  constructor() {
    if (super(), !this[b])
      throw new TypeError(`Failed to construct '${this.constructor.name}': '${this.constructor.name}' was constructed outside a Window context.`);
  }
  /**
   * Reads as ArrayBuffer.
   *
   * @param blob Blob.
   */
  readAsArrayBuffer(e) {
    if (!(e instanceof Di))
      throw new this[b].TypeError("Failed to execute 'readAsArrayBuffer' on 'FileReader': parameter 1 is not of type 'Blob'.");
    this.#r(e, yl.buffer);
  }
  /**
   * Reads as binary string.
   *
   * @param blob Blob.
   */
  readAsBinaryString(e) {
    if (!(e instanceof Di))
      throw new this[b].TypeError("Failed to execute 'readAsBinaryString' on 'FileReader': parameter 1 is not of type 'Blob'.");
    this.#r(e, yl.binaryString);
  }
  /**
   * Reads as data URL.
   *
   * @param blob Blob.
   */
  readAsDataURL(e) {
    if (!(e instanceof Di))
      throw new this[b].TypeError("Failed to execute 'readAsDataURL' on 'FileReader': parameter 1 is not of type 'Blob'.");
    this.#r(e, yl.dataURL);
  }
  /**
   * Reads as text.
   *
   * @param blob Blob.
   * @param [encoding] Encoding.
   */
  readAsText(e, n = null) {
    if (!(e instanceof Di))
      throw new this[b].TypeError("Failed to execute 'readAsText' on 'FileReader': parameter 1 is not of type 'Blob'.");
    this.#r(e, yl.text, n || "UTF-8");
  }
  /**
   * Aborts the file reader.
   */
  abort() {
    const e = this[b];
    if (this.#t && e.clearTimeout(this.#t), this.#n && e.clearTimeout(this.#n), this.readyState === bl.empty || this.readyState === bl.done) {
      this.result = null;
      return;
    }
    this.readyState === bl.loading && (this.readyState = bl.done, this.result = null), this.#e = !0, this.dispatchEvent(new kl(dd.abort)), this.dispatchEvent(new kl(dd.loadend));
  }
  /**
   * Reads a file.
   *
   * @param blob Blob.
   * @param format Format.
   * @param [encoding] Encoding.
   */
  #r(e, n, r = null) {
    const i = this[b];
    if (this.readyState === bl.loading)
      throw new i.DOMException("The object is in an invalid state.", ne.invalidStateError);
    this.readyState = bl.loading, this.#t = i.setTimeout(() => {
      if (this.#e) {
        this.#e = !1;
        return;
      }
      this.dispatchEvent(new kl(dd.loadstart));
      let s = e[En];
      s || (s = nr.alloc(0)), this.dispatchEvent(new kl(dd.loadstart, {
        lengthComputable: !isNaN(e.size),
        total: e.size,
        loaded: s.length
      })), this.#n = i.setTimeout(() => {
        if (this.#e) {
          this.#e = !1;
          return;
        }
        switch (n) {
          default:
          case yl.buffer: {
            this.result = new Uint8Array(s).buffer;
            break;
          }
          case yl.binaryString: {
            this.result = s.toString("binary");
            break;
          }
          case yl.dataURL: {
            const a = aGe.parse(e.type) || "application/octet-stream";
            this.result = `data:${a};base64,${s.toString("base64")}`;
            break;
          }
          case yl.text: {
            this.result = new TextDecoder(r || "UTF-8").decode(s);
            break;
          }
        }
        this.readyState = bl.done, this.dispatchEvent(new kl(dd.load)), this.dispatchEvent(new kl(dd.loadend));
      });
    });
  }
};
const uGe = {
  aspectRatio: {
    max: 300,
    min: 0.006666666666666667
  },
  deviceId: "",
  facingMode: [],
  frameRate: {
    max: 60,
    min: 0
  },
  height: {
    max: 150,
    min: 1
  },
  resizeMode: ["none", "crop-and-scale"],
  width: {
    max: 300,
    min: 1
  }
}, lGe = {
  deviceId: "",
  frameRate: 60,
  resizeMode: "none"
};
let IW = class extends Xr {
  contentHint = "";
  enabled = !0;
  id = _f.randomUUID();
  muted = !1;
  readyState = "live";
  label = "";
  [$g] = "";
  [Wu] = "video";
  [bm] = {};
  [$u] = JSON.parse(JSON.stringify(uGe));
  [Pd] = JSON.parse(JSON.stringify(lGe));
  // Events
  onended = null;
  onmute = null;
  onunmute = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   */
  constructor(e) {
    if (super(), e !== T)
      throw new TypeError("Illegal constructor");
    if (!this[b])
      throw new TypeError(`Failed to construct '${this.constructor.name}': '${this.constructor.name}' was constructed outside a Window context.`);
  }
  /**
   * Returns the kind of the track.
   *
   * @returns Kind.
   */
  get kind() {
    return this[Wu];
  }
  /**
   * Applies constraints.
   *
   * @param _constraints Constraints.
   * @param constraints
   */
  async applyConstraints(e) {
    this.#e(this[bm], e);
  }
  /**
   * Returns constraints.
   *
   * @returns Constraints.
   */
  getConstraints() {
    return this[bm];
  }
  /**
   * Returns capabilities.
   *
   * @returns Capabilities.
   */
  getCapabilities() {
    return this[$u];
  }
  /**
   * Returns settings.
   *
   * @returns Settings.
   */
  getSettings() {
    return this[Pd];
  }
  /**
   * Clones the track.
   *
   * @returns Clone.
   */
  clone() {
    const e = new this.constructor(T);
    return e[Wu] = this[Wu], e[bm] = this[bm], e[$u] = this[$u], e[Pd] = this[Pd], e.contentHint = this.contentHint, e.enabled = this.enabled, e.label = this.label, e.muted = this.muted, e.readyState = this.readyState, e;
  }
  /**
   * Stops the track.
   */
  stop() {
    this.readyState = "ended";
  }
  /**
   * Merges two objects.
   *
   * @param source Target.
   * @param target Source.
   */
  #e(e, n) {
    for (const r in n)
      n[r] !== null && typeof n[r] == "object" && !Array.isArray(n[r]) ? (typeof e[r] != "object" && (e[r] = {}), this.#e(e[r], n[r])) : e[r] = n[r];
  }
}, cGe = class extends IW {
  [ib];
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param canvas Canvas.
   */
  constructor(e, n) {
    super(e), this[ib] = n;
  }
  /**
   * Returns the canvas.
   *
   * @returns Canvas.
   */
  get canvas() {
    return this[ib];
  }
  /**
   * Requests a frame.
   */
  requestFrame() {
  }
  /**
   * Clones the track.
   *
   * @returns Clone.
   */
  clone() {
    const e = super.clone();
    return e[ib] = this.canvas, e;
  }
};
var bx;
(function(t) {
  t[t.connecting = 0] = "connecting", t[t.open = 1] = "open", t[t.closing = 2] = "closing", t[t.closed = 3] = "closed";
})(bx || (bx = {}));
const ks = bx;
var Tm = { exports: {} }, YF, fM;
function xc() {
  if (fM) return YF;
  fM = 1;
  const t = ["nodebuffer", "arraybuffer", "fragments"], e = typeof Blob < "u";
  return e && t.push("blob"), YF = {
    BINARY_TYPES: t,
    CLOSE_TIMEOUT: 3e4,
    EMPTY_BUFFER: Buffer.alloc(0),
    GUID: "258EAFA5-E914-47DA-95CA-C5AB0DC85B11",
    hasBlob: e,
    kForOnEventAttribute: /* @__PURE__ */ Symbol("kIsForOnEventAttribute"),
    kListener: /* @__PURE__ */ Symbol("kListener"),
    kStatusCode: /* @__PURE__ */ Symbol("status-code"),
    kWebSocket: /* @__PURE__ */ Symbol("websocket"),
    NOOP: () => {
    }
  }, YF;
}
const hGe = {}, dGe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hGe
}, Symbol.toStringTag, { value: "Module" })), fGe = /* @__PURE__ */ vt(dGe);
var mM;
function YA() {
  if (mM) return Tm.exports;
  mM = 1;
  const { EMPTY_BUFFER: t } = xc(), e = Buffer[Symbol.species];
  function n(o, u) {
    if (o.length === 0) return t;
    if (o.length === 1) return o[0];
    const l = Buffer.allocUnsafe(u);
    let h = 0;
    for (let f = 0; f < o.length; f++) {
      const m = o[f];
      l.set(m, h), h += m.length;
    }
    return h < u ? new e(l.buffer, l.byteOffset, h) : l;
  }
  function r(o, u, l, h, f) {
    for (let m = 0; m < f; m++)
      l[h + m] = o[m] ^ u[m & 3];
  }
  function i(o, u) {
    for (let l = 0; l < o.length; l++)
      o[l] ^= u[l & 3];
  }
  function s(o) {
    return o.length === o.buffer.byteLength ? o.buffer : o.buffer.slice(o.byteOffset, o.byteOffset + o.length);
  }
  function a(o) {
    if (a.readOnly = !0, Buffer.isBuffer(o)) return o;
    let u;
    return o instanceof ArrayBuffer ? u = new e(o) : ArrayBuffer.isView(o) ? u = new e(o.buffer, o.byteOffset, o.byteLength) : (u = Buffer.from(o), a.readOnly = !1), u;
  }
  if (Tm.exports = {
    concat: n,
    mask: r,
    toArrayBuffer: s,
    toBuffer: a,
    unmask: i
  }, !process.env.WS_NO_BUFFER_UTIL)
    try {
      const o = fGe;
      Tm.exports.mask = function(u, l, h, f, m) {
        m < 48 ? r(u, l, h, f, m) : o.mask(u, l, h, f, m);
      }, Tm.exports.unmask = function(u, l) {
        u.length < 32 ? i(u, l) : o.unmask(u, l);
      };
    } catch {
    }
  return Tm.exports;
}
var qF, gM;
function mGe() {
  if (gM) return qF;
  gM = 1;
  const t = /* @__PURE__ */ Symbol("kDone"), e = /* @__PURE__ */ Symbol("kRun");
  class n {
    /**
     * Creates a new `Limiter`.
     *
     * @param {Number} [concurrency=Infinity] The maximum number of jobs allowed
     *     to run concurrently
     */
    constructor(i) {
      this[t] = () => {
        this.pending--, this[e]();
      }, this.concurrency = i || 1 / 0, this.jobs = [], this.pending = 0;
    }
    /**
     * Adds a job to the queue.
     *
     * @param {Function} job The job to run
     * @public
     */
    add(i) {
      this.jobs.push(i), this[e]();
    }
    /**
     * Removes a job from the queue and runs it if possible.
     *
     * @private
     */
    [e]() {
      if (this.pending !== this.concurrency && this.jobs.length) {
        const i = this.jobs.shift();
        this.pending++, i(this[t]);
      }
    }
  }
  return qF = n, qF;
}
var JF, pM;
function qA() {
  if (pM) return JF;
  pM = 1;
  const t = Da, e = YA(), n = mGe(), { kStatusCode: r } = xc(), i = Buffer[Symbol.species], s = Buffer.from([0, 0, 255, 255]), a = /* @__PURE__ */ Symbol("permessage-deflate"), o = /* @__PURE__ */ Symbol("total-length"), u = /* @__PURE__ */ Symbol("callback"), l = /* @__PURE__ */ Symbol("buffers"), h = /* @__PURE__ */ Symbol("error");
  let f;
  class m {
    /**
     * Creates a PerMessageDeflate instance.
     *
     * @param {Object} [options] Configuration options
     * @param {(Boolean|Number)} [options.clientMaxWindowBits] Advertise support
     *     for, or request, a custom client window size
     * @param {Boolean} [options.clientNoContextTakeover=false] Advertise/
     *     acknowledge disabling of client context takeover
     * @param {Number} [options.concurrencyLimit=10] The number of concurrent
     *     calls to zlib
     * @param {(Boolean|Number)} [options.serverMaxWindowBits] Request/confirm the
     *     use of a custom server window size
     * @param {Boolean} [options.serverNoContextTakeover=false] Request/accept
     *     disabling of server context takeover
     * @param {Number} [options.threshold=1024] Size (in bytes) below which
     *     messages should not be compressed if context takeover is disabled
     * @param {Object} [options.zlibDeflateOptions] Options to pass to zlib on
     *     deflate
     * @param {Object} [options.zlibInflateOptions] Options to pass to zlib on
     *     inflate
     * @param {Boolean} [isServer=false] Create the instance in either server or
     *     client mode
     * @param {Number} [maxPayload=0] The maximum allowed message length
     */
    constructor(x, N, B) {
      if (this._maxPayload = B | 0, this._options = x || {}, this._threshold = this._options.threshold !== void 0 ? this._options.threshold : 1024, this._isServer = !!N, this._deflate = null, this._inflate = null, this.params = null, !f) {
        const P = this._options.concurrencyLimit !== void 0 ? this._options.concurrencyLimit : 10;
        f = new n(P);
      }
    }
    /**
     * @type {String}
     */
    static get extensionName() {
      return "permessage-deflate";
    }
    /**
     * Create an extension negotiation offer.
     *
     * @return {Object} Extension parameters
     * @public
     */
    offer() {
      const x = {};
      return this._options.serverNoContextTakeover && (x.server_no_context_takeover = !0), this._options.clientNoContextTakeover && (x.client_no_context_takeover = !0), this._options.serverMaxWindowBits && (x.server_max_window_bits = this._options.serverMaxWindowBits), this._options.clientMaxWindowBits ? x.client_max_window_bits = this._options.clientMaxWindowBits : this._options.clientMaxWindowBits == null && (x.client_max_window_bits = !0), x;
    }
    /**
     * Accept an extension negotiation offer/response.
     *
     * @param {Array} configurations The extension negotiation offers/reponse
     * @return {Object} Accepted configuration
     * @public
     */
    accept(x) {
      return x = this.normalizeParams(x), this.params = this._isServer ? this.acceptAsServer(x) : this.acceptAsClient(x), this.params;
    }
    /**
     * Releases all resources used by the extension.
     *
     * @public
     */
    cleanup() {
      if (this._inflate && (this._inflate.close(), this._inflate = null), this._deflate) {
        const x = this._deflate[u];
        this._deflate.close(), this._deflate = null, x && x(
          new Error(
            "The deflate stream was closed while data was being processed"
          )
        );
      }
    }
    /**
     *  Accept an extension negotiation offer.
     *
     * @param {Array} offers The extension negotiation offers
     * @return {Object} Accepted configuration
     * @private
     */
    acceptAsServer(x) {
      const N = this._options, B = x.find((P) => !(N.serverNoContextTakeover === !1 && P.server_no_context_takeover || P.server_max_window_bits && (N.serverMaxWindowBits === !1 || typeof N.serverMaxWindowBits == "number" && N.serverMaxWindowBits > P.server_max_window_bits) || typeof N.clientMaxWindowBits == "number" && !P.client_max_window_bits));
      if (!B)
        throw new Error("None of the extension offers can be accepted");
      return N.serverNoContextTakeover && (B.server_no_context_takeover = !0), N.clientNoContextTakeover && (B.client_no_context_takeover = !0), typeof N.serverMaxWindowBits == "number" && (B.server_max_window_bits = N.serverMaxWindowBits), typeof N.clientMaxWindowBits == "number" ? B.client_max_window_bits = N.clientMaxWindowBits : (B.client_max_window_bits === !0 || N.clientMaxWindowBits === !1) && delete B.client_max_window_bits, B;
    }
    /**
     * Accept the extension negotiation response.
     *
     * @param {Array} response The extension negotiation response
     * @return {Object} Accepted configuration
     * @private
     */
    acceptAsClient(x) {
      const N = x[0];
      if (this._options.clientNoContextTakeover === !1 && N.client_no_context_takeover)
        throw new Error('Unexpected parameter "client_no_context_takeover"');
      if (!N.client_max_window_bits)
        typeof this._options.clientMaxWindowBits == "number" && (N.client_max_window_bits = this._options.clientMaxWindowBits);
      else if (this._options.clientMaxWindowBits === !1 || typeof this._options.clientMaxWindowBits == "number" && N.client_max_window_bits > this._options.clientMaxWindowBits)
        throw new Error(
          'Unexpected or invalid parameter "client_max_window_bits"'
        );
      return N;
    }
    /**
     * Normalize parameters.
     *
     * @param {Array} configurations The extension negotiation offers/reponse
     * @return {Array} The offers/response with normalized parameters
     * @private
     */
    normalizeParams(x) {
      return x.forEach((N) => {
        Object.keys(N).forEach((B) => {
          let P = N[B];
          if (P.length > 1)
            throw new Error(`Parameter "${B}" must have only a single value`);
          if (P = P[0], B === "client_max_window_bits") {
            if (P !== !0) {
              const C = +P;
              if (!Number.isInteger(C) || C < 8 || C > 15)
                throw new TypeError(
                  `Invalid value for parameter "${B}": ${P}`
                );
              P = C;
            } else if (!this._isServer)
              throw new TypeError(
                `Invalid value for parameter "${B}": ${P}`
              );
          } else if (B === "server_max_window_bits") {
            const C = +P;
            if (!Number.isInteger(C) || C < 8 || C > 15)
              throw new TypeError(
                `Invalid value for parameter "${B}": ${P}`
              );
            P = C;
          } else if (B === "client_no_context_takeover" || B === "server_no_context_takeover") {
            if (P !== !0)
              throw new TypeError(
                `Invalid value for parameter "${B}": ${P}`
              );
          } else
            throw new Error(`Unknown parameter "${B}"`);
          N[B] = P;
        });
      }), x;
    }
    /**
     * Decompress data. Concurrency limited.
     *
     * @param {Buffer} data Compressed data
     * @param {Boolean} fin Specifies whether or not this is the last fragment
     * @param {Function} callback Callback
     * @public
     */
    decompress(x, N, B) {
      f.add((P) => {
        this._decompress(x, N, (C, D) => {
          P(), B(C, D);
        });
      });
    }
    /**
     * Compress data. Concurrency limited.
     *
     * @param {(Buffer|String)} data Data to compress
     * @param {Boolean} fin Specifies whether or not this is the last fragment
     * @param {Function} callback Callback
     * @public
     */
    compress(x, N, B) {
      f.add((P) => {
        this._compress(x, N, (C, D) => {
          P(), B(C, D);
        });
      });
    }
    /**
     * Decompress data.
     *
     * @param {Buffer} data Compressed data
     * @param {Boolean} fin Specifies whether or not this is the last fragment
     * @param {Function} callback Callback
     * @private
     */
    _decompress(x, N, B) {
      const P = this._isServer ? "client" : "server";
      if (!this._inflate) {
        const C = `${P}_max_window_bits`, D = typeof this.params[C] != "number" ? t.Z_DEFAULT_WINDOWBITS : this.params[C];
        this._inflate = t.createInflateRaw({
          ...this._options.zlibInflateOptions,
          windowBits: D
        }), this._inflate[a] = this, this._inflate[o] = 0, this._inflate[l] = [], this._inflate.on("error", E), this._inflate.on("data", A);
      }
      this._inflate[u] = B, this._inflate.write(x), N && this._inflate.write(s), this._inflate.flush(() => {
        const C = this._inflate[h];
        if (C) {
          this._inflate.close(), this._inflate = null, B(C);
          return;
        }
        const D = e.concat(
          this._inflate[l],
          this._inflate[o]
        );
        this._inflate._readableState.endEmitted ? (this._inflate.close(), this._inflate = null) : (this._inflate[o] = 0, this._inflate[l] = [], N && this.params[`${P}_no_context_takeover`] && this._inflate.reset()), B(null, D);
      });
    }
    /**
     * Compress data.
     *
     * @param {(Buffer|String)} data Data to compress
     * @param {Boolean} fin Specifies whether or not this is the last fragment
     * @param {Function} callback Callback
     * @private
     */
    _compress(x, N, B) {
      const P = this._isServer ? "server" : "client";
      if (!this._deflate) {
        const C = `${P}_max_window_bits`, D = typeof this.params[C] != "number" ? t.Z_DEFAULT_WINDOWBITS : this.params[C];
        this._deflate = t.createDeflateRaw({
          ...this._options.zlibDeflateOptions,
          windowBits: D
        }), this._deflate[o] = 0, this._deflate[l] = [], this._deflate.on("data", g);
      }
      this._deflate[u] = B, this._deflate.write(x), this._deflate.flush(t.Z_SYNC_FLUSH, () => {
        if (!this._deflate)
          return;
        let C = e.concat(
          this._deflate[l],
          this._deflate[o]
        );
        N && (C = new i(C.buffer, C.byteOffset, C.length - 4)), this._deflate[u] = null, this._deflate[o] = 0, this._deflate[l] = [], N && this.params[`${P}_no_context_takeover`] && this._deflate.reset(), B(null, C);
      });
    }
  }
  JF = m;
  function g(w) {
    this[l].push(w), this[o] += w.length;
  }
  function A(w) {
    if (this[o] += w.length, this[a]._maxPayload < 1 || this[o] <= this[a]._maxPayload) {
      this[l].push(w);
      return;
    }
    this[h] = new RangeError("Max payload size exceeded"), this[h].code = "WS_ERR_UNSUPPORTED_MESSAGE_LENGTH", this[h][r] = 1009, this.removeListener("data", A), this.reset();
  }
  function E(w) {
    if (this[a]._inflate = null, this[h]) {
      this[u](this[h]);
      return;
    }
    w[r] = 1007, this[u](w);
  }
  return JF;
}
var vm = { exports: {} };
const gGe = {}, pGe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gGe
}, Symbol.toStringTag, { value: "Module" })), bGe = /* @__PURE__ */ vt(pGe);
var bM;
function Ap() {
  if (bM) return vm.exports;
  bM = 1;
  const { isUtf8: t } = UQ, { hasBlob: e } = xc(), n = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    // 0 - 15
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    // 16 - 31
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    // 32 - 47
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    // 48 - 63
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    // 64 - 79
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    // 80 - 95
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    // 96 - 111
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    0
    // 112 - 127
  ];
  function r(a) {
    return a >= 1e3 && a <= 1014 && a !== 1004 && a !== 1005 && a !== 1006 || a >= 3e3 && a <= 4999;
  }
  function i(a) {
    const o = a.length;
    let u = 0;
    for (; u < o; )
      if ((a[u] & 128) === 0)
        u++;
      else if ((a[u] & 224) === 192) {
        if (u + 1 === o || (a[u + 1] & 192) !== 128 || (a[u] & 254) === 192)
          return !1;
        u += 2;
      } else if ((a[u] & 240) === 224) {
        if (u + 2 >= o || (a[u + 1] & 192) !== 128 || (a[u + 2] & 192) !== 128 || a[u] === 224 && (a[u + 1] & 224) === 128 || // Overlong
        a[u] === 237 && (a[u + 1] & 224) === 160)
          return !1;
        u += 3;
      } else if ((a[u] & 248) === 240) {
        if (u + 3 >= o || (a[u + 1] & 192) !== 128 || (a[u + 2] & 192) !== 128 || (a[u + 3] & 192) !== 128 || a[u] === 240 && (a[u + 1] & 240) === 128 || // Overlong
        a[u] === 244 && a[u + 1] > 143 || a[u] > 244)
          return !1;
        u += 4;
      } else
        return !1;
    return !0;
  }
  function s(a) {
    return e && typeof a == "object" && typeof a.arrayBuffer == "function" && typeof a.type == "string" && typeof a.stream == "function" && (a[Symbol.toStringTag] === "Blob" || a[Symbol.toStringTag] === "File");
  }
  if (vm.exports = {
    isBlob: s,
    isValidStatusCode: r,
    isValidUTF8: i,
    tokenChars: n
  }, t)
    vm.exports.isValidUTF8 = function(a) {
      return a.length < 24 ? i(a) : t(a);
    };
  else if (!process.env.WS_NO_UTF_8_VALIDATE)
    try {
      const a = bGe;
      vm.exports.isValidUTF8 = function(o) {
        return o.length < 32 ? i(o) : a(o);
      };
    } catch {
    }
  return vm.exports;
}
var QF, yM;
function RW() {
  if (yM) return QF;
  yM = 1;
  const { Writable: t } = Ti, e = qA(), {
    BINARY_TYPES: n,
    EMPTY_BUFFER: r,
    kStatusCode: i,
    kWebSocket: s
  } = xc(), { concat: a, toArrayBuffer: o, unmask: u } = YA(), { isValidStatusCode: l, isValidUTF8: h } = Ap(), f = Buffer[Symbol.species], m = 0, g = 1, A = 2, E = 3, w = 4, x = 5, N = 6;
  class B extends t {
    /**
     * Creates a Receiver instance.
     *
     * @param {Object} [options] Options object
     * @param {Boolean} [options.allowSynchronousEvents=true] Specifies whether
     *     any of the `'message'`, `'ping'`, and `'pong'` events can be emitted
     *     multiple times in the same tick
     * @param {String} [options.binaryType=nodebuffer] The type for binary data
     * @param {Object} [options.extensions] An object containing the negotiated
     *     extensions
     * @param {Boolean} [options.isServer=false] Specifies whether to operate in
     *     client or server mode
     * @param {Number} [options.maxPayload=0] The maximum allowed message length
     * @param {Boolean} [options.skipUTF8Validation=false] Specifies whether or
     *     not to skip UTF-8 validation for text and close messages
     */
    constructor(C = {}) {
      super(), this._allowSynchronousEvents = C.allowSynchronousEvents !== void 0 ? C.allowSynchronousEvents : !0, this._binaryType = C.binaryType || n[0], this._extensions = C.extensions || {}, this._isServer = !!C.isServer, this._maxPayload = C.maxPayload | 0, this._skipUTF8Validation = !!C.skipUTF8Validation, this[s] = void 0, this._bufferedBytes = 0, this._buffers = [], this._compressed = !1, this._payloadLength = 0, this._mask = void 0, this._fragmented = 0, this._masked = !1, this._fin = !1, this._opcode = 0, this._totalPayloadLength = 0, this._messageLength = 0, this._fragments = [], this._errored = !1, this._loop = !1, this._state = m;
    }
    /**
     * Implements `Writable.prototype._write()`.
     *
     * @param {Buffer} chunk The chunk of data to write
     * @param {String} encoding The character encoding of `chunk`
     * @param {Function} cb Callback
     * @private
     */
    _write(C, D, L) {
      if (this._opcode === 8 && this._state == m) return L();
      this._bufferedBytes += C.length, this._buffers.push(C), this.startLoop(L);
    }
    /**
     * Consumes `n` bytes from the buffered data.
     *
     * @param {Number} n The number of bytes to consume
     * @return {Buffer} The consumed bytes
     * @private
     */
    consume(C) {
      if (this._bufferedBytes -= C, C === this._buffers[0].length) return this._buffers.shift();
      if (C < this._buffers[0].length) {
        const L = this._buffers[0];
        return this._buffers[0] = new f(
          L.buffer,
          L.byteOffset + C,
          L.length - C
        ), new f(L.buffer, L.byteOffset, C);
      }
      const D = Buffer.allocUnsafe(C);
      do {
        const L = this._buffers[0], k = D.length - C;
        C >= L.length ? D.set(this._buffers.shift(), k) : (D.set(new Uint8Array(L.buffer, L.byteOffset, C), k), this._buffers[0] = new f(
          L.buffer,
          L.byteOffset + C,
          L.length - C
        )), C -= L.length;
      } while (C > 0);
      return D;
    }
    /**
     * Starts the parsing loop.
     *
     * @param {Function} cb Callback
     * @private
     */
    startLoop(C) {
      this._loop = !0;
      do
        switch (this._state) {
          case m:
            this.getInfo(C);
            break;
          case g:
            this.getPayloadLength16(C);
            break;
          case A:
            this.getPayloadLength64(C);
            break;
          case E:
            this.getMask();
            break;
          case w:
            this.getData(C);
            break;
          case x:
          case N:
            this._loop = !1;
            return;
        }
      while (this._loop);
      this._errored || C();
    }
    /**
     * Reads the first two bytes of a frame.
     *
     * @param {Function} cb Callback
     * @private
     */
    getInfo(C) {
      if (this._bufferedBytes < 2) {
        this._loop = !1;
        return;
      }
      const D = this.consume(2);
      if ((D[0] & 48) !== 0) {
        const k = this.createError(
          RangeError,
          "RSV2 and RSV3 must be clear",
          !0,
          1002,
          "WS_ERR_UNEXPECTED_RSV_2_3"
        );
        C(k);
        return;
      }
      const L = (D[0] & 64) === 64;
      if (L && !this._extensions[e.extensionName]) {
        const k = this.createError(
          RangeError,
          "RSV1 must be clear",
          !0,
          1002,
          "WS_ERR_UNEXPECTED_RSV_1"
        );
        C(k);
        return;
      }
      if (this._fin = (D[0] & 128) === 128, this._opcode = D[0] & 15, this._payloadLength = D[1] & 127, this._opcode === 0) {
        if (L) {
          const k = this.createError(
            RangeError,
            "RSV1 must be clear",
            !0,
            1002,
            "WS_ERR_UNEXPECTED_RSV_1"
          );
          C(k);
          return;
        }
        if (!this._fragmented) {
          const k = this.createError(
            RangeError,
            "invalid opcode 0",
            !0,
            1002,
            "WS_ERR_INVALID_OPCODE"
          );
          C(k);
          return;
        }
        this._opcode = this._fragmented;
      } else if (this._opcode === 1 || this._opcode === 2) {
        if (this._fragmented) {
          const k = this.createError(
            RangeError,
            `invalid opcode ${this._opcode}`,
            !0,
            1002,
            "WS_ERR_INVALID_OPCODE"
          );
          C(k);
          return;
        }
        this._compressed = L;
      } else if (this._opcode > 7 && this._opcode < 11) {
        if (!this._fin) {
          const k = this.createError(
            RangeError,
            "FIN must be set",
            !0,
            1002,
            "WS_ERR_EXPECTED_FIN"
          );
          C(k);
          return;
        }
        if (L) {
          const k = this.createError(
            RangeError,
            "RSV1 must be clear",
            !0,
            1002,
            "WS_ERR_UNEXPECTED_RSV_1"
          );
          C(k);
          return;
        }
        if (this._payloadLength > 125 || this._opcode === 8 && this._payloadLength === 1) {
          const k = this.createError(
            RangeError,
            `invalid payload length ${this._payloadLength}`,
            !0,
            1002,
            "WS_ERR_INVALID_CONTROL_PAYLOAD_LENGTH"
          );
          C(k);
          return;
        }
      } else {
        const k = this.createError(
          RangeError,
          `invalid opcode ${this._opcode}`,
          !0,
          1002,
          "WS_ERR_INVALID_OPCODE"
        );
        C(k);
        return;
      }
      if (!this._fin && !this._fragmented && (this._fragmented = this._opcode), this._masked = (D[1] & 128) === 128, this._isServer) {
        if (!this._masked) {
          const k = this.createError(
            RangeError,
            "MASK must be set",
            !0,
            1002,
            "WS_ERR_EXPECTED_MASK"
          );
          C(k);
          return;
        }
      } else if (this._masked) {
        const k = this.createError(
          RangeError,
          "MASK must be clear",
          !0,
          1002,
          "WS_ERR_UNEXPECTED_MASK"
        );
        C(k);
        return;
      }
      this._payloadLength === 126 ? this._state = g : this._payloadLength === 127 ? this._state = A : this.haveLength(C);
    }
    /**
     * Gets extended payload length (7+16).
     *
     * @param {Function} cb Callback
     * @private
     */
    getPayloadLength16(C) {
      if (this._bufferedBytes < 2) {
        this._loop = !1;
        return;
      }
      this._payloadLength = this.consume(2).readUInt16BE(0), this.haveLength(C);
    }
    /**
     * Gets extended payload length (7+64).
     *
     * @param {Function} cb Callback
     * @private
     */
    getPayloadLength64(C) {
      if (this._bufferedBytes < 8) {
        this._loop = !1;
        return;
      }
      const D = this.consume(8), L = D.readUInt32BE(0);
      if (L > Math.pow(2, 21) - 1) {
        const k = this.createError(
          RangeError,
          "Unsupported WebSocket frame: payload length > 2^53 - 1",
          !1,
          1009,
          "WS_ERR_UNSUPPORTED_DATA_PAYLOAD_LENGTH"
        );
        C(k);
        return;
      }
      this._payloadLength = L * Math.pow(2, 32) + D.readUInt32BE(4), this.haveLength(C);
    }
    /**
     * Payload length has been read.
     *
     * @param {Function} cb Callback
     * @private
     */
    haveLength(C) {
      if (this._payloadLength && this._opcode < 8 && (this._totalPayloadLength += this._payloadLength, this._totalPayloadLength > this._maxPayload && this._maxPayload > 0)) {
        const D = this.createError(
          RangeError,
          "Max payload size exceeded",
          !1,
          1009,
          "WS_ERR_UNSUPPORTED_MESSAGE_LENGTH"
        );
        C(D);
        return;
      }
      this._masked ? this._state = E : this._state = w;
    }
    /**
     * Reads mask bytes.
     *
     * @private
     */
    getMask() {
      if (this._bufferedBytes < 4) {
        this._loop = !1;
        return;
      }
      this._mask = this.consume(4), this._state = w;
    }
    /**
     * Reads data bytes.
     *
     * @param {Function} cb Callback
     * @private
     */
    getData(C) {
      let D = r;
      if (this._payloadLength) {
        if (this._bufferedBytes < this._payloadLength) {
          this._loop = !1;
          return;
        }
        D = this.consume(this._payloadLength), this._masked && (this._mask[0] | this._mask[1] | this._mask[2] | this._mask[3]) !== 0 && u(D, this._mask);
      }
      if (this._opcode > 7) {
        this.controlMessage(D, C);
        return;
      }
      if (this._compressed) {
        this._state = x, this.decompress(D, C);
        return;
      }
      D.length && (this._messageLength = this._totalPayloadLength, this._fragments.push(D)), this.dataMessage(C);
    }
    /**
     * Decompresses data.
     *
     * @param {Buffer} data Compressed data
     * @param {Function} cb Callback
     * @private
     */
    decompress(C, D) {
      this._extensions[e.extensionName].decompress(C, this._fin, (k, I) => {
        if (k) return D(k);
        if (I.length) {
          if (this._messageLength += I.length, this._messageLength > this._maxPayload && this._maxPayload > 0) {
            const U = this.createError(
              RangeError,
              "Max payload size exceeded",
              !1,
              1009,
              "WS_ERR_UNSUPPORTED_MESSAGE_LENGTH"
            );
            D(U);
            return;
          }
          this._fragments.push(I);
        }
        this.dataMessage(D), this._state === m && this.startLoop(D);
      });
    }
    /**
     * Handles a data message.
     *
     * @param {Function} cb Callback
     * @private
     */
    dataMessage(C) {
      if (!this._fin) {
        this._state = m;
        return;
      }
      const D = this._messageLength, L = this._fragments;
      if (this._totalPayloadLength = 0, this._messageLength = 0, this._fragmented = 0, this._fragments = [], this._opcode === 2) {
        let k;
        this._binaryType === "nodebuffer" ? k = a(L, D) : this._binaryType === "arraybuffer" ? k = o(a(L, D)) : this._binaryType === "blob" ? k = new Blob(L) : k = L, this._allowSynchronousEvents ? (this.emit("message", k, !0), this._state = m) : (this._state = N, setImmediate(() => {
          this.emit("message", k, !0), this._state = m, this.startLoop(C);
        }));
      } else {
        const k = a(L, D);
        if (!this._skipUTF8Validation && !h(k)) {
          const I = this.createError(
            Error,
            "invalid UTF-8 sequence",
            !0,
            1007,
            "WS_ERR_INVALID_UTF8"
          );
          C(I);
          return;
        }
        this._state === x || this._allowSynchronousEvents ? (this.emit("message", k, !1), this._state = m) : (this._state = N, setImmediate(() => {
          this.emit("message", k, !1), this._state = m, this.startLoop(C);
        }));
      }
    }
    /**
     * Handles a control message.
     *
     * @param {Buffer} data Data to handle
     * @return {(Error|RangeError|undefined)} A possible error
     * @private
     */
    controlMessage(C, D) {
      if (this._opcode === 8) {
        if (C.length === 0)
          this._loop = !1, this.emit("conclude", 1005, r), this.end();
        else {
          const L = C.readUInt16BE(0);
          if (!l(L)) {
            const I = this.createError(
              RangeError,
              `invalid status code ${L}`,
              !0,
              1002,
              "WS_ERR_INVALID_CLOSE_CODE"
            );
            D(I);
            return;
          }
          const k = new f(
            C.buffer,
            C.byteOffset + 2,
            C.length - 2
          );
          if (!this._skipUTF8Validation && !h(k)) {
            const I = this.createError(
              Error,
              "invalid UTF-8 sequence",
              !0,
              1007,
              "WS_ERR_INVALID_UTF8"
            );
            D(I);
            return;
          }
          this._loop = !1, this.emit("conclude", L, k), this.end();
        }
        this._state = m;
        return;
      }
      this._allowSynchronousEvents ? (this.emit(this._opcode === 9 ? "ping" : "pong", C), this._state = m) : (this._state = N, setImmediate(() => {
        this.emit(this._opcode === 9 ? "ping" : "pong", C), this._state = m, this.startLoop(D);
      }));
    }
    /**
     * Builds an error object.
     *
     * @param {function(new:Error|RangeError)} ErrorCtor The error constructor
     * @param {String} message The error message
     * @param {Boolean} prefix Specifies whether or not to add a default prefix to
     *     `message`
     * @param {Number} statusCode The status code
     * @param {String} errorCode The exposed error code
     * @return {(Error|RangeError)} The error
     * @private
     */
    createError(C, D, L, k, I) {
      this._loop = !1, this._errored = !0;
      const U = new C(
        L ? `Invalid WebSocket frame: ${D}` : D
      );
      return Error.captureStackTrace(U, this.createError), U.code = I, U[i] = k, U;
    }
  }
  return QF = B, QF;
}
var XF, AM;
function PW() {
  if (AM) return XF;
  AM = 1;
  const { Duplex: t } = Ti, { randomFillSync: e } = _f, n = qA(), { EMPTY_BUFFER: r, kWebSocket: i, NOOP: s } = xc(), { isBlob: a, isValidStatusCode: o } = Ap(), { mask: u, toBuffer: l } = YA(), h = /* @__PURE__ */ Symbol("kByteLength"), f = Buffer.alloc(4), m = 8 * 1024;
  let g, A = m;
  const E = 0, w = 1, x = 2;
  class N {
    /**
     * Creates a Sender instance.
     *
     * @param {Duplex} socket The connection socket
     * @param {Object} [extensions] An object containing the negotiated extensions
     * @param {Function} [generateMask] The function used to generate the masking
     *     key
     */
    constructor(D, L, k) {
      this._extensions = L || {}, k && (this._generateMask = k, this._maskBuffer = Buffer.alloc(4)), this._socket = D, this._firstFragment = !0, this._compress = !1, this._bufferedBytes = 0, this._queue = [], this._state = E, this.onerror = s, this[i] = void 0;
    }
    /**
     * Frames a piece of data according to the HyBi WebSocket protocol.
     *
     * @param {(Buffer|String)} data The data to frame
     * @param {Object} options Options object
     * @param {Boolean} [options.fin=false] Specifies whether or not to set the
     *     FIN bit
     * @param {Function} [options.generateMask] The function used to generate the
     *     masking key
     * @param {Boolean} [options.mask=false] Specifies whether or not to mask
     *     `data`
     * @param {Buffer} [options.maskBuffer] The buffer used to store the masking
     *     key
     * @param {Number} options.opcode The opcode
     * @param {Boolean} [options.readOnly=false] Specifies whether `data` can be
     *     modified
     * @param {Boolean} [options.rsv1=false] Specifies whether or not to set the
     *     RSV1 bit
     * @return {(Buffer|String)[]} The framed data
     * @public
     */
    static frame(D, L) {
      let k, I = !1, U = 2, j = !1;
      L.mask && (k = L.maskBuffer || f, L.generateMask ? L.generateMask(k) : (A === m && (g === void 0 && (g = Buffer.alloc(m)), e(g, 0, m), A = 0), k[0] = g[A++], k[1] = g[A++], k[2] = g[A++], k[3] = g[A++]), j = (k[0] | k[1] | k[2] | k[3]) === 0, U = 6);
      let J;
      typeof D == "string" ? (!L.mask || j) && L[h] !== void 0 ? J = L[h] : (D = Buffer.from(D), J = D.length) : (J = D.length, I = L.mask && L.readOnly && !j);
      let G = J;
      J >= 65536 ? (U += 8, G = 127) : J > 125 && (U += 2, G = 126);
      const H = Buffer.allocUnsafe(I ? J + U : U);
      return H[0] = L.fin ? L.opcode | 128 : L.opcode, L.rsv1 && (H[0] |= 64), H[1] = G, G === 126 ? H.writeUInt16BE(J, 2) : G === 127 && (H[2] = H[3] = 0, H.writeUIntBE(J, 4, 6)), L.mask ? (H[1] |= 128, H[U - 4] = k[0], H[U - 3] = k[1], H[U - 2] = k[2], H[U - 1] = k[3], j ? [H, D] : I ? (u(D, k, H, U, J), [H]) : (u(D, k, D, 0, J), [H, D])) : [H, D];
    }
    /**
     * Sends a close message to the other peer.
     *
     * @param {Number} [code] The status code component of the body
     * @param {(String|Buffer)} [data] The message component of the body
     * @param {Boolean} [mask=false] Specifies whether or not to mask the message
     * @param {Function} [cb] Callback
     * @public
     */
    close(D, L, k, I) {
      let U;
      if (D === void 0)
        U = r;
      else {
        if (typeof D != "number" || !o(D))
          throw new TypeError("First argument must be a valid error code number");
        if (L === void 0 || !L.length)
          U = Buffer.allocUnsafe(2), U.writeUInt16BE(D, 0);
        else {
          const J = Buffer.byteLength(L);
          if (J > 123)
            throw new RangeError("The message must not be greater than 123 bytes");
          U = Buffer.allocUnsafe(2 + J), U.writeUInt16BE(D, 0), typeof L == "string" ? U.write(L, 2) : U.set(L, 2);
        }
      }
      const j = {
        [h]: U.length,
        fin: !0,
        generateMask: this._generateMask,
        mask: k,
        maskBuffer: this._maskBuffer,
        opcode: 8,
        readOnly: !1,
        rsv1: !1
      };
      this._state !== E ? this.enqueue([this.dispatch, U, !1, j, I]) : this.sendFrame(N.frame(U, j), I);
    }
    /**
     * Sends a ping message to the other peer.
     *
     * @param {*} data The message to send
     * @param {Boolean} [mask=false] Specifies whether or not to mask `data`
     * @param {Function} [cb] Callback
     * @public
     */
    ping(D, L, k) {
      let I, U;
      if (typeof D == "string" ? (I = Buffer.byteLength(D), U = !1) : a(D) ? (I = D.size, U = !1) : (D = l(D), I = D.length, U = l.readOnly), I > 125)
        throw new RangeError("The data size must not be greater than 125 bytes");
      const j = {
        [h]: I,
        fin: !0,
        generateMask: this._generateMask,
        mask: L,
        maskBuffer: this._maskBuffer,
        opcode: 9,
        readOnly: U,
        rsv1: !1
      };
      a(D) ? this._state !== E ? this.enqueue([this.getBlobData, D, !1, j, k]) : this.getBlobData(D, !1, j, k) : this._state !== E ? this.enqueue([this.dispatch, D, !1, j, k]) : this.sendFrame(N.frame(D, j), k);
    }
    /**
     * Sends a pong message to the other peer.
     *
     * @param {*} data The message to send
     * @param {Boolean} [mask=false] Specifies whether or not to mask `data`
     * @param {Function} [cb] Callback
     * @public
     */
    pong(D, L, k) {
      let I, U;
      if (typeof D == "string" ? (I = Buffer.byteLength(D), U = !1) : a(D) ? (I = D.size, U = !1) : (D = l(D), I = D.length, U = l.readOnly), I > 125)
        throw new RangeError("The data size must not be greater than 125 bytes");
      const j = {
        [h]: I,
        fin: !0,
        generateMask: this._generateMask,
        mask: L,
        maskBuffer: this._maskBuffer,
        opcode: 10,
        readOnly: U,
        rsv1: !1
      };
      a(D) ? this._state !== E ? this.enqueue([this.getBlobData, D, !1, j, k]) : this.getBlobData(D, !1, j, k) : this._state !== E ? this.enqueue([this.dispatch, D, !1, j, k]) : this.sendFrame(N.frame(D, j), k);
    }
    /**
     * Sends a data message to the other peer.
     *
     * @param {*} data The message to send
     * @param {Object} options Options object
     * @param {Boolean} [options.binary=false] Specifies whether `data` is binary
     *     or text
     * @param {Boolean} [options.compress=false] Specifies whether or not to
     *     compress `data`
     * @param {Boolean} [options.fin=false] Specifies whether the fragment is the
     *     last one
     * @param {Boolean} [options.mask=false] Specifies whether or not to mask
     *     `data`
     * @param {Function} [cb] Callback
     * @public
     */
    send(D, L, k) {
      const I = this._extensions[n.extensionName];
      let U = L.binary ? 2 : 1, j = L.compress, J, G;
      typeof D == "string" ? (J = Buffer.byteLength(D), G = !1) : a(D) ? (J = D.size, G = !1) : (D = l(D), J = D.length, G = l.readOnly), this._firstFragment ? (this._firstFragment = !1, j && I && I.params[I._isServer ? "server_no_context_takeover" : "client_no_context_takeover"] && (j = J >= I._threshold), this._compress = j) : (j = !1, U = 0), L.fin && (this._firstFragment = !0);
      const H = {
        [h]: J,
        fin: L.fin,
        generateMask: this._generateMask,
        mask: L.mask,
        maskBuffer: this._maskBuffer,
        opcode: U,
        readOnly: G,
        rsv1: j
      };
      a(D) ? this._state !== E ? this.enqueue([this.getBlobData, D, this._compress, H, k]) : this.getBlobData(D, this._compress, H, k) : this._state !== E ? this.enqueue([this.dispatch, D, this._compress, H, k]) : this.dispatch(D, this._compress, H, k);
    }
    /**
     * Gets the contents of a blob as binary data.
     *
     * @param {Blob} blob The blob
     * @param {Boolean} [compress=false] Specifies whether or not to compress
     *     the data
     * @param {Object} options Options object
     * @param {Boolean} [options.fin=false] Specifies whether or not to set the
     *     FIN bit
     * @param {Function} [options.generateMask] The function used to generate the
     *     masking key
     * @param {Boolean} [options.mask=false] Specifies whether or not to mask
     *     `data`
     * @param {Buffer} [options.maskBuffer] The buffer used to store the masking
     *     key
     * @param {Number} options.opcode The opcode
     * @param {Boolean} [options.readOnly=false] Specifies whether `data` can be
     *     modified
     * @param {Boolean} [options.rsv1=false] Specifies whether or not to set the
     *     RSV1 bit
     * @param {Function} [cb] Callback
     * @private
     */
    getBlobData(D, L, k, I) {
      this._bufferedBytes += k[h], this._state = x, D.arrayBuffer().then((U) => {
        if (this._socket.destroyed) {
          const J = new Error(
            "The socket was closed while the blob was being read"
          );
          process.nextTick(B, this, J, I);
          return;
        }
        this._bufferedBytes -= k[h];
        const j = l(U);
        L ? this.dispatch(j, L, k, I) : (this._state = E, this.sendFrame(N.frame(j, k), I), this.dequeue());
      }).catch((U) => {
        process.nextTick(P, this, U, I);
      });
    }
    /**
     * Dispatches a message.
     *
     * @param {(Buffer|String)} data The message to send
     * @param {Boolean} [compress=false] Specifies whether or not to compress
     *     `data`
     * @param {Object} options Options object
     * @param {Boolean} [options.fin=false] Specifies whether or not to set the
     *     FIN bit
     * @param {Function} [options.generateMask] The function used to generate the
     *     masking key
     * @param {Boolean} [options.mask=false] Specifies whether or not to mask
     *     `data`
     * @param {Buffer} [options.maskBuffer] The buffer used to store the masking
     *     key
     * @param {Number} options.opcode The opcode
     * @param {Boolean} [options.readOnly=false] Specifies whether `data` can be
     *     modified
     * @param {Boolean} [options.rsv1=false] Specifies whether or not to set the
     *     RSV1 bit
     * @param {Function} [cb] Callback
     * @private
     */
    dispatch(D, L, k, I) {
      if (!L) {
        this.sendFrame(N.frame(D, k), I);
        return;
      }
      const U = this._extensions[n.extensionName];
      this._bufferedBytes += k[h], this._state = w, U.compress(D, k.fin, (j, J) => {
        if (this._socket.destroyed) {
          const G = new Error(
            "The socket was closed while data was being compressed"
          );
          B(this, G, I);
          return;
        }
        this._bufferedBytes -= k[h], this._state = E, k.readOnly = !1, this.sendFrame(N.frame(J, k), I), this.dequeue();
      });
    }
    /**
     * Executes queued send operations.
     *
     * @private
     */
    dequeue() {
      for (; this._state === E && this._queue.length; ) {
        const D = this._queue.shift();
        this._bufferedBytes -= D[3][h], Reflect.apply(D[0], this, D.slice(1));
      }
    }
    /**
     * Enqueues a send operation.
     *
     * @param {Array} params Send operation parameters.
     * @private
     */
    enqueue(D) {
      this._bufferedBytes += D[3][h], this._queue.push(D);
    }
    /**
     * Sends a frame.
     *
     * @param {(Buffer | String)[]} list The frame to send
     * @param {Function} [cb] Callback
     * @private
     */
    sendFrame(D, L) {
      D.length === 2 ? (this._socket.cork(), this._socket.write(D[0]), this._socket.write(D[1], L), this._socket.uncork()) : this._socket.write(D[0], L);
    }
  }
  XF = N;
  function B(C, D, L) {
    typeof L == "function" && L(D);
    for (let k = 0; k < C._queue.length; k++) {
      const I = C._queue[k], U = I[I.length - 1];
      typeof U == "function" && U(D);
    }
  }
  function P(C, D, L) {
    B(C, D, L), C.onerror(D);
  }
  return XF;
}
var ZF, EM;
function yGe() {
  if (EM) return ZF;
  EM = 1;
  const { kForOnEventAttribute: t, kListener: e } = xc(), n = /* @__PURE__ */ Symbol("kCode"), r = /* @__PURE__ */ Symbol("kData"), i = /* @__PURE__ */ Symbol("kError"), s = /* @__PURE__ */ Symbol("kMessage"), a = /* @__PURE__ */ Symbol("kReason"), o = /* @__PURE__ */ Symbol("kTarget"), u = /* @__PURE__ */ Symbol("kType"), l = /* @__PURE__ */ Symbol("kWasClean");
  class h {
    /**
     * Create a new `Event`.
     *
     * @param {String} type The name of the event
     * @throws {TypeError} If the `type` argument is not specified
     */
    constructor(x) {
      this[o] = null, this[u] = x;
    }
    /**
     * @type {*}
     */
    get target() {
      return this[o];
    }
    /**
     * @type {String}
     */
    get type() {
      return this[u];
    }
  }
  Object.defineProperty(h.prototype, "target", { enumerable: !0 }), Object.defineProperty(h.prototype, "type", { enumerable: !0 });
  class f extends h {
    /**
     * Create a new `CloseEvent`.
     *
     * @param {String} type The name of the event
     * @param {Object} [options] A dictionary object that allows for setting
     *     attributes via object members of the same name
     * @param {Number} [options.code=0] The status code explaining why the
     *     connection was closed
     * @param {String} [options.reason=''] A human-readable string explaining why
     *     the connection was closed
     * @param {Boolean} [options.wasClean=false] Indicates whether or not the
     *     connection was cleanly closed
     */
    constructor(x, N = {}) {
      super(x), this[n] = N.code === void 0 ? 0 : N.code, this[a] = N.reason === void 0 ? "" : N.reason, this[l] = N.wasClean === void 0 ? !1 : N.wasClean;
    }
    /**
     * @type {Number}
     */
    get code() {
      return this[n];
    }
    /**
     * @type {String}
     */
    get reason() {
      return this[a];
    }
    /**
     * @type {Boolean}
     */
    get wasClean() {
      return this[l];
    }
  }
  Object.defineProperty(f.prototype, "code", { enumerable: !0 }), Object.defineProperty(f.prototype, "reason", { enumerable: !0 }), Object.defineProperty(f.prototype, "wasClean", { enumerable: !0 });
  class m extends h {
    /**
     * Create a new `ErrorEvent`.
     *
     * @param {String} type The name of the event
     * @param {Object} [options] A dictionary object that allows for setting
     *     attributes via object members of the same name
     * @param {*} [options.error=null] The error that generated this event
     * @param {String} [options.message=''] The error message
     */
    constructor(x, N = {}) {
      super(x), this[i] = N.error === void 0 ? null : N.error, this[s] = N.message === void 0 ? "" : N.message;
    }
    /**
     * @type {*}
     */
    get error() {
      return this[i];
    }
    /**
     * @type {String}
     */
    get message() {
      return this[s];
    }
  }
  Object.defineProperty(m.prototype, "error", { enumerable: !0 }), Object.defineProperty(m.prototype, "message", { enumerable: !0 });
  class g extends h {
    /**
     * Create a new `MessageEvent`.
     *
     * @param {String} type The name of the event
     * @param {Object} [options] A dictionary object that allows for setting
     *     attributes via object members of the same name
     * @param {*} [options.data=null] The message content
     */
    constructor(x, N = {}) {
      super(x), this[r] = N.data === void 0 ? null : N.data;
    }
    /**
     * @type {*}
     */
    get data() {
      return this[r];
    }
  }
  Object.defineProperty(g.prototype, "data", { enumerable: !0 }), ZF = {
    CloseEvent: f,
    ErrorEvent: m,
    Event: h,
    EventTarget: {
      /**
       * Register an event listener.
       *
       * @param {String} type A string representing the event type to listen for
       * @param {(Function|Object)} handler The listener to add
       * @param {Object} [options] An options object specifies characteristics about
       *     the event listener
       * @param {Boolean} [options.once=false] A `Boolean` indicating that the
       *     listener should be invoked at most once after being added. If `true`,
       *     the listener would be automatically removed when invoked.
       * @public
       */
      addEventListener(w, x, N = {}) {
        for (const P of this.listeners(w))
          if (!N[t] && P[e] === x && !P[t])
            return;
        let B;
        if (w === "message")
          B = function(C, D) {
            const L = new g("message", {
              data: D ? C : C.toString()
            });
            L[o] = this, E(x, this, L);
          };
        else if (w === "close")
          B = function(C, D) {
            const L = new f("close", {
              code: C,
              reason: D.toString(),
              wasClean: this._closeFrameReceived && this._closeFrameSent
            });
            L[o] = this, E(x, this, L);
          };
        else if (w === "error")
          B = function(C) {
            const D = new m("error", {
              error: C,
              message: C.message
            });
            D[o] = this, E(x, this, D);
          };
        else if (w === "open")
          B = function() {
            const C = new h("open");
            C[o] = this, E(x, this, C);
          };
        else
          return;
        B[t] = !!N[t], B[e] = x, N.once ? this.once(w, B) : this.on(w, B);
      },
      /**
       * Remove an event listener.
       *
       * @param {String} type A string representing the event type to remove
       * @param {(Function|Object)} handler The listener to remove
       * @public
       */
      removeEventListener(w, x) {
        for (const N of this.listeners(w))
          if (N[e] === x && !N[t]) {
            this.removeListener(w, N);
            break;
          }
      }
    },
    MessageEvent: g
  };
  function E(w, x, N) {
    typeof w == "object" && w.handleEvent ? w.handleEvent.call(w, N) : w.call(x, N);
  }
  return ZF;
}
var eT, SM;
function LW() {
  if (SM) return eT;
  SM = 1;
  const { tokenChars: t } = Ap();
  function e(i, s, a) {
    i[s] === void 0 ? i[s] = [a] : i[s].push(a);
  }
  function n(i) {
    const s = /* @__PURE__ */ Object.create(null);
    let a = /* @__PURE__ */ Object.create(null), o = !1, u = !1, l = !1, h, f, m = -1, g = -1, A = -1, E = 0;
    for (; E < i.length; E++)
      if (g = i.charCodeAt(E), h === void 0)
        if (A === -1 && t[g] === 1)
          m === -1 && (m = E);
        else if (E !== 0 && (g === 32 || g === 9))
          A === -1 && m !== -1 && (A = E);
        else if (g === 59 || g === 44) {
          if (m === -1)
            throw new SyntaxError(`Unexpected character at index ${E}`);
          A === -1 && (A = E);
          const x = i.slice(m, A);
          g === 44 ? (e(s, x, a), a = /* @__PURE__ */ Object.create(null)) : h = x, m = A = -1;
        } else
          throw new SyntaxError(`Unexpected character at index ${E}`);
      else if (f === void 0)
        if (A === -1 && t[g] === 1)
          m === -1 && (m = E);
        else if (g === 32 || g === 9)
          A === -1 && m !== -1 && (A = E);
        else if (g === 59 || g === 44) {
          if (m === -1)
            throw new SyntaxError(`Unexpected character at index ${E}`);
          A === -1 && (A = E), e(a, i.slice(m, A), !0), g === 44 && (e(s, h, a), a = /* @__PURE__ */ Object.create(null), h = void 0), m = A = -1;
        } else if (g === 61 && m !== -1 && A === -1)
          f = i.slice(m, E), m = A = -1;
        else
          throw new SyntaxError(`Unexpected character at index ${E}`);
      else if (u) {
        if (t[g] !== 1)
          throw new SyntaxError(`Unexpected character at index ${E}`);
        m === -1 ? m = E : o || (o = !0), u = !1;
      } else if (l)
        if (t[g] === 1)
          m === -1 && (m = E);
        else if (g === 34 && m !== -1)
          l = !1, A = E;
        else if (g === 92)
          u = !0;
        else
          throw new SyntaxError(`Unexpected character at index ${E}`);
      else if (g === 34 && i.charCodeAt(E - 1) === 61)
        l = !0;
      else if (A === -1 && t[g] === 1)
        m === -1 && (m = E);
      else if (m !== -1 && (g === 32 || g === 9))
        A === -1 && (A = E);
      else if (g === 59 || g === 44) {
        if (m === -1)
          throw new SyntaxError(`Unexpected character at index ${E}`);
        A === -1 && (A = E);
        let x = i.slice(m, A);
        o && (x = x.replace(/\\/g, ""), o = !1), e(a, f, x), g === 44 && (e(s, h, a), a = /* @__PURE__ */ Object.create(null), h = void 0), f = void 0, m = A = -1;
      } else
        throw new SyntaxError(`Unexpected character at index ${E}`);
    if (m === -1 || l || g === 32 || g === 9)
      throw new SyntaxError("Unexpected end of input");
    A === -1 && (A = E);
    const w = i.slice(m, A);
    return h === void 0 ? e(s, w, a) : (f === void 0 ? e(a, w, !0) : o ? e(a, f, w.replace(/\\/g, "")) : e(a, f, w), e(s, h, a)), s;
  }
  function r(i) {
    return Object.keys(i).map((s) => {
      let a = i[s];
      return Array.isArray(a) || (a = [a]), a.map((o) => [s].concat(
        Object.keys(o).map((u) => {
          let l = o[u];
          return Array.isArray(l) || (l = [l]), l.map((h) => h === !0 ? u : `${u}=${h}`).join("; ");
        })
      ).join("; ")).join(", ");
    }).join(", ");
  }
  return eT = { format: r, parse: n }, eT;
}
var tT, wM;
function J2() {
  if (wM) return tT;
  wM = 1;
  const t = GM, e = UM, n = Cx, r = KQ, i = JQ, { randomBytes: s, createHash: a } = _f, { Duplex: o, Readable: u } = Ti, { URL: l } = $Q, h = qA(), f = RW(), m = PW(), { isBlob: g } = Ap(), {
    BINARY_TYPES: A,
    CLOSE_TIMEOUT: E,
    EMPTY_BUFFER: w,
    GUID: x,
    kForOnEventAttribute: N,
    kListener: B,
    kStatusCode: P,
    kWebSocket: C,
    NOOP: D
  } = xc(), {
    EventTarget: { addEventListener: L, removeEventListener: k }
  } = yGe(), { format: I, parse: U } = LW(), { toBuffer: j } = YA(), J = /* @__PURE__ */ Symbol("kAborted"), G = [8, 13], H = ["CONNECTING", "OPEN", "CLOSING", "CLOSED"], q = /^[!#$%&'*+\-.0-9A-Z^_`|a-z~]+$/;
  class X extends t {
    /**
     * Create a new `WebSocket`.
     *
     * @param {(String|URL)} address The URL to which to connect
     * @param {(String|String[])} [protocols] The subprotocols
     * @param {Object} [options] Connection options
     */
    constructor(Te, Je, rt) {
      super(), this._binaryType = A[0], this._closeCode = 1006, this._closeFrameReceived = !1, this._closeFrameSent = !1, this._closeMessage = w, this._closeTimer = null, this._errorEmitted = !1, this._extensions = {}, this._paused = !1, this._protocol = "", this._readyState = X.CONNECTING, this._receiver = null, this._sender = null, this._socket = null, Te !== null ? (this._bufferedAmount = 0, this._isServer = !1, this._redirects = 0, Je === void 0 ? Je = [] : Array.isArray(Je) || (typeof Je == "object" && Je !== null ? (rt = Je, Je = []) : Je = [Je]), ie(this, Te, Je, rt)) : (this._autoPong = rt.autoPong, this._closeTimeout = rt.closeTimeout, this._isServer = !0);
    }
    /**
     * For historical reasons, the custom "nodebuffer" type is used by the default
     * instead of "blob".
     *
     * @type {String}
     */
    get binaryType() {
      return this._binaryType;
    }
    set binaryType(Te) {
      A.includes(Te) && (this._binaryType = Te, this._receiver && (this._receiver._binaryType = Te));
    }
    /**
     * @type {Number}
     */
    get bufferedAmount() {
      return this._socket ? this._socket._writableState.length + this._sender._bufferedBytes : this._bufferedAmount;
    }
    /**
     * @type {String}
     */
    get extensions() {
      return Object.keys(this._extensions).join();
    }
    /**
     * @type {Boolean}
     */
    get isPaused() {
      return this._paused;
    }
    /**
     * @type {Function}
     */
    /* istanbul ignore next */
    get onclose() {
      return null;
    }
    /**
     * @type {Function}
     */
    /* istanbul ignore next */
    get onerror() {
      return null;
    }
    /**
     * @type {Function}
     */
    /* istanbul ignore next */
    get onopen() {
      return null;
    }
    /**
     * @type {Function}
     */
    /* istanbul ignore next */
    get onmessage() {
      return null;
    }
    /**
     * @type {String}
     */
    get protocol() {
      return this._protocol;
    }
    /**
     * @type {Number}
     */
    get readyState() {
      return this._readyState;
    }
    /**
     * @type {String}
     */
    get url() {
      return this._url;
    }
    /**
     * Set up the socket and the internal resources.
     *
     * @param {Duplex} socket The network socket between the server and client
     * @param {Buffer} head The first packet of the upgraded stream
     * @param {Object} options Options object
     * @param {Boolean} [options.allowSynchronousEvents=false] Specifies whether
     *     any of the `'message'`, `'ping'`, and `'pong'` events can be emitted
     *     multiple times in the same tick
     * @param {Function} [options.generateMask] The function used to generate the
     *     masking key
     * @param {Number} [options.maxPayload=0] The maximum allowed message size
     * @param {Boolean} [options.skipUTF8Validation=false] Specifies whether or
     *     not to skip UTF-8 validation for text and close messages
     * @private
     */
    setSocket(Te, Je, rt) {
      const Ue = new f({
        allowSynchronousEvents: rt.allowSynchronousEvents,
        binaryType: this.binaryType,
        extensions: this._extensions,
        isServer: this._isServer,
        maxPayload: rt.maxPayload,
        skipUTF8Validation: rt.skipUTF8Validation
      }), rn = new m(Te, this._extensions, rt.generateMask);
      this._receiver = Ue, this._sender = rn, this._socket = Te, Ue[C] = this, rn[C] = this, Te[C] = this, Ue.on("conclude", fn), Ue.on("drain", Yt), Ue.on("error", Rn), Ue.on("message", ls), Ue.on("ping", Tn), Ue.on("pong", qt), rn.onerror = $n, Te.setTimeout && Te.setTimeout(0), Te.setNoDelay && Te.setNoDelay(), Je.length > 0 && Te.unshift(Je), Te.on("close", ii), Te.on("data", Hn), Te.on("end", cs), Te.on("error", hs), this._readyState = X.OPEN, this.emit("open");
    }
    /**
     * Emit the `'close'` event.
     *
     * @private
     */
    emitClose() {
      if (!this._socket) {
        this._readyState = X.CLOSED, this.emit("close", this._closeCode, this._closeMessage);
        return;
      }
      this._extensions[h.extensionName] && this._extensions[h.extensionName].cleanup(), this._receiver.removeAllListeners(), this._readyState = X.CLOSED, this.emit("close", this._closeCode, this._closeMessage);
    }
    /**
     * Start a closing handshake.
     *
     *          +----------+   +-----------+   +----------+
     *     - - -|ws.close()|-->|close frame|-->|ws.close()|- - -
     *    |     +----------+   +-----------+   +----------+     |
     *          +----------+   +-----------+         |
     * CLOSING  |ws.close()|<--|close frame|<--+-----+       CLOSING
     *          +----------+   +-----------+   |
     *    |           |                        |   +---+        |
     *                +------------------------+-->|fin| - - - -
     *    |         +---+                      |   +---+
     *     - - - - -|fin|<---------------------+
     *              +---+
     *
     * @param {Number} [code] Status code explaining why the connection is closing
     * @param {(String|Buffer)} [data] The reason why the connection is
     *     closing
     * @public
     */
    close(Te, Je) {
      if (this.readyState !== X.CLOSED) {
        if (this.readyState === X.CONNECTING) {
          Me(this, this._req, "WebSocket was closed before the connection was established");
          return;
        }
        if (this.readyState === X.CLOSING) {
          this._closeFrameSent && (this._closeFrameReceived || this._receiver._writableState.errorEmitted) && this._socket.end();
          return;
        }
        this._readyState = X.CLOSING, this._sender.close(Te, Je, !this._isServer, (rt) => {
          rt || (this._closeFrameSent = !0, (this._closeFrameReceived || this._receiver._writableState.errorEmitted) && this._socket.end());
        }), Cr(this);
      }
    }
    /**
     * Pause the socket.
     *
     * @public
     */
    pause() {
      this.readyState === X.CONNECTING || this.readyState === X.CLOSED || (this._paused = !0, this._socket.pause());
    }
    /**
     * Send a ping.
     *
     * @param {*} [data] The data to send
     * @param {Boolean} [mask] Indicates whether or not to mask `data`
     * @param {Function} [cb] Callback which is executed when the ping is sent
     * @public
     */
    ping(Te, Je, rt) {
      if (this.readyState === X.CONNECTING)
        throw new Error("WebSocket is not open: readyState 0 (CONNECTING)");
      if (typeof Te == "function" ? (rt = Te, Te = Je = void 0) : typeof Je == "function" && (rt = Je, Je = void 0), typeof Te == "number" && (Te = Te.toString()), this.readyState !== X.OPEN) {
        Le(this, Te, rt);
        return;
      }
      Je === void 0 && (Je = !this._isServer), this._sender.ping(Te || w, Je, rt);
    }
    /**
     * Send a pong.
     *
     * @param {*} [data] The data to send
     * @param {Boolean} [mask] Indicates whether or not to mask `data`
     * @param {Function} [cb] Callback which is executed when the pong is sent
     * @public
     */
    pong(Te, Je, rt) {
      if (this.readyState === X.CONNECTING)
        throw new Error("WebSocket is not open: readyState 0 (CONNECTING)");
      if (typeof Te == "function" ? (rt = Te, Te = Je = void 0) : typeof Je == "function" && (rt = Je, Je = void 0), typeof Te == "number" && (Te = Te.toString()), this.readyState !== X.OPEN) {
        Le(this, Te, rt);
        return;
      }
      Je === void 0 && (Je = !this._isServer), this._sender.pong(Te || w, Je, rt);
    }
    /**
     * Resume the socket.
     *
     * @public
     */
    resume() {
      this.readyState === X.CONNECTING || this.readyState === X.CLOSED || (this._paused = !1, this._receiver._writableState.needDrain || this._socket.resume());
    }
    /**
     * Send a data message.
     *
     * @param {*} data The message to send
     * @param {Object} [options] Options object
     * @param {Boolean} [options.binary] Specifies whether `data` is binary or
     *     text
     * @param {Boolean} [options.compress] Specifies whether or not to compress
     *     `data`
     * @param {Boolean} [options.fin=true] Specifies whether the fragment is the
     *     last one
     * @param {Boolean} [options.mask] Specifies whether or not to mask `data`
     * @param {Function} [cb] Callback which is executed when data is written out
     * @public
     */
    send(Te, Je, rt) {
      if (this.readyState === X.CONNECTING)
        throw new Error("WebSocket is not open: readyState 0 (CONNECTING)");
      if (typeof Je == "function" && (rt = Je, Je = {}), typeof Te == "number" && (Te = Te.toString()), this.readyState !== X.OPEN) {
        Le(this, Te, rt);
        return;
      }
      const Ue = {
        binary: typeof Te != "string",
        mask: !this._isServer,
        compress: !0,
        fin: !0,
        ...Je
      };
      this._extensions[h.extensionName] || (Ue.compress = !1), this._sender.send(Te || w, Ue, rt);
    }
    /**
     * Forcibly close the connection.
     *
     * @public
     */
    terminate() {
      if (this.readyState !== X.CLOSED) {
        if (this.readyState === X.CONNECTING) {
          Me(this, this._req, "WebSocket was closed before the connection was established");
          return;
        }
        this._socket && (this._readyState = X.CLOSING, this._socket.destroy());
      }
    }
  }
  Object.defineProperty(X, "CONNECTING", {
    enumerable: !0,
    value: H.indexOf("CONNECTING")
  }), Object.defineProperty(X.prototype, "CONNECTING", {
    enumerable: !0,
    value: H.indexOf("CONNECTING")
  }), Object.defineProperty(X, "OPEN", {
    enumerable: !0,
    value: H.indexOf("OPEN")
  }), Object.defineProperty(X.prototype, "OPEN", {
    enumerable: !0,
    value: H.indexOf("OPEN")
  }), Object.defineProperty(X, "CLOSING", {
    enumerable: !0,
    value: H.indexOf("CLOSING")
  }), Object.defineProperty(X.prototype, "CLOSING", {
    enumerable: !0,
    value: H.indexOf("CLOSING")
  }), Object.defineProperty(X, "CLOSED", {
    enumerable: !0,
    value: H.indexOf("CLOSED")
  }), Object.defineProperty(X.prototype, "CLOSED", {
    enumerable: !0,
    value: H.indexOf("CLOSED")
  }), [
    "binaryType",
    "bufferedAmount",
    "extensions",
    "isPaused",
    "protocol",
    "readyState",
    "url"
  ].forEach((oe) => {
    Object.defineProperty(X.prototype, oe, { enumerable: !0 });
  }), ["open", "error", "close", "message"].forEach((oe) => {
    Object.defineProperty(X.prototype, `on${oe}`, {
      enumerable: !0,
      get() {
        for (const Te of this.listeners(oe))
          if (Te[N]) return Te[B];
        return null;
      },
      set(Te) {
        for (const Je of this.listeners(oe))
          if (Je[N]) {
            this.removeListener(oe, Je);
            break;
          }
        typeof Te == "function" && this.addEventListener(oe, Te, {
          [N]: !0
        });
      }
    });
  }), X.prototype.addEventListener = L, X.prototype.removeEventListener = k, tT = X;
  function ie(oe, Te, Je, rt) {
    const Ue = {
      allowSynchronousEvents: !0,
      autoPong: !0,
      closeTimeout: E,
      protocolVersion: G[1],
      maxPayload: 104857600,
      skipUTF8Validation: !1,
      perMessageDeflate: !0,
      followRedirects: !1,
      maxRedirects: 10,
      ...rt,
      socketPath: void 0,
      hostname: void 0,
      protocol: void 0,
      timeout: void 0,
      method: "GET",
      host: void 0,
      path: void 0,
      port: void 0
    };
    if (oe._autoPong = Ue.autoPong, oe._closeTimeout = Ue.closeTimeout, !G.includes(Ue.protocolVersion))
      throw new RangeError(
        `Unsupported protocol version: ${Ue.protocolVersion} (supported versions: ${G.join(", ")})`
      );
    let rn;
    if (Te instanceof l)
      rn = Te;
    else
      try {
        rn = new l(Te);
      } catch {
        throw new SyntaxError(`Invalid URL: ${Te}`);
      }
    rn.protocol === "http:" ? rn.protocol = "ws:" : rn.protocol === "https:" && (rn.protocol = "wss:"), oe._url = rn.href;
    const Vs = rn.protocol === "wss:", el = rn.protocol === "ws+unix:";
    let Xa;
    if (rn.protocol !== "ws:" && !Vs && !el ? Xa = `The URL's protocol must be one of "ws:", "wss:", "http:", "https:", or "ws+unix:"` : el && !rn.pathname ? Xa = "The URL's pathname is empty" : rn.hash && (Xa = "The URL contains a fragment identifier"), Xa) {
      const bn = new SyntaxError(Xa);
      if (oe._redirects === 0)
        throw bn;
      te(oe, bn);
      return;
    }
    const Tp = Vs ? 443 : 80, tl = s(16).toString("base64"), mu = Vs ? e.request : n.request, gu = /* @__PURE__ */ new Set();
    let pu;
    if (Ue.createConnection = Ue.createConnection || (Vs ? We : Pe), Ue.defaultPort = Ue.defaultPort || Tp, Ue.port = rn.port || Tp, Ue.host = rn.hostname.startsWith("[") ? rn.hostname.slice(1, -1) : rn.hostname, Ue.headers = {
      ...Ue.headers,
      "Sec-WebSocket-Version": Ue.protocolVersion,
      "Sec-WebSocket-Key": tl,
      Connection: "Upgrade",
      Upgrade: "websocket"
    }, Ue.path = rn.pathname + rn.search, Ue.timeout = Ue.handshakeTimeout, Ue.perMessageDeflate && (pu = new h(
      Ue.perMessageDeflate !== !0 ? Ue.perMessageDeflate : {},
      !1,
      Ue.maxPayload
    ), Ue.headers["Sec-WebSocket-Extensions"] = I({
      [h.extensionName]: pu.offer()
    })), Je.length) {
      for (const bn of Je) {
        if (typeof bn != "string" || !q.test(bn) || gu.has(bn))
          throw new SyntaxError(
            "An invalid or duplicated subprotocol was specified"
          );
        gu.add(bn);
      }
      Ue.headers["Sec-WebSocket-Protocol"] = Je.join(",");
    }
    if (Ue.origin && (Ue.protocolVersion < 13 ? Ue.headers["Sec-WebSocket-Origin"] = Ue.origin : Ue.headers.Origin = Ue.origin), (rn.username || rn.password) && (Ue.auth = `${rn.username}:${rn.password}`), el) {
      const bn = Ue.path.split(":");
      Ue.socketPath = bn[0], Ue.path = bn[1];
    }
    let Br;
    if (Ue.followRedirects) {
      if (oe._redirects === 0) {
        oe._originalIpc = el, oe._originalSecure = Vs, oe._originalHostOrSocketPath = el ? Ue.socketPath : rn.host;
        const bn = rt && rt.headers;
        if (rt = { ...rt, headers: {} }, bn)
          for (const [gi, Lo] of Object.entries(bn))
            rt.headers[gi.toLowerCase()] = Lo;
      } else if (oe.listenerCount("redirect") === 0) {
        const bn = el ? oe._originalIpc ? Ue.socketPath === oe._originalHostOrSocketPath : !1 : oe._originalIpc ? !1 : rn.host === oe._originalHostOrSocketPath;
        (!bn || oe._originalSecure && !Vs) && (delete Ue.headers.authorization, delete Ue.headers.cookie, bn || delete Ue.headers.host, Ue.auth = void 0);
      }
      Ue.auth && !rt.headers.authorization && (rt.headers.authorization = "Basic " + Buffer.from(Ue.auth).toString("base64")), Br = oe._req = mu(Ue), oe._redirects && oe.emit("redirect", oe.url, Br);
    } else
      Br = oe._req = mu(Ue);
    Ue.timeout && Br.on("timeout", () => {
      Me(oe, Br, "Opening handshake has timed out");
    }), Br.on("error", (bn) => {
      Br === null || Br[J] || (Br = oe._req = null, te(oe, bn));
    }), Br.on("response", (bn) => {
      const gi = bn.headers.location, Lo = bn.statusCode;
      if (gi && Ue.followRedirects && Lo >= 300 && Lo < 400) {
        if (++oe._redirects > Ue.maxRedirects) {
          Me(oe, Br, "Maximum redirects exceeded");
          return;
        }
        Br.abort();
        let bu;
        try {
          bu = new l(gi, Te);
        } catch {
          const Mo = new SyntaxError(`Invalid URL: ${gi}`);
          te(oe, Mo);
          return;
        }
        ie(oe, bu, Je, rt);
      } else oe.emit("unexpected-response", Br, bn) || Me(
        oe,
        Br,
        `Unexpected server response: ${bn.statusCode}`
      );
    }), Br.on("upgrade", (bn, gi, Lo) => {
      if (oe.emit("upgrade", bn), oe.readyState !== X.CONNECTING) return;
      Br = oe._req = null;
      const bu = bn.headers.upgrade;
      if (bu === void 0 || bu.toLowerCase() !== "websocket") {
        Me(oe, gi, "Invalid Upgrade header");
        return;
      }
      const Mh = a("sha1").update(tl + x).digest("base64");
      if (bn.headers["sec-websocket-accept"] !== Mh) {
        Me(oe, gi, "Invalid Sec-WebSocket-Accept header");
        return;
      }
      const Mo = bn.headers["sec-websocket-protocol"];
      let kc;
      if (Mo !== void 0 ? gu.size ? gu.has(Mo) || (kc = "Server sent an invalid subprotocol") : kc = "Server sent a subprotocol but none was requested" : gu.size && (kc = "Server sent no subprotocol"), kc) {
        Me(oe, gi, kc);
        return;
      }
      Mo && (oe._protocol = Mo);
      const vp = bn.headers["sec-websocket-extensions"];
      if (vp !== void 0) {
        if (!pu) {
          Me(oe, gi, "Server sent a Sec-WebSocket-Extensions header but no extension was requested");
          return;
        }
        let $f;
        try {
          $f = U(vp);
        } catch {
          Me(oe, gi, "Invalid Sec-WebSocket-Extensions header");
          return;
        }
        const Hf = Object.keys($f);
        if (Hf.length !== 1 || Hf[0] !== h.extensionName) {
          Me(oe, gi, "Server indicated an extension that was not requested");
          return;
        }
        try {
          pu.accept($f[h.extensionName]);
        } catch {
          Me(oe, gi, "Invalid Sec-WebSocket-Extensions header");
          return;
        }
        oe._extensions[h.extensionName] = pu;
      }
      oe.setSocket(gi, Lo, {
        allowSynchronousEvents: Ue.allowSynchronousEvents,
        generateMask: Ue.generateMask,
        maxPayload: Ue.maxPayload,
        skipUTF8Validation: Ue.skipUTF8Validation
      });
    }), Ue.finishRequest ? Ue.finishRequest(Br, oe) : Br.end();
  }
  function te(oe, Te) {
    oe._readyState = X.CLOSING, oe._errorEmitted = !0, oe.emit("error", Te), oe.emitClose();
  }
  function Pe(oe) {
    return oe.path = oe.socketPath, r.connect(oe);
  }
  function We(oe) {
    return oe.path = void 0, !oe.servername && oe.servername !== "" && (oe.servername = r.isIP(oe.host) ? "" : oe.host), i.connect(oe);
  }
  function Me(oe, Te, Je) {
    oe._readyState = X.CLOSING;
    const rt = new Error(Je);
    Error.captureStackTrace(rt, Me), Te.setHeader ? (Te[J] = !0, Te.abort(), Te.socket && !Te.socket.destroyed && Te.socket.destroy(), process.nextTick(te, oe, rt)) : (Te.destroy(rt), Te.once("error", oe.emit.bind(oe, "error")), Te.once("close", oe.emitClose.bind(oe)));
  }
  function Le(oe, Te, Je) {
    if (Te) {
      const rt = g(Te) ? Te.size : j(Te).length;
      oe._socket ? oe._sender._bufferedBytes += rt : oe._bufferedAmount += rt;
    }
    if (Je) {
      const rt = new Error(
        `WebSocket is not open: readyState ${oe.readyState} (${H[oe.readyState]})`
      );
      process.nextTick(Je, rt);
    }
  }
  function fn(oe, Te) {
    const Je = this[C];
    Je._closeFrameReceived = !0, Je._closeMessage = Te, Je._closeCode = oe, Je._socket[C] !== void 0 && (Je._socket.removeListener("data", Hn), process.nextTick(yr, Je._socket), oe === 1005 ? Je.close() : Je.close(oe, Te));
  }
  function Yt() {
    const oe = this[C];
    oe.isPaused || oe._socket.resume();
  }
  function Rn(oe) {
    const Te = this[C];
    Te._socket[C] !== void 0 && (Te._socket.removeListener("data", Hn), process.nextTick(yr, Te._socket), Te.close(oe[P])), Te._errorEmitted || (Te._errorEmitted = !0, Te.emit("error", oe));
  }
  function Pn() {
    this[C].emitClose();
  }
  function ls(oe, Te) {
    this[C].emit("message", oe, Te);
  }
  function Tn(oe) {
    const Te = this[C];
    Te._autoPong && Te.pong(oe, !this._isServer, D), Te.emit("ping", oe);
  }
  function qt(oe) {
    this[C].emit("pong", oe);
  }
  function yr(oe) {
    oe.resume();
  }
  function $n(oe) {
    const Te = this[C];
    Te.readyState !== X.CLOSED && (Te.readyState === X.OPEN && (Te._readyState = X.CLOSING, Cr(Te)), this._socket.end(), Te._errorEmitted || (Te._errorEmitted = !0, Te.emit("error", oe)));
  }
  function Cr(oe) {
    oe._closeTimer = setTimeout(
      oe._socket.destroy.bind(oe._socket),
      oe._closeTimeout
    );
  }
  function ii() {
    const oe = this[C];
    if (this.removeListener("close", ii), this.removeListener("data", Hn), this.removeListener("end", cs), oe._readyState = X.CLOSING, !this._readableState.endEmitted && !oe._closeFrameReceived && !oe._receiver._writableState.errorEmitted && this._readableState.length !== 0) {
      const Te = this.read(this._readableState.length);
      oe._receiver.write(Te);
    }
    oe._receiver.end(), this[C] = void 0, clearTimeout(oe._closeTimer), oe._receiver._writableState.finished || oe._receiver._writableState.errorEmitted ? oe.emitClose() : (oe._receiver.on("error", Pn), oe._receiver.on("finish", Pn));
  }
  function Hn(oe) {
    this[C]._receiver.write(oe) || this.pause();
  }
  function cs() {
    const oe = this[C];
    oe._readyState = X.CLOSING, oe._receiver.end(), this.end();
  }
  function hs() {
    const oe = this[C];
    this.removeListener("error", hs), this.on("error", D), oe && (oe._readyState = X.CLOSING, this.destroy());
  }
  return tT;
}
var nT, FM;
function AGe() {
  if (FM) return nT;
  FM = 1, J2();
  const { Duplex: t } = Ti;
  function e(s) {
    s.emit("close");
  }
  function n() {
    !this.destroyed && this._writableState.finished && this.destroy();
  }
  function r(s) {
    this.removeListener("error", r), this.destroy(), this.listenerCount("error") === 0 && this.emit("error", s);
  }
  function i(s, a) {
    let o = !0;
    const u = new t({
      ...a,
      autoDestroy: !1,
      emitClose: !1,
      objectMode: !1,
      writableObjectMode: !1
    });
    return s.on("message", function(h, f) {
      const m = !f && u._readableState.objectMode ? h.toString() : h;
      u.push(m) || s.pause();
    }), s.once("error", function(h) {
      u.destroyed || (o = !1, u.destroy(h));
    }), s.once("close", function() {
      u.destroyed || u.push(null);
    }), u._destroy = function(l, h) {
      if (s.readyState === s.CLOSED) {
        h(l), process.nextTick(e, u);
        return;
      }
      let f = !1;
      s.once("error", function(g) {
        f = !0, h(g);
      }), s.once("close", function() {
        f || h(l), process.nextTick(e, u);
      }), o && s.terminate();
    }, u._final = function(l) {
      if (s.readyState === s.CONNECTING) {
        s.once("open", function() {
          u._final(l);
        });
        return;
      }
      s._socket !== null && (s._socket._writableState.finished ? (l(), u._readableState.endEmitted && u.destroy()) : (s._socket.once("finish", function() {
        l();
      }), s.close()));
    }, u._read = function() {
      s.isPaused && s.resume();
    }, u._write = function(l, h, f) {
      if (s.readyState === s.CONNECTING) {
        s.once("open", function() {
          u._write(l, h, f);
        });
        return;
      }
      s.send(l, f);
    }, u.on("end", n), u.on("error", r), u;
  }
  return nT = i, nT;
}
AGe();
RW();
PW();
var EGe = J2();
const SGe = /* @__PURE__ */ kh(EGe);
var rT, TM;
function wGe() {
  if (TM) return rT;
  TM = 1;
  const { tokenChars: t } = Ap();
  function e(n) {
    const r = /* @__PURE__ */ new Set();
    let i = -1, s = -1, a = 0;
    for (a; a < n.length; a++) {
      const u = n.charCodeAt(a);
      if (s === -1 && t[u] === 1)
        i === -1 && (i = a);
      else if (a !== 0 && (u === 32 || u === 9))
        s === -1 && i !== -1 && (s = a);
      else if (u === 44) {
        if (i === -1)
          throw new SyntaxError(`Unexpected character at index ${a}`);
        s === -1 && (s = a);
        const l = n.slice(i, s);
        if (r.has(l))
          throw new SyntaxError(`The "${l}" subprotocol is duplicated`);
        r.add(l), i = s = -1;
      } else
        throw new SyntaxError(`Unexpected character at index ${a}`);
    }
    if (i === -1 || s !== -1)
      throw new SyntaxError("Unexpected end of input");
    const o = n.slice(i, a);
    if (r.has(o))
      throw new SyntaxError(`The "${o}" subprotocol is duplicated`);
    return r.add(o), r;
  }
  return rT = { parse: e }, rT;
}
var iT, vM;
function FGe() {
  if (vM) return iT;
  vM = 1;
  const t = GM, e = Cx, { Duplex: n } = Ti, { createHash: r } = _f, i = LW(), s = qA(), a = wGe(), o = J2(), { CLOSE_TIMEOUT: u, GUID: l, kWebSocket: h } = xc(), f = /^[+/0-9A-Za-z]{22}==$/, m = 0, g = 1, A = 2;
  class E extends t {
    /**
     * Create a `WebSocketServer` instance.
     *
     * @param {Object} options Configuration options
     * @param {Boolean} [options.allowSynchronousEvents=true] Specifies whether
     *     any of the `'message'`, `'ping'`, and `'pong'` events can be emitted
     *     multiple times in the same tick
     * @param {Boolean} [options.autoPong=true] Specifies whether or not to
     *     automatically send a pong in response to a ping
     * @param {Number} [options.backlog=511] The maximum length of the queue of
     *     pending connections
     * @param {Boolean} [options.clientTracking=true] Specifies whether or not to
     *     track clients
     * @param {Number} [options.closeTimeout=30000] Duration in milliseconds to
     *     wait for the closing handshake to finish after `websocket.close()` is
     *     called
     * @param {Function} [options.handleProtocols] A hook to handle protocols
     * @param {String} [options.host] The hostname where to bind the server
     * @param {Number} [options.maxPayload=104857600] The maximum allowed message
     *     size
     * @param {Boolean} [options.noServer=false] Enable no server mode
     * @param {String} [options.path] Accept only connections matching this path
     * @param {(Boolean|Object)} [options.perMessageDeflate=false] Enable/disable
     *     permessage-deflate
     * @param {Number} [options.port] The port where to bind the server
     * @param {(http.Server|https.Server)} [options.server] A pre-created HTTP/S
     *     server to use
     * @param {Boolean} [options.skipUTF8Validation=false] Specifies whether or
     *     not to skip UTF-8 validation for text and close messages
     * @param {Function} [options.verifyClient] A hook to reject connections
     * @param {Function} [options.WebSocket=WebSocket] Specifies the `WebSocket`
     *     class to use. It must be the `WebSocket` class or class that extends it
     * @param {Function} [callback] A listener for the `listening` event
     */
    constructor(D, L) {
      if (super(), D = {
        allowSynchronousEvents: !0,
        autoPong: !0,
        maxPayload: 100 * 1024 * 1024,
        skipUTF8Validation: !1,
        perMessageDeflate: !1,
        handleProtocols: null,
        clientTracking: !0,
        closeTimeout: u,
        verifyClient: null,
        noServer: !1,
        backlog: null,
        // use default (511 as implemented in net.js)
        server: null,
        host: null,
        path: null,
        port: null,
        WebSocket: o,
        ...D
      }, D.port == null && !D.server && !D.noServer || D.port != null && (D.server || D.noServer) || D.server && D.noServer)
        throw new TypeError(
          'One and only one of the "port", "server", or "noServer" options must be specified'
        );
      if (D.port != null ? (this._server = e.createServer((k, I) => {
        const U = e.STATUS_CODES[426];
        I.writeHead(426, {
          "Content-Length": U.length,
          "Content-Type": "text/plain"
        }), I.end(U);
      }), this._server.listen(
        D.port,
        D.host,
        D.backlog,
        L
      )) : D.server && (this._server = D.server), this._server) {
        const k = this.emit.bind(this, "connection");
        this._removeListeners = w(this._server, {
          listening: this.emit.bind(this, "listening"),
          error: this.emit.bind(this, "error"),
          upgrade: (I, U, j) => {
            this.handleUpgrade(I, U, j, k);
          }
        });
      }
      D.perMessageDeflate === !0 && (D.perMessageDeflate = {}), D.clientTracking && (this.clients = /* @__PURE__ */ new Set(), this._shouldEmitClose = !1), this.options = D, this._state = m;
    }
    /**
     * Returns the bound address, the address family name, and port of the server
     * as reported by the operating system if listening on an IP socket.
     * If the server is listening on a pipe or UNIX domain socket, the name is
     * returned as a string.
     *
     * @return {(Object|String|null)} The address of the server
     * @public
     */
    address() {
      if (this.options.noServer)
        throw new Error('The server is operating in "noServer" mode');
      return this._server ? this._server.address() : null;
    }
    /**
     * Stop the server from accepting new connections and emit the `'close'` event
     * when all existing connections are closed.
     *
     * @param {Function} [cb] A one-time listener for the `'close'` event
     * @public
     */
    close(D) {
      if (this._state === A) {
        D && this.once("close", () => {
          D(new Error("The server is not running"));
        }), process.nextTick(x, this);
        return;
      }
      if (D && this.once("close", D), this._state !== g)
        if (this._state = g, this.options.noServer || this.options.server)
          this._server && (this._removeListeners(), this._removeListeners = this._server = null), this.clients ? this.clients.size ? this._shouldEmitClose = !0 : process.nextTick(x, this) : process.nextTick(x, this);
        else {
          const L = this._server;
          this._removeListeners(), this._removeListeners = this._server = null, L.close(() => {
            x(this);
          });
        }
    }
    /**
     * See if a given request should be handled by this server instance.
     *
     * @param {http.IncomingMessage} req Request object to inspect
     * @return {Boolean} `true` if the request is valid, else `false`
     * @public
     */
    shouldHandle(D) {
      if (this.options.path) {
        const L = D.url.indexOf("?");
        if ((L !== -1 ? D.url.slice(0, L) : D.url) !== this.options.path) return !1;
      }
      return !0;
    }
    /**
     * Handle a HTTP Upgrade request.
     *
     * @param {http.IncomingMessage} req The request object
     * @param {Duplex} socket The network socket between the server and client
     * @param {Buffer} head The first packet of the upgraded stream
     * @param {Function} cb Callback
     * @public
     */
    handleUpgrade(D, L, k, I) {
      L.on("error", N);
      const U = D.headers["sec-websocket-key"], j = D.headers.upgrade, J = +D.headers["sec-websocket-version"];
      if (D.method !== "GET") {
        P(this, D, L, 405, "Invalid HTTP method");
        return;
      }
      if (j === void 0 || j.toLowerCase() !== "websocket") {
        P(this, D, L, 400, "Invalid Upgrade header");
        return;
      }
      if (U === void 0 || !f.test(U)) {
        P(this, D, L, 400, "Missing or invalid Sec-WebSocket-Key header");
        return;
      }
      if (J !== 13 && J !== 8) {
        P(this, D, L, 400, "Missing or invalid Sec-WebSocket-Version header", {
          "Sec-WebSocket-Version": "13, 8"
        });
        return;
      }
      if (!this.shouldHandle(D)) {
        B(L, 400);
        return;
      }
      const G = D.headers["sec-websocket-protocol"];
      let H = /* @__PURE__ */ new Set();
      if (G !== void 0)
        try {
          H = a.parse(G);
        } catch {
          P(this, D, L, 400, "Invalid Sec-WebSocket-Protocol header");
          return;
        }
      const q = D.headers["sec-websocket-extensions"], X = {};
      if (this.options.perMessageDeflate && q !== void 0) {
        const ie = new s(
          this.options.perMessageDeflate,
          !0,
          this.options.maxPayload
        );
        try {
          const te = i.parse(q);
          te[s.extensionName] && (ie.accept(te[s.extensionName]), X[s.extensionName] = ie);
        } catch {
          P(this, D, L, 400, "Invalid or unacceptable Sec-WebSocket-Extensions header");
          return;
        }
      }
      if (this.options.verifyClient) {
        const ie = {
          origin: D.headers[`${J === 8 ? "sec-websocket-origin" : "origin"}`],
          secure: !!(D.socket.authorized || D.socket.encrypted),
          req: D
        };
        if (this.options.verifyClient.length === 2) {
          this.options.verifyClient(ie, (te, Pe, We, Me) => {
            if (!te)
              return B(L, Pe || 401, We, Me);
            this.completeUpgrade(
              X,
              U,
              H,
              D,
              L,
              k,
              I
            );
          });
          return;
        }
        if (!this.options.verifyClient(ie)) return B(L, 401);
      }
      this.completeUpgrade(X, U, H, D, L, k, I);
    }
    /**
     * Upgrade the connection to WebSocket.
     *
     * @param {Object} extensions The accepted extensions
     * @param {String} key The value of the `Sec-WebSocket-Key` header
     * @param {Set} protocols The subprotocols
     * @param {http.IncomingMessage} req The request object
     * @param {Duplex} socket The network socket between the server and client
     * @param {Buffer} head The first packet of the upgraded stream
     * @param {Function} cb Callback
     * @throws {Error} If called more than once with the same socket
     * @private
     */
    completeUpgrade(D, L, k, I, U, j, J) {
      if (!U.readable || !U.writable) return U.destroy();
      if (U[h])
        throw new Error(
          "server.handleUpgrade() was called more than once with the same socket, possibly due to a misconfiguration"
        );
      if (this._state > m) return B(U, 503);
      const H = [
        "HTTP/1.1 101 Switching Protocols",
        "Upgrade: websocket",
        "Connection: Upgrade",
        `Sec-WebSocket-Accept: ${r("sha1").update(L + l).digest("base64")}`
      ], q = new this.options.WebSocket(null, void 0, this.options);
      if (k.size) {
        const X = this.options.handleProtocols ? this.options.handleProtocols(k, I) : k.values().next().value;
        X && (H.push(`Sec-WebSocket-Protocol: ${X}`), q._protocol = X);
      }
      if (D[s.extensionName]) {
        const X = D[s.extensionName].params, ie = i.format({
          [s.extensionName]: [X]
        });
        H.push(`Sec-WebSocket-Extensions: ${ie}`), q._extensions = D;
      }
      this.emit("headers", H, I), U.write(H.concat(`\r
`).join(`\r
`)), U.removeListener("error", N), q.setSocket(U, j, {
        allowSynchronousEvents: this.options.allowSynchronousEvents,
        maxPayload: this.options.maxPayload,
        skipUTF8Validation: this.options.skipUTF8Validation
      }), this.clients && (this.clients.add(q), q.on("close", () => {
        this.clients.delete(q), this._shouldEmitClose && !this.clients.size && process.nextTick(x, this);
      })), J(q, I);
    }
  }
  iT = E;
  function w(C, D) {
    for (const L of Object.keys(D)) C.on(L, D[L]);
    return function() {
      for (const k of Object.keys(D))
        C.removeListener(k, D[k]);
    };
  }
  function x(C) {
    C._state = A, C.emit("close");
  }
  function N() {
    this.destroy();
  }
  function B(C, D, L, k) {
    L = L || e.STATUS_CODES[D], k = {
      Connection: "close",
      "Content-Type": "text/html",
      "Content-Length": Buffer.byteLength(L),
      ...k
    }, C.once("finish", C.destroy), C.end(
      `HTTP/1.1 ${D} ${e.STATUS_CODES[D]}\r
` + Object.keys(k).map((I) => `${I}: ${k[I]}`).join(`\r
`) + `\r
\r
` + L
    );
  }
  function P(C, D, L, k, I, U) {
    if (C.listenerCount("wsClientError")) {
      const j = new Error(I);
      Error.captureStackTrace(j, P), C.emit("wsClientError", j, L, D);
    } else
      B(L, k, I, U);
  }
  return iT;
}
FGe();
const TGe = /^[!#$%&'*+\-.^_`|~\dA-Za-z]+$/;
let vGe = class extends Xr {
  static CONNECTING = ks.connecting;
  static OPEN = ks.open;
  static CLOSING = ks.closing;
  static CLOSED = ks.closed;
  #e = ks.closed;
  #t = "";
  #n = "blob";
  #r = null;
  #i;
  [Oi] = null;
  /**
   *
   * @param url
   * @param protocols
   */
  constructor(e, n) {
    super();
    const r = this[b];
    let i;
    try {
      i = new URL(e);
    } catch {
      throw new r.DOMException(`The URL '${e}' is invalid.`, ne.syntaxError);
    }
    if (i.protocol !== "ws:" && i.protocol !== "wss:")
      throw new r.DOMException(`The URL's protocol must be either 'ws' or 'wss'. '${i.protocol}' is not allowed.`, ne.syntaxError);
    i.hash && (i.hash = "");
    const s = /* @__PURE__ */ new Set(), a = n !== void 0 ? Array.isArray(n) ? n : [n] : [];
    for (const o of a) {
      if (!this.#d(o))
        throw new r.DOMException(`The subprotocol '${o}' is invalid.`, ne.syntaxError);
      if (s.has(o))
        throw new r.DOMException(`The subprotocol '${o}' is duplicated.`, ne.syntaxError);
      s.add(o);
    }
    this.#i = i, this.#s(i, a);
  }
  /**
   * Returns the ready state.
   *
   * @returns The ready state.
   */
  get readyState() {
    return this.#e;
  }
  /**
   * Returns the extensions.
   *
   * @returns The extensions.
   */
  get extensions() {
    return this.#t;
  }
  /**
   * Returns the binary type.
   *
   * @returns The binary type.
   */
  get binaryType() {
    return this.#n;
  }
  /**
   * Sets the binary type.
   *
   * @param value The binary type.
   */
  set binaryType(e) {
    e !== "blob" && e !== "arraybuffer" || (this.#n = e);
  }
  /**
   * Returns protocol.
   */
  get protocol() {
    return this[Oi]?.protocol || "";
  }
  /**
   * Returns the URL.
   *
   * @returns The URL.
   */
  get url() {
    return this.#i.href;
  }
  /**
   * Closes the WebSocket.
   *
   * @param [code] Code.
   * @param [reason] Reason.
   */
  close(e, n) {
    const r = this[b];
    if (e !== void 0 && e !== 1e3 && !(e >= 3e3 && e <= 4999))
      throw new r.DOMException(`The code must be either 1000, or between 3000 and 4999. ${e} is neither.`, ne.invalidAccessError);
    if (n !== void 0 && Buffer.byteLength(n, "utf8") > 123)
      throw new r.DOMException("The message must not be greater than 123 bytes.", ne.syntaxError);
    this.#u(e, n ? Buffer.from(n) : void 0);
  }
  /**
   * Sends data through the WebSocket.
   *
   * @param data Data.
   */
  send(e) {
    const n = this[b];
    if (this.#e === ks.connecting)
      throw new n.DOMException("Still in CONNECTING state.", ne.invalidStateError);
    if (this.#e !== ks.open)
      return;
    if (typeof e == "string") {
      this[Oi]?.send(e, { binary: !1 });
      return;
    }
    let r;
    e instanceof ArrayBuffer ? r = Buffer.from(new Uint8Array(e)) : e instanceof Di ? r = e[En] : e instanceof Buffer ? r = e : ArrayBuffer.isView(e) ? r = Buffer.from(new Uint8Array(e.buffer, e.byteOffset, e.byteLength)) : r = Buffer.from(String(e)), this[Oi]?.send(r, { binary: !0 });
  }
  /**
   * Destroys the WebSocket.
   */
  [tn]() {
    super[tn](), this.#u(1001);
  }
  /**
   * Connects the WebSocket.
   *
   * @param url URL.
   * @param protocols Protocols.
   */
  #s(e, n) {
    const r = this[b], i = new pt(r).getBrowserContext();
    if (!i)
      return;
    const s = new URL(r.location.href), a = i.cookieContainer.getCookies(s, !1);
    this.#e = ks.connecting, this[Oi] = new SGe(e, n, {
      headers: {
        "user-agent": r.navigator.userAgent,
        cookie: xf.cookiesToString(a),
        origin: s.origin
      },
      rejectUnauthorized: !i.browser.settings.fetch.disableStrictSSL
    }), this[Oi].once("open", () => {
      this.#l();
    }), this[Oi].on("message", this.#c.bind(this)), this[Oi].once("close", (o, u) => {
      this.#o(o, u);
    }), this[Oi].once("upgrade", ({ headers: o }) => {
      if (o["set-cookie"] !== void 0) {
        const u = Array.isArray(o["set-cookie"]) ? o["set-cookie"] : [o["set-cookie"]];
        for (const l of u) {
          const h = xf.stringToCookie(s, l);
          h && i.cookieContainer.addCookies([h]);
        }
      }
    }), this[Oi].once("error", (o) => {
      this.#r = o;
    }), r[nf].push(this);
  }
  /**
   * Closes the WebSocket connection.
   *
   * @param code Code.
   * @param reason Reason.
   */
  #u(e, n) {
    this.readyState === ks.connecting ? this[Oi] ? this[Oi].terminate() : this.#e = ks.closing : this[Oi] && this.readyState === ks.open && this[Oi].close(e, n), this[Oi] = null;
  }
  /**
   * Called when the connection has been established.
   *
   * @see https://html.spec.whatwg.org/multipage/web-sockets.html#feedback-from-the-protocol
   */
  #l() {
    this[Oi]?.extensions && (this.#t = Object.keys(this[Oi].extensions).join(", ")), this.#e = ks.open, this.dispatchEvent(new this[b].Event("open"));
  }
  /**
   * Called when the connection has been closed.
   *
   * @param code Code.
   * @param reason Reason.
   */
  #o(e, n) {
    const r = this[b], i = r[nf].indexOf(this);
    i !== -1 && r[nf].splice(i, 1), this.#e = ks.closed, this.dispatchEvent(new this[b].CloseEvent("close", {
      wasClean: this.#r === null,
      code: e,
      reason: n.toString()
    }));
  }
  /**
   * Called when a message has been received.
   *
   * @param data Data.
   * @param isBinary "true" if the data is binary.
   */
  #c(e, n) {
    if (this.#e !== ks.open)
      return;
    const r = this[b];
    let i;
    n ? this.binaryType === "arraybuffer" ? e instanceof r.ArrayBuffer ? i = e : Array.isArray(e) ? i = this.#h(Buffer.concat(e)) : i = this.#h(e) : (Array.isArray(e) || (e = [e]), i = new r.Blob(e)) : i = String(e), this.dispatchEvent(new r.MessageEvent("message", {
      data: i,
      origin: this.#i.origin
    }));
  }
  /**
   * Converts a Node.js Buffer to an ArrayBuffer.
   *
   * @param buffer Node.js Buffer.
   * @returns ArrayBuffer.
   */
  #h(e) {
    const n = this[b], r = new n.ArrayBuffer(e.byteLength);
    return new Uint8Array(r).set(e), r;
  }
  /**
   * See Sec-WebSocket-Protocol-Client, which is for the syntax of an entire header value. This function checks if a single header conforms to the rules.
   *
   * @see https://tools.ietf.org/html/rfc6455#section-4.3
   * @param protocol
   */
  #d(e) {
    return TGe.test(e);
  }
};
class xGe {
  /**
   * Extends classes with a "window" property.
   *
   * @param window Window.
   */
  static extendClasses(e) {
    class n extends kf {
    }
    n.prototype[b] = e, e.Document = n;
    class r extends xUe {
    }
    r.prototype[b] = e, e.HTMLDocument = r;
    class i extends CUe {
    }
    i.prototype[b] = e, e.XMLDocument = i;
    class s extends _W {
    }
    s.prototype[b] = e, e.DocumentFragment = s;
    class a extends kUe {
    }
    a.prototype[b] = e, e.Text = a;
    class o extends _Ue {
    }
    o.prototype[b] = e, e.Comment = o;
    class u extends NUe {
    }
    u.prototype[b] = e, e.Image = u;
    class l extends DUe {
    }
    l.prototype[b] = e, e.Audio = l;
    class h extends RUe {
    }
    h.prototype[b] = e, e.MutationObserver = h;
    class f extends PUe {
    }
    f.prototype[b] = e, e.MessagePort = f;
    class m extends MUe {
    }
    m.prototype[b] = e, e.CSSStyleSheet = m;
    class g extends Tr {
    }
    e.DOMException = g;
    class A extends G1 {
    }
    A.prototype[b] = e, e.Headers = A;
    class E extends rW {
    }
    E.prototype[b] = e, e.Request = E;
    class w extends Lu {
    }
    w.prototype[b] = e, w[b] = e, e.Response = w;
    class x extends Xr {
    }
    x.prototype[b] = e, e.EventTarget = x;
    class N extends OUe {
    }
    N.prototype[b] = e, e.XMLHttpRequestUpload = N;
    class B extends q2 {
    }
    B.prototype[b] = e, e.XMLHttpRequestEventTarget = B;
    class P extends BUe {
    }
    P.prototype[b] = e, e.AbortController = P;
    class C extends $Ue {
    }
    C.prototype[b] = e, C[b] = e, e.AbortSignal = C;
    class D extends nW {
    }
    D.prototype[b] = e, e.FormData = D;
    class L extends HUe {
    }
    L.prototype[b] = e, e.PermissionStatus = L;
    class k extends UUe {
    }
    k.prototype[b] = e, e.XMLHttpRequest = k;
    class I extends qUe {
    }
    I.prototype[b] = e, e.DOMParser = I;
    class U extends JUe {
    }
    U.prototype[b] = e, e.Range = U;
    class j extends QUe {
    }
    j.prototype[b] = e, e.VTTCue = j;
    class J extends XUe {
    }
    J.prototype[b] = e, e.TextTrack = J;
    class G extends ZUe {
    }
    G.prototype[b] = e, e.TextTrackList = G;
    class H extends NW {
    }
    H.prototype[b] = e, e.TextTrackCue = H;
    class q extends eGe {
    }
    q.prototype[b] = e, e.RemotePlayback = q;
    class X extends oGe {
    }
    X.prototype[b] = e, e.FileReader = X;
    class ie extends mW {
    }
    ie.prototype[b] = e, e.MediaStream = ie;
    class te extends IW {
    }
    te.prototype[b] = e, e.MediaStreamTrack = te;
    class Pe extends cGe {
    }
    Pe.prototype[b] = e, e.CanvasCaptureMediaStreamTrack = Pe;
    class We extends vi {
    }
    We.prototype[b] = e, e.URL = We;
    class Me extends vGe {
    }
    Me.prototype[b] = e, e.WebSocket = Me;
  }
}
class CGe {
  [me] = 0;
  [ge] = 0;
  [aa] = 0;
  [dg] = 1;
  /**
   * Constructor.
   *
   * @param [x] X position.
   * @param [y] Y position.
   * @param [z] Width.
   * @param [w] Height.
   */
  constructor(e, n, r, i) {
    this[me] = e != null ? Number(e) : 0, this[ge] = n != null ? Number(n) : 0, this[aa] = r != null ? Number(r) : 0, this[dg] = i != null ? Number(i) : 1;
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge];
  }
  /**
   * Returns z.
   *
   * @returns Z.
   */
  get z() {
    return this[aa];
  }
  /**
   * Returns w.
   *
   * @returns W.
   */
  get w() {
    return this[dg];
  }
  /**
   * Returns the JSON representation of the object.
   *
   * @returns JSON representation.
   */
  toJSON() {
    return {
      x: this.x,
      y: this.y,
      z: this.z,
      w: this.w
    };
  }
  /**
   * Returns a new DOMPointReadOnly object.
   *
   * @param [otherPoint] Other point.
   * @returns Cloned object.
   */
  static fromPoint(e) {
    return e ? new this(e.x ?? null, e.y ?? null, e.z ?? null, e.w ?? null) : new this();
  }
}
class MW extends CGe {
  /**
   * Sets x.
   *
   * @param value X.
   */
  set x(e) {
    this[me] = e;
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me];
  }
  /**
   * Sets y.
   *
   * @param value Y.
   */
  set y(e) {
    this[ge] = e;
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge];
  }
  /**
   * Sets z.
   *
   * @param value Z.
   */
  set z(e) {
    this[aa] = e;
  }
  /**
   * Returns z.
   *
   * @returns Z.
   */
  get z() {
    return this[aa];
  }
  /**
   * Sets w.
   *
   * @param value W.
   */
  set w(e) {
    this[dg] = e;
  }
  /**
   * Returns w.
   *
   * @returns W.
   */
  get w() {
    return this[dg];
  }
}
const fd = {
  a: 1,
  b: 0,
  c: 0,
  d: 1,
  e: 0,
  f: 0,
  m11: 1,
  m12: 0,
  m13: 0,
  m14: 0,
  m21: 0,
  m22: 1,
  m23: 0,
  m24: 0,
  m31: 0,
  m32: 0,
  m33: 1,
  m34: 0,
  m41: 0,
  m42: 0,
  m43: 0,
  m44: 1,
  is2D: !0,
  isIdentity: !0
}, kGe = /([a-zA-Z0-9]+)\(([^)]+)\)/gm, _Ge = /[\s,]+/;
class Gg {
  [Nt] = 1;
  [Lt] = 0;
  [an] = 0;
  [on] = 0;
  [Dt] = 0;
  [Mt] = 1;
  [un] = 0;
  [ln] = 0;
  [Vt] = 0;
  [Qt] = 0;
  [Xt] = 1;
  [Kt] = 0;
  [It] = 0;
  [Ot] = 0;
  [Zt] = 0;
  [en] = 1;
  /**
   * Constructor.
   *
   * @param init Init parameter.
   */
  constructor(e) {
    e && this[Hy](e);
  }
  /**
   * Returns the `a` value of the matrix.
   */
  get a() {
    return this[Nt];
  }
  /**
   * Returns the `b` value of the matrix.
   */
  get b() {
    return this[Lt];
  }
  /**
   * Returns the `c` value of the matrix.
   */
  get c() {
    return this[Dt];
  }
  /**
   * Returns the `d` value of the matrix.
   */
  get d() {
    return this[Mt];
  }
  /**
   * Returns the `e` value of the matrix.
   */
  get e() {
    return this[It];
  }
  /**
   * Returns the `f` value of the matrix.
   */
  get f() {
    return this[Ot];
  }
  /**
   * Returns the `m11` value of the matrix.
   */
  get m11() {
    return this[Nt];
  }
  /**
   * Returns the `m12` value of the matrix.
   */
  get m12() {
    return this[Lt];
  }
  /**
   * Returns the `m13` value of the matrix.
   */
  get m13() {
    return this[an];
  }
  /**
   * Returns the `m14` value of the matrix.
   */
  get m14() {
    return this[on];
  }
  /**
   * Returns the `m21` value of the matrix.
   */
  get m21() {
    return this[Dt];
  }
  /**
   * Returns the `m22` value of the matrix.
   */
  get m22() {
    return this[Mt];
  }
  /**
   * Returns the `m23` value of the matrix.
   */
  get m23() {
    return this[un];
  }
  /**
   * Returns the `m24` value of the matrix.
   */
  get m24() {
    return this[ln];
  }
  /**
   * Returns the `m31` value of the matrix.
   */
  get m31() {
    return this[Vt];
  }
  /**
   * Returns the `m32` value of the matrix.
   */
  get m32() {
    return this[Qt];
  }
  /**
   * Returns the `m33` value of the matrix.
   */
  get m33() {
    return this[Xt];
  }
  /**
   * Returns the `m34` value of the matrix.
   */
  get m34() {
    return this[Kt];
  }
  /**
   * Returns the `m41` value of the matrix.
   */
  get m41() {
    return this[It];
  }
  /**
   * Returns the `m42` value of the matrix.
   */
  get m42() {
    return this[Ot];
  }
  /**
   * Returns the `m43` value of the matrix.
   */
  get m43() {
    return this[Zt];
  }
  /**
   * Returns the `m44` value of the matrix.
   */
  get m44() {
    return this[en];
  }
  /**
   * A `Boolean` whose value is `true` if the matrix is the identity matrix.
   *
   * The identity matrix is one in which every value is 0 except those on the main diagonal from top-left to bottom-right corner (in other words, where the offsets in each direction are equal).
   *
   * @returns "true" if the matrix is the identity matrix.
   */
  get isIdentity() {
    return this[Nt] === 1 && this[Lt] === 0 && this[an] === 0 && this[on] === 0 && this[Dt] === 0 && this[Mt] === 1 && this[un] === 0 && this[ln] === 0 && this[Vt] === 0 && this[Qt] === 0 && this[Xt] === 1 && this[Kt] === 0 && this[It] === 0 && this[Ot] === 0 && this[Zt] === 0 && this[en] === 1;
  }
  /**
   * A `Boolean` flag whose value is `true` if the matrix is a 2D matrix and `false` if the matrix is 3D.
   *
   * @returns "true" if the matrix is a 2D matrix.
   */
  get is2D() {
    return this[Vt] === 0 && this[Qt] === 0 && this[Xt] === 1 && this[Kt] === 0 && this[Zt] === 0 && this[en] === 1;
  }
  /**
   * Returns a *Float32Array* containing elements which comprise the matrix.
   *
   * The method can return either the 16 elements or the 6 elements depending on the value of the `is2D` parameter.
   *
   * @param [is2D] Set to `true` to return a 2D matrix.
   * @returns An *Array* representation of the matrix.
   */
  toFloat32Array(e) {
    return Float32Array.from(this[Rb](e));
  }
  /**
   * Returns a *Float64Array* containing elements which comprise the matrix.
   *
   * The method can return either the 16 elements or the 6 elements depending on the value of the `is2D` parameter.
   *
   * @param [is2D] Set to `true` to return a 2D matrix.
   * @returns An *Array* representation of the matrix
   */
  toFloat64Array(e) {
    return Float64Array.from(this[Rb](e));
  }
  /**
   * Returns a string representation of the matrix in `CSS` matrix syntax, using the appropriate `CSS` matrix notation.
   *
   * Examples:
   * - `matrix3d(m11, m12, m13, m14, m21, ...)`
   * - `matrix(a, b, c, d, e, f)`
   *
   * @returns A string representation of the matrix.
   */
  toString() {
    const e = this.is2D, n = this[Rb](e).join(", ");
    return `${e ? "matrix" : "matrix3d"}(${n})`;
  }
  /**
   * Returns an Object that can be serialized to a JSON string.
   *
   * The result can be used as a second parameter for the `fromMatrix` static method to load values into another matrix instance.
   *
   * @returns An *Object* with matrix values.
   */
  toJSON() {
    const { is2D: e, isIdentity: n } = this;
    return {
      m11: this[Nt],
      m12: this[Lt],
      m13: this[an],
      m14: this[on],
      m21: this[Dt],
      m22: this[Mt],
      m23: this[un],
      m24: this[ln],
      m31: this[Vt],
      m32: this[Qt],
      m33: this[Xt],
      m34: this[Kt],
      m41: this[It],
      m42: this[Ot],
      m43: this[Zt],
      m44: this[en],
      a: this[Nt],
      b: this[Lt],
      c: this[Dt],
      d: this[Mt],
      e: this[It],
      f: this[Ot],
      is2D: e,
      isIdentity: n
    };
  }
  /**
   * Returns a new DOMMatrix instance which is the result of this matrix multiplied by the passed matrix.
   *
   * @param secondMatrix DOMMatrix
   * @returns A new DOMMatrix object.
   */
  multiply(e) {
    const n = new this.constructor(this);
    return n[wa](e), n;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix post multiplied by a translation matrix containing the passed values.
   *
   * @param [x=0] X component of the translation value.
   * @param [y=0] Y component of the translation value.
   * @param [z=0] Z component of the translation value.
   * @returns The resulted matrix
   */
  translate(e = 0, n = 0, r = 0) {
    const i = new this.constructor(this);
    return i[Sa](e, n, r), i;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix post multiplied by a scale 2D matrix containing the passed values.
   *
   * @param [scaleX] X-Axis scale.
   * @param [scaleY] Y-Axis scale.
   * @param [scaleZ] Z-Axis scale.
   * @param [originX] X-Axis scale.
   * @param [originY] Y-Axis scale.
   * @param [originZ] Z-Axis scale.
   * @returns The resulted matrix
   */
  scale(e, n, r = 1, i = 0, s = 0, a = 0) {
    const o = new this.constructor(this);
    return o[Tl](e, n, r, i, s, a), o;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix post multiplied by a scale 3D matrix containing the passed values.
   *
   * @param [scale] The scale factor.
   * @param [originX] X-Axis scale.
   * @param [originY] Y-Axis scale.
   * @param [originZ] Z-Axis scale.
   * @returns The resulted matrix
   */
  scale3d(e = 1, n = 0, r = 0, i = 0) {
    const s = new this.constructor(this);
    return s[vv](e, n, r, i), s;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix post multiplied by a scale 3D matrix containing the passed values.
   *
   * @param [scaleX] X-Axis scale.
   * @param [scaleY] Y-Axis scale.
   * @returns The resulted matrix
   */
  scaleNonUniform(e = 1, n = 1) {
    const r = new this.constructor(this);
    return r[xv](e, n), r;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix post multiplied by a rotation matrix with the given axis and `angle`.
   *
   * @param [x] The X component of the axis vector.
   * @param [y] The Y component of the axis vector.
   * @param [z] The Z component of the axis vector.
   * @param [angle] Angle of rotation about the axis vector, in degrees.
   * @returns The resulted matrix
   */
  rotateAxisAngle(e = 0, n = 0, r = 0, i = 0) {
    const s = new this.constructor(this);
    return s[Qc](e, n, r, i), s;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix post multiplied by each of 3 rotation matrices about the major axes, first X, then Y, then Z.
   *
   * @param [x] X component of the rotation, or Z if Y and Z are null.
   * @param [y] Y component of the rotation value.
   * @param [z] Z component of the rotation value.
   * @returns The resulted matrix
   */
  rotate(e = 0, n, r) {
    const i = new this.constructor(this);
    return i[Jc](e, n, r), i;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix post multiplied by a rotation matrix with the angle between the specified vector and (1, 0).
   *
   * @param [x] X-Axis skew.
   * @param [y] Y-Axis skew.
   */
  rotateFromVector(e = 0, n = 0) {
    const r = new this.constructor(this);
    return r[Cv](e, n), r;
  }
  /**
   * Returns a new DOMMatrix instance that specifies a skew transformation along X-Axis by the given angle.
   *
   * @param angle Angle amount in degrees to skew.
   * @returns The resulted matrix
   */
  skewX(e) {
    const n = new this.constructor(this);
    return n[Um](e), n;
  }
  /**
   * Returns a new DOMMatrix instance that specifies a skew transformation along Y-Axis by the given angle.
   *
   * @param angle Angle amount in degrees to skew.
   * @returns The resulted matrix
   */
  skewY(e) {
    const n = new this.constructor(this);
    return n[Gm](e), n;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix flipped on X-axis.
   */
  flipX() {
    const e = new this.constructor(this);
    return e[kv](), e;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix flipped on Y-axis.
   */
  flipY() {
    const e = new this.constructor(this);
    return e[_v](), e;
  }
  /**
   * Returns a new DOMMatrix instance which is this matrix inversed.
   */
  inverse() {
    const e = new this.constructor(this);
    return e[Nv](), e;
  }
  /**
   * Returns a new DOMPoint instance with the vector transformed using the matrix.
   *
   * @param domPoint DOM point compatible object.
   * @returns A new DOMPoint object.
   */
  transformPoint(e) {
    const n = e.x ?? 0, r = e.y ?? 0, i = e.z ?? 0, s = e.w ?? 1, a = this[Nt] * n + this[Dt] * r + this[Vt] * i + this[It] * s, o = this[Lt] * n + this[Mt] * r + this[Qt] * i + this[Ot] * s, u = this[an] * n + this[un] * r + this[Xt] * i + this[Zt] * s, l = this[on] * n + this[ln] * r + this[Kt] * i + this[en] * s;
    return new MW(a, o, u, l);
  }
  /**
   * The `setMatrixValue` method replaces the existing matrix with one computed in the browser (e.g.`matrix(1,0.25,-0.25,1,0,0)`).
   *
   * @param source A `DOMMatrix`, `Float32Array`, `Float64Array`, `Array`, or DOMMatrix compatible object to set the matrix values from.
   */
  [Hy](e) {
    let n = null;
    if (typeof e == "string" && e.length && e !== "none")
      n = this.constructor[fg](e);
    else if (Array.isArray(e) || e instanceof Float64Array || e instanceof Float32Array)
      n = this.constructor[Xs](e);
    else if (typeof e == "object")
      n = this.constructor.fromMatrix(e);
    else
      return;
    this[Nt] = n[Nt], this[Lt] = n[Lt], this[an] = n[an], this[on] = n[on], this[Dt] = n[Dt], this[Mt] = n[Mt], this[un] = n[un], this[ln] = n[ln], this[Vt] = n[Vt], this[Qt] = n[Qt], this[Xt] = n[Xt], this[Kt] = n[Kt], this[It] = n[It], this[Ot] = n[Ot], this[Zt] = n[Zt], this[en] = n[en];
  }
  /**
   * Applies a multiply operation to the current matrix.
   *
   * @param matrixCompatibleObject Second matrix.
   */
  [wa](e) {
    let n = e;
    n instanceof Gg || (n?.m11 === void 0 && n?.a !== void 0 ? (n = Object.assign({}, fd, n), n.m11 = n.a, n.m12 = n.b, n.m21 = n.c, n.m22 = n.d, n.m41 = n.e, n.m42 = n.f) : n = Object.assign({}, fd, n));
    const r = this[Nt] * n.m11 + this[Dt] * n.m12 + this[Vt] * n.m13 + this[It] * n.m14, i = this[Nt] * n.m21 + this[Dt] * n.m22 + this[Vt] * n.m23 + this[It] * n.m24, s = this[Nt] * n.m31 + this[Dt] * n.m32 + this[Vt] * n.m33 + this[It] * n.m34, a = this[Nt] * n.m41 + this[Dt] * n.m42 + this[Vt] * n.m43 + this[It] * n.m44, o = this[Lt] * n.m11 + this[Mt] * n.m12 + this[Qt] * n.m13 + this[Ot] * n.m14, u = this[Lt] * n.m21 + this[Mt] * n.m22 + this[Qt] * n.m23 + this[Ot] * n.m24, l = this[Lt] * n.m31 + this[Mt] * n.m32 + this[Qt] * n.m33 + this[Ot] * n.m34, h = this[Lt] * n.m41 + this[Mt] * n.m42 + this[Qt] * n.m43 + this[Ot] * n.m44, f = this[an] * n.m11 + this[un] * n.m12 + this[Xt] * n.m13 + this[Zt] * n.m14, m = this[an] * n.m21 + this[un] * n.m22 + this[Xt] * n.m23 + this[Zt] * n.m24, g = this[an] * n.m31 + this[un] * n.m32 + this[Xt] * n.m33 + this[Zt] * n.m34, A = this[an] * n.m41 + this[un] * n.m42 + this[Xt] * n.m43 + this[Zt] * n.m44, E = this[on] * n.m11 + this[ln] * n.m12 + this[Kt] * n.m13 + this[en] * n.m14, w = this[on] * n.m21 + this[ln] * n.m22 + this[Kt] * n.m23 + this[en] * n.m24, x = this[on] * n.m31 + this[ln] * n.m32 + this[Kt] * n.m33 + this[en] * n.m34, N = this[on] * n.m41 + this[ln] * n.m42 + this[Kt] * n.m43 + this[en] * n.m44;
    this[Nt] = r, this[Lt] = o, this[an] = f, this[on] = E, this[Dt] = i, this[Mt] = u, this[un] = m, this[ln] = w, this[Vt] = s, this[Qt] = l, this[Xt] = g, this[Kt] = x, this[It] = a, this[Ot] = h, this[Zt] = A, this[en] = N;
  }
  /**
   * Applies translate to the matrix.
   *
   * This method is equivalent to the CSS `translate3d()` function.
   *
   * @see https://drafts.csswg.org/css-transforms-1/#TranslateDefined
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/translate3d
   * @see https://www.w3.org/TR/css-transforms-1/#transform-functions
   * @param [x] X-Axis position.
   * @param [y] Y-Axis position.
   * @param [z] Z-Axis position.
   */
  [Sa](e = 0, n = 0, r = 0) {
    const i = this.constructor[Xs]([
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      e,
      n,
      r,
      1
    ]);
    this[wa](i);
  }
  /**
   * Applies a scale to the matrix.
   *
   * This method is equivalent to the CSS `scale()` function.
   *
   * @see https://drafts.csswg.org/css-transforms-1/#ScaleDefined
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/scale
   * @see https://www.w3.org/TR/css-transforms-1/#transform-functions
   * @param [scaleX] X-Axis scale.
   * @param [scaleY] Y-Axis scale.
   * @param [scaleZ] Z-Axis scale.
   * @param [originX] X-Axis scale.
   * @param [originY] Y-Axis scale.
   * @param [originZ] Z-Axis scale.
   */
  [Tl](e, n, r = 1, i = 0, s = 0, a = 0) {
    e = e === void 0 ? 1 : Number(e), n = n === void 0 ? e : Number(n), (i !== 0 || s !== 0 || a !== 0) && this[Sa](i, s, a), (e !== 1 || n !== 1 || r !== 1) && this[wa](this.constructor[Xs]([
      e,
      0,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      0,
      r,
      0,
      0,
      0,
      0,
      1
    ])), (i !== 0 || s !== 0 || a !== 0) && this[Sa](-i, -s, -a);
  }
  /**
   * Applies a scale to the matrix.
   *
   * This method is equivalent to the CSS `scale()` function.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/scale3d
   * @see https://www.w3.org/TR/css-transforms-1/#transform-functions
   * @param [scale] The scale factor.
   * @param [originX] X-Axis scale.
   * @param [originY] Y-Axis scale.
   * @param [originZ] Z-Axis scale.
   */
  [vv](e = 1, n = 0, r = 0, i = 0) {
    (n !== 0 || r !== 0 || i !== 0) && this[Sa](n, r, i), e !== 1 && this[wa](this.constructor[Xs]([
      e,
      0,
      0,
      0,
      0,
      e,
      0,
      0,
      0,
      0,
      e,
      0,
      0,
      0,
      0,
      1
    ])), (n !== 0 || r !== 0 || i !== 0) && this[Sa](-n, -r, -i);
  }
  /**
   * Applies a scale to the matrix.
   *
   * @see https://www.w3.org/TR/css-transforms-1/#transform-functions
   * @param [scaleX] X-Axis scale.
   * @param [scaleY] Y-Axis scale.
   */
  [xv](e = 1, n = 1) {
    e === 1 && n === 1 || this[wa](this.constructor[Xs]([
      e,
      0,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ]));
  }
  /**
   * Applies a rotation to the matrix.
   *
   * This method is equivalent to the CSS `rotate3d()` function.
   *
   * @see https://drafts.fxtf.org/geometry/#dom-dommatrixreadonly-rotateaxisangleself
   * @see https://www.w3.org/TR/css-transforms-1/#transform-functions
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate3d
   * @param [x] X-Axis vector.
   * @param [y] Y-Axis vector.
   * @param [z] Z-Axis vector.
   * @param [angle] Angle in degrees of the rotation.
   */
  [Qc](e = 0, n = 0, r = 0, i = 0) {
    if (e = Number(e), n = Number(n), r = Number(r), i = Number(i), isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i))
      throw new TypeError("Failed to execute 'rotateAxisAngleSelf' on 'DOMMatrix': The arguments must be numbers.");
    const s = Math.hypot(e, n, r);
    if (s === 0)
      return;
    s !== 1 && (e /= s, n /= s, r /= s);
    const a = -(i * Math.PI / 360), o = this.#e, u = Math.sin(a) * Math.cos(a), l = Math.sin(a) * Math.sin(a), h = o(1 - 2 * (n * n + r * r) * l), f = o(2 * (e * n * l + r * u)), m = o(2 * (e * r * l - n * u)), g = o(2 * (e * n * l - r * u)), A = o(1 - 2 * (e * e + r * r) * l), E = o(2 * (n * r * l + e * u)), w = o(2 * (e * r * l + n * u)), x = o(2 * (n * r * l - e * u)), N = o(1 - 2 * (e * e + n * n) * l), B = this.constructor[Xs]([
      h,
      g,
      w,
      0,
      f,
      A,
      x,
      0,
      m,
      E,
      N,
      0,
      0,
      0,
      0,
      1
    ]);
    this[wa](B);
  }
  /**
   * Applies a rotation to the matrix.
   *
   * @see http://en.wikipedia.org/wiki/Rotation_matrix
   * @see https://www.w3.org/TR/css-transforms-1/#transform-functions
   * @param [x] X-Axis rotation in degrees.
   * @param [y] Y-Axis rotation in degrees.
   * @param [z] Z-Axis rotation in degrees.
   */
  [Jc](e = 0, n, r) {
    if (n === void 0 && r === void 0 && (r = e, e = 0, n = 0), n === void 0 && (n = 0), r === void 0 && (r = 0), e = Number(e), n = Number(n), r = Number(r), isNaN(e) || isNaN(n) || isNaN(r))
      throw new TypeError("Failed to execute 'rotateSelf' on 'DOMMatrix': The arguments must be numbers.");
    r !== 0 && this[Qc](0, 0, 1, r), n !== 0 && this[Qc](0, 1, 0, n), e !== 0 && this[Qc](1, 0, 0, e);
  }
  /**
   * Modifies the matrix by rotating it by the angle between the specified vector and (1, 0).
   *
   * @param x The X component of the axis vector.
   * @param y The Y component of the axis vector.
   */
  [Cv](e = 0, n = 0) {
    e === 0 && n === 0 || this[Jc](Math.atan2(n, e) * 180 / Math.PI);
  }
  /**
   * Applies a skew operation to the matrix on the X axis.
   *
   * This method is equivalent to the CSS `skewX()` function.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/skewX
   * @see https://www.w3.org/TR/css-transforms-1/#transform-functions
   * @param angle Angle in degrees.
   */
  [Um](e) {
    const n = Object.assign({}, fd), r = Math.tan(e * Math.PI / 180);
    n.m21 = r, n.c = r, this[wa](n);
  }
  /**
   * Applies a skew operation to the matrix on the Y axis.
   *
   * This method is equivalent to the CSS `skewY()` function.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/skewY
   * @see https://www.w3.org/TR/css-transforms-1/#transform-functions
   * @param angle Angle in degrees.
   */
  [Gm](e) {
    const n = Object.assign({}, fd), r = Math.tan(e * Math.PI / 180);
    n.m12 = r, n.b = r, this[wa](n);
  }
  /**
   * Applies a flip operation to the matrix on the X axis.
   */
  [kv]() {
    const e = this.constructor[Xs]([
      -1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ]);
    this[wa](e);
  }
  /**
   * Applies a flip operation to the matrix on the Y axis.
   */
  [_v]() {
    const e = this.constructor[Xs]([
      1,
      0,
      0,
      0,
      0,
      -1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ]);
    this[wa](e);
  }
  /**
   * Applies an inversion operation to the matrix.
   */
  [Nv]() {
    const e = this[Mt] * this[Xt] * this[en] - this[Mt] * this[Kt] * this[Zt] - this[Qt] * this[un] * this[en] + this[Qt] * this[ln] * this[Zt] + this[Ot] * this[un] * this[Kt] - this[Ot] * this[ln] * this[Xt], n = -this[Lt] * this[Xt] * this[en] + this[Lt] * this[Kt] * this[Zt] + this[Qt] * this[an] * this[en] - this[Qt] * this[on] * this[Zt] - this[Ot] * this[an] * this[Kt] + this[Ot] * this[on] * this[Xt], r = this[Lt] * this[un] * this[en] - this[Lt] * this[ln] * this[Zt] - this[Mt] * this[an] * this[en] + this[Mt] * this[on] * this[Zt] + this[Ot] * this[an] * this[ln] - this[Ot] * this[on] * this[un], i = -this[Lt] * this[un] * this[Kt] + this[Lt] * this[ln] * this[Xt] + this[Mt] * this[an] * this[Kt] - this[Mt] * this[on] * this[Xt] - this[Qt] * this[an] * this[ln] + this[Qt] * this[on] * this[un], s = this[Nt] * e + this[Dt] * n + this[Vt] * r + this[It] * i;
    if (s === 0) {
      this[Nt] = NaN, this[Lt] = NaN, this[an] = NaN, this[on] = NaN, this[Dt] = NaN, this[Mt] = NaN, this[un] = NaN, this[ln] = NaN, this[Vt] = NaN, this[Qt] = NaN, this[Xt] = NaN, this[Kt] = NaN, this[It] = NaN, this[Ot] = NaN, this[Zt] = NaN, this[en] = NaN;
      return;
    }
    const a = -this[Dt] * this[Xt] * this[en] + this[Dt] * this[Kt] * this[Zt] + this[Vt] * this[un] * this[en] - this[Vt] * this[ln] * this[Zt] - this[It] * this[un] * this[Kt] + this[It] * this[ln] * this[Xt], o = this[Nt] * this[Xt] * this[en] - this[Nt] * this[Kt] * this[Zt] - this[Vt] * this[an] * this[en] + this[Vt] * this[on] * this[Zt] + this[It] * this[an] * this[Kt] - this[It] * this[on] * this[Xt], u = -this[Nt] * this[un] * this[en] + this[Nt] * this[ln] * this[Zt] + this[Dt] * this[an] * this[en] - this[Dt] * this[on] * this[Zt] - this[It] * this[an] * this[ln] + this[It] * this[on] * this[un], l = this[Nt] * this[un] * this[Kt] - this[Nt] * this[ln] * this[Xt] - this[Dt] * this[an] * this[Kt] + this[Dt] * this[on] * this[Xt] + this[Vt] * this[an] * this[ln] - this[Vt] * this[on] * this[un], h = this[Dt] * this[Qt] * this[en] - this[Dt] * this[Kt] * this[Ot] - this[Vt] * this[Mt] * this[en] + this[Vt] * this[ln] * this[Ot] + this[It] * this[Mt] * this[Kt] - this[It] * this[ln] * this[Qt], f = -this[Nt] * this[Qt] * this[en] + this[Nt] * this[Kt] * this[Ot] + this[Vt] * this[Lt] * this[en] - this[Vt] * this[on] * this[Ot] - this[It] * this[Lt] * this[Kt] + this[It] * this[on] * this[Qt], m = this[Nt] * this[Mt] * this[en] - this[Nt] * this[ln] * this[Ot] - this[Dt] * this[Lt] * this[en] + this[Dt] * this[on] * this[Ot] + this[It] * this[Lt] * this[ln] - this[It] * this[on] * this[Mt], g = -this[Nt] * this[Mt] * this[Kt] + this[Nt] * this[ln] * this[Qt] + this[Dt] * this[Lt] * this[Kt] - this[Dt] * this[on] * this[Qt] - this[Vt] * this[Lt] * this[ln] + this[Vt] * this[on] * this[Mt], A = -this[Dt] * this[Qt] * this[Zt] + this[Dt] * this[Xt] * this[Ot] + this[Vt] * this[Mt] * this[Zt] - this[Vt] * this[un] * this[Ot] - this[It] * this[Mt] * this[Xt] + this[It] * this[un] * this[Qt], E = this[Nt] * this[Qt] * this[Zt] - this[Nt] * this[Xt] * this[Ot] - this[Vt] * this[Lt] * this[Zt] + this[Vt] * this[an] * this[Ot] + this[It] * this[Lt] * this[Xt] - this[It] * this[an] * this[Qt], w = -this[Nt] * this[Mt] * this[Zt] + this[Nt] * this[un] * this[Ot] + this[Dt] * this[Lt] * this[Zt] - this[Dt] * this[an] * this[Ot] - this[It] * this[Lt] * this[un] + this[It] * this[an] * this[Mt], x = this[Nt] * this[Mt] * this[Xt] - this[Nt] * this[un] * this[Qt] - this[Dt] * this[Lt] * this[Xt] + this[Dt] * this[an] * this[Qt] + this[Vt] * this[Lt] * this[un] - this[Vt] * this[an] * this[Mt];
    this[Nt] = e / s || 0, this[Lt] = n / s || 0, this[an] = r / s || 0, this[on] = i / s || 0, this[Dt] = a / s || 0, this[Mt] = o / s || 0, this[un] = u / s || 0, this[ln] = l / s || 0, this[Vt] = h / s || 0, this[Qt] = f / s || 0, this[Xt] = m / s || 0, this[Kt] = g / s || 0, this[It] = A / s || 0, this[Ot] = E / s || 0, this[Zt] = w / s || 0, this[en] = x / s || 0;
  }
  /**
   * Returns an *Array* containing elements which comprise the matrix.
   *
   * @param matrix Matrix to convert.
   * @param [is2D] If the matrix is 2D.
   * @returns Array representation of the matrix.
   */
  [Rb](e = !1) {
    return e ? [
      this[Nt],
      this[Lt],
      this[Dt],
      this[Mt],
      this[It],
      this[Ot]
    ] : [
      this[Nt],
      this[Lt],
      this[an],
      this[on],
      this[Dt],
      this[Mt],
      this[un],
      this[ln],
      this[Vt],
      this[Qt],
      this[Xt],
      this[Kt],
      this[It],
      this[Ot],
      this[Zt],
      this[en]
    ];
  }
  /**
   * Rounds the value to the given number of decimals.
   *
   * @param value The value to round.
   * @param [decimals] The number of decimals to round to.
   */
  #e(e, n = 1e15) {
    return Math.round(e * n) / n;
  }
  /**
   * Returns a new `DOMMatrix` instance given an existing matrix.
   *
   * @param matrix Matrix.
   */
  static fromMatrix(e) {
    return e instanceof Gg || (e?.m11 === void 0 && e?.a !== void 0 ? (e = Object.assign({}, fd, e), e.m11 = e.a, e.m12 = e.b, e.m21 = e.c, e.m22 = e.d, e.m41 = e.e, e.m42 = e.f) : e = Object.assign({}, fd, e)), this[Xs]([
      e.m11,
      e.m12,
      e.m13,
      e.m14,
      e.m21,
      e.m22,
      e.m23,
      e.m24,
      e.m31,
      e.m32,
      e.m33,
      e.m34,
      e.m41,
      e.m42,
      e.m43,
      e.m44
    ]);
  }
  /**
   * Returns a new `DOMMatrix` instance given an array of 16/6 floating point values.
   *
   * @param array An `Array` to feed values from.
   * @returns DOMMatrix instance.
   */
  static fromFloat32Array(e) {
    return this[Xs](e);
  }
  /**
   * Returns a new `DOMMatrix` instance given an array of 16/6 floating point values.
   *
   * @param array An `Array` to feed values from.
   * @returns DOMMatrix instance.
   */
  static fromFloat64Array(e) {
    return this[Xs](e);
  }
  /**
   * Returns a new `DOMMatrix` instance given an array of 16/6 floating point values.
   *
   * Conditions:
   * - If the array has six values, the result is a 2D matrix.
   * - If the array has 16 values, the result is a 3D matrix.
   * - Otherwise, a TypeError exception is thrown.
   *
   * @param array An `Array` to feed values from.
   * @returns DOMMatrix instance.
   */
  static [Xs](e) {
    if (!(e instanceof Float64Array || e instanceof Float32Array || Array.isArray(e)) || e.length !== 6 && e.length !== 16)
      throw TypeError(`Failed to execute 'fromArray' on '${this.name}': '${String(e)}' is not a compatible array.`);
    const n = new this();
    if (e.length === 16) {
      const [r, i, s, a, o, u, l, h, f, m, g, A, E, w, x, N] = e;
      n[Nt] = r, n[Lt] = i, n[an] = s, n[on] = a, n[Dt] = o, n[Mt] = u, n[un] = l, n[ln] = h, n[Vt] = f, n[Qt] = m, n[Xt] = g, n[Kt] = A, n[It] = E, n[Ot] = w, n[Zt] = x, n[en] = N;
    } else if (e.length === 6) {
      const [r, i, s, a, o, u] = e;
      n[Nt] = r, n[Lt] = i, n[Dt] = s, n[Mt] = a, n[It] = o, n[Ot] = u;
    }
    return n;
  }
  /**
   * Returns a new `DOMMatrix` instance from a DOM transform string.
   *
   * @param source valid CSS transform string syntax.
   * @returns DOMMatrix instance.
   */
  static [fg](e) {
    if (typeof e != "string")
      throw TypeError(`Failed to execute 'setMatrixValue' on '${this.name}': Expected '${String(e)}' to be a string.`);
    const n = new this(), r = new RegExp(kGe);
    let i;
    for (; i = r.exec(e); ) {
      const s = i[1], a = i[2].split(_Ge);
      for (let f = 0, m = a.length; f < m; f++)
        a[f] = this[xL](a[f]);
      const [o, u, l, h] = a;
      switch (s) {
        case "perspective":
          !isNaN(o) && o !== 0 && u === void 0 && l === void 0 && (n[Kt] = -1 / o);
          break;
        case "translate":
          !isNaN(o) && l === void 0 && n[Sa](o, u || 0, 0);
          break;
        case "translate3d":
          !isNaN(o) && !isNaN(u) && !isNaN(l) && n[Sa](o, u, l);
          break;
        case "translateX":
          !isNaN(o) && u === void 0 && l === void 0 && n[Sa](o);
          break;
        case "translateY":
          !isNaN(o) && u === void 0 && l === void 0 && n[Sa](0, o);
          break;
        case "translateZ":
          !isNaN(o) && u === void 0 && l === void 0 && n[Sa](0, 0, o);
          break;
        case "matrix":
        case "matrix3d":
          (a.length === 6 || a.length === 16) && n[Hy](this[Xs](a));
          break;
        case "rotate":
        case "rotateZ":
          !isNaN(o) && u === void 0 && l === void 0 && n[Jc](0, 0, o);
          break;
        case "rotateX":
          !isNaN(o) && u === void 0 && l === void 0 && n[Jc](o, 0, 0);
          break;
        case "rotateY":
          !isNaN(o) && u === void 0 && l === void 0 && n[Jc](0, o, 0);
        case "rotate3d":
          !isNaN(o) && !isNaN(u) && !isNaN(l) && !isNaN(h) && n[Qc](o, u, l, h);
          break;
        case "scale":
          !isNaN(o) && o !== 1 && l === void 0 && n[Tl](o, isNaN(u) ? o : u);
          break;
        case "scale3d":
          !isNaN(o) && !isNaN(u) && !isNaN(l) && n[Tl](o, u, l);
          break;
        case "scaleX":
          !isNaN(o) && u === void 0 && l === void 0 && n[Tl](o, 1, 1);
          break;
        case "scaleY":
          !isNaN(o) && u === void 0 && l === void 0 && n[Tl](1, o, 1);
          break;
        case "scaleZ":
          !isNaN(o) && u === void 0 && l === void 0 && n[Tl](1, 1, o);
          break;
        case "skew":
          isNaN(o) || n[Um](o), isNaN(u) || n[Gm](u);
          break;
        case "skewX":
          !isNaN(o) && u === void 0 && n[Um](o);
          break;
        case "skewY":
          !isNaN(o) && u === void 0 && n[Gm](o);
          break;
        default:
          throw TypeError(`Failed to execute 'setMatrixValue' on '${this.name}': Unknown transform function '${i[1]}'.`);
      }
    }
    return n;
  }
  /**
   * Returns length.
   *
   * @param length Length to convert.
   * @returns Length.
   */
  static [xL](e) {
    const n = parseFloat(e);
    switch (e.replace(n.toString(), "")) {
      case "rem":
      case "em":
      case "vw":
      case "vh":
      case "%":
      case "vmin":
      case "vmax":
        throw new SyntaxError(`Failed to construct '${this.name}': Lengths must be absolute, not relative`);
      case "rad":
        return n * (180 / Math.PI);
      case "turn":
        return n * 360;
      case "px":
        return n;
      case "cm":
        return n * 37.7812;
      case "mm":
        return n * 3.7781;
      case "in":
        return n * 96;
      case "pt":
        return n * 1.3281;
      case "pc":
        return n * 16;
      case "Q":
        return n * 0.945;
      default:
        return n;
    }
  }
}
class Jo extends Gg {
  /**
   * Returns the `a` value of the matrix.
   */
  get a() {
    return this[Nt];
  }
  /**
   * Sets the `a` value of the matrix.
   */
  set a(e) {
    this[Nt] = e;
  }
  /**
   * Returns the `b` value of the matrix.
   */
  get b() {
    return this[Lt];
  }
  /**
   * Sets the `b` value of the matrix.
   */
  set b(e) {
    this[Lt] = e;
  }
  /**
   * Returns the `c` value of the matrix.
   */
  get c() {
    return this[Dt];
  }
  /**
   * Sets the `c` value of the matrix.
   */
  set c(e) {
    this[Dt] = e;
  }
  /**
   * Returns the `d` value of the matrix.
   */
  get d() {
    return this[Mt];
  }
  /**
   * Sets the `d` value of the matrix.
   */
  set d(e) {
    this[Mt] = e;
  }
  /**
   * Returns the `e` value of the matrix.
   */
  get e() {
    return this[It];
  }
  /**
   * Sets the `e` value of the matrix.
   */
  set e(e) {
    this[It] = e;
  }
  /**
   * Returns the `f` value of the matrix.
   */
  get f() {
    return this[Ot];
  }
  /**
   * Sets the `f` value of the matrix.
   */
  set f(e) {
    this[Ot] = e;
  }
  /**
   * Returns the `m11` value of the matrix.
   */
  get m11() {
    return this[Nt];
  }
  /**
   * Sets the `m11` value of the matrix.
   */
  set m11(e) {
    this[Nt] = e;
  }
  /**
   * Returns the `m12` value of the matrix.
   */
  get m12() {
    return this[Lt];
  }
  /**
   * Sets the `m12` value of the matrix.
   */
  set m12(e) {
    this[Lt] = e;
  }
  /**
   * Returns the `m13` value of the matrix.
   */
  get m13() {
    return this[an];
  }
  /**
   * Sets the `m13` value of the matrix.
   */
  set m13(e) {
    this[an] = e;
  }
  /**
   * Returns the `m14` value of the matrix.
   */
  get m14() {
    return this[on];
  }
  /**
   * Sets the `m14` value of the matrix.
   */
  set m14(e) {
    this[on] = e;
  }
  /**
   * Returns the `m21` value of the matrix.
   */
  get m21() {
    return this[Dt];
  }
  /**
   * Sets the `m21` value of the matrix.
   */
  set m21(e) {
    this[Dt] = e;
  }
  /**
   * Returns the `m22` value of the matrix.
   */
  get m22() {
    return this[Mt];
  }
  /**
   * Sets the `m22` value of the matrix.
   */
  set m22(e) {
    this[Mt] = e;
  }
  /**
   * Returns the `m23` value of the matrix.
   */
  get m23() {
    return this[un];
  }
  /**
   * Sets the `m23` value of the matrix.
   */
  set m23(e) {
    this[un] = e;
  }
  /**
   * Returns the `m24` value of the matrix.
   */
  get m24() {
    return this[ln];
  }
  /**
   * Sets the `m24` value of the matrix.
   */
  set m24(e) {
    this[ln] = e;
  }
  /**
   * Returns the `m31` value of the matrix.
   */
  get m31() {
    return this[Vt];
  }
  /**
   * Sets the `m31` value of the matrix.
   */
  set m31(e) {
    this[Vt] = e;
  }
  /**
   * Returns the `m32` value of the matrix.
   */
  get m32() {
    return this[Qt];
  }
  /**
   * Sets the `m32` value of the matrix.
   */
  set m32(e) {
    this[Qt] = e;
  }
  /**
   * Returns the `m33` value of the matrix.
   */
  get m33() {
    return this[Xt];
  }
  /**
   * Sets the `m33` value of the matrix.
   */
  set m33(e) {
    this[Xt] = e;
  }
  /**
   * Returns the `m34` value of the matrix.
   */
  get m34() {
    return this[Kt];
  }
  /**
   * Sets the `m34` value of the matrix.
   */
  set m34(e) {
    this[Kt] = e;
  }
  /**
   * Returns the `m41` value of the matrix.
   */
  get m41() {
    return this[It];
  }
  /**
   * Sets the `m41` value of the matrix.
   */
  set m41(e) {
    this[It] = e;
  }
  /**
   * Returns the `m42` value of the matrix.
   */
  get m42() {
    return this[Ot];
  }
  /**
   * Sets the `m42` value of the matrix.
   */
  set m42(e) {
    this[Ot] = e;
  }
  /**
   * Returns the `m43` value of the matrix.
   */
  get m43() {
    return this[Zt];
  }
  /**
   * Sets the `m43` value of the matrix.
   */
  set m43(e) {
    this[Zt] = e;
  }
  /**
   * Returns the `m44` value of the matrix.
   */
  get m44() {
    return this[en];
  }
  /**
   * Sets the `m44` value of the matrix.
   */
  set m44(e) {
    this[en] = e;
  }
  /**
   * The `setMatrixValue` method replaces the existing matrix with one computed in the browser (e.g.`matrix(1,0.25,-0.25,1,0,0)`).
   *
   * @param source A `DOMMatrix`, `Float32Array`, `Float64Array`, `Array`, or DOMMatrix compatible object to set the matrix values from.
   * @returns Self.
   */
  setMatrixValue(e) {
    return this[Hy](e), this;
  }
  /**
   * Sets self to be multiplied by the passed matrix.
   *
   * @param secondMatrix DOMMatrix
   * @returns Self.
   */
  multiplySelf(e) {
    return this[wa](e), this;
  }
  /**
   * Sets self to multiplied by a translation matrix containing the passed values.
   *
   * @param [x=0] X component of the translation value.
   * @param [y=0] Y component of the translation value.
   * @param [z=0] Z component of the translation value.
   * @returns Self.
   */
  translateSelf(e = 0, n = 0, r = 0) {
    return this[Sa](e, n, r), this;
  }
  /**
   * Sets self to be multiplied by a scale matrix containing the passed values.
   *
   * @param [scaleX] X-Axis scale.
   * @param [scaleY] Y-Axis scale.
   * @param [scaleZ] Z-Axis scale.
   * @param [originX] X-Axis scale.
   * @param [originY] Y-Axis scale.
   * @param [originZ] Z-Axis scale.
   * @returns Self.
   */
  scaleSelf(e, n, r = 1, i = 0, s = 0, a = 0) {
    return this[Tl](e, n, r, i, s, a), this;
  }
  /**
   * Sets self to be multiplied by a scale matrix containing the passed values.
   *
   * @param [scale] The scale factor.
   * @param [originX] X-Axis scale.
   * @param [originY] Y-Axis scale.
   * @param [originZ] Z-Axis scale.
   * @returns Self.
   */
  scale3dSelf(e = 1, n = 0, r = 0, i = 0) {
    return this[vv](e, n, r, i), this;
  }
  /**
   * Sets self to be multiplied by a scale matrix containing the passed values.
   *
   * @param [scaleX] X-Axis scale.
   * @param [scaleY] Y-Axis scale.
   * @returns Self.
   */
  scaleNonUniformSelf(e = 1, n = 1) {
    return this[xv](e, n), this;
  }
  /**
   * Sets self to be multiplied by a rotation matrix with the given axis and `angle`.
   *
   * @param [x] The X component of the axis vector.
   * @param [y] The Y component of the axis vector.
   * @param [z] The Z component of the axis vector.
   * @param [angle] Angle of rotation about the axis vector, in degrees.
   * @returns Self.
   */
  rotateAxisAngleSelf(e = 0, n = 0, r = 0, i = 0) {
    return this[Qc](e, n, r, i), this;
  }
  /**
   * Set self to be multiplied by each of 3 rotation matrices about the major axes, first X, then Y, then Z.
   *
   * @param [x] X component of the rotation, or Z if Y and Z are null.
   * @param [y] Y component of the rotation value.
   * @param [z] Z component of the rotation value.
   * @returns Self.
   */
  rotateSelf(e = 0, n, r) {
    return this[Jc](e, n, r), this;
  }
  /**
   * Sets self to be multiplied by a skew matrix along the X axis by the given angle.
   *
   * @param [x] X-Axis skew.
   * @param [y] Y-Axis skew.
   */
  rotateFromVectorSelf(e = 0, n = 0) {
    return this[Cv](e, n), this;
  }
  /**
   * Set self to be specified as a skew transformation along X-Axis by the given angle.
   *
   * @param angle Angle amount in degrees to skew.
   * @returns Self.
   */
  skewXSelf(e) {
    return this[Um](e), this;
  }
  /**
   * Set self to be specified as a skew transformation along Y-Axis by the given angle.
   *
   * @param angle Angle amount in degrees to skew.
   * @returns Self.
   */
  skewYSelf(e) {
    return this[Gm](e), this;
  }
  /**
   * Set self to be specified as matrix flipped on X-axis.
   */
  flipXSelf() {
    return this[kv](), this;
  }
  /**
   * Set self to be specified as matrix flipped on Y-axis.
   */
  flipYSelf() {
    return this[_v](), this;
  }
  /**
   * Set self to be specified as matrix inverted.
   */
  invertSelf() {
    return this[Nv](), this;
  }
}
const NGe = /[\t\f\n\r ,]+/;
class xh {
  [b];
  [se];
  [Q];
  [Be] = !1;
  [Ae] = {
    items: [],
    attributeValue: ""
  };
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param [options.readOnly] Read only.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    if (this[b] = n, this[Be] = !!r.readOnly, this[se] = r.getAttribute, this[Q] = r.setAttribute, e !== T)
      throw new TypeError("Illegal constructor");
    const i = new Ws(this, [xh]);
    return new Proxy(this, {
      get: (s, a) => {
        if (a === "length" || a === "numberOfItems")
          return s[De]().length;
        if (a in s || typeof a == "symbol")
          return i.bind(a), s[a];
        const o = Number(a);
        if (!isNaN(o))
          return s[De]()[o];
      },
      set(s, a, o) {
        if (i.bind(a), typeof a == "symbol")
          return s[a] = o, !0;
        const u = Number(a);
        return isNaN(u) && (s[a] = o), !0;
      },
      deleteProperty(s, a) {
        if (typeof a == "symbol")
          return delete s[a], !0;
        const o = Number(a);
        return isNaN(o) && delete s[a], !0;
      },
      ownKeys(s) {
        return Object.keys(s[De]());
      },
      has(s, a) {
        if (a in s)
          return !0;
        if (typeof a == "symbol")
          return !1;
        const o = Number(a);
        return !isNaN(o) && o >= 0 && o < s[De]().length;
      },
      defineProperty(s, a, o) {
        return i.preventBinding(a), a in s ? (Object.defineProperty(s, a, o), !0) : !1;
      },
      getOwnPropertyDescriptor(s, a) {
        if (a in s || typeof a == "symbol")
          return;
        const o = Number(a), u = s[De]();
        if (!isNaN(o) && u[o])
          return {
            value: u[o],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[De]().length;
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get numberOfItems() {
    return this[De]().length;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   */
  [Symbol.iterator]() {
    return this[De]().values();
  }
  /**
   * Clears all items from the list.
   */
  clear() {
    this[Ae].attributeValue = "", this[Ae].items = [], this[Q]("");
  }
  /**
   * Replace Token.
   *
   * @param newItem New item.
   * @returns The item being replaced.
   */
  initialize(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'initialize' on 'SVGStringList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'initialize' on 'SVGStringList': 1 arguments required, but only ${arguments.length} present.`);
    if (e = String(e), !e) {
      this.clear();
      return;
    }
    return this[Q](e), e;
  }
  /**
   * Returns item at index.
   *
   * @param index Index.
   * @returns The item at the index.
   **/
  getItem(e) {
    const n = this[De]();
    return typeof e == "number" || (e = Number(e), e = isNaN(e) ? 0 : e), n[e] ? n[e] : null;
  }
  /**
   * Inserts a new item into the list at the specified position. The first item is number 0. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to insert before is before the removal of the item. If the index is equal to 0, then the new item is inserted at the front of the list. If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being inserted.
   */
  insertItemBefore(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'insertItemBefore' on 'SVGStringList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'insertItemBefore' on 'SVGStringList': 2 arguments required, but only ${arguments.length} present.`);
    if (e = String(e), !e)
      return e;
    const r = this[De](), i = r.indexOf(e);
    return i !== -1 && r.splice(i, 1), n < 0 ? n = 0 : n > r.length && (n = r.length), r.splice(n, 0, e), this[Q](r.join(" ")), e;
  }
  /**
   * Replaces an existing item in the list with a new item. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to replace is before the removal of the item.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being replaced.
   */
  replaceItem(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'replaceItem' on 'SVGStringList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'replaceItem' on 'SVGStringList': 2 arguments required, but only ${arguments.length} present.`);
    if (e = String(e), !e)
      return this.removeItem(n);
    const r = this[De]();
    n < 0 ? n = 0 : n >= r.length && (n = r.length - 1);
    const i = r[n];
    return r[n] = e, this[Q](r.join(" ")), i;
  }
  /**
   * Removes an existing item from the list.
   *
   * @param index Index.
   * @returns The removed item.
   */
  removeItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'removeItem' on 'SVGStringList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'removeItem' on 'SVGStringList': 1 argument required, but only ${arguments.length} present.`);
    const n = this[De]();
    if (e = Number(e), isNaN(e) && (e = 0), e >= n.length)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGStringList':  The index provided (${e}) is greater than the maximum bound.`, ne.indexSizeError);
    if (e < 0)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGStringList':  The index provided (${e}) is negative.`, ne.indexSizeError);
    const r = n[e];
    return n.splice(e, 1), this[Q](n.join(" ")), r;
  }
  /**
   * Appends an item to the end of the list.
   *
   * @param newItem The item to add to the list.
   * @returns The item being appended.
   */
  appendItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGStringList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'appendItem' on 'SVGStringList': 1 argument required, but only ${arguments.length} present.`);
    if (e = String(e), !e)
      return e;
    const n = this[De](), r = n.indexOf(e);
    return r !== -1 && n.splice(r, 1), n.push(e), this[Q](n.join(" ")), e;
  }
  /**
   * Returns item list from attribute value.
   *
   * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
   */
  [De]() {
    const e = this[se]() ?? "", n = this[Ae];
    if (n.attributeValue === e)
      return n.items;
    const r = [], i = e.trim();
    if (i)
      for (const s of i.split(NGe))
        r.includes(s) || r.push(s);
    return n.attributeValue = e, n.items = r, r;
  }
}
const DGe = /([a-zA-Z0-9]+)\(([^)]+)\)/, IGe = /[\s,]+/;
class Hi {
  // Internal properties
  [b];
  [se] = null;
  [Q] = null;
  [ae] = null;
  [Be] = !1;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param [options] Options.
   * @param [options.readOnly] Read only.
   * @param [options.getAttribute] Get attribute.
   * @param [options.setAttribute] Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, r && (this[Be] = !!r.readOnly, this[se] = r.getAttribute || null, this[Q] = r.setAttribute || null);
  }
  /**
   * Returns the `a` value of the matrix.
   */
  get a() {
    return this[dr]().a;
  }
  /**
   * Sets the `a` value of the matrix.
   */
  set a(e) {
    if (this[Be])
      return;
    const n = this[dr]();
    n.a = e, this[bi](n);
  }
  /**
   * Returns the `b` value of the matrix.
   */
  get b() {
    return this[dr]().b;
  }
  /**
   * Sets the `b` value of the matrix.
   */
  set b(e) {
    if (this[Be])
      return;
    const n = this[dr]();
    n.b = e, this[bi](n);
  }
  /**
   * Returns the `c` value of the matrix.
   */
  get c() {
    return this[dr]().c;
  }
  /**
   * Sets the `c` value of the matrix.
   */
  set c(e) {
    if (this[Be])
      return;
    const n = this[dr]();
    n.c = e, this[bi](n);
  }
  /**
   * Returns the `d` value of the matrix.
   */
  get d() {
    return this[dr]().d;
  }
  /**
   * Sets the `d` value of the matrix.
   */
  set d(e) {
    if (this[Be])
      return;
    const n = this[dr]();
    n.d = e, this[bi](n);
  }
  /**
   * Returns the `e` value of the matrix.
   */
  get e() {
    return this[dr]().e;
  }
  /**
   * Sets the `e` value of the matrix.
   */
  set e(e) {
    if (this[Be])
      return;
    const n = this[dr]();
    n.e = e, this[bi](n);
  }
  /**
   * Returns the `f` value of the matrix.
   */
  get f() {
    return this[dr]().f;
  }
  /**
   * Sets the `f` value of the matrix.
   */
  set f(e) {
    if (this[Be])
      return;
    const n = this[dr]();
    n.f = e, this[bi](n);
  }
  /**
   * Returns a new SVGMatrix instance which is the result of this matrix multiplied by the passed matrix.
   *
   * @param secondMatrix Matrix object.
   * @returns A new SVGMatrix object.
   */
  multiply(e) {
    if (!(e instanceof Hi))
      throw new this[b].TypeError("Failed to execute 'multiply' on 'SVGMatrix': parameter 1 is not of type 'SVGMatrix'.");
    const n = this[dr](), r = new Hi(T, this[b]);
    return n.multiplySelf(e[dr]()), r[bi](n), r;
  }
  /**
   * Returns a new SVGMatrix instance which is this matrix post multiplied by a translation matrix containing the passed values.
   *
   * @param [x=0] X component of the translation value.
   * @param [y=0] Y component of the translation value.
   * @returns The resulted matrix
   */
  translate(e = 0, n = 0) {
    const r = this[dr](), i = new Hi(T, this[b]);
    return r.translateSelf(e, n), i[bi](r), i;
  }
  /**
   * Returns a new SVGMatrix instance which is this matrix post multiplied by a scale 2D matrix containing the passed values.
   *
   * @param scale The scale factor.
   * @returns The resulted matrix
   */
  scale(e) {
    const n = this[dr](), r = new Hi(T, this[b]);
    return n.scaleSelf(e), r[bi](n), r;
  }
  /**
   * Returns a new SVGMatrix instance which is this matrix post multiplied by a scale 3D matrix containing the passed values.
   *
   * @param [scaleX] X-Axis scale.
   * @param [scaleY] Y-Axis scale.
   * @returns The resulted matrix
   */
  scaleNonUniform(e = 1, n = 1) {
    const r = this[dr](), i = new Hi(T, this[b]);
    return r.scaleNonUniformSelf(e, n), i[bi](r), i;
  }
  /**
   * Returns a new SVGMatrix instance which is this matrix post multiplied by each of 3 rotation matrices about the major axes, first X, then Y, then Z.
   *
   * @param angle Angle of rotation in degrees.
   * @returns The resulted matrix
   */
  rotate(e) {
    const n = this[dr](), r = new Hi(T, this[b]);
    return n.rotateSelf(e), r[bi](n), r;
  }
  /**
   * Returns a new SVGMatrix instance which is this matrix post multiplied by a skew matrix along the X axis by the given angle.
   *
   * Not implemented in Happy DOM yet.
   *
   * @param [x] X-Axis skew.
   * @param [y] Y-Axis skew.
   */
  rotateFromVector(e = 0, n = 0) {
    const r = this[dr](), i = new Hi(T, this[b]);
    return r.rotateFromVectorSelf(e, n), i[bi](r), i;
  }
  /**
   * Returns a new SVGMatrix instance that specifies a skew transformation along X-Axis by the given angle.
   *
   * @param angle Angle amount in degrees to skew.
   * @returns The resulted matrix
   */
  skewX(e) {
    const n = this[dr](), r = new Hi(T, this[b]);
    return n.skewXSelf(e), r[bi](n), r;
  }
  /**
   * Returns a new SVGMatrix instance that specifies a skew transformation along Y-Axis by the given angle.
   *
   * @param angle Angle amount in degrees to skew.
   * @returns The resulted matrix
   */
  skewY(e) {
    const n = this[dr](), r = new Hi(T, this[b]);
    return n.skewYSelf(e), r[bi](n), r;
  }
  /**
   * Returns a new SVGMatrix instance which is this matrix flipped on X-axis.
   */
  flipX() {
    const e = this[dr](), n = new Hi(T, this[b]);
    return e.flipXSelf(), n[bi](e), n;
  }
  /**
   * Returns a new SVGMatrix instance which is this matrix flipped on Y-axis.
   */
  flipY() {
    const e = this[dr](), n = new Hi(T, this[b]);
    return e.flipYSelf(), n[bi](e), n;
  }
  /**
   * Returns a new SVGMatrix instance which is this matrix inverted.
   */
  inverse() {
    const e = this[dr](), n = new Hi(T, this[b]);
    return e.invertSelf(), n[bi](e), n;
  }
  /**
   * Returns DOM matrix.
   *
   * @returns DOM matrix.
   */
  [dr]() {
    const e = this[se] ? this[se]() : this[ae];
    if (!e)
      return new Jo();
    const n = e.match(DGe);
    if (!n)
      return new Jo();
    const r = [];
    for (const i of n[2].trim().split(IGe)) {
      const s = Number(i);
      if (isNaN(s))
        throw new this[b].TypeError(`Failed to parse transform attribute: Expected number, but got "${i}" in "${e}".`);
      r.push(s);
    }
    switch (n[1]) {
      case "matrix":
        if (r.length !== 6)
          throw new this[b].TypeError(`Failed to parse transform attribute: Expected 6 parameters in "${e}".`);
        return Jo[fg](e);
      case "scale":
      case "translate":
        if (r.length !== 1 && r.length !== 2)
          throw new this[b].TypeError(`Failed to parse transform attribute: Expected 1 or 2 parameters in "${e}".`);
        return Jo[fg](e);
      case "skewY":
      case "skewX":
        if (r.length !== 1)
          throw new this[b].TypeError(`Failed to parse transform attribute: Expected 1 parameter in "${e}".`);
        return Jo[fg](e);
      case "rotate":
        const i = new Jo();
        if (r.length !== 1 && r.length !== 3)
          throw new this[b].TypeError(`Failed to parse transform attribute: Expected 1 or 3 parameters in "${e}".`);
        const [s, a, o] = r;
        (a || o) && i.translateSelf(a, o);
        const u = s * Math.PI / 180;
        return i.multiplySelf(
          // prettier-ignore
          new Jo([
            Math.cos(u),
            Math.sin(u),
            -Math.sin(u),
            Math.cos(u),
            0,
            0
          ])
        ), (a || o) && i.translateSelf(-a, -o), i;
      default:
        throw new this[b].TypeError(`Failed to parse transform attribute: Unknown transformation "${e}".`);
    }
  }
  /**
   * Sets DOM matrix.
   *
   * @param domMatrix DOM matrix.
   */
  [bi](e) {
    this[ae] = e.toString().replace(/, /g, " "), this[Q] && this[Q](this[ae]);
  }
}
var yx;
(function(t) {
  t[t.unknown = 0] = "unknown", t[t.matrix = 1] = "matrix", t[t.translate = 2] = "translate", t[t.scale = 3] = "scale", t[t.rotate = 4] = "rotate", t[t.skewX = 5] = "skewX", t[t.skewY = 6] = "skewY";
})(yx || (yx = {}));
const _s = yx, xM = /([a-zA-Z0-9]+)\(([^)]+)\)/, RGe = /[\s,]+/;
class Pl {
  static SVG_TRANSFORM_UNKNOWN = _s.unknown;
  static SVG_TRANSFORM_MATRIX = _s.matrix;
  static SVG_TRANSFORM_TRANSLATE = _s.translate;
  static SVG_TRANSFORM_SCALE = _s.scale;
  static SVG_TRANSFORM_ROTATE = _s.rotate;
  static SVG_TRANSFORM_SKEWX = _s.skewX;
  static SVG_TRANSFORM_SKEWY = _s.skewY;
  // Internal properties
  [b];
  [se] = null;
  [Q] = null;
  [ae] = null;
  [Be] = !1;
  [gl] = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param [options] Options.
   * @param [options.readOnly] Read only.
   * @param [options.getAttribute] Get attribute.
   * @param [options.setAttribute] Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, r && (this[Be] = !!r.readOnly, this[se] = r.getAttribute || null, this[Q] = r.setAttribute || null);
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    const n = (this[se] ? this[se]() : this[ae])?.match(xM);
    if (!n)
      return _s.unknown;
    switch (n[1]) {
      case "matrix":
        return _s.matrix;
      case "translate":
        return _s.translate;
      case "rotate":
        return _s.rotate;
      case "scale":
        return _s.scale;
      case "skewX":
        return _s.skewX;
      case "skewY":
        return _s.skewY;
    }
    return 0;
  }
  /**
   * Returns angle.
   *
   * @returns Angle.
   */
  get angle() {
    const n = (this[se] ? this[se]() : this[ae])?.match(xM);
    if (!n)
      return 0;
    const r = parseFloat(n[2].trim().split(RGe)[0]);
    if (isNaN(r))
      return 0;
    switch (n[1]) {
      case "rotate":
      case "skewX":
      case "skewY":
        return r;
    }
    return 0;
  }
  /**
   * Returns matrix.
   *
   * @returns Matrix.
   */
  get matrix() {
    return this[gl] || (this[gl] = new Hi(T, this[b], {
      readOnly: this[Be],
      getAttribute: () => this[se] ? this[se]() : this[ae],
      setAttribute: (e) => {
        if (this[ae] = e, this[Q]) {
          this[Q](e);
          return;
        }
      }
    })), this[gl];
  }
  /**
   * Set matrix.
   *
   * @param matrix Matrix.
   */
  setMatrix(e) {
    if (!(e instanceof Hi))
      throw new TypeError('Failed to set the "matrix" property on "SVGTransform": The provided value is not of type "SVGMatrix".');
    this[Be] || (this[gl] && (this[gl][se] = null, this[gl][Q] = null), e[se] = () => this[se] ? this[se]() : this[ae], e[Q] = (n) => {
      if (this[ae] = n, this[Q]) {
        this[Q](n);
        return;
      }
    }, this[gl] = e, e[ae] !== this[ae] && (this[ae] = e[ae], this[Q] && this[Q](this[ae] || "")));
  }
  /**
   * Set translate.
   *
   * @param x X.
   * @param y Y.
   */
  setTranslate(e, n) {
    if (arguments.length < 2)
      throw new TypeError(`Failed to execute 'setTranslate' on 'SVGTransform': 2 arguments required, but only ${arguments.length} present.`);
    if (e = Number(e), n = Number(n), isNaN(e) || isNaN(n))
      throw new TypeError("Failed to execute 'setTranslate' on 'SVGTransform':  The provided float value is non-finite.");
    this[Be] || (this[ae] = `translate(${e} ${n})`, this[Q] && this[Q](this[ae]));
  }
  /**
   * Set scale.
   *
   * @param x X.
   * @param y Y.
   */
  setScale(e, n) {
    if (arguments.length < 2)
      throw new TypeError(`Failed to execute 'setScale' on 'SVGTransform': 2 arguments required, but only ${arguments.length} present.`);
    if (e = Number(e), n = Number(n), isNaN(e) || isNaN(n))
      throw new TypeError("Failed to execute 'setScale' on 'SVGTransform':  The provided float value is non-finite.");
    this[Be] || (this[ae] = `scale(${e} ${n})`, this[Q] && this[Q](this[ae]));
  }
  /**
   * Set rotate.
   *
   * @param angle Angle.
   * @param x X.
   * @param y Y.
   */
  setRotate(e, n, r) {
    if (arguments.length < 3)
      throw new TypeError(`Failed to execute 'setRotate' on 'SVGTransform': 3 arguments required, but only ${arguments.length} present.`);
    if (e = Number(e), n = Number(n), r = Number(r), isNaN(e) || isNaN(n) || isNaN(r))
      throw new TypeError("Failed to execute 'setRotate' on 'SVGTransform':  The provided float value is non-finite.");
    this[Be] || (this[ae] = `rotate(${e} ${n} ${r})`, this[Q] && this[Q](this[ae]));
  }
  /**
   * Set skew x.
   *
   * @param angle Angle.
   */
  setSkewX(e) {
    if (arguments.length < 1)
      throw new TypeError(`Failed to execute 'setSkewX' on 'SVGTransform': 1 arguments required, but only ${arguments.length} present.`);
    if (e = Number(e), isNaN(e))
      throw new TypeError("Failed to execute 'setSkewX' on 'SVGTransform':  The provided float value is non-finite.");
    this[Be] || (this[ae] = `skewX(${e})`, this[Q] && this[Q](this[ae]));
  }
  /**
   * Set skew y.
   *
   * @param angle Angle.
   */
  setSkewY(e) {
    if (arguments.length < 1)
      throw new TypeError(`Failed to execute 'setSkewY' on 'SVGTransform': 1 arguments required, but only ${arguments.length} present.`);
    if (e = Number(e), isNaN(e))
      throw new TypeError("Failed to execute 'setSkewY' on 'SVGTransform':  The provided float value is non-finite.");
    this[Be] || (this[ae] = `skewY(${e})`, this[Q] && this[Q](this[ae]));
  }
}
const PGe = /([a-zA-Z0-9]+)\(([^)]+)\)/gm, Iu = "matrix(1 0 0 1 0 0)";
class Wg {
  [b];
  [se];
  [Q];
  [Be] = !1;
  [Ae] = {
    items: [],
    attributeValue: ""
  };
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   * @param [options.readOnly] Read only.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[Be] = !!r.readOnly, this[se] = r.getAttribute, this[Q] = r.setAttribute;
    const i = new Ws(this, [Wg]);
    return new Proxy(this, {
      get: (s, a) => {
        if (a === "length" || a === "numberOfItems")
          return s[De]().length;
        if (a in s || typeof a == "symbol")
          return i.bind(a), s[a];
        const o = Number(a);
        if (!isNaN(o))
          return s[De]()[o];
      },
      set(s, a, o) {
        if (i.bind(a), typeof a == "symbol")
          return s[a] = o, !0;
        const u = Number(a);
        return isNaN(u) && (s[a] = o), !0;
      },
      deleteProperty(s, a) {
        if (typeof a == "symbol")
          return delete s[a], !0;
        const o = Number(a);
        return isNaN(o) && delete s[a], !0;
      },
      ownKeys(s) {
        return Object.keys(s[De]());
      },
      has(s, a) {
        if (a in s)
          return !0;
        if (typeof a == "symbol")
          return !1;
        const o = Number(a);
        return !isNaN(o) && o >= 0 && o < s[De]().length;
      },
      defineProperty(s, a, o) {
        return i.preventBinding(a), a in s ? (Object.defineProperty(s, a, o), !0) : !1;
      },
      getOwnPropertyDescriptor(s, a) {
        if (a in s || typeof a == "symbol")
          return;
        const o = Number(a), u = s[De]();
        if (!isNaN(o) && u[o])
          return {
            value: u[o],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[De]().length;
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get numberOfItems() {
    return this[De]().length;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   */
  [Symbol.iterator]() {
    return this[De]().values();
  }
  /**
   * Clears all items from the list.
   */
  clear() {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'clear' on 'SVGTransformList': The object is read-only.");
    for (const e of this[Ae].items)
      e[se] = null, e[Q] = null;
    this[Ae].items = [], this[Ae].attributeValue = "", this[Q]("");
  }
  /**
   * Replace Token.
   *
   * @param newItem New item.
   * @returns The item being replaced.
   */
  initialize(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'initialize' on 'SVGTransformList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'initialize' on 'SVGTransformList': 1 arguments required, but only ${arguments.length} present.`);
    if (!(e instanceof Pl))
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGTransformList': parameter 1 is not of type 'SVGTransform'.");
    for (const n of this[Ae].items)
      n[se] = null, n[Q] = null;
    return e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((n) => n[ae] || Iu).join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].items = [e], this[Ae].attributeValue = e[ae], this[Q](e[ae] || ""), e;
  }
  /**
   * Returns item at index.
   *
   * @param index Index.
   * @returns The item at the index.
   **/
  getItem(e) {
    const n = this[De]();
    return typeof e == "number" || (e = Number(e), e = isNaN(e) ? 0 : e), n[e] ? n[e] : null;
  }
  /**
   * Inserts a new item into the list at the specified position. The first item is number 0. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to insert before is before the removal of the item. If the index is equal to 0, then the new item is inserted at the front of the list. If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being inserted.
   */
  insertItemBefore(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'insertItemBefore' on 'SVGTransformList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'insertItemBefore' on 'SVGTransformList': 2 arguments required, but only ${arguments.length} present.`);
    if (!(e instanceof Pl))
      throw new this[b].TypeError("Failed to execute 'insertItemBefore' on 'SVGTransformList': parameter 1 is not of type 'SVGTransform'.");
    const r = this[De](), i = r.indexOf(e);
    return i !== -1 && r.splice(i, 1), n < 0 ? n = 0 : n > r.length && (n = r.length), r.splice(n, 0, e), e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((s) => s[ae] || Iu).join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = r.map((s) => s[ae] || Iu).join(" "), this[Q](this[Ae].attributeValue), e;
  }
  /**
   * Replaces an existing item in the list with a new item. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to replace is before the removal of the item.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being replaced.
   */
  replaceItem(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'replaceItem' on 'SVGTransformList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'replaceItem' on 'SVGTransformList': 2 arguments required, but only ${arguments.length} present.`);
    if (!(e instanceof Pl))
      throw new this[b].TypeError("Failed to execute 'replaceItem' on 'SVGTransformList': parameter 1 is not of type 'SVGTransform'.");
    const r = this[De](), i = r.indexOf(e);
    if (i === n)
      return e;
    i !== -1 && r.splice(i, 1), n < 0 ? n = 0 : n >= r.length && (n = r.length - 1), r[n] && (r[n][se] = null, r[n][Q] = null);
    const s = r[n];
    return r[n] = e, e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((a) => a[ae] || Iu).join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = r.map((a) => a[ae] || Iu).join(" "), this[Q](this[Ae].attributeValue), s;
  }
  /**
   * Removes an existing item from the list.
   *
   * @param index Index.
   * @returns The removed item.
   */
  removeItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'removeItem' on 'SVGTransformList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'removeItem' on 'SVGTransformList': 1 argument required, but only ${arguments.length} present.`);
    const n = this[De]();
    if (e = Number(e), isNaN(e) && (e = 0), e >= n.length)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGTransformList':  The index provided (${e}) is greater than the maximum bound.`, ne.indexSizeError);
    if (e < 0)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGTransformList':  The index provided (${e}) is negative.`, ne.indexSizeError);
    const r = n[e];
    return r && (r[se] = null, r[Q] = null), n.splice(e, 1), this[Ae].attributeValue = n.map((i) => i[ae] || Iu).join(" "), this[Q](this[Ae].attributeValue), r;
  }
  /**
   * Appends an item to the end of the list.
   *
   * @param newItem The item to add to the list.
   * @returns The item being appended.
   */
  appendItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGTransformList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'appendItem' on 'SVGTransformList': 1 argument required, but only ${arguments.length} present.`);
    if (!(e instanceof Pl))
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGTransformList': parameter 1 is not of type 'SVGTransform'.");
    const n = this[De](), r = n.indexOf(e);
    return r !== -1 && n.splice(r, 1), n.push(e), e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((i) => i[ae] || Iu).join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = n.map((i) => i[ae] || Iu).join(" "), this[Q](this[Ae].attributeValue), e;
  }
  /**
   * Returns item list from attribute value.
   *
   * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
   */
  [De]() {
    const e = this[se]() ?? "", n = this[Ae];
    if (n.attributeValue === e)
      return n.items;
    if (n.items.length)
      for (const s of n.items)
        s[se] = null, s[Q] = null;
    const r = [], i = e.trim();
    if (i) {
      const s = new RegExp(PGe);
      let a;
      for (; a = s.exec(i); ) {
        const o = new Pl(T, this[b], {
          readOnly: this[Be],
          getAttribute: () => o[ae],
          setAttribute: () => {
            this[Ae].attributeValue = this[De]().map((u) => u[ae] || Iu).join(" "), this[Q](this[Ae].attributeValue);
          }
        });
        o[ae] = `${a[1]}(${a[2]})`, r.push(o);
      }
    }
    return n.attributeValue = e, n.items = r, r;
  }
}
class JA {
  // Internal properties
  [b];
  [se];
  [Q];
  [Jn] = null;
  [Qn] = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this[Qn] || (this[Qn] = new Wg(T, this[b], {
      readOnly: !0,
      getAttribute: this[se],
      setAttribute: () => {
      }
    })), this[Qn];
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    return this[Jn] || (this[Jn] = new Wg(T, this[b], {
      getAttribute: this[se],
      setAttribute: this[Q]
    })), this[Jn];
  }
  /**
   * Returns base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
  }
}
class ha extends nn {
  // Internal properties
  [zl] = null;
  [jl] = null;
  [lb] = null;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get oncopy() {
    return K.getEventListener(this, "oncopy");
  }
  set oncopy(e) {
    this[F].set("oncopy", e);
  }
  get oncut() {
    return K.getEventListener(this, "oncut");
  }
  set oncut(e) {
    this[F].set("oncut", e);
  }
  get onpaste() {
    return K.getEventListener(this, "onpaste");
  }
  set onpaste(e) {
    this[F].set("onpaste", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns required extensions.
   *
   * @returns Required extensions.
   */
  get requiredExtensions() {
    return this[zl] || (this[zl] = new xh(T, this[b], {
      getAttribute: () => this.getAttribute("requiredExtensions"),
      setAttribute: (e) => this.setAttribute("requiredExtensions", e)
    })), this[zl];
  }
  /**
   * Returns system language.
   *
   * @returns System language.
   */
  get systemLanguage() {
    return this[jl] || (this[jl] = new xh(T, this[b], {
      getAttribute: () => this.getAttribute("systemLanguage"),
      setAttribute: (e) => this.setAttribute("systemLanguage", e)
    })), this[jl];
  }
  /**
   * Returns transform.
   *
   * @returns Transform.
   */
  get transform() {
    return this[lb] || (this[lb] = new JA(T, this[b], {
      getAttribute: () => this.getAttribute("transform"),
      setAttribute: (e) => this.setAttribute("transform", e)
    })), this[lb];
  }
  /**
   * Returns DOM rect.
   *
   * @returns DOM rect.
   */
  getBBox() {
    return new Of();
  }
  /**
   * Returns CTM.
   *
   * @returns CTM.
   */
  getCTM() {
    return new Jo();
  }
  /**
   * Returns screen CTM.
   *
   * @returns Screen CTM.
   */
  getScreenCTM() {
    return new Jo();
  }
}
class Vg {
  // Internal properties
  [b];
  [se] = null;
  [Q] = null;
  [ae] = null;
  [Be] = !1;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param [options] Options.
   * @param [options.readOnly] Read only.
   * @param [options.getAttribute] Get attribute.
   * @param [options.setAttribute] Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, r && (this[Be] = !!r.readOnly, this[se] = r.getAttribute || null, this[Q] = r.setAttribute || null);
  }
  /**
   * Returns x value.
   *
   * @returns X value.
   */
  get x() {
    const e = this[se] ? this[se]() : this[ae];
    if (!e)
      return 0;
    const n = e.split(/\s+/), r = Number(n[0]);
    return isNaN(r) ? 0 : r;
  }
  /**
   * Sets x value.
   *
   * @param value X value.
   */
  set x(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'x' property on 'SVGRect': The object is read-only.");
    this[ae] = `${String(typeof e == "number" ? e : parseFloat(e))} ${this.y} ${this.width} ${this.height}`, this[Q] && this[Q](this[ae]);
  }
  /**
   * Returns y value.
   *
   * @returns Y value.
   */
  get y() {
    const e = this[se] ? this[se]() : this[ae];
    if (!e)
      return 0;
    const n = e.split(/\s+/), r = Number(n[1]);
    return isNaN(r) ? 0 : r;
  }
  /**
   * Sets y value.
   *
   * @param value Y value.
   */
  set y(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'y' property on 'SVGRect': The object is read-only.");
    this[ae] = `${this.x} ${String(typeof e == "number" ? e : parseFloat(e))} ${this.width} ${this.height}`, this[Q] && this[Q](this[ae]);
  }
  /**
   * Returns width value.
   *
   * @returns Width value.
   */
  get width() {
    const e = this[se] ? this[se]() : this[ae];
    if (!e)
      return 0;
    const n = e.split(/\s+/), r = Number(n[2]);
    return isNaN(r) ? 0 : r;
  }
  /**
   * Sets width value.
   *
   * @param value Width value.
   */
  set width(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'width' property on 'SVGRect': The object is read-only.");
    this[ae] = `${this.x} ${this.y} ${String(typeof e == "number" ? e : parseFloat(e))} ${this.height}`, this[Q] && this[Q](this[ae]);
  }
  /**
   * Returns height value.
   *
   * @returns Height value.
   */
  get height() {
    const e = this[se] ? this[se]() : this[ae];
    if (!e)
      return 0;
    const n = e.split(/\s+/), r = Number(n[3]);
    return isNaN(r) ? 0 : r;
  }
  /**
   * Sets height value.
   *
   * @param value Height value.
   */
  set height(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'height' property on 'SVGRect': The object is read-only.");
    this[ae] = `${this.x} ${this.y} ${this.width} ${String(typeof e == "number" ? e : parseFloat(e))}`, this[Q] && this[Q](this[ae]);
  }
}
const CM = /[\t\f\n\r, ]+/;
class sa {
  // Internal properties
  [b];
  [se] = null;
  [Q] = null;
  [ae] = null;
  [Be] = !1;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param [options] Options.
   * @param [options.readOnly] Read only.
   * @param [options.getAttribute] Get attribute.
   * @param [options.setAttribute] Set attribute
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, r && (this[Be] = !!r.readOnly, this[se] = r.getAttribute || null, this[Q] = r.setAttribute || null);
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    const n = ((this[se] ? this[se]() : this[ae]) || "").split(CM);
    return n[0] ? parseFloat(n[0]) : 0;
  }
  /**
   * Sets x.
   *
   * @param value X.
   */
  set x(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'x' property on 'SVGPoint': The object is read-only.");
    this[ae] = `${e} ${this.y}`, this[Q] && this[Q](this[ae]);
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    const n = ((this[se] ? this[se]() : this[ae]) || "").split(CM);
    return n[1] ? parseFloat(n[1]) : 0;
  }
  /**
   * Sets y.
   *
   * @param value Y.
   */
  set y(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'y' property on 'SVGPoint': The object is read-only.");
    this[ae] = `${this.x} ${e}`, this[Q] && this[Q](this[ae]);
  }
}
var Ax;
(function(t) {
  t[t.unknown = 0] = "unknown", t[t.number = 1] = "number", t[t.percentage = 2] = "percentage", t[t.ems = 3] = "ems", t[t.exs = 4] = "exs", t[t.px = 5] = "px", t[t.cm = 6] = "cm", t[t.mm = 7] = "mm", t[t.in = 8] = "in", t[t.pt = 9] = "pt", t[t.pc = 10] = "pc";
})(Ax || (Ax = {}));
const ht = Ax, kM = /^(\d+|\d+\.\d+)(px|em|ex|cm|mm|in|pt|pc|%|)$/;
class Kg {
  // Static properties
  static SVG_LENGTHTYPE_UNKNOWN = ht.unknown;
  static SVG_LENGTHTYPE_NUMBER = ht.number;
  static SVG_LENGTHTYPE_PERCENTAGE = ht.percentage;
  static SVG_LENGTHTYPE_EMS = ht.ems;
  static SVG_LENGTHTYPE_EXS = ht.exs;
  static SVG_LENGTHTYPE_PX = ht.px;
  static SVG_LENGTHTYPE_CM = ht.cm;
  static SVG_LENGTHTYPE_MM = ht.mm;
  static SVG_LENGTHTYPE_IN = ht.in;
  static SVG_LENGTHTYPE_PT = ht.pt;
  static SVG_LENGTHTYPE_PC = ht.pc;
  // Internal properties
  [b];
  [se] = null;
  [Q] = null;
  [ae] = null;
  [Be] = !1;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param [options] Options.
   * @param [options.readOnly] Read only.
   * @param [options.getAttribute] Get attribute.
   * @param [options.setAttribute] Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, r && (this[Be] = !!r.readOnly, this[se] = r.getAttribute || null, this[Q] = r.setAttribute || null);
  }
  /**
   * Returns unit type.
   *
   * @returns Unit type.
   */
  get unitType() {
    const n = (this[se] ? this[se]() || "" : this[ae] || "").match(kM);
    if (!n || isNaN(parseFloat(n[1])))
      return ht.unknown;
    switch (n[2]) {
      case "":
        return ht.number;
      case "px":
        return ht.px;
      case "cm":
        return ht.cm;
      case "mm":
        return ht.mm;
      case "in":
        return ht.in;
      case "pt":
        return ht.pt;
      case "pc":
        return ht.pc;
      case "em":
      case "ex":
      case "%":
        throw new this[b].TypeError("Failed to execute 'value' on 'SVGLength': Could not resolve relative length.");
      default:
        return ht.unknown;
    }
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    const n = (this[se] ? this[se]() || "" : this[ae] || "").match(kM);
    if (!n)
      return 0;
    const r = parseFloat(n[1]);
    if (isNaN(r))
      return 0;
    switch (n[2]) {
      case "":
        return r;
      case "px":
        return r;
      case "cm":
        return r / 2.54 * 96;
      case "mm":
        return r / 25.4 * 96;
      case "in":
        return r * 96;
      case "pt":
        return r * 72;
      case "pc":
        return r * 6;
      case "em":
      case "ex":
      case "%":
        throw new this[b].TypeError("Failed to execute 'value' on 'SVGLength': Could not resolve relative length.");
      default:
        return 0;
    }
  }
  /**
   * Sets value.
   *
   * @param value Value in pixels.
   */
  set value(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'value' property on 'SVGLength': The object is read-only.");
    if (e = typeof e != "number" ? parseFloat(String(e)) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'value' property on 'SVGLength': The provided float value is non-finite.");
    let n = "", r = e;
    switch (this.unitType) {
      case ht.number:
        r = e, n = "";
        break;
      case ht.px:
        r = e, n = "px";
        break;
      case ht.cm:
        r = e / 96 * 2.54, n = "cm";
        break;
      case ht.mm:
        r = e / 96 * 25.4, n = "mm";
        break;
      case ht.in:
        r = e / 96, n = "in";
        break;
      case ht.pt:
        r = e / 72, n = "pt";
        break;
      case ht.pc:
        r = e / 6, n = "pc";
        break;
      case ht.percentage:
      case ht.ems:
      case ht.exs:
        throw new this[b].TypeError("Failed to set the 'value' property on 'SVGLength': Could not resolve relative length.");
    }
    this[ae] = String(r) + n, this[Q] && this[Q](this[ae]);
  }
  /**
   * Returns value as string.
   *
   * @returns Value as string.
   */
  get valueAsString() {
    return this[se] ? this[se]() || "0" : this[ae] || "0";
  }
  /**
   * Returns value in specified units.
   *
   * @returns Value in specified units.
   */
  get valueInSpecifiedUnits() {
    const e = this.valueAsString;
    return parseFloat(e) || 0;
  }
  /**
   * New value specific units.
   *
   * @param unitType
   * @param value
   */
  newValueSpecifiedUnits(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'newValueSpecifiedUnits' on 'SVGLength': The object is read-only.");
    if (typeof e != "number")
      throw new this[b].TypeError("Failed to execute 'newValueSpecifiedUnits' on 'SVGLength': parameter 1 ('unitType') is not of type 'number'.");
    if (n = typeof n != "number" ? parseFloat(String(n)) : n, isNaN(n))
      throw new this[b].TypeError("Failed to execute 'newValueSpecifiedUnits' on 'SVGLength': The provided float value is non-finite.");
    let r = "";
    switch (e) {
      case ht.number:
        r = "";
        break;
      case ht.px:
        r = "px";
        break;
      case ht.cm:
        r = "cm";
        break;
      case ht.mm:
        r = "mm";
        break;
      case ht.in:
        r = "in";
        break;
      case ht.pt:
        r = "pt";
        break;
      case ht.pc:
        r = "pc";
        break;
      case ht.ems:
      case ht.exs:
      case ht.percentage:
        throw new this[b].TypeError("Failed to execute 'newValueSpecifiedUnits' on 'SVGLength': Could not resolve relative length.");
    }
    this[ae] = String(n) + r, this[Q] && this[Q](this[ae]);
  }
  /**
   * Convert to specific units.
   * @param unitType
   */
  convertToSpecifiedUnits(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'convertToSpecifiedUnits' on 'SVGLength': The object is read-only.");
    if (typeof e != "number")
      throw new this[b].TypeError("Failed to execute 'convertToSpecifiedUnits' on 'SVGLength': parameter 1 ('unitType') is not of type 'number'.");
    let n = this.value, r = "";
    switch (e) {
      case ht.number:
        r = "";
        break;
      case ht.px:
        r = "px";
        break;
      case ht.cm:
        n = n / 96 * 2.54, r = "cm";
        break;
      case ht.mm:
        n = n / 96 * 25.4, r = "mm";
        break;
      case ht.in:
        n = n / 96, r = "in";
        break;
      case ht.pt:
        n = n / 72, r = "pt";
        break;
      case ht.pc:
        n = n / 6, r = "pc";
        break;
      case ht.percentage:
      case ht.ems:
      case ht.exs:
        throw new this[b].TypeError("Failed to execute 'convertToSpecifiedUnits' on 'SVGLength': Could not resolve relative length.");
    }
    this[ae] = String(n) + r, this[Q] && this[Q](this[ae]);
  }
}
var Ex;
(function(t) {
  t[t.unknown = 0] = "unknown", t[t.unspecified = 1] = "unspecified", t[t.deg = 2] = "deg", t[t.rad = 3] = "rad", t[t.grad = 4] = "grad";
})(Ex || (Ex = {}));
const Kn = Ex, _M = /^(\d+|\d+\.\d+)(deg|rad|grad|turn|)$/;
class Z1 {
  // Static properties
  static SVG_ANGLETYPE_UNKNOWN = Kn.unknown;
  static SVG_ANGLETYPE_UNSPECIFIED = Kn.unspecified;
  static SVG_ANGLETYPE_DEG = Kn.deg;
  static SVG_ANGLETYPE_RAD = Kn.rad;
  static SVG_ANGLETYPE_GRAD = Kn.grad;
  // Internal properties
  [b];
  [se] = null;
  [Q] = null;
  [ae] = "";
  [Be] = !1;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param [options] Options.
   * @param [options.readOnly] Read only.
   * @param [options.getAttribute] Get attribute.
   * @param [options.setAttribute] Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, r && (this[Be] = !!r.readOnly, this[se] = r.getAttribute || null, this[Q] = r.setAttribute || null);
  }
  /**
   * Returns unit type.
   *
   * @returns Unit type.
   */
  get unitType() {
    const n = (this[se] ? this[se]() : this[ae])?.match(_M);
    if (!n || isNaN(parseFloat(n[1])))
      return Kn.unknown;
    switch (n[2]) {
      case "":
        return Kn.unspecified;
      case "deg":
        return Kn.deg;
      case "rad":
        return Kn.rad;
      case "grad":
        return Kn.grad;
      case "turn":
        return Kn.unknown;
      default:
        return Kn.unspecified;
    }
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    const n = (this[se] ? this[se]() : this[ae])?.match(_M);
    if (!n)
      return 0;
    const r = parseFloat(n[1]);
    if (isNaN(r))
      return 0;
    switch (n[2]) {
      case "":
        return r;
      case "deg":
        return r;
      case "rad":
        return r * (180 / Math.PI);
      case "grad":
        return r * (180 / 200);
      case "turn":
        return r * 360;
      default:
        return r;
    }
  }
  /**
   * Sets value.
   *
   * @param value Value in pixels.
   */
  set value(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'value' property on 'SVGAngle': The object is read-only.");
    if (e = typeof e != "number" ? parseFloat(String(e)) : e, isNaN(e))
      throw new this[b].TypeError("Failed to set the 'value' property on 'SVGAngle': The provided float value is non-finite.");
    let n = "", r = e;
    switch (this.unitType) {
      case Kn.unspecified:
        r = e, n = "";
        break;
      case Kn.deg:
        r = e, n = "deg";
        break;
      case Kn.rad:
        r = e / (180 / Math.PI), n = "rad";
        break;
      case Kn.grad:
        r = e / (180 / 200), n = "grad";
        break;
      case Kn.unknown:
        r = e / 360, n = "turn";
    }
    this[ae] = String(r) + n, this[Q] && this[Q](this[ae]);
  }
  /**
   * Returns value as string.
   *
   * @returns Value as string.
   */
  get valueAsString() {
    return this[se] ? this[se]() || "0" : this[ae] || "0";
  }
  /**
   * Returns value in specified units.
   *
   * @returns Value in specified units.
   */
  get valueInSpecifiedUnits() {
    const e = this.valueAsString;
    return parseFloat(e) || 0;
  }
  /**
   * New value specific units.
   * @param unitType
   * @param value
   */
  newValueSpecifiedUnits(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'newValueSpecifiedUnits' on 'SVGAngle': The object is read-only.");
    if (typeof e != "number")
      throw new this[b].TypeError("Failed to execute 'newValueSpecifiedUnits' on 'SVGAngle': parameter 1 ('unitType') is not of type 'number'.");
    if (n = typeof n != "number" ? parseFloat(n) : n, isNaN(n))
      throw new this[b].TypeError("Failed to execute 'newValueSpecifiedUnits' on 'SVGAngle': The provided float value is non-finite.");
    let r = "";
    switch (e) {
      case Kn.unspecified:
        r = "";
        break;
      case Kn.deg:
        r = "deg";
        break;
      case Kn.rad:
        r = "rad";
        break;
      case Kn.grad:
        r = "grad";
        break;
      case Kn.unknown:
        r = "turn";
        break;
    }
    this[ae] = String(n) + r, this[Q] && this[Q](this[ae]);
  }
  /**
   * Convert to specific units.
   * @param unitType
   */
  convertToSpecifiedUnits(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'convertToSpecifiedUnits' on 'SVGAngle': The object is read-only.");
    if (typeof e != "number")
      throw new this[b].TypeError("Failed to execute 'convertToSpecifiedUnits' on 'SVGAngle': parameter 1 ('unitType') is not of type 'number'.");
    let n = this.value, r = "";
    switch (e) {
      case Kn.unspecified:
        r = "";
        break;
      case Kn.deg:
        r = "deg";
        break;
      case Kn.rad:
        r = "rad", n = n / (180 / Math.PI);
        break;
      case Kn.grad:
        r = "grad", n = n / (180 / 200);
        break;
      case Kn.unknown:
        r = "turn", n = n / 360;
        break;
    }
    this[ae] = String(n) + r, this[Q] && this[Q](this[ae]);
  }
}
class Bd {
  // Internal properties
  [b];
  [se] = null;
  [Q] = null;
  [ae] = null;
  [Be] = !1;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param [options] Options.
   * @param [options.readOnly] Read only.
   * @param [options.getAttribute] Get attribute.
   * @param [options.setAttribute] Set attribute
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, r && (this[Be] = !!r.readOnly, this[se] = r.getAttribute || null, this[Q] = r.setAttribute || null);
  }
  /**
   * Returns value.
   *
   * @returns Value.
   */
  get value() {
    const e = this[se] ? this[se]() : this[ae];
    return parseFloat(e || "0");
  }
  /**
   * Sets value.
   *
   * @param value Value.
   */
  set value(e) {
    if (this[Be])
      throw new TypeError("Failed to set the 'value' property on 'SVGNumber': The object is read-only.");
    const n = typeof e != "number" ? parseFloat(String(e)) : e;
    if (isNaN(n))
      throw new TypeError("Failed to set the 'value' property on 'SVGNumber': The provided value is not a number.");
    this[ae] = String(e), this[Q] && this[Q](this[ae] || "");
  }
}
class Q2 {
  // Internal properties
  [b];
  [se];
  [Q];
  [Jn] = null;
  [Qn] = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this[Qn] || (this[Qn] = new Vg(T, this[b], {
      readOnly: !0,
      getAttribute: this[se]
    })), this[Qn];
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    return this[Jn] || (this[Jn] = new Vg(T, this[b], {
      getAttribute: this[se],
      setAttribute: this[Q]
    })), this[Jn];
  }
  /**
   * Returns base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
  }
}
var Sx;
(function(t) {
  t[t.unknown = 0] = "unknown", t[t.meet = 1] = "meet", t[t.slice = 2] = "slice";
})(Sx || (Sx = {}));
const vl = Sx;
var wx;
(function(t) {
  t[t.unknown = 0] = "unknown", t[t.none = 1] = "none", t[t.xMinYMin = 2] = "xMinYMin", t[t.xMidYMin = 3] = "xMidYMin", t[t.xMaxYMin = 4] = "xMaxYMin", t[t.xMinYMid = 5] = "xMinYMid", t[t.xMidYMid = 6] = "xMidYMid", t[t.xMaxYMid = 7] = "xMaxYMid", t[t.xMinYMax = 8] = "xMinYMax", t[t.xMidYMax = 9] = "xMidYMax", t[t.xMaxYMax = 10] = "xMaxYMax";
})(wx || (wx = {}));
const qi = wx, Eg = Object.values(qi);
Eg.length = Eg.indexOf(0);
const eA = Object.values(vl);
eA.length = eA.indexOf(0);
class Fx {
  // Static properties
  static SVG_MEETORSLICE_UNKNOWN = vl.unknown;
  static SVG_MEETORSLICE_MEET = vl.meet;
  static SVG_MEETORSLICE_SLICE = vl.slice;
  static SVG_PRESERVEASPECTRATIO_UNKNOWN = qi.unknown;
  static SVG_PRESERVEASPECTRATIO_NONE = qi.none;
  static SVG_PRESERVEASPECTRATIO_XMINYMIN = qi.xMinYMin;
  static SVG_PRESERVEASPECTRATIO_XMIDYMIN = qi.xMidYMin;
  static SVG_PRESERVEASPECTRATIO_XMAXYMIN = qi.xMaxYMin;
  static SVG_PRESERVEASPECTRATIO_XMINYMID = qi.xMinYMid;
  static SVG_PRESERVEASPECTRATIO_XMIDYMID = qi.xMidYMid;
  static SVG_PRESERVEASPECTRATIO_XMAXYMID = qi.xMaxYMid;
  static SVG_PRESERVEASPECTRATIO_XMINYMAX = qi.xMinYMax;
  static SVG_PRESERVEASPECTRATIO_XMIDYMAX = qi.xMidYMax;
  static SVG_PRESERVEASPECTRATIO_XMAXYMAX = qi.xMaxYMax;
  // Internal properties
  [b];
  [se] = null;
  [Q] = null;
  [ae] = null;
  [Be] = !1;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param [options] Options.
   * @param [options.readOnly] Read only.
   * @param [options.getAttribute] Get attribute.
   * @param [options.setAttribute] Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, r && (this[Be] = !!r.readOnly, this[se] = r.getAttribute || null, this[Q] = r.setAttribute || null);
  }
  /**
   * Returns align.
   *
   * @returns Align.
   */
  get align() {
    const e = this[se] ? this[se]() : this[ae];
    if (!e)
      return qi.xMidYMid;
    const n = e.split(/\s+/)[0];
    return qi[n] === void 0 ? qi.xMidYMid : qi[n];
  }
  /**
   * Sets align.
   *
   * @param value Align.
   */
  set align(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'align' property on 'SVGPreserveAspectRatio': The object is read-only.");
    const n = Number(e);
    if (isNaN(n) || n < 1 || n > Eg.length)
      throw new this[b].TypeError("Failed to set the 'align' property on 'SVGPreserveAspectRatio': The alignment provided is invalid.");
    this[ae] = `${Eg[n]} ${eA[this.meetOrSlice]}`, this[Q] && this[Q](this[ae]);
  }
  /**
   * Returns meet or slice.
   *
   * @returns Meet or slice.
   */
  get meetOrSlice() {
    const e = this[se] ? this[se]() : this[ae];
    if (!e)
      return vl.meet;
    const n = e.split(/\s+/)[1];
    return !n || vl[n] === void 0 ? vl.meet : vl[n];
  }
  /**
   * Sets meet or slice.
   *
   * @param value Meet or slice.
   */
  set meetOrSlice(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to set the 'meetOrSlice' property on 'SVGPreserveAspectRatio': The object is read-only.");
    const n = Number(e);
    if (isNaN(n) || n < 1 || n > 2)
      throw new this[b].TypeError("Failed to set the 'meetOrSlice' property on 'SVGPreserveAspectRatio': The meetOrSlice provided is invalid.");
    this[ae] = `${Eg[this.align]} ${eA[n]}`, this[Q] && this[Q](this[ae]);
  }
}
class Ep {
  // Internal properties
  [b];
  [se];
  [Q];
  [Jn] = null;
  [Qn] = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this[Qn] || (this[Qn] = new Fx(T, this[b], {
      readOnly: !0,
      getAttribute: this[se]
    })), this[Qn];
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    return this[Jn] || (this[Jn] = new Fx(T, this[b], {
      getAttribute: this[se],
      setAttribute: this[Q]
    })), this[Jn];
  }
  /**
   * Returns base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
  }
}
class de {
  // Internal properties
  [b];
  [se];
  [Q];
  [Jn] = null;
  [Qn] = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this[Qn] || (this[Qn] = new Kg(T, this[b], {
      readOnly: !0,
      getAttribute: this[se]
    })), this[Qn];
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    return this[Jn] || (this[Jn] = new Kg(T, this[b], {
      getAttribute: this[se],
      setAttribute: this[Q]
    })), this[Jn];
  }
  /**
   * Returns base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
  }
}
class LGe extends ha {
  // Internal properties
  [ns] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  [we] = null;
  [RF] = 1;
  [Yl] = null;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onafterprint() {
    return K.getEventListener(this, "onafterprint");
  }
  set onafterprint(e) {
    this[F].set("onafterprint", e);
  }
  get onbeforeprint() {
    return K.getEventListener(this, "onbeforeprint");
  }
  set onbeforeprint(e) {
    this[F].set("onbeforeprint", e);
  }
  get onbeforeunload() {
    return K.getEventListener(this, "onbeforeunload");
  }
  set onbeforeunload(e) {
    this[F].set("onbeforeunload", e);
  }
  get ongamepadconnected() {
    return K.getEventListener(this, "ongamepadconnected");
  }
  set ongamepadconnected(e) {
    this[F].set("ongamepadconnected", e);
  }
  get ongamepaddisconnected() {
    return K.getEventListener(this, "ongamepaddisconnected");
  }
  set ongamepaddisconnected(e) {
    this[F].set("ongamepaddisconnected", e);
  }
  get onhashchange() {
    return K.getEventListener(this, "onhashchange");
  }
  set onhashchange(e) {
    this[F].set("onhashchange", e);
  }
  get onlanguagechange() {
    return K.getEventListener(this, "onlanguagechange");
  }
  set onlanguagechange(e) {
    this[F].set("onlanguagechange", e);
  }
  get onmessage() {
    return K.getEventListener(this, "onmessage");
  }
  set onmessage(e) {
    this[F].set("onmessage", e);
  }
  get onmessageerror() {
    return K.getEventListener(this, "onmessageerror");
  }
  set onmessageerror(e) {
    this[F].set("onmessageerror", e);
  }
  get onoffline() {
    return K.getEventListener(this, "onoffline");
  }
  set onoffline(e) {
    this[F].set("onoffline", e);
  }
  get ononline() {
    return K.getEventListener(this, "ononline");
  }
  set ononline(e) {
    this[F].set("ononline", e);
  }
  get onpagehide() {
    return K.getEventListener(this, "onpagehide");
  }
  set onpagehide(e) {
    this[F].set("onpagehide", e);
  }
  get onpageshow() {
    return K.getEventListener(this, "onpageshow");
  }
  set onpageshow(e) {
    this[F].set("onpageshow", e);
  }
  get onpopstate() {
    return K.getEventListener(this, "onpopstate");
  }
  set onpopstate(e) {
    this[F].set("onpopstate", e);
  }
  get onrejectionhandled() {
    return K.getEventListener(this, "onrejectionhandled");
  }
  set onrejectionhandled(e) {
    this[F].set("onrejectionhandled", e);
  }
  get onstorage() {
    return K.getEventListener(this, "onstorage");
  }
  set onstorage(e) {
    this[F].set("onstorage", e);
  }
  get onunhandledrejection() {
    return K.getEventListener(this, "onunhandledrejection");
  }
  set onunhandledrejection(e) {
    this[F].set("onunhandledrejection", e);
  }
  get onunload() {
    return K.getEventListener(this, "onunload");
  }
  set onunload(e) {
    this[F].set("onunload", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns preserve aspect ratio.
   *
   * @returns Preserve aspect ratio.
   */
  get preserveAspectRatio() {
    return this[ns] || (this[ns] = new Ep(T, this[b], {
      getAttribute: () => this.getAttribute("preserveAspectRatio"),
      setAttribute: (e) => this.setAttribute("preserveAspectRatio", e)
    })), this[ns];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Returns currentScale.
   *
   * @returns CurrentScale.
   */
  get currentScale() {
    return this[RF];
  }
  /**
   * Sets currentScale.
   *
   * @param currentScale CurrentScale.
   */
  set currentScale(e) {
    const n = typeof e != "number" ? parseFloat(String(e)) : e;
    if (isNaN(n))
      throw this[b].TypeError("Failed to set the 'currentScale' property on 'SVGSVGElement': The provided float value is non-finite.");
    n < 1 || (this[RF] = n);
  }
  /**
   * Returns current translate.
   *
   * @returns SVG point.
   */
  get currentTranslate() {
    return new sa(T, this[b]);
  }
  /**
   * Returns view box.
   *
   * @returns View box.
   */
  get viewBox() {
    return this[Yl] || (this[Yl] = new Q2(T, this[b], {
      getAttribute: () => this.getAttribute("viewBox"),
      setAttribute: (e) => this.setAttribute("viewBox", e)
    })), this[Yl];
  }
  /**
   * Pauses animation.
   */
  pauseAnimations() {
  }
  /**
   * Unpauses animation.
   */
  unpauseAnimations() {
  }
  /**
   * Returns "true" if animation is paused.
   *
   * @returns "true" if animation is paused.
   */
  animationsPaused() {
    return !1;
  }
  /**
   * Returns the current time in seconds relative to the start time for the current SVG document fragment.
   *
   * @returns Current time in seconds.
   */
  getCurrentTime() {
    return 0;
  }
  /**
   * Sets current time.
   *
   * @param _seconds Seconds.
   */
  setCurrentTime(e) {
  }
  /**
   * Returns intersection list.
   *
   * @param _rect SVG Rect.
   * @param _element SVG Element.
   * @returns Intersection list.
   */
  getIntersectionList(e, n) {
    return new xo(T, []);
  }
  /**
   * Returns enclousure list.
   *
   * @param _rect SVG Rect.
   * @param _element SVG Element.
   * @returns Enclousure list.
   */
  getEnclosureList(e, n) {
    return new xo(T, []);
  }
  /**
   * Returns true if the rendered content of the given element intersects the supplied rectangle.
   *
   * @param _element SVG Element.
   * @param _rect SVG Rect.
   * @returns Intersection state.
   */
  checkIntersection(e, n) {
    return !1;
  }
  /**
   * Returns true if the rendered content of the given element is entirely contained within the supplied rectangle.
   *
   * @param _element SVG Element.
   * @param _rect SVG Rect.
   * @returns Enclousure state.
   */
  checkEnclosure(e, n) {
    return !1;
  }
  /**
   * Unselects any selected objects, including any selections of text strings and type-in bars.
   */
  deselectAll() {
  }
  /**
   * Returns a number.
   *
   * @returns Number.
   */
  createSVGNumber() {
    return new Bd(T, this[b]);
  }
  /**
   * Returns a length.
   *
   * @returns Length.
   */
  createSVGLength() {
    return new Kg(T, this[b]);
  }
  /**
   * Returns a angle.
   *
   * @returns Angle.
   */
  createSVGAngle() {
    return new Z1(T, this[b]);
  }
  /**
   * Returns a point.
   *
   * @returns Point.
   */
  createSVGPoint() {
    return new sa(T, this[b]);
  }
  /**
   * Returns a matrix.
   *
   * @returns Matrix.
   */
  createSVGMatrix() {
    return new Hi(T, this[b]);
  }
  /**
   * Returns a rect.
   *
   * @returns Rect.
   */
  createSVGRect() {
    return new Vg(T, this[b]);
  }
  /**
   * Returns a transform.
   *
   * @returns Transform.
   */
  createSVGTransform() {
    return new Pl(T, this[b]);
  }
  /**
   * Returns a transform from a matrix.
   *
   * @param matrix Matrix.
   */
  createSVGTransformFromMatrix(e) {
    const n = new Pl(T, this[b]);
    return n.setMatrix(e), n;
  }
  /**
   * Returns an elements by class name.
   *
   * @param className Tag name.
   * @returns Matching element.
   */
  getElementsByClassName(e) {
    return Wn.getElementsByClassName(this, e);
  }
  /**
   * Returns an elements by tag name.
   *
   * @param tagName Tag name.
   * @returns Matching element.
   */
  getElementsByTagName(e) {
    return Wn.getElementsByTagName(this, e);
  }
  /**
   * Returns an elements by tag name and namespace.
   *
   * @param namespaceURI Namespace URI.
   * @param tagName Tag name.
   * @returns Matching element.
   */
  getElementsByTagNameNS(e, n) {
    return Wn.getElementsByTagNameNS(this, e, n);
  }
  /**
   * Returns an element by ID.
   *
   * @param id ID.
   * @returns Matching element.
   */
  getElementById(e) {
    return Wn.getElementById(this, e);
  }
  /**
   * @override
   */
  [Bt](e = !1) {
    return super[Bt](e);
  }
}
class Sp extends nn {
  // Internal properties
  [zl] = null;
  [jl] = null;
  // Events
  /* eslint-disable jsdoc/require-jsdoc */
  get onbegin() {
    return K.getEventListener(this, "onbegin");
  }
  set onbegin(e) {
    this[F].set("onbegin", e);
  }
  get onend() {
    return K.getEventListener(this, "onend");
  }
  set onend(e) {
    this[F].set("onend", e);
  }
  get onrepeat() {
    return K.getEventListener(this, "onrepeat");
  }
  set onrepeat(e) {
    this[F].set("onrepeat", e);
  }
  /* eslint-enable jsdoc/require-jsdoc */
  /**
   * Returns required extensions.
   *
   * @returns Required extensions.
   */
  get requiredExtensions() {
    return this[zl] || (this[zl] = new xh(T, this[b], {
      getAttribute: () => this.getAttribute("requiredExtensions"),
      setAttribute: (e) => this.setAttribute("requiredExtensions", e)
    })), this[zl];
  }
  /**
   * Returns system language.
   *
   * @returns System language.
   */
  get systemLanguage() {
    return this[jl] || (this[jl] = new xh(T, this[b], {
      getAttribute: () => this.getAttribute("systemLanguage"),
      setAttribute: (e) => this.setAttribute("systemLanguage", e)
    })), this[jl];
  }
  /**
   * Returns target element.
   *
   * @returns Target element.
   */
  get targetElement() {
    return null;
  }
}
class MGe extends Sp {
}
class OGe extends Sp {
}
class BGe extends Sp {
}
class At {
  // Internal properties
  [b];
  [se];
  [Q];
  [So] = 0;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   * @param options.defaultValue
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute, this[So] = r.defaultValue || 0;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this.baseVal;
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    const e = this[se]();
    if (!e)
      return this[So];
    const n = parseFloat(e);
    return isNaN(n) ? this[So] : n;
  }
  /**
   * Sets base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
    const n = typeof e != "number" ? parseFloat(e) : e;
    if (isNaN(n))
      throw new this[b].TypeError("TypeError: Failed to set the 'baseVal' property on 'SVGAnimatedNumber': The provided float value is non-finite.");
    this[Q](String(n));
  }
}
class Cc extends ha {
  // Internal properties
  [cb] = null;
  /**
   * Returns path length.
   *
   * @returns Path length.
   */
  get pathLength() {
    return this[cb] || (this[cb] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("pathLength"),
      setAttribute: (e) => this.setAttribute("pathLength", e)
    })), this[cb];
  }
  /**
   * Returns true if the point is in the fill of the element.
   *
   * Not implemented yet.
   *
   * @param point Point.
   * @returns True if the point is in the fill of the element.
   */
  isPointInFill(e) {
    if (!(e instanceof sa))
      throw new TypeError("Failed to execute 'isPointInFill' on 'SVGGeometryElement': parameter 1 is not of type 'SVGPoint'.");
    return !1;
  }
  /**
   * Returns true if the point is in the stroke of the element.
   *
   * Not implemented yet.
   *
   * @param point Point.
   * @returns True if the point is in the stroke of the element.
   */
  isPointInStroke(e) {
    if (!(e instanceof sa))
      throw new TypeError("Failed to execute 'isPointInFill' on 'SVGGeometryElement': parameter 1 is not of type 'SVGPoint'.");
    return !1;
  }
  /**
   * Returns total length.
   *
   * Not implemented yet.
   *
   * @returns Total length.
   */
  getTotalLength() {
    return 0;
  }
  /**
   * Returns point at length.
   *
   * Not implemented yet.
   *
   * @param _distance Distance.
   * @returns Point at length.
   */
  getPointAtLength(e) {
    return new sa(T, this[b]);
  }
}
class $Ge extends Cc {
  // Internal properties
  [Oa] = null;
  [Ba] = null;
  [Zl] = null;
  /**
   * Returns cx.
   *
   * @returns Cx.
   */
  get cx() {
    return this[Oa] || (this[Oa] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("cx"),
      setAttribute: (e) => this.setAttribute("cx", e)
    })), this[Oa];
  }
  /**
   * Returns cy.
   *
   * @returns Cy.
   */
  get cy() {
    return this[Ba] || (this[Ba] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("cy"),
      setAttribute: (e) => this.setAttribute("cy", e)
    })), this[Ba];
  }
  /**
   * Returns r.
   *
   * @returns R.
   */
  get r() {
    return this[Zl] || (this[Zl] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("r"),
      setAttribute: (e) => this.setAttribute("r", e)
    })), this[Zl];
  }
}
class cr {
  // Internal properties
  [b];
  [se];
  [Q];
  [Fi];
  [So];
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   * @param options.values Values.
   * @param options.defaultValue Default value.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute, this[Fi] = r.values, this[So] = r.defaultValue;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this.baseVal;
  }
  /**
   * Returns animated value.
   *
   * @param _value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    const e = this[se]();
    if (!e)
      return this[Fi].indexOf(this[So]) + 1;
    const n = this[Fi].indexOf(e);
    if (n === -1) {
      const r = this[Fi].indexOf(null);
      return r !== -1 ? r + 1 : 0;
    }
    return n + 1;
  }
  /**
   * Sets base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
    let n = Number(e);
    if (isNaN(n) && (n = 0), n < 1)
      throw new TypeError(`Failed to set the 'baseVal' property on 'SVGAnimatedEnumeration': The enumeration value provided is ${n}, which is not settable.`);
    if (n > this[Fi].length)
      throw new TypeError(`Failed to set the 'baseVal' property on 'SVGAnimatedEnumeration': The enumeration value provided (${n}) is larger than the largest allowed value (${this[Fi].length}).`);
    const r = this[se](), i = this[Fi][n - 1] === null, s = i ? "0" : this[Fi][n - 1];
    (!r || i && this[Fi].includes(r) || !i && r !== s) && this[Q](s || "");
  }
}
class HGe extends nn {
  // Internal properties
  [yb] = null;
  /**
   * Returns clipPathUnits.
   *
   * @returns ClipPathUnits.
   */
  get clipPathUnits() {
    return this[yb] || (this[yb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("clipPathUnits"),
      setAttribute: (e) => this.setAttribute("clipPathUnits", e),
      values: ["userSpaceOnUse", "objectBoundingBox"],
      defaultValue: "userSpaceOnUse"
    })), this[yb];
  }
}
class UGe extends ha {
}
class GGe extends nn {
}
class WGe extends Cc {
  // Internal properties
  [Oa] = null;
  [Ba] = null;
  [Ql] = null;
  [Xl] = null;
  /**
   * Returns cx.
   *
   * @returns Cx.
   */
  get cx() {
    return this[Oa] || (this[Oa] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("cx"),
      setAttribute: (e) => this.setAttribute("cx", e)
    })), this[Oa];
  }
  /**
   * Returns cy.
   *
   * @returns Cy.
   */
  get cy() {
    return this[Ba] || (this[Ba] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("cy"),
      setAttribute: (e) => this.setAttribute("cy", e)
    })), this[Ba];
  }
  /**
   * Returns rx.
   *
   * @returns Rx.
   */
  get rx() {
    return this[Ql] || (this[Ql] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("rx"),
      setAttribute: (e) => this.setAttribute("rx", e)
    })), this[Ql];
  }
  /**
   * Returns ry.
   *
   * @returns Ry.
   */
  get ry() {
    return this[Xl] || (this[Xl] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("ry"),
      setAttribute: (e) => this.setAttribute("ry", e)
    })), this[Xl];
  }
}
class Pt {
  // Internal properties
  [b];
  [se];
  [Q];
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this.baseVal;
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    const e = this[se]();
    return e || "";
  }
  /**
   * Sets base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
    this[Q](String(e));
  }
}
class VGe extends nn {
  // Static properties
  static SVG_FEBLEND_MODE_UNKNOWN = 0;
  static SVG_FEBLEND_MODE_NORMAL = 1;
  static SVG_FEBLEND_MODE_MULTIPLY = 2;
  static SVG_FEBLEND_MODE_SCREEN = 3;
  static SVG_FEBLEND_MODE_DARKEN = 4;
  static SVG_FEBLEND_MODE_LIGHTEN = 5;
  static SVG_FEBLEND_MODE_OVERLAY = 6;
  static SVG_FEBLEND_MODE_COLOR_DODGE = 7;
  static SVG_FEBLEND_MODE_COLOR_BURN = 8;
  static SVG_FEBLEND_MODE_HARD_LIGHT = 9;
  static SVG_FEBLEND_MODE_SOFT_LIGHT = 10;
  static SVG_FEBLEND_MODE_DIFFERENCE = 11;
  static SVG_FEBLEND_MODE_EXCLUSION = 12;
  static SVG_FEBLEND_MODE_HUE = 13;
  static SVG_FEBLEND_MODE_SATURATION = 14;
  static SVG_FEBLEND_MODE_COLOR = 15;
  static SVG_FEBLEND_MODE_LUMINOSITY = 16;
  // Internal properties
  [we] = null;
  [nt] = null;
  [$a] = null;
  [Jr] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns in2.
   *
   * @returns In2.
   */
  get in2() {
    return this[$a] || (this[$a] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in2"),
      setAttribute: (e) => this.setAttribute("in2", e)
    })), this[$a];
  }
  /**
   * Returns mode.
   *
   * @returns Mode.
   */
  get mode() {
    return this[Jr] || (this[Jr] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("mode"),
      setAttribute: (e) => this.setAttribute("mode", e),
      values: [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "color-dodge",
        "color-burn",
        "hard-light",
        "soft-light",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ],
      defaultValue: "normal"
    })), this[Jr];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
const KGe = /[\t\f\n\r, ]+/;
class zg {
  [b];
  [se];
  [Q];
  [Be] = !1;
  [Ae] = {
    items: [],
    attributeValue: ""
  };
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param [options.readOnly] Read only.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    if (this[b] = n, this[Be] = !!r.readOnly, this[se] = r.getAttribute, this[Q] = r.setAttribute, e !== T)
      throw new TypeError("Illegal constructor");
    const i = new Ws(this, [zg]);
    return new Proxy(this, {
      get: (s, a) => {
        if (a === "length" || a === "numberOfItems")
          return s[De]().length;
        if (a in s || typeof a == "symbol")
          return i.bind(a), s[a];
        const o = Number(a);
        if (!isNaN(o))
          return s[De]()[o];
      },
      set(s, a, o) {
        if (i.bind(a), typeof a == "symbol")
          return s[a] = o, !0;
        const u = Number(a);
        return isNaN(u) && (s[a] = o), !0;
      },
      deleteProperty(s, a) {
        if (typeof a == "symbol")
          return delete s[a], !0;
        const o = Number(a);
        return isNaN(o) && delete s[a], !0;
      },
      ownKeys(s) {
        return Object.keys(s[De]());
      },
      has(s, a) {
        if (a in s)
          return !0;
        if (typeof a == "symbol")
          return !1;
        const o = Number(a);
        return !isNaN(o) && o >= 0 && o < s[De]().length;
      },
      defineProperty(s, a, o) {
        return i.preventBinding(a), a in s ? (Object.defineProperty(s, a, o), !0) : !1;
      },
      getOwnPropertyDescriptor(s, a) {
        if (a in s || typeof a == "symbol")
          return;
        const o = Number(a), u = s[De]();
        if (!isNaN(o) && u[o])
          return {
            value: u[o],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[De]().length;
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get numberOfItems() {
    return this[De]().length;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   */
  [Symbol.iterator]() {
    return this[De]().values();
  }
  /**
   * Clears all items from the list.
   */
  clear() {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'clear' on 'SVGNumberList': The object is read-only.");
    for (const e of this[Ae].items)
      e[se] = null, e[Q] = null;
    this[Ae].items = [], this[Ae].attributeValue = "", this[Q]("");
  }
  /**
   * Replace Token.
   *
   * @param newItem New item.
   * @returns The item being replaced.
   */
  initialize(e) {
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'initialize' on 'SVGNumberList': 1 arguments required, but only ${arguments.length} present.`);
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'initialize' on 'SVGNumberList': The object is read-only.");
    for (const n of this[Ae].items)
      n[se] = null, n[Q] = null;
    return e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((n) => n[ae] || "0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].items = [e], this[Ae].attributeValue = e[ae], this[Q](e[ae] || ""), e;
  }
  /**
   * Returns item at index.
   *
   * @param index Index.
   * @returns The item at the index.
   **/
  getItem(e) {
    const n = this[De]();
    return typeof e == "number" || (e = Number(e), e = isNaN(e) ? 0 : e), n[e] ? n[e] : null;
  }
  /**
   * Inserts a new item into the list at the specified position. The first item is number 0. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to insert before is before the removal of the item. If the index is equal to 0, then the new item is inserted at the front of the list. If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being inserted.
   */
  insertItemBefore(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'insertItemBefore' on 'SVGNumberList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'insertItemBefore' on 'SVGNumberList': 2 arguments required, but only ${arguments.length} present.`);
    if (!(e instanceof Bd))
      throw new this[b].TypeError("Failed to execute 'insertItemBefore' on 'SVGNumberList': parameter 1 is not of type 'SVGNumber'.");
    const r = this[De](), i = r.indexOf(e);
    return i !== -1 && r.splice(i, 1), n < 0 ? n = 0 : n > r.length && (n = r.length), r.splice(n, 0, e), e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((s) => s[ae] || "0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = r.map((s) => s[ae] || "0").join(" "), this[Q](this[Ae].attributeValue), e;
  }
  /**
   * Replaces an existing item in the list with a new item. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to replace is before the removal of the item.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being replaced.
   */
  replaceItem(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'replaceItem' on 'SVGNumberList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'replaceItem' on 'SVGNumberList': 2 arguments required, but only ${arguments.length} present.`);
    if (!(e instanceof Bd))
      throw new this[b].TypeError("Failed to execute 'replaceItem' on 'SVGNumberList': parameter 1 is not of type 'SVGNumber'.");
    const r = this[De](), i = r.indexOf(e);
    if (i === n)
      return e;
    i !== -1 && r.splice(i, 1), n < 0 ? n = 0 : n >= r.length && (n = r.length - 1), r[n] && (r[n][se] = null, r[n][Q] = null);
    const s = r[n];
    return r[n] = e, e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((a) => a[ae] || "0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = r.map((a) => a[ae] || "0").join(" "), this[Q](this[Ae].attributeValue), s;
  }
  /**
   * Removes an existing item from the list.
   *
   * @param index Index.
   * @returns The removed item.
   */
  removeItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'removeItem' on 'SVGNumberList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'removeItem' on 'SVGNumberList': 1 argument required, but only ${arguments.length} present.`);
    const n = this[De]();
    if (e = Number(e), isNaN(e) && (e = 0), e >= n.length)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGNumberList':  The index provided (${e}) is greater than the maximum bound.`, ne.indexSizeError);
    if (e < 0)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGNumberList':  The index provided (${e}) is negative.`, ne.indexSizeError);
    const r = n[e];
    return r && (r[se] = null, r[Q] = null), n.splice(e, 1), this[Q](n.map((i) => i[ae] || "0").join(" ")), r;
  }
  /**
   * Appends an item to the end of the list.
   *
   * @param newItem The item to add to the list.
   * @returns The item being appended.
   */
  appendItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGNumberList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'appendItem' on 'SVGNumberList': 1 argument required, but only ${arguments.length} present.`);
    if (!(e instanceof Bd))
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGNumberList': parameter 1 is not of type 'SVGNumber'.");
    const n = this[De](), r = n.indexOf(e);
    return r !== -1 && n.splice(r, 1), n.push(e), e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((i) => i[ae] || "0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = n.map((i) => i[ae] || "0").join(" "), this[Q](this[Ae].attributeValue), e;
  }
  /**
   * Returns item list from attribute value.
   *
   * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
   */
  [De]() {
    const e = this[se]() ?? "", n = this[Ae];
    if (n.attributeValue === e)
      return n.items;
    if (n.items.length)
      for (const s of n.items)
        s[se] = null, s[Q] = null;
    const r = [], i = e.trim();
    if (i) {
      const s = i.split(KGe);
      for (let a = 0, o = s.length; a < o; a++) {
        const u = new Bd(T, this[b], {
          readOnly: this[Be],
          getAttribute: () => u[ae],
          setAttribute: () => {
            this[Ae].attributeValue = this[De]().map((l) => l[ae] || "0").join(" "), this[Q](this[Ae].attributeValue);
          }
        });
        u[ae] = String(parseFloat(s[a])), r.push(u);
      }
    }
    return n.attributeValue = e, n.items = r, r;
  }
}
class Bf {
  // Internal properties
  [b];
  [se];
  [Q];
  [Jn] = null;
  [Qn] = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this[Qn] || (this[Qn] = new zg(T, this[b], {
      readOnly: !0,
      getAttribute: this[se],
      setAttribute: () => {
      }
    })), this[Qn];
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    return this[Jn] || (this[Jn] = new zg(T, this[b], {
      getAttribute: this[se],
      setAttribute: this[Q]
    })), this[Jn];
  }
  /**
   * Sets base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
  }
}
class zGe extends nn {
  // Static properties
  static SVG_FEBLEND_TYPE_UNKNOWN = 0;
  static SVG_FEBLEND_TYPE_MATRIX = 1;
  static SVG_FEBLEND_TYPE_SATURATE = 2;
  static SVG_FEBLEND_TYPE_HUEROTATE = 3;
  static SVG_FEBLEND_TYPE_LUMINANCETOALPHA = 4;
  // Internal properties
  [we] = null;
  [nt] = null;
  [$a] = null;
  [Qe] = null;
  [qn] = null;
  [Fi] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns in2.
   *
   * @returns In2.
   */
  get in2() {
    return this[$a] || (this[$a] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in2"),
      setAttribute: (e) => this.setAttribute("in2", e)
    })), this[$a];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this[qn] || (this[qn] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("type"),
      setAttribute: (e) => this.setAttribute("type", e),
      values: ["matrix", "saturate", "huerotate", "luminancetoalpha"],
      defaultValue: "matrix"
    })), this[qn];
  }
  /**
   * Returns values.
   *
   * @returns Values.
   */
  get values() {
    return this[Fi] || (this[Fi] = new Bf(T, this[b], {
      getAttribute: () => this.getAttribute("values"),
      setAttribute: (e) => this.setAttribute("values", e)
    })), this[Fi];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class jGe extends nn {
  // Internal properties
  [we] = null;
  [nt] = null;
  [Qe] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class YGe extends nn {
  // Static properties
  static SVG_FECOMPOSITE_OPERATOR_UNKNOWN = 0;
  static SVG_FECOMPOSITE_OPERATOR_OVER = 1;
  static SVG_FECOMPOSITE_OPERATOR_IN = 2;
  static SVG_FECOMPOSITE_OPERATOR_OUT = 3;
  static SVG_FECOMPOSITE_OPERATOR_ATOP = 4;
  static SVG_FECOMPOSITE_OPERATOR_XOR = 5;
  static SVG_FECOMPOSITE_OPERATOR_ARITHMETIC = 6;
  // Internal properties
  [we] = null;
  [nt] = null;
  [Qe] = null;
  [qn] = null;
  [Fi] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this[qn] || (this[qn] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("type"),
      setAttribute: (e) => this.setAttribute("type", e),
      values: ["over", "in", "out", "atop", "xor", "arithmetic"],
      defaultValue: "over"
    })), this[qn];
  }
  /**
   * Returns values.
   *
   * @returns Values.
   */
  get values() {
    return this[Fi] || (this[Fi] = new Bf(T, this[b], {
      getAttribute: () => this.getAttribute("values"),
      setAttribute: (e) => this.setAttribute("values", e)
    })), this[Fi];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class OW {
  // Internal properties
  [b];
  [se];
  [Q];
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this.baseVal;
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    return this[se]() === "true";
  }
  /**
   * Sets base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
    this[Q](String(typeof e != "boolean" ? !!e : e));
  }
}
class $d {
  // Internal properties
  [b];
  [se];
  [Q];
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this.baseVal;
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    const e = this[se]();
    if (!e)
      return 0;
    const n = parseInt(e);
    return isNaN(n) ? 0 : n;
  }
  /**
   * Sets base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
    const n = parseInt(String(e));
    if (isNaN(n))
      throw new this[b].TypeError("TypeError: Failed to set the 'baseVal' property on 'SVGAnimatedInteger': The provided float value is non-finite.");
    this[Q](String(n));
  }
}
class qGe extends nn {
  // Static properties
  static SVG_EDGEMODE_UNKNOWN = 0;
  static SVG_EDGEMODE_DUPLICATE = 1;
  static SVG_EDGEMODE_WRAP = 2;
  static SVG_EDGEMODE_NONE = 3;
  // Internal properties
  [Mb] = null;
  [Ob] = null;
  [sc] = null;
  [we] = null;
  [nt] = null;
  [Bb] = null;
  [Ha] = null;
  [Ua] = null;
  [$b] = null;
  [Hb] = null;
  [Ub] = null;
  [Qe] = null;
  [Gb] = null;
  [Wb] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns bias.
   *
   * @returns Bias.
   */
  get bias() {
    return this[Mb] || (this[Mb] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("bias"),
      setAttribute: (e) => this.setAttribute("bias", e)
    })), this[Mb];
  }
  /**
   * Returns divisor.
   *
   * @returns Divisor.
   */
  get divisor() {
    return this[Ob] || (this[Ob] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("divisor"),
      setAttribute: (e) => this.setAttribute("divisor", e)
    })), this[Ob];
  }
  /**
   * Returns edge mode.
   *
   * @returns Edge mode.
   */
  get edgeMode() {
    return this[sc] || (this[sc] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("edgeMode"),
      setAttribute: (e) => this.setAttribute("edgeMode", e),
      values: ["duplicate", "wrap", "none"],
      defaultValue: "duplicate"
    })), this[sc];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns kernel matrix.
   *
   * @returns Kernel matrix.
   */
  get kernelMatrix() {
    return this[Bb] || (this[Bb] = new Bf(T, this[b], {
      getAttribute: () => this.getAttribute("kernelMatrix"),
      setAttribute: (e) => this.setAttribute("kernelMatrix", e)
    })), this[Bb];
  }
  /**
   * Returns kernel unit length x.
   *
   * @returns Kernel unit length x.
   */
  get kernelUnitLengthX() {
    return this[Ha] || (this[Ha] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("kernelUnitLengthX"),
      setAttribute: (e) => this.setAttribute("kernelUnitLengthX", e)
    })), this[Ha];
  }
  /**
   * Returns kernel unit length y.
   *
   * @returns Kernel unit length y.
   */
  get kernelUnitLengthY() {
    return this[Ua] || (this[Ua] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("kernelUnitLengthY"),
      setAttribute: (e) => this.setAttribute("kernelUnitLengthY", e)
    })), this[Ua];
  }
  /**
   * Returns order x.
   *
   * @returns Order x.
   */
  get orderX() {
    return this[$b] || (this[$b] = new $d(T, this[b], {
      getAttribute: () => this.getAttribute("orderX"),
      setAttribute: (e) => this.setAttribute("orderX", e)
    })), this[$b];
  }
  /**
   * Returns order y.
   *
   * @returns Order y.
   */
  get orderY() {
    return this[Hb] || (this[Hb] = new $d(T, this[b], {
      getAttribute: () => this.getAttribute("orderY"),
      setAttribute: (e) => this.setAttribute("orderY", e)
    })), this[Hb];
  }
  /**
   * Returns preserve alpha.
   *
   * @returns Preserve alpha.
   */
  get preserveAlpha() {
    return this[Ub] || (this[Ub] = new OW(T, this[b], {
      getAttribute: () => this.getAttribute("preserveAlpha"),
      setAttribute: (e) => this.setAttribute("preserveAlpha", e)
    })), this[Ub];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns target x.
   *
   * @returns Target x.
   */
  get targetX() {
    return this[Gb] || (this[Gb] = new $d(T, this[b], {
      getAttribute: () => this.getAttribute("targetX"),
      setAttribute: (e) => this.setAttribute("targetX", e)
    })), this[Gb];
  }
  /**
   * Returns target y.
   *
   * @returns Target y.
   */
  get targetY() {
    return this[Wb] || (this[Wb] = new $d(T, this[b], {
      getAttribute: () => this.getAttribute("targetY"),
      setAttribute: (e) => this.setAttribute("targetY", e)
    })), this[Wb];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class JGe extends nn {
  // Internal properties
  [Vb] = null;
  [we] = null;
  [nt] = null;
  [Ha] = null;
  [Ua] = null;
  [Qe] = null;
  [ac] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns diffuse constant.
   *
   * @returns Diffuse constant.
   */
  get diffuseConstant() {
    return this[Vb] || (this[Vb] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("diffuseConstant"),
      setAttribute: (e) => this.setAttribute("diffuseConstant", e)
    })), this[Vb];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns kernel unit length x.
   *
   * @returns Kernel unit length x.
   */
  get kernelUnitLengthX() {
    return this[Ha] || (this[Ha] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("kernelUnitLengthX"),
      setAttribute: (e) => this.setAttribute("kernelUnitLengthX", e)
    })), this[Ha];
  }
  /**
   * Returns kernel unit length y.
   *
   * @returns Kernel unit length y.
   */
  get kernelUnitLengthY() {
    return this[Ua] || (this[Ua] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("kernelUnitLengthY"),
      setAttribute: (e) => this.setAttribute("kernelUnitLengthY", e)
    })), this[Ua];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns surface scale.
   *
   * @returns Surface scale.
   */
  get surfaceScale() {
    return this[ac] || (this[ac] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("surfaceScale"),
      setAttribute: (e) => this.setAttribute("surfaceScale", e)
    })), this[ac];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class QGe extends nn {
  // Static properties
  static SVG_CHANNEL_UNKNOWN = 0;
  static SVG_CHANNEL_R = 1;
  static SVG_CHANNEL_G = 2;
  static SVG_CHANNEL_B = 3;
  static SVG_CHANNEL_A = 4;
  // Internal properties
  [we] = null;
  [nt] = null;
  [$a] = null;
  [Qe] = null;
  [Kb] = null;
  [Fe] = null;
  [me] = null;
  [zb] = null;
  [ge] = null;
  [jb] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns in2.
   *
   * @returns In2.
   */
  get in2() {
    return this[$a] || (this[$a] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in2"),
      setAttribute: (e) => this.setAttribute("in2", e)
    })), this[$a];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns scale.
   *
   * @returns Scale.
   */
  get scale() {
    return this[Kb] || (this[Kb] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("scale"),
      setAttribute: (e) => this.setAttribute("scale", e)
    })), this[Kb];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns x channel selector.
   *
   * @returns X channel selector.
   */
  get xChannelSelector() {
    return this[zb] || (this[zb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("xChannelSelector"),
      setAttribute: (e) => this.setAttribute("xChannelSelector", e),
      values: ["r", "g", "b", "a"],
      defaultValue: "r"
    })), this[zb];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Returns y channel selector.
   *
   * @returns Y channel selector.
   */
  get yChannelSelector() {
    return this[jb] || (this[jb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("yChannelSelector"),
      setAttribute: (e) => this.setAttribute("yChannelSelector", e),
      values: ["r", "g", "b", "a"],
      defaultValue: "r"
    })), this[jb];
  }
}
class XGe extends nn {
  // Internal properties
  [Yb] = null;
  [qb] = null;
  /**
   * Returns azimuth.
   *
   * @returns Azimuth.
   */
  get azimuth() {
    return this[Yb] || (this[Yb] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("azimuth"),
      setAttribute: (e) => this.setAttribute("azimuth", e)
    })), this[Yb];
  }
  /**
   * Returns elevation.
   *
   * @returns Elevation.
   */
  get elevation() {
    return this[qb] || (this[qb] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("elevation"),
      setAttribute: (e) => this.setAttribute("elevation", e)
    })), this[qb];
  }
}
class ZGe extends nn {
  // Internal properties
  [Ga] = null;
  [Wa] = null;
  [we] = null;
  [nt] = null;
  [Qe] = null;
  [oc] = null;
  [uc] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns dx.
   *
   * @returns Dx.
   */
  get dx() {
    return this[Ga] || (this[Ga] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("dx"),
      setAttribute: (e) => this.setAttribute("dx", e)
    })), this[Ga];
  }
  /**
   * Returns dy.
   *
   * @returns Dy.
   */
  get dy() {
    return this[Wa] || (this[Wa] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("dy"),
      setAttribute: (e) => this.setAttribute("dy", e)
    })), this[Wa];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns stdDeviationX.
   *
   * @returns StdDeviationX.
   */
  get stdDeviationX() {
    return this[oc] || (this[oc] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("stdDeviationX"),
      setAttribute: (e) => this.setAttribute("stdDeviationX", e),
      defaultValue: 2
    })), this[oc];
  }
  /**
   * Returns stdDeviationY.
   *
   * @returns StdDeviationY.
   */
  get stdDeviationY() {
    return this[uc] || (this[uc] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("stdDeviationY"),
      setAttribute: (e) => this.setAttribute("stdDeviationY", e),
      defaultValue: 2
    })), this[uc];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Sets stdDeviation.
   *
   * @param x X.
   * @param y Y.
   */
  setStdDeviation(e, n) {
    this.stdDeviationX.baseVal = e, this.stdDeviationY.baseVal = n;
  }
}
class e7e extends nn {
  // Internal properties
  [we] = null;
  [Qe] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class wp extends nn {
  // Static properties
  static SVG_FECOMPONENTTRANSFER_TYPE_UNKNOWN = 0;
  static SVG_FECOMPONENTTRANSFER_TYPE_IDENTITY = 1;
  static SVG_FECOMPONENTTRANSFER_TYPE_TABLE = 2;
  static SVG_FECOMPONENTTRANSFER_TYPE_DISCRETE = 3;
  static SVG_FECOMPONENTTRANSFER_TYPE_LINEAR = 4;
  static SVG_FECOMPONENTTRANSFER_TYPE_GAMMA = 5;
  // Internal properties
  [qn] = null;
  [Jb] = null;
  [Qb] = null;
  [Xb] = null;
  [Zb] = null;
  [ey] = null;
  [ic] = null;
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this[qn] || (this[qn] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("type"),
      setAttribute: (e) => this.setAttribute("type", e),
      values: ["identity", "table", "discrete", "linear", "gamma"],
      defaultValue: "identity"
    })), this[qn];
  }
  /**
   * Returns table values.
   *
   * @returns Table values.
   */
  get tableValues() {
    return this[Jb] || (this[Jb] = new Bf(T, this[b], {
      getAttribute: () => this.getAttribute("tableValues"),
      setAttribute: (e) => this.setAttribute("tableValues", e)
    })), this[Jb];
  }
  /**
   * Returns slope.
   *
   * @returns Slope.
   */
  get slope() {
    return this[Qb] || (this[Qb] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("slope"),
      setAttribute: (e) => this.setAttribute("slope", e),
      defaultValue: 1
    })), this[Qb];
  }
  /**
   * Returns intercept.
   *
   * @returns Intercept.
   */
  get intercept() {
    return this[Xb] || (this[Xb] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("intercept"),
      setAttribute: (e) => this.setAttribute("intercept", e)
    })), this[Xb];
  }
  /**
   * Returns amplitude.
   *
   * @returns Amplitude.
   */
  get amplitude() {
    return this[Zb] || (this[Zb] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("amplitude"),
      setAttribute: (e) => this.setAttribute("amplitude", e),
      defaultValue: 1
    })), this[Zb];
  }
  /**
   * Returns exponent.
   *
   * @returns Exponent.
   */
  get exponent() {
    return this[ey] || (this[ey] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("exponent"),
      setAttribute: (e) => this.setAttribute("exponent", e),
      defaultValue: 1
    })), this[ey];
  }
  /**
   * Returns offset.
   *
   * @returns Offset.
   */
  get offset() {
    return this[ic] || (this[ic] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("offset"),
      setAttribute: (e) => this.setAttribute("offset", e)
    })), this[ic];
  }
}
class t7e extends wp {
}
class n7e extends wp {
}
class r7e extends wp {
}
class i7e extends wp {
}
class s7e extends nn {
  // Static properties
  static SVG_EDGEMODE_UNKNOWN = 0;
  static SVG_EDGEMODE_DUPLICATE = 1;
  static SVG_EDGEMODE_WRAP = 2;
  static SVG_EDGEMODE_NONE = 3;
  // Internal properties
  [sc] = null;
  [we] = null;
  [nt] = null;
  [Qe] = null;
  [oc] = null;
  [uc] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns edge mode.
   *
   * @returns Edge mode.
   */
  get edgeMode() {
    return this[sc] || (this[sc] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("edgeMode"),
      setAttribute: (e) => this.setAttribute("edgeMode", e),
      values: ["duplicate", "wrap", "none"],
      defaultValue: "duplicate"
    })), this[sc];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns stdDeviationX.
   *
   * @returns StdDeviationX.
   */
  get stdDeviationX() {
    return this[oc] || (this[oc] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("stdDeviationX") || "2",
      setAttribute: (e) => this.setAttribute("stdDeviationX", e)
    })), this[oc];
  }
  /**
   * Returns stdDeviationY.
   *
   * @returns StdDeviationY.
   */
  get stdDeviationY() {
    return this[uc] || (this[uc] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("stdDeviationY") || "2",
      setAttribute: (e) => this.setAttribute("stdDeviationY", e)
    })), this[uc];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Sets stdDeviation.
   *
   * @param x X.
   * @param y Y.
   */
  setStdDeviation(e, n) {
    this.stdDeviationX.baseVal = e, this.stdDeviationY.baseVal = n;
  }
}
class a7e extends nn {
  // Internal properties
  [G8e] = null;
  [we] = null;
  [dn] = null;
  [ns] = null;
  [Qe] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns "crossorigin" attribute.
   *
   * @returns Cross origin.
   */
  get crossOrigin() {
    return this.getAttribute("crossorigin");
  }
  /**
   * Sets "crossorigin" attribute.
   *
   * @param value Cross origin.
   */
  set crossOrigin(e) {
    this.setAttribute("crossorigin", e);
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this[dn] || (this[dn] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("href"),
      setAttribute: (e) => this.setAttribute("href", e)
    })), this[dn];
  }
  /**
   * Returns preserveAspectRatio.
   *
   * @returns PreserveAspectRatio.
   */
  get preserveAspectRatio() {
    return this[ns] || (this[ns] = new Ep(T, this[b], {
      getAttribute: () => this.getAttribute("preserveAspectRatio"),
      setAttribute: (e) => this.setAttribute("preserveAspectRatio", e)
    })), this[ns];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class o7e extends nn {
  // Internal properties
  [we] = null;
  [Qe] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class u7e extends nn {
  // Internal properties
  [nt] = null;
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
}
class l7e extends nn {
  // Static properties
  static SVG_MORPHOLOGY_OPERATOR_UNKNOWN = 0;
  static SVG_MORPHOLOGY_OPERATOR_ERODE = 1;
  static SVG_MORPHOLOGY_OPERATOR_DILATE = 2;
  // Internal properties
  [we] = null;
  [nt] = null;
  [ty] = null;
  [ny] = null;
  [ry] = null;
  [Qe] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns operator.
   *
   * @returns Operator.
   */
  get operator() {
    return this[ty] || (this[ty] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("operator"),
      setAttribute: (e) => this.setAttribute("operator", e),
      values: ["erode", "dilate"],
      defaultValue: "erode"
    })), this[ty];
  }
  /**
   * Returns radiusX.
   *
   * @returns RadiusX.
   */
  get radiusX() {
    return this[ny] || (this[ny] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("radiusX"),
      setAttribute: (e) => this.setAttribute("radiusX", e)
    })), this[ny];
  }
  /**
   * Returns radiusY.
   *
   * @returns RadiusY.
   */
  get radiusY() {
    return this[ry] || (this[ry] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("radiusY"),
      setAttribute: (e) => this.setAttribute("radiusY", e)
    })), this[ry];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class c7e extends nn {
  // Internal properties
  [we] = null;
  [nt] = null;
  [Ga] = null;
  [Wa] = null;
  [Qe] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns dx.
   *
   * @returns Dx.
   */
  get dx() {
    return this[Ga] || (this[Ga] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("dx"),
      setAttribute: (e) => this.setAttribute("dx", e)
    })), this[Ga];
  }
  /**
   * Returns dy.
   *
   * @returns Dy.
   */
  get dy() {
    return this[Wa] || (this[Wa] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("dy"),
      setAttribute: (e) => this.setAttribute("dy", e)
    })), this[Wa];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class h7e extends nn {
  // Internal properties
  [me] = null;
  [ge] = null;
  [aa] = null;
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me] || (this[me] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge] || (this[ge] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Returns z.
   *
   * @returns Z.
   */
  get z() {
    return this[aa] || (this[aa] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("z"),
      setAttribute: (e) => this.setAttribute("z", e)
    })), this[aa];
  }
}
class d7e extends nn {
  // Internal properties
  [we] = null;
  [nt] = null;
  [Ha] = null;
  [Ua] = null;
  [Qe] = null;
  [iy] = null;
  [lc] = null;
  [ac] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns kernelUnitLengthX.
   *
   * @returns KernelUnitLengthX.
   */
  get kernelUnitLengthX() {
    return this[Ha] || (this[Ha] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("kernelUnitLengthX"),
      setAttribute: (e) => this.setAttribute("kernelUnitLengthX", e)
    })), this[Ha];
  }
  /**
   * Returns kernelUnitLengthY.
   *
   * @returns KernelUnitLengthY.
   */
  get kernelUnitLengthY() {
    return this[Ua] || (this[Ua] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("kernelUnitLengthY"),
      setAttribute: (e) => this.setAttribute("kernelUnitLengthY", e)
    })), this[Ua];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns specularConstant.
   *
   * @returns SpecularConstant.
   */
  get specularConstant() {
    return this[iy] || (this[iy] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("specularConstant"),
      setAttribute: (e) => this.setAttribute("specularConstant", e),
      defaultValue: 1
    })), this[iy];
  }
  /**
   * Returns specularExponent.
   *
   * @returns SpecularExponent.
   */
  get specularExponent() {
    return this[lc] || (this[lc] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("specularExponent"),
      setAttribute: (e) => this.setAttribute("specularExponent", e),
      defaultValue: 1
    })), this[lc];
  }
  /**
   * Returns surfaceScale.
   *
   * @returns SurfaceScale.
   */
  get surfaceScale() {
    return this[ac] || (this[ac] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("surfaceScale"),
      setAttribute: (e) => this.setAttribute("surfaceScale", e),
      defaultValue: 1
    })), this[ac];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class f7e extends nn {
  // Internal properties
  [me] = null;
  [ge] = null;
  [aa] = null;
  [sy] = null;
  [ay] = null;
  [oy] = null;
  [lc] = null;
  [uy] = null;
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me] || (this[me] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge] || (this[ge] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Returns z.
   *
   * @returns Z.
   */
  get z() {
    return this[aa] || (this[aa] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("z"),
      setAttribute: (e) => this.setAttribute("z", e)
    })), this[aa];
  }
  /**
   * Returns pointsAtX.
   *
   * @returns PointsAtX.
   */
  get pointsAtX() {
    return this[sy] || (this[sy] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("pointsAtX"),
      setAttribute: (e) => this.setAttribute("pointsAtX", e)
    })), this[sy];
  }
  /**
   * Returns pointsAtY.
   *
   * @returns PointsAtY.
   */
  get pointsAtY() {
    return this[ay] || (this[ay] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("pointsAtY"),
      setAttribute: (e) => this.setAttribute("pointsAtY", e)
    })), this[ay];
  }
  /**
   * Returns pointsAtZ.
   *
   * @returns PointsAtZ.
   */
  get pointsAtZ() {
    return this[oy] || (this[oy] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("pointsAtZ"),
      setAttribute: (e) => this.setAttribute("pointsAtZ", e)
    })), this[oy];
  }
  /**
   * Returns specularExponent.
   *
   * @returns SpecularExponent.
   */
  get specularExponent() {
    return this[lc] || (this[lc] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("specularExponent"),
      setAttribute: (e) => this.setAttribute("specularExponent", e),
      defaultValue: 1
    })), this[lc];
  }
  /**
   * Returns limitingConeAngle.
   *
   * @returns LimitingConeAngle.
   */
  get limitingConeAngle() {
    return this[uy] || (this[uy] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("limitingConeAngle"),
      setAttribute: (e) => this.setAttribute("limitingConeAngle", e)
    })), this[uy];
  }
}
class m7e extends nn {
  // Internal properties
  [we] = null;
  [nt] = null;
  [Qe] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns in1.
   *
   * @returns In1.
   */
  get in1() {
    return this[nt] || (this[nt] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("in"),
      setAttribute: (e) => this.setAttribute("in", e)
    })), this[nt];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class g7e extends nn {
  // Static properties
  static SVG_TURBULENCE_TYPE_UNKNOWN = 0;
  static SVG_TURBULENCE_TYPE_FRACTALNOISE = 1;
  static SVG_TURBULENCE_TYPE_TURBULENCE = 2;
  static SVG_STITCHTYPE_UNKNOWN = 0;
  static SVG_STITCHTYPE_STITCH = 1;
  static SVG_STITCHTYPE_NOSTITCH = 2;
  // Internal properties
  [ly] = null;
  [cy] = null;
  [we] = null;
  [hy] = null;
  [Qe] = null;
  [dy] = null;
  [fy] = null;
  [qn] = null;
  [Fe] = null;
  [me] = null;
  [ge] = null;
  /**
   * Returns baseFrequencyX.
   *
   * @returns Base frequency x.
   */
  get baseFrequencyX() {
    return this[ly] || (this[ly] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("baseFrequencyX"),
      setAttribute: (e) => this.setAttribute("baseFrequencyX", e)
    })), this[ly];
  }
  /**
   * Returns baseFrequencyY.
   *
   * @returns Base frequency y.
   */
  get baseFrequencyY() {
    return this[cy] || (this[cy] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("baseFrequencyY"),
      setAttribute: (e) => this.setAttribute("baseFrequencyY", e)
    })), this[cy];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns numOctaves.
   *
   * @returns Num octaves.
   */
  get numOctaves() {
    return this[hy] || (this[hy] = new $d(T, this[b], {
      getAttribute: () => this.getAttribute("numOctaves"),
      setAttribute: (e) => this.setAttribute("numOctaves", e)
    })), this[hy];
  }
  /**
   * Returns result.
   *
   * @returns Result.
   */
  get result() {
    return this[Qe] || (this[Qe] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("result"),
      setAttribute: (e) => this.setAttribute("result", e)
    })), this[Qe];
  }
  /**
   * Returns seed.
   *
   * @returns Seed.
   */
  get seed() {
    return this[dy] || (this[dy] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("seed"),
      setAttribute: (e) => this.setAttribute("seed", e)
    })), this[dy];
  }
  /**
   * Returns stitchTiles.
   *
   * @returns Stitch tiles.
   */
  get stitchTiles() {
    return this[fy] || (this[fy] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("stitchTiles"),
      setAttribute: (e) => this.setAttribute("stitchTiles", e),
      values: ["stitch", "noStitch"],
      defaultValue: "stitch"
    })), this[fy];
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this[qn] || (this[qn] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("type"),
      setAttribute: (e) => this.setAttribute("type", e),
      values: ["fractalNoise", "turbulence"],
      defaultValue: "turbulence"
    })), this[qn];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class p7e extends nn {
  // Internal properties
  [dn] = null;
  [Sb] = null;
  [wb] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  [we] = null;
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this[dn] || (this[dn] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("href"),
      setAttribute: (e) => this.setAttribute("href", e)
    })), this[dn];
  }
  /**
   * Returns filter units.
   *
   * @returns Filter units.
   */
  get filterUnits() {
    return this[Sb] || (this[Sb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("filterUnits"),
      setAttribute: (e) => this.setAttribute("filterUnits", e),
      values: ["userSpaceOnUse", "objectBoundingBox"],
      defaultValue: "userSpaceOnUse"
    })), this[Sb];
  }
  /**
   * Returns primitive units.
   *
   * @returns Primitive units.
   */
  get primitiveUnits() {
    return this[wb] || (this[wb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("primitiveUnits"),
      setAttribute: (e) => this.setAttribute("primitiveUnits", e),
      values: ["userSpaceOnUse", "objectBoundingBox"],
      defaultValue: "userSpaceOnUse"
    })), this[wb];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class b7e extends ha {
  // Internal properties
  [me] = null;
  [ge] = null;
  [Fe] = null;
  [we] = null;
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class y7e extends ha {
}
class A7e extends ha {
  // Internal properties
  [dn] = null;
  [ns] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  [we] = null;
  /**
   * Returns "crossorigin" attribute.
   *
   * @returns Cross origin.
   */
  get crossOrigin() {
    return this.getAttribute("crossorigin");
  }
  /**
   * Sets "crossorigin" attribute.
   *
   * @param value Cross origin.
   */
  set crossOrigin(e) {
    this.setAttribute("crossorigin", e);
  }
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this[dn] || (this[dn] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("href"),
      setAttribute: (e) => this.setAttribute("href", e)
    })), this[dn];
  }
  /**
   * Returns decoding.
   *
   * @returns Decoding.
   */
  get decoding() {
    const e = this.getAttribute("decoding");
    switch (e) {
      case "sync":
      case "async":
      case "auto":
        return e;
      default:
        return "auto";
    }
  }
  /**
   * Sets decoding.
   *
   * @param value Decoding.
   */
  set decoding(e) {
    this.setAttribute("decoding", e);
  }
  /**
   * Returns preserve aspect ratio.
   *
   * @returns Preserve aspect ratio.
   */
  get preserveAspectRatio() {
    return this[ns] || (this[ns] = new Ep(T, this[b], {
      getAttribute: () => this.getAttribute("preserveAspectRatio"),
      setAttribute: (e) => this.setAttribute("preserveAspectRatio", e)
    })), this[ns];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Decodes the image.
   *
   * @returns Promise.
   */
  decode() {
    return Promise.resolve();
  }
}
class E7e extends Cc {
  // Internal properties
  [ec] = null;
  [tc] = null;
  [nc] = null;
  [rc] = null;
  /**
   * Returns x1 position.
   *
   * @returns X1 position.
   */
  get x1() {
    return this[ec] || (this[ec] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x1"),
      setAttribute: (e) => this.setAttribute("x1", e)
    })), this[ec];
  }
  /**
   * Returns y1 position.
   *
   * @returns Y1 position.
   */
  get y1() {
    return this[tc] || (this[tc] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y1"),
      setAttribute: (e) => this.setAttribute("y1", e)
    })), this[tc];
  }
  /**
   * Returns x2 position.
   *
   * @returns X2 position.
   */
  get x2() {
    return this[nc] || (this[nc] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x2"),
      setAttribute: (e) => this.setAttribute("x2", e)
    })), this[nc];
  }
  /**
   * Returns y2 position.
   *
   * @returns Y2 position.
   */
  get y2() {
    return this[rc] || (this[rc] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y2"),
      setAttribute: (e) => this.setAttribute("y2", e)
    })), this[rc];
  }
}
class X2 extends ha {
  // Public static properties
  static SVG_SPREADMETHOD_UNKNOWN = 0;
  static SVG_SPREADMETHOD_PAD = 1;
  static SVG_SPREADMETHOD_REFLECT = 2;
  static SVG_SPREADMETHOD_REPEAT = 3;
  // Internal properties
  [dn] = null;
  [Fb] = null;
  [Tb] = null;
  [vb] = null;
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this[dn] || (this[dn] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("href"),
      setAttribute: (e) => this.setAttribute("href", e)
    })), this[dn];
  }
  /**
   * Returns gradient units.
   *
   * @returns Gradient units.
   */
  get gradientUnits() {
    return this[Fb] || (this[Fb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("gradientUnits"),
      setAttribute: (e) => this.setAttribute("gradientUnits", e),
      values: ["userSpaceOnUse", "objectBoundingBox"],
      defaultValue: "objectBoundingBox"
    })), this[Fb];
  }
  /**
   * Returns gradient transform.
   *
   * @returns Gradient transform.
   */
  get gradientTransform() {
    return this[Tb] || (this[Tb] = new JA(T, this[b], {
      getAttribute: () => this.getAttribute("gradientTransform"),
      setAttribute: (e) => this.setAttribute("gradientTransform", e)
    })), this[Tb];
  }
  /**
   * Returns spread method.
   *
   * @returns Spread method.
   */
  get spreadMethod() {
    return this[vb] || (this[vb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("spreadMethod"),
      setAttribute: (e) => this.setAttribute("spreadMethod", e),
      values: ["pad", "reflect", "repeat"],
      defaultValue: "pad"
    })), this[vb];
  }
}
class S7e extends X2 {
  // Internal properties
  [ec] = null;
  [tc] = null;
  [nc] = null;
  [rc] = null;
  /**
   * Returns x1 position.
   *
   * @returns X1 position.
   */
  get x1() {
    return this[ec] || (this[ec] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x1"),
      setAttribute: (e) => this.setAttribute("x1", e)
    })), this[ec];
  }
  /**
   * Returns y1 position.
   *
   * @returns Y1 position.
   */
  get y1() {
    return this[tc] || (this[tc] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y1"),
      setAttribute: (e) => this.setAttribute("y1", e)
    })), this[tc];
  }
  /**
   * Returns x2 position.
   *
   * @returns X2 position.
   */
  get x2() {
    return this[nc] || (this[nc] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x2"),
      setAttribute: (e) => this.setAttribute("x2", e)
    })), this[nc];
  }
  /**
   * Returns y2 position.
   *
   * @returns Y2 position.
   */
  get y2() {
    return this[rc] || (this[rc] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y2"),
      setAttribute: (e) => this.setAttribute("y2", e)
    })), this[rc];
  }
}
class BW {
  // Internal properties
  [b];
  [se];
  [Q];
  [Jn] = null;
  [Qn] = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this[Qn] || (this[Qn] = new Z1(T, this[b], {
      readOnly: !0,
      getAttribute: this[se]
    })), this[Qn];
  }
  /**
   * Sets animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    return this[Jn] || (this[Jn] = new Z1(T, this[b], {
      getAttribute: this[se],
      setAttribute: this[Q]
    })), this[Jn];
  }
  /**
   * Sets base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
  }
}
class w7e extends nn {
  // Static properties
  static SVG_MARKER_ORIENT_UNKNOWN = 0;
  static SVG_MARKER_ORIENT_AUTO = 1;
  static SVG_MARKER_ORIENT_ANGLE = 2;
  static SVG_MARKERUNITS_UNKNOWN = 0;
  static SVG_MARKERUNITS_USERSPACEONUSE = 1;
  static SVG_MARKERUNITS_STROKEWIDTH = 2;
  // Public properties
  SVG_MARKER_ORIENT_UNKNOWN = 0;
  SVG_MARKER_ORIENT_AUTO = 1;
  SVG_MARKER_ORIENT_ANGLE = 2;
  // Internal properties
  [hb] = null;
  [db] = null;
  [fb] = null;
  [mb] = null;
  [gb] = null;
  [pb] = null;
  [bb] = null;
  [Yl] = null;
  [ns] = null;
  /**
   * Returns marker units.
   *
   * @returns Marker units.
   */
  get markerUnits() {
    return this[hb] || (this[hb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("markerUnits"),
      setAttribute: (e) => this.setAttribute("markerUnits", e),
      values: ["userSpaceOnUse", "strokeWidth"],
      defaultValue: "strokeWidth"
    })), this[hb];
  }
  /**
   * Returns marker width.
   *
   * @returns Marker width.
   */
  get markerWidth() {
    return this[db] || (this[db] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("markerWidth"),
      setAttribute: (e) => this.setAttribute("markerWidth", e)
    })), this[db];
  }
  /**
   * Returns marker height.
   *
   * @returns Marker height.
   */
  get markerHeight() {
    return this[fb] || (this[fb] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("markerHeight"),
      setAttribute: (e) => this.setAttribute("markerHeight", e)
    })), this[fb];
  }
  /**
   * Returns orient type.
   *
   * @returns Orient type.
   */
  get orientType() {
    return this[mb] || (this[mb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("orient"),
      setAttribute: (e) => this.setAttribute("orient", e),
      values: ["auto", null],
      defaultValue: "auto"
    })), this[mb];
  }
  /**
   * Returns orient angle.
   *
   * @returns Orient angle.
   */
  get orientAngle() {
    return this[gb] || (this[gb] = new BW(T, this[b], {
      getAttribute: () => this.getAttribute("orient"),
      setAttribute: (e) => this.setAttribute("orient", e)
    })), this[gb];
  }
  /**
   * Returns ref x.
   *
   * @returns Ref x.
   */
  get refX() {
    return this[pb] || (this[pb] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("refX"),
      setAttribute: (e) => this.setAttribute("refX", e)
    })), this[pb];
  }
  /**
   * Returns ref y.
   *
   * @returns Ref y.
   */
  get refY() {
    return this[bb] || (this[bb] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("refY"),
      setAttribute: (e) => this.setAttribute("refY", e)
    })), this[bb];
  }
  /**
   * Returns view box.
   *
   * @returns View box.
   */
  get viewBox() {
    return this[Yl] || (this[Yl] = new Q2(T, this[b], {
      getAttribute: () => this.getAttribute("viewBox"),
      setAttribute: (e) => this.setAttribute("viewBox", e)
    })), this[Yl];
  }
  /**
   * Returns preserve aspect ratio.
   *
   * @returns Preserve aspect ratio.
   */
  get preserveAspectRatio() {
    return this[ns] || (this[ns] = new Ep(T, this[b], {
      getAttribute: () => this.getAttribute("preserveAspectRatio"),
      setAttribute: (e) => this.setAttribute("preserveAspectRatio", e)
    })), this[ns];
  }
  /**
   * Sets the value of the orient attribute to auto.
   */
  setOrientToAuto() {
    this.setAttribute("orient", "auto");
  }
  /**
   * Sets the value of the orient attribute to an angle.
   *
   * @param angle Angle.
   */
  setOrientToAngle(e) {
    this.setAttribute("orient", e.valueAsString);
  }
}
class F7e extends nn {
  // Internal properties
  [Ab] = null;
  [Eb] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  [we] = null;
  /**
   * Returns mask units.
   *
   * @returns Mask units.
   */
  get maskUnits() {
    return this[Ab] || (this[Ab] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("maskUnits"),
      setAttribute: (e) => this.setAttribute("maskUnits", e),
      values: ["userSpaceOnUse", "objectBoundingBox"],
      defaultValue: "userSpaceOnUse"
    })), this[Ab];
  }
  /**
   * Returns mask content units.
   *
   * @returns Mask content units.
   */
  get maskContentUnits() {
    return this[Eb] || (this[Eb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("maskContentUnits"),
      setAttribute: (e) => this.setAttribute("maskContentUnits", e),
      values: ["userSpaceOnUse", "objectBoundingBox"],
      defaultValue: "userSpaceOnUse"
    })), this[Eb];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
class T7e extends nn {
}
class v7e extends nn {
  // Internal properties
  [dn] = null;
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this[dn] || (this[dn] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("href"),
      setAttribute: (e) => this.setAttribute("href", e)
    })), this[dn];
  }
}
class x7e extends Cc {
}
class C7e extends nn {
  // Internal properties
  [dn] = null;
  [xb] = null;
  [Cb] = null;
  [kb] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  [we] = null;
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this[dn] || (this[dn] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("href"),
      setAttribute: (e) => this.setAttribute("href", e)
    })), this[dn];
  }
  /**
   * Returns pattern units.
   *
   * @returns Pattern units.
   */
  get patternUnits() {
    return this[xb] || (this[xb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("patternUnits"),
      setAttribute: (e) => this.setAttribute("patternUnits", e),
      values: ["userSpaceOnUse", "objectBoundingBox"],
      defaultValue: "objectBoundingBox"
    })), this[xb];
  }
  /**
   * Returns pattern content units.
   *
   * @returns Pattern content units.
   */
  get patternContentUnits() {
    return this[Cb] || (this[Cb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("patternContentUnits"),
      setAttribute: (e) => this.setAttribute("patternContentUnits", e),
      values: ["userSpaceOnUse", "objectBoundingBox"],
      defaultValue: "userSpaceOnUse"
    })), this[Cb];
  }
  /**
   * Returns pattern transform.
   *
   * @returns Pattern transform.
   */
  get patternTransform() {
    return this[kb] || (this[kb] = new JA(T, this[b], {
      getAttribute: () => this.getAttribute("patternTransform"),
      setAttribute: (e) => this.setAttribute("patternTransform", e)
    })), this[kb];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
}
const k7e = /[\t\f\n\r, ]+/;
class Ch {
  [b];
  [se];
  [Q];
  [Be] = !1;
  [Ae] = {
    items: [],
    attributeValue: ""
  };
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   * @param [options.readOnly] Read only.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[Be] = !!r.readOnly, this[se] = r.getAttribute, this[Q] = r.setAttribute;
    const i = new Ws(this, [Ch]);
    return new Proxy(this, {
      get: (s, a) => {
        if (a === "length" || a === "numberOfItems")
          return s[De]().length;
        if (a in s || typeof a == "symbol")
          return i.bind(a), s[a];
        const o = Number(a);
        if (!isNaN(o))
          return s[De]()[o];
      },
      set(s, a, o) {
        if (i.bind(a), typeof a == "symbol")
          return s[a] = o, !0;
        const u = Number(a);
        return isNaN(u) && (s[a] = o), !0;
      },
      deleteProperty(s, a) {
        if (typeof a == "symbol")
          return delete s[a], !0;
        const o = Number(a);
        return isNaN(o) && delete s[a], !0;
      },
      ownKeys(s) {
        return Object.keys(s[De]());
      },
      has(s, a) {
        if (a in s)
          return !0;
        if (typeof a == "symbol")
          return !1;
        const o = Number(a);
        return !isNaN(o) && o >= 0 && o < s[De]().length;
      },
      defineProperty(s, a, o) {
        return i.preventBinding(a), a in s ? (Object.defineProperty(s, a, o), !0) : !1;
      },
      getOwnPropertyDescriptor(s, a) {
        if (a in s || typeof a == "symbol")
          return;
        const o = Number(a), u = s[De]();
        if (!isNaN(o) && u[o])
          return {
            value: u[o],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[De]().length;
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get numberOfItems() {
    return this[De]().length;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   */
  [Symbol.iterator]() {
    return this[De]().values();
  }
  /**
   * Clears all items from the list.
   */
  clear() {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'clear' on 'SVGPointList': The object is read-only.");
    for (const e of this[Ae].items)
      e[se] = null, e[Q] = null;
    this[Ae].items = [], this[Ae].attributeValue = "", this[Q]("");
  }
  /**
   * Replace Token.
   *
   * @param newItem New item.
   * @returns The item being replaced.
   */
  initialize(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'initialize' on 'SVGPointList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'initialize' on 'SVGPointList': 1 arguments required, but only ${arguments.length} present.`);
    if (!(e instanceof sa))
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGPointList': parameter 1 is not of type 'SVGPoint'.");
    for (const n of this[Ae].items)
      n[se] = null, n[Q] = null;
    return e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((n) => n[ae] || "0 0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].items = [e], this[Ae].attributeValue = e[ae], this[Q](e[ae] || ""), e;
  }
  /**
   * Returns item at index.
   *
   * @param index Index.
   * @returns The item at the index.
   **/
  getItem(e) {
    const n = this[De]();
    return typeof e == "number" || (e = Number(e), e = isNaN(e) ? 0 : e), n[e] ? n[e] : null;
  }
  /**
   * Inserts a new item into the list at the specified position. The first item is number 0. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to insert before is before the removal of the item. If the index is equal to 0, then the new item is inserted at the front of the list. If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being inserted.
   */
  insertItemBefore(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'insertItemBefore' on 'SVGPointList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'insertItemBefore' on 'SVGPointList': 2 arguments required, but only ${arguments.length} present.`);
    if (!(e instanceof sa))
      throw new this[b].TypeError("Failed to execute 'insertItemBefore' on 'SVGPointList': parameter 1 is not of type 'SVGPoint'.");
    const r = this[De](), i = r.indexOf(e);
    return i !== -1 && r.splice(i, 1), n < 0 ? n = 0 : n > r.length && (n = r.length), r.splice(n, 0, e), e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((s) => s[ae] || "0 0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = r.map((s) => s[ae] || "0 0").join(" "), this[Q](this[Ae].attributeValue), e;
  }
  /**
   * Replaces an existing item in the list with a new item. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to replace is before the removal of the item.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being replaced.
   */
  replaceItem(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'replaceItem' on 'SVGPointList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'replaceItem' on 'SVGPointList': 2 arguments required, but only ${arguments.length} present.`);
    if (!(e instanceof sa))
      throw new this[b].TypeError("Failed to execute 'replaceItem' on 'SVGPointList': parameter 1 is not of type 'SVGPoint'.");
    const r = this[De](), i = r.indexOf(e);
    if (i === n)
      return e;
    i !== -1 && r.splice(i, 1), n < 0 ? n = 0 : n >= r.length && (n = r.length - 1), r[n] && (r[n][se] = null, r[n][Q] = null);
    const s = r[n];
    return r[n] = e, e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((a) => a[ae] || "0 0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = r.map((a) => a[ae] || "0 0").join(" "), this[Q](this[Ae].attributeValue), s;
  }
  /**
   * Removes an existing item from the list.
   *
   * @param index Index.
   * @returns The removed item.
   */
  removeItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'removeItem' on 'SVGPointList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'removeItem' on 'SVGPointList': 1 argument required, but only ${arguments.length} present.`);
    const n = this[De]();
    if (e = Number(e), isNaN(e) && (e = 0), e >= n.length)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGPointList':  The index provided (${e}) is greater than the maximum bound.`, ne.indexSizeError);
    if (e < 0)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGPointList':  The index provided (${e}) is negative.`, ne.indexSizeError);
    const r = n[e];
    return r && (r[se] = null, r[Q] = null), n.splice(e, 1), this[Q](n.map((i) => i[ae] || "0 0").join(" ")), r;
  }
  /**
   * Appends an item to the end of the list.
   *
   * @param newItem The item to add to the list.
   * @returns The item being appended.
   */
  appendItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGPointList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'appendItem' on 'SVGPointList': 1 argument required, but only ${arguments.length} present.`);
    if (!(e instanceof sa))
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGPointList': parameter 1 is not of type 'SVGPoint'.");
    const n = this[De](), r = n.indexOf(e);
    return r !== -1 && n.splice(r, 1), n.push(e), e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((i) => i[ae] || "0 0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = n.map((i) => i[ae] || "0 0").join(" "), this[Q](this[Ae].attributeValue), e;
  }
  /**
   * Returns item list from attribute value.
   *
   * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
   */
  [De]() {
    const e = this[se]() ?? "", n = this[Ae];
    if (n.attributeValue === e)
      return n.items;
    if (n.items.length)
      for (const s of n.items)
        s[se] = null, s[Q] = null;
    const r = [], i = e.trim();
    if (i) {
      const s = i.split(k7e);
      for (let a = 0, o = s.length; a < o; a += 2) {
        const u = parseFloat(s[a]), l = s[a + 1] !== void 0 ? " " + parseFloat(s[a + 1]) : "", h = new sa(T, this[b], {
          readOnly: this[Be],
          getAttribute: () => h[ae],
          setAttribute: () => {
            this[Ae].attributeValue = this[De]().map((f) => f[ae] || "0 0").join(" "), this[Q](this[Ae].attributeValue);
          }
        });
        h[ae] = `${u}${l}`, r.push(h);
      }
    }
    return n.attributeValue = e, n.items = r, r;
  }
}
class _7e extends Cc {
  // Internal properties
  [ql] = null;
  [Jl] = null;
  /**
   * Returns animated points.
   *
   * @returns Animated points.
   */
  get animatedPoints() {
    return this[ql] || (this[ql] = new Ch(T, this[b], {
      readOnly: !0,
      getAttribute: () => this.getAttribute("points"),
      setAttribute: () => {
      }
    })), this[ql];
  }
  /**
   * Returns points.
   *
   * @returns Points.
   */
  get points() {
    return this[Jl] || (this[Jl] = new Ch(T, this[b], {
      getAttribute: () => this.getAttribute("points"),
      setAttribute: (e) => this.setAttribute("points", e)
    })), this[Jl];
  }
}
class N7e extends Cc {
  // Internal properties
  [ql] = null;
  [Jl] = null;
  /**
   * Returns animated points.
   *
   * @returns Animated points.
   */
  get animatedPoints() {
    return this[ql] || (this[ql] = new Ch(T, this[b], {
      readOnly: !0,
      getAttribute: () => this.getAttribute("points"),
      setAttribute: () => {
      }
    })), this[ql];
  }
  /**
   * Returns points.
   *
   * @returns Points.
   */
  get points() {
    return this[Jl] || (this[Jl] = new Ch(T, this[b], {
      getAttribute: () => this.getAttribute("points"),
      setAttribute: (e) => this.setAttribute("points", e)
    })), this[Jl];
  }
}
class D7e extends X2 {
  // Internal properties
  [Oa] = null;
  [Ba] = null;
  [Zl] = null;
  [_b] = null;
  [Nb] = null;
  /**
   * Returns cx.
   *
   * @returns Cx.
   */
  get cx() {
    return this[Oa] || (this[Oa] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("cx"),
      setAttribute: (e) => this.setAttribute("cx", e)
    })), this[Oa];
  }
  /**
   * Returns cy.
   *
   * @returns Cy.
   */
  get cy() {
    return this[Ba] || (this[Ba] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("cy"),
      setAttribute: (e) => this.setAttribute("cy", e)
    })), this[Ba];
  }
  /**
   * Returns r.
   *
   * @returns R.
   */
  get r() {
    return this[Zl] || (this[Zl] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("r"),
      setAttribute: (e) => this.setAttribute("r", e)
    })), this[Zl];
  }
  /**
   * Returns fx.
   *
   * @returns Fx.
   */
  get fx() {
    return this[_b] || (this[_b] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("fx"),
      setAttribute: (e) => this.setAttribute("fx", e)
    })), this[_b];
  }
  /**
   * Returns fy.
   *
   * @returns Fy.
   */
  get fy() {
    return this[Nb] || (this[Nb] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("fy"),
      setAttribute: (e) => this.setAttribute("fy", e)
    })), this[Nb];
  }
}
class I7e extends Cc {
  // Internal properties
  [me] = null;
  [ge] = null;
  [Fe] = null;
  [we] = null;
  [Ql] = null;
  [Xl] = null;
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns rx.
   *
   * @returns Rx.
   */
  get rx() {
    return this[Ql] || (this[Ql] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("rx"),
      setAttribute: (e) => this.setAttribute("rx", e)
    })), this[Ql];
  }
  /**
   * Returns ry.
   *
   * @returns Ry.
   */
  get ry() {
    return this[Xl] || (this[Xl] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("ry"),
      setAttribute: (e) => this.setAttribute("ry", e)
    })), this[Xl];
  }
}
class R7e extends ha {
  // Internal properties
  [dn] = null;
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this[dn] || (this[dn] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("href"),
      setAttribute: (e) => this.setAttribute("href", e)
    })), this[dn];
  }
  /**
   * Returns type.
   *
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "";
  }
  /**
   * Sets type.
   *
   * @param value New value.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
}
class P7e extends Sp {
}
class L7e extends nn {
  // Internal properties
  [ic] = null;
  /**
   * Returns offset.
   *
   * @returns Offset.
   */
  get offset() {
    return this[ic] || (this[ic] = new At(T, this[b], {
      getAttribute: () => this.getAttribute("offset"),
      setAttribute: (e) => this.setAttribute("offset", e)
    })), this[ic];
  }
}
class M7e extends nn {
  // Internal properties
  [Yr] = null;
  [ys] = this;
  [Zd] = !1;
  /**
   * Returns media.
   *
   * @returns Media.
   */
  get media() {
    return this.getAttribute("media") || "all";
  }
  /**
   * Sets media.
   *
   * @param media Media.
   */
  set media(e) {
    this.setAttribute("media", e);
  }
  /**
   * Returns type.
   *
   * @deprecated
   * @returns Type.
   */
  get type() {
    return this.getAttribute("type") || "text/css";
  }
  /**
   * Sets type.
   *
   * @deprecated
   * @param type Type.
   */
  set type(e) {
    this.setAttribute("type", e);
  }
  /**
   * Returns title.
   *
   * @returns Title.
   */
  get title() {
    return this.getAttribute("title") || "";
  }
  /**
   * Sets title.
   *
   * @param title Title.
   */
  set title(e) {
    this.setAttribute("title", e);
  }
  /**
   * Returns disabled.
   *
   * @returns Disabled.
   */
  get disabled() {
    return this[Zd];
  }
  /**
   * Sets disabled.
   *
   * @param disabled Disabled.
   */
  set disabled(e) {
    this[Zd] = !!e;
  }
  /**
   * Returns style.
   *
   * @returns Style.
   */
  get sheet() {
    return this[st] ? (this[Yr] || (this[Yr] = new this[he][b].CSSStyleSheet(), this[Yr].replaceSync(this.textContent)), this[Yr]) : null;
  }
  /**
   * @override
   */
  [Bs]() {
    super[Bs](), this[Yr] = null;
  }
  /**
   * @override
   */
  [tn]() {
    super[tn](), this[Yr] = null;
  }
  /**
   * Updates the CSSStyleSheet with the text content.
   */
  [cg]() {
    this[Yr] && this[Yr].replaceSync(this.textContent);
  }
}
class O7e extends ha {
}
class B7e extends ha {
}
class $W extends ha {
  // Public static properties
  static LENGTHADJUST_UNKNOWN = 0;
  static LENGTHADJUST_SPACING = 1;
  static LENGTHADJUST_SPACINGANDGLYPHS = 2;
  // Internal properties
  [Db] = null;
  [Ib] = null;
  /**
   * Returns textLength.
   *
   * @returns Text length.
   */
  get textLength() {
    return this[Db] || (this[Db] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("textLength"),
      setAttribute: (e) => this.setAttribute("textLength", e)
    })), this[Db];
  }
  /**
   * Returns lengthAdjust.
   *
   * @returns Length adjust.
   */
  get lengthAdjust() {
    return this[Ib] || (this[Ib] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("lengthAdjust"),
      setAttribute: (e) => this.setAttribute("lengthAdjust", e),
      values: ["spacing", "spacingAndGlyphs"],
      defaultValue: "spacing"
    })), this[Ib];
  }
  /**
   * Returns the number of characters available for rendering.
   *
   * @returns Number of characters.
   */
  getNumberOfChars() {
    return 0;
  }
  /**
   * Returns a float representing the computed length for the text within the element.
   *
   * @returns Computed text length.
   */
  getComputedTextLength() {
    return 0;
  }
  /**
   * Returns a float representing the computed length of the formatted text advance distance for a substring of text within the element. Note that this method only accounts for the widths of the glyphs in the substring and any extra spacing inserted by the CSS 'letter-spacing' and 'word-spacing' properties. Visual spacing adjustments made by the 'x' attribute is ignored.
   *
   * @param _charnum The index of the first character in the substring.
   * @param _nchars The number of characters in the substring.
   */
  getSubStringLength(e, n) {
    return 0;
  }
  /**
   * Returns a SVGPoint representing the position of a typographic character after text layout has been performed.
   *
   * @param _charnum The index of the character.
   */
  getStartPositionOfChar(e) {
    return new sa(T, this[b]);
  }
  /**
   * Returns a SVGPoint representing the trailing position of a typographic character after text layout has been performed.
   *
   * @param _charnum The index of the character.
   */
  getEndPositionOfChar(e) {
    return new sa(T, this[b]);
  }
  /**
   * Returns a SVGRect representing the computed tight bounding box of the glyph cell that corresponds to a given typographic character.
   *
   * @param _charnum The index of the character.
   */
  getExtentOfChar(e) {
    return new Vg(T, this[b]);
  }
  /**
   * Returns a float representing the rotation of typographic character.
   *
   * @param _charnum The index of the character.
   */
  getRotationOfChar(e) {
    return 0;
  }
  /**
   * Returns a long representing the character which caused a text glyph to be rendered at a given position in the coordinate system. Because the relationship between characters and glyphs is not one-to-one, only the first character of the relevant typographic character is returned
   *
   * @param _point The point to be tested.
   */
  getCharNumAtPosition(e) {
    return 0;
  }
}
const $7e = /[\t\f\n\r, ]+/;
class jg {
  [b];
  [se];
  [Q];
  [Be] = !1;
  [Ae] = {
    items: [],
    attributeValue: ""
  };
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   * @param [options.readOnly] Read only.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[Be] = !!r.readOnly, this[se] = r.getAttribute, this[Q] = r.setAttribute;
    const i = new Ws(this, [jg]);
    return new Proxy(this, {
      get: (s, a) => {
        if (a === "length" || a === "numberOfItems")
          return s[De]().length;
        if (a in s || typeof a == "symbol")
          return i.bind(a), s[a];
        const o = Number(a);
        if (!isNaN(o))
          return s[De]()[o];
      },
      set(s, a, o) {
        if (i.bind(a), typeof a == "symbol")
          return s[a] = o, !0;
        const u = Number(a);
        return isNaN(u) && (s[a] = o), !0;
      },
      deleteProperty(s, a) {
        if (typeof a == "symbol")
          return delete s[a], !0;
        const o = Number(a);
        return isNaN(o) && delete s[a], !0;
      },
      ownKeys(s) {
        return Object.keys(s[De]());
      },
      has(s, a) {
        if (a in s)
          return !0;
        if (typeof a == "symbol")
          return !1;
        const o = Number(a);
        return !isNaN(o) && o >= 0 && o < s[De]().length;
      },
      defineProperty(s, a, o) {
        return i.preventBinding(a), a in s ? (Object.defineProperty(s, a, o), !0) : !1;
      },
      getOwnPropertyDescriptor(s, a) {
        if (a in s || typeof a == "symbol")
          return;
        const o = Number(a), u = s[De]();
        if (!isNaN(o) && u[o])
          return {
            value: u[o],
            writable: !1,
            enumerable: !0,
            configurable: !0
          };
      }
    });
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get length() {
    return this[De]().length;
  }
  /**
   * Returns length.
   *
   * @returns Length.
   */
  get numberOfItems() {
    return this[De]().length;
  }
  /**
   * Returns an iterator, allowing you to go through all values of the key/value pairs contained in this object.
   */
  [Symbol.iterator]() {
    return this[De]().values();
  }
  /**
   * Clears all items from the list.
   */
  clear() {
    this[Q]("");
  }
  /**
   * Replace Token.
   *
   * @param newItem New item.
   * @returns The item being replaced.
   */
  initialize(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'initialize' on 'SVGLengthList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'initialize' on 'SVGLengthList': 1 arguments required, but only ${arguments.length} present.`);
    for (const n of this[Ae].items)
      n[se] = null, n[Q] = null;
    return e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((n) => n[ae] ?? "0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].items = [e], this[Ae].attributeValue = e[ae], this[Q](e[ae] || ""), e;
  }
  /**
   * Returns item at index.
   *
   * @param index Index.
   * @returns The item at the index.
   **/
  getItem(e) {
    const n = this[De]();
    return typeof e == "number" || (e = Number(e), e = isNaN(e) ? 0 : e), n[e] ? n[e] : null;
  }
  /**
   * Inserts a new item into the list at the specified position. The first item is number 0. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to insert before is before the removal of the item. If the index is equal to 0, then the new item is inserted at the front of the list. If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being inserted.
   */
  insertItemBefore(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'insertItemBefore' on 'SVGLengthList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'insertItemBefore' on 'SVGLengthList': 2 arguments required, but only ${arguments.length} present.`);
    const r = this[De](), i = r.indexOf(e);
    return i !== -1 && r.splice(i, 1), n < 0 ? n = 0 : n > r.length && (n = r.length), r.splice(n, 0, e), e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((s) => s[ae] ?? "0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = r.map((s) => s[ae] ?? "0").join(" "), this[Q](this[Ae].attributeValue), e;
  }
  /**
   * Replaces an existing item in the list with a new item. If newItem is already in a list, it is removed from its previous list before it is inserted into this list. The inserted item is the item itself and not a copy. If the item is already in this list, note that the index of the item to replace is before the removal of the item.
   *
   * @param newItem The item to insert into the list.
   * @param index Index.
   * @returns The item being replaced.
   */
  replaceItem(e, n) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'replaceItem' on 'SVGLengthList': The object is read-only.");
    if (arguments.length < 2)
      throw new this[b].TypeError(`Failed to execute 'replaceItem' on 'SVGLengthList': 2 arguments required, but only ${arguments.length} present.`);
    const r = this[De](), i = r.indexOf(e);
    if (i === n)
      return e;
    i !== -1 && r.splice(i, 1), n < 0 ? n = 0 : n >= r.length && (n = r.length - 1), r[n] && (r[n][se] = null, r[n][Q] = null);
    const s = r[n];
    return r[n] = e, e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((a) => a[ae] ?? "0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = r.map((a) => a[ae] ?? "0").join(" "), this[Q](this[Ae].attributeValue), s;
  }
  /**
   * Removes an existing item from the list.
   *
   * @param index Index.
   * @returns The removed item.
   */
  removeItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'removeItem' on 'SVGLengthList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'removeItem' on 'SVGLengthList': 1 argument required, but only ${arguments.length} present.`);
    const n = this[De]();
    if (e = Number(e), isNaN(e) && (e = 0), e >= n.length)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGLengthList':  The index provided (${e}) is greater than the maximum bound.`, ne.indexSizeError);
    if (e < 0)
      throw new this[b].DOMException(`Failed to execute 'removeItem' on 'SVGLengthList':  The index provided (${e}) is negative.`, ne.indexSizeError);
    const r = n[e];
    return r && (r[se] = null, r[Q] = null), n.splice(e, 1), this[Q](n.map((i) => i[ae] ?? "0").join(" ")), r;
  }
  /**
   * Appends an item to the end of the list.
   *
   * @param newItem The item to add to the list.
   * @returns The item being appended.
   */
  appendItem(e) {
    if (this[Be])
      throw new this[b].TypeError("Failed to execute 'appendItem' on 'SVGLengthList': The object is read-only.");
    if (arguments.length < 1)
      throw new this[b].TypeError(`Failed to execute 'appendItem' on 'SVGLengthList': 1 argument required, but only ${arguments.length} present.`);
    const n = this[De](), r = n.indexOf(e);
    return r !== -1 && n.splice(r, 1), n.push(e), e[se] = () => e[ae], e[Q] = () => {
      this[Ae].attributeValue = this[De]().map((i) => i[ae] ?? "0").join(" "), this[Q](this[Ae].attributeValue);
    }, this[Ae].attributeValue = n.map((i) => i[ae] ?? "0").join(" "), this[Q](this[Ae].attributeValue), e;
  }
  /**
   * Returns item list from attribute value.
   *
   * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
   */
  [De]() {
    const e = this[se]() ?? "", n = this[Ae];
    if (n.attributeValue === e)
      return n.items;
    if (n.items.length)
      for (const s of n.items)
        s[se] = null, s[Q] = null;
    const r = [], i = e.trim();
    if (i) {
      const s = i.split($7e);
      for (let a = 0, o = s.length; a < o; a++) {
        const u = new Kg(T, this[b], {
          readOnly: this[Be],
          getAttribute: () => u[ae],
          setAttribute: (l) => {
            u[ae] = l;
            const h = r.map((f) => f[ae] ?? "0").join(" ");
            n.attributeValue = h, this[Q](h);
          }
        });
        u[ae] = s[a], r.push(u);
      }
    }
    return n.attributeValue = e, n.items = r, r;
  }
}
class zm {
  // Internal properties
  [b];
  [se];
  [Q];
  [Jn] = null;
  [Qn] = null;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   * @param window Window.
   * @param options Options.
   * @param options.getAttribute Get attribute.
   * @param options.setAttribute Set attribute.
   */
  constructor(e, n, r) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
    this[b] = n, this[se] = r.getAttribute, this[Q] = r.setAttribute;
  }
  /**
   * Returns animated value.
   *
   * @returns Animated value.
   */
  get animVal() {
    return this[Qn] || (this[Qn] = new jg(T, this[b], {
      readOnly: !0,
      getAttribute: this[se],
      setAttribute: this[Q]
    })), this[Qn];
  }
  /**
   * Returns animated value.
   *
   * @param value Animated value.
   */
  set animVal(e) {
  }
  /**
   * Returns base value.
   *
   * @returns Base value.
   */
  get baseVal() {
    return this[Jn] || (this[Jn] = new jg(T, this[b], {
      getAttribute: this[se],
      setAttribute: this[Q]
    })), this[Jn];
  }
  /**
   * Returns base value.
   *
   * @param value Base value.
   */
  set baseVal(e) {
  }
}
class Z2 extends $W {
  // Internal properties
  [me] = null;
  [ge] = null;
  [Ga] = null;
  [Wa] = null;
  [my] = null;
  /**
   * Returns x.
   *
   * @returns X.
   */
  get x() {
    return this[me] || (this[me] = new zm(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y.
   *
   * @returns Y.
   */
  get y() {
    return this[ge] || (this[ge] = new zm(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Returns dx.
   *
   * @returns DX.
   */
  get dx() {
    return this[Ga] || (this[Ga] = new zm(T, this[b], {
      getAttribute: () => this.getAttribute("dx"),
      setAttribute: (e) => this.setAttribute("dx", e)
    })), this[Ga];
  }
  /**
   * Returns dy.
   *
   * @returns DY.
   */
  get dy() {
    return this[Wa] || (this[Wa] = new zm(T, this[b], {
      getAttribute: () => this.getAttribute("dy"),
      setAttribute: (e) => this.setAttribute("dy", e)
    })), this[Wa];
  }
  /**
   * Returns rotate.
   *
   * @returns Rotate.
   */
  get rotate() {
    return this[my] || (this[my] = new Bf(T, this[b], {
      getAttribute: () => this.getAttribute("rotate"),
      setAttribute: (e) => this.setAttribute("rotate", e)
    })), this[my];
  }
}
class H7e extends Z2 {
}
class U7e extends $W {
  // Public static properties
  static TEXTPATH_METHODTYPE_UNKNOWN = 0;
  static TEXTPATH_METHODTYPE_ALIGN = 1;
  static TEXTPATH_METHODTYPE_STRETCH = 2;
  static TEXTPATH_SPACINGTYPE_UNKNOWN = 0;
  static TEXTPATH_SPACINGTYPE_AUTO = 1;
  static TEXTPATH_SPACINGTYPE_EXACT = 2;
  // Internal properties
  [dn] = null;
  [Pb] = null;
  [dh] = null;
  [Lb] = null;
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this[dn] || (this[dn] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("href"),
      setAttribute: (e) => this.setAttribute("href", e)
    })), this[dn];
  }
  /**
   * Returns start offset.
   *
   * @returns Start offset.
   */
  get startOffset() {
    return this[Pb] || (this[Pb] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("startOffset"),
      setAttribute: (e) => this.setAttribute("startOffset", e)
    })), this[Pb];
  }
  /**
   * Returns method.
   *
   * @returns ClipPathUnits.
   */
  get method() {
    return this[dh] || (this[dh] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("method"),
      setAttribute: (e) => this.setAttribute("method", e),
      values: ["align", "stretch"],
      defaultValue: "align"
    })), this[dh];
  }
  /**
   * Returns spacing.
   *
   * @returns Spacing.
   */
  get spacing() {
    return this[Lb] || (this[Lb] = new cr(T, this[b], {
      getAttribute: () => this.getAttribute("spacing"),
      setAttribute: (e) => this.setAttribute("spacing", e),
      values: ["auto", "exact"],
      defaultValue: "exact"
    })), this[Lb];
  }
}
class G7e extends nn {
}
class W7e extends Z2 {
}
class V7e extends ha {
  // Internal properties
  [dn] = null;
  [me] = null;
  [ge] = null;
  [Fe] = null;
  [we] = null;
  /**
   * Returns href.
   *
   * @returns Href.
   */
  get href() {
    return this[dn] || (this[dn] = new Pt(T, this[b], {
      getAttribute: () => this.getAttribute("href"),
      setAttribute: (e) => this.setAttribute("href", e)
    })), this[dn];
  }
  /**
   * Returns x position.
   *
   * @returns X position.
   */
  get x() {
    return this[me] || (this[me] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("x"),
      setAttribute: (e) => this.setAttribute("x", e)
    })), this[me];
  }
  /**
   * Returns y position.
   *
   * @returns Y position.
   */
  get y() {
    return this[ge] || (this[ge] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("y"),
      setAttribute: (e) => this.setAttribute("y", e)
    })), this[ge];
  }
  /**
   * Returns width.
   *
   * @returns Width.
   */
  get width() {
    return this[Fe] || (this[Fe] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("width"),
      setAttribute: (e) => this.setAttribute("width", e)
    })), this[Fe];
  }
  /**
   * Returns height.
   *
   * @returns Height.
   */
  get height() {
    return this[we] || (this[we] = new de(T, this[b], {
      getAttribute: () => this.getAttribute("height"),
      setAttribute: (e) => this.setAttribute("height", e)
    })), this[we];
  }
}
class K7e extends nn {
}
class z7e {
  static SVG_UNIT_TYPE_UNKNOWN = 0;
  static SVG_UNIT_TYPE_USERSPACEONUSE = 1;
  static SVG_UNIT_TYPE_OBJECTBOUNDINGBOX = 2;
  SVG_UNIT_TYPE_UNKNOWN = 0;
  SVG_UNIT_TYPE_USERSPACEONUSE = 1;
  SVG_UNIT_TYPE_OBJECTBOUNDINGBOX = 2;
  /**
   * Constructor.
   *
   * @param illegalConstructorSymbol Illegal constructor symbol.
   */
  constructor(e) {
    if (e !== T)
      throw new TypeError("Illegal constructor");
  }
}
class j7e {
  window;
  /**
   * Constructor.
   *
   * @param window Window.
   */
  constructor(e) {
    this.window = e;
  }
  /**
   * Enqueues a custom element reaction.
   *
   * @see https://html.spec.whatwg.org/multipage/custom-elements.html#enqueue-a-custom-element-callback-reaction
   * @see https://html.spec.whatwg.org/multipage/custom-elements.html#enqueue-an-element-on-the-appropriate-element-queue
   * @param element Element.
   * @param callbackName Callback name.
   * @param [args] Arguments.
   */
  enqueueReaction(e, n, r) {
    const i = this.window.customElements[xl]?.get(e.localName);
    if (i && e[he] === this.window.document)
      switch (n) {
        case "connectedCallback":
          if (i.lifecycleCallbacks.connectedCallback) {
            const s = i.lifecycleCallbacks.connectedCallback?.call(e);
            if (s instanceof Promise) {
              const a = new pt(this.window).getAsyncTaskManager();
              if (a) {
                const o = a.startTask();
                s.then(() => a.endTask(o)).catch(() => a.endTask(o));
              }
            }
          }
          break;
        case "disconnectedCallback":
          i.lifecycleCallbacks.disconnectedCallback && i.lifecycleCallbacks.disconnectedCallback.call(e);
          break;
        case "attributeChangedCallback":
          i.lifecycleCallbacks.attributeChangedCallback && r?.length && i.observedAttributes.has(r[0]) && i.lifecycleCallbacks.attributeChangedCallback.apply(e, r);
          break;
      }
  }
}
class Y7e extends be {
  state;
  hasUAVisualTransition;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e), this.state = n?.state ?? null, this.hasUAVisualTransition = n?.hasUAVisualTransition ?? !1;
  }
}
class q7e extends be {
  code;
  reason;
  wasClean;
  /**
   * Constructor.
   *
   * @param type Event type.
   * @param [eventInit] Event init.
   */
  constructor(e, n = null) {
    super(e, n), this.code = n?.code ?? 0, this.reason = n?.reason ?? "", this.wasClean = n?.wasClean ?? !1;
  }
}
const Al = {
  setTimeout: globalThis.setTimeout.bind(globalThis),
  clearTimeout: globalThis.clearTimeout.bind(globalThis),
  setInterval: globalThis.setInterval.bind(globalThis),
  clearInterval: globalThis.clearInterval.bind(globalThis),
  queueMicrotask: globalThis.queueMicrotask.bind(globalThis),
  setImmediate: globalThis.setImmediate.bind(globalThis),
  clearImmediate: globalThis.clearImmediate.bind(globalThis)
}, sT = setTimeout.toString().includes("new Timeout"), J7e = (() => {
  try {
    return new Function("return true;")(), !0;
  } catch {
    return !1;
  }
})(), Q7e = (() => {
  try {
    return globalThis.Function.$UNFROZEN$ = !0, delete globalThis.Function.$UNFROZEN$, !0;
  } catch {
    return !1;
  }
})();
class X7e {
  /**
   * Constructor.
   */
  constructor() {
    throw new TypeError("Illegal constructor");
  }
}
class NM {
  callback;
  /**
   * Constructor.
   * @param callback Callback.
   */
  constructor(e) {
    this.callback = e;
  }
}
class tA extends Xr {
  // Nodes
  Node = ot;
  Attr = T$e;
  ShadowRoot = SUe;
  ProcessingInstruction = EUe;
  Element = Sc;
  CharacterData = KA;
  DocumentType = W2;
  // HTML Element classes
  HTMLAnchorElement = X$e;
  HTMLButtonElement = oHe;
  HTMLOptGroupElement = YHe;
  HTMLOptionElement = zy;
  HTMLElement = Ye;
  HTMLUnknownElement = yUe;
  HTMLTemplateElement = fUe;
  HTMLInputElement = zo;
  HTMLSelectElement = Y2;
  HTMLTextAreaElement = ax;
  HTMLImageElement = vW;
  HTMLStyleElement = uUe;
  HTMLLabelElement = OHe;
  HTMLSlotElement = CW;
  HTMLMetaElement = VHe;
  HTMLMediaElement = K2;
  HTMLAudioElement = pW;
  HTMLVideoElement = AUe;
  HTMLBaseElement = eHe;
  HTMLDialogElement = gHe;
  HTMLScriptElement = sUe;
  HTMLLinkElement = UHe;
  HTMLIFrameElement = MHe;
  HTMLFormElement = j2;
  HTMLUListElement = bUe;
  HTMLTrackElement = pUe;
  HTMLTableRowElement = dUe;
  HTMLTitleElement = gUe;
  HTMLTimeElement = mUe;
  HTMLTableSectionElement = X1;
  HTMLTableCellElement = lUe;
  HTMLTableElement = hUe;
  HTMLSpanElement = oUe;
  HTMLSourceElement = aUe;
  HTMLQuoteElement = eUe;
  HTMLProgressElement = ZHe;
  HTMLPreElement = XHe;
  HTMLPictureElement = QHe;
  HTMLParamElement = JHe;
  HTMLParagraphElement = qHe;
  HTMLOutputElement = yW;
  HTMLOListElement = jHe;
  HTMLObjectElement = bW;
  HTMLMeterElement = KHe;
  HTMLMenuElement = WHe;
  HTMLMapElement = GHe;
  HTMLLIElement = $He;
  HTMLLegendElement = BHe;
  HTMLModElement = zHe;
  HTMLHtmlElement = PHe;
  HTMLHRElement = RHe;
  HTMLHeadElement = DHe;
  HTMLHeadingElement = IHe;
  HTMLFieldSetElement = AW;
  HTMLEmbedElement = bHe;
  HTMLDListElement = hHe;
  HTMLDivElement = pHe;
  HTMLDetailsElement = mHe;
  HTMLDataListElement = fHe;
  HTMLDataElement = dHe;
  HTMLTableColElement = cUe;
  HTMLTableCaptionElement = kW;
  HTMLCanvasElement = cHe;
  HTMLBRElement = nHe;
  HTMLBodyElement = tHe;
  HTMLAreaElement = Z$e;
  // SVG Element classes
  SVGSVGElement = LGe;
  SVGAnimateElement = MGe;
  SVGAnimateMotionElement = OGe;
  SVGAnimateTransformElement = BGe;
  SVGCircleElement = $Ge;
  SVGClipPathElement = HGe;
  SVGDefsElement = UGe;
  SVGDescElement = GGe;
  SVGEllipseElement = WGe;
  SVGFEBlendElement = VGe;
  SVGFEColorMatrixElement = zGe;
  SVGFEComponentTransferElement = jGe;
  SVGFECompositeElement = YGe;
  SVGFEConvolveMatrixElement = qGe;
  SVGFEDiffuseLightingElement = JGe;
  SVGFEDisplacementMapElement = QGe;
  SVGFEDistantLightElement = XGe;
  SVGFEDropShadowElement = ZGe;
  SVGFEFloodElement = e7e;
  SVGFEFuncAElement = t7e;
  SVGFEFuncBElement = n7e;
  SVGFEFuncGElement = r7e;
  SVGFEFuncRElement = i7e;
  SVGFEGaussianBlurElement = s7e;
  SVGFEImageElement = a7e;
  SVGFEMergeElement = o7e;
  SVGFEMergeNodeElement = u7e;
  SVGFEMorphologyElement = l7e;
  SVGFEOffsetElement = c7e;
  SVGFEPointLightElement = h7e;
  SVGFESpecularLightingElement = d7e;
  SVGFESpotLightElement = f7e;
  SVGFETileElement = m7e;
  SVGFETurbulenceElement = g7e;
  SVGFilterElement = p7e;
  SVGForeignObjectElement = b7e;
  SVGGElement = y7e;
  SVGImageElement = A7e;
  SVGLineElement = E7e;
  SVGLinearGradientElement = S7e;
  SVGMarkerElement = w7e;
  SVGMaskElement = F7e;
  SVGMetadataElement = T7e;
  SVGMPathElement = v7e;
  SVGPathElement = x7e;
  SVGPatternElement = C7e;
  SVGPolygonElement = _7e;
  SVGPolylineElement = N7e;
  SVGRadialGradientElement = D7e;
  SVGRectElement = I7e;
  SVGScriptElement = R7e;
  SVGSetElement = P7e;
  SVGStopElement = L7e;
  SVGStyleElement = M7e;
  SVGSwitchElement = O7e;
  SVGSymbolElement = B7e;
  SVGTextElement = H7e;
  SVGTextPathElement = U7e;
  SVGTitleElement = G7e;
  SVGTSpanElement = W7e;
  SVGUseElement = V7e;
  SVGViewElement = K7e;
  // Abstract SVG Element classes
  SVGElement = nn;
  SVGAnimationElement = Sp;
  SVGComponentTransferFunctionElement = wp;
  SVGGeometryElement = Cc;
  SVGGradientElement = X2;
  SVGTextPositioningElement = Z2;
  SVGGraphicsElement = ha;
  // Event classes
  Event = be;
  UIEvent = vc;
  CustomEvent = n$e;
  CloseEvent = q7e;
  AnimationEvent = e$e;
  KeyboardEvent = i$e;
  MessageEvent = VL;
  MouseEvent = _o;
  PointerEvent = Z7;
  FocusEvent = Vm;
  WheelEvent = o$e;
  InputEvent = r$e;
  ErrorEvent = V1;
  StorageEvent = s$e;
  SubmitEvent = eW;
  ProgressEvent = kl;
  MediaQueryListEvent = U7;
  HashChangeEvent = X7;
  ClipboardEvent = t$e;
  TouchEvent = a$e;
  PopStateEvent = Y7e;
  Touch = Z5e;
  // Non-implemented event classes
  AudioProcessingEvent = be;
  BeforeInputEvent = be;
  BeforeUnloadEvent = be;
  BlobEvent = be;
  CompositionEvent = be;
  CSSFontFaceLoadEvent = be;
  DeviceLightEvent = be;
  DeviceMotionEvent = be;
  DeviceOrientationEvent = be;
  DeviceProximityEvent = be;
  DOMTransactionEvent = be;
  DragEvent = be;
  EditingBeforeInputEvent = be;
  FetchEvent = be;
  GamepadEvent = be;
  IDBVersionChangeEvent = be;
  MediaStreamEvent = be;
  MutationEvent = be;
  OfflineAudioCompletionEvent = be;
  OverconstrainedError = be;
  PageTransitionEvent = be;
  PaymentRequestUpdateEvent = be;
  RelatedEvent = be;
  RTCDataChannelEvent = be;
  RTCIdentityErrorEvent = be;
  RTCIdentityEvent = be;
  RTCPeerConnectionIceEvent = be;
  SensorEvent = be;
  SVGEvent = be;
  SVGZoomEvent = be;
  TimeEvent = be;
  TrackEvent = be;
  TransitionEvent = be;
  UserProximityEvent = be;
  WebGLContextEvent = be;
  TextEvent = be;
  // Other classes that don't have to be bound to the Window context
  Permissions = oW;
  History = jL;
  Navigator = qL;
  Clipboard = $7;
  TimeRanges = Vy;
  TextTrackCueList = lx;
  ValidityState = Lh;
  MutationRecord = Ah;
  IntersectionObserver = A$e;
  IntersectionObserverEntry = E$e;
  CSSStyleDeclaration = vh;
  CSSRule = bp;
  CSSContainerRule = V7;
  CSSFontFaceRule = K7;
  CSSKeyframeRule = U2;
  CSSKeyframesRule = z7;
  CSSMediaRule = j7;
  CSSStyleRule = Wy;
  CSSSupportsRule = J7;
  CSSConditionRule = GA;
  CSSGroupingRule = UA;
  CSSScopeRule = H2;
  DOMRect = Of;
  DOMRectReadOnly = zA;
  Plugin = F$e;
  PluginArray = aW;
  Location = YL;
  CustomElementRegistry = WL;
  ResizeObserver = wUe;
  Blob = Di;
  File = mh;
  Storage = Ag;
  MimeType = S$e;
  MimeTypeArray = sW;
  NodeFilter = Gn;
  HTMLCollection = mi;
  HTMLFormControlCollection = EW;
  HTMLOptionsCollection = xW;
  NodeList = xo;
  RadioNodeList = TW;
  FileList = sx;
  Screen = iM;
  DOMMatrixReadOnly = Gg;
  DOMMatrix = Jo;
  NamedNodeMap = q1;
  TreeWalker = V2;
  NodeIterator = lW;
  DataTransfer = X5e;
  DataTransferItem = W1;
  DataTransferItemList = Q7;
  XMLSerializer = FUe;
  ClipboardItem = J8e;
  Selection = cW;
  CSSUnitValue = On;
  SVGAngle = Z1;
  SVGAnimatedAngle = BW;
  SVGAnimatedBoolean = OW;
  SVGAnimatedEnumeration = cr;
  SVGAnimatedInteger = $d;
  SVGAnimatedLength = de;
  SVGAnimatedNumber = At;
  SVGAnimatedNumberList = Bf;
  SVGAnimatedPreserveAspectRatio = Ep;
  SVGAnimatedRect = Q2;
  SVGAnimatedString = Pt;
  SVGAnimatedTransformList = JA;
  SVGLength = Kg;
  SVGLengthList = jg;
  SVGMatrix = Hi;
  SVGNumber = Bd;
  SVGNumberList = zg;
  SVGPoint = sa;
  SVGPointList = Ch;
  SVGPreserveAspectRatio = Fx;
  SVGRect = Vg;
  SVGStringList = xh;
  SVGTransform = Pl;
  SVGTransformList = Wg;
  SVGAnimatedLengthList = zm;
  SVGUnitTypes = z7e;
  DOMPoint = MW;
  StylePropertyMap = q7;
  StylePropertyMapReadOnly = Y7;
  MediaList = WA;
  CSSKeywordValue = Kv;
  CSSStyleValue = zv;
  Window = this.constructor;
  // Node.js Classes
  URLSearchParams = xx;
  WritableStream = Ti.Writable;
  ReadableStream = sh;
  TransformStream = Ti.Transform;
  PerformanceObserver = YQ;
  PerformanceEntry = qQ;
  PerformanceObserverEntryList = X7e;
  // Events
  onload = null;
  onerror = null;
  // Public properties.
  document;
  customElements = new WL(this);
  window = this;
  globalThis = this;
  performance = performance;
  screenLeft = 0;
  screenTop = 0;
  screenX = 0;
  screenY = 0;
  crypto = HQ;
  TextEncoder = WQ;
  TextDecoder = VQ;
  closed = !1;
  console;
  name = "";
  Buffer = nr;
  // Public internal properties
  // Used for tracking capture event listeners to improve performance when they are not used.
  // See EventTarget class.
  [Jd] = [];
  [Uu];
  [Gu];
  [Ci];
  [FF];
  [TF];
  [vF];
  [xF];
  [Qd] = this;
  [gc] = this;
  [bo] = this;
  [b] = this;
  [_L] = this;
  [gd] = -1;
  [ef] = new j7e(this);
  [cc] = {
    json: /* @__PURE__ */ new Map(),
    css: /* @__PURE__ */ new Map(),
    esm: /* @__PURE__ */ new Map()
  };
  [H1] = null;
  [nf] = [];
  // Private properties
  #e;
  #t = null;
  #n = null;
  #r = null;
  #i = null;
  #s = null;
  #u = { timeouts: null };
  #l = [];
  #o = [];
  /**
   * Constructor.
   *
   * @param browserFrame Browser frame.
   * @param [options] Options.
   * @param [options.url] URL.
   */
  constructor(e, n) {
    super(), this.#e = e, this[NL](), this.console = e.page.console, this[Uu] = new v$e(e), this[FF] = new qL(this), this[TF] = new iM(), this[vF] = new Ag(), this[xF] = new Ag(), this[Gu] = new YL(this.#e, n?.url ?? "about:blank"), this[Ci] = new jL(this.#e, this), e[Ci].currentItem.href = n?.url ?? "about:blank", pt.setWindowBrowserFrameRelation(this, this.#e), this[tL](), xGe.extendClasses(this), this.document = new this.HTMLDocument(), this.document[lu] = this;
    const r = e[xt].startTask(() => this[Uu].destroy());
    this[Uu].waitUntilComplete().then(() => {
      e[xt].endTask(r), this.document[Og] = uW.complete, this.document.dispatchEvent(new be("readystatechange"));
      const i = new be("load");
      i[tu] = this, i[Ma] = this.document, i[ia] = mr.atTarget, this.dispatchEvent(i), i[tu] = null, i[ia] = mr.none, i[mg] = !1;
    }), this[CL]();
  }
  /**
   * Returns self.
   *
   * @returns Self.
   */
  get self() {
    return this[Qd];
  }
  /**
   * Sets self.
   *
   * @param self Self.
   */
  set self(e) {
    this[Qd] = e;
  }
  /**
   * Returns top.
   *
   * @returns Top.
   */
  get top() {
    return this[gc];
  }
  /**
   * Returns parent.
   *
   * @returns Parent.
   */
  get parent() {
    return this[bo];
  }
  /**
   * Sets parent.
   *
   * @param parent Parent.
   */
  set parent(e) {
    this[bo] = e;
  }
  /**
   * Returns frames.
   *
   * @returns Frames.
   */
  get frames() {
    return this[_L];
  }
  /**
   * Sets frames.
   *
   * @param frames Frames.
   */
  set frames(e) {
    this[bo] = e;
  }
  /**
   * Returns location.
   */
  get location() {
    return this[Gu];
  }
  /**
   * Returns location.
   *
   * @param href Href.
   */
  set location(e) {
    this[Gu].href = e;
  }
  /**
   * Returns history.
   */
  get history() {
    return this[Ci];
  }
  /**
   * Returns navigator.
   */
  get navigator() {
    return this[FF];
  }
  /**
   * Returns screen.
   */
  get screen() {
    return this[TF];
  }
  /**
   * Returns session storage.
   */
  get sessionStorage() {
    return this[vF];
  }
  /**
   * Returns local storage.
   */
  get localStorage() {
    return this[xF];
  }
  /**
   * Returns opener.
   *
   * @returns Opener.
   */
  get opener() {
    return this.#e[Ff];
  }
  /**
   * The number of pixels that the document is currently scrolled horizontally.
   *
   * @returns Scroll X.
   */
  get scrollX() {
    return this.document?.documentElement?.scrollLeft ?? 0;
  }
  /**
   * The read-only Window property pageXOffset is an alias for scrollX.
   *
   * @returns Scroll X.
   */
  get pageXOffset() {
    return this.scrollX;
  }
  /**
   * The number of pixels that the document is currently scrolled vertically.
   *
   * @returns Scroll Y.
   */
  get scrollY() {
    return this.document?.documentElement?.scrollTop ?? 0;
  }
  /**
   * The read-only Window property pageYOffset is an alias for scrollY.
   *
   * @returns Scroll Y.
   */
  get pageYOffset() {
    return this.scrollY;
  }
  /**
   * The CSS interface holds useful CSS-related methods.
   *
   * @returns CSS interface.
   */
  get CSS() {
    return new Z8e();
  }
  /**
   * Returns inner width.
   *
   * @returns Inner width.
   */
  get innerWidth() {
    return this.#t === null ? this.#e.page.viewport.width : this.#t;
  }
  /**
   * Sets inner width.
   *
   * @param value Inner width.
   */
  set innerWidth(e) {
    this.#t = e;
  }
  /**
   * Returns inner height.
   *
   * @returns Inner height.
   */
  get innerHeight() {
    return this.#n === null ? this.#e.page.viewport.height : this.#n;
  }
  /**
   * Sets inner height.
   *
   * @param value Inner height.
   */
  set innerHeight(e) {
    this.#n = e;
  }
  /**
   * Returns outer width.
   *
   * @returns Outer width.
   */
  get outerWidth() {
    return this.#r === null ? this.#e.page.viewport.width : this.#r;
  }
  /**
   * Sets outer width.
   *
   * @param value Outer width.
   */
  set outerWidth(e) {
    this.#r = e;
  }
  /**
   * Returns outer height.
   *
   * @returns Outer height.
   */
  get outerHeight() {
    return this.#i === null ? this.#e.page.viewport.height : this.#i;
  }
  /**
   * Sets outer height.
   *
   * @param value Outer height.
   */
  set outerHeight(e) {
    this.#i = e;
  }
  /**
   * Returns device pixel ratio.
   *
   * @returns Device pixel ratio.
   */
  get devicePixelRatio() {
    return this.#s === null ? this.#e.page.viewport.devicePixelRatio : this.#s;
  }
  /**
   * Sets device pixel ratio.
   *
   * @param value Device pixel ratio.
   */
  set devicePixelRatio(e) {
    this.#s = e;
  }
  /**
   * Returns an object containing the values of all CSS properties of an element.
   *
   * @param element Element.
   * @returns CSS style declaration.
   */
  getComputedStyle(e) {
    return e[hg] = e[hg] || new vh(T, this, { element: e, computed: !0 }), e[hg];
  }
  /**
   * Returns selection.
   *
   * @returns Selection.
   */
  getSelection() {
    return this.document.getSelection();
  }
  /**
   * Scrolls to a particular set of coordinates.
   *
   * @param x X position or options object.
   * @param y Y position.
   */
  scroll(e, n) {
    if (typeof e != "object" && arguments.length === 1)
      throw new this.TypeError("Failed to execute 'scroll' on 'Window': The provided value is not of type 'ScrollToOptions'.");
    const r = typeof e == "object" ? e : { left: e, top: n };
    if (r.behavior === "smooth")
      this.setTimeout(() => {
        if (r.top !== void 0) {
          const i = Number(r.top);
          this.document.documentElement.scrollTop = isNaN(i) ? 0 : i;
        }
        if (r.left !== void 0) {
          const i = Number(r.left);
          this.document.documentElement.scrollLeft = isNaN(i) ? 0 : i;
        }
      });
    else {
      if (r.top !== void 0) {
        const i = Number(r.top);
        this.document.documentElement.scrollTop = isNaN(i) ? 0 : i;
      }
      if (r.left !== void 0) {
        const i = Number(r.left);
        this.document.documentElement.scrollLeft = isNaN(i) ? 0 : i;
      }
    }
  }
  /**
   * Scrolls to a particular set of coordinates.
   *
   * @param x X position or options object.
   * @param y Y position.
   */
  scrollTo(e, n) {
    if (typeof e != "object" && arguments.length === 1)
      throw new this.TypeError("Failed to execute 'scrollTo' on 'Window': The provided value is not of type 'ScrollToOptions'.");
    this.scroll(e, n);
  }
  /**
   * Scrolls by a relative amount from the current position.
   *
   * @param x Pixels to scroll by from top or scroll options object.
   * @param y Pixels to scroll by from left.
   */
  scrollBy(e, n) {
    if (typeof e != "object" && arguments.length === 1)
      throw new this.TypeError("Failed to execute 'scrollBy' on 'Window': The provided value is not of type 'ScrollToOptions'.");
    const r = typeof e == "object" ? e : { left: e, top: n };
    this.scroll({
      left: this.document.documentElement.scrollLeft + (r.left ?? 0),
      top: this.document.documentElement.scrollTop + (r.top ?? 0),
      behavior: r.behavior
    });
  }
  /**
   * Shifts focus away from the window.
   */
  blur() {
  }
  /**
   * Gives focus to the window.
   */
  focus() {
  }
  /**
   * Loads a specified resource into a new or existing browsing context (that is, a tab, a window, or an iframe) under a specified name.
   *
   * @param [url] URL.
   * @param [target] Target.
   * @param [features] Window features.
   * @returns Window.
   */
  open(e, n, r) {
    return vUe.openPage(this.#e, {
      url: e,
      target: n,
      features: r
    });
  }
  /**
   * Closes the window.
   */
  close() {
    this.#e.page.mainFrame === this.#e && // Scripts may close only the windows that were opened by them.
    // In this case, this means windows that have been opened by another window
    this.#e[Ff] && (this[tn](), this.#e.page.close());
  }
  /**
   * Returns a new MediaQueryList object that can then be used to determine if the document matches the media query string.
   *
   * @param mediaQueryString A string specifying the media query to parse into a MediaQueryList.
   * @returns A new MediaQueryList.
   */
  matchMedia(e) {
    return new W7({ window: this, media: e });
  }
  /**
   * Sets a timer which executes a function once the timer expires.
   *
   * @param callback Function to be executed.
   * @param [delay=0] Delay in ms.
   * @param args Arguments passed to the callback function.
   * @returns Timeout ID.
   */
  setTimeout(e, n = 0, ...r) {
    if (this.closed)
      return {};
    const i = this.#e.page.context.browser.settings;
    if (i.timer.preventTimerLoops) {
      const o = new Error().stack, u = this.#l, l = this.#o, h = u.indexOf(o);
      if (h !== -1) {
        if (l[h].timeout++, l[h].timeout >= (i.timer.preventTimerLoops === !0 ? 1 : i.timer.preventTimerLoops.timeout ?? 1))
          return {};
      } else
        u.push(o), l.push({
          timeout: 0,
          requestAnimationFrame: 0
        });
    }
    if (!n) {
      const o = this.#u;
      if (!o.timeouts) {
        const l = !i || !i.disableErrorCapturing && i.errorCapture === Rr.tryAndCatch, h = Al.setTimeout(() => {
          this.#e[xt].endTimer(h);
          const f = o.timeouts;
          o.timeouts = null;
          for (const m of f)
            if (l) {
              let g;
              try {
                g = m.callback();
              } catch (A) {
                this[tr](A);
              }
              g instanceof Promise && g.catch((A) => this[tr](A));
            } else
              m.callback();
        }, 0);
        o.timeouts = [], this.#e[xt].startTimer(h);
      }
      const u = new NM(() => e(...r));
      return o.timeouts.push(u), u;
    }
    const s = !i || !i.disableErrorCapturing && i.errorCapture === Rr.tryAndCatch, a = Al.setTimeout(() => {
      if (this.#e[xt].endTimer(a), s) {
        let o;
        try {
          o = e(...r);
        } catch (u) {
          this[tr](u);
        }
        o instanceof Promise && o.catch((u) => this[tr](u));
      } else
        e(...r);
    }, i?.timer.maxTimeout !== -1 && n && n > i?.timer.maxTimeout ? i?.timer.maxTimeout : n);
    return this.#e[xt].startTimer(a), a;
  }
  /**
   * Cancels a timeout previously established by calling setTimeout().
   *
   * @param id ID of the timeout.
   */
  clearTimeout(e) {
    if (e && e instanceof NM) {
      const n = this.#u;
      if (!n.timeouts)
        return;
      const r = n.timeouts.indexOf(e);
      r !== -1 && n.timeouts.splice(r, 1);
      return;
    }
    sT && (!e || e.constructor.name !== "Timeout") || (Al.clearTimeout(e), this.#e[xt].endTimer(e));
  }
  /**
   * Calls a function with a fixed time delay between each call.
   *
   * @param callback Function to be executed.
   * @param [delay=0] Delay in ms.
   * @param args Arguments passed to the callback function.
   * @returns Interval ID.
   */
  setInterval(e, n = 0, ...r) {
    if (this.closed)
      return {};
    const i = this.#e.page.context.browser.settings, s = !i || !i.disableErrorCapturing && i.errorCapture === Rr.tryAndCatch;
    let a = 0;
    const o = Al.setInterval(() => {
      if (s) {
        let u;
        try {
          u = e(...r);
        } catch (l) {
          this.clearInterval(o), this[tr](l);
        }
        u instanceof Promise && u.catch((l) => {
          this.clearInterval(o), this[tr](l);
        });
      } else
        e(...r);
      i?.timer.maxIntervalIterations !== -1 && (a >= i?.timer.maxIntervalIterations && this.clearInterval(o), a++);
    }, i?.timer.maxIntervalTime !== -1 && n && n > i?.timer.maxIntervalTime ? i?.timer.maxIntervalTime : n);
    return this.#e[xt].startTimer(o), o;
  }
  /**
   * Cancels a timed repeating action which was previously established by a call to setInterval().
   *
   * @param id ID of the interval.
   */
  clearInterval(e) {
    sT && (!e || e.constructor.name !== "Timeout") || (Al.clearInterval(e), this.#e[xt].endTimer(e));
  }
  /**
   * Mock animation frames with timeouts.
   *
   * @param callback Callback.
   * @returns ID.
   */
  requestAnimationFrame(e) {
    if (this.closed)
      return {};
    const n = this.#e.page.context.browser.settings;
    if (n.timer.preventTimerLoops) {
      const s = new Error().stack, a = this.#l, o = this.#o, u = a.indexOf(s);
      if (u !== -1) {
        if (o[u].requestAnimationFrame++, o[u].requestAnimationFrame >= (n.timer.preventTimerLoops === !0 ? 1 : n.timer.preventTimerLoops.requestAnimationFrame ?? 1))
          return {};
      } else
        a.push(s), o.push({
          timeout: 0,
          requestAnimationFrame: 0
        });
    }
    const r = !n || !n.disableErrorCapturing && n.errorCapture === Rr.tryAndCatch, i = Al.setImmediate(() => {
      if (this.#e[xt].endImmediate(i), r) {
        let s;
        try {
          s = e(this.performance.now());
        } catch (a) {
          this[tr](a);
        }
        s instanceof Promise && s.catch((a) => this[tr](a));
      } else
        e(this.performance.now());
    });
    return this.#e[xt].startImmediate(i), i;
  }
  /**
   * Mock animation frames with timeouts.
   *
   * @param id ID.
   */
  cancelAnimationFrame(e) {
    sT && (!e || e.constructor.name !== "Immediate") || (Al.clearImmediate(e), this.#e[xt].endImmediate(e));
  }
  /**
   * Queues a microtask to be executed at a safe time prior to control returning to the browser's event loop.
   *
   * @param callback Function to be executed.
   */
  queueMicrotask(e) {
    if (this.closed)
      return;
    let n = !1;
    const r = this.#e[xt].startTask(() => n = !0), i = this.#e.page.context.browser.settings, s = !i || !i.disableErrorCapturing && i.errorCapture === Rr.tryAndCatch;
    Al.queueMicrotask(() => {
      if (!n)
        if (this.#e[xt].endTask(r), s) {
          let a;
          try {
            a = e();
          } catch (o) {
            this[tr](o);
          }
          a instanceof Promise && a.catch((o) => this[tr](o));
        } else
          e();
    });
  }
  /**
   * This method provides an easy, logical way to fetch resources asynchronously across the network.
   *
   * @param url URL.
   * @param [init] Init.
   * @returns Promise.
   */
  async fetch(e, n) {
    return this.closed ? Promise.reject(new this.DOMException("Failed to execute 'fetch' on 'Window': The window is closed.", ne.invalidStateError)) : await new cu({
      browserFrame: this.#e,
      window: this,
      url: e,
      init: n
    }).send();
  }
  /**
   * Creates a Base64-encoded ASCII string from a binary string (i.e., a string in which each character in the string is treated as a byte of binary data).
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/btoa
   * @param data Binay data.
   * @returns Base64-encoded string.
   */
  btoa(e) {
    return RL.btoa(e);
  }
  /**
   * Decodes a string of data which has been encoded using Base64 encoding.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/atob
   * @see https://infra.spec.whatwg.org/#forgiving-base64-encode.
   * @see Https://html.spec.whatwg.org/multipage/webappapis.html#btoa.
   * @param data Binay string.
   * @returns An ASCII string containing decoded data from encodedData.
   */
  atob(e) {
    return RL.atob(e);
  }
  /**
   * Safely enables cross-origin communication between Window objects; e.g., between a page and a pop-up that it spawned, or between a page and an iframe embedded within it.
   *
   * @param message Message.
   * @param [targetOrigin=*] Target origin.
   * @param _transfer Transfer. Not implemented.
   */
  postMessage(e, n = "*", r) {
    if (!this.closed) {
      if (n && n !== "*" && this.location.origin !== n)
        throw new this.DOMException(`Failed to execute 'postMessage' on 'Window': The target origin provided ('${n}') does not match the recipient window's origin ('${this.location.origin}').`, ne.securityError);
      try {
        JSON.stringify(e);
      } catch {
        throw new this.DOMException("Failed to execute 'postMessage' on 'Window': The provided message cannot be serialized.", ne.invalidStateError);
      }
      this.setTimeout(() => this.dispatchEvent(new VL("message", {
        data: e,
        origin: this.#e.parentFrame ? this.#e.parentFrame.window.location.origin : this.#e.window.location.origin,
        source: this.#e.parentFrame ? this.#e.parentFrame.window : this.#e.window,
        lastEventId: ""
      })));
    }
  }
  /**
   * Resizes the window.
   *
   * @param width Width.
   * @param height Height.
   */
  resizeTo(e, n) {
    if (!this.closed) {
      if (!e || !n)
        throw new this.DOMException(`Failed to execute 'resizeTo' on 'Window': 2 arguments required, but only ${arguments.length} present.`);
      this.#e[M1] && this.#e.page.setViewport({ width: e, height: n });
    }
  }
  /**
   * Resizes the current window by a specified amount.
   *
   * @param width Width.
   * @param height Height.
   */
  resizeBy(e, n) {
    if (!this.closed) {
      if (!e || !n)
        throw new this.DOMException(`Failed to execute 'resizeBy' on 'Window': 2 arguments required, but only ${arguments.length} present.`);
      if (this.#e[M1]) {
        const r = this.#e.page.viewport;
        this.#e.page.setViewport({
          width: r.width + e,
          height: r.height + n
        });
      }
    }
  }
  /**
   * Dispatches an error event and outputs the error to the console.
   *
   * @param error Error.
   */
  [tr](e) {
    this.#e.page.console.error(e), this.dispatchEvent(new V1("error", { message: e.message, error: e }));
  }
  /**
   * Evaluates code in a VM context.
   *
   * @param code Code.
   * @param [options] Options.
   * @param [options.filename] Filename.
   * @returns any.
   */
  [wf](e, n) {
    return new hS.Script(e, n).runInContext(this);
  }
  /**
   * Setup of VM context.
   */
  [tL]() {
    hS.isContext(this) || (hS.createContext(this), TUe.runInContext(this));
  }
  /**
   * Checks if the JavaScript execution environment is secure and outputs a warning if not.
   */
  [NL]() {
    const e = this.#e;
    (J7e || Q7e) && e.page.context.browser.settings.enableJavaScriptEvaluation && !e.page.context.browser.settings.suppressInsecureJavaScriptEnvironmentWarning && !e.page.context.browser.settings.suppressCodeGenerationFromStringsWarning && console.warn(`
Warning! Happy DOM has JavaScript evaluation enabled and is running in an insecure environment.

A VM Context is not an isolated environment, and if you run untrusted code you are at risk of RCE (Remote Code Execution) attacks. The attacker can escape the VM and run code at process level.

It is recommended to disable code generation and freeze all builtins at process level by running node with the flags "--disallow-code-generation-from-strings" and "--frozen-intrinsics". You can suppress this warning by setting "suppressInsecureJavaScriptEnvironmentWarning" to "true" at your own risk.

For more information, see https://github.com/capricorn86/happy-dom/wiki/JavaScript-Evaluation-Warning

`);
  }
  /**
   * @override
   */
  [tn]() {
    if (this.closed)
      return;
    super[tn](), this.closed = !0;
    const e = this[Jd];
    for (const s of e)
      s[tn] && s[tn]();
    this[Jd] = [];
    for (const s of this[nf])
      s[tn]();
    this[nf] = [], this.document[tn]();
    const n = this.document.createElement("html"), r = this.document.createElement("head"), i = this.document.createElement("body");
    n.appendChild(r), n.appendChild(i), this.document[Ht](n), this.location[tn] && this.location[tn](), this.customElements[tn] && this.customElements[tn](), this.history[tn] && this.history[tn](), this[cc].json.clear(), this[cc].css.clear(), this[cc].esm.clear(), this.document[Va].clear(), this.document[jr] = null, this.document[Yd] = null, this.document[eu] = null, this.document[yd] = null, this[bo] = null, this[gc] = null, pt.removeWindowBrowserFrameRelation(this);
  }
  /**
   * Binds methods to a window as scope.
   */
  [CL]() {
    for (const e of [tA, Xr]) {
      const n = Object.getOwnPropertyDescriptors(e.prototype), r = Object.keys(n);
      for (const i of r) {
        const s = n[i];
        s.get || s.set ? Object.defineProperty(this, i, {
          ...s,
          get: s.get?.bind(this),
          set: s.set?.bind(this)
        }) : i !== "constructor" && typeof s.value == "function" && !s.value.toString().startsWith("class ") && Object.defineProperty(this, i, {
          ...s,
          value: s.value.bind(this)
        });
      }
    }
  }
}
class Z7e {
  #e;
  #t = {};
  #n = {};
  #r = 0;
  #i = [];
  /**
   * Constructor.
   *
   * @param printer Console printer.
   */
  constructor(e) {
    this.#e = e;
  }
  /**
   * Writes an error message to the console if the assertion is false. If the assertion is true, nothing happens.
   *
   * @param assertion Assertion.
   * @param message Message.
   * @param args Arguments.
   */
  assert(e, n, ...r) {
    e || this.#e.print({
      type: Hr.assert,
      level: $i.error,
      message: ["Assertion failed:", ...n ? [n, ...r] : r],
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Clears the console.
   */
  clear() {
    this.#e.clear();
  }
  /**
   * Logs the number of times that this particular call to count() has been called.
   *
   * @param [label='default'] Label.
   */
  count(e = "default") {
    this.#t[e] || (this.#t[e] = 0), this.#t[e]++, this.#e.print({
      type: Hr.count,
      level: $i.info,
      message: [`${e}: ${this.#t[e]}`],
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Resets the counter.
   *
   * @param [label='default'] Label.
   */
  countReset(e = "default") {
    delete this.#t[e], this.#e.print({
      type: Hr.countReset,
      level: $i.warn,
      message: [`${e}: 0`],
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Outputs a message to the web console at the "debug" log level.
   *
   * @param message Message.
   * @param args Arguments.
   */
  debug(e, ...n) {
    this.#e.print({
      type: Hr.debug,
      level: $i.log,
      message: e ? [e, ...n] : n,
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Displays an interactive list of the properties of the specified JavaScript object.
   *
   * @param data Data.
   */
  dir(e) {
    this.#e.print({
      type: Hr.dir,
      level: $i.log,
      message: [e],
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Displays an interactive tree of the descendant elements of the specified XML/HTML element.
   *
   * @param data Data.
   */
  dirxml(e) {
    this.#e.print({
      type: Hr.dirxml,
      level: $i.log,
      message: [e],
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Outputs an error message to the console.
   *
   * @param message Message.
   * @param args Arguments.
   */
  error(e, ...n) {
    this.#e.print({
      type: Hr.error,
      level: $i.error,
      message: e ? [e, ...n] : n,
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Alias for error().
   *
   * @deprecated
   * @alias error()
   * @param args Arguments.
   */
  exception(...e) {
    this.error(...e);
  }
  /**
   * Creates a new inline group in the console, causing any subsequent console messages to be indented by an additional level, until console.groupEnd() is called.
   *
   * @param [label] Label.
   */
  group(e) {
    this.#r++;
    const n = {
      id: this.#r,
      label: e || "default",
      collapsed: !1,
      parent: this.#i[this.#i.length - 1] || null
    };
    this.#i.push(n), this.#e.print({
      type: Hr.group,
      level: $i.log,
      message: [e || "default"],
      group: n
    });
  }
  /**
   * Creates a new inline group in the console, but prints it as collapsed, requiring the use of a disclosure button to expand it.
   *
   * @param [label] Label.
   */
  groupCollapsed(e) {
    this.#r++;
    const n = {
      id: this.#r,
      label: e || "default",
      collapsed: !0,
      parent: this.#i[this.#i.length - 1] || null
    };
    this.#i.push(n), this.#e.print({
      type: Hr.groupCollapsed,
      level: $i.log,
      message: [e || "default"],
      group: n
    });
  }
  /**
   * Exits the current inline group in the console.
   */
  groupEnd() {
    this.#i.length !== 0 && this.#i.pop();
  }
  /**
   * Outputs an informational message to the console.
   *
   * @param message Message.
   * @param args Arguments.
   */
  info(e, ...n) {
    this.#e.print({
      type: Hr.info,
      level: $i.info,
      message: e ? [e, ...n] : n,
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Outputs a message to the console.
   *
   * @param message Message.
   * @param args Arguments.
   */
  log(e, ...n) {
    this.#e.print({
      type: Hr.log,
      level: $i.log,
      message: e ? [e, ...n] : n,
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Starts recording a performance profile.
   *
   * TODO: Implement this.
   */
  profile() {
    throw new Error("Method not implemented.");
  }
  /**
   * Stops recording a performance profile.
   *
   * TODO: Implement this.
   */
  profileEnd() {
    throw new Error("Method not implemented.");
  }
  /**
   * Displays tabular data as a table.
   *
   * @param data Data.
   */
  table(e) {
    this.#e.print({
      type: Hr.table,
      level: $i.log,
      message: [e],
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Starts a timer you can use to track how long an operation takes.
   *
   * @param [label=default] Label.
   */
  time(e = "default") {
    this.#n[e] = performance.now();
  }
  /**
   * Stops a timer that was previously started by calling console.time().
   * The method logs the elapsed time in milliseconds.
   *
   * @param [label=default] Label.
   */
  timeEnd(e = "default") {
    const n = this.#n[e];
    if (n) {
      const r = performance.now() - n;
      this.#e.print({
        type: Hr.timeEnd,
        level: $i.info,
        message: [`${e}: ${r}ms - timer ended`],
        group: this.#i[this.#i.length - 1] || null
      });
    }
  }
  /**
   * Logs the current value of a timer that was previously started by calling console.time().
   * The method logs the elapsed time in milliseconds.
   *
   * @param [label=default] Label.
   * @param [args] Arguments.
   */
  timeLog(e = "default", ...n) {
    const r = this.#n[e];
    if (r) {
      const i = performance.now() - r;
      this.#e.print({
        type: Hr.timeLog,
        level: $i.info,
        message: [`${e}: ${i}ms`, ...n],
        group: this.#i[this.#i.length - 1] || null
      });
    }
  }
  /**
   * Adds a single marker to the browser's Performance tool.
   *
   * TODO: Implement this.
   */
  timeStamp() {
    throw new Error("Method not implemented.");
  }
  /**
   * Outputs a stack trace to the console.
   *
   * @param message Message.
   * @param args Arguments.
   */
  trace(e, ...n) {
    this.#e.print({
      type: Hr.trace,
      level: $i.log,
      message: [
        ...e ? [e, ...n] : n,
        new Error("stack").stack.replace("Error: stack", "")
      ],
      group: this.#i[this.#i.length - 1] || null
    });
  }
  /**
   * Outputs a warning message to the console.
   *
   * @param message Message.
   * @param args Arguments.
   */
  warn(e, ...n) {
    this.#e.print({
      type: Hr.warn,
      level: $i.warn,
      message: e ? [e, ...n] : n,
      group: this.#i[this.#i.length - 1] || null
    });
  }
}
class DM {
  /**
   * Returns frames for a page.
   *
   * @param page Page.
   * @returns Frames.
   */
  static getFrames(e) {
    return this.findFrames(e.mainFrame);
  }
  /**
   * Aborts all ongoing operations and destroys the page.
   *
   * @param page Page.
   */
  static closePage(e) {
    if (e.closed)
      return Promise.resolve();
    e.closed = !0;
    const n = e.context.pages.indexOf(e);
    return n !== -1 && e.context.pages.splice(n, 1), e.virtualConsolePrinter.close(), yg.destroyFrame(e.mainFrame);
  }
  /**
   * Returns all frames.
   *
   * @param parentFrame Parent frame.
   * @returns Frames, including the parent.
   */
  static findFrames(e) {
    let n = [e];
    for (const r of e.childFrames)
      n = n.concat(this.findFrames(r));
    return n;
  }
}
class eWe {
  #e = /* @__PURE__ */ new Map();
  /**
   * Returns cached response.
   *
   * @param request Request.
   * @returns Cached response.
   */
  get(e) {
    const n = this.#e.get(e.url);
    return n ? n.expires < Date.now() ? (this.#e.delete(e.url), null) : n : null;
  }
  /**
   * Adds a cache entity.
   *
   * @param request Request.
   * @param response Response.
   * @returns Cached response.
   */
  add(e, n) {
    if (this.#e.delete(e.url), e.headers.get("Cache-Control")?.includes("no-cache") || n.status < 200 || n.status >= 300)
      return null;
    const r = n.headers.get("Access-Control-Max-Age"), i = n.headers.get("Access-Control-Allow-Origin");
    if (!r || !i)
      return null;
    const s = [];
    if (n.headers.has("Access-Control-Allow-Methods") && n.headers.get("Access-Control-Allow-Methods") !== "*")
      for (const u of n.headers.get("Access-Control-Allow-Methods").split(","))
        s.push(u.trim().toUpperCase());
    const a = {
      allowOrigin: i,
      allowMethods: s,
      expires: Date.now() + parseInt(r) * 1e3
    };
    return isNaN(a.expires) || a.expires < Date.now() ? null : (this.#e.set(e.url, a), a);
  }
  /**
   * Clears the cache.
   */
  clear() {
    this.#e.clear();
  }
}
const tWe = { version: "20.4.0" }, Ko = {
  disableJavaScriptEvaluation: !1,
  enableJavaScriptEvaluation: !1,
  disableJavaScriptFileLoading: !1,
  disableCSSFileLoading: !1,
  disableIframePageLoading: !1,
  disableComputedStyleRendering: !1,
  handleDisabledFileLoadingAsSuccess: !1,
  disableErrorCapturing: !1,
  errorCapture: Rr.tryAndCatch,
  enableFileSystemHttpRequests: !1,
  suppressCodeGenerationFromStringsWarning: !1,
  suppressInsecureJavaScriptEnvironmentWarning: !1,
  timer: {
    maxTimeout: -1,
    maxIntervalTime: -1,
    maxIntervalIterations: -1,
    preventTimerLoops: !1
  },
  fetch: {
    disableSameOriginPolicy: !1,
    disableStrictSSL: !1,
    interceptor: null,
    requestHeaders: null,
    virtualServers: null
  },
  module: {
    resolveNodeModules: null,
    urlResolver: null,
    disableCache: !1
  },
  navigation: {
    disableMainFrameNavigation: !1,
    disableChildFrameNavigation: !1,
    disableChildPageNavigation: !1,
    disableFallbackToSetURL: !1,
    crossOriginPolicy: ux.anyOrigin,
    beforeContentCallback: null
  },
  navigator: {
    userAgent: `Mozilla/5.0 (X11; ${process.platform.charAt(0).toUpperCase() + process.platform.slice(1) + " " + process.arch}) AppleWebKit/537.36 (KHTML, like Gecko) HappyDOM/${tWe.version}`,
    maxTouchPoints: 0
  },
  device: {
    prefersColorScheme: "light",
    prefersReducedMotion: "no-preference",
    mediaType: "screen",
    forcedColors: "none"
  },
  debug: {
    traceWaitUntilComplete: -1
  },
  viewport: {
    width: 1024,
    height: 768,
    devicePixelRatio: 1
  }
};
class nWe {
  /**
   * Returns browser settings.
   *
   * @param [settings] Browser settings.
   * @returns Settings.
   */
  static createSettings(e) {
    return e && this.validate(Ko, e), {
      ...Ko,
      ...e,
      navigation: {
        ...Ko.navigation,
        ...e?.navigation
      },
      navigator: {
        ...Ko.navigator,
        ...e?.navigator
      },
      timer: {
        ...Ko.timer,
        ...e?.timer
      },
      fetch: {
        ...Ko.fetch,
        ...e?.fetch
      },
      module: {
        ...Ko.module,
        ...e?.module
      },
      device: {
        ...Ko.device,
        ...e?.device
      },
      debug: {
        ...Ko.debug,
        ...e?.debug
      },
      viewport: {
        ...Ko.viewport,
        ...e?.viewport
      }
    };
  }
  /**
   * Validates settings.
   *
   * @param target Target.
   * @param source Source.
   * @param [parentNamespace] Parent namespace.
   */
  static validate(e, n, r) {
    for (const i of Object.keys(n)) {
      if (e[i] === void 0) {
        const s = r ? r + "." + i : i;
        throw new Error(`Unknown browser setting "${s}"`);
      }
      if (typeof e[i] == "object" && !Array.isArray(e[i]) && e[i] !== null) {
        const s = r ? r + "." + i : i;
        if (typeof n[i] != "object" || Array.isArray(n[i]) || n[i] === null)
          throw new Error(`Browser setting "${s}" cannot be null`);
        this.validate(e[i], n[i], s);
      } else if ((typeof e[i] == "boolean" || typeof e[i] == "number" || typeof e[i] == "string") && typeof n[i] != typeof e[i] && !(i === "preventTimerLoops" && typeof n[i] == "object" && n[i] !== null)) {
        const a = r ? r + "." + i : i;
        throw new Error(`Browser setting "${a}" must be of type "${typeof e[i]}"`);
      }
    }
  }
}
class rWe {
  static listenerCount = 0;
  observedWindows = [];
  uncaughtExceptionListener = null;
  uncaughtRejectionListener = null;
  /**
   * Observes the Node process for uncaught exceptions.
   *
   * @param window Browser window.
   */
  observe(e) {
    if (this.observedWindows.includes(e))
      throw new Error("Browser window is already being observed.");
    this.observedWindows.push(e), !this.uncaughtExceptionListener && (this.uncaughtExceptionListener = (n, r) => {
      if (r === "unhandledRejection")
        return;
      let i = null;
      for (const s of this.observedWindows)
        if (n instanceof s.Error || n instanceof s.DOMException) {
          i = s;
          break;
        }
      i ? (i.console.error(n), i.dispatchEvent(new i.ErrorEvent("error", {
        error: n,
        message: n.message
      }))) : process.listenerCount("uncaughtException") === this.constructor.listenerCount && (console.error(n), process.exit(1));
    }, this.uncaughtRejectionListener = (n) => {
      let r = null;
      for (const i of this.observedWindows)
        if (n instanceof i.Error || n instanceof i.DOMException) {
          r = i;
          break;
        }
      r ? (r.console.error(n), r.dispatchEvent(new r.ErrorEvent("error", {
        error: n,
        message: n.message
      }))) : process.listenerCount("unhandledRejection") === this.constructor.listenerCount && (console.error(n), process.exit(1));
    }, this.constructor.listenerCount++, process.on("uncaughtException", this.uncaughtExceptionListener), process.on("unhandledRejection", this.uncaughtRejectionListener));
  }
  /**
   * Disconnects observer.
   *
   * @param window Browser window.
   */
  disconnect(e) {
    const n = this.observedWindows.indexOf(e);
    n !== -1 && (this.observedWindows.splice(n, 1), this.observedWindows.length === 0 && this.uncaughtExceptionListener && (this.constructor.listenerCount--, process.off("uncaughtException", this.uncaughtExceptionListener), this.uncaughtRejectionListener && process.off("unhandledRejection", this.uncaughtRejectionListener), this.uncaughtExceptionListener = null, this.uncaughtRejectionListener = null));
  }
}
class IM {
  virtualConsolePrinter = new q8e();
  mainFrame;
  context;
  console;
  viewport;
  closed = !1;
  /**
   * Constructor.
   *
   * @param context Browser context.
   */
  constructor(e) {
    this.context = e, this.console = e.browser.console ?? new Z7e(this.virtualConsolePrinter), this.mainFrame = new FW(this), this.viewport = {
      width: e.browser.settings.viewport.width,
      height: e.browser.settings.viewport.height,
      devicePixelRatio: e.browser.settings.viewport.devicePixelRatio
    };
  }
  /**
   * Returns frames.
   */
  get frames() {
    return DM.getFrames(this);
  }
  /**
   * Returns the viewport.
   */
  get content() {
    return this.mainFrame.content;
  }
  /**
   * Sets the content.
   *
   * @param content Content.
   */
  set content(e) {
    this.mainFrame.content = e;
  }
  /**
   * Returns the URL.
   *
   * @returns URL.
   */
  get url() {
    return this.mainFrame.url;
  }
  /**
   * Sets the content.
   *
   * @param url URL.
   */
  set url(e) {
    this.mainFrame.url = e;
  }
  /**
   * Aborts all ongoing operations and destroys the page.
   */
  close() {
    return new Promise((e, n) => {
      const r = this.context;
      DM.closePage(this).then(() => {
        r.pages[0] === this ? r.browser.close().then(e).catch(n) : e();
      }).catch(n);
    });
  }
  /**
   * Returns a promise that is resolved when all resources has been loaded, fetch has completed, and all async tasks such as timers are complete.
   */
  waitUntilComplete() {
    return this.mainFrame.waitUntilComplete();
  }
  /**
   * Returns a promise that is resolved when the page has navigated and the response HTML has been written to the document.
   */
  waitForNavigation() {
    return this.mainFrame.waitForNavigation();
  }
  /**
   * Aborts all ongoing operations.
   */
  abort() {
    return this.mainFrame.abort();
  }
  /**
   * Evaluates code or a VM Script in the page's context.
   *
   * @param script Script.
   * @returns Result.
   */
  evaluate(e) {
    return this.mainFrame.evaluate(e);
  }
  /**
   * Evaluates a module in the page's context.
   *
   * @param options Options.
   * @param options.url URL.
   * @param options.type Module type.
   * @param options.code Code.
   * @returns Module exports.
   */
  evaluateModule(e) {
    return this.mainFrame.evaluateModule(e);
  }
  /**
   * Sets the viewport.
   *
   * @param viewport Viewport.
   */
  setViewport(e) {
    const n = Object.assign({}, this.viewport);
    Object.assign(this.viewport, e), (n.width !== this.viewport.width || n.height !== this.viewport.height || n.devicePixelRatio !== this.viewport.devicePixelRatio) && this.mainFrame.window.dispatchEvent(new be("resize"));
  }
  /**
   * Go to a page.
   *
   * @param url URL.
   * @param [options] Options.
   * @returns Response.
   */
  goto(e, n) {
    return this.mainFrame.goto(e, n);
  }
  /**
   * Navigates back in history.
   *
   * @param [options] Options.
   */
  goBack(e) {
    return this.mainFrame.goBack(e);
  }
  /**
   * Navigates forward in history.
   *
   * @param [options] Options.
   */
  goForward(e) {
    return this.mainFrame.goForward(e);
  }
  /**
   * Navigates a delta in history.
   *
   * @param delta Delta.
   * @param steps
   * @param [options] Options.
   */
  goSteps(e, n) {
    return this.mainFrame.goSteps(e, n);
  }
  /**
   * Reloads the current page.
   *
   * @param [options] Options.
   * @returns Response.
   */
  reload(e) {
    return this.mainFrame.reload(e);
  }
}
class iWe {
  pages;
  browser;
  cookieContainer = new V8e();
  responseCache = new j8e();
  preflightResponseCache = new eWe();
  closed = !1;
  [Dv] = /* @__PURE__ */ new Map();
  /**
   * Constructor.
   *
   * @param browser Browser.
   */
  constructor(e) {
    this.browser = e, this.pages = [], this.pages.push(new IM(this));
  }
  /**
   * Aborts all ongoing operations and destroys the context.
   */
  async close() {
    if (this.closed)
      return;
    if (this.browser.contexts[0] === this)
      throw new Error("Cannot close the default context. Use `browser.close()` to close the browser instead.");
    this.closed = !0, await Promise.all(this.pages.slice().map((r) => r.close()));
    const e = this.browser, n = e.contexts.indexOf(this);
    n !== -1 && e.contexts.splice(n, 1), this.pages = [], this.cookieContainer.clearCookies(), this.responseCache.clear(), this.preflightResponseCache.clear();
  }
  /**
   * Returns a promise that is resolved when all resources has been loaded, fetch has completed, and all async tasks such as timers are complete.
   *
   * @returns Promise.
   */
  async waitUntilComplete() {
    await Promise.all(this.pages.map((e) => e.waitUntilComplete()));
  }
  /**
   * Aborts all ongoing operations.
   */
  abort() {
    return new Promise((e, n) => {
      if (!this.pages.length) {
        e();
        return;
      }
      Promise.all(this.pages.slice().map((r) => r.abort())).then(() => e()).catch((r) => n(r));
    });
  }
  /**
   * Creates a new page.
   *
   * @param [opener] Opener.
   * @returns Page.
   */
  newPage() {
    const e = new IM(this);
    return this.pages.push(e), e;
  }
}
class sWe {
  contexts;
  settings;
  console;
  windowClass;
  [Ec] = null;
  /**
   * Constructor.
   *
   * @param windowClass Window class.
   * @param [options] Options.
   * @param [options.settings] Browser settings.
   * @param [options.console] Console.
   */
  constructor(e, n) {
    this.windowClass = e, this.console = n?.console || null, this.settings = nWe.createSettings(n?.settings), this.settings.errorCapture === Rr.processLevel && (this[Ec] = new rWe()), this.contexts = [], this.contexts.push(new iWe(this));
  }
  /**
   * Returns true if the browser is closed.
   *
   * @returns True if the browser is closed.
   */
  get closed() {
    return this.contexts.length === 0;
  }
  /**
   * Returns the default context.
   *
   * @returns Default context.
   */
  get defaultContext() {
    if (this.contexts.length === 0)
      throw new Error("No default context. The browser has been closed.");
    return this.contexts[0];
  }
  /**
   * Aborts all ongoing operations and destroys the browser.
   */
  async close() {
    if (this.contexts.length === 0)
      return;
    const e = this.contexts;
    this.contexts = [], await Promise.all(e.map((n) => n.close()));
  }
  /**
   * Returns a promise that is resolved when all resources has been loaded, fetch has completed, and all async tasks such as timers are complete.
   *
   * @returns Promise.
   */
  async waitUntilComplete() {
    await Promise.all(this.contexts.map((e) => e.waitUntilComplete()));
  }
  /**
   * Aborts all ongoing operations.
   */
  abort() {
    return new Promise((e, n) => {
      if (!this.contexts.length) {
        e();
        return;
      }
      Promise.all(this.contexts.slice().map((r) => r.abort())).then(() => e()).catch((r) => n(r));
    });
  }
  /**
   * Creates a new incognito context.
   */
  newIncognitoContext() {
    throw new Error("Not possible to create a new context on a detached browser.");
  }
  /**
   * Creates a new page.
   *
   * @returns Page.
   */
  newPage() {
    if (this.contexts.length === 0)
      throw new Error("No default context. The browser has been closed.");
    return this.contexts[0].newPage();
  }
}
class aWe {
  #e;
  /**
   * Constructor.
   *
   * @param browserFrame Browser frame.
   */
  constructor(e) {
    this.#e = e;
  }
  /**
   * Returns settings.
   *
   * @returns Settings.
   */
  get settings() {
    return this.#e.page.context.browser.settings;
  }
  /**
   * Returns virtual console printer.
   *
   * @returns Virtual console printer.
   */
  get virtualConsolePrinter() {
    return this.#e.page.virtualConsolePrinter;
  }
  /**
   * Waits for all async tasks to complete.
   *
   * @returns Promise.
   */
  waitUntilComplete() {
    return this.#e.waitUntilComplete();
  }
  /**
   * Waits for all async tasks to complete.
   *
   * @deprecated Use waitUntilComplete() instead.
   * @returns Promise.
   */
  whenAsyncComplete() {
    return this.waitUntilComplete();
  }
  /**
   * Aborts all async tasks.
   */
  abort() {
    return this.#e.abort();
  }
  /**
   * Aborts all async tasks.
   *
   * @deprecated Use abort() instead.
   */
  cancelAsync() {
    return this.abort();
  }
  /**
   * Aborts all async tasks and closes the window.
   */
  close() {
    return this.#e.page.close();
  }
  /**
   * Sets the URL without navigating the browser.
   *
   * @param url URL.
   */
  setURL(e) {
    this.#e.url = e;
  }
  /**
   * Sets the viewport.
   *
   * @param viewport Viewport.
   */
  setViewport(e) {
    this.#e.page.setViewport(e);
  }
  /**
   * Sets the window size.
   *
   * @deprecated Use setViewport() instead.
   * @param options Options.
   * @param options.width Width.
   * @param options.height Height.
   */
  setWindowSize(e) {
    this.setViewport({
      width: e?.width,
      height: e?.height
    });
  }
  /**
   * Sets the window width.
   *
   * @deprecated Use setViewport() instead.
   * @param width Width.
   */
  setInnerWidth(e) {
    this.setViewport({ width: e });
  }
  /**
   * Sets the window height.
   *
   * @deprecated Use setViewport() instead.
   * @param height Height.
   */
  setInnerHeight(e) {
    this.setViewport({ height: e });
  }
}
class oWe extends tA {
  // Detached Window API.
  happyDOM;
  /**
   * Constructor.
   *
   * @param [options] Options.
   * @param [options.width] Window width. Defaults to "1024".
   * @param [options.height] Window height. Defaults to "768".
   * @param [options.innerWidth] Inner width. Deprecated. Defaults to "1024".
   * @param [options.innerHeight] Inner height. Deprecated. Defaults to "768".
   * @param [options.url] URL.
   * @param [options.console] Console.
   * @param [options.settings] Settings.
   */
  constructor(e) {
    const r = new sWe(tA, {
      console: e?.console,
      settings: e?.settings
    }).defaultContext.pages[0], i = r.mainFrame;
    e && (e.width || e.height || e.innerWidth || e.innerHeight) && Object.assign(r.viewport, {
      width: e.width || e.innerWidth || r.viewport.width,
      height: e.height || e.innerHeight || r.viewport.height
    }), super(i, {
      url: e?.url
    }), i.window = this, i.page.context.browser[Ec] && i.page.context.browser[Ec].observe(this), this.happyDOM = new aWe(i);
  }
}
class uWe {
  disconnect() {
  }
  observe() {
  }
  takeRecords() {
    return [];
  }
  unobserve() {
  }
}
function lWe() {
  const t = globalThis;
  if (t.window === void 0) {
    const r = new oWe();
    t.window = r, t.document = r.document, t.HTMLElement = r.HTMLElement, t.customElements = r.customElements;
  }
  const e = t.window;
  t.navigator === void 0 && (t.navigator = e.navigator), t.Element === void 0 && (t.Element = e.Element);
  const n = e.IntersectionObserver ?? uWe;
  t.IntersectionObserver === void 0 && (t.IntersectionObserver = n), e.IntersectionObserver === void 0 && (e.IntersectionObserver = n), t.React === void 0 && (t.React = gr), t.ReactDOM === void 0 && (t.ReactDOM = N3), e.React === void 0 && (e.React = gr), e.ReactDOM === void 0 && (e.ReactDOM = N3);
}
function CKe(t) {
  return HW(t).map((e) => e.moduleExports);
}
function HW(t, e = []) {
  return t ? (lWe(), ar.fromPromise(
    hWe(t, e),
    (n) => n instanceof Error ? n : new Error(String(n))
  ).orElse((n) => {
    try {
      return tpe(fEe(t, e));
    } catch (r) {
      const i = r instanceof Error ? r : new Error(String(r));
      return gh({ esmError: n, cjsError: i });
    }
  })) : gh({ esmError: null, cjsError: new Error("No compiled entry path provided") });
}
async function cWe(t, e) {
  try {
    const n = await import(t);
    return { cleanup: e, moduleExports: n };
  } catch (n) {
    throw await e(), n;
  }
}
async function hWe(t, e) {
  const n = await hEe(t, e);
  return cWe(n.importUrl, n.cleanup);
}
function Tx(t) {
  return typeof t == "function" || typeof t == "object" && t !== null && "$$typeof" in t;
}
function dWe(t, e) {
  const n = t[e];
  if (Tx(n))
    return n;
  const r = t.default;
  if (r) {
    if (typeof r == "function" && r.name === e)
      return r;
    if (typeof r == "object" && r !== null) {
      const i = r[e];
      if (Tx(i))
        return i;
    }
  }
  return null;
}
function fWe(t) {
  const e = t.default;
  return Tx(e) ? e : null;
}
const mWe = new RegExp("\\" + rr.posix.sep, "g"), gWe = new RegExp("\\" + rr.sep, "g"), aT = /* @__PURE__ */ new Map(), Ed = "**/*", QA = [".ts", ".tsx", ".mts", ".cts"], pWe = [".js", ".jsx", ".mjs", ".cjs"], ek = QA.concat(pWe), bWe = `\\.(?:${QA.map((t) => t.substring(1)).join("|")})`, yWe = `\\.(?:${ek.map((t) => t.substring(1)).join(
  "|"
)})`, tk = rr.posix.sep === rr.sep;
function AWe() {
  let t, e;
  return { promise: new Promise((r, i) => {
    t = r, e = i;
  }), resolve: t, reject: e };
}
async function UW() {
  try {
    return import("typescript").then((t) => t.default);
  } catch (t) {
    throw console.error('typescript must be installed to use "native" functions'), t;
  }
}
async function EWe(t, e) {
  if (rr.extname(t) !== ".json")
    return;
  const n = rr.resolve(t);
  return OQ.stat(n).then((r) => {
    if (r.isFile() || r.isFIFO())
      return n;
    throw new Error(`${t} exists but is not a regular file.`);
  });
}
const oT = tk ? (t) => t : (t) => t.replace(mWe, rr.sep), Fp = tk ? (t) => t : (t) => t.replace(gWe, rr.posix.sep), nA = tk ? (t, e) => t ? rr.resolve(t, e) : rr.resolve(e) : (t, e) => Fp(
  t ? rr.resolve(oT(t), oT(e)) : rr.resolve(oT(e))
);
function SWe(t, e) {
  const n = rr.dirname(t.tsconfigFile);
  return t.tsconfig.references.map((r) => {
    const i = r.path.endsWith(".json") ? r.path : rr.join(r.path, "tsconfig.json");
    return nA(n, i);
  });
}
function wWe(t, e) {
  const r = e.tsconfig.compilerOptions?.allowJs ? ek : QA;
  if (e.referenced && r.some((i) => t.endsWith(i)) && !RM(t, e)) {
    const i = e.referenced.find(
      (s) => RM(t, s)
    );
    if (i)
      return i;
  }
  return e;
}
function RM(t, e) {
  const n = Fp(rr.dirname(e.tsconfigFile)), r = (e.tsconfig.files || []).map((o) => nA(n, o)), i = nA(null, t);
  if (r.includes(t))
    return !0;
  const s = e.tsconfig.compilerOptions?.allowJs;
  return PM(
    i,
    n,
    e.tsconfig.include || (e.tsconfig.files ? [] : [Ed]),
    s
  ) ? !PM(i, n, e.tsconfig.exclude || [], s) : !1;
}
function PM(t, e, n, r) {
  const i = r ? ek : QA;
  return n.some((s) => {
    let a = s.length, o = !1, u = !1, l = !1, h = -1;
    for (let A = s.length - 1; A > -1; A--) {
      const E = s[A];
      if (o || (E === "*" || E === "?") && (a = A, o = !0), l || (E === "." ? u = !0 : E === "/" && (h = A, l = !0)), o && l)
        break;
    }
    if (!u && (!o || a < h) && (s += `${s.endsWith("/") ? "" : "/"}${Ed}`, a = s.length - 1, o = !0), a < s.length - 1 && !t.endsWith(s.slice(a + 1)) || s.endsWith("*") && !i.some((A) => t.endsWith(A)))
      return !1;
    if (s === Ed)
      return t.startsWith(`${e}/`);
    const f = nA(e, s);
    let m = -1;
    for (let A = 0; A < f.length; A++)
      if (f[A] === "*" || f[A] === "?") {
        m = A, o = !0;
        break;
      }
    if (m > 1 && !t.startsWith(f.slice(0, m - 1)))
      return !1;
    if (o) {
      if (m + Ed.length === f.length - (s.length - 1 - a) && f.slice(m, m + Ed.length) === Ed)
        return !0;
    } else return t === f;
    if (aT.has(f))
      return aT.get(f).test(t);
    const g = FWe(f, r);
    return aT.set(f, g), g.test(t);
  });
}
function FWe(t, e) {
  let n = "^";
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    if (i === "?") {
      n += "[^\\/]";
      continue;
    }
    if (i === "*") {
      if (t[r + 1] === "*" && t[r + 2] === "/") {
        r += 2, n += "(?:[^\\/]*\\/)*";
        continue;
      }
      n += "[^\\/]*";
      continue;
    }
    "/.+^${}()|[]\\".includes(i) && (n += "\\"), n += i;
  }
  return t.endsWith("*") && (n += e ? yWe : bWe), n += "$", new RegExp(n);
}
function TWe(t) {
  t.tsconfig && (t.tsconfig = JSON.parse(
    JSON.stringify(t.tsconfig).replaceAll(/"\${configDir}/g, `"${Fp(rr.dirname(t.tsconfigFile))}`)
  ));
}
rr.sep;
async function vWe(t, e) {
  let n = Fp(rr.dirname(rr.resolve(t)));
  const r = void 0, i = "tsconfig.json", s = await UW(), { findConfigFile: a, sys: o } = s;
  let u = a(n, o.fileExists, i);
  return (!u || xWe(u, r)) && (u = null), u;
}
function xWe(t, e) {
  return e;
}
const CWe = {
  tsconfigFile: null,
  tsconfig: {},
  result: null
};
async function kWe(t, e) {
  const n = e?.cache, {
    resolve: r,
    reject: i,
    /** @type {Promise<import('./public.d.ts').TSConfckParseNativeResult>}*/
    promise: s
  } = AWe();
  try {
    const a = await EWe(t, n) || await vWe(t, e);
    if (!a)
      return r(CWe), s;
    let o;
    if (!(t !== a && n?.hasParseResult(a))) {
      const u = await UW();
      o = await GW(a, u, e, t === a), await _We(o, u, e), n?.setParseResult(a, Promise.resolve(o));
    }
    return r(wWe(t, o)), s;
  } catch (a) {
    return i(a), s;
  }
}
function GW(t, e, n, r) {
  const i = n?.cache;
  if (!r && i?.hasParseResult(t))
    return i.getParseResult(t);
  const s = Fp(t), { parseJsonConfigFileContent: a, readConfigFile: o, sys: u } = e, { config: l, error: h } = o(s, u.readFile);
  if (h)
    throw new Yg(h, t, null);
  const f = {
    useCaseSensitiveFileNames: !1,
    readDirectory: u.readDirectory,
    fileExists: u.fileExists,
    readFile: u.readFile
  }, m = a(
    l,
    f,
    rr.dirname(s),
    void 0,
    s
  );
  return NWe(m, t), {
    tsconfigFile: t,
    tsconfig: DWe(m, e, t),
    result: m
  };
}
async function _We(t, e, n) {
  if (!t.tsconfig.references)
    return;
  const r = SWe(t);
  t.referenced = await Promise.all(
    r.map((i) => GW(i, e, n))
  ), t.referenced.forEach((i) => i.solution = t);
}
function NWe(t, e) {
  const n = [
    // see https://github.com/microsoft/TypeScript/blob/main/src/compiler/diagnosticMessages.json
    18002,
    // empty files list
    18003
    // no inputs
  ], r = t.errors?.find(
    (i) => i.category === 1 && !n.includes(i.code)
  );
  if (r)
    throw new Yg(r, e, t);
}
function DWe(t, e, n) {
  const r = JSON.parse(JSON.stringify(t.raw)), i = ["configFilePath", "pathsBasePath"];
  if (t.options && Object.keys(t.options).some((u) => !i.includes(u))) {
    r.compilerOptions = {
      ...t.options
    };
    for (const u of i)
      delete r.compilerOptions[u];
  }
  const s = r.compilerOptions;
  if (s) {
    s.lib != null && (s.lib = s.lib.map(
      (l) => l.replace(/^lib\./, "").replace(/\.d\.ts$/, "")
    ));
    const u = [
      { name: "importsNotUsedAsValues", enumeration: e.ImportsNotUsedAsValues },
      { name: "module", enumeration: e.ModuleKind },
      {
        name: "moduleResolution",
        enumeration: {
          ...e.ModuleResolutionKind,
          2: "node"
          /*ts.ModuleResolutionKind uses "Node10" but in tsconfig it is just node"*/
        }
      },
      {
        name: "newLine",
        enumeration: { 0: "crlf", 1: "lf" }
        /*ts.NewLineKind uses different names*/
      },
      { name: "target", enumeration: e.ScriptTarget }
    ];
    for (const l of u)
      s[l.name] != null && typeof s[l.name] == "number" && (s[l.name] = l.enumeration[s[l.name]].toLowerCase());
    s.target === "latest" && (s.target = "esnext");
  }
  t.watchOptions && (r.watchOptions = {
    ...t.watchOptions
  });
  const a = r.watchOptions;
  if (a) {
    const u = [
      { name: "watchFile", enumeration: e.WatchFileKind },
      { name: "watchDirectory", enumeration: e.WatchDirectoryKind },
      { name: "fallbackPolling", enumeration: e.PollingWatchKind }
    ];
    for (const l of u)
      if (a[l.name] != null && typeof a[l.name] == "number") {
        const h = l.enumeration[a[l.name]];
        a[l.name] = h.charAt(0).toLowerCase() + h.slice(1);
      }
  }
  r.compileOnSave === !1 && delete r.compileOnSave;
  const o = { tsconfig: r, tsconfigFile: n };
  return TWe(o), o.tsconfig;
}
class Yg extends Error {
  /**
   *
   * @param {TSDiagnosticError} diagnostic - diagnostics of ts
   * @param {string} tsconfigFile - file that errored
   * @param {any?} result  - parsed result, if any
   */
  constructor(e, n, r) {
    super(e.messageText), Object.setPrototypeOf(this, Yg.prototype), this.name = Yg.name, this.code = `TS ${e.code}`, this.diagnostic = e, this.result = r, this.tsconfigFile = n;
  }
  /**
   * code of typescript diagnostic, prefixed with "TS "
   * @type {string}
   */
  code;
  /**
   * full ts diagnostic that caused this error
   * @type {TSDiagnosticError}
   */
  diagnostic;
  /**
   * absolute path of tsconfig file where the error happened
   * @type {string}
   */
  tsconfigFile;
  /**
   * native result if present, contains all errors in result.errors
   * @type {any|undefined}
   */
  result;
}
function IWe(t) {
  const e = Ke.createCompilerHost(t, !0), n = RWe();
  return n && (e.getDefaultLibLocation = () => n, e.getDefaultLibFileName = (r) => rr.join(n, Ke.getDefaultLibFileName(r))), e;
}
function RWe() {
  try {
    const e = bc(rr.join(process.cwd(), "package.json")).resolve("typescript/lib/typescript.js");
    return rr.dirname(e);
  } catch {
    return;
  }
}
function PWe(t) {
  const e = rr.resolve(t);
  return uT.existsSync(e) ? ar.fromPromise(
    kWe(e),
    (n) => new ru(`Failed to parse TypeScript config for ${e}`, {
      cause: n,
      props: { phase: "compile" }
    })
  ).map(({ result: n }) => {
    const r = IWe(n.options);
    return Ke.createProgram([t], n.options, r);
  }) : gh(new a$(`File not found: ${e}`, { props: { phase: "compile" } }));
}
const LWe = (t) => (n) => gr.createElement(Qge.WixServicesWrapper, null, gr.createElement(t, n));
function MWe(t, e, n) {
  return PWe(t).andThen((r) => hf.fromThrowable(
    (s) => {
      const a = vBe(s, t);
      if (!a)
        throw new Error(`No default export found in "${t}"`);
      return a;
    },
    (s) => new ru(
      `Failed to extract component types from "${t}": ${s instanceof Error ? s.message : String(s)}`,
      { cause: s, props: { phase: "extract" } }
    )
  )(r).map((s) => ({ program: r, componentInfo: s }))).andThen(({ program: r, componentInfo: i }) => {
    const { componentName: s } = i;
    return ar.fromPromise(
      ZOe(r, t, i, e),
      (a) => new ru(
        `Failed to build ref-element context for "${t}": ${a instanceof Error ? a.message : String(a)}`,
        { cause: a instanceof Error ? a : void 0, props: { phase: "extract" } }
      )
    ).andThen(
      (a) => (
        // Step 3b: Build context provider modules
        ar.fromPromise(
          WOe(r, t, e),
          (o) => new ru(
            `Failed to build context provider modules for "${t}": ${o instanceof Error ? o.message : String(o)}`,
            { cause: o instanceof Error ? o : void 0, props: { phase: "extract" } }
          )
        ).andThen((o) => {
          const u = async () => {
            const l = n?.wrapper ?? LWe;
            if (o.length === 0)
              return l;
            const h = await jOe(
              o,
              gr,
              a.runtimeModules
            );
            return h.length === 0 ? l : YOe(h, l, gr);
          };
          return ar.fromPromise(
            u(),
            (l) => new ru(
              `Failed to build context provider wrapper for "${t}": ${l instanceof Error ? l.message : String(l)}`,
              { cause: l instanceof Error ? l : void 0, props: { phase: "extract" } }
            )
          ).andThen((l) => {
            const h = {
              ...n,
              wrapper: l
            };
            return HW(e, a.runtimeModules).mapErr((f) => {
              const m = f.esmError ? `ESM: ${f.esmError.message}` : "ESM: not attempted";
              return new Vd(
                `Failed to load compiled bundle at "${e}". ${m}. CJS: ${f.cjsError.message}. Ensure the package is built before extraction.`,
                { cause: f.cjsError, props: { phase: "loader" } }
              );
            }).andThen(({ cleanup: f, moduleExports: m }) => {
              const g = (E) => dWe(m, E) ?? fWe(m), A = () => {
                const E = hf.fromThrowable(
                  BBe,
                  (w) => new ru(
                    `Failed to extract CSS import paths from "${t}": ${w instanceof Error ? w.message : String(w)}`,
                    { cause: w instanceof Error ? w : void 0, props: { phase: "css" } }
                  )
                )(r);
                if (E.isErr()) throw E.error;
                return E.value;
              };
              return ar.fromPromise(
                BWe(
                  i,
                  g,
                  A,
                  h,
                  e,
                  a,
                  f
                ),
                OWe
              );
            });
          });
        })
      )
    );
  });
}
function OWe(t) {
  const e = Ao.normalize(t);
  return e instanceof Ao ? e : new Vd("Unexpected failure during component extraction cleanup", {
    cause: e,
    props: { phase: "loader" }
  });
}
async function BWe(t, e, n, r, i, s, a) {
  try {
    const o = n(), u = L8e(
      t,
      e,
      o,
      r,
      i,
      s.eligiblePaths
    );
    if (!u.ok)
      throw u.error;
    return { component: IMe(u.component), errors: [] };
  } finally {
    await a();
  }
}
async function kKe(t, e, n) {
  return (await MWe(t, e, n)).match(
    (i) => i,
    (i) => {
      throw i;
    }
  );
}
export {
  Ao as B,
  YAe as D,
  tEe as E,
  Vd as I,
  a$ as N,
  ru as P,
  hf as R,
  SVe as V,
  ar as a,
  HLe as b,
  PWe as c,
  ILe as d,
  GLe as e,
  Ps as f,
  kh as g,
  gh as h,
  DP as i,
  kKe as j,
  MWe as k,
  BBe as l,
  vBe as m,
  dWe as n,
  CKe as o,
  Gr as p,
  tpe as q,
  VPe as r,
  NEe as s,
  ULe as t,
  wVe as w
};
